/*
    json2.js
    2015-05-03

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse. This file is provides the ES5 JSON capability to ES3 systems.
    If a project might run on IE8 or earlier, then this file should be included.
    This file does nothing on ES5 systems.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 
                            ? '0' + n 
                            : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date 
                    ? 'Date(' + this[key] + ')' 
                    : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/

/*jslint 
    eval, for, this 
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== 'object') {
    JSON = {};
}

(function () {
    'use strict';
    
    var rx_one = /^[\],:{}\s]*$/,
        rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
        rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
        rx_four = /(?:^|:|,)(?:\s*\[)+/g,
        rx_escapable = /[\\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 
            ? '0' + n 
            : n;
    }
    
    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== 'function') {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + '-' +
                        f(this.getUTCMonth() + 1) + '-' +
                        f(this.getUTCDate()) + 'T' +
                        f(this.getUTCHours()) + ':' +
                        f(this.getUTCMinutes()) + ':' +
                        f(this.getUTCSeconds()) + 'Z'
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap,
        indent,
        meta,
        rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string) 
            ? '"' + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === 'string'
                    ? c
                    : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' 
            : '"' + string + '"';
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            mind = gap,
            partial,
            value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case 'string':
            return quote(value);

        case 'number':

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value) 
                ? String(value) 
                : 'null';

        case 'boolean':
        case 'null':

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce 'null'. The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is 'object', we might be dealing with an object or an array or
// null.

        case 'object':

// Due to a specification blunder in ECMAScript, typeof null is 'object',
// so watch out for that case.

            if (!value) {
                return 'null';
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === '[object Array]') {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || 'null';
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? '[]'
                    : gap
                        ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
                        : '[' + partial.join(',') + ']';
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === 'object') {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === 'string') {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap 
                                    ? ': ' 
                                    : ':'
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap 
                                    ? ': ' 
                                    : ':'
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? '{}'
                : gap
                    ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
                    : '{' + partial.join(',') + '}';
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"': '\\"',
            '\\': '\\\\'
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === 'string') {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' &&
                    (typeof replacer !== 'object' ||
                    typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

// Make a fake root object containing our value under the key of ''.
// Return the result of stringifying the value.

            return str('', {'': value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== 'function') {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k, v, value = holder[key];
                if (value && typeof value === 'object') {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return '\\u' +
                            ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with '()' and 'new'
// because they can cause invocation, and '=' because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
// replace all simple value tokens with ']' characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or ']' or
// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, '@')
                        .replace(rx_three, ']')
                        .replace(rx_four, '')
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval('(' + text + ')');

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return typeof reviver === 'function'
                    ? walk({'': j}, '')
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError('JSON.parse');
        };
    }
}());
(function() {
  Spine.Module.include({
    view: function(name) {
      return JST["app/views/" + name];
    }
  });

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.App = (function(superClass) {
    extend(App, superClass);

    function App() {
      return App.__super__.constructor.apply(this, arguments);
    }

    return App;

  })(Spine.Controller);

}).call(this);
(function() {
  var slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.Utils = (function() {
    function Utils() {}

    Utils.SUPPORTED_HYPERLINK_PREFIXES = ["https://", "http://", "tel:"];

    Utils.EMPTY_PASSWORD_MESSAGE = 'Password is required.';

    Utils.PASSWORD_NO_MATCH_MESSAGE = 'Passwords do not match.';

    Utils.DATE_FORMAT = 'YYYY-MM-DD';

    Utils.TIME_FORMAT = 'H:mm:ss z';

    Utils.S4 = function() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };

    Utils.formatDate = function(timestamp) {
      var date, moment, ref, ref1, time;
      if (timestamp == null) {
        return null;
      }
      if (this.siteTimezone == null) {
        this.siteTimezone = (ref = App.Site) != null ? (ref1 = ref.first()) != null ? ref1.display_timezone : void 0 : void 0;
      }
      moment = App.TimeMachine.timestampToMoment(timestamp, App.TimeMachine.mapDisplayTimezone(this.siteTimezone));
      date = moment.format(App.Utils.DATE_FORMAT);
      time = moment.format(App.Utils.TIME_FORMAT);
      return [date, time];
    };

    Utils.formatDateGivenDatetime = function(datetime) {
      var timestamp;
      timestamp = App.TimeMachine.parseDateTimeToTimestamp(datetime, App.TimeMachine.mapDisplayTimezone('UTC'));
      return this.formatDate(timestamp);
    };

    Utils.makeGuid = function() {
      return this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };

    Utils.initCanvasWidthSizer = function(fontSize, fonts) {
      if (fontSize == null) {
        fontSize = 12;
      }
      this.ctx = $('#canvas-text-sizer')[0].getContext('2d');
      if (!fonts) {
        fonts = 'DINWeb, "Helvetica Neue", HelveticaNeue, "Helvetica-Neue", Helvetica, "BBAlpha Sans", sans-serif';
      }
      return this.ctx.font = fontSize + "px " + fonts;
    };

    Utils.initRedesignCanvasWidthSizer = function(fontSize) {
      var fonts;
      if (fontSize == null) {
        fontSize = 12;
      }
      this.ctx = $('#canvas-text-sizer')[0].getContext('2d');
      fonts = 'FF_DIN_Regular, FF_DIN_Light, DinProRegular, "Helvetica Neue", HelveticaNeue, "Helvetica-Neue", Helvetica, "BBAlpha Sans", sans-serif';
      return this.ctx.font = fontSize + "px " + fonts;
    };

    Utils.randomInt = function(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    };

    Utils.canvasWidthForText = function(text) {
      return this.ctx.measureText(text).width;
    };

    Utils.fastApproxWidthForTextCache = {};

    Utils.fastApproxWidthForText = function(text) {
      var cache, j, len1, length, letter, letterKey, letters;
      cache = this.fastApproxWidthForTextCache;
      letters = text.split('');
      length = 0;
      for (j = 0, len1 = letters.length; j < len1; j++) {
        letter = letters[j];
        letterKey = this.ctx.font + " " + letter;
        if (!cache[letterKey]) {
          cache[letterKey] = this.canvasWidthForText(letter);
        }
        length += cache[letterKey];
      }
      return length;
    };

    Utils.titleize = function(str) {
      var splitCapJoin;
      if (str == null) {
        return "";
      }
      splitCapJoin = function(str, char, replaceChar) {
        var word;
        return ((function() {
          var j, len1, ref, results;
          ref = str.split(char);
          results = [];
          for (j = 0, len1 = ref.length; j < len1; j++) {
            word = ref[j];
            results.push(word.charAt(0).toUpperCase() + word.slice(1));
          }
          return results;
        })()).join(replaceChar || char);
      };
      str = splitCapJoin(str, ' ');
      str = splitCapJoin(str, '-');
      str = splitCapJoin(str, '(');
      str = splitCapJoin(str, '_', ' ');
      return str;
    };

    Utils.isUnicodeWord = function(s) {
      return /^((?:[0-9A-Z_a-z\x80-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)$/.test(s);
    };

    Utils.pluralize = function(singular, count) {
      return this.pluralizeIf(singular, count !== 1);
    };

    Utils.pluralizeIf = function(word, cond) {
      if (!cond) {
        return word;
      }
      return word.pluralize();
    };

    Utils.lowercaseFirstLetter = function(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    };

    Utils.safeRatio = function(num, denom) {
      if (denom === 0) {
        return 0;
      }
      return num / denom;
    };

    Utils.listsToObject = function(lists) {
      var j, len1, list, object;
      object = {};
      for (j = 0, len1 = lists.length; j < len1; j++) {
        list = lists[j];
        object[list[0]] = list[1];
      }
      return object;
    };

    Utils.trackSomething = function(action, obj) {
      var e, hostname, site;
      if (obj == null) {
        obj = {};
      }
      try {
        site = App.Site.first();
        hostname = site.host;
      } catch (error) {
        e = error;
        return null;
      }
      return null;
    };

    Utils.roundToSignificantDigits = function(number, num_digits) {
      if (typeof number !== "number") {
        return number;
      }
      if (num_digits < 2) {
        num_digits = 2;
      }
      return parseFloat(number.toPrecision(num_digits));
    };

    Utils.displayRoundedPercentage = function(number, decimal) {
      var i;
      if (typeof number !== "number") {
        return number;
      }
      i = Math.pow(10, decimal);
      return Math.round(number * 100 * i) / i;
    };

    Utils.displayRoundedPercentageList = function(list) {
      var decimal, j, len1, percentageList, ref, roundedPercentageList, sum, sumPercentage;
      sum = list.reduce(this.getSum, 0);
      percentageList = list.map(function(el) {
        return el / sum;
      });
      ref = [0, 1, 2, 3];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        decimal = ref[j];
        roundedPercentageList = percentageList.map(function(number) {
          if (decimal >= 3 && number < 0.00001) {
            return App.Utils.roundToSignificantDigits(number * 100.0, 2);
          } else {
            return App.Utils.displayRoundedPercentage(number, decimal);
          }
        });
        sumPercentage = roundedPercentageList.reduce(this.getSum, 0);
        if (sumPercentage === 100 && !roundedPercentageList.includes(0) && !roundedPercentageList.includes(100)) {
          return roundedPercentageList;
        }
      }
      return roundedPercentageList;
    };

    Utils.getSum = function(total, number) {
      return total + number;
    };

    Utils.roundToDecimals = function(number, digits) {
      var float_num, multiplier;
      multiplier = Math.pow(10, digits);
      float_num = parseFloat(number);
      return Math.round(float_num * multiplier) / multiplier;
    };

    Utils.rpadZeroes = function(numberString, requestedDecimals) {
      var curDecimals, decimalPos, neededZeroes;
      decimalPos = numberString.indexOf('.');
      if (decimalPos === -1) {
        curDecimals = 0;
        if (requestedDecimals > 0) {
          numberString += '.';
        }
      } else {
        curDecimals = (numberString.length - decimalPos) - 1;
      }
      neededZeroes = requestedDecimals - curDecimals;
      numberString += Utils.repeatStr('0', neededZeroes);
      return numberString;
    };

    Utils.repeatStr = function(str, n) {
      var result;
      result = '';
      while (n > 0) {
        result += str;
        n -= 1;
      }
      return result;
    };

    Utils.log10 = function(value) {
      return Math.log(value) / Math.log(10);
    };

    Utils.valueOfNthPercentile = function(array, percent) {
      var firstVal, fractionalRank, integerRank, rank, secondVal;
      if (!(array.length && percent > 0 && percent < 100)) {
        return;
      }
      array.sort(function(a, b) {
        return a - b;
      });
      rank = percent / 100 * (array.length - 1);
      if (this.fractionalPortion(rank) != null) {
        integerRank = Math.floor(rank);
        fractionalRank = this.fractionalPortion(rank);
        firstVal = array[integerRank];
        secondVal = array[integerRank + 1];
        return (firstVal * (1 - fractionalRank)) + (secondVal * fractionalRank);
      } else {
        return array[rank];
      }
    };

    Utils.fractionalPortion = function(i) {
      return i % 1;
    };

    Utils.scaleDisplayNumber = function(value, min_sig, fullSuffix) {
      var powerOfTen, prefix, significantDigits, suffixString;
      if (min_sig == null) {
        min_sig = 1;
      }
      if (fullSuffix == null) {
        fullSuffix = false;
      }
      if (value === 0) {
        return "0";
      }
      prefix = (value < 0 ? '-' : '');
      value = Math.abs(value);
      if (value >= 1000000000000) {
        suffixString = fullSuffix ? ' trillion' : 'T';
        powerOfTen = 12;
      } else if (value >= 1000000000) {
        suffixString = fullSuffix ? ' billion' : 'B';
        powerOfTen = 9;
      } else if (value >= 1000000) {
        suffixString = fullSuffix ? ' million' : 'M';
        powerOfTen = 6;
      } else if (value >= 1000) {
        suffixString = fullSuffix ? ' thousand' : 'k';
        powerOfTen = 3;
      } else {
        suffixString = "";
        powerOfTen = 0;
      }
      significantDigits = Math.floor(this.log10(Math.abs(value)) - this.log10(Math.abs(Math.pow(10, powerOfTen)))) + 2;
      significantDigits = Math.max(min_sig, significantDigits);
      value = App.Utils.roundToSignificantDigits(value, significantDigits) / Math.pow(10, powerOfTen);
      value = "" + prefix + value + suffixString;
      return value;
    };

    Utils.scaleNumberForYAxis = function(value, axisMin, axisMax, tickInterval) {
      if (typeof value !== "number") {
        return value;
      }
      if (axisMin >= 750000000000 || (axisMax >= 1000000000000 && tickInterval % 50000000000 === 0)) {
        return (value / 1000000000000) + "T";
      }
      if (axisMin >= 750000000 || (axisMax >= 1000000000 && tickInterval % 50000000 === 0)) {
        return (value / 1000000000) + "B";
      }
      if (axisMin >= 750000 || (axisMax >= 1000000 && tickInterval % 50000 === 0)) {
        return (value / 1000000) + "M";
      }
      if (tickInterval >= 1000 && tickInterval % 1000 === 0) {
        return (value / 1000) + "k";
      }
      if (value >= 1000) {
        return value.commaDelimit();
      }
      return this.roundToSignificantDigits(value, 5);
    };

    Utils.getReportMetricDataType = function(report_metric) {
      if (report_metric === "revenue" || report_metric === "arpu" || report_metric === "arppu") {
        return "dollars";
      }
      if (report_metric === "active_users" || report_metric === "activity_count" || report_metric === "purchasing_users" || report_metric === "purchases") {
        return "integer";
      }
      if (report_metric === "ppu") {
        return "float";
      }
      if (report_metric === "percent_purchasers") {
        return "percent";
      }
      return "string";
    };

    Utils.formatNumWithPrecision = function(num, precision) {
      var floatNum;
      if (precision == null) {
        precision = null;
      }
      if (num == null) {
        return num;
      }
      floatNum = parseFloat(num);
      if (isNaN(floatNum)) {
        return num;
      }
      if (precision != null) {
        num = parseFloat(floatNum.toPrecision(precision));
      }
      if (Math.abs(num) > 9999) {
        if (precision != null) {
          return App.Utils.scaleDisplayNumber(num, precision);
        } else {
          return App.Utils.scaleDisplayNumber(num);
        }
      } else {
        return num.commaDelimit();
      }
    };

    Utils.formatAsPercent = function(value, options) {
      if (options == null) {
        options = {};
      }
      if (value == null) {
        return "0 %";
      }
      if (options.truncate_large_values && value >= 1000) {
        return "999+%";
      }
      if (options.truncate_large_values && value <= -1000) {
        return "-999+%";
      }
      if (options.num_decimals === 0) {
        return "" + (value > 0 && options.include_positive_sign ? '+' : '') + (parseInt(value)) + "%";
      }
      return "" + (value > 0 && options.include_positive_sign ? '+' : '') + (parseFloat(value).toFixed(2)) + "%";
    };

    Utils.formatDollarsAsString = function(value, options) {
      var decimalIndex, flippedNegativeRegex, formattedNumber, lastChar, result, sym;
      if (options == null) {
        options = {};
      }
      if (options.do_not_round) {
        if (typeof value === "string") {
          value = parseFloat(value);
        }
        if (!value) {
          value = 0;
        }
        formattedNumber = value.commaDelimit();
        decimalIndex = formattedNumber.indexOf(".");
        if (decimalIndex === -1) {
          formattedNumber += ".00";
        } else if (formattedNumber.length === decimalIndex + 2) {
          formattedNumber += "0";
        } else if (formattedNumber.length > decimalIndex + 3) {
          formattedNumber = formattedNumber.slice(0, +(decimalIndex + 2) + 1 || 9e9);
        }
      } else if (value < 10) {
        formattedNumber = this.scaleDisplayNumber(value, 3);
      } else {
        formattedNumber = this.scaleDisplayNumber(value);
        lastChar = formattedNumber.substr(-1);
        if (!(isNaN(lastChar) || formattedNumber.indexOf(".") === -1)) {
          formattedNumber = (parseFloat(formattedNumber).toFixed(2)).toString();
        }
      }
      sym = options.symbol || '$';
      if (App.Tooltip.SUFFIX_CURRENCY[sym] != null) {
        result = formattedNumber;
        if (formattedNumber !== "0") {
          result = formattedNumber + " " + sym;
        }
      } else {
        if (formattedNumber !== "0") {
          formattedNumber = "" + sym + formattedNumber;
        }
        flippedNegativeRegex = new RegExp("\\" + sym + "-");
        result = formattedNumber.replace(flippedNegativeRegex, "-" + sym);
      }
      return result;
    };

    Utils.parseFloatOrZero = function(str) {
      return this.parseFloatOr(str, 0);
    };

    Utils.parseFloatOrNull = function(str) {
      return this.parseFloatOr(str, null);
    };

    Utils.parseFloatOr = function(str, defaultVal) {
      var v;
      if (typeof str === 'string') {
        str = str.replace(/,/g, '');
        str = str.replace(App.ChartUtils.CURRENCY_REGEX, '');
      }
      v = parseFloat(str);
      if (!isNaN(v)) {
        return v;
      }
      return defaultVal;
    };

    Utils.animateHack = function(animateOn, animateClass, element) {
      if (animateOn) {
        if (element.data('animateTimeout') != null) {
          clearTimeout(element.data('animateTimeout'));
        }
        element.css("display", "block");
        return element.data('animateTimeout', setTimeout(((function(_this) {
          return function() {
            return element.addClass(animateClass);
          };
        })(this))));
      } else {
        if (element.data('animateTimeout') != null) {
          clearTimeout(element.data('animateTimeout'));
        }
        element.removeClass(animateClass);
        return element.data('animateTimeout', setTimeout(((function(_this) {
          return function() {
            return element.css("display", "none");
          };
        })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME));
      }
    };

    Utils.probablyAValidEmailAddress = function(str) {
      return /^[&\w+\-.']+@[a-z\d\-.]+\.[a-z]+$/i.test("" + str);
    };

    Utils.validatePassword = function(newPassword, newPasswordConfirm) {
      if ((newPassword == null) || (newPasswordConfirm == null) || newPassword.trim().length === 0 || newPasswordConfirm.trim().length === 0) {
        return this.EMPTY_PASSWORD_MESSAGE;
      }
      if (newPassword !== newPasswordConfirm) {
        return this.PASSWORD_NO_MATCH_MESSAGE;
      }
      if (!this.passwordHippaCompliant(newPassword)) {
        return 'Passwords must be at least 8 characters and include a mix of upper and lowercase letters, numbers and special characters. Cannot contain the word "password", "." or "@".';
      }
      return null;
    };

    Utils.DATETIME_ON_THE_HOUR_WITH_TZ_REGEX = /^\d{4}\-\d{2}\-\d{2} \d{2}:00:00\+00$/;

    Utils.DATETIME_ON_THE_HOUR_NO_TZ_REGEX = /^\d{4}\-\d{2}\-\d{2} \d{2}:00:00$/;

    Utils.datetimeStringToISO8601String = function(string) {
      if (App.Utils.DATETIME_ON_THE_HOUR_WITH_TZ_REGEX.test(string)) {
        return string.replace(' ', 'T').replace('+00', 'Z');
      }
      if (!App.Utils.DATETIME_ON_THE_HOUR_NO_TZ_REGEX.test(string)) {
        return string;
      }
      return string.replace(' ', 'T') + 'Z';
    };

    Utils.datetimeStringToJSDate = function(string) {
      return new Date(App.Utils.datetimeStringToISO8601String(string));
    };

    Utils.isClientId = function(id) {
      if (id == null) {
        return true;
      }
      return !!("" + id).match(/^c-\d+$/);
    };

    Utils.fullscreenSupported = function() {
      var ref;
      if ((ref = App.Site.first()) != null ? ref.sso_enabled : void 0) {
        return false;
      }
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled;
    };

    Utils.appIsFullscreen = function() {
      return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement);
    };

    Utils.emptyArray = function(arr) {
      if (arr == null) {
        return true;
      }
      if (!isArray(arr)) {
        return void 0;
      }
      return arr[0] == null;
    };

    Utils.serializeArray = function(array) {
      var actualArray, cleanArray;
      actualArray = array.constructor === Array ? array : array.toArray();
      cleanArray = actualArray.map(function(val) {
        if ((val != null) && val !== '-1') {
          return val;
        } else {
          return '';
        }
      });
      return cleanArray.join(",");
    };

    Utils.deserializeArray = function(str) {
      var pieces;
      if (str == null) {
        return [null];
      }
      pieces = str.split(',');
      return pieces.map(function(piece) {
        if (piece === "") {
          return null;
        } else {
          return piece;
        }
      });
    };

    Utils.addPositions = function(p1, p2) {
      return {
        left: p1.left + p2.left,
        top: p1.top + p2.top
      };
    };

    Utils.logFeature = function(feature, opts) {
      var appContext, u;
      if (opts == null) {
        opts = {};
      }
      if (!opts.context) {
        appContext = AppRedesign.current().featureLogContext().value();
        if (appContext) {
          opts = _.merge(opts, {
            context: appContext
          });
        }
      }
      if (!((feature != null) && feature.length > 0)) {
        return;
      }
      if (!App.Site.first()) {
        return;
      }
      opts.feature = feature;
      if (opts.user_id == null) {
        u = App.User.currentUser();
        if (u != null) {
          opts.user_id = u.id;
        }
      }
      return $.post("/sites/" + (App.Site.first().id) + "/log_feature", opts);
    };

    Utils.arraysEqual = function(arr1, arr2) {
      var el, i, j, len1;
      if ((arr1 == null) && (arr2 == null)) {
        return true;
      }
      if ((arr1 != null) !== (arr2 != null)) {
        return false;
      }
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (i = j = 0, len1 = arr1.length; j < len1; i = ++j) {
        el = arr1[i];
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    };

    Utils.arrayNoContent = function(arr) {
      return (arr == null) || arr.length === 0;
    };

    Utils.arraysSameContent = function(arr1, arr2) {
      var el, i, j, len1;
      if (this.arrayNoContent(arr1) && this.arrayNoContent(arr2)) {
        return true;
      }
      if (this.arrayNoContent(arr1) || this.arrayNoContent(arr2)) {
        return false;
      }
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (i = j = 0, len1 = arr1.length; j < len1; i = ++j) {
        el = arr1[i];
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    };

    Utils.arraysSameIgnoringOrder = function(arr1, arr2) {
      return $(arr1).not(arr2).length === 0 && $(arr2).not(arr1).length === 0;
    };

    Utils.findByValue = function(list, value) {
      var item, j, len1;
      for (j = 0, len1 = list.length; j < len1; j++) {
        item = list[j];
        if ((item != null) && item.value === value) {
          return item;
        }
      }
      return null;
    };

    Utils.findByProperty = function(list, property, value) {
      var item, j, len1;
      for (j = 0, len1 = list.length; j < len1; j++) {
        item = list[j];
        if ((item != null) && item[property] === value) {
          return item;
        }
      }
      return null;
    };

    Utils.appendFrame = function(parentEl, frameCssClassName) {
      var el;
      el = document.createElement("div");
      if (frameCssClassName != null) {
        el.className = frameCssClassName;
      }
      parentEl[0].appendChild(el);
      return $(el);
    };

    Utils.requires = function() {
      var j, len1, obj, param, params, results;
      obj = arguments[0], params = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      results = [];
      for (j = 0, len1 = params.length; j < len1; j++) {
        param = params[j];
        if (obj[param] == null) {
          throw new Error("requires " + param);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Utils.scrollWithoutLeaking = function(event, elementToScroll) {
      var childrenHeight, deltaY, scrollTop;
      deltaY = -event.originalEvent.wheelDeltaY || event.originalEvent.deltaY;
      if (deltaY == null) {
        return;
      }
      childrenHeight = 0;
      scrollTop = elementToScroll.scrollTop();
      elementToScroll.children().each(function() {
        return childrenHeight += $(this).outerHeight(true);
      });
      if ((deltaY < 0 && scrollTop === 0) || (deltaY > 0 && scrollTop + elementToScroll.height() + 1 >= childrenHeight)) {
        event.preventDefault();
        event.stopPropagation();
      }
      return null;
    };

    Utils.tokenizeString = function(string) {
      return string.toLowerCase().replace(/[\s\.\-_]+/g, ' ').split(' ');
    };

    Utils.matchesQuery = function(queryTokens, resultTokens) {
      var j, k, len1, len2, mToken, matchFound, qToken;
      for (j = 0, len1 = queryTokens.length; j < len1; j++) {
        qToken = queryTokens[j];
        matchFound = false;
        for (k = 0, len2 = resultTokens.length; k < len2; k++) {
          mToken = resultTokens[k];
          if (mToken.indexOf(qToken) === 0) {
            matchFound = true;
            break;
          }
        }
        if (!matchFound) {
          return false;
        }
      }
      return true;
    };

    Utils.queryMatchesString = function(queryTokens, targetString) {
      var checkIndex, j, k, len1, len2, lowerTarget, matched, qToken;
      lowerTarget = targetString.toLowerCase();
      queryTokens = queryTokens.without("");
      for (j = 0, len1 = queryTokens.length; j < len1; j++) {
        qToken = queryTokens[j];
        if (lowerTarget.indexOf(qToken) === -1) {
          return false;
        }
      }
      for (k = 0, len2 = queryTokens.length; k < len2; k++) {
        qToken = queryTokens[k];
        checkIndex = 0;
        matched = false;
        while ((checkIndex = lowerTarget.indexOf(qToken, checkIndex + 1)) !== -1) {
          if (lowerTarget[checkIndex - 1].match(/\W/) != null) {
            matched = true;
            break;
          }
        }
        if (!matched) {
          return false;
        }
      }
      return true;
    };

    Utils.allNumeric = function(list) {
      var item, j, len1, nonNumeric;
      if ((list == null) || list.length === 0) {
        return false;
      }
      nonNumeric = false;
      for (j = 0, len1 = list.length; j < len1; j++) {
        item = list[j];
        nonNumeric || (nonNumeric = !$.isNumeric(item));
      }
      return !nonNumeric;
    };

    Utils.sortNumericOrAlpha = function(list) {
      if (App.Utils.allNumeric(list)) {
        return list.sort(function(a, b) {
          return parseFloat(a) - parseFloat(b);
        });
      } else {
        return list.sort();
      }
    };

    Utils.sortAlphanumeric = function(list) {
      return list.sort(this.sortAlphanumericComparator);
    };

    Utils.sortAlphanumericComparator = function(a, b) {
      var aF, aNum, bF, bNum;
      aNum = !isNaN(parseFloat(a));
      bNum = !isNaN(parseFloat(b));
      if (aNum && !bNum) {
        return -1;
      }
      if (bNum && !aNum) {
        return 1;
      }
      if (aNum && bNum) {
        aF = parseFloat(Utils.stripCommas(a));
        bF = parseFloat(Utils.stripCommas(b));
        if (aF !== bF || (typeof a === 'number' && typeof b === 'number')) {
          return aF - bF;
        }
      }
      return a.toLowerCase().localeCompare(b.toLowerCase());
    };

    Utils.sortByMethodString = function(array, methodName) {
      var methodGetter;
      methodGetter = _.method(methodName);
      return App.Utils.sortByString(array, methodGetter);
    };

    Utils.sortByPropertyString = function(array, propertyName) {
      var propertyGetter;
      propertyGetter = _.property(propertyName);
      return App.Utils.sortByString(array, propertyGetter);
    };

    Utils.sortByString = function(array, valueGetter) {
      return array.sort(function(el1, el2) {
        var word1, word2;
        word1 = valueGetter(el1);
        word2 = valueGetter(el2);
        return word1.localeCompare(word2);
      });
    };

    Utils.stripCommas = function(val) {
      while ((typeof val.indexOf === "function" ? val.indexOf(',') : void 0) !== -1 && (val.replace != null)) {
        val = val.replace(',', '');
      }
      return val;
    };

    Utils.sortBooleanComparator = function(a, b) {
      var aNumeric, bNumeric;
      aNumeric = a ? 1 : 0;
      bNumeric = b ? 1 : 0;
      return Utils.sortAlphanumericComparator(aNumeric, bNumeric);
    };

    Utils.sortNumericOrAlphaByProperty = function(list, property) {
      if (App.Utils.allNumeric($.map(list, function(l) {
        return l[property];
      }))) {
        return list.sort(function(a, b) {
          return parseFloat(a[property]) - parseFloat(b[property]);
        });
      } else {
        return list.sort(function(a, b) {
          return (a[property] || '').localeCompare(b[property] || '');
        });
      }
    };

    Utils.INSERTION_REGEX_PREFIX = "^\\[([^\\[\\]\\=]*[^\\s\\[\\]\\=])\s*:\s*";

    Utils.INSERTION_REGEX_ARGS = "\\(([a-zA-Z0-9\\-_\\s,\\.]+)\\)";

    Utils.INSERTION_REGEX_POSTFIX = "\\]$";

    Utils.SUPPORTED_FORMATTERS = {
      "%": "%",
      "$": "$",
      "£": "£",
      "€": "€",
      "pst": "pst",
      "mst": "mst",
      "cst": "cst",
      "est": "est",
      "utc": "utc",
      "hawaii": "hawaii",
      "ist": "ist",
      "date": "date",
      "sec": "sec",
      "min": "min",
      "hour": "hour",
      "month": "month",
      "day": "day",
      "quarter": "quarter",
      "year": "year",
      "epoch": "epoch",
      "ts": "ts",
      "day_of_month": "day_of_month",
      "day_of_year": "day_of_year",
      "day_of_week": "day_of_week",
      "month_of_year": "month_of_year",
      "year_only": "year_only",
      "hour_of_day": "hour_of_day",
      "min_of_hour": "min_of_hour",
      "sec_of_min": "sec_of_min",
      "dow": "dow",
      "doy": "doy",
      "isodow": "isodow",
      "week": "week",
      "aggregation": "aggregation",
      "gmt": "gmt",
      "wet": "wet",
      "aest": "aest",
      "nzst": "nzst",
      "today": "today",
      "yesterday": "yesterday",
      "wtd": "wtd",
      "mtd": "mtd",
      "ytd": "ytd",
      "cet": "cet",
      "eet": "eet",
      "awst": "awst",
      "acst": "acst",
      "acdt": "acdt",
      "aedt": "aedt",
      "israel": "israel",
      "hest": "hest",
      "hcst": "hcst",
      "hmst": "hmst",
      "hpst": "hpst",
      "wib": "wib",
      "myt": "myt",
      "jst": "jst",
      "kst": "kst",
      "pet": "pet",
      "sgt": "sgt",
      "brt": "brt",
      "cot": "cot",
      "eat": "eat"
    };

    Utils.matchesFormatter = function(str) {
      var f, formatters, j, len1;
      formatters = str.slice(1, -1).split(":").slice(1);
      if (!formatters.length) {
        return false;
      }
      for (j = 0, len1 = formatters.length; j < len1; j++) {
        f = formatters[j];
        if ((this.SUPPORTED_FORMATTERS[f] == null) && !this.testDimensionLabelsFormatter(f)) {
          return false;
        }
      }
      return true;
    };

    Utils.matchesDaterange = function(str) {
      return str.match(/\[(.+?)\s?=\s?(daterange|daterange_start|daterange_end|daterange_no_tz|today|yesterday|\d+days)\]|\[(daterange|daterange_start|daterange_end)\]/i) != null;
    };

    Utils.testDimensionLabelsFormatter = function(str) {
      var matches, regex_str;
      regex_str = "[(?:dim_name)(?:dimension_name)]" + this.INSERTION_REGEX_ARGS;
      matches = str.match(new RegExp(regex_str, "i"));
      if ((matches == null) || matches.length < 2) {
        return false;
      }
      return App.CustomDimension.matches("[foo=" + matches[1] + "]");
    };

    Utils.hashesToRowsArray = function(rows, columns) {
      var column, hashes, j, len1, results, row;
      if ((rows == null) || (columns == null)) {
        return [];
      }
      hashes = [];
      results = [];
      for (j = 0, len1 = rows.length; j < len1; j++) {
        row = rows[j];
        results.push((function() {
          var k, len2, results1;
          results1 = [];
          for (k = 0, len2 = columns.length; k < len2; k++) {
            column = columns[k];
            results1.push(row[column]);
          }
          return results1;
        })());
      }
      return results;
    };

    Utils.rowsArraysToHashes = function(rows, columns) {
      var columnsWithDuplicatesRenamed;
      if ((rows == null) || (columns == null)) {
        return [];
      }
      columnsWithDuplicatesRenamed = Utils.renameDuplicateColumns(columns);
      return rows.map((function(_this) {
        return function(row) {
          var column, hashRow, i, j, len1;
          hashRow = {};
          for (i = j = 0, len1 = columnsWithDuplicatesRenamed.length; j < len1; i = ++j) {
            column = columnsWithDuplicatesRenamed[i];
            hashRow[column] = row[i];
          }
          return hashRow;
        };
      })(this));
    };

    Utils.renameDuplicateColumns = function(columns) {
      var colId, column, j, len1, safeColumns;
      if (columns == null) {
        return [];
      }
      safeColumns = [];
      for (j = 0, len1 = columns.length; j < len1; j++) {
        column = columns[j];
        if (safeColumns.includes(column)) {
          colId = safeColumns.length + 1;
          while (safeColumns.includes("column_" + colId)) {
            colId++;
          }
          safeColumns.push("column_" + colId);
        } else {
          safeColumns.push(column);
        }
      }
      return safeColumns;
    };

    Utils.cacheBreaker17 = function() {};

    Utils.intersect = function(array1, array2, caseSensitive, returnFirst) {
      var j, k, len1, len2, ref, result, reversed, val, val1, val2;
      if (caseSensitive == null) {
        caseSensitive = true;
      }
      if (returnFirst == null) {
        returnFirst = true;
      }
      reversed = false;
      if (array1.length > array2.length) {
        ref = [array2, array1], array1 = ref[0], array2 = ref[1];
        reversed = true;
      }
      if (caseSensitive) {
        return (function() {
          var j, len1, results;
          results = [];
          for (j = 0, len1 = array1.length; j < len1; j++) {
            val = array1[j];
            if (indexOf.call(array2, val) >= 0) {
              results.push(val);
            }
          }
          return results;
        })();
      } else {
        result = [];
        for (j = 0, len1 = array1.length; j < len1; j++) {
          val1 = array1[j];
          for (k = 0, len2 = array2.length; k < len2; k++) {
            val2 = array2[k];
            if (val1.toLowerCase() === val2.toLowerCase()) {
              if ((returnFirst && !reversed) || (!returnFirst && reversed)) {
                result.push(val1);
              } else {
                result.push(val2);
              }
              break;
            }
          }
        }
        return result;
      }
    };

    Utils.sanitizeHtml = function(text) {
      if (typeof text !== 'string') {
        return '';
      }
      return text.escapeHtml();
    };

    Utils.stripSpacesBetweenTags = function(html) {
      var r;
      r = "><";
      return html.replace(/>\s+</g, r);
    };

    Utils.captureStack = function() {
      var e;
      e = new Error('dummy');
      return e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@').split('\n');
    };

    Utils.dateFormat = function(format, date, utc) {
      if (utc) {
        return DateFormat.dateFormat(format, date);
      } else {
        return DateFormatLocalTime.dateFormat(format, date);
      }
    };

    Utils.roundedAgo = function(t_msec, useShortNames, singular) {
      var r_unit, r_val, str, t_min;
      if (useShortNames == null) {
        useShortNames = false;
      }
      if (singular == null) {
        singular = false;
      }
      t_min = t_msec / 60000;
      r_val = 0;
      r_unit = "";
      if (t_min < 1) {
        r_val = Math.round(t_msec / 1000);
        if (r_val === 0) {
          r_val = 1;
        }
        r_unit = "second";
      } else if (t_min < 60) {
        r_val = Math.round(t_min);
        r_unit = "minute";
      } else if (t_min < 60 * 36) {
        r_val = Math.round(t_min / 60);
        r_unit = "hour";
      } else {
        r_val = Math.round(t_min / (60 * 24));
        r_unit = "day";
      }
      if (useShortNames) {
        str = "" + r_val + (r_unit.substr(0, 1));
      } else {
        str = r_val + " " + r_unit;
        if (r_val !== 1 && !singular) {
          str += "s";
        }
      }
      return str;
    };

    Utils.roundedAgoFromDateString = function(dateStr, successSuffix, failValue) {
      var diff_msec, dtMs;
      if (successSuffix == null) {
        successSuffix = "";
      }
      if (failValue == null) {
        failValue = null;
      }
      if (dateStr == null) {
        return failValue;
      }
      dtMs = Date.parse(dateStr);
      if (isNaN(dtMs)) {
        return failValue;
      }
      diff_msec = (new Date).getTime() - dtMs;
      return ((this.roundedAgo(diff_msec)) + " " + successSuffix).trim();
    };

    Utils.sanitizeSqlIdentifier = function(name) {
      return name.replace(/[^a-zA-Z0-9_\s]/g, '').trim().replace(/\s+/g, '_').toLowerCase();
    };

    Utils.optionsToHtml = function(list, chosenVal) {
      return this._optionsToHtml(list, chosenVal);
    };

    Utils.optionsToHtmlWithNone = function(list, chosenVal) {
      list = [
        {
          name: 'None',
          value: ''
        }
      ].concat(list);
      return this._optionsToHtml(list, chosenVal);
    };

    Utils.optionsToHtmlWithPlaceholder = function(list) {
      list = [
        {
          value: ''
        }
      ].concat(list);
      return this._optionsToHtml(list);
    };

    Utils.optionsToHtmlWithNoneAndPlaceholder = function(list) {
      list = [
        {
          value: ''
        }, {
          name: 'None',
          value: ''
        }
      ].concat(list);
      return this._optionsToHtml(list);
    };

    Utils._optionsToHtml = function(list, chosenVal) {
      var j, len1, li, o, options;
      options = [];
      for (j = 0, len1 = list.length; j < len1; j++) {
        li = list[j];
        if (li.hidden) {
          continue;
        }
        o = $('<option></option>');
        o.text(li.name);
        o.attr('value', li.value);
        if (li.value === chosenVal) {
          o.attr('selected', 'selected');
        }
        if (Array.isArray(chosenVal)) {
          if (chosenVal.includes(li.value)) {
            o.attr('selected', 'selected');
          }
        }
        options.push(o.prop('outerHTML'));
      }
      return options.join('');
    };

    Utils.fastUnique = function(list) {
      var el, j, len1, seenElements, uniques;
      seenElements = {};
      uniques = [];
      for (j = 0, len1 = list.length; j < len1; j++) {
        el = list[j];
        if (!seenElements[el]) {
          uniques.push(el);
          seenElements[el] = true;
        }
      }
      return uniques;
    };

    Utils.withoutAny = function(list, forbiddenList) {
      var forbiddenMap, item, j, len1;
      forbiddenMap = {};
      for (j = 0, len1 = forbiddenList.length; j < len1; j++) {
        item = forbiddenList[j];
        forbiddenMap[item] = true;
      }
      return (function() {
        var k, len2, results;
        results = [];
        for (k = 0, len2 = list.length; k < len2; k++) {
          item = list[k];
          if (!forbiddenMap[item]) {
            results.push(item);
          }
        }
        return results;
      })();
    };

    Utils.isBlank = function(val) {
      return (val == null) || /^\s*$/.test(val + "");
    };

    Utils.hasOnlySpaceOrNewline = function(val) {
      if (val === '') {
        return false;
      }
      if (val == null) {
        return false;
      }
      return !/\S/.test(val);
    };

    Utils.unauthorizedEmail = function(recipients) {
      var allowed_email_domains, domain, email_address, email_domain, j, k, len1, len2, len3, m, ref, site, unauthorized, unauthorized_email;
      site = App.Site.first();
      unauthorized = [];
      if (site.allowed_email_domains != null) {
        allowed_email_domains = [];
        ref = site.allowed_email_domains.split(',');
        for (j = 0, len1 = ref.length; j < len1; j++) {
          domain = ref[j];
          allowed_email_domains.push(domain.trim());
        }
        for (k = 0, len2 = recipients.length; k < len2; k++) {
          email_address = recipients[k];
          unauthorized_email = true;
          email_domain = email_address.replace(/.*@/, '');
          for (m = 0, len3 = allowed_email_domains.length; m < len3; m++) {
            domain = allowed_email_domains[m];
            if (email_domain === domain) {
              unauthorized_email = false;
              break;
            }
          }
          if (unauthorized_email) {
            unauthorized.push(email_address);
          }
        }
      }
      return unauthorized;
    };

    Utils.padZero = function(n, width, z) {
      z = z || '0';
      n = n + '';
      if (n.length >= width) {
        return n;
      } else {
        return new Array(width - n.length + 1).join(z) + n;
      }
    };

    Utils.isValueTrue = function(hash, key) {
      return (hash[key] != null) && hash[key];
    };

    Utils.isHyperLink = function(str) {
      var j, len1, prefix, ref;
      if (typeof str !== "string") {
        return false;
      }
      str = str.toLowerCase();
      ref = App.Utils.SUPPORTED_HYPERLINK_PREFIXES;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        prefix = ref[j];
        if (str.startsWith(prefix)) {
          return true;
        }
      }
      return false;
    };

    Utils.parseMarkdown = function(str) {
      var friendlyLink, markdownLinkRegex, obj;
      obj = {
        text: str,
        isLink: App.Utils.isHyperLink(str),
        val: str,
        linkName: null
      };
      if (obj.isLink) {
        return obj;
      }
      markdownLinkRegex = /^\[([^\[\]]+)\]\(([^\(\)]+)\)$/;
      friendlyLink = markdownLinkRegex.exec(obj.text);
      if ((friendlyLink != null ? friendlyLink.length : void 0) === 3 && this.isHyperLink(friendlyLink[2])) {
        obj.isLink = true;
        obj.linkName = this.sanitizeHtml(friendlyLink[1]);
        obj.val = friendlyLink[2];
      }
      return obj;
    };

    Utils.passwordHippaCompliant = function(raw_password) {
      if (!this.passwordPassedMuster(raw_password, 8, 4)) {
        return false;
      }
      if (raw_password.toLowerCase().includes('password')) {
        return false;
      }
      if (raw_password.match(/(.)\1\1\1/)) {
        return false;
      }
      if (raw_password.match(/@|\./)) {
        return false;
      }
      return true;
    };

    Utils.passwordPassedMuster = function(raw_password, min_length, min_classes) {
      var num_classes;
      if (!((raw_password != null ? raw_password.length : void 0) >= min_length)) {
        return false;
      }
      num_classes = 0;
      if (raw_password.match(/[a-z]/)) {
        num_classes++;
      }
      if (raw_password.match(/[A-Z]/)) {
        num_classes++;
      }
      if (raw_password.match(/[0-9]/)) {
        num_classes++;
      }
      if (raw_password.match(/[$-\/:-?{-~!"^_`\[\]]/)) {
        num_classes++;
      }
      return num_classes >= min_classes;
    };

    Utils.timeNowInSecs = function() {
      return new Date().getTime() / 1000;
    };

    Utils.reverseString = function(input) {
      var i, inputReversed, j, len, ref;
      if (typeof input !== "string") {
        return input;
      }
      inputReversed = "";
      len = input.length;
      for (i = j = 1, ref = len; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        inputReversed += input[len - i];
      }
      return inputReversed;
    };

    Utils.copyText = function(text) {
      var ex, txtEl;
      try {
        txtEl = $('<textarea>').text(text);
        txtEl.css({
          position: "absolute",
          top: "0px",
          opacity: 0
        });
        $('body').append(txtEl);
        txtEl.trigger('select');
        document.execCommand('copy');
        return txtEl.detach();
      } catch (error) {
        ex = error;
        return AppRedesign.logError(ex);
      }
    };

    Utils.generateOptionsForNumbers = function(from, to, increment) {
      var j, n, ref, ref1, results;
      if (increment == null) {
        increment = 1;
      }
      results = [];
      for (n = j = ref = from, ref1 = to; ref <= ref1 ? j <= ref1 : j >= ref1; n = ref <= ref1 ? ++j : --j) {
        if (n % increment === 0) {
          results.push({
            value: n,
            name: App.Utils.padZero(n, 2)
          });
        }
      }
      return results;
    };

    Utils.isInsideIframe = function() {
      return window.parent !== window;
    };

    Utils.caseInsensitiveUniq = function(arrayOfStrings) {
      return _.uniqBy(arrayOfStrings, function(string) {
        return string.toLowerCase();
      });
    };

    Utils.adminUser = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      return App.User.safeCurrentUser().isAdmin() || App.User.currentUserIsPeriscopeAdmin();
    };

    Utils.spaceAdminUser = function() {
      var ref;
      return (ref = App.User.safeCurrentUser()) != null ? typeof ref.isSpaceAdmin === "function" ? ref.isSpaceAdmin() : void 0 : void 0;
    };

    Utils.buildDropdownRange = function(start, end) {
      var j, r, range, ref;
      range = [];
      for (r = j = 0, ref = end; 0 <= ref ? j < ref : j > ref; r = 0 <= ref ? ++j : --j) {
        if (r < 10) {
          range.push({
            name: "0" + r,
            value: r
          });
        } else {
          range.push({
            name: "" + r,
            value: r
          });
        }
      }
      return range;
    };

    Utils.cssSet = function(selector, prop, value) {
      return $(selector).css(prop, value);
    };

    Utils.createOwnerSelectOption = function(owner) {
      return Utils.optionHtml({
        value: "" + owner.id,
        content: Utils.ownerDisplayName(owner)
      });
    };

    Utils.ownerDisplayName = function(owner) {
      var displayName;
      return displayName = (owner.first_name + " " + owner.last_name).trim();
    };

    Utils.optionHtml = function(obj) {
      var content, value;
      value = this.sanitizeHtml(obj.value);
      content = this.sanitizeHtml(obj.content);
      return "<option value=" + value + ">" + content + "</option>";
    };

    return Utils;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PeriscopeModel = (function(superClass) {
    extend(PeriscopeModel, superClass);

    function PeriscopeModel() {
      return PeriscopeModel.__super__.constructor.apply(this, arguments);
    }

    PeriscopeModel.UNCLONEABLE_ATTRIBUTES = {
      id: true,
      cid: true,
      last_update: true,
      sync_version: true
    };

    PeriscopeModel.DONT_TRIGGER_ON_CHECK_FOR_UPDATE = false;

    PeriscopeModel.DESCRIPTION_MAX_LENGTH = 1000;

    PeriscopeModel.ERROR_LONG_DESCRIPTION = 'long description text';

    PeriscopeModel.applyUpdates = function(attributeArray, dontTriggerUpdateEvents, shouldValidate) {
      var attributes, client_last_update, equal_updates_ok, existingVersion, i, last_update_different, last_update_missing, len, results;
      if (dontTriggerUpdateEvents == null) {
        dontTriggerUpdateEvents = false;
      }
      if (shouldValidate == null) {
        shouldValidate = false;
      }
      if (attributeArray == null) {
        return;
      }
      results = [];
      for (i = 0, len = attributeArray.length; i < len; i++) {
        attributes = attributeArray[i];
        if (attributes == null) {
          continue;
        }
        if (attributes.sync_version != null) {
          this.restore_misversioned_data(attributes);
        }
        attributes["server_update_pending"] = false;
        if (this.modelForAttributesWasNotDestroyed(attributes) || this.modelForAttributesIsRestrictedDatabase(attributes)) {
          if (this.exists(attributes.id)) {
            existingVersion = this.find(attributes.id);
            client_last_update = existingVersion.last_update;
            last_update_missing = (client_last_update == null) || (attributes.last_update == null);
            last_update_different = !last_update_missing && (attributes.last_update > client_last_update);
            equal_updates_ok = !last_update_missing && (this.allowsEqualUpdates() && this.lastUpdatesMatch(attributes.last_update, client_last_update));
            if (last_update_missing || last_update_different || equal_updates_ok) {
              if (existingVersion.id !== attributes.id) {
                existingVersion.changeID(attributes.id);
              }
              this.beforeApplyUpdates(this.exists(attributes.id));
              this.update(attributes.id, attributes, {
                ajax: false,
                noTrigger: dontTriggerUpdateEvents,
                validate: shouldValidate
              });
              results.push(this.appliedUpdates(this.exists(attributes.id)));
            } else {
              results.push(void 0);
            }
          } else {
            this.create(attributes, {
              ajax: false,
              noTrigger: dontTriggerUpdateEvents,
              validate: shouldValidate
            });
            results.push(this.appliedUpdates(this.exists(attributes.id)));
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    PeriscopeModel.modelForAttributesWasNotDestroyed = function(attributes) {
      return this.destroyedIds.indexOf(attributes.id) === -1;
    };

    PeriscopeModel.modelForAttributesIsRestrictedDatabase = function(attributes) {
      return AppRedesign.restrictDatabasesEnabled() && this.className === 'Database' && attributes['is_restricted'] === true;
    };

    PeriscopeModel.lastUpdatesMatch = function(lu1, lu2) {
      if (typeof lu1 === "number" && typeof lu2 === "number") {
        return lu1.toPrecision(13) === lu2.toPrecision(13);
      } else {
        return lu1 === lu2;
      }
    };

    PeriscopeModel.appliedUpdates = function(model) {};

    PeriscopeModel.beforeApplyUpdates = function(model) {};

    PeriscopeModel.shortcutDestroys = function() {
      return true;
    };

    PeriscopeModel.allowsEqualUpdates = function() {
      return false;
    };

    PeriscopeModel.applyDeletions = function(attributeArray) {
      var attributes, i, len, results;
      if (attributeArray == null) {
        return;
      }
      results = [];
      for (i = 0, len = attributeArray.length; i < len; i++) {
        attributes = attributeArray[i];
        if (attributes == null) {
          continue;
        }
        if (this.exists(attributes.id)) {
          results.push(this.destroy(attributes.id, {
            ajax: false,
            backgroundUpdate: true
          }));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    PeriscopeModel.restore_misversioned_data = function(attributes) {
      var attr, item, ref, results, value;
      item = this.exists(attributes.id);
      if ((item != null) && item.sync_version > attributes.sync_version) {
        ref = item.attributes();
        results = [];
        for (attr in ref) {
          value = ref[attr];
          results.push(attributes[attr] = value);
        }
        return results;
      }
    };

    PeriscopeModel.prototype.set = function(params) {
      var key, value;
      for (key in params) {
        value = params[key];
        this[key] = value;
      }
      return this._hasChanged = true;
    };

    PeriscopeModel.prototype.markAsUnchanged = function() {
      return this._hasChanged = false;
    };

    PeriscopeModel.prototype.hasChanged = function() {
      return this._hasChanged === true;
    };

    PeriscopeModel.prototype.destroy = function(params) {
      var clientParams;
      if (params == null) {
        params = {};
      }
      if (this.wasDestroyed()) {
        return;
      }
      if (App[this.constructor.className].shortcutDestroys()) {
        App[this.constructor.className].destroyedIds.push(this.id);
      }
      if (typeof this.id === 'string') {
        clientParams = jQuery.extend(true, {}, params, {
          ajax: false
        });
        PeriscopeModel.__super__.destroy.call(this, clientParams);
        return;
      }
      return PeriscopeModel.__super__.destroy.call(this, params);
    };

    PeriscopeModel.prototype.remove = function() {
      delete this.constructor.records[this.id];
      return delete this.constructor.crecords[this.cid];
    };

    PeriscopeModel.prototype.save = function(params) {
      if (params == null) {
        params = {};
      }
      if (this.wasDestroyed()) {
        return;
      }
      if (this.wasDestroyedBeforeServerCreate() && this.readyToBeDestroyed()) {
        setTimeout(((function(_this) {
          return function() {
            return _this.destroy();
          };
        })(this)));
      }
      if (this.hasChanged()) {
        this.markAsUnchanged();
      }
      return PeriscopeModel.__super__.save.call(this, params);
    };

    PeriscopeModel.prototype.update = function(params) {
      var current_item;
      if (params == null) {
        params = {};
      }
      current_item = this.constructor.records[this.id];
      if (params.ajax !== false && this.sync_version < current_item.sync_version) {
        return;
      }
      return PeriscopeModel.__super__.update.call(this, params);
    };

    PeriscopeModel.prototype.updateAttributes = function(atts, options) {
      var current_item;
      if (options == null) {
        options = {};
      }
      current_item = this.constructor.exists(this.id);
      if (current_item) {
        if (options.ajax !== false && this.sync_version < current_item.sync_version) {
          return;
        }
        return PeriscopeModel.__super__.updateAttributes.call(this, atts, options);
      }
    };

    PeriscopeModel.prototype.wasDestroyed = function() {
      return App[this.constructor.className].destroyedIds.indexOf(this.id) !== -1 && typeof this.id === 'number';
    };

    PeriscopeModel.prototype.wasDestroyedBeforeServerCreate = function() {
      return App[this.constructor.className].destroyedIds.indexOf(this.cid) !== -1;
    };

    PeriscopeModel.prototype.readyToBeDestroyed = function() {
      return typeof this.id === 'number' && !this.wasDestroyed();
    };

    PeriscopeModel.prototype.client_site_id = function() {
      return App.Site.first().id;
    };

    PeriscopeModel.prototype.hasLongDescription = function() {
      var ref;
      return ((ref = this.description) != null ? ref.length : void 0) > this.constructor.DESCRIPTION_MAX_LENGTH;
    };

    PeriscopeModel.prototype.displayName = function() {
      var ref;
      return (ref = this.name) != null ? ref.trim() : void 0;
    };

    PeriscopeModel.prototype.leadingNumericName = function() {
      var ref;
      if (this.name == null) {
        return false;
      }
      return ((ref = this.name) != null ? ref.trim().match(/^[0-9]+/) : void 0) !== null;
    };

    PeriscopeModel.prototype.hasName = function() {
      var ref;
      return ((ref = this.name) != null ? ref.trim().length : void 0) > 0;
    };

    PeriscopeModel.prototype.getName = function() {
      var dn, ref;
      dn = this.displayName();
      if (!_.isEmpty(dn)) {
        return dn;
      }
      return "Untitled " + ((ref = this.constructor.PRETTY_CLASS_NAME) != null ? ref : _.startCase(this.constructor.className));
    };

    PeriscopeModel.prototype.setName = function(newName) {
      return this.name = newName;
    };

    PeriscopeModel.prototype.searchTokens = function() {
      return this.displayName().split('_').tokenize();
    };

    PeriscopeModel.prototype.matchesQuery = function(queryTokens) {
      return App.Utils.matchesQuery(queryTokens, this.searchTokens());
    };

    PeriscopeModel.allSortedByName = function(filterQuery) {
      var all, queryTokens;
      if (filterQuery == null) {
        filterQuery = null;
      }
      if ((filterQuery != null) && filterQuery.trim() !== "") {
        queryTokens = filterQuery.split(' ').tokenize();
        all = this.select(function(u) {
          return u.matchesQuery(queryTokens);
        });
      } else {
        all = this.all();
      }
      return all.sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    };

    PeriscopeModel.allByCategory = function(categoryFilter, comparator, filterQuery) {
      var queryTokens, views;
      if (categoryFilter.customMatch) {
        views = this.select((function(_this) {
          return function(u) {
            return categoryFilter.filter(u);
          };
        })(this));
      } else if (_.trim(filterQuery)) {
        queryTokens = filterQuery.split(' ').tokenize();
        views = this.select((function(_this) {
          return function(u) {
            return categoryFilter.filter(u) && u.matchesQuery(queryTokens);
          };
        })(this));
      } else {
        views = this.select((function(_this) {
          return function(u) {
            return categoryFilter.filter(u);
          };
        })(this));
      }
      return views.sort(comparator);
    };

    PeriscopeModel.prototype.database = function() {
      var id;
      id = this.database_id || this.constructor.defaultDatabase();
      if (App.Database.exists(id)) {
        return App.Database.find(id);
      }
      return null;
    };

    PeriscopeModel.prototype.databaseOrDefault = function() {
      return this.database() || App.User.defaultDbForCurrentUser();
    };

    PeriscopeModel.prototype.setDatabase = function(database_id) {
      var ref;
      this.database_id = database_id;
      return (ref = App.User.currentUser()) != null ? ref.setLastUsedDatabase(this.database_id) : void 0;
    };

    PeriscopeModel.defaultDatabase = function() {
      var ref, user;
      user = App.User.currentUser();
      if ((user != null) && (user.lastUsedDatabase() != null) && App.Database.exists(user.lastUsedDatabase())) {
        return user.lastUsedDatabase();
      } else {
        return (ref = App.Database.first()) != null ? ref.id : void 0;
      }
    };

    return PeriscopeModel;

  })(Spine.Model);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Annotation = (function(superClass) {
    extend(Annotation, superClass);

    function Annotation() {
      return Annotation.__super__.constructor.apply(this, arguments);
    }

    Annotation.configure('Annotation', 'client_site_id', 'group_name', 'x_value', 'description', 'sync_version', 'is_auto_created_group');

    Annotation.extend(Spine.Model.Ajax);

    Annotation.groups = function() {
      var _, anno, groups, ref;
      groups = {};
      ref = App.Annotation.records;
      for (_ in ref) {
        anno = ref[_];
        groups[anno.group_name] = true;
      }
      return App.Utils.sortAlphanumeric(Object.keys(groups));
    };

    Annotation.getUniqueGroupName = function(title) {
      var groups, new_title;
      title = title.slice(0, 201);
      groups = Annotation.groups().to_set();
      new_title = title;
      while (groups[new_title]) {
        if (i > 500) {
          return 'Ungrouped';
        }
        new_title = title + " " + i;
        i++;
      }
      return new_title;
    };

    return Annotation;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ArchivedSqlAlert = (function(superClass) {
    extend(ArchivedSqlAlert, superClass);

    function ArchivedSqlAlert() {
      return ArchivedSqlAlert.__super__.constructor.apply(this, arguments);
    }

    ArchivedSqlAlert.configure('ArchivedSqlAlert', 'client_site_id', 'sql_alert_id', 'user_id', 'created_at', 'sql_alert_properties', 'user_name');

    ArchivedSqlAlert.extend(Spine.Model.Ajax);

    ArchivedSqlAlert.prototype.save = function(opts) {
      if (opts == null) {
        opts = {};
      }
      opts['ajax'] = false;
      return ArchivedSqlAlert.__super__.save.call(this, opts);
    };

    ArchivedSqlAlert.allForSqlAlertId = function(sqlAlertId) {
      var id, ref, results, w;
      ref = this.records;
      results = [];
      for (id in ref) {
        w = ref[id];
        if (w.sql_alert_id === sqlAlertId) {
          results.push(w);
        }
      }
      return results;
    };

    return ArchivedSqlAlert;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ArchivedSqlSnippet = (function(superClass) {
    extend(ArchivedSqlSnippet, superClass);

    function ArchivedSqlSnippet() {
      return ArchivedSqlSnippet.__super__.constructor.apply(this, arguments);
    }

    ArchivedSqlSnippet.configure('ArchivedSqlSnippet', 'client_site_id', 'sql_snippet_id', 'user_id', 'created_at', 'sql_snippet_properties', 'user_name');

    ArchivedSqlSnippet.extend(Spine.Model.Ajax);

    ArchivedSqlSnippet.prototype.save = function(opts) {
      if (opts == null) {
        opts = {};
      }
      opts['ajax'] = false;
      return ArchivedSqlSnippet.__super__.save.call(this, opts);
    };

    ArchivedSqlSnippet.allForSqlSnippetId = function(sqlSnippetId) {
      var id, ref, results, w;
      ref = this.records;
      results = [];
      for (id in ref) {
        w = ref[id];
        if (w.sql_snippet_id === sqlSnippetId) {
          results.push(w);
        }
      }
      return results;
    };

    return ArchivedSqlSnippet;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ArchivedSqlView = (function(superClass) {
    extend(ArchivedSqlView, superClass);

    function ArchivedSqlView() {
      return ArchivedSqlView.__super__.constructor.apply(this, arguments);
    }

    ArchivedSqlView.configure('ArchivedSqlView', 'client_site_id', 'sql_view_id', 'user_id', 'created_at', 'sql_view_properties', 'user_name');

    ArchivedSqlView.extend(Spine.Model.Ajax);

    ArchivedSqlView.prototype.save = function(opts) {
      if (opts == null) {
        opts = {};
      }
      opts['ajax'] = false;
      return ArchivedSqlView.__super__.save.call(this, opts);
    };

    ArchivedSqlView.allForSqlViewId = function(sqlViewId) {
      var id, ref, results, w;
      ref = this.records;
      results = [];
      for (id in ref) {
        w = ref[id];
        if (w.sql_view_id === sqlViewId) {
          results.push(w);
        }
      }
      return results;
    };

    return ArchivedSqlView;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ArchivedWidget = (function(superClass) {
    extend(ArchivedWidget, superClass);

    function ArchivedWidget() {
      return ArchivedWidget.__super__.constructor.apply(this, arguments);
    }

    ArchivedWidget.configure('ArchivedWidget', 'client_site_id', 'widget_id', 'user_id', 'created_at', 'widget_properties', 'user_name');

    ArchivedWidget.extend(Spine.Model.Ajax);

    ArchivedWidget.prototype.save = function(opts) {
      if (opts == null) {
        opts = {};
      }
      opts['ajax'] = false;
      return ArchivedWidget.__super__.save.call(this, opts);
    };

    ArchivedWidget.allForWidgetId = function(widgetId) {
      var id, ref, results, w;
      ref = this.records;
      results = [];
      for (id in ref) {
        w = ref[id];
        if (w.widget_id === widgetId) {
          results.push(w);
        }
      }
      return results;
    };

    return ArchivedWidget;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Badge = (function(superClass) {
    extend(Badge, superClass);

    function Badge() {
      return Badge.__super__.constructor.apply(this, arguments);
    }

    Badge.configure('Badge', 'client_site_id', 'created_at', 'created_by_user_id', 'badgeable_type', 'badgeable_id');

    Badge.extend(Spine.Model.Ajax);

    Badge.createForModel = function(model) {
      return this.create({
        badgeable_id: model.id,
        badgeable_type: model.constructor.className
      });
    };

    Badge.getBadgeForModel = function(model) {
      if (model == null) {
        return;
      }
      return App.Badge.select(_.matches({
        badgeable_id: model.id,
        badgeable_type: model.constructor.className
      })).first();
    };

    Badge.isBadged = function(model) {
      return !!this.getBadgeForModel(model);
    };

    Badge.toggleBadged = function(model, badgeState) {
      var badge;
      badge = this.getBadgeForModel(model);
      if (badgeState) {
        if (badge == null) {
          return this.createForModel(model);
        }
      } else {
        if (badge != null ? badge.readyToBeDestroyed() : void 0) {
          return badge.destroy();
        }
      }
    };

    return Badge;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CacheSchedule = (function(superClass) {
    extend(CacheSchedule, superClass);

    function CacheSchedule() {
      return CacheSchedule.__super__.constructor.apply(this, arguments);
    }

    CacheSchedule.configure('CacheSchedule', 'client_site_id', 'created_at', 'custom', 'deleted_at', 'id', 'interval', 'locked_at', 'next_at', 'schedulable_id', 'schedulable_type', 'updated_at');

    CacheSchedule.shortcutDestroys = function() {
      return false;
    };

    return CacheSchedule;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ColorTheme = (function(superClass) {
    extend(ColorTheme, superClass);

    function ColorTheme() {
      return ColorTheme.__super__.constructor.apply(this, arguments);
    }

    ColorTheme.configure('ColorTheme', 'name', 'table_color_header_background', 'table_color_header_text', 'table_color_odd_rows_background', 'table_color_odd_rows_text', 'table_color_even_rows_background', 'table_color_even_rows_text', 'site_id', 'series');

    ColorTheme.extend(Spine.Model.Ajax);

    ColorTheme.PERISCOPE_DEFAULT_PALETTE = function() {
      return {
        name: 'Default Theme',
        table_color_header_background: '#5270ab',
        table_color_header_text: '#f9f9f9',
        table_color_odd_rows_background: '#f5f6f7',
        table_color_odd_rows_text: '#131326',
        table_color_even_rows_background: '#ffffff',
        table_color_even_rows_text: '#131326',
        series: _.clone(App.ColorHelper.CHART_COLORS.normal)
      };
    };

    ColorTheme.PERISCOPE_DEFAULT_DARK_THEME_PALETTE = function() {
      return {
        table_color_even_rows_background: '#434456',
        table_color_odd_rows_background: '#535368'
      };
    };

    ColorTheme.PERISCOPE_DEFAULT_THEME = _.memoize(function() {
      return _.tap(new App.ColorTheme(_.defaults({
        id: null,
        isPeriscopeDefault: true
      }, this.PERISCOPE_DEFAULT_PALETTE())), function(defaultTheme) {
        return defaultTheme.save = _.stubFalse();
      });
    });

    ColorTheme.prototype.colorList = function() {
      return this.series.concat([this.table_color_header_background, this.table_color_header_text, this.table_color_odd_rows_background, this.table_color_odd_rows_text, this.table_color_even_rows_background, this.table_color_even_rows_text]);
    };

    ColorTheme.prototype.isSiteTheme = function() {
      return App.Site.first().colorTheme().id === this.id;
    };

    ColorTheme.prototype.displayColors = function(n) {
      return this.colorList().slice(0, n);
    };

    ColorTheme.newColorThemeWithPeriscopeDefaults = function() {
      var site_id;
      site_id = App.Site.first().id;
      return new App.ColorTheme(_.defaults(this.PERISCOPE_DEFAULT_PALETTE(), {
        site_id: site_id
      }));
    };

    ColorTheme.prototype.dialogTitle = function() {
      if (this.isNew()) {
        return 'New Theme';
      } else {
        return "Edit " + this.name;
      }
    };

    ColorTheme.prototype.isPeriscopeDefault = false;

    ColorTheme.prototype.siteDefaultName = function() {
      if (App.Site.isSpacesEnabled()) {
        return 'Space Default';
      }
      return 'Default';
    };

    ColorTheme.themeOptions = function(themeableRecord, parent, isCustomTheme) {
      if (isCustomTheme == null) {
        isCustomTheme = false;
      }
      return _(App.ColorTheme.all()).map(function(theme) {
        return {
          id: theme.id,
          theme: theme,
          usePeriscopeTheme: false
        };
      }).concat([
        {
          id: null,
          theme: parent.colorTheme(),
          useParentTheme: true,
          usePeriscopeTheme: false
        }, {
          id: null,
          usePeriscopeTheme: true,
          theme: App.ColorTheme.newColorThemeWithPeriscopeDefaults()
        }
      ]).reject(!isCustomTheme && _.matches({
        id: themeableRecord.default_color_theme_id,
        usePeriscopeTheme: Boolean(themeableRecord.use_periscope_theme)
      })).value();
    };

    return ColorTheme;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CsvView = (function(superClass) {
    extend(CsvView, superClass);

    function CsvView() {
      this.fsUpdated = bind(this.fsUpdated, this);
      this.status = bind(this.status, this);
      this.isLoading = bind(this.isLoading, this);
      return CsvView.__super__.constructor.apply(this, arguments);
    }

    CsvView.configure('CsvView', 'client_site_id', 'name', 'owner_user_id', 'user_id', 'preview_source_hash_key', 'error_message', 'guid', 'last_update', 'last_refreshed_at', 'percent_complete', 'preview_data', 's3_key', 'user_columns', 'csv', 'filename', 'filesize', 'created_at', 'delimiter', 'published_at', 'row_count', 'description', 'tag_names', 'database_id', 'has_dataset', 'archived_at', 'excluded_from_auto_archive', 'icon_color', 'uploaded_from_chart_editor');

    CsvView.extend(Spine.Model.Ajax);

    CsvView.EMPTY_FIELD_NAMES = 'empty field names';

    CsvView.DUPE_FIELD_NAMES = 'duplicate field names';

    CsvView.ERROR_NO_NAME = 'No name';

    CsvView.LEADING_NUMERIC_NAME = 'Leading numerical in name';

    CsvView.DUPE_NAME = 'Duplicate name';

    CsvView.NO_DATA = 'no data';

    CsvView.FAILED_UPLOAD = 'bad upload';

    CsvView.FILE_TOO_BIG = 'file too big';

    CsvView.BAD_FILE = 'bad file';

    CsvView.routeName = 'csv_views';

    CsvView.DEFAULT_VALUES = {
      name: 'Untitled CSV View'
    };

    CsvView.PRETTY_CLASS_NAME = 'CSV';

    CsvView.PRETTY_CLASS_NAME_LOWERCASE = 'CSV';

    CsvView.SIMPLE_CLASS_NAME = 'CSV';

    CsvView.IS_TAGGABLE = true;

    CsvView.prototype.destinationDatabaseId = function() {
      return this.database_id;
    };

    CsvView.loadArchived = function(id, callback, preloadedData) {
      return jQuery.when(preloadedData || jQuery.get(App.CsvView.url(id, 'show_archived'))).done(function(response) {
        var csvView;
        csvView = new App.CsvView(response.CsvView);
        if (typeof callback === 'function') {
          return callback(csvView);
        }
      });
    };

    CsvView.prototype.database = function() {
      return null;
    };

    CsvView.prototype.validate = function() {
      var errors;
      errors = [];
      this.reformatName();
      if (!this.hasName()) {
        errors.push(CsvView.ERROR_NO_NAME);
      }
      if (this.leadingNumericName()) {
        errors.push(CsvView.LEADING_NUMERIC_NAME);
      }
      if (App.ValidationHelper.dupeName(this)) {
        errors.push(CsvView.DUPE_NAME);
      }
      if (this.hasLongDescription()) {
        errors.push(CsvView.ERROR_LONG_DESCRIPTION);
      }
      if (errors.length === 0) {
        return null;
      }
      return errors;
    };

    CsvView.prototype.hasData = function() {
      return ((this.s3_key != null) && (this.preview_data != null)) || this.preview_source_hash_key;
    };

    CsvView.prototype.clearData = function() {
      return delete this.preview_data;
    };

    CsvView.prototype.reformatName = function() {
      if (this.name == null) {
        return;
      }
      return this.name = this.name.replace(/[^a-zA-Z0-9_\s]/g, '').trim().replace(/\s+/, '_').toLowerCase();
    };

    CsvView.prototype.csvParsed = function(csv) {
      var rows;
      this.user_columns = csv.user_columns;
      rows = App.Utils.hashesToRowsArray(csv.rows.slice(0, 5001), csv.columns);
      this.preview_data = {
        rows: rows,
        columns: csv.columns
      };
      this.reformatName();
      this.filename = csv.name;
      this.filesize = csv.size;
      this.delimiter = csv.delimiter;
      this.row_count = csv.rows.length;
      this.updatePreviewSource(rows, csv.columns);
      return this.trigger('update', this);
    };

    CsvView.prototype.csvErring = function(error) {
      this.updatePreviewSource([], [], App.CsvView.prettyErrorMessage(error));
      return this.trigger('update', this);
    };

    CsvView.prototype.updatePreviewSource = function(rows, columns, error_message) {
      var fs;
      if (error_message == null) {
        error_message = null;
      }
      this.preview_source_hash_key = 'csv-view-preview-' + App.Utils.S4();
      fs = this.formulaSource();
      if (fs == null) {
        fs = new App.FormulaSource({
          hash_key: this.preview_source_hash_key,
          percent_complete: 1,
          sql: ''
        });
      }
      fs.rows = rows;
      fs.columns = columns;
      fs.error_message = error_message;
      fs.save();
      return this.trigger('update', this);
    };

    CsvView.prettyErrorMessage = function(error) {
      switch (error) {
        case App.CsvView.ERROR_NO_NAME:
          return 'Invalid name';
        case App.CsvView.LEADING_NUMERIC_NAME:
          return 'Name cannot start with a number';
        case App.CsvView.DUPE_NAME:
          return 'A view or snippet with this name already exists';
        case App.CsvView.NO_DATA:
          return 'You must upload a file before saving';
        case App.CsvView.EMPTY_FIELD_NAMES:
          return 'All columns must have names.';
        case App.CsvView.DUPE_FIELD_NAMES:
          return 'CSV Cannot contain duplicate field names.';
        case App.CsvView.FAILED_UPLOAD:
          return 'Upload failed. Please try again';
        case App.CsvView.FILE_TOO_BIG:
          return 'File exceeds the 50 MB limit';
        case App.CsvView.BAD_FILE:
          return 'File cannot be parsed as a CSV';
        default:
          if (error.endsWith(" cannot include space or newline characters")) {
            return error;
          }
          return null;
      }
    };

    CsvView.destroyCsvViews = function(ids) {
      return ids.forEach(function(id) {
        return App.CsvView.find(id).destroy();
      });
    };

    CsvView.prototype.isLoading = function() {
      return !(this.last_refreshed_at != null);
    };

    CsvView.prototype.save = function(options) {
      var r;
      if (options == null) {
        options = {};
      }
      r = CsvView.__super__.save.call(this, options);
      App.Database.clearTableCache();
      return r;
    };

    CsvView.prototype.asSchema = function() {
      var c, j, len, ref, s;
      s = {};
      ref = this.user_columns;
      for (j = 0, len = ref.length; j < len; j++) {
        c = ref[j];
        s[c.name] = {
          is_datetime: c.type === 'timestamp',
          column_name: c.name,
          column_type: c.type
        };
      }
      return s;
    };

    CsvView.refresh = function(values, options) {
      if (options == null) {
        options = {};
      }
      CsvView.__super__.constructor.refresh.call(this, values, options);
      return App.Database.clearTableCache();
    };

    CsvView.allAsSchema = function() {
      var j, len, ref, s, sv;
      s = {};
      ref = this.recordsValues();
      for (j = 0, len = ref.length; j < len; j++) {
        sv = ref[j];
        s[sv.name] = {
          is_view: true,
          columns: sv.asSchema()
        };
      }
      return s;
    };

    CsvView.prototype.displayName = function() {
      return this.name;
    };

    CsvView.prototype.searchTokens = function() {
      return this.displayName().split('_').tokenize();
    };

    CsvView.prototype.matchesQuery = function(queryTokens) {
      return App.Utils.matchesQuery(queryTokens, this.searchTokens());
    };

    CsvView.prototype.getLastModifiedBy = function() {
      var user;
      user = App.User.exists(this.user_id);
      if ((user != null) && (user.abbreviatedDisplayName != null)) {
        return user.abbreviatedDisplayName();
      } else {
        return "-";
      }
    };

    CsvView.prototype.getMetadata = function() {
      var db;
      db = App.Database.exists(this.database_id);
      return {
        state: this.getState(),
        lastUploadedBy: this.getLastModifiedBy()
      };
    };

    CsvView.prototype.status = function() {
      return this.statusForIcon();
    };

    CsvView.prototype.statusForIcon = function() {
      return new App.CsvViewState(this).statusForIcon();
    };

    CsvView.prototype.getState = function() {
      if (this.isSuccessful()) {
        return 'Success';
      } else if (this.isErring()) {
        return 'Failed';
      } else {
        return 'Queued';
      }
    };

    CsvView.getAllViewsWithColumnNameMatchingQuery = function(searchStr) {
      var allViews, column, columnTokens, i, j, k, len, len1, matchesQuery, matchingViews, queryTokens, ref, view, viewHasMatchingColumn;
      allViews = CsvView.allSortedByName();
      if (_.isEmpty(_.trim(searchStr))) {
        return allViews;
      }
      queryTokens = App.Utils.tokenizeString(searchStr);
      matchingViews = [];
      for (j = 0, len = allViews.length; j < len; j++) {
        view = allViews[j];
        viewHasMatchingColumn = false;
        ref = view.user_columns;
        for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
          column = ref[i];
          columnTokens = App.Utils.tokenizeString(column.name);
          matchesQuery = (column.name.indexOf(searchStr) !== -1) || App.Utils.matchesQuery(queryTokens, columnTokens);
          view.user_columns[i].matches_query = matchesQuery;
          if (matchesQuery) {
            viewHasMatchingColumn = true;
          }
        }
        if (viewHasMatchingColumn) {
          matchingViews.push(view);
        }
      }
      return matchingViews;
    };

    CsvView.prototype.fsUpdated = function(fs) {
      if (fs.hash_key !== this.preview_source_hash_key) {
        return;
      }
      App.SourceFetcher.unbind('source-updated', this.fsUpdated);
      this.trigger('update', this);
      App.CsvView.trigger('update', this);
      return this.trigger('source-updated');
    };

    CsvView.prototype.fetchPreview = function() {
      if (!this.preview_source_hash_key) {
        return;
      }
      App.SourceFetcher.bind('source-updated', this.fsUpdated);
      return App.fetchSourceWithoutExplicitQuerySource(this.preview_source_hash_key);
    };

    CsvView.prototype.formulaSource = function() {
      return App.FormulaSource.findByHash(this.preview_source_hash_key);
    };

    CsvView.prototype.source = function() {
      var fs;
      if (this.error_message) {
        return null;
      }
      if (this.preview_data != null) {
        return this.preview_data;
      }
      fs = this.formulaSource();
      if (!fs) {
        this.fetchPreview();
      }
      return fs;
    };

    CsvView.prototype.getColumns = function() {
      var fs;
      fs = this.source();
      if (fs == null) {
        return [];
      }
      return fs.columns;
    };

    CsvView.prototype.rowsAsHashList = function() {
      var fs;
      fs = this.source();
      if (fs == null) {
        return [];
      }
      return App.Utils.rowsArraysToHashes(fs.rows, fs.columns);
    };

    CsvView.prototype.getPreviewRows = function() {
      var fs;
      fs = this.source();
      if (fs == null) {
        return [];
      }
      return fs.rows;
    };

    CsvView.prototype.getRowCount = function() {
      return this.row_count || this.getPreviewRows().length;
    };

    CsvView.prototype.getColumnCount = function() {
      if (this.user_columns != null) {
        return this.user_columns.length;
      } else if (this.getColumns() != null) {
        return this.getColumns().length;
      } else {
        return 0;
      }
    };

    CsvView.prototype.getError = function() {
      return this.error_message;
    };

    CsvView.wordsForSqlHints = function() {
      var j, len, ref, results, sn;
      ref = CsvView.all();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        sn = ref[j];
        results.push(sn.name);
      }
      return results;
    };

    CsvView.matches = function(str) {
      var j, k, len, len1, lowerStr, match, ref, ref1, sn, viewName;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      if (lowerStr.indexOf("as") >= 1 && (match = lowerStr.match(App.SqlView.ALIAS_REGEX))) {
        viewName = match[1];
        ref = this.all();
        for (j = 0, len = ref.length; j < len; j++) {
          sn = ref[j];
          if (sn.name === viewName) {
            return sn;
          }
        }
      } else {
        ref1 = this.all();
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          sn = ref1[k];
          if (("[" + sn.name + "]") === lowerStr) {
            return sn;
          }
        }
      }
      return false;
    };

    CsvView.prototype.cacheDisabled = function() {
      return false;
    };

    CsvView.prototype.isFailed = function() {
      return this.error_message != null;
    };

    CsvView.prototype.isErring = function() {
      return this.error_message != null;
    };

    CsvView.prototype.isSuccessful = function() {
      return (this.error_message == null) && (this.last_refreshed_at != null);
    };

    CsvView.prototype.getOwnerId = function() {
      return this.user_id;
    };

    CsvView.prototype.setOwnerId = function(id) {
      return this.user_id = id;
    };

    CsvView.prototype.destroy = function() {
      CsvView.__super__.destroy.apply(this, arguments);
      return App.RecentItem.removeForItem(this);
    };

    CsvView.prototype.dataset = function() {
      return App.Dataset.all().find((function(_this) {
        return function(dataset) {
          return dataset.explorable_id === _this.id && dataset.explorable_type === _this.constructor.className;
        };
      })(this));
    };

    CsvView.prototype.hasDataset = function() {
      return Boolean(this.dataset());
    };

    CsvView.prototype.previewColumns = function() {
      var columnInfo, j, len, ref, ret;
      ret = [];
      ref = this.user_columns;
      for (j = 0, len = ref.length; j < len; j++) {
        columnInfo = ref[j];
        ret.push({
          columnName: columnInfo.name,
          type: App.Dataset.simplifiedTypeFromDatabaseType(columnInfo.type)
        });
      }
      return ret;
    };

    return CsvView;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CustomDimension = (function(superClass) {
    extend(CustomDimension, superClass);

    function CustomDimension() {
      return CustomDimension.__super__.constructor.apply(this, arguments);
    }

    CustomDimension.configure('CustomDimension', 'filter_type', 'client_site_id', 'name', 'user_id', 'values_query', 'values_list', 'match_expression', 'database_id', 'last_update', 'error_message', 'last_data_loaded_at', 'parent_id', 'exclusive', 'available_by_default', 'used_by_shared_dashboards', 'hash_key');

    CustomDimension.extend(Spine.Model.Ajax);

    CustomDimension.AGGREGATION = 'aggregation';

    CustomDimension.DATE_RANGE = 'date_range';

    CustomDimension.CUSTOM_RANGE_START_DATE = 'custom_range_start_date';

    CustomDimension.CUSTOM_RANGE_END_DATE = 'custom_range_end_date';

    CustomDimension.BUILTIN_DIMENSIONS = [CustomDimension.AGGREGATION, CustomDimension.DATE_RANGE];

    CustomDimension.QUERY_DIMENSION_TYPE = 'Query';

    CustomDimension.VALUESLIST_DIMENSION_TYPE = 'ValuesList';

    CustomDimension.FREEINPUT_DIMENSION_TYPE = 'FreeInput';

    CustomDimension.DATERANGE_DIMENSION_TYPE = 'DateRange';

    CustomDimension.ALL_BUILTIN_DIMENSIONS = [CustomDimension.AGGREGATION, CustomDimension.DATE_RANGE, CustomDimension.CUSTOM_RANGE_START_DATE, CustomDimension.CUSTOM_RANGE_END_DATE];

    CustomDimension.ALL_DATERANGE_DIMENSIONS = [CustomDimension.DATE_RANGE, CustomDimension.CUSTOM_RANGE_START_DATE, CustomDimension.CUSTOM_RANGE_END_DATE];

    CustomDimension.FORBIDDEN_DIMENSION_NAMES = ['date_range', 'daterange', 'aggregation'];

    CustomDimension.ERROR_NO_NAME = 'no name';

    CustomDimension.ERROR_BAD_NAME = 'bad name';

    CustomDimension.ERROR_NO_VALUES = 'no values';

    CustomDimension.ERROR_NO_DB = 'no db';

    CustomDimension.ERROR_DUP_NAME = 'duplicate name';

    CustomDimension.ERROR_FORBIDDEN_NAME = 'forbidden name';

    CustomDimension.ERROR_FORBIDDEN_SUFFIX = 'forbidden suffix';

    CustomDimension.dimensionValueCache = {};

    CustomDimension.CACHE_ALL = 'all';

    CustomDimension.TOTAL_CHILD_LOAD_LIMIT = 1000;

    CustomDimension.find = function(id_or_cid) {
      switch (id_or_cid) {
        case this.DATE_RANGE:
          return {
            id: this.DATE_RANGE,
            name: this.DATE_RANGE
          };
        case this.AGGREGATION:
          return {
            id: this.AGGREGATION,
            name: this.AGGREGATION
          };
        default:
          return CustomDimension.__super__.constructor.find.call(this, id_or_cid);
      }
    };

    CustomDimension.allowsEqualUpdates = function() {
      return true;
    };

    CustomDimension.prototype.fetchHashKey = function() {
      return jQuery.ajax({
        url: "/custom_dimensions/" + this.id,
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id
        },
        dataType: 'json'
      }).always(((function(_this) {
        return function(r) {
          return _this.applyHash(r);
        };
      })(this)));
    };

    CustomDimension.prototype.applyHash = function(response) {
      this.hash_key = response != null ? response.hash_key : void 0;
      this.save({
        ajax: false
      });
      return this.trigger('data-updated');
    };

    CustomDimension.prototype.validate = function() {
      var errors;
      errors = [];
      if (!this.hasName()) {
        errors.push(CustomDimension.ERROR_NO_NAME);
      }
      if (!this.goodName()) {
        errors.push(CustomDimension.ERROR_BAD_NAME);
      }
      if (!this.valuesPresenceValid()) {
        errors.push(CustomDimension.ERROR_NO_VALUES);
      }
      if (!this.hasDbIfRequired()) {
        errors.push(CustomDimension.ERROR_NO_DB);
      }
      if (!this.nameIsUnique()) {
        errors.push(CustomDimension.ERROR_DUP_NAME);
      }
      if (!this.hasAllowedName()) {
        errors.push(CustomDimension.ERROR_FORBIDDEN_NAME);
      }
      if (errors.length === 0) {
        return null;
      }
      return errors;
    };

    CustomDimension.prototype.hasName = function() {
      return (this.name != null) && this.name.trim() !== '';
    };

    CustomDimension.prototype.hasValuesQuery = function() {
      return (this.values_query != null) && this.values_query.trim() !== '';
    };

    CustomDimension.prototype.hasValuesList = function() {
      return (this.values_list != null) && this.values_list.length > 0;
    };

    CustomDimension.prototype.hasDatabase = function() {
      return this.database_id != null;
    };

    CustomDimension.prototype.hasParent = function() {
      return (this.parent_id != null) && App.CustomDimension.exists(this.parent_id);
    };

    CustomDimension.prototype.hasAllowedName = function() {
      return (this.name != null) && CustomDimension.FORBIDDEN_DIMENSION_NAMES.indexOf(this.name.toLowerCase()) === -1;
    };

    CustomDimension.prototype.getParentValues = function(dashboard) {
      if (!this.hasParent()) {
        return [];
      }
      return dashboard.dimensionConfig().configuredDimensionValues(this.parent_id);
    };

    CustomDimension.prototype.valuesPresenceValid = function() {
      return this.hasValuesQuery() || this.hasValuesList() || this.isFreeInput() || this.isDateRange();
    };

    CustomDimension.prototype.hasDbIfRequired = function() {
      return !this.hasValuesQuery() || this.hasDatabase();
    };

    CustomDimension.prototype.nameIsUnique = function() {
      var cd, j, len, ref;
      if (!this.hasName()) {
        return true;
      }
      ref = CustomDimension.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        if (cd.cid !== this.cid && cd.name.toLowerCase() === this.name.toLowerCase()) {
          return false;
        }
      }
      return true;
    };

    CustomDimension.prototype.goodName = function() {
      return this.hasName() && App.Utils.isUnicodeWord(this.name);
    };

    CustomDimension.prototype.isFreeInput = function() {
      return this.filter_type === CustomDimension.FREEINPUT_DIMENSION_TYPE;
    };

    CustomDimension.prototype.isDateRange = function() {
      return this.filter_type === CustomDimension.DATERANGE_DIMENSION_TYPE;
    };

    CustomDimension.appliedUpdates = function(cd) {
      if (App.CustomDimensionHelper.dimensionDataUpToDate(cd)) {
        return;
      }
      if (cd && (cd != null) && (cd.last_data_loaded_at != null) && CustomDimension.initial_fetch_done) {
        return cd.resetCache();
      }
    };

    CustomDimension.prototype.isLoading = function() {
      if ((this.filter_type === CustomDimension.QUERY_DIMENSION_TYPE) || (this.filter_type === CustomDimension.VALUESLIST_DIMENSION_TYPE)) {
        return (this.error_message == null) && ((this.last_data_loaded_at == null) || !CustomDimension.hasCacheValue(this.id));
      } else {
        return (this.error_message == null) && (this.last_data_loaded_at == null);
      }
    };

    CustomDimension.prototype.isErrored = function() {
      return this.error_message != null;
    };

    CustomDimension.prototype.hasDefault = function() {
      return !this.isErrored() && !this.isFreeInput();
    };

    CustomDimension.prototype.cacheGet = function(prefix, groupNames) {
      if (groupNames == null) {
        groupNames = [];
      }
      return CustomDimension.cacheGet(this.id, prefix, groupNames);
    };

    CustomDimension.cacheGet = function(dimensionId, prefix, groupNames) {
      if (groupNames == null) {
        groupNames = [];
      }
      return this.cacheFor(dimensionId)[JSON.stringify([prefix, groupNames])] || null;
    };

    CustomDimension.prototype.cacheSet = function(prefix, values, groupNames) {
      if (groupNames == null) {
        groupNames = [];
      }
      return CustomDimension.cacheSet(this, prefix, values, groupNames);
    };

    CustomDimension.cacheSet = function(dimension, prefix, values, groupNames) {
      if (groupNames == null) {
        groupNames = [];
      }
      this.cacheFor(dimension.id)[JSON.stringify([prefix, groupNames])] = values;
      if (!_.isEmpty(dimension.hash_key)) {
        return App.CustomDimensionHelper.cachedHashKey(dimension.id)[dimension.hash_key] = dimension.last_data_loaded_at;
      }
    };

    CustomDimension.prototype.resetCache = function() {
      return this.constructor.resetCache(this);
    };

    CustomDimension.resetCache = function(dimension) {
      var fetcher;
      if (dimension != null) {
        delete this.dimensionValueCache[dimension.id];
        fetcher = new App.DimensionValueFetcher(dimension);
        return fetcher.fetch('', null, ((function(_this) {
          return function() {
            return dimension.trigger('data-updated');
          };
        })(this)));
      }
    };

    CustomDimension.cacheFor = function(dimensionId) {
      var base;
      return (base = this.dimensionValueCache)[dimensionId] != null ? base[dimensionId] : base[dimensionId] = {};
    };

    CustomDimension.hasCacheValue = function(dimensionId) {
      return this.dimensionValueCache[dimensionId] !== void 0;
    };

    CustomDimension.getDefaultDimensionValues = function(values) {
      if (values == null) {
        values = App.CustomDimension.records;
      }
      if (_.isEmpty(values)) {
        return;
      }
      return App.dimentorClient().remoteDefaultValues(values, (function(response) {
        return App.CustomDimension.cacheDefaults(response);
      }));
    };

    CustomDimension.cacheDefaults = function(results) {
      var dim, dimensionId, j, len, result, values, valuesByDimension;
      valuesByDimension = {};
      for (j = 0, len = results.length; j < len; j++) {
        result = results[j];
        dimensionId = result.dimension_id;
        valuesByDimension[dimensionId] || (valuesByDimension[dimensionId] = []);
        valuesByDimension[dimensionId].push(result);
      }
      for (dimensionId in valuesByDimension) {
        values = valuesByDimension[dimensionId];
        dim = App.CustomDimension.exists(dimensionId);
        this.cacheSet(dim, '', values, []);
        if (dim) {
          dim.trigger('data-updated');
        }
      }
      return CustomDimension.initial_fetch_done = true;
    };

    CustomDimension.prototype.getDimensionValues = function(prefix, group, callback) {
      if (App.Utils.isClientId(this.id)) {
        return false;
      }
      if (CustomDimension.doCallbackIfCached(this.id, prefix, group, callback)) {
        return;
      }
      return App.dimentorClient().remoteValues(this, prefix, group, callback);
    };

    CustomDimension.prototype.getDimensionValuesAsArrays = function(prefix, group, callback) {
      var translateCallback;
      translateCallback = function(results) {
        var r, values;
        values = (function() {
          var j, len, results1;
          results1 = [];
          for (j = 0, len = results.length; j < len; j++) {
            r = results[j];
            results1.push([r.id, r.name || r.id, r.group]);
          }
          return results1;
        })();
        return callback(values);
      };
      return this.getDimensionValues(prefix, group, translateCallback);
    };

    CustomDimension.doCallbackIfCached = function(dimensionId, prefix, group, callback) {
      var result;
      result = this.cacheGet(dimensionId, prefix, group);
      if (result != null) {
        if (typeof callback === "function") {
          callback(result);
        }
        return true;
      }
      return false;
    };

    CustomDimension.allSortedByName = function() {
      return CustomDimension.all().sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    };

    CustomDimension.allNonFreeInputSortedByName = function() {
      return _.reject(this.allSortedByName(), function(dim) {
        return dim.isFreeInput();
      });
    };

    CustomDimension.isCustomDimension = function(obj) {
      var ref;
      return (obj != null ? (ref = obj.constructor) != null ? ref.className : void 0 : void 0) === 'CustomDimension';
    };

    CustomDimension.elementIdForDimension = function(dim) {
      return dim.cid || dim.id || dim;
    };

    CustomDimension.idToNameMap = function() {
      var cd, j, len, map, ref;
      map = {};
      ref = CustomDimension.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        map[cd.id] = cd.name;
      }
      return map;
    };

    CustomDimension.idsFromList = function(custom_dimensions_list) {
      var dim, list;
      list = custom_dimensions_list || [];
      return ((function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = list.length; j < len; j++) {
          dim = list[j];
          results1.push(dim[0]);
        }
        return results1;
      })()).unique().sort();
    };

    CustomDimension.deletedCustomDimensionIdsFromList = function(custom_dimensions_list) {
      var allIds;
      allIds = this.idsFromList(custom_dimensions_list);
      return _.filter(allIds, function(id) {
        return !App.CustomDimension.exists(id);
      });
    };

    CustomDimension.signableIdsFromList = function(custom_dimensions_list) {
      var allIds;
      allIds = this.idsFromList(custom_dimensions_list);
      return _.filter(allIds, function(id) {
        var cd;
        cd = App.CustomDimension.exists(id);
        if (!cd) {
          return false;
        }
        return !cd.isFreeInput() && !cd.isDateRange();
      });
    };

    CustomDimension.dimNamesFromList = function(custom_dimensions_list) {
      var id, ids, nameMap;
      ids = CustomDimension.idsFromList(custom_dimensions_list);
      nameMap = CustomDimension.idToNameMap();
      return ((function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = ids.length; j < len; j++) {
          id = ids[j];
          results1.push(nameMap[id]);
        }
        return results1;
      })()).sort();
    };

    CustomDimension.prototype.sharedDashboardFactories = function() {
      var sdf, sdfs;
      sdfs = (function() {
        var j, len, ref, results1;
        ref = App.SharedDashboardFactory.all();
        results1 = [];
        for (j = 0, len = ref.length; j < len; j++) {
          sdf = ref[j];
          if (sdf.custom_dimension_id === this.id) {
            results1.push(sdf);
          }
        }
        return results1;
      }).call(this);
      return sdfs.sort(function(a, b) {
        return a.id - b.id;
      });
    };

    CustomDimension.prototype.hasSharedDashboardFactories = function() {
      return this.sharedDashboardFactories().length > 0;
    };

    CustomDimension.sortedByIdAndValue = function(list) {
      var listCopy;
      listCopy = jQuery.extend(true, [], list);
      return listCopy.sort(function(a, b) {
        if (a[0] === b[0]) {
          return a[1] - b[1];
        } else {
          return a[0] - b[0];
        }
      });
    };

    CustomDimension.equalArrays = function(l1, l2) {
      var el, i, j, l1Sorted, l2Sorted, len;
      if ((l1 == null) && (l2 == null)) {
        return true;
      }
      if ((l1 == null) || (l2 == null)) {
        return false;
      }
      if (l1.length !== l2.length) {
        return false;
      }
      l1Sorted = this.sortedByIdAndValue(l1);
      l2Sorted = this.sortedByIdAndValue(l2);
      for (i = j = 0, len = l1Sorted.length; j < len; i = ++j) {
        el = l1Sorted[i];
        if (l1Sorted[i][0] !== l2Sorted[i][0] || l1Sorted[i][1] !== l2Sorted[i][1]) {
          return false;
        }
      }
      return true;
    };

    CustomDimension.findByName = function(str) {
      var cd, j, len, lowerStr, ref;
      lowerStr = str.toLowerCase();
      ref = this.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        if (cd.name.toLowerCase() === lowerStr) {
          return cd;
        }
      }
      return null;
    };

    CustomDimension.isVisibleOnSharedDashboard = function(dashboard, dimensionId) {
      var j, len, ref, sd;
      dimensionId = dimensionId + "";
      ref = dashboard.sharedDashboards();
      for (j = 0, len = ref.length; j < len; j++) {
        sd = ref[j];
        if (sd.unlocked_filters.indexOf(dimensionId) !== -1) {
          return true;
        }
      }
      return false;
    };

    CustomDimension.isCustomDimensionId = function(dim_cid) {
      var match;
      match = dim_cid.match(/^c-\d+$/);
      return (match != null) && match.length > 0;
    };

    CustomDimension.extractDimNameFromBrackets = function(str) {
      var matches;
      if (typeof str !== 'string') {
        return null;
      }
      matches = str.match(/^\[\S(.*?)=(\S+)\]$/);
      if ((matches != null ? matches.length : void 0) === 3) {
        return matches[2];
      }
      return null;
    };

    CustomDimension.wordsForSqlHints = function() {
      var cd, j, len, output, ref;
      output = ['daterange', 'daterange_start', 'daterange_end'];
      ref = CustomDimension.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        if (cd.filter_type === CustomDimension.DATERANGE_DIMENSION_TYPE) {
          output.push.apply(output, [cd.name, cd.name + "_start", cd.name + "_end", cd.name + "_no_tz"]);
        } else {
          output.push(cd.name);
        }
      }
      return output;
    };

    CustomDimension.matches = function(str) {
      var cd, dimName, j, len, lowerStr, ref;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      dimName = this.extractDimNameFromBrackets(lowerStr);
      if (dimName == null) {
        return false;
      }
      if (dimName === 'category') {
        return true;
      }
      ref = this.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        if (cd.name.toLowerCase() === dimName) {
          return true;
        }
      }
      return false;
    };

    CustomDimension.matchesColumnInsertion = function(str) {
      var cd, j, k, len, len1, lowerStr, prefix, ref, ref1;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      ref = ['select', 'group'];
      for (j = 0, len = ref.length; j < len; j++) {
        prefix = ref[j];
        ref1 = this.all();
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          cd = ref1[k];
          if (lowerStr === ("[" + prefix + ":" + (cd.name.toLowerCase()) + "]")) {
            return true;
          }
        }
      }
      return false;
    };

    CustomDimension.matchesLiteralInsertion = function(str) {
      var cd, j, len, lowerStr, matches, ref;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      ref = this.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        matches = lowerStr.match(/^\[(single:)?(.+?)(\|.+)?\]$/);
        if ((matches != null) && matches[2] === cd.name.toLowerCase()) {
          return true;
        }
      }
      return false;
    };

    CustomDimension.matchesCustomDaterange = function(str) {
      var cd, dimName, j, len, literalMatch, lowerStr, matches, ref;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      dimName = this.extractDimNameFromBrackets(lowerStr);
      if (dimName == null) {
        literalMatch = lowerStr.match(/^\[(.+?)(_start|_end|_no_tz)?\]$/);
        if (literalMatch != null) {
          dimName = literalMatch[1];
        }
        if (!((dimName != null) && literalMatch[2] !== '_no_tz')) {
          return false;
        }
      }
      matches = dimName.match(/^([\w]+?)(_start|_end|_no_tz)?(:[\w:]+)?$/);
      ref = this.all();
      for (j = 0, len = ref.length; j < len; j++) {
        cd = ref[j];
        if ((matches != null) && (matches[1] === cd.name.toLowerCase()) && cd.isDateRange()) {
          return true;
        }
      }
      return false;
    };

    return CustomDimension;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CustomModule = (function(superClass) {
    extend(CustomModule, superClass);

    function CustomModule() {
      return CustomModule.__super__.constructor.apply(this, arguments);
    }

    CustomModule.configure('CustomModule', 'filepath');

    CustomModule.extend(Spine.Model.Ajax);

    return CustomModule;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Dashboard = (function(superClass) {
    extend(Dashboard, superClass);

    function Dashboard() {
      this.dimensionConfig = bind(this.dimensionConfig, this);
      this.refreshAllWidgetsFromUdv = bind(this.refreshAllWidgetsFromUdv, this);
      this.updateUserDataViewWithNamesAndMakeCurrent = bind(this.updateUserDataViewWithNamesAndMakeCurrent, this);
      this.removeInvalidDimensions = bind(this.removeInvalidDimensions, this);
      this.formatDateRangeForEmbed = bind(this.formatDateRangeForEmbed, this);
      this.applyPendingConfig = bind(this.applyPendingConfig, this);
      this.triggerScroll = bind(this.triggerScroll, this);
      return Dashboard.__super__.constructor.apply(this, arguments);
    }

    Dashboard.REFRESH_STRATEGY_DEFAULT = 'default';

    Dashboard.REFRESH_STRATEGY_NEVER_SKIP = 'never';

    Dashboard.REFRESH_STRATEGY_ALWAYS_SKIP = 'always';

    Dashboard.REFRESH_STRATEGY_FRESHNESS = 'freshness';

    Dashboard.configure('Dashboard', 'client_site_id', 'active', 'name', 'aggregation', 'date_range_dimension', 'default_color_theme_id', 'last_update', 'recurring_report_recipients', 'recurring_report_schedule', 'recurring_report_day_of_week', 'recurring_report_hour_of_day', 'user_id', 'shared_with_site', 'custom_dimensions_list', 'num_columns', 'sync_version', 'visibility', 'dimension_availability', 'config', 'pending_aggregation', 'pending_date_range', 'create_time', 'high_priority', 'tag_ids', 'dimension_order', 'last_7_day_usage_hours', 'num_shared_dashboards', 'is_fluid', 'description', 'filters_enabled', 'use_periscope_theme', 'num_udvs', 'schedule_id', 'user_refresh_disabled_when_fresher_than_seconds', 'user_refresh_disabling_strategy', 'archived_at', 'archived_by_user_id', 'excluded_from_auto_archive', 'sql_alert_id', 'send_quality_check_failed_message', 'quality_check_failed_message', 'permissions', 'icon_color');

    Dashboard.extend(Spine.Model.Ajax);

    Dashboard.CLIENT_ONLY_ATTRIBUTES = ['config', 'pending_aggregation', 'pending_date_range'];

    Dashboard.DONT_TRIGGER_ON_CHECK_FOR_UPDATE = true;

    Dashboard.EVENT_CONFIG_CHANGED = 'config-changed';

    Dashboard.EVENT_CONFIG_RESET = 'config-reset';

    Dashboard.EVENT_APPLIED_CONFIG = 'applied-config';

    Dashboard._archivedDashboards = {};

    Dashboard.currentDashboard = function() {
      return this.currentlyActiveArchiveDashboard() || this.currentlyActiveDashboard();
    };

    Dashboard.currentlyActiveArchiveDashboard = function() {
      var activeArchivedDashboard, archivedDashboards, finderfunc;
      archivedDashboards = _.values(this._archivedDashboards);
      finderfunc = function(d) {
        return d.active;
      };
      return activeArchivedDashboard = _.find(archivedDashboards, finderfunc);
    };

    Dashboard.currentlyActiveDashboard = function() {
      return this.findByAttribute('active', true);
    };

    Dashboard.loadArchived = function(id, callback, preloadedData) {
      return jQuery.when(preloadedData || jQuery.get(App.Dashboard.url(id, 'show_archived'))).then((function(_this) {
        return function(response) {
          var item;
          item = new App.Dashboard(response.Dashboard);
          item.filters_enabled = false;
          item._archived_widgets = response['Widget'].map(function(w) {
            return new App.Widget(Object.assign(w, {
              _archived_dashboard: item
            }));
          });
          if (typeof callback === 'function') {
            callback(item);
          }
          return _this._archivedDashboards[item.id] = item;
        };
      })(this));
    };

    Dashboard.persistNewDashboard = function(dashboard) {
      dashboard.filters_enabled = false;
      dashboard.one('ajaxError', (function(_this) {
        return function(xhr) {
          if (xhr.status === HttpCodes.permissionDenied) {
            dashboard.destroy();
            return Spine.trigger('permission_denied');
          }
        };
      })(this));
      if (AppRedesign.createDashboardsEnabled()) {
        dashboard.save({
          success: (function(_this) {
            return function() {
              return App.RouteHelper.navigateTo('Dashboard', dashboard.reload(), {
                replace: true
              });
            };
          })(this)
        });
      }
      return dashboard;
    };

    Dashboard.prototype.displayName = function() {
      return this.getName();
    };

    Dashboard.prototype.status = function() {
      return '';
    };

    Dashboard.prototype.load = function() {
      var self;
      self = Dashboard.__super__.load.apply(this, arguments);
      return self;
    };

    Dashboard.prototype.destroy = function() {
      var i, len, ref, widget;
      ref = this.widgets(true);
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        widget.destroy({
          ajax: false
        });
      }
      App.RecentItem.removeForItem(this);
      if (AppRedesign.autoArchiveEnabled()) {
        App.SearchableArchive.createRecord(this.id, this.name, 'Dashboard', new Date().toISOString(), this.tags());
      }
      if (this.isActive()) {
        this.makeNextDashboardCurrent();
      }
      this.constructor.trigger('destroyed', this);
      return Dashboard.__super__.destroy.apply(this, arguments);
    };

    Dashboard.prototype.makeNextDashboardCurrent = function() {
      var dashboard, i, len, ref;
      ref = App.User.currentUser().dashboards().concat(App.Dashboard.allSortedByName());
      for (i = 0, len = ref.length; i < len; i++) {
        dashboard = ref[i];
        if (this.id !== dashboard.id) {
          App.RouteHelper.navigateTo('Dashboard', dashboard, {
            replace: true
          });
          return;
        }
      }
    };

    Dashboard.prototype.isActive = function() {
      return (this.active != null) && this.active;
    };

    Dashboard.prototype.hasAnyDatabaseBlockedMappingWidgets = function() {
      return _.some(this.widgets(), function(widget) {
        return widget.blocked_by_database_mapping_feature;
      });
    };

    Dashboard.prototype.widgets = function() {
      var w;
      if (this._archived_widgets && this.isArchived()) {
        return this._archived_widgets;
      }
      w = App.Widget.select((function(_this) {
        return function(w) {
          return w.dashboard_id === _this.id;
        };
      })(this));
      return App.RedesignRectangles.rectsSortedByRow(w);
    };

    Dashboard.prototype.widgetIds = function() {
      var i, len, ref, results, w;
      ref = this.widgets();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        w = ref[i];
        results.push(w.id);
      }
      return results;
    };

    Dashboard.prototype.reliesOnRestrictedDb = function() {
      return _.some(this.widgets(), function(widget) {
        return widget.reliesOnRestrictedDb();
      });
    };

    Dashboard.prototype.widgetsRequiresQuery = function() {
      return _.filter(this.widgets(), function(widget) {
        return widget.contentRequiresQuery();
      });
    };

    Dashboard.prototype.useSpaceTheme = function() {
      return (this.default_color_theme_id == null) && !this.use_periscope_theme;
    };

    Dashboard.prototype.colorTheme = function() {
      if (this.use_periscope_theme) {
        return App.ColorTheme.PERISCOPE_DEFAULT_THEME();
      }
      return App.ColorTheme.exists(this.default_color_theme_id) || App.Site.first().colorTheme();
    };

    Dashboard.prototype.widgetHashKeys = function() {
      var i, keys, len, ref, w;
      keys = [];
      ref = this.widgetsRequiresQuery();
      for (i = 0, len = ref.length; i < len; i++) {
        w = ref[i];
        if (w.formula_source_hash_key != null) {
          keys.push(w.formula_source_hash_key);
        }
        if (w.code_hash_key != null) {
          keys.push(w.code_hash_key);
        }
      }
      return keys.unique();
    };

    Dashboard.prototype.widgetsSortedByRow = function() {
      return this.widgets();
    };

    Dashboard.prototype.getName = function() {
      if ((this.name == null) || this.name.trim() === '') {
        return this.makePrettyName();
      }
      return this.name;
    };

    Dashboard.prototype.setName = function(val) {
      return this.name = val;
    };

    Dashboard.prototype.makePrettyName = function() {
      return "Untitled Dashboard";
    };

    Dashboard.prototype.dashboardNumber = function(name) {
      var match;
      if (name == null) {
        name = this.name;
      }
      match = /Dashboard (\d+)/.exec(name);
      if ((match != null) && match.length > 1) {
        return parseInt(match[1]);
      } else {
        return null;
      }
    };

    Dashboard.prototype.makeNotCurrent = function() {
      this.active = false;
      this.trigger("dashboard-no-longer-current");
      if (this.isArchived()) {
        return delete this.constructor._archivedDashboards[this.id];
      } else {
        return this.save({
          ajax: false
        });
      }
    };

    Dashboard.prototype.makeCurrent = function() {
      this._makeCurrent();
      if (this.shouldFetchFilterValues()) {
        App.CustomDimensionHelper.loadCustomDimensionsAndFetchDefaults(this.id);
      }
      return this.trigger("dashboard-made-current");
    };

    Dashboard.prototype._makeCurrent = function() {
      var ref, ref1;
      if (!this.isArchived()) {
        if ((ref = AppRedesign.current().spinalCord) != null) {
          ref.firstBatchOfWidgetsNotLoaded();
        }
      }
      App.Lagotron.addContext('dashboard made current');
      if ((ref1 = App.Dashboard.currentDashboard()) != null) {
        ref1.makeNotCurrent();
      }
      this.active = true;
      if (!this.isArchived()) {
        this.save({
          ajax: false
        });
      }
      return this.trigger("ensure-dashboard-controller-exists");
    };

    Dashboard.prototype.makeCurrentAndScroll = function(widgetId) {
      this._makeCurrent();
      return this.trigger("dashboard-made-current", ((function(_this) {
        return function() {
          return _this.triggerScroll(widgetId);
        };
      })(this)));
    };

    Dashboard.prototype.triggerScroll = function(widgetId) {
      return this.trigger('scroll-to-widget', widgetId);
    };

    Dashboard.prototype.activateAndScrollToWidget = function(widgetId) {
      if (this.isCompletelyLoaded()) {
        this.makeCurrent();
        return this.triggerScroll(widgetId);
      } else {
        return this.makeCurrentAndScroll(widgetId);
      }
    };

    Dashboard.prototype.nextFreeRow = function() {
      var i, len, maxClientRow, ref, widget, widgetBottom;
      maxClientRow = -1;
      ref = this.widgets();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        widgetBottom = widget.getRow() + (widget.getHeight() - 1);
        if (widgetBottom > maxClientRow) {
          maxClientRow = widgetBottom;
        }
      }
      return maxClientRow + 1;
    };

    Dashboard.prototype.isCompletelyLoaded = function() {
      var sc;
      sc = AppRedesign.current().spinalCord;
      if (sc == null) {
        return;
      }
      return (sc.getLastUpdateForDashboard(this.id) || sc.getLastUpdateForDashboard(this.cid)) && (sc.getWidgetsLoadedForDashboard(this.id) || sc.getWidgetsLoadedForDashboard(this.cid) || AppRedesign.current().shared_mode);
    };

    Dashboard.prototype.filtersVisibleOnSharedDashboards = function() {
      var filter, i, j, len, len1, ref, sd, uniqueFilterHash, uniqueUnlockedFilters, unlockedFilters;
      unlockedFilters = [];
      ref = this.sharedDashboards();
      for (i = 0, len = ref.length; i < len; i++) {
        sd = ref[i];
        unlockedFilters = unlockedFilters.concat(sd.unlocked_filters);
      }
      uniqueUnlockedFilters = App.Utils.fastUnique(unlockedFilters);
      uniqueFilterHash = {};
      for (j = 0, len1 = uniqueUnlockedFilters.length; j < len1; j++) {
        filter = uniqueUnlockedFilters[j];
        uniqueFilterHash[filter] = true;
      }
      return uniqueFilterHash;
    };

    Dashboard.prototype.allDimensionCidsInOrder = function() {
      var allCids, cd_id, cid, d, dimCids, i, len, ref;
      if (((ref = this.dimension_order) != null ? ref.length : void 0) > 0) {
        dimCids = (function() {
          var i, len, ref1, results;
          ref1 = this.dimension_order;
          results = [];
          for (i = 0, len = ref1.length; i < len; i++) {
            cd_id = ref1[i];
            results.push(App.DimensionAvailability.dimensionExists(cd_id).cid);
          }
          return results;
        }).call(this);
        allCids = ((function() {
          var i, len, ref1, results;
          ref1 = App.CustomDimension.allSortedByName();
          results = [];
          for (i = 0, len = ref1.length; i < len; i++) {
            d = ref1[i];
            results.push(d.cid);
          }
          return results;
        })()).concat(App.CustomDimension.BUILTIN_DIMENSIONS);
        for (i = 0, len = allCids.length; i < len; i++) {
          cid = allCids[i];
          if (!dimCids.includes(cid)) {
            dimCids.push(cid);
          }
        }
      } else {
        dimCids = (function() {
          var j, len1, ref1, results;
          ref1 = App.CustomDimension.allSortedByName();
          results = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            d = ref1[j];
            results.push(d.cid);
          }
          return results;
        })();
        dimCids = dimCids.concat(App.CustomDimension.BUILTIN_DIMENSIONS);
      }
      return dimCids;
    };

    Dashboard.prototype.visibleDimensionsInOrder = function() {
      var cid, dimCids, i, len, results, visibleDimSet;
      dimCids = this.allDimensionCidsInOrder();
      visibleDimSet = this.visibleDimensionCids().to_set();
      results = [];
      for (i = 0, len = dimCids.length; i < len; i++) {
        cid = dimCids[i];
        if ((visibleDimSet[cid] != null) && App.CustomDimension.exists(cid)) {
          results.push(App.CustomDimension.exists(cid));
        }
      }
      return results;
    };

    Dashboard.prototype.visibleDimensionCids = function() {
      var available, cid;
      return (function() {
        var ref, results;
        ref = App.DimensionAvailability.availableForDashboard(this);
        results = [];
        for (cid in ref) {
          available = ref[cid];
          if (available) {
            results.push(cid);
          }
        }
        return results;
      }).call(this);
    };

    Dashboard.prototype.setCurrentConfigAsDefault = function() {
      var defaults;
      App.Utils.logFeature("set-custom-dimension-defaults", {
        dashboard_id: this.id
      });
      defaults = {
        custom_dimensions_list: this.dimensionConfig().custom_dimensions_list,
        date_range_dimension: this.dateRangeSetting(),
        aggregation: this.aggregationSetting()
      };
      if (!AppRedesign.current().shared_mode) {
        App.DimensionAvailability.setDimensionOrderForDashboard(this);
        defaults.dimension_order = this.dimension_order;
      }
      return jQuery.ajax({
        url: "/dashboards/" + this.id + "/set_defaults",
        type: 'POST',
        data: JSON.stringify(defaults),
        dataType: 'json',
        contentType: 'application/json'
      });
    };

    Dashboard.prototype.clearDashboardSettings = function() {
      this.dimensionConfig().setFromDashDefaults(this);
      this.removeInvalidDimensions();
      this.clearDateRangeAndAggregation();
      this.save({
        ajax: false
      });
      return this.trigger(App.Dashboard.EVENT_CONFIG_CHANGED);
    };

    Dashboard.prototype.clearDateRangeAndAggregation = function() {
      var sd;
      sd = App.SharedDashboard.currentSharedDashboard();
      if (sd != null) {
        this.pending_aggregation = sd.aggregation;
        return this.pending_date_range = sd.date_range_dimension;
      } else {
        this.pending_aggregation = this.aggregation;
        return this.pending_date_range = this.date_range_dimension;
      }
    };

    Dashboard.prototype.clearPendingState = function() {
      this.pending_aggregation = void 0;
      this.pending_date_range = void 0;
      this.config = new App.DimensionConfig();
      this.config.initializeFrom(this);
      this.save({
        ajax: false
      });
      return this.trigger(App.Dashboard.EVENT_CONFIG_CHANGED);
    };

    Dashboard.prototype.setPendingAggregation = function(aggregation) {
      this.pending_aggregation = aggregation;
      this.save({
        ajax: false
      });
      return this.trigger(App.Dashboard.EVENT_CONFIG_CHANGED);
    };

    Dashboard.prototype.setPendingDateRange = function(dateRange) {
      this.pending_date_range = dateRange;
      this.save({
        ajax: false
      });
      return this.trigger(App.Dashboard.EVENT_CONFIG_CHANGED);
    };

    Dashboard.prototype.setFiltersDisabledState = function(state) {
      this.disable_filters = state;
      return this.save({
        ajax: false
      });
    };

    Dashboard.prototype.hasNewPendingSettings = function() {
      return this.hasNewPendingDimensions() || this.hasNewPendingAggregation() || this.hasNewPendingDateRange();
    };

    Dashboard.prototype.hasNewPendingDimensions = function() {
      var ref;
      return !App.CustomDimension.equalArrays((ref = this.config) != null ? ref.custom_dimensions_list : void 0, this.userDataView().custom_dimensions_list);
    };

    Dashboard.prototype.hasNewPendingAggregation = function() {
      return this.aggregationSetting(true) !== this.aggregationSetting() && ((this.aggregationSetting() != null) || (this.aggregationSetting(true) != null));
    };

    Dashboard.prototype.hasNewPendingDateRange = function() {
      return !App.RedesignDateRangeDimensionSetting.dateRangeOptionsMatch(this.dateRangeSetting(true), this.dateRangeSetting(), true) && ((this.dateRangeSetting() != null) || (this.dateRangeSetting(true) != null));
    };

    Dashboard.applyUpdates = function(attributeArray, dontTriggerUpdateEvents) {
      if (dontTriggerUpdateEvents == null) {
        dontTriggerUpdateEvents = false;
      }
      if (attributeArray == null) {
        return;
      }
      if (AppRedesign.loadOnlyFluidDashboards()) {
        _.remove(attributeArray, function(attributes) {
          return (attributes != null ? attributes.is_fluid : void 0) !== true;
        });
      }
      return Dashboard.__super__.constructor.applyUpdates.call(this, attributeArray, dontTriggerUpdateEvents);
    };

    Dashboard.prototype.applyPendingConfig = function() {
      if (this.config == null) {
        return;
      }
      this.updateUserDataViewToConfig();
      if (App.Utils.isInsideIframe() && AppRedesign.isInEmbedMode()) {
        this.postMessageForFilterChange();
      }
      return this.trigger(Dashboard.EVENT_APPLIED_CONFIG);
    };

    Dashboard.prototype.postMessageForFilterChange = function() {
      var ref;
      return window.parent.postMessage({
        event_type: 'viewport_changed',
        event_detail: 'filters_changed',
        has_dashboard_changed: false,
        dashboard_id: (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0,
        aggregation: this.aggregationSetting(),
        daterange: this.formatDateRangeForEmbed(),
        filters: this.dimensionConfig().customDimensionsFormattedForEmbedApi()
      }, '*');
    };

    Dashboard.prototype.formatDateRangeForEmbed = function() {
      var ref, ref1, ref2, ref3, ref4;
      if (((ref = this.dateRangeSetting()) != null ? ref.type : void 0) === 'units') {
        return {
          days: this.dateRangeSetting().num_units
        };
      } else if (((ref1 = this.dateRangeSetting()) != null ? ref1.type : void 0) === 'range') {
        return {
          start: ((ref2 = this.dateRangeSetting()) != null ? ref2.range_start : void 0) || '',
          end: ((ref3 = this.dateRangeSetting()) != null ? ref3.range_end : void 0) || ''
        };
      } else if (((ref4 = this.dateRangeSetting()) != null ? ref4.type : void 0) === 'timeframe') {
        return {
          unit: this.dateRangeSetting().unit,
          frame: this.dateRangeSetting().frame
        };
      }
      return null;
    };

    Dashboard.prototype.fetchUdvSignatures = function() {
      if (this.userDataView().isNew() || this.signaturesFetched || !AppRedesign.current().remainingStateLoaded) {
        return;
      }
      App.UdvHelper.signAndCleanCustomDimensions(this.userDataView(), {
        ajax: false,
        dashboard: this
      });
      return this.signaturesFetched = true;
    };

    Dashboard.prototype.removeInvalidDimensions = function(dimensionList) {
      var config, dim, i, len, ref, results;
      this.invalid_udv_dimensions || (this.invalid_udv_dimensions = dimensionList);
      if (!this.invalid_udv_dimensions) {
        return;
      }
      config = this.dimensionConfig();
      ref = this.invalid_udv_dimensions;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        dim = ref[i];
        results.push(config.removeDimensionInfo(dim[0], dim[1]));
      }
      return results;
    };

    Dashboard.prototype.updateUserDataViewToConfig = function() {
      var config, ref, udv;
      udv = this.userDataView();
      udv.removeSourcesFromSourceFetcher();
      config = this.dimensionConfig();
      udv.date_range_dimension = this.dateRangeSetting();
      udv.aggregation = this.aggregationSetting();
      udv.custom_dimensions_list = jQuery.extend(true, [], config.custom_dimensions_list) || [];
      if (AppRedesign.current().shared_mode) {
        udv.save();
        if ((ref = AppRedesign.current()) != null) {
          ref.loadUntilNextCheckForUpdates = true;
        }
        return udv.prepareWidgetsForUpdate();
      } else {
        udv.fast_update = true;
        App.UdvHelper.signAndCleanCustomDimensions(udv, {
          success: this.refreshAllWidgetsFromUdv
        });
        if (!_.isEmpty(this.invalid_udv_dimensions)) {
          return App.UdvHelper.logInvalidDimensions(this.invalid_udv_dimensions);
        }
      }
    };

    Dashboard.prototype.setCustomDimensionListAndMakeCurrent = function(id_values) {
      if (this.shouldFetchFilterValues()) {
        return App.CustomDimensionHelper.loadCustomDimensionsAndMakeCurrent(this, id_values);
      } else {
        return App.dimentorClient().remoteNameFromValues(id_values, this.updateUserDataViewWithNamesAndMakeCurrent);
      }
    };

    Dashboard.prototype.updateUserDataViewWithNamesAndMakeCurrent = function(response) {
      var builtinDateRange, config, filter, filter_id, i, len, ref, result, udv, value;
      udv = this.userDataView();
      config = this.dimensionConfig();
      builtinDateRange = null;
      config.custom_dimensions_list = [];
      ref = response.results;
      for (i = 0, len = ref.length; i < len; i++) {
        result = ref[i];
        if (result.length < 3) {
          continue;
        }
        filter = result[0];
        if (App.CustomDimension.ALL_BUILTIN_DIMENSIONS.includes(filter)) {
          value = result[1].trim().toLowerCase();
          if (filter === App.CustomDimension.AGGREGATION) {
            this.pending_aggregation = value;
          }
          if (filter === App.CustomDimension.DATE_RANGE) {
            this.pending_date_range = App.RedesignDateRangeDimensionSetting.getOption(value);
          }
          if ([App.CustomDimension.CUSTOM_RANGE_START_DATE, App.CustomDimension.CUSTOM_RANGE_END_DATE].includes(filter) && builtinDateRange === null) {
            builtinDateRange = App.RedesignDateRangeDimensionSetting.getOption(filter);
            builtinDateRange.range_start = null;
            builtinDateRange.range_end = null;
          }
          if (filter === App.CustomDimension.CUSTOM_RANGE_START_DATE) {
            builtinDateRange.range_start = value;
          }
          if (filter === App.CustomDimension.CUSTOM_RANGE_END_DATE) {
            builtinDateRange.range_end = value;
          }
        } else {
          filter_id = parseInt(result[0]);
          if (isNaN(filter_id)) {
            continue;
          }
          result[0] = filter_id;
          config.custom_dimensions_list.push(result);
        }
      }
      config.cleanupAndSave();
      this.pending_date_range = builtinDateRange;
      this.updateUserDataViewToConfig();
      App.RedesignDashboardsController.switchToDashboard(this);
      App.Site.trigger('request-several-updates');
      return AppRedesign.current().syncParentIframeDashboardOnDrilldown(this);
    };

    Dashboard.prototype.refreshAllWidgets = function() {
      var i, len, ref, results, widget;
      if (AppRedesign.current().batchedChartUpdateEnabled) {
        return this.batchRefreshWidgets();
      } else {
        ref = this.widgetsRequiresQuery();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          widget = ref[i];
          results.push(widget.refreshData(true));
        }
        return results;
      }
    };

    Dashboard.prototype.refreshAllWidgetsFromUdv = function() {
      var i, len, ref, results, udv, widget;
      udv = this.userDataView();
      if (AppRedesign.current().batchedChartUpdateEnabled) {
        return this.batchRefreshWidgetsFromUdv(udv);
      } else {
        ref = this.widgetsRequiresQuery();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          widget = ref[i];
          results.push(widget.refreshData(false, udv));
        }
        return results;
      }
    };

    Dashboard.prototype.refreshAllWidgetsFromEmbedApi = function() {
      return this.userDataView().refreshDataWithoutNewHashKeys();
    };

    Dashboard.prototype.batchRefreshWidgets = function() {
      if (this.isNew() || App.Utils.isClientId(this.id)) {
        return;
      }
      return new App.BatchWidgetRefreshHelper(this).refreshAll();
    };

    Dashboard.prototype.batchRefreshWidgetsFromUdv = function(udv) {
      if (this.isNew() || App.Utils.isClientId(this.id)) {
        return;
      }
      return new App.BatchWidgetRefreshHelper(this).refreshFilters();
    };

    Dashboard.prototype.userDataView = function() {
      return this.getExistingUserDataView() || this.newUserDataView();
    };

    Dashboard.prototype.getExistingUserDataView = function() {
      return App.UserDataView.currentForDashboard(this);
    };

    Dashboard.prototype.newUserDataView = function() {
      return App.UserDataView.newForDashboard(this);
    };

    Dashboard.prototype.resetConfigState = function() {
      this.config = null;
      this.save({
        ajax: false
      });
      return this.trigger('rerender-settings');
    };

    Dashboard.prototype.dimensionConfig = function() {
      var sv, udv;
      udv = this.getExistingUserDataView();
      sv = udv != null ? udv.sync_version : void 0;
      if ((this.config != null) && (!sv || this.config.sync_version === sv)) {
        return App.DimensionConfig.enforceExclusiveConstraints(this.config);
      }
      this.config = new App.DimensionConfig();
      this.config.initializeFrom(this);
      return this.config;
    };

    Dashboard.prototype.aggregationSetting = function(ignorePending) {
      var udv;
      if (ignorePending == null) {
        ignorePending = false;
      }
      if (!ignorePending && this.pending_aggregation !== void 0) {
        return this.pending_aggregation;
      }
      udv = this.getExistingUserDataView();
      if (udv != null) {
        return udv.aggregation;
      }
      return this.aggregation;
    };

    Dashboard.prototype.dateRangeSetting = function(ignorePending) {
      var udv;
      if (ignorePending == null) {
        ignorePending = false;
      }
      if (!ignorePending && this.pending_date_range !== void 0) {
        return this.pending_date_range;
      }
      udv = this.getExistingUserDataView();
      if (udv != null) {
        return udv.date_range_dimension;
      }
      return this.date_range_dimension;
    };

    Dashboard.prototype.defaultAggregationSetting = function() {
      return this.aggregation;
    };

    Dashboard.prototype.defaultDateRangeSetting = function() {
      return this.date_range_dimension;
    };

    Dashboard.prototype.filters = function() {
      return new App.DashboardFilters(this.custom_dimensions_list, this.aggregation, this.date_range_dimension);
    };

    Dashboard.prototype.isVisibleToOwner = function() {
      return this.dashboardGroupPermissions.length === 0;
    };

    Dashboard.prototype.isVisibleToGroups = function() {
      return this.dashboardGroupPermissions.length > 1 && !this.isVisibleToEveryone();
    };

    Dashboard.prototype.isVisibleToEveryone = function() {
      return this.everyoneGroupPermission(false);
    };

    Dashboard.prototype.isEditableByGroups = function() {
      var dgp, numEditable;
      numEditable = ((function() {
        var i, len, ref, results;
        ref = App.DashboardGroupPermission.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          dgp = ref[i];
          if (dgp.dashboard_id === this.id && dgp.can_edit) {
            results.push(dgp);
          }
        }
        return results;
      }).call(this)).length;
      return numEditable > 1 && !this.isEditableByEveryone();
    };

    Dashboard.prototype.isEditableByEveryone = function() {
      return this.everyoneGroupPermission(true);
    };

    Dashboard.prototype.dashboardGroupPermissions = function() {
      var dgp, i, len, ref, results;
      ref = App.DashboardGroupPermission.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        dgp = ref[i];
        if (dgp.dashboard_id === this.id && (dgp.deleted_at == null)) {
          results.push(dgp);
        }
      }
      return results;
    };

    Dashboard.prototype.everyoneGroupPermission = function(checkEdit) {
      return this.groupPermission(App.Group.ALL_USERS, checkEdit);
    };

    Dashboard.prototype.adminGroupPermission = function(checkEdit) {
      return this.groupPermission(App.Group.ADMINS, checkEdit);
    };

    Dashboard.prototype.groupPermission = function(groupName, checkEdit) {
      var dgp, everyoneGroup, everyoneGroupPermission, i, len, ref;
      everyoneGroup = App.Group.findByName(groupName);
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        dgp = ref[i];
        if (dgp.dashboard_id === this.id && dgp.group_id === everyoneGroup.id) {
          everyoneGroupPermission = dgp;
          break;
        }
      }
      if (everyoneGroupPermission == null) {
        return false;
      }
      return !checkEdit || everyoneGroupPermission.can_edit;
    };

    Dashboard.prototype.isVisibleToCurrentUser = function() {
      var dashboardGroups, i, len, membershipIdMap, permission, user;
      if ((AppRedesign.current() != null) && AppRedesign.current().shared_mode) {
        return true;
      }
      user = App.User.currentUser();
      if (user == null) {
        return false;
      }
      if (user.isAdmin()) {
        return true;
      }
      if (this.user_id === user.id) {
        return true;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        return true;
      } else {
        if (this.isVisibleToEveryone()) {
          return true;
        }
        dashboardGroups = this.dashboardGroupPermissions();
        membershipIdMap = App.GroupMembership.userToGroupsMap()[user.id];
        for (i = 0, len = dashboardGroups.length; i < len; i++) {
          permission = dashboardGroups[i];
          if (membershipIdMap[permission.group_id]) {
            return true;
          }
        }
        return false;
      }
    };

    Dashboard.prototype.isArchived = function() {
      return AppRedesign.autoArchiveEnabled() && !!this.archived_at;
    };

    Dashboard.prototype.isReadOnlyToCurrentUser = function() {
      if (this.isArchived()) {
        return true;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        return !this.hasCreateSqlOrDiscoveryChartsPermission();
      } else {
        return this.isVisibleToCurrentUser() && !this.isExplorableByCurrentUser();
      }
    };

    Dashboard.prototype.isRearrangeableByCurrentUser = function() {
      var dp;
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.readOnlyMaintenanceMode()) {
          return false;
        }
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        dp = AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions;
        return AppRedesign.createSqlChartsEnabledOnDashboard() || AppRedesign.createDiscoveryChartsEnabledOnDashboard() || AppRedesign.editDashboardSettingsEnabledOnDashboard();
      } else {
        return this._isEditableByCurrentUser({
          anyAdmin: false,
          exploreUser: true
        });
      }
    };

    Dashboard.prototype.isEditableByCurrentUser = function() {
      return this._isEditableByCurrentUser({
        anyAdmin: false,
        exploreUser: false
      });
    };

    Dashboard.prototype.isExplorableByCurrentUser = function() {
      return this._isEditableByCurrentUser({
        anyAdmin: true,
        exploreUser: true
      });
    };

    Dashboard.prototype._isEditableByCurrentUser = function(allow) {
      var dashboardGroups, i, len, membershipIdMap, permission, user;
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      if (!this.isVisibleToCurrentUser()) {
        return false;
      }
      user = App.User.currentUser();
      if (user == null) {
        return false;
      }
      if (user.isAdmin() && allow.anyAdmin) {
        return true;
      }
      if (user.isAdminWithEditPrivilege()) {
        return true;
      }
      if (!(user.canEdit() || (allow.exploreUser && user.canExplore()))) {
        return false;
      }
      if (this.user_id === user.id) {
        return true;
      }
      if ((AppRedesign.current() != null) && AppRedesign.current().shared_mode) {
        return false;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        if (allow.exploreUser) {
          return AppRedesign.createDiscoveryChartsEnabledOnDashboard();
        }
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        if (this.isEditableByEveryone()) {
          return true;
        }
        dashboardGroups = this.dashboardGroupPermissions();
        membershipIdMap = App.GroupMembership.userToGroupsMap()[user.id];
        if (membershipIdMap === void 0) {
          return false;
        }
        for (i = 0, len = dashboardGroups.length; i < len; i++) {
          permission = dashboardGroups[i];
          if (membershipIdMap[permission.group_id] && (permission.can_edit || (allow.exploreUser && permission.can_drag_and_drop))) {
            return true;
          }
        }
      }
      return false;
    };

    Dashboard.prototype.hasCreateSqlOrDiscoveryChartsPermission = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      return this.hasCreateSqlChartsPermission() || this.hasCreateDiscoveryChartsPermission();
    };

    Dashboard.prototype.hasCreateSqlChartsPermission = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      return AppRedesign.createSqlChartsEnabled();
    };

    Dashboard.prototype.hasCreateDiscoveryChartsPermission = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.create_discovery_charts;
    };

    Dashboard.prototype.canMoveTo = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.readOnlyMaintenanceMode()) {
          return false;
        }
        return this.hasCreateSqlOrDiscoveryChartsPermission();
      } else {
        return this.isExplorableByCurrentUser();
      }
    };

    Dashboard.prototype.canCopyTo = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.readOnlyMaintenanceMode()) {
          return false;
        }
        return this.hasCreateSqlOrDiscoveryChartsPermission();
      } else {
        return this.isEditableByCurrentUser();
      }
    };

    Dashboard.prototype.isPrivateToCurrentUser = function() {
      return !this.shared_with_site;
    };

    Dashboard.prototype.isOwnedByCurrentUser = function() {
      var cu;
      cu = App.User.currentUser();
      if (cu == null) {
        return false;
      }
      return this.user_id === cu.id;
    };

    Dashboard.prototype.isStarredByCurrentUser = function() {
      return this.starForCurrentUser() != null;
    };

    Dashboard.prototype.starForCurrentUser = function() {
      var cu, i, len, ref, star;
      cu = App.User.currentUser();
      ref = this.stars();
      for (i = 0, len = ref.length; i < len; i++) {
        star = ref[i];
        if (star.user_id === cu.id) {
          return star;
        }
      }
      return null;
    };

    Dashboard.prototype.stars = function() {
      return App.DashboardStar.select(((function(_this) {
        return function(s) {
          return s.dashboard_id === _this.id;
        };
      })(this)));
    };

    Dashboard.prototype.isUnowned = function() {
      return !((this.user_id != null) && this.user());
    };

    Dashboard.prototype.user = function() {
      var user;
      if (this.user_id == null) {
        return null;
      }
      user = App.User.exists(this.user_id);
      if (user) {
        return user;
      }
      return null;
    };

    Dashboard.prototype.searchTokens = function() {
      var tokens;
      tokens = [];
      if (this.user() != null) {
        tokens = tokens.concat(this.user().searchTokens());
      }
      tokens.push(this.getName());
      return tokens.tokenize();
    };

    Dashboard.prototype.matchesQuery = function(queryTokens) {
      return App.Utils.matchesQuery(queryTokens, this.searchTokens());
    };

    Dashboard.prototype.tags = function() {
      return _(this.tag_ids).map(function(tag_id) {
        var t;
        t = App.Tag.exists(tag_id);
        if (t) {
          return t.name;
        } else {
          return null;
        }
      }).compact().value().unique();
    };

    Dashboard.prototype.sendTestEmail = function(emailAddress) {
      return $.post("/dashboards/" + this.id + "/send_test_email", {
        email_address: emailAddress
      }).fail(this.maybeShowError);
    };

    Dashboard.prototype.maybeShowError = function(xhr) {
      if (xhr.status === HttpCodes.permissionDenied) {
        return Spine.trigger('permission_denied');
      }
    };

    Dashboard.prototype.sharedDashboards = function() {
      var sd, sds;
      sds = (function() {
        var i, len, ref, results;
        ref = App.SharedDashboard.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          sd = ref[i];
          if (sd.dashboard_id === this.id) {
            results.push(sd);
          }
        }
        return results;
      }).call(this);
      return sds.sort(function(a, b) {
        return a.id - b.id;
      });
    };

    Dashboard.prototype.sharedDashboardFactories = function() {
      var sdf, sdfs;
      sdfs = (function() {
        var i, len, ref, results;
        ref = App.SharedDashboardFactory.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          sdf = ref[i];
          if (sdf.dashboard_id === this.id) {
            results.push(sdf);
          }
        }
        return results;
      }).call(this);
      return sdfs.sort(function(a, b) {
        return a.id - b.id;
      });
    };

    Dashboard.prototype.hasSharedDashboardFactories = function() {
      return this.sharedDashboardFactories().length > 0;
    };

    Dashboard.prototype.saveWidgetStubs = function(widgetStubs) {
      if (widgetStubs.length > 0) {
        return Spine.Ajax.queue((function(_this) {
          return function() {
            return jQuery.ajax({
              url: "/dashboards/" + _this.id + "/reposition_widgets",
              type: 'POST',
              data: JSON.stringify({
                'widgets': widgetStubs
              }),
              dataType: 'json',
              contentType: 'application/json'
            });
          };
        })(this));
      }
    };

    Dashboard.logWidgetMove = function(widgetStubs, resizedWidget, reason) {
      return setTimeout(function() {
        var i, len, logData, stub;
        logData = {};
        for (i = 0, len = widgetStubs.length; i < len; i++) {
          stub = widgetStubs[i];
          logData[stub.id] = stub.fluid_column + "," + stub.fluid_row + "," + stub.fluid_width + "," + stub.fluid_height;
        }
        logData['label'] = reason;
        logData['target_widget_id'] = resizedWidget != null ? resizedWidget.id : void 0;
        return AppRedesign.logToScalyr('reposition_widgets', logData);
      });
    };

    Dashboard.widgetStubsForLogging = function(widgetList) {
      return _.map(widgetList, function(w) {
        return w.getStub();
      });
    };

    Dashboard.prototype.numCols = function() {
      return new App.DashboardSizer(this).numCols();
    };

    Dashboard.prototype.columnWidth = function() {
      return new App.DashboardSizer(this).columnWidth();
    };

    Dashboard.prototype.rowHeight = function() {
      return new App.DashboardSizer(this).rowHeight();
    };

    Dashboard.prototype.enableTvMode = function() {
      return this.updateColumns(new App.DashboardSizer(this).numColsForTVMode());
    };

    Dashboard.prototype.disableTvMode = function() {
      return this.updateColumns(new App.DashboardSizer(this).minCols());
    };

    Dashboard.prototype.tvModeEnabled = function() {
      return this.numCols() === new App.DashboardSizer(this).numColsForTVMode();
    };

    Dashboard.prototype.updateColumns = function(cols) {
      var dashboardSizer;
      dashboardSizer = new App.DashboardSizer(this);
      this.num_columns = Math.min(Math.max(cols, dashboardSizer.minCols()), dashboardSizer.maxCols());
      this.save();
      return this.trigger('dash-width-updated');
    };

    Dashboard.prototype.refreshPriorityName = function() {
      if (this.high_priority) {
        return 'High';
      }
      return 'Normal';
    };

    Dashboard.allDashboardsVisibleToCurrentUser = function(dashboards) {
      var dgp, everyoneGroup, i, len, membershipIdMap, ref, user, userDashboardGroups;
      user = App.User.currentUser();
      if (user == null) {
        return [];
      }
      if (user.isAdmin()) {
        return dashboards;
      }
      membershipIdMap = App.GroupMembership.userToGroupsMap()[user.id];
      userDashboardGroups = {};
      everyoneGroup = App.Group.findByName(App.Group.ALL_USERS);
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        dgp = ref[i];
        if ((everyoneGroup.id === dgp.group_id || membershipIdMap[dgp.group_id]) && (dgp.deleted_at == null)) {
          userDashboardGroups[dgp.dashboard_id] = true;
        }
      }
      dashboards = dashboards.filter(function(d) {
        return userDashboardGroups[d.id] || (d.user_id === user.id);
      });
      return dashboards;
    };

    Dashboard.allSortedByName = function(filterQuery) {
      var allDashboards;
      if (filterQuery == null) {
        filterQuery = null;
      }
      if ((filterQuery != null) && filterQuery.trim() !== "") {
        allDashboards = this.dashboardsFromQuery(filterQuery);
      } else {
        allDashboards = this.all();
      }
      return allDashboards.sort(function(a, b) {
        return App.Utils.sortAlphanumericComparator(a.name || 'Untitled', b.name || 'Untitled');
      });
    };

    Dashboard.dashboardsFromQuery = function(filterQuery) {
      var blankTagDoesMatch, currentUserId, matchedDashboards, mineTag, queryTokens, rawTagNames, tagIdGroups, tagSearchTerms, tagSearchTermsWithoutSpecial, tags, tokenizedQuery;
      queryTokens = filterQuery.split(' ');
      rawTagNames = queryTokens.filter(function(t) {
        return t[0] === '#';
      });
      queryTokens = queryTokens.withoutAny(rawTagNames);
      tagSearchTerms = rawTagNames.map(function(t) {
        return t.substring(1).toLowerCase();
      });
      tagSearchTermsWithoutSpecial = tagSearchTerms.filter(function(term) {
        return !App.Tag.RESERVED_TAG_NAMES.includes(term);
      });
      tags = App.Tag.tagsFromSearchTerms(tagSearchTermsWithoutSpecial);
      if (App.Tag.invalidTag(tags, tagSearchTermsWithoutSpecial)) {
        return [];
      }
      tagIdGroups = App.Tag.tagIdsFromSearchTerms(tagSearchTermsWithoutSpecial);
      currentUserId = App.User.currentUser().id;
      blankTagDoesMatch = tagSearchTerms.includes('');
      mineTag = tagSearchTerms.includes(App.Tag.MINE_TAG_SPECIAL);
      tokenizedQuery = queryTokens.tokenize();
      matchedDashboards = this.select(function(dashboard) {
        return dashboard.dashboardMatchesQuery(tokenizedQuery, tagIdGroups, currentUserId, blankTagDoesMatch, mineTag);
      });
      return matchedDashboards;
    };

    Dashboard.prototype.dashboardMatchesQuery = function(queryTokens, tagIdGroups, currentUserId, blankTagDoesMatch, mineTag) {
      var groupMatch, i, j, len, len1, tagId, tagIdGroup, tagMatch;
      if (mineTag && this.user_id !== currentUserId) {
        return false;
      }
      if (!this.matchesQuery(queryTokens)) {
        return false;
      }
      tagMatch = true;
      for (i = 0, len = tagIdGroups.length; i < len; i++) {
        tagIdGroup = tagIdGroups[i];
        groupMatch = false;
        for (j = 0, len1 = tagIdGroup.length; j < len1; j++) {
          tagId = tagIdGroup[j];
          if ((this.tag_ids || []).includes(tagId)) {
            groupMatch = true;
            break;
          }
        }
        if (groupMatch === false) {
          return false;
        }
      }
      if (blankTagDoesMatch) {
        return this.tag_ids.length > 0;
      }
      return this.matchesQuery(queryTokens) && (!mineTag || this.user_id === currentUserId);
    };

    Dashboard.prototype.cleanTags = function() {
      return this.tag_ids = _.map(this.tag_ids, function(tagId) {
        return String(tagId);
      });
    };

    Dashboard.allSortedByNameNotNull = function() {
      var allDashboards;
      allDashboards = this.allSortedByName();
      return allDashboards.filter(function(dashboard) {
        return dashboard.name != null;
      });
    };

    Dashboard.allByCategories = function(filterQuery) {
      var categorizedDashboards, dashboardsByCategory, i, len, ref, tag;
      dashboardsByCategory = App.Dashboard.dashboardsByCategory(filterQuery);
      categorizedDashboards = [];
      this.categoryFormat(categorizedDashboards, 'recent', 'recent', dashboardsByCategory);
      this.categoryFormat(categorizedDashboards, 'starred', 'starred', dashboardsByCategory);
      ref = App.Tag.allSortedByName();
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        this.categoryFormat(categorizedDashboards, tag.name, tag.id, dashboardsByCategory);
      }
      this.categoryFormat(categorizedDashboards, 'untagged', 'untagged', dashboardsByCategory);
      return categorizedDashboards;
    };

    Dashboard.categoryFormat = function(categorizedDashboards, categoryName, categoryKey, categoryDashboards) {
      if ((categoryDashboards[categoryKey] == null) || categoryDashboards[categoryKey].isEmpty()) {
        return;
      }
      return categorizedDashboards.push({
        name: categoryName,
        items: categoryDashboards[categoryKey]
      });
    };

    Dashboard.allStarredByCurrentUser = function() {
      return this.select(function(d) {
        return d.isStarredByCurrentUser();
      });
    };

    Dashboard.prototype.getDashboardRefreshData = function() {
      var ref, refreshData;
      refreshData = {
        ownedBy: (ref = this.user()) != null ? ref.abbreviatedDisplayName() : void 0,
        lastRefreshed: this.getLastRefreshed(),
        isFailingQualityCheck: this.isFailingQualityCheck(),
        description: this.description
      };
      return refreshData;
    };

    Dashboard.prototype.getTotalQueryTime = function() {
      var i, len, ref, runtime, sum, widget;
      sum = 0;
      ref = this.widgetsRequiresQuery();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        runtime = widget.getQueryDuration();
        if ((runtime == null) || isNaN(runtime)) {
          continue;
        }
        if (runtime) {
          sum += runtime;
        }
      }
      return Math.round(sum);
    };

    Dashboard.prototype.getLastRefreshed = function() {
      var currLastRefresh, i, len, msSinceLastRefresh, oldestLastRefresh, ref, ref1, widget;
      oldestLastRefresh = Number.MAX_SAFE_INTEGER;
      ref = this.widgetsRequiresQuery();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        currLastRefresh = (ref1 = widget.selectedFormulaSource()) != null ? ref1.last_refresh : void 0;
        if ((currLastRefresh != null) && (widget.getError() == null) && currLastRefresh < oldestLastRefresh) {
          oldestLastRefresh = currLastRefresh;
        }
      }
      msSinceLastRefresh = new Date().getTime() - oldestLastRefresh * 1000;
      if (this.widgetsRequiresQuery().isEmpty() || oldestLastRefresh === Number.MAX_SAFE_INTEGER) {
        return "N/A";
      }
      return App.Utils.roundedAgo(msSinceLastRefresh) + " ago";
    };

    Dashboard.prototype.isFailingQualityCheck = function() {
      var sqlAlert;
      if (this.sql_alert_id == null) {
        return false;
      }
      if (!App.SqlAlert.exists(this.sql_alert_id)) {
        return false;
      }
      sqlAlert = App.SqlAlert.find(this.sql_alert_id);
      return sqlAlert.last_check_failed;
    };

    Dashboard.prototype.getOldestWidgetLastRefreshMs = function() {
      var i, lastRefreshMs, lastRefreshSec, len, oldestLastRefreshMs, ref, ref1, widget;
      oldestLastRefreshMs = null;
      ref = this.widgetsRequiresQuery();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        lastRefreshSec = (ref1 = widget.selectedFormulaSource()) != null ? ref1.last_refresh : void 0;
        if (lastRefreshSec != null) {
          lastRefreshMs = lastRefreshSec * 1000;
        }
        if (!((lastRefreshMs != null) && (widget.getError() == null))) {
          continue;
        }
        if (lastRefreshMs < oldestLastRefreshMs || oldestLastRefreshMs === null) {
          oldestLastRefreshMs = lastRefreshMs;
        }
      }
      return oldestLastRefreshMs;
    };

    Dashboard.prototype.hasNonrefreshedWidgets = function() {
      var i, len, ref, ref1, widget;
      ref = this.widgetsRequiresQuery();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (!((ref1 = widget.selectedFormulaSource()) != null ? ref1.last_refresh : void 0)) {
          return true;
        }
      }
      return false;
    };

    Dashboard.prototype.userRefreshDisabled = function() {
      var refreshDisableMS, refreshDisableStrategy;
      if (this.isArchived()) {
        return true;
      }
      if (!App.Site.first().isDashboardRefreshV2Enabled()) {
        return false;
      }
      refreshDisableStrategy = this.userRefreshDisabledStrategy();
      refreshDisableMS = this.userRefreshDisableMS();
      if (!refreshDisableStrategy) {
        return false;
      }
      if (refreshDisableStrategy === App.Dashboard.REFRESH_STRATEGY_NEVER_SKIP) {
        return false;
      }
      if (refreshDisableStrategy === App.Dashboard.REFRESH_STRATEGY_ALWAYS_SKIP) {
        return true;
      }
      if (refreshDisableMS) {
        return this.getOldestWidgetLastRefreshMs() + refreshDisableMS > Date.now();
      }
      return false;
    };

    Dashboard.prototype.userRefreshDisabledStrategy = function() {
      if (this.user_refresh_disabling_strategy === App.Dashboard.REFRESH_STRATEGY_DEFAULT) {
        return App.Site.first().dashboard_user_refresh_disabling_strategy;
      }
      return this.user_refresh_disabling_strategy;
    };

    Dashboard.prototype.userRefreshDisableMS = function() {
      var refreshDisableSeconds;
      refreshDisableSeconds = this.user_refresh_disabled_when_fresher_than_seconds;
      if (this.user_refresh_disabling_strategy === App.Dashboard.REFRESH_STRATEGY_DEFAULT) {
        refreshDisableSeconds = App.Site.first().dashboard_user_refresh_disabled_when_fresher_than_seconds;
      }
      if (refreshDisableSeconds && this.userRefreshDisabledStrategy() === App.Dashboard.REFRESH_STRATEGY_FRESHNESS) {
        return refreshDisableSeconds * 1000;
      }
      return null;
    };

    Dashboard.dashboardInfos = function(dashboardToGroupsMap, dashboardToUserMap) {
      var dashboard, i, infos, len, ref;
      infos = [];
      ref = App.Dashboard.all();
      for (i = 0, len = ref.length; i < len; i++) {
        dashboard = ref[i];
        infos.push(dashboard.dashboardInfo(dashboardToGroupsMap, dashboardToUserMap));
      }
      return infos;
    };

    Dashboard.prototype.dashboardInfo = function(dashboardToGroupsMap, dashboardToUserMap) {
      var groups, info, owner, user, users;
      owner = App.RedesignPermissionsController.BLANK_FIELD_FORMAT;
      try {
        user = App.User.find(this.user_id);
        owner = user.abbreviatedDisplayName();
      } catch (error) {

      }
      groups = dashboardToGroupsMap[this.id] != null ? Object.keys(dashboardToGroupsMap[this.id]).length : 0;
      users = dashboardToUserMap[this.id] != null ? Object.keys(dashboardToUserMap[this.id]).length : 0;
      info = {
        name: this.getName(),
        owner: owner,
        groups: groups,
        users: users,
        shares: this.num_shared_dashboards || 0,
        create_time: this.create_time,
        last_7_day_usage_hours: this.last_7_day_usage_hours || 0
      };
      info[App.RedesignSimpleGridController.OBJECT_FIELD] = this;
      return info;
    };

    Dashboard.prototype.users = function(dashboardToUsersMap, userToGroups, dashboardToGroupsMap, allUsers) {
      var _, ref, userId, userInfo, users;
      users = [];
      if (!dashboardToUsersMap[this.id]) {
        return users;
      }
      ref = dashboardToUsersMap[this.id];
      for (userId in ref) {
        _ = ref[userId];
        userInfo = this.userInfo(userId, userToGroups, dashboardToGroupsMap, allUsers);
        if (userInfo) {
          users.push(userInfo);
        }
      }
      return users;
    };

    Dashboard.prototype.userInfo = function(userId, userToGroups, dashboardToGroupsMap, allUsers) {
      var edit, groupId, groupProperties, groups, ref, user, userInfo, view;
      if (!userToGroups[userId]) {
        return null;
      }
      if (!dashboardToGroupsMap[this.id]) {
        return null;
      }
      groups = [];
      edit = false;
      view = false;
      ref = dashboardToGroupsMap[this.id];
      for (groupId in ref) {
        groupProperties = ref[groupId];
        if (userToGroups[userId][groupId]) {
          view = true;
          groups.push(groupProperties['name']);
          if (groupProperties['edit']) {
            edit = true;
          }
        }
      }
      if (this.user_id === parseInt(userId)) {
        view = true;
        edit = true;
        groups.push(App.Group.OWNER);
      }
      if (!view) {
        return null;
      }
      try {
        user = allUsers.find(function(user) {
          return user.id === parseInt(userId);
        });
        userInfo = {
          access: edit ? 'Edit' : 'View',
          name: user.abbreviatedDisplayName(),
          group_names: groups
        };
        userInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = user;
        return userInfo;
      } catch (error) {

      }
      return null;
    };

    Dashboard.prototype.groups = function(dashboardToGroupsMap) {
      var groupId, groupInfo, groups, i, len, ref;
      groups = [];
      if (dashboardToGroupsMap[this.id] == null) {
        return groups;
      }
      ref = Object.keys(dashboardToGroupsMap[this.id]);
      for (i = 0, len = ref.length; i < len; i++) {
        groupId = ref[i];
        groupInfo = this.group(groupId, dashboardToGroupsMap);
        if (groupInfo) {
          groups.push(groupInfo);
        }
      }
      return groups;
    };

    Dashboard.prototype.group = function(groupId, dashboardToGroupsMap) {
      var group, groupInfo;
      try {
        group = App.Group.find(groupId);
        groupInfo = {
          name: group.name,
          can_edit: dashboardToGroupsMap[this.id][groupId]['edit'],
          can_view: true,
          disabled: group.admin,
          is_site_family_group: group.site_family_id != null
        };
        groupInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = group;
        return groupInfo;
      } catch (error) {

      }
      return null;
    };

    Dashboard.prototype.groupDashboardPermission = function(groupId) {
      var i, len, permission, ref;
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        if (permission.dashboard_id === this.id && permission.group_id === groupId) {
          return permission;
        }
      }
      return null;
    };

    Dashboard.prototype.editableUserIds = function(groupToUsersMap, dashboardToGroupsMap) {
      var groupId, properties, ref, userIdMap;
      userIdMap = {};
      ref = dashboardToGroupsMap[this.id];
      for (groupId in ref) {
        properties = ref[groupId];
        if (properties['edit'] && groupToUsersMap[groupId]) {
          userIdMap = $.extend(userIdMap, groupToUsersMap[groupId]);
        }
      }
      userIdMap[this.user_id] = true;
      return Object.keys(userIdMap);
    };

    Dashboard.prototype.editableUserIdOptions = function(groupToUsersMap, dashboardToGroupsMap) {
      var i, id, ids, len, options, user;
      ids = this.editableUserIds(groupToUsersMap, dashboardToGroupsMap);
      options = [];
      for (i = 0, len = ids.length; i < len; i++) {
        id = ids[i];
        try {
          user = App.User.find(id);
          options.push({
            value: user.id,
            name: user.displayName()
          });
        } catch (error) {

        }
      }
      return options;
    };

    Dashboard.prototype.filtersEnabled = function() {
      if (this.isArchived()) {
        return false;
      }
      return this.filters_enabled === true;
    };

    Dashboard.prototype.shouldFetchFilterValues = function() {
      if (this.isArchived()) {
        return false;
      }
      return this.filtersEnabled() && !AppRedesign.current().shared_mode;
    };

    Dashboard.prototype.numEmailReports = function() {
      if ((this.recurring_report_recipients || "").trim() === "") {
        return 0;
      }
      return this.recurring_report_recipients.split(',').length;
    };

    Dashboard.prototype.getOwnerId = function() {
      return this.user_id;
    };

    Dashboard.prototype.setOwnerId = function(id) {
      return this.user_id = id;
    };

    Dashboard.prototype.unarchive = function() {
      return jQuery.ajax({
        url: "/dashboards/" + this.id + "/unarchive",
        type: 'post'
      }).done((function(_this) {
        return function(res) {
          return AppRedesign.current().spinalCord.applyAllUnarchivedUpdates(res);
        };
      })(this)).always((function(_this) {
        return function() {
          var dashboard;
          dashboard = App.Dashboard.exists(_this.id);
          if (!dashboard) {
            return;
          }
          App.RouteHelper.navigateTo('Dashboard', dashboard, {
            replace: true
          });
          App.SearchableArchive.deleteRecord(dashboard.id, 'Dashboard');
          return dashboard.refreshAllWidgets();
        };
      })(this));
    };

    Dashboard.prototype.permaDeleteArchive = function() {
      return jQuery.ajax({
        url: "/dashboards/" + this.id + "/delete_archive",
        type: 'post'
      }).always((function(_this) {
        return function() {
          App.SearchableArchive.deleteRecord(_this.id, 'Dashboard');
          return _this.makeNextDashboardCurrent();
        };
      })(this));
    };

    Dashboard.prototype.applyPermissions = function(permissions) {
      this.permissions = permissions;
      return this.save({
        ajax: false
      });
    };

    return Dashboard;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  App.DashboardFilters = (function() {
    function DashboardFilters(custom_dimensions_list, aggregation, date_range_dimension) {
      this.custom_dimensions_list = custom_dimensions_list;
      this.aggregation = aggregation;
      this.date_range_dimension = date_range_dimension;
    }

    DashboardFilters.prototype.filtersHash = function() {
      return {
        date_range_dimension: this.date_range_dimension,
        custom_dimensions_list: this.custom_dimensions_list,
        aggregation: this.aggregation
      };
    };

    return DashboardFilters;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardGroupPermission = (function(superClass) {
    extend(DashboardGroupPermission, superClass);

    function DashboardGroupPermission() {
      return DashboardGroupPermission.__super__.constructor.apply(this, arguments);
    }

    DashboardGroupPermission.configure('DashboardGroupPermission', 'client_site_id', 'id', 'dashboard_id', 'group_id', 'sync_version', 'can_edit');

    DashboardGroupPermission.extend(Spine.Model.Ajax);

    DashboardGroupPermission.permissionMap = function() {
      var i, len, map, name, permission, ref;
      map = {};
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        map[name = permission.dashboard_id] || (map[name] = {});
        map[permission.dashboard_id][permission.group_id] = {
          edit: permission.can_edit,
          view: true
        };
      }
      return map;
    };

    DashboardGroupPermission.dashboardToGroupsMap = function() {
      var adminGroup, dashboard, group, i, j, len, len1, map, name, name1, permission, ref, ref1;
      map = {};
      adminGroup = App.Group.adminGroup();
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        map[name = permission.dashboard_id] || (map[name] = {});
        try {
          group = App.Group.find(permission.group_id);
          map[permission.dashboard_id][permission.group_id] = {
            view: true,
            edit: permission.can_edit,
            name: group.name
          };
        } catch (error) {

        }
      }
      if (adminGroup != null ? adminGroup.id : void 0) {
        ref1 = App.Dashboard.all();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          dashboard = ref1[j];
          map[name1 = dashboard.id] || (map[name1] = {});
          map[dashboard.id][adminGroup.id] = {
            view: true,
            edit: true,
            name: App.Group.ADMINS
          };
        }
      }
      return map;
    };

    DashboardGroupPermission.groupToPermissionMap = function() {
      var adminGroup, base, base1, dashboard, i, j, len, len1, map, name, name1, name2, name3, permission, ref, ref1;
      map = {};
      adminGroup = App.Group.adminGroup();
      ref = App.DashboardGroupPermission.all();
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        map[name = permission.group_id] || (map[name] = {});
        (base = map[permission.group_id])[name1 = permission.dashboard_id] || (base[name1] = {
          view: true,
          edit: permission.group_id === (adminGroup != null ? adminGroup.id : void 0) || permission.can_edit
        });
      }
      if (adminGroup != null ? adminGroup.id : void 0) {
        ref1 = App.Dashboard.all();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          dashboard = ref1[j];
          map[name2 = adminGroup.id] || (map[name2] = {});
          (base1 = map[adminGroup.id])[name3 = dashboard.id] || (base1[name3] = {
            view: true,
            edit: true
          });
        }
      }
      return map;
    };

    DashboardGroupPermission.dashboardToUsersMap = function(dashboardToGroupsMap, membershipMap) {
      var _, dashboardId, map;
      map = {};
      for (dashboardId in dashboardToGroupsMap) {
        _ = dashboardToGroupsMap[dashboardId];
        App.DashboardGroupPermission.updateDashboardToUsersMap(map, dashboardId, dashboardToGroupsMap, membershipMap);
      }
      return map;
    };

    DashboardGroupPermission.updateDashboardToUsersMap = function(map, dashboardId, dashboardToGroupsMap, membershipMap) {
      var _, dashboard, dashboardToUsersTempHash, groupId, groups, ref, results, userId;
      groups = dashboardToGroupsMap[dashboardId];
      dashboardToUsersTempHash = {};
      results = [];
      for (groupId in groups) {
        _ = groups[groupId];
        if (membershipMap[groupId]) {
          ref = membershipMap[groupId];
          for (userId in ref) {
            _ = ref[userId];
            dashboardToUsersTempHash[userId] = true;
          }
        }
        map[dashboardId] = $.extend(dashboardToUsersTempHash, {});
        try {
          dashboard = App.Dashboard.find(dashboardId);
          results.push(map[dashboardId][dashboard.user_id] = true);
        } catch (error) {

        }
      }
      return results;
    };

    return DashboardGroupPermission;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardStar = (function(superClass) {
    extend(DashboardStar, superClass);

    function DashboardStar() {
      return DashboardStar.__super__.constructor.apply(this, arguments);
    }

    DashboardStar.configure('DashboardStar', 'client_site_id', 'user_id', 'dashboard_id', 'last_update');

    DashboardStar.extend(Spine.Model.Ajax);

    DashboardStar.prototype.dashboard = function() {
      return App.Dashboard.exists(this.dashboard_id);
    };

    DashboardStar.prototype.user = function() {
      return App.User.find(this.user_id);
    };

    DashboardStar.prototype.create = function() {
      var db;
      DashboardStar.__super__.create.apply(this, arguments);
      db = this.dashboard();
      if (db) {
        return db.trigger('starred');
      }
    };

    DashboardStar.prototype.destroy = function() {
      var db;
      DashboardStar.__super__.destroy.apply(this, arguments);
      db = this.dashboard();
      if (db) {
        return db.trigger('unstarred');
      }
    };

    return DashboardStar;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.Database = (function(superClass) {
    extend(Database, superClass);

    function Database() {
      return Database.__super__.constructor.apply(this, arguments);
    }

    Database.configure('Database', 'client_site_id', 'id', 'cache', 'schema', 'real_database_name', 'database_name', 'database_user', 'database_host', 'database_port', 'database_type', 'cache_enabled', 'schema_updated_at', 'last_ping_successful_at', 'row_counts_updated_at', 'row_counts', 'schema_is_updating', 'row_counts_are_updating', 'autocomplete_list', 'num_widgets', 'num_sql_views', 'disable_updates', 'ssh_tunnel_id', 'redshift_id', 'parent_database_id', 'has_child', 'warehouse_name', 'client_id', 'specific_database_id', 'example', 'doctor_setup_successful', 'warehouse', 'command_type', 'cloud_provider', 'cluster_name', 'metadata_db', 's3_staging_dir', 'row_count_disabled', 'schema_is_stale', 'is_restricted', 'cacheable_admin_username', 'database_role_mapping_ids');

    Database.extend(Spine.Model.Ajax);

    Database.ALLOW_NO_INDEX_ROWS_THRESHOLD = 5 * 1e5;

    Database.ALL_DATABASES_CACHE_KEY = -1000;

    Database.TABLE_MAP_LOWER_CACHE_KEY = 'TablesMapLower';

    Database.CACHEABLE_DB_TYPES = ['postgres', 'redshift', 'mysql', 'sql_server', 'oracle', 'SalesforceDatabase', 'databricks'];

    Database.cacheDatabase = function() {
      return App.Database.all().find((function(_this) {
        return function(d) {
          return d.cache;
        };
      })(this)) || null;
    };

    Database.prototype.tableHarvests = function() {
      var i, len, ref, results, th;
      if (this.isSalesforceDatabase()) {
        return this.salesforceObjectHarvests();
      }
      ref = App.TableHarvest.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        th = ref[i];
        if (th.database_id === this.id) {
          results.push(th);
        }
      }
      return results;
    };

    Database.prototype.salesforceObjectHarvests = function() {
      var i, len, ref, results, salesforceObjectHarvest;
      ref = App.SalesforceObjectHarvest.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        salesforceObjectHarvest = ref[i];
        if (salesforceObjectHarvest.database_id === this.id) {
          results.push(salesforceObjectHarvest);
        }
      }
      return results;
    };

    Database.prototype.tableHarvestsAsMapByName = function() {
      var h, i, len, ref, t;
      h = {};
      ref = this.tableHarvests();
      for (i = 0, len = ref.length; i < len; i++) {
        t = ref[i];
        h[t.fullName()] = t;
      }
      return h;
    };

    Database.prototype.findTableHarvestByFullName = function(fullName) {
      return App.TableHarvest.findByFullName(this.id, fullName);
    };

    Database.prototype.canCacheToSnowflake = function() {
      return App.Site.first().has_snowflake_cache && this.cacheable();
    };

    Database.prototype.canCache = function() {
      return this.cache_enabled || this.canCacheToSnowflake();
    };

    Database.prototype.info = function() {
      return {
        name: this.database_name,
        type: this.prettyType()
      };
    };

    Database.prototype.prettyType = function() {
      switch (this.database_type) {
        case 'postgres':
          return 'PostgreSQL';
        case 'mysql':
          return 'MySQL';
        case 'redshift':
          return 'Amazon Redshift';
        case 'sql_server':
          return 'SQL Server';
        case 'bigquery_standard':
          return 'BigQuery Standard';
        case 'bigquery':
          return 'BigQuery';
        default:
          return this.database_type.charAt(0).toUpperCase() + this.database_type.substring(1);
      }
    };

    Database.prototype.tables = function() {
      var cached;
      cached = App.Database.cachedTables(this);
      if (cached != null) {
        return cached;
      }
      return App.Database.cacheTables(this, this.calculateTables());
    };

    Database.prototype.tablesAndViews = function() {
      var cached;
      cached = App.Database.cachedTablesAndViews(this);
      if (cached != null) {
        return cached;
      }
      return App.Database.cacheTablesAndViews(this, this.calculateTablesAndViews());
    };

    Database.prototype.calculateTables = function() {
      var c, cols, i, j, k, len, len1, len2, name, ref, ref1, ref2, ref3, tables, tablesV2, tbls;
      tables = {};
      if (this.schema != null) {
        tables = this.schema.tables;
      }
      if (this.schema_is_stale) {
        this.getNewSchema();
      }
      if (((ref = this.schema) != null ? ref.version : void 0) === 2) {
        tablesV2 = {};
        ref1 = tables.tables;
        for (i = 0, len = ref1.length; i < len; i++) {
          tbls = ref1[i];
          cols = {};
          ref2 = tbls[1];
          for (j = 0, len1 = ref2.length; j < len1; j++) {
            c = ref2[j];
            cols[tables.col_index[c][0]] = tables.col_index[c][1];
          }
          ref3 = tbls[0];
          for (k = 0, len2 = ref3.length; k < len2; k++) {
            name = ref3[k];
            tablesV2[name] = {
              name: name,
              columns: cols
            };
          }
        }
        return tablesV2;
      } else {
        return jQuery.extend({}, tables);
      }
    };

    Database.prototype.calculateTablesAndViews = function() {
      return jQuery.extend({}, App.SqlView.allAsSchema(), App.CsvView.allAsSchema(), this.calculateTables());
    };

    Database.any = function() {
      return this.count() > 0;
    };

    Database.cacheTables = function(database, tables) {
      return this.setCacheValue(database, 'Tables', tables);
    };

    Database.cachedTables = function(database) {
      return this.getCacheValue(database, 'Tables');
    };

    Database.cacheTablesAndViews = function(database, tables) {
      return this.setCacheValue(database, 'TablesAndViews', tables);
    };

    Database.cachedTablesAndViews = function(database) {
      return this.getCacheValue(database, 'TablesAndViews');
    };

    Database.clearTableCache = function() {
      return this.tableCache = {};
    };

    Database.getCacheValue = function(database, group) {
      var ref, ref1;
      if (database.schema_is_stale) {
        database.getNewSchema();
      }
      return (ref = this.tableCache) != null ? (ref1 = ref[database.id]) != null ? ref1[group] : void 0 : void 0;
    };

    Database.setCacheValue = function(database, group, data) {
      var base, base1, name1;
      if (this.tableCache == null) {
        this.tableCache = {};
      }
      if ((base = this.tableCache)[name1 = database.id] == null) {
        base[name1] = {};
      }
      if ((base1 = this.tableCache[database.id])[group] == null) {
        base1[group] = {};
      }
      this.tableCache[database.id][group] = data;
      return data;
    };

    Database.prototype.markSchemaUpdateRequested = function() {
      this.schema_is_updating = true;
      this.save({
        ajax: false
      });
      return App.Database.setSchemaUpdateCacheValue(this);
    };

    Database.prototype.clearSchemaUpdateRequested = function() {
      this.schema_is_updating = false;
      this.save({
        ajax: false
      });
      if (App.Database.schemaUpdateCache == null) {
        return;
      }
      return delete App.Database.schemaUpdateCache[this.id];
    };

    Database.prototype.isSchemaUpdateRequested = function() {
      if (this.schema_is_updating) {
        return true;
      }
      if (App.Database.schemaUpdateCache == null) {
        return false;
      }
      if (App.Database.schemaUpdateCache[this.id] == null) {
        return false;
      }
      return App.Database.schemaUpdateCache[this.id];
    };

    Database.setSchemaUpdateCacheValue = function(database) {
      if (this.schemaUpdateCache == null) {
        this.schemaUpdateCache = {};
      }
      return this.schemaUpdateCache[database.id] = true;
    };

    Database.prototype.getTableNames = function(allow_views, includeHiddenTables) {
      var name, names, props, schema;
      if (allow_views == null) {
        allow_views = false;
      }
      if (includeHiddenTables == null) {
        includeHiddenTables = false;
      }
      names = [];
      schema = (allow_views ? this.tablesAndViews() : this.tables());
      for (name in schema) {
        props = schema[name];
        if (!includeHiddenTables && props.should_display === false) {
          continue;
        }
        names.push(name);
      }
      names = names.sortIgnoreCase();
      return names;
    };

    Database.prototype.getTableNamesWithImpliedSchemas = function(defaultSchema) {
      var baseNames;
      if (defaultSchema == null) {
        defaultSchema = 'public';
      }
      baseNames = this.getTableNames();
      return this.getImpliedSchemas(baseNames, defaultSchema);
    };

    Database.prototype.getImpliedSchemas = function(baseNames, defaultSchema) {
      var baseName, i, len, results;
      if (defaultSchema == null) {
        defaultSchema = 'public';
      }
      results = [];
      for (i = 0, len = baseNames.length; i < len; i++) {
        baseName = baseNames[i];
        results.push(this.getFullTableNameFromBaseNameAndSchema(baseName, defaultSchema));
      }
      return results;
    };

    Database.prototype.getFullTableNameFromBaseNameAndSchema = function(baseName, defaultSchema) {
      var ref, schemaName, tableName;
      if (defaultSchema == null) {
        defaultSchema = 'public';
      }
      schemaName = defaultSchema;
      tableName = baseName;
      if (baseName.indexOf('.') !== -1) {
        ref = baseName.split('.'), schemaName = ref[0], tableName = ref[1];
      }
      return schemaName + "." + tableName;
    };

    Database.prototype.getTableNamesIncludingHarvestedTables = function() {
      var allTables, baseNames, h;
      baseNames = this.getTableNames(false, true);
      allTables = this.getImpliedSchemas(baseNames);
      allTables = allTables.concat((function() {
        var i, len, ref, results;
        ref = this.tableHarvests();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          h = ref[i];
          results.push(h.fullName());
        }
        return results;
      }).call(this));
      allTables = allTables.unique();
      return allTables.sort();
    };

    Database.prototype.getTableNamesWithColumnInfo = function(tableName) {
      var c, columns, name, p, props, ref, tables;
      if (tableName == null) {
        tableName = null;
      }
      tables = [];
      ref = this.tables();
      for (name in ref) {
        props = ref[name];
        if ((tableName != null) && name !== tableName && ("public." + name) !== tableName) {
          continue;
        }
        columns = (function() {
          var ref1, results;
          ref1 = props.columns;
          results = [];
          for (c in ref1) {
            p = ref1[c];
            results.push({
              name: c,
              sql_type: p.sql_type
            });
          }
          return results;
        })();
        tables.push({
          name: name,
          columns: columns
        });
      }
      return tables.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    };

    Database.prototype.getAllTablesWithNameMatchingQuery = function(searchStr) {
      var fullName, i, len, queryTokens, ref, tables;
      tables = [];
      queryTokens = App.Utils.tokenizeString(searchStr);
      ref = this.getTableNamesWithImpliedSchemas();
      for (i = 0, len = ref.length; i < len; i++) {
        fullName = ref[i];
        if (App.Database.tableNameMatchesQuery(fullName, queryTokens)) {
          tables.push(App.Database.getTableSummary(fullName));
        }
      }
      return tables.sort(App.Database.tableSortComparator);
    };

    Database.prototype.getAllTablesWithColumnNameMatchingQuery = function(searchStr) {
      var columnName, columnProps, columnTokens, fullName, newColumnProps, newTableProps, queryTokens, ref, ref1, tableHasMatchingColumn, tableName, tableProps, tables;
      queryTokens = App.Utils.tokenizeString(searchStr);
      tables = [];
      ref = this.tables();
      for (tableName in ref) {
        tableProps = ref[tableName];
        if (tableProps.should_display === false) {
          continue;
        }
        fullName = this.getFullTableNameFromBaseNameAndSchema(tableName);
        newTableProps = App.Database.getTableSummary(fullName);
        newTableProps.columns = [];
        tableHasMatchingColumn = false;
        ref1 = tableProps.columns;
        for (columnName in ref1) {
          columnProps = ref1[columnName];
          newColumnProps = {
            name: columnName,
            sql_type: columnProps.sql_type
          };
          columnTokens = App.Utils.tokenizeString(columnName);
          if ((columnName.indexOf(searchStr) !== -1) || App.Utils.matchesQuery(queryTokens, columnTokens)) {
            newColumnProps.matches_query = true;
            tableHasMatchingColumn = true;
          }
          newTableProps.columns.push(newColumnProps);
        }
        if (tableHasMatchingColumn) {
          tables.push(newTableProps);
        }
      }
      return tables.sort(App.Database.tableSortComparator);
    };

    Database.tableSortComparator = function(tableA, tableB) {
      return tableA.sortName.localeCompare(tableB.sortName);
    };

    Database.getTableSummary = function(fullName) {
      var name, schema, sortName;
      schema = fullName.split('.').first();
      name = fullName.substring(schema.length + 1, fullName.length);
      sortName = fullName.toLocaleLowerCase();
      return {
        type: 'Table',
        name: name,
        fullName: fullName,
        schema: schema,
        sortName: sortName
      };
    };

    Database.prototype.getTableColumns = function(tableName, kind) {
      var columnName, columns, cv, key, props;
      if (kind == null) {
        kind = "all";
      }
      key = tableName + "-" + kind;
      cv = Database.getCacheValue(this, 'TableColumns' + key);
      if (cv != null) {
        return cv;
      }
      columns = [];
      if (this.tablesAndViews()[tableName] == null) {
        return columns;
      }
      if (kind === "all") {
        columns = (function() {
          var ref, results;
          ref = this.tablesAndViews()[tableName].columns;
          results = [];
          for (columnName in ref) {
            props = ref[columnName];
            results.push(columnName);
          }
          return results;
        }).call(this);
      } else if (kind === "datetimes") {
        columns = (function() {
          var ref, results;
          ref = this.tablesAndViews()[tableName].columns;
          results = [];
          for (columnName in ref) {
            props = ref[columnName];
            if (props.is_datetime || props.is_timestamp) {
              results.push(columnName);
            }
          }
          return results;
        }).call(this);
      } else if (kind === "nondatetimes") {
        columns = (function() {
          var ref, results;
          ref = this.tablesAndViews()[tableName].columns;
          results = [];
          for (columnName in ref) {
            props = ref[columnName];
            if (!props.is_datetime && !props.is_timestamp) {
              results.push(columnName);
            }
          }
          return results;
        }).call(this);
      } else if (kind === "numeric") {
        columns = (function() {
          var ref, results;
          ref = this.tablesAndViews()[tableName].columns;
          results = [];
          for (columnName in ref) {
            props = ref[columnName];
            if (props.is_numeric) {
              results.push(columnName);
            }
          }
          return results;
        }).call(this);
      }
      return Database.setCacheValue(this, 'TableColumns' + key, columns);
    };

    Database.prototype.getAutocompleteList = function(prevToken) {
      var bigramList, frequencyList, ref, ref1, ref2, ref3, tableAndColumnNames;
      bigramList = ((ref = this.autocomplete_list) != null ? (ref1 = ref.bigramList) != null ? ref1[prevToken.toLowerCase()] : void 0 : void 0) || [];
      frequencyList = ((ref2 = this.autocomplete_list) != null ? ref2.frequencyList : void 0) || [];
      tableAndColumnNames = ((ref3 = this.autocomplete_list) != null ? ref3.tableAndColumnNames : void 0) || [];
      return App.Utils.caseInsensitiveUniq(slice.call(bigramList).concat(slice.call(frequencyList), slice.call(tableAndColumnNames), slice.call(App.DatabaseSqlFunctions.getNames(this.database_type))));
    };

    Database.prototype.hasMultipleNonpublicSchemas = function() {
      return this.schemas().without('public').length > 1;
    };

    Database.prototype.hasMultipleSchemas = function() {
      return this.schemas(true).length > 1;
    };

    Database.prototype.schemas = function(addPublic) {
      var i, len, name, ref, schemas;
      if (addPublic == null) {
        addPublic = false;
      }
      schemas = [];
      ref = this.getTableNames();
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        if (name.indexOf('.') !== -1) {
          schemas.push(name.split('.').first());
        } else if (addPublic) {
          schemas.push("public");
        }
      }
      return schemas.unique();
    };

    Database.prototype.dbHighlightMode = function() {
      var mode, ref;
      mode = 'text/x-mysql';
      if ((ref = this.database_type) === 'redshift' || ref === 'postgres' || ref === 'vertica') {
        mode = 'text/x-plsql';
      }
      return mode;
    };

    Database.prototype.quote = function(v) {
      switch (this.database_type) {
        case "mysql":
          return "`" + v + "`";
        case "bigquery":
          return "[" + v + "]";
        default:
          return "\"" + v + "\"";
      }
    };

    Database.prototype.supportsGroupByAlias = function() {
      return this.database_type !== 'sql_server';
    };

    Database.tableNameMatchesQuery = function(tableName, queryTokens) {
      var tableTokens;
      tableTokens = App.Utils.tokenizeString(tableName);
      return App.Utils.matchesQuery(queryTokens, tableTokens);
    };

    Database.matchesMagicJoin = function(str) {
      var cacheDBKey, cacheVarName, cachedTablesMap, db, i, j, k, len, len1, len2, ref, table, tables, tokens, v;
      tokens = str.replace(/[\]\[]/g, '').toLocaleLowerCase().split(/[+<]/);
      if (tokens.length < 2) {
        return;
      }
      cacheDBKey = App.Database.ALL_DATABASES_CACHE_KEY;
      cacheVarName = App.Database.TABLE_MAP_LOWER_CACHE_KEY;
      cachedTablesMap = App.Database.getCacheValue(cacheDBKey, cacheVarName);
      if (cachedTablesMap == null) {
        tables = [];
        ref = App.Database.allWithReplicas();
        for (i = 0, len = ref.length; i < len; i++) {
          db = ref[i];
          tables = tables.concat(db.getTableNames(false));
        }
        tables = tables.concat((function() {
          var j, len1, ref1, results;
          ref1 = App.SqlView.all();
          results = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            v = ref1[j];
            results.push(v.name);
          }
          return results;
        })());
        tables = tables.concat((function() {
          var j, len1, ref1, results;
          ref1 = App.CsvView.all();
          results = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            v = ref1[j];
            results.push(v.name);
          }
          return results;
        })());
        cachedTablesMap = {};
        for (j = 0, len1 = tables.length; j < len1; j++) {
          table = tables[j];
          if (table != null) {
            cachedTablesMap[table.toLocaleLowerCase()] = true;
          }
        }
        App.Database.setCacheValue(cacheDBKey, cacheVarName, cachedTablesMap);
      }
      for (k = 0, len2 = tokens.length; k < len2; k++) {
        table = tokens[k];
        if (!cachedTablesMap[table]) {
          return false;
        }
      }
      return true;
    };

    Database.matchesSampleFactor = function(str) {
      if (!str) {
        return false;
      }
      return str.toLocaleLowerCase() === "[samplefactor]";
    };

    Database.sqlTypeToSimpleType = function(sqlType) {
      var sqlTypeLowerCase;
      sqlTypeLowerCase = sqlType != null ? sqlType.toLowerCase() : void 0;
      switch (sqlTypeLowerCase) {
        case '__int4':
        case '__int8':
        case 'int':
        case 'tinyint':
        case 'bigint':
        case 'int2':
        case 'int4':
        case 'int8':
        case 'smallint':
        case 'bigint':
        case 'mediumint':
        case 'serial':
        case 'number':
          return 'integer';
        case 'float':
        case 'float4':
        case 'float8':
        case 'double precision':
        case 'double':
        case 'numeric':
          return 'decimal';
        case 'date':
        case 'time':
        case 'datetime':
        case 'timestamp without time zone':
        case 'timestamp':
        case 'timestamp with time zone':
        case 'time with time zone':
        case 'timestamp(6)':
        case 'timestamp_tz':
        case 'timestamp_ntz':
        case 'timestamp_ltz':
        case 'timestampltz':
        case 'timestampntz':
        case 'timestamptz':
          return 'datetime';
        case 'varchar':
        case 'text':
        case 'char':
        case 'character varying':
        case 'smalltext':
        case 'nchar':
        case 'nvarchar':
          return 'string';
        case 'varbinary':
        case 'bytea':
          return 'binary';
        case 'USER-DEFINED':
          return 'user defined';
        case 'bool':
          return 'boolean';
        default:
          return sqlTypeLowerCase;
      }
    };

    Database.prototype.searchTokens = function() {
      var tokens;
      tokens = [this.database_name];
      return tokens.tokenize();
    };

    Database.prototype.matchesQuery = function(queryTokens) {
      return App.Utils.matchesQuery(queryTokens, this.searchTokens());
    };

    Database.allSortedByNameWithReplicas = function(filterQuery) {
      var allDbs, queryTokens;
      if (filterQuery == null) {
        filterQuery = null;
      }
      if ((filterQuery != null) && filterQuery.trim() !== "") {
        queryTokens = filterQuery.split(' ').tokenize();
        allDbs = this.select(function(u) {
          return u.matchesQuery(queryTokens);
        });
      } else {
        allDbs = this.allWithReplicas();
      }
      return allDbs.sort(function(a, b) {
        return App.Utils.sortAlphanumericComparator(a.database_name, b.database_name);
      });
    };

    Database.cacheableDatabases = function() {
      var ref;
      if ((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0) {
        return _.filter(this.configurableDatabases(), function(d) {
          return !d.is_restricted;
        });
      } else {
        return this.configurableDatabases();
      }
    };

    Database.configurableDatabases = function() {
      return _.filter(this.allSortedByNameWithReplicas(), function(d) {
        return d.isOwnedByCustomer();
      });
    };

    Database.dbsWithoutChildren = function(dbs) {
      return dbs.filter(function(db) {
        return db.parent_database_id == null;
      });
    };

    Database.all = function() {
      return this.dbsWithoutChildren(this.allWithReplicas());
    };

    Database.count = function() {
      return App.Database.all().length;
    };

    Database.allSortedByName = function(filterQuery) {
      if (filterQuery == null) {
        filterQuery = null;
      }
      return this.dbsWithoutChildren(this.allSortedByNameWithReplicas(filterQuery));
    };

    Database.allWithReplicas = function() {
      return this.cloneArray(this.recordsValues());
    };

    Database.countWithReplicas = function() {
      return this.recordsValues().length;
    };

    Database.prototype.schemaLastRefreshedAgo = function() {
      return App.Utils.roundedAgoFromDateString(this.schema_updated_at, "ago", "Never");
    };

    Database.prototype.pingLastSuccessfulAgo = function() {
      return App.Utils.roundedAgoFromDateString(this.last_ping_successful_at, "ago", "Never");
    };

    Database.prototype.rowCountsUpdatedAgo = function() {
      return App.Utils.roundedAgoFromDateString(this.row_counts_updated_at, "ago", "Never");
    };

    Database.prototype.totalRowCount = function() {
      var count, i, len, sum, t, tableNames;
      if (this.row_counts == null) {
        return null;
      }
      tableNames = this.getTableNames();
      sum = 0;
      for (i = 0, len = tableNames.length; i < len; i++) {
        t = tableNames[i];
        count = this.row_counts[t];
        if (count != null) {
          sum += count;
        }
      }
      return sum;
    };

    Database.prototype.numUncountedTables = function() {
      var count, i, len, t, tableNames;
      if (this.row_counts == null) {
        return null;
      }
      tableNames = this.getTableNames();
      count = 0;
      for (i = 0, len = tableNames.length; i < len; i++) {
        t = tableNames[i];
        if (this.row_counts[t] == null) {
          count += 1;
        }
      }
      return count;
    };

    Database.prototype.numTables = function() {
      return this.getTableNames().length;
    };

    Database.prototype.rowCountForTable = function(t) {
      if (!((this.row_counts != null) && (t != null) && (this.row_counts[t] != null))) {
        return null;
      }
      return this.row_counts[t];
    };

    Database.prototype.getNewRowCounts = function() {
      return jQuery.get("/databases/" + this.id + "/row_counts", {}, (function(_this) {
        return function(response) {
          if ((response != null ? response.row_counts : void 0) != null) {
            _this.row_counts = response.row_counts;
            return _this.save({
              ajax: false
            });
          }
        };
      })(this));
    };

    Database.prototype.getNewSchema = function() {
      this.schema_is_stale = false;
      this.save({
        ajax: false
      });
      return jQuery.get("/databases/" + this.id + "/schema", {}, (function(_this) {
        return function(response) {
          if ((response != null ? response.schema : void 0) != null) {
            App.Database.clearTableCache();
            _this.schema = response.schema;
            return _this.clearSchemaUpdateRequested();
          }
        };
      })(this));
    };

    Database.hasWarehouseWithNoConfigurableDatabases = function() {
      return _.isEmpty(this.configurableDatabases()) && _.some(App.Database.allWithReplicas(), function(database) {
        return database.warehouse;
      });
    };

    Database.onlyExampleDbConnected = function() {
      var db, i, len, ref;
      ref = App.Database.all();
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        if (db.example) {
          continue;
        }
        if (!db.doctor_setup_successful) {
          continue;
        }
        return false;
      }
      return true;
    };

    Database.prototype.isSalesforceDatabase = function() {
      return this.database_type === 'SalesforceDatabase';
    };

    Database.prototype.isRedshift = function() {
      return this.database_type === 'redshift';
    };

    Database.prototype.isSnowflake = function() {
      return this.database_type === 'snowflake';
    };

    Database.prototype.cacheable = function() {
      return _.includes(this.constructor.CACHEABLE_DB_TYPES, this.database_type);
    };

    Database.prototype.isOwnedByCustomer = function() {
      return Boolean(this.isOrigin() || App.Site.first().byow_enabled);
    };

    Database.prototype.isByowDatabase = function() {
      return Boolean(this.isByowEligible() && this.cache);
    };

    Database.prototype.isByowEligible = function() {
      return Boolean((this.isRedshift() || this.isSnowflake()) && App.Site.first().byow_enabled);
    };

    Database.prototype.isOrigin = function() {
      return !this.cache;
    };

    Database.prototype.warehouseSchemaEnabled = function() {
      return Boolean(App.Site.first().cached_site && this.cache);
    };

    Database.prototype.activeRestriction = function() {
      return Boolean(AppRedesign.restrictDatabasesEnabled() && this.is_restricted);
    };

    Database.prototype.wasDestroyed = function() {
      if (AppRedesign.restrictDatabasesEnabled() && this.is_restricted) {
        return false;
      } else {
        return Database.__super__.wasDestroyed.call(this);
      }
    };

    return Database;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DatabaseGroupPermission = (function(superClass) {
    extend(DatabaseGroupPermission, superClass);

    function DatabaseGroupPermission() {
      return DatabaseGroupPermission.__super__.constructor.apply(this, arguments);
    }

    DatabaseGroupPermission.configure('DatabaseGroupPermission', 'client_site_id', 'id', 'database_id', 'group_id', 'sync_version', 'can_query');

    DatabaseGroupPermission.extend(Spine.Model.Ajax);

    DatabaseGroupPermission.addQueryAccess = function(databaseId, groupId) {
      var groupPermission;
      groupPermission = this.findPermission(databaseId, groupId);
      if (groupPermission) {
        groupPermission.can_query = true;
        return groupPermission.save();
      } else {
        groupPermission = new App.DatabaseGroupPermission({
          database_id: databaseId,
          group_id: groupId,
          can_query: true
        });
        return groupPermission.save();
      }
    };

    DatabaseGroupPermission.revokeQueryAccess = function(databaseId, groupId) {
      var groupPermission;
      groupPermission = this.findPermission(databaseId, groupId);
      groupPermission.can_query = false;
      return groupPermission.save();
    };

    DatabaseGroupPermission.findPermission = function(databaseId, groupId) {
      return _.find(App.DatabaseGroupPermission.all(), function(permission) {
        return permission.database_id === databaseId && permission.group_id === groupId;
      });
    };

    DatabaseGroupPermission.editGroupsWithQueryPermissionStatus = function(database_id) {
      var databaseGroupPermission, databaseGroupPermissions, editGroupRoles, editGroups, group, groupPermissions, i, len, permission, ref;
      editGroupRoles = _.filter(App.GroupRole.all(), ['can_edit', true]);
      editGroups = _.map(editGroupRoles, function(groupRole) {
        return App.Group.find(groupRole.group_id);
      });
      databaseGroupPermissions = _.filter(App.DatabaseGroupPermission.all(), ['database_id', database_id]);
      groupPermissions = [];
      ref = _.sortBy(editGroups, ['name']);
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        databaseGroupPermission = _.find(databaseGroupPermissions, ['group_id', group.id]);
        permission = {
          is_admin: group.admin,
          group_id: group.id,
          database_id: database_id,
          display_name: group.name,
          can_query: group.admin || (databaseGroupPermission != null ? databaseGroupPermission.can_query : void 0)
        };
        groupPermissions.push(permission);
      }
      return groupPermissions;
    };

    return DatabaseGroupPermission;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Dataset = (function(superClass) {
    extend(Dataset, superClass);

    function Dataset() {
      return Dataset.__super__.constructor.apply(this, arguments);
    }

    Dataset.configure('Dataset', 'client_site_id', 'explorable_id', 'explorable_type');

    Dataset.extend(Spine.Model.Ajax);

    Dataset.prototype.name = function() {
      return this.explorable().name;
    };

    Dataset.prototype.explorable = function() {
      return this.explorable_instance || (this.explorable_instance = (function() {
        switch (this.explorable_type) {
          case 'SqlView':
            return App.SqlView.exists(this.explorable_id);
          case 'CsvView':
            return App.CsvView.exists(this.explorable_id);
        }
      }).call(this));
    };

    Dataset.prototype.databaseId = function() {
      return this.explorable().destinationDatabaseId();
    };

    Dataset.prototype.columns = function() {
      if (this.explorable() === false) {
        return [];
      }
      return this.explorable().previewColumns();
    };

    Dataset.columnsWithExampleData = function(callback, explorable) {
      var source, timeout, wrapperCallback;
      if (explorable.preview_source_hash_key === null) {
        callback(App.Dataset.columnsWithNullExampleData(explorable));
        return;
      }
      source = explorable.source();
      if (source) {
        return App.Dataset.loadedSource(callback, explorable);
      } else {
        timeout = setTimeout((function(_this) {
          return function() {
            explorable.unbind('source-updated', wrapperCallback);
            return callback(App.Dataset.columnsWithNullExampleData(explorable));
          };
        })(this), 5000);
        wrapperCallback = (function(_this) {
          return function(explorablePassedViaEvent) {
            clearTimeout(timeout);
            if (explorable.id !== explorablePassedViaEvent.id) {
              return;
            }
            explorable.unbind('source-updated', wrapperCallback);
            return App.Dataset.loadedSource(callback, explorable);
          };
        })(this);
        return explorable.bind('source-updated', wrapperCallback);
      }
    };

    Dataset.loadedSource = function(callback, explorable) {
      var columns, source;
      source = explorable.source();
      if (!((source.rows != null) && source.rows.length !== 0)) {
        callback(App.Dataset.columnsWithNullExampleData(explorable));
        return;
      }
      columns = explorable.previewColumns();
      App.Dataset.mergeRowDataFromSourceIntoColumnsAsExampleData(source, columns);
      return callback(columns);
    };

    Dataset.mergeRowDataFromSourceIntoColumnsAsExampleData = function(source, columns) {
      var column, columnIndex, columnLookup, columnName, exampleRow, i, j, k, l, len, len1, len2, len3, ref, ref1, results, row;
      columnLookup = {};
      for (i = 0, len = columns.length; i < len; i++) {
        column = columns[i];
        columnLookup[column.columnName] = column;
      }
      exampleRow = [];
      ref = source.rows;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        row = ref[j];
        for (columnIndex = k = 0, len2 = row.length; k < len2; columnIndex = ++k) {
          column = row[columnIndex];
          if (exampleRow[columnIndex]) {
            continue;
          }
          exampleRow[columnIndex] = column;
        }
        if (_.every(exampleRow)) {
          break;
        }
      }
      ref1 = source.columns;
      results = [];
      for (columnIndex = l = 0, len3 = ref1.length; l < len3; columnIndex = ++l) {
        columnName = ref1[columnIndex];
        column = columnLookup[columnName];
        if (column) {
          results.push(column.exampleData = exampleRow[columnIndex]);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Dataset.columnsWithNullExampleData = function(explorable) {
      var column, columns, i, len;
      columns = explorable.previewColumns();
      for (i = 0, len = columns.length; i < len; i++) {
        column = columns[i];
        column.exampleData = null;
      }
      return columns;
    };

    Dataset.simplifiedTypeFromDatabaseType = function(databaseType) {
      switch (databaseType.toLowerCase()) {
        case 'bigint':
        case 'int':
        case 'int4':
        case 'int8':
        case 'integer':
        case 'mediumint':
        case 'serial':
        case 'smallint':
        case 'tinyint':
        case 'byteint':
          return 'integer';
        case 'bool':
        case 'boolean':
          return 'boolean';
        case 'double precision':
        case 'float8':
        case 'float4':
        case 'numeric':
        case 'float':
        case 'decimal':
        case 'double':
        case 'real':
        case 'number':
          return 'number';
        case 'datetime':
        case 'timestamp':
        case 'timestamp with time zone':
        case 'timestamp without time zone':
        case 'timestamp(6)':
        case 'date':
        case 'time':
        case 'timestampltz':
        case 'timestamp_ltz':
        case 'timestamp_ntz':
        case 'timestamp_tz':
        case 'timestampntz':
        case 'smalldatetime':
        case 'datetime2':
        case 'datetimeoffset':
        case 'timestamptz':
          return 'datetime';
        case '_text':
        case 'char':
        case 'character varying':
        case 'text':
        case 'nchar':
        case 'nvarchar':
        case 'smalltext':
        case 'varchar':
        case 'varchar2':
          return 'string';
        default:
          return 'string';
      }
    };

    Dataset.prototype.recentViewedAt = function() {
      var recent_item;
      recent_item = _.find(App.RecentItem.all(), {
        item_id: this.id,
        item_type: 'Dataset'
      });
      return (recent_item != null ? recent_item.updated_at : void 0) || null;
    };

    Dataset.prototype.createRecentItem = function() {
      return App.RecentItem.createFromRecord(this);
    };

    Dataset.prototype.prettyStatus = function() {
      return this.explorable().getState();
    };

    Dataset.prototype.statusForIcon = function() {
      return this.explorable().statusForIcon();
    };

    Dataset.datasetId = function(explorable_id, explorable_type) {
      var ref;
      return (ref = App.Dataset.all().filter((function(_this) {
        return function(dataset) {
          return dataset.explorable_id === explorable_id && dataset.explorable_type === explorable_type;
        };
      })(this))[0]) != null ? ref.id : void 0;
    };

    return Dataset;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FileDownload = (function(superClass) {
    extend(FileDownload, superClass);

    function FileDownload() {
      this.fsUpdated = bind(this.fsUpdated, this);
      return FileDownload.__super__.constructor.apply(this, arguments);
    }

    FileDownload.configure('FileDownload', 'client_site_id', 'display_name', 'hash_key', 'user_id', 'query_completed_at', 'download_started_at', 'download_canceled_at', 'download_initialized_from', 'item_id', 'item_type', 'udv_id', 'query', 'database_id');

    FileDownload.extend(Spine.Model.Ajax);

    FileDownload.prototype.getStartedAt = function() {
      return this.download_started_at;
    };

    FileDownload.getNameFromItem = function(item, modified) {
      var suffix;
      if (modified == null) {
        modified = false;
      }
      suffix = modified ? 'modified' : '';
      return App.DownloadHelper.getDownloadTitle(item, new Date(), suffix, '.csv');
    };

    FileDownload.prototype.source = function() {
      return App.FormulaSource.findByHash(this.hash_key);
    };

    FileDownload.prototype.getDataDestination = function() {
      var source;
      if (_.isEmpty(this.hash_key)) {
        return;
      }
      source = this.source();
      if ((source != null) && (this.getError() == null) && this.queryCompleted()) {
        return source.data_destination;
      }
      if (this.getError() == null) {
        this.fetchSource();
      }
      return null;
    };

    FileDownload.prototype.queryCompleted = function() {
      return (this.source() != null) && this.source().query_duration > 0;
    };

    FileDownload.prototype.fsUpdated = function(fs) {
      if (fs.hash_key !== this.hash_key) {
        return;
      }
      delete this.awaitingSource;
      App.SourceFetcher.unbind('source-updated', this.fsUpdated);
      return this.trigger('source-updated');
    };

    FileDownload.prototype.getError = function() {
      if (this.source() != null) {
        return this.source().error_message;
      }
      return null;
    };

    FileDownload.prototype.fetchSource = function() {
      if (_.isEmpty(this.hash_key) || this.awaitingSource) {
        return;
      }
      App.SourceFetcher.bind('source-updated', this.fsUpdated);
      this.awaitingSource = true;
      return App.fetchSourceWithoutExplicitQuerySource(this.hash_key);
    };

    FileDownload.prototype.readyForDownload = function() {
      return this.queryCompleted() && (this.getDataDestination() != null) && _.isEmpty(this.getError());
    };

    FileDownload.prototype.itemType = function() {
      return this.item_type;
    };

    FileDownload.prototype.displayName = function() {
      return this.display_name;
    };

    FileDownload.downloadFromWidget = function(widget) {
      return this.runQueryAndSave(widget, this.paramsForWidget(widget.id), 'Chart');
    };

    FileDownload.runQueryWithSql = function(item, sql, database_id, modified_from_original) {
      if (modified_from_original == null) {
        modified_from_original = false;
      }
      return this.runQueryAndSave(item, this.paramsForSql(item, sql, database_id), 'Editor', modified_from_original);
    };

    FileDownload.runQueryAndSave = function(item, params, download_source, modified) {
      var download;
      if (modified == null) {
        modified = false;
      }
      download = new App.FileDownload({
        display_name: App.FileDownload.getNameFromItem(item, modified),
        download_started_at: (new Date).getTime(),
        download_initialized_from: download_source,
        item_id: !item.isNew() ? item.id : void 0,
        item_type: item.constructor.className
      });
      AppRedesign.current().fileDownloadsController.addToLocalDownloadCache(download);
      params['data']['display_name'] = download.display_name;
      return jQuery.ajax(params).done((function(_this) {
        return function(response) {
          download.hash_key = response.hash_key;
          if (AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
            return download.save({
              custom_url: "/shared_dashboards/" + (AppRedesign.current().shared_dashboard_token) + "/file_downloads"
            });
          } else {
            return download.save();
          }
        };
      })(this));
    };

    FileDownload.paramsForWidget = function(widget_id) {
      if (AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
        return this.paramsForWidgetOnSharedDashboards(widget_id);
      } else {
        return this.paramsForWidgetOnDashboards(widget_id);
      }
    };

    FileDownload.paramsForWidgetOnSharedDashboards = function(widget_id) {
      var filters, ref, shareDashboardFilters;
      shareDashboardFilters = App.SharedDashboard.currentSharedDashboard().filters();
      filters = Object.assign(shareDashboardFilters.filtersHash(), ((ref = App.UserDataView.current()) != null ? ref.filters().filtersHash() : void 0) || {});
      return {
        url: "/shared_dashboards/" + (AppRedesign.current().shared_dashboard_token) + "/file_download_scheduler",
        type: 'POST',
        data: {
          client_site_id: App.Site.first().id,
          widget_id: widget_id,
          filters: JSON.stringify(filters)
        },
        dataType: 'json'
      };
    };

    FileDownload.paramsForWidgetOnDashboards = function(widget_id) {
      return {
        url: "/widgets/" + widget_id + "/download_csv",
        type: 'POST',
        data: {
          client_site_id: App.Site.first().id,
          udv: AppRedesign.udvIdInUrl()
        },
        dataType: 'json'
      };
    };

    FileDownload.paramsForSql = function(item, sql, database_id) {
      return {
        url: "/file_downloads/run_query_for_download",
        type: 'POST',
        data: {
          client_site_id: App.Site.first().id,
          item_id: !item.isNew() ? item.id : void 0,
          item_type: item.constructor.className,
          dashboard_id: item instanceof App.Widget ? App.Dashboard.currentDashboard().id : void 0,
          udv_id: item instanceof App.Widget ? App.UserDataView.currentId() : void 0,
          query: sql,
          database_id: database_id,
          no_filters: !(item instanceof App.Widget) ? true : void 0
        },
        dataType: 'json'
      };
    };

    return FileDownload;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FormulaSource = (function(superClass) {
    extend(FormulaSource, superClass);

    function FormulaSource() {
      this.setDataFetchedAt = bind(this.setDataFetchedAt, this);
      return FormulaSource.__super__.constructor.apply(this, arguments);
    }

    FormulaSource.configure('FormulaSource', 'client_site_id', 'hash_key', 'rows', 'columns', 'column_infos', 'error_message', 'error_pos', 'last_update', 'last_refresh', 'percent_complete', 'ran_on_redshift', 'query_duration', 'redshift_sql', 'source_type', 'sql', 'has_order_by', 'insertotron_metadata', 'waiting_user_ids', 'data_destination', 'links');

    FormulaSource.extend(Spine.Model.Ajax);

    FormulaSource.CODE = 'code';

    FormulaSource._cache = {};

    FormulaSource.exists = function(id_or_cid_or_hash_key) {
      var source;
      source = App.FormulaSource.findByHash(id_or_cid_or_hash_key);
      if (source != null) {
        return source;
      }
      return FormulaSource.__super__.constructor.exists.apply(this, arguments);
    };

    FormulaSource.find = function(id_or_cid_or_hash_key) {
      var record;
      record = App.FormulaSource.exists(id_or_cid_or_hash_key);
      if (!record) {
        throw new Error('Unknown record');
      }
      return record;
    };

    FormulaSource.prototype.save = function(options) {
      var c;
      if (options == null) {
        options = {};
      }
      delete this.constructor._cache[this.hash_key];
      delete this._myUsedViewIds;
      if (this.column_infos != null) {
        this.columns = (function() {
          var i, len, ref, results;
          ref = this.column_infos;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            c = ref[i];
            results.push(c.column_name);
          }
          return results;
        }).call(this);
      }
      options['ajax'] = false;
      return FormulaSource.__super__.save.call(this, options);
    };

    FormulaSource.reset = function() {
      return this._cache = {};
    };

    FormulaSource.prototype.setDataFetchedAt = function(val) {
      return this.dataFetchedAt = val;
    };

    FormulaSource.appliedUpdates = function(fs) {
      return this._cache[fs.hash_key] = fs;
    };

    FormulaSource.prototype.waitingOnS3Links = function() {
      if (!this.links) {
        return false;
      }
      return window.reactApp.waitingOnAnyS3Links(this.links);
    };

    FormulaSource.prototype.hasUpdatePending = function() {
      if (this.tooOld()) {
        return true;
      }
      return (!this.hasData() || this.waiting()) && App.SourceFetcher.sourcePending(this.hash_key);
    };

    FormulaSource.prototype.canceled = function() {
      var ref, ref1;
      return ((ref = this.insertotron_metadata) != null ? (ref1 = ref.canceled_for_users) != null ? ref1.length : void 0 : void 0) > 0;
    };

    FormulaSource.prototype.canceledForUser = function() {
      var currentUser, ref, ref1;
      if (AppRedesign.current().shared_mode) {
        return false;
      }
      currentUser = App.User.currentUser();
      if (currentUser == null) {
        return false;
      }
      return !!((ref = this.insertotron_metadata) != null ? (ref1 = ref.canceled_for_users) != null ? ref1.includes(currentUser.id) : void 0 : void 0);
    };

    FormulaSource.prototype.waiting = function() {
      var ref;
      return ((ref = this.waiting_user_ids) != null ? ref.indexOf(App.User.currentUserId()) : void 0) >= 0 || App.SourceFetcher.waitingFor(this.hash_key);
    };

    FormulaSource.prototype.tooOld = function() {
      var ref;
      return (((ref = AppRedesign.current()) != null ? ref.sourceMinUpdateTime : void 0) != null) && (this.last_refresh != null) && AppRedesign.current().sourceMinUpdateTime > this.last_refresh;
    };

    FormulaSource.prototype.hasData = function() {
      return Boolean(this.error_message || this.rows || this.columns || (this.links && !this.waitingOnS3Links()));
    };

    FormulaSource.prototype.hasOrderBy = function() {
      return this.has_order_by === true || this.source_type === "code";
    };

    FormulaSource.prototype.errorMessage = function() {
      if (this.canceledForUser()) {
        return App.Widget.QUERY_CANCELED_MESSAGE;
      }
      if (this.canceled() && this.emptyRows()) {
        return App.Chartographer.ERR_NO_ROWS;
      }
      return this.error_message;
    };

    FormulaSource.prototype.emptyRows = function() {
      return (this.rows == null) || this.rows.length === 0;
    };

    FormulaSource.prototype.getDataType = function() {
      if (!this.links) {
        return 'table';
      }
      switch (window.reactApp.defaultContentTypeForS3Links(this.links)) {
        case 'image/png':
          return 'imagelink';
        case 'text/plain':
          return 'textlink';
        case 'application/json':
          if (this.isPlotlySource()) {
            return 'plotlylink';
          }
      }
      return 'table';
    };

    FormulaSource.prototype.isPlotlySource = function() {
      return window.reactApp.subTypeForS3Links(this.links) === 'plotly';
    };

    FormulaSource.prototype.isCodeSource = function() {
      return this.source_type === 'code';
    };

    FormulaSource.prototype.getInsertotronMetadata = function(key) {
      var md, v;
      md = this.insertotron_metadata;
      if (md != null) {
        v = md[key];
        if (v != null) {
          return v;
        }
      }
      return null;
    };

    FormulaSource.prototype.getFailingViews = function() {
      var failedViews, i, id, len, ref, view;
      if (!this.ran_on_redshift) {
        return [];
      }
      if (this._myUsedViewIds == null) {
        this._myUsedViewIds = App.SqlView.getAllParents(this.redshift_sql);
      }
      failedViews = [];
      ref = this._myUsedViewIds;
      for (i = 0, len = ref.length; i < len; i++) {
        id = ref[i];
        view = App.SqlView.exists(id);
        if (view && view.isFailed()) {
          failedViews.push(view);
        }
      }
      return failedViews;
    };

    FormulaSource.prototype.htmlSql = function() {
      if ((this.sql != null) && (this.sql.indexOf("--yes_cache") !== -1 || this.ran_on_redshift) && (this.redshift_sql != null)) {
        return this.redshift_sql;
      } else {
        return this.sql;
      }
    };

    FormulaSource.isLoading = function(fs) {
      return (fs == null) || fs.percent_complete === 0 || fs.waitingOnS3Links();
    };

    FormulaSource.prototype.isCompletelyLoaded = function() {
      return this.percent_complete === 1 && !this.waitingOnS3Links();
    };

    FormulaSource.prototype.linkData = function(dataType) {
      switch (dataType) {
        case 'imagelink':
          return this.imageData();
        case 'textlink':
          return this.textData();
      }
      return null;
    };

    FormulaSource.prototype.imageData = function() {
      return window.reactApp.imageForS3Links(this.links);
    };

    FormulaSource.prototype.textData = function() {
      return window.reactApp.textForS3Links(this.links);
    };

    FormulaSource.prototype.tableData = function() {
      return window.reactApp.tableForS3Links(this.links);
    };

    FormulaSource.prototype.tableDataRows = function() {
      var ref, tableData;
      if (this.links != null) {
        tableData = this.tableData();
        return (ref = tableData != null ? tableData.rows : void 0) != null ? ref : [[]];
      }
      return this.rowsAsHashList();
    };

    FormulaSource.prototype.tableDataColumns = function() {
      var d, i, len, ref, ref1, tableData, traceNames;
      if (this.links != null) {
        tableData = this.tableData();
        if (this.isPlotlySource()) {
          traceNames = [];
          if ((tableData != null ? tableData.data : void 0) == null) {
            return traceNames;
          }
          ref = tableData.data;
          for (i = 0, len = ref.length; i < len; i++) {
            d = ref[i];
            if (d.name) {
              traceNames.push(d.name);
            }
          }
          return traceNames;
        } else {
          return (ref1 = tableData != null ? tableData.columns : void 0) != null ? ref1 : [];
        }
      }
      return this.columnsWithoutDupes();
    };

    FormulaSource.prototype.rowsAsHashList = function() {
      return App.Utils.rowsArraysToHashes(this.rows, this.columns);
    };

    FormulaSource.prototype.columnsWithoutDupes = function() {
      if (this.columns == null) {
        return this.columns;
      }
      return App.Utils.renameDuplicateColumns(this.columns);
    };

    FormulaSource.allowsEqualUpdates = function() {
      return true;
    };

    FormulaSource.findByHash = function(hash) {
      var base;
      return (base = this._cache)[hash] != null ? base[hash] : base[hash] = _.find(App.FormulaSource.records, {
        hash_key: hash
      });
    };

    FormulaSource.prototype.csvBlob = function() {
      var data;
      if (!((this.columns != null) && (this.rows != null))) {
        return "There is no data for this csv.";
      }
      return data = Papa.unparse([this.columns]) + "\n" + Papa.unparse(this.rows);
    };

    FormulaSource.prototype.hasErrorPositions = function() {
      var ref;
      return _.isInteger((ref = this.error_pos) != null ? ref.first() : void 0);
    };

    return FormulaSource;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Group = (function(superClass) {
    extend(Group, superClass);

    function Group() {
      this.accessLevelCurrentSite = bind(this.accessLevelCurrentSite, this);
      return Group.__super__.constructor.apply(this, arguments);
    }

    Group.configure('Group', 'client_site_id', 'name', 'admin', 'all_users', 'site_id', 'site_family_id', 'can_edit', 'created_by_user_id', 'created_at', 'sync_version');

    Group.extend(Spine.Model.Ajax);

    Group.ALL_USERS = 'All Users';

    Group.ADMINS = 'Administrators';

    Group.OWNER = 'Owner';

    Group.ACCESS_LEVEL_DISPLAY_MAP = {
      'SQL': 'can_edit',
      'Discovery': 'can_drag_and_drop',
      'View': 'view_only'
    };

    Group.ACCESS_LEVEL_VALUE_MAP = {
      'can_edit': 'SQL',
      'can_drag_and_drop': 'Discovery',
      'view_only': 'View'
    };

    Group.prototype.addUser = function(member, options) {
      var membership;
      membership = new App.GroupMembership({
        user_id: member.id,
        group_id: this.id
      });
      return membership.save(options);
    };

    Group.prototype.removeUser = function(member, options) {
      var i, len, membership, ref, results;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        if (membership.group_id === this.id && membership.user_id === member.id) {
          results.push(membership.destroy(options));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Group.adminGroup = function() {
      var group, i, len, ref;
      ref = App.Group.all();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (group.admin) {
          return group;
        }
      }
    };

    Group.allUsersGroup = function() {
      var group, i, len, ref;
      ref = App.Group.all();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (group.all_users) {
          return group;
        }
      }
    };

    Group.findByName = function(groupName) {
      var group;
      return ((function() {
        var i, len, ref, results;
        ref = App.Group.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          if (group.name === groupName) {
            results.push(group);
          }
        }
        return results;
      })()).first();
    };

    Group.groupInfos = function(groupMembership, dashboardPerms) {
      var group, i, infos, len, ref;
      infos = [];
      ref = App.Group.all();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        infos.push(group.groupInfo(groupMembership, dashboardPerms));
      }
      return infos;
    };

    Group.groupToGroupRolesMap = function() {
      var groupRole, i, len, map, name, ref;
      map = {};
      ref = App.GroupRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (map[name = groupRole.site_id] == null) {
          map[name] = {};
        }
        map[groupRole.site_id][groupRole.group_id] = groupRole;
      }
      return map;
    };

    Group.prototype.addRole = function(siteId) {
      var role;
      role = new App.GroupRole({
        site_id: siteId,
        group_id: this.id
      });
      return role.save();
    };

    Group.prototype.removeRole = function(siteId) {
      var i, len, ref, results, role;
      ref = App.GroupRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        role = ref[i];
        if (role.group_id === this.id && siteId === role.site_id) {
          results.push(role.destroy());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Group.prototype.currentGroupPermissionsForDashboard = function(dashboardId) {
      var i, len, permission, ref, results;
      ref = App.DashboardGroupPermission.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        if (permission.dashboard_id === dashboardId && permission.group_id === this.id) {
          results.push(permission);
        }
      }
      return results;
    };

    Group.prototype.usersForGroup = function(groupToUsersMap, users) {
      var _, infos, ref, user, userId, userInfo;
      infos = [];
      ref = groupToUsersMap[this.id];
      for (userId in ref) {
        _ = ref[userId];
        try {
          user = users.find(function(user) {
            return user.id === parseInt(userId);
          });
          userInfo = {
            user_id: userId,
            user_name: user.fullName()
          };
          userInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = user;
          infos.push(userInfo);
        } catch (error) {

        }
      }
      return infos;
    };

    Group.prototype.dashboardMap = function() {
      var dashboardPerms, dashboardsForGroup, db, i, len, ref;
      dashboardsForGroup = {};
      dashboardPerms = App.DashboardGroupPermission.groupToPermissionMap();
      if (dashboardPerms[this.id] != null) {
        ref = Object.keys(dashboardPerms[this.id]);
        for (i = 0, len = ref.length; i < len; i++) {
          db = ref[i];
          dashboardsForGroup[db] = true;
        }
      }
      return dashboardsForGroup;
    };

    Group.prototype.getDashboardInfo = function(groupToDashboardsMap) {
      var dashboard, dashboardId, dashboardInfo, dashboardInfos, i, len, ref;
      dashboardInfos = [];
      if (groupToDashboardsMap[this.id] != null) {
        ref = Object.keys(groupToDashboardsMap[this.id]);
        for (i = 0, len = ref.length; i < len; i++) {
          dashboardId = ref[i];
          try {
            dashboard = App.Dashboard.find(dashboardId);
            dashboardInfo = {
              dashboard_name: dashboard.getName(),
              id: parseInt(dashboardId),
              can_edit: groupToDashboardsMap[this.id][dashboardId]['edit']
            };
            dashboardInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = dashboard;
            dashboardInfos.push(dashboardInfo);
          } catch (error) {

          }
        }
      }
      return dashboardInfos;
    };

    Group.prototype.groupInfo = function(groupMembership, dashboardPerms) {
      var createdBy, createdByUserName, dashboardCount, info, userCount;
      createdByUserName = null;
      if (this.created_by_user_id != null) {
        createdBy = null;
        try {
          createdBy = App.User.find(this.created_by_user_id);
        } catch (error) {

        }
        createdByUserName = createdBy != null ? createdBy.abbreviatedDisplayName() : void 0;
      }
      if (this.all_users) {
        userCount = App.User.count();
      } else {
        userCount = groupMembership[this.id] != null ? Object.keys(groupMembership[this.id]).length : 0;
      }
      dashboardCount = dashboardPerms[this.id] != null ? Object.keys(dashboardPerms[this.id]).length : 0;
      info = {
        id: this.id,
        name: this.name,
        can_edit: this.canEditCurrentSite(),
        access_level: this.accessLevelCurrentSite(),
        created_by: createdByUserName,
        created_on: this.created_at,
        users: userCount,
        dashboards: dashboardCount,
        admin: this.admin,
        is_site_family_group: this.isSiteFamilyGroup()
      };
      info[App.RedesignSimpleGridController.OBJECT_FIELD] = this;
      return info;
    };

    Group.prototype.groupMemberships = function() {
      return _.filter(App.GroupMembership.all(), (function(_this) {
        return function(groupMembership) {
          return groupMembership.group_id === _this.id;
        };
      })(this));
    };

    Group.prototype.isLocalGroup = function() {
      return !this.isSiteFamilyGroup();
    };

    Group.prototype.isSiteFamilyGroup = function() {
      return this.site_family_id != null;
    };

    Group.prototype.getCurrentSiteGroupRole = function() {
      return this.currentSiteGroupRole != null ? this.currentSiteGroupRole : this.currentSiteGroupRole = _.find(App.GroupRole.all(), {
        group_id: this.id,
        site_id: App.Site.first().id
      });
    };

    Group.prototype.reloadCurrentSiteGroupRole = function() {
      return this.currentSiteGroupRole.reload();
    };

    Group.prototype.canEditCurrentSite = function() {
      var ref;
      return Boolean((ref = this.getCurrentSiteGroupRole()) != null ? ref.can_edit : void 0);
    };

    Group.prototype.accessLevelCurrentSite = function() {
      var ref;
      return (ref = this.getCurrentSiteGroupRole()) != null ? ref.access_level : void 0;
    };

    Group.prototype.accessLevelValueCurrentSite = function() {
      return App.Group.ACCESS_LEVEL_DISPLAY_MAP[this.accessLevelCurrentSite()];
    };

    Group.prototype.setCanEditCurrentSite = function(canEdit) {
      var ref;
      return (ref = this.getCurrentSiteGroupRole()) != null ? ref.can_edit = canEdit : void 0;
    };

    Group.prototype.setAccessLevelCurrentSite = function(accessLevel) {
      var ref, ref1, ref2;
      if ((ref = this.getCurrentSiteGroupRole()) != null) {
        ref.can_edit = accessLevel === 'can_edit';
      }
      if ((ref1 = this.getCurrentSiteGroupRole()) != null) {
        ref1.can_drag_and_drop = accessLevel === 'can_drag_and_drop';
      }
      return (ref2 = this.getCurrentSiteGroupRole()) != null ? ref2.access_level = App.Group.ACCESS_LEVEL_VALUE_MAP[accessLevel] : void 0;
    };

    Group.prototype.saveCurrentSiteGroupRole = function() {
      var ref;
      return (ref = this.getCurrentSiteGroupRole()) != null ? ref.save() : void 0;
    };

    return Group;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.GroupMembership = (function(superClass) {
    extend(GroupMembership, superClass);

    function GroupMembership() {
      return GroupMembership.__super__.constructor.apply(this, arguments);
    }

    GroupMembership.configure('GroupMembership', 'client_site_id', 'id', 'user_id', 'group_id', 'sync_version');

    GroupMembership.extend(Spine.Model.Ajax);

    GroupMembership.membershipMap = function() {
      var i, len, map, membership, name, ref;
      map = {};
      ref = App.GroupMembership.all();
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        map[name = membership.group_id] || (map[name] = {});
        map[membership.group_id][membership.user_id] = true;
      }
      return map;
    };

    GroupMembership.userToGroupsMap = function() {
      var i, len, map, membership, name, ref;
      map = {};
      ref = App.GroupMembership.all();
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        map[name = membership.user_id] || (map[name] = []);
        map[membership.user_id][membership.group_id] = true;
      }
      return map;
    };

    return GroupMembership;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.GroupRole = (function(superClass) {
    extend(GroupRole, superClass);

    function GroupRole() {
      return GroupRole.__super__.constructor.apply(this, arguments);
    }

    GroupRole.configure('GroupRole', 'client_site_id', 'site_id', 'group_id', 'can_edit', 'access_level', 'can_drag_and_drop');

    GroupRole.extend(Spine.Model.Ajax);

    GroupRole.prototype.name = function() {
      return this.group().name;
    };

    GroupRole.prototype.group = function() {
      return App.Group.find(this.group_id);
    };

    return GroupRole;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DownloadHelper = (function(superClass) {
    extend(DownloadHelper, superClass);

    function DownloadHelper() {
      return DownloadHelper.__super__.constructor.apply(this, arguments);
    }

    DownloadHelper.SOURCE_TOO_LARGE_ERROR_PREFIX = "Result set too large";

    DownloadHelper.getDownloadDate = function(epoch) {
      return [epoch.getFullYear(), epoch.getMonth() + 1, epoch.getDate()].join('-');
    };

    DownloadHelper.getDownloadTime = function(epoch) {
      return "" + (this.doubleDigitize(epoch.getHours())) + (this.doubleDigitize(epoch.getMinutes()));
    };

    DownloadHelper.doubleDigitize = function(timePart) {
      return ('0' + timePart).slice(-2).toString();
    };

    DownloadHelper.getDownloadTitle = function(item, epoch, suffix, extension) {
      var datePart, fullName, hourPart, rawName;
      if (suffix == null) {
        suffix = '';
      }
      if (extension == null) {
        extension = '';
      }
      rawName = item instanceof App.Widget ? item.getTitleForDisplay() : item.name;
      fullName = this.sanitizeDownloadName(rawName);
      if (!_.isEmpty(suffix)) {
        fullName = [fullName, suffix].join('_');
      }
      if (epoch == null) {
        return fullName + extension;
      }
      datePart = App.DownloadHelper.getDownloadDate(epoch);
      hourPart = App.DownloadHelper.getDownloadTime(epoch);
      return [fullName, datePart, hourPart].join('_') + extension;
    };

    DownloadHelper.sanitizeDownloadName = function(name) {
      return name.replace(/[^a-zA-Z0-9]/g, '');
    };

    DownloadHelper.exportCSV = function(item) {
      var fs;
      fs = item.selectedFormulaSource();
      if (fs == null) {
        return;
      }
      if (this.isLargeFileDownload(fs, item)) {
        return this.exportLargeFileDownload(item);
      } else {
        return this.exportCSVFromSource(fs, item);
      }
    };

    DownloadHelper.exportLargeFileDownload = function(item) {
      return App.FileDownload.downloadFromWidget(item);
    };

    DownloadHelper.exportCSVForEditUser = function(item, sql, database_id, modified) {
      var fs, itemHasNoSource;
      itemHasNoSource = !(item instanceof App.Widget && (item.selectedFormulaSource() != null));
      if (!itemHasNoSource) {
        fs = item.selectedFormulaSource();
      }
      if (itemHasNoSource || this.hashKeyChanged(item, sql) || this.largeFileDownload(fs, item)) {
        return App.FileDownload.runQueryWithSql(item, sql, database_id, modified);
      } else {
        return this.exportCSVFromSource(fs, item);
      }
    };

    DownloadHelper.isLargeFileDownload = function(fs, item) {
      if (AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
        return this.sharedDashboardLFD(fs, item);
      } else {
        return this.largeFileDownload(fs, item);
      }
    };

    DownloadHelper.sharedDashboardLFD = function(fs, item) {
      var ref;
      if (fs == null) {
        return true;
      }
      if ((ref = fs.error_message) != null ? ref.startsWith(this.SOURCE_TOO_LARGE_ERROR_PREFIX) : void 0) {
        return true;
      }
      if (!_.isEmpty(fs.error_message)) {
        return false;
      }
      if (item.sourceRowsComplete()) {
        return false;
      }
      if (fs.isCodeSource()) {
        return false;
      }
      return true;
    };

    DownloadHelper.largeFileDownload = function(fs, item) {
      var ref;
      if (fs == null) {
        return true;
      }
      if (AppRedesign.current().shared_mode) {
        return false;
      }
      if ((ref = fs.error_message) != null ? ref.startsWith(this.SOURCE_TOO_LARGE_ERROR_PREFIX) : void 0) {
        return true;
      }
      if (!_.isEmpty(fs.error_message)) {
        return false;
      }
      if (item.sourceRowsComplete()) {
        return false;
      }
      if (fs.isCodeSource()) {
        return false;
      }
      return true;
    };

    DownloadHelper.exportCSVFromSource = function(fs, item) {
      var download, downloadDate, route;
      download = new App.FileDownload({
        display_name: App.FileDownload.getNameFromItem(item),
        download_started_at: (new Date).getTime(),
        item_type: App.FileDownload.className
      });
      download.save({
        ajax: false
      });
      if (typeof app !== "undefined" && app !== null ? app.shared_mode : void 0) {
        route = "/shared_dashboards/" + app.shared_dashboard_token + "/download_csv/" + fs.hash_key;
      } else {
        route = "/sites/" + (App.Site.first().id) + "/download_csv/" + fs.hash_key;
      }
      if (fs.last_update != null) {
        downloadDate = new Date(fs.last_update * 1000);
      }
      window.location = route + ("?title=" + (encodeURIComponent(this.getDownloadTitle(item, downloadDate))));
      if (!AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
        App.Utils.logFeature("csv-export", {
          widget_id: item.id,
          dashboard_id: item.dashboard_id
        });
      }
      return setTimeout((function() {
        return download.destroy({
          ajax: false
        });
      }), 500);
    };

    DownloadHelper.hashKeyChanged = function(item, sql) {
      var savedCopy;
      savedCopy = App.Widget.exists(item.id);
      if (!savedCopy) {
        return true;
      }
      return sql !== savedCopy.sql || parseInt(item.database_id) !== savedCopy.database_id;
    };

    DownloadHelper.getVerbForDownloadItemType = function(downloadItem) {
      if (downloadItem.item_type === 'SqlViewDataExport') {
        return 'export';
      }
      return 'download';
    };

    DownloadHelper.getForDisplay = function(downloadItem) {
      return {
        cid: downloadItem.cid,
        file_name: downloadItem.displayName(),
        time_elapsed: this.formatElapsedTime(downloadItem.getStartedAt()),
        data_destination: downloadItem.getDataDestination(),
        ready: downloadItem.readyForDownload(),
        error: downloadItem.getError(),
        item_type: downloadItem.itemType()
      };
    };

    DownloadHelper.formatElapsedTime = function(startedAt) {
      return (App.Utils.roundedAgo(new Date().getTime() - new Date(startedAt).getTime(), true)) + " ago";
    };

    DownloadHelper.downloadPDF = function(dashboard_id, dashboard_name) {
      var download, filename, udv_id;
      filename = App.DownloadHelper.getDownloadTitle({
        name: dashboard_name
      }, new Date(), '', '.pdf');
      udv_id = App.UserDataView.currentId();
      download = new App.PdfDownload({
        dashboard_id: dashboard_id,
        display_name: filename,
        filename: filename,
        udv_id: udv_id,
        download_started_at: (new Date).getTime(),
        item_type: App.PdfDownload.className
      });
      return jQuery.ajax({
        type: 'POST',
        url: "/pdf_downloads",
        data: {
          filename: filename,
          udv_id: udv_id,
          dashboard_id: dashboard_id
        }
      }).done((function(_this) {
        return function(pdf_download) {
          download.file_url = pdf_download.file_url;
          download.hash_key = pdf_download.hash_key;
          download.id = pdf_download.id;
          download.save({
            ajax: false
          });
          return App.Utils.logFeature("pdf-download-schedule-success", {
            dashboard_id: dashboard_id,
            udv_id: udv_id
          });
        };
      })(this)).fail((function(_this) {
        return function(response) {
          if (response.status !== 403) {
            download.error_message = 'Download failed, please try again';
            download.save({
              ajax: false
            });
            return App.Utils.logFeature("pdf-download-failure", {
              dashboard_id: dashboard_id,
              udv_id: udv_id
            });
          }
        };
      })(this));
    };

    return DownloadHelper;

  })(Spine.Module);

}).call(this);
(function() {
  App.ValidationHelper = (function() {
    function ValidationHelper() {}

    ValidationHelper.dupeName = function(object) {
      var s, v;
      return ((function() {
        var i, len, ref, results;
        ref = App.SqlSnippet.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          s = ref[i];
          if (s.cid !== object.cid && this.matchesMyName(object.name, s.name)) {
            results.push(1);
          }
        }
        return results;
      }).call(this)).length > 0 || ((function() {
        var i, len, ref, results;
        ref = App.SqlView.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          v = ref[i];
          if (v.cid !== object.cid && this.matchesMyName(object.name, v.name)) {
            results.push(1);
          }
        }
        return results;
      }).call(this)).length > 0 || ((function() {
        var i, len, ref, results;
        ref = App.CsvView.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          v = ref[i];
          if (v.cid !== object.cid && this.matchesMyName(object.name, v.name)) {
            results.push(1);
          }
        }
        return results;
      }).call(this)).length > 0;
    };

    ValidationHelper.matchesMyName = function(name, otherName) {
      if (!((name != null) && (otherName != null))) {
        return false;
      }
      return name.toLowerCase() === otherName.toLowerCase();
    };

    return ValidationHelper;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.NpsSurveyResponse = (function(superClass) {
    extend(NpsSurveyResponse, superClass);

    function NpsSurveyResponse() {
      return NpsSurveyResponse.__super__.constructor.apply(this, arguments);
    }

    NpsSurveyResponse.configure('NpsSurveyResponse', 'id', 'score', 'explanation', 'completed', 'completed_at', 'shown');

    NpsSurveyResponse.mostRecentNps = function() {
      var completed_nps;
      completed_nps = this.select(function(response) {
        return response.isCompleted();
      })[0];
      if (completed_nps) {
        return completed_nps.score;
      } else {
        return null;
      }
    };

    NpsSurveyResponse.incompleteResponse = function() {
      if (this.count() === 0) {
        return null;
      } else {
        return this.select(function(response) {
          return !response.isCompleted();
        })[0];
      }
    };

    NpsSurveyResponse.prototype.hasResponded = function() {
      return this.score || this.explanation;
    };

    NpsSurveyResponse.prototype.updateSurveyResponse = function() {
      return jQuery.ajax({
        method: 'put',
        url: '/nps_survey_response',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(this.asJson())
      });
    };

    NpsSurveyResponse.prototype.asJson = function() {
      return _.omit(this.attributes(), ['sync_version', 'last_requested_sync_version', 'last_completed_sync_version']);
    };

    NpsSurveyResponse.prototype.isCompleted = function() {
      return this.completed_at != null;
    };

    return NpsSurveyResponse;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PdfDownload = (function(superClass) {
    extend(PdfDownload, superClass);

    function PdfDownload() {
      return PdfDownload.__super__.constructor.apply(this, arguments);
    }

    PdfDownload.configure('PdfDownload', 'client_site_id', 'hash_key', 'user_id', 'site_id', 'download_started_at', 'download_canceled_at', 'download_initialized_from', 'id', 'udv_id', 'dashboard_id', 'file_url', 'error_message', 'filename');

    PdfDownload.extend(Spine.Model.Ajax);

    PdfDownload.prototype.getDataDestination = function() {
      return this.file_url;
    };

    PdfDownload.prototype.getError = function() {
      return this.error_message;
    };

    PdfDownload.prototype.readyForDownload = function() {
      return !_.isEmpty(this.getDataDestination()) && _.isEmpty(this.getError());
    };

    PdfDownload.prototype.itemType = function() {
      return App.PdfDownload.className;
    };

    PdfDownload.prototype.displayName = function() {
      return this.filename;
    };

    PdfDownload.prototype.getStartedAt = function() {
      return this.download_started_at;
    };

    return PdfDownload;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RecentItem = (function(superClass) {
    extend(RecentItem, superClass);

    RecentItem.configure('RecentItem', 'client_site_id', 'item_type', 'item_id', 'user_role_id', 'created_at', 'updated_at');

    RecentItem.extend(Spine.Model.Ajax);

    RecentItem.createFromRecord = function(model) {
      if (model.isNew() || App.Utils.isClientId(model.id)) {
        return;
      }
      return this.create({
        item_id: model.id,
        item_type: model.constructor.className
      });
    };

    RecentItem.recentForModelSorted = function(itemClass) {
      return _(App.RecentItem.all()).filter({
        item_type: itemClass.className
      }).orderBy(function(recentItem) {
        return Date.parse(recentItem.updated_at);
      }, 'desc').uniqBy('item_id').take(5).map(_.method('item')).value();
    };

    RecentItem.removeForItem = function(model) {
      var ref;
      return (ref = _.find(this.records, {
        item_id: model.id,
        item_type: model.constructor.className
      })) != null ? ref.remove() : void 0;
    };

    function RecentItem() {
      RecentItem.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item_id', 'item_type');
    }

    RecentItem.prototype.item = function() {
      return App[this.item_type].exists(this.item_id);
    };

    return RecentItem;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Redshift = (function(superClass) {
    extend(Redshift, superClass);

    function Redshift() {
      return Redshift.__super__.constructor.apply(this, arguments);
    }

    Redshift.configure('Redshift', 'id', 'name', 'aws_region', 'cpu', 'disk', 'rank', 'node_count');

    Redshift.extend(Spine.Model.Ajax);

    Redshift.prototype.menuText = function() {
      return this.name + " (" + (this.nodeText()) + (App.Utils.formatAsPercent(Math.max(this.disk, this.cpu))) + " used)";
    };

    Redshift.prototype.searchTokens = function() {
      var tokens;
      tokens = [this.name, this.aws_region];
      return tokens.tokenize();
    };

    Redshift.prototype.matchesQuery = function(queryTokens) {
      return App.Utils.matchesQuery(queryTokens, this.searchTokens());
    };

    Redshift.prototype.nodeText = function() {
      var text;
      if (this.node_count == null) {
        return "";
      }
      text = this.node_count + " node";
      if (this.node_count > 1) {
        text = text + "s";
      }
      return text + ", ";
    };

    Redshift.allSortedByName = function(filterQuery) {
      if (filterQuery == null) {
        filterQuery = null;
      }
      return this.allSortedByRank(filterQuery);
    };

    Redshift.allSortedByRank = function(filterQuery) {
      var allDbs, queryTokens;
      if ((filterQuery != null) && filterQuery.trim() !== "") {
        queryTokens = filterQuery.split(' ').tokenize();
        allDbs = this.select(function(u) {
          return u.matchesQuery(queryTokens);
        });
      } else {
        allDbs = this.all();
      }
      return allDbs.sort(function(a, b) {
        return App.Utils.sortAlphanumericComparator(a.rank, b.rank);
      });
    };

    return Redshift;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SalesforceObjectHarvest = (function(superClass) {
    extend(SalesforceObjectHarvest, superClass);

    function SalesforceObjectHarvest() {
      return SalesforceObjectHarvest.__super__.constructor.apply(this, arguments);
    }

    SalesforceObjectHarvest.configure('SalesforceObjectHarvest', 'client_site_id', 'id', 'salesforce_database_id', 'table_name', 'full_harvest_interval_seconds', 'full_harvest_custom_schedule', 'last_successful_full_harvest_at', 'database_id', 'disabled_at', 'error_count', 'next_full_harvest_at', 'harvest_started_at', 'last_error_info', 'pretty_error', 'last_full_harvest_msec');

    SalesforceObjectHarvest.extend(Spine.Model.Ajax);

    SalesforceObjectHarvest.filterByDatabase = function(database) {
      var i, len, ref, results, salesforceObjectHarvest;
      if (database.database_type !== 'SalesforceDatabase') {
        return [];
      }
      ref = this.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        salesforceObjectHarvest = ref[i];
        if (salesforceObjectHarvest.database_id === database.id) {
          results.push(salesforceObjectHarvest);
        }
      }
      return results;
    };

    SalesforceObjectHarvest.prototype.fullName = function() {
      return "public." + this.table_name;
    };

    SalesforceObjectHarvest.prototype.getStrategy = function() {
      return this.clientSideStrategy || this.getSavedStrategy();
    };

    SalesforceObjectHarvest.prototype.getSavedStrategy = function() {
      if (this.isNew()) {
        return "";
      }
      return App.TableHarvest.STRATEGIES.FULL_ONLY;
    };

    SalesforceObjectHarvest.prototype.isFullOnly = function() {
      return this.getStrategy() === App.TableHarvest.STRATEGIES.FULL_ONLY;
    };

    SalesforceObjectHarvest.prototype.isIncrementalOnly = function() {
      return false;
    };

    SalesforceObjectHarvest.prototype.isFullAndIncremental = function() {
      return false;
    };

    SalesforceObjectHarvest.prototype.isBoundedUpdates = function() {
      return false;
    };

    SalesforceObjectHarvest.prototype.isModifiedOnly = function() {
      return false;
    };

    SalesforceObjectHarvest.prototype.status = function() {
      if (this.disabled_at != null) {
        return 'disabled';
      } else if (this.error_count > 9) {
        return 'failed';
      } else if (this.error_count > 0) {
        return 'warning';
      } else if (this.harvest_started_at != null) {
        return 'running';
      } else if (Date.parse(this.next_full_harvest_at) > (new Date).getTime()) {
        return 'waiting';
      } else {
        return 'queued';
      }
    };

    SalesforceObjectHarvest.prototype.nextUpdateText = function() {
      var diff_msec;
      if (this.next_full_harvest_at == null) {
        return "not scheduled";
      }
      diff_msec = Date.parse(this.next_full_harvest_at) - (new Date).getTime();
      if (diff_msec < 0) {
        return "soon";
      } else {
        return "in " + (App.Utils.roundedAgo(diff_msec));
      }
    };

    SalesforceObjectHarvest.findByDatabaseAndName = function(databaseId, name) {
      var harvest, i, len, ref;
      ref = this.all();
      for (i = 0, len = ref.length; i < len; i++) {
        harvest = ref[i];
        if (harvest.database_id === databaseId && harvest.table_name === name) {
          return harvest;
        }
      }
      return null;
    };

    return SalesforceObjectHarvest;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Schedule = (function(superClass) {
    extend(Schedule, superClass);

    function Schedule() {
      return Schedule.__super__.constructor.apply(this, arguments);
    }

    Schedule.configure('Schedule', 'client_site_id', 'schedule_type', 'interval_seconds', 'monthly_day_selector', 'weekdays', 'hour', 'minute', 'runtime_range_lower', 'runtime_range_upper', 'next_run_at');

    Schedule.extend(Spine.Model.Ajax);

    Schedule.TYPE_NEVER = 'never';

    Schedule.TYPE_DEFAULT = 'default';

    Schedule.TYPE_INTERVAL = 'interval';

    Schedule.TYPE_CALENDAR = 'calendar';

    Schedule.HOURLY = 3600;

    return Schedule;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  App.SearchableArchive = (function() {
    SearchableArchive.all = function(className) {
      if (!className) {
        return this.records || [];
      }
      return this.records.filter(function(record) {
        return record.className === className;
      });
    };

    SearchableArchive.applyUpdates = function(items) {
      var i, item, len;
      this.records || (this.records = []);
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        if (this.indexOfRecord(item.id, item.class_name) !== -1) {
          continue;
        }
        new App.SearchableArchive(item.id, item.name, item.class_name, item.archived_at, item.tag_names, item.is_dataset, item.guid);
      }
      if (AppRedesign.dashboardOrganizationEnabled()) {
        return window.reactApp.populateSearchableArchives(items);
      }
    };

    SearchableArchive.createRecord = function(id, name, class_name, archived_at, tag_names, is_dataset, guid) {
      new App.SearchableArchive(id, name, class_name, archived_at, tag_names, is_dataset, guid);
      if (AppRedesign.dashboardOrganizationEnabled()) {
        return window.reactApp.populateSearchableArchives([
          {
            id: id,
            name: name,
            class_name: class_name,
            archived_at: archived_at,
            is_dataset: is_dataset,
            guid: guid
          }
        ]);
      }
    };

    SearchableArchive.applyDeletions = function(items) {
      var i, item, len, results;
      this.records || (this.records = []);
      results = [];
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        results.push(this.deleteRecord(item.id, item.class_name));
      }
      return results;
    };

    SearchableArchive.searchSqlViews = function(query) {
      return this.filterByQueryAndSort(this.all('SqlView'), query);
    };

    SearchableArchive.searchCsvViews = function(query) {
      return this.filterByQueryAndSort(this.all('CsvView'), query);
    };

    SearchableArchive.searchDashboards = function(query) {
      return this.filterByQueryAndSort(this.all('Dashboard'), query);
    };

    SearchableArchive.filterByQueryAndSort = function(archives, query) {
      var filterQuery, queryTokens;
      filterQuery = query.toLowerCase().replace(App.LeftMenuHelper.ARCHIVED_KEYWORD, '').trim();
      if (filterQuery !== "") {
        queryTokens = filterQuery.split(' ').tokenize();
        archives = archives.filter(function(archive) {
          return App.Utils.matchesQuery(queryTokens, archive.name.split('_').tokenize());
        });
      }
      return archives.sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    };

    SearchableArchive.deleteRecord = function(id, className) {
      var index;
      index = this.indexOfRecord(id, className);
      if (index >= 0) {
        this.records.splice(index, 1);
        if (AppRedesign.dashboardOrganizationEnabled()) {
          return window.reactApp.unpopulateSearchableArchives([
            {
              id: id,
              class_name: className
            }
          ]);
        }
      }
    };

    SearchableArchive.indexOfRecord = function(id, className) {
      return this.records.findIndex(function(record) {
        return record.id === id && record.className === className;
      });
    };

    function SearchableArchive(id1, name1, className1, archivedAt, tag_names1, isDataset, guid1) {
      var base;
      this.id = id1;
      this.name = name1;
      this.className = className1;
      this.archivedAt = archivedAt;
      this.tag_names = tag_names1;
      this.isDataset = isDataset;
      this.guid = guid1;
      this.cid = this.id;
      (base = this.constructor).records || (base.records = []);
      this.constructor.records.push(this);
    }

    SearchableArchive.prototype.displayName = function() {
      return this.name;
    };

    SearchableArchive.prototype.hasDataset = function() {
      return this.isDataset;
    };

    return SearchableArchive;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SharedDashboard = (function(superClass) {
    extend(SharedDashboard, superClass);

    function SharedDashboard() {
      return SharedDashboard.__super__.constructor.apply(this, arguments);
    }

    SharedDashboard.configure('SharedDashboard', 'client_site_id', 'name', 'dashboard_id', 'aggregation', 'date_range_dimension', 'access_count', 'token', 'last_update', 'custom_dimensions_list', 'api_generated', 'unlocked_filters', 'password_protected');

    SharedDashboard.extend(Spine.Model.Ajax);

    SharedDashboard.MIN_API_REFRESH_INTERVAL = 60 * 1000;

    SharedDashboard.currentSharedDashboard = function() {
      var sd;
      if (!AppRedesign.current().shared_mode) {
        return null;
      }
      return ((function() {
        var i, len, ref, results;
        ref = App.SharedDashboard.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          sd = ref[i];
          if (sd.token === AppRedesign.current().shared_dashboard_token) {
            results.push(sd);
          }
        }
        return results;
      })()).first();
    };

    SharedDashboard.prototype.dashboard = function() {
      return App.Dashboard.exists(this.dashboard_id);
    };

    SharedDashboard.prototype.title = function() {
      var cd, dim_id, dim_list, dim_value, dim_value_name, filtersByDimId, i, len, nameParts, ref, ref1, valueNames;
      if (this.name != null) {
        return this.name;
      }
      nameParts = [];
      if (this.custom_dimensions_list != null) {
        filtersByDimId = {};
        ref = this.custom_dimensions_list;
        for (i = 0, len = ref.length; i < len; i++) {
          dim_list = ref[i];
          dim_id = dim_list[0], dim_value = dim_list[1], dim_value_name = dim_list[2];
          filtersByDimId[dim_id] || (filtersByDimId[dim_id] = []);
          filtersByDimId[dim_id].push(dim_value_name);
        }
      }
      for (dim_id in filtersByDimId) {
        valueNames = filtersByDimId[dim_id];
        cd = App.CustomDimension.exists(dim_id);
        if (cd) {
          nameParts.push(cd.name + ": " + (valueNames.join(', ')));
        } else {
          nameParts.push("Filter: " + valueNames.join(', '));
        }
      }
      if (((ref1 = this.date_range_dimension) != null ? ref1.type : void 0) != null) {
        nameParts.push("Date Range: " + (App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(this.date_range_dimension).toLowerCase()));
      }
      if (this.aggregation) {
        nameParts.push("Aggregation: " + this.aggregation);
      }
      if (nameParts.length > 0) {
        return nameParts.join(', ');
      }
      return 'No Restrictions';
    };

    SharedDashboard.prototype.shareUrl = function() {
      return "http://" + window.location.host + ("/shared/" + this.token);
    };

    SharedDashboard.prototype.openShareUrl = function() {
      return window.open(this.shareUrl());
    };

    SharedDashboard.prototype.filters = function() {
      return new App.DashboardFilters(this.custom_dimensions_list, this.aggregation, this.date_range_dimension);
    };

    SharedDashboard.messageFromPostMessageApi = function(event) {
      if (!((event != null) && (event.data != null) && typeof event.data === 'object')) {
        return;
      }
      if (event.data.event_type !== 'refresh_charts') {
        return;
      }
      if ((SharedDashboard.lastApiRefresh != null) && (AppRedesign.timestamp() - SharedDashboard.lastApiRefresh < SharedDashboard.MIN_API_REFRESH_INTERVAL)) {
        return;
      }
      SharedDashboard.lastApiRefresh = AppRedesign.timestamp();
      return App.Dashboard.currentDashboard().refreshAllWidgetsFromEmbedApi();
    };

    return SharedDashboard;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SharedDashboardFactory = (function(superClass) {
    extend(SharedDashboardFactory, superClass);

    function SharedDashboardFactory() {
      return SharedDashboardFactory.__super__.constructor.apply(this, arguments);
    }

    SharedDashboardFactory.configure('SharedDashboardFactory', 'client_site_id', 'dashboard_id', 'custom_dimension_id', 'user_id', 'token', 'last_update');

    SharedDashboardFactory.extend(Spine.Model.Ajax);

    SharedDashboardFactory.prototype.customDimension = function() {
      var cd;
      cd = App.CustomDimension.exists(this.custom_dimension_id);
      if (cd) {
        return cd;
      }
      return null;
    };

    return SharedDashboardFactory;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Site = (function(superClass) {
    var obj;

    extend(Site, superClass);

    function Site() {
      this.accessLevels = bind(this.accessLevels, this);
      return Site.__super__.constructor.apply(this, arguments);
    }

    Site.PERISCOPE_DEMO_SITE_ID = 1903;

    Site.ACTIVE_TRIALS = 'active-trials';

    Site.PAYING_CUSTOMER_GROUP = 'paying';

    Site.CSV_ACCESS_EDIT_USERS = 'Edit Users';

    Site.CSV_ACCESS_ADMINS = 'Admins';

    Site.CSV_ACCESS_NONE = 'None';

    Site.CSV_ACCESS = (
      obj = {},
      obj["" + Site.CSV_ACCESS_EDIT_USERS] = 0,
      obj["" + Site.CSV_ACCESS_ADMINS] = 1,
      obj["" + Site.CSV_ACCESS_NONE] = 2,
      obj
    );

    Site.UPSELL_STATUS_PROMO = 'promo';

    Site.UPSELL_STATUS_PROMO_BUY_NOW = 'promo_buy_now';

    Site.UPSELL_STATUS_TRIAL = 'trial';

    Site.UPSELL_STATUS_DISABLED = 'disabled';

    Site.UPSELL_STATUS_PURCHASED = 'purchased';

    Site.CONTROL_FEATURES = 'control-features';

    Site.DEFAULT_SUPPORT_EMAIL = 'supportdt@sisense.com';

    Site.configure('Site', 'allowed_email_domains', 'api_key', 'billing_email', 'butter_bar_modern_user_seats_enabled', 'byow_enabled', 'cache_enabled', 'cached_site', 'csv_api_access', 'csv_download_access', 'csv_download_disable_on_new_charts', 'csv_download_permissions_enabled', 'csv_exports_disabled_for_shared_dashboards', 'csv_download_delimiter', 'customer_group', 'dashboard_refresh_enabled', 'dashboard_refresh_rollout_enabled', 'dashboard_user_refresh_disabled_when_fresher_than_seconds', 'dashboard_user_refresh_disabling_strategy', 'days_remaining_in_ssu_trial', 'deep_analysis_feature_flag_enabled', 'deep_analysis_r_enabled', 'deep_analysis_upsell_enabled', 'default_color_theme_id', 'default_dashboard_id', 'disable_background_refresh_for_unused_dashboard_enabled', 'display_name', 'display_timezone', 'display_timezone', 'drag_drop_calculated_fields_enabled', 'drag_drop_enabled', 'embed_upsell_enabled', 'enabled_customer_account_feature_settings', 'existing_control_upsell_features', 'filter_changes_run_unaffected_queries', 'forbid_csv_api', 'forbid_email_reports', 'forbid_slack_reports', 'forbid_embed_api', 'forbid_shared_dashboards', 'has_credit_card', 'has_ever_paid', 'host', 'metadata_enabled_for_customer', 'new_dashboards_not_public', 'new_filters_not_shared', 'pdf_download_enabled', 'pdf_download_enabled_for_admin', 'periscope_admin_access_ui_enabled', 'python_r_views_enabled', 'summary_stats_enabled', 'query_queue_enabled', 'redesign', 'require_tfa', 'row_count_disabled', 'sagemaker_enabled', 'sales_owner_email', 'sales_owner_name', 'salesforce_enabled', 'schedulable_views_enabled', 'schedule_id', 'self_signup', 'show_billing_modal', 'site_family_id', 'site_info_list', 'site_version', 'spaces_enabled', 'sso_enabled', 'wix_feature_flag_enabled', 'salesforce_chat_feature_flag_enabled', 'stripe_monthly_amount', 'stripe_monthly_amount_discounted', 'text_on_dashboard_enabled', 'trial_extension_duration_days_with_default', 'trial_extension_enabled', 'trial_extension_reason', 'trial_extension_started_at', 'version_control_enabled', 'view_dependencies_enabled', 'waas_upsell_enabled', 'warehouse_enabled', 'week_start_day_id', 'auto_archive_enabled', 'has_snowflake_cache', 'uses_explicit_cache', 'filter_check_all_enabled', 'app_connectors_username', 'data_engine_cloud_admin_site_enabled', 'only_user_specific_api_keys_enabled', 'user_specific_api_keys_feature_flag_enabled', 'large_csv_download_for_shared_dashboards_enabled', 'shared_dashboards_refresh_flag_enabled', 'snowflake_keypair_auth_feature_flag_enabled');

    Site.METAPERISCOPE_HOST = 'secure-springs-5928.herokuapp.com';

    Site.isMetaperiscope = function() {
      return this.first().host === this.METAPERISCOPE_HOST;
    };

    Site.extend(Spine.Model.Ajax);

    Site.isSpacesEnabled = function() {
      return this.first().isSpacesEnabled();
    };

    Site.allSites = function() {
      var firstSite;
      firstSite = App.Site.first();
      if (App.Site.isSpacesEnabled()) {
        return firstSite.site_info_list;
      } else {
        return [firstSite];
      }
    };

    Site.allAdminSites = function() {
      var sites;
      sites = App.Site.allSites();
      return sites.filter(function(site) {
        return site.is_admin;
      });
    };

    Site.prototype.accessLevels = function() {
      if (this.drag_drop_enabled) {
        return [
          {
            name: 'SQL',
            value: 'can_edit'
          }, {
            name: 'Discovery',
            value: 'can_drag_and_drop'
          }, {
            name: 'View',
            value: 'view_only'
          }
        ];
      } else {
        return [
          {
            name: 'SQL',
            value: 'can_edit'
          }, {
            name: 'View',
            value: 'view_only'
          }
        ];
      }
    };

    Site.prototype.singularKindName = function() {
      if (this.kind_name) {
        return this.kind_name.singularize();
      }
      AppRedesign.logError("singularKindName called for Site with no Kind Name: " + this.id);
      return ' ';
    };

    Site.prototype.showDimensionOptions = function() {
      return (AppRedesign.current() == null) || !AppRedesign.current().shared_mode || AppRedesign.current().shared_filter_mode;
    };

    Site.prototype.hasDimensions = function() {
      return ((this.dimensions != null) && this.dimensions.length > 0) || (App.CustomDimension.count() > 0);
    };

    Site.prototype.setDefaultDashboard = function(dashboardId) {
      this.default_dashboard_id = dashboardId;
      this.trigger('set-default-dashboard', {
        dashboard_id: dashboardId
      });
      return this.save();
    };

    Site.prototype.schedule = function() {
      if (App.Schedule.exists(this.schedule_id)) {
        return App.Schedule.find(this.schedule_id);
      }
    };

    Site.prototype.displayTimezoneOffset = function() {
      if (this.display_timezone === 'PST') {
        return -8;
      }
      if (this.display_timezone === 'MST') {
        return -7;
      }
      if (this.display_timezone === 'CST') {
        return -6;
      }
      if (this.display_timezone === 'EST') {
        return -5;
      }
      return 0;
    };

    Site.prototype.displayTimezoneOffsetString = function() {
      if (this.display_timezone === 'PST') {
        return '-08';
      }
      if (this.display_timezone === 'MST') {
        return '-07';
      }
      if (this.display_timezone === 'CST') {
        return '-06';
      }
      if (this.display_timezone === 'EST') {
        return '-05';
      }
      return '+00';
    };

    Site.prototype.isPeriscopeDemo = function() {
      return this.id === Site.PERISCOPE_DEMO_SITE_ID;
    };

    Site.prototype.isTfaRequired = function() {
      return this.require_tfa === true;
    };

    Site.prototype.isSalesforceEnabled = function() {
      return this.salesforce_enabled === true;
    };

    Site.prototype.isSpacesEnabled = function() {
      var base;
      if (typeof (base = App.Utils).spaceAdminUser === "function" ? base.spaceAdminUser() : void 0) {
        return false;
      }
      return this.spaces_enabled;
    };

    Site.prototype.isPDFDownloadEnabled = function() {
      return this.pdf_download_enabled === true;
    };

    Site.prototype.hasMultipleSitesInFamily = function() {
      var ref;
      return ((ref = this.site_info_list) != null ? ref.length : void 0) > 1;
    };

    Site.prototype.spaceName = function() {
      if (this.isSpacesEnabled()) {
        return this.display_name;
      } else {
        return null;
      }
    };

    Site.prototype.isQueryQueueEnabled = function() {
      return this.query_queue_enabled === true;
    };

    Site.prototype.isDashboardRefreshRolloutEnabled = function() {
      return this.dashboard_refresh_rollout_enabled === true;
    };

    Site.prototype.isDashboardRefreshEnabled = function() {
      return (this.dashboard_refresh_enabled === true) || App.User.currentUserIsPeriscopeAdmin();
    };

    Site.prototype.isDashboardRefreshV1Enabled = function() {
      return this.isDashboardRefreshEnabled();
    };

    Site.prototype.isDashboardRefreshV2Enabled = function() {
      return this.isDashboardRefreshEnabled();
    };

    Site.prototype.isVersionControlEnabled = function() {
      return this.version_control_enabled === true;
    };

    Site.prototype.isSkipForUnusedEnabled = function() {
      return this.disable_background_refresh_for_unused_dashboard_enabled === true;
    };

    Site.prototype.viewDependenciesEnabled = function() {
      return this.view_dependencies_enabled === true;
    };

    Site.prototype.isCsvDownloadPermissionsEnabled = function() {
      return this.csv_download_permissions_enabled === true;
    };

    Site.prototype.shouldShowWaasUpsellPromo = function() {
      return App.Utils.adminUser() && this.waas_upsell_enabled;
    };

    Site.prototype.shouldShowEmbedUpsellPromo = function() {
      return App.Utils.adminUser() && this.embed_upsell_enabled;
    };

    Site.prototype.shouldShowDeepAnalysisUpsellPromo = function() {
      return App.Utils.adminUser() && this.deep_analysis_upsell_enabled;
    };

    Site.prototype.isPayingCustomer = function() {
      return this.customer_group === this.constructor.PAYING_CUSTOMER_GROUP;
    };

    Site.prototype.isActiveTrial = function() {
      return this.customer_group === this.constructor.ACTIVE_TRIALS;
    };

    Site.prototype.dataEngineCloudAdminSite = function() {
      return this.data_engine_cloud_admin_site_enabled === true;
    };

    Site.prototype.csvDownloadAccessNone = function() {
      return this.csv_download_access === App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_NONE];
    };

    Site.prototype.csvApiAccessAdmins = function() {
      return this.csv_api_access === App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_ADMINS];
    };

    Site.prototype.csvApiAccessNone = function() {
      return this.csv_api_access === App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_NONE];
    };

    Site.prototype.usingSupercache = function() {
      return Boolean(App.Site.first().isAccountFeatureSettingEnabled('redshift-supercache') || App.Site.first().has_snowflake_cache);
    };

    Site.prototype.hasCacheDatabase = function() {
      return App.Database.findByAttribute('cache', true) != null;
    };

    Site.prototype.applyAppConnectorsUsername = function(username) {
      this.app_connectors_username = username;
      return this.save({
        ajax: false
      });
    };

    Site.prototype.anyBillingModalEnabled = function() {
      return this.manual_billing_modal_enabled || this.auto_exp_billing_modal_enabled;
    };

    Site.prototype.zuoraModalAllowed = function() {
      return this.zuora_modal_allowed;
    };

    Site.prototype.shouldShowManualBillingModal = function() {
      return this.manual_billing_modal_enabled;
    };

    Site.prototype.shouldShowAutoExpBillingModal = function() {
      return this.auto_exp_billing_modal_enabled;
    };

    Site.prototype.colorTheme = function() {
      return App.ColorTheme.exists(this.default_color_theme_id) || App.ColorTheme.PERISCOPE_DEFAULT_THEME();
    };

    Site.prototype.isAccountFeatureSettingEnabled = function(featureName) {
      return !_.isUndefined(_.find(this.enabled_customer_account_feature_settings, _.matchesProperty('feature_name', featureName)));
    };

    return Site;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SiteThemeUsageCount = (function(superClass) {
    extend(SiteThemeUsageCount, superClass);

    function SiteThemeUsageCount() {
      return SiteThemeUsageCount.__super__.constructor.apply(this, arguments);
    }

    SiteThemeUsageCount.getRecord = function(id) {
      return jQuery.ajax({
        type: 'get',
        url: "/site_theme_usage_counts/" + id
      }).done((function(_this) {
        return function(response) {
          _this.dashboardCount = response.dashboard_count;
          return _this.widgetCount = response.widget_count;
        };
      })(this));
    };

    SiteThemeUsageCount.hasCounts = function() {
      return (this.dashboardCount != null) && (this.widgetCount != null);
    };

    return SiteThemeUsageCount;

  })(Spine.Model.Ajax);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SlackTeam = (function(superClass) {
    extend(SlackTeam, superClass);

    function SlackTeam() {
      return SlackTeam.__super__.constructor.apply(this, arguments);
    }

    SlackTeam.configure('SlackTeam', 'id', 'site_id', 'team_name', 'last_update');

    SlackTeam.extend(Spine.Model.Ajax);

    SlackTeam.forSite = function(siteId) {
      return App.SlackTeam.findByAttribute('site_id', siteId);
    };

    return SlackTeam;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlAlert = (function(superClass) {
    extend(SqlAlert, superClass);

    function SqlAlert() {
      this.status = bind(this.status, this);
      return SqlAlert.__super__.constructor.apply(this, arguments);
    }

    SqlAlert.configure('SqlAlert', 'client_site_id', 'site_id', 'database_id', 'guid', 'name', 'sql', 'sql_limit', 'triggers', 'report_emails', 'user_id', 'sync_version', 'last_value', 'error_message', 'last_refreshed_at', 'last_check_failed', 'custom_schedule', 'refresh_interval_seconds', 'disabled', 'description', 'error_count', 'max_ignored_errors', 'tag_names', 'icon_color');

    SqlAlert.extend(Spine.Model.Ajax);

    SqlAlert.DEFAULT_VALUES = {
      refresh_interval_seconds: 3600,
      name: 'Untitled SQL Alert'
    };

    SqlAlert.ERROR_NO_NAME = 'Invalid Name';

    SqlAlert.ERROR_NO_SQL = 'SQL should be not empty';

    SqlAlert.ERROR_NO_EMAILS = 'alert: no emails';

    SqlAlert.ERROR_NO_TRIGGERS = 'alert: no triggers';

    SqlAlert.ERROR_UNAUTHORIZED = 'alert: unauthorized email';

    SqlAlert.ERROR_MAX_IGNORED_ERRORS = 'alert: max ignored errors';

    SqlAlert.PRETTY_CLASS_NAME = 'SQL Alert';

    SqlAlert.PRETTY_CLASS_NAME_LOWERCASE = 'SQL alert';

    SqlAlert.SIMPLE_CLASS_NAME = 'Alert';

    SqlAlert.IS_TAGGABLE = true;

    SqlAlert.Comparator = (function(a, b) {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });

    SqlAlert.status = function(view) {
      switch (false) {
        case !view.last_check_failed:
          return 'alerting';
        case view.error_message == null:
          return 'erring';
        case !view.disabled:
          return 'disabled';
        default:
          return '';
      }
    };

    SqlAlert.prototype.status = function() {
      return App.SqlAlert.status(this);
    };

    SqlAlert.prototype.getTriggerValue = function() {
      return this._getTrigger().value;
    };

    SqlAlert.prototype.hasTrigger = function() {
      return this._getTrigger() != null;
    };

    SqlAlert.prototype._getTrigger = function() {
      var ref;
      return (ref = this.triggers) != null ? ref[0] : void 0;
    };

    SqlAlert.prototype.getTriggerComparator = function() {
      return this._getTrigger().comparator;
    };

    SqlAlert.prototype.comparisonValue = function() {
      var t, val;
      t = this._getTrigger();
      if (t == null) {
        return null;
      }
      val = t.value;
      if (!((val != null) && val !== '')) {
        return null;
      }
      if (typeof val === 'string' && val.trim() === '') {
        return null;
      }
      return val;
    };

    SqlAlert.prototype.conditionAsString = function() {
      if (!this.hasTrigger()) {
        return 'Unknown';
      }
      return (this.getTriggerComparator().titleize().capitalize()) + " " + (this.getTriggerValue());
    };

    SqlAlert.prototype.getRows = function() {
      if (this.last_value != null) {
        return [[this.last_value]];
      }
    };

    SqlAlert.prototype.getColumns = function() {
      if (this.last_value != null) {
        return ['result'];
      }
    };

    SqlAlert.prototype.rowsAsHashList = function() {
      if (this.last_value != null) {
        return [
          {
            'result': this.last_value
          }
        ];
      } else {
        return [];
      }
    };

    SqlAlert.prototype.getError = function(tempHashKey) {
      var expandedSql, formulaSource, message;
      if (tempHashKey) {
        formulaSource = App.FormulaSource.findByHash(tempHashKey);
      }
      message = this.error_message || (formulaSource != null ? formulaSource.error_message : void 0);
      if (message) {
        message = App.SourceErrorMessageInterpreter.call(message);
        if (formulaSource && formulaSource.hasErrorPositions()) {
          expandedSql = formulaSource.htmlSql() || this.sql;
          message = App.ErrorMessageLineAnnotator.call(this.sql, expandedSql, formulaSource.error_pos, message, this.database().info());
        }
      }
      return message;
    };

    SqlAlert.prototype.setName = function(name) {
      SqlAlert.__super__.setName.call(this, name);
      return this.trigger('title-changed');
    };

    SqlAlert.prototype.validate = function() {
      var errors;
      errors = [];
      if (!this.hasName()) {
        errors.push(this.constructor.ERROR_NO_NAME);
      }
      if (!this.hasSql()) {
        errors.push(this.constructor.ERROR_NO_SQL);
      }
      if (!(this.hasReportEmails() && this.hasValidEmails())) {
        errors.push(this.constructor.ERROR_NO_EMAILS);
      }
      if (!this.validTrigger()) {
        errors.push(this.constructor.ERROR_NO_TRIGGERS);
      }
      if (this.hasUnauthorizedEmails()) {
        errors.push(this.constructor.ERROR_UNAUTHORIZED);
      }
      if (this.hasLongDescription()) {
        errors.push(this.constructor.ERROR_LONG_DESCRIPTION);
      }
      if (!this.hasValidMaxIgnoredErrors()) {
        errors.push(this.constructor.ERROR_MAX_IGNORED_ERRORS);
      }
      if (errors.length === 0) {
        return null;
      }
      return errors;
    };

    SqlAlert.prototype.hasName = function() {
      return this.hasField('name');
    };

    SqlAlert.prototype.hasSql = function() {
      return this.hasField('sql');
    };

    SqlAlert.prototype.hasReportEmails = function() {
      return this.hasField('report_emails');
    };

    SqlAlert.prototype.hasValidEmails = function() {
      if (!this.hasReportEmails()) {
        return false;
      }
      return _.every(this.report_emails.split(','), function(reportEmail) {
        return App.Utils.probablyAValidEmailAddress(reportEmail.trim());
      });
    };

    SqlAlert.prototype.validTrigger = function() {
      return this.hasTrigger() && this.getTriggerComparator() && !!_.trim(this.getTriggerValue());
    };

    SqlAlert.prototype.hasUnauthorizedEmails = function() {
      var unauthorized;
      if (!this.hasReportEmails()) {
        return true;
      }
      unauthorized = App.Utils.unauthorizedEmail(this.report_emails.split(','));
      return unauthorized.length > 0;
    };

    SqlAlert.prototype.hasValidMaxIgnoredErrors = function() {
      return this.hasMaxIgnoredErrors() || this.max_ignored_errors === null || this.max_ignored_errors === void 0;
    };

    SqlAlert.prototype.hasMaxIgnoredErrors = function() {
      return this.max_ignored_errors > 0;
    };

    SqlAlert.prototype.hasField = function(f) {
      return (this[f] != null) && this[f].trim().length > 0;
    };

    SqlAlert.prototype.getOwnerId = function() {
      return this.user_id;
    };

    SqlAlert.prototype.setOwnerId = function(id) {
      return this.user_id = id;
    };

    SqlAlert.prototype.destroy = function() {
      SqlAlert.__super__.destroy.apply(this, arguments);
      return App.RecentItem.removeForItem(this);
    };

    return SqlAlert;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlSnippet = (function(superClass) {
    extend(SqlSnippet, superClass);

    function SqlSnippet() {
      return SqlSnippet.__super__.constructor.apply(this, arguments);
    }

    SqlSnippet.configure('SqlSnippet', 'client_site_id', 'sql', 'guid', 'name', 'parameters', 'user_id', 'description', 'tag_names', 'server_has_invalid_name_for_git', 'icon_color');

    SqlSnippet.extend(Spine.Model.Ajax);

    SqlSnippet.ERROR_NO_NAME = 'no name';

    SqlSnippet.DUPE_NAME = 'Duplicate name';

    SqlSnippet.ILLEGAL_PARAM = 'illegal snippet param';

    SqlSnippet.ILLEGAL_PARAM_NAME = 'illegal parameterized snippet name';

    SqlSnippet.ILLEGAL_NAME = 'illegal snippet name';

    SqlSnippet.NOT_UNIQUE_PARAM = 'not unique parameters';

    SqlSnippet.NO_PARAM = 'no param';

    SqlSnippet.INVALID_FILENAME_CHARACTERS = 'Name can\'t contain < > : " \\ | ? * /';

    SqlSnippet.PRETTY_CLASS_NAME = 'SQL Snippet';

    SqlSnippet.PRETTY_CLASS_NAME_LOWERCASE = 'SQL snippet';

    SqlSnippet.SIMPLE_CLASS_NAME = 'Snippet';

    SqlSnippet.DEFAULT_VALUES = {
      name: 'Untitled SQL Snippet'
    };

    SqlSnippet.INVALID_FILENAME_REGEX = /[<>:\"\\|?*\/]/;

    SqlSnippet.IS_TAGGABLE = true;

    SqlSnippet.prototype.status = function() {};

    SqlSnippet.prototype.validate = function() {
      var errors, nameSyntaxError;
      errors = [];
      if (!this.hasName()) {
        errors.push(SqlSnippet.ERROR_NO_NAME);
      }
      if (App.ValidationHelper.dupeName(this)) {
        errors.push(SqlSnippet.DUPE_NAME);
      }
      nameSyntaxError = this.nameSyntax();
      if (nameSyntaxError != null) {
        errors.push(nameSyntaxError);
      }
      if (this.hasLongDescription()) {
        errors.push(SqlSnippet.ERROR_LONG_DESCRIPTION);
      }
      if (errors.length === 0) {
        return null;
      }
      return errors;
    };

    SqlSnippet.prototype.nameSyntax = function() {
      var i, illegalCharacterMatch, len, p, pCleaned, paramSection, paramSet, parenthesesMatch, ref, snippetName;
      if (this.name == null) {
        return;
      }
      parenthesesMatch = /.+\(.*\)$/.exec(this.name.trim());
      if (parenthesesMatch != null) {
        snippetName = this.name.trim().substring(0, this.name.indexOf('(')).trim();
        if (/[),"]/.exec(snippetName) != null) {
          return App.SqlSnippet.ILLEGAL_PARAM_NAME;
        }
        paramSection = App.SqlSnippet.getParams(this.name);
        if (paramSection.trim().length === 0) {
          return App.SqlSnippet.NO_PARAM;
        }
        illegalCharacterMatch = /[()"]/.exec(paramSection);
        if (illegalCharacterMatch != null) {
          return App.SqlSnippet.ILLEGAL_PARAM;
        }
        paramSet = {};
        ref = paramSection.split(',');
        for (i = 0, len = ref.length; i < len; i++) {
          p = ref[i];
          if (p.trim().length === 0 || /\s/.test(p.trim())) {
            return App.SqlSnippet.ILLEGAL_PARAM;
          } else {
            pCleaned = p.trim().toLowerCase();
            if (pCleaned in paramSet) {
              return App.SqlSnippet.NOT_UNIQUE_PARAM;
            }
            paramSet[pCleaned] = 1;
          }
        }
      } else {
        if (/[()",]/.test(this.name.trim())) {
          return App.SqlSnippet.ILLEGAL_NAME;
        }
      }
      if (!this.server_has_invalid_name_for_git && App.SqlSnippet.INVALID_FILENAME_REGEX.test(this.name)) {
        return App.SqlSnippet.INVALID_FILENAME_CHARACTERS;
      }
      return null;
    };

    SqlSnippet.prototype.displayName = function() {
      var ref;
      if (!(((ref = this.parameters) != null ? ref.length : void 0) > 0)) {
        return this.name;
      }
      return App.SqlSnippet.getCleanedName(this.name) + "(" + this.parameters.join(",") + ")";
    };

    SqlSnippet.prototype.setName = function(newNameWithParameters) {
      this.name = App.SqlSnippet.getCleanedName(newNameWithParameters);
      this.parameters = App.SqlSnippet.getParamsArray(newNameWithParameters);
      return this.trigger('title-changed');
    };

    SqlSnippet.prototype.getError = function() {};

    SqlSnippet.wordsForSqlHints = function() {
      var i, len, ref, results, sn;
      ref = SqlSnippet.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        sn = ref[i];
        results.push(sn.displayName());
      }
      return results;
    };

    SqlSnippet.matches = function(str) {
      var i, len, lowerStr, ref, sn;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      ref = this.all();
      for (i = 0, len = ref.length; i < len; i++) {
        sn = ref[i];
        if (("[" + (sn.name.toLowerCase()) + "]") === lowerStr) {
          return sn;
        }
      }
      return false;
    };

    SqlSnippet.matchesCurrentParameters = function(str) {
      var base;
      if (this.currentParameters == null) {
        return false;
      }
      return typeof (base = this.currentParameters).includes === "function" ? base.includes(str.toLowerCase()) : void 0;
    };

    SqlSnippet.getCurrentParameters = function() {
      if (this.currentParameters != null) {
        return [];
      }
      return this.currentParameters;
    };

    SqlSnippet.shouldUpdateCurrentParams = function(name) {
      var k, lastParams, nameMatch, p, params, paramsStr, ref, v;
      lastParams = SqlSnippet.currentParameters || [];
      SqlSnippet.currentParameters = [];
      if ((name != null ? name.length : void 0) === 0) {
        return false;
      }
      nameMatch = SqlSnippet.matchParamterizedFormat(name);
      if (nameMatch == null) {
        return lastParams.length > 0;
      }
      paramsStr = /\(.+\)$/.exec(nameMatch)[0];
      params = paramsStr.replace(/[()\s]/g, '').split(',');
      if (params.length === 0 || (typeof params.includes === "function" ? params.includes('') : void 0)) {
        return true;
      }
      ref = App.SqlBox.cachedPeriscopeSyntaxClass;
      for (k in ref) {
        v = ref[k];
        if (v === 'param' && !params.includes(k)) {
          delete App.SqlBox.cachedPeriscopeSyntaxClass[k];
        }
      }
      return SqlSnippet.currentParameters = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = params.length; i < len; i++) {
          p = params[i];
          results.push('[' + p.toLowerCase() + ']');
        }
        return results;
      })();
    };

    SqlSnippet.getCleanedName = function(name) {
      var nameMatch;
      nameMatch = this.matchParamterizedFormat(name);
      if (nameMatch == null) {
        return name;
      }
      return name.substring(0, name.indexOf('(')).trim();
    };

    SqlSnippet.extractNameFromCall = function(name) {
      var nameMatch;
      nameMatch = this.matchParameterizedFormatOnCall(name);
      if (nameMatch == null) {
        return name;
      }
      return name.substring(0, name.indexOf('(')).trim();
    };

    SqlSnippet.matchParamterizedFormat = function(name) {
      return /[^(),"\s]+\s*\([^()]+\)$/.exec(_.trim(name));
    };

    SqlSnippet.matchParameterizedFormatOnCall = function(name) {
      return /[^(),"\s]+\s*\(.+\)$/.exec(name.trim());
    };

    SqlSnippet.getParams = function(name) {
      return name.substring(name.indexOf('(')).replace(/^\(/, '').replace(/\)$/, '');
    };

    SqlSnippet.getParamsString = function(name) {
      if (name == null) {
        return '';
      }
      if (!this.matchParamterizedFormat(name)) {
        return '';
      }
      return this.getParams(name);
    };

    SqlSnippet.getParamsArray = function(name) {
      var paramsString;
      paramsString = this.getParamsString(name);
      if (!((paramsString != null ? paramsString.length : void 0) > 0)) {
        return [];
      }
      return paramsString.split(',');
    };

    SqlSnippet.prototype.getOwnerId = function() {
      return this.user_id;
    };

    SqlSnippet.prototype.setOwnerId = function(id) {
      return this.user_id = id;
    };

    SqlSnippet.prototype.destroy = function() {
      SqlSnippet.__super__.destroy.apply(this, arguments);
      return App.RecentItem.removeForItem(this);
    };

    return SqlSnippet;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlView = (function(superClass) {
    extend(SqlView, superClass);

    function SqlView() {
      this.codeSourceUpdated = bind(this.codeSourceUpdated, this);
      this.fsUpdated = bind(this.fsUpdated, this);
      return SqlView.__super__.constructor.apply(this, arguments);
    }

    SqlView.configure('SqlView', 'client_site_id', 'code', 'code_language', 'code_preview_source_hash_key', 'code_version', 'columns', 'complete_sql_for_redshift', 'database_id', 'description', 'error_count', 'guid', 'has_dataset', 'last_materializer_error', 'last_successful_materialize_at', 'last_successful_materialize_time_ms', 'last_update', 'last_updated_by_user_at', 'materialize_pending', 'name', 'next_materialize_at', 'no_cache_results', 'owner_user_id', 'preview_source_hash_key', 'published_at', 'sql', 'sql_limit', 'started_materialization_at', 'tag_names', 'user_id', 'view_schema', 'archived_at', 'archived_by_user_id', 'excluded_from_auto_archive', 'icon_color', 'schedulable', 'cache_schedule_ids');

    SqlView.extend(Spine.Model.Ajax);

    SqlView.ERROR_NO_NAME = 'no name';

    SqlView.LEADING_NUMERIC_NAME = 'Leading numerical in name';

    SqlView.DUPE_NAME = 'Duplicate name';

    SqlView.ALIAS_REGEX = /^\[(\w+) as (\w+)\]$/;

    SqlView.routeName = 'sql_views';

    SqlView.PRETTY_CLASS_NAME = 'View';

    SqlView.PRETTY_CLASS_NAME_LOWERCASE = 'view';

    SqlView.SIMPLE_CLASS_NAME = 'View';

    SqlView.DEFAULT_VALUES = {
      name: 'Untitled View',
      schedulable: {}
    };

    SqlView.IS_TAGGABLE = true;

    SqlView.prototype.destinationDatabaseId = function() {
      return this.queryFromDatabaseId != null ? this.queryFromDatabaseId : this.queryFromDatabaseId = this.fetchDestinationDatabaseId();
    };

    SqlView.prototype.fetchDestinationDatabaseId = function() {
      if (this.isCodeView() && App.Database.cacheDatabase()) {
        return App.Database.cacheDatabase().id;
      }
      return this.database_id;
    };

    SqlView.loadArchived = function(id, callback, preloadedData) {
      return jQuery.when(preloadedData || jQuery.get(App.SqlView.url(id, 'show_archived'))).done(function(response) {
        var sqlView;
        sqlView = new App.SqlView(response.SqlView);
        if (typeof callback === 'function') {
          return callback(sqlView);
        }
      });
    };

    SqlView.prototype.validate = function() {
      var errors;
      errors = [];
      this.reformatName();
      if (!this.hasName()) {
        errors.push(SqlView.ERROR_NO_NAME);
      }
      if (this.leadingNumericName()) {
        errors.push(SqlView.LEADING_NUMERIC_NAME);
      }
      if (App.ValidationHelper.dupeName(this)) {
        errors.push(SqlView.DUPE_NAME);
      }
      if (this.hasLongDescription()) {
        errors.push(SqlView.ERROR_LONG_DESCRIPTION);
      }
      if (errors.length === 0) {
        return null;
      }
      return errors;
    };

    SqlView.prototype.reformatName = function() {
      if (this.name == null) {
        return;
      }
      return this.name = this.name.replace(/[^a-zA-Z0-9_\s]/g, '').trim().replace(/\s+/g, '_').toLowerCase();
    };

    SqlView.Comparator = (function(a, b) {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });

    SqlView.prototype.displayName = function() {
      return this.name;
    };

    SqlView.prototype.fsUpdated = function(fs) {
      if (fs.hash_key !== this.preview_source_hash_key) {
        return;
      }
      App.SourceFetcher.unbind('source-updated', this.fsUpdated);
      this.trigger('update', this);
      App.SqlView.trigger('update', this);
      return this.trigger('source-updated');
    };

    SqlView.prototype.codeSourceUpdated = function(fs) {
      if (!(AppRedesign.codeInViewsEnabled() && fs.hash_key === this.code_preview_source_hash_key)) {
        return;
      }
      App.SourceFetcher.unbind('source-updated', this.codeSourceUpdated);
      this.trigger('update', this);
      App.SqlView.trigger('update', this);
      return this.trigger('source-updated');
    };

    SqlView.prototype.removeCodeConfig = function() {
      this.code = null;
      this.code_language = null;
      this.code_preview_source_hash_key = null;
      return this.code_version = null;
    };

    SqlView.prototype.fetchPreview = function() {
      if (!this.preview_source_hash_key) {
        return;
      }
      App.SourceFetcher.bind('source-updated', this.fsUpdated);
      return App.fetchSourceWithoutExplicitQuerySource(this.preview_source_hash_key);
    };

    SqlView.prototype.fetchCodeSource = function() {
      if (!this.code_preview_source_hash_key) {
        return;
      }
      App.SourceFetcher.bind('source-updated', this.codeSourceUpdated);
      return App.fetchSourceWithoutExplicitQuerySource(this.code_preview_source_hash_key);
    };

    SqlView.prototype.setCodeHashKey = function(code_preview_source_hash_key) {
      this.code_preview_source_hash_key = code_preview_source_hash_key;
    };

    SqlView.prototype.getCodeHashKey = function() {
      return this.code_preview_source_hash_key;
    };

    SqlView.prototype.cacheSchedules = function() {
      return App.CacheSchedule.select((function(_this) {
        return function(schedule) {
          return schedule.schedulable_type === _this.constructor.className && schedule.schedulable_id === _this.id && (schedule.deleted_at == null);
        };
      })(this));
    };

    SqlView.prototype.nextScheduleAt = function() {
      var ref;
      return (ref = this.cacheSchedules().first()) != null ? ref.next_at : void 0;
    };

    SqlView.prototype.codeSource = function() {
      var codeSource;
      codeSource = App.FormulaSource.findByHash(this.getCodeHashKey());
      if (!codeSource) {
        this.fetchCodeSource();
      }
      return codeSource;
    };

    SqlView.prototype.sqlSource = function() {
      var fs;
      if (this.preview_data != null) {
        return this.preview_data;
      }
      fs = App.FormulaSource.findByHash(this.preview_source_hash_key);
      if (!fs) {
        this.fetchPreview();
      }
      return fs;
    };

    SqlView.prototype.source = function() {
      return this.sqlSource();
    };

    SqlView.prototype.getColumns = function() {
      var fs;
      fs = this.sqlSource();
      if (fs == null) {
        return [];
      }
      return fs.columns;
    };

    SqlView.prototype.rowsAsHashList = function() {
      var fs;
      fs = this.sqlSource();
      if (fs == null) {
        return [];
      }
      return fs.rowsAsHashList();
    };

    SqlView.prototype.getRows = function() {
      var fs;
      fs = this.sqlSource();
      if (fs == null) {
        return [];
      }
      return fs.rows;
    };

    SqlView.prototype.setDatabase = function(databaseId) {
      var ref;
      if ((ref = App.User.currentUser()) != null) {
        ref.setLastUsedDatabase(databaseId);
      }
      return this.database_id = databaseId;
    };

    SqlView.prototype.save = function(options) {
      var result;
      if (options == null) {
        options = {};
      }
      result = SqlView.__super__.save.call(this, options);
      App.Database.clearTableCache();
      return result;
    };

    SqlView.prototype.asSchema = function() {
      var c, i, len, ref, s;
      if (!isEmpty(this.view_schema)) {
        return this.view_schema;
      }
      s = {};
      if (!this.getColumns()) {
        return s;
      }
      ref = this.getColumns();
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        s[c] = {
          is_datetime: false,
          column_name: c,
          column_type: "unknown"
        };
      }
      return s;
    };

    SqlView.refresh = function(values, options) {
      if (options == null) {
        options = {};
      }
      SqlView.__super__.constructor.refresh.call(this, values, options);
      return App.Database.clearTableCache();
    };

    SqlView.prototype.setName = function(name) {
      SqlView.__super__.setName.call(this, name);
      return this.trigger('title-changed');
    };

    SqlView.prototype.status = function() {
      return this.statusForIcon();
    };

    SqlView.prototype.statusForIcon = function() {
      return new App.SqlViewState(this).statusForIcon();
    };

    SqlView.prototype.getState = function() {
      return new App.SqlViewState(this).prettyStatus();
    };

    SqlView.prototype.getLastModifiedBy = function() {
      var user;
      user = App.User.exists(this.user_id);
      if (user && (user.abbreviatedDisplayName != null)) {
        return user.abbreviatedDisplayName();
      } else {
        return "-";
      }
    };

    SqlView.prototype.getOwnedBy = function() {
      var user;
      user = App.User.exists(this.owner_user_id);
      if (user && (user.abbreviatedDisplayName != null)) {
        return user.abbreviatedDisplayName();
      } else {
        return null;
      }
    };

    SqlView.prototype.getLastMaterialization = function() {
      var neverMaterializedText;
      neverMaterializedText = 'Never';
      if (this.last_successful_materialize_at == null) {
        return neverMaterializedText;
      }
      return moment(this.last_successful_materialize_at).fromNow();
    };

    SqlView.prototype.lastRunAt = function() {
      var date;
      if (this.last_successful_materialize_at == null) {
        return '--';
      }
      date = App.Utils.formatDateGivenDatetime(this.last_successful_materialize_at);
      return date[0] + "  " + date[1];
    };

    SqlView.prototype.sqlModifiedAt = function() {
      var date;
      if (this.last_updated_by_user_at == null) {
        return '--';
      }
      date = App.Utils.formatDateGivenDatetime(this.last_updated_by_user_at);
      return date[0] + "  " + date[1];
    };

    SqlView.prototype.getMetadata = function() {
      var metadata;
      metadata = {
        ownedBy: this.getOwnedBy(),
        lastModifiedBy: this.getLastModifiedBy()
      };
      if (this.shouldShowMaterializationMetadata(this.database_id)) {
        _.merge(metadata, {
          state: this.getState(),
          lastMaterializedAt: this.getLastMaterialization(),
          lastRunAt: this.lastRunAt(),
          sqlModifiedAt: this.sqlModifiedAt(),
          errorCount: this.error_count
        });
      }
      if (App.Site.first().schedulable_views_enabled) {
        _.merge(metadata, {
          nextRunAt: new App.SqlViewState(this).nextRunAt(),
          duration: new App.SqlViewState(this).duration(),
          schedule: new App.SqlViewState(this).schedule()
        });
      }
      return metadata;
    };

    SqlView.prototype.shouldShowMaterializationMetadata = function(database_id) {
      var db, materializeCodeViewsFromSource;
      db = App.Database.exists(database_id);
      materializeCodeViewsFromSource = this.isCodeView();
      return db && (db.canCache() || db.cache || materializeCodeViewsFromSource);
    };

    SqlView.prototype.isCodeView = function() {
      return !!((this.code != null) && App.Site.first().deep_analysis_feature_flag_enabled);
    };

    SqlView.prototype.getError = function(tempHashKey) {
      var expandedSql, formulaSource, hashOverridden, message;
      hashOverridden = (tempHashKey != null) && tempHashKey !== this.preview_source_hash_key;
      if (!hashOverridden && (this.last_materializer_error != null)) {
        return App.SqlView.remapMaterializerError(this.last_materializer_error);
      } else {
        formulaSource = hashOverridden ? App.FormulaSource.findByHash(tempHashKey) : this.sqlSource();
        message = formulaSource != null ? formulaSource.error_message : void 0;
        if (message) {
          message = App.SourceErrorMessageInterpreter.call(message);
          if (formulaSource.hasErrorPositions()) {
            expandedSql = formulaSource.htmlSql() || this.sql;
            message = App.ErrorMessageLineAnnotator.call(this.sql, expandedSql, formulaSource.error_pos, message);
          }
        }
        return message;
      }
    };

    SqlView.remapMaterializerError = function(last_materializer_error) {
      var errorMessages, formatted_error, i, len, ref;
      if (SqlView.materializerErrorMap == null) {
        SqlView.materializerErrorMap = [[/ERROR: Load into table.*failed.*Check.*system table for details/, "Cache error. Please contact Sisense Support if error persists."], [/ERROR: Manifest file is not in expected format - .* list is empty. Please check the user documentation for the correct format of manifest file during copy command/, "Temporary cache error. Please contact Sisense Support if error persists."], [/ERROR: Cannot execute query because system is in resize mode.*Detail: System is in resize mode, and ONLY read-only queries are allowed to execute./, "Could not cache due to redshift maintenance."], [/ERROR: column "column_\d+" does not exist in.*/, "Unnamed columns are not supported in SQL Views"]];
      }
      formatted_error = last_materializer_error;
      ref = SqlView.materializerErrorMap;
      for (i = 0, len = ref.length; i < len; i++) {
        errorMessages = ref[i];
        if (errorMessages[0].test(last_materializer_error)) {
          formatted_error = errorMessages[1];
          break;
        }
      }
      return formatted_error;
    };

    SqlView.allAsSchema = function() {
      var i, len, ref, s, sv;
      s = {};
      ref = this.recordsValues();
      for (i = 0, len = ref.length; i < len; i++) {
        sv = ref[i];
        s[sv.name] = {
          is_view: true,
          columns: sv.asSchema()
        };
      }
      return s;
    };

    SqlView.getAllViewsWithColumnNameMatchingQuery = function(searchStr) {
      var allViews, columnName, columnProps, columnTokens, i, len, matchesQuery, matchingViews, queryTokens, ref, view, viewHasMatchingColumn;
      allViews = SqlView.allSortedByName();
      if (_.isEmpty(_.trim(searchStr))) {
        return allViews;
      }
      queryTokens = App.Utils.tokenizeString(searchStr);
      matchingViews = [];
      for (i = 0, len = allViews.length; i < len; i++) {
        view = allViews[i];
        viewHasMatchingColumn = false;
        ref = view.view_schema;
        for (columnName in ref) {
          columnProps = ref[columnName];
          columnTokens = App.Utils.tokenizeString(columnName);
          matchesQuery = (columnName.indexOf(searchStr) !== -1) || App.Utils.matchesQuery(queryTokens, columnTokens);
          view.view_schema[columnName].matches_query = matchesQuery;
          if (matchesQuery) {
            viewHasMatchingColumn = true;
          }
        }
        if (viewHasMatchingColumn) {
          matchingViews.push(view);
        }
      }
      return matchingViews;
    };

    SqlView.findMaterializedSqlViewsInCompleteSql = function(sql) {
      var matches, name, re, views;
      sql = sql.toLowerCase();
      re = /periscope_views."([^"]+)"/ig;
      views = [];
      while ((matches = re.exec(sql)) != null) {
        views.push(matches[1]);
      }
      return ((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = views.length; i < len; i++) {
          name = views[i];
          results.push(App.SqlView.findByAttribute('name', name));
        }
        return results;
      })()).without(null);
    };

    SqlView.prettyErrorMessage = function(error) {
      switch (error) {
        case App.SqlView.ERROR_NO_NAME:
          return 'Invalid name';
        case App.SqlView.LEADING_NUMERIC_NAME:
          return 'Name cannot start with a number';
        case App.SqlView.DUPE_NAME:
          return 'Name conflict';
        default:
          return null;
      }
    };

    SqlView.wordsForSqlHints = function() {
      var i, len, ref, results, sn;
      ref = SqlView.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        sn = ref[i];
        results.push(sn.name);
      }
      return results;
    };

    SqlView.matches = function(str) {
      var i, j, len, len1, lowerStr, match, ref, ref1, sn, viewName;
      if (typeof str !== 'string') {
        return false;
      }
      lowerStr = str.toLowerCase();
      if (lowerStr.indexOf(" as ") >= 1 && (match = lowerStr.match(App.SqlView.ALIAS_REGEX))) {
        viewName = match[1];
        ref = this.all();
        for (i = 0, len = ref.length; i < len; i++) {
          sn = ref[i];
          if (sn.name === viewName) {
            return sn;
          }
        }
      } else {
        ref1 = this.all();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          sn = ref1[j];
          if (("[" + sn.name + "]") === lowerStr) {
            return sn;
          }
        }
      }
      return false;
    };

    SqlView.prototype.cacheDisabled = function() {
      var db;
      db = App.Database.exists(this.database_id);
      if (!db) {
        return true;
      }
      return !db.cache_enabled;
    };

    SqlView.prototype.numErrors = function() {
      return this.error_count || 0;
    };

    SqlView.prototype.isFailed = function() {
      return this.numErrors() >= 10;
    };

    SqlView.prototype.isErring = function() {
      return (this.numErrors() > 0 && this.numErrors() < 10) || (this.numErrors() < 20 && (this.last_materializer_error != null) && this.last_materializer_error.indexOf("Search path doesn't exist") !== -1);
    };

    SqlView.prototype.isSuccessful = function() {
      return this.numErrors() === 0 && (this.last_successful_materialize_at != null);
    };

    SqlView.prototype.getAllParents = function(seenViews) {
      if (seenViews == null) {
        seenViews = {};
      }
      return [this.id].concat(App.SqlView.getAllParents(this.complete_sql_for_redshift, seenViews));
    };

    SqlView.getAllParents = function(sql, seenViews) {
      var allParents, i, len, ref, view;
      if (seenViews == null) {
        seenViews = {};
      }
      allParents = [];
      ref = App.SqlView.findMaterializedSqlViewsInCompleteSql(sql);
      for (i = 0, len = ref.length; i < len; i++) {
        view = ref[i];
        if ((view != null) && !seenViews[view.name]) {
          seenViews[view.name] = true;
          allParents.push.apply(allParents, view.getAllParents(seenViews));
        }
      }
      return allParents.unique();
    };

    SqlView.prototype.getOwnerId = function() {
      return this.owner_user_id;
    };

    SqlView.prototype.setOwnerId = function(id) {
      return this.owner_user_id = id;
    };

    SqlView.prototype.destroy = function() {
      SqlView.__super__.destroy.apply(this, arguments);
      return App.RecentItem.removeForItem(this);
    };

    SqlView.prototype.hasDataset = function() {
      return App.Dataset.datasetId(this.id, this.constructor.className) != null;
    };

    SqlView.prototype.previewColumns = function() {
      var columnInfo, columnName, ref, ret;
      ret = [];
      ref = this.view_schema;
      for (columnName in ref) {
        columnInfo = ref[columnName];
        ret.push({
          columnName: columnName,
          type: App.Dataset.simplifiedTypeFromDatabaseType(columnInfo.column_type)
        });
      }
      return ret;
    };

    return SqlView;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlViewDataExport = (function(superClass) {
    extend(SqlViewDataExport, superClass);

    function SqlViewDataExport() {
      return SqlViewDataExport.__super__.constructor.apply(this, arguments);
    }

    SqlViewDataExport.configure('SqlViewDataExport', 'client_site_id', 'completed_at', 'database_id', 'destination_s3_bucket_name', 'destination_s3_key', 'destination_s3_region', 'error_msg', 'export_started_at', 'site_id', 'sql_query', 'sql_view_id', 'view_name');

    SqlViewDataExport.extend(Spine.Model.Ajax);

    SqlViewDataExport.prototype.getDataDestination = function() {
      return "https://console.aws.amazon.com/sagemaker/home";
    };

    SqlViewDataExport.prototype.readyForDownload = function() {
      return !(_.isNil(this.completed_at) && _.isNil(this.getError()));
    };

    SqlViewDataExport.prototype.getError = function() {
      return this.error_msg;
    };

    SqlViewDataExport.prototype.itemType = function() {
      return App.SqlViewDataExport.className;
    };

    SqlViewDataExport.prototype.displayName = function() {
      if (!this.readyForDownload()) {
        return 'Preparing S3 Export';
      }
      return this.destination_s3_key;
    };

    SqlViewDataExport.prototype.getStartedAt = function() {
      return this.export_started_at;
    };

    return SqlViewDataExport;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SshTunnel = (function(superClass) {
    extend(SshTunnel, superClass);

    function SshTunnel() {
      return SshTunnel.__super__.constructor.apply(this, arguments);
    }

    SshTunnel.configure('SshTunnel', 'client_site_id', 'id', 'database_port', 'local_port', 'ssh_host', 'ssh_username', 'ssh_port', 'database_host');

    SshTunnel.extend(Spine.Model.Ajax);

    return SshTunnel;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SsoConfig = (function(superClass) {
    extend(SsoConfig, superClass);

    function SsoConfig() {
      return SsoConfig.__super__.constructor.apply(this, arguments);
    }

    SsoConfig.configure('SsoConfig', 'id', 'client_site_id', 'site_id', 'site_family_id', 'identity_provider_type', 'identity_provider_issuer', 'identity_provider_sso_url', 'identity_provider_slo_url', 'identity_provider_cert', 'idp_scim_enabled', 'idp_scim_alerts_emails', 'skip_logout', 'identifier');

    SsoConfig.extend(Spine.Model.Ajax);

    SsoConfig.optionsForSamlProvider = function() {
      return [
        {
          value: "okta",
          name: "Okta"
        }, {
          value: "onelogin",
          name: "OneLogin"
        }, {
          value: "google",
          name: "Google Apps"
        }, {
          value: "azure",
          name: "Azure Active Directory"
        }, {
          value: "disabled",
          name: "Disabled"
        }
      ];
    };

    return SsoConfig;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.StarredItem = (function(superClass) {
    extend(StarredItem, superClass);

    function StarredItem() {
      return StarredItem.__super__.constructor.apply(this, arguments);
    }

    StarredItem.configure('StarredItem', 'client_site_id', 'item_type', 'item_id', 'user_role_id');

    StarredItem.extend(Spine.Model.Ajax);

    StarredItem.createFromRecord = function(model) {
      return this.create({
        item_id: model.id,
        item_type: model.constructor.className
      });
    };

    StarredItem.getStarForCurrentUser = function(model) {
      if (model == null) {
        return;
      }
      return App.StarredItem.select(_.matches({
        item_id: model.id,
        item_type: model.constructor.className
      })).first();
    };

    StarredItem.prototype.destroyIfReady = function() {
      if (this.readyToBeDestroyed()) {
        return this.destroy();
      }
    };

    StarredItem.prototype.destroy = function() {
      return StarredItem.__super__.destroy.call(this, {
        ajax: false
      });
    };

    StarredItem.url = function() {
      return '/starred_item';
    };

    StarredItem.prototype.url = function() {
      return this.constructor.url();
    };

    StarredItem.toggleStarred = function(model, starState) {
      var star;
      star = this.getStarForCurrentUser(model);
      if (starState) {
        if (star == null) {
          return this.createFromRecord(model);
        }
      } else {
        return star.destroyIfReady();
      }
    };

    StarredItem.prototype.item = function() {
      return App[this.item_type].find(this.item_id);
    };

    return StarredItem;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableHarvest = (function(superClass) {
    extend(TableHarvest, superClass);

    function TableHarvest() {
      return TableHarvest.__super__.constructor.apply(this, arguments);
    }

    TableHarvest.configure('TableHarvest', 'client_site_id', 'id', 'database_id', 'schema_name', 'table_name', 'ingest_key', 'next_harvest_at', 'next_full_harvest_at', 'next_update_harvest_at', 'harvest_interval_seconds', 'full_harvest_custom_schedule', 'full_harvest_interval_seconds', 'sort_keys', 'ingest_key_type', 'next_yoink_type', 'pretty_error', 'disabled_at', 'error_count', 'locked_by', 'last_harvest_msec', 'last_successful_harvest_at', 'last_successful_full_harvest_at', 'last_successful_incremental_harvest_at', 'last_full_harvest_msec', 'last_incremental_harvest_msec', 'update_harvest_interval_seconds', 'update_date_range', 'uses_diff_strategy', 'unique_id_column', 'updated_at_can_be_null', 'created_at_column');

    TableHarvest.extend(Spine.Model.Ajax);

    TableHarvest.STRATEGIES = {
      BOUNDED_UPDATES: 'update',
      FULL_AND_INCREMENTAL: 'full-and-incremental',
      FULL_ONLY: 'full-only',
      INCREMENTAL_ONLY: 'incremental-only',
      MODIFIED_ONLY: 'diff'
    };

    TableHarvest.prototype.save = function(params) {
      if (params == null) {
        params = {
          ajax: false
        };
      }
      return TableHarvest.__super__.save.call(this, params);
    };

    TableHarvest.prototype.destroy = function(params) {
      if (params == null) {
        params = {
          ajax: false
        };
      }
      return TableHarvest.__super__.destroy.call(this, params);
    };

    TableHarvest.prototype.validate = function() {
      if (this.importColumnIsNone()) {
        return;
      }
      if (this.isModifiedOnly()) {
        if (this.isMissingIngestKey()) {
          return "Modified Date required";
        } else if (this.isMissingUniqueID()) {
          return "Unique ID required";
        } else if (this.isMissingCreatedColumn()) {
          return "Created Date required";
        }
      } else if (this.isMissingIngestKey()) {
        return "Ingest Key required";
      }
    };

    TableHarvest.prototype.importColumnIsNone = function() {
      var ref;
      return ((ref = this.database()) != null ? ref.isRedshift() : void 0) && this.isFullOnly();
    };

    TableHarvest.prototype.isMissingIngestKey = function() {
      return this.isBlank('ingest_key');
    };

    TableHarvest.prototype.isMissingUniqueID = function() {
      return this.isBlank('unique_id_column');
    };

    TableHarvest.prototype.isMissingCreatedColumn = function() {
      return this.updated_at_can_be_null === true && this.isBlank('created_at_column');
    };

    TableHarvest.prototype.isBlank = function(key) {
      return (this[key] == null) || this[key] === '';
    };

    TableHarvest.prototype.getStrategy = function() {
      return this.clientSideStrategy || this.getSavedStrategy();
    };

    TableHarvest.prototype.getSavedStrategy = function() {
      if (this.isNew()) {
        return "";
      } else if (this.uses_diff_strategy) {
        return this.constructor.STRATEGIES.MODIFIED_ONLY;
      } else if ((this.harvest_interval_seconds === this.full_harvest_interval_seconds) || (this.harvest_interval_seconds == null)) {
        return this.constructor.STRATEGIES.FULL_ONLY;
      } else if (this.update_harvest_interval_seconds > 0) {
        return this.constructor.STRATEGIES.BOUNDED_UPDATES;
      } else if (this.full_harvest_interval_seconds === 0 && (this.full_harvest_custom_schedule == null)) {
        return this.constructor.STRATEGIES.INCREMENTAL_ONLY;
      } else {
        return this.constructor.STRATEGIES.FULL_AND_INCREMENTAL;
      }
    };

    TableHarvest.prototype.isModifiedOnly = function() {
      return this.getStrategy() === this.constructor.STRATEGIES.MODIFIED_ONLY;
    };

    TableHarvest.prototype.isFullOnly = function() {
      return this.getStrategy() === this.constructor.STRATEGIES.FULL_ONLY;
    };

    TableHarvest.prototype.isIncrementalOnly = function() {
      return this.getStrategy() === this.constructor.STRATEGIES.INCREMENTAL_ONLY;
    };

    TableHarvest.prototype.isFullAndIncremental = function() {
      return this.getStrategy() === this.constructor.STRATEGIES.FULL_AND_INCREMENTAL;
    };

    TableHarvest.prototype.isBoundedUpdates = function() {
      return this.getStrategy() === this.constructor.STRATEGIES.BOUNDED_UPDATES;
    };

    TableHarvest.prototype.fullName = function() {
      return this.schema_name + "." + this.table_name;
    };

    TableHarvest.prototype.nextUpdateText = function() {
      var diff_msec;
      if (this.next_harvest_at == null) {
        return "not scheduled";
      }
      diff_msec = Date.parse(this.next_harvest_at) - (new Date).getTime();
      if (diff_msec < 0) {
        return "soon";
      } else {
        return "in " + (App.Utils.roundedAgo(diff_msec));
      }
    };

    TableHarvest.lastUpdateText = function(value) {
      return App.Utils.roundedAgoFromDateString(value, "ago");
    };

    TableHarvest.lastRuntimeText = function(value) {
      var diff_msec;
      if (!((value != null) && value)) {
        return null;
      }
      diff_msec = value;
      if (diff_msec < 0) {
        return "Unknown";
      } else {
        return App.Utils.roundedAgo(diff_msec);
      }
    };

    TableHarvest.prototype.status = function() {
      if (this.disabled_at != null) {
        return 'disabled';
      } else if (this.pretty_error === 'Permission denied') {
        return 'permission-denied';
      } else if (this.error_count > 9) {
        return 'failed';
      } else if (this.error_count > 0) {
        return 'warning';
      } else if (this.locked_by != null) {
        return 'running';
      } else if (Date.parse(this.next_harvest_at) > (new Date).getTime()) {
        return 'waiting';
      } else if ((this.next_full_harvest_at != null) && Date.parse(this.next_full_harvest_at) < (new Date).getTime()) {
        return 'queued';
      } else if ((this.next_update_harvest_at != null) && Date.parse(this.next_update_harvest_at) < (new Date).getTime()) {
        return 'queued';
      } else {
        return 'queued';
      }
    };

    TableHarvest.findByFullName = function(databaseId, fullName) {
      var i, len, ref, th;
      ref = this.all();
      for (i = 0, len = ref.length; i < len; i++) {
        th = ref[i];
        if (th.database_id === databaseId && th.fullName() === fullName) {
          return th;
        }
      }
      return null;
    };

    return TableHarvest;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Tag = (function(superClass) {
    extend(Tag, superClass);

    function Tag() {
      return Tag.__super__.constructor.apply(this, arguments);
    }

    Tag.configure('Tag', 'client_site_id', 'name', 'user_id', 'site_id', 'special');

    Tag.extend(Spine.Model.Ajax);

    Tag.RESERVED_TAG_NAMES = ['mine', ''];

    Tag.MINE_TAG_SPECIAL = 'mine';

    Tag.prototype.validatationError = function() {
      var i, len, ref, tag;
      if ((this.name == null) || this.name === '') {
        return 'Tag name cannot be blank.';
      }
      if (this.name.indexOf(' ') !== -1) {
        return 'Tag name cannot contain spaces.';
      }
      if (this.reservedTag()) {
        return this.name + " is a reserved tag name.";
      }
      ref = App.Tag.all();
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        if (tag.name.toLowerCase() === this.name.toLowerCase()) {
          return 'Tag name must be unique.';
        }
      }
      return null;
    };

    Tag.allSortedByName = function() {
      return App.Tag.all().sort(function(a, b) {
        return App.Utils.sortAlphanumericComparator(a.name, b.name);
      });
    };

    Tag.tagsInString = function(str) {
      var hashTags, queryTokens, searchTerms;
      queryTokens = str.split(' ').tokenize();
      hashTags = queryTokens.filter(function(t) {
        return t[0] === '#';
      });
      searchTerms = hashTags.map(function(h) {
        return h.substring(1);
      });
      return this.tagsFromSearchTerms(searchTerms);
    };

    Tag.matchesPrefix = function(searchTerms, tagName) {
      var i, len, searchTerm;
      for (i = 0, len = searchTerms.length; i < len; i++) {
        searchTerm = searchTerms[i];
        if (tagName.indexOf(searchTerm) === 0) {
          return true;
        }
      }
      return false;
    };

    Tag.tagsFromSearchTerms = function(searchTerms) {
      searchTerms = searchTerms.without('');
      return App.Tag.select(function(tag) {
        return App.Tag.matchesPrefix(searchTerms, tag.name.toLowerCase());
      });
    };

    Tag.invalidTag = function(tags, searchTerms) {
      var i, j, len, len1, searchTerm, tag, tagMatch;
      if (searchTerms.length === 0) {
        return false;
      }
      for (i = 0, len = searchTerms.length; i < len; i++) {
        searchTerm = searchTerms[i];
        tagMatch = false;
        for (j = 0, len1 = tags.length; j < len1; j++) {
          tag = tags[j];
          if (tag.name.toLowerCase().indexOf(searchTerm) === 0) {
            tagMatch = true;
            break;
          }
        }
        if (tagMatch) {
          return false;
        }
      }
      return true;
    };

    Tag.tagIdsFromSearchTerms = function(searchTerms) {
      var i, j, len, len1, searchTerm, searchToTag, searchToTags, tag, tags;
      searchTerms = searchTerms.without('');
      tags = this.tagsFromSearchTerms(searchTerms);
      searchToTags = [];
      for (i = 0, len = searchTerms.length; i < len; i++) {
        searchTerm = searchTerms[i];
        searchToTag = [];
        for (j = 0, len1 = tags.length; j < len1; j++) {
          tag = tags[j];
          if (tag.name.toLowerCase().indexOf(searchTerm) === 0 && (tag.special == null)) {
            searchToTag.push('' + tag.id);
          }
        }
        if (searchToTag.length > 0) {
          searchToTags.push(searchToTag);
        }
      }
      return searchToTags;
    };

    Tag.prototype.reservedTag = function() {
      if (this.name == null) {
        return false;
      }
      return App.Tag.RESERVED_TAG_NAMES.includes(this.name.toLowerCase());
    };

    return Tag;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TagStar = (function(superClass) {
    extend(TagStar, superClass);

    function TagStar() {
      return TagStar.__super__.constructor.apply(this, arguments);
    }

    TagStar.configure('TagStar', 'client_site_id', 'user_id', 'site_id', 'tag_id');

    TagStar.extend(Spine.Model.Ajax);

    TagStar.starMap = function() {
      var i, len, ref, starMap, ts;
      starMap = {};
      ref = App.TagStar.all();
      for (i = 0, len = ref.length; i < len; i++) {
        ts = ref[i];
        starMap[ts.tag_id] = true;
      }
      return starMap;
    };

    return TagStar;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TextBox = (function(superClass) {
    extend(TextBox, superClass);

    function TextBox() {
      return TextBox.__super__.constructor.apply(this, arguments);
    }

    TextBox.configure('TextBox', 'client_site_id', 'text_data');

    TextBox.extend(Spine.Model.Ajax);

    TextBox.url = '/text_boxes';

    TextBox.prototype.getName = function() {
      return "TextBox" + this.id.toString();
    };

    TextBox.prototype.flash = function() {
      return this.trigger('flash');
    };

    TextBox.prototype.getRawText = function() {
      return window.reactApp.getTextBoxRawText(this.text_data);
    };

    return TextBox;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.User = (function(superClass) {
    var NullCurrentUser;

    extend(User, superClass);

    function User() {
      return User.__super__.constructor.apply(this, arguments);
    }

    User.configure('User', 'client_site_id', 'email_address', 'first_name', 'last_name', 'roles_info', 'periscope_admin', 'current_user', 'must_change_password', 'is_tfa_active', 'preferences', 'experiment', 'password_changed_at', 'last_login', 'chart_tutorial_completed_at', 'department', 'job_title', 'use_case', 'self_service_dashboards_access', 'workbooks_access', 'sessions');

    User.extend(Spine.Model.Ajax);

    User.USERS_SEARCH_API_ENABLED = 'users-search-api';

    User.CurrentUserCanEdit = function() {
      return this.currentUser().canEdit();
    };

    User.currentUserId = function() {
      var ref;
      return (ref = this.currentUser()) != null ? ref.id : void 0;
    };

    User.currentUser = function() {
      var currentApp;
      currentApp = AppRedesign.current();
      if (!currentApp) {
        return;
      }
      return currentApp.currentUser != null ? currentApp.currentUser : currentApp.currentUser = _.find(this.records, 'current_user');
    };

    User.safeCurrentUser = function() {
      var ref;
      return (ref = this.currentUser()) != null ? ref : new NullCurrentUser();
    };

    NullCurrentUser = (function() {
      function NullCurrentUser() {}

      NullCurrentUser.prototype.isAdmin = _.stubFalse;

      return NullCurrentUser;

    })();

    User.prototype.displayName = function() {
      var fullName;
      fullName = this.fullName();
      if (fullName !== '') {
        return fullName;
      }
      return this.email_address;
    };

    User.prototype.abbreviatedDisplayName = function() {
      var nameParts;
      nameParts = [];
      if (this.first_name != null) {
        nameParts.push(this.first_name);
        if (this.last_name != null) {
          nameParts.push(this.last_name[0] + ".");
        }
      } else if (this.last_name != null) {
        nameParts.push(this.last_name);
      } else {
        nameParts.push(this.email_address);
      }
      return nameParts.join(' ').trim();
    };

    User.prototype.fullName = function() {
      var names;
      names = [];
      if (this.first_name != null) {
        names.push(this.first_name);
      }
      if (this.last_name != null) {
        names.push(this.last_name);
      }
      return names.join(' ').trim();
    };

    User.prototype.dashboards = function(includeUnowned) {
      var d, i, len, ref, results;
      if (includeUnowned == null) {
        includeUnowned = false;
      }
      ref = App.Dashboard.allSortedByName();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        if (d.user_id === this.id || (includeUnowned && d.user_id === null)) {
          results.push(d);
        }
      }
      return results;
    };

    User.prototype.writeableDashboards = function() {
      var d, i, len, ref, results;
      ref = App.Dashboard.allSortedByName();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        if (d.isEditableByCurrentUser()) {
          results.push(d);
        }
      }
      return results;
    };

    User.prototype.stars = function() {
      var i, len, ref, results, s;
      ref = App.DashboardStar.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        s = ref[i];
        if (s.user_id === this.id) {
          results.push(s);
        }
      }
      return results;
    };

    User.prototype.isConnectedToDashboard = function(dashboard) {
      var s;
      if (!((dashboard != null) && this.isReal())) {
        return false;
      }
      if (dashboard.user_id === this.id) {
        return true;
      }
      if (((function() {
        var i, len, ref, results;
        ref = dashboard.stars();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          s = ref[i];
          if (s.user_id === this.id) {
            results.push(s);
          }
        }
        return results;
      }).call(this)).length > 0) {
        return true;
      }
      return false;
    };

    User.prototype.isTfaUser = function() {
      return this.is_tfa_active;
    };

    User.prototype.currentRole = function() {
      var i, len, ref, role;
      if (this.roles_info.length === 1) {
        return this.roles_info.first();
      }
      ref = this.roles_info;
      for (i = 0, len = ref.length; i < len; i++) {
        role = ref[i];
        if (role.site_id === App.Site.first().id) {
          return role;
        }
      }
      return null;
    };

    User.prototype.canSwitchSites = function() {
      return this.roles_info.length > 1;
    };

    User.prototype.allSites = function() {
      var currentSiteId, sites;
      currentSiteId = App.Site.first().id;
      sites = _.map(this.roles_info, function(role) {
        return {
          current: role.site_id === currentSiteId,
          host: role.site_host,
          id: role.site_id,
          name: role.site_name
        };
      });
      return App.Utils.sortByPropertyString(sites, 'name');
    };

    User.prototype.accessibleSitesInFamily = function() {
      var accessibleSiteIds, accessibleSites, i, isAdmin, len, site, sitesInFamily;
      accessibleSiteIds = this.roles_info.map(function(role) {
        return role.site_id;
      });
      sitesInFamily = App.Site.first().site_info_list;
      accessibleSites = [];
      isAdmin = this.isAdmin();
      for (i = 0, len = sitesInFamily.length; i < len; i++) {
        site = sitesInFamily[i];
        if (accessibleSiteIds.includes(site.id) || isAdmin) {
          accessibleSites.push({
            id: site.id,
            host: site.host,
            display_name: site.display_name,
            is_current_site: site.id === App.Site.first().id
          });
        }
      }
      return accessibleSites;
    };

    User.prototype.revokeAccess = function() {
      jQuery.post("/users/revoke_access/", {
        user_id: this.id,
        client_site_id: App.Site.first().id
      });
      return this.destroy({
        ajax: false
      });
    };

    User.prototype.revokeAccessAllSites = function(directoryHelper) {
      var i, len, ref, ref1, ref2, siteUserRole;
      jQuery.post("/users/revoke_access_all_sites/", {
        user_id: this.id,
        client_site_id: App.Site.first().id
      });
      ref = directoryHelper.sitesForUser(this.id);
      for (i = 0, len = ref.length; i < len; i++) {
        siteUserRole = ref[i];
        if (((ref1 = siteUserRole.site) != null ? ref1.site_family_id : void 0) !== ((ref2 = App.Site.first()) != null ? ref2.site_family_id : void 0)) {
          continue;
        }
        siteUserRole.userRole.destroy({
          ajax: false
        });
      }
      return this.destroy({
        ajax: false
      });
    };

    User.prototype.lastUsedDatabase = function() {
      var ref;
      return (ref = this.currentRole()) != null ? ref.last_used_database_id : void 0;
    };

    User.prototype.setLastUsedDatabase = function(database_id) {
      var cr;
      cr = this.currentRole();
      if (cr == null) {
        return;
      }
      cr.last_used_database_id = database_id;
      this.save({
        ajax: false
      });
      return jQuery.post("/users/set_last_used_database/", {
        database_id: database_id,
        client_site_id: App.Site.first().id
      });
    };

    User.prototype.savePreferences = function() {
      this.save({
        ajax: false
      });
      return jQuery.ajax({
        url: '/users/update_preferences/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          preferences: this.preferences,
          client_site_id: App.Site.first().id
        }),
        dataType: 'json'
      });
    };

    User.prototype.shouldShowLeftNavSettingsUpsellTooltip = function() {
      var ref, ref1, ref2;
      if (!App.Utils.adminUser()) {
        return false;
      }
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        return !((ref = this.preferences) != null ? ref.left_nav_settings_upsell_tooltip_seen_deep_analysis : void 0);
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        return !((ref1 = this.preferences) != null ? ref1.left_nav_settings_upsell_tooltip_seen_waas : void 0);
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        return !((ref2 = this.preferences) != null ? ref2.left_nav_settings_upsell_tooltip_seen_embed : void 0);
      } else {
        return false;
      }
    };

    User.prototype.shouldShowLeftNavSettingsPromoIndicator = function() {
      var ref, ref1, ref2;
      if (!App.Utils.adminUser()) {
        return false;
      }
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        return !((ref = this.preferences) != null ? ref.deep_analysis_upsell_promo_seen : void 0);
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        return !((ref1 = this.preferences) != null ? ref1.waas_features_promo_seen : void 0);
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        return !((ref2 = this.preferences) != null ? ref2.embed_upsell_promo_seen : void 0);
      } else {
        return false;
      }
    };

    User.prototype.markLeftNavSettingsUpsellTooltipSeenDeepAnalysis = function() {
      var ref;
      if (!((ref = this.preferences) != null ? ref.left_nav_settings_upsell_tooltip_seen_deep_analysis : void 0)) {
        this.preferences.left_nav_settings_upsell_tooltip_seen_deep_analysis = true;
        return this.savePreferences();
      }
    };

    User.prototype.markLeftNavSettingsUpsellTooltipSeenWaas = function() {
      var ref;
      if (!((ref = this.preferences) != null ? ref.left_nav_settings_upsell_tooltip_seen_waas : void 0)) {
        this.preferences.left_nav_settings_upsell_tooltip_seen_waas = true;
        return this.savePreferences();
      }
    };

    User.prototype.markLeftNavSettingsUpsellTooltipSeenEmbed = function() {
      var ref;
      if (!((ref = this.preferences) != null ? ref.left_nav_settings_upsell_tooltip_seen_embed : void 0)) {
        this.preferences.left_nav_settings_upsell_tooltip_seen_embed = true;
        return this.savePreferences();
      }
    };

    User.prototype.setLastUsedCodeSetting = function(code_language, code_version) {
      if (this.preferences != null) {
        if (this.preferences.code_language !== code_language || this.preferences.code_version !== code_version) {
          this.preferences.code_language = code_language;
          this.preferences.code_version = code_version;
          return this.savePreferences();
        }
      }
    };

    User.prototype.updateTopicGridListView = function(listViewTopicIds) {
      if (this.preferences != null) {
        this.preferences.list_view_topic_ids = listViewTopicIds;
        return this.savePreferences();
      }
    };

    User.prototype.getLastUsedCodeLanguage = function() {
      var ref;
      return (ref = this.preferences) != null ? ref.code_language : void 0;
    };

    User.prototype.getLastUsedCodeVersion = function() {
      var ref;
      return (ref = this.preferences) != null ? ref.code_version : void 0;
    };

    User.prototype.setLastUsedDatasetId = function(dataset_id) {
      if ((this.preferences != null) && this.preferences.dataset_id !== dataset_id) {
        this.preferences.dataset_id = dataset_id;
        return this.savePreferences();
      }
    };

    User.prototype.getLastUsedDatasetId = function() {
      var ref;
      return (ref = this.preferences) != null ? ref.dataset_id : void 0;
    };

    User.prototype.isReal = function() {
      return parseInt(this.id) === this.id;
    };

    User.prototype.isTemporary = function() {
      var ref;
      return (ref = this.currentRole()) != null ? ref.temporary : void 0;
    };

    User.prototype.isCurrentUser = function() {
      return this.current_user;
    };

    User.prototype.mustChangePassword = function() {
      return this.must_change_password;
    };

    User.prototype.searchTokens = function() {
      var tokens;
      tokens = [];
      if (this.first_name != null) {
        tokens.push(this.first_name);
      }
      if (this.last_name != null) {
        tokens.push(this.last_name);
      }
      if (this.email_address != null) {
        tokens.push(this.email_address);
      }
      return tokens.tokenize();
    };

    User.prototype.isAdmin = function() {
      return this.periscope_admin || this.isSiteAdmin();
    };

    User.prototype.isAdminWithEditPrivilege = function() {
      return (!App.Site.first().restrict_periscope_admins && this.periscope_admin) || this.isSiteAdmin();
    };

    User.prototype.isSiteAdmin = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacSiteAdmin || this.isSpaceAdmin();
      } else {
        return this.inGroupWithProperty(function(group) {
          return group.admin;
        });
      }
    };

    User.prototype.isSpaceAdmin = function() {
      return AppRedesign.current().state.RbacEnabled && AppRedesign.current().state.RbacSpaceAdmin;
    };

    User.prototype.canQuery = function(database_id) {
      var canQuery;
      canQuery = this.canEdit() && App.Database.exists(database_id);
      if (AppRedesign.current().state.RbacEnabled && canQuery) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      }
      return canQuery;
    };

    User.prototype.canEdit = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      if (this.isAdminWithEditPrivilege()) {
        return true;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return this.inGroupRoleWithProperty(function(groupRole) {
          return groupRole.can_edit;
        });
      }
    };

    User.prototype.canExplore = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      if (this.isAdmin()) {
        return true;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createDiscoveryChartsEnabled();
      } else {
        return this.inGroupRoleWithProperty(function(groupRole) {
          return groupRole.can_edit || groupRole.can_drag_and_drop;
        });
      }
    };

    User.prototype.inGroupWithProperty = function(conditionFunc) {
      var group, i, len, membership, ref;
      ref = App.GroupMembership.all();
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        if (membership.user_id !== this.id) {
          continue;
        }
        group = App.Group.exists(membership.group_id);
        if (!group) {
          continue;
        }
        if (conditionFunc(group)) {
          return true;
        }
      }
      return false;
    };

    User.prototype.inGroupRoleWithProperty = function(conditionFunc) {
      var currentSiteId, groupIds, groupRole, i, j, len, len1, membership, ref, ref1;
      groupIds = [];
      ref = App.GroupMembership.all();
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        if (membership.user_id !== this.id) {
          continue;
        }
        groupIds.push(membership.group_id);
      }
      currentSiteId = App.Site.first().id;
      ref1 = App.GroupRole.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        groupRole = ref1[j];
        if (!(groupRole.site_id === currentSiteId && groupIds.includes(groupRole.group_id))) {
          continue;
        }
        if (conditionFunc(groupRole)) {
          return true;
        }
      }
      return false;
    };

    User.prototype.userInfo = function(groupToPermissionMap, userToGroups, ownerCache) {
      var groupCount, info;
      groupCount = (userToGroups != null ? userToGroups[this.id] : void 0) != null ? Object.keys(userToGroups[this.id]).length : 0;
      info = {
        first_name: this.first_name,
        last_name: this.last_name,
        display_name: this.fullName(),
        email: this.email_address,
        group_count: groupCount,
        spaces_count: 0,
        dashboard_count: this.getDashboardCount(groupToPermissionMap, userToGroups, ownerCache),
        last_site_login: App.TimeMachine.parseDateTimeToTimestamp(this.last_login, App.TimeMachine.mapDisplayTimezone('UTC')),
        password_changed_at: App.TimeMachine.parseDateTimeToTimestamp(this.password_changed_at, App.TimeMachine.mapDisplayTimezone('UTC')),
        is_tfa_active: this.is_tfa_active,
        self_service_dashboards_access: this.self_service_dashboards_access,
        workbooks_access: this.workbooks_access
      };
      info[App.RedesignSimpleGridController.OBJECT_FIELD] = this;
      return info;
    };

    User.prototype.groupMemberships = function() {
      var i, len, membership, ref, results;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        membership = ref[i];
        if (membership.user_id === this.id) {
          results.push(membership);
        }
      }
      return results;
    };

    User.prototype.groupMembershipsByPermission = function(userToGroups) {
      var can_edit, groupInfo, grp, i, id, len, membershipPermissionMap, ref;
      membershipPermissionMap = [];
      if ((userToGroups != null ? userToGroups[this.id] : void 0) != null) {
        ref = Object.keys(userToGroups[this.id]);
        for (i = 0, len = ref.length; i < len; i++) {
          id = ref[i];
          try {
            grp = App.Group.find(id);
            can_edit = grp.canEditCurrentSite();
            groupInfo = {
              group_name: grp.name,
              id: parseInt(id),
              can_edit: can_edit,
              access_level: grp.accessLevelCurrentSite(),
              is_site_family_group: grp.site_family_id != null
            };
            groupInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = grp;
            membershipPermissionMap.push(groupInfo);
          } catch (error) {
            AppRedesign.logError(new Error("Group with id " + id + " not found."));
          }
        }
      }
      return membershipPermissionMap;
    };

    User.prototype.allAccessibleDashboardsById = function(groupPermissionMap, userToGroups, ownerCache) {
      var dashboardIds, dbs, grp_id, i, j, k, l, len, len1, len2, ref, ref1, ref2;
      dashboardIds = [];
      if ((userToGroups != null ? userToGroups[this.id] : void 0) != null) {
        ref = Object.keys(userToGroups[this.id]);
        for (i = 0, len = ref.length; i < len; i++) {
          grp_id = ref[i];
          if (groupPermissionMap[grp_id]) {
            ref1 = Object.keys(groupPermissionMap[grp_id]);
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              k = ref1[j];
              dashboardIds.push(k);
            }
          }
        }
      }
      if (ownerCache[this.id]) {
        ref2 = Object.keys(ownerCache[this.id]);
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          dbs = ref2[l];
          dashboardIds.push(dbs);
        }
      }
      return dashboardIds.unique();
    };

    User.prototype.getDashboardCount = function(groupToPermissionMap, userToGroups, ownerCache) {
      return this.allAccessibleDashboardsById(groupToPermissionMap, userToGroups, ownerCache).length;
    };

    User.prototype.getDashboardInfo = function(groupPermissionMap, userToGroups, ownerCache) {
      var d, dashboard, dashboardInfo, dashboardInfos, editable, groupAccess, group_id, i, isOwner, j, len, len1, ref, ref1, userGroupIds;
      dashboardInfos = [];
      if ((userToGroups != null ? userToGroups[this.id] : void 0) == null) {
        return dashboardInfos;
      }
      userGroupIds = Object.keys(userToGroups[this.id]);
      ref = this.allAccessibleDashboardsById(groupPermissionMap, userToGroups, ownerCache);
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        try {
          dashboard = App.Dashboard.find(d);
          isOwner = dashboard.user_id === this.id;
          groupAccess = [];
          editable = isOwner;
          for (j = 0, len1 = userGroupIds.length; j < len1; j++) {
            group_id = userGroupIds[j];
            if (((ref1 = groupPermissionMap[group_id]) != null ? ref1[d] : void 0) != null) {
              groupAccess.push(group_id);
              if (groupPermissionMap[group_id][d]['edit']) {
                editable = true;
              }
            }
          }
          dashboardInfo = {
            dashboard_name: dashboard.getName(),
            can_edit: editable,
            accessible_via: groupAccess,
            isOwnedByUser: isOwner
          };
          dashboardInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = dashboard;
          dashboardInfos.push(dashboardInfo);
        } catch (error) {

        }
      }
      return dashboardInfos;
    };

    User.prototype.getSiteInfo = function() {
      return [
        {
          site_display_name: "TODO:SPACES",
          user_in_space: true
        }
      ];
    };

    User.prototype.sendForgotPasswordMail = function() {
      return $.post('/users/send_forgot_password_mail', {
        email_address: this.email_address
      });
    };

    User.allSortedByName = function() {
      var all;
      all = this.select(function(u) {
        return u.isReal() && !u.isTemporary();
      });
      return App.Utils.sortByMethodString(all, 'displayName');
    };

    User.currentUserIsPeriscopeAdmin = function() {
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return false;
      }
      if (this.currentUser() != null) {
        return (this.currentUser().periscope_admin != null) && this.currentUser().periscope_admin;
      } else {
        return false;
      }
    };

    User.currentUserHasMultipleSites = function() {
      var ref;
      return ((ref = this.currentUser()) != null ? ref.allSites().length : void 0) > 1;
    };

    User.shortcutDestroys = function() {
      return false;
    };

    User.defaultDbForCurrentUser = function() {
      var cu;
      cu = App.User.currentUser();
      if (cu != null) {
        return App.Database.exists(cu.lastUsedDatabase()) || App.Database.first();
      } else {
        return App.Database.first();
      }
    };

    User.search = function(term, onResults) {
      var site_id;
      site_id = App.Site.first().id;
      return jQuery.get("/api/" + site_id + "/users/search", {
        'query': term
      }).done(function(data) {
        return onResults(data['users']);
      });
    };

    User.userInfos = function(groupToPermissionMap, userToGroups, ownerCache) {
      return App.User.loadUserInfos(App.User.all(), groupToPermissionMap, userToGroups, ownerCache);
    };

    User.searchUserInfos = function(term, groupToPermissionMap, userToGroups, ownerCache, onResults) {
      var onUsers;
      onUsers = function(users, nextPage) {
        return onResults(App.User.loadUserInfos(App.User.fromJSON(users), groupToPermissionMap, userToGroups, ownerCache));
      };
      return App.User.search(term, onUsers);
    };

    User.loadUserInfos = function(users, groupToPermissionMap, userToGroups, ownerCache) {
      var i, len, user, userArr;
      userArr = [];
      for (i = 0, len = users.length; i < len; i++) {
        user = users[i];
        userArr.push(user.userInfo(groupToPermissionMap, userToGroups, ownerCache));
      }
      return userArr;
    };

    User.ownerDashboardMap = function() {
      var d, i, len, map, name, ref;
      map = {};
      ref = App.Dashboard.all();
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        if (d.user_id != null) {
          map[name = d.user_id] || (map[name] = {});
          map[d.user_id][d.id] = true;
        }
      }
      return map;
    };

    User.allEditUsers = function() {
      var adminGroupIds, canEditGroupIds, currentSiteId, editUserIds, relevantGroupIds;
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return [];
      }
      adminGroupIds = _(App.Group.all()).filter(function(group) {
        return group.admin;
      }).map(function(group) {
        return group.id;
      }).value();
      currentSiteId = App.Site.first().id;
      canEditGroupIds = _(App.GroupRole.all()).filter(function(groupRole) {
        return groupRole.site_id === currentSiteId;
      }).filter(function(groupRole) {
        return groupRole.can_edit;
      }).map(function(groupRole) {
        return groupRole.group_id;
      }).value();
      relevantGroupIds = _.union(adminGroupIds, canEditGroupIds);
      editUserIds = _(App.GroupMembership.all()).filter(function(groupMembership) {
        return relevantGroupIds.includes(groupMembership.group_id);
      }).map(function(groupMembership) {
        return groupMembership.user_id;
      }).value();
      return _(App.User.all()).filter(function(user) {
        return user.periscope_admin || editUserIds.includes(user.id);
      }).value();
    };

    User.allExploreUsers = function() {
      var currentSiteId, exploreGroupIds, exploreUserIds, exploreUsers;
      if (AppRedesign.readOnlyMaintenanceMode()) {
        return [];
      }
      currentSiteId = App.Site.first().id;
      exploreGroupIds = _(App.GroupRole.all()).filter(function(groupRole) {
        return groupRole.site_id === currentSiteId;
      }).filter(function(groupRole) {
        return groupRole.can_drag_and_drop;
      }).map(function(groupRole) {
        return groupRole.group_id;
      }).value();
      exploreUserIds = _(App.GroupMembership.all()).filter(function(groupMembership) {
        return exploreGroupIds.includes(groupMembership.group_id);
      }).map(function(groupMembership) {
        return groupMembership.user_id;
      }).value();
      exploreUsers = _(App.User.all()).filter(function(user) {
        return exploreUserIds.includes(user.id);
      }).value();
      return _.union(this.allEditUsers(), exploreUsers);
    };

    User.allExploreUsersSortedByDisplayName = function() {
      return App.Utils.sortByMethodString(App.User.allExploreUsers(), 'displayName');
    };

    User.usersInSiteFamilyGroup = function() {
      var group, i, j, len, len1, membership, ref, ref1, siteFamilyGroups, userIds;
      siteFamilyGroups = [];
      ref = App.Group.all();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (group.site_family_id != null) {
          siteFamilyGroups.push(group.id);
        }
      }
      userIds = {};
      ref1 = App.GroupMembership.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        membership = ref1[j];
        if ((userIds[membership.id] == null) && siteFamilyGroups.includes(membership.group_id)) {
          userIds[membership.user_id] = true;
        }
      }
      return _.map(_.keys(userIds), function(userId) {
        return parseInt(userId);
      });
    };

    User.prototype.addUserRole = function(siteId, options) {
      var role;
      role = new App.UserRole({
        site_id: siteId,
        user_id: this.id
      });
      return role.save(options);
    };

    User.prototype.removeUserRole = function(siteId, options) {
      var i, len, ref, results, role;
      ref = App.UserRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        role = ref[i];
        if (role.user_id === this.id && siteId === role.site_id) {
          results.push(role.destroy(options));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return User;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UserDataView = (function(superClass) {
    extend(UserDataView, superClass);

    function UserDataView() {
      this.handleSharedUdvResponse = bind(this.handleSharedUdvResponse, this);
      this.addAllToDeletedDimensions = bind(this.addAllToDeletedDimensions, this);
      this.addToDeletedDimensions = bind(this.addToDeletedDimensions, this);
      this.signAndSave = bind(this.signAndSave, this);
      return UserDataView.__super__.constructor.apply(this, arguments);
    }

    UserDataView.configure('UserDataView', 'client_site_id', 'dashboard_id', 'user_id', 'custom_dimensions_list', 'date_range_dimension', 'aggregation', 'last_update', 'sync_version', 'fast_update');

    UserDataView.extend(Spine.Model.Ajax);

    UserDataView.CLIENT_ONLY_ATTRIBUTES = ['signed_custom_dimensions_list'];

    UserDataView.newForDashboard = function(dashboard) {
      var sd;
      if (AppRedesign.current().shared_mode) {
        sd = App.SharedDashboard.currentSharedDashboard();
        return new App.UserDataView({
          dashboard_id: dashboard.id,
          date_range_dimension: sd != null ? sd.date_range_dimension : void 0,
          aggregation: sd != null ? sd.aggregation : void 0,
          custom_dimensions_list: sd != null ? sd.custom_dimensions_list : void 0
        });
      } else {
        return new App.UserDataView({
          dashboard_id: dashboard.id,
          user_id: App.User.safeCurrentUser().id,
          date_range_dimension: dashboard.dateRangeSetting(),
          aggregation: dashboard.aggregationSetting(),
          custom_dimensions_list: dashboard.custom_dimensions_list
        });
      }
    };

    UserDataView.prototype.save = function(options) {
      if (options == null) {
        options = {};
      }
      if ((AppRedesign.current() != null) && AppRedesign.current().shared_mode) {
        if (!AppRedesign.current().shared_filter_mode) {
          return;
        }
        options['ajax'] = false;
        this.saveSharedUdv();
      }
      return UserDataView.__super__.save.call(this, options);
    };

    UserDataView.prototype.signDimension = function(dimensionId, id, groupId, signature) {
      var dimension, name;
      this.deleted_dimensions || (this.deleted_dimensions = []);
      if (_.isEmpty(signature)) {
        return;
      }
      dimension = App.UdvHelper.removeDimension(this, dimensionId, id);
      if (dimension == null) {
        return;
      }
      dimension[name = App.DimensionConfig.GROUP_INDEX] || (dimension[name] = '');
      dimension[App.DimensionConfig.SIGNATURE_INDEX] = signature;
      this.custom_dimensions_list.push(dimension);
      if (groupId !== dimension[App.DimensionConfig.GROUP_INDEX]) {
        return this.deleted_dimensions.push([dimensionId, id, App.UdvHelper.INVALID_UDV_DETAILS.GROUP_CHANGE]);
      }
    };

    UserDataView.prototype.signAndSave = function(options) {
      var ref;
      this.updateSignatureCache();
      this.save(options);
      return (ref = options.dashboard) != null ? ref.removeInvalidDimensions(this.deleted_dimensions) : void 0;
    };

    UserDataView.prototype.updateSignatureCache = function() {
      return this.signed_custom_dimensions_list = _.filter(this.custom_dimensions_list, function(dim) {
        return !_.isEmpty(dim[App.DimensionConfig.SIGNATURE_INDEX]);
      });
    };

    UserDataView.prototype.addToDeletedDimensions = function(dim) {
      this.deleted_dimensions || (this.deleted_dimensions = []);
      return this.deleted_dimensions.push(dim);
    };

    UserDataView.prototype.addAllToDeletedDimensions = function(dimensionList) {
      this.deleted_dimensions || (this.deleted_dimensions = []);
      return _.forEach(dimensionList, (function(_this) {
        return function(dim) {
          return _this.deleted_dimensions.push(dim);
        };
      })(this));
    };

    UserDataView.prototype.saveSharedUdv = function() {
      return this.requestUpdatedChartData('update_filters');
    };

    UserDataView.prototype.refreshDataWithoutNewHashKeys = function() {
      return this.requestUpdatedChartData('refresh_data');
    };

    UserDataView.prototype.requestUpdatedChartData = function(action) {
      return jQuery.post("/shared_dashboards/" + (AppRedesign.current().shared_dashboard_token) + "/" + action, {
        shared_dashboard_filters: this.filtersAsJson(),
        sd_user_id: AppRedesign.current().shared_dashboard_user_id
      }).done(this.handleSharedUdvResponse);
    };

    UserDataView.prototype.handleSharedUdvResponse = function(r) {
      var isOverloaded, j, len, ref, w, wasOverloaded;
      wasOverloaded = AppRedesign.current().state.overloaded_site;
      isOverloaded = r.overloaded_site;
      AppRedesign.current().overloaded_site = isOverloaded;
      if ((r.reset != null) || wasOverloaded !== isOverloaded) {
        AppRedesign.current().resetIfReady();
      }
      if (r.widgets != null) {
        if (r.min_update_time) {
          AppRedesign.current().sourceMinUpdateTime = r.min_update_time;
        }
        App.Widget.applyUpdates(r.widgets);
        ref = this.widgets();
        for (j = 0, len = ref.length; j < len; j++) {
          w = ref[j];
          w.trigger('update');
        }
        return this.requestManyUpdates();
      }
    };

    UserDataView.prototype.requestManyUpdates = function() {
      var i, j, k, l, len, len1, ref, results, t, times;
      if (this.existingTimeouts == null) {
        this.existingTimeouts = [];
      }
      ref = this.existingTimeouts;
      for (j = 0, len = ref.length; j < len; j++) {
        t = ref[j];
        clearTimeout(t);
      }
      this.existingTimeouts = [];
      times = [1, 2, 4, 7];
      for (i = k = 1; k <= 30; i = ++k) {
        times.push(i * 10);
      }
      results = [];
      for (l = 0, len1 = times.length; l < len1; l++) {
        t = times[l];
        results.push(this.existingTimeouts.push(setTimeout(App.Widget.checkForNewData, t * 1000)));
      }
      return results;
    };

    UserDataView.prototype.filtersAsJson = function() {
      return JSON.stringify({
        date_range_dimension: this.date_range_dimension,
        custom_dimensions_list: this.custom_dimensions_list,
        aggregation: this.aggregation
      });
    };

    UserDataView.prototype.dashboard = function() {
      return App.Dashboard.exists(this.dashboard_id);
    };

    UserDataView.prototype.widgets = function() {
      var d;
      d = this.dashboard();
      if (d) {
        return d.widgets();
      }
      return [];
    };

    UserDataView.prototype.removeSourcesFromSourceFetcher = function() {
      var j, len, ref, results, w;
      ref = this.widgets();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        w = ref[j];
        results.push(App.sourceFetcher().delHash(w.formula_source_hash_key));
      }
      return results;
    };

    UserDataView.prototype.prepareWidgetsForUpdate = function() {
      var j, len, ref, w;
      if (!((this.id == null) || App.Utils.isClientId(this.id))) {
        this.save({
          ajax: false
        });
      }
      ref = this.widgets();
      for (j = 0, len = ref.length; j < len; j++) {
        w = ref[j];
        w.trigger('update');
      }
      return App.Site.trigger('request-several-updates');
    };

    UserDataView.prototype.isBlank = function() {
      var dash, dashBlank, udvBlank;
      dash = this.dashboard();
      if (!dash) {
        return false;
      }
      dashBlank = (dash.aggregation == null) && (dash.date_range_dimension == null) && ((dash.custom_dimensions_list == null) || dash.custom_dimensions_list.isEmpty());
      udvBlank = (this.aggregation == null) && ((this.date_range_dimension == null) || Object.keys(this.date_range_dimension).length < 2) && ((this.custom_dimensions_list == null) || this.custom_dimensions_list.isEmpty());
      return udvBlank && dashBlank;
    };

    UserDataView.prototype.filters = function() {
      return new App.DashboardFilters(this.custom_dimensions_list, this.aggregation, this.date_range_dimension);
    };

    UserDataView.current = function() {
      var udv;
      udv = AppRedesign.udvInUrl();
      if (AppRedesign.udvIdInUrl() != null) {
        return udv;
      }
      if (udv == null) {
        udv = this.forDashboard(App.Dashboard.currentDashboard());
      }
      return udv;
    };

    UserDataView.currentForDashboard = function(dashboard) {
      var udv;
      udv = AppRedesign.udvInUrl();
      if ((udv != null) && (dashboard != null) && udv.dashboard_id === dashboard.id) {
        return udv;
      }
      return this.forDashboard(dashboard);
    };

    UserDataView.currentId = function() {
      var c;
      c = this.current();
      if (c) {
        return c.id;
      }
      return null;
    };

    UserDataView.forDashboard = function(dashboard) {
      var cu, j, k, len, len1, ref, ref1, u;
      if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode) {
        ref = App.UserDataView.all();
        for (j = 0, len = ref.length; j < len; j++) {
          u = ref[j];
          if (u.dashboard_id === dashboard.id && (u.user_id == null)) {
            return u;
          }
        }
        return App.UserDataView.newForDashboard(dashboard);
      }
      cu = App.User.currentUser();
      if (!((dashboard != null) && (cu != null))) {
        return null;
      }
      ref1 = App.UserDataView.all();
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        u = ref1[k];
        if (u.dashboard_id === dashboard.id && u.user_id === cu.id) {
          return u;
        }
      }
      return null;
    };

    return UserDataView;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UserRole = (function(superClass) {
    extend(UserRole, superClass);

    function UserRole() {
      return UserRole.__super__.constructor.apply(this, arguments);
    }

    UserRole.configure('UserRole', 'client_site_id', 'recent_colors', 'user_id', 'site_id', 'chart_tutorial_completed_at', 'chart_tutorial_dismissed_at', 'contacted_sales_at', 'tutorial_popup_dismissed_at');

    UserRole.extend(Spine.Model.Ajax);

    UserRole.url = "/users/user_roles";

    UserRole.currentRole = function() {
      return App.UserRole.findByAttribute('user_id', App.User.currentUserId());
    };

    return UserRole;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UserWidgetView = (function(superClass) {
    extend(UserWidgetView, superClass);

    function UserWidgetView() {
      return UserWidgetView.__super__.constructor.apply(this, arguments);
    }

    UserWidgetView.configure('UserWidgetView', 'client_site_id', 'user_id', 'widget_id', 'sync_version', 'twiddles', 'save_pivot_settings', 'widget_cid');

    UserWidgetView.extend(Spine.Model.Ajax);

    UserWidgetView.TABLE_COLUMN_TWIDDLES = ['filter_columns'];

    UserWidgetView.PIVOT_COLUMN_TWIDDLES = ['point_cols', 'segment_column', 'value_columns'];

    UserWidgetView.PIVOT_FORMAT_TWIDDLES = ['no_cohort_color', 'use_pivot_settings', 'table_line_numbers'];

    UserWidgetView.prototype.save = function(options) {
      var ref;
      if (options == null) {
        options = {};
      }
      if ((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0) {
        options['ajax'] = false;
      }
      return UserWidgetView.__super__.save.call(this, options);
    };

    UserWidgetView.findByWidget = function(widget) {
      var uwv;
      if (widget == null) {
        return null;
      }
      uwv = this.findByWidgetOrNull(widget);
      if (uwv == null) {
        uwv = widget.uwv;
      }
      if (uwv == null) {
        uwv = this.setUwvFromWidget(widget);
      }
      if (!App.Utils.isClientId(widget.id)) {
        uwv.widget_id = widget.id;
      }
      return uwv;
    };

    UserWidgetView.findByWidgetOrNull = function(widget) {
      var uwv, widget_id;
      if (widget == null) {
        return null;
      }
      widget_id = this.setWidgetId(widget);
      uwv = App.UserWidgetView.findByWidgetId(widget_id, widget.cid);
      return uwv;
    };

    UserWidgetView.findByWidgetId = function(widgetId, widgetCid) {
      var i, len, ref, uwv;
      if (widgetCid == null) {
        widgetCid = -1;
      }
      ref = this.all();
      for (i = 0, len = ref.length; i < len; i++) {
        uwv = ref[i];
        if (uwv.widget_id != null) {
          if (uwv.widget_id === widgetId) {
            return uwv;
          }
        } else if (uwv.widget_cid === widgetCid) {
          return uwv;
        }
      }
      return null;
    };

    UserWidgetView.setUwvFromWidget = function(widget) {
      var uwv;
      uwv = new App.UserWidgetView({
        twiddles: {}
      });
      uwv.setDefaultsFromWidget(widget);
      uwv.widget_cid = widget.cid;
      return uwv;
    };

    UserWidgetView.prototype.prefixedTwiddle = function(twiddle) {
      return 'twiddle_' + twiddle;
    };

    UserWidgetView.setWidgetId = function(widget) {
      var widget_id;
      widget_id = widget.id;
      if (widget_id == null) {
        widget_id = widget.widget_id;
      }
      return widget_id;
    };

    UserWidgetView.prototype.setDefaultsFromWidget = function(widget) {
      var i, j, len, len1, prefixedChartType, prefixedTwiddle, ref, twiddle, twiddleGroup, twiddles, widgetTwiddles;
      this.widget_id = App.UserWidgetView.setWidgetId(widget);
      widgetTwiddles = widget.twiddles;
      if (widgetTwiddles != null) {
        twiddles = App.TwiddleMap.readWrite({});
        prefixedChartType = this.prefixedTwiddle('chart_type');
        if (widgetTwiddles[prefixedChartType]) {
          twiddles.twiddles[prefixedChartType] = widgetTwiddles[prefixedChartType];
        }
        ref = [App.UserWidgetView.TABLE_COLUMN_TWIDDLES, App.UserWidgetView.PIVOT_FORMAT_TWIDDLES, App.UserWidgetView.PIVOT_COLUMN_TWIDDLES];
        for (i = 0, len = ref.length; i < len; i++) {
          twiddleGroup = ref[i];
          for (j = 0, len1 = twiddleGroup.length; j < len1; j++) {
            twiddle = twiddleGroup[j];
            prefixedTwiddle = this.prefixedTwiddle(twiddle);
            if (widget.getTwiddle(prefixedTwiddle) != null) {
              twiddles.set(prefixedTwiddle, widget.getTwiddle(prefixedTwiddle));
            }
          }
        }
        return this.twiddles = twiddles.twiddles;
      }
    };

    UserWidgetView.prototype.setDefaultTwiddlesFromUwv = function(twiddles) {
      return this.setWidgetTwiddles(twiddles, true);
    };

    UserWidgetView.prototype.setWidgetTwiddles = function(twiddles, set_default) {
      var uwvTwiddles;
      if (set_default == null) {
        set_default = false;
      }
      if (set_default && !this.save_pivot_settings) {
        return;
      }
      if (this.twiddles == null) {
        return;
      }
      if (!(set_default || twiddles['twiddle_chart_type'] === 'table')) {
        return;
      }
      uwvTwiddles = App.TwiddleMap.readWrite(this.twiddles);
      this.setPivotTableTwiddles(twiddles, uwvTwiddles);
      return twiddles;
    };

    UserWidgetView.prototype.setPivotTableTwiddles = function(twiddles, uwvTwiddles) {
      var i, j, k, l, len, len1, len2, len3, prefixedTwiddle, ref, ref1, ref2, ref3, results, twiddle;
      ref = ['chart_type'];
      for (i = 0, len = ref.length; i < len; i++) {
        twiddle = ref[i];
        prefixedTwiddle = this.prefixedTwiddle(twiddle);
        if (uwvTwiddles.get(prefixedTwiddle) != null) {
          twiddles[prefixedTwiddle] = uwvTwiddles.get(twiddle);
        }
      }
      ref1 = App.UserWidgetView.TABLE_COLUMN_TWIDDLES;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        twiddle = ref1[j];
        prefixedTwiddle = this.prefixedTwiddle(twiddle);
        twiddles[prefixedTwiddle] = uwvTwiddles.getArray(prefixedTwiddle);
      }
      ref2 = App.UserWidgetView.PIVOT_FORMAT_TWIDDLES;
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        twiddle = ref2[k];
        prefixedTwiddle = this.prefixedTwiddle(twiddle);
        if (uwvTwiddles.get(prefixedTwiddle) != null) {
          twiddles[prefixedTwiddle] = uwvTwiddles.get(twiddle);
        }
      }
      ref3 = App.UserWidgetView.PIVOT_COLUMN_TWIDDLES;
      results = [];
      for (l = 0, len3 = ref3.length; l < len3; l++) {
        twiddle = ref3[l];
        prefixedTwiddle = this.prefixedTwiddle(twiddle);
        results.push(twiddles[prefixedTwiddle] = uwvTwiddles.getArray(prefixedTwiddle));
      }
      return results;
    };

    return UserWidgetView;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Widget = (function(superClass) {
    extend(Widget, superClass);

    function Widget() {
      this.handleRefreshResponse = bind(this.handleRefreshResponse, this);
      this.handleRefreshFailure = bind(this.handleRefreshFailure, this);
      this.postRefreshData = bind(this.postRefreshData, this);
      this.databaseOrDefault = bind(this.databaseOrDefault, this);
      return Widget.__super__.constructor.apply(this, arguments);
    }

    Widget.REFRESH_TIME = 1000;

    Widget.MAX_WIDGET_WIDTH = 3;

    Widget.MAX_WIDGET_HEIGHT = 2;

    Widget.PRETTY_CLASS_NAME = 'Chart';

    Widget.PRETTY_CLASS_NAME_LOWERCASE = 'chart';

    Widget.SIMPLE_CLASS_NAME = 'Chart';

    Widget.FACTORY_DIMENSION_COLUMN = 'periscope_dimension';

    Widget.FACTORY_ERROR_TYPE = (function() {
      return 'Only SQL charts are supported on this dashboard';
    });

    Widget.FACTORY_ERROR_LIMIT = (function() {
      return 'Metric cannot contain limit clauses on this dashboard';
    });

    Widget.FACTORY_ERROR_DIMENSION = (function(cdName) {
      return "Metric must include [my_column=" + cdName + "] on this dashboard";
    });

    Widget.FACTORY_ERROR_COLUMN = (function() {
      return "The right-most column must be named '" + this.FACTORY_DIMENSION_COLUMN + "' and contain the dimension value";
    });

    Widget.QUERY_CANCELED_MESSAGE = "Query canceled by an administrator";

    Widget.NEW_CHART_NAME = 'Untitled Chart';

    Widget.DB_MAPPING_ERROR_MESSAGE = 'The database selected for the chart is not available. Please contact administrator to resolve permission issue.';

    Widget.DONT_TRIGGER_ON_CHECK_FOR_UPDATE = true;

    Widget.MAX_CHART_DESC_LEN = 400;

    Widget.configure('Widget', 'api_enabled', 'api_token', 'chart_description', 'chart_type', 'client_site_id', 'code', 'code_hash_key', 'code_language', 'code_version', 'content_id', 'content_type', 'copy_archived_widgets_from_id', 'csv_download_disabled', 'dashboard_id', 'database_id', 'date_range_dimension', 'default_color_theme_id', 'default_color_theme_id', 'drag_drop_config', 'fluid_column', 'fluid_height', 'fluid_row', 'fluid_width', 'formula_source_hash_key', 'last_update', 'server_update_pending', 'shared_dashboard_id', 'sql', 'sql_limit', 'state', 'sync_version', 'title', 'twiddles', 'use_periscope_theme', 'user_id', 'uwv', 'uwv_twiddles', 'archived_at', 'blocked_by_database_mapping_feature');

    Widget.extend(Spine.Model.Ajax);

    Widget.allowsEqualUpdates = function() {
      return (AppRedesign.current() != null) && AppRedesign.current().shared_mode;
    };

    Widget.prototype.copy = function() {
      var newWidget;
      newWidget = new App.Widget();
      newWidget.mergeEditableProperties(this);
      newWidget.api_token = null;
      newWidget.api_enabled = false;
      newWidget.setColumn(0);
      newWidget.setRow(this.dashboard().nextFreeRow());
      newWidget.title = "Copy of " + (this.title || App.Widget.NEW_CHART_NAME);
      newWidget.copy_archived_widgets_from_id = this.id;
      newWidget.twiddles = _.cloneDeep(this.twiddles);
      newWidget.drag_drop_config = _.cloneDeep(this.drag_drop_config);
      return newWidget;
    };

    Widget.prototype.dashboard = function() {
      if (this.archived_at && AppRedesign.autoArchiveEnabled()) {
        return this._archived_dashboard;
      }
      return App.Dashboard.exists(this.dashboard_id);
    };

    Widget.prototype.sharedDashboards = function() {
      var i, len, ref, results, sd;
      ref = App.SharedDashboard.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        sd = ref[i];
        if (sd.dashboard_id === this.dashboard_id) {
          results.push(sd);
        }
      }
      return results;
    };

    Widget.EDITABLE_WIDGET_PROPERTIES = ['api_enabled', 'api_token', 'chart_description', 'chart_type', 'code', 'code_language', 'code_version', 'csv_download_disabled', 'dashboard_id', 'database_id', 'default_color_theme_id', 'fluid_column', 'fluid_height', 'fluid_row', 'fluid_width', 'formula_source_hash_key', 'sql', 'title', 'use_periscope_theme'];

    Widget.ALL_CHART_TYPES = ["table", "line", "column", "bignumber", "pie", "area", "cohort", "geomap", "sparkline", "scatter", "bubble", "image"];

    Widget.ALL_CODE_CHART_TYPES = ["codeimage", "codetext"];

    Widget.prototype.mergeEditableProperties = function(newWidget) {
      var i, len, prop, ref;
      ref = App.Widget.EDITABLE_WIDGET_PROPERTIES;
      for (i = 0, len = ref.length; i < len; i++) {
        prop = ref[i];
        this[prop] = newWidget[prop];
      }
      return this.twiddles = $.extend(true, {}, newWidget.twiddles);
    };

    Widget.S_LOADING = 'loading';

    Widget.S_REFRESHING = 'refreshing';

    Widget.S_COMPLETE = 'complete';

    Widget.S_CANCELED = 'canceled';

    Widget.prototype["export"] = function() {
      return JSON.stringify({
        title: this.title,
        chart_type: this.chart_type,
        sql: this.sql,
        chart_description: this.chart_description,
        twiddles: this.twiddles,
        width: this.getWidth(),
        height: this.getHeight(),
        code: this.code,
        code: this.code_language,
        code: this.code_version
      });
    };

    Widget.prototype.content = function() {
      if (!AppRedesign.textOnDashboardEnabled()) {
        return this;
      }
      if (!((this.content_type != null) && this.content_id)) {
        return this;
      }
      return App[this.content_type].find(this.content_id);
    };

    Widget.prototype.state = function() {
      var ref;
      if (this.blocked_by_database_mapping_feature) {
        return Widget.S_COMPLETE;
      }
      if (this.canceledForCurrentUser()) {
        return Widget.S_CANCELED;
      }
      if ((ref = AppRedesign.current()) != null ? ref.loadUntilNextCheckForUpdates : void 0) {
        return Widget.S_LOADING;
      }
      if (this.server_update_pending || App.FormulaSource.isLoading(this.selectedFormulaSource())) {
        return Widget.S_LOADING;
      }
      if (this.hasUpdatePending()) {
        return Widget.S_REFRESHING;
      }
      return Widget.S_COMPLETE;
    };

    Widget.prototype.getError = function() {
      var formulaSource, message;
      if (this.blocked_by_database_mapping_feature) {
        return this.DB_MAPPING_ERROR_MESSAGE;
      }
      formulaSource = this.selectedFormulaSource();
      message = formulaSource != null ? formulaSource.errorMessage() : void 0;
      if (message) {
        message = App.SourceErrorMessageInterpreter.call(message);
        if (formulaSource.hasErrorPositions()) {
          message = App.ErrorMessageLineAnnotator.call(this.sql, this.expandedSql(), formulaSource.error_pos, message, this.database().info());
        }
      }
      return message;
    };

    Widget.isNoDataError = function(errorMsg) {
      return errorMsg === 'No data' || errorMsg === App.Chartographer.ERR_NO_ROWS;
    };

    Widget.prototype.getChartType = function() {
      return this.chart_type;
    };

    Widget.prototype.empty = function() {
      var ref, ref1;
      return !(((ref = this.selectedFormulaSource()) != null ? (ref1 = ref.rows) != null ? ref1.length : void 0 : void 0) > 0);
    };

    Widget.prototype.hasCodeSource = function(dataType) {
      var ref;
      return (ref = this.selectedFormulaSource()) != null ? ref.isCodeSource() : void 0;
    };

    Widget.prototype.linkData = function(dataType) {
      return this.selectedFormulaSource().linkData(dataType);
    };

    Widget.prototype.hasPlotlyData = function() {
      var ref, ref1;
      return (ref = (ref1 = this.selectedFormulaSource()) != null ? ref1.isPlotlySource() : void 0) != null ? ref : false;
    };

    Widget.prototype.getRows = function() {
      var ref, ref1;
      return (ref = (ref1 = this.selectedFormulaSource()) != null ? ref1.tableDataRows() : void 0) != null ? ref : [];
    };

    Widget.prototype.getColumns = function() {
      var ref, ref1;
      return (ref = (ref1 = this.selectedFormulaSource()) != null ? ref1.tableDataColumns() : void 0) != null ? ref : [];
    };

    Widget.prototype.contentRequiresQuery = function() {
      return this.content_type !== 'TextBox';
    };

    Widget.prototype.fetchSource = function() {
      var existingFs, hash_key;
      if (this.blocked_by_database_mapping_feature) {
        return;
      }
      if (!this.contentRequiresQuery()) {
        return;
      }
      hash_key = this.hashKey();
      if (hash_key == null) {
        return;
      }
      existingFs = App.FormulaSource.findByHash(hash_key);
      if ((existingFs != null) && existingFs.percent_complete === 1 && !existingFs.tooOld()) {
        return;
      }
      return App.fetchSourceHighPriority(hash_key, App.SourceFetcher.QUERY_WIDGET);
    };

    Widget.prototype.setHashKey = function(formula_source_hash_key) {
      this.formula_source_hash_key = formula_source_hash_key;
    };

    Widget.prototype.setCodeHashKey = function(code_hash_key) {
      this.code_hash_key = code_hash_key;
    };

    Widget.prototype.getCodeLanguage = function() {
      return this.code_language;
    };

    Widget.prototype.removeCodeConfig = function() {
      this.code = null;
      this.code_hash_key = null;
      this.code_language = null;
      return this.code_version = null;
    };

    Widget.prototype.getSqlHashKey = function() {
      var ref, ref1;
      if (!this.contentRequiresQuery()) {
        return null;
      }
      return (ref = (ref1 = App.editronLinkedWidgetFormulaSourceHashKey) != null ? ref1 : App.linkedWidgetFormulaSourceHashKey) != null ? ref : this.formula_source_hash_key;
    };

    Widget.prototype.sqlSource = function() {
      return App.FormulaSource.findByHash(this.getSqlHashKey());
    };

    Widget.prototype.getCodeHashKey = function() {
      var ref, ref1;
      return (ref = (ref1 = App.codeEditronLinkedWidgetFormulaSourceHashKey) != null ? ref1 : App.codeLinkedWidgetFormulaSourceHashKey) != null ? ref : this.code_hash_key;
    };

    Widget.prototype.codeSource = function() {
      return App.FormulaSource.findByHash(this.getCodeHashKey());
    };

    Widget.prototype.hashKey = function() {
      var ref;
      return (ref = (AppRedesign.current().deepAnalysisEnabled ? this.getCodeHashKey() : void 0)) != null ? ref : this.getSqlHashKey();
    };

    Widget.prototype.databaseOrDefault = function() {
      return Widget.__super__.databaseOrDefault.apply(this, arguments);
    };

    Widget.prototype.hasTwiddle = function(k) {
      return this.getTwiddle(k) != null;
    };

    Widget.prototype.getArrayTwiddle = function(name) {
      var twiddleCols, twiddleVal;
      twiddleVal = this.getTwiddle(name) || [];
      if (twiddleVal.constructor === String) {
        twiddleCols = twiddleVal.split(',');
      } else {
        twiddleCols = twiddleVal;
      }
      return twiddleCols;
    };

    Widget.prototype.getTwiddle = function(k) {
      if (this.twiddles == null) {
        return void 0;
      }
      return App.TwiddleConfig.getTwiddle(this.twiddles, k);
    };

    Widget.prototype.maybeInitTwiddles = function() {
      var base, base1;
      if (this.twiddles == null) {
        this.twiddles = {};
      }
      if ((base = this.twiddles).series == null) {
        base.series = {};
      }
      return (base1 = this.twiddles).dragDrop != null ? base1.dragDrop : base1.dragDrop = {};
    };

    Widget.prototype.setTwiddle = function(k, v) {
      this.maybeInitTwiddles();
      return App.TwiddleConfig.setTwiddle(this.twiddles, k, v);
    };

    Widget.prototype.setDragDropConfig = function(value) {
      return this.drag_drop_config = value;
    };

    Widget.prototype.setSeriesTwiddle = function(name, k, v) {
      var twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readWrite(this.twiddles);
      twiddleMap.setForSeriesWithOverride(name, k, v);
      return this.twiddles = twiddleMap.twiddles;
    };

    Widget.prototype.setColumnTwiddle = function(name, k, v) {
      var twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readWrite(this.twiddles);
      twiddleMap.setForColumnWithOverride(name, k, v);
      return this.twiddles = twiddleMap.twiddles;
    };

    Widget.prototype.setAllSeriesTwiddle = function(k, v) {
      var i, len, name, ref, twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readWrite(this.twiddles);
      ref = Object.keys(this.twiddles.series);
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        twiddleMap.setForSeriesWithOverride(name, k, v);
      }
      return this.twiddles = twiddleMap.twiddles;
    };

    Widget.prototype.getSeriesTwiddle = function(name, k) {
      var twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readOnly(this.twiddles);
      return twiddleMap.getForSeries(name, k);
    };

    Widget.prototype.getColumnTwiddle = function(name, k) {
      var twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readOnly(this.twiddles);
      return twiddleMap.getForColumn(name, k);
    };

    Widget.prototype.deleteColumnTwiddle = function(name, k) {
      var twiddleMap;
      this.maybeInitTwiddles();
      twiddleMap = App.TwiddleMap.readOnly(this.twiddles);
      twiddleMap.deleteForColumn(name, k);
      return this.twiddles = twiddleMap.twiddles;
    };

    Widget.prototype.completeSql = function() {
      if ((this.sql != null) && this.contentRequiresQuery()) {
        return this.sql;
      }
      return "";
    };

    Widget.prototype.expandedSql = function() {
      var ref;
      return ((ref = this.selectedFormulaSource()) != null ? ref.htmlSql() : void 0) || this.completeSql();
    };

    Widget.prototype.hasSql = function() {
      return this.completeSql().trim() !== '';
    };

    Widget.prototype.hasError = function() {
      var fs;
      fs = this.selectedFormulaSource();
      if (fs != null) {
        if (!this.isComplete()) {
          return false;
        }
        return (fs.error_message != null) && fs.error_message.length > 0;
      }
      return false;
    };

    Widget.prototype.hasUpdatePending = function(checkFormulaSource) {
      var fs, hash_key;
      if (checkFormulaSource == null) {
        checkFormulaSource = true;
      }
      if (this.server_update_pending) {
        return true;
      }
      hash_key = this.hashKey();
      if (hash_key == null) {
        return true;
      }
      if (!checkFormulaSource) {
        return false;
      }
      fs = App.FormulaSource.findByHash(hash_key);
      if (fs != null) {
        if (!this.isComplete()) {
          return false;
        }
        return fs.hasUpdatePending() || fs.percent_complete < 1;
      }
      if (this.hashKey() != null) {
        return true;
      }
      return false;
    };

    Widget.prototype.canceledForCurrentUser = function() {
      var ref;
      return (ref = this.selectedFormulaSource()) != null ? ref.canceledForUser() : void 0;
    };

    Widget.prototype.hasData = function() {
      var fs;
      if (this.blocked_by_database_mapping_feature) {
        return true;
      }
      fs = this.selectedFormulaSource();
      if (fs != null) {
        if (!this.isComplete()) {
          return false;
        }
        return fs.isCompletelyLoaded();
      }
      return false;
    };

    Widget.prototype.isComplete = function() {
      return this.sql != null;
    };

    Widget.prototype.saveOrCreate = function() {
      return this.save();
    };

    Widget.prototype.errorsBlockingSave = function() {
      return false;
    };

    Widget.prototype.toJSON = function() {
      var json;
      json = Widget.__super__.toJSON.apply(this, arguments);
      return json;
    };

    Widget.prototype.moveTo = function(column, row, ajaxSave, saveNow) {
      if (ajaxSave == null) {
        ajaxSave = false;
      }
      if (saveNow == null) {
        saveNow = true;
      }
      this.setColumn(column);
      this.setRow(row);
      this.positionOrSizeChanged = true;
      if (saveNow && this.exists()) {
        return this.save({
          ajax: ajaxSave
        });
      }
    };

    Widget.prototype.sizeTo = function(width, height, ajaxSave) {
      if (ajaxSave == null) {
        ajaxSave = false;
      }
      this.setWidth(width);
      this.setHeight(height);
      this.positionOrSizeChanged = true;
      if (this.exists()) {
        return this.save({
          ajax: ajaxSave
        });
      }
    };

    Widget.prototype.refreshData = function(refreshAll, udv) {
      if (refreshAll == null) {
        refreshAll = false;
      }
      if (udv == null) {
        udv = null;
      }
      if (!this.contentRequiresQuery()) {
        return;
      }
      if (!(this.isNew() || App.Utils.isClientId(this.id))) {
        this.prepareForNewData();
        this.trigger('widget-post-refresh-data', refreshAll, udv);
        App.Site.trigger('request-several-updates');
      }
      return null;
    };

    Widget.prototype.postRefreshData = function(refreshAll, udv) {
      if (this.blocked_by_database_mapping_feature) {
        return;
      }
      return jQuery.post("/widgets/" + this.id + "/refresh_data", {
        udv: AppRedesign.udvIdInUrl(),
        refreshAll: refreshAll,
        udvRefresh: udv != null,
        hashKey: this.hashKey()
      }).done((function(_this) {
        return function(r) {
          return _this.handleRefreshResponse(r);
        };
      })(this)).fail(this.handleRefreshFailure);
    };

    Widget.prototype.handleRefreshFailure = function() {
      this.server_update_pending = false;
      return this.save({
        ajax: false
      });
    };

    Widget.prototype.handleRefreshResponse = function(response) {
      if (response.hash_key == null) {
        return;
      }
      App.fetchSourceHighPriority(response.hash_key, App.SourceFetcher.QUERY_REFRESH);
      if (!AppRedesign.widgetIdInUrl() && this.hashKey() !== response.hash_key) {
        if (this.hasCodeSource()) {
          this.setCodeHashKey(response.hash_key);
        } else {
          this.setHashKey(response.hash_key);
        }
      }
      return this.server_update_pending = false;
    };

    Widget.prototype.prepareForNewData = function() {
      this.server_update_pending = true;
      return this.save({
        ajax: false
      });
    };

    Widget.prototype.getActiveDimensionValueNames = function(for_dim_id) {
      var cdl, dimension_value_names;
      if (for_dim_id == null) {
        for_dim_id = null;
      }
      dimension_value_names = [];
      cdl = this.filters().custom_dimensions_list;
      dimension_value_names = Widget.namesFromCustomDimensionsList(cdl, for_dim_id);
      return dimension_value_names;
    };

    Widget.namesFromCustomDimensionsList = function(cdl, for_dim_id) {
      var dim_id, dim_list, dim_value, dim_value_name, i, len, names;
      if (for_dim_id == null) {
        for_dim_id = null;
      }
      names = [];
      if (cdl == null) {
        return names;
      }
      for (i = 0, len = cdl.length; i < len; i++) {
        dim_list = cdl[i];
        dim_id = dim_list[0], dim_value = dim_list[1], dim_value_name = dim_list[2];
        if ((for_dim_id == null) || dim_id === for_dim_id) {
          names.push(dim_value_name);
        }
      }
      return names;
    };

    Widget.prototype.getLinkId = function() {
      return this.id;
    };

    Widget.prototype.getRawTitle = function() {
      return _.trim(this.title);
    };

    Widget.prototype.getName = function() {
      return this.getTitleForDisplay();
    };

    Widget.prototype.getTitleForDisplay = function() {
      var dimension_value_names, placeholder, title;
      if (this.content_type === 'TextBox' && this.content_id) {
        return this.content().getRawText();
      }
      placeholder = '[category]';
      title = _.trim(this.title);
      title = new App.TitleFormatter(this).formatChartTitle(title);
      if (title.indexOf(placeholder) !== -1) {
        dimension_value_names = this.getActiveDimensionValueNames();
        if (!dimension_value_names.isEmpty()) {
          return title.replace(placeholder, dimension_value_names.join(', ').trim());
        } else {
          return title.replace(placeholder, 'All');
        }
      } else {
        return title;
      }
    };

    Widget.prototype.makePrettyName = function() {
      return App.Widget.NEW_CHART_NAME;
    };

    Widget.prototype.neverSavedToServer = function() {
      return ("" + this.id) !== ("" + (parseInt(this.id)));
    };

    Widget.prototype.isReadOnlyToCurrentUser = function() {
      var d;
      d = this.dashboard();
      if (!d) {
        return false;
      }
      return d.isReadOnlyToCurrentUser();
    };

    Widget.prototype.segmentColumnsFromInsertotron = function() {
      var fs, values;
      fs = this.selectedFormulaSource();
      if (fs != null) {
        values = fs.getInsertotronMetadata('dimension_column_insertion');
        if (values != null) {
          return values;
        }
      }
      return [];
    };

    Widget.prototype.isGeomap = function() {
      return this.chart_type === 'geomap';
    };

    Widget.prototype.isTable = function() {
      return this.chart_type === 'table';
    };

    Widget.prototype.isDragDrop = function() {
      var ref;
      return ((ref = this.twiddles) != null ? ref.twiddle_drag_drop_chart : void 0) === true;
    };

    Widget.prototype.selectedFormulaSource = function() {
      if (!this.contentRequiresQuery()) {
        return null;
      }
      return App.FormulaSource.findByHash(this.hashKey());
    };

    Widget.prototype.getQueryDuration = function() {
      var fs;
      fs = this.selectedFormulaSource();
      if (fs != null) {
        return App.Utils.roundToSignificantDigits(fs.query_duration, 3);
      }
      return null;
    };

    Widget.prototype.ranOnRedshiftStatus = function() {
      var fs;
      fs = this.selectedFormulaSource();
      if ((fs != null) && fs.ran_on_redshift) {
        return "true";
      } else if (fs != null) {
        return "false";
      } else {
        return "";
      }
    };

    Widget.prototype.availableDetailColumns = function() {
      var columns, detailColumn, i, len, ref, results;
      columns = this.getColumns();
      ref = this.detailColumns();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        detailColumn = ref[i];
        if (columns.indexOf(detailColumn) !== -1) {
          results.push(detailColumn);
        }
      }
      return results;
    };

    Widget.prototype.detailColumns = function() {
      var detail_columns;
      detail_columns = this.getTwiddle(App.TwiddleConfig.DETAIL_COLUMNS);
      if (typeof detail_columns === 'string') {
        return detail_columns.split(',');
      }
      return this.getArrayTwiddle(App.TwiddleConfig.DETAIL_COLUMNS);
    };

    Widget.prototype.defaultCurrency = function() {
      return App.Tooltip.DOLLAR;
    };

    Widget.prototype.currency = function() {
      return this.getTwiddle(App.TwiddleConfig.CURRENCY) || this.defaultCurrency();
    };

    Widget.prototype.valueFormat = function(getFormatForSecondAxis) {
      var format, i, len, ref;
      if (getFormatForSecondAxis && this.getTwiddle(App.TwiddleConfig.SECOND_AXIS_PERCENT)) {
        return App.Tooltip.PERCENT;
      }
      ref = [App.Tooltip.PERCENT, App.Tooltip.DOLLAR, App.Tooltip.NUMBER];
      for (i = 0, len = ref.length; i < len; i++) {
        format = ref[i];
        if (this.getTwiddle(App.TwiddleConfig.VALUES_FORMAT) === format) {
          return format;
        }
      }
      return App.Tooltip.DEFAULT_VALUE_FORMAT;
    };

    Widget.prototype.csvDownloadEnabled = function() {
      return !Boolean(this.csv_download_disabled) && !App.Site.first().csvDownloadAccessNone();
    };

    Widget.prototype.reliesOnRestrictedDb = function() {
      var ref;
      return (ref = this.database()) != null ? ref.is_restricted : void 0;
    };

    Widget.prototype.getApiToken = function() {
      if (this.api_token == null) {
        this.api_token = App.Utils.makeGuid();
      }
      return this.api_token;
    };

    Widget.prototype.apiRouteForCSV = function() {
      var host, origin, udv, url;
      if (!this.api_enabled) {
        return null;
      }
      host = App.Site.first().host;
      origin = "";
      if (typeof window !== "undefined" && window !== null) {
        origin = window.location.origin;
      }
      url = origin + "/api/" + host + "/chart/csv/" + (this.getApiToken());
      udv = App.UserDataView.current();
      if (udv != null) {
        url += "/" + udv.id;
      }
      return url;
    };

    Widget.prototype.filters = function() {
      var d, sd, udv;
      udv = App.UserDataView.current();
      if ((this.shared_dashboard_id != null) && !AppRedesign.current().shared_filter_mode) {
        sd = App.SharedDashboard.find(this.shared_dashboard_id);
        return sd.filters();
      } else if ((udv != null) && udv.dashboard_id === this.dashboard_id) {
        return udv.filters();
      } else {
        d = this.dashboard() || App.Dashboard.currentDashboard();
        return d.filters();
      }
    };

    Widget.stubsForWidgets = function(widgetList) {
      var i, len, stubs, widget;
      stubs = [];
      if (!Array.isArray(widgetList)) {
        return stubs;
      }
      for (i = 0, len = widgetList.length; i < len; i++) {
        widget = widgetList[i];
        widget.sync_version += 1;
        widget.save({
          ajax: false
        });
        stubs.push(widget.getStub());
      }
      return stubs;
    };

    Widget.prototype.getStub = function() {
      return {
        __constructor_name: this.constructor.className,
        id: this.id,
        fluid_column: this.fluid_column,
        fluid_row: this.fluid_row,
        fluid_height: this.fluid_height,
        fluid_width: this.fluid_width
      };
    };

    Widget.prototype.dateRange = function() {
      var ref, udv;
      udv = App.UserDataView.current();
      if ((udv != null) && !udv.isBlank()) {
        return udv.date_range_dimension;
      }
      return (ref = this.dashboard()) != null ? ref.date_range_dimension : void 0;
    };

    Widget.prototype.valuesForCustomDimension = function(cd_id) {
      var ref;
      return (ref = this.filters().custom_dimensions_list) != null ? ref.filter((function(_this) {
        return function(cd) {
          return cd[0] === cd_id;
        };
      })(this)) : void 0;
    };

    Widget.prototype.hasChartDescription = function() {
      return this.chart_description && this.chart_description !== '';
    };

    Widget.prototype.getChartDescription = function() {
      var desc;
      desc = this.chart_description;
      if (desc == null) {
        desc = '';
      }
      desc = new App.TitleFormatter(this).formatChartTitle(desc);
      if (desc.length > Widget.MAX_CHART_DESC_LEN) {
        desc = desc.substr(0, Widget.MAX_CHART_DESC_LEN) + "...";
      }
      return desc;
    };

    Widget.checkForNewData = function() {
      var dash, i, len, ref, results, w;
      if (this.blocked_by_database_mapping_feature) {
        return;
      }
      if (App.SourceFetcher.sourcesPending()) {
        return;
      }
      dash = App.Dashboard.currentDashboard();
      if (dash == null) {
        return;
      }
      ref = dash.widgets();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        w = ref[i];
        results.push(App.fetchSource(w.formula_source_hash_key, App.SourceFetcher.QUERY_CHECK_FOR_UPDATES));
      }
      return results;
    };

    Widget.prototype.getRow = function() {
      return this.fluid_row;
    };

    Widget.prototype.getColumn = function() {
      return this.fluid_column;
    };

    Widget.prototype.getWidth = function() {
      return this.fluid_width;
    };

    Widget.prototype.getHeight = function() {
      return this.fluid_height;
    };

    Widget.prototype.setRow = function(row) {
      return this.fluid_row = row;
    };

    Widget.prototype.setColumn = function(column) {
      return this.fluid_column = column;
    };

    Widget.prototype.setWidth = function(width) {
      return this.fluid_width = width;
    };

    Widget.prototype.setHeight = function(height) {
      return this.fluid_height = height;
    };

    Widget.prototype.setName = function(name) {
      this.title = name;
      return this.trigger('title-changed');
    };

    Widget.prototype.colorTheme = function() {
      if (this.use_periscope_theme) {
        return App.ColorTheme.PERISCOPE_DEFAULT_THEME();
      }
      return App.ColorTheme.exists(this.default_color_theme_id) || (this.dashboard() && this.dashboard().colorTheme()) || App.Site.first().colorTheme();
    };

    Widget.prototype.triggerRendered = function() {
      return this.trigger('chart-rendered');
    };

    Widget.prototype.sourceRowsComplete = function() {
      var fs;
      fs = this.selectedFormulaSource();
      if ((fs == null) || (fs.rows == null) || (fs.error_message != null)) {
        return false;
      }
      return (this.customSqlLimitApplied() && fs.rows.length < this.sql_limit) || (this.defaultSqlLimitApplied() && fs.rows.length < App.QueryRunner.DEFAULT_SQL_LIMIT) || (this.noSqlLimitApplied() && fs.rows.length > 0);
    };

    Widget.prototype.defaultSqlLimitApplied = function() {
      return _.isUndefined(this.sql_limit);
    };

    Widget.prototype.customSqlLimitApplied = function() {
      return this.sql_limit > 0;
    };

    Widget.prototype.noSqlLimitApplied = function() {
      return _.isNull(this.sql_limit);
    };

    return Widget;

  })(App.PeriscopeModel);

}).call(this);
(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.Chartographer = (function() {
    function Chartographer() {}

    Chartographer.CHART_TYPE_BUBBLE = 'scatter';

    Chartographer.DEFAULT_SERIES_NAME = 'default_series_name';

    Chartographer.ORIGINAL_ROW = '_periscope_original_row';

    Chartographer.RAW_COLUMN_TYPE = 'raw';

    Chartographer.NUMERIC_COLUMN_TYPE = 'numeric';

    Chartographer.DATETIME_COLUMN_TYPE = 'datetime';

    Chartographer.TIMESERIES_AXIS_TYPE = 'timeseries';

    Chartographer.NUMERIC_AXIS_TYPE = 'numeric';

    Chartographer.CONTINUOUS_AXIS_TYPES = [Chartographer.TIMESERIES_AXIS_TYPE, Chartographer.NUMERIC_AXIS_TYPE];

    Chartographer.TIMEZONE_DEFAULT = 'America/Los_Angeles';

    Chartographer.DO_NOT_SEGMENT = "-1";

    Chartographer.ERR_NO_CODE_CHART_DATA = 'No available code chart.';

    Chartographer.ERR_NO_CODE_TEXT_DATA = 'No available code text.';

    Chartographer.MAX_DRAG_DROP_ROWS = 20000;

    Chartographer.ERR_NO_COLUMNS = 'No columns were selected in the query.';

    Chartographer.ERR_NO_ROWS = 'Query returned no matching rows.';

    Chartographer.ERR_NO_SERIES = 'No available data series. Please select more columns in your query or have at least one available column.';

    Chartographer.ERR_NO_X = 'No available X column.';

    Chartographer.ERR_NO_Y = 'No available Y columns.';

    Chartographer.ERR_NO_Z = 'No available Z column.';

    Chartographer.ERR_NO_DATA = 'No available data columns.';

    Chartographer.ERR_STRING_VALUE_COL = 'Non-numeric Y values are not supported.';

    Chartographer.ERR_STRING_Z_COL = 'Non-numeric Z values are not supported.';

    Chartographer.ERR_NOT_SINGLE = 'Incorrect number of rows and columns were selected in the query. Please select exactly one row and one column.';

    Chartographer.ERR_NOT_URL = 'No URL selected in the query.';

    Chartographer.ERR_NO_COMMA = 'Column names with commas are not supported in Cohort Grids.';

    Chartographer.ERR_COHORT_COLUMNS = 'Cohort grids require at least three columns: cohort, pivot, and value.';

    Chartographer.ERR_TOO_MANY_UNNAMED_COLUMNS = 'Queries returning more than 100 unnamed columns are not supported.';

    Chartographer.ERR_BAD_NUMERIC_FORMAT = 'Numeric formatting not supported for non-numeric columns.';

    Chartographer.ERR_TIMEOUT = 'Chart rendering timed out';

    Chartographer.ERR_GENERIC = 'Unable to display this chart.';

    Chartographer.ERROR_TRUNCATED_RESULTS = 'Results have been truncated to ' + Chartographer.MAX_DRAG_DROP_ROWS.toLocaleString() + ' data points. Please filter to reduce data points.';

    Chartographer.ROW = 'row';

    Chartographer.MILLISECONDS_IN_DAY = 1000 * 3600 * 24;

    Chartographer.convertLinkData = function(rows, columns, linkData, codeLanguage, originTwiddles, chartHashKey, theme, aggregation) {
      if (theme == null) {
        theme = null;
      }
      return App.ChartographerCache.setIntoCache(chartHashKey, Chartographer._convertLinkData(rows, columns, linkData, codeLanguage, originTwiddles, theme, aggregation));
    };

    Chartographer.convert = function(rows, columns, originTwiddles, chartHashKey, theme, aggregation) {
      if (theme == null) {
        theme = null;
      }
      return App.ChartographerCache.setIntoCache(chartHashKey, Chartographer._convert(rows, columns, originTwiddles, theme, aggregation));
    };

    Chartographer._codeChartEmptyDataMsg = function(chartType, codeLanguage) {
      var empty_code_output_messages;
      empty_code_output_messages = {
        codeimage: {
          R: 'No available r chart.',
          python: 'No available python chart.'
        },
        codetext: {
          R: 'No available r text.',
          python: 'No available python text.'
        }
      };
      return empty_code_output_messages[chartType][codeLanguage];
    };

    Chartographer._convertCodeSpecificChart = function(chartType, codeLanguage, linkData) {
      var error;
      if (linkData != null) {
        return {
          chartType: chartType,
          linkData: linkData,
          twiddlesActual: App.TwiddleMap.readWrite({})
        };
      } else {
        error = this._codeChartEmptyDataMsg(chartType, codeLanguage);
        return {
          error: error
        };
      }
    };

    Chartographer._convertCodeChart = function(chartType, codeLanguage, rows, columns, originTwiddles, theme, aggregation) {
      if (rows.length > 0 && columns.length > 0) {
        return this._convert(rows, columns, originTwiddles, theme, aggregation);
      } else {
        if (codeLanguage === 'R') {
          return {
            error: 'No available table data. Please pass a dataframe to periscope.table'
          };
        } else if (codeLanguage === 'python') {
          return {
            error: 'No available table data. Please pass a dataframe to periscope.output'
          };
        } else {
          return {
            error: 'No available table data.'
          };
        }
      }
    };

    Chartographer._convertLinkData = function(rows, columns, linkData, codeLanguage, originTwiddles, theme, aggregation) {
      var chartType;
      chartType = originTwiddles['twiddle_chart_type'];
      if (chartType === '') {
        return {
          error: 'Please select a chart type.'
        };
      }
      if (indexOf.call(App.Widget.ALL_CODE_CHART_TYPES, chartType) >= 0) {
        return this._convertCodeSpecificChart(chartType, codeLanguage, linkData, aggregation);
      } else {
        return this._convertCodeChart(chartType, codeLanguage, rows, columns, originTwiddles, theme, aggregation);
      }
    };

    Chartographer._convert = function(rows, columns, originTwiddles, theme, aggregation) {
      var adjustedTable, c, chartData, chartType, columnProcessor, columnToFormat, error, filteredRows, i, j, len, len1, measures, percentOfColumnColumns, percentOfRowColumns, ref, ref1, ref2, ref3, ref4, ref5, rowProcessor, seriesProcessor, summaryMap, tableProcessor, twiddles, twiddlesActual, valueColumns, warning, xColumns, yColumns;
      twiddles = jQuery.extend(true, {}, originTwiddles);
      chartType = twiddles['twiddle_chart_type'];
      if (chartType === '') {
        return {
          error: 'Please select a chart type.'
        };
      }
      if (indexOf.call(App.Widget.ALL_CODE_CHART_TYPES, chartType) >= 0) {
        if (AppRedesign.current().deepAnalysisEnabled) {
          switch (chartType) {
            case 'codeimage':
              return {
                error: Chartographer.ERR_NO_CODE_CHART_DATA
              };
            case 'codetext':
              return {
                error: Chartographer.ERR_NO_CODE_TEXT_DATA
              };
          }
        }
        return {
          error: 'Python and R are not enabled on this site.'
        };
      }
      if (columns.length === 0) {
        return {
          error: Chartographer.ERR_NO_COLUMNS
        };
      }
      if (rows.length === 0) {
        return {
          error: Chartographer.ERR_NO_ROWS
        };
      }
      warning = null;
      if (rows.length >= App.Chartographer.MAX_DRAG_DROP_ROWS && (twiddles != null ? twiddles.twiddle_drag_drop_chart : void 0) === true) {
        warning = App.Chartographer.ERROR_TRUNCATED_RESULTS;
      }
      if (chartType === 'cohort' && ((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = columns.length; i < len; i++) {
          c = columns[i];
          if (c.indexOf(',') !== -1) {
            results.push(1);
          }
        }
        return results;
      })()).length) {
        return {
          error: Chartographer.ERR_NO_COMMA
        };
      }
      Chartographer.preprocessTwiddles(twiddles);
      if (!App.Chartographer.isSupported(chartType)) {
        throw new Error("Unsupported Chart Type: " + chartType);
      }
      twiddles = App.TwiddleMap.readOnly(twiddles);
      twiddlesActual = App.TwiddleMap.readWrite({});
      summaryMap = null;
      if (twiddles.get('drag_drop_chart')) {
        adjustedTable = App.SourceTableProcessor.lowerCaseColumnNames({
          rows: rows,
          columns: columns
        });
        rows = adjustedTable.rows;
        columns = adjustedTable.columns;
        measures = originTwiddles != null ? (ref = originTwiddles.dragDrop) != null ? (ref1 = ref.sqlParams) != null ? ref1.measures : void 0 : void 0 : void 0;
        if ((measures != null) && chartType === 'cohort') {
          valueColumns = Chartographer.getValueColumnsForSummaryCalculations(measures, columns, twiddles);
          xColumns = twiddles.getArray('twiddle_point_cols');
          yColumns = twiddles.getArray('twiddle_segment_column');
          summaryMap = new App.SummaryCalculator(rows, columns, valueColumns, xColumns, yColumns).summaryMap();
        }
      } else {
        percentOfColumnColumns = twiddles.colummnsWithValue('value_format', 'cohort_percent_of_column');
        for (i = 0, len = percentOfColumnColumns.length; i < len; i++) {
          columnToFormat = percentOfColumnColumns[i];
          ref2 = App.PercentageFormatter.formatPercentOfColumn(rows, columns, twiddles, columnToFormat), rows = ref2[0], columns = ref2[1];
        }
        percentOfRowColumns = twiddles.colummnsWithValue('value_format', 'cohort_percent_of_row');
        for (j = 0, len1 = percentOfRowColumns.length; j < len1; j++) {
          columnToFormat = percentOfRowColumns[j];
          ref3 = App.PercentageFormatter.formatPercentOfRow(rows, columns, twiddles, columnToFormat), rows = ref3[0], columns = ref3[1];
        }
      }
      if (twiddles.get('drag_drop_chart')) {
        ref4 = App.DragDropSorter.sortSource(rows, columns, twiddles), rows = ref4[0], columns = ref4[1];
        if (!((rows != null ? rows.length : void 0) > 0)) {
          return {
            error: Chartographer.ERR_NO_ROWS
          };
        }
        if (chartType === 'table') {
          columns = twiddles.get('twiddle_point_cols');
        }
      }
      if (twiddles.get('secondary_axis_enabled')) {
        originTwiddles['twiddle_secondary_axis_enabled'] = true;
        originTwiddles['twiddle_secondary_axis_series_names'] = twiddles.get('secondary_axis_series_names');
      }
      if (twiddles.get('transpose_table') && chartType === 'table') {
        ref5 = App.TableProcessor.transpose(rows, columns), rows = ref5[0], columns = ref5[1];
      }
      try {
        columnProcessor = new App.ColumnProcessor(rows, columns, twiddles, twiddlesActual);
        columnProcessor.pickAllColumns();
        if (columnProcessor.error != null) {
          return {
            twiddlesActual: twiddlesActual,
            error: columnProcessor.error
          };
        }
        if (['table', 'cohort'].includes(twiddlesActual.get('chart_type'))) {
          tableProcessor = new App.TableProcessor(twiddles, twiddlesActual);
          tableProcessor.forwardTableTwiddles();
          if (tableProcessor.error != null) {
            return {
              twiddlesActual: twiddlesActual,
              error: tableProcessor.error
            };
          }
        }
        if (twiddlesActual.get('chart_type') === 'table') {
          filteredRows = App.PivotFilterProcessor.filterRows(twiddles, twiddlesActual, rows);
          return {
            columns: columns,
            rows: filteredRows,
            twiddlesActual: twiddlesActual,
            warning: warning
          };
        }
        rowProcessor = new App.RowProcessor(columnProcessor.typedRows, twiddles, twiddlesActual, summaryMap);
        rowProcessor.generateAllSeries(aggregation);
        if (rowProcessor.error != null) {
          return {
            twiddlesActual: twiddlesActual,
            error: rowProcessor.error
          };
        }
        if (rowProcessor.allSeries.length) {
          seriesProcessor = new App.SeriesProcessor(rowProcessor.allSeries, rowProcessor.seriesNames, twiddles, twiddlesActual, theme);
          seriesProcessor.annotateSeries();
          if (seriesProcessor.error != null) {
            return {
              twiddlesActual: twiddlesActual,
              error: seriesProcessor.error
            };
          }
        }
        chartData = {
          dataSeries: rowProcessor.allSeries,
          twiddlesActual: twiddlesActual,
          warning: warning,
          summaryMap: summaryMap
        };
        return chartData;
      } catch (error1) {
        error = error1;
        error.twiddles = twiddles.twiddles;
        error.twiddlesActual = twiddlesActual.twiddles;
        throw error;
      }
    };

    Chartographer.getValueColumnsForSummaryCalculations = function(measures, columns, twiddles) {
      var agg_prefix, i, len, measure, measuresLookup, valueColumns;
      agg_prefix = twiddles.get('use_pivot_settings');
      measuresLookup = {};
      for (i = 0, len = measures.length; i < len; i++) {
        measure = measures[i];
        measuresLookup[measure.column_display_name] = measure;
      }
      valueColumns = twiddles.getArray('twiddle_value_columns').filter(function(vc) {
        var ref;
        return ref = vc.column_name, indexOf.call(columns, ref) >= 0;
      });
      return valueColumns = valueColumns.map(function(vc) {
        var valueColumn;
        valueColumn = _.clone(vc);
        if (agg_prefix) {
          valueColumn.column_display_name = vc.column_value_aggregation + " of " + vc.column_name;
        } else {
          valueColumn.column_display_name = vc.column_name;
        }
        valueColumn.measure = measuresLookup[vc.column_name];
        return valueColumn;
      });
    };

    Chartographer.preprocessTwiddles = function(twiddles) {
      var base, base1, base2, column, columnTwiddles, i, j, len, len1, name, ref, ref1, ref2, ref3, s, twiddle, value, valueColumn, valueColumnMap, valueColumns;
      twiddles['series'] || (twiddles['series'] = {});
      if (twiddles['twiddle_multiple_y_axes']) {
        if (twiddles['twiddle_multiple_y_axes_columns']) {
          ref = twiddles['twiddle_multiple_y_axes_columns'].split(',');
          for (i = 0, len = ref.length; i < len; i++) {
            s = ref[i];
            (base = twiddles['series'])[s] || (base[s] = {});
            if ((base1 = twiddles['series'][s])['series_show_on_secondary_axis'] == null) {
              base1['series_show_on_secondary_axis'] = true;
            }
            if ((base2 = twiddles['series'][s])['series_show_on_primary_axis'] == null) {
              base2['series_show_on_primary_axis'] = false;
            }
          }
        } else if (!!twiddles['new_logic']) {
          twiddles['twiddle_auto_y2'] = true;
          twiddles['twiddle_secondary_axis_enabled'] = true;
        }
      }
      twiddles['twiddle_secondary_axis_series_names'] = [];
      ref1 = twiddles.series;
      for (name in ref1) {
        s = ref1[name];
        if (s['series_show_on_secondary_axis']) {
          twiddles['twiddle_secondary_axis_enabled'] = true;
          twiddles['twiddle_secondary_axis_series_names'].push(name);
        }
      }
      if (twiddles['twiddle_chart_type'] === 'cohort') {
        if (twiddles['twiddle_pivot_column'] != null) {
          twiddles['twiddle_segment_column'] = twiddles['twiddle_pivot_column'];
        }
        if (twiddles['twiddle_cohort_detail_columns'] != null) {
          twiddles['twiddle_detail_columns'] = twiddles['twiddle_cohort_detail_columns'];
        }
        if (twiddles['twiddle_unpivoted_column'] != null) {
          twiddles['twiddle_point_cols'] = twiddles['twiddle_unpivoted_column'];
        }
      }
      if (twiddles.columns != null) {
        valueColumns = [];
        valueColumnMap = {};
        ref2 = twiddles['twiddle_value_columns'] || [];
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          valueColumn = ref2[j];
          columnTwiddles = twiddles.columns[valueColumn.column_name];
          if (columnTwiddles != null) {
            for (twiddle in columnTwiddles) {
              value = columnTwiddles[twiddle];
              if (valueColumn[twiddle] == null) {
                valueColumn[twiddle] = value;
              }
            }
          }
          valueColumnMap[valueColumn.column_name] = true;
          valueColumns.push(valueColumn);
        }
        if (!twiddles['twiddle_use_pivot_settings']) {
          ref3 = twiddles.columns;
          for (column in ref3) {
            columnTwiddles = ref3[column];
            if (valueColumnMap[column]) {
              continue;
            }
            if (columnTwiddles['column_use_as_value']) {
              valueColumns.push($.extend(true, {
                column_name: column
              }, columnTwiddles));
            }
          }
        }
        return twiddles['twiddle_value_columns'] = valueColumns;
      }
    };

    Chartographer.prototype.pointCols = function() {
      return this.actual('point_cols') || [];
    };

    Chartographer.prototype.valueCols = function() {
      return this.actual('value_cols');
    };

    Chartographer.prototype.valueColumns = function() {
      return this.actual('value_columns');
    };

    Chartographer.prototype.pointIsValue = function() {
      return App.Utils.intersect(this.pointCols(), this.valueCols()).length > 0;
    };

    Chartographer.prototype.xCol = function() {
      return this.pointCols()[0];
    };

    Chartographer.prototype.segmentCols = function() {
      return this.actual('segment_column');
    };

    Chartographer.prototype.mainChartType = function() {
      return this.actual('chart_type');
    };

    Chartographer.prototype.twiddle = function(name) {
      return this.twiddles.get(name);
    };

    Chartographer.prototype.seriesTwiddle = function(series, name) {
      return this.twiddles.getForSeries(series.name, name);
    };

    Chartographer.prototype.columnTwiddle = function(column, name) {
      return this.twiddles.getForColumn(column, name);
    };

    Chartographer.prototype.actual = function(name) {
      return this.twiddlesActual.get(name);
    };

    Chartographer.prototype.setActual = function(name, value) {
      return this.twiddlesActual.set(name, value);
    };

    Chartographer.prototype.setActualWithOverride = function(name, value) {
      return this.twiddlesActual.setWithOverride(name, value);
    };

    Chartographer.prototype.seriesActual = function(series, name) {
      return this.twiddlesActual.getForSeries(series.name, name);
    };

    Chartographer.prototype.setSeriesActual = function(series, name, value) {
      return this.twiddlesActual.setForSeries(series.name, name, value);
    };

    Chartographer.prototype.columnActual = function(column, name) {
      return this.twiddlesActual.getForColumn(column, name);
    };

    Chartographer.prototype.setColumnActual = function(column, name, value) {
      return this.twiddlesActual.setForColumn(column, name, value);
    };

    Chartographer.prototype.forwardTwiddle = function(name) {
      if (this.twiddle(name) != null) {
        return this.setActual(name, this.twiddle(name));
      }
    };

    Chartographer.prototype.forwardIfPresent = function(twiddle) {
      if (this.twiddle(twiddle) != null) {
        return this.setActual(twiddle, this.twiddle(twiddle));
      }
    };

    Chartographer.prototype.forwardColumnIfPresent = function(twiddle) {
      var col, columnNames, i, len, results, val;
      columnNames = this.twiddlesActual.get('column_names');
      if (columnNames == null) {
        throw new Error("Columns missing and are required");
      }
      results = [];
      for (i = 0, len = columnNames.length; i < len; i++) {
        col = columnNames[i];
        val = this.columnTwiddle(col, twiddle);
        if (val != null) {
          results.push(this.setColumnActual(col, twiddle, val));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Chartographer.prototype.forwardNumericTwiddle = function(name) {
      var val;
      if (this.twiddle(name) != null) {
        val = this.twiddle(name);
        if (val.toString().match(App.ChartUtils.LOOSE_DATE_REGEX)) {
          val = App.TimeMachine.parseDateTimeToTimestamp(val, this.actual('timezone'), this.twiddle('start_of_week'));
        }
        if (!App.Utils.isBlank(val) && ($.isNumeric(val))) {
          return this.setActual(name, App.ChartUtils.numberFromNumberishString(val));
        }
      }
    };

    Chartographer.prototype.forwardSeriesIfPresent = function(series, twiddle) {
      if (this.seriesTwiddle(series, twiddle) != null) {
        return this.setSeriesActual(series, twiddle, this.seriesTwiddle(series, twiddle));
      }
    };

    Chartographer.isSupported = function(chartType) {
      return App.ChartUtils.CHART_TYPES[chartType] != null;
    };

    Chartographer.prototype.parseArrayTwiddle = function(name) {
      var twiddleCols, twiddleVal;
      twiddleVal = this.twiddle(name) || [];
      if (twiddleVal.constructor === String) {
        twiddleCols = twiddleVal.split(',');
      } else {
        twiddleCols = twiddleVal;
      }
      return twiddleCols;
    };

    return Chartographer;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SearchableMenu = (function(superClass) {
    extend(SearchableMenu, superClass);

    function SearchableMenu() {
      this.searchTyped = bind(this.searchTyped, this);
      return SearchableMenu.__super__.constructor.apply(this, arguments);
    }

    SearchableMenu.prototype.getActiveableItemsList = function() {
      throw new Error('NYI - must override');
    };

    SearchableMenu.prototype.getNextActiveItem = function(activeableItems, nextDiff) {
      var a, activeIndex, i, len, nextIndex;
      activeIndex = 0;
      for (i = 0, len = activeableItems.length; i < len; i++) {
        a = activeableItems[i];
        if ($(a).hasClass('active')) {
          break;
        }
        activeIndex++;
      }
      if (activeIndex === activeableItems.length) {
        this.lastActiveIndex[this.activeBlock] = 0;
        if (nextDiff < 0) {
          return activeableItems.last();
        } else {
          return activeableItems.first();
        }
      }
      nextIndex = (activeableItems.length + activeIndex + nextDiff) % activeableItems.length;
      this.lastActiveIndex[this.activeBlock] = nextIndex;
      return $(activeableItems[nextIndex]);
    };

    SearchableMenu.prototype.clearAnyActives = function() {
      var i, len, list, ref, results;
      ref = this.allItemLists;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        list = ref[i];
        results.push(list.find('.item.active').removeClass('active'));
      }
      return results;
    };

    SearchableMenu.prototype.moveActiveIndexSideways = function() {};

    SearchableMenu.prototype.moveActiveIndex = function(direction) {
      var activeableItems, nextActive;
      activeableItems = this.getActiveableItemsList();
      if (activeableItems.length === 0) {
        this.moveActiveIndexSideways(null, 1);
      }
      if (activeableItems.length === 0) {
        return;
      }
      nextActive = this.getNextActiveItem(activeableItems, direction);
      this.clearAnyActives();
      nextActive.addClass('active');
      return this.scrollActiveItemInView();
    };

    SearchableMenu.prototype.moveActiveIndexUp = function() {
      return this.moveActiveIndex(-1);
    };

    SearchableMenu.prototype.moveActiveIndexDown = function() {
      return this.moveActiveIndex(1);
    };

    SearchableMenu.prototype.getActiveItem = function() {
      var activeItems, i, len, list, ref;
      ref = this.allItemLists;
      for (i = 0, len = ref.length; i < len; i++) {
        list = ref[i];
        activeItems = list.find('.item.active');
        if (activeItems.length > 0) {
          return activeItems;
        }
      }
      return [];
    };

    SearchableMenu.prototype.pickActiveOption = function() {
      var activeItem;
      activeItem = this.getActiveItem();
      if (activeItem.length > 0) {
        return this.itemPicked(activeItem.first());
      }
    };

    SearchableMenu.prototype.itemPicked = function(item) {
      throw new Error('NYI - must override');
    };

    SearchableMenu.prototype.scrollActiveItemInView = function(activeItem) {
      var currentScrollBottom, currentScrollTop, currentScrollWindow, itemHeight, itemList, itemPosition, scrollContainer;
      if (activeItem == null) {
        activeItem = null;
      }
      if (activeItem == null) {
        activeItem = this.getActiveItem();
      }
      if (activeItem.length > 0) {
        scrollContainer = activeItem.closest('.scroll-container');
        itemList = activeItem.closest('.items');
        currentScrollTop = scrollContainer.scrollTop();
        currentScrollWindow = scrollContainer.height();
        currentScrollBottom = currentScrollWindow + currentScrollTop;
        itemPosition = activeItem.position().top - itemList.position().top;
        itemHeight = activeItem.height();
        if (itemPosition - itemHeight / 2 < currentScrollTop) {
          return scrollContainer.scrollTop(itemPosition - itemHeight / 2);
        } else if (itemPosition + itemHeight + itemHeight / 2 > currentScrollBottom) {
          return scrollContainer.scrollTop(itemPosition + itemHeight - currentScrollWindow + itemHeight / 2);
        }
      }
    };

    SearchableMenu.prototype.searchTyped = function(event) {
      if (event.type === 'keydown') {
        switch (event.which) {
          case AppRedesign.KEYS.UP_ARROW:
            event.preventDefault();
            return this.moveActiveIndexUp();
          case AppRedesign.KEYS.DOWN_ARROW:
            event.preventDefault();
            return this.moveActiveIndexDown();
          case AppRedesign.KEYS.LEFT_ARROW:
            return this.moveActiveIndexSideways(event, -1);
          case AppRedesign.KEYS.RIGHT_ARROW:
            return this.moveActiveIndexSideways(event, 1);
          case AppRedesign.KEYS.ENTER:
            return this.pickActiveOption();
          default:
            return this.clearAnyActives();
        }
      } else {
        return this.triggerSearch();
      }
    };

    SearchableMenu.prototype.triggerSearch = function() {
      var searchQuery;
      if (this.searchBox == null) {
        return;
      }
      searchQuery = this.searchBox.val().trim();
      if (this.lastSearchQuery !== searchQuery) {
        this.lastSearchQuery = searchQuery;
        return this.filterMenuItems();
      }
    };

    SearchableMenu.prototype.allSortedByName = function(filterQuery) {
      if (filterQuery == null) {
        filterQuery = null;
      }
      return this.baseModelClass.allSortedByName(filterQuery);
    };

    SearchableMenu.prototype.itemModelSelector = function(model) {
      return ".item[" + this.modelIdAttr + "=" + model.cid + "]";
    };

    SearchableMenu.prototype.filterMenuItems = function() {
      var i, len, list, model, ref, results;
      ref = this.allItemLists;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        list = ref[i];
        list.find('.item').addClass('collapsed').removeClass('active');
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = this.allSortedByName(this.lastSearchQuery);
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            model = ref1[j];
            results1.push(list.find(this.itemModelSelector(model)).removeClass('collapsed'));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    return SearchableMenu;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AppFrameRedesign = (function(superClass) {
    var REACT_SEARCH_MODELS;

    extend(AppFrameRedesign, superClass);

    AppFrameRedesign.NORMAL_ANIMATION_TIME = 500;

    AppFrameRedesign.FAST_ANIMATION_TIME = 250;

    AppFrameRedesign.prototype.elements = {
      '.dashboards-container': 'dashboardsContainer',
      '.left-navigation': 'leftNavigation',
      '.switcher-dropdown': 'switcherDropdown',
      '.switcher-dropdown-options': 'switcherDropdownOptions',
      '#tv_mode_frame': 'tvModeFrame',
      '#modal': 'modal',
      '.screen-loader-line': 'loaderLine',
      '.no-database-message': 'noDbMessage',
      '.no-privileges-message': 'noPrivilegesMessage',
      '.no-content-message': 'noContentMessage',
      '.no-workbooks-message': 'noWorkbooksMessage',
      '.dialog': 'dialog',
      '.notification-bar': 'notificationBar',
      '#main-viewport-react': 'mainViewportReact'
    };

    AppFrameRedesign.prototype.events = {
      'click .switcher-dropdown': 'toggleDropdownOptions',
      'click .switcher-dropdown-sisense': 'switchToSisense',
      'click #no-workbooks-profile-link': 'noWorkbooksProfileLinkClicked'
    };

    function AppFrameRedesign() {
      this.createSqlChartsEnabledOnDashboard = bind(this.createSqlChartsEnabledOnDashboard, this);
      this.checkToOpenConfirm = bind(this.checkToOpenConfirm, this);
      this.closeArchivedDashboard = bind(this.closeArchivedDashboard, this);
      this.showArchivedDashboard = bind(this.showArchivedDashboard, this);
      this.removeDashboard = bind(this.removeDashboard, this);
      this.uncacheController = bind(this.uncacheController, this);
      this.addDashboard = bind(this.addDashboard, this);
      this.createNewSqlView = bind(this.createNewSqlView, this);
      this.createNewWidgetWithState = bind(this.createNewWidgetWithState, this);
      this.createNewWidget = bind(this.createNewWidget, this);
      this.createNewExploration = bind(this.createNewExploration, this);
      this.ensureDashboardControllerExists = bind(this.ensureDashboardControllerExists, this);
      this.ensureLinkedWidgetControllerExists = bind(this.ensureLinkedWidgetControllerExists, this);
      this.addCurrentDashboard = bind(this.addCurrentDashboard, this);
      this.exitTvMode = bind(this.exitTvMode, this);
      this.enterTvMode = bind(this.enterTvMode, this);
      this.navigateToBillingSettings = bind(this.navigateToBillingSettings, this);
      this.notificationBarClick = bind(this.notificationBarClick, this);
      this.noWorkbooksProfileLinkClicked = bind(this.noWorkbooksProfileLinkClicked, this);
      this.orphan = bind(this.orphan, this);
      this.escapeLeftHandNav = bind(this.escapeLeftHandNav, this);
      this.applyPostEditorState = bind(this.applyPostEditorState, this);
      this.openEditor = bind(this.openEditor, this);
      this.closeNewSiteDialog = bind(this.closeNewSiteDialog, this);
      this.openNewSiteDialog = bind(this.openNewSiteDialog, this);
      this.openItem = bind(this.openItem, this);
      this.navigateTo = bind(this.navigateTo, this);
      this.leftMenuNewItemClicked = bind(this.leftMenuNewItemClicked, this);
      this.leftMenuItemClicked = bind(this.leftMenuItemClicked, this);
      this.openSettings = bind(this.openSettings, this);
      this.settingsItemClicked = bind(this.settingsItemClicked, this);
      this.showLeftMenu = bind(this.showLeftMenu, this);
      this.hideLeftMenu = bind(this.hideLeftMenu, this);
      this.exitModal = bind(this.exitModal, this);
      this.enterModal = bind(this.enterModal, this);
      this.hotkeyGlobalSearch = bind(this.hotkeyGlobalSearch, this);
      this.hotkeySaveAndClose = bind(this.hotkeySaveAndClose, this);
      this.hotkeySave = bind(this.hotkeySave, this);
      this.hotkeyEscape = bind(this.hotkeyEscape, this);
      this.hotkeyNewView = bind(this.hotkeyNewView, this);
      this.hotkeyNewChart = bind(this.hotkeyNewChart, this);
      this.hotkeySearchDashboards = bind(this.hotkeySearchDashboards, this);
      this.hotkeySearch = bind(this.hotkeySearch, this);
      this.updateChildren = bind(this.updateChildren, this);
      this.removeTextboxDrawingMode = bind(this.removeTextboxDrawingMode, this);
      this.textBoxDrawingModeChanged = bind(this.textBoxDrawingModeChanged, this);
      this.triggerSaveOnDashboardPreferences = bind(this.triggerSaveOnDashboardPreferences, this);
      this.triggerCloseOnDashboardPreferences = bind(this.triggerCloseOnDashboardPreferences, this);
      this.release = bind(this.release, this);
      AppFrameRedesign.__super__.constructor.apply(this, arguments);
      this.dashboardControllers = {};
      App.Dashboard.bind('refresh destroyed', this.removeDashboard);
      App.Dashboard.bind('ensure-dashboard-controller-exists', this.ensureDashboardControllerExists);
      App.Site.bind('enter-modal', this.enterModal);
      App.Site.bind('exit-modal', this.exitModal);
      App.Site.bind('all-updates', this.updateChildren);
      if (!AppRedesign.current().shared_mode) {
        $('#body').on('click', this.escapeLeftHandNav);
      }
      App.hotkeys.bind(App.HotkeyManager.NEW, this.hotkeyNewChart);
      App.hotkeys.bind(App.HotkeyManager.NEW_VIEW, this.hotkeyNewView);
      App.hotkeys.bind(App.HotkeyManager.SEARCH_CHARTS, this.hotkeySearchDashboards);
      App.hotkeys.bind(App.HotkeyManager.SEARCH, this.hotkeySearch);
      App.hotkeys.bind(App.HotkeyManager.ESC, this.hotkeyEscape);
      App.hotkeys.bind(App.HotkeyManager.SAVE, this.hotkeySave);
      App.hotkeys.bind(App.HotkeyManager.SAVE_AND_CLOSE, this.hotkeySaveAndClose);
      App.hotkeys.bind(App.HotkeyManager.GLOBAL_SEARCH, this.hotkeyGlobalSearch);
      AppRedesign.current().bind('text-box-drawing-mode-changed', this.textBoxDrawingModeChanged);
      this.render();
      if ((typeof performance !== "undefined" && performance !== null) && typeof performance.mark === "function") {
        performance.mark('first-render');
      }
      if (AppRedesign.hasNotificationBar()) {
        this.leftNavigation.addClass('with-notification-bar');
        this.dashboardsContainer.addClass('with-notification-bar');
        this.mainViewportReact.addClass('with-notification-bar');
      }
    }

    AppFrameRedesign.prototype.release = function() {
      var ref;
      App.Dashboard.unbind('refresh', this.removeDashboard);
      App.Dashboard.unbind('ensure-dashboard-controller-exists', this.ensureDashboardControllerExists);
      App.Site.unbind('enter-modal', this.enterModal);
      App.Site.unbind('exit-modal', this.exitModal);
      App.Site.unbind('all-updates', this.updateChildren);
      App.hotkeys.unbind(App.HotkeyManager.NEW, this.hotkeyNewChart);
      App.hotkeys.unbind(App.HotkeyManager.NEW_VIEW, this.hotkeyNewView);
      App.hotkeys.unbind(App.HotkeyManager.SEARCH_CHARTS, this.hotkeySearchDashboards);
      App.hotkeys.unbind(App.HotkeyManager.SEARCH, this.hotkeySearch);
      App.hotkeys.unbind(App.HotkeyManager.ESC, this.hotkeyEscape);
      App.hotkeys.unbind(App.HotkeyManager.SAVE, this.hotkeySave);
      App.hotkeys.unbind(App.HotkeyManager.SAVE_AND_CLOSE, this.hotkeySaveAndClose);
      App.hotkeys.unbind(App.HotkeyManager.GLOBAL_SEARCH, this.hotkeyGlobalSearch);
      AppRedesign.current().unbind('text-box-drawing-mode-changed', this.textBoxDrawingModeChanged);
      $('#body').off('click', this.escapeLeftHandNav);
      return (ref = this.notificationBarController) != null ? ref.unbind('click') : void 0;
    };

    AppFrameRedesign.prototype.triggerCloseOnDashboardPreferences = function() {
      return App.Dashboard.currentDashboard().trigger('close-dashboard-preferences');
    };

    AppFrameRedesign.prototype.triggerSaveOnDashboardPreferences = function(userId) {
      var dashboard;
      dashboard = App.Dashboard.currentDashboard();
      dashboard.user_id = userId;
      return dashboard.save({
        ajax: false
      });
    };

    AppFrameRedesign.prototype.textBoxDrawingModeChanged = function() {
      if (AppRedesign.current().newTextBoxDrawingMode) {
        return this.leftNavigation.on('mousedown', this.removeTextboxDrawingMode);
      } else {
        return this.leftNavigation.off('mousedown', this.removeTextboxDrawingMode);
      }
    };

    AppFrameRedesign.prototype.removeTextboxDrawingMode = function() {
      return AppRedesign.current().setTextBoxDrawingMode(false);
    };

    AppFrameRedesign.prototype.updateChildren = function(widgetsByDash) {
      var dashId, dashUpdate, id, results;
      results = [];
      for (dashId in widgetsByDash) {
        dashUpdate = widgetsByDash[dashId];
        id = dashId;
        results.push(AppRedesign.current().uiQueue.add(((function(_this) {
          return function() {
            var ref;
            return (ref = _this.dashboardControllers[id]) != null ? ref.updateChildren(dashUpdate) : void 0;
          };
        })(this)), 'update-dashboard', 20));
      }
      return results;
    };

    AppFrameRedesign.prototype.hotkeySearch = function(ev) {
      if (AppRedesign.dashboardOrganizationEnabled()) {
        return this.hotkeyGlobalSearch(ev);
      } else {
        return this.hotkeySearchDashboards(ev);
      }
    };

    AppFrameRedesign.prototype.hotkeySearchDashboards = function(ev) {
      ev.preventDefault();
      this.leftNavigationController.dashboardIcon.trigger('click');
      if (!this.leftMenu.searchBox) {
        return;
      }
      this.leftMenu.searchBox.val('');
      return this.leftMenu.searchBox.trigger('focus');
    };

    AppFrameRedesign.prototype.hotkeyNewChart = function() {
      if (!(this.createSqlChartsEnabledOnDashboard() || this.createDiscoveryChartEnabled())) {
        return;
      }
      if (this.isCurrentStateDash() && (this.settingsContainerController == null)) {
        return this.createNewWidget();
      } else {
        return App.RouteHelper.navigateTo('Explore');
      }
    };

    AppFrameRedesign.prototype.hotkeyNewView = function() {
      if (!this.createSqlChartEnabled()) {
        return;
      }
      if (!(this.isCurrentStateDash() && (this.settingsContainerController == null))) {
        return;
      }
      return this.createNewSqlView();
    };

    AppFrameRedesign.prototype.hotkeyEscape = function() {
      var ref;
      if (this.isCurrentStateDialog()) {
        return;
      }
      if (AppRedesign.current().newTextBoxDrawingMode) {
        AppRedesign.current().setTextBoxDrawingMode(false);
      }
      if ((ref = this.leftNavigationController) != null) {
        ref.close();
      }
      return this.checkToOpenConfirm(function() {
        return App.RouteHelper.navigateToPrev({
          force: true
        });
      });
    };

    AppFrameRedesign.prototype.hotkeySave = function(e) {
      var ref;
      if (!this.isCurrentStateEditron()) {
        return;
      }
      if (e != null) {
        e.preventDefault();
      }
      return (ref = this.editor) != null ? ref.saveClicked(false) : void 0;
    };

    AppFrameRedesign.prototype.hotkeySaveAndClose = function(e) {
      var ref;
      if (!this.isCurrentStateEditron()) {
        return;
      }
      if (e != null) {
        e.preventDefault();
      }
      return (ref = this.editor) != null ? ref.saveClicked(true) : void 0;
    };

    AppFrameRedesign.prototype.hotkeyGlobalSearch = function(e) {
      var ref;
      if (!AppRedesign.dashboardOrganizationEnabled()) {
        return;
      }
      if (e != null) {
        e.preventDefault();
      }
      App.Utils.logFeature('global-search-opened', {
        detail: 'hotkey'
      });
      return (ref = window.reactApp) != null ? ref.openGlobalSearch() : void 0;
    };

    AppFrameRedesign.prototype.isCurrentStateEditron = function() {
      return AppRedesign.current().currentState === AppRedesign.IN_EDITRON;
    };

    AppFrameRedesign.prototype.isCurrentStateDash = function() {
      return AppRedesign.current().currentState === AppRedesign.IN_DASH;
    };

    AppFrameRedesign.prototype.isCurrentStateDialog = function() {
      return AppRedesign.current().currentState === AppRedesign.IN_DIALOG;
    };

    AppFrameRedesign.prototype.isCurrentStateSingleWidget = function() {
      return AppRedesign.current().currentState === AppRedesign.IN_SINGLE_WIDGET;
    };

    AppFrameRedesign.prototype.enterModal = function() {
      if (this.inModal) {
        return;
      }
      App.PageOverlay.showWithoutCallback();
      App.Utils.animateHack(true, 'visible', this.modal);
      return this.inModal = true;
    };

    AppFrameRedesign.prototype.exitModal = function() {
      App.PageOverlay.hide();
      App.Utils.animateHack(false, 'visible', this.modal);
      return delete this.inModal;
    };

    AppFrameRedesign.prototype.hideLeftMenu = function() {
      var ref, ref1, ref2;
      if (!((ref = this.leftMenu) != null ? ref.el.hasClass('open') : void 0)) {
        return;
      }
      if ((ref1 = this.leftMenu) != null) {
        ref1.el.removeClass('open');
      }
      if ((ref2 = this.leftMenu) != null) {
        ref2.el.addClass('closing');
      }
      this.leftNavigationController.unselect();
      return setTimeout(((function(_this) {
        return function() {
          var ref3;
          if ((ref3 = _this.leftMenu) != null) {
            ref3.release();
          }
          return delete _this.leftMenu;
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    REACT_SEARCH_MODELS = ['Topic', 'View', 'Dashboard', 'SqlSnippet', 'SqlAlert'];

    AppFrameRedesign.prototype.showLeftMenu = function(menuName, title) {
      var openImmediately, ref;
      openImmediately = this.leftMenu != null;
      if ((ref = this.leftMenu) != null) {
        ref.release();
      }
      this.leftMenu = menuName === 'Settings' ? new App.LeftMenuSettings().bind('hide-menu', this.hideLeftMenu).bind('settings-item-clicked', this.settingsItemClicked) : AppRedesign.dashboardOrganizationEnabled() && REACT_SEARCH_MODELS.includes(menuName) ? new App.LeftMenuReact(menuName) : new App.LeftMenu({
        helper: new App.LeftMenuHelper(App[menuName]),
        title: title != null ? title : AppRedesign.displayName(menuName).pluralize()
      }).bind('item-clicked', this.leftMenuItemClicked).bind('add-new-clicked', this.leftMenuNewItemClicked);
      if (AppRedesign.hasCustomerUnification()) {
        this.leftMenu.el.addClass('customer-unification');
      }
      if (AppRedesign.hasNotificationBar()) {
        this.leftMenu.el.addClass('with-notification-bar');
      }
      this.append(this.leftMenu.el);
      if (openImmediately) {
        return this.leftMenu.el.addClass('open');
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.leftMenu.el.addClass('open');
          };
        })(this)), 10);
      }
    };

    AppFrameRedesign.prototype.settingsItemClicked = function(settingsControllerClass) {
      return this.navigateTo('Settings', settingsControllerClass);
    };

    AppFrameRedesign.prototype.openSettings = function(settingsControllerClass) {
      this.settingsContainerController = new App.RedesignSettingsContainerController({
        settingsControllerClass: settingsControllerClass
      });
      this.prepend(this.settingsContainerController.el);
      return this.highlightLeftNavControl('Settings');
    };

    AppFrameRedesign.prototype.leftMenuItemClicked = function(itemClass, item, widgetId) {
      var options;
      options = widgetId ? {
        widgetId: widgetId,
        force: true
      } : {};
      return this.navigateTo(itemClass, item, options);
    };

    AppFrameRedesign.prototype.leftMenuNewItemClicked = function(itemClass) {
      return this.navigateTo(itemClass);
    };

    AppFrameRedesign.prototype.navigateTo = function(itemClass, item, options) {
      if (options == null) {
        options = {};
      }
      if (App.RouteHelper.navigateTo(itemClass, item, options)) {
        return;
      }
      this.hideLeftMenu();
      return this.checkToOpenConfirm((function(_this) {
        return function() {
          _this.closeEditors();
          _this.closeSettings();
          return _this.openItem(itemClass, item, options);
        };
      })(this));
    };

    AppFrameRedesign.prototype.openItem = function(itemClass, item, options) {
      if (options == null) {
        options = {};
      }
      if (itemClass === App.Dashboard.className) {
        AppRedesign.current().setCurrentState(AppRedesign.IN_DASH);
        if (item != null ? item.isArchived() : void 0) {
          return this.showArchivedDashboard(item);
        } else if ((options != null ? options.widgetId : void 0) != null) {
          return item.activateAndScrollToWidget(options.widgetId);
        } else if (item.isActive()) {
          return this.ensureDashboardControllerExists(item);
        } else {
          return item.makeCurrent();
        }
      } else if (itemClass === App.Site.className) {
        if (item.isNewSite) {
          return this.openNewSiteDialog();
        }
      } else if (itemClass === 'Widget') {
        return this.ensureLinkedWidgetControllerExists(item);
      } else if (itemClass === 'Settings') {
        return this.openSettings(item);
      } else {
        return this.openEditorImmediately(item);
      }
    };

    AppFrameRedesign.prototype.openNewSiteDialog = function() {
      return this.newSiteDialog = new App.RedesignAddSiteController();
    };

    AppFrameRedesign.prototype.closeNewSiteDialog = function() {
      return this.newSiteDialog.close();
    };

    AppFrameRedesign.prototype.openEditor = function(item) {
      return this.checkToOpenConfirm(((function(_this) {
        return function() {
          return _this.openEditorImmediately(item);
        };
      })(this)));
    };

    AppFrameRedesign.prototype.openEditorImmediately = function(item) {
      var featureName, ref, ref1;
      AppRedesign.current().featureLogContext().setSessionIfBlank('editor');
      featureName = item.isNew() ? 'editor-open-new' : 'editor-open-edit';
      App.Utils.logFeature(featureName, {
        detail: item != null ? (ref = item.constructor) != null ? ref.className : void 0 : void 0
      });
      if ((ref1 = this.editor) != null) {
        ref1.helper.unbind('saved');
      }
      this.editor = new App.RedesignEditor({
        item: item
      }).one('close', this.applyPostEditorState);
      if (AppRedesign.hasCustomerUnification()) {
        this.editor.el.addClass('customer-unification');
      }
      if (AppRedesign.hasNotificationBar()) {
        this.editor.el.addClass('with-notification-bar');
      }
      this.prepend(this.editor.el);
      return this.highlightLeftNavControl(item.constructor.className);
    };

    AppFrameRedesign.prototype.showErrorInSourceView = function(msg) {
      var ref, ref1, ref2;
      return (ref = this.editor) != null ? (ref1 = ref.centerController) != null ? (ref2 = ref1.sourceViewer) != null ? ref2.showDependencyError(msg) : void 0 : void 0 : void 0;
    };

    AppFrameRedesign.prototype.highlightLeftNavControl = function(className) {
      this.el.find('.control.open').removeClass('open');
      return this.el.find(".control." + (className.underscore().dasherize())).addClass('open');
    };

    AppFrameRedesign.prototype.applyPostEditorState = function() {
      var createSuccessItem;
      createSuccessItem = this.editor.getCreateSuccessItem();
      App.CsvView.destroyCsvViews(window.reactApp.getUploadedFromChartEditorCsvs());
      window.reactApp.clearUploadedFromChartEditorCsvs();
      window.reactApp.setCsvMaterializationStatus(null);
      delete this.editor;
      if (this.isCurrentStateSingleWidget()) {
        if (!createSuccessItem || createSuccessItem.constructor.className !== 'Widget') {
          return;
        }
      }
      if (!this.linkedWidgetController) {
        return;
      }
      this.linkedWidgetController.close();
      delete this.linkedWidgetController;
      if (createSuccessItem) {
        return setTimeout((function() {
          return App.Dashboard.currentDashboard().trigger('scroll-to-widget', createSuccessItem.id);
        }));
      }
    };

    AppFrameRedesign.prototype.escapeLeftHandNav = function(ev) {
      if ($(ev.target).parents('.left-menu,.left-navigation,#react-simple-tooltip').length === 0) {
        return this.leftNavigationController.close();
      }
    };

    AppFrameRedesign.prototype.render = function() {
      var noDbMode, ref, ref1;
      if (AppRedesign.hasCustomerUnification()) {
        this.switcherDropdownOptionsVisible = false;
        this.html(this.view('app_frame/app_frame_redesign_unification')({
          selfServiceAccessEnabled: (ref = AppRedesign.current().state.CustomerUnificationFields) != null ? ref.self_service_dashboards_access : void 0
        }));
      } else {
        this.html(this.view('app_frame/app_frame_redesign'));
      }
      $('#body').attr('data-browser', BrowserDetect.browser);
      $('#body').attr('data-mobile', AppRedesign.current().onMobileOs);
      if (this.appHasNoDashboards()) {
        this.orphan();
      }
      noDbMode = this.appHasNoDatabases() && (this.sharedMode == null);
      if (AppRedesign.hasCustomerUnification() && !AppRedesign.hasWorkbooksAccess()) {
        this.displayNoWorkbooksMessage();
      } else if (AppRedesign.current().state.RbacEnabled && !AppRedesign.hasPrivileges()) {
        this.displayNoPrivilegesMessage();
      } else if (this.appHasNoDashboards() && !AppRedesign.createDashboardsEnabled()) {
        this.displayNoContentMessage();
      } else if (noDbMode) {
        this.orphanDatabase();
      }
      this.notificationBarController = new App.NotificationBarController({
        el: this.notificationBar
      });
      this.notificationBarController.bind('click', this.notificationBarClick);
      if (!((ref1 = AppRedesign.current()) != null ? ref1.shared_mode : void 0)) {
        this.leftNavigationController = new App.RedesignLeftNavigation({
          el: this.leftNavigation,
          noDbMode: noDbMode
        });
        this.leftNavigationController.bind('show-menu', this.showLeftMenu);
        this.leftNavigationController.bind('hide-menu', this.hideLeftMenu);
        return this.maybeOpenEditor();
      }
    };

    AppFrameRedesign.prototype.maybeOpenEditor = function() {
      if (this.linkedWidget() && AppRedesign.widgetEditMode()) {
        return this.openEditor(this.linkedWidget());
      }
    };

    AppFrameRedesign.prototype.appHasNoDashboards = function() {
      return App.Dashboard.count() === 0;
    };

    AppFrameRedesign.prototype.appHasNoDatabases = function() {
      return !App.Database.any();
    };

    AppFrameRedesign.prototype.orphan = function() {
      var ref;
      if (this.orphaned) {
        return;
      }
      this.orphaned = true;
      return (ref = AppRedesign.current().spinalCord) != null ? ref.stopUpdates() : void 0;
    };

    AppFrameRedesign.prototype.orphanDatabase = function() {
      this.orphan();
      if (App.User.safeCurrentUser().isAdmin()) {
        new App.RedesignConfigitronController();
      }
      return this.noDbMessage.show();
    };

    AppFrameRedesign.prototype.displayNoPrivilegesMessage = function() {
      return this.noPrivilegesMessage.show();
    };

    AppFrameRedesign.prototype.displayNoContentMessage = function() {
      return this.noContentMessage.show();
    };

    AppFrameRedesign.prototype.displayNoWorkbooksMessage = function() {
      return this.noWorkbooksMessage.show();
    };

    AppFrameRedesign.prototype.noWorkbooksProfileLinkClicked = function(ev) {
      return App.RouteHelper.navigateTo('Settings', App.RedesignSettingsAccountController);
    };

    AppFrameRedesign.prototype.notificationBarClick = function(clickType) {
      if (clickType === 'upgrade-link') {
        return this.navigateToBillingSettings();
      }
    };

    AppFrameRedesign.prototype.navigateToBillingSettings = function() {
      return this.settingsItemClicked(App.RedesignBillingSecurityController);
    };

    AppFrameRedesign.prototype.enterTvMode = function() {
      var dashboardId, el, ref;
      dashboardId = (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0;
      if (!dashboardId) {
        return;
      }
      this.el.addClass('tv-mode-parent');
      this.tvModeFrame[0].src = AppRedesign.pathForSiteHost({
        queryStr: "?tv_mode_frame=true",
        dashboardId: dashboardId
      });
      el = this.el[0];
      if (el.requestFullScreen != null) {
        el.requestFullScreen();
        return $(document).on('fullscreenchange', this.exitTvMode);
      } else if (el.webkitRequestFullScreen != null) {
        el.webkitRequestFullScreen();
        return $(document).on('webkitfullscreenchange', this.exitTvMode);
      } else if (el.mozRequestFullScreen != null) {
        el.mozRequestFullScreen();
        return $(document).on('mozfullscreenchange', this.exitTvMode);
      }
    };

    AppFrameRedesign.prototype.exitTvMode = function() {
      if (!App.Utils.appIsFullscreen()) {
        this.tvModeFrame[0].src = '/blank';
        this.el.removeClass('tv-mode-parent');
        $(document).off('fullscreenchange', this.exitTvMode);
        $(document).off('webkitfullscreenchange', this.exitTvMode);
        return $(document).off('mozfullscreenchange', this.exitTvMode);
      }
    };

    AppFrameRedesign.prototype.linkedWidget = function() {
      return App.Widget.exists(AppRedesign.widgetIdInUrl());
    };

    AppFrameRedesign.prototype.inSingleWidgetMode = function() {
      return AppRedesign.widgetIdInUrl();
    };

    AppFrameRedesign.prototype.addCurrentDashboard = function() {
      var w;
      if (this.inSingleWidgetMode()) {
        if (this.linkedWidget()) {
          w = this.linkedWidget();
        }
        return this.ensureLinkedWidgetControllerExists(w);
      } else {
        this.ensureDashboardControllerExists(App.Dashboard.currentDashboard());
        return this.highlightLeftNavControl(App.Dashboard.className);
      }
    };

    AppFrameRedesign.prototype.ensureLinkedWidgetControllerExists = function(widget) {
      if (widget != null) {
        widget.setHashKey(this.linked_widget_hash_key);
      }
      if (widget != null) {
        widget.setCodeHashKey(this.code_linked_widget_hash_key);
      }
      if (!this.linkedWidgetController) {
        this.linkedWidgetController = new App.RedesignLinkedWidgetController({
          widget: widget
        });
        this.linkedWidgetController.bind('edit-widget', this.openEditor);
      }
      this.dashboardsContainer.append(this.linkedWidgetController.el);
      if (AppRedesign.current().embed_mode) {
        this.linkedWidgetController.setWidgetPosition();
      }
      return this.linkedWidgetController;
    };

    AppFrameRedesign.prototype.ensureDashboardControllerExists = function(dashboard) {
      if (!dashboard || this.orphaned) {
        return;
      }
      return this.dashboardControllers[dashboard.id] || this.dashboardControllers[dashboard.cid] || this.addDashboard(dashboard);
    };

    AppFrameRedesign.prototype.cleanUpLinkedWidgetState = function() {
      if (this.linkedWidgetController == null) {
        return;
      }
      this.linkedWidgetController.release();
      return delete this.linkedWidgetController;
    };

    AppFrameRedesign.prototype.onTextBoxIconClicked = function() {
      return AppRedesign.current().setTextBoxDrawingMode(true);
    };

    AppFrameRedesign.prototype.createNewTextBox = function(column, row, width, height) {
      var tempWidget, user, widgetAttributes;
      user = App.User.currentUser();
      widgetAttributes = {
        dashboard_id: App.Dashboard.currentDashboard().id,
        user_id: user.isTemporary() ? null : user.id,
        chart_type: 'text_box',
        database_id: App.Widget.defaultDatabase(),
        sql: 'N/A',
        content_type: 'TextBox',
        fluid_height: height,
        fluid_width: width,
        fluid_column: column,
        fluid_row: row
      };
      tempWidget = new App.Widget(widgetAttributes);
      tempWidget.save({
        ajax: false
      });
      return jQuery.ajax({
        url: '/widgets/create_text_widget',
        type: 'POST',
        data: {
          client_site_id: App.Site.first().id,
          widget: widgetAttributes
        },
        dataType: 'json'
      }).done(function(response) {
        var textBox, widget;
        AppRedesign.current().spinalCord.applyAllTheUpdates(response);
        tempWidget.destroy();
        textBox = response.TextBox.first();
        widget = App.Widget.find(response.Widget.first().id);
        widget.dashboard().trigger("resized-widget", widget);
        return window.reactApp.enterEditingTextBox(textBox);
      }).fail(function(response) {
        if (response.status === HttpCodes.permissionDenied) {
          tempWidget.destroy();
          return Spine.trigger('permission_denied');
        }
      });
    };

    AppFrameRedesign.prototype.createNewExploration = function() {
      AppRedesign.current().featureLogContext().setSession('editor-exploration');
      App.Utils.logFeature('editor-explore-start');
      return this.createNewWidgetWithState('Untitled Exploration', 30, 10, 0, {
        is_exploration: true
      });
    };

    AppFrameRedesign.prototype.createNewWidget = function() {
      var dashboard, dashboardSizer, initHeight, initRow, initWidth, title;
      title = App.Widget.NEW_CHART_NAME;
      dashboard = App.Dashboard.currentDashboard();
      dashboardSizer = new App.RedesignDashboardSizer(dashboard);
      initHeight = dashboardSizer.EDITOR_INITIAL_HEIGHT;
      initWidth = dashboardSizer.EDITOR_INITIAL_WIDTH;
      initRow = dashboard.nextFreeRow();
      return this.createNewWidgetWithState(title, initWidth, initHeight, initRow, {
        dashboard_id: dashboard.id
      });
    };

    AppFrameRedesign.prototype.createNewWidgetWithState = function(title, initWidth, initHeight, initRow, optionalAttrs) {
      var attrs, chartType, databaseId, datasetId, discoveryPermissionOnly, newWidget, ref, ref1, twiddles, user;
      if (optionalAttrs == null) {
        optionalAttrs = {};
      }
      user = App.User.currentUser();
      chartType = 'table';
      databaseId = App.Widget.defaultDatabase();
      twiddles = {
        use_default_chart_type: true,
        continuous_x_axis: true,
        twiddle_legend_position: 'right'
      };
      if (AppRedesign.dragDropEnabled()) {
        discoveryPermissionOnly = this.createDiscoveryEnabledOnly();
        datasetId = user != null ? user.getLastUsedDatasetId() : void 0;
        if (!App.Dataset.exists(datasetId)) {
          datasetId = discoveryPermissionOnly ? (ref = App.Dataset.first()) != null ? ref.id : void 0 : null;
        }
        if ((datasetId != null) || discoveryPermissionOnly) {
          chartType = 'cohort';
          _.merge(twiddles, {
            twiddle_drag_drop_chart: true,
            dragDrop: {
              selectedDatasetId: datasetId
            }
          });
        }
        if (datasetId) {
          databaseId = (ref1 = App.Dataset.find(datasetId).explorable()) != null ? ref1.database_id : void 0;
        }
      }
      attrs = Object.assign({
        user_id: user.isTemporary() ? null : user.id,
        chart_type: chartType,
        database_id: databaseId,
        sql: '',
        title: title,
        twiddles: twiddles,
        csv_download_disabled: Boolean(App.Site.first().csv_download_disable_on_new_charts)
      }, optionalAttrs);
      newWidget = new App.Widget(attrs);
      newWidget.setHeight(initHeight);
      newWidget.setWidth(initWidth);
      newWidget.setColumn(0);
      newWidget.setRow(initRow);
      return this.openEditor(newWidget);
    };

    AppFrameRedesign.prototype.createNewSqlView = function() {
      return this.openEditor(App.LeftMenuHelper.newItem(App.SqlView));
    };

    AppFrameRedesign.prototype.addDashboard = function(dashboard) {
      var dashboardController;
      dashboardController = new App.RedesignDashboardsController({
        item: dashboard
      }).bind('create-new-text-box', this.createNewTextBox).bind('text-box-icon-clicked', this.onTextBoxIconClicked).bind('new-widget', this.createNewWidget).bind('edit-widget', this.openEditor).bind('released', this.uncacheController);
      if (!dashboard.isArchived()) {
        this.dashboardControllers[dashboard.id] = dashboardController;
      }
      this.dashboardsContainer.append(dashboardController.el);
      return dashboardController;
    };

    AppFrameRedesign.prototype.uncacheController = function(item) {
      return delete this.dashboardControllers[item.id];
    };

    AppFrameRedesign.prototype.removeDashboard = function(dashboard) {
      var controller;
      if (!this.dashboardControllers[dashboard.id]) {
        return;
      }
      controller = this.dashboardControllers[dashboard.id];
      controller.release();
      return delete this.dashboardControllers[dashboard.id];
    };

    AppFrameRedesign.prototype.showArchivedDashboard = function(dashboard) {
      this.archivedDashboardController = new App.RedesignDashboardsController({
        item: dashboard
      });
      this.archivedDashboardController.dashboardMadeCurrent();
      return this.dashboardsContainer.append(this.archivedDashboardController.el);
    };

    AppFrameRedesign.prototype.hideLoadingMessage = function() {};

    AppFrameRedesign.prototype.closeEditors = function() {
      var ref;
      return (ref = this.editor) != null ? ref.release() : void 0;
    };

    AppFrameRedesign.prototype.closeSettings = function() {
      var ref;
      if ((ref = this.settingsContainerController) != null) {
        ref.release();
      }
      return delete this.settingsContainerController;
    };

    AppFrameRedesign.prototype.closeArchivedDashboard = function() {
      var ref;
      if ((ref = this.archivedDashboardController) != null) {
        ref.release();
      }
      return delete this.archivedDashboardController;
    };

    AppFrameRedesign.prototype.checkToOpenConfirm = function(openImmediatelyFunc, cancelFunc) {
      var ref, unbindFunc;
      if ((ref = this.editor) != null ? ref.headerController.cancelIsDestructive : void 0) {
        this.editor.headerController.showWarningModal();
        this.editor.headerController.confirmController.bind('cancel', openImmediatelyFunc);
        if (cancelFunc) {
          this.editor.headerController.confirmController.bind('release', cancelFunc);
        }
        this.editor.helper.bind('saved', openImmediatelyFunc);
        unbindFunc = (function(_this) {
          return function() {
            var ref1, ref2;
            _this.editor.helper.unbind('saved', openImmediatelyFunc);
            if ((ref1 = _this.editor.headerController.confirmController) != null) {
              ref1.unbind('cancel', openImmediatelyFunc);
            }
            if (cancelFunc) {
              return (ref2 = _this.editor.headerController.confirmController) != null ? ref2.unbind('release', cancelFunc) : void 0;
            }
          };
        })(this);
        return this.editor.helper.bind('error', unbindFunc);
      } else {
        return openImmediatelyFunc();
      }
    };

    AppFrameRedesign.prototype.startScreenTransitionAnimation = function() {
      var loaderSpeed, ref, timer1;
      if ((ref = this.screenTransitionAnimationTimers) != null) {
        ref.forEach(clearTimeout);
      }
      if (this.screenTransitionAnimationTimers == null) {
        this.screenTransitionAnimationTimers = [];
      }
      this.loaderLine.removeClass('step-1 step-2');
      loaderSpeed = 400;
      timer1 = setTimeout(((function(_this) {
        return function() {
          var timer2;
          _this.loaderLine.addClass('step-1');
          timer2 = setTimeout((function() {
            var timer3;
            _this.loaderLine.addClass('step-2');
            timer3 = setTimeout((function() {
              return _this.loaderLine.removeClass('step-1 step-2');
            }), loaderSpeed);
            return _this.screenTransitionAnimationTimers.push(timer3);
          }), loaderSpeed);
          return _this.screenTransitionAnimationTimers.push(timer2);
        };
      })(this)), 1);
      return this.screenTransitionAnimationTimers.push(timer1);
    };

    AppFrameRedesign.prototype.createDiscoveryEnabledOnly = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createDiscoveryChartsEnabledOnDashboard() && !AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return App.User.currentUser().canExplore() && !App.User.currentUser().canEdit();
      }
    };

    AppFrameRedesign.prototype.createSqlChartEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return App.User.currentUser().canEdit();
      }
    };

    AppFrameRedesign.prototype.createSqlChartsEnabledOnDashboard = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return App.User.currentUser().canEdit();
      }
    };

    AppFrameRedesign.prototype.createDiscoveryChartEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createDiscoveryChartsEnabledOnDashboard();
      } else {
        return App.User.currentUser().canExplore();
      }
    };

    AppFrameRedesign.renderPermissionDeniedNotice = function() {
      return new App.RedesignPermissionDeniedController();
    };

    AppFrameRedesign.prototype.toggleDropdownOptions = function() {
      if (!AppRedesign.current().state.CustomerUnificationFields.self_service_dashboards_access) {
        return;
      }
      if (this.switcherDropdownOptionsVisible) {
        this.switcherDropdownOptionsVisible = false;
        return this.switcherDropdownOptions.hide();
      } else {
        this.switcherDropdownOptionsVisible = true;
        return this.switcherDropdownOptions.show();
      }
    };

    AppFrameRedesign.prototype.switchToSisense = function() {
      var sisense_url;
      if (!AppRedesign.current().state.CustomerUnificationFields.self_service_dashboards_access) {
        return;
      }
      sisense_url = AppRedesign.current().state.CustomerUnificationFields.sisense_deployment;
      App.Utils.logFeature('self-service-switch-to-sisense', {
        user_id: App.User.currentUser().id
      });
      return window.open(sisense_url, "_blank") || window.location.replace(sisense_url);
    };

    return AppFrameRedesign;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.BatchWidgetRefreshHelper = (function(superClass) {
    extend(BatchWidgetRefreshHelper, superClass);

    BatchWidgetRefreshHelper.BATCH_SIZE = 10;

    function BatchWidgetRefreshHelper(dashboard) {
      this.dashboard = dashboard;
      this.handleRefreshResponse = bind(this.handleRefreshResponse, this);
      this.remainingWidgets = this.dashboard.widgets();
    }

    BatchWidgetRefreshHelper.prototype.refreshFilters = function() {
      return this.refresh(true);
    };

    BatchWidgetRefreshHelper.prototype.refreshAll = function() {
      return this.refresh(false);
    };

    BatchWidgetRefreshHelper.prototype.refresh = function(filterChange) {
      return _.forEach(_.chunk(this.remainingWidgets, this.constructor.BATCH_SIZE), (function(_this) {
        return function(partition) {
          var i, len, widget;
          for (i = 0, len = partition.length; i < len; i++) {
            widget = partition[i];
            widget.prepareForNewData();
          }
          Spine.Ajax.queue(function() {
            return jQuery.post("/dashboards/" + _this.dashboard.id + "/refresh_charts", {
              filter_change: filterChange,
              widget_ids: _.map(partition, 'id'),
              skippable_hash_keys: _.map(partition, function(w) {
                return w.hashKey();
              })
            }).done(_this.handleRefreshResponse).fail(function(r) {
              return _this.handleRefreshFailure(r, partition);
            });
          });
          return App.Site.trigger('request-several-updates');
        };
      })(this));
    };

    BatchWidgetRefreshHelper.prototype.handleRefreshResponse = function(response) {
      if (response.hash_keys == null) {
        return;
      }
      return _.map(response.hash_keys, function(hashKey, wid) {
        var w;
        if (hashKey != null) {
          w = App.Widget.exists(wid);
          if (w) {
            return w.handleRefreshResponse({
              hash_key: hashKey
            });
          }
        }
      });
    };

    BatchWidgetRefreshHelper.prototype.handleRefreshFailure = function(response, widgetsToFetch) {
      return this.unsetPendingWidgetUpdate(widgetsToFetch, true);
    };

    BatchWidgetRefreshHelper.prototype.unsetPendingWidgetUpdate = function(widgetsToFetch, feSave) {
      var i, len, results, widget;
      if (feSave == null) {
        feSave = false;
      }
      results = [];
      for (i = 0, len = widgetsToFetch.length; i < len; i++) {
        widget = widgetsToFetch[i];
        widget.server_update_pending = false;
        if (feSave) {
          results.push(widget.save({
            ajax: false
          }));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return BatchWidgetRefreshHelper;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ButterBarController = (function(superClass) {
    extend(ButterBarController, superClass);

    ButterBarController.prototype.elements = {
      '.butter-bar-message': 'butterBarMessage'
    };

    ButterBarController.prototype.events = {
      'click .plan-upgrade-link': 'clickUpgradeLink'
    };

    function ButterBarController() {
      this.clickUpgradeLink = bind(this.clickUpgradeLink, this);
      ButterBarController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.overageData = AppRedesign.current().overageData;
      this.render();
    }

    ButterBarController.prototype.render = function() {
      this.overageDataPresenter = new App.OverageDataPresenter(this.overageData);
      this.html(this.view('app_frame/overage_notification')({
        overageDataPresenter: this.overageDataPresenter
      }));
      this.el.show();
      return this.logFeature('butter-bar-shown');
    };

    ButterBarController.prototype.clickUpgradeLink = function() {
      this.trigger('click', 'upgrade-link');
      return this.logFeature('butter-bar-clicked');
    };

    ButterBarController.prototype.logFeature = function(featureName) {
      var context, detail;
      detail = this.overageDataPresenter.keysPresent().toString();
      context = _.trim(this.butterBarMessage.text().replace(/\s\s+/g, ' '));
      return App.Utils.logFeature(featureName, {
        detail: detail,
        context: context
      });
    };

    ButterBarController.shouldShow = function() {
      return AppRedesign.current().overageData != null;
    };

    return ButterBarController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.BenchmarkChartographer = (function() {
    function BenchmarkChartographer() {}

    BenchmarkChartographer.renderWithChartographer = function(widget, source) {
      var chartData, ref, twiddles;
      twiddles = $.extend(true, {}, widget.twiddles || {});
      twiddles['twiddle_chart_type'] = widget.chart_type;
      if (source.has_order_by === true) {
        twiddles['twiddle_do_not_sort_series'] = true;
      }
      if (((ref = source.sql) != null ? ref.toLowerCase().indexOf('order by') : void 0) !== -1) {
        twiddles['twiddle_do_not_sort_series'] = true;
      }
      twiddles['twiddle_chart_type'] = widget.chart_type;
      twiddles['twiddle_insertotron_segment_columns'] = widget.segmentColumnsFromInsertotron();
      twiddles;
      return chartData = new App.Chartographer.convert(widget.getRows(), widget.getColumns(), twiddles);
    };

    BenchmarkChartographer.testCurrent = function(n) {
      var i, j, k, len, ref, start, times, w, wList;
      if (n == null) {
        n = 1;
      }
      wList = App.Dashboard.currentDashboard().widgets();
      times = [];
      for (i = j = 0, ref = n; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        App.TimeMachine.clearCache();
        start = performance.now();
        App.TimeMachine.readCacheFromLocalStorage();
        for (k = 0, len = wList.length; k < len; k++) {
          w = wList[k];
          if (w.row < 4) {
            BenchmarkChartographer.renderWithChartographer(w, w.selectedFormulaSource());
          }
        }
        times.push(performance.now() - start);
      }
      return times.sum() / times.length;
    };

    BenchmarkChartographer.dateParsing = function() {
      var browserDateFn, cloneMomentAndChangeFn, cloneMomentFn, d, dates, i, j, m, momentFn, momentTimestampFn, newFn, ninjaFn, oldFn;
      dates = [];
      d = moment('2014-01-01');
      for (i = j = 0; j < 1000; i = ++j) {
        d.add('day', 1);
        dates.push(d.format('YYYY-MM-DD'));
      }
      oldFn = (function() {
        var date, k, len, results;
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(App.Utils.parseDate(date, true));
        }
        return results;
      });
      newFn = (function() {
        var date, k, len, results;
        App.TimeMachine.clearCache();
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(App.TimeMachine.parseDateTimeToTimestamp(date, 'America/Los_Angeles', 1));
        }
        return results;
      });
      momentFn = (function() {
        var date, k, len, results;
        App.TimeMachine.clearCache();
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(moment(date));
        }
        return results;
      });
      momentTimestampFn = (function() {
        var date, k, len, results;
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          d = App.Utils.parseDate(date, true);
          results.push(moment(d));
        }
        return results;
      });
      browserDateFn = (function() {
        var date, k, len, results;
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          d = App.Utils.parseDate(date, true);
          results.push(new Date(d));
        }
        return results;
      });
      m = moment();
      cloneMomentFn = (function() {
        var date, k, len, results;
        App.TimeMachine.clearCache();
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(m.clone());
        }
        return results;
      });
      m = moment();
      cloneMomentAndChangeFn = (function() {
        var date, k, len, results;
        App.TimeMachine.clearCache();
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(m = m.clone().year(2010).month(5).date(12));
        }
        return results;
      });
      ninjaFn = (function() {
        var date, k, len, results;
        App.TimeMachine.clearCache();
        App.Utils.DATE_CACHE = {};
        results = [];
        for (k = 0, len = dates.length; k < len; k++) {
          date = dates[k];
          results.push(m = App.TimeMachine.parseYearMonthDay(date, 'America/Los_Angeles'));
        }
        return results;
      });
      this.benchmark('old date parsing', 10, oldFn);
      this.benchmark('time machine date parsing', 10, newFn);
      this.benchmark('moment date parsing', 10, momentFn);
      this.benchmark('moment timestamp parsing', 10, momentTimestampFn);
      this.benchmark('browser date', 10, browserDateFn);
      this.benchmark('clone moment', 10, cloneMomentAndChangeFn);
      return this.benchmark('ninja moment', 10, ninjaFn);
    };

    BenchmarkChartographer.dateAndOtherChartographer = function() {
      var columns, d, fn, i, j, name, row, rows;
      rows = [];
      columns = ['date', 'category', 'value'];
      d = moment('2014-01-01');
      for (i = j = 0; j < 5000; i = ++j) {
        row = {
          date: d.format('YYYY-MM-DD'),
          category: 'c_' + i,
          value: i
        };
        rows.push(row);
        d.add('day', 1);
      }
      if (!App.ChartUtils.columnDateTimeType('date', rows)) {
        throw new Error('should be datetime');
      }
      name = '5k dates and categories';
      fn = (function() {
        App.TimeMachine.clearCache();
        return App.Chartographer.convert(rows, columns, {
          twiddle_chart_type: 'line'
        });
      });
      this.benchmark(name, 5, fn);
      return this.profile(name, fn);
    };

    BenchmarkChartographer.bigTable = function() {
      var columns, fn, i, j, name, row, rows;
      rows = [];
      columns = ['date', 'category', 'value', 'x', 'y', 'z'];
      for (i = j = 0; j < 50000; i = ++j) {
        row = {
          date: 'd_' + i,
          category: 'c_' + i,
          value: i,
          x: 'x',
          y: 'y',
          z: 'z'
        };
        rows.push(row);
      }
      name = 'BigTable';
      fn = (function() {
        App.TimeMachine.clearCache();
        return App.Chartographer.convert(rows, columns, {
          twiddle_chart_type: 'table'
        });
      });
      this.benchmark(name, 5, fn);
      return this.profile(name, fn);
    };

    BenchmarkChartographer.makeAllSeries = function() {
      var columns, d, fn, i, j, name, row, rows, sac;
      rows = [];
      columns = ['date', 'category', 'value'];
      d = moment('2014-01-01');
      for (i = j = 0; j < 5000; i = ++j) {
        row = {
          date: d.format('YYYY-MM-DD'),
          category: 'c_' + i,
          value: i
        };
        rows.push(row);
        d.add('day', 1);
      }
      if (!App.ChartUtils.columnDateTimeType('date', rows)) {
        throw new Error('should be datetime');
      }
      sac = new App.SingleAxisChartographer(rows, columns, 'line', {});
      sac.calculateProperties();
      name = '5k dates and categories, makeAllSeries';
      fn = (function() {
        App.TimeMachine.clearCache();
        return sac.makeAllSeries();
      });
      this.benchmark(name, 30, fn);
      return this.profile(name, fn);
    };

    BenchmarkChartographer.benchmark = function(name, trials, fn) {
      var elapsedTime, i, j, ref, startTime;
      startTime = AppRedesign.timestamp();
      for (i = j = 0, ref = trials; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        fn();
      }
      elapsedTime = AppRedesign.timestamp() - startTime;
      return console.info(name, '' + Math.round(elapsedTime / trials) + 'ms');
    };

    BenchmarkChartographer.profile = function(name, fn) {
      console.profile(name);
      fn();
      return console.profileEnd(name);
    };

    return BenchmarkChartographer;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.ColumnProcessor = (function(superClass) {
    extend(ColumnProcessor, superClass);

    ColumnProcessor.HIDDEN_COLUMNS = ['periscope_dimension', 'periscope_no_segmentation'];

    ColumnProcessor.INDEX_COLUMN = 'periscope_index';

    function ColumnProcessor(rows1, columns1, twiddles, twiddlesActual) {
      this.rows = rows1;
      this.columns = columns1;
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
      this.preferNumericColumns = bind(this.preferNumericColumns, this);
      this.filterNumericColumns = bind(this.filterNumericColumns, this);
      this.rows = this.rows.slice(0);
      this.columns = this.columns.slice(0).withoutAny(ColumnProcessor.HIDDEN_COLUMNS);
      this.columnTypes = {};
      this.columnDateTypes = {};
      this.setTwiddlesFromSite();
    }

    ColumnProcessor.prototype.columnsWithoutPoints = function() {
      return this.columns.withoutAny(this.pointCols());
    };

    ColumnProcessor.prototype.isColumnarSeries = function() {
      return this.actual('columnar_series');
    };

    ColumnProcessor.prototype.allowsStringValueCols = function() {
      return App.ChartUtils.CHART_TYPES_ALLOW_STRING_VALUE_COLS.includes(this.mainChartType());
    };

    ColumnProcessor.prototype.chartAllowsSegmentation = function() {
      if (this.mainChartType() === 'pie') {
        return true;
      }
      if (this.columns.length < 3 && !App.ChartUtils.CHART_TYPES_ALLOW_POINT_AND_VALUE.includes(this.twiddle('chart_type'))) {
        return false;
      }
      return !App.ChartUtils.CHART_TYPES_DISALLOW_SEGMENTATION.includes(this.mainChartType());
    };

    ColumnProcessor.prototype.reservedValueColumnNames = function() {
      if (this.mainChartType() === 'geomap' && this.twiddle('geomap_data_mode') === 'geojson') {
        return [];
      }
      return this.getColumnNames(this.reservedValueColumns());
    };

    ColumnProcessor.prototype.reservedValueColumns = function() {
      var valueColumns;
      valueColumns = this.parseArrayTwiddle('value_columns');
      return valueColumns.filter((function(_this) {
        return function(valueColumn) {
          return _this.columns.includes(valueColumn.column_name);
        };
      })(this));
    };

    ColumnProcessor.prototype.reservedY2Cols = function() {
      var twiddleCols;
      if (!this.twiddle('secondary_axis_enabled')) {
        return [];
      }
      twiddleCols = this.parseArrayTwiddle('secondary_axis_series_names');
      return App.Utils.intersect(twiddleCols, this.columns, false, false);
    };

    ColumnProcessor.prototype.reservedSegmentCols = function() {
      var insertotronSegmentCols, twiddleCols;
      twiddleCols = this.parseArrayTwiddle('segment_column');
      insertotronSegmentCols = this.twiddle('twiddle_insertotron_segment_columns') || [];
      if (insertotronSegmentCols.length) {
        twiddleCols = twiddleCols.concat(insertotronSegmentCols).unique();
      }
      return App.Utils.intersect(twiddleCols, this.columns, false, false);
    };

    ColumnProcessor.prototype.reservedDetailCols = function() {
      var twiddleCols;
      twiddleCols = this.parseArrayTwiddle('detail_columns');
      return App.Utils.intersect(twiddleCols, this.columns, false, false);
    };

    ColumnProcessor.prototype.setColumnNames = function(valueColumns) {
      return valueColumns.map(function(column) {
        return {
          column_name: column
        };
      });
    };

    ColumnProcessor.prototype.getColumnNames = function(valueColumns) {
      return valueColumns.map(function(column) {
        return column.column_name;
      });
    };

    ColumnProcessor.prototype.pickAllColumns = function() {
      var ref;
      this.setUsePivotSettings();
      this.setChartType();
      this.transposeSingleRowCharts();
      this.indexSingleColumnCharts();
      ref = App.ColumnProcessor.pickColumnTypes(this.rows, this.columns), this.columnTypes = ref[0], this.columnDateTypes = ref[1];
      this.pickPointCols();
      this.downgradeExtraYearWeeks();
      this.createTypedRows();
      this.pickSegmentCols();
      this.setIsColumnarSeries(this.columnsWithoutPoints());
      this.pickValueCols();
      this.setExplicitColumnOverrides();
      this.setAxisType();
      this.error = this.checkNumberOfColumns();
      if (this.error != null) {
        return this.error;
      }
      this.setColumnTwiddles();
      this.forwardColumnsIfPresent('detail_columns');
      this.forwardColumnsIfPresent('geomap_weight_columns');
      this.error = this.checkPropertyErrors();
      return this.error != null;
    };

    ColumnProcessor.prototype.setUsePivotSettings = function() {
      var pointCols, segmentCols, usePivotSettings, valueCols;
      usePivotSettings = this.twiddle('use_pivot_settings');
      pointCols = App.Utils.intersect(this.twiddles.getArray('point_cols'), this.columns);
      segmentCols = App.Utils.intersect(this.twiddles.getArray('segment_column'), this.columns);
      valueCols = App.Utils.intersect(this.getColumnNames(this.twiddles.getArray('value_columns')), this.columns);
      usePivotSettings && (usePivotSettings = pointCols.length > 0 || segmentCols.length > 0 || valueCols.length > 0);
      return this.setActual('use_pivot_settings', usePivotSettings);
    };

    ColumnProcessor.prototype.setChartType = function() {
      if (this.twiddle('chart_type') === 'cohort' && this.twiddle('use_pivot_settings') && !this.actual('use_pivot_settings')) {
        return this.setActual('chart_type', 'table');
      } else if (this.actual('use_pivot_settings')) {
        return this.setActual('chart_type', 'cohort');
      } else {
        return this.forwardIfPresent('chart_type');
      }
    };

    ColumnProcessor.prototype.setAxisType = function() {
      var ref, ref1, xColumnType;
      if (!(((ref = this.pointCols()) != null ? ref.length : void 0) > 0)) {
        return;
      }
      xColumnType = this.columnTypes[this.xCol()];
      if (xColumnType === App.Chartographer.DATETIME_COLUMN_TYPE) {
        return this.setActual('x_axis_type', App.Chartographer.TIMESERIES_AXIS_TYPE);
      } else if (xColumnType === App.Chartographer.NUMERIC_COLUMN_TYPE && this.twiddle('continuous_x_axis') && (ref1 = this.mainChartType(), indexOf.call(App.ChartUtils.CHART_TYPES_ALLOW_CONT_X, ref1) >= 0)) {
        return this.setActual('x_axis_type', App.Chartographer.NUMERIC_AXIS_TYPE);
      }
    };

    ColumnProcessor.prototype.transposeSingleRowCharts = function() {
      var c;
      if (['table', 'geomap'].includes(this.mainChartType())) {
        return;
      }
      if (this.mainChartType() === 'cohort' && this.twiddle('drag_drop_chart')) {
        return;
      }
      if (!(this.rows.length === 1 && this.columns.length > 2 && App.ChartUtils.everyValueNumeric(this.rows[0]))) {
        return;
      }
      this.rows = (function() {
        var j, len, ref, results;
        ref = this.columns;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          c = ref[j];
          results.push({
            category: c,
            value: this.rows[0][c]
          });
        }
        return results;
      }).call(this);
      return this.columns = ['category', 'value'];
    };

    ColumnProcessor.prototype.indexSingleColumnCharts = function() {
      var i, j, len, r, ref;
      if (['table', 'cohort', 'geomap'].includes(this.mainChartType())) {
        return;
      }
      if (!this.checkIfAddIndex()) {
        return;
      }
      ref = this.rows;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        r = ref[i];
        r[App.ColumnProcessor.INDEX_COLUMN] = "" + i;
      }
      return this.columns.unshift(App.ColumnProcessor.INDEX_COLUMN);
    };

    ColumnProcessor.prototype.checkIfAddIndex = function() {
      var ref;
      if (this.twiddle('drag_drop_chart') && ((ref = this.twiddle('point_cols')) != null ? ref.includes(App.ColumnProcessor.INDEX_COLUMN) : void 0)) {
        return true;
      }
      return this.columns.length === 1 || App.ChartUtils.alwaysIndex(this.twiddles);
    };

    ColumnProcessor.prototype.setColumnTwiddles = function() {
      var column, j, len, ref;
      ref = this.columns;
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        this.setColumnActual(column, 'type', this.columnTypes[column]);
      }
      return this.setActual('column_names', this.columns);
    };

    ColumnProcessor.pickColumnTypes = function(rows, columns) {
      var column, columnDateTypes, columnTypes, j, len;
      columnTypes = {};
      columnDateTypes = {};
      for (j = 0, len = columns.length; j < len; j++) {
        column = columns[j];
        columnTypes[column] = App.ColumnProcessor.pickColumnType(column, rows, columnDateTypes);
      }
      return [columnTypes, columnDateTypes];
    };

    ColumnProcessor.pickColumnType = function(column, rows, columnDateTypes) {
      var datetimeType;
      datetimeType = App.ChartUtils.columnDateTimeType(column, rows);
      if (datetimeType != null) {
        columnDateTypes[column] = datetimeType;
        return App.Chartographer.DATETIME_COLUMN_TYPE;
      }
      if (App.ChartUtils.columnIsNumeric(column, rows, {
        allowPercent: true,
        allowBlanks: true,
        checkAllRows: true,
        numRowsToTest: 1e6
      })) {
        return App.Chartographer.NUMERIC_COLUMN_TYPE;
      }
      return App.Chartographer.RAW_COLUMN_TYPE;
    };

    ColumnProcessor.prototype.pickPointCols = function() {
      var chartDisallowsPoint, onlyNumericColumn, pointCols, rawTwiddlePointCols, switchOrder, twiddleXCols, xPair;
      rawTwiddlePointCols = this.twiddle('point_cols');
      if (this.actual('use_pivot_settings')) {
        this.setActual('point_cols', rawTwiddlePointCols || []);
        return;
      }
      twiddleXCols = rawTwiddlePointCols || [];
      twiddleXCols = App.Utils.intersect(twiddleXCols, this.columns);
      chartDisallowsPoint = ['pie', 'table'].includes(this.mainChartType());
      if (twiddleXCols.length && !chartDisallowsPoint) {
        this.setActual('point_cols', twiddleXCols);
      } else {
        pointCols = this.columns.withoutAny(this.reservedValueColumnNames()).withoutAny(this.reservedY2Cols()).withoutAny(this.reservedSegmentCols());
        if (!this.twiddle('new_logic')) {
          pointCols = pointCols.withoutAny(this.reservedDetailCols());
        }
        onlyNumericColumn = this.onlyNumericColumn(this.columns);
        if (!(this.allowsStringValueCols() || this.twiddle('new_logic'))) {
          pointCols = pointCols.without(onlyNumericColumn);
        }
        switchOrder = this.preferSecondColumnIfWrongOrder(pointCols);
        xPair = App.ChartUtils.chartHasXYPoints(this.twiddles);
        pointCols = (function() {
          switch (false) {
            case !chartDisallowsPoint:
              return [];
            case !(switchOrder && xPair):
              return [pointCols[1], pointCols[0]];
            case !xPair:
              return [pointCols[0], pointCols[1]];
            case !switchOrder:
              return [pointCols[1]];
            case !pointCols.length:
              return [pointCols[0]];
            default:
              return [this.columns.first()];
          }
        }).call(this);
        return this.setActual('point_cols', pointCols);
      }
    };

    ColumnProcessor.prototype.preferSecondColumnIfWrongOrder = function(pointCols) {
      if (this.twiddle('new_logic')) {
        return false;
      }
      return this.twiddle('segment_column') === '-1' && pointCols.length >= 2 && this.columnTypes[pointCols[0]] === App.Chartographer.NUMERIC_COLUMN_TYPE && this.columnTypes[pointCols[1]] === App.Chartographer.DATETIME_COLUMN_TYPE && this.columns[0] !== ColumnProcessor.INDEX_COLUMN;
    };

    ColumnProcessor.prototype.downgradeExtraYearWeeks = function() {
      var column, columnType, dateTimeType, pointCols, ref, results;
      pointCols = this.pointCols();
      ref = this.columnTypes;
      results = [];
      for (column in ref) {
        columnType = ref[column];
        if (pointCols.includes(column)) {
          continue;
        }
        dateTimeType = this.columnDateTypes[column];
        if (dateTimeType === App.TimeMachine.DATE_TYPE_YEAR_WEEK) {
          results.push(this.columnTypes[column] = 'numeric');
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ColumnProcessor.prototype.createTypedRows = function() {
      var j, len, ref, results, row, startOfWeek, tz;
      this.typedRows = [];
      tz = this.actual('timezone');
      startOfWeek = this.actual('start_of_week');
      if (['table'].includes(this.mainChartType())) {
        return this.typedRows = this.rows;
      } else {
        ref = this.rows;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          results.push(this.typedRows.push(this.createTypedRow(row, tz, startOfWeek)));
        }
        return results;
      }
    };

    ColumnProcessor.prototype.createTypedRow = function(row, tz, startOfWeek) {
      var column, j, len, ref, typedRow, typedValue;
      typedRow = {};
      ref = this.columns;
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        typedValue = this.convertToType(row[column], this.columnTypes[column], tz, startOfWeek);
        typedRow[column] = typedValue;
      }
      typedRow[App.Chartographer.ORIGINAL_ROW] = row;
      return typedRow;
    };

    ColumnProcessor.prototype.convertToType = function(value, columnType, tz, startOfWeek) {
      switch (columnType) {
        case App.Chartographer.RAW_COLUMN_TYPE:
          return value;
        case App.Chartographer.NUMERIC_COLUMN_TYPE:
          return App.Utils.parseFloatOrNull(value);
        case App.Chartographer.DATETIME_COLUMN_TYPE:
          if (this.mainChartType() === 'cohort') {
            return value;
          }
          return App.TimeMachine.parseDateTimeToTimestamp(value, tz, startOfWeek, App.ChartUtils.CHART_TYPES_ALLOW_BAD_DATES.includes(this.mainChartType()));
        default:
          throw new Error("Unexpected column type: " + columnType);
      }
    };

    ColumnProcessor.prototype.pickSegmentCols = function() {
      var onlyNumericColumn, potentialNumericColumns, segmentCols;
      if (!this.chartAllowsSegmentation()) {
        this.setActual('segment_column', []);
        return;
      }
      if (this.twiddle('segment_column') === App.Chartographer.DO_NOT_SEGMENT) {
        this.setActual('segment_column', []);
        return;
      }
      if (this.actual('use_pivot_settings')) {
        this.setActual('segment_column', this.twiddle('segment_column') || []);
        return;
      }
      if (this.mainChartType() === 'geomap') {
        this.setActual('segment_column', this.reservedSegmentCols());
        return;
      }
      potentialNumericColumns = this.columnsWithoutPoints().withoutAny(this.reservedY2Cols());
      if (!this.twiddle('new_logic')) {
        potentialNumericColumns = potentialNumericColumns.withoutAny(this.reservedDetailCols());
      }
      onlyNumericColumn = this.onlyNumericColumn(potentialNumericColumns);
      if (this.twiddle('segment_column') != null) {
        segmentCols = this.reservedSegmentCols();
        if (['cohort'].includes(this.mainChartType())) {
          this.setActual('segment_column', segmentCols);
          return;
        }
        if (!this.twiddle('new_logic')) {
          segmentCols = segmentCols.withoutAny(this.pointCols()).without(onlyNumericColumn);
        }
        if (segmentCols.length > 0) {
          this.setActual('segment_column', segmentCols);
          return;
        }
      }
      if (this.columnarSeriesCondition(this.columnsWithoutPoints())) {
        this.setActual('segment_column', []);
        return;
      }
      segmentCols = this.columnsWithoutPoints().without(onlyNumericColumn).withoutAny(this.reservedValueColumnNames()).withoutAny(this.reservedY2Cols());
      if (!this.twiddle('new_logic')) {
        segmentCols = segmentCols.withoutAny(this.reservedDetailCols());
      }
      if ((segmentCols.length >= 1 && (!App.ChartUtils.chartHasXYPoints(this.twiddles))) || segmentCols.length > 2) {
        return this.setActual('segment_column', segmentCols.slice(0, 1));
      } else {
        return this.setActual('segment_column', []);
      }
    };

    ColumnProcessor.prototype.setIsColumnarSeries = function(columns) {
      if (!this.twiddle('new_logic')) {
        columns = columns.withoutAny(this.reservedDetailCols());
      }
      return this.setActual('columnar_series', this.columnarSeriesCondition(columns));
    };

    ColumnProcessor.prototype.columnarSeriesCondition = function(columns) {
      var segment_cols;
      if (this.twiddle('chart_type') === 'table') {
        return true;
      }
      if (this.twiddle('chart_type') === 'cohort') {
        return false;
      }
      segment_cols = this.actual('segment_column');
      if ((segment_cols != null) && !segment_cols.isEmpty()) {
        return false;
      }
      if (this.twiddle('segment_column') === '-1' && this.manyNumericColumns(columns, 2)) {
        return true;
      }
      return this.manyNumericColumns(columns, 3);
    };

    ColumnProcessor.prototype.pickValueCols = function() {
      var explicitlyEnabledColNames, explicitlySetValueColumns, valueCols, valueColumns, yAxisEnabledColumns;
      explicitlySetValueColumns = this.reservedValueColumns();
      explicitlyEnabledColNames = this.reservedValueColumnNames();
      if (this.actual('chart_type') === 'table') {
        valueColumns = this.setColumnNames(this.columns).filter(function(column) {
          var ref;
          return ref = column.column_name, indexOf.call(explicitlyEnabledColNames, ref) < 0;
        });
        valueColumns = explicitlySetValueColumns.concat(valueColumns);
        valueCols = this.columns;
      } else if (this.actual('use_pivot_settings')) {
        valueColumns = explicitlySetValueColumns || [];
        valueCols = explicitlyEnabledColNames || [];
      } else {
        valueColumns = this.autoSelectValueCols();
        valueColumns = valueColumns.filter(function(column) {
          var ref;
          return ref = column.column_name, indexOf.call(explicitlyEnabledColNames, ref) < 0;
        });
        valueColumns = explicitlySetValueColumns.concat(valueColumns);
        if (!(this.isColumnarSeries() || (this.twiddle('secondary_axis_enabled') && this.segmentCols().isEmpty()) || explicitlySetValueColumns.length > 1)) {
          valueColumns = valueColumns.slice(0, 1);
        }
        valueColumns = this.sortValueColsByColumnIndex(valueColumns);
        valueCols = this.getColumnNames(valueColumns);
      }
      this.setValueColumnTwiddles(valueColumns);
      this.setActual('value_columns', valueColumns);
      this.setActual('value_cols', valueCols);
      yAxisEnabledColumns = _.union(this.twiddles.getArray('twiddle_y_axis_enabled_columns'), valueCols);
      yAxisEnabledColumns = _.intersection(yAxisEnabledColumns, this.columns);
      this.setActual('y_axis_enabled_columns', yAxisEnabledColumns);
      return this.setActual('value_column_type', this.columnTypes[valueCols[0]]);
    };

    ColumnProcessor.prototype.setValueColumnTwiddles = function(valueColumns) {
      var columnTwiddles, columnTwiddlesObject, j, len, results, twiddle, value, valueColumn;
      columnTwiddlesObject = this.twiddles.twiddles.columns;
      if (!((valueColumns != null ? valueColumns.length : void 0) > 0 && (columnTwiddlesObject != null))) {
        return;
      }
      results = [];
      for (j = 0, len = valueColumns.length; j < len; j++) {
        valueColumn = valueColumns[j];
        columnTwiddles = columnTwiddlesObject[valueColumn.column_name];
        if (columnTwiddles != null) {
          results.push((function() {
            var results1;
            results1 = [];
            for (twiddle in columnTwiddles) {
              value = columnTwiddles[twiddle];
              results1.push(valueColumn[twiddle] != null ? valueColumn[twiddle] : valueColumn[twiddle] = value);
            }
            return results1;
          })());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ColumnProcessor.prototype.setExplicitColumnOverrides = function() {
      var ref;
      if (this.twiddle('drag_drop_chart')) {
        if (((ref = this.twiddle('point_cols')) != null ? ref.length : void 0) > 0 || this.twiddle('chart_type') === 'cohort') {
          this.setActualWithOverride('point_cols', this.twiddle('point_cols'));
        }
        this.setActualWithOverride('segment_column', this.reservedSegmentCols());
        if (this.twiddle('chart_type') !== 'geomap') {
          this.setActualWithOverride('value_columns', this.reservedValueColumns());
          this.setActualWithOverride('value_cols', this.reservedValueColumnNames());
        }
        return;
      }
      if (!App.ChartUtils.CHART_TYPES_ONLY_EXPLICIT_COLUMNS_WHEN_SET.includes(this.twiddle('chart_type'))) {
        return;
      }
      if (this.twiddle('use_explicit_point_cols')) {
        this.setActualWithOverride('point_cols', this.twiddle('point_cols'));
      }
      if (this.twiddle('use_explicit_segment_column')) {
        this.setActualWithOverride('segment_column', this.reservedSegmentCols());
      }
      if (this.twiddle('use_explicit_value_cols')) {
        this.setActualWithOverride('value_columns', this.reservedValueColumns());
      }
      if (this.twiddle('use_explicit_value_cols')) {
        return this.setActualWithOverride('value_cols', this.reservedValueColumnNames());
      }
    };

    ColumnProcessor.prototype.sortValueColsByColumnIndex = function(valueCols) {
      var column, columnIndex, i, j, len, ref;
      columnIndex = {};
      ref = this.columns;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        column = ref[i];
        columnIndex[column] = i;
      }
      return valueCols.sort(function(a, b) {
        return columnIndex[a.column_name] - columnIndex[b.column_name];
      });
    };

    ColumnProcessor.prototype.autoSelectValueCols = function() {
      var col, disabledColumns, valueCols;
      disabledColumns = (function() {
        var j, len, ref, results;
        ref = this.columns;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          col = ref[j];
          if (this.columnTwiddle(col, 'use_as_value') === false) {
            results.push(col);
          }
        }
        return results;
      }).call(this);
      valueCols = this.columnsWithoutPoints().withoutAny(this.segmentCols()).withoutAny(disabledColumns);
      if (!this.twiddle('new_logic')) {
        valueCols = valueCols.withoutAny(this.reservedDetailCols());
      }
      if (!this.allowsStringValueCols()) {
        valueCols = this.filterNumericColumns(valueCols);
      }
      if (App.ChartUtils.CHART_TYPES_SORT_VALUE_COLS.includes(this.mainChartType())) {
        valueCols = this.preferNumericColumns(valueCols);
      }
      if (this.mainChartType() === 'geomap') {
        if (this.twiddle('geomap_data_mode') !== 'geojson') {
          valueCols = this.pointCols().slice(1, 2);
        } else {
          valueCols = this.columns.slice(0, 1);
        }
      }
      return this.setColumnNames(valueCols);
    };

    ColumnProcessor.prototype.forwardColumnsIfPresent = function(twiddle) {
      var columns, twiddleCols;
      twiddleCols = this.parseArrayTwiddle(twiddle);
      columns = App.Utils.intersect(twiddleCols, this.columns, false, false);
      if ((columns != null ? columns.length : void 0) > 0) {
        return this.setActual(twiddle, columns);
      }
    };

    ColumnProcessor.prototype.checkNumberOfColumns = function() {
      var base;
      if (this.columns.length >= 100 && (typeof (base = this.columns).includes === "function" ? base.includes('column_99') : void 0)) {
        return App.Chartographer.ERR_TOO_MANY_UNNAMED_COLUMNS;
      }
      if (this.columns.length >= 100 && this.columns.length !== this.columns.unique().length) {
        return App.Chartographer.ERR_TOO_MANY_UNNAMED_COLUMNS;
      }
      return void 0;
    };

    ColumnProcessor.prototype.checkPropertyErrors = function() {
      if (this.twiddle('drag_drop_chart') && this.actual('chart_type') === 'table') {
        return null;
      }
      if (!this.pointCols()) {
        return App.Chartographer.ERR_NO_X;
      }
      if ((!this.valueCols().length) && this.actual('chart_type') === 'bubble') {
        return App.Chartographer.ERR_NO_Z;
      }
      if ((!this.valueCols().length) && this.actual('chart_type') !== 'cohort') {
        return App.Chartographer.ERR_NO_Y;
      }
      if (this.twiddle('chart_type') === 'image') {
        return this.checkImageErrors();
      }
      if (this.checkStringZCol()) {
        return App.Chartographer.ERR_STRING_Z_COL;
      }
      if (this.checkStringValueCol()) {
        return App.Chartographer.ERR_STRING_VALUE_COL;
      }
      return null;
    };

    ColumnProcessor.prototype.checkStringZCol = function() {
      var column, j, len, ref;
      if (!App.ChartUtils.chartHasXYPoints(this.twiddles)) {
        return false;
      }
      return false;
      if (this.allowsStringValueCols()) {
        return false;
      }
      ref = this.actual('value_cols');
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        if (this.columnTypes[column.column_name] === App.Chartographer.RAW_COLUMN_TYPE) {
          return true;
        }
      }
      return false;
    };

    ColumnProcessor.prototype.checkStringValueCol = function() {
      var column, j, len, ref;
      if (this.allowsStringValueCols()) {
        return false;
      }
      if (App.ChartUtils.chartHasXYPoints(this.twiddles) && this.columnTypes[this.pointCols()[1]] === App.Chartographer.RAW_COLUMN_TYPE) {
        return true;
      }
      ref = this.actual('value_cols');
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        if (this.columnTypes[column] === App.Chartographer.RAW_COLUMN_TYPE) {
          return true;
        }
      }
      return false;
    };

    ColumnProcessor.prototype.checkImageErrors = function() {
      if (!(this.rows.length === 1 && this.valueCols().length === 1)) {
        return App.Chartographer.ERR_NOT_SINGLE;
      }
      if (!("" + this.rows[0][this.valueCols()[0]]).match(/^http/)) {
        return App.Chartographer.ERR_NOT_URL;
      }
      return null;
    };

    ColumnProcessor.prototype.setTwiddlesFromSite = function() {
      var displayTimezone, site;
      site = App.Site.first();
      displayTimezone = site != null ? site.display_timezone : void 0;
      if (displayTimezone != null) {
        this.setActual('timezone', App.TimeMachine.mapDisplayTimezone(displayTimezone));
      } else {
        this.setActual('timezone', App.Chartographer.TIMEZONE_DEFAULT);
      }
      return this.setActual('start_of_week', (site != null ? site.week_start_day_id : void 0) || 0);
    };

    ColumnProcessor.prototype.filterColumnsByType = function(columns, columnType) {
      return columns.filter((function(_this) {
        return function(c) {
          return _this.columnTypes[c] === columnType;
        };
      })(this));
    };

    ColumnProcessor.prototype.filterNumericColumns = function(columns) {
      return this.filterColumnsByType(columns, App.Chartographer.NUMERIC_COLUMN_TYPE);
    };

    ColumnProcessor.prototype.preferNumericColumns = function(columns) {
      return columns.sort((function(_this) {
        return function(a, b) {
          if (_this.columnTypes[a] === App.Chartographer.NUMERIC_COLUMN_TYPE && _this.columnTypes[b] !== App.Chartographer.NUMERIC_COLUMN_TYPE) {
            return -1;
          } else if (_this.columnTypes[a] !== App.Chartographer.NUMERIC_COLUMN_TYPE && _this.columnTypes[b] === App.Chartographer.NUMERIC_COLUMN_TYPE) {
            return 1;
          } else {
            return 0;
          }
        };
      })(this));
    };

    ColumnProcessor.prototype.onlyNumericColumn = function(columns) {
      var numericColumns;
      numericColumns = this.filterNumericColumns(columns);
      if (numericColumns.length === 1) {
        return numericColumns[0];
      }
      return null;
    };

    ColumnProcessor.prototype.manyNumericColumns = function(columns, minColumns) {
      var numNumeric, numericColumns;
      numericColumns = this.filterNumericColumns(columns);
      numNumeric = numericColumns.length;
      return numNumeric === columns.length && numNumeric >= minColumns;
    };

    return ColumnProcessor;

  })(App.Chartographer);

}).call(this);
(function() {
  App.Distribution = (function() {
    function Distribution(data) {
      this.data = data;
    }

    Distribution.prototype.getSum = function() {
      var i, len, ref, value;
      if (this.sum) {
        return this.sum;
      }
      this.sum = 0;
      ref = this.data;
      for (i = 0, len = ref.length; i < len; i++) {
        value = ref[i];
        this.sum += value;
      }
      return this.sum;
    };

    Distribution.prototype.getMax = function() {
      var i, len, ref, value;
      if (this.max) {
        return this.max;
      }
      if (!(this.data.length > 0)) {
        return null;
      }
      this.max = this.data[0];
      ref = this.data;
      for (i = 0, len = ref.length; i < len; i++) {
        value = ref[i];
        if (value > this.max) {
          this.max = value;
        }
      }
      return this.max;
    };

    Distribution.prototype.getMin = function() {
      var i, len, ref, value;
      if (this.min) {
        return this.min;
      }
      if (!(this.data.length > 0)) {
        return null;
      }
      this.min = this.data[0];
      ref = this.data;
      for (i = 0, len = ref.length; i < len; i++) {
        value = ref[i];
        if (value < this.min) {
          this.min = value;
        }
      }
      return this.min;
    };

    Distribution.prototype.getMean = function() {
      return this.getAverage();
    };

    Distribution.prototype.getAverage = function() {
      if (this.avg) {
        return this.avg;
      }
      this.avg = this.getSum() / this.data.length;
      return this.avg;
    };

    Distribution.prototype.getN = function() {
      return this.getCount();
    };

    Distribution.prototype.getCount = function() {
      return this.data.length;
    };

    return Distribution;

  })();

}).call(this);
(function() {
  App.DragDropSorter = (function() {
    function DragDropSorter() {}

    DragDropSorter._prepareForSort = function(sp, sourceTable, twiddles, twKeys, sortType, sortIndex) {
      var col, i, len, limit, limits, sortBy, sortByList, sortColumns, sortDir, sortDirections, sortIndexes, sortKeys, sortTable, sort_by_column, twSortBy, twSortDir;
      twSortBy = 'twiddle_' + sortType + '_sort_by';
      twSortDir = 'twiddle_' + sortType + '_sort_dir';
      sortByList = twiddles.get(twSortBy) || [];
      if (sortByList.length === 0) {
        return [
          sourceTable, {
            sortColumns: [],
            sortDirections: {},
            sortIndexes: []
          }
        ];
      }
      sortColumns = [];
      sortDirections = {};
      sortIndexes = [];
      sortKeys = twiddles.get(twKeys) || [];
      sortDir = twiddles.get(twSortDir) || {};
      limits = sortByList.map(function(s) {
        return s.limit;
      }).filter(function(l) {
        return !!l;
      });
      if (limits.length > 0) {
        limit = Math.min.apply(Math, limits);
      }
      for (i = 0, len = sortByList.length; i < len; i++) {
        sortBy = sortByList[i];
        if (sortBy.sort_by === 'periscope_alphabetical_order') {
          col = sortBy.column_name;
          sortColumns.push(col);
          sortDirections[col] = sortDir[col] || 1;
        } else {
          sortIndex = 'periscope_sort_index_' + sortIndex + '_' + sortIndexes.length;
          sort_by_column = sortBy.sort_by.toLowerCase();
          sortTable = sp.groupBy(sourceTable, sortKeys, [
            {
              column: sort_by_column,
              aggFunc: 'Sum',
              aggName: sortIndex
            }
          ]);
          sourceTable = sp.innerJoin(sourceTable, sortTable, sortKeys);
          sortIndexes.push(sortIndex);
          sortColumns.push(sortIndex);
          sortDirections[sortIndex] = sortDir[sortBy.sort_by];
        }
      }
      sortColumns = sortColumns.concat(sortKeys.filter(function(c) {
        return !sortColumns.includes(c);
      }));
      return [
        sourceTable, {
          sortColumns: sortColumns,
          sortDirections: sortDirections,
          sortIndexes: sortIndexes,
          limit: limit
        }
      ];
    };

    DragDropSorter._limitRows = function(sp, sourceTable, sortInfo) {
      var distinctTable, limitedTable;
      if ((sortInfo.limit != null) && !isNaN(sortInfo.limit)) {
        distinctTable = sp.distinctValues(sourceTable, sortInfo.sortColumns);
        limitedTable = sp.limitTable(distinctTable, sortInfo.sortColumns, sortInfo.sortDirections, sortInfo.limit);
        sourceTable = sp.innerJoin(sourceTable, limitedTable, sortInfo.sortColumns);
      }
      return sourceTable;
    };

    DragDropSorter._clearIndexes = function(sourceTable, sortInfo) {
      var i, j, len, len1, ref, ref1, row, sortIndex;
      if (sortInfo.sortIndexes.length > 0) {
        ref = sourceTable.rows;
        for (i = 0, len = ref.length; i < len; i++) {
          row = ref[i];
          ref1 = sortInfo.sortIndexes;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            sortIndex = ref1[j];
            delete row[sortIndex];
          }
        }
      }
      return sourceTable;
    };

    DragDropSorter._sortTable = function(sp, sourceTable, sortInfo) {
      if (sortInfo.sortColumns.length > 0) {
        sourceTable = sp.orderBy(sourceTable, sortInfo.sortColumns, sortInfo.sortDirections);
      }
      return sourceTable;
    };

    DragDropSorter.sortSource = function(rows, columns, twiddles) {
      var colDateTimeTypes, colTypes, limit_by_x_axis_first, ref, ref1, ref2, ref3, ref4, ref5, seriesSortInfo, sourceTable, sp, xAxisSortInfo;
      if (!twiddles.get('drag_drop_chart')) {
        return [rows, columns];
      }
      ref = App.ColumnProcessor.pickColumnTypes(rows, columns), colTypes = ref[0], colDateTimeTypes = ref[1];
      sp = new App.SourceTableProcessor(colTypes);
      sourceTable = {
        rows: rows,
        columns: columns
      };
      if (twiddles.get('chart_type') === 'table') {
        ref1 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_segment_column', 'series', 'series'), sourceTable = ref1[0], seriesSortInfo = ref1[1];
        sourceTable = App.DragDropSorter._sortTable(sp, sourceTable, seriesSortInfo);
        if ((seriesSortInfo.limit != null) && !isNaN(seriesSortInfo.limit)) {
          sourceTable.rows = sourceTable.rows.slice(0, seriesSortInfo.limit);
        }
        sourceTable = App.DragDropSorter._clearIndexes(sourceTable, seriesSortInfo);
      } else {
        limit_by_x_axis_first = twiddles.get('twiddle_limit_first_by') === 'x_axis';
        if (limit_by_x_axis_first) {
          ref2 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_point_cols', 'x_axis', 'x_axis'), sourceTable = ref2[0], xAxisSortInfo = ref2[1];
          sourceTable = App.DragDropSorter._limitRows(sp, sourceTable, xAxisSortInfo);
        }
        ref3 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_segment_column', 'series', 'series'), sourceTable = ref3[0], seriesSortInfo = ref3[1];
        sourceTable = App.DragDropSorter._limitRows(sp, sourceTable, seriesSortInfo);
        if (!limit_by_x_axis_first) {
          ref4 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_point_cols', 'x_axis', 'x_axis'), sourceTable = ref4[0], xAxisSortInfo = ref4[1];
          sourceTable = App.DragDropSorter._limitRows(sp, sourceTable, xAxisSortInfo);
        }
        sourceTable = App.DragDropSorter._clearIndexes(sourceTable, xAxisSortInfo);
        sourceTable = App.DragDropSorter._clearIndexes(sourceTable, seriesSortInfo);
        ref5 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_point_cols', 'x_axis', 'x_axis_final'), sourceTable = ref5[0], xAxisSortInfo = ref5[1];
        sourceTable = App.DragDropSorter._sortTable(sp, sourceTable, xAxisSortInfo);
        sourceTable = App.DragDropSorter._clearIndexes(sourceTable, xAxisSortInfo);
      }
      return [sourceTable.rows, columns];
    };

    DragDropSorter.sortSeries = function(rows, columns, twiddles) {
      var colDateTimeTypes, colTypes, ref, ref1, seriesSortInfo, sourceTable, sp;
      if (!twiddles.get('drag_drop_chart')) {
        return [rows, columns];
      }
      ref = App.ColumnProcessor.pickColumnTypes(rows, columns), colTypes = ref[0], colDateTimeTypes = ref[1];
      sp = new App.SourceTableProcessor(colTypes);
      sourceTable = {
        rows: rows,
        columns: columns
      };
      ref1 = App.DragDropSorter._prepareForSort(sp, sourceTable, twiddles, 'twiddle_segment_column', 'series'), sourceTable = ref1[0], seriesSortInfo = ref1[1];
      sourceTable = App.DragDropSorter._sortTable(sp, sourceTable, seriesSortInfo);
      sourceTable = App.DragDropSorter._clearIndexes(sourceTable, seriesSortInfo);
      return [sourceTable.rows, columns];
    };

    return DragDropSorter;

  })();

}).call(this);
(function() {
  App.PercentageFormatter = (function() {
    function PercentageFormatter() {}

    PercentageFormatter.PERCENT_OF_COLUMN = 'percentOfColumn';

    PercentageFormatter.PERCENT_OF_ROW = 'percentOfRow';

    PercentageFormatter.COUNT_COLUMN = 'countOfFormatColumn';

    PercentageFormatter._formatPercentOf = function(rows, columns, percentOf, segmentColumns, columnToFormat, aggName) {
      var colDateTimeTypes, colTypes, columnToTotal, ref, sourceTable, sp, totalsTable, useCounts;
      ref = App.ColumnProcessor.pickColumnTypes(rows, columns), colTypes = ref[0], colDateTimeTypes = ref[1];
      sp = new App.SourceTableProcessor(colTypes);
      sourceTable = {
        rows: rows,
        columns: columns
      };
      useCounts = false;
      if (colTypes[columnToFormat] !== 'numeric') {
        sourceTable = sp.updateColumn(sourceTable, PercentageFormatter.COUNT_COLUMN, function() {
          return 1;
        });
        useCounts = true;
      }
      columnToTotal = useCounts ? PercentageFormatter.COUNT_COLUMN : columnToFormat;
      totalsTable = sp.groupBy(sourceTable, segmentColumns, [
        {
          column: columnToTotal,
          aggFunc: 'Sum',
          aggName: aggName
        }
      ]);
      sourceTable = sp.innerJoin(sourceTable, totalsTable, segmentColumns);
      sourceTable = sp.updateColumn(sourceTable, percentOf, function(row) {
        return row[columnToTotal] / (row[aggName] || 1);
      });
      return [sourceTable.rows, columns];
    };

    PercentageFormatter.formatPercentOfColumn = function(rows, columns, twiddles, columnToFormat) {
      return App.PercentageFormatter._formatPercentOf(rows, columns, PercentageFormatter.PERCENT_OF_COLUMN, twiddles.getArray('twiddle_segment_column'), columnToFormat, 'column_total');
    };

    PercentageFormatter.formatPercentOfRow = function(rows, columns, twiddles, columnToFormat) {
      return App.PercentageFormatter._formatPercentOf(rows, columns, PercentageFormatter.PERCENT_OF_ROW, twiddles.getArray('twiddle_point_cols'), columnToFormat, 'row_total');
    };

    return PercentageFormatter;

  })();

}).call(this);
(function() {
  App.RowComparator = (function() {
    function RowComparator(colTypes, columns, sortDirections) {
      this.colTypes = colTypes;
      this.columns = columns;
      this.sortDirections = sortDirections;
    }

    RowComparator.prototype._getFloat = function(row, col) {
      var value;
      if (!row.periscope_sort_values) {
        row.periscope_sort_values = {};
      }
      value = row.periscope_sort_values[col];
      if (!value) {
        value = parseFloat(row[col]);
        row.periscope_sort_values[col] = value;
      }
      return value;
    };

    RowComparator.prototype._getDateTime = function(row, col) {
      var value;
      if (!row.periscope_sort_values) {
        row.periscope_sort_values = {};
      }
      value = row.periscope_sort_values[col];
      if (!value) {
        value = moment(row[col]).valueOf();
        row.periscope_sort_values[col] = value;
      }
      return value;
    };

    RowComparator.prototype.compare = function(row1, row2) {
      var checkNaN, col, direction, i, len, ref, row1Undefined, row2Undefined, value1, value2;
      ref = this.columns;
      for (i = 0, len = ref.length; i < len; i++) {
        col = ref[i];
        direction = this.sortDirections[col] || 1;
        row1Undefined = (row1[col] == null) || row1[col] === '';
        row2Undefined = (row2[col] == null) || row2[col] === '';
        if (row1Undefined && row2Undefined) {
          continue;
        } else if (row1Undefined) {
          return 1;
        } else if (row2Undefined) {
          return -1;
        }
        switch (this.colTypes[col]) {
          case App.Chartographer.NUMERIC_COLUMN_TYPE:
            checkNaN = true;
            value1 = this._getFloat(row1, col);
            value2 = this._getFloat(row2, col);
            break;
          case App.Chartographer.DATETIME_COLUMN_TYPE:
            checkNaN = true;
            value1 = this._getDateTime(row1, col);
            value2 = this._getDateTime(row2, col);
            break;
          default:
            checkNaN = false;
            value1 = row1[col];
            value2 = row2[col];
        }
        if (checkNaN) {
          if (isNaN(value1) && isNaN(value2)) {
            continue;
          } else if (isNaN(value1)) {
            return 1;
          } else if (isNaN(value2)) {
            return -1;
          }
        }
        if (value1 < value2) {
          return -1 * direction;
        } else if (value1 > value2) {
          return 1 * direction;
        }
      }
      return 0;
    };

    return RowComparator;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RowProcessor = (function(superClass) {
    var DatetimeAggregator, DefaultAggregator;

    extend(RowProcessor, superClass);

    RowProcessor.PERISCOPE_SUM_COL = '__periscope_sum';

    RowProcessor.ORIGIN_ROWS = '__origin_rows';

    RowProcessor.ORIGIN_POINTS = '__origin_points';

    RowProcessor.MILLISECONDS_IN_HOUR = 1000 * 3600;

    RowProcessor.MAX_NUM_COLUMNS_NORMAL = 20;

    RowProcessor.BUILD_SERIES_TIMEOUT_SECS = 3;

    RowProcessor.SECONDS_MIN = 900;

    RowProcessor.SECONDS_MAX = 6000;

    RowProcessor.MINUTES_MAX = 0.9 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.HOURLY_MAX = 22 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.DAILY_MAX = 6.9 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.WEEKLY_MAX = 26.9 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.MONTHLY_MAX = 32 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.QUARTERLY_MIN = 89 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.QUARTERLY_MAX = 93 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.YEARLY_MIN = 360 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    RowProcessor.YEARLY_MAX = 370 * 24 * RowProcessor.MILLISECONDS_IN_HOUR;

    function RowProcessor(typedRows, twiddles, twiddlesActual, summaryMap) {
      this.typedRows = typedRows;
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
      this.summaryMap = summaryMap;
    }

    RowProcessor.prototype.isTimeSeries = function() {
      return this.actual('x_axis_type') === App.Chartographer.TIMESERIES_AXIS_TYPE;
    };

    RowProcessor.prototype.isContinuousNumeric = function() {
      return this.actual('x_axis_type') === App.Chartographer.NUMERIC_AXIS_TYPE;
    };

    RowProcessor.prototype.categoryForRow = function(row) {
      var j, len, ref, results, segment;
      ref = this.segmentCols();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        segment = ref[j];
        results.push(row[App.Chartographer.ORIGINAL_ROW][segment]);
      }
      return results;
    };

    RowProcessor.prototype.generateAllSeries = function(aggregation) {
      var e;
      this.forwardSortTwiddles();
      this.buildSeriesRows();
      this.pickDetailSeries();
      this.pickAggregation(aggregation);
      this.sortSeriesRows();
      try {
        this.allSeries = this.buildSeries();
        if (!this.allSeries.length && this.mainChartType() !== 'cohort') {
          this.error = App.Chartographer.ERR_NO_SERIES;
        }
        return this.error != null;
      } catch (error) {
        e = error;
        return this.error = e;
      }
    };

    RowProcessor.prototype.forwardSortTwiddles = function() {
      if (this.twiddle('do_not_sort_series')) {
        this.setActual('do_not_sort_series', true);
      }
      this.forwardIfPresent('do_not_resort_for_legend');
      this.forwardIfPresent('cohort_sort_order');
      this.forwardIfPresent('cohort_no_row_totals');
      return this.forwardIfPresent('overlay_zoom');
    };

    RowProcessor.prototype.forwardIfPresent = function(twiddle) {
      if (this.twiddle(twiddle) != null) {
        return this.setActual(twiddle, this.twiddle(twiddle));
      }
    };

    RowProcessor.prototype.forwardColumnTwiddlesToSeries = function(valueColumn, series) {
      var twiddle, twiddlesToForward, value;
      if (valueColumn == null) {
        return;
      }
      twiddlesToForward = ['width', 'alignment', 'value_format', 'value_aggregation', 'num_decimals', 'currency', 'table_total_column'];
      for (twiddle in valueColumn) {
        value = valueColumn[twiddle];
        twiddle = twiddle.toLowerCase().replace("column_", "");
        if (!twiddlesToForward.includes(twiddle)) {
          continue;
        }
        this.setSeriesActual(series, twiddle, value);
      }
      return this.setSeriesActual(series, 'type', this.columnActual(valueColumn.column_name, 'type'));
    };

    RowProcessor.prototype.pickDetailSeries = function() {
      var detailSeries;
      detailSeries = this.twiddle('detail_series');
      if (detailSeries != null) {
        detailSeries = detailSeries.unique();
      }
      return this.setActual('detail_series', this.twiddle('detail_series'));
    };

    RowProcessor.prototype.formattedValueColumn = function(columnName, aggregation, useColumnName) {
      if (useColumnName == null) {
        useColumnName = false;
      }
      if (useColumnName) {
        return columnName;
      }
      if (!((columnName != null) && (aggregation != null) && this.actual('use_pivot_settings'))) {
        return columnName;
      }
      return aggregation + " of " + columnName;
    };

    RowProcessor.prototype.seriesName = function(row, valueColumn, valueColsLength, segmentCols, aggregation, formattedValueColumn) {
      var seriesName;
      seriesName = this.rawSeriesName(row, formattedValueColumn, valueColsLength, segmentCols);
      return seriesName;
    };

    RowProcessor.prototype.rawSeriesName = function(row, valueColumn, valueColsLength, segmentCols) {
      var category;
      if (segmentCols.length === 0) {
        return valueColumn;
      }
      category = this.categoryForRowBySegment(row, segmentCols);
      if (category === '' || category === null) {
        category = 'None';
      }
      if (valueColsLength <= 1) {
        return category;
      }
      return category + "-" + valueColumn;
    };

    RowProcessor.prototype.buildSeriesRows = function() {
      var seriesInfo;
      seriesInfo = this.createSeriesMap();
      this.otherSeriesNames = this.findOtherSeries(seriesInfo.seriesMap);
      this.seriesNamelists = seriesInfo.seriesNamelists;
      this.seriesNames = this.sortSeriesNames(seriesInfo.seriesNames, this.otherSeriesNames);
      if (!this.otherSeriesNames.isEmpty()) {
        this.seriesNames.push('_other');
      }
      return this.seriesRows = this.makeGroupedSeriesRows();
    };

    RowProcessor.prototype.createSeriesMap = function() {
      var column, columns, j, k, len, len1, ref, row, rows, segmentColumns, seriesMap, seriesNamelists, seriesNames, valueColumns;
      seriesMap = {};
      seriesNames = [];
      seriesNamelists = {};
      valueColumns = this.valueColumns();
      segmentColumns = this.segmentCols();
      rows = this.typedRows;
      if (this.twiddles.get('drag_drop_chart')) {
        ref = App.DragDropSorter.sortSeries(rows, segmentColumns, this.twiddles), rows = ref[0], columns = ref[1];
      }
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        if (valueColumns.length === 0) {
          this.addSeriesNameToMap(seriesMap, seriesNames, seriesNamelists, row, valueColumns, segmentColumns, null);
        }
        for (k = 0, len1 = valueColumns.length; k < len1; k++) {
          column = valueColumns[k];
          this.addSeriesNameToMap(seriesMap, seriesNames, seriesNamelists, row, valueColumns, segmentColumns, column);
        }
      }
      return {
        seriesMap: seriesMap,
        seriesNames: seriesNames,
        seriesNamelists: seriesNamelists
      };
    };

    RowProcessor.prototype.addSeriesNameToMap = function(seriesMap, seriesNames, seriesNamelists, row, valueColumns, segmentColumns, column) {
      var aggregation, columnName, formattedValueColumn, headers, seriesName;
      aggregation = this.aggregationForColumn(column);
      columnName = column != null ? column.column_name : void 0;
      formattedValueColumn = this.formattedValueColumn(columnName, aggregation, column != null ? column.use_column_name : void 0);
      seriesName = this.seriesName(row, columnName, valueColumns.length, segmentColumns, aggregation, formattedValueColumn);
      if (seriesName != null) {
        seriesName += "";
      }
      if (seriesMap[seriesName] == null) {
        seriesNames.push(seriesName);
      }
      if (!((seriesNamelists[seriesName] != null) || segmentColumns.length === 0)) {
        headers = this.categoryForRow(row);
        if (valueColumns.length > 1) {
          headers.push(formattedValueColumn);
        }
        if (valueColumns.length === 1 && this.actual('use_pivot_settings')) {
          headers.unshift(formattedValueColumn);
        }
        seriesNamelists[seriesName] = headers;
      }
      if (seriesMap[seriesName] == null) {
        this.forwardColumnTwiddlesToSeries(column, {
          name: seriesName
        });
        seriesMap[seriesName] = 0;
      }
      return seriesMap[seriesName] += row[formattedValueColumn];
    };

    RowProcessor.prototype.categoryForRowBySegment = function(row, segmentCols) {
      var firstSegmentCol, hasOneSegmentCols, hasZeroSegmentCols;
      firstSegmentCol = segmentCols[0];
      hasZeroSegmentCols = segmentCols.length === 0;
      hasOneSegmentCols = segmentCols.length === 1;
      if (hasOneSegmentCols) {
        return row[App.Chartographer.ORIGINAL_ROW][firstSegmentCol];
      } else if (hasZeroSegmentCols) {
        return '';
      } else {
        return this.categoryForRow(row).join(', ');
      }
    };

    RowProcessor.prototype.isBaseChartType = function() {
      return !this.twiddles.anySeriesDifferent('series_chart_type', this.mainChartType());
    };

    RowProcessor.prototype.aggregationForColumn = function(valueColumn) {
      var aggregation, columnType;
      columnType = this.columnActual(valueColumn != null ? valueColumn.column_name : void 0, 'type');
      aggregation = valueColumn != null ? valueColumn.column_value_aggregation : void 0;
      if (this.mainChartType() === 'cohort') {
        if (columnType === 'numeric') {
          if (aggregation == null) {
            aggregation = 'sum';
          }
        } else {
          if (aggregation == null) {
            aggregation = 'count';
          }
        }
      }
      return aggregation;
    };

    RowProcessor.prototype.makeGroupedSeriesRows = function() {
      var chartType, cohortPercentOfColumn, cohortPercentOfRow, computeAverage, j, k, len, len1, percentOfColumn, percentOfRow, pivotFilterProcessor, point, pointCol, pointCols, pointOriginalOrder, ref, row, rowsByPoint, segmentColumns, seriesRow, seriesRows, valueAggregators, valueColumns, valueColumnsLength, xCol;
      rowsByPoint = {};
      pointCols = this.pointCols();
      xCol = this.xCol();
      pointOriginalOrder = [];
      segmentColumns = this.segmentCols();
      computeAverage = false;
      percentOfColumn = false;
      percentOfRow = false;
      cohortPercentOfColumn = false;
      cohortPercentOfRow = false;
      chartType = this.mainChartType();
      valueColumns = this.valueColumns();
      if (segmentColumns.length === 0 && !App.ChartUtils.CHART_TYPES_ALLOW_POINT_AND_VALUE.includes(chartType)) {
        valueColumns = valueColumns.filter(function(valueColumn) {
          var ref;
          return ref = valueColumn.column_name, indexOf.call(pointCols, ref) < 0;
        });
      }
      valueAggregators = valueColumns.map((function(_this) {
        return function(valueColumn) {
          var aggregation, isDatetime, valueAggregatorClass;
          isDatetime = _this.columnActual(valueColumn.column_name, 'type') === App.Chartographer.DATETIME_COLUMN_TYPE;
          aggregation = _this.aggregationForColumn(valueColumn);
          computeAverage || (computeAverage = aggregation === 'average');
          percentOfColumn || (percentOfColumn = ['percent_of_column'].includes(valueColumn.column_value_format));
          percentOfRow || (percentOfRow = ['percent_of_row'].includes(valueColumn.column_value_format));
          cohortPercentOfColumn || (cohortPercentOfColumn = ['cohort_percent_of_column'].includes(valueColumn.column_value_format));
          cohortPercentOfRow || (cohortPercentOfRow = ['cohort_percent_of_row'].includes(valueColumn.column_value_format));
          valueAggregatorClass = DefaultAggregator;
          if (isDatetime) {
            valueAggregatorClass = DatetimeAggregator;
          }
          return new valueAggregatorClass(aggregation, valueColumn.column_name, valueColumn.use_column_name);
        };
      })(this));
      valueColumnsLength = valueColumns.length;
      pivotFilterProcessor = new App.PivotFilterProcessor(this.twiddles, this.twiddlesActual);
      ref = this.typedRows;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        if ((xCol != null) && (row[xCol] == null) || pivotFilterProcessor.failsAnyFilter(row)) {
          continue;
        }
        point = ((function() {
          var k, len1, results;
          results = [];
          for (k = 0, len1 = pointCols.length; k < len1; k++) {
            pointCol = pointCols[k];
            results.push(row[pointCol]);
          }
          return results;
        })()).join('-:~:-');
        if (rowsByPoint[point] == null) {
          rowsByPoint[point] = {
            __periscope_sum: 0
          };
          for (k = 0, len1 = pointCols.length; k < len1; k++) {
            pointCol = pointCols[k];
            if (row[pointCol] == null) {
              continue;
            }
            rowsByPoint[point][pointCol] = row[pointCol];
          }
          pointOriginalOrder.push(point);
        }
        seriesRow = rowsByPoint[point];
        this.setYValues(seriesRow, row, valueAggregators, valueColumnsLength, segmentColumns, chartType);
      }
      seriesRows = (function() {
        var len2, n, results;
        results = [];
        for (n = 0, len2 = pointOriginalOrder.length; n < len2; n++) {
          point = pointOriginalOrder[n];
          results.push(rowsByPoint[point]);
        }
        return results;
      })();
      if (computeAverage) {
        this.maybeCalculateAverageForSeries(seriesRows);
      }
      if (percentOfColumn) {
        this.maybeCalculateColumnPercentageForSeries(seriesRows);
      }
      if (percentOfRow) {
        this.maybeCalculateRowPercentageForSeries(seriesRows);
      }
      if (this.twiddles.get('drag_drop_chart') && (this.summaryMap != null)) {
        if (cohortPercentOfColumn || cohortPercentOfRow) {
          this.calculatePercentageForSeries(seriesRows);
        }
      } else {
        if (cohortPercentOfColumn) {
          this.maybeCalculateCohortColumnPercentageForSeries(seriesRows);
        }
        if (cohortPercentOfRow) {
          this.maybeCalculateCohortRowPercentageForSeries(seriesRows);
        }
      }
      return seriesRows;
    };

    RowProcessor.prototype.maybeCalculateAverageForSeries = function(seriesRows) {
      var j, len, results, seriesName, seriesRow, value;
      results = [];
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            if (this.seriesActual({
              name: seriesName
            }, 'value_aggregation') !== 'average') {
              continue;
            }
            results1.push(this.calculateAverage(seriesRow, seriesName));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RowProcessor.prototype.maybeCalculateColumnPercentageForSeries = function(seriesRows) {
      var j, k, len, len1, results, seriesName, seriesRow, sumBySeries, value;
      sumBySeries = {};
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        for (seriesName in seriesRow) {
          value = seriesRow[seriesName];
          if (this.seriesActual({
            name: seriesName
          }, 'value_format') !== 'percent_of_column') {
            continue;
          }
          if ((value != null ? value.val : void 0) != null) {
            value = value.val;
          }
          if (sumBySeries[seriesName] == null) {
            sumBySeries[seriesName] = 0;
          }
          sumBySeries[seriesName] += value || 0;
        }
      }
      results = [];
      for (k = 0, len1 = seriesRows.length; k < len1; k++) {
        seriesRow = seriesRows[k];
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            if (this.seriesActual({
              name: seriesName
            }, 'value_format') !== 'percent_of_column') {
              continue;
            }
            if ((sumBySeries[seriesName] == null) || sumBySeries[seriesName] === 0) {
              sumBySeries[seriesName] = 1;
            }
            if ((value != null ? value.val : void 0) != null) {
              results1.push(seriesRow[seriesName].val = seriesRow[seriesName].val / sumBySeries[seriesName]);
            } else {
              results1.push(seriesRow[seriesName] = seriesRow[seriesName] / sumBySeries[seriesName]);
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RowProcessor.prototype.getValueColumnFromSeries = function(seriesName) {
      if (this.segmentCols().length === 0) {
        return;
      }
      if (this.valueColumns().length > 1) {
        return this.seriesNamelists[seriesName].last();
      } else {
        return this.seriesNamelists[seriesName].first();
      }
    };

    RowProcessor.prototype.maybeCalculateRowPercentageForSeries = function(seriesRows) {
      var j, len, name1, results, rowTotal, rowTotals, seriesName, seriesRow, value;
      results = [];
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        rowTotals = {};
        for (seriesName in seriesRow) {
          value = seriesRow[seriesName];
          if (this.seriesActual({
            name: seriesName
          }, 'value_format') !== 'percent_of_row') {
            continue;
          }
          if ((value != null ? value.val : void 0) != null) {
            value = value.val;
          }
          if (rowTotals[name1 = this.getValueColumnFromSeries(seriesName)] == null) {
            rowTotals[name1] = 0;
          }
          rowTotals[this.getValueColumnFromSeries(seriesName)] += value;
        }
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            if (this.seriesActual({
              name: seriesName
            }, 'value_format') !== 'percent_of_row') {
              continue;
            }
            rowTotal = rowTotals[this.getValueColumnFromSeries(seriesName)];
            if (rowTotal === 0) {
              rowTotal = 1;
            }
            if ((value != null ? value.val : void 0) != null) {
              seriesRow[seriesName].originalVal = seriesRow[seriesName].val;
              results1.push(seriesRow[seriesName].val = seriesRow[seriesName].val / rowTotal);
            } else {
              results1.push(seriesRow[seriesName] = {
                val: seriesRow[seriesName] / rowTotal,
                originalVal: seriesRow[seriesName]
              });
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RowProcessor.prototype.maybeCalculateCohortColumnPercentageForSeries = function(seriesRows) {
      var j, len, results, seriesName, seriesRow, val, value;
      results = [];
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            if (this.seriesActual({
              name: seriesName
            }, 'value_format') !== 'cohort_percent_of_column') {
              continue;
            }
            val = _.sumBy(seriesRow[RowProcessor.ORIGIN_ROWS][seriesName], function(row) {
              return row[App.PercentageFormatter.PERCENT_OF_COLUMN];
            });
            results1.push(seriesRow[seriesName] = {
              val: val,
              originalVal: val
            });
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RowProcessor.prototype.maybeCalculateCohortRowPercentageForSeries = function(seriesRows) {
      var j, len, results, seriesName, seriesRow, val, value;
      results = [];
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            if (this.seriesActual({
              name: seriesName
            }, 'value_format') !== 'cohort_percent_of_row') {
              continue;
            }
            val = _.sumBy(seriesRow[RowProcessor.ORIGIN_ROWS][seriesName], function(row) {
              return row[App.PercentageFormatter.PERCENT_OF_ROW];
            });
            results1.push(seriesRow[seriesName] = {
              val: val,
              originalVal: seriesRow[seriesName]
            });
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RowProcessor.prototype.calculatePercentageForSeries = function(seriesRows) {
      var j, len, results, rowHashKey, seriesName, seriesRow, val, value, value_format;
      results = [];
      for (j = 0, len = seriesRows.length; j < len; j++) {
        seriesRow = seriesRows[j];
        rowHashKey = App.SourceTableProcessor.getColumnValues(seriesRow, this.pointCols()).toString();
        results.push((function() {
          var results1;
          results1 = [];
          for (seriesName in seriesRow) {
            value = seriesRow[seriesName];
            value_format = this.seriesActual({
              name: seriesName
            }, 'value_format');
            if (!(value_format === 'cohort_percent_of_row' || value_format === 'cohort_percent_of_column')) {
              continue;
            }
            val = this.summaryMap[seriesName][rowHashKey];
            results1.push(seriesRow[seriesName] = {
              val: val,
              originalVal: seriesRow[seriesName]
            });
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    DefaultAggregator = (function() {
      function DefaultAggregator(aggregation1, columnName1, useColumnName1) {
        this.aggregation = aggregation1;
        this.columnName = columnName1;
        this.useColumnName = useColumnName1;
      }

      DefaultAggregator.prototype.calculateAggregation = function(seriesRow, seriesName, value) {
        switch (this.aggregation) {
          case 'count':
            if (value != null) {
              return seriesRow[seriesName] += 1;
            }
            break;
          case 'min':
            return seriesRow[seriesName] = Math.min(seriesRow[seriesName], value);
          case 'max':
            return seriesRow[seriesName] = Math.max(seriesRow[seriesName], value);
          case 'average':
            if (value != null) {
              seriesRow[seriesName].count += 1;
            }
            return seriesRow[seriesName].sum += value;
          default:
            return seriesRow[seriesName] += value;
        }
      };

      DefaultAggregator.prototype.zeroValue = function(seriesName, value) {
        var count;
        count = value != null ? 1 : 0;
        switch (this.aggregation) {
          case 'count':
            return count;
          case 'average':
            return {
              count: count,
              sum: value
            };
          default:
            return value;
        }
      };

      return DefaultAggregator;

    })();

    DatetimeAggregator = (function() {
      function DatetimeAggregator(aggregation1, columnName1, useColumnName1) {
        this.aggregation = aggregation1;
        this.columnName = columnName1;
        this.useColumnName = useColumnName1;
      }

      DatetimeAggregator.prototype.calculateAggregation = function(seriesRow, seriesName, value) {
        switch (this.aggregation) {
          case 'count':
            return seriesRow[seriesName] += 1;
          case 'min':
            return seriesRow[seriesName] = moment.min(moment(seriesRow[seriesName]), moment(value))._i;
          case 'max':
            return seriesRow[seriesName] = moment.max(moment(seriesRow[seriesName]), moment(value))._i;
        }
      };

      DatetimeAggregator.prototype.zeroValue = function(seriesName, value) {
        if (this.aggregation === 'count') {
          return 1;
        } else {
          return value;
        }
      };

      return DatetimeAggregator;

    })();

    RowProcessor.prototype.calculateAverage = function(seriesRow, seriesName) {
      if (seriesRow[seriesName].count === 0) {
        return seriesRow[seriesName] = {
          val: null,
          count: 0,
          sum: null
        };
      } else {
        return seriesRow[seriesName] = {
          val: seriesRow[seriesName].sum / seriesRow[seriesName].count,
          count: seriesRow[seriesName].count,
          sum: seriesRow[seriesName].sum
        };
      }
    };

    RowProcessor.prototype.setYValues = function(seriesRow, row, valueAggregators, valueColumnsLength, segmentColumns, mainChartType) {
      var aggregation, base, base1, chartType, firstPoint, formattedValueColumn, isMultiValue, j, len, name1, name2, results, seriesName, valueAggregator, valueColumn;
      seriesRow[name1 = RowProcessor.ORIGIN_ROWS] || (seriesRow[name1] = {});
      results = [];
      for (j = 0, len = valueAggregators.length; j < len; j++) {
        valueAggregator = valueAggregators[j];
        aggregation = valueAggregator.aggregation;
        valueColumn = valueAggregator.columnName;
        formattedValueColumn = this.formattedValueColumn(valueAggregator.columnName, valueAggregator.aggregation, valueAggregator.useColumnName);
        seriesName = this.seriesName(row, valueColumn, valueColumnsLength, segmentColumns, aggregation, formattedValueColumn) + "";
        chartType = this.twiddles.getForSeries(seriesName, 'chart_type');
        if (chartType == null) {
          chartType = mainChartType;
        }
        (base = seriesRow[RowProcessor.ORIGIN_ROWS])[seriesName] || (base[seriesName] = []);
        seriesRow[RowProcessor.ORIGIN_ROWS][seriesName].push(row['_periscope_original_row']);
        seriesRow[RowProcessor.PERISCOPE_SUM_COL] += row[valueColumn];
        isMultiValue = App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(chartType);
        if (seriesRow[seriesName] != null) {
          seriesRow[name2 = RowProcessor.ORIGIN_POINTS] || (seriesRow[name2] = {});
          firstPoint = seriesRow[seriesName];
          if (isMultiValue) {
            firstPoint = seriesRow[seriesName][0];
          }
          (base1 = seriesRow[RowProcessor.ORIGIN_POINTS])[seriesName] || (base1[seriesName] = [firstPoint]);
          seriesRow[RowProcessor.ORIGIN_POINTS][seriesName].push(row[valueColumn]);
          if (isMultiValue) {
            if (seriesRow[seriesName].push != null) {
              results.push(seriesRow[seriesName].push(row[valueColumn]));
            } else {
              results.push(void 0);
            }
          } else {
            results.push(valueAggregator.calculateAggregation(seriesRow, seriesName, row[valueColumn]));
          }
        } else {
          results.push(seriesRow[seriesName] = isMultiValue && !this.pointIsValue() ? [row[valueColumn]] : valueAggregator.zeroValue(seriesName, row[valueColumn]));
        }
      }
      return results;
    };

    RowProcessor.prototype.allXValAreNumeric = function() {
      var j, k, len, len1, pointCol, ref, ref1, row;
      ref = this.pointCols();
      for (j = 0, len = ref.length; j < len; j++) {
        pointCol = ref[j];
        ref1 = this.seriesRows;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          row = ref1[k];
          if (!App.ChartUtils.isNumberish(row[pointCol])) {
            return false;
          }
        }
      }
      return true;
    };

    RowProcessor.prototype.sortSeriesRows = function() {
      var ref;
      if (this.actual('cohort_sort_order')) {
        return;
      }
      if (this.twiddle('drag_drop_chart') && ((ref = this.twiddle('twiddle_x_axis_sort_by')) != null ? ref.length : void 0) > 0) {
        return;
      }
      if (this.actual('do_not_sort_series') && !this.isTimeSeries() && !this.isContinuousNumeric()) {
        return;
      }
      if (this.isTimeSeries() || this.allXValAreNumeric() || this.isContinuousNumeric()) {
        return this.sortRowsForTimeseries();
      } else if (this.mainChartType() === 'cohort' && !this.isContinuousNumeric()) {
        return this.sortRowsAlphabetically();
      } else {
        return this.sortRowsForCategoricalXAxis();
      }
    };

    RowProcessor.prototype.sortRowsForTimeseries = function() {
      var xCol;
      xCol = this.xCol();
      return this.seriesRows.sort(function(a, b) {
        return a[xCol] - b[xCol];
      });
    };

    RowProcessor.prototype.sortRowsAlphabetically = function() {
      var xCol;
      xCol = this.xCol();
      return this.seriesRows.sort(function(a, b) {
        var cmpA, cmpB;
        if ((a[xCol].localeCompare == null) && (b[xCol].localeCompare == null)) {
          return a[xCol] - b[xCol];
        } else {
          cmpA = a[xCol] + "";
          cmpB = b[xCol] + "";
          return cmpA.localeCompare(cmpB);
        }
      });
    };

    RowProcessor.prototype.sortRowsForCategoricalXAxis = function() {
      return this.seriesRows.sort(function(a, b) {
        return b[RowProcessor.PERISCOPE_SUM_COL] - a[RowProcessor.PERISCOPE_SUM_COL];
      });
    };

    RowProcessor.prototype.numChartableSeries = function() {
      var max_series_before_other;
      if (this.twiddle('series_no_other') || this.mainChartType() === 'cohort') {
        return 1000;
      }
      max_series_before_other = this.twiddle('max_series_before_other');
      if ($.isNumeric(max_series_before_other)) {
        return parseInt(max_series_before_other);
      }
      return App.RowProcessor.MAX_NUM_COLUMNS_NORMAL - 1;
    };

    RowProcessor.prototype.findOtherSeries = function(categoriesMap) {
      var c, cat, j, len, numOtherSeries, otherSeriesSums, r, results, value;
      c = (function() {
        var results;
        results = [];
        for (cat in categoriesMap) {
          value = categoriesMap[cat];
          results.push([cat, value]);
        }
        return results;
      })();
      c.sort(function(a, b) {
        if (b[1] === a[1]) {
          return a[0].localeCompare(b[0]);
        }
        return b[1] - a[1];
      });
      numOtherSeries = Math.max(c.length - this.numChartableSeries(), 0);
      otherSeriesSums = c.slice(c.length - numOtherSeries, c.length);
      results = [];
      for (j = 0, len = otherSeriesSums.length; j < len; j++) {
        r = otherSeriesSums[j];
        results.push(r[0]);
      }
      return results;
    };

    RowProcessor.prototype.sortSeriesNames = function(columns, otherColumns) {
      var allNumberishColumns, column, columnCopy, j, k, len, len1, len2, n, realColumns, ref, segmentCol, seriesMatchValueColumns, sortedCols;
      realColumns = columns.withoutAny(otherColumns);
      if (this.actual('do_not_resort_for_legend') || this.actual('cohort_sort_order')) {
        return realColumns;
      }
      seriesMatchValueColumns = App.Utils.intersect(this.valueCols(), columns).length === columns.length;
      if (seriesMatchValueColumns && (this.actual('columnar_series') || this.twiddle('secondary_axis_enabled'))) {
        return this.valueCols();
      }
      allNumberishColumns = true;
      ref = realColumns.without(['_other']);
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        if (!App.ChartUtils.isNumberish(column)) {
          allNumberishColumns = false;
          break;
        }
      }
      segmentCol = this.actual('segment_column');
      columnCopy = [];
      for (k = 0, len1 = realColumns.length; k < len1; k++) {
        column = realColumns[k];
        if (column !== 'None' && column !== '_other') {
          columnCopy.push(column);
        }
      }
      if (this.mainChartType() === 'cohort') {
        columnCopy = this.sortPivot(this.seriesNamelists, columnCopy);
      } else if (this.columnActual(segmentCol, 'type') === App.Chartographer.DATETIME_COLUMN_TYPE) {
        columnCopy.sort((function(_this) {
          return function(a, b) {
            a = App.TimeMachine.parseDateTimeToTimestamp(a, _this.actual('timezone'), _this.actual('start_of_week'));
            b = App.TimeMachine.parseDateTimeToTimestamp(b, _this.actual('timezone'), _this.actual('start_of_week'));
            return b - a;
          };
        })(this));
      } else if (allNumberishColumns) {
        columnCopy.sort((function(_this) {
          return function(a, b) {
            return App.ChartUtils.numberFromNumberishString(a) - App.ChartUtils.numberFromNumberishString(b);
          };
        })(this));
      } else {
        columnCopy.sort((function(_this) {
          return function(a, b) {
            if (a.localeCompare(b) === 1) {
              return 1;
            } else {
              return -1;
            }
          };
        })(this));
      }
      for (n = 0, len2 = realColumns.length; n < len2; n++) {
        column = realColumns[n];
        if (column === 'None' || column === '_other') {
          columnCopy.push(column);
        }
      }
      sortedCols = columnCopy;
      return sortedCols;
    };

    RowProcessor.prototype.sortPivot = function(seriesNamelists, columnCopy) {
      var aggregation, allColumnNames, column, columnName, formattedValueColumn, formattedValues, i, valueColumns;
      if (Object.keys(seriesNamelists).length === 0) {
        return columnCopy;
      }
      if (this.valueCols().length < 2 || !this.actual('use_pivot_settings')) {
        return App.Utils.sortNumericOrAlpha(columnCopy);
      }
      valueColumns = this.valueColumns();
      formattedValues = {};
      for (i in valueColumns) {
        column = valueColumns[i];
        aggregation = this.aggregationForColumn(column);
        columnName = column != null ? column.column_name : void 0;
        formattedValueColumn = this.formattedValueColumn(columnName, aggregation, column != null ? column.use_column_name : void 0);
        formattedValues[formattedValueColumn] = i;
      }
      allColumnNames = Object.keys(seriesNamelists).map(function(key) {
        return seriesNamelists[key];
      });
      allColumnNames.sort((function(_this) {
        return function(a, b) {
          var formattedValueA, formattedValueB, l, nestedColumnPathA, nestedColumnPathB;
          l = a.length;
          nestedColumnPathA = a.slice(0, l - 1).join('');
          nestedColumnPathB = b.slice(0, l - 1).join('');
          formattedValueA = a[l - 1];
          formattedValueB = b[l - 1];
          if (nestedColumnPathA === nestedColumnPathB) {
            return formattedValues[a[l - 1]] - formattedValues[b[l - 1]];
          } else {
            return nestedColumnPathA.localeCompare(nestedColumnPathB);
          }
        };
      })(this));
      return allColumnNames.map(function(col) {
        var fullColumnName, l;
        l = col.length;
        return fullColumnName = col.slice(0, l - 1).join(', ') + "-" + col[l - 1];
      });
    };

    RowProcessor.prototype.getSeriesData = function() {
      return {
        seriesNames: this.seriesNames.withoutAny(this.otherSeriesNames).without('_other'),
        seriesNamelists: this.seriesNamelists,
        rows: this.seriesRows
      };
    };

    RowProcessor.prototype.buildSeries = function() {
      var _, allSeries, alteredSeriesName, chartSeries, chartType, found, idx, j, k, len, len1, len2, n, otherSeriesSet, pointCols, pointIsValue, ref, ref1, ref2, row, series, seriesData, seriesName, seriesNamelist, startTime, xCol, yCol;
      startTime = App.Utils.timeNowInSecs();
      xCol = this.xCol();
      yCol = null;
      if (App.ChartUtils.chartHasXYPoints(this.twiddles)) {
        yCol = this.pointCols()[1];
      }
      pointCols = this.pointCols();
      allSeries = [];
      if (this.isBaseChartType()) {
        chartType = this.mainChartType();
      }
      pointIsValue = this.pointIsValue();
      seriesData = this.getSeriesData();
      ref = seriesData.seriesNames;
      for (j = 0, len = ref.length; j < len; j++) {
        seriesName = ref[j];
        seriesNamelist = seriesData.seriesNamelists[seriesName];
        if (seriesNamelist == null) {
          alteredSeriesName = "None" + seriesName;
          seriesNamelist = seriesData.seriesNamelists[alteredSeriesName];
        }
        chartSeries = this.emptySeries(seriesName, seriesNamelist);
        allSeries.push(chartSeries);
        if (App.Utils.timeNowInSecs() - RowProcessor.BUILD_SERIES_TIMEOUT_SECS >= startTime) {
          throw App.Chartographer.ERR_TIMEOUT;
        }
        ref1 = seriesData.rows;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          row = ref1[k];
          this.pushAllPoints(chartSeries, row, pointCols, xCol, yCol, seriesName, chartType, pointIsValue);
        }
      }
      if ((this.otherSeriesNames != null) && this.otherSeriesNames.length > 0) {
        otherSeriesSet = this.otherSeriesNames.to_set();
        chartSeries = this.emptySeries('_other', ['_other']);
        idx = ((function() {
          var len2, n, results;
          results = [];
          for (idx = n = 0, len2 = allSeries.length; n < len2; idx = ++n) {
            series = allSeries[idx];
            if (series.name === 'None') {
              results.push(idx);
            }
          }
          return results;
        })()).first();
        if ((idx != null) && !this.twiddles.get('drag_drop_chart')) {
          allSeries.splice(idx, 0, chartSeries);
        } else {
          allSeries.push(chartSeries);
        }
        ref2 = seriesData.rows;
        for (n = 0, len2 = ref2.length; n < len2; n++) {
          row = ref2[n];
          found = false;
          if (App.Utils.timeNowInSecs() - RowProcessor.BUILD_SERIES_TIMEOUT_SECS >= startTime) {
            throw App.Chartographer.ERR_TIMEOUT;
          }
          for (seriesName in row) {
            _ = row[seriesName];
            if (!otherSeriesSet[seriesName]) {
              continue;
            }
            found = true;
            pointIsValue = false;
            this.pushAllPoints(chartSeries, row, pointCols, xCol, null, seriesName, chartType, pointIsValue);
          }
          if (!found) {
            this.pushAllPoints(chartSeries, row, pointCols, xCol, null, null, chartType, pointIsValue);
          }
        }
      }
      return allSeries;
    };

    RowProcessor.prototype.emptySeries = function(name, namelist) {
      return {
        dataPoints: [],
        name: name,
        namelist: namelist
      };
    };

    RowProcessor.prototype.pushPoint = function(chartSeries, chartType, row, pointCols, xCol, yCol, value, yValueExists) {
      if (App.ChartUtils.chartHasXYPoints(this.twiddles)) {
        if (yValueExists) {
          return chartSeries.dataPoints.push(this.pointFromRow(chartType, row, pointCols, xCol, row[yCol], value, yValueExists));
        }
      } else {
        return chartSeries.dataPoints.push(this.pointFromRow(chartType, row, pointCols, xCol, value, null, yValueExists));
      }
    };

    RowProcessor.prototype.pushAllPoints = function(chartSeries, row, pointCols, xCol, yCol, valueCol, chartType, pointIsValue) {
      var j, len, ref, results, value, valueExists;
      if (chartType == null) {
        chartType = this.twiddles.getForSeries(valueCol, 'chart_type');
      }
      if (chartType == null) {
        chartType = this.mainChartType();
      }
      if ((row[valueCol] != null) && (App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(chartType) && !pointIsValue)) {
        ref = row[valueCol];
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          value = ref[j];
          results.push(this.pushPoint(chartSeries, chartType, row, pointCols, xCol, yCol, value, true));
        }
        return results;
      } else {
        value = null;
        valueExists = (row != null) && (row != null ? row[valueCol] : void 0) !== void 0;
        if (valueExists) {
          value = row[valueCol];
        }
        return this.pushPoint(chartSeries, chartType, row, pointCols, xCol, yCol, value, valueExists);
      }
    };

    RowProcessor.prototype.pointFromRow = function(chartType, row, pointCols, xCol, yValue, zValue, yValueExists) {
      var col, point, xValue;
      if (pointCols.length > 1 && (chartType === 'cohort')) {
        xValue = (function() {
          var j, len, results;
          results = [];
          for (j = 0, len = pointCols.length; j < len; j++) {
            col = pointCols[j];
            results.push(row[col]);
          }
          return results;
        })();
      } else {
        xValue = row[xCol];
      }
      point = {
        x: xValue,
        y: yValue,
        row: row[App.RowProcessor.ORIGIN_ROWS],
        originalPoints: row[App.RowProcessor.ORIGIN_POINTS],
        yValueExists: yValueExists
      };
      if (zValue) {
        point.z = zValue;
      }
      return point;
    };

    RowProcessor.prototype.pickAggregation = function(aggregation) {
      var allDatesAreTheSame, dates, j, k, len, len1, m, ref, ref1, typedRow, x, xCol;
      if (!this.isTimeSeries()) {
        return;
      }
      if (aggregation != null) {
        this.setActual('aggregation', aggregation);
        return;
      }
      dates = [];
      xCol = this.xCol();
      ref = this.typedRows.slice(0, 101);
      for (j = 0, len = ref.length; j < len; j++) {
        typedRow = ref[j];
        dates.push(typedRow[xCol]);
      }
      allDatesAreTheSame = Object.keys(dates.to_set()).length === 1;
      if (allDatesAreTheSame) {
        ref1 = this.typedRows.slice(100, 1001);
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          typedRow = ref1[k];
          dates.push(typedRow[xCol]);
        }
      }
      aggregation = App.RowProcessor.pickAggregationFromDates(dates, this.actual('timezone'));
      if (aggregation != null) {
        this.setActual('aggregation', aggregation);
      }
      if ((this.actual('aggregation') == null) && (this.typedRows.length === 1 || allDatesAreTheSame)) {
        x = this.typedRows[0][this.xCol()];
        m = App.TimeMachine.timestampToMoment(x, this.actual('timezone'));
        if (m.hours() === 0 && m.minutes() === 0) {
          return this.setActual('aggregation', 'daily');
        } else if (m.minutes() === 0) {
          return this.setActual('aggregation', 'hourly');
        }
      }
    };

    RowProcessor.pickAggregationFromDates = function(dates, targetTimeZone) {
      var bigInitialValue, date, e, i, j, len, millisecondDelta, minMillisecondDelta, nextDate, ref;
      try {
        dates.sort(function(a, b) {
          return a - b;
        });
        bigInitialValue = 10000 * App.RowProcessor.MILLISECONDS_IN_HOUR;
        minMillisecondDelta = bigInitialValue;
        ref = dates.slice(0, dates.length - 1);
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          date = ref[i];
          nextDate = dates[i + 1];
          millisecondDelta = nextDate - date;
          if (millisecondDelta < minMillisecondDelta && millisecondDelta !== 0) {
            minMillisecondDelta = millisecondDelta;
          }
        }
        if (minMillisecondDelta === bigInitialValue) {
          return null;
        }
        if (minMillisecondDelta < App.RowProcessor.SECONDS_MIN) {
          return null;
        }
        if (minMillisecondDelta < App.RowProcessor.SECONDS_MAX) {
          return App.TimeMachine.SECONDS;
        }
        if (minMillisecondDelta < App.RowProcessor.MINUTES_MAX) {
          return App.TimeMachine.MINUTES;
        }
        if (minMillisecondDelta < App.RowProcessor.HOURLY_MAX) {
          return App.TimeMachine.HOURLY;
        }
        if (minMillisecondDelta < App.RowProcessor.DAILY_MAX) {
          return App.TimeMachine.DAILY;
        }
        if (minMillisecondDelta < App.RowProcessor.WEEKLY_MAX) {
          return App.TimeMachine.WEEKLY;
        }
        if (minMillisecondDelta < App.RowProcessor.MONTHLY_MAX && this.datesAllMonthStarts(dates, targetTimeZone)) {
          return App.TimeMachine.MONTHLY;
        }
        if (minMillisecondDelta > App.RowProcessor.QUARTERLY_MIN && minMillisecondDelta < App.RowProcessor.QUARTERLY_MAX) {
          return App.TimeMachine.QUARTERLY;
        }
        if (minMillisecondDelta > App.RowProcessor.YEARLY_MIN && minMillisecondDelta < App.RowProcessor.YEARLY_MAX) {
          return App.TimeMachine.YEARLY;
        }
        return App.TimeMachine.DAILY;
      } catch (error) {
        e = error;
      }
      return null;
    };

    RowProcessor.datesAllMonthStarts = function(dates, targetTimeZone) {
      var d, j, len;
      for (j = 0, len = dates.length; j < len; j++) {
        d = dates[j];
        if (moment.tz(d, targetTimeZone).date() !== 1) {
          return false;
        }
      }
      return true;
    };

    return RowProcessor;

  })(App.Chartographer);

}).call(this);
(function() {
  App.SeriesMutator = (function() {
    function SeriesMutator() {}

    SeriesMutator.MAX_INSERTION = 10000;

    SeriesMutator.mutateSeries = function(allSeries, twiddlesActual) {
      this.sumOtherSeriesForProportional(allSeries, twiddlesActual);
      this.maybePruneUndefinedBubbles(allSeries, twiddlesActual);
      if (!App.ChartUtils.disableChartSettings(twiddlesActual)) {
        this.maybeConvertNullsToZeros(allSeries, twiddlesActual);
      }
      this.fillSeries(allSeries, twiddlesActual);
      if (!App.ChartUtils.disableChartSettings(twiddlesActual)) {
        this.makeSeriesCumulative(allSeries, twiddlesActual);
      }
      this.maybeAddTooltipTotal(allSeries, twiddlesActual);
      return this.annotateProportionalSeries(allSeries, twiddlesActual);
    };

    SeriesMutator.maybePruneUndefinedBubbles = function(allSeries, twiddlesActual) {
      var i, index, len, results, series;
      if (!App.ChartUtils.chartHasXYPoints(twiddlesActual)) {
        return;
      }
      results = [];
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        results.push((function() {
          var j, ref, results1;
          results1 = [];
          for (index = j = ref = series.dataPoints.length - 1; j >= 0; index = j += -1) {
            if (series.dataPoints[index].z === void 0) {
              results1.push(series.dataPoints.splice(index, 1));
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };

    SeriesMutator.isChartEligibleForContinuousXAxis = function(twiddlesActual) {
      return twiddlesActual.get('fill_null_values') && !['table', 'cohort'].includes(twiddlesActual.get('chart_type'));
    };

    SeriesMutator.makeContinuousRange = function(allSeries, twiddlesActual) {
      var epochDiff, first, firstMoment, i, isTimeseries, j, last, lastMoment, len, range, rangeApprox, results, series, step;
      if (allSeries.length === 0 || (allSeries.first().dataPoints.first() === void 0)) {
        return;
      }
      first = allSeries.first().dataPoints.first().x;
      last = allSeries.first().dataPoints.last().x;
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        if (series.dataPoints.isEmpty()) {
          continue;
        }
        first = Math.min(first, series.dataPoints.first().x);
        last = Math.max(last, series.dataPoints.last().x);
      }
      step = (function() {
        switch (twiddlesActual.get('aggregation')) {
          case 'seconds':
            return 'seconds';
          case 'minutes':
            return 'minutes';
          case 'hourly':
            return 'hours';
          case 'daily':
            return 'days';
          case 'weekly':
            return 'weeks';
          case 'monthly':
            return 'months';
          default:
            return 1;
        }
      })();
      isTimeseries = twiddlesActual.get('x_axis_type') === App.Chartographer.TIMESERIES_AXIS_TYPE;
      if (isTimeseries && step === 1) {
        return null;
      }
      if (step === 1) {
        if ((last - first) < SeriesMutator.MAX_INSERTION) {
          range = (function() {
            results = [];
            for (var j = first; first <= last ? j <= last : j >= last; first <= last ? j++ : j--){ results.push(j); }
            return results;
          }).apply(this);
        }
      } else {
        range = [];
        firstMoment = moment.tz(first, twiddlesActual.get('timezone'));
        lastMoment = moment.tz(last, twiddlesActual.get('timezone'));
        epochDiff = (lastMoment.valueOf() - firstMoment.valueOf()) / App.Chartographer.MILLISECONDS_IN_DAY;
        rangeApprox = (function() {
          switch (step) {
            case 'seconds':
              return epochDiff * 24 * 60 * 60;
            case 'minutes':
              return epochDiff * 24 * 60;
            case 'hours':
              return epochDiff * 24;
            case 'days':
              return epochDiff;
            case 'weeks':
              return epochDiff / 7;
            case 'months':
              return epochDiff / 30;
            default:
              return 0;
          }
        })();
        if (rangeApprox < SeriesMutator.MAX_INSERTION) {
          moment.range(firstMoment, lastMoment).by(step, function(m) {
            return range.push(m.valueOf());
          });
        }
      }
      return range;
    };

    SeriesMutator.copySeriesToContinuousSeries = function(dataPoints, range) {
      var i, index, insertionCount, len, newSeriesRows, numRows, row;
      newSeriesRows = [];
      insertionCount = 0;
      index = 0;
      numRows = range.length;
      for (i = 0, len = dataPoints.length; i < len; i++) {
        row = dataPoints[i];
        while (range[index + 1] <= row.x && index + 1 < numRows) {
          index += 1;
        }
        insertionCount += 1;
        newSeriesRows[index] = row;
        index += 1;
        if (insertionCount > SeriesMutator.MAX_INSERTION) {
          AppRedesign.logError(new Error("Exceeded insertion limit :("));
          break;
        }
      }
      return newSeriesRows;
    };

    SeriesMutator.fillContinuousSeries = function(range, newSeriesRows, twiddlesActual) {
      var base, fillFromLeft, i, index, insertionCount, len, name, originalRow, v, x;
      insertionCount = 0;
      fillFromLeft = twiddlesActual.get('fill_null_values_strategy') === 'fill-from-left';
      for (index = i = 0, len = range.length; i < len; index = ++i) {
        x = range[index];
        if (newSeriesRows[index] == null) {
          newSeriesRows[index] = {};
          newSeriesRows[index].x = x;
          if ((base = newSeriesRows[index])[name = App.Chartographer.ROW] == null) {
            base[name] = {};
          }
          originalRow = 0;
          if (fillFromLeft && index !== 0) {
            originalRow = newSeriesRows[index - 1][App.Chartographer.ROW][App.RowProcessor.ORIGIN_ROWS] || 0;
          }
          newSeriesRows[index][App.Chartographer.ROW][App.RowProcessor.ORIGIN_ROWS] = originalRow;
        }
        if (newSeriesRows[index].y == null) {
          v = 0;
          if (fillFromLeft && index !== 0) {
            v = newSeriesRows[index - 1].y || 0;
          }
          newSeriesRows[index].y = v;
          insertionCount += 1;
        }
        if (insertionCount > SeriesMutator.MAX_INSERTION) {
          AppRedesign.logError(new Error("Exceeded insertion limit :("));
          break;
        }
      }
      return newSeriesRows;
    };

    SeriesMutator.maybeConvertNullsToZeros = function(allSeries, twiddlesActual) {
      var i, len, point, results, series;
      results = [];
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        if (twiddlesActual.getForSeries(series.name, 'chart_type') !== 'area') {
          continue;
        }
        results.push((function() {
          var j, len1, ref, results1;
          ref = series.dataPoints;
          results1 = [];
          for (j = 0, len1 = ref.length; j < len1; j++) {
            point = ref[j];
            results1.push(point.y != null ? point.y : point.y = 0);
          }
          return results1;
        })());
      }
      return results;
    };

    SeriesMutator.fillSeries = function(allSeries, twiddlesActual) {
      var i, len, newSeriesRows, range, results, series;
      if (this.isChartEligibleForContinuousXAxis(twiddlesActual)) {
        range = this.makeContinuousRange(allSeries, twiddlesActual);
        if (range != null) {
          results = [];
          for (i = 0, len = allSeries.length; i < len; i++) {
            series = allSeries[i];
            newSeriesRows = this.copySeriesToContinuousSeries(series.dataPoints, range, series.name);
            results.push(series.dataPoints = this.fillContinuousSeries(range, newSeriesRows, twiddlesActual));
          }
          return results;
        }
      }
    };

    SeriesMutator.makeSeriesCumulative = function(allSeries, twiddlesActual) {
      var i, lastSum, len, p, prevPX, results, series;
      results = [];
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        if (!(this.isCumulative(twiddlesActual, series))) {
          continue;
        }
        lastSum = 0;
        prevPX = null;
        results.push((function() {
          var j, len1, ref, results1;
          ref = series.dataPoints;
          results1 = [];
          for (j = 0, len1 = ref.length; j < len1; j++) {
            p = ref[j];
            if (p.y == null) {
              p.y = 0;
            }
            lastSum += p.y;
            if (p.x !== prevPX) {
              p.y = lastSum;
              results1.push(prevPX = p.x);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };

    SeriesMutator.isCumulative = function(twiddles, series) {
      return twiddles.getForSeries(series.name, 'cumulative');
    };

    SeriesMutator.sumOtherSeriesForProportional = function(allSeries, twiddlesActual) {
      var i, index, len, point, prevPoint, results, series;
      if (!this.chartIsProportional(twiddlesActual)) {
        return;
      }
      results = [];
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        if (series.name === '_other') {
          results.push((function() {
            var j, ref, results1;
            results1 = [];
            for (index = j = ref = series.dataPoints.length - 1; j >= 0; index = j += -1) {
              point = series.dataPoints[index];
              if ((typeof prevPoint !== "undefined" && prevPoint !== null) && prevPoint.x === point.x) {
                prevPoint.y += point.y;
                results1.push(series.dataPoints.splice(index, 1));
              } else {
                results1.push(prevPoint = point);
              }
            }
            return results1;
          })());
        }
      }
      return results;
    };

    SeriesMutator.annotateProportionalSeries = function(allSeries, twiddlesActual) {
      var error, i, len, primarySeries, secondarySeries, series;
      primarySeries = [];
      secondarySeries = [];
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        if (this.seriesIsProportional(series, twiddlesActual)) {
          if (this.isPrimaryAxis(twiddlesActual, series)) {
            primarySeries.push(series);
          } else if (this.isSecondaryAxis(twiddlesActual, series)) {
            secondarySeries.push(series);
          }
        }
      }
      error = this.makeSeriesGroupProportional(primarySeries);
      if (error == null) {
        error = this.makeSeriesGroupProportional(secondarySeries);
      }
      return error;
    };

    SeriesMutator.makeSeriesGroupProportional = function(allSeries) {
      var i, j, k, l, len, len1, len2, len3, name, p, ref, ref1, series, sumsByX;
      if (!((allSeries != null ? allSeries.length : void 0) > 0)) {
        return null;
      }
      sumsByX = {};
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        ref = series.dataPoints;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          p = ref[j];
          if (sumsByX[name = p.x] == null) {
            sumsByX[name] = 0;
          }
          if (p.y == null) {
            p.y = 0;
          }
          if (p.y < 0) {
            return 'Negative numbers are not supported in proportional charts.';
          }
          sumsByX[p.x] += p.y;
        }
      }
      for (k = 0, len2 = allSeries.length; k < len2; k++) {
        series = allSeries[k];
        ref1 = series.dataPoints;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          p = ref1[l];
          if (sumsByX[p.x]) {
            p.percentage = p.y / sumsByX[p.x];
          }
        }
      }
      return null;
    };

    SeriesMutator.maybeAddTooltipTotal = function(allSeries, twiddlesActual) {
      var i, j, k, len, len1, len2, name, name1, point, ref, results, series, totalForPrimary, totalForSecondary;
      if (!this.shouldAddTooltipTotalColumn(allSeries, twiddlesActual)) {
        return;
      }
      totalForPrimary = {};
      totalForSecondary = {};
      for (i = 0, len = allSeries.length; i < len; i++) {
        series = allSeries[i];
        ref = series.dataPoints;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          point = ref[j];
          if (this.isPrimaryAxis(twiddlesActual, series)) {
            if (totalForPrimary[name = point.x] == null) {
              totalForPrimary[name] = 0;
            }
            totalForPrimary[point.x] += point.y;
          }
          if (this.isSecondaryAxis(twiddlesActual, series)) {
            if (totalForSecondary[name1 = point.x] == null) {
              totalForSecondary[name1] = 0;
            }
            totalForSecondary[point.x] += point.y;
          }
        }
      }
      results = [];
      for (k = 0, len2 = allSeries.length; k < len2; k++) {
        series = allSeries[k];
        results.push((function() {
          var l, len3, ref1, results1;
          ref1 = series.dataPoints;
          results1 = [];
          for (l = 0, len3 = ref1.length; l < len3; l++) {
            point = ref1[l];
            if (this.isPrimaryAxis(twiddlesActual, series)) {
              point.total = totalForPrimary[point.x];
            }
            if (this.isSecondaryAxis(twiddlesActual, series)) {
              results1.push(point.total = totalForSecondary[point.x]);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    SeriesMutator.shouldAddTooltipTotalColumn = function(allSeries, twiddlesActual) {
      return twiddlesActual.get('tooltip_total') && !App.ChartUtils.CHART_TYPES_DISABLE_TOOLTIP_TOTAL.includes(twiddlesActual.get('chart_type'));
    };

    SeriesMutator.chartIsProportional = function(twiddles) {
      return (twiddles.get('proportional') && ['column', 'area'].includes(twiddles.get('chart_type'))) || twiddles.get('chart_type') === 'pie';
    };

    SeriesMutator.seriesIsProportional = function(series, twiddlesActual) {
      return twiddlesActual.getForSeries(series.name, 'proportional') || twiddlesActual.get('chart_type') === 'pie';
    };

    SeriesMutator.isPrimaryAxis = function(twiddles, series) {
      return twiddles.getForSeries(series.name, 'show_on_primary_axis');
    };

    SeriesMutator.isSecondaryAxis = function(twiddles, series) {
      return twiddles.getForSeries(series.name, 'show_on_secondary_axis');
    };

    return SeriesMutator;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.SeriesProcessor = (function(superClass) {
    extend(SeriesProcessor, superClass);

    SeriesProcessor.CHART_TYPE_DEPENDENT_SERIES_TWIDDLES = {
      line: ['average_lines_enabled', 'average_lines_num_leading', 'average_lines_num_trailing'],
      column: ['proportional', 'horizontal_bars', 'grouped_bars'],
      area: ['proportional'],
      scatter: ['trendline_enabled']
    };

    function SeriesProcessor(allSeries1, seriesNames1, twiddles, twiddlesActual, theme) {
      this.allSeries = allSeries1;
      this.seriesNames = seriesNames1;
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
      this.theme = theme != null ? theme : null;
    }

    SeriesProcessor.prototype.annotateSeries = function() {
      this.setYAxisTwiddes();
      this.detectDuplicateSeries(this.allSeries);
      this.forwardMainChartTypeTwiddles(this.allSeries);
      this.error = this.setAxisProperties(this.allSeries);
      this.setSeriesChartTypes(this.allSeries);
      this.forwardSyntheticSeriesTwiddles();
      (new App.SyntheticSeriesGenerator(this.allSeries, this.twiddles, this.twiddlesActual)).addSeries();
      if (this.error == null) {
        this.error = App.SeriesMutator.mutateSeries(this.allSeries, this.twiddlesActual);
      }
      this.addFormatTwiddles(this.allSeries);
      return this.error != null;
    };

    SeriesProcessor.prototype.setSeriesChartTypes = function(allSeries) {
      var j, len, ref, results, series;
      ref = allSeries;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        results.push(this.setChartType(series));
      }
      return results;
    };

    SeriesProcessor.prototype.forwardMainChartTypeTwiddles = function(allSeries) {
      var j, len, results, series;
      if (this.mainChartType() !== 'cohort') {
        this.forwardIfPresent('fill_null_values');
        this.forwardIfPresent('fill_null_values_strategy');
      }
      if (['area', 'column'].includes(this.mainChartType())) {
        this.forwardIfPresent('proportional');
      }
      if (this.twiddle('horizontal_bars') && this.mainChartType() === 'column') {
        this.setActual('horizontal', true);
      }
      if (['bignumber', 'sparkline'].includes(this.mainChartType())) {
        this.forwardIfPresent('overlay_cumulative');
        this.forwardIfPresent('conditional_formatting');
        this.setActual('twiddle_overlay_value_on_hover', this.twiddle('twiddle_overlay_value_on_hover') != null ? this.twiddle('twiddle_overlay_value_on_hover') : true);
      }
      results = [];
      for (j = 0, len = allSeries.length; j < len; j++) {
        series = allSeries[j];
        this.setMainChartTypeDependentSeriesTwiddles(series);
        results.push(this.setValuesFormat(series));
      }
      return results;
    };

    SeriesProcessor.prototype.forwardSyntheticSeriesTwiddles = function() {
      this.forwardIfPresent('tooltip_total');
      if (!(this.actual('drilldown_dashboard') || this.actual('drilldown_dashboard') === App.DrilldownsController.NONE_VALUE)) {
        this.forwardIfPresent('drilldown_dashboard');
      }
      if (!this.actual('drilldown_mapping')) {
        return this.forwardIfPresent('drilldown_mapping');
      }
    };

    SeriesProcessor.prototype.setSeriesNameTwiddles = function() {
      var j, len, ref, series;
      ref = this.allSeries;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        this.addSeriesDisplayName(series);
      }
      return this.setActual('series_names', (function() {
        var l, len1, ref1, results;
        ref1 = this.allSeries;
        results = [];
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          series = ref1[l];
          results.push(series.name);
        }
        return results;
      }).call(this));
    };

    SeriesProcessor.prototype.detectDuplicateSeries = function(allSeries) {
      var countStrings, hasDupe, j, k, len, name1, nameTally, series, v;
      nameTally = {};
      for (j = 0, len = allSeries.length; j < len; j++) {
        series = allSeries[j];
        nameTally[name1 = series.name] || (nameTally[name1] = 0);
        nameTally[series.name] += 1;
      }
      hasDupe = false;
      countStrings = [];
      for (k in nameTally) {
        v = nameTally[k];
        if (v > 1) {
          hasDupe = true;
        }
        countStrings.push(k + "_" + v);
      }
      if (hasDupe) {
        return AppRedesign.logError(new Error('Duplicate series in chartographer: ' + countStrings.join(' ')));
      }
    };

    SeriesProcessor.prototype.addFormatTwiddles = function(allSeries) {
      if (this.twiddle('annotation_groups') != null) {
        this.setActual('annotation_groups', this.parseArrayTwiddle('annotation_groups'));
      }
      this.forwardIfPresent('show_values_in_legend');
      this.forwardIfPresent('values_format');
      if (this.actual('values_format') && !this.actual('values_format_original')) {
        this.setActual('values_format_original', this.actual('values_format'));
      } else if (!this.actual('values_format_original')) {
        this.setActual('values_format_original', App.Tooltip.DEFAULT_VALUE_FORMAT);
      }
      this.forwardIfPresent('overlay_text_size');
      this.forwardIfPresent('do_not_round_big_number');
      this.forwardTwiddle('currency');
      if (this.twiddle('title_case_series_names')) {
        this.setActual('titleize_all_labels', true);
      }
      this.markSeriesNameTooltipVisibility(allSeries);
      this.forwardLegendTwiddles(allSeries);
      this.forwardGeomapPlotModeTwiddles(allSeries);
      this.setSeriesColors(this.allSeries);
      this.setSeriesNameTwiddles();
      return this.setActual('overlay_has_one_data_point', this.seriesHasOneDataPoint(allSeries));
    };

    SeriesProcessor.prototype.forwardGeomapPlotModeTwiddles = function(allSeries) {
      var geomapPlotMode, j, len, results, series;
      results = [];
      for (j = 0, len = allSeries.length; j < len; j++) {
        series = allSeries[j];
        geomapPlotMode = this.twiddles.getForSeries(series.name, 'geomap_plot_mode');
        if (geomapPlotMode == null) {
          geomapPlotMode = this.twiddles.get(App.TwiddleConfig.GEOMAP_PLOT_MODE);
        }
        if (geomapPlotMode == null) {
          geomapPlotMode = App.Geomap.PLOT_MODE_POINTS;
        }
        if (geomapPlotMode != null) {
          results.push(this.setSeriesActual(series, 'geomap_plot_mode', geomapPlotMode));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    SeriesProcessor.prototype.forwardLegendTwiddles = function(allSeries) {
      var legendOptions, ref;
      legendOptions = {
        legend_width: this.twiddle('legend_width'),
        legend_position: this.twiddle('legend_position'),
        hide_if_single_series: this.twiddle('hide_legend_for_single_series')
      };
      if (legendOptions.legend_position == null) {
        legendOptions = App.LegendSettings.migrateLegendStructureToSupportLegendPositions(this.twiddle('do_not_show_legend'), this.twiddle('hide_legend_strategy'));
      }
      if (legendOptions.hide_if_single_series && allSeries.length === 1) {
        this.setActual('do_not_show_legend', true);
      } else if (legendOptions.legend_position === 'none') {
        this.setActual('do_not_show_legend', true);
      } else if (allSeries.length <= 1 && ((ref = this.actual('segment_column')) != null ? ref.isEmpty() : void 0) && !(this.seriesActual(allSeries[0], 'average_lines_enabled') === true)) {
        this.setActual('do_not_show_legend', true);
      } else {
        this.setActual('do_not_show_legend', false);
      }
      this.setActual('legend_position', legendOptions.legend_position);
      return this.setActual('legend_width', legendOptions.legend_width);
    };

    SeriesProcessor.prototype.seriesHasOneDataPoint = function(allSeries) {
      var xColumnName;
      xColumnName = this.pointCols().first();
      return allSeries.first().dataPoints.length === 1 && xColumnName === App.ColumnProcessor.INDEX_COLUMN;
    };

    SeriesProcessor.prototype.markSeriesNameTooltipVisibility = function(allSeries) {
      var j, len, moreThanOneSeries, results, series;
      results = [];
      for (j = 0, len = allSeries.length; j < len; j++) {
        series = allSeries[j];
        moreThanOneSeries = allSeries.length > 1;
        results.push(this.setSeriesActual(series, 'name_visible', moreThanOneSeries));
      }
      return results;
    };

    SeriesProcessor.prototype.setYAxisTwiddes = function() {
      var j, len, ref, results, series;
      if (this.twiddle('auto_y2')) {
        this.setActual('secondary_axis_enabled', true);
        this.setDefaultYAxes(this.seriesNames);
        return;
      }
      this.forwardIfPresent('secondary_axis_enabled');
      ref = this.allSeries;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        results.push(this.setSeriesAxis(series));
      }
      return results;
    };

    SeriesProcessor.prototype.setSeriesAxis = function(series) {
      var onPrimary, onSecondary;
      onSecondary = !!this.seriesTwiddle(series, 'show_on_secondary_axis');
      onPrimary = this.seriesTwiddle(series, 'show_on_primary_axis');
      if (onPrimary === void 0 && !onSecondary) {
        onPrimary = true;
      }
      this.setSeriesActual(series, 'show_on_primary_axis', !!onPrimary);
      return this.setSeriesActual(series, 'show_on_secondary_axis', !!onSecondary);
    };

    SeriesProcessor.prototype.setDefaultYAxes = function(seriesNames) {
      var j, len, ref, results, secondarySeriesName, series;
      secondarySeriesName = "";
      if (seriesNames.length >= 2) {
        secondarySeriesName = seriesNames[1];
        this.setSeriesActual({
          name: secondarySeriesName
        }, 'show_on_secondary_axis', true);
      }
      ref = seriesNames.without(secondarySeriesName);
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        results.push(this.setSeriesActual({
          name: series
        }, 'show_on_primary_axis', true));
      }
      return results;
    };

    SeriesProcessor.prototype.addSeriesDisplayName = function(series) {
      var name, segmentCol;
      segmentCol = this.actual('segment_column')[0];
      name = void 0;
      if (name == null) {
        name = series.name;
      }
      if (name === '_other') {
        name = 'Other';
      }
      if (this.actual('titleize_all_labels')) {
        name = name.titleize();
      }
      if (this.seriesActual(series, 'display_name') == null) {
        return this.setSeriesActual(series, 'display_name', name);
      }
    };

    SeriesProcessor.prototype.setChartType = function(series) {
      var chartType;
      if (this.seriesActual(series, 'chart_type')) {
        return;
      }
      if (this.seriesTwiddle(series, 'chart_type') != null) {
        return this.forwardSeriesIfPresent(series, 'chart_type');
      } else {
        if (this.seriesActual(series, 'show_on_secondary_axis') && !this.twiddle('new_logic')) {
          chartType = this.twiddle('second_axis_chart_type') || 'line';
        } else if (this.twiddle('proportional') || this.twiddle('horizontal_bars')) {
          chartType = this.mainChartType();
        } else if (this.twiddle('chart_type') === 'bignumber' || this.twiddle('chart_type') === 'sparkline' || this.seriesActual(series, 'synthetic_series_type') === 'trendline') {
          chartType = 'line';
        } else {
          chartType = this.twiddle('chart_type');
        }
        return this.setSeriesActual(series, 'chart_type', chartType);
      }
    };

    SeriesProcessor.prototype.setValuesFormat = function(series) {
      if (this.seriesActual(series, 'show_on_secondary_axis') && this.twiddle('second_axis_percent')) {
        return this.setSeriesActual(series, 'values_format', App.Tooltip.PERCENT);
      } else if (this.twiddle('chart_type') === 'pie') {
        return this.setSeriesActual(series, 'values_format', App.Tooltip.PERCENT);
      } else if (App.SeriesMutator.seriesIsProportional(series, this.twiddlesActual)) {
        this.setSeriesActual(series, 'values_format', App.Tooltip.PERCENT);
        if (this.seriesActual(series, 'show_on_primary_axis') && !this.actual('values_format_original')) {
          return this.setActual('values_format_original', this.twiddle('values_format'));
        }
      } else if (!this.seriesActual(series, 'show_on_secondary_axis')) {
        return this.setSeriesActual(series, 'values_format', this.twiddle('values_format'));
      }
    };

    SeriesProcessor.prototype.forwardXAxisTwiddles = function() {
      var j, len, ref, ref1, results, twiddle;
      if (ref = this.actual('x_axis_type'), indexOf.call(App.Chartographer.CONTINUOUS_AXIS_TYPES, ref) < 0) {
        return;
      }
      ref1 = ['min_x_axis', 'max_x_axis'];
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        twiddle = ref1[j];
        results.push(this.forwardNumericTwiddle(twiddle));
      }
      return results;
    };

    SeriesProcessor.prototype.setAxisProperties = function(allSeries) {
      var axisMinSettings, axisMinTwiddle, axisTriplet, error, foundSubZero, j, l, len, len1, len2, len3, m, n, point, ref, ref1, series, seriesIsY2, setting;
      this.forwardTwiddle('x_axis_title');
      this.forwardXAxisTwiddles();
      if (this.twiddle('x_axis_show_all_labels')) {
        this.setActual('x_axis_interval', 1);
      }
      this.forwardTwiddle('y_axis_title');
      this.forwardNumericTwiddle('y_axis_interval');
      this.forwardNumericTwiddle('y2_axis_interval');
      this.forwardTwiddle(App.TwiddleConfig.Y_AXIS_FIT);
      this.forwardTwiddle(App.TwiddleConfig.Y2_AXIS_FIT);
      if (App.SeriesMutator.chartIsProportional(this.twiddles)) {
        this.setActual('y_axis_format', App.Tooltip.PERCENT);
        this.setActual('max_y_axis', 1);
        this.setActual('min_y_axis', 0);
      } else {
        this.setActual('y_axis_format', this.twiddle('values_format'));
        this.forwardNumericTwiddle('max_y_axis');
        this.forwardNumericTwiddle('min_y_axis');
      }
      this.forwardTwiddle('y2_axis_title');
      if (this.twiddle('second_axis_percent') || App.SeriesMutator.chartIsProportional(this.twiddles)) {
        this.setActual('y2_axis_format', App.Tooltip.PERCENT);
        if (!this.twiddle(App.TwiddleConfig.Y2_AXIS_FIT)) {
          if (this.twiddle('max_y2_axis') == null) {
            this.setActual('max_y2_axis', 1);
          }
          if (this.twiddle('min_y2_axis') == null) {
            this.setActual('min_y2_axis', 0);
          }
        }
      }
      this.forwardNumericTwiddle('max_y2_axis');
      this.forwardNumericTwiddle('min_y2_axis');
      foundSubZero = {};
      for (j = 0, len = allSeries.length; j < len; j++) {
        series = allSeries[j];
        seriesIsY2 = this.seriesActual(series, 'show_on_secondary_axis');
        axisMinTwiddle = seriesIsY2 ? 'min_y2_axis' : 'min_y_axis';
        if ((this.actual(axisMinTwiddle) != null) || (foundSubZero[axisMinTwiddle] != null)) {
          continue;
        }
        ref = series.dataPoints;
        for (l = 0, len1 = ref.length; l < len1; l++) {
          point = ref[l];
          if (point.y < 0) {
            foundSubZero[axisMinTwiddle] = true;
            break;
          }
        }
      }
      axisMinSettings = [
        {
          minTwiddle: 'min_y_axis',
          fitTwiddle: App.TwiddleConfig.Y_AXIS_FIT
        }, {
          minTwiddle: 'min_y2_axis',
          fitTwiddle: App.TwiddleConfig.Y2_AXIS_FIT
        }
      ];
      for (m = 0, len2 = axisMinSettings.length; m < len2; m++) {
        setting = axisMinSettings[m];
        if (this.actual(setting.minTwiddle) != null) {
          continue;
        }
        if (this.actual(setting.fitTwiddle)) {
          continue;
        }
        this.setActual(setting.minTwiddle, foundSubZero[setting.minTwiddle] ? null : 0);
      }
      this.forwardTwiddle('rotate_x_axis_labels');
      error = null;
      if (this.mainChartType() === 'cohort') {
        return error;
      }
      ref1 = [['X Axis', 'min_x_axis', 'max_x_axis'], ['Y Axis', 'min_y_axis', 'max_y_axis'], ['Secondary Y Axis', 'min_y2_axis', 'max_y2_axis']];
      for (n = 0, len3 = ref1.length; n < len3; n++) {
        axisTriplet = ref1[n];
        if (this.actual(axisTriplet[1]) !== void 0 && this.actual(axisTriplet[2]) !== void 0 && this.actual(axisTriplet[1]) > this.actual(axisTriplet[2])) {
          error = axisTriplet[0] + " Min is greater than " + axisTriplet[0] + " Max.";
          break;
        }
      }
      return error;
    };

    SeriesProcessor.prototype.setMainChartTypeDependentSeriesTwiddles = function(series) {
      var alwaysCopy, j, len, results, t, twiddlesToCopy;
      alwaysCopy = ['data_labels', 'cumulative'];
      twiddlesToCopy = SeriesProcessor.CHART_TYPE_DEPENDENT_SERIES_TWIDDLES[this.mainChartType()] || [];
      twiddlesToCopy = alwaysCopy.concat(twiddlesToCopy);
      results = [];
      for (j = 0, len = twiddlesToCopy.length; j < len; j++) {
        t = twiddlesToCopy[j];
        results.push(this.setSeriesActual(series, t, this.twiddle(t)));
      }
      return results;
    };

    SeriesProcessor.prototype.series_opacity = function(chartType) {
      if (chartType === 'bubble') {
        return 0.5;
      }
      return 1;
    };

    SeriesProcessor.prototype.legend_opacity = function(chartType) {
      if (chartType === 'area') {
        return 0.7;
      }
      if (chartType === 'bubble') {
        return 0.5;
      }
      return 1;
    };

    SeriesProcessor.prototype.setSeriesColors = function(allSeries) {
      var chart_type, color, colors, i, j, legendColor, len, ref, results, series, seriesColor;
      colors = ((ref = this.theme) != null ? ref.series : void 0) || App.ColorHelper.CHART_COLORS.normal;
      results = [];
      for (i = j = 0, len = allSeries.length; j < len; i = ++j) {
        series = allSeries[i];
        chart_type = this.seriesActual(series, 'chart_type');
        color = this.twiddles.getForSeries(series.name, 'color');
        if (chart_type === 'geomap' && this.actual('segment_column').length === 0) {
          if ([App.Geomap.PLOT_MODE_POINTS, App.Geomap.PLOT_MODE_BUBBLES].includes(this.seriesActual(series, 'geomap_plot_mode'))) {
            if (color == null) {
              color = App.Geomap.MARKER_COLOR;
            }
          }
        } else {
          if (color == null) {
            color = colors[i % colors.length];
          }
        }
        seriesColor = App.ColorHelper.hexToRGBA(color, this.series_opacity(chart_type));
        legendColor = App.ColorHelper.hexToRGBA(color, this.legend_opacity(chart_type));
        this.setSeriesActual(series, 'color', seriesColor);
        results.push(this.setSeriesActual(series, 'legend_color', legendColor));
      }
      return results;
    };

    return SeriesProcessor;

  })(App.Chartographer);

}).call(this);
(function() {
  App.SourceTableProcessor = (function() {
    function SourceTableProcessor(colTypes) {
      this.colTypes = colTypes;
    }

    SourceTableProcessor.prototype._getAggregatedValues = function(rows, aggregationColumns) {
      var aggFunc, aggName, aggregationColumn, col, data, dataArray, distribution, i, len, row, value;
      row = {};
      for (i = 0, len = aggregationColumns.length; i < len; i++) {
        aggregationColumn = aggregationColumns[i];
        col = aggregationColumn.column;
        aggFunc = aggregationColumn.aggFunc;
        aggName = aggregationColumn.aggName;
        dataArray = rows.filter(function(r) {
          return !!r[col];
        });
        if (this.colTypes[col] === App.Chartographer.DATETIME_COLUMN_TYPE) {
          data = dataArray.map(function(r) {
            return moment(r[col])._i;
          });
        } else {
          data = dataArray.map(function(r) {
            return parseFloat(r[col]);
          });
        }
        distribution = new App.Distribution(data);
        value = distribution["get" + aggFunc]();
        row[aggName] = value;
      }
      return row;
    };

    SourceTableProcessor.prototype._getColumnNameValues = function(row, columns) {
      var col, i, len, values;
      values = {};
      for (i = 0, len = columns.length; i < len; i++) {
        col = columns[i];
        values[col] = row[col];
      }
      return values;
    };

    SourceTableProcessor.prototype._emptyTable = function(table) {
      return !((table.rows != null) && (table.columns != null) && table.rows.length > 0 && table.columns.length > 0);
    };

    SourceTableProcessor.prototype._separateBy = function(table, separateByColumns) {
      var allGroups, i, len, prevRow, row, rowComparator, rowGroup, sortDirections, sortedRows;
      if (this._emptyTable(table)) {
        return [];
      }
      sortDirections = {};
      rowComparator = new App.RowComparator(this.colTypes, separateByColumns, sortDirections);
      sortedRows = this._orderBy(table, rowComparator, false).rows;
      rowGroup = [];
      allGroups = [];
      prevRow = sortedRows[0];
      for (i = 0, len = sortedRows.length; i < len; i++) {
        row = sortedRows[i];
        if (rowComparator.compare(row, prevRow) !== 0) {
          allGroups.push(rowGroup);
          rowGroup = [];
        }
        rowGroup.push(row);
        prevRow = row;
      }
      allGroups.push(rowGroup);
      this._sortCleanup(sortedRows);
      return allGroups;
    };

    SourceTableProcessor.prototype._orderBy = function(table, rowComparator, sortCleanup) {
      var sortedRows;
      sortedRows = table.rows.slice(0).sort(function(a, b) {
        return rowComparator.compare(a, b);
      });
      if (sortCleanup) {
        this._sortCleanup(sortedRows);
      }
      return {
        rows: sortedRows,
        columns: table.columns.slice(0)
      };
    };

    SourceTableProcessor.prototype._sortCleanup = function(rows) {
      var i, len, results, row;
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        results.push(delete row['periscope_sort_values']);
      }
      return results;
    };

    SourceTableProcessor.lowerCaseColumnNames = function(table) {
      var col, i, index, j, k, len, len1, len2, newColumns, newRow, newRows, ref, ref1, row, upperCaseExists;
      newColumns = table.columns.map(function(c) {
        return c.toLowerCase();
      });
      for (index = i = 0, len = newColumns.length; i < len; index = ++i) {
        col = newColumns[index];
        if (col !== table.columns[index]) {
          upperCaseExists = true;
          break;
        }
      }
      if (upperCaseExists == null) {
        return table;
      }
      newRows = [];
      ref = table.rows;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        row = ref[j];
        newRow = {};
        ref1 = table.columns;
        for (k = 0, len2 = ref1.length; k < len2; k++) {
          col = ref1[k];
          newRow[col.toLowerCase()] = row[col];
        }
        newRows.push(newRow);
      }
      return {
        rows: newRows,
        columns: newColumns
      };
    };

    SourceTableProcessor.prototype.groupBy = function(table, groupByColumns, aggregationColumns) {
      var aggNames, aggregationValues, allGroups, goupByTitle, group, groupByResults, i, len, rows;
      if (this._emptyTable(table)) {
        return {
          rows: [],
          columns: []
        };
      }
      allGroups = this._separateBy(table, groupByColumns);
      aggNames = aggregationColumns.map(function(c) {
        return c.aggName;
      });
      rows = [];
      for (i = 0, len = allGroups.length; i < len; i++) {
        group = allGroups[i];
        goupByTitle = this._getColumnNameValues(group[0], groupByColumns);
        aggregationValues = this._getAggregatedValues(group, aggregationColumns);
        rows.push(_.merge(goupByTitle, aggregationValues));
      }
      groupByResults = {
        rows: rows,
        columns: [].concat(groupByColumns.concat(aggNames))
      };
      return groupByResults;
    };

    SourceTableProcessor.prototype.distinctValues = function(table, distinctColumns) {
      var allGroups, distinctResults, distinctValues, group, i, len, rows;
      if (this._emptyTable(table)) {
        return {
          rows: [],
          columns: []
        };
      }
      allGroups = this._separateBy(table, distinctColumns);
      rows = [];
      for (i = 0, len = allGroups.length; i < len; i++) {
        group = allGroups[i];
        distinctValues = this._getColumnNameValues(group[0], distinctColumns);
        rows.push(distinctValues);
      }
      distinctResults = {
        rows: rows,
        columns: distinctColumns
      };
      return distinctResults;
    };

    SourceTableProcessor.prototype.innerJoin = function(table, joinTable, joinKeys) {
      var addValues, col, group, hashKey, i, j, joinGroups, joinHash, joinRow, joinRows, k, l, len, len1, len2, len3, newColumns, newRows, ref, row;
      if (this._emptyTable(table)) {
        return {
          rows: [],
          columns: []
        };
      }
      if (this._emptyTable(joinTable)) {
        return {
          rows: [],
          columns: []
        };
      }
      joinGroups = this._separateBy(joinTable, joinKeys);
      joinHash = {};
      for (i = 0, len = joinGroups.length; i < len; i++) {
        group = joinGroups[i];
        hashKey = App.SourceTableProcessor.getColumnValues(group[0], joinKeys).toString();
        joinHash[hashKey] = group;
      }
      newRows = [];
      newColumns = joinTable.columns.filter(function(c) {
        return !table.columns.includes(c);
      });
      ref = table.rows;
      for (j = 0, len1 = ref.length; j < len1; j++) {
        row = ref[j];
        hashKey = App.SourceTableProcessor.getColumnValues(row, joinKeys).toString();
        joinRows = joinHash[hashKey];
        if (!joinRows) {
          continue;
        }
        for (k = 0, len2 = joinRows.length; k < len2; k++) {
          joinRow = joinRows[k];
          addValues = {};
          for (l = 0, len3 = newColumns.length; l < len3; l++) {
            col = newColumns[l];
            addValues[col] = joinRow[col];
          }
          newRows.push(_.merge({}, row, addValues));
        }
      }
      return {
        rows: newRows,
        columns: table.columns.slice(0).concat(newColumns)
      };
    };

    SourceTableProcessor.prototype.orderBy = function(table, sortColumns, sortDirections) {
      var rowComparator;
      if (this._emptyTable(table)) {
        return {
          rows: [],
          columns: []
        };
      }
      rowComparator = new App.RowComparator(this.colTypes, sortColumns, sortDirections);
      return this._orderBy(table, rowComparator, true);
    };

    SourceTableProcessor.prototype.limitTable = function(orderedTable, sortColumns, sortDirections, limitCnt) {
      var groupCnt, i, len, prevRow, row, rowComparator, rows, sortedRows;
      if (this._emptyTable(orderedTable)) {
        return {
          rows: [],
          columns: []
        };
      }
      rowComparator = new App.RowComparator(this.colTypes, sortColumns, sortDirections);
      sortedRows = this._orderBy(orderedTable, rowComparator, false).rows;
      prevRow = sortedRows[0];
      groupCnt = 0;
      rows = [];
      for (i = 0, len = sortedRows.length; i < len; i++) {
        row = sortedRows[i];
        if (rowComparator.compare(row, prevRow) !== 0) {
          groupCnt++;
        }
        if (!(groupCnt < limitCnt)) {
          break;
        }
        prevRow = row;
        rows.push(row);
      }
      this._sortCleanup(rows);
      return {
        rows: rows,
        columns: orderedTable.columns
      };
    };

    SourceTableProcessor.prototype.updateColumn = function(table, columnToUpdate, updateFunction) {
      var i, len, new_row, ref, row, rows;
      if (this._emptyTable(table)) {
        return {
          rows: [],
          columns: []
        };
      }
      rows = [];
      ref = table.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        new_row = row;
        new_row[columnToUpdate] = updateFunction(row);
        rows.push(new_row);
      }
      return {
        rows: rows,
        columns: table.columns
      };
    };

    SourceTableProcessor.getColumnValues = function(row, columns) {
      var col, i, len, values;
      values = [];
      for (i = 0, len = columns.length; i < len; i++) {
        col = columns[i];
        values.push(row[col]);
      }
      return values;
    };

    return SourceTableProcessor;

  })();

}).call(this);
(function() {
  App.SummaryCalculator = (function() {
    SummaryCalculator.PERCENT_OF_COLUMN = 'percentOfColumn';

    SummaryCalculator.PERCENT_OF_ROW = 'percentOfRow';

    SummaryCalculator.COUNT_COLUMN = 'countOfFormatColumn';

    function SummaryCalculator(rows, columns, valueColumns1, xColumns, yColumns) {
      var colDateTimeTypes, colTypes, ref, ref1;
      this.valueColumns = valueColumns1;
      this.xColumns = xColumns;
      this.yColumns = yColumns;
      this.sourceTable = {
        rows: rows,
        columns: columns
      };
      this.multipleValueColumns = ((ref = this.valueColumns) != null ? ref.length : void 0) > 1;
      this.noYColumns = this.yColumns.length === 0;
      ref1 = App.ColumnProcessor.pickColumnTypes(rows, columns), colTypes = ref1[0], colDateTimeTypes = ref1[1];
      this.sp = new App.SourceTableProcessor(colTypes);
      this._summaryMap = {};
      this._pivotTableCalculations();
    }

    SummaryCalculator.prototype.summaryMap = function() {
      return this._summaryMap;
    };

    SummaryCalculator.prototype._pivotTableCalculations = function() {
      var columnNames, i, len, ref, results, summaryTable, valueColumn, xColumn, xGroupByColumns;
      columnNames = this.valueColumns.map(function(c) {
        return c.column_name;
      });
      xGroupByColumns = [];
      ref = this.xColumns;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        xColumn = ref[i];
        xGroupByColumns.push(xColumn);
        summaryTable = this._calculateSummaryRow(this.valueColumns, xGroupByColumns);
        if (xGroupByColumns.length !== this.xColumns.length) {
          this._calculateComplexExpressions(summaryTable, xGroupByColumns);
        }
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = this.valueColumns;
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            valueColumn = ref1[j];
            results1.push(this._calculatePercentOf(summaryTable, valueColumn, xGroupByColumns));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    SummaryCalculator.prototype._updateSummaryMap = function(summaryTable, xGroupByColumns, valueColumn, aggName) {
      var base, i, len, ref, results, row, xGroupByHashKey, yHashKey;
      ref = summaryTable.rows;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        if (this.noYColumns) {
          yHashKey = valueColumn.column_display_name;
        } else {
          yHashKey = App.SourceTableProcessor.getColumnValues(row, this.yColumns).join(', ');
          if (this.multipleValueColumns) {
            yHashKey += '-' + valueColumn.column_display_name;
          }
        }
        xGroupByHashKey = App.SourceTableProcessor.getColumnValues(row, xGroupByColumns).toString();
        (base = this._summaryMap)[yHashKey] || (base[yHashKey] = {});
        results.push(this._summaryMap[yHashKey][xGroupByHashKey] = row[aggName]);
      }
      return results;
    };

    SummaryCalculator._capitalizeWord = function(word) {
      return word[0].toUpperCase() + word.substring(1);
    };

    SummaryCalculator.prototype._calculateSummaryRow = function(valueColumns, xGroupByColumns) {
      var aggList, i, len, summaryGroupBy, summaryTable, valueColumn;
      aggList = valueColumns.map(function(vc) {
        return {
          column: vc.column_name,
          aggFunc: App.SummaryCalculator._capitalizeWord(vc.column_value_aggregation),
          aggName: vc.column_display_name
        };
      });
      summaryGroupBy = [].concat(xGroupByColumns.concat(this.yColumns));
      summaryTable = this.sp.groupBy(this.sourceTable, summaryGroupBy, aggList);
      for (i = 0, len = valueColumns.length; i < len; i++) {
        valueColumn = valueColumns[i];
        this._updateSummaryMap(summaryTable, xGroupByColumns, valueColumn, valueColumn.column_display_name);
      }
      return summaryTable;
    };

    SummaryCalculator.prototype._getPercentOfOption = function(valueColumn) {
      var ref, ref1;
      if ((ref = valueColumn.column_value_format) != null ? ref.endsWith("percent_of_column") : void 0) {
        return SummaryCalculator.PERCENT_OF_COLUMN;
      } else if ((ref1 = valueColumn.column_value_format) != null ? ref1.endsWith("percent_of_row") : void 0) {
        return SummaryCalculator.PERCENT_OF_ROW;
      }
      return null;
    };

    SummaryCalculator.prototype._calculatePercentOf = function(sourceTable, valueColumn, xGroupByColumns) {
      var AGG_NAME, percentOf, totalGroupBy, totalsTable;
      percentOf = this._getPercentOfOption(valueColumn);
      if (percentOf == null) {
        return sourceTable;
      }
      AGG_NAME = 'percentOfTotal';
      if (percentOf === SummaryCalculator.PERCENT_OF_COLUMN) {
        totalGroupBy = this.yColumns;
      } else {
        totalGroupBy = xGroupByColumns;
      }
      totalsTable = this.sp.groupBy(sourceTable, totalGroupBy, [
        {
          column: valueColumn.column_display_name,
          aggFunc: 'Sum',
          aggName: AGG_NAME
        }
      ]);
      sourceTable = this.sp.innerJoin(sourceTable, totalsTable, totalGroupBy);
      sourceTable = this.sp.updateColumn(sourceTable, percentOf, function(row) {
        return row[valueColumn.column_display_name] / (row[AGG_NAME] || 1);
      });
      this._updateSummaryMap(sourceTable, xGroupByColumns, valueColumn, percentOf);
      return sourceTable;
    };

    SummaryCalculator.prototype._calculateComplexExpressions = function(summaryTable, xGroupByColumns) {
      var columnName, dependentColumn, expression, formula, formula_variables, i, j, k, l, len, len1, len2, len3, ref, ref1, results, row, sub, sumTokens, summaryTableColumns, token, tokens, v, valueColumn;
      summaryTableColumns = summaryTable.columns.map(function(c) {
        return c.replace(/ /g, '_');
      });
      ref = this.valueColumns;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        valueColumn = ref[i];
        if (valueColumn.measure == null) {
          continue;
        }
        columnName = valueColumn.column_name;
        formula = valueColumn.measure.formula.toLowerCase();
        sumTokens = formula.match(/sum\((.*?)\)/g);
        tokens = formula.match(/\[(.*?)\]/g);
        if ((sumTokens != null ? sumTokens.length : void 0) !== (tokens != null ? tokens.length : void 0)) {
          continue;
        }
        if ((tokens != null ? tokens.length : void 0) === 1 && formula.indexOf('[' + columnName + ']') > -1) {
          continue;
        }
        formula_variables = [];
        for (j = 0, len1 = tokens.length; j < len1; j++) {
          token = tokens[j];
          dependentColumn = token.replace('[', '').replace(']', '').replace(/ /g, '_');
          if (!summaryTableColumns.includes(dependentColumn)) {
            formula = null;
            break;
          }
          sub = "$" + formula_variables.length + "$";
          formula_variables.push({
            sub: sub,
            token: token,
            column: dependentColumn
          });
          formula = formula.replace(token, sub);
        }
        if (formula == null) {
          continue;
        }
        formula = formula.replace(/sum\(/g, '(');
        if (formula.match(/[a-z]/g) != null) {
          continue;
        }
        if (formula_variables.length > 0) {
          ref1 = summaryTable.rows;
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            row = ref1[k];
            expression = formula;
            for (l = 0, len3 = formula_variables.length; l < len3; l++) {
              v = formula_variables[l];
              expression = expression.replace(v.sub, row[v.column]);
            }
            row[columnName] = eval(expression);
          }
        }
        results.push(this._updateSummaryMap(summaryTable, xGroupByColumns, valueColumn, columnName));
      }
      return results;
    };

    return SummaryCalculator;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SyntheticSeriesGenerator = (function(superClass) {
    extend(SyntheticSeriesGenerator, superClass);

    function SyntheticSeriesGenerator(allSeries, twiddles, twiddlesActual) {
      this.allSeries = allSeries;
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
    }

    SyntheticSeriesGenerator.prototype.addSeries = function() {
      var avgSeries, k, len, ref, results, s, trendlineSeries;
      avgSeries = this.makeAverageSeries();
      trendlineSeries = this.makeTrendlineSeries();
      ref = avgSeries.concat(trendlineSeries);
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        s = ref[k];
        results.push(this.allSeries.push(s));
      }
      return results;
    };

    SyntheticSeriesGenerator.prototype.cloneLine = function(fromSeries, toSeries) {
      var overrides;
      overrides = {
        chart_type: void 0,
        show_on_primary_axis: void 0,
        show_on_secondary_axis: void 0
      };
      this.twiddlesActual.cloneSeries(fromSeries.name, toSeries.name, overrides);
      this.setSyntheticSeriesAxis(fromSeries, toSeries);
      return this.setSyntheticSeriesChartType(toSeries);
    };

    SyntheticSeriesGenerator.prototype.setSyntheticSeriesAxis = function(fromSeries, toSeries) {
      var onPrimary, onSecondary;
      onPrimary = this.seriesTwiddle(toSeries, 'show_on_primary_axis');
      onSecondary = this.seriesTwiddle(toSeries, 'show_on_secondary_axis');
      if (onPrimary === void 0 && onSecondary === void 0) {
        onPrimary = this.seriesActual(fromSeries, 'show_on_primary_axis');
        onSecondary = this.seriesActual(fromSeries, 'show_on_secondary_axis');
      }
      if (onPrimary === void 0 && !onSecondary) {
        onPrimary = true;
      }
      this.setSeriesActual(toSeries, 'show_on_primary_axis', !!onPrimary);
      return this.setSeriesActual(toSeries, 'show_on_secondary_axis', !!onSecondary);
    };

    SyntheticSeriesGenerator.prototype.setSyntheticSeriesChartType = function(series) {
      if (this.seriesTwiddle(series, 'chart_type') != null) {
        return this.forwardSeriesIfPresent(series, 'chart_type');
      } else {
        return this.setSeriesActual(series, 'chart_type', 'line');
      }
    };

    SyntheticSeriesGenerator.prototype.makeAverageSeries = function() {
      var avgSeries, k, len, newSeries, ref, series;
      newSeries = [];
      ref = this.allSeries;
      for (k = 0, len = ref.length; k < len; k++) {
        series = ref[k];
        if (this.seriesActual(series, 'average_lines_enabled')) {
          avgSeries = this.rollingAverageSeriesForSeries(series, this.seriesActual(series, 'average_lines_num_leading'), this.seriesActual(series, 'average_lines_num_trailing'));
          if (avgSeries != null) {
            newSeries.push(avgSeries);
            this.cloneLine(series, avgSeries);
            this.seriesActual(avgSeries, 'synthetic_series_type', 'average');
          }
        }
      }
      return newSeries;
    };

    SyntheticSeriesGenerator.prototype.lastValidPoint = function(series) {
      var index, k, last, point, ref;
      last = 0;
      for (index = k = ref = series.dataPoints.length - 1; k >= 0; index = k += -1) {
        point = series.dataPoints[index];
        if ((point.y != null)) {
          last = index;
          break;
        }
      }
      return last;
    };

    SyntheticSeriesGenerator.prototype.rollingAverageSeriesForSeries = function(series, leading, trailing) {
      var avgDataPoints, i, j, k, l, last, m, pickedLeading, pickedTrailing, ref, ref1, ref2, ref3, windowDataPoints;
      if (leading == null) {
        leading = 3;
      }
      if (trailing == null) {
        trailing = 3;
      }
      if ((series != null ? series.dataPoints : void 0) == null) {
        return null;
      }
      if (typeof leading !== "number" || leading < 0) {
        return null;
      }
      if (typeof trailing !== "number" || trailing < 0) {
        return null;
      }
      last = this.lastValidPoint(series);
      avgDataPoints = [];
      for (i = k = 0, ref = series.dataPoints.length; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
        if (i <= last) {
          windowDataPoints = [];
          if (series.dataPoints[i].yValueExists) {
            windowDataPoints.push(series.dataPoints[i].y);
          }
          pickedTrailing = pickedLeading = 0;
          for (j = l = ref1 = i - 1; l >= 0; j = l += -1) {
            if (++pickedTrailing > trailing) {
              break;
            }
            if (!series.dataPoints[j].yValueExists) {
              continue;
            }
            windowDataPoints.push(series.dataPoints[j].y);
          }
          for (j = m = ref2 = i + 1, ref3 = series.dataPoints.length; ref2 <= ref3 ? m < ref3 : m > ref3; j = ref2 <= ref3 ? ++m : --m) {
            if (++pickedLeading > leading) {
              break;
            }
            if (!series.dataPoints[j].yValueExists) {
              continue;
            }
            windowDataPoints.push(series.dataPoints[j].y);
          }
          avgDataPoints.push({
            x: series.dataPoints[i].x,
            y: windowDataPoints.average()
          });
        }
      }
      return $.extend(true, {}, series, {
        name: series.name + " Average",
        dataPoints: avgDataPoints
      });
    };

    SyntheticSeriesGenerator.prototype.makeTrendlineSeries = function() {
      var k, len, newSeries, ref, series, trendlineSeries;
      newSeries = [];
      ref = this.allSeries;
      for (k = 0, len = ref.length; k < len; k++) {
        series = ref[k];
        if (this.seriesActual(series, 'trendline_enabled')) {
          trendlineSeries = this.trendlineSeriesForSeries(series);
          if (trendlineSeries != null) {
            newSeries.push(trendlineSeries);
            this.cloneLine(series, trendlineSeries);
            this.setSeriesActual(trendlineSeries, 'synthetic_series_type', 'trendline');
          }
        }
      }
      return newSeries;
    };

    SyntheticSeriesGenerator.prototype.trendlineSeriesForSeries = function(series) {
      var i, intercept, k, l, lastDataPoint, numPoints, point, ref, ref1, row, slope, sumX, sumXSquared, sumXTimesY, sumY, trendlineSeries, x, xAxisCol, y, yAxisCol;
      if ((series != null ? series.dataPoints : void 0) == null) {
        return null;
      }
      numPoints = 0;
      sumX = 0;
      sumY = 0;
      sumXTimesY = 0;
      sumXSquared = 0;
      for (i = k = 0, ref = series.dataPoints.length; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
        if (series.dataPoints[i].yValueExists) {
          x = series.dataPoints[i].x;
          y = series.dataPoints[i].y;
          numPoints += 1;
          sumX += x;
          sumY += y;
          sumXSquared += x * x;
          sumXTimesY += x * y;
        }
      }
      slope = ((numPoints * sumXTimesY) - (sumX * sumY)) / ((numPoints * sumXSquared) - (sumX * sumX));
      intercept = (sumY - (slope * sumX)) / numPoints;
      xAxisCol = this.actual('point_cols')[0];
      yAxisCol = this.actual('value_cols')[0];
      trendlineSeries = {};
      trendlineSeries.name = series.name + " Trendline";
      trendlineSeries.dataPoints = [];
      lastDataPoint = void 0;
      for (i = l = 0, ref1 = series.dataPoints.length; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
        x = series.dataPoints[i].x;
        if (series.dataPoints[i].yValueExists && lastDataPoint !== x) {
          lastDataPoint = x;
          y = x * slope + intercept;
          point = {};
          point[xAxisCol] = x;
          row = {};
          row[yAxisCol] = [point];
          trendlineSeries.dataPoints.push({
            x: x,
            y: y,
            row: row
          });
        }
      }
      return trendlineSeries;
    };

    return SyntheticSeriesGenerator;

  })(App.Chartographer);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableProcessor = (function(superClass) {
    extend(TableProcessor, superClass);

    function TableProcessor(twiddles, twiddlesActual) {
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
    }

    TableProcessor.prototype.forwardTableTwiddles = function() {
      var k, l, len, len1, ref, ref1, results, t;
      ref = ['transpose_table', 'table_line_numbers', 'conditional_formatting', 'data_bars', 'table_total_column', 'table_right_align_numbers', 'table_alignment', 'table_alignment_checked', 'hide_table_grid_lines', 'keep_table_column_underscores', 'no_cohort_color', 'table_color_header_text', 'table_color_header_background', 'table_color_odd_rows_text', 'table_color_odd_rows_background', 'table_color_even_rows_text', 'table_color_even_rows_background', 'drilldown_dashboard', 'drilldown_mapping'];
      for (k = 0, len = ref.length; k < len; k++) {
        t = ref[k];
        this.forwardIfPresent(t);
      }
      ref1 = ['width', 'alignment', 'value_format', 'value_aggregation', 'currency', 'num_decimals', 'table_total_column', 'image_width', 'image_height'];
      results = [];
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        t = ref1[l];
        results.push(this.forwardColumnIfPresent(t));
      }
      return results;
    };

    TableProcessor.transpose = function(rows, columns) {
      var c, i, j, k, l, len, len1, newColumns, newRows, r;
      if (!((rows != null) && (columns != null) && rows.length > 0 && columns.length > 0)) {
        return [rows, columns];
      }
      c = 1;
      newColumns = ['Column'].concat((function() {
        var k, len, results;
        results = [];
        for (k = 0, len = rows.length; k < len; k++) {
          r = rows[k];
          results.push("" + (c++));
        }
        return results;
      })());
      newRows = (function() {
        var k, len, results;
        results = [];
        for (k = 0, len = columns.length; k < len; k++) {
          c = columns[k];
          results.push({});
        }
        return results;
      })();
      for (i = k = 0, len = columns.length; k < len; i = ++k) {
        c = columns[i];
        newRows[i]['Column'] = c;
        for (j = l = 0, len1 = rows.length; l < len1; j = ++l) {
          r = rows[j];
          newRows[i]["" + (j + 1)] = r[c];
        }
      }
      return [newRows, newColumns];
    };

    return TableProcessor;

  })(App.Chartographer);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Checkbox = (function(superClass) {
    extend(Checkbox, superClass);

    Checkbox.prototype.elements = {
      '.icon': 'icon',
      '.label': 'label'
    };

    Checkbox.prototype.events = {
      'click .icon': 'clickedCheckbox',
      'click .label': 'clickedLabel'
    };

    function Checkbox() {
      this.clickedCheckbox = bind(this.clickedCheckbox, this);
      this.clickedLabel = bind(this.clickedLabel, this);
      this.clicked = bind(this.clicked, this);
      Checkbox.__super__.constructor.apply(this, arguments);
      if (this.callback == null) {
        throw new Error('requires callback');
      }
      if (this.textLabel == null) {
        throw new Error('requires label');
      }
      this.html(this.view('checkbox')({
        label: this.textLabel
      }));
      this.setState(this.initialState);
      if (this.initiallyDisabled) {
        this.setDisabled(true);
      }
      this.lastClickedAt = 0;
    }

    Checkbox.prototype.setState = function(state) {
      if (state) {
        this.el.addClass('checked');
      } else {
        this.el.removeClass('checked');
      }
      return state;
    };

    Checkbox.prototype.isEnabled = function() {
      return !this.el.hasClass('disabled');
    };

    Checkbox.prototype.setDisabled = function(disabled) {
      if (disabled) {
        return this.el.addClass('disabled');
      } else {
        return this.el.removeClass('disabled');
      }
    };

    Checkbox.prototype.toggle = function() {
      return this.setState(!this.state());
    };

    Checkbox.prototype.clicked = function(callback, immediate) {
      var afterState, clickOptions;
      if (immediate == null) {
        immediate = false;
      }
      if (!this.isEnabled()) {
        return false;
      }
      if (!this.isEnabled()) {
        return false;
      }
      clickOptions = this.clickOptions();
      afterState = clickOptions.doubleClick ? this.state() : this.toggle();
      if (this.immediatelyTriggerCallback || immediate) {
        callback(afterState, this.value, this.textLabel, clickOptions);
      } else {
        setTimeout(((function(_this) {
          return function() {
            return callback(afterState, _this.value, _this.textLabel, clickOptions);
          };
        })(this)), 0);
      }
      return this.trigger('clicked', this);
    };

    Checkbox.prototype.clickedLabel = function(e) {
      this.clicked(this.labelCallback || this.callback, true);
      return e.stopPropagation();
    };

    Checkbox.prototype.clickedCheckbox = function(e) {
      this.clicked(this.callback, false);
      return e.stopPropagation();
    };

    Checkbox.prototype.state = function() {
      return this.el.hasClass("checked");
    };

    Checkbox.prototype.clickOptions = function() {
      return {
        doubleClick: this.isDoubleClick()
      };
    };

    Checkbox.prototype.isDoubleClick = function() {
      var doubleClick;
      doubleClick = App.RadioButton.isDoubleClick(this.lastClickedAt);
      this.lastClickedAt = App.RadioButton.lastClickedAtForDoubleClick(doubleClick);
      return doubleClick;
    };

    Checkbox.makeFrame = function() {
      return $("<div class='checkbox'></div>");
    };

    Checkbox.appendFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.append(f);
      return f;
    };

    Checkbox.prependFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.prepend(f);
      return f;
    };

    return Checkbox;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CheckboxList = (function(superClass) {
    extend(CheckboxList, superClass);

    CheckboxList.prototype.events = {
      'click .icon': 'clicked',
      'click .label': 'clicked'
    };

    function CheckboxList() {
      this.clickedIndex = bind(this.clickedIndex, this);
      this.clicked = bind(this.clicked, this);
      CheckboxList.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'callback', 'config');
      this.html(this.view('controls/checkbox_list')({
        config: this.config
      }));
      this.lastClickedAt = 0;
      this.lastClickedId = null;
    }

    CheckboxList.prototype.bulkUpdateChecked = function(checkedIds) {
      var checkbox, checkboxId, checkboxIndex, checked, checkedMap, i, j, len, len1, ref, results;
      checkedMap = {};
      for (i = 0, len = checkedIds.length; i < len; i++) {
        checkboxId = checkedIds[i];
        checkedMap[checkboxId] = true;
      }
      ref = this.config;
      results = [];
      for (checkboxIndex = j = 0, len1 = ref.length; j < len1; checkboxIndex = ++j) {
        checkbox = ref[checkboxIndex];
        checked = !!checkedMap[checkbox.value];
        if (!!checkbox.checked !== checked) {
          results.push(this.setChecked(checkboxIndex, checked));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    CheckboxList.prototype.checkedValues = function() {
      var checkbox, i, len, ref, results;
      ref = this.config;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        checkbox = ref[i];
        if (checkbox.checked) {
          results.push(checkbox.value);
        }
      }
      return results;
    };

    CheckboxList.prototype.checkboxEl = function(checkboxIndex) {
      return this.el.find(".checkbox[checkbox_index='" + checkboxIndex + "']");
    };

    CheckboxList.prototype.isChecked = function(checkboxIndex) {
      return this.config[checkboxIndex].checked;
    };

    CheckboxList.prototype.setChecked = function(checkboxIndex, state) {
      this.config[checkboxIndex].checked = state;
      this.checkboxEl(checkboxIndex).toggleClass('checked', state);
      return state;
    };

    CheckboxList.prototype.toggleChecked = function(checkboxIndex) {
      var checked;
      checked = this.isChecked(checkboxIndex);
      return this.setChecked(checkboxIndex, !checked);
    };

    CheckboxList.prototype.clicked = function(e) {
      var checkboxEl, checkboxIndex;
      checkboxEl = $(e.target).closest('.checkbox');
      checkboxIndex = parseInt(checkboxEl.attr('checkbox_index'));
      this.clickedIndex(checkboxIndex);
      return e.stopPropagation();
    };

    CheckboxList.prototype.clickedIndex = function(checkboxIndex, enter) {
      var afterState, checkbox, doubleClick;
      if (enter == null) {
        enter = false;
      }
      checkbox = this.config[checkboxIndex];
      doubleClick = this.isDoubleClick(checkboxIndex);
      afterState = doubleClick ? this.isChecked(checkboxIndex) : this.toggleChecked(checkboxIndex);
      return this.callback(afterState, checkbox.value, checkbox.label, checkbox.group, doubleClick, enter);
    };

    CheckboxList.prototype.isDoubleClick = function(checkboxIndex) {
      var doubleClick;
      if (this.lastClickedId !== checkboxIndex) {
        doubleClick = false;
      } else {
        doubleClick = App.RadioButton.isDoubleClick(this.lastClickedAt);
      }
      this.lastClickedAt = App.RadioButton.lastClickedAtForDoubleClick(doubleClick);
      this.lastClickedId = checkboxIndex;
      return doubleClick;
    };

    CheckboxList.makeFrame = function() {
      return $('<div class="checkbox-list"></div>');
    };

    CheckboxList.appendFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.append(f);
      return f;
    };

    return CheckboxList;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.ClientTiming = (function() {
    ClientTiming.MAX_DURATION_SECONDS = 600;

    function ClientTiming() {
      this.report = bind(this.report, this);
      this.finish = bind(this.finish, this);
      this.times = {};
      this.waitingOnWidgetIds = [];
      this.done = !!AppRedesign.widgetIdInUrl();
      this.waitingOnInitialCharts = false;
    }

    ClientTiming.prototype.add = function(label, time) {
      if (time == null) {
        time = (new Date()).getTime();
      }
      return this.times[label] = time;
    };

    ClientTiming.prototype.waitForWidgets = function(widgetIds, waitForInitialRender) {
      this.waitingOnWidgetIds = widgetIds || [];
      if (widgetIds.length > 0 && !this.done) {
        return this.waitingOnInitialCharts = waitForInitialRender;
      }
    };

    ClientTiming.prototype.doneIfNoWidgets = function() {
      var e;
      try {
        if (this.noWidgetsLeft() && !this.done) {
          return this.finish();
        }
      } catch (error) {
        e = error;
        return AppRedesign.logError(e);
      }
    };

    ClientTiming.prototype.doneWithWidget = function(widgetId, rendered) {
      var e, ref;
      if (this.done) {
        return;
      }
      try {
        if (rendered && this.missing('firstChartTime')) {
          if ((ref = AppRedesign.current().uiQueue) != null) {
            ref.insertInterrupt();
          }
          this.add('firstChartTime');
        }
        this.waitingOnWidgetIds = this.waitingOnWidgetIds.without(widgetId);
        if (this.noWidgetsLeft()) {
          return this.finish();
        }
      } catch (error) {
        e = error;
        return AppRedesign.logError(e);
      }
    };

    ClientTiming.prototype.stop = function() {
      return this.done = true;
    };

    ClientTiming.prototype.finish = function() {
      var ref;
      this.waitingOnInitialCharts = false;
      this.done = true;
      if (this.missing('firstChartTime')) {
        this.add('firstChartTime');
      }
      this.add('aboveTheFoldTime');
      if ((ref = AppRedesign.current().uiQueue) != null) {
        ref.insertInterrupt();
      }
      return this.report();
    };

    ClientTiming.prototype.missing = function(label) {
      return this.times[label] == null;
    };

    ClientTiming.prototype.noWidgetsLeft = function() {
      return this.waitingOnWidgetIds.length === 0;
    };

    ClientTiming.prototype.report = function() {
      var aft, duration, timings, variable, windowTimings;
      timings = this.timings();
      for (variable in timings) {
        duration = timings[variable];
        if ((duration == null) || duration > ClientTiming.MAX_DURATION_SECONDS * 1000) {
          return;
        }
      }
      this.postTimings(timings);
      aft = timings.nav_duration;
      if (window.location.href.indexOf('reloadcountdown') !== -1) {
        windowTimings = App.LocalStorage.fetchJSONItem('timings', []);
        windowTimings.push(aft);
        App.LocalStorage.setJSONItem('timings', windowTimings);
        if (AppRedesign.parseNumericParam(window.location.href, 'reloadcountdown') === 0) {
          windowTimings.sort();
          console.info(windowTimings);
          console.info(windowTimings[parseInt(windowTimings.length / 2)]);
          AppRedesign.current().windowTimings = windowTimings;
          return App.LocalStorage.removeItem('timings');
        }
      }
    };

    ClientTiming.prototype.timings = function() {
      var navStart, ref, timings;
      navStart = typeof performance !== "undefined" && performance !== null ? (ref = performance.timing) != null ? ref.navigationStart : void 0 : void 0;
      timings = {
        server_duration: this.times.serverDuration,
        server_json_duration: this.times.serverJsonDuration,
        resource_duration: this.times.appStartTime - this.times.startTime,
        app_duration: this.times.firstChartTime - this.times.appStartTime,
        pre_dashboard_duration: this.times.preDashboardTime - this.times.appStartTime,
        dashboard_duration: this.times.postDashboardTime - this.times.preDashboardTime,
        post_dashboard_duration: this.times.firstChartTime - this.times.postDashboardTime,
        above_the_fold_duration: this.times.aboveTheFoldTime - this.times.appStartTime
      };
      if (navStart != null) {
        timings.nav_duration = this.times.startTime - navStart;
      }
      return timings;
    };

    ClientTiming.prototype.postTimings = function(timings) {
      var data, ref;
      data = jQuery.extend(true, timings, {
        browser: BrowserDetect.browser,
        browser_version: BrowserDetect.version,
        os: BrowserDetect.OS,
        dashboard_id: (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0
      });
      jQuery.post("/sites/" + (App.Site.first().id) + "/log_timings", data);
      return setTimeout(this.reloadCountdown, 3000);
    };

    ClientTiming.prototype.reloadCountdown = function() {
      var count, e, k, newHref, queryDict, v;
      try {
        if (window.location.href.includes('reloadcountdown')) {
          count = AppRedesign.parseNumericParam(window.location.href, 'reloadcountdown');
          if (!(count <= 100 && count > 0)) {
            return;
          }
          queryDict = {};
          location.search.substr(1).split("&").forEach(function(item) {
            return queryDict[item.split("=")[0]] = item.split("=")[1];
          });
          queryDict["reloadcountdown"] = count - 1;
          newHref = window.location.href.split('?')[0] + "?";
          for (k in queryDict) {
            v = queryDict[k];
            newHref += k + "=" + v + "&";
          }
          return window.location.href = newHref;
        }
      } catch (error) {
        e = error;
        return console.error(e);
      }
    };

    return ClientTiming;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConnectPage = (function(superClass) {
    extend(ConnectPage, superClass);

    ConnectPage.prototype.elements = {
      '.signup-form': 'signupForm'
    };

    function ConnectPage() {
      ConnectPage.__super__.constructor.apply(this, arguments);
      if (!this.featureEnabled('connect_wizard')) {
        return;
      }
      AppRedesign.setCurrentApp(this);
      this.html(this.view('signup/frame')());
      this.dbConnectForm = new App.DatabaseConnectForm({
        el: this.signupForm,
        submitRoute: '/connect/wizard_submit',
        pollRoute: '/connect/poll_doctor',
        uploadKeyRoute: "/connect/upload_bigquery_key",
        uploadSnowflakePk8KeyRoute: "/connect/upload_snowflake_key",
        uploadSnowflakeCacheablePk8KeyRoute: "/connect/upload_snowflake_cacheable_key",
        newCustomer: true,
        extraParams: {
          signup_token: App.Utils.makeGuid()
        },
        successMessage: "Success! Your database is connected. The Sisense for Cloud Data Teams team will contact you shortly."
      });
      $('body').css('overflow', 'auto');
    }

    ConnectPage.prototype.release = function() {
      var ref;
      if ((ref = this.dbConnectForm) != null) {
        ref.release();
      }
      return ConnectPage.__super__.release.apply(this, arguments);
    };

    ConnectPage.prototype.featureEnabled = function(feature) {
      var ref;
      return Boolean((ref = this.state.features) != null ? ref[feature] : void 0);
    };

    return ConnectPage;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConnectionTester = (function(superClass) {
    extend(ConnectionTester, superClass);

    ConnectionTester.prototype.elements = {
      '.panel': 'panel'
    };

    function ConnectionTester() {
      ConnectionTester.__super__.constructor.apply(this, arguments);
      AppRedesign.setCurrentApp(this);
      this.dbConnectForm = new App.InternalDatabaseConnectForm({
        el: this.panel,
        sshTunnelRoute: "/internal/connection_tester/test_ssh_tunnel",
        submitRoute: "/internal/connection_tester/test_database_connection",
        newCustomer: true,
        extraParams: {
          create_token: App.Utils.makeGuid()
        },
        successMessage: "The database connection was successful!",
        infoGrid: true,
        addDb: true
      });
      this.dbConnectForm.hideErrors();
    }

    ConnectionTester.prototype.release = function() {
      var ref;
      if ((ref = this.dbConnectForm) != null) {
        ref.release();
      }
      return ConnectionTester.__super__.release.apply(this, arguments);
    };

    ConnectionTester.prototype.featureEnabled = function(feature) {
      var ref;
      return Boolean((ref = this.state.features) != null ? ref[feature] : void 0);
    };

    return ConnectionTester;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DatabaseConnectForm = (function(superClass) {
    extend(DatabaseConnectForm, superClass);

    DatabaseConnectForm.prototype.elements = {
      '.button.submit': 'submitButton',
      '.db-loader': 'dbLoader',
      '[row="email_address"]': 'rowEmailAddress',
      '[row="display_name"]': 'rowDbDisplayName',
      '[row="database_name"]': 'rowDbName',
      '[row="host"]': 'rowDbHost',
      '[row="port"]': 'rowDbPort',
      '[row="username"]': 'rowDbUser',
      '[row="password"]': 'rowPassword',
      '[row="account_name"]': 'rowAccountName',
      '[row="warehouse_name"]': 'rowWarehouseName',
      '[row="httppath"]': 'rowHttppath',
      '[row="snowflake_username"]': 'rowSnowflakeUsername',
      '[row="snowflake_password"]': 'rowSnowflakePassword',
      '[row="parent_database"]': 'parentDatabase',
      '[row="service_account"]': 'rowBigqueryServiceAccount',
      '[row="project_id"]': 'rowBigqueryProjectId',
      '[row="p12_key_file"]': 'rowBigqueryKeyFile',
      '[row="snowflake_pk8_key_file"]': 'rowSnowflakeKeyFile',
      '[row="snowflake_pk8_pwd"]': 'rowSnowflakePk8KeyFile',
      '[row="jdbc_command_type"]': 'rowJdbcCommandType',
      '.form [row="email_address"] input': 'fieldEmailAddress',
      '.form [row="httppath"] input': 'fieldHttppath',
      '.form [row="display_name"] input': 'fieldDisplayName',
      '.form [row="database_name"] input': 'fieldDatabaseName',
      '.form [row="jdbc_command_type"] input': 'fieldOracleDatabaseName',
      '.form [row="host"] input': 'fieldHost',
      '.form [row="port"] input': 'fieldPort',
      '.form [row="username"] input': 'fieldUsername',
      '.form [row="password"] input': 'fieldPassword',
      '.form [row="account_name"] input': 'fieldAccountName',
      '.form [row="warehouse_name"] input': 'fieldWarehouseName',
      '.form [row="snowflake_username"] input': 'fieldSnowflakeUsername',
      '.form [row="snowflake_password"] input': 'fieldSnowflakePassword',
      '.form [row="snowflake_pk8_pwd"] input': 'fieldSnowflakePk8Pwd',
      '.form [row="parent_database"] select': 'parentDatabaseInput',
      '.form [row="service_account"] input': 'fieldServiceAccount',
      '.form [row="project_id"] input': 'fieldProjectId',
      '.form [row="p12_key_file"] input': 'fieldBigqueryKeyFile',
      '.form [row="snowflake_pk8_key_file"] input': 'fieldSnowflakePk8KeyFile',
      '.form [row="type"] select': 'databaseTypeInput',
      '.form [row="jdbc_command_type"] select': 'jdbcCommandTypeInput',
      '.key-file.p12 .file-name': 'divFileName',
      '.key-file.p12': 'divKeyFile',
      '.key-file.pk8 .file-name': 'divSnowflakePk8FileName',
      '.key-file.pk8': 'divSnowflakePk8KeyFile',
      '.form [row="ssh-host"] input': 'fieldSshHost',
      '.form [row="ssh-port"] input': 'fieldSshPort',
      '.form [row="ssh-username"] input': 'fieldSshUsername',
      '.errors': 'errorsBlock',
      '.errors .error.validation': 'errorValidation',
      '.errors .error': 'errorMessages',
      '.errors .error .database_name': 'databaseNameInErrors',
      '.errors .error .username': 'usernameInErrors',
      '.errors .error .account_name': 'accountNameInErrors',
      '.errors .error.status-ok': 'successMessageEl',
      '.errors .error-unexpected .full-msg': 'unexpectedErrorFullMessageEl',
      '.errors .error-link': 'errorLinks',
      '.signup-form': 'signupForm',
      '.ssh-tunnel': 'sshTunnel',
      '.ssh-tunnel-form': 'sshTunnelForm',
      '.ssh-tunnel.help': 'sshTunnelHelp',
      '.private-network': 'privateNetwork',
      '.more-info': 'moreInfo',
      '.ssh-tunnel-doc': 'sshTunnelDoc',
      '.key-file.p12 .default-text': 'defaultBigqueryKeyFileText',
      '.key-file.pk8 .default-text': 'defaultSnowflakeKeyFileText',
      '.salesforce [row="client_id"] input': 'salesforceClientId',
      '.salesforce [row="client_secret"] input': 'salesforceClientSecret',
      '.salesforce [row="login_name"] input': 'salesforceLoginName',
      '.salesforce [row="login_password"] input': 'salesforceLoginPassword',
      '.salesforce [row="security_token"] input': 'salesforceSecurityToken',
      '#specific-database-fields': 'specificDatabaseFields'
    };

    DatabaseConnectForm.prototype.events = {
      'click .button.submit': 'submit',
      'change [row="type"] select': 'databaseTypeChanged',
      'change .form [row="p12_key_file"] input': 'handleKeyFileSet',
      'change .form [row="snowflake_pk8_key_file"] input': 'handleSnowflakePk8KeyFileSet',
      'keypress .form input': 'formInputKeypress',
      'click .private-network': 'privateNetworkClicked'
    };

    DatabaseConnectForm.STATUS_ERROR_UNEXPECTED = 'error-unexpected';

    DatabaseConnectForm.STATUS_OK = 'status-ok';

    DatabaseConnectForm.STATUS_PENDING = 'pending';

    DatabaseConnectForm.STATUS_VALIDATION = 'validation';

    DatabaseConnectForm.POLL_INTERVAL = 2000;

    DatabaseConnectForm.FORM_FIELDS = ['email_address', 'database_name', 'host', 'port', 'username', 'password'];

    DatabaseConnectForm.SYBASE = 'sybase';

    DatabaseConnectForm.BIGQUERY = 'bigquery';

    DatabaseConnectForm.SNOWFLAKE = 'snowflake';

    DatabaseConnectForm.PRESTO = 'presto';

    DatabaseConnectForm.ORACLE = 'oracle';

    DatabaseConnectForm.DATABRICKS = 'databricks';

    DatabaseConnectForm.P12FILE_SIZE_LIMIT = 5000;

    DatabaseConnectForm.NONE_PARENT_ID = "-1";

    function DatabaseConnectForm() {
      this.setSnowflakePk8KeyFileHandle = bind(this.setSnowflakePk8KeyFileHandle, this);
      this.handleSnowflakePk8KeyFileSet = bind(this.handleSnowflakePk8KeyFileSet, this);
      this.uploadSnowflakePk8Start = bind(this.uploadSnowflakePk8Start, this);
      this.setKeyFileHandle = bind(this.setKeyFileHandle, this);
      this.handleKeyFileSet = bind(this.handleKeyFileSet, this);
      this.uploadComplete = bind(this.uploadComplete, this);
      this.uploadFailed = bind(this.uploadFailed, this);
      this.uploadStart = bind(this.uploadStart, this);
      this.showConnectionLoader = bind(this.showConnectionLoader, this);
      this.updateParentChildRelationship = bind(this.updateParentChildRelationship, this);
      this.showConnectionResults = bind(this.showConnectionResults, this);
      this.stopDoctorPolling = bind(this.stopDoctorPolling, this);
      this.startDoctorPolling = bind(this.startDoctorPolling, this);
      this.doctorResponse = bind(this.doctorResponse, this);
      this.pollDoctor = bind(this.pollDoctor, this);
      this.validateForm = bind(this.validateForm, this);
      this.formInputKeypress = bind(this.formInputKeypress, this);
      this.handleAjaxResponse = bind(this.handleAjaxResponse, this);
      this.handleAjaxError = bind(this.handleAjaxError, this);
      this.validateAndSubmit = bind(this.validateAndSubmit, this);
      this.submit = bind(this.submit, this);
      var ref, ref1;
      DatabaseConnectForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'extraParams', 'uploadKeyRoute', 'uploadSnowflakePk8KeyRoute', 'uploadSnowflakeCacheablePk8KeyRoute', 'submitRoute', 'pollRoute', 'newCustomer', 'successMessage');
      this.polling = false;
      this.html(this.view('databases/form')({
        newCustomer: this.newCustomer,
        salesforceEnabled: (ref = App.Site.first()) != null ? ref.isSalesforceEnabled() : void 0,
        cacheEnabled: (ref1 = App.Site.first()) != null ? ref1.cache_enabled : void 0
      }));
      if (this.initialValues != null) {
        this.databaseTypeInput.val(this.initialValues.database_type);
        if (this.initialValues.database_type === 'SalesforceDatabase') {
          this.databaseTypeInput.prop('disabled', true);
        }
      } else {
        this.initialValues = {};
      }
      if (this.newCustomer) {
        this.moreInfo.hide();
      } else {
        this.sshTunnelDoc.hide();
      }
      this.databaseTypeInput.chosen({
        disable_search: true,
        width: '170px'
      });
      this.render();
    }

    DatabaseConnectForm.prototype.render = function() {
      this.specificDatabaseFields.html(this.specificDatabase().renderSpecificDatabaseFields());
      this.fieldDisplayName.val(this.initialValues.display_name);
      if (this.infoGrid != null) {
        this.$('.form').addClass('info-grid');
      }
      this.refreshElements();
      this.specificDatabase().render();
      if (!this.fieldDisplayName.val()) {
        return requestAnimationFrame((function(_this) {
          return function() {
            return _this.fieldDisplayName.trigger('focus');
          };
        })(this));
      }
    };

    DatabaseConnectForm.prototype.replicaDatabaseNames = function(values) {
      var d, databaseNames, databases, i, len;
      databaseNames = {};
      databases = App.Database.allSortedByName();
      for (i = 0, len = databases.length; i < len; i++) {
        d = databases[i];
        if ((values != null ? values.display_name : void 0) === d.database_name) {
          continue;
        }
        databaseNames[d.database_name] = d.id;
      }
      return databaseNames;
    };

    DatabaseConnectForm.prototype.submit = function() {
      var dbId, parentId, ref;
      parentId = this.parentId();
      dbId = (ref = this.initialValues) != null ? ref.database_id : void 0;
      if ((dbId != null) && (parentId != null) && parentId !== App.DatabaseConnectForm.NONE_PARENT_ID && App.Database.find(dbId).tableHarvests().length > 0) {
        return this.addDbDialog = App.Dialog.createDialog({
          warning: true,
          title: 'WARNING',
          mainText: "Are you sure you want to set this database as a replica? This will remove all cache settings for this database.",
          okCallback: ((function(_this) {
            return function() {
              return _this.validateAndSubmit();
            };
          })(this))
        });
      } else {
        return this.validateAndSubmit();
      }
    };

    DatabaseConnectForm.prototype.validateAndSubmit = function() {
      if (this.polling) {
        return;
      }
      if (!this.validateForm()) {
        return;
      }
      $.post(this.submitRoute, _.omit(this.formParams(), 'p12_key_file')).fail(this.handleAjaxError).done(this.handleAjaxResponse);
      return this.showConnectionLoader();
    };

    DatabaseConnectForm.prototype.handleAjaxError = function(response) {
      var error;
      error = (response != null ? response.error_message : void 0) || this.constructor.STATUS_ERROR_UNEXPECTED;
      this.stopDoctorPolling();
      this.showConnectionResults();
      return this.updateStatus(error);
    };

    DatabaseConnectForm.prototype.handleAjaxResponse = function(response) {
      var ref;
      if (response.error) {
        return this.handleAjaxError(response);
      }
      if (this.databaseType() === DatabaseConnectForm.SYBASE) {
        this.showError(DatabaseConnectForm.STATUS_OK);
        return this.showConnectionResults();
      } else if (this.databaseType() === this.constructor.BIGQUERY) {
        return this.readFile();
      } else if (this.databaseType() === this.constructor.SNOWFLAKE && ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0)) {
        return this.readSnowflakePk8File();
      } else {
        return this.startDoctorPolling();
      }
    };

    DatabaseConnectForm.prototype.formParams = function() {
      var base, command_type, databaseName, databaseType, host, k, params, password, ref, username, v;
      databaseType = this.databaseType();
      if (databaseType === this.constructor.SNOWFLAKE) {
        host = this.fieldAccountName.val();
        username = this.fieldSnowflakeUsername.val();
        password = this.fieldSnowflakePassword.val();
      } else {
        host = this.fieldHost.val();
        username = this.specificDatabase().username();
        password = this.specificDatabase().password();
      }
      command_type = databaseType === this.constructor.ORACLE ? this.jdbcCommandTypeInput.val() : '';
      databaseName = databaseType === this.constructor.ORACLE ? this.fieldOracleDatabaseName.val() : this.fieldDatabaseName.val();
      params = $.extend({
        database_type: databaseType,
        email_address: this.fieldEmailAddress.val(),
        database_name: databaseName,
        project_id: this.fieldProjectId.val(),
        display_name: this.fieldDisplayName.val(),
        httppath: this.fieldHttppath.val(),
        host: host,
        port: this.fieldPort.val(),
        username: username,
        service_account: this.fieldServiceAccount.val(),
        password: password,
        ssh_host: this.fieldSshHost.val(),
        ssh_port: this.fieldSshPort.val(),
        ssh_username: this.fieldSshUsername.val(),
        p12_key_file: this.validKeyFile,
        command_type: command_type,
        parent_database_id: this.parentId(),
        specific_database_attributes: typeof (base = this.specificDatabase()).attributes === "function" ? base.attributes() : void 0,
        warehouse_name: this.fieldWarehouseName.val()
      }, this.extraParams);
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        params = $.extend(params, {
          snowflake_pk8_key_file: this.validSnowflakePk8KeyFile,
          snowflake_pk8_pwd: this.fieldSnowflakePk8Pwd.val()
        });
      }
      for (k in params) {
        v = params[k];
        if (typeof v === 'string') {
          params[k] = v.trim();
        }
      }
      return params;
    };

    DatabaseConnectForm.prototype.formInputKeypress = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        this.trigger('busy');
        return this.submit();
      }
    };

    DatabaseConnectForm.prototype.databaseType = function() {
      return this.databaseTypeInput.val();
    };

    DatabaseConnectForm.prototype.parentId = function() {
      return this.parentDatabaseInput.val() || App.DatabaseConnectForm.NONE_PARENT_ID;
    };

    DatabaseConnectForm.prototype.validateForm = function() {
      var badDisplayName, badEmail, displayNameHasSpace, email, errorFields, errorMsg, field, missingFields, msg, ref, titleizedFields;
      missingFields = this.specificDatabase().missingFields();
      if (this.databaseType() === this.constructor.SNOWFLAKE) {
        if (missingFields.includes('username')) {
          missingFields.push('snowflake_username');
        }
        if (missingFields.includes('password')) {
          missingFields.push('snowflake_password');
        }
        if (missingFields.includes('host')) {
          missingFields.push('account_name');
        }
        missingFields = missingFields.withoutAny(['username', 'password', 'host']);
      }
      errorFields = [].concat(missingFields);
      if (this.newCustomer) {
        email = $.trim(this.fieldEmailAddress.val());
        if (email !== '' && !App.Utils.probablyAValidEmailAddress(email)) {
          errorFields = ['email_address'].concat(missingFields);
          badEmail = true;
        }
      }
      displayNameHasSpace = (ref = this.fieldDisplayName.val()) != null ? ref.includes(' ') : void 0;
      if (displayNameHasSpace) {
        errorFields = ['display_name'].concat(errorFields);
        badDisplayName = true;
      }
      this.markFieldsAsErrors(errorFields);
      if (errorFields.length > 0) {
        errorMsg = "";
        if (badEmail) {
          errorMsg += "Please enter a valid email address. ";
        }
        if (badDisplayName) {
          errorMsg += "Display Name should not have spaces. ";
        }
        if (missingFields.length > 0) {
          titleizedFields = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = missingFields.length; i < len; i++) {
              field = missingFields[i];
              results.push(App.Utils.titleize(field));
            }
            return results;
          })();
          msg = "Missing required field";
          if (titleizedFields.length > 1) {
            msg = msg.pluralize();
          }
          errorMsg += msg + ": " + (titleizedFields.join(', '));
        }
        this.errorValidation.text(errorMsg);
        this.showError(this.constructor.STATUS_VALIDATION);
        return false;
      } else {
        return true;
      }
    };

    DatabaseConnectForm.prototype.removeAllErrors = function() {
      return this.$('.form input').removeClass('error');
    };

    DatabaseConnectForm.prototype.markFieldsAsErrors = function(errorFields) {
      var field, i, len, ref;
      this.removeAllErrors();
      if (errorFields.isEmpty()) {
        return;
      }
      for (i = 0, len = errorFields.length; i < len; i++) {
        field = errorFields[i];
        this.$(".form [row=\"" + field + "\"] input").addClass('error');
        if (field === 'database_name') {
          this.fieldOracleDatabaseName.addClass('error');
        }
      }
      if (errorFields.includes('p12_key_file')) {
        this.divKeyFile.addClass('error');
      }
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        if (errorFields.includes('snowflake_pk8_key_file')) {
          return this.divSnowflakePk8KeyFile.addClass('error');
        }
      }
    };

    DatabaseConnectForm.prototype.bigqueryRows = function() {
      return [this.rowBigqueryServiceAccount, this.rowBigqueryProjectId, this.rowBigqueryKeyFile];
    };

    DatabaseConnectForm.prototype.standardRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    DatabaseConnectForm.prototype.oracleRows = function() {
      return [this.rowJdbcCommandType, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    DatabaseConnectForm.prototype.prestoRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowDbPort, this.rowDbUser];
    };

    DatabaseConnectForm.prototype.replicaRows = function() {
      return [this.parentDatabase];
    };

    DatabaseConnectForm.prototype.snowflakeRows = function() {
      var ref, rows;
      rows = [this.rowDbName, this.rowAccountName, this.rowWarehouseName, this.rowSnowflakeUsername, this.rowSnowflakePassword];
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        rows = rows.concat([this.rowSnowflakeKeyFile, this.rowSnowflakePk8KeyFile]);
      }
      return rows;
    };

    DatabaseConnectForm.prototype.databricksRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowHttppath, this.rowDbUser, this.rowPassword];
    };

    DatabaseConnectForm.prototype.specificDatabase = function() {
      var databaseClass, ref;
      databaseClass = (ref = App.DatabaseConnectForm[(this.databaseType()) + "ConnectForm"]) != null ? ref : App.DatabaseConnectForm.GenericDatabaseConnectForm;
      return this._specificDatabase = new databaseClass(this);
    };

    DatabaseConnectForm.SalesforceDatabaseConnectForm = (function() {
      SalesforceDatabaseConnectForm.SALESFORCE_FIELDS = ['display_name', 'login_name', 'login_password', 'security_token', 'client_id', 'client_secret'];

      function SalesforceDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
      }

      SalesforceDatabaseConnectForm.prototype.render = function() {
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.toggleSshTunnel(false);
        return this.databaseConnectForm.togglePrivateNetwork(false);
      };

      SalesforceDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('databases/salesforce_form')({
          initialValues: this.databaseConnectForm.initialValues
        });
      };

      SalesforceDatabaseConnectForm.prototype.username = function() {
        return this.databaseConnectForm.salesforceLoginName.val();
      };

      SalesforceDatabaseConnectForm.prototype.password = function() {
        return this.databaseConnectForm.salesforceLoginPassword.val();
      };

      SalesforceDatabaseConnectForm.prototype.attributes = function() {
        var ref;
        return {
          id: (ref = this.databaseConnectForm.initialValues) != null ? ref.specific_database_id : void 0,
          client_id: this.databaseConnectForm.salesforceClientId.val(),
          client_secret: this.databaseConnectForm.salesforceClientSecret.val(),
          login_token: this.databaseConnectForm.salesforceSecurityToken.val()
        };
      };

      SalesforceDatabaseConnectForm.prototype.requiredFields = function() {
        return this.constructor.SALESFORCE_FIELDS;
      };

      SalesforceDatabaseConnectForm.prototype.missingFields = function() {
        var field, formParams, requiredFields, salesforceParams;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        formParams = this.databaseConnectForm.formParams();
        salesforceParams = {
          'client_id': formParams.specific_database_attributes['client_id'],
          'client_secret': formParams.specific_database_attributes['client_secret'],
          'security_token': formParams.specific_database_attributes['login_token'],
          'login_name': formParams['username'],
          'login_password': formParams['password'],
          'display_name': formParams['display_name']
        };
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (salesforceParams[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      return SalesforceDatabaseConnectForm;

    })();

    DatabaseConnectForm.GenericDatabaseConnectForm = (function() {
      GenericDatabaseConnectForm.PLACEHOLDERS = {
        "default": ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        postgres: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        redshift: ["db1.abcdefg.us-east-1.redshift.amazonaws.com", "5439"],
        mysql: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "3306"],
        vertica: ["db1.company.com", "5433"],
        sql_server: ["db1.company.com", "1433"],
        oracle: ["db1.company.com", "1521"],
        memsql: ["ec2-154-43-211-119.compute-1.amazonaws.com", "3306"],
        sybase: ["db1.company.com", "5000"],
        bigquery: ["N/A", "N/A"],
        exasol: ["192.168.100.5", "8563"],
        presto: ["db1.company.com", "9898"]
      };

      function GenericDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
        this.handleSnowflakePk8Drop = bind(this.handleSnowflakePk8Drop, this);
        this.handleDrop = bind(this.handleDrop, this);
      }

      GenericDatabaseConnectForm.prototype.render = function() {
        var hideSshTunnelLink, i, j, l, len, len1, len2, len3, len4, m, n, ref, ref1, ref2, ref3, ref4, ref5, row;
        if (this.databaseConnectForm.newCustomer || App.Database.countWithReplicas() <= 1) {
          this.databaseConnectForm.parentDatabase.hide();
        }
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.parentDatabaseInput.chosen({
          disable_search: true,
          width: '170px',
          placeholder_text_single: 'None'
        });
        if (this.databaseConnectForm.initialValues != null) {
          this.populateForm();
        } else {
          this.populateBlankForm();
        }
        ref = this.databaseConnectForm.standardRows();
        for (i = 0, len = ref.length; i < len; i++) {
          row = ref[i];
          row.hide();
        }
        ref1 = this.databaseConnectForm.bigqueryRows();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          row = ref1[j];
          row.hide();
        }
        ref2 = this.databaseConnectForm.snowflakeRows();
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          row = ref2[l];
          row.hide();
        }
        ref3 = this.databaseConnectForm.databricksRows();
        for (m = 0, len3 = ref3.length; m < len3; m++) {
          row = ref3[m];
          row.hide();
        }
        ref4 = this.databaseConnectForm.oracleRows();
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          row = ref4[n];
          row.hide();
        }
        this.databaseConnectForm.toggleSshTunnel(false);
        hideSshTunnelLink = [App.DatabaseConnectForm.BIGQUERY, App.DatabaseConnectForm.SNOWFLAKE].includes(this.databaseConnectForm.databaseType());
        this.databaseConnectForm.togglePrivateNetwork(!hideSshTunnelLink);
        this.showRows();
        if (this.databaseConnectForm.databaseType() === App.DatabaseConnectForm.BIGQUERY) {
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('drop', this.handleDrop, false);
        } else if (this.databaseConnectForm.fieldBigqueryKeyFile.length > 0) {
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('drop', this.handleDrop, false);
        }
        if ((ref5 = App.Site.first()) != null ? ref5.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.SNOWFLAKE) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('drop', this.handleSnowflakePk8Drop, false);
          } else if (this.databaseConnectForm.fieldSnowflakePk8KeyFile.length > 0) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('drop', this.handleSnowflakePk8Drop, false);
          }
        }
        if (this.databaseConnectForm.databaseType() === App.DatabaseConnectForm.ORACLE) {
          this.databaseConnectForm.jdbcCommandTypeInput.chosen({
            disable_search: true,
            width: '119px'
          });
        }
        return this.setPlaceholderText();
      };

      GenericDatabaseConnectForm.prototype.populateForm = function() {
        this.databaseConnectForm.databaseTypeInput.trigger('chosen:updated');
        if (this.databaseConnectForm.initialValues.has_child) {
          this.databaseConnectForm.parentDatabaseInput.prop('disabled', true);
        }
        this.databaseConnectForm.parentDatabaseInput.val(this.databaseConnectForm.initialValues.parent_database_id || App.DatabaseConnectForm.NONE_PARENT_ID);
        this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
        this.databaseConnectForm.fieldEmailAddress.val(this.databaseConnectForm.initialValues.email_address);
        this.databaseConnectForm.fieldDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
        this.databaseConnectForm.fieldHost.val(this.databaseConnectForm.initialValues.host);
        this.databaseConnectForm.fieldPort.val(this.databaseConnectForm.initialValues.port);
        this.databaseConnectForm.fieldUsername.val(this.databaseConnectForm.initialValues.username);
        if (this.databaseConnectForm.initialValues.ssh_host != null) {
          this.databaseConnectForm.fieldSshHost.val(this.databaseConnectForm.initialValues.ssh_host);
        }
        if (this.databaseConnectForm.initialValues.ssh_port != null) {
          this.databaseConnectForm.fieldSshPort.val(this.databaseConnectForm.initialValues.ssh_port);
        }
        if (this.databaseConnectForm.initialValues.ssh_username != null) {
          this.databaseConnectForm.fieldSshUsername.val(this.databaseConnectForm.initialValues.ssh_username);
        }
        if (this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.BIGQUERY) {
          this.databaseConnectForm.fieldServiceAccount.val(this.databaseConnectForm.initialValues.username);
          this.databaseConnectForm.fieldProjectId.val(this.databaseConnectForm.initialValues.database_name);
        }
        if (this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.SNOWFLAKE) {
          this.databaseConnectForm.fieldWarehouseName.val(this.databaseConnectForm.initialValues.warehouse_name);
          this.databaseConnectForm.fieldAccountName.val(this.databaseConnectForm.initialValues.host);
          this.databaseConnectForm.fieldSnowflakeUsername.val(this.databaseConnectForm.initialValues.username);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.ORACLE) {
          this.databaseConnectForm.fieldOracleDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
          return this.databaseConnectForm.jdbcCommandTypeInput.val(this.databaseConnectForm.initialValues.command_type === 'service_name' ? 'service_name' : 'sid');
        }
      };

      GenericDatabaseConnectForm.prototype.populateBlankForm = function() {
        this.databaseConnectForm.parentDatabaseInput.val(App.DatabaseConnectForm.NONE_PARENT_ID);
        return this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
      };

      GenericDatabaseConnectForm.prototype.setPlaceholderText = function() {
        var placeholders;
        placeholders = this.constructor.PLACEHOLDERS[this.databaseConnectForm.databaseType()];
        if (placeholders != null) {
          return this.databaseConnectForm.setPlaceholders(placeholders[0], placeholders[1]);
        }
      };

      GenericDatabaseConnectForm.prototype.handleDragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleDrop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setKeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8DragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8Drop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setSnowflakePk8KeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.showRows = function() {
        var i, len, results, row, rows;
        rows = (function() {
          switch (this.databaseConnectForm.databaseType()) {
            case App.DatabaseConnectForm.BIGQUERY:
              return this.databaseConnectForm.bigqueryRows();
            case App.DatabaseConnectForm.SNOWFLAKE:
              return this.databaseConnectForm.snowflakeRows();
            case App.DatabaseConnectForm.PRESTO:
              return this.databaseConnectForm.prestoRows();
            case App.RedesignDatabaseConnectForm.ORACLE:
              return this.databaseConnectForm.oracleRows();
            case App.RedesignDatabaseConnectForm.DATABRICKS:
              return this.databaseConnectForm.databricksRows();
            default:
              return this.databaseConnectForm.standardRows();
          }
        }).call(this);
        results = [];
        for (i = 0, len = rows.length; i < len; i++) {
          row = rows[i];
          results.push(row.show());
        }
        return results;
      };

      GenericDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('databases/non_polymorphic_form_fields')({
          moreHelp: this.databaseConnectForm.view('databases/more_help')(),
          databaseNames: this.databaseConnectForm.replicaDatabaseNames(this.databaseConnectForm.initialValues)
        });
      };

      GenericDatabaseConnectForm.prototype.username = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakeUsername.val();
        } else {
          return this.databaseConnectForm.fieldUsername.val();
        }
      };

      GenericDatabaseConnectForm.prototype.password = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakePassword.val();
        } else {
          return this.databaseConnectForm.fieldPassword.val();
        }
      };

      GenericDatabaseConnectForm.prototype.missingFields = function() {
        var field, params, requiredFields;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        params = this.databaseConnectForm.formParams();
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (params[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      GenericDatabaseConnectForm.prototype.requiredFields = function() {
        var constructor;
        constructor = this.databaseConnectForm.constructor;
        switch (this.databaseConnectForm.databaseType()) {
          case constructor.BIGQUERY:
            return ['service_account', 'project_id', 'email_address', 'p12_key_file'];
          case constructor.SNOWFLAKE:
            return ['email_address', 'database_name', 'warehouse_name', 'host', 'username'];
          case constructor.PRESTO:
            return ['email_address', 'host', 'port', 'username'];
          default:
            return constructor.FORM_FIELDS;
        }
      };

      return GenericDatabaseConnectForm;

    })();

    DatabaseConnectForm.prototype.databaseTypeChanged = function() {
      this.initialValues = this.formParams();
      return this.render();
    };

    DatabaseConnectForm.prototype.setPlaceholders = function(host, port) {
      this.fieldHost.attr('placeholder', host);
      return this.fieldPort.attr('placeholder', port);
    };

    DatabaseConnectForm.prototype.showError = function(status) {
      var app, filter, foundError, logOpts;
      filter = "." + status + "[databases~=\"" + (this.databaseType()) + "\"], ." + status + ":not([databases])";
      foundError = this.errorMessages.filter(filter);
      foundError.slideDown();
      this.errorMessages.not(foundError).slideUp();
      if (!(foundError.length > 0)) {
        this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      }
      this.maybeShowErrorLink(foundError);
      this.trigger('error');
      logOpts = {
        detail: status
      };
      if (this.logContext) {
        logOpts.context = this.logContext;
      }
      App.Utils.logFeature('db-connect-error', logOpts);
      app = AppRedesign.current();
      if (app && typeof app.tutorial === 'function') {
        return app.tutorial();
      }
    };

    DatabaseConnectForm.prototype.maybeShowErrorLink = function(foundError) {
      var databaseToDoc;
      this.errorsBlock.find('.error-link').remove();
      if (this.databaseType() !== 'sql_server') {
        return;
      }
      databaseToDoc = {
        'sql_server': 'connecting-sql-server'
      };
      if (foundError.find('.help-connecting').length === 0) {
        return foundError.append(this.view('databases/error_link')({
          link: databaseToDoc[this.databaseType()]
        }));
      }
    };

    DatabaseConnectForm.prototype.substituteErrors = function() {
      this.databaseNameInErrors.text(this.formParams()['database_name']);
      this.usernameInErrors.text(this.formParams()['username']);
      return this.accountNameInErrors.text(this.formParams()['host']);
    };

    DatabaseConnectForm.prototype.pollDoctor = function() {
      return $.post(this.pollRoute, this.extraParams).fail(this.handleAjaxError).done(this.doctorResponse);
    };

    DatabaseConnectForm.prototype.doctorResponse = function(response) {
      var ref;
      if (response.status === this.constructor.STATUS_PENDING) {
        return;
      }
      this.stopDoctorPolling();
      this.updateStatus(response.status, response.error);
      this.showConnectionResults();
      this.updateParentChildRelationship();
      if (response.status === this.constructor.STATUS_OK) {
        if (response.id != null) {
          if ((ref = App.User.currentUser()) != null) {
            ref.setLastUsedDatabase(response.id);
          }
        }
        this.trigger('database-connection-success');
        return this.trigger('success');
      }
    };

    DatabaseConnectForm.prototype.updateStatus = function(status, fullError) {
      if (fullError == null) {
        fullError = "";
      }
      this.unexpectedErrorFullMessageEl.text(fullError);
      this.substituteErrors();
      return this.showError(status);
    };

    DatabaseConnectForm.prototype.startDoctorPolling = function() {
      this.stopDoctorPolling();
      this.polling = true;
      return this.doctorInterval = setInterval(this.pollDoctor, this.constructor.POLL_INTERVAL);
    };

    DatabaseConnectForm.prototype.stopDoctorPolling = function() {
      this.polling = false;
      clearInterval(this.doctorInterval);
      return this.doctorInterval = null;
    };

    DatabaseConnectForm.prototype.showConnectionResults = function() {
      if (!this.noDbLoader) {
        this.dbLoader.hide();
      }
      this.submitButton.text('Submit');
      return this.submitButton.removeClass('testing');
    };

    DatabaseConnectForm.prototype.updateParentChildRelationship = function() {
      var parentDb, parentId, ref;
      parentId = this.parentId();
      App.Database.trigger('parent-database-added', parentId);
      if (!((parentId != null) && parentId !== App.DatabaseConnectForm.NONE_PARENT_ID)) {
        return;
      }
      parentDb = App.Database.find(parentId);
      parentDb.has_child = true;
      parentDb.save({
        ajax: false
      });
      return (ref = App.User.currentUser()) != null ? ref.setLastUsedDatabase(parentId) : void 0;
    };

    DatabaseConnectForm.prototype.showConnectionLoader = function() {
      if (!this.noDbLoader) {
        this.dbLoader.fadeIn();
        this.dbLoader.css('display', 'block');
      }
      this.errorMessages.slideUp();
      this.errorLinks.slideUp();
      this.submitButton.text('Testing');
      return this.submitButton.addClass('testing');
    };

    DatabaseConnectForm.prototype.privateNetworkClicked = function() {
      this.toggleSshTunnel(true);
      this.togglePrivateNetwork(false);
      return this.trigger('content-expanded');
    };

    DatabaseConnectForm.prototype.toggleSshTunnel = function(show) {
      this.sshTunnelForm.toggle(show);
      return this.sshTunnelHelp.toggle(show);
    };

    DatabaseConnectForm.prototype.togglePrivateNetwork = function(show) {
      return this.privateNetwork.toggle(show);
    };

    DatabaseConnectForm.prototype.readFile = function() {
      var reader;
      reader = new FileReader();
      if (this.keyFile == null) {
        this.keyFile = this.fieldBigqueryKeyFile.val();
      }
      reader.file = this.keyFile;
      reader.onload = this.uploadStart;
      reader.readAsBinaryString(this.keyFile);
      return this.keyFileSize = this.keyFile.size;
    };

    DatabaseConnectForm.prototype.uploadStart = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadKeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keyFileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    DatabaseConnectForm.prototype.uploadFailed = function(xhr, msg, err) {
      this.errorValidation.text('Key file upload failed.');
      this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      return this.showConnectionResults();
    };

    DatabaseConnectForm.prototype.uploadComplete = function() {
      return this.startDoctorPolling();
    };

    DatabaseConnectForm.prototype.handleKeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      return this.setKeyFileHandle(evt.target.files[0]);
    };

    DatabaseConnectForm.prototype.setKeyFileHandle = function(file) {
      if (!file.type.match('application/x-pkcs12')) {
        return this.keyFileError('Key file should be of type .p12');
      } else if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keyFileError('Maximum key file size is 5KB');
      } else {
        this.defaultBigqueryKeyFileText.hide();
        this.errorValidation.text('');
        this.divKeyFile.removeClass('error');
        this.keyFile = file;
        this.divFileName.text(file.name);
        return this.validKeyFile = file.name;
      }
    };

    DatabaseConnectForm.prototype.keyFileError = function(message) {
      this.divFileName.text('');
      this.divKeyFile.addClass('error');
      this.defaultBigqueryKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validKeyFile = '';
    };

    DatabaseConnectForm.prototype.readSnowflakePk8File = function() {
      var reader;
      reader = new FileReader();
      if (this.keySnowflakePk8File == null) {
        this.keySnowflakePk8File = this.fieldSnowflakePk8KeyFile.val();
      }
      if (this.keySnowflakePk8File) {
        reader.file = this.keySnowflakePk8File;
        reader.onload = this.uploadSnowflakePk8Start;
        reader.readAsBinaryString(this.keySnowflakePk8File);
        return this.keySnowflakePk8FileSize = this.keySnowflakePk8File.size;
      } else {
        return this.startDoctorPolling();
      }
    };

    DatabaseConnectForm.prototype.uploadSnowflakePk8Start = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadSnowflakePk8KeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keySnowflakePk8FileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    DatabaseConnectForm.prototype.handleSnowflakePk8KeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      return this.setSnowflakePk8KeyFileHandle(evt.target.files[0]);
    };

    DatabaseConnectForm.prototype.setSnowflakePk8KeyFileHandle = function(file) {
      if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keySnowflakePk8FileError('Maximum key file size is 5KB');
      } else {
        this.defaultSnowflakeKeyFileText.hide();
        this.errorValidation.text('');
        this.divSnowflakePk8KeyFile.removeClass('error');
        this.keySnowflakePk8File = file;
        this.divSnowflakePk8FileName.text(file.name);
        return this.validSnowflakePk8KeyFile = file.name;
      }
    };

    DatabaseConnectForm.prototype.keySnowflakePk8FileError = function(message) {
      this.divSnowflakePk8FileName.text('');
      this.divSnowflakePk8KeyFile.addClass('error');
      this.defaultSnowflakeKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validSnowflakePk8KeyFile = '';
    };

    return DatabaseConnectForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Dialog = (function(superClass) {
    extend(Dialog, superClass);

    Dialog.prototype.elements = {
      '.dialog': 'dialog',
      '.dialog-content': 'contentEl',
      '.cancel-icon': 'cancelIcon'
    };

    Dialog.prototype.events = {
      'click .cancel-icon': 'close'
    };

    Dialog.createDialog = function(properties, container) {
      var dialog, frame;
      if (container == null) {
        container = null;
      }
      container || (container = $('#dialogs'));
      if (container == null) {
        console.error('Error, tried to add a dialog but dialog container does not exist');
        return;
      }
      frame = App.Utils.appendFrame(container, 'dialog-container');
      properties['el'] = frame;
      if (properties['viewController'] == null) {
        properties['viewController'] = new App.DialogViewController({
          el: $('<div class="default-dialog"></div>'),
          mainText: properties.mainText,
          okCallback: properties.okCallback
        });
      }
      return dialog = new App.Dialog(properties);
    };

    function Dialog() {
      this.finish = bind(this.finish, this);
      this.close = bind(this.close, this);
      Dialog.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'title', 'viewController');
      if (this.title === '') {
        this.el.addClass('no-title');
      }
      if (this.warning) {
        this.el.addClass('with-warning');
      }
      if (!this.noCancel) {
        App.hotkeys.bind(App.HotkeyManager.ESC, this.close);
      }
      this.viewController.bind('close', this.close);
      this.render();
    }

    Dialog.prototype.release = function() {
      if (!this.noCancel) {
        App.hotkeys.unbind(App.HotkeyManager.ESC, this.close);
      }
      this.viewController.release();
      return Dialog.__super__.release.apply(this, arguments);
    };

    Dialog.prototype.render = function() {
      if (this.customDialogClass) {
        this.el.addClass(this.customDialogClass);
      } else {
        this.el.addClass('dark-theme');
      }
      this.html(this.view('dialog/frame')({
        title: this.title
      }));
      if (this.noCancel) {
        this.cancelIcon.hide();
      }
      this.contentEl.html(this.viewController.el);
      this.viewController.refreshElements();
      if (this.noAnimateOpen) {
        this.dialog.show();
        this.dialog.addClass('visible');
      } else {
        App.Utils.animateHack(true, 'visible', this.dialog);
      }
      if (this.noCancel) {
        return App.PageOverlay.showWithoutCallback();
      } else {
        return App.PageOverlay.show(this.close);
      }
    };

    Dialog.prototype.close = function() {
      App.PageOverlay.hide();
      App.Utils.animateHack(false, 'visible', this.dialog);
      setTimeout(this.finish, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      return this.trigger('close');
    };

    Dialog.prototype.finish = function() {
      if (this.closeCallback != null) {
        this.closeCallback();
      }
      return this.release();
    };

    return Dialog;

  })(Spine.Controller);

  App.DialogViewController = (function(superClass) {
    extend(DialogViewController, superClass);

    DialogViewController.prototype.elements = {
      '.main-text': 'mainTextEl'
    };

    DialogViewController.prototype.events = {
      'click .ok.button': 'ok',
      'click .cancel.button': 'close'
    };

    function DialogViewController() {
      this.close = bind(this.close, this);
      this.ok = bind(this.ok, this);
      DialogViewController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'mainText', 'okCallback');
      this.html(this.view('dialog/dialog')({
        mainText: this.mainText,
        cancelButtonText: this.cancelButtonText || 'Cancel',
        okButtonText: this.okButtonText || 'Ok'
      }));
    }

    DialogViewController.prototype.ok = function() {
      this.okCallback();
      return this.close();
    };

    DialogViewController.prototype.close = function() {
      return this.trigger('close');
    };

    return DialogViewController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.ManipulateDirectoryForSimpleGrid = (function() {
    function ManipulateDirectoryForSimpleGrid() {}

    ManipulateDirectoryForSimpleGrid.call = function(rows, editingRows, nameCallback, setDisabledCallback, canEditCallback) {
      var i, len, row;
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        row.name = nameCallback(row);
        row.sortValue = editingRows ? '2' + row.name : '1' + row.name;
        if (!editingRows) {
          row.inDirectory = true;
        }
        if (setDisabledCallback != null) {
          row.disabled = setDisabledCallback(row);
        }
        if (canEditCallback != null) {
          row.can_edit = canEditCallback(row);
        }
      }
      return rows;
    };

    return ManipulateDirectoryForSimpleGrid;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDirectoryHelper = (function(superClass) {
    extend(RedesignDirectoryHelper, superClass);

    function RedesignDirectoryHelper() {
      this.prepareLookups = bind(this.prepareLookups, this);
      this.loadedDirectory = bind(this.loadedDirectory, this);
      this.loaded = false;
      this.loadDirectory();
    }

    RedesignDirectoryHelper.prototype.loadDirectory = function() {
      return jQuery.ajax({
        method: 'get',
        data: {
          client_site_id: App.Site.first().id
        },
        url: "/site_families/directory_info"
      }).done(this.loadedDirectory);
    };

    RedesignDirectoryHelper.prototype.loadedDirectory = function(directory) {
      this.directory = directory;
      App.Site.bind('change', this.prepareLookups);
      this.siteFamilyId = this.directory.site_family_id;
      App.User.applyUpdates(this.directory.users);
      App.Group.applyUpdates(this.directory.groups);
      App.UserRole.applyUpdates(this.directory.user_roles);
      App.GroupRole.applyUpdates(this.directory.group_roles);
      App.GroupMembership.applyUpdates(this.directory.group_memberships);
      this.prepareLookups();
      this.loaded = true;
      return this.trigger('directory-loaded');
    };

    RedesignDirectoryHelper.prototype.hasLoaded = function() {
      return this.loaded;
    };

    RedesignDirectoryHelper.prototype.reset = function() {
      new App.RemoveNonSiteModels().call();
      return App.Site.unbind('change', this.prepareLookups);
    };

    RedesignDirectoryHelper.prototype.prepareLookups = function() {
      var i, len, ref, results, site;
      this.sites = App.Site.first().site_info_list;
      this.siteLookup = {};
      ref = this.sites;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        site = ref[i];
        results.push(this.siteLookup[site.id] = site);
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.siteIdForLocalGroup = function(groupId) {
      var groupRole, i, len, ref;
      ref = App.GroupRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (groupRole.group_id === groupId) {
          return groupRole.site_id;
        }
      }
    };

    RedesignDirectoryHelper.prototype.siteForId = function(siteId) {
      var ref;
      return (ref = this.siteLookup) != null ? ref[siteId] : void 0;
    };


    /* For site view */

    RedesignDirectoryHelper.prototype.usersInSite = function(siteId) {
      var i, len, ref, results, user, userRole;
      ref = App.UserRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (!(userRole.site_id === siteId)) {
          continue;
        }
        user = App.User.exists(userRole.user_id);
        if (!user) {
          continue;
        }
        results.push({
          user: user,
          userRole: userRole
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.usersNotInSite = function(siteId) {
      var i, len, ref, results, user, userIdsInSite, userRole;
      userIdsInSite = (function() {
        var i, len, ref, results;
        ref = App.UserRole.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          userRole = ref[i];
          if (userRole.site_id === siteId) {
            results.push(userRole.user_id);
          }
        }
        return results;
      })();
      ref = App.User.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        user = ref[i];
        if (!userIdsInSite.includes(user.id)) {
          results.push({
            user: user
          });
        }
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.usersInSiteFromSearch = function(siteId, users) {
      var i, len, ref, results, user, userRole;
      ref = App.UserRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (!(userRole.site_id === siteId)) {
          continue;
        }
        user = users.find(function(u) {
          return u.id === userRole.user_id;
        });
        if (!user) {
          continue;
        }
        results.push({
          user: user,
          userRole: userRole
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.groupsInSite = function(siteId) {
      var group, groupRole, i, len, ref, results;
      ref = App.GroupRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (!(groupRole.site_id === siteId)) {
          continue;
        }
        group = App.Group.exists(groupRole.group_id);
        if (!group) {
          continue;
        }
        results.push({
          group: group,
          groupRole: groupRole
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.customerGroupsNotInSite = function(siteId) {
      var group, groupIdsInSite, groupRole, i, len, ref, results;
      groupIdsInSite = (function() {
        var i, len, ref, results;
        ref = App.GroupRole.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          groupRole = ref[i];
          if (groupRole.site_id === siteId) {
            results.push(groupRole.group_id);
          }
        }
        return results;
      })();
      ref = App.Group.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (!groupIdsInSite.includes(group.id) && group.site_family_id === this.siteFamilyId) {
          results.push({
            group: group
          });
        }
      }
      return results;
    };


    /* For group view */

    RedesignDirectoryHelper.prototype.usersInGroup = function(groupId) {
      var groupMembership, i, len, ref, results, user;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupMembership = ref[i];
        if (!(groupMembership.group_id === groupId)) {
          continue;
        }
        user = App.User.exists(groupMembership.user_id);
        if (!user) {
          continue;
        }
        results.push({
          user: user,
          groupMembership: groupMembership
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.usersInGroupFromSearch = function(groupId, users) {
      var groupMembership, i, len, ref, results, user;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupMembership = ref[i];
        if (!(groupMembership.group_id === groupId)) {
          continue;
        }
        user = users.find(function(u) {
          return u.id === groupMembership.user_id;
        });
        if (!user) {
          continue;
        }
        results.push({
          user: user,
          groupMembership: groupMembership
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.usersNotInGroup = function(groupId) {
      var group, groupMembership, i, j, len, len1, ref, ref1, results, results1, siteId, user, userCombo, userIdsInGroup;
      userIdsInGroup = (function() {
        var i, len, ref, results;
        ref = App.GroupMembership.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          groupMembership = ref[i];
          if (groupMembership.group_id === groupId) {
            results.push(groupMembership.user_id);
          }
        }
        return results;
      })();
      group = App.Group.exists(groupId);
      if (!group) {
        return [];
      }
      if (group.isSiteFamilyGroup()) {
        ref = App.User.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          user = ref[i];
          if (!userIdsInGroup.includes(user.id)) {
            results.push({
              user: user
            });
          }
        }
        return results;
      } else {
        siteId = this.siteIdForLocalGroup(groupId);
        ref1 = this.usersInSite(siteId);
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          userCombo = ref1[j];
          if (!userIdsInGroup.includes(userCombo.user.id)) {
            results1.push({
              user: userCombo.user
            });
          }
        }
        return results1;
      }
    };

    RedesignDirectoryHelper.prototype.sitesForGroup = function(groupId) {
      var groupRole, i, len, ref, ref1, results, site;
      ref = App.GroupRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (!(groupRole.group_id === groupId)) {
          continue;
        }
        site = (ref1 = this.siteLookup) != null ? ref1[groupRole.site_id] : void 0;
        if (!site) {
          continue;
        }
        results.push({
          site: site,
          groupRole: groupRole
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.sitesNotLinkedToGroup = function(groupId) {
      var group, groupRole, i, len, ref, results, site, siteIdsLinkedToGroup;
      group = App.Group.exists(groupId);
      if (!group) {
        return [];
      }
      if (!group.isSiteFamilyGroup()) {
        return [];
      }
      siteIdsLinkedToGroup = (function() {
        var i, len, ref, results;
        ref = App.GroupRole.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          groupRole = ref[i];
          if (groupRole.group_id === groupId) {
            results.push(groupRole.site_id);
          }
        }
        return results;
      })();
      ref = this.sites;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        site = ref[i];
        if (!siteIdsLinkedToGroup.includes(site.id)) {
          results.push({
            site: site
          });
        }
      }
      return results;
    };


    /* For user view */

    RedesignDirectoryHelper.prototype.groupsForUser = function(userId) {
      var group, groupMembership, i, len, ref, results;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupMembership = ref[i];
        if (!(groupMembership.user_id === userId)) {
          continue;
        }
        group = App.Group.exists(groupMembership.group_id);
        if (!group) {
          continue;
        }
        results.push({
          group: group,
          groupMembership: groupMembership
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.groupsNotLinkedToUser = function(userId) {
      var group, groupIdsForUser, groupMembership, i, len, ref, results, siteId, siteIdsForUser, userRole;
      groupIdsForUser = (function() {
        var i, len, ref, results;
        ref = App.GroupMembership.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          groupMembership = ref[i];
          if (groupMembership.user_id === userId) {
            results.push(groupMembership.group_id);
          }
        }
        return results;
      })();
      siteIdsForUser = (function() {
        var i, len, ref, results;
        ref = App.UserRole.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          userRole = ref[i];
          if (userRole.user_id === userId) {
            results.push(userRole.site_id);
          }
        }
        return results;
      })();
      ref = App.Group.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (!(!groupIdsForUser.includes(group.id))) {
          continue;
        }
        if (!group.isSiteFamilyGroup()) {
          siteId = this.siteIdForLocalGroup(group.id);
          if (!siteIdsForUser.includes(siteId)) {
            continue;
          }
        }
        results.push({
          group: group
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.sitesForUser = function(userId) {
      var i, len, ref, ref1, results, site, userRole;
      ref = App.UserRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (!(userRole.user_id === userId)) {
          continue;
        }
        site = (ref1 = this.siteLookup) != null ? ref1[userRole.site_id] : void 0;
        if (!site) {
          continue;
        }
        results.push({
          site: site,
          userRole: userRole
        });
      }
      return results;
    };

    RedesignDirectoryHelper.prototype.sitesNotLinkedToUser = function(userId) {
      var i, len, ref, results, site, siteIdsForUser, userRole;
      siteIdsForUser = (function() {
        var i, len, ref, results;
        ref = App.UserRole.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          userRole = ref[i];
          if (userRole.user_id === userId) {
            results.push(userRole.site_id);
          }
        }
        return results;
      })();
      ref = this.sites;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        site = ref[i];
        if (!siteIdsForUser.includes(site.id)) {
          results.push({
            site: site
          });
        }
      }
      return results;
    };

    return RedesignDirectoryHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  App.RemoveNonSiteModels = (function() {
    function RemoveNonSiteModels() {
      this.currentSiteId = App.Site.first().id;
      this.currentUserId = App.User.currentUser().id;
      this.currentSiteGroupIds = {};
      this.currentSiteUserIds = {};
    }

    RemoveNonSiteModels.prototype.call = function() {
      this.removeUserRoles();
      this.removeUsers();
      this.removeGroupRoles();
      this.removeGroups();
      return this.removeGroupMemberships();
    };

    RemoveNonSiteModels.prototype.removeUserRoles = function() {
      var i, len, ref, results, userRole;
      ref = App.UserRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (userRole.site_id === this.currentSiteId) {
          this.currentSiteUserIds[userRole.user_id] = true;
        }
        if (!(userRole.user_id === this.currentUserId && userRole.site_id === this.currentSiteId)) {
          results.push(userRole.remove());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RemoveNonSiteModels.prototype.removeUsers = function() {
      var i, len, ref, results, user;
      ref = App.User.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        user = ref[i];
        if (!this.currentSiteUserIds[user.id]) {
          results.push(user.remove());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RemoveNonSiteModels.prototype.removeGroupRoles = function() {
      var groupRole, i, len, ref, results;
      ref = App.GroupRole.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (groupRole.site_id === this.currentSiteId) {
          results.push(this.currentSiteGroupIds[groupRole.group_id] = true);
        } else {
          results.push(groupRole.remove());
        }
      }
      return results;
    };

    RemoveNonSiteModels.prototype.removeGroups = function() {
      var group, i, len, ref, results;
      ref = App.Group.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (!this.currentSiteGroupIds[group.id]) {
          results.push(group.remove());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RemoveNonSiteModels.prototype.removeGroupMemberships = function() {
      var groupMembership, i, len, ref, results;
      ref = App.GroupMembership.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        groupMembership = ref[i];
        if (!this.currentSiteGroupIds[groupMembership.group_id] || !this.currentSiteUserIds[groupMembership.user_id]) {
          results.push(groupMembership.remove());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return RemoveNonSiteModels;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.EditorController = (function(superClass) {
    extend(EditorController, superClass);

    function EditorController() {
      this.reallyRelease = bind(this.reallyRelease, this);
      this.release = bind(this.release, this);
      this.trigger = bind(this.trigger, this);
      this.recenter = bind(this.recenter, this);
      EditorController.__super__.constructor.apply(this, arguments);
      if (this.openImmediately) {
        this.el.addClass('open');
      } else {
        setTimeout(((function(_this) {
          return function() {
            return _this.el.addClass('open');
          };
        })(this)), 0);
      }
      App.Dashboard.bind('dash-width-updated grid-updated', this.recenter);
      App.Site.bind('close-all-editors', this.release);
    }

    EditorController.prototype.renderOnce = function() {
      this.recenter();
      $('.app-frame').prepend(this.el);
      return App.Site.trigger('opened-editor');
    };

    EditorController.prototype.setEl = function(className) {
      return this.el = $('<div class="editor-frame"></div>').addClass(className);
    };

    EditorController.prototype.recenter = function(evt, animate) {
      var leftMargin, rightMargin;
      this.leftSpaceNeeded = 0;
      if (this.tabsDrawer != null) {
        this.leftSpaceNeeded = this.tabsDrawer.leftSpaceNeeded();
      }
      leftMargin = (App.RedesignDashboardSizer.screenSize() - 960) / 2;
      if (this.leftSpaceNeeded > 0) {
        rightMargin = (App.RedesignDashboardSizer.screenSize() - this.editronBody.width()) / 2 - 12;
        if (animate) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.editorBody().animate({
                marginLeft: Math.max(leftMargin, _this.leftSpaceNeeded),
                paddingRight: rightMargin
              }, App.AppFrameRedesign.FAST_ANIMATION_TIME);
            };
          })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
        } else {
          this.editorBody().css({
            marginLeft: Math.max(leftMargin, this.leftSpaceNeeded),
            paddingRight: rightMargin
          });
          return this.editorWrapper().scrollLeft(this.leftSpaceNeeded);
        }
      } else {
        if (animate) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.editorBody().animate({
                marginLeft: leftMargin
              }, App.AppFrameRedesign.FAST_ANIMATION_TIME);
            };
          })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
        } else {
          return this.editorBody().css({
            marginLeft: leftMargin
          });
        }
      }
    };

    EditorController.prototype.editorBody = function() {
      throw 'NYI';
    };

    EditorController.prototype.editorWrapper = function() {
      throw 'NYI';
    };

    EditorController.prototype.trigger = function() {
      if (this.RELEASED) {
        return;
      }
      return EditorController.__super__.trigger.apply(this, arguments);
    };

    EditorController.prototype.release = function(args) {
      if (this.dontClose) {
        return;
      }
      App.Site.unbind('close-all-editors', this.release);
      App.Dashboard.unbind('dash-width-updated grid-updated', this.recenter);
      this.RELEASED = true;
      if (!(args != null ? args.delayedClose : void 0)) {
        this.el.removeClass('open');
      }
      return setTimeout(((function(_this) {
        return function() {
          _this.reallyRelease();
          EditorController.__super__.release.apply(_this, arguments);
          if (args != null ? args.delayedClose : void 0) {
            return _this.el.removeClass('open');
          }
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    EditorController.prototype.reallyRelease = function() {};

    EditorController.prototype.setDontClose = function() {
      return this.dontClose = true;
    };

    EditorController.prototype.unsetDontClose = function() {
      return delete this.dontClose;
    };

    EditorController.closeAllEditors = function(delayedClose) {
      return App.Site.trigger('close-all-editors', {
        delayedClose: delayedClose
      });
    };

    return EditorController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DatabaseStatusController = (function(superClass) {
    extend(DatabaseStatusController, superClass);

    DatabaseStatusController.prototype.elements = {
      '.last-ping': 'pingAgoEl',
      '.schema-refresh': 'schemaAgoEl',
      '.refresh-schema-now.refresh-button': 'refreshSchemaNowButton'
    };

    DatabaseStatusController.prototype.events = {
      'click .refresh-schema-now.refresh-button': 'refreshSchemaNowClick'
    };

    function DatabaseStatusController() {
      this.refreshFail = bind(this.refreshFail, this);
      this.refreshSuccess = bind(this.refreshSuccess, this);
      this.refreshSchemaNowClick = bind(this.refreshSchemaNowClick, this);
      this.updateForm = bind(this.updateForm, this);
      DatabaseStatusController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'currentDb');
      this.html(this.view('editors/configitron/database_status_form')({
        lastPingAgo: this.currentDb.pingLastSuccessfulAgo(),
        lastSchemaRefresh: this.currentDb.schemaLastRefreshedAgo()
      }));
      App.Database.bind('update', this.updateForm);
      this.statusUpdateInterval = setInterval(this.updateForm, 1 * 1000);
    }

    DatabaseStatusController.prototype.release = function() {
      clearInterval(this.statusUpdateInterval);
      App.Database.unbind('update', this.updateForm);
      return DatabaseStatusController.__super__.release.apply(this, arguments);
    };

    DatabaseStatusController.prototype.dbSelected = function(currentDb) {
      this.currentDb = currentDb;
      return this.updateForm();
    };

    DatabaseStatusController.schemaLastRefreshedAgo = function(db) {
      if (db.schema_is_updating) {
        return 'Updating...';
      }
      return db.schemaLastRefreshedAgo();
    };

    DatabaseStatusController.prototype.updateForm = function() {
      this.currentDb.reload();
      this.pingAgoEl.text(this.currentDb.pingLastSuccessfulAgo());
      this.schemaAgoEl.text(this.constructor.schemaLastRefreshedAgo(this.currentDb));
      if (this.currentDb.schema_is_updating) {
        return this.refreshSchemaNowButton.hide();
      } else {
        return this.refreshSchemaNowButton.show();
      }
    };

    DatabaseStatusController.prototype.refreshSchemaNowClick = function() {
      this.currentDb.markSchemaUpdateRequested();
      jQuery.ajax({
        method: 'post',
        url: "/databases/" + this.currentDb.id + "/refresh_schema",
        data: {
          client_site_id: App.Site.first().id
        }
      }).done(this.refreshSuccess).fail(this.refreshFail);
      return App.Utils.logFeature("refresh-schema");
    };

    DatabaseStatusController.prototype.refreshSuccess = function(response) {
      return App.Database.applyUpdates(response);
    };

    DatabaseStatusController.prototype.refreshFail = function() {
      this.currentDb.schema_is_updating = false;
      return this.currentDb.save({
        ajax: false
      });
    };

    return DatabaseStatusController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DrilldownsController = (function(superClass) {
    extend(DrilldownsController, superClass);

    DrilldownsController.prototype.elements = {
      '.drilldown-dashboard': 'drilldownDashboard',
      '.drilldown-mapping-list': 'drilldownMappingList',
      '.add-drilldown-mapping': 'addDrilldownMapping',
      '.link.delete-rules': 'deleteButton',
      '.drilldown-message': 'drilldownMessage'
    };

    DrilldownsController.prototype.events = {
      'click .add-drilldown-mapping': 'addMapping',
      'click .delete-rules': 'enterDeleteMode',
      'click .back-to-rules': 'exitDeleteMode',
      'click .reorder-controls .delete': 'deleteSingleMapping'
    };

    DrilldownsController.NONE_VALUE = '';

    DrilldownsController.NONE_NAME = 'None';

    function DrilldownsController() {
      this.drilldownCurrentValue = bind(this.drilldownCurrentValue, this);
      this.getDrilldownMappingFromDOM = bind(this.getDrilldownMappingFromDOM, this);
      this.drilldownSetValue = bind(this.drilldownSetValue, this);
      this.drilldownDashboardClicked = bind(this.drilldownDashboardClicked, this);
      this.exitDeleteMode = bind(this.exitDeleteMode, this);
      this.enterDeleteMode = bind(this.enterDeleteMode, this);
      this.redraw = bind(this.redraw, this);
      DrilldownsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.render();
    }

    DrilldownsController.prototype.enable = function(val) {
      this.enabled = val;
      if (this.enabled) {
        this.deleteButton.removeClass('disabled');
        return this.addDrilldownMapping.removeClass('disabled');
      } else {
        this.deleteButton.addClass('disabled');
        return this.addDrilldownMapping.addClass('disabled');
      }
    };

    DrilldownsController.prototype.isEnabled = function() {
      if (this.enabled == null) {
        this.enabled = true;
      }
      return this.enabled;
    };

    DrilldownsController.prototype.render = function() {
      this.itemsToRelease = [];
      this.html(this.view('editors/drilldowns_frame')());
      this.refreshElements();
      return this.initDrilldown();
    };

    DrilldownsController.prototype.redraw = function() {
      this.releaseChildren();
      return this.render();
    };

    DrilldownsController.prototype.addMapping = function() {
      if (!this.isEnabled()) {
        return;
      }
      return this.addOneDrilldownMapping();
    };

    DrilldownsController.prototype.deleteSingleMapping = function(ev) {
      var newValue;
      $(ev.target).closest('.drilldown-mapping').remove();
      if (this.drilldownMappingList.children().length === 0) {
        this.exitDeleteMode();
        this.addMapping();
      }
      newValue = this.getDrilldownMappingFromDOM();
      return this.trigger('update', newValue);
    };

    DrilldownsController.prototype.enterDeleteMode = function() {
      if (!this.isEnabled()) {
        return;
      }
      return this.el.addClass('reorder-mode');
    };

    DrilldownsController.prototype.exitDeleteMode = function() {
      return this.el.removeClass('reorder-mode');
    };

    DrilldownsController.prototype.releaseChildren = function() {
      var i, j, len, ref;
      delete this.firstDrilldownMapping;
      ref = this.itemsToRelease;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.release();
      }
      return this.itemsToRelease = [];
    };

    DrilldownsController.prototype.release = function() {
      this.releaseChildren();
      this.itemsToRelease = null;
      return DrilldownsController.__super__.release.apply(this, arguments);
    };

    DrilldownsController.prototype.newDropdown = function(property, questionEl, optionsFunc, defaultValue, optionsMode, currentValueFunc, optionClickedCallback) {
      var dd;
      if (currentValueFunc == null) {
        currentValueFunc = null;
      }
      if (optionClickedCallback == null) {
        optionClickedCallback = null;
      }
      dd = new App.RedesignSmoothDropdown({
        el: App.RedesignSmoothDropdown.appendFrame(questionEl),
        widget: this.widget,
        property: property,
        optionsFunc: optionsFunc,
        defaultValue: defaultValue,
        optionsMode: optionsMode,
        currentValueFunc: currentValueFunc,
        optionClickedCallback: optionClickedCallback
      });
      this.bubbles(dd, 'changed-twiddle');
      this.itemsToRelease.push(dd);
      return dd;
    };

    DrilldownsController.prototype.initDrilldown = function() {
      this.newDropdown('twiddle_drilldown_dashboard', this.drilldownDashboard, ((function(_this) {
        return function() {
          var dashboard, j, len, options, ref;
          options = [
            {
              name: App.DrilldownsController.NONE_NAME,
              serverValue: App.DrilldownsController.NONE_VALUE,
              exclusive: true
            }
          ];
          ref = App.Dashboard.allSortedByNameNotNull();
          for (j = 0, len = ref.length; j < len; j++) {
            dashboard = ref[j];
            options.push({
              name: dashboard.name,
              serverValue: dashboard.id
            });
          }
          return options;
        };
      })(this)), '', App.RedesignSmoothDropdown.SINGLE_SELECT, null, this.drilldownDashboardClicked);
      return this.appendExistingDrilldownMappings();
    };

    DrilldownsController.prototype.appendExistingDrilldownMappings = function() {
      var columnName, filterName, j, len, mapping, mappings;
      mappings = this.widget.getTwiddle('twiddle_drilldown_mapping');
      if (!((mappings != null ? mappings.length : void 0) > 0)) {
        return;
      }
      for (j = 0, len = mappings.length; j < len; j++) {
        mapping = mappings[j];
        columnName = mapping.column;
        filterName = mapping.filter;
        this.addOneDrilldownMapping(columnName, filterName);
      }
      this.firstDrilldownMapping = true;
      return this.addDrilldownMapping.show();
    };

    DrilldownsController.prototype.drilldownDashboardClicked = function(event, selectedOption) {
      if (this.widget.getTwiddle('twiddle_drilldown_dashboard') === App.DrilldownsController.NONE_VALUE) {
        this.clearMappings();
        return;
      }
      if (this.firstDrilldownMapping) {
        return;
      }
      this.firstDrilldownMapping = true;
      this.addDrilldownMapping.show();
      this.addOneDrilldownMapping();
      return App.Utils.logFeature("add-drilldown", {
        widget_id: this.widget.id,
        dashboard_id: this.widget.dashboard_id
      });
    };

    DrilldownsController.prototype.drilldownTargetDashboard = function() {
      return App.Dashboard.exists(this.widget.getTwiddle('twiddle_drilldown_dashboard')) || App.Dashboard.currentDashboard();
    };

    DrilldownsController.prototype.clearMappings = function() {
      this.drilldownMappingList.empty();
      this.firstDrilldownMapping = false;
      return this.trigger('update', null);
    };

    DrilldownsController.prototype.addOneDrilldownMapping = function(inputColumnName, inputFilterId) {
      var availableDimensions, columnDropdown, columnName, drilldownMapping, filterDropdown, filterName;
      if (inputColumnName == null) {
        inputColumnName = App.DrilldownsController.NONE_VALUE;
      }
      if (inputFilterId == null) {
        inputFilterId = App.DrilldownsController.NONE_VALUE;
      }
      this.el.addClass('delete-ok');
      drilldownMapping = $(this.view('editors/drilldown_mapping')());
      this.drilldownMappingList.append(drilldownMapping);
      this.refreshElements();
      columnName = drilldownMapping.find('.column-name');
      filterName = drilldownMapping.find('.filter-id');
      if (!this.widget.getColumns().includes(inputColumnName)) {
        inputColumnName = App.DrilldownsController.NONE_VALUE;
      }
      columnDropdown = this.newDropdown(null, columnName, ((function(_this) {
        return function() {
          var column, j, len, options, ref;
          options = [
            {
              name: 'Select Column',
              serverValue: App.DrilldownsController.NONE_VALUE,
              exclusive: true
            }
          ];
          ref = _this.widget.getColumns();
          for (j = 0, len = ref.length; j < len; j++) {
            column = ref[j];
            options.push({
              name: column.humanize(),
              serverValue: column
            });
          }
          return options;
        };
      })(this)), inputColumnName, App.RedesignSmoothDropdown.SINGLE_SELECT, this.drilldownCurrentValue, this.drilldownSetValue);
      availableDimensions = App.DimensionAvailability.availableForDashboardById(this.drilldownTargetDashboard()).concat(App.CustomDimension.BUILTIN_DIMENSIONS);
      if (availableDimensions.includes(App.CustomDimension.DATE_RANGE)) {
        availableDimensions.push(App.CustomDimension.CUSTOM_RANGE_START_DATE);
        availableDimensions.push(App.CustomDimension.CUSTOM_RANGE_END_DATE);
      }
      if (!availableDimensions.includes(inputFilterId)) {
        inputFilterId = App.DrilldownsController.NONE_VALUE;
      }
      filterDropdown = this.newDropdown(null, filterName, ((function(_this) {
        return function() {
          var dimension, j, len, options, ref;
          options = [
            {
              name: 'Select Filter',
              serverValue: App.DrilldownsController.NONE_VALUE,
              exclusive: true
            }
          ];
          availableDimensions = App.DimensionAvailability.availableForDashboardById(_this.drilldownTargetDashboard());
          ref = App.CustomDimension.allSortedByName();
          for (j = 0, len = ref.length; j < len; j++) {
            dimension = ref[j];
            if (availableDimensions.includes(dimension.id + "")) {
              options.push({
                name: dimension.name,
                serverValue: dimension.id + ""
              });
            }
          }
          if (availableDimensions.includes(App.CustomDimension.AGGREGATION)) {
            options.push({
              name: 'Aggregation',
              serverValue: App.CustomDimension.AGGREGATION
            });
          }
          if (availableDimensions.includes(App.CustomDimension.DATE_RANGE)) {
            options.push({
              name: 'Date Range',
              serverValue: App.CustomDimension.DATE_RANGE
            });
            options.push({
              name: 'Date Range Start',
              serverValue: App.CustomDimension.CUSTOM_RANGE_START_DATE
            });
            options.push({
              name: 'Date Range End',
              serverValue: App.CustomDimension.CUSTOM_RANGE_END_DATE
            });
          }
          return options;
        };
      })(this)), inputFilterId, App.RedesignSmoothDropdown.SINGLE_SELECT, this.drilldownCurrentValue, this.drilldownSetValue);
      filterDropdown.el.parent().attr('drilldown-value', inputFilterId);
      columnDropdown.el.parent().attr('drilldown-value', inputColumnName);
      return this.setDescriptionTextForMapping($(filterDropdown.el).closest('.drilldown-mapping'));
    };

    DrilldownsController.prototype.drilldownSetValue = function(event, selectedOption, dropdown) {
      var newValue;
      dropdown.el.parent().attr('drilldown-value', selectedOption.serverValue);
      this.setDescriptionTextForMapping($(dropdown.el).closest('.drilldown-mapping'));
      newValue = this.getDrilldownMappingFromDOM();
      return this.trigger('update', newValue);
    };

    DrilldownsController.prototype.setDescriptionTextForMapping = function(mapping) {
      var columnName, descriptionText, filterId, filterName;
      columnName = $(mapping).find('.column-name').attr('drilldown-value');
      filterId = $(mapping).find('.filter-id').attr('drilldown-value');
      filterName = App.CustomDimension.exists(filterId).name;
      descriptionText = this.buildDescriptionTest(columnName, filterName);
      return $(mapping).find(".description").text(descriptionText);
    };

    DrilldownsController.prototype.buildDescriptionTest = function(columnName, filterName) {
      var descriptionText;
      if (columnName && filterName) {
        return descriptionText = "Column " + columnName + " mapped to Filter " + filterName;
      } else if (columnName && !filterName) {
        return descriptionText = "Column " + columnName + " not mapped to any filter";
      } else if (filterName && !columnName) {
        return descriptionText = "No column mapped to Filter " + filterName;
      } else {
        return "";
      }
    };

    DrilldownsController.prototype.getDrilldownMappingFromDOM = function() {
      var columnName, filterName, j, len, mapping, mappings, ref;
      mappings = [];
      ref = this.drilldownMappingList.children();
      for (j = 0, len = ref.length; j < len; j++) {
        mapping = ref[j];
        columnName = $(mapping).find('.column-name').attr('drilldown-value');
        filterName = $(mapping).find('.filter-id').attr('drilldown-value');
        if (!(columnName || filterName)) {
          continue;
        }
        mappings.push({
          column: columnName,
          filter: filterName
        });
      }
      return mappings;
    };

    DrilldownsController.prototype.drilldownCurrentValue = function(dropdown) {
      return dropdown.el.parent().attr('drilldown-value');
    };

    DrilldownsController.applyDrilldownRequest = function(obj, dashboard_id, mappings, point, twiddles) {
      if (AppRedesign.isInEmbedMode()) {
        App.DrilldownsController.postMessageForDrilldownWithEmbedFilterFormat(dashboard_id, mappings, point, twiddles);
        return App.DrilldownsController.postMessageForDrilldown(dashboard_id, mappings, point);
      } else {
        return App.DrilldownsController.setDimensionsAndSwitchDashboard(obj, dashboard_id, mappings, point, twiddles);
      }
    };

    DrilldownsController.applyGeomapDrilldownRequest = function(dashboard_id, mappings, originalPoint, twiddles) {
      var dashboard, dimension_id, filter_value, id_values, j, len, mapping;
      if (AppRedesign.isInEmbedMode()) {
        App.DrilldownsController.postMessageForDrilldownWithEmbedFilterFormat(dashboard_id, mappings, originalPoint, twiddles);
        return App.DrilldownsController.postMessageForDrilldown(dashboard_id, mappings, originalPoint);
      } else {
        id_values = [];
        for (j = 0, len = mappings.length; j < len; j++) {
          mapping = mappings[j];
          dimension_id = mapping.filter;
          if (originalPoint[mapping.column] != null) {
            filter_value = originalPoint[mapping.column];
            id_values.push({
              id: dimension_id,
              value_id: filter_value
            });
          }
        }
        dashboard = App.Dashboard.exists(dashboard_id);
        if (dashboard === false) {
          return;
        }
        return dashboard.setCustomDimensionListAndMakeCurrent(id_values);
      }
    };

    DrilldownsController.setDimensionsAndSwitchDashboard = function(obj, dashboard_id, mappings, point, twiddles) {
      var dashboard, error, id_values;
      dashboard = App.Dashboard.exists(dashboard_id);
      error = App.DrilldownsController.checkForErrors(mappings, dashboard, point, twiddles);
      if (error != null) {
        obj.trigger('overlay-error', error);
        return false;
      }
      id_values = this.getIdValues(mappings, point, twiddles);
      dashboard.setCustomDimensionListAndMakeCurrent(id_values);
      App.Utils.logFeature('drilldown-clicked');
      return true;
    };

    DrilldownsController.getIdValues = function(mappings, point, twiddles) {
      var dimension_id, filter_value, id_values, j, len, mapping;
      id_values = [];
      for (j = 0, len = mappings.length; j < len; j++) {
        mapping = mappings[j];
        dimension_id = mapping.filter;
        filter_value = point[mapping.column];
        if (this.isValidDateRangeMapping(dimension_id, filter_value)) {
          id_values.push({
            id: App.CustomDimension.CUSTOM_RANGE_START_DATE,
            value_id: filter_value
          });
          id_values.push({
            id: App.CustomDimension.CUSTOM_RANGE_END_DATE,
            value_id: this.getEndForDateRangeMapping(filter_value, twiddles)
          });
        } else {
          id_values.push({
            id: dimension_id,
            value_id: filter_value
          });
        }
      }
      return id_values;
    };

    DrilldownsController.isValidDateRangeMapping = function(dimension_id, filter_value) {
      return dimension_id === App.CustomDimension.DATE_RANGE && !isNaN(Date.parse(filter_value));
    };

    DrilldownsController.getEndForDateRangeMapping = function(filter_value, twiddles) {
      var aggregation, aggregationDuration;
      aggregation = App.CanvasChart.AGGREGATION_SIZE[twiddles.get('aggregation')] || 1;
      aggregationDuration = aggregation * App.CanvasChart.DAY_MS;
      return App.TimeMachine.formatTimestamp(Date.parse(filter_value) + aggregationDuration);
    };

    DrilldownsController.checkForErrors = function(mappings, dashboard, point, twiddles) {
      var all_dates, all_ids, column, dashboardDimensions, dateInMilliseconds, dimension, dimension_id, filter_value, j, key, len, mapping, obj, ref, valueColumns;
      if (!((dashboard != null) && dashboard !== false && dashboard.isVisibleToCurrentUser())) {
        return "Dashboard does not exist";
      }
      if (!((mappings != null) && (point != null) && (twiddles != null))) {
        return "Invalid Drilldown";
      }
      dashboardDimensions = App.DimensionAvailability.availableForDashboardById(dashboard);
      all_ids = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = mappings.length; j < len; j++) {
          mapping = mappings[j];
          results.push(parseInt(mapping.filter));
        }
        return results;
      })();
      all_dates = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = mappings.length; j < len; j++) {
          mapping = mappings[j];
          if (App.CustomDimension.ALL_DATERANGE_DIMENSIONS.includes(mapping.filter)) {
            results.push(mapping.filter);
          }
        }
        return results;
      })();
      if (all_dates.includes(App.CustomDimension.DATE_RANGE) && (all_dates.includes(App.CustomDimension.CUSTOM_RANGE_START_DATE) || all_dates.includes(App.CustomDimension.CUSTOM_RANGE_END_DATE))) {
        return "Cannot have both Date Range and Date Range Start / End";
      }
      for (j = 0, len = mappings.length; j < len; j++) {
        mapping = mappings[j];
        dimension_id = mapping.filter;
        column = mapping.column;
        if (App.CustomDimension.ALL_BUILTIN_DIMENSIONS.includes(dimension_id)) {
          if (dimension_id === App.CustomDimension.AGGREGATION) {
            if (!dashboardDimensions.includes(App.CustomDimension.AGGREGATION)) {
              return "Filter 'Aggregation' does not exist";
            }
          } else {
            if (!dashboardDimensions.includes(App.CustomDimension.DATE_RANGE)) {
              return "Filter 'Date Range' does not exist";
            }
          }
          if (dimension_id === App.CustomDimension.AGGREGATION) {
            if ((point[column] == null) || !['hourly', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly'].includes(point[column].trim().toLowerCase())) {
              if (point[column] != null) {
                return "Invalid aggregation value '" + point[column] + "'";
              }
              return "Invalid aggregation value";
            }
          }
          if (App.CustomDimension.ALL_DATERANGE_DIMENSIONS.includes(dimension_id)) {
            dateInMilliseconds = Date.parse(point[column]);
            if (isNaN(dateInMilliseconds)) {
              if (point[column] != null) {
                return "Invalid Date Range value '" + point[column] + "'";
              }
              return "Invalid Date Range value";
            }
          }
        } else {
          if (isNaN(parseInt(dimension_id))) {
            return "Selected filter does not exist on target dashboard";
          }
          dimension = App.CustomDimension.exists(dimension_id);
          if (dimension === false) {
            return "Selected filter does not exist on target dashboard";
          }
          if (!dashboardDimensions.includes(dimension_id)) {
            return "Filter '" + dimension.name + "' does not exist";
          }
          if ((dimension.parent_id != null) && !all_ids.includes(dimension.parent_id)) {
            return "Parent filter missing for selected child filter";
          }
        }
        valueColumns = twiddles.get('value_cols');
        if (!(column in point || ((valueColumns != null) && valueColumns.includes(column)))) {
          for (key in point) {
            obj = point[key];
            if (obj.length > 0 && (((ref = obj[0]) != null ? ref[column] : void 0) != null)) {
              return "Cannot drilldown synthetic series";
            }
            break;
          }
          return "Selected column does not exist";
        }
        filter_value = this.extractDataPoint(point, column);
        if (!filter_value) {
          return "Invalid value";
        }
      }
      return null;
    };

    DrilldownsController.extractDataPoint = function(point, column) {
      var ref, v;
      if (column in point) {
        return v = point[column];
      } else if (((ref = point["originalRowList"]) != null ? ref[0][column] : void 0) != null) {
        v = point["originalRowList"][0][column];
      } else if (point.y != null) {
        return point.y;
      } else {
        return;
      }
      if (point.y == null) {
        return v;
      }
      if (!(jQuery.isNumeric(v) && jQuery.isNumeric(point.y))) {
        return v;
      }
      return point.y;
    };

    DrilldownsController.shouldAddDrilldown = function(el, twiddles) {
      return !App.DashboardSizer.inEditron(el) && (twiddles.get('drilldown_dashboard') != null) && twiddles.get('drilldown_dashboard') !== App.DrilldownsController.NONE_VALUE;
    };

    DrilldownsController.postMessageForDrilldownWithEmbedFilterFormat = function(dashboard_id, mappings, point, twiddles) {
      var message, ref;
      if (!((dashboard_id != null) && (mappings != null) && (point != null) && App.Utils.isInsideIframe())) {
        return;
      }
      message = {
        event_type: 'viewport_changed',
        event_detail: 'drilldown',
        has_dashboard_changed: dashboard_id !== ((ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0),
        dashboard_id: dashboard_id,
        filters: [],
        daterange: {},
        aggregation: null
      };
      _.each(mappings, (function(map) {
        var columnValue, ref1;
        columnValue = App.DrilldownsController.extractDataPoint(point, map.column);
        if (App.DrilldownsController.isValidDateRangeMapping(map.filter, columnValue)) {
          message.daterange.start = columnValue;
          return message.daterange.end = App.DrilldownsController.getEndForDateRangeMapping(columnValue, twiddles);
        } else {
          switch (map.filter) {
            case App.CustomDimension.AGGREGATION:
              return message.aggregation = columnValue;
            case App.CustomDimension.CUSTOM_RANGE_START_DATE:
              return message.daterange.start = columnValue;
            case App.CustomDimension.CUSTOM_RANGE_END_DATE:
              return message.daterange.end = columnValue;
            default:
              return message.filters.push({
                name: ((ref1 = App.CustomDimension.exists(map.filter)) != null ? ref1.name : void 0) || App.DrilldownsController.NONE_VALUE,
                value: columnValue
              });
          }
        }
      }));
      return window.parent.postMessage(message, '*');
    };

    DrilldownsController.postMessageForDrilldown = function(dashboard_id, mappings, point) {
      var filterValues, message;
      if (!((dashboard_id != null) && (mappings != null) && (point != null) && App.Utils.isInsideIframe())) {
        return false;
      }
      message = {
        event_type: 'drilldown',
        destination_dashboard_id: dashboard_id
      };
      filterValues = _.map(mappings, (function(m) {
        var dimensionName, dimensionOrId, ref;
        dimensionOrId = m.filter;
        if (App.CustomDimension.ALL_BUILTIN_DIMENSIONS.includes(dimensionOrId)) {
          dimensionName = dimensionOrId;
        } else {
          dimensionName = ((ref = App.CustomDimension.exists(dimensionOrId)) != null ? ref.name : void 0) || App.DrilldownsController.NONE_VALUE;
        }
        return {
          filter_name: dimensionName,
          column_value: App.DrilldownsController.extractDataPoint(point, m.column)
        };
      }));
      message.filter_values = filterValues;
      window.parent.postMessage(message, '*');
      return true;
    };

    return DrilldownsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.EditronController = (function(superClass) {
    extend(EditronController, superClass);

    EditronController.NEW_WIDGET_MODE = "new-widget";

    EditronController.EXISTING_WIDGET_MODE = "existing-widget";

    EditronController.NEW_SQL_VIEW_MODE = "new-sql-view";

    EditronController.EXISTING_SQL_VIEW_MODE = "existing-sql-view";

    EditronController.NEW_CSV_VIEW_MODE = "new-csv-view";

    EditronController.EXISTING_CSV_VIEW_MODE = "existing-csv-view";

    EditronController.SQL_VIEW_WAITING_TEXT = "Caching";

    EditronController.EDITRON_SQL = 'editron-sql';

    EditronController.currentMode = null;

    EditronController.CONSOLE_MODE = "console";

    EditronController.prototype.elements = {
      '.editron-wrapper': 'editronWrapper',
      '.editron-mk3': 'editronBody',
      '.editor-header': 'header',
      '.tab[name=definition]': 'definitionTab',
      '.tab[name=series]': 'seriesTab',
      '.tab[name=settings]': 'settingsTab',
      '.editor-settings': 'settingsPane',
      '.editor-series': 'seriesPane',
      '.editor-series .series-charts': 'seriesPaneSeries',
      '.editor-series .table-charts': 'seriesPaneTables',
      '.editor-sql': 'editorPane',
      '.data-viewer': 'dataViewerPane',
      '.tab-drawer': 'tabArea'
    };

    EditronController.prototype.events = {
      'click .tab[name=definition]': 'clickedDefinitionTab',
      'click .tab[name=series]': 'clickedSeriesTab',
      'click .tab[name=settings]': 'clickedSettingsTab'
    };

    EditronController.isNewMode = function(mode) {
      return _.includes([this.NEW_WIDGET_MODE, this.NEW_SQL_VIEW_MODE, this.NEW_CSV_VIEW_MODE], mode);
    };

    EditronController.isExistingMode = function(mode) {
      return !this.isNewMode(mode);
    };

    EditronController.isWidgetMode = function(mode) {
      return _.includes([this.NEW_WIDGET_MODE, this.EXISTING_WIDGET_MODE], mode);
    };

    EditronController.isAnyViewMode = function(mode) {
      return this.isSqlViewMode(mode) || this.isCsvViewMode(mode);
    };

    EditronController.isSqlViewMode = function(mode) {
      return mode === this.NEW_SQL_VIEW_MODE || mode === this.EXISTING_SQL_VIEW_MODE;
    };

    EditronController.isCsvViewMode = function(mode) {
      return mode === this.NEW_CSV_VIEW_MODE || this.isExistingCsvViewMode(mode);
    };

    EditronController.isExistingCsvViewMode = function(mode) {
      return mode === this.EXISTING_CSV_VIEW_MODE;
    };

    function EditronController() {}

    EditronController.editronIsOpen = function() {
      return $('.editor-frame.editron-frame.open').length > 0;
    };

    EditronController.setEditronOpen = function() {
      this.previousState = AppRedesign.current().getCurrentState();
      AppRedesign.current().currentState = AppRedesign.IN_EDITRON;
      return $('body').attr('editron_open', 1);
    };

    EditronController.unsetEditronOpen = function() {
      AppRedesign.current().currentState = this.previousState;
      return $('body').attr('editron_open', null);
    };

    EditronController.getCurrentMode = function() {
      return App.EditronController.currentMode;
    };

    return EditronController;

  })(App.EditorController);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDataBarsRuleController = (function(superClass) {
    extend(RedesignDataBarsRuleController, superClass);

    RedesignDataBarsRuleController.prototype.elements = {
      '.conditional-dropdown': 'conditionalDropdownEl',
      '.color-picker-area.negative': 'negativeColorPickerArea',
      '.color-picker-area.positive': 'positiveColorPickerArea',
      '.reorder-controls .description': 'reorderDescription'
    };

    RedesignDataBarsRuleController.prototype.events = {
      'click .reorder-controls .delete': 'deleteClicked',
      'click .positive .theme-color-picker-box': 'openPositiveColorPicker',
      'click .negative .theme-color-picker-box': 'openNegativeColorPicker'
    };

    RedesignDataBarsRuleController.DATA_BAR_POS_COLOR = "#3D8020";

    RedesignDataBarsRuleController.DATA_BAR_NEG_COLOR = "#FF0000";

    function RedesignDataBarsRuleController() {
      this.columnNames = bind(this.columnNames, this);
      this.deleteClicked = bind(this.deleteClicked, this);
      this.updateParent = bind(this.updateParent, this);
      this.negColorsUpdated = bind(this.negColorsUpdated, this);
      this.posColorsUpdated = bind(this.posColorsUpdated, this);
      this.conditionalUpdated = bind(this.conditionalUpdated, this);
      this.openNegativeColorPicker = bind(this.openNegativeColorPicker, this);
      this.openPicker = bind(this.openPicker, this);
      this.openPositiveColorPicker = bind(this.openPositiveColorPicker, this);
      var base, base1;
      RedesignDataBarsRuleController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget', 'rule', 'twiddles');
      if ((base = this.rule).pos_bar_color == null) {
        base.pos_bar_color = App.RedesignDataBarsRuleController.DATA_BAR_POS_COLOR;
      }
      if ((base1 = this.rule).neg_bar_color == null) {
        base1.neg_bar_color = App.RedesignDataBarsRuleController.DATA_BAR_NEG_COLOR;
      }
      this.render();
      this.setConditionalText();
      this.released = false;
    }

    RedesignDataBarsRuleController.prototype.release = function() {
      var ref, ref1;
      if (this.released) {
        return;
      }
      this.conditionalDropdown.release();
      if ((ref = this.positiveColorPicker) != null) {
        ref.release();
      }
      if ((ref1 = this.negativeColorPicker) != null) {
        ref1.release();
      }
      RedesignDataBarsRuleController.__super__.release.apply(this, arguments);
      return this.released = true;
    };

    RedesignDataBarsRuleController.prototype.render = function() {
      this.conditionalDropdown = new App.RedesignSmoothDropdown({
        el: App.RedesignSmoothDropdown.appendFrame(this.conditionalDropdownEl),
        widget: this.widget,
        optionsFunc: this.columnNames,
        optionsMode: App.RedesignSmoothDropdown.SINGLE_SELECT
      });
      return this.conditionalDropdown.bind('update', this.conditionalUpdated);
    };

    RedesignDataBarsRuleController.prototype.openPositiveColorPicker = function(e) {
      var pickerAttributes, ref, ref1, target;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      if ((ref = this.positiveColorPicker) != null) {
        ref.release();
      }
      if ((ref1 = this.negativeColorPicker) != null) {
        ref1.release();
      }
      target = $(e.currentTarget);
      pickerAttributes = {
        colors: {
          background: this.rule.pos_bar_color,
          text: this.rule.pos_text_color
        },
        backgroundTarget: target.find('.background-color'),
        textTarget: target.find('.text-color')
      };
      this.positiveColorPicker = this.openPicker(pickerAttributes);
      this.positiveColorPicker.bind('update', this.posColorsUpdated);
      $(e.currentTarget).append(this.positiveColorPicker.$el);
      return $('.js-toggle-positive-negative').removeClass('negative').addClass('positive');
    };

    RedesignDataBarsRuleController.prototype.openPicker = function(pickerAttributes) {
      return new App.DataBarsColorPickerController({
        colorGroup: pickerAttributes.colors,
        colorTheme: this.widget.colorTheme(),
        backgroundTarget: pickerAttributes.backgroundTarget,
        textTarget: pickerAttributes.textTarget
      });
    };

    RedesignDataBarsRuleController.prototype.openNegativeColorPicker = function(e) {
      var pickerAttributes, ref, ref1, target;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      if ((ref = this.positiveColorPicker) != null) {
        ref.release();
      }
      if ((ref1 = this.negativeColorPicker) != null) {
        ref1.release();
      }
      target = $(e.currentTarget);
      pickerAttributes = {
        colors: {
          background: this.rule.neg_bar_color,
          text: this.rule.neg_text_color
        },
        backgroundTarget: target.find('.background-color'),
        textTarget: target.find('.text-color')
      };
      this.negativeColorPicker = this.openPicker(pickerAttributes);
      this.negativeColorPicker.bind('update', this.negColorsUpdated);
      $(e.currentTarget).append(this.negativeColorPicker.$el);
      return $('.js-toggle-positive-negative').removeClass('positive').addClass('negative');
    };

    RedesignDataBarsRuleController.prototype.conditionalUpdated = function(option) {
      if ((option != null ? option.name : void 0) == null) {
        return;
      }
      this.rule.column = option.name;
      this.updateParent();
      return this.setConditionalText();
    };

    RedesignDataBarsRuleController.prototype.setConditionalText = function() {
      if (this.rule.column != null) {
        this.conditionalDropdown.setText("" + this.rule.column);
        return this.reorderDescription.text("" + this.rule.column);
      } else {
        return this.conditionalDropdown.setText("Select a Column", true);
      }
    };

    RedesignDataBarsRuleController.prototype.posColorsUpdated = function(colors) {
      this.rule.pos_text_color = colors.text;
      this.rule.pos_bar_color = colors.background;
      return this.updateParent();
    };

    RedesignDataBarsRuleController.prototype.negColorsUpdated = function(colors) {
      this.rule.neg_text_color = colors.text;
      this.rule.neg_bar_color = colors.background;
      return this.updateParent();
    };

    RedesignDataBarsRuleController.prototype.updateParent = function() {
      return this.trigger('update', this.rule);
    };

    RedesignDataBarsRuleController.prototype.deleteClicked = function() {
      this.trigger('delete', this.rule);
      return this.release();
    };

    RedesignDataBarsRuleController.prototype.columnNames = function() {
      var c, dataBarRules, dataBarTwiddleColumnNames, i, j, len, len1, options, rule, twiddleColumns;
      dataBarTwiddleColumnNames = [];
      options = [];
      dataBarRules = this.twiddles.get(App.TwiddleConfig.DATA_BARS);
      if (dataBarRules != null) {
        for (i = 0, len = dataBarRules.length; i < len; i++) {
          rule = dataBarRules[i];
          dataBarTwiddleColumnNames.push(rule.column);
        }
      }
      twiddleColumns = this.twiddles.get('column_names');
      if (twiddleColumns != null) {
        for (j = 0, len1 = twiddleColumns.length; j < len1; j++) {
          c = twiddleColumns[j];
          if (!dataBarTwiddleColumnNames.includes(c)) {
            options.push({
              name: c
            });
          }
        }
      }
      return options;
    };

    RedesignDataBarsRuleController.makeFrame = function(rule) {
      return $(JST['app/views/editors/data_bar_row']({
        rule: rule
      }));
    };

    RedesignDataBarsRuleController.appendFrame = function(parentEl, rule) {
      var frame;
      frame = this.makeFrame(rule);
      parentEl.append(frame);
      return frame;
    };

    return RedesignDataBarsRuleController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDataBarsRulesController = (function(superClass) {
    extend(RedesignDataBarsRulesController, superClass);

    RedesignDataBarsRulesController.prototype.className = 'data-bars-rules';

    RedesignDataBarsRulesController.prototype.elements = {
      '.rules-area': 'rulesAreaEl',
      '.move-delete-rules': 'moveDeleteButton',
      '.add-rule': 'addRuleButton'
    };

    RedesignDataBarsRulesController.prototype.events = {
      'click .add-rule': 'addRuleClick',
      'click .move-delete-rules': 'toggleMoveMode',
      'click .back-to-rules': 'toggleMoveMode'
    };

    function RedesignDataBarsRulesController() {
      this.ruleOrderUpdated = bind(this.ruleOrderUpdated, this);
      this.ruleDeleted = bind(this.ruleDeleted, this);
      this.ruleUpdated = bind(this.ruleUpdated, this);
      this.toggleMoveMode = bind(this.toggleMoveMode, this);
      this.addRuleClick = bind(this.addRuleClick, this);
      RedesignDataBarsRulesController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.twiddles || (this.twiddles = App.TwiddleMap.readOnly({}));
      this.ruleControllers = [];
      if (this.rules == null) {
        this.rules = [];
      }
      this.render();
    }

    RedesignDataBarsRulesController.prototype.release = function() {
      var i, j, len, ref;
      ref = this.ruleControllers;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.release();
      }
      this.ruleControllers = null;
      this.rules = [];
      return RedesignDataBarsRulesController.__super__.release.apply(this, arguments);
    };

    RedesignDataBarsRulesController.prototype.newChartData = function(twiddles) {
      var i, j, len, ref;
      this.twiddles = twiddles || App.TwiddleMap.readOnly({});
      ref = this.ruleControllers;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.release();
      }
      this.ruleControllers = [];
      return this.render();
    };

    RedesignDataBarsRulesController.prototype.render = function() {
      var j, len, r, ref, results;
      this.html(this.view('redesign/editors/data_bars_rules_frame')());
      ref = this.rules;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        r = ref[j];
        results.push(this.renderRule(r));
      }
      return results;
    };

    RedesignDataBarsRulesController.prototype.renderRule = function(rule) {
      var ruleController;
      ruleController = new App.RedesignDataBarsRuleController({
        el: App.RedesignDataBarsRuleController.appendFrame(this.rulesAreaEl, rule),
        widget: this.widget,
        rule: rule,
        twiddles: this.twiddles
      });
      ruleController.bind('update', this.ruleUpdated);
      ruleController.bind('delete', this.ruleDeleted);
      this.ruleControllers.push(ruleController);
      return this.updateButtons();
    };

    RedesignDataBarsRulesController.prototype.addRuleClick = function() {
      var r;
      if (this.addRuleButton.hasClass('disabled')) {
        return;
      }
      r = {
        id: App.Utils.makeGuid()
      };
      this.rules.push(r);
      this.renderRule(r);
      this.updateButtons();
      return App.Utils.logFeature("add-data-bar-rule", {
        widget_id: this.widget.id,
        dashboard_id: this.widget.dashboard_id
      });
    };

    RedesignDataBarsRulesController.prototype.updateButtons = function() {
      this.updateDeleteButton();
      return this.updateAddButton();
    };

    RedesignDataBarsRulesController.prototype.updateDeleteButton = function() {
      if (this.rules.length > 0) {
        return this.el.addClass('move-ok');
      } else {
        return this.el.removeClass('move-ok');
      }
    };

    RedesignDataBarsRulesController.prototype.updateAddButton = function() {
      if (this.dataBarTwiddleCount() >= this.columnCount()) {
        return this.addRuleButton.addClass('disabled');
      } else {
        return this.addRuleButton.removeClass('disabled');
      }
    };

    RedesignDataBarsRulesController.prototype.toggleMoveMode = function() {
      return this.el.toggleClass('reorder-mode');
    };

    RedesignDataBarsRulesController.prototype.updateParent = function() {
      return this.trigger('update', this.rules);
    };

    RedesignDataBarsRulesController.prototype.ruleUpdated = function(rule) {
      return this.updateParent();
    };

    RedesignDataBarsRulesController.prototype.ruleDeleted = function(rule) {
      var r;
      this.rules = (function() {
        var j, len, ref, results;
        ref = this.rules;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          r = ref[j];
          if (r.id !== rule.id) {
            results.push(r);
          }
        }
        return results;
      }).call(this);
      if (this.rules.length === 0) {
        this.el.removeClass('reorder-mode');
      }
      this.updateParent();
      return this.updateButtons();
    };

    RedesignDataBarsRulesController.prototype.ruleOrderUpdated = function() {
      var j, k, len, len1, orderedRules, r, rId, ref, ruleIdsInDomOrder;
      ruleIdsInDomOrder = (function() {
        var j, len, ref, results;
        ref = this.rulesAreaEl.find('.rule');
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          r = ref[j];
          results.push($(r).attr('rule_id'));
        }
        return results;
      }).call(this);
      orderedRules = [];
      for (j = 0, len = ruleIdsInDomOrder.length; j < len; j++) {
        rId = ruleIdsInDomOrder[j];
        ref = this.rules;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          r = ref[k];
          if (r.id === rId) {
            orderedRules.push(r);
          }
        }
      }
      this.rules = orderedRules;
      return this.updateParent();
    };

    RedesignDataBarsRulesController.prototype.updateDropdowns = function() {
      var j, len, ref, ruleController;
      ref = this.ruleControllers;
      for (j = 0, len = ref.length; j < len; j++) {
        ruleController = ref[j];
        ruleController.conditionalDropdown.getOptions();
      }
      return this.updateButtons();
    };

    RedesignDataBarsRulesController.prototype.dataBarTwiddleCount = function() {
      var ref;
      return (ref = this.widget.getTwiddle(App.TwiddleConfig.DATA_BARS)) != null ? ref.length : void 0;
    };

    RedesignDataBarsRulesController.prototype.columnCount = function() {
      var ref;
      return (ref = this.twiddles.get('column_names')) != null ? ref.length : void 0;
    };

    return RedesignDataBarsRulesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SalesforceObjectHarvestSettingsController = (function(superClass) {
    extend(SalesforceObjectHarvestSettingsController, superClass);

    SalesforceObjectHarvestSettingsController.prototype.elements = {
      '.strategy-select': 'strategySelect',
      '.full-harvest-interval-select': 'fullHarvestIntervalSelect',
      '.full-harvest-hour-select': 'fullHarvestHourSelect',
      '.full-harvest-min-select': 'fullHarvestMinuteSelect',
      '.radio-button.interval': 'intervalRadioButton',
      '.radio-button.schedule': 'scheduleRadioButton',
      '.refresh-schedule': 'refreshScheduleTr',
      '.refresh-interval': 'refreshIntervalTr',
      '.last-full-update-time': 'lastFullUpdateTimeEl',
      '.last-full-runtime': 'lastFullRunTimeEl',
      '.full-row': 'fullRowTr',
      '.save.button': 'saveButtonEl',
      '.error-row': 'errorRowEl',
      '.disable-harvest  .checkbox': 'disableHarvestCheckbox',
      '.full-refresh-now .button': 'refreshButtonEl',
      '.delete-harvest .button': 'deleteButtonEl'
    };

    SalesforceObjectHarvestSettingsController.prototype.events = {
      'change .strategy-select': 'changedStrategy',
      'click .radio-button.interval': 'selectedInterval',
      'click .radio-button.schedule': 'selectedSchedule',
      'click .save.button': 'save',
      'click .cancel.link': 'cancel',
      'click .delete-harvest .button': 'deleteClick',
      'click .disable-harvest .checkbox': 'disableHarvestClick',
      'click .full-refresh-now .button': 'fullRefreshNowClick'
    };

    function SalesforceObjectHarvestSettingsController() {
      this.closeOpenDialogs = bind(this.closeOpenDialogs, this);
      this.fullRefreshNowClick = bind(this.fullRefreshNowClick, this);
      this.disableHarvestClick = bind(this.disableHarvestClick, this);
      this.applyResponseHarvest = bind(this.applyResponseHarvest, this);
      this.saveComplete = bind(this.saveComplete, this);
      this.saveSuccess = bind(this.saveSuccess, this);
      this.saveFail = bind(this.saveFail, this);
      this.save = bind(this.save, this);
      this.selectedSchedule = bind(this.selectedSchedule, this);
      this.selectedInterval = bind(this.selectedInterval, this);
      this.changedStrategy = bind(this.changedStrategy, this);
      var ref;
      SalesforceObjectHarvestSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'database', 'tableName');
      this.html(this.view('editors/configitron/salesforce_object_harvest_config')({
        rowCount: this.prettyRowCount()
      }));
      this.salesforceObjectHarvest = App.SalesforceObjectHarvest.findByDatabaseAndName(this.database.id, this.tableName);
      this.scheduleOptionSelected = ((ref = this.salesforceObjectHarvest) != null ? ref.full_harvest_custom_schedule : void 0) != null;
      this.populateForm();
      this.initChosens();
      this.updateForm();
    }

    SalesforceObjectHarvestSettingsController.prototype.rowCount = function() {
      return this.database.rowCountForTable(this.tableName);
    };

    SalesforceObjectHarvestSettingsController.prototype.prettyRowCount = function() {
      var count;
      count = this.rowCount();
      if (count != null) {
        return (count.commaDelimit()) + " rows";
      }
      return "Unknown";
    };

    SalesforceObjectHarvestSettingsController.prototype.populateForm = function() {
      var schedule;
      if (this.salesforceObjectHarvest != null) {
        this.strategySelect.val('full');
        if (this.salesforceObjectHarvest.full_harvest_interval_seconds != null) {
          this.fullHarvestIntervalSelect.val(this.salesforceObjectHarvest.full_harvest_interval_seconds);
        }
        schedule = this.parseCustomSchedule(this.salesforceObjectHarvest.full_harvest_custom_schedule);
        this.updateTimestamps();
        if (schedule != null) {
          this.fullHarvestHourSelect.val(schedule.hour);
          this.fullHarvestMinuteSelect.val(schedule.minute);
        }
      } else {
        this.strategySelect.val('none');
      }
      return this.updateDisabledState();
    };

    SalesforceObjectHarvestSettingsController.prototype.initChosens = function() {
      this.strategySelect.chosen({
        disable_search: true
      });
      this.fullHarvestIntervalSelect.chosen({
        disable_search: true
      });
      this.fullHarvestHourSelect.chosen({
        disable_search: false
      });
      return this.fullHarvestMinuteSelect.chosen({
        disable_search: false
      });
    };

    SalesforceObjectHarvestSettingsController.prototype.updateForm = function() {
      if (this.strategySelect.val() === 'none') {
        this.fullRowTr.hide();
      } else if (this.strategySelect.val() === 'full') {
        this.fullRowTr.show();
      }
      if (this.scheduleOptionSelected) {
        this.intervalRadioButton.removeClass('checked');
        this.refreshIntervalTr.addClass('disabled');
        this.scheduleRadioButton.addClass('checked');
        this.refreshScheduleTr.removeClass('disabled');
      } else {
        this.intervalRadioButton.addClass('checked');
        this.refreshIntervalTr.removeClass('disabled');
        this.scheduleRadioButton.removeClass('checked');
        this.refreshScheduleTr.addClass('disabled');
      }
      if (this.yoinkIsRunning()) {
        return this.disableForms();
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.yoinkIsRunning = function() {
      var ref;
      return ((ref = this.salesforceObjectHarvest) != null ? ref.status() : void 0) === 'running';
    };

    SalesforceObjectHarvestSettingsController.prototype.disableForms = function() {
      this.refreshButtonEl.addClass('disabled');
      return this.deleteButtonEl.addClass('disabled');
    };

    SalesforceObjectHarvestSettingsController.prototype.changedStrategy = function() {
      return this.updateForm();
    };

    SalesforceObjectHarvestSettingsController.prototype.selectedInterval = function() {
      this.scheduleOptionSelected = false;
      return this.updateForm();
    };

    SalesforceObjectHarvestSettingsController.prototype.selectedSchedule = function() {
      this.scheduleOptionSelected = true;
      return this.updateForm();
    };

    SalesforceObjectHarvestSettingsController.prototype.save = function() {
      var savePromise;
      if (this.saveRunning) {
        return;
      }
      this.clearError();
      this.saveRunning = true;
      this.saveButtonEl.text("Saving");
      if (this.strategySelect.val() === 'none') {
        if (this.salesforceObjectHarvest == null) {
          this.cancel();
        }
        if (this.salesforceObjectHarvest != null) {
          this.destroy();
        }
        return;
      }
      return savePromise = jQuery.ajax(this.persistenceData()).done(this.saveSuccess).fail(this.saveFail).always(this.saveComplete);
    };

    SalesforceObjectHarvestSettingsController.prototype.persistenceData = function() {
      var formData;
      formData = {
        'salesforce_object_harvest[full_harvest_interval_seconds]': this.fullHarvestIntervalSelect.val(),
        'salesforce_object_harvest[salesforce_database_id]': this.database.specific_database_id,
        'salesforce_object_harvest[full_harvest_custom_schedule(4i)]': this.harvestHour(),
        'salesforce_object_harvest[full_harvest_custom_schedule(5i)]': this.harvestMinute(),
        'salesforce_object_harvest[table_name]': this.tableName
      };
      if (this.salesforceObjectHarvest != null) {
        return {
          data: formData,
          method: 'patch',
          url: "/salesforce_object_harvests/" + this.salesforceObjectHarvest.id
        };
      } else {
        return {
          data: formData,
          method: 'post',
          url: '/salesforce_object_harvests'
        };
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.harvestHour = function() {
      if (this.scheduleOptionSelected) {
        return this.fullHarvestHourSelect.val();
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.harvestMinute = function() {
      if (this.scheduleOptionSelected) {
        return this.fullHarvestMinuteSelect.val();
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.saveFail = function(response) {
      var errorString;
      errorString = _.join(_.map(response.responseJSON.errors, function(fieldErrors, fieldName) {
        return fieldName + " " + (_.join(fieldErrors, ','));
      }), ', ');
      return this.setError("Unable to save settings, please try again. " + errorString);
    };

    SalesforceObjectHarvestSettingsController.prototype.saveSuccess = function(response) {
      var updatedSalesforceObjectHarvest;
      updatedSalesforceObjectHarvest = this.applyResponseHarvest(response);
      return this.trigger('saved', this.tableName, updatedSalesforceObjectHarvest);
    };

    SalesforceObjectHarvestSettingsController.prototype.saveComplete = function() {
      this.saveButtonEl.text("Save");
      return this.saveRunning = false;
    };

    SalesforceObjectHarvestSettingsController.prototype.applyResponseHarvest = function(response) {
      App.SalesforceObjectHarvest.applyUpdates([response]);
      return App.SalesforceObjectHarvest.find(response.id);
    };

    SalesforceObjectHarvestSettingsController.prototype.updateDisabledState = function() {
      var ref;
      if (this.salesforceObjectHarvest != null) {
        this.disableHarvestCheckbox.removeClass('disabled');
        this.refreshButtonEl.removeClass('nobg disabled');
        this.deleteButtonEl.removeClass('nobg disabled');
      } else {
        this.disableHarvestCheckbox.addClass('disabled');
        this.refreshButtonEl.addClass('nobg disabled');
        this.deleteButtonEl.addClass('nobg disabled');
      }
      if (((ref = this.salesforceObjectHarvest) != null ? ref.disabled_at : void 0) != null) {
        return this.disableHarvestCheckbox.addClass('checked');
      } else {
        return this.disableHarvestCheckbox.removeClass('checked');
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.disableHarvestClick = function() {
      var action;
      if (this.disableHarvestCheckbox.hasClass('disabled') || (this.salesforceObjectHarvest == null) || this.disableRunning) {
        return;
      }
      this.disableRunning = true;
      this.disableHarvestCheckbox.toggleClass('checked');
      if (this.disableHarvestCheckbox.hasClass('checked')) {
        action = 'disable';
        this.salesforceObjectHarvest.disabled_at = true;
      } else {
        action = 'enable';
        this.salesforceObjectHarvest.disabled_at = null;
      }
      this.salesforceObjectHarvest.save({
        ajax: false
      });
      return jQuery.ajax({
        method: 'put',
        url: "/salesforce_object_harvests/" + this.salesforceObjectHarvest.id + "/" + action
      }).done(this.applyResponseHarvest).always((function(_this) {
        return function() {
          return _this.disableRunning = false;
        };
      })(this));
    };

    SalesforceObjectHarvestSettingsController.prototype.fullRefreshNowClick = function() {
      if ((this.salesforceObjectHarvest == null) || this.fullRefreshRunning) {
        return;
      }
      if (this.refreshButtonEl.hasClass('disabled')) {
        return;
      }
      this.fullRefreshRunning = true;
      return jQuery.ajax({
        method: 'put',
        url: "/salesforce_object_harvests/" + this.salesforceObjectHarvest.id + "/full_refresh"
      }).done(this.applyResponseHarvest).always((function(_this) {
        return function() {
          return _this.fullRefreshRunning = false;
        };
      })(this));
    };

    SalesforceObjectHarvestSettingsController.prototype.setError = function(str) {
      var errorEl;
      errorEl = $("<div class='error-container'></div>").text(str);
      this.errorRowEl.html(errorEl);
      return this.errorRowEl.css("height", "initial");
    };

    SalesforceObjectHarvestSettingsController.prototype.clearError = function() {
      return this.errorRowEl.height(0);
    };

    SalesforceObjectHarvestSettingsController.prototype.cancel = function() {
      this.clearError();
      return this.trigger('cancel');
    };

    SalesforceObjectHarvestSettingsController.prototype.deleteClick = function() {
      if (this.salesforceObjectHarvest == null) {
        return;
      }
      if (this.deleteButtonEl.hasClass('disabled')) {
        return;
      }
      return this.destroy();
    };

    SalesforceObjectHarvestSettingsController.prototype.destroy = function() {
      return this.openDeleteDialog = App.Dialog.createDialog({
        warning: true,
        title: "Delete Cached Table",
        mainText: "Deleting the cache for '" + this.tableName + "' will remove it from the Sisense Cache. Delete this cache?",
        okButtonText: "Delete",
        okCallback: ((function(_this) {
          return function() {
            _this.salesforceObjectHarvest.destroy();
            return _this.trigger('destroy', _this.salesforceObjectHarvest);
          };
        })(this)),
        closeCallback: ((function(_this) {
          return function() {
            _this.saveButtonEl.text("Save");
            return _this.saveRunning = false;
          };
        })(this))
      });
    };

    SalesforceObjectHarvestSettingsController.prototype.updateTimestamps = function() {
      if (this.salesforceObjectHarvest != null) {
        if (this.salesforceObjectHarvest.last_successful_full_harvest_at != null) {
          this.lastFullUpdateTimeEl.text(App.TableHarvest.lastUpdateText(this.salesforceObjectHarvest.last_successful_full_harvest_at));
        }
        if (this.salesforceObjectHarvest.last_successful_full_harvest_at != null) {
          return this.lastFullRunTimeEl.text(App.TableHarvest.lastRuntimeText(this.salesforceObjectHarvest.last_full_harvest_msec));
        }
      }
    };

    SalesforceObjectHarvestSettingsController.prototype.prepareToRelease = function() {
      return this.closeOpenDialogs();
    };

    SalesforceObjectHarvestSettingsController.prototype.closeOpenDialogs = function() {
      var ref;
      if ((ref = this.openDeleteDialog) != null) {
        ref.close();
      }
      return delete this.openDeleteDialog;
    };

    SalesforceObjectHarvestSettingsController.prototype.parseCustomSchedule = function(str) {
      var schedule;
      if (str == null) {
        return null;
      }
      schedule = str.split(':');
      return {
        hour: parseInt(schedule[0]),
        minute: parseInt(schedule[1])
      };
    };

    return SalesforceObjectHarvestSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Geomap = (function(superClass) {
    extend(Geomap, superClass);

    Geomap.MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZW5naW5lZXJpbmctYXQtc2lzZW5zZSIsImEiOiJja290NWJmMDMwMGVvMndwaXU5Zm1kcjg5In0.zlIp5OyDkKFblJ25TlSevA';

    Geomap.TOOLTIP_PROXIMITY_PX = 35;

    Geomap.MARKER_COLOR = '#874ca3';

    Geomap.MARKER_OPTIONS = {
      color: Geomap.MARKER_COLOR,
      fill: false,
      opacity: 1
    };

    Geomap.CIRCLE_OPTIONS = {
      color: Geomap.MARKER_COLOR,
      fill: true,
      opacity: 1,
      radius: 5
    };

    Geomap.POINTS_OPTIONS = {
      color: Geomap.MARKER_COLOR,
      fillColor: Geomap.MARKER_COLOR,
      fillOpacity: 0.75,
      fill: true,
      opacity: 0.075,
      radius: 3
    };

    Geomap.DEFAULT_HEAT_GRADIENT = {
      0.2: 'blue',
      0.5: 'dodgerblue',
      0.7: 'cyan',
      1: 'lime'
    };

    Geomap.HEAT_OPTIONS = {
      minOpacity: 0.25,
      max: 0.75,
      radius: 15,
      blur: 15,
      gradient: Geomap.DEFAULT_MAP_GRADIENT
    };

    Geomap.CLUSTERS_OPTIONS = {
      singleMarkerMode: true,
      iconCreateFunction: null
    };

    Geomap.MIN_RADIUS = 5;

    Geomap.MAX_RADIUS = 25;

    Geomap.WEIGHT_TOL = 0.000001;

    Geomap.GEOJSON_LAYER_OPTIONS = {
      pointToLayer: function(feature, latlng) {
        return L.circleMarker(latlng, {
          radius: 5,
          fillColor: Geomap.MARKER_COLOR,
          color: Geomap.MARKER_COLOR,
          weight: 1,
          opacity: 1,
          fillOpacity: 1
        });
      }
    };

    Geomap.RENDER_EVENT_DELAY = 500;

    Geomap.DATA_MODE_LATLONG = 'latlong';

    Geomap.DATA_MODE_GEOJSON = 'geojson';

    Geomap.PLOT_MODE_HEATMAP = 'heatmap';

    Geomap.PLOT_MODE_POINTS = 'points';

    Geomap.PLOT_MODE_BUBBLES = 'bubbles';

    Geomap.PLOT_MODE_CLUSTERS = 'clusters';

    Geomap.RENDER_ORDER = [Geomap.PLOT_MODE_HEATMAP, Geomap.PLOT_MODE_CLUSTERS, Geomap.PLOT_MODE_BUBBLES, Geomap.PLOT_MODE_POINTS];

    Geomap.SAVE_POSITION_MESSAGE = 'Save Map Position';

    Geomap.CLEAR_POSITION_MESSAGE = 'Clear Map Position';

    Geomap.GEOJSON_COLUMN_INDEX = 0;

    Geomap.prototype.elements = {
      '.geomap-tooltip': 'tooltipEl'
    };

    Geomap.prototype.events = {
      'mouseleave': 'hideTooltip'
    };

    Geomap.checkDataForErrors = function(columns, series, dataMode, weightColumns) {
      var col, error, gj, j, l, len, len1, len2, n, ref, ref1, ref2, ref3, ref4, row, seriesName;
      if (weightColumns == null) {
        weightColumns = [];
      }
      if (dataMode === App.Geomap.DATA_MODE_GEOJSON) {
        if (columns.length === 0) {
          return 'One column required.';
        }
        error = true;
        ref = series.dataPoints;
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          try {
            gj = JSON.parse(row[columns[App.Geomap.GEOJSON_COLUMN_INDEX]]);
            if ((gj.type != null) && (gj.coordinates != null)) {
              error = false;
              break;
            }
          } catch (error1) {

          }
        }
        if (error) {
          return 'GeoJSON data not detected.';
        }
      } else {
        if (columns.length < 2 || (columns.length === 2 && columns.includes(App.ColumnProcessor.INDEX_COLUMN))) {
          return 'Two columns required: latitude and longitude';
        }
        seriesName = series.name;
        ref1 = series.dataPoints;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          row = ref1[l];
          for (n = 0, len2 = weightColumns.length; n < len2; n++) {
            col = weightColumns[n];
            if (isNaN(parseFloat((ref2 = row.row) != null ? (ref3 = ref2[seriesName]) != null ? (ref4 = ref3[0]) != null ? ref4[col] : void 0 : void 0 : void 0))) {
              return 'Non-numeric weight values are not supported.';
              break;
            }
          }
        }
      }
      return null;
    };

    Geomap.prototype.hideTooltip = function() {
      return this.tooltipHelper.hideTooltip();
    };

    function Geomap() {
      this.clusterPointTooltip = bind(this.clusterPointTooltip, this);
      this.mapMouseMove = bind(this.mapMouseMove, this);
      this.dblClicked = bind(this.dblClicked, this);
      this.renderAll = bind(this.renderAll, this);
      this.stopEventPropagation = bind(this.stopEventPropagation, this);
      this.savePosition = bind(this.savePosition, this);
      this.selectSeriesInLegend = bind(this.selectSeriesInLegend, this);
      this.toggleSeriesInLegend = bind(this.toggleSeriesInLegend, this);
      Geomap.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'chartData', 'position');
      this.twiddles = this.chartData.twiddlesActual;
      if (this.plotMode == null) {
        this.plotMode = Geomap.PLOT_MODE_POINTS;
      }
      this.layers = {};
      this.elId = App.Utils.makeGuid();
      this.html(this.view('geomap/geomap_frame')({
        elId: this.elId
      }));
      this.tooltipHelper = new App.GeomapTooltipHelper({
        tooltipEl: this.tooltipEl,
        tooltipColumns: this.tooltipColumns
      });
      this.tooltipHelper.hideTooltip();
      this.renderedOnce = false;
      this.hiddenSeries = {};
      this.allPoints = [];
      this.orderedSeries = [];
    }

    Geomap.prototype.enableMouseZoom = function() {
      this.map.touchZoom.enable();
      return this.map.scrollWheelZoom.enable();
    };

    Geomap.prototype.disableMouseZoom = function() {
      this.map.touchZoom.disable();
      return this.map.scrollWheelZoom.disable();
    };

    Geomap.prototype.plotAsHeatmap = function(series) {
      return this.seriesPlotMode(series) === Geomap.PLOT_MODE_HEATMAP && !this.plotAsGeoJSON();
    };

    Geomap.prototype.plotAsPoints = function(series) {
      return this.seriesPlotMode(series) === Geomap.PLOT_MODE_POINTS && !this.plotAsGeoJSON();
    };

    Geomap.prototype.plotAsBubbles = function(series) {
      return this.seriesPlotMode(series) === Geomap.PLOT_MODE_BUBBLES && !this.plotAsGeoJSON();
    };

    Geomap.prototype.plotAsClusters = function(series) {
      return this.seriesPlotMode(series) === Geomap.PLOT_MODE_CLUSTERS && !this.plotAsGeoJSON();
    };

    Geomap.prototype.seriesPlotMode = function(series) {
      var plotMode;
      if ((series != null ? series.name : void 0) != null) {
        plotMode = this.seriesTwiddle(series, 'geomap_plot_mode');
      }
      if (plotMode == null) {
        plotMode = this.plotMode;
      }
      return plotMode;
    };

    Geomap.prototype.plotAsGeoJSON = function() {
      return this.dataMode === Geomap.DATA_MODE_GEOJSON;
    };

    Geomap.prototype.render = function() {
      if (typeof L !== "undefined" && L !== null) {
        return this.renderWithLeaflet();
      } else {
        return this.waitForLeaflet();
      }
    };

    Geomap.prototype.waitForLeaflet = function() {
      return setTimeout(((function(_this) {
        return function() {
          return _this.render();
        };
      })(this)), 50);
    };

    Geomap.prototype.renderWithLeaflet = function() {
      var layer;
      if (this.el.width() === 0 || this.el.height() === 0) {
        return;
      }
      App.Lagotron.addContext("geomap render");
      if (this.map == null) {
        this.map = L.map(this.elId, {
          zoomControl: !App.SetUpScreenshotMode.screenshotModeInUrl(),
          doubleClickZoom: false
        }).on('mousemove', this.mapMouseMove).on('zoomend', this.renderAll).on('dragend', this.renderAll).on('dblclick', this.dblClicked);
      }
      if (!this.leafletButton) {
        this.createSavePositionButton();
      }
      if ((this.position.zoom != null) && (this.position.lat != null) && (this.position.lng != null)) {
        this.map.setView(L.latLng(this.position.lat % 90, this.position.lng % 180), this.position.zoom);
        this.isPositionedByTwiddles = true;
      }
      L.mapbox.accessToken = Geomap.MAPBOX_ACCESS_TOKEN;
      layer = L.tileLayer(("https://api.mapbox.com/styles/v1/mapbox/" + (this.satelliteTiles ? 'satellite-v9' : 'streets-v11') + "/tiles/{z}/{x}/{y}") + ("?access_token=" + L.mapbox.accessToken), {
        tileSize: 512,
        maxZoom: 18,
        zoomOffset: -1,
        id: 'mapbox/streets-v11',
        accessToken: L.mapbox.accessToken
      });
      layer.addTo(this.map);
      layer.on("load", this.delayedNotifyRender);
      this.initializeVisibility();
      this.orderAllSeries();
      this.setWeightBounds();
      this.removeMarkers();
      this.renderAllSeries(true);
      this.renderLegend(this.legendEnabled());
      if (!this.isPositionedByTwiddles) {
        this.fitBounds();
      }
      this.renderedOnce = true;
      if (App.Site.first().redesign) {
        this.disableMouseZoom();
      }
      return this.widget.triggerRendered();
    };

    Geomap.prototype.resize = function() {
      var ref;
      return (ref = this.map) != null ? ref.invalidateSize() : void 0;
    };

    Geomap.prototype.twiddle = function(name) {
      return this.twiddles.get(name);
    };

    Geomap.prototype.seriesTwiddle = function(series, name) {
      return this.twiddles.getForSeries(series.name, name);
    };

    Geomap.prototype.canvasChartLegendSizer = function() {
      return new App.CanvasChartLegendSizer({
        chartEl: this.el.find('.map'),
        legendEl: this.legendEl(),
        twiddles: this.twiddles,
        isWide: this.isWide(),
        width: this.el.width(),
        height: this.el.height(),
        leftOffset: 10,
        rightOffset: 10
      });
    };

    Geomap.prototype.renderLegend = function(legendEnabled, initialize) {
      var ref;
      if (initialize == null) {
        initialize = true;
      }
      this.el.toggleClass('with-legend', legendEnabled).toggleClass('wide', this.isWide());
      if (legendEnabled) {
        if (this.legend == null) {
          this.legend = new App.CanvasLegend({
            el: this.legendEl()
          });
          this.legend.bind('legend-click', this.toggleSeriesInLegend);
          this.legend.bind('legend-dblclick', this.selectSeriesInLegend);
        }
        this.legend.render(this.chartData, this.hiddenSeries);
        if (initialize) {
          this.canvasChartLegendSizer().layoutChartAndLegend();
        }
        return this.legend.show();
      } else {
        if ((ref = this.legend) != null) {
          ref.hide();
        }
        return this.canvasChartLegendSizer().setChartToFullWidth();
      }
    };

    Geomap.prototype.legendEnabled = function() {
      return !this.twiddle('do_not_show_legend');
    };

    Geomap.prototype.legendEl = function() {
      return this.el.find('.legend');
    };

    Geomap.prototype.renderWidthInColumns = function() {
      return Math.round(this.el.width() / this.columnWidthFunc());
    };

    Geomap.prototype.isWide = function() {
      return this.renderWidthInColumns() > 1;
    };

    Geomap.prototype.allButOneHidden = function() {
      var k, numHidden;
      numHidden = ((function() {
        var j, len, ref, results;
        ref = Object.keys(this.hiddenSeries);
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          k = ref[j];
          if (this.hiddenSeries[k]) {
            results.push(1);
          }
        }
        return results;
      }).call(this)).length;
      return Object.keys(this.chartData.dataSeries).length <= (numHidden + 1);
    };

    Geomap.prototype.toggleSeriesInLegend = function(seriesId) {
      var allButOneHidden, id, j, len, ref;
      if (isNaN(seriesId)) {
        return;
      }
      allButOneHidden = this.allButOneHidden();
      if (!allButOneHidden || this.hiddenSeries[seriesId]) {
        this.hiddenSeries[seriesId] = !this.hiddenSeries[seriesId];
      } else if (allButOneHidden && !this.hiddenSeries[seriesId]) {
        ref = Object.keys(this.hiddenSeries);
        for (j = 0, len = ref.length; j < len; j++) {
          id = ref[j];
          this.hiddenSeries[id] = false;
        }
      }
      return this.rerenderWithVisibility();
    };

    Geomap.prototype.selectSeriesInLegend = function(seriesId) {
      var j, key, len, ref;
      if (isNaN(seriesId)) {
        return;
      }
      ref = Object.keys(this.hiddenSeries);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        this.hiddenSeries[key] = true;
      }
      this.hiddenSeries[seriesId] = false;
      return this.rerenderWithVisibility();
    };

    Geomap.prototype.rerenderWithVisibility = function() {
      this.removeMarkers();
      this.renderAllSeries();
      return this.renderLegend(this.legendEnabled(), false);
    };

    Geomap.prototype.initializeVisibility = function() {
      var base, i, j, len, ref, results, series;
      ref = this.chartData.dataSeries;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        series = ref[i];
        results.push((base = this.hiddenSeries)[i] != null ? base[i] : base[i] = false);
      }
      return results;
    };

    Geomap.prototype.orderAllSeries = function() {
      var allSeries, j, len, ref, results, s_id, type;
      this.orderedSeries = [];
      allSeries = this.chartData.dataSeries;
      ref = Geomap.RENDER_ORDER;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        type = ref[j];
        results.push((function() {
          var l, len1, ref1, results1;
          ref1 = Object.keys(allSeries);
          results1 = [];
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            s_id = ref1[l];
            if (this.seriesPlotMode(allSeries[s_id]) === type) {
              results1.push(this.orderedSeries.push(s_id));
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    Geomap.prototype.setWeightBounds = function() {
      var j, len, maxWeight, minWeight, points, ref, ref1, ref2, results, series;
      this.minWeight = Number.MAX_VALUE;
      this.maxWeight = Number.MIN_VALUE;
      this.minClusterWeight = Number.MAX_VALUE;
      this.maxClusterWeight = Number.MIN_VALUE;
      ref = this.chartData.dataSeries;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        points = this.getPoints(series, true);
        ref1 = Geomap.weightRangeFrom(points), minWeight = ref1[0], maxWeight = ref1[1];
        if (((ref2 = points[0]) != null ? ref2.radius : void 0) != null) {
          this.minClusterWeight = Math.min(this.minClusterWeight, minWeight);
          results.push(this.maxClusterWeight = Math.max(this.maxClusterWeight, maxWeight));
        } else {
          this.minWeight = Math.min(this.minWeight, minWeight);
          results.push(this.maxWeight = Math.max(this.maxWeight, maxWeight));
        }
      }
      return results;
    };

    Geomap.prototype.renderAllSeries = function(ignoreBounds) {
      var allSeries, j, len, ref, results, series, series_id, shouldShowSeries;
      if (ignoreBounds == null) {
        ignoreBounds = false;
      }
      allSeries = this.chartData.dataSeries;
      ref = this.orderedSeries;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        series_id = ref[j];
        series = allSeries[series_id];
        shouldShowSeries = !this.hiddenSeries[series_id] && this.seriesTwiddle(series, 'show_on_primary_axis');
        if (shouldShowSeries) {
          results.push(this.renderSeries(series_id, series, ignoreBounds));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Geomap.prototype.renderSeries = function(series_id, series, ignoreBounds) {
      var j, len, p, seriesColor, seriesPoints, seriesType;
      if (!series) {
        return;
      }
      seriesColor = this.seriesTwiddle(series, 'color');
      if (this.plotAsBubbles(series)) {
        seriesPoints = this.getPoints(series, ignoreBounds, this.minClusterWeight, this.maxClusterWeight);
      } else {
        seriesPoints = this.getPoints(series, ignoreBounds, this.minWeight, this.maxWeight);
      }
      for (j = 0, len = seriesPoints.length; j < len; j++) {
        p = seriesPoints[j];
        this.allPoints.push(p);
      }
      if (this.plotAsGeoJSON()) {
        return this.renderGeoJSONSeries(series_id, seriesPoints, seriesColor);
      } else {
        seriesType = this.seriesPlotMode(series);
        switch (seriesType) {
          case Geomap.PLOT_MODE_POINTS:
            return this.renderPointSeries(series_id, seriesPoints, seriesColor);
          case Geomap.PLOT_MODE_BUBBLES:
            return this.renderBubbleSeries(series_id, seriesPoints, seriesColor);
          case Geomap.PLOT_MODE_HEATMAP:
            return this.renderHeatmapSeries(series_id, seriesPoints, seriesColor);
          case Geomap.PLOT_MODE_CLUSTERS:
            return this.renderClusterSeries(series_id, seriesPoints, seriesColor);
        }
      }
    };

    Geomap.prototype.getPoints = function(series, ignoreBounds, minWeight, maxWeight) {
      var bounds, geojsonColumn, points, ref, ref1, seriesName, weightColumns;
      if (!series) {
        return;
      }
      seriesName = series.name;
      if (this.plotAsGeoJSON()) {
        geojsonColumn = (ref = this.twiddles.getArray('value_columns')) != null ? (ref1 = ref[0]) != null ? ref1.column_name : void 0 : void 0;
        points = Geomap.extractGeoJsonFromRows(seriesName, this.columns, series.dataPoints, this.tooltipColumns, geojsonColumn);
      } else {
        bounds = ((this.map != null) && !ignoreBounds ? this.map.getBounds() : null);
        weightColumns = this.twiddle('geomap_weight_columns');
        points = Geomap.extractPointsFromRows(seriesName, this.columns, series.dataPoints, weightColumns, this.tooltipColumns, bounds, this.plotAsBubbles(series), minWeight, maxWeight);
      }
      return points;
    };

    Geomap.prototype.createSavePositionButton = function() {
      var savePositionEl;
      this.leafletButton = L.control({
        position: 'topleft'
      });
      this.savePositionLink = $(L.DomUtil.create('a'));
      savePositionEl = $(L.DomUtil.create('div', 'leaflet-bar'));
      savePositionEl.addClass('save-position');
      savePositionEl.on('click', this.savePosition);
      savePositionEl.on('mousemove mousedown mouseup dblclick', this.stopEventPropagation);
      savePositionEl.append(this.savePositionLink);
      this.leafletButton.onAdd = (function(_this) {
        return function(map) {
          return savePositionEl[0];
        };
      })(this);
      return this.leafletButton.addTo(this.map);
    };

    Geomap.prototype.atSavedPosition = function() {
      var currentPosition;
      if (this.position == null) {
        return false;
      }
      currentPosition = this.getPosition();
      if (this.position.zoom !== currentPosition.zoom) {
        return false;
      }
      if (Math.abs(currentPosition.lat - this.position.lat) > (1 / 1e6)) {
        return false;
      }
      if (Math.abs(currentPosition.lng - this.position.lng) > (1 / 1e6)) {
        return false;
      }
      return true;
    };

    Geomap.prototype.updateSavePositionButton = function() {
      if (this.atSavedPosition()) {
        return this.savePositionLink.text(Geomap.CLEAR_POSITION_MESSAGE);
      } else {
        return this.savePositionLink.text(Geomap.SAVE_POSITION_MESSAGE);
      }
    };

    Geomap.prototype.savePosition = function(e) {
      if (this.atSavedPosition()) {
        this.position = null;
        this.repaintMarkers(true);
        this.fitBounds();
      } else {
        this.position = this.getPosition();
      }
      this.trigger('save-map-position', this.position);
      this.updateSavePositionButton();
      return e != null ? e.stopPropagation() : void 0;
    };

    Geomap.prototype.stopEventPropagation = function(e) {
      return e.stopPropagation();
    };

    Geomap.prototype.getPosition = function() {
      var center;
      center = this.map.getCenter();
      return {
        zoom: this.map.getZoom(),
        lat: center.lat,
        lng: center.lng
      };
    };

    Geomap.prototype.getMapKey = function() {
      if (this.satelliteTiles) {
        return this.constructor.MAPBOX_KEY_SATELLITE;
      } else {
        return this.constructor.MAPBOX_KEY_NORMAL;
      }
    };

    Geomap.prototype.delayedNotifyRender = function() {
      return setTimeout((function() {
        return App.Widget.trigger('map-rendered');
      }), Geomap.RENDER_EVENT_DELAY);
    };

    Geomap.prototype.fitBounds = function() {
      var bounds;
      bounds = null;
      if (this.geoJsonMarker != null) {
        bounds = this.geoJsonMarker.getBounds();
      } else if (this.allPoints.length > 0) {
        bounds = Geomap.makeLatLngBounds(this.allPoints);
      }
      if (bounds != null) {
        return this.map.fitBounds(bounds);
      }
    };

    Geomap.prototype.renderPointSeries = function(id, points, color) {
      var base, base1, j, len, options, p, results;
      if (points.isEmpty()) {
        return;
      }
      options = $.extend(false, {}, Geomap.POINTS_OPTIONS);
      if (color != null) {
        options.color = color;
        options.fillColor = color;
      }
      (base = this.layers)[id] || (base[id] = {});
      (base1 = this.layers[id]).markers || (base1.markers = []);
      results = [];
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        results.push(this.layers[id].markers.push(L.circleMarker(p.latLng, options).addTo(this.map)));
      }
      return results;
    };

    Geomap.prototype.renderHeatmapSeries = function(id, points, color) {
      var j, latLngs, len, options, p, spectrum;
      if (points.isEmpty()) {
        return;
      }
      latLngs = [];
      Geomap.normalizePointWeights(points, this.minWeight, this.maxWeight);
      options = Geomap.HEAT_OPTIONS;
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        p.latLng.alt = p.weight * options.max;
        latLngs.push(p.latLng);
      }
      if (color != null) {
        spectrum = Geomap.getSpectrumFor(color);
        if (spectrum != null) {
          options.gradient = {
            0.2: spectrum[0],
            0.5: spectrum[1],
            0.7: spectrum[2],
            1: spectrum[3]
          };
        }
      } else {
        options.gradient = Geomap.DEFAULT_HEAT_GRADIENT;
      }
      return this.layers[id] = L.heatLayer(latLngs, options).addTo(this.map);
    };

    Geomap.prototype.renderGeoJSONSeries = function(id, points, color) {
      var j, jPoints, len, options, p;
      if (points.isEmpty()) {
        return;
      }
      if (color != null) {
        options = {
          pointToLayer: (function(_this) {
            return function(feature, latlng) {
              return L.circleMarker(latlng, {
                radius: 5,
                fillColor: color,
                color: color,
                weight: 1,
                opacity: 1,
                fillOpacity: 1
              });
            };
          })(this),
          fillColor: color,
          color: color
        };
      } else {
        options = Geomap.GEOJSON_LAYER_OPTIONS;
      }
      jPoints = [];
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        if (p.geojson != null) {
          jPoints.push(p.geojson);
        }
      }
      this.layers[id] = L.geoJson(jPoints, options).addTo(this.map);
      return this.layers[id].on('dblclick', this.dblClicked);
    };

    Geomap.prototype.renderBubbleSeries = function(id, points, color) {
      var base, base1, j, len, options, p, results;
      if (points.isEmpty()) {
        return;
      }
      options = Geomap.CIRCLE_OPTIONS;
      if (color != null) {
        options.color = color;
      }
      (base = this.layers)[id] || (base[id] = {});
      (base1 = this.layers[id]).markers || (base1.markers = []);
      results = [];
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        results.push(this.layers[id].markers.push(L.circleMarker(p.latLng, options).setRadius(p.radius).addTo(this.map)));
      }
      return results;
    };

    Geomap.prototype.renderClusterSeries = function(id, points, color) {
      var j, len, marker, options, p;
      if (points.isEmpty()) {
        return;
      }
      options = Geomap.CLUSTERS_OPTIONS;
      options.color = color;
      this.clusterMarkers = L.markerClusterGroup(options);
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        marker = L.marker(p.latLng);
        this.clusterMarkers.addLayer(marker);
      }
      this.clusterMarkers.on('mouseover', this.clusterPointTooltip);
      this.layers[id] = this.clusterMarkers;
      return this.map.addLayer(this.layers[id]);
    };

    Geomap.prototype.removeMarkers = function() {
      var ex, j, l_id, len, ref;
      try {
        if (this.layers) {
          ref = Object.keys(this.layers);
          for (j = 0, len = ref.length; j < len; j++) {
            l_id = ref[j];
            this.removeLayer(l_id);
          }
        }
        this.layers = {};
        return this.allPoints = [];
      } catch (error1) {
        ex = error1;
      }
    };

    Geomap.prototype.removeLayer = function(series_id) {
      var j, layer, len, m, ref, ref1;
      layer = (ref = this.layers) != null ? ref[series_id] : void 0;
      if ((layer != null ? layer.markers : void 0) != null) {
        ref1 = layer.markers;
        for (j = 0, len = ref1.length; j < len; j++) {
          m = ref1[j];
          this.map.removeLayer(m);
        }
      }
      return this.map.removeLayer(layer);
    };

    Geomap.prototype.release = function() {
      var ref;
      if ((ref = this.map) != null) {
        ref.remove();
      }
      this.map = null;
      this.markers = null;
      this.allPoints = null;
      return Geomap.__super__.release.apply(this, arguments);
    };

    Geomap.extractPointsFromRows = function(seriesName, columns, rows, weightColumns, detailColumns, boundsLimit, cluster, minWeight, maxWeight) {
      var parsedRows;
      if (weightColumns == null) {
        weightColumns = [];
      }
      if (detailColumns == null) {
        detailColumns = [];
      }
      if (boundsLimit == null) {
        boundsLimit = null;
      }
      if (cluster == null) {
        cluster = true;
      }
      parsedRows = this.parseRows(seriesName, columns, rows, weightColumns, detailColumns, boundsLimit);
      return this.extraPointsFromParsedRows(parsedRows, cluster, minWeight, maxWeight);
    };

    Geomap.extraPointsFromParsedRows = function(parsedRows, cluster, minWeight, maxWeight) {
      var j, len, p, results;
      if (cluster) {
        return this.clusterPoints(parsedRows, minWeight, maxWeight);
      } else {
        results = [];
        for (j = 0, len = parsedRows.length; j < len; j++) {
          p = parsedRows[j];
          results.push({
            latLng: L.latLng(p.x, p.y),
            weight: p.weight,
            tooltipDetails: p.tooltipDetails,
            originalPoint: p.originalPoint
          });
        }
        return results;
      }
    };

    Geomap.extractGeoJsonFromRows = function(seriesName, columns, rows, detailColumns, geojsonColumn) {
      var ex, gj, j, latLng, len, parsedPoints, row;
      parsedPoints = [];
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        try {
          gj = JSON.parse(row[columns[App.Geomap.GEOJSON_COLUMN_INDEX]]);
          latLng = this.extractLatLngFromGeoJson(gj);
          if (gj != null) {
            parsedPoints.push({
              geojson: gj,
              latLng: latLng,
              tooltipDetails: this.getTooltipDetailsFromRow(row['row'][seriesName], detailColumns, geojsonColumn, row.y),
              originalPoint: row['row'][seriesName][0]
            });
          }
        } catch (error1) {
          ex = error1;
        }
      }
      return parsedPoints;
    };

    Geomap.extractLatLngFromGeoJson = function(gj) {
      var bounds, c, coord, coords, j, l, len, len1, len2, n, poly, t, tmpCoords;
      switch (gj.type) {
        case 'Polygon':
          coords = gj.coordinates.first();
          break;
        case 'Point':
          coords = [gj.coordinates];
          break;
        case 'MultiPolygon':
          tmpCoords = (function() {
            var j, len, ref, results;
            ref = gj.coordinates;
            results = [];
            for (j = 0, len = ref.length; j < len; j++) {
              poly = ref[j];
              results.push(poly.first());
            }
            return results;
          })();
          coords = [];
          for (j = 0, len = tmpCoords.length; j < len; j++) {
            t = tmpCoords[j];
            for (l = 0, len1 = t.length; l < len1; l++) {
              c = t[l];
              coords.push(c);
            }
          }
          break;
        default:
          coords = gj.coordinates;
      }
      bounds = L.latLngBounds([]);
      for (n = 0, len2 = coords.length; n < len2; n++) {
        coord = coords[n];
        bounds.extend(L.latLng(coord[1], coord[0]));
      }
      return bounds.getCenter();
    };

    Geomap.parseRows = function(seriesName, columns, rows, weightCols, detailColumns, boundsLimit) {
      var col, details, j, l, lat, len, len1, lng, mapCols, originalPoint, parsedPoints, ref, ref1, ref2, row, weight, wt;
      if (weightCols == null) {
        weightCols = [];
      }
      if (detailColumns == null) {
        detailColumns = [];
      }
      if (boundsLimit == null) {
        boundsLimit = null;
      }
      mapCols = Geomap.inferColumns(columns, rows);
      parsedPoints = [];
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        wt = 1;
        for (l = 0, len1 = weightCols.length; l < len1; l++) {
          col = weightCols[l];
          wt *= (ref = row.row) != null ? (ref1 = ref[seriesName]) != null ? (ref2 = ref1[0]) != null ? ref2[col] : void 0 : void 0 : void 0;
        }
        weight = App.Utils.parseFloatOrZero(wt);
        lat = App.Utils.parseFloatOrZero(row[mapCols.latCol]);
        lng = App.Utils.parseFloatOrZero(row[mapCols.lngCol]);
        if ((boundsLimit == null) || boundsLimit.contains(L.latLng(lat, lng))) {
          if (row['row'][seriesName] != null) {
            details = Geomap.getTooltipDetailsFromRow(row['row'][seriesName], detailColumns, seriesName, "" + row[mapCols.lngCol]);
            if (row['row'][seriesName][0]) {
              originalPoint = row['row'][seriesName][0];
            }
          } else {
            details = null;
            originalPoint = null;
          }
          parsedPoints.push({
            x: lat,
            y: lng,
            weight: weight,
            tooltipDetails: details,
            originalPoint: originalPoint
          });
        }
      }
      return parsedPoints;
    };

    Geomap.clusterPoints = function(clusterPoints, min, max) {
      var closestPoint, cluster, clusters, j, l, latLng, latLngPoints, len, len1, maxWeight, minWeight, point, points, pointsWithin, ref, ttd;
      clusters = App.KMedoids.cluster(clusterPoints);
      if ((min != null) && (max != null)) {
        minWeight = min;
        maxWeight = max;
      } else {
        ref = this.weightRangeFrom(clusters), minWeight = ref[0], maxWeight = ref[1];
      }
      latLngPoints = [];
      for (j = 0, len = clusterPoints.length; j < len; j++) {
        point = clusterPoints[j];
        latLngPoints.push({
          latLng: L.latLng(point.x, point.y),
          originalPoint: point.originalPoint
        });
      }
      points = [];
      for (l = 0, len1 = clusters.length; l < len1; l++) {
        cluster = clusters[l];
        ttd = cluster.medoid.tooltipDetails;
        pointsWithin = cluster.points.length;
        if (pointsWithin > 1) {
          if (ttd == null) {
            ttd = {};
          }
          ttd["Points Within"] = pointsWithin;
        }
        latLng = L.latLng(cluster.medoid.x, cluster.medoid.y);
        closestPoint = Geomap.getClosestPointTo(latLngPoints, latLng);
        points.push({
          latLng: latLng,
          tooltipDetails: ttd,
          weight: cluster.weight,
          radius: this.weightToRadius(cluster.weight, minWeight, maxWeight),
          originalPoint: closestPoint.originalPoint
        });
      }
      return points;
    };

    Geomap.normalizePointWeights = function(points, minWeight, maxWeight) {
      var doNotWeigh, j, len, p, results, weightRange;
      if (Math.abs(maxWeight - minWeight) > Geomap.WEIGHT_TOL) {
        weightRange = maxWeight - minWeight;
      }
      doNotWeigh = minWeight === maxWeight;
      if (weightRange == null) {
        weightRange = 1;
      }
      if (!doNotWeigh) {
        results = [];
        for (j = 0, len = points.length; j < len; j++) {
          p = points[j];
          results.push(p.weight = (p.weight - minWeight) / weightRange);
        }
        return results;
      }
    };

    Geomap.weightRangeFrom = function(items) {
      var c, weights;
      weights = ((function() {
        var j, len, results;
        results = [];
        for (j = 0, len = items.length; j < len; j++) {
          c = items[j];
          results.push(c.weight);
        }
        return results;
      })()).sort(function(a, b) {
        return a - b;
      });
      return [weights.first(), weights.last()];
    };

    Geomap.weightToRadius = function(weight, minWeight, maxWeight) {
      if (maxWeight === minWeight) {
        return App.Geomap.MIN_RADIUS;
      }
      return Math.round(((weight - minWeight) / (maxWeight - minWeight)) * (App.Geomap.MAX_RADIUS - App.Geomap.MIN_RADIUS)) + App.Geomap.MIN_RADIUS;
    };

    Geomap.prototype.renderAll = function() {
      this.repaintMarkers();
      this.renderLegend(this.legendEnabled());
      return this.updateSavePositionButton();
    };

    Geomap.prototype.dblClicked = function(event) {
      var closestPoint, dashboard_id, mappings;
      if (this.twiddles == null) {
        return;
      }
      dashboard_id = this.twiddles.get('drilldown_dashboard');
      if (dashboard_id == null) {
        return;
      }
      closestPoint = Geomap.getClosestPointTo(this.allPoints, event.latlng);
      if (closestPoint == null) {
        return;
      }
      if (closestPoint.originalPoint == null) {
        return;
      }
      mappings = this.twiddles.getArray('drilldown_mapping');
      return App.DrilldownsController.applyGeomapDrilldownRequest(dashboard_id, mappings, closestPoint.originalPoint, this.twiddles);
    };

    Geomap.prototype.repaintMarkers = function(ignoreBounds) {
      if (ignoreBounds == null) {
        ignoreBounds = false;
      }
      if (!this.renderedOnce) {
        return;
      }
      this.removeMarkers();
      return this.renderAllSeries(ignoreBounds);
    };

    Geomap.inferColumns = function(allCols, rows) {
      var cols, remainingCols;
      remainingCols = allCols.slice(0);
      cols = {
        latCol: remainingCols.shift(),
        lngCol: remainingCols.shift()
      };
      return cols;
    };

    Geomap.makeLatLngBounds = function(points) {
      var p;
      return L.latLngBounds((function() {
        var j, len, results;
        results = [];
        for (j = 0, len = points.length; j < len; j++) {
          p = points[j];
          results.push(p.latLng);
        }
        return results;
      })());
    };

    Geomap.formatLatLngForDisplay = function(latLng) {
      var lat, lng;
      lat = App.Utils.roundToSignificantDigits(latLng.lat, 9);
      lng = App.Utils.roundToSignificantDigits(latLng.lng, 9);
      return lat + ", " + lng;
    };

    Geomap.getClosestPointTo = function(points, latLng) {
      var closestDist, closestPoint, dist, j, len, p;
      closestPoint = null;
      for (j = 0, len = points.length; j < len; j++) {
        p = points[j];
        dist = p.latLng.distanceTo(latLng);
        if ((closestPoint == null) || dist < closestDist) {
          closestDist = dist;
          closestPoint = p;
        }
      }
      return closestPoint;
    };

    Geomap.getTooltipDetailsFromRow = function(rows, tooltipColumns, seriesName, longitude) {
      var dCol, j, l, len, len1, len2, matchingRow, matchingRows, n, row, tooltipDetails;
      if (!((tooltipColumns != null) && !tooltipColumns.isEmpty())) {
        return null;
      }
      matchingRows = [];
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        if (row[seriesName] === longitude) {
          matchingRows.push(row);
        }
      }
      if (matchingRows.length === 0) {
        matchingRows = [rows[0]];
      }
      if (!((matchingRows != null) && (matchingRows[0] != null))) {
        return;
      }
      tooltipDetails = {};
      for (l = 0, len1 = tooltipColumns.length; l < len1; l++) {
        dCol = tooltipColumns[l];
        tooltipDetails[dCol] = [];
        for (n = 0, len2 = matchingRows.length; n < len2; n++) {
          matchingRow = matchingRows[n];
          tooltipDetails[dCol].push(matchingRow[dCol]);
        }
      }
      return tooltipDetails;
    };

    Geomap.prototype.mapMouseMove = function(event) {
      var closestPoint, mousePos, pointPos, proximity, weightColumns;
      closestPoint = Geomap.getClosestPointTo(this.allPoints, event.latlng);
      if (closestPoint == null) {
        return;
      }
      mousePos = this.map.latLngToContainerPoint(event.latlng);
      pointPos = this.map.latLngToContainerPoint(closestPoint.latLng);
      proximity = Geomap.TOOLTIP_PROXIMITY_PX + (closestPoint.radius || Geomap.MIN_RADIUS);
      if (Math.pow(mousePos.x - pointPos.x, 2) + Math.pow(mousePos.y - pointPos.y, 2) < Math.pow(proximity, 2)) {
        weightColumns = this.plotAsBubbles ? this.twiddle('geomap_weight_columns') : [];
        if (!this.plotAsClusters()) {
          return this.tooltipHelper.renderTooltip(closestPoint, pointPos, weightColumns);
        }
      } else {
        return this.tooltipHelper.hideTooltip();
      }
    };

    Geomap.createClusterIcon = function(cluster) {
      var borderColor, childCount, color, customStyle, divIcon, markerClass, transparency, transparentColor;
      childCount = cluster.getChildCount();
      transparency = 0.8;
      if (childCount === 1) {
        markerClass = 'single';
        transparency = 0.2;
      } else if (childCount < 10) {
        markerClass = 'small';
        transparency = 0.4;
      } else if (childCount < 100) {
        markerClass = 'medium';
        transparency = 0.6;
      } else {
        markerClass = 'large';
      }
      color = this.color;
      customStyle = '';
      if (color != null) {
        transparentColor = App.ColorHelper.setAlpha(color, transparency);
        borderColor = App.ColorHelper.setAlpha(color, 0.8);
        customStyle = "background-color:" + transparentColor + ";border-color:" + borderColor;
      }
      divIcon = new L.DivIcon({
        html: "<div style='" + customStyle + "'><span>" + childCount + "</span></div>",
        className: "marker-cluster " + markerClass,
        iconSize: new L.Point(40, 40)
      });
      return divIcon;
    };

    Geomap.CLUSTERS_OPTIONS.iconCreateFunction = Geomap.createClusterIcon;

    Geomap.getSpectrumFor = function(color) {
      var dc1, lc1, lc2;
      if (!color) {
        return;
      }
      dc1 = App.ColorHelper.lightenOrDarken(color, -50);
      lc2 = App.ColorHelper.lightenOrDarken(color, 20);
      lc1 = App.ColorHelper.lightenOrDarken(color, 10);
      return [lc2, lc1, color, dc1];
    };

    Geomap.prototype.clusterPointTooltip = function(event) {
      var closestPoint, pointPos, weightColumns;
      this.hideTooltip();
      closestPoint = Geomap.getClosestPointTo(this.allPoints, event.latlng);
      if (closestPoint == null) {
        return;
      }
      pointPos = this.map.latLngToContainerPoint(closestPoint.latLng);
      weightColumns = this.plotAsBubbles ? this.twiddle('geomap_weight_columns') : [];
      return this.tooltipHelper.renderTooltip(closestPoint, pointPos, weightColumns);
    };

    return Geomap;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.GeomapTooltipHelper = (function(superClass) {
    extend(GeomapTooltipHelper, superClass);

    GeomapTooltipHelper.prototype.events = {
      'mouseleave': 'hideTooltip'
    };

    function GeomapTooltipHelper() {
      this.renderTooltip = bind(this.renderTooltip, this);
      GeomapTooltipHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'tooltipEl', 'tooltipColumns');
    }

    GeomapTooltipHelper.prototype.hideTooltip = function() {
      this.tooltipOn = false;
      return setTimeout(((function(_this) {
        return function() {
          if (!_this.tooltipOn) {
            return _this.tooltipEl.hide();
          }
        };
      })(this)), 250);
    };

    GeomapTooltipHelper.prototype.renderTooltip = function(point, pointPos, weightColumns) {
      this.repositionWeightColumnInTooltipColumnsAndDetails(point, weightColumns);
      this.tooltipEl.html(this.tooltipInnardsForPoint(point, weightColumns));
      this.alignTooltip(pointPos);
      if (!this.tooltipOn) {
        this.tooltipOn = true;
        return setTimeout(((function(_this) {
          return function() {
            return _this.tooltipEl.show();
          };
        })(this)), 0);
      }
    };

    GeomapTooltipHelper.prototype.repositionWeightColumnInTooltipColumnsAndDetails = function(point, weightColumns) {
      var weightColumn, weightColumnIndex, weightColumnObj, weightColumnValue;
      if ((weightColumns != null) && (weightColumns.length === 1) && (this.tooltipColumns != null) && (this.tooltipColumns.length > 1)) {
        weightColumn = weightColumns.first();
        weightColumnIndex = this.tooltipColumns.indexOf(weightColumn);
        if (weightColumnIndex !== -1) {
          this.tooltipColumns.splice(weightColumnIndex, 1);
          this.tooltipColumns.unshift(weightColumn);
          if (point.tooltipDetails != null) {
            weightColumnValue = point.tooltipDetails[weightColumn];
            delete point.tooltipDetails[weightColumn];
            weightColumnObj = {};
            weightColumnObj[weightColumn] = weightColumnValue;
            return point.tooltipDetails = Object.assign(weightColumnObj, point.tooltipDetails);
          }
        }
      }
    };

    GeomapTooltipHelper.prototype.tooltipInnardsForPoint = function(point, weightColumns) {
      var singleDetail;
      singleDetail = '';
      return singleDetail = App.RedesignChartTooltip.makeTooltipHtml(App.Geomap.formatLatLngForDisplay(point.latLng), this.majorDetailForTooltip(point, weightColumns), void 0, false, App.Geomap.MARKER_COLOR, this.detailsForTooltip(point));
    };

    GeomapTooltipHelper.prototype.detailsForTooltip = function(point) {
      var detail_list, first, i, k, len, ref, v, v_list;
      first = true;
      detail_list = [];
      if (point.tooltipDetails != null) {
        ref = point.tooltipDetails;
        for (k in ref) {
          v_list = ref[k];
          for (i = 0, len = v_list.length; i < len; i++) {
            v = v_list[i];
            if (first) {
              first = false;
              continue;
            }
            detail_list.push([k, v]);
          }
        }
        return detail_list;
      } else {
        return [];
      }
    };

    GeomapTooltipHelper.prototype.majorDetailForTooltip = function(point, weightColumns) {
      if ((point.tooltipDetails != null) && (this.tooltipColumns != null) && !this.tooltipColumns.isEmpty() && (point.tooltipDetails[this.tooltipColumns.first()] != null) && !point.tooltipDetails[this.tooltipColumns.first()].isEmpty()) {
        return this.detailWithBubbleWeight(point, weightColumns);
      } else {
        return '';
      }
    };

    GeomapTooltipHelper.prototype.detailWithBubbleWeight = function(point, weightColumns) {
      var ref;
      if (isArray(weightColumns) && ((ref = this.tooltipColumns.first(), indexOf.call(weightColumns, ref) >= 0) && weightColumns.length === 1)) {
        return point.weight;
      } else {
        return point.tooltipDetails[this.tooltipColumns.first()].first();
      }
    };

    GeomapTooltipHelper.prototype.alignTooltip = function(pointPos) {
      var amountToShift, chartBoundary, containerLeft, containerRight, currentArrowMargin, geomapOffset, leftRelativeToChart, leftRelativeToWindow, top, toppanel;
      top = pointPos.y - this.tooltipEl.height() - 16;
      leftRelativeToChart = pointPos.x - this.tooltipEl.width() / 2;
      if (AppRedesign.isRedesignMode()) {
        toppanel = $('.tooltip-cover-heading:visible:not(:empty)').toArray().reduce(((function(_this) {
          return function(sum, element) {
            return sum + Number($(element).outerHeight());
          };
        })(this)), 0);
        geomapOffset = this.tooltipEl.parent().offset();
        if (geomapOffset.top + top + 30 < toppanel) {
          top = pointPos.y + 16;
          this.tooltipEl.find('.tooltip-container').addClass('arrow-bottom');
        } else {
          this.tooltipEl.find('.tooltip-container').removeClass('arrow-bottom');
        }
        chartBoundary = this.tooltipEl.closest('.chart-tooltip-boundary');
        containerLeft = chartBoundary.offset().left;
        containerRight = containerLeft + chartBoundary.outerWidth();
        leftRelativeToWindow = geomapOffset.left + leftRelativeToChart;
        if (leftRelativeToWindow < containerLeft) {
          this.tooltipEl.find('.tooltip-container .arrow').css({
            'margin-left': leftRelativeToChart + "px"
          });
          leftRelativeToChart = -10;
        }
        if (leftRelativeToWindow + this.tooltipEl.width() > containerRight) {
          amountToShift = leftRelativeToWindow + this.tooltipEl.width() - containerRight;
          leftRelativeToChart = leftRelativeToChart - amountToShift;
          currentArrowMargin = parseInt(this.tooltipEl.find('.tooltip-container .arrow').css('margin-left'));
          this.tooltipEl.find('.tooltip-container .arrow').css({
            'margin-left': currentArrowMargin + amountToShift + "px"
          });
        }
      }
      return this.tooltipEl.css({
        top: top,
        left: leftRelativeToChart
      });
    };

    return GeomapTooltipHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.NotificationBarController = (function(superClass) {
    extend(NotificationBarController, superClass);

    function NotificationBarController() {
      this.onChildClose = bind(this.onChildClose, this);
      NotificationBarController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.render();
    }

    NotificationBarController.prototype.render = function() {
      this.childController = this.activeBar();
      if (!this.childController) {
        return;
      }
      this.bubbles(this.childController, 'click');
      this.childController.bind('close', this.onChildClose);
      this.el.append(this.childController.el);
      return this.el.show();
    };

    NotificationBarController.prototype.release = function() {
      var ref;
      return (ref = this.childController) != null ? ref.release() : void 0;
    };

    NotificationBarController.prototype.activeBar = function() {
      var bar, bars, i, len;
      bars = [App.StatusBarController, App.NonPaymentBarController, App.ButterBarController];
      for (i = 0, len = bars.length; i < len; i++) {
        bar = bars[i];
        if (bar.shouldShow()) {
          return new bar();
        }
      }
      return null;
    };

    NotificationBarController.prototype.onChildClose = function() {
      var nextActiveBar;
      nextActiveBar = this.activeBar();
      if (!nextActiveBar) {
        this.el.css('height', '0px');
        return setTimeout((function(_this) {
          return function() {
            _this.childController.release();
            return _this.el.hide();
          };
        })(this), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      } else {
        this.childController.release();
        return this.render();
      }
    };

    return NotificationBarController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TutorialTooltip = (function(superClass) {
    extend(TutorialTooltip, superClass);

    TutorialTooltip.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.panel) != null) {
        ref.release();
      }
      return (ref1 = this.anchor) != null ? ref1.remove() : void 0;
    };

    TutorialTooltip.prototype.visible = function() {
      var ref;
      return (ref = this.panel) != null ? ref.el.is(':visible') : void 0;
    };

    function TutorialTooltip(preferredPosition, targetEl, titleText, linkUrl) {
      this.preferredPosition = preferredPosition;
      this.targetEl = targetEl;
      this.titleText = titleText;
      this.linkUrl = linkUrl;
      this.exitClicked = bind(this.exitClicked, this);
      this.show = bind(this.show, this);
      this.showAndReparent = bind(this.showAndReparent, this);
      this.anchorEl = bind(this.anchorEl, this);
      this.onClose = bind(this.onClose, this);
      this.targetEl.append(this.anchorEl());
      this.targetEl.css({
        'position': 'relative'
      });
    }

    TutorialTooltip.prototype.onClose = function(onCloseCb) {
      this.onCloseCb = onCloseCb;
      return this;
    };

    TutorialTooltip.prototype.anchorEl = function() {
      return this.anchor != null ? this.anchor : this.anchor = $('<div class="tutorial-anchor"></div>');
    };

    TutorialTooltip.prototype.linkView = function() {
      return this.view('tooltip/tutorial_link')({
        titleText: this.titleText,
        linkUrl: this.linkUrl
      });
    };

    TutorialTooltip.prototype.showAndReparent = function(indentWidth, indentHeight, reparentContainerClass) {
      this.panel = new App.RedesignTooltipPanel({
        contentEl: this.linkView(),
        extraClass: 'tutorial-tooltip',
        pointerOffsetPercent: 0.53,
        side: this.preferredPosition,
        useSmallPointer: true,
        width: '210px'
      });
      requestAnimationFrame((function(_this) {
        return function() {
          $(_this.targetEl).closest(reparentContainerClass).append(_this.panel.el);
          _this.panel.addPanel();
          _this.panel.pointAtEl(_this.preferredPosition, _this.targetEl, 0.53, indentWidth, indentHeight);
          _this.panel.el.on('click', _this.panelClicked);
          _this.panel.mouseLeft = function() {};
          return _this.panel.$('.close').on('click', _this.exitClicked);
        };
      })(this));
      return this;
    };

    TutorialTooltip.prototype.show = function(indentWidth, indentHeight) {
      return this.showAndReparent(indentWidth, indentHeight, '*');
    };

    TutorialTooltip.prototype.panelClicked = function(evt) {
      return evt.stopPropagation();
    };

    TutorialTooltip.prototype.exitClicked = function(evt) {
      this.release();
      if (typeof this.onCloseCb === "function") {
        this.onCloseCb();
      }
      return evt.stopPropagation();
    };

    return TutorialTooltip;

  })(Spine.Module);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.OverloadedSiteController = (function(superClass) {
    extend(OverloadedSiteController, superClass);

    OverloadedSiteController.prototype.className = 'reload-modal';

    OverloadedSiteController.SLEEP_THRESHOLD_MIN_SECONDS = 60;

    OverloadedSiteController.SLEEP_THRESHOLD_MAX_SECONDS = 600;

    function OverloadedSiteController() {
      var sleepMs;
      OverloadedSiteController.__super__.constructor.apply(this, arguments);
      this.render();
      sleepMs = App.Utils.randomInt(this.constructor.SLEEP_THRESHOLD_MIN_SECONDS, this.constructor.SLEEP_THRESHOLD_MAX_SECONDS) * 1000;
      this.reloadTimeout = setTimeout(this.reloadNow, sleepMs);
    }

    OverloadedSiteController.prototype.render = function() {
      this.html(this.view('redesign/overloaded_site'));
      return this.dialog = App.RedesignDialog.createDialog({
        noCancel: true,
        title: '',
        viewController: this
      });
    };

    OverloadedSiteController.prototype.reloadNow = function() {
      return AppRedesign.current().resetIfReady();
    };

    return OverloadedSiteController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.PageOverlay = (function() {
    function PageOverlay() {}

    PageOverlay.SELECTOR = '.page-overlay';

    PageOverlay.show = function(callback) {
      PageOverlay.el().off('click');
      PageOverlay.fadeInPageOverlay();
      return PageOverlay.addOnetimeClickCallback(callback);
    };

    PageOverlay.showWithoutCallback = function() {
      PageOverlay.el().off('click');
      return PageOverlay.fadeInPageOverlay();
    };

    PageOverlay.hide = function() {
      if (!PageOverlay.el().hasClass('visible')) {
        return;
      }
      PageOverlay.el().off('click');
      return PageOverlay.fadeOutPageOverlay();
    };

    PageOverlay.hideAndInvokeCallback = function() {
      return PageOverlay.el().trigger('click');
    };

    PageOverlay.el = function() {
      return $(PageOverlay.SELECTOR);
    };

    PageOverlay.addOnetimeClickCallback = function(callback) {
      var onetimeCallback;
      onetimeCallback = function() {
        callback();
        return PageOverlay.hide();
      };
      return PageOverlay.el().on('click', onetimeCallback);
    };

    PageOverlay.fadeInPageOverlay = function() {
      PageOverlay.sizePageOverlay();
      $(window).on('resize', PageOverlay.sizePageOverlay);
      return App.Utils.animateHack(true, 'visible', PageOverlay.el());
    };

    PageOverlay.fadeOutPageOverlay = function() {
      $(window).off('resize', PageOverlay.sizePageOverlay);
      return App.Utils.animateHack(false, 'visible', PageOverlay.el());
    };

    PageOverlay.sizePageOverlay = function() {
      return PageOverlay.el().css({
        height: $(window).height()
      });
    };

    return PageOverlay;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.PivotFilterProcessor = (function(superClass) {
    extend(PivotFilterProcessor, superClass);

    PivotFilterProcessor.filterRows = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return ((function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(App.PivotFilterProcessor, args, function(){})).applyFilters();
    };

    function PivotFilterProcessor(twiddles, twiddlesActual, rows) {
      this.twiddles = twiddles;
      this.twiddlesActual = twiddlesActual;
      this.rows = rows;
    }

    PivotFilterProcessor.prototype.applyFilters = function() {
      if (App.Utils.emptyArray(this.rows)) {
        return this.rows;
      }
      if (App.Utils.emptyArray(this.filters())) {
        return this.rows;
      }
      return this.rows.filter((function(_this) {
        return function(row) {
          return !_this.failsAnyFilter(row);
        };
      })(this));
    };

    PivotFilterProcessor.prototype.filtersFromTwiddles = function() {
      return this.parseArrayTwiddle('filter_columns');
    };

    PivotFilterProcessor.prototype.filters = function() {
      var columnType, filterParams;
      return this._filters != null ? this._filters : this._filters = (function() {
        var i, len, ref, ref1, results;
        ref = this.filtersFromTwiddles();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          filterParams = ref[i];
          filterParams.column_filter_condition = (ref1 = filterParams.column_filter_condition) != null ? ref1.toLowerCase() : void 0;
          columnType = this.columnTypeFromFilterCondition(filterParams.column_name);
          switch (columnType) {
            case App.Chartographer.NUMERIC_COLUMN_TYPE:
              results.push(this.passesNumericFilter(filterParams));
              break;
            case App.Chartographer.DATETIME_COLUMN_TYPE:
              results.push(this.passesDateRangeFilter(filterParams));
              break;
            default:
              results.push(this.passesRawFilter(filterParams));
          }
        }
        return results;
      }).call(this);
    };

    PivotFilterProcessor.prototype.columnTypeFromFilterCondition = function(columnName) {
      return this.columnActual(columnName, 'type');
    };

    PivotFilterProcessor.prototype.failsAnyFilter = function(row) {
      var filter, filters, i, len;
      filters = this.filters();
      if (!((filters != null ? filters.length : void 0) > 0)) {
        return false;
      }
      for (i = 0, len = filters.length; i < len; i++) {
        filter = filters[i];
        if (!filter(row)) {
          return true;
        }
      }
      return false;
    };

    PivotFilterProcessor.prototype.passesRawFilter = function(filterParams) {
      var columnName, filterValue;
      filterValue = filterParams.column_filter_value;
      columnName = filterParams.column_name;
      switch (filterParams.column_filter_condition) {
        case 'equals':
          return function(row) {
            return filterValue === row[columnName];
          };
        case 'does not equal':
          return function(row) {
            return filterValue !== row[columnName];
          };
        case 'contains':
          return function(row) {
            return row[columnName].indexOf(filterValue) !== -1;
          };
        case 'does not contain':
          return function(row) {
            return row[columnName].indexOf(filterValue) === -1;
          };
        case 'begins with':
          return function(row) {
            return row[columnName].indexOf(filterValue) === 0;
          };
        case 'ends with':
          return function(row) {
            var reversedFilter, reversedRow;
            reversedRow = App.Utils.reverseString(row[columnName]);
            reversedFilter = App.Utils.reverseString(filterValue);
            return reversedRow.indexOf(reversedFilter) === 0;
          };
        default:
          return function(row) {
            return filterValue === row[columnName];
          };
      }
    };

    PivotFilterProcessor.prototype.passesDateRangeFilter = function(filterParams) {
      var columnName, cutoffDate, filterCondition, ref;
      filterCondition = filterParams.column_filter_condition || '365 days';
      columnName = filterParams.column_name;
      cutoffDate = (ref = moment(new Date().getTime())).subtract.apply(ref, filterCondition.split(' '));
      return function(row) {
        return moment(row[columnName]) >= cutoffDate;
      };
    };

    PivotFilterProcessor.prototype.passesNumericFilter = function(filterParams) {
      var columnName, filterValue;
      filterValue = parseFloat(filterParams.column_filter_value);
      columnName = filterParams.column_name;
      switch (filterParams.column_filter_condition) {
        case '==':
          return function(row) {
            return parseFloat(row[columnName]) === filterValue;
          };
        case '!=':
          return function(row) {
            return parseFloat(row[columnName]) !== filterValue;
          };
        case '>':
          return function(row) {
            return parseFloat(row[columnName]) > filterValue;
          };
        case '<':
          return function(row) {
            return parseFloat(row[columnName]) < filterValue;
          };
        case '>=':
          return function(row) {
            return parseFloat(row[columnName]) >= filterValue;
          };
        case '<=':
          return function(row) {
            return parseFloat(row[columnName]) <= filterValue;
          };
        default:
          return function(row) {
            return parseFloat(row[columnName]) > filterValue;
          };
      }
    };

    return PivotFilterProcessor;

  })(App.Chartographer);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RadioButton = (function(superClass) {
    extend(RadioButton, superClass);

    RadioButton.prototype.elements = {
      '.icon': 'icon',
      '.label': 'label'
    };

    RadioButton.prototype.events = {
      'click .icon': 'clickedRadioButton',
      'click .label': 'clickedRadioButton'
    };

    RadioButton.NOTHING_SELECTED = null;

    function RadioButton() {
      this.clickedRadioButton = bind(this.clickedRadioButton, this);
      var capitalizedTextLabel;
      RadioButton.__super__.constructor.apply(this, arguments);
      if (this.callback == null) {
        throw new Error('requires callback');
      }
      if (this.textLabel == null) {
        throw new Error('requires label');
      }
      capitalizedTextLabel = this.textLabel[0].toUpperCase() + this.textLabel.slice(1);
      this.html(this.view('radio_button')({
        label: capitalizedTextLabel
      }));
      if (this.enabled == null) {
        this.enabled = true;
      }
      if (this.enabled !== true) {
        this.el.addClass('disabled');
      }
      this.lastClickedAt = 0;
    }

    RadioButton.prototype.setSelected = function(isSelected, isDefault) {
      if (isDefault == null) {
        isDefault = false;
      }
      if (isSelected || isDefault) {
        return this.el.addClass('checked');
      } else {
        return this.el.removeClass('checked');
      }
    };

    RadioButton.prototype.toggle = function() {
      if (this.explicitlySelected()) {
        return this.setSelected(false);
      } else {
        return this.setSelected(true);
      }
    };

    RadioButton.prototype.clickedRadioButton = function(e) {
      var callbackValue;
      if (!this.enabled) {
        return false;
      }
      if (!(this.explicitlySelected() && this.disableDeselection)) {
        this.toggle();
      }
      callbackValue = this.selected() ? this.value : RadioButton.NOTHING_SELECTED;
      this.callback(callbackValue, this.clickOptions());
      return e != null ? e.stopPropagation() : void 0;
    };

    RadioButton.prototype.selected = function() {
      return this.explicitlySelected();
    };

    RadioButton.prototype.unselected = function() {
      return !this.selected();
    };

    RadioButton.prototype.explicitlySelected = function() {
      return this.el.hasClass('checked');
    };

    RadioButton.prototype.clickOptions = function() {
      return {
        doubleClick: this.isDoubleClick()
      };
    };

    RadioButton.prototype.isDoubleClick = function() {
      var doubleClick;
      doubleClick = RadioButton.isDoubleClick(this.lastClickedAt);
      this.lastClickedAt = RadioButton.lastClickedAtForDoubleClick(doubleClick);
      return doubleClick;
    };

    RadioButton.isDoubleClick = function(lastClickedAt) {
      var elapsed;
      elapsed = AppRedesign.timestamp() - lastClickedAt;
      return elapsed < AppRedesign.DOUBLE_CLICK_TIMEFRAME;
    };

    RadioButton.lastClickedAtForDoubleClick = function(doubleClick) {
      if (doubleClick) {
        return 0;
      } else {
        return AppRedesign.timestamp();
      }
    };

    RadioButton.makeFrame = function() {
      return $("<div class='radio-button'></div>");
    };

    RadioButton.appendFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.append(f);
      return f;
    };

    RadioButton.prependFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.prepend(f);
      return f;
    };

    return RadioButton;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RadioButtonGroup = (function(superClass) {
    extend(RadioButtonGroup, superClass);

    function RadioButtonGroup() {
      this.clickedRadioOption = bind(this.clickedRadioOption, this);
      var i, len, radioButton, radioOption, ref;
      RadioButtonGroup.__super__.constructor.apply(this, arguments);
      if (this.callback == null) {
        throw new Error('requires callback');
      }
      if (!((this.radioOptions != null) && this.radioOptions.length > 0)) {
        throw new Error('requires radioOptions');
      }
      if (this.optionCompareFunc == null) {
        this.optionCompareFunc = (function(a, b) {
          return a === b;
        });
      }
      if (this.disableDeselection == null) {
        this.disableDeselection = true;
      }
      this.radioButtons = [];
      ref = this.radioOptions;
      for (i = 0, len = ref.length; i < len; i++) {
        radioOption = ref[i];
        radioButton = new App.RadioButton({
          textLabel: radioOption.label,
          el: App.RadioButton.appendFrame(this.el),
          value: radioOption.value,
          disableDeselection: this.disableDeselection,
          callback: this.clickedRadioOption,
          enabled: !radioOption.disabled
        });
        this.radioButtons.push(radioButton);
      }
      this.setValueOrDefault(this.initialValue, this.defaultValue);
    }

    RadioButtonGroup.prototype.release = function() {
      var i, len, radioButton, ref, results;
      RadioButtonGroup.__super__.release.apply(this, arguments);
      ref = this.radioButtons;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        results.push(radioButton.release());
      }
      return results;
    };

    RadioButtonGroup.prototype.setValueOrDefault = function(value, defaultValue) {
      var not_selected;
      not_selected = value === App.RadioButton.NOTHING_SELECTED || value === void 0;
      if (not_selected && (defaultValue != null)) {
        return this.setState(defaultValue, true);
      } else {
        return this.setState(value);
      }
    };

    RadioButtonGroup.prototype.selectedValue = function() {
      var i, len, radioButton, ref;
      ref = this.radioButtons;
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        if (radioButton.selected()) {
          return radioButton.value;
        }
      }
      return null;
    };

    RadioButtonGroup.makeFrame = function() {
      return $('<div class="radio-button-group"></div>');
    };

    RadioButtonGroup.appendFrame = function(parentEl) {
      var el;
      el = this.makeFrame();
      parentEl.prepend(el);
      return el;
    };

    RadioButtonGroup.prependFrame = function(parentEl) {
      var el;
      el = this.makeFrame();
      parentEl.prepend(el);
      return el;
    };

    RadioButtonGroup.prototype.clickedRadioOption = function(value, clickOptions) {
      if (!clickOptions.doubleClick) {
        this.setValueOrDefault(value, this.defaultValue);
      }
      return this.callback(value, clickOptions);
    };

    RadioButtonGroup.prototype.setState = function(value, isDefault) {
      var i, j, len, len1, radioButton, ref, ref1, results;
      if (isDefault == null) {
        isDefault = false;
      }
      ref = this.radioButtons;
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        radioButton.setSelected(false);
      }
      ref1 = this.radioButtons;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        radioButton = ref1[j];
        if (this.optionCompareFunc(radioButton.value, value)) {
          radioButton.setSelected(true, isDefault);
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RadioButtonGroup.prototype.setDisabled = function(disabled) {
      var i, j, len, len1, radioButton, ref, ref1, results, results1;
      if (disabled) {
        this.el.addClass('disabled');
        ref = this.radioButtons;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          radioButton = ref[i];
          results.push(radioButton.enabled = false);
        }
        return results;
      } else {
        this.el.removeClass('disabled');
        ref1 = this.radioButtons;
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          radioButton = ref1[j];
          results1.push(radioButton.enabled = true);
        }
        return results1;
      }
    };

    return RadioButtonGroup;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DualColorPickerController = (function(superClass) {
    extend(DualColorPickerController, superClass);

    function DualColorPickerController() {
      this.selectColor = bind(this.selectColor, this);
      this.updateColor = bind(this.updateColor, this);
      this.bodyClick = bind(this.bodyClick, this);
      this.render = bind(this.render, this);
      DualColorPickerController.__super__.constructor.apply(this, arguments);
      this.initialBackgroundColor = this.colorGroup.background;
      this.initialTextColor = this.colorGroup.text;
      this.colorType = 'background';
      this.colorToSet = this.colorGroup.background;
      this.render();
    }

    DualColorPickerController.prototype.switchColor = function(colorType) {
      this.colorType = colorType;
      this.colorToSet = this.colorGroup[colorType];
      return this.trigger('reset', this.colorToSet);
    };

    DualColorPickerController.prototype.render = function() {
      this.renderThemeColors();
      setTimeout(((function(_this) {
        return function() {
          return $('#body').on('click', _this.bodyClick);
        };
      })(this)));
      this.gradientColorPicker = new App.GradientColorPicker({
        viewController: this,
        colorToSet: this.colorToSet
      });
      this.colorPickerArea.append(this.gradientColorPicker.$el);
      this.gradientColorPicker.bind('set-color', this.updateColor);
      return this.renderRecentColors();
    };

    DualColorPickerController.prototype.renderThemeColors = function() {
      this.themeColorsController = new App.ThemeColorsController({
        viewController: this,
        colorTheme: this.colorTheme
      });
      this.themeColorsController.bind('set-color', this.updateColor);
      return this.themeColorsArea.append(this.themeColorsController.$el);
    };

    DualColorPickerController.prototype.bodyClick = function(event) {
      if (_.isEmpty($(event.target).parents('.gradient-color-picker'))) {
        return this.updateAndRelease();
      }
    };

    DualColorPickerController.prototype.updateAndRelease = function() {
      if (this.colorToSet) {
        this.trigger('add-recent', this.colorToSet);
      }
      this.trigger('update', this.colorGroup);
      return this.release();
    };

    DualColorPickerController.prototype.renderRecentColors = function() {
      this.recentColorsController = new App.RecentColorsController({
        viewController: this
      });
      this.recentColorsController.bind('set-color', this.updateColor);
      return this.recentColorsArea.append(this.recentColorsController.$el);
    };

    DualColorPickerController.prototype.updateColor = function(backgroundColor) {
      this.colorToSet = App.ColorHelper.hexColorOrNull(backgroundColor);
      this.colorGroup[this.colorType] = this.colorToSet;
      return this.setTargetColor();
    };

    DualColorPickerController.prototype.resetColor = function() {
      if (this.colorType === 'text') {
        this.colorToSet = this.initialTextColor;
      } else {
        this.colorToSet = this.initialBackgroundColor;
      }
      this.colorGroup[this.colorType] = this.colorToSet;
      this.setTargetColor();
      return this.trigger('reset', this.colorToSet);
    };

    DualColorPickerController.prototype.setTargetColor = function() {
      this.backgroundTarget.css({
        'border-bottom-color': App.ColorHelper.hexColorOrNull(this.colorGroup.background)
      });
      return this.textTarget.css({
        'border-top-color': App.ColorHelper.hexColorOrNull(this.colorGroup.text)
      });
    };

    DualColorPickerController.prototype.toggleRotator = function(e) {
      var rotator;
      e.stopPropagation();
      rotator = $(e.currentTarget.closest('.subheader-2.rotator'));
      return rotator.toggleClass('closed');
    };

    DualColorPickerController.prototype.selectColor = function(e) {
      if ($(e.currentTarget).data('color-type') === this.colorType) {
        return;
      }
      this.switchColor($(e.currentTarget).data('color-type'));
      return $('.color-type').toggleClass('selected');
    };

    return DualColorPickerController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardSettingsForm = (function(superClass) {
    extend(RedesignDashboardSettingsForm, superClass);

    RedesignDashboardSettingsForm.ZINDEX_ABOVE_OVERLAY = 102;

    function RedesignDashboardSettingsForm() {
      this.repositionSelf = bind(this.repositionSelf, this);
      this.showForm = bind(this.showForm, this);
      this.hideForm = bind(this.hideForm, this);
      this.hideFormWithSlide = bind(this.hideFormWithSlide, this);
      RedesignDashboardSettingsForm.__super__.constructor.apply(this, arguments);
      this.open = false;
      App.Utils.requires(this, 'dashboard');
      this.dashboard.bind('dashboard-settings-changed-pinned', this.repositionSelf);
      this.el.on('click', (function(e) {
        return e.stopPropagation();
      }));
    }

    RedesignDashboardSettingsForm.prototype.release = function() {
      this.dashboard.unbind('dashboard-settings-changed-pinned', this.repositionSelf);
      return this.el.off('click');
    };

    RedesignDashboardSettingsForm.prototype.hideFormWithSlide = function(resetOverlay) {
      if (resetOverlay == null) {
        resetOverlay = true;
      }
      this.el.removeClass('slideable');
      return this.hideForm(resetOverlay);
    };

    RedesignDashboardSettingsForm.prototype.hideForm = function(resetOverlay) {
      if (resetOverlay == null) {
        resetOverlay = true;
      }
      if (!this.open) {
        return false;
      }
      this.el.addClass('closing');
      this.el.removeClass('open scrollable');
      App.CustomDimension.trigger('editing-dimension', null);
      this.open = false;
      if (resetOverlay) {
        App.Site.trigger('exit-modal');
      }
      setTimeout(((function(_this) {
        return function() {
          var ref;
          if (resetOverlay) {
            _this.undoShowAboveOverlay();
          }
          _this.dashboard.trigger('dimension-form-closed');
          return (ref = _this.el) != null ? ref.removeClass('closing') : void 0;
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      return true;
    };

    RedesignDashboardSettingsForm.prototype.showForm = function() {
      if (AppRedesign.current().inModal) {
        return;
      }
      this.showAboveOverlay();
      return App.Site.trigger('enter-modal');
    };

    RedesignDashboardSettingsForm.prototype.undoShowAboveOverlay = function() {
      this.el.css('z-index', '');
      $('.dashboard-header').css('z-index', '');
      $('.dashboard-settings-frame').css('z-index', '');
      return this.setOverlay = false;
    };

    RedesignDashboardSettingsForm.prototype.showAboveOverlay = function() {
      this.el.css('z-index', this.constructor.ZINDEX_ABOVE_OVERLAY);
      $('.dashboard-header').css('z-index', this.constructor.ZINDEX_ABOVE_OVERLAY);
      $('.dashboard-settings-frame').css('z-index', this.constructor.ZINDEX_ABOVE_OVERLAY);
      return this.setOverlay = true;
    };

    RedesignDashboardSettingsForm.prototype.positionOfDimSetting = function() {
      return null;
    };

    RedesignDashboardSettingsForm.prototype.settingsEl = function() {
      return $('.dashboard-settings');
    };

    RedesignDashboardSettingsForm.prototype.dashboardEl = function() {
      return $('.dashboard-container.active');
    };

    RedesignDashboardSettingsForm.prototype.repositionSelf = function() {
      var dimPos, formWidth;
      dimPos = this.positionOfDimSetting();
      formWidth = this.el.width();
      if (dimPos === null) {
        this.setPosition(null);
        return;
      }
      if (dimPos.left > formWidth) {
        return this.setPosition(dimPos.left - formWidth, dimPos.top);
      } else {
        return this.setPosition(dimPos.left + dimPos.width, dimPos.top);
      }
    };

    RedesignDashboardSettingsForm.prototype.setPosition = function(left, top) {
      var dashWidth, formWidth;
      if (left == null) {
        dashWidth = this.dashboardEl().width();
        formWidth = this.el.width();
        left = dashWidth - formWidth + 1;
      }
      if (top != null) {
        return this.el.css({
          left: left + "px",
          top: top + "px"
        });
      } else {
        return this.el.css({
          left: left + "px",
          top: ""
        });
      }
    };

    return RedesignDashboardSettingsForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SingleColorPickerController = (function(superClass) {
    extend(SingleColorPickerController, superClass);

    function SingleColorPickerController() {
      this.updateColor = bind(this.updateColor, this);
      this.render = bind(this.render, this);
      this.bodyClick = bind(this.bodyClick, this);
      SingleColorPickerController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'colorToSet');
      this.initialColor = this.colorToSet;
      this.render();
    }

    SingleColorPickerController.prototype.bodyClick = function(event) {
      if (_.isEmpty($(event.target).parents('.gradient-color-picker'))) {
        return this.updateAndRelease();
      }
    };

    SingleColorPickerController.prototype.updateAndRelease = function() {
      this.trigger('add-recent', this.colorToSet);
      if (this.colorToSet) {
        this.trigger('update', this.colorToSet, this.indexOrAttribute);
      }
      return this.release();
    };

    SingleColorPickerController.prototype.render = function() {
      setTimeout(((function(_this) {
        return function() {
          return $('#body').on('click', _this.bodyClick);
        };
      })(this)));
      this.gradientColorPicker = new App.GradientColorPicker({
        viewController: this,
        colorToSet: this.colorToSet
      });
      this.colorPickerArea.append(this.gradientColorPicker.$el);
      this.gradientColorPicker.bind('set-color', this.updateColor);
      this.renderRecentColors();
      return this.addBorders();
    };

    SingleColorPickerController.prototype.renderRecentColors = function() {
      this.recentColorsController = new App.RecentColorsController({
        viewController: this
      });
      this.recentColorsController.bind('set-color', this.updateColor);
      return this.recentColorsArea.append(this.recentColorsController.$el);
    };

    SingleColorPickerController.prototype.updateColor = function(colorToSet) {
      var ref;
      this.colorToSet = (ref = App.ColorHelper.hexColorOrNull(colorToSet)) != null ? ref : this.colorToSet;
      return this.setTargetColor();
    };

    SingleColorPickerController.prototype.resetColor = function() {
      this.colorToSet = this.initialColor;
      this.setTargetColor();
      return this.trigger('reset', this.colorToSet);
    };

    SingleColorPickerController.prototype.deleteColor = function(e) {
      this.trigger('delete', this.colorToSet, this.indexOrAttribute);
      return this.release();
    };

    SingleColorPickerController.prototype.toggleRotator = function(e) {
      var rotator;
      e.stopPropagation();
      rotator = $($(e.currentTarget).closest('.subheader-2.rotator'));
      return rotator.toggleClass('closed');
    };

    SingleColorPickerController.prototype.addBorders = function() {
      var squares;
      squares = $(this.el).find('.color-square');
      return $(squares).each(function() {
        return App.ColorHelper.toggleBorderClassOnColorLightness($(this), $(this).css('background-color'), 'show-border', 200);
      });
    };

    SingleColorPickerController.prototype.release = function() {
      $('#body').off('click', this.bodyClick);
      return SingleColorPickerController.__super__.release.apply(this, arguments);
    };

    return SingleColorPickerController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.AlertHelpers = {
    alertWarningMessage: function(warnings) {
      var tables;
      tables = warnings.map(function(warning) {
        return warning.table_name;
      });
      return "“" + (tables.join(', ')) + "” may refer to more than one table in the Sisense Cache. Please qualify with the appropriate schema and database names.";
    },
    determineErrorReferenceAndMessage: function(errorMsg) {
      var alertMsg, alertReference;
      alertReference = this.showAlertReferenceIfIdentified(errorMsg);
      alertMsg = alertReference ? errorMsg.replace('ERROR: ', '').replace('syntax error ', '') : errorMsg;
      return {
        alertReference: alertReference,
        alertMsg: alertMsg
      };
    },
    showAlertReferenceIfIdentified: function(errorMsg) {
      if (errorMsg.includes('syntax error')) {
        return 'Syntax Error:';
      }
    }
  };

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ArchivedWidgetController = (function(superClass) {
    extend(ArchivedWidgetController, superClass);

    ArchivedWidgetController.prototype.className = 'archived-widget-container';

    function ArchivedWidgetController() {
      ArchivedWidgetController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    ArchivedWidgetController.prototype.render = function() {
      return this.html(this.view('redesign/widgets/archived_widget')({
        title: this.item.title,
        chartType: this.item.chart_type
      }));
    };

    ArchivedWidgetController.prototype.renderIfInViewport = function() {};

    ArchivedWidgetController.prototype.changedSize = function() {};

    ArchivedWidgetController.prototype.returnToUnrenderedState = function() {};

    ArchivedWidgetController.prototype.update = function() {};

    return ArchivedWidgetController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAuthenticationSequenceController = (function(superClass) {
    extend(RedesignAuthenticationSequenceController, superClass);

    function RedesignAuthenticationSequenceController() {
      this.release = bind(this.release, this);
      this.releaseSoon = bind(this.releaseSoon, this);
      this.closeAuthForm = bind(this.closeAuthForm, this);
      this.showTwoFactorSetupForm = bind(this.showTwoFactorSetupForm, this);
      this.showSetPasswordForm = bind(this.showSetPasswordForm, this);
      this.maybeShowTwoFactorSetupForm = bind(this.maybeShowTwoFactorSetupForm, this);
      RedesignAuthenticationSequenceController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'setPassword', 'forgotPassword', 'setupTfa');
      this.maybeShowSetPasswordForm();
      if (!this.setPassword) {
        this.maybeShowTwoFactorSetupForm();
      }
    }

    RedesignAuthenticationSequenceController.prototype.maybeShowSetPasswordForm = function() {
      if (this.setPassword) {
        return this.showSetPasswordForm();
      }
    };

    RedesignAuthenticationSequenceController.prototype.maybeShowTwoFactorSetupForm = function() {
      if (this.setupTfa) {
        return this.showTwoFactorSetupForm();
      } else {
        return this.closeAuthForm();
      }
    };

    RedesignAuthenticationSequenceController.prototype.showSetPasswordForm = function() {
      this.setPasswordController = new App.RedesignSetPasswordFormController({
        el: App.Utils.appendFrame(this.el, 'tfa-wrapper'),
        forgotPassword: this.forgotPassword,
        closeCallback: this.maybeShowTwoFactorSetupForm
      });
      this.activeController = this.setPasswordController;
      return this.trigger('update-title');
    };

    RedesignAuthenticationSequenceController.prototype.showTwoFactorSetupForm = function() {
      this.twoFactorController = new App.RedesignTfaSetupForm({
        el: App.Utils.appendFrame(this.el, 'tfa-wrapper'),
        selfEnabled: this.selfEnabled,
        closeCallback: this.closeAuthForm
      });
      this.activeController = this.twoFactorController;
      return this.trigger('update-title');
    };

    RedesignAuthenticationSequenceController.prototype.closeAuthForm = function() {
      this.trigger('close');
      return this.releaseSoon();
    };

    RedesignAuthenticationSequenceController.prototype.releaseSoon = function() {
      return setTimeout(this.release, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignAuthenticationSequenceController.prototype.release = function() {
      var ref, ref1;
      RedesignAuthenticationSequenceController.__super__.release.apply(this, arguments);
      App.HotkeyManager.enable();
      if ((ref = this.setPasswordController) != null) {
        ref.release();
      }
      if ((ref1 = this.twoFactorController) != null) {
        ref1.release();
      }
      return typeof this.closeCallback === "function" ? this.closeCallback() : void 0;
    };

    RedesignAuthenticationSequenceController.prototype.getTitle = function() {
      var ref;
      return (ref = this.activeController) != null ? ref.getTitle() : void 0;
    };

    return RedesignAuthenticationSequenceController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignTfaSetupForm = (function(superClass) {
    extend(RedesignTfaSetupForm, superClass);

    RedesignTfaSetupForm.prototype.elements = {
      'input.vcode': 'codeInput',
      '.button.verify': 'verifyButtonEl',
      '.qrcode': 'qrCodeImage',
      '.vcode-message': 'vcodeMessage',
      '.errors': 'errorRow',
      '.tfa-area': 'dialogContent',
      '.button-row': 'buttonRow'
    };

    RedesignTfaSetupForm.prototype.events = {
      'click .verify.button': 'verifyClicked',
      'keydown input.vcode': 'checkNumeric',
      'keyup input.vcode': 'updateConfirmKeyup',
      'click .tfa-area': 'updateFormClick'
    };

    function RedesignTfaSetupForm() {
      this.close = bind(this.close, this);
      this.userUpdated = bind(this.userUpdated, this);
      this.applyProfileUpdates = bind(this.applyProfileUpdates, this);
      this.verifyClicked = bind(this.verifyClicked, this);
      this.updateConfirmKeyup = bind(this.updateConfirmKeyup, this);
      this.generateSuccessDialog = bind(this.generateSuccessDialog, this);
      this.handleServerResponse = bind(this.handleServerResponse, this);
      this.renderQRCode = bind(this.renderQRCode, this);
      this.generateQRCode = bind(this.generateQRCode, this);
      RedesignTfaSetupForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'selfEnabled');
      this.html(this.view('redesign/tfa/tfa_setup_form_sidebar_flow')({
        userEnabled: this.selfEnabled
      }));
      this.codeInput.trigger('focus');
      this.updateButtonState();
      App.HotkeyManager.disable();
      this.qrCodeLoaded = false;
      this.generateQRCode();
      App.User.currentUser().bind('update', this.userUpdated);
    }

    RedesignTfaSetupForm.prototype.generateQRCode = function() {
      return $.post("/users/get_qr_code", {
        client_site_id: App.Site.first().id
      }, this.renderQRCode);
    };

    RedesignTfaSetupForm.prototype.renderQRCode = function(response) {
      if ((response.uri != null) && (response.secret != null)) {
        this.qrCodeImage.css({
          'backgroundImage': "url(" + response.uri + ")"
        });
        this.secret = response.secret;
        this.qrCodeLoaded = true;
        return this.updateButtonState();
      } else if (response.error != null) {
        return this.showError(response.error);
      } else {
        return this.showError('Could not render QR Code. Please refresh and try again.');
      }
    };

    RedesignTfaSetupForm.prototype.onboardingPaneSubmit = function() {
      if (this.success) {
        if (this.closeCallback != null) {
          this.closeCallback();
        }
        return this.trigger('success');
      } else {
        return this.verifyClicked();
      }
    };

    RedesignTfaSetupForm.prototype.checkNumeric = function(e) {
      if ((e.which !== AppRedesign.KEYS.BACKSPACE) && (e.which < AppRedesign.KEYS.ZERO || e.which > AppRedesign.KEYS.NINE)) {
        return e.preventDefault();
      } else {
        return this.clearError();
      }
    };

    RedesignTfaSetupForm.prototype.inputLenValid = function() {
      return this.codeInput.val().trim().length === AppRedesign.VCODE_LENGTH;
    };

    RedesignTfaSetupForm.prototype.checkVerificationCode = function(enteredCode) {
      this.trigger('busy');
      return $.post("/users/setup_two_factor", {
        vcode: enteredCode,
        secret: this.secret,
        client_site_id: App.Site.first().id
      }, this.handleServerResponse);
    };

    RedesignTfaSetupForm.prototype.handleServerResponse = function(r) {
      if (r.error) {
        this.verifyButtonEl.addClass("disabled");
        this.codeInput.val("");
        return this.showError(r.error);
      } else if (r.success) {
        this.clearError();
        App.User.currentUser().unbind('update', this.userUpdated);
        if (r.codes != null) {
          this.backupCodes = r.codes;
          this.applyProfileUpdates(r);
          return this.generateSuccessDialog(this.backupCodes);
        } else {
          this.showError("There was a problem fetching backup codes.");
          return AppRedesign.logError(new Error('Could not get backup codes.'));
        }
      } else {
        return this.showError("An unexpected error has occurred. Please refresh and try again.");
      }
    };

    RedesignTfaSetupForm.prototype.generateSuccessDialog = function(backupCodes) {
      this.success = true;
      this.dialogContent.html(this.view('redesign/tfa/tfa_success_sidebar_flow')({
        userEnabled: this.selfEnabled,
        backupCodes: backupCodes
      }));
      this.proceedButton = this.el.find('.button.proceed');
      this.proceedButton.on('update click', this.close);
      this.trigger('stage-transition');
      return App.Utils.logFeature('tfa-success');
    };

    RedesignTfaSetupForm.prototype.updateConfirmKeyup = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        return this.verifyClicked();
      } else {
        return this.updateButtonState();
      }
    };

    RedesignTfaSetupForm.prototype.updateButtonState = function() {
      if (this.inputLenValid() && this.qrCodeLoaded) {
        return this.verifyButtonEl.removeClass("disabled");
      } else {
        return this.verifyButtonEl.addClass("disabled");
      }
    };

    RedesignTfaSetupForm.prototype.updateFormClick = function(e) {
      return e.stopPropagation();
    };

    RedesignTfaSetupForm.prototype.verifyClicked = function() {
      var code;
      code = this.codeInput.val().trim();
      if (code.length !== AppRedesign.VCODE_LENGTH) {
        return this.showError("Code should be " + AppRedesign.VCODE_LENGTH + " digits.");
      } else {
        return this.checkVerificationCode(code);
      }
    };

    RedesignTfaSetupForm.prototype.showError = function(message) {
      App.Utils.logFeature('tfa-error', {
        detail: message
      });
      this.codeInput.addClass('error');
      this.errorRow.html(message).slideDown();
      return this.trigger('error');
    };

    RedesignTfaSetupForm.prototype.clearError = function() {
      this.codeInput.removeClass('error');
      return this.errorRow.slideUp();
    };

    RedesignTfaSetupForm.prototype.applyProfileUpdates = function(response) {
      var user;
      user = response.user;
      if (user != null) {
        return App.User.applyUpdates([user]);
      } else {
        return this.showError('Error updating user profile, please try again later.');
      }
    };

    RedesignTfaSetupForm.prototype.userUpdated = function(user) {
      if (user.is_tfa_active) {
        App.User.currentUser().unbind('update', this.userUpdated);
        return this.close();
      }
    };

    RedesignTfaSetupForm.prototype.close = function() {
      if (this.closeCallback != null) {
        this.closeCallback();
      }
      this.trigger('success');
      return this.release();
    };

    RedesignTfaSetupForm.prototype.release = function() {
      if (this.RELEASED) {
        return;
      }
      this.RELEASED = true;
      App.HotkeyManager.enable();
      return RedesignTfaSetupForm.__super__.release.apply(this, arguments);
    };

    RedesignTfaSetupForm.prototype.getTitle = function() {
      return 'Two-Factor Authentication Setup';
    };

    return RedesignTfaSetupForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.BadgeToggleSettingsController = (function(superClass) {
    extend(BadgeToggleSettingsController, superClass);

    BadgeToggleSettingsController.prototype.className = 'badge-toggle-settings';

    function BadgeToggleSettingsController() {
      this.saveBadge = bind(this.saveBadge, this);
      this.badgeToggleClicked = bind(this.badgeToggleClicked, this);
      var ref;
      BadgeToggleSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'hasDetail');
      if ((ref = this.editHelper) != null) {
        ref.bind('saved', this.saveBadge);
      }
      this.render();
    }

    BadgeToggleSettingsController.prototype.release = function() {
      this.badgeToggleSettings.release();
      return BadgeToggleSettingsController.__super__.release.apply(this, arguments);
    };

    BadgeToggleSettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/badge_toggle_settings')({
        hasDetail: this.hasDetail
      }));
      this.toggleArea = this.el.find('.toggles-area');
      this.badgeToggleSettings = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.hasBadge(),
        labelWhenToggleOn: 'Mark as Official',
        labelWhenToggleOff: 'Mark as Official'
      });
      this.badgeToggleSettings.bind("toggled", this.badgeToggleClicked);
      return this.toggleArea.append(this.badgeToggleSettings.el);
    };

    BadgeToggleSettingsController.prototype.badgeToggleClicked = function(toggleState) {
      return this.item.trigger('badge-toggled', toggleState);
    };

    BadgeToggleSettingsController.prototype.hasBadge = function() {
      return App.Badge.isBadged(this.item);
    };

    BadgeToggleSettingsController.prototype.saveBadge = function() {
      var toggleState;
      toggleState = this.badgeToggleSettings.getToggleState();
      return App.Badge.toggleBadged(this.item, toggleState);
    };

    return BadgeToggleSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ContactUsModalController = (function(superClass) {
    extend(ContactUsModalController, superClass);

    function ContactUsModalController() {
      ContactUsModalController.__super__.constructor.apply(this, arguments);
      App.Site.trigger('enter-modal');
      this.render();
    }

    ContactUsModalController.prototype.render = function() {
      this.html(this.view('redesign/billing/contact_us_modal'));
      return $('#modal').empty().append(this.el);
    };

    ContactUsModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      App.PageOverlay.fadeOutPageOverlay();
      return ContactUsModalController.__super__.release.apply(this, arguments);
    };

    return ContactUsModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.OverageUpgradeModalController = (function(superClass) {
    extend(OverageUpgradeModalController, superClass);

    OverageUpgradeModalController.prototype.elements = {
      '.submit-button': 'submitButton',
      '.eula.checkbox': 'eulaCheckbox',
      '.error-row .errors': 'error'
    };

    OverageUpgradeModalController.prototype.events = {
      'click .submit-button': 'submit',
      'click .cancel-button': 'close',
      'click .eula.checkbox': 'checkboxClick'
    };

    function OverageUpgradeModalController() {
      this.currentYear = bind(this.currentYear, this);
      this.currentDate = bind(this.currentDate, this);
      this.currentMonth = bind(this.currentMonth, this);
      this.currentDateForRenewal = bind(this.currentDateForRenewal, this);
      this.checkboxClick = bind(this.checkboxClick, this);
      this.toggleSubmitButton = bind(this.toggleSubmitButton, this);
      this.submit = bind(this.submit, this);
      this.close = bind(this.close, this);
      OverageUpgradeModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'newPlanPrice', 'displayName');
      this.render();
    }

    OverageUpgradeModalController.prototype.render = function() {
      this.html(this.view('redesign/billing/overage_upgrade_modal')({
        newPlanPrice: this.newPlanPrice,
        currentDay: this.currentDateForRenewal(),
        customerName: this.displayName
      }));
      return this.submitButton.addClass('disabled');
    };

    OverageUpgradeModalController.prototype.close = function() {
      return this.trigger('close');
    };

    OverageUpgradeModalController.prototype.submit = function() {
      if (!this.validateEulaChecked()) {
        return;
      }
      App.Utils.logFeature('butter-bar-upgrade-accepted');
      this.trigger('success');
      return this.trigger('close');
    };

    OverageUpgradeModalController.prototype.toggleSubmitButton = function() {
      if (this.eulaCheckbox.hasClass('selected')) {
        return this.submitButton.removeClass('disabled');
      } else {
        return this.submitButton.addClass('disabled');
      }
    };

    OverageUpgradeModalController.prototype.checkboxClick = function(e) {
      this.eulaCheckbox.toggleClass('selected');
      return this.toggleSubmitButton();
    };

    OverageUpgradeModalController.prototype.validateEulaChecked = function() {
      return this.eulaCheckbox.hasClass('selected');
    };

    OverageUpgradeModalController.prototype.currentDateForRenewal = function() {
      var date;
      date = new Date();
      return (this.currentMonth(date)) + "/" + (this.currentDate(date)) + "/" + (this.currentYear(date));
    };

    OverageUpgradeModalController.prototype.currentMonth = function(date) {
      var month;
      month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      return month;
    };

    OverageUpgradeModalController.prototype.currentDate = function(date) {
      date = date.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      return date;
    };

    OverageUpgradeModalController.prototype.currentYear = function(date) {
      return date.getFullYear();
    };

    return OverageUpgradeModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignTrialExtensionController = (function(superClass) {
    extend(RedesignTrialExtensionController, superClass);

    RedesignTrialExtensionController.prototype.className = 'trial-extension-area';

    RedesignTrialExtensionController.prototype.elements = {
      '.reason-field': 'reasonField',
      '.trial-extension-body': 'extensionBody',
      '.trial-extension-link': 'trialExtensionLink'
    };

    RedesignTrialExtensionController.prototype.events = {
      'click  .trial-extension-link': 'showBody',
      'click  .undo-extension-link': 'hideBody',
      'keyup .reason-field': 'onReasonKeyPress'
    };

    RedesignTrialExtensionController.SUBMIT_TEXT = 'EXTEND TRIAL';

    function RedesignTrialExtensionController() {
      this.isReasonBlank = bind(this.isReasonBlank, this);
      this.updateSiteWithReason = bind(this.updateSiteWithReason, this);
      this.render = bind(this.render, this);
      RedesignTrialExtensionController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'submitButton');
      this.render();
    }

    RedesignTrialExtensionController.prototype.render = function() {
      return this.html(this.view('redesign/billing/trial_extension')({
        days: App.Site.first().trial_extension_duration_days_with_default
      }));
    };

    RedesignTrialExtensionController.prototype.onReasonKeyPress = function() {
      return this.submitButton.toggleClass('disabled', this.isReasonBlank());
    };

    RedesignTrialExtensionController.prototype.submit = function() {
      if (this.isReasonBlank()) {
        return;
      }
      this.updateSiteWithReason();
      return this.trigger('submit-complete', true);
    };

    RedesignTrialExtensionController.prototype.showBody = function() {
      this.trialExtensionLink.hide();
      this.extensionBody.slideDown();
      this.reasonField.trigger('focus');
      this.onReasonKeyPress();
      return this.trigger('form-changed', true);
    };

    RedesignTrialExtensionController.prototype.hideBody = function() {
      this.extensionBody.slideUp(300);
      setTimeout(((function(_this) {
        return function() {
          return _this.trialExtensionLink.slideDown();
        };
      })(this)), 300);
      return this.trigger('form-changed', false);
    };

    RedesignTrialExtensionController.prototype.updateSiteWithReason = function() {
      var site;
      site = App.Site.first();
      site.trial_extension_started_at = (new Date()).toISOString();
      site.trial_extension_reason = this.reasonField.val();
      return site.save();
    };

    RedesignTrialExtensionController.prototype.isReasonBlank = function() {
      return this.reasonField.val().trim() === '';
    };

    return RedesignTrialExtensionController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RowOverageUpgradeController = (function(superClass) {
    extend(RowOverageUpgradeController, superClass);

    RowOverageUpgradeController.prototype.elements = {
      '.upgrade-button': 'upgradeButton'
    };

    RowOverageUpgradeController.prototype.events = {
      'click .upgrade-button': 'clickUpgrade'
    };

    function RowOverageUpgradeController() {
      RowOverageUpgradeController.__super__.constructor.apply(this, arguments);
      this.overageData = AppRedesign.current().overageData;
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/billing/upgrade_billing_form')({
        currentPlanPrice: this.currentPlanPrice(),
        newPlanPrice: this.newPlanPrice(),
        overages: this.overages(),
        totals: _(this.overages()).map(_.method('formattedNewCount')).join(', ')
      }));
    }

    RowOverageUpgradeController.prototype.overages = function() {
      return _.compact([this.rowOverage(), this.userOverage(), this.spaceOverage(), this.embedApiHitsOverage(), this.cachedRowsOverage(), this.creatorOverage(), this.explorerOverage()]);
    };

    RowOverageUpgradeController.prototype.rowOverage = function() {
      return this._rowOverage != null ? this._rowOverage : this._rowOverage = this.overage('rows');
    };

    RowOverageUpgradeController.prototype.userOverage = function() {
      return this._userOverage != null ? this._userOverage : this._userOverage = this.overage('users');
    };

    RowOverageUpgradeController.prototype.spaceOverage = function() {
      return this._spaceOverage != null ? this._spaceOverage : this._spaceOverage = this.overage('spaces');
    };

    RowOverageUpgradeController.prototype.embedApiHitsOverage = function() {
      return this._embedApiHitsOverage != null ? this._embedApiHitsOverage : this._embedApiHitsOverage = this.overage('embed_api_hits');
    };

    RowOverageUpgradeController.prototype.cachedRowsOverage = function() {
      return this._cachedRowsOverage != null ? this._cachedRowsOverage : this._cachedRowsOverage = this.overage('cached_rows');
    };

    RowOverageUpgradeController.prototype.cachedStorageOverage = function() {
      return this._cachedStorageOverage != null ? this._cachedStorageOverage : this._cachedStorageOverage = this.overage('cached_storage');
    };

    RowOverageUpgradeController.prototype.creatorOverage = function() {
      return this._creatorOverage != null ? this._creatorOverage : this._creatorOverage = this.overage('creators');
    };

    RowOverageUpgradeController.prototype.explorerOverage = function() {
      return this._explorerOverage != null ? this._explorerOverage : this._explorerOverage = this.overage('explorers');
    };

    RowOverageUpgradeController.prototype.overage = function(overageName) {
      var classNamePrefix, specificOverage, thisOverageData;
      thisOverageData = this.overageData[overageName];
      if (thisOverageData == null) {
        return;
      }
      classNamePrefix = _.upperFirst(_.camelCase(overageName));
      specificOverage = new this.constructor[classNamePrefix + "OverageData"](thisOverageData);
      return new this.constructor.UpgradePresenter(specificOverage);
    };

    RowOverageUpgradeController.prototype.clickUpgrade = function() {
      var overageUpgradeModalController;
      overageUpgradeModalController = new App.OverageUpgradeModalController({
        displayName: App.Site.first().display_name,
        newPlanPrice: this.newPlanPrice()
      });
      this.dashboardPreferencesDialog = App.RedesignDialog.createDialog({
        customDialogClass: 'overage-upgrade-container',
        title: 'Upgrade',
        viewController: overageUpgradeModalController
      });
      return overageUpgradeModalController.bind('success', this.upgrade.bind(this));
    };

    RowOverageUpgradeController.prototype.upgrade = function() {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6;
      jQuery.ajax({
        data: {
          client_site_id: App.Site.first().id,
          new_price: this.newPlanPrice(),
          new_row_total: (ref = this.rowOverage()) != null ? ref.newCount() : void 0,
          new_space_total: (ref1 = this.spaceOverage()) != null ? ref1.newCount() : void 0,
          new_user_total: (ref2 = this.userOverage()) != null ? ref2.newCount() : void 0,
          new_creator_total: (ref3 = this.creatorOverage()) != null ? ref3.newCount() : void 0,
          new_explorer_total: (ref4 = this.explorerOverage()) != null ? ref4.newCount() : void 0,
          new_embed_api_hits_total: (ref5 = this.embedApiHitsOverage()) != null ? ref5.newCount() : void 0,
          new_cached_rows_total: (ref6 = this.cachedRowsOverage()) != null ? ref6.newCount() : void 0
        },
        method: 'post',
        url: '/billing_upgrade/upgrade'
      });
      return this.trigger('close');
    };

    RowOverageUpgradeController.UpgradePresenter = (function() {
      function UpgradePresenter(specificPresenter) {
        this.specificPresenter = specificPresenter;
      }

      UpgradePresenter.prototype.noun = function() {
        return this.specificPresenter.noun();
      };

      UpgradePresenter.prototype.planMax = function() {
        return this.specificPresenter.planMax();
      };

      UpgradePresenter.prototype.currentCount = function() {
        return this.specificPresenter.currentCount();
      };

      UpgradePresenter.prototype.additionalCount = function() {
        return this.format(this.specificPresenter.planMaxIncrement() * this.incrementMultiple());
      };

      UpgradePresenter.prototype.overBy = function() {
        return this.specificPresenter.rawCurrentCount() - this.specificPresenter.rawPlanMax();
      };

      UpgradePresenter.prototype.additionalCost = function() {
        return this.specificPresenter.planMaxIncrementCost() * this.incrementMultiple();
      };

      UpgradePresenter.prototype.formattedNewCount = function() {
        return (this.format(this.newCount())) + " " + (this.noun());
      };

      UpgradePresenter.prototype.newCount = function() {
        return this.specificPresenter.rawPlanMax() + this.specificPresenter.planMaxIncrement() * this.incrementMultiple();
      };

      UpgradePresenter.prototype.incrementMultiple = function() {
        return this._incrementMultiple || (this._incrementMultiple = Math.ceil(this.overBy() / this.specificPresenter.planMaxIncrement()));
      };

      UpgradePresenter.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return UpgradePresenter;

    })();

    RowOverageUpgradeController.RowsOverageData = (function() {
      function RowsOverageData(rowsOverageData) {
        _.merge(this, rowsOverageData);
      }

      RowsOverageData.prototype.noun = function() {
        return 'Rows';
      };

      RowsOverageData.prototype.planMax = function() {
        return this.format(this.max_rows);
      };

      RowsOverageData.prototype.currentCount = function() {
        return this.format(this.current_rows);
      };

      RowsOverageData.prototype.rawCurrentCount = function() {
        return this.current_rows;
      };

      RowsOverageData.prototype.rawPlanMax = function() {
        return this.max_rows;
      };

      RowsOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_rows_increment;
      };

      RowsOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_rows_increment_cost;
      };

      RowsOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return RowsOverageData;

    })();

    RowOverageUpgradeController.SpacesOverageData = (function() {
      function SpacesOverageData(spacesOverageData) {
        this.spacesOverageData = spacesOverageData;
        _.merge(this, this.spacesOverageData);
      }

      SpacesOverageData.prototype.noun = function() {
        return 'Spaces';
      };

      SpacesOverageData.prototype.planMax = function() {
        return this.plan_max_spaces;
      };

      SpacesOverageData.prototype.currentCount = function() {
        return this.current_spaces;
      };

      SpacesOverageData.prototype.rawCurrentCount = function() {
        return this.current_spaces;
      };

      SpacesOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_spaces;
      };

      SpacesOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_spaces_increment;
      };

      SpacesOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_spaces_increment_cost;
      };

      return SpacesOverageData;

    })();

    RowOverageUpgradeController.UsersOverageData = (function() {
      function UsersOverageData(usersOverageData) {
        _.merge(this, usersOverageData);
      }

      UsersOverageData.prototype.noun = function() {
        return 'Users';
      };

      UsersOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_users);
      };

      UsersOverageData.prototype.currentCount = function() {
        return this.format(this.current_users);
      };

      UsersOverageData.prototype.rawCurrentCount = function() {
        return this.current_users;
      };

      UsersOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_users;
      };

      UsersOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_users_increment;
      };

      UsersOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_users_increment_cost;
      };

      UsersOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return UsersOverageData;

    })();

    RowOverageUpgradeController.CreatorsOverageData = (function() {
      function CreatorsOverageData(creatorsOverageData) {
        _.merge(this, creatorsOverageData);
      }

      CreatorsOverageData.prototype.noun = function() {
        return 'Creators';
      };

      CreatorsOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_creators);
      };

      CreatorsOverageData.prototype.currentCount = function() {
        return this.format(this.current_creators);
      };

      CreatorsOverageData.prototype.rawCurrentCount = function() {
        return this.current_creators;
      };

      CreatorsOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_creators;
      };

      CreatorsOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_creators_increment;
      };

      CreatorsOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_creators_increment_cost;
      };

      CreatorsOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return CreatorsOverageData;

    })();

    RowOverageUpgradeController.ExplorersOverageData = (function() {
      function ExplorersOverageData(explorersOverageData) {
        _.merge(this, explorersOverageData);
      }

      ExplorersOverageData.prototype.noun = function() {
        return 'Explorers';
      };

      ExplorersOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_explorers);
      };

      ExplorersOverageData.prototype.currentCount = function() {
        return this.format(this.current_explorers);
      };

      ExplorersOverageData.prototype.rawCurrentCount = function() {
        return this.current_explorers;
      };

      ExplorersOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_explorers;
      };

      ExplorersOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_explorers_increment;
      };

      ExplorersOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_explorers_increment_cost;
      };

      ExplorersOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return ExplorersOverageData;

    })();

    RowOverageUpgradeController.EmbedApiHitsOverageData = (function() {
      function EmbedApiHitsOverageData(embedApiHitsOverageData) {
        _.merge(this, embedApiHitsOverageData);
      }

      EmbedApiHitsOverageData.prototype.noun = function() {
        return 'Embed API Calls';
      };

      EmbedApiHitsOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_embed_api_hits);
      };

      EmbedApiHitsOverageData.prototype.currentCount = function() {
        return this.format(this.current_monthly_hits);
      };

      EmbedApiHitsOverageData.prototype.rawCurrentCount = function() {
        return this.current_monthly_hits;
      };

      EmbedApiHitsOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_embed_api_hits;
      };

      EmbedApiHitsOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_embed_api_hits_increment;
      };

      EmbedApiHitsOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_embed_api_hits_increment_cost;
      };

      EmbedApiHitsOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return EmbedApiHitsOverageData;

    })();

    RowOverageUpgradeController.CachedRowsOverageData = (function() {
      function CachedRowsOverageData(cachedRowsOverageData) {
        _.merge(this, cachedRowsOverageData);
      }

      CachedRowsOverageData.prototype.noun = function() {
        return 'Cached Rows';
      };

      CachedRowsOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_cached_rows);
      };

      CachedRowsOverageData.prototype.currentCount = function() {
        return this.format(this.current_cached_rows);
      };

      CachedRowsOverageData.prototype.rawCurrentCount = function() {
        return this.current_cached_rows;
      };

      CachedRowsOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_cached_rows;
      };

      CachedRowsOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_cached_rows_increment;
      };

      CachedRowsOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_cached_rows_increment_cost;
      };

      CachedRowsOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return CachedRowsOverageData;

    })();

    RowOverageUpgradeController.CachedStorageOverageData = (function() {
      function CachedStorageOverageData(cachedStorageOverageData) {
        _.merge(this, cachedStorageOverageData);
      }

      CachedStorageOverageData.prototype.noun = function() {
        return 'Cached GBs';
      };

      CachedStorageOverageData.prototype.planMax = function() {
        return this.format(this.plan_max_cached_storage);
      };

      CachedStorageOverageData.prototype.currentCount = function() {
        return this.format(this.current_cached_storage);
      };

      CachedStorageOverageData.prototype.rawCurrentCount = function() {
        return this.current_cached_storage;
      };

      CachedStorageOverageData.prototype.rawPlanMax = function() {
        return this.plan_max_cached_storage;
      };

      CachedStorageOverageData.prototype.planMaxIncrement = function() {
        return this.plan_max_cached_storage_increment;
      };

      CachedStorageOverageData.prototype.planMaxIncrementCost = function() {
        return this.plan_max_cached_storage_increment_cost;
      };

      CachedStorageOverageData.prototype.format = function(value) {
        return App.Utils.scaleDisplayNumber(value, 3);
      };

      return CachedStorageOverageData;

    })();

    RowOverageUpgradeController.prototype.newPlanPrice = function() {
      return this.currentPlanPrice() + _.sumBy(this.overages(), _.method('additionalCost'));
    };

    RowOverageUpgradeController.prototype.currentPlanPrice = function() {
      return AppRedesign.current().overageData.current_plan_price;
    };

    return RowOverageUpgradeController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ZuoraBillingFormController = (function(superClass) {
    extend(ZuoraBillingFormController, superClass);

    ZuoraBillingFormController.prototype.elements = {
      '.onboarding-billing.form': 'billingForm',
      '.row.price': 'rowPrice'
    };

    ZuoraBillingFormController.prototype.events = {
      'submit #stripe-billing-form': 'submit'
    };

    function ZuoraBillingFormController() {
      var ref;
      ZuoraBillingFormController.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/billing/zuora_billing_form')({
        onboarding: this.onboarding
      }));
      this.billingHelper = new App.ZuoraBillingHelper({
        el: this.billingForm,
        planAreaTemplate: 'redesign/billing/zuora_plan_name',
        overrideAndShowPlan: true,
        submitButton: this.submitButton,
        submitButtonText: 'Pay Securely',
        planArea: (ref = this.planArea) != null ? ref : this.el.find('.plan-area')
      });
      this.bubbles(this.billingHelper, 'submit-complete error');
      this.billingHelper.populateForm();
    }

    ZuoraBillingFormController.prototype.release = function() {
      this.billingHelper.logBilling();
      return ZuoraBillingFormController.__super__.release.apply(this, arguments);
    };

    ZuoraBillingFormController.prototype.submit = function(e) {
      return this.billingHelper.submit(e);
    };

    return ZuoraBillingFormController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ZuoraBillingHelper = (function(superClass) {
    extend(ZuoraBillingHelper, superClass);

    ZuoraBillingHelper.prototype.elements = {
      '.stripe-billing-form': 'stripeBillingForm',
      'input.email': 'emailInput',
      'input.creditCardNumber': 'cardNumberInput',
      'input.expirationYear': 'expYearInput',
      'input.expirationMonth': 'expMonthInput',
      'input.securityCode': 'cvcInput',
      'input.coupon': 'couponInput',
      'input.zipCode': 'zipcodeInput',
      'input.cardHolderName': 'nameInput',
      '.coupon-area': 'couponArea',
      '.errors': 'errorRow',
      '.cardTypes': 'cardTypes'
    };

    ZuoraBillingHelper.prototype.events = {
      'keyup input': 'inputChanged',
      'keyup input.coupon': 'couponInputChanged'
    };

    ZuoraBillingHelper.MASKED_CC_NUMBER = "****************";

    ZuoraBillingHelper.COUPON_CODE = 'SCOPE255';

    ZuoraBillingHelper.SUBMIT_TEXT = 'PAY SECURELY';

    ZuoraBillingHelper.CARD_TYPES = [
      {
        labelClass: 'visa',
        value: 'Visa'
      }, {
        labelClass: 'mastercard',
        value: 'MasterCard'
      }, {
        labelClass: 'american-express',
        value: 'AmericanExpress'
      }, {
        labelClass: 'discover',
        value: 'Discover'
      }
    ];

    function ZuoraBillingHelper() {
      this.cancelClick = bind(this.cancelClick, this);
      this.handleServerError = bind(this.handleServerError, this);
      this.handleServerSuccess = bind(this.handleServerSuccess, this);
      var ref, ref1, ref2;
      ZuoraBillingHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'planAreaTemplate', 'overrideAndShowPlan');
      if ((ref = this.submitButton) != null) {
        ref.addClass('disabled');
      }
      if ((ref1 = this.cancelButton) != null) {
        ref1.addClass('disabled');
      }
      if ((ref2 = this.cancelButton) != null) {
        ref2.on('click', this.cancelClick);
      }
      this.renderRadioButtons();
    }

    ZuoraBillingHelper.prototype.renderRadioButtons = function() {
      var cardTypesRadio;
      this.cardType = "Visa";
      cardTypesRadio = new App.RedesignRadioButtonGroup({
        radioOptions: this.constructor.CARD_TYPES,
        defaultValue: "Visa",
        callback: ((function(_this) {
          return function(value) {
            return _this.cardType = value;
          };
        })(this))
      });
      return this.cardTypes.append(cardTypesRadio.el);
    };

    ZuoraBillingHelper.prototype.touchedFormFields = function() {
      return _(['emailInput', 'cardNumberInput', 'expMonthInput', 'expYearInput', 'cvcInput', 'couponInput', 'zipcodeInput', 'nameInput']).map((function(_this) {
        return function(field) {
          if (_this[field].val()) {
            return field;
          }
        };
      })(this)).filter().values();
    };

    ZuoraBillingHelper.prototype.logBilling = function() {
      if (!(this.submitSuccess || App.Site.first().isPayingCustomer())) {
        return App.Utils.logFeature('billing-closed-without-payment', {
          detail: this.touchedFormFields().join(",")
        });
      }
    };

    ZuoraBillingHelper.prototype.populateForm = function() {
      var ref, site;
      site = App.Site.first();
      if (site.billing_email != null) {
        this.setValueAndInnerLabel(this.emailInput, site.billing_email);
      } else {
        this.setValueAndInnerLabel(this.emailInput, (ref = App.User.currentUser()) != null ? ref.email_address : void 0);
      }
      if (site.isPayingCustomer() && !this.overrideAndShowPlan) {
        this.planArea.hide();
        this.couponArea.hide();
      } else {
        this.populatePlanText();
        if (site.stripe_monthly_amount_discounted == null) {
          this.couponArea.hide();
        }
      }
      if (site.isPayingCustomer()) {
        this.setValueAndInnerLabel(this.cardNumberInput, this.constructor.MASKED_CC_NUMBER);
        this.setValueAndInnerLabel(this.expMonthInput, "**");
        this.setValueAndInnerLabel(this.expYearInput, "****");
        this.setValueAndInnerLabel(this.cvcInput, "***");
        this.setValueAndInnerLabel(this.nameInput, '*******');
        return this.setValueAndInnerLabel(this.zipcodeInput, '*****');
      }
    };

    ZuoraBillingHelper.prototype.setValueAndInnerLabel = function(el, val) {
      el.val(val);
      return el.next('.inner-label').addClass('show');
    };

    ZuoraBillingHelper.prototype.couponOk = function() {
      return this.couponInput.val().toUpperCase() === this.constructor.COUPON_CODE;
    };

    ZuoraBillingHelper.prototype.populatePlanText = function() {
      var site;
      site = App.Site.first();
      return this.planArea.html(this.view(this.planAreaTemplate)({
        base: site.stripe_monthly_amount,
        discount: site.stripe_monthly_amount_discounted,
        showMonthlyPrice: !!this.showMonthlyPrice,
        showPlanPrefix: !this.hidePlanPrefix
      }));
    };

    ZuoraBillingHelper.prototype.validateField = function(el, digits) {
      return el.val() !== _.repeat('*', digits);
    };

    ZuoraBillingHelper.prototype.validateForm = function() {
      if (!this.validateField(this.expMonthInput, 2)) {
        return 'Please enter a valid month';
      }
      if (!this.validateField(this.expYearInput, 4)) {
        return 'Please enter a valid year';
      }
      if (!this.validateField(this.cvcInput, 3)) {
        return 'Please enter a valid CVC';
      }
      if (this.emailInput.val().trim() === "") {
        return 'Please enter a valid email address';
      }
    };

    ZuoraBillingHelper.prototype.resetDoneButton = function() {
      if ((this.submitButton != null) && (this.submitButtonText != null)) {
        return this.submitButton.text(this.submitButtonText);
      }
    };

    ZuoraBillingHelper.prototype.inputChanged = function(e) {
      var inputNotEmpty, inputTarget, ref, ref1, ref2;
      if ((ref = this.submitButton) != null) {
        ref.removeClass('disabled');
      }
      if ((ref1 = this.cancelButton) != null) {
        ref1.removeClass('disabled');
      }
      inputTarget = $(e.target);
      inputNotEmpty = ((ref2 = inputTarget.val()) != null ? ref2.length : void 0) > 0;
      return inputTarget.next('.inner-label').toggleClass('show', inputNotEmpty);
    };

    ZuoraBillingHelper.prototype.couponInputChanged = function() {
      return this.el.toggleClass('coupon-ok', this.couponOk());
    };

    ZuoraBillingHelper.prototype.submit = function(event) {
      var params, valError;
      if (event != null) {
        event.preventDefault();
      }
      valError = this.validateForm();
      if (!valError) {
        this.clearError();
      }
      if (!this.checkIfSubmitEnabled()) {
        return;
      }
      if (valError != null) {
        this.resetDoneButton();
        this.error(valError, true);
        return;
      }
      params = {
        client_site_id: App.Site.first().id,
        form_fields: this.prepareForm()
      };
      return $.post("/zuora_credit_cards", params).fail(this.handleServerError).done(this.handleServerSuccess);
    };

    ZuoraBillingHelper.prototype.prepareForm = function() {
      return {
        creditCardNumber: this.cardNumberInput.val(),
        expirationMonth: this.expMonthInput.val(),
        expirationYear: this.expYearInput.val(),
        securityCode: this.cvcInput.val(),
        creditCardType: this.cardType,
        cardHolderInfo: {
          cardHolderName: this.nameInput.val(),
          email: this.emailInput.val(),
          zipCode: this.zipcodeInput.val()
        }
      };
    };

    ZuoraBillingHelper.prototype.checkIfSubmitEnabled = function() {
      if (this.submitButton == null) {
        return true;
      }
      if (this.submitButton.hasClass('disabled')) {
        this.error('Please edit payment information.');
        return false;
      }
      this.submitButton.html('Loading');
      return true;
    };

    ZuoraBillingHelper.prototype.clearError = function() {
      if (this.noAnimateErrors) {
        return this.errorRow.hide();
      } else {
        return this.errorRow.slideUp();
      }
    };

    ZuoraBillingHelper.prototype.handleServerSuccess = function() {
      var ref, ref1, site;
      jQuery.post("/sites/" + (App.Site.first().id) + "/bill_success", {
        email: this.emailInput.val(),
        use_discount: this.couponOk()
      });
      site = App.Site.first();
      site.has_credit_card = true;
      site.save({
        ajax: false
      });
      App.Utils.logFeature('billing-success');
      if ((ref = this.submitButton) != null) {
        ref.addClass('disabled');
      }
      if ((ref1 = this.cancelButton) != null) {
        ref1.addClass('disabled');
      }
      this.resetDoneButton();
      this.clearError();
      this.trigger('submit-complete', true);
      return this.submitSuccess = true;
    };

    ZuoraBillingHelper.prototype.handleServerError = function(response) {
      App.Utils.logFeature('billing-show-error', {
        detail: response.responseJSON.errors,
        context: 'zuora'
      });
      return this.displayError(this.prettyError(response.responseJSON.errors.base[0]));
    };

    ZuoraBillingHelper.prototype.prettyError = function(rawError) {
      var error;
      error = _.replace(rawError, "'cardHolderInfo.email'", 'Email is');
      error = _.replace(error, "'expirationMonth'", 'Month');
      error = _.replace(error, "'expirationYear'", 'Year');
      error = _.replace(error, "'securityCode'", 'Year');
      if (_.includes(error, 'incorrect_number') || _.includes(error, 'invalid_number')) {
        error = "The card number is not a valid credit card number.";
      }
      if (_.includes(error, 'Cannot find entity by key')) {
        error = "Billing account not found, please contact your sales rep.";
      }
      return error;
    };

    ZuoraBillingHelper.prototype.displayError = function(errorText) {
      this.resetDoneButton();
      this.error(errorText);
      return this.trigger('submit-complete', false);
    };

    ZuoraBillingHelper.prototype.error = function(e, validationMode) {
      this.trigger('error');
      this.errorRow.html(e + "<br/><br/>");
      if (this.noAnimateErrors || validationMode) {
        return this.errorRow.show();
      } else {
        return this.errorRow.slideDown();
      }
    };

    ZuoraBillingHelper.prototype.cancelClick = function() {
      var ref, ref1;
      this.populateForm();
      if ((ref = this.submitButton) != null) {
        ref.addClass('disabled');
      }
      return (ref1 = this.cancelButton) != null ? ref1.addClass('disabled') : void 0;
    };

    return ZuoraBillingHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ZuoraBillingModalController = (function(superClass) {
    extend(ZuoraBillingModalController, superClass);

    ZuoraBillingModalController.prototype.className = 'onboarding-wizard';

    ZuoraBillingModalController.prototype.elements = {
      '.button .label': 'buttonLabel',
      '.submit.button': 'submitButton',
      '.onboarding-main-column': 'onboardingMainColumn',
      '.onboarding-sidebar': 'sidebar',
      '.onboarding-body-content': 'bodyContent',
      '.onboarding-body': 'body',
      '.plan-area': 'planArea',
      '.button.cancel': 'cancelButton'
    };

    ZuoraBillingModalController.prototype.events = {
      'click .button.submit': 'submit',
      'click .button.cancel': 'cancel'
    };

    ZuoraBillingModalController.DONE_DELAY = 1000;

    ZuoraBillingModalController.CSS_BUSY_BUTTON = 'busy-button-spinner';

    function ZuoraBillingModalController() {
      this.endBusyState = bind(this.endBusyState, this);
      this.startBusyState = bind(this.startBusyState, this);
      this.formSubmitted = bind(this.formSubmitted, this);
      ZuoraBillingModalController.__super__.constructor.apply(this, arguments);
      App.Site.trigger('enter-modal');
      this.html(this.view('redesign/billing/billing_frame')());
      this.render();
    }

    ZuoraBillingModalController.prototype.render = function() {
      this.addSideBar();
      this.addBillingPane();
      this.addReactBillingComponent();
      if (this.showCancel) {
        return this.cancelButton.show();
      }
    };

    ZuoraBillingModalController.prototype.addSideBar = function() {
      return this.sidebar.html(this.view('redesign/onboarding/sidebar_billing')({
        salesOwnerName: App.Site.first().sales_owner_name,
        salesOwnerEmail: App.Site.first().sales_owner_email,
        supportEmail: App.Site.DEFAULT_SUPPORT_EMAIL
      }));
    };

    ZuoraBillingModalController.prototype.addBillingPane = function() {
      this.billingController = new App.ZuoraBillingFormController({
        el: App.RedesignOnboardingPane.createControllerEl(),
        submitButton: this.submitButton,
        planArea: this.planArea
      });
      this.billingController.bind('error', this.endBusyState);
      this.billingController.bind('submit-complete', this.formSubmitted);
      this.bodyContent.append(this.billingController.el);
      this.body.addClass('billing-pane');
      return App.RedesignDialog.createDialog({
        title: '',
        viewController: this,
        warning: false,
        noCancel: true,
        customDialogClass: 'onboarding-wizard-dialog',
        noAnimationOpen: true,
        closeCallback: null
      });
    };

    ZuoraBillingModalController.prototype.addReactBillingComponent = function() {
      var data, ref;
      data = {
        clientSiteId: App.Site.first().id,
        stripeMonthlyAmount: App.Site.first().stripe_monthly_amount,
        billingEmailFromSpine: App.Site.first().billing_email,
        removeDialog: this.release,
        blockingModal: true
      };
      this.reactElement = (ref = this.el) != null ? ref.find('.billing-react-div')[0] : void 0;
      return this.reactRoot = window.reactApp.billingForm(this.reactElement, data);
    };

    ZuoraBillingModalController.prototype.formSubmitted = function(successful) {
      if (successful) {
        this.submitButton.removeClass(this.constructor.CSS_BUSY_BUTTON).addClass('done');
        return setTimeout(this.release, App.RedesignOnboardingPane.DONE_DELAY);
      }
    };

    ZuoraBillingModalController.prototype.cancel = function() {
      return this.release();
    };

    ZuoraBillingModalController.prototype.submit = function() {
      if (this.busy) {
        return;
      }
      this.startBusyState();
      return this.billingController.submit();
    };

    ZuoraBillingModalController.prototype.startBusyState = function() {
      this.busy = true;
      return this.submitButton.addClass(this.constructor.CSS_BUSY_BUTTON);
    };

    ZuoraBillingModalController.prototype.endBusyState = function() {
      this.busy = false;
      return this.submitButton.removeClass(this.constructor.CSS_BUSY_BUTTON);
    };

    ZuoraBillingModalController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      this.trigger('close');
      this.billingController.release();
      App.Site.trigger('exit-modal');
      return ZuoraBillingModalController.__super__.release.apply(this, arguments);
    };

    return ZuoraBillingModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ZuoraSettingsBillingFormController = (function(superClass) {
    extend(ZuoraSettingsBillingFormController, superClass);

    ZuoraSettingsBillingFormController.prototype.className = 'billing form';

    ZuoraSettingsBillingFormController.prototype.elements = {
      '.stripe-billing-form': 'billingForm',
      '.done.button': 'doneButton',
      '.cancel.button': 'cancelButton',
      '.button-row': 'buttonRow',
      '.plan-area': 'planArea'
    };

    function ZuoraSettingsBillingFormController() {
      var data, ref;
      ZuoraSettingsBillingFormController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      if (App.Site.first().stripe_monthly_amount != null) {
        this.html(this.view('redesign/billing/zuora_billing_form')({
          notModal: true
        }));
        data = {
          clientSiteId: App.Site.first().id,
          stripeMonthlyAmount: App.Site.first().stripe_monthly_amount,
          billingEmailFromSpine: App.Site.first().billing_email
        };
        this.reactElement = (ref = this.el) != null ? ref.find('.billing-react-div')[0] : void 0;
        this.reactRoot = window.reactApp.billingPageRoot(this.reactElement, data);
      } else {
        this.html(this.view('redesign/billing/zuora_billing_not_enabled')({
          salesOwnerName: App.Site.first().sales_owner_name,
          salesOwnerEmail: App.Site.first().sales_owner_email,
          supportEmail: App.Site.DEFAULT_SUPPORT_EMAIL
        }));
      }
    }

    ZuoraSettingsBillingFormController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return ZuoraSettingsBillingFormController.__super__.release.apply(this, arguments);
    };

    return ZuoraSettingsBillingFormController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ButtonBlock = (function(superClass) {
    extend(ButtonBlock, superClass);

    function ButtonBlock() {
      this.cancelClick = bind(this.cancelClick, this);
      this.actionClick = bind(this.actionClick, this);
      this.deleteOrDiscardClick = bind(this.deleteOrDiscardClick, this);
      this.showDelete = bind(this.showDelete, this);
      this.showDeleteClick = bind(this.showDeleteClick, this);
      return ButtonBlock.__super__.constructor.apply(this, arguments);
    }

    ButtonBlock.prototype.className = 'button-block';

    ButtonBlock.prototype.elements = {
      '.destructive-large .label': 'destructiveLabel',
      '.action.button': 'actionButton'
    };

    ButtonBlock.prototype.events = {
      'click .show-delete': 'showDeleteClick',
      'click .cancel': 'cancelClick',
      'click .delete': 'deleteOrDiscardClick',
      'click .action': 'actionClick'
    };

    ButtonBlock.prototype.render = function() {
      var ref;
      this.html(this.view('redesign/controls/button_block')({
        itemName: this.itemName,
        action: this.action,
        deleteLabel: this.deleteLabel || 'delete',
        delete_disabled: this.deleteDisabled,
        buttonSize: (ref = this.buttonSize) != null ? ref : 'medium'
      }));
      if (this.actionDisabledFn != null) {
        return this.actionButton.toggleClass('disabled', this.actionDisabledFn());
      }
    };

    ButtonBlock.prototype.showDeleteClick = function() {
      if (this.externalShowDeleteFn != null) {
        return this.externalShowDeleteFn(this.showDelete);
      }
      return this.showDelete();
    };

    ButtonBlock.prototype.showDelete = function() {
      this.el.addClass('show-delete-confirm');
      return this.trigger('size-changed');
    };

    ButtonBlock.prototype.deleteOrDiscardClick = function() {
      if (this.el.hasClass('show-delete-confirm')) {
        return this.trigger('delete');
      } else if (this.el.hasClass('show-cancel-confirm')) {
        return this.trigger('cancel');
      }
    };

    ButtonBlock.prototype.actionClick = function() {
      return this.trigger(_.replace(this.action, ' ', '-'));
    };

    ButtonBlock.prototype.cancelClick = function() {
      if (this.el.hasClass('show-delete-confirm')) {
        this.el.removeClass('show-delete-confirm');
        this.trigger('size-changed');
        return;
      }
      if (this.el.hasClass('show-cancel-confirm')) {
        this.el.removeClass('show-cancel-confirm');
        return this.destructiveLabel.html('Delete');
      } else {
        if (typeof this.isDestructive === "function" ? this.isDestructive() : void 0) {
          this.el.addClass('show-cancel-confirm');
          return this.destructiveLabel.html('Discard');
        } else {
          return this.trigger('cancel');
        }
      }
    };

    return ButtonBlock;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ChartContainerResizer = (function(superClass) {
    extend(ChartContainerResizer, superClass);

    ChartContainerResizer.prototype.className = 'chart-container-resizer';

    function ChartContainerResizer() {
      this.commitWidgetResize = bind(this.commitWidgetResize, this);
      this.widgetResizeDragStart = bind(this.widgetResizeDragStart, this);
      this.widgetResizeDragEnd = bind(this.widgetResizeDragEnd, this);
      this.resetDimensions = bind(this.resetDimensions, this);
      this.destroyResizeable = bind(this.destroyResizeable, this);
      this.resetResizeable = bind(this.resetResizeable, this);
      this.bindResizeUndo = bind(this.bindResizeUndo, this);
      ChartContainerResizer.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'dashboardSizer', 'item', 'isResizableFunc', 'resizeChartsFunc', 'repositionChartFunc');
      this.item.bind('frame-reset', this.resetResizeable);
      this.item.bind('frame-unrendered', this.destroyResizeable);
      this.item.bind('frame-rendered', this.bindResizeUndo);
    }

    ChartContainerResizer.prototype.release = function() {
      this.destroyResizeable();
      this.item.unbind("frame-reset", this.resetResizeable);
      this.item.unbind("frame-unrendered", this.destroyResizeable);
      return this.item.unbind("frame-rendered", this.bindResizeUndo);
    };

    ChartContainerResizer.prototype.resizeHandleEl = function() {
      return this.$('.resize-handle');
    };

    ChartContainerResizer.prototype.resizeWarning = function() {
      return this.$('.resize-warning');
    };

    ChartContainerResizer.prototype.gridBoundary = function() {
      return this.el.closest('.grid-boundary');
    };

    ChartContainerResizer.prototype.undoLink = function() {
      return this.resizeWarning().find('.link');
    };

    ChartContainerResizer.prototype.resizeDimensions = function() {
      return this.$('.resize-dimensions');
    };

    ChartContainerResizer.prototype.resizeDimensionsWidth = function() {
      return this.$('.resize-dimensions .width');
    };

    ChartContainerResizer.prototype.resizeDimensionsHeight = function() {
      return this.$('.resize-dimensions .height');
    };

    ChartContainerResizer.prototype.bindResizeUndo = function() {
      if (!this.shouldShowUndoMessage()) {
        return;
      }
      return this.undoLink().on('click', this.resetDimensions);
    };

    ChartContainerResizer.prototype.resetResizeable = function() {
      var handle, newHandle;
      handle = this.resizeHandleEl();
      if (handle == null) {
        return;
      }
      newHandle = handle.clone();
      this.destroyResizeable();
      this.el.append(newHandle);
      return this.bindResizeable();
    };

    ChartContainerResizer.prototype.destroyResizeable = function() {
      if (this.el.data("ui-resizable")) {
        this.el.resizable("destroy");
      }
      this.resizeHandleEl().remove();
      return App.RedesignDashboardsController.clearResizeDragInProgress();
    };

    ChartContainerResizer.prototype.resetDimensions = function() {
      var itemRecord;
      itemRecord = App.Widget.exists(this.item.id);
      if (!itemRecord) {
        return;
      }
      this.item.setWidth(itemRecord.getWidth());
      this.item.setHeight(itemRecord.getHeight());
      this.el.addClass("resizing-widget");
      setTimeout((function(_this) {
        return function() {
          return _this.applySizeUpdates();
        };
      })(this));
      setTimeout(this.commitWidgetResize, App.AppFrameRedesign.FAST_ANIMATION_TIME);
      this.el.removeClass('widget-border');
      return this.resizeWarning().hide();
    };

    ChartContainerResizer.prototype.widgetResizeDragEnd = function() {
      if (!this.isResizableFunc()) {
        return false;
      }
      this.hideResizeAnnotations();
      this.el.addClass("resizing-widget");
      this.el.removeClass('display-resize-handle');
      setTimeout(((function(_this) {
        return function() {
          var gridSize, pendingHorizontalResize, pendingVerticalResize, widgetWidth;
          clearInterval(_this.rerenderInterval);
          clearInterval(_this.scrollInterval);
          delete _this.rerenderInterval;
          delete _this.scrollInterval;
          gridSize = _this.dashboardSizer.gridSizeForWidget(_this.el, _this.item);
          widgetWidth = _this.el.width();
          if (_this.el.hasClass("left-gutter")) {
            widgetWidth -= _this.dashboardSizer.LEFT_GUTTER;
          }
          pendingHorizontalResize = Math.round(widgetWidth / gridSize[0]) - _this.item.getWidth();
          pendingVerticalResize = Math.round(_this.el.height() / gridSize[1]) - _this.item.getHeight();
          _this.item.setWidth(Math.max(_this.item.getWidth() + pendingHorizontalResize, _this.dashboardSizer.MIN_WIDGET_WIDTH));
          _this.item.setHeight(Math.max(_this.item.getHeight() + pendingVerticalResize, _this.dashboardSizer.MIN_WIDGET_HEIGHT));
          _this.widgetUndoController.maybeRender(_this.item);
          return _this.applySizeUpdates();
        };
      })(this)));
      setTimeout(this.commitWidgetResize, 0);
      this.el.removeClass('widget-border');
      if (!this.chartInEditron) {
        this.gridBoundary().removeClass('show-grid');
        this.dashboardSizer.layoutGrid(this.gridBoundary());
      }
      this.repositionChartFunc();
      App.RedesignDashboardsController.clearResizeDragInProgress();
      return true;
    };

    ChartContainerResizer.prototype.shouldShowUndoMessage = function() {
      return this.chartInEditron && !this.item.isNew();
    };

    ChartContainerResizer.prototype.bindResizeable = function() {
      var columnWidth;
      columnWidth = this.dashboardSizer.columnWidth(this.chartInEditron);
      return this.el.resizable({
        handles: {
          se: this.resizeHandleEl()
        },
        start: this.widgetResizeDragStart,
        stop: this.widgetResizeDragEnd,
        containment: this.chartInEditron ? 'parent' : void 0,
        minHeight: this.dashboardSizer.MIN_WIDGET_HEIGHT * columnWidth,
        minWidth: this.dashboardSizer.MIN_WIDGET_WIDTH * columnWidth
      }).on('resize', ((function(_this) {
        return function(e) {
          return e.stopPropagation();
        };
      })(this)));
    };

    ChartContainerResizer.prototype.showResizeAnnotations = function() {
      this.resizeDimensions().show();
      if (!this.shouldShowUndoMessage()) {
        return;
      }
      this.resizeWarning().show();
      return this.resizeWarning().removeClass('undo-mode');
    };

    ChartContainerResizer.prototype.hideResizeAnnotations = function() {
      this.resizeDimensions().hide();
      if (!this.shouldShowUndoMessage()) {
        return;
      }
      return this.resizeWarning().addClass('undo-mode');
    };

    ChartContainerResizer.prototype.widgetResizeDragStart = function() {
      if (!this.isResizableFunc()) {
        return false;
      }
      App.RedesignDashboardsController.setResizeDragInProgress();
      this.widgetUndoController = new App.RedesignWidgetUndoController({
        dashboard: this.item.dashboard(),
        action: 'resized'
      });
      this.showResizeAnnotations();
      this.updateResizeDimensions();
      this.rerenderInterval = setInterval(((function(_this) {
        return function() {
          if (_this.released) {
            return;
          }
          _this.resizeChartsFunc();
          return _this.updateResizeDimensions();
        };
      })(this)), 200);
      this.el.addClass("clip-widget");
      this.el.addClass('widget-border');
      this.el.addClass('display-resize-handle');
      if (!this.chartInEditron) {
        this.scrollInterval = setInterval(((function(_this) {
          return function() {
            return _this.maybeScroll();
          };
        })(this)), 50);
        this.dashboardSizer.expandForResize(this.gridBoundary());
        this.gridBoundary().addClass('show-grid');
      }
      return true;
    };

    ChartContainerResizer.prototype.updateResizeDimensions = function() {
      var columnWidth, newHeight, newWidth, widgetPixelWidth;
      columnWidth = this.dashboardSizer.columnWidth(this.chartInEditron);
      widgetPixelWidth = this.el.width();
      if (this.el.hasClass("left-gutter")) {
        widgetPixelWidth -= this.dashboardSizer.LEFT_GUTTER;
      }
      newHeight = Math.round(this.el.height() / columnWidth);
      newWidth = Math.round(widgetPixelWidth / columnWidth);
      this.resizeDimensionsWidth().text(newWidth);
      return this.resizeDimensionsHeight().text(newHeight);
    };

    ChartContainerResizer.prototype.maybeScroll = function() {
      return App.Dashboard.trigger('scroll-to-el-while-resizing', this.el, this.chartInEditron);
    };

    ChartContainerResizer.prototype.commitWidgetResize = function() {
      if (this.released) {
        return;
      }
      this.resizeChartsFunc();
      this.trigger('size-updated', this.item.getWidth(), this.item.getHeight());
      return this.el.removeClass("resizing-widget clip-widget");
    };

    ChartContainerResizer.prototype.applySizeUpdates = function() {
      var hasReachedBorder, heightPx, leftPx, ref, ref1, topPx, widthPx;
      if (this.chartInEditron) {
        this.dashboardSizer.layoutEditorGrid(this.gridBoundary(), this.item);
        ref = this.dashboardSizer.editorSizeforWidget(this.item), widthPx = ref[0], heightPx = ref[1], hasReachedBorder = ref[2];
        return this.el.css({
          left: 0,
          top: 0,
          width: hasReachedBorder ? '100%' : widthPx,
          height: heightPx
        });
      } else {
        ref1 = this.dashboardSizer.widgetPositionNormalMode(this.el, this.item), widthPx = ref1[0], heightPx = ref1[1], topPx = ref1[2], leftPx = ref1[3];
        this.el.width(widthPx);
        return this.el.height(heightPx);
      }
    };

    return ChartContainerResizer;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCheckbox = (function(superClass) {
    extend(RedesignCheckbox, superClass);

    RedesignCheckbox.prototype.elements = {
      '.icon': 'icon',
      '.label': 'label'
    };

    RedesignCheckbox.prototype.events = {
      'click .icon': 'clickedCheckbox',
      'click .label': 'clickedLabel'
    };

    function RedesignCheckbox() {
      this.clickedCheckbox = bind(this.clickedCheckbox, this);
      this.clickedLabel = bind(this.clickedLabel, this);
      this.clicked = bind(this.clicked, this);
      RedesignCheckbox.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'labelText', 'callback');
      this.html(this.view('checkbox')({
        label: this.labelText
      }));
      this.el.addClass(this.iconClassName());
      this.toggleSelected(this.initialState);
      if (this.initiallyDisabled) {
        this.disable(true);
      }
      this.lastClickedAt = 0;
    }

    RedesignCheckbox.prototype.iconClassName = function() {
      if (this.iconClass != null) {
        return this.iconClass;
      } else {
        return 'checkbox';
      }
    };

    RedesignCheckbox.prototype.toggleSelected = function(state) {
      if (state != null) {
        this.el.toggleClass('selected', state);
      }
      return state;
    };

    RedesignCheckbox.prototype.select = function() {
      return this.el.addClass('selected');
    };

    RedesignCheckbox.prototype.unselect = function() {
      return this.el.removeClass('selected');
    };

    RedesignCheckbox.prototype.isDisabled = function() {
      return this.el.hasClass('disabled');
    };

    RedesignCheckbox.prototype.disable = function(disabled) {
      return this.el.toggleClass('disabled', disabled);
    };

    RedesignCheckbox.prototype.toggle = function() {
      return this.toggleSelected(!this.state());
    };

    RedesignCheckbox.prototype.clicked = function(callback, immediate) {
      var afterState, clickOptions;
      if (immediate == null) {
        immediate = false;
      }
      if (this.isDisabled()) {
        return;
      }
      clickOptions = this.clickOptions();
      afterState = clickOptions.doubleClick ? this.state() : this.toggle();
      if (this.immediatelyTriggerCallback || immediate) {
        callback(afterState, this.value, this.labelText, clickOptions);
      } else {
        setTimeout(((function(_this) {
          return function() {
            return callback(afterState, _this.value, _this.labelText, clickOptions);
          };
        })(this)), 0);
      }
      return this.trigger('clicked', this);
    };

    RedesignCheckbox.prototype.clickedLabel = function(e) {
      this.clicked(this.labelTextCallback || this.callback, true);
      return e.stopPropagation();
    };

    RedesignCheckbox.prototype.clickedCheckbox = function(e) {
      this.clicked(this.callback, false);
      return e.stopPropagation();
    };

    RedesignCheckbox.prototype.state = function() {
      return this.el.hasClass('selected');
    };

    RedesignCheckbox.prototype.clickOptions = function() {
      return {
        doubleClick: this.isDoubleClick()
      };
    };

    RedesignCheckbox.prototype.isDoubleClick = function() {
      var doubleClick;
      doubleClick = App.RadioButton.isDoubleClick(this.lastClickedAt);
      this.lastClickedAt = App.RadioButton.lastClickedAtForDoubleClick(doubleClick);
      return doubleClick;
    };

    return RedesignCheckbox;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.AutoScroller = (function() {
    AutoScroller.BOTTOM_BUFFER = 50;

    AutoScroller.AUTO_SCROLL_TIMEOUT = 10;

    function AutoScroller(scrollableSheet, scrollParent, lowestYCoordinate, autoScrollCallback) {
      this.scrollableSheet = scrollableSheet;
      this.scrollParent = scrollParent;
      this.lowestYCoordinate = lowestYCoordinate;
      this.autoScrollCallback = autoScrollCallback;
      this.autoScroll = bind(this.autoScroll, this);
      this.maybeHandleScroll = bind(this.maybeHandleScroll, this);
      this.mouseMove = bind(this.mouseMove, this);
      $(document).on('mousemove', this.mouseMove);
    }

    AutoScroller.prototype.release = function() {
      clearTimeout(this.autoScrollTimeout);
      return $(document).off('mousemove', this.mouseMove);
    };

    AutoScroller.prototype.mouseMove = function(e) {
      var parentOffset;
      parentOffset = this.scrollParent.offset();
      this.mouseX = e.pageX - parentOffset.left;
      return this.mouseY = e.pageY - parentOffset.top;
    };

    AutoScroller.prototype.maybeHandleScroll = function(ui) {
      var xScrollAmount, yScrollAmount;
      this.ui = ui;
      clearTimeout(this.autoScrollTimeout);
      this.arenaOffset = this.scrollableSheet.position();
      xScrollAmount = this.xScrollAmount();
      yScrollAmount = this.yScrollAmount();
      if (xScrollAmount || yScrollAmount) {
        return this.autoScroll(xScrollAmount, yScrollAmount, this.ui.helper);
      }
    };

    AutoScroller.prototype.autoScroll = function(xScrollAmount, yScrollAmount, draggableEl) {
      if (this.currentlyScrolledAllTheWayLeft() && xScrollAmount < 0) {
        return;
      }
      if (this.currentlyScrolledAllTheWayUp() && yScrollAmount < 0) {
        return;
      }
      if (this.currentlyScrolledAllTheWayDown() && yScrollAmount > 0) {
        return;
      }
      this.scrollParent.scrollLeft(this.scrollParent.scrollLeft() + xScrollAmount);
      this.scrollParent.scrollTop(this.scrollParent.scrollTop() + yScrollAmount);
      return this.autoScrollTimeout = setTimeout((function(_this) {
        return function() {
          _this.autoScroll(xScrollAmount, yScrollAmount, draggableEl);
          draggableEl.css({
            top: draggableEl.position().top + yScrollAmount,
            left: draggableEl.position().left + xScrollAmount
          });
          return _this.autoScrollCallback();
        };
      })(this), this.constructor.AUTO_SCROLL_TIMEOUT);
    };

    AutoScroller.prototype.currentlyScrolledAllTheWayLeft = function() {
      return this.scrollParent.scrollLeft() <= 0;
    };

    AutoScroller.prototype.currentlyScrolledAllTheWayUp = function() {
      return this.scrollParent.scrollTop() <= 0;
    };

    AutoScroller.prototype.currentlyScrolledAllTheWayDown = function() {
      return this.scrollParent.scrollTop() >= this.lowestYCoordinate;
    };

    AutoScroller.prototype.xScrollAmount = function() {
      var distanceFromLeftScrollThreshold, distanceFromRightScrollThreshold, scrollSpeed;
      if (this.userMovedMousePastLeftThreshold()) {
        distanceFromLeftScrollThreshold = this.mouseX - this.leftScrollThreshold();
        scrollSpeed = distanceFromLeftScrollThreshold * 0.3;
        return this.limitValueBetween(scrollSpeed, -20, -1);
      } else if (this.userMovedMousePastRightThreshold()) {
        distanceFromRightScrollThreshold = this.mouseX - this.rightScrollThreshold();
        scrollSpeed = distanceFromRightScrollThreshold * 0.3;
        return this.limitValueBetween(scrollSpeed, 1, 20);
      } else {
        return 0;
      }
    };

    AutoScroller.prototype.yScrollAmount = function() {
      var distanceFromBottomScrollThreshold, distanceFromTopScrollThreshold, scrollSpeed;
      if (this.userMovedMousePastTopThreshold()) {
        distanceFromTopScrollThreshold = this.mouseY - this.topScrollThreshold();
        scrollSpeed = distanceFromTopScrollThreshold * 0.5;
        return this.limitValueBetween(scrollSpeed, -40, -1);
      } else if (this.userMovedMousePastBottomThreshold()) {
        distanceFromBottomScrollThreshold = this.mouseY - this.bottomScrollThreshold();
        scrollSpeed = distanceFromBottomScrollThreshold * 0.5;
        return this.limitValueBetween(scrollSpeed, 1, 40);
      } else {
        return 0;
      }
    };

    AutoScroller.prototype.limitValueBetween = function(value, min, max) {
      return Math.min(Math.max(min, Math.round(value)), max);
    };

    AutoScroller.prototype.userMovedMousePastLeftThreshold = function() {
      return this.mouseX < this.leftScrollThreshold();
    };

    AutoScroller.prototype.userMovedMousePastRightThreshold = function() {
      return this.mouseX > this.rightScrollThreshold();
    };

    AutoScroller.prototype.userMovedMousePastTopThreshold = function() {
      return this.mouseY < this.topScrollThreshold();
    };

    AutoScroller.prototype.userMovedMousePastBottomThreshold = function() {
      return this.mouseY > this.bottomScrollThreshold();
    };

    AutoScroller.prototype.leftScrollThreshold = function() {
      return 0;
    };

    AutoScroller.prototype.rightScrollThreshold = function() {
      return this.scrollParent.width();
    };

    AutoScroller.prototype.topScrollThreshold = function() {
      return 0;
    };

    AutoScroller.prototype.bottomScrollThreshold = function() {
      return this.scrollParent.height() - this.constructor.BOTTOM_BUFFER;
    };

    return AutoScroller;

  })();

}).call(this);
(function() {
  App.BulldozePusher = (function() {
    function BulldozePusher() {}

    BulldozePusher.prototype.push = function(state, widgets, preferredWidget) {
      var i, len, results, widget;
      this.widgetsBelow = this.getWidgetsBelow(state, widgets, preferredWidget);
      results = [];
      for (i = 0, len = widgets.length; i < len; i++) {
        widget = widgets[i];
        results.push(this.pushWidget(state, widget, preferredWidget));
      }
      return results;
    };

    BulldozePusher.prototype.pushWidget = function(state, widget, preferredWidget) {
      var abuttingWidget, abuttingWidgets, hasReachedWidgetsBelow, i, j, len, len1, movingWidget, movingWidgets;
      movingWidgets = [];
      movingWidgets.push(widget);
      hasReachedWidgetsBelow = false;
      while (state.isOverlap(preferredWidget, widget)) {
        abuttingWidgets = state.getAbuttingWidgets(movingWidgets, App.Force.DOWN);
        for (i = 0, len = abuttingWidgets.length; i < len; i++) {
          abuttingWidget = abuttingWidgets[i];
          if (this.widgetsBelow.includes(abuttingWidget)) {
            hasReachedWidgetsBelow = true;
          } else {
            movingWidgets.push(abuttingWidget);
          }
        }
        for (j = 0, len1 = movingWidgets.length; j < len1; j++) {
          movingWidget = movingWidgets[j];
          state.moveWidget(movingWidget, App.Force.DOWN, 1);
        }
        if (hasReachedWidgetsBelow) {
          this.moveWidgetsBelow(state);
        }
      }
      return null;
    };

    BulldozePusher.prototype.moveWidgetsBelow = function(state) {
      var i, len, ref, results, widget;
      ref = this.widgetsBelow;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        results.push(state.moveWidget(widget, App.Force.DOWN, 1));
      }
      return results;
    };

    BulldozePusher.prototype.getWidgetsBelow = function(state, widgets, preferredWidget) {
      var i, ignoredWidgetIds, j, len, len1, preferredCoords, ref, w, widgetCoords, widgetsBelow;
      ignoredWidgetIds = {};
      ignoredWidgetIds[preferredWidget.id] = true;
      for (i = 0, len = widgets.length; i < len; i++) {
        w = widgets[i];
        ignoredWidgetIds[w.id] = true;
      }
      preferredCoords = state.getWidgetCoordinates(preferredWidget);
      widgetsBelow = [];
      ref = state.getWidgets();
      for (j = 0, len1 = ref.length; j < len1; j++) {
        w = ref[j];
        if (ignoredWidgetIds[w.id]) {
          continue;
        }
        widgetCoords = state.getWidgetCoordinates(w);
        if (widgetCoords.getRow() >= preferredCoords.row + preferredCoords.height) {
          widgetsBelow.push(w);
        }
      }
      return widgetsBelow;
    };

    return BulldozePusher;

  })();

}).call(this);
(function() {
  App.DetermineDirectionOfForce = (function() {
    function DetermineDirectionOfForce() {}

    DetermineDirectionOfForce.prototype.get = function(state, selectedWidget, overlapper, splitDirection) {
      var overlapperCenter, selectedWidgetCenter;
      selectedWidgetCenter = state.getCenter(selectedWidget);
      overlapperCenter = state.getCenter(overlapper);
      if (splitDirection === App.SplitDirectionCalculator.SPLIT_LEFT_RIGHT) {
        if (overlapperCenter.column < selectedWidgetCenter.column) {
          return App.Force.LEFT;
        } else {
          return App.Force.RIGHT;
        }
      } else if (splitDirection === App.SplitDirectionCalculator.SPLIT_UP_DOWN) {
        if (overlapperCenter.row < selectedWidgetCenter.row) {
          return App.Force.UP;
        } else {
          return App.Force.DOWN;
        }
      }
    };

    return DetermineDirectionOfForce;

  })();

}).call(this);
(function() {
  App.Force = (function() {
    Force.LEFT = new Force(-1, 0);

    Force.RIGHT = new Force(1, 0);

    Force.UP = new Force(0, -1);

    Force.DOWN = new Force(0, 1);

    Force.INDETERMINATE = new Force(0, 0);

    function Force(x, y) {
      this.x = x;
      this.y = y;
    }

    return Force;

  })();

}).call(this);
(function() {
  App.GentleStepPusher = (function() {
    function GentleStepPusher() {}

    GentleStepPusher.prototype.push = function(state, selectedWidget, force, numberOfSteps) {
      var abuttingWidgets, i, j, movingWidgets, ref, results;
      movingWidgets = [selectedWidget];
      results = [];
      for (i = j = 0, ref = numberOfSteps; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        abuttingWidgets = state.getAbuttingWidgets(movingWidgets, force);
        if (abuttingWidgets.length > 0) {
          break;
        }
        if (state.hasReachedBorder(movingWidgets, force)) {
          break;
        }
        results.push(state.moveWidget(selectedWidget, force, 1));
      }
      return results;
    };

    return GentleStepPusher;

  })();

}).call(this);
(function() {
  App.OutOfBoundsCorrector = (function() {
    function OutOfBoundsCorrector() {}

    OutOfBoundsCorrector.prototype.maybeFix = function(state, selectedWidget) {
      var widgetCoords;
      widgetCoords = state.getWidgetCoordinates(selectedWidget);
      if (widgetCoords.column < 0) {
        state.moveWidget(selectedWidget, App.Force.RIGHT, -widgetCoords.column);
      }
      if (widgetCoords.row < 0) {
        return state.moveWidget(selectedWidget, App.Force.DOWN, -widgetCoords.row);
      }
    };

    return OutOfBoundsCorrector;

  })();

}).call(this);
(function() {
  App.RedesignCascadePusher = (function() {
    function RedesignCascadePusher(maxColsWide) {
      this.maxColsWide = maxColsWide;
    }

    RedesignCascadePusher.prototype.push = function(state, widget, preferredWidget, force) {
      var abuttingWidgets, i, len, movingWidget, movingWidgets;
      movingWidgets = [];
      movingWidgets.push(widget);
      while (state.isOverlap(preferredWidget, widget)) {
        abuttingWidgets = state.getAbuttingWidgets(movingWidgets, force);
        movingWidgets.push.apply(movingWidgets, abuttingWidgets);
        if (this.hasReachedBorder(state, movingWidgets, force)) {
          break;
        }
        for (i = 0, len = movingWidgets.length; i < len; i++) {
          movingWidget = movingWidgets[i];
          state.moveWidget(movingWidget, force, 1);
        }
      }
      return movingWidgets;
    };

    RedesignCascadePusher.prototype.hasReachedBorder = function(state, movingWidgets, force) {
      var boundariesReached, columnLimitReached, i, len, movingWidget, widgetCoordinates;
      for (i = 0, len = movingWidgets.length; i < len; i++) {
        movingWidget = movingWidgets[i];
        widgetCoordinates = state.getWidgetCoordinates(movingWidget);
        boundariesReached = (force === App.Force.LEFT && widgetCoordinates.column === 0) || (force === App.Force.UP && widgetCoordinates.row === 0);
        columnLimitReached = (this.maxColsWide != null) && (force === App.Force.RIGHT && (widgetCoordinates.column + widgetCoordinates.width) >= this.maxColsWide);
        if (boundariesReached || columnLimitReached) {
          return true;
        }
      }
      return false;
    };

    return RedesignCascadePusher;

  })();

}).call(this);
(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.ResolverState = (function() {
    ResolverState.INFINITE_LOOP_ITRS = 10000;

    function ResolverState(widgets) {
      this.widgets = widgets;
      this.locations = {};
      this.infiniteLoopCounter = 0;
    }

    ResolverState.prototype.getWidgets = function() {
      return this.widgets;
    };

    ResolverState.prototype.hasWidgetChanged = function(widget) {
      return this.locations[widget.id] != null;
    };

    ResolverState.prototype.setWidgetCoordinates = function(widget, column, row) {
      return this.locations[widget.id] = new App.WidgetCoordinates(column, row, widget.getWidth(), widget.getHeight());
    };

    ResolverState.prototype.moveWidget = function(widget, force, distance) {
      var column, row, widgetCoordinates;
      widgetCoordinates = this.getWidgetCoordinates(widget);
      column = widgetCoordinates.column;
      row = widgetCoordinates.getRow();
      return this.setWidgetCoordinates(widget, column + force.x * distance, row + force.y * distance);
    };

    ResolverState.prototype.getWidgetCoordinates = function(widget) {
      if (this.locations[widget.id]) {
        return this.locations[widget.id];
      }
      return new App.WidgetCoordinates(widget.getColumn(), widget.getRow(), widget.getWidth(), widget.getHeight());
    };

    ResolverState.prototype.getCenter = function(widget) {
      var widgetCoordinates;
      widgetCoordinates = this.getWidgetCoordinates(widget);
      return {
        column: widgetCoordinates.column + (widgetCoordinates.width / 2),
        row: widgetCoordinates.row + (widgetCoordinates.height / 2)
      };
    };

    ResolverState.prototype.isOverlap = function(widget1, widget2, checkForInfiniteLoop) {
      if (checkForInfiniteLoop == null) {
        checkForInfiniteLoop = true;
      }
      if (checkForInfiniteLoop && this.isInfiniteLoop()) {
        return false;
      }
      return this.getOverlap(widget1, widget2) != null;
    };

    ResolverState.prototype.getOverlap = function(widget1, widget2) {
      var w1Coordinates, w2Coordinates, xOverlap, yOverlap;
      w1Coordinates = this.getWidgetCoordinates(widget1);
      w2Coordinates = this.getWidgetCoordinates(widget2);
      xOverlap = this.getXOverlap(w1Coordinates, w2Coordinates);
      yOverlap = this.getYOverlap(w1Coordinates, w2Coordinates);
      if (xOverlap.width === 0 || yOverlap.height === 0) {
        return null;
      } else {
        return new App.WidgetCoordinates(xOverlap.column, yOverlap.row, xOverlap.width, yOverlap.height);
      }
    };

    ResolverState.prototype.getXOverlap = function(w1Coordinates, w2Coordinates) {
      var rightMostColumn, width;
      rightMostColumn = Math.max(w1Coordinates.column, w2Coordinates.column);
      width = Math.min(w1Coordinates.endColumn, w2Coordinates.endColumn) - rightMostColumn;
      return {
        column: rightMostColumn,
        width: Math.max(width, 0)
      };
    };

    ResolverState.prototype.getYOverlap = function(w1Coordinates, w2Coordinates) {
      var bottomMostRow, height;
      bottomMostRow = Math.max(w1Coordinates.row, w2Coordinates.row);
      height = Math.min(w1Coordinates.endRow, w2Coordinates.endRow) - bottomMostRow;
      return {
        row: bottomMostRow,
        height: Math.max(height, 0)
      };
    };

    ResolverState.prototype.getAbuttingWidgets = function(primaryWidgets, force) {
      var clonedPrimaryWidgets, foundWidgets, i, j, k, len, len1, len2, primaryWidget, ref, ref1, widget, widgetIds;
      clonedPrimaryWidgets = primaryWidgets.slice(0);
      widgetIds = [];
      for (i = 0, len = clonedPrimaryWidgets.length; i < len; i++) {
        primaryWidget = clonedPrimaryWidgets[i];
        widgetIds.push(primaryWidget.id);
      }
      foundWidgets = [];
      ref = this.sortWidgetsByForceDirection(force);
      for (j = 0, len1 = ref.length; j < len1; j++) {
        widget = ref[j];
        if (ref1 = widget.id, indexOf.call(widgetIds, ref1) >= 0) {
          continue;
        }
        for (k = 0, len2 = clonedPrimaryWidgets.length; k < len2; k++) {
          primaryWidget = clonedPrimaryWidgets[k];
          if (this.isAbutting(primaryWidget, widget, force)) {
            widgetIds.push(widget.id);
            foundWidgets.push(widget);
            clonedPrimaryWidgets.push(widget);
            break;
          }
        }
      }
      return foundWidgets;
    };

    ResolverState.prototype.sortWidgetsByForceDirection = function(force) {
      var sortedWidgets;
      sortedWidgets = this.widgets.slice(0);
      sortedWidgets.sort((function(_this) {
        return function(widget1, widget2) {
          var w1Coords, w2Coords, widget1Bottom, widget1Right, widget2Bottom, widget2Right;
          w1Coords = _this.getWidgetCoordinates(widget1);
          w2Coords = _this.getWidgetCoordinates(widget2);
          if (force === App.Force.LEFT) {
            widget1Right = w1Coords.column + w1Coords.width;
            widget2Right = w2Coords.column + w2Coords.width;
            return widget2Right - widget1Right;
          } else if (force === App.Force.RIGHT) {
            return w1Coords.column - w2Coords.column;
          } else if (force === App.Force.UP) {
            widget1Bottom = w1Coords.row + w1Coords.height;
            widget2Bottom = w2Coords.row + w2Coords.height;
            return widget2Bottom - widget1Bottom;
          } else if (force === App.Force.DOWN) {
            if (w1Coords.row === w2Coords.row) {
              return w1Coords.column - w2Coords.column;
            }
            return w1Coords.row - w2Coords.row;
          }
        };
      })(this));
      return sortedWidgets;
    };

    ResolverState.prototype.isAbutting = function(primaryWidget, otherWidget, force) {
      var isXAbutting, isXOverlap, isYAbutting, isYOverlap, other, primary;
      other = this.getWidgetCoordinates(otherWidget);
      primary = this.getWidgetCoordinates(primaryWidget);
      if (force === App.Force.LEFT) {
        isXAbutting = other.column + other.width === primary.column;
        isYOverlap = (primary.row + primary.height > other.row) && (primary.row < other.row + other.height);
        return isXAbutting && isYOverlap;
      } else if (force === App.Force.RIGHT) {
        isXAbutting = primary.column + primary.width === other.column;
        isYOverlap = (primary.row + primary.height > other.row) && (primary.row < other.row + other.height);
        return isXAbutting && isYOverlap;
      } else if (force === App.Force.UP) {
        isYAbutting = other.row + other.height === primary.row;
        isXOverlap = (primary.column < other.column + other.width) && (primary.column + primary.width > other.column);
        return isYAbutting && isXOverlap;
      } else if (force === App.Force.DOWN) {
        isYAbutting = primary.row + primary.height === other.row;
        isXOverlap = (primary.column < other.column + other.width) && (primary.column + primary.width > other.column);
        return isYAbutting && isXOverlap;
      } else {
        return false;
      }
    };

    ResolverState.prototype.hasReachedBorder = function(movingWidgets, force) {
      var i, len, movingWidget, widgetCoordinates;
      for (i = 0, len = movingWidgets.length; i < len; i++) {
        movingWidget = movingWidgets[i];
        widgetCoordinates = this.getWidgetCoordinates(movingWidget);
        if ((force === App.Force.LEFT && widgetCoordinates.column === 0) || (force === App.Force.UP && widgetCoordinates.row === 0)) {
          return true;
        }
      }
      return false;
    };

    ResolverState.prototype.isInfiniteLoop = function() {
      if (this.infiniteLoopCounter++ > ResolverState.INFINITE_LOOP_ITRS) {
        this.logInfiniteLoopError();
        return true;
      }
      return false;
    };

    ResolverState.prototype.logInfiniteLoopError = function() {
      return AppRedesign.logError(new Error("Infinite resolver loop on " + (App.Dashboard.currentDashboard().id)));
    };

    ResolverState.prototype.clone = function() {
      var coordinates, newState, ref, widgetId;
      newState = new App.ResolverState();
      ref = this.locations;
      for (widgetId in ref) {
        coordinates = ref[widgetId];
        newState.locations[widgetId] = new App.WidgetCoordinates(coordinates.column, coordinates.row, coordinates.width, coordinates.height);
      }
      newState.widgets = this.widgets;
      newState.infiniteLoopCounter = this.infiniteLoopCounter;
      return newState;
    };

    return ResolverState;

  })();

  App.WidgetCoordinates = (function() {
    function WidgetCoordinates(column1, row1, width1, height1) {
      this.column = column1;
      this.row = row1;
      this.width = width1;
      this.height = height1;
      this.endColumn = this.column + this.width;
      this.endRow = this.row + this.height;
    }

    WidgetCoordinates.prototype.getColumn = function() {
      return this.column;
    };

    WidgetCoordinates.prototype.getRow = function() {
      return this.row;
    };

    WidgetCoordinates.prototype.getWidth = function() {
      return this.width;
    };

    WidgetCoordinates.prototype.getHeight = function() {
      return this.height;
    };

    return WidgetCoordinates;

  })();

}).call(this);
(function() {
  App.SnapWithAbuttingWidgets = (function() {
    SnapWithAbuttingWidgets.SNAP_REGION = 2;

    function SnapWithAbuttingWidgets() {
      this.gentleStepPusher = new App.GentleStepPusher();
    }

    SnapWithAbuttingWidgets.prototype.snapWithAbuttingWidgets = function(state, selectedWidget1) {
      var currWidgetCoords, i, len, potentialMove, potentialMovesByAxis, ref, selectedWidgetCoords, widget;
      this.state = state;
      this.selectedWidget = selectedWidget1;
      selectedWidgetCoords = this.state.getWidgetCoordinates(this.selectedWidget);
      potentialMovesByAxis = {
        'left-right': [],
        'up-down': [],
        'no-move': []
      };
      ref = this.state.getWidgets();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (!(widget.id !== this.selectedWidget.id)) {
          continue;
        }
        currWidgetCoords = this.state.getWidgetCoordinates(widget);
        potentialMove = this.getPotentialMove(selectedWidgetCoords, currWidgetCoords);
        potentialMovesByAxis[potentialMove.type].push(potentialMove);
      }
      this.snapEdgeForSpecificAxis(potentialMovesByAxis['left-right']);
      return this.snapEdgeForSpecificAxis(potentialMovesByAxis['up-down']);
    };

    SnapWithAbuttingWidgets.prototype.snapEdgeForSpecificAxis = function(potentialMoves) {
      var winningMove;
      if (potentialMoves.length === 0) {
        return;
      }
      potentialMoves.sort(function(a, b) {
        return a.priority - b.priority;
      });
      winningMove = potentialMoves[0];
      return this.gentleStepPusher.push(this.state, this.selectedWidget, winningMove.force, winningMove.distance);
    };

    SnapWithAbuttingWidgets.prototype.getPotentialMove = function(selectedWidget, widget) {
      var delta, distance, force, priority, type;
      distance = null;
      if (this.widgetsAbutVertically(selectedWidget, widget)) {
        type = "left-right";
        delta = !this.leftRightDiffEqual(selectedWidget, widget) ? this.leftEdgeCanSnap(selectedWidget, widget) ? this.leftEdgeDiff(selectedWidget, widget) : this.rightEdgeCanSnap(selectedWidget, widget) ? this.rightEdgeDiff(selectedWidget, widget) : void 0 : void 0;
        priority = this.getPriorityForLeftOrRightSnap(selectedWidget, widget);
        if ((delta != null) && delta <= 0) {
          force = App.Force.LEFT;
          distance = Math.abs(delta);
        } else if ((delta != null) && delta > 0) {
          force = App.Force.RIGHT;
          distance = Math.abs(delta);
        }
      } else if (this.widgetsAbutHorizontally(selectedWidget, widget)) {
        type = "up-down";
        delta = !this.topBottomDiffEqual(selectedWidget, widget) ? this.topEdgeCanSnap(selectedWidget, widget) ? this.topEdgeDiff(selectedWidget, widget) : this.bottomEdgeCanSnap(selectedWidget, widget) ? this.bottomEdgeDiff(selectedWidget, widget) : void 0 : void 0;
        priority = this.getPriorityForUpOrDownSnap(selectedWidget, widget);
        if ((delta != null) && delta <= 0) {
          force = App.Force.UP;
          distance = Math.abs(delta);
        } else if ((delta != null) && delta > 0) {
          force = App.Force.DOWN;
          distance = Math.abs(delta);
        }
      }
      if (distance === null) {
        return {
          type: 'no-move'
        };
      }
      return {
        type: type,
        priority: priority,
        distance: distance,
        force: force
      };
    };

    SnapWithAbuttingWidgets.prototype.widgetsAbutVertically = function(selectedWidget, widget) {
      var xOverlap;
      xOverlap = this.state.getXOverlap(selectedWidget, widget);
      return xOverlap.width > 0 && (widget.endRow === selectedWidget.row || widget.row === selectedWidget.endRow);
    };

    SnapWithAbuttingWidgets.prototype.widgetsAbutHorizontally = function(selectedWidget, widget) {
      var yOverlap;
      yOverlap = this.state.getYOverlap(selectedWidget, widget);
      return yOverlap.height > 0 && (widget.endColumn === selectedWidget.column || widget.column === selectedWidget.endColumn);
    };

    SnapWithAbuttingWidgets.prototype.leftEdgeDiff = function(selectedWidget, widget) {
      return widget.column - selectedWidget.column;
    };

    SnapWithAbuttingWidgets.prototype.rightEdgeDiff = function(selectedWidget, widget) {
      return widget.endColumn - selectedWidget.endColumn;
    };

    SnapWithAbuttingWidgets.prototype.topEdgeDiff = function(selectedWidget, widget) {
      return widget.row - selectedWidget.row;
    };

    SnapWithAbuttingWidgets.prototype.bottomEdgeDiff = function(selectedWidget, widget) {
      return widget.endRow - selectedWidget.endRow;
    };

    SnapWithAbuttingWidgets.prototype.leftRightDiffEqual = function(selectedWidget, widget) {
      return this.leftEdgeDiff(selectedWidget, widget) === (-1 * this.rightEdgeDiff(selectedWidget, widget));
    };

    SnapWithAbuttingWidgets.prototype.topBottomDiffEqual = function(selectedWidget, widget) {
      return this.topEdgeDiff(selectedWidget, widget) === (-1 * this.bottomEdgeDiff(selectedWidget, widget));
    };

    SnapWithAbuttingWidgets.prototype.leftEdgeCanSnap = function(selectedWidget, widget) {
      return Math.abs(this.leftEdgeDiff(selectedWidget, widget)) <= this.constructor.SNAP_REGION;
    };

    SnapWithAbuttingWidgets.prototype.rightEdgeCanSnap = function(selectedWidget, widget) {
      return Math.abs(this.rightEdgeDiff(selectedWidget, widget)) <= this.constructor.SNAP_REGION;
    };

    SnapWithAbuttingWidgets.prototype.topEdgeCanSnap = function(selectedWidget, widget) {
      return Math.abs(this.topEdgeDiff(selectedWidget, widget)) <= this.constructor.SNAP_REGION;
    };

    SnapWithAbuttingWidgets.prototype.bottomEdgeCanSnap = function(selectedWidget, widget) {
      return Math.abs(this.bottomEdgeDiff(selectedWidget, widget)) <= this.constructor.SNAP_REGION;
    };

    SnapWithAbuttingWidgets.prototype.abutsOnTopSide = function(selectedWidget, widget) {
      return selectedWidget.row === widget.endRow;
    };

    SnapWithAbuttingWidgets.prototype.abutsOnBottomSide = function(selectedWidget, widget) {
      return selectedWidget.endRow === widget.row;
    };

    SnapWithAbuttingWidgets.prototype.abutsOnLeftSide = function(selectedWidget, widget) {
      return selectedWidget.column === widget.endColumn;
    };

    SnapWithAbuttingWidgets.prototype.abutsOnRightSide = function(selectedWidget, widget) {
      return selectedWidget.endColumn === widget.column;
    };

    SnapWithAbuttingWidgets.prototype.getPriorityForLeftOrRightSnap = function(selectedWidget, widget) {
      if (this.leftRightDiffEqual(selectedWidget, widget)) {
        return null;
      }
      if (this.leftEdgeCanSnap(selectedWidget, widget) && this.abutsOnTopSide(selectedWidget, widget)) {
        return 1;
      }
      if (this.leftEdgeCanSnap(selectedWidget, widget) && this.abutsOnBottomSide(selectedWidget, widget)) {
        return 2;
      }
      if (this.rightEdgeCanSnap(selectedWidget, widget) && this.abutsOnTopSide(selectedWidget, widget)) {
        return 3;
      }
      if (this.rightEdgeCanSnap(selectedWidget, widget) && this.abutsOnBottomSide(selectedWidget, widget)) {
        return 4;
      }
      return null;
    };

    SnapWithAbuttingWidgets.prototype.getPriorityForUpOrDownSnap = function(selectedWidget, widget) {
      if (this.topBottomDiffEqual(selectedWidget, widget)) {
        return null;
      }
      if (this.topEdgeCanSnap(selectedWidget, widget) && this.abutsOnLeftSide(selectedWidget, widget)) {
        return 1;
      }
      if (this.topEdgeCanSnap(selectedWidget, widget) && this.abutsOnRightSide(selectedWidget, widget)) {
        return 2;
      }
      if (this.bottomEdgeCanSnap(selectedWidget, widget) && this.abutsOnLeftSide(selectedWidget, widget)) {
        return 3;
      }
      if (this.bottomEdgeCanSnap(selectedWidget, widget) && this.abutsOnRightSide(selectedWidget, widget)) {
        return 4;
      }
      return null;
    };

    return SnapWithAbuttingWidgets;

  })();

}).call(this);
(function() {
  App.SplitDirectionCalculator = (function() {
    function SplitDirectionCalculator() {}

    SplitDirectionCalculator.SPLIT_LEFT_RIGHT = 'left-right';

    SplitDirectionCalculator.SPLIT_UP_DOWN = 'up-down';

    SplitDirectionCalculator.OVERLAP_PERCENTAGE_DIFF_THRESHOLD = 30;

    SplitDirectionCalculator.HALF_OVERLAP_PERCENTAGE = 50;

    SplitDirectionCalculator.prototype.determineSplitAxis = function(state, selectedWidget, overlappers) {
      var i, len, overlapper, result, selectedWidgetCenter, selectedWidgetCoords, votes;
      votes = {
        'left-right': 0,
        'up-down': 0
      };
      selectedWidgetCoords = state.getWidgetCoordinates(selectedWidget);
      selectedWidgetCenter = state.getCenter(selectedWidget);
      for (i = 0, len = overlappers.length; i < len; i++) {
        overlapper = overlappers[i];
        result = this.determinePreferredSplitDirection(state, selectedWidgetCoords, selectedWidgetCenter, overlapper);
        votes[result.splitDirection] += result.strength;
      }
      if (votes[this.constructor.SPLIT_UP_DOWN] > votes[this.constructor.SPLIT_LEFT_RIGHT]) {
        return this.constructor.SPLIT_UP_DOWN;
      } else {
        return this.constructor.SPLIT_LEFT_RIGHT;
      }
    };

    SplitDirectionCalculator.prototype.determinePreferredSplitDirection = function(state, selectedWidgetCoords, selectedWidgetCenter, overlapper) {
      var leftRightPreference, overlapperCenter, overlapperCoords, percentageXOverlap, percentageYOverlap, upDownPreference;
      overlapperCoords = state.getWidgetCoordinates(overlapper);
      overlapperCenter = state.getCenter(overlapper);
      percentageXOverlap = this.percentageXOverlap(state, selectedWidgetCoords, overlapperCoords);
      percentageYOverlap = this.percentageYOverlap(state, selectedWidgetCoords, overlapperCoords);
      leftRightPreference = this.preferenceForSplittingLeftRight(selectedWidgetCenter, overlapperCenter, overlapperCoords, percentageYOverlap);
      upDownPreference = this.preferenceForSplittingUpDown(selectedWidgetCenter, overlapperCenter, overlapperCoords, percentageXOverlap);
      if (this.yOverlapMuchGreaterThanXOverlap(percentageXOverlap, percentageYOverlap)) {
        return leftRightPreference;
      } else if (this.xOverlapMuchGreaterThanYOverlap(percentageXOverlap, percentageYOverlap)) {
        return upDownPreference;
      } else if (leftRightPreference.strength > upDownPreference.strength) {
        return leftRightPreference;
      } else {
        return upDownPreference;
      }
    };

    SplitDirectionCalculator.prototype.preferenceForSplittingLeftRight = function(selectedWidgetCenter, overlapperCenter, overlapperCoords, percentageYOverlap) {
      var halfWidth, leftRightStrength;
      halfWidth = overlapperCoords.width / 2;
      leftRightStrength = Math.abs(selectedWidgetCenter.column - overlapperCenter.column) / halfWidth;
      leftRightStrength = Math.min(leftRightStrength, 1);
      leftRightStrength = this.discountStrengthIfSmallOverlap(leftRightStrength, percentageYOverlap);
      return {
        splitDirection: this.constructor.SPLIT_LEFT_RIGHT,
        strength: leftRightStrength
      };
    };

    SplitDirectionCalculator.prototype.preferenceForSplittingUpDown = function(selectedWidgetCenter, overlapperCenter, overlapperCoords, percentageXOverlap) {
      var halfHeight, upDownStrength;
      halfHeight = overlapperCoords.height / 2;
      upDownStrength = Math.abs(selectedWidgetCenter.row - overlapperCenter.row) / halfHeight;
      upDownStrength = Math.min(upDownStrength, 1);
      upDownStrength = this.discountStrengthIfSmallOverlap(upDownStrength, percentageXOverlap);
      return {
        splitDirection: this.constructor.SPLIT_UP_DOWN,
        strength: upDownStrength
      };
    };

    SplitDirectionCalculator.prototype.percentageXOverlap = function(state, selectedWidgetCoords, overlapperCoords) {
      var smallerWidth, xOverlap;
      xOverlap = state.getXOverlap(selectedWidgetCoords, overlapperCoords);
      smallerWidth = Math.min(selectedWidgetCoords.width, overlapperCoords.width);
      return 100 * (xOverlap.width / smallerWidth);
    };

    SplitDirectionCalculator.prototype.percentageYOverlap = function(state, selectedWidgetCoords, overlapperCoords) {
      var smallerHeight, yOverlap;
      yOverlap = state.getYOverlap(selectedWidgetCoords, overlapperCoords);
      smallerHeight = Math.min(selectedWidgetCoords.height, overlapperCoords.height);
      return 100 * (yOverlap.height / smallerHeight);
    };

    SplitDirectionCalculator.prototype.yOverlapMuchGreaterThanXOverlap = function(percentageXOverlap, percentageYOverlap) {
      return percentageYOverlap >= percentageXOverlap + this.constructor.OVERLAP_PERCENTAGE_DIFF_THRESHOLD;
    };

    SplitDirectionCalculator.prototype.xOverlapMuchGreaterThanYOverlap = function(percentageXOverlap, percentageYOverlap) {
      return percentageXOverlap >= percentageYOverlap + this.constructor.OVERLAP_PERCENTAGE_DIFF_THRESHOLD;
    };

    SplitDirectionCalculator.prototype.discountStrengthIfSmallOverlap = function(strength, overlapPercentage) {
      if (overlapPercentage < this.constructor.HALF_OVERLAP_PERCENTAGE) {
        return strength / 2;
      } else {
        return strength;
      }
    };

    return SplitDirectionCalculator;

  })();

}).call(this);
(function() {
  App.SplitStyleCollisionResolver = (function() {
    function SplitStyleCollisionResolver(dashboard, inDashboard, interactive) {
      this.dashboard = dashboard;
      this.inDashboard = inDashboard;
      this.interactive = interactive;
      this.splitDirectionCalculator = new App.SplitDirectionCalculator();
      this.determineDirectionOfForce = new App.DetermineDirectionOfForce();
      this.outOfBoundsCorrector = new App.OutOfBoundsCorrector();
      this.cascadePusher = new App.RedesignCascadePusher();
      this.bulldozePusher = new App.BulldozePusher();
      this.abuttingWidgetsSnapper = new App.SnapWithAbuttingWidgets();
      this.gentleStepPusher = new App.GentleStepPusher();
      this.yielder = new App.YieldWithinOverlapTolerance();
    }

    SplitStyleCollisionResolver.prototype.rearrange = function(widgets, selectedWidget, resolveReason) {
      this.widgets = widgets;
      this.selectedWidget = selectedWidget != null ? selectedWidget : null;
      this.resolveReason = resolveReason != null ? resolveReason : null;
      this.state = new App.ResolverState(this.widgets);
      if (App.NO_COLLISION_DETECTION) {
        return;
      }
      App.Lagotron.addContext("CollisionResolver.rearrange");
      if (this.selectedWidget) {
        this.clearOverlapperArrays();
        delete this.splitDirection;
        this.resolveOverlappingWidgets();
        this.commitWidgetChanges();
      }
      if (this.interactive) {
        return;
      }
      if (!this.dashboard.isCompletelyLoaded()) {
        AppRedesign.logToScalyr('redesign_prevent_collapse_empty_rows', {
          widgets: this.dashboard.widgets().length
        });
        return;
      }
      if (AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON && this.resolveReason === 'widget-moved') {
        return;
      }
      return App.RedesignRectangles.collapseEmptyRows(this.widgets);
    };

    SplitStyleCollisionResolver.prototype.anchorSelectedWidget = function() {
      return this.resolveReason === 'widget-resized' || this.resolveReason === 'widget-resized-in-editor';
    };

    SplitStyleCollisionResolver.prototype.resolveOverlappingWidgets = function() {
      this.findOverlappers();
      this.outOfBoundsCorrector.maybeFix(this.state, this.selectedWidget);
      this.findOverlappers();
      if (!this.hasOverlappers()) {
        if (!this.anchorSelectedWidget()) {
          this.abuttingWidgetsSnapper.snapWithAbuttingWidgets(this.state, this.selectedWidget);
        }
        return;
      }
      if (!this.anchorSelectedWidget()) {
        this.yielder.maybeYield(this.state, this.selectedWidget, this.leftOverlappers, this.rightOverlappers, this.topOverlappers, this.bottomOverlappers);
      }
      this.clearOverlappersIfNoLongerOverlapping();
      this.pushAgainstLeftAndTopWallFirst();
      this.pushRight();
      if (!this.anchorSelectedWidget()) {
        this.abuttingWidgetsSnapper.snapWithAbuttingWidgets(this.state, this.selectedWidget);
      }
      this.bringDisplacedWidgetsBackIfPossible();
      return this.bulldozeDown(this.bottomOverlappers);
    };

    SplitStyleCollisionResolver.prototype.clearOverlapperArrays = function() {
      this.allOverlappers = [];
      this.leftOverlappers = [];
      this.rightOverlappers = [];
      this.topOverlappers = [];
      this.bottomOverlappers = [];
      return this.indeterminateOverlappers = [];
    };

    SplitStyleCollisionResolver.prototype.findOverlappers = function() {
      var force, i, len, overlappers, results, widget;
      overlappers = _(this.widgets).filter((function(_this) {
        return function(widget) {
          return widget.id !== _this.selectedWidget.id || widget.constructor.className !== _this.selectedWidget.constructor.className;
        };
      })(this)).filter((function(_this) {
        return function(widget) {
          return _this.state.isOverlap(_this.selectedWidget, widget, false);
        };
      })(this)).value();
      if (overlappers.length === 0) {
        return;
      }
      this.splitDirection || (this.splitDirection = this.splitDirectionCalculator.determineSplitAxis(this.state, this.selectedWidget, overlappers));
      results = [];
      for (i = 0, len = overlappers.length; i < len; i++) {
        widget = overlappers[i];
        if (this.allOverlappers.includes(widget)) {
          continue;
        }
        this.allOverlappers.push(widget);
        force = this.determineDirectionOfForce.get(this.state, this.selectedWidget, widget, this.splitDirection);
        results.push(this.overlapperList(force).push(widget));
      }
      return results;
    };

    SplitStyleCollisionResolver.prototype.overlapperList = function(force) {
      switch (force) {
        case App.Force.LEFT:
          return this.leftOverlappers;
        case App.Force.RIGHT:
          return this.rightOverlappers;
        case App.Force.UP:
          return this.topOverlappers;
        case App.Force.DOWN:
          return this.bottomOverlappers;
      }
    };

    SplitStyleCollisionResolver.prototype.hasOverlappers = function() {
      return this.allOverlappers.length > 0;
    };

    SplitStyleCollisionResolver.prototype.clearOverlappersIfNoLongerOverlapping = function() {
      this.checkOverlapperArray(this.leftOverlappers);
      this.checkOverlapperArray(this.rightOverlappers);
      this.checkOverlapperArray(this.topOverlappers);
      return this.checkOverlapperArray(this.bottomOverlappers);
    };

    SplitStyleCollisionResolver.prototype.checkOverlapperArray = function(overlappers) {
      var originalLength;
      originalLength = overlappers.length;
      return _.remove(overlappers, (function(_this) {
        return function(overlapper) {
          return !_this.state.isOverlap(_this.selectedWidget, overlapper);
        };
      })(this));
    };

    SplitStyleCollisionResolver.prototype.pushAgainstLeftAndTopWallFirst = function() {
      this.pushAgainstBorder(this.leftOverlappers, App.Force.LEFT);
      if (this.anchorSelectedWidget()) {
        this.pushOrthogonalIfAgainstBorder(this.leftOverlappers, App.Force.DOWN);
      } else {
        this.maybeSelectedWidgetGivesWay(this.leftOverlappers, App.Force.RIGHT);
      }
      this.pushAgainstBorder(this.topOverlappers, App.Force.UP);
      if (this.anchorSelectedWidget()) {
        return this.pushOrthogonalIfAgainstBorder(this.topOverlappers, App.Force.RIGHT);
      } else {
        return this.maybeSelectedWidgetGivesWay(this.topOverlappers, App.Force.DOWN);
      }
    };

    SplitStyleCollisionResolver.prototype.pushAgainstBorder = function(overlappers, force) {
      var i, len, results, widget;
      results = [];
      for (i = 0, len = overlappers.length; i < len; i++) {
        widget = overlappers[i];
        results.push(this.cascadePusher.push(this.state, widget, this.selectedWidget, force));
      }
      return results;
    };

    SplitStyleCollisionResolver.prototype.pushOrthogonalIfAgainstBorder = function(oppositeOverlappers, directionToMove) {
      return _(oppositeOverlappers).filter((function(_this) {
        return function(overlapper) {
          return _this.state.isOverlap(overlapper, _this.selectedWidget);
        };
      })(this)).forEach((function(_this) {
        return function(overlapper) {
          return _this.cascadePusher.push(_this.state, overlapper, _this.selectedWidget, directionToMove);
        };
      })(this));
    };

    SplitStyleCollisionResolver.prototype.maybeSelectedWidgetGivesWay = function(oppositeOverlappers, directionToMove) {
      return _(oppositeOverlappers).filter((function(_this) {
        return function(overlapper) {
          return _this.state.isOverlap(overlapper, _this.selectedWidget);
        };
      })(this)).forEach((function(_this) {
        return function(overlapper) {
          return _this.cascadePusher.push(_this.state, _this.selectedWidget, overlapper, directionToMove);
        };
      })(this));
    };

    SplitStyleCollisionResolver.prototype.pushRight = function() {
      var i, len, ref, results, widget;
      ref = this.rightOverlappers;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        results.push(this.cascadePusher.push(this.state, widget, this.selectedWidget, App.Force.RIGHT));
      }
      return results;
    };

    SplitStyleCollisionResolver.prototype.bringDisplacedWidgetsBackIfPossible = function() {
      var finalCoords, i, len, ref, results, widget;
      ref = this.widgets;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (this.state.hasWidgetChanged(widget) && widget.id !== this.selectedWidget.id) {
          finalCoords = this.state.getWidgetCoordinates(widget);
          if (this.widgetWasDisplacedLeft(finalCoords, widget)) {
            results.push(this.gentleStepPusher.push(this.state, widget, App.Force.RIGHT, widget.getColumn() - finalCoords.column));
          } else if (this.widgetWasDisplacedRight(finalCoords, widget)) {
            results.push(this.gentleStepPusher.push(this.state, widget, App.Force.LEFT, finalCoords.column - widget.getColumn()));
          } else if (this.widgetWasDisplacedUp(finalCoords, widget)) {
            results.push(this.gentleStepPusher.push(this.state, widget, App.Force.DOWN, widget.getRow() - finalCoords.row));
          } else if (this.widgetWasDisplacedDown(finalCoords, widget)) {
            results.push(this.gentleStepPusher.push(this.state, widget, App.Force.UP, finalCoords.row - widget.getRow()));
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    SplitStyleCollisionResolver.prototype.widgetWasDisplacedLeft = function(finalCoords, widget) {
      return finalCoords.column < widget.getColumn();
    };

    SplitStyleCollisionResolver.prototype.widgetWasDisplacedRight = function(finalCoords, widget) {
      return finalCoords.column > widget.getColumn();
    };

    SplitStyleCollisionResolver.prototype.widgetWasDisplacedUp = function(finalCoords, widget) {
      return finalCoords.row < widget.getRow();
    };

    SplitStyleCollisionResolver.prototype.widgetWasDisplacedDown = function(finalCoords, widget) {
      return finalCoords.row > widget.getRow();
    };

    SplitStyleCollisionResolver.prototype.bulldozeDown = function(bottomOverlappers) {
      if (bottomOverlappers.length === 0) {
        return;
      }
      return this.bulldozePusher.push(this.state, bottomOverlappers, this.selectedWidget);
    };

    SplitStyleCollisionResolver.prototype.commitWidgetChanges = function() {
      var i, len, newWidgetCoordinates, ref, results, widget;
      ref = this.widgets;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (this.state.hasWidgetChanged(widget)) {
          newWidgetCoordinates = this.state.getWidgetCoordinates(widget);
          results.push(widget.moveTo(newWidgetCoordinates.column, newWidgetCoordinates.row, false, false));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return SplitStyleCollisionResolver;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.YieldWithinOverlapTolerance = (function(superClass) {
    extend(YieldWithinOverlapTolerance, superClass);

    function YieldWithinOverlapTolerance() {
      return YieldWithinOverlapTolerance.__super__.constructor.apply(this, arguments);
    }

    YieldWithinOverlapTolerance.TOLERANCE = 2;

    YieldWithinOverlapTolerance.prototype.maybeYield = function(state, selectedWidget, leftOverlappers, rightOverlappers, topOverlappers, bottomOverlappers) {
      var overlapParameters;
      this.state = state;
      this.selectedWidget = selectedWidget;
      this.leftOverlappers = leftOverlappers;
      this.rightOverlappers = rightOverlappers;
      this.topOverlappers = topOverlappers;
      this.bottomOverlappers = bottomOverlappers;
      if (this.isSqueezedOnBothSides()) {
        return;
      }
      if (this.hasNoOverlappers()) {
        return;
      }
      overlapParameters = this.overlapParameters();
      if (overlapParameters.distance > this.constructor.TOLERANCE) {
        return;
      }
      return new App.GentleStepPusher().push(this.state, this.selectedWidget, overlapParameters.force, overlapParameters.distance);
    };

    YieldWithinOverlapTolerance.prototype.isSqueezedOnBothSides = function() {
      if (this.leftOverlappers.length > 0 && this.rightOverlappers.length > 0) {
        return true;
      }
      if (this.topOverlappers.length > 0 && this.bottomOverlappers.length > 0) {
        return true;
      }
      return false;
    };

    YieldWithinOverlapTolerance.prototype.hasNoOverlappers = function() {
      return this.leftOverlappers.length === 0 && this.rightOverlappers.length === 0 && this.topOverlappers.length === 0 && this.bottomOverlappers.length === 0;
    };

    YieldWithinOverlapTolerance.prototype.overlapParameters = function() {
      var force, overlappers;
      if (this.leftOverlappers.length > 0) {
        force = App.Force.RIGHT;
        overlappers = this.leftOverlappers;
      } else if (this.rightOverlappers.length > 0) {
        force = App.Force.LEFT;
        overlappers = this.rightOverlappers;
      } else if (this.topOverlappers.length > 0) {
        force = App.Force.DOWN;
        overlappers = this.topOverlappers;
      } else if (this.bottomOverlappers.length > 0) {
        force = App.Force.UP;
        overlappers = this.bottomOverlappers;
      }
      return {
        distance: this.getMaxOverlap(force, overlappers),
        force: force
      };
    };

    YieldWithinOverlapTolerance.prototype.getMaxOverlap = function(force, overlappers) {
      var i, len, maxOverlap, overlap, overlapper;
      maxOverlap = 0;
      for (i = 0, len = overlappers.length; i < len; i++) {
        overlapper = overlappers[i];
        overlap = this.state.getOverlap(this.selectedWidget, overlapper);
        if (force === App.Force.LEFT || force === App.Force.RIGHT) {
          if (overlap.getWidth() > maxOverlap) {
            maxOverlap = overlap.getWidth();
          }
        } else {
          if (overlap.getHeight() > maxOverlap) {
            maxOverlap = overlap.getHeight();
          }
        }
      }
      return maxOverlap;
    };

    return YieldWithinOverlapTolerance;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ColorBoxDragHelper = (function(superClass) {
    extend(ColorBoxDragHelper, superClass);

    function ColorBoxDragHelper() {
      this.sortSeries = bind(this.sortSeries, this);
      this.startSort = bind(this.startSort, this);
      this.makeSortable = bind(this.makeSortable, this);
      ColorBoxDragHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires('el');
      this.makeSortable();
    }

    ColorBoxDragHelper.prototype.release = function() {
      this.destroySortable();
      return ColorBoxDragHelper.__super__.release.apply(this, arguments);
    };

    ColorBoxDragHelper.prototype.bindSortable = function() {
      return this.el.sortable({
        items: '.draggable-color',
        start: this.startSort,
        update: this.sortSeries,
        axis: "x"
      });
    };

    ColorBoxDragHelper.prototype.destroySortable = function() {
      if (this.el.data('ui-sortable')) {
        return this.el.sortable('destroy');
      }
    };

    ColorBoxDragHelper.prototype.makeSortable = function() {
      return this.bindSortable();
    };

    ColorBoxDragHelper.prototype.startSort = function(event, ui) {
      ui.item.addClass('drag');
      return this.moveFrom = ui.item.index();
    };

    ColorBoxDragHelper.prototype.sortSeries = function(event, ui) {
      ui.item.removeClass('drag');
      this.moveTo = ui.item.index();
      return this.trigger('updateSeries', this.moveTo, this.moveFrom);
    };

    return ColorBoxDragHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignColorThemesMenuController = (function(superClass) {
    extend(RedesignColorThemesMenuController, superClass);

    RedesignColorThemesMenuController.prototype.elements = {
      '.sg-menu': 'menuEl',
      '.sg-item-holder': 'itemHolderEl',
      '.sg-item': 'itemEl',
      '.sg-item.remove': 'removeItem',
      '.sg-item.default': 'setDefaultItem',
      '.delete-block': 'deleteBlock',
      '.set-default-block': 'defaultBlock'
    };

    RedesignColorThemesMenuController.prototype.events = {
      'click .sg-item.remove': 'showDeleteBlock',
      'click .delete.destructive-small': 'deleteTheme',
      'click .button.delete.cancel': 'hideMenu',
      'click .button.default.cancel': 'hideDefaultBlock',
      'click .sg-item.default': 'showDefault',
      'click .default.action-small': 'setAsSpaceDefault',
      'click .sg-item.edit': 'editTheme'
    };

    function RedesignColorThemesMenuController() {
      this.setAsSpaceDefault = bind(this.setAsSpaceDefault, this);
      this.deleteTheme = bind(this.deleteTheme, this);
      this.editTheme = bind(this.editTheme, this);
      RedesignColorThemesMenuController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'theme');
      this.html(this.view("redesign/settings/color_themes_menu")({
        theme: this.theme,
        confirmMessage: this.confirmMessage()
      }));
    }

    RedesignColorThemesMenuController.prototype.showDeleteBlock = function() {
      this.defaultBlock.slideUp();
      return this.deleteBlock.slideDown();
    };

    RedesignColorThemesMenuController.prototype.showDefault = function() {
      this.deleteBlock.slideUp();
      return this.defaultBlock.slideDown();
    };

    RedesignColorThemesMenuController.prototype.hideDefaultBlock = function() {
      return this.defaultBlock.slideUp();
    };

    RedesignColorThemesMenuController.prototype.hideMenu = function() {
      return this.deleteBlock.slideUp();
    };

    RedesignColorThemesMenuController.prototype.editTheme = function() {
      return this.trigger('edit-theme', this.theme);
    };

    RedesignColorThemesMenuController.prototype.deleteTheme = function() {
      App.Utils.logFeature('color-theme-delete');
      this.theme.destroy();
      return this.trigger('update-theme');
    };

    RedesignColorThemesMenuController.prototype.setAsSpaceDefault = function() {
      App.Utils.logFeature('color-theme-set-as-default');
      this.site.updateAttributes({
        default_color_theme_id: this.theme.id
      });
      App.Widget.trigger('refresh');
      return this.trigger('update-theme');
    };

    RedesignColorThemesMenuController.prototype.countMessage = function() {
      var chartCounts, dashboardCounts;
      dashboardCounts = App.SiteThemeUsageCount.dashboardCount;
      chartCounts = App.SiteThemeUsageCount.widgetCount;
      return "Setting default will impact " + dashboardCounts + " " + (App.Utils.pluralizeIf('dashboard', dashboardCounts !== 1)) + " and " + chartCounts + " " + (App.Utils.pluralizeIf('chart', chartCounts !== 1));
    };

    RedesignColorThemesMenuController.prototype.confirmMessage = function() {
      if (App.SiteThemeUsageCount.hasCounts()) {
        return this.countMessage();
      }
      return "Setting a new default theme will impact any dashboards and widgets that are set to use the site default theme";
    };

    return RedesignColorThemesMenuController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConditionalFormattingColorPickerController = (function(superClass) {
    extend(ConditionalFormattingColorPickerController, superClass);

    function ConditionalFormattingColorPickerController() {
      this.render = bind(this.render, this);
      return ConditionalFormattingColorPickerController.__super__.constructor.apply(this, arguments);
    }

    ConditionalFormattingColorPickerController.prototype.className = 'gradient-color-picker';

    ConditionalFormattingColorPickerController.prototype.elements = {
      '.custom.color-content': 'colorPickerArea',
      '.recent.color-content': 'recentColorsArea',
      '.theme.color-content': 'themeColorsArea'
    };

    ConditionalFormattingColorPickerController.prototype.events = {
      'click .action.reset': 'resetColor',
      'click .action.save': 'updateAndRelease',
      'click .rotator-title': 'toggleRotator',
      'click .color-type': 'selectColor'
    };

    ConditionalFormattingColorPickerController.prototype.render = function() {
      this.html(this.view('redesign/settings/conditional_formatting_color_picker')());
      return ConditionalFormattingColorPickerController.__super__.render.apply(this, arguments);
    };

    return ConditionalFormattingColorPickerController;

  })(App.DualColorPickerController);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CopyToButtonBlock = (function(superClass) {
    extend(CopyToButtonBlock, superClass);

    CopyToButtonBlock.prototype.className = 'copy-to-button-block button-block';

    CopyToButtonBlock.prototype.elements = {
      '.expandable': 'expandableArea',
      '.action.button': 'actionButton',
      '.destructive-large .label': 'destructiveLabel'
    };

    CopyToButtonBlock.prototype.events = {
      'mouseup .show-delete': 'showDeleteConfirmation',
      'mouseup .cancel-delete': 'cancelDelete',
      'mouseup .delete': 'delete',
      'mouseup .cancel-edit': 'maybeCancelEdit',
      'mouseup .cancel-discard-changes': 'cancelDiscardChanges',
      'mouseup .discard-changes': 'discardChanges',
      'mouseup .action .label': 'triggerSave',
      'mouseup .action .expand': 'toggleExpanded',
      'mouseup .copy-to': 'copyToClicked',
      'mouseup .move-to': 'moveToClicked',
      'mouseup .save-as-copy': 'saveAsCopyClicked'
    };

    function CopyToButtonBlock() {
      this["delete"] = bind(this["delete"], this);
      this.showDeleteConfirmation = bind(this.showDeleteConfirmation, this);
      CopyToButtonBlock.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'isDestructive', 'item');
    }

    CopyToButtonBlock.prototype.render = function() {
      this.html(this.view('redesign/controls/copy_to_button_block')({
        item: this.item,
        canOnlyEditChartAsCopy: AppRedesign.canOnlyEditChartAsCopy()
      }));
      if (this.actionDisabledFn != null) {
        return this.actionButton.toggleClass('disabled', this.actionDisabledFn());
      }
    };

    CopyToButtonBlock.prototype.triggerSave = function() {
      return this.trigger('save');
    };

    CopyToButtonBlock.prototype.copyToClicked = function() {
      this.trigger('copy-to');
      return this.collapse();
    };

    CopyToButtonBlock.prototype.moveToClicked = function() {
      this.trigger('move-to');
      return this.collapse();
    };

    CopyToButtonBlock.prototype.saveAsCopyClicked = function() {
      this.trigger('save-as-copy');
      return this.collapse();
    };

    CopyToButtonBlock.prototype.collapse = function() {
      return this.expandableArea.removeClass('open');
    };

    CopyToButtonBlock.prototype.toggleExpanded = function() {
      return this.expandableArea.toggleClass('open');
    };

    CopyToButtonBlock.prototype.maybeCancelEdit = function() {
      if (this.isDestructive()) {
        return this.showDiscardChangesConfirmation();
      } else {
        return this.trigger('cancel');
      }
    };

    CopyToButtonBlock.prototype.showDiscardChangesConfirmation = function() {
      return this.el.addClass('confirming-cancel');
    };

    CopyToButtonBlock.prototype.cancelDiscardChanges = function() {
      return this.el.removeClass('confirming-cancel');
    };

    CopyToButtonBlock.prototype.discardChanges = function() {
      return this.trigger('cancel');
    };

    CopyToButtonBlock.prototype.showDeleteConfirmation = function() {
      this.el.addClass('confirming-delete');
      return this.trigger('size-changed');
    };

    CopyToButtonBlock.prototype.cancelDelete = function() {
      this.el.removeClass('confirming-delete');
      return this.trigger('size-changed');
    };

    CopyToButtonBlock.prototype["delete"] = function() {
      return this.trigger('delete');
    };

    return CopyToButtonBlock;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardEmailRecipient = (function(superClass) {
    extend(RedesignDashboardEmailRecipient, superClass);

    RedesignDashboardEmailRecipient.prototype.className = 'dashboard-email-recipient';

    RedesignDashboardEmailRecipient.prototype.elements = {
      ".recipient-email": 'recipientEmail',
      ".remove-icon": 'removeButton',
      ".send-test": 'sendTest'
    };

    RedesignDashboardEmailRecipient.prototype.events = {
      "click .remove-icon": 'clickedRemove',
      "click .send-test": 'clickedSendTest'
    };

    function RedesignDashboardEmailRecipient() {
      this.clickedSendTest = bind(this.clickedSendTest, this);
      this.clickedRemove = bind(this.clickedRemove, this);
      RedesignDashboardEmailRecipient.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'value', 'onRemove');
      this.html(this.view('redesign/dashboard_email_reports/dashboard_email_recipient')());
      this.recipientEmail.text(this.value);
    }

    RedesignDashboardEmailRecipient.prototype.clickedRemove = function(e) {
      return this.onRemove(this.recipientEmail.text());
    };

    RedesignDashboardEmailRecipient.prototype.clickedSendTest = function(e) {
      App.Dashboard.currentDashboard().sendTestEmail(this.recipientEmail.text());
      this.sendTest.text("Sent");
      return this.sendTest.addClass("sent");
    };

    return RedesignDashboardEmailRecipient;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardEmailReports = (function(superClass) {
    extend(RedesignDashboardEmailReports, superClass);

    RedesignDashboardEmailReports.prototype.className = 'dashboard-email-reports';

    RedesignDashboardEmailReports.prototype.elements = {
      '.day-schedule': 'daySchedule',
      '.day-schedule .label': 'dayScheduleLabel',
      '.hour-schedule': 'hourSchedule',
      '.hour-schedule .label': 'hourScheduleLabel',
      '.default-filters': 'defaultFilters',
      '.default-filters-title': 'defaultFiltersTitle',
      '.slack-container': 'slackContainer',
      '.email-container': 'emailContainer'
    };

    RedesignDashboardEmailReports.prototype.events = {
      'change .day-schedule': 'changedDaySchedule',
      'change .hour-schedule': 'changedHourSchedule'
    };

    RedesignDashboardEmailReports.DAY_ITEMS = [
      {
        name: 'DAILY',
        value: 0
      }, {
        name: 'MONDAY',
        value: 1
      }, {
        name: 'TUESDAY',
        value: 2
      }, {
        name: 'WEDNESDAY',
        value: 3
      }, {
        name: 'THURSDAY',
        value: 4
      }, {
        name: 'FRIDAY',
        value: 5
      }, {
        name: 'SATURDAY',
        value: 6
      }, {
        name: 'SUNDAY',
        value: 7
      }
    ];

    RedesignDashboardEmailReports.HOUR_ITEMS = [
      {
        name: 'MIDNIGHT',
        value: 0
      }, {
        name: '1AM',
        value: 1
      }, {
        name: '2AM',
        value: 2
      }, {
        name: '3AM',
        value: 3
      }, {
        name: '4AM',
        value: 4
      }, {
        name: '5AM',
        value: 5
      }, {
        name: '6AM',
        value: 6
      }, {
        name: '7AM',
        value: 7
      }, {
        name: '8AM',
        value: 8
      }, {
        name: '9AM',
        value: 9
      }, {
        name: '10AM',
        value: 10
      }, {
        name: '11AM',
        value: 11
      }, {
        name: 'NOON',
        value: 12
      }, {
        name: '1PM',
        value: 13
      }, {
        name: '2PM',
        value: 14
      }, {
        name: '3PM',
        value: 15
      }, {
        name: '4PM',
        value: 16
      }, {
        name: '5PM',
        value: 17
      }, {
        name: '6PM',
        value: 18
      }, {
        name: '7PM',
        value: 19
      }, {
        name: '8PM',
        value: 20
      }, {
        name: '9PM',
        value: 21
      }, {
        name: '10PM',
        value: 22
      }, {
        name: '11PM',
        value: 23
      }
    ];

    RedesignDashboardEmailReports.DROPDOWN_WIDTH = '311px';

    function RedesignDashboardEmailReports() {
      this.saveRecipients = bind(this.saveRecipients, this);
      this.changedHourSchedule = bind(this.changedHourSchedule, this);
      this.changedDaySchedule = bind(this.changedDaySchedule, this);
      this.dashboardUpdated = bind(this.dashboardUpdated, this);
      var config, d, dimensions, i, len, ref, showEmail, showFilters, showSlack, startDay, startHour;
      RedesignDashboardEmailReports.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      config = this.dashboard.dimensionConfig();
      showFilters = this.dashboard.filtersEnabled() && _.size(config.canonicalizedDimensions()) > 0;
      if (AppRedesign.current().state.RbacEnabled) {
        showEmail = !App.Site.first().forbid_email_reports && AppRedesign.emailReportsEnabledOnDashboard();
        showSlack = !App.Site.first().forbid_slack_reports && AppRedesign.emailReportsEnabledOnDashboard() && AppRedesign.slackEnabled();
      } else {
        showEmail = !App.Site.first().forbid_email_reports;
        showSlack = !App.Site.first().forbid_slack_reports && AppRedesign.slackEnabled();
      }
      this.html(this.view('redesign/dashboard_email_reports/dashboard_email_reports')({
        showFilters: showFilters,
        days: App.RedesignDashboardEmailReports.DAY_ITEMS,
        hours: App.RedesignDashboardEmailReports.HOUR_ITEMS,
        showSlack: showSlack,
        showEmail: showEmail
      }));
      this.emailsList = new App.RedesignAddRemoveListController({
        el: this.emailContainer,
        itemClass: App.RedesignDashboardEmailRecipient,
        saveCallback: this.saveRecipients
      });
      this.emailsList.addItems(this.parseRecipients(this.dashboard.recurring_report_recipients).join(','));
      if (showFilters) {
        dimensions = config.canonicalizedDimensionMap(true);
        ref = Object.keys(dimensions);
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          this.defaultFilters.append(this.view('redesign/dashboards/dashboard_settings_filter_item')({
            dimensionId: d,
            dimensionArray: dimensions[d]
          }));
        }
      }
      this.daySchedule.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: App.RedesignDashboardEmailReports.DROPDOWN_WIDTH
      });
      startDay = this.dashboard.recurring_report_day_of_week;
      if (startDay != null) {
        this.daySchedule.val(startDay + 1);
        this.daySchedule.trigger("chosen:updated");
      }
      this.hourSchedule.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: App.RedesignDashboardEmailReports.DROPDOWN_WIDTH
      });
      startHour = this.dashboard.recurring_report_hour_of_day;
      if (startHour == null) {
        startHour = 7;
      }
      this.hourSchedule.val(startHour);
      this.hourSchedule.trigger("chosen:updated");
      App.Dashboard.bind('update', this.dashboardUpdated);
      if (showSlack) {
        this.slackReactRoot = App.ReactRoot.create({
          name: 'slackRecipientInputListRoot',
          params: [this.dashboard.id]
        });
        this.slackContainer.append(this.slackReactRoot.el);
      }
    }

    RedesignDashboardEmailReports.prototype.release = function() {
      var ref;
      RedesignDashboardEmailReports.__super__.release.apply(this, arguments);
      App.Dashboard.unbind('update', this.dashboardUpdated);
      return (ref = this.slackReactRoot) != null ? ref.release() : void 0;
    };

    RedesignDashboardEmailReports.prototype.dashboardUpdated = function(dashModel) {
      if (dashModel.id === this.dashboard.id) {
        return this.dashboard.reload();
      }
    };

    RedesignDashboardEmailReports.prototype.changedDaySchedule = function(e) {
      var day;
      day = this.daySchedule[0].selectedIndex - 1;
      this.dashboard.recurring_report_day_of_week = day;
      if (day === -1) {
        this.dashboard.recurring_report_schedule = 'daily';
      } else {
        this.dashboard.recurring_report_schedule = 'weekly';
      }
      this.dashboard.save();
      return this.updateDashboardReportSchedule();
    };

    RedesignDashboardEmailReports.prototype.changedHourSchedule = function(e) {
      var hour;
      hour = this.hourSchedule[0].selectedIndex;
      this.dashboard.recurring_report_hour_of_day = hour;
      this.dashboard.save();
      return this.updateDashboardReportSchedule();
    };

    RedesignDashboardEmailReports.prototype.updateDashboardReportSchedule = function() {
      var day_of_week, hour_of_day;
      day_of_week = this.daySchedule[0].selectedIndex - 1;
      hour_of_day = this.hourSchedule[0].selectedIndex;
      return jQuery.ajax({
        url: "/dashboard_reports/update_schedule_for_all_reports",
        type: "POST",
        data: {
          client_site_id: App.Site.first().id,
          dashboard_id: this.dashboard.id,
          day_of_week: day_of_week,
          hour_of_day: hour_of_day
        }
      });
    };

    RedesignDashboardEmailReports.prototype.saveRecipients = function() {
      return this.dashboard.updateAttributes({
        recurring_report_recipients: this.emailsList.joinValues()
      });
    };

    RedesignDashboardEmailReports.prototype.parseRecipients = function(recipients) {
      if (!recipients) {
        return [];
      }
      recipients = recipients.split(/[, ]+/).sort();
      return _.filter(recipients, function(r) {
        return r !== '';
      });
    };

    return RedesignDashboardEmailReports;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardFreshnessController = (function(superClass) {
    extend(DashboardFreshnessController, superClass);

    DashboardFreshnessController.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function DashboardFreshnessController() {
      this.render = bind(this.render, this);
      this._onChange = bind(this._onChange, this);
      this._initSchedules = bind(this._initSchedules, this);
      DashboardFreshnessController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'dashboard', 'renderCallback');
      App.SourceFetcher.bind(App.SourceFetcher.EVENT_SOURCES_FETCHED, this.render);
      App.WidgetFetcher.bind(App.WidgetFetcher.EVENT_WIDGETS_ALL_FETCHED, this.render);
      this.dashboard.bind('update', this._onChange);
      App.Schedule.bind('create', this._onChange);
      this._initSchedules();
      this.render();
    }

    DashboardFreshnessController.prototype._initSchedules = function() {
      var ref, ref1;
      this.schedule = App.Schedule.exists(this.dashboard.schedule_id);
      this.defaultSchedule = App.Site.first().schedule();
      this.schedule !== false && this.schedule.unbind('update', this._onChange);
      if ((ref = this.defaultSchedule) != null) {
        ref.unbind('update', this._onChange);
      }
      this.schedule !== false && this.schedule.bind('update', this._onChange);
      return (ref1 = this.defaultSchedule) != null ? ref1.bind('update', this._onChange) : void 0;
    };

    DashboardFreshnessController.prototype._onChange = function() {
      this._initSchedules();
      return this.render();
    };

    DashboardFreshnessController.prototype.render = function() {
      var ref;
      this.html("<div class=\"react-root\"></div>");
      if (!(this.schedule && this.defaultSchedule)) {
        return;
      }
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      this.reactRoot = window.reactApp.dashboardFreshnessRoot(this.reactRootEl[0], this.constructor.scheduleAttributes(this.schedule), this.constructor.scheduleAttributes(this.defaultSchedule), this.dashboard.getOldestWidgetLastRefreshMs(), !this.dashboard.widgets().isEmpty(), this.dashboard.hasNonrefreshedWidgets(), !this.dashboard.isCompletelyLoaded(), App.Site.first().isDashboardRefreshEnabled());
      return this.renderCallback();
    };

    DashboardFreshnessController.scheduleAttributes = function(schedule) {
      var attrs;
      attrs = schedule.attributes();
      if (attrs.next_run_at != null) {
        attrs.next_run_at = new Date(attrs.next_run_at).getTime();
      }
      return attrs;
    };

    DashboardFreshnessController.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      this.schedule !== false && this.schedule.unbind('update', this._onChange);
      if ((ref1 = this.defaultSchedule) != null) {
        ref1.unbind('update', this._onChange);
      }
      this.dashboard.unbind('update', this._onChange);
      App.Schedule.unbind('create', this._onChange);
      return DashboardFreshnessController.__super__.release.apply(this, arguments);
    };

    return DashboardFreshnessController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardItemContainerController = (function(superClass) {
    extend(DashboardItemContainerController, superClass);

    DashboardItemContainerController.prototype.className = 'widget-container dashboard-item-container';

    function DashboardItemContainerController() {
      this.flash = bind(this.flash, this);
      this.reposition = bind(this.reposition, this);
      this.update = bind(this.update, this);
      this.sizeUpdated = bind(this.sizeUpdated, this);
      this.isRearrangeable = bind(this.isRearrangeable, this);
      this.makeTitleDraggable = bind(this.makeTitleDraggable, this);
      this.renderPriority = bind(this.renderPriority, this);
      this.renderIfInViewport = bind(this.renderIfInViewport, this);
      this.canBeRendered = bind(this.canBeRendered, this);
      this.isOnCurrentDashboard = bind(this.isOnCurrentDashboard, this);
      this.release = bind(this.release, this);
      var dashboardItemControllerClass;
      DashboardItemContainerController.__super__.constructor.apply(this, arguments);
      this.el.addClass((_.kebabCase(this.item.constructor.className)) + "-" + this.item.id);
      this.addSizing();
      this.dashboard = this.item.dashboard();
      this.bind("render-if-in-viewport", this.renderIfInViewport);
      this.dashboardSizer = new App.RedesignDashboardSizer(this.dashboard);
      if (this.dashboard.isArchived() || AppRedesign.current().state.overloaded_site) {
        dashboardItemControllerClass = App.ArchivedWidgetController;
      } else {
        if (this.item.content_type === 'TextBox') {
          if (AppRedesign.textOnDashboardEnabled()) {
            dashboardItemControllerClass = App.TextBoxController;
          } else {
            dashboardItemControllerClass = App.EmptyBoxController;
          }
        } else {
          dashboardItemControllerClass = App.RedesignWidgetsController;
        }
      }
      if (!dashboardItemControllerClass) {
        throw new Error(this.item.dashboard_item_type + "Controller does not exist");
      }
      this.dashboardItemController = new dashboardItemControllerClass({
        el: this.el,
        item: this.item,
        resizableFunc: this.isRearrangeable,
        canBeRenderedFunc: this.canBeRendered,
        renderPriorityFunc: this.renderPriority
      });
      this.dashboardItemController.bind("size-updated", this.sizeUpdated);
      this.dashboardItemController.bind("title-needs-draggability", this.makeTitleDraggable);
      this.bubbles(this.dashboardItemController, 'edit-widget');
      this.bindEvents();
      if (AppRedesign.current().state.overloaded_site) {
        this.showBusyState();
      }
    }

    DashboardItemContainerController.prototype.release = function() {
      var ref, ref1;
      if (this.released) {
        return;
      }
      this.item.unbind("update", this.update);
      this.item.unbind("destroy", this.release);
      this.item.unbind("flash", this.flash);
      if ((ref = this.dashboardItemController) != null) {
        ref.release();
      }
      if ((ref1 = this.dragHelper) != null) {
        ref1.release();
      }
      this.released = true;
      return DashboardItemContainerController.__super__.release.apply(this, arguments);
    };

    DashboardItemContainerController.prototype.addSizing = function() {
      this.el.css({
        left: this.left,
        top: this.top,
        width: this.width,
        height: this.height
      });
      return this.el.toggleClass('left-gutter', this.left === 0);
    };

    DashboardItemContainerController.prototype.destroyDraggable = function() {
      var ref;
      return (ref = this.dragHelper) != null ? ref.destroyDraggable() : void 0;
    };

    DashboardItemContainerController.prototype.showBusyState = function() {
      return new App.OverloadedSiteController();
    };

    DashboardItemContainerController.prototype.isOnCurrentDashboard = function() {
      var dash;
      dash = App.Dashboard.exists(this.item.dashboard_id);
      return dash && dash.active;
    };

    DashboardItemContainerController.prototype.nearTopOfViewport = function() {
      var offset;
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return true;
      }
      offset = this.el.offset();
      if (offset == null) {
        return false;
      }
      return offset.top < window.innerHeight * 1.2 && this.el.height() + offset.top > -10;
    };

    DashboardItemContainerController.prototype.canBeRendered = function() {
      return this.isOnCurrentDashboard() && this.nearTopOfViewport();
    };

    DashboardItemContainerController.prototype.bindEvents = function() {
      this.eventsBound = true;
      this.item.bind("update", this.update);
      this.item.bind("destroy", this.release);
      return this.item.bind("flash", this.flash);
    };

    DashboardItemContainerController.prototype.renderIfInViewport = function() {
      return this.dashboardItemController.renderIfInViewport();
    };

    DashboardItemContainerController.prototype.renderPriority = function() {
      if (this.item == null) {
        return App.UiQueue.PRIORITY_DEFAULT;
      }
      return (this.item.getRow() || 0) / 100.0 + (this.item.getColumn() || 0) / 1000.0;
    };

    DashboardItemContainerController.prototype.makeTitleDraggable = function() {
      return this.bindDraggable();
    };

    DashboardItemContainerController.prototype.isRearrangeable = function() {
      return this.dashboard.isRearrangeableByCurrentUser() && !(typeof app !== "undefined" && app !== null ? app.tvmode : void 0);
    };

    DashboardItemContainerController.prototype.bindDraggable = function() {
      this.refreshElements();
      this.destroyDraggable();
      this.dragHelper = new App.RedesignChartDragHelper({
        item: this.item,
        el: this.el,
        rearrangeableFunc: this.isRearrangeable
      });
      return this.dragHelper.bindDraggable();
    };

    DashboardItemContainerController.prototype.sizeUpdated = function() {
      this.item.sizeTo(this.item.getWidth(), this.item.getHeight(), true);
      return this.item.dashboard().trigger("resized-widget", this.item);
    };

    DashboardItemContainerController.prototype.update = function() {
      this.item.reload();
      this.reposition();
      return this.dashboardItemController.update();
    };

    DashboardItemContainerController.prototype.reposition = function() {
      if (!this.canBeRendered()) {
        this.dashboardItemController.returnToUnrenderedState();
      }
      if (this.el.hasClass('clip-widget')) {
        return;
      }
      App.Lagotron.addContext("widget.reposition");
      if (this.setElementDashboardPosition()) {
        this.dashboardItemController.changedSize();
        return this.destroyDraggable();
      }
    };

    DashboardItemContainerController.prototype.setElementDashboardPosition = function() {
      var newHeight, newWidth, oldHeight, oldWidth, ref;
      oldWidth = this.el.width();
      oldHeight = this.el.height();
      ref = this.dashboardSizer.setWidgetDashboardPosition(this.el, this.item), newWidth = ref[0], newHeight = ref[1];
      return (oldWidth !== newWidth) || (oldHeight !== newHeight);
    };

    DashboardItemContainerController.prototype.flash = function() {
      this.el.addClass('flash-on');
      setTimeout(((function(_this) {
        return function() {
          return _this.el.addClass('flashing');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      return setTimeout(((function(_this) {
        return function() {
          return _this.el.removeClass('flashing flash-on');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME + 1300);
    };

    return DashboardItemContainerController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardColorThemesController = (function(superClass) {
    extend(DashboardColorThemesController, superClass);

    DashboardColorThemesController.prototype.className = 'dashboard-color-theme';

    DashboardColorThemesController.prototype.elements = {
      '.color-theme-box.default': 'colorThemeBox',
      '.icon.expando': 'iconExpando',
      '.top-label .name': 'name',
      '.default-theme-container': 'defaultTheme',
      '.top-label': 'topLabel',
      '.scroll-container': 'scrollContainer'
    };

    DashboardColorThemesController.prototype.events = {
      'click .top-label': 'clickTopLabel',
      'click .color-theme-box .color-theme-row': 'selectColorTheme',
      'click': 'stopPropagation'
    };

    function DashboardColorThemesController() {
      this.renderColors = bind(this.renderColors, this);
      this.unparentEl = bind(this.unparentEl, this);
      this.clickTopLabel = bind(this.clickTopLabel, this);
      this.render = bind(this.render, this);
      this.renderContent = bind(this.renderContent, this);
      this.themeWasChanged = bind(this.themeWasChanged, this);
      this.selectColorTheme = bind(this.selectColorTheme, this);
      this.reRender = bind(this.reRender, this);
      this.release = bind(this.release, this);
      DashboardColorThemesController.__super__.constructor.apply(this, arguments);
      this.originalTheme = this.dashboard.colorTheme();
      App.Utils.requires(this, 'el', 'dashboard');
      App.Site.bind('update-color-themes', this.reRender);
      this.render();
      this.maybeDisable();
      $(window).on('resize', this.unparentEl);
    }

    DashboardColorThemesController.prototype.release = function() {
      this.unparentEl();
      App.Site.unbind('update-color-themes', this.reRender);
      return DashboardColorThemesController.__super__.release.apply(this, arguments);
    };

    DashboardColorThemesController.prototype.save = function() {
      if (this.themeWasChanged()) {
        return;
      }
      return App.Widget.trigger('refresh');
    };

    DashboardColorThemesController.prototype.reRender = function() {
      var theme;
      theme = this.view('redesign/dashboard_preferences/dashboard_color_themes_row')({
        theme: this.dashboard.colorTheme(),
        useParentTheme: this.dashboard.useSpaceTheme()
      });
      this.defaultTheme.html(theme);
      return this.addBorders();
    };

    DashboardColorThemesController.prototype.selectColorTheme = function(e) {
      var id, theme, usePeriscopeTheme;
      if (this.themeWasChanged()) {
        App.Utils.logFeature('color-theme-dashboard-change');
      }
      theme = $(e.currentTarget).data('theme');
      id = theme.newDefaultColorThemeIdForDashboard;
      usePeriscopeTheme = theme.usePeriscopeTheme;
      return this.updateTheme(id, usePeriscopeTheme);
    };

    DashboardColorThemesController.prototype.updateTheme = function(themeId, usePeriscopeTheme) {
      this.dashboard.default_color_theme_id = themeId;
      this.dashboard.use_periscope_theme = usePeriscopeTheme;
      this.reRender();
      return this.unparentEl();
    };

    DashboardColorThemesController.prototype.themeWasChanged = function() {
      return this.originalTheme.id === this.dashboard.colorTheme().id;
    };

    DashboardColorThemesController.prototype.addBorders = function() {
      var squares;
      squares = $(this.el).find('.color-square.dashboard');
      return $(squares).each(function() {
        return App.ColorHelper.toggleBorderClassOnColorLightness($(this), $(this).css('background-color'), 'show-border', 200);
      });
    };

    DashboardColorThemesController.prototype.renderContent = function() {
      this.render();
      this.renderColors();
      this.reRender();
      return this.reparentEl();
    };

    DashboardColorThemesController.prototype.render = function() {
      this.html(this.view('redesign/dashboard_preferences/dashboard_color_themes')({
        defaultTheme: this.dashboard.colorTheme(),
        useParentTheme: this.dashboard.useSpaceTheme()
      }));
      return this.addBorders();
    };

    DashboardColorThemesController.prototype.clickTopLabel = function() {
      if (this.isDisabled()) {
        return;
      }
      if (this.isOpen()) {
        return this.unparentEl();
      } else {
        return this.renderContent();
      }
    };

    DashboardColorThemesController.prototype.reparentEl = function() {
      this.el.addClass('open');
      this.placeholder = $('<div class="reparent-placeholder"/>').css({
        height: this.topLabel.outerHeight(),
        width: this.topLabel.outerWidth()
      });
      this.reparentContainer = $('<div class="reparent-container dashboard-preferences-color-theme"/>').css(_.pick(this.el.offset(), 'left', 'top'));
      $('.dashboard-preferences-container').after(this.reparentContainer);
      this.reparentContainer.append(this.el.before(this.placeholder).detach());
      return $('#body').on('click', this.clickTopLabel);
    };

    DashboardColorThemesController.prototype.unparentEl = function() {
      if (this.reparentContainer == null) {
        return;
      }
      this.el.removeClass('open');
      $('#body').off('click', this.clickTopLabel);
      this.el = this.reparentContainer.detach().contents();
      this.placeholder.replaceWith(this.el);
      return delete this.reparentedTopLabel;
    };

    DashboardColorThemesController.prototype.getOptions = function() {
      return App.ColorTheme.themeOptions(this.dashboard, App.Site.first());
    };

    DashboardColorThemesController.prototype.renderColors = function() {
      var i, len, option, options, themeView, themeViewRow;
      options = this.getOptions();
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        themeView = this.view('redesign/dashboard_preferences/dashboard_color_themes_row')({
          themeId: option.id,
          theme: option.theme,
          useParentTheme: option.useParentTheme
        });
        themeViewRow = $(themeView).data({
          'theme': {
            newDefaultColorThemeIdForDashboard: option.id,
            usePeriscopeTheme: option.usePeriscopeTheme
          }
        });
        this.colorThemeBox.append(themeViewRow);
      }
      return this.addBorders();
    };

    DashboardColorThemesController.prototype.maybeDisable = function() {
      var isAdmin, isOwner, shouldDisable, singleTheme, userHasPermissions;
      isOwner = (this.dashboard.user_id != null) && this.dashboard.user_id === App.User.safeCurrentUser().id;
      isAdmin = App.User.safeCurrentUser().isAdmin();
      userHasPermissions = isOwner || isAdmin;
      singleTheme = App.ColorTheme.count() === 0;
      shouldDisable = AppRedesign.readOnlyMaintenanceMode() || !userHasPermissions || singleTheme;
      this.iconExpando.toggle(!shouldDisable);
      return this.el.toggleClass('disabled', shouldDisable);
    };

    DashboardColorThemesController.prototype.isDisabled = function() {
      return this.el.hasClass('disabled');
    };

    DashboardColorThemesController.prototype.isOpen = function() {
      return this.el.hasClass('open');
    };

    DashboardColorThemesController.prototype.stopPropagation = function(e) {
      return e.stopPropagation();
    };

    return DashboardColorThemesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardPermissionsController = (function(superClass) {
    extend(RedesignDashboardPermissionsController, superClass);

    RedesignDashboardPermissionsController.prototype.className = 'dashboard-permissions';

    RedesignDashboardPermissionsController.prototype.elements = {
      '.permission-box.default': 'defaultPermissionBox',
      '.permission-box.custom-groups': 'customGroupsPermissionBox',
      '.error-message': 'errorMessage',
      '.icon.expando': 'iconExpando',
      '.top-label .name': 'name',
      '.top-label': 'topLabel',
      '.scroll-container .body': 'scrollContainer',
      '.custom-groups': 'customGroups'
    };

    RedesignDashboardPermissionsController.prototype.events = {
      'click .top-label': 'clickTopLabel',
      'click .small-checkbox.selected:not(.disabled)': 'uncheckedPermission',
      'click .small-checkbox:not(.selected):not(.disabled)': 'checkedPermission'
    };

    RedesignDashboardPermissionsController.defaultGroupNames = function() {
      return _.at(App.Group, 'OWNER', 'ADMINS', 'ALL_USERS');
    };

    function RedesignDashboardPermissionsController() {
      this.uncheckedPermission = bind(this.uncheckedPermission, this);
      this.updateUiForGroups = bind(this.updateUiForGroups, this);
      this.release = bind(this.release, this);
      RedesignDashboardPermissionsController.__super__.constructor.apply(this, arguments);
      this.permissionProxies = _.map(this.currentDashboardGroupPermissions(), (function(_this) {
        return function(permission) {
          return new _this.constructor.PermissionProxy(permission);
        };
      })(this));
      App.Utils.requires(this, 'el', 'dashboard');
      this.allUsersGroup = App.Group.findByAttribute('all_users', true);
      this.adminGroup = App.Group.findByAttribute('admin', true);
      this.canEdit = this.dashboard.isOwnedByCurrentUser() || App.User.safeCurrentUser().isAdmin();
      this.html(this.view('redesign/dashboard_preferences/dashboard_permissions')({
        can_edit: this.canEdit
      }));
      this.updateUiForGroups();
      App.Site.bind('group-change', this.updateUiForGroups);
      this.elementReparenter = new App.ElementReparenter({
        el: this.el,
        unparentCallback: ((function(_this) {
          return function() {
            return _this.el.find('.small-checkbox .icon').off('click', _this.updatePermission);
          };
        })(this))
      });
    }

    RedesignDashboardPermissionsController.PermissionProxy = (function() {
      PermissionProxy["new"] = function(options) {
        var permission;
        permission = new App.DashboardGroupPermission(options);
        return new this(permission);
      };

      function PermissionProxy(permission1) {
        this.permission = permission1;
        this.dashboard_id = this.permission.dashboard_id;
        this.group_id = this.permission.group_id;
        this.canEditInitial = this.permission.can_edit;
      }

      PermissionProxy.prototype.canEdit = function() {
        return this.permission.can_edit;
      };

      PermissionProxy.prototype.forGroupId = function(groupId) {
        return this.permission.group_id === groupId;
      };

      PermissionProxy.prototype.groupId = function() {
        return this.group_id;
      };

      PermissionProxy.prototype.setCanEdit = function(canEdit) {
        this.permission.can_edit = canEdit;
        return true;
      };

      PermissionProxy.prototype.hasChanged = function() {
        return this.permission.can_edit !== this.canEditInitial;
      };

      PermissionProxy.prototype.destroy = function() {
        return this.permission.destroy();
      };

      PermissionProxy.prototype.save = function() {
        return this.permission.save();
      };

      return PermissionProxy;

    })();

    RedesignDashboardPermissionsController.prototype.release = function() {
      App.Site.unbind('group-change', this.updateUiForGroups);
      return RedesignDashboardPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardPermissionsController.prototype.unparentAllReparented = function() {
      return this.elementReparenter.unparentEl();
    };

    RedesignDashboardPermissionsController.prototype.updateUiForGroups = function() {
      var scrollPosition;
      this.dashboard.reload();
      this.maybeDisable();
      if (this.isOpen()) {
        scrollPosition = this.scrollContainer.scrollTop();
        this.updatePermissions();
        return this.scrollContainer.scrollTop(scrollPosition);
      } else {
        return this.updateName();
      }
    };

    RedesignDashboardPermissionsController.prototype.currentDashboardGroupPermissions = function() {
      var result;
      result = _(App.DashboardGroupPermission.all()).filter({
        dashboard_id: this.dashboard.id
      });
      if (this.adminGroup) {
        result = result.reject({
          group_id: this.adminGroup.id
        });
      }
      return result.value();
    };

    RedesignDashboardPermissionsController.prototype.setPermissionMap = function() {
      return this.permissionMap = App.DashboardGroupPermission.permissionMap()[this.dashboard.id] || {};
    };

    RedesignDashboardPermissionsController.prototype.renderContent = function() {
      this.updatePermissions();
      return this.reparentEl();
    };

    RedesignDashboardPermissionsController.prototype.updatePermissions = function() {
      this.html(this.view('redesign/dashboard_preferences/dashboard_permissions')({
        can_edit: this.canEdit
      }));
      this.renderVisibilityRadioButtons();
      return this.updateName();
    };

    RedesignDashboardPermissionsController.prototype.reparentEl = function() {
      return this.elementReparenter.reparentElWithClassname('dashboard-preferences-permissions');
    };

    RedesignDashboardPermissionsController.prototype.updateName = function() {
      return this.name.text(this.menuName());
    };

    RedesignDashboardPermissionsController.prototype.menuName = function() {
      if (this.allUsersGroupPermission() != null) {
        if (this.allUsersGroupPermission().canEdit()) {
          return 'Editable by Everyone';
        }
        return 'Viewable by Everyone';
      }
      switch (false) {
        case !this.someGroupCanEdit():
          return 'Editable by Certain Groups';
        case !!_.isEmpty(this.permissionProxies):
          return 'Viewable by Certain Groups';
        default:
          return 'Viewable Only by ' + this.dashboardOwner();
      }
    };

    RedesignDashboardPermissionsController.prototype.allUsersGroupPermission = function() {
      var ref;
      return this.findPermission((ref = this.allUsersGroup) != null ? ref.id : void 0);
    };

    RedesignDashboardPermissionsController.prototype.someGroupCanEdit = function() {
      return _.some(this.permissionProxies, function(proxy) {
        return proxy.canEdit();
      });
    };

    RedesignDashboardPermissionsController.prototype.dashboardOwner = function() {
      if (this.dashboard.isOwnedByCurrentUser()) {
        return 'Me';
      } else {
        return 'Owner';
      }
    };

    RedesignDashboardPermissionsController.prototype.clickTopLabel = function(e) {
      if (this.isDisabled()) {
        return;
      }
      if (this.isOpen()) {
        return this.elementReparenter.unparentEl();
      } else {
        return this.renderContent();
      }
    };

    RedesignDashboardPermissionsController.prototype.checkedPermission = function(e) {
      var canEdit, checkbox, groupId, permissionProxy, type;
      checkbox = $(e.currentTarget);
      groupId = checkbox.data('group-id');
      type = checkbox.data('permission');
      canEdit = type === 'edit';
      permissionProxy = this.findPermission(groupId);
      if (permissionProxy) {
        if (canEdit) {
          permissionProxy.setCanEdit(true);
        }
      } else {
        this.permissionProxies.push(this.constructor.PermissionProxy["new"]({
          can_edit: canEdit,
          dashboard_id: this.dashboard.id,
          group_id: groupId
        }));
      }
      return this.updateUiForGroups();
    };

    RedesignDashboardPermissionsController.prototype.uncheckedPermission = function(e) {
      var checkbox, groupId, permissionType;
      checkbox = $(e.currentTarget);
      permissionType = checkbox.data('permission');
      groupId = checkbox.data('group-id');
      if (groupId === this.allUsersGroup.id) {
        this.removeAllPermissions(permissionType);
      } else {
        this.removePermission(groupId, permissionType);
      }
      return this.updateUiForGroups();
    };

    RedesignDashboardPermissionsController.prototype.removeAllPermissions = function(type) {
      if (type === 'view') {
        return this.permissionProxies = [];
      } else if (type === 'edit') {
        return _.each(this.permissionProxies, _.method('setCanEdit', false));
      }
    };

    RedesignDashboardPermissionsController.prototype.removePermission = function(groupId, type) {
      if (type === 'view') {
        return _.remove(this.permissionProxies, _.method('forGroupId', groupId));
      } else if (type === 'edit') {
        return this.findPermission(groupId).setCanEdit(false);
      }
    };

    RedesignDashboardPermissionsController.prototype.save = function() {
      var toBeDestroyed, toBeSaved;
      toBeDestroyed = _.differenceBy(this.currentDashboardGroupPermissions(), this.permissionProxies, 'dashboard_id', 'group_id');
      _(toBeDestroyed).each(_.method('destroy'));
      toBeSaved = _.filter(this.permissionProxies, function(proxy) {
        return proxy.permission.isNew() || proxy.hasChanged();
      });
      _(toBeSaved).each(_.method('save'));
      if (toBeDestroyed.length > 0 || toBeSaved.length > 0) {
        return App.Utils.logFeature("update_dashboard_group_permission_from_dashboard_settings_page");
      }
    };

    RedesignDashboardPermissionsController.prototype.errorDetails = function(e) {
      var checkbox, details, group_id, isChecked, isDisabled, ref;
      checkbox = $(e.target).parent();
      group_id = checkbox.data('group-id');
      isChecked = checkbox.hasClass('selected');
      isDisabled = checkbox.hasClass('disabled');
      details = ["dashboard_id: " + ((ref = this.dashboard) != null ? ref.id : void 0), "group_id: " + group_id, "isChecked: " + isChecked, "isDisabled: " + isDisabled];
      return "\n" + details.join("\n");
    };

    RedesignDashboardPermissionsController.prototype.ownerGroupViewOptions = function() {
      return {
        group: {
          id: 'none',
          name: 'Owner'
        },
        viewIsChecked: true,
        editIsChecked: true,
        viewDisabled: true,
        editDisabled: true
      };
    };

    RedesignDashboardPermissionsController.prototype.adminGroupViewOptions = function() {
      return {
        group: {
          id: 'none',
          name: 'Admin'
        },
        viewIsChecked: true,
        editIsChecked: true,
        viewDisabled: true,
        editDisabled: true
      };
    };

    RedesignDashboardPermissionsController.prototype.allUsersGroupViewOptions = function() {
      var allUsersGroupPermission, ref;
      allUsersGroupPermission = this.allUsersGroupPermission();
      return {
        group: {
          id: (ref = this.allUsersGroup) != null ? ref.id : void 0,
          name: 'All Users'
        },
        viewIsChecked: allUsersGroupPermission != null,
        editIsChecked: allUsersGroupPermission != null ? allUsersGroupPermission.canEdit() : void 0,
        viewDisabled: false,
        editDisabled: false
      };
    };

    RedesignDashboardPermissionsController.prototype.findPermission = function(groupId) {
      return _.find(this.permissionProxies, _.method('forGroupId', groupId));
    };

    RedesignDashboardPermissionsController.prototype.renderVisibilityRadioButtons = function() {
      var allUsersGroupPermission, allUsersGroups, checkboxRow, customGroups, defaultGroupsOptions, group, i, len, permissionProxy, results;
      allUsersGroups = _.filter(App.Group.all(), {
        name: 'All Users'
      });
      this.setPermissionMap();
      defaultGroupsOptions = [this.ownerGroupViewOptions(), this.adminGroupViewOptions(), this.allUsersGroupViewOptions()];
      _(defaultGroupsOptions).each((function(_this) {
        return function(defaultGroupOptions) {
          var checkboxRow;
          checkboxRow = _this.view('redesign/dashboard_preferences/dashboard_permission_row')(defaultGroupOptions);
          return _this.defaultPermissionBox.append(checkboxRow);
        };
      })(this));
      customGroups = _.differenceBy(App.Group.all(), [this.adminGroup, this.allUsersGroup], 'id');
      if (_.isEmpty(customGroups)) {
        this.customGroups.hide();
      }
      allUsersGroupPermission = this.allUsersGroupPermission();
      results = [];
      for (i = 0, len = customGroups.length; i < len; i++) {
        group = customGroups[i];
        permissionProxy = this.findPermission(group.id);
        checkboxRow = this.view('redesign/dashboard_preferences/dashboard_permission_row')({
          group: {
            id: group.id,
            name: group.name
          },
          viewIsChecked: (permissionProxy != null) || (allUsersGroupPermission != null),
          editIsChecked: (permissionProxy != null ? permissionProxy.canEdit() : void 0) || (allUsersGroupPermission != null ? allUsersGroupPermission.canEdit() : void 0),
          viewDisabled: allUsersGroupPermission != null,
          editDisabled: allUsersGroupPermission != null ? allUsersGroupPermission.canEdit() : void 0
        });
        results.push(this.customGroupsPermissionBox.append(checkboxRow));
      }
      return results;
    };

    RedesignDashboardPermissionsController.prototype.maybeDisable = function() {
      var shouldDisable;
      shouldDisable = AppRedesign.readOnlyMaintenanceMode() || !this.canEditDashboard();
      this.iconExpando.toggle(!shouldDisable);
      return this.el.toggleClass('disabled', shouldDisable);
    };

    RedesignDashboardPermissionsController.prototype.canEditDashboard = function() {
      return this.isOwner() || this.isAdmin();
    };

    RedesignDashboardPermissionsController.prototype.isOwner = function() {
      return (this.dashboard.user_id != null) && this.dashboard.user_id === App.User.safeCurrentUser().id;
    };

    RedesignDashboardPermissionsController.prototype.isAdmin = function() {
      return App.User.safeCurrentUser().isAdmin();
    };

    RedesignDashboardPermissionsController.prototype.isDisabled = function() {
      return this.el.hasClass('disabled');
    };

    RedesignDashboardPermissionsController.prototype.isOpen = function() {
      return this.el.hasClass('open');
    };

    return RedesignDashboardPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardPreferencesSettingsController = (function(superClass) {
    extend(RedesignDashboardPreferencesSettingsController, superClass);

    RedesignDashboardPreferencesSettingsController.prototype.className = 'dashboard-preference-settings';

    RedesignDashboardPreferencesSettingsController.prototype.elements = {
      '.permissions .body': 'permissionsArea',
      '.owner select': 'ownerSelect',
      '.description textarea': 'descriptionTextarea',
      '.tags-area': 'tagsArea',
      '.color-themes-area .body': 'colorThemeArea',
      '.archive-toggle-area': 'archiveToggleArea',
      '.badge-toggle-area': 'badgeToggleArea'
    };

    RedesignDashboardPreferencesSettingsController.prototype.events = {
      'click .save-button': 'save',
      'click .cancel-button': 'close',
      'keyup .chosen-search input': 'ownerSearch',
      'change .owner select': 'ownerChanged',
      'chosen:showing_dropdown .owner select': 'showingOwnerSelectDropdown',
      'chosen:hiding_dropdown .owner select': 'hidingOwnerSelectDropdown'
    };

    function RedesignDashboardPreferencesSettingsController() {
      this.release = bind(this.release, this);
      this.excludedFromAutoArchiveChanged = bind(this.excludedFromAutoArchiveChanged, this);
      this.updateOwnerSelect = bind(this.updateOwnerSelect, this);
      this.resetOwnerSelect = bind(this.resetOwnerSelect, this);
      var autoArchiveEnabled, badgeToggleEnabled, colorThemesEnabled;
      RedesignDashboardPreferencesSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      colorThemesEnabled = AppRedesign.current().colorThemesEnabled;
      autoArchiveEnabled = AppRedesign.autoArchiveEnabled();
      badgeToggleEnabled = AppRedesign.dashboardOrganizationEnabled() && AppRedesign.editOfficeStatusEnabledOnDashboard();
      this.html(this.view('redesign/dashboard_preferences/settings')({
        allUsers: App.User.all(),
        colorThemesEnabled: colorThemesEnabled,
        autoArchiveEnabled: autoArchiveEnabled,
        badgeToggleEnabled: badgeToggleEnabled,
        rbacEnabled: AppRedesign.current().state.RbacEnabled
      }));
      this.site = App.Site.first();
      this.ownerSelect.val("" + (this.dashboard.getOwnerId()));
      if (!(App.User.currentUser().id === this.dashboard.getOwnerId() || App.User.currentUser().isAdmin())) {
        this.ownerSelect.attr('disabled', true);
      }
      this.ownerSelect.chosen({
        disable_search: false,
        width: '320px'
      });
      this.permissionsController = new App.RedesignDashboardPermissionsController({
        dashboard: this.dashboard,
        el: this.permissionsArea
      });
      this.descriptionTextarea.val(this.dashboard.description);
      if (AppRedesign.dashboardOrganizationEnabled()) {
        this.tagsArea.hide();
      } else {
        this.tagsController = new App.RedesignDashboardTagsController({
          dashboard: this.dashboard
        });
        this.tagsArea.append(this.tagsController.el);
      }
      if (colorThemesEnabled) {
        this.colorThemesController = new App.DashboardColorThemesController({
          el: this.colorThemeArea,
          dashboard: this.dashboard
        });
        this.el.on('wheel mousewheel', this.colorThemesController.hide);
      }
      if (this.shouldRenderArchiveToggle()) {
        this.renderArchiveToggle();
      }
      this.ownerSelectDropdownShowing = false;
      this.currentQuery = '';
      this.ownerSelectTimer = null;
      this.initializeOwnerSelect();
      if (badgeToggleEnabled) {
        this.renderBadgeToggleArea();
      }
    }

    RedesignDashboardPreferencesSettingsController.prototype.ownerSearch = function() {
      var query;
      if (!this.usersSearchApiEnabled()) {
        return;
      }
      query = this.chosenSearchInput().val().trim();
      if (query === this.currentQuery) {
        return;
      }
      this.currentQuery = query;
      return this.updateOwnerSelectWithQuery();
    };

    RedesignDashboardPreferencesSettingsController.prototype.ownerChanged = function(e, params) {
      var selectedId;
      if (!this.usersSearchApiEnabled()) {
        return;
      }
      clearTimeout(this.ownerSelectTimer);
      selectedId = params.selected;
      this.ownerProfile = this.userInUserObjects(+selectedId, this.userObjects);
      return this.resetOwnerSelect();
    };

    RedesignDashboardPreferencesSettingsController.prototype.resetOwnerSelect = function() {
      this.currentQuery = '';
      return this.updateOwnerSelectWithQuery();
    };

    RedesignDashboardPreferencesSettingsController.prototype.showingOwnerSelectDropdown = function() {
      if (!this.usersSearchApiEnabled()) {
        return;
      }
      return this.ownerSelectDropdownShowing = true;
    };

    RedesignDashboardPreferencesSettingsController.prototype.hidingOwnerSelectDropdown = function(e, params) {
      if (!this.usersSearchApiEnabled()) {
        return;
      }
      this.ownerSelectDropdownShowing = false;
      return this.ownerSelectTimer = setTimeout(this.resetOwnerSelect, 0);
    };

    RedesignDashboardPreferencesSettingsController.prototype.updateOwnerSelectWithQuery = function() {
      return App.User.search(this.currentQuery, this.updateOwnerSelect);
    };

    RedesignDashboardPreferencesSettingsController.prototype.updateOwnerSelect = function(userObjects) {
      var newQuery, ref, selectHtml;
      this.userObjects = this.addOwnerProfile(userObjects);
      selectHtml = this.userObjects.map(App.Utils.createOwnerSelectOption).join("\n");
      if (this.userObjects.length === 0) {
        selectHtml = App.Utils.optionHtml({
          value: '',
          content: ''
        });
      }
      newQuery = this.chosenSearchInput().val();
      this.ownerSelect.empty().html(selectHtml).trigger('chosen:updated');
      if (this.ownerSelectDropdownShowing) {
        this.chosenSearchInput().trigger('keyup.chosen');
      }
      this.ownerSelect.val("" + ((ref = this.ownerProfile) != null ? ref.id : void 0));
      this.ownerSelect.trigger('chosen:updated');
      this.chosenSearchInput().val(newQuery);
      if (this.ownerSelectDropdownShowing && this.userObjects.length <= 1) {
        return this.chosenSearchInput().trigger('keyup.chosen');
      }
    };

    RedesignDashboardPreferencesSettingsController.prototype.usersSearchApiEnabled = function() {
      return App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED);
    };

    RedesignDashboardPreferencesSettingsController.prototype.initializeOwnerSelect = function() {
      if (AppRedesign.current().state.RbacEnabled || !this.usersSearchApiEnabled()) {
        return;
      }
      return jQuery.get("/dashboards/" + this.dashboard.id + "/minimal_owner_profile").done((function(_this) {
        return function(ownerProfile) {
          _this.ownerProfile = ownerProfile;
          return _this.updateOwnerSelectWithQuery();
        };
      })(this));
    };

    RedesignDashboardPreferencesSettingsController.prototype.addOwnerProfile = function(userObjects) {
      if (this.currentQuery !== '' || (this.ownerProfile == null) || this.userInUserObjects(this.ownerProfile.id, userObjects)) {
        return userObjects;
      }
      return [this.ownerProfile].concat(userObjects);
    };

    RedesignDashboardPreferencesSettingsController.prototype.userInUserObjects = function(id, userObjects) {
      return userObjects.find((function(_this) {
        return function(userObject) {
          return id === userObject.id;
        };
      })(this));
    };

    RedesignDashboardPreferencesSettingsController.prototype.chosenSearchInput = function() {
      return $('.chosen-search input');
    };

    RedesignDashboardPreferencesSettingsController.prototype.renderArchiveToggle = function() {
      this.archiveToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.dashboard.excluded_from_auto_archive,
        labelWhenToggleOn: 'Exclude from auto archive',
        labelWhenToggleOff: 'Exclude from auto archive'
      });
      this.archiveToggleArea.append(this.archiveToggle.el);
      this.archiveToggle.bind('toggled', this.excludedFromAutoArchiveChanged);
      return this.checkAutoArchiveConfig();
    };

    RedesignDashboardPreferencesSettingsController.prototype.checkAutoArchiveConfig = function() {
      return jQuery.ajax({
        url: '/auto_archive_configs',
        type: 'get',
        data: {
          client_site_id: App.Site.first().id
        }
      }).done((function(_this) {
        return function(res) {
          if (!res || !res.id) {
            return _this.archiveToggle.disable();
          }
        };
      })(this));
    };

    RedesignDashboardPreferencesSettingsController.prototype.excludedFromAutoArchiveChanged = function(toggleState) {
      return this.dashboard.excluded_from_auto_archive = toggleState;
    };

    RedesignDashboardPreferencesSettingsController.prototype.shouldRenderArchiveToggle = function() {
      return AppRedesign.autoArchiveEnabled() && this.showSettingsTab;
    };

    RedesignDashboardPreferencesSettingsController.prototype.renderBadgeToggleArea = function() {
      this.badgeToggleSettingsController = new App.BadgeToggleSettingsController({
        item: this.dashboard,
        hasDetail: false
      });
      return this.badgeToggleArea.append(this.badgeToggleSettingsController.el);
    };

    RedesignDashboardPreferencesSettingsController.prototype.unparentAllReparented = function() {
      return this.permissionsController.unparentAllReparented();
    };

    RedesignDashboardPreferencesSettingsController.prototype.release = function() {
      var ref, ref1, ref2, ref3;
      this.permissionsController.release();
      if ((ref = this.tagsController) != null) {
        ref.release();
      }
      if ((ref1 = this.colorThemesController) != null) {
        ref1.release();
      }
      if ((ref2 = this.archiveToggle) != null) {
        ref2.release();
      }
      if ((ref3 = this.badgeToggleSettingsController) != null) {
        ref3.release();
      }
      return RedesignDashboardPreferencesSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardPreferencesSettingsController.prototype.close = function() {
      return this.trigger('close');
    };

    RedesignDashboardPreferencesSettingsController.prototype.hide = function() {
      var ref;
      this.permissionsController.hide();
      return (ref = this.colorThemesController) != null ? ref.hide() : void 0;
    };

    RedesignDashboardPreferencesSettingsController.prototype.save = function() {
      var ref, ref1, ref2;
      if (this.showSettingsTab) {
        this.updateDashboardDescription();
        if (!AppRedesign.current().state.RbacEnabled) {
          this.updateDashboardOwner();
        }
        this.permissionsController.save();
        if ((ref = this.tagsController) != null) {
          ref.save();
        }
        if ((ref1 = this.colorThemesController) != null) {
          ref1.save();
        }
        this.dashboard.save();
        if ((ref2 = this.badgeToggleSettingsController) != null) {
          ref2.saveBadge();
        }
      }
      return this.close();
    };

    RedesignDashboardPreferencesSettingsController.prototype.updateDashboardDescription = function() {
      var newDescription;
      newDescription = this.descriptionTextarea.val().trim();
      if (this.dashboard.description === newDescription) {
        return;
      }
      return this.dashboard.description = newDescription;
    };

    RedesignDashboardPreferencesSettingsController.prototype.updateDashboardOwner = function() {
      return this.dashboard.setOwnerId(parseInt(this.ownerSelect.val()));
    };

    return RedesignDashboardPreferencesSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardTagsController = (function(superClass) {
    extend(RedesignDashboardTagsController, superClass);

    RedesignDashboardTagsController.prototype.className = 'tags-input';

    RedesignDashboardTagsController.prototype.elements = {
      'ul#tags': 'tagUl'
    };

    function RedesignDashboardTagsController() {
      this.removeTagFromDashboard = bind(this.removeTagFromDashboard, this);
      this.addNewTagId = bind(this.addNewTagId, this);
      this.afterTagAdded = bind(this.afterTagAdded, this);
      this.onTagExists = bind(this.onTagExists, this);
      this.preprocessTag = bind(this.preprocessTag, this);
      this.updateCacheTagsAndAutocomplete = bind(this.updateCacheTagsAndAutocomplete, this);
      this.unsetFocusedState = bind(this.unsetFocusedState, this);
      this.tagClicked = bind(this.tagClicked, this);
      this.setUpTagIt = bind(this.setUpTagIt, this);
      RedesignDashboardTagsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      App.Tag.bind('save destroy', this.updateCacheTagsAndAutocomplete);
      this.tag_ids = _.clone(this.dashboard.tag_ids) || [];
      this.render();
    }

    RedesignDashboardTagsController.prototype.release = function() {
      App.Tag.unbind('save', this.updateCacheTagsAndAutocomplete);
      App.Tag.unbind('destroy', this.updateCacheTagsAndAutocomplete);
      return RedesignDashboardTagsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardTagsController.prototype.save = function() {
      return this.dashboard.tag_ids = this.tag_ids;
    };

    RedesignDashboardTagsController.prototype.render = function() {
      var existingTags;
      existingTags = this.dashboard.tags();
      this.html(this.view('redesign/dashboard_preferences/dashboard_tags')({
        tags: existingTags
      }));
      this.cacheTags();
      return setTimeout(this.setUpTagIt);
    };

    RedesignDashboardTagsController.prototype.setUpTagIt = function() {
      this.tagUl.tagit({
        afterTagAdded: this.afterTagAdded,
        afterTagRemoved: this.removeTagFromDashboard,
        autocomplete: {
          appendTo: '.tags-input',
          position: {
            at: 'left bottom-2',
            collision: 'flip none',
            my: 'left top',
            of: this.tagUl
          }
        },
        availableTags: this.allTags,
        caseSensitive: false,
        onTagExists: this.onTagExists,
        preprocessTag: this.preprocessTag,
        showAutocompleteOnFocus: true
      });
      return this.tagUl.on('click', this.tagClicked);
    };

    RedesignDashboardTagsController.prototype.tagClicked = function(event) {
      if ($(event.target).hasClass('ui-icon-close') || $(event.target).is(this.inputEl())) {
        return;
      }
      if (this.tagUl.hasClass('focused')) {
        return this.unsetFocusedState();
      } else {
        this.tagUl.addClass('focused');
        return this.inputEl().trigger('focus');
      }
    };

    RedesignDashboardTagsController.prototype.unsetFocusedState = function() {
      return this.tagUl.removeClass('focused');
    };

    RedesignDashboardTagsController.prototype.updateCacheTagsAndAutocomplete = function() {
      this.cacheTags();
      return this.inputEl().autocomplete({
        source: this.allTags
      });
    };

    RedesignDashboardTagsController.prototype.cacheTags = function() {
      var i, len, ref, results, tag;
      this.allTags = _.map(App.Tag.all(), 'name').sort();
      this.tagIdsByName = {};
      ref = App.Tag.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        results.push(this.tagIdsByName[tag.name] = tag.id);
      }
      return results;
    };

    RedesignDashboardTagsController.prototype.preprocessTag = function(val) {
      var properCasedTag;
      if (!val) {
        return '';
      }
      properCasedTag = _.find(this.allTags, function(tag) {
        return tag.toLowerCase() === val.toLowerCase();
      });
      if (properCasedTag) {
        return properCasedTag;
      }
      return val.trim();
    };

    RedesignDashboardTagsController.prototype.onTagExists = function(event, ui) {
      this.tagUl.find('.tagit-new input').val('');
      return false;
    };

    RedesignDashboardTagsController.prototype.afterTagAdded = function(event, ui) {
      var tagId;
      if (ui.duringInitialization) {
        return;
      }
      tagId = this.getTagId(ui);
      if (tagId) {
        return this.tag_ids.push(String(tagId));
      } else {
        return this.addNewTagAndAddToDashboard(ui.tagLabel);
      }
    };

    RedesignDashboardTagsController.prototype.addNewTagAndAddToDashboard = function(tagName) {
      var ref;
      return $.post('/tags', {
        client_site_id: (ref = App.Site.first()) != null ? ref.id : void 0,
        name: tagName
      }).done(this.addNewTagId);
    };

    RedesignDashboardTagsController.prototype.addNewTagId = function(response) {
      return this.tag_ids.push(String(response.id));
    };

    RedesignDashboardTagsController.prototype.getTagId = function(ui) {
      return this.tagIdsByName[ui.tagLabel];
    };

    RedesignDashboardTagsController.prototype.removeTagFromDashboard = function(event, ui) {
      var tagIdAsNumberOrString;
      tagIdAsNumberOrString = this.getTagId(ui);
      if (!tagIdAsNumberOrString) {
        return;
      }
      _.pull(this.tag_ids, Number(tagIdAsNumberOrString), String(tagIdAsNumberOrString));
      return this.autocompleteEl().autocomplete('close');
    };

    RedesignDashboardTagsController.prototype.inputEl = function() {
      return this.tagUl.find('li.tagit-new input');
    };

    RedesignDashboardTagsController.prototype.autocompleteEl = function() {
      return this.el.find('input.ui-autocomplete-input');
    };

    return RedesignDashboardTagsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardRearranger = (function(superClass) {
    extend(RedesignDashboardRearranger, superClass);

    RedesignDashboardRearranger.prototype.className = 'dashboard-rearranger';

    RedesignDashboardRearranger.prototype.events = {
      'mousewheel': 'setScrollTop',
      'mousemove .grid-area': 'mouseMoveGridArea',
      'mouseenter .rearranger-block:not(.ui-draggable-dragging) .title': 'maybeDisplayTooltip',
      'mouseleave .rearranger-block .title': 'removeTooltip',
      'mousedown  .rearranger-block .title': 'removeTooltip',
      'click .reset-rearrange': 'reset',
      'click .apply-rearrange': 'applyRearrange'
    };

    RedesignDashboardRearranger.prototype.elements = {
      '.grid-boundary': 'blockArea',
      '.grid-area': 'gridArea',
      '.loading-message': 'loadingMessage',
      '.no-charts-message': 'noChartsMessage',
      '.buttons': 'buttons',
      '.save.button': 'saveButton',
      '.reset-rearrange.button': 'resetButton',
      '.button': 'buttons'
    };

    RedesignDashboardRearranger.SCROLL_INTERVAL = 30;

    RedesignDashboardRearranger.EDGE_PADDING = 10;

    RedesignDashboardRearranger.CHART_TITLE_FONT_SIZE = 14;

    RedesignDashboardRearranger.TOOLTIP_HOVER_TIMEOUT_MS = 1000;

    function RedesignDashboardRearranger() {
      this.removeTooltip = bind(this.removeTooltip, this);
      this.scrollGridArea = bind(this.scrollGridArea, this);
      this.setScrollTop = bind(this.setScrollTop, this);
      this.blockDragStop = bind(this.blockDragStop, this);
      this.blockDragStart = bind(this.blockDragStart, this);
      this.blockDrag = bind(this.blockDrag, this);
      this.blockUnselected = bind(this.blockUnselected, this);
      this.blockSelected = bind(this.blockSelected, this);
      this.widgetUpdated = bind(this.widgetUpdated, this);
      this.checkUntilLoadingComplete = bind(this.checkUntilLoadingComplete, this);
      this.revertDrag = bind(this.revertDrag, this);
      this.maybeResetDrag = bind(this.maybeResetDrag, this);
      this.layoutGrid = bind(this.layoutGrid, this);
      this.resizeWidgets = bind(this.resizeWidgets, this);
      this.reset = bind(this.reset, this);
      this.render = bind(this.render, this);
      RedesignDashboardRearranger.__super__.constructor.apply(this, arguments);
      this.open = true;
      this.blocks = [];
      App.Widget.bind('update create refresh', this.widgetUpdated);
      this.currentDashboard = null;
      this.scrollSpeed = 0;
      App.hotkeys.bind(App.HotkeyManager.ESC, this.maybeResetDrag);
      this.render();
      this.renderBlocks();
      $(window).on('resize', this.resizeWidgets);
    }

    RedesignDashboardRearranger.prototype.release = function() {
      App.hotkeys.unbind(App.HotkeyManager.ESC, this.maybeResetDrag);
      return RedesignDashboardRearranger.__super__.release.apply(this, arguments);
    };

    RedesignDashboardRearranger.prototype.renderBlocks = function() {
      App.Lagotron.addContext("openDashboardRearranger");
      this.currentDashboard = App.Dashboard.currentDashboard();
      this.collisionResolver = new App.SplitStyleCollisionResolver(this.currentDashboard, false);
      this.layoutGrid();
      this.addBlocks();
      this.checkUntilLoadingComplete();
      return this.dragScrollInterval = setInterval(this.scrollGridArea, RedesignDashboardRearranger.SCROLL_INTERVAL);
    };

    RedesignDashboardRearranger.prototype.render = function() {
      this.html(this.view('redesign/dashboard_rearranger/dialog')());
      this.dialog = App.RedesignDialog.createDialog({
        title: 'Rearrange Charts',
        viewController: this,
        customDialogClass: 'wide-dialog',
        closeCallback: this.clickedClose
      });
      return this.refreshElements();
    };

    RedesignDashboardRearranger.prototype.reset = function() {
      _.each(this.blocks, function(block) {
        block.initializePosition();
        return block.reposition();
      });
      return this.setUnchanged();
    };

    RedesignDashboardRearranger.prototype.resizeWidgets = function() {
      var rearrangerSizer;
      rearrangerSizer = this.newRearrangerSizer();
      this.layoutGrid();
      return _.each(this.blocks, function(block) {
        return block.repositionForResize(rearrangerSizer);
      });
    };

    RedesignDashboardRearranger.prototype.layoutGrid = function() {
      var currentRows, numRows;
      currentRows = this.currentDashboard.nextFreeRow();
      numRows = this.getRearrangerSizer().bufferRowsAvailable(currentRows) + currentRows;
      return this.blockArea.height((numRows - 1) * this.getRearrangerSizer().rowHeight());
    };

    RedesignDashboardRearranger.prototype.addBlocks = function() {
      var i, len, ref, results, widget;
      ref = this.currentDashboard.widgets();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        results.push(this.addBlock(widget));
      }
      return results;
    };

    RedesignDashboardRearranger.prototype.addBlock = function(widget) {
      var block, blockEl;
      if (!this.widgetIsForCurrentDashboard(widget.dashboard_id)) {
        return;
      }
      if (this.weAlreadyHaveBlockForThisWidget(widget.id)) {
        return;
      }
      blockEl = $(this.view('redesign/dashboard_rearranger/rearranger_block')({
        widget: widget
      }));
      block = new App.RedesignRearrangerBlock({
        el: blockEl,
        widget: widget,
        rearrangerSizer: this.getRearrangerSizer()
      });
      block.bind('selected', this.blockSelected);
      block.bind('unselected', this.blockUnselected);
      this.blocks.push(block);
      this.blockArea.append(blockEl);
      return this.resetDraggableForBlock(block);
    };

    RedesignDashboardRearranger.prototype.widgetIsForCurrentDashboard = function(widgetDashboardId) {
      var ref;
      return widgetDashboardId === ((ref = this.currentDashboard) != null ? ref.id : void 0);
    };

    RedesignDashboardRearranger.prototype.weAlreadyHaveBlockForThisWidget = function(widgetId) {
      return _.some(this.blocks, _.matchesProperty('widget.id', widgetId));
    };

    RedesignDashboardRearranger.prototype.maybeResetDrag = function(e) {
      if (e.which !== AppRedesign.KEYS.ESCAPE) {
        return;
      }
      if (this.currentlySelectedBlock != null) {
        return this.escapePressed = true;
      }
    };

    RedesignDashboardRearranger.prototype.revertDrag = function() {
      return this.escapePressed;
    };

    RedesignDashboardRearranger.prototype.resetDraggableForBlock = function(block) {
      if (this.el.data("ui-resizable")) {
        block.el.draggable('destroy');
      }
      return block.el.draggable({
        grid: [this.getRearrangerSizer().columnWidth(), this.getRearrangerSizer().rowHeight()],
        containment: $('.dashboard-chart-rearranger-container .grid-area'),
        revert: this.revertDrag,
        start: this.blockDragStart,
        stop: this.blockDragStop,
        drag: this.blockDrag,
        scroll: true
      });
    };

    RedesignDashboardRearranger.prototype.checkUntilLoadingComplete = function() {
      if (this.currentDashboard.isCompletelyLoaded()) {
        this.loadingMessage.hide();
        if (this.currentDashboard.widgets().length === 0) {
          this.noChartsMessage.show();
          return this.buttons.hide();
        }
      } else {
        this.loadingMessage.show();
        return setTimeout(this.checkUntilLoadingComplete, 250);
      }
    };

    RedesignDashboardRearranger.prototype.resetDraggableForWidgets = function() {
      var block, i, len, ref, results;
      ref = this.blocks;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        block = ref[i];
        results.push(this.resetDraggableForBlock(block));
      }
      return results;
    };

    RedesignDashboardRearranger.prototype.widgetUpdated = function(widget) {
      if (this.open) {
        return this.addBlock(widget);
      }
    };

    RedesignDashboardRearranger.prototype.blockSelected = function(block) {
      if ((this.currentlySelectedBlock != null) && this.currentlySelectedBlock.id !== block.id) {
        this.currentlySelectedBlock.unselect();
      }
      this.currentlySelectedBlock = block;
      return this.el.addClass('block-selected');
    };

    RedesignDashboardRearranger.prototype.blockUnselected = function() {
      var ref;
      if ((ref = this.currentlySelectedBlock) != null) {
        ref.unselect();
      }
      this.currentlySelectedBlock = null;
      return this.el.removeClass('block-selected');
    };

    RedesignDashboardRearranger.prototype.blockDrag = function(event, position) {
      var nearestColumn, nearestRow;
      if (this.currentlySelectedBlock == null) {
        return;
      }
      if (this.revertDrag()) {
        return;
      }
      nearestRow = Math.round(position.position.top / this.getRearrangerSizer().rowHeight());
      nearestColumn = Math.round(position.position.left / this.getRearrangerSizer().columnWidth());
      if (!this.currentlySelectedBlock.positionDifferent(nearestColumn, nearestRow)) {
        return;
      }
      return this.makeRoomFor(this.currentlySelectedBlock, nearestColumn, nearestRow);
    };

    RedesignDashboardRearranger.prototype.blockForElement = function(rearrangerBlock) {
      var widget;
      widget = App[$(rearrangerBlock).data('widgetClassName')].exists($(rearrangerBlock).data('widgetCid'));
      if (!widget) {
        return;
      }
      return _.find(this.blocks, function(b) {
        return b.widget.cid === widget.cid && b.widget.constructor.className === widget.constructor.className;
      });
    };

    RedesignDashboardRearranger.prototype.blockDragStart = function(event, position) {
      var block;
      this.setScrollTop();
      this.checkpointPositions();
      block = this.blockForElement(event.target);
      this.currentlySelectedBlock = block;
      if (block != null) {
        block.select();
      }
      this.el.addClass('block-dragging');
      return this.setChanged();
    };

    RedesignDashboardRearranger.prototype.blockDragStop = function(event, position) {
      var block;
      if (this.revertDrag()) {
        delete this.escapePressed;
        this.restorePositions();
        return;
      }
      block = this.blockForElement(event.target);
      block.unselectWithTrigger();
      this.currentlySelectedBlock = null;
      this.el.removeClass('block-dragging');
      App.RedesignRectangles.collapseEmptyRows(this.blocks);
      return block.reposition();
    };

    RedesignDashboardRearranger.prototype.setChanged = function() {
      return this.buttons.removeClass('disabled');
    };

    RedesignDashboardRearranger.prototype.setUnchanged = function() {
      return this.buttons.addClass('disabled');
    };

    RedesignDashboardRearranger.prototype.makeRoomFor = function(movingBlock, toColumn, toRow) {
      this.restorePositions();
      movingBlock.moveTo(toColumn, toRow);
      return this.collisionResolver.rearrange(this.blocks, movingBlock);
    };

    RedesignDashboardRearranger.prototype.checkpointPositions = function() {
      var b, i, len, ref, results;
      ref = this.blocks;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        b = ref[i];
        results.push(b.checkpointPosition());
      }
      return results;
    };

    RedesignDashboardRearranger.prototype.restorePositions = function() {
      var b, i, len, ref, results;
      ref = this.blocks;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        b = ref[i];
        results.push(b.restorePosition());
      }
      return results;
    };

    RedesignDashboardRearranger.prototype.setScrollTop = function() {
      return this.scrollTop = this.gridArea.scrollTop();
    };

    RedesignDashboardRearranger.prototype.mouseMoveGridArea = function(event) {
      var gridAreaHeight, mousePosGridArea;
      mousePosGridArea = event.clientY - this.gridArea.offset().top;
      gridAreaHeight = this.gridArea.height();
      return this.scrollSpeed = (this.currentlySelectedBlock == null ? 0 : mousePosGridArea < gridAreaHeight * 0.1 ? -1 : mousePosGridArea > gridAreaHeight * 0.9 ? 1 : 0);
    };

    RedesignDashboardRearranger.prototype.scrollGridArea = function() {
      var newScrollTop;
      if (this.scrollSpeed === 0) {
        return;
      }
      newScrollTop = this.scrollTop + this.getRearrangerSizer().rowHeight() * this.scrollSpeed;
      if (!(newScrollTop >= 0 && newScrollTop < this.blockArea.height())) {
        return;
      }
      this.scrollTop = newScrollTop;
      return this.gridArea.animate({
        scrollTop: this.scrollTop
      }, RedesignDashboardRearranger.SCROLL_INTERVAL, 'linear');
    };

    RedesignDashboardRearranger.prototype.getRearrangerSizer = function() {
      return this.rearrangerSizer != null ? this.rearrangerSizer : this.rearrangerSizer = new App.RedesignRearrangerSizer(this.currentDashboard, this);
    };

    RedesignDashboardRearranger.prototype.newRearrangerSizer = function() {
      delete this.rearrangerSizer;
      return this.getRearrangerSizer();
    };

    RedesignDashboardRearranger.prototype.applyRearrange = function() {
      this.saveChanges();
      return this.clickedClose();
    };

    RedesignDashboardRearranger.prototype.clickedClose = function() {
      this.trigger('close');
      return this.release();
    };

    RedesignDashboardRearranger.prototype.saveChanges = function() {
      var changedBlocks, changedWidgets;
      if (this.currentDashboard == null) {
        return;
      }
      App.Lagotron.addContext("saveDashboardRearrange");
      changedBlocks = _.filter(this.blocks, function(block) {
        return block.hasChanged();
      });
      App.Dashboard.logWidgetMove(App.Dashboard.widgetStubsForLogging(this.currentDashboard.widgets()), null, 'before-rearrange');
      changedWidgets = _.map(changedBlocks, function(block) {
        return block.applyChangesAndGetWidget();
      });
      this.currentDashboard.saveWidgetStubs(App.Widget.stubsForWidgets(changedWidgets));
      App.Dashboard.logWidgetMove(changedWidgets, null, 'rearrange');
      this.setUnchanged();
      return App.Utils.logFeature("save-rearrange-mode", {
        dashboard_id: this.currentDashboard.id
      });
    };

    RedesignDashboardRearranger.prototype.maybeDisplayTooltip = function(e) {
      var target;
      target = $(e.currentTarget);
      if (!this.isOverflown(target)) {
        return;
      }
      return this.tooltipTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.displayTooltip(target);
        };
      })(this)), App.RedesignDashboardRearranger.TOOLTIP_HOVER_TIMEOUT_MS);
    };

    RedesignDashboardRearranger.prototype.displayTooltip = function(target) {
      var ref, targetOffset, tooltipValue, tooltipWidth;
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      tooltipValue = target.text().trim();
      if (!tooltipValue) {
        return;
      }
      targetOffset = target.offset();
      App.Utils.initRedesignCanvasWidthSizer(11);
      tooltipWidth = Math.min(250, App.Utils.canvasWidthForText(tooltipValue));
      return this.hoverTooltip = App.RedesignTooltipPanel.addPanel({
        description: '',
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        width: tooltipWidth + " px",
        contentEl: $(this.view('tooltip_content')({
          tooltipValue: tooltipValue
        })),
        useSmallPointer: true,
        extraClass: 'light-theme'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, App.RedesignTooltipPanel.CENTER_POINTER, targetOffset.left + (target.width() * 0.5), targetOffset.top + (target.height() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE));
    };

    RedesignDashboardRearranger.prototype.isOverflown = function(el) {
      var expectedWidth;
      if (!el) {
        return false;
      }
      App.Utils.initRedesignCanvasWidthSizer(RedesignDashboardRearranger.CHART_TITLE_FONT_SIZE);
      expectedWidth = App.Utils.fastApproxWidthForText(el.text());
      return el.width() < expectedWidth;
      return el.offsetWidth < el.scrollWidth;
    };

    RedesignDashboardRearranger.prototype.removeTooltip = function() {
      var ref;
      clearTimeout(this.tooltipTimeout);
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      return this.hoverTooltip = null;
    };

    return RedesignDashboardRearranger;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignRearrangerBlock = (function(superClass) {
    extend(RedesignRearrangerBlock, superClass);

    RedesignRearrangerBlock.prototype.elements = {
      '.title': 'titleEl'
    };

    RedesignRearrangerBlock.prototype.events = {
      'mousedown': 'mouseDown',
      'mouseup': 'mouseUp'
    };

    RedesignRearrangerBlock.CLICK_MAX_TIME_MS = 150;

    RedesignRearrangerBlock.ICON_AREA_HEIGHT = 20;

    function RedesignRearrangerBlock() {
      this.mouseUp = bind(this.mouseUp, this);
      this.mouseDown = bind(this.mouseDown, this);
      this.repositionForResize = bind(this.repositionForResize, this);
      this.reposition = bind(this.reposition, this);
      RedesignRearrangerBlock.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.id = "" + this.widget.constructor.className + this.widget.cid;
      this.titleEl.text(this.widget.getName());
      this.el.attr('chart_type', this.widget.chart_type);
      this.initializePosition();
      this.checkpointPosition();
      this.mouseDownAt = 0;
    }

    RedesignRearrangerBlock.prototype.initializePosition = function() {
      this.sizeTo(this.widget.getWidth(), this.widget.getHeight());
      return this.moveTo(this.widget.getColumn(), this.widget.getRow());
    };

    RedesignRearrangerBlock.prototype.positionDifferent = function(column, row) {
      return this.column !== column || this.row !== row;
    };

    RedesignRearrangerBlock.prototype.moveTo = function(column, row) {
      if (!this.positionDifferent(column, row)) {
        return;
      }
      this.column = column;
      this.row = row;
      if (AppRedesign.current() == null) {
        return;
      }
      return AppRedesign.uiQueueAdd(this.reposition, 'rearrangerBlockMoveTo', 10, this.id);
    };

    RedesignRearrangerBlock.prototype.reposition = function() {
      var effectiveHeight, effectiveWidth;
      if (this.colW == null) {
        this.colW = this.rearrangerSizer.columnWidth();
      }
      if (this.rowH == null) {
        this.rowH = this.rearrangerSizer.rowHeight();
      }
      effectiveHeight = this.rowH * this.height - 2;
      effectiveWidth = this.colW * this.width - 2;
      return this.el.css({
        height: effectiveHeight,
        left: this.colW * this.column,
        top: this.rowH * this.row,
        width: effectiveWidth
      });
    };

    RedesignRearrangerBlock.prototype.repositionForResize = function(rearranger) {
      delete this.rearrangerSizer;
      this.restPixelSizeCache();
      this.rearrangerSizer = rearranger;
      return this.reposition();
    };

    RedesignRearrangerBlock.prototype.restPixelSizeCache = function() {
      this.colW = null;
      return this.rowH = null;
    };

    RedesignRearrangerBlock.prototype.restorePosition = function() {
      return this.moveTo(this.checkpointColumn, this.checkpointRow);
    };

    RedesignRearrangerBlock.prototype.checkpointPosition = function() {
      this.checkpointColumn = this.column;
      return this.checkpointRow = this.row;
    };

    RedesignRearrangerBlock.prototype.sizeTo = function(width1, height1) {
      this.width = width1;
      this.height = height1;
    };

    RedesignRearrangerBlock.prototype.hasChanged = function() {
      this.widget.reload();
      return this.row !== this.widget.getRow() || this.column !== this.widget.getColumn() || this.width !== this.widget.getWidth() || this.height !== this.widget.getHeight();
    };

    RedesignRearrangerBlock.prototype.applyChangesAndGetWidget = function() {
      this.widget.moveTo(this.column, this.row);
      this.widget.sizeTo(this.width, this.height);
      return this.widget;
    };

    RedesignRearrangerBlock.prototype.equals = function(otherBlock) {
      return this.id === otherBlock.id;
    };

    RedesignRearrangerBlock.prototype.mouseDown = function() {
      return this.mouseDownAt = (new Date()).getTime();
    };

    RedesignRearrangerBlock.prototype.mouseUp = function() {
      var diff;
      diff = (new Date()).getTime() - this.mouseDownAt;
      if (diff < RedesignRearrangerBlock.CLICK_MAX_TIME_MS) {
        return this.toggleSelection();
      }
    };

    RedesignRearrangerBlock.prototype.isSelected = function() {
      return this.el.hasClass('selected');
    };

    RedesignRearrangerBlock.prototype.toggleSelection = function() {
      if (this.isSelected()) {
        return this.unselectWithTrigger();
      } else {
        return this.select();
      }
    };

    RedesignRearrangerBlock.prototype.select = function(trigger) {
      if (trigger == null) {
        trigger = true;
      }
      this.el.addClass('selected');
      if (trigger) {
        return this.trigger('selected', this);
      }
    };

    RedesignRearrangerBlock.prototype.unselectWithTrigger = function() {
      this.unselect();
      return this.trigger('unselected', this);
    };

    RedesignRearrangerBlock.prototype.unselect = function() {
      return this.el.removeClass('selected');
    };

    RedesignRearrangerBlock.prototype.getRow = function() {
      return this.row;
    };

    RedesignRearrangerBlock.prototype.getColumn = function() {
      return this.column;
    };

    RedesignRearrangerBlock.prototype.getWidth = function() {
      return this.width;
    };

    RedesignRearrangerBlock.prototype.getHeight = function() {
      return this.height;
    };

    RedesignRearrangerBlock.prototype.setRow = function(row) {
      return this.row = row;
    };

    RedesignRearrangerBlock.prototype.setColumn = function(column) {
      return this.column = column;
    };

    RedesignRearrangerBlock.prototype.setWidth = function(width) {
      return this.width = width;
    };

    RedesignRearrangerBlock.prototype.setHeight = function(height) {
      return this.height = height;
    };

    return RedesignRearrangerBlock;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.DashboardShareHelper = (function() {
    function DashboardShareHelper(dashboard) {
      this.dashboard = dashboard;
      this.createShare = bind(this.createShare, this);
    }

    DashboardShareHelper.prototype.sharedDashboards = function() {
      return this.dashboard.sharedDashboards();
    };

    DashboardShareHelper.prototype.getAvailableDims = function(sd) {
      var cid, dims, orderedCids, visible, visibleCids;
      if (sd == null) {
        sd = null;
      }
      visible = this.getDimensionAvailability(sd);
      orderedCids = this.dashboard.allDimensionCidsInOrder();
      visibleCids = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = orderedCids.length; i < len; i++) {
          cid = orderedCids[i];
          if (visible[cid]) {
            results.push(cid);
          }
        }
        return results;
      })();
      dims = this.getUnorderedAvailableDims(visibleCids, sd);
      return this.sortedDims(dims, orderedCids);
    };

    DashboardShareHelper.prototype.sortedDims = function(dims, orderedCids) {
      var cid, i, idx, len, orderMap;
      orderMap = [];
      for (idx = i = 0, len = orderedCids.length; i < len; idx = ++i) {
        cid = orderedCids[idx];
        orderMap[cid] = idx;
      }
      return dims.sort(function(a, b) {
        return orderMap[a.cid] - orderMap[b.cid];
      });
    };

    DashboardShareHelper.prototype.getUnorderedAvailableDims = function(visibleCids, sd) {
      var cid, d, dims, i, len, ref, values;
      if (sd == null) {
        sd = null;
      }
      dims = [];
      for (i = 0, len = visibleCids.length; i < len; i++) {
        cid = visibleCids[i];
        d = App.CustomDimension.exists(cid);
        if (!d) {
          continue;
        }
        if (sd != null) {
          values = this.getSelectedDimensionInfos(sd, d.id);
        } else {
          values = this.getSelectedDimensionInfos(this.dashboard.userDataView(), d.id);
        }
        dims.push({
          cid: d.cid,
          name: d.name,
          values: values,
          checked: sd != null ? (ref = sd.unlocked_filters) != null ? ref.includes("" + d.id) : void 0 : void 0,
          filterType: d.filter_type
        });
      }
      if (sd != null) {
        dims = dims.concat(this.getDateRangeAggregationFromSharedDashboard(sd));
      } else {
        dims = dims.concat(this.getDateRangeAggregationFromCurrentUdv(sd));
      }
      return dims;
    };

    DashboardShareHelper.prototype.getDimensionAvailability = function(sd) {
      var customDimension, dim, dimId, i, len, ref, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      if (sd == null) {
        return visible;
      }
      ref = sd.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        dim = ref[i];
        dimId = dim[0];
        customDimension = App.CustomDimension.exists(dimId);
        if (customDimension) {
          visible[customDimension.cid] = true;
        }
      }
      return visible;
    };

    DashboardShareHelper.prototype.getSelectedDimensionInfos = function(sd, dimension_id) {
      var cd, cdl, i, len, matches, ref, value, valueName, viewingSd;
      if (sd == null) {
        return [];
      }
      matches = [];
      ref = sd.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        cdl = ref[i];
        if ((cdl.length > 2) && (cdl[0] === dimension_id)) {
          cd = App.CustomDimension.find(dimension_id);
          viewingSd = sd instanceof App.SharedDashboard;
          valueName = cd.isDateRange() ? this.getDateRangeDisplayName(cdl[1], viewingSd) : cdl[2];
          value = cd.isDateRange() ? JSON.stringify(cdl[1]) : cdl[1];
          matches.push({
            value_name: valueName,
            value: value,
            group: cdl[3]
          });
        }
      }
      return matches;
    };

    DashboardShareHelper.prototype.getDateRangeDisplayName = function(daterange, isSharedDash) {
      if (isSharedDash) {
        return App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(daterange);
      } else {
        return App.RedesignDateRangeDimensionSetting.getOptionLabel(daterange);
      }
    };

    DashboardShareHelper.prototype.getDateRangeAggregationFromSharedDashboard = function(sd) {
      var aggregationUnlocked, aggregationValue, dateRangeDimensionValue, dateRangeUnlocked, dims, ref, ref1, values, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      dims = [];
      aggregationValue = null;
      if (sd.aggregation != null) {
        aggregationValue = sd.aggregation.titleize();
      }
      aggregationUnlocked = (ref = sd.unlocked_filters) != null ? ref.includes('aggregation') : void 0;
      if (visible['aggregation']) {
        values = aggregationValue != null ? [
          {
            value_name: aggregationValue
          }
        ] : [];
        dims.push({
          cid: 'aggregation',
          name: 'Aggregation',
          values: values,
          checked: aggregationUnlocked
        });
      }
      dateRangeDimensionValue = null;
      if (!isEmpty(sd.date_range_dimension)) {
        dateRangeDimensionValue = App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(sd.date_range_dimension);
      }
      dateRangeUnlocked = (ref1 = sd.unlocked_filters) != null ? ref1.includes('date_range') : void 0;
      if (visible['date_range']) {
        values = dateRangeDimensionValue != null ? [
          {
            value_name: dateRangeDimensionValue
          }
        ] : [];
        dims.push({
          cid: 'date_range',
          name: 'Date Range',
          values: values,
          checked: dateRangeUnlocked
        });
      }
      return dims;
    };

    DashboardShareHelper.prototype.getDateRangeAggregationFromCurrentUdv = function(sd) {
      var currentAggregationValue, currentDateRangeDimension, dims, label, values, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      dims = [];
      if ((visible['aggregation'] != null) && visible['aggregation']) {
        currentAggregationValue = this.dashboard.userDataView().aggregation;
        if (currentAggregationValue != null) {
          values = [
            {
              value: currentAggregationValue,
              value_name: currentAggregationValue.titleize()
            }
          ];
        } else {
          values = [];
        }
        dims.push({
          cid: 'aggregation',
          name: 'Aggregation',
          values: values,
          checked: false
        });
      }
      if ((visible['date_range'] != null) && visible['date_range']) {
        currentDateRangeDimension = this.dashboard.userDataView().date_range_dimension;
        if (!isEmpty(currentDateRangeDimension)) {
          label = App.RedesignDateRangeDimensionSetting.getOptionLabel(currentDateRangeDimension);
          values = [
            {
              value_name: label,
              value: JSON.stringify(currentDateRangeDimension)
            }
          ];
        } else {
          values = [];
        }
        dims.push({
          cid: 'date_range',
          name: 'Date Range',
          values: values,
          checked: false
        });
      }
      return dims;
    };

    DashboardShareHelper.prototype.deleteShare = function(shareId) {
      var sd;
      sd = App.SharedDashboard.exists(shareId);
      if (sd) {
        return sd.destroy();
      }
    };

    DashboardShareHelper.prototype.createShare = function(detailController, successCb) {
      if (this.currentlySharing) {
        return;
      }
      this.currentlySharing = true;
      return jQuery.ajax({
        type: 'post',
        url: "/shared_dashboards",
        data: {
          dashboard_id: this.dashboard.id,
          client_site_id: App.Site.first().id,
          name: detailController.name(),
          unlocked_filters: detailController.unlockedFilters(),
          custom_dimensions_list: JSON.stringify(detailController.customDimensionsList()),
          aggregation: detailController.getAggregation(),
          date_range_dimension: detailController.getDateRangeDimension(),
          password: detailController.getPasswordInput()
        },
        async: false,
        success: this.shareSuccess(successCb)
      }).always((function(_this) {
        return function() {
          return _this.currentlySharing = false;
        };
      })(this));
    };

    DashboardShareHelper.prototype.shareSuccess = function(successCb) {
      return function(response) {
        var sd;
        sd = new App.SharedDashboard(response).save({
          ajax: false
        });
        return successCb(sd);
      };
    };

    return DashboardShareHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DataBarsColorPickerController = (function(superClass) {
    extend(DataBarsColorPickerController, superClass);

    function DataBarsColorPickerController() {
      this.render = bind(this.render, this);
      return DataBarsColorPickerController.__super__.constructor.apply(this, arguments);
    }

    DataBarsColorPickerController.prototype.className = 'gradient-color-picker';

    DataBarsColorPickerController.prototype.elements = {
      '.custom.color-content': 'colorPickerArea',
      '.recent.color-content': 'recentColorsArea',
      '.theme.color-content': 'themeColorsArea'
    };

    DataBarsColorPickerController.prototype.events = {
      'click .action.reset': 'resetColor',
      'click .action.save': 'updateAndRelease',
      'click .rotator-title': 'toggleRotator',
      'click .color-type': 'selectColor'
    };

    DataBarsColorPickerController.prototype.render = function() {
      this.html(this.view('redesign/settings/data_bars_color_picker')());
      return DataBarsColorPickerController.__super__.render.apply(this, arguments);
    };

    return DataBarsColorPickerController;

  })(App.DualColorPickerController);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DefaultEditorSettingsController = (function(superClass) {
    extend(DefaultEditorSettingsController, superClass);

    DefaultEditorSettingsController.prototype.className = 'default-editor-settings';

    DefaultEditorSettingsController.prototype.elements = {
      '.owner': 'owner',
      '.desc': 'description',
      'ul.tags': 'tagsUl',
      '.tags-input': 'tagsInput'
    };

    DefaultEditorSettingsController.prototype.events = {
      'keyup  .desc': 'descriptionChanged',
      'change .owner': 'ownerChanged'
    };

    function DefaultEditorSettingsController() {
      this.ownerChanged = bind(this.ownerChanged, this);
      this.descriptionChanged = bind(this.descriptionChanged, this);
      this.updateTags = bind(this.updateTags, this);
      DefaultEditorSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      if (this.item.isNew()) {
        if (this.currentUserCanOwn()) {
          this.item.setOwnerId(App.User.currentUser().id);
        }
      }
      this.render();
      this.refreshOwner();
      this.description.one('keydown', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
    }

    DefaultEditorSettingsController.prototype.userToHash = function(userHash, user) {
      var display_name, first_name, last_name;
      first_name = user['first_name'];
      last_name = user['last_name'];
      if (first_name === null) {
        first_name = '';
      }
      if (last_name === null) {
        last_name = '';
      }
      display_name = (first_name + ' ' + last_name).trim();
      if (display_name === '') {
        display_name = user['email_address'];
      }
      userHash.push({
        user_id: user['id'],
        display_name: display_name
      });
      return userHash;
    };

    DefaultEditorSettingsController.prototype.render = function() {
      var site_id, usersQuery;
      if (AppRedesign.current().state.RbacEnabled) {
        this.dashboardOwners = [];
        site_id = App.Site.first().id;
        return usersQuery = jQuery.get("/api/" + site_id + "/users/rbac_search", {
          client_site_id: site_id,
          object_type: 'Dashboard',
          query: '',
          permissions: 'create_sql_charts'
        }).done((function(_this) {
          return function(users) {
            _this.dashboardOwners = users.users.reduce(_this.userToHash, []);
            _this.renderHTML();
            return _this.refreshOwner();
          };
        })(this));
      } else {
        this.dashboardOwners = App.User.allEditUsers();
        return this.renderHTML();
      }
    };

    DefaultEditorSettingsController.prototype.renderHTML = function() {
      var isTaggable, ref, ref1;
      isTaggable = AppRedesign.dashboardOrganizationEnabled() ? false : this.item.constructor.IS_TAGGABLE;
      this.html(this.view('redesign/editors/default_editor_settings')({
        dashboardOwners: this.dashboardOwners,
        isTaggable: isTaggable,
        itemName: this.item.constructor.SIMPLE_CLASS_NAME,
        hideMainHeader: this.hideMainHeader,
        tagNames: (ref = this.item.tag_names) != null ? ref : []
      }));
      this.owner.asyncChosen({
        width: '100%',
        placeholder_text: 'Select an Option',
        ignore_search_events: false,
        rewrote_search_input: false
      }, {
        keyupFocusCallback: ((function(_this) {
          return function(term, successCallback) {
            return _this.updateOwnerAsyncSelect(term, successCallback, _this.userToHash);
          };
        })(this))
      });
      this.description.val((ref1 = this.item.description) != null ? ref1 : '');
      this.tagsUl.tagit({
        afterTagAdded: this.updateTags,
        afterTagRemoved: this.updateTags,
        autocomplete: {
          appendTo: this.tagsInput,
          position: {
            at: 'left bottom-2',
            collision: 'flip none',
            my: 'left top',
            of: this.tagsUl
          },
          source: function(search, showChoices) {
            var choices, filter;
            filter = search.term.toLowerCase();
            choices = $.grep(_.map(App.Tag.all(), 'name').sort(), function(element) {
              return element.toLowerCase().indexOf(filter) === 0;
            });
            if (!this.options.allowDuplicates) {
              choices = this._subtractArray(choices, this.assignedTags());
            }
            return showChoices(choices);
          }
        },
        caseSensitive: false,
        showAutocompleteOnFocus: true,
        placeholderText: 'Add Tags'
      });
      this.refreshOwner();
      if (this.usersSearchApiEnabled()) {
        return this.updateOwnerSelect();
      }
    };

    DefaultEditorSettingsController.prototype.updateOwnerSelect = function() {
      if (!this.usersSearchApiEnabled()) {
        return;
      }
      return jQuery.get("/sites/" + (App.Site.first().id) + "/edit_users_profiles").done((function(_this) {
        return function(usersProfiles) {
          return _this.updateOwnerSelectWithUsers(usersProfiles);
        };
      })(this));
    };

    DefaultEditorSettingsController.prototype.updateOwnerSelectWithUsers = function(usersProfiles) {
      var selectHtml;
      selectHtml = usersProfiles.map(App.Utils.createOwnerSelectOption).join("\n");
      this.owner.empty().html(selectHtml);
      return this.refreshOwner();
    };

    DefaultEditorSettingsController.prototype.updateOwnerAsyncSelect = function(term, successCallback, userToHash) {
      var site_id;
      site_id = App.Site.first().id;
      return jQuery.get("/api/" + site_id + "/users/rbac_search", {
        client_site_id: site_id,
        object_type: 'Dashboard',
        query: term.trim(),
        permissions: 'create_sql_charts'
      }).done((function(_this) {
        return function(response) {
          var users;
          users = response.users.reduce(userToHash, []);
          users = users.map(function(user) {
            return [user.user_id, user.display_name];
          });
          return successCallback(users);
        };
      })(this));
    };

    DefaultEditorSettingsController.prototype.usersSearchApiEnabled = function() {
      return App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED);
    };

    DefaultEditorSettingsController.prototype.updateTags = function(event, ui) {
      var placeholder;
      this.item.tag_names = this.tagsUl.tagit('assignedTags');
      placeholder = 'Add Tags';
      if (this.item.tag_names.length > 0) {
        placeholder = '';
      }
      return this.tagsUl.data("ui-tagit").tagInput.attr("placeholder", placeholder);
    };

    DefaultEditorSettingsController.prototype.refresh = function() {
      var ref;
      this.description.val((ref = this.item.description) != null ? ref : '');
      return this.refreshOwner();
    };

    DefaultEditorSettingsController.prototype.refreshOwner = function() {
      var ownerID, ownerUser;
      ownerID = this.item.getOwnerId();
      ownerUser = App.User.findByAttribute('id', ownerID);
      if (this.owner.html() === void 0 || this.owner.html().includes(ownerID)) {
        this.owner.val(ownerID);
      } else {
        $("<option />").attr('value', ownerID).text(ownerUser && ownerUser.displayName()).appendTo(this.owner);
      }
      return this.owner.trigger("chosen:updated");
    };

    DefaultEditorSettingsController.prototype.descriptionChanged = function() {
      if ((this.item.description == null) && _.isEmpty(this.description.val().trim())) {
        return;
      }
      return this.item.description = this.description.val().trim();
    };

    DefaultEditorSettingsController.prototype.ownerChanged = function() {
      this.item.setOwnerId(this.owner.val());
      return this.triggerOnce('right-panel-settings-changed');
    };

    DefaultEditorSettingsController.prototype.currentUserCanOwn = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return App.User.CurrentUserCanEdit();
      }
    };

    return DefaultEditorSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DragDropSeriesHelper = (function(superClass) {
    extend(DragDropSeriesHelper, superClass);

    DragDropSeriesHelper.include(Spine.Events);

    function DragDropSeriesHelper(item) {
      this.item = item;
      DragDropSeriesHelper.__super__.constructor.apply(this, arguments);
    }

    DragDropSeriesHelper.prototype.setSeriesTwiddles = function(chartOptions) {
      var base, base1, chartType, col, column, i, j, k, len, len1, len2, ref, ref1, ref2, ref3, ref4, seriesSettings, series_sort_by, series_sort_dir, subChartType, value, value_columns, x_axis, x_axis_sort_by, x_axis_sort_dir;
      chartType = chartOptions.chartType;
      subChartType = chartOptions.subChartType;
      seriesSettings = chartOptions.seriesSettings;
      (base = this.item.twiddles).series || (base.series = {});
      (base1 = this.item.twiddles).columns || (base1.columns = {});
      this.item.setTwiddle('twiddle_detail_columns', []);
      this.item.setTwiddle('twiddle_detail_series', []);
      this.item.setTwiddle('twiddle_value_columns', []);
      this.item.setTwiddle('twiddle_point_cols', []);
      this.item.setTwiddle('twiddle_y_axis_enabled_columns', []);
      this.item.setTwiddle('twiddle_use_pivot_settings', false);
      this.item.setTwiddle('twiddle_do_not_resort_for_legend', false);
      this.item.setTwiddle('continuous_x_axis', true);
      this.item.setTwiddle('twiddle_x_axis_sort_by', []);
      this.item.setTwiddle('twiddle_x_axis_sort_dir', {});
      this.item.setTwiddle('twiddle_series_sort_by', []);
      this.item.setTwiddle('twiddle_series_sort_dir', {});
      this.item.setTwiddle('twiddle_cohort_sort_order', false);
      delete this.item.twiddles['twiddle_limit_first_by'];
      ref = this.item.twiddles.series;
      for (col in ref) {
        value = ref[col];
        delete value['series_show_on_primary_axis'];
        delete value['series_show_on_secondary_axis'];
      }
      ref1 = this.item.twiddles.columns;
      for (col in ref1) {
        value = ref1[col];
        delete value['column_use_as_value'];
      }
      if (chartType === 'table') {
        this.item.setTwiddle('twiddle_point_cols', seriesSettings.series);
      } else {
        ref2 = seriesSettings.series;
        for (i = 0, len = ref2.length; i < len; i++) {
          column = ref2[i];
          this.item.setSeriesTwiddle(column, 'show_on_primary_axis', false);
          this.item.setSeriesTwiddle(column, 'show_on_secondary_axis', false);
        }
        this.item.setTwiddle(App.TwiddleConfig.SEGMENT_COLUMN, seriesSettings.series);
        if (chartType === 'scatter') {
          x_axis = seriesSettings.x_axis.length > 0 ? seriesSettings.x_axis : [App.ColumnProcessor.INDEX_COLUMN];
          this.item.setTwiddle('twiddle_point_cols', x_axis);
          this.item.setTwiddle('twiddle_y_axis_enabled_columns', seriesSettings.y_axis);
          value_columns = seriesSettings.y_axis.map(function(column) {
            return {
              column_name: column,
              column_use_as_value: true
            };
          }) || [];
          this.item.setTwiddle('twiddle_value_columns', value_columns);
        } else if (chartType === 'bubble') {
          x_axis = seriesSettings.x_axis.length > 0 ? seriesSettings.x_axis : [App.ColumnProcessor.INDEX_COLUMN];
          this.item.setTwiddle('twiddle_point_cols', x_axis.concat(seriesSettings.y_axis));
          value_columns = seriesSettings.z_axis.map(function(column) {
            return {
              column_name: column,
              column_use_as_value: true
            };
          }) || [];
          this.item.setTwiddle('twiddle_value_columns', value_columns);
          ref3 = seriesSettings.z_axis;
          for (j = 0, len1 = ref3.length; j < len1; j++) {
            column = ref3[j];
            this.item.setSeriesTwiddle(column, 'show_on_primary_axis', true);
          }
        } else if (chartType === 'geomap') {
          this.item.setTwiddle('twiddle_geomap_data_mode', subChartType);
          if (subChartType === 'geojson') {
            this.item.setTwiddle('twiddle_point_cols', seriesSettings.geojson);
          } else {
            this.item.setTwiddle('twiddle_point_cols', seriesSettings.latitude.concat(seriesSettings.longitude));
            this.item.setTwiddle('twiddle_geomap_weight_columns', seriesSettings.weight);
          }
        } else {
          this.item.setTwiddle('twiddle_point_cols', seriesSettings.x_axis);
          ref4 = seriesSettings.y_axis;
          for (k = 0, len2 = ref4.length; k < len2; k++) {
            column = ref4[k];
            this.item.setColumnTwiddle(column, 'use_as_value', true);
          }
          value_columns = seriesSettings.y_axis.map(function(column) {
            return {
              column_name: column,
              column_value_aggregation: 'sum',
              use_column_name: true
            };
          }) || [];
          this.item.setTwiddle('twiddle_value_columns', value_columns);
          this.item.setTwiddle('twiddle_use_pivot_settings', false);
          this.item.setTwiddle('twiddle_y_axis_enabled_columns', seriesSettings.y_axis);
          if (chartType === 'cohort') {
            this.item.setTwiddle('twiddle_detail_columns', seriesSettings.details);
            this.item.setTwiddle('twiddle_detail_series', seriesSettings.details);
          }
        }
      }
      if (seriesSettings.sort.length > 0) {
        x_axis_sort_by = [];
        x_axis_sort_dir = {};
        series_sort_by = [];
        series_sort_dir = {};
        this.item.setTwiddle('twiddle_x_axis_sort_by', x_axis_sort_by);
        this.item.setTwiddle('twiddle_x_axis_sort_dir', x_axis_sort_dir);
        this.item.setTwiddle('twiddle_series_sort_by', series_sort_by);
        this.item.setTwiddle('twiddle_series_sort_dir', series_sort_dir);
        this.item.setTwiddle('twiddle_limit_first_by', seriesSettings.sort.first().sort_slot);
        seriesSettings.sort.forEach((function(_this) {
          return function(column) {
            var column_name, sort_by, sort_dir_key;
            column_name = column.column_name.toLowerCase();
            sort_by = column.sort_by.toLowerCase();
            if (sort_by === 'periscope_alphabetical_order') {
              sort_dir_key = column_name;
            } else {
              sort_dir_key = sort_by;
            }
            if (column.sort_slot === 'x_axis') {
              x_axis_sort_by.push({
                sort_by: sort_by,
                column_name: column_name,
                limit: column.sort_limit
              });
              return x_axis_sort_dir[sort_dir_key] = column.sort_order;
            } else {
              series_sort_by.push({
                sort_by: sort_by,
                column_name: column_name,
                limit: column.sort_limit
              });
              return series_sort_dir[sort_dir_key] = column.sort_order;
            }
          };
        })(this));
        if (x_axis_sort_by.length > 0 || seriesSettings.x_axis.length === 0) {
          this.item.setTwiddle('continuous_x_axis', false);
          if (chartType === 'cohort') {
            this.item.setTwiddle('twiddle_cohort_sort_order', true);
          }
        }
        return this.item.setTwiddle('twiddle_do_not_resort_for_legend', true);
      }
    };

    DragDropSeriesHelper.prototype.setDragDropStateTwiddles = function(chartOptions) {
      this.item.setTwiddle('dragDrop', chartOptions.dragDropState);
      return this.item.setDragDropConfig(chartOptions.dragDropState);
    };

    DragDropSeriesHelper.isDragDropWidget = function(widget) {
      return widget.constructor === App.Widget && widget.isDragDrop();
    };

    return DragDropSeriesHelper;

  })(Spine.Module);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Dropdown = (function(superClass) {
    extend(Dropdown, superClass);

    Dropdown.prototype.className = 'dropdown-container';

    Dropdown.prototype.elements = {
      '.dropdown': 'dropdownEl'
    };

    function Dropdown() {
      Dropdown.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'options', 'callback', 'width');
      this.html(this.view('dropdown')({
        options: this.options
      }));
      this.dropdownSelect = this.dropdownEl;
      this.dropdownSelect.on('change', this.callback);
      this.dropdownSelect.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: this.width
      });
    }

    Dropdown.prototype.selectedIndex = function() {
      return this.dropdownSelect[0].selectedIndex;
    };

    Dropdown.prototype.setSelectedIndex = function(idx) {
      this.dropdownSelect[0].selectedIndex = idx;
      return this.dropdownSelect.trigger("chosen:updated");
    };

    Dropdown.prototype.hide = function() {
      return this.el.css('display', 'none');
    };

    Dropdown.prototype.show = function() {
      return this.el.css('display', '');
    };

    Dropdown.prototype.isVisible = function() {
      return this.el.is(':visible');
    };

    Dropdown.prototype.release = function() {
      return Dropdown.__super__.release.apply(this, arguments);
    };

    return Dropdown;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.EditHelper = (function(superClass) {
    extend(EditHelper, superClass);

    EditHelper.include(Spine.Events);

    EditHelper.COLUMN_ERROR = 'SQL must return only one column';

    EditHelper.ROW_ERROR = 'SQL must return only one row';

    EditHelper.SOURCE_EDITOR_CACHE_EXPERIATION = 600;

    function EditHelper(item1) {
      this.item = item1;
      this.saveError = bind(this.saveError, this);
      this.permaDeleteArchive = bind(this.permaDeleteArchive, this);
      this.unarchiveItem = bind(this.unarchiveItem, this);
      this.destroyItem = bind(this.destroyItem, this);
      this.createOrDestroyStars = bind(this.createOrDestroyStars, this);
      this.createPermissionDenied = bind(this.createPermissionDenied, this);
      this.linkWidgetToDashboardCallbackFn = bind(this.linkWidgetToDashboardCallbackFn, this);
      this.completeCodeRunCallBack = bind(this.completeCodeRunCallBack, this);
      this.completeSqlRunCallBack = bind(this.completeSqlRunCallBack, this);
      this.runCodeStart = bind(this.runCodeStart, this);
      this.triggerResize = bind(this.triggerResize, this);
      this.handleError = bind(this.handleError, this);
      this.handleUpdate = bind(this.handleUpdate, this);
      this.sourceUpdated = bind(this.sourceUpdated, this);
      this.itemUpdated = bind(this.itemUpdated, this);
      this.removeCodeConfig = bind(this.removeCodeConfig, this);
      this.updateCodeConfig = bind(this.updateCodeConfig, this);
      this.setCodeHashKey = bind(this.setCodeHashKey, this);
      this.setDatabase = bind(this.setDatabase, this);
      this.enqueueWidgetResize = bind(this.enqueueWidgetResize, this);
      this.code = bind(this.code, this);
      this.sql = bind(this.sql, this);
      this.database = bind(this.database, this);
      EditHelper.__super__.constructor.apply(this, arguments);
      App.RedesignChartDragHelper.clearAdjustTimeout();
      App.SourceFetcher.bind('source-updated', this.sourceUpdated);
      if (this.isView()) {
        this.setHashKey(this.item.preview_source_hash_key);
      }
      this.item.bind('change', this.itemUpdated);
      this.item.bind('error', this.saveError);
      $(window).on('resize', this.triggerResize);
      this.bubbles(this.item, 'error');
      if (this.isSqlSnippet()) {
        App.SqlSnippet.shouldUpdateCurrentParams(this.item.displayName());
      }
      this.dragDropSeriesHelper = new App.DragDropSeriesHelper(this.item);
      this.dragDropSourceHashKeys = {};
      this.setChangeTrackingForDependencies();
      this.changeTrackingForDependencies.firstRender = true;
    }

    EditHelper.prototype.release = function() {
      var widget;
      App.SourceFetcher.unbind('source-updated', this.sourceUpdated);
      if (App.editronLinkedWidgetFormulaSourceHashKey || App.codeEditronLinkedWidgetFormulaSourceHashKey) {
        if (App.editronLinkedWidgetFormulaSourceHashKey) {
          delete App.editronLinkedWidgetFormulaSourceHashKey;
        }
        if (App.codeEditronLinkedWidgetFormulaSourceHashKey) {
          delete App.codeEditronLinkedWidgetFormulaSourceHashKey;
        }
        widget = App.Widget.exists(AppRedesign.widgetIdInUrl());
        if (widget) {
          widget.trigger('update');
        }
      }
      this.item.unbind('change', this.itemUpdated);
      this.item.unbind('error', this.saveError);
      AppRedesign.recoverator().clear(this.item.constructor.className);
      if (this.isWidgetOrSqlView()) {
        AppRedesign.recoverator().clear(App.EditHelper.itemCodeRecoveratorKey(this.item.constructor.name, this.item.id, this.codeLanguage(), this.codeVersion()));
        AppRedesign.recoverator().clear(App.EditHelper.itemCodeRecoveratorKey(this.item.constructor.name, null, this.codeLanguage(), this.codeVersion()));
      }
      return $(window).off('resize', this.triggerResize);
    };

    EditHelper.prototype.initReactWithSources = function() {
      return App.ReactActions.initReactStateWithSources(this.item, this.getError(), this.previewSql(), this.hasRunResultReachedPreviewLimit());
    };

    EditHelper.prototype.maybeInitSqlViewSource = function(source) {
      var base;
      if (!(this.isSqlView() && source.hash_key === this.getHashKey())) {
        return;
      }
      if (this.sqlRunResult != null) {
        return;
      }
      return App.ReactActions.initSqlRunResultForSource(typeof (base = this.item).sqlSource === "function" ? base.sqlSource() : void 0, this.previewSql(), null, this.item);
    };

    EditHelper.prototype.maybeInitSqlViewCodeSource = function(source) {
      var base;
      if (!(this.isSqlView() && source.hash_key === this.item.getCodeHashKey())) {
        return;
      }
      if (this.codeRunResult != null) {
        return;
      }
      return App.ReactActions.initCodeRunResultForSource(typeof (base = this.item).codeSource === "function" ? base.codeSource() : void 0);
    };

    EditHelper.prototype.itemConstructor = function() {
      return this.item.constructor;
    };

    EditHelper.prototype.getSql = function() {
      return this.item.sql;
    };

    EditHelper.prototype.getSqlHashKey = function() {
      if (this.isWidget()) {
        return this.item.getSqlHashKey();
      } else {
        return this.temp_view_hash_key;
      }
    };

    EditHelper.prototype.getHashKey = function() {
      if (this.isWidget()) {
        return this.item.hashKey();
      } else {
        return this.temp_view_hash_key;
      }
    };

    EditHelper.prototype.getName = function() {
      if (this.isWidget()) {
        return this.item.title;
      } else {
        return this.item.name;
      }
    };

    EditHelper.prototype.getError = function() {
      if (this.isView() || this.isSqlAlert()) {
        return this.item.getError(this.temp_view_hash_key);
      } else {
        return this.item.getError();
      }
    };

    EditHelper.prototype.database = function() {
      return this.item.database();
    };

    EditHelper.prototype.databaseOrDefault = function() {
      return this.database() || this.item.databaseOrDefault();
    };

    EditHelper.prototype.sql = function() {
      return this.getSql() || AppRedesign.recoverator().get(this.item.constructor.className) || '';
    };

    EditHelper.prototype.previewSql = function() {
      var ref;
      return ((ref = this.sqlDataSource()) != null ? ref.htmlSql() : void 0) || this.sql();
    };

    EditHelper.prototype.code = function() {
      var recoveredCode, savedCode, savedOrRecoveredSql;
      if (!this.isWidgetOrSqlView()) {
        return null;
      }
      savedOrRecoveredSql = this.sql();
      recoveredCode = AppRedesign.recoverator().get(App.EditHelper.itemCodeRecoveratorKey(this.item.constructor.name, this.item.id, this.codeLanguage(), this.codeVersion()));
      if (savedOrRecoveredSql && recoveredCode) {
        return recoveredCode;
      }
      savedCode = this.item.code;
      if (typeof savedCode === 'string') {
        return savedCode;
      }
      return null;
    };

    EditHelper.prototype.codeLanguage = function() {
      var ref;
      if (this.isWidgetOrSqlView()) {
        return this.item.code_language || ((ref = App.User.currentUser()) != null ? ref.getLastUsedCodeLanguage() : void 0);
      } else {
        return null;
      }
    };

    EditHelper.prototype.codeVersion = function() {
      var ref;
      if (this.isWidgetOrSqlView()) {
        return this.item.code_version || ((ref = App.User.currentUser()) != null ? ref.getLastUsedCodeVersion() : void 0);
      } else {
        return null;
      }
    };

    EditHelper.prototype.getSqlErrorInfo = function() {
      var fs;
      fs = this.sqlDataSource();
      if ((fs != null ? fs.error_message : void 0) == null) {
        return;
      }
      return {
        sql: this.previewSql(),
        error_message: fs.error_message,
        error_pos: fs.error_pos,
        ran_on_redshift: fs.ran_on_redshift
      };
    };

    EditHelper.prototype.getInfoAndWarnings = function() {
      return this.getQueryRunner().info_and_warnings;
    };

    EditHelper.prototype.enqueueWidgetResize = function() {
      return this.widget_resized = true;
    };

    EditHelper.prototype.getRows = function() {
      return (this.isWidget() ? this.item.getRows() : this.getViewRows()) || [];
    };

    EditHelper.prototype.getColumns = function() {
      return (this.isWidget() ? this.item.getColumns() : this.getViewColumns()) || [];
    };

    EditHelper.prototype.getViewRows = function() {
      var base, ref, ref1;
      return (ref = (ref1 = this.dataSource()) != null ? typeof ref1.rowsAsHashList === "function" ? ref1.rowsAsHashList() : void 0 : void 0) != null ? ref : typeof (base = this.item).rowsAsHashList === "function" ? base.rowsAsHashList() : void 0;
    };

    EditHelper.prototype.getViewColumns = function() {
      var base, ref, ref1;
      return (ref = (ref1 = this.dataSource()) != null ? ref1.columns : void 0) != null ? ref : typeof (base = this.item).getColumns === "function" ? base.getColumns() : void 0;
    };

    EditHelper.prototype.getSqlQueryInfo = function() {
      return {
        query: this.previewSql(),
        errorInfo: this.getSqlErrorInfo() || {}
      };
    };

    EditHelper.prototype.getItemInfoForReact = function() {
      var ref, ref1, ref2, ref3, ref4;
      if (this.isCsvView()) {
        return {
          widgetId: this.item.id,
          dashboardId: (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0,
          type: this.itemConstructor().className
        };
      } else {
        return {
          databaseName: (ref1 = this.database()) != null ? ref1.database_name : void 0,
          isForCacheDb: !!((ref2 = this.database()) != null ? ref2.cache : void 0),
          isForWarehouseDb: !!((ref3 = this.database()) != null ? ref3.warehouse : void 0),
          widgetId: this.item.id,
          dashboardId: (ref4 = App.Dashboard.currentDashboard()) != null ? ref4.id : void 0,
          type: this.itemConstructor().className,
          devDependencies: AppRedesign.devDependencies()
        };
      }
    };

    EditHelper.prototype.sqlDataSource = function() {
      var source;
      source = App.FormulaSource.findByHash(this.getSqlHashKey());
      if (this.isView()) {
        if (this.viewHashOverridden()) {
          return source;
        } else {
          return this.item.sqlSource();
        }
      } else {
        return source;
      }
    };

    EditHelper.prototype.dataSource = function() {
      var source;
      source = App.FormulaSource.findByHash(this.getHashKey());
      if (this.isView()) {
        if (this.viewHashOverridden()) {
          return source;
        } else {
          return this.item.sqlSource();
        }
      } else {
        return source;
      }
    };

    EditHelper.itemCodeRecoveratorKey = function(itemClass, itemId, codeLanguage, codeVersion) {
      if (itemId == null) {
        itemId = null;
      }
      return itemClass + ":" + itemId + ":" + codeLanguage + ":" + codeVersion;
    };

    EditHelper.prototype.setDatabase = function(dbId) {
      return this.item.setDatabase(dbId);
    };

    EditHelper.prototype.setHashKey = function(hash_key) {
      if (this.isWidget()) {
        this.item.setHashKey(hash_key);
        if (AppRedesign.widgetIdInUrl() && !this.hasCode()) {
          return App.editronLinkedWidgetFormulaSourceHashKey = hash_key;
        }
      } else {
        return this.temp_view_hash_key = hash_key;
      }
    };

    EditHelper.prototype.setCodeHashKey = function(hash_key) {
      if (hash_key != null) {
        this.item.setCodeHashKey(hash_key);
        this.codeRunResult.setHashKey(hash_key);
        if (AppRedesign.widgetIdInUrl()) {
          return App.codeEditronLinkedWidgetFormulaSourceHashKey = hash_key;
        }
      } else {
        this.codeRunResult.completedWithError('Error running code, please try again.');
        return this.trigger('update');
      }
    };

    EditHelper.prototype.setSqlModified = function(value) {
      return this.sqlModified = value;
    };

    EditHelper.prototype.setSql = function(sql) {
      return this.item.sql = sql;
    };

    EditHelper.prototype.updateSql = function(sql) {
      this.item.sql = sql;
      return AppRedesign.recoverator().set(this.item.constructor.className, sql);
    };

    EditHelper.prototype.updateLimit = function(limit) {
      return this.item.sql_limit = limit;
    };

    EditHelper.prototype.saveCode = function() {
      var codeInfo;
      codeInfo = App.ReactActions.getCodeInfoState();
      if (codeInfo.code != null) {
        this.item.code = codeInfo.code;
        this.item.code_version = codeInfo.code_version;
        return this.item.code_language = codeInfo.code_language;
      }
    };

    EditHelper.prototype.updateCodeConfig = function(code, code_language, code_version) {
      this.item.code = code;
      this.item.code_language = code_language;
      return this.item.code_version = code_version;
    };

    EditHelper.prototype.removeCodeConfig = function() {
      this.item.removeCodeConfig();
      return this.trigger('update');
    };

    EditHelper.prototype.deepAnalysisEnabled = function() {
      return AppRedesign.current().deepAnalysisEnabled;
    };

    EditHelper.prototype.isWidget = function() {
      return this.item instanceof App.Widget;
    };

    EditHelper.prototype.isSqlAlert = function() {
      return this.item instanceof App.SqlAlert;
    };

    EditHelper.prototype.isSqlView = function() {
      return this.item instanceof App.SqlView;
    };

    EditHelper.prototype.isCsvView = function() {
      return this.item instanceof App.CsvView;
    };

    EditHelper.prototype.isSqlSnippet = function() {
      return this.item instanceof App.SqlSnippet;
    };

    EditHelper.prototype.isView = function() {
      return this.isSqlView() || this.isCsvView();
    };

    EditHelper.prototype.isWidgetOrSqlView = function() {
      return this.isWidget() || this.isSqlView();
    };

    EditHelper.prototype.isDragDrop = function() {
      return App.DragDropSeriesHelper.isDragDropWidget(this.item);
    };

    EditHelper.prototype.isArchivedSqlView = function() {
      return AppRedesign.autoArchiveEnabled() && this.isSqlView() && (this.item.archived_at != null);
    };

    EditHelper.prototype.isValidWidget = function() {
      return this.isWidget() && this.item.hasSql();
    };

    EditHelper.prototype.isInvalidWidget = function() {
      return this.isWidget() && !this.item.hasSql();
    };

    EditHelper.prototype.indexDisabled = function() {
      return this.isSqlAlert();
    };

    EditHelper.prototype.shouldShowSourceViewer = function() {
      return this.isWidget() && (((this.database() != null) && this.itemConstructor() !== App.SqlSnippet) || this.hasData());
    };

    EditHelper.prototype.shouldShowRunButton = function() {
      return ((this.database() != null) && this.itemConstructor() !== App.SqlSnippet) || this.hasData();
    };

    EditHelper.prototype.isRestrictedDatabase = function() {
      var ref;
      return (ref = this.database()) != null ? ref.is_restricted : void 0;
    };

    EditHelper.prototype.updatePending = function() {
      var base;
      return typeof (base = this.item).hasUpdatePending === "function" ? base.hasUpdatePending() : void 0;
    };

    EditHelper.prototype.hasData = function() {
      var dataPresent, errorPresent, ref;
      if (!((this.dataSource() != null) || this.isSqlAlert())) {
        return false;
      }
      dataPresent = ((ref = this.dataSource()) != null ? typeof ref.hasData === "function" ? ref.hasData() : void 0 : void 0) || this.getColumns().length > 0 || this.getRows().length > 0;
      errorPresent = Boolean(this.getError());
      if (this.isSqlAlert()) {
        return dataPresent;
      } else {
        return dataPresent || errorPresent;
      }
    };

    EditHelper.prototype.hasRows = function() {
      return this.getRows().length > 0;
    };

    EditHelper.prototype.hasCode = function() {
      return (this.item.code != null) && this.deepAnalysisEnabled();
    };

    EditHelper.prototype.queryPending = function() {
      var ref;
      return (ref = this.sqlRunResult) != null ? ref.isRunning() : void 0;
    };

    EditHelper.prototype.viewHashOverridden = function() {
      return (this.temp_view_hash_key != null) && this.temp_view_hash_key !== this.item.preview_source_hash_key;
    };

    EditHelper.prototype.hasRunnableQuery = function() {
      return !this.isSqlSnippet();
    };

    EditHelper.prototype.itemUpdated = function() {
      return this.trigger('update');
    };

    EditHelper.prototype.sourceUpdated = function(source) {
      if (!(source.percent_complete === 1 || (typeof source.canceledForUser === "function" ? source.canceledForUser() : void 0))) {
        return;
      }
      this.updateSqlRunResult(source);
      this.updateCodeRunResult(source);
      if (this.isSqlAlert()) {
        this.applySourceToSqlAlert(source);
      }
      if (source.hash_key === this.getHashKey()) {
        return this.trigger('source-updated', source.hash_key);
      }
    };

    EditHelper.prototype.updateSqlRunResult = function(source) {
      var ref;
      this.maybeInitSqlViewSource(source);
      if (!((ref = this.sqlRunResult) != null ? ref.isWaitingFor(source.hash_key) : void 0)) {
        return;
      }
      this.sqlRunResult.completedWithFormulaSource(source);
      this.trigger('sql-source-updated', source.hash_key);
      if (this.sqlRunResult.getSqlHashKey() && this.sqlRunResult.hasRows() && !this.sqlRunResult.getErrorMessage()) {
        return this.dragDropStoreSourceHashKey(this.sqlRunResult.getSqlHashKey(), source);
      }
    };

    EditHelper.prototype.updateCodeRunResult = function(source) {
      var ref;
      this.maybeInitSqlViewCodeSource(source);
      if ((ref = this.codeRunResult) != null ? ref.isWaitingFor(source.hash_key) : void 0) {
        return this.codeRunResult.completedWithFormulaSource(source);
      }
    };

    EditHelper.prototype.handleUpdate = function(hash_key) {
      var last_hash_key, ref, ref1, ref2;
      last_hash_key = (ref = this.lastSqlRunResult) != null ? ref.getHashKey() : void 0;
      if (((ref1 = this.lastSqlRunResult) != null ? ref1.isRunning() : void 0) && last_hash_key && last_hash_key !== hash_key) {
        this.queryRunner.cancelLastQuery(this.lastSqlRequestId, last_hash_key);
        this.lastSqlRunResult = null;
      }
      this.setHashKey(hash_key);
      if ((ref2 = this.sqlRunResult) != null) {
        ref2.setHashKey(hash_key);
      }
      if (this.deepAnalysisEnabled()) {
        return App.ReactActions.updateCodeInputHashKeyState(hash_key);
      }
    };

    EditHelper.prototype.handleError = function(error) {
      var ref;
      this.item.error_message = error;
      if ((ref = this.sqlRunResult) != null) {
        ref.completedWithError(error);
      }
      return this.trigger('update');
    };

    EditHelper.prototype.showHeaderError = function(msg) {
      return this.trigger('show-header-error', msg);
    };

    EditHelper.prototype.clearHeaderError = function(msg) {
      return this.trigger('clear-header-error');
    };

    EditHelper.prototype.triggerResize = function() {
      return this.trigger('window-resized');
    };

    EditHelper.prototype.getSqlRows = function() {
      var sqlSource;
      sqlSource = this.sqlDataSource();
      if (!sqlSource) {
        return null;
      }
      if (sqlSource != null ? sqlSource.error_message : void 0) {
        return null;
      }
      return sqlSource.rows;
    };

    EditHelper.prototype.hasRunResultReachedPreviewLimit = function() {
      var rows;
      rows = this.getSqlRows();
      if (rows === null) {
        return false;
      }
      return (this.item.sql_limit != null) && this.getSqlRows().length === parseInt(this.item.sql_limit);
    };

    EditHelper.prototype.getQueryRunner = function() {
      return this.queryRunner != null ? this.queryRunner : this.queryRunner = new App.QueryRunner(this).bind('update', this.handleUpdate).bind('error', this.handleError);
    };

    EditHelper.prototype.runQuery = function(sql, limit, runPreviewAndFullSql) {
      var allowQueryCancel;
      if (runPreviewAndFullSql == null) {
        runPreviewAndFullSql = false;
      }
      if (_.isEmpty(sql.trim())) {
        return;
      }
      allowQueryCancel = AppRedesign.allowQueryCancel(this.database());
      if (!allowQueryCancel) {
        this.lastSqlRunResult = this.sqlRunResult;
        this.lastSqlRequestId = this.getQueryRunner().lastRequestId;
      }
      this.sqlRunResult = new App.RunResult(this.completeSqlRunCallBack);
      this.sqlRunResult.setDbInfo(this.database().info());
      jQuery.when(this.getQueryRunner().runQuery(sql, limit, this.item, runPreviewAndFullSql)).done((function(_this) {
        return function() {
          if (allowQueryCancel) {
            _this.lastSqlRunResult = _this.sqlRunResult;
            return _this.lastSqlRequestId = _this.getQueryRunner().lastRequestId;
          }
        };
      })(this));
      this.trigger('query-running');
      this.item.sql = sql;
      this.item.sql_limit = limit;
      return App.ReactActions.dispatchRanSqlInEditor();
    };

    EditHelper.prototype.cancelRunningQuery = function() {
      var hash_key, ref, ref1;
      if (!AppRedesign.allowQueryCancel(this.database())) {
        return;
      }
      hash_key = (ref = this.lastSqlRunResult) != null ? ref.getHashKey() : void 0;
      if (!(hash_key && ((ref1 = this.lastSqlRunResult) != null ? ref1.isRunning() : void 0))) {
        return;
      }
      this.getQueryRunner().cancelLastQuery(this.lastSqlRequestId, hash_key);
      return this.lastSqlRunResult = null;
    };

    EditHelper.prototype.runCodeStart = function() {
      this.codeRunResult = new App.RunResult(this.completeCodeRunCallBack);
      this.codeRunResult.setDbInfo(this.database().info());
      if (this.isWidget()) {
        return this.trigger('code-running');
      }
    };

    EditHelper.prototype.runPreviewAndFullSqlQueryInvisibly = function(sql, limit) {
      var runPreviewAndFullSql;
      if (!this.deepAnalysisEnabled()) {
        return;
      }
      if (_.isEmpty(sql.trim())) {
        return;
      }
      this.sqlRunResult = new App.RunResult(this.completeSqlRunCallBack);
      this.sqlRunResult.setDbInfo(this.database().info());
      this.getQueryRunner().runQuery(sql, limit, this.item, (runPreviewAndFullSql = true));
      this.item.sql = sql;
      return this.item.sql_limit = limit;
    };

    EditHelper.prototype.runQueryForDownload = function(sql) {
      if (_.isEmpty(sql.trim())) {
        return;
      }
      return App.DownloadHelper.exportCSVForEditUser(this.item, sql, this.databaseOrDefault().id, this.sqlModified);
    };

    EditHelper.prototype.completeSqlRunCallBack = function(result) {
      var errorInfo, sqlRun;
      errorInfo = this.getSqlErrorInfo() || {};
      sqlRun = {
        result: result,
        sql_query: App.ReactActions.queryAndErrorInfoObject(this.previewSql(), errorInfo),
        sqlRunReachedPreviewLimit: this.hasRunResultReachedPreviewLimit()
      };
      return App.ReactActions.updateSqlRunResultState(sqlRun);
    };

    EditHelper.prototype.completeCodeRunCallBack = function(result) {
      if (this.deepAnalysisEnabled()) {
        return App.ReactActions.updateCodeRunResultState(result);
      }
    };

    EditHelper.prototype.dragDropStoreSourceHashKey = function(sqlHashKey, source) {
      delete this.dragDropSourceHashKeys[sqlHashKey];
      if (source.error_message != null) {
        return;
      }
      return this.dragDropSourceHashKeys[sqlHashKey] = source.hash_key;
    };

    EditHelper.prototype.sourceIsValidAndRecent = function(sqlHashKey, source) {
      var duration;
      if (source == null) {
        return false;
      }
      duration = Date.now() / 1000 - source.last_update;
      if (duration > App.EditHelper.SOURCE_EDITOR_CACHE_EXPERIATION) {
        delete this.dragDropSourceHashKeys[sqlHashKey];
        return false;
      }
      return true;
    };

    EditHelper.prototype.dragDropFreshSourceAlreadyExists = function(sqlHashKey) {
      var fsHashKey, source;
      fsHashKey = this.dragDropSourceHashKeys[sqlHashKey];
      if (fsHashKey == null) {
        return false;
      }
      source = App.FormulaSource.findByHash(fsHashKey);
      if (!this.sourceIsValidAndRecent(sqlHashKey, source)) {
        return false;
      }
      this.handleUpdate(fsHashKey);
      this.sourceUpdated(source);
      return true;
    };

    EditHelper.prototype.runDragDropQuery = function(sql, sqlHashKey, chartOptions, limit) {
      this.updateSql(sql || '');
      this.updateLimit(limit);
      this.setDragDropTwiddle(chartOptions);
      this.dragDropInfo = chartOptions.missingSlotsMessage;
      if (sql) {
        this.lastSqlRunResult = this.sqlRunResult;
        this.lastSqlRequestId = this.getQueryRunner().lastRequestId;
        this.sqlRunResult = new App.RunResult(this.completeSqlRunCallBack);
        this.sqlRunResult.setDbInfo(this.database().info());
        this.sqlRunResult.setSqlHashKey(sqlHashKey);
        if (!this.dragDropFreshSourceAlreadyExists(sqlHashKey)) {
          this.getQueryRunner().runQuery(sql, limit, this.item, false);
          this.trigger('query-running');
        }
      } else {
        this.setHashKey(null);
      }
      return this.trigger('sql-changed', sql);
    };

    EditHelper.prototype.dragDropChangedChartType = function(chartType) {
      this.item.chart_type = chartType;
      return this.trigger('drag-drop-changed-chart-type', chartType);
    };

    EditHelper.prototype.setDragDropTwiddle = function(chartOptions) {
      this.dragDropSeriesHelper.setSeriesTwiddles(chartOptions);
      return this.dragDropSeriesHelper.setDragDropStateTwiddles(chartOptions);
    };

    EditHelper.prototype.applySourceToSqlAlert = function(source) {
      var ref, ref1;
      this.item.error_message = this.getSqlAlertErrorMessageFromFormulaSource(source);
      return this.item.last_value = (ref = source.rows) != null ? (ref1 = ref[0]) != null ? ref1[0] : void 0 : void 0;
    };

    EditHelper.prototype.getSqlAlertErrorMessageFromFormulaSource = function(fs) {
      var ref;
      if (!this.hasData()) {
        return;
      }
      if (fs.error_message != null) {
        return fs.error_message;
      }
      if (((ref = fs.column_infos) != null ? ref.length : void 0) !== 1) {
        return App.EditHelper.COLUMN_ERROR;
      }
      if (fs.rows.length !== 1 || fs.rows[0].length !== 1) {
        return App.EditHelper.ROW_ERROR;
      }
      return null;
    };

    EditHelper.prototype.shouldShowDatasetDeletionModal = function() {
      var datasetId;
      datasetId = App.Dataset.datasetId(this.item.id, this.item.constructor.className);
      return datasetId != null;
    };

    EditHelper.prototype.shouldShowDatasetUnpublishModal = function() {
      if (this.item.isNew()) {
        return false;
      }
      return (this.isSqlView() || this.isCsvView()) && (this.hasDatasetChanged() && !this.item.has_dataset);
    };

    EditHelper.prototype.getNumDiscoveryChartAndDisplayModal = function(title, afterDeletionCallBack, noDiscoveryChartCallback) {
      var datasetId, datasetToDelete;
      datasetId = App.Dataset.datasetId(this.item.id, this.item.constructor.className);
      datasetToDelete = {
        datasetId: datasetId,
        name: this.item.name,
        type: this.item.constructor.className
      };
      return App.ReactActions.getNumDiscoveryChartAndDisplayModal(App.Dataset.all(), datasetToDelete, title, afterDeletionCallBack, noDiscoveryChartCallback);
    };

    EditHelper.prototype.hasDatasetChanged = function() {
      return this.item.has_dataset !== this.item.__proto__.has_dataset;
    };

    EditHelper.prototype.hasCacheScheduleChanged = function() {
      return this.isSqlView() && App.Site.first().schedulable_views_enabled && !_.isEqual(this.item.schedulable, this.item.__proto__.schedulable);
    };

    EditHelper.prototype.linkWidgetToDashboardCallbackFn = function(dashboard) {
      dashboard.unbind("ajaxSuccess", this.linkWidgetToDashboardCallbackFn);
      this.item.dashboard_id = dashboard.id;
      return this.saveItemContent(true);
    };

    EditHelper.prototype.createNewDashboardAndSaveItemContent = function() {
      return App.LeftMenuHelper.newItem(App.Dashboard).bind('ajaxSuccess', this.linkWidgetToDashboardCallbackFn);
    };

    EditHelper.prototype.removeSavedCsvViewFromUploadedFromChartEditorCsvIds = function() {
      var csvViewId, datasetId;
      if (!(window.reactApp.getUploadedFromChartEditorCsvs().length > 0)) {
        return;
      }
      datasetId = App.User.currentUser().getLastUsedDatasetId();
      if (datasetId == null) {
        return;
      }
      csvViewId = App.Dataset.find(datasetId).explorable().id;
      return window.reactApp.removeUploadedFromChartEditorCsv(csvViewId);
    };

    EditHelper.prototype.setRowAndSaveItemContent = function() {
      var dashboard;
      dashboard = this.item.dashboard();
      dashboard.reload();
      return jQuery.ajax({
        url: "/dashboards/" + dashboard.id + "/next_free_row",
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id,
          dashboard_id: dashboard.id
        }
      }).done((function(_this) {
        return function(res) {
          if (res.free_row >= 0) {
            return _this.item.setRow(res.free_row);
          }
        };
      })(this)).always((function(_this) {
        return function() {
          return _this.saveItemContent(true);
        };
      })(this));
    };

    EditHelper.prototype.saveItemContent = function(shouldClose) {
      var itemIsNew, refreshHistory, saveSuccess;
      if (shouldClose == null) {
        shouldClose = true;
      }
      itemIsNew = this.item.isNew();
      if (this.isValidWidget()) {
        this.saveUwv();
      }
      this.saveCode();
      saveSuccess = this.saveItemByType();
      if (this.isValidWidget()) {
        this.updateDashboard(this.item.dashboard());
      }
      if (saveSuccess) {
        if (itemIsNew) {
          this.newItemSaved = true;
        }
        if (AppRedesign.widgetIdInUrl()) {
          if (App.editronLinkedWidgetFormulaSourceHashKey) {
            App.linkedWidgetFormulaSourceHashKey = App.editronLinkedWidgetFormulaSourceHashKey;
          }
          if (App.codeEditronLinkedWidgetFormulaSourceHashKey) {
            App.codeLinkedWidgetFormulaSourceHashKey = App.codeEditronLinkedWidgetFormulaSourceHashKey;
          }
        }
        if (shouldClose) {
          this.trigger('close', this.newItemSaved && {
            nextNavItem: this.item.reload()
          });
          return this.trigger('saved');
        } else {
          this.trigger('saved');
          refreshHistory = (function(_this) {
            return function() {
              _this.item.unbind('ajaxSuccess', refreshHistory);
              return _this.trigger('refresh-history');
            };
          })(this);
          return this.item.bind('ajaxSuccess', refreshHistory);
        }
      }
    };

    EditHelper.prototype.saveItem = function(shouldClose) {
      var itemIsNew;
      App.Utils.logFeature('editor-save');
      itemIsNew = this.item.isNew();
      if (this.isWidget() && itemIsNew) {
        if (this.item.is_exploration && !this.item.dashboard()) {
          this.createNewDashboardAndSaveItemContent();
        } else {
          this.setRowAndSaveItemContent();
        }
        return this.removeSavedCsvViewFromUploadedFromChartEditorCsvIds();
      } else {
        return this.saveItemContent(shouldClose);
      }
    };

    EditHelper.prototype.saveItemByType = function() {
      var hasCacheScheduleChanged, hasDatasetChanged;
      if (this.isInvalidWidget()) {
        return true;
      }
      if (this.isCsvView() && this.item.isNew()) {
        hasDatasetChanged = this.hasDatasetChanged();
        return this.csvController.uploadAndSave(this.item, (function(_this) {
          return function() {
            _this.createOrDestroyStars;
            if (hasDatasetChanged) {
              return App.Site.trigger('request-several-updates');
            }
          };
        })(this));
      } else if (this.isSqlView() || this.isCsvView()) {
        hasDatasetChanged = this.hasDatasetChanged();
        hasCacheScheduleChanged = this.hasCacheScheduleChanged();
        this.item.bind('ajaxError', this.createPermissionDenied);
        return this.item.save({
          success: (function(_this) {
            return function() {
              _this.createOrDestroyStars();
              if (hasDatasetChanged || hasCacheScheduleChanged) {
                return App.Site.trigger('request-several-updates');
              }
            };
          })(this)
        });
      } else {
        this.item.bind('ajaxError', this.createPermissionDenied);
        return this.item.save({
          success: this.createOrDestroyStars
        });
      }
    };

    EditHelper.prototype.hadSuccessfulCreate = function() {
      return this.newItemSaved;
    };

    EditHelper.prototype.saveUwv = function() {
      var ref;
      if (this.item.chart_type !== 'table') {
        return;
      }
      return (ref = App.UserWidgetView.findByWidget(this.item)) != null ? ref.setDefaultTwiddlesFromUwv(this.item.twiddles) : void 0;
    };

    EditHelper.prototype.updateDashboard = function(dashboard) {
      if (dashboard == null) {
        return;
      }
      if (this.widget_resized) {
        dashboard.trigger('resized-widget-in-editor', this.item);
      }
      dashboard.trigger('scroll-to-widget', this.item.id);
      return setTimeout(((function(_this) {
        return function() {
          return _this.item.trigger('flash');
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    EditHelper.prototype.createPermissionDenied = function(xhr, statusText, error) {
      this.item.unbind('ajaxError', this.createPermissionDenied);
      if (xhr.status === HttpCodes.permissionDenied) {
        this.item.destroy();
        return Spine.trigger('permission_denied');
      }
    };

    EditHelper.prototype.createOrDestroyStars = function() {
      var starState;
      if (this.item.pending_star_state == null) {
        return;
      }
      starState = this.item.pending_star_state;
      this.item.unbind('ajaxError', this.createPermissionDenied);
      this.item.reload();
      return App.StarredItem.toggleStarred(this.item, starState);
    };

    EditHelper.prototype.deleteItem = function() {
      var starForItem;
      App.Utils.logFeature('editor-delete');
      starForItem = App.StarredItem.getStarForCurrentUser(this.item);
      if (starForItem != null) {
        starForItem.destroy();
      }
      this.destroyItem();
      if (this.isWidget()) {
        return App.Dashboard.trigger('collapse-empty-rows', this.item.dashboard_id);
      }
    };

    EditHelper.prototype.destroyItem = function() {
      if (!this.item.readyToBeDestroyed()) {
        return;
      }
      this.item.destroy();
      if (AppRedesign.autoArchiveEnabled() && this.isView()) {
        return App.SearchableArchive.createRecord(this.item.id, this.item.name, this.item.constructor.className, new Date().toISOString(), this.item.tag_names, this.item.has_dataset, this.item.guid);
      }
    };

    EditHelper.prototype.unarchiveItem = function() {
      return jQuery.ajax({
        url: "/" + this.item.constructor.routeName + "/" + this.item.id + "/unarchive",
        type: 'post'
      }).done((function(_this) {
        return function(res) {
          return AppRedesign.current().spinalCord.applyAllUnarchivedUpdates(res);
        };
      })(this)).always((function(_this) {
        return function() {
          var item;
          item = App[_this.item.constructor.className].exists(_this.item.id);
          _this.trigger('close', {
            nextNavItem: item
          });
          if (!item) {
            return;
          }
          App.RouteHelper.navigateTo(item.constructor.className, item, {
            replace: true
          });
          return App.SearchableArchive.deleteRecord(item.id, item.constructor.className);
        };
      })(this));
    };

    EditHelper.prototype.permaDeleteArchive = function() {
      return jQuery.ajax({
        url: "/" + this.item.constructor.routeName + "/" + this.item.id + "/delete_archive",
        type: 'post'
      }).always((function(_this) {
        return function() {
          _this.trigger('close');
          return App.SearchableArchive.deleteRecord(_this.item.id, _this.item.constructor.className);
        };
      })(this));
    };

    EditHelper.prototype.saveError = function(item, errors) {
      var base, error, ref;
      error = this.nonUploadingError(errors);
      if (!error) {
        return;
      }
      return this.showHeaderError((ref = typeof (base = this.itemConstructor()).prettyErrorMessage === "function" ? base.prettyErrorMessage(error) : void 0) != null ? ref : error);
    };

    EditHelper.prototype.nonUploadingError = function(errors) {
      return _.find(this.nonUploadingErrors(), function(error) {
        return _.includes(errors, error);
      });
    };

    EditHelper.prototype.nonUploadingErrors = function() {
      return _.at(this.itemConstructor(), ['ERROR_NO_NAME', 'DUPE_FIELD_NAMES', 'DUPE_NAME', 'LEADING_NUMERIC_NAME', 'FAILED_UPLOAD', 'NO_DATA', 'ILLEGAL_NAME', 'ILLEGAL_PARAM_NAME', 'ILLEGAL_PARAM', 'NOT_UNIQUE_PARAM', 'ERROR_NO_SQL', 'INVALID_FILENAME_CHARACTERS']);
    };

    EditHelper.prototype.dependenciesDataWasUpdated = function() {
      if (this.changeTrackingForDependencies == null) {
        return false;
      }
      if (this.changeTrackingForDependencies.firstRender === true) {
        return true;
      }
      return this.changeTrackingForDependencies.sqlHashKey !== this.getSqlHashKey() || this.changeTrackingForDependencies.name !== this.getName() || this.changeTrackingForDependencies.chartType !== this.item.chart_type;
    };

    EditHelper.prototype.maybeFetchViewDependenciesGraph = function() {
      if (this.dependenciesDataWasUpdated()) {
        return this.fetchViewDependenciesGraph();
      }
    };

    EditHelper.prototype.fetchViewDependenciesGraph = function() {
      App.ReactActions.dispatchFetchGraph(this.item, this.dependenciesDataWasUpdated());
      return this.setChangeTrackingForDependencies();
    };

    EditHelper.prototype.setChangeTrackingForDependencies = function() {
      return this.changeTrackingForDependencies = {
        name: this.getName(),
        sqlHashKey: this.getSqlHashKey(),
        chartType: this.item.chart_type,
        firstRender: false
      };
    };

    return EditHelper;

  })(Spine.Module);

}).call(this);
(function() {
  App.EditorRightPanelHelper = (function() {
    function EditorRightPanelHelper() {}

    EditorRightPanelHelper.SETTING_TABS = {
      'SqlAlert': [
        {
          iconClass: 'settings-icon',
          controllerClass: 'RedesignSqlAlertSettingsController',
          openByDefault: true,
          tooltipText: 'Settings'
        }, {
          iconClass: 'history-icon',
          controllerClass: 'RedesignHistoryController',
          tooltipText: 'History'
        }
      ],
      'SqlView': [
        {
          iconClass: 'settings-icon',
          controllerClass: 'RedesignSqlViewSettingsController',
          openByDefault: true,
          tooltipText: 'Settings'
        }, {
          iconClass: 'history-icon',
          controllerClass: 'RedesignHistoryController',
          tooltipText: 'History'
        }
      ],
      'CsvView': [
        {
          iconClass: 'settings-icon',
          controllerClass: 'RedesignCsvEditorSettingsController',
          openByDefault: true,
          tooltipText: 'Settings'
        }
      ],
      'Widget': [
        {
          iconClass: 'widget-series-icon',
          controllerClass: 'WidgetSettingsController',
          type: 'SeriesSettings',
          openByDefault: true,
          tooltipText: 'Series Settings'
        }, {
          iconClass: 'widget-format-icon',
          controllerClass: 'WidgetSettingsController',
          type: 'ChartFormat',
          tooltipText: 'Chart Format'
        }, {
          iconClass: 'history-icon',
          controllerClass: 'RedesignHistoryController',
          tooltipText: 'History'
        }
      ],
      'SqlSnippet': [
        {
          iconClass: 'settings-icon',
          controllerClass: 'SqlSnippetViewSettingsController',
          openByDefault: true,
          tooltipText: 'Settings'
        }, {
          iconClass: 'history-icon',
          controllerClass: 'RedesignHistoryController',
          tooltipText: 'History'
        }
      ]
    };

    return EditorRightPanelHelper;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CancelSaveBlock = (function(superClass) {
    extend(CancelSaveBlock, superClass);

    CancelSaveBlock.prototype.className = 'buttons flex-fill-row';

    CancelSaveBlock.prototype.elements = {
      '.button.save': 'saveButton',
      '.button.cancel': 'cancelButton'
    };

    CancelSaveBlock.prototype.events = {
      'click .cancel': 'cancelClicked',
      'click .save': 'saveClicked'
    };

    function CancelSaveBlock() {
      var ref;
      CancelSaveBlock.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'saveFunc', 'cancelFunc', 'saveText');
      this.html(this.view('redesign/cancel_save')({
        saveText: this.saveText,
        hideCancel: this.hideCancel,
        saveButtonClass: (ref = this.saveButtonClass) != null ? ref : 'action'
      }));
      if (this.hideCancel) {
        this.el.addClass('single');
      }
      this.el.addClass("" + (_.lowerCase(this.saveText)));
    }

    CancelSaveBlock.prototype.cancelClicked = function() {
      return this.cancelFunc();
    };

    CancelSaveBlock.prototype.saveClicked = function() {
      return this.saveFunc();
    };

    CancelSaveBlock.prototype.setSaveDisabled = function(val) {
      return this.saveButton.toggleClass('disabled', val);
    };

    CancelSaveBlock.prototype.disable = function() {
      this.setSaveDisabled(true);
      return this.cancelButton.addClass('disabled');
    };

    return CancelSaveBlock;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ChartBuilder = (function(superClass) {
    extend(ChartBuilder, superClass);

    ChartBuilder.prototype.className = 'drag-drop-chart-builder';

    ChartBuilder.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function ChartBuilder(widget1) {
      this.widget = widget1;
      this.onWidgetSettingsUpdated = bind(this.onWidgetSettingsUpdated, this);
      ChartBuilder.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    ChartBuilder.prototype.initialize = function() {
      var chartBuilderState;
      this.html("<div class=\"react-root\"></div>");
      chartBuilderState = this.getChartBuilderState(this.widget);
      this.reactRoot = window.reactApp.chartBuilderRoot(this.reactRootEl[0], chartBuilderState);
      return this.widget.bind('settings-updated', this.onWidgetSettingsUpdated);
    };

    ChartBuilder.prototype.refresh = function(widget) {
      var chartBuilderState;
      chartBuilderState = this.getChartBuilderState(widget);
      return window.reactApp.dragDropChartLoadHistory(chartBuilderState);
    };

    ChartBuilder.prototype.getChartBuilderState = function(widget) {
      var builder, calculatedFields, chartType, geomapPlotMode, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, selectedDatasetId, subChartType;
      builder = ((ref = widget.twiddles) != null ? (ref1 = ref.dragDrop) != null ? ref1.builder : void 0 : void 0) || {};
      calculatedFields = ((ref2 = widget.twiddles) != null ? (ref3 = ref2.dragDrop) != null ? ref3.calculatedFields : void 0 : void 0) || [];
      selectedDatasetId = ((ref4 = widget.twiddles) != null ? (ref5 = ref4.dragDrop) != null ? ref5.selectedDatasetId : void 0 : void 0) || null;
      if (!App.Dataset.exists(selectedDatasetId)) {
        selectedDatasetId = ((ref6 = App.Dataset.first()) != null ? ref6.id : void 0) || null;
      }
      chartType = widget.chart_type;
      subChartType = ((ref7 = widget.twiddles) != null ? ref7.twiddle_geomap_data_mode : void 0) || null;
      geomapPlotMode = ((ref8 = widget.twiddles) != null ? ref8.twiddle_geomap_plot_mode : void 0) || null;
      return {
        builder: builder,
        selectedDatasetId: selectedDatasetId,
        calculatedFields: calculatedFields,
        chartType: chartType,
        subChartType: subChartType,
        geomapPlotMode: geomapPlotMode,
        sqlForDisplay: ''
      };
    };

    ChartBuilder.prototype.release = function() {
      var ref;
      this.widget.unbind('settings-updated', this.onWidgetSettingsUpdated);
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return ChartBuilder.__super__.release.apply(this, arguments);
    };

    ChartBuilder.prototype.onWidgetSettingsUpdated = function(widget) {
      var chartBuilderState;
      chartBuilderState = this.getChartBuilderState(widget);
      return window.reactApp.updateChartBuilderState(chartBuilderState);
    };

    return ChartBuilder;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CodeEditorPanel = (function(superClass) {
    extend(CodeEditorPanel, superClass);

    CodeEditorPanel.prototype.className = 'code-editor-panel';

    CodeEditorPanel.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function CodeEditorPanel() {
      CodeEditorPanel.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    CodeEditorPanel.prototype.initialize = function() {
      this.html("<div class=\"react-root\"></div>");
      return this.reactRoot = window.reactApp.codeEditorRoot(this.reactRootEl[0], App.Dashboard.currentDashboard().id, this.input_hash_key, this.code, this.codeLanguage, this.codeVersion);
    };

    CodeEditorPanel.prototype.refresh = function(helper) {
      if (helper.item.code != null) {
        window.reactApp.updateCode(helper.item.code);
        return window.reactApp.requestCodeTimeTravel();
      } else {
        window.reactApp.updateCode("");
        return window.reactApp.requestCodeTimeTravel();
      }
    };

    CodeEditorPanel.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return CodeEditorPanel.__super__.release.apply(this, arguments);
    };

    return CodeEditorPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CodeSchemaViewer = (function(superClass) {
    extend(CodeSchemaViewer, superClass);

    CodeSchemaViewer.prototype.className = 'code';

    CodeSchemaViewer.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function CodeSchemaViewer() {
      CodeSchemaViewer.__super__.constructor.apply(this, arguments);
      this.initialize();
      App.CustomModule.bind('refresh change', this.updateCustomModules);
      App.CustomModule.fetch();
    }

    CodeSchemaViewer.prototype.initialize = function() {
      this.html("<div class=\"react-root code-schema\"></div>");
      return this.reactRoot = window.reactApp.codeSchemaViewerRoot(this.reactRootEl[0]);
    };

    CodeSchemaViewer.prototype.updateCustomModules = function() {
      var filePaths, ref;
      filePaths = _.map(App.CustomModule.all(), function(f) {
        return f["filepath"];
      });
      return (ref = window.reactApp) != null ? ref.updateCustomModulesSchema(filePaths) : void 0;
    };

    CodeSchemaViewer.prototype.release = function() {
      var ref;
      App.CustomModule.unbind('ajaxSuccess');
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return CodeSchemaViewer.__super__.release.apply(this, arguments);
    };

    return CodeSchemaViewer;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConfirmController = (function(superClass) {
    extend(ConfirmController, superClass);

    ConfirmController.prototype.className = 'confirm-controller modal';

    ConfirmController.prototype.elements = {
      '.button-row': 'buttonRow',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    ConfirmController.prototype.events = {
      'click .dont-save': 'dontSaveClicked',
      'click .cancel-icon': 'release'
    };

    function ConfirmController() {
      this.release = bind(this.release, this);
      this.save = bind(this.save, this);
      ConfirmController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'itemClass');
      App.Site.trigger('enter-modal');
      this.html(this.view('redesign/editors/confirm')({
        itemClass: this.itemClass.PRETTY_CLASS_NAME_LOWERCASE
      }));
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.release,
        saveFunc: this.save,
        saveText: 'SAVE'
      });
      this.rightAlignedButtons.append(this.cancelSaveBlock.el);
      $('#modal').empty();
      $('#modal').append(this.el);
    }

    ConfirmController.prototype.save = function() {
      this.trigger('save');
      return this.release();
    };

    ConfirmController.prototype.dontSaveClicked = function() {
      this.trigger('cancel');
      return this.release();
    };

    ConfirmController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return ConfirmController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return ConfirmController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CopyToController = (function(superClass) {
    extend(CopyToController, superClass);

    CopyToController.prototype.elements = {
      'input.widget-title': 'widgetTitle',
      'select.dashboard-list': 'dashboardListSelect',
      '.button-row': 'buttonRow',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    CopyToController.prototype.events = {
      'click .cancel-icon': 'cancel'
    };

    function CopyToController() {
      this.release = bind(this.release, this);
      this.cancel = bind(this.cancel, this);
      this.save = bind(this.save, this);
      this.renderDashboardList = bind(this.renderDashboardList, this);
      CopyToController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget');
      App.Dashboard.one('remaining-state-loaded', this.renderDashboardList);
      this.render();
    }

    CopyToController.prototype.render = function() {
      this.html(this.view('redesign/editors/copy_to')());
      this.widgetTitle.val(this.widget.getRawTitle());
      this.renderDashboardList();
      this.dashboardListSelect.chosen({
        width: '100%',
        disable_search: false
      });
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.save,
        saveText: 'SAVE'
      });
      return this.rightAlignedButtons.append(this.cancelSaveBlock.el);
    };

    CopyToController.prototype.renderDashboardList = function() {
      var d, i, len, list, ref, ref1;
      list = [];
      ref = App.Dashboard.allSortedByName();
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        if (d.canCopyTo() && d.id) {
          list.push({
            name: d.getName(),
            value: d.id
          });
        }
      }
      this.dashboardListSelect.html(App.Utils.optionsToHtml(list, (ref1 = App.Dashboard.currentDashboard()) != null ? ref1.id : void 0));
      return this.dashboardListSelect.trigger("chosen:updated");
    };

    CopyToController.prototype.save = function() {
      var dashboardId, saveFn, targetDashboard;
      dashboardId = Number(this.dashboardListSelect.val());
      targetDashboard = App.Dashboard.find(dashboardId);
      saveFn = (function(_this) {
        return function() {
          var widget;
          widget = _this.widget.dup(true);
          widget.api_token = null;
          if (widget.api_enabled) {
            widget.getApiToken();
          }
          widget.cid = widget.constructor.uid("c-");
          widget.id = null;
          widget.copy_archived_widgets_from_id = _this.widget.id;
          widget.title = _this.widgetTitle.val();
          widget.setColumn(0);
          widget.setRow(targetDashboard.nextFreeRow());
          widget.dashboard_id = targetDashboard.id;
          widget.twiddles = _.cloneDeep(_this.widget.twiddles);
          _this.trigger('copy-to', widget, _this.widget.dashboard_id !== targetDashboard.id);
          return _this.release();
        };
      })(this);
      if (!targetDashboard.isCompletelyLoaded()) {
        return targetDashboard.trigger('load-dashboard', saveFn);
      } else {
        return saveFn();
      }
    };

    CopyToController.prototype.cancel = function() {
      return this.release();
    };

    CopyToController.prototype.release = function() {
      this.trigger('close-dialog');
      return setTimeout(((function(_this) {
        return function() {
          return CopyToController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return CopyToController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CsvEditorCenterPanel = (function(superClass) {
    extend(CsvEditorCenterPanel, superClass);

    CsvEditorCenterPanel.prototype.className = 'deep-editor editron-center flex-filler';

    CsvEditorCenterPanel.prototype.elements = {
      '.replace': 'replaceLink',
      '.file-container': 'fileContainerEl',
      '.sql-result': 'sqlResultContainer'
    };

    CsvEditorCenterPanel.prototype.events = {
      'click .replace': 'replaceLinkClicked',
      'change .file-upload': 'readCsv'
    };

    function CsvEditorCenterPanel() {
      this.resizeChartArea = bind(this.resizeChartArea, this);
      this.showLoading = bind(this.showLoading, this);
      this.readCsv = bind(this.readCsv, this);
      this.handleDrop = bind(this.handleDrop, this);
      this.handleDragOut = bind(this.handleDragOut, this);
      this.handleDragOver = bind(this.handleDragOver, this);
      this.uploadAndSave = bind(this.uploadAndSave, this);
      this.renderPanel = bind(this.renderPanel, this);
      CsvEditorCenterPanel.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper', 'csvView');
      this.csvUploader = new App.CsvUploader(this.csvView);
      this.csvView.bind('update', this.renderPanel);
      this.renderPanel();
    }

    CsvEditorCenterPanel.prototype.renderPanel = function() {
      this.html(this.view('redesign/editors/csv_center_panel')({
        item: this.csvView
      }));
      this.reactRoot = window.reactApp.sqlResultRoot(this.sqlResultContainer[0], this.editHelper.getItemInfoForReact(), this.editHelper.itemConstructor().className);
      window.reactApp.updateSqlRunResult({
        result: this.transformCsvViewToRunResult(),
        sql_query: {}
      });
      if (App.Utils.isClientId(this.csvView.id)) {
        this.fileContainerEl[0].addEventListener('dragover', this.handleDragOver, false);
        this.fileContainerEl[0].addEventListener('dragleave', this.handleDragOut, false);
        return this.fileContainerEl[0].addEventListener('drop', this.handleDrop, false);
      } else {
        return this.replaceLink.hide();
      }
    };

    CsvEditorCenterPanel.prototype.transformCsvViewToRunResult = function() {
      var fs;
      if (!this.csvView.isNew() && this.csvView.getState() === 'Queued') {
        return {
          running: true
        };
      } else {
        fs = this.csvView.formulaSource();
        if (fs != null) {
          return App.RunResult.translateSourceToRunResultOutput(fs);
        } else if (this.csvView.preview_data) {
          return App.RunResult.translateItemToRunResultOutput(this.csvView);
        } else {

        }
      }
    };

    CsvEditorCenterPanel.prototype.release = function() {
      var ref;
      this.csvView.unbind('loading', this.showLoading);
      this.csvView.unbind('update', this.renderPanel);
      return (ref = this.reactRoot) != null ? ref.close() : void 0;
    };

    CsvEditorCenterPanel.prototype.replaceLinkClicked = function() {
      if (!App.Utils.isClientId(this.csvView.id)) {
        return;
      }
      this.csvUploader.release();
      delete this.csvUploader;
      delete this.csvView.filename;
      delete this.csvView.preview_source_hash_key;
      this.csvView.clearData();
      this.csvUploader = new App.CsvUploader(this.csvView);
      return this.csvView.trigger('update');
    };

    CsvEditorCenterPanel.prototype.uploadAndSave = function(csvView, successCallback) {
      this.editHelper.clearHeaderError();
      return this.csvUploader.uploadAndSave(successCallback).success;
    };

    CsvEditorCenterPanel.prototype.handleDragOver = function(evt) {
      this.fileContainerEl.addClass("dragover");
      evt.stopPropagation();
      evt.preventDefault();
      return evt.dataTransfer.dropEffect = 'copy';
    };

    CsvEditorCenterPanel.prototype.handleDragOut = function(evt) {
      return this.fileContainerEl.removeClass("dragover");
    };

    CsvEditorCenterPanel.prototype.handleDrop = function(evt) {
      var file;
      this.fileContainerEl.removeClass("dragover");
      evt.stopPropagation();
      evt.preventDefault();
      file = evt.dataTransfer.files[0];
      return this.readFileToCsv(file);
    };

    CsvEditorCenterPanel.prototype.readCsv = function(evt) {
      var file;
      if (evt.target.files.length < 1) {
        return;
      }
      file = evt.target.files[0];
      return this.readFileToCsv(file);
    };

    CsvEditorCenterPanel.prototype.readFileToCsv = function(file) {
      this.trigger('csv-uploaded');
      return this.csvUploader.readFile(file);
    };

    CsvEditorCenterPanel.prototype.showLoading = function() {
      var ref;
      return (ref = this.sourceViewer) != null ? ref.showLoading() : void 0;
    };

    CsvEditorCenterPanel.prototype.resizeChartArea = function() {
      return window.reactApp.updateEditorWidth(this.el.width());
    };

    return CsvEditorCenterPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DataSourcePicker = (function(superClass) {
    extend(DataSourcePicker, superClass);

    DataSourcePicker.prototype.className = 'DataSourcePicker';

    DataSourcePicker.prototype.elements = {
      '.datasource-picker-react-root': 'dataSourcePickerReactRootEl'
    };

    function DataSourcePicker() {
      DataSourcePicker.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    DataSourcePicker.prototype.initialize = function() {
      this.html("<div class='datasource-picker-react-root' style='margin-left:18px;'></div>");
      return this.reactRoot = window.reactApp.dataSourcePickerRoot(this.dataSourcePickerReactRootEl[0]);
    };

    DataSourcePicker.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return DataSourcePicker.__super__.release.apply(this, arguments);
    };

    return DataSourcePicker;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DatasetViewer = (function(superClass) {
    extend(DatasetViewer, superClass);

    DatasetViewer.prototype.className = 'dataset-viewer';

    DatasetViewer.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function DatasetViewer() {
      DatasetViewer.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    DatasetViewer.prototype.initialize = function() {
      this.html("<div class=\"react-root\"></div>");
      return this.reactRoot = window.reactApp.datasetViewerRoot(this.reactRootEl[0]);
    };

    DatasetViewer.datasets = function() {
      return App.Dataset.all().filter(function(dataset) {
        return dataset.explorable() !== false;
      }).map(function(dataset) {
        var owner, ownerName, ref;
        owner = App.User.exists(dataset.explorable().owner_user_id);
        if (owner) {
          ownerName = owner.displayName();
        }
        return {
          id: dataset.id,
          name: dataset.explorable().name,
          database_id: dataset.databaseId(),
          database_type: (ref = _.filter(App.Database.all(), function(el) {
            return el.id === dataset.explorable().database_id;
          })[0]) != null ? ref.database_type : void 0,
          description: dataset.explorable().description,
          tag_names: dataset.explorable().tag_names,
          owner_name: ownerName,
          last_update: dataset.explorable().last_update,
          last_materialize_at: dataset.explorable().last_successful_materialize_at,
          materialization_status: dataset.prettyStatus(),
          status_for_icon: _.camelCase(dataset.statusForIcon()),
          columns: _.map(dataset.columns(), function(vs) {
            return {
              column_name: vs.columnName,
              column_type: vs.type
            };
          }),
          recent_viewed_at: dataset.recentViewedAt(),
          is_mine: dataset.explorable().owner_user_id === App.User.currentUser().id,
          is_starred: Boolean(App.StarredItem.getStarForCurrentUser(dataset.explorable())),
          explorable_type: dataset.explorable_type,
          explorable_id: dataset.explorable_id
        };
      });
    };

    DatasetViewer.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return DatasetViewer.__super__.release.apply(this, arguments);
    };

    return DatasetViewer;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DeepEditorCenterPanel = (function(superClass) {
    extend(DeepEditorCenterPanel, superClass);

    DeepEditorCenterPanel.prototype.className = 'deep-editor editron-center flex-filler';

    function DeepEditorCenterPanel() {
      this.limitChanged = bind(this.limitChanged, this);
      this.sqlChanged = bind(this.sqlChanged, this);
      this.maybeUpdateHighlightedParams = bind(this.maybeUpdateHighlightedParams, this);
      this.dbChanged = bind(this.dbChanged, this);
      this.schemaColumnClicked = bind(this.schemaColumnClicked, this);
      DeepEditorCenterPanel.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
      this.sqlEditorController = new App.SqlEditorCenterPanel({
        editHelper: this.editHelper
      });
      this.bubbles(this.sqlEditorController, 'sql-keydown sql-changed');
      this.append(this.sqlEditorController.el);
      if (this.editHelper.isWidget() || (this.editHelper.isSqlView() && AppRedesign.codeInViewsEnabled())) {
        if (AppRedesign.current().deepAnalysisEnabled) {
          this.codeEditorController = new App.CodeEditorPanel({
            code: this.editHelper.code(),
            codeLanguage: this.editHelper.codeLanguage(),
            codeVersion: this.editHelper.codeVersion(),
            input_hash_key: this.editHelper.getSqlHashKey()
          });
          this.append(this.codeEditorController.el);
        }
        if (this.editHelper.shouldShowSourceViewer()) {
          this.sourceViewer = new App.SourceViewController({
            editHelper: this.editHelper
          });
          this.append(this.sourceViewer.el);
        }
      }
      this.editHelper.initReactWithSources();
    }

    DeepEditorCenterPanel.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.sourceViewer) != null) {
        ref.release();
      }
      if ((ref1 = this.codeEditorController) != null) {
        ref1.release();
      }
      this.sqlEditorController.release();
      return DeepEditorCenterPanel.__super__.release.apply(this, arguments);
    };

    DeepEditorCenterPanel.prototype.resizeChartArea = function() {
      var ref;
      if ((ref = this.sourceViewer) != null) {
        if (typeof ref.resizeChartArea === "function") {
          ref.resizeChartArea();
        }
      }
      return window.reactApp.updateEditorWidth(this.getWidth());
    };

    DeepEditorCenterPanel.prototype.getWidth = function() {
      return this.el.width();
    };

    DeepEditorCenterPanel.prototype.refresh = function(helper) {
      var ref;
      this.sqlEditorController.refresh(helper);
      return (ref = this.codeEditorController) != null ? ref.refresh(helper) : void 0;
    };

    DeepEditorCenterPanel.prototype.schemaColumnClicked = function(columnName) {
      return this.sqlEditorController.schemaColumnClicked(columnName);
    };

    DeepEditorCenterPanel.prototype.dbChanged = function() {
      return this.sqlEditorController.dbChanged();
    };

    DeepEditorCenterPanel.prototype.maybeUpdateHighlightedParams = function(newTitle) {
      return this.sqlEditorController.maybeUpdateHighlightedParams(newTitle);
    };

    DeepEditorCenterPanel.prototype.sqlChanged = function() {
      return this.sqlEditorController.sqlChanged();
    };

    DeepEditorCenterPanel.prototype.limitChanged = function() {
      return this.sqlEditorController.limitChanged();
    };

    DeepEditorCenterPanel.dateOfLastEditorScroll = function() {
      return AppRedesign.current()._dateOfLastEditorScroll;
    };

    return DeepEditorCenterPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DragDropEditorPanel = (function(superClass) {
    extend(DragDropEditorPanel, superClass);

    DragDropEditorPanel.prototype.className = 'drag-drop-editor editron-center flex-filler';

    DragDropEditorPanel.prototype.elements = {
      '.chart-builder-area': 'chartBuilderArea',
      '.source-viewer-area': 'sourceViewerArea',
      '.chart-button': 'chartButton',
      '.sql-button': 'sqlButton',
      '.read-only-sql-editor-area': 'readOnlySqlEditorArea'
    };

    DragDropEditorPanel.prototype.events = {
      'click .chart-button': 'onChartButtonClicked',
      'click .sql-button': 'onSqlButtonClicked'
    };

    function DragDropEditorPanel() {
      this.limitChanged = bind(this.limitChanged, this);
      this.sqlChanged = bind(this.sqlChanged, this);
      this.maybeUpdateHighlightedParams = bind(this.maybeUpdateHighlightedParams, this);
      this.dbChanged = bind(this.dbChanged, this);
      this.schemaColumnClicked = bind(this.schemaColumnClicked, this);
      this.showSql = bind(this.showSql, this);
      this.showChart = bind(this.showChart, this);
      this.onSqlButtonClicked = bind(this.onSqlButtonClicked, this);
      this.onChartButtonClicked = bind(this.onChartButtonClicked, this);
      DragDropEditorPanel.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
      this.html(this.view('redesign/dashboards/drag_drop_editor_panel')());
      this.setupChartBuilder();
      this.bubbles(this.editHelper, 'sql-changed');
      this.bind('sql-changed', this.sqlChanged);
      if (this.editHelper.shouldShowSourceViewer()) {
        this.sourceViewer = new App.SourceViewController({
          editHelper: this.editHelper
        });
        this.sourceViewerArea.append(this.sourceViewer.el);
        this.readOnlySqlEditor = new App.DragDropReadOnlySqlEditor();
        this.readOnlySqlEditorArea.append(this.readOnlySqlEditor.el);
        this.showChart();
      } else {
        this.sourceViewerArea.hide();
        this.chartButton.hide();
        this.sqlButton.hide();
        this.readOnlySqlEditorArea.hide();
      }
    }

    DragDropEditorPanel.prototype.setupChartBuilder = function() {
      this.chartBuilder = new App.ChartBuilder({
        widget: this.editHelper.item
      });
      return this.chartBuilderArea.append(this.chartBuilder.el);
    };

    DragDropEditorPanel.prototype.onChartButtonClicked = function() {
      return this.showChart();
    };

    DragDropEditorPanel.prototype.onSqlButtonClicked = function() {
      return this.showSql();
    };

    DragDropEditorPanel.prototype.showChart = function() {
      this.sourceViewerArea.show();
      this.sourceViewer.chartTabUpdated();
      this.readOnlySqlEditorArea.hide();
      return this.highlightChartButton();
    };

    DragDropEditorPanel.prototype.showSql = function() {
      this.sourceViewerArea.hide();
      this.readOnlySqlEditorArea.show();
      this.readOnlySqlEditor.render();
      return this.highlightSqlButton();
    };

    DragDropEditorPanel.prototype.highlightChartButton = function() {
      this.chartButton.css({
        color: '#22AB9F',
        fontWeight: 'bold'
      });
      return this.sqlButton.css({
        color: 'black',
        fontWeight: 'normal'
      });
    };

    DragDropEditorPanel.prototype.highlightSqlButton = function() {
      this.sqlButton.css({
        color: '#22AB9F',
        fontWeight: 'bold'
      });
      return this.chartButton.css({
        color: 'black',
        fontWeight: 'normal'
      });
    };

    DragDropEditorPanel.prototype.release = function() {
      var ref, ref1, ref2;
      if ((ref = this.sourceViewer) != null) {
        ref.release();
      }
      if ((ref1 = this.chartBuilder) != null) {
        ref1.release();
      }
      if ((ref2 = this.readOnlySqlEditor) != null) {
        ref2.release();
      }
      this.unbind('sql-changed', this.sqlChanged);
      return DragDropEditorPanel.__super__.release.apply(this, arguments);
    };

    DragDropEditorPanel.prototype.resizeChartArea = function() {
      var ref;
      return (ref = this.sourceViewer) != null ? typeof ref.resizeChartArea === "function" ? ref.resizeChartArea() : void 0 : void 0;
    };

    DragDropEditorPanel.prototype.getWidth = function() {
      return this.el.width();
    };

    DragDropEditorPanel.prototype.refresh = function(helper) {
      this.chartBuilder.refresh(helper.item);
      return helper.item.trigger('chart-type-refresh', helper.item.chart_type);
    };

    DragDropEditorPanel.prototype.schemaColumnClicked = function(columnName) {};

    DragDropEditorPanel.prototype.dbChanged = function() {};

    DragDropEditorPanel.prototype.maybeUpdateHighlightedParams = function(newTitle) {};

    DragDropEditorPanel.prototype.sqlChanged = function(newSql) {
      if (newSql === null) {
        return this.sourceViewer.chartTabUpdated();
      }
    };

    DragDropEditorPanel.prototype.limitChanged = function() {};

    return DragDropEditorPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DragDropReadOnlySqlEditor = (function(superClass) {
    extend(DragDropReadOnlySqlEditor, superClass);

    DragDropReadOnlySqlEditor.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function DragDropReadOnlySqlEditor() {
      DragDropReadOnlySqlEditor.__super__.constructor.apply(this, arguments);
      this.render();
    }

    DragDropReadOnlySqlEditor.prototype.render = function() {
      this.html("<div class=\"react-root\"></div>");
      return this.reactRoot = window.reactApp.dragDropReadOnlySqlEditorRoot(this.reactRootEl[0]);
    };

    DragDropReadOnlySqlEditor.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return DragDropReadOnlySqlEditor.__super__.release.apply(this, arguments);
    };

    return DragDropReadOnlySqlEditor;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.EditorChartHelper = (function(superClass) {
    extend(EditorChartHelper, superClass);

    EditorChartHelper.prototype.elements = {
      '.grid-boundary': 'grid',
      '.widget-container': 'widgetContainer'
    };

    function EditorChartHelper() {
      this.buttonLabel = bind(this.buttonLabel, this);
      this.changedUwv = bind(this.changedUwv, this);
      this.controlPressed = bind(this.controlPressed, this);
      this.saveMapPosition = bind(this.saveMapPosition, this);
      this.renderOnSettingsUpdated = bind(this.renderOnSettingsUpdated, this);
      this.rerender = bind(this.rerender, this);
      var dashboard, ref;
      EditorChartHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'editHelper');
      this.chartable = this.editHelper.item;
      dashboard = ((ref = this.chartable) != null ? typeof ref.dashboard === "function" ? ref.dashboard() : void 0 : void 0) || App.Dashboard.currentDashboard();
      this.html(this.view('redesign/editors/editor_chart_pane')());
      this.dashboardSizer = new App.RedesignDashboardSizer(dashboard);
      this.chartable.bind('changed-uwv', this.changedUwv);
    }

    EditorChartHelper.prototype.release = function() {
      var ref;
      if ((ref = this.chartContainer) != null) {
        ref.release();
      }
      return EditorChartHelper.__super__.release.apply(this, arguments);
    };

    EditorChartHelper.prototype.initialize = function() {
      this.dashboardSizer.buildEditorGrid(this.grid);
      this.dashboardSizer.updateGridWidth(this.grid);
      this.chartContainer = this.createChartContainer();
      this.chartContainer.bind('control-pressed', this.controlPressed);
      this.chartContainer.bind('save-map-position', this.saveMapPosition);
      this.chartable.bind('settings-updated', this.renderOnSettingsUpdated);
      this.chartContainer.renderFrame();
      this.bubbles(this.chartContainer, "size-updated");
      this.bubbles(this.chartContainer, "chart-rendered");
      return this.render();
    };

    EditorChartHelper.prototype.createChartContainer = function() {
      this.setWidgetSize();
      this.widgetContainer.addClass("in-editron");
      return new App.RedesignChartContainerController({
        animateOnce: true,
        canEdit: !this.chartable.isReadOnlyToCurrentUser(),
        chartInEditron: true,
        editHelper: this.editHelper,
        editing: true,
        el: this.widgetContainer,
        item: this.chartable,
        resizableFunc: (function() {
          return true;
        }),
        waitingText: 'Set chart settings'
      });
    };

    EditorChartHelper.prototype.setWidgetSize = function() {
      var hasReachedBorder, height, ref, width;
      ref = this.dashboardSizer.editorSizeforWidget(this.chartable), width = ref[0], height = ref[1], hasReachedBorder = ref[2];
      return this.widgetContainer.css({
        left: 0,
        top: 0,
        width: hasReachedBorder ? '100%' : width,
        height: height
      });
    };

    EditorChartHelper.prototype.rerender = function(complete) {
      this.dashboardSizer.updateGridWidth(this.grid);
      this.setWidgetSize();
      this.chartContainer.resizeOnly();
      this.render(false);
      if (complete) {
        return this.hideChartLoadingIndicator();
      }
    };

    EditorChartHelper.prototype.renderOnSettingsUpdated = function(widget, animate) {
      if (animate == null) {
        animate = true;
      }
      return this.render(animate, null);
    };

    EditorChartHelper.prototype.render = function(animate, uwv) {
      if (uwv == null) {
        uwv = null;
      }
      this.chartContainer.notifyFrameRendered();
      return this.renderWidgetSoon(animate, uwv);
    };

    EditorChartHelper.prototype.renderWidgetSoon = function(animate, uwv) {
      var closure, ref;
      closure = (function(_this) {
        return function() {
          return _this.chartContainer.renderWidget(_this.chartable, animate, false, uwv);
        };
      })(this);
      return (ref = AppRedesign.current()) != null ? ref.uiQueue.addWithFlush(closure, 'render-widget-in-editor') : void 0;
    };

    EditorChartHelper.prototype.saveMapPosition = function(position) {
      var lat, lng, zoom;
      if (position != null) {
        zoom = position.zoom;
        lat = position.lat;
        lng = position.lng;
      } else {
        zoom = null;
        lat = null;
        lng = null;
      }
      this.chartable.setTwiddle(App.TwiddleConfig.GEOMAP_LATITUDE, lat);
      this.chartable.setTwiddle(App.TwiddleConfig.GEOMAP_LONGITUDE, lng);
      return this.chartable.setTwiddle(App.TwiddleConfig.GEOMAP_ZOOM, zoom);
    };

    EditorChartHelper.prototype.controlPressed = function(action) {
      if (action === 'pivot') {
        return this.addPivot();
      }
    };

    EditorChartHelper.prototype.addPivot = function() {
      var ref;
      return (ref = this.chartContainer) != null ? ref.chartHandler('addPivot') : void 0;
    };

    EditorChartHelper.prototype.showChartLoadingIndicator = function() {
      this.chartContainer.hideMaterializingCsvMessage();
      return this.chartContainer.fadeInLoader();
    };

    EditorChartHelper.prototype.hideChartLoadingIndicator = function() {
      return this.chartContainer.hideLoaderEl();
    };

    EditorChartHelper.prototype.changedUwv = function(widget, uwv) {
      widget.uwv = uwv;
      widget.uwv_twiddles = uwv != null ? uwv.twiddles : void 0;
      this.uwv = uwv;
      return this.render(false, uwv);
    };

    EditorChartHelper.prototype.buttonLabel = function(evt) {
      if (evt.text != null) {
        return evt.text;
      } else {
        return $(evt.currentTarget).attr('title').trim();
      }
    };

    return EditorChartHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.IconTooltipHelper = (function(superClass) {
    extend(IconTooltipHelper, superClass);

    IconTooltipHelper.DEFAULT_FONT_SIZE = 11;

    IconTooltipHelper.LEFT_MARGIN = 15;

    IconTooltipHelper.TOP_OFFSET = 33;

    IconTooltipHelper.TOP_OVERFLOW = {
      direction: 'top',
      scale: 0.5,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.BOTTOM_OVERFLOW = {
      direction: 'bottom',
      scale: 0.5,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.BOTTOM_LEFT_CORNER = {
      direction: 'bottom',
      scale: 0.05,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.LEFT_OVERFLOW = {
      direction: 'top',
      scale: 0.1,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.LEFT_OVERFLOW_LOW_MARGIN = {
      direction: 'top',
      scale: 0.05,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.RIGHT_OVERFLOW_BOTTOM = {
      direction: 'bottom',
      scale: 0.8,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.RIGHT_OVERFLOW_TOP = {
      direction: 'top',
      scale: 0.9,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.RIGHT_OVERFLOW_LOW_MARGIN_BOTTOM = {
      direction: 'bottom',
      scale: 0.95,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.RIGHT_OVERFLOW_LOW_MARGIN_TOP = {
      direction: 'top',
      scale: 0.95,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.RIGHT_SIDE_OVERFLOW = {
      direction: 'bottom',
      scale: 0.85,
      leftScale: 0.5,
      topScale: 0.2
    };

    IconTooltipHelper.CHART_TITLE_POSITION_PARAMETERS = [IconTooltipHelper.RIGHT_SIDE_OVERFLOW];

    IconTooltipHelper.POSITION_PARAMETERS = [IconTooltipHelper.TOP_OVERFLOW, IconTooltipHelper.BOTTOM_OVERFLOW, IconTooltipHelper.LEFT_OVERFLOW, IconTooltipHelper.LEFT_OVERFLOW_LOW_MARGIN, IconTooltipHelper.RIGHT_OVERFLOW_BOTTOM, IconTooltipHelper.RIGHT_OVERFLOW_TOP, IconTooltipHelper.RIGHT_OVERFLOW_LOW_MARGIN_BOTTOM, IconTooltipHelper.RIGHT_OVERFLOW_LOW_MARGIN_TOP, IconTooltipHelper.BOTTOM_LEFT_CORNER];

    IconTooltipHelper.POSITION_PARAMETERS_TABLE_CHART = [IconTooltipHelper.TOP_OVERFLOW, IconTooltipHelper.BOTTOM_OVERFLOW, IconTooltipHelper.LEFT_OVERFLOW, IconTooltipHelper.LEFT_OVERFLOW_LOW_MARGIN, IconTooltipHelper.RIGHT_OVERFLOW_TOP, IconTooltipHelper.RIGHT_OVERFLOW_LOW_MARGIN_TOP, IconTooltipHelper.BOTTOM_LEFT_CORNER];

    IconTooltipHelper.HIDE_DELAY_MS = 3000;

    function IconTooltipHelper() {
      this.tooltipHidden = bind(this.tooltipHidden, this);
      this.iconMouseLeave = bind(this.iconMouseLeave, this);
      this.buildTooltip = bind(this.buildTooltip, this);
      this.iconMouseEnter = bind(this.iconMouseEnter, this);
      this.showSavedTooltip = bind(this.showSavedTooltip, this);
      this.releaseTooltipOnce = bind(this.releaseTooltipOnce, this);
      this.release = bind(this.release, this);
      IconTooltipHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'icon', 'infoCallback');
      this.icon.on('mouseenter', this.iconMouseEnter);
      this.icon.on('mouseleave', this.iconMouseLeave);
      this.icon.on('show-saved-tooltip', this.showSavedTooltip);
      if (this.activeClass == null) {
        this.activeClass = 'selected';
      }
      if (this.exitClass == null) {
        this.exitClass = 'no-tooltip';
      }
      if (this.useWidthAsMin == null) {
        this.useWidthAsMin = true;
      }
      if (this.tooltipClass == null) {
        this.tooltipClass = 'light-theme';
      }
    }

    IconTooltipHelper.prototype.release = function() {
      var ref;
      if ((ref = this.descriptionTooltip) != null) {
        ref.closeAndRelease();
      }
      this.icon.off('mouseenter', this.iconMouseEnter);
      this.icon.off('mouseleave', this.iconMouseLeave);
      this.unbindScroll();
      return IconTooltipHelper.__super__.release.apply(this, arguments);
    };

    IconTooltipHelper.prototype.releaseTooltipOnce = function() {
      var ref;
      if ((ref = this.descriptionTooltip) != null) {
        ref.release();
      }
      return this.unbindScroll();
    };

    IconTooltipHelper.prototype.unbindScroll = function() {
      var ref;
      return (ref = this.scrolEl) != null ? ref.off('scroll', this.releaseTooltipOnce) : void 0;
    };

    IconTooltipHelper.prototype.bindScroll = function() {
      var ref;
      if (this.scrollEl == null) {
        this.scrollEl = AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON ? $('.editor-panel .editron-center') : AppRedesign.current().getCurrentState() === AppRedesign.IN_DASH ? $('.main-content') : void 0;
      }
      return (ref = this.scrollEl) != null ? ref.on('scroll', this.releaseTooltipOnce) : void 0;
    };

    IconTooltipHelper.prototype.showSavedTooltip = function(evt) {
      this.buildTooltip(evt, 'Saved!');
      return setTimeout(((function(_this) {
        return function() {
          var ref;
          if ((ref = _this.descriptionTooltip) != null) {
            ref.closeAndRelease();
          }
          _this.unbindScroll();
          return _this.descriptionTooltip = null;
        };
      })(this)), this.constructor.HIDE_DELAY_MS);
    };

    IconTooltipHelper.prototype.iconMouseEnter = function(evt) {
      var height, newTopOffset, panelTop, pointerPosition, ref, targetIcon, targetLeft, targetOffset, targetTop, tooltipDirection, validParamSet, width;
      this.buildTooltip(evt);
      targetIcon = $(evt.currentTarget);
      targetOffset = targetIcon.offset();
      tooltipDirection = (ref = this.direction) != null ? ref : App.RedesignTooltipPanel.TOP;
      targetLeft = this.leftOffset + targetOffset.left;
      targetTop = this.topOffset + targetOffset.top;
      pointerPosition = App.RedesignTooltipPanel.CENTER_POINTER;
      if (!this.descriptionTooltip) {
        return;
      }
      width = this.descriptionTooltip.panel.outerWidth();
      height = this.descriptionTooltip.panel.outerHeight();
      panelTop = tooltipDirection === App.RedesignTooltipPanel.TOP ? targetTop + this.constructor.TOP_OFFSET : targetTop - height - App.RedesignTooltipPanel.SMALL_POINTER_SIZE - App.RedesignTooltipPanel.TIP_PADDING;
      if (!(this.alwaysKeepInDashboard && !App.IconTooltipHelper.validDashboardPosition(targetLeft - width * pointerPosition, panelTop, width, height))) {
        return;
      }
      validParamSet = App.IconTooltipHelper.findValidPosition(targetIcon, this.descriptionTooltip.panel, this.constructor.POSITION_PARAMETERS);
      if (validParamSet == null) {
        return;
      }
      newTopOffset = targetIcon.outerHeight() * validParamSet.topScale;
      return this.descriptionTooltip = this.makeTooltip(evt, validParamSet.direction, validParamSet.scale, targetIcon.outerWidth() * validParamSet.leftScale + targetOffset.left, newTopOffset + targetOffset.top);
    };

    IconTooltipHelper.prototype.buildTooltip = function(evt, tooltipDescription) {
      var pointerPosition, ref, targetIcon, targetLeft, targetOffset, targetTop, tooltipDirection;
      this.iconMouseLeave();
      targetIcon = $(evt.currentTarget);
      if (targetIcon.hasClass(this.exitClass)) {
        return;
      }
      if (this.closeOnScroll) {
        this.bindScroll();
      }
      targetIcon.addClass(this.activeClass);
      targetOffset = targetIcon.offset();
      tooltipDirection = (ref = this.direction) != null ? ref : App.RedesignTooltipPanel.TOP;
      if (this.tooltipWidth == null) {
        this.tooltipWidth = Math.min(this.tooltipWidth, this.widthFromContents(evt));
      }
      if (this.minWidth != null) {
        this.tooltipWidth = Math.max(this.minWidth, this.tooltipWidth);
      }
      if (this.contentCallback != null) {
        this.content = this.contentCallback(evt);
      }
      if (this.infoCallback(evt) === 'SPACES') {
        this.tooltipClass += ' spaces';
      }
      if (this.leftOffset == null) {
        this.leftOffset = (targetIcon.outerWidth() * App.RedesignTooltipPanel.DEFAULT_POINT_LEFT_SCALE) + 1;
      }
      if (this.topOffset == null) {
        this.topOffset = targetIcon.outerHeight() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE;
      }
      targetLeft = this.leftOffset + targetOffset.left;
      targetTop = this.topOffset + targetOffset.top;
      pointerPosition = App.RedesignTooltipPanel.CENTER_POINTER;
      return this.descriptionTooltip = this.makeTooltip(evt, tooltipDirection, pointerPosition, targetLeft, targetTop, tooltipDescription);
    };

    IconTooltipHelper.prototype.makeTooltip = function(evt, tooltipDirection, pointerPosition, left, top, description) {
      var ref, targetIcon;
      description = description || this.infoCallback(evt);
      if (this.skipMakingLeftNavSettingsTooltip && description === 'Settings') {
        return;
      }
      targetIcon = $(evt.currentTarget);
      if ((ref = this.descriptionTooltip) != null) {
        ref.release();
      }
      return App.RedesignTooltipPanel.addPanel({
        side: tooltipDirection,
        width: this.tooltipWidth,
        pointerOffsetPercent: pointerPosition,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        description: description,
        contentEl: this.content,
        useSmallPointer: true,
        extraClass: this.tooltipClass,
        useWidthAsMin: this.useWidthAsMin,
        showOnce: this.showOnce,
        hideOnLeave: this.hideOnLeave,
        parentSelector: this.parentSelector
      }).pointAt(tooltipDirection, targetIcon, pointerPosition, left, top).bind('hide', this.tooltipHidden);
    };

    IconTooltipHelper.prototype.iconMouseLeave = function(evt) {
      var ref, ref1;
      if ((ref = $(evt != null ? evt.currentTarget : void 0)) != null) {
        ref.removeClass(this.activeClass);
      }
      if ((ref1 = this.descriptionTooltip) != null) {
        ref1.closeAndRelease();
      }
      this.unbindScroll();
      return this.descriptionTooltip = null;
    };

    IconTooltipHelper.prototype.tooltipHidden = function() {
      var ref;
      this.icon.removeClass(this.activeClass);
      return (ref = this.descriptionTooltip) != null ? ref.unbind('hide', this.tooltipHidden) : void 0;
    };

    IconTooltipHelper.prototype.widthFromContents = function(evt) {
      var ref;
      App.Utils.initCanvasWidthSizer((ref = this.fontSize) != null ? ref : this.constructor.DEFAULT_FONT_SIZE);
      return Math.min(250, App.Utils.canvasWidthForText(this.infoCallback(evt)));
    };

    IconTooltipHelper.findValidPosition = function(targetIcon, panel, positionParameters) {
      var height, i, len, paramSet, targetLeft, targetOffset, targetTop, top, width;
      targetOffset = targetIcon.offset();
      width = panel.outerWidth();
      height = panel.outerHeight();
      for (i = 0, len = positionParameters.length; i < len; i++) {
        paramSet = positionParameters[i];
        targetLeft = targetIcon.outerWidth() * paramSet.leftScale + targetOffset.left;
        targetTop = targetIcon.outerHeight() * paramSet.topScale + targetOffset.top;
        top = paramSet.direction === App.RedesignTooltipPanel.TOP ? targetTop + App.IconTooltipHelper.TOP_OFFSET : targetTop - height - App.RedesignTooltipPanel.SMALL_POINTER_SIZE - App.RedesignTooltipPanel.TIP_PADDING;
        if (App.IconTooltipHelper.validDashboardPosition(targetLeft - width * paramSet.scale, top, width, height)) {
          return paramSet;
        }
      }
    };

    IconTooltipHelper.validDashboardPosition = function(tooltipLeft, tooltipTop, tooltipWidth, tooltipHeight) {
      var mainContentEl, mainLeft, mainTop, withinTop;
      mainContentEl = $('.dashboards-container');
      if (_.isEmpty(mainContentEl)) {
        return;
      }
      mainLeft = mainContentEl.offset().left;
      mainTop = mainContentEl.offset().top;
      withinTop = mainTop < tooltipTop;
      return mainLeft < tooltipLeft && withinTop && (mainLeft + mainContentEl.width()) > tooltipLeft + tooltipWidth && (mainTop + mainContentEl.height()) > tooltipTop + tooltipHeight;
    };

    return IconTooltipHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LeftPanelController = (function(superClass) {
    extend(LeftPanelController, superClass);

    LeftPanelController.prototype.className = 'editron-left-panel open';

    LeftPanelController.prototype.events = {
      'click .editron-left-panel-toggle': 'toggleOpen'
    };

    LeftPanelController.MIN_SCREEN_WIDTH_FOR_LEFTPANE = 900;

    function LeftPanelController() {
      this.getCurrentDatabase = bind(this.getCurrentDatabase, this);
      this.editorToggled = bind(this.editorToggled, this);
      this.toggleOpen = bind(this.toggleOpen, this);
      this.render = bind(this.render, this);
      LeftPanelController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'editHelper');
      this.render();
      App.Dashboard.bind('remaining-state-loaded', this.render);
    }

    LeftPanelController.prototype.render = function() {
      var db, ref, ref1, ref2, ref3, schemaViewerEl, selectedDatasetId;
      this.html(this.view('redesign/editors/left_panel')());
      if (AppRedesign.current().bodyWidth() < this.constructor.MIN_SCREEN_WIDTH_FOR_LEFTPANE) {
        this.el.removeClass('open');
      }
      schemaViewerEl = this.createSchemaViewerController().el.appendTo(this.el);
      if (!(AppRedesign.dragDropEnabled() && this.item.constructor === App.Widget)) {
        return;
      }
      window.reactApp.updateDatabases(this.convertToSimpleObject(this.sortedDatabases()));
      window.reactApp.updateDatasets(App.DatasetViewer.datasets());
      db = this.getCurrentDatabase();
      if (this.isDragDropWidget()) {
        selectedDatasetId = ((ref = this.item.twiddles) != null ? (ref1 = ref.dragDrop) != null ? ref1.selectedDatasetId : void 0 : void 0) || null;
        if (selectedDatasetId) {
          if ((ref2 = App.User.currentUser()) != null) {
            ref2.setLastUsedDatasetId(selectedDatasetId);
          }
        }
        window.reactApp.pickDataset(selectedDatasetId, {
          skipConfirm: true
        });
        this.editorToggled(App.RedesignEditor.DRAG_DROP_EDITOR);
      } else {
        if ((ref3 = App.User.currentUser()) != null) {
          ref3.setLastUsedDatasetId(null);
        }
        window.reactApp.pickDatabase(db.id, {
          skipConfirm: true
        });
      }
      return this.createLeftPanelRoot().el.insertBefore(schemaViewerEl);
    };

    LeftPanelController.prototype.release = function() {
      var ref, ref1, ref2, ref3;
      App.Dashboard.unbind('remaining-state-loaded', this.render);
      this.schemaViewerController.release();
      if ((ref = this.buttonGroup) != null) {
        ref.release();
      }
      if ((ref1 = this.leftPanel) != null) {
        ref1.release();
      }
      if ((ref2 = this.dataSourcePicker) != null) {
        ref2.release();
      }
      if ((ref3 = this.dragDropDatasetView) != null) {
        ref3.release();
      }
      return LeftPanelController.__super__.release.apply(this, arguments);
    };

    LeftPanelController.prototype.refresh = function(editHelper) {
      this.editHelper = editHelper;
      this.schemaViewerController.refresh(editHelper);
      return this.render();
    };

    LeftPanelController.prototype.convertToSimpleObject = function(databases) {
      var mappedDatabases, warehouseDbs;
      mappedDatabases = databases.map((function(_this) {
        return function(item) {
          return {
            activeRestriction: item.activeRestriction(),
            id: item.id,
            name: item.database_name,
            warehouseSchemaEnabled: item.warehouseSchemaEnabled(),
            isByowDatabase: item.isByowDatabase()
          };
        };
      })(this));
      warehouseDbs = _.remove(mappedDatabases, function(database) {
        return database.warehouseSchemaEnabled;
      });
      return _.concat(warehouseDbs, mappedDatabases);
    };

    LeftPanelController.prototype.createSchemaViewerController = function() {
      this.schemaViewerController = new App.SchemaBrowser({
        editHelper: this.editHelper,
        clickableColumn: this.item.constructor !== App.CsvView
      });
      this.bubbles(this.schemaViewerController, 'column-name-clicked db-changed left-panel-toggled');
      return this.schemaViewerController;
    };

    LeftPanelController.prototype.isDragDropWidget = function() {
      return App.DragDropSeriesHelper.isDragDropWidget(this.item);
    };

    LeftPanelController.prototype.createLeftPanelRoot = function() {
      return this.leftPanel = new App.LeftPanelReactRoot();
    };

    LeftPanelController.prototype.createDataSourcePickerRoot = function() {
      return this.dataSourcePicker = new App.DataSourcePicker();
    };

    LeftPanelController.prototype.createDragDropRoot = function() {
      return this.dragDropDatasetView = new App.DatasetViewer();
    };

    LeftPanelController.prototype.toggleOpen = function() {
      this.el.toggleClass('open');
      this.el.addClass('moving');
      return setTimeout(((function(_this) {
        return function() {
          _this.el.removeClass('moving');
          return _this.trigger('left-panel-toggled');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    LeftPanelController.prototype.editorToggled = function(editorSelection) {
      this.trigger('editor-toggle', editorSelection);
      return this.el.toggleClass('drag-drop-editor', editorSelection === App.RedesignEditor.DRAG_DROP_EDITOR);
    };

    LeftPanelController.prototype.selectDataSource = function(id, type) {
      var dataset, ref, ref1;
      switch (type) {
        case 'dataset':
          if ((ref = App.User.currentUser()) != null) {
            ref.setLastUsedDatasetId(id);
          }
          if (!this.item.getTwiddle('twiddle_drag_drop_chart')) {
            this.item.sql = null;
            this.item.chart_type = 'cohort';
            this.item.setHashKey(null);
            this.item.setCodeHashKey(null);
            this.item.removeCodeConfig();
            this.item.setTwiddle('twiddle_drag_drop_chart', true);
          }
          dataset = App.Dataset.exists(id);
          if (dataset) {
            dataset.createRecentItem();
            if (dataset.databaseId()) {
              this.item.setDatabase(dataset.databaseId());
            }
          }
          this.editorToggled(App.RedesignEditor.DRAG_DROP_EDITOR);
          return this.editHelper.trigger('update');
        case 'database':
          if ((ref1 = App.User.currentUser()) != null) {
            ref1.setLastUsedDatasetId(null);
          }
          if (this.getCurrentDatabase().id !== id) {
            this.schemaViewerController.databaseChanged(id);
            this.editHelper.setDatabase(id);
          }
          if (AppRedesign.dragDropEnabled() && this.item instanceof App.Widget) {
            if (this.item.getTwiddle('twiddle_drag_drop_chart')) {
              this.item.chart_type = 'table';
              this.editHelper.trigger('drag-drop-changed-chart-type', this.item.chart_type);
              this.editHelper.updateSql(null);
              this.item.setHashKey(null);
              this.item.setTwiddle('twiddle_drag_drop_chart', false);
            }
            this.item.setDragDropConfig(null);
            delete this.item.twiddles['dragDrop'];
          }
          this.editorToggled(App.RedesignEditor.SQL_EDITOR);
          return this.editHelper.trigger('update');
      }
    };

    LeftPanelController.prototype.sortedDatabases = function() {
      var databases, warehouseDbs;
      databases = App.Database.all();
      warehouseDbs = _.remove(databases, function(database) {
        return database.warehouseSchemaEnabled();
      });
      return _.concat(warehouseDbs, databases);
    };

    LeftPanelController.prototype.getCurrentDatabase = function() {
      return this.editHelper.databaseOrDefault();
    };

    return LeftPanelController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LeftPanelReactRoot = (function(superClass) {
    var DISCOVERY_MODE, SQL_MODE;

    extend(LeftPanelReactRoot, superClass);

    LeftPanelReactRoot.prototype.className = 'left-panel-react-root';

    SQL_MODE = 'sql';

    DISCOVERY_MODE = 'discovery';

    function LeftPanelReactRoot() {
      LeftPanelReactRoot.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    LeftPanelReactRoot.prototype.initialize = function() {
      return this.reactRoot = window.reactApp.leftPanelRoot(this.el[0], DISCOVERY_MODE);
    };

    LeftPanelReactRoot.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return LeftPanelReactRoot.__super__.release.apply(this, arguments);
    };

    return LeftPanelReactRoot;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.MoveToController = (function(superClass) {
    extend(MoveToController, superClass);

    MoveToController.prototype.elements = {
      'select.dashboard-list': 'dashboardListSelect',
      '.button-row': 'buttonRow',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    MoveToController.prototype.events = {
      'click .cancel-icon': 'cancel'
    };

    function MoveToController() {
      this.cancel = bind(this.cancel, this);
      this.save = bind(this.save, this);
      this.appendDashboardList = bind(this.appendDashboardList, this);
      this.renderDashboardList = bind(this.renderDashboardList, this);
      MoveToController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget');
      App.Dashboard.one('remaining-state-loaded', this.renderDashboardList);
      this.render();
    }

    MoveToController.prototype.render = function() {
      this.html(this.view('redesign/editors/move_to')());
      this.renderDashboardList();
      this.dashboardListSelect.chosen({
        width: '100%',
        disable_search: false
      });
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.save,
        saveText: 'SAVE'
      });
      return this.rightAlignedButtons.append(this.cancelSaveBlock.el);
    };

    MoveToController.prototype.renderDashboardList = function() {
      var d, i, len, list, ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return jQuery.get("/dashboards/chart_as_copy_dashboard_list", {
          client_site_id: App.Site.first().id
        }).then((function(_this) {
          return function(response) {
            return _this.appendDashboardList(response.dashboards);
          };
        })(this));
      } else {
        list = [];
        ref = App.Dashboard.allSortedByName();
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          if (d.canMoveTo() && d.id) {
            list.push({
              name: d.getName(),
              value: d.id
            });
          }
        }
        return this.appendDashboardList(list);
      }
    };

    MoveToController.prototype.appendDashboardList = function(dashboardList) {
      var ref;
      this.dashboardListSelect.html(App.Utils.optionsToHtml(dashboardList, (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0));
      return this.dashboardListSelect.trigger("chosen:updated");
    };

    MoveToController.prototype.save = function() {
      var dashboardId, moveFn, targetDashboard;
      dashboardId = Number(this.dashboardListSelect.val());
      targetDashboard = App.Dashboard.find(dashboardId);
      moveFn = (function(_this) {
        return function() {
          var differentDashboard;
          differentDashboard = _this.widget.dashboard_id !== dashboardId;
          _this.widget.dashboard_id = dashboardId;
          if (differentDashboard) {
            _this.widget.setRow(targetDashboard.nextFreeRow());
            _this.widget.setColumn(0);
          }
          _this.trigger('save');
          if (differentDashboard) {
            targetDashboard.trigger('refresh');
            App.RouteHelper.navigateTo('Dashboard', targetDashboard);
          }
          targetDashboard.trigger('scroll-to-widget', _this.widget.id);
          return _this.release();
        };
      })(this);
      if (!targetDashboard.isCompletelyLoaded()) {
        return targetDashboard.trigger('load-dashboard', moveFn);
      } else {
        return moveFn();
      }
    };

    MoveToController.prototype.cancel = function() {
      return this.release();
    };

    MoveToController.prototype.release = function() {
      this.trigger('close-dialog');
      return setTimeout(((function(_this) {
        return function() {
          return MoveToController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return MoveToController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DashboardPermissionSelector = (function(superClass) {
    extend(DashboardPermissionSelector, superClass);

    DashboardPermissionSelector.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function DashboardPermissionSelector(roles, users) {
      this.roles = roles;
      this.users = users;
      DashboardPermissionSelector.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    DashboardPermissionSelector.prototype.initialize = function() {
      var display_name, first_name, info_hash, last_name, objectOwner, owner_id, user;
      this.html("<div class=\"react-root\"></div>");
      owner_id = App.Dashboard.currentDashboard().user_id;
      if (!App.User.exists(owner_id)) {
        objectOwner = {
          value: null,
          label: 'Select'
        };
      } else {
        user = App.User.find(owner_id);
        first_name = user['first_name'];
        last_name = user['last_name'];
        if (first_name === null) {
          first_name = '';
        }
        if (last_name === null) {
          last_name = '';
        }
        display_name = (first_name + ' ' + last_name).trim();
        if (display_name === '') {
          display_name = user['email_address'];
        }
        objectOwner = {
          value: user.id,
          key: user.id,
          label: display_name
        };
      }
      info_hash = {
        users: this.users,
        objectId: App.Dashboard.currentDashboard().id,
        objectOwner: objectOwner,
        roles: this.roles
      };
      return this.createReactComponent(info_hash);
    };

    DashboardPermissionSelector.prototype.createReactComponent = function(info_hash) {
      return this.reactRoot = window.reactApp.dashboardPermissionsSelectorRoot(this.reactRootEl[0], info_hash);
    };

    DashboardPermissionSelector.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return DashboardPermissionSelector.__super__.release.apply(this, arguments);
    };

    return DashboardPermissionSelector;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PermissionsDashboardSelectorController = (function(superClass) {
    extend(PermissionsDashboardSelectorController, superClass);

    PermissionsDashboardSelectorController.prototype.elements = {
      '.spinner-container': 'spinnerContainer'
    };

    function PermissionsDashboardSelectorController() {
      this.loadedRolesAndUsers = bind(this.loadedRolesAndUsers, this);
      PermissionsDashboardSelectorController.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/spinner')());
      this.loadRolesAndUsers();
    }

    PermissionsDashboardSelectorController.prototype.loadRolesAndUsers = function() {
      var rolesQuery, site_id, usersQuery;
      site_id = App.Site.first().id;
      rolesQuery = jQuery.get('/roles', {
        client_site_id: App.Site.first().id,
        object_id: App.Dashboard.currentDashboard().id,
        object_type: 'Dashboard'
      });
      usersQuery = jQuery.get("/api/" + site_id + "/users/rbac_search", {
        client_site_id: App.Site.first().id,
        sort_by: 'first_name',
        sort_order: 'ASC',
        object_type: 'Dashboard',
        query: '',
        permissions: 'create_dashboards'
      });
      return rolesQuery.done((function(_this) {
        return function(roles) {
          return usersQuery.done(function(users) {
            return _this.loadedRolesAndUsers(roles, users);
          });
        };
      })(this));
    };

    PermissionsDashboardSelectorController.prototype.loadedRolesAndUsers = function(roles, users) {
      if (this.released) {
        return;
      }
      this.permissionsPage = new App.DashboardPermissionSelector(roles.roles, users.users);
      this.append(this.permissionsPage.el);
      return this.removeSpinner();
    };

    PermissionsDashboardSelectorController.prototype.removeSpinner = function() {
      return this.spinnerContainer.remove();
    };

    PermissionsDashboardSelectorController.prototype.release = function() {
      var ref;
      this.released = true;
      if ((ref = this.permissionsPage) != null) {
        ref.release();
      }
      return this.removeSpinner();
    };

    return PermissionsDashboardSelectorController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignEditor = (function(superClass) {
    extend(RedesignEditor, superClass);

    RedesignEditor.prototype.className = 'editor-panel flex-fill-column';

    RedesignEditor.prototype.elements = {
      '.editor-body': 'body'
    };

    RedesignEditor.SQL_EDITOR = 'SQL_EDITOR';

    RedesignEditor.DRAG_DROP_EDITOR = 'DRAG_DROP_EDITOR';

    RedesignEditor.prototype.window = function() {
      return window;
    };

    function RedesignEditor() {
      this.editorToggled = bind(this.editorToggled, this);
      this.triggerResize = bind(this.triggerResize, this);
      this.hotkeySave = bind(this.hotkeySave, this);
      this.refresh = bind(this.refresh, this);
      this.permaDeleteArchiveClicked = bind(this.permaDeleteArchiveClicked, this);
      this.unarchiveClicked = bind(this.unarchiveClicked, this);
      this.deleteClicked = bind(this.deleteClicked, this);
      this.getNumDiscoveryChartAndDisplayModal = bind(this.getNumDiscoveryChartAndDisplayModal, this);
      this.saveItem = bind(this.saveItem, this);
      this.saveClicked = bind(this.saveClicked, this);
      this.copyToClicked = bind(this.copyToClicked, this);
      this.setCancelDestructive = bind(this.setCancelDestructive, this);
      this.unsetCancelDestructive = bind(this.unsetCancelDestructive, this);
      this.sqlChanged = bind(this.sqlChanged, this);
      this.setSaveable = bind(this.setSaveable, this);
      this.dbChanged = bind(this.dbChanged, this);
      this.release = bind(this.release, this);
      this.cancel = bind(this.cancel, this);
      this.close = bind(this.close, this);
      RedesignEditor.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/editor'));
      if (typeof window !== "undefined" && window !== null) {
        this.window().edit_w = this.item;
      }
      AppRedesign.current().setCurrentState(AppRedesign.IN_EDITRON);
      App.Site.trigger('close-toast');
      if (App.DragDropSeriesHelper.isDragDropWidget(this.item) || !AppRedesign.createSqlChartsEnabled()) {
        this.activeEditor = this.constructor.DRAG_DROP_EDITOR;
      } else {
        this.activeEditor = this.constructor.SQL_EDITOR;
      }
      this.renderChildControllers();
      this.rightPanelController.bind('refresh', this.refresh);
      AppRedesign.current().startScreenTransitionAnimation();
      if (AppRedesign.autoArchiveEnabled() && (this.item instanceof App.SqlView || this.item instanceof App.CsvView) && (this.item.archived_at != null)) {
        this.body.addClass('archived-grayout');
      }
    }

    RedesignEditor.prototype.close = function(options) {
      if (options == null) {
        options = {};
      }
      this.release();
      if (!(options.nextNavItem instanceof App.Widget)) {
        return App.RouteHelper.navigateToPrev();
      }
    };

    RedesignEditor.prototype.cancel = function(options) {
      if (options == null) {
        options = {};
      }
      App.Utils.logFeature('editor-cancel');
      return this.close(options);
    };

    RedesignEditor.prototype.release = function() {
      var ref;
      this.headerController.release();
      this.leftPanelController.release();
      this.rightPanelController.release();
      this.centerController.release();
      this.rightPanelController.unbind('refresh', this.refresh);
      if ((ref = this.helper) != null) {
        ref.release();
      }
      if ($('#body').hasClass('linked-widget-mode')) {
        AppRedesign.current().setCurrentState(AppRedesign.IN_SINGLE_WIDGET);
      } else {
        AppRedesign.current().setCurrentState(AppRedesign.IN_DASH);
      }
      AppRedesign.current().startScreenTransitionAnimation();
      this.trigger('close');
      App.Utils.logFeature('editor-exit');
      AppRedesign.current().featureLogContext().clear();
      return RedesignEditor.__super__.release.apply(this, arguments);
    };

    RedesignEditor.prototype.renderChildControllers = function() {
      this.prepend(this.createHeaderController().el);
      this.body.append(this.createLeftPanelController().el);
      this.body.append(this.createCenterController().el);
      return this.body.append(this.createRightPanelController().el);
    };

    RedesignEditor.prototype.isWarehouseBeta = function() {
      return _.some(App.Database.all(), function(database) {
        return database.warehouse;
      });
    };

    RedesignEditor.prototype.createLeftPanelController = function() {
      return this.leftPanelController = new App.LeftPanelController({
        item: this.item,
        editHelper: this.editHelper()
      }).bind('column-name-clicked', ((function(_this) {
        return function(colName) {
          return _this.centerController.schemaColumnClicked(colName);
        };
      })(this))).bind('db-changed', this.dbChanged).one('db-changed', this.setCancelDestructive).bind('left-panel-toggled', this.triggerResize).bind('editor-toggle', this.editorToggled);
    };

    RedesignEditor.prototype.dbChanged = function() {
      this.centerController.dbChanged();
      if (this.item instanceof App.SqlView) {
        return this.rightPanelController.refresh();
      }
    };

    RedesignEditor.prototype.createHeaderController = function() {
      var titlePlaceholder;
      if (this.item instanceof App.Widget) {
        titlePlaceholder = "Enter chart title";
      }
      this.headerController = new App.StarredItemHeaderController({
        item: this.item,
        titlePlaceholder: titlePlaceholder,
        externalShowDeleteFn: this.editHelper().shouldShowDatasetDeletionModal() ? this.getNumDiscoveryChartAndDisplayModal : void 0
      });
      return this.headerController.bind('cancel', this.cancel).bind('delete', this.deleteClicked).bind('save', this.saveClicked).bind('copy-to', this.copyToClicked).bind('unarchive', this.unarchiveClicked).bind('perma-delete-archive', this.permaDeleteArchiveClicked);
    };

    RedesignEditor.prototype.editHelper = function() {
      if (this.helper) {
        return this.helper;
      }
      this.helper = new App.EditHelper(this.item).bind('close', this.close).bind('show-header-error', (function(_this) {
        return function(msg) {
          return _this.headerController.showError(msg);
        };
      })(this)).bind('clear-header-error', (function(_this) {
        return function() {
          return _this.headerController.clearError();
        };
      })(this)).bind('window-resized', this.triggerResize).bind('refresh-history', this.hotkeySave);
      if (this.item.constructor === App.CsvView) {
        this.helper.csvController = this.createCenterController();
      }
      return this.helper;
    };

    RedesignEditor.prototype.createCenterController = function(replaceController) {
      if (this.centerController && !replaceController) {
        return this.centerController;
      }
      if (this.item.constructor === App.CsvView) {
        this.centerController = new App.CsvEditorCenterPanel({
          editHelper: this.editHelper(),
          csvView: this.item
        }).one('csv-uploaded', this.setCancelDestructive);
      } else {
        if (AppRedesign.dragDropEnabled() && this.activeEditor === this.constructor.DRAG_DROP_EDITOR) {
          this.centerController = new App.DragDropEditorPanel({
            editHelper: this.editHelper()
          }).bind('sql-changed', this.sqlChanged);
        } else {
          this.centerController = new App.DeepEditorCenterPanel({
            editHelper: this.editHelper()
          }).bind('sql-changed', this.sqlChanged);
        }
        this.headerController.bind('header-title-changed', ((function(_this) {
          return function(newTitle) {
            return _this.centerController.maybeUpdateHighlightedParams(newTitle);
          };
        })(this)));
      }
      return this.centerController;
    };

    RedesignEditor.prototype.setSaveable = function(saveable) {
      return this.headerController.setSaveable(saveable);
    };

    RedesignEditor.prototype.sqlChanged = function(newSql, initialValue) {
      var emptySql;
      emptySql = _.isEmpty(_.trim(newSql));
      this.setSaveable(!emptySql);
      if (emptySql) {
        return this.unsetCancelDestructive();
      } else if (initialValue) {
        this.headerController.setCancelDestructive(false, true);
        return this.editHelper().setSqlModified(false);
      } else {
        return this.setCancelDestructive();
      }
    };

    RedesignEditor.prototype.unsetCancelDestructive = function() {
      if (!this.headerController.isDestructive()) {
        return;
      }
      return this.headerController.setCancelDestructive(false);
    };

    RedesignEditor.prototype.setCancelDestructive = function() {
      this.editHelper().setSqlModified(true);
      if (this.headerController.isDestructive()) {
        return;
      }
      return this.headerController.setCancelDestructive(true);
    };

    RedesignEditor.prototype.createRightPanelController = function() {
      this.item.one('settings-updated', this.setCancelDestructive);
      return this.rightPanelController = new App.RightPanelController({
        item: this.item,
        editHelper: this.editHelper()
      }).bind('right-panel-opened right-panel-closed', this.triggerResize).one('right-panel-settings-changed', this.setCancelDestructive);
    };

    RedesignEditor.prototype.copyToClicked = function(duplicatedItem, makeDashboardCurrent) {
      var dashboard;
      duplicatedItem.save();
      setTimeout(((function(_this) {
        return function() {
          return duplicatedItem.trigger('flash');
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      dashboard = App.Dashboard.find(duplicatedItem.dashboard_id);
      if (makeDashboardCurrent) {
        App.RouteHelper.navigateTo('Dashboard', dashboard);
      }
      if (dashboard != null) {
        dashboard.trigger('scroll-to-widget', duplicatedItem.id);
      }
      return this.close();
    };

    RedesignEditor.prototype.saveClicked = function(shouldClose) {
      var base, base1;
      if (typeof (base = this.centerController).sqlChanged === "function") {
        base.sqlChanged();
      }
      if (typeof (base1 = this.centerController).limitChanged === "function") {
        base1.limitChanged();
      }
      if (this.editHelper().shouldShowDatasetUnpublishModal()) {
        return this.editHelper().getNumDiscoveryChartAndDisplayModal('Unpublish Dataset', this.saveItem, this.saveItem);
      } else {
        return this.saveItem(shouldClose);
      }
    };

    RedesignEditor.prototype.saveItem = function(shouldClose) {
      this.editHelper().saveItem(shouldClose);
      return this.unsetCancelDestructive();
    };

    RedesignEditor.prototype.getCreateSuccessItem = function() {
      if (this.editHelper().hadSuccessfulCreate()) {
        return this.item;
      }
      return null;
    };

    RedesignEditor.prototype.getNumDiscoveryChartAndDisplayModal = function(noDiscoveryChartCallback) {
      var title;
      title = AppRedesign.autoArchiveEnabled() ? 'Archive Dataset' : 'Delete Dataset';
      return this.editHelper().getNumDiscoveryChartAndDisplayModal(title, this.deleteClicked, noDiscoveryChartCallback);
    };

    RedesignEditor.prototype.deleteClicked = function() {
      this.editHelper().deleteItem();
      return this.close();
    };

    RedesignEditor.prototype.unarchiveClicked = function() {
      return this.editHelper().unarchiveItem();
    };

    RedesignEditor.prototype.permaDeleteArchiveClicked = function() {
      return this.editHelper().permaDeleteArchive();
    };

    RedesignEditor.prototype.refresh = function() {
      var ref;
      if (App.DragDropSeriesHelper.isDragDropWidget(this.item)) {
        this.editorToggled(this.constructor.DRAG_DROP_EDITOR);
      } else {
        this.editorToggled(this.constructor.SQL_EDITOR);
        if ((ref = this.editHelper()) != null) {
          ref.itemUpdated();
        }
      }
      this.headerController.refresh();
      this.leftPanelController.refresh(this.editHelper());
      this.centerController.refresh(this.editHelper());
      return this.rightPanelController.refresh();
    };

    RedesignEditor.prototype.hotkeySave = function() {
      return this.rightPanelController.historySaved();
    };

    RedesignEditor.prototype.triggerResize = function() {
      var base;
      return typeof (base = this.centerController).resizeChartArea === "function" ? base.resizeChartArea() : void 0;
    };

    RedesignEditor.prototype.editorToggled = function(editorSelection) {
      if (editorSelection === this.activeEditor) {
        return;
      }
      this.activeEditor = editorSelection;
      return this.centerController.el.replaceWith(this.createCenterController(true).el);
    };

    return RedesignEditor;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignPivotSettingsPosition = (function() {
    function RedesignPivotSettingsPosition(el, twiddles, widget, exitPivotCallback) {
      var ref, ref1, timeout, widgetContainer, widgetContainerOffset;
      this.el = el;
      this.twiddles = twiddles;
      this.widget = widget;
      this.exitPivotCallback = exitPivotCallback;
      this.exitPivotInDashboard = bind(this.exitPivotInDashboard, this);
      App.Utils.logFeature('open-pivot-table', {
        widget_id: (ref = this.widget) != null ? ref.id : void 0,
        dashboard_id: App.Dashboard.currentDashboard().id
      });
      widgetContainer = this.parentWidgetContainer();
      if (!App.RedesignDashboardSizer.inEditron(this.el)) {
        App.PageOverlay.show(((function(_this) {
          return function() {
            return _this.exitPivotInDashboard(widgetContainer);
          };
        })(this)));
      }
      timeout = 0;
      if (window.innerHeight - widgetContainer.offset().top < App.RedesignPivotSettings.PIVOT_SETTINGS_HEIGHT || widgetContainer.offset().top + widgetContainer.height() > window.innerHeight) {
        timeout = App.AppFrameRedesign.FAST_ANIMATION_TIME;
        if (App.RedesignDashboardSizer.inEditron(this.el)) {
          $('.editron-wrapper').animate({
            scrollTop: $('.editron-wrapper').scrollTop() + widgetContainer.offset().top
          }, timeout);
        } else {
          if ((ref1 = AppRedesign.current()) != null ? ref1.shared_mode : void 0) {
            widgetContainerOffset = 0;
          } else {
            widgetContainerOffset = App.RedesignTableChart.WIDGET_CONTAINER_OFFSET;
          }
          $('.content-offset-wrapper').animate({
            scrollTop: widgetContainer.position().top + widgetContainerOffset
          }, timeout);
        }
      }
      setTimeout(((function(_this) {
        return function() {
          _this.pivotSettings = new App.RedesignPivotSettings({
            columns: _this.twiddles.getArray('column_names'),
            widget: _this.widget,
            widgetContainer: widgetContainer,
            columnsToType: _this.buildColumnsToTypeMap()
          });
          if (App.RedesignDashboardSizer.inEditron(_this.el)) {
            $('.editor-panel').append(_this.pivotSettings.el);
          } else {
            $('.dashboards-container').append(_this.pivotSettings.el);
          }
          _this.positionPivotSettings();
          return _this.pivotSettings.bind('close-pivot-settings', _this.exitPivotInDashboard);
        };
      })(this)), timeout);
      widgetContainer.addClass('pivot-mode');
      if (!App.RedesignDashboardSizer.inEditron(this.el)) {
        widgetContainer.css('z-index', 150);
      }
    }

    RedesignPivotSettingsPosition.prototype.buildColumnsToTypeMap = function() {
      var column, columnsToType, i, len, ref, type;
      columnsToType = {};
      ref = this.twiddles.getArray('column_names');
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        type = this.twiddles.getForColumn(column, 'type');
        columnsToType[column] = type;
      }
      return columnsToType;
    };

    RedesignPivotSettingsPosition.prototype.parentWidgetContainer = function() {
      return this.el.closest('.widget-container');
    };

    RedesignPivotSettingsPosition.prototype.resize = function() {
      var widgetContainer;
      if (this.pivotSettings == null) {
        return;
      }
      this.positionPivotSettings();
      widgetContainer = this.parentWidgetContainer();
      if ((this.pivotSettings != null) && (widgetContainer.offset().top < App.PAGE_HEADER_HEIGHT || widgetContainer.offset().top + App.RedesignPivotSettings.PIVOT_SETTINGS_HEIGHT > window.innerHeight)) {
        return $('.content-offset-wrapper').scrollTop(widgetContainer.position().top + App.RedesignTableChart.WIDGET_CONTAINER_OFFSET);
      }
    };

    RedesignPivotSettingsPosition.prototype.positionPivotSettings = function() {
      var widgetContainer;
      widgetContainer = this.parentWidgetContainer();
      if (App.RedesignDashboardSizer.inEditron(this.el)) {
        this.pivotSettings.el.offset({
          top: widgetContainer.offset().top
        });
      } else {
        this.pivotSettings.el.css({
          'top': this.calculateTop(widgetContainer),
          'position': 'absolute'
        });
      }
      return this.pivotSettings.el.css('left', this.calculateLeft(widgetContainer));
    };

    RedesignPivotSettingsPosition.prototype.calculateLeft = function(widgetContainer) {
      var left, widgetLeft;
      widgetLeft = widgetContainer.offset().left;
      left = 0;
      if (widgetLeft - App.RedesignTableChart.WIDGET_CONTAINER_PADDING > App.RedesignPivotSettings.PIVOT_SETTINGS_WIDTH) {
        left = widgetLeft - App.RedesignPivotSettings.PIVOT_SETTINGS_WIDTH - App.RedesignTableChart.WIDGET_CONTAINER_PADDING;
      } else {
        left = widgetLeft + widgetContainer.width() + App.RedesignTableChart.WIDGET_CONTAINER_PADDING;
        if (left + App.RedesignPivotSettings.PIVOT_SETTINGS_WIDTH > window.innerWidth) {
          left = window.innerWidth - App.RedesignPivotSettings.PIVOT_SETTINGS_WIDTH - App.RedesignTableChart.WIDGET_CONTAINER_PADDING;
        }
      }
      return left;
    };

    RedesignPivotSettingsPosition.prototype.calculateTop = function(widgetContainer) {
      var widgetTop;
      if (AppRedesign.current().embed_mode && AppRedesign.isLinkedWidgetMode()) {
        return 0;
      }
      widgetTop = widgetContainer.offset().top;
      if (window.innerWidth - widgetContainer.width() < this.pivotSettings.el.width()) {
        widgetTop + App.RedesignTableChart.WIDGET_CONTAINER_PADDING;
      }
      return widgetTop - App.RedesignTableChart.WIDGET_CONTAINER_PADDING;
    };

    RedesignPivotSettingsPosition.prototype.exitPivotInDashboard = function() {
      var widgetContainer;
      App.PageOverlay.hide();
      widgetContainer = this.parentWidgetContainer();
      if (widgetContainer != null) {
        if (!App.RedesignDashboardSizer.inEditron(this.el)) {
          widgetContainer.css('z-index', '');
        }
        widgetContainer.addClass('no-tick-transition');
        widgetContainer.removeClass('pivot-mode');
        setTimeout(((function(_this) {
          return function() {
            return widgetContainer.removeClass('no-tick-transition');
          };
        })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      }
      if (this.pivotSettings == null) {
        return;
      }
      this.pivotSettings.save(true);
      this.pivotSettings.unbind('close-pivot-settings', this.exitPivotInDashboard);
      this.pivotSettings.release();
      this.pivotSettings = null;
      return this.exitPivotCallback();
    };

    return RedesignPivotSettingsPosition;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSmoothDropdown = (function(superClass) {
    extend(RedesignSmoothDropdown, superClass);

    RedesignSmoothDropdown.prototype.elements = {
      '.smooth-dropdown-label': 'labelEl',
      '.smooth-dropdown': 'smoothDropdown'
    };

    RedesignSmoothDropdown.prototype.events = {
      'click': 'openDropdown',
      'keypress': 'optionsListSearch'
    };

    RedesignSmoothDropdown.SINGLE_SELECT = 'single-select';

    RedesignSmoothDropdown.MULTI_SELECT = 'multi-select';

    function RedesignSmoothDropdown() {
      this.optionsListSearch = bind(this.optionsListSearch, this);
      this.openDropdown = bind(this.openDropdown, this);
      this.scrollHandler = bind(this.scrollHandler, this);
      this.optionClicked = bind(this.optionClicked, this);
      this.updateText = bind(this.updateText, this);
      var i, len, option, ref, ref1;
      RedesignSmoothDropdown.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'optionsFunc', 'optionsMode');
      if (this.property == null) {
        this.property = null;
      }
      if (this.defaultValue == null) {
        this.defaultValue = null;
      }
      if (this.currentValueFunc == null) {
        this.currentValueFunc = null;
      }
      if (this.optionClickedCallback == null) {
        this.optionClickedCallback = null;
      }
      if ((ref = this.widget) != null) {
        ref.bind('update', this.updateText);
      }
      this.updateText();
      this.names = [];
      ref1 = this.getOptions();
      for (i = 0, len = ref1.length; i < len; i++) {
        option = ref1[i];
        this.names.push(option.name);
      }
    }

    RedesignSmoothDropdown.prototype.release = function() {
      var ref;
      if ((ref = this.widget) != null) {
        ref.unbind('update', this.updateText);
      }
      return RedesignSmoothDropdown.__super__.release.apply(this, arguments);
    };

    RedesignSmoothDropdown.prototype.currentValue = function() {
      if (this.property != null) {
        if (this.optionsMode === RedesignSmoothDropdown.SINGLE_SELECT) {
          return this.widget.getTwiddle(this.property);
        } else {
          return this.parseArrayTwiddle(this.property);
        }
      } else if (this.currentValueFunc != null) {
        return this.currentValueFunc(this);
      } else {
        return null;
      }
    };

    RedesignSmoothDropdown.prototype.parseArrayTwiddle = function(name) {
      var twiddleCols, twiddleVal;
      twiddleVal = this.widget.getTwiddle(name) || [];
      if (twiddleVal.constructor === String) {
        twiddleCols = twiddleVal.split(',');
      } else {
        twiddleCols = twiddleVal;
      }
      return twiddleCols;
    };

    RedesignSmoothDropdown.prototype.getOptions = function() {
      var currentVal;
      currentVal = this.currentValue();
      if (currentVal == null) {
        currentVal = null;
      }
      return RedesignSmoothDropdown.checkOptionsForValues(this.optionsFunc(), currentVal, this.defaultValue);
    };

    RedesignSmoothDropdown.prototype.updateText = function() {
      return this.setHtml(RedesignSmoothDropdown.getDisplayHtmlFromOptions(this.getOptions()));
    };

    RedesignSmoothDropdown.prototype.setText = function(text, placeholder) {
      if (placeholder == null) {
        placeholder = false;
      }
      return this.setHtml(App.Utils.sanitizeHtml(text), placeholder);
    };

    RedesignSmoothDropdown.prototype.setHtml = function(html, placeholder) {
      if (placeholder == null) {
        placeholder = false;
      }
      this.labelEl.html(html);
      if (placeholder) {
        return this.labelEl.addClass('placeholder');
      } else {
        return this.labelEl.removeClass('placeholder');
      }
    };

    RedesignSmoothDropdown.prototype.optionClicked = function(event, option) {
      var curVals, i, j, len, len1, opt, ref, ref1, subOpt;
      if (this.property != null) {
        if (this.optionsMode === RedesignSmoothDropdown.SINGLE_SELECT) {
          this.updateIfDifferent(this.property, option.serverValue);
        } else {
          if (option.exclusive) {
            this.updateIfDifferent(this.property, option.serverValue);
          } else {
            curVals = [];
            ref = this.getOptions();
            for (i = 0, len = ref.length; i < len; i++) {
              opt = ref[i];
              if (opt.checked && !opt.exclusive) {
                curVals.push(opt.serverValue);
              }
              if (opt.subItems) {
                ref1 = opt.subItems;
                for (j = 0, len1 = ref1.length; j < len1; j++) {
                  subOpt = ref1[j];
                  if (subOpt.checked && !subOpt.exclusive) {
                    curVals.push(opt.serverValue);
                  }
                }
              }
            }
            if (curVals.indexOf(option.serverValue) === -1) {
              curVals.push(option.serverValue);
            } else {
              curVals = curVals.without(option.serverValue);
            }
            this.updateIfDifferent(this.property, curVals);
          }
        }
      }
      if (this.optionClickedCallback != null) {
        this.optionClickedCallback(event, option, this);
      }
      this.updateText();
      this.trigger('update', option);
      return event != null ? typeof event.stopPropagation === "function" ? event.stopPropagation() : void 0 : void 0;
    };

    RedesignSmoothDropdown.prototype.scrollHandler = function(evt) {
      var m;
      m = $(evt.target).closest('.dropdownMenu');
      if (m.length === 0) {
        return;
      }
      if ((evt.originalEvent.deltaY > 0) && (m.height() + m.scrollTop() === m[0].scrollHeight)) {
        evt.preventDefault();
      }
      if ((evt.originalEvent.deltaY < 0) && (m.scrollTop() === 0)) {
        return evt.preventDefault();
      }
    };

    RedesignSmoothDropdown.prototype.openDropdown = function() {
      var p;
      if (this.el.closest('.setting').hasClass('disabled')) {
        return;
      }
      if (this.noReparent) {
        RedesignSmoothDropdown.showDropdownMenu(this.el, this.optionsFunc(), this.optionClickedCallback);
      } else {
        p = RedesignSmoothDropdown.reparentDropdown(this.el.closest('.body'), this.el, this.getOptions(), this.optionClicked, this.menuSortFunc, this.subMenuSortFunc);
        p.on('mousewheel', this.scrollHandler);
        this.dropdownMenuEl = p.find('.dropdownMenu').not('.subMenu').not('.subSubMenu');
      }
      return this.smoothDropdown.trigger('focus');
    };

    RedesignSmoothDropdown.prototype.updateIfDifferent = function(field, value) {
      if (this.widget.getTwiddle(field) !== value) {
        this.widget.setTwiddle(field, value);
        this.widget.trigger('changed-twiddle');
        return this.trigger('changed-twiddle', field, value);
      }
    };

    RedesignSmoothDropdown.checkOptionsForValues = function(options, propValue, defaultValue) {
      var i, j, k, l, len, len1, len2, len3, opt, possibleValues, ref, ref1, subChecked, subOpt, val, valuesToCheck;
      possibleValues = this.allOptionValues(options);
      valuesToCheck = [];
      if ((propValue != null ? propValue.push : void 0) != null) {
        ref = valuesToCheck.concat(propValue);
        for (i = 0, len = ref.length; i < len; i++) {
          val = ref[i];
          if (possibleValues.indexOf(val) !== -1) {
            valuesToCheck.push(val);
          }
        }
      } else if (propValue != null) {
        if (possibleValues.indexOf(propValue) !== -1) {
          valuesToCheck.push(propValue);
        }
      }
      if (valuesToCheck.isEmpty()) {
        valuesToCheck.push(defaultValue);
      }
      for (j = 0, len1 = options.length; j < len1; j++) {
        opt = options[j];
        subChecked = false;
        if (opt.subItems) {
          ref1 = opt.subItems;
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            subOpt = ref1[k];
            if (subOpt.serverValue === val) {
              subOpt.checked = true;
              subChecked = true;
            }
          }
        }
        for (l = 0, len3 = valuesToCheck.length; l < len3; l++) {
          val = valuesToCheck[l];
          if (opt.serverValue === val || subChecked) {
            opt.checked = true;
          }
        }
      }
      return options;
    };

    RedesignSmoothDropdown.allOptionValues = function(options) {
      var i, j, len, len1, opt, ref, subOpt, values;
      values = [];
      for (i = 0, len = options.length; i < len; i++) {
        opt = options[i];
        values.push(opt.serverValue);
        if (opt.subItems) {
          ref = opt.subItems;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            subOpt = ref[j];
            values.push(subOpt.serverValue);
          }
        }
      }
      return values;
    };

    RedesignSmoothDropdown.getDisplayHtmlFromOptions = function(options) {
      var cOpts, i, j, len, len1, opt, optsString, ref, subNameString, subNames, subOpt;
      cOpts = [];
      subNames = [];
      for (i = 0, len = options.length; i < len; i++) {
        opt = options[i];
        if (opt.checked && ((opt.subItems == null) || opt.subItems.isEmpty())) {
          cOpts.push(opt.name);
          if (opt.subName != null) {
            subNames.push(opt.subName);
          }
        }
        if (opt.subItems) {
          ref = opt.subItems;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            subOpt = ref[j];
            if (subOpt.checked) {
              cOpts.push(subOpt.name);
              if (subOpt.subName != null) {
                subNames.push(subOpt.subName);
              }
            }
          }
        }
      }
      subNameString = subNames.length ? App.Utils.sanitizeHtml(subNames.unique().join(', ')) : "";
      optsString = App.Utils.sanitizeHtml(cOpts.unique().join(', '));
      if (subNameString !== "") {
        subNameString = "<div class='sub-name'>" + subNameString + "</div>";
      }
      return "" + optsString + subNameString;
    };

    RedesignSmoothDropdown.makeFrame = function() {
      return $('<div class="smooth-dropdown" tabindex="1"><div class="smooth-dropdown-label"></div></div>');
    };

    RedesignSmoothDropdown.appendFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.append(f);
      return f;
    };

    RedesignSmoothDropdown.prependFrame = function(parentEl) {
      var f;
      f = this.makeFrame();
      parentEl.prepend(f);
      return f;
    };

    RedesignSmoothDropdown.reparentDropdown = function(parentEl, dropdown, options, callback, menuSortFunc, subMenuSortFunc) {
      var dropdownOffset, editorOffset, label, placeholder, relativeOffset, scrollHandler, settingsEl;
      placeholder = $(document.createElement('div'));
      label = dropdown.find('.smooth-dropdown-label').text();
      placeholder.html('<div class="smooth-dropdown-label"></div>');
      placeholder.find('.smooth-dropdown-label').text(label);
      placeholder.addClass('scroll-hover-placeholder smooth-dropdown settings-dropdown').width(dropdown.outerWidth());
      dropdownOffset = dropdown.offset();
      editorOffset = parentEl.closest('.editor-panel').offset();
      relativeOffset = {
        top: dropdownOffset.top - editorOffset.top,
        left: dropdownOffset.left - editorOffset.left
      };
      placeholder.offset(relativeOffset).css('position', 'absolute');
      parentEl.closest('.editor-panel').append(placeholder);
      settingsEl = parentEl;
      scrollHandler = function(evt) {
        placeholder.dropdownMenu('destroy');
        placeholder.remove();
        return settingsEl.off('scroll', scrollHandler);
      };
      parentEl.on('scroll', scrollHandler);
      placeholder.dropdownMenu({
        items: options,
        callbackFunct: callback,
        width: dropdown.outerWidth(),
        destroyCallbackFunct: (function() {
          placeholder.remove();
          return settingsEl.off('scroll', scrollHandler);
        }),
        menuSortFunc: menuSortFunc,
        subMenuSortFunc: subMenuSortFunc
      });
      return placeholder;
    };

    RedesignSmoothDropdown.showDropdownMenu = function(el, items, callback) {
      return el.dropdownMenu({
        items: items,
        callbackFunct: callback
      });
    };

    RedesignSmoothDropdown.prototype.optionsListSearch = function(event) {
      var keyvalue;
      if (this.dropdownMenuEl == null) {
        return;
      }
      keyvalue = event.which;
      if (keyvalue === AppRedesign.KEYS.ENTER) {
        this.dropdownMenuEl.find('.active').trigger('click');
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      if (keyvalue >= AppRedesign.KEYS.a && keyvalue <= AppRedesign.KEYS.z) {
        keyvalue -= 32;
      }
      if (this.optionsListSearchString == null) {
        this.optionsListSearchString = "";
      }
      this.optionsListSearchString += String.fromCharCode(keyvalue);
      this.optionsListFirstSubstringMatchAndHighlight();
      if (this.dropdownSearchTimeout) {
        clearTimeout(this.dropdownSearchTimeout);
      }
      return this.dropdownSearchTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.optionsListSearchString = "";
        };
      })(this)), AppRedesign.TYPE_TIMEOUT);
    };

    RedesignSmoothDropdown.prototype.optionsListFirstSubstringMatchAndHighlight = function() {
      var i, len, name, ref;
      ref = this.names;
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        if (this.optionsListSearchString !== "" && name.toUpperCase().indexOf(this.optionsListSearchString) === 0) {
          this.searchedOption = this.dropdownMenuEl.find(".item:contains(" + name + ")");
          this.searchedOption.trigger('mouseover', true);
          return;
        }
      }
      if (this.optionsListSearchString.length > 1) {
        this.optionsListSearchString = this.optionsListSearchString.slice(-1);
        return this.optionsListFirstSubstringMatchAndHighlight();
      }
    };

    return RedesignSmoothDropdown;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RightPanelController = (function(superClass) {
    extend(RightPanelController, superClass);

    RightPanelController.prototype.className = 'editron-right-panel';

    RightPanelController.prototype.elements = {
      '.body': "body"
    };

    RightPanelController.prototype.events = {
      'click .icon': "iconClicked"
    };

    RightPanelController.MIN_SCREEN_WIDTH_FOR_RIGHTPANE = 1280;

    function RightPanelController() {
      this.iconClicked = bind(this.iconClicked, this);
      this.iconInfo = bind(this.iconInfo, this);
      var controller, defaultOpenTab, i, len, ref, screenTooNarrow, tab;
      RightPanelController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'editHelper');
      this.tabs = App.EditorRightPanelHelper.SETTING_TABS[this.item.constructor.className];
      ref = this.tabs;
      for (i = 0, len = ref.length; i < len; i++) {
        tab = ref[i];
        controller = new App[tab.controllerClass]({
          editHelper: this.editHelper,
          item: this.item,
          type: tab.type
        });
        this.bubbles(controller, 'refresh right-panel-settings-changed');
        tab.controller = controller;
      }
      this.html(this.view('redesign/editors/right_panel')({
        tabs: this.tabs
      }));
      this.iconTooltipHelper = new App.IconTooltipHelper({
        icon: this.el.find('.icons .icon'),
        infoCallback: this.iconInfo,
        direction: App.RedesignTooltipPanel.RIGHT,
        tooltipClass: 'rhe-tooltip',
        leftOffset: -1,
        topOffset: 20,
        activeClass: '',
        exitClass: 'selected'
      });
      defaultOpenTab = _.filter(this.tabs, ['openByDefault', true]);
      screenTooNarrow = AppRedesign.current().bodyWidth() < this.constructor.MIN_SCREEN_WIDTH_FOR_RIGHTPANE;
      if (_.isEmpty(defaultOpenTab) || screenTooNarrow) {
        return;
      }
      this.activeController = this.tabs[0].controller;
      this.setController();
      this.el.find('.icons .icon').first().addClass('selected');
    }

    RightPanelController.prototype.iconInfo = function(evt) {
      return $(evt.currentTarget).data('tooltip');
    };

    RightPanelController.prototype.release = function() {
      var i, len, ref, tab;
      ref = this.tabs;
      for (i = 0, len = ref.length; i < len; i++) {
        tab = ref[i];
        tab.controller.release();
      }
      this.iconTooltipHelper.release();
      return RightPanelController.__super__.release.apply(this, arguments);
    };

    RightPanelController.prototype.refresh = function() {
      var i, len, ref, results, tab;
      ref = this.tabs;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        tab = ref[i];
        results.push(tab.controller.refresh());
      }
      return results;
    };

    RightPanelController.prototype.historySaved = function() {
      var historyIcon, historyTabController;
      historyIcon = this.el.find('.history-icon');
      historyTabController = _.find(this.tabs, ['iconClass', 'history-icon']).controller;
      historyIcon.trigger('show-saved-tooltip');
      return historyTabController.refresh();
    };

    RightPanelController.prototype.iconClicked = function(e) {
      var targetIcon;
      this.iconTooltipHelper.iconMouseLeave();
      targetIcon = $(e.currentTarget);
      if (targetIcon.hasClass('selected')) {
        return this.closeRightPanel(targetIcon);
      } else if (!this.el.hasClass('closing')) {
        return this.openRightPanel(targetIcon);
      }
    };

    RightPanelController.prototype.setController = function() {
      this.body.append(this.activeController.el[0]);
      return this.el.addClass('open');
    };

    RightPanelController.prototype.openRightPanel = function(targetIcon) {
      var base, ref;
      this.el.find('.icons .icon.selected').removeClass('selected');
      targetIcon.addClass('selected');
      if ((ref = this.activeController) != null) {
        ref.el.detach();
      }
      this.activeController = _.find(this.tabs, ['iconClass', targetIcon.data('iconclass')]).controller;
      if (typeof (base = this.activeController).renderOpenSubsections === "function") {
        base.renderOpenSubsections();
      }
      this.setController();
      return setTimeout(((function(_this) {
        return function() {
          return _this.trigger('right-panel-opened');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RightPanelController.prototype.closeRightPanel = function(targetIcon) {
      targetIcon.removeClass('selected');
      targetIcon.addClass('closing');
      this.el.addClass('closing');
      setTimeout(((function(_this) {
        return function() {
          var ref;
          if ((ref = _this.activeController) != null) {
            ref.el.detach();
          }
          _this.activeController = null;
          targetIcon.removeClass('closing');
          _this.el.removeClass('closing');
          return _this.trigger('right-panel-closed');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      return this.el.toggleClass('open');
    };

    return RightPanelController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RoleBasedPermissionsPage = (function(superClass) {
    extend(RoleBasedPermissionsPage, superClass);

    RoleBasedPermissionsPage.prototype.className = 'drag-drop-chart-builder';

    RoleBasedPermissionsPage.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function RoleBasedPermissionsPage(info_hash) {
      this.info_hash = info_hash;
      RoleBasedPermissionsPage.__super__.constructor.apply(this, arguments);
      this.initialize();
    }

    RoleBasedPermissionsPage.prototype.initialize = function() {
      this.html("<div class=\"react-root\"></div>");
      return this.createReactComponent();
    };

    RoleBasedPermissionsPage.prototype.createReactComponent = function() {
      var ref, ref1, ref2, tz_abbreviation;
      tz_abbreviation = (ref = App.Site) != null ? (ref1 = ref.first()) != null ? ref1.display_timezone : void 0 : void 0;
      this.info_hash['userId'] = AppRedesign.current().currentUser.id;
      this.info_hash['siteId'] = AppRedesign.current().state.Site.id;
      this.info_hash['spacesEnabled'] = AppRedesign.current().state.Site.spaces_enabled;
      this.info_hash['ssoEnabled'] = (ref2 = App.Site.first()) != null ? ref2.sso_enabled : void 0;
      this.info_hash['autoArchiveEnabled'] = AppRedesign.autoArchiveEnabled();
      this.info_hash['scimProvisioningEnabled'] = AppRedesign.scimProvisioningEnabled();
      this.info_hash['defaultTimezoneAbbreviation'] = tz_abbreviation;
      this.info_hash['permissionsMap'] = AppRedesign.current().state.Permissions;
      return this.reactRoot = window.reactApp.permissionPageBuilderRoot(this.reactRootEl[0], this.info_hash);
    };

    RoleBasedPermissionsPage.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return RoleBasedPermissionsPage.__super__.release.apply(this, arguments);
    };

    return RoleBasedPermissionsPage;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SchemaBrowser = (function(superClass) {
    extend(SchemaBrowser, superClass);

    SchemaBrowser.prototype.className = 'schema-viewer browser';

    SchemaBrowser.prototype.elements = {
      '.database-selector': 'databasePickerContainer',
      '.database-picker': 'databasePicker',
      '.search-area input': 'searchInput',
      '.results-area': 'resultsArea',
      '.search-area': 'searchArea',
      '.toggle-area': 'toggleArea',
      '.sql-language-header': 'sqlLanguageHeader',
      '.sql-language-header-chevron': 'sqlLanguageHeaderChevron'
    };

    SchemaBrowser.prototype.events = {
      'change .database-picker': 'databasePickerChanged',
      'keyup .search-area input': 'searchKeypress',
      'click .sql-language-header': 'sqlLanguageHeaderClicked',
      'click .result': 'resultClicked',
      'click .cell-name': 'columnNameClicked',
      'click .result-header': 'resultHeaderClicked',
      'mouseenter .result .name': 'tableNameMouseEnter',
      'mouseleave .result .name': 'nameMouseLeave',
      'mouseenter .result .cell-name': 'columnNameMouseEnter',
      'mouseleave .result .cell-name': 'nameMouseLeave'
    };

    SchemaBrowser.SEARCH_KEYPRESS_DELAY_MS = 100;

    SchemaBrowser.WIDE_MODE_SCREEN_MIN_SIZE = 1600;

    SchemaBrowser.SCROLLBAR_WIDTH = 10;

    SchemaBrowser.PROHIBITED_MODELS_FOR_RESTRICTED_DB = [App.SqlView, App.SqlSnippet, App.SqlAlert];

    function SchemaBrowser() {
      this.shouldSearchFields = bind(this.shouldSearchFields, this);
      this.getCurrentDatabase = bind(this.getCurrentDatabase, this);
      this.columnNameMouseEnter = bind(this.columnNameMouseEnter, this);
      this.nameMouseLeave = bind(this.nameMouseLeave, this);
      this.tableNameMouseEnter = bind(this.tableNameMouseEnter, this);
      this.columnNameClicked = bind(this.columnNameClicked, this);
      this.resultHeaderClicked = bind(this.resultHeaderClicked, this);
      this.resultClicked = bind(this.resultClicked, this);
      this.sqlLanguageHeaderClicked = bind(this.sqlLanguageHeaderClicked, this);
      this.csvResultsMatchingSearch = bind(this.csvResultsMatchingSearch, this);
      this.viewsResultsMatchingSearch = bind(this.viewsResultsMatchingSearch, this);
      this.tableResultsMatchingSearch = bind(this.tableResultsMatchingSearch, this);
      this.snippetResultsMatchingSearch = bind(this.snippetResultsMatchingSearch, this);
      this.doSearch = bind(this.doSearch, this);
      this.searchToggleStateChanged = bind(this.searchToggleStateChanged, this);
      this.searchKeypress = bind(this.searchKeypress, this);
      this.render = bind(this.render, this);
      this.renderBind = bind(this.renderBind, this);
      this.updateIfRestricted = bind(this.updateIfRestricted, this);
      this.updateIfByow = bind(this.updateIfByow, this);
      this.updateIfWarehouse = bind(this.updateIfWarehouse, this);
      this.selectedDatabase = bind(this.selectedDatabase, this);
      SchemaBrowser.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
      App.Dashboard.bind('remaining-state-loaded schemas-loaded', this.renderBind);
      this.searchFns = {
        snippets: this.snippetResultsMatchingSearch,
        sqlView: this.viewsResultsMatchingSearch,
        csv: this.csvResultsMatchingSearch,
        data: this.tableResultsMatchingSearch
      };
      AppRedesign.current().uiQueue.add(this.renderBind, 'schema-viewer-construct');
    }

    SchemaBrowser.prototype.initDatabasePicker = function() {
      var db;
      db = this.getCurrentDatabase();
      if (this.selectableDatabases().length > 0) {
        this.databasePicker.val(db.id);
        this.editHelper.setDatabase(db.id);
        this.editHelper.itemUpdated();
        this.databasePicker.chosen({
          disable_search: false,
          width: '95%',
          height: '35px'
        });
      }
      this.updateIfWarehouse(db);
      this.updateIfByow(db);
      return this.updateIfRestricted(db);
    };

    SchemaBrowser.prototype.selectedDatabase = function() {
      return this.databasePickerContainer.find('a.chosen-single span');
    };

    SchemaBrowser.prototype.updateIfWarehouse = function(db) {
      this.warehouse = db.warehouseSchemaEnabled();
      this.selectedDatabase().toggleClass('warehouse', this.warehouse);
      return this.resultsArea.toggleClass('warehouse', this.warehouse);
    };

    SchemaBrowser.prototype.updateIfByow = function(db) {
      this.byowDatabaseSelected = db.isByowDatabase();
      this.selectedDatabase().toggleClass('byow', this.byowDatabaseSelected);
      return this.resultsArea.toggleClass('byow', this.byowDatabaseSelected);
    };

    SchemaBrowser.prototype.updateIfRestricted = function(db) {
      var ref;
      if (!((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0)) {
        return;
      }
      this.restricted = Boolean(db.is_restricted);
      this.selectedDatabase().toggleClass('restricted', this.restricted);
      return this.resultsArea.toggleClass('restricted', this.restricted);
    };

    SchemaBrowser.prototype.databasePickerChanged = function(event) {
      return this.databaseChanged(this.databasePicker.val());
    };

    SchemaBrowser.prototype.databaseChanged = function(id) {
      this.editHelper.setDatabase(id);
      this.editHelper.itemUpdated();
      this.updateIfWarehouse(this.getCurrentDatabase());
      this.updateIfByow(this.getCurrentDatabase());
      this.updateIfRestricted(this.getCurrentDatabase());
      this.isFirstBlock = true;
      if (this.rendered) {
        this.repopulateResults(this.nextSearchTerm);
      }
      this.trigger('db-changed');
      return window.reactApp.updateItemInfo(this.editHelper.getItemInfoForReact());
    };

    SchemaBrowser.prototype.refresh = function(helper) {
      this.editHelper = helper;
      return this.renderBind();
    };

    SchemaBrowser.prototype.release = function() {
      var ref;
      App.Dashboard.unbind('remaining-state-loaded schemas-loaded', this.renderBind);
      if ((ref = this.codeSchemaViewer) != null) {
        ref.release();
      }
      return SchemaBrowser.__super__.release.apply(this, arguments);
    };

    SchemaBrowser.prototype.unrender = function() {
      this.html('');
      this.rendered = false;
      delete this.currentUserId;
      return delete this.novelViewsExist;
    };

    SchemaBrowser.prototype.renderBind = function() {
      this.currentDatabase = this.getCurrentDatabase();
      this.isFirstBlock = true;
      this.openBlocks = [];
      return this.render();
    };

    SchemaBrowser.prototype.render = function() {
      this.html(this.view('redesign/editors/schema_viewer/schema_viewer')({
        hideDbDropdown: this.shouldHideDbDropdown(),
        sortedDatabases: this.sortedDatabases()
      }));
      this.maybeShowSqlLanguageHeader();
      this.initDatabasePicker();
      if (this.selectableDatabases().length === 1) {
        this.databasePickerContainer.hide();
      }
      this.repopulateResults();
      this.rendered = true;
      this.resultsArea.on('scroll', this.nameMouseLeave);
      this.searchToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: false,
        staticLeftLabel: 'Objects',
        staticRightLabel: 'Fields'
      });
      this.searchToggle.bind('toggled', this.searchToggleStateChanged);
      this.toggleArea.append(this.searchToggle.el);
      if (AppRedesign.current().codeSchemaViewerEnabled) {
        return this.renderCodeSchemaViewer();
      }
    };

    SchemaBrowser.prototype.renderCodeSchemaViewer = function() {
      this.codeSchemaViewer = new App.CodeSchemaViewer();
      return this.el.append(this.codeSchemaViewer.el);
    };

    SchemaBrowser.prototype.maybeShowSqlLanguageHeader = function() {
      if (!this.shouldShowSqlLanguageHeader()) {
        this.sqlLanguageHeader.hide();
        return;
      }
      this.sqlLanguageHeader.show();
      if (this.editHelper.hasCode()) {
        return this.collapseSqlSchema();
      } else {
        return this.expandSqlSchema();
      }
    };

    SchemaBrowser.prototype.sortedDatabases = function() {
      var currentDatabase, databases, warehouseDbs;
      databases = this.selectableDatabases();
      currentDatabase = this.getCurrentDatabase();
      if (this.onlyUnrestrictedDatabasesAreSelectable() && (currentDatabase != null ? currentDatabase.is_restricted : void 0)) {
        if (databases.length > 0) {
          this.databaseChanged(databases.first().id);
        }
      }
      warehouseDbs = _.remove(databases, function(database) {
        return database.warehouseSchemaEnabled();
      });
      return _.concat(warehouseDbs, databases);
    };

    SchemaBrowser.prototype.onlyUnrestrictedDatabasesAreSelectable = function() {
      var ref;
      return ((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0) && this.constructor.PROHIBITED_MODELS_FOR_RESTRICTED_DB.includes(this.editHelper.itemConstructor());
    };

    SchemaBrowser.prototype.selectableDatabases = function() {
      var allDatabases;
      allDatabases = App.Database.all();
      if (!this.onlyUnrestrictedDatabasesAreSelectable()) {
        return allDatabases;
      }
      return _.filter(allDatabases, function(database) {
        return !database.is_restricted;
      });
    };

    SchemaBrowser.prototype.repopulateResults = function(searchStr) {
      var htmlParts, results;
      if (searchStr == null) {
        searchStr = '';
      }
      this.isFirstBlock = true;
      App.Lagotron.addContext("SchemaViewer repopulateResults");
      results = this.resultsMatchingSearch(searchStr);
      htmlParts = [];
      this.renderResult(results, htmlParts, searchStr);
      return this.resultsArea.html(htmlParts.join(''));
    };

    SchemaBrowser.prototype.splitViewsIntoGroups = function(viewResults) {
      var currentUserId, groupHeader, i, j, k, len, len1, len2, map, ref, ref1, result, viewHeader;
      map = {};
      ref = this.getViewHeaders();
      for (i = 0, len = ref.length; i < len; i++) {
        viewHeader = ref[i];
        map[viewHeader] = [];
      }
      currentUserId = App.User.currentUserId();
      for (j = 0, len1 = viewResults.length; j < len1; j++) {
        result = viewResults[j];
        groupHeader = (function() {
          switch (false) {
            case !result.published_at:
              return 'Published';
            case result.user_id !== currentUserId:
              return 'Mine';
            default:
              return 'All';
          }
        })();
        map[groupHeader].push(result);
      }
      ref1 = this.getViewHeaders();
      for (k = 0, len2 = ref1.length; k < len2; k++) {
        viewHeader = ref1[k];
        if (map[viewHeader].length > 0) {
          this.setAsOpen(viewHeader);
          break;
        }
      }
      return map;
    };

    SchemaBrowser.prototype.splitTablesIntoSchemas = function(tableResults) {
      var group, i, len, map, result;
      map = {};
      for (i = 0, len = tableResults.length; i < len; i++) {
        result = tableResults[i];
        group = result.schema;
        map[group] || (map[group] = []);
        map[group].push(result);
      }
      return map;
    };

    SchemaBrowser.prototype.insertViewBlock = function(results, htmlParts, isSearch, group) {
      var fieldCount, i, j, len, len1, ref, result, resultType, results1, resultsHtml, shouldSearchFields, splitViews, viewHeader, views;
      splitViews = this.splitViewsIntoGroups(results);
      shouldSearchFields = this.shouldSearchFields();
      this.numViewResults = shouldSearchFields ? this.getFieldCountFromViewResults(results, isSearch, group) : results.length;
      ref = this.getViewHeaders();
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        viewHeader = ref[i];
        views = splitViews[viewHeader];
        resultsHtml = [];
        for (j = 0, len1 = views.length; j < len1; j++) {
          result = views[j];
          resultType = result.type || result.constructor.className;
          resultsHtml.push(this.renderView(result, group, isSearch, shouldSearchFields));
        }
        if (shouldSearchFields) {
          fieldCount = this.getFieldCountFromViewResults(views, isSearch, group);
        }
        results1.push(htmlParts.push(this.renderBlock(viewHeader, group, resultsHtml, isSearch, fieldCount)));
      }
      return results1;
    };

    SchemaBrowser.prototype.insertBlock = function(results, group, htmlParts, isSearch) {
      var dataSectionHtmlList, fieldCount, i, len, numberOfTables, result, resultsHtml;
      resultsHtml = [];
      switch (group) {
        case 'snippets':
          for (i = 0, len = results.length; i < len; i++) {
            result = results[i];
            resultsHtml.push(this.renderSqlSnippet(result, isSearch));
          }
          fieldCount = 0;
          return htmlParts.push(this.renderBlock('SQL Snippets', 'snippet', resultsHtml, isSearch, fieldCount));
        case 'sqlView':
        case 'csv':
          return this.insertViewBlock(results, htmlParts, isSearch, group);
        case 'data':
          dataSectionHtmlList = [];
          numberOfTables = 0;
          this.isFirstSchema = true;
          if (this.warehouse) {
            this.warehouseSchemaHelper = new App.WarehouseSchemaHelper(results);
            numberOfTables = this.warehouseSchemaHelper.tablesLength();
            dataSectionHtmlList = _.concat(dataSectionHtmlList, this.renderDatabases(isSearch));
            dataSectionHtmlList = _.concat(dataSectionHtmlList, this.renderSchemas(this.warehouseSchemaHelper.customerSchemas(), isSearch));
          } else {
            numberOfTables = results.length;
            dataSectionHtmlList = _.concat(dataSectionHtmlList, this.renderSchemas(results, isSearch));
          }
          return htmlParts.push(this.renderDataSection(isSearch, numberOfTables, dataSectionHtmlList));
        default:
          return AppRedesign.logError(new Error("Invalid result type: " + result.constructor.className));
      }
    };

    SchemaBrowser.prototype.renderDatabases = function(isSearch) {
      var database_html_pieces, dbName, i, isFirstDatabase, len, ref, schemaResultsHtml;
      isFirstDatabase = true;
      database_html_pieces = [];
      ref = this.warehouseSchemaHelper.databaseNames();
      for (i = 0, len = ref.length; i < len; i++) {
        dbName = ref[i];
        schemaResultsHtml = this.schemasHtml(this.warehouseSchemaHelper.schemasForDatabase(dbName), isSearch, this.shouldSearchFields(), 'schema');
        if (isFirstDatabase) {
          this.setAsOpen(dbName);
          isFirstDatabase = false;
        }
        database_html_pieces.push(this.renderDataBlock(dbName, schemaResultsHtml, isSearch, '', 'database'));
      }
      return database_html_pieces;
    };

    SchemaBrowser.prototype.renderSchemas = function(tables, isSearch) {
      var schemaResultsHtml, schemaToTables;
      schemaToTables = this.splitTablesIntoSchemas(tables);
      schemaResultsHtml = this.schemasHtml(schemaToTables, isSearch, this.shouldSearchFields(), 'schema');
      return schemaResultsHtml;
    };

    SchemaBrowser.prototype.renderDataSection = function(isSearch, numberOfTables, dataSectionHtmlList) {
      return this.renderDataBlock('Data', dataSectionHtmlList, isSearch, numberOfTables, 'data');
    };

    SchemaBrowser.prototype.schemasHtml = function(schemaToTables, isSearch, shouldSearchFields, className) {
      var fieldCount, i, len, result, schema, schemaHtml, tables, tablesHtml;
      schemaHtml = [];
      tablesHtml = [];
      for (schema in schemaToTables) {
        tables = schemaToTables[schema];
        for (i = 0, len = tables.length; i < len; i++) {
          result = tables[i];
          tablesHtml.push(this.renderTable(result, isSearch, shouldSearchFields));
        }
        if (shouldSearchFields) {
          fieldCount = this.getFieldCountFromTableResults(tables, isSearch);
        }
        if (this.isFirstSchema) {
          this.setAsOpen(schema);
          this.isFirstSchema = false;
        }
        schemaHtml.push(this.renderDataBlock(schema, tablesHtml, isSearch, fieldCount, className));
        tablesHtml = [];
      }
      return schemaHtml;
    };

    SchemaBrowser.prototype.renderResult = function(results, htmlParts, searchStr) {
      var group, isSearch, res;
      isSearch = searchStr !== '';
      this.openBlocks = [];
      for (group in results) {
        res = results[group];
        if (!(res.length > 0)) {
          continue;
        }
        if (this.isFirstBlock) {
          this.setAsOpen(group);
          this.isFirstBlock = false;
        }
        this.insertBlock(res, group, htmlParts, isSearch);
      }
      if (isSearch && _.isEmpty(htmlParts)) {
        return htmlParts.push(this.renderNoResults());
      }
    };

    SchemaBrowser.prototype.renderNoResults = function() {
      return this.view('redesign/editors/schema_viewer/schema_viewer_no_results')({});
    };

    SchemaBrowser.prototype.renderDataBlock = function(header, resultsHtml, isSearch, fieldCount, className) {
      return this.view('editors/schema_viewer/schema_browser_data_result_block')({
        className: className,
        headerName: header,
        results: resultsHtml,
        isOpen: this.isOpen(header, isSearch, resultsHtml),
        numResults: this.shouldSearchFields() || (className === 'data') ? fieldCount : resultsHtml.length
      });
    };

    SchemaBrowser.prototype.renderBlock = function(header, type, resultsHtml, isSearch, fieldCount) {
      return this.view('editors/schema_viewer/redesign_schema_viewer_result_block')({
        type: type,
        header: header,
        results: resultsHtml,
        isOpen: this.isOpen(header, isSearch, resultsHtml),
        isViewBlockOpen: (isSearch && this.numViewResults > 0) || this.inOpenBlocks(type),
        numViewResults: this.numViewResults,
        numResults: this.shouldSearchFields() ? fieldCount : resultsHtml.length,
        firstViewBlock: header === "Published",
        lastViewBlock: header === "All",
        viewHeader: type === "sqlView" ? "Views" : "CSVs"
      });
    };

    SchemaBrowser.prototype.setAsOpen = function(header) {
      return this.openBlocks.push(_.lowerCase(header));
    };

    SchemaBrowser.prototype.inOpenBlocks = function(header) {
      return this.openBlocks.includes(_.lowerCase(header));
    };

    SchemaBrowser.prototype.isOpen = function(str, isSearch, resultsHtml) {
      return (this.inOpenBlocks(str) && resultsHtml.length > 0) || (isSearch && resultsHtml.length > 0);
    };

    SchemaBrowser.prototype.renderSqlSnippet = function(snip, isSearch) {
      return this.view('editors/schema_viewer/schema_viewer_sql_snippet')({
        id: snip.id,
        name: snip.name,
        sql: snip.sql,
        shouldBoldName: isSearch
      });
    };

    SchemaBrowser.prototype.renderView = function(view, type, isSearch, shouldSearchFields) {
      return this.view('redesign/editors/schema_viewer/schema_viewer_view')({
        id: view.id,
        name: view.name,
        columns: type === 'csv' ? this.getRenderedColumnsForCsvView(view) : this.getRenderedColumnsForSqlView(view),
        clickableColumn: this.clickableColumn,
        type: type,
        shouldBoldName: isSearch,
        matchingCols: this.serializeColumnIndexesMatchingQuery(view),
        openMatchingCols: isSearch && shouldSearchFields
      });
    };

    SchemaBrowser.prototype.renderTable = function(table, isSearch, shouldSearchFields) {
      return this.view('redesign/editors/schema_viewer/schema_browser_table')({
        fullName: table.fullName,
        name: table.name,
        columns: table.columns || [],
        clickableColumn: this.clickableColumn,
        shouldBoldName: isSearch,
        matchingCols: this.serializeColumnIndexesMatchingQuery(table),
        openMatchingCols: isSearch && shouldSearchFields
      });
    };

    SchemaBrowser.prototype.descriptionForResult = function(resultEl) {
      var columnIndexesMatchingQuery, columns, isSearch, snip, tableInfo, tableName, view;
      isSearch = !_.isEmpty(_.trim(this.nextSearchTerm));
      columnIndexesMatchingQuery = isSearch ? this.deserializeColumnIndexes(resultEl.attr('matching_cols')) : [];
      if (resultEl.hasClass('table')) {
        tableName = resultEl.attr('table_name');
        tableInfo = this.getCurrentDatabase().getTableNamesWithColumnInfo(tableName).first();
        if (((tableInfo != null ? tableInfo.columns : void 0) != null) && tableInfo.columns.length > 0) {
          return this.renderColumns(tableInfo.columns, columnIndexesMatchingQuery);
        }
      } else if (resultEl.hasClass('snippet')) {
        snip = App.SqlSnippet.exists(parseInt(resultEl.attr('snippet_id')));
        if (snip && (snip.sql != null)) {
          return snip.sql.escapeHtml();
        }
      } else if (resultEl.closest('.result-block').hasClass('sqlView')) {
        view = App.SqlView.exists(parseInt(resultEl.attr('view_id')));
        if (view && (view.columns != null)) {
          columns = this.getRenderedColumnsForSqlView(view);
          return this.renderColumns(columns, columnIndexesMatchingQuery);
        }
      } else if (resultEl.closest('.result-block').hasClass('csv')) {
        view = App.CsvView.exists(parseInt(resultEl.attr('view_id')));
        if (view && (view.user_columns != null)) {
          columns = this.getRenderedColumnsForCsvView(view);
          return this.renderColumns(columns, columnIndexesMatchingQuery);
        }
      }
      return "Not available";
    };

    SchemaBrowser.prototype.getRenderedColumnsForSqlView = function(sqlView) {
      var c, i, len, ref, ref1, ref2, results1;
      if (!sqlView.columns || !sqlView.view_schema) {
        return [];
      }
      ref = sqlView.columns;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        results1.push({
          name: c,
          sql_type: (ref1 = sqlView.view_schema[c]) != null ? ref1.column_type : void 0,
          matches_query: (ref2 = sqlView.view_schema[c]) != null ? ref2.matches_query : void 0
        });
      }
      return results1;
    };

    SchemaBrowser.prototype.getRenderedColumnsForCsvView = function(csvView) {
      var c, i, len, ref, results1;
      if (!csvView.user_columns) {
        return [];
      }
      ref = csvView.user_columns;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        results1.push({
          name: c.name,
          sql_type: c.type,
          matches_query: c.matches_query
        });
      }
      return results1;
    };

    SchemaBrowser.prototype.renderColumns = function(columns, columnIndexesMatchingQuery) {
      return this.view('editors/schema_viewer/schema_browser_columns')({
        columns: columns,
        clickableColumn: this.clickableColumn,
        columnIndexesMatchingQuery: columnIndexesMatchingQuery
      });
    };

    SchemaBrowser.prototype.searchKeypress = function() {
      this.nextSearchTerm = this.searchInput.val().trim();
      if (!this.searchScheduled) {
        return this.scheduleSearch();
      }
    };

    SchemaBrowser.prototype.searchToggleStateChanged = function() {
      return this.repopulateResults(this.nextSearchTerm);
    };

    SchemaBrowser.prototype.scheduleSearch = function() {
      this.searchScheduled = true;
      return setTimeout(this.doSearch, App.SchemaBrowser.SEARCH_KEYPRESS_DELAY_MS);
    };

    SchemaBrowser.prototype.doSearch = function() {
      if (this.lastSearchTerm === this.nextSearchTerm) {
        return this.searchScheduled = false;
      } else {
        this.lastSearchTerm = this.nextSearchTerm;
        this.repopulateResults(this.nextSearchTerm);
        return this.scheduleSearch();
      }
    };

    SchemaBrowser.prototype.resultsMatchingSearch = function(searchStr) {
      var i, len, ref, results, s;
      if (searchStr == null) {
        searchStr = '';
      }
      results = {};
      ref = this.getGroups();
      for (i = 0, len = ref.length; i < len; i++) {
        s = ref[i];
        results[s] = this.searchFns[s](searchStr);
      }
      return results;
    };

    SchemaBrowser.prototype.snippetResultsMatchingSearch = function(searchStr) {
      if (this.shouldSearchFields()) {
        return [];
      }
      return App.SqlSnippet.allSortedByName(searchStr);
    };

    SchemaBrowser.prototype.tableResultsMatchingSearch = function(searchStr) {
      if (this.shouldSearchFields()) {
        return this.getCurrentDatabase().getAllTablesWithColumnNameMatchingQuery(searchStr);
      }
      return this.getCurrentDatabase().getAllTablesWithNameMatchingQuery(searchStr);
    };

    SchemaBrowser.prototype.viewsResultsMatchingSearch = function(searchStr) {
      if (this.shouldSearchFields()) {
        return App.SqlView.getAllViewsWithColumnNameMatchingQuery(searchStr);
      }
      return App.SqlView.allSortedByName(searchStr);
    };

    SchemaBrowser.prototype.csvResultsMatchingSearch = function(searchStr) {
      if (this.shouldSearchFields()) {
        return App.CsvView.getAllViewsWithColumnNameMatchingQuery(searchStr);
      }
      return App.CsvView.allSortedByName(searchStr);
    };

    SchemaBrowser.prototype.publishedOrOwnedViewsExist = function() {
      var currentUserId, i, len, ref, v;
      currentUserId = App.User.currentUserId();
      ref = [].concat(App.SqlView.all()).concat(App.CsvView.all());
      for (i = 0, len = ref.length; i < len; i++) {
        v = ref[i];
        if (v.user_id === currentUserId) {
          return true;
        }
        if (v.published_at) {
          return true;
        }
      }
      return false;
    };

    SchemaBrowser.prototype.isSqlSchemaExpanded = function() {
      return this.resultsArea.css('display') !== 'none' && this.sqlLanguageHeaderChevron.hasClass('expanded');
    };

    SchemaBrowser.prototype.isSqlSchemaCollapsed = function() {
      return this.resultsArea.css('display') === 'none' && this.sqlLanguageHeaderChevron.hasClass('collapsed');
    };

    SchemaBrowser.prototype.collapseSqlSchema = function() {
      var ref;
      if (!this.shouldShowSqlLanguageHeader()) {
        return false;
      }
      if (this.isSqlSchemaCollapsed()) {
        return false;
      }
      this.resultsArea.hide();
      this.sqlLanguageHeaderChevron.addClass('collapsed');
      this.sqlLanguageHeaderChevron.removeClass('expanded');
      if ((ref = window.reactApp) != null) {
        ref.collapseSqlSchema();
      }
      return true;
    };

    SchemaBrowser.prototype.expandSqlSchema = function() {
      var ref;
      if (!this.shouldShowSqlLanguageHeader()) {
        return false;
      }
      if (this.isSqlSchemaExpanded()) {
        return false;
      }
      this.resultsArea.show();
      this.sqlLanguageHeaderChevron.addClass('expanded');
      this.sqlLanguageHeaderChevron.removeClass('collapsed');
      if ((ref = window.reactApp) != null) {
        ref.expandSqlSchema();
      }
      return true;
    };

    SchemaBrowser.prototype.sqlLanguageHeaderClicked = function(event) {
      if (this.isSqlSchemaExpanded()) {
        return this.collapseSqlSchema();
      } else {
        return this.expandSqlSchema();
      }
    };

    SchemaBrowser.prototype.resultClicked = function(event) {
      var descriptionEl, isSearch, resultEl;
      if ($(event.target).closest('.cell, .description').length > 0) {
        return;
      }
      resultEl = $(event.target).closest('.result');
      resultEl.toggleClass('open');
      descriptionEl = resultEl.find('.description');
      isSearch = !_.isEmpty(this.lastSearchTerm);
      if (this.shouldSearchFields() && isSearch) {
        return descriptionEl.toggleClass('open-matching-cols');
      } else {
        return descriptionEl.html(this.descriptionForResult(resultEl));
      }
    };

    SchemaBrowser.prototype.resultHeaderClicked = function(event) {
      var header, headerName, index;
      header = $(event.currentTarget);
      if (header.hasClass('empty')) {
        return;
      }
      header.parent().toggleClass('open');
      headerName = header.parent().attr('attr_id');
      if (header.parent().hasClass('open')) {
        if (!this.inOpenBlocks(headerName)) {
          return this.setAsOpen(headerName);
        }
      } else {
        index = this.openBlocks.indexOf(_.lowerCase(headerName));
        return this.openBlocks.splice(index, 1);
      }
    };

    SchemaBrowser.prototype.columnNameClicked = function(event) {
      var columnName;
      columnName = $(event.currentTarget).text().trim();
      if ((columnName != null) && columnName.length > 0) {
        this.trigger('column-name-clicked', columnName);
        return App.Utils.logFeature('column-name-click');
      }
    };

    SchemaBrowser.prototype.tableNameMouseEnter = function(e) {
      var target;
      target = $(e.currentTarget);
      if (!this.isOverflown(target)) {
        return;
      }
      return this.fieldTooltip = App.RedesignTooltipPanel.addPanelForSchemaViewer(target, {
        width: '120px'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, 0.5, target.offset().left + $(e.target).width() / 2, target.offset().top);
    };

    SchemaBrowser.prototype.nameMouseLeave = function(e) {
      var ref;
      if ((ref = this.fieldTooltip) != null) {
        ref.release();
      }
      return this.fieldTooltip = null;
    };

    SchemaBrowser.prototype.columnNameMouseEnter = function(e) {
      var target;
      target = $(e.currentTarget);
      this.fieldTooltip = App.RedesignTooltipPanel.addPanelForSchemaViewer(target, {
        width: '50px',
        contentEl: target.siblings('.sql-type').data('sql-type')
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, 0.5, target.offset().left + $(e.target).width() / 2, target.offset().top + 5);
      return this.fieldTooltip.descriptionEl.addClass('bold');
    };

    SchemaBrowser.prototype.isOverflown = function(el) {
      var expectedWidth;
      if (el == null) {
        return false;
      }
      App.Utils.initRedesignCanvasWidthSizer(13);
      expectedWidth = App.Utils.fastApproxWidthForText(el.text());
      return el.width() - App.SchemaBrowser.SCROLLBAR_WIDTH < expectedWidth;
    };

    SchemaBrowser.prototype.shouldShowSqlLanguageHeader = function() {
      return AppRedesign.current().codeSchemaViewerEnabled;
    };

    SchemaBrowser.prototype.getOpenBlocks = function() {
      return this.openBlocks;
    };

    SchemaBrowser.prototype.getGroups = function() {
      if (this.editHelper.itemConstructor() === App.CsvView) {
        return ['csv'];
      }
      if (AppRedesign.current().restrictDatabasesEnabled && this.editHelper.isRestrictedDatabase()) {
        return ['data'];
      }
      return ['data', 'sqlView', 'csv', 'snippets'];
    };

    SchemaBrowser.prototype.getViewHeaders = function() {
      return ["Published", "Mine", "All"];
    };

    SchemaBrowser.prototype.shouldHideDbDropdown = function() {
      return this.editHelper.itemConstructor() === App.CsvView || AppRedesign.dragDropEnabled() && this.editHelper.itemConstructor() === App.Widget;
    };

    SchemaBrowser.prototype.getCurrentDatabase = function() {
      return this.editHelper.databaseOrDefault();
    };

    SchemaBrowser.prototype.shouldSearchFields = function() {
      if (this.searchToggle == null) {
        return false;
      }
      return this.searchToggle.getToggleState();
    };

    SchemaBrowser.prototype.serializeColumnIndexesMatchingQuery = function(result) {
      var c, column, columnsArray, index;
      if (result.type === 'Table' && Array.isArray(result.columns)) {
        columnsArray = result.columns;
      } else if (result instanceof App.CsvView && Array.isArray(result.user_columns)) {
        columnsArray = result.user_columns;
      } else if (result instanceof App.SqlView && Array.isArray(result.columns) && (result.view_schema != null)) {
        columnsArray = (function() {
          var i, len, ref, ref1, ref2, ref3, ref4, results1;
          ref = result.columns;
          results1 = [];
          for (i = 0, len = ref.length; i < len; i++) {
            c = ref[i];
            results1.push({
              name: c,
              sql_type: (ref1 = result.view_schema) != null ? (ref2 = ref1[c]) != null ? ref2.column_type : void 0 : void 0,
              matches_query: (ref3 = result.view_schema) != null ? (ref4 = ref3[c]) != null ? ref4.matches_query : void 0 : void 0
            });
          }
          return results1;
        })();
      }
      if (!((columnsArray != null ? columnsArray.length : void 0) > 0)) {
        return '';
      }
      return ((function() {
        var i, len, results1;
        results1 = [];
        for (index = i = 0, len = columnsArray.length; i < len; index = ++i) {
          column = columnsArray[index];
          if (column.matches_query) {
            results1.push(index);
          }
        }
        return results1;
      })()).join(',');
    };

    SchemaBrowser.prototype.getFieldCountFromTableResults = function(tableResults, isSearch) {
      var column, fieldCount, i, j, len, len1, ref, table;
      fieldCount = 0;
      for (i = 0, len = tableResults.length; i < len; i++) {
        table = tableResults[i];
        if (table.columns != null) {
          ref = table.columns;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            column = ref[j];
            if (!isSearch || column.matches_query) {
              fieldCount++;
            }
          }
        }
      }
      return fieldCount;
    };

    SchemaBrowser.prototype.getFieldCountFromViewResults = function(views, isSearch, group) {
      if (group === 'sqlView') {
        return this.getFieldCountFromSqlViewResults(views, isSearch);
      }
      if (group === 'csv') {
        return this.getFieldCountFromCsvViewResults(views, isSearch);
      }
    };

    SchemaBrowser.prototype.getFieldCountFromSqlViewResults = function(sqlViews, isSearch) {
      var column, columnName, fieldCount, i, len, ref, sqlView;
      fieldCount = 0;
      for (i = 0, len = sqlViews.length; i < len; i++) {
        sqlView = sqlViews[i];
        if (sqlView.view_schema != null) {
          ref = sqlView.view_schema;
          for (columnName in ref) {
            column = ref[columnName];
            if (!isSearch || column.matches_query) {
              fieldCount++;
            }
          }
        }
      }
      return fieldCount;
    };

    SchemaBrowser.prototype.getFieldCountFromCsvViewResults = function(csvViews, isSearch) {
      var column, csvView, fieldCount, i, j, len, len1, ref;
      fieldCount = 0;
      for (i = 0, len = csvViews.length; i < len; i++) {
        csvView = csvViews[i];
        if (csvView.user_columns != null) {
          ref = csvView.user_columns;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            column = ref[j];
            if (!isSearch || column.matches_query) {
              fieldCount++;
            }
          }
        }
      }
      return fieldCount;
    };

    SchemaBrowser.prototype.deserializeColumnIndexes = function(integerStringsSeparatedByCommas) {
      if (!integerStringsSeparatedByCommas) {
        return [];
      }
      return _.map(integerStringsSeparatedByCommas.split(','), function(integerString) {
        return Number(integerString);
      });
    };

    return SchemaBrowser;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SendWidgetToSlackController = (function(superClass) {
    extend(SendWidgetToSlackController, superClass);

    SendWidgetToSlackController.prototype.elements = {
      'input.channel-name': 'channelName',
      '.slack-message': 'messageText',
      '.button-row': 'buttonRow',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    SendWidgetToSlackController.prototype.events = {
      'click .cancel-icon': 'cancel',
      'input .channel-name': 'onChannelNameChanged'
    };

    function SendWidgetToSlackController() {
      this.release = bind(this.release, this);
      this.cancel = bind(this.cancel, this);
      this.save = bind(this.save, this);
      SendWidgetToSlackController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget');
      this.render();
      this.cancelSaveBlock.setSaveDisabled(true);
    }

    SendWidgetToSlackController.prototype.render = function() {
      this.html(this.view('redesign/editors/send_widget_to_slack')());
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.save,
        saveText: 'POST'
      });
      return this.rightAlignedButtons.append(this.cancelSaveBlock.el);
    };

    SendWidgetToSlackController.prototype.onChannelNameChanged = function() {
      if (this.channelName.val().length === 0) {
        return this.cancelSaveBlock.setSaveDisabled(true);
      } else {
        return this.cancelSaveBlock.setSaveDisabled(false);
      }
    };

    SendWidgetToSlackController.prototype.save = function() {
      this.cancelSaveBlock.disable();
      return Spine.Ajax.queue((function(_this) {
        return function() {
          var ref;
          return jQuery.post("/widgets/" + _this.widget.id + "/post_to_slack", {
            channel_name: _this.channelName.val(),
            message: _this.messageText.val().trim(),
            udv_id: (ref = App.UserDataView.current()) != null ? ref.id : void 0
          }).done(_this.release).fail(_this.release);
        };
      })(this));
    };

    SendWidgetToSlackController.prototype.cancel = function() {
      return this.release();
    };

    SendWidgetToSlackController.prototype.release = function() {
      this.trigger('close-dialog');
      return setTimeout(((function(_this) {
        return function() {
          return SendWidgetToSlackController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return SendWidgetToSlackController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SourceViewController = (function(superClass) {
    extend(SourceViewController, superClass);

    SourceViewController.prototype.className = 'source-view chart-tooltip-boundary right-boundary';

    SourceViewController.prototype.elements = {
      '.tab-list .tab': 'tabs',
      '.bottom-box': 'bottomBox',
      '.chart-icons': 'chartIcons',
      '.error-message': 'errorMessage'
    };

    SourceViewController.prototype.alertBlockEl = function() {
      return this.$('.alert-flex-wrapper');
    };

    SourceViewController.prototype.alertReferenceEl = function() {
      return this.$('.alert-reference');
    };

    SourceViewController.prototype.alertMessageEl = function() {
      return this.$('.alert-message');
    };

    SourceViewController.CHART_TAB = 'chart';

    SourceViewController.LOADING_OFFSET = 130;

    SourceViewController.ALERT_LOADING_OFFSET = 13;

    function SourceViewController() {
      this.updateChartSource = bind(this.updateChartSource, this);
      this.updateChartStateLoading = bind(this.updateChartStateLoading, this);
      this.handleQueryRunningState = bind(this.handleQueryRunningState, this);
      this.handleCodeRunningState = bind(this.handleCodeRunningState, this);
      this.showCaching = bind(this.showCaching, this);
      this.applySourceUpdate = bind(this.applySourceUpdate, this);
      this.itemUpdate = bind(this.itemUpdate, this);
      SourceViewController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
      this.html(this.view('redesign/editors/source_view')());
      this.editHelper.bind('update', this.itemUpdate);
      this.editHelper.bind('source-updated', this.applySourceUpdate);
      this.editHelper.bind('query-running', this.handleQueryRunningState);
      this.editHelper.bind('code-running', this.handleCodeRunningState);
      this.showTab(this.constructor.CHART_TAB);
    }

    SourceViewController.prototype.release = function() {
      var ref, ref1;
      this.editHelper.unbind('update', this.itemUpdate);
      this.editHelper.unbind('source-updated', this.applySourceUpdate);
      this.editHelper.unbind('query-running', this.handleQueryRunningState);
      this.editHelper.unbind('code-running', this.handleCodeRunningState);
      if ((ref = this.editorChartHelper) != null) {
        ref.release();
      }
      return (ref1 = this.tableChart) != null ? ref1.release() : void 0;
    };

    SourceViewController.prototype.itemUpdate = function() {
      return this.update();
    };

    SourceViewController.prototype.update = function() {
      this.bottomBox.children(':not(.error-message)').detach();
      this.bottomBox.attr('tabName', this.tabName);
      return this[this.tabName + "TabUpdated"]();
    };

    SourceViewController.prototype.applySourceUpdate = function(currentHashKey) {
      this.currentHashKey = currentHashKey;
      this.updateChartSource();
      return this.update();
    };

    SourceViewController.prototype.removeNonErrorMessageAndAppendEditorError = function() {
      this.bottomBox.children(':not(.error-message)').remove();
      return this.bottomBox.append(this.view('redesign/editors/editor_error')());
    };

    SourceViewController.prototype.showAlert = function(alertLevel, alertReference, alertMessage) {
      this.removeNonErrorMessageAndAppendEditorError();
      this.alertReferenceEl().text(alertReference);
      this.alertMessageEl().text(alertMessage);
      return this.alertBlockEl().addClass(alertLevel).show();
    };

    SourceViewController.prototype.showMessage = function(cssClass, msg) {
      this.bottomBox.children(':not(.error-message)').remove();
      return this.bottomBox.append(this.view('redesign/editors/message')({
        cssClass: cssClass,
        msg: msg
      }));
    };

    SourceViewController.prototype.showSpinnerMessage = function(msg) {
      this.alertBlockEl().remove();
      return this.bottomBox.append(this.view('redesign/editors/loading_message')({
        text: msg
      }));
    };

    SourceViewController.prototype.showLoading = function() {
      return this.showSpinnerMessage('Loading');
    };

    SourceViewController.prototype.showCaching = function() {
      return this.showSpinnerMessage('Caching');
    };

    SourceViewController.prototype.getLoaderOffset = function() {
      return this.constructor.LOADING_OFFSET;
    };

    SourceViewController.prototype.showTab = function(tabName) {
      this.tabName = tabName;
      return this.update();
    };

    SourceViewController.prototype.showDependencyError = function(msg) {
      return this.showAlert('error', 'Failed to parse dependency tree: ', msg);
    };

    SourceViewController.prototype.chartTabUpdated = function() {
      var firstRender;
      this.errorMessage.hide();
      firstRender = this.editorChartHelper == null;
      if (this.editorChartHelper == null) {
        this.editorChartHelper = new App.EditorChartHelper({
          editHelper: this.editHelper
        }).bind('size-updated', this.editHelper.enqueueWidgetResize).bind("chart-rendered", (function(_this) {
          return function() {
            if (_this.tabName !== _this.constructor.CHART_TAB) {
              return _this.update();
            }
          };
        })(this));
      }
      this.bottomBox.append(this.editorChartHelper.el);
      if (firstRender) {
        this.editorChartHelper.initialize();
      }
      return setTimeout(((function(_this) {
        return function() {
          _this.editorChartHelper.rerender(_this.sourceComplete);
          return delete _this.sourceComplete;
        };
      })(this)), 0);
    };

    SourceViewController.prototype.handleCodeRunningState = function() {
      return this.updateChartStateLoading();
    };

    SourceViewController.prototype.handleQueryRunningState = function() {
      if (this.editHelper.isWidget() && this.editHelper.hasCode()) {
        return;
      }
      return this.updateChartStateLoading();
    };

    SourceViewController.prototype.updateChartStateLoading = function() {
      var ref;
      return (ref = this.editorChartHelper) != null ? ref.showChartLoadingIndicator() : void 0;
    };

    SourceViewController.prototype.updateChartSource = function() {
      var ref;
      if ((ref = this.editorChartHelper) != null) {
        ref.render(true);
      }
      return this.sourceComplete = true;
    };

    SourceViewController.prototype.resizeChartArea = function() {
      return this.editorChartHelper.rerender();
    };

    return SourceViewController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlEditorCenterPanel = (function(superClass) {
    extend(SqlEditorCenterPanel, superClass);

    SqlEditorCenterPanel.prototype.className = 'sql-editor-center-panel';

    SqlEditorCenterPanel.prototype.elements = {
      '.sql-box': 'sqlBoxEl',
      '.run-box .button': 'runButton',
      '.run-box .button,.run-box .option': 'sqlSelectionLabels',
      '.run-box .cancel-query': 'cancelQueryLabel',
      '.run-box .expandable': 'expandableArea',
      '.run-box.flex-fill-row': 'flexFillRow',
      '.run-box .flex-filler': 'flexFiller',
      '.sql-result': 'sqlResultContainer',
      '.restricted-banner': 'restrictedBanner',
      '.preview-limit-icon': 'previewLimitIcon'
    };

    SqlEditorCenterPanel.prototype.events = {
      'click .run-box .button': 'runClicked',
      'keyup .sql-box': 'sqlChanged',
      'scroll': 'panelScrolled',
      'wheel': 'panelScrolled',
      'mousewheel': 'panelScrolled',
      'click .action .expand': 'toggleExpanded',
      'click .cancel-query.query-running': 'cancelQueryClicked',
      'click .download.option': 'downloadClicked',
      'click .sagemaker-export.option': 'sagemakerExportClicked',
      'mouseenter .preview-limit-icon': 'previewIconMouseEntered',
      'mouseleave .preview-limit-icon': 'previewIconMouseLeave'
    };

    SqlEditorCenterPanel.SQL_HELPER_TEXT = 'Type SQL';

    function SqlEditorCenterPanel() {
      this.previewIconMouseLeave = bind(this.previewIconMouseLeave, this);
      this.previewIconMouseEntered = bind(this.previewIconMouseEntered, this);
      this.maybeUpdateHighlightedParams = bind(this.maybeUpdateHighlightedParams, this);
      this.toggleRestrictedBanner = bind(this.toggleRestrictedBanner, this);
      this.dbChanged = bind(this.dbChanged, this);
      this.panelScrolled = bind(this.panelScrolled, this);
      this.schemaColumnClicked = bind(this.schemaColumnClicked, this);
      this.updateQueryErrors = bind(this.updateQueryErrors, this);
      this.sourceUpdated = bind(this.sourceUpdated, this);
      this.limitChanged = bind(this.limitChanged, this);
      this.sqlChanged = bind(this.sqlChanged, this);
      this.runPreviewAndFullSqlQueryInvisibly = bind(this.runPreviewAndFullSqlQueryInvisibly, this);
      this.shouldRunPreviewAndFullSqlQuery = bind(this.shouldRunPreviewAndFullSqlQuery, this);
      this.runClicked = bind(this.runClicked, this);
      this.sagemakerExportClicked = bind(this.sagemakerExportClicked, this);
      this.downloadClicked = bind(this.downloadClicked, this);
      this.recheckSqlForLimit = bind(this.recheckSqlForLimit, this);
      this.toggleQueryRunning = bind(this.toggleQueryRunning, this);
      this.setQueryDone = bind(this.setQueryDone, this);
      this.setQueryRunning = bind(this.setQueryRunning, this);
      this.setRunButtonText = bind(this.setRunButtonText, this);
      this.cancelQueryClicked = bind(this.cancelQueryClicked, this);
      var ref, ref1;
      SqlEditorCenterPanel.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
      this.html(this.view('redesign/editors/center_panel')({
        restrictDatabasesEnabled: (ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0,
        showRun: this.editHelper.shouldShowRunButton(),
        sagemakerEnabled: AppRedesign.sagemakerEnabled() && this.editHelper.isSqlView() && ((ref1 = AppRedesign.current().state) != null ? ref1.SqlViewDataExportEnabled : void 0)
      }));
      this.sqlBox = App.RedesignSqlBoxFactory.create('editor', {
        dbFunc: this.editHelper.database,
        initialValue: this.editHelper.sql(),
        placeholder: this.constructor.SQL_HELPER_TEXT,
        autofocus: !this.editHelper.isArchivedSqlView(),
        enabled: !this.editHelper.isArchivedSqlView()
      }).bind('sql-updated', this.runClicked).bind('selection-changed', this.setRunButtonText).bind('selected-or-deselected', this.recheckSqlForLimit).one('codemirror-loaded', this.updateQueryErrors);
      this.editHelper.bind('update sql-source-updated', this.sourceUpdated).bind('query-running', this.setQueryRunning).bind('sql-source-updated', this.setQueryDone);
      this.bubbles(this.sqlBox, 'sql-keydown sql-changed');
      this.sqlBoxEl.prepend(this.sqlBox.el);
      this.toggleRestrictedBanner();
      this.addLimitCheckbox();
      this.toggleQueryCancelButton();
      this.updateQueryErrors();
      if (!this.editHelper.isSqlSnippet()) {
        this.reactRoot = window.reactApp.sqlResultRoot(this.sqlResultContainer[0], this.editHelper.getItemInfoForReact(), this.editHelper.itemConstructor().className);
      }
    }

    SqlEditorCenterPanel.prototype.toggleExpanded = function() {
      return this.expandableArea.toggleClass('open');
    };

    SqlEditorCenterPanel.prototype.collapseDownload = function() {
      return this.expandableArea.removeClass('open');
    };

    SqlEditorCenterPanel.prototype.addLimitCheckbox = function() {
      var ref, ref1;
      if ((ref = this.sqlLimitCheckbox) != null) {
        ref.release();
      }
      if (((ref1 = this.editHelper.database()) != null ? ref1.database_type : void 0) !== 'oracle') {
        this.sqlLimitCheckbox = new App.SqlLimitCheckbox({
          item: this.editHelper.item,
          editHelper: this.editHelper
        });
        return this.flexFiller.after(this.sqlLimitCheckbox.el);
      }
    };

    SqlEditorCenterPanel.prototype.toggleQueryCancelButton = function() {
      return this.cancelQueryLabel.toggle(AppRedesign.allowQueryCancel(this.editHelper.database()));
    };

    SqlEditorCenterPanel.prototype.cancelQueryClicked = function() {
      if (!this.queryRunning) {
        return;
      }
      this.setQueryDone();
      this.editHelper.cancelRunningQuery();
      return this.collapseDownload();
    };

    SqlEditorCenterPanel.prototype.setRunButtonText = function(hasSelection) {
      return this.sqlSelectionLabels.toggleClass('with-selection', hasSelection);
    };

    SqlEditorCenterPanel.prototype.setQueryRunning = function() {
      return this.toggleQueryRunning(true);
    };

    SqlEditorCenterPanel.prototype.setQueryDone = function() {
      return this.toggleQueryRunning(false);
    };

    SqlEditorCenterPanel.prototype.toggleQueryRunning = function(isRunning) {
      this.queryRunning = isRunning;
      return this.cancelQueryLabel.toggleClass('query-running', isRunning);
    };

    SqlEditorCenterPanel.prototype.recheckSqlForLimit = function() {
      var ref;
      return (ref = this.sqlLimitCheckbox) != null ? ref.checkSqlForLimit(this.sqlBox.getSqlPreferSelected()) : void 0;
    };

    SqlEditorCenterPanel.prototype.refresh = function(helper) {
      var newSql;
      this.editHelper = helper;
      newSql = this.editHelper.sql();
      this.addLimitCheckbox();
      if (this.sqlBox.getSql() !== newSql) {
        this.sqlBox.setSql(newSql);
        this.trigger('sql-changed', newSql);
        return this.runClicked();
      } else if (this.editHelper.isWidget()) {
        return this.editHelper.item.trigger('settings-updated');
      }
    };

    SqlEditorCenterPanel.prototype.downloadClicked = function() {
      this.editHelper.runQueryForDownload(this.sqlBox.getSqlPreferSelected());
      return this.collapseDownload();
    };

    SqlEditorCenterPanel.prototype.sagemakerExportClicked = function() {
      var viewDataExport;
      this.collapseDownload();
      if (AppRedesign.magicLDemoModeEnabled()) {
        return window.open("https://console.aws.amazon.com/sagemaker/home");
      } else {
        if (_.isEmpty(this.sqlBox.getSql().trim())) {
          return;
        }
        viewDataExport = new App.SqlViewDataExport({
          client_site_id: App.Site.first().id,
          database_id: this.editHelper.database().id,
          export_started_at: (new Date).getTime(),
          sql_query: this.sqlBox.getSql(),
          view_name: this.editHelper.item.getName().trim().replace(/\s+/g, "_")
        });
        return viewDataExport.save();
      }
    };

    SqlEditorCenterPanel.prototype.runClicked = function(e) {
      var ref, ref1, runPreviewAndFullSql;
      if (!this.editHelper.hasRunnableQuery()) {
        return;
      }
      if ($(e != null ? e.target : void 0).hasClass('expando')) {
        return;
      }
      App.Utils.logFeature("editor-sql-run");
      runPreviewAndFullSql = this.shouldRunPreviewAndFullSqlQuery() && this.editHelper.hasCode();
      this.previewLimitIcon.toggleClass("hidden", true);
      this.editHelper.runQuery(this.sqlBox.getSqlPreferSelected(), (ref = this.sqlLimitCheckbox) != null ? ref.limit() : void 0, runPreviewAndFullSql);
      return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.queryRan() : void 0;
    };

    SqlEditorCenterPanel.prototype.shouldRunPreviewAndFullSqlQuery = function() {
      var ref;
      return AppRedesign.current().deepAnalysisEnabled && ((ref = this.sqlLimitCheckbox) != null ? ref.isEnabledAndChecked() : void 0);
    };

    SqlEditorCenterPanel.prototype.runPreviewAndFullSqlQueryInvisibly = function() {
      var limit, ref, sql;
      if (!this.shouldRunPreviewAndFullSqlQuery()) {
        return false;
      }
      sql = this.sqlBox.getSqlPreferSelected();
      limit = (ref = this.sqlLimitCheckbox) != null ? ref.limit() : void 0;
      this.editHelper.runPreviewAndFullSqlQueryInvisibly(sql, limit);
      return true;
    };

    SqlEditorCenterPanel.prototype.sqlChanged = function() {
      var ref;
      this.editHelper.updateSql(this.sqlBox.getSql());
      return (ref = this.sqlLimitCheckbox) != null ? ref.checkSqlForLimit(this.sqlBox.getSqlPreferSelected()) : void 0;
    };

    SqlEditorCenterPanel.prototype.limitChanged = function() {
      var ref;
      return this.editHelper.updateLimit((ref = this.sqlLimitCheckbox) != null ? ref.limit() : void 0);
    };

    SqlEditorCenterPanel.prototype.sourceUpdated = function() {
      var ref;
      this.updateQueryErrors();
      this.previewLimitReached = this.editHelper.hasRunResultReachedPreviewLimit();
      this.previewLimitIcon.toggleClass("hidden", !this.previewLimitReached);
      return (ref = this.sqlLimitCheckbox) != null ? ref.updatePreviewLimitState() : void 0;
    };

    SqlEditorCenterPanel.prototype.updateQueryErrors = function() {
      this.updateSqlErrors(this.editHelper.getSqlErrorInfo());
      return this.updateInfoAndWarnings(this.editHelper.getInfoAndWarnings());
    };

    SqlEditorCenterPanel.prototype.updateSqlErrors = function(sqlErrors) {
      if (sqlErrors != null) {
        return this.sqlBox.updateErrors(sqlErrors);
      } else {
        return this.sqlBox.updateErrors(null);
      }
    };

    SqlEditorCenterPanel.prototype.updateInfoAndWarnings = function(infoAndWarnings) {
      if (infoAndWarnings != null) {
        this.sqlBox.updateInfoAndWarnings(infoAndWarnings);
        return App.ReactActions.updateAlertsState(infoAndWarnings.warnings);
      } else {
        this.sqlBox.updateInfoAndWarnings(null);
        return App.ReactActions.updateAlertsState(null);
      }
    };

    SqlEditorCenterPanel.prototype.schemaColumnClicked = function(columnName) {
      return this.sqlBox.insertAtCursor(columnName);
    };

    SqlEditorCenterPanel.prototype.release = function() {
      var ref;
      this.sqlBox.release();
      if ((ref = this.reactRoot) != null) {
        if (typeof ref.close === "function") {
          ref.close();
        }
      }
      return SqlEditorCenterPanel.__super__.release.apply(this, arguments);
    };

    SqlEditorCenterPanel.prototype.panelScrolled = function() {
      return this.sqlBox.scrolled();
    };

    SqlEditorCenterPanel.prototype.dbChanged = function() {
      this.toggleRestrictedBanner();
      this.addLimitCheckbox();
      this.toggleQueryCancelButton();
      return this.runClicked();
    };

    SqlEditorCenterPanel.prototype.toggleRestrictedBanner = function() {
      var ref;
      if (!((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0)) {
        return;
      }
      if (this.editHelper.isRestrictedDatabase()) {
        return this.restrictedBanner.addClass('active');
      } else {
        return this.restrictedBanner.removeClass('active');
      }
    };

    SqlEditorCenterPanel.prototype.maybeUpdateHighlightedParams = function(newTitle) {
      if (newTitle === this.lastTitle) {
        return;
      }
      this.lastTitle = newTitle;
      if (App.SqlSnippet.shouldUpdateCurrentParams(newTitle)) {
        return this.sqlBox.setSql(this.sqlBox.getSql());
      }
    };

    SqlEditorCenterPanel.prototype.previewIconMouseEntered = function(e) {
      var ref;
      return (ref = this.sqlLimitCheckbox) != null ? ref.previewLimitTooltip.show(e) : void 0;
    };

    SqlEditorCenterPanel.prototype.previewIconMouseLeave = function() {
      var ref;
      return (ref = this.sqlLimitCheckbox) != null ? ref.previewLimitTooltip.hide() : void 0;
    };

    return SqlEditorCenterPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlLimitCheckbox = (function(superClass) {
    extend(SqlLimitCheckbox, superClass);

    SqlLimitCheckbox.prototype.className = 'sql-limit-checkbox';

    SqlLimitCheckbox.prototype.elements = {
      '.checkbox-area': 'checkboxArea',
      '.redesign-input': 'inputArea'
    };

    SqlLimitCheckbox.prototype.events = {
      'mouseenter .checkbox-area': 'mouseEntered',
      'mouseleave .checkbox-area': 'mouseLeft',
      'mouseenter .redesign-input': 'previewLimitMouseEntered',
      'mouseleave .redesign-input': 'previewLimitMouseLeft'
    };

    function SqlLimitCheckbox() {
      this.previewLimitMouseLeft = bind(this.previewLimitMouseLeft, this);
      this.previewLimitMouseEntered = bind(this.previewLimitMouseEntered, this);
      this.mouseLeft = bind(this.mouseLeft, this);
      this.mouseEntered = bind(this.mouseEntered, this);
      this.checkboxStateChanged = bind(this.checkboxStateChanged, this);
      var limit;
      SqlLimitCheckbox.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'editHelper');
      this.html(this.view('redesign/editors/sql_limit_checkbox'));
      this.checkboxChecked = !_.isNull(this.item.sql_limit);
      this.wasCheckedBefore = this.checkboxChecked;
      this.limitCheckbox = new App.RedesignCheckbox({
        labelText: 'Limit Preview',
        initialState: this.checkboxChecked,
        callback: this.checkboxStateChanged
      });
      this.checkboxArea.append(this.limitCheckbox.el);
      limit = this.item.isNew() ? App.QueryRunner.DEFAULT_SQL_LIMIT : this.item.sql_limit;
      this.inputArea.val(limit);
      this.checkSqlForLimit(this.item.sql);
      this.previewLimitTooltip = new App.PreviewLimitTooltipController({
        editHelper: this.editHelper
      });
    }

    SqlLimitCheckbox.prototype.limit = function() {
      if (!this.checkboxChecked) {
        return null;
      }
      return this.inputArea.val();
    };

    SqlLimitCheckbox.prototype.checkboxStateChanged = function(enabled) {
      this.checkboxChecked = enabled;
      return this.setInputEnabled(!this.limitWasInQuery && this.checkboxChecked);
    };

    SqlLimitCheckbox.prototype.checkSqlForLimit = function(sql) {
      var limitInQuery;
      limitInQuery = this.sqlContainsLimit(sql);
      if (this.limitWasInQuery === limitInQuery) {
        return;
      }
      this.limitWasInQuery = limitInQuery;
      if (limitInQuery) {
        return this.limitAddedToQuery();
      } else {
        return this.limitRemovedFromQuery();
      }
    };

    SqlLimitCheckbox.prototype.limitAddedToQuery = function() {
      this.setCheckboxEnabled(false);
      this.wasCheckedBefore = this.checkboxChecked;
      this.setCheckboxChecked(false);
      return this.setInputEnabled(this.checkboxChecked);
    };

    SqlLimitCheckbox.prototype.limitRemovedFromQuery = function() {
      this.setCheckboxEnabled(true);
      this.setCheckboxChecked(this.wasCheckedBefore);
      return this.setInputEnabled(this.checkboxChecked);
    };

    SqlLimitCheckbox.prototype.isEnabledAndChecked = function() {
      return this.limitCheckbox.state() && !this.limitCheckbox.isDisabled();
    };

    SqlLimitCheckbox.prototype.setCheckboxChecked = function(checked) {
      this.checkboxChecked = checked;
      return this.limitCheckbox.toggleSelected(checked);
    };

    SqlLimitCheckbox.prototype.setCheckboxEnabled = function(enabled) {
      return this.limitCheckbox.disable(!enabled);
    };

    SqlLimitCheckbox.prototype.setInputEnabled = function(enabled) {
      this.inputArea.prop('disabled', !enabled);
      return this.inputArea.toggleClass('disabled', !enabled);
    };

    SqlLimitCheckbox.prototype.sqlContainsLimit = function(sql) {
      var ref, ref1, regex;
      regex = (ref = (ref1 = this.item.database()) != null ? ref1.database_type : void 0) === 'bigquery' || ref === 'bigquery_standard' ? /\s+(limit\s+\d+|top\s*\(.*,\s*\d+.*\))/mi : /\s+(limit|top|sample)\s+\d+/mi;
      return (sql != null ? sql.match(new RegExp(regex)) : void 0) != null;
    };

    SqlLimitCheckbox.prototype.mouseEntered = function(e) {
      var ref, target, targetOffset;
      if (!this.limitWasInQuery) {
        return;
      }
      target = $(e.target);
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      targetOffset = target.offset();
      return this.hoverTooltip = App.RedesignTooltipPanel.addPanel({
        description: 'A limit has been applied in the SQL of this query',
        extraClass: 'light-theme',
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        side: App.RedesignTooltipPanel.TOP,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        width: "254px"
      }).pointAt(App.RedesignTooltipPanel.TOP, target, App.RedesignTooltipPanel.CENTER_POINTER, targetOffset.left + target.outerWidth() / 2, targetOffset.top);
    };

    SqlLimitCheckbox.prototype.mouseLeft = function() {
      var ref;
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      return this.hoverTooltip = null;
    };

    SqlLimitCheckbox.prototype.updatePreviewLimitState = function() {
      return this.inputArea.toggleClass('preview-limit-reached', this.editHelper.hasRunResultReachedPreviewLimit());
    };

    SqlLimitCheckbox.prototype.previewLimitMouseEntered = function(e) {
      return this.previewLimitTooltip.show(e);
    };

    SqlLimitCheckbox.prototype.previewLimitMouseLeft = function() {
      return this.previewLimitTooltip.hide();
    };

    return SqlLimitCheckbox;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.StarredItemHeaderController = (function(superClass) {
    extend(StarredItemHeaderController, superClass);

    StarredItemHeaderController.prototype.className = 'app-header editron-header starred-item';

    StarredItemHeaderController.prototype.elements = {
      '.button-area': 'buttonArea',
      '.star.header-icon': 'starIcon',
      '.badge.header-icon': 'badgeIcon',
      '.info.header-icon': 'infoIcon',
      '.add-to-topic.header-icon': 'addToTopicIcon',
      '.expandable .button.save': 'saveButton',
      '.header-description': 'headerDescription',
      '.button-block': 'deleteButtonBlock',
      '.text-icon-root': 'textIcon',
      '.refresh': 'refreshIcon'
    };

    StarredItemHeaderController.prototype.events = {
      'click .header-icon.star': 'starIconClicked',
      'click .add-to-topic': 'pinIconClicked',
      'click .refresh': 'refreshIconClicked'
    };

    function StarredItemHeaderController() {
      this.isDestructive = bind(this.isDestructive, this);
      this.clearError = bind(this.clearError, this);
      this.showError = bind(this.showError, this);
      this.viewInfo = bind(this.viewInfo, this);
      this.badgeInfo = bind(this.badgeInfo, this);
      this.renderRefreshIconState = bind(this.renderRefreshIconState, this);
      this.pinIconClicked = bind(this.pinIconClicked, this);
      this.starIconClicked = bind(this.starIconClicked, this);
      this.showMoveToModal = bind(this.showMoveToModal, this);
      this.showCopyToModal = bind(this.showCopyToModal, this);
      this.disableSaveFn = bind(this.disableSaveFn, this);
      this.isItemArchivable = bind(this.isItemArchivable, this);
      this.release = bind(this.release, this);
      this.toggleBadge = bind(this.toggleBadge, this);
      var fallbackIcon;
      StarredItemHeaderController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.isSqlView = this.item instanceof App.SqlView;
      this.isArchivedView = AppRedesign.autoArchiveEnabled() && (this.isSqlView || this.item instanceof App.CsvView) && (this.item.archived_at != null);
      this.showRefreshButton = this.isSqlView && App.Site.first().schedulable_views_enabled;
      this.html(this.view('redesign/editors/starred_item_header_controller')({
        item: this.item,
        info: this.shouldShowInfo(),
        spaceName: App.Site.first().spaceName(),
        titleDisabled: (this.item instanceof App.CsvView && this.item.exists()) || this.isArchivedView,
        isWidget: this.item instanceof App.Widget,
        titlePlaceholder: this.titlePlaceholder,
        isArchivedView: this.isArchivedView,
        showAddToTopicIcon: this.isDashboardOrganizationItem() && this.addToTopicEnabled() && !this.isArchivedView,
        dashboardOrganizationEnabled: AppRedesign.dashboardOrganizationEnabled(),
        showRefreshButton: this.showRefreshButton
      }));
      if (this.isDashboardOrganizationItem()) {
        this.badgeState = App.Badge.isBadged(this.item);
        this.item.bind('badge-toggled', this.toggleBadge);
        if (this.item instanceof App.CsvView || this.item instanceof App.SqlView) {
          fallbackIcon = 'sql-view-icon-large';
        }
        if (this.item instanceof App.SqlSnippet) {
          fallbackIcon = 'sql-snippet-icon-large';
        }
        if (this.item instanceof App.SqlAlert) {
          fallbackIcon = 'sql-alert-icon-large';
        }
        this.textIconRoot = window.reactApp.textIconRoot(this.textIcon[0], this.item.displayName(), this.item.icon_color, 48, fallbackIcon);
      }
      this.saveable = !this.isArchivedView;
      this.render();
      if (this.shouldShowInfo()) {
        App.ViewUtils.fetchWidgetViewCount(this.item);
      }
      this.item.bind('update', this.renderRefreshIconState);
    }

    StarredItemHeaderController.prototype.shouldShowInfo = function() {
      if (this.isArchivedView) {
        return false;
      }
      return _.includes([App.CsvView, App.SqlView], this.item.constructor);
    };

    StarredItemHeaderController.prototype.isDashboardOrganizationItem = function() {
      return !(this.item instanceof App.Widget) && AppRedesign.dashboardOrganizationEnabled();
    };

    StarredItemHeaderController.prototype.itemIsBadged = function() {
      return this.isDashboardOrganizationItem() && this.badgeState;
    };

    StarredItemHeaderController.prototype.toggleBadge = function(item, toggleState) {
      this.badgeState = toggleState;
      return this.render();
    };

    StarredItemHeaderController.prototype.release = function() {
      var ref, ref1, ref2, ref3, ref4;
      this.buttons.release();
      this.headerTitleController.release();
      if ((ref = this.badgeTooltipHelper) != null) {
        ref.release();
      }
      if ((ref1 = this.headerTooltipHelper) != null) {
        ref1.release();
      }
      if ((ref2 = this.addToTopicTooltipController) != null) {
        ref2.release();
      }
      if ((ref3 = this.refreshTooltipController) != null) {
        ref3.release();
      }
      if ((ref4 = this.textIconRoot) != null) {
        ref4.close();
      }
      this.item.unbind('update', this.renderRefreshIconState);
      return StarredItemHeaderController.__super__.release.apply(this, arguments);
    };

    StarredItemHeaderController.prototype.render = function() {
      this.headerTitleController = new App.HeaderTitleController({
        el: this.el,
        item: this.item,
        titlePlaceholder: this.titlePlaceholder
      });
      this.bubbles(this.headerTitleController, 'header-title-changed');
      if (this.itemIsBadged()) {
        this.badgeTooltipHelper = new App.IconTooltipHelper({
          icon: this.badgeIcon,
          infoCallback: this.badgeInfo
        });
      }
      if (this.shouldShowInfo()) {
        this.headerTooltipHelper = new App.IconTooltipHelper({
          icon: this.infoIcon,
          infoCallback: this.viewInfo,
          alwaysKeepInDashboard: true,
          tooltipClass: this.item.constructor.className.toLowerCase() + '-header'
        });
      }
      if (this.isDashboardOrganizationItem()) {
        this.badgeIcon.toggleClass('badge-hidden', !this.itemIsBadged());
        if (this.addToTopicTooltipController == null) {
          this.addToTopicTooltipController = new App.IconTooltipHelper({
            icon: this.addToTopicIcon,
            infoCallback: function(evt) {
              return $(evt.currentTarget).data('tooltip');
            }
          });
        }
      }
      if (this.showRefreshButton) {
        this.refreshTooltipController = new App.IconTooltipHelper({
          icon: this.refreshIcon,
          infoCallback: function() {
            return 'Re-materialize the last saved view';
          }
        });
      }
      this.setupButtons();
      this.renderStarButtonState();
      return this.renderRefreshIconState();
    };

    StarredItemHeaderController.prototype.refresh = function() {
      return this.headerTitleController.refresh();
    };

    StarredItemHeaderController.prototype.setupButtons = function() {
      var ref;
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      if (this.item instanceof App.Widget && this.item.isReadOnlyToCurrentUser()) {
        this.buttons = new App.ButtonBlock({
          action: "move to",
          buttonSize: 'large',
          deleteDisabled: true,
          isDestructive: this.isDestructive,
          actionDisabledFn: this.disableSaveFn
        }).bind("move-to", this.showMoveToModal);
      } else {
        if (this.item instanceof App.Widget) {
          this.buttons = new App.CopyToButtonBlock({
            item: this.item,
            actionDisabledFn: this.disableSaveFn,
            isDestructive: this.isDestructive
          }).bind('copy-to', this.showCopyToModal).bind('move-to', this.showMoveToModal).bind('save-as-copy', this.showMoveToModal);
        } else {
          if (this.isArchivedView) {
            this.buttons = new App.UnarchiveButtonBlock({
              itemName: this.item.constructor.SIMPLE_CLASS_NAME
            });
          } else {
            this.buttons = new App.ButtonBlock({
              itemName: this.item.constructor.SIMPLE_CLASS_NAME,
              action: 'save',
              buttonSize: 'large',
              deleteDisabled: this.item.isNew(),
              isDestructive: this.isDestructive,
              actionDisabledFn: this.disableSaveFn,
              externalShowDeleteFn: this.externalShowDeleteFn,
              deleteLabel: this.isItemArchivable() ? 'archive' : 'delete'
            });
          }
        }
      }
      this.buttons.bind('size-changed', this.headerTitleController.updateMaxTitleWidth);
      this.bubbles(this.buttons, 'delete save cancel unarchive perma-delete-archive');
      this.buttonArea.append(this.buttons.el);
      this.buttons.render();
      return this.item.bind('title-changed', (function(_this) {
        return function() {
          return _this.setCancelDestructive(true);
        };
      })(this));
    };

    StarredItemHeaderController.prototype.isItemArchivable = function() {
      if (!AppRedesign.autoArchiveEnabled()) {
        return false;
      }
      return this.item instanceof App.SqlView || this.item instanceof App.CsvView;
    };

    StarredItemHeaderController.prototype.disableSaveFn = function() {
      var base;
      if (!this.saveable) {
        return true;
      }
      if ((typeof (base = this.item).hasSql === "function" ? base.hasSql() : void 0) || this.editorSqlSet) {
        return false;
      }
      return this.item.isNew() && (this.isDestructive != null) && !this.isDestructive();
    };

    StarredItemHeaderController.prototype.setSaveable = function(saveable) {
      this.saveable = saveable;
      return this.buttons.render();
    };

    StarredItemHeaderController.prototype.showCopyToModal = function() {
      var copyToController;
      copyToController = new App.CopyToController({
        widget: this.item
      });
      this.bubbles(copyToController, 'copy-to');
      this.addCopyToDialog = App.RedesignDialog.createDialog({
        title: 'Copy To',
        viewController: copyToController,
        customDialogClass: 'copy-to'
      });
      return copyToController.bind('close-dialog', this.addCopyToDialog.close);
    };

    StarredItemHeaderController.prototype.showMoveToModal = function() {
      var moveToController, title;
      title = AppRedesign.canOnlyEditChartAsCopy() ? 'Save as Copy' : this.item.is_exploration ? 'Save To' : 'Move To';
      moveToController = new App.MoveToController({
        widget: this.item
      });
      this.bubbles(moveToController, 'save cancel');
      this.addMoveToDialog = App.RedesignDialog.createDialog({
        title: title,
        viewController: moveToController,
        customDialogClass: 'move-to'
      });
      return moveToController.bind('close-dialog', this.addMoveToDialog.close);
    };

    StarredItemHeaderController.prototype.renderStarButtonState = function() {
      var user;
      user = App.User.currentUser(this.item);
      if ((user != null) && user.isReal() && !user.isTemporary() && !this.isArchivedView) {
        return this.starIcon.toggleClass('starred', Boolean(App.StarredItem.getStarForCurrentUser(this.item)));
      } else {
        return this.starIcon.hide();
      }
    };

    StarredItemHeaderController.prototype.starIconClicked = function(e) {
      e.stopPropagation();
      this.starIcon.toggleClass('starred');
      this.item.pending_star_state = this.starIcon.hasClass('starred');
      return this.setCancelDestructive(true);
    };

    StarredItemHeaderController.prototype.pinIconClicked = function(e) {
      var dialogWidth, divRect, left, top;
      if (!AppRedesign.dashboardOrganizationEnabled()) {
        return;
      }
      divRect = e.target.getBoundingClientRect();
      top = divRect.bottom + 10;
      left = divRect.left - 182;
      dialogWidth = 386;
      if ((window.innerWidth - divRect.left) < 182) {
        left = window.innerWidth - dialogWidth;
      }
      return window.reactApp.dispatchPinToTopicModal(this.item.constructor.className, this.item.id, top, left);
    };

    StarredItemHeaderController.prototype.refreshIconClicked = function() {
      this.logFeatureOnRefresh();
      if (this.refreshIcon.hasClass('disabled')) {
        return;
      }
      this.disableRefreshIcon();
      return this.materializeManually();
    };

    StarredItemHeaderController.prototype.logFeatureOnRefresh = function() {
      var detail, schedule;
      schedule = this.item.cacheSchedules().first();
      detail = "custom: " + (schedule != null ? schedule.custom : void 0) + ", interval: " + (schedule != null ? schedule.interval : void 0);
      return App.Utils.logFeature('sql-view-manual-materialize', {
        detail: detail
      });
    };

    StarredItemHeaderController.prototype.disableRefreshIcon = function() {
      return this.refreshIcon.addClass('disabled');
    };

    StarredItemHeaderController.prototype.materializeManually = function() {
      var site_id, url;
      url = "/sql_views/" + this.item.id + "/cache_schedules/materialize_manually";
      site_id = App.Site.first().id;
      return $.post(url, {
        client_site_id: site_id
      });
    };

    StarredItemHeaderController.prototype.renderRefreshIconState = function() {
      var noSchedules, shouldDisable, state;
      if (!this.showRefreshButton) {
        return;
      }
      state = new App.SqlViewState(this.item);
      noSchedules = this.item.cacheSchedules().length === 0;
      shouldDisable = this.item.isNew() || state.isMaterializing() || noSchedules;
      return this.refreshIcon.toggleClass('disabled', shouldDisable);
    };

    StarredItemHeaderController.prototype.badgeInfo = function() {
      var badge, user;
      badge = App.Badge.getBadgeForModel(this.item);
      if (!badge) {
        return;
      }
      user = App.User.find(badge.created_by_user_id);
      return this.view('tooltip/badge')({
        userString: user != null ? user.abbreviatedDisplayName() : void 0,
        dateString: App.TimeMachine.formatTimestamp(badge.created_at, 'MMM D, YYYY')
      }).trim();
    };

    StarredItemHeaderController.prototype.viewInfo = function() {
      var metadata;
      metadata = App.ViewUtils.metadataWithCounts(this.item);
      if (App.Site.first().schedulable_views_enabled && this.isSqlView) {
        return this.view("header_menu_sql_views/sql_view_schedulable_tooltip_table")(metadata).trim();
      } else {
        return this.view("header_menu_sql_views/new_sql_view_tooltip_table")(metadata).trim();
      }
    };

    StarredItemHeaderController.prototype.showError = function(msg) {
      return this.headerTitleController.showError(msg);
    };

    StarredItemHeaderController.prototype.clearError = function() {
      return this.headerTitleController.clearError();
    };

    StarredItemHeaderController.prototype.setCancelDestructive = function(value, editorSqlSet) {
      this.cancelIsDestructive = value;
      this.editorSqlSet = editorSqlSet;
      return this.buttons.render();
    };

    StarredItemHeaderController.prototype.isDestructive = function() {
      return this.cancelIsDestructive;
    };

    StarredItemHeaderController.prototype.showWarningModal = function() {
      this.confirmController = new App.ConfirmController({
        itemClass: this.item.constructor
      });
      return this.bubbles(this.confirmController, 'save cancel');
    };

    StarredItemHeaderController.prototype.addToTopicEnabled = function() {
      var ref, tp;
      if (!AppRedesign.current().state.RbacEnabled) {
        return true;
      }
      tp = (ref = AppRedesign.current().state.RbacPermissionsHash) != null ? ref.topic_permissions : void 0;
      return Boolean(tp != null ? tp.add_objects_to_topics : void 0);
    };

    return StarredItemHeaderController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.WarehouseSchemaHelper = (function() {
    function WarehouseSchemaHelper(tables) {
      this.tables = tables;
      this.buildDatabaseMap();
    }

    WarehouseSchemaHelper.prototype.buildDatabaseMap = function() {
      var base, base1, db_display_name, db_id, i, len, ref, results, schema_name, split, table, warehouse_schema;
      this.periscopeManagedDatabases = {};
      this.customerManagedSchemas = [];
      ref = this.tables;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        table = ref[i];
        warehouse_schema = table.schema;
        if (warehouse_schema.toLowerCase() === 'periscope_views') {
          this.hasPeriscopeView = true;
          continue;
        }
        split = warehouse_schema.match(/db_([0-9]+)_(.*)/i);
        if (split != null) {
          db_id = split[1];
          schema_name = split[2];
          if (App.Database.exists(db_id)) {
            db_display_name = App.Database.find(db_id).database_name;
            (base = this.periscopeManagedDatabases)[db_display_name] || (base[db_display_name] = {});
            (base1 = this.periscopeManagedDatabases[db_display_name])[schema_name] || (base1[schema_name] = []);
            this.periscopeManagedDatabases[db_display_name][schema_name].push(table);
            continue;
          }
        }
        results.push(this.customerManagedSchemas.push(table));
      }
      return results;
    };

    WarehouseSchemaHelper.prototype.databaseNames = function() {
      return _.keys(this.periscopeManagedDatabases);
    };

    WarehouseSchemaHelper.prototype.schemasForDatabase = function(databaseName) {
      return this.periscopeManagedDatabases[databaseName];
    };

    WarehouseSchemaHelper.prototype.customerSchemas = function() {
      return this.customerManagedSchemas;
    };

    WarehouseSchemaHelper.prototype.tablesLength = function() {
      if (this.hasPeriscopeView) {
        return this.tables.length - 1;
      } else {
        return this.tables.length;
      }
    };

    return WarehouseSchemaHelper;

  })();

}).call(this);
(function() {
  App.SeriesHelper = (function() {
    function SeriesHelper(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    SeriesHelper.prototype.disableSegmentationIfAutoSelected = function(column) {
      if (this.segmentationIsAutoSelected(column)) {
        return this.widget.setTwiddle(App.TwiddleConfig.SEGMENT_COLUMN, App.Chartographer.DO_NOT_SEGMENT);
      }
    };

    SeriesHelper.prototype.segmentationIsAutoSelected = function(column) {
      var actualSegment, userSegment;
      userSegment = this.widget.getTwiddle(App.TwiddleConfig.SEGMENT_COLUMN);
      actualSegment = this.twiddlesActual.getArray('segment_column');
      if (!((actualSegment != null) && actualSegment.length > 0)) {
        return false;
      }
      return userSegment == null;
    };

    SeriesHelper.prototype.xyPointChart = function() {
      if (this.geojsonMapType()) {
        return false;
      }
      return ['bubble', 'geomap'].includes(this.widget.chart_type);
    };

    SeriesHelper.prototype.columnNames = function() {
      return this.twiddlesActual.redesignGetArray(App.TwiddleConfig.COLUMN_NAMES);
    };

    SeriesHelper.prototype.geojsonMapType = function() {
      return this.widget.chart_type === 'geomap' && this.widget.getTwiddle(App.TwiddleConfig.GEOMAP_DATA_MODE) === App.Geomap.DATA_MODE_GEOJSON;
    };

    return SeriesHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SettingsSubsection = (function(superClass) {
    extend(SettingsSubsection, superClass);

    function SettingsSubsection() {
      this.toggleExpandAll = bind(this.toggleExpandAll, this);
      this.fieldMouseLeave = bind(this.fieldMouseLeave, this);
      this.fieldMouseEnter = bind(this.fieldMouseEnter, this);
      this.geomapPlotModeForSeries = bind(this.geomapPlotModeForSeries, this);
      this.refresh = bind(this.refresh, this);
      this.getTwiddle = bind(this.getTwiddle, this);
      this.setNumberTwiddle = bind(this.setNumberTwiddle, this);
      this.setTwiddle = bind(this.setTwiddle, this);
      this.toggleCheckboxInArray = bind(this.toggleCheckboxInArray, this);
      SettingsSubsection.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.widget.bind('new-chart-data', this.refresh);
      this._checkboxes = [];
    }

    SettingsSubsection.prototype.release = function() {
      return this.widget.unbind('new-chart-data', this.refresh);
    };

    SettingsSubsection.prototype.createCheckbox = function(label, twiddleName, callback) {
      var checkbox;
      checkbox = new App.RedesignCheckbox({
        labelText: label,
        initialState: this.getTwiddle(twiddleName),
        callback: ((function(_this) {
          return function() {
            _this.setTwiddle(twiddleName, checkbox.state());
            return typeof callback === "function" ? callback() : void 0;
          };
        })(this))
      });
      checkbox.twiddleName = twiddleName;
      this._checkboxes.push(checkbox);
      return checkbox.el;
    };

    SettingsSubsection.prototype.createCheckboxForSeries = function(columnName, seriesHelper, labelText, initiallyDisabled) {
      var checkbox;
      if (labelText == null) {
        labelText = '';
      }
      if (initiallyDisabled == null) {
        initiallyDisabled = false;
      }
      checkbox = new App.RedesignCheckbox({
        labelText: labelText,
        initialState: seriesHelper.getValue(columnName),
        callback: ((function(_this) {
          return function() {
            seriesHelper.setValue(columnName, checkbox.state());
            return _this.widget.trigger('settings-updated');
          };
        })(this)),
        initiallyDisabled: initiallyDisabled
      });
      return checkbox.el;
    };

    SettingsSubsection.prototype.createCheckboxNegated = function(label, twiddleName, callback) {
      var checkbox;
      checkbox = new App.RedesignCheckbox({
        labelText: label,
        initialState: !this.getTwiddle(twiddleName),
        callback: ((function(_this) {
          return function() {
            _this.setTwiddle(twiddleName, !checkbox.state());
            if (callback != null) {
              return callback();
            }
          };
        })(this))
      });
      checkbox.twiddleName = twiddleName;
      checkbox.isNegated = true;
      this._checkboxes.push(checkbox);
      return checkbox.el;
    };

    SettingsSubsection.prototype.createCheckboxesFromArray = function(labelTwiddle, valueTwiddle, animate) {
      var checkbox, checkboxArray, j, label, labels, len, values;
      labels = this.twiddlesActual.redesignGetArray(labelTwiddle);
      values = this.twiddlesActual.redesignGetArray(valueTwiddle);
      checkboxArray = [];
      for (j = 0, len = labels.length; j < len; j++) {
        label = labels[j];
        checkbox = this._createCheckboxFromArray(label, valueTwiddle, values, animate);
        checkboxArray.push(checkbox.el);
      }
      return checkboxArray;
    };

    SettingsSubsection.prototype._createCheckboxFromArray = function(label, valueTwiddle, values, animate) {
      return new App.RedesignCheckbox({
        labelText: label,
        initialState: values.includes(label),
        callback: ((function(_this) {
          return function() {
            return _this.toggleCheckboxInArray(label, valueTwiddle, animate);
          };
        })(this))
      });
    };

    SettingsSubsection.prototype.toggleCheckboxInArray = function(column, twiddleName, animate) {
      var currentCols, newCols;
      currentCols = this.widget.getArrayTwiddle(twiddleName);
      if (currentCols.length && currentCols[0] === '-1') {
        currentCols = [];
      }
      if (!currentCols.includes(column)) {
        newCols = currentCols.concat(column);
      } else {
        newCols = currentCols.without(column);
      }
      this.setTwiddle(twiddleName, newCols, animate);
      return this.widget.setTwiddle('new_logic', true);
    };

    SettingsSubsection.prototype.createRadioGroup = function(options, defaultValue, twiddleName, callback) {
      var rg;
      rg = new App.RedesignRadioButtonGroup({
        radioOptions: options,
        initialValue: this.getTwiddle(twiddleName) || App.RedesignRadioButton.NOTHING_SELECTED,
        defaultValue: defaultValue,
        callback: ((function(_this) {
          return function(value) {
            if (callback != null) {
              callback();
            }
            return _this.setTwiddle(twiddleName, value);
          };
        })(this))
      });
      return rg.el;
    };

    SettingsSubsection.prototype.createRadioGroupForSeries = function(options, seriesHelper) {
      var rg;
      rg = new App.RedesignRadioButtonGroup({
        radioOptions: options,
        initialValue: seriesHelper.getValue(),
        callback: (function(_this) {
          return function(value) {
            seriesHelper.setValue(value);
            return _this.widget.trigger('settings-updated');
          };
        })(this)
      });
      return rg.getRadioButtons();
    };

    SettingsSubsection.prototype.setTwiddle = function(twiddleName, value, animate) {
      if (animate == null) {
        animate = true;
      }
      this.widget.setTwiddle(twiddleName, value);
      return this.widget.trigger('settings-updated', animate);
    };

    SettingsSubsection.prototype.setNumberTwiddle = function(twiddleName, inputElement, conditions) {
      var value;
      value = _.trim(inputElement.val());
      if (value === '' || isNaN(value)) {
        this.setTwiddle(twiddleName, null);
        return inputElement.val('');
      } else if (conditions.includes('gt0') && Number(value) <= 0) {
        this.setTwiddle(twiddleName, null);
        return inputElement.val('');
      } else {
        this.setTwiddle(twiddleName, Number(value));
        return inputElement.val(value);
      }
    };

    SettingsSubsection.prototype.getTwiddle = function(twiddleName) {
      var ref;
      if (this.widget.getTwiddle(twiddleName) != null) {
        return this.widget.getTwiddle(twiddleName);
      }
      return (ref = this.twiddlesActual) != null ? ref.get(twiddleName) : void 0;
    };

    SettingsSubsection.prototype.refresh = function(widget, chartData) {
      var checkbox, j, len, ref;
      if (widget !== this.widget) {
        return;
      }
      ref = this._checkboxes;
      for (j = 0, len = ref.length; j < len; j++) {
        checkbox = ref[j];
        if (checkbox.isNegated) {
          checkbox.toggleSelected(!this.getTwiddle(checkbox.twiddleName));
        } else {
          checkbox.toggleSelected(this.getTwiddle(checkbox.twiddleName));
        }
      }
      this.twiddlesActual = chartData.twiddlesActual;
      if (this.rerender != null) {
        AppRedesign.current().uiQueue.add(((function(_this) {
          return function() {
            return _this.rerender();
          };
        })(this)), 'editor-settings-subjection-rerender');
      }
    };

    SettingsSubsection.prototype.chartTypeIs = function(validChartTypes) {
      return validChartTypes.includes(this.widget.chart_type);
    };

    SettingsSubsection.prototype.columnNames = function() {
      return this.twiddlesActual.redesignGetArray(App.TwiddleConfig.COLUMN_NAMES);
    };

    SettingsSubsection.prototype.geojsonMapType = function() {
      return this.chartTypeIs(['geomap']) && this.widget.getTwiddle(App.TwiddleConfig.GEOMAP_DATA_MODE) === App.Geomap.DATA_MODE_GEOJSON;
    };

    SettingsSubsection.prototype.seriesNames = function() {
      if (!this.twiddlesActual) {
        return [];
      }
      if (this.twiddlesActual.get('segment_column').isEmpty()) {
        return this.columnNames().concat(this.twiddlesActual.getArray('series_names')).unique();
      } else {
        return this.twiddlesActual.getArray('series_names');
      }
    };

    SettingsSubsection.prototype.tableColors = function() {
      var colorTheme, colors, j, len, ref, twiddleName;
      colorTheme = this.widget.colorTheme();
      colors = {};
      ref = ['table_color_header_background', 'table_color_header_text', 'table_color_odd_rows_background', 'table_color_odd_rows_text', 'table_color_even_rows_background', 'table_color_even_rows_text'];
      for (j = 0, len = ref.length; j < len; j++) {
        twiddleName = ref[j];
        colors[twiddleName] = this.widget.twiddles[twiddleName] || colorTheme[twiddleName];
      }
      return colors;
    };

    SettingsSubsection.prototype.getTwiddleOrThemeColor = function(colorType, theme) {
      return this.widget.twiddles[colorType] || theme[colorType];
    };

    SettingsSubsection.prototype.setAllColors = function() {
      this.setTableTwiddleColors();
      return this.setSeriesTwiddleColors();
    };

    SettingsSubsection.prototype.setTableTwiddleColors = function() {
      var j, len, ref, results, tableColors, twiddleName;
      tableColors = this.tableColors();
      ref = _.keys(tableColors);
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        twiddleName = ref[j];
        results.push(this.widget.setTwiddle(twiddleName, tableColors[twiddleName]));
      }
      return results;
    };

    SettingsSubsection.prototype.setSeriesTwiddleColors = function() {
      var color, i, j, k, len, len1, name, results, results1, seriesNames, themeSeriesColors;
      themeSeriesColors = this.widget.colorTheme().series;
      seriesNames = this.seriesNames();
      if (_.some(seriesNames, (function(_this) {
        return function(name) {
          return _this.widget.getSeriesTwiddle(name, 'color') != null;
        };
      })(this))) {
        results = [];
        for (i = j = 0, len = seriesNames.length; j < len; i = ++j) {
          name = seriesNames[i];
          color = this.widget.getSeriesTwiddle(name, 'color') || themeSeriesColors[i % themeSeriesColors.length];
          results.push(this.widget.setSeriesTwiddle(name, 'color', color));
        }
        return results;
      } else {
        results1 = [];
        for (i = k = 0, len1 = themeSeriesColors.length; k < len1; i = ++k) {
          color = themeSeriesColors[i];
          results1.push(this.widget.setSeriesTwiddle(seriesNames[i], 'color', color));
        }
        return results1;
      }
    };

    SettingsSubsection.prototype.geomapPlotModeForSeries = function(columnName) {
      var geomap_plot_mode;
      geomap_plot_mode = this.twiddlesActual.getForSeries(columnName, 'geomap_plot_mode');
      if (geomap_plot_mode == null) {
        geomap_plot_mode = this.widget.getSeriesTwiddle(columnName, 'geomap_plot_mode');
      }
      if (geomap_plot_mode == null) {
        geomap_plot_mode = this.widget.getTwiddle(App.TwiddleConfig.GEOMAP_PLOT_MODE);
      }
      if (geomap_plot_mode == null) {
        geomap_plot_mode = App.Geomap.PLOT_MODE_POINTS;
      }
      return geomap_plot_mode;
    };

    SettingsSubsection.prototype.fieldMouseEnter = function(e) {
      var target;
      target = $(e.currentTarget);
      if (!this.isOverflown(target)) {
        return;
      }
      return this.fieldTooltip = App.RedesignTooltipPanel.addPanel({
        contentEl: null,
        description: target.text(),
        extraClass: 'light-theme name',
        pointerOffsetPercent: 0.5,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        useWidthAsMin: true,
        width: '70px'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, 0.5, target.offset().left + target.width() / 2, target.offset().top);
    };

    SettingsSubsection.prototype.isOverflown = function(el) {
      var expectedWidth, fontSize;
      if (el == null) {
        return false;
      }
      fontSize = parseInt(el.css('font-size'));
      App.Utils.initRedesignCanvasWidthSizer(fontSize);
      expectedWidth = App.Utils.fastApproxWidthForText(el.text());
      return el.width() < parseInt(expectedWidth);
    };

    SettingsSubsection.prototype.fieldMouseLeave = function(evt) {
      var ref;
      if ((ref = this.fieldTooltip) != null) {
        ref.release();
      }
      return this.fieldTooltip = null;
    };

    SettingsSubsection.prototype.cleanupBeforeSave = function() {};

    SettingsSubsection.prototype.updateOpenRotators = function() {
      var i, j, len, ref, results, rotator;
      ref = this.rotators;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        rotator = ref[i];
        if ($(rotator).hasClass('closed')) {
          results.push(_.remove(this.openRotators, function(n) {
            return i === n;
          }));
        } else {
          results.push(this.openRotators.push(i));
        }
      }
      return results;
    };

    SettingsSubsection.prototype.toggleExpandAll = function() {
      var expand, i, j, len, ref, rotator;
      expand = !this.expandAllButton.hasClass('expanded');
      this.expandAllButton.toggleClass('expanded');
      ref = this.rotators;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        rotator = ref[i];
        $(rotator).toggleClass('closed', !expand);
        if (expand) {
          this.openRotators.push(i);
        }
      }
      if (!expand) {
        return this.openRotators = [];
      }
    };

    SettingsSubsection.prototype.resetExpandAll = function(evt) {
      var allRotatorsOpen, rotatorDelta;
      if (evt == null) {
        evt = null;
      }
      rotatorDelta = 0;
      if (evt != null ? evt.currentTarget : void 0) {
        if ($(evt.currentTarget).hasClass('closed')) {
          rotatorDelta = -1;
        } else {
          rotatorDelta = 1;
        }
      }
      allRotatorsOpen = this.rotators.filter('.closed').length + rotatorDelta === 0;
      return this.expandAllButton.toggleClass('expanded', allRotatorsOpen);
    };

    return SettingsSubsection;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AdvancedSettings = (function(superClass) {
    extend(AdvancedSettings, superClass);

    AdvancedSettings.TOOLTIP_TEXT_ADMIN = 'Only admins can adjust this preference';

    AdvancedSettings.TOOLTIP_TEXT_NONE_ADMIN = 'Adjusting this preference has been disabled by an admin';

    AdvancedSettings.URL_ADMIN_ONLY = 'The Public CSV URL is only visible to admins';

    AdvancedSettings.prototype.elements = {
      '.csv-setting': 'csvSetting',
      '.csv-checkbox': 'csvCheckboxArea',
      '.csv-textarea': 'apiKeyTextarea',
      '.annotation-groups': 'annotationGroupSection',
      '.annotation-group-dropdown': 'annotationGroupDropdown',
      '.chart-description textarea': 'chartDescription',
      '.drilldowns': 'drilldownSection'
    };

    AdvancedSettings.prototype.events = {
      'change .chart-description textarea': 'changedChartDescription',
      'change .annotation-group-dropdown': 'changedAnnotationGroups',
      'click .csv-textarea': 'clickedApiKeyTextarea'
    };

    function AdvancedSettings() {
      this.changedAnnotationGroups = bind(this.changedAnnotationGroups, this);
      this.updateCsvUrl = bind(this.updateCsvUrl, this);
      this.clickedCsvDownloadCheckbox = bind(this.clickedCsvDownloadCheckbox, this);
      this.clickedApiCheckbox = bind(this.clickedApiCheckbox, this);
      this.changedChartDescription = bind(this.changedChartDescription, this);
      this.textForApiKeyTextArea = bind(this.textForApiKeyTextArea, this);
      this.refreshApiKey = bind(this.refreshApiKey, this);
      this.renderDrilldownSection = bind(this.renderDrilldownSection, this);
      this.maybeShowTooltipOnDropdownItem = bind(this.maybeShowTooltipOnDropdownItem, this);
      this.maybeShowTooltipOnSelectedItem = bind(this.maybeShowTooltipOnSelectedItem, this);
      this.renderOnce = bind(this.renderOnce, this);
      AdvancedSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'subsectionName');
      this.html(this.view('redesign/editors/widgets/advanced_settings')({
        subsectionName: this.subsectionName
      }));
    }

    AdvancedSettings.prototype.renderOnce = function() {
      if (this._rendered) {
        return;
      }
      this._rendered = true;
      if (this.shouldHideCsvSetting()) {
        this.csvSetting.hide();
      } else {
        if (this.shouldShowCsvDownloadCheckbox()) {
          this.csvDownloadCheckbox = new App.RedesignCheckbox({
            labelText: 'Enable CSV Download From Chart',
            initialState: this.widget.csvDownloadEnabled(),
            callback: this.clickedCsvDownloadCheckbox
          });
          this.csvCheckboxArea.append(this.csvDownloadCheckbox.el);
          this.setCheckBoxStatusAndTooltip(App.Site.first().csv_download_access, this.csvDownloadCheckbox.el, this.csvDownloadTooltipController);
        }
        if (this.shouldShowCsvUrlCheckbox()) {
          this.csvCheckbox = new App.RedesignCheckbox({
            labelText: 'Expose Public CSV URL',
            initialState: this.isApiEnabled(),
            callback: this.clickedApiCheckbox
          });
          this.csvCheckboxArea.append(this.csvCheckbox.el);
          if (App.Site.first().isCsvDownloadPermissionsEnabled()) {
            this.setCheckBoxStatusAndTooltip(App.Site.first().csv_api_access, this.csvCheckbox.el, this.csvApiTooltipController);
          }
        }
        this.updateCsvUrl();
      }
      this.chartDescription.val(this.widget.chart_description);
      if (this.chartTypeIs(['table', 'cohort', 'codeimage', 'codetext', 'image', 'pie'])) {
        this.annotationGroupSection.hide();
      } else {
        this.setupAnnotationGroupDropdown();
      }
      this.renderDrilldownSection();
      return App.Dashboard.bind('remaining-state-loaded', this.renderDrilldownSection);
    };

    AdvancedSettings.prototype.release = function() {
      var ref, ref1, ref2;
      App.Dashboard.unbind('remaining-state-loaded', this.renderDrilldownSection);
      if ((ref = this.drilldownSectionController) != null) {
        ref.release();
      }
      if ((ref1 = this.csvDownloadTooltipController) != null) {
        ref1.release();
      }
      if ((ref2 = this.csvApiTooltipController) != null) {
        ref2.release();
      }
      return AdvancedSettings.__super__.release.apply(this, arguments);
    };

    AdvancedSettings.prototype.setCheckBoxStatusAndTooltip = function(accessFlag, checkBoxElement, tooltipController) {
      var tooltipWidth, useWidthAsMin;
      if (accessFlag === App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_ADMINS]) {
        tooltipWidth = '100px';
        useWidthAsMin = true;
        if (App.User.safeCurrentUser().isAdmin()) {
          checkBoxElement.attr('data-tooltip', App.AdvancedSettings.TOOLTIP_TEXT_ADMIN);
        } else {
          checkBoxElement.addClass('disabled');
          checkBoxElement.attr('data-tooltip', App.AdvancedSettings.TOOLTIP_TEXT_NONE_ADMIN);
          tooltipWidth = '180px';
          useWidthAsMin = false;
        }
        return tooltipController != null ? tooltipController : tooltipController = new App.IconTooltipHelper({
          icon: checkBoxElement,
          infoCallback: (function(_this) {
            return function(evt) {
              return $(evt.currentTarget).data('tooltip');
            };
          })(this),
          direction: App.RedesignTooltipPanel.BOTTOM,
          activeClass: '',
          tooltipWidth: tooltipWidth,
          useWidthAsMin: useWidthAsMin,
          leftOffset: 110,
          closeOnScroll: true
        });
      }
    };

    AdvancedSettings.prototype.setupAnnotationGroupDropdown = function() {
      var annotation, dropdownItems, initialAnnotations, options, selectedItems;
      options = (function() {
        var i, len, ref, results;
        ref = App.Annotation.groups();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          annotation = ref[i];
          results.push({
            name: annotation,
            value: annotation
          });
        }
        return results;
      })();
      initialAnnotations = this.getTwiddle(App.TwiddleConfig.ANNOTATION_GROUPS);
      this.annotationGroupDropdown.html(App.Utils.optionsToHtml(options, initialAnnotations));
      this.annotationGroupDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      this.annotationGroupDropdown.find('.search-field').remove();
      selectedItems = this.annotationGroupDropdown.data('chosen').container.find('.chosen-choices');
      selectedItems.on('mouseover', '.search-choice span', this.maybeShowTooltipOnSelectedItem);
      selectedItems.on('mouseout', '.search-choice span', ((function(_this) {
        return function() {
          var ref;
          return (ref = _this.annotationGroupTooltip) != null ? ref.closeAndRelease() : void 0;
        };
      })(this)));
      dropdownItems = this.annotationGroupDropdown.data('chosen').search_results;
      dropdownItems.on('mouseover.chosen', this.maybeShowTooltipOnDropdownItem);
      return dropdownItems.on('mouseout.chosen', ((function(_this) {
        return function() {
          var ref;
          return (ref = _this.annotationGroupTooltip) != null ? ref.closeAndRelease() : void 0;
        };
      })(this)));
    };

    AdvancedSettings.prototype.maybeShowTooltipOnSelectedItem = function(e) {
      var searchChoice, spanEl;
      spanEl = $(e.currentTarget);
      searchChoice = spanEl.parent()[0];
      if (searchChoice.offsetWidth >= searchChoice.scrollWidth) {
        return;
      }
      return this.showTooltip(spanEl.parent());
    };

    AdvancedSettings.prototype.maybeShowTooltipOnDropdownItem = function(e) {
      var target;
      target = $(e.target).closest('.chosen-results li')[0];
      if ((target == null) || target.offsetWidth >= target.scrollWidth) {
        return;
      }
      return this.showTooltip($(target));
    };

    AdvancedSettings.prototype.showTooltip = function(targetEl) {
      var pointerOffset, ref, targetOffset, tooltipValue, tooltipWidth;
      if ((ref = this.annotationGroupTooltip) != null) {
        ref.closeAndRelease();
      }
      tooltipValue = targetEl.text().trim();
      if (!tooltipValue) {
        return;
      }
      pointerOffset = App.RedesignTooltipPanel.DEFAULT_POINTER_OFFSET;
      targetOffset = targetEl.offset();
      App.Utils.initRedesignCanvasWidthSizer(11);
      tooltipWidth = Math.min(250, App.Utils.canvasWidthForText(tooltipValue));
      return this.annotationGroupTooltip = App.RedesignTooltipPanel.addPanel({
        side: App.RedesignTooltipPanel.BOTTOM,
        width: tooltipWidth + " px",
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        description: '',
        contentEl: $(this.view('tooltip_content')({
          tooltipValue: tooltipValue
        })),
        useSmallPointer: true,
        extraClass: 'light-theme'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, targetEl, pointerOffset, targetOffset.left - (tooltipWidth - targetEl.innerWidth()) * 0.45, targetOffset.top + (targetEl.outerHeight() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE));
    };

    AdvancedSettings.prototype.shouldHideCsvSetting = function() {
      return this.chartTypeIs(['codetext']) || this.chartTypeIs(['codeimage']) || (!this.shouldShowCsvDownloadCheckbox() && !this.shouldShowCsvUrlCheckbox());
    };

    AdvancedSettings.prototype.shouldShowCsvDownloadCheckbox = function() {
      return App.Site.first().isCsvDownloadPermissionsEnabled() && App.Site.first().csv_download_access !== App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_NONE];
    };

    AdvancedSettings.prototype.shouldShowCsvUrlCheckbox = function() {
      return App.Site.first().csv_api_access !== App.Site.CSV_ACCESS[App.Site.CSV_ACCESS_NONE];
    };

    AdvancedSettings.prototype.shouldShowCsvUrlTextArea = function() {
      return this.shouldShowCsvUrlCheckbox() && this.isApiEnabled();
    };

    AdvancedSettings.prototype.rerender = function() {
      if (!this._rendered) {
        return;
      }
      if (this.widget.getTwiddle('twiddle_transpose_table') && this.chartTypeIs(['table'])) {
        return this.drilldownSection.hide();
      } else {
        return this.renderDrilldownSection();
      }
    };

    AdvancedSettings.prototype.renderDrilldownSection = function() {
      var ref;
      if (this.chartTypeIs(['codetext']) || this.chartTypeIs(['image']) || (this.widget.getTwiddle('twiddle_transpose_table') && this.chartTypeIs(['table']))) {
        return;
      }
      if (this.chartTypeIs(['codeimage']) && !this.widget.hasPlotlyData()) {
        return;
      }
      this.drilldownSection.show();
      if ((ref = this.drilldownSectionController) != null) {
        ref.release();
      }
      this.drilldownSectionController = new App.DrilldownSectionController({
        widget: this.widget
      });
      return this.drilldownSection.append(this.drilldownSectionController.el);
    };

    AdvancedSettings.prototype.refreshApiKey = function() {
      this.apiKeyTextarea.text(this.textForApiKeyTextArea());
      if (this.widget.api_enabled && (this.widget.api_token != null) && this.widget.api_token !== '' && !this.shouldHideCsvSetting()) {
        return this.csvSetting.addClass('enabled');
      } else {
        return this.csvSetting.removeClass('enabled');
      }
    };

    AdvancedSettings.prototype.textForApiKeyTextArea = function() {
      if (this.shouldShowCsvUrlTextArea()) {
        if (App.Site.first().isCsvDownloadPermissionsEnabled()) {
          if (App.Site.first().csvApiAccessAdmins() && !App.User.safeCurrentUser().isAdmin()) {
            return App.AdvancedSettings.URL_ADMIN_ONLY;
          }
        }
        return this.widget.apiRouteForCSV() || '';
      }
    };

    AdvancedSettings.prototype.clickedApiKeyTextarea = function() {
      return this.apiKeyTextarea.trigger('select');
    };

    AdvancedSettings.prototype.changedChartDescription = function() {
      this.widget.chart_description = this.chartDescription.val();
      return this.widget.trigger('settings-updated');
    };

    AdvancedSettings.prototype.clickedApiCheckbox = function() {
      if (this.csvCheckbox.state()) {
        this.enableApi();
      } else {
        this.disableApi();
      }
      return this.updateCsvUrl();
    };

    AdvancedSettings.prototype.clickedCsvDownloadCheckbox = function() {
      return this.widget.csv_download_disabled = !this.csvDownloadCheckbox.state();
    };

    AdvancedSettings.prototype.isApiEnabled = function() {
      return this.widget.api_enabled && (this.widget.api_token != null) && this.widget.api_token !== '';
    };

    AdvancedSettings.prototype.enableApi = function() {
      this.widget.api_enabled = true;
      return this.widget.getApiToken();
    };

    AdvancedSettings.prototype.disableApi = function() {
      return this.widget.api_enabled = false;
    };

    AdvancedSettings.prototype.updateCsvUrl = function() {
      if (this.shouldShowCsvUrlTextArea()) {
        this.apiKeyTextarea.show();
        return this.apiKeyTextarea.text(this.textForApiKeyTextArea());
      } else {
        this.apiKeyTextarea.hide();
        return this.apiKeyTextarea.text('');
      }
    };

    AdvancedSettings.prototype.changedAnnotationGroups = function() {
      return this.setTwiddle(App.TwiddleConfig.ANNOTATION_GROUPS, this.annotationGroupDropdown.val());
    };

    AdvancedSettings.prototype.cleanupBeforeSave = function() {
      var ref;
      return (ref = this.drilldownSectionController) != null ? ref.cleanupBeforeSave() : void 0;
    };

    return AdvancedSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AreaSettings = (function(superClass) {
    extend(AreaSettings, superClass);

    AreaSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function AreaSettings() {
      AreaSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Area Settings'
      }));
      this.contentArea.append(this.createCheckbox('Proportional Area', App.TwiddleConfig.PROPORTIONAL));
    }

    return AreaSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AxesSettings = (function(superClass) {
    extend(AxesSettings, superClass);

    AxesSettings.prototype.elements = {
      '.checkboxes': 'checkboxes',
      '.format-dropdown': 'formatDropdown',
      '.currency-dropdown-area': 'currencyDropdownArea',
      '.currency-dropdown': 'currencyDropdown',
      '.x-axis-title': 'xAxisTitle',
      '.x-min': 'xMin',
      '.x-max': 'xMax',
      '.x-min-max-row': 'xMinMaxRow',
      '.y-axis-title': 'yAxisTitle',
      '.y-min': 'yMin',
      '.y-max': 'yMax',
      '.y-interval': 'yInterval',
      '.y-min-max-interval-row': 'yMinMaxIntervalRow',
      '.y-section .content-area': 'yContentArea',
      '.y2-axis-title': 'y2AxisTitle',
      '.y2-min': 'y2Min',
      '.y2-max': 'y2Max',
      '.y2-interval': 'y2Interval',
      '.y2-section': 'y2Section',
      '.y2-section .content-area': 'y2ContentArea'
    };

    AxesSettings.prototype.events = {
      'change .format-dropdown': 'formatChanged',
      'change .currency-dropdown': 'currencyChanged',
      'change .x-axis-title': 'xAxisChanged',
      'change .x-min': 'xMinChanged',
      'change .x-max': 'xMaxChanged',
      'change .y-axis-title': 'yAxisChanged',
      'change .y-min': 'yMinChanged',
      'change .y-max': 'yMaxChanged',
      'change .y-interval': 'yIntervalChanged',
      'change .y2-axis-title': 'y2AxisChanged',
      'change .y2-min': 'y2MinChanged',
      'change .y2-max': 'y2MaxChanged',
      'change .y2-interval': 'y2IntervalChanged'
    };

    function AxesSettings() {
      this.y2IntervalChanged = bind(this.y2IntervalChanged, this);
      this.y2MaxChanged = bind(this.y2MaxChanged, this);
      this.y2MinChanged = bind(this.y2MinChanged, this);
      this.y2AxisChanged = bind(this.y2AxisChanged, this);
      this.yIntervalChanged = bind(this.yIntervalChanged, this);
      this.yMaxChanged = bind(this.yMaxChanged, this);
      this.yMinChanged = bind(this.yMinChanged, this);
      this.yAxisChanged = bind(this.yAxisChanged, this);
      this.xMaxChanged = bind(this.xMaxChanged, this);
      this.xMinChanged = bind(this.xMinChanged, this);
      this.xAxisChanged = bind(this.xAxisChanged, this);
      this.renderOnce = bind(this.renderOnce, this);
      AxesSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'subsectionName');
      this.html(this.view('redesign/editors/widgets/axes_settings')({
        subsectionName: this.subsectionName
      }));
    }

    AxesSettings.prototype.renderOnce = function() {
      if (this._rendered) {
        return;
      }
      this._rendered = true;
      this.checkboxes.append(this.createCheckbox('Show all X Axis Labels', App.TwiddleConfig.X_AXIS_SHOW_ALL_LABELS));
      this.checkboxes.append(this.createCheckbox('Rotate X Axis Labels', App.TwiddleConfig.ROTATE_X_AXIS_LABELS));
      this.checkboxes.append(this.createCheckbox('Make Axis Continuous', App.TwiddleConfig.CONTINUOUS_X_AXIS));
      if (this.chartTypeIs(['sparkline', 'bubble'])) {
        this.y2Section.hide();
      }
      if (this.chartTypeIs(['sparkline'])) {
        this.xMinMaxRow.hide();
      }
      if (this.chartTypeIs(['sparkline'])) {
        this.yMinMaxIntervalRow.hide();
      }
      if (this.getTwiddle(App.TwiddleConfig.VALUES_FORMAT) != null) {
        this.formatDropdown.val(this.getTwiddle(App.TwiddleConfig.VALUES_FORMAT));
      }
      if (this.getTwiddle(App.TwiddleConfig.CURRENCY) != null) {
        this.currencyDropdown.val(this.getTwiddle(App.TwiddleConfig.CURRENCY));
      }
      this.formatDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      this.currencyDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      this.xAxisTitle.val(this.getTwiddle(App.TwiddleConfig.X_AXIS_TITLE));
      this.xMin.val(this.getTwiddle(App.TwiddleConfig.MIN_X_AXIS));
      this.xMax.val(this.getTwiddle(App.TwiddleConfig.MAX_X_AXIS));
      this.yAxisTitle.val(this.getTwiddle(App.TwiddleConfig.Y_AXIS_TITLE));
      this.yMin.val(this.getTwiddle(App.TwiddleConfig.MIN_Y_AXIS));
      this.yMax.val(this.getTwiddle(App.TwiddleConfig.MAX_Y_AXIS));
      this.yInterval.val(this.getTwiddle(App.TwiddleConfig.Y_AXIS_INTERVAL));
      this.yContentArea.append(this.createCheckbox('Fit to Data', App.TwiddleConfig.Y_AXIS_FIT));
      this.y2AxisTitle.val(this.getTwiddle(App.TwiddleConfig.Y2_AXIS_TITLE));
      this.y2Min.val(this.getTwiddle(App.TwiddleConfig.MIN_Y2_AXIS));
      this.y2Max.val(this.getTwiddle(App.TwiddleConfig.MAX_Y2_AXIS));
      this.y2Interval.val(this.getTwiddle(App.TwiddleConfig.Y2_AXIS_INTERVAL));
      this.y2ContentArea.append(this.createCheckbox('Fit to Data', App.TwiddleConfig.Y2_AXIS_FIT));
      return this.y2ContentArea.append(this.createCheckbox('Use Percentages on Y2 Axis', App.TwiddleConfig.SECOND_AXIS_PERCENT));
    };

    AxesSettings.prototype.formatChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.VALUES_FORMAT, this.formatDropdown.val());
    };

    AxesSettings.prototype.currencyChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.CURRENCY, this.currencyDropdown.val());
    };

    AxesSettings.prototype.rerender = function() {
      if (this.getTwiddle(App.TwiddleConfig.VALUES_FORMAT) === 'dollar') {
        return this.currencyDropdownArea.css('visibility', '');
      } else {
        return this.currencyDropdownArea.css('visibility', 'hidden');
      }
    };

    AxesSettings.prototype.xAxisChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.X_AXIS_TITLE, this.xAxisTitle.val());
    };

    AxesSettings.prototype.xMinChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MIN_X_AXIS, this.xMin.val());
    };

    AxesSettings.prototype.xMaxChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MAX_X_AXIS, this.xMax.val());
    };

    AxesSettings.prototype.yAxisChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.Y_AXIS_TITLE, this.yAxisTitle.val());
    };

    AxesSettings.prototype.yMinChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MIN_Y_AXIS, this.yMin.val());
    };

    AxesSettings.prototype.yMaxChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MAX_Y_AXIS, this.yMax.val());
    };

    AxesSettings.prototype.yIntervalChanged = function() {
      return this.setNumberTwiddle(App.TwiddleConfig.Y_AXIS_INTERVAL, this.yInterval, ['gt0']);
    };

    AxesSettings.prototype.y2AxisChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.Y2_AXIS_TITLE, this.y2AxisTitle.val());
    };

    AxesSettings.prototype.y2MinChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MIN_Y2_AXIS, this.y2Min.val());
    };

    AxesSettings.prototype.y2MaxChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.MAX_Y2_AXIS, this.y2Max.val());
    };

    AxesSettings.prototype.y2IntervalChanged = function() {
      return this.setNumberTwiddle(App.TwiddleConfig.Y2_AXIS_INTERVAL, this.y2Interval, ['gt0']);
    };

    return AxesSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.BarSettings = (function(superClass) {
    extend(BarSettings, superClass);

    BarSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function BarSettings() {
      this.deleteExistingSeries = bind(this.deleteExistingSeries, this);
      BarSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Bar Settings'
      }));
    }

    BarSettings.prototype.rerender = function() {
      this.contentArea.empty();
      this.contentArea.append(this.createCheckbox('Proportional Bars', App.TwiddleConfig.PROPORTIONAL, this.deleteExistingSeries));
      this.contentArea.append(this.createCheckbox('Grouped Bars', App.TwiddleConfig.GROUPED_BARS, this.deleteExistingSeries));
      return this.contentArea.append(this.createCheckbox('Horizontal Bars', App.TwiddleConfig.HORIZONTAL_BARS, this.deleteExistingSeries));
    };

    BarSettings.prototype.deleteExistingSeries = function() {
      var results, series, settings, twiddleSeries;
      twiddleSeries = {};
      if ((this.widget.twiddles != null) && (this.widget.twiddles.series != null)) {
        twiddleSeries = this.widget.twiddles.series;
      }
      results = [];
      for (series in twiddleSeries) {
        settings = twiddleSeries[series];
        if (settings['series_chart_type'] != null) {
          results.push(delete settings['series_chart_type']);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return BarSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  App.CohortSeries = (function() {
    function CohortSeries(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    CohortSeries.prototype.setValue = function(columnName, checked) {
      var column, currentState, newColumns, sortedNewColumns;
      this.widget.setTwiddle('twiddle_use_explicit_point_cols', true);
      currentState = this.twiddlesActual.redesignGetArray('point_cols').includes(columnName);
      if (currentState) {
        newColumns = this.twiddlesActual.redesignGetArray('point_cols').without(columnName);
      } else {
        newColumns = this.twiddlesActual.redesignGetArray('point_cols')["with"](columnName);
      }
      sortedNewColumns = (function() {
        var i, len, ref, results;
        ref = this.twiddlesActual.redesignGetArray('column_names');
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          column = ref[i];
          if (typeof newColumns.includes === "function" ? newColumns.includes(column) : void 0) {
            results.push(column);
          }
        }
        return results;
      }).call(this);
      return this.widget.setTwiddle('twiddle_point_cols', sortedNewColumns);
    };

    CohortSeries.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('point_cols').includes(columnName);
    };

    return CohortSeries;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CohortSeriesSettings = (function(superClass) {
    extend(CohortSeriesSettings, superClass);

    CohortSeriesSettings.prototype.elements = {
      '.row .cohort': 'cohorts',
      '.row .pivot': 'pivots',
      '.row .data': 'datas',
      '.row .detail': 'details',
      '.row .field-name': 'fieldNames'
    };

    function CohortSeriesSettings() {
      CohortSeriesSettings.__super__.constructor.apply(this, arguments);
    }

    CohortSeriesSettings.prototype.rerender = function() {
      var cohortSeriesHelper, dataSeriesHelper, detailSeriesHelper, fieldName, i, item, j, k, l, len, len1, len2, len3, len4, m, pivotSeriesHelper, ref, ref1, ref2, ref3, ref4, results;
      if (this.twiddlesActual == null) {
        return;
      }
      this.html(this.view('redesign/editors/widgets/cohort_series_settings')({
        fields: this.twiddlesActual.redesignGetArray(App.TwiddleConfig.COLUMN_NAMES)
      }));
      cohortSeriesHelper = new App.CohortSeries(this.twiddlesActual, this.widget);
      ref = this.cohorts;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        $(item).append(this.createCheckboxForSeries($(item).data('field-name'), cohortSeriesHelper));
      }
      pivotSeriesHelper = new App.PivotSeries(this.twiddlesActual, this.widget);
      ref1 = this.pivots;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        item = ref1[j];
        $(item).append(this.createCheckboxForSeries($(item).data('field-name'), pivotSeriesHelper));
      }
      dataSeriesHelper = new App.DataSeries(this.twiddlesActual, this.widget);
      ref2 = this.datas;
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        item = ref2[k];
        $(item).append(this.createCheckboxForSeries($(item).data('field-name'), dataSeriesHelper));
      }
      detailSeriesHelper = new App.DetailSeries(this.twiddlesActual, this.widget);
      ref3 = this.details;
      for (l = 0, len3 = ref3.length; l < len3; l++) {
        item = ref3[l];
        $(item).append(this.createCheckboxForSeries($(item).data('field-name'), detailSeriesHelper));
      }
      ref4 = this.fieldNames;
      results = [];
      for (m = 0, len4 = ref4.length; m < len4; m++) {
        fieldName = ref4[m];
        $(fieldName).on('mouseenter', this.fieldMouseEnter);
        results.push($(fieldName).on('mouseleave', this.fieldMouseLeave));
      }
      return results;
    };

    return CohortSeriesSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CohortSettings = (function(superClass) {
    extend(CohortSettings, superClass);

    CohortSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function CohortSettings() {
      CohortSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Cohort Settings'
      }));
      this.contentArea.append(this.createCheckbox('Disable Cohort Colors', App.TwiddleConfig.NO_COHORT_COLOR));
      if (!App.DragDropSeriesHelper.isDragDropWidget(this.widget)) {
        this.contentArea.append(this.createCheckbox('Preserve Sort Order', App.TwiddleConfig.COHORT_SORT_ORDER));
      }
      this.contentArea.append(this.createCheckbox('Hide Row Totals', App.TwiddleConfig.COHORT_NO_ROW_TOTALS));
    }

    return CohortSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ColorSettings = (function(superClass) {
    extend(ColorSettings, superClass);

    ColorSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    ColorSettings.prototype.events = {
      'click .theme-color-picker-box': 'launchTablePicker'
    };

    function ColorSettings() {
      this.setTableColors = bind(this.setTableColors, this);
      this.launchTablePicker = bind(this.launchTablePicker, this);
      this.render = bind(this.render, this);
      ColorSettings.__super__.constructor.apply(this, arguments);
      this.render();
      this.widget.bind('theme-changed', this.render);
    }

    ColorSettings.prototype.render = function() {
      return this.html(this.view('redesign/settings/theme_color_setting')({
        title: 'Color Settings',
        colors: this.tableColorGroups()
      }));
    };

    ColorSettings.prototype.launchTablePicker = function(e) {
      var colorGroup, colorPicker, ref, target;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      if ((ref = this.colorPicker) != null) {
        ref.release();
      }
      this.contentArea.addClass('edit-mode');
      target = $(e.currentTarget);
      colorGroup = this.tableColorGroups()[target.data('color-group')];
      colorPicker = new App.TableColorPickerController({
        colorGroup: colorGroup,
        colorTheme: this.widget.colorTheme(),
        backgroundTarget: target.find('.background-color'),
        textTarget: target.find('.text-color')
      });
      colorPicker.bind('update', this.setTableColors);
      return $(e.currentTarget).append(colorPicker.$el);
    };

    ColorSettings.prototype.setTableColors = function(colorGroup) {
      this.widget.setTwiddle(colorGroup.type + "_text", colorGroup.text);
      this.widget.setTwiddle(colorGroup.type + "_background", colorGroup.background);
      this.contentArea.removeClass('edit-mode');
      this.setAllColors();
      return this.widget.trigger('settings-updated');
    };

    ColorSettings.prototype.tableColorGroups = function() {
      var colorTheme, colors;
      colorTheme = this.widget.colorTheme();
      return colors = {
        table_color_header: {
          type: 'table_color_header',
          displayName: 'Header',
          background: this.getTwiddleOrThemeColor('table_color_header_background', colorTheme),
          text: this.getTwiddleOrThemeColor('table_color_header_text', colorTheme)
        },
        table_color_odd_rows: {
          type: 'table_color_odd_rows',
          displayName: 'Odd Rows',
          background: this.getTwiddleOrThemeColor('table_color_odd_rows_background', colorTheme),
          text: this.getTwiddleOrThemeColor('table_color_odd_rows_text', colorTheme)
        },
        table_color_even_rows: {
          type: 'table_color_even_rows',
          displayName: 'Even Rows',
          background: this.getTwiddleOrThemeColor('table_color_even_rows_background', colorTheme),
          text: this.getTwiddleOrThemeColor('table_color_even_rows_text', colorTheme)
        }
      };
    };

    return ColorSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ColorThemeSettings = (function(superClass) {
    extend(ColorThemeSettings, superClass);

    ColorThemeSettings.prototype.elements = {
      '.content-area': 'contentArea',
      '.widget-color-themes-area .body': 'colorThemeArea'
    };

    ColorThemeSettings.prototype.events = {
      'click .save-new-theme:not(.disabled)': 'clickedSaveNew'
    };

    function ColorThemeSettings() {
      this.hideThemeOptions = bind(this.hideThemeOptions, this);
      this.unsetTwiddleColors = bind(this.unsetTwiddleColors, this);
      this.themeChanged = bind(this.themeChanged, this);
      this.savedNewTheme = bind(this.savedNewTheme, this);
      this.clickedSaveNew = bind(this.clickedSaveNew, this);
      this.rerender = bind(this.rerender, this);
      this.release = bind(this.release, this);
      ColorThemeSettings.__super__.constructor.apply(this, arguments);
      this.widget.bind('theme-selected', this.themeChanged);
      App.Site.bind('update-color-themes', this.themeChanged);
      this.userIsAdmin = App.User.safeCurrentUser().isAdmin();
      $('#body').on('click', this.hideThemeOptions);
    }

    ColorThemeSettings.prototype.release = function() {
      this.widget.unbind('theme-selected', this.themeChanged);
      App.Site.unbind('update-color-themes', this.themeChanged);
      $('#body').off('click', this.hideThemeOptions);
      return ColorThemeSettings.__super__.release.apply(this, arguments);
    };

    ColorThemeSettings.prototype.rerender = function() {
      this.defaultTheme = this.buildDefaultTheme();
      this.defaultTheme.bind('ajaxSuccess', this.savedNewTheme);
      this.html(this.view('redesign/editors/widgets/color_theme_settings')({
        color_themes_enabled: AppRedesign.current().colorThemesEnabled,
        isCustomTheme: this.isCustomTheme,
        title: 'Color Theme',
        userIsAdmin: this.userIsAdmin
      }));
      return this.widgetColorThemeController = new App.WidgetColorThemesController({
        el: this.colorThemeArea,
        widget: this.widget,
        defaultTheme: this.defaultTheme,
        isCustomTheme: this.isCustomTheme
      });
    };

    ColorThemeSettings.prototype.clickedSaveNew = function() {
      return this.themesController = new App.RedesignSettingsColorThemesController({
        colorTheme: this.defaultTheme
      });
    };

    ColorThemeSettings.prototype.savedNewTheme = function(newTheme) {
      var ref;
      if ((ref = this.defaultTheme) != null) {
        ref.unbind('ajaxSuccess');
      }
      this.widget.default_color_theme_id = newTheme.id;
      this.unsetTwiddleColors();
      return this.rerender();
    };

    ColorThemeSettings.prototype.themeChanged = function() {
      var ref;
      if ((ref = this.widgetColorThemeController) != null) {
        ref.release();
      }
      this.unsetTwiddleColors();
      this.widget.trigger('colors-changed');
      this.widget.trigger('settings-updated');
      this.widget.trigger('theme-changed');
      return this.rerender();
    };

    ColorThemeSettings.prototype.buildDefaultTheme = function() {
      var colorTheme, originalDefaultTheme, twiddleColors, twiddleSeries;
      originalDefaultTheme = this.widget.colorTheme();
      colorTheme = originalDefaultTheme.dup();
      colorTheme.series = _.clone(originalDefaultTheme.series);
      twiddleColors = _.pick(this.widget.twiddles, 'table_color_header_background', 'table_color_header_text', 'table_color_odd_rows_background', 'table_color_odd_rows_text', 'table_color_even_rows_background', 'table_color_even_rows_text');
      _.assign(colorTheme, twiddleColors);
      twiddleSeries = _.map(this.seriesNames(), (function(_this) {
        return function(k) {
          return _this.widget.getSeriesTwiddle(k, 'color');
        };
      })(this));
      this.mergeSeriesColors(colorTheme.series, twiddleSeries);
      this.isCustomTheme = !_.isEqual(colorTheme.colorList(), originalDefaultTheme.colorList());
      if (this.isCustomTheme) {
        colorTheme.name = 'Custom Theme';
      }
      return colorTheme;
    };

    ColorThemeSettings.prototype.mergeSeriesColors = function(themeSeries, twiddleSeries) {
      var color, i, j, len, results;
      results = [];
      for (i = j = 0, len = twiddleSeries.length; j < len; i = ++j) {
        color = twiddleSeries[i];
        if (color) {
          results.push(themeSeries[i] = color);
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ColorThemeSettings.prototype.unsetTwiddleColors = function() {
      var j, key, len, ref, results, twiddles;
      twiddles = this.widget.twiddles;
      _.unset(twiddles, 'table_color_header_background');
      _.unset(twiddles, 'table_color_header_text');
      _.unset(twiddles, 'table_color_odd_rows_background');
      _.unset(twiddles, 'table_color_odd_rows_text');
      _.unset(twiddles, 'table_color_even_rows_background');
      _.unset(twiddles, 'table_color_even_rows_text');
      ref = this.seriesNames();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        results.push(_.unset(twiddles, ['series', key, 'series_color']));
      }
      return results;
    };

    ColorThemeSettings.prototype.hideThemeOptions = function() {
      var ref;
      if ((ref = this.widgetColorThemeController) != null) {
        ref.release();
      }
      return this.rerender();
    };

    return ColorThemeSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConditionalFormattingSettings = (function(superClass) {
    extend(ConditionalFormattingSettings, superClass);

    ConditionalFormattingSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function ConditionalFormattingSettings() {
      this.conditionalFormattingUpdated = bind(this.conditionalFormattingUpdated, this);
      ConditionalFormattingSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Conditional Formatting'
      }));
      this.conditionalFormattingRulesController = new App.RedesignConditionalFormattingRulesController({
        widget: this.widget,
        rules: $.extend(true, [], this.getTwiddle(App.TwiddleConfig.CONDITIONAL_FORMATTING)),
        twiddles: this.twiddlesActual
      });
      this.contentArea.append(this.conditionalFormattingRulesController.el);
      this.conditionalFormattingRulesController.bind('update', this.conditionalFormattingUpdated);
    }

    ConditionalFormattingSettings.prototype.conditionalFormattingUpdated = function(rules) {
      return this.setTwiddle(App.TwiddleConfig.CONDITIONAL_FORMATTING, $.extend(true, [], rules));
    };

    ConditionalFormattingSettings.prototype.rerender = function() {
      return this.conditionalFormattingRulesController.newChartData(this.twiddlesActual);
    };

    return ConditionalFormattingSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DataBarsSettings = (function(superClass) {
    extend(DataBarsSettings, superClass);

    DataBarsSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function DataBarsSettings() {
      this.conditionalFormattingUpdated = bind(this.conditionalFormattingUpdated, this);
      DataBarsSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Data Bars'
      }));
      this.dataBarsRulesController = new App.RedesignDataBarsRulesController({
        widget: this.widget,
        rules: $.extend(true, [], this.getTwiddle(App.TwiddleConfig.DATA_BARS)),
        twiddles: this.twiddlesActual
      });
      this.contentArea.append(this.dataBarsRulesController.el);
      this.dataBarsRulesController.bind('update', this.conditionalFormattingUpdated);
    }

    DataBarsSettings.prototype.conditionalFormattingUpdated = function(rules) {
      return this.setTwiddle(App.TwiddleConfig.DATA_BARS, $.extend(true, [], rules));
    };

    DataBarsSettings.prototype.rerender = function() {
      return this.dataBarsRulesController.newChartData(this.twiddlesActual);
    };

    return DataBarsSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  App.DataSeries = (function() {
    function DataSeries(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    DataSeries.prototype.setValue = function(columnName, checked) {
      var base, currentState;
      this.widget.setTwiddle('twiddle_use_explicit_value_cols', true);
      currentState = this.widget.getColumnTwiddle(columnName, 'use_as_value');
      if (currentState == null) {
        currentState = typeof (base = this.twiddlesActual.redesignGetArray('value_cols')).includes === "function" ? base.includes(columnName) : void 0;
      }
      return this.widget.setColumnTwiddle(columnName, 'use_as_value', !currentState);
    };

    DataSeries.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('value_cols').includes(columnName);
    };

    return DataSeries;

  })();

}).call(this);
(function() {
  App.DetailSeries = (function() {
    function DetailSeries(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    DetailSeries.prototype.setValue = function(columnName, checked) {
      var column, currentState, newColumns, sortedNewColumns;
      currentState = this.twiddlesActual.redesignGetArray('detail_columns').includes(columnName);
      if (currentState) {
        newColumns = this.twiddlesActual.redesignGetArray('detail_columns').without(columnName);
      } else {
        newColumns = this.twiddlesActual.redesignGetArray('detail_columns')["with"](columnName);
      }
      sortedNewColumns = (function() {
        var i, len, ref, results;
        ref = this.twiddlesActual.redesignGetArray('column_names');
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          column = ref[i];
          if (typeof newColumns.includes === "function" ? newColumns.includes(column) : void 0) {
            results.push(column);
          }
        }
        return results;
      }).call(this);
      return this.widget.setTwiddle('twiddle_detail_columns', sortedNewColumns);
    };

    DetailSeries.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('detail_columns').includes(columnName);
    };

    return DetailSeries;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DrilldownSectionController = (function(superClass) {
    extend(DrilldownSectionController, superClass);

    DrilldownSectionController.prototype.elements = {
      '.drilldown-dropdown': 'drilldownDropdown',
      '.mapping-section': 'mappingSection',
      '.mapping-list': 'mappingList'
    };

    DrilldownSectionController.prototype.events = {
      'click .add-mapping-link': 'clickedAddMapping',
      'click .delete-link': 'clickedDelete',
      'click .done-delete-link': 'clickedDoneDelete',
      'change .drilldown-dropdown': 'changedDashboard'
    };

    DrilldownSectionController.NONE_VALUE = '';

    function DrilldownSectionController() {
      this.changedDashboard = bind(this.changedDashboard, this);
      this.clickedDeleteMapping = bind(this.clickedDeleteMapping, this);
      this.clickedDoneDelete = bind(this.clickedDoneDelete, this);
      this.clickedDelete = bind(this.clickedDelete, this);
      this.clickedAddMapping = bind(this.clickedAddMapping, this);
      this.setReorderDescriptionText = bind(this.setReorderDescriptionText, this);
      var dashboard, initialDashboardId, options;
      DrilldownSectionController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.html(this.view('redesign/editors/widgets/drilldown_section')());
      initialDashboardId = this.widget.getTwiddle(App.TwiddleConfig.DRILLDOWN_DASHBOARD);
      options = (function() {
        var i, len, ref, results;
        ref = App.Dashboard.allSortedByNameNotNull();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          dashboard = ref[i];
          results.push({
            name: dashboard.name,
            value: dashboard.id
          });
        }
        return results;
      })();
      this.drilldownDropdown.html(App.Utils.optionsToHtmlWithNone(options, initialDashboardId));
      this.drilldownDropdown.chosen({
        width: '100%'
      });
      this.renderMappings();
      this.updateNoMappings();
    }

    DrilldownSectionController.prototype.renderMappings = function() {
      var dashboardId, i, len, mapping, ref, results;
      dashboardId = this.widget.getTwiddle(App.TwiddleConfig.DRILLDOWN_DASHBOARD);
      this.mappingList.empty();
      this.mappings = this.widget.getTwiddle(App.TwiddleConfig.DRILLDOWN_MAPPING);
      if (this.mappings == null) {
        this.mappings = [];
        this.widget.setTwiddle(App.TwiddleConfig.DRILLDOWN_MAPPING, this.mappings);
      }
      ref = this.mappings;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        mapping = ref[i];
        results.push(this.addMapping(mapping, dashboardId));
      }
      return results;
    };

    DrilldownSectionController.prototype.addMapping = function(mapping, dashboardId) {
      var columnName, filterId, mappingEl;
      columnName = mapping.column;
      filterId = mapping.filter;
      mappingEl = $(this.view('redesign/editors/widgets/drilldown_option')());
      this.mappingList.append(mappingEl);
      mappingEl.find('.delete').on('click', (function(_this) {
        return function() {
          return _this.clickedDeleteMapping(mapping, mappingEl);
        };
      })(this));
      this.addColumnDropdown(mapping, mappingEl, columnName);
      this.addFilterDropdown(mapping, mappingEl, filterId, dashboardId);
      this.setReorderDescriptionText(mapping, mappingEl);
      return this.updateNoMappings();
    };

    DrilldownSectionController.prototype.addColumnDropdown = function(mapping, mappingEl, columnName) {
      var column, columnOptions, columnSelect, i, len, ref;
      columnOptions = [
        {
          name: 'Select Column',
          value: ''
        }
      ];
      ref = this.widget.getColumns();
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        columnOptions.push({
          name: column.humanize(),
          value: column
        });
      }
      columnSelect = mappingEl.find(".column-select");
      columnSelect.html(App.Utils.optionsToHtml(columnOptions, columnName));
      columnSelect.chosen({
        width: '132px'
      });
      return columnSelect.on('change', (function(_this) {
        return function() {
          mapping.column = columnSelect.val();
          return _this.setReorderDescriptionText(mapping, mappingEl);
        };
      })(this));
    };

    DrilldownSectionController.prototype.addFilterDropdown = function(mapping, mappingEl, filterId, dashboardId) {
      var filterSelect, option, options, validFilterIds;
      options = this.getFilterDropdownOptions(dashboardId);
      validFilterIds = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = options.length; i < len; i++) {
          option = options[i];
          results.push(option.value);
        }
        return results;
      })();
      if (!validFilterIds.includes(filterId)) {
        filterId = App.DrilldownSectionController.NONE_VALUE;
      }
      filterSelect = mappingEl.find(".filter-select");
      filterSelect.html(App.Utils.optionsToHtml(options, filterId));
      filterSelect.chosen({
        width: '132px'
      });
      return filterSelect.on('change', (function(_this) {
        return function() {
          mapping.filter = filterSelect.val();
          return _this.setReorderDescriptionText(mapping, mappingEl);
        };
      })(this));
    };

    DrilldownSectionController.prototype.setReorderDescriptionText = function(mapping, mappingEl) {
      var columnName, descriptionText, filterName;
      columnName = mapping.column;
      filterName = App.CustomDimension.exists(mapping.filter).name;
      if (columnName && filterName) {
        descriptionText = "Column " + columnName + " mapped to Filter " + filterName;
      } else if (columnName && !filterName) {
        descriptionText = "Column " + columnName + " not mapped to any filter";
      } else if (filterName && !columnName) {
        descriptionText = "No column mapped to Filter " + filterName;
      } else {
        descriptionText = "";
      }
      return mappingEl.find('.reorder-controls .description').text(descriptionText);
    };

    DrilldownSectionController.prototype.getFilterDropdownOptions = function(dashboardId) {
      var availableDimensions, dimension, i, len, options, ref;
      availableDimensions = App.DimensionAvailability.availableForDashboardById(App.Dashboard.exists(dashboardId));
      options = [
        {
          name: 'Select Filter',
          value: ''
        }
      ];
      ref = App.CustomDimension.allSortedByName();
      for (i = 0, len = ref.length; i < len; i++) {
        dimension = ref[i];
        if (availableDimensions.includes(dimension.id + "")) {
          options.push({
            name: dimension.name,
            value: dimension.id + ""
          });
        }
      }
      if (availableDimensions.includes(App.CustomDimension.AGGREGATION)) {
        options.push({
          name: 'Aggregation',
          value: App.CustomDimension.AGGREGATION
        });
      }
      if (availableDimensions.includes(App.CustomDimension.DATE_RANGE)) {
        options.push({
          name: 'Date Range',
          value: App.CustomDimension.DATE_RANGE
        });
        options.push({
          name: 'Date Range Start',
          value: App.CustomDimension.CUSTOM_RANGE_START_DATE
        });
        options.push({
          name: 'Date Range End',
          value: App.CustomDimension.CUSTOM_RANGE_END_DATE
        });
      }
      return options;
    };

    DrilldownSectionController.prototype.clickedAddMapping = function() {
      var dashboardId, mapping;
      mapping = {
        column: null,
        filter: null
      };
      this.mappings.push(mapping);
      dashboardId = this.widget.getTwiddle(App.TwiddleConfig.DRILLDOWN_DASHBOARD);
      return this.addMapping(mapping, dashboardId);
    };

    DrilldownSectionController.prototype.clickedDelete = function() {
      return this.mappingSection.addClass('delete-mode');
    };

    DrilldownSectionController.prototype.clickedDoneDelete = function() {
      return this.mappingSection.removeClass('delete-mode');
    };

    DrilldownSectionController.prototype.clickedDeleteMapping = function(mapping, mappingEl) {
      mappingEl.remove();
      _.pull(this.mappings, mapping);
      return this.updateNoMappings();
    };

    DrilldownSectionController.prototype.updateNoMappings = function() {
      this.mappingSection.toggleClass('no-mappings', this.mappings.length === 0);
      if (this.mappings.length === 0) {
        return this.mappingSection.removeClass('delete-mode');
      }
    };

    DrilldownSectionController.prototype.changedDashboard = function() {
      var selectedDashboardId;
      selectedDashboardId = App.Dashboard.exists(this.drilldownDropdown.val()).id;
      this.widget.setTwiddle(App.TwiddleConfig.DRILLDOWN_DASHBOARD, selectedDashboardId);
      this.mappings = this.widget.getTwiddle(App.TwiddleConfig.DRILLDOWN_MAPPING);
      if ((selectedDashboardId != null) && this.mappings.length === 0) {
        this.mappings.push({});
      } else if (selectedDashboardId == null) {
        _.remove(this.mappings, function() {
          return true;
        });
      }
      return this.renderMappings();
    };

    DrilldownSectionController.prototype.cleanupBeforeSave = function() {
      var i, len, mapping, ref;
      this.mappingsCopy = _.clone(this.mappings);
      ref = this.mappingsCopy;
      for (i = 0, len = ref.length; i < len; i++) {
        mapping = ref[i];
        if ((mapping.column == null) && (mapping.filter == null)) {
          _.remove(this.mappings, mapping);
        }
      }
      if (this.mappings.length === 0) {
        return this.widget.setTwiddle(App.TwiddleConfig.DRILLDOWN_MAPPING, null);
      }
    };

    return DrilldownSectionController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FieldSettings = (function(superClass) {
    extend(FieldSettings, superClass);

    FieldSettings.prototype.elements = {
      '.row .x-axis': 'xAxes',
      '.row .y-axis': 'yAxes',
      '.row .z-axis': 'zAxes',
      '.row .series': 'series',
      '.row .weight': 'weights',
      '.header-area .x-axis': 'xAxisHeader',
      '.row .field-name': 'fieldNames'
    };

    function FieldSettings() {
      FieldSettings.__super__.constructor.apply(this, arguments);
    }

    FieldSettings.prototype.rerender = function() {
      var fieldName, fields, i, isSegmented, item, j, k, l, len, len1, len2, len3, len4, len5, len6, m, n, o, pair, ref, ref1, ref2, ref3, ref4, ref5, ref6, results, seriesColumn, weightColumn, xAxisColumn, xAxisRadioButtons, yAxis, yAxisColumn, yAxisRadioButtons, zAxisColumn, zAxisRadioButtons;
      if (this.twiddlesActual == null) {
        return;
      }
      this.html(this.view('redesign/editors/widgets/field_settings')({
        fields: this.twiddlesActual.redesignGetArray(App.TwiddleConfig.COLUMN_NAMES),
        zAxisEnabled: this.chartTypeIs(['bubble']),
        latLong: this.chartTypeIs(['geomap']) && !this.geojsonMapType(),
        geoJson: this.geojsonMapType(),
        chartType: this.widget.chart_type
      }));
      this.refreshElements();
      ref = this.fieldNames;
      for (i = 0, len = ref.length; i < len; i++) {
        fieldName = ref[i];
        $(fieldName).on('mouseenter', this.fieldMouseEnter);
        $(fieldName).on('mouseleave', this.fieldMouseLeave);
      }
      fields = (function() {
        var j, len1, ref1, results;
        ref1 = this.columnNames();
        results = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          fieldName = ref1[j];
          results.push({
            value: fieldName
          });
        }
        return results;
      }).call(this);
      if (this.chartTypeIs(['pie'])) {
        this.xAxisHeader.hide();
        this.xAxes.hide();
      } else {
        xAxisColumn = new App.XAxisColumn(this.twiddlesActual, this.widget);
        xAxisRadioButtons = this.createRadioGroupForSeries(fields, xAxisColumn);
        ref1 = _.zip(this.xAxes, xAxisRadioButtons);
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          pair = ref1[j];
          $(pair[0]).append(pair[1].el);
        }
      }
      if (this.chartTypeIs(['bubble', 'geomap']) && !this.geojsonMapType()) {
        yAxisColumn = new App.YAxisColumnForXYPointChart(this.twiddlesActual, this.widget);
        yAxisRadioButtons = this.createRadioGroupForSeries(fields, yAxisColumn);
        ref2 = _.zip(this.yAxes, yAxisRadioButtons);
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          pair = ref2[k];
          $(pair[0]).append(pair[1].el);
        }
      } else {
        yAxisColumn = new App.YAxisColumn(this.twiddlesActual, this.widget);
        ref3 = this.yAxes;
        for (l = 0, len3 = ref3.length; l < len3; l++) {
          yAxis = ref3[l];
          $(yAxis).append(this.createCheckboxForSeries($(yAxis).data('field-name'), yAxisColumn));
        }
      }
      if (this.chartTypeIs(['bubble'])) {
        isSegmented = !this.twiddlesActual.get('segment_column').isEmpty();
        zAxisColumn = new App.ZAxisColumn(this.twiddlesActual, this.widget, isSegmented);
        zAxisRadioButtons = this.createRadioGroupForSeries(fields, zAxisColumn);
        ref4 = _.zip(this.zAxes, zAxisRadioButtons);
        for (m = 0, len4 = ref4.length; m < len4; m++) {
          pair = ref4[m];
          $(pair[0]).append(pair[1].el);
        }
      }
      if (this.chartTypeIs(['geomap']) && !this.geojsonMapType()) {
        weightColumn = new App.WeightColumn(this.twiddlesActual, this.widget);
        ref5 = this.weights;
        for (n = 0, len5 = ref5.length; n < len5; n++) {
          item = ref5[n];
          $(item).append(this.createCheckboxForSeries($(item).data('field-name'), weightColumn, '', this.weightDisabled()));
        }
      }
      seriesColumn = new App.SeriesColumn(this.twiddlesActual, this.widget);
      ref6 = this.series;
      results = [];
      for (o = 0, len6 = ref6.length; o < len6; o++) {
        item = ref6[o];
        results.push($(item).append(this.createCheckboxForSeries($(item).data('field-name'), seriesColumn, '', this.seriesDisabled())));
      }
      return results;
    };

    FieldSettings.prototype.weightDisabled = function() {
      var geomapHasHeatmapOrBubbleSeries, i, len, ref, seriesName;
      if (!this.chartTypeIs(['geomap'])) {
        return false;
      }
      geomapHasHeatmapOrBubbleSeries = false;
      ref = this.seriesNames();
      for (i = 0, len = ref.length; i < len; i++) {
        seriesName = ref[i];
        geomapHasHeatmapOrBubbleSeries || (geomapHasHeatmapOrBubbleSeries = [App.Geomap.PLOT_MODE_HEATMAP, App.Geomap.PLOT_MODE_BUBBLES].includes(this.geomapPlotModeForSeries(seriesName)));
      }
      return !geomapHasHeatmapOrBubbleSeries;
    };

    FieldSettings.prototype.seriesDisabled = function() {
      return (this.columnNames().length <= 1 && this.geojsonMapType()) || (this.columnNames().length <= 2 && !this.chartTypeIs(['geomap', 'bubble', 'pie']));
    };

    return FieldSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ImageSettings = (function(superClass) {
    extend(ImageSettings, superClass);

    ImageSettings.prototype.elements = {
      '.right-panel-instructions': 'rightPanelInstructions'
    };

    function ImageSettings() {
      ImageSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/no_settings')({
        errorText: 'Series settings are not available for image charts'
      }));
      this.rightPanelInstructions.show();
    }

    return ImageSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LegendSettings = (function(superClass) {
    extend(LegendSettings, superClass);

    LegendSettings.prototype.elements = {
      '.checkboxes': 'checkboxes',
      '.position-dropdown': 'positionDropdown',
      '.legend-width': 'legendWidthArea',
      '.legend-width-input': 'legendWidth'
    };

    LegendSettings.prototype.events = {
      'change .position-dropdown': 'legendChanged',
      'change .legend-width-input': 'widthChanged'
    };

    LegendSettings.migrateLegendStructureToSupportLegendPositions = function(doNotShowLegend, hideLegendStrategy) {
      var hideLegendIfSingleSeries, legendPosition, legendWidth;
      if (doNotShowLegend && hideLegendStrategy !== 'hide-single-series') {
        legendPosition = 'none';
        legendWidth = '';
      } else {
        legendPosition = 'right';
        legendWidth = 140;
      }
      if (doNotShowLegend && hideLegendStrategy === 'hide-single-series') {
        hideLegendIfSingleSeries = true;
      } else {
        hideLegendIfSingleSeries = false;
      }
      return {
        legend_position: legendPosition,
        legend_width: legendWidth,
        hide_if_single_series: hideLegendIfSingleSeries
      };
    };

    function LegendSettings() {
      this.renderOnce = bind(this.renderOnce, this);
      LegendSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'subsectionName');
      this.html(this.view('redesign/editors/widgets/legend_settings')({
        subsectionName: this.subsectionName
      }));
    }

    LegendSettings.prototype.renderOnce = function() {
      if (this._rendered) {
        return;
      }
      this._rendered = true;
      this.migrateLegendTwiddlesToSupportLegendPositions();
      this.hideWhenOnlyOneSeriesCheckbox = this.createCheckbox('Hide When Only One Series', App.TwiddleConfig.HIDE_LEGEND_FOR_SINGLE_SERIES);
      this.checkboxes.append(this.hideWhenOnlyOneSeriesCheckbox);
      if (!(this.chartTypeIs(['geomap']) || App.DragDropSeriesHelper.isDragDropWidget(this.widget))) {
        this.checkboxes.append(this.createCheckbox('Preserve Sort Order', App.TwiddleConfig.DO_NOT_RESORT_FOR_LEGEND));
      }
      if (this.chartTypeIs(['pie'])) {
        this.checkboxes.append(this.createCheckbox('Show Percentage', App.TwiddleConfig.SHOW_VALUES_IN_LEGEND));
      }
      this.positionDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      return this.updateMenus();
    };

    LegendSettings.prototype.updateMenus = function() {
      this.positionDropdown.val(this.getTwiddle(App.TwiddleConfig.LEGEND_POSITION));
      this.positionDropdown.trigger('chosen:updated');
      this.legendWidth.val(this.getTwiddle(App.TwiddleConfig.LEGEND_WIDTH));
      this.toggleWidth();
      return this.toggleHideWhenOnlyOneSeries();
    };

    LegendSettings.prototype.rerender = function() {
      if (!this._rendered) {
        return;
      }
      this.migrateLegendTwiddlesToSupportLegendPositions();
      this.updateCheckboxes();
      return this.updateMenus();
    };

    LegendSettings.prototype.updateCheckboxes = function() {
      var checkbox, i, len, ref, results;
      ref = this._checkboxes;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        checkbox = ref[i];
        if (typeof this.getTwiddle === "function" ? this.getTwiddle(checkbox.twiddleName) : void 0) {
          results.push(checkbox.toggleSelected(true));
        } else {
          results.push(checkbox.toggleSelected(false));
        }
      }
      return results;
    };

    LegendSettings.prototype.migrateLegendTwiddlesToSupportLegendPositions = function() {
      var legendOptions;
      if (this.getTwiddle(App.TwiddleConfig.LEGEND_POSITION) != null) {
        return;
      }
      legendOptions = this.constructor.migrateLegendStructureToSupportLegendPositions(this.getTwiddle(App.TwiddleConfig.DO_NOT_SHOW_LEGEND), this.getTwiddle(App.TwiddleConfig.HIDE_LEGEND_STRATEGY));
      this.setTwiddle(App.TwiddleConfig.LEGEND_POSITION, legendOptions.legend_position);
      this.setTwiddle(App.TwiddleConfig.HIDE_LEGEND_FOR_SINGLE_SERIES, legendOptions.hide_legend_for_single_series);
      this.setTwiddle(App.TwiddleConfig.LEGEND_WIDTH, legendOptions.legend_width);
      this.setTwiddle(App.TwiddleConfig.DO_NOT_SHOW_LEGEND, null);
      return this.setTwiddle(App.TwiddleConfig.HIDE_LEGEND_STRATEGY, null);
    };

    LegendSettings.prototype.legendChanged = function() {
      this.setTwiddle(App.TwiddleConfig.LEGEND_POSITION, this.positionDropdown.val());
      this.toggleWidth();
      return this.toggleHideWhenOnlyOneSeries();
    };

    LegendSettings.prototype.widthChanged = function() {
      var value;
      try {
        value = parseInt(this.legendWidth.val().trim());
      } catch (error) {}
      if (Number.isInteger(value)) {
        return this.setTwiddle(App.TwiddleConfig.LEGEND_WIDTH, value);
      } else {
        return this.setTwiddle(App.TwiddleConfig.LEGEND_WIDTH, null);
      }
    };

    LegendSettings.prototype.toggleWidth = function() {
      if (['left', 'right'].includes(this.positionDropdown.val())) {
        return this.legendWidthArea.css('display', 'inline-block');
      } else {
        return this.legendWidthArea.hide();
      }
    };

    LegendSettings.prototype.toggleHideWhenOnlyOneSeries = function() {
      if (this.positionDropdown.val() === 'none') {
        return this.hideWhenOnlyOneSeriesCheckbox.hide();
      } else {
        return this.hideWhenOnlyOneSeriesCheckbox.show();
      }
    };

    return LegendSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LineSettings = (function(superClass) {
    extend(LineSettings, superClass);

    LineSettings.prototype.className = 'line-settings';

    LineSettings.prototype.elements = {
      '.content-area': 'contentArea',
      '.rolling-average': 'rollingAverage',
      '.rolling-average .leading input': 'rollingAverageLeadingInput',
      '.rolling-average .trailing input': 'rollingAverageTrailingInput'
    };

    LineSettings.prototype.events = {
      'change .rolling-average input': 'rollingAverageChanged'
    };

    LineSettings.DEFAULT_LEADING_TRAILING_AVERAGE = 5;

    function LineSettings() {
      this.rollingAverageChanged = bind(this.rollingAverageChanged, this);
      LineSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Line Settings'
      }));
      this.contentArea.append(this.createCheckbox('Show Rolling Average', App.TwiddleConfig.AVERAGE_LINES_ENABLED));
      this.contentArea.append(this.view('redesign/editors/widgets/rolling_average'));
      this.refreshElements();
      if (this.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_LEADING) != null) {
        this.rollingAverageLeadingInput.val(this.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_LEADING));
      }
      if (this.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_TRAILING) != null) {
        this.rollingAverageTrailingInput.val(this.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_TRAILING));
      }
    }

    LineSettings.prototype.rollingAverageChanged = function() {
      this.updateTwiddlesIfDifferent({
        twiddle_average_lines_num_leading: this.parseToInt(this.rollingAverageLeadingInput.val()),
        twiddle_average_lines_num_trailing: this.parseToInt(this.rollingAverageTrailingInput.val())
      });
      return this.setRollingAvgValues();
    };

    LineSettings.prototype.parseToInt = function(stringValue) {
      var intValue;
      intValue = parseInt(stringValue);
      if (isNaN(intValue) || intValue < 0) {
        return this.constructor.DEFAULT_LEADING_TRAILING_AVERAGE;
      }
      return intValue;
    };

    LineSettings.prototype.updateTwiddlesIfDifferent = function(settings) {
      var field, results, value;
      results = [];
      for (field in settings) {
        value = settings[field];
        if (this.widget.getTwiddle(field) !== value) {
          results.push(this.setTwiddle(field, value));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    LineSettings.prototype.setRollingAvgValues = function() {
      this.rollingAverageLeadingInput.val(this.widget.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_LEADING));
      return this.rollingAverageTrailingInput.val(this.widget.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_NUM_TRAILING));
    };

    LineSettings.prototype.rerender = function() {
      if (Boolean(this.getTwiddle(App.TwiddleConfig.AVERAGE_LINES_ENABLED))) {
        return this.rollingAverage.show().css('display', 'flex');
      } else {
        return this.rollingAverage.hide();
      }
    };

    return LineSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.MapDataSettings = (function(superClass) {
    extend(MapDataSettings, superClass);

    MapDataSettings.prototype.className = 'map-data-settings';

    MapDataSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    MapDataSettings.MAP_DATA_OPTIONS = [
      {
        label: 'Latitude & Longitude',
        value: App.Geomap.DATA_MODE_LATLONG
      }, {
        label: 'GeoJSON',
        value: App.Geomap.DATA_MODE_GEOJSON
      }
    ];

    function MapDataSettings() {
      MapDataSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/series_header')({
        title: 'Map Data Settings'
      }));
      this.mapDataRadioGroup = this.createRadioGroup(App.MapDataSettings.MAP_DATA_OPTIONS, App.Geomap.DATA_MODE_LATLONG, App.TwiddleConfig.GEOMAP_DATA_MODE);
      this.contentArea.append(this.mapDataRadioGroup);
    }

    return MapDataSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.MapDisplaySettings = (function(superClass) {
    extend(MapDisplaySettings, superClass);

    MapDisplaySettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    MapDisplaySettings.MAP_DISPLAY_TYPES = [
      {
        label: 'Points',
        value: App.Geomap.PLOT_MODE_POINTS
      }, {
        label: 'Bubbles',
        value: App.Geomap.PLOT_MODE_BUBBLES
      }, {
        label: 'Heatmap',
        value: App.Geomap.PLOT_MODE_HEATMAP
      }, {
        label: 'Clusters',
        value: App.Geomap.PLOT_MODE_CLUSTERS
      }
    ];

    function MapDisplaySettings() {
      this.resetSeriesTypes = bind(this.resetSeriesTypes, this);
      var displayTypesRadio;
      MapDisplaySettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Map Display Settings'
      }));
      displayTypesRadio = this.createRadioGroup(App.MapDisplaySettings.MAP_DISPLAY_TYPES, App.Geomap.PLOT_MODE_POINTS, App.TwiddleConfig.GEOMAP_PLOT_MODE, this.resetSeriesTypes);
      this.contentArea.append(displayTypesRadio);
    }

    MapDisplaySettings.prototype.rerender = function() {
      if (this.geojsonMapType()) {
        return this.el.hide();
      } else {
        return this.el.show();
      }
    };

    MapDisplaySettings.prototype.resetSeriesTypes = function() {
      return this.widget.setAllSeriesTwiddle('geomap_plot_mode', null);
    };

    return MapDisplaySettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.MapTitleSettings = (function(superClass) {
    extend(MapTitleSettings, superClass);

    MapTitleSettings.prototype.elements = {
      '.subheader-1.rotator': 'headerRotator',
      '.content-area': 'contentArea'
    };

    function MapTitleSettings() {
      MapTitleSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Map Title Settings'
      }));
      this.contentArea.append(this.createCheckbox('Show Satellite View', App.TwiddleConfig.GEOMAP_SATELLITE_TILES));
    }

    MapTitleSettings.prototype.rerender = function() {
      if (this.geojsonMapType()) {
        return this.headerRotator.removeClass('closed');
      }
    };

    return MapTitleSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.MiscSettings = (function(superClass) {
    extend(MiscSettings, superClass);

    MiscSettings.prototype.elements = {
      '.checkboxes-area': 'checkboxesArea',
      '.max-series input': 'maxSeries'
    };

    MiscSettings.prototype.events = {
      'change .max-series input': 'maxSeriesChanged'
    };

    MiscSettings.DEFAULT_MAX_SERIES_VALUE = 19;

    function MiscSettings() {
      this.maxSeriesChanged = bind(this.maxSeriesChanged, this);
      var ref;
      MiscSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/misc_settings')({
        default_max_series_value: (ref = this.getTwiddle(App.TwiddleConfig.MAX_SERIES_BEFORE_OTHER)) != null ? ref : this.constructor.DEFAULT_MAX_SERIES_VALUE
      }));
      if (!this.chartTypeIs(['pie', 'geomap'])) {
        this.checkboxesArea.append(this.createCheckbox('Calculate Cumulative', App.TwiddleConfig.CUMULATIVE));
        this.checkboxesArea.append(this.createCheckbox('Show Data Labels', App.TwiddleConfig.DATA_LABELS));
      }
      this.checkboxesArea.append(this.createCheckbox('Title-Case Series Names', App.TwiddleConfig.TITLE_CASE_SERIES_NAMES));
      if (!this.chartTypeIs(['geomap'])) {
        this.checkboxesArea.append(this.createCheckbox('Animate on Dashboard', App.TwiddleConfig.ANIMATE_ON_DASHBOARD));
      }
      if (!this.chartTypeIs(['pie', 'geomap'])) {
        this.checkboxesArea.append(this.createCheckbox('Fill in Null Values', App.TwiddleConfig.FILL_NULL_VALUES));
        this.fillInNullValsRadio = this.createRadioGroup([
          {
            label: 'Fill With Zeroes',
            value: 'fill-with-zeroes'
          }, {
            label: 'Fill From Left',
            value: 'fill-from-left'
          }
        ], 'fill-with-zeroes', App.TwiddleConfig.FILL_NULL_VALUES_STRATEGY);
        this.checkboxesArea.append(this.fillInNullValsRadio);
        this.fillInNullValsRadio.addClass('one-indent');
      }
      this.checkboxesArea.append(this.createCheckboxNegated('Enable Aggregation into "Other" Series', App.TwiddleConfig.SERIES_NO_OTHER));
    }

    MiscSettings.prototype.maxSeriesChanged = function() {
      if (_.isEmpty(this.maxSeries.val())) {
        this.maxSeries.val(App.MiscSettings.DEFAULT_MAX_SERIES_VALUE);
      }
      return this.setTwiddle(App.TwiddleConfig.MAX_SERIES_BEFORE_OTHER, this.maxSeries.val());
    };

    MiscSettings.prototype.rerender = function() {
      var ref;
      return (ref = this.fillInNullValsRadio) != null ? ref.toggle(Boolean(this.getTwiddle(App.TwiddleConfig.FILL_NULL_VALUES))) : void 0;
    };

    return MiscSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.NumberOverlaySettings = (function(superClass) {
    extend(NumberOverlaySettings, superClass);

    NumberOverlaySettings.prototype.elements = {
      '.checkboxes': 'checkboxes',
      '.text-size-dropdown': 'textSizeDropdown',
      '.overlay-text-size': 'overlayTextSizeDiv'
    };

    NumberOverlaySettings.prototype.events = {
      'change .text-size-dropdown': 'textSizeChanged'
    };

    function NumberOverlaySettings() {
      this.renderOnce = bind(this.renderOnce, this);
      NumberOverlaySettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'subsectionName');
      this.html(this.view('redesign/editors/widgets/number_overlay_settings')({
        subsectionName: this.subsectionName
      }));
    }

    NumberOverlaySettings.prototype.renderOnce = function() {
      if (this._rendered) {
        return;
      }
      this._rendered = true;
      this.checkboxes.append(this.createCheckbox('Do Not Round Numbers', App.TwiddleConfig.DO_NOT_ROUND_BIG_NUMBER));
      this.checkboxes.append(this.createCheckbox('Show Cumulative', App.TwiddleConfig.OVERLAY_CUMULATIVE));
      this.origValueCheckbox = this.createCheckbox('Show Original Value on Hover', App.TwiddleConfig.OVERLAY_VALUE_ON_HOVER);
      this.checkboxes.append(this.origValueCheckbox);
      this.showOrHideOrigValueCheckbox();
      this.textSizeDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      return this.updateMenus();
    };

    NumberOverlaySettings.prototype.updateMenus = function() {
      var textSize;
      textSize = this.getTwiddle(App.TwiddleConfig.OVERLAY_TEXT_SIZE);
      if (textSize == null) {
        textSize = 'normal';
      }
      this.textSizeDropdown.val(textSize);
      return this.textSizeDropdown.trigger('chosen:updated');
    };

    NumberOverlaySettings.prototype.rerender = function() {
      if (!this._rendered) {
        return;
      }
      this.updateCheckboxes();
      return this.updateMenus();
    };

    NumberOverlaySettings.prototype.showOrHideOrigValueCheckbox = function() {
      var shouldHide;
      shouldHide = !this.getTwiddle(App.TwiddleConfig.OVERLAY_HAS_ONE_DATA_POINT);
      return this.origValueCheckbox.toggleClass("hidden", shouldHide);
    };

    NumberOverlaySettings.prototype.updateCheckboxes = function() {
      var checkbox, i, len, ref;
      ref = this._checkboxes;
      for (i = 0, len = ref.length; i < len; i++) {
        checkbox = ref[i];
        checkbox.toggleSelected(this.getTwiddle(checkbox.twiddleName));
      }
      return this.showOrHideOrigValueCheckbox();
    };

    NumberOverlaySettings.prototype.textSizeChanged = function() {
      return this.setTwiddle(App.TwiddleConfig.OVERLAY_TEXT_SIZE, this.textSizeDropdown.val());
    };

    return NumberOverlaySettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  App.PivotSeries = (function() {
    function PivotSeries(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    PivotSeries.prototype.setValue = function(columnName, checked) {
      var column, currentState, newColumns, sortedNewColumns;
      this.widget.setTwiddle('twiddle_use_explicit_segment_column', true);
      currentState = this.twiddlesActual.redesignGetArray('segment_column').includes(columnName);
      if (currentState) {
        newColumns = this.twiddlesActual.redesignGetArray('segment_column').without(columnName);
      } else {
        newColumns = this.twiddlesActual.redesignGetArray('segment_column')["with"](columnName);
      }
      sortedNewColumns = (function() {
        var i, len, ref, results;
        ref = this.twiddlesActual.redesignGetArray('column_names');
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          column = ref[i];
          if (typeof newColumns.includes === "function" ? newColumns.includes(column) : void 0) {
            results.push(column);
          }
        }
        return results;
      }).call(this);
      return this.widget.setTwiddle('twiddle_segment_column', sortedNewColumns);
    };

    PivotSeries.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('segment_column').includes(columnName);
    };

    return PivotSeries;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PlotOnY2AxisSeries = (function(superClass) {
    extend(PlotOnY2AxisSeries, superClass);

    function PlotOnY2AxisSeries(twiddlesActual, widget, isSegmented, isExtraSeries) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
      this.isSegmented = isSegmented;
      this.isExtraSeries = isExtraSeries;
      PlotOnY2AxisSeries.__super__.constructor.apply(this, arguments);
    }

    PlotOnY2AxisSeries.prototype.setValue = function(columnName, checked) {
      var onPrimary, onSecondary, oneAlreadyChecked, yAxisEnabledCols;
      onSecondary = onPrimary = false;
      if (this.isSegmented || this.isExtraSeries) {
        onSecondary = checked;
        if (checked) {
          onPrimary = false;
        }
      } else {
        this.disableSegmentationIfAutoSelected(columnName);
        oneAlreadyChecked = this.widget.getColumnTwiddle(columnName, 'use_as_value') !== false;
        if (oneAlreadyChecked && !checked) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', false);
        } else if (oneAlreadyChecked && checked) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          onSecondary = true;
        } else {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          onSecondary = true;
        }
        yAxisEnabledCols = _.union(this.widget.getArrayTwiddle('twiddle_y_axis_enabled_columns'), [columnName]);
        this.widget.setTwiddle('twiddle_y_axis_enabled_columns', yAxisEnabledCols);
      }
      this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', onPrimary);
      this.widget.setSeriesTwiddle(columnName, 'show_on_secondary_axis', onSecondary);
      this.widget.setTwiddle('twiddle_multiple_y_axes', false);
      this.widget.setTwiddle('twiddle_multiple_y_axes_columns', '');
      return this.widget.setTwiddle('new_logic', true);
    };

    PlotOnY2AxisSeries.prototype.getValue = function(columnName) {
      if (this.twiddlesActual.get('segment_column').isEmpty() && !this.isExtraSeries) {
        return this.twiddlesActual.redesignGetArray('value_cols').includes(columnName) && this.twiddlesActual.getForSeries(columnName, 'show_on_secondary_axis');
      } else {
        return this.twiddlesActual.getForSeries(columnName, 'show_on_secondary_axis');
      }
    };

    return PlotOnY2AxisSeries;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PlotOnYAxisSeries = (function(superClass) {
    extend(PlotOnYAxisSeries, superClass);

    function PlotOnYAxisSeries(twiddlesActual, widget, isSegmented, isExtraSeries) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
      this.isSegmented = isSegmented;
      this.isExtraSeries = isExtraSeries;
      PlotOnYAxisSeries.__super__.constructor.apply(this, arguments);
    }

    PlotOnYAxisSeries.prototype.setValue = function(columnName, checked) {
      var onPrimary, onSecondary, oneAlreadyChecked, yAxisEnabledCols;
      onSecondary = onPrimary = false;
      if (this.isSegmented || this.isExtraSeries) {
        onPrimary = checked;
        if (checked) {
          onSecondary = false;
        }
      } else {
        this.disableSegmentationIfAutoSelected(columnName);
        oneAlreadyChecked = this.widget.getColumnTwiddle(columnName, 'use_as_value') !== false;
        if (oneAlreadyChecked && !checked) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', false);
        } else if (oneAlreadyChecked && checked) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          onPrimary = true;
        } else {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          onPrimary = true;
        }
        yAxisEnabledCols = _.union(this.widget.getArrayTwiddle('twiddle_y_axis_enabled_columns'), [columnName]);
        this.widget.setTwiddle('twiddle_y_axis_enabled_columns', yAxisEnabledCols);
      }
      this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', onPrimary);
      this.widget.setSeriesTwiddle(columnName, 'show_on_secondary_axis', onSecondary);
      this.widget.setTwiddle('twiddle_multiple_y_axes', false);
      this.widget.setTwiddle('twiddle_multiple_y_axes_columns', '');
      return this.widget.setTwiddle('new_logic', true);
    };

    PlotOnYAxisSeries.prototype.getValue = function(columnName) {
      if (this.twiddlesActual.get('segment_column').isEmpty() && !this.isExtraSeries) {
        return this.twiddlesActual.redesignGetArray('value_cols').includes(columnName) && this.twiddlesActual.getForSeries(columnName, 'show_on_primary_axis');
      } else {
        return this.twiddlesActual.getForSeries(columnName, 'show_on_primary_axis');
      }
    };

    return PlotOnYAxisSeries;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignChartPicker = (function(superClass) {
    extend(RedesignChartPicker, superClass);

    RedesignChartPicker.prototype.elements = {
      'select.chart-type-dropdown': 'chartTypeDropdown'
    };

    RedesignChartPicker.prototype.events = {
      'change select.chart-type-dropdown': 'chartTypeChanged'
    };

    function RedesignChartPicker() {
      this.updateSelectedChartIcon = bind(this.updateSelectedChartIcon, this);
      this.chartTypeRefresh = bind(this.chartTypeRefresh, this);
      this.chartTypeChangedFromOtherTab = bind(this.chartTypeChangedFromOtherTab, this);
      this.chartTypeChanged = bind(this.chartTypeChanged, this);
      this.chartTypeChangedFromCurrentTab = bind(this.chartTypeChangedFromCurrentTab, this);
      var chosenElement, chosenListItem, chosenListItems, i, j, len;
      RedesignChartPicker.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget');
      this.html(this.view('redesign/editors/widgets/chart_picker')({
        chartTypes: this.chartTypes(),
        chartTypeDetails: this.chartTypeDetails(),
        widget: this.widget
      }));
      this.chartTypeDropdown.chosen({
        disable_search: true,
        width: '100%'
      });
      chosenElement = this.chartTypeDropdown.siblings();
      chosenListItems = chosenElement.siblings().find('li');
      for (i = j = 0, len = chosenListItems.length; j < len; i = ++j) {
        chosenListItem = chosenListItems[i];
        chosenListItem.attr('data-chart-type', App.Widget.ALL_CHART_TYPES[i]);
      }
      this.currentlySelectedItem = chosenElement.find('a.chosen-single span');
      this.updateSelectedChartIcon();
      this.widget.bind('chart-type-changed-from-other-tab', this.chartTypeChangedFromOtherTab);
      this.widget.bind('chart-type-refresh', this.chartTypeRefresh);
    }

    RedesignChartPicker.prototype.release = function() {
      this.widget.unbind('chart-type-changed-from-other-tab', this.chartTypeChangedFromOtherTab);
      return this.widget.unbind('chart-type-refresh', this.chartTypeRefresh);
    };

    RedesignChartPicker.prototype.chartTypes = function() {
      if (AppRedesign.current().deepAnalysisEnabled) {
        if (this.widget.code != null) {
          return [].concat(App.Widget.ALL_CHART_TYPES, App.Widget.ALL_CODE_CHART_TYPES);
        }
      }
      return App.Widget.ALL_CHART_TYPES;
    };

    RedesignChartPicker.prototype.codeChartTypeDetailsByLanguage = function(codeLanguage) {
      switch (codeLanguage) {
        case 'R':
          return App.ChartUtils.R_CHART_TYPE_DETAILS;
        case 'python':
          return App.ChartUtils.PYTHON_CHART_TYPE_DETAILS;
      }
    };

    RedesignChartPicker.prototype.chartTypeDetails = function() {
      var baseChartTypeDetails, detailsForLanguage;
      baseChartTypeDetails = App.ChartUtils.CHART_TYPES;
      if (AppRedesign.current().deepAnalysisEnabled) {
        if (this.widget.code != null) {
          detailsForLanguage = this.codeChartTypeDetailsByLanguage(this.widget.getCodeLanguage());
          return $.extend(baseChartTypeDetails, detailsForLanguage);
        }
      }
      return baseChartTypeDetails;
    };

    RedesignChartPicker.prototype.chartTypeChangedFromCurrentTab = function() {
      this.trigger('chart-type-changed', this.chartTypeDropdown.val());
      if (!this.widget.twiddles['twiddle_drag_drop_chart']) {
        this.widget.trigger('settings-updated', this.chartTypeDropdown.val());
      }
      this.widget.trigger('chart-type-changed-from-other-tab', this, this.chartTypeDropdown.val());
      return this.updateSelectedChartIcon();
    };

    RedesignChartPicker.prototype.chartTypeChanged = function() {
      this.widget.setTwiddle('use_default_chart_type', false);
      return this.chartTypeChangedFromCurrentTab();
    };

    RedesignChartPicker.prototype.chartTypeChangedFromOtherTab = function(widget, chartPickerInstance, newChartType) {
      if (chartPickerInstance === this) {
        return;
      }
      this.chartTypeDropdown.val(newChartType);
      this.chartTypeDropdown.trigger('chosen:updated');
      this.trigger('chart-type-changed', this.chartTypeDropdown.val());
      return this.updateSelectedChartIcon();
    };

    RedesignChartPicker.prototype.defaultChartTypeChanged = function(newChartType) {
      this.chartTypeDropdown.val(newChartType);
      this.chartTypeDropdown.trigger('chosen:updated');
      return this.chartTypeChangedFromCurrentTab();
    };

    RedesignChartPicker.prototype.chartTypeRefresh = function(widget, newChartType) {
      this.chartTypeDropdown.val(newChartType);
      this.chartTypeDropdown.trigger('chosen:updated');
      return this.updateSelectedChartIcon();
    };

    RedesignChartPicker.prototype.updateSelectedChartIcon = function() {
      return this.currentlySelectedItem.attr('data-chart-type', this.chartTypeDropdown.val());
    };

    return RedesignChartPicker;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignConditionalFormattingRuleController = (function(superClass) {
    extend(RedesignConditionalFormattingRuleController, superClass);

    RedesignConditionalFormattingRuleController.prototype.elements = {
      '.conditional-dropdown': 'conditionalDropdownEl',
      'input': 'ruleValueInput',
      '.color-picker-area': 'colorPickerArea',
      '.reorder-controls .description': 'reorderDescription'
    };

    RedesignConditionalFormattingRuleController.prototype.events = {
      'blur input': 'ruleValueChanged',
      'click .reorder-controls .delete': 'deleteClicked',
      'click .theme-color-picker-box': 'launchPicker'
    };

    RedesignConditionalFormattingRuleController.RULES = [
      {
        name: "greater than",
        id: "greaterThan"
      }, {
        name: "less than",
        id: "lessThan"
      }, {
        name: "equals",
        id: "equals"
      }, {
        name: "doesn't equal",
        id: "notEquals"
      }, {
        name: "contains",
        id: "contains"
      }, {
        name: "doesn't contain",
        id: "notContains"
      }
    ];

    RedesignConditionalFormattingRuleController.COL_TYPE_STRING = 'string';

    RedesignConditionalFormattingRuleController.COL_TYPE_NUMBER = 'number';

    function RedesignConditionalFormattingRuleController() {
      this.conditionalOptions = bind(this.conditionalOptions, this);
      this.deleteClicked = bind(this.deleteClicked, this);
      this.updateParent = bind(this.updateParent, this);
      this.colorsUpdated = bind(this.colorsUpdated, this);
      this.ruleValueChanged = bind(this.ruleValueChanged, this);
      this.conditionalUpdated = bind(this.conditionalUpdated, this);
      RedesignConditionalFormattingRuleController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget', 'rule', 'twiddles');
      this.html(this.view('redesign/editors/widgets/conditional_formatting_rule')({
        rule: this.rule
      }));
      this.render();
      this.setConditionalText();
      this.setValuePlaceholder();
      this.released = false;
    }

    RedesignConditionalFormattingRuleController.prototype.release = function() {
      var ref;
      if (this.released) {
        return;
      }
      this.conditionalDropdown.release();
      if ((ref = this.colorPicker) != null) {
        ref.release();
      }
      RedesignConditionalFormattingRuleController.__super__.release.apply(this, arguments);
      return this.released = true;
    };

    RedesignConditionalFormattingRuleController.prototype.render = function() {
      this.conditionalDropdown = new App.RedesignSmoothDropdown({
        el: App.RedesignSmoothDropdown.appendFrame(this.conditionalDropdownEl),
        widget: this.widget,
        optionsFunc: this.conditionalOptions,
        optionsMode: App.RedesignSmoothDropdown.SINGLE_SELECT,
        currentValueFunc: ((function(_this) {
          return function() {
            return _this.rule.conditionId + "!" + _this.rule.column;
          };
        })(this))
      });
      this.conditionalDropdown.bind('update', this.conditionalUpdated);
      if (this.rule.value != null) {
        return this.ruleValueInput.val(this.rule.value);
      }
    };

    RedesignConditionalFormattingRuleController.prototype.launchPicker = function(e) {
      var ref, target;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      if ((ref = this.colorPicker) != null) {
        ref.release();
      }
      target = $(e.currentTarget);
      this.colorPicker = new App.ConditionalFormattingColorPickerController({
        colorGroup: {
          background: this.rule.bg_color,
          text: this.rule.text_color
        },
        colorTheme: this.widget.colorTheme(),
        backgroundTarget: target.find('.background-color'),
        textTarget: target.find('.text-color')
      });
      this.colorPicker.bind('update', this.colorsUpdated);
      return $(e.currentTarget).append(this.colorPicker.$el);
    };

    RedesignConditionalFormattingRuleController.prototype.conditionalUpdated = function(option) {
      this.rule.conditionId = option.conditionId;
      this.rule.column = option.column;
      this.setConditionalText();
      if (this.twiddles.getForColumn(this.rule.column, 'type') === App.Chartographer.NUMERIC_COLUMN_TYPE) {
        this.ruleValueInput.attr('placeholder', '123');
      } else {
        this.ruleValueInput.attr('placeholder', 'abc');
      }
      this.updateParent();
      return this.setValuePlaceholder();
    };

    RedesignConditionalFormattingRuleController.prototype.setConditionalText = function() {
      var column, conditional, i, len, r, ref, value;
      column = (this.rule.column != null ? this.rule.column : '');
      conditional = '';
      ref = App.RedesignConditionalFormattingRuleController.RULES;
      for (i = 0, len = ref.length; i < len; i++) {
        r = ref[i];
        if (r.id === this.rule.conditionId) {
          conditional = r.name;
        }
      }
      value = (this.rule.value != null ? this.rule.value : '');
      if (column !== '') {
        this.conditionalDropdown.setText(column + " " + conditional);
      } else {
        this.conditionalDropdown.setText("Select a Column", true);
      }
      return this.reorderDescription.text(column + " " + conditional + " " + value);
    };

    RedesignConditionalFormattingRuleController.prototype.ruleValueChanged = function() {
      this.rule.value = this.ruleValueInput.val();
      this.setConditionalText();
      return this.updateParent();
    };

    RedesignConditionalFormattingRuleController.prototype.setValuePlaceholder = function() {
      var dateSeries, e, numeric, placeholder;
      try {
        numeric = this.twiddles.getForColumn(this.rule.column, 'type') === App.Chartographer.NUMERIC_COLUMN_TYPE;
        dateSeries = this.twiddles.getForColumn(this.rule.column, 'type') === App.Chartographer.DATETIME_COLUMN_TYPE;
        placeholder = null;
        if (this.rule.column == null) {
          placeholder = '';
        }
        if (dateSeries) {
          if (placeholder == null) {
            placeholder = '2014-01-01';
          }
        }
        if (numeric) {
          if (placeholder == null) {
            placeholder = '0';
          }
        }
        if (placeholder == null) {
          placeholder = 'abc';
        }
        return this.ruleValueInput.attr('placeholder', placeholder);
      } catch (error) {
        e = error;
        return AppRedesign.logError(e);
      }
    };

    RedesignConditionalFormattingRuleController.prototype.colorsUpdated = function(colors) {
      this.rule.text_color = colors.text;
      this.rule.bg_color = colors.background;
      return this.updateParent();
    };

    RedesignConditionalFormattingRuleController.prototype.updateParent = function() {
      return this.trigger('update', this.rule);
    };

    RedesignConditionalFormattingRuleController.prototype.deleteClicked = function() {
      this.trigger('delete', this.rule);
      return this.release();
    };

    RedesignConditionalFormattingRuleController.prototype.conditionalOptions = function() {
      var c, i, j, len, len1, options, r, ref, ref1, subItems;
      options = [];
      ref = this.twiddles.get('column_names') || [];
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        subItems = [];
        ref1 = App.RedesignConditionalFormattingRuleController.RULES;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          r = ref1[j];
          subItems.push({
            name: r.name,
            serverValue: r.id + "!" + c,
            column: c,
            conditionId: r.id
          });
        }
        options.push({
          name: c,
          subItems: subItems
        });
      }
      return options;
    };

    RedesignConditionalFormattingRuleController.matchFirstRule = function(rules, column, columnValue, isNumeric) {
      var a, b, e, i, len, r;
      if (!((rules != null) && (column != null) && (columnValue != null))) {
        return null;
      }
      for (i = 0, len = rules.length; i < len; i++) {
        r = rules[i];
        if (!((r.value != null) && (r.column != null))) {
          continue;
        }
        if (r.column.toUpperCase() === column.toUpperCase()) {
          try {
            switch (r.conditionId) {
              case 'greaterThan':
                if (isNumeric) {
                  a = App.ChartUtils.numberFromNumberishString(columnValue);
                  b = App.ChartUtils.numberFromNumberishString(r.value);
                  if (a > b) {
                    return r;
                  }
                } else {
                  if (columnValue.toLowerCase() > r.value.toLowerCase()) {
                    return r;
                  }
                }
                break;
              case 'lessThan':
                if (isNumeric) {
                  a = App.ChartUtils.numberFromNumberishString(columnValue);
                  b = App.ChartUtils.numberFromNumberishString(r.value);
                  if (a < b) {
                    return r;
                  }
                } else {
                  if (columnValue.toLowerCase() < r.value.toLowerCase()) {
                    return r;
                  }
                }
                break;
              case 'equals':
                if (columnValue === r.value) {
                  return r;
                }
                break;
              case 'notEquals':
                if (columnValue !== r.value) {
                  return r;
                }
                break;
              case 'contains':
                if (columnValue.indexOf(r.value) !== -1) {
                  return r;
                }
                break;
              case 'notContains':
                if (columnValue.indexOf(r.value) === -1) {
                  return r;
                }
                break;
            }
          } catch (error) {
            e = error;
            AppRedesign.logError(e);
          }
        }
      }
      return null;
    };

    return RedesignConditionalFormattingRuleController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignConditionalFormattingRulesController = (function(superClass) {
    extend(RedesignConditionalFormattingRulesController, superClass);

    RedesignConditionalFormattingRulesController.prototype.className = 'conditional-formatting-rules';

    RedesignConditionalFormattingRulesController.prototype.elements = {
      '.rules-area': 'rulesAreaEl',
      '.move-delete-rules': 'moveDeleteButton'
    };

    RedesignConditionalFormattingRulesController.prototype.events = {
      'click .add-rule': 'addRuleClick',
      'click .move-delete-rules': 'toggleMoveMode',
      'click .back-to-rules': 'toggleMoveMode'
    };

    function RedesignConditionalFormattingRulesController() {
      this.ruleOrderUpdated = bind(this.ruleOrderUpdated, this);
      this.ruleDeleted = bind(this.ruleDeleted, this);
      this.ruleUpdated = bind(this.ruleUpdated, this);
      this.toggleMoveMode = bind(this.toggleMoveMode, this);
      this.addRuleClick = bind(this.addRuleClick, this);
      RedesignConditionalFormattingRulesController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.twiddles || (this.twiddles = App.TwiddleMap.readOnly({}));
      this.itemsToRelease = [];
      if (this.rules == null) {
        this.rules = [];
      }
      this.render();
    }

    RedesignConditionalFormattingRulesController.prototype.release = function() {
      var i, j, len, ref;
      ref = this.itemsToRelease;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.release();
      }
      this.itemsToRelease = null;
      this.rules = [];
      return RedesignConditionalFormattingRulesController.__super__.release.apply(this, arguments);
    };

    RedesignConditionalFormattingRulesController.prototype.newChartData = function(twiddles) {
      var i, j, len, ref;
      this.twiddles = twiddles;
      ref = this.itemsToRelease;
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.release();
      }
      this.itemsToRelease = [];
      return this.render();
    };

    RedesignConditionalFormattingRulesController.prototype.render = function() {
      var j, len, r, ref;
      this.html(this.view('redesign/editors/conditional_formatting_rules_frame')());
      ref = this.rules;
      for (j = 0, len = ref.length; j < len; j++) {
        r = ref[j];
        this.renderRule(r);
      }
      return this.rulesAreaEl.sortable({
        axis: 'y',
        handle: '.reorder-controls',
        containment: this.el.closest('.subheader-1'),
        update: this.ruleOrderUpdated
      });
    };

    RedesignConditionalFormattingRulesController.prototype.renderRule = function(rule) {
      var ruleController;
      ruleController = new App.RedesignConditionalFormattingRuleController({
        widget: this.widget,
        rule: rule,
        twiddles: this.twiddles
      });
      this.rulesAreaEl.append(ruleController.el);
      ruleController.bind('update', this.ruleUpdated);
      ruleController.bind('delete', this.ruleDeleted);
      this.itemsToRelease.push(ruleController);
      return this.updateDeleteButton();
    };

    RedesignConditionalFormattingRulesController.prototype.addRuleClick = function() {
      var r;
      r = {
        id: App.Utils.makeGuid()
      };
      this.rules.push(r);
      this.renderRule(r);
      this.rulesAreaEl.sortable("refresh");
      this.updateDeleteButton();
      return App.Utils.logFeature("add-conditional-formatting-rule", {
        widget_id: this.widget.id,
        dashboard_id: this.widget.dashboard_id
      });
    };

    RedesignConditionalFormattingRulesController.prototype.updateDeleteButton = function() {
      if (this.rules.length > 0) {
        return this.el.addClass('move-ok');
      } else {
        return this.el.removeClass('move-ok');
      }
    };

    RedesignConditionalFormattingRulesController.prototype.toggleMoveMode = function() {
      return this.el.toggleClass('reorder-mode');
    };

    RedesignConditionalFormattingRulesController.prototype.updateParent = function() {
      return this.trigger('update', this.rules);
    };

    RedesignConditionalFormattingRulesController.prototype.ruleUpdated = function(rule) {
      return this.updateParent();
    };

    RedesignConditionalFormattingRulesController.prototype.ruleDeleted = function(rule) {
      var r;
      this.rules = (function() {
        var j, len, ref, results;
        ref = this.rules;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          r = ref[j];
          if (r.id !== rule.id) {
            results.push(r);
          }
        }
        return results;
      }).call(this);
      if (this.rules.length === 0) {
        this.el.removeClass('reorder-mode');
      }
      this.updateDeleteButton();
      return this.updateParent();
    };

    RedesignConditionalFormattingRulesController.prototype.ruleOrderUpdated = function() {
      var j, k, len, len1, orderedRules, r, rId, ref, ruleIdsInDomOrder;
      ruleIdsInDomOrder = (function() {
        var j, len, ref, results;
        ref = this.rulesAreaEl.find('.rule');
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          r = ref[j];
          results.push($(r).attr('rule_id'));
        }
        return results;
      }).call(this);
      orderedRules = [];
      for (j = 0, len = ruleIdsInDomOrder.length; j < len; j++) {
        rId = ruleIdsInDomOrder[j];
        ref = this.rules;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          r = ref[k];
          if (r.id === rId) {
            orderedRules.push(r);
          }
        }
      }
      this.rules = orderedRules;
      return this.updateParent();
    };

    return RedesignConditionalFormattingRulesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ScatterSettings = (function(superClass) {
    extend(ScatterSettings, superClass);

    ScatterSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function ScatterSettings() {
      ScatterSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Scatter Settings'
      }));
      this.contentArea.append(this.createCheckbox('Show Trendlines', App.TwiddleConfig.TRENDLINE_ENABLED));
    }

    return ScatterSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  App.SeriesColumn = (function() {
    function SeriesColumn(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    SeriesColumn.prototype.setValue = function(columnName, checked) {
      var currentCols, i, len, ref, ref1, segmentCols;
      currentCols = this.widget.getArrayTwiddle('twiddle_segment_column').without('-1');
      if (!checked) {
        segmentCols = currentCols.without(columnName);
      } else {
        segmentCols = currentCols.concat(columnName).unique();
      }
      segmentCols = App.Utils.intersect(segmentCols, this.columnNames());
      if (!checked && segmentCols.isEmpty()) {
        this.widget.setTwiddle('twiddle_segment_column', '-1');
        ref = this.columnNames();
        for (i = 0, len = ref.length; i < len; i++) {
          columnName = ref[i];
          if (((ref1 = this.widget.twiddles.series) != null ? ref1[columnName] : void 0) != null) {
            delete this.widget.twiddles.series[columnName]['series_show_on_secondary_axis'];
          }
        }
      } else {
        this.widget.setTwiddle('twiddle_segment_column', segmentCols);
      }
      return this.setValueColumns(checked);
    };

    SeriesColumn.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('segment_column').includes(columnName);
    };

    SeriesColumn.prototype.columnNames = function() {
      return this.twiddlesActual.redesignGetArray(App.TwiddleConfig.COLUMN_NAMES);
    };

    SeriesColumn.prototype.setValueColumns = function(checked) {
      var columnName, i, len, ref, results, yAxisEnabledCols;
      yAxisEnabledCols = this.twiddlesActual.redesignGetArray('y_axis_enabled_columns');
      ref = this.columnNames();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        columnName = ref[i];
        if (yAxisEnabledCols.includes(columnName)) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', true);
          results.push(this.widget.setTwiddle('new_logic', true));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return SeriesColumn;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SeriesSettings = (function(superClass) {
    extend(SeriesSettings, superClass);

    SeriesSettings.prototype.elements = {
      '.content-area': 'contentArea',
      '.subheader-1': 'subheader1',
      '.expand': 'expandAllButton',
      '.content-area .rotator': 'rotators'
    };

    SeriesSettings.prototype.events = {
      'click .expand': 'toggleExpandAll',
      'click .content-area .rotator': 'resetExpandAll'
    };

    function SeriesSettings() {
      this.toggleExpandAll = bind(this.toggleExpandAll, this);
      SeriesSettings.__super__.constructor.apply(this, arguments);
      this.openRotators = [0];
      this.closed = false;
      this.mySeries = [];
    }

    SeriesSettings.prototype.rerender = function() {
      var columnName, extraSeries, i, isSegmented, j, len, seriesToDisplay, specificSeries, y_axis_columns;
      if (this.twiddlesActual == null) {
        return;
      }
      this.updateOpenRotators();
      this.closed = this.subheader1.hasClass('closed');
      this.html(this.view('redesign/editors/widgets/series_header')({
        title: 'Series',
        expandAll: true,
        geomap: this.chartTypeIs('geomap'),
        closed: this.closed
      }));
      isSegmented = !this.twiddlesActual.get('segment_column').isEmpty();
      if (isSegmented) {
        seriesToDisplay = this.twiddlesActual.getArray('series_names');
      } else {
        y_axis_columns = this.twiddlesActual.redesignGetArray('twiddle_y_axis_enabled_columns');
        seriesToDisplay = _.union(y_axis_columns, this.twiddlesActual.getArray('series_names'));
        extraSeries = _.filter(seriesToDisplay, (function(_this) {
          return function(series) {
            return !y_axis_columns.includes(series);
          };
        })(this));
      }
      for (i = j = 0, len = seriesToDisplay.length; j < len; i = ++j) {
        columnName = seriesToDisplay[i];
        if (!(columnName != null)) {
          continue;
        }
        specificSeries = new App.SpecificSeries({
          twiddlesActual: this.twiddlesActual,
          widget: this.widget,
          columnName: columnName,
          isExpanded: this.openRotators.includes(i),
          isSegmented: isSegmented,
          isExtraSeries: extraSeries != null ? extraSeries.includes(columnName) : void 0
        });
        this.contentArea.append(specificSeries.el);
        this.mySeries.push(specificSeries);
      }
      this.refreshElements();
      return this.resetExpandAll();
    };

    SeriesSettings.prototype.toggleExpandAll = function() {
      var j, len, ref, results, s;
      SeriesSettings.__super__.toggleExpandAll.apply(this, arguments);
      ref = this.mySeries;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        s = ref[j];
        results.push(s.renderOnce());
      }
      return results;
    };

    return SeriesSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SparklineSettings = (function(superClass) {
    extend(SparklineSettings, superClass);

    SparklineSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    function SparklineSettings() {
      SparklineSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget');
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Sparkline Settings'
      }));
      this.contentArea.append(this.createCheckbox('Show Cumulative', App.TwiddleConfig.OVERLAY_CUMULATIVE));
    }

    return SparklineSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SpecificSeries = (function(superClass) {
    extend(SpecificSeries, superClass);

    SpecificSeries.prototype.className = 'specific-series-container subheader-2 rotator';

    SpecificSeries.prototype.elements = {
      '.content-area': 'contentEl',
      '.attributes .plot-y-axis': 'plotOnYAxisEl',
      '.attributes .plot-y2-axis': 'plotOnY2AxisEl',
      '.chart-type-dropdown': 'chartTypeDropdown',
      '.color-picker-area': 'colorPickerArea'
    };

    SpecificSeries.prototype.events = {
      'click': 'renderOnce',
      'click .color-picker-area': 'clickedColorPicker',
      'change .chart-type-dropdown': 'chartTypeChanged',
      'mouseenter .column-name': 'fieldMouseEnter',
      'mouseleave .column-name': 'fieldMouseLeave'
    };

    SpecificSeries.CHART_DISPLAY_NAMES = {
      area: 'Area',
      column: 'Bar',
      line: 'Line',
      scatter: 'Scatter'
    };

    SpecificSeries.GEOMAP_PLOT_DISPLAY_NAMES = {
      points: 'Points',
      bubbles: 'Bubbles',
      heatmap: 'Heatmap',
      clusters: 'Clusters'
    };

    function SpecificSeries() {
      this.updateSelectedChartIcon = bind(this.updateSelectedChartIcon, this);
      this.chartTypeChanged = bind(this.chartTypeChanged, this);
      this.colorsUpdated = bind(this.colorsUpdated, this);
      SpecificSeries.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'twiddlesActual', 'widget', 'columnName', 'isExpanded', 'isSegmented');
      this.html(this.view('redesign/editors/widgets/specific_series')({
        columnName: this.columnName,
        color: this.getColor()
      }));
      this.el.toggleClass('closed', !this.isExpanded);
      if (this.isExpanded) {
        this.renderOnce();
      }
    }

    SpecificSeries.prototype.renderOnce = function() {
      var plotOnY2AxisSeries, plotOnYAxisSeries;
      if (this.rendered) {
        return;
      }
      this.rendered = true;
      this.contentEl.html(this.view('redesign/editors/widgets/specific_series_content')({
        columnName: this.columnName,
        color: this.getColor(),
        chartTypes: this.getChartTypes(),
        chartTypeDisabled: this.useMainChartType() || !(this.twiddlesActual.getForSeries(this.columnName, 'show_on_primary_axis') || this.twiddlesActual.getForSeries(this.columnName, 'show_on_secondary_axis')),
        chartTypeHidden: this.chartTypeIs(['bubble', 'pie']) || this.geojsonMapType(),
        plotOnY2Disabled: this.chartTypeIs(['bubble', 'sparkline', 'pie', 'geomap'])
      }));
      this.refreshElements();
      if (!(this.chartTypeIs(['bubble', 'geomap']) && !this.isSegmented)) {
        plotOnYAxisSeries = new App.PlotOnYAxisSeries(this.twiddlesActual, this.widget, this.isSegmented, this.isExtraSeries);
        this.plotOnYAxisEl.append(this.createCheckboxForSeries(this.columnName, plotOnYAxisSeries, this.plotLabel()));
      }
      if (!this.chartTypeIs(['bubble', 'sparkline', 'pie', 'geomap'])) {
        plotOnY2AxisSeries = new App.PlotOnY2AxisSeries(this.twiddlesActual, this.widget, this.isSegmented, this.isExtraSeries);
        this.plotOnY2AxisEl.append(this.createCheckboxForSeries(this.columnName, plotOnY2AxisSeries, 'Plot on Y2 Axis'));
      }
      if (!this.chartTypeIs(['bubble', 'pie'])) {
        this.chartTypeDropdown.val(this.getChartType());
        this.chartTypeDropdown.chosen({
          disable_search: true,
          width: '100%'
        });
      }
      this.currentlySelectedItem = this.chartTypeDropdown.siblings().find('a.chosen-single span');
      return this.updateSelectedChartIcon();
    };

    SpecificSeries.prototype.clickedColorPicker = function(e) {
      var ref;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      if ((ref = this.colorPicker) != null) {
        ref.release();
      }
      if (this.seriesIsPlotted()) {
        this.colorPicker = new App.SeriesColorPicker({
          targetCircle: $(e.currentTarget),
          titleColor: $(e.currentTarget).closest('.specific-series-container').find('.title-color'),
          colorToSet: App.ColorHelper.rgbToHex(this.getColor()),
          colorTheme: this.widget.colorTheme()
        });
        this.colorPicker.bind('update', this.colorsUpdated);
        return this.colorPickerArea.append(this.colorPicker.el);
      }
    };

    SpecificSeries.prototype.plotLabel = function() {
      if (this.geojsonMapType()) {
        return "Plot";
      }
      return "Plot on " + (this.yAxisName());
    };

    SpecificSeries.prototype.seriesIsPlotted = function() {
      return this.twiddlesActual.getForSeries(this.columnName, 'show_on_primary_axis') || this.twiddlesActual.getForSeries(this.columnName, 'show_on_secondary_axis');
    };

    SpecificSeries.prototype.getColor = function() {
      if (this.seriesIsPlotted()) {
        return App.ColorHelper.rgbToHex(this.twiddlesActual.getForSeries(this.columnName, 'color'));
      }
    };

    SpecificSeries.prototype.colorsUpdated = function(color) {
      this.widget.setSeriesTwiddle(this.columnName, 'color', color);
      this.setAllColors();
      return this.widget.trigger('settings-updated', false);
    };

    SpecificSeries.prototype.getChartType = function() {
      var chart_type;
      if (this.chartTypeIs(['geomap'])) {
        return this.geomapPlotModeForSeries(this.columnName);
      }
      if (this.useMainChartType()) {
        chart_type = this.widget.chart_type;
      }
      if (chart_type == null) {
        chart_type = this.twiddlesActual.getForSeries(this.columnName, 'chart_type');
      }
      if (chart_type == null) {
        chart_type = this.widget.getSeriesTwiddle(this.columnName, 'chart_type');
      }
      if (chart_type == null) {
        chart_type = this.widget.chart_type;
      }
      return chart_type;
    };

    SpecificSeries.prototype.useMainChartType = function() {
      return this.twiddlesActual.get('proportional') || this.twiddlesActual.get('horizontal') || this.chartTypeIs(['pie', 'bubble']);
    };

    SpecificSeries.prototype.getChartTypes = function() {
      if (this.chartTypeIs(['geomap'])) {
        return App.SpecificSeries.GEOMAP_PLOT_DISPLAY_NAMES;
      } else {
        return App.SpecificSeries.CHART_DISPLAY_NAMES;
      }
    };

    SpecificSeries.prototype.chartTypeChanged = function() {
      var seriesTwiddle;
      seriesTwiddle = this.chartTypeIs(['geomap']) ? 'geomap_plot_mode' : 'chart_type';
      this.widget.setSeriesTwiddle(this.columnName, seriesTwiddle, this.chartTypeDropdown.val());
      return this.widget.trigger('settings-updated');
    };

    SpecificSeries.prototype.yAxisName = function() {
      if (this.chartTypeIs(['geomap'])) {
        return 'Longitude';
      } else {
        return 'Y Axis';
      }
    };

    SpecificSeries.prototype.updateSelectedChartIcon = function() {
      return this.currentlySelectedItem.attr('data-chart-type', this.chartTypeDropdown.val());
    };

    return SpecificSeries;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableSeriesSettings = (function(superClass) {
    extend(TableSeriesSettings, superClass);

    TableSeriesSettings.prototype.elements = {
      '.attributes': 'attributes',
      '.right-panel-instructions': 'rightPanelInstructions',
      '.expand': 'expandAllButton',
      '.content-area .rotator': 'rotators'
    };

    TableSeriesSettings.prototype.events = {
      'change .textbox.column_width': 'columnWidthChange',
      'change .textbox.image_height': 'imageHeightChange',
      'change .textbox.image_width': 'imageWidthChange',
      'change .num_decimals input': 'numDecimalsChange',
      'click .expand': 'toggleExpandAll',
      'click .rotator': 'resetExpandAll'
    };

    function TableSeriesSettings() {
      this.toggleExpandAll = bind(this.toggleExpandAll, this);
      this.resetExpandAll = bind(this.resetExpandAll, this);
      this.chosenChanged = bind(this.chosenChanged, this);
      this.isFieldHidden = bind(this.isFieldHidden, this);
      this.isFieldDisabled = bind(this.isFieldDisabled, this);
      this.seriesNames = bind(this.seriesNames, this);
      TableSeriesSettings.__super__.constructor.apply(this, arguments);
      this.openRotators = [0];
    }

    TableSeriesSettings.prototype.rerender = function() {
      var c, decimalsByIdx, i, imageHeightByIdx, imageWidthByIdx, j, k, l, len, len1, len2, len3, m, ref, ref1, ref2, ref3, value, widthByIdx;
      if (this.widget.getTwiddle('twiddle_transpose_table')) {
        this.html(this.view('redesign/editors/widgets/no_settings')({
          errorText: 'Series settings are not available for transposed tables'
        }));
        this.rightPanelInstructions.show();
        return;
      }
      if (this.twiddlesActual == null) {
        return;
      }
      this.updateOpenRotators();
      widthByIdx = {};
      ref = this.seriesNames();
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        c = ref[i];
        value = this.widget.getColumnTwiddle(c, 'width');
        if (value != null) {
          widthByIdx[i] = value;
        }
      }
      imageHeightByIdx = {};
      ref1 = this.seriesNames();
      for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
        c = ref1[i];
        value = this.widget.getColumnTwiddle(c, 'image_height');
        if (value != null) {
          imageHeightByIdx[i] = value;
        }
      }
      imageWidthByIdx = {};
      ref2 = this.seriesNames();
      for (i = l = 0, len2 = ref2.length; l < len2; i = ++l) {
        c = ref2[i];
        value = this.widget.getColumnTwiddle(c, 'image_width');
        if (value != null) {
          imageWidthByIdx[i] = value;
        }
      }
      decimalsByIdx = {};
      ref3 = this.seriesNames();
      for (i = m = 0, len3 = ref3.length; m < len3; i = ++m) {
        c = ref3[i];
        if (this.isFieldDisabled(c, 'num_decimals')) {
          continue;
        }
        value = this.widget.getColumnTwiddle(c, 'num_decimals');
        if (value != null) {
          decimalsByIdx[i] = value;
        }
      }
      this.html(this.view('redesign/editors/widgets/table_series_settings')({
        twiddlesActual: this.twiddlesActual,
        widthByIdx: widthByIdx,
        imageHeightByIdx: imageHeightByIdx,
        imageWidthByIdx: imageWidthByIdx,
        decimalsByIdx: decimalsByIdx,
        isFieldDisabled: this.isFieldDisabled,
        isFieldHidden: this.isFieldHidden,
        openRotators: this.openRotators,
        seriesNames: this.seriesNames,
        singleCheckedPivotColumns: this.singleCheckedPivotColumns(),
        chartTypeIsCohort: this.chartTypeIs('cohort')
      }));
      this.addTotalCheckboxes();
      this.renderChosen();
      return this.resetExpandAll();
    };

    TableSeriesSettings.prototype.seriesNames = function() {
      if (this.chartTypeIs('table')) {
        return this.columnNames();
      }
      return _.union(this.twiddlesActual.redesignGetArray('point_cols'), this.twiddlesActual.redesignGetArray('value_cols'), this.twiddlesActual.redesignGetArray('detail_columns'), this.twiddlesActual.redesignGetArray('segment_column'));
    };

    TableSeriesSettings.prototype.singleCheckedPivotColumns = function() {
      return _.difference(this.twiddlesActual.redesignGetArray('segment_column'), this.twiddlesActual.redesignGetArray('point_cols'), this.twiddlesActual.redesignGetArray('value_cols'), this.twiddlesActual.redesignGetArray('detail_columns'));
    };

    TableSeriesSettings.prototype.addTotalCheckboxes = function() {
      var attributeSection, column, j, len, ref, results, totalColumnSeriesHelper;
      if (this.chartTypeIs('cohort')) {
        return;
      }
      totalColumnSeriesHelper = new App.TotalColumnSeries(this.twiddlesActual, this.widget);
      ref = this.attributes;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        attributeSection = ref[j];
        column = $(attributeSection).data('column');
        if (this.twiddlesActual.columnTableTotalEnabled(column)) {
          results.push($(attributeSection).append(this.createCheckboxForSeries(column, totalColumnSeriesHelper, 'Show Column Total')));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    TableSeriesSettings.prototype.columnFormat = function(column) {
      return this.twiddlesActual.getForColumn(column, 'value_format') || 'none';
    };

    TableSeriesSettings.prototype.isFieldDisabled = function(column, attribute) {
      if (attribute === 'currency') {
        return this.columnFormat(column) !== 'currency';
      }
      if (attribute === 'num_decimals') {
        return this.columnFormat(column) === 'none';
      }
      return false;
    };

    TableSeriesSettings.prototype.isFieldHidden = function(column, attribute) {
      var columnFormat;
      columnFormat = this.columnFormat(column);
      switch (attribute) {
        case 'image_height':
          return columnFormat !== 'image';
        case 'image_width':
          return columnFormat !== 'image';
        case 'column_width':
          return columnFormat === 'image';
        case 'num_decimals':
          return columnFormat === 'image';
        case 'alignment':
          return columnFormat === 'image';
        default:
          return false;
      }
    };

    TableSeriesSettings.prototype.renderChosen = function() {
      var attrId, column, elem, initialValue, isDisabled, j, jSelectEl, len, ref, results, selectEl;
      ref = this.$('.rotator:not(.closed) select:not(.chosen-added)');
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        selectEl = ref[j];
        jSelectEl = $(selectEl);
        jSelectEl.addClass('chosen-added');
        elem = jSelectEl.closest('.input');
        attrId = elem.attr('attr_id');
        column = jSelectEl.closest('.attributes').data('column');
        isDisabled = this.isFieldDisabled(column, attrId);
        initialValue = this.twiddlesActual.getForColumn(column, attrId);
        if (attrId === 'alignment') {
          initialValue = this.maybeAlignNumericColumn(column);
        }
        if (initialValue && !isDisabled) {
          jSelectEl.val(initialValue);
        }
        if (isDisabled) {
          jSelectEl.prop('disabled', true);
        }
        results.push(jSelectEl.chosen({
          disable_search: true,
          inherit_select_classes: true,
          width: '100%'
        }).on('change', this.chosenChanged));
      }
      return results;
    };

    TableSeriesSettings.prototype.maybeAlignNumericColumn = function(column) {
      var alignmentTwiddle, autoAlignRight;
      if (!column) {
        return;
      }
      alignmentTwiddle = this.twiddlesActual.getForColumn(column, 'alignment');
      autoAlignRight = this.twiddlesActual.getForColumn(column, 'type') === 'numeric' && (alignmentTwiddle == null);
      if (autoAlignRight) {
        return 'right';
      } else {
        return alignmentTwiddle;
      }
    };

    TableSeriesSettings.prototype.chosenChanged = function(e, chosenObject) {
      var attrId, column, elem;
      elem = $(e.target).closest('.input');
      column = this.columnForEvent(e);
      attrId = elem.attr('attr_id');
      this.widget.setColumnTwiddle(column, attrId, chosenObject.selected);
      if (chosenObject.selected === 'image') {
        this.widget.setColumnTwiddle(column, 'alignment', 'center');
        if (!this.widget.getColumnTwiddle(column, 'image_height')) {
          this.widget.setColumnTwiddle(column, 'image_height', App.RedesignTableChart.DEFAULT_ROW_HEIGHT);
        }
      }
      return this.widget.trigger('settings-updated');
    };

    TableSeriesSettings.prototype.columnForEvent = function(e) {
      return $(e.currentTarget.closest('.attributes')).data('column');
    };

    TableSeriesSettings.prototype.inputChange = function(e, twiddleName) {
      var column, value;
      value = parseInt(e.target.value);
      column = this.columnForEvent(e);
      if (isNaN(value)) {
        this.widget.deleteColumnTwiddle(column, twiddleName);
      } else {
        this.widget.setColumnTwiddle(column, twiddleName, value);
        if (twiddleName === 'image_width') {
          this.widget.setColumnTwiddle(column, 'width', value);
        }
      }
      return this.widget.trigger('settings-updated', twiddleName, value);
    };

    TableSeriesSettings.prototype.columnWidthChange = function(e) {
      return this.inputChange(e, 'width');
    };

    TableSeriesSettings.prototype.imageHeightChange = function(e) {
      return this.inputChange(e, 'image_height');
    };

    TableSeriesSettings.prototype.imageWidthChange = function(e) {
      return this.inputChange(e, 'image_width');
    };

    TableSeriesSettings.prototype.numDecimalsChange = function(e) {
      return this.inputChange(e, 'num_decimals');
    };

    TableSeriesSettings.prototype.resetExpandAll = function() {
      TableSeriesSettings.__super__.resetExpandAll.apply(this, arguments);
      return setTimeout((function(_this) {
        return function() {
          return _this.renderChosen();
        };
      })(this));
    };

    TableSeriesSettings.prototype.toggleExpandAll = function() {
      TableSeriesSettings.__super__.toggleExpandAll.apply(this, arguments);
      return setTimeout((function(_this) {
        return function() {
          return _this.renderChosen();
        };
      })(this));
    };

    return TableSeriesSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableSettings = (function(superClass) {
    extend(TableSettings, superClass);

    TableSettings.prototype.elements = {
      '.content-area': 'contentArea'
    };

    TableSettings.ALIGNMENT_OPTIONS = [
      {
        label: 'Center',
        value: 'center'
      }, {
        label: 'Fill',
        value: 'fill'
      }
    ];

    function TableSettings() {
      TableSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/header_only_settings')({
        title: 'Table Settings'
      }));
      this.contentArea.append(this.createCheckbox('Keep Table Column Underscores', App.TwiddleConfig.KEEP_TABLE_COLUMN_UNDERSCORES));
      if (!this.chartTypeIs(['cohort'])) {
        this.contentArea.append(this.createCheckbox('Transpose Table', App.TwiddleConfig.TRANSPOSE_TABLE));
      }
      this.contentArea.append(this.createCheckbox('Hide Table Line Numbers', App.TwiddleConfig.TABLE_LINE_NUMBERS));
      this.contentArea.append(this.createCheckbox('Remove Borders', App.TwiddleConfig.HIDE_TABLE_GRID_LINES));
      this.contentArea.append(this.createCheckbox('Align Table', App.TwiddleConfig.TABLE_ALIGNMENT_CHECKED));
      this.alignmentRadioGroup = this.createRadioGroup(App.TableSettings.ALIGNMENT_OPTIONS, 'center', App.TwiddleConfig.TABLE_ALIGNMENT);
      this.contentArea.append(this.alignmentRadioGroup);
      this.alignmentRadioGroup.addClass('one-indent');
    }

    TableSettings.prototype.rerender = function() {
      return this.alignmentRadioGroup.toggle(Boolean(this.getTwiddle(App.TwiddleConfig.TABLE_ALIGNMENT_CHECKED)));
    };

    return TableSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TextSettings = (function(superClass) {
    extend(TextSettings, superClass);

    TextSettings.prototype.elements = {
      '.right-panel-instructions': 'rightPanelInstructions'
    };

    function TextSettings() {
      TextSettings.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/editors/widgets/no_settings')({
        errorText: 'Series settings are not available for text charts'
      }));
      this.rightPanelInstructions.show();
    }

    return TextSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TooltipSettings = (function(superClass) {
    extend(TooltipSettings, superClass);

    TooltipSettings.prototype.elements = {
      '.tooltip-settings': 'tooltipSettings',
      '.tooltip-settings > .content-area': 'contentArea',
      '.subheader-2 > .content-area.fields': 'fields',
      '.subheader-2 > .content-area.series': 'series'
    };

    TooltipSettings.prototype.events = {
      'mouseenter .checkbox .label': 'fieldMouseEnter',
      'mouseleave .checkbox .label': 'fieldMouseLeave'
    };

    function TooltipSettings() {
      TooltipSettings.__super__.constructor.apply(this, arguments);
      this.firstRender = true;
    }

    TooltipSettings.prototype.rerender = function() {
      var noSegment;
      if (this.twiddlesActual == null) {
        return;
      }
      this.closed = this.firstRender || this.tooltipSettings.hasClass('closed');
      noSegment = this.twiddlesActual.get('segment_column').isEmpty();
      this.html(this.view('redesign/editors/widgets/tooltip_settings')({
        noSegment: noSegment,
        closed: this.closed
      }));
      if (!this.chartTypeIs(['bubble', 'pie'])) {
        this.contentArea.prepend(this.createCheckbox('Show Total in Tooltip', App.TwiddleConfig.TOOLTIP_TOTAL));
      }
      this.fields.append(this.createCheckboxesFromArray(App.TwiddleConfig.COLUMN_NAMES, App.TwiddleConfig.DETAIL_COLUMNS, false));
      if (!noSegment) {
        this.series.append(this.createCheckboxesFromArray(App.TwiddleConfig.SERIES_NAMES, App.TwiddleConfig.DETAIL_SERIES, false));
      }
      return this.firstRender = false;
    };

    return TooltipSettings;

  })(App.SettingsSubsection);

}).call(this);
(function() {
  App.TotalColumnSeries = (function() {
    function TotalColumnSeries(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    TotalColumnSeries.prototype.setValue = function(columnName, checked) {
      return this.widget.setColumnTwiddle(columnName, 'table_total_column', checked);
    };

    TotalColumnSeries.prototype.getValue = function(columnName) {
      return this.twiddlesActual.columnTableTotalChecked(columnName);
    };

    return TotalColumnSeries;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WeightColumn = (function(superClass) {
    extend(WeightColumn, superClass);

    function WeightColumn(twiddlesActual, widget, isSegmented) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
      this.isSegmented = isSegmented;
      WeightColumn.__super__.constructor.apply(this, arguments);
    }

    WeightColumn.prototype.setValue = function(columnName, checked) {
      var currentCols, newCols;
      currentCols = this.widget.getArrayTwiddle('twiddle_geomap_weight_columns');
      if (currentCols.length && currentCols[0] === '-1') {
        currentCols = [];
      }
      if (!currentCols.includes(columnName)) {
        newCols = currentCols.concat(columnName);
      } else {
        newCols = currentCols.without(columnName);
      }
      this.widget.setTwiddle('twiddle_geomap_weight_columns', newCols);
      return this.widget.setTwiddle('new_logic', true);
    };

    WeightColumn.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('geomap_weight_columns').includes(columnName);
    };

    return WeightColumn;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WidgetColorThemesController = (function(superClass) {
    extend(WidgetColorThemesController, superClass);

    WidgetColorThemesController.prototype.className = 'widget-color-theme';

    WidgetColorThemesController.prototype.elements = {
      '.color-theme-box.default': 'colorThemeBox',
      '.icon.expando': 'iconExpando',
      '.default-theme-container': 'defaultThemeContainer',
      '.top-label': 'topLabel'
    };

    WidgetColorThemesController.prototype.events = {
      'click .top-label': 'clickTopLabel',
      'click .color-theme-box .color-theme-row': 'selectColorTheme',
      'click': 'stopPropagation'
    };

    function WidgetColorThemesController() {
      this.renderColors = bind(this.renderColors, this);
      this.clickTopLabel = bind(this.clickTopLabel, this);
      this.render = bind(this.render, this);
      this.selectColorTheme = bind(this.selectColorTheme, this);
      this.updateTheme = bind(this.updateTheme, this);
      this.getOptions = bind(this.getOptions, this);
      this.release = bind(this.release, this);
      WidgetColorThemesController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'widget', 'defaultTheme', 'isCustomTheme');
      this.render();
    }

    WidgetColorThemesController.prototype.release = function() {
      this.unparentEl();
      return WidgetColorThemesController.__super__.release.apply(this, arguments);
    };

    WidgetColorThemesController.prototype.getOptions = function() {
      return App.ColorTheme.themeOptions(this.widget, this.widget.dashboard(), this.isCustomTheme);
    };

    WidgetColorThemesController.prototype.updateTheme = function(themeId, usePeriscopeTheme) {
      this.widget.default_color_theme_id = themeId;
      this.widget.use_periscope_theme = usePeriscopeTheme;
      return this.widget.trigger('theme-selected');
    };

    WidgetColorThemesController.prototype.setDefaultTheme = function() {
      var theme;
      theme = this.view('redesign/dashboard_preferences/widget_color_themes_row')({
        theme: this.defaultTheme,
        useParentTheme: (this.widget.default_color_theme_id == null) && !this.widget.use_periscope_theme,
        isCustomTheme: this.isCustomTheme
      });
      this.defaultThemeContainer.html(theme);
      return this.addBorders();
    };

    WidgetColorThemesController.prototype.selectColorTheme = function(e) {
      var id, theme, usePeriscopeTheme;
      App.Utils.logFeature('color-theme-chart-change');
      theme = $(e.currentTarget).data('widget');
      id = theme.newDefaultColorThemeIdForWidget;
      usePeriscopeTheme = theme.usePeriscopeTheme;
      return this.updateTheme(id, usePeriscopeTheme);
    };

    WidgetColorThemesController.prototype.render = function() {
      this.html(this.view('redesign/widgets/widget_color_themes')({
        defaultTheme: this.defaultTheme,
        useParentTheme: (this.widget.default_color_theme_id == null) && !this.widget.use_periscope_theme,
        isCustomTheme: this.isCustomTheme
      }));
      return this.addBorders();
    };

    WidgetColorThemesController.prototype.addBorders = function() {
      var squares;
      squares = $(this.el).find('.color-square.dashboard');
      return $(squares).each(function() {
        return App.ColorHelper.toggleBorderClassOnColorLightness($(this), $(this).css('background-color'), 'show-border', 200);
      });
    };

    WidgetColorThemesController.prototype.renderContent = function() {
      this.render();
      this.renderColors();
      this.setDefaultTheme();
      return this.reparentEl();
    };

    WidgetColorThemesController.prototype.clickTopLabel = function() {
      if (this.isOpen()) {
        return this.unparentEl();
      } else {
        return this.renderContent();
      }
    };

    WidgetColorThemesController.prototype.reparentEl = function() {
      this.el.addClass('open');
      this.placeholder = $('<div class="reparent-placeholder"/>').css({
        height: this.topLabel.outerHeight(),
        width: this.topLabel.outerWidth()
      });
      this.reparentContainer = $('<div class="widget-color-theme reparent-container widget-editor-color-theme"/>').css({
        'top': this.el.offset().top - $('.chart-format-wrapper').offset().top,
        'left': this.el.offset().left - $('.chart-format-wrapper').offset().left
      });
      $('.widget-color-container').after(this.reparentContainer);
      this.reparentContainer.append(this.el.before(this.placeholder).detach());
      return this.reparentContainer.css({
        'height': $('.body.widget-color-theme.open').height()
      });
    };

    WidgetColorThemesController.prototype.unparentEl = function() {
      if (this.reparentContainer == null) {
        return;
      }
      this.el.removeClass('open');
      this.el = this.reparentContainer.detach().contents();
      return this.placeholder.replaceWith(this.el);
    };

    WidgetColorThemesController.prototype.renderColors = function() {
      var i, len, option, optionRow, optionRowWithData, ref, results;
      ref = this.getOptions();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        optionRow = this.view('redesign/dashboard_preferences/widget_color_themes_row')({
          usePeriscopeDefault: option.usePeriscopeTheme,
          theme: option.theme,
          useParentTheme: option.useParentTheme
        });
        optionRowWithData = $(optionRow).data({
          'widget': {
            newDefaultColorThemeIdForWidget: option.id,
            usePeriscopeTheme: option.usePeriscopeTheme
          }
        });
        this.colorThemeBox.append(optionRowWithData);
        results.push(this.addBorders());
      }
      return results;
    };

    WidgetColorThemesController.prototype.isOpen = function() {
      return this.el.hasClass('open');
    };

    WidgetColorThemesController.prototype.stopPropagation = function(e) {
      return e.stopPropagation();
    };

    return WidgetColorThemesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WidgetSettingsController = (function(superClass) {
    extend(WidgetSettingsController, superClass);

    WidgetSettingsController.prototype.className = 'chart-format-wrapper';

    WidgetSettingsController.prototype.elements = {
      '.chart-type-dropdown-area': 'chartTypeDropdownArea',
      '.main-content-area': 'mainContentArea',
      '.right-panel-instructions': 'rightPanelInstructions'
    };

    WidgetSettingsController.prototype.events = {
      'click .rotator-title': 'clickedRotators'
    };

    WidgetSettingsController.CHART_FORMAT_SETTINGS = {
      subsections: {
        table: ['TableSettings', 'ColorThemeSettings', 'ColorSettings', 'ConditionalFormattingSettings', 'DataBarsSettings', 'AdvancedSettings'],
        line: ['LineSettings', 'AxesSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        column: ['BarSettings', 'AxesSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        bignumber: ['NumberOverlaySettings', 'AxesSettings', 'LegendSettings', 'ConditionalFormattingSettings', 'MiscSettings', 'AdvancedSettings'],
        pie: ['LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        area: ['AreaSettings', 'AxesSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        cohort: ['CohortSettings', 'TableSettings', 'ColorThemeSettings', 'ColorSettings', 'ConditionalFormattingSettings', 'DataBarsSettings', 'AdvancedSettings'],
        geomap: ['MapDisplaySettings', 'MapTitleSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        sparkline: ['SparklineSettings', 'AxesSettings', 'LegendSettings', 'ConditionalFormattingSettings', 'MiscSettings', 'AdvancedSettings'],
        scatter: ['ScatterSettings', 'AxesSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        bubble: ['AxesSettings', 'LegendSettings', 'MiscSettings', 'AdvancedSettings'],
        image: ['AdvancedSettings'],
        codeimage: ['AdvancedSettings'],
        codetext: ['AdvancedSettings']
      },
      title: "Format Chart"
    };

    WidgetSettingsController.SERIES_SETTINGS = {
      subsections: {
        table: ['TableSeriesSettings'],
        line: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        column: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        bignumber: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        pie: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        area: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        cohort: ['CohortSeriesSettings', 'TableSeriesSettings'],
        geomap: ['MapDataSettings', 'FieldSettings', 'SeriesSettings', 'TooltipSettings'],
        sparkline: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        scatter: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        bubble: ['FieldSettings', 'ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        image: ['ImageSettings'],
        codeimage: ['ImageSettings'],
        codetext: ['TextSettings']
      },
      title: "Series Settings"
    };

    WidgetSettingsController.SERIES_SETTINGS_FOR_DRAGDROP = {
      subsections: {
        table: ['TableSeriesSettings'],
        line: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        column: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        bignumber: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        pie: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        area: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        cohort: ['TableSeriesSettings'],
        geomap: ['SeriesSettings', 'TooltipSettings'],
        sparkline: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        scatter: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        bubble: ['ColorThemeSettings', 'SeriesSettings', 'TooltipSettings'],
        image: ['ImageSettings'],
        codeimage: ['ImageSettings'],
        codetext: ['TextSettings']
      },
      title: "Series Settings"
    };

    WidgetSettingsController.RUN_QUERY_MSG = 'Run query to customize chart settings';

    WidgetSettingsController.NO_ROW_MSG = 'Query returned no results';

    WidgetSettingsController.CODE_NO_ROW_MSG = 'No available settings to configure';

    WidgetSettingsController.NUM_OPEN_SECTIONS = 2;

    function WidgetSettingsController() {
      this.cleanupBeforeSave = bind(this.cleanupBeforeSave, this);
      this.chartTypeRefresh = bind(this.chartTypeRefresh, this);
      this.chartTypeChanged = bind(this.chartTypeChanged, this);
      this.clickedRotators = bind(this.clickedRotators, this);
      this.render = bind(this.render, this);
      this.formulaSourceUpdated = bind(this.formulaSourceUpdated, this);
      this.newChartDataAvailable = bind(this.newChartDataAvailable, this);
      this.updateSourceType = bind(this.updateSourceType, this);
      this.changeCurrentChartType = bind(this.changeCurrentChartType, this);
      this.updateItem = bind(this.updateItem, this);
      this.updateChartPickerFromSourceType = bind(this.updateChartPickerFromSourceType, this);
      this.release = bind(this.release, this);
      WidgetSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item', 'type', 'editHelper');
      this.widget = this.item;
      this.html(this.view('redesign/editors/widgets/chart_settings')({
        title: this.getWidgetSettings().title
      }));
      this.chartPicker = new App.RedesignChartPicker({
        widget: this.item
      });
      this.chartTypeDropdownArea.append(this.chartPicker.el);
      this.toggleChartTypeDropdownArea();
      this.updateSourceType();
      this.showNoQueryResult();
      this.setUpSections();
      this.chartPicker.bind('chart-type-changed', this.chartTypeChanged);
      this.widget.bind('chart-type-refresh', this.chartTypeRefresh);
      this.widget.bind('new-chart-data', this.newChartDataAvailable);
      App.SourceFetcher.bind('source-updated', this.formulaSourceUpdated);
      this.widget.bind('beforeSave', this.cleanupBeforeSave);
      this.editHelper.bind('update', this.updateItem);
      this.editHelper.bind('drag-drop-changed-chart-type', this.changeCurrentChartType);
      if (!AppRedesign.current().deepAnalysisEnabled) {
        if (this.widget.chart_type === 'codetext' || this.widget.chart_type === 'codeimage') {
          this.chartPicker.defaultChartTypeChanged('table');
        }
      }
    }

    WidgetSettingsController.prototype.getWidgetSettings = function() {
      var seriesSetting, widgetSettings;
      if (this.showSettingsForDragDrop()) {
        seriesSetting = App.WidgetSettingsController.SERIES_SETTINGS_FOR_DRAGDROP;
      } else {
        seriesSetting = App.WidgetSettingsController.SERIES_SETTINGS;
      }
      widgetSettings = this.type === 'ChartFormat' ? App.WidgetSettingsController.CHART_FORMAT_SETTINGS : seriesSetting;
      return widgetSettings;
    };

    WidgetSettingsController.prototype.showSettingsForDragDrop = function() {
      return App.DragDropSeriesHelper.isDragDropWidget(this.widget) && AppRedesign.dragDropEnabled();
    };

    WidgetSettingsController.prototype.release = function() {
      this.chartPicker.unbind('chart-type-changed', this.chartTypeChanged);
      this.widget.unbind('chart-type-refresh', this.chartTypeRefresh);
      this.widget.unbind('new-chart-data', this.newChartDataAvailable);
      this.editHelper.unbind('update', this.updateItem);
      this.editHelper.unbind('drag-drop-changed-chart-type', this.changeCurrentChartType);
      App.SourceFetcher.unbind('source-updated', this.formulaSourceUpdated);
      this.chartPicker.release();
      return this.releaseSubsections();
    };

    WidgetSettingsController.prototype.releaseSubsections = function() {
      var controller, name, ref, results;
      this.widget.unbind('beforeSave', this.cleanupBeforeSave);
      if (this.subsectionControllers == null) {
        return;
      }
      ref = this.subsectionControllers;
      results = [];
      for (name in ref) {
        controller = ref[name];
        results.push(controller.release());
      }
      return results;
    };

    WidgetSettingsController.prototype.updateChartPickerFromSourceType = function() {
      this.chartPicker.el.remove();
      this.chartPicker.unbind('chart-type-changed', this.chartTypeChanged);
      this.chartPicker.release();
      this.chartPicker = new App.RedesignChartPicker({
        widget: this.item
      });
      this.chartTypeDropdownArea.append(this.chartPicker.el);
      this.toggleChartTypeDropdownArea();
      return this.chartPicker.bind('chart-type-changed', this.chartTypeChanged);
    };

    WidgetSettingsController.prototype.usesCodeSource = function() {
      return AppRedesign.current().deepAnalysisEnabled && (this.item.code != null);
    };

    WidgetSettingsController.prototype.updateItem = function() {
      if (this.widget.code != null) {
        return;
      }
      this.updateSourceType();
      if (this.widget.chart_type === 'codetext' || this.widget.chart_type === 'codeimage') {
        this.chartPicker.defaultChartTypeChanged('table');
      }
      return this.refresh();
    };

    WidgetSettingsController.prototype.changeCurrentChartType = function(chartType) {
      return this.chartPicker.defaultChartTypeChanged(chartType);
    };

    WidgetSettingsController.prototype.updateSourceType = function() {
      if (this.usesCodeSource()) {
        if (!this.chartTypeDropdownArea.hasClass('code-source')) {
          this.chartTypeDropdownArea.addClass("code-source");
          return this.updateChartPickerFromSourceType();
        }
      } else {
        if (this.chartTypeDropdownArea.hasClass('code-source')) {
          this.chartTypeDropdownArea.removeClass("code-source");
          return this.updateChartPickerFromSourceType();
        }
      }
    };

    WidgetSettingsController.prototype.refresh = function() {
      this.toggleChartTypeDropdownArea();
      return this.showNoQueryResult();
    };

    WidgetSettingsController.prototype.toggleChartTypeDropdownArea = function() {
      var ref;
      return (ref = this.chartPicker) != null ? ref.el.toggle(!this.showSettingsForDragDrop()) : void 0;
    };

    WidgetSettingsController.prototype.newChartDataAvailable = function(_, chartData) {
      if (chartData.twiddlesActual == null) {
        return this.displayError(this.constructor.NO_ROW_MSG);
      } else {
        return this.removeErrorMsg();
      }
    };

    WidgetSettingsController.prototype.removeErrorMsg = function() {
      this.el.removeClass('display-code-source-error');
      return this.el.removeClass('display-error');
    };

    WidgetSettingsController.prototype.updateDefaultChartType = function(fs) {
      var default_chart_type;
      default_chart_type = App.ChartUtils.getDefaultChartType(fs.getDataType());
      if (App.ChartUtils.isCodeChart(fs.getDataType())) {
        this.widget.setTwiddle('use_default_chart_type', true);
      }
      if (this.widget.chart_type !== default_chart_type && this.widget.getTwiddle('use_default_chart_type')) {
        return this.chartPicker.defaultChartTypeChanged(default_chart_type);
      }
    };

    WidgetSettingsController.prototype.formulaSourceUpdated = function(fs) {
      if (!(fs.hash_key === this.widget.hashKey() && fs.isCompletelyLoaded())) {
        return;
      }
      this.updateSourceType();
      if (AppRedesign.current().deepAnalysisEnabled && (this.item.code != null)) {
        this.updateDefaultChartType(fs);
      }
      if (this.widget.hasData() && !this.widget.hasError()) {
        return this.removeErrorMsg();
      } else {
        return this.displayError(this.constructor.RUN_QUERY_MSG);
      }
    };

    WidgetSettingsController.prototype.showNoQueryResult = function() {
      if (this.widget.hasData() && !this.widget.hasError()) {
        if (this.widget.empty()) {
          this.displayError(this.constructor.NO_ROW_MSG);
          return true;
        }
      } else {
        this.displayError(this.constructor.RUN_QUERY_MSG);
        return true;
      }
      this.removeErrorMsg();
      return false;
    };

    WidgetSettingsController.prototype.displayError = function(errorText) {
      if (this.usesCodeSource()) {
        this.rightPanelInstructions.text(this.constructor.CODE_NO_ROW_MSG);
        return this.el.addClass('display-code-source-error');
      } else {
        this.rightPanelInstructions.text(errorText);
        return this.el.addClass('display-error');
      }
    };

    WidgetSettingsController.prototype.setUpSections = function() {
      var i, len, subsection, subsectionController, subsections;
      subsections = this.getWidgetSettings().subsections[this.widget.chart_type];
      if (subsections == null) {
        return;
      }
      this.releaseSubsections();
      this.subsectionControllers = {};
      for (i = 0, len = subsections.length; i < len; i++) {
        subsection = subsections[i];
        subsectionController = new App[subsection]({
          widget: this.widget,
          subsectionName: subsection
        });
        this.mainContentArea.append(subsectionController.el);
        this.subsectionControllers[subsection] = subsectionController;
      }
      return this.el.find(".subheader-1.rotator").slice(this.constructor.NUM_OPEN_SECTIONS).addClass('closed');
    };

    WidgetSettingsController.prototype.render = function() {
      return this.renderOpenSubsections();
    };

    WidgetSettingsController.prototype.renderOpenSubsections = function() {
      var i, len, ref, results, rotator;
      ref = this.el.find(".subheader-1.rotator:not(.closed)");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        rotator = ref[i];
        results.push(this.renderSubsectionOnce($(rotator)));
      }
      return results;
    };

    WidgetSettingsController.prototype.clickedRotators = function(evt) {
      var rotator;
      rotator = $(evt.target).closest('.rotator');
      rotator.toggleClass('closed');
      return this.renderSubsectionOnce(rotator);
    };

    WidgetSettingsController.prototype.renderSubsectionOnce = function(rotator) {
      var ref, subsectionName;
      subsectionName = rotator.data('subsection-name');
      return (ref = this.subsectionControllers[subsectionName]) != null ? ref.renderOnce() : void 0;
    };

    WidgetSettingsController.prototype.chartTypeChanged = function(chartType) {
      this.widget.chart_type = chartType;
      this.mainContentArea.empty();
      this.resetTwiddles(chartType);
      this.setUpSections();
      return this.renderOpenSubsections();
    };

    WidgetSettingsController.prototype.chartTypeRefresh = function(widget, chartType) {
      this.widget.chart_type = chartType;
      this.mainContentArea.empty();
      this.setUpSections();
      return this.renderOpenSubsections();
    };

    WidgetSettingsController.prototype.resetTwiddles = function(chartType) {
      if ((this.widget.chart_type !== 'table' && chartType !== 'table') || (this.lastTypeNotTable && this.widget.chart_type === 'table' && this.lastTypeNotTable !== chartType)) {
        this.widget.setAllSeriesTwiddle('chart_type', null);
      }
      if (App.ChartUtils.CHART_TYPES_X_Y_POINT.includes(this.widget.chart_type) && chartType !== 'table') {
        this.widget.setTwiddle('twiddle_point_cols', []);
      }
      if (chartType !== 'table') {
        this.lastTypeNotTable = chartType;
      }
      if (chartType === 'table') {
        if (this.lastPivotSettings != null) {
          return this.widget.setTwiddle('twiddle_use_pivot_settings', this.lastPivotSettings);
        }
      } else {
        this.lastPivotSettings = this.widget.getTwiddle('twiddle_use_pivot_settings');
        return this.widget.setTwiddle('twiddle_use_pivot_settings', false);
      }
    };

    WidgetSettingsController.prototype.cleanupBeforeSave = function() {
      var controller, name, ref, results;
      if (this.subsectionControllers == null) {
        return;
      }
      ref = this.subsectionControllers;
      results = [];
      for (name in ref) {
        controller = ref[name];
        results.push(controller.cleanupBeforeSave());
      }
      return results;
    };

    return WidgetSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.XAxisColumn = (function(superClass) {
    extend(XAxisColumn, superClass);

    function XAxisColumn(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
      XAxisColumn.__super__.constructor.apply(this, arguments);
    }

    XAxisColumn.prototype.setValue = function(value) {
      var pointCols;
      if (this.twiddlesActual.redesignGetArray('twiddle_point_cols')[0] === value) {
        return;
      }
      this.disableSegmentationIfAutoSelected(value);
      if (this.xyPointChart()) {
        pointCols = this.widget.getArrayTwiddle('twiddle_point_cols');
        if (pointCols.length < 1) {
          pointCols = this.twiddlesActual.get('point_cols');
        }
        pointCols[0] = value;
      } else {
        pointCols = [value];
      }
      this.widget.setTwiddle('twiddle_point_cols', pointCols);
      return this.widget.setTwiddle('new_logic', true);
    };

    XAxisColumn.prototype.getValue = function() {
      return this.twiddlesActual.redesignGetArray('twiddle_point_cols')[0];
    };

    return XAxisColumn;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.YAxisColumn = (function(superClass) {
    extend(YAxisColumn, superClass);

    function YAxisColumn(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    YAxisColumn.prototype.setValue = function(columnName, checked) {
      var yAxisEnabledCols;
      this.disableSegmentationIfAutoSelected(columnName);
      yAxisEnabledCols = this.widget.getArrayTwiddle('twiddle_y_axis_enabled_columns');
      if (checked) {
        yAxisEnabledCols = _.union(yAxisEnabledCols, [columnName]);
      } else {
        _.pull(yAxisEnabledCols, columnName);
      }
      this.widget.setTwiddle('twiddle_y_axis_enabled_columns', yAxisEnabledCols);
      if (this.twiddlesActual.getForColumn(columnName, 'use_as_value') === void 0) {
        if (checked) {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
          this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', true);
          this.widget.setSeriesTwiddle(columnName, 'show_on_secondary_axis', false);
        } else {
          this.widget.setColumnTwiddle(columnName, 'use_as_value', false);
          this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', false);
          this.widget.setSeriesTwiddle(columnName, 'show_on_secondary_axis', false);
        }
        return this.widget.setTwiddle('new_logic', true);
      }
    };

    YAxisColumn.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('y_axis_enabled_columns').includes(columnName);
    };

    return YAxisColumn;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.YAxisColumnForXYPointChart = (function(superClass) {
    extend(YAxisColumnForXYPointChart, superClass);

    function YAxisColumnForXYPointChart(twiddlesActual, widget) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
    }

    YAxisColumnForXYPointChart.prototype.setValue = function(columnName, checked) {
      var pointCols;
      this.disableSegmentationIfAutoSelected(columnName);
      pointCols = this.widget.getArrayTwiddle('twiddle_point_cols');
      if (pointCols.length < 1) {
        pointCols = this.twiddlesActual.get('point_cols');
      }
      pointCols[1] = columnName;
      return this.widget.setTwiddle('twiddle_point_cols', pointCols);
    };

    YAxisColumnForXYPointChart.prototype.getValue = function(columnName) {
      var pointCols;
      pointCols = this.twiddlesActual.redesignGetArray('point_cols');
      return pointCols[1];
    };

    return YAxisColumnForXYPointChart;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ZAxisColumn = (function(superClass) {
    extend(ZAxisColumn, superClass);

    function ZAxisColumn(twiddlesActual, widget, isSegmented) {
      this.twiddlesActual = twiddlesActual;
      this.widget = widget;
      this.isSegmented = isSegmented;
      ZAxisColumn.__super__.constructor.apply(this, arguments);
    }

    ZAxisColumn.prototype.setValue = function(columnName, checked) {
      var i, j, len, len1, ref, ref1, series;
      this.disableSegmentationIfAutoSelected(columnName);
      ref = this.columnNames();
      for (i = 0, len = ref.length; i < len; i++) {
        series = ref[i];
        this.widget.setColumnTwiddle(series, 'use_as_value', false);
      }
      this.widget.setColumnTwiddle(columnName, 'use_as_value', true);
      if (!this.isSegmented) {
        ref1 = this.columnNames();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          series = ref1[j];
          this.widget.setSeriesTwiddle(series, 'show_on_primary_axis', false);
        }
        this.widget.setSeriesTwiddle(columnName, 'show_on_primary_axis', true);
      }
      return this.widget.setTwiddle('new_logic', true);
    };

    ZAxisColumn.prototype.getValue = function(columnName) {
      return this.twiddlesActual.redesignGetArray('value_cols')[0];
    };

    return ZAxisColumn;

  })(App.SeriesHelper);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ElementReparenter = (function(superClass) {
    extend(ElementReparenter, superClass);

    ElementReparenter.prototype.events = {
      click: 'stopPropagation'
    };

    function ElementReparenter() {
      this.unparentEl = bind(this.unparentEl, this);
      this.resize = bind(this.resize, this);
      ElementReparenter.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
    }

    ElementReparenter.prototype.stopPropagation = _.method('stopPropagation');

    ElementReparenter.prototype.reparentEl = function() {
      return this.reparentElWithClassname('');
    };

    ElementReparenter.prototype.reparentElWithClassname = function(className) {
      var dialog, ref, relativeX, relativeY;
      this.el.addClass('open');
      this.placeholder = $('<div class="reparent-placeholder"/>');
      dialog = this.el.closest('#dialogs');
      relativeX = this.el.offset().left;
      relativeY = this.el.offset().top;
      if (dialog.length && (dialog.offset() != null)) {
        relativeX = relativeX - dialog.offset().left;
        relativeY = relativeY - dialog.offset().top;
      }
      this.reparentContainer = $("<div class='reparent-container " + className + "'/>").css({
        top: relativeY,
        left: relativeX
      });
      this.reparentContainer.css({
        width: this.el.width()
      });
      $('.dashboard-preferences-container').after(this.reparentContainer);
      this.reparentContainer.append(this.el.before(this.placeholder).detach());
      $(window).one('resize', this.resize);
      if ((ref = this.scrollEl) != null) {
        ref.one('scroll', this.unparentEl);
      }
      return $('#body').on('click', this.unparentEl);
    };

    ElementReparenter.prototype.reparented = function() {
      return this.reparentContainer != null;
    };

    ElementReparenter.prototype.resize = function() {
      if (typeof this.resizeCallback === "function") {
        this.resizeCallback();
      }
      return this.unparentEl();
    };

    ElementReparenter.prototype.unparentEl = function() {
      var el;
      if (!this.reparented()) {
        return;
      }
      this.el.removeClass('open');
      $('#body').off('click', this.unparentEl);
      el = this.reparentContainer.detach().contents();
      this.placeholder.replaceWith(el);
      if (typeof this.unparentCallback === "function") {
        this.unparentCallback();
      }
      return this.reparentContainer = null;
    };

    return ElementReparenter;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.EmptyBoxController = (function(superClass) {
    extend(EmptyBoxController, superClass);

    EmptyBoxController.prototype.elements = {
      '.react-div': 'reactDiv'
    };

    function EmptyBoxController() {
      this.repositionChart = bind(this.repositionChart, this);
      this.resizeCharts = bind(this.resizeCharts, this);
      EmptyBoxController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.html(this.view('redesign/dashboards/empty_box')());
      this.reactRoot = window.reactApp.emptyBoxRoot(this.reactDiv[0], this.item.id);
    }

    EmptyBoxController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return EmptyBoxController.__super__.release.apply(this, arguments);
    };

    EmptyBoxController.prototype.resizeCharts = function() {};

    EmptyBoxController.prototype.repositionChart = function() {};

    EmptyBoxController.prototype.renderIfInViewport = function() {};

    EmptyBoxController.prototype.update = function() {};

    EmptyBoxController.prototype.changedSize = function() {};

    EmptyBoxController.prototype.returnToUnrenderedState = function() {};

    return EmptyBoxController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FileDownloadsController = (function(superClass) {
    extend(FileDownloadsController, superClass);

    FileDownloadsController.LONG_COLLAPSE_TIMEOUT = 1000;

    FileDownloadsController.COLLAPSE_TIMEOUT = 500;

    FileDownloadsController.HEADER_LAG = 250;

    FileDownloadsController.REFRESH_INTERVAL = 2000;

    FileDownloadsController.SOURCE_POLL_INTERVAL = 1000;

    FileDownloadsController.prototype.elements = {
      '.modal.file-downloads': 'panel',
      '.modal.file-downloads header': 'panelHeader',
      '.download-row.error .status-icon': 'errorIcons',
      '.download-row .item .name-label': 'downloadTitle'
    };

    FileDownloadsController.prototype.events = {
      'mouseenter .modal.file-downloads': 'startRefresh',
      'mouseleave .modal.file-downloads': 'stopRefresh',
      'click .download-row .cancel-icon': 'cancelClicked',
      'click .download-row .download-icon a': 'clearDownloadRow'
    };

    function FileDownloadsController() {
      this.checkSourceStatus = bind(this.checkSourceStatus, this);
      this.itemLoaded = bind(this.itemLoaded, this);
      this.fetchSourcesAndExpand = bind(this.fetchSourcesAndExpand, this);
      this.titleInfo = bind(this.titleInfo, this);
      this.errorInfo = bind(this.errorInfo, this);
      this.clearDownloadRow = bind(this.clearDownloadRow, this);
      this.cancelClicked = bind(this.cancelClicked, this);
      this.collapseTab = bind(this.collapseTab, this);
      this.cidAndItemType = bind(this.cidAndItemType, this);
      this.stopRefresh = bind(this.stopRefresh, this);
      this.startRefresh = bind(this.startRefresh, this);
      this.renderAndCollapse = bind(this.renderAndCollapse, this);
      this.pdfDownloadUpdated = bind(this.pdfDownloadUpdated, this);
      this.fileDownloadUpdated = bind(this.fileDownloadUpdated, this);
      this.sqlViewDataExportUpdated = bind(this.sqlViewDataExportUpdated, this);
      this.render = bind(this.render, this);
      FileDownloadsController.__super__.constructor.apply(this, arguments);
      this._items_pending_sources = [];
      this._local_download_cache = [];
      this._items_pending_cancel = [];
      this.pendingSources = true;
      this.el.appendTo('.sticky-footer-panels');
      this.html(this.view('redesign/file_downloads/panel')());
      App.Dashboard.one('remaining-state-loaded', this.fetchSourcesAndExpand);
      App.FileDownload.bind('create destroy', this.renderAndCollapse);
      App.FileDownload.bind('update source-updated', this.fileDownloadUpdated);
      App.SqlViewDataExport.bind('create update destroy', this.sqlViewDataExportUpdated);
      App.PdfDownload.bind('create destroy', this.renderAndCollapse);
      App.PdfDownload.bind('update', this.pdfDownloadUpdated);
    }

    FileDownloadsController.prototype.render = function() {
      if (this.tooltipDisplaying()) {
        return;
      }
      this.downloadItems = this.allItemsForDisplay();
      this.downloadAwaitingItems();
      this.panel.addClass('invisible');
      if (_.isEmpty(this.downloadItems)) {
        return;
      }
      this.panel.html(this.view('redesign/file_downloads/form')({
        items: this.downloadItems
      }));
      this.refreshElements();
      this.renderHeader();
      this.markOverflownTitles();
      this.errorTooltipHelper = new App.IconTooltipHelper({
        icon: this.errorIcons,
        infoCallback: this.errorInfo,
        parentSelector: '.sticky-footer-panel',
        direction: App.RedesignTooltipPanel.BOTTOM,
        tooltipWidth: 200
      });
      this.titleTooltipHelper = new App.IconTooltipHelper({
        icon: this.downloadTitle,
        infoCallback: this.titleInfo,
        direction: App.RedesignTooltipPanel.BOTTOM,
        parentSelector: '.sticky-footer-panel',
        leftOffset: 150
      });
      return this.panel.removeClass('invisible collapsed');
    };

    FileDownloadsController.prototype.renderHeader = function(cancelled) {
      if (cancelled == null) {
        cancelled = false;
      }
      this.panelHeader.html(this.view('redesign/file_downloads/download_header')({
        items: this.allItemsForDisplay(),
        state: this.getHeaderInfo(cancelled)
      }));
      return this.refreshElements();
    };

    FileDownloadsController.prototype.sqlViewDataExportUpdated = function(viewDataExport) {
      return this.renderAndCollapse(true);
    };

    FileDownloadsController.prototype.fileDownloadUpdated = function(fileDownload) {
      if (this.pendingSources) {
        return;
      }
      if (!(fileDownload.readyForDownload() || (fileDownload.getError() != null))) {
        return;
      }
      return this.renderAndCollapse(true);
    };

    FileDownloadsController.prototype.pdfDownloadUpdated = function(pdfDownload) {
      if (!(pdfDownload.readyForDownload() || (pdfDownload.getError() != null))) {
        return;
      }
      return this.renderAndCollapse(true);
    };

    FileDownloadsController.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.errorTooltipHelper) != null) {
        ref.release();
      }
      if ((ref1 = this.titleTooltipHelper) != null) {
        ref1.release();
      }
      App.FileDownload.unbind('create destroy', this.renderAndCollapse);
      App.FileDownload.unbind('update source-updated', this.fileDownloadUpdated);
      App.PdfDownload.unbind('create destroy', this.renderAndCollapse);
      App.PdfDownload.unbind('update', this.pdfDownloadUpdated);
      App.SqlViewDataExport.unbind('create update destroy', this.sqlViewDataExportUpdated);
      return FileDownloadsController.__super__.release.apply(this, arguments);
    };

    FileDownloadsController.prototype.renderAndCollapse = function(longCollapse) {
      var collapseTimeout;
      if (longCollapse == null) {
        longCollapse = false;
      }
      clearTimeout(this.collapseTimeout);
      this.render();
      collapseTimeout = longCollapse ? this.constructor.LONG_COLLAPSE_TIMEOUT : this.constructor.COLLAPSE_TIMEOUT;
      return this.collapseTimeout = setTimeout(this.collapseTab, collapseTimeout);
    };

    FileDownloadsController.prototype.startRefresh = function() {
      clearInterval(this.refreshInterval);
      clearTimeout(this.collapseTimeout);
      clearTimeout(this.headerCollapseTimeout);
      this.panel.removeClass('invisible collapsed');
      this.panelHeader.removeClass('collapsed');
      return this.refreshInterval = setInterval(this.renderAndCollapse, this.constructor.REFRESH_INTERVAL);
    };

    FileDownloadsController.prototype.stopRefresh = function() {
      clearInterval(this.refreshInterval);
      delete this.refreshInterval;
      return this.collapseTimeout = setTimeout(this.collapseTab, this.constructor.COLLAPSE_TIMEOUT);
    };

    FileDownloadsController.prototype.cidAndItemType = function(downloadItem) {
      return downloadItem.cid.toString() + downloadItem.item_type.toString();
    };

    FileDownloadsController.prototype.allItemsForDisplay = function() {
      var largeFileDownloads, pdfDownloads, sqlViewDataExports;
      largeFileDownloads = this.largeFileDownloadItemForDisplay();
      pdfDownloads = this.pdfDownloadItemsForDisplay();
      sqlViewDataExports = this.sqlViewDataExportItemForDisplay();
      return largeFileDownloads.concat(pdfDownloads.concat(sqlViewDataExports));
    };

    FileDownloadsController.prototype.sqlViewDataExportItemForDisplay = function() {
      return this.collectItemsForDisplayByType(App.SqlViewDataExport.all());
    };

    FileDownloadsController.prototype.largeFileDownloadItemForDisplay = function() {
      return this.collectItemsForDisplayByType(App.FileDownload.all());
    };

    FileDownloadsController.prototype.pdfDownloadItemsForDisplay = function() {
      return this.collectItemsForDisplayByType(App.PdfDownload.all());
    };

    FileDownloadsController.prototype.collectItemsForDisplayByType = function(itemsToDisplay) {
      return _.filter(_.map(itemsToDisplay, function(item) {
        return App.DownloadHelper.getForDisplay(item);
      }), (function(_this) {
        return function(item) {
          return !_.includes(_this._items_pending_cancel, _this.cidAndItemType(item));
        };
      })(this));
    };

    FileDownloadsController.prototype.downloadAwaitingItems = function() {
      var cachedItemsWithDestination, i, item, len, results;
      this.downloadItems = this.allItemsForDisplay();
      cachedItemsWithDestination = _.filter(this.downloadItems, (function(_this) {
        return function(item) {
          return _.includes(_this._local_download_cache, _this.cidAndItemType(item)) && item.ready && (item.error == null);
        };
      })(this));
      results = [];
      for (i = 0, len = cachedItemsWithDestination.length; i < len; i++) {
        item = cachedItemsWithDestination[i];
        this._local_download_cache = _.pull(this._local_download_cache, this.cidAndItemType(item));
        _.remove(this.downloadItems, (function(_this) {
          return function(x) {
            return _this.cidAndItemType(x) === _this.cidAndItemType(item);
          };
        })(this));
        this.setWindowLocation(item.data_destination);
        results.push(this.findAndDestroy(item.cid, item.item_type));
      }
      return results;
    };

    FileDownloadsController.prototype.setWindowLocation = function(location) {
      return window.location.assign(location);
    };

    FileDownloadsController.prototype.collapseTab = function() {
      if (this.refreshInterval != null) {
        return;
      }
      this.panel.addClass('collapsed');
      clearTimeout(this.headerCollapseTimeout);
      return this.headerCollapseTimeout = setTimeout(((function(_this) {
        return function() {
          var ref;
          return (ref = _this.panelHeader) != null ? ref.addClass('collapsed') : void 0;
        };
      })(this)), this.constructor.HEADER_LAG);
    };

    FileDownloadsController.prototype.cancelClicked = function(e) {
      var downloadItem, row;
      row = $(e.currentTarget).parents('.download-row');
      row.addClass('cancelling');
      downloadItem = {};
      downloadItem.cid = row.attr('id');
      downloadItem.item_type = row.attr('itemType');
      return this.cancelDownload(downloadItem);
    };

    FileDownloadsController.prototype.cancelDownload = function(downloadItem) {
      this._items_pending_cancel.push(this.cidAndItemType(downloadItem));
      this.renderHeader(true);
      return setTimeout(((function(_this) {
        return function() {
          _this.findAndDestroy(downloadItem.cid, downloadItem.item_type);
          _this.render();
          return _this._items_pending_cancel = _.pull(_this._items_pending_cancel, _this.cidAndItemType(downloadItem));
        };
      })(this)), this.constructor.LONG_COLLAPSE_TIMEOUT);
    };

    FileDownloadsController.prototype.clearDownloadRow = function(e) {
      var cid, itemType;
      cid = $(e.currentTarget).parents('.download-row').attr('id');
      itemType = $(e.currentTarget).parents('.download-row').attr('itemType');
      this.findAndDestroy(cid, itemType);
      return this.render();
    };

    FileDownloadsController.prototype.findAndDestroy = function(cid, itemType, options) {
      var downloadToDelete;
      if (options == null) {
        options = {};
      }
      if (itemType === App.PdfDownload.className) {
        downloadToDelete = App.PdfDownload.exists(cid);
      } else if (itemType === App.SqlViewDataExport.className) {
        downloadToDelete = App.SqlViewDataExport.exists(cid);
      } else {
        downloadToDelete = App.FileDownload.exists(cid);
        if (AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
          options['custom_url'] = "/shared_dashboards/" + (AppRedesign.current().shared_dashboard_token) + "/file_downloads/" + downloadToDelete.id;
        }
      }
      if (!downloadToDelete) {
        return;
      }
      return downloadToDelete != null ? downloadToDelete.destroy(options) : void 0;
    };

    FileDownloadsController.prototype.errorInfo = function(evt) {
      return $(evt.currentTarget).data('tooltip').replace(/(\r\n|\n|\r)/gm, "");
    };

    FileDownloadsController.prototype.titleInfo = function(evt) {
      return $(evt.currentTarget).text().trim();
    };

    FileDownloadsController.prototype.markOverflownTitles = function() {
      return _.map(this.downloadTitle, function(el) {
        if (!(el.offsetWidth < el.scrollWidth)) {
          return $(el).addClass('no-tooltip');
        }
      });
    };

    FileDownloadsController.prototype.tooltipDisplaying = function() {
      return this.errorIcons.hasClass('selected') || this.downloadTitle.hasClass('selected');
    };

    FileDownloadsController.prototype.addToLocalDownloadCache = function(fileDownloadItem) {
      return this._local_download_cache.push(this.cidAndItemType(fileDownloadItem));
    };

    FileDownloadsController.prototype.fetchSourcesAndExpand = function() {
      var i, item, len, ref;
      ref = App.FileDownload.all();
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        this._items_pending_sources.push(this.cidAndItemType(item));
        item.one('source-updated', this.itemLoaded);
        item.fetchSource();
      }
      return this.sourcePollInterval = setInterval(this.checkSourceStatus, this.constructor.SOURCE_POLL_INTERVAL);
    };

    FileDownloadsController.prototype.itemLoaded = function(downloadItem) {
      return this._items_pending_sources = _.pull(this._items_pending_sources, this.cidAndItemType(downloadItem));
    };

    FileDownloadsController.prototype.pendingSourcesExist = function() {
      return this._items_pending_sources.length > 0;
    };

    FileDownloadsController.prototype.checkSourceStatus = function() {
      if (this.pendingSourcesExist()) {
        return;
      }
      clearInterval(this.sourcePollInterval);
      delete this.pendingSources;
      return this.renderAndCollapse(true);
    };

    FileDownloadsController.prototype._groupItemsByType = function(downloadItems) {
      return _.groupBy(downloadItems, function(item) {
        return App.DownloadHelper.getVerbForDownloadItemType(item);
      });
    };

    FileDownloadsController.prototype._groupItemsByStatus = function(downloadItems) {
      return _.groupBy(downloadItems, function(item) {
        if (item.error != null) {
          return 'failed';
        }
        if (item.ready) {
          return 'ready';
        }
        return 'preparing';
      });
    };

    FileDownloadsController.prototype.getHeaderInfo = function(cancelled) {
      var items, itemsByStatus;
      if (cancelled == null) {
        cancelled = false;
      }
      items = this.allItemsForDisplay();
      if (cancelled && _.isEmpty(items)) {
        return {
          msg: 'Download Cancelled',
          cancelled: true
        };
      }
      itemsByStatus = this._groupItemsByStatus(items);
      if (itemsByStatus.failed != null) {
        return {
          msg: this.getHeaderMessage(itemsByStatus.failed, 'failed'),
          failed: true
        };
      } else if (itemsByStatus.preparing != null) {
        return {
          msg: this.getHeaderMessage(itemsByStatus.preparing, 'preparing'),
          preparing: true
        };
      } else {
        return {
          msg: this.getHeaderMessage(itemsByStatus.ready, 'ready'),
          ready: true
        };
      }
    };

    FileDownloadsController.prototype.getHeaderMessage = function(items, state) {
      var exportKeyword, fileKeyword, itemsByTypes, numFiles, stateKeyword;
      numFiles = items.length;
      fileKeyword = numFiles > 1 ? "files" : "file";
      itemsByTypes = this._groupItemsByType(items);
      exportKeyword = state === "ready" ? "exported" : state + " to export";
      if ((itemsByTypes.download != null) && (itemsByTypes["export"] != null)) {
        if (state === "ready") {
          stateKeyword = exportKeyword + " or " + state + " to download";
        } else {
          stateKeyword = exportKeyword + " or download";
        }
      } else if (itemsByTypes.download != null) {
        stateKeyword = state + " to download";
      } else if (itemsByTypes["export"] != null) {
        stateKeyword = "" + exportKeyword;
      }
      return numFiles + " " + fileKeyword + " " + stateKeyword;
    };

    return FileDownloadsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FreeInputSanitizer = (function(superClass) {
    extend(FreeInputSanitizer, superClass);

    function FreeInputSanitizer() {
      return FreeInputSanitizer.__super__.constructor.apply(this, arguments);
    }

    FreeInputSanitizer.BLACKLISTED_CHARACTERS_PATTERN = /[^\-a-zA-Z0-9]/gi;

    FreeInputSanitizer.NUMERIC_PATTERN = /^-?\d+(\.\d+)?$/;

    FreeInputSanitizer.sanitize = function(input) {
      if (!this.freeInputNumericFormat(input)) {
        input = this.sanitizeInput(input);
      }
      return this.removePotentialCommentStrings(input);
    };

    FreeInputSanitizer.freeInputNumericFormat = function(input) {
      return input.match(this.NUMERIC_PATTERN);
    };

    FreeInputSanitizer.sanitizeInput = function(input) {
      return input.replace(this.BLACKLISTED_CHARACTERS_PATTERN, '');
    };

    FreeInputSanitizer.removePotentialCommentStrings = function(input) {
      return input.replace(/\-\-+/, '');
    };

    return FreeInputSanitizer;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.FreeInputSettingAutocompleteController = (function(superClass) {
    extend(FreeInputSettingAutocompleteController, superClass);

    FreeInputSettingAutocompleteController.prototype.className = 'free-input-setting-autocomplete normal-13-mirage-font';

    FreeInputSettingAutocompleteController.prototype.elements = {
      '.search-box': 'searchBox',
      '.search-input': 'searchInput',
      'input[name=dimension_value]': 'dimensionValueInput'
    };

    FreeInputSettingAutocompleteController.prototype.events = {
      'focus .search-input': 'focusedSearchInput',
      'blur .search-input': 'blurredSearchInput',
      'keydown input[name=dimension_value]': 'keydown'
    };

    function FreeInputSettingAutocompleteController() {
      this.autocompleteOptionSelected = bind(this.autocompleteOptionSelected, this);
      FreeInputSettingAutocompleteController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'alreadySelected', 'key', 'selectionMade');
      this.render();
    }

    FreeInputSettingAutocompleteController.prototype.render = function() {
      this.html(this.view('free_input_setting_autocomplete'));
      return this.setupJqueryAutocomplete();
    };

    FreeInputSettingAutocompleteController.prototype.setupJqueryAutocomplete = function() {
      return this.dimensionValueInput.autocomplete({
        appendTo: this.el,
        messages: {
          noResults: '',
          results: function() {}
        },
        minLength: 0,
        select: this.autocompleteOptionSelected,
        source: _.without.apply(_, [this.autocompletePromptEntries()].concat(slice.call(this.alreadySelected)))
      });
    };

    FreeInputSettingAutocompleteController.prototype.autocompleteOptionSelected = function(event, ui) {
      if (App.Utils.isBlank(ui.item.value)) {
        return;
      }
      return this.callSelectionMade(ui.item.value);
    };

    FreeInputSettingAutocompleteController.prototype.autocompletePromptEntries = function() {
      var ref;
      return (ref = AppRedesign.recoverator().get(this.key)) != null ? ref : [];
    };

    FreeInputSettingAutocompleteController.prototype.showAutocompleteResults = function() {
      return this.dimensionValueInput.autocomplete('search', this.dimensionValueInput.val());
    };

    FreeInputSettingAutocompleteController.prototype.focusedSearchInput = function() {
      this.searchBox.addClass('focused');
      return this.showAutocompleteResults();
    };

    FreeInputSettingAutocompleteController.prototype.focus = function() {
      return this.dimensionValueInput.trigger('focus');
    };

    FreeInputSettingAutocompleteController.prototype.sanitizedInputVal = function() {
      return App.FreeInputSanitizer.sanitize(this.dimensionValueInput.val());
    };

    FreeInputSettingAutocompleteController.prototype.blurredSearchInput = function(e) {
      return this.searchBox.removeClass('focused');
    };

    FreeInputSettingAutocompleteController.prototype.keydown = function(e) {
      var dimensionValue;
      if (e.which !== AppRedesign.KEYS.ENTER) {
        return;
      }
      if (this.dimensionValueIsBlank()) {
        return;
      }
      dimensionValue = this.sanitizedInputVal();
      this.addInputValueToAutocomplete(dimensionValue);
      return this.callSelectionMade(dimensionValue);
    };

    FreeInputSettingAutocompleteController.prototype.callSelectionMade = function(value) {
      this.dimensionValueInput.val('').trigger('focus');
      return this.selectionMade(value);
    };

    FreeInputSettingAutocompleteController.prototype.dimensionValueIsBlank = function() {
      return App.Utils.isBlank(this.dimensionValueInput.val());
    };

    FreeInputSettingAutocompleteController.prototype.addInputValueToAutocomplete = function(dimensionValue) {
      return AppRedesign.recoverator().addToSet(this.key, dimensionValue);
    };

    return FreeInputSettingAutocompleteController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.FreeInputSettingController = (function(superClass) {
    extend(FreeInputSettingController, superClass);

    FreeInputSettingController.prototype.elements = {
      '.free-input-values': 'freeInputValues'
    };

    FreeInputSettingController.prototype.events = {
      'click .remove-icon': 'removeValue'
    };

    function FreeInputSettingController() {
      this.updateDimension = bind(this.updateDimension, this);
      FreeInputSettingController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard', 'el', 'dimension');
      this.render();
      this.dashboard.bind(App.Dashboard.EVENT_CONFIG_CHANGED, (function(_this) {
        return function() {
          return _this.render();
        };
      })(this));
    }

    FreeInputSettingController.prototype.render = function() {
      this.html(this.view('free_input_setting')({
        dimensionValues: this.dimensionValues()
      }));
      this.autocompleter = new App.FreeInputSettingAutocompleteController({
        alreadySelected: this.dimensionValues(),
        key: this.recoveratorKeyName(),
        selectionMade: this.updateDimension
      });
      return this.freeInputValues.before(this.autocompleter.el);
    };

    FreeInputSettingController.prototype.updateDimension = function(dimensionValue) {
      if (App.Utils.isBlank(dimensionValue)) {
        return;
      }
      this.dimensionConfig().addDimensionInfo(this.dimension.id, dimensionValue, dimensionValue);
      return this.autocompleter.focus();
    };

    FreeInputSettingController.prototype.dimensionValues = function() {
      return this.dimensionConfig().dimensionValues(this.dimension.id);
    };

    FreeInputSettingController.prototype.dimensionValue = function() {
      return this.dimensionValueInput.val();
    };

    FreeInputSettingController.prototype.dashboardSettingsClosed = function() {};

    FreeInputSettingController.prototype.onDataUpdated = function() {};

    FreeInputSettingController.prototype.dimensionConfig = function() {
      return this.dashboard.dimensionConfig();
    };

    FreeInputSettingController.prototype.removeValue = function(e) {
      var input_value, value;
      input_value = $(e.currentTarget).parent('div');
      value = input_value.data('value');
      return this.dimensionConfig().removeDimensionInfo(this.dimension.id, value);
    };

    FreeInputSettingController.prototype.recoveratorKeyName = function() {
      return "free_input_autocomplete_" + this.dimension.id;
    };

    return FreeInputSettingController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.GradientColorPicker = (function(superClass) {
    extend(GradientColorPicker, superClass);

    GradientColorPicker.prototype.className = 'gradient-color-picker';

    GradientColorPicker.prototype.elements = {
      '#color-block': 'colorBlock',
      '#color-strip': 'colorStrip',
      'input#hexColor': 'colorHex'
    };

    GradientColorPicker.prototype.events = {
      'click #color-strip': 'clickColor',
      'click #color-block': 'setColorFromClick',
      'change #hexColor': 'updateHex'
    };

    function GradientColorPicker() {
      this.reset = bind(this.reset, this);
      this.setInitialCursors = bind(this.setInitialCursors, this);
      this.setColorFromCursorPosition = bind(this.setColorFromCursorPosition, this);
      this.clickColor = bind(this.clickColor, this);
      this.setRgba = bind(this.setRgba, this);
      this.setColor = bind(this.setColor, this);
      this.setColorFromClick = bind(this.setColorFromClick, this);
      this.updateHex = bind(this.updateHex, this);
      this.fillColor = bind(this.fillColor, this);
      GradientColorPicker.__super__.constructor.apply(this, arguments);
      this.rgbaColor = App.ColorHelper.hexToRGBA(this.colorToSet, 1);
      this.hsvColor = App.ColorHelper.rgbToHsv(this.rgbaColor);
      this.viewController.bind('reset', this.reset);
      this.colorSelectionCursor = $('<div class="color-cursor"></div>');
      this.colorSliderCursor = $('<div class="color-slider-cursor"></div>');
      this.render();
      this.setInitialCursors();
    }

    GradientColorPicker.prototype.render = function() {
      this.html(this.view('redesign/gradient_color_picker')({
        hexColor: App.ColorHelper.hexColorOrNull(this.colorToSet)
      }));
      this.colorBlockCanvas = {
        context: this.colorBlock[0].getContext('2d'),
        height: this.colorBlock.attr('height'),
        width: this.colorBlock.attr('width')
      };
      this.colorStripCanvas = {
        context: this.colorStrip[0].getContext('2d'),
        height: this.colorStrip.attr('height'),
        width: this.colorStrip.attr('width')
      };
      this.colorBlockCanvas.context.rect(0, 0, this.colorBlockCanvas.width, this.colorBlockCanvas.height);
      this.colorStripCanvas.context.rect(0, 0, this.colorStripCanvas.width, this.colorStripCanvas.height);
      this.fillColor();
      this.colorStripCanvas.context.fillStyle = this.buildColorStrip();
      return this.colorStripCanvas.context.fill();
    };

    GradientColorPicker.prototype.buildColorStrip = function() {
      var strip;
      strip = this.colorStripCanvas.context.createLinearGradient(0, 0, 0, this.colorStripCanvas.height);
      strip.addColorStop(0, 'rgba(255, 0, 0, 1)');
      strip.addColorStop(0.17, 'rgba(255, 255, 0, 1)');
      strip.addColorStop(0.34, 'rgba(0, 255, 0, 1)');
      strip.addColorStop(0.51, 'rgba(0, 255, 255, 1)');
      strip.addColorStop(0.68, 'rgba(0, 0, 255, 1)');
      strip.addColorStop(0.85, 'rgba(255, 0, 255, 1)');
      strip.addColorStop(1, 'rgba(255, 0, 0, 1)');
      return strip;
    };

    GradientColorPicker.prototype.fillColor = function() {
      var grdWhite, maxSaturationAndValueColor, ref;
      maxSaturationAndValueColor = App.ColorHelper.hsvToRgb(((ref = this.hsvColor) != null ? ref[0] : void 0) || 0, 1, 1);
      this.colorBlockCanvas.context.fillStyle = maxSaturationAndValueColor;
      this.colorBlockCanvas.context.fillRect(0, 0, this.colorBlockCanvas.width, this.colorBlockCanvas.height);
      grdWhite = this.colorStripCanvas.context.createLinearGradient(0, 0, this.colorBlockCanvas.width, 0);
      grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
      grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
      this.colorBlockCanvas.context.fillStyle = grdWhite;
      this.colorBlockCanvas.context.fillRect(0, 0, this.colorBlockCanvas.width, this.colorBlockCanvas.height);
      this.grdBlack = this.colorStripCanvas.context.createLinearGradient(0, 0, 0, this.colorBlockCanvas.height);
      this.grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
      this.grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
      this.colorBlockCanvas.context.fillStyle = this.grdBlack;
      return this.colorBlockCanvas.context.fillRect(0, 0, this.colorBlockCanvas.width, this.colorBlockCanvas.height);
    };

    GradientColorPicker.prototype.updateHex = function(e) {
      var colorInput;
      colorInput = this.colorHex.val();
      this.colorToSet = App.ColorHelper.hexColorOrNull(colorInput);
      this.colorHex.val(this.colorToSet);
      this.rgbaColor = App.ColorHelper.hexToRGBA(this.colorToSet);
      this.hsvColor = App.ColorHelper.rgbToHsv(this.rgbaColor);
      this.fillColor();
      return this.trigger('set-color', this.colorToSet);
    };

    GradientColorPicker.prototype.setColorFromClick = function(e) {
      var imageData, x, y;
      y = e.offsetY;
      x = e.offsetX;
      imageData = this.colorBlockCanvas.context.getImageData(x, y, 1, 1).data;
      this.colorSelectionCursor.css({
        top: y - 6,
        left: x - 6
      });
      $('#gradient-color-picker').append(this.colorSelectionCursor);
      return this.setColor(imageData);
    };

    GradientColorPicker.prototype.setColor = function(imageData) {
      this.setRgba(imageData);
      this.colorToSet = App.ColorHelper.rgbToHex(this.rgbaColor);
      this.colorHex.val(this.colorToSet);
      return this.trigger('set-color', this.colorToSet);
    };

    GradientColorPicker.prototype.setRgba = function(imageData) {
      this.rgbaColor = "rgba(" + imageData[0] + "," + imageData[1] + "," + imageData[2] + ",1)";
      return this.hsvColor = App.ColorHelper.rgbToHsv(this.rgbaColor);
    };

    GradientColorPicker.prototype.clickColor = function(e) {
      var imageData, x, y;
      y = e.offsetY;
      x = e.offsetX;
      this.colorSliderCursor.remove();
      this.colorSliderCursor.css({
        top: y
      });
      $('#gradient-color-picker').append(this.colorSliderCursor);
      imageData = this.colorStripCanvas.context.getImageData(x, y, 1, 1).data;
      this.setRgba(imageData);
      this.fillColor();
      return this.setColorFromCursorPosition();
    };

    GradientColorPicker.prototype.setColorFromCursorPosition = function() {
      var imageData, x, y;
      x = this.colorSelectionCursor.position().left;
      y = this.colorSelectionCursor.position().top;
      imageData = this.colorBlockCanvas.context.getImageData(x, y, 1, 1).data;
      return this.setColor(imageData);
    };

    GradientColorPicker.prototype.setInitialCursors = function() {
      this.setInitialCursorOffsets();
      $(this.el).find('#gradient-color-picker').append(this.colorSelectionCursor);
      return $(this.el).find('#gradient-color-picker').append(this.colorSliderCursor);
    };

    GradientColorPicker.prototype.setInitialCursorOffsets = function() {
      var distanceAlongColorStrip, horizontalDistanceOnColorBlock, hue, ref, ref1, ref2, saturation, value, verticalDistanceOnColorBlock;
      hue = ((ref = this.hsvColor) != null ? ref[0] : void 0) || 0;
      saturation = ((ref1 = this.hsvColor) != null ? ref1[1] : void 0) || 0;
      value = ((ref2 = this.hsvColor) != null ? ref2[2] : void 0) || 1;
      distanceAlongColorStrip = (hue * this.colorStripCanvas.height) - 2;
      horizontalDistanceOnColorBlock = (saturation * this.colorBlockCanvas.width) - 6;
      verticalDistanceOnColorBlock = ((1 - value) * this.colorBlockCanvas.height) - 6;
      this.colorSelectionCursor.css({
        top: verticalDistanceOnColorBlock,
        left: horizontalDistanceOnColorBlock
      });
      return this.colorSliderCursor.css({
        top: distanceAlongColorStrip
      });
    };

    GradientColorPicker.prototype.reset = function(hexColor) {
      this.colorHex.val(hexColor);
      this.rgbaColor = App.ColorHelper.hexToRGBA(hexColor);
      this.hsvColor = App.ColorHelper.rgbToHsv(this.rgbaColor);
      this.setInitialCursors();
      return this.fillColor();
    };

    return GradientColorPicker;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.HeaderTitleController = (function(superClass) {
    extend(HeaderTitleController, superClass);

    HeaderTitleController.prototype.elements = {
      'input.header-title': 'titleInput',
      '.header-content': 'headerContent',
      '.right-controls': 'rightControls',
      '.header-icons': 'iconsWrapper',
      '.errors': 'errors',
      '.title-wrapper': 'titleWrapper',
      '.dashboard-freshness-root': 'dashboardFreshnessRoot'
    };

    HeaderTitleController.prototype.events = {
      'blur .header-title': 'titleBlurred',
      'keydown .header-title': 'titleKeydown',
      'input .header-title': 'titleInputChange',
      'focus .header-title': 'titleFocused'
    };

    HeaderTitleController.DASHBOARD_TITLE_FONT_SIZE = 24;

    HeaderTitleController.DASHBOARD_TITLE_MARGIN = 12;

    HeaderTitleController.DASHBOARD_TITLE_BORDER = 4;

    HeaderTitleController.RIGHT_CONTROLS_RIGHT = 19;

    HeaderTitleController.DASHBOARD_TITLE_PADDING = 4;

    HeaderTitleController.PADDING_NEEDED_FOR_SAFARI = 3;

    HeaderTitleController.FRESHNESS_PADDING = 17;

    HeaderTitleController.INPUT_FONT = 'FF_DIN_Regular, FF_DIN_Light, DinProRegular, "Helvetica Neue", HelveticaNeue, "Helvetica-Neue", Helvetica, "BBAlpha Sans", sans-serif';

    function HeaderTitleController() {
      this.maybeEnableInput = bind(this.maybeEnableInput, this);
      this.editDashboardTitleEnabled = bind(this.editDashboardTitleEnabled, this);
      this.clearError = bind(this.clearError, this);
      this.showError = bind(this.showError, this);
      this.maxWidth = bind(this.maxWidth, this);
      this.updateMaxTitleWidth = bind(this.updateMaxTitleWidth, this);
      this.setTitleOnChangeElsewhere = bind(this.setTitleOnChangeElsewhere, this);
      this.release = bind(this.release, this);
      this.refresh = bind(this.refresh, this);
      this.maybeRenderDashboardFreshnessController = bind(this.maybeRenderDashboardFreshnessController, this);
      HeaderTitleController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item');
      this.isWidget = this.item instanceof App.Widget;
      this.immediatelySave = this.item instanceof App.Dashboard;
      $(window).on('resize', this.updateMaxTitleWidth);
      this.maybeDisableInput();
      this.renderTitle();
      this.item.bind('update', this.refresh);
      this.item.bind('title-changed', this.setTitleOnChangeElsewhere);
      setTimeout(this.updateMaxTitleWidth, 0);
      this.maybeRenderDashboardFreshnessController();
    }

    HeaderTitleController.prototype.maybeRenderDashboardFreshnessController = function() {
      var site;
      site = App.Site.first();
      if (!site.isDashboardRefreshV1Enabled()) {
        return;
      }
      if (!(site.isDashboardRefreshEnabled() || site.isDashboardRefreshRolloutEnabled())) {
        return;
      }
      if (AppRedesign.autoArchiveEnabled() && this.item.archived_at) {
        return;
      }
      return this.freshnessController != null ? this.freshnessController : this.freshnessController = new App.DashboardFreshnessController({
        el: this.dashboardFreshnessRoot[0],
        dashboard: this.item,
        renderCallback: this.updateMaxTitleWidth
      });
    };

    HeaderTitleController.prototype.refresh = function() {
      this.renderTitle();
      return this.updateStatus();
    };

    HeaderTitleController.prototype.release = function() {
      var ref;
      $(window).off('resize', this.updateMaxTitleWidth);
      this.item.unbind('update', this.refresh);
      this.item.unbind('title-changed', this.setTitleOnChangeElsewhere);
      if ((ref = this.freshnessController) != null) {
        ref.release();
      }
      return HeaderTitleController.__super__.release.apply(this, arguments);
    };

    HeaderTitleController.prototype.getTitleVal = function() {
      return this.titleInput.val().trim();
    };

    HeaderTitleController.prototype.titleBlurred = function() {
      var newTitle, savedTitle;
      newTitle = this.getTitleVal();
      savedTitle = this.item.getName();
      this.item.setName(newTitle);
      this.renderTitle();
      if (savedTitle !== newTitle) {
        if (this.immediatelySave) {
          this.item.save();
          return App.RouteHelper.navigateTo(this.item.constructor.className, this.item, {
            replace: true
          });
        }
      }
    };

    HeaderTitleController.prototype.setTitleOnChangeElsewhere = function() {
      if (this.titleInput.is(':focus')) {
        return;
      }
      return this.renderTitle();
    };

    HeaderTitleController.prototype.renderTitle = function() {
      this.titleInput.val(this.displayTitle());
      return this.resizeTitle();
    };

    HeaderTitleController.prototype.resizeTitle = function(rightPadding) {
      var finalWidth, newFullWidth, paddedFinalWidth, textToSize;
      if (rightPadding == null) {
        rightPadding = 0;
      }
      App.Utils.initRedesignCanvasWidthSizer(HeaderTitleController.DASHBOARD_TITLE_FONT_SIZE);
      textToSize = this.titleInput.val();
      if (textToSize.length === 0 && (this.titlePlaceholder != null) && rightPadding === 0) {
        textToSize = this.titlePlaceholder;
      }
      newFullWidth = App.Utils.fastApproxWidthForText(textToSize) + HeaderTitleController.DASHBOARD_TITLE_BORDER;
      newFullWidth += this.constructor.PADDING_NEEDED_FOR_SAFARI;
      finalWidth = newFullWidth;
      if (!isNaN(this.maxTitleWidth)) {
        finalWidth = Math.min(newFullWidth, this.maxTitleWidth);
      }
      paddedFinalWidth = finalWidth + rightPadding;
      if (paddedFinalWidth !== this.titleInput.width()) {
        return this.titleInput.css('width', paddedFinalWidth);
      }
    };

    HeaderTitleController.prototype.updateStatus = function() {
      var c, classes, i, infoIcon, len, results, status, statusCss;
      infoIcon = this.iconsWrapper.find('.info');
      if (infoIcon.length === 0) {
        return;
      }
      classes = infoIcon.attr('class').split(' ');
      results = [];
      for (i = 0, len = classes.length; i < len; i++) {
        c = classes[i];
        if (c.startsWith('status-')) {
          status = this.item.status();
          statusCss = "status-" + status;
          if (status && statusCss !== c) {
            infoIcon.removeClass(c);
            results.push(infoIcon.addClass(statusCss));
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    HeaderTitleController.prototype.displayTitle = function() {
      if (this.isWidget) {
        return this.item.getTitleForDisplay();
      } else {
        return this.item.getName();
      }
    };

    HeaderTitleController.prototype.setRawTitle = function() {
      return this.titleInput.val(this.rawName());
    };

    HeaderTitleController.prototype.rawName = function() {
      if (this.isWidget) {
        return this.item.getRawTitle();
      } else {
        return this.item.getName();
      }
    };

    HeaderTitleController.prototype.maybeDisableInput = function() {
      var ref;
      if (this.item.archived_at) {
        this.titleInput.attr('disabled', 'disabled');
        return;
      } else if (AppRedesign.current().state.RbacEnabled) {
        if (!this.editDashboardTitleEnabled()) {
          this.titleInput.attr('disabled', 'disabled');
        }
        return;
      } else if (this.item.isExplorableByCurrentUser != null) {
        if (this.item.isExplorableByCurrentUser()) {
          return;
        }
      } else if ((ref = App.User.currentUser()) != null ? ref.canExplore() : void 0) {
        return;
      }
      return this.titleInput.attr('disabled', 'disabled');
    };

    HeaderTitleController.prototype.titleKeydown = function(event) {
      if (event.which === AppRedesign.KEYS.ENTER) {
        return this.titleInput.trigger('blur');
      }
    };

    HeaderTitleController.prototype.titleInputChange = function() {
      this.resizeTitle();
      if (this.isWidget) {
        this.item.setName(this.getTitleVal());
      }
      return this.trigger('header-title-changed', this.getTitleVal());
    };

    HeaderTitleController.prototype.titleFocused = function() {
      if (!this.isWidget) {
        return;
      }
      this.setRawTitle();
      return this.resizeTitle();
    };

    HeaderTitleController.prototype.updateMaxTitleWidth = function() {
      this.maxTitleWidth = this.maxWidth();
      return this.resizeTitle();
    };

    HeaderTitleController.prototype.maxWidth = function() {
      return this.defaultMaxWidth() - this.freshnessRootWidth();
    };

    HeaderTitleController.prototype.freshnessRootWidth = function() {
      var freshnessRootWidth;
      freshnessRootWidth = this.dashboardFreshnessRoot.width();
      if (freshnessRootWidth > 0) {
        freshnessRootWidth += this.constructor.FRESHNESS_PADDING;
      }
      return freshnessRootWidth;
    };

    HeaderTitleController.prototype.defaultMaxWidth = function() {
      var c, childrenSize, startingSpace, titleSpacing;
      c = this.constructor;
      titleSpacing = c.DASHBOARD_TITLE_MARGIN + c.DASHBOARD_TITLE_PADDING + c.DASHBOARD_TITLE_BORDER;
      childrenSize = this.rightControls.width() + this.iconsWrapper.width();
      startingSpace = this.headerContent.width();
      return startingSpace - titleSpacing - childrenSize - c.RIGHT_CONTROLS_RIGHT;
    };

    HeaderTitleController.prototype.showError = function(msg) {
      this.errors.text(msg);
      return this.titleWrapper.addClass("show-error");
    };

    HeaderTitleController.prototype.clearError = function() {
      this.errors.text('');
      return this.titleWrapper.removeClass("show-error");
    };

    HeaderTitleController.prototype.editDashboardTitleEnabled = function() {
      var dp;
      if (AppRedesign.currentPermissionsExist()) {
        dp = AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions;
        return AppRedesign.createSqlChartsEnabledOnDashboard() || AppRedesign.canOnlyEditChartAsCopy() || AppRedesign.createDiscoveryChartsEnabledOnDashboard() || dp.create_dashboards;
      } else {
        setTimeout(this.maybeEnableInput, 200);
        return false;
      }
    };

    HeaderTitleController.prototype.maybeEnableInput = function() {
      if (this.editDashboardTitleEnabled()) {
        return this.titleInput.attr('disabled', false);
      }
    };

    return HeaderTitleController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LeftMenu = (function(superClass) {
    extend(LeftMenu, superClass);

    LeftMenu.prototype.className = 'left-menu';

    LeftMenu.prototype.elements = {
      'input.search': 'searchBox',
      '.section-list': 'sectionList',
      '.loading.message': 'loadingMessage',
      '.info.message': 'infoMessage',
      '.toggle-area': 'toggleArea'
    };

    LeftMenu.prototype.events = {
      'click .section-header': 'toggleSection',
      'click .section-contents li': 'itemClicked',
      'mouseenter .section-contents li': 'itemEnter',
      'mouseleave .section-contents li': 'itemLeave',
      'click .button.add-new': 'addNewClicked',
      'keyup input.search': 'onSearch',
      'wheel .section-list': 'scrollSectionList',
      'mousewheel .section-list': 'scrollSectionList',
      'scroll .section-list': 'scrollSectionList'
    };

    LeftMenu.SEARCH_DELAY = 100;

    LeftMenu.DASHBOARDS = 'Dashboards';

    LeftMenu.SPACES = 'Spaces';

    LeftMenu.prototype.searchQuery = function() {
      return this.searchBox.val().trim();
    };

    LeftMenu.prototype.isSearching = function() {
      return this.searchQuery().length > 0;
    };

    function LeftMenu() {
      this.itemLeave = bind(this.itemLeave, this);
      this.itemEnter = bind(this.itemEnter, this);
      this.itemClicked = bind(this.itemClicked, this);
      this.scrollSectionList = bind(this.scrollSectionList, this);
      this.addNewClicked = bind(this.addNewClicked, this);
      this.renderResults = bind(this.renderResults, this);
      this.onSearch = bind(this.onSearch, this);
      this.toggled = bind(this.toggled, this);
      this.logSearchQuery = bind(this.logSearchQuery, this);
      var ref, ref1;
      LeftMenu.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'helper', 'title');
      this.html(this.view('redesign/controls/left_menu_frame')({
        title: this.title,
        shouldAddDatasetToggler: this.shouldAddDatasetToggler(),
        showAddNewButton: this.showAddNewButton()
      }));
      if (this.shouldAddDatasetToggler()) {
        this.addDatasetToggler();
      }
      this.helper.bind('update', this.renderResults);
      this.el.addClass(this.helper.baseClass.className.toLowerCase());
      App.Dashboard.bind('remaining-state-loaded', this.renderResults);
      this.debouncedLogSearchQuery = _.debounce(this.logSearchQuery, 1000);
      this.renderResults();
      setTimeout(((function(_this) {
        return function() {
          return _this.searchBox.trigger('focus');
        };
      })(this)), App.LeftMenu.SEARCH_DELAY);
      if ((ref = AppRedesign.current().tutorial()) != null) {
        if ((ref1 = ref.tutorialMole) != null) {
          ref1.hide();
        }
      }
    }

    LeftMenu.prototype.showAddNewButton = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (this.title === App.LeftMenu.DASHBOARDS) {
          return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.create_dashboards;
        } else if (this.title === App.LeftMenu.SPACES) {
          return AppRedesign.current().state.RbacAdmin;
        } else {
          return true;
        }
      } else {
        if (this.title === App.LeftMenu.DASHBOARDS) {
          return App.User.currentUser().canExplore();
        } else {
          return true;
        }
      }
    };

    LeftMenu.prototype.release = function() {
      var ref, ref1, ref2;
      App.Dashboard.unbind('remaining-state-loaded', this.renderResults);
      if ((ref = this.datasetToggler) != null) {
        ref.unbind('toggled');
      }
      this.helper.release();
      if ((ref1 = this.superToolTip) != null) {
        ref1.release();
      }
      if ((ref2 = this.datasetToggler) != null) {
        ref2.release();
      }
      return LeftMenu.__super__.release.apply(this, arguments);
    };

    LeftMenu.prototype.logSearchQuery = function() {
      return App.Utils.logFeature('search', {
        detail: "searchQuery:" + (this.searchQuery())
      });
    };

    LeftMenu.prototype.shouldAddDatasetToggler = function() {
      return AppRedesign.dragDropEnabled() && (this.title === 'Views' || this.title === 'CSVs');
    };

    LeftMenu.prototype.addDatasetToggler = function() {
      var leftLabel;
      leftLabel = 'Views';
      if (this.title === 'CSVs') {
        leftLabel = 'CSVs';
      }
      this.datasetToggler = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: false,
        staticLeftLabel: leftLabel,
        staticRightLabel: 'Datasets'
      });
      this.toggleArea.append(this.datasetToggler.el);
      return this.datasetToggler.bind('toggled', this.toggled);
    };

    LeftMenu.prototype.toggled = function() {
      return this.renderResults();
    };

    LeftMenu.prototype.onSearch = function(event) {
      if (this.handleKeyboardNavigation(event)) {
        return;
      }
      this.debouncedLogSearchQuery();
      return this.renderResults(true);
    };

    LeftMenu.prototype.renderResults = function(fromSearch) {
      var menuSections, openSectionNames, ref, ref1;
      if (fromSearch == null) {
        fromSearch = false;
      }
      openSectionNames = fromSearch ? [] : this.el.find('.menu-section.open').map(function() {
        return $(this).attr('name');
      }).get();
      menuSections = this.helper.menuSections(this.searchQuery(), (ref = this.datasetToggler) != null ? ref.isToggleOn : void 0);
      this.el.toggleClass('loading', !AppRedesign.current().remainingStateLoaded);
      if (this.noItemsExist()) {
        if (!AppRedesign.current().remainingStateLoaded || ((ref1 = this.infoMessage) != null ? ref1.is(':visible') : void 0)) {
          return;
        }
        return this.html(this.view('redesign/controls/left_menu_frame')({
          infoClass: this.helper.baseClass.PRETTY_CLASS_NAME,
          infoText: this.helper.infoText(),
          title: this.title,
          showAddNewButton: this.showAddNewButton()
        }));
      } else {
        this.infoMessage.hide();
        this.el.removeClass('loading');
        return this.renderAndQueueSections(menuSections, openSectionNames);
      }
    };

    LeftMenu.prototype.renderAndQueueSections = function(menuSections, openSectionNames) {
      var queue;
      this.sectionList.html(this.view('redesign/controls/left_menu_results')({
        isSearching: this.isSearching(),
        sections: menuSections,
        contentsView: this.view('redesign/controls/left_menu_contents'),
        openSectionNames: openSectionNames
      }).trim());
      if (!this.isSearching()) {
        queue = AppRedesign.current().uiQueue;
        return setTimeout(((function(_this) {
          return function() {
            var i, index, len, results, section;
            results = [];
            for (index = i = 0, len = menuSections.length; i < len; index = ++i) {
              section = menuSections[index];
              if (index > 0) {
                results.push(queue.add(_this.makePopulateFunc(section, index), 'render-left-menu-section'));
              }
            }
            return results;
          };
        })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      }
    };

    LeftMenu.prototype.makePopulateFunc = function(section, index) {
      return (function(_this) {
        return function() {
          return _this.populateSection(section, index);
        };
      })(this);
    };

    LeftMenu.prototype.populateSection = function(section, index) {
      var items;
      items = App.LeftMenuHelper.transformSectionRecordsToDisplayData(section).items;
      return this.el.find(".section-contents[data-section-id=" + index + "]").html(this.view('redesign/controls/left_menu_contents')({
        items: items
      }));
    };

    LeftMenu.prototype.toggleSection = function(ev) {
      return $(ev.target).closest('.menu-section').toggleClass('open');
    };

    LeftMenu.prototype.noItemsExist = function() {
      return this.helper.baseClass.count() === 0;
    };

    LeftMenu.prototype.addNewClicked = function() {
      return this.trigger('add-new-clicked', this.helper.baseClass.className);
    };

    LeftMenu.prototype.scrollSectionList = function() {
      return this.closeSuperTooltip();
    };

    LeftMenu.prototype.itemFromResultListEvent = function(ev) {
      var item, itemClassName, target, widgetId;
      target = $(ev.currentTarget);
      itemClassName = target.data('item-class');
      item = App[itemClassName].exists(target.data('item-cid'));
      if (!item) {
        item = target.data('item-cid');
      }
      widgetId = target.data('item-widgetid');
      return {
        target: target,
        itemClassName: itemClassName,
        item: item,
        widgetId: widgetId
      };
    };

    LeftMenu.prototype.featureLogItemClicked = function(itemInfo) {
      var browserHeight, browserWidth, detail, feature, ref, ref1;
      feature = itemInfo.itemClassName + '-clicked';
      if (((ref = this.searchQuery()) != null ? ref.length : void 0) > 0) {
        detail = "searchQuery:" + (this.searchQuery());
      }
      if (feature === 'Dashboard-clicked') {
        ref1 = App.RedesignDashboardSizer.browserWidthHeight(), browserWidth = ref1[0], browserHeight = ref1[1];
        detail = detail != null ? detail + ", " : '';
        detail += "browserWidthHeight: (" + browserWidth + ", " + browserHeight + ")";
      }
      if (detail != null) {
        return App.Utils.logFeature(feature, {
          detail: detail,
          context: "id:" + itemInfo.item.id
        });
      } else {
        return App.Utils.logFeature(feature, {
          context: "id:" + itemInfo.item.id
        });
      }
    };

    LeftMenu.prototype.itemClicked = function(ev) {
      var itemInfo;
      if (this.helper.searchingArchives()) {
        this.archivedItemClicked(ev);
        return;
      }
      itemInfo = this.itemFromResultListEvent(ev);
      this.closeSuperTooltip();
      this.featureLogItemClicked(itemInfo);
      return this.trigger('item-clicked', itemInfo.itemClassName, itemInfo.item, itemInfo.widgetId);
    };

    LeftMenu.prototype.archivedItemClicked = function(ev) {
      var itemCid, itemClass, itemGuid, params, ref;
      this.closeSuperTooltip();
      ref = $(ev.currentTarget).data(), itemClass = ref.itemClass, itemCid = ref.itemCid, itemGuid = ref.itemGuid;
      params = {
        id: itemCid,
        className: itemClass,
        name: $(ev.currentTarget).text().trim()
      };
      if (itemGuid != null) {
        params.guid = itemGuid;
      }
      return this.trigger('item-clicked', 'Archive', params);
    };

    LeftMenu.prototype.itemEnter = function(ev) {
      var itemInfo, ref, timeout;
      itemInfo = this.itemFromResultListEvent(ev);
      clearTimeout(this.showSuperTooltipTimeout);
      clearTimeout(this.hideSuperTooltipTimeout);
      timeout = {
        "true": 0,
        "false": App.SuperTooltipController.SHOW_DELAY_MS
      }[Boolean((ref = this.superTooltip) != null ? ref.visible() : void 0)];
      return this.showSuperTooltipTimeout = setTimeout(((function(_this) {
        return function() {
          if (_this.superTooltip == null) {
            _this.superTooltip = new App.SuperTooltipController({
              offsetLeft: 3
            });
          }
          return _this.superTooltip.show(itemInfo.item, itemInfo.target);
        };
      })(this)), timeout);
    };

    LeftMenu.prototype.itemLeave = function(ev) {
      var itemInfo, ref;
      itemInfo = this.itemFromResultListEvent(ev);
      clearTimeout(this.showSuperTooltipTimeout);
      clearTimeout(this.hideSuperTooltipTimeout);
      if (!((ref = this.superTooltip) != null ? ref.visible() : void 0)) {
        return;
      }
      return this.hideSuperTooltipTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.closeSuperTooltip();
        };
      })(this)), App.SuperTooltipController.HIDE_DELAY_MS);
    };

    LeftMenu.prototype.closeSuperTooltip = function() {
      var ref;
      clearTimeout(this.showSuperTooltipTimeout);
      clearTimeout(this.hideSuperTooltipTimeout);
      return (ref = this.superTooltip) != null ? ref.hide() : void 0;
    };

    LeftMenu.prototype.handleKeyboardNavigation = function(event) {
      if (event == null) {
        return false;
      }
      switch (event.which) {
        case AppRedesign.KEYS.UP_ARROW:
          event.preventDefault();
          this.moveActiveItem(-1);
          return true;
        case AppRedesign.KEYS.DOWN_ARROW:
          event.preventDefault();
          this.moveActiveItem(1);
          return true;
        case AppRedesign.KEYS.ENTER:
          event.preventDefault();
          this.selectCurrentItem();
          return true;
      }
      return false;
    };

    LeftMenu.prototype.moveActiveItem = function(step) {
      var currIndex, currItem, items, previousItem;
      items = this.sectionList.find('li.item');
      if (items.length === 0) {
        return;
      }
      previousItem = this.sectionList.find('li.item.active');
      currIndex = items.index(previousItem) + step;
      if (currIndex < 0) {
        currIndex = items.length - 1;
      }
      if (currIndex >= items.length) {
        currIndex = 0;
      }
      previousItem.removeClass('active');
      currItem = $(items[currIndex]);
      currItem.addClass('active');
      currItem.closest('.menu-section').addClass('open');
      return this.scrollItemIntoView(currItem);
    };

    LeftMenu.prototype.selectCurrentItem = function() {
      var currItem;
      currItem = this.sectionList.find('li.item.active');
      if (currItem.length === 0) {
        currItem = this.sectionList.find('li.item:first');
      }
      return currItem.trigger('click');
    };

    LeftMenu.prototype.scrollItemIntoView = function(item) {
      var bottomOfItemWithBuffer, currentScrollBottom, currentScrollTop, firstElement, itemHeight, itemPosition, scrollContainer, scrollContainerHeight, topOfItemWithBuffer;
      scrollContainer = item.closest('.section-list');
      firstElement = scrollContainer.find('.menu-section:first');
      currentScrollTop = scrollContainer.scrollTop();
      scrollContainerHeight = scrollContainer.height();
      currentScrollBottom = scrollContainerHeight + currentScrollTop;
      itemPosition = item.position().top - firstElement.position().top;
      itemHeight = item.height();
      topOfItemWithBuffer = itemPosition - itemHeight / 2;
      bottomOfItemWithBuffer = itemPosition + itemHeight + itemHeight / 2;
      if (topOfItemWithBuffer < currentScrollTop) {
        return scrollContainer.scrollTop(topOfItemWithBuffer);
      } else if (bottomOfItemWithBuffer > currentScrollBottom) {
        return scrollContainer.scrollTop(bottomOfItemWithBuffer - scrollContainerHeight);
      }
    };

    return LeftMenu;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.LeftMenuHelper = (function(superClass) {
    extend(LeftMenuHelper, superClass);

    LeftMenuHelper.include(Spine.Events);

    LeftMenuHelper.SEARCH_CACHE_REFRESH_INTERVAL_MSEC = 30 * 1000;

    LeftMenuHelper.SEARCH_CACHE_WIDGET_ID = 0;

    LeftMenuHelper.SEARCH_CACHE_DASHBOARD_ID = 1;

    LeftMenuHelper.SEARCH_CACHE_NAME = 2;

    LeftMenuHelper.SEARCH_CACHE_CREATED_AT = 3;

    LeftMenuHelper.SEARCH_CACHE_TOKENS = 4;

    LeftMenuHelper.SEARCH_CACHE_MAX_RESULTS = 25;

    LeftMenuHelper.CHART_MATCHES_SECTION = 'chart matches';

    LeftMenuHelper.ARCHIVED_KEYWORD = 'in:archived';

    LeftMenuHelper.transformSectionRecordsToDisplayData = function(recordsForOneSection) {
      var shouldAddWidgetId;
      shouldAddWidgetId = recordsForOneSection.name === LeftMenuHelper.CHART_MATCHES_SECTION;
      return {
        displayClass: recordsForOneSection.displayClass,
        items: _.map(recordsForOneSection.items, function(record) {
          var intermediateResults;
          intermediateResults = {
            cid: record.cid,
            "class": record.className || record.constructor.className,
            name: record.displayName(),
            status: typeof record.status === "function" ? record.status() : void 0,
            hasDataset: typeof record.hasDataset === "function" ? record.hasDataset() : void 0
          };
          if (record.guid != null) {
            intermediateResults.guid = record.guid;
          }
          if (shouldAddWidgetId) {
            intermediateResults.widgetId = record.widgetId;
          }
          return intermediateResults;
        }),
        name: recordsForOneSection.name
      };
    };

    LeftMenuHelper.newItem = function(baseClass) {
      var defaultProps, item, noPrivilgesExist;
      defaultProps = {
        is_fluid: true,
        isNewSite: true,
        user_id: App.User.currentUser().id
      };
      if (!['Widget', 'Site'].includes(baseClass.className)) {
        defaultProps.icon_color = window.reactApp.getColorRandomization(baseClass.className);
      }
      if (baseClass.DEFAULT_VALUES) {
        jQuery.extend(defaultProps, baseClass.DEFAULT_VALUES);
      }
      item = new baseClass(defaultProps);
      noPrivilgesExist = AppRedesign.current().state.RbacEnabled && !AppRedesign.hasPrivileges();
      if (!noPrivilgesExist) {
        if (baseClass === App.Dashboard) {
          App.Dashboard.persistNewDashboard(item);
        }
      }
      return item;
    };

    function LeftMenuHelper(baseClass1) {
      var classToWatch, j, len, ref;
      this.baseClass = baseClass1;
      this.fetchSearchCacheOnSuccess = bind(this.fetchSearchCacheOnSuccess, this);
      this.baseClassUpdate = bind(this.baseClassUpdate, this);
      this.scheduleBaseClassUpdate = bind(this.scheduleBaseClassUpdate, this);
      this.menuSections = bind(this.menuSections, this);
      LeftMenuHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'baseClass');
      App.Site.trigger('close-toast');
      this.resetCache();
      ref = this.classesToWatch();
      for (j = 0, len = ref.length; j < len; j++) {
        classToWatch = ref[j];
        classToWatch.bind('change', this.scheduleBaseClassUpdate);
      }
    }

    LeftMenuHelper.prototype.menuSections = function(searchQuery, showDatasetOnly) {
      var noPrivilgesExist;
      noPrivilgesExist = AppRedesign.current().state.RbacEnabled && !AppRedesign.hasPrivileges();
      if (!noPrivilgesExist) {
        if (this.baseClass === App.Dashboard) {
          this.fetchSearchCache();
        }
      }
      this._prevSearchQuery = searchQuery;
      return this._menuSections[searchQuery] = this.constructor.BuildMenuSections.call(this, searchQuery, showDatasetOnly);
    };

    LeftMenuHelper.prototype.infoText = function() {
      return this["infoFor" + this.baseClass.className];
    };

    LeftMenuHelper.prototype.searchingArchives = function() {
      return AppRedesign.autoArchiveEnabled() && _.startsWith(this._prevSearchQuery.toLowerCase(), LeftMenuHelper.ARCHIVED_KEYWORD);
    };

    LeftMenuHelper.prototype.classesToWatch = function() {
      var ref;
      return _.tap([this.baseClass, (ref = App[this.baseClass.className + "Star"]) != null ? ref : App.StarredItem, App.RecentItem], function(result) {
        if (this.baseClass === App.Dashboard) {
          return result.push(App.Tag);
        }
      });
    };

    LeftMenuHelper.prototype.scheduleBaseClassUpdate = function() {
      return AppRedesign.current().uiQueue.addOrReplace(this.baseClassUpdate, 'leftMenuUpdate');
    };

    LeftMenuHelper.prototype.menuSectionResults = function() {
      return this.menuSections(this._prevSearchQuery);
    };

    LeftMenuHelper.prototype.baseClassUpdate = function() {
      this.resetCache();
      return this.trigger('update');
    };

    LeftMenuHelper.prototype.resetCache = function() {
      return this._menuSections = {};
    };

    LeftMenuHelper.prototype.resetSearchCache = function() {
      this._searchCache = [];
      this._searchCacheLastLoaded = null;
      return this._searchCacheFetchPending = null;
    };

    LeftMenuHelper.prototype.release = function() {
      return this.baseClass.unbind('change', this.scheduleBaseClassUpdate);
    };

    LeftMenuHelper.prototype.fetchSearchCache = function() {
      if (!this.cachedResultsExpired()) {
        return;
      }
      this._searchCacheFetchPending = true;
      this._searchCacheLastLoaded = new Date().getTime();
      return jQuery.get("/sites/" + (App.Site.first().id) + "/get_search_cache", this.fetchSearchCacheOnSuccess);
    };

    LeftMenuHelper.prototype.cachedResultsExpired = function() {
      if (this._searchCacheLastLoaded == null) {
        return true;
      }
      return new Date().getTime() >= this.nextUpdateTime();
    };

    LeftMenuHelper.prototype.nextUpdateTime = function() {
      return this._searchCacheLastLoaded + this.constructor.SEARCH_CACHE_REFRESH_INTERVAL_MSEC;
    };

    LeftMenuHelper.prototype.fetchSearchCacheOnSuccess = function(searchResults) {
      this._searchCache = _.map(searchResults, function(searchResult) {
        var last;
        last = searchResult[2] === null ? [] : searchResult[LeftMenuHelper.SEARCH_CACHE_NAME].toLowerCase().replace(/\W+/, ' ').trim().split(/\s+/).sort();
        return _.at(searchResult, [LeftMenuHelper.SEARCH_CACHE_WIDGET_ID, LeftMenuHelper.SEARCH_CACHE_DASHBOARD_ID, LeftMenuHelper.SEARCH_CACHE_NAME, LeftMenuHelper.SEARCH_CACHE_CREATED_AT]).concat([last]);
      });
      return this._searchCacheFetchPending = false;
    };

    LeftMenuHelper.prototype.infoForSqlSnippet = {
      text: 'SQL Snippets are reusable SQL that you can substitute into your query.\nName your snippet "test markets" and give it SQL like "country in (\'CA\',\'AU\',\'UK\',\'NL\')" and you can write "where [test_markets]" in any SQL box in Sisense for Cloud Data Teams.',
      action: 'create'
    };

    LeftMenuHelper.prototype.infoForCsvView = {
      text: 'Uploaded CSVs can be queried like any table. Name your CSV "GA_data" and query it with "select * from [GA_data]".',
      action: 'upload'
    };

    LeftMenuHelper.prototype.infoForSqlView = {
      text: 'SQL Views are quick table definitions for your whole team to use. Sisense will automatically keep your SQL Views up to date.',
      action: 'create'
    };

    LeftMenuHelper.prototype.infoForSqlAlert = {
      text: 'SQL Alerts are notifications from your data that run on your database and email you when your conditions are met.',
      action: 'create'
    };

    LeftMenuHelper.BuildMenuSections = (function() {
      BuildMenuSections.call = function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return ((function(func, args, ctor) {
          ctor.prototype = func.prototype;
          var child = new ctor, result = func.apply(child, args);
          return Object(result) === result ? result : child;
        })(this, args, function(){})).call();
      };

      function BuildMenuSections(menuHelper, searchQuery1, showDatasetOnly1) {
        this.menuHelper = menuHelper;
        this.searchQuery = searchQuery1;
        this.showDatasetOnly = showDatasetOnly1;
        this.getWidgetSearchResults = bind(this.getWidgetSearchResults, this);
      }

      BuildMenuSections.prototype.call = function() {
        var j, len, r, ref, results;
        ref = this.recordsForAllSections();
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          r = ref[j];
          if (r.items.length) {
            results.push(r);
          }
        }
        return results;
      };

      BuildMenuSections.prototype.recordsForAllSections = function() {
        return _.concat(this.universalItems(), this.itemsForBaseClass(), this.searchItemsForBaseClass());
      };

      BuildMenuSections.prototype.universalItems = function() {
        if (this.menuHelper.searchingArchives()) {
          return [];
        }
        return [this.recordsForRecentItemsSection(), this.recordsForStarredItemsSection()];
      };

      BuildMenuSections.prototype.filterByDatasetOnly = function(items) {
        if (this.showDatasetOnly) {
          items = items.filter(function(item) {
            return item.hasDataset();
          });
        }
        return items;
      };

      BuildMenuSections.prototype.itemsForBaseClass = function() {
        return this["itemsFor" + this.menuHelper.baseClass.className]();
      };

      BuildMenuSections.prototype.searchItemsForBaseClass = function() {
        var name, ref;
        if (_.isEmpty(this.searchQuery) || this.menuHelper.searchingArchives()) {
          return [];
        }
        return (ref = typeof this[name = "searchItemsFor" + this.menuHelper.baseClass.className] === "function" ? this[name](this.searchQuery) : void 0) != null ? ref : [];
      };

      BuildMenuSections.prototype.itemsForSite = function() {
        var ref, siteItems;
        siteItems = _.map((ref = App.User.currentUser()) != null ? ref.accessibleSitesInFamily() : void 0, function(siteInfo) {
          siteInfo.cid = siteInfo.host;
          siteInfo.className = 'Site';
          siteInfo.displayName = function() {
            return siteInfo.display_name;
          };
          return siteInfo;
        });
        return [
          {
            items: _.filter(siteItems, (function(_this) {
              return function(item) {
                return App.Utils.matchesQuery(_this.searchQuery.split(' ').tokenize(), item.display_name.split(/\W+/).tokenize());
              };
            })(this))
          }
        ];
      };

      BuildMenuSections.prototype.searchSqlItems = function() {
        var items, queryTokens;
        queryTokens = this.searchQuery.toLowerCase().split(/\W+/);
        items = _.filter(this.menuHelper.baseClass.allSortedByName(), (function(_this) {
          return function(item) {
            return App.Utils.queryMatchesString(queryTokens, item.sql);
          };
        })(this));
        items = this.filterByDatasetOnly(items);
        return [
          {
            items: items,
            name: 'sql matches',
            displayClass: 'custom-match'
          }
        ];
      };

      BuildMenuSections.prototype.searchItemsForSqlAlert = function() {
        return this.searchSqlItems();
      };

      BuildMenuSections.prototype.getWidgetSearchResults = function() {
        var queryWords;
        if (_.isEmpty(this.searchQuery) || (this.menuHelper._searchCache == null)) {
          return [];
        }
        queryWords = this.searchQuery.split(/\s/).sort();
        return _(this.menuHelper._searchCache).filter(function(w) {
          return _.every(queryWords, function(queryWord) {
            return _.some(w[LeftMenuHelper.SEARCH_CACHE_TOKENS], _.method('startsWith', queryWord.toLowerCase()));
          });
        }).take(LeftMenuHelper.SEARCH_CACHE_MAX_RESULTS).map(function(w) {
          return {
            id: w[LeftMenuHelper.SEARCH_CACHE_WIDGET_ID],
            dashboardId: w[LeftMenuHelper.SEARCH_CACHE_DASHBOARD_ID],
            name: w[LeftMenuHelper.SEARCH_CACHE_NAME]
          };
        }).value();
      };

      BuildMenuSections.prototype.itemsForDashboard = function() {
        var allDashboards, ref, viewableDashboards;
        if (this.menuHelper.searchingArchives()) {
          return this.archivedItemsForDashboard();
        }
        allDashboards = App.Dashboard.allSortedByName(this.searchQuery);
        if ((ref = AppRedesign.current()) != null ? ref.state.RbacEnabled : void 0) {
          viewableDashboards = allDashboards;
        } else {
          viewableDashboards = App.Dashboard.allDashboardsVisibleToCurrentUser(allDashboards);
        }
        return _.concat(this.taggedSections(viewableDashboards), this.untaggedSections(viewableDashboards), this.allDashboardsSection(viewableDashboards), this.chartSections());
      };

      BuildMenuSections.prototype.archivedItemsForDashboard = function() {
        var viewableDashboards;
        viewableDashboards = App.SearchableArchive.searchDashboards(this.searchQuery);
        return _.concat(this.taggedItemsSections(viewableDashboards), this.untaggedItemsSection(viewableDashboards), this.allDashboardsSection(viewableDashboards));
      };

      BuildMenuSections.prototype.taggedSections = function(allDashboards) {
        var dashboardsByTag, j, k, l, len, len1, len2, ref, tag, tagIdToName, tagName, tag_id, taggedDashboard, taggedDashboards, taggedSections, uniq_tag_ids;
        dashboardsByTag = {};
        tagIdToName = {};
        ref = App.Tag.all();
        for (j = 0, len = ref.length; j < len; j++) {
          tag = ref[j];
          tagIdToName[tag.id] = tag.name;
        }
        dashboardsByTag.mine = _.filter(allDashboards, {
          user_id: App.User.currentUserId()
        });
        taggedDashboards = _.reject(allDashboards, function(dashboard) {
          return _.isEmpty(dashboard.tag_ids);
        });
        for (k = 0, len1 = taggedDashboards.length; k < len1; k++) {
          taggedDashboard = taggedDashboards[k];
          taggedDashboard.cleanTags();
          uniq_tag_ids = _.uniq(taggedDashboard.tag_ids);
          for (l = 0, len2 = uniq_tag_ids.length; l < len2; l++) {
            tag_id = uniq_tag_ids[l];
            tagName = tagIdToName[tag_id];
            if (!tagName) {
              continue;
            }
            if (dashboardsByTag[tagName] == null) {
              dashboardsByTag[tagName] = [];
            }
            dashboardsByTag[tagName].push(taggedDashboard);
          }
        }
        return taggedSections = _.map(dashboardsByTag, function(dashboards, tag) {
          return {
            items: dashboards,
            name: '#' + tag
          };
        }).sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });
      };

      BuildMenuSections.prototype.untaggedSections = function(allDashboards) {
        var untagged;
        untagged = _.filter(allDashboards, function(dashboard) {
          return _.isEmpty(dashboard.tag_ids);
        });
        return {
          items: untagged,
          name: 'untagged'
        };
      };

      BuildMenuSections.prototype.allDashboardsSection = function(viewableDashboards) {
        return {
          items: viewableDashboards,
          name: 'all'
        };
      };

      BuildMenuSections.prototype.chartSections = function() {
        var items;
        items = _.map(this.getWidgetSearchResults(), function(w) {
          var dashboard;
          dashboard = App.Dashboard.exists(w.dashboardId);
          return {
            cid: dashboard ? dashboard.cid : null,
            widgetId: w.id,
            className: App.Dashboard.className,
            displayName: function() {
              return w.name;
            }
          };
        });
        _.remove(items, function(item) {
          return !item.cid;
        });
        return {
          displayClass: 'custom-match',
          items: items,
          name: LeftMenuHelper.CHART_MATCHES_SECTION
        };
      };

      BuildMenuSections.prototype.itemsForSqlView = function() {
        var sqlViews;
        sqlViews = this.menuHelper.searchingArchives() ? App.SearchableArchive.searchSqlViews(this.searchQuery) : this.menuHelper.baseClass.allSortedByName(this.searchQuery);
        sqlViews = this.filterByDatasetOnly(sqlViews);
        return _.concat(this.taggedItemsSections(sqlViews), this.untaggedItemsSection(sqlViews), this.allItemsSection(sqlViews));
      };

      BuildMenuSections.prototype.itemsForCsvView = function() {
        var csvViews;
        csvViews = this.menuHelper.searchingArchives() ? App.SearchableArchive.searchCsvViews(this.searchQuery) : this.menuHelper.baseClass.allSortedByName(this.searchQuery);
        csvViews = this.filterByDatasetOnly(csvViews);
        return _.concat(this.taggedItemsSections(csvViews), this.untaggedItemsSection(csvViews), this.allItemsSection(csvViews));
      };

      BuildMenuSections.prototype.itemsForSqlAlert = function() {
        var sqlAlerts;
        sqlAlerts = this.menuHelper.baseClass.allSortedByName(this.searchQuery);
        return _.concat(this.taggedItemsSections(sqlAlerts), this.untaggedItemsSection(sqlAlerts), this.allItemsSection(sqlAlerts));
      };

      BuildMenuSections.prototype.itemsForSqlSnippet = function() {
        var sqlSnippets;
        sqlSnippets = this.menuHelper.baseClass.allSortedByName(this.searchQuery);
        return _.concat(this.taggedItemsSections(sqlSnippets), this.untaggedItemsSection(sqlSnippets), this.allItemsSection(sqlSnippets));
      };

      BuildMenuSections.prototype.taggedItemsSections = function(taggables) {
        var j, k, len, len1, ref, tagName, taggable, taggablesByTag, taggedSections, taggedTaggables;
        taggablesByTag = {};
        taggablesByTag['mine'] = _.filter(taggables, {
          owner_user_id: App.User.currentUserId()
        });
        taggedTaggables = _.reject(taggables, function(taggable) {
          return _.isEmpty(taggable.tag_names);
        });
        for (j = 0, len = taggedTaggables.length; j < len; j++) {
          taggable = taggedTaggables[j];
          ref = taggable.tag_names;
          for (k = 0, len1 = ref.length; k < len1; k++) {
            tagName = ref[k];
            if (taggablesByTag[tagName] == null) {
              taggablesByTag[tagName] = [];
            }
            taggablesByTag[tagName].push(taggable);
          }
        }
        return taggedSections = _.map(taggablesByTag, function(taggables, tag) {
          return {
            items: taggables,
            name: '#' + tag
          };
        }).sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });
      };

      BuildMenuSections.prototype.untaggedItemsSection = function(taggables) {
        var untaggedTaggables;
        untaggedTaggables = _.filter(taggables, function(taggable) {
          return _.isEmpty(taggable.tag_names);
        });
        return {
          items: untaggedTaggables,
          name: 'untagged'
        };
      };

      BuildMenuSections.prototype.searchItemsForSqlView = function() {
        return this.searchSqlItems();
      };

      BuildMenuSections.prototype.searchItemsForSqlSnippet = function() {
        return this.searchSqlItems();
      };

      BuildMenuSections.prototype.itemsForTestClass = function() {
        return this.allItemsSection(this.menuHelper.baseClass.allSortedByName(this.searchQuery));
      };

      BuildMenuSections.prototype.recordsForRecentItemsSection = function() {
        var existingItems, items, tokens;
        existingItems = App.RecentItem.recentForModelSorted(this.menuHelper.baseClass);
        tokens = (this.searchQuery || '').split(' ').tokenize();
        items = _.filter(existingItems, _.method('matchesQuery', tokens));
        items = this.filterByDatasetOnly(items);
        return {
          items: items,
          name: 'recent'
        };
      };

      BuildMenuSections.prototype.recordsForStarredItemsSection = function() {
        var i, items, starredDashboards, tokens;
        tokens = (this.searchQuery || '').split(' ').tokenize();
        if (this.menuHelper.baseClass === App.Dashboard) {
          starredDashboards = _(App.DashboardStar.all()).map(function(dashboardStar) {
            return App.Dashboard.exists(dashboardStar.dashboard_id);
          }).compact().filter(_.method('matchesQuery', tokens)).value();
          items = this.sortByLowerCaseName(starredDashboards);
          items = this.filterByDatasetOnly(items);
          return {
            items: items,
            name: 'starred'
          };
        } else {
          items = _.map(App.StarredItem.findAllByAttribute('item_type', this.menuHelper.baseClass.className), _.method('item'));
          items = (function() {
            var j, len, results;
            results = [];
            for (j = 0, len = items.length; j < len; j++) {
              i = items[j];
              if (i.matchesQuery(tokens)) {
                results.push(i);
              }
            }
            return results;
          })();
          items = this.sortByLowerCaseName(items);
          items = this.filterByDatasetOnly(items);
          return {
            items: items,
            name: 'starred'
          };
        }
      };

      BuildMenuSections.prototype.sortByLowerCaseName = function(items) {
        return _.sortBy(items, (function(n) {
          return (n.name || 'Untitled').toLowerCase();
        }));
      };

      BuildMenuSections.prototype.allItemsSection = function(items) {
        return {
          items: items,
          name: 'all'
        };
      };

      BuildMenuSections.prototype.myItemsSection = function() {
        return {
          items: this.myViews(),
          name: 'mine'
        };
      };

      BuildMenuSections.prototype.myViews = function() {
        var items;
        items = _.filter(this.menuHelper.baseClass.allSortedByName(this.searchQuery), (function(view) {
          return view.owner_user_id === App.User.currentUserId();
        }));
        return this.filterByDatasetOnly(items);
      };

      return BuildMenuSections;

    })();

    return LeftMenuHelper;

  })(Spine.Module);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LeftMenuReact = (function(superClass) {
    extend(LeftMenuReact, superClass);

    LeftMenuReact.prototype.className = 'left-menu wider';

    LeftMenuReact.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function LeftMenuReact(type) {
      LeftMenuReact.__super__.constructor.apply(this, arguments);
      this.html("<div class=\"react-root\" style='height:100%'></div>");
      App.Utils.logFeature('open-left-menu-' + type.toLowerCase());
      this.reactRoot = window.reactApp.leftMenuRoot(this.reactRootEl[0], type);
    }

    LeftMenuReact.prototype.release = function() {
      this.reactRoot.close();
      return LeftMenuReact.__super__.release.apply(this, arguments);
    };

    return LeftMenuReact;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LeftMenuSettings = (function(superClass) {
    extend(LeftMenuSettings, superClass);

    LeftMenuSettings.extend(Spine.Events);

    LeftMenuSettings.prototype.className = 'left-menu';

    LeftMenuSettings.prototype.events = {
      'click .settings-item': 'clickSettingsItem'
    };

    LeftMenuSettings.prototype.elements = {
      '.upsell-promo-react-container': 'upsellPromoReactContainer',
      '.new-feature-icon.RedesignDashboardRefreshController': 'drmNewFeatureIcon',
      '.new-feature-icon.RedesignQueryQueueController': 'qqFeatureIcon',
      '.new-feature-icon.UsageDataSettingsController': 'usageFeatureIcon',
      '.new-feature-icon.RedesignPreferencesController': 'preferencesFeatureIcon',
      '.upgrade-icon.RedesignDashboardRefreshController': 'drmUpgradeIcon',
      '.upgrade-icon.RedesignQueryQueueController': 'qqUpgradeIcon',
      '.upgrade-icon.UsageDataSettingsController': 'usageUpgradeIcon'
    };

    LeftMenuSettings.NON_ADMIN_OPTIONS = ['RedesignSettingsAccountController'];

    LeftMenuSettings.ADMIN = 'admin';

    LeftMenuSettings.BILLING_SECURITY = 'billingSecurity';

    LeftMenuSettings.CACHE = 'cache';

    LeftMenuSettings.CONNECTOR_INGESTION = 'connectorIngestion';

    LeftMenuSettings.CLUSTER_INFO = 'clusterInfo';

    LeftMenuSettings.VERSION_CONTROL = 'versionControl';

    LeftMenuSettings.RBAC = 'rbac';

    LeftMenuSettings.NOT_RBAC = 'notRbac';

    LeftMenuSettings.USAGE_DATA_SITE = 'usageDataSite';

    LeftMenuSettings.SUPPORT_ACCESS = 'supportAccess';

    LeftMenuSettings.ALL_FLAT_OPTIONS = [
      {
        controller: 'RedesignConfigitronController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'ConnectorIngestionController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CONNECTOR_INGESTION]
      }, {
        controller: 'RedesignCacheController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CACHE]
      }, {
        controller: 'ClusterInfoSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CLUSTER_INFO]
      }, {
        controller: 'RedesignBillingSecurityController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.BILLING_SECURITY]
      }, {
        controller: 'RedesignPreferencesController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'RedesignSettingsAccountController',
        dependencies: []
      }, {
        controller: 'RedesignQueryQueueController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'RedesignDashboardRefreshController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'UsageDataSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.USAGE_DATA_SITE]
      }, {
        controller: 'VersionControlSettingsPageController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.VERSION_CONTROL]
      }, {
        controller: 'RoleBasedPermissionsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.RBAC]
      }, {
        controller: 'RedesignPermissionsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.NOT_RBAC]
      }, {
        controller: 'SupportAccessSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.SUPPORT_ACCESS]
      }
    ];

    LeftMenuSettings.SPACE_SETTINGS_OPTIONS = [
      {
        controller: 'RedesignConfigitronController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'ConnectorIngestionController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CONNECTOR_INGESTION]
      }, {
        controller: 'RedesignCacheController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CACHE]
      }, {
        controller: 'RedesignPreferencesController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'RedesignQueryQueueController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'RedesignDashboardRefreshController',
        dependencies: [LeftMenuSettings.ADMIN]
      }, {
        controller: 'VersionControlSettingsPageController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.VERSION_CONTROL]
      }, {
        controller: 'RoleBasedPermissionsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.RBAC]
      }, {
        controller: 'RedesignPermissionsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.NOT_RBAC]
      }, {
        controller: 'SupportAccessSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.SUPPORT_ACCESS]
      }
    ];

    LeftMenuSettings.ACCOUNT_SETTINGS_OPTIONS = [
      {
        controller: 'RedesignDirectoryController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.NOT_RBAC]
      }, {
        controller: 'ClusterInfoSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.CLUSTER_INFO]
      }, {
        controller: 'RedesignBillingSecurityController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.BILLING_SECURITY]
      }, {
        controller: 'RedesignSettingsAccountController',
        dependencies: []
      }, {
        controller: 'UsageDataSettingsController',
        dependencies: [LeftMenuSettings.ADMIN, LeftMenuSettings.USAGE_DATA_SITE]
      }
    ];

    function LeftMenuSettings() {
      this.updateUpsell = bind(this.updateUpsell, this);
      var ref, ref1, ref2;
      LeftMenuSettings.__super__.constructor.apply(this, arguments);
      if ((ref = App.Site.first()) != null ? ref.dataEngineCloudAdminSite() : void 0) {
        this.html(this.view('redesign/controls/left_menu_settings_frame_dec')({
          settings: this.constructor.hierarchicalSettings()
        }));
      } else {
        this.html(this.view('redesign/controls/left_menu_settings_frame')({
          settings: this.constructor.hierarchicalSettings()
        }));
      }
      if ((ref1 = AppRedesign.current().tutorial()) != null) {
        if ((ref2 = ref1.tutorialMole) != null) {
          ref2.hide();
        }
      }
      App.Site.trigger('close-toast');
      App.Site.bind('change', this.updateUpsell);
      this.updateUpsell();
    }

    LeftMenuSettings.prototype.clickSettingsItem = function(e) {
      var settingsControllerClass, settingsItem;
      settingsItem = $(e.currentTarget);
      if (!settingsItem.hasClass('disabled-for-promo')) {
        settingsControllerClass = App[settingsItem.data('itemClass')];
        return this.trigger('settings-item-clicked', settingsControllerClass);
      } else {
        if (window.reactApp == null) {
          return;
        }
        if (typeof window.reactApp.upsellLeftMenuSettingsPromoClickLearnMore !== 'function') {
          return;
        }
        return window.reactApp.upsellLeftMenuSettingsPromoClickLearnMore();
      }
    };

    LeftMenuSettings.dependenciesFulfilled = function() {
      var dependenciesFulfilled, has_rbac, ref;
      dependenciesFulfilled = [];
      if (App.Utils.adminUser()) {
        dependenciesFulfilled.push(this.ADMIN);
      }
      if (!((ref = App.Utils) != null ? typeof ref.spaceAdminUser === "function" ? ref.spaceAdminUser() : void 0 : void 0)) {
        dependenciesFulfilled.push(this.BILLING_SECURITY);
      }
      if (App.Site.first().cached_site && App.Database.count() > 0 && !App.Site.first().byow_enabled) {
        dependenciesFulfilled.push(this.CACHE);
      }
      if (AppRedesign.connectorIngestionEnabled()) {
        dependenciesFulfilled.push(this.CONNECTOR_INGESTION);
      }
      if (App.Site.first().warehouse_enabled) {
        dependenciesFulfilled.push(this.CLUSTER_INFO);
      }
      if (App.Site.first().isVersionControlEnabled()) {
        dependenciesFulfilled.push(this.VERSION_CONTROL);
      }
      has_rbac = AppRedesign.current().state.RbacEnabled || AppRedesign.current().showRbacPermissionsPage;
      dependenciesFulfilled.push(has_rbac ? this.RBAC : this.NOT_RBAC);
      if (AppRedesign.current().state.ShowUsageData) {
        dependenciesFulfilled.push(this.USAGE_DATA_SITE);
      }
      if (App.Site.first().periscope_admin_access_ui_enabled) {
        dependenciesFulfilled.push(this.SUPPORT_ACCESS);
      }
      return dependenciesFulfilled;
    };

    LeftMenuSettings.hierarchicalSettings = function() {
      var dependenciesFulfilled, hierarchicalList;
      dependenciesFulfilled = this.dependenciesFulfilled();
      hierarchicalList = App.Site.isSpacesEnabled() && App.Utils.adminUser();
      if (!hierarchicalList) {
        return this.buildMenu(this.ALL_FLAT_OPTIONS, dependenciesFulfilled);
      }
      return {
        items: [
          {
            heading: 'SPACE SETTINGS',
            menu: this.buildMenu(this.SPACE_SETTINGS_OPTIONS, dependenciesFulfilled)
          }, {
            heading: 'ACCOUNT SETTINGS',
            menu: this.buildMenu(this.ACCOUNT_SETTINGS_OPTIONS, dependenciesFulfilled)
          }
        ],
        spaces: true
      };
    };

    LeftMenuSettings.allowedRoutes = function() {
      var dependenciesFulfilled, hierarchicalList, options, promotableFeatures;
      promotableFeatures = this.promotableFeatures();
      dependenciesFulfilled = this.dependenciesFulfilled();
      hierarchicalList = App.Site.isSpacesEnabled() && App.Utils.adminUser();
      options = hierarchicalList ? [].concat(this.SPACE_SETTINGS_OPTIONS, this.ACCOUNT_SETTINGS_OPTIONS) : this.ALL_FLAT_OPTIONS;
      return this.buildMenu(options, dependenciesFulfilled).filter(function(controllerName) {
        return promotableFeatures[controllerName] !== false;
      }).reduce((function(_this) {
        return function(result, controllerName) {
          var routeName, settingsControllerClass;
          settingsControllerClass = App[controllerName];
          routeName = _this.controllerToRouteName(settingsControllerClass);
          result[routeName] = {
            id: routeName,
            name: settingsControllerClass.TITLE,
            controller: controllerName
          };
          return result;
        };
      })(this), {});
    };

    LeftMenuSettings.controllerToRouteName = function(settingsControllerClass) {
      return (settingsControllerClass != null ? settingsControllerClass.URL_SLUG : void 0) || (settingsControllerClass != null ? settingsControllerClass.TITLE.replace(/[^a-zA-Z]+/g, '-').toLowerCase() : void 0);
    };

    LeftMenuSettings.buildMenu = function(options, dependenciesFulfilled) {
      var i, len, menu, option;
      menu = [];
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        if (_.difference(option.dependencies, dependenciesFulfilled).length === 0) {
          menu.push(option.controller);
        }
      }
      return menu;
    };

    LeftMenuSettings.prototype.updateUpsell = function() {
      this.maybeRenderUpsellPromo();
      return this.maybeRenderPromotableFeatures();
    };

    LeftMenuSettings.prototype.maybeRenderUpsellPromo = function() {
      var ref;
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        this.upsellPromoReactContainer.show();
        return this.reactRoot = window.reactApp.deepAnalysisUpsellLeftMenuSettingsPromoRoot(this.upsellPromoReactContainer[0]);
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        this.upsellPromoReactContainer.show();
        return this.reactRoot = window.reactApp.leftMenuSettingsPromoRoot(this.upsellPromoReactContainer[0]);
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        this.upsellPromoReactContainer.show();
        return this.reactRoot = window.reactApp.embedUpsellLeftMenuSettingsPromoRoot(this.upsellPromoReactContainer[0]);
      } else {
        this.upsellPromoReactContainer.hide();
        return (ref = this.reactRoot) != null ? ref.close() : void 0;
      }
    };

    LeftMenuSettings.prototype.maybeRenderPromotableFeatures = function() {
      var featureController, featureEnabled, ref, results;
      ref = this.constructor.promotableFeatures();
      results = [];
      for (featureController in ref) {
        featureEnabled = ref[featureController];
        results.push($(".settings-item." + featureController, this.el).toggle(featureEnabled));
      }
      return results;
    };

    LeftMenuSettings.promotableFeatures = function() {
      var periscope_admin, upsell_features;
      upsell_features = App.Site.first().existing_control_upsell_features;
      periscope_admin = App.User.currentUserIsPeriscopeAdmin();
      return {
        'RedesignDashboardRefreshController': (upsell_features != null ? upsell_features.dashboard_refresh : void 0) || periscope_admin,
        'RedesignQueryQueueController': (upsell_features != null ? upsell_features.query_queue : void 0) || periscope_admin,
        'UsageDataSettingsController': upsell_features != null ? upsell_features.metadata : void 0
      };
    };

    LeftMenuSettings.prototype.release = function() {
      var ref;
      App.Site.unbind('change', this.updateUpsell);
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return LeftMenuSettings.__super__.release.apply(this, arguments);
    };

    return LeftMenuSettings;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.LinkedWidgetContainerController = (function(superClass) {
    extend(LinkedWidgetContainerController, superClass);

    function LinkedWidgetContainerController() {
      this.update = bind(this.update, this);
      this.renderIfInViewport = bind(this.renderIfInViewport, this);
      this.release = bind(this.release, this);
      LinkedWidgetContainerController.__super__.constructor.apply(this, arguments);
      this.widgetContainer = new App.RedesignWidgetsController({
        el: this.el,
        item: this.item
      });
      this.bubbles(this.widgetContainer, 'edit-widget');
      this.bindEvents();
    }

    LinkedWidgetContainerController.prototype.release = function() {
      var ref;
      if (this.released) {
        return;
      }
      this.item.unbind("update", this.update);
      this.item.unbind("destroy", this.release);
      if ((ref = this.widgetContainer) != null) {
        ref.release();
      }
      this.released = true;
      return LinkedWidgetContainerController.__super__.release.apply(this, arguments);
    };

    LinkedWidgetContainerController.prototype.bindEvents = function() {
      this.eventsBound = true;
      this.item.bind("update", this.update);
      return this.item.bind("destroy", this.release);
    };

    LinkedWidgetContainerController.prototype.renderIfInViewport = function() {
      return this.widgetContainer.renderIfInViewport();
    };

    LinkedWidgetContainerController.prototype.update = function() {
      return this.widgetContainer.update();
    };

    return LinkedWidgetContainerController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ManageFiltersController = (function(superClass) {
    extend(ManageFiltersController, superClass);

    ManageFiltersController.prototype.className = 'manage-filters filter-modal modal';

    ManageFiltersController.prototype.events = {
      'click    .cancel-icon': 'hideFormWithSlide',
      'click    .small-checkbox .icon': 'checkboxClick'
    };

    ManageFiltersController.prototype.elements = {
      '.left-column': 'leftColumn',
      '.right-column': 'rightColumn',
      '.visible-list': 'visibleFiltersList',
      '.hidden-list': 'hiddenFiltersList'
    };

    function ManageFiltersController() {
      this.hideFormWithSlide = bind(this.hideFormWithSlide, this);
      this.hideFormWithoutReset = bind(this.hideFormWithoutReset, this);
      this.saveVisibleOrder = bind(this.saveVisibleOrder, this);
      this.checkboxClick = bind(this.checkboxClick, this);
      this.scrollWithoutLeaking = bind(this.scrollWithoutLeaking, this);
      ManageFiltersController.__super__.constructor.apply(this, arguments);
      this.open = false;
      App.CustomDimension.bind('edit', this.hideFormWithoutReset);
      this.html(this.view('redesign/dashboards/manage_filters_form')());
      this.hiddenFiltersList.on('wheel mousewheel', this.scrollWithoutLeaking);
      this.visibleFiltersList.on('wheel mousewheel', this.scrollWithoutLeaking);
      this.visibleFiltersList.sortable({
        axis: "y",
        containment: "parent",
        forcePlaceholderSize: true,
        tolerance: "pointer"
      }).on("sortstop", this.saveVisibleOrder);
    }

    ManageFiltersController.prototype.release = function() {
      this.hiddenFiltersList.off('wheel mousewheel', this.scrollWithoutLeaking);
      this.visibleFiltersList.off('wheel mousewheel', this.scrollWithoutLeaking);
      App.CustomDimension.unbind('edit', this.hideFormWithoutReset);
      if (this.visibleFiltersList.data("ui-sortable")) {
        this.visibleFiltersList.sortable("destroy");
      }
      return ManageFiltersController.__super__.release.apply(this, arguments);
    };

    ManageFiltersController.prototype.scrollWithoutLeaking = function(event) {
      return App.Utils.scrollWithoutLeaking(event, $(event.currentTarget));
    };

    ManageFiltersController.prototype.resetDimensionFormHeights = function() {
      var height;
      height = Math.max.apply(Math, [this.visibleFiltersList.height(), this.hiddenFiltersList.height()]);
      this.visibleFiltersList.height(height);
      return this.hiddenFiltersList.height(height);
    };

    ManageFiltersController.prototype.showForm = function() {
      if (this.open) {
        return;
      }
      this.open = true;
      ManageFiltersController.__super__.showForm.apply(this, arguments);
      this.el.addClass('open slideable');
      this.dashboard.trigger('dimension-form-opened');
      App.Dashboard.trigger('suppress-other-modals', {
        opener: this
      });
      this.renderFilters();
      return this.resetDimensionFormHeights();
    };

    ManageFiltersController.prototype.renderFilters = function() {
      var availableDims, cd, cdId, hiddenItems, i, len, list, ref, selected, sharedDims, visibleItems;
      availableDims = this.getAvailability();
      sharedDims = this.dashboard.filtersVisibleOnSharedDashboards();
      visibleItems = [];
      hiddenItems = [];
      ref = this.dashboard.allDimensionCidsInOrder();
      for (i = 0, len = ref.length; i < len; i++) {
        cdId = ref[i];
        cd = App.DimensionAvailability.dimensionExists(cdId);
        if (!cd) {
          continue;
        }
        selected = availableDims[cd.cid];
        list = selected ? visibleItems : hiddenItems;
        list.push(this.view('redesign/dashboards/custom_dimension_availability_item')({
          name: cd.name,
          cid: cd.cid,
          selected: selected,
          disabled: App.Utils.isValueTrue(sharedDims, cd.id)
        }));
      }
      this.visibleFiltersList.html(visibleItems.join(''));
      this.hiddenFiltersList.html(hiddenItems.join(''));
      return this.refreshElements();
    };

    ManageFiltersController.prototype.getAllDimensions = function() {
      var aggregation, date_range;
      aggregation = {
        name: 'Aggregation',
        cid: App.CustomDimension.AGGREGATION,
        id: 'aggregation'
      };
      date_range = {
        name: 'Date Range',
        cid: App.CustomDimension.DATE_RANGE,
        id: 'date_range'
      };
      return App.CustomDimension.allSortedByName().concat([aggregation, date_range]);
    };

    ManageFiltersController.prototype.checkboxClick = function(e) {
      var cd, cdEl, isSelected;
      cdEl = $(e.target).closest('.small-checkbox');
      if (!(cdEl.length > 0)) {
        return;
      }
      if (cdEl.hasClass('disabled') && cdEl.hasClass('selected')) {
        return;
      }
      cdEl.toggleClass('selected');
      isSelected = cdEl.hasClass('selected');
      cd = App.DimensionAvailability.dimensionExists(cdEl.attr('cd_cid'));
      if (cd) {
        return this.setAvailability(cd.id, isSelected);
      }
    };

    ManageFiltersController.prototype.getAvailability = function() {
      return App.DimensionAvailability.availableForDashboard(this.dashboard);
    };

    ManageFiltersController.prototype.setAvailability = function(id, available) {
      var index;
      if (!available && this.dashboard.dimension_order) {
        index = this.dashboard.dimension_order.indexOf(id);
        if (index !== -1) {
          this.dashboard.dimension_order.splice(index, 1);
        }
      }
      App.DimensionAvailability.setForDashboard(this.dashboard, id, available);
      return this.renderFilters();
    };

    ManageFiltersController.prototype.saveVisibleOrder = function() {
      this.dashboard.dimension_order = this.getDimensionOrder();
      return this.dashboard.save();
    };

    ManageFiltersController.prototype.getDimensionOrder = function() {
      var active_filters;
      active_filters = [];
      this.visibleFiltersList.children().each(function() {
        var attr, id, ref;
        attr = $(this).attr("cd_cid");
        id = ((ref = App.CustomDimension.exists(attr)) != null ? ref.id : void 0) || attr;
        if (!active_filters.includes(id)) {
          return active_filters.push(id);
        }
      });
      return active_filters;
    };

    ManageFiltersController.prototype.hideFormWithoutReset = function() {
      return this.hideForm(false);
    };

    ManageFiltersController.prototype.hideFormWithSlide = function() {
      return _.tap(ManageFiltersController.__super__.hideFormWithSlide.apply(this, arguments), (function(_this) {
        return function(result) {
          if (result) {
            return _this.dashboard.trigger('manage-filters-form-closed');
          }
        };
      })(this));
    };

    return ManageFiltersController;

  })(App.RedesignDashboardSettingsForm);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.NonPaymentBarController = (function(superClass) {
    extend(NonPaymentBarController, superClass);

    function NonPaymentBarController() {
      NonPaymentBarController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.deadline = AppRedesign.current().nonPaymentDeadline;
      this.render();
    }

    NonPaymentBarController.prototype.render = function() {
      return this.html(this.view('app_frame/non_payment_bar')({
        daysLeft: this.daysLeft(),
        userIsAdmin: App.User.currentUser().isAdmin()
      }));
    };

    NonPaymentBarController.prototype.daysLeft = function() {
      var deadlineMoment, displayTz, momentTz, now;
      displayTz = App.Site.first().display_timezone;
      momentTz = App.TimeMachine.mapDisplayTimezone(displayTz);
      now = moment().tz(momentTz);
      deadlineMoment = moment(this.deadline).tz(momentTz);
      return deadlineMoment.diff(now, 'days');
    };

    NonPaymentBarController.prototype.now = function() {
      return moment();
    };

    NonPaymentBarController.shouldShow = function() {
      return AppRedesign.current().nonPaymentDeadline != null;
    };

    return NonPaymentBarController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.NpsSurveyResponseController = (function(superClass) {
    extend(NpsSurveyResponseController, superClass);

    NpsSurveyResponseController.prototype.elements = {
      '.nps-survey-response-form-panel': 'formPanel',
      '.nps-survey-response-thank-you-panel': 'thankYouBody',
      '.nps-survey-response-form': 'form',
      '.nps-survey-response-explanation-and-submit': 'formExplanationAndSubmit',
      '.nps-survey-response-explanation': 'formExplanationTextArea',
      '.nps-survey-response-score-label': 'scoreLabels'
    };

    NpsSurveyResponseController.prototype.events = {
      'click .cancel-icon': 'completeSurveyResponseAndRelease',
      'click .nps-survey-response-submit-button': 'completeSurveyResponseAndThankUser',
      'change .nps-survey-response-score-radio': 'saveAndExpandForm'
    };

    function NpsSurveyResponseController() {
      this.releaseIfNpsSurveyResponseCompleted = bind(this.releaseIfNpsSurveyResponseCompleted, this);
      this.render = bind(this.render, this);
      NpsSurveyResponseController.__super__.constructor.apply(this, arguments);
      this.el.appendTo('.sticky-footer-panels');
      this.render();
      this.updateSurveyResponseAsShown();
      new App.Textarea({
        el: this.formExplanationTextArea
      });
      this.npsSurveyResponse.bind('update', this.releaseIfNpsSurveyResponseCompleted);
    }

    NpsSurveyResponseController.prototype.render = function() {
      return this.html(this.view('redesign/nps_survey_response/form')({
        npsSurveyResponse: this.npsSurveyResponse
      }));
    };

    NpsSurveyResponseController.prototype.saveSurveyResponse = function(e) {
      return App.NpsSurveyResponse.fromForm(this.form).updateSurveyResponse();
    };

    NpsSurveyResponseController.prototype.updateSurveyResponseAsShown = function(e) {
      var npsSurveyResponse;
      npsSurveyResponse = App.NpsSurveyResponse.fromForm(this.form);
      npsSurveyResponse.shown = true;
      return npsSurveyResponse.updateSurveyResponse();
    };

    NpsSurveyResponseController.prototype.releaseIfNpsSurveyResponseCompleted = function() {
      if (this.npsSurveyResponse.isCompleted() && this.notShowingThankYou()) {
        return this.release();
      }
    };

    NpsSurveyResponseController.prototype.completeSurveyResponse = function(e) {
      var npsSurveyResponse;
      npsSurveyResponse = App.NpsSurveyResponse.fromForm(this.form);
      npsSurveyResponse.completed = true;
      return npsSurveyResponse.updateSurveyResponse();
    };

    NpsSurveyResponseController.prototype.completeSurveyResponseAndRelease = function(e) {
      e.preventDefault();
      this.completeSurveyResponse(e);
      return this.release();
    };

    NpsSurveyResponseController.prototype.completeSurveyResponseAndThankUser = function(e) {
      e.preventDefault();
      this.completeSurveyResponse(e);
      this.hideForm();
      return this.showThankYou();
    };

    NpsSurveyResponseController.prototype.saveAndExpandForm = function(e) {
      this.saveSurveyResponse(e);
      return this.expandForm();
    };

    NpsSurveyResponseController.prototype.expandForm = function() {
      return this.formExplanationAndSubmit.removeClass('hidden');
    };

    NpsSurveyResponseController.prototype.hideForm = function() {
      return this.formPanel.addClass('hidden');
    };

    NpsSurveyResponseController.prototype.showThankYou = function() {
      return this.thankYouBody.removeClass('hidden');
    };

    NpsSurveyResponseController.prototype.notShowingThankYou = function() {
      return this.thankYouBody.hasClass('hidden');
    };

    return NpsSurveyResponseController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGetStartedController = (function(superClass) {
    extend(RedesignGetStartedController, superClass);

    function RedesignGetStartedController() {
      RedesignGetStartedController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/onboarding/get_started')());
    }

    RedesignGetStartedController.prototype.submit = function() {
      return this.trigger('success');
    };

    RedesignGetStartedController.prototype.release = function() {
      if (App.Site.first().tutorial_enabled) {
        return AppRedesign.current().walkMe.init();
      }
    };

    return RedesignGetStartedController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignInviteUsersController = (function(superClass) {
    extend(RedesignInviteUsersController, superClass);

    RedesignInviteUsersController.prototype.elements = {
      '.emails': 'emailsForm',
      '.error': 'error'
    };

    function RedesignInviteUsersController() {
      this.handlePostError = bind(this.handlePostError, this);
      this.handlePostSuccess = bind(this.handlePostSuccess, this);
      this.submit = bind(this.submit, this);
      RedesignInviteUsersController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/onboarding/invite_users')());
    }

    RedesignInviteUsersController.prototype.submit = function() {
      var unparsedEmails;
      unparsedEmails = this.unparsedEmails();
      if (this.validateEmails(unparsedEmails)) {
        return this.postInviteUsers(unparsedEmails);
      }
    };

    RedesignInviteUsersController.prototype.unparsedEmails = function() {
      return this.emailsForm.val();
    };

    RedesignInviteUsersController.prototype.validateEmails = function(unparsedEmails) {
      var emails, non_blank_emails, valid_emails;
      emails = unparsedEmails.split(/[,\s]+/);
      non_blank_emails = _.filter(emails, (function(e) {
        return !App.Utils.isBlank(e);
      }));
      valid_emails = _.filter(non_blank_emails, App.Utils.probablyAValidEmailAddress);
      if (non_blank_emails.length === 0) {
        this.showError('Please enter some emails.');
        return false;
      } else if (valid_emails.length !== non_blank_emails.length) {
        this.showError('Invalid email address.');
        return false;
      } else {
        return true;
      }
    };

    RedesignInviteUsersController.prototype.postInviteUsers = function(unparsedEmails) {
      var params;
      this.error.text('');
      params = {
        unparsed_emails: unparsedEmails,
        client_site_id: App.Site.first().id
      };
      return jQuery.post("/users/invite_new_users", params).done(this.handlePostSuccess).fail(this.handlePostError);
    };

    RedesignInviteUsersController.prototype.handlePostSuccess = function(res) {
      var ref;
      if (res.status === 'error') {
        return this.showError(res.body);
      } else {
        if ((ref = AppRedesign.current().tutorial()) != null) {
          ref.logFeature('invite-colleagues', res.count, this.logContext);
        }
        return this.trigger('success');
      }
    };

    RedesignInviteUsersController.prototype.handlePostError = function(res) {
      return this.showError('Unknown error occured, please contact support.');
    };

    RedesignInviteUsersController.prototype.showError = function(error) {
      this.error.text(error);
      return this.trigger('error');
    };

    return RedesignInviteUsersController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignOnboardingController = (function(superClass) {
    extend(RedesignOnboardingController, superClass);

    RedesignOnboardingController.prototype.elements = {
      '.onboarding-main-column': 'onboardingMainColumn',
      '.onboarding-sidebar': 'sidebar',
      '.sidebar-title': 'sidebarTitle',
      '.sidebar-blurb': 'sidebarBlurb',
      '.sidebar-progress': 'sidebarProgress'
    };

    RedesignOnboardingController.prototype.events = {
      'click .sidebar-help a': 'sidebarLinkClick'
    };

    RedesignOnboardingController.prototype.sidebarLinkClick = function(e) {
      var eventName, t;
      t = $(e.currentTarget);
      eventName = (function() {
        switch (false) {
          case !t.hasClass('contact-support'):
            return 'contact-support-click';
          case !t.hasClass('contact-ae'):
            return 'contact-ae-click';
          case !t.attr('href').includes(AppRedesign.DOC_PATH):
            return 'doc-link-click';
          default:
            return 'other-link-click';
        }
      })();
      return this.createTutorialLog(eventName);
    };

    function RedesignOnboardingController() {
      this.release = bind(this.release, this);
      this.closeAuthForm = bind(this.closeAuthForm, this);
      this.stageSuccess = bind(this.stageSuccess, this);
      this.loadPreviousStage = bind(this.loadPreviousStage, this);
      this.loadNextStage = bind(this.loadNextStage, this);
      this.sidebarLinkClick = bind(this.sidebarLinkClick, this);
      RedesignOnboardingController.__super__.constructor.apply(this, arguments);
      App.HotkeyManager.disable();
      App.Utils.requires(this, 'el', 'stages', 'logContext');
      this.html(this.view('redesign/onboarding/onboarding_wizard')());
      this.paneFactory = new App.RedesignOnboardingPaneFactory();
      this.completedStages = {};
      this.stageIndex = -1;
      this.pane = null;
      this.loadNextStage();
    }

    RedesignOnboardingController.frameEl = function() {
      return $('<div class="onboarding-wizard"></div>');
    };

    RedesignOnboardingController.prototype.loadNextStage = function() {
      if (this.onLastStage()) {
        return this.closeAuthForm();
      } else {
        this.stageIndex += 1;
        return this.loadStage(this.currentStage());
      }
    };

    RedesignOnboardingController.prototype.loadPreviousStage = function() {
      this.stageIndex = this.previousStageIdx();
      return this.loadStage(this.stages[this.stageIndex]);
    };

    RedesignOnboardingController.prototype.previousStageIdx = function() {
      var idx;
      idx = this.stageIndex - 1;
      while (idx > -1) {
        if (!this.completedStages[this.stages[idx]]) {
          return idx;
        }
        idx -= 1;
      }
      return null;
    };

    RedesignOnboardingController.prototype.canBack = function() {
      return this.previousStageIdx() !== null;
    };

    RedesignOnboardingController.prototype.canSkip = function() {
      return this.pane.canSkip();
    };

    RedesignOnboardingController.prototype.onLastStage = function() {
      return this.stageIndex >= (this.stages.length - 1);
    };

    RedesignOnboardingController.prototype.isSingleStage = function() {
      return this.stages.length === 1;
    };

    RedesignOnboardingController.prototype.stageSuccess = function(onlyCompletableOnce) {
      if (onlyCompletableOnce) {
        this.completedStages[this.currentStage()] = true;
      }
      return this.loadNextStage();
    };

    RedesignOnboardingController.prototype.createTutorialLog = function(evt) {
      var ref;
      return (ref = AppRedesign.current().tutorial()) != null ? ref.logFeature(evt, this.currentStage(), this.logContext) : void 0;
    };

    RedesignOnboardingController.prototype.loadStage = function(stage) {
      var ref;
      if ((ref = this.pane) != null) {
        ref.release();
      }
      this.pane = this.paneFactory.paneByStage(stage, this.logContext);
      if (this.canBack()) {
        this.pane.showBack();
      }
      if (this.canSkip()) {
        this.showSkipOrCancel();
      }
      this.pane.onSuccess((function(_this) {
        return function() {
          return _this.createTutorialLog('onboard-step-success');
        };
      })(this));
      this.pane.onSkip((function(_this) {
        return function() {
          return _this.createTutorialLog('onboard-step-skip');
        };
      })(this));
      this.pane.onBack((function(_this) {
        return function() {
          return _this.createTutorialLog('onboard-step-back');
        };
      })(this));
      this.pane.onCancel((function(_this) {
        return function() {
          return _this.createTutorialLog('onboard-step-cancel');
        };
      })(this));
      this.pane.onSuccess(this.stageSuccess);
      this.pane.onSkip(this.loadNextStage);
      this.pane.onBack(this.loadPreviousStage);
      this.pane.onCancel(this.closeAuthForm);
      this.sidebar.html(this.pane.sidebarView);
      this.onboardingMainColumn.html(this.pane.el);
      this.refreshElements();
      this.updateProgressDots();
      return this.createTutorialLog('onboard-step-show');
    };

    RedesignOnboardingController.prototype.showSkipOrCancel = function() {
      if (this.isSingleStage()) {
        return this.pane.showCancel();
      } else {
        return this.pane.showSkip();
      }
    };

    RedesignOnboardingController.prototype.progressDotClasses = function() {
      var currentStage, dotClasses, i, len, ref, stage;
      if (this.stages.length === 1) {
        return [];
      }
      dotClasses = [];
      currentStage = this.currentStage();
      ref = this.stages;
      for (i = 0, len = ref.length; i < len; i++) {
        stage = ref[i];
        if (stage === currentStage) {
          dotClasses.push('current');
        } else if (this.completedStages[stage]) {
          dotClasses.push('unavailable');
        } else {
          dotClasses.push('available');
        }
      }
      return dotClasses;
    };

    RedesignOnboardingController.prototype.updateProgressDots = function() {
      if (this.stages.length === 1) {
        return;
      }
      return this.sidebarProgress.html(this.view('redesign/onboarding/onboarding_wizard_progress')({
        dotClasses: this.progressDotClasses()
      }));
    };

    RedesignOnboardingController.prototype.currentStage = function() {
      return this.stages[this.stageIndex];
    };

    RedesignOnboardingController.prototype.closeAuthForm = function() {
      var mainDashboard, ref, ref1;
      App.HotkeyManager.enable();
      this.trigger('close');
      if (App.FivetranSnowflakeSsu.isOnboarding()) {
        mainDashboard = App.FivetranSnowflakeSsu.mainDashboard();
        App.Site.first().updateAttribute('default_dashboard_id', mainDashboard.id);
        $('.dashboard-icon.dashboard').trigger('click');
        setTimeout(function() {
          var ref;
          if ((ref = $("li:contains('" + mainDashboard.name + "')")[0]) != null) {
            ref.click();
          }
          App.FivetranSnowflakeSsu.landingDashboard().destroy();
          return App.Database.findByAttribute('database_type', 'redshift').destroy();
        }, 400);
        return (ref = AppRedesign.current().tutorial()) != null ? ref.permanentlyCompleteTour() : void 0;
      } else {
        return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.setupFlowComplete() : void 0;
      }
    };

    RedesignOnboardingController.prototype.release = function() {
      var ref;
      RedesignOnboardingController.__super__.release.apply(this, arguments);
      if ((ref = this.pane) != null) {
        ref.release();
      }
      App.HotkeyManager.enable();
      return typeof this.closeCallback === "function" ? this.closeCallback() : void 0;
    };

    return RedesignOnboardingController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignOnboardingPane = (function(superClass) {
    extend(RedesignOnboardingPane, superClass);

    RedesignOnboardingPane.prototype.elements = {
      '.onboarding-body-content': 'bodyContent',
      '.onboarding-body': 'body',
      '.onboarding-button-row': 'buttonRow',
      '.onboarding-button-row .submit': 'submitButton',
      '.onboarding-button-row .back': 'backButton',
      '.onboarding-button-row .cancel': 'cancelButton',
      '.onboarding-button-row .skip': 'skipLink'
    };

    RedesignOnboardingPane.prototype.events = {
      'click .onboarding-button-row .submit': 'clickedSubmit',
      'click .onboarding-button-row .skip': 'clickedSkip',
      'click .onboarding-button-row .back': 'clickedBack',
      'click .onboarding-button-row .cancel': 'clickedCancel',
      'click .help-icon': 'helpClick',
      'keypress .onboarding-button-row .button': 'clickOnEnterOrSpace'
    };

    RedesignOnboardingPane.prototype.clickOnEnterOrSpace = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER || e.which === AppRedesign.KEYS.SPACE) {
        return $(e.currentTarget).trigger('click');
      }
    };

    RedesignOnboardingPane.DONE_DELAY = 1000;

    RedesignOnboardingPane.CSS_BUSY_BUTTON = 'busy-button-spinner';

    function RedesignOnboardingPane() {
      this.externalControllerContentExpanded = bind(this.externalControllerContentExpanded, this);
      this.externalControllerError = bind(this.externalControllerError, this);
      this.exit = bind(this.exit, this);
      this.externalControllerSuccess = bind(this.externalControllerSuccess, this);
      this.onBack = bind(this.onBack, this);
      this.onSkip = bind(this.onSkip, this);
      this.onCancel = bind(this.onCancel, this);
      this.onSuccess = bind(this.onSuccess, this);
      this.endBusyState = bind(this.endBusyState, this);
      this.startBusyState = bind(this.startBusyState, this);
      this.clickedCancel = bind(this.clickedCancel, this);
      this.clickedBack = bind(this.clickedBack, this);
      this.clickedSkip = bind(this.clickedSkip, this);
      this.clickedSubmit = bind(this.clickedSubmit, this);
      this.setSubmitLabel = bind(this.setSubmitLabel, this);
      this.clickOnEnterOrSpace = bind(this.clickOnEnterOrSpace, this);
      RedesignOnboardingPane.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'title', 'externalController', 'submitLabel', 'submitCallback', 'skippable', 'onlyCompletableOnce', 'sidebarView');
      if (this.skipMessage == null) {
        this.skipMessage = null;
      }
      this.busy = false;
      this.render();
      this.connectExternalController();
      if (typeof this.createCallback === "function") {
        this.createCallback();
      }
    }

    RedesignOnboardingPane.prototype.setSubmitLabel = function(submitLabel) {
      this.submitLabel = submitLabel;
      this.endBusyState();
      return this.submitButton.text(this.submitLabel);
    };

    RedesignOnboardingPane.prototype.render = function() {
      this.html(this.view('redesign/onboarding/onboarding_pane')({
        title: this.title,
        submitLabel: this.submitLabel,
        showSkip: this.skippable,
        showTitleHelpIcon: this.helpLink != null,
        skipMessage: this.skipMessage
      }));
      if (this.noOverflow) {
        return this.bodyContent.addClass('no-overflow');
      }
    };

    RedesignOnboardingPane.prototype.connectExternalController = function() {
      this.bodyContent.append(this.externalController.el);
      if (this.contentCssClass != null) {
        this.body.addClass(this.contentCssClass);
      }
      this.externalController.bind('success', this.externalControllerSuccess);
      this.externalController.bind('error', this.externalControllerError);
      this.externalController.bind('busy', this.startBusyState);
      return this.externalController.bind('content-expanded', this.externalControllerContentExpanded);
    };

    RedesignOnboardingPane.prototype.clickedSubmit = function() {
      if (this.busy) {
        return;
      }
      this.startBusyState();
      return this.submitCallback();
    };

    RedesignOnboardingPane.prototype.clickedSkip = function() {
      return this.trigger('skip');
    };

    RedesignOnboardingPane.prototype.clickedBack = function() {
      return this.trigger('back');
    };

    RedesignOnboardingPane.prototype.clickedCancel = function() {
      return this.trigger('cancel');
    };

    RedesignOnboardingPane.prototype.showBack = function() {
      return this.backButton.show();
    };

    RedesignOnboardingPane.prototype.showCancel = function() {
      return this.cancelButton.show();
    };

    RedesignOnboardingPane.prototype.showSkip = function() {
      return this.skipLink.show();
    };

    RedesignOnboardingPane.prototype.canSkip = function() {
      return this.skippable;
    };

    RedesignOnboardingPane.prototype.helpClick = function() {
      return window.open(this.helpLink);
    };

    RedesignOnboardingPane.prototype.startBusyState = function() {
      this.busy = true;
      return this.submitButton.addClass(this.constructor.CSS_BUSY_BUTTON);
    };

    RedesignOnboardingPane.prototype.endBusyState = function() {
      this.busy = false;
      return this.submitButton.removeClass(this.constructor.CSS_BUSY_BUTTON);
    };

    RedesignOnboardingPane.prototype.onSuccess = function(callback) {
      return this.bind('success', callback);
    };

    RedesignOnboardingPane.prototype.onCancel = function(callback) {
      return this.bind('cancel', callback);
    };

    RedesignOnboardingPane.prototype.onSkip = function(callback) {
      return this.bind('skip', callback);
    };

    RedesignOnboardingPane.prototype.onBack = function(callback) {
      return this.bind('back', callback);
    };

    RedesignOnboardingPane.prototype.externalControllerSuccess = function() {
      return this.exitSoon();
    };

    RedesignOnboardingPane.prototype.exitSoon = function() {
      this.submitButton.removeClass(this.constructor.CSS_BUSY_BUTTON).addClass('done');
      return setTimeout(this.exit, App.RedesignOnboardingPane.DONE_DELAY);
    };

    RedesignOnboardingPane.prototype.exit = function() {
      this.trigger('success', this.onlyCompletableOnce);
      return this.release();
    };

    RedesignOnboardingPane.prototype.release = function() {
      this.externalController.release();
      return RedesignOnboardingPane.__super__.release.apply(this, arguments);
    };

    RedesignOnboardingPane.prototype.externalControllerError = function(msg) {
      return this.endBusyState();
    };

    RedesignOnboardingPane.prototype.externalControllerContentExpanded = function() {
      return this.scrollToBottom();
    };

    RedesignOnboardingPane.prototype.scrollToBottom = function() {
      return this.bodyContent.scrollTop(9000);
    };

    RedesignOnboardingPane.createControllerEl = function() {
      return $('<div class="external-controller"></div>');
    };

    return RedesignOnboardingPane;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignOnboardingPaneFactory = (function() {
    function RedesignOnboardingPaneFactory() {
      this.requiredBillingPane = bind(this.requiredBillingPane, this);
      this.optionalBillingPane = bind(this.optionalBillingPane, this);
      this.getStartedPane = bind(this.getStartedPane, this);
      this.inviteUsersPane = bind(this.inviteUsersPane, this);
      this.connectDatabasePane = bind(this.connectDatabasePane, this);
      this.tfaPane = bind(this.tfaPane, this);
      this.forgotPasswordPane = bind(this.forgotPasswordPane, this);
      this.passwordPane = bind(this.passwordPane, this);
      this.createPaneEl = bind(this.createPaneEl, this);
    }

    RedesignOnboardingPaneFactory.STAGE_PASSWORD = 'stage-password';

    RedesignOnboardingPaneFactory.STAGE_FORGOT_PASSWORD = 'stage-forgot-password';

    RedesignOnboardingPaneFactory.STAGE_TFA = 'stage-tfa';

    RedesignOnboardingPaneFactory.STAGE_DB = 'stage-db';

    RedesignOnboardingPaneFactory.STAGE_INVITE = 'stage-invite';

    RedesignOnboardingPaneFactory.STAGE_GET_STARTED = 'stage-get-started';

    RedesignOnboardingPaneFactory.STAGE_BILLING = 'stage-billing';

    RedesignOnboardingPaneFactory.STAGE_BILLING_REQUIRED = 'stage-billing-required';

    RedesignOnboardingPaneFactory.stagesForCurrentUser = function() {
      return App.RedesignOnboardingPaneFactory.stagesForUser(AppRedesign.current().passwordResetRequired(), AppRedesign.current().userForgotPassword(), AppRedesign.current().tfaSetupRequired(), App.User.currentUser().isAdmin(), App.User.count() === 1, App.Database.onlyExampleDbConnected(), App.Site.first().sso_enabled, App.FivetranSnowflakeSsu.isOnboarding(), AppRedesign.current().isSSUTrialUser());
    };

    RedesignOnboardingPaneFactory.stagesForUser = function(setPassword, forgotPassword, setupTFA, isAdmin, isOnlyUser, onlyExampleDbConnected, ssoEnabled, snowflakeSsuOnboarding, ssuTrial) {
      var opc, stages;
      opc = App.RedesignOnboardingPaneFactory;
      stages = [];
      if (setPassword) {
        if (forgotPassword) {
          stages.push(opc.STAGE_FORGOT_PASSWORD);
        } else {
          stages.push(opc.STAGE_PASSWORD);
        }
      }
      if (setupTFA) {
        stages.push(opc.STAGE_TFA);
      }
      if (isAdmin) {
        if ((onlyExampleDbConnected && !ssuTrial) || snowflakeSsuOnboarding) {
          stages.push(opc.STAGE_DB);
        }
        if (isOnlyUser && !ssoEnabled) {
          stages.push(opc.STAGE_INVITE);
        }
      }
      stages.push(opc.STAGE_GET_STARTED);
      return stages;
    };

    RedesignOnboardingPaneFactory.prototype.createPaneEl = function(title) {
      return $('<div class="onboarding-pane"></div>');
    };

    RedesignOnboardingPaneFactory.prototype.paneByStage = function(stage, logContext) {
      var fn, opf;
      opf = App.RedesignOnboardingPaneFactory;
      fn = (function() {
        switch (stage) {
          case opf.STAGE_PASSWORD:
            return this.passwordPane;
          case opf.STAGE_FORGOT_PASSWORD:
            return this.forgotPasswordPane;
          case opf.STAGE_TFA:
            return this.tfaPane;
          case opf.STAGE_DB:
            return this.connectDatabasePane;
          case opf.STAGE_INVITE:
            return this.inviteUsersPane;
          case opf.STAGE_GET_STARTED:
            return this.getStartedPane;
          case opf.STAGE_BILLING:
            return this.optionalBillingPane;
          case opf.STAGE_BILLING_REQUIRED:
            return this.requiredBillingPane;
          default:
            throw "Invalid onboarding stage: " + stage;
        }
      }).call(this);
      return fn(logContext);
    };

    RedesignOnboardingPaneFactory.prototype.passwordPane = function() {
      var setPasswordController;
      App.Utils.logFeature('saw_initial_in_app_form_with_password_pane', {
        user_id: App.User.currentUserId()
      });
      setPasswordController = new App.RedesignSetPasswordFormController({
        el: App.RedesignOnboardingPane.createControllerEl(),
        forgotPassword: false,
        skipHotkeyDisable: true,
        noAutoRelease: true
      });
      return new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Create Account',
        externalController: setPasswordController,
        submitLabel: 'Create',
        submitCallback: ((function(_this) {
          return function() {
            return setPasswordController.formSubmit();
          };
        })(this)),
        skippable: false,
        onlyCompletableOnce: true,
        sidebarView: this.view('redesign/onboarding/sidebar_create_account')({
          amazon_flow: readCookie("periscope_amazon_signup"),
          is_trial: App.Site.first().isActiveTrial()
        })
      });
    };

    RedesignOnboardingPaneFactory.prototype.forgotPasswordPane = function() {
      var setPasswordController;
      setPasswordController = new App.RedesignSetPasswordFormController({
        el: App.RedesignOnboardingPane.createControllerEl(),
        forgotPassword: true,
        skipHotkeyDisable: true,
        noAutoRelease: true
      });
      return new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Reset Password',
        externalController: setPasswordController,
        submitLabel: 'Reset',
        submitCallback: ((function(_this) {
          return function() {
            return setPasswordController.formSubmit();
          };
        })(this)),
        skippable: false,
        onlyCompletableOnce: true,
        sidebarView: this.view('redesign/onboarding/sidebar_forgot_password')()
      });
    };

    RedesignOnboardingPaneFactory.prototype.tfaPane = function() {
      var pane, twoFactorController;
      twoFactorController = new App.RedesignTfaSetupForm({
        el: App.RedesignOnboardingPane.createControllerEl(),
        selfEnabled: false
      });
      pane = new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Two Factor Authentication',
        externalController: twoFactorController,
        submitLabel: 'Verify',
        submitCallback: ((function(_this) {
          return function() {
            return twoFactorController.onboardingPaneSubmit();
          };
        })(this)),
        skippable: false,
        onlyCompletableOnce: true,
        noOverflow: true,
        sidebarView: this.view('redesign/onboarding/sidebar_tfa')()
      });
      twoFactorController.bind('stage-transition', function() {
        return pane.setSubmitLabel('next');
      });
      return pane;
    };

    RedesignOnboardingPaneFactory.prototype.connectDatabasePane = function(logContext) {
      var connectDatabaseExtraParams, databaseConnectController;
      connectDatabaseExtraParams = {
        create_token: App.Utils.makeGuid(),
        client_site_id: App.Site.first().id
      };
      if (App.FivetranSnowflakeSsu.isOnboarding()) {
        connectDatabaseExtraParams['id'] = App.Database.first().id;
      }
      databaseConnectController = new App.DatabaseConnectForm({
        el: App.RedesignOnboardingPane.createControllerEl(),
        submitRoute: "/databases/update_settings",
        pollRoute: "/databases/poll_doctor",
        uploadKeyRoute: "/databases/upload_bigquery_key",
        uploadSnowflakePk8KeyRoute: "/databases/upload_snowflake_key",
        uploadSnowflakeCacheablePk8KeyRoute: "/databases/upload_snowflake_cacheable_key",
        newCustomer: false,
        extraParams: connectDatabaseExtraParams,
        successMessage: "The database connection was successful!",
        infoGrid: true,
        noDbLoader: true,
        logContext: logContext
      });
      return new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Connect Database',
        externalController: databaseConnectController,
        submitLabel: 'Connect',
        submitCallback: ((function(_this) {
          return function() {
            return databaseConnectController.submit();
          };
        })(this)),
        skippable: !App.FivetranSnowflakeSsu.isOnboarding(),
        skipMessage: 'Connect to Demo Database',
        onlyCompletableOnce: true,
        sidebarView: this.view('redesign/onboarding/sidebar_connect_db')(),
        contentCssClass: 'db-pane',
        helpLink: AppRedesign.DOC_PATH + '/connecting-to-periscope-menu',
        createCallback: ((function(_this) {
          return function() {
            return _.noop;
          };
        })(this))
      });
    };

    RedesignOnboardingPaneFactory.prototype.inviteUsersPane = function(logContext) {
      var inviteUsersController, mainDashboard;
      if (App.FivetranSnowflakeSsu.isOnboarding()) {
        mainDashboard = App.FivetranSnowflakeSsu.mainDashboard();
        mainDashboard.refreshAllWidgets();
        App.CustomDimension.each(function(cd) {
          $.post("/custom_dimensions/" + cd.id + "/refresh_values").done((function(_this) {
            return function(res) {
              return cd.applyHash(res);
            };
          })(this));
          cd.last_data_loaded_at = null;
          cd.error_message = null;
          return cd.save({
            ajax: false
          });
        });
      }
      inviteUsersController = new App.RedesignInviteUsersController({
        el: App.RedesignOnboardingPane.createControllerEl(),
        logContext: logContext
      });
      return new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Invite Colleagues',
        externalController: inviteUsersController,
        submitLabel: 'Invite',
        submitCallback: ((function(_this) {
          return function() {
            return inviteUsersController.submit();
          };
        })(this)),
        skippable: true,
        onlyCompletableOnce: false,
        sidebarView: this.view('redesign/onboarding/sidebar_invite_users')()
      });
    };

    RedesignOnboardingPaneFactory.prototype.getStartedPane = function() {
      var getStartedController;
      getStartedController = new App.RedesignGetStartedController({
        el: App.RedesignOnboardingPane.createControllerEl()
      });
      return new App.RedesignOnboardingPane({
        el: this.createPaneEl(),
        title: 'Get Started',
        externalController: getStartedController,
        submitLabel: 'Ready!',
        submitCallback: ((function(_this) {
          return function() {
            return getStartedController.submit();
          };
        })(this)),
        skippable: false,
        onlyCompletableOnce: false,
        sidebarView: this.view('redesign/onboarding/sidebar_get_started')()
      });
    };

    RedesignOnboardingPaneFactory.prototype.optionalBillingPane = function() {
      return this.billingPane(true);
    };

    RedesignOnboardingPaneFactory.prototype.requiredBillingPane = function() {
      return this.billingPane(false);
    };

    RedesignOnboardingPaneFactory.prototype.billingPane = function(skippable) {};

    RedesignOnboardingPaneFactory.prototype.view = function(name) {
      return JST["app/views/" + name];
    };

    return RedesignOnboardingPaneFactory;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignSetupFlow = (function() {
    function RedesignSetupFlow(context) {
      this.context = context;
      this.openNewDialogForStages = bind(this.openNewDialogForStages, this);
      this.showStage = bind(this.showStage, this);
      this.showOnboardingFlow = bind(this.showOnboardingFlow, this);
      this.run = bind(this.run, this);
      App.Utils.requires(this, 'context');
    }

    RedesignSetupFlow.prototype.delayedRun = function() {
      return setTimeout(this.run, 100);
    };

    RedesignSetupFlow.prototype.run = function() {
      var ref;
      if (this.noAuthToSetup()) {
        if ((ref = AppRedesign.current().tutorial()) != null) {
          ref.setupFlowComplete();
        }
        if (!App.FivetranSnowflakeSsu.initialDatabaseConnected()) {
          return;
        }
      }
      return this.showOnboardingFlow();
    };

    RedesignSetupFlow.prototype.app = function() {
      return AppRedesign.current();
    };

    RedesignSetupFlow.prototype.noAuthToSetup = function() {
      return !(this.app().passwordResetRequired() || this.app().userForgotPassword() || this.app().tfaSetupRequired());
    };

    RedesignSetupFlow.prototype.openDialog = function(viewController, cssClasses, closeCallback) {
      return App.RedesignDialog.createDialog({
        title: '',
        viewController: viewController,
        warning: false,
        noCancel: true,
        customDialogClass: cssClasses,
        noAnimationOpen: true,
        closeCallback: closeCallback
      });
    };

    RedesignSetupFlow.prototype.showOnboardingFlow = function() {
      return this.openNewDialogForStages(App.RedesignOnboardingPaneFactory.stagesForCurrentUser());
    };

    RedesignSetupFlow.prototype.showStage = function(stage) {
      return this.openNewDialogForStages([stage]);
    };

    RedesignSetupFlow.prototype.openNewDialogForStages = function(stages) {
      var onboardingController;
      if (stages.length === 1 && stages[0] === App.RedesignOnboardingPaneFactory.STAGE_BILLING) {
        return new App.ZuoraBillingModalController({
          showCancel: true
        });
      } else {
        onboardingController = new App.RedesignOnboardingController({
          el: App.RedesignOnboardingController.frameEl(),
          stages: stages,
          logContext: this.context
        });
        return this.openDialog(onboardingController, 'onboarding-wizard-dialog', null);
      }
    };

    return RedesignSetupFlow;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignTutorialFlow = (function() {
    RedesignTutorialFlow.SAMPLE_QUERY = 'select date(gameplays.created_at), source, count(*)\nfrom [periscope_views.gameplays+periscope_views.users]\ngroup by 1, 2';

    function RedesignTutorialFlow(appFrameEl, countdownOnly) {
      this.appFrameEl = appFrameEl;
      this.countdownOnly = countdownOnly;
      this.showSqlBoxTip = bind(this.showSqlBoxTip, this);
      this.sqlboxTipText = bind(this.sqlboxTipText, this);
      this.showRunButtonTip = bind(this.showRunButtonTip, this);
      this.showChartTip = bind(this.showChartTip, this);
      this.showMole = bind(this.showMole, this);
      this.queryRan = bind(this.queryRan, this);
      this.editorExit = bind(this.editorExit, this);
      this.hideAllTips = bind(this.hideAllTips, this);
      this.permanentlyCompleteTour = bind(this.permanentlyCompleteTour, this);
      this.unDismissTour = bind(this.unDismissTour, this);
      this.dismissTour = bind(this.dismissTour, this);
      this.enabled = bind(this.enabled, this);
      this._role = App.UserRole.currentRole();
    }

    RedesignTutorialFlow.prototype.role = function() {
      return this._role.reload();
    };

    RedesignTutorialFlow.prototype.logFeature = function(event, detail, context) {
      if (context == null) {
        context = null;
      }
      return App.Utils.logFeature(event, {
        context: context,
        detail: detail
      });
    };

    RedesignTutorialFlow.prototype.chartTutorialCompleted = function() {
      return Boolean(this.role().chart_tutorial_completed_at);
    };

    RedesignTutorialFlow.prototype.chartTutorialDismissed = function() {
      return Boolean(this.role().chart_tutorial_dismissed_at);
    };

    RedesignTutorialFlow.prototype.enabled = function() {
      return !this.chartTutorialCompleted() && !this.chartTutorialDismissed() && !this.countdownOnly;
    };

    RedesignTutorialFlow.prototype.dismissTour = function(sourceTip) {
      var ref, role;
      this.logFeature('chart-tutorial-dismissed', sourceTip);
      role = this.role();
      role.chart_tutorial_dismissed_at = true;
      role.save();
      this.hideAllTips();
      return (ref = this.tutorialMole) != null ? ref.render() : void 0;
    };

    RedesignTutorialFlow.prototype.unDismissTour = function() {
      var ref, role;
      role = this.role();
      role.chart_tutorial_dismissed_at = false;
      role.save();
      this.showChartTip();
      if (AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON) {
        this.showSqlBoxTip();
      }
      return (ref = this.tutorialMole) != null ? ref.render() : void 0;
    };

    RedesignTutorialFlow.prototype.permanentlyCompleteTour = function() {
      var role;
      role = this.role();
      role.chart_tutorial_completed_at = AppRedesign.timestamp();
      role.save();
      this.hideAllTips();
      return this.pendingExpandMole = true;
    };

    RedesignTutorialFlow.prototype.hideAllTips = function() {
      this.hideSqlTip();
      this.hideRunTip();
      return this.hideNewChartTip();
    };

    RedesignTutorialFlow.prototype.editorExit = function() {
      var ref;
      if (this.pendingExpandMole) {
        if ((ref = this.tutorialMole) != null) {
          ref.expand();
        }
      }
      return delete this.pendingExpandMole;
    };

    RedesignTutorialFlow.prototype.setupFlowComplete = function() {
      return requestAnimationFrame(((function(_this) {
        return function() {
          _this.showChartTip();
          return _this.showMole();
        };
      })(this)), 0);
    };

    RedesignTutorialFlow.prototype.sqlEditorKeypress = function(sqlInEditor) {
      if (sqlInEditor) {
        return this.showRunButtonTip();
      } else {
        return this.showSqlBoxTip();
      }
    };

    RedesignTutorialFlow.prototype.codeMirrorClicked = function() {
      return this.showRunButtonTip();
    };

    RedesignTutorialFlow.prototype.sqlboxLoaded = function(setSqlFunc) {
      if (!this.enabled()) {
        return;
      }
      this.showSqlBoxTip();
      if (App.Database.onlyExampleDbConnected()) {
        return setSqlFunc(App.RedesignTutorialFlow.SAMPLE_QUERY);
      }
    };

    RedesignTutorialFlow.prototype.queryRan = function() {
      return this.permanentlyCompleteTour();
    };

    RedesignTutorialFlow.prototype.showMole = function() {
      if (readCookie("periscope_amazon_signup")) {
        return;
      }
      if (this.tutorialMole != null) {
        return;
      }
      this.tutorialMole = new App.RedesignTutorialMole(this.countdownOnly);
      this.appFrameEl.append(this.tutorialMole.el);
      App.UserRole.bind('change', this.tutorialMole.render);
      App.User.bind('change', this.tutorialMole.render);
      return App.Database.bind('change', this.tutorialMole.render);
    };

    RedesignTutorialFlow.prototype.showChartTip = function() {
      var ref, ref1, targetEl;
      if (!this.enabled()) {
        return;
      }
      targetEl = this.appFrameEl.find('.dashboard-container.active .new-chart-button');
      if (!targetEl.length) {
        return;
      }
      if ((ref = this.newChartTip) != null ? ref.visible() : void 0) {
        return;
      }
      this.logShowTooltip('new-chart-tip');
      if ((ref1 = this.newChartTip) != null) {
        ref1.release();
      }
      return this.newChartTip = new App.TutorialTooltip(App.RedesignTooltipPanel.RIGHT, targetEl, 'Create Charts using SQL', AppRedesign.DOC_PATH + '/chart-overview').showAndReparent(0, 0.5, '.dashboard-container.active').onClose((function(_this) {
        return function() {
          return _this.dismissTour('new-chart-tip');
        };
      })(this));
    };

    RedesignTutorialFlow.prototype.showRunButtonTip = function() {
      var ref, ref1, targetEl;
      if (!this.enabled()) {
        return;
      }
      targetEl = this.appFrameEl.find('.editor-panel .run-box .action-medium');
      if (!targetEl.length) {
        return;
      }
      if ((ref = this.runButtonTip) != null ? ref.visible() : void 0) {
        return;
      }
      this.logShowTooltip('run-button-tip');
      if ((ref1 = this.runButtonTip) != null) {
        ref1.release();
      }
      this.runButtonTip = new App.TutorialTooltip(App.RedesignTooltipPanel.RIGHT, targetEl, 'Visualize your data!', AppRedesign.DOC_PATH + '/chart-overview').show(0, 0.33).onClose((function(_this) {
        return function() {
          return _this.dismissTour('run-button-tip');
        };
      })(this));
      return this.hideSqlTip();
    };

    RedesignTutorialFlow.prototype.sqlboxTipText = function() {
      if (App.Database.onlyExampleDbConnected()) {
        return 'This is the SQL Editor.<p>Use our sample query or begin typing to get started.';
      } else {
        return 'This is the SQL Editor.<p>Type your SQL query here.';
      }
    };

    RedesignTutorialFlow.prototype.showSqlBoxTip = function() {
      var ref, ref1, targetEl;
      if (!this.enabled()) {
        return;
      }
      targetEl = this.appFrameEl.find('.editor-panel .sql-box');
      if (!targetEl.length) {
        return;
      }
      if ((ref = this.sqlTip) != null ? ref.visible() : void 0) {
        return;
      }
      this.logShowTooltip('sql-box-tip');
      if ((ref1 = this.sqlTip) != null) {
        ref1.release();
      }
      this.sqlTip = new App.TutorialTooltip(App.RedesignTooltipPanel.TOP, targetEl, this.sqlboxTipText(), AppRedesign.DOC_PATH + '/chart-overview').show(0.2, -0.85).onClose((function(_this) {
        return function() {
          return _this.dismissTour('sql-box-tip');
        };
      })(this));
      return this.hideRunTip();
    };

    RedesignTutorialFlow.prototype.tooltipsActive = function() {
      return (this.newChartTip != null) || (this.sqlTip != null) || (this.runButtonTip != null);
    };

    RedesignTutorialFlow.prototype.hideNewChartTip = function() {
      var ref, ref1;
      if ((ref = this.newChartTip) != null ? ref.visible() : void 0) {
        this.logHideTooltip('new-chart-tip');
      }
      if ((ref1 = this.newChartTip) != null) {
        ref1.release();
      }
      return delete this.newChartTip;
    };

    RedesignTutorialFlow.prototype.hideSqlTip = function() {
      var ref, ref1;
      if ((ref = this.sqlTip) != null ? ref.visible() : void 0) {
        this.logHideTooltip('sql-box-tip');
      }
      if ((ref1 = this.sqlTip) != null) {
        ref1.release();
      }
      return delete this.sqlTip;
    };

    RedesignTutorialFlow.prototype.hideRunTip = function() {
      var ref, ref1;
      if ((ref = this.runButtonTip) != null ? ref.visible() : void 0) {
        this.logHideTooltip('run-button-tip');
      }
      if ((ref1 = this.runButtonTip) != null) {
        ref1.release();
      }
      return delete this.runButtonTip;
    };

    RedesignTutorialFlow.prototype.window = function() {
      return window;
    };

    RedesignTutorialFlow.prototype.logHideTooltip = function(tip) {
      return this.logFeature('hide-tooltip', tip, this.chartTutorialCompleted() ? 'permanent' : '');
    };

    RedesignTutorialFlow.prototype.logShowTooltip = function(tip) {
      return this.logFeature('show-tooltip', tip);
    };

    return RedesignTutorialFlow;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignTutorialMole = (function(superClass) {
    extend(RedesignTutorialMole, superClass);

    RedesignTutorialMole.prototype.className = 'tutorial-mole';

    RedesignTutorialMole.prototype.elements = {
      '.tutorial-mole-popup': 'tutorialMolePopup',
      '.purchase-step': 'purchaseStep'
    };

    RedesignTutorialMole.prototype.events = {
      'click .mole-day-count': 'toggleMoleOpen',
      'click .title': 'closePopup',
      'click li': 'itemClicked',
      'click .button': 'itemClicked'
    };

    function RedesignTutorialMole(countdownOnly) {
      this.itemClicked = bind(this.itemClicked, this);
      this.setClosed = bind(this.setClosed, this);
      this.render = bind(this.render, this);
      RedesignTutorialMole.__super__.constructor.apply(this, arguments);
      this.countdownOnly = countdownOnly;
      this.renderInitial();
      this.setClosed(this.tooltipsShowing());
    }

    RedesignTutorialMole.prototype.render = function() {
      this.role = App.UserRole.currentRole();
      return this.renderHtml(this.rerenderPopupIfAlreadyOpen());
    };

    RedesignTutorialMole.prototype.renderInitial = function() {
      this.role = App.UserRole.currentRole();
      return this.renderHtml(this.showPopup());
    };

    RedesignTutorialMole.prototype.renderHtml = function(showPopup) {
      var stages;
      this.site = App.Site.first();
      stages = App.RedesignOnboardingPaneFactory.stagesForCurrentUser();
      this.html(this.view('redesign/tutorial/mole')({
        countdownOnly: this.countdownOnly,
        showConnect: stages.includes(App.RedesignOnboardingPaneFactory.STAGE_DB),
        showInvite: stages.includes(App.RedesignOnboardingPaneFactory.STAGE_INVITE),
        showCreate: this.canShowCreateChart(),
        daysLeft: this.site.days_remaining_in_ssu_trial,
        showPopup: showPopup,
        salesEmailAddress: this.site.sales_owner_email
      }));
      return this.setButtonState();
    };

    RedesignTutorialMole.prototype.rerenderPopupIfAlreadyOpen = function() {
      return !this.moleHidden() && this.showPopup();
    };

    RedesignTutorialMole.prototype.setButtonState = function() {
      if (this.site.stripe_monthly_amount != null) {
        return this.purchaseStep.attr('stage', 'buy');
      } else if (this.role.contacted_sales_at != null) {
        return this.purchaseStep.attr('stage', 'contacted');
      } else {
        return this.purchaseStep.attr('stage', 'to-contact');
      }
    };

    RedesignTutorialMole.prototype.showPopup = function() {
      var popupDismissedTime, yesterday;
      if (this.tooltipsEnabled() || this.countdownOnly) {
        return false;
      }
      if (this.role.tutorial_popup_dismissed_at == null) {
        return true;
      }
      yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      popupDismissedTime = new Date(this.role.tutorial_popup_dismissed_at);
      if (popupDismissedTime === "Invalid Date") {
        return true;
      }
      return popupDismissedTime < yesterday;
    };

    RedesignTutorialMole.prototype.tooltipsEnabled = function() {
      var ref;
      return (ref = AppRedesign.current().tutorial()) != null ? ref.enabled() : void 0;
    };

    RedesignTutorialMole.prototype.tooltipsShowing = function() {
      var ref;
      return (ref = AppRedesign.current().tutorial()) != null ? ref.tooltipsActive() : void 0;
    };

    RedesignTutorialMole.prototype.canShowCreateChart = function() {
      if ((App.UserRole.currentRole().chart_tutorial_completed_at != null) || this.countdownOnly) {
        return false;
      }
      return !this.tooltipsShowing();
    };

    RedesignTutorialMole.prototype.hide = function() {
      return this.setClosed(true);
    };

    RedesignTutorialMole.prototype.expand = function() {
      return this.setClosed(false);
    };

    RedesignTutorialMole.prototype.closePopup = function() {
      var ref, role;
      role = App.UserRole.currentRole();
      role.tutorial_popup_dismissed_at = true;
      role.save();
      this.hide();
      return (ref = AppRedesign.current().tutorial()) != null ? ref.logFeature('mole-toggle', 'hide') : void 0;
    };

    RedesignTutorialMole.prototype.openPopup = function() {
      var ref, role;
      if (this.countdownOnly) {
        return null;
      }
      role = App.UserRole.currentRole();
      role.tutorial_popup_dismissed_at = false;
      role.save();
      this.expand();
      return (ref = AppRedesign.current().tutorial()) != null ? ref.logFeature('mole-toggle', 'show') : void 0;
    };

    RedesignTutorialMole.prototype.setClosed = function(isClosed) {
      return this.tutorialMolePopup.toggleClass('closed', isClosed);
    };

    RedesignTutorialMole.prototype.moleHidden = function() {
      return this.tutorialMolePopup.hasClass('closed');
    };

    RedesignTutorialMole.prototype.itemClicked = function(evt) {
      var opf, target, tutorial;
      target = $(evt.currentTarget).data('menu-item');
      opf = App.RedesignOnboardingPaneFactory;
      switch (target) {
        case 'connect':
          this.invokeSetupFlowStage(opf.STAGE_DB);
          break;
        case 'invite':
          this.invokeSetupFlowStage(opf.STAGE_INVITE);
          break;
        case 'create':
          this.startCreateChartTour();
          break;
        case 'buy':
          this.invokeSetupFlowStage(opf.STAGE_BILLING);
          break;
        case 'contact':
          this.contactSales();
      }
      this.hide();
      tutorial = AppRedesign.current().tutorial();
      if (tutorial != null) {
        tutorial.hideAllTips();
        return tutorial.logFeature('mole-click', target);
      }
    };

    RedesignTutorialMole.prototype.startCreateChartTour = function() {
      var ref;
      return (ref = AppRedesign.current().tutorial()) != null ? ref.unDismissTour() : void 0;
    };

    RedesignTutorialMole.prototype.invokeSetupFlowStage = function(stage) {
      var setupFlow;
      setupFlow = new App.RedesignSetupFlow('mole-initiated');
      return setupFlow.showStage(stage);
    };

    RedesignTutorialMole.prototype.toggleMoleOpen = function() {
      if (this.countdownOnly) {
        return;
      }
      if (this.moleHidden()) {
        return this.openPopup();
      } else {
        return this.closePopup();
      }
    };

    RedesignTutorialMole.prototype.contactSales = function() {
      var ref;
      $.post("/users/user_roles/" + this.role.id + "/contact_sales", {});
      this.role.contacted_sales_at = (new Date()).getTime();
      this.role.save({
        ajax: false
      });
      return (ref = AppRedesign.current().tutorial()) != null ? ref.logFeature('contact-sales', 'mole-initiated') : void 0;
    };

    return RedesignTutorialMole;

  })(Spine.Controller);

}).call(this);
(function() {
  App.FivetranSnowflakeSsu = (function() {
    function FivetranSnowflakeSsu() {}

    FivetranSnowflakeSsu.FORM_TYPE = 'ssu-fivetran-snowflake';

    FivetranSnowflakeSsu.INITIAL_DATABASE_HOST = 'fivetran_dummy_host';

    FivetranSnowflakeSsu.LANDING_DASHBOARD_NAME = 'Welcome to Sisense for Cloud Data Teams!';

    FivetranSnowflakeSsu.MAIN_DASHBOARD_NAME = 'Marketing Channels';

    FivetranSnowflakeSsu.FORM_TYPE = 'ssu-fivetran-snowflake';

    FivetranSnowflakeSsu.initialDatabaseConnected = function() {
      var database;
      if (!this.isOnboarding()) {
        return false;
      }
      database = App.Database.findByAttribute('database_type', 'snowflake');
      return database.database_host === this.INITIAL_DATABASE_HOST;
    };

    FivetranSnowflakeSsu.landingDashboard = function() {
      return App.Dashboard.findByAttribute('name', this.LANDING_DASHBOARD_NAME);
    };

    FivetranSnowflakeSsu.mainDashboard = function() {
      return App.Dashboard.findByAttribute('name', this.MAIN_DASHBOARD_NAME);
    };

    FivetranSnowflakeSsu.isOnboarding = function() {
      var ref;
      return ((ref = AppRedesign.current()) != null ? ref.betaSignupFormType : void 0) === this.FORM_TYPE;
    };

    return FivetranSnowflakeSsu;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PreferencesColorPickerController = (function(superClass) {
    extend(PreferencesColorPickerController, superClass);

    function PreferencesColorPickerController() {
      return PreferencesColorPickerController.__super__.constructor.apply(this, arguments);
    }

    PreferencesColorPickerController.prototype.className = 'gradient-color-picker';

    PreferencesColorPickerController.prototype.elements = {
      '.custom.color-content': 'colorPickerArea',
      '.recent.color-content': 'recentColorsArea'
    };

    PreferencesColorPickerController.prototype.events = {
      'click .action.reset': 'resetColor',
      'click .action.delete': 'deleteColor',
      'click .action.save': 'updateAndRelease',
      'click .rotator-title': 'toggleRotator'
    };

    PreferencesColorPickerController.prototype.render = function() {
      this.html(this.view('redesign/settings/theme_color_picker')({
        show_delete: this.showDelete
      }));
      return PreferencesColorPickerController.__super__.render.apply(this, arguments);
    };

    PreferencesColorPickerController.prototype.setTargetColor = function() {
      if (this.colorToSet) {
        return this.targetColor.css({
          'background-color': this.colorToSet
        });
      }
    };

    return PreferencesColorPickerController;

  })(App.SingleColorPickerController);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PreferencesColorThemeController = (function(superClass) {
    extend(PreferencesColorThemeController, superClass);

    PreferencesColorThemeController.prototype.className = 'theme-selection sg-row';

    PreferencesColorThemeController.prototype.events = {
      'click .sg-gear': 'toggleMenu',
      'mouseleave .sg-gear-holder': 'detachMenu'
    };

    PreferencesColorThemeController.prototype.elements = {
      '.color-cell .color-square': 'squares'
    };

    function PreferencesColorThemeController() {
      this.updateTheme = bind(this.updateTheme, this);
      this.toggleMenu = bind(this.toggleMenu, this);
      this.clickedColorTheme = bind(this.clickedColorTheme, this);
      this.render = bind(this.render, this);
      PreferencesColorThemeController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'colorTheme', 'site');
      this.render();
    }

    PreferencesColorThemeController.prototype.render = function() {
      this.html(this.view("redesign/settings/color_theme_preference")({
        colorTheme: this.colorTheme,
        hideGear: this.hideGear()
      }));
      return this.addBorders();
    };

    PreferencesColorThemeController.prototype.hideGear = function() {
      return this.colorTheme.isPeriscopeDefault && this.periscopeDefaultIsAlreadyApplied();
    };

    PreferencesColorThemeController.prototype.periscopeDefaultIsAlreadyApplied = function() {
      return this.site.colorTheme().id === App.ColorTheme.PERISCOPE_DEFAULT_THEME().id;
    };

    PreferencesColorThemeController.prototype.clickedColorTheme = function(theme) {
      this.colorThemeController = new App.RedesignSettingsColorThemesController({
        colorTheme: theme
      });
      return this.colorThemeController.bind('updated', this.render);
    };

    PreferencesColorThemeController.prototype.toggleMenu = function(evt) {
      var gear, gearParent;
      evt.stopPropagation();
      gear = $(evt.currentTarget).closest('.sg-gear');
      gearParent = $(evt.currentTarget).closest('.sg-gear-holder');
      return this.toggleMenuElement(gear, gearParent);
    };

    PreferencesColorThemeController.prototype.updateTheme = function() {
      this.detachMenu();
      this.render();
      return this.addBorders();
    };

    PreferencesColorThemeController.prototype.addBorders = function() {
      return this.squares.each(function() {
        var square;
        square = $(this);
        return App.ColorHelper.toggleBorderClassOnColorLightness(square, square.css('background-color'), 'show-border', 220);
      });
    };

    PreferencesColorThemeController.prototype.detachMenu = function() {
      var ref;
      return (ref = this.menuController) != null ? ref.release() : void 0;
    };

    PreferencesColorThemeController.prototype.toggleMenuElement = function(gear, gearParent) {
      this.menuController = new App.RedesignColorThemesMenuController({
        site: this.site,
        theme: this.colorTheme
      });
      this.bubbles(this.menuController, 'update-theme');
      this.menuController.bind('update-theme', this.updateTheme);
      this.menuController.bind('edit-theme', this.clickedColorTheme);
      this.trigger('menu-added', this.menuController);
      return gearParent.append(this.menuController.$el);
    };

    return PreferencesColorThemeController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PreferencesColorThemesController = (function(superClass) {
    extend(PreferencesColorThemesController, superClass);

    PreferencesColorThemesController.prototype.events = {
      'click .add-icon': 'clickedNewTheme'
    };

    PreferencesColorThemesController.prototype.elements = {
      '.color-theme-table': 'colorThemeTable'
    };

    function PreferencesColorThemesController() {
      this.menuAdded = bind(this.menuAdded, this);
      this.clickedNewTheme = bind(this.clickedNewTheme, this);
      this.reRenderChildren = bind(this.reRenderChildren, this);
      this.render = bind(this.render, this);
      PreferencesColorThemesController.__super__.constructor.apply(this, arguments);
      App.Site.bind('update-color-themes', this.render);
      App.SiteThemeUsageCount.getRecord(this.site.id);
      this.render();
    }

    PreferencesColorThemesController.prototype.release = function() {
      App.Site.unbind('update-color-themes', this.render);
      return PreferencesColorThemesController.__super__.release.apply(this, arguments);
    };

    PreferencesColorThemesController.prototype.render = function() {
      var colorTheme, colorThemes, controller, i, len, results;
      this.html(this.view('redesign/settings/color_theme_preferences'));
      colorThemes = _(App.ColorTheme.all()).concat(App.ColorTheme.PERISCOPE_DEFAULT_THEME()).sortBy(function(t) {
        return !t.isSiteTheme();
      }).value();
      this.controllers = [];
      results = [];
      for (i = 0, len = colorThemes.length; i < len; i++) {
        colorTheme = colorThemes[i];
        controller = new App.PreferencesColorThemeController({
          colorTheme: colorTheme,
          site: this.site
        });
        controller.bind('menu-added', this.menuAdded);
        controller.bind('update-theme', this.reRenderChildren);
        this.controllers.push(controller);
        results.push(this.colorThemeTable.append(controller.el));
      }
      return results;
    };

    PreferencesColorThemesController.prototype.reRenderChildren = function() {
      _.each(this.controllers, function(controller) {
        return controller.release();
      });
      return this.render();
    };

    PreferencesColorThemesController.prototype.clickedNewTheme = function() {
      this.colorThemeController = new App.RedesignSettingsColorThemesController({
        colorTheme: App.ColorTheme.newColorThemeWithPeriscopeDefaults()
      });
      return this.colorThemeController.bind('updated', this.render);
    };

    PreferencesColorThemesController.prototype.menuAdded = function(menuController) {
      var ref;
      if ((ref = this.lastOpenedMenuController) != null) {
        ref.release();
      }
      return this.lastOpenedMenuController = menuController;
    };

    return PreferencesColorThemesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.QualityCheckController = (function(superClass) {
    extend(QualityCheckController, superClass);

    QualityCheckController.prototype.className = 'dashboard-quality-check';

    QualityCheckController.prototype.elements = {
      '.search-select': 'sqlAlertEl',
      '.failed-message-toggler': 'failedMessageTogglerEl',
      '.failed-message-area': 'failedMessageEl'
    };

    QualityCheckController.prototype.events = {
      'change .search-select': 'changeSqlAlert',
      'click .save-button': 'save',
      'click .cancel-button': 'close'
    };

    QualityCheckController.toggleLabel = 'Inform report recipients when skipping emails';

    function QualityCheckController() {
      this.failedMessageToggled = bind(this.failedMessageToggled, this);
      QualityCheckController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      this.html(this.view('redesign/quality_check/dashboard-quality-check')({
        sqlAlerts: App.SqlAlert.all()
      }));
      this.setupSqlAlertSelect();
      this.setupFailedMessageToggler();
      this.failedMessageEl.val(this.dashboard.quality_check_failed_message);
    }

    QualityCheckController.prototype.setupSqlAlertSelect = function() {
      this.sqlAlertEl.val("" + this.dashboard.sql_alert_id);
      return this.sqlAlertEl.chosen({
        disable_search: false,
        width: '100%',
        no_results_text: "No SQL Alert named",
        allow_single_deselect: true
      });
    };

    QualityCheckController.prototype.setupFailedMessageToggler = function() {
      this.failedMessageToggler = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.dashboard.send_quality_check_failed_message,
        labelWhenToggleOn: App.QualityCheckController.toggleLabel,
        labelWhenToggleOff: App.QualityCheckController.toggleLabel
      });
      this.failedMessageToggler.bind('toggled', this.failedMessageToggled);
      this.failedMessageTogglerEl.append(this.failedMessageToggler.el);
      this.failedMessageToggled();
      return this.setTogglerEnabledState();
    };

    QualityCheckController.prototype.failedMessageToggled = function() {
      return this.failedMessageEl.toggle(this.failedMessageToggler.isToggleOn);
    };

    QualityCheckController.prototype.setTogglerEnabledState = function() {
      var alertSelected, send_quality_check_failed_message;
      alertSelected = +this.sqlAlertEl.val() !== 0;
      if (alertSelected) {
        send_quality_check_failed_message = !!this.dashboard.send_quality_check_failed_message;
        this.failedMessageToggler.enable();
        this.failedMessageToggler.setToggleState(send_quality_check_failed_message);
        return this.failedMessageEl.toggle(send_quality_check_failed_message);
      } else {
        this.failedMessageEl.toggle(false);
        this.failedMessageToggler.setToggleState(false);
        return this.failedMessageToggler.disable();
      }
    };

    QualityCheckController.prototype.changeSqlAlert = function() {
      return this.setTogglerEnabledState();
    };

    QualityCheckController.prototype.save = function() {
      this.captureSqlAlertId();
      this.captureSendQualityCheckFailedMessage();
      this.captureQualityCheckFailedMessage();
      this.dashboard.save();
      return this.close();
    };

    QualityCheckController.prototype.captureSqlAlertId = function() {
      var sqlAlertId;
      sqlAlertId = +this.sqlAlertEl.val();
      return this.dashboard.sql_alert_id = sqlAlertId ? sqlAlertId : null;
    };

    QualityCheckController.prototype.captureSendQualityCheckFailedMessage = function() {
      return this.dashboard.send_quality_check_failed_message = this.failedMessageToggler.isToggleOn;
    };

    QualityCheckController.prototype.captureQualityCheckFailedMessage = function() {
      return this.dashboard.quality_check_failed_message = this.failedMessageEl.val().trim();
    };

    QualityCheckController.prototype.close = function() {
      return this.trigger('close');
    };

    QualityCheckController.prototype.release = function() {
      var ref;
      if ((ref = this.failedMessageToggler) != null) {
        ref.unbind('toggled', this.failedMessageToggled);
      }
      return QualityCheckController.__super__.release.apply(this, arguments);
    };

    return QualityCheckController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ReactActions = (function(superClass) {
    extend(ReactActions, superClass);

    function ReactActions() {
      ReactActions.__super__.constructor.apply(this, arguments);
    }

    ReactActions.initReactStateWithSources = function(item, error, previewSql, sqlRunReachedPreviewLimit) {
      if (item instanceof App.SqlAlert && (item.getRows() || error)) {
        return this.initSqlRunResultForSqlAlert(item, error, previewSql);
      } else {
        this.initSqlRunResultForSource(typeof item.sqlSource === "function" ? item.sqlSource() : void 0, previewSql, sqlRunReachedPreviewLimit, item);
        return this.initCodeRunResultForSource(typeof item.codeSource === "function" ? item.codeSource() : void 0, item);
      }
    };

    ReactActions.initSqlRunResultForSource = function(source, previewSql, sqlRunReachedPreviewLimit, item) {
      var sqlRun;
      if (!source) {
        return;
      }
      sqlRun = {
        result: App.RunResult.translateSourceToRunResultOutput(source, item.database().info()),
        sql_query: this.sqlQueryAndErrorInfo(source, previewSql),
        sqlRunReachedPreviewLimit: sqlRunReachedPreviewLimit
      };
      return this.updateSqlRunResultState(sqlRun);
    };

    ReactActions.sqlQueryAndErrorInfo = function(source, previewSql) {
      var errorInfo;
      if (source.error_message != null) {
        errorInfo = {
          sql: previewSql,
          error_message: source.error_message,
          error_pos: source.error_pos,
          ran_on_redshift: source.ran_on_redshift
        };
      } else {
        errorInfo = {};
      }
      return this.queryAndErrorInfoObject(previewSql, errorInfo);
    };

    ReactActions.queryAndErrorInfoObject = function(query, errorInfo) {
      return {
        query: query,
        errorInfo: errorInfo
      };
    };

    ReactActions.initCodeRunResultForSource = function(source, item) {
      if (!source) {
        return;
      }
      return this.updateCodeRunResultState(App.RunResult.translateSourceToRunResultOutput(source, item.database().info()));
    };

    ReactActions.initSqlRunResultForSqlAlert = function(item, error, previewSql) {
      var sqlRun;
      sqlRun = {
        sqlRunReachedPreviewLimit: false,
        result: App.RunResult.translateItemToRunResultOutput(item, item.database().info()),
        sql_query: this.sqlQueryInfoForAlert(item, error, previewSql)
      };
      return this.updateSqlRunResultState(sqlRun);
    };

    ReactActions.sqlQueryInfoForAlert = function(item, error, previewSql) {
      var errorInfo;
      if (error) {
        errorInfo = {
          sql: previewSql,
          error_pos: null,
          error_message: item.error_message,
          ran_on_redshift: null
        };
      } else {
        errorInfo = {};
      }
      return {
        query: previewSql,
        errorInfo: errorInfo
      };
    };

    ReactActions.updateSqlRunResultState = function(sqlRun) {
      return window.reactApp.updateSqlRunResult(sqlRun);
    };

    ReactActions.updateCodeRunResultState = function(result) {
      return window.reactApp.updateCodeRunResult(result);
    };

    ReactActions.updateCodeInputHashKeyState = function(hashKey) {
      return window.reactApp.updateCodeInputHashKey(hashKey);
    };

    ReactActions.updateAlertsState = function(warning) {
      return window.reactApp.updateAlerts(warning);
    };

    ReactActions.dispatchRanSqlInEditor = function() {
      return window.reactApp.dispatchRanSqlInEditor();
    };

    ReactActions.dispatchFetchGraph = function(item, dependenciesUpdated) {
      return window.reactApp.dispatchFetchGraph(item, dependenciesUpdated);
    };

    ReactActions.getCodeInfoState = function() {
      return window.reactApp.getCodeInfo();
    };

    ReactActions.getNumDiscoveryChartAndDisplayModal = function(datasets, datasetToDelete, title, afterDeletionCallBack, noDiscoveryChartCallback) {
      var ref;
      return (ref = window.reactApp) != null ? ref.getNumDiscoveryChartAndDisplayModal(datasets, datasetToDelete, title, afterDeletionCallBack, noDiscoveryChartCallback) : void 0;
    };

    return ReactActions;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RecentColorsController = (function(superClass) {
    extend(RecentColorsController, superClass);

    RecentColorsController.prototype.className = 'recent-colors';

    RecentColorsController.prototype.events = {
      'click .recent-color': 'setFromRecent'
    };

    function RecentColorsController() {
      this.addToRecentColors = bind(this.addToRecentColors, this);
      RecentColorsController.__super__.constructor.apply(this, arguments);
      this.recentColors = this.userRole().recent_colors || [];
      this.viewController.bind('add-recent', this.addToRecentColors);
      this.render();
    }

    RecentColorsController.prototype.render = function() {
      return this.html(this.view('redesign/settings/recent_colors')({
        recent_colors: this.recentColors
      }));
    };

    RecentColorsController.prototype.setFromRecent = function(e) {
      var color;
      color = $(e.currentTarget).data('color');
      return this.trigger('set-color', color);
    };

    RecentColorsController.prototype.addToRecentColors = function(color) {
      if (_.includes(this.recentColors, color)) {
        return;
      }
      this.recentColors.push(color);
      return this.updateRecentColors();
    };

    RecentColorsController.prototype.updateRecentColors = function() {
      var role;
      role = this.userRole();
      role.recent_colors = _.takeRight(this.recentColors, 12);
      return role.save();
    };

    RecentColorsController.prototype.userRole = function() {
      return App.UserRole.findByAttribute('user_id', App.User.currentUserId());
    };

    return RecentColorsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAddRemoveListController = (function(superClass) {
    extend(RedesignAddRemoveListController, superClass);

    RedesignAddRemoveListController.prototype.elements = {
      '.new-item-input': 'newItemInput',
      '.list': 'itemsList',
      '.add-error': 'error',
      '.add-icon': 'addButton'
    };

    RedesignAddRemoveListController.prototype.events = {
      'click .add-icon': 'clickedAdd',
      'keyup .new-item-input': 'keypress'
    };

    function RedesignAddRemoveListController() {
      this.removeItem = bind(this.removeItem, this);
      RedesignAddRemoveListController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'saveCallback', 'itemClass');
      this.items = [];
    }

    RedesignAddRemoveListController.prototype.clickedAdd = function() {
      this.addItems(this.newItemInput.val(), true);
      if (this.error.text() === '') {
        return this.newItemInput.val('');
      }
    };

    RedesignAddRemoveListController.prototype.keypress = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        return this.clickedAdd();
      } else {
        this.clearError();
        return this.addButton.toggleClass('active', !!this.newItemInput.val());
      }
    };

    RedesignAddRemoveListController.prototype.removeItem = function(value) {
      var items;
      items = _.filter(this.items, function(item) {
        return item.value !== value;
      });
      this.renderList(items);
      return typeof this.saveCallback === "function" ? this.saveCallback() : void 0;
    };

    RedesignAddRemoveListController.prototype.renderList = function(items) {
      var i, item, len, results;
      this.items = [];
      this.itemsList.html('');
      results = [];
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        results.push(this.addItems(item.value));
      }
      return results;
    };

    RedesignAddRemoveListController.prototype.setError = function(message) {
      this.error.text(message);
      return this.newItemInput.addClass('error');
    };

    RedesignAddRemoveListController.prototype.clearError = function() {
      this.error.text('');
      return this.newItemInput.removeClass('error');
    };

    RedesignAddRemoveListController.prototype.joinValues = function() {
      return _.map(this.items, function(item) {
        return item.value;
      }).join(',');
    };

    RedesignAddRemoveListController.prototype.addItems = function(values, save) {
      var i, item, len, list, value;
      if (save == null) {
        save = false;
      }
      list = _.uniq(_.filter(values.split(','), (function(_this) {
        return function(value) {
          return value.trim().length > 0 && !_.includes(_this.joinValues(), value);
        };
      })(this)));
      if (!this.validateEmails(list)) {
        return;
      }
      for (i = 0, len = list.length; i < len; i++) {
        value = list[i];
        value = value.trim();
        item = new this.itemClass({
          value: value,
          onRemove: this.removeItem
        });
        this.items.push(item);
        this.itemsList.append(item.el);
      }
      this.clearError();
      this.addButton.removeClass('active');
      if (save) {
        return typeof this.saveCallback === "function" ? this.saveCallback() : void 0;
      }
    };

    RedesignAddRemoveListController.prototype.validateEmails = function(list) {
      var i, len, unauthorized, value;
      unauthorized = App.Utils.unauthorizedEmail(list);
      if (unauthorized.length) {
        this.setError('Unauthorized email addresses: ' + unauthorized.join(','));
        return false;
      }
      for (i = 0, len = list.length; i < len; i++) {
        value = list[i];
        value = value.trim();
        if (!App.Utils.probablyAValidEmailAddress(value)) {
          this.setError('Incorrectly formatted email address: ' + value);
          return false;
        }
      }
      return true;
    };

    return RedesignAddRemoveListController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAddSiteController = (function(superClass) {
    extend(RedesignAddSiteController, superClass);

    RedesignAddSiteController.prototype.className = 'add-site';

    RedesignAddSiteController.prototype.elements = {
      '.new-site-name': 'newSiteName',
      '.error': 'errorEl',
      '.button.save': 'createButton',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    RedesignAddSiteController.prototype.events = {
      'keypress .new-site-name': 'checkForEnter',
      'click .info-question-mark': 'clickedHelpButton'
    };

    function RedesignAddSiteController() {
      this.clickedHelpButton = bind(this.clickedHelpButton, this);
      this.close = bind(this.close, this);
      this.cancel = bind(this.cancel, this);
      this.clickedGoToNewSite = bind(this.clickedGoToNewSite, this);
      this.successfullyCreated = bind(this.successfullyCreated, this);
      this.handleError = bind(this.handleError, this);
      this.doneAjax = bind(this.doneAjax, this);
      this.clickedCreate = bind(this.clickedCreate, this);
      this.checkForEnter = bind(this.checkForEnter, this);
      RedesignAddSiteController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/controls/add_site')());
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.clickedCreate,
        saveText: 'CREATE'
      });
      this.rightAlignedButtons.append(this.cancelSaveBlock.el);
      this.dialog = App.RedesignDialog.createDialog({
        title: 'Create a Space',
        viewController: this,
        customDialogClass: 'add-site',
        helpIcon: true
      }).bind('close', this.cancel);
      $('.add-site .info-question-mark').on('click', this.clickedHelpButton);
      setTimeout(((function(_this) {
        return function() {
          return _this.newSiteName.trigger('focus');
        };
      })(this)), App.LeftMenu.SEARCH_DELAY);
    }

    RedesignAddSiteController.prototype.checkForEnter = function(evt) {
      if (evt.which === AppRedesign.KEYS.ENTER) {
        evt.stopPropagation();
        evt.preventDefault();
        return this.clickedCreate();
      }
    };

    RedesignAddSiteController.prototype.clickedCreate = function() {
      var formData, newSiteName;
      if (this.isSaving) {
        return;
      }
      this.errorEl.text('');
      this.errorEl.hide();
      newSiteName = this.newSiteName.val();
      if (!this.validate(newSiteName)) {
        return;
      }
      formData = {
        new_site_name: newSiteName
      };
      jQuery.ajax({
        method: 'post',
        url: "/sites/" + (App.Site.first().id) + "/add_site_to_family",
        data: formData
      }).done(this.successfullyCreated).fail(this.handleError).always(this.doneAjax);
      this.isSaving = true;
      return this.createButton.addClass("disabled");
    };

    RedesignAddSiteController.prototype.doneAjax = function() {
      this.createButton.removeClass("disabled");
      return this.isSaving = false;
    };

    RedesignAddSiteController.prototype.handleError = function(response) {
      var attribute, errorList, errors, messages;
      if (response.responseJSON != null) {
        errors = response.responseJSON.errors;
      }
      if (errors == null) {
        errors = {};
      }
      errorList = [];
      for (attribute in errors) {
        messages = errors[attribute];
        errorList.push(attribute + ": " + (messages.join(', ')));
      }
      if (errorList.length === 0) {
        errorList.push("An unknown error has occured.");
      }
      return this.showError(errorList.join("\n"));
    };

    RedesignAddSiteController.prototype.validate = function(newSiteName) {
      var error, isSuccessful, ref;
      ref = App.SiteNameValidator.validate(newSiteName), isSuccessful = ref[0], error = ref[1];
      if (!isSuccessful) {
        this.showError("Space name: " + error);
        return false;
      }
      return true;
    };

    RedesignAddSiteController.prototype.showError = function(msg) {
      this.errorEl.text(msg);
      return this.errorEl.slideDown();
    };

    RedesignAddSiteController.prototype.successfullyCreated = function(response) {
      this.dialog.contentEl.html(this.view('redesign/controls/site_ready')({
        display_name: this.newSiteName.val()
      }));
      $('.go-to-new-site').on('click', ((function(_this) {
        return function() {
          return _this.clickedGoToNewSite(response);
        };
      })(this)));
      return App.RedesignAddSiteController.commonSuccessfullyCreatedSite(response);
    };

    RedesignAddSiteController.commonSuccessfullyCreatedSite = function(response) {
      var updated_site, updated_user;
      updated_user = response.user;
      if (updated_user != null) {
        App.User.applyUpdates([updated_user]);
      }
      updated_site = response.site;
      if (updated_site != null) {
        App.Site.applyUpdates([updated_site]);
      }
      return App.Site.trigger('request-several-updates');
    };

    RedesignAddSiteController.prototype.clickedGoToNewSite = function(response) {
      return window.location.href = AppRedesign.pathForSiteHost({
        siteHost: response.new_site.host
      });
    };

    RedesignAddSiteController.prototype.cancel = function() {
      return App.RouteHelper.navigateToPrev();
    };

    RedesignAddSiteController.prototype.close = function() {
      return this.dialog.close();
    };

    RedesignAddSiteController.prototype.clickedHelpButton = function() {
      return window.open(AppRedesign.DOC_PATH + '/spaces');
    };

    return RedesignAddSiteController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAggregationDimensionSetting = (function(superClass) {
    extend(RedesignAggregationDimensionSetting, superClass);

    RedesignAggregationDimensionSetting.prototype.elements = {
      '.search-results': 'aggregationOptions'
    };

    RedesignAggregationDimensionSetting.DEFAULT_AGGREGATION_LABEL = "Aggregation";

    RedesignAggregationDimensionSetting.AGGREGATION_OPTIONS = [
      {
        value: 'hourly',
        label: "Hourly"
      }, {
        value: 'daily',
        label: "Daily"
      }, {
        value: 'weekly',
        label: "Weekly"
      }, {
        value: 'monthly',
        label: "Monthly"
      }, {
        value: 'quarterly',
        label: "Quarterly"
      }, {
        value: 'yearly',
        label: "Yearly"
      }
    ];

    function RedesignAggregationDimensionSetting() {
      this.clickedAggregationRadioButton = bind(this.clickedAggregationRadioButton, this);
      RedesignAggregationDimensionSetting.__super__.constructor.apply(this, arguments);
      this.render();
    }

    RedesignAggregationDimensionSetting.prototype.render = function() {
      this.html(this.view('redesign/dashboards/setting_autocompleter')({
        settingName: 'Aggregation',
        disableSearch: true
      }));
      this.refreshElements();
      return this.aggregationRadioButtonGroup = new App.RedesignRadioButtonGroup({
        radioOptions: this.constructor.AGGREGATION_OPTIONS,
        initialValue: this.dashboard.aggregationSetting(),
        defaultValue: -1,
        el: App.RadioButtonGroup.appendFrame(this.aggregationOptions),
        disableDeselection: true,
        callback: this.clickedAggregationRadioButton
      });
    };

    RedesignAggregationDimensionSetting.prototype.clickedAggregationRadioButton = function(value, clickOptions) {
      if (clickOptions.doubleClick) {
        return this.trigger('apply-pending-config');
      } else {
        return this.dashboard.setPendingAggregation(value);
      }
    };

    RedesignAggregationDimensionSetting.prototype.updateLabel = function() {
      var i, item, len, ref, selectedAggregation;
      ref = this.constructor.AGGREGATION_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        if (this.dashboard.aggregationSetting() === item.value) {
          selectedAggregation = item;
          break;
        }
      }
      if (selectedAggregation) {
        return this.aggregationRadioButtonGroup.setState(item.value);
      } else {
        return this.aggregationRadioButtonGroup.setState('daily');
      }
    };

    RedesignAggregationDimensionSetting.getAggregationValuesAsArrays = function(term, callback) {
      var translateCallback;
      translateCallback = function(results) {
        var r, values;
        values = (function() {
          var i, len, results1;
          results1 = [];
          for (i = 0, len = results.length; i < len; i++) {
            r = results[i];
            results1.push([r.value, r.label]);
          }
          return results1;
        })();
        return callback(values);
      };
      return this.getAggregationValues(term, translateCallback);
    };

    RedesignAggregationDimensionSetting.getAggregationValues = function(term, translateCallback) {
      var i, len, option, ref, results;
      term = term.trim().toLowerCase();
      results = [];
      ref = App.RedesignAggregationDimensionSetting.AGGREGATION_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.value.toLowerCase().indexOf(term) !== -1) {
          results.push(option);
        }
      }
      return translateCallback(results);
    };

    return RedesignAggregationDimensionSetting;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAllSpacesWarningController = (function(superClass) {
    extend(RedesignAllSpacesWarningController, superClass);

    RedesignAllSpacesWarningController.prototype.className = 'permission-denied modal';

    RedesignAllSpacesWarningController.prototype.elements = {
      '.button.cancel': 'cancelButton',
      '.button.proceed': 'proceedButton'
    };

    RedesignAllSpacesWarningController.prototype.events = {
      'click .button.cancel': 'clickedCancel',
      'click .button.proceed': 'clickedProceed',
      'click .cancel-icon': 'cancel'
    };

    function RedesignAllSpacesWarningController(user, panel) {
      this.user = user;
      this.panel = panel;
      RedesignAllSpacesWarningController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignAllSpacesWarningController.prototype.render = function() {
      this.html(this.view('redesign/controls/all_spaces_warning')({}));
      return $('#modal').empty().append(this.el);
    };

    RedesignAllSpacesWarningController.prototype.clickedProceed = function() {
      var updateParams;
      updateParams = {
        user_id: this.user.id,
        client_site_id: App.Site.first().id
      };
      updateParams['self_service_dashboards_access'] = true;
      updateParams['workbooks_access'] = false;
      return $.post("/users/update_user_platform_access", updateParams).done(this.confirmProceed(this.user, this.panel));
    };

    RedesignAllSpacesWarningController.prototype.confirmProceed = function(user, panel) {
      this.user = user;
      this.panel = panel;
      this.panel.closeEdit();
      this.user.self_service_dashboards_access = true;
      this.user.workbooks_access = false;
      this.user.save({
        ajax: false
      });
      return this.release();
    };

    RedesignAllSpacesWarningController.prototype.cancel = function() {
      return this.release();
    };

    RedesignAllSpacesWarningController.prototype.clickedCancel = function() {
      return this.release();
    };

    RedesignAllSpacesWarningController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignAllSpacesWarningController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return RedesignAllSpacesWarningController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAnnotationController = (function(superClass) {
    extend(RedesignAnnotationController, superClass);

    RedesignAnnotationController.HIDE_DISTANCE = 50;

    RedesignAnnotationController.MAX_CHARACTERS = 620;

    RedesignAnnotationController.setFormShowing = function() {
      return RedesignAnnotationController._formShowing = true;
    };

    RedesignAnnotationController.clearFormShowing = function() {
      return RedesignAnnotationController._formShowing = false;
    };

    RedesignAnnotationController.isFormShowing = function() {
      return RedesignAnnotationController._formShowing;
    };

    function RedesignAnnotationController() {
      this.hideAnnotation = bind(this.hideAnnotation, this);
      this.hideHandler = bind(this.hideHandler, this);
      this.hideUnlessInTooltip = bind(this.hideUnlessInTooltip, this);
      RedesignAnnotationController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      App.Annotation.bind('hide-all-annotations', this.hideAnnotation);
      $('#body').on('click mousewheel', this.hideUnlessInTooltip);
    }

    RedesignAnnotationController.prototype.release = function() {
      this.hideAnnotation();
      App.Annotation.unbind('hide-all-annotations', this.hideAnnotation);
      $('#body').off('click mousewheel', this.hideUnlessInTooltip);
      return RedesignAnnotationController.__super__.release.apply(this, arguments);
    };

    RedesignAnnotationController.prototype.maybeShowAnnotation = function(ids, x, mouseX, bottomAxisOffset) {
      var annotations, id;
      if (App.RedesignDashboardSizer.isTvMode() || App.RedesignAnnotationController.isFormShowing()) {
        return;
      }
      annotations = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = ids.length; i < len; i++) {
          id = ids[i];
          results.push(this.maybeElide(App.Annotation.exists(id)));
        }
        return results;
      }).call(this);
      if (this.alreadyShowingAnnotations(annotations)) {
        return;
      }
      return this.showAnnotations(annotations, x, mouseX, annotations.first().x_value, false, bottomAxisOffset);
    };

    RedesignAnnotationController.prototype.showAnnotations = function(annotations, x, mouseX, xValue, showForm, bottomAxisOffset) {
      var boundary, boundaryLeftOffset, chartEl, edgePadding, leftDifference, leftOffset, maxLeft, minLeft, pointerOffset, ref, targetOffset, widthPx;
      if (xValue === this.lastXValue && showForm) {
        this.updateTooltipToForm(annotations, xValue);
        return;
      }
      App.Annotation.trigger('hide-all-annotations');
      this.showingAnnotationIds = annotations.map(function(a) {
        return a.id;
      });
      chartEl = this.el.find('.canvasjs-chart-container');
      targetOffset = chartEl.offset();
      targetOffset.left += x;
      targetOffset.left -= 5;
      bottomAxisOffset += 5;
      if (showForm) {
        this.createFormController(annotations, xValue);
      } else {
        if (xValue == null) {
          return;
        }
        this.releaseContentController();
        this.contentController = new App.RedesignAnnotationListController({
          xValue: xValue,
          annotations: annotations
        });
        this.contentController.bind('close', this.hideAnnotation);
        this.hideOnLeave = true;
        this.showOnce = false;
      }
      leftOffset = targetOffset.left;
      widthPx = 270;
      edgePadding = 10;
      pointerOffset = widthPx / 2;
      boundary = this.el.closest('.chart-tooltip-boundary');
      boundaryLeftOffset = boundary.length && ((ref = boundary.offset()) != null ? ref.left : void 0) || 0;
      minLeft = boundaryLeftOffset + widthPx / 2 + edgePadding;
      leftOffset = Math.max(leftOffset, minLeft);
      maxLeft = boundary.width() + boundaryLeftOffset - widthPx / 2 - edgePadding;
      leftOffset = Math.min(leftOffset, maxLeft);
      leftDifference = leftOffset - targetOffset.left;
      pointerOffset -= leftDifference;
      this.annotationTooltip = App.RedesignTooltipPanel.addDialogPanel({
        contentEl: this.contentController.el,
        description: null,
        extraClass: this.contentController.constructor.TOOLTIP_PANEL_CLASS,
        hideOnLeave: this.hideOnLeave,
        pointerOffsetPercent: pointerOffset / widthPx,
        title: this.contentController.title(),
        width: widthPx + "px"
      });
      this.annotationTooltip.bind('mouse-left', this.hideAnnotation);
      this.annotationTooltip.bind('hide', this.releaseContentController);
      this.annotationTooltip.$('.cancel-icon').one('click', this.hideAnnotation);
      this.annotationTooltip.fixPositionAt(leftOffset, targetOffset.top + bottomAxisOffset);
      this.bindHideHandler(mouseX);
      return this.lastXValue = xValue;
    };

    RedesignAnnotationController.prototype.updateTooltipToForm = function(annotations, xValue) {
      this.createFormController(annotations, xValue);
      return this.annotationTooltip.updateDialogContent(this.contentController.el, this.contentController.title(), this.contentController.TOOLTIP_PANEL_CLASS, 'list', this.hideOnLeave, this.showOnce);
    };

    RedesignAnnotationController.prototype.alreadyShowingAnnotations = function(annotations) {
      var newIds;
      if (this.showingAnnotationIds == null) {
        return false;
      }
      newIds = annotations.map(function(a) {
        return a.id;
      });
      return App.Utils.arraysSameIgnoringOrder(newIds, this.showingAnnotationIds);
    };

    RedesignAnnotationController.prototype.createFormController = function(annotations, xValue) {
      if (!((annotations != null) && (xValue != null))) {
        return;
      }
      App.RedesignAnnotationController.setFormShowing();
      this.releaseContentController();
      this.contentController = new App.RedesignAnnotationFormController({
        xValue: xValue,
        annotations: annotations,
        defaultGroupFunc: this.defaultGroupFunc
      }).bind('add-annotation', this.hideAnnotation).bind('close', this.hideAnnotation);
      this.bubbles(this.contentController, 'add-annotation');
      this.hideOnLeave = false;
      return this.showOnce = true;
    };

    RedesignAnnotationController.prototype.releaseContentController = function() {
      if (!this.contentController) {
        return;
      }
      this.contentController.unbind('add-annotation', this.hideAnnotation);
      this.contentController.unbind('close', this.hideAnnotation);
      return this.contentController.release();
    };

    RedesignAnnotationController.prototype.maybeElide = function(annotation) {
      if (annotation && annotation.description.length >= App.RedesignAnnotationController.MAX_CHARACTERS) {
        annotation.description = annotation.description.slice(0, App.RedesignAnnotationController.MAX_CHARACTERS - 3) + '...';
      }
      return annotation;
    };

    RedesignAnnotationController.prototype.eventIsInTooltipPanel = function(e) {
      return $(e.target).closest(".tooltip-panel").length > 0;
    };

    RedesignAnnotationController.prototype.hideUnlessInTooltip = function(e) {
      if (!this.eventIsInTooltipPanel(e)) {
        return this.hideAnnotation();
      }
    };

    RedesignAnnotationController.prototype.hideHandler = function(ev) {
      if (this.eventIsInTooltipPanel(ev) || RedesignAnnotationController.isFormShowing()) {
        return;
      }
      if (Math.abs(ev.clientX - this.lastMouseX) > RedesignAnnotationController.HIDE_DISTANCE) {
        return this.maybeHideAnnotation();
      }
    };

    RedesignAnnotationController.prototype.bindHideHandler = function(lastMouseX) {
      $('body').off('mousemove', this.hideHandler);
      if (lastMouseX != null) {
        $('body').on('mousemove', this.hideHandler);
      }
      return this.lastMouseX = lastMouseX;
    };

    RedesignAnnotationController.prototype.maybeHideAnnotation = function() {
      if (this.hideAnnotationTimeout != null) {
        return;
      }
      return this.hideAnnotation();
    };

    RedesignAnnotationController.prototype.hideAnnotation = function() {
      var ref, ref1, ref2;
      delete this.showingAnnotationIds;
      delete this.lastMouseX;
      delete this.lastXValue;
      App.RedesignAnnotationController.clearFormShowing();
      $('body').off('mousemove', this.hideHandler);
      if ((ref = this.annotationTooltip) != null) {
        ref.closeAndRelease();
      }
      if (((ref1 = this.contentController) != null ? (ref2 = ref1.pendingDeletes) != null ? ref2.length : void 0 : void 0) > 0) {
        this.trigger('delete-annotations', this.contentController.pendingDeletes);
        return this.contentController.pendingDeletes = [];
      }
    };

    return RedesignAnnotationController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAnnotationFormController = (function(superClass) {
    extend(RedesignAnnotationFormController, superClass);

    RedesignAnnotationFormController.TOOLTIP_PANEL_CLASS = 'annotations-tooltip-panel';

    RedesignAnnotationFormController.prototype.elements = {
      '.new-group': 'groupInput',
      '.note-description': 'descriptionInput',
      '.add-group': 'addGroup',
      '.button-row': 'buttonRow',
      '.select-wrapper': 'selectWrapper'
    };

    RedesignAnnotationFormController.prototype.events = {
      'click .button.add': 'clickedSave',
      'keyup input': 'inputKeyUp',
      'change .add-group': 'pickedGroupOption'
    };

    RedesignAnnotationFormController.NEW_GROUP_VALUE = '_periscope_new_group';

    RedesignAnnotationFormController.SELECT_GROUP_VALUE = '_periscope_select_group';

    function RedesignAnnotationFormController() {
      this.inputKeyUp = bind(this.inputKeyUp, this);
      this.clickedClose = bind(this.clickedClose, this);
      this.clickedSave = bind(this.clickedSave, this);
      this.pickedGroupOption = bind(this.pickedGroupOption, this);
      this.groupDropdownOptions = bind(this.groupDropdownOptions, this);
      this.currentOption = bind(this.currentOption, this);
      RedesignAnnotationFormController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'xValue', 'annotations', 'defaultGroupFunc');
      this.showOptions = false;
      this.render();
      this.setDefaultGroup();
    }

    RedesignAnnotationFormController.prototype.render = function() {
      this.html(this.view('redesign/annotations/form')({
        x: this.xValue,
        annotations: this.annotations,
        options: this.groupDropdownOptions()
      }));
      this.initGroupDropdown();
      this.toggleNewGroupInput();
      this.buttonBlock = new App.CancelSaveBlock({
        cancelFunc: this.clickedClose,
        saveFunc: this.clickedSave,
        saveText: 'save'
      });
      this.buttonRow.append(this.buttonBlock.el);
      return setTimeout(((function(_this) {
        return function() {
          return _this.descriptionInput.trigger('focus');
        };
      })(this)), 0);
    };

    RedesignAnnotationFormController.prototype.setDefaultGroup = function() {
      this.selectedGroup = this.defaultGroupFunc() || RedesignAnnotationFormController.SELECT_GROUP_VALUE;
      this.addGroup.val(this.selectedGroup);
      return this.addGroup.trigger("chosen:updated");
    };

    RedesignAnnotationFormController.prototype.currentOption = function() {
      return this.selectedGroup;
    };

    RedesignAnnotationFormController.prototype.groupDropdownOptions = function() {
      var group, i, len, options, ref;
      options = [
        {
          name: 'New Group',
          serverValue: App.RedesignAnnotationFormController.NEW_GROUP_VALUE
        }
      ];
      ref = this.allGroups();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        options.push({
          name: group,
          serverValue: group
        });
      }
      return options;
    };

    RedesignAnnotationFormController.prototype.allGroups = function() {
      return App.Annotation.groups();
    };

    RedesignAnnotationFormController.prototype.initGroupDropdown = function() {
      return this.addGroup.chosen({
        disable_search: true,
        width: '100%'
      });
    };

    RedesignAnnotationFormController.prototype.pickedGroupOption = function(option) {
      this.selectedGroup = $(option.currentTarget).val();
      return this.toggleNewGroupInput();
    };

    RedesignAnnotationFormController.prototype.isNewGroupSelected = function() {
      return this.selectedGroup === RedesignAnnotationFormController.NEW_GROUP_VALUE;
    };

    RedesignAnnotationFormController.prototype.toggleNewGroupInput = function() {
      var isNewGroup;
      isNewGroup = this.isNewGroupSelected();
      this.groupInput.toggle(isNewGroup);
      if (isNewGroup) {
        this.groupInput.trigger('focus');
        return this.selectWrapper.hide();
      }
    };

    RedesignAnnotationFormController.prototype.clickedSave = function(e) {
      var description, groupName;
      groupName = this.isNewGroupSelected() ? this.groupInput.val().trim() : this.selectedGroup !== RedesignAnnotationFormController.SELECT_GROUP_VALUE ? this.selectedGroup : '';
      description = this.descriptionInput.val().trim();
      if (App.Utils.isBlank(description)) {
        return;
      }
      return this.trigger('add-annotation', groupName, description, this.xValue);
    };

    RedesignAnnotationFormController.prototype.clickedClose = function(e) {
      return this.trigger('close');
    };

    RedesignAnnotationFormController.prototype.inputKeyUp = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        return this.clickedSave();
      }
    };

    RedesignAnnotationFormController.prototype.title = function() {
      return "Annotate";
    };

    return RedesignAnnotationFormController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAnnotationListController = (function(superClass) {
    extend(RedesignAnnotationListController, superClass);

    RedesignAnnotationListController.TOOLTIP_PANEL_CLASS = 'annotations-tooltip-panel list';

    RedesignAnnotationListController.prototype.elements = {
      '.annotations': 'annotationsList'
    };

    RedesignAnnotationListController.prototype.events = {
      'click .delete-x': 'clickedDelete'
    };

    RedesignAnnotationListController.prototype.title = function() {
      return "Notes for " + this.xValue;
    };

    RedesignAnnotationListController.prototype.release = function() {
      return setTimeout(this.reallyRelease, App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RedesignAnnotationListController.prototype.reallyRelease = function() {
      this.trigger('release');
      this.el.remove();
      return this.unbind();
    };

    function RedesignAnnotationListController() {
      this.scrollWithoutLeaking = bind(this.scrollWithoutLeaking, this);
      this.clickedDelete = bind(this.clickedDelete, this);
      this.reallyRelease = bind(this.reallyRelease, this);
      RedesignAnnotationListController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'xValue', 'annotations');
      this.render();
      this.pendingDeletes = [];
    }

    RedesignAnnotationListController.prototype.render = function() {
      this.html(this.view('redesign/annotations/list')({
        annotations: App.Utils.sortNumericOrAlphaByProperty(this.annotations, 'x_value')
      }));
      return this.annotationsList.on('wheel mousewheel', this.scrollWithoutLeaking);
    };

    RedesignAnnotationListController.prototype.clickedDelete = function(e) {
      var annotationEl, annotationId;
      if (!this.canModifyAnnotations()) {
        return;
      }
      annotationEl = $(e.target).closest('.annotation');
      annotationId = parseInt(annotationEl.attr('annotation-id'));
      if (this.pendingDeletes.indexOf(annotationId) !== -1) {
        annotationEl.removeClass('deleted');
        this.pendingDeletes = this.pendingDeletes.without(annotationId);
      } else {
        annotationEl.addClass('deleted');
        this.pendingDeletes.push(annotationId);
      }
      if (this.pendingDeletes.isEmpty()) {
        return App.RedesignAnnotationController.clearFormShowing();
      } else {
        return App.RedesignAnnotationController.setFormShowing();
      }
    };

    RedesignAnnotationListController.prototype.scrollWithoutLeaking = function(event) {
      return App.Utils.scrollWithoutLeaking(event, this.annotationsList);
    };

    RedesignAnnotationListController.prototype.canModifyAnnotations = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return App.User.CurrentUserCanEdit();
      }
    };

    return RedesignAnnotationListController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignChartContainerController = (function(superClass) {
    extend(RedesignChartContainerController, superClass);

    RedesignChartContainerController.prototype.className = 'redesign-chart-container';

    RedesignChartContainerController.TYPES_ALLOWING_IMAGE_DATA = ['column', 'line', 'area', 'pie', 'scatter', 'bubble', 'codeimage'];

    RedesignChartContainerController.TYPES_WITH_NO_CSV_DATA = ['codetext', 'codeimage'];

    RedesignChartContainerController.ALERT_MARGIN = 11;

    RedesignChartContainerController.ALERT_SPACE_FROM_BOTTOM = 15;

    RedesignChartContainerController.LOADING_TEXT = 'Loading';

    RedesignChartContainerController.SCROLL_CHECK_TIMEOUT = 50;

    RedesignChartContainerController.TABLE_CHART_ALERT_ADJUSTMENT = RedesignChartContainerController.ALERT_MARGIN + 5;

    RedesignChartContainerController.TABLE_RENDER_TIMEOUT_SECS = 3;

    RedesignChartContainerController.TIME_SINCE_LAST_DASHBOARD_SCROLL = 350;

    RedesignChartContainerController.WAITING_TEXT = 'Set chart settings.';

    function RedesignChartContainerController() {
      this.saveMapPosition = bind(this.saveMapPosition, this);
      this.repositionChart = bind(this.repositionChart, this);
      this.resizeCharts = bind(this.resizeCharts, this);
      this.overlayError = bind(this.overlayError, this);
      this.addAnnotation = bind(this.addAnnotation, this);
      this.showAlert = bind(this.showAlert, this);
      this.setTitle = bind(this.setTitle, this);
      this.uiQueue = bind(this.uiQueue, this);
      this.unrenderAllCharts = bind(this.unrenderAllCharts, this);
      this.onChartRendered = bind(this.onChartRendered, this);
      this.release = bind(this.release, this);
      this.hideLoader = bind(this.hideLoader, this);
      this.checkFormulaSourceLoadingState = bind(this.checkFormulaSourceLoadingState, this);
      this.showWaiting = bind(this.showWaiting, this);
      this.setChartType = bind(this.setChartType, this);
      this.returnToUnrenderedState = bind(this.returnToUnrenderedState, this);
      this.renderWidget = bind(this.renderWidget, this);
      this.erroredOnSourceLimit = bind(this.erroredOnSourceLimit, this);
      this.supportsCopyClipboard = bind(this.supportsCopyClipboard, this);
      this.supportsPivot = bind(this.supportsPivot, this);
      this.supportsSearch = bind(this.supportsSearch, this);
      this.supportsCSVData = bind(this.supportsCSVData, this);
      this.supportsImageData = bind(this.supportsImageData, this);
      this.isResizable = bind(this.isResizable, this);
      var dashboard;
      RedesignChartContainerController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      dashboard = this.item.dashboard() || App.Dashboard.currentDashboard();
      this.dashboardSizer = new App.RedesignDashboardSizer(dashboard);
      this.errorMessage = 'initial loading';
      this.chartContainerResize = new App.ChartContainerResizer({
        el: this.el,
        dashboardSizer: this.dashboardSizer,
        item: this.item,
        isResizableFunc: this.isResizable,
        resizeChartsFunc: this.resizeCharts,
        repositionChartFunc: this.repositionChart,
        chartInEditron: this.chartInEditron
      });
      this.bubbles(this.chartContainerResize, 'size-updated');
      this.renderChartController = new App.RenderChartController({
        el: this.el,
        item: this.item,
        chartInEditron: this.chartInEditron,
        dashboardSizer: this.dashboardSizer,
        showAlertFunc: this.showAlert,
        uiQueueFunc: this.uiQueue
      });
      this.bubbles(this.renderChartController, 'chart-rendered');
      this.renderChartController.bind('overlay-error', this.overlayError);
      this.renderChartController.bind('add-annotation', this.addAnnotation);
      this.renderChartController.bind('delete-annotations', this.deleteAnnotations);
      this.renderChartController.bind('save-map-position', this.saveMapPosition);
    }

    RedesignChartContainerController.prototype.titleEl = function() {
      return this.$('.title');
    };

    RedesignChartContainerController.prototype.contentEl = function() {
      return this.$('.widget-content');
    };

    RedesignChartContainerController.prototype.contentContainerEl = function() {
      return this.$('.chart-container');
    };

    RedesignChartContainerController.prototype.loaderElementEl = function() {
      return this.$('.widget-loader');
    };

    RedesignChartContainerController.prototype.loaderLoadingMessageElementEl = function() {
      return this.$('.widget-loader .label.loading, .widget-loader .loader-strip');
    };

    RedesignChartContainerController.prototype.loaderMaterializingCsvMessageElementEl = function() {
      return this.$('.loader.materializing');
    };

    RedesignChartContainerController.prototype.loaderWaitingMessageElementEl = function() {
      return this.$('.widget-loader .label.waiting');
    };

    RedesignChartContainerController.prototype.loaderElementSpinnerEl = function() {
      return this.$('.widget-loader .spinner');
    };

    RedesignChartContainerController.prototype.alertBlockEl = function() {
      return this.$('.alert-flex-wrapper');
    };

    RedesignChartContainerController.prototype.alertReferenceEl = function() {
      return this.$('.alert-reference');
    };

    RedesignChartContainerController.prototype.alertMessageEl = function() {
      return this.$('.alert-message');
    };

    RedesignChartContainerController.prototype.errorMessageEl = function() {
      return this.$('.error-message');
    };

    RedesignChartContainerController.prototype.isResizable = function() {
      if (this.resizableFunc() != null) {
        return this.resizableFunc();
      } else {
        return false;
      }
    };

    RedesignChartContainerController.prototype.supportsImageData = function() {
      if (BrowserDetect.browser === 'Explorer') {
        return false;
      }
      return RedesignChartContainerController.TYPES_ALLOWING_IMAGE_DATA.indexOf(this.item.chart_type) !== -1 && !this.item.hasError();
    };

    RedesignChartContainerController.prototype.supportsCSVData = function() {
      return RedesignChartContainerController.TYPES_WITH_NO_CSV_DATA.indexOf(this.item.chart_type) === -1;
    };

    RedesignChartContainerController.prototype.supportsSearch = function() {
      var ref;
      return ['table', 'cohort'].includes((ref = this.item) != null ? ref.chart_type : void 0) && !this.item.hasError();
    };

    RedesignChartContainerController.prototype.supportsPivot = function() {
      var ref;
      return ((ref = this.item) != null ? ref.chart_type : void 0) === 'table' && !this.pivotDisabled && !this.item.hasError();
    };

    RedesignChartContainerController.prototype.supportsCopyClipboard = function() {
      return this.copyClipboardOk && BrowserDetect.browser !== "Safari";
    };

    RedesignChartContainerController.prototype.getImageData = function() {
      var ref;
      return (ref = this.chart()) != null ? ref.getImageData() : void 0;
    };

    RedesignChartContainerController.prototype.renderPriority = function() {
      if (this.renderPriorityFunc != null) {
        return this.renderPriorityFunc();
      } else {
        return App.UiQueue.PRIORITY_DEFAULT;
      }
    };

    RedesignChartContainerController.prototype.erroredOnSourceLimit = function() {
      var ref;
      if (!AppRedesign.current().allowLargeCsvDownloadForSharedDashboards()) {
        if (AppRedesign.current().shared_mode) {
          return false;
        }
      }
      if ((ref = this.errorMessage) != null ? ref.startsWith(App.DownloadHelper.SOURCE_TOO_LARGE_ERROR_PREFIX) : void 0) {
        return true;
      }
      return false;
    };

    RedesignChartContainerController.prototype.renderFrame = function(persistLoader) {
      if (persistLoader == null) {
        persistLoader = false;
      }
      this.releaseChart();
      this.renderOpts = null;
      this.frameRendered = true;
      this.renderGuid = App.Utils.makeGuid();
      this.html(this.view('redesign/widgets/widget')({
        renderGuid: this.renderGuid,
        waitingText: this.waitingText || App.RedesignChartContainerController.WAITING_TEXT
      }));
      this.createTitleController();
      this.renderTitle();
      this.alertBlockEl().hide();
      if (!this.item.isComplete()) {
        this.showWaiting();
      }
      if (persistLoader && this.item.isComplete() && !this.item.hasData()) {
        this.showLoader();
      }
      return this.notifyFrameRendered();
    };

    RedesignChartContainerController.prototype.renderWidget = function(widget, animate, force, uwv) {
      if (force == null) {
        force = false;
      }
      if (uwv == null) {
        uwv = null;
      }
      this.item = widget;
      if (this.item.isComplete() && !this.item.hasData() && !this.item.canceledForCurrentUser()) {
        this.fadeInLoader();
      }
      return this.uiQueue(((function(_this) {
        return function() {
          return _this.renderChart(widget, animate, force, uwv);
        };
      })(this)), "renderChart");
    };

    RedesignChartContainerController.prototype.renderTitle = function() {
      var ref;
      return (ref = this.chartTitleController) != null ? ref.render() : void 0;
    };

    RedesignChartContainerController.prototype.returnToUnrenderedState = function() {
      this.renderOpts = null;
      this.notifyFrameUnrendered();
      return this.releaseChart();
    };

    RedesignChartContainerController.prototype.setChartType = function(chartType) {
      return this.queuePropertyChangeAndRender('chart_type', chartType);
    };

    RedesignChartContainerController.prototype.chart = function() {
      return this.renderChartController.chart();
    };

    RedesignChartContainerController.prototype.showWaitingInitialize = function() {
      this.errorMessageEl().hide();
      this.loaderLoadingMessageElementEl().hide();
      this.hideMaterializingCsvMessage();
      this.loaderWaitingMessageElementEl().show();
      this.unrenderAllCharts();
      return this.renderOpts = JSON.stringify({
        chart_type: this.item.chart_type
      });
    };

    RedesignChartContainerController.prototype.showWaiting = function() {
      this.showLoader();
      return this.showWaitingInitialize();
    };

    RedesignChartContainerController.LOADER_WATCHDOG_TIMEOUT = 60 * 1 * 1000;

    RedesignChartContainerController.prototype.checkFormulaSourceLoadingState = function(watchdog) {
      var ref;
      if (!((((ref = this.item) != null ? ref.id : void 0) != null) && this.item.hashKey())) {
        return;
      }
      if (this.loaderElementEl().filter(':visible').length === 0) {
        if (watchdog != null) {
          watchdog.stop();
        }
        return false;
      }
      if (!App.SourceFetcher.sourcesPending(this.item.hashKey())) {
        return this.item.trigger('update');
      }
    };

    RedesignChartContainerController.prototype.showLoader = function() {
      if (this.released != null) {
        return;
      }
      this.setupLoader();
      return this.loaderElementEl().show();
    };

    RedesignChartContainerController.prototype.fadeInLoader = function() {
      if (this.released != null) {
        return;
      }
      this.setupLoader();
      this.loaderElementEl().fadeIn();
      return this.loaderElementSpinnerEl().css('display', 'block');
    };

    RedesignChartContainerController.prototype.sqlBlank = function() {
      return this.item.sql === '';
    };

    RedesignChartContainerController.prototype.setupLoader = function() {
      this.loaderShown = true;
      this.notifyFrameReset();
      if (this.loaderWatchdog != null) {
        this.loaderWatchdog.heartbeat();
      } else {
        this.loaderWatchdog = new App.Watchdog(RedesignChartContainerController.LOADER_WATCHDOG_TIMEOUT, "loader for " + this.item.id + ", " + (this.item.hashKey()), this.checkFormulaSourceLoadingState);
      }
      this.loaderLoadingMessageElementEl().find('.msg').text(App.RedesignChartContainerController.LOADING_TEXT);
      this.loaderLoadingMessageElementEl().toggle(!this.sqlBlank());
      if (this.sqlBlank()) {
        this.showWaitingInitialize();
      } else {
        this.loaderWaitingMessageElementEl().hide();
      }
      if (typeof app !== "undefined" && app !== null) {
        if (typeof app.notRenderingWidget === "function") {
          app.notRenderingWidget(this.item.id);
        }
      }
      return this.renderTitle();
    };

    RedesignChartContainerController.prototype.hideLoader = function() {
      var ref;
      if (!this.loaderShown) {
        return;
      }
      if ((ref = this.loaderWatchdog) != null) {
        ref.stop();
      }
      this.loaderElementEl().fadeOut();
      return delete this.loaderShown;
    };

    RedesignChartContainerController.prototype.hideLoaderEl = function() {
      this.loaderElementEl().hide();
      return delete this.loaderShown;
    };

    RedesignChartContainerController.prototype.hideMaterializingCsvMessage = function() {
      return this.loaderMaterializingCsvMessageElementEl().hide();
    };

    RedesignChartContainerController.prototype.hideChartEls = function() {
      this.contentContainerEl().hide();
      return this.contentEl().hide();
    };

    RedesignChartContainerController.prototype.showChartEls = function() {
      this.contentContainerEl().show();
      return this.contentEl().show();
    };

    RedesignChartContainerController.prototype.release = function() {
      var ref, ref1, ref2;
      if ((ref = this.loaderWatchdog) != null) {
        ref.release();
      }
      if ((ref1 = this.chartContainerResize) != null) {
        ref1.release();
      }
      if ((ref2 = this.chartTitleController) != null) {
        ref2.release();
      }
      this.releaseChart();
      this.item.unbind('title-changed', this.setTitle);
      this.renderChartController.unbind('overlay-error', this.overlayError);
      this.renderChartController.unbind('add-annotation', this.addAnnotation);
      this.renderChartController.unbind('delete-annotations', this.deleteAnnotations);
      this.renderChartController.unbind('save-map-position', this.saveMapPosition);
      this.released = true;
      return RedesignChartContainerController.__super__.release.apply(this, arguments);
    };

    RedesignChartContainerController.prototype.releaseChart = function() {
      if (this.rerenderInterval != null) {
        clearInterval(this.rerenderInterval);
        this.widgetResizeDragEnd();
        delete this.rerenderInterval;
      }
      this.renderChartController.releaseChart();
      this.hideLoader();
      return this.frameRendered = false;
    };

    RedesignChartContainerController.prototype.onChartRendered = function() {
      this.trigger("chart-rendered");
      return setTimeout(((function(_this) {
        return function() {
          return _this.el.closest('.widget-container').addClass('render-complete');
        };
      })(this)), 100);
    };

    RedesignChartContainerController.prototype.unrenderAllCharts = function() {
      return this.renderChartController.unrenderAllCharts();
    };

    RedesignChartContainerController.prototype.uiQueue = function(closure, label) {
      var ref;
      return (ref = AppRedesign.current()) != null ? ref.uiQueue.add(closure, label, this.renderPriority(), this.item.id) : void 0;
    };

    RedesignChartContainerController.prototype.createTitleController = function() {
      var ref;
      if ((ref = this.chartTitleController) != null) {
        ref.release();
      }
      this.chartTitleController = new App.RedesignChartTitleController({
        el: this.titleEl(),
        item: this.item,
        supportsImageDataFunc: this.supportsImageData,
        supportsCSVDataFunc: this.supportsCSVData,
        supportsSearchFunc: this.supportsSearch,
        supportsPivotFunc: this.supportsPivot,
        sourceLimitError: this.erroredOnSourceLimit,
        supportsCopyClipboard: this.supportsCopyClipboard,
        chartHasError: ((function(_this) {
          return function() {
            var ref1;
            return ((ref1 = _this.errorMessage) != null ? ref1.length : void 0) > 0;
          };
        })(this)),
        editing: this.editing
      });
      this.bubbles(this.chartTitleController, "export-image-click");
      this.bubbles(this.chartTitleController, "control-pressed");
      this.bubbles(this.chartTitleController, "title-needs-draggability");
      this.item.bind('title-changed', this.setTitle);
      return this.renderChartController.setTitleController(this.chartTitleController);
    };

    RedesignChartContainerController.prototype.setTitle = function() {
      return this.renderChartController.updateTitle(this.item.getTitleForDisplay());
    };

    RedesignChartContainerController.prototype.queuePropertyChangeAndRender = function(property, value) {
      return this.uiQueue(((function(_this) {
        return function() {
          var newChartData;
          newChartData = {};
          if (_this.item[property] !== value) {
            newChartData[property] = value;
            return _this.renderChart(_this.item, true);
          }
        };
      })(this)), "renderChart");
    };

    RedesignChartContainerController.prototype.inEditron = function(el) {
      return App.RedesignDashboardSizer.inEditron(el);
    };

    RedesignChartContainerController.prototype.chartPadding = function() {
      var defaultTitlePadding;
      defaultTitlePadding = 5;
      if (this.inEditron(this.el)) {
        defaultTitlePadding *= 2;
      }
      if (this.item.chart_type === 'sparkline') {
        return 60 + defaultTitlePadding;
      }
      return defaultTitlePadding;
    };

    RedesignChartContainerController.prototype.setWidgetContentPosition = function() {
      return this.contentEl().css('top', this.titleEl().height() + this.chartPadding() + this.alertBlockEl().outerHeight(true) + App.RedesignChartContainerController.ALERT_MARGIN);
    };

    RedesignChartContainerController.prototype.hideAlert = function() {
      this.alertReferenceEl().text('');
      this.alertMessageEl().text('');
      this.alertBlockEl().hide();
      this.alertBlockEl().removeClass('error info warning');
      this.errorMessageEl().hide();
      return this.contentEl().css('top', this.titleEl().height() + this.chartPadding());
    };

    RedesignChartContainerController.prototype.renderErrorMessage = function(errorMsg) {
      this.hideAlert();
      this.errorMsg = errorMsg;
      if (errorMsg) {
        return this.renderErrors(errorMsg);
      }
    };

    RedesignChartContainerController.prototype.renderErrors = function(errorMsg) {
      var refAndError;
      this.unrenderAllCharts();
      this.renderTitle();
      if (errorMsg === 'No data' || errorMsg === App.Chartographer.ERR_NO_ROWS) {
        this.errorMessageEl().text("Query returned no matching rows.");
        this.errorMessageEl().show();
        return this.item.trigger('chart-rendered');
      } else if (errorMsg === App.Widget.QUERY_CANCELED_MESSAGE) {
        this.errorMessageEl().text(App.Widget.QUERY_CANCELED_MESSAGE);
        return this.errorMessageEl().show();
      } else if (errorMsg.includes('Result set too large.') && this.item.isDragDrop()) {
        return this.showAlert('error', '', this.formatDragDropTooLargeMessage(errorMsg));
      } else {
        refAndError = App.AlertHelpers.determineErrorReferenceAndMessage(errorMsg);
        this.showAlert('error', refAndError.alertReference, refAndError.alertMsg);
        this.hideLoader();
        return this.item.trigger('chart-rendered');
      }
    };

    RedesignChartContainerController.prototype.formatDragDropTooLargeMessage = function(message) {
      var regex_matches, row_count;
      regex_matches = message.match(/fewer than (.*) rows/);
      row_count = regex_matches[1];
      if (!row_count) {
        return message;
      }
      return "Results too large. Data displayed in web browser is limited to 5MB, please filter to narrow results to fewer than " + row_count + " data points.";
    };

    RedesignChartContainerController.prototype.showAlert = function(alertLevel, alertReference, alertMessage) {
      this.alertReferenceEl().text(alertReference);
      this.alertMessageEl().text(alertMessage);
      this.alertBlockEl().addClass(alertLevel).show().css('max-height', this.el.height() - this.titleEl().outerHeight(true) - App.RedesignChartContainerController.ALERT_SPACE_FROM_BOTTOM);
      return this.setWidgetContentPosition();
    };

    RedesignChartContainerController.prototype.beingModified = function() {
      return this.el.hasClass("clip-widget");
    };

    RedesignChartContainerController.prototype.renderChart = function(widget, animate, force, uwv) {
      var formulaSource, ref, ref1, ref2;
      if (force == null) {
        force = false;
      }
      if (uwv == null) {
        uwv = null;
      }
      if (this.released) {
        return;
      }
      this.renderTitle();
      if ((ref = this.chartTitleController) != null) {
        ref.maybeDisableExpand();
      }
      if (this.renderChartController.shouldHideOverlayTitle()) {
        if ((ref1 = this.chartTitleController) != null) {
          ref1.hideTitle();
        }
      } else {
        if ((ref2 = this.chartTitleController) != null) {
          ref2.showTitle();
        }
      }
      if (widget.isDragDrop()) {
        this.showDragDropInfo();
      }
      formulaSource = widget.selectedFormulaSource();
      if (!this.formulaSourceCanBeRendered(widget, force, formulaSource)) {
        return;
      }
      if (uwv == null) {
        uwv = App.UserWidgetView.findByWidgetOrNull(widget);
      }
      if (this.checkForDoubleRender(widget, uwv, formulaSource, force)) {
        return;
      }
      if (!this.beingModified()) {
        this.notifyFrameReset();
      }
      this.showChartEls();
      this.hideAlert();
      if (this.renderWidgetErrorMessage(widget)) {
        return;
      }
      if (!this.frameRendered) {
        this.renderFrame();
      }
      return this.tryRenderingWithChartographer(widget, animate, uwv);
    };

    RedesignChartContainerController.prototype.checkForDoubleRender = function(widget, uwv, formulaSource, force) {
      var renderOpts;
      renderOpts = JSON.stringify({
        chart_type: widget.chart_type,
        color_theme: widget.colorTheme().colorList(),
        hash_key: formulaSource != null ? formulaSource.hash_key : 0,
        height: this.contentEl().height(),
        last_refresh: formulaSource != null ? formulaSource.last_refresh : 0,
        s3LinksReady: (formulaSource != null) && !formulaSource.waitingOnS3Links(),
        title: widget.getTitleForDisplay(),
        twiddles: JSON.stringify(widget.twiddles),
        uwv: JSON.stringify(uwv != null ? uwv.twiddles : void 0),
        width: this.contentEl().width()
      });
      if (!force && ((this.renderOpts != null) && this.renderOpts === renderOpts)) {
        return true;
      }
      if ((this.renderOpts != null) && JSON.parse(this.renderOpts).chart_type !== widget.chart_type) {
        this.returnToUnrenderedState();
        this.renderFrame(true);
      }
      this.renderOpts = renderOpts;
      return false;
    };

    RedesignChartContainerController.prototype.formulaSourceCanBeRendered = function(widget, force, formulaSource) {
      var isCodeSource;
      if (widget.blocked_by_database_mapping_feature) {
        return true;
      }
      if (!(formulaSource != null ? formulaSource.hasData() : void 0) && widget.state() !== App.Widget.S_CANCELED) {
        return false;
      }
      isCodeSource = formulaSource.isCodeSource();
      if (!force && isCodeSource && !formulaSource.isCompletelyLoaded()) {
        return false;
      }
      if (!force && isCodeSource && formulaSource.hasUpdatePending()) {
        return false;
      }
      return true;
    };

    RedesignChartContainerController.prototype.renderWidgetErrorMessage = function(widget) {
      var ref, ref1, ref2, rows;
      this.errorMessage = widget.getError();
      if (this.inEditron(this.el) && (this.errorMessage = App.Widget.QUERY_CANCELED_MESSAGE)) {
        this.errorMessage = null;
      }
      rows = (ref = widget.selectedFormulaSource()) != null ? ref.rows : void 0;
      if (this.errorMessage && ((rows == null) || (rows != null ? rows.length : void 0) === 0)) {
        if (this.errorMessage.includes('syntax error at or near \"[') && widget.isDragDrop()) {
          this.errorMessage = 'Dataset not found, please select another dataset';
        }
        this.hideChartEls();
        this.unrenderAllCharts();
        this.renderErrorMessage(this.errorMessage);
        if ((ref1 = this.chartTitleController) != null) {
          ref1.maybeHidePreviewTooltipIcon();
        }
        if ((ref2 = this.chartTitleController) != null) {
          ref2.maybeDisableExpand();
        }
        return true;
      }
    };

    RedesignChartContainerController.prototype.tryRenderingWithChartographer = function(widget, animate, uwv) {
      var error, extraDetails, prefix, ref;
      try {
        if (!widget.isComplete()) {
          return this.showWaiting();
        }
        if (widget.state() === App.Widget.S_COMPLETE || widget.state() === App.Widget.S_CANCELED) {
          this.hideLoader();
        }
        this.errorMessage = this.renderChartController.renderWithChartographer(widget, widget.selectedFormulaSource(), animate, uwv, this.renderGuid);
        if (widget.state() === App.Widget.S_COMPLETE && (this.errorMessage != null)) {
          this.renderErrorMessage(this.errorMessage);
        }
        return (ref = this.chartTitleController) != null ? ref.maybeDisableExpand() : void 0;
      } catch (error1) {
        error = error1;
        prefix = "[widget:" + widget.id + ", ";
        prefix += "formula_source_hash:" + (widget.hashKey()) + "] ";
        extraDetails = {};
        if (error.twiddles != null) {
          extraDetails['twiddles'] = error.twiddles;
        }
        if (error.twiddlesActual != null) {
          extraDetails['twiddlesActual'] = error.twiddlesActual;
        }
        error.message = prefix + error.message;
        return this.reportError(error, extraDetails);
      }
    };

    RedesignChartContainerController.prototype.showDragDropInfo = function() {
      var ref, ref1, ref2;
      this.hideMaterializingCsvMessage();
      if (!((ref = this.editHelper) != null ? ref.dragDropInfo : void 0)) {
        return;
      }
      this.hideAlert();
      if (((ref1 = this.editHelper) != null ? ref1.dragDropInfo : void 0) === '__MATERIALIZING_CSV__') {
        return this.loaderMaterializingCsvMessageElementEl().show();
      } else {
        return this.showAlert('info', '', (ref2 = this.editHelper) != null ? ref2.dragDropInfo : void 0);
      }
    };

    RedesignChartContainerController.prototype.reportError = function(error, extraDetails) {
      return AppRedesign.logError(error, extraDetails);
    };

    RedesignChartContainerController.prototype.addAnnotation = function(group_name, description, x_value) {
      var a, autoAddGroup, currentAnnotations;
      if (group_name === '') {
        autoAddGroup = true;
        group_name = this.item.getTwiddle('twiddle_widget_annotation_group');
        if (!group_name) {
          group_name = App.Annotation.getUniqueGroupName(this.item.getTitleForDisplay());
          this.item.setTwiddle('twiddle_widget_annotation_group', group_name);
        }
      }
      if (group_name === this.item.getTwiddle('twiddle_widget_annotation_group')) {
        autoAddGroup = true;
      }
      a = new App.Annotation({
        group_name: group_name,
        description: description,
        x_value: x_value,
        is_auto_created_group: autoAddGroup
      });
      if (!a.save()) {
        return;
      }
      currentAnnotations = this.item.getArrayTwiddle('twiddle_annotation_groups').without(group_name);
      currentAnnotations.push(group_name);
      this.item.setTwiddle('twiddle_annotation_groups', currentAnnotations);
      if (this.inEditron(this.el)) {
        this.item.trigger('update');
        return this.uiQueue(((function(_this) {
          return function() {
            return _this.renderChart(_this.item, false, true);
          };
        })(this)), "renderChart");
      } else {
        return this.item.save();
      }
    };

    RedesignChartContainerController.prototype.deleteAnnotations = function(annotationIds) {
      var annotation, annotationId, i, len, results;
      results = [];
      for (i = 0, len = annotationIds.length; i < len; i++) {
        annotationId = annotationIds[i];
        annotation = App.Annotation.exists(annotationId);
        if (annotation) {
          results.push(annotation.destroy());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RedesignChartContainerController.prototype.overlayError = function(message) {
      var ref;
      return (ref = this.chartTitleController) != null ? ref.setTitleErrorMessage(message) : void 0;
    };

    RedesignChartContainerController.prototype.updateTitleArea = function() {
      var ref;
      return (ref = this.chartTitleController) != null ? ref.refreshChartDescriptionIcon() : void 0;
    };

    RedesignChartContainerController.prototype.resizeOnly = function() {
      return this.renderChartController.resizeOnly();
    };

    RedesignChartContainerController.prototype.resizeCharts = function() {
      return this.renderChartController.resizeCharts(this.errorMsg, this.sqlBlank());
    };

    RedesignChartContainerController.prototype.show = function() {
      return this.el.show();
    };

    RedesignChartContainerController.prototype.hide = function() {
      return this.el.hide();
    };

    RedesignChartContainerController.prototype.repositionChart = function() {
      var ref;
      if ((ref = this.alertBlockEl()) != null ? ref.is(':visible') : void 0) {
        this.setWidgetContentPosition();
      }
      return this.renderChartController.setAlertHeightForTableChart();
    };

    RedesignChartContainerController.prototype.saveMapPosition = function(position) {
      return this.trigger('save-map-position', position);
    };

    RedesignChartContainerController.prototype.chartHandler = function(msg) {
      return this.renderChartController.chartHandler(msg);
    };

    RedesignChartContainerController.prototype.notifyFrameReset = function() {
      return this.item.trigger('frame-reset');
    };

    RedesignChartContainerController.prototype.notifyFrameUnrendered = function() {
      return this.item.trigger('frame-unrendered');
    };

    RedesignChartContainerController.prototype.notifyFrameRendered = function() {
      return this.item.trigger('frame-rendered');
    };

    return RedesignChartContainerController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignChartDragHelper = (function(superClass) {
    extend(RedesignChartDragHelper, superClass);

    RedesignChartDragHelper.PREVIEW_INTERVAL = 10;

    RedesignChartDragHelper.AUTO_SCROLL_BOTTOM_BUFFER = 100;

    RedesignChartDragHelper.adjustIfNotDraggingTimeout = null;

    RedesignChartDragHelper.prototype.titleCover = function() {
      return this.el.find('.title > .cover');
    };

    RedesignChartDragHelper.prototype.gridBoundary = function() {
      return this.el.closest('.grid-boundary');
    };

    function RedesignChartDragHelper() {
      this.savePositionToBackend = bind(this.savePositionToBackend, this);
      this.adjustIfNotDraggingAgain = bind(this.adjustIfNotDraggingAgain, this);
      this.maybeResetDrag = bind(this.maybeResetDrag, this);
      this.handleMoveDragEnd = bind(this.handleMoveDragEnd, this);
      this.handleMove = bind(this.handleMove, this);
      this.dynamicallyRecalculatePositions = bind(this.dynamicallyRecalculatePositions, this);
      this.drag = bind(this.drag, this);
      this.handleMoveDragStart = bind(this.handleMoveDragStart, this);
      this.makeTitleDraggable = bind(this.makeTitleDraggable, this);
      RedesignChartDragHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'el');
      this.dashboard = App.Dashboard.exists(this.item.dashboard_id);
      this.dashboardSizer = new App.RedesignDashboardSizer(this.item.dashboard());
      RedesignChartDragHelper.__super__.constructor.apply(this, arguments);
    }

    RedesignChartDragHelper.prototype.release = function() {
      if (this.released) {
        return;
      }
      this.destroyDraggable();
      this.released = true;
      return RedesignChartDragHelper.__super__.release.apply(this, arguments);
    };

    RedesignChartDragHelper.prototype.destroyDraggable = function() {
      if (this.el.hasClass('clip-widget')) {
        return;
      }
      if (this.el.data("ui-draggable")) {
        return this.el.draggable("destroy");
      }
    };

    RedesignChartDragHelper.prototype.makeTitleDraggable = function() {
      return this.bindDraggable();
    };

    RedesignChartDragHelper.prototype.isRearrangeable = function() {
      if (this.rearrangeableFunc != null) {
        return this.rearrangeableFunc();
      } else {
        return false;
      }
    };

    RedesignChartDragHelper.prototype.bindDraggable = function() {
      return this.el.draggable({
        handle: this.titleCover(),
        start: this.handleMoveDragStart,
        stop: this.handleMoveDragEnd,
        drag: this.drag,
        containment: this.scrollContainmentAreaSlightlyLargerThanVisibleDashboardArea(),
        scroll: false
      });
    };

    RedesignChartDragHelper.prototype.scrollContainmentAreaSlightlyLargerThanVisibleDashboardArea = function() {
      var offsetFromWindowTopLeft, overflow, scrollParentEndX, scrollParentEndY, scrollParentX, scrollParentY;
      this.scrollParent = this.gridBoundary().closest('.main-content');
      offsetFromWindowTopLeft = this.scrollParent.offset();
      scrollParentX = offsetFromWindowTopLeft.left;
      scrollParentY = offsetFromWindowTopLeft.top;
      scrollParentEndX = offsetFromWindowTopLeft.left + this.scrollParent.width();
      scrollParentEndY = offsetFromWindowTopLeft.top + this.scrollParent.height();
      overflow = this.containmentAreaOverflow();
      return [scrollParentX - overflow.left, scrollParentY - overflow.top, scrollParentEndX + overflow.right, scrollParentEndY + overflow.bottom];
    };

    RedesignChartDragHelper.prototype.containmentAreaOverflow = function() {
      var bufferThatRemainsOnScreen;
      bufferThatRemainsOnScreen = this.dashboardSizer.columnWidth() * 2;
      return {
        left: this.el.width() - bufferThatRemainsOnScreen,
        top: this.el.height() - bufferThatRemainsOnScreen,
        right: -bufferThatRemainsOnScreen,
        bottom: -bufferThatRemainsOnScreen
      };
    };

    RedesignChartDragHelper.prototype.temporarilyMoveWidgetsInDOM = function(includeDraggedItem) {
      var i, len, ref, results, widget;
      ref = this.widgets;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (!includeDraggedItem && widget.id === this.item.id) {
          continue;
        }
        if (this.widgetHasMoved(widget)) {
          results.push(this.moveWidgetInDOM(widget));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RedesignChartDragHelper.prototype.moveWidgetInDOM = function(widget) {
      var widgetEl;
      widgetEl = $(".widget-container." + (_.kebabCase(widget.constructor.className)) + "-" + widget.id);
      this.dashboardSizer.setWidgetDashboardPosition(widgetEl, widget);
      return this.state[widget.id] = {
        col: widget.getColumn(),
        row: widget.getRow()
      };
    };

    RedesignChartDragHelper.prototype.widgetHasMoved = function(widget) {
      var currentLocation;
      currentLocation = this.state[widget.id];
      return currentLocation.col !== widget.getColumn() || currentLocation.row !== widget.getRow();
    };

    RedesignChartDragHelper.prototype.resetToCheckpoint = function(includeDraggedItem) {
      var i, len, ref, results, widget;
      ref = this.widgets;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (!includeDraggedItem && widget.id === this.item.id) {
          continue;
        }
        results.push(this.revertWidgetPosition(widget));
      }
      return results;
    };

    RedesignChartDragHelper.prototype.revertWidgetPosition = function(widget) {
      var prevState;
      prevState = this.initialState[widget.id];
      widget.setColumn(prevState.col);
      widget.setRow(prevState.row);
      return widget.positionOrSizeChanged = false;
    };

    RedesignChartDragHelper.prototype.handleMoveDragStart = function(e) {
      var widgetContainerPosition;
      this.widgetUndoController = new App.RedesignWidgetUndoController({
        dashboard: this.item.dashboard(),
        action: 'moved'
      });
      this.appState = AppRedesign.current().getCurrentState();
      this.beenDragging = false;
      App.hotkeys.bind(App.HotkeyManager.ESC, this.maybeResetDrag);
      if (!this.isRearrangeable()) {
        return false;
      }
      AppRedesign.current().setCurrentState(AppRedesign.INTERACTIVE);
      this.checkpointDashboard();
      this.el.addClass("clip-widget");
      this.el.addClass('widget-border');
      this.dashboardSizer.expandForResize(this.gridBoundary());
      this.gridBoundary().addClass('show-grid');
      widgetContainerPosition = this.el.position();
      this.widgetPositionLeft = Math.max(widgetContainerPosition.left, this.dashboardSizer.LEFT_GUTTER);
      this.widgetPositionTop = widgetContainerPosition.top;
      this.widgetWidthWithoutGutter = this.dashboardSizer.widgetWidthOnDashboardWithoutGutter(this.item);
      this.dragHandlerQuantization = 0;
      this.shadowDiv || (this.shadowDiv = $("<div class='moving-widget-shadow'></div>"));
      this.setShadowDimension();
      this.setShadowPosition();
      this.gridBoundary().append(this.shadowDiv);
      this.autoScroller = new App.AutoScroller(this.gridBoundary(), this.scrollParent, this.lowestScrollableYCoordinate(), (function(_this) {
        return function() {
          _this.shadowDivIsHidden = true;
          return _this.shadowDiv.hide();
        };
      })(this));
      return true;
    };

    RedesignChartDragHelper.prototype.lowestScrollableYCoordinate = function() {
      return this.lowestWidgetRow() * this.dashboardSizer.columnWidth() - this.constructor.AUTO_SCROLL_BOTTOM_BUFFER;
    };

    RedesignChartDragHelper.prototype.lowestWidgetRow = function() {
      var i, len, lowestRow, ref, widget;
      lowestRow = 0;
      ref = this.dashboard.widgets();
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        if (widget.id !== this.item.id) {
          lowestRow = Math.max(lowestRow, widget.getRow() + widget.getHeight());
        }
      }
      return lowestRow;
    };

    RedesignChartDragHelper.prototype.drag = function(event, ui) {
      clearTimeout(this.dragTimeout);
      if (this.escapePressed) {
        return false;
      }
      this.handleMove();
      this.el.addClass("moving-widget");
      this.autoScroller.maybeHandleScroll(ui);
      this.beenDragging = false;
      return this.dragTimeout = setTimeout(this.dynamicallyRecalculatePositions, this.constructor.PREVIEW_INTERVAL);
    };

    RedesignChartDragHelper.prototype.dynamicallyRecalculatePositions = function() {
      var _, ref;
      this.resetToCheckpoint();
      this.setPosition();
      this.collisionResolver.rearrange(this.widgets, this.item);
      this.setShadowPosition();
      this.temporarilyMoveWidgetsInDOM(false);
      ref = this.dashboardSizer.getWidgetPositionOnDashboard(this.item), _ = ref[0], _ = ref[1], this.widgetPositionTop = ref[2], this.widgetPositionLeft = ref[3];
      this.beenDragging = true;
      return this.dashboardSizer.expandForResize(this.gridBoundary());
    };

    RedesignChartDragHelper.prototype.setShadowDimension = function() {
      var _, height, ref, width;
      ref = this.dashboardSizer.getWidgetPositionOnDashboard(this.item), width = ref[0], height = ref[1], _ = ref[2], _ = ref[3];
      return this.shadowDiv.css({
        width: width,
        height: height
      });
    };

    RedesignChartDragHelper.prototype.setShadowPosition = function() {
      var _, left, ref, top;
      ref = this.dashboardSizer.getWidgetPositionOnDashboard(this.item), _ = ref[0], _ = ref[1], top = ref[2], left = ref[3];
      this.shadowDiv.css({
        top: top,
        left: left
      });
      if (this.shadowDivIsHidden) {
        this.shadowDivIsHidden = false;
        return this.shadowDiv.show();
      }
    };

    RedesignChartDragHelper.prototype.handleMove = function(e) {
      var variableGutter, widgetPosition;
      widgetPosition = this.el.position();
      this.dragHandlerQuantization++;
      if (widgetPosition.left < this.dashboardSizer.LEFT_GUTTER || this.dragHandlerQuantization % 10 === 0) {
        variableGutter = this.calculateVariableGutterBasedOnWidgetPosition(widgetPosition);
        this.el.find(".variable-left-margin").css("margin-left", 12 + variableGutter);
        return this.el.width(this.widgetWidthWithoutGutter + variableGutter);
      }
    };

    RedesignChartDragHelper.prototype.calculateVariableGutterBasedOnWidgetPosition = function(widgetPosition) {
      var variableGutter;
      variableGutter = this.dashboardSizer.LEFT_GUTTER - widgetPosition.left;
      variableGutter = Math.max(0, variableGutter);
      return variableGutter = Math.min(variableGutter, this.dashboardSizer.LEFT_GUTTER);
    };

    RedesignChartDragHelper.prototype.setPosition = function() {
      var gridSize, pendingHorizontalMove, pendingVerticalMove, widgetContainerPosition;
      widgetContainerPosition = this.el.position();
      gridSize = this.dashboardSizer.gridSizeForWidget(this.el, this.item);
      pendingHorizontalMove = Math.round((widgetContainerPosition.left - this.widgetPositionLeft) / gridSize[0]);
      pendingVerticalMove = Math.round((widgetContainerPosition.top - this.widgetPositionTop) / gridSize[1]);
      return this.item.moveTo(this.item.getColumn() + pendingHorizontalMove, this.item.getRow() + pendingVerticalMove);
    };

    RedesignChartDragHelper.prototype.handleMoveDragEnd = function(e) {
      App.hotkeys.unbind(App.HotkeyManager.ESC, this.maybeResetDrag);
      if (!this.isRearrangeable()) {
        return false;
      }
      if (this.escapePressed) {
        delete this.escapePressed;
        return;
      }
      this.el.addClass("moving-widget");
      setTimeout((function(_this) {
        return function() {
          var heightPx, leftPx, ref, topPx, widthPx;
          if (!_this.beenDragging) {
            _this.setPosition();
            _this.collisionResolver.rearrange(_this.widgets, _this.item);
            ref = _this.dashboardSizer.widgetPositionNormalMode(_this.el, _this.item), widthPx = ref[0], heightPx = ref[1], topPx = ref[2], leftPx = ref[3];
            _this.el.css({
              top: topPx + "px",
              left: leftPx + "px"
            });
          }
          AppRedesign.current().setCurrentState(_this.appState);
          _this.commitWidgetMove();
          return _this.widgetUndoController.maybeRender(_this.item);
        };
      })(this));
      clearTimeout(this.dragTimeout);
      this.removeShadow();
      this.resetGrid();
      this.autoScroller.release();
      return true;
    };

    RedesignChartDragHelper.prototype.maybeResetDrag = function(event) {
      if (this.escapePressed) {
        return;
      }
      if ((event != null ? event.which : void 0) !== AppRedesign.KEYS.ESCAPE) {
        return;
      }
      this.escapePressed = true;
      this.resetToCheckpoint(true);
      this.temporarilyMoveWidgetsInDOM(true);
      this.el.removeClass("moving-widget clip-widget widget-border");
      this.item.moveTo(this.item.getColumn(), this.item.getRow());
      this.resetGrid();
      this.removeShadow();
      return AppRedesign.current().setCurrentState(this.appState);
    };

    RedesignChartDragHelper.prototype.resetGrid = function() {
      this.el.removeClass('widget-border');
      this.gridBoundary().removeClass('show-grid');
      return this.dashboardSizer.layoutGrid(this.gridBoundary());
    };

    RedesignChartDragHelper.prototype.removeShadow = function() {
      this.shadowDiv.remove();
      return delete this.shadowDiv;
    };

    RedesignChartDragHelper.clearAdjustTimeout = function() {
      return clearTimeout(App.RedesignChartDragHelper.adjustIfNotDraggingTimeout);
    };

    RedesignChartDragHelper.prototype.commitWidgetMove = function() {
      if (this.released) {
        return;
      }
      this.item.moveTo(this.item.getColumn(), this.item.getRow());
      this.el.removeClass("clip-widget moving-widget");
      this.savePositionToBackend();
      App.RedesignChartDragHelper.clearAdjustTimeout();
      App.RedesignChartDragHelper.adjustIfNotDraggingTimeout = setTimeout(this.adjustIfNotDraggingAgain, 4000);
      return this.el.find(".variable-left-margin").css("margin-left", "");
    };

    RedesignChartDragHelper.prototype.adjustIfNotDraggingAgain = function() {
      if (AppRedesign.current().getCurrentState() === AppRedesign.INTERACTIVE) {
        return;
      }
      return this.dashboard.trigger('moved-widget');
    };

    RedesignChartDragHelper.prototype.savePositionToBackend = function() {
      var changedWidgets, preMoveWidgetStubs, resolveReason, stubsForWidgets, w;
      if (AppRedesign.current().getCurrentState() === AppRedesign.INTERACTIVE) {
        return;
      }
      if (AppRedesign.current().shared_mode || $('#body').hasClass('linked-widget-mode')) {
        return;
      }
      App.Lagotron.addContext("resolveWidgetCollision");
      preMoveWidgetStubs = App.Dashboard.widgetStubsForLogging(this.dashboard.widgets());
      changedWidgets = (function() {
        var i, len, ref, results;
        ref = this.widgets;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          w = ref[i];
          if (w.positionOrSizeChanged) {
            results.push(w);
          }
        }
        return results;
      }).call(this);
      stubsForWidgets = App.Widget.stubsForWidgets(changedWidgets);
      this.dashboard.saveWidgetStubs(stubsForWidgets);
      if (changedWidgets.length > 0) {
        resolveReason = 'widget-moved';
        App.Dashboard.logWidgetMove(preMoveWidgetStubs, this.item, 'before-' + resolveReason);
        return App.Dashboard.logWidgetMove(App.Dashboard.widgetStubsForLogging(changedWidgets), this.item, resolveReason);
      }
    };

    RedesignChartDragHelper.prototype.checkpointDashboard = function() {
      var i, len, ref, w;
      this.collisionResolver = new App.SplitStyleCollisionResolver(this.dashboard, true, true);
      this.widgets = _.filter(this.dashboard.widgets(), ((function(_this) {
        return function(w) {
          return w.id !== _this.item.id;
        };
      })(this)));
      this.widgets.push(this.item);
      this.initialState = {};
      ref = this.widgets;
      for (i = 0, len = ref.length; i < len; i++) {
        w = ref[i];
        this.initialState[w.id] = {
          row: w.getRow(),
          col: w.getColumn()
        };
      }
      return this.state = _.clone(this.initialState);
    };

    return RedesignChartDragHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCheckboxListController = (function(superClass) {
    extend(RedesignCheckboxListController, superClass);

    RedesignCheckboxListController.prototype.className = 'checkbox-list';

    RedesignCheckboxListController.prototype.events = {
      'click .icon': 'clicked',
      'click .label': 'clicked'
    };

    function RedesignCheckboxListController() {
      this.checkItemSelectedByKeyword = bind(this.checkItemSelectedByKeyword, this);
      this.clickedIndex = bind(this.clickedIndex, this);
      this.clicked = bind(this.clicked, this);
      RedesignCheckboxListController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'callback', 'checkboxConfigs');
      if (this.iconClass == null) {
        this.iconClass = 'checkbox';
      }
      this.html(this.view('redesign/controls/checkbox_list')({
        config: this.checkboxConfigs,
        iconClass: this.iconClass
      }));
      this.lastClickedAt = 0;
      this.lastClickedId = null;
    }

    RedesignCheckboxListController.prototype.bulkUpdateChecked = function(selectedIds) {
      var checkboxConfig, checkboxId, i, index, j, len, len1, ref, results, selectedMap, shouldBeChecked;
      selectedMap = {};
      for (i = 0, len = selectedIds.length; i < len; i++) {
        checkboxId = selectedIds[i];
        selectedMap[checkboxId] = true;
      }
      ref = this.checkboxConfigs;
      results = [];
      for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
        checkboxConfig = ref[index];
        shouldBeChecked = !!selectedMap[checkboxConfig.value];
        if (!!checkboxConfig.checked !== shouldBeChecked) {
          results.push(this.setChecked(index, shouldBeChecked));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RedesignCheckboxListController.prototype.checkAll = function() {
      var checkboxConfig, i, index, len, ref, shouldBeChecked;
      this.lastClickedId = null;
      ref = this.checkboxConfigs;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        checkboxConfig = ref[index];
        shouldBeChecked = true;
        if (!!checkboxConfig.checked !== shouldBeChecked) {
          this.setChecked(index, shouldBeChecked);
        }
      }
      return this.lastClickedId = null;
    };

    RedesignCheckboxListController.prototype.uncheckAll = function() {
      var checkboxConfig, i, index, len, ref, shouldBeChecked;
      this.lastClickedId = null;
      ref = this.checkboxConfigs;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        checkboxConfig = ref[index];
        shouldBeChecked = false;
        if (!!checkboxConfig.checked !== shouldBeChecked) {
          this.setChecked(index, shouldBeChecked);
        }
      }
      return this.lastClickedId = null;
    };

    RedesignCheckboxListController.prototype.selectedValues = function() {
      return _(this.checkboxConfigs).filter('checked').map('value').value();
    };

    RedesignCheckboxListController.prototype.changeIconClass = function(newIconClass) {
      this.$('.checkbox').removeClass(this.iconClass).addClass(newIconClass);
      return this.iconClass = newIconClass;
    };

    RedesignCheckboxListController.prototype.checkboxEl = function(checkboxIndex) {
      return this.$(".checkbox[data-checkbox-index='" + checkboxIndex + "']");
    };

    RedesignCheckboxListController.prototype.isChecked = function(checkboxIndex) {
      return this.checkboxConfigs[checkboxIndex].checked;
    };

    RedesignCheckboxListController.prototype.setChecked = function(checkboxIndex, state) {
      this.checkboxConfigs[checkboxIndex].checked = state;
      this.checkboxEl(checkboxIndex).toggleClass('selected', state);
      return state;
    };

    RedesignCheckboxListController.prototype.clicked = function(e) {
      var checkboxEl, checkboxIndex;
      checkboxEl = $(e.target).closest("." + this.iconClass);
      checkboxIndex = parseInt(checkboxEl.data('checkboxIndex'));
      this.clickedIndex(checkboxIndex, false);
      return e.stopPropagation();
    };

    RedesignCheckboxListController.prototype.clickedIndex = function(checkboxIndex, enter) {
      var checkboxConfig, doubleClick;
      checkboxConfig = this.checkboxConfigs[checkboxIndex];
      doubleClick = this.isDoubleClick(checkboxIndex);
      if (!doubleClick) {
        this.toggleChecked(checkboxIndex);
      }
      return this.callback(this.isChecked(checkboxIndex), checkboxConfig, doubleClick, enter);
    };

    RedesignCheckboxListController.prototype.toggleChecked = function(checkboxIndex) {
      var selected;
      selected = this.isChecked(checkboxIndex);
      return this.setChecked(checkboxIndex, !selected);
    };

    RedesignCheckboxListController.prototype.isDoubleClick = function(checkboxIndex) {
      var doubleClick;
      if (this.lastClickedId !== checkboxIndex) {
        doubleClick = false;
      } else {
        doubleClick = App.RadioButton.isDoubleClick(this.lastClickedAt);
      }
      this.lastClickedAt = App.RadioButton.lastClickedAtForDoubleClick(doubleClick);
      this.lastClickedId = checkboxIndex;
      return doubleClick;
    };

    RedesignCheckboxListController.prototype.checkItemSelectedByKeyword = function(e) {
      var checkboxEl, checkboxIndex;
      checkboxEl = this.$('.label-highlight').parent();
      checkboxIndex = parseInt(checkboxEl.data('checkboxIndex'));
      if (isNaN(checkboxIndex)) {
        return;
      }
      return this.clickedIndex(checkboxIndex, false);
    };

    return RedesignCheckboxListController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCsvEditorSettingsController = (function(superClass) {
    extend(RedesignCsvEditorSettingsController, superClass);

    RedesignCsvEditorSettingsController.prototype.className = 'csv-view-settings';

    RedesignCsvEditorSettingsController.prototype.elements = {
      '.data-discovery-area': 'dataDiscoveryArea',
      '.auto-archive-area': 'autoArchiveArea',
      '.auto-archive-toggle-area': 'autoArchiveToggleArea',
      '.default-settings-area': 'defaultSettingsArea',
      '.badge-toggle-area': 'badgeToggleArea'
    };

    function RedesignCsvEditorSettingsController() {
      this.excludedFromAutoArchiveChanged = bind(this.excludedFromAutoArchiveChanged, this);
      RedesignCsvEditorSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    RedesignCsvEditorSettingsController.prototype.release = function() {
      var ref, ref1;
      this.defaultSettingsController.release();
      if (AppRedesign.dragDropEnabled()) {
        this.dataDiscoverySettingsController.release();
      }
      if ((ref = this.archiveToggle) != null) {
        ref.release();
      }
      if ((ref1 = this.badgeToggleSettingsController) != null) {
        ref1.release();
      }
      return RedesignCsvEditorSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignCsvEditorSettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/sqlview_settings')({
        dragDropEnabled: AppRedesign.dragDropEnabled(),
        autoArchiveEnabled: AppRedesign.autoArchiveEnabled(),
        badgeToggleEnabled: AppRedesign.dashboardOrganizationEnabled()
      }));
      this.renderDataDiscoveryArea();
      this.renderAutoArchiveArea();
      this.renderDefaultSettingsArea();
      return this.renderBadgeToggleArea();
    };

    RedesignCsvEditorSettingsController.prototype.renderDataDiscoveryArea = function() {
      if (!AppRedesign.dragDropEnabled()) {
        return;
      }
      this.dataDiscoverySettingsController = new App.RedesignDataDiscoverySettingsController({
        item: this.item
      });
      this.dataDiscoverySettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.dataDiscoveryArea.append(this.dataDiscoverySettingsController.el);
    };

    RedesignCsvEditorSettingsController.prototype.renderAutoArchiveArea = function() {
      if (!AppRedesign.autoArchiveEnabled()) {
        return;
      }
      this.archiveToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.item.excluded_from_auto_archive,
        labelWhenToggleOn: 'Exclude from auto archive',
        labelWhenToggleOff: 'Exclude from auto archive'
      });
      this.autoArchiveToggleArea.append(this.archiveToggle.el);
      this.archiveToggle.bind('toggled', this.excludedFromAutoArchiveChanged);
      return this.checkAutoArchiveConfig();
    };

    RedesignCsvEditorSettingsController.prototype.renderDefaultSettingsArea = function() {
      this.defaultSettingsController = new App.DefaultEditorSettingsController({
        item: this.item,
        hideMainHeader: true
      });
      this.defaultSettingsArea.append(this.defaultSettingsController.el);
      return this.defaultSettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
    };

    RedesignCsvEditorSettingsController.prototype.excludedFromAutoArchiveChanged = function(toggleState) {
      this.item.excluded_from_auto_archive = toggleState;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignCsvEditorSettingsController.prototype.checkAutoArchiveConfig = function() {
      return jQuery.ajax({
        url: '/auto_archive_configs',
        type: 'get',
        data: {
          client_site_id: App.Site.first().id
        }
      }).done((function(_this) {
        return function(res) {
          if (!res || !res.id) {
            return _this.archiveToggle.disable();
          }
        };
      })(this));
    };

    RedesignCsvEditorSettingsController.prototype.renderBadgeToggleArea = function() {
      if (!(AppRedesign.dashboardOrganizationEnabled() && App.User.currentUser().isAdmin())) {
        return;
      }
      this.badgeToggleSettingsController = new App.BadgeToggleSettingsController({
        item: this.item,
        editHelper: this.editHelper,
        hasDetail: true
      });
      return this.badgeToggleArea.append(this.badgeToggleSettingsController.el);
    };

    return RedesignCsvEditorSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardHeaderController = (function(superClass) {
    extend(RedesignDashboardHeaderController, superClass);

    RedesignDashboardHeaderController.prototype.elements = {
      'input.header-title': 'dashboardTitle',
      '.badge': 'badgeIcon',
      '.info': 'infoIcon',
      '.refresh': 'refreshIcon',
      '.star': 'starIcon',
      '.add-to-topic': 'addToTopicIcon',
      '.dashboard-menu': 'dashboardMenuIcon',
      '.new-chart-button': 'newChartButton',
      '.new-text-box-button': 'newTextBoxButton',
      '.unarchive-button-area': 'unarchiveButtonArea',
      '.text-icon-root': 'textIcon'
    };

    RedesignDashboardHeaderController.prototype.events = {
      'click    .refresh': 'refreshIconClicked',
      'click    .star': 'starIconClicked',
      'click    .add-to-topic': 'addToTopicIconClicked',
      'click    .dashboard-menu': 'dashboardMenuIconClicked',
      'click .new-chart-button': 'newChartClicked',
      'click .new-text-box-button': 'newTextBoxClicked'
    };

    RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_INTERVAL = 50;

    RedesignDashboardHeaderController.MAX_TIME_TO_POLL_FOR_SQL_ALERT = 10000;

    RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_TIMER_ID = null;

    function RedesignDashboardHeaderController() {
      this.textBoxDrawingModeChanged = bind(this.textBoxDrawingModeChanged, this);
      this.addToTopicIconClicked = bind(this.addToTopicIconClicked, this);
      this.starIconClicked = bind(this.starIconClicked, this);
      this.maybeDisableRefresh = bind(this.maybeDisableRefresh, this);
      this.refreshInfo = bind(this.refreshInfo, this);
      this.iconInfo = bind(this.iconInfo, this);
      this.viewInfo = bind(this.viewInfo, this);
      this.badgeInfo = bind(this.badgeInfo, this);
      this.maybeHideNewChart = bind(this.maybeHideNewChart, this);
      this.permaDeleteArchiveClicked = bind(this.permaDeleteArchiveClicked, this);
      this.unarchiveClicked = bind(this.unarchiveClicked, this);
      this.toggleBadge = bind(this.toggleBadge, this);
      this.renderStarButtonState = bind(this.renderStarButtonState, this);
      this.release = bind(this.release, this);
      RedesignDashboardHeaderController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      if (this.dashboard.isArchived()) {
        this.html(this.view('redesign/dashboards/archived_dashboard_header')({
          spaceName: App.Site.first().spaceName(),
          textOnDashboardEnabled: false,
          dashboardOrganizationEnabled: AppRedesign.dashboardOrganizationEnabled()
        }));
      } else {
        this.html(this.view('redesign/dashboards/dashboard_header')({
          spaceName: App.Site.first().spaceName(),
          textOnDashboardEnabled: AppRedesign.textOnDashboardEnabled(),
          dashboardOrganizationEnabled: AppRedesign.dashboardOrganizationEnabled()
        }));
      }
      this.headerTitleController = new App.HeaderTitleController({
        el: this.el,
        item: this.dashboard
      });
      if (AppRedesign.dashboardOrganizationEnabled()) {
        this.badgeState = App.Badge.isBadged(this.dashboard);
        this.dashboard.bind('badge-toggled', this.toggleBadge);
        this.textIconRoot = window.reactApp.textIconRoot(this.textIcon[0], this.dashboard.displayName(), this.dashboard.icon_color, 48, 'dashboard-icon-large');
      }
      this.renderStarButtonState();
      this.dashboard.bind('starred', this.renderStarButtonState);
      this.dashboard.bind('unstarred', this.renderStarButtonState);
      App.Site.bind('group-change', this.maybeHideNewChart);
      App.Site.bind('change', this.maybeDisableRefresh);
      App.WidgetFetcher.bind(App.WidgetFetcher.EVENT_WIDGETS_ALL_FETCHED, this.maybeDisableRefresh);
      App.SourceFetcher.bind(App.SourceFetcher.EVENT_SOURCES_FETCHED, this.maybeDisableRefresh);
      if (AppRedesign.textOnDashboardEnabled()) {
        AppRedesign.current().bind('text-box-drawing-mode-changed', this.textBoxDrawingModeChanged);
      }
      this.render();
    }

    RedesignDashboardHeaderController.prototype.dashboardIsBadged = function() {
      return AppRedesign.dashboardOrganizationEnabled() && this.badgeState;
    };

    RedesignDashboardHeaderController.prototype.release = function() {
      var ref, ref1, ref2;
      this.dashboard.unbind('starred', this.renderStarButtonState);
      this.dashboard.unbind('unstarred', this.renderStarButtonState);
      App.Site.unbind('group-change', this.maybeHideNewChart);
      App.Site.unbind('change', this.maybeDisableRefresh);
      App.WidgetFetcher.unbind(App.WidgetFetcher.EVENT_WIDGETS_ALL_FETCHED, this.maybeDisableRefresh);
      App.SourceFetcher.unbind(App.SourceFetcher.EVENT_SOURCES_FETCHED, this.maybeDisableRefresh);
      if (AppRedesign.textOnDashboardEnabled()) {
        AppRedesign.current().unbind('text-box-drawing-mode-changed', this.textBoxDrawingModeChanged);
      }
      this.headerTitleController.release();
      this.infoTooltipController.release();
      if ((ref = this.badgeTooltipController) != null) {
        ref.release();
      }
      if ((ref1 = this.dashboardMoreMenuController) != null) {
        ref1.release();
      }
      if ((ref2 = this.textIconRoot) != null) {
        ref2.close();
      }
      if (App.RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_TIMER_ID != null) {
        this.clearSqlAlertPollInterval();
      }
      return RedesignDashboardHeaderController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardHeaderController.prototype.renderStarButtonState = function() {
      var cu, ref, ref1, ref2;
      if (this.dashboard.isArchived()) {
        return;
      }
      cu = App.User.currentUser();
      if ((cu != null) && cu.isReal() && !cu.isTemporary()) {
        if (this.dashboard.isStarredByCurrentUser()) {
          return (ref = this.starIcon) != null ? ref.addClass('starred') : void 0;
        } else {
          return (ref1 = this.starIcon) != null ? ref1.removeClass('starred') : void 0;
        }
      } else {
        return (ref2 = this.starIcon) != null ? ref2.hide() : void 0;
      }
    };

    RedesignDashboardHeaderController.prototype.toggleBadge = function(item, toggleState) {
      this.badgeState = toggleState;
      return this.render();
    };

    RedesignDashboardHeaderController.prototype.render = function() {
      var ref;
      this.maybeHideNewChart();
      this.maybeDisableRefresh();
      this.badgeIcon.toggleClass('badge-hidden', !this.dashboardIsBadged());
      if (!this.addToTopicEnabled()) {
        if ((ref = this.addToTopicIcon) != null) {
          ref.hide();
        }
      }
      if (this.dashboardIsBadged()) {
        if (this.badgeTooltipController == null) {
          this.badgeTooltipController = new App.IconTooltipHelper({
            icon: this.badgeIcon,
            infoCallback: this.badgeInfo
          });
        }
      }
      if (this.infoTooltipController == null) {
        this.infoTooltipController = new App.IconTooltipHelper({
          icon: this.infoIcon,
          infoCallback: this.viewInfo,
          tooltipWidth: '160px'
        });
      }
      if (this.refreshTooltipController == null) {
        this.refreshTooltipController = new App.IconTooltipHelper({
          icon: this.refreshIcon,
          infoCallback: this.refreshInfo
        });
      }
      if (this.starTooltipController == null) {
        this.starTooltipController = new App.IconTooltipHelper({
          icon: this.starIcon,
          infoCallback: this.iconInfo
        });
      }
      if (this.addToTopicTooltipController == null) {
        this.addToTopicTooltipController = new App.IconTooltipHelper({
          icon: this.addToTopicIcon,
          infoCallback: this.iconInfo
        });
      }
      this.headerTitleController.refresh();
      if (this.dashboard.isArchived() && !this.unarchiveButtons) {
        this.unarchiveButtons = new App.UnarchiveButtonBlock({
          itemName: 'dashboard'
        });
        this.unarchiveButtonArea.append(this.unarchiveButtons.el);
        this.unarchiveButtons.bind('unarchive', this.unarchiveClicked);
        this.unarchiveButtons.bind('perma-delete-archive', this.permaDeleteArchiveClicked);
      }
      return this.updateQualityCheckIcon();
    };

    RedesignDashboardHeaderController.prototype.updateQualityCheckIcon = function() {
      var maybeUpdateQualityCheckIcon, start;
      if (this.dashboard.sql_alert_id == null) {
        return;
      }
      start = Date.now();
      maybeUpdateQualityCheckIcon = (function(_this) {
        return function() {
          if (App.SqlAlert.exists(_this.dashboard.sql_alert_id)) {
            _this.clearSqlAlertPollInterval();
            if (_this.dashboard.isFailingQualityCheck()) {
              _this.infoIcon.addClass('status-failed-quality-check');
            } else {
              _this.infoIcon.removeClass('status-failed-quality-check');
            }
          }
          if ((Date.now() - start) > App.RedesignDashboardHeaderController.MAX_TIME_TO_POLL_FOR_SQL_ALERT) {
            return _this.clearSqlAlertPollInterval();
          }
        };
      })(this);
      return App.RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_TIMER_ID = setInterval(maybeUpdateQualityCheckIcon, App.RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_INTERVAL);
    };

    RedesignDashboardHeaderController.prototype.clearSqlAlertPollInterval = function() {
      clearInterval(App.RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_TIMER_ID);
      return App.RedesignDashboardHeaderController.POLL_FOR_SQL_ALERT_TIMER_ID = null;
    };

    RedesignDashboardHeaderController.prototype.unarchiveClicked = function() {
      return this.dashboard.unarchive();
    };

    RedesignDashboardHeaderController.prototype.permaDeleteArchiveClicked = function() {
      return this.dashboard.permaDeleteArchive();
    };

    RedesignDashboardHeaderController.prototype.maybeHideNewChart = function() {
      this.newChartButton.hide();
      this.newTextBoxButton.hide();
      if (this.createSqlChartEnabled() || this.createDiscoveryChartEnabled()) {
        this.newChartButton.css('display', 'inline-block');
      }
      if (this.createSqlChartEnabled()) {
        return this.newTextBoxButton.css('display', 'inline-block');
      }
    };

    RedesignDashboardHeaderController.prototype.makeMoreMenuOnce = function() {
      if (this.dashboardMoreMenuController) {
        return;
      }
      this.dashboardMoreMenuController = new App.RedesignDashboardMoreMenuController({
        dashboard: this.dashboard
      });
      this.dashboardMoreMenu = this.dashboardMoreMenuController.el;
      this.dashboardMoreMenuController.hideMenu();
      return this.el.closest('.dashboard-container').append(this.dashboardMoreMenu);
    };

    RedesignDashboardHeaderController.prototype.badgeInfo = function() {
      var badge, user;
      badge = App.Badge.getBadgeForModel(this.dashboard);
      if (!badge) {
        return;
      }
      user = App.User.find(badge.created_by_user_id);
      return this.view('tooltip/badge')({
        userString: user != null ? user.abbreviatedDisplayName() : void 0,
        dateString: App.TimeMachine.formatTimestamp(badge.created_at, 'MMM D, YYYY')
      }).trim();
    };

    RedesignDashboardHeaderController.prototype.viewInfo = function() {
      var dashboardInfo;
      dashboardInfo = this.dashboard.getDashboardRefreshData();
      return this.view('redesign/dashboards/info_view_tooltip')(dashboardInfo).trim();
    };

    RedesignDashboardHeaderController.prototype.iconInfo = function(evt) {
      return $(evt.currentTarget).data('tooltip');
    };

    RedesignDashboardHeaderController.prototype.refreshInfo = function() {
      var ref, refreshDisableSeconds, tooltipText;
      tooltipText = 'Refresh';
      if ((ref = this.refreshIcon) != null ? ref.hasClass('disabled') : void 0) {
        tooltipText = 'Refresh disabled by an administrator';
        refreshDisableSeconds = this.dashboard.userRefreshDisableMS();
        if (refreshDisableSeconds) {
          tooltipText += ' for data fresher than ' + App.Utils.roundedAgo(refreshDisableSeconds);
        }
      }
      return tooltipText;
    };

    RedesignDashboardHeaderController.prototype.maybeDisableRefresh = function() {
      var ref, ref1;
      if (this.dashboard.userRefreshDisabled()) {
        return (ref = this.refreshIcon) != null ? ref.addClass('disabled') : void 0;
      } else {
        return (ref1 = this.refreshIcon) != null ? ref1.removeClass('disabled') : void 0;
      }
    };

    RedesignDashboardHeaderController.prototype.refreshIconClicked = function() {
      if (this.dashboard.userRefreshDisabled()) {
        return;
      }
      this.dashboard.refreshAllWidgets();
      return App.Utils.logFeature("refresh-all-charts", {
        dashboard_id: this.dashboard.id
      });
    };

    RedesignDashboardHeaderController.prototype.starIconClicked = function() {
      var star;
      if (AppRedesign.readOnlyMaintenanceMode() || this.dashboard.isNew()) {
        return;
      }
      star = this.dashboard.starForCurrentUser();
      if (star != null) {
        if (star.readyToBeDestroyed()) {
          return star.destroy();
        }
      } else {
        return App.DashboardStar.create({
          user_id: App.User.currentUser().id,
          dashboard_id: this.dashboard.id
        });
      }
    };

    RedesignDashboardHeaderController.prototype.addToTopicIconClicked = function(mouseEvent) {
      var dialogWidth, divRect, left, top;
      if (AppRedesign.readOnlyMaintenanceMode() || this.dashboard.isNew()) {
        return;
      }
      if (!AppRedesign.dashboardOrganizationEnabled()) {
        return;
      }
      divRect = mouseEvent.target.getBoundingClientRect();
      top = divRect.bottom + 10;
      left = divRect.left - 182;
      dialogWidth = 386;
      if ((window.innerWidth - divRect.left) < 182) {
        left = window.innerWidth - dialogWidth;
      }
      return window.reactApp.dispatchPinToTopicModal('Dashboard', this.dashboard.id, top, left);
    };

    RedesignDashboardHeaderController.prototype.dashboardMenuIconClicked = function(e) {
      var menuRight, menuWidth, mouseLeft, mouseRight, pointer, pointerBorder, pointerLeft;
      App.Site.trigger('close-toast');
      this.makeMoreMenuOnce();
      if (this.dashboardMoreMenuController.isOpen()) {
        return this.dashboardMoreMenuController.hideMenu();
      } else {
        mouseLeft = (e.target.getBoundingClientRect().left + e.target.getBoundingClientRect().right) / 2;
        mouseRight = window.innerWidth - mouseLeft;
        menuWidth = this.dashboardMoreMenu.width();
        menuRight = mouseRight - (menuWidth / 2);
        this.dashboardMoreMenu.css({
          right: menuRight
        });
        pointerBorder = this.dashboardMoreMenu.find('.pointer-border');
        pointerLeft = menuWidth / 2 - 7;
        pointerBorder.css({
          left: pointerLeft
        });
        pointer = this.dashboardMoreMenu.find('.pointer');
        pointer.css({
          left: pointerLeft + 1
        });
        if (menuRight < 5) {
          menuRight = 5;
          this.dashboardMoreMenu.css({
            right: menuRight
          });
          pointerBorder.css({
            left: menuWidth - 28
          });
          pointer.css({
            left: menuWidth + 1 - 28
          });
        }
        return this.dashboardMoreMenuController.openMenu();
      }
    };

    RedesignDashboardHeaderController.prototype.newChartClicked = function() {
      return this.trigger('new-widget');
    };

    RedesignDashboardHeaderController.prototype.newTextBoxClicked = function() {
      return this.trigger('text-box-icon-clicked');
    };

    RedesignDashboardHeaderController.prototype.textBoxDrawingModeChanged = function() {
      if (AppRedesign.current().newTextBoxDrawingMode) {
        return this.newTextBoxButton.addClass('pressed');
      } else {
        return this.newTextBoxButton.removeClass('pressed');
      }
    };

    RedesignDashboardHeaderController.prototype.createSqlChartEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.currentPermissionsExist() && AppRedesign.createSqlChartsEnabledOnDashboard()) {
          return true;
        }
      } else {
        return !(this.dashboard.isReadOnlyToCurrentUser() || this.dashboard.hasSharedDashboardFactories());
      }
    };

    RedesignDashboardHeaderController.prototype.createDiscoveryChartEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.currentPermissionsExist() && (AppRedesign.createDiscoveryChartsEnabledOnDashboard() && AppRedesign.dragDropEnabled())) {
          return true;
        }
      } else {
        return !(this.dashboard.isReadOnlyToCurrentUser() || this.dashboard.hasSharedDashboardFactories());
      }
    };

    RedesignDashboardHeaderController.prototype.addToTopicEnabled = function() {
      var ref, ref1;
      if (AppRedesign.current().state.RbacEnabled) {
        return (ref = AppRedesign.current().state.RbacPermissionsHash) != null ? (ref1 = ref.topic_permissions) != null ? ref1.add_objects_to_topics : void 0 : void 0;
      } else {
        return this.createDiscoveryChartEnabled();
      }
    };

    return RedesignDashboardHeaderController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardLayoutController = (function(superClass) {
    extend(RedesignDashboardLayoutController, superClass);

    RedesignDashboardLayoutController.prototype.className = 'charts-container';

    RedesignDashboardLayoutController.prototype.elements = {
      '.grid-boundary': 'gridBoundary',
      '.dashboard-header': 'dashboardHeader'
    };

    RedesignDashboardLayoutController.DASHBOARD_COLUMN_WIDTHS_BY_ID = {};

    function RedesignDashboardLayoutController() {
      this.checkControlsState = bind(this.checkControlsState, this);
      this.widgetUpdated = bind(this.widgetUpdated, this);
      this.scrollToWidget = bind(this.scrollToWidget, this);
      this.resizeToExactHeightForScreenshot = bind(this.resizeToExactHeightForScreenshot, this);
      this.update = bind(this.update, this);
      this.widgetMovedDashboards = bind(this.widgetMovedDashboards, this);
      this.resolveWidgetCollision = bind(this.resolveWidgetCollision, this);
      this.resolveWidgetCollisionOnCollapse = bind(this.resolveWidgetCollisionOnCollapse, this);
      this.resolveWidgetCollisionOnEditorResize = bind(this.resolveWidgetCollisionOnEditorResize, this);
      this.resolveWidgetCollisionOnMove = bind(this.resolveWidgetCollisionOnMove, this);
      this.resolveWidgetCollisionOnResize = bind(this.resolveWidgetCollisionOnResize, this);
      this.newWidget = bind(this.newWidget, this);
      this.updateGridSize = bind(this.updateGridSize, this);
      this.updateGridLines = bind(this.updateGridLines, this);
      this.recheckRows = bind(this.recheckRows, this);
      this.runScheduledUpdateGridSize = bind(this.runScheduledUpdateGridSize, this);
      this.scheduleUpdateGridSize = bind(this.scheduleUpdateGridSize, this);
      this.renderWidgetsInViewport = bind(this.renderWidgetsInViewport, this);
      this.resetWidgetRenderInterval = bind(this.resetWidgetRenderInterval, this);
      this.removePDFGuideline = bind(this.removePDFGuideline, this);
      this.renderPDFGuideline = bind(this.renderPDFGuideline, this);
      this.renderPrintFriendlyLabel = bind(this.renderPrintFriendlyLabel, this);
      this.removePrintFriendlyLabel = bind(this.removePrintFriendlyLabel, this);
      this.renderOrRemovePDFGuideline = bind(this.renderOrRemovePDFGuideline, this);
      this.render = bind(this.render, this);
      this.dashboardMadeCurrent = bind(this.dashboardMadeCurrent, this);
      this.hideGrid = bind(this.hideGrid, this);
      this.showGrid = bind(this.showGrid, this);
      this.release = bind(this.release, this);
      var ref;
      RedesignDashboardLayoutController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      this.dashboardSizer = new App.RedesignDashboardSizer(this.dashboard);
      if (this.tvMode == null) {
        this.tvMode = AppRedesign.isInTvMode();
      }
      if (this.widgetControllers == null) {
        this.widgetControllers = [];
      }
      this.elevation = 0;
      this.currentWidth = this.dashboard.numCols();
      this.widgetToScrollTo = -1;
      this.rightmostWidgetGridColumn = 0;
      this.dashboard.bind('update', this.update);
      this.dashboard.bind('moved-widget', this.resolveWidgetCollisionOnMove);
      this.dashboard.bind('resized-widget', this.resolveWidgetCollisionOnResize);
      this.dashboard.bind('resized-widget-in-editor', this.resolveWidgetCollisionOnEditorResize);
      this.dashboard.bind('dashboard-window-focus', this.resetWidgetRenderInterval);
      this.dashboard.bind('resize-to-exact-height-for-screenshot', this.resizeToExactHeightForScreenshot);
      this.dashboard.bind('scroll-to-widget', this.scrollToWidget);
      this.dashboard.bind('dashboard-made-current', this.dashboardMadeCurrent);
      App.Dashboard.bind('collapse-empty-rows', this.resolveWidgetCollisionOnCollapse);
      App.Widget.bind('refresh', this.render);
      App.Widget.bind("create", this.newWidget);
      App.Widget.bind("destroy", this.recheckRows);
      App.Widget.bind("update", this.widgetUpdated);
      App.Widget.bind('move-dashboards', this.widgetMovedDashboards);
      App.Site.bind('group-change', this.checkControlsState);
      $(window).on('resize', this.scheduleUpdateGridSize);
      App.FontLoadedChecker.checkIfFirstTime();
      if ((ref = window.reactApp) != null) {
        if (typeof ref.updateGridSize === "function") {
          ref.updateGridSize(this.dashboardSizer.columnWidth());
        }
      }
      this.render();
      this.dashboardMadeCurrent();
    }

    RedesignDashboardLayoutController.prototype.release = function() {
      delete this.constructor.DASHBOARD_COLUMN_WIDTHS_BY_ID[this.dashboard.id];
      this.dashboard.unbind('moved-widget', this.resolveWidgetCollisionOnMove);
      this.dashboard.unbind('resized-widget', this.resolveWidgetCollisionOnResize);
      this.dashboard.unbind('resized-widget-in-editor', this.resolveWidgetCollisionOnEditorResize);
      this.dashboard.unbind('update', this.update);
      this.dashboard.unbind('dashboard-window-focus', this.resetWidgetRenderInterval);
      this.dashboard.unbind('resize-to-exact-height-for-screenshot', this.resizeToExactHeightForScreenshot);
      this.dashboard.unbind('scroll-to-widget', this.scrollToWidget);
      this.dashboard.unbind('dashboard-made-current', this.dashboardMadeCurrent);
      App.Dashboard.unbind('collapse-empty-rows', this.resolveWidgetCollisionOnCollapse);
      App.Widget.unbind('refresh', this.render);
      App.Widget.unbind("create", this.newWidget);
      App.Widget.unbind("destroy", this.recheckRows);
      App.Widget.unbind("update", this.widgetUpdated);
      App.Widget.unbind('move-dashboards', this.widgetMovedDashboards);
      App.Site.unbind('group-change', this.checkControlsState);
      $(window).off('resize', this.scheduleUpdateGridSize);
      this.trigger('released-layout-controller');
      return RedesignDashboardLayoutController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardLayoutController.prototype.showGrid = function() {
      return this.gridBoundary.addClass('show-grid');
    };

    RedesignDashboardLayoutController.prototype.hideGrid = function() {
      return this.gridBoundary.removeClass('show-grid');
    };

    RedesignDashboardLayoutController.prototype.refreshWidgets = function(widgetIds) {
      var j, len, ref, results, wc;
      ref = this.widgetControllers;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        wc = ref[j];
        if (widgetIds.includes(wc.item.id)) {
          results.push(wc.update());
        }
      }
      return results;
    };

    RedesignDashboardLayoutController.prototype.dashboardMadeCurrent = function() {
      return this.resetWidgetRenderInterval();
    };

    RedesignDashboardLayoutController.prototype.render = function() {
      var c, j, k, len, len1, newControllers, ref, widget;
      App.Lagotron.addContext("dashboardRender");
      this.gridRowCount = 0;
      this.html(this.view('redesign/dashboards/charts-container')());
      this.gridBoundary.append(this.view('redesign/dashboards/grid_columns')({
        numDividers: 10
      }));
      this.renderOrRemovePDFGuideline();
      this.recheckRows();
      newControllers = (function() {
        var j, len, ref, results;
        ref = this.dashboard.widgets();
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          widget = ref[j];
          results.push(this.addWidget(widget));
        }
        return results;
      }).call(this);
      for (j = 0, len = newControllers.length; j < len; j++) {
        c = newControllers[j];
        c.renderIfInViewport();
      }
      for (k = 0, len1 = newControllers.length; k < len1; k++) {
        c = newControllers[k];
        this.gridBoundary.append(c.el);
      }
      if ((ref = AppRedesign.current()) != null ? ref.embed_mode : void 0) {
        AppRedesign.logToScalyr('embed-dashboard-margin', {
          margin: this.el.css('margin-left')
        });
        this.postResizeMessage();
      }
      return this.checkControlsState();
    };

    RedesignDashboardLayoutController.prototype.renderOrRemovePDFGuideline = function() {
      if (App.Site.first().isPDFDownloadEnabled()) {
        this.renderPrintFriendlyLabel();
        return this.renderPDFGuideline();
      } else {
        this.removePrintFriendlyLabel();
        return this.removePDFGuideline();
      }
    };

    RedesignDashboardLayoutController.prototype.removePrintFriendlyLabel = function() {
      return this.gridBoundary.find(".grid-marker-label.print-friendly").remove();
    };

    RedesignDashboardLayoutController.prototype.renderPrintFriendlyLabel = function() {
      this.removePrintFriendlyLabel();
      return this.gridBoundary.append(this.view('redesign/dashboards/print-friendly-label')());
    };

    RedesignDashboardLayoutController.prototype.renderPDFGuideline = function() {
      var firstPageTop, i, j, pageNum, ref, results, top;
      this.removePDFGuideline();
      this.PAGE_HEIGHT = 768;
      this.FIRST_PAGE_TOP_WITH_FILTER = 608;
      this.FIRST_PAGE_TOP_NO_FILTER = 672;
      this.NUM_GUIDELINES = 24;
      firstPageTop = this.FIRST_PAGE_TOP_WITH_FILTER;
      if (this.dashboard.filtersEnabled()) {
        firstPageTop = this.FIRST_PAGE_TOP_WITH_FILTER;
      } else {
        firstPageTop = this.FIRST_PAGE_TOP_NO_FILTER;
      }
      results = [];
      for (i = j = 0, ref = this.NUM_GUIDELINES; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        top = firstPageTop + i * this.PAGE_HEIGHT;
        pageNum = i + 1;
        results.push(this.gridBoundary.append(this.view('redesign/dashboards/pdf-guideline')({
          pageNum: pageNum,
          top: top
        })));
      }
      return results;
    };

    RedesignDashboardLayoutController.prototype.removePDFGuideline = function() {
      return this.gridBoundary.find(".grid-screen-marker-horizontal").remove();
    };

    RedesignDashboardLayoutController.prototype.resetWidgetRenderInterval = function(renderNow, renderDelay) {
      if (renderNow == null) {
        renderNow = true;
      }
      if (renderDelay == null) {
        renderDelay = 300;
      }
      clearInterval(this.widgetInterval);
      if (renderNow) {
        this.renderWidgetsInViewport();
      }
      return this.widgetInterval = setInterval(this.renderWidgetsInViewport, renderDelay);
    };

    RedesignDashboardLayoutController.prototype.renderWidgetsInViewport = function() {
      var j, len, ref, results, wc;
      ref = this.widgetControllers;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        wc = ref[j];
        results.push(wc.trigger('render-if-in-viewport'));
      }
      return results;
    };

    RedesignDashboardLayoutController.prototype.scheduleUpdateGridSize = function(e) {
      if (e.target !== window) {
        return;
      }
      if (this.dashboard.isActive()) {
        clearTimeout(this.resizeTimer);
        return this.resizeTimer = setTimeout(this.runScheduledUpdateGridSize, 500);
      } else {
        if (!this.dashboard.isArchived()) {
          return this.release();
        }
      }
    };

    RedesignDashboardLayoutController.prototype.runScheduledUpdateGridSize = function() {
      delete this.constructor.DASHBOARD_COLUMN_WIDTHS_BY_ID[this.dashboard.id];
      this.updateGridSize();
      if (typeof app !== "undefined" && app !== null ? app.embed_mode : void 0) {
        return this.postResizeMessage();
      }
    };

    RedesignDashboardLayoutController.prototype.recheckRows = function() {
      var shortMode;
      shortMode = (typeof app !== "undefined" && app !== null ? app.embed_mode : void 0) || (typeof app !== "undefined" && app !== null ? app.tvmode : void 0);
      if (shortMode) {
        this.dashboardSizer.DEFAULT_ROWS = 0;
      }
      return this.updateGridLines();
    };

    RedesignDashboardLayoutController.prototype.removeGridRow = function() {
      this.gridBoundary.find(".grid-row.row-" + this.gridRowCount).remove();
      return this.gridRowCount--;
    };

    RedesignDashboardLayoutController.prototype.addGridRow = function() {
      this.gridBoundary.append(this.view('dashboards/grid_row')({
        row: this.gridRowCount,
        tvMode: this.tvMode
      }));
      return this.gridRowCount++;
    };

    RedesignDashboardLayoutController.prototype.updateGridLines = function() {
      App.Lagotron.addContext("updateGridLines");
      this.dashboardSizer.centerElementForDashboard(this.el);
      this.dashboardSizer.layoutGrid(this.gridBoundary);
      return this.dashboard.trigger('grid-updated');
    };

    RedesignDashboardLayoutController.prototype.updateGridSize = function() {
      var ref;
      if (!this.dashboard.isActive()) {
        return;
      }
      this.updateGridLines();
      App.Lagotron.addContext("updateGridSize");
      setTimeout(((function(_this) {
        return function() {
          var j, len, ref, ref1, results, wc;
          if (AppRedesign.current() == null) {
            return;
          }
          ref = _this.widgetControllers;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            wc = ref[j];
            results.push(AppRedesign.current().uiQueue.add(wc.reposition, "Widget Reposition", 10, (ref1 = wc.item) != null ? ref1.id : void 0));
          }
          return results;
        };
      })(this)), 100);
      return (ref = window.reactApp) != null ? typeof ref.updateGridSize === "function" ? ref.updateGridSize(this.dashboardSizer.columnWidth()) : void 0 : void 0;
    };

    RedesignDashboardLayoutController.prototype.maybeResizeGrid = function() {
      var rightmost;
      rightmost = this.dashboardSizer.getRightmostWidgetGridColumn();
      if (rightmost !== this.rightmostWidgetGridColumn) {
        this.rightmostWidgetGridColumn = rightmost;
        return this.updateGridSize();
      }
    };

    RedesignDashboardLayoutController.prototype.addWidget = function(widget) {
      var newHeight, newLeft, newTop, newWidth, ref, widgetController;
      ref = this.dashboardSizer.getWidgetPositionOnDashboard(widget), newWidth = ref[0], newHeight = ref[1], newTop = ref[2], newLeft = ref[3];
      this.trigger('chart-added');
      widgetController = new App.DashboardItemContainerController({
        item: widget,
        width: newWidth,
        height: newHeight,
        top: newTop,
        left: newLeft
      });
      this.bubbles(widgetController, 'edit-widget');
      this.widgetControllers.push(widgetController);
      return widgetController;
    };

    RedesignDashboardLayoutController.prototype.newWidget = function(widget) {
      var c, index;
      index = _.findIndex(this.widgetControllers, function(controller) {
        return controller.item.id === widget.id;
      });
      if (index !== -1) {
        return;
      }
      if (widget.dashboard_id === this.dashboard.id) {
        c = this.addWidget(widget);
        this.gridBoundary.append(c.el);
        this.recheckNextTick();
        this.maybeResizeGrid();
      }
      if (this.widgetToScrollTo === widget.id) {
        return this.scrollToWidget(null, widget.id);
      }
    };

    RedesignDashboardLayoutController.prototype.recheckNextTick = function() {
      if (!this.recheckRowsTimeout) {
        return this.recheckRowsTimeout = setTimeout(((function(_this) {
          return function() {
            _this.recheckRows();
            return delete _this.recheckRowsTimeout;
          };
        })(this)), 0);
      }
    };

    RedesignDashboardLayoutController.prototype.resolveWidgetCollisionOnResize = function(dashboard, resizedWidget) {
      return this.resolveWidgetCollision(resizedWidget, 'widget-resized');
    };

    RedesignDashboardLayoutController.prototype.resolveWidgetCollisionOnMove = function(dashboard) {
      return this.resolveWidgetCollision(null, 'widget-moved');
    };

    RedesignDashboardLayoutController.prototype.resolveWidgetCollisionOnEditorResize = function(dashboard, resizedWidget) {
      return this.resolveWidgetCollision(resizedWidget, 'widget-resized-in-editor');
    };

    RedesignDashboardLayoutController.prototype.resolveWidgetCollisionOnCollapse = function(dashboard_id) {
      if (dashboard_id !== this.dashboard.id) {
        return;
      }
      return this.resolveWidgetCollision(null, 'collapse-empty-rows');
    };

    RedesignDashboardLayoutController.prototype.resolveWidgetCollision = function(resizedWidget, resolveReason) {
      var changedWidgets, preMoveWidgetStubs, stubsForWidgets, w, widgetList;
      if (resizedWidget == null) {
        resizedWidget = null;
      }
      if (AppRedesign.current().getCurrentState() === AppRedesign.INTERACTIVE) {
        return;
      }
      if (AppRedesign.current().shared_mode || $('#body').hasClass('linked-widget-mode')) {
        return;
      }
      App.Lagotron.addContext("resolveWidgetCollision");
      this.el.addClass('moving-widget');
      if (resizedWidget != null) {
        widgetList = (function() {
          var j, len, ref, results;
          ref = this.dashboard.widgets();
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            w = ref[j];
            if (w.id !== resizedWidget.id) {
              results.push(w);
            }
          }
          return results;
        }).call(this);
        widgetList.push(resizedWidget);
      } else {
        widgetList = this.dashboard.widgets();
      }
      preMoveWidgetStubs = App.Dashboard.widgetStubsForLogging(this.dashboard.widgets());
      new App.SplitStyleCollisionResolver(this.dashboard, true).rearrange(widgetList, resizedWidget, resolveReason);
      changedWidgets = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = widgetList.length; j < len; j++) {
          w = widgetList[j];
          if (w.positionOrSizeChanged) {
            results.push(w);
          }
        }
        return results;
      })();
      stubsForWidgets = App.Widget.stubsForWidgets(changedWidgets);
      this.dashboard.saveWidgetStubs(stubsForWidgets);
      if (changedWidgets.length > 0) {
        App.Dashboard.logWidgetMove(preMoveWidgetStubs, resizedWidget, 'before-' + resolveReason);
        App.Dashboard.logWidgetMove(App.Dashboard.widgetStubsForLogging(changedWidgets), resizedWidget, resolveReason);
      }
      App.Widget.trigger('resolved-collision');
      return setTimeout(((function(_this) {
        return function() {
          return _this.el.removeClass('moving-widget');
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignDashboardLayoutController.prototype.widgetMovedDashboards = function(widget, args) {
      if (widget.dashboard_id === this.dashboard.id) {
        return this.newWidget(widget);
      } else if (args.old_dashboard_id === this.dashboard.id) {
        this.releaseWidgetIfExists(widget);
        return this.resolveWidgetCollision(null, 'widget-moved-dashboards');
      }
    };

    RedesignDashboardLayoutController.prototype.releaseWidgetIfExists = function(widget) {
      var c, j, len, newControllers, ref;
      newControllers = [];
      ref = this.widgetControllers;
      for (j = 0, len = ref.length; j < len; j++) {
        c = ref[j];
        if (c.item.id === widget.id && c.item.constructor.className === widget.constructor.className) {
          c.release();
        } else {
          newControllers.push(c);
        }
      }
      return this.widgetControllers = newControllers;
    };

    RedesignDashboardLayoutController.prototype.newWidgetIfNotExists = function(widget) {
      var c, j, len, ref, widgetEl;
      ref = this.widgetControllers;
      for (j = 0, len = ref.length; j < len; j++) {
        c = ref[j];
        if (c.item.id === widget.id || c.item.id === widget.cid) {
          widgetEl = c.el;
          widgetEl.addClass("widget-" + widget.id);
          return;
        }
      }
      return this.newWidget(widget);
    };

    RedesignDashboardLayoutController.prototype.update = function() {
      if (this.currentWidth !== this.dashboard.numCols()) {
        this.currentWidth = this.dashboard.numCols();
      }
      return this.checkControlsState();
    };

    RedesignDashboardLayoutController.prototype.resizeToExactHeightForScreenshot = function() {
      return this.el.height(this.dashboardSizer.SCREENSHOT_COLUMN_WIDTH * this.dashboard.nextFreeRow() + this.dashboardSizer.SCREENSHOT_BORDER_OFFSET);
    };

    RedesignDashboardLayoutController.prototype.scrollToWidget = function(_, widgetId) {
      var widget, widgetEl;
      widget = App.Widget.exists(widgetId);
      if (widget) {
        widgetEl = this.gridBoundary.find(".widget-container.widget-" + widget.id + ", .widget-container.widget-" + widget.cid).last();
        if ((widgetEl != null ? widgetEl.length : void 0) > 0) {
          App.Dashboard.trigger('scroll-to-el', widgetEl);
          this.widgetToScrollTo = -1;
        }
      }
    };

    RedesignDashboardLayoutController.prototype.widgetUpdated = function(widget) {
      this.recheckNextTick();
      if (widget.dashboard_id !== this.dashboard.id) {
        return this.releaseWidgetIfExists(widget);
      } else {
        return this.newWidgetIfNotExists(widget);
      }
    };

    RedesignDashboardLayoutController.prototype.checkControlsState = function() {
      var ref;
      this.el.toggleClass('shared-mode', !!((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0));
      this.el.toggleClass('read-only', this.dashboard.isReadOnlyToCurrentUser());
      return this.el.toggleClass('not-rearrangeable', !this.dashboard.isRearrangeableByCurrentUser());
    };

    RedesignDashboardLayoutController.prototype.postResizeMessage = function() {
      var args, filterBarHeight, ref;
      if (App.Utils.isInsideIframe()) {
        filterBarHeight = (ref = $('.dashboard-container.active .filters-bar').outerHeight()) != null ? ref : 0;
        args = {
          event_type: "dashboard_resize",
          dashboard_height: this.dashboardSizer.rowHeight() * this.dashboard.nextFreeRow() + filterBarHeight,
          dashboard_width: this.dashboardSizer.widthForScreen()
        };
        return window.parent.postMessage(args, '*');
      }
    };

    RedesignDashboardLayoutController.getInitialColumnWidth = function(dashboardId) {
      return App.RedesignDashboardLayoutController.DASHBOARD_COLUMN_WIDTHS_BY_ID[dashboardId];
    };

    RedesignDashboardLayoutController.setInitialColumnWidth = function(dashboardId, initialColumnWidth) {
      return App.RedesignDashboardLayoutController.DASHBOARD_COLUMN_WIDTHS_BY_ID[dashboardId] = initialColumnWidth;
    };

    return RedesignDashboardLayoutController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardMoreMenuController = (function(superClass) {
    extend(RedesignDashboardMoreMenuController, superClass);

    RedesignDashboardMoreMenuController.prototype.className = 'modal dashboard-more-menu';

    RedesignDashboardMoreMenuController.prototype.events = {
      'click  .member.preferences': 'preferencesClick',
      'click  .member.clone': 'cloneClick',
      'click  .member.delete .menu-label': 'deleteClick',
      'click  .member.delete .cancel.button': 'deleteCancelClick',
      'click  .member.delete .delete.button': 'deleteConfirmClick',
      'click  .member.disable-filters .cancel.button': 'disableFiltersCancelClick',
      'click  .member.disable-filters .disable.button': 'disableFiltersConfirmClick',
      'click  .member.enable-tv-mode': 'enableTvModeClick',
      'click  .member.disable-filters .menu-label': 'disableFiltersClick',
      'click  .member.rearrange-charts': 'rearrangeChartsClick',
      'click  .member.download-pdf': 'downloadPDFClick',
      'mouseenter': 'maybeHideMenuParts'
    };

    RedesignDashboardMoreMenuController.prototype.elements = {
      '.member.clone': 'cloneMember',
      '.member.disable-filters': 'filtersMember',
      '.member.delete': 'deleteMember',
      '.member.enable-tv-mode': 'enableTvModeEl',
      '.member.disable-filters .disable.button': 'filterDisableButton',
      '.member.rearrange-charts': 'rearrangeCharts'
    };

    RedesignDashboardMoreMenuController.CLONE_ERROR_MSG = 'Error: Could Not Clone';

    RedesignDashboardMoreMenuController.CLONE_PERMISSION_DENIED = 'Permission Denied';

    function RedesignDashboardMoreMenuController() {
      this.preferencesEnabled = bind(this.preferencesEnabled, this);
      this.filtersDisabled = bind(this.filtersDisabled, this);
      this.rearrangeChartsClick = bind(this.rearrangeChartsClick, this);
      this.preferencesClick = bind(this.preferencesClick, this);
      this.enableTvModeClick = bind(this.enableTvModeClick, this);
      this.handleFilterDisableResponse = bind(this.handleFilterDisableResponse, this);
      this.disableFiltersConfirmClick = bind(this.disableFiltersConfirmClick, this);
      this.disableFiltersCancelClick = bind(this.disableFiltersCancelClick, this);
      this.disableFiltersClick = bind(this.disableFiltersClick, this);
      this.deleteConfirmClick = bind(this.deleteConfirmClick, this);
      this.deleteCancelClick = bind(this.deleteCancelClick, this);
      this.deleteClick = bind(this.deleteClick, this);
      this.maybeHideMenuParts = bind(this.maybeHideMenuParts, this);
      this.cloneDashboardFail = bind(this.cloneDashboardFail, this);
      this.cloneDashboardSuccess = bind(this.cloneDashboardSuccess, this);
      this.downloadPDFClick = bind(this.downloadPDFClick, this);
      this.cloneClick = bind(this.cloneClick, this);
      this.checkAnotherMenuOpened = bind(this.checkAnotherMenuOpened, this);
      this.hideMenu = bind(this.hideMenu, this);
      this.openMenu = bind(this.openMenu, this);
      this.updateUiForGroups = bind(this.updateUiForGroups, this);
      this.release = bind(this.release, this);
      RedesignDashboardMoreMenuController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      this.site = App.Site.first();
      App.Site.bind('group-change', this.updateUiForGroups);
      App.Dashboard.bind('suppress-other-modals', this.checkAnotherMenuOpened);
      this.dashboardMenuIcon = $('.dashboard-menu.dashboard-header-icon');
      this.cloneLoading = false;
      this.renderContent();
    }

    RedesignDashboardMoreMenuController.prototype.release = function() {
      App.Site.unbind('group-change', this.updateUiForGroups);
      App.Dashboard.unbind('suppress-other-modals', this.checkAnotherMenuOpened);
      return RedesignDashboardMoreMenuController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardMoreMenuController.prototype.updateUiForGroups = function() {
      return this.renderContent();
    };

    RedesignDashboardMoreMenuController.prototype.renderContent = function() {
      var newRenderOptions, ref, safeOptions;
      if (this.lastRenderOptions == null) {
        this.lastRenderOptions = {};
      }
      newRenderOptions = this.renderOptions();
      if (_.isEqual(newRenderOptions, this.lastRenderOptions)) {
        return;
      }
      this.lastRenderOptions = newRenderOptions;
      safeOptions = jQuery.extend({}, newRenderOptions);
      if (this.rbacEnabled()) {
        return this.html(this.view('redesign/dashboard_menu/dashboard_more_menu_rbac_enabled')(safeOptions));
      } else {
        this.html(this.view('redesign/dashboard_menu/dashboard_more_menu_rbac_disabled')(safeOptions));
        if (((ref = App.User.currentUser()) != null ? ref.canExplore() : void 0) && this.dashboard.isExplorableByCurrentUser()) {
          return;
        }
        return this.el.addClass('readonly');
      }
    };

    RedesignDashboardMoreMenuController.prototype.renderOptions = function() {
      var dp, ref, ref1;
      if (this.rbacEnabled()) {
        dp = AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions;
        return {
          showDashboardPreferencesButton: this.preferencesEnabled(),
          showRearrangeChartsButton: AppRedesign.editDashboardSettingsEnabledOnDashboard(),
          showFullScreenButton: !((ref = App.Site.first()) != null ? ref.sso_enabled : void 0),
          showFiltersButton: AppRedesign.createSqlChartsEnabledOnDashboard(),
          grayOutFiltersButton: this.dashboard.filtersEnabled() && this.dashboard.num_shared_dashboards > 0,
          filtersButtonText: this.dashboard.filtersEnabled() ? 'Disable Filters' : 'Enable Filters',
          showCloneDashboardButton: AppRedesign.cloneDashboardsEnabledOnDashboard(),
          showDownloadPDFButton: this.pdfDownloadEnabled(),
          grayOutDeleteButton: App.Dashboard.count() <= 1,
          deleteOrArchiveButtonText: AppRedesign.autoArchiveEnabled() ? 'archive' : 'delete',
          showArchiveButton: AppRedesign.archiveDashboardsEnabledOnDashboard()
        };
      } else {
        return {
          user_can_edit: (ref1 = App.User.currentUser()) != null ? ref1.canExplore() : void 0,
          dashboard_editable: this.dashboard.isExplorableByCurrentUser(),
          filters_enabled: this.dashboard.filtersEnabled(),
          shared_dashboards_exist: this.dashboard.num_shared_dashboards > 0,
          delete_enabled: App.Dashboard.count() > 1,
          pdf_download_enabled: App.Site.first().isPDFDownloadEnabled(),
          deleteLabel: AppRedesign.autoArchiveEnabled() ? 'archive' : 'delete'
        };
      }
    };

    RedesignDashboardMoreMenuController.prototype.rbacEnabled = function() {
      return AppRedesign.current().state.RbacEnabled;
    };

    RedesignDashboardMoreMenuController.prototype.pdfDownloadEnabled = function() {
      var allowed_by_rbac_global_permission, allowed_on_database_mapping_level, allowed_on_site_level;
      allowed_on_database_mapping_level = !this.dashboard.hasAnyDatabaseBlockedMappingWidgets();
      allowed_on_site_level = App.Site.first().isPDFDownloadEnabled();
      allowed_by_rbac_global_permission = false || AppRedesign.downloadPdfPermissionEnabledOnDashboard();
      return allowed_on_site_level && allowed_by_rbac_global_permission && allowed_on_database_mapping_level;
    };

    RedesignDashboardMoreMenuController.prototype.openMenu = function(e) {
      this.renderContent();
      App.Utils.logFeature("dashboard-menu-open", {
        dashboard_id: this.dashboard.id
      });
      this.dashboardMenuIcon.addClass('selected');
      this.el.addClass('open');
      App.Dashboard.trigger('suppress-other-modals', {
        opener: this
      });
      this.dashboard.trigger('request-elevate');
      setTimeout(((function(_this) {
        return function() {
          return $('#body').on('click', _this.hideMenu);
        };
      })(this)), 0);
      return e != null ? e.stopPropagation() : void 0;
    };

    RedesignDashboardMoreMenuController.prototype.hideMenu = function() {
      this.deleteMember.removeClass('confirm-mode');
      this.filtersMember.removeClass('confirm-mode');
      this.dashboardMenuIcon.removeClass('selected');
      this.el.removeClass('open');
      this.dashboard.trigger('cancel-elevate');
      return $('#body').off('click', this.hideMenu);
    };

    RedesignDashboardMoreMenuController.prototype.checkAnotherMenuOpened = function(e) {
      if (this.el.hasClass('open') && e.opener !== this) {
        return this.hideMenu();
      }
    };

    RedesignDashboardMoreMenuController.prototype.cloneClick = function(e) {
      if (this.cloneLoading) {
        return;
      }
      this.cloneLoading = true;
      this.cloneMember.html("Cloning...");
      return jQuery.ajax({
        type: 'POST',
        url: "/dashboards/" + this.dashboard.id + "/clone"
      }).done(this.cloneDashboardSuccess).fail(this.cloneDashboardFail);
    };

    RedesignDashboardMoreMenuController.prototype.downloadPDFClick = function() {
      return App.DownloadHelper.downloadPDF(this.dashboard.id, this.dashboard.getName());
    };

    RedesignDashboardMoreMenuController.prototype.cloneDashboardSuccess = function(response) {
      var dashboard, dashboardJson, firstWidgetJson, udvJson;
      udvJson = response.udv;
      if (udvJson != null) {
        App.UserDataView.applyUpdates([udvJson]);
      }
      dashboardJson = response.dashboard;
      App.Dashboard.applyUpdates([dashboardJson]);
      firstWidgetJson = response.first_cloned_widget;
      if (firstWidgetJson != null) {
        App.Widget.applyUpdates([firstWidgetJson]);
      }
      if (response.first_content_type != null) {
        App[response.first_content_type].applyUpdates([response.first_content]);
      }
      dashboard = App.Dashboard.exists(dashboardJson.id);
      if (dashboard) {
        App.RouteHelper.navigateTo('Dashboard', dashboard);
      }
      this.cloneLoading = false;
      this.cloneMember.html("Clone");
      setTimeout((function() {
        return App.Site.trigger('request-several-updates');
      }), 2000);
      return setTimeout((function() {
        return App.Site.trigger('request-several-updates');
      }), 4000);
    };

    RedesignDashboardMoreMenuController.prototype.cloneDashboardFail = function(response) {
      var errorMessage;
      this.cloneLoading = false;
      if (response.status === 403) {
        errorMessage = App.RedesignDashboardMoreMenuController.CLONE_PERMISSION_DENIED;
        alert("Permission denied");
      } else {
        errorMessage = App.RedesignDashboardMoreMenuController.CLONE_ERROR_MSG;
      }
      return this.cloneMember.html(errorMessage);
    };

    RedesignDashboardMoreMenuController.prototype.isOpen = function() {
      return this.el.hasClass('open');
    };

    RedesignDashboardMoreMenuController.prototype.maybeHideMenuParts = function() {
      if (this.dashboard.hasSharedDashboardFactories()) {
        return this.el.addClass('factory-dashboard');
      } else {
        return this.el.removeClass('factory-dashboard');
      }
    };

    RedesignDashboardMoreMenuController.prototype.deleteClick = function(e) {
      e.stopPropagation();
      if (this.deleteMember.hasClass('disabled') || this.deleteMember.hasClass("confirm-mode")) {
        return;
      }
      this.deleteMember.addClass("confirm-mode");
      return this.filtersMember.removeClass("confirm-mode");
    };

    RedesignDashboardMoreMenuController.prototype.deleteCancelClick = function(e) {
      this.deleteMember.removeClass("confirm-mode");
      return e.stopPropagation();
    };

    RedesignDashboardMoreMenuController.prototype.deleteConfirmClick = function() {
      var dashboard;
      this.dashboard.destroy();
      if (App.Dashboard.count()) {
        return;
      }
      App.Site.refresh(this.state.Site);
      dashboard = App.LeftMenuHelper.newItem(App.Dashboard);
      return App.RouteHelper.navigateTo('Dashboard', dashboard);
    };

    RedesignDashboardMoreMenuController.prototype.disableFiltersClick = function(e) {
      e.stopPropagation();
      if (this.filtersDisabled()) {
        return;
      }
      if (this.dashboard.filtersEnabled()) {
        this.filtersMember.addClass("confirm-mode");
        return this.deleteMember.removeClass("confirm-mode");
      } else {
        this.dashboard.updateAttributes({
          filters_enabled: true
        });
        this.dashboard.trigger('filter-permissions-changed');
        return this.hideMenu();
      }
    };

    RedesignDashboardMoreMenuController.prototype.disableFiltersCancelClick = function(e) {
      this.filtersMember.removeClass('confirm-mode');
      return e.stopPropagation();
    };

    RedesignDashboardMoreMenuController.prototype.disableFiltersConfirmClick = function(e) {
      var ref, startingFromEmpty;
      startingFromEmpty = this.dashboard.dimensionConfig().isEmpty();
      this.dashboard.updateAttributes({
        filters_enabled: false,
        ajax: false
      });
      if ((ref = this.dashboard.getExistingUserDataView()) != null) {
        ref.destroy({
          ajax: false
        });
      }
      this.dashboard.trigger('filter-permissions-changed');
      this.dashboard.dimensionConfig().clear();
      if (!startingFromEmpty) {
        this.dashboard.applyPendingConfig();
      }
      return jQuery.ajax({
        type: 'POST',
        url: "/dashboards/" + this.dashboard.id + "/disable_filters"
      }).done(this.handleFilterDisableResponse);
    };

    RedesignDashboardMoreMenuController.prototype.handleFilterDisableResponse = function(response) {
      if (response.error != null) {
        return AppRedesign.logError(new Error(response.error));
      }
    };

    RedesignDashboardMoreMenuController.prototype.enableTvModeClick = function() {
      var ref;
      if ((ref = App.Site.first()) != null ? ref.sso_enabled : void 0) {
        return;
      }
      App.Utils.logFeature("dashboard-menu-widescreen-enabled", {
        dashboard_id: this.dashboard.id
      });
      return app.appFrame.enterTvMode();
    };

    RedesignDashboardMoreMenuController.prototype.preferencesClick = function() {
      var dashboardPreferencesController;
      if (!this.preferencesEnabled()) {
        return;
      }
      dashboardPreferencesController = new App.RedesignDashboardPreferencesController();
      return this.dashboardPreferencesDialog = App.RedesignDialog.createDialog({
        customDialogClass: 'dashboard-preferences-container',
        title: 'Dashboard Preferences',
        viewController: dashboardPreferencesController
      });
    };

    RedesignDashboardMoreMenuController.prototype.rearrangeChartsClick = function() {
      return this.rearrangeChartsController = new App.RedesignDashboardRearranger();
    };

    RedesignDashboardMoreMenuController.prototype.filtersDisabled = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return !AppRedesign.createSqlChartsEnabled() || this.filtersMember.hasClass('confirm-mode') || this.filtersMember.hasClass('disabled');
      } else {
        return !((ref = App.User.currentUser()) != null ? ref.canExplore() : void 0) || this.filtersMember.hasClass('confirm-mode') || this.filtersMember.hasClass('disabled');
      }
    };

    RedesignDashboardMoreMenuController.prototype.preferencesEnabled = function() {
      var dp, ref;
      if (AppRedesign.current().state.RbacEnabled) {
        dp = AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions;
        return AppRedesign.editDashboardSettingsEnabledOnDashboard() || AppRedesign.editPermissionsEnabledOnDashboard() || AppRedesign.sharedDashboardsEnabledOnDashboard() || AppRedesign.emailReportsEnabledOnDashboard() || AppRedesign.qualityCheckEnabledOnDashboard();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canExplore() : void 0;
      }
    };

    return RedesignDashboardMoreMenuController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardPreferencesController = (function(superClass) {
    extend(RedesignDashboardPreferencesController, superClass);

    RedesignDashboardPreferencesController.prototype.className = 'dashboard-preferences';

    RedesignDashboardPreferencesController.prototype.elements = {
      '.item.dashboard-settings': 'settingsItem',
      '.item.shared-dashboards': 'sharedDashboardItem',
      '.item.email': 'emailItem',
      '.item.quality-check': 'qualityCheckItem',
      '.item-container': 'itemContainer',
      '.content-container': 'contentContainer',
      '.item.permissions': 'permissionsItem'
    };

    RedesignDashboardPreferencesController.prototype.events = {
      'click .member.dashboard-settings': 'clickSettings',
      'click .item.email': 'clickEmail',
      'click .item.email .icon': 'clickEmailHelp',
      'click .item.shared-dashboards': 'clickSharedDashboards',
      'click .item.shared-dashboards .icon': 'clickSharedDashboardsIcon',
      'click .item.quality-check': 'clickQualityCheck',
      'click .item.quality-check .icon': 'clickQualityCheckIcon',
      'click .item.dashboard-settings': 'clickSettings',
      'click .item.permissions': 'clickPermissions'
    };

    function RedesignDashboardPreferencesController() {
      this.closeAndRelease = bind(this.closeAndRelease, this);
      RedesignDashboardPreferencesController.__super__.constructor.apply(this, arguments);
      this.dashboard = App.Dashboard.currentDashboard();
      App.Dashboard.currentDashboard().bind('close-dashboard-preferences', this.closeAndRelease);
      this.render();
    }

    RedesignDashboardPreferencesController.prototype.render = function() {
      this.html(this.view('redesign/dashboard_preferences/dashboard_preferences')({
        showSettingsTab: this.showSettingsTab(),
        showReports: this.showReports(),
        showQualityCheck: this.showQualityCheck(),
        showSharedDashboards: this.showSharedDashboards(),
        showPermissions: this.showPermissions(),
        slackEnabled: AppRedesign.slackEnabled()
      }));
      return this.renderTheCorrectContentContainer();
    };

    RedesignDashboardPreferencesController.prototype.renderTheCorrectContentContainer = function() {
      this.setCurrentControllerToSettings();
      if (!this.showSettingsTab()) {
        if (this.showPermissions()) {
          return this.clickPermissions();
        } else {
          if (this.showSharedDashboards()) {
            return this.clickSharedDashboards();
          } else {
            if (this.showReports()) {
              return this.clickEmail();
            } else {
              if (this.showQualityCheck()) {
                return this.clickQualityCheck();
              }
            }
          }
        }
      }
    };

    RedesignDashboardPreferencesController.prototype.showSettingsTab = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return false || AppRedesign.editDashboardSettingsEnabledOnDashboard();
      } else {
        return true;
      }
    };

    RedesignDashboardPreferencesController.prototype.showPermissions = function() {
      return AppRedesign.current().state.RbacEnabled && AppRedesign.editPermissionsEnabledOnDashboard();
    };

    RedesignDashboardPreferencesController.prototype.showSharedDashboards = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return !(App.Site.first().forbid_shared_dashboards || App.Site.first().prevent_shared_dashboard_creation) && AppRedesign.sharedDashboardsEnabledOnDashboard();
      } else {
        return !(App.Site.first().forbid_shared_dashboards || App.Site.first().prevent_shared_dashboard_creation);
      }
    };

    RedesignDashboardPreferencesController.prototype.showReports = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return (!App.Site.first().forbid_email_reports || !App.Site.first().forbid_slack_reports) && AppRedesign.emailReportsEnabledOnDashboard();
      } else {
        return !App.Site.first().forbid_email_reports || !App.Site.first().forbid_slack_reports;
      }
    };

    RedesignDashboardPreferencesController.prototype.showQualityCheck = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return !App.Site.first().forbid_email_reports && AppRedesign.qualityCheckEnabledOnDashboard();
      } else {
        return !App.Site.first().forbid_email_reports;
      }
    };

    RedesignDashboardPreferencesController.prototype.clickSettings = function() {
      if (this.isActive(this.settingsItem)) {
        return;
      }
      this.switchActive(this.settingsItem);
      return this.setCurrentControllerToSettings();
    };

    RedesignDashboardPreferencesController.prototype.setCurrentControllerToSettings = function() {
      this.setActive(this.settingsItem);
      this.currentController = this.settingsController = new App.RedesignDashboardPreferencesSettingsController({
        colorThemes: App.ColorTheme.all(),
        dashboard: this.dashboard,
        showSettingsTab: this.showSettingsTab()
      });
      this.settingsController.bind('close', this.closeAndRelease);
      return this.contentContainer.append(this.currentController.el);
    };

    RedesignDashboardPreferencesController.prototype.unparentAllReparented = function() {
      var ref;
      return (ref = this.currentController) != null ? typeof ref.unparentAllReparented === "function" ? ref.unparentAllReparented() : void 0 : void 0;
    };

    RedesignDashboardPreferencesController.prototype.release = function() {
      var ref;
      return (ref = this.currentController) != null ? ref.release() : void 0;
    };

    RedesignDashboardPreferencesController.prototype.closeAndRelease = function() {
      this.trigger('close');
      return App.Dashboard.currentDashboard().unbind('close-dashboard-preferences', this.closeAndRelease);
    };

    RedesignDashboardPreferencesController.prototype.clickEmail = function() {
      if (this.isActive(this.emailItem)) {
        return;
      }
      this.switchActive(this.emailItem);
      this.currentController = this.emailReportsController = new App.RedesignDashboardEmailReports({
        dashboard: this.dashboard
      });
      this.contentContainer.append(this.currentController.el);
      return App.Utils.logFeature("enter-email-reports-mode", {
        dashboard_id: this.dashboard.id
      });
    };

    RedesignDashboardPreferencesController.prototype.clickEmailHelp = function() {
      return window.open(AppRedesign.DOC_PATH + '/email-reports');
    };

    RedesignDashboardPreferencesController.prototype.clickQualityCheck = function() {
      if (this.isActive(this.qualityCheckItem)) {
        return;
      }
      this.switchActive(this.qualityCheckItem);
      this.currentController = this.qualityCheckController = new App.QualityCheckController({
        dashboard: this.dashboard
      });
      this.contentContainer.append(this.currentController.el);
      this.qualityCheckController.bind('close', this.closeAndRelease);
      return App.Utils.logFeature("enter-quality-check-mode", {
        dashboard_id: this.dashboard.id
      });
    };

    RedesignDashboardPreferencesController.prototype.clickQualityCheckIcon = function() {
      return window.open(AppRedesign.DOC_PATH + '/email-reports');
    };

    RedesignDashboardPreferencesController.prototype.clickSharedDashboardsIcon = function() {
      return window.open(AppRedesign.DOC_PATH + '/share-dashboards');
    };

    RedesignDashboardPreferencesController.prototype.clickSharedDashboards = function() {
      if (this.isActive(this.sharedDashboardItem)) {
        return;
      }
      this.switchActive(this.sharedDashboardItem);
      this.currentController = this.sharedDashboardListController = new App.RedesignSharedDashboardListController();
      this.contentContainer.append(this.currentController.el);
      this.sharedDashboardListController.showSharesList();
      return App.Utils.logFeature("enter-shared-dashboard-mode", {
        dashboard_id: this.dashboard.id
      });
    };

    RedesignDashboardPreferencesController.prototype.clickPermissions = function() {
      if (this.isActive(this.permissionsItem)) {
        return;
      }
      this.switchActive(this.permissionsItem);
      this.currentController = this.permissionsDashboardSelectorController = new App.PermissionsDashboardSelectorController();
      return this.contentContainer.append(this.permissionsDashboardSelectorController.el);
    };

    RedesignDashboardPreferencesController.prototype.isActive = function(item) {
      return item.hasClass('active');
    };

    RedesignDashboardPreferencesController.prototype.switchActive = function(item) {
      this.currentController.release();
      this.itemContainer.find('.active').removeClass('active');
      return this.setActive(item);
    };

    RedesignDashboardPreferencesController.prototype.setActive = function(item) {
      return item.addClass('active');
    };

    return RedesignDashboardPreferencesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignDashboardSettingAutoCompleter = (function(superClass) {
    extend(RedesignDashboardSettingAutoCompleter, superClass);

    RedesignDashboardSettingAutoCompleter.prototype.elements = {
      '.search-box': 'searchBox',
      '.search-input': 'searchInput',
      '.search-results': 'searchResults',
      '.edit-icon': 'editLabel',
      '.message': 'messageEl',
      '.small-checkbox.check-all': 'checkAllBox',
      '.check-all.label': 'checkAllLabel'
    };

    RedesignDashboardSettingAutoCompleter.prototype.events = {
      'focus .search-input': 'focusedSearchInput',
      'blur .search-input': 'blurredSearchInput',
      'keydown .search-input': 'searchInputKeydown',
      'paste .search-input': 'searchInputFilled',
      'click .check-all.icon': 'checkAllClicked',
      'click .check-all.label': 'checkAllClicked'
    };

    RedesignDashboardSettingAutoCompleter.NEVER_RENDERED_STATE = '_never_fetched';

    RedesignDashboardSettingAutoCompleter.DEFAULT_ERROR_MESSAGE = 'Query returned an error.';

    RedesignDashboardSettingAutoCompleter.NO_ROWS_ERROR_MESSAGE = 'Query returned no results.';

    function RedesignDashboardSettingAutoCompleter() {
      this.maybeScroll = bind(this.maybeScroll, this);
      this.dimensionSettingSearch = bind(this.dimensionSettingSearch, this);
      this.removeHighlightedLabel = bind(this.removeHighlightedLabel, this);
      this.scrollToLastY = bind(this.scrollToLastY, this);
      this.fetchedResults = bind(this.fetchedResults, this);
      this.fetch = bind(this.fetch, this);
      this.fetchWhenPossible = bind(this.fetchWhenPossible, this);
      this.otherDimensionUpdated = bind(this.otherDimensionUpdated, this);
      this.clicked = bind(this.clicked, this);
      this.updateUiForGroups = bind(this.updateUiForGroups, this);
      this.searchInputFilled = bind(this.searchInputFilled, this);
      this.scrollWithoutLeaking = bind(this.scrollWithoutLeaking, this);
      this.dimensionUpdated = bind(this.dimensionUpdated, this);
      this.blurredSearchInput = bind(this.blurredSearchInput, this);
      this.focusedSearchInput = bind(this.focusedSearchInput, this);
      this.checkItemSelectedByKeyboard = bind(this.checkItemSelectedByKeyboard, this);
      this.ensureCorrectIconClass = bind(this.ensureCorrectIconClass, this);
      this.dimensionDataUpdated = bind(this.dimensionDataUpdated, this);
      this.configChanged = bind(this.configChanged, this);
      RedesignDashboardSettingAutoCompleter.__super__.constructor.apply(this, arguments);
      if (this.dimension == null) {
        throw new Error('requires dimension');
      }
      if (this.dashboard == null) {
        throw new Error('requires dashboard');
      }
      this.lastRenderedPrefix = RedesignDashboardSettingAutoCompleter.NEVER_RENDERED_STATE;
      this.lastRenderedParentValue = void 0;
      this.pendingRequest = false;
      this.filterCheckAllEnabled = AppRedesign.filterCheckAllEnabled();
      this.html(this.view('redesign/dashboards/setting_autocompleter_standalone')({
        settingName: this.dimension.name,
        filterCheckAllEnabled: this.filterCheckAllEnabled
      }));
      if (this.dimension.exclusive) {
        this.checkAllBox.hide();
      }
      this.fetcher = new App.DimensionValueFetcher(this.dimension);
      this.dashboard.bind('update', this.ensureCorrectIconClass);
      this.dashboard.bind(App.Dashboard.EVENT_CONFIG_CHANGED, this.configChanged);
      this.lastScrollY = 0;
      this.searchResults.on('wheel mousewheel', this.scrollWithoutLeaking);
      this.dashboard.bind('dashboard-settings-opened', this.scrollToLastY);
      this.dimension.bind('update', this.dimensionUpdated);
      this.dimension.bind('data-updated', this.dimensionDataUpdated);
      App.Site.bind('group-change', this.updateUiForGroups);
      this.updateUiForGroups();
      this.checkExclusive();
    }

    RedesignDashboardSettingAutoCompleter.prototype.release = function() {
      var ref;
      App.Site.unbind('group-change', this.updateUiForGroups);
      this.dashboard.unbind(App.Dashboard.EVENT_CONFIG_CHANGED);
      if ((ref = this.searchResults) != null) {
        ref.off('wheel mousewheel');
      }
      this.dimension.unbind('update', this.dimensionUpdated);
      return this.clearResults();
    };

    RedesignDashboardSettingAutoCompleter.prototype.configChanged = function() {
      this.fetch();
      if (this.dimension.hasParent()) {
        return this.otherDimensionUpdated();
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.searchInputKeydown = function(e) {
      this.searchInputFilled(e);
      return this.dimensionSettingSearch(e);
    };

    RedesignDashboardSettingAutoCompleter.prototype.dashboardSettingsClosed = function() {
      return this.clearSearch();
    };

    RedesignDashboardSettingAutoCompleter.prototype.dimensionDataUpdated = function() {
      this.lastRenderedPrefix = App.RedesignDashboardSettingAutoCompleter.NEVER_RENDERED_STATE;
      return this.fetch();
    };

    RedesignDashboardSettingAutoCompleter.prototype.ensureCorrectIconClass = function() {
      var newIconClass;
      if (!this.hasRendered()) {
        return;
      }
      newIconClass = this.iconClass();
      if (this.renderedIconClass === newIconClass) {
        return;
      }
      this.checkboxList.changeIconClass(newIconClass);
      return this.renderedIconClass = newIconClass;
    };

    RedesignDashboardSettingAutoCompleter.prototype.hasRendered = function() {
      return this.checkboxList != null;
    };

    RedesignDashboardSettingAutoCompleter.prototype.checkItemSelectedByKeyboard = function(e) {
      return this.checkboxList.checkItemSelectedByKeyword(e);
    };

    RedesignDashboardSettingAutoCompleter.prototype.focusedSearchInput = function() {
      return this.searchBox.addClass('focused');
    };

    RedesignDashboardSettingAutoCompleter.prototype.blurredSearchInput = function() {
      this.removeHighlightedLabel();
      return this.searchBox.removeClass('focused');
    };

    RedesignDashboardSettingAutoCompleter.prototype.dimensionUpdated = function() {
      var checkboxConfig, i, index, len, numChecked, ref, ref1, ref2, results1;
      this.checkExclusive();
      this.ensureCorrectIconClass();
      if (this.dimension.exclusive) {
        this.checkAllBox.hide();
        numChecked = (ref = this.checkboxList) != null ? ref.selectedValues().length : void 0;
        if (numChecked > 1) {
          if ((ref1 = this.checkboxList) != null) {
            ref1.uncheckAll();
          }
          ref2 = this.checkboxList.checkboxConfigs;
          results1 = [];
          for (index = i = 0, len = ref2.length; i < len; index = ++i) {
            checkboxConfig = ref2[index];
            results1.push(this.toggleDimensionValue(false, checkboxConfig));
          }
          return results1;
        }
      } else {
        return this.checkAllBox.show();
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.scrollWithoutLeaking = function(event) {
      this.lastScrollY = this.searchResults.scrollTop();
      return App.Utils.scrollWithoutLeaking(event, this.searchResults);
    };

    RedesignDashboardSettingAutoCompleter.prototype.searchInputFilled = function(_event) {
      return this.fetchWhenPossible();
    };

    RedesignDashboardSettingAutoCompleter.prototype.updateUiForGroups = function() {
      if (this.canEditFilters() && !AppRedesign.current().tvmode) {
        return this.editLabel.show();
      } else {
        return this.editLabel.addClass('hidden');
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.clicked = function(isChecked, checkboxConfig, doubleClick, enter) {
      if (doubleClick) {
        if (isChecked && !enter) {
          this.dashboard.dimensionConfig().setSingleInfoForDimension(this.dimension.id, checkboxConfig.value, checkboxConfig.label, checkboxConfig.group, checkboxConfig.signature);
        } else {
          this.toggleDimensionValue(isChecked, checkboxConfig);
        }
        return this.dashboard.applyPendingConfig();
      } else if (this.dimension.exclusive) {
        if (isChecked) {
          this.dashboard.dimensionConfig().setSingleInfoForDimension(this.dimension.id, checkboxConfig.value, checkboxConfig.label, checkboxConfig.group, checkboxConfig.signature);
        }
        this.toggleDimensionValue(isChecked, checkboxConfig);
        if (enter) {
          return this.dashboard.applyPendingConfig();
        }
      } else {
        return this.toggleDimensionValue(isChecked, checkboxConfig);
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.toggleDimensionValue = function(isChecked, checkboxConfig) {
      var config;
      config = this.dashboard.dimensionConfig();
      if (isChecked) {
        config.addDimensionInfo(this.dimension.id, checkboxConfig.value, checkboxConfig.label, checkboxConfig.group, checkboxConfig.signature);
      } else {
        config.removeDimensionInfo(this.dimension.id, checkboxConfig.value);
      }
      if (this.filterCheckAllEnabled) {
        return this.updateCheckAllStatus();
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.updateCheckAllStatus = function() {
      var numChecked, ref, ref1, ref2, total;
      if (!(this.checkAllBox && this.checkAllLabel)) {
        return;
      }
      total = (ref = this.checkboxList) != null ? (ref1 = ref.checkboxConfigs) != null ? ref1.length : void 0 : void 0;
      numChecked = (ref2 = this.checkboxList) != null ? ref2.selectedValues().length : void 0;
      this.checkAllLabel.text('Select Displayed (' + total + ')');
      if (numChecked > 0 && numChecked < total) {
        this.checkAllBox.addClass('partial-check');
        return this.checkAllBox.addClass('selected');
      } else if (numChecked === 0) {
        this.checkAllBox.removeClass('selected');
        return this.checkAllBox.removeClass('partial-check');
      } else if (numChecked === total) {
        this.checkAllBox.addClass('selected');
        return this.checkAllBox.removeClass('partial-check');
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.otherDimensionUpdated = function(dashboard, config, agg, dr, dimensionId) {
      var parentValues;
      if (dimensionId !== this.dimension.parent_id) {
        return;
      }
      parentValues = config.configuredDimensionValues(this.dimension.parent_id);
      if (this.parentDimensionValues() === parentValues) {
        return;
      }
      config.filterDimensionInfoByGroup(this.dimension.id, parentValues);
      return setTimeout(this.fetch, 10);
    };

    RedesignDashboardSettingAutoCompleter.prototype.fetchWhenPossible = function() {
      clearTimeout(this.fetchTimeout);
      if (!this.pendingRequest) {
        return setTimeout(this.fetch, 0);
      } else {
        return this.fetchTimeout = setTimeout(this.fetchWhenPossible, 200);
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.fetch = function() {
      this.dimension.reload();
      if (this.alreadyRenderedThisState() || this.dimension.isErrored()) {
        return;
      }
      if (this.alreadyRenderedTheseOptions()) {
        this.updateCheckboxStatus(this.dashboard.dimensionConfig());
        return;
      }
      this.lastRenderedParentValue = this.parentDimensionValues();
      this.lastRenderedPrefix = this.prefix();
      this.pendingRequest = true;
      return this.fetcher.fetch(this.prefix(), this.lastRenderedParentValue, this.fetchedResults);
    };

    RedesignDashboardSettingAutoCompleter.prototype.fetchedResults = function(prefix, results) {
      var allowedIds;
      if (AppRedesign.current().roleLevelAccessEnabled) {
        if (!App.User.safeCurrentUser().isAdmin()) {
          allowedIds = AppRedesign.current().roleLevelAccessObject[this.dimension.name];
          if (Array.isArray(allowedIds)) {
            results = results.filter(function(item) {
              var ref;
              return ref = item.id, indexOf.call(allowedIds, ref) >= 0;
            });
          }
        }
      }
      this.pendingRequest = false;
      if (prefix === this.prefix()) {
        this.showSearchResults(prefix, results);
      }
      return App.UdvHelper.updateSignaturesFromResults(this.dashboard.userDataView(), this.dimension.id, results);
    };

    RedesignDashboardSettingAutoCompleter.prototype.updateCheckboxStatus = function(config) {
      var valueIds;
      if (this.checkboxList == null) {
        return false;
      }
      valueIds = config.dimensionValues(this.dimension.id);
      this.checkboxList.bulkUpdateChecked(valueIds);
      if (this.filterCheckAllEnabled) {
        return this.updateCheckAllStatus();
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.showSearchResults = function(prefix, results) {
      this.clearResults();
      return this.renderResults(results);
    };

    RedesignDashboardSettingAutoCompleter.prototype.resultsToRender = function(results) {
      var parentValues;
      parentValues = this.parentDimensionValues();
      if ((parentValues != null) && !parentValues.isEmpty()) {
        results = _.filter(results, function(result) {
          return _.includes(parentValues, result.group);
        });
      }
      return _.map(results, (function(_this) {
        return function(result) {
          return {
            checked: _this.checked(result.id),
            group: result.group,
            label: result.name,
            value: result.id,
            signature: result.signature
          };
        };
      })(this));
    };

    RedesignDashboardSettingAutoCompleter.prototype.renderResults = function(results) {
      this.checkboxList = new App.RedesignCheckboxListController({
        checkboxConfigs: this.resultsToRender(results),
        callback: this.clicked,
        iconClass: this.iconClass()
      });
      this.searchResults.append(this.checkboxList.el);
      if (this.filterCheckAllEnabled) {
        this.updateCheckAllStatus();
      }
      return this.updateMessages();
    };

    RedesignDashboardSettingAutoCompleter.prototype.checkAllClicked = function(e) {
      var checkboxConfig, i, index, isChecked, len, ref, ref1, ref2, results1;
      if (!this.checkboxList) {
        return;
      }
      e.stopPropagation();
      isChecked = null;
      this.checkAllBox.toggleClass('selected');
      if (this.checkAllBox.hasClass('selected')) {
        if ((ref = this.checkboxList) != null) {
          ref.checkAll();
        }
        isChecked = true;
      } else {
        if ((ref1 = this.checkboxList) != null) {
          ref1.uncheckAll();
        }
        isChecked = false;
      }
      ref2 = this.checkboxList.checkboxConfigs;
      results1 = [];
      for (index = i = 0, len = ref2.length; i < len; index = ++i) {
        checkboxConfig = ref2[index];
        results1.push(this.toggleDimensionValue(isChecked, checkboxConfig));
      }
      return results1;
    };

    RedesignDashboardSettingAutoCompleter.prototype.iconClass = function() {
      if (this.dimension.exclusive) {
        return 'small-radio-button';
      } else {
        return 'small-checkbox';
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.clearResults = function() {
      var ref;
      if ((ref = this.checkboxList) != null) {
        ref.release();
      }
      return this.checkboxList = null;
    };

    RedesignDashboardSettingAutoCompleter.prototype.clearSearch = function() {
      this.searchInput.val('');
      return this.fetchWhenPossible();
    };

    RedesignDashboardSettingAutoCompleter.prototype.onDataUpdated = function() {
      return this.updateMessages();
    };

    RedesignDashboardSettingAutoCompleter.prototype.updateMessages = function() {
      this.dimension.reload();
      if (this.dimension.isLoading()) {
        this.hideError();
        return this.searchResults.hide();
      } else if (this.dimension.isErrored()) {
        this.searchResults.hide();
        return this.showError();
      } else {
        this.hideError();
        return this.searchResults.show();
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.showError = function() {
      var errorMessage;
      errorMessage = this.dimension.error_message === this.constructor.NO_ROWS_ERROR_MESSAGE ? this.constructor.NO_ROWS_ERROR_MESSAGE : this.constructor.DEFAULT_ERROR_MESSAGE;
      this.messageEl.show().text(errorMessage);
      return this.messageEl.addClass('filter-error').removeClass('loading');
    };

    RedesignDashboardSettingAutoCompleter.prototype.hideError = function() {
      return this.messageEl.hide().text('').removeClass('filter-error');
    };

    RedesignDashboardSettingAutoCompleter.prototype.scrollToLastY = function() {
      if (this.lastScrollY === 0) {
        return;
      }
      return this.searchResults.scrollTop(this.lastScrollY);
    };

    RedesignDashboardSettingAutoCompleter.prototype.selectedDimensionsMatchesCheckboxState = function() {
      var checkedValues;
      checkedValues = this.checkboxList.selectedValues();
      return checkedValues.equals(this.selectedValues());
    };

    RedesignDashboardSettingAutoCompleter.prototype.alreadyRenderedTheseOptions = function() {
      return this.prefix() === this.lastRenderedPrefix && App.Utils.arraysEqual(this.lastRenderedParentValue, this.parentDimensionValues());
    };

    RedesignDashboardSettingAutoCompleter.prototype.alreadyRenderedThisState = function() {
      if (this.checkboxList == null) {
        return false;
      }
      return this.alreadyRenderedTheseOptions() && this.selectedDimensionsMatchesCheckboxState();
    };

    RedesignDashboardSettingAutoCompleter.prototype.prefix = function() {
      return this.searchInput.val();
    };

    RedesignDashboardSettingAutoCompleter.prototype.parentDimensionValues = function() {
      if (this.dimension.hasParent()) {
        return this.dimension.getParentValues(this.dashboard);
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.selectedValues = function() {
      return this.dashboard.dimensionConfig().dimensionValues(this.dimension.id);
    };

    RedesignDashboardSettingAutoCompleter.prototype.checked = function(value) {
      var dimensionValue, i, len, ref;
      ref = this.selectedValues();
      for (i = 0, len = ref.length; i < len; i++) {
        dimensionValue = ref[i];
        if (dimensionValue === value) {
          return true;
        }
      }
      return false;
    };

    RedesignDashboardSettingAutoCompleter.prototype.checkExclusive = function() {
      return this.el.toggleClass('exclusive', !!this.dimension.exclusive);
    };

    RedesignDashboardSettingAutoCompleter.prototype.removeHighlightedLabel = function(e) {
      var ref;
      if ((ref = this.highlightedLabel) != null) {
        ref.removeClass('label-highlight');
      }
      return this.highlightedLabel = null;
    };

    RedesignDashboardSettingAutoCompleter.prototype.dimensionSettingSearch = function(e) {
      var neighbor;
      if (e.which === AppRedesign.KEYS.ENTER) {
        return this.checkItemSelectedByKeyboard(e);
      }
      if (![AppRedesign.KEYS.UP_ARROW, AppRedesign.KEYS.DOWN_ARROW].includes(e.which)) {
        return;
      }
      this.highlightedLabel = this.$('.label-highlight').first();
      if ((this.highlightedLabel == null) || this.highlightedLabel.length === 0) {
        this.highlightedLabel = this.$('.label').first();
        this.highlightedLabel.addClass('label-highlight');
        return;
      }
      switch (e.which) {
        case AppRedesign.KEYS.UP_ARROW:
          neighbor = this.highlightedLabel.parent().prev().find('.label').first();
          break;
        case AppRedesign.KEYS.DOWN_ARROW:
          neighbor = this.highlightedLabel.parent().next().find('.label').first();
          break;
        default:
          return;
      }
      if ((neighbor == null) || neighbor.length === 0) {
        return;
      }
      this.highlightNeighbor(neighbor);
      this.maybeScroll();
      return e.stopPropagation();
    };

    RedesignDashboardSettingAutoCompleter.prototype.highlightNeighbor = function(neighbor) {
      this.highlightedLabel.removeClass('label-highlight');
      this.highlightedLabel = neighbor;
      return this.highlightedLabel.addClass('label-highlight');
    };

    RedesignDashboardSettingAutoCompleter.prototype.maybeScroll = function() {
      var elementHeight, index, position, scrollElements, searchResults;
      elementHeight = this.$('.checkbox').outerHeight(true);
      searchResults = this.$('.search-results');
      scrollElements = Math.floor(searchResults.height() / elementHeight);
      position = this.$('.search-results').scrollTop() / elementHeight;
      index = this.$('.label-highlight').parent().index();
      if (index < position) {
        searchResults.scrollTop(index * elementHeight);
      }
      if (index >= position + scrollElements) {
        return searchResults.scrollTop((position + 1) * elementHeight);
      }
    };

    RedesignDashboardSettingAutoCompleter.prototype.canEditFilters = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canEdit() : void 0;
      }
    };

    return RedesignDashboardSettingAutoCompleter;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignDashboardSettingsController = (function(superClass) {
    extend(RedesignDashboardSettingsController, superClass);

    RedesignDashboardSettingsController.prototype.className = 'dashboard-filters-container';

    RedesignDashboardSettingsController.prototype.elements = {
      '.filters': 'filters',
      '.filters-bar': 'filtersBar',
      '.settings': 'settings',
      '.dash-loading-cover': 'dashboardLoader',
      '.no-dimensions-message': 'noDimensionsMessage',
      '.side-frame': 'sideFrame',
      '.apply-button': 'applyButton',
      '.set-default-filters': 'setDefaultButton',
      '.reset-filters': 'resetFilters',
      '.add-filter': 'addFilterModal',
      '.manage-filters': 'manageFiltersModal',
      '.add-icon': 'createFilterIcon',
      '.gear-icon': 'manageFiltersIcon',
      '.dashboard-settings-frame': 'dashSettingsFrame',
      '.new-spinner-with-label-white-bg': 'spinner'
    };

    RedesignDashboardSettingsController.prototype.events = {
      'click .setting .label': 'clickedSettingLabel',
      'click .setting .filter-chevron': 'clickedSettingLabel',
      'click .dash-loading-cover': 'toggleOpen',
      'click .add-icon': 'openAddFilter',
      'click .filters-bar': 'clickedFiltersBar',
      'click .filter .remove-icon': 'clickedRemoveFilter',
      'click .reset-filters': 'clickedResetFilters',
      'click .set-default-filters': 'clickedSetDefaultFilters',
      'click .cancel-button': 'closeForm',
      'click .apply-button': 'clickedApply',
      'click .gear-icon': 'openManageFiltersForm'
    };

    RedesignDashboardSettingsController.CSS_SETTING_HEIGHT = 216;

    RedesignDashboardSettingsController.CSS_SETTING_CLOSED_HEIGHT = 35;

    RedesignDashboardSettingsController.CSS_NO_DIMENSIONS_MESSAGE_HEIGHT = 92;

    RedesignDashboardSettingsController.CSS_HEADER_OFFSET = 71;

    RedesignDashboardSettingsController.CSS_SCREENSHOT_HEADER_OFFSET = 88;

    RedesignDashboardSettingsController.CSS_FILTER_BORDER = 1;

    RedesignDashboardSettingsController.MINIMUM_DIM_WIDTH = 240;

    RedesignDashboardSettingsController.windowWidth = void 0;

    function RedesignDashboardSettingsController() {
      this.updateApplyButtonState = bind(this.updateApplyButtonState, this);
      this.updateLabelsFromDashboard = bind(this.updateLabelsFromDashboard, this);
      this.applyPendingConfig = bind(this.applyPendingConfig, this);
      this.removeDimension = bind(this.removeDimension, this);
      this.addNewDimension = bind(this.addNewDimension, this);
      this.renderDimensions = bind(this.renderDimensions, this);
      this.clickedFiltersBar = bind(this.clickedFiltersBar, this);
      this.updateAvailableDimensions = bind(this.updateAvailableDimensions, this);
      this.restrictSettingsForFactory = bind(this.restrictSettingsForFactory, this);
      this.openManageFiltersForm = bind(this.openManageFiltersForm, this);
      this.openAddFilter = bind(this.openAddFilter, this);
      this.clickedApply = bind(this.clickedApply, this);
      this.closeFormOnApply = bind(this.closeFormOnApply, this);
      this.closeForm = bind(this.closeForm, this);
      this.openForm = bind(this.openForm, this);
      this.maybeShowDashLoader = bind(this.maybeShowDashLoader, this);
      this.toggleOpen = bind(this.toggleOpen, this);
      this.windowResized = bind(this.windowResized, this);
      this.clickedSettingLabel = bind(this.clickedSettingLabel, this);
      this.clickedSetDefaultFilters = bind(this.clickedSetDefaultFilters, this);
      this.clickedResetFilters = bind(this.clickedResetFilters, this);
      this.resetConfigAndRenderContent = bind(this.resetConfigAndRenderContent, this);
      this.renderFilterBar = bind(this.renderFilterBar, this);
      this.renderFilterBarForUdv = bind(this.renderFilterBarForUdv, this);
      this.offsetMainContent = bind(this.offsetMainContent, this);
      this.renderFilterBarAndAnimate = bind(this.renderFilterBarAndAnimate, this);
      this.updateEditPermissions = bind(this.updateEditPermissions, this);
      this.maybeHideForms = bind(this.maybeHideForms, this);
      this.deferredRender = bind(this.deferredRender, this);
      this.renderAll = bind(this.renderAll, this);
      this.updateFilterConfig = bind(this.updateFilterConfig, this);
      var ref, ref1;
      RedesignDashboardSettingsController.__super__.constructor.apply(this, arguments);
      this.fittedSettingsWrapper = $('.fitted-dashboard-settings-wrapper');
      this.contentOffsetWrapper = $('.content-offset-wrapper');
      this.settingsWrapper = $('.dashboard-container.active .dashboard-settings-wrapper');
      this.addDimensionForm = $('.dashboard-container.active .add-filter.filter-modal');
      this.manageFiltersFormEl = $('.dashboard-container.active .manage-filters.filter-modal');
      this.mainContentEl = $('.dashboard-container.active .main-content');
      this.dimensionSettings = [];
      this.settingsOpen = false;
      this.lastSettingsScrollTop = 0;
      this.isRowOpened = {};
      this.isRowOpened[0] = true;
      this.storeWindowSize();
      this.render();
      if ((ref = AppRedesign.current()) != null) {
        ref.bind('loaded-dashboard-filters', this.renderAll);
      }
      if (((ref1 = AppRedesign.current()) != null ? ref1.uiQueue : void 0) != null) {
        AppRedesign.current().uiQueue.add(this.deferredRender, 'dashboard-settings-deferred-render', App.UiQueue.PRIORITY_DASHBOARD_SETTINGS);
      } else {
        this.deferredRender();
      }
      this.dashboard.bind('rerender-settings', this.updateLabelsFromDashboard);
      this.dashboard.bind(App.Dashboard.EVENT_CONFIG_CHANGED, this.updateFilterConfig);
      this.dashboard.bind(App.Dashboard.EVENT_APPLIED_CONFIG, this.closeFormOnApply);
      this.dashboard.bind(App.Dashboard.EVENT_CONFIG_RESET, this.resetConfigAndRenderContent);
      App.UserDataView.bind('save', this.renderFilterBarForUdv);
      App.Dashboard.bind(App.DimensionAvailability.AVAILABILITY_CHANGED, this.updateAvailableDimensions);
      App.SharedDashboardFactory.bind('refresh create', this.restrictSettingsForFactory);
      App.CustomDimension.bind('destroy', this.removeDimension);
      App.Site.bind('group-change', this.updateEditPermissions);
      $(window).on('resize', _.debounce(this.windowResized, 547));
      this.el.on('click', (function(e) {
        return e.stopPropagation();
      }));
    }

    RedesignDashboardSettingsController.prototype.dimensions = function() {
      var config;
      config = this.dashboard.dimensionConfig();
      return config.canonicalizedDimensionMap();
    };

    RedesignDashboardSettingsController.prototype.selectedDimensionCount = function() {
      return _.size(this.dimensions());
    };

    RedesignDashboardSettingsController.prototype.updateFilterConfig = function() {
      return this.updateLabelsFromDashboard();
    };

    RedesignDashboardSettingsController.prototype.renderAll = function() {
      return this.deferredRender();
    };

    RedesignDashboardSettingsController.prototype.deferredRender = function() {
      if (this.released) {
        return;
      }
      this.rendered = true;
      this.renderDimensions();
      this.updateRowOpenedStatus(false);
      this.buildForms();
      this.restrictSettingsForFactory();
      this.updateLabelsFromDashboard();
      return this.updateAvailableDimensions();
    };

    RedesignDashboardSettingsController.prototype.maybeHideForms = function(e) {
      if (e.opener === this.dimensionsForm) {
        return this.manageFiltersIcon.removeClass('active');
      } else if (e.opener === this.manageFiltersForm) {
        return this.createFilterIcon.removeClass('active');
      } else {
        return this.hideForms();
      }
    };

    RedesignDashboardSettingsController.prototype.hideForms = function() {
      this.createFilterIcon.removeClass('active');
      this.manageFiltersIcon.removeClass('active');
      return this.manageFiltersForm.hideForm() || this.dimensionsForm.hideForm();
    };

    RedesignDashboardSettingsController.prototype.buildForms = function() {
      this.dimensionsForm = new App.RedesignFilterForm({
        dashboard: this.dashboard
      });
      this.el.append(this.dimensionsForm.el);
      this.manageFiltersForm = new App.ManageFiltersController({
        dashboard: this.dashboard
      });
      this.el.append(this.manageFiltersForm.el);
      App.Dashboard.bind('suppress-other-modals', this.maybeHideForms);
      App.Dashboard.bind('manage-filters-form-closed', ((function(_this) {
        return function() {
          return _this.manageFiltersIcon.removeClass('active');
        };
      })(this)));
      return App.Dashboard.bind('filter-form-closed', ((function(_this) {
        return function() {
          return _this.createFilterIcon.removeClass('active');
        };
      })(this)));
    };

    RedesignDashboardSettingsController.prototype.releaseAll = function() {
      var j, len, ref, ref1, ref2, ref3, ref4, setting;
      ref = this.dimensionSettings;
      for (j = 0, len = ref.length; j < len; j++) {
        setting = ref[j];
        setting.release();
      }
      if ((ref1 = this.filterBar) != null) {
        ref1.release();
      }
      if ((ref2 = this.dimensionsForm) != null) {
        ref2.release();
      }
      if ((ref3 = this.manageFiltersForm) != null) {
        ref3.release();
      }
      if ((ref4 = AppRedesign.current()) != null) {
        if (typeof ref4.unbind === "function") {
          ref4.unbind('loaded-dashboard-filters', this.renderAll);
        }
      }
      this.dashboard.unbind('rerender-settings', this.updateLabelsFromDashboard);
      this.dashboard.unbind(App.Dashboard.EVENT_CONFIG_CHANGED, this.updateLabelsFromDashboard);
      this.dashboard.unbind(App.Dashboard.EVENT_APPLIED_CONFIG, this.closeFormOnApply);
      this.dashboard.unbind(App.Dashboard.EVENT_CONFIG_RESET, this.resetConfigAndRenderContent);
      App.UserDataView.unbind('save', this.renderFilterBarForUdv);
      App.Dashboard.unbind(App.DimensionAvailability.AVAILABILITY_CHANGED, this.updateAvailableDimensions);
      App.Dashboard.unbind('suppress-other-modals', this.maybeHideForms);
      App.Dashboard.unbind('manage-filters-form-closed', ((function(_this) {
        return function() {
          return _this.manageFiltersIcon.removeClass('active');
        };
      })(this)));
      App.Dashboard.unbind('filter-form-closed', ((function(_this) {
        return function() {
          return _this.createFilterIcon.removeClass('active');
        };
      })(this)));
      App.SharedDashboardFactory.unbind('refresh create', this.restrictSettingsForFactory);
      App.CustomDimension.unbind('destroy', this.removeDimension);
      $(window).off('resize', this.windowResized);
      this.el.off('click');
      App.Site.unbind('group-change', this.updateEditPermissions);
      return this.released = true;
    };

    RedesignDashboardSettingsController.prototype.release = function() {
      this.offsetMainContent(0);
      this.releaseAll();
      return RedesignDashboardSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardSettingsController.prototype.updateEditPermissions = function() {
      var canEdit, canExplore, ref, ref1, ref2, ref3;
      if (AppRedesign.current().state.RbacEnabled) {
        canEdit = this.dashboard.hasCreateSqlOrDiscoveryChartsPermission();
        this.createFilterIcon.toggleClass('disabled', ((ref = AppRedesign.current()) != null ? ref.tvmode : void 0) || !canEdit);
        return this.manageFiltersIcon.toggleClass('disabled', ((ref1 = AppRedesign.current()) != null ? ref1.tvmode : void 0) || !canEdit);
      } else {
        canEdit = this.dashboard.isEditableByCurrentUser();
        canExplore = this.dashboard.isExplorableByCurrentUser();
        this.createFilterIcon.toggleClass('disabled', ((ref2 = AppRedesign.current()) != null ? ref2.tvmode : void 0) || !canEdit);
        return this.manageFiltersIcon.toggleClass('disabled', ((ref3 = AppRedesign.current()) != null ? ref3.tvmode : void 0) || !canExplore);
      }
    };

    RedesignDashboardSettingsController.prototype.render = function() {
      this.html(this.view('redesign/dashboards/dashboard_filters')());
      this.el.addClass('fully-closed');
      this.setMaxSettingsHeight();
      this.dashboardLoader.hide();
      this.updateEditPermissions();
      return setTimeout(((function(_this) {
        return function() {
          return _this.settings.addClass('can-animate');
        };
      })(this)), 0);
    };

    RedesignDashboardSettingsController.prototype.renderFilterBarAndAnimate = function() {
      return this.renderFilterBar();
    };

    RedesignDashboardSettingsController.prototype.offsetMainContent = function(filterBarHeight) {
      var closedAdjustment, headerOffset;
      headerOffset = AppRedesign.current().embed_mode ? 0 : App.SetUpScreenshotMode.inScreenshotMode() ? this.constructor.CSS_SCREENSHOT_HEADER_OFFSET : this.constructor.CSS_HEADER_OFFSET;
      closedAdjustment = this.el.hasClass('fully-closed') ? 0 : -1;
      return this.mainContentEl.css('top', filterBarHeight + headerOffset + closedAdjustment);
    };

    RedesignDashboardSettingsController.prototype.renderFilterBarForUdv = function(udv) {
      if (udv.dashboard_id !== this.dashboard.id) {
        return;
      }
      return this.renderFilterBar();
    };

    RedesignDashboardSettingsController.prototype.renderFilterBar = function() {
      var canEdit;
      this.filtersBar.html(this.view('redesign/dashboards/filter_bar')({
        filterCount: this.selectedDimensionCount()
      }));
      this.filters = $(this.filtersBar).find('.filters');
      this.populateFilters();
      this.individualFilters = $(this.filters).find('.filter-group .filter');
      canEdit = this.dashboard.isEditableByCurrentUser();
      this.setDefaultButton.toggleClass('hidden', !canEdit);
      if (!AppRedesign.createSqlChartsEnabled()) {
        this.sideFrame.hide();
      }
      this.updateApplyButtonState();
      this.refreshElements();
      this.offsetMainContent(this.filtersBar.outerHeight() + this.constructor.CSS_FILTER_BORDER);
      if (AppRedesign.current().shared_mode) {
        return AppRedesign.current().setupScreenshotMode();
      }
    };

    RedesignDashboardSettingsController.prototype.resetConfigAndRenderContent = function() {
      this.dashboard.resetConfigState();
      return this.render();
    };

    RedesignDashboardSettingsController.prototype.populateFilters = function() {
      var d, dimensionKeys, dimensionMap, hiddenFilters, j, k, len, len1, results, visibleFiltersInBarOrder, visibleKeysInOrder;
      this.filters.empty();
      dimensionMap = this.dimensions();
      dimensionKeys = Object.keys(dimensionMap);
      visibleKeysInOrder = this.getFiltersInBarOrder();
      visibleFiltersInBarOrder = _.intersection(visibleKeysInOrder, dimensionKeys);
      hiddenFilters = _.difference(dimensionKeys, visibleKeysInOrder);
      for (j = 0, len = visibleFiltersInBarOrder.length; j < len; j++) {
        d = visibleFiltersInBarOrder[j];
        this.filters.append(this.view('redesign/dashboards/dashboard_settings_filter_item')({
          dimensionId: d,
          dimensionArray: dimensionMap[d]
        }));
      }
      results = [];
      for (k = 0, len1 = hiddenFilters.length; k < len1; k++) {
        d = hiddenFilters[k];
        results.push(this.filters.append(this.view('redesign/dashboards/dashboard_settings_filter_item')({
          dimensionId: d,
          dimensionArray: dimensionMap[d]
        })));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.updateRowOpenedStatus = function() {
      var i, j, len, ref, results, row, setting, shouldOpen;
      ref = this.getSettingsInOrderEls(true);
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        setting = ref[i];
        row = this.constructor.settingIndexToRow(i);
        shouldOpen = !!this.isRowOpened[row];
        results.push(setting.toggleClass('open', shouldOpen));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.clickedResetFilters = function() {
      return this.dashboard.clearDashboardSettings();
    };

    RedesignDashboardSettingsController.prototype.clickedSetDefaultFilters = function(e) {
      this.applyPendingConfig(e);
      return this.dashboard.setCurrentConfigAsDefault();
    };

    RedesignDashboardSettingsController.prototype.clickedRemoveFilter = function(e) {
      var config, dimensionId, dimensionValueId, filterEl;
      if (this.el.hasClass('fully-closed')) {
        return;
      }
      filterEl = $(e.currentTarget).closest('.filter')[0];
      dimensionId = filterEl.attributes.dimensionid.value;
      if ($.isNumeric(dimensionId)) {
        dimensionId = parseInt(dimensionId);
      }
      dimensionValueId = filterEl.attributes.dimensionvalueid.value;
      config = this.dashboard.dimensionConfig();
      if (dimensionId === App.CustomDimension.AGGREGATION) {
        this.dashboard.setPendingAggregation(null);
        return this.updateLabelsFromDashboard();
      } else if (dimensionId === App.CustomDimension.DATE_RANGE) {
        this.dashboard.setPendingDateRange(null);
        return this.updateLabelsFromDashboard();
      } else {
        return config.removeDimensionInfo(dimensionId, dimensionValueId);
      }
    };

    RedesignDashboardSettingsController.prototype.clickedSettingLabel = function(event) {
      var clickedSetting, idx, row, shouldOpen;
      clickedSetting = $(event.target).closest('.setting');
      idx = this.getSettingIndexByCid(clickedSetting.attr('dimension'));
      row = this.constructor.settingIndexToRow(idx);
      shouldOpen = !clickedSetting.hasClass('open');
      this.isRowOpened[row] = shouldOpen;
      this.updateRowOpenedStatus();
      this.setHeights(true);
      return this.hideForms();
    };

    RedesignDashboardSettingsController.prototype.windowResized = function() {
      if (this.el.hasClass('open')) {
        this.setMaxSettingsHeight();
        this.setHeights(true);
      }
      this.offsetMainContent(this.filtersBar.outerHeight() + this.constructor.CSS_FILTER_BORDER);
      this.updateRowOpenedStatus();
      this.storeWindowSize();
      return this.sideFramePositionSet = false;
    };

    RedesignDashboardSettingsController.prototype.storeWindowSize = function() {
      this.constructor.windowWidth = $(window).width();
      return this.constructor.windowHeight = $(window).height();
    };

    RedesignDashboardSettingsController.prototype.settingsHeight = function() {
      var closedRows, i, j, openedRows, ref;
      if (!this.el.hasClass('open')) {
        return 0;
      }
      openedRows = 0;
      closedRows = 0;
      for (i = j = 0, ref = this.numRows(); 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        if (!!this.isRowOpened[i]) {
          openedRows += 1;
        } else {
          closedRows += 1;
        }
      }
      if ((openedRows + closedRows) === 0) {
        this.noDimensionsMessage.addClass('fade-in');
        this.el.addClass('no-dims');
        return RedesignDashboardSettingsController.CSS_NO_DIMENSIONS_MESSAGE_HEIGHT;
      } else {
        this.noDimensionsMessage.removeClass('fade-in');
        this.el.removeClass('no-dims');
      }
      return (closedRows * this.constructor.CSS_SETTING_CLOSED_HEIGHT) + (openedRows * this.constructor.CSS_SETTING_HEIGHT);
    };

    RedesignDashboardSettingsController.prototype.setMaxSettingsHeight = function() {
      this.maxSettingsHeight = this.constructor.windowHeight - 250;
      return setTimeout(((function(_this) {
        return function() {
          return _this.settings.css({
            'max-height': _this.maxSettingsHeight
          });
        };
      })(this)), 0);
    };

    RedesignDashboardSettingsController.prototype.setHeights = function(force) {
      var newHeight;
      if (force == null) {
        force = false;
      }
      newHeight = this.settingsHeight();
      if (newHeight === this.lastSetHeight && !force) {
        return;
      }
      this.lastSetHeight = newHeight;
      setTimeout((function(_this) {
        return function() {
          _this.settings.height(newHeight);
          return _this.spinner.toggle();
        };
      })(this));
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.el.toggleClass('internal-scroll-ok', newHeight >= _this.maxSettingsHeight);
        };
      })(this)), (newHeight === 0 ? App.AppFrameRedesign.FAST_ANIMATION_TIME : 0));
      if (newHeight > 0) {
        this.setSettingsPositions();
        return this.setSideFramePosition();
      }
    };

    RedesignDashboardSettingsController.prototype.setSideFramePosition = function() {
      return setTimeout(((function(_this) {
        return function() {
          return _this.sideFrame.css('top', _this.filtersBar.css('height'));
        };
      })(this)), 0);
    };

    RedesignDashboardSettingsController.prototype.toggleOpen = function(e) {
      App.Site.trigger('close-toast');
      this.maybeShowDashLoader();
      if (this.isOpen()) {
        this.closeForm();
      } else {
        this.openForm(e);
      }
      if (e.stopPropagation != null) {
        return e.stopPropagation();
      }
    };

    RedesignDashboardSettingsController.prototype.isOpen = function() {
      return this.el.hasClass('open');
    };

    RedesignDashboardSettingsController.prototype.maybeShowDashLoader = function() {
      if (this.dashboard.isCompletelyLoaded()) {
        this.dashboardLoader.hide();
        return clearInterval(this.dashLoaderInterval);
      } else {
        this.dashboardLoader.show();
        return this.dashLoaderInterval != null ? this.dashLoaderInterval : this.dashLoaderInterval = setInterval(this.maybeShowDashLoader, 1000);
      }
    };

    RedesignDashboardSettingsController.prototype.noDimensionsText = function() {
      var owner;
      owner = App.User.exists(this.dashboard.user_id);
      if (owner) {
        if (App.User.currentUser().id === owner.id) {
          return 'Add filters to this dashboard from the gear menu.';
        } else {
          return 'Ask ' + owner.first_name + ' ' + owner.last_name + ' to add filters to this dashboard.';
        }
      } else {
        return 'Claim this dashboard to change filters.';
      }
    };

    RedesignDashboardSettingsController.prototype.openForm = function(e) {
      $('#body').trigger('click');
      clearTimeout(this.fullyClosedTimeout);
      App.Lagotron.addContext("openRedesignDashboardSettingsController");
      this.dashboard.clearPendingState();
      this.dashboard.fetchUdvSignatures();
      this.dashboard.removeInvalidDimensions();
      this.el.removeClass('fully-closed');
      this.el.addClass('open');
      this.setMaxSettingsHeight();
      this.setHeights();
      this.noDimensionsMessage.text(this.noDimensionsText());
      this.dashboard.trigger('dashboard-settings-opened');
      if ((e != null ? e.stopPropagation : void 0) != null) {
        return e != null ? e.stopPropagation() : void 0;
      }
    };

    RedesignDashboardSettingsController.prototype.closeForm = function(_, applyBtnClicked) {
      var ref;
      if (applyBtnClicked == null) {
        applyBtnClicked = false;
      }
      App.Lagotron.addContext("closeRedesignDashboardSettingsController");
      if (!(applyBtnClicked && this.dashboard.userDataView().isNew())) {
        this.dashboard.clearPendingState();
      }
      this.hideForms();
      this.el.removeClass('open');
      this.setHeights();
      this.el.find('.label-highlight').removeClass('label-highlight');
      this.setMaxSettingsHeight();
      if ((ref = this.dateRangeDimensionSetting) != null) {
        ref.closeForm();
      }
      this.fullyClosedTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.el.addClass('fully-closed');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      return this.dashboard.trigger('dashboard-settings-closed');
    };

    RedesignDashboardSettingsController.prototype.closeFormOnApply = function() {
      return this.closeForm(null, true);
    };

    RedesignDashboardSettingsController.prototype.clickedApply = function(e) {
      return this.applyPendingConfig(e);
    };

    RedesignDashboardSettingsController.prototype.openAddFilter = function(e) {
      if (this.createFilterIcon.hasClass('active')) {
        return;
      }
      if (e != null) {
        e.stopPropagation();
      }
      if (!this.addFiltersEnabled()) {
        return;
      }
      this.createFilterIcon.addClass('active');
      App.Utils.logFeature('open-add-filter-form', {
        dashboard_id: this.dashboard.id
      });
      this.dimensionsForm.newDimensionClicked();
      return this.manageFiltersForm.hideForm(false);
    };

    RedesignDashboardSettingsController.prototype.openManageFiltersForm = function(e) {
      if (this.manageFiltersIcon.hasClass('active')) {
        return;
      }
      if (e != null) {
        e.stopPropagation();
      }
      if (!this.manageFiltersEnabled()) {
        return;
      }
      App.Utils.logFeature("open-dimension-availabilty-form", {
        dashboard_id: this.dashboard.id
      });
      this.dimensionsForm.hideForm(false);
      if (this.manageFiltersForm.open) {
        this.manageFiltersForm.hideFormWithSlide(false);
        return;
      }
      this.manageFiltersIcon.addClass('active');
      return this.manageFiltersForm.showForm();
    };

    RedesignDashboardSettingsController.prototype.restrictSettingsForFactory = function() {
      var factory;
      factory = this.dashboard.sharedDashboardFactories().first();
      if (factory != null) {
        this.el.removeClass('with-custom-dimensions-form');
        this.el.addClass('for-factory');
        return this.elementForDimension(factory.customDimension()).addClass('for-factory');
      } else {
        this.el.addClass('with-custom-dimensions-form');
        this.el.removeClass('for-factory');
        return this.el.find('.dimension-setting').removeClass('for-factory');
      }
    };

    RedesignDashboardSettingsController.prototype.updateAvailableDimensions = function() {
      var currentlyShowingDim, dim_cid, j, k, len, len1, newOrder, nothingChanged, orderChanged, shouldBeShownDim, toHide, toShow;
      this.dashboard.reload();
      if (AppRedesign.current().pdf_mode) {
        return;
      }
      currentlyShowingDim = this.currentlyVisibleDimensions();
      shouldBeShownDim = this.visibleDimensionIds();
      toHide = currentlyShowingDim.withoutAny(shouldBeShownDim);
      toShow = shouldBeShownDim.withoutAny(currentlyShowingDim);
      newOrder = this.dashboard.allDimensionCidsInOrder().join(',');
      orderChanged = newOrder !== this.lastAvailableDimOrder;
      nothingChanged = toHide.length === 0 && toShow.length === 0 && !orderChanged;
      if (nothingChanged) {
        return;
      }
      for (j = 0, len = toHide.length; j < len; j++) {
        dim_cid = toHide[j];
        this.hideDimension(dim_cid);
      }
      for (k = 0, len1 = toShow.length; k < len1; k++) {
        dim_cid = toShow[k];
        this.showDimension(dim_cid);
      }
      this.updateRowOpenedStatus();
      this.setHeights(!nothingChanged);
      return this.lastAvailableDimOrder = newOrder;
    };

    RedesignDashboardSettingsController.prototype.hideDimension = function(dim_cid) {
      return this.elementForDimension(dim_cid).addClass('collapsed');
    };

    RedesignDashboardSettingsController.prototype.showDimension = function(dim_cid) {
      var dimEl;
      dimEl = this.elementForDimension(dim_cid);
      if (dimEl.length === 0 && indexOf.call(this.visibleDimensionIds(), dim_cid) >= 0) {
        this.addNewDimension(App.CustomDimension.find(dim_cid));
        if (App.CustomDimension.isCustomDimensionId(dim_cid)) {
          App.CustomDimension.find(dim_cid).trigger('data-updated');
        }
      }
      return this.elementForDimension(dim_cid).removeClass('collapsed');
    };

    RedesignDashboardSettingsController.prototype.clickedFiltersBar = function(e) {
      if (!$(e.target).hasClass('remove-icon')) {
        return this.toggleOpen(e);
      }
    };

    RedesignDashboardSettingsController.prototype.visibleDimensionIds = function() {
      var available, cid, ref, ref1, results, results1, sd;
      if (AppRedesign.current().shared_mode) {
        if (AppRedesign.current().shared_filter_mode) {
          sd = App.SharedDashboard.currentSharedDashboard();
          if (sd) {
            ref = App.DimensionAvailability.availableForSharedDashboard(sd);
            results = [];
            for (cid in ref) {
              available = ref[cid];
              if (available) {
                results.push(cid);
              }
            }
            return results;
          } else {
            return [];
          }
        }
      } else {
        ref1 = App.DimensionAvailability.availableForDashboard(this.dashboard);
        results1 = [];
        for (cid in ref1) {
          available = ref1[cid];
          if (available) {
            results1.push(cid);
          }
        }
        return results1;
      }
    };

    RedesignDashboardSettingsController.prototype.renderDimensions = function() {
      var dimension, j, len, ref, results;
      if (!App.Site.first().showDimensionOptions()) {
        return;
      }
      ref = this.dimensionsToRender();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        dimension = ref[j];
        results.push(this.renderDimension(dimension, this.settings, 'append', true));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.dimensionsToRender = function() {
      var dim_cid, j, len, ref, results;
      ref = this.visibleDimensionIds();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        dim_cid = ref[j];
        results.push(App.CustomDimension.find(dim_cid));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.renderDimension = function(dimension, parentElement, parentAction, collapsed) {
      var ref, setting, view, viewEl;
      view = this.view('dashboards/setting_frame')({
        dimension: dimension,
        collapsed: collapsed
      });
      parentElement[parentAction](view);
      viewEl = this.elementForDimension(dimension);
      switch (dimension.name) {
        case App.CustomDimension.DATE_RANGE:
          if ((ref = this.dateRangeDimensionSetting) != null) {
            ref.release();
          }
          this.dateRangeDimensionSetting = setting = new App.RedesignDateRangeDimensionSetting({
            el: viewEl,
            dashboard: this.dashboard,
            dimension: dimension
          });
          break;
        case App.CustomDimension.AGGREGATION:
          viewEl.addClass('aggregation-setting');
          setting = new App.RedesignAggregationDimensionSetting({
            el: viewEl,
            dashboard: this.dashboard,
            dimension: dimension
          });
          break;
        default:
          setting = new App.RedesignDimensionSetting({
            el: viewEl,
            dimension: dimension,
            dashboard: this.dashboard
          });
      }
      setting.bind('apply-pending-config', this.applyPendingConfig);
      this.dimensionSettings.push(setting);
      return viewEl;
    };

    RedesignDashboardSettingsController.prototype.elementForDimension = function(dimension) {
      var id;
      id = App.CustomDimension.elementIdForDimension(dimension);
      return this.settings.find("div[dimension=" + id + "]");
    };

    RedesignDashboardSettingsController.prototype.popSettingForDimension = function(dimension) {
      var ds, foundDs, j, len, newSettings, ref;
      foundDs = null;
      newSettings = [];
      ref = this.dimensionSettings;
      for (j = 0, len = ref.length; j < len; j++) {
        ds = ref[j];
        if (ds.dimension.id === dimension.id) {
          foundDs = ds;
        } else {
          newSettings.push(ds);
        }
      }
      this.dimensionSettings = newSettings;
      return foundDs;
    };

    RedesignDashboardSettingsController.prototype.addNewDimension = function(dimension) {
      var dim, dims, j, lastDim, len, newEl, parentAction, parentEl;
      if (!this.rendered) {
        return;
      }
      dims = this.dimensionsToRender();
      lastDim = null;
      for (j = 0, len = dims.length; j < len; j++) {
        dim = dims[j];
        if (dim.cid === dimension.cid) {
          break;
        }
        lastDim = dim;
      }
      if (lastDim != null) {
        parentEl = this.elementForDimension(lastDim);
        parentAction = 'after';
      } else {
        parentEl = this.settings;
        parentAction = 'prepend';
      }
      newEl = this.renderDimension(dimension, parentEl, parentAction, true);
      setTimeout((function() {
        return newEl.removeClass('collapsed');
      }), 0);
      this.settings.animate({
        scrollLeft: newEl.position().left
      }, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      this.setHeights(true);
      this.refreshElements();
      this.updateRowOpenedStatus();
      return this.updateAvailableDimensions();
    };

    RedesignDashboardSettingsController.prototype.removeDimension = function(dimension) {
      var dimensionSetting;
      this.elementForDimension(dimension).addClass('collapsed');
      dimensionSetting = this.popSettingForDimension(dimension);
      this.updateLabelsFromDashboard();
      if (dimensionSetting != null) {
        return setTimeout(((function(_this) {
          return function() {
            dimensionSetting.release();
            _this.elementForDimension(dimension).remove();
            _this.setHeights(true);
            _this.refreshElements();
            return _this.updateRowOpenedStatus();
          };
        })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      }
    };

    RedesignDashboardSettingsController.prototype.currentlyVisibleDimensions = function() {
      var el, j, len, ref, results;
      ref = this.settings.find(".setting[dimension]:not(.collapsed)");
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        el = ref[j];
        results.push($(el).attr('dimension'));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.applyPendingConfig = function(e) {
      if (this.dashboard.hasNewPendingSettings()) {
        this.dashboard.applyPendingConfig();
      } else {
        this.closeForm();
      }
      if ((e != null ? e.stopPropagation : void 0) != null) {
        return e != null ? e.stopPropagation() : void 0;
      }
    };

    RedesignDashboardSettingsController.labelForOptionValue = function(value, options) {
      var j, len, option;
      for (j = 0, len = options.length; j < len; j++) {
        option = options[j];
        if (option.value === value) {
          return option.label;
        }
      }
      return "OPTION_NOT_FOUND";
    };

    RedesignDashboardSettingsController.prototype.updateLabelsFromDashboard = function() {
      var dimensionSetting, j, len, ref;
      ref = this.dimensionSettings;
      for (j = 0, len = ref.length; j < len; j++) {
        dimensionSetting = ref[j];
        dimensionSetting.updateLabel();
      }
      this.refreshElements();
      this.renderFilterBar();
      return this.setSideFramePosition();
    };

    RedesignDashboardSettingsController.prototype.updateApplyButtonState = function() {
      if (this.dashboard.hasNewPendingSettings()) {
        return this.applyButton.removeClass('disabled');
      } else {
        return this.applyButton.addClass('disabled');
      }
    };

    RedesignDashboardSettingsController.prototype.getSettingIndexByCid = function(dimCid) {
      var dCid, i, j, len, ref, visibleSet;
      i = 0;
      visibleSet = this.visibleDimensionIds().to_set();
      ref = this.dashboard.allDimensionCidsInOrder();
      for (j = 0, len = ref.length; j < len; j++) {
        dCid = ref[j];
        if (!visibleSet[dCid]) {
          continue;
        }
        if (dCid === dimCid) {
          return i;
        }
        i++;
      }
      return 0;
    };

    RedesignDashboardSettingsController.prototype.getSettingsInOrderEls = function(onlyVisible) {
      var dimCid, dimEl, dimensionEls, j, len, ref, settingEls, visibleDimSet;
      if (onlyVisible == null) {
        onlyVisible = false;
      }
      settingEls = [];
      visibleDimSet = this.dashboard.visibleDimensionCids().to_set();
      dimensionEls = this.settings.find('.dimension-setting');
      ref = this.dashboard.allDimensionCidsInOrder();
      for (j = 0, len = ref.length; j < len; j++) {
        dimCid = ref[j];
        if (onlyVisible && !visibleDimSet[dimCid]) {
          continue;
        }
        dimEl = _.find(dimensionEls, (function(e) {
          return e.getAttribute('dimension') === dimCid;
        }));
        if (dimEl) {
          settingEls.push($(dimEl));
        }
      }
      return settingEls;
    };

    RedesignDashboardSettingsController.prototype.getFiltersInBarOrder = function() {
      return _.map(this.dashboard.visibleDimensionsInOrder(), (function(dim) {
        return dim.id.toString();
      }));
    };

    RedesignDashboardSettingsController.prototype.setSettingsPositions = function() {
      var j, leftVal, len, numSettings, ref, results, settingEl, settingWidth, visibleDimSet, visibleIndex, widthPoints;
      numSettings = this.numSettings();
      widthPoints = this.constructor.widthPointsForSettings(numSettings);
      visibleIndex = -1;
      visibleDimSet = this.visibleDimensionIds().to_set();
      ref = this.getSettingsInOrderEls(false);
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        settingEl = ref[j];
        settingWidth = 0;
        if (!(settingEl.hasClass('collapsed') || !visibleDimSet[settingEl.attr('dimension')])) {
          settingWidth = widthPoints;
          visibleIndex += 1;
        }
        leftVal = this.constructor.leftPointsForSetting(visibleIndex, numSettings);
        settingEl.css({
          width: settingWidth + "%",
          left: leftVal + "%",
          top: (this.constructor.topPxForSetting(visibleIndex, this.isRowOpened)) + "px"
        });
        results.push(settingEl.toggleClass('left-edge', leftVal === 0));
      }
      return results;
    };

    RedesignDashboardSettingsController.prototype.numSettings = function() {
      if (!App.Site.first().showDimensionOptions()) {
        return 0;
      }
      return this.visibleDimensionIds().length;
    };

    RedesignDashboardSettingsController.prototype.numRows = function() {
      var numSettings;
      numSettings = this.numSettings();
      if (numSettings.length < this.constructor.settingsPerRow()) {
        return 1;
      }
      return Math.ceil(numSettings / this.constructor.settingsPerRow());
    };

    RedesignDashboardSettingsController.settingsPerRow = function() {
      if (this.windowWidth == null) {
        this.windowWidth = $(window).width();
      }
      return Math.floor(this.windowWidth / this.MINIMUM_DIM_WIDTH);
    };

    RedesignDashboardSettingsController.settingIndexToRow = function(index) {
      return Math.floor(index / this.settingsPerRow());
    };

    RedesignDashboardSettingsController.widthPointsForSettings = function(numSettings) {
      switch (numSettings) {
        case 1:
        case 2:
        case 3:
          return 100 / 3;
        default:
          return 100 / Math.min(numSettings, this.settingsPerRow());
      }
    };

    RedesignDashboardSettingsController.leftPointsForSetting = function(visibleIndex, numSettings) {
      var leftForRow, widthPts;
      if (visibleIndex < 0) {
        return 0;
      }
      leftForRow = visibleIndex % this.settingsPerRow();
      widthPts = this.widthPointsForSettings(numSettings);
      return leftForRow * widthPts;
    };

    RedesignDashboardSettingsController.topPxForSetting = function(visibleIndex, rowOpenMap) {
      var i, j, onRow, ref, top;
      if (visibleIndex < 0) {
        return 0;
      }
      onRow = this.settingIndexToRow(visibleIndex);
      top = 0;
      for (i = j = 0, ref = onRow; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        if (rowOpenMap[i]) {
          top += this.CSS_SETTING_HEIGHT;
        } else {
          top += this.CSS_SETTING_CLOSED_HEIGHT;
        }
      }
      return top;
    };

    RedesignDashboardSettingsController.prototype.manageFiltersEnabled = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canExplore() : void 0;
      }
    };

    RedesignDashboardSettingsController.prototype.addFiltersEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return App.User.CurrentUserCanEdit();
      }
    };

    return RedesignDashboardSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.RedesignDashboardSizer = (function() {
    RedesignDashboardSizer.LEFT_NAV_WIDTH = 60;

    RedesignDashboardSizer.TOP_MENU_HEIGHT = 100;

    RedesignDashboardSizer.browserWidthHeight = function() {
      return [window.innerWidth, window.innerHeight];
    };

    function RedesignDashboardSizer(dash) {
      var unit;
      this.dash = dash;
      this.SCROLLBAR_WIDTH = 15;
      this.DASHBOARD_HEADER_EMAIL_HEIGHT_NO_FILTERS = 88;
      this.RIGHT_MARGIN = 10;
      unit = 32;
      this.MIN_COLUMN_WIDTH = unit / 2;
      this.MAX_COLUMN_WIDTH = unit;
      this.MAX_ROW_HEIGHT = unit;
      this.MIN_NUM_COLS = 960 / unit;
      this.MAX_NUM_COLS = 2880 / unit;
      this.DEFAULT_COLS = (960 / unit) * 2;
      this.SCREENSHOT_COLUMN_WIDTH = unit;
      this.SCREENSHOT_MARGIN = 11;
      this.SCREENSHOT_MIN_COLS = 30;
      this.DEFAULT_SCREEN_MARGIN = 2 * this.MAX_COLUMN_WIDTH;
      this.MAX_ROWS = 1280 / unit;
      this.EDITOR_MAX_ROWS = 2 * Math.round(320 / unit);
      this.EDITOR_COLUMNS = 3 * Math.round(320 / unit);
      this.EDITOR_INITIAL_HEIGHT = Math.round(320 / unit);
      this.EDITOR_INITIAL_WIDTH = 3 * Math.round(320 / unit);
      this.SHARED_DASHBOARD_HEADER_LOGO_PADDING = 7;
      this.LINKED_MODE_NUM_COLS = 960 / unit;
      this.LINKED_MODE_NUM_ROWS = 2 * Math.round(320 / unit);
      this.LIMIT_TO_BE_CONSIDERED_WIDE = 10;
      this.MIN_WIDGET_WIDTH = Math.round(224 / unit);
      this.MIN_WIDGET_HEIGHT = AppRedesign.textOnDashboardEnabled() ? Math.round(96 / unit) : Math.round(224 / unit);
      this.DEFAULT_ROW_BUFFER = Math.round(480 / unit);
      this.DEFAULT_COL_BUFFER = Math.round(1600 / unit);
      this.DEFAULT_ROWS = 5 * Math.round(320 / unit);
      this.RESIZE_ROW_BUFFER = 5 * Math.round(320 / unit);
      this.RESIZE_COL_BUFFER = 10 * Math.round(320 / unit);
      this.MARKER_WIDTH = 48;
      this.LEFT_GUTTER = 10;
      this.CHART_MENU_HEIGHT = 35;
      this.SCREENSHOT_BORDER_OFFSET = 1;
    }

    RedesignDashboardSizer.prototype.minDashboardWidth = function() {
      return this.getRightmostWidgetGridColumn() * this.MIN_COLUMN_WIDTH;
    };

    RedesignDashboardSizer.prototype.maxDashboardWidth = function() {
      return this.numCols() * this.MAX_COLUMN_WIDTH;
    };

    RedesignDashboardSizer.prototype.numCols = function(inEditron, screenshotMode) {
      if (inEditron == null) {
        inEditron = false;
      }
      if (screenshotMode == null) {
        screenshotMode = false;
      }
      if (inEditron) {
        return this.MIN_NUM_COLS;
      }
      if (screenshotMode || App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.getRightmostWidgetGridColumn(this.SCREENSHOT_MIN_COLS);
      } else {
        return this.DEFAULT_COLS;
      }
    };

    RedesignDashboardSizer.prototype.minCols = function() {
      return this.MIN_NUM_COLS;
    };

    RedesignDashboardSizer.prototype.numColsForTVMode = function() {
      return this.DEFAULT_COLS;
    };

    RedesignDashboardSizer.prototype.maxRows = function() {
      return this.MAX_ROWS;
    };

    RedesignDashboardSizer.prototype.maxColumnWidth = function() {
      return this.MAX_COLUMN_WIDTH;
    };

    RedesignDashboardSizer.prototype.getRightmostWidgetGridColumn = function(minimumWidth) {
      var j, len, max, ref, widget;
      if (minimumWidth == null) {
        minimumWidth = this.MIN_NUM_COLS;
      }
      max = minimumWidth;
      ref = this.dash.widgets();
      for (j = 0, len = ref.length; j < len; j++) {
        widget = ref[j];
        if (max < widget.getColumn() + widget.getWidth()) {
          max = widget.getColumn() + widget.getWidth();
        }
      }
      return max;
    };

    RedesignDashboardSizer.prototype.columnWidth = function(inEditron) {
      var colWidth, initialColumnWidth, ref, ref1;
      if (inEditron == null) {
        inEditron = false;
      }
      if (inEditron) {
        return this.MAX_COLUMN_WIDTH;
      }
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.SCREENSHOT_COLUMN_WIDTH;
      }
      if (this.dash == null) {
        return this.MAX_COLUMN_WIDTH;
      }
      initialColumnWidth = App.RedesignDashboardLayoutController.getInitialColumnWidth((ref = this.dash) != null ? ref.id : void 0);
      if (initialColumnWidth) {
        return initialColumnWidth;
      }
      colWidth = Math.floor(Math.max(this.maxWidthForScreen(), this.minDashboardWidth()) / this.getRightmostWidgetGridColumn());
      if (colWidth > this.MAX_COLUMN_WIDTH) {
        colWidth = this.MAX_COLUMN_WIDTH;
      } else if (colWidth < this.MIN_COLUMN_WIDTH) {
        colWidth = this.MIN_COLUMN_WIDTH;
      }
      if (AppRedesign.current().spinalCord.firstBatchLoaded) {
        App.RedesignDashboardLayoutController.setInitialColumnWidth((ref1 = this.dash) != null ? ref1.id : void 0, colWidth);
      }
      return colWidth;
    };

    RedesignDashboardSizer.prototype.rowHeight = function(inEditron) {
      return this.columnWidth(inEditron);
    };

    RedesignDashboardSizer.prototype.widthForScreen = function() {
      var dashboardContainerWidth, snappedDashboardContainerWidth;
      dashboardContainerWidth = this.constructor.screenSize() - this.SCROLLBAR_WIDTH - this.screenMargin();
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.columnWidth() * this.numCols();
      }
      if (this.columnWidth() < this.MAX_COLUMN_WIDTH) {
        return Math.max(this.columnWidth() * this.getRightmostWidgetGridColumn(), this.minDashboardWidth());
      } else if (dashboardContainerWidth < this.maxDashboardWidth()) {
        snappedDashboardContainerWidth = dashboardContainerWidth - (dashboardContainerWidth % this.MAX_COLUMN_WIDTH);
        return Math.max(snappedDashboardContainerWidth, this.minDashboardWidth());
      } else {
        return this.columnWidth() * this.numCols();
      }
    };

    RedesignDashboardSizer.prototype.marginForScreen = function() {
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.SCREENSHOT_MARGIN;
      }
      return Math.max(App.RedesignDashboardSizer.screenSize() - this.SCROLLBAR_WIDTH - this.widthForScreen(), 0);
    };

    RedesignDashboardSizer.prototype.maxWidthForScreen = function() {
      return App.RedesignDashboardSizer.screenSize() - this.screenMargin() - this.SCROLLBAR_WIDTH;
    };

    RedesignDashboardSizer.maybeBindResize = function() {
      if (RedesignDashboardSizer._boundResize == null) {
        return $(window).on('resize', this.clearCachedSizes).RedesignDashboardSizer_boundResize = true;
      }
    };

    RedesignDashboardSizer.clearCachedSizes = function() {
      return delete RedesignDashboardSizer._width;
    };

    RedesignDashboardSizer.screenSize = function() {
      if (RedesignDashboardSizer._width == null) {
        RedesignDashboardSizer.maybeBindResize();
        RedesignDashboardSizer._width = $('body').width();
      }
      return RedesignDashboardSizer._width;
    };

    RedesignDashboardSizer.prototype.screenMargin = function() {
      if (this.constructor.isTvMode()) {
        return 0;
      }
      if (AppRedesign.current().embed_mode != null) {
        return 0;
      } else {
        return this.DEFAULT_SCREEN_MARGIN;
      }
    };

    RedesignDashboardSizer.prototype.centerElementForDashboard = function(el) {
      return el.css({
        width: (this.widthForScreen()) + "px"
      });
    };

    RedesignDashboardSizer.prototype.screenshotDashboadSizer = function(slackMode, widgetMode) {
      var filterOffset;
      filterOffset = $('#body').hasClass('with-filters') ? $('#body .filters-bar').outerHeight() : 0;
      return new App.RedesignScreenshotDashboardSizer(this.dash, slackMode, widgetMode, filterOffset, this);
    };

    RedesignDashboardSizer.prototype.view = function(name) {
      return JST["app/views/" + name];
    };

    RedesignDashboardSizer.prototype.resizeGrid = function(gridBoundaryEl) {
      var colWidth, j, len, ref, size;
      colWidth = this.columnWidth();
      gridBoundaryEl.css("background-size", (colWidth * 10) + "px " + (colWidth * 10) + "px");
      gridBoundaryEl.css("background-position", (colWidth * 4.5 + this.LEFT_GUTTER) + "px " + (colWidth * 4.5) + "px");
      ref = [1024, 1920, 2560];
      for (j = 0, len = ref.length; j < len; j++) {
        size = ref[j];
        gridBoundaryEl.find(".grid-screen-marker.p" + size).css('left', this.scaledPosition(size));
        gridBoundaryEl.find(".grid-marker-label.p" + size).css('left', this.scaledPosition(size) - this.MARKER_WIDTH);
      }
      return this.scalePDFGuidelines(gridBoundaryEl);
    };

    RedesignDashboardSizer.prototype.scalePDFGuidelines = function(gridBoundaryEl) {
      var columnWidth, j, num, ref, results, scaleRatio, top, width;
      columnWidth = this.columnWidth();
      scaleRatio = this.columnWidth() / this.MAX_COLUMN_WIDTH;
      this.NUM_GUIDELINE = 12;
      this.NUM_GRID_WITH_FILTER = 19;
      this.NUM_GRID_NO_FILTER = 21;
      this.NUM_GRID_EACH_PAGE = 24;
      this.GUIDELINE_MAX_WIDTH = 970;
      this.PRINT_FRIENDLY_LABEL_LEFT = 1024;
      this.PRINT_FRIENDLY_LABEL_WITDH = 80;
      gridBoundaryEl.find(".grid-marker-label.print-friendly").css('left', this.scaledPosition(this.PRINT_FRIENDLY_LABEL_LEFT) - this.PRINT_FRIENDLY_LABEL_WITDH);
      results = [];
      for (num = j = 1, ref = this.NUM_GUIDELINE; 1 <= ref ? j < ref : j > ref; num = 1 <= ref ? ++j : --j) {
        width = this.GUIDELINE_MAX_WIDTH * scaleRatio;
        if (this.dash.filtersEnabled()) {
          top = (this.NUM_GRID_WITH_FILTER + (num - 1) * this.NUM_GRID_EACH_PAGE) * columnWidth;
        } else {
          top = (this.NUM_GRID_NO_FILTER + (num - 1) * this.NUM_GRID_EACH_PAGE) * columnWidth;
        }
        gridBoundaryEl.find(".grid-screen-marker-horizontal.guideline" + num).css('top', top);
        results.push(gridBoundaryEl.find(".grid-screen-marker-horizontal.guideline" + num).css('width', width));
      }
      return results;
    };

    RedesignDashboardSizer.prototype.scaledPosition = function(originalPosition) {
      var columnWidth, position, positionCorrection, scaleRatio;
      columnWidth = this.columnWidth();
      scaleRatio = this.columnWidth() / this.MAX_COLUMN_WIDTH;
      positionCorrection = -4;
      position = originalPosition - App.RedesignDashboardSizer.LEFT_NAV_WIDTH + positionCorrection;
      return scaleRatio * position + this.LEFT_GUTTER;
    };

    RedesignDashboardSizer.prototype.buildEditorGrid = function(gridBoundaryEl) {
      var i, j;
      gridBoundaryEl.append(this.view('dashboards/grid_columns')());
      for (i = j = 0; j < 3; i = ++j) {
        gridBoundaryEl.append(this.view('dashboards/grid_row')({
          row: i
        }));
      }
      gridBoundaryEl.find(".grid-row").last().addClass("last");
      return this.layoutEditorGrid(gridBoundaryEl);
    };

    RedesignDashboardSizer.prototype.layoutEditorGrid = function(gridBoundaryEl) {
      var colWidth;
      colWidth = this.MAX_COLUMN_WIDTH;
      gridBoundaryEl.css("background-size", (colWidth * 10) + "px " + (colWidth * 10) + "px");
      gridBoundaryEl.css("background-position", (colWidth * 4.5 - 1) + "px " + (colWidth * 4.5 - 1) + "px");
      gridBoundaryEl.height(this.EDITOR_MAX_ROWS * colWidth + 1);
      return this.updateGridWidth(gridBoundaryEl);
    };

    RedesignDashboardSizer.prototype.updateGridWidth = function(gridBoundaryEl) {
      return this.EDITOR_COLUMNS = Math.floor(gridBoundaryEl.innerWidth() / this.MAX_ROW_HEIGHT);
    };

    RedesignDashboardSizer.prototype.layoutGrid = function(gridBoundaryEl) {
      var inEditron, numRows, ref, rowHeight;
      this.resizeGrid(gridBoundaryEl);
      inEditron = App.RedesignDashboardSizer.inEditron(gridBoundaryEl);
      rowHeight = this.rowHeight(inEditron);
      if (AppRedesign.current().embed_mode || App.SetUpScreenshotMode.inScreenshotMode()) {
        numRows = (ref = this.dash) != null ? ref.nextFreeRow() : void 0;
      } else {
        numRows = Math.max(this.dash.nextFreeRow() + this.DEFAULT_ROW_BUFFER, this.DEFAULT_ROWS);
      }
      gridBoundaryEl.height(numRows * rowHeight);
      return gridBoundaryEl.width(this.getRightmostWidgetGridColumn() * rowHeight + this.LEFT_GUTTER);
    };

    RedesignDashboardSizer.prototype.expandForResize = function(gridBoundaryEl) {
      var numCols, numRows, rowHeight;
      numRows = Math.max(this.dash.nextFreeRow(), this.DEFAULT_ROWS) + this.RESIZE_ROW_BUFFER;
      numCols = this.getRightmostWidgetGridColumn() + this.RESIZE_COL_BUFFER;
      rowHeight = this.rowHeight();
      gridBoundaryEl.height(numRows * rowHeight);
      return gridBoundaryEl.width(numCols * rowHeight);
    };

    RedesignDashboardSizer.prototype.getWidgetPositionOnDashboard = function(widget) {
      return this.widgetPositionNormalMode(null, widget, true);
    };

    RedesignDashboardSizer.prototype.setWidgetDashboardPosition = function(widgetEl, widget, assumeInDashboard) {
      var newHeight, newLeft, newTop, newWidth, ref, ref1;
      if (assumeInDashboard == null) {
        assumeInDashboard = false;
      }
      if (!widget) {
        return;
      }
      if (App.RedesignDashboardSizer.inLinkedWidgetArea(widgetEl)) {
        ref = this.widgetPositionLinkedMode(widget.getChartType()), newWidth = ref[0], newHeight = ref[1];
        widgetEl.css({
          width: newWidth,
          height: newHeight
        });
        if (AppRedesign.current().embed_mode) {
          widgetEl.css({
            top: 0,
            left: 0
          });
        }
        return [newWidth, newHeight];
      } else {
        ref1 = this.widgetPositionNormalMode(widgetEl, widget, assumeInDashboard), newWidth = ref1[0], newHeight = ref1[1], newTop = ref1[2], newLeft = ref1[3];
        widgetEl.css({
          width: newWidth,
          height: newHeight,
          top: newTop,
          left: newLeft
        }).toggleClass('left-gutter', newLeft === 0);
        return [newWidth, newHeight];
      }
    };

    RedesignDashboardSizer.prototype.sizeBigNumberOverlays = function(bigNumParent, widget) {
      var _, height, ref, width;
      if (bigNumParent.find('.bignumber-overlay').length === 0) {
        return;
      }
      if (App.RedesignDashboardSizer.inLinkedWidgetArea(bigNumParent)) {
        ref = this.widgetPositionLinkedMode('bignumber'), width = ref[0], height = ref[1], _ = ref[2], _ = ref[3];
      } else {
        width = bigNumParent.width();
        height = bigNumParent.height();
      }
      return App.ChartOverlay.sizeBigNumberOverlay(widget, bigNumParent, this.contentScale(height), width, height);
    };

    RedesignDashboardSizer.prototype.gridScale = function() {
      return this.columnWidth() / this.MAX_COLUMN_WIDTH;
    };

    RedesignDashboardSizer.prototype.contentScale = function(widgetHeight) {
      return this.gridScale() * widgetHeight / (this.CHART_MENU_HEIGHT + widgetHeight - (this.gridScale() * this.CHART_MENU_HEIGHT));
    };

    RedesignDashboardSizer.prototype.widgetPositionNormalMode = function(widgetEl, widget, assumeInDashboard) {
      var inDash, newGridHeight, newGridLeft, newGridTop, newGridWidth, newHeight, newLeft, newTop, newWidth, ref;
      if (assumeInDashboard == null) {
        assumeInDashboard = false;
      }
      inDash = false;
      ref = assumeInDashboard || App.RedesignDashboardSizer.inDashboard(widgetEl) ? (inDash = true, this.widgetGridPositionDashboard()) : App.RedesignDashboardSizer.inEditron(widgetEl) ? this.widgetGridPositionEditron(widgetEl, widget) : this.widgetGridPositionDashboard(widgetEl, widget), newGridWidth = ref[0], newGridHeight = ref[1], newGridTop = ref[2], newGridLeft = ref[3];
      newWidth = newGridWidth * widget.getWidth() - 1;
      newHeight = newGridHeight * widget.getHeight() - 1;
      newTop = newGridTop * widget.getRow();
      newLeft = newGridLeft * widget.getColumn();
      if (inDash) {
        if (newLeft === 0) {
          newWidth += this.LEFT_GUTTER;
        } else {
          newLeft += this.LEFT_GUTTER;
        }
      }
      return [newWidth, newHeight, newTop, newLeft];
    };

    RedesignDashboardSizer.prototype.widgetWidthOnDashboardWithoutGutter = function(widget) {
      return this.columnWidth() * widget.getWidth() - 1;
    };

    RedesignDashboardSizer.prototype.widgetGridPositionDashboard = function() {
      var colW, rowH;
      colW = this.columnWidth();
      rowH = this.rowHeight();
      return [colW, rowH, colW, rowH];
    };

    RedesignDashboardSizer.prototype.widgetGridPositionEditron = function(widgetEl, widget) {
      return [this.MAX_COLUMN_WIDTH, this.MAX_ROW_HEIGHT, 0, 0];
    };

    RedesignDashboardSizer.prototype.widgetPositionLinkedMode = function(chartType) {
      var aspectRatio, bottomMargin, browserHeight, browserWidth, maxReduction, newHeight, newWidth, ref, responsiveHeight, responsiveWidth, sideMargin, tabular;
      if (AppRedesign.current().embed_mode) {
        return [$('.bottom-box').width(), $('.bottom-box').height()];
      }
      newWidth = this.MAX_COLUMN_WIDTH * this.LINKED_MODE_NUM_COLS;
      newHeight = this.MAX_ROW_HEIGHT * this.LINKED_MODE_NUM_ROWS;
      if (App.SetUpScreenshotMode.slackModeInUrl()) {
        return [newWidth, newHeight];
      }
      ref = this.constructor.browserWidthHeight(), browserWidth = ref[0], browserHeight = ref[1];
      tabular = ['cohort', 'table'].includes(chartType);
      bottomMargin = 0.95;
      sideMargin = 0.90;
      maxReduction = 3;
      aspectRatio = newWidth / newHeight;
      responsiveHeight = Math.max((browserHeight - this.constructor.TOP_MENU_HEIGHT) * bottomMargin, newHeight / maxReduction);
      responsiveWidth = Math.max((browserWidth - this.constructor.LEFT_NAV_WIDTH) * sideMargin, newWidth / maxReduction);
      if (responsiveHeight < newHeight) {
        newHeight = responsiveHeight;
        if (!tabular) {
          newWidth = responsiveHeight * aspectRatio;
        }
      }
      if (responsiveWidth < newWidth) {
        newWidth = responsiveWidth;
        if (!tabular) {
          newHeight = responsiveWidth / aspectRatio;
        }
      }
      return [Math.round(newWidth), Math.round(newHeight)];
    };

    RedesignDashboardSizer.inDashboard = function(el) {
      return AppRedesign.current().getCurrentState() === AppRedesign.IN_DASH || this.inEl(el, ".dashboard-container");
    };

    RedesignDashboardSizer.inEditron = function() {
      return AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON;
    };

    RedesignDashboardSizer.inLinkedWidgetArea = function(el) {
      return this.inEl(el, '.linked-widget-panel');
    };

    RedesignDashboardSizer.inDataTab = function(el) {
      return this.inEl(el, '.in-data-tab');
    };

    RedesignDashboardSizer.inEl = function(el, search) {
      return el.closest(search).length !== 0;
    };

    RedesignDashboardSizer.useDarkTheme = function(el) {
      return App.RedesignDashboardSizer.isTvMode();
    };

    RedesignDashboardSizer.isTvMode = function() {
      return $('.app-frame').hasClass('tv-mode');
    };

    RedesignDashboardSizer.prototype.dashboardSizeForWidget = function(widget) {
      return [this.columnWidth() * widget.getWidth() - 1, this.rowHeight() * widget.getHeight() - 1];
    };

    RedesignDashboardSizer.prototype.editorSizeforWidget = function(widget) {
      return [this.MAX_COLUMN_WIDTH * Math.min(widget.getWidth(), this.EDITOR_COLUMNS) - 1, this.MAX_ROW_HEIGHT * Math.min(widget.getHeight(), this.EDITOR_MAX_ROWS) - 1, this.EDITOR_COLUMNS <= widget.getWidth()];
    };

    RedesignDashboardSizer.prototype.gridSizeForWidget = function(widgetEl, widget) {
      if (App.RedesignDashboardSizer.inDashboard(widgetEl)) {
        return [this.columnWidth(), this.rowHeight()];
      } else {
        return [this.MAX_COLUMN_WIDTH, this.MAX_ROW_HEIGHT];
      }
    };

    RedesignDashboardSizer.prototype.isWide = function(width) {
      var widthInCols;
      widthInCols = Math.round(width / this.columnWidth());
      return widthInCols > this.LIMIT_TO_BE_CONSIDERED_WIDE;
    };

    RedesignDashboardSizer.prototype.getScreenshotPadding = function() {
      var filterOffset;
      filterOffset = $('#body').hasClass('with-filters') ? $('#body .filters-bar').outerHeight() : 0;
      return this.DASHBOARD_HEADER_EMAIL_HEIGHT_NO_FILTERS + filterOffset + this.SCREENSHOT_BORDER_OFFSET;
    };

    RedesignDashboardSizer.prototype.getDashboardEmailMargin = function() {
      return this.SCREENSHOT_MARGIN;
    };

    return RedesignDashboardSizer;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardsController = (function(superClass) {
    extend(RedesignDashboardsController, superClass);

    RedesignDashboardsController.prototype.className = 'dashboard-container';

    RedesignDashboardsController.prototype.elements = {
      '.filters-wrapper': 'filtersWrapper',
      '.dashboard-header': 'dashboardHeader',
      '.empty-dash-message': 'emptyDashMessage',
      '.main-content': 'mainContent',
      '.dashboard-loader': 'dashLoaderEl'
    };

    RedesignDashboardsController.prototype.events = {
      'scroll .main-content': 'mainContentScroll',
      'wheel .main-content': 'mainContentScroll',
      'mousewheel .main-content': 'mainContentScroll'
    };

    RedesignDashboardsController.PRETTY_BUFFER_SIZE_PX = 100;

    RedesignDashboardsController.lastDashboardScroll = 0;

    RedesignDashboardsController.resizeDragInProgress = false;

    function RedesignDashboardsController() {
      this.mainContentScroll = bind(this.mainContentScroll, this);
      this.updateEmptyMessage = bind(this.updateEmptyMessage, this);
      this.updateLoadingComplete = bind(this.updateLoadingComplete, this);
      this.scroll = bind(this.scroll, this);
      this.scrollToElWhileResizing = bind(this.scrollToElWhileResizing, this);
      this.scrollToEl = bind(this.scrollToEl, this);
      this.refresh = bind(this.refresh, this);
      this.dashboardNoLongerCurrent = bind(this.dashboardNoLongerCurrent, this);
      this.hideDashboardLoadingMessageIfLoaded = bind(this.hideDashboardLoadingMessageIfLoaded, this);
      this.dashboardMadeCurrent = bind(this.dashboardMadeCurrent, this);
      this.orphanUser = bind(this.orphanUser, this);
      this.switchToFirstVisibleDashboard = bind(this.switchToFirstVisibleDashboard, this);
      this.renderDashboardSettings = bind(this.renderDashboardSettings, this);
      this.removeTextOnDashCursor = bind(this.removeTextOnDashCursor, this);
      this.addTextOnDashCursor = bind(this.addTextOnDashCursor, this);
      this.removeTextboxDrawingMode = bind(this.removeTextboxDrawingMode, this);
      this.textBoxDrawingModeChanged = bind(this.textBoxDrawingModeChanged, this);
      this.render = bind(this.render, this);
      this.release = bind(this.release, this);
      RedesignDashboardsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item');
      if (this.tvMode == null) {
        this.tvMode = AppRedesign.isInTvMode();
      }
      this.item.bind('update', this.refresh);
      this.item.bind('dashboard-no-longer-current', this.dashboardNoLongerCurrent);
      this.item.bind('dashboard-made-current', this.dashboardMadeCurrent);
      this.item.bind('destroy', this.release);
      this.item.bind('filter-permissions-changed', this.renderDashboardSettings);
      App.Dashboard.bind('update-empty-message', this.updateLoadingComplete);
      App.Dashboard.bind('scroll-to-el', this.scrollToEl);
      App.Dashboard.bind('scroll-to-el-while-resizing', this.scrollToElWhileResizing);
      App.Widget.bind("create destroy", this.updateEmptyMessage);
      App.Widget.bind('move-dashboards', this.updateEmptyMessage);
      AppRedesign.current().bind('text-box-drawing-mode-changed', this.textBoxDrawingModeChanged);
      if (this.item.active) {
        this.dashboardMadeCurrent();
      }
      this.scroller = this.mainContent;
    }

    RedesignDashboardsController.prototype.release = function() {
      var ref, ref1;
      this.item.unbind('dashboard-made-current', this.dashboardMadeCurrent);
      this.item.unbind('dashboard-no-longer-current', this.dashboardNoLongerCurrent);
      this.item.unbind('update', this.refresh);
      this.item.unbind('destroy', this.release);
      this.item.unbind('filter-permissions-changed', this.renderDashboardSettings);
      App.Dashboard.unbind('update-empty-message', this.updateEmptyMessage);
      App.Dashboard.unbind('scroll-to-el', this.scrollToEl);
      App.Dashboard.unbind('scroll-to-el-while-resizing', this.scrollToElWhileResizing);
      App.Widget.unbind("create destroy", this.updateEmptyMessage);
      App.Widget.unbind('move-dashboards', this.updateEmptyMessage);
      if ((ref = this.chartsController) != null) {
        ref.unbind('released-layout-controller', this.release);
      }
      this.releaseDashboardSettings();
      if ((ref1 = this.textboxDrawingController) != null) {
        ref1.release();
      }
      this.trigger('released', this.item);
      return RedesignDashboardsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardsController.prototype.render = function() {
      App.Lagotron.addContext("dashboardRender");
      this.gridRowCount = 0;
      this.html(this.view('redesign/dashboards/dashboard')({
        dashboard: this.item
      }));
      this.el.toggleClass('active', this.item.isActive());
      this.el.toggleClass('archived', this.item.isArchived());
      this.$('.app-footer').append(this.view('redesign/dashboards/powered_by')());
      this.chartsController = new App.RedesignDashboardLayoutController({
        dashboard: this.item
      }).bind('chart-added', this.updateEmptyMessage);
      this.chartsController.bind('released-layout-controller', this.release);
      this.bubbles(this.chartsController, 'edit-widget');
      this.mainContent.append(this.chartsController.el);
      return this.mainDashboardContentRendered = true;
    };

    RedesignDashboardsController.prototype.textBoxDrawingModeChanged = function() {
      var ref;
      if (AppRedesign.current().newTextBoxDrawingMode) {
        this.textboxDrawingController = new App.TextboxDrawingController({
          dashboardLayoutController: this.chartsController,
          mainContent: this.mainContent
        });
        this.bubbles(this.textboxDrawingController, 'create-new-text-box');
        this.addTextOnDashCursor();
        this.filtersWrapper.on('mousedown', this.removeTextboxDrawingMode);
        return this.dashboardHeader.on('mousedown', this.removeTextboxDrawingMode);
      } else {
        if ((ref = this.textboxDrawingController) != null) {
          ref.release();
        }
        this.removeTextOnDashCursor();
        this.filtersWrapper.off('mousedown', this.removeTextboxDrawingMode);
        return this.dashboardHeader.off('mousedown', this.removeTextboxDrawingMode);
      }
    };

    RedesignDashboardsController.prototype.removeTextboxDrawingMode = function() {
      return AppRedesign.current().setTextBoxDrawingMode(false);
    };

    RedesignDashboardsController.prototype.addTextOnDashCursor = function() {
      this.el.addClass('text-on-dash-cursor');
      this.mainContent.addClass('text-on-dash-cursor');
      return this.filtersWrapper.find('.filters-bar').addClass('text-on-dash-cursor');
    };

    RedesignDashboardsController.prototype.removeTextOnDashCursor = function() {
      this.el.removeClass('text-on-dash-cursor');
      this.mainContent.removeClass('text-on-dash-cursor');
      return this.filtersWrapper.find('.filters-bar').removeClass('text-on-dash-cursor');
    };

    RedesignDashboardsController.prototype.renderDashboardSettings = function() {
      this.releaseDashboardSettings();
      this.renderOrRemovePDFGuideline();
      this.dashboardHeader.toggleClass('no-filters', !this.item.filtersEnabled());
      if (this.shouldHideFilters()) {
        if (AppRedesign.current().shared_mode) {
          AppRedesign.current().setupScreenshotMode();
        }
      } else {
        this.refreshElements();
        this.dashboardSettingsController = new App.RedesignDashboardSettingsController({
          dashboard: this.item
        });
        return this.filtersWrapper.append(this.dashboardSettingsController.el);
      }
    };

    RedesignDashboardsController.prototype.renderOrRemovePDFGuideline = function() {
      if (App.Site.first().isPDFDownloadEnabled()) {
        this.chartsController.renderPrintFriendlyLabel();
        this.chartsController.renderPDFGuideline();
        return this.chartsController.updateGridLines();
      } else {
        this.chartsController.removePrintFriendlyLabel();
        return this.chartsController.removePDFGuideline();
      }
    };

    RedesignDashboardsController.prototype.renderDashboardHeader = function() {
      var ref;
      if ((ref = this.dashboardHeaderController) != null) {
        ref.release();
      }
      if (AppRedesign.current().shared_mode || AppRedesign.current().pdf_mode) {
        this.dashboardHeaderController = new App.RedesignSharedDashboardHeaderController({
          dashboard: this.item,
          hideLogo: this.isHidePeriscopeLogo()
        });
      } else {
        this.dashboardHeaderController = new App.RedesignDashboardHeaderController({
          dashboard: this.item
        });
        this.bubbles(this.dashboardHeaderController, 'text-box-icon-clicked');
        this.bubbles(this.dashboardHeaderController, 'new-widget');
      }
      this.dashboardHeader.append(this.dashboardHeaderController.el);
      this.dashboardHeader.toggleClass('no-filters', !this.item.filtersEnabled());
      return this.dashboardHeaderController.render();
    };

    RedesignDashboardsController.prototype.isHidePeriscopeLogo = function() {
      return AppRedesign.current().pdf_mode && AppRedesign.current().state.Site.whitelabelled_embedded_dashboards_enabled;
    };

    RedesignDashboardsController.prototype.releaseDashboardSettings = function() {
      var ref, ref1;
      if ((ref = this.chartsController) != null) {
        ref.unbind('update-empty-message', this.updateEmptyMessage);
      }
      if ((ref1 = this.dashboardSettingsController) != null) {
        ref1.release();
      }
      delete this.dashboardSettingsController;
      if (!this.item.isVisibleToCurrentUser()) {
        return this.switchToFirstVisibleDashboard();
      }
    };

    RedesignDashboardsController.prototype.switchToFirstVisibleDashboard = function() {
      var dashboard, i, len, ref;
      ref = App.Dashboard.all();
      for (i = 0, len = ref.length; i < len; i++) {
        dashboard = ref[i];
        if (dashboard.isVisibleToCurrentUser()) {
          App.RouteHelper.navigateTo('Dashboard', dashboard);
          return;
        }
      }
      return this.orphanUser();
    };

    RedesignDashboardsController.prototype.orphanUser = function() {
      this.item.makeNotCurrent();
      return App.Dashboard.trigger('dashboard-orphaned');
    };

    RedesignDashboardsController.prototype.shouldHideFilters = function() {
      if (AppRedesign.current().pdf_mode && this.item.filtersEnabled()) {
        return false;
      }
      return (AppRedesign.current().shared_mode && !AppRedesign.current().shared_filter_mode) || !this.item.filtersEnabled();
    };

    RedesignDashboardsController.prototype.dashboardMadeCurrent = function() {
      if (!this.mainDashboardContentRendered) {
        this.render();
      }
      return setTimeout((function(_this) {
        return function() {
          _this.renderDashboardHeader();
          if (_this.mainDashboardContentRendered) {
            _this.renderDashboardSettings();
          }
          if (!_this.item.isArchived()) {
            _this.showLoadingSpinner();
          }
          _this.hideDashboardLoadingMessageIfLoaded();
          if (!App.Utils.isClientId(_this.item.id)) {
            return AppRedesign.current().startScreenTransitionAnimation();
          }
        };
      })(this));
    };

    RedesignDashboardsController.prototype.hideDashboardLoadingMessageIfLoaded = function() {
      if ((AppRedesign.current() != null) && (this.item.isCompletelyLoaded() || AppRedesign.current().shared_mode)) {
        if (AppRedesign.current().shared_mode) {
          App.Site.trigger('request-several-updates');
          setTimeout(((function(_this) {
            return function() {
              if (App.Widget.count() > 0) {
                return _this.updateLoadingComplete();
              }
            };
          })(this)), 100);
          return setTimeout(this.updateLoadingComplete, 5000);
        } else {
          return this.updateLoadingComplete();
        }
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.hideDashboardLoadingMessageIfLoaded();
          };
        })(this)), 50);
      }
    };

    RedesignDashboardsController.prototype.dashboardNoLongerCurrent = function() {
      clearInterval(this.widgetInterval);
      return setTimeout((function(_this) {
        return function() {
          return _this.releaseDashboardSettings();
        };
      })(this));
    };

    RedesignDashboardsController.prototype.updateChildren = function(dashUpdate) {
      var ref, widgetIds;
      widgetIds = dashUpdate.widgets.unique();
      if ((ref = this.chartsController) != null) {
        ref.refreshWidgets(widgetIds);
      }
      if (dashUpdate.dashboard != null) {
        return this.refresh();
      }
    };

    RedesignDashboardsController.prototype.refresh = function() {
      var ref;
      this.item.reload();
      if ((ref = this.dashboardHeaderController) != null) {
        ref.render();
      }
      return this.el.toggleClass('active', this.item.isActive());
    };

    RedesignDashboardsController.prototype.scrollToEl = function(el, inEditron) {
      var args, elLeft, elScrollBottom, elScrollLeft, elScrollRight, elScrollTop, elTop, ref, ref1;
      args = {};
      if (inEditron) {
        args.animate = false;
      }
      this.scroller = inEditron ? el.closest('.chart-area') : this.mainContent;
      elTop = el.position().top;
      elLeft = el.position().left;
      elScrollTop = elTop + el.offsetParent().position().top;
      elScrollBottom = elScrollTop + el.height();
      elScrollLeft = elLeft + el.offsetParent().position().left;
      elScrollRight = elScrollLeft + el.width();
      if (args.vertical == null) {
        args.vertical = (ref = this.moveNegativeIfOutsideWindow(elScrollTop)) != null ? ref : this.movePositiveIfOutsideWindow(elScrollTop, elScrollBottom, this.scroller.height());
      }
      if (args.horizontal == null) {
        args.horizontal = (ref1 = this.moveNegativeIfOutsideWindow(elScrollLeft)) != null ? ref1 : this.movePositiveIfOutsideWindow(elScrollLeft, elScrollRight, this.scroller.width());
      }
      if ((args.vertical != null) || (args.horizontal != null)) {
        return this.scroll(args);
      }
    };

    RedesignDashboardsController.prototype.scrollToElWhileResizing = function(el, inEditron) {
      var args, elLeft, elScrollBottom, elScrollLeft, elScrollRight, elScrollTop, elTop;
      args = {
        animate: false
      };
      this.scroller = inEditron ? el.closest('.chart-area') : this.mainContent;
      elTop = el.position().top;
      elLeft = el.position().left;
      elScrollTop = elTop + el.offsetParent().position().top;
      elScrollBottom = elScrollTop + el.height();
      elScrollLeft = elLeft + el.offsetParent().position().left;
      elScrollRight = elScrollLeft + el.width();
      if (args.vertical == null) {
        args.vertical = this.movePositiveIfOutsideWindow(elScrollTop, elScrollBottom, this.scroller.height());
      }
      if (args.horizontal == null) {
        args.horizontal = this.movePositiveIfOutsideWindow(elScrollLeft, elScrollRight, this.scroller.width());
      }
      if ((args.vertical != null) || (args.horizontal != null)) {
        return this.scroll(args);
      }
    };

    RedesignDashboardsController.prototype.moveNegativeIfOutsideWindow = function(positiveElPosition) {
      if (positiveElPosition < 0) {
        return positiveElPosition - App.RedesignDashboardsController.PRETTY_BUFFER_SIZE_PX;
      } else {
        return void 0;
      }
    };

    RedesignDashboardsController.prototype.movePositiveIfOutsideWindow = function(positiveElPosition, negativeElPosition, viewPane) {
      var difference;
      difference = negativeElPosition - viewPane;
      if (difference > 0) {
        return difference + App.RedesignDashboardsController.PRETTY_BUFFER_SIZE_PX;
      } else {
        return void 0;
      }
    };

    RedesignDashboardsController.prototype.scroll = function(args) {
      var horizontalScrollDistance, verticalScrollDistance;
      verticalScrollDistance = this.scroller.scrollTop() + args.vertical;
      horizontalScrollDistance = this.scroller.scrollLeft() + args.horizontal;
      if (args.animate === false) {
        if (args.vertical != null) {
          this.scroller.scrollTop(verticalScrollDistance);
        }
        if (args.horizontal != null) {
          return this.scroller.scrollLeft(horizontalScrollDistance);
        }
      } else {
        if (args.vertical != null) {
          this.scroller.animate({
            scrollTop: verticalScrollDistance
          });
        }
        if (args.horizontal != null) {
          return this.scroller.animate({
            scrollLeft: horizontalScrollDistance
          });
        }
      }
    };

    RedesignDashboardsController.prototype.showLoadingSpinner = function() {
      if (!this.chartsLoaded) {
        return this.dashLoaderEl.fadeIn();
      }
    };

    RedesignDashboardsController.prototype.updateLoadingComplete = function() {
      this.chartsLoaded = true;
      if (this.mainDashboardContentRendered) {
        return this.hideLoadingMessage();
      }
    };

    RedesignDashboardsController.prototype.hideLoadingMessage = function() {
      return this.dashLoaderEl.fadeOut(this.updateEmptyMessage);
    };

    RedesignDashboardsController.prototype.updateEmptyMessage = function() {
      return this.emptyDashMessage.toggle(_.isEmpty(this.item.widgets()));
    };

    RedesignDashboardsController.prototype.mainContentScroll = function() {
      var ref;
      if ((ref = this.chartsController) != null) {
        ref.resetWidgetRenderInterval(false, 50);
      }
      return App.RedesignDashboardsController.lastDashboardScroll = AppRedesign.timestamp();
    };

    RedesignDashboardsController.timeSinceLastDashboardScroll = function() {
      return AppRedesign.timestamp() - this.lastDashboardScroll;
    };

    RedesignDashboardsController.setResizeDragInProgress = function() {
      return this.resizeDragInProgress = true;
    };

    RedesignDashboardsController.clearResizeDragInProgress = function() {
      return this.resizeDragInProgress = false;
    };

    RedesignDashboardsController.isResizeDragInProgress = function() {
      return this.resizeDragInProgress;
    };

    RedesignDashboardsController.switchToDashboard = function(dashboard, widgetId) {
      if (widgetId == null) {
        widgetId = null;
      }
      App.RouteHelper.navigateTo('Dashboard', dashboard);
      if (widgetId !== null && widgetId !== -1) {
        return dashboard.trigger('scroll-to-widget', widgetId);
      }
    };

    return RedesignDashboardsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDataDiscoverySettingsController = (function(superClass) {
    extend(RedesignDataDiscoverySettingsController, superClass);

    RedesignDataDiscoverySettingsController.prototype.className = 'data-discovery-settings';

    function RedesignDataDiscoverySettingsController() {
      this.publishAsDatasetStateChanged = bind(this.publishAsDatasetStateChanged, this);
      RedesignDataDiscoverySettingsController.__super__.constructor.apply(this, arguments);
      if (AppRedesign.dragDropEnabled()) {
        App.Utils.requires(this, 'item');
        this.render();
      }
    }

    RedesignDataDiscoverySettingsController.prototype.release = function() {
      if (AppRedesign.dragDropEnabled()) {
        this.publishAsDatasetToggle.release();
      }
      return RedesignDataDiscoverySettingsController.__super__.release.apply(this, arguments);
    };

    RedesignDataDiscoverySettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/data_discovery_settings')());
      this.toggleArea = this.el.find('.toggles-area');
      this.publishAsDatasetToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.hasDataset(),
        labelWhenToggleOn: 'Publish as Dataset',
        labelWhenToggleOff: 'Publish as Dataset'
      });
      this.publishAsDatasetToggle.el.addClass('publish-as-dataset');
      this.toggleArea.append(this.publishAsDatasetToggle.el);
      return this.publishAsDatasetToggle.bind('toggled', this.publishAsDatasetStateChanged);
    };

    RedesignDataDiscoverySettingsController.prototype.hasDataset = function() {
      return _.some(App.Dataset.all(), {
        explorable_id: this.item.id,
        explorable_type: this.item.constructor.className
      });
    };

    RedesignDataDiscoverySettingsController.prototype.publishAsDatasetStateChanged = function(toggleState) {
      this.item.has_dataset = toggleState;
      return this.triggerOnce('right-panel-settings-changed');
    };

    return RedesignDataDiscoverySettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignDataTable = (function(superClass) {
    extend(RedesignDataTable, superClass);

    RedesignDataTable.prototype.className = 'data-table';

    RedesignDataTable.prototype.elements = {
      '.rows': 'rows',
      '.rows-wrapper': 'rowsWrapper',
      '.header-row': 'headerRow',
      '.no-rows-message': 'noRowsMessage',
      '.table-border': 'tableBorder'
    };

    RedesignDataTable.prototype.events = {
      'click .header-row.last .ninja-header:not(.index)': 'handleHeaderClick',
      'mouseenter .ninja-cell': 'cellMouseEnter',
      'mouseleave .ninja-cell': 'cellMouseLeave'
    };

    RedesignDataTable.GRID_MAX_DISPLAY_CHARS = 120;

    RedesignDataTable.GRID_MAX_DISPLAY_CHARS_TOOLTIP = RedesignDataTable.GRID_MAX_DISPLAY_CHARS * 10;

    RedesignDataTable.HOVER_TOOLTIP_TIMEOUT = 1000;

    RedesignDataTable.PADDING_OFFSET = 13;

    RedesignDataTable.GRID_INDEX_COL_WIDTH = 27 + RedesignDataTable.PADDING_OFFSET;

    RedesignDataTable.EDITOR_BOX_PADDING = 24;

    RedesignDataTable.GRID_INDEX_COL_LEFT_OFFSET = 40;

    RedesignDataTable.ROW_HEIGHT = 25;

    RedesignDataTable.HEADER_HEIGHT = 30;

    RedesignDataTable.TABLE_TITLE_HEIGHT = 0;

    RedesignDataTable.TOTAL_HEADER_HEIGHT = RedesignDataTable.HEADER_HEIGHT + RedesignDataTable.TABLE_TITLE_HEIGHT;

    RedesignDataTable.SINGLE_CELL_HEIGHT = 25;

    RedesignDataTable.CHILDREN_SIZE = '__periscope_children_size';

    RedesignDataTable.COLLAPSED_STATE = '__periscope_collapsed';

    RedesignDataTable.LEVEL = "__periscope_level";

    RedesignDataTable.PARENT_ID = "__periscope_parent_id";

    RedesignDataTable.LEVEL_INDENT_INCREMENT = 15;

    RedesignDataTable.NEST_ARROW_WIDTH = 13;

    RedesignDataTable.SETDATA_TIMEOUT_SECS = 3;

    RedesignDataTable.DATA_TAB_HEIGHT = 640;

    RedesignDataTable.SORT_ICON_GUTTER = 24;

    RedesignDataTable.EXTRA_ROW_TO_RENDER = 5;

    RedesignDataTable.prototype.pointCols = function() {
      return [];
    };

    RedesignDataTable.prototype.segmentCols = function() {
      return [];
    };

    RedesignDataTable.prototype.valueCols = function() {
      return this.columns;
    };

    RedesignDataTable.getColumnTwiddleFromTwiddles = function(twiddles, column, twiddle) {
      var seriesTwiddle;
      seriesTwiddle = twiddles.getForSeries(column, twiddle);
      if (seriesTwiddle != null) {
        return seriesTwiddle;
      }
      return twiddles.getForColumn(column, twiddle);
    };

    function RedesignDataTable() {
      this.showHoverTooltip = bind(this.showHoverTooltip, this);
      this.cellMouseLeave = bind(this.cellMouseLeave, this);
      this.cellMouseEnter = bind(this.cellMouseEnter, this);
      this.render = bind(this.render, this);
      this.resetRenderingState = bind(this.resetRenderingState, this);
      this.handleHeaderClick = bind(this.handleHeaderClick, this);
      this.generateHeader = bind(this.generateHeader, this);
      this.renderRow = bind(this.renderRow, this);
      this.handleViewportChange = bind(this.handleViewportChange, this);
      this.markSortOrder = bind(this.markSortOrder, this);
      this.sortAllRows = bind(this.sortAllRows, this);
      this.updateSortState = bind(this.updateSortState, this);
      this.sortByColumn = bind(this.sortByColumn, this);
      this.doRender = bind(this.doRender, this);
      var ref;
      RedesignDataTable.__super__.constructor.apply(this, arguments);
      this.noBodyBorder = ((ref = AppRedesign.current().state) != null ? ref.border : void 0) === 'off';
    }

    RedesignDataTable.prototype.unrender = function() {
      this.$el.empty();
      return this.destroy();
    };

    RedesignDataTable.prototype.setDataAndNestedColumns = function(rows, columns) {
      var column, nestedColumns;
      nestedColumns = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = columns.length; j < len; j++) {
          column = columns[j];
          results.push(App.PivotTableHelper.createLeaf(column, column));
        }
        return results;
      })();
      return this.setData(rows, columns, nestedColumns);
    };

    RedesignDataTable.prototype.setData = function(rows, columns, nestedColumns) {
      this.rawRows = rows;
      this.columns = columns;
      this.nestedColumns = nestedColumns;
      return this.processData();
    };

    RedesignDataTable.prototype.setDataFromChartData = function(chartData) {
      this.setDataAndNestedColumns(chartData.rows, chartData.columns);
      this.processData();
      return this.twiddles = chartData.twiddlesActual;
    };

    RedesignDataTable.prototype.processData = function() {
      this.unformattedColumns = [];
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.colsOnPage = {};
      this.sortedByColumn = null;
      this.sortedByColumnIndex = -1;
      this.sortDirection = 1;
      this.allSortedRawRows = jQuery.extend([], true, this.rawRows);
      this.processedRows = {};
      this.formatter = App.ChartFormatters.tableCellFormatter;
      return this.columnWidthMap = {};
    };

    RedesignDataTable.prototype.destroy = function() {
      var ref;
      if ((ref = this.rowsWrapper[0]) != null) {
        ref.onscroll = null;
      }
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.colsOnPage = {};
      this.rawRows = [];
      this.allSortedRawRows = [];
      this.processedRows = {};
      this.columnWidthCache = {};
      delete this.nestedRows;
      return delete this.nestedColumns;
    };

    RedesignDataTable.prototype.doRender = function() {
      this.noRowsMessage.toggle(this.allSortedRawRows.length === 0);
      this.rowsWrapper.scrollTop(0);
      this.resetRenderingState();
      this.rows.html('');
      this.handleViewportChange();
      return this.updateRowsHeight();
    };

    RedesignDataTable.prototype.sortByColumn = function(sortColumnIndex) {
      this.markSortOrder();
      this.updateSortState(sortColumnIndex);
      this.sortAllRows();
      this.resetRenderingState();
      this.leftOffset = this.rowsWrapper.scrollLeft();
      this.render();
      return this.setSearchColumnClass();
    };

    RedesignDataTable.prototype.setSearchColumnClass = function() {
      var lastHeaderRow;
      lastHeaderRow = this.headerRow.last();
      lastHeaderRow.find("[headerIndex]").removeClass("sort");
      return lastHeaderRow.find("[headerIndex=" + this.sortedByColumnIndex + "]").addClass(this.sortDirection != null ? 'sort' : void 0);
    };

    RedesignDataTable.prototype.updateSortState = function(sortColumnIndex) {
      var sortColumn;
      sortColumn = this.columns[sortColumnIndex];
      if (sortColumn === this.sortedByColumn) {
        return this.sortDirection = -this.sortDirection;
      } else {
        this.sortedByColumn = sortColumn;
        this.sortedByColumnIndex = sortColumnIndex;
        return this.sortDirection = 1;
      }
    };

    RedesignDataTable.prototype.isDataNumeric = function(allSortedRawRows, sortedByColumn) {
      var isDataNumeric, j, len, row, val;
      isDataNumeric = true;
      for (j = 0, len = allSortedRawRows.length; j < len; j++) {
        row = allSortedRawRows[j];
        val = row[sortedByColumn];
        isDataNumeric && (isDataNumeric = App.PivotTableHelper.setPeriscopeSortProperty(row, val));
        if (!isDataNumeric) {
          break;
        }
      }
      return isDataNumeric;
    };

    RedesignDataTable.prototype.sortAllRows = function() {
      var isDataNumeric, j, k, len, len1, ref, ref1, results, row;
      if (this.nestedRows != null) {
        ref = this.nestedRows;
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          App.PivotTableHelper.setNestedPeriscopeSortProperty(row, this.sortedByColumn);
        }
        App.PivotTableHelper.sortNestedRows(this.nestedRows, this.sortDirection, this.sortedByColumn);
        this.allSortedRawRows = [];
        ref1 = this.nestedRows;
        results = [];
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          row = ref1[k];
          results.push(this.traverseNestedRows(row, [], -1, this.allSortedRawRows));
        }
        return results;
      } else {
        isDataNumeric = this.isDataNumeric(this.allSortedRawRows, this.sortedByColumn);
        return this.allSortedRawRows.sort(App.PivotTableHelper.sortRows(isDataNumeric, this.sortDirection, this.sortedByColumn));
      }
    };

    RedesignDataTable.prototype.markSortOrder = function() {
      var i, j, len, ref, results, row;
      ref = this.allSortedRawRows;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        row = ref[i];
        results.push(row.periscopeLastIndex = i);
      }
      return results;
    };

    RedesignDataTable.prototype.errorDetails = function(columns) {
      var details, hash_key, ref, ref1;
      if (columns == null) {
        columns = [];
      }
      details = [];
      details.push("widget_id:" + ((ref = this.widget) != null ? ref.id : void 0));
      hash_key = (ref1 = this.widget) != null ? ref1.sqlWidgetFormulaSourceHashKey() : void 0;
      if (hash_key != null) {
        details.push("hash_key:" + hash_key);
      }
      if (columns != null) {
        details.push("columns:" + (columns.join(',')));
      }
      if (this.allSortedRawRows != null) {
        details.push("num_displayed_rows:" + this.allSortedRawRows.length);
      }
      if (this.allSortedRawRows != null) {
        details.push("num_all_rows:" + this.allSortedRawRows.length);
      }
      return "\n" + details.join("\n");
    };

    RedesignDataTable.prototype.handleViewportChange = function(e) {
      var colsOnPageChanged, contentStart, el, i, j, k, len, parent_widget_container, purgeDownTo, purgeUpTo, ref, ref1, ref2, ref3, ref4, row, rowBatchEl, rowIndex, scrollTop, target_width, viewportHeight, wrapper, wrapperHeight;
      App.Utils.initRedesignCanvasWidthSizer();
      wrapper = this.rowsWrapper[0];
      parent_widget_container = this.parentWidgetContent();
      target_width = (ref = parent_widget_container != null ? parent_widget_container.width() : void 0) != null ? ref : 0;
      ref1 = this.headerRow;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        row = ref1[i];
        row.style.left = -wrapper.scrollLeft + "px";
        row.style.top = i * this.constructor.HEADER_HEIGHT + "px";
      }
      if (this.noBodyBorder && target_width > this.totalColumnWidth) {
        this.tableBorder[0].style.left = -wrapper.scrollLeft + "px";
      }
      scrollTop = wrapper.scrollTop;
      wrapperHeight = this.targetHeight() - this.constructor.HEADER_HEIGHT;
      if (AppRedesign.isNewLook()) {
        wrapperHeight += 12;
      }
      purgeDownTo = Math.max(0, Math.floor(scrollTop / this.constructor.ROW_HEIGHT) - this.constructor.EXTRA_ROW_TO_RENDER);
      contentStart = Math.floor(scrollTop / this.constructor.ROW_HEIGHT);
      viewportHeight = Math.floor(wrapperHeight / this.constructor.ROW_HEIGHT);
      purgeUpTo = Math.min(contentStart + viewportHeight + this.constructor.EXTRA_ROW_TO_RENDER, this.allSortedRawRows.length);
      if (this.lastScrollLeft !== wrapper.scrollLeft || this.lastRowWrapperWidth !== this.rowsWrapper.width()) {
        colsOnPageChanged = this.updateColsOnPage();
        this.lastScrollLeft = wrapper.scrollLeft;
        this.lastRowWrapperWidth = this.rowsWrapper.width();
      }
      ref2 = this.rowsOnPage;
      for (rowIndex in ref2) {
        el = ref2[rowIndex];
        if (rowIndex < purgeDownTo || rowIndex > purgeUpTo || colsOnPageChanged) {
          el.parentNode.removeChild(el);
          delete this.rowsOnPage[rowIndex];
        }
      }
      if (colsOnPageChanged) {
        this.renderedEls = {};
      }
      rowBatchEl = document.createElement("div");
      rowBatchEl.className = "row-batch";
      for (i = k = ref3 = purgeDownTo, ref4 = purgeUpTo; ref3 <= ref4 ? k < ref4 : k > ref4; i = ref3 <= ref4 ? ++k : --k) {
        if (this.rowsOnPage[i]) {
          continue;
        }
        row = this.renderRow(i);
        if (!row) {
          break;
        }
        rowBatchEl.appendChild(row);
        this.rowsOnPage[i] = row;
      }
      return this.rows.append(rowBatchEl);
    };

    RedesignDataTable.prototype.updateColsOnPage = function() {
      var colsOnPageChanged, column, currentColLeft, i, indexWidth, j, len, ref, scrollLeft, showCol, wrapperWidth;
      colsOnPageChanged = false;
      currentColLeft = 0;
      wrapperWidth = this.rowsWrapper.width();
      scrollLeft = this.rowsWrapper[0].scrollLeft;
      indexWidth = this.indexColWidth();
      ref = this.columns;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        column = ref[i];
        showCol = true;
        if ((wrapperWidth + scrollLeft < currentColLeft) || (currentColLeft + this.rawColumnWidths[i] + indexWidth < scrollLeft)) {
          showCol = false;
        }
        if (this.colsOnPage[i] !== showCol) {
          colsOnPageChanged = true;
          this.colsOnPage[i] = showCol;
        }
        currentColLeft += this.rawColumnWidths[i];
      }
      return colsOnPageChanged;
    };

    RedesignDataTable.prototype.widgetHeight = function() {
      return this.constructor.DATA_TAB_HEIGHT;
    };

    RedesignDataTable.prototype.calcIndexWidth = function() {
      var index;
      index = this.indexColWidth();
      return this.indexWidth = index;
    };

    RedesignDataTable.prototype.extractValueCol = function(column, twiddles) {
      return App.PivotTableHelper.extractValueCol(column, twiddles);
    };

    RedesignDataTable.prototype.renderRow = function(rowIndex) {
      var borderClass, cell, cellBorderClass, column, el, html, i, indexBorderClass, isEvenRow, j, len, paddingLeft, ref, ref1, ref2, ref3, row, truncatedValue, value, valueIsNumeric, valueStr;
      if (this.renderedEls[rowIndex]) {
        return this.renderedEls[rowIndex];
      }
      if (this.valueCols().length === 0) {
        return;
      }
      el = document.createElement("div");
      isEvenRow = rowIndex % 2 === 0;
      el.className = "row " + (isEvenRow ? 'even' : 'odd');
      html = [];
      borderClass = 'right-border';
      if (this.renderIndex) {
        indexBorderClass = borderClass;
        if (this.centerAlign()) {
          indexBorderClass = 'right-border';
        }
        html.push(this.view('redesign/ninja_grid/data_table_ninja_cell')({
          val: rowIndex + 1,
          cssClassName: "index",
          left: this.addUnits(0),
          borderClass: indexBorderClass,
          top: this.constructor.ROW_HEIGHT * rowIndex,
          width: this.indexWidth + 'px'
        }));
      }
      row = this.processRow(rowIndex);
      ref = this.columns;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        column = ref[i];
        if (!this.colsOnPage[i]) {
          continue;
        }
        value = row[column] != null ? row[column]["value"] : "";
        valueStr = '' + value;
        valueIsNumeric = this.twiddles.getForColumn(column, 'type') === 'numeric';
        truncatedValue = ((ref1 = row[column]) != null ? ref1["linkName"] : void 0) != null ? row[column]["linkName"] : valueStr;
        if (truncatedValue.length > this.constructor.GRID_MAX_DISPLAY_CHARS) {
          truncatedValue = truncatedValue.substr(0, this.constructor.GRID_MAX_DISPLAY_CHARS) + "...";
        }
        cellBorderClass = borderClass;
        if (i === this.columns.length - 1) {
          cellBorderClass = '';
        }
        paddingLeft = (ref2 = row[column]) != null ? ref2['paddingLeft'] : void 0;
        cell = this.view('redesign/ninja_grid/data_table_ninja_cell')({
          isLink: (ref3 = row[column]) != null ? ref3["isLink"] : void 0,
          fullValue: valueStr,
          val: truncatedValue,
          cssClassName: " " + (this.cellCssAlignmentClass(column, valueIsNumeric)),
          left: this.leftOffsets[i],
          borderClass: cellBorderClass,
          top: this.constructor.ROW_HEIGHT * rowIndex,
          width: this.columnWidths[i],
          row: rowIndex,
          column: i,
          paddingLeft: paddingLeft
        });
        html.push(cell);
      }
      el.innerHTML = html.join("");
      this.renderedEls[rowIndex] = el;
      return el;
    };

    RedesignDataTable.prototype.isDisplayingSearchResult = function() {
      return this.allSortedRawRows.length < this.allSortedRawRows.length;
    };

    RedesignDataTable.prototype.leftAlign = function() {
      return false;
    };

    RedesignDataTable.prototype.centerAlign = function() {
      return false;
    };

    RedesignDataTable.prototype.cellCssAlignmentClass = function(column, valueIsNumeric) {
      if (valueIsNumeric) {
        return 'right';
      } else {
        return '';
      }
    };

    RedesignDataTable.prototype.generateHeader = function(columnName) {
      return (columnName + '').trim();
    };

    RedesignDataTable.prototype.resize = function() {
      this.resizeRowWrapper();
      return this.handleViewportChange();
    };

    RedesignDataTable.prototype.handleHeaderClick = function(e) {
      if (this.sortingDisabled) {
        return;
      }
      return this.sortByColumn(parseInt($(e.currentTarget).attr("headerIndex")));
    };

    RedesignDataTable.prototype.resetRenderingState = function() {
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.processedRows = {};
      this.lastScrollLeft = null;
      return this.lastRowWrapperWidth = null;
    };

    RedesignDataTable.prototype.resetCollapseState = function() {
      var _, ref, results, row;
      ref = this.allSortedRawRows;
      results = [];
      for (_ in ref) {
        row = ref[_];
        results.push(row[this.constructor.COLLAPSED_STATE] = false);
      }
      return results;
    };

    RedesignDataTable.prototype.render = function() {
      var error, h, totalWidth;
      try {
        App.Utils.initRedesignCanvasWidthSizer();
        this.setColumnWidths();
        this.calcIndexWidth();
        totalWidth = this.totalColumnWidth + 'px';
        h = this.view('redesign/ninja_grid/data_table_ninja_grid')({
          sortedByHeader: this.sortedByColumnIndex,
          totalWidth: totalWidth,
          indexWidth: this.indexWidth + 'px',
          totalHeaders: this.formattedColumnWidths,
          renderIndex: this.renderIndex,
          sortingDisabled: this.sortingDisabled
        });
        this.html(App.Utils.stripSpacesBetweenTags(h));
        this.updateRowsHeight();
        this.resizeRowWrapper();
        if (App.SetUpScreenshotMode.inScreenshotMode()) {
          this.rowsWrapper.addClass('no-animate');
        }
        this.doRender();
        if (this.leftOffset != null) {
          this.rowsWrapper.scrollLeft(this.leftOffset);
        }
        this.refreshElements();
        return this.rowsWrapper[0].onscroll = this.handleViewportChange;
      } catch (error1) {
        error = error1;
        error.message = "" + error.message + (this.errorDetails());
        return AppRedesign.logError(error);
      }
    };

    RedesignDataTable.prototype.updateRowsHeight = function() {
      return this.rows.height(this.constructor.ROW_HEIGHT * this.allSortedRawRows.length);
    };

    RedesignDataTable.prototype.totalHeaderRowHeight = function() {
      var height, j, len, ref, row;
      height = 0;
      ref = this.headerRow;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        height += $(row).height();
      }
      return height;
    };

    RedesignDataTable.prototype.resizeRowWrapper = function() {
      var parent_widget_container, target_width;
      parent_widget_container = this.parentWidgetContainer();
      target_width = parent_widget_container.width();
      this.rowsWrapper[0].style.width = (target_width - this.constructor.EDITOR_BOX_PADDING) + "px";
      this.rowsWrapper[0].style.marginTop = this.formattedColumnWidths.length * this.constructor.HEADER_HEIGHT + "px";
      this.rows.addClass('left-border right-border');
      return this.headerRow.addClass('left-border right-border');
    };

    RedesignDataTable.prototype.parentWidgetContent = function() {
      return this.el;
    };

    RedesignDataTable.prototype.parentWidgetContainer = function() {
      return this.rows.closest('.bottom-box');
    };

    RedesignDataTable.prototype.targetHeight = function() {
      var headerHeight;
      if (this.fixedTargetHeight != null) {
        return this.fixedTargetHeight;
      }
      headerHeight = this.constructor.HEADER_HEIGHT;
      return this.widgetHeight() - headerHeight;
    };

    RedesignDataTable.prototype.indexColWidth = function() {
      if (this.renderIndex) {
        return this.constructor.GRID_INDEX_COL_WIDTH;
      } else {
        return 0;
      }
    };

    RedesignDataTable.prototype.indexColLeftOffset = function() {
      if (this.renderIndex) {
        return this.constructor.GRID_INDEX_COL_LEFT_OFFSET;
      } else {
        return 0;
      }
    };

    RedesignDataTable.prototype.fieldIsCohortValueColumn = function(field) {
      return (this.seriesSet[field] != null) && (this.originalColumnSet[field] == null);
    };

    RedesignDataTable.prototype.processRow = function(rowIndex) {
      var field, isLink, linkName, metafields, newRow, rawRow, raw_val, ref, ref1, ref2, val;
      if (this.processedRows[rowIndex]) {
        return this.processedRows[rowIndex];
      }
      this.unformattedColumnSet = this.unformattedColumns.to_set();
      rawRow = this.allSortedRawRows[rowIndex];
      newRow = {};
      metafields = [this.constructor.LEVEL, this.constructor.COLLAPSED_STATE, this.constructor.CHILDREN_SIZE, this.constructor.PARENT_ID];
      for (field in rawRow) {
        val = rawRow[field];
        if (typeof val === "object") {
          if (val != null) {
            val = val.val;
          }
          if (typeof val === "object" || (val == null)) {
            continue;
          }
        }
        if (indexOf.call(metafields, field) >= 0) {
          continue;
        }
        raw_val = val;
        ref = App.Utils.parseMarkdown(val), isLink = ref.isLink, val = ref.val, linkName = ref.linkName;
        if (typeof val === "string") {
          val = val.escapeHtml();
        }
        if (this.formatter != null) {
          val = this.formatValue(val);
        }
        newRow[field] = {
          value: val,
          raw_value: raw_val,
          isLink: isLink,
          linkName: linkName
        };
        if (linkName && !this.loggedFriendlyLinks) {
          App.Utils.logFeature('friendly-link', {
            widget_id: (ref1 = this.widget) != null ? ref1.id : void 0,
            dashboard_id: (ref2 = App.Dashboard.currentDashboard()) != null ? ref2.id : void 0
          });
          this.loggedFriendlyLinks = true;
        }
      }
      this.processedRows[rowIndex] = newRow;
      return newRow;
    };

    RedesignDataTable.prototype.formatValue = function(val) {
      return this.formatter(val, {
        tableValueFormat: false,
        columnValueFormat: [],
        numDecimals: 6,
        currency: null
      });
    };

    RedesignDataTable.prototype.addUnits = function(number) {
      return number + 'px';
    };

    RedesignDataTable.prototype.getColumnWidthsByLevel = function(nestedColumns, rows) {
      var childWidths, j, len, node, widthInfo;
      widthInfo = [];
      this.leafColumnIndex = 0;
      this.columnWidthCache = {};
      if (nestedColumns == null) {
        return widthInfo;
      }
      for (j = 0, len = nestedColumns.length; j < len; j++) {
        node = nestedColumns[j];
        childWidths = this.getColumnWidthInfo(node.name, rows);
        widthInfo = widthInfo.concat(childWidths);
      }
      return widthInfo;
    };

    RedesignDataTable.prototype.getColumnWidthInfo = function(colName, rows) {
      var calculatedWidth, name, showTotalColumn;
      showTotalColumn = this.pointCols().length === 0 && this.valueCols().length > 0;
      if ((colName == null) && !showTotalColumn) {
        return [];
      }
      calculatedWidth = this.calcColumnWidth(colName, rows);
      calculatedWidth += 25;
      this.leafColumnIndex += 1;
      name = this.generateHeader(colName);
      if (colName == null) {
        name = '';
      }
      return {
        name: name,
        width: calculatedWidth
      };
    };

    RedesignDataTable.prototype.setColumnWidths = function() {
      var columnWidths, i, info, j, k, l, leftOffset, len, len1, rows, startTime, width, widths;
      startTime = App.Utils.timeNowInSecs();
      rows = [];
      if (this.allSortedRawRows != null) {
        for (i = j = 0; j <= 30; i = ++j) {
          if (i >= this.allSortedRawRows.length) {
            break;
          }
          rows.push(this.processRow(i));
        }
      }
      columnWidths = [this.getColumnWidthsByLevel(this.nestedColumns, rows)];
      if (columnWidths.length > 0) {
        this.rawColumnWidths = columnWidths[0].map(function(info) {
          return info.width;
        });
      } else {
        this.rawColumnWidths = [];
      }
      this.totalColumnWidth = this.rawColumnWidths.sum() + this.indexColWidth();
      this.leftOffsets = [];
      leftOffset = this.indexColWidth();
      this.leftOffsets.push(this.addUnits(leftOffset));
      this.formattedColumnWidths = [];
      for (k = 0, len = columnWidths.length; k < len; k++) {
        widths = columnWidths[k];
        if (App.Utils.timeNowInSecs() - this.constructor.SETDATA_TIMEOUT_SECS > startTime) {
          throw new Error(App.Chartographer.ERR_TIMEOUT);
        }
        this.formattedColumnWidths.push([]);
        leftOffset = this.indexColWidth();
        for (l = 0, len1 = widths.length; l < len1; l++) {
          info = widths[l];
          width = info.width;
          leftOffset += width;
          this.leftOffsets.push(this.addUnits(leftOffset));
          this.formattedColumnWidths[0].push({
            name: info.name,
            width: this.addUnits(width)
          });
        }
      }
      if (this.formattedColumnWidths.length > 0) {
        return this.columnWidths = this.formattedColumnWidths[0].map(function(info) {
          return info.width;
        });
      } else {
        return this.columnWidths = [];
      }
    };

    RedesignDataTable.prototype.columnWidthFromName = function(colName) {
      var header_text, header_width;
      header_text = this.generateHeader(colName).toUpperCase();
      if (this.columnWidthCache[header_text] == null) {
        header_width = App.Utils.canvasWidthForText(header_text);
        this.columnWidthCache[header_text] = header_width;
      }
      return this.columnWidthCache[header_text];
    };

    RedesignDataTable.prototype.calcColumnWidth = function(colName, rows) {
      var cell, i, j, mapping, maxWidth, row, str, value, width;
      maxWidth = this.columnWidthFromName(colName);
      mapping = colName;
      for (i = j = 0; j <= 29; i = ++j) {
        if (i > rows.length - 1) {
          break;
        }
        row = rows[i];
        if ((row == null) || !(row[mapping] != null)) {
          continue;
        }
        cell = row[mapping] || row[mapping.toLowerCase()];
        value = cell["raw_value"];
        if ($.isNumeric(value)) {
          value = cell["value"];
        }
        if (cell["linkName"]) {
          value = cell["linkName"];
        }
        str = (value + "").substr(0, this.constructor.GRID_MAX_DISPLAY_CHARS);
        width = Math.ceil(App.Utils.canvasWidthForText(str)) + 1;
        if (width > maxWidth) {
          maxWidth = width;
        }
      }
      return maxWidth + this.constructor.PADDING_OFFSET;
    };

    RedesignDataTable.prototype.cellMouseEnter = function(e) {
      clearTimeout(this.hoverTimeout);
      return this.hoverTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.showHoverTooltip($(e.target));
        };
      })(this)), this.constructor.HOVER_TOOLTIP_TIMEOUT);
    };

    RedesignDataTable.prototype.cellMouseLeave = function() {
      var ref;
      clearTimeout(this.hoverTimeout);
      return (ref = this.hoverTooltip) != null ? ref.closeAndRelease() : void 0;
    };

    RedesignDataTable.prototype.showHoverTooltip = function(target) {
      var cellWidth, fullValueWidth, ref, targetOffset, targetWidth, tooltipValue;
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      targetOffset = target.offset();
      tooltipValue = this.tooltipValueForCell(target);
      if (!tooltipValue) {
        return;
      }
      fullValueWidth = App.Utils.canvasWidthForText(tooltipValue);
      targetWidth = target.width();
      if (target.hasClass('level1') || target.hasClass('level2')) {
        fullValueWidth += this.constructor.NEST_ARROW_WIDTH;
        targetWidth = target.outerWidth();
      }
      if (fullValueWidth <= targetWidth) {
        return;
      }
      cellWidth = target.outerWidth();
      return this.hoverTooltip = App.RedesignTooltipPanel.addPanel({
        contentEl: null,
        description: tooltipValue,
        extraClass: 'light-theme',
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        width: (cellWidth + 30) + "px"
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, App.RedesignTooltipPanel.CENTER_POINTER, targetOffset.left + cellWidth / 2, targetOffset.top + 15);
    };

    RedesignDataTable.prototype.tooltipValueForCell = function(targetCell) {
      var columnId, rowId, val;
      if (!targetCell) {
        return "";
      }
      val = null;
      try {
        rowId = parseInt(targetCell.attr('row'));
        columnId = parseInt(targetCell.attr('column'));
        val = this.processedRows[rowId][this.columns[columnId]].value;
      } catch (error1) {
        val = null;
      }
      if (val == null) {
        val = targetCell.text().trim();
      }
      if (val.length > this.GRID_MAX_DISPLAY_CHARS_TOOLTIP) {
        val = val.substr(0, this.GRID_MAX_DISPLAY_CHARS_TOOLTIP) + '...';
      }
      return val;
    };

    return RedesignDataTable;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDateRangeDimensionSetting = (function(superClass) {
    extend(RedesignDateRangeDimensionSetting, superClass);

    RedesignDateRangeDimensionSetting.prototype.elements = {
      '.date-range-dropdown': 'dateRangeDropdown',
      '.aggregation-dropdown .options': 'aggregationOptions',
      '.date-range-dropdown .options': 'dateRangeOptions',
      '.date-range-dropdown .range-start': 'dateRangeOptionRangeStart',
      '.date-range-dropdown .range-end': 'dateRangeOptionRangeEnd',
      '.custom-date-option': 'customDateOptionEl',
      '.other-options': 'otherOptionsEl'
    };

    RedesignDateRangeDimensionSetting.prototype.events = {
      'keyup .date-range-dropdown .redesign-input': 'updateFromDateRangeCustomRangeBoxen',
      'blur  .date-range-dropdown .redesign-input': 'finalizeFromDateRangeCustomRangeBoxen',
      'click .date-range-dropdown .picker-button.start': 'clickDateRangeCustomRangeStartPick',
      'click .date-range-dropdown .picker-button.end': 'clickDateRangeCustomRangeEndPick'
    };

    RedesignDateRangeDimensionSetting.DEFAULT_DATE_RANGE_LABEL = "Date Range";

    RedesignDateRangeDimensionSetting.DEFAULT_DATE_RANGE_VALUE = null;

    RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE = 'range';

    RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS = 'units';

    RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_TIMEFRAME = 'timeframe';

    RedesignDateRangeDimensionSetting.WEEK_UNIT = 'week';

    RedesignDateRangeDimensionSetting.MONTH_UNIT = 'month';

    RedesignDateRangeDimensionSetting.CURRENT_FRAME = 'current';

    RedesignDateRangeDimensionSetting.LAST_FRAME = 'last';

    RedesignDateRangeDimensionSetting.DATE_RANGE_OPTIONS = [
      {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE,
          range_start: null,
          range_end: null
        },
        label: "Custom Range"
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_TIMEFRAME,
          unit: RedesignDateRangeDimensionSetting.WEEK_UNIT,
          frame: RedesignDateRangeDimensionSetting.CURRENT_FRAME
        },
        label: 'Current Week'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_TIMEFRAME,
          unit: RedesignDateRangeDimensionSetting.WEEK_UNIT,
          frame: RedesignDateRangeDimensionSetting.LAST_FRAME
        },
        label: 'Last Week'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_TIMEFRAME,
          unit: RedesignDateRangeDimensionSetting.MONTH_UNIT,
          frame: RedesignDateRangeDimensionSetting.CURRENT_FRAME
        },
        label: 'Current Month'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: null,
          unit_aggregation: 'day'
        },
        label: 'All Dates'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 365,
          unit_aggregation: 'day'
        },
        label: '365 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 180,
          unit_aggregation: 'day'
        },
        label: '180 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 90,
          unit_aggregation: 'day'
        },
        label: '90 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 60,
          unit_aggregation: 'day'
        },
        label: '60 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 30,
          unit_aggregation: 'day'
        },
        label: '30 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 14,
          unit_aggregation: 'day'
        },
        label: '14 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 7,
          unit_aggregation: 'day'
        },
        label: '7 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 3,
          unit_aggregation: 'day'
        },
        label: '3 Days'
      }, {
        value: {
          type: RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS,
          num_units: 1,
          unit_aggregation: 'day'
        },
        label: '1 Day'
      }
    ];

    RedesignDateRangeDimensionSetting.ALL_DATES_INDEX = 4;

    function RedesignDateRangeDimensionSetting() {
      this.finalizeFromDateRangeCustomRangeBoxen = bind(this.finalizeFromDateRangeCustomRangeBoxen, this);
      this.updateFromDateRangeCustomRangeBoxen = bind(this.updateFromDateRangeCustomRangeBoxen, this);
      this.clickedDateRangeRadioButton = bind(this.clickedDateRangeRadioButton, this);
      this.clickDateRangeCustomRangeEndPick = bind(this.clickDateRangeCustomRangeEndPick, this);
      this.clickDateRangeCustomRangeStartPick = bind(this.clickDateRangeCustomRangeStartPick, this);
      this.scrollWithoutLeaking = bind(this.scrollWithoutLeaking, this);
      this.updateLabel = bind(this.updateLabel, this);
      this.configChanged = bind(this.configChanged, this);
      this.hidePickers = bind(this.hidePickers, this);
      RedesignDateRangeDimensionSetting.__super__.constructor.apply(this, arguments);
      this.stashedDateRange = {};
      App.Utils.requires(this, 'dashboard', 'el', 'dimension');
      this.dashboard.bind(App.Dashboard.EVENT_CONFIG_CHANGED, this.configChanged);
      this.render();
    }

    RedesignDateRangeDimensionSetting.prototype.release = function() {
      this.dateRangeRadioButtonGroup.release();
      this.safeReleasePickers();
      this.dateRangeOptions.off('wheel mousewheel', this.scrollWithoutLeaking);
      this.dateRangeOptions.off('wheel mousewheel', this.hidePickers);
      this.dashboard.unbind(App.Dashboard.EVENT_CONFIG_CHANGED, this.configChanged);
      return RedesignDateRangeDimensionSetting.__super__.release.apply(this, arguments);
    };

    RedesignDateRangeDimensionSetting.prototype.safeReleasePickers = function() {
      try {
        this.dateRangeOptionRangeStart.datepicker('destroy');
        return this.dateRangeOptionRangeEnd.datepicker('destroy');
      } catch (error) {

      }
    };

    RedesignDateRangeDimensionSetting.prototype.hidePickers = function() {
      this.dateRangeOptionRangeStart.datepicker('hide');
      return this.dateRangeOptionRangeEnd.datepicker('hide');
    };

    RedesignDateRangeDimensionSetting.prototype.render = function() {
      var customDateRadioButton;
      this.html(this.view('redesign/dashboards/date_range_dimension_setting')({
        labelText: this.labelText()
      }));
      this.refreshElements();
      this.dateRangeOptions.on('wheel mousewheel', this.scrollWithoutLeaking);
      this.dateRangeOptions.on('wheel mousewheel', this.hidePickers);
      customDateRadioButton = this.addCustomDateRadioButton();
      this.customDateOptionEl.append(customDateRadioButton.el);
      this.dateRangeRadioButtonGroup = new App.RedesignRadioButtonGroup({
        radioOptions: this.constructor.DATE_RANGE_OPTIONS.slice(1, this.constructor.DATE_RANGE_OPTIONS.length),
        optionCompareFunc: this.constructor.dateRangeOptionsMatch,
        initialValue: this.selectedDateRange(),
        defaultValue: -1,
        el: App.RadioButtonGroup.prependFrame(this.otherOptionsEl),
        disableDeselection: true,
        callback: this.clickedDateRangeRadioButton
      });
      this.dateRangeRadioButtonGroup.radioButtons.push(customDateRadioButton);
      this.refreshElements();
      this.updateDateRangeCustomRangeUiState(this.savedDimensionValue());
      this.updateLabel();
      return this.hookUpDatePickers();
    };

    RedesignDateRangeDimensionSetting.prototype.labelText = function() {
      if (!(this.dimension instanceof App.CustomDimension)) {
        return 'Date Range';
      }
    };

    RedesignDateRangeDimensionSetting.prototype.configChanged = function() {
      return this.updateLabel();
    };

    RedesignDateRangeDimensionSetting.prototype.selectedDateRange = function() {
      if (this.dimension instanceof App.CustomDimension) {
        return this.savedDimensionValue() || this.constructor.DATE_RANGE_OPTIONS[this.constructor.ALL_DATES_INDEX].value;
      } else {
        return this.dashboard.dateRangeSetting();
      }
    };

    RedesignDateRangeDimensionSetting.prototype.savedDimensionValue = function() {
      if (this.dimension instanceof App.CustomDimension) {
        return this.dimensionConfig().dimensionValues(this.dimension.id).last();
      } else {
        return this.dashboard.dateRangeSetting();
      }
    };

    RedesignDateRangeDimensionSetting.prototype.addCustomDateRadioButton = function() {
      var radioButton, radioOption;
      radioOption = this.constructor.DATE_RANGE_OPTIONS[0];
      return radioButton = new App.RedesignRadioButton({
        iconClass: radioOption.iconClass || 'small-radio-button',
        labelText: radioOption.label,
        labelClass: radioOption.labelClass,
        value: radioOption.value,
        disableDeselection: true,
        callback: this.clickedDateRangeRadioButton,
        enabled: !radioOption.disabled
      });
    };

    RedesignDateRangeDimensionSetting.prototype.closeForm = function() {
      return this.updateDateRangeCustomRangeUiState(this.savedDimensionValue());
    };

    RedesignDateRangeDimensionSetting.prototype.dashboardSettingsClosed = function() {};

    RedesignDateRangeDimensionSetting.prototype.onDataUpdated = function() {};

    RedesignDateRangeDimensionSetting.prototype.dimensionConfig = function() {
      return this.dashboard.dimensionConfig();
    };

    RedesignDateRangeDimensionSetting.prototype.updateLabel = function() {
      var i, item, len, ref, selectedDateRange, value;
      ref = this.constructor.DATE_RANGE_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        if (this.constructor.dateRangeOptionsMatch(this.selectedDateRange(), item.value)) {
          selectedDateRange = item;
          break;
        }
      }
      if (selectedDateRange) {
        this.dateRangeRadioButtonGroup.setState(selectedDateRange.value);
        if (selectedDateRange.value.type === "range") {
          value = this.prepareDateRangeValue(selectedDateRange.value);
          return this.updateDateRangeCustomRangeUiState(value);
        }
      } else {
        return this.dateRangeRadioButtonGroup.setState(this.constructor.DATE_RANGE_OPTIONS[this.constructor.ALL_DATES_INDEX].value);
      }
    };

    RedesignDateRangeDimensionSetting.prototype.scrollWithoutLeaking = function(event) {
      return App.Utils.scrollWithoutLeaking(event, this.dateRangeOptions);
    };

    RedesignDateRangeDimensionSetting.prototype.populateDateRangeFilter = function(dateRange) {
      var label;
      if ((dateRange == null) || dateRange === this.constructor.DEFAULT_DATE_RANGE_VALUE) {
        return;
      }
      label = this.constructor.labelForDateRangeFilters(dateRange);
      if (label == null) {
        return;
      }
      return this.filters.append(this.view('dashboards/dashboard_settings_filter')({
        label: label,
        filterType: 'date-range'
      }));
    };

    RedesignDateRangeDimensionSetting.prototype.hookUpDatePickers = function() {
      var datePickerOpts;
      datePickerOpts = {
        showOn: "none",
        dateFormat: "yy-mm-dd",
        constrainInput: false,
        onClose: ((function(_this) {
          return function() {
            return setTimeout(_this.finalizeFromDateRangeCustomRangeBoxen, 0);
          };
        })(this))
      };
      this.dateRangeOptionRangeStart.datepicker(datePickerOpts);
      return this.dateRangeOptionRangeEnd.datepicker(datePickerOpts);
    };

    RedesignDateRangeDimensionSetting.prototype.clickDateRangeCustomRangeStartPick = function() {
      this.dateRangeOptionRangeStart.datepicker('show');
      return this.maybeSetTvModeClass();
    };

    RedesignDateRangeDimensionSetting.prototype.clickDateRangeCustomRangeEndPick = function() {
      this.dateRangeOptionRangeEnd.datepicker('show');
      return this.maybeSetTvModeClass();
    };

    RedesignDateRangeDimensionSetting.prototype.maybeSetTvModeClass = function() {
      var ref;
      return $('.ui-datepicker').toggleClass('tv-mode', (ref = AppRedesign.current()) != null ? ref.tvmode : void 0);
    };

    RedesignDateRangeDimensionSetting.prototype.stashDateRange = function() {
      return this.stashedDateRange = {
        start: this.dateRangeOptionRangeStart.val(),
        end: this.dateRangeOptionRangeEnd.val()
      };
    };

    RedesignDateRangeDimensionSetting.prototype.updateDateRangeCustomRangeUiState = function(value) {
      if ((value != null ? value.type : void 0) === this.constructor.DATE_RANGE_TYPE_RANGE) {
        this.dateRangeOptionRangeStart.val(value.range_start || '');
        this.dateRangeOptionRangeEnd.val(value.range_end || '');
        setTimeout(((function(_this) {
          return function() {
            _this.dateRangeDropdown.addClass('with-custom-range');
            return _this.dateRangeDropdown.addClass('animate-range-closed');
          };
        })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
        return this.stashDateRange();
      } else {
        return this.closeCustomDateRange();
      }
    };

    RedesignDateRangeDimensionSetting.prototype.closeCustomDateRange = function() {
      this.dateRangeDropdown.removeClass('with-custom-range');
      return setTimeout(((function(_this) {
        return function() {
          return _this.dateRangeDropdown.removeClass('animate-range-closed');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RedesignDateRangeDimensionSetting.prototype.prepareDateRangeValue = function(value) {
      var re, rs;
      if ((value != null ? value.type : void 0) === this.constructor.DATE_RANGE_TYPE_RANGE) {
        value = jQuery.extend(true, {}, value);
        rs = this.dateRangeOptionRangeStart.val().trim();
        re = this.dateRangeOptionRangeEnd.val().trim();
        if (rs !== '') {
          value.range_start = rs;
        }
        if (re !== '') {
          value.range_end = re;
        }
      }
      return value;
    };

    RedesignDateRangeDimensionSetting.prototype.clickedDateRangeRadioButton = function(value, clickOptions) {
      value = this.prepareDateRangeValue(value);
      this.updateDateRangeCustomRangeUiState(value);
      if (clickOptions.doubleClick) {
        return this.trigger('apply-pending-config');
      } else {
        return this.setPendingDateRange(value);
      }
    };

    RedesignDateRangeDimensionSetting.prototype.setPendingDateRange = function(value) {
      if (this.dimension instanceof App.CustomDimension) {
        if (App.Utils.isBlank(value)) {
          return;
        }
        this.dimensionConfig().removeDimensionInfo(this.dimension.id, this.savedDimensionValue());
        this.dimensionConfig().addDimensionInfo(this.dimension.id, value, value);
        return this.updateLabel();
      } else {
        return this.dashboard.setPendingDateRange(value);
      }
    };

    RedesignDateRangeDimensionSetting.prototype.updateFromDateRangeCustomRangeBoxen = function(event, cleanInput) {
      var value;
      if (cleanInput == null) {
        cleanInput = false;
      }
      if (cleanInput) {
        this.constructor.cleanUserDateInput(this.dateRangeOptionRangeStart);
        this.constructor.cleanUserDateInput(this.dateRangeOptionRangeEnd);
        this.constructor.correctDateValuesIfReversed(this.dateRangeOptionRangeStart, this.dateRangeOptionRangeEnd, this.stashedDateRange);
        this.stashDateRange();
      }
      value = this.prepareDateRangeValue({
        type: this.constructor.DATE_RANGE_TYPE_RANGE
      });
      return this.setPendingDateRange(value);
    };

    RedesignDateRangeDimensionSetting.prototype.finalizeFromDateRangeCustomRangeBoxen = function() {
      return this.updateFromDateRangeCustomRangeBoxen(null, true);
    };

    RedesignDateRangeDimensionSetting.dateRangeOptionsMatch = function(a, b, requireRangeMatch) {
      if (requireRangeMatch == null) {
        requireRangeMatch = false;
      }
      if (!((a != null) && (b != null))) {
        return false;
      }
      if (a.type === b.type) {
        switch (a.type) {
          case void 0:
            return true;
          case RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_UNITS:
            if (a.num_units === b.num_units && a.unit_aggregation === b.unit_aggregation) {
              return true;
            }
            break;
          case RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE:
            if (requireRangeMatch) {
              return (a.range_start || null) === (b.range_start || null) && (a.range_end || null) === (b.range_end || null);
            } else {
              return true;
            }
            break;
          case RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_TIMEFRAME:
            if (a.unit === b.unit && a.frame === b.frame) {
              return true;
            }
        }
      }
      return false;
    };

    RedesignDateRangeDimensionSetting.labelForDateRangeFilters = function(value) {
      return this.labelForDateRange(value, 'filters');
    };

    RedesignDateRangeDimensionSetting.labelForDateRangeTitles = function(value) {
      return this.labelForDateRange(value, 'titles');
    };

    RedesignDateRangeDimensionSetting.labelForDateRange = function(value, mode) {
      var i, label, len, option, ref;
      if ((value != null ? value.type : void 0) === this.DATE_RANGE_TYPE_RANGE) {
        label = this.labelForDateRangeCustomRange(value);
        if (label != null) {
          return label;
        }
      } else if ((value != null ? value.type : void 0) === this.DATE_RANGE_TYPE_UNITS || (value != null ? value.type : void 0) === this.DATE_RANGE_TYPE_TIMEFRAME) {
        if (mode === 'titles' && value.num_units === 1 && value.unit_aggregation === 'day') {
          return "Today";
        }
        ref = this.DATE_RANGE_OPTIONS;
        for (i = 0, len = ref.length; i < len; i++) {
          option = ref[i];
          if (this.dateRangeOptionsMatch(value, option.value)) {
            return option.label;
          }
        }
      }
      if (mode === 'filters') {
        if ((value != null ? value.type : void 0) === this.DATE_RANGE_TYPE_RANGE) {
          return 'Custom Range';
        } else {
          return null;
        }
      } else {
        return 'All Time';
      }
    };

    RedesignDateRangeDimensionSetting.labelForDateRangeCustomRange = function(value) {
      var hasEnd, hasStart;
      hasStart = (value.range_start != null) && value.range_start.trim() !== '';
      hasEnd = (value.range_end != null) && value.range_end.trim() !== '';
      if (hasStart && hasEnd) {
        return value.range_start + " to " + value.range_end;
      } else if (hasStart) {
        return "After " + value.range_start;
      } else if (hasEnd) {
        return "Before " + value.range_end;
      } else {
        return null;
      }
    };

    RedesignDateRangeDimensionSetting.parseDateToISO = function(dateString) {
      var dt, e;
      try {
        dt = new Date(Date.parse(dateString));
        if (dt === "Invalid Date") {
          return null;
        }
        return dt.toISOString().split('T').first();
      } catch (error) {
        e = error;
        return null;
      }
    };

    RedesignDateRangeDimensionSetting.cleanUserDateInput = function(element) {
      var pVal, tVal;
      if (element.length !== 1) {
        return;
      }
      element.val(element.val().trim());
      tVal = element.val();
      if (tVal !== '' && !tVal.match(/^\d{4}-\d{2}-\d{2}$/)) {
        pVal = this.parseDateToISO(tVal);
        if (pVal != null) {
          return element.val(pVal);
        }
      }
    };

    RedesignDateRangeDimensionSetting.correctDateValuesIfReversed = function(inputEl1, inputEl2, previousState) {
      var d1, d2, v1, v2;
      if (previousState == null) {
        previousState = {};
      }
      v1 = inputEl1.val().trim();
      v2 = inputEl2.val().trim();
      d1 = Date.parse(v1);
      d2 = Date.parse(v2);
      if (v1 !== '' && v2 !== '' && !isNaN(d1) && !isNaN(d2) && d2 < d1) {
        if (previousState.start !== v1) {
          return inputEl2.val(v1);
        } else {
          return inputEl1.val(v2);
        }
      }
    };

    RedesignDateRangeDimensionSetting.getOption = function(name) {
      var i, len, option, ref;
      name = name.toLowerCase().replace(/\s/, "");
      if (name === App.CustomDimension.CUSTOM_RANGE_START_DATE || name === App.CustomDimension.CUSTOM_RANGE_END_DATE) {
        return this.DATE_RANGE_OPTIONS.filter((function(a) {
          return a.label === "Custom Range";
        }))[0].value;
      }
      ref = this.DATE_RANGE_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.label.toLowerCase().replace(/\s/, "") === name) {
          return option.value;
        }
      }
      return null;
    };

    RedesignDateRangeDimensionSetting.getDateRangeValuesAsArrays = function(term, callback) {
      var translateCallback;
      translateCallback = function(results) {
        var r, values;
        values = (function() {
          var i, len, results1;
          results1 = [];
          for (i = 0, len = results.length; i < len; i++) {
            r = results[i];
            results1.push([JSON.stringify(r.value), r.label]);
          }
          return results1;
        })();
        return callback(values);
      };
      return this.getDateRangeValues(term, translateCallback);
    };

    RedesignDateRangeDimensionSetting.getDateRangeValues = function(term, translateCallback) {
      var i, len, option, ref, results;
      term = term.trim().toLowerCase();
      results = [];
      ref = this.DATE_RANGE_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.label.toLowerCase().indexOf(term) !== -1) {
          results.push(option);
        }
      }
      return translateCallback(results);
    };

    RedesignDateRangeDimensionSetting.getOptionLabel = function(value) {
      var i, len, option, ref;
      ref = this.DATE_RANGE_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (this.dateRangeOptionsMatch(value, option.value)) {
          return option.label;
        }
      }
    };

    return RedesignDateRangeDimensionSetting;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDialog = (function(superClass) {
    extend(RedesignDialog, superClass);

    RedesignDialog.prototype.elements = {
      '.dialog': 'dialog',
      '.dialog-content': 'contentEl',
      '.cancel-icon': 'cancelIcon',
      '.title': 'titleEl'
    };

    RedesignDialog.prototype.events = {
      'click .cancel-icon': 'close'
    };

    RedesignDialog.createDialog = function(properties, container) {
      var dialog, frame;
      if (container == null) {
        container = null;
      }
      container || (container = $('#dialogs'));
      if (container == null) {
        console.error('Error, tried to add a dialog but dialog container does not exist');
        return;
      }
      frame = App.Utils.appendFrame(container, 'dialog-container flex-fill-column');
      properties.el = frame;
      if (properties.viewController == null) {
        properties.viewController = new App.RedesignDialogViewController({
          mainText: properties.mainText,
          okButtonText: properties.okButtonText,
          okCallback: properties.okCallback
        });
      }
      return dialog = new App.RedesignDialog(properties);
    };

    function RedesignDialog() {
      this.finish = bind(this.finish, this);
      this.close = bind(this.close, this);
      this.updateTitle = bind(this.updateTitle, this);
      RedesignDialog.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'title', 'viewController');
      this.updateTitle();
      if (!this.noCancel) {
        App.hotkeys.bind(App.HotkeyManager.ESC, this.close);
      }
      this.viewController.bind('close', this.close);
      this.viewController.bind('update-title', this.updateTitle);
      this.prevState = AppRedesign.current().getCurrentState();
      AppRedesign.current().setCurrentState(AppRedesign.IN_DIALOG);
      this.render();
    }

    RedesignDialog.prototype.release = function() {
      if (!this.noCancel) {
        App.hotkeys.unbind(App.HotkeyManager.ESC, this.close);
      }
      this.viewController.release();
      AppRedesign.current().setCurrentState(this.prevState);
      return RedesignDialog.__super__.release.apply(this, arguments);
    };

    RedesignDialog.prototype.updateTitle = function() {
      var base;
      if (typeof (base = this.viewController).getTitle === "function" ? base.getTitle() : void 0) {
        this.title = this.viewController.getTitle();
        this.titleEl.text(this.title);
      }
      return this.el.toggleClass('no-title', _.isEmpty(this.title));
    };

    RedesignDialog.prototype.render = function() {
      if (this.customDialogClass) {
        this.el.addClass(this.customDialogClass);
      }
      this.html(this.view('redesign/controls/frame')({
        title: this.title,
        helpIcon: this.helpIcon
      }));
      if (this.noCancel) {
        this.cancelIcon.hide();
      }
      this.contentEl.html(this.viewController.el);
      this.viewController.refreshElements();
      if (this.noAnimateOpen) {
        this.dialog.addClass('visible');
      } else {
        App.Utils.animateHack(true, 'visible', this.dialog);
      }
      if (this.noCancel) {
        return App.PageOverlay.showWithoutCallback();
      } else {
        return App.PageOverlay.show(this.close);
      }
    };

    RedesignDialog.prototype.close = function() {
      var base;
      this.trigger('close');
      App.PageOverlay.hide();
      App.Utils.animateHack(false, 'visible', this.dialog);
      if (typeof (base = this.viewController).unparentAllReparented === "function") {
        base.unparentAllReparented();
      }
      return setTimeout(this.finish, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignDialog.prototype.finish = function() {
      if (this.closeCallback != null) {
        this.closeCallback();
      }
      return this.release();
    };

    return RedesignDialog;

  })(Spine.Controller);

  App.RedesignDialogViewController = (function(superClass) {
    extend(RedesignDialogViewController, superClass);

    RedesignDialogViewController.prototype.className = 'default-dialog';

    RedesignDialogViewController.prototype.elements = {
      '.main-text': 'mainTextEl',
      '.button-row': 'buttonRow'
    };

    function RedesignDialogViewController() {
      this.close = bind(this.close, this);
      this.ok = bind(this.ok, this);
      RedesignDialogViewController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'mainText', 'okCallback');
      this.html(this.view('redesign/controls/default_dialog')({
        mainText: this.mainText
      }));
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.close,
        saveFunc: this.ok,
        saveText: this.okButtonText || 'PROCEED'
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
    }

    RedesignDialogViewController.prototype.ok = function() {
      this.okCallback();
      return this.close();
    };

    RedesignDialogViewController.prototype.close = function() {
      return this.trigger('close');
    };

    return RedesignDialogViewController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDimensionSetting = (function(superClass) {
    extend(RedesignDimensionSetting, superClass);

    RedesignDimensionSetting.prototype.elements = {
      '.values-selection': 'valuesSelectionEl',
      '.loading-message': 'loadingEl',
      '.setting-header .label': 'settingLabel'
    };

    RedesignDimensionSetting.prototype.events = {
      'click .edit-icon': 'clickedEdit'
    };

    function RedesignDimensionSetting() {
      this.editingDimension = bind(this.editingDimension, this);
      this.onDataUpdated = bind(this.onDataUpdated, this);
      this.updateLabel = bind(this.updateLabel, this);
      this.createDimensionController = bind(this.createDimensionController, this);
      this.dashboardSettingsClosed = bind(this.dashboardSettingsClosed, this);
      this.dimensionUpdated = bind(this.dimensionUpdated, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      RedesignDimensionSetting.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'dimension', 'dashboard');
      this.render();
      App.Dashboard.bind('dashboard-settings-closed', this.dashboardSettingsClosed);
      this.dimension.bind('update', this.dimensionUpdated);
      this.dimension.bind('data-updated', this.onDataUpdated);
      App.CustomDimension.bind('editing-dimension', this.editingDimension);
    }

    RedesignDimensionSetting.prototype.release = function() {
      RedesignDimensionSetting.__super__.release.apply(this, arguments);
      App.Dashboard.unbind('dashboard-settings-closed', this.dashboardSettingsClosed);
      this.valuesSelectionController.release();
      this.dimension.unbind('update', this.dimensionUpdated);
      this.dimension.unbind('data-updated', this.onDataUpdated);
      return App.CustomDimension.unbind('editing-dimension', this.editingDimension);
    };

    RedesignDimensionSetting.prototype.clickedEdit = function(event) {
      if (!($(event.target).closest('.dimension-setting.open').length > 0)) {
        return;
      }
      if (AppRedesign.current().tvmode) {
        return;
      }
      if (event != null) {
        event.stopPropagation();
      }
      if (!this.canEditDimensionSettings()) {
        return;
      }
      event.stopPropagation();
      return this.dimension.trigger('edit');
    };

    RedesignDimensionSetting.prototype.dimensionUpdated = function() {
      if (!this.selectionControllerMatchesFilterType()) {
        this.render();
      }
      this.updateLabel();
      return this.onDataUpdated();
    };

    RedesignDimensionSetting.prototype.dashboardSettingsClosed = function() {
      return this.valuesSelectionController.dashboardSettingsClosed();
    };

    RedesignDimensionSetting.prototype.selectionControllerMatchesFilterType = function() {
      return (this.dimension.isFreeInput() && this.valuesSelectionController instanceof App.FreeInputSettingController) || (this.dimension.isDateRange() && this.valuesSelectionController instanceof App.RedesignDateRangeDimensionSetting) || (!this.dimension.isFreeInput() && !this.dimension.isDateRange() && this.valuesSelectionController instanceof App.RedesignDashboardSettingAutoCompleter);
    };

    RedesignDimensionSetting.prototype.render = function() {
      var canEdit;
      canEdit = this.canEditDimensionSettings() && !AppRedesign.current().shared_mode;
      this.html(this.view('redesign/dashboards/setting')({
        canEdit: canEdit
      }));
      this.valuesSelectionController = this.createDimensionController();
      this.updateLabel();
      return this.onDataUpdated();
    };

    RedesignDimensionSetting.prototype.createDimensionController = function() {
      if (this.dimension.isFreeInput()) {
        return new App.FreeInputSettingController({
          dashboard: this.dashboard,
          dimension: this.dimension,
          el: this.valuesSelectionEl
        });
      } else if (this.dimension.isDateRange()) {
        return new App.RedesignDateRangeDimensionSetting({
          dashboard: this.dashboard,
          dimension: this.dimension,
          el: this.valuesSelectionEl
        });
      } else {
        return new App.RedesignDashboardSettingAutoCompleter({
          dashboard: this.dashboard,
          dimension: this.dimension,
          el: this.valuesSelectionEl
        });
      }
    };

    RedesignDimensionSetting.prototype.updateLabel = function() {
      return this.settingLabel.text(this.dimension.name);
    };

    RedesignDimensionSetting.prototype.onDataUpdated = function() {
      return this.valuesSelectionController.onDataUpdated();
    };

    RedesignDimensionSetting.prototype.editingDimension = function(dim) {
      return this.el.toggleClass('edit-mode', (dim != null ? dim.id : void 0) === this.dimension.id);
    };

    RedesignDimensionSetting.prototype.canEditDimensionSettings = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canEdit() : void 0;
      }
    };

    return RedesignDimensionSetting;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignFilterForm = (function(superClass) {
    extend(RedesignFilterForm, superClass);

    RedesignFilterForm.prototype.className = 'add-filter filter-modal modal';

    RedesignFilterForm.INPUT_ROW_ADD_CLASS = 'new';

    RedesignFilterForm.INPUT_ROW_HEIGHT = null;

    RedesignFilterForm.STD_DIM_PLACEHOLDER = 'select id, name from table';

    RedesignFilterForm.CHILD_DIM_PLACEHOLDER = 'select id, name, parent_value from table';

    RedesignFilterForm.OPEN_CLASSES = 'open slideable';

    RedesignFilterForm.FILTER_EDITOR_WINDOW_HEIGHT = 480.5;

    RedesignFilterForm.FILTER_EDITOR_WINDOW_BOTTOM_MARGIN = 15;

    RedesignFilterForm.prototype.events = {
      'click    .cancel-icon': 'triggerHideForm',
      'click    .cancel.button': 'triggerHideForm',
      'click    .save.button': 'saveButtonClick',
      'click    .more.options.link': 'moreOptionsClick',
      'click    .less.options.link': 'lessOptionsClick',
      'click    .names-from-form .input-row .action': 'namesFormActionClick',
      'keypress .names-from-form .input-row input': 'namesFormKeypress',
      'click    .save-row .hide.options': 'hideClick',
      'click    .enable-deletion.checkbox': 'enableDeletionCheckboxClick',
      'click    .save-row .delete.options': 'deleteOptionClick',
      'click    .delete.button': 'deleteConfirmClick',
      'click    .delete-confirm .cancel-delete': 'deleteCancelClick',
      'click    .refresh-icon': 'refreshDimensionValues',
      'chosen:showing_dropdown select': 'reparentChosen'
    };

    RedesignFilterForm.prototype.elements = {
      'header span.title': 'formTitle',
      '.dimension-name': 'dimensionNameInput',
      '.names-from-db.block': 'namesFromDbBlock',
      '.names-from-db.block .values-area': 'namesFromDbValueArea',
      '.names-from-db.block .sql-box': 'namesFromDbSqlSqlBox',
      '.names-from-db.block .database-picker': 'namesFromDbDatabaseSelect',
      '.names-from-form.block': 'namesFromFormBlock',
      '.names-from-form.block .values-area': 'namesFromFormValueArea',
      '.names-from-form.block .values-content': 'namesFromFormValueContent',
      '.free-input.block': 'freeInputBlock',
      '.daterange.block': 'dateRangeBlock',
      '.expression-from-sql': 'expressionFromSqlBlock',
      '.expression-from-sql .values-area': 'expressionFromSqlValuesArea',
      '.expression-from-sql .sql-box': 'expressionFromSqlSqlBox',
      '.more.options.link': 'moreOptionsLink',
      '.less.options.link': 'lessOptionsLink',
      '.input-row.new': 'lastNameValueInputRow',
      '.save-row': 'saveRow',
      '.errors.title-error': 'titleError',
      '.errors.db-error': 'dbError',
      '.errors.val-error': 'valError',
      '.alert-flex-wrapper': 'alertBlockEl',
      '.alert-reference': 'alertReferenceEl',
      '.alert-message': 'alertMessageEl',
      '.save-row .hide.options': 'hideLink',
      '.save-row .delete.button': 'deleteButton',
      '.enable-deletion.checkbox': 'enableDeletionCheckbox',
      '.parent-dim-area': 'parentDimArea',
      '.expression-from-sql .parent-dim-area .checkbox': 'parentDimCheckboxEl',
      '.expression-from-sql .parent-dim-picker': 'parentDimSelect',
      '.delete-area': 'deletionArea',
      '.delete-area .checkbox': 'deleteCheckbox',
      '.refresh-icon': 'refreshIcon',
      '.modal-content': 'formScrollBody'
    };

    function RedesignFilterForm() {
      this.codemirrorLoaded = bind(this.codemirrorLoaded, this);
      this.repositionSelf = bind(this.repositionSelf, this);
      this.showForm = bind(this.showForm, this);
      this.resetForm = bind(this.resetForm, this);
      this.editDimension = bind(this.editDimension, this);
      this.newDimensionClicked = bind(this.newDimensionClicked, this);
      this.deleteCancelClick = bind(this.deleteCancelClick, this);
      this.deleteConfirmClick = bind(this.deleteConfirmClick, this);
      this.enableDeletionCheckboxClick = bind(this.enableDeletionCheckboxClick, this);
      this.deleteOptionClick = bind(this.deleteOptionClick, this);
      this.hideClick = bind(this.hideClick, this);
      this.handleSaveError = bind(this.handleSaveError, this);
      this.getNamesFromFormValues = bind(this.getNamesFromFormValues, this);
      this.createPermissionDenied = bind(this.createPermissionDenied, this);
      this.saveButtonClick = bind(this.saveButtonClick, this);
      this.refreshDimensionValues = bind(this.refreshDimensionValues, this);
      this.lessOptionsClick = bind(this.lessOptionsClick, this);
      this.moreOptionsClick = bind(this.moreOptionsClick, this);
      this.parentDimToggled = bind(this.parentDimToggled, this);
      this.namesFormActionClick = bind(this.namesFormActionClick, this);
      this.namesFormKeypress = bind(this.namesFormKeypress, this);
      this.hideExpressionMatch = bind(this.hideExpressionMatch, this);
      this.showExpressionMatch = bind(this.showExpressionMatch, this);
      this.clickedDateRangeRadio = bind(this.clickedDateRangeRadio, this);
      this.clickedFreeInputRadio = bind(this.clickedFreeInputRadio, this);
      this.clickedNamesFromFormRadio = bind(this.clickedNamesFromFormRadio, this);
      this.clickedNamesFromDbRadio = bind(this.clickedNamesFromDbRadio, this);
      this.reparentChosen = bind(this.reparentChosen, this);
      this.closeChosen = bind(this.closeChosen, this);
      this.hideForm = bind(this.hideForm, this);
      this.triggerHideForm = bind(this.triggerHideForm, this);
      this.scrollWithoutLeaking = bind(this.scrollWithoutLeaking, this);
      RedesignFilterForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      this.item = new App.CustomDimension({
        available_by_default: this.availableByDefault()
      });
      App.CustomDimension.bind('edit', this.editDimension);
      this.resetForm(this.item);
      $(window).on('resize', this.closeChosen);
    }

    RedesignFilterForm.prototype.release = function() {
      this.resetForm();
      App.CustomDimension.unbind('edit', this.editDimension);
      return RedesignFilterForm.__super__.release.apply(this, arguments);
    };

    RedesignFilterForm.prototype.resetScrollBind = function() {
      return this.formScrollBody.on('wheel mousewheel', this.scrollWithoutLeaking);
    };

    RedesignFilterForm.prototype.listenFormScroll = function() {
      return this.formScrollBody.on('scroll', this.closeChosen);
    };

    RedesignFilterForm.prototype.scrollWithoutLeaking = function(event) {
      return App.Utils.scrollWithoutLeaking(event, this.formScrollBody);
    };

    RedesignFilterForm.prototype.availableByDefault = function() {
      return !App.Site.first().new_filters_not_shared;
    };

    RedesignFilterForm.prototype.updateName = function() {
      return this.dimensionNameInput.val(this.item.name);
    };

    RedesignFilterForm.prototype.updateHeader = function() {
      if (this.itemIsExisting()) {
        this.refreshIcon.show();
        return this.formTitle.text('Edit Filter');
      } else {
        this.refreshIcon.hide();
        return this.formTitle.text('Create Filter');
      }
    };

    RedesignFilterForm.prototype.setUpNamesFrom = function() {
      this.namesFromDbRadio = new App.RedesignRadioButton({
        labelText: 'Get names and values from the database',
        value: true,
        callback: this.clickedNamesFromDbRadio
      });
      this.namesFromDbBlock.prepend(this.namesFromDbRadio.el);
      this.namesFromFormRadio = new App.RedesignRadioButton({
        labelText: 'Type in names and values',
        value: true,
        callback: this.clickedNamesFromFormRadio
      });
      this.namesFromFormBlock.prepend(this.namesFromFormRadio.el);
      this.freeInputRadio = new App.RedesignRadioButton({
        labelText: 'Allow users to enter filter values',
        value: true,
        callback: this.clickedFreeInputRadio
      });
      this.freeInputBlock.prepend(this.freeInputRadio.el);
      this.dateRangeRadio = new App.RedesignRadioButton({
        labelText: 'Create as date range filter',
        value: true,
        callback: this.clickedDateRangeRadio
      });
      this.dateRangeBlock.prepend(this.dateRangeRadio.el);
      this.createNamesFromDbFormPart();
      return this.createNamesFromFormPart();
    };

    RedesignFilterForm.prototype.assignRadioButtonSelection = function() {
      var ref;
      if (this.item.filter_type === App.CustomDimension.FREEINPUT_DIMENSION_TYPE) {
        return this.clickedFreeInputRadio();
      } else if (this.item.filter_type === App.CustomDimension.DATERANGE_DIMENSION_TYPE) {
        return this.clickedDateRangeRadio();
      } else if (((ref = this.item.values_list) != null ? ref.length : void 0) > 0) {
        return this.clickedNamesFromFormRadio();
      } else {
        return this.clickedNamesFromDbRadio();
      }
    };

    RedesignFilterForm.prototype.createNamesFromDbFormPart = function() {
      this.namesFromDbSqlBox = App.RedesignSqlBoxFactory.create('mini', {
        dbFunc: App.User.defaultDbForCurrentUser,
        el: this.namesFromDbSqlSqlBox[0],
        initialValue: this.emptyOrStr(this.item.values_query),
        placeholder: RedesignFilterForm.STD_DIM_PLACEHOLDER
      }).one('codemirror-loaded', this.codemirrorLoaded);
      this.namesFromDbSqlBox.setCodeMirrorEvent('focus', ((function(_this) {
        return function() {
          return _this.namesFromDbSqlSqlBox.addClass('focused');
        };
      })(this)));
      this.namesFromDbSqlBox.setCodeMirrorEvent('blur', ((function(_this) {
        return function() {
          return _this.namesFromDbSqlSqlBox.removeClass('focused');
        };
      })(this)));
      if (App.Database.count() > 1) {
        if (this.item.database_id != null) {
          this.namesFromDbDatabaseSelect.val(this.item.database_id);
        } else {
          this.namesFromDbDatabaseSelect.val(this.getDefaultDatabase().id);
        }
        return this.namesFromDbDatabaseSelect.chosen({
          disable_search: true,
          inherit_select_classes: true
        });
      } else {
        return this.namesFromDbDatabaseSelect.hide();
      }
    };

    RedesignFilterForm.prototype.triggerHideForm = function() {
      return this.hideForm();
    };

    RedesignFilterForm.prototype.hideForm = function(resetOverlay) {
      var res;
      if (resetOverlay == null) {
        resetOverlay = true;
      }
      this.closeChosen();
      res = RedesignFilterForm.__super__.hideForm.call(this, resetOverlay);
      if (res) {
        this.dashboard.trigger('filter-form-closed');
      }
      return res;
    };

    RedesignFilterForm.prototype.closeChosen = function() {
      $('.chosen-container-active').trigger('mouseleave.chosen');
      return this.$('select').trigger('chosen:close');
    };

    RedesignFilterForm.prototype.reparentChosen = function(event) {
      var chosenContainer, placeholder, reparentContainer, select;
      select = $(event.currentTarget);
      chosenContainer = select.siblings('.chosen-container');
      placeholder = $('<div class="reparent-placeholder"/>').css({
        height: chosenContainer.outerHeight(),
        width: chosenContainer.outerWidth()
      });
      this.formScrollBody.off('scroll');
      reparentContainer = $('<div class="reparent-container"/>').css(_.pick(chosenContainer.offset(), 'left', 'top')).appendTo('#body').append(chosenContainer.before(placeholder).detach()).on('scroll', function() {
        return false;
      });
      select.one('chosen:hiding_dropdown', _.bind(this.unreparentChosen, this, placeholder, reparentContainer));
      return setTimeout(((function(_this) {
        return function() {
          return _this.listenFormScroll();
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RedesignFilterForm.prototype.unreparentChosen = function(placeholder, reparentContainer, event) {
      var chosenContainer;
      chosenContainer = reparentContainer.detach().contents();
      return placeholder.replaceWith(chosenContainer);
    };

    RedesignFilterForm.prototype.createNamesFromFormPart = function() {
      var i, len, ref, value;
      if (this.item.values_list != null) {
        ref = this.item.values_list;
        for (i = 0, len = ref.length; i < len; i++) {
          value = ref[i];
          this.addNamesInputRow('', value[1], value[0]);
        }
      }
      return this.addNamesInputRow(RedesignFilterForm.INPUT_ROW_ADD_CLASS);
    };

    RedesignFilterForm.prototype.addNamesInputRow = function(mode, name, value) {
      var e;
      if (name == null) {
        name = '';
      }
      if (value == null) {
        value = '';
      }
      e = $(this.view('redesign/dashboards/custom_dimension_input_value_row')({
        name: name,
        value: value,
        mode: mode
      }));
      this.namesFromFormValueContent.append(e);
      if (RedesignFilterForm.INPUT_ROW_HEIGHT == null) {
        RedesignFilterForm.INPUT_ROW_HEIGHT = parseInt(e.css('maxHeight'));
      }
      return e;
    };

    RedesignFilterForm.prototype.clickedNamesFromDbRadio = function() {
      this.resetErrorState();
      this.setRadioButtonStates('dbRadio');
      this.showExpressionMatch();
      this.sizeValuesArea(this.namesFromDbValueArea);
      this.namesFromFormValueArea.height(0);
      return this.showOptionalOptions();
    };

    RedesignFilterForm.prototype.clickedNamesFromFormRadio = function() {
      this.closeChosen();
      this.resetErrorState();
      this.setRadioButtonStates('formRadio');
      this.showExpressionMatch();
      this.sizeValuesArea(this.namesFromFormValueArea);
      this.namesFromDbValueArea.height(0);
      return this.showOptionalOptions();
    };

    RedesignFilterForm.prototype.clickedFreeInputRadio = function() {
      this.resetErrorState();
      this.setRadioButtonStates('freeInputRadio');
      this.showExpressionMatch();
      this.namesFromDbValueArea.height(0);
      this.namesFromFormValueArea.height(0);
      return this.hideOptionalOptions();
    };

    RedesignFilterForm.prototype.clickedDateRangeRadio = function() {
      this.resetErrorState();
      this.setRadioButtonStates('dateRangeRadio');
      this.namesFromDbValueArea.height(0);
      this.namesFromFormValueArea.height(0);
      this.hideExpressionMatch();
      return this.hideOptionalOptions();
    };

    RedesignFilterForm.prototype.showExpressionMatch = function() {
      var ref, ref1;
      if ((ref = this.expressionFromSqlCheckbox.el) != null) {
        ref.show();
      }
      return (ref1 = this.expressionSqlBox.el) != null ? ref1.show() : void 0;
    };

    RedesignFilterForm.prototype.hideExpressionMatch = function() {
      var ref, ref1;
      if ((ref = this.expressionFromSqlCheckbox.el) != null) {
        ref.hide();
      }
      return (ref1 = this.expressionSqlBox.el) != null ? ref1.hide() : void 0;
    };

    RedesignFilterForm.prototype.setRadioButtonStates = function(radioClicked) {
      this.namesFromDbRadio.enabled = radioClicked !== 'dbRadio';
      this.namesFromDbRadio.setSelected(radioClicked === 'dbRadio');
      this.namesFromFormRadio.enabled = radioClicked !== 'formRadio';
      this.namesFromFormRadio.setSelected(radioClicked === 'formRadio');
      this.freeInputRadio.enabled = radioClicked !== 'freeInputRadio';
      this.freeInputRadio.setSelected(radioClicked === 'freeInputRadio');
      if (this.dateRangeRadio) {
        this.dateRangeRadio.enabled = radioClicked !== 'dateRangeRadio';
        return this.dateRangeRadio.setSelected(radioClicked === 'dateRangeRadio');
      }
    };

    RedesignFilterForm.prototype.showOptionalOptions = function() {
      var ref;
      this.parentDimArea.show();
      if ((ref = this.exclusiveOptionsCheckbox) != null) {
        ref.el.show();
      }
      if (this.optionsVisible) {
        return this.fitExpressionFormChildren();
      }
    };

    RedesignFilterForm.prototype.hideOptionalOptions = function() {
      var ref;
      this.parentDimArea.hide();
      if ((ref = this.exclusiveOptionsCheckbox) != null) {
        ref.el.hide();
      }
      if (this.optionsVisible) {
        return this.fitExpressionFormChildren();
      }
    };

    RedesignFilterForm.prototype.namesFormKeypress = function(event) {
      var inputRow;
      inputRow = $(event.target).closest('.input-row');
      if (inputRow.hasClass(RedesignFilterForm.INPUT_ROW_ADD_CLASS) && event.which === AppRedesign.KEYS.ENTER) {
        return this.namesFormActionClick(event);
      }
    };

    RedesignFilterForm.prototype.namesFormActionClick = function(event) {
      var e, inputRow;
      inputRow = $(event.target).closest('.input-row');
      if (inputRow.hasClass(RedesignFilterForm.INPUT_ROW_ADD_CLASS)) {
        inputRow.removeClass(RedesignFilterForm.INPUT_ROW_ADD_CLASS);
        e = this.addNamesInputRow(RedesignFilterForm.INPUT_ROW_ADD_CLASS + ' collapsed');
        setTimeout(((function(_this) {
          return function() {
            return e.removeClass('collapsed');
          };
        })(this)));
        this.sizeValuesArea(this.namesFromFormValueArea, App.RedesignFilterForm.INPUT_ROW_HEIGHT);
        return e.find('input.name').trigger('focus');
      } else {
        inputRow.addClass('collapsed');
        setTimeout(((function(_this) {
          return function() {
            return _this.sizeValuesArea(_this.namesFromFormValueArea, -1 * App.RedesignFilterForm.INPUT_ROW_HEIGHT);
          };
        })(this)));
        return setTimeout(((function(_this) {
          return function() {
            return inputRow.remove();
          };
        })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
      }
    };

    RedesignFilterForm.prototype.parentDimToggled = function(isChecked, value, label) {
      var ref, ref1;
      if (isChecked) {
        return (ref = this.namesFromDbSqlBox) != null ? ref.setPlaceholder(RedesignFilterForm.CHILD_DIM_PLACEHOLDER) : void 0;
      } else {
        return (ref1 = this.namesFromDbSqlBox) != null ? ref1.setPlaceholder(RedesignFilterForm.STD_DIM_PLACEHOLDER) : void 0;
      }
    };

    RedesignFilterForm.prototype.setUpParentDimensionCheckbox = function() {
      this.expressionFromSqlValuesArea.prepend(this.view("dashboards/parent_dim_picker")({
        currentId: this.item.id,
        selectedId: this.item.parent_id
      }));
      this.refreshElements();
      this.parentDimensionCheckbox = new App.RedesignCheckbox({
        labelText: 'Make this filter a child of',
        initialState: this.item.hasParent(),
        callback: this.parentDimToggled
      });
      this.parentDimCheckboxEl.append(this.parentDimensionCheckbox.el);
      return this.parentDimSelect.chosen({
        inherit_select_classes: true,
        width: '386px'
      });
    };

    RedesignFilterForm.prototype.setUpExpressionCheckbox = function() {
      this.expressionFromSqlCheckbox = new App.RedesignCheckbox({
        labelText: 'Match an expression for this filter',
        initialState: false,
        callback: (function() {})
      });
      return this.expressionFromSqlValuesArea.prepend(this.expressionFromSqlCheckbox.el);
    };

    RedesignFilterForm.prototype.setUpDefaultAvailabilityCheckbox = function() {
      this.availableByDefaultCheckbox = new App.RedesignCheckbox({
        labelText: 'Available on all dashboards by default.',
        initialState: this.item.available_by_default,
        callback: (function() {})
      });
      return this.expressionFromSqlValuesArea.prepend(this.availableByDefaultCheckbox.el);
    };

    RedesignFilterForm.prototype.setExclusiveOptionsCheckbox = function() {
      this.exclusiveOptionsCheckbox = new App.RedesignCheckbox({
        labelText: 'Make filter values radio buttons.',
        initialState: this.item.exclusive,
        callback: (function() {})
      });
      return this.expressionFromSqlValuesArea.prepend(this.exclusiveOptionsCheckbox.el);
    };

    RedesignFilterForm.prototype.createExpressionFormPart = function() {
      this.expressionSqlBox = App.RedesignSqlBoxFactory.create('mini', {
        el: this.expressionFromSqlSqlBox[0],
        initialValue: this.emptyOrStr(this.item.match_expression),
        placeholder: "[column] < [value] and type = 'open'",
        dbFunc: App.User.defaultDbForCurrentUser
      });
      this.expressionSqlBox.setCodeMirrorEvent('focus', ((function(_this) {
        return function() {
          return _this.expressionFromSqlSqlBox.addClass('focused');
        };
      })(this)));
      this.expressionSqlBox.setCodeMirrorEvent('blur', ((function(_this) {
        return function() {
          return _this.expressionFromSqlSqlBox.removeClass('focused');
        };
      })(this)));
      return this.expressionSqlBox.setCodeMirrorEvent('keypress', ((function(_this) {
        return function() {
          return _this.expressionFromSqlCheckbox.toggleSelected(true);
        };
      })(this)));
    };

    RedesignFilterForm.prototype.setUpMoreLessOptions = function() {
      if (this.emptyOrStr(this.item.match_expression) === '') {
        return this.lessOptionsClick();
      } else {
        this.expressionFromSqlCheckbox.toggleSelected(true);
        return this.moreOptionsClick();
      }
    };

    RedesignFilterForm.prototype.moreOptionsClick = function() {
      this.optionsVisible = true;
      this.lessOptionsLink.show();
      this.moreOptionsLink.hide();
      this.fitExpressionFormChildren();
      return this.clearErrors();
    };

    RedesignFilterForm.prototype.fitExpressionFormChildren = function() {
      return this.expressionFromSqlBlock.height(this.expressionFromSqlValuesArea.outerHeight());
    };

    RedesignFilterForm.prototype.lessOptionsClick = function() {
      this.optionsVisible = false;
      this.lessOptionsLink.hide();
      this.moreOptionsLink.show();
      this.expressionFromSqlBlock.height(0);
      return this.clearErrors();
    };

    RedesignFilterForm.prototype.refreshDimensionValues = function() {
      App.Utils.logFeature("custom-dimension-value-refresh", {
        dashboard_id: this.dashboard.id
      });
      jQuery.ajax({
        url: "/custom_dimensions/" + this.item.id + "/refresh_values",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json'
      }).done((function(_this) {
        return function(response) {
          return _this.item.applyHash(response);
        };
      })(this));
      this.item.last_data_loaded_at = null;
      this.item.error_message = null;
      this.item.save({
        ajax: false
      });
      return this.hideForm();
    };

    RedesignFilterForm.prototype.saveButtonClick = function() {
      var isNewDim, query, ref, shouldReloadData, values;
      if (!this.codemirrorLoaded) {
        return;
      }
      App.Utils.logFeature("save-custom-dimension", {
        dashboard_id: this.dashboard.id
      });
      this.item.name = this.dimensionNameInput.val();
      this.item.match_expression = this.expressionSqlBox.getSql();
      this.item.available_by_default = this.availableByDefaultCheckbox.state();
      this.item.exclusive = this.exclusiveOptionsCheckbox.state();
      if (this.item.database_id != null) {
        if ((ref = App.User.currentUser()) != null) {
          ref.setLastUsedDatabase(this.item.database_id);
        }
      }
      this.item.parent_id = this.parentDimensionCheckbox.state() ? parseInt(this.parentDimSelect.val()) : null;
      shouldReloadData = false;
      if (this.namesFromDbRadio.selected()) {
        this.item.values_list = null;
        query = this.namesFromDbSqlBox.getSql();
        shouldReloadData = _.toString(this.item.database_id) !== _.toString(this.namesFromDbDatabaseSelect.val()) || JSON.stringify(query) !== JSON.stringify(this.item.values_query);
        this.item.values_query = query;
        this.item.filter_type = App.CustomDimension.QUERY_DIMENSION_TYPE;
      } else if (this.namesFromFormRadio.selected()) {
        this.item.values_query = null;
        this.item.database_id = null;
        values = this.getNamesFromFormValues();
        shouldReloadData = JSON.stringify(values) !== JSON.stringify(this.item.values_list);
        this.item.values_list = this.getNamesFromFormValues();
        this.item.filter_type = App.CustomDimension.VALUESLIST_DIMENSION_TYPE;
      } else if (this.freeInputRadio.selected()) {
        this.item.values_list = null;
        this.item.values_query = null;
        this.item.database_id = null;
        this.item.filter_type = App.CustomDimension.FREEINPUT_DIMENSION_TYPE;
      } else if (this.dateRangeRadio.selected()) {
        this.item.values_list = null;
        this.item.values_query = null;
        this.item.database_id = null;
        this.item.filter_type = App.CustomDimension.DATERANGE_DIMENSION_TYPE;
      }
      this.item.database_id = this.namesFromDbDatabaseSelect.val();
      if (shouldReloadData) {
        this.item.last_data_loaded_at = null;
        this.item.error_message = null;
      }
      if (!this.expressionFromSqlCheckbox.state()) {
        this.item.match_expression = null;
      }
      isNewDim = App.Utils.isClientId(this.item.id);
      this.clearErrors();
      this.item.bind('ajaxError', this.createPermissionDenied);
      if (this.item.save()) {
        if (!this.item.available_by_default) {
          App.DimensionAvailability.setForDashboard(this.dashboard, this.item.id, true);
        }
        this.hideForm();
        setTimeout(this.resetForm, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
        App.Site.trigger('request-several-updates');
      } else {
        this.item.reload();
      }
      return this.item.unbind('ajaxError', this.createPermissionDenied);
    };

    RedesignFilterForm.prototype.createPermissionDenied = function(xhr, statusText, error) {
      this.item.unbind('ajaxError', this.createPermissionDenied);
      if (xhr.status === HttpCodes.permissionDenied) {
        this.item.destroy();
        return Spine.trigger('permission_denied');
      }
    };

    RedesignFilterForm.prototype.getNamesFromFormValues = function() {
      var values;
      values = [];
      this.namesFromFormValueContent.find('.input-row').each(function() {
        var e, n, v, value;
        value = [];
        e = $(this);
        v = e.find('.value').val();
        if (v !== '') {
          value.push(v);
        }
        n = e.find('.name').val();
        if (n !== '') {
          value.push(n);
        }
        if (value.length > 0) {
          return values.push(value);
        }
      });
      return values;
    };

    RedesignFilterForm.prototype.clearErrors = function() {
      this.dimensionNameInput.removeClass('error');
      this.hideErrorEl(this.titleError);
      this.hideErrorEl(this.dbError);
      this.hideErrorEl(this.valError);
      return this.hideAlert();
    };

    RedesignFilterForm.prototype.hideAlert = function() {
      this.alertReferenceEl.text('');
      this.alertMessageEl.text('');
      this.alertBlockEl.hide();
      return this.alertBlockEl.removeClass('error');
    };

    RedesignFilterForm.prototype.showTitleError = function(msg) {
      this.dimensionNameInput.addClass('error');
      return this.showErrorEl(this.titleError, msg);
    };

    RedesignFilterForm.prototype.showDbValuesError = function(msg) {
      this.namesFromDbSqlSqlBox.addClass('error');
      this.showErrorEl(this.dbError, msg);
      return this.sizeValuesArea(this.namesFromDbValueArea);
    };

    RedesignFilterForm.prototype.showNameValueError = function(msg) {
      return this.showErrorEl(this.valError, msg);
    };

    RedesignFilterForm.prototype.showErrorEl = function(el, msg) {
      el.text(msg);
      el.show();
      return el.addClass('open');
    };

    RedesignFilterForm.prototype.hideErrorEl = function(el) {
      this.el.find('.error').removeClass('error');
      return el.removeClass('open');
    };

    RedesignFilterForm.prototype.handleSaveError = function(item, errors) {
      var blank_name, error, i, len, results;
      results = [];
      for (i = 0, len = errors.length; i < len; i++) {
        error = errors[i];
        switch (error) {
          case App.CustomDimension.ERROR_NO_VALUES:
            if (this.namesFromDbRadio.selected()) {
              results.push(this.showDbValuesError('SQL cannot be blank'));
            } else if (this.namesFromFormRadio.selected()) {
              results.push(this.showNameValueError('Name and values list cannot be empty'));
            } else {
              results.push(void 0);
            }
            break;
          case App.CustomDimension.ERROR_NO_DB:
            results.push(this.showDbValuesError('No database selected'));
            break;
          case App.CustomDimension.ERROR_NO_NAME:
            this.showTitleError('Name cannot be blank');
            results.push(blank_name = true);
            break;
          case App.CustomDimension.ERROR_BAD_NAME:
            if (!blank_name) {
              results.push(this.showTitleError('Name can only contain letters, numbers, and underscores'));
            } else {
              results.push(void 0);
            }
            break;
          case App.CustomDimension.ERROR_DUP_NAME:
            results.push(this.showTitleError("A filter already exists with the name '" + this.item.name + "'"));
            break;
          case App.CustomDimension.ERROR_FORBIDDEN_NAME:
            if (!blank_name) {
              results.push(this.showTitleError('Name cannot be "daterange", "date_range", or "aggregation"'));
            } else {
              results.push(void 0);
            }
            break;
          case App.CustomDimension.ERROR_FORBIDDEN_SUFFIX:
            if (!blank_name) {
              results.push(this.showTitleError('Name cannot end with "_daterange", "_daterange_start", "_daterange_end", or "_daterange_no_tz"'));
            } else {
              results.push(void 0);
            }
            break;
          default:
            results.push(AppRedesign.logError(new Error("Unknown error type: " + error)));
        }
      }
      return results;
    };

    RedesignFilterForm.prototype.setUpDeleteRow = function() {
      if (!this.itemIsExisting()) {
        this.hideLink.hide();
      }
      if (this.itemIsExisting()) {
        if (App.CustomDimension.isVisibleOnSharedDashboard(this.dashboard, this.item.id)) {
          this.hideLink.addClass('disabled');
          this.deleteCheckbox.addClass('disabled');
          this.cannotHide = true;
          this.cannotDelete = true;
        } else if (this.item.used_by_shared_dashboards > 0) {
          this.deleteCheckbox.addClass('disabled');
          this.cannotDelete = true;
        }
      }
      this.saveRow.removeClass('delete-mode');
      this.saveRow.removeClass('enable-delete-mode');
      return this.deleteButton.hide();
    };

    RedesignFilterForm.prototype.hideClick = function() {
      if (this.cannotHide) {
        return;
      }
      App.DimensionAvailability.setForDashboard(this.dashboard, this.item.id, false);
      return this.hideForm();
    };

    RedesignFilterForm.prototype.deleteOptionClick = function() {
      this.saveRow.toggleClass('enable-delete-mode');
      this.saveRow.toggleClass('delete-mode');
      return this.deleteButton.show();
    };

    RedesignFilterForm.prototype.enableDeletionCheckboxClick = function() {
      if (this.cannotDelete) {
        return;
      }
      this.enableDeletionCheckbox.toggleClass('selected');
      if (this.enableDeletionCheckbox.hasClass('selected')) {
        this.saveRow.addClass('enable-delete-mode');
      } else {
        this.saveRow.removeClass('enable-delete-mode');
      }
      return this.saveRow.removeClass('delete-mode');
    };

    RedesignFilterForm.prototype.deleteConfirmClick = function() {
      this.item.destroy();
      this.hideForm();
      return setTimeout(this.resetForm, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignFilterForm.prototype.deleteCancelClick = function() {
      return this.deleteConfirmArea.removeClass('open');
    };

    RedesignFilterForm.prototype.newDimensionClicked = function() {
      if (this.open && !this.itemIsExisting()) {
        return;
      }
      return this.rerenderWithDim(new App.CustomDimension({
        available_by_default: this.availableByDefault()
      }));
    };

    RedesignFilterForm.prototype.editDimension = function(dim) {
      App.Utils.logFeature("edit-custom-dimension", {
        dashboard_id: this.dashboard.id
      });
      return this.rerenderWithDim(dim);
    };

    RedesignFilterForm.prototype.rerenderWithDim = function(dim) {
      var filterModals;
      filterModals = $('.filter-modal');
      if (filterModals.hasClass('closing')) {
        return;
      }
      this.hideFormWithSlide(!filterModals.hasClass('open'));
      this.resetForm(dim);
      return this.showForm();
    };

    RedesignFilterForm.prototype.firstRender = function() {
      this.item.trigger('editing-dimension');
      this.repositionSelf();
      this.updateHeader();
      this.updateName();
      this.setUpNamesFrom();
      this.setUpExpressionCheckbox();
      this.setUpParentDimensionCheckbox();
      this.setUpDefaultAvailabilityCheckbox();
      this.setExclusiveOptionsCheckbox();
      this.createExpressionFormPart();
      this.setUpMoreLessOptions();
      this.setUpDeleteRow();
      this.assignRadioButtonSelection();
      this.refreshElements();
      this.maybeHideDeleteButton();
      this.clearErrors();
      return this.listenFormScroll();
    };

    RedesignFilterForm.prototype.resetForm = function(newItem) {
      var ref, ref1, ref2, ref3, ref4;
      this.cannotHide = false;
      this.cannotDelete = false;
      this.optionsVisible = false;
      this.item.unbind('error', this.handleSaveError);
      if ((ref = this.namesFromDbRadio) != null) {
        ref.release();
      }
      if ((ref1 = this.namesFromFormRadio) != null) {
        ref1.release();
      }
      if ((ref2 = this.expressionFromSqlCheckbox) != null) {
        ref2.release();
      }
      if ((ref3 = this.parentDimensionCheckbox) != null) {
        ref3.release();
      }
      if ((ref4 = this.availableByDefaultCheckbox) != null) {
        ref4.release();
      }
      this.html(this.view('redesign/dashboards/filter_form')());
      this.resetScrollBind();
      this.created = false;
      if (newItem != null) {
        this.item = newItem;
        this.item.bind('error', this.handleSaveError);
      }
      return this.resetErrorState();
    };

    RedesignFilterForm.prototype.resetErrorState = function() {
      this.clearErrors();
      if (this.item.isErrored()) {
        return this.showAlertError();
      }
    };

    RedesignFilterForm.prototype.showAlertError = function() {
      var refAndError;
      refAndError = App.AlertHelpers.determineErrorReferenceAndMessage(this.item.error_message);
      this.alertReferenceEl.text(refAndError.alertReference);
      this.alertMessageEl.text(refAndError.alertMsg);
      return this.alertBlockEl.addClass('error').show();
    };

    RedesignFilterForm.prototype.showForm = function() {
      if (this.open) {
        return;
      }
      this.dashboard.trigger('dimension-form-opened');
      App.Dashboard.trigger('suppress-other-modals', {
        opener: this
      });
      this.open = true;
      RedesignFilterForm.__super__.showForm.apply(this, arguments);
      this.clearErrors();
      if (this.created) {
        return this.el.addClass(this.constructor.OPEN_CLASSES);
      } else {
        this.el.addClass('open');
        this.firstRender();
        this.created = true;
        this.el.addClass('scrollable');
        if (this.codemirrorLoaded) {
          this.resetErrorState();
        }
        return requestAnimationFrame(((function(_this) {
          return function() {
            if (_this.namesFromDbRadio.selected()) {
              _this.sizeValuesArea(_this.namesFromDbValueArea);
            }
            return requestAnimationFrame((function() {
              return _this.el.addClass('slideable');
            }));
          };
        })(this)));
      }
    };

    RedesignFilterForm.prototype.maybeHideDeleteButton = function() {
      var ref;
      if (((ref = this.item) != null ? ref.hasSharedDashboardFactories() : void 0) || !this.itemIsExisting()) {
        return this.deletionArea.hide();
      } else {
        return this.deletionArea.show();
      }
    };

    RedesignFilterForm.prototype.positionOfDimSetting = function() {
      var del, id;
      id = App.CustomDimension.elementIdForDimension(this.item);
      del = this.settingsEl().find(".dimension-setting[dimension=" + id + "]");
      if ((del != null ? del.length : void 0) > 0) {
        return {
          left: del.position().left,
          width: del.width(),
          top: del.position().top + 55
        };
      }
      this.el.css('left', '');
      this.el.css('top', '');
      return null;
    };

    RedesignFilterForm.prototype.repositionSelf = function() {
      var dimPos, formBottomOffset, formHeight, formWidth, leftOffset, topOffset, windowHeight;
      dimPos = this.positionOfDimSetting();
      formWidth = this.el.width();
      if (dimPos === null) {
        this.setPosition(null);
        return;
      }
      formHeight = RedesignFilterForm.FILTER_EDITOR_WINDOW_HEIGHT;
      formBottomOffset = RedesignFilterForm.FILTER_EDITOR_WINDOW_BOTTOM_MARGIN;
      windowHeight = window.innerHeight;
      leftOffset = 0;
      topOffset = 0;
      if (dimPos.left > formWidth) {
        leftOffset = dimPos.left - formWidth;
      } else {
        leftOffset = dimPos.left + dimPos.width;
      }
      if (dimPos.top + formHeight > windowHeight) {
        topOffset = windowHeight - formHeight - formBottomOffset;
      } else {
        topOffset = dimPos.top;
      }
      return this.setPosition(leftOffset, topOffset);
    };

    RedesignFilterForm.prototype.sizeValuesArea = function(v, extraChange) {
      if (extraChange == null) {
        extraChange = 0;
      }
      return v.height(v.find('.values-content').outerHeight() + extraChange);
    };

    RedesignFilterForm.prototype.getDatabase = function() {
      return App.Database.exists(parseInt(this.namesFromDbDatabaseSelect.val())) || this.getDefaultDatabase();
    };

    RedesignFilterForm.prototype.getDefaultDatabase = function() {
      return App.User.defaultDbForCurrentUser();
    };

    RedesignFilterForm.prototype.getDbMode = function() {
      return this.getDatabase().dbHighlightMode();
    };

    RedesignFilterForm.prototype.emptyOrStr = function(str) {
      if ((str != null) && str.trim() !== '') {
        return str;
      }
      return '';
    };

    RedesignFilterForm.prototype.itemIsExisting = function() {
      return (this.item != null) && (this.item.id != null) && !App.Utils.isClientId(this.item.id);
    };

    RedesignFilterForm.prototype.settingsEl = function() {
      return $('.dashboard-settings-frame');
    };

    RedesignFilterForm.prototype.dashboardEl = function() {
      return $('.dashboard-container');
    };

    RedesignFilterForm.prototype.setPosition = function(left, top) {
      if (left == null) {
        return;
      }
      if (top != null) {
        return this.el.css({
          left: left + "px",
          top: top + "px"
        });
      } else {
        return this.el.css({
          left: left + "px",
          top: ""
        });
      }
    };

    RedesignFilterForm.prototype.codemirrorLoaded = function() {
      this.codemirrorLoaded = true;
      if (this.namesFromDbRadio.selected()) {
        this.resetErrorState();
        this.sizeValuesArea(this.namesFromDbValueArea);
      }
      if (this.optionsVisible) {
        return this.fitExpressionFormChildren();
      }
    };

    return RedesignFilterForm;

  })(App.RedesignDashboardSettingsForm);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignFullDataTable = (function(superClass) {
    extend(RedesignFullDataTable, superClass);

    function RedesignFullDataTable() {
      this.handleViewportChange = bind(this.handleViewportChange, this);
      this.renderRow = bind(this.renderRow, this);
      this.render = bind(this.render, this);
      return RedesignFullDataTable.__super__.constructor.apply(this, arguments);
    }

    RedesignFullDataTable.GRID_MAX_DISPLAY_CHARS = 120;

    RedesignFullDataTable.DATA_TAB_HEIGHT = 960;

    RedesignFullDataTable.prototype.render = function() {
      var error, h, totalWidth;
      try {
        App.Utils.initRedesignCanvasWidthSizer();
        this.setColumnWidths();
        this.calcIndexWidth();
        this.initRowsLinesHeight();
        totalWidth = this.totalColumnWidth + 'px';
        h = this.view('redesign/ninja_grid/full_data_table_ninja_grid')({
          sortedByHeader: this.sortedByColumnIndex,
          totalWidth: totalWidth,
          indexWidth: this.indexWidth + 'px',
          totalHeaders: this.formattedColumnWidths,
          renderIndex: this.renderIndex,
          sortingDisabled: this.sortingDisabled
        });
        this.html(App.Utils.stripSpacesBetweenTags(h));
        this.resizeRowWrapper();
        if (App.SetUpScreenshotMode.inScreenshotMode()) {
          this.rowsWrapper.addClass('no-animate');
        }
        this.doRender();
        if (this.leftOffset != null) {
          this.rowsWrapper.scrollLeft(this.leftOffset);
        }
        this.refreshElements();
        return this.rowsWrapper[0].onscroll = this.handleViewportChange;
      } catch (error1) {
        error = error1;
        error.message = "" + error.message + (this.errorDetails());
        return AppRedesign.logError(error);
      }
    };

    RedesignFullDataTable.prototype.renderRow = function(rowIndex) {
      var borderClass, cell, cellBorderClass, column, currentTop, el, html, i, indexBorderClass, isEvenRow, j, k, len, linesOfTextBeforeCurrent, paddingLeft, ref, ref1, ref2, ref3, row, value, valueIsNumeric, valueStr;
      if (this.renderedEls[rowIndex]) {
        return this.renderedEls[rowIndex];
      }
      if (this.valueCols().length === 0) {
        return;
      }
      row = this.processRow(rowIndex);
      this.setRowLinesHeight(rowIndex);
      linesOfTextBeforeCurrent = 0;
      for (i = j = 0, ref = rowIndex; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        linesOfTextBeforeCurrent += this.rowNumOfLines[i];
      }
      currentTop = linesOfTextBeforeCurrent * this.constructor.ROW_HEIGHT;
      el = document.createElement("div");
      isEvenRow = rowIndex % 2 === 0;
      el.className = "row " + (isEvenRow ? 'even' : 'odd');
      html = [];
      borderClass = 'right-border';
      if (this.renderIndex) {
        indexBorderClass = borderClass;
        if (this.centerAlign()) {
          indexBorderClass = 'right-border';
        }
        html.push(this.view('redesign/ninja_grid/full_data_table_ninja_cell')({
          val: rowIndex + 1,
          cssClassName: "index",
          left: this.addUnits(0),
          borderClass: indexBorderClass,
          top: this.addUnits(currentTop),
          width: this.indexWidth + 'px',
          height: this.addUnits(this.constructor.ROW_HEIGHT * this.rowNumOfLines[rowIndex])
        }));
      }
      ref1 = this.columns;
      for (i = k = 0, len = ref1.length; k < len; i = ++k) {
        column = ref1[i];
        if (!this.colsOnPage[i]) {
          continue;
        }
        value = row[column] != null ? row[column]["value"] : "";
        valueStr = '' + value;
        valueIsNumeric = this.twiddles.getForColumn(column, 'type') === 'numeric';
        cellBorderClass = borderClass;
        if (i === this.columns.length - 1) {
          cellBorderClass = '';
        }
        paddingLeft = (ref2 = row[column]) != null ? ref2['paddingLeft'] : void 0;
        cell = this.view('redesign/ninja_grid/full_data_table_ninja_cell')({
          isLink: (ref3 = row[column]) != null ? ref3["isLink"] : void 0,
          fullValue: valueStr,
          val: valueStr,
          cssClassName: " " + (this.cellCssAlignmentClass(column, valueIsNumeric)),
          left: this.leftOffsets[i],
          borderClass: cellBorderClass,
          top: this.addUnits(currentTop),
          width: this.columnWidths[i],
          height: this.addUnits(this.constructor.ROW_HEIGHT * this.rowNumOfLines[rowIndex]),
          row: rowIndex,
          column: i,
          paddingLeft: paddingLeft
        });
        html.push(cell);
      }
      el.innerHTML = html.join("");
      this.renderedEls[rowIndex] = el;
      return el;
    };

    RedesignFullDataTable.prototype.updateRowsHeight = function() {
      var i, j, linesCount, ref;
      linesCount = 0;
      for (i = j = 0, ref = this.rowNumOfLines.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        linesCount += this.rowNumOfLines[i];
      }
      return this.rows.height(this.constructor.ROW_HEIGHT * linesCount);
    };

    RedesignFullDataTable.prototype.handleViewportChange = function(e) {
      var colsOnPageChanged, contentStart, el, i, j, k, len, parent_widget_container, purgeDownTo, purgeUpTo, ref, ref1, ref2, ref3, ref4, row, rowBatchEl, rowIndex, scrollTop, target_width, viewportHeight, wrapper, wrapperHeight;
      App.Utils.initRedesignCanvasWidthSizer();
      wrapper = this.rowsWrapper[0];
      parent_widget_container = this.parentWidgetContent();
      target_width = (ref = parent_widget_container != null ? parent_widget_container.width() : void 0) != null ? ref : 0;
      ref1 = this.headerRow;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        row = ref1[i];
        row.style.left = -wrapper.scrollLeft + "px";
        row.style.top = i * this.constructor.HEADER_HEIGHT + "px";
      }
      if (this.noBodyBorder && target_width > this.totalColumnWidth) {
        this.tableBorder[0].style.left = -wrapper.scrollLeft + "px";
      }
      scrollTop = wrapper.scrollTop;
      wrapperHeight = this.targetHeight() - this.constructor.HEADER_HEIGHT;
      if (AppRedesign.isNewLook()) {
        wrapperHeight += 12;
      }
      purgeDownTo = this.rowsDownToRemove(scrollTop);
      contentStart = this.rowsScrolled;
      viewportHeight = this.rowsInViewport(wrapperHeight);
      purgeUpTo = Math.min(contentStart + viewportHeight + this.constructor.EXTRA_ROW_TO_RENDER, this.allSortedRawRows.length);
      if (this.lastScrollLeft !== wrapper.scrollLeft || this.lastRowWrapperWidth !== this.rowsWrapper.width()) {
        colsOnPageChanged = this.updateColsOnPage();
        this.lastScrollLeft = wrapper.scrollLeft;
        this.lastRowWrapperWidth = this.rowsWrapper.width();
      }
      ref2 = this.rowsOnPage;
      for (rowIndex in ref2) {
        el = ref2[rowIndex];
        if (rowIndex < purgeDownTo || rowIndex > purgeUpTo || colsOnPageChanged) {
          el.parentNode.removeChild(el);
          delete this.rowsOnPage[rowIndex];
        }
      }
      if (colsOnPageChanged) {
        this.renderedEls = {};
      }
      rowBatchEl = document.createElement("div");
      rowBatchEl.className = "row-batch";
      for (i = k = ref3 = purgeDownTo, ref4 = purgeUpTo; ref3 <= ref4 ? k < ref4 : k > ref4; i = ref3 <= ref4 ? ++k : --k) {
        if (this.rowsOnPage[i]) {
          continue;
        }
        row = this.renderRow(i);
        if (!row) {
          break;
        }
        rowBatchEl.appendChild(row);
        this.rowsOnPage[i] = row;
      }
      return this.rows.append(rowBatchEl);
    };

    RedesignFullDataTable.prototype.initRowsLinesHeight = function() {
      var i, index, j, k, len, results, row, rows;
      this.rowNumOfLines = [];
      rows = [];
      if (this.allSortedRawRows != null) {
        for (i = j = 0; j <= 29; i = ++j) {
          if (i >= this.allSortedRawRows.length) {
            break;
          }
          rows.push(this.processRow(i));
        }
      }
      results = [];
      for (index = k = 0, len = rows.length; k < len; index = ++k) {
        row = rows[index];
        results.push(this.setRowLinesHeight(index));
      }
      return results;
    };

    RedesignFullDataTable.prototype.setRowLinesHeight = function(rowIndex) {
      var columnIndex, columnWidth, contentFullWidth, key, linesForColumn, linesForRow, row, value;
      row = this.allSortedRawRows[rowIndex];
      columnIndex = 0;
      linesForRow = 0;
      for (key in row) {
        value = row[key];
        columnWidth = this.rawColumnWidths[columnIndex];
        contentFullWidth = App.Utils.canvasWidthForText(value);
        linesForColumn = Math.ceil(contentFullWidth / columnWidth);
        linesForRow = Math.max(linesForRow, linesForColumn);
        columnIndex += 1;
      }
      this.rowNumOfLines[rowIndex] = Math.max(1, linesForRow);
      return this.updateRowsHeight();
    };

    RedesignFullDataTable.prototype.rowsDownToRemove = function(scrollTop) {
      var j, len, linesInRow, ref, rowsHeightPx;
      rowsHeightPx = 0;
      this.rowsScrolled = 0;
      ref = this.rowNumOfLines;
      for (j = 0, len = ref.length; j < len; j++) {
        linesInRow = ref[j];
        rowsHeightPx += linesInRow * this.constructor.ROW_HEIGHT;
        if (scrollTop < rowsHeightPx) {
          break;
        }
        this.rowsScrolled += 1;
      }
      return Math.max(0, this.rowsScrolled - this.constructor.EXTRA_ROW_TO_RENDER);
    };

    RedesignFullDataTable.prototype.rowsInViewport = function(wrapperHeight) {
      var i, j, ref, ref1, rowsHeightPx, rowsViewport;
      rowsHeightPx = 0;
      rowsViewport = 0;
      for (i = j = ref = this.rowsScrolled, ref1 = this.rowNumOfLines.length - 1; ref <= ref1 ? j <= ref1 : j >= ref1; i = ref <= ref1 ? ++j : --j) {
        rowsHeightPx += this.rowNumOfLines[i] * this.constructor.ROW_HEIGHT;
        if (wrapperHeight < rowsHeightPx) {
          break;
        }
        rowsViewport += 1;
      }
      return rowsViewport;
    };

    return RedesignFullDataTable;

  })(App.RedesignDataTable);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignHistoryController = (function(superClass) {
    extend(RedesignHistoryController, superClass);

    RedesignHistoryController.prototype.className = 'chart-format-wrapper history';

    RedesignHistoryController.prototype.elements = {
      '.results-area': 'resultsArea'
    };

    RedesignHistoryController.prototype.events = {
      'click .history-item .apply': 'applyHistory'
    };

    RedesignHistoryController.RESULTS_LOADING = "Loading history...";

    function RedesignHistoryController() {
      this.archivesRecv = bind(this.archivesRecv, this);
      this.applyHistory = bind(this.applyHistory, this);
      RedesignHistoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.historian = (function() {
        switch (this.item.constructor.className) {
          case App.SqlView.className:
            return App.SqlViewHistorian;
          case App.Widget.className:
            return App.WidgetHistorian;
          case App.SqlSnippet.className:
            return App.SqlSnippetHistorian;
          case App.SqlAlert.className:
            return App.SqlAlertHistorian;
          default:
            throw new Error("No historian class found for " + this.item.constructor.className);
        }
      }).call(this);
      this.failCount = 0;
      this.fetchArchived();
      this.render();
    }

    RedesignHistoryController.prototype.refresh = function() {
      return this.fetchArchived();
    };

    RedesignHistoryController.prototype.release = function() {
      return RedesignHistoryController.__super__.release.apply(this, arguments);
    };

    RedesignHistoryController.prototype.unrender = function() {
      this.resultsArea.html('');
      return this.rendered = false;
    };

    RedesignHistoryController.prototype.render = function() {
      var histories, history, i, lastPrettyDate, len, prettyDate, views;
      App.Lagotron.addContext("History render");
      this.html(this.view('redesign/editors/history/history')());
      views = [];
      lastPrettyDate = null;
      histories = this.historian.getHistory(this.item.id);
      for (i = 0, len = histories.length; i < len; i++) {
        history = histories[i];
        prettyDate = App.Utils.roundedAgoFromDateString(history.date, 'ago');
        if (prettyDate !== lastPrettyDate) {
          views.push(this.view('redesign/editors/history/header')({
            header: prettyDate
          }));
          lastPrettyDate = prettyDate;
        }
        views.push(this.renderArchiveHistory(history));
      }
      if (histories.length === 0) {
        if (this.fetching) {
          views.push(this.renderMessage(this.constructor.RESULTS_LOADING));
        } else {
          views.push(this.renderNoResultsMessage(this.historian.NO_RESULTS));
        }
      }
      this.resultsArea.html(views.join(''));
      this.refreshElements();
      this.rendered = true;
      return this.logFeature('history-open-tab');
    };

    RedesignHistoryController.prototype.renderNoResultsMessage = function(msg) {
      return this.view('redesign/editors/history/no_results')({
        errorText: msg
      });
    };

    RedesignHistoryController.prototype.renderMessage = function(msg) {
      return this.view('redesign/editors/history/item')({
        message: msg,
        cssClass: 'message',
        applyDisabled: true
      });
    };

    RedesignHistoryController.prototype.renderArchiveHistory = function(history) {
      var amPM, hours, minutes, time, timeString;
      time = new Date(history.date);
      hours = (time.getHours() % 12) || 12;
      amPM = time.getHours() > 11 ? 'pm' : 'am';
      minutes = time.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      timeString = hours + ":" + minutes + amPM;
      return this.view('redesign/editors/history/item')({
        message: history.message,
        time: timeString,
        archivedId: history.archivedId,
        applyDisabled: history.applyDisabled,
        cssClass: ''
      });
    };

    RedesignHistoryController.prototype.applyHistory = function(event) {
      var archivedId, target;
      target = $(event.target).closest('.history-item');
      archivedId = target.attr('archived_id');
      this.getHistorian().applyHistory(archivedId);
      this.trigger('refresh');
      return this.logFeature('history-revert');
    };

    RedesignHistoryController.prototype.getHistorian = function() {
      return new App.Historian(this.item);
    };

    RedesignHistoryController.prototype.logFeature = function(msg) {
      var ref;
      return App.Utils.logFeature(msg, {
        dashboard_id: (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0,
        className: this.item.constructor.className,
        id: this.item.id
      });
    };

    RedesignHistoryController.prototype.fetchArchived = function() {
      var ref, ref1, ref2;
      if (AppRedesign.autoArchiveEnabled() && (this.item.archived_at != null)) {
        return;
      }
      if (!(this.item.id && !App.Utils.isClientId(this.item.id))) {
        return;
      }
      if (((ref = this.historian) != null ? ref.modelName : void 0) == null) {
        return;
      }
      this.fetching = true;
      return jQuery.ajax({
        url: "/" + ((ref1 = this.historian) != null ? ref1.modelName() : void 0) + "s/" + this.item.id + "/" + ((ref2 = this.historian) != null ? ref2.modelName() : void 0) + "_history",
        type: 'GET',
        dataType: 'json'
      }).always(this.archivesRecv);
    };

    RedesignHistoryController.prototype.archivesRecv = function(response) {
      var ref;
      this.fetching = false;
      if (response.archived_widgets) {
        App.ArchivedWidget.applyUpdates(response.archived_widgets);
      } else if (response.archived_sql_views) {
        App.ArchivedSqlView.applyUpdates(response.archived_sql_views);
        if (response.cache_schedules) {
          App.CacheSchedule.applyUpdates(response.cache_schedules);
        }
      } else if (response.archived_sql_snippets) {
        App.ArchivedSqlSnippet.applyUpdates(response.archived_sql_snippets);
      } else if (response.archived_sql_alerts) {
        App.ArchivedSqlAlert.applyUpdates(response.archived_sql_alerts);
      } else {
        this.failCount++;
        if (this.failCount > 5) {
          AppRedesign.logError(new Error("Failed to get archived " + ((ref = this.historian) != null ? ref.modelName() : void 0) + "s after " + this.failCount + " tries for " + this.item.id));
        } else {
          this.fetchArchived();
        }
      }
      if (this.rendered) {
        return this.render();
      }
    };

    return RedesignHistoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignLeftNavUpsellPromoTooltipController = (function(superClass) {
    extend(RedesignLeftNavUpsellPromoTooltipController, superClass);

    function RedesignLeftNavUpsellPromoTooltipController(settingsWheelEl, upsellTooltipEl) {
      this.settingsWheelEl = settingsWheelEl;
      this.upsellTooltipEl = upsellTooltipEl;
      this.noOpAndStopPropagation = bind(this.noOpAndStopPropagation, this);
      this.closeClicked = bind(this.closeClicked, this);
      this.panelClicked = bind(this.panelClicked, this);
      this.reattachEventHandlers = bind(this.reattachEventHandlers, this);
      this.showPromoTooltip = bind(this.showPromoTooltip, this);
      RedesignLeftNavUpsellPromoTooltipController.__super__.constructor.call(this);
      this.showPromoTooltip();
    }

    RedesignLeftNavUpsellPromoTooltipController.prototype.showPromoTooltip = function() {
      var pointerDirection, pointerOffsetPercent, targetHeightIndentPercent, targetWidthIndentPercent, width;
      if (!this.settingsWheelEl || !this.upsellTooltipEl || !this.settingsWheelEl.length || !this.upsellTooltipEl.length) {
        return;
      }
      pointerDirection = App.RedesignTooltipPanel.LEFT;
      pointerOffsetPercent = 0.45;
      targetWidthIndentPercent = 0.015;
      targetHeightIndentPercent = 0.145;
      width = '286px';
      this.panel = new App.RedesignTooltipPanel({
        el: this.upsellTooltipEl,
        pointerOffsetPercent: pointerOffsetPercent,
        side: pointerDirection,
        useSmallPointer: true,
        width: width
      });
      if (!this.panel) {
        return;
      }
      this.panel.renderPanel();
      this.panel.pointAtEl(pointerDirection, this.settingsWheelEl, pointerOffsetPercent, targetWidthIndentPercent, targetHeightIndentPercent);
      return this.reattachEventHandlers();
    };

    RedesignLeftNavUpsellPromoTooltipController.prototype.reattachEventHandlers = function() {
      var ref, ref1, ref2, ref3, ref4, ref5;
      if (!this.panel) {
        return;
      }
      if ((ref = this.panel.panel) != null) {
        ref.off();
      }
      if ((ref1 = this.panel.panel) != null) {
        ref1.on('click', this.panelClicked);
      }
      if ((ref2 = this.panel.panelContent) != null) {
        ref2.off();
      }
      if ((ref3 = this.panel.panelContent) != null) {
        ref3.on('click', this.panelClicked);
      }
      if ((ref4 = this.panel.$('.close')) != null) {
        ref4.off();
      }
      if ((ref5 = this.panel.$('.close')) != null) {
        ref5.on('click', this.closeClicked);
      }
      this.panel.mouseEntered = this.noOpAndStopPropagation;
      return this.panel.mouseLeft = this.noOpAndStopPropagation;
    };

    RedesignLeftNavUpsellPromoTooltipController.prototype.panelClicked = function(evt) {
      var ref, ref1, ref2;
      if (evt != null) {
        evt.stopPropagation();
      }
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        if ((ref = window.reactApp) != null) {
          ref.dispatchDeepAnalysisUpsellFeaturesDialogModal();
        }
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        if ((ref1 = window.reactApp) != null) {
          ref1.dispatchAddUpsellFeaturesDialogModal();
        }
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        if ((ref2 = window.reactApp) != null) {
          ref2.dispatchEmbedUpsellFeaturesDialogModal();
        }
      }
      return this.release();
    };

    RedesignLeftNavUpsellPromoTooltipController.prototype.closeClicked = function(evt) {
      if (evt != null) {
        evt.stopPropagation();
      }
      return this.release();
    };

    RedesignLeftNavUpsellPromoTooltipController.prototype.noOpAndStopPropagation = function(evt) {
      return evt != null ? evt.stopPropagation() : void 0;
    };

    RedesignLeftNavUpsellPromoTooltipController.prototype.release = function() {
      var base, ref, ref1, ref2;
      if (!this.panel) {
        RedesignLeftNavUpsellPromoTooltipController.__super__.release.apply(this, arguments);
        return;
      }
      if (typeof (base = this.panel).release === "function") {
        base.release();
      }
      delete this.panel;
      App.Utils.logFeature('upsell-ac-left-nav-promo-tooltip-dismissed');
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        if ((ref = App.User.currentUser()) != null) {
          ref.markLeftNavSettingsUpsellTooltipSeenDeepAnalysis();
        }
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        if ((ref1 = App.User.currentUser()) != null) {
          ref1.markLeftNavSettingsUpsellTooltipSeenWaas();
        }
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        if ((ref2 = App.User.currentUser()) != null) {
          ref2.markLeftNavSettingsUpsellTooltipSeenEmbed();
        }
      }
      return RedesignLeftNavUpsellPromoTooltipController.__super__.release.apply(this, arguments);
    };

    return RedesignLeftNavUpsellPromoTooltipController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignLeftNavigation = (function(superClass) {
    extend(RedesignLeftNavigation, superClass);

    RedesignLeftNavigation.prototype.className = 'left-navigation';

    RedesignLeftNavigation.prototype.elements = {
      '.control.search-icon': 'searchIcon',
      '.control.star-icon': 'starIcon',
      '.control.dashboard-icon': 'dashboardIcon',
      '.control.sql-icon': 'sqlIcon',
      '.control.sql-alert-icon': 'sqlAlertIcon',
      '.control.csv-icon': 'csvIcon',
      '.control.settings-wheel': 'settingsWheel',
      '.control.help-icon': 'helpIcon',
      '.upsell-indicator': 'upsellIndicator',
      '.control.settings-wheel .tooltip-panel.upsell-tooltip': 'upsellTooltipEl'
    };

    RedesignLeftNavigation.prototype.events = {
      'click .top-controls .control ': 'controlClick',
      'click .space-icon': 'controlClick',
      'click .settings-wheel': 'settingsWheelClick',
      'click .help-icon': 'helpIconClick'
    };

    RedesignLeftNavigation.DEEP_ANALYSIS_UPSELL_TOOLTIP_MESSAGE = 'SQL, Python, and R: Together on One Platform for the First Time.';

    RedesignLeftNavigation.WAAS_UPSELL_TOOLTIP_MESSAGE = 'Visualize SQL View dependencies with Sisense for Cloud Data Teams Warehouse';

    RedesignLeftNavigation.EMBED_UPSELL_TOOLTIP_MESSAGE = 'Embed analytics inside your';

    RedesignLeftNavigation.EMBED_UPSELL_TOOLTIP_MESSAGE2 = 'portal, website, or product';

    function RedesignLeftNavigation() {
      this.createSqlPermissionEnabled = bind(this.createSqlPermissionEnabled, this);
      this.helpIconClick = bind(this.helpIconClick, this);
      this.settingsWheelClick = bind(this.settingsWheelClick, this);
      this.ensureNoUpsellTooltip = bind(this.ensureNoUpsellTooltip, this);
      this.maybeShowUpsellTooltip = bind(this.maybeShowUpsellTooltip, this);
      this.maybeShowUpsellIndicator = bind(this.maybeShowUpsellIndicator, this);
      this.topicsEnabled = bind(this.topicsEnabled, this);
      this.displayDashboards = bind(this.displayDashboards, this);
      this.controlClick = bind(this.controlClick, this);
      this.iconContent = bind(this.iconContent, this);
      this.iconInfo = bind(this.iconInfo, this);
      this.render = bind(this.render, this);
      RedesignLeftNavigation.__super__.constructor.apply(this, arguments);
      App.Site.bind('group-change', this.render);
      App.User.bind('change', this.maybeShowUpsellIndicator);
      App.User.bind('change', this.maybeShowUpsellTooltip);
      this.render();
    }

    RedesignLeftNavigation.prototype.render = function() {
      var initiallyOpenedMenu, ref, ref1, ref2, site, upsellTooltipMessage, upsellTooltipMessage2;
      initiallyOpenedMenu = this.el.find('.open').data('menu');
      site = App.Site.first();
      upsellTooltipMessage = '';
      upsellTooltipMessage2 = '';
      if (App.Site.first().shouldShowDeepAnalysisUpsellPromo()) {
        upsellTooltipMessage = this.constructor.DEEP_ANALYSIS_UPSELL_TOOLTIP_MESSAGE;
      } else if (App.Site.first().shouldShowWaasUpsellPromo()) {
        upsellTooltipMessage = this.constructor.WAAS_UPSELL_TOOLTIP_MESSAGE;
      } else if (App.Site.first().shouldShowEmbedUpsellPromo()) {
        upsellTooltipMessage = this.constructor.EMBED_UPSELL_TOOLTIP_MESSAGE;
        upsellTooltipMessage2 = this.constructor.EMBED_UPSELL_TOOLTIP_MESSAGE2;
      }
      if (site.dataEngineCloudAdminSite()) {
        this.html(this.view('redesign/controls/left_navigation_dec')());
      } else {
        this.html(this.view('redesign/controls/left_navigation')({
          noDbMode: this.noDbMode,
          spaceEnabled: (site.isSpacesEnabled() && App.Utils.adminUser()) || site.hasMultipleSitesInFamily(),
          tutorialMolePresent: AppRedesign.current().tutorial() != null,
          upsellTooltipMessage: upsellTooltipMessage,
          upsellTooltipMessage2: upsellTooltipMessage2,
          canCreateSql: this.createSqlPermissionEnabled(),
          topicEnabled: this.topicsEnabled(),
          displayDashboards: this.displayDashboards(),
          userCanExplore: (ref = App.User.currentUser()) != null ? ref.canExplore() : void 0,
          customerUnificationEnabled: AppRedesign.hasCustomerUnification()
        }));
      }
      this.el.find(".control[data-menu=" + initiallyOpenedMenu + "]").addClass('open');
      if ((ref1 = this.iconTooltipHelper) != null) {
        if ((ref2 = ref1.descriptionTooltip) != null) {
          ref2.closeAndRelease();
        }
      }
      this.iconTooltipHelper = new App.IconTooltipHelper({
        icon: this.el.find('.control'),
        infoCallback: this.iconInfo,
        contentCallback: this.iconContent,
        direction: App.RedesignTooltipPanel.LEFT,
        tooltipClass: 'leftnav-tooltip',
        leftOffset: 1,
        topOffset: 10,
        activeClass: '',
        exitClass: 'selected'
      });
      this.maybeShowUpsellIndicator();
      return this.maybeShowUpsellTooltip();
    };

    RedesignLeftNavigation.prototype.iconInfo = function(evt) {
      return $(evt.currentTarget).data('tooltip');
    };

    RedesignLeftNavigation.prototype.iconContent = function(evt) {
      if ($(evt.currentTarget).data('tooltip') === 'Spaces') {
        return App.Site.first().display_name;
      }
    };

    RedesignLeftNavigation.prototype.unselect = function() {
      this.iconTooltipHelper.iconMouseLeave();
      return this.el.find('.control.selected').removeClass('selected');
    };

    RedesignLeftNavigation.prototype.controlClick = function(ev) {
      var button, buttonName, globalSearchItems, wasSelected;
      button = $(ev.currentTarget);
      buttonName = button.data('menu');
      globalSearchItems = ['Topic', 'Dashboard', 'View', 'SqlSnippet', 'SqlAlert'];
      if (button.data('menu') === 'Explore') {
        return App.RouteHelper.navigateTo('Explore');
      }
      if (button.data('menu') === 'Search') {
        return this.openGlobalSearchDialog();
      }
      if (['Favorites'].includes(button.data('menu'))) {
        return;
      }
      wasSelected = button.hasClass('selected');
      this.unselect();
      if (wasSelected) {
        return this.trigger('hide-menu');
      } else if (!$('.left-menu').hasClass('closing')) {
        button.addClass('selected');
        this.trigger('show-menu', buttonName, button.data('title'));
        if (globalSearchItems.includes(buttonName)) {
          return App.Utils.logFeature('left-hand-nav-selected', {
            detail: buttonName
          });
        }
      }
    };

    RedesignLeftNavigation.prototype.displayDashboards = function() {
      if (AppRedesign.hasCustomerUnification() && AppRedesign.allowRevokingWorkbooksAccess() && !AppRedesign.hasWorkbooksAccess()) {
        return false;
      }
      return !AppRedesign.current().state.RbacEnabled || AppRedesign.hasPrivileges();
    };

    RedesignLeftNavigation.prototype.topicsEnabled = function() {
      return AppRedesign.dashboardOrganizationEnabled() && this.displayDashboards();
    };

    RedesignLeftNavigation.prototype.maybeShowUpsellIndicator = function() {
      var ref;
      return this.upsellIndicator.toggle((ref = App.User.currentUser()) != null ? ref.shouldShowLeftNavSettingsPromoIndicator() : void 0);
    };

    RedesignLeftNavigation.prototype.maybeShowUpsellTooltip = function() {
      var ref, ref1, ref2;
      if (!((ref = App.User.currentUser()) != null ? ref.shouldShowLeftNavSettingsUpsellTooltip() : void 0)) {
        this.ensureNoUpsellTooltip();
        return;
      }
      if (!this.didFeatureLogPromoTooltipSeen) {
        App.Utils.logFeature('upsell-ac-left-nav-tooltip-seen');
        this.didFeatureLogPromoTooltipSeen = true;
      }
      if ((ref1 = this.iconTooltipHelper) != null) {
        ref1.skipMakingLeftNavSettingsTooltip = true;
      }
      if ((ref2 = this.upsellTooltipEl) != null) {
        ref2.show();
      }
      this.upsellTooltipController = new App.RedesignLeftNavUpsellPromoTooltipController(this.settingsWheel, this.upsellTooltipEl);
      if (this.upsellTooltipController.jquery) {
        debugger;
      }
    };

    RedesignLeftNavigation.prototype.ensureNoUpsellTooltip = function() {
      var ref, ref1;
      if ((ref = this.upsellTooltipEl) != null) {
        ref.hide();
      }
      if ((ref1 = this.iconTooltipHelper) != null) {
        ref1.skipMakingLeftNavSettingsTooltip = false;
      }
      if (this.upsellTooltipController) {
        this.upsellTooltipController.release();
        return delete this.upsellTooltipController;
      }
    };

    RedesignLeftNavigation.prototype.settingsWheelClick = function(ev) {
      this.ensureNoUpsellTooltip();
      return this.controlClick(ev);
    };

    RedesignLeftNavigation.prototype.helpIconClick = function() {
      window.open(AppRedesign.DOC_PATH);
      return App.Utils.logFeature("opened-help");
    };

    RedesignLeftNavigation.prototype.close = function() {
      this.unselect();
      return this.trigger('hide-menu');
    };

    RedesignLeftNavigation.prototype.createSqlPermissionEnabled = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canEdit() : void 0;
      }
    };

    RedesignLeftNavigation.prototype.openGlobalSearchDialog = function() {
      var ref;
      App.Utils.logFeature('global-search-opened', {
        detail: 'search-icon'
      });
      return (ref = window.reactApp) != null ? ref.openGlobalSearch() : void 0;
    };

    return RedesignLeftNavigation;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignLinkedWidgetController = (function(superClass) {
    extend(RedesignLinkedWidgetController, superClass);

    RedesignLinkedWidgetController.prototype.className = 'linked-widget-panel chart-tooltip-boundary';

    RedesignLinkedWidgetController.prototype.elements = {
      '.main-panel': 'mainPanel',
      '.chart-header .title': 'chartTitle'
    };

    RedesignLinkedWidgetController.prototype.events = {
      'click .back-to-dash': 'close'
    };

    function RedesignLinkedWidgetController() {
      this.scheduleUpdateWidgetSize = bind(this.scheduleUpdateWidgetSize, this);
      this.update = bind(this.update, this);
      this.close = bind(this.close, this);
      var dashboard;
      RedesignLinkedWidgetController.__super__.constructor.apply(this, arguments);
      AppRedesign.current().setCurrentState(AppRedesign.IN_SINGLE_WIDGET);
      this.render();
      dashboard = this.dashboard();
      if (!dashboard.isActive()) {
        dashboard.makeCurrent();
      }
      App.Utils.logFeature('linked-widget-view', {
        dashboard_id: this.dashboard().id
      });
      App.Site.bind('all-updates', this.update);
      $(window).on('resize', this.scheduleUpdateWidgetSize);
      if (AppRedesign.current().shared_mode) {
        AppRedesign.current().setupScreenshotMode();
      }
    }

    RedesignLinkedWidgetController.prototype.release = function() {
      var ref, ref1;
      RedesignLinkedWidgetController.__super__.release.apply(this, arguments);
      if (App.linkedWidgetFormulaSourceHashKey) {
        delete App.linkedWidgetFormulaSourceHashKey;
      }
      if (App.codeLinkedWidgetFormulaSourceHashKey) {
        delete App.codeLinkedWidgetFormulaSourceHashKey;
      }
      if ((ref = this.widget) != null) {
        ref.unbind('update', this.update);
      }
      AppRedesign.current().setCurrentState(AppRedesign.IN_DASH);
      if ((ref1 = this.widgetController) != null) {
        ref1.release();
      }
      App.Site.unbind('all-updates', this.update);
      $('#body').removeClass('linked-widget-mode');
      return $(window).off('resize', this.scheduleUpdateWidgetSize);
    };

    RedesignLinkedWidgetController.prototype.close = function() {
      var currentDash, i, len, ref, ref1, w;
      this.release();
      if ((ref = this.widget) != null) {
        ref.reload();
      }
      currentDash = App.Dashboard.currentDashboard();
      if (currentDash == null) {
        return;
      }
      App.RouteHelper.navigateTo('Dashboard', currentDash);
      currentDash.trigger(App.Dashboard.EVENT_CONFIG_CHANGED);
      ref1 = currentDash.widgets();
      for (i = 0, len = ref1.length; i < len; i++) {
        w = ref1[i];
        w.trigger('update');
      }
      return currentDash.trigger(App.Dashboard.EVENT_CONFIG_RESET);
    };

    RedesignLinkedWidgetController.prototype.update = function(updatesByDash) {
      var newHeight, newWidth, oldHeight, oldWidth, ref, ref1;
      if ((updatesByDash != null) && (updatesByDash[(ref = this.widgetController) != null ? ref.item.dashboard_id : void 0] != null)) {
        if ((ref1 = this.widgetController) != null) {
          ref1.update();
        }
      }
      if (this.widget == null) {
        return;
      }
      this.chartTitle.text(this.widget.getTitleForDisplay());
      oldWidth = this.widgetController.el.width();
      oldHeight = this.widgetController.el.height();
      this.setWidgetPosition();
      newWidth = this.widgetController.el.width();
      newHeight = this.widgetController.el.height();
      if (!(newWidth === oldWidth && newHeight === oldHeight)) {
        return this.renderWidget();
      }
    };

    RedesignLinkedWidgetController.prototype.scheduleUpdateWidgetSize = function(e) {
      if (e.target !== window) {
        return;
      }
      clearTimeout(this.resizeTimer);
      return this.resizeTimer = setTimeout(this.update, 500);
    };

    RedesignLinkedWidgetController.prototype.dashboard = function() {
      var dashboardId, hashDash, ref, ref1;
      hashDash = parseInt(window.location.hash.substring(1));
      dashboardId = ((ref = this.widget) != null ? ref.dashboard_id : void 0) || hashDash || ((ref1 = App.Dashboard.currentDashboard()) != null ? ref1.id : void 0);
      if (App.Dashboard.exists(dashboardId)) {
        return App.Dashboard.find(dashboardId);
      }
      return App.Dashboard.first();
    };

    RedesignLinkedWidgetController.prototype.render = function() {
      var ref;
      $('#body').addClass('linked-widget-mode');
      if (!this.widget) {
        this.html(this.view('redesign/dashboards/link_to_widget_not_found')());
        return;
      }
      this.html(this.view('redesign/dashboards/link_to_widget_frame')({
        spaceName: App.Site.first().spaceName()
      }));
      this.$('.app-footer').append(this.view('redesign/dashboards/powered_by')());
      this.widget.bind('update', this.update);
      this.widget.fetchSource();
      this.chartTitle.text(this.widget.getTitleForDisplay());
      this.renderWidget();
      if ((ref = this.dashboard()) != null ? ref.isReadOnlyToCurrentUser() : void 0) {
        return this.el.addClass('read-only');
      }
    };

    RedesignLinkedWidgetController.prototype.renderWidget = function() {
      this.widgetController = new App.LinkedWidgetContainerController({
        item: this.widget
      });
      this.mainPanel.html(this.widgetController.el);
      this.bubbles(this.widgetController, 'edit-widget');
      this.setWidgetPosition();
      return this.widgetController.renderIfInViewport();
    };

    RedesignLinkedWidgetController.prototype.setWidgetPosition = function() {
      return new App.RedesignDashboardSizer(App.Dashboard.currentDashboard()).setWidgetDashboardPosition(this.widgetController.el, this.widget);
    };

    return RedesignLinkedWidgetController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignPermissionDeniedController = (function(superClass) {
    extend(RedesignPermissionDeniedController, superClass);

    RedesignPermissionDeniedController.prototype.className = 'permission-denied modal';

    RedesignPermissionDeniedController.prototype.elements = {
      '.button.refresh': 'refreshButton'
    };

    RedesignPermissionDeniedController.prototype.events = {
      'click .button.refresh': 'clickedRefresh',
      'click .cancel-icon': 'cancel'
    };

    function RedesignPermissionDeniedController() {
      RedesignPermissionDeniedController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignPermissionDeniedController.prototype.render = function() {
      this.html(this.view('redesign/controls/permission_denied')({}));
      return $('#modal').empty().append(this.el);
    };

    RedesignPermissionDeniedController.prototype.clickedRefresh = function() {
      return location.reload();
    };

    RedesignPermissionDeniedController.prototype.cancel = function() {
      return this.release();
    };

    RedesignPermissionDeniedController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignPermissionDeniedController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return RedesignPermissionDeniedController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignPlaceholderSettingsController = (function(superClass) {
    extend(RedesignPlaceholderSettingsController, superClass);

    RedesignPlaceholderSettingsController.prototype.className = 'placeholder-settings';

    RedesignPlaceholderSettingsController.prototype.render = function() {
      return this.html('');
    };

    function RedesignPlaceholderSettingsController() {
      RedesignPlaceholderSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    RedesignPlaceholderSettingsController.prototype.refresh = function() {};

    return RedesignPlaceholderSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignRadioButton = (function(superClass) {
    extend(RedesignRadioButton, superClass);

    RedesignRadioButton.prototype.elements = {
      '.icon': 'icon',
      '.label': 'label'
    };

    RedesignRadioButton.prototype.events = {
      'click .icon': 'clickedRadioButton',
      'click .label': 'clickedRadioButton'
    };

    RedesignRadioButton.NOTHING_SELECTED = null;

    function RedesignRadioButton() {
      this.clickedRadioButton = bind(this.clickedRadioButton, this);
      var capitalizedTextLabel;
      RedesignRadioButton.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'callback');
      capitalizedTextLabel = this.labelText ? this.labelText[0].toUpperCase() + this.labelText.slice(1) : '';
      this.html(this.view('radio_button')({
        label: capitalizedTextLabel,
        labelClass: this.labelClass
      }));
      if (this.iconClass == null) {
        this.iconClass = 'radio-button';
      }
      this.el.addClass(this.iconClass);
      if (this.enabled == null) {
        this.enabled = true;
      }
      if (this.enabled !== true) {
        this.el.addClass('disabled');
      }
      this.lastClickedAt = 0;
    }

    RedesignRadioButton.prototype.setSelected = function(isSelected, isDefault) {
      if (isDefault == null) {
        isDefault = false;
      }
      if (isSelected || isDefault) {
        return this.el.addClass('selected');
      } else {
        return this.el.removeClass('selected');
      }
    };

    RedesignRadioButton.prototype.toggle = function() {
      if (this.explicitlySelected()) {
        return this.setSelected(false);
      } else {
        return this.setSelected(true);
      }
    };

    RedesignRadioButton.prototype.clickedRadioButton = function(e) {
      var callbackValue;
      if (!this.enabled) {
        return false;
      }
      if (!(this.explicitlySelected() && this.disableDeselection)) {
        this.toggle();
      }
      callbackValue = this.selected() ? this.value : RedesignRadioButton.NOTHING_SELECTED;
      this.callback(callbackValue, this.clickOptions());
      return e != null ? e.stopPropagation() : void 0;
    };

    RedesignRadioButton.prototype.selected = function() {
      return this.explicitlySelected();
    };

    RedesignRadioButton.prototype.unselected = function() {
      return !this.selected();
    };

    RedesignRadioButton.prototype.explicitlySelected = function() {
      return this.el.hasClass('selected');
    };

    RedesignRadioButton.prototype.clickOptions = function() {
      return {
        doubleClick: this.isDoubleClick()
      };
    };

    RedesignRadioButton.prototype.isDoubleClick = function() {
      var doubleClick;
      doubleClick = RedesignRadioButton.isDoubleClick(this.lastClickedAt);
      this.lastClickedAt = RedesignRadioButton.lastClickedAtForDoubleClick(doubleClick);
      return doubleClick;
    };

    RedesignRadioButton.isDoubleClick = function(lastClickedAt) {
      var elapsed;
      elapsed = AppRedesign.timestamp() - lastClickedAt;
      return elapsed < AppRedesign.DOUBLE_CLICK_TIMEFRAME;
    };

    RedesignRadioButton.lastClickedAtForDoubleClick = function(doubleClick) {
      if (doubleClick) {
        return 0;
      } else {
        return AppRedesign.timestamp();
      }
    };

    return RedesignRadioButton;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignRadioButtonGroup = (function(superClass) {
    extend(RedesignRadioButtonGroup, superClass);

    RedesignRadioButtonGroup.prototype.className = 'radio-button-group';

    function RedesignRadioButtonGroup() {
      this.clickedRadioOption = bind(this.clickedRadioOption, this);
      var i, len, radioButton, radioOption, ref;
      RedesignRadioButtonGroup.__super__.constructor.apply(this, arguments);
      if (this.callback == null) {
        throw new Error('requires callback');
      }
      if (!((this.radioOptions != null) && this.radioOptions.length > 0)) {
        throw new Error('requires radioOptions');
      }
      if (this.optionCompareFunc == null) {
        this.optionCompareFunc = (function(a, b) {
          return a === b;
        });
      }
      if (this.disableDeselection == null) {
        this.disableDeselection = true;
      }
      this.radioButtons = [];
      ref = this.radioOptions;
      for (i = 0, len = ref.length; i < len; i++) {
        radioOption = ref[i];
        radioButton = new App.RedesignRadioButton({
          iconClass: radioOption.iconClass || 'small-radio-button',
          labelText: radioOption.label,
          labelClass: radioOption.labelClass,
          value: radioOption.value,
          disableDeselection: this.disableDeselection,
          callback: this.clickedRadioOption,
          enabled: !radioOption.disabled
        });
        this.radioButtons.push(radioButton);
        this.el.append(radioButton.el);
      }
      this.setValueOrDefault(this.initialValue, this.defaultValue);
    }

    RedesignRadioButtonGroup.prototype.release = function() {
      var i, len, radioButton, ref, results;
      RedesignRadioButtonGroup.__super__.release.apply(this, arguments);
      ref = this.radioButtons;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        results.push(radioButton.release());
      }
      return results;
    };

    RedesignRadioButtonGroup.prototype.setValueOrDefault = function(value, defaultValue) {
      var not_selected;
      not_selected = value === App.RedesignRadioButton.NOTHING_SELECTED || value === void 0;
      if (not_selected && (defaultValue != null)) {
        return this.setState(defaultValue, true);
      } else {
        return this.setState(value);
      }
    };

    RedesignRadioButtonGroup.prototype.selectedValue = function() {
      var i, len, radioButton, ref;
      ref = this.radioButtons;
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        if (radioButton.selected()) {
          return radioButton.value;
        }
      }
      return null;
    };

    RedesignRadioButtonGroup.prototype.getRadioButtons = function() {
      return this.radioButtons;
    };

    RedesignRadioButtonGroup.prototype.clickedRadioOption = function(value, clickOptions) {
      if (!clickOptions.doubleClick) {
        this.setValueOrDefault(value, this.defaultValue);
      }
      return this.callback(value, clickOptions);
    };

    RedesignRadioButtonGroup.prototype.setState = function(value, isDefault) {
      var i, j, len, len1, radioButton, ref, ref1, results;
      if (isDefault == null) {
        isDefault = false;
      }
      ref = this.radioButtons;
      for (i = 0, len = ref.length; i < len; i++) {
        radioButton = ref[i];
        radioButton.setSelected(false);
      }
      ref1 = this.radioButtons;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        radioButton = ref1[j];
        if (this.optionCompareFunc(radioButton.value, value)) {
          radioButton.setSelected(true, isDefault);
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    RedesignRadioButtonGroup.prototype.setDisabled = function(disabled) {
      var i, j, len, len1, radioButton, ref, ref1, results, results1;
      if (disabled) {
        this.el.addClass('disabled');
        ref = this.radioButtons;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          radioButton = ref[i];
          results.push(radioButton.enabled = false);
        }
        return results;
      } else {
        this.el.removeClass('disabled');
        ref1 = this.radioButtons;
        results1 = [];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          radioButton = ref1[j];
          results1.push(radioButton.enabled = true);
        }
        return results1;
      }
    };

    return RedesignRadioButtonGroup;

  })(Spine.Controller);

}).call(this);
(function() {
  App.RedesignRectangles = (function() {
    function RedesignRectangles() {}

    RedesignRectangles.INFINITE_LOOP_ITRS = 10000;

    RedesignRectangles.rearrange = function(rects, preferredRect, maxRowsHigh, inDashboard) {
      var _, changedRects, j, len, rect, tempChangedRects;
      if (inDashboard == null) {
        inDashboard = true;
      }
      if (App.NO_COLLISION_DETECTION) {
        return;
      }
      App.Lagotron.addContext("RedesignRectangles.rearrange");
      this.correctOutOfBoundsRects(rects);
      changedRects = {};
      if (inDashboard) {
        tempChangedRects = this.collapseEmptyRowsOld(rects, preferredRect);
        $.extend(changedRects, tempChangedRects);
      }
      tempChangedRects = this.swapRectsInSameRows(rects, preferredRect);
      $.extend(changedRects, tempChangedRects);
      tempChangedRects = this.moveCollidingRects(rects, preferredRect);
      $.extend(changedRects, tempChangedRects);
      tempChangedRects = this.collapseEmptyRowsOld(rects, preferredRect);
      $.extend(changedRects, tempChangedRects);
      if (inDashboard) {
        tempChangedRects = this.collapseEmptyRowsOld(rects);
        $.extend(changedRects, tempChangedRects);
      }
      if (inDashboard) {
        for (rect = j = 0, len = changedRects.length; j < len; rect = ++j) {
          _ = changedRects[rect];
          if (typeof rect.exists === "function" ? rect.exists() : void 0) {
            if (typeof rect.save === "function") {
              rect.save({
                ajax: false
              });
            }
          }
        }
      }
      return null;
    };

    RedesignRectangles.fitSameRow = function(rects, preferredRect, maxColsWide, maxRowsHigh) {
      var i, j, originalColumn, ref;
      if (preferredRect.getColumn() == null) {
        return false;
      }
      originalColumn = preferredRect.getColumn();
      for (i = j = 0, ref = maxColsWide; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        preferredRect.setColumn((originalColumn + i) % maxColsWide);
        this.correctOutOfBoundsRects([preferredRect], maxColsWide, maxRowsHigh);
        if (this.noRectsOverlap(rects)) {
          return true;
        }
      }
      preferredRect.setColumn(originalColumn);
      return false;
    };

    RedesignRectangles.rectsOverlap = function(a, b) {
      if (a.id === b.id) {
        return false;
      }
      return a.getColumn() < b.getColumn() + b.getWidth() && a.getColumn() + a.getWidth() > b.getColumn() && a.getRow() < b.getRow() + b.getHeight() && a.getRow() + a.getHeight() > b.getRow();
    };

    RedesignRectangles.rectOverlapsWithAny = function(rectList, rectToTest) {
      var j, len, rect;
      for (j = 0, len = rectList.length; j < len; j++) {
        rect = rectList[j];
        if (this.rectsOverlap(rect, rectToTest)) {
          return true;
        }
      }
      return false;
    };

    RedesignRectangles.noRectsOverlap = function(rects) {
      var a, b, j, k, len, len1;
      for (j = 0, len = rects.length; j < len; j++) {
        a = rects[j];
        for (k = 0, len1 = rects.length; k < len1; k++) {
          b = rects[k];
          if (this.rectsOverlap(a, b)) {
            return false;
          }
        }
      }
      return true;
    };

    RedesignRectangles.rectsSortedByRow = function(rects) {
      return rects.sort(function(a, b) {
        if (!((a.getRow() != null) && (a.getColumn() != null) && (a.getHeight() != null) && (b.getRow() != null) && (b.getColumn() != null) && (b.getHeight() != null))) {
          return 0;
        }
        if (a.getRow() !== b.getRow()) {
          return a.getRow() - b.getRow();
        } else if (a.getColumn() !== b.getColumn()) {
          return a.getColumn() - b.getColumn();
        } else {
          return a.getHeight() - b.getHeight();
        }
      });
    };

    RedesignRectangles.getOverlappingRectPair = function(rects, preferredRect, changedRects) {
      var _, j, k, l, len, len1, len2, len3, m, owner, squatter;
      if (preferredRect != null) {
        for (j = 0, len = rects.length; j < len; j++) {
          squatter = rects[j];
          if (this.rectsOverlap(preferredRect, squatter)) {
            return {
              owner: preferredRect,
              squatter: squatter
            };
          }
        }
      }
      if (changedRects != null) {
        for (_ in changedRects) {
          owner = changedRects[_];
          for (k = 0, len1 = rects.length; k < len1; k++) {
            squatter = rects[k];
            if (this.rectsOverlap(owner, squatter)) {
              return {
                owner: owner,
                squatter: squatter
              };
            }
          }
        }
      }
      for (l = 0, len2 = rects.length; l < len2; l++) {
        owner = rects[l];
        for (m = 0, len3 = rects.length; m < len3; m++) {
          squatter = rects[m];
          if (this.rectsOverlap(owner, squatter)) {
            return {
              owner: owner,
              squatter: squatter
            };
          }
        }
      }
      return null;
    };

    RedesignRectangles.correctOutOfBoundsRects = function(rects) {
      var j, len, rect;
      for (j = 0, len = rects.length; j < len; j++) {
        rect = rects[j];
        if (rect.getWidth() < 1) {
          rect.sizeTo(1, rect.getHeight());
        }
        if (rect.getHeight() < 1) {
          rect.sizeTo(rect.getWidth(), 1);
        }
        if (rect.getColumn() < 0) {
          rect.moveTo(0, rect.getRow());
        }
        if (rect.getRow() < 0) {
          rect.moveTo(rect.getColumn(), 0);
        }
      }
      return null;
    };

    RedesignRectangles.swapRectsInSameRows = function(rects, preferredRect) {
      var changedRects, i, j, ref, temporaryChangedRects;
      if (preferredRect == null) {
        return;
      }
      changedRects = {};
      for (i = j = 0, ref = preferredRect.getHeight(); 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        temporaryChangedRects = this.swapSameRowRects(rects, preferredRect, i);
        $.extend(changedRects, temporaryChangedRects);
      }
      return changedRects;
    };

    RedesignRectangles.swapSameRowRects = function(rects, preferredRect, rowOffset) {
      var changedRects, column, currentRect, currentRow, rectsToMove, sameRowRects;
      if (rowOffset == null) {
        rowOffset = 0;
      }
      if (preferredRect == null) {
        return [];
      }
      currentRow = preferredRect.getRow() + rowOffset;
      sameRowRects = this.rectsInRow(rects, currentRow);
      if (rowOffset > 0) {
        sameRowRects.push(preferredRect);
      }
      if (this.noRectsOverlap(sameRowRects)) {
        return [];
      }
      rectsToMove = sameRowRects.without(preferredRect);
      currentRect = rectsToMove.shift();
      column = 0;
      changedRects = {};
      while ((currentRect != null) && !this.noRectsOverlap(sameRowRects)) {
        if (column + currentRect.getWidth() <= preferredRect.getColumn() || column >= preferredRect.getColumn() + preferredRect.getWidth()) {
          currentRect.moveTo(column, currentRect.getRow(), false, false);
          changedRects[currentRect.id] = currentRect;
          column += currentRect.getWidth();
          currentRect = rectsToMove.shift();
        } else {
          column++;
        }
      }
      return changedRects;
    };

    RedesignRectangles.moveCollidingRects = function(rects, preferredRect) {
      var changedRects, currentIteration, overlappers, rectsByRow, rowChange;
      if (preferredRect == null) {
        preferredRect = null;
      }
      rectsByRow = this.rectsSortedByRow(rects);
      changedRects = {};
      overlappers = this.getOverlappingRectPair(rectsByRow, preferredRect);
      currentIteration = 0;
      while (overlappers != null) {
        rowChange = this.rowChangeForOverlappers(rectsByRow, preferredRect, overlappers.owner, overlappers.squatter);
        overlappers.squatter.moveTo(overlappers.squatter.getColumn(), overlappers.squatter.getRow() + rowChange, false, false);
        changedRects[overlappers.squatter.id] = overlappers.squatter;
        overlappers = this.getOverlappingRectPair(rectsByRow, preferredRect, changedRects);
        if (currentIteration++ >= RedesignRectangles.INFINITE_LOOP_ITRS) {
          this.logInfiniteLoopError();
          return [];
        }
      }
      return changedRects;
    };

    RedesignRectangles.collapseEmptyRows = function(rects) {
      var allRectGroups, changedRects, cumulativeDelta, currentRectEndRow, currentRectRow, firstPostitiveRowRectFound, j, k, l, len, len1, len2, len3, len4, m, maxNegativeRectEndRow, n, rect, rectGroup, rectGroupDelta, rectGroupEndRow, rectsByRow, ref, ref1;
      if (AppRedesign.current().getCurrentState() === AppRedesign.INTERACTIVE) {
        return;
      }
      if (!(rects.length > 0)) {
        return {};
      }
      changedRects = {};
      rectsByRow = this.rectsSortedByRow(rects);
      firstPostitiveRowRectFound = false;
      maxNegativeRectEndRow = 0;
      allRectGroups = [];
      rectGroup = [];
      for (j = 0, len = rectsByRow.length; j < len; j++) {
        rect = rectsByRow[j];
        currentRectRow = rect.getRow();
        currentRectEndRow = rect.getRow() + rect.getHeight();
        if (currentRectRow < 0) {
          if (currentRectEndRow > maxNegativeRectEndRow) {
            maxNegativeRectEndRow = currentRectEndRow;
          }
          continue;
        } else {
          if (!firstPostitiveRowRectFound) {
            rectGroupEndRow = currentRectEndRow;
            if (maxNegativeRectEndRow > 0) {
              rectGroupDelta = 0;
            } else {
              rectGroupDelta = currentRectRow;
            }
            firstPostitiveRowRectFound = true;
          }
        }
        if (currentRectRow > rectGroupEndRow) {
          allRectGroups.push({
            rects: rectGroup,
            delta: rectGroupDelta
          });
          rectGroup = [];
          rectGroupDelta = currentRectRow - rectGroupEndRow;
        }
        if (currentRectEndRow > rectGroupEndRow) {
          rectGroupEndRow = currentRectEndRow;
        }
        rectGroup.push(rect);
      }
      allRectGroups.push({
        rects: rectGroup,
        delta: rectGroupDelta
      });
      cumulativeDelta = 0;
      for (k = 0, len1 = allRectGroups.length; k < len1; k++) {
        rectGroup = allRectGroups[k];
        cumulativeDelta += rectGroup.delta;
        if (cumulativeDelta > 0) {
          ref = rectGroup.rects;
          for (l = 0, len2 = ref.length; l < len2; l++) {
            rect = ref[l];
            if ((rect.getRow() - cumulativeDelta) < 0) {
              return {};
            }
          }
        }
      }
      cumulativeDelta = 0;
      for (m = 0, len3 = allRectGroups.length; m < len3; m++) {
        rectGroup = allRectGroups[m];
        cumulativeDelta += rectGroup.delta;
        if (cumulativeDelta > 0) {
          ref1 = rectGroup.rects;
          for (n = 0, len4 = ref1.length; n < len4; n++) {
            rect = ref1[n];
            rect.moveTo(rect.getColumn(), rect.getRow() - cumulativeDelta, false, false);
            changedRects[rect.id] = rect;
          }
        }
      }
      return changedRects;
    };

    RedesignRectangles.collapseEmptyRowsOld = function(rects, unmoveableRect) {
      var block, changed, changedRects, collapseUpTo, iterationNum, j, len, maxRow, rowNum;
      if (unmoveableRect == null) {
        unmoveableRect = null;
      }
      iterationNum = 0;
      maxRow = this.maxRowForRects(rects);
      rowNum = 0;
      changedRects = {};
      while (rowNum < maxRow) {
        if (iterationNum++ > RedesignRectangles.INFINITE_LOOP_ITRS) {
          this.logInfiniteLoopError();
          return [];
        }
        collapseUpTo = this.canCollapseUpTo(rects, rowNum, unmoveableRect, maxRow);
        if (collapseUpTo > 0) {
          changed = false;
          for (j = 0, len = rects.length; j < len; j++) {
            block = rects[j];
            if (!(block.getRow() > rowNum && block.getRow() <= collapseUpTo)) {
              continue;
            }
            if ((unmoveableRect != null ? unmoveableRect.id : void 0) === block.id) {
              continue;
            }
            block.moveTo(block.getColumn(), block.getRow() - 1, false, false);
            changedRects[block.id] = block;
            changed = true;
          }
          if (!changed) {
            rowNum++;
          }
        } else {
          rowNum++;
        }
      }
      return changedRects;
    };

    RedesignRectangles.rowChangeForOverlappers = function(rects, preferredRect, owner, squatter) {
      var upChange;
      if ((preferredRect != null) && this.rectsOverlap(preferredRect, squatter)) {
        upChange = this.roomToMoveUpBy(rects, squatter, preferredRect.getHeight());
        if (upChange > 0) {
          return -1 * upChange;
        }
      }
      return (owner.getRow() + owner.getHeight()) - squatter.getRow();
    };

    RedesignRectangles.roomToMoveUpBy = function(rects, rectToTest, maxMove) {
      var i, j, ref;
      for (i = j = 1, ref = maxMove; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        if (this.roomToMoveUpByRows(rects, rectToTest, i)) {
          return i;
        }
      }
      return 0;
    };

    RedesignRectangles.roomToMoveUpByRows = function(rects, rectToTest, upByRows) {
      var intersectRect;
      intersectRect = this.makeIntersectRect(rectToTest.getColumn(), rectToTest.getRow() - upByRows, rectToTest.getWidth(), rectToTest.getHeight(), rectToTest.id);
      if (intersectRect.getRow() < 0) {
        return false;
      }
      return !this.rectOverlapsWithAny(rects, intersectRect);
    };

    RedesignRectangles.sumRowWidth = function(rects, rowNum) {
      var j, len, r, rowWidth;
      rowWidth = 0;
      for (j = 0, len = rects.length; j < len; j++) {
        r = rects[j];
        if (r.getRow() <= rowNum && r.getRow() + r.getHeight() > rowNum) {
          rowWidth += r.getWidth();
        }
      }
      return rowWidth;
    };

    RedesignRectangles.rectsInRow = function(rects, rowNum) {
      var r, sameRowRects;
      sameRowRects = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = rects.length; j < len; j++) {
          r = rects[j];
          if (r.getRow() + r.getHeight() > rowNum && r.getRow() <= rowNum) {
            results.push(r);
          }
        }
        return results;
      })();
      sameRowRects.sort(function(a, b) {
        return a.getColumn() - b.getColumn();
      });
      return sameRowRects;
    };

    RedesignRectangles.maxRowForRects = function(rects) {
      var rect;
      return ((function() {
        var j, len, results;
        results = [];
        for (j = 0, len = rects.length; j < len; j++) {
          rect = rects[j];
          results.push(rect.getRow());
        }
        return results;
      })()).max();
    };

    RedesignRectangles.canCollapseUpTo = function(rects, rowNum, unmoveableRect, maxRow) {
      var changed, j, k, len, maxCollapse, maxWidth, rect, rectsCopy, ref, testMax, unmoveableRectId;
      maxWidth = _.max(_.map(rects, ((function(_this) {
        return function(r) {
          return r.getWidth() + r.getColumn();
        };
      })(this))));
      if (this.rectOverlapsWithAny(rects, this.makeIntersectRect(0, rowNum, maxWidth, 1))) {
        return -1;
      }
      unmoveableRectId = (unmoveableRect != null ? unmoveableRect.id : App.Utils.makeGuid());
      maxCollapse = -1;
      for (testMax = j = ref = maxRow; j >= 0; testMax = j += -1) {
        rectsCopy = this.cloneRectFrames(rects, rowNum, testMax);
        changed = false;
        for (k = 0, len = rectsCopy.length; k < len; k++) {
          rect = rectsCopy[k];
          if (rect.id !== unmoveableRectId) {
            rect.setRow(rect.getRow() - 1);
            changed = true;
          }
        }
        if (changed && this.noRectsOverlap(rectsCopy)) {
          maxCollapse = testMax;
          break;
        }
      }
      return maxCollapse;
    };

    RedesignRectangles.makeIntersectRect = function(column, row, width, height, id) {
      var rect;
      if (id == null) {
        id = App.Utils.makeGuid();
      }
      rect = {
        width: width,
        height: height,
        column: column,
        row: row,
        id: id
      };
      this.addGettersAndSetters(rect);
      return rect;
    };

    RedesignRectangles.cloneRectFrames = function(rects, minRow, maxRow) {
      var j, len, rect, results;
      results = [];
      for (j = 0, len = rects.length; j < len; j++) {
        rect = rects[j];
        if (rect.getRow() <= maxRow && rect.getRow() > minRow) {
          results.push(this.cloneRectFrame(rect));
        }
      }
      return results;
    };

    RedesignRectangles.cloneRectFrame = function(rect) {
      rect = {
        column: rect.getColumn(),
        row: rect.getRow(),
        width: rect.getWidth(),
        height: rect.getHeight(),
        id: rect.id
      };
      this.addGettersAndSetters(rect);
      return rect;
    };

    RedesignRectangles.addGettersAndSetters = function(rect) {
      rect.getRow = function() {
        return rect.row;
      };
      rect.setRow = function(row) {
        return rect.row = row;
      };
      rect.getColumn = function() {
        return rect.column;
      };
      rect.setColumn = function(column) {
        return rect.column = column;
      };
      rect.getWidth = function() {
        return rect.width;
      };
      rect.setWidth = function(width) {
        return rect.width = width;
      };
      rect.getHeight = function() {
        return rect.height;
      };
      return rect.setHeight = function(height) {
        return rect.height = height;
      };
    };

    RedesignRectangles.rectToString = function(rect) {
      return "#" + rect.id + ": " + (rect.getColumn()) + "," + (rect.getRow()) + " " + (rect.getWidth()) + "x" + (rect.getHeight());
    };

    RedesignRectangles.rectsToString = function(rects) {
      var rect;
      return ((function() {
        var j, len, results;
        results = [];
        for (j = 0, len = rects.length; j < len; j++) {
          rect = rects[j];
          results.push("  " + (this.rectToString(rect)));
        }
        return results;
      }).call(this)).join("\n");
    };

    RedesignRectangles.logInfiniteLoopError = function() {
      return AppRedesign.logError(new Error("Infinite loop on " + (App.Dashboard.currentDashboard().id)));
    };

    return RedesignRectangles;

  })();

}).call(this);
(function() {
  App.RedesignScreenshotDashboardSizer = (function() {
    RedesignScreenshotDashboardSizer.SLACK_HEADER_DEFAULT_HEIGHT = 102;

    RedesignScreenshotDashboardSizer.SLACK_ASPECT_RATIO_TARGET = 1.0;

    RedesignScreenshotDashboardSizer.SLACK_REFERENCE_WIDTH = 968;

    RedesignScreenshotDashboardSizer.SLACK_REFERENCE_ELEMENT_SIZE = {
      '.header-title': {
        fontSize: 33,
        lineHeight: 33
      },
      '.email-subheader': {
        fontSize: 24
      },
      '.dashboard-header': {
        paddingTop: 15
      },
      '.shared-mode-logo': {
        width: 187,
        height: 44,
        top: 28
      }
    };

    function RedesignScreenshotDashboardSizer(dashboard, slackMode, widgetMode, filterOffset, dashboardSizer) {
      this.dashboard = dashboard;
      this.slackMode = slackMode;
      this.widgetMode = widgetMode;
      this.filterOffset = filterOffset;
      this.bodyWidth = null;
      this.bodyHeight = null;
      this.headerHeight = null;
      this.columns = dashboardSizer.numCols(false, true);
      this.colWidth = dashboardSizer.SCREENSHOT_COLUMN_WIDTH;
      this.screenshotMargin = dashboardSizer.SCREENSHOT_MARGIN;
      this.leftGutterMargin = dashboardSizer.LEFT_GUTTER;
      this.linkedModeNumCols = dashboardSizer.LINKED_MODE_NUM_COLS;
      this.linkedModeNumRows = dashboardSizer.LINKED_MODE_NUM_ROWS;
      this.screenshotPadding = dashboardSizer.getScreenshotPadding();
      this.calculateDimensions();
    }

    RedesignScreenshotDashboardSizer.prototype.resizeHeaderForSlack = function() {
      this.resizeHeaderContentsForSlack();
      return this.resizeHeaderSizeForSlack();
    };

    RedesignScreenshotDashboardSizer.prototype.calculateDimensions = function() {
      if (this.slackMode) {
        return this.calculateDimensionsForSlack();
      } else {
        this.bodyWidth = this.columns * this.colWidth + this.screenshotMargin;
        return this.bodyHeight = this.getDashboardEmailHeight();
      }
    };

    RedesignScreenshotDashboardSizer.prototype.calculateDimensionsForSlack = function() {
      var ref;
      if (this.widgetMode) {
        this.bodyWidth = this.colWidth * this.linkedModeNumCols;
        return this.bodyHeight = this.colWidth * this.linkedModeNumRows;
      } else {
        this.bodyWidth = this.columns * this.colWidth + this.leftGutterMargin - 2;
        return ref = this.widgetAlignedHeightForAspectRatio(), this.bodyHeight = ref[0], this.headerHeight = ref[1], ref;
      }
    };

    RedesignScreenshotDashboardSizer.prototype.getDashboardEmailHeight = function() {
      var widgetsHeight;
      widgetsHeight = this.dashboard.nextFreeRow() * this.colWidth + 1;
      return widgetsHeight + this.screenshotPadding;
    };

    RedesignScreenshotDashboardSizer.prototype.resizeHeaderContentsForSlack = function() {
      var pixels, prop, props, ref, results, scale, selector, value;
      scale = this.scaleFactorForSlackHeader(this.bodyWidth, this.bodyHeight);
      ref = this.constructor.SLACK_REFERENCE_ELEMENT_SIZE;
      results = [];
      for (selector in ref) {
        props = ref[selector];
        results.push((function() {
          var results1;
          results1 = [];
          for (prop in props) {
            value = props[prop];
            pixels = Math.round(value * scale);
            results1.push(App.Utils.cssSet(selector, prop, pixels + "px"));
          }
          return results1;
        })());
      }
      return results;
    };

    RedesignScreenshotDashboardSizer.prototype.resizeHeaderSizeForSlack = function() {
      App.Utils.cssSet('.dashboard-header', 'height', this.headerHeight);
      return App.Utils.cssSet('.main-content', 'top', this.headerHeight + this.filterOffset);
    };

    RedesignScreenshotDashboardSizer.prototype.headeredHeight = function(width, height) {
      var expandedHeight, i, j, scale;
      expandedHeight = height;
      for (i = j = 1; j <= 5; i = ++j) {
        scale = this.scaleFactorForSlackHeader(width, expandedHeight);
        expandedHeight = height + this.constructor.SLACK_HEADER_DEFAULT_HEIGHT * scale;
      }
      return Math.round(expandedHeight);
    };

    RedesignScreenshotDashboardSizer.prototype.widgetAlignedHeightForAspectRatio = function() {
      var best, error, headeredHeightPx, height, j, len, ref, rowHeight, widget, widgetsHeightPx, widthPx;
      widthPx = this.columns * this.colWidth;
      rowHeight = this.colWidth;
      if (App.Widget.count() === 0) {
        height = this.constructor.SLACK_HEADER_DEFAULT_HEIGHT;
        return [height, headerHeight];
      }
      best = null;
      ref = App.Widget.all();
      for (j = 0, len = ref.length; j < len; j++) {
        widget = ref[j];
        widgetsHeightPx = (widget.fluid_row + widget.fluid_height) * rowHeight;
        headeredHeightPx = this.headeredHeight(widthPx, widgetsHeightPx);
        error = this.aspectRatioError(widthPx / headeredHeightPx);
        if (best === null || error < best.error) {
          best = {
            error: error,
            height: headeredHeightPx,
            headerHeight: headeredHeightPx - widgetsHeightPx
          };
        }
      }
      return [best.height, best.headerHeight];
    };

    RedesignScreenshotDashboardSizer.prototype.aspectRatioError = function(aspectRatio) {
      var ratio;
      ratio = this.constructor.SLACK_ASPECT_RATIO_TARGET / aspectRatio;
      if (ratio < 1) {
        return 1 / ratio;
      } else {
        return ratio;
      }
    };

    RedesignScreenshotDashboardSizer.prototype.scaleFactorForSlackHeader = function(width, height) {
      return Math.max(width, height) / this.constructor.SLACK_REFERENCE_WIDTH;
    };

    return RedesignScreenshotDashboardSizer;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSetPasswordFormController = (function(superClass) {
    extend(RedesignSetPasswordFormController, superClass);

    RedesignSetPasswordFormController.prototype.elements = {
      'input.first-name': 'firstNameInput',
      'input.last-name': 'lastNameInput',
      'select.role-picker': 'roleInput',
      'select.department-picker': 'departmentSelect',
      'input.password': 'passwordInput',
      'input.confirm-password': 'confirmPasswordInput',
      '.error-row .errors': 'error',
      '.eula.checkbox': 'eulaCheckbox',
      'td.password': 'passwordArea',
      'td.confirm-password': 'confirmPasswordArea',
      '.errors': 'allErrors',
      '.role-picker': 'rolePicker',
      '.react-root-use-case': 'reactRootUseCase'
    };

    RedesignSetPasswordFormController.prototype.events = {
      'click .done': 'formSubmit',
      'keypress .done': 'clickOnEnterOrSpace',
      'keypress input': 'keyPress',
      'click .eula.checkbox': 'checkboxClick',
      'keypress .icon': 'clickOnEnterOrSpace',
      'change .department-picker': 'onDepartmentChanged',
      'change .role-picker': 'onJobRoleChanged'
    };

    RedesignSetPasswordFormController.ERROR_MESSAGE = 'An error occurred, please try again.';

    RedesignSetPasswordFormController.SELECT_ROLE_MSG = 'Select your role';

    RedesignSetPasswordFormController.SELECT_DEPT_MSG = 'Select department first';

    RedesignSetPasswordFormController.DEPT_TO_ROLES = {
      'CEO/President': [],
      'Data': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Data Scientist', 'Data Analyst', 'Data Engineer'],
      'Product': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Product/Program Manager'],
      'Engineering': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Software Engineer'],
      'IT': ['C-Level Executive', 'VP', 'Director', 'Manager'],
      'Business/Revenue Operations': ['C-Level Executive', 'VP', 'Director', 'Manager'],
      'Sales': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Operations'],
      'Marketing': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Operations'],
      'Customer Success': ['C-Level Executive', 'Director', 'Manager', 'Operations'],
      'Customer Support': ['VP', 'Director', 'Manager', 'Operations'],
      'Finance': ['C-Level Executive', 'VP', 'Director', 'Manager', 'Operations'],
      'Human Resources': ['C-Level Executive', 'VP', 'Director', 'Manager'],
      'Other': ['Consultant/Agency', 'Job Applicant', 'Student', 'Other']
    };

    function RedesignSetPasswordFormController() {
      this.releaseSoon = bind(this.releaseSoon, this);
      this.setPasswordSuccess = bind(this.setPasswordSuccess, this);
      this.setPasswordFail = bind(this.setPasswordFail, this);
      this.hideError = bind(this.hideError, this);
      this.showError = bind(this.showError, this);
      this.checkboxClick = bind(this.checkboxClick, this);
      this.clickOnEnterOrSpace = bind(this.clickOnEnterOrSpace, this);
      this.keyPress = bind(this.keyPress, this);
      this.formSubmit = bind(this.formSubmit, this);
      this.useCaseChangedCallbackFn = bind(this.useCaseChangedCallbackFn, this);
      this.reRenderReactRootUseCase = bind(this.reRenderReactRootUseCase, this);
      this.onJobRoleChanged = bind(this.onJobRoleChanged, this);
      this.onDepartmentChanged = bind(this.onDepartmentChanged, this);
      var currentUser;
      RedesignSetPasswordFormController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'forgotPassword');
      currentUser = App.User.currentUser();
      this.showDepartment = AppRedesign.current().addDepartmentToSignup;
      this.department = currentUser.department;
      this.jobRole = currentUser.job_title;
      this.html(this.view('redesign/set_password/set_password_form_sidebar_flow')({
        forgotPassword: this.forgotPassword,
        email: currentUser.email_address,
        first_name: currentUser.first_name,
        last_name: currentUser.last_name,
        department: this.department,
        departments: Object.keys(this.constructor.DEPT_TO_ROLES),
        showDepartment: this.showDepartment,
        job_title: this.jobRole
      }));
      this.passwordInput.trigger('focus');
      if (!this.skipHotkeyDisable) {
        App.HotkeyManager.disable();
      }
      this.departmentSelect.chosen({
        disable_search: true,
        width: '100%'
      });
      this.rolePicker.chosen({
        disable_search: true,
        width: '100%'
      });
      if (!this.forgotPassword) {
        this.initReactRootUseCase();
      }
      if (!this.forgotPassword) {
        this.departmentSelect.on('chosen:showing_dropdown', this.reRenderReactRootUseCase);
      }
      if (!this.forgotPassword) {
        this.rolePicker.on('chosen:showing_dropdown', this.reRenderReactRootUseCase);
      }
      if (this.showDepartment) {
        this.renderJobRolePicker();
      }
    }

    RedesignSetPasswordFormController.prototype.renderJobRolePicker = function() {
      var optionsHtml;
      optionsHtml = '';
      if (this.validDepartmentSelected()) {
        optionsHtml = this.generateJobRolePickerHtml(this.constructor.DEPT_TO_ROLES[this.department]);
        if (this.selectedDepartmentHasNoRole()) {
          this.jobRole = '';
          this.setJobRoleSelectPlaceholder(this.department);
        } else if (this.selectedDepartmentDoesNotHaveSelectedRole()) {
          this.setJobRoleSelectPlaceholder(this.constructor.SELECT_ROLE_MSG);
        }
      } else {
        this.setJobRoleSelectPlaceholder(this.constructor.SELECT_DEPT_MSG);
      }
      optionsHtml = this.blankOption() + optionsHtml;
      this.roleInput.html(optionsHtml);
      return this.roleInput.trigger('chosen:updated');
    };

    RedesignSetPasswordFormController.prototype.validDepartmentSelected = function() {
      return (this.department != null) && (this.constructor.DEPT_TO_ROLES[this.department] != null);
    };

    RedesignSetPasswordFormController.prototype.selectedDepartmentHasNoRole = function() {
      return this.constructor.DEPT_TO_ROLES[this.department].length === 0;
    };

    RedesignSetPasswordFormController.prototype.selectedDepartmentDoesNotHaveSelectedRole = function() {
      return !this.constructor.DEPT_TO_ROLES[this.department].includes(this.jobRole);
    };

    RedesignSetPasswordFormController.prototype.generateJobRolePickerHtml = function(options) {
      return options.map((function(_this) {
        return function(option) {
          return _this.jobRoleOption(option);
        };
      })(this)).join('');
    };

    RedesignSetPasswordFormController.prototype.jobRoleOption = function(value) {
      var jobRoleSelected;
      jobRoleSelected = this.jobRole === value;
      if (jobRoleSelected) {
        return "<option value='" + value + "' selected>" + value + "</option>";
      } else {
        return "<option value='" + value + "'>" + value + "</option>";
      }
    };

    RedesignSetPasswordFormController.prototype.blankOption = function() {
      return '<option></option>';
    };

    RedesignSetPasswordFormController.prototype.setJobRoleSelectPlaceholder = function(text) {
      this.roleInput.attr('data-placeholder', text);
      return this.roleInput.trigger('liszt:updated');
    };

    RedesignSetPasswordFormController.prototype.onDepartmentChanged = function() {
      this.department = this.departmentSelect.val();
      return this.renderJobRolePicker();
    };

    RedesignSetPasswordFormController.prototype.onJobRoleChanged = function() {
      return this.jobRole = this.roleInput.val();
    };

    RedesignSetPasswordFormController.prototype.release = function() {
      var ref;
      if (this.RELEASED) {
        return;
      }
      this.RELEASED = true;
      if ((ref = this.useCaseReactRoot) != null) {
        ref.close();
      }
      RedesignSetPasswordFormController.__super__.release.apply(this, arguments);
      if (!this.skipHotkeyDisable) {
        App.HotkeyManager.enable();
      }
      if (this.closeCallback != null) {
        return this.closeCallback();
      }
    };

    RedesignSetPasswordFormController.prototype.initReactRootUseCase = function() {
      return this.useCaseReactRoot = window.reactApp.useCaseRoot(this.reactRootUseCase[0], this.useCaseChangedCallbackFn, this.useCase);
    };

    RedesignSetPasswordFormController.prototype.reRenderReactRootUseCase = function(_evt, _params) {
      var ref;
      if ((ref = this.useCaseReactRoot) != null) {
        ref.close();
      }
      return this.initReactRootUseCase();
    };

    RedesignSetPasswordFormController.prototype.useCaseChangedCallbackFn = function(useCase) {
      this.useCase = useCase;
    };

    RedesignSetPasswordFormController.prototype.mapUseCaseToPersona = function() {
      if (!this.useCase) {
        return null;
      }
      switch (this.useCase.value) {
        case 1:
          return 'data-analyst';
        case 2:
          return 'drag-drop-user';
        case 3:
          return 'consumer';
        default:
          return null;
      }
    };

    RedesignSetPasswordFormController.prototype.formSubmit = function() {
      var confirm, pass;
      this.hideError('');
      pass = this.passwordInput.val();
      confirm = this.confirmPasswordInput.val();
      if (!this.validate(pass, confirm)) {
        return;
      }
      if (!this.forgotPassword) {
        if (!this.validateEulaChecked()) {
          return;
        }
      }
      return this.postPassword(pass);
    };

    RedesignSetPasswordFormController.prototype.validateEulaChecked = function() {
      if (this.eulaCheckbox.hasClass('selected')) {
        return true;
      }
      this.showError(this.error, 'Sisense for Cloud Data Teams License Agreement must be accepted.');
      return false;
    };

    RedesignSetPasswordFormController.prototype.validate = function(pass, confirmedPass) {
      var error;
      this.clearErrorMessages();
      error = App.Utils.validatePassword(pass, confirmedPass);
      if (error != null) {
        switch (error) {
          case App.Utils.EMPTY_PASSWORD_MESSAGE:
            this.passwordArea.toggleClass('error', _.isEmpty(this.passwordInput.val()));
            this.confirmPasswordArea.toggleClass('error', _.isEmpty(this.confirmPasswordInput.val()));
            break;
          default:
            this.passwordArea.addClass('error');
            this.confirmPasswordArea.addClass('error');
        }
        this.showError(this.error, error);
        return false;
      }
      return true;
    };

    RedesignSetPasswordFormController.prototype.keyPress = function(event) {
      if (event.which === AppRedesign.KEYS.ENTER) {
        return this.formSubmit();
      }
    };

    RedesignSetPasswordFormController.prototype.clickOnEnterOrSpace = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER || e.which === AppRedesign.KEYS.SPACE) {
        return $(e.currentTarget).trigger('click');
      }
    };

    RedesignSetPasswordFormController.prototype.checkboxClick = function(e) {
      return this.eulaCheckbox.toggleClass('selected');
    };

    RedesignSetPasswordFormController.prototype.showError = function(el, msg) {
      el.text(msg);
      return this.trigger('error');
    };

    RedesignSetPasswordFormController.prototype.hideError = function() {
      this.error.text('');
      this.passwordArea.removeClass('error');
      return this.confirmPasswordArea.removeClass('error');
    };

    RedesignSetPasswordFormController.prototype.clearErrorMessages = function() {
      return this.allErrors.text('');
    };

    RedesignSetPasswordFormController.prototype.postPassword = function(pass) {
      var route;
      this.trigger('busy');
      if (this.forgotPassword) {
        route = "/users/set_password";
      } else {
        route = "/users/update";
      }
      return jQuery.post(route, {
        client_site_id: App.Site.first().id,
        raw_password: pass,
        sign_eula: !this.forgotPassword,
        first_name: this.firstNameInput.val(),
        last_name: this.lastNameInput.val(),
        department: this.department,
        job_title: this.jobRole,
        use_case: this.mapUseCaseToPersona()
      }).done(this.setPasswordSuccess).fail(this.setPasswordFail);
    };

    RedesignSetPasswordFormController.prototype.setPasswordFail = function(response) {
      return this.showError(this.error, this.constructor.ERROR_MESSAGE);
    };

    RedesignSetPasswordFormController.prototype.setPasswordSuccess = function(response) {
      if (response.error != null) {
        return this.showError(this.error, response.error);
      } else {
        this.hideError();
        this.setCurrentUserWindowVariablesForWalkMe();
        if (!this.forgotPassword) {
          App.User.trigger('wix-update');
        }
        this.trigger('success');
        if (!this.noAutoRelease) {
          return this.releaseSoon();
        }
      }
    };

    RedesignSetPasswordFormController.prototype.setCurrentUserWindowVariablesForWalkMe = function() {
      return AppRedesign.current().currentUser.use_case = this.mapUseCaseToPersona();
    };

    RedesignSetPasswordFormController.prototype.releaseSoon = function() {
      return setTimeout(this.release, App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignSetPasswordFormController.prototype.getTitle = function() {
      if (this.forgotPassword) {
        return 'Reset Your Password';
      } else {
        return 'Create Your Account';
      }
    };

    return RedesignSetPasswordFormController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSharedDashboardDetailController = (function(superClass) {
    extend(RedesignSharedDashboardDetailController, superClass);

    RedesignSharedDashboardDetailController.prototype.className = 'edit-share-form';

    RedesignSharedDashboardDetailController.prototype.elements = {
      '.button-area': 'buttonArea',
      '.settings-body': 'settingsBody',
      '.headers .filter-is-visible .info-icon': 'filterIsVisibleIcon',
      '.settings-body.dimensions-grid': 'filtersBox',
      '.title input': 'nameInput',
      '.security-advisory': 'securityAdvisoryText',
      '.password-toggler': 'passwordTogglerArea',
      '.password-input-area': 'passwordInputArea',
      '.password-input-area input': 'passwordInput',
      '.cross-out-line': 'crossOutLine',
      '.password-error-message': 'passwordErrorMessage'
    };

    RedesignSharedDashboardDetailController.prototype.events = {
      'mouseenter .filter-is-visible .info-icon': 'showFilterIsVisibleTooltip',
      'mouseleave .filter-is-visible .info-icon': 'hideFilterIsVisibleTooltip',
      'mouseenter .security-advisory': 'showSecurityAdvisoryTooltip',
      'mouseleave .security-advisory': 'hideSecurityAdvisoryTooltip',
      'click .bottom-box .checkbox': 'checkCheckbox',
      'click .custom-date-range .picker-button.start': 'clickDateRangeCustomRangeStartPick',
      'click .custom-date-range .picker-button.end': 'clickDateRangeCustomRangeEndPick',
      'click .view-hide-password': 'viewOrHidePassword',
      'focus .password-input-area input': 'passwordInputFocused'
    };

    RedesignSharedDashboardDetailController.prototype.editMode = function() {
      return this.sharedDashboard == null;
    };

    function RedesignSharedDashboardDetailController() {
      this.passwordLoadSuccess = bind(this.passwordLoadSuccess, this);
      this.updateSuccess = bind(this.updateSuccess, this);
      this.saveClicked = bind(this.saveClicked, this);
      this.createClicked = bind(this.createClicked, this);
      this.reparentElement = bind(this.reparentElement, this);
      this.hookUpDatePickers = bind(this.hookUpDatePickers, this);
      this.clickDateRangeCustomRangeEndPick = bind(this.clickDateRangeCustomRangeEndPick, this);
      this.clickDateRangeCustomRangeStartPick = bind(this.clickDateRangeCustomRangeStartPick, this);
      this.finalizeFromDateRangeCustomRangeBoxen = bind(this.finalizeFromDateRangeCustomRangeBoxen, this);
      this.checkCheckbox = bind(this.checkCheckbox, this);
      this.passwordToggled = bind(this.passwordToggled, this);
      this.hideSecurityAdvisoryTooltip = bind(this.hideSecurityAdvisoryTooltip, this);
      this.showSecurityAdvisoryTooltip = bind(this.showSecurityAdvisoryTooltip, this);
      this.hideFilterIsVisibleTooltip = bind(this.hideFilterIsVisibleTooltip, this);
      this.showFilterIsVisibleTooltip = bind(this.showFilterIsVisibleTooltip, this);
      RedesignSharedDashboardDetailController.__super__.constructor.apply(this, arguments);
      this.passwordsEnabled = AppRedesign.current().sharedDashboardPasswordEnabled;
      App.Utils.requires(this, 'shareHelper');
      this.chosens = [];
    }

    RedesignSharedDashboardDetailController.prototype.render = function() {
      this.renderView();
      if (this.editMode()) {
        return this.setupEditMode();
      }
    };

    RedesignSharedDashboardDetailController.prototype.renderView = function() {
      var ref, ref1, ref2;
      this.html(this.view('redesign/dashboard_preferences/shared_dashboard_detail')({
        canEdit: this.sharedDashboard == null,
        title: (ref = this.sharedDashboard) != null ? ref.title() : void 0,
        dims: this.shareHelper.getAvailableDims(this.sharedDashboard),
        shareUrl: (ref1 = this.sharedDashboard) != null ? ref1.shareUrl() : void 0,
        viewCount: ((ref2 = this.sharedDashboard) != null ? ref2.access_count : void 0) || 0,
        passwordsEnabled: this.passwordsEnabled
      }));
      if (this.passwordsEnabled) {
        this.setupPasswordArea();
      }
      this.setupButtons();
      return this.resizeFiltersBox();
    };

    RedesignSharedDashboardDetailController.prototype.setupButtons = function() {
      var action, ref;
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      action = this.editMode() ? 'create' : this.passwordsEnabled ? 'save' : void 0;
      this.buttons = new App.ButtonBlock({
        itemName: 'dashboard',
        buttonSize: 'small',
        action: action,
        delete_disabled: !this.editMode()
      });
      this.bubbles(this.buttons, 'cancel delete');
      this.buttons.bind('save', this.saveClicked);
      this.buttons.bind('create', this.createClicked);
      this.buttonArea.append(this.buttons.el);
      return this.buttons.render();
    };

    RedesignSharedDashboardDetailController.prototype.setupPasswordArea = function() {
      var ref;
      if ((ref = this.sharedDashboard) != null ? ref.password_protected : void 0) {
        this.loadPassword();
      }
      return this.setupPasswordToggler();
    };

    RedesignSharedDashboardDetailController.prototype.setupPasswordToggler = function() {
      var ref;
      this.passwordToggler = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: (ref = this.sharedDashboard) != null ? ref.password_protected : void 0,
        labelWhenToggleOn: 'Password Protected',
        labelWhenToggleOff: 'Password Protected'
      });
      this.passwordToggler.bind('toggled', this.passwordToggled);
      this.passwordTogglerArea.append(this.passwordToggler.el);
      return this.passwordToggled();
    };

    RedesignSharedDashboardDetailController.prototype.setupEditMode = function() {
      var sharesController;
      this.nameInput.trigger('focus');
      sharesController = this;
      return this.el.find('.bottom-box .body .selected-dimensions').each(function() {
        var cellEl, ch, dim, dim_cid, selectEl;
        cellEl = $(this);
        selectEl = cellEl.find('select');
        dim_cid = selectEl.attr('dim_cid');
        ch = null;
        dim = App.CustomDimension.find(dim_cid);
        if (dim_cid === "aggregation") {
          ch = App.Shares.setUpAggregationRow(selectEl);
          if (ch != null) {
            App.Shares.setUpExclusiveChosen(ch, sharesController);
          }
        } else if (dim_cid === "date_range" || dim.isDateRange()) {
          ch = App.Shares.setUpDateRangeRow(selectEl, sharesController, dim_cid);
          if (ch != null) {
            App.Shares.setUpExclusiveChosen(ch, sharesController);
          }
        } else if (App.CustomDimension.isCustomDimension(dim)) {
          ch = App.Shares.setUpCustomDimension(selectEl, sharesController);
        }
        if (ch != null) {
          return App.Shares.setUpChosenBinding(ch, sharesController);
        }
      });
    };

    RedesignSharedDashboardDetailController.prototype.unparentAllReparented = function() {
      var ref;
      return (ref = this.elementReparenter) != null ? ref.unparentEl() : void 0;
    };

    RedesignSharedDashboardDetailController.prototype.release = function() {
      var ref, ref1;
      this.safeReleasePickers();
      this.buttons.unbind('save', this.saveClicked);
      this.buttons.unbind('create', this.createClicked);
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      if ((ref1 = this.passwordToggler) != null) {
        ref1.unbind('toggled', this.passwordToggled);
      }
      return RedesignSharedDashboardDetailController.__super__.release.apply(this, arguments);
    };

    RedesignSharedDashboardDetailController.prototype.safeReleasePickers = function() {
      var datepickerEl, i, len, ref, results;
      try {
        ref = $('.hasDatepicker');
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          datepickerEl = ref[i];
          $(datepickerEl).datepicker('destroy');
          results.push($(datepickerEl).datepicker('destroy'));
        }
        return results;
      } catch (error) {

      }
    };

    RedesignSharedDashboardDetailController.prototype.showFilterIsVisibleTooltip = function() {
      var iconEl, iconElOffset, pointerOffset;
      pointerOffset = App.RedesignTooltipPanel.DEFAULT_POINTER_OFFSET;
      iconEl = this.filterIsVisibleIcon;
      iconElOffset = iconEl.offset();
      return this.filterIsVisibleTooltipPanel = App.RedesignTooltipPanel.addPanel({
        description: 'Visible filters are available to users to change on the shared dashboard.',
        pointerOffsetPercent: pointerOffset,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        width: '200px',
        useSmallPointer: true
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, iconEl, pointerOffset, iconElOffset.left + (iconEl.outerWidth() * App.RedesignTooltipPanel.DEFAULT_POINT_LEFT_SCALE), iconElOffset.top + (iconEl.outerHeight() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE) - 3);
    };

    RedesignSharedDashboardDetailController.prototype.hideFilterIsVisibleTooltip = function() {
      var ref;
      if ((ref = this.filterIsVisibleTooltipPanel) != null) {
        ref.closeAndRelease();
      }
      return delete this.filterIsVisibleTooltipPanel;
    };

    RedesignSharedDashboardDetailController.prototype.showSecurityAdvisoryTooltip = function() {
      return this.securityAdvisoryTimeout = setTimeout((function(_this) {
        return function() {
          var iconEl, iconElOffset, pointerOffset, tooltipText;
          pointerOffset = 0.5;
          iconEl = _this.securityAdvisoryText;
          iconElOffset = iconEl.offset();
          tooltipText = 'Using a password to limit access to Shared Dashboards is not as secure as issuing Sisense for Cloud Data Teams user accounts. Click the link to learn more.';
          return _this.securityAdvisoryTooltipPanel = App.RedesignTooltipPanel.addPanel({
            description: tooltipText,
            pointerOffsetPercent: pointerOffset,
            side: App.RedesignTooltipPanel.BOTTOM,
            title: App.RedesignTooltipPanel.BLANK_TITLE,
            width: '233px',
            useSmallPointer: true
          }).pointAt(App.RedesignTooltipPanel.BOTTOM, iconEl, pointerOffset, iconElOffset.left + (iconEl.outerWidth() * pointerOffset), iconElOffset.top + (iconEl.outerHeight() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE));
        };
      })(this), 200);
    };

    RedesignSharedDashboardDetailController.prototype.hideSecurityAdvisoryTooltip = function() {
      var ref;
      clearTimeout(this.securityAdvisoryTimeout);
      if ((ref = this.securityAdvisoryTooltipPanel) != null) {
        ref.closeAndRelease();
      }
      return delete this.securityAdvisoryTooltipPanel;
    };

    RedesignSharedDashboardDetailController.prototype.passwordToggled = function() {
      this.passwordInputArea.toggle(this.passwordToggler.isToggleOn);
      return this.resizeFiltersBox();
    };

    RedesignSharedDashboardDetailController.prototype.checkCheckbox = function(evt) {
      if (!this.editMode()) {
        return;
      }
      return $(evt.target).closest('.checkbox').toggleClass('selected');
    };

    RedesignSharedDashboardDetailController.prototype.finalizeFromDateRangeCustomRangeBoxen = function() {
      var dateRange, i, len, rangeEnd, rangeStart, ref, results;
      ref = $('.custom-date-range');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        dateRange = ref[i];
        rangeStart = $(dateRange).find('.range-start');
        rangeEnd = $(dateRange).find('.range-end');
        App.RedesignDateRangeDimensionSetting.cleanUserDateInput(rangeStart);
        App.RedesignDateRangeDimensionSetting.cleanUserDateInput(rangeEnd);
        results.push(App.RedesignDateRangeDimensionSetting.correctDateValuesIfReversed(rangeStart, rangeEnd));
      }
      return results;
    };

    RedesignSharedDashboardDetailController.prototype.clickDateRangeCustomRangeStartPick = function(e) {
      $(e.target).parent().find('.range-start').datepicker('show');
      return $('.ui-datepicker').addClass('dark-theme');
    };

    RedesignSharedDashboardDetailController.prototype.clickDateRangeCustomRangeEndPick = function(e) {
      $(e.target).parent().find('.range-end').datepicker('show');
      return $('.ui-datepicker').addClass('dark-theme');
    };

    RedesignSharedDashboardDetailController.prototype.hookUpDatePickers = function() {
      var datePickerOpts, i, j, len, len1, rangeEnd, rangeStart, ref, ref1, results;
      datePickerOpts = {
        showOn: "none",
        dateFormat: "yy-mm-dd",
        constrainInput: false,
        onClose: ((function(_this) {
          return function() {
            return setTimeout(_this.finalizeFromDateRangeCustomRangeBoxen, 0);
          };
        })(this))
      };
      ref = $('.range-start');
      for (i = 0, len = ref.length; i < len; i++) {
        rangeStart = ref[i];
        $(rangeStart).datepicker(datePickerOpts);
      }
      ref1 = $('.range-end');
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        rangeEnd = ref1[j];
        results.push($(rangeEnd).datepicker(datePickerOpts));
      }
      return results;
    };

    RedesignSharedDashboardDetailController.prototype.reparentElement = function(dimensionAreaEl, popOut) {
      var dim_cid, downEl, originalHome, ref;
      dim_cid = dimensionAreaEl.attr('dim_cid');
      if (dim_cid) {
        originalHome = this.el.find("[dim_cid=" + dim_cid + "] .selected-dimensions");
        originalHome.css({
          height: ""
        });
        downEl = dimensionAreaEl.closest(".dimension-area.open");
        downEl.find('.chosen-drop .chosen-results').html('');
        originalHome.append(downEl);
      }
      if (popOut) {
        dimensionAreaEl.parent().css({
          height: dimensionAreaEl.parent().height()
        });
        if ((ref = this.elementReparenter) != null) {
          ref.unparentEl();
        }
        this.elementReparenter = new App.ElementReparenter({
          el: dimensionAreaEl,
          scrollEl: this.settingsBody
        });
        return this.elementReparenter.reparentElWithClassname('dashboard-preferences-container');
      }
    };

    RedesignSharedDashboardDetailController.prototype.cleanChildren = function(parent_dim_cid) {
      var cd, child_cids, cid, groupSelectors, groups, i, len, parent_dim, ref, results, selectEl;
      if ((ref = this.elementReparenter) != null) {
        ref.unparentEl();
      }
      parent_dim = App.CustomDimension.find(parent_dim_cid);
      child_cids = (function() {
        var i, len, ref1, results;
        ref1 = App.CustomDimension.all();
        results = [];
        for (i = 0, len = ref1.length; i < len; i++) {
          cd = ref1[i];
          if (cd.parent_id === parent_dim.id) {
            results.push(cd.cid);
          }
        }
        return results;
      })();
      if (!child_cids.length) {
        return;
      }
      groups = this.customDimensionsList().filter(function(d) {
        return d[0] === parent_dim.id;
      }).map(function(d) {
        return d[1];
      });
      groupSelectors = groups.map(function(g) {
        return "not([group=" + g + "])";
      }).join(':');
      if (groupSelectors.length) {
        groupSelectors = ":" + groupSelectors;
      }
      results = [];
      for (i = 0, len = child_cids.length; i < len; i++) {
        cid = child_cids[i];
        selectEl = this.el.find("select[dim_cid=" + cid + "]");
        if (!selectEl.length) {
          continue;
        }
        selectEl.find('option' + groupSelectors).remove();
        results.push(selectEl.trigger('chosen:updated'));
      }
      return results;
    };

    RedesignSharedDashboardDetailController.prototype.name = function() {
      return this.nameInput.val();
    };

    RedesignSharedDashboardDetailController.prototype.unlockedFilters = function() {
      var el, i, len, ref, unlockedFilters;
      unlockedFilters = [];
      ref = this.settingsBody.find('.checkbox.selected');
      for (i = 0, len = ref.length; i < len; i++) {
        el = ref[i];
        unlockedFilters.push(App.CustomDimension.find($(el).attr("dim_cid")).id);
      }
      return JSON.stringify(unlockedFilters);
    };

    RedesignSharedDashboardDetailController.prototype.customDimensionsList = function() {
      var cid, customDimensionsList, dim, dimObj, group, i, j, len, len1, name, option, ref, row, sel, value;
      customDimensionsList = [];
      ref = this.settingsBody.find('.row.body');
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        cid = $(row).attr('dim_cid');
        if (!App.CustomDimension.isCustomDimensionId(cid)) {
          continue;
        }
        dim = App.CustomDimension.find(cid);
        sel = $(row).find('.selected-dimensions select option:selected');
        if (sel) {
          for (j = 0, len1 = sel.length; j < len1; j++) {
            option = sel[j];
            name = $(option).text();
            value = $(option).val();
            group = $(sel).attr('group');
            if (dim.isDateRange()) {
              dimObj = this.customDateRangeValue(row, sel);
              customDimensionsList.push([dim.id, dimObj, dimObj]);
            } else if ((group != null) && group !== "") {
              customDimensionsList.push([dim.id, value, name, group]);
            } else {
              customDimensionsList.push([dim.id, value, name]);
            }
          }
        }
      }
      return customDimensionsList;
    };

    RedesignSharedDashboardDetailController.prototype.customDateRangeValue = function(row, sel) {
      var json, selectedValue;
      selectedValue = $(sel[0]).val();
      if (selectedValue == null) {
        return null;
      }
      json = JSON.parse(selectedValue);
      if (json.type === App.RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE) {
        json.range_start = $(row).find('.range-start').val();
        json.range_end = $(row).find('.range-end').val();
        selectedValue = json;
      }
      return json;
    };

    RedesignSharedDashboardDetailController.prototype.getAggregation = function() {
      var aggregation, sel;
      aggregation = this.settingsBody.find('div[dim_cid=aggregation]');
      if (aggregation == null) {
        return null;
      }
      sel = $(aggregation).find('.selected-dimensions select option:selected');
      if (sel) {
        return $(sel[0]).val();
      }
    };

    RedesignSharedDashboardDetailController.prototype.getDateRangeDimension = function() {
      var dateRange, json, sel, selectedValue;
      dateRange = this.settingsBody.find('div[dim_cid=date_range]');
      if (dateRange == null) {
        return null;
      }
      sel = $(dateRange).find('.selected-dimensions select option:selected');
      if (sel) {
        selectedValue = $(sel[0]).val();
        if (selectedValue == null) {
          return null;
        }
        json = JSON.parse(selectedValue);
        if (json.type === App.RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE) {
          json['range_start'] = $(dateRange).find('.range-start').val();
          json['range_end'] = $(dateRange).find('.range-end').val();
          return JSON.stringify(json);
        } else {
          return selectedValue;
        }
      }
    };

    RedesignSharedDashboardDetailController.prototype.resizeFiltersBox = function() {
      var buffer, filtersBoxOffset, modal, modalHeight, modalOffset;
      if (!(this.filtersBox.length > 0)) {
        return;
      }
      modal = this.el.parent().parent();
      modalHeight = modal.outerHeight();
      modalOffset = modal.offset().top;
      filtersBoxOffset = this.filtersBox.offset().top;
      buffer = 4;
      return this.filtersBox.css('maxHeight', modalOffset + modalHeight - filtersBoxOffset - buffer);
    };

    RedesignSharedDashboardDetailController.prototype.getPasswordInput = function() {
      var ref;
      if ((ref = this.passwordToggler) != null ? ref.isToggleOn : void 0) {
        return this.passwordInput.val();
      } else {
        return null;
      }
    };

    RedesignSharedDashboardDetailController.prototype.viewOrHidePassword = function() {
      var shouldHidePasword;
      shouldHidePasword = _.eq(this.passwordInput.prop('type'), 'text');
      this.crossOutLine.toggle(shouldHidePasword);
      return this.passwordInput.prop({
        type: shouldHidePasword ? 'password' : 'text'
      });
    };

    RedesignSharedDashboardDetailController.prototype.passwordInputFocused = function() {
      this.passwordInput.removeClass('error');
      return this.passwordErrorMessage.addClass('hidden');
    };

    RedesignSharedDashboardDetailController.prototype.createClicked = function() {
      if (this.passwordsEnabled && _.eq(this.getPasswordInput(), '')) {
        this.passwordInput.addClass('error');
        this.passwordErrorMessage.removeClass('hidden');
        return;
      }
      return this.trigger('create');
    };

    RedesignSharedDashboardDetailController.prototype.saveClicked = function() {
      var password;
      password = this.getPasswordInput();
      if (_.eq(password, this.originalPassword)) {
        return;
      }
      if (_.eq(password, '')) {
        this.passwordInput.addClass('error');
        this.passwordErrorMessage.removeClass('hidden');
        this.resizeFiltersBox();
        return;
      }
      return jQuery.ajax({
        type: 'patch',
        url: "/shared_dashboards/" + this.sharedDashboard.id,
        data: {
          client_site_id: App.Site.first().id,
          password: password
        },
        success: this.updateSuccess
      });
    };

    RedesignSharedDashboardDetailController.prototype.updateSuccess = function(response) {
      this.sharedDashboard.password_protected = response.password_protected;
      AppRedesign.current().checkForUpdatesImmediately();
      return this.trigger('cancel');
    };

    RedesignSharedDashboardDetailController.prototype.loadPassword = function() {
      return jQuery.ajax({
        type: 'get',
        url: "/shared_dashboards/" + this.sharedDashboard.id + "/password",
        data: {
          client_site_id: App.Site.first().id
        },
        success: this.passwordLoadSuccess
      });
    };

    RedesignSharedDashboardDetailController.prototype.passwordLoadSuccess = function(response) {
      this.passwordInput.val(response.password);
      this.originalPassword = response.password;
      return this.passwordLoaded = true;
    };

    return RedesignSharedDashboardDetailController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSharedDashboardHeaderController = (function(superClass) {
    extend(RedesignSharedDashboardHeaderController, superClass);

    RedesignSharedDashboardHeaderController.prototype.elements = {
      '.header-title': 'dashboardTitle'
    };

    RedesignSharedDashboardHeaderController.prototype.events = {
      'click    .refresh': 'refreshIconClicked'
    };

    function RedesignSharedDashboardHeaderController() {
      this.render = bind(this.render, this);
      RedesignSharedDashboardHeaderController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard');
      this.html(this.view('redesign/dashboards/shared_dashboard_header')({
        screenshotTimestampLabel: AppRedesign.current().screenshotTimestampLabel(),
        hideLogo: this.hideLogo,
        showRefreshIcon: AppRedesign.current().state.shared_dashboards_refresh_flag_enabled
      }));
      this.render();
    }

    RedesignSharedDashboardHeaderController.prototype.render = function() {
      return this.dashboardTitle.text(this.dashboard.getName());
    };

    RedesignSharedDashboardHeaderController.prototype.refreshIconClicked = function() {
      return App.Dashboard.currentDashboard().refreshAllWidgetsFromEmbedApi();
    };

    return RedesignSharedDashboardHeaderController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSharedDashboardListController = (function(superClass) {
    extend(RedesignSharedDashboardListController, superClass);

    RedesignSharedDashboardListController.prototype.className = 'share-list-panel';

    RedesignSharedDashboardListController.prototype.elements = {
      '.add-new': 'addNewButton'
    };

    RedesignSharedDashboardListController.prototype.events = {
      'click .add-new.button': 'addNewClicked',
      'click li.share-list-item': 'sharedItemClicked',
      'click li.share-list-item .link-icon': 'linkClicked'
    };

    function RedesignSharedDashboardListController() {
      this.linkClicked = bind(this.linkClicked, this);
      this.sharedItemClicked = bind(this.sharedItemClicked, this);
      this.addNewClicked = bind(this.addNewClicked, this);
      this.shareSuccess = bind(this.shareSuccess, this);
      this.createClicked = bind(this.createClicked, this);
      this.deleteClicked = bind(this.deleteClicked, this);
      this.cancelClicked = bind(this.cancelClicked, this);
      RedesignSharedDashboardListController.__super__.constructor.apply(this, arguments);
      this.shareHelper = new App.DashboardShareHelper(App.Dashboard.currentDashboard());
    }

    RedesignSharedDashboardListController.prototype.unparentAllReparented = function() {
      var ref;
      return (ref = this.detailController) != null ? ref.unparentAllReparented() : void 0;
    };

    RedesignSharedDashboardListController.prototype.release = function() {
      var ref, ref1;
      RedesignSharedDashboardListController.__super__.release.apply(this, arguments);
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      return (ref1 = this.detailController) != null ? ref1.release() : void 0;
    };

    RedesignSharedDashboardListController.prototype.showSharesList = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        if (AppRedesign.sharedDashboardsEnabledOnDashboard()) {
          return this.renderShareListView();
        }
      } else {
        return this.renderShareListView();
      }
    };

    RedesignSharedDashboardListController.prototype.renderShareListView = function() {
      var s, visibleShares;
      delete this.selectedShareId;
      visibleShares = (function() {
        var i, len, ref, results;
        ref = this.shareHelper.sharedDashboards();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          s = ref[i];
          if (!(s.api_generated || s.temporary)) {
            results.push(s);
          }
        }
        return results;
      }).call(this);
      return this.html(this.view('redesign/dashboard_preferences/shared_dashboard_list')({
        sharedDashboards: visibleShares
      }));
    };

    RedesignSharedDashboardListController.prototype.renderSharedDashboard = function(selectedShareId) {
      var sd;
      this.selectedShareId = selectedShareId;
      sd = App.SharedDashboard.find(this.selectedShareId);
      return this.showDetailController(sd);
    };

    RedesignSharedDashboardListController.prototype.showDetailController = function(sharedDashboard) {
      var ref;
      if (sharedDashboard == null) {
        sharedDashboard = null;
      }
      if ((ref = this.detailController) != null) {
        ref.release();
      }
      this.detailController = new App.RedesignSharedDashboardDetailController({
        shareHelper: this.shareHelper,
        sharedDashboard: sharedDashboard
      });
      this.el.empty();
      this.el.append(this.detailController.el);
      this.detailController.render();
      this.detailController.bind('cancel', this.cancelClicked);
      this.detailController.bind('delete', this.deleteClicked);
      return this.detailController.bind('create', this.createClicked);
    };

    RedesignSharedDashboardListController.prototype.cancelClicked = function() {
      return this.showSharesList();
    };

    RedesignSharedDashboardListController.prototype.deleteClicked = function() {
      this.shareHelper.deleteShare(this.selectedShareId);
      return this.showSharesList();
    };

    RedesignSharedDashboardListController.prototype.createClicked = function() {
      return this.shareHelper.createShare(this.detailController, this.shareSuccess);
    };

    RedesignSharedDashboardListController.prototype.shareSuccess = function(sd) {
      sd.openShareUrl();
      return this.renderSharedDashboard(sd.id);
    };

    RedesignSharedDashboardListController.prototype.addNewClicked = function() {
      return this.showDetailController();
    };

    RedesignSharedDashboardListController.prototype.sharedItemClicked = function(e) {
      return this.renderSharedDashboard($(e.currentTarget).attr('shared_dashboard_id'));
    };

    RedesignSharedDashboardListController.prototype.linkClicked = function(e) {
      return e.stopPropagation();
    };

    return RedesignSharedDashboardListController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSqlAlertSettingsController = (function(superClass) {
    extend(RedesignSqlAlertSettingsController, superClass);

    RedesignSqlAlertSettingsController.prototype.className = 'sql-alert-settings';

    RedesignSqlAlertSettingsController.prototype.elements = {
      '.alert-toggle': 'alertToggleArea',
      '.frequency-option': 'frequencyOptionArea',
      '.frequency-setting': 'frequencySettingArea',
      '.alert-trigger-operation': 'alertTriggerOperation',
      '.alert-trigger-value': 'alertTriggerValue',
      '.email': 'emailRecipients',
      '.query-errors-checkbox-area': 'queryErrorsCheckboxArea',
      '.query-errors-container': 'queryErrorsContainer',
      '.query-errors-input': 'queryErrorsInput',
      '.badge-toggle-area': 'badgeToggleArea'
    };

    RedesignSqlAlertSettingsController.prototype.events = {
      'change .alert-trigger-operation': 'triggerChanged',
      'keyup  .alert-trigger-value': 'triggerChanged',
      'keyup  .query-errors-input': 'maxIgnoredErrorsChanged',
      'keyup  .email': 'emailChanged'
    };

    RedesignSqlAlertSettingsController.OPERATORS = [
      {
        name: 'greater than',
        type: 'greater_than',
        value: 0
      }, {
        name: 'equal to',
        type: 'equal_to',
        value: 1
      }, {
        name: 'less than',
        type: 'less_than',
        value: 2
      }
    ];

    RedesignSqlAlertSettingsController.INTERVALS = [
      {
        name: '10 minutes',
        seconds: 600,
        value: 0
      }, {
        name: '30 minutes',
        seconds: 1800,
        value: 1
      }, {
        name: '1 hour',
        seconds: 3600,
        value: 2
      }, {
        name: '4 hours',
        seconds: 14400,
        value: 3
      }, {
        name: '12 hours',
        seconds: 43200,
        value: 4
      }, {
        name: '24 hours',
        seconds: 86400,
        value: 5
      }
    ];

    RedesignSqlAlertSettingsController.HOURS = App.Utils.buildDropdownRange(0, 24);

    RedesignSqlAlertSettingsController.MINUTES = [
      {
        name: '00',
        value: 0
      }, {
        name: '15',
        value: 15
      }, {
        name: '30',
        value: 30
      }, {
        name: '45',
        value: 45
      }
    ];

    RedesignSqlAlertSettingsController.DEFAULT_COMPARATOR_VALUE = 100;

    function RedesignSqlAlertSettingsController() {
      this.scheduleChanged = bind(this.scheduleChanged, this);
      this.intervalChanged = bind(this.intervalChanged, this);
      this.triggerChanged = bind(this.triggerChanged, this);
      this.emailChanged = bind(this.emailChanged, this);
      this.alertToggleChanged = bind(this.alertToggleChanged, this);
      this.maxIgnoredErrorsChanged = bind(this.maxIgnoredErrorsChanged, this);
      this.queryErrorsToggleChanged = bind(this.queryErrorsToggleChanged, this);
      this.selectedSchedule = bind(this.selectedSchedule, this);
      this.selectedInterval = bind(this.selectedInterval, this);
      RedesignSqlAlertSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.sqlAlert = this.item;
      if (this.sqlAlert.isNew()) {
        this.setItemDefaults();
      }
      this.render();
      this.refresh();
      this.emailRecipients.one('keydown', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      this.alertTriggerValue.one('keydown', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      $('.app-frame').on("click", (function(_this) {
        return function(e) {
          return _this.clickedOutsideInputBox(e);
        };
      })(this));
    }

    RedesignSqlAlertSettingsController.prototype.refresh = function() {
      this.refreshEnabledSection();
      this.refreshConditionSection();
      return this.refreshNotificationSection();
    };

    RedesignSqlAlertSettingsController.prototype.release = function() {
      var ref;
      this.alertEnabledToggle.release();
      this.defaultSettingsController.release();
      this.ignoreErrorCheckbox.release();
      if ((ref = this.badgeToggleSettingsController) != null) {
        ref.release();
      }
      return RedesignSqlAlertSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignSqlAlertSettingsController.prototype.setItemDefaults = function() {
      this.sqlAlert.report_emails = App.User.currentUser().email_address;
      return this.sqlAlert.triggers = [
        {
          comparator: this.constructor.OPERATORS[0].type,
          value: this.constructor.DEFAULT_COMPARATOR_VALUE
        }
      ];
    };

    RedesignSqlAlertSettingsController.prototype.refreshEnabledSection = function() {
      return this.alertEnabledToggle.setToggleState(!this.sqlAlert.disabled);
    };

    RedesignSqlAlertSettingsController.prototype.refreshNotificationSection = function() {
      this.refreshNotificationFrequencySettings();
      return this.refreshNotificationEmailSettings();
    };

    RedesignSqlAlertSettingsController.prototype.refreshNotificationFrequencySettings = function() {
      var date, idx;
      if (this.sqlAlert.custom_schedule) {
        this.intervalRadioButton.setSelected(false);
        this.scheduleRadioButton.setSelected(true);
        date = App.Utils.datetimeStringToJSDate(this.sqlAlert.custom_schedule);
        this.scheduleHour.val(date.getUTCHours());
        this.scheduleHour.trigger("chosen:updated");
        this.scheduleMinute.val(date.getUTCMinutes());
        this.scheduleMinute.trigger("chosen:updated");
        this.intervalView.detach();
        return this.frequencySettingArea.append(this.scheduleView[0]);
      } else if (this.sqlAlert.refresh_interval_seconds) {
        this.intervalRadioButton.setSelected(true);
        this.scheduleRadioButton.setSelected(false);
        this.scheduleView.detach();
        this.frequencySettingArea.append(this.intervalView[0]);
        idx = _.filter(App.RedesignSqlAlertSettingsController.INTERVALS, (function(_this) {
          return function(i) {
            return _this.sqlAlert.refresh_interval_seconds === i.seconds;
          };
        })(this))[0].value;
        this.interval[0].selectedIndex = idx;
        return this.interval.trigger("chosen:updated");
      } else {
        this.intervalRadioButton.setSelected(true);
        this.scheduleRadioButton.setSelected(false);
        this.scheduleView.detach();
        this.frequencySettingArea.append(this.intervalView[0]);
        return this.intervalChanged();
      }
    };

    RedesignSqlAlertSettingsController.prototype.refreshNotificationEmailSettings = function() {
      return this.emailRecipients.val(this.sqlAlert.report_emails);
    };

    RedesignSqlAlertSettingsController.prototype.refreshConditionSection = function() {
      this.maybeSetSelectedCriteriaInput();
      if (this.sqlAlert.hasMaxIgnoredErrors()) {
        this.ignoreErrorCheckbox.select();
        this.queryErrorsInput.val(this.sqlAlert.max_ignored_errors);
        return this.queryErrorsContainer.show();
      } else {
        this.ignoreErrorCheckbox.unselect();
        this.queryErrorsInput.val('');
        return this.queryErrorsContainer.hide();
      }
    };

    RedesignSqlAlertSettingsController.prototype.maybeSetSelectedCriteriaInput = function() {
      if (!this.sqlAlert.hasTrigger()) {
        return;
      }
      this.alertTriggerOperation[0].selectedIndex = this.alertTriggerOperationValue();
      this.alertTriggerOperation.trigger('chosen:updated');
      return this.alertTriggerValue.val(this.sqlAlert.getTriggerValue());
    };

    RedesignSqlAlertSettingsController.prototype.alertTriggerOperationValue = function() {
      return _.find(this.constructor.OPERATORS, {
        type: this.sqlAlert.getTriggerComparator()
      }).value;
    };

    RedesignSqlAlertSettingsController.prototype.render = function() {
      this.alertEnabledToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: !this.sqlAlert.disabled,
        labelWhenToggleOn: 'Alert Enabled',
        labelWhenToggleOff: 'Alert Disabled'
      });
      this.alertEnabledToggle.bind('toggled', this.alertToggleChanged);
      this.ignoreErrorCheckbox = new App.RedesignCheckbox({
        labelText: 'Do not alert if query errors',
        initialState: this.sqlAlert.hasMaxIgnoredErrors(),
        callback: this.queryErrorsToggleChanged
      });
      this.intervalRadioButton = new App.RedesignRadioButton({
        labelText: 'Interval',
        enabled: true,
        disableDeselection: true,
        callback: this.selectedInterval
      });
      this.scheduleRadioButton = new App.RedesignRadioButton({
        labelText: 'Schedule',
        enabled: true,
        disableDeselection: true,
        callback: this.selectedSchedule
      });
      this.intervalView = $(this.view('redesign/editors/sql_alert_settings_interval')({
        intervals: App.RedesignSqlAlertSettingsController.INTERVALS
      }));
      this.interval = $(this.intervalView).find('.interval');
      this.interval.on('change', this.intervalChanged);
      this.scheduleView = $(this.view('redesign/editors/sql_alert_settings_schedule')({
        hours: App.RedesignSqlAlertSettingsController.HOURS,
        minutes: App.RedesignSqlAlertSettingsController.MINUTES
      }));
      this.scheduleHour = $(this.scheduleView).find('.schedule-hour');
      this.scheduleMinute = $(this.scheduleView).find('.schedule-minute');
      this.scheduleHour.on('change', this.scheduleChanged);
      this.scheduleMinute.on('change', this.scheduleChanged);
      this.html(this.view('redesign/editors/sql_alert_settings')({
        operators: App.RedesignSqlAlertSettingsController.OPERATORS,
        default_comparator_value: this.DEFAULT_COMPARATOR_VALUE,
        badgeToggleEnabled: AppRedesign.dashboardOrganizationEnabled()
      }));
      this.alertToggleArea.append(this.alertEnabledToggle.el);
      this.queryErrorsCheckboxArea.append(this.ignoreErrorCheckbox.el);
      this.frequencyOptionArea.append(this.intervalRadioButton.el);
      this.frequencyOptionArea.append(this.scheduleRadioButton.el);
      this.alertTriggerOperation.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: '141px'
      });
      this.scheduleHour.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: '125px'
      });
      this.scheduleMinute.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: '125px'
      });
      this.interval.chosen({
        disable_search: true,
        inherit_select_classes: true,
        width: '292px'
      });
      this.defaultSettingsController = new App.DefaultEditorSettingsController({
        item: this.sqlAlert,
        hideMainHeader: true
      });
      this.defaultSettingsController.bind('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      this.el.append(this.defaultSettingsController.el);
      return this.renderBadgeToggleArea();
    };

    RedesignSqlAlertSettingsController.prototype.renderBadgeToggleArea = function() {
      if (!(AppRedesign.dashboardOrganizationEnabled() && App.User.currentUser().isAdmin())) {
        return;
      }
      this.badgeToggleSettingsController = new App.BadgeToggleSettingsController({
        item: this.item,
        editHelper: this.editHelper,
        hasDetail: true
      });
      return this.badgeToggleArea.append(this.badgeToggleSettingsController.el);
    };

    RedesignSqlAlertSettingsController.prototype.selectedInterval = function() {
      this.scheduleRadioButton.setSelected(false);
      this.intervalRadioButton.setSelected(true);
      this.scheduleView.detach();
      this.frequencySettingArea.append(this.intervalView[0]);
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.selectedSchedule = function() {
      this.intervalRadioButton.setSelected(false);
      this.scheduleRadioButton.setSelected(true);
      this.intervalView.detach();
      this.frequencySettingArea.append(this.scheduleView[0]);
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.queryErrorsToggleChanged = function(enabled) {
      if (enabled) {
        this.sqlAlert.error_count = 0;
        this.sqlAlert.max_ignored_errors = 1;
        this.queryErrorsInput.val('1');
        return this.queryErrorsContainer.slideDown();
      } else {
        this.sqlAlert.error_count = null;
        this.sqlAlert.max_ignored_errors = null;
        this.queryErrorsInput.val('');
        return this.queryErrorsContainer.slideUp();
      }
    };

    RedesignSqlAlertSettingsController.prototype.maxIgnoredErrorsChanged = function() {
      var maxIgnoredErrors;
      maxIgnoredErrors = parseInt(this.queryErrorsInput.val(), 10);
      if (maxIgnoredErrors === (0/0) || maxIgnoredErrors === 0) {
        this.sqlAlert.max_ignored_errors = null;
      } else {
        this.sqlAlert.max_ignored_errors = maxIgnoredErrors;
      }
      return this.sqlAlert.error_count = 0;
    };

    RedesignSqlAlertSettingsController.prototype.alertToggleChanged = function(enabled) {
      this.sqlAlert.disabled = !enabled;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.emailChanged = function() {
      return this.sqlAlert.report_emails = this.emailRecipients.val();
    };

    RedesignSqlAlertSettingsController.prototype.triggerChanged = function() {
      var comparator, triggers;
      comparator = App.RedesignSqlAlertSettingsController.OPERATORS[this.alertTriggerOperation[0].selectedIndex].type;
      triggers = [
        {
          comparator: comparator,
          value: parseFloat(this.alertTriggerValue.val())
        }
      ];
      this.sqlAlert.triggers = triggers;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.intervalChanged = function() {
      var seconds;
      this.sqlAlert.custom_schedule = null;
      seconds = App.RedesignSqlAlertSettingsController.INTERVALS[this.interval[0].selectedIndex].seconds;
      this.sqlAlert.refresh_interval_seconds = seconds;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.scheduleChanged = function() {
      var hour, minute;
      hour = App.RedesignSqlAlertSettingsController.HOURS[this.scheduleHour[0].selectedIndex].name;
      minute = App.RedesignSqlAlertSettingsController.MINUTES[this.scheduleMinute[0].selectedIndex].name;
      this.sqlAlert.refresh_interval_seconds = null;
      this.sqlAlert.custom_schedule = hour + ":" + minute;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlAlertSettingsController.prototype.clickedOutsideInputBox = function(e) {
      if (this.alertTriggerValue[0] === e.target) {
        return;
      }
      if (_.isEmpty(this.alertTriggerValue.val())) {
        return this.alertTriggerValue.val(App.RedesignSqlAlertSettingsController.DEFAULT_COMPARATOR_VALUE);
      }
    };

    return RedesignSqlAlertSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSqlBox = (function(superClass) {
    extend(RedesignSqlBox, superClass);

    RedesignSqlBox.prototype.className = 'codemirror-wrapper';

    RedesignSqlBox.prototype.elements = {
      '.CodeMirror': 'codeMirrorEl'
    };

    RedesignSqlBox.prototype.events = {
      'mouseenter  .CodeMirror .cm-snippet': 'mouseEnterKw',
      'mousemove   .CodeMirror .cm-snippet': 'mouseEnterKw',
      'blur        .CodeMirror': 'codeMirrorBlurred',
      'submitted   .CodeMirror': 'codeMirrorSubmit',
      'keydown     .CodeMirror': 'codeMirrorKeydown',
      'keypress    .CodeMirror': 'clearErrors',
      'paste       .CodeMirror': 'codeMirrorPaste',
      'mousedown   .CodeMirror': 'selectCodeMirror',
      'mouseleave  .cm-snippet': 'hideTooltip',
      'mouseenter  .cm-sql-view': 'mouseEnterKw',
      'mousemove   .cm-sql-view': 'mouseEnterKw',
      'mouseleave  .cm-sql-view': 'hideTooltip',
      'mouseenter  .cm-csv-view': 'mouseEnterKw',
      'mousemove   .cm-csv-view': 'mouseEnterKw',
      'mouseleave  .cm-csv-view': 'hideTooltip',
      'mouseenter  .cm-underline-error': 'mouseEnterAlert',
      'mouseleave  .cm-underline-error': 'hideAlertDelay',
      'mousedown   .cm-underline-error': 'hideAlertInstant',
      'mouseenter  .cm-underline-info': 'mouseEnterAlert',
      'mouseleave  .cm-underline-info': 'hideAlertDelay',
      'mousedown   .cm-underline-info': 'hideAlertInstant',
      'mouseenter  .cm-underline-warning': 'mouseEnterAlert',
      'mouseleave  .cm-underline-warning': 'hideAlertDelay',
      'mousedown   .cm-underline-warning': 'hideAlertInstant'
    };

    function RedesignSqlBox() {
      this.finishFormatResponse = bind(this.finishFormatResponse, this);
      this.handleFormatResponse = bind(this.handleFormatResponse, this);
      this.reformatSql = bind(this.reformatSql, this);
      this.codeMirrorPaste = bind(this.codeMirrorPaste, this);
      this.codeMirrorSubmit = bind(this.codeMirrorSubmit, this);
      this.triggerSubmittedIfMetaEnter = bind(this.triggerSubmittedIfMetaEnter, this);
      this.codeMirrorKeydown = bind(this.codeMirrorKeydown, this);
      this.codeMirrorBlurred = bind(this.codeMirrorBlurred, this);
      this.selectCodeMirror = bind(this.selectCodeMirror, this);
      this.selectionChanged = bind(this.selectionChanged, this);
      this.cursorActivity = bind(this.cursorActivity, this);
      this.checkModified = bind(this.checkModified, this);
      this.insertAtCursor = bind(this.insertAtCursor, this);
      this.triggerChanged = bind(this.triggerChanged, this);
      this.setSql = bind(this.setSql, this);
      this.setInitialSql = bind(this.setInitialSql, this);
      this.getSql = bind(this.getSql, this);
      this.getSqlPreferSelected = bind(this.getSqlPreferSelected, this);
      this.cmEsc = bind(this.cmEsc, this);
      this.timeoutLoopCodeMirror = bind(this.timeoutLoopCodeMirror, this);
      this.deferredInitCodeMirror = bind(this.deferredInitCodeMirror, this);
      this.initCodeMirror = bind(this.initCodeMirror, this);
      this.show = bind(this.show, this);
      this.hide = bind(this.hide, this);
      RedesignSqlBox.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dbFunc');
      App.SqlBox.cachedPeriscopeSyntaxClass = {};
      this.hasSelection = false;
      this.lastSql = null;
      this.alerts = [];
      this.infoAlertTags = {};
      this.infoAlertTagNum = 1;
      if (this.autofocus == null) {
        this.autofocus = false;
      }
      if (this.initialValue == null) {
        this.initialValue = "";
      }
      if (this.lineNumbers == null) {
        this.lineNumbers = false;
      }
      this.placeholder = _.trim(this.placeholder);
      this.themes = _.trim(_.join(_.concat('redesign-sql-box', this.themes), ' '));
      AppRedesign.current().uiQueue.add(this.deferredInitCodeMirror);
    }

    RedesignSqlBox.prototype.hide = function() {
      return this.el.hide();
    };

    RedesignSqlBox.prototype.show = function() {
      this.el.show();
      return setTimeout(((function(_this) {
        return function() {
          return _this.setSql(_this.getSql());
        };
      })(this)), 0);
    };

    RedesignSqlBox.prototype.release = function() {
      var ref, ref1, ref2, ref3, ref4;
      RedesignSqlBox.__super__.release.apply(this, arguments);
      if ((ref = this.codeMirror) != null) {
        if ((ref1 = ref.state) != null) {
          if ((ref2 = ref1.completionActive) != null) {
            ref2.close();
          }
        }
      }
      if ((ref3 = this._tooltipHelper) != null) {
        ref3.release();
      }
      if ((ref4 = this._alertTooltipHelper) != null) {
        ref4.release();
      }
      $('#body').off('mouseup');
      return this.codeMirror = null;
    };

    RedesignSqlBox.prototype.initCodeMirror = function() {
      var _enabled, callback, i, len, name, pendingCallback, ref;
      this.codeMirror = CodeMirror(this.el[0], {
        autofocus: this.autofocus,
        extraKeys: {
          Esc: this.cmEsc,
          Tab: this.cmIndent,
          "Shift-Ctrl-L": this.reformatSql,
          "Shift-Cmd-L": this.reformatSql,
          "Shift-Tab": this.cmBackdent,
          "Cmd-/": this.cmToggleComment,
          "Ctrl-/": this.cmToggleComment
        },
        indentWithTabs: false,
        lineNumbers: this.lineNumbers,
        lineWrapping: true,
        matchBrackets: true,
        mode: this.dbHighlightMode(),
        placeholder: this.placeholder,
        styleActiveLine: this.styleActiveLine,
        tabSize: 2,
        theme: this.themes,
        value: this.initialValue
      });
      if (this.enabled !== false) {
        App.AddSqlHintToCodeMirror.call(this.codeMirror, this.dbFunc);
      }
      this.refreshElements();
      this.codeMirror.on('cursorActivity', this.cursorActivity);
      this.codeMirrorEl.on('keyup', this.checkModified);
      $('#body').on('mouseup', this.selectionChanged);
      this.renderAlerts();
      setTimeout(((function(_this) {
        return function() {
          return _this.setSql(_this.getSql());
        };
      })(this)), 0);
      _enabled = this.pendingEnabled || this.enabled;
      if (_enabled != null) {
        this.setEnabled(_enabled);
      }
      if (this.pendingSql != null) {
        this.setSql(this.pendingSql);
      }
      if (this.pendingCallbacks != null) {
        ref = this.pendingCallbacks;
        for (i = 0, len = ref.length; i < len; i++) {
          pendingCallback = ref[i];
          name = pendingCallback[0];
          callback = pendingCallback[1];
          this.codeMirror.on(name, callback);
        }
      }
      delete this.pendingSql;
      delete this.pendingEnabled;
      delete this.pendingCallbacks;
      requestAnimationFrame((function(_this) {
        return function() {
          var ref1;
          return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.sqlboxLoaded(_this.setInitialSql) : void 0;
        };
      })(this));
      this.codeMirrorEl.on('click', (function(_this) {
        return function() {
          var ref1;
          return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.codeMirrorClicked() : void 0;
        };
      })(this));
      return this.codeMirrorEl.attr('data-test-id', 'sqlCodeMirror');
    };

    RedesignSqlBox.prototype.deferredInitCodeMirror = function() {
      if (typeof CodeMirror !== "undefined" && CodeMirror !== null) {
        return this.initCodeMirror(this.initialValue, this.placeholder, this.enabled, this.autofocus);
      } else {
        return this.timeoutLoopCodeMirror();
      }
    };

    RedesignSqlBox.prototype.timeoutLoopCodeMirror = function() {
      if (typeof CodeMirror !== "undefined" && CodeMirror !== null) {
        if (!this.codeMirror) {
          this.initCodeMirror(this.initialValue, this.placeholder, this.enabled, this.autofocus);
          return this.trigger('codemirror-loaded');
        }
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.timeoutLoopCodeMirror();
          };
        })(this)), 10);
      }
    };

    RedesignSqlBox.prototype.cmEsc = function(cm) {
      this.hideAlertInstant();
      return App.hotkeys.trigger(App.HotkeyManager.ESC, null);
    };

    RedesignSqlBox.prototype.cmIndent = function(cm) {
      if (cm.somethingSelected()) {
        return cm.indentSelection("add");
      } else {
        return cm.execCommand('insertSoftTab');
      }
    };

    RedesignSqlBox.prototype.cmBackdent = function(cm) {
      return cm.indentSelection("subtract");
    };

    RedesignSqlBox.prototype.cmToggleComment = function(cm) {
      return cm.execCommand('toggleComment');
    };

    RedesignSqlBox.prototype.getSqlPreferSelected = function() {
      return this.getSql(true, true);
    };

    RedesignSqlBox.prototype.getSql = function(preferSelected) {
      var selectedSql;
      if (preferSelected == null) {
        preferSelected = false;
      }
      if ((this.pendingSql != null) && (this.codeMirror == null)) {
        return this.pendingSql;
      }
      if (this.codeMirror == null) {
        return '';
      }
      if (preferSelected) {
        selectedSql = this.codeMirror.getSelection();
        selectedSql = RedesignSqlBox.cleanSQL(selectedSql);
        if (selectedSql && selectedSql.length > 0) {
          return selectedSql;
        }
      }
      return RedesignSqlBox.cleanSQL(this.codeMirror.getValue());
    };

    RedesignSqlBox.prototype.setInitialSql = function(sql) {
      this.setSql(sql);
      return this.triggerChanged(sql, true);
    };

    RedesignSqlBox.prototype.setSql = function(sql, preferSelected) {
      var selectedSql, trimmedSql;
      if (preferSelected == null) {
        preferSelected = false;
      }
      if (this.codeMirror == null) {
        this.pendingSql = sql;
        return;
      }
      if (sql) {
        trimmedSql = sql.trim();
      } else {
        trimmedSql = '';
      }
      selectedSql = this.codeMirror.getSelection();
      if (preferSelected && selectedSql && selectedSql.length > 0) {
        this.codeMirror.replaceSelection(trimmedSql);
      } else {
        this.codeMirror.setValue(trimmedSql);
      }
      return this.renderAlerts();
    };

    RedesignSqlBox.prototype.triggerChanged = function(sql, initialValue) {
      if (initialValue == null) {
        initialValue = false;
      }
      return this.trigger('sql-changed', sql, initialValue);
    };

    RedesignSqlBox.prototype.insertAtCursor = function(text) {
      var cursorPosition;
      if (!((this.codeMirror != null) && (text != null ? text.length : void 0) > 0)) {
        return;
      }
      cursorPosition = this.codeMirror.getDoc().getCursor('head');
      this.codeMirror.getDoc().replaceRange(text, cursorPosition);
      this.triggerChanged(text);
      if (!this.codeMirror.hasFocus()) {
        return this.codeMirror.focus();
      }
    };

    RedesignSqlBox.cleanSQL = function(sql) {
      var s;
      if (!((sql != null) && (sql.trim != null) && sql.length > 0)) {
        return sql;
      }
      s = sql.trim();
      while (s[s.length - 1] === ';') {
        s = s.slice(0, s.length - 1).trim();
      }
      return s;
    };

    RedesignSqlBox.prototype.checkModified = function() {
      var newSql;
      newSql = this.getSql();
      if (newSql !== this.lastSql) {
        this.lastSql = newSql;
        return this.triggerChanged(newSql);
      }
    };

    RedesignSqlBox.prototype.setPlaceholder = function(placeholder) {
      var ref;
      this.placeholder = placeholder;
      return (ref = this.codeMirror) != null ? ref.setOption('placeholder', this.placeholder) : void 0;
    };

    RedesignSqlBox.prototype.setEnabled = function(enabled) {
      this.enabled = enabled;
      if (this.codeMirror == null) {
        this.pendingEnabled = this.enabled;
        return;
      }
      if (this.enabled) {
        this.codeMirror.setOption('readOnly', false);
        return this.codeMirrorEl.removeClass('disabled');
      } else {
        this.codeMirror.setOption('readOnly', true);
        return this.codeMirrorEl.addClass('disabled');
      }
    };

    RedesignSqlBox.prototype.cursorActivity = function() {
      var hasSelection;
      if (this.codeMirror == null) {
        return;
      }
      hasSelection = !!this.codeMirror.getSelection();
      if (this.hasSelection !== hasSelection) {
        this.trigger('selection-changed', hasSelection);
        return this.hasSelection = hasSelection;
      }
    };

    RedesignSqlBox.prototype.selectionChanged = function() {
      return setTimeout((function(_this) {
        return function() {
          var selection;
          if (_this.codeMirror == null) {
            return;
          }
          selection = _this.codeMirror.getSelection();
          if (selection === _this.previousSelection) {
            return;
          }
          _this.previousSelection = selection;
          return _this.trigger('selected-or-deselected');
        };
      })(this));
    };

    RedesignSqlBox.prototype.updateErrors = function(errorInfo) {
      if (errorInfo != null) {
        if (errorInfo.ran_on_redshift == null) {
          errorInfo.ran_on_redshift = false;
        }
        this.errorInfo = errorInfo.error_message != null ? errorInfo : null;
      } else {
        this.errorInfo = null;
      }
      return this.renderAlerts();
    };

    RedesignSqlBox.prototype.updateInfoAndWarnings = function(infoAndWarnings) {
      if (this.errorInfo != null) {
        return;
      }
      this.infoAndWarnings = infoAndWarnings;
      return this.renderAlerts();
    };

    RedesignSqlBox.prototype.getAlertIndices = function(startPos, alertLevel) {
      var alertLineNumber, endIndex, restOfQueryAfterError, selectionOffset, startIndex, userSql;
      userSql = this.getSql();
      selectionOffset = 0;
      if (this.hasSelection) {
        selectionOffset = userSql.indexOf(RedesignSqlBox.cleanSQL(this.codeMirror.getSelection()));
      }
      startIndex = startPos + selectionOffset;
      alertLineNumber = (userSql.substring(0, startIndex).match(/\n/g) || []).length + this.newlineCount;
      this.alerts.push({
        alertLineNumber: alertLineNumber,
        alertLevel: alertLevel
      });
      restOfQueryAfterError = /[\s'"`]/.exec(userSql.slice(startIndex));
      if (restOfQueryAfterError) {
        endIndex = startIndex + restOfQueryAfterError.index;
      } else {
        endIndex = userSql.length;
      }
      return {
        startIndex: this.adjustIndexPositionDueToWhitespaceTrim(startIndex),
        endIndex: this.adjustIndexPositionDueToWhitespaceTrim(endIndex),
        alertLineNumber: alertLineNumber
      };
    };

    RedesignSqlBox.prototype.markCodeMirrorAlertText = function(startIndex, endIndex, alertLineNumber, alertLevel) {
      this.codeMirror.markText(this.codeMirror.posFromIndex(startIndex), this.codeMirror.posFromIndex(endIndex), {
        className: "cm-underline-" + alertLevel
      });
      return this.codeMirror.addLineClass(alertLineNumber, 'gutter', "cm-" + alertLevel + "-gutter");
    };

    RedesignSqlBox.prototype.markCodeMirrorAlertTag = function(alert, indices, alertLevel) {
      var hintClass;
      hintClass = "alert-" + this.infoAlertTagNum;
      this.codeMirror.markText(this.codeMirror.posFromIndex(indices.startIndex), this.codeMirror.posFromIndex(indices.endIndex), {
        className: hintClass
      });
      this.infoAlertTags[hintClass] = alertLevel === "info" ? alert.hint : {
        table_name: alert.table_name,
        hint: alert.hint
      };
      return this.infoAlertTagNum++;
    };

    RedesignSqlBox.prototype.adjustIndexPositionDueToWhitespaceTrim = function(index) {
      return index + this.whitespaceCount;
    };

    RedesignSqlBox.prototype.setWhitespaceAndNewlineCount = function() {
      var ch, i, len, ref, results;
      this.newlineCount = 0;
      this.whitespaceCount = 0;
      ref = this.codeMirror.getValue();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        ch = ref[i];
        if (ch === '\n') {
          this.newlineCount++;
          results.push(this.whitespaceCount++);
        } else if (ch === ' ') {
          results.push(this.whitespaceCount++);
        } else {
          break;
        }
      }
      return results;
    };

    RedesignSqlBox.prototype.getAlertIndicesAndMarkAlertText = function(startPos, alertLevel) {
      var indices;
      indices = this.getAlertIndices(startPos, alertLevel);
      this.markCodeMirrorAlertText(indices.startIndex, indices.endIndex, indices.alertLineNumber, alertLevel);
      return indices;
    };

    RedesignSqlBox.prototype.markInfoAlert = function(info) {
      var i, indices, len, pos, ref, results;
      ref = info.locations;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        pos = ref[i];
        indices = this.getAlertIndicesAndMarkAlertText(pos, "info");
        results.push(this.markCodeMirrorAlertTag(info, indices, "info"));
      }
      return results;
    };

    RedesignSqlBox.prototype.markWarningAlert = function(warning) {
      var i, indices, len, pos, ref, results;
      ref = warning.locations;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        pos = ref[i];
        indices = this.getAlertIndicesAndMarkAlertText(pos, "warning");
        results.push(this.markCodeMirrorAlertTag(warning, indices, "warning"));
      }
      return results;
    };

    RedesignSqlBox.prototype.renderInfoAndWarnings = function() {
      var i, info, j, len, len1, ref, ref1, results, warning;
      ref = this.infoAndWarnings.info;
      for (i = 0, len = ref.length; i < len; i++) {
        info = ref[i];
        this.markInfoAlert(info);
      }
      ref1 = this.infoAndWarnings.warnings;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        warning = ref1[j];
        results.push(this.markWarningAlert(warning));
      }
      return results;
    };

    RedesignSqlBox.prototype.isUsingNewErrorPositionFormat = function() {
      var ref;
      return _.isInteger((ref = this.errorInfo.error_pos) != null ? ref.first() : void 0);
    };

    RedesignSqlBox.prototype.determineErrorPosition = function() {
      var expandedErrorPosition, originalErrorPosition, ref, ref1;
      if (this.isUsingNewErrorPositionFormat()) {
        originalErrorPosition = (ref = this.errorInfo.error_pos) != null ? ref.first() : void 0;
        expandedErrorPosition = (ref1 = this.errorInfo.error_pos) != null ? ref1.last() : void 0;
        if (this.enabled) {
          return originalErrorPosition;
        } else {
          return expandedErrorPosition;
        }
      } else {
        return this.getLegacyErrorPosition();
      }
    };

    RedesignSqlBox.prototype.renderErrors = function() {
      var errorPosition, indices;
      errorPosition = this.determineErrorPosition();
      if (errorPosition == null) {
        return;
      }
      indices = this.getAlertIndices(errorPosition, 'error');
      return this.markCodeMirrorAlertText(indices.startIndex, indices.endIndex, indices.alertLineNumber, 'error');
    };

    RedesignSqlBox.prototype.renderAlerts = function() {
      if (this.codeMirror == null) {
        return;
      }
      this.clearErrors();
      if (!((this.errorInfo != null) || (this.infoAndWarnings != null))) {
        return;
      }
      this.setWhitespaceAndNewlineCount();
      if (this.errorInfo != null) {
        return this.renderErrors();
      } else if (this.infoAndWarnings != null) {
        return this.renderInfoAndWarnings();
      }
    };

    RedesignSqlBox.prototype.getLegacyErrorPosition = function() {
      var matchedPos, msg, ref, ref1;
      msg = this.errorInfo.error_message;
      if (this.enabled === false && msg) {
        matchedPos = msg.match(/Expanded\:\s(\d+)/);
        if (matchedPos == null) {
          matchedPos = msg.match(/Position\:\s(\d+)/);
        }
        if (matchedPos != null) {
          return parseInt(matchedPos[1]);
        }
      } else {
        return (ref = this.errorInfo.error_pos) != null ? (ref1 = ref.first()) != null ? ref1.first() : void 0 : void 0;
      }
    };

    RedesignSqlBox.prototype.removeLineClass = function(lineNumber, alertLevel) {
      this.codeMirror.removeLineClass(lineNumber, 'background', "cm-" + alertLevel + "-line");
      return this.codeMirror.removeLineClass(lineNumber, 'gutter', "cm-" + alertLevel + "-gutter");
    };

    RedesignSqlBox.prototype.clearErrors = function() {
      var alert, i, j, len, len1, mark, ref, ref1, results;
      if (this.codeMirror == null) {
        return;
      }
      ref = this.alerts;
      for (i = 0, len = ref.length; i < len; i++) {
        alert = ref[i];
        this.removeLineClass(alert.alertLineNumber, alert.alertLevel);
      }
      this.alerts = [];
      this.infoAlertTagNum = 1;
      this.infoAlertTags = {};
      ref1 = this.codeMirror.getAllMarks();
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        mark = ref1[j];
        results.push(mark.clear());
      }
      return results;
    };

    RedesignSqlBox.prototype.scrolled = function() {
      var ref, ref1;
      if ((ref = this._alertTooltipHelper) != null) {
        ref.hideAlert(0);
      }
      return (ref1 = this._tooltipHelper) != null ? ref1.hideTooltip() : void 0;
    };

    RedesignSqlBox.prototype.selectCodeMirror = function(evt) {
      if (this.codeMirror == null) {
        return;
      }
      if (evt != null) {
        evt.preventDefault();
      }
      if (this.codeMirror.hasFocus()) {
        return;
      }
      this.codeMirror.focus();
      return this.codeMirror.getInputField().focus();
    };

    RedesignSqlBox.prototype.codeMirrorBlurred = function() {
      var ref, ref1;
      if (((ref = this.codeMirror) != null ? (ref1 = ref.state) != null ? ref1.completionActive : void 0 : void 0) != null) {

      }
    };

    RedesignSqlBox.prototype.codeMirrorKeydown = function(evt) {
      if (evt.which === AppRedesign.KEYS.ESCAPE) {
        evt.stopPropagation();
      }
      if (evt.which === AppRedesign.KEYS.ENTER) {
        this.trigger('enter-pressed');
      }
      if (evt.which === AppRedesign.KEYS.BACKSPACE || evt.which === AppRedesign.KEYS.ENTER) {
        this.clearErrors();
      }
      this.hideAlertInstant();
      this.triggerSubmittedIfMetaEnter(evt);
      this.trigger('sql-keydown');
      this.hideTooltip(evt, 250);
      return requestAnimationFrame((function(_this) {
        return function() {
          var ref, ref1;
          return (ref = AppRedesign.current().tutorial()) != null ? ref.sqlEditorKeypress(((ref1 = _this.getSql()) != null ? ref1.length : void 0) > 0) : void 0;
        };
      })(this));
    };

    RedesignSqlBox.prototype.triggerSubmittedIfMetaEnter = function(event) {
      if (event.which === AppRedesign.KEYS.ENTER && (event.ctrlKey || event.metaKey)) {
        jQuery(event.currentTarget).trigger('submitted');
        return event.preventDefault();
      }
    };

    RedesignSqlBox.prototype.codeMirrorSubmit = function() {
      return this.trigger('sql-updated');
    };

    RedesignSqlBox.prototype.setCodeMirrorEvent = function(name, callback) {
      if (this.codeMirror != null) {
        return this.codeMirror.on(name, callback);
      } else {
        if (this.pendingCallbacks == null) {
          this.pendingCallbacks = [];
        }
        return this.pendingCallbacks.push([name, callback]);
      }
    };

    RedesignSqlBox.prototype.codeMirrorPaste = function() {
      return setTimeout(((function(_this) {
        return function() {
          var ref;
          return (ref = _this.codeMirror) != null ? ref.refresh() : void 0;
        };
      })(this)));
    };

    RedesignSqlBox.prototype.tooltipHelper = function() {
      return this._tooltipHelper != null ? this._tooltipHelper : this._tooltipHelper = new App.RedesignSqlTooltipHelper();
    };

    RedesignSqlBox.prototype.hideTooltip = function(_, fadeTime) {
      if (fadeTime == null) {
        fadeTime = 50;
      }
      return this.tooltipHelper().hideTooltip(fadeTime);
    };

    RedesignSqlBox.prototype.mouseEnterKw = function(evt) {
      return this.tooltipHelper().mouseEnterKw(evt);
    };

    RedesignSqlBox.prototype.dbHighlightMode = function() {
      var database_type, mode;
      database_type = 'postgres';
      if ((this.dbFunc != null) && (this.dbFunc() != null)) {
        database_type = this.dbFunc().database_type;
      }
      mode = 'text/x-mysql';
      if (database_type === 'redshift' || database_type === 'postgres' || database_type === 'vertica' || database_type === 'oracle' || database_type === 'snowflake' || database_type === 'teradata' || database_type === 'databricks') {
        mode = 'text/x-plsql';
      }
      return mode;
    };

    RedesignSqlBox.prototype.alertTooltipHelper = function() {
      return this._alertTooltipHelper != null ? this._alertTooltipHelper : this._alertTooltipHelper = new App.RedesignAlertToolTipHelper();
    };

    RedesignSqlBox.prototype.hideAlertDelay = function() {
      return this.alertTooltipHelper().hideAlert(250);
    };

    RedesignSqlBox.prototype.hideAlertInstant = function() {
      return this.alertTooltipHelper().hideAlert(0);
    };

    RedesignSqlBox.prototype.mouseEnterAlert = function(evt) {
      return this.alertTooltipHelper().showAlert(evt, this.infoAlertTags);
    };

    RedesignSqlBox.prototype.toggleGrey = function(useGray) {
      return this.codeMirrorEl.toggleClass("cm-s-greyscale", useGray);
    };

    RedesignSqlBox.prototype.reformatSql = function() {
      var sql;
      if (this.formatRequestPending) {
        return;
      }
      this.formatRequestPending = true;
      sql = this.getSql(true);
      this.toggleGrey(true);
      jQuery.ajax({
        method: 'POST',
        url: '/sql_formatting/format',
        data: {
          sql: sql,
          client_site_id: App.Site.first().id
        }
      }).done(this.handleFormatResponse).always(this.finishFormatResponse);
      App.Utils.logFeature("format-sql");
      return this.codeMirror.focus();
    };

    RedesignSqlBox.prototype.handleFormatResponse = function(data) {
      this.setSql(data.formatted_sql, true);
      return this.checkModified();
    };

    RedesignSqlBox.prototype.finishFormatResponse = function() {
      this.formatRequestPending = false;
      return this.toggleGrey(false);
    };

    return RedesignSqlBox;

  })(Spine.Controller);

}).call(this);
(function() {
  App.RedesignSqlBoxFactory = (function() {
    RedesignSqlBoxFactory.create = function(type, sqlBoxOptions) {
      return new App.RedesignSqlBoxFactory(type, sqlBoxOptions).create();
    };

    function RedesignSqlBoxFactory(type1, sqlBoxOptions1) {
      this.type = type1;
      this.sqlBoxOptions = sqlBoxOptions1;
    }

    RedesignSqlBoxFactory.prototype.create = function() {
      switch (this.type) {
        case 'editor':
          return this.createEditorSqlBox();
        case 'mini':
          return this.createMiniSqlBox();
        default:
          return this.complainAboutUnknownType(this.type);
      }
    };

    RedesignSqlBoxFactory.prototype.complainAboutUnknownType = function(type) {
      throw new Error("RedesignSqlBoxFactory does not support the type: " + type);
    };

    RedesignSqlBoxFactory.prototype.createEditorSqlBox = function() {
      return this.createSqlBox({
        autofocus: true,
        enabled: true,
        lineNumbers: true,
        styleActiveLine: true,
        themes: 'editor'
      });
    };

    RedesignSqlBoxFactory.prototype.createMiniSqlBox = function() {
      return this.createSqlBox({
        autofocus: false,
        enabled: true,
        lineNumbers: false,
        styleActiveLine: false,
        themes: 'mini'
      });
    };

    RedesignSqlBoxFactory.prototype.createSqlBox = function(defaultOptions) {
      return new App.RedesignSqlBox(_.defaultsDeep(this.sqlBoxOptions, defaultOptions));
    };

    return RedesignSqlBoxFactory;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSqlViewSettingsController = (function(superClass) {
    extend(RedesignSqlViewSettingsController, superClass);

    RedesignSqlViewSettingsController.prototype.className = 'sql-view-settings';

    RedesignSqlViewSettingsController.prototype.elements = {
      '.auto-archive-area': 'autoArchiveArea',
      '.auto-archive-toggle-area': 'autoArchiveToggleArea',
      '.data-discovery-area': 'dataDiscoveryArea',
      '.default-settings-area': 'defaultSettingsArea',
      '.view-schedule-area': 'viewScheduleArea',
      '.view-materialization-area': 'viewMaterializationArea',
      '.badge-toggle-area': 'badgeToggleArea'
    };

    function RedesignSqlViewSettingsController() {
      this.excludedFromAutoArchiveChanged = bind(this.excludedFromAutoArchiveChanged, this);
      this.checkAutoArchiveConfig = bind(this.checkAutoArchiveConfig, this);
      RedesignSqlViewSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    RedesignSqlViewSettingsController.prototype.release = function() {
      var ref, ref1, ref2;
      if ((ref = this.archiveToggle) != null) {
        ref.release();
      }
      if (AppRedesign.dragDropEnabled()) {
        this.dataDiscoverySettingsController.release();
      }
      this.defaultSettingsController.release();
      if (App.Site.first().cached_site) {
        if ((ref1 = this.viewMaterializationSettingsController) != null) {
          ref1.release();
        }
      }
      if ((ref2 = this.badgeToggleSettingsController) != null) {
        ref2.release();
      }
      return RedesignSqlViewSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignSqlViewSettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/sqlview_settings')({
        autoArchiveEnabled: AppRedesign.autoArchiveEnabled(),
        viewScheduleEnabled: this._showViewSchedulingArea(),
        dragDropEnabled: AppRedesign.dragDropEnabled(),
        viewMaterializationEnabled: App.Site.first().cached_site,
        badgeToggleEnabled: AppRedesign.dashboardOrganizationEnabled()
      }));
      this.renderViewScheduleArea();
      this.renderDataDiscoveryArea();
      this.renderAutoArchiveArea();
      this.renderDefaultSettingsArea();
      if (this._showOldViewMaterializationArea()) {
        this.renderViewMaterializationArea();
      }
      return this.renderBadgeToggleArea();
    };

    RedesignSqlViewSettingsController.prototype.renderDataDiscoveryArea = function() {
      if (!AppRedesign.dragDropEnabled()) {
        return;
      }
      this.dataDiscoverySettingsController = new App.RedesignDataDiscoverySettingsController({
        item: this.item
      });
      this.dataDiscoverySettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.dataDiscoveryArea.append(this.dataDiscoverySettingsController.el);
    };

    RedesignSqlViewSettingsController.prototype.renderViewScheduleArea = function() {
      if (!this._showViewSchedulingArea()) {
        return;
      }
      this.viewScheduleController = new App.ViewScheduleController({
        item: this.item
      });
      this.viewScheduleController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.viewScheduleArea.append(this.viewScheduleController.el);
    };

    RedesignSqlViewSettingsController.prototype.renderAutoArchiveArea = function() {
      if (!AppRedesign.autoArchiveEnabled()) {
        return;
      }
      this.archiveToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: this.item.excluded_from_auto_archive,
        labelWhenToggleOn: 'Exclude from auto archive',
        labelWhenToggleOff: 'Exclude from auto archive'
      });
      this.autoArchiveToggleArea.append(this.archiveToggle.el);
      this.archiveToggle.bind('toggled', this.excludedFromAutoArchiveChanged);
      return this.checkAutoArchiveConfig();
    };

    RedesignSqlViewSettingsController.prototype.checkAutoArchiveConfig = function() {
      return jQuery.ajax({
        url: '/auto_archive_configs',
        type: 'get',
        data: {
          client_site_id: App.Site.first().id
        }
      }).done((function(_this) {
        return function(res) {
          if (!res || !res.id) {
            return _this.archiveToggle.disable();
          }
        };
      })(this));
    };

    RedesignSqlViewSettingsController.prototype.renderDefaultSettingsArea = function() {
      this.defaultSettingsController = new App.DefaultEditorSettingsController({
        item: this.item,
        hideMainHeader: true
      });
      this.defaultSettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.defaultSettingsArea.append(this.defaultSettingsController.el);
    };

    RedesignSqlViewSettingsController.prototype.renderViewMaterializationArea = function() {
      if (!App.Site.first().cached_site) {
        return;
      }
      this.viewMaterializationSettingsController = new App.ViewMaterializationSettingsController({
        item: this.item
      });
      this.viewMaterializationSettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.viewMaterializationArea.append(this.viewMaterializationSettingsController.el);
    };

    RedesignSqlViewSettingsController.prototype.hasDataset = function() {
      return _.some(App.Dataset.all(), {
        explorable_id: this.item.id,
        explorable_type: 'SqlView'
      });
    };

    RedesignSqlViewSettingsController.prototype.refresh = function() {
      var ref, ref1;
      this.defaultSettingsController.refresh();
      if ((ref = this.viewMaterializationSettingsController) != null) {
        ref.refresh();
      }
      return (ref1 = this.viewScheduleController) != null ? ref1.render() : void 0;
    };

    RedesignSqlViewSettingsController.prototype.excludedFromAutoArchiveChanged = function(toggleState) {
      this.item.excluded_from_auto_archive = toggleState;
      return this.triggerOnce('right-panel-settings-changed');
    };

    RedesignSqlViewSettingsController.prototype.renderBadgeToggleArea = function() {
      if (!(AppRedesign.dashboardOrganizationEnabled() && App.User.currentUser().isAdmin())) {
        return;
      }
      this.badgeToggleSettingsController = new App.BadgeToggleSettingsController({
        item: this.item,
        editHelper: this.editHelper,
        hasDetail: true
      });
      return this.badgeToggleArea.append(this.badgeToggleSettingsController.el);
    };

    RedesignSqlViewSettingsController.prototype._showOldViewMaterializationArea = function() {
      return !App.Site.first().schedulable_views_enabled && App.Site.first().cached_site;
    };

    RedesignSqlViewSettingsController.prototype._showViewSchedulingArea = function() {
      return App.Site.first().schedulable_views_enabled && App.Site.first().cached_site;
    };

    return RedesignSqlViewSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignTableChart = (function(superClass) {
    extend(RedesignTableChart, superClass);

    RedesignTableChart.prototype.elements = {
      '.ninja-grid': 'ninjaGrid',
      '.rows': 'rows',
      '.rows-wrapper': 'rowsWrapper',
      '.header-row': 'headerRow',
      '.table-search-box': 'searchBoxArea',
      '.table-search-box input': 'searchBoxInput',
      '.no-rows-message': 'noRowsMessage',
      '.table-border': 'tableBorder'
    };

    RedesignTableChart.prototype.events = {
      'click .header-row.last .ninja-header:not(.index)': 'handleHeaderClick',
      'click .table-search-box .close.table-icon': 'closeSearch',
      'mouseenter .ninja-cell': 'cellMouseEnter',
      'mouseleave .ninja-cell': 'cellMouseLeave',
      'keyup .table-search-box input': 'searchBoxClicked',
      'click .nested.clickable': 'nestedRowClicked',
      'mouseenter .ninja-grid': 'mouseEnterTable',
      'mouseleave .ninja-grid': 'mouseLeaveTable'
    };

    RedesignTableChart.GRID_MAX_DISPLAY_CHARS = 120;

    RedesignTableChart.GRID_MAX_DISPLAY_CHARS_TOOLTIP = RedesignTableChart.GRID_MAX_DISPLAY_CHARS * 10;

    RedesignTableChart.HOVER_TOOLTIP_TIMEOUT = 1000;

    RedesignTableChart.PADDING_OFFSET = 13;

    RedesignTableChart.GRID_INDEX_COL_WIDTH = 27 + RedesignTableChart.PADDING_OFFSET;

    RedesignTableChart.GRID_INDEX_COL_LEFT_OFFSET = 40;

    RedesignTableChart.DEFAULT_ROW_HEIGHT = 25;

    RedesignTableChart.NULL_PIVOT_NAME = 'None';

    RedesignTableChart.HEADER_HEIGHT = 30;

    RedesignTableChart.SEARCH_TYPING_DELAY = 100;

    RedesignTableChart.TABLE_TITLE_HEIGHT = 45;

    RedesignTableChart.TOTAL_HEADER_HEIGHT = RedesignTableChart.HEADER_HEIGHT + RedesignTableChart.TABLE_TITLE_HEIGHT;

    RedesignTableChart.SINGLE_CELL_HEIGHT = 25;

    RedesignTableChart.MULTICOHORT_XCOL_NAME = 'multiCohortXCol';

    RedesignTableChart.CHILDREN_SIZE = '__periscope_children_size';

    RedesignTableChart.COLLAPSED_STATE = '__periscope_collapsed';

    RedesignTableChart.LEVEL = "__periscope_level";

    RedesignTableChart.PARENT_ID = "__periscope_parent_id";

    RedesignTableChart.LEVEL_INDENT_INCREMENT = 15;

    RedesignTableChart.NEST_ARROW_WIDTH = 13;

    RedesignTableChart.SETDATA_TIMEOUT_SECS = 3;

    RedesignTableChart.WIDGET_CONTAINER_OFFSET = 150;

    RedesignTableChart.WIDGET_CONTAINER_PADDING = 50;

    RedesignTableChart.SORT_ICON_GUTTER = 24;

    RedesignTableChart.COHORT_MIDDLE_BUCKET_COLOR = '#a2d3fc';

    RedesignTableChart.COHORT_TOP_BUCKET_COLOR = '#6fb8ff';

    RedesignTableChart.EXTRA_ROW_TO_RENDER = 5;

    RedesignTableChart.DATE_COLUMN_REGEX = /[0-9]{4}-[0-9]{2}-[0-9]{2}/i;

    RedesignTableChart.DEFAULT_COLUMN_HEADER_WIDTHS = {
      delta_pct: 50
    };

    RedesignTableChart.prototype.isCohort = function() {
      return this.twiddles.get('chart_type') === 'cohort';
    };

    RedesignTableChart.prototype.pointCols = function() {
      return this.twiddles.getArray('point_cols');
    };

    RedesignTableChart.prototype.segmentCols = function() {
      return this.twiddles.getArray('segment_column');
    };

    RedesignTableChart.prototype.valueCols = function() {
      return this.twiddles.getArray('value_cols');
    };

    RedesignTableChart.prototype.multiRowOrMultiColumn = function() {
      return this.pointCols().length > 1 || this.segmentCols().length > 1;
    };

    RedesignTableChart.prototype.getColumnTwiddle = function(column, twiddle) {
      return App.RedesignTableChart.getColumnTwiddleFromTwiddles(this.twiddles, column, twiddle);
    };

    RedesignTableChart.getColumnTwiddleFromTwiddles = function(twiddles, column, twiddle) {
      var seriesTwiddle;
      seriesTwiddle = twiddles.getForSeries(column, twiddle);
      if (seriesTwiddle != null) {
        return seriesTwiddle;
      }
      return twiddles.getForColumn(column, twiddle);
    };

    function RedesignTableChart() {
      this.getChartHandler = bind(this.getChartHandler, this);
      this.mouseLeaveTable = bind(this.mouseLeaveTable, this);
      this.mouseEnterTable = bind(this.mouseEnterTable, this);
      this.nestedRowClicked = bind(this.nestedRowClicked, this);
      this.showHoverTooltip = bind(this.showHoverTooltip, this);
      this.cellMouseLeave = bind(this.cellMouseLeave, this);
      this.cellMouseEnter = bind(this.cellMouseEnter, this);
      this.onWidgetSettingsUpdated = bind(this.onWidgetSettingsUpdated, this);
      this.render = bind(this.render, this);
      this.resetRenderingState = bind(this.resetRenderingState, this);
      this.handleHeaderClick = bind(this.handleHeaderClick, this);
      this.generateHeader = bind(this.generateHeader, this);
      this.renderRow = bind(this.renderRow, this);
      this.cellDblclick = bind(this.cellDblclick, this);
      this.handleViewportChange = bind(this.handleViewportChange, this);
      this.markSortOrder = bind(this.markSortOrder, this);
      this.sortAllRows = bind(this.sortAllRows, this);
      this.updateSortState = bind(this.updateSortState, this);
      this.sortByColumn = bind(this.sortByColumn, this);
      this.getDarkThemeColor = bind(this.getDarkThemeColor, this);
      this.getColorFromTheme = bind(this.getColorFromTheme, this);
      this.getColor = bind(this.getColor, this);
      this.searchAndRenderRows = bind(this.searchAndRenderRows, this);
      this.searchBoxClicked = bind(this.searchBoxClicked, this);
      var ref;
      RedesignTableChart.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.noBodyBorder = ((ref = AppRedesign.current().state) != null ? ref.border : void 0) === 'off';
      this.query = '';
      this.alertHeight = 0;
      this.rowHeight = this.getMaxImageHeight() || this.constructor.DEFAULT_ROW_HEIGHT;
    }

    RedesignTableChart.prototype.unrender = function() {
      this.$el.empty();
      return this.destroy();
    };

    RedesignTableChart.prototype.setDataAndNestedColumns = function(rows, columns) {
      var column, nestedColumns;
      nestedColumns = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = columns.length; j < len; j++) {
          column = columns[j];
          results1.push(App.PivotTableHelper.createLeaf(column, column));
        }
        return results1;
      })();
      return this.setData(rows, columns, nestedColumns);
    };

    RedesignTableChart.prototype.setData = function(rows, columns, nestedColumns) {
      this.rawRows = rows;
      this.columns = columns;
      this.nestedColumns = nestedColumns;
      return this.processData();
    };

    RedesignTableChart.prototype.setDataFromChartData = function(chartData) {
      this.widget.bind('settings-updated', this.onWidgetSettingsUpdated);
      this.summaryMap = chartData.summaryMap;
      this.twiddles = chartData.twiddlesActual;
      this.defaultTheme = this.widget.colorTheme();
      switch (this.twiddles.get('chart_type')) {
        case 'cohort':
          return this.setDataFromCohortChartData(chartData);
        case 'table':
          return this.setDataFromTableChartData(chartData);
      }
    };

    RedesignTableChart.prototype.setDataFromTableChartData = function(chartData) {
      this.setDataAndNestedColumns(chartData.rows, chartData.columns);
      return this.processData();
    };

    RedesignTableChart.prototype.setDataFromCohortChartData = function(chartData) {
      var column, columns, detailColumns, firstSeriesName, j, l, len, len1, len2, m, multiRow, nestedColumns, point, pointIndex, ref, ref1, ref2, ref3, ref4, row, rows, seriesDisplayName, seriesDisplayNames, seriesIndex, seriesNames, startTime, values, xCol;
      startTime = App.Utils.timeNowInSecs();
      multiRow = (this.pointCols().length > 0 && this.isPivotTable()) || this.pointCols().length > 1;
      if (multiRow) {
        xCol = this.constructor.MULTICOHORT_XCOL_NAME;
      } else {
        xCol = this.pointCols()[0];
      }
      detailColumns = this.twiddles.get('detail_columns') || [];
      seriesNames = chartData.dataSeries.map(function(series) {
        return series.name;
      });
      seriesDisplayNames = seriesNames.map((function(_this) {
        return function(name) {
          return _this.twiddles.getForSeries(name, 'display_name');
        };
      })(this)).without(null);
      rows = [];
      if (((ref = chartData.dataSeries) != null ? (ref1 = ref[0]) != null ? ref1.dataPoints : void 0 : void 0) != null) {
        ref2 = chartData.dataSeries[0].dataPoints;
        for (pointIndex = j = 0, len = ref2.length; j < len; pointIndex = ++j) {
          point = ref2[pointIndex];
          if (pointIndex % 100 === 0) {
            if (App.Utils.timeNowInSecs() - this.constructor.SETDATA_TIMEOUT_SECS > startTime) {
              throw new Error(App.Chartographer.ERR_TIMEOUT);
            }
          }
          row = {};
          if (this.isPivotTable() && (typeof point.x === 'string' || typeof point.x === 'number')) {
            row[xCol] = [point.x];
          } else {
            row[xCol] = point.x;
          }
          for (seriesIndex = l = 0, len1 = seriesDisplayNames.length; l < len1; seriesIndex = ++l) {
            seriesDisplayName = seriesDisplayNames[seriesIndex];
            row[seriesDisplayName] = chartData.dataSeries[seriesIndex].dataPoints[pointIndex].y;
          }
          if ((point != null ? point.row : void 0) != null) {
            firstSeriesName = Object.keys(point.row)[0];
          }
          if ((firstSeriesName != null) && (((ref3 = point.row) != null ? (ref4 = ref3[firstSeriesName]) != null ? ref4[0] : void 0 : void 0) != null)) {
            values = point.row[firstSeriesName][0];
            for (m = 0, len2 = detailColumns.length; m < len2; m++) {
              column = detailColumns[m];
              row[column] = values[column];
            }
          }
          rows.push(row);
        }
      }
      if (multiRow) {
        rows = this.makeNestedRows(rows, seriesNames, this.twiddles, chartData.dataSeries);
      }
      nestedColumns = App.PivotTableHelper.getNestedColumns(xCol, detailColumns, chartData.dataSeries);
      columns = App.PivotTableHelper.traverseNestedColumns(nestedColumns);
      this.setData(rows, columns, nestedColumns);
      this.originalColumnSet = this.twiddles.getArray('column_names').to_set();
      return this.seriesSet = this.twiddles.getArray('series_names').to_set();
    };

    RedesignTableChart.prototype.processData = function() {
      this.unformattedColumns = [];
      if (this.isCohort()) {
        this.unformattedColumns = (this.twiddles.get('point_cols') || []).slice(0);
      }
      if (this.isCohort()) {
        this.unformattedColumns = this.unformattedColumns.concat(this.twiddles.get('detail_columns'));
      }
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.colsOnPage = {};
      this.sortedByColumn = null;
      this.sortedByColumnIndex = -1;
      this.sortDirection = 1;
      this.allSortedRawRows = jQuery.extend([], true, this.rawRows);
      this.processedRows = {};
      if (this.dragDropTableChart()) {
        this.renderIndex = !this.twiddles.get('table_line_numbers');
      } else {
        this.renderIndex = !this.twiddles.get('table_line_numbers') && !this.multiRowOrMultiColumn();
      }
      if (this.isCohort()) {
        this.valueBucketsCache = null;
        this.valueRangesCache = null;
        this.formatter = App.ChartFormatters.cohortGridCellFormatter;
      } else {
        this.formatter = App.ChartFormatters.tableCellFormatter;
      }
      this.initConditionalFormatting();
      this.initDataBars();
      this.setupSearchotron();
      this.columnWidthMap = {};
      return this.valueBuckets();
    };

    RedesignTableChart.prototype.dragDropTableChart = function() {
      return this.widget.isDragDrop() && this.twiddles.get('chart_type') === 'table';
    };

    RedesignTableChart.prototype.setColumnRanges = function() {
      var column, j, len, maxValue, minValue, ref, results1, rowMap, zeroPoint;
      this.dataBarRanges = {};
      ref = this.columns;
      results1 = [];
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        rowMap = _.map(this.rawRows, (function(r) {
          var parsedVal;
          parsedVal = App.ChartUtils.numberFromNumberishString(r[column]);
          if (typeof parsedVal === 'number') {
            return parsedVal;
          }
          return 0;
        }));
        maxValue = _.max(rowMap);
        minValue = _.min(rowMap);
        if (maxValue < 0) {
          zeroPoint = 1;
        } else if (minValue > 0) {
          zeroPoint = 0;
        } else {
          if ((maxValue - minValue) !== 0) {
            zeroPoint = Math.abs(minValue) / (maxValue - minValue);
          }
        }
        if (zeroPoint == null) {
          zeroPoint = 0;
        }
        results1.push(this.dataBarRanges[column] = {
          minValue: minValue,
          maxValue: maxValue,
          zeroPoint: zeroPoint
        });
      }
      return results1;
    };

    RedesignTableChart.prototype.setupSearchotron = function() {
      this.sortedRawRows = this.allSortedRawRows;
      return this.searchotron = new App.Searchotron(this.columns, this.sortedRawRows);
    };

    RedesignTableChart.prototype.destroy = function() {
      var ref;
      this.widget.unbind('settings-updated', this.onWidgetSettingsUpdated);
      if ((ref = this.rowsWrapper[0]) != null) {
        ref.onscroll = null;
      }
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.colsOnPage = {};
      this.rawRows = [];
      this.sortedRawRows = [];
      this.processedRows = {};
      this.columnWidthCache = {};
      delete this.nestedRows;
      return delete this.nestedColumns;
    };

    RedesignTableChart.prototype.seriesNameToAggregationMap = function(dataSeries) {
      var j, len, series, seriesNameToAggregationMap, useLastSeriesName;
      if (this.twiddles.getArray('value_columns').length < 1 || this.segmentCols().length === 0) {
        return {};
      }
      seriesNameToAggregationMap = {};
      useLastSeriesName = this.twiddles.getArray('value_columns').length > 1;
      for (j = 0, len = dataSeries.length; j < len; j++) {
        series = dataSeries[j];
        seriesNameToAggregationMap[series.name] = useLastSeriesName ? series.namelist.last() : series.namelist.first();
      }
      return seriesNameToAggregationMap;
    };

    RedesignTableChart.prototype.makeNestedRows = function(rows, seriesNames, twiddles, dataSeries) {
      var j, len, orderedRows, ref, row, seriesNameToAggregationMap;
      seriesNameToAggregationMap = this.seriesNameToAggregationMap(dataSeries);
      this.nestedRows = App.PivotTableHelper.getNestedRows(rows, seriesNames, twiddles, seriesNameToAggregationMap, this.summaryMap);
      if (!(this.isCohort() && this.twiddles.get('cohort_sort_order'))) {
        App.PivotTableHelper.sortNestedRowsByName(this.nestedRows, false);
      }
      orderedRows = [];
      ref = this.nestedRows;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        this.traverseNestedRows(row, [], -1, orderedRows);
      }
      return orderedRows;
    };

    RedesignTableChart.prototype.traverseNestedRows = function(node, stack, parentId, orderedRows) {
      return App.PivotTableHelper.traverseNestedRows(node, stack, parentId, orderedRows);
    };

    RedesignTableChart.prototype.hasSearch = function() {
      return this.query.length > 0;
    };

    RedesignTableChart.prototype.searchBoxClicked = function(e) {
      this.query = this.searchBoxInput.val();
      clearTimeout(this.pendingSearchTimeout);
      return this.pendingSearchTimeout = setTimeout(this.searchAndRenderRows, this.constructor.SEARCH_TYPING_DELAY);
    };

    RedesignTableChart.prototype.renderNewData = function() {
      var searchWasShowing;
      searchWasShowing = this.searchIsOpen();
      this.render(true);
      if (searchWasShowing) {
        this.toggleSearch(true);
      }
      this.searchAndRenderRows();
      if (searchWasShowing) {
        this.searchBoxInput.trigger('focus');
        this.searchBoxInput.val('');
        this.searchBoxInput.val(this.query);
      }
      return this.rowsWrapper.removeClass('with-animate');
    };

    RedesignTableChart.prototype.resize = function() {
      this.resizeRowWrapper();
      return this.handleViewportChange();
    };

    RedesignTableChart.prototype.searchAndRenderRows = function() {
      var index, matchingRowsWithParents, queryTokens, row;
      this.matchingRows = this.searchotron.search(this.query);
      queryTokens = App.Searchotron.tokenize(this.query);
      if (queryTokens.length !== 0) {
        if (this.isCohort()) {
          matchingRowsWithParents = this.setMatchingRowsAndParents();
          this.resetCollapseState();
          this.sortedRawRows = (function() {
            var j, len, ref, results1;
            ref = this.allSortedRawRows;
            results1 = [];
            for (index = j = 0, len = ref.length; j < len; index = ++j) {
              row = ref[index];
              if (matchingRowsWithParents[index]) {
                results1.push(row);
              }
            }
            return results1;
          }).call(this);
        } else {
          this.sortedRawRows = (function() {
            var j, len, ref, results1;
            ref = this.allSortedRawRows;
            results1 = [];
            for (index = j = 0, len = ref.length; j < len; index = ++j) {
              row = ref[index];
              if (this.matchingRows[index]) {
                results1.push(row);
              }
            }
            return results1;
          }).call(this);
        }
      } else {
        this.sortedRawRows = this.allSortedRawRows;
      }
      this.noRowsMessage.toggle(this.sortedRawRows.length === 0);
      this.rowsWrapper.scrollTop(0);
      this.resetRenderingState();
      this.rows.html('');
      this.handleViewportChange();
      return this.updateRowsHeight();
    };

    RedesignTableChart.prototype.setMatchingRowsAndParents = function() {
      var i, matched, matchingRowsWithParents;
      matchingRowsWithParents = $.extend({}, this.matchingRows);
      for (i in matchingRowsWithParents) {
        matched = matchingRowsWithParents[i];
        if (matched) {
          this.setParentRows(i, matchingRowsWithParents);
        }
      }
      return matchingRowsWithParents;
    };

    RedesignTableChart.prototype.setParentRows = function(index, parentRows) {
      var parentId;
      parentId = this.allSortedRawRows[index][this.constructor.PARENT_ID];
      if ((parentId == null) || parentId === -1 || index >= parentRows) {
        return;
      }
      parentRows[parentId] = true;
      return this.setParentRows(parentId, parentRows);
    };

    RedesignTableChart.prototype.matchesQuery = function(row) {
      var k, v;
      for (k in row) {
        v = row[k];
        if ((v || '').indexOf(this.query) !== -1) {
          return true;
        }
      }
    };

    RedesignTableChart.prototype.searchIsOpen = function() {
      return this.rowsWrapper.hasClass('with-search');
    };

    RedesignTableChart.prototype.toggleSearch = function(instant) {
      if (instant == null) {
        instant = false;
      }
      if (this.searchIsOpen()) {
        return this.closeSearch(instant);
      } else {
        return this.openSearch(instant);
      }
    };

    RedesignTableChart.prototype.getColor = function(color_type) {
      if (App.RedesignDashboardSizer.useDarkTheme(this.el)) {
        return this.getDarkThemeColor(color_type);
      } else {
        return this.getColorFromTheme(color_type);
      }
    };

    RedesignTableChart.prototype.getColorFromTheme = function(color_type) {
      var ref;
      return (ref = this.twiddles.get(color_type)) != null ? ref : this.defaultTheme[color_type];
    };

    RedesignTableChart.prototype.getDarkThemeColor = function(color_type) {
      var ref, ref1;
      if (!AppRedesign.current().colorThemesEnabled || ((ref = this.defaultTheme) != null ? ref.isPeriscopeDefault : void 0)) {
        return (ref1 = this.twiddles.get(color_type)) != null ? ref1 : App.ColorTheme.PERISCOPE_DEFAULT_DARK_THEME_PALETTE()[color_type];
      } else {
        return this.getColorFromTheme(color_type);
      }
    };

    RedesignTableChart.prototype.openSearch = function(instant) {
      var ref;
      if (instant == null) {
        instant = false;
      }
      App.Utils.logFeature('open-ninja-grid-search', {
        widget_id: this.widget.id,
        dashboard_id: (ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0
      });
      if (instant) {
        this.searchBoxArea.addClass('no-animate');
        this.rowsWrapper.addClass('no-animate');
      }
      this.rowsWrapper.addClass('with-search with-animate');
      this.parentWidgetContainer().addClass('with-search');
      this.searchBoxArea[0].style.top = this.formattedColumnWidths.length * this.constructor.HEADER_HEIGHT + "px";
      this.resizeRowWrapper();
      this.searchBoxArea.removeClass('hidden');
      this.maybeAddBorder();
      this.searchBoxInput.trigger('focus');
      if (instant) {
        this.searchotron.initializeIndexOnce();
        return setTimeout(((function(_this) {
          return function() {
            _this.searchBoxArea.removeClass('no-animate');
            return _this.rowsWrapper.removeClass('no-animate');
          };
        })(this)), 0);
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.searchotron.initializeIndexOnce();
          };
        })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      }
    };

    RedesignTableChart.prototype.closeSearch = function(instant) {
      if (instant == null) {
        instant = false;
      }
      this.rowsWrapper.removeClass('with-search');
      this.parentWidgetContainer().removeClass('with-search');
      this.rowsWrapper[0].style.marginTop = this.formattedColumnWidths.length * this.constructor.HEADER_HEIGHT + "px";
      this.searchBoxArea.addClass('hidden hiding');
      setTimeout(((function(_this) {
        return function() {
          return _this.searchBoxArea.removeClass('hiding');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      if (this.searchBoxInput.val() !== '') {
        this.searchBoxInput.val('');
        this.query = '';
        this.searchAndRenderRows();
      }
      return this.resizeRowWrapper();
    };

    RedesignTableChart.prototype.sortByColumn = function(sortColumnIndex) {
      this.markSortOrder();
      this.updateSortState(sortColumnIndex);
      this.sortAllRows();
      this.resetRenderingState();
      this.leftOffset = this.rowsWrapper.scrollLeft();
      this.renderNewData();
      return this.setSearchColumnClass();
    };

    RedesignTableChart.prototype.setSearchColumnClass = function() {
      var lastHeaderRow;
      lastHeaderRow = this.headerRow.last();
      lastHeaderRow.find("[headerIndex]").removeClass("sort");
      return lastHeaderRow.find("[headerIndex=" + this.sortedByColumnIndex + "]").addClass(this.sortDirection != null ? 'sort' : void 0);
    };

    RedesignTableChart.prototype.updateSortState = function(sortColumnIndex) {
      var sortColumn;
      sortColumn = this.columns[sortColumnIndex];
      if (sortColumn === this.sortedByColumn) {
        return this.sortDirection = -this.sortDirection;
      } else {
        this.sortedByColumn = sortColumn;
        this.sortedByColumnIndex = sortColumnIndex;
        return this.sortDirection = 1;
      }
    };

    RedesignTableChart.prototype.isDataNumeric = function(allSortedRawRows, sortedByColumn) {
      var isDataNumeric, j, len, row, val;
      isDataNumeric = true;
      for (j = 0, len = allSortedRawRows.length; j < len; j++) {
        row = allSortedRawRows[j];
        val = row[sortedByColumn];
        isDataNumeric && (isDataNumeric = App.PivotTableHelper.setPeriscopeSortProperty(row, val));
        if (!isDataNumeric) {
          break;
        }
      }
      return isDataNumeric;
    };

    RedesignTableChart.prototype.sortAllRows = function() {
      var isDataNumeric, j, l, len, len1, ref, ref1, row;
      if (this.nestedRows != null) {
        ref = this.nestedRows;
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          App.PivotTableHelper.setNestedPeriscopeSortProperty(row, this.sortedByColumn);
        }
        App.PivotTableHelper.sortNestedRows(this.nestedRows, this.sortDirection, this.sortedByColumn);
        this.allSortedRawRows = [];
        ref1 = this.nestedRows;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          row = ref1[l];
          this.traverseNestedRows(row, [], -1, this.allSortedRawRows);
        }
      } else {
        isDataNumeric = this.isDataNumeric(this.allSortedRawRows, this.sortedByColumn);
        this.allSortedRawRows.sort(App.PivotTableHelper.sortRows(isDataNumeric, this.sortDirection, this.sortedByColumn));
      }
      this.setupSearchotron();
      return this.searchotron.initializeIndexOnce();
    };

    RedesignTableChart.prototype.markSortOrder = function() {
      var i, j, len, ref, results1, row;
      ref = this.sortedRawRows;
      results1 = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        row = ref[i];
        results1.push(row.periscopeLastIndex = i);
      }
      return results1;
    };

    RedesignTableChart.prototype.errorDetails = function(columns) {
      var details, hash_key, ref, ref1;
      if (columns == null) {
        columns = [];
      }
      details = [];
      details.push("widget_id:" + ((ref = this.widget) != null ? ref.id : void 0));
      hash_key = (ref1 = this.widget) != null ? ref1.hashKey() : void 0;
      if (hash_key != null) {
        details.push("hash_key:" + hash_key);
      }
      details.push("chart_type:" + (this.twiddles.get('chart_type')));
      details.push("twiddle_segment_column:" + (this.twiddles.get('segment_column')));
      details.push("twiddle_unpivoted_column:" + (this.twiddles.get('point_cols')));
      if (columns != null) {
        details.push("columns:" + (columns.join(',')));
      }
      if (this.sortedRawRows != null) {
        details.push("num_displayed_rows:" + this.sortedRawRows.length);
      }
      if (this.allSortedRawRows != null) {
        details.push("num_all_rows:" + this.allSortedRawRows.length);
      }
      return "\n" + details.join("\n");
    };

    RedesignTableChart.prototype.initConditionalFormatting = function() {
      return this.allCfRules = (this.twiddles.get('conditional_formatting') || []).slice(0);
    };

    RedesignTableChart.prototype.initDataBars = function() {
      var ref, ref1;
      this.defaultTheme = this.widget.colorTheme();
      this.dataBarRules = (this.twiddles.get(App.TwiddleConfig.DATA_BARS) || []).slice(0);
      if (((ref = this.dataBarRules) != null ? ref.length : void 0) > 0) {
        this.setColumnRanges();
      }
      this.defaultEvenRowColor = this.getColor('table_color_even_rows_background');
      this.defaulOddRowColor = this.getColor('table_color_even_rows_background');
      return this.dataBarRulesPresent = ((ref1 = this.dataBarRules) != null ? ref1.length : void 0) > 0;
    };

    RedesignTableChart.prototype.handleViewportChange = function(e) {
      var colsOnPageChanged, contentStart, el, i, j, l, len, parent_widget_container, purgeDownTo, purgeUpTo, ref, ref1, ref2, ref3, row, rowBatchEl, rowIndex, scrollTop, target_width, totalRow, viewportHeight, wrapper, wrapperHeight;
      App.Utils.initRedesignCanvasWidthSizer();
      wrapper = this.rowsWrapper[0];
      parent_widget_container = this.parentWidgetContent();
      target_width = parent_widget_container != null ? parent_widget_container.clientWidth : 0;
      ref = this.headerRow;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        row = ref[i];
        row.style.left = -wrapper.scrollLeft + "px";
        row.style.top = i * this.constructor.HEADER_HEIGHT + "px";
      }
      if (this.noBodyBorder && target_width > this.totalColumnWidth) {
        this.tableBorder[0].style.left = -wrapper.scrollLeft + "px";
      }
      scrollTop = wrapper.scrollTop;
      wrapperHeight = this.targetHeight() - this.constructor.HEADER_HEIGHT;
      if (AppRedesign.isNewLook()) {
        wrapperHeight += 12;
      }
      this.rowHeight = this.getMaxImageHeight() || this.constructor.DEFAULT_ROW_HEIGHT;
      purgeDownTo = Math.max(0, Math.floor(scrollTop / this.rowHeight) - this.constructor.EXTRA_ROW_TO_RENDER);
      contentStart = Math.floor(scrollTop / this.rowHeight);
      viewportHeight = Math.floor(wrapperHeight / this.rowHeight);
      purgeUpTo = Math.min(contentStart + viewportHeight + this.constructor.EXTRA_ROW_TO_RENDER, this.sortedRawRows.length);
      if (this.lastScrollLeft !== wrapper.scrollLeft || this.lastRowWrapperWidth !== this.rowsWrapper.width()) {
        colsOnPageChanged = this.updateColsOnPage();
        this.lastScrollLeft = wrapper.scrollLeft;
        this.lastRowWrapperWidth = this.rowsWrapper.width();
      }
      ref1 = this.rowsOnPage;
      for (rowIndex in ref1) {
        el = ref1[rowIndex];
        if (rowIndex < purgeDownTo || rowIndex > purgeUpTo || colsOnPageChanged) {
          el.parentNode.removeChild(el);
          if (scrollTop !== wrapper.scrollTop) {
            wrapper.scrollTop = scrollTop;
          }
          delete this.rowsOnPage[rowIndex];
        }
      }
      if (colsOnPageChanged) {
        this.renderedEls = {};
      }
      rowBatchEl = document.createElement("div");
      rowBatchEl.className = "row-batch";
      for (i = l = ref2 = purgeDownTo, ref3 = purgeUpTo; ref2 <= ref3 ? l < ref3 : l > ref3; i = ref2 <= ref3 ? ++l : --l) {
        if (this.rowsOnPage[i]) {
          continue;
        }
        row = this.renderRow(i);
        if (!row) {
          break;
        }
        rowBatchEl.appendChild(row);
        this.rowsOnPage[i] = row;
        if ((i === this.sortedRawRows.length - 1) && this.shouldShowTotalRow() && !this.isCohort()) {
          totalRow = this.renderRow(this.sortedRawRows.length, true);
          if (totalRow != null) {
            rowBatchEl.appendChild(totalRow);
          }
        }
      }
      return this.rows.append(rowBatchEl);
    };

    RedesignTableChart.prototype.updateColsOnPage = function() {
      var colsOnPageChanged, column, currentColLeft, fillAlign, i, indexWidth, j, len, ref, scrollLeft, showCol, wrapperWidth;
      colsOnPageChanged = false;
      currentColLeft = 0;
      wrapperWidth = this.rowsWrapper.width();
      scrollLeft = this.rowsWrapper[0].scrollLeft;
      indexWidth = this.indexColWidth();
      fillAlign = this.fillAlign();
      ref = this.columns;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        column = ref[i];
        showCol = true;
        if ((wrapperWidth + scrollLeft < currentColLeft) || (currentColLeft + this.rawColumnWidths[i] + indexWidth < scrollLeft)) {
          if (!fillAlign) {
            showCol = false;
          }
        }
        if (this.colsOnPage[i] !== showCol) {
          colsOnPageChanged = true;
          this.colsOnPage[i] = showCol;
        }
        currentColLeft += this.rawColumnWidths[i];
      }
      return colsOnPageChanged;
    };

    RedesignTableChart.prototype.widgetHeight = function() {
      var dash, inEditron, inLinkedWidgetArea, isInDataTab, sizer, widgetHeight;
      inLinkedWidgetArea = App.RedesignDashboardSizer.inLinkedWidgetArea(this.el);
      isInDataTab = App.RedesignDashboardSizer.inDataTab(this.el);
      inEditron = App.RedesignDashboardSizer.inEditron(this.el);
      sizer = new App.RedesignDashboardSizer(App.Dashboard.currentDashboard());
      if (inLinkedWidgetArea) {
        widgetHeight = sizer.LINKED_MODE_NUM_ROWS;
      } else if (this.widget != null) {
        widgetHeight = this.widget.getHeight() || sizer.EDITOR_INITIAL_HEIGHT;
      } else {
        widgetHeight = sizer.EDITOR_INITIAL_HEIGHT;
      }
      if (isInDataTab) {
        return sizer.maxColumnWidth() * sizer.EDITOR_MAX_ROWS;
      }
      if (inEditron || inLinkedWidgetArea) {
        if (widgetHeight > sizer.EDITOR_MAX_ROWS) {
          widgetHeight = sizer.EDITOR_MAX_ROWS;
        }
        return sizer.maxColumnWidth() * widgetHeight;
      } else {
        dash = App.Dashboard.currentDashboard();
        return sizer.columnWidth() * widgetHeight;
      }
    };

    RedesignTableChart.prototype.calcIndexWidth = function() {
      var index;
      index = this.indexColWidth();
      if (this.fillAlign()) {
        index /= this.totalColumnWidth;
        index *= 100;
      }
      return this.indexWidth = this.addUnits(index);
    };

    RedesignTableChart.prototype.cellDblclick = function(row) {
      var column, dashboard_id, i, j, l, len, len1, mapping, mappings, point, pointSet, ref;
      dashboard_id = this.twiddles.get('drilldown_dashboard');
      if (dashboard_id == null) {
        return false;
      }
      mappings = this.twiddles.getArray('drilldown_mapping');
      point = {};
      for (j = 0, len = mappings.length; j < len; j++) {
        mapping = mappings[j];
        if (this.columns.includes(mapping.column) && (typeof pointSet === "undefined" || pointSet === null)) {
          ref = this.columns;
          for (i = l = 0, len1 = ref.length; l < len1; i = ++l) {
            column = ref[i];
            if (row[column] != null) {
              point[column] = row[column]["raw_value"];
            }
          }
          pointSet = true;
        }
        if (mapping.filter === App.CustomDimension.DATE_RANGE) {
          this.pickAggregation(mapping.column);
        }
      }
      return App.DrilldownsController.applyDrilldownRequest(this, dashboard_id, mappings, point, this.twiddles);
    };

    RedesignTableChart.prototype.pickAggregation = function(column) {
      var aggregation, dates, j, l, len, len1, rawRow, ref, ref1;
      dates = [];
      ref = this.rawRows.slice(0, 101);
      for (j = 0, len = ref.length; j < len; j++) {
        rawRow = ref[j];
        dates.push(Date.parse(rawRow[column]));
      }
      if (Object.keys(dates.to_set()).length === 1) {
        ref1 = this.rawRows.slice(100, 1001);
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          rawRow = ref1[l];
          dates.push(Date.parse(rawRow[column]));
        }
      }
      aggregation = App.RowProcessor.pickAggregationFromDates(dates);
      if (aggregation != null) {
        return this.twiddles.set('aggregation', aggregation);
      }
    };

    RedesignTableChart.prototype.extractValueCol = function(column, twiddles) {
      return App.PivotTableHelper.extractValueCol(column, twiddles);
    };

    RedesignTableChart.prototype.renderRow = function(rowIndex, isTotalRow) {
      var arrowCss, baseBgColor, baseTextColor, bgColor, borderClass, borderColor, cell, cellBorderClass, colors, column, cssClassName, dataBar, el, headerBgColor, headerColors, headerTextColor, html, i, imgHeight, imgWidth, indexBorderClass, isCohortValueCol, isEvenRow, j, len, nested, paddingLeft, rawRowIndex, rawValue, rawValueStr, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, row, rule, sourceColumn, textColor, truncatedValue, value, valueIsNumeric, valueStr;
      if (isTotalRow == null) {
        isTotalRow = false;
      }
      if (!isTotalRow && this.renderedEls[rowIndex]) {
        return this.renderedEls[rowIndex];
      }
      if (this.pointCols().length === 0 && this.valueCols().length === 0) {
        return;
      }
      el = document.createElement("div");
      isEvenRow = rowIndex % 2 === 0;
      el.className = "row " + (isEvenRow ? 'even' : 'odd');
      if (isTotalRow) {
        el.className += " total";
      }
      baseTextColor = this.colorForTextRow(isEvenRow);
      baseBgColor = this.colorForBackgroundRow(isEvenRow);
      html = [];
      borderClass = 'right-border';
      colors = "";
      if (baseTextColor != null) {
        colors += "color:" + baseTextColor + ";";
      }
      if (baseBgColor != null) {
        colors += "background:" + baseBgColor + ";";
      }
      if (this.renderIndex) {
        indexBorderClass = borderClass;
        html.push(this.view('redesign/ninja_grid/ninja_cell_index')({
          colors: colors,
          left: this.addUnits(0),
          val: (isTotalRow ? '&sum;' : rowIndex + 1),
          top: this.rowHeight * rowIndex,
          width: this.indexWidth,
          height: this.rowHeight
        }));
      }
      if (isTotalRow) {
        row = this.getTotalRow();
      }
      if (this.isCohort() && !this.isDisplayingSearchResult()) {
        rawRowIndex = this.toRawRowIndex(rowIndex);
        if (rawRowIndex === -1) {
          return null;
        }
        if (row == null) {
          row = this.processRow(rawRowIndex);
        }
        if (row == null) {
          return null;
        }
      } else {
        if (row == null) {
          row = this.processRow(rowIndex);
        }
      }
      ref = this.columns;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        column = ref[i];
        if (!this.colsOnPage[i]) {
          continue;
        }
        rawValue = row[column] != null ? row[column]["raw_value"] : "";
        rawValueStr = "" + rawValue;
        value = row[column] != null ? row[column]["value"] : "";
        if ((value == null) && this.pointCols().length === 0) {
          value = 'Total';
        }
        valueStr = "" + value;
        sourceColumn = column;
        imgHeight = this.twiddles.getForColumn(sourceColumn, 'image_height');
        imgWidth = this.twiddles.getForColumn(sourceColumn, 'image_width');
        if (this.isCohort() && (column != null) && (this.unformattedColumnSet[column] == null)) {
          sourceColumn = this.extractValueCol(column, this.twiddles);
        }
        valueIsNumeric = this.twiddles.getForColumn(sourceColumn, 'type') === 'numeric';
        isCohortValueCol = this.isCohort() && this.fieldIsCohortValueColumn(column);
        rule = App.RedesignConditionalFormattingRuleController.matchFirstRule(this.allCfRules, sourceColumn, rawValueStr, valueIsNumeric);
        dataBar = this.getDataBarProperties(sourceColumn, column, value);
        bgColor = (rule != null ? rule.bg_color : void 0) || this.cohortColor(row, column) || baseBgColor;
        textColor = (rule != null ? rule.text_color : void 0) || (dataBar != null ? dataBar.textColor : void 0) || baseTextColor;
        colors = "";
        if (textColor != null) {
          colors += "color:" + textColor + ";";
        }
        if (bgColor != null) {
          colors += "background:" + bgColor + ";";
        }
        if ((dataBar != null) && (bgColor != null)) {
          colors += "background:linear-gradient(to right, " + bgColor + " " + dataBar.start + "%, " + dataBar.dataBarColor + " " + dataBar.start + "%, " + dataBar.dataBarColor + " " + dataBar.end + "%";
          if (dataBar.end !== 100) {
            colors += ", " + bgColor + " " + dataBar.end + "%";
          }
          colors += ");";
        }
        if (this.dataBarRulesPresent && !(((ref1 = row[column]) != null ? (ref2 = ref1.cssClass) != null ? ref2.length : void 0 : void 0) > 0)) {
          if (bgColor == null) {
            bgColor = (isEvenRow ? this.defaultEvenRowColor : this.defaultOddRowColor);
          }
        }
        if (column === this.constructor.MULTICOHORT_XCOL_NAME) {
          headerTextColor = this.getColorFromTheme('table_color_header_text');
          if (this.defaultTheme || (this.twiddles.get('table_color_header_background') != null)) {
            headerBgColor = this.getColorFromTheme('table_color_header_background');
            if (row.multiCohortXCol.level === 2) {
              headerBgColor = App.ColorHelper.lightenOrDarken(headerBgColor, 18);
            }
            if (row.multiCohortXCol.level === 3) {
              headerBgColor = App.ColorHelper.lightenOrDarken(headerBgColor, 32);
            }
            borderColor = App.ColorHelper.lightenOrDarken(headerBgColor, -50);
          }
        }
        truncatedValue = ((ref3 = row[column]) != null ? ref3["linkName"] : void 0) != null ? row[column]["linkName"] : valueStr;
        if (truncatedValue.length > this.constructor.GRID_MAX_DISPLAY_CHARS) {
          truncatedValue = truncatedValue.substr(0, this.constructor.GRID_MAX_DISPLAY_CHARS) + "...";
        }
        cssClassName = ((ref4 = row[column]) != null ? ref4["cssClass"] : void 0) != null ? row[column]["cssClass"] : '';
        cssClassName += " " + (this.cellCssAlignmentClass(column, valueIsNumeric, isCohortValueCol));
        cellBorderClass = borderClass;
        if (i === 0 && (!this.renderIndex) && this.centerAlign()) {
          cellBorderClass += ' left-border';
        }
        if (i === this.columns.length - 1) {
          cellBorderClass = '';
        }
        paddingLeft = (ref5 = row[column]) != null ? ref5['paddingLeft'] : void 0;
        nested = (ref6 = row[column]) != null ? ref6.nested : void 0;
        arrowCss = "";
        if (row[this.constructor.COLLAPSED_STATE]) {
          arrowCss += "collapsed";
        }
        if (!this.isDisplayingSearchResult() && nested) {
          cssClassName += " clickable";
        }
        headerColors = "";
        if (headerTextColor != null) {
          headerColors += "color:" + headerTextColor + ";";
        }
        if (headerBgColor != null) {
          headerColors += "background:" + headerBgColor + ";";
        }
        if (borderColor != null) {
          headerColors += "border-color:" + borderColor + ";";
        }
        cell = this.view('redesign/ninja_grid/ninja_cell_column')({
          arrowCss: arrowCss,
          borderClass: cellBorderClass,
          bgColor: bgColor,
          colors: colors,
          column: i,
          cssClassName: cssClassName,
          dataBar: dataBar,
          fullValue: valueStr,
          headerColors: headerColors,
          isLink: (ref7 = row[column]) != null ? ref7.isLink : void 0,
          isImage: (ref8 = row[column]) != null ? ref8.isImage : void 0,
          left: this.leftOffsets[i],
          multiCohortXCol: column === this.constructor.MULTICOHORT_XCOL_NAME,
          nested: nested,
          paddingLeft: paddingLeft != null ? "padding-left:" + paddingLeft + "px;" : void 0,
          row: rowIndex,
          textColor: textColor,
          top: this.rowHeight * rowIndex,
          val: truncatedValue,
          width: this.columnWidths[i],
          height: this.rowHeight,
          imgHeight: imgHeight,
          imgWidth: imgWidth
        });
        html.push(cell);
      }
      el.innerHTML = html.join("");
      if (App.DrilldownsController.shouldAddDrilldown(this.el, this.twiddles)) {
        $(el).on('dblclick', ((function(_this) {
          return function() {
            return _this.cellDblclick(row);
          };
        })(this)));
        $(el).addClass("drilldown");
      }
      if (!isTotalRow) {
        this.renderedEls[rowIndex] = el;
      }
      return el;
    };

    RedesignTableChart.prototype.isDisplayingSearchResult = function() {
      return this.sortedRawRows.length < this.allSortedRawRows.length;
    };

    RedesignTableChart.prototype.horizontalPositioning = function() {
      if (this.centerAlign()) {
        return "position: absolute; margin-left: auto; margin-right: auto; left: 0px; right: 0px;";
      } else {
        return "position: absolute; left: 0px";
      }
    };

    RedesignTableChart.prototype.leftAlign = function() {
      return !this.twiddles.get('table_alignment_checked') || this.twiddles.get('table_alignment') === 'left' || this.twiddles.get('table_alignment') === void 0;
    };

    RedesignTableChart.prototype.centerAlign = function() {
      return this.twiddles.get('table_alignment_checked') && this.twiddles.get('table_alignment') !== 'fill';
    };

    RedesignTableChart.prototype.fillAlign = function() {
      return this.twiddles.get('table_alignment_checked') && this.twiddles.get('table_alignment') === 'fill';
    };

    RedesignTableChart.prototype.cellCssAlignmentClass = function(column, valueIsNumeric, numericCohortColumn) {
      var cssAlign, userAlign;
      cssAlign = "";
      if (valueIsNumeric || numericCohortColumn) {
        cssAlign = "right";
      }
      userAlign = this.getColumnTwiddle(column, 'alignment');
      if (userAlign != null) {
        cssAlign = userAlign;
      }
      return cssAlign;
    };

    RedesignTableChart.prototype.colorForBackgroundRow = function(isEven) {
      var evenClass;
      evenClass = (isEven ? 'even' : 'odd');
      return this.getColor("table_color_" + evenClass + "_rows_background");
    };

    RedesignTableChart.prototype.colorForTextRow = function(isEven) {
      var evenClass;
      evenClass = (isEven ? 'even' : 'odd');
      return this.getColor("table_color_" + evenClass + "_rows_text");
    };

    RedesignTableChart.prototype.cohortColor = function(row, column) {
      var float_value, ref, value, valueBuckets;
      if (!(this.isCohort() && (column != null))) {
        return;
      }
      if (this.dontColorColumn(column)) {
        return;
      }
      value = (ref = row[column]) != null ? ref.raw_value : void 0;
      if (!App.ChartUtils.isNumberish(value)) {
        return;
      }
      float_value = App.ChartUtils.numberFromNumberishString(value);
      valueBuckets = this.valueBuckets();
      if (this.twiddles.get('no_cohort_color')) {
        return;
      }
      switch (false) {
        case !(float_value > valueBuckets[1]):
          return this.constructor.COHORT_TOP_BUCKET_COLOR;
        case !(float_value > valueBuckets[0]):
          return this.constructor.COHORT_MIDDLE_BUCKET_COLOR;
      }
    };

    RedesignTableChart.prototype.dontColorColumn = function(field) {
      return (this.unformattedColumns != null) && this.unformattedColumns.includes(field);
    };

    RedesignTableChart.prototype.getDataBarProperties = function(sourceColumn, column, value) {
      var asPercent, dataBarProperties, dataBarRange, dataBarRule, numericValue, ref;
      if (!this.dataBarRulesPresent) {
        return null;
      }
      dataBarRule = _.find(this.dataBarRules, {
        'column': sourceColumn
      });
      if (this.isCohort() && this.unformattedColumns.indexOf(column) === -1 && sourceColumn !== column) {
        dataBarRange = this.valueRangesCache;
      } else {
        dataBarRange = (ref = this.dataBarRanges) != null ? ref[sourceColumn] : void 0;
      }
      numericValue = App.ChartUtils.numberFromNumberishString(value);
      if (!((dataBarRule != null) && (dataBarRange != null) && $.isNumeric(numericValue) && numericValue !== 0)) {
        return null;
      }
      asPercent = this.valueFormatFromTwiddle(this.getColumnTwiddle(column, 'value_format')) === App.ChartFormatters.CELL_FORMAT_PERCENT;
      if (asPercent) {
        numericValue = numericValue / 100;
      }
      dataBarProperties = {};
      if (numericValue >= 0) {
        if (dataBarRange.maxValue === dataBarRange.minValue) {
          dataBarProperties.start = 0;
          dataBarProperties.end = (numericValue > 0 ? 100 : 0);
        } else {
          dataBarProperties.start = dataBarRange.zeroPoint * 100;
          dataBarProperties.end = ((numericValue * (1 - dataBarRange.zeroPoint) / dataBarRange.maxValue) + dataBarRange.zeroPoint) * 100;
        }
        dataBarProperties.dataBarColor = dataBarRule.pos_bar_color;
        dataBarProperties.textColor = dataBarRule.pos_text_color;
      } else {
        if (dataBarRange.maxValue === dataBarRange.minValue) {
          dataBarProperties.start = 0;
          dataBarProperties.end = 100;
        } else {
          dataBarProperties.start = (1 - numericValue / dataBarRange.minValue) * dataBarRange.zeroPoint * 100;
          dataBarProperties.end = dataBarRange.zeroPoint * 100;
        }
        dataBarProperties.dataBarColor = dataBarRule.neg_bar_color;
        dataBarProperties.textColor = dataBarRule.neg_text_color;
      }
      return dataBarProperties;
    };

    RedesignTableChart.prototype.generateHeader = function(columnName) {
      var name;
      if (this.isCohort() && columnName === this.constructor.MULTICOHORT_XCOL_NAME) {
        return "";
      }
      if (this.twiddles.get('keep_table_column_underscores')) {
        name = columnName;
      } else {
        name = (columnName + "").replace(/_/g, " ");
      }
      if (this.isCohort()) {
        name = this.formatValue(name, this.twiddles.getArray('segment_column').first());
      }
      if (name == null) {
        return name;
      }
      return (name + "").trim();
    };

    RedesignTableChart.prototype.handleHeaderClick = function(e) {
      if (this.sortingDisabled) {
        return;
      }
      return this.sortByColumn(parseInt($(e.currentTarget).attr("headerIndex")));
    };

    RedesignTableChart.prototype.resetRenderingState = function() {
      this.renderedEls = {};
      this.rowsOnPage = {};
      this.processedRows = {};
      this.lastScrollLeft = null;
      return this.lastRowWrapperWidth = null;
    };

    RedesignTableChart.prototype.resetCollapseState = function() {
      var _, ref, results1, row;
      ref = this.sortedRawRows;
      results1 = [];
      for (_ in ref) {
        row = ref[_];
        results1.push(row[this.constructor.COLLAPSED_STATE] = false);
      }
      return results1;
    };

    RedesignTableChart.prototype.cohortPivotExists = function() {
      return (this.isCohort() && this.twiddles.redesignGetArray('point_cols').length > 1) || (this.isPivotTable() && this.twiddles.redesignGetArray('point_cols').length > 0);
    };

    RedesignTableChart.prototype.render = function(keepWidths) {
      var error, firstClass, gridCssClass, h, totalWidth;
      if (keepWidths == null) {
        keepWidths = false;
      }
      try {
        App.Utils.initRedesignCanvasWidthSizer();
        if (!(keepWidths && (this.columnWidths != null))) {
          this.setColumnWidths();
        }
        if (!(keepWidths && (this.indexWidth != null))) {
          this.calcIndexWidth();
        }
        gridCssClass = '';
        if (this.twiddles.get('hide_table_grid_lines')) {
          gridCssClass = 'hide-gridlines';
        }
        firstClass = 'right-border';
        totalWidth = this.totalColumnWidth + 'px';
        if (this.fillAlign()) {
          totalWidth = '100%';
        }
        if (this.cohortPivotExists()) {
          gridCssClass += ' cohort';
        }
        h = this.view('redesign/ninja_grid/ninja_grid')({
          gridCssClass: gridCssClass,
          firstClass: firstClass,
          firstBorder: this.centerAlign() && !this.renderIndex,
          horizontalPositioning: this.horizontalPositioning(),
          sortedByHeader: this.sortedByColumnIndex,
          sortDirection: this.sortDirection,
          columnWidths: this.columnWidths,
          totalWidth: totalWidth,
          indexWidth: this.indexWidth,
          renderIndex: this.renderIndex,
          query: this.query,
          sortingDisabled: this.sortingDisabled,
          textColor: this.getColorFromTheme('table_color_header_text'),
          bgColor: this.getColorFromTheme('table_color_header_background'),
          inCohortMode: this.cohortPivotExists(),
          totalHeaders: this.formattedColumnWidths,
          numBlankHeaders: this.numBlankHeaders(),
          singleValHeader: this.singleValHeader()
        });
        this.html(App.Utils.stripSpacesBetweenTags(h));
        this.updateRowsHeight();
        this.resizeRowWrapper();
        if (App.SetUpScreenshotMode.inScreenshotMode()) {
          this.rowsWrapper.addClass('no-animate');
        }
        this.searchAndRenderRows();
        if (this.leftOffset != null) {
          this.rowsWrapper.scrollLeft(this.leftOffset);
        }
        this.refreshElements();
        this.rowsWrapper[0].onscroll = this.handleViewportChange;
        this.resize();
        if (this.hasSearch()) {
          return this.openSearch(true);
        }
      } catch (error1) {
        error = error1;
        error.message = "" + error.message + (this.errorDetails());
        return AppRedesign.logError(error);
      }
    };

    RedesignTableChart.prototype.singleValHeader = function() {
      return this.isPivotTable() && this.valueCols().length === 1;
    };

    RedesignTableChart.prototype.numBlankHeaders = function() {
      var numBlankHeaders;
      numBlankHeaders = this.segmentCols().length;
      if (this.valueCols().length > 0) {
        numBlankHeaders += 1;
      } else if (this.segmentCols().length === 0 && this.valueCols().length > 0) {
        numBlankHeaders = 1;
      }
      if (this.pointCols().length === 0 || !this.isPivotTable()) {
        numBlankHeaders = 0;
      }
      return numBlankHeaders;
    };

    RedesignTableChart.prototype.updateRowsHeight = function() {
      return this.rows.height(this.rowHeight * this.sortedRawRows.length);
    };

    RedesignTableChart.prototype.getMaxImageHeight = function() {
      var maxImageHeight;
      if (!this.widget.twiddles || !this.widget.twiddles.columns) {
        return null;
      }
      maxImageHeight = Object.values(this.widget.twiddles.columns).reduce((function(acc, val) {
        if (val.column_value_format === 'image') {
          acc = Math.max(acc, val.column_image_height || 0);
        }
        return acc;
      }), 0);
      if (maxImageHeight !== 0) {
        return maxImageHeight;
      }
    };

    RedesignTableChart.prototype.maybeAddBorder = function() {
      var borderLeft, newBorderWidth, parent_widget_container, searchHeight, tableHeight, widgetWidth;
      if (!this.shouldAddBorder()) {
        return;
      }
      parent_widget_container = this.parentWidgetContent();
      if (parent_widget_container == null) {
        return;
      }
      widgetWidth = parent_widget_container.clientWidth - 2;
      if (this.fillAlign()) {
        this.el.find('.ninja-grid').addClass('fill');
        newBorderWidth = widgetWidth;
        borderLeft = 0;
      } else {
        newBorderWidth = Math.min(widgetWidth, this.totalColumnWidth);
        borderLeft = widgetWidth > this.totalColumnWidth && this.centerAlign() ? 2 : 0;
      }
      this.tableBorder.width(newBorderWidth);
      this.searchBoxArea.width(newBorderWidth);
      this.tableBorder.css('left', borderLeft);
      tableHeight = (this.rowHeight * Object.keys(this.rowsOnPage).length) + this.totalHeaderRowHeight() - 1;
      if (this.shouldShowTotalRow()) {
        tableHeight += this.rowHeight;
      }
      searchHeight = this.searchIsOpen() ? this.searchBoxInput.height() : 0;
      tableHeight += searchHeight;
      this.tableBorder.height(Math.min(tableHeight, parent_widget_container.clientHeight - 1) - searchHeight - this.totalHeaderRowHeight());
      this.rows.addClass('left-border right-border');
      this.tableBorder.addClass('left-border right-border bottom-border');
      return this.headerRow.addClass('left-border right-border');
    };

    RedesignTableChart.prototype.totalHeaderRowHeight = function() {
      var height, j, len, ref, row;
      height = 0;
      ref = this.headerRow;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        height += $(row).height();
      }
      return height;
    };

    RedesignTableChart.prototype.shouldAddBorder = function() {
      return !this.twiddles.get('hide_table_grid_lines');
    };

    RedesignTableChart.prototype.resizeRowWrapper = function() {
      var borderHeight, inEditron, newLookOffset, parent_widget_container, searchHeight, target_width;
      parent_widget_container = this.parentWidgetContent();
      inEditron = App.RedesignDashboardSizer.inEditron(this.el);
      if (parent_widget_container == null) {
        return;
      }
      borderHeight = this.noBodyBorder ? -1 : 1;
      newLookOffset = inEditron ? 10 : 4;
      this.rowsWrapper[0].style.height = this.targetHeight() + borderHeight - (this.formattedColumnWidths.length - 1) * this.constructor.HEADER_HEIGHT - newLookOffset + "px";
      target_width = parent_widget_container.clientWidth;
      if (this.leftAlign()) {
        this.rowsWrapper[0].style.width = target_width + "px";
      }
      if (this.centerAlign()) {
        this.rowsWrapper[0].style.width = (target_width / 2 + this.totalColumnWidth / 2) + "px";
      }
      searchHeight = this.searchIsOpen() ? 1 : 0;
      this.rowsWrapper[0].style.marginTop = (this.formattedColumnWidths.length + searchHeight) * this.constructor.HEADER_HEIGHT + "px";
      this.tableBorder.css('marginTop', (this.formattedColumnWidths.length + searchHeight) * this.constructor.HEADER_HEIGHT);
      if (this.fillAlign()) {
        this.rows.css('min-width', target_width + "px");
        this.rowsWrapper[0].style.overflowX = 'hidden';
      }
      if (this.centerAlign()) {
        this.rowsWrapper[0].style.maxWidth = target_width + "px";
        if (this.totalColumnWidth < target_width) {
          this.rowsWrapper[0].style.overflowX = "visible";
        }
      }
      return this.maybeAddBorder();
    };

    RedesignTableChart.prototype.parentWidgetContent = function() {
      return this.rows.closest('.widget-content, .grid-area')[0];
    };

    RedesignTableChart.prototype.parentWidgetContainer = function() {
      return this.rows.closest('.widget-container');
    };

    RedesignTableChart.prototype.targetHeight = function() {
      var h, headerHeight;
      if (this.fixedTargetHeight != null) {
        return this.fixedTargetHeight;
      }
      if (!App.SetUpScreenshotMode.slackModeInUrl()) {
        if (App.RedesignDashboardSizer.inLinkedWidgetArea(this.el)) {
          return this.targetHeightLinkedWidget();
        }
      }
      headerHeight = this.constructor.TOTAL_HEADER_HEIGHT;
      if (App.EditronController.isAnyViewMode(App.EditronController.getCurrentMode())) {
        headerHeight = this.constructor.HEADER_HEIGHT;
      }
      h = this.widgetHeight() - headerHeight - this.alertHeight;
      if (this.searchIsOpen()) {
        h -= this.constructor.HEADER_HEIGHT;
      }
      return h;
    };

    RedesignTableChart.prototype.setAlertHeight = function(alertHeight) {
      this.alertHeight = alertHeight;
    };

    RedesignTableChart.prototype.targetHeightLinkedWidget = function() {
      var h, headerHeight;
      if (this.fixedTargetHeight != null) {
        return this.fixedTargetHeight;
      }
      headerHeight = this.constructor.HEADER_HEIGHT;
      h = this.parentWidgetContent().clientHeight - headerHeight + 2;
      return h;
    };

    RedesignTableChart.prototype.indexColWidth = function() {
      if (this.renderIndex) {
        return this.constructor.GRID_INDEX_COL_WIDTH;
      } else {
        return 0;
      }
    };

    RedesignTableChart.prototype.indexColLeftOffset = function() {
      if (this.renderIndex) {
        return this.constructor.GRID_INDEX_COL_LEFT_OFFSET;
      } else {
        return 0;
      }
    };

    RedesignTableChart.prototype.fieldIsCohortValueColumn = function(field) {
      return (this.seriesSet[field] != null) && (this.originalColumnSet[field] == null);
    };

    RedesignTableChart.prototype.processRow = function(rowIndex) {
      var field, isImage, isLink, linkName, metafields, newRow, rawRow, raw_val, ref, ref1, ref2, useTableValueFormat, val;
      if (this.processedRows[rowIndex]) {
        return this.processedRows[rowIndex];
      }
      this.unformattedColumnSet = this.unformattedColumns.to_set();
      rawRow = this.sortedRawRows[rowIndex];
      newRow = {};
      metafields = [this.constructor.LEVEL, this.constructor.COLLAPSED_STATE, this.constructor.CHILDREN_SIZE, this.constructor.PARENT_ID];
      for (field in rawRow) {
        val = rawRow[field];
        if (typeof val === "object") {
          if (val != null) {
            val = val.val;
          }
          if (typeof val === "object" || (val == null)) {
            continue;
          }
        }
        if (indexOf.call(metafields, field) >= 0) {
          continue;
        }
        raw_val = val;
        ref = App.Utils.parseMarkdown(val), isLink = ref.isLink, val = ref.val, linkName = ref.linkName;
        isImage = this.valueFormatFromTwiddle(this.getColumnTwiddle(field, 'value_format')) === 'image';
        if (isImage) {
          isLink = false;
        }
        if (typeof val === "string") {
          val = val.escapeHtml();
        }
        if (this.isCohort() && (field != null) && this.fieldIsCohortValueColumn(field)) {
          useTableValueFormat = this.twiddles.get('values_format') != null;
        }
        if (this.formatter != null) {
          val = this.formatValue(val, field, useTableValueFormat);
        }
        newRow[field] = {
          value: val,
          raw_value: raw_val,
          isLink: isLink,
          isImage: isImage,
          linkName: linkName
        };
        if (linkName && !this.loggedFriendlyLinks) {
          App.Utils.logFeature('friendly-link', {
            widget_id: (ref1 = this.widget) != null ? ref1.id : void 0,
            dashboard_id: (ref2 = App.Dashboard.currentDashboard()) != null ? ref2.id : void 0
          });
          this.loggedFriendlyLinks = true;
        }
      }
      if (this.isPivotTable() || ((rawRow != null ? rawRow[this.constructor.MULTICOHORT_XCOL_NAME] : void 0) != null)) {
        App.PivotTableHelper.setNestedRowProperties(rawRow, newRow, this.pointCols().length);
      }
      this.processedRows[rowIndex] = newRow;
      return newRow;
    };

    RedesignTableChart.prototype.valueFormatFromTwiddle = function(valueFormat) {
      switch (valueFormat) {
        case 'percent_of_column':
          return 'percent';
        case 'percent_of_row':
          return 'percent';
        case 'cohort_percent_of_column':
          return 'percent';
        case 'cohort_percent_of_row':
          return 'percent';
        default:
          return valueFormat;
      }
    };

    RedesignTableChart.prototype.formatValue = function(val, field, useTableValueFormat) {
      if (useTableValueFormat == null) {
        useTableValueFormat = false;
      }
      return this.formatter(val, {
        tableValueFormat: useTableValueFormat ? this.twiddles.get('values_format') : null,
        columnValueFormat: this.valueFormatFromTwiddle(this.getColumnTwiddle(field, 'value_format')),
        numDecimals: this.getColumnTwiddle(field, 'num_decimals'),
        currency: this.getColumnTwiddle(field, 'currency') || this.twiddles.get('currency')
      });
    };

    RedesignTableChart.prototype.shouldShowTotalRow = function() {
      var column, j, len, ref;
      if (this.isCohort()) {
        return false;
      }
      ref = this.columns;
      for (j = 0, len = ref.length; j < len; j++) {
        column = ref[j];
        if (this.twiddles.columnTableTotalChecked(column)) {
          return true;
        }
      }
      return !!this.twiddles.get('table_total_column');
    };

    RedesignTableChart.prototype.shouldTotalColumn = function(column) {
      return this.twiddles.columnTableTotalChecked(column);
    };

    RedesignTableChart.prototype.formatTotalColumnValue = function(column, val) {
      var formattedValue;
      if (this.twiddles.columnHasNumericFormatting(column)) {
        formattedValue = this.formatValue(val, column);
        return formattedValue;
      } else {
        return parseFloat(val.toFixed(5)).commaDelimit();
      }
    };

    RedesignTableChart.prototype.getTotalRow = function() {
      var base, column, field, j, len, parsedVal, rawRow, ref, totalRow, val;
      if (this.isCohort()) {
        return null;
      }
      totalRow = {};
      ref = this.sortedRawRows;
      for (j = 0, len = ref.length; j < len; j++) {
        rawRow = ref[j];
        for (field in rawRow) {
          val = rawRow[field];
          if (!this.shouldTotalColumn(field)) {
            continue;
          }
          parsedVal = App.ChartUtils.numberFromNumberishString(val);
          if (typeof parsedVal !== "number") {
            continue;
          }
          if (totalRow[field] == null) {
            totalRow[field] = {};
          }
          if ((base = totalRow[field]).value == null) {
            base.value = 0;
          }
          totalRow[field].value += parsedVal;
          totalRow[field].cssClass = "total";
        }
      }
      for (column in totalRow) {
        val = totalRow[column];
        val.value = this.formatTotalColumnValue(column, val.value);
      }
      return totalRow;
    };

    RedesignTableChart.prototype.valueBuckets = function() {
      var all_vals, f, j, len, metafields, range, ref, results, row, v, valueRanges;
      if (this.valueBucketsCache) {
        return this.valueBucketsCache;
      }
      if (!this.isCohort()) {
        return [];
      }
      results = [];
      all_vals = [];
      valueRanges = {};
      metafields = [this.constructor.LEVEL, this.constructor.COLLAPSED_STATE, this.constructor.CHILDREN_SIZE, this.constructor.PARENT_ID];
      ref = this.sortedRawRows;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        for (f in row) {
          v = row[f];
          if (indexOf.call(metafields, f) >= 0 || ((this.unformattedColumns != null) && this.unformattedColumns.indexOf(f) !== -1)) {
            continue;
          }
          if (f !== 'users' && f !== 'date' && App.ChartUtils.isNumberish(v)) {
            all_vals.push(App.ChartUtils.numberFromNumberishString(v));
          }
        }
      }
      all_vals.sort(function(a, b) {
        return a - b;
      });
      results.push(App.Utils.valueOfNthPercentile(all_vals, 33));
      results.push(App.Utils.valueOfNthPercentile(all_vals, 66));
      valueRanges.minValue = all_vals[0], valueRanges.maxValue = all_vals[all_vals.length - 1];
      if (valueRanges.maxValue < 0) {
        valueRanges.zeroPoint = 1;
      } else if (valueRanges.minValue > 0) {
        valueRanges.zeroPoint = 0;
      } else {
        range = valueRanges.maxValue - valueRanges.minValue;
        if (range !== 0) {
          valueRanges.zeroPoint = Math.abs(valueRanges.minValue) / range;
        }
      }
      if (valueRanges.zeroPoint == null) {
        valueRanges.zeroPoint = 0;
      }
      this.valueRangesCache = valueRanges;
      this.valueBucketsCache = results;
      return this.valueBucketsCache;
    };

    RedesignTableChart.prototype.addUnits = function(number) {
      if (this.fillAlign()) {
        return number + '%';
      } else {
        return number + 'px';
      }
    };

    RedesignTableChart.prototype.getColumnWidthsByLevel = function(indexColWidth, nestedColumns, rows) {
      var childWidths, j, l, len, len1, level, node, widthInfo, widths;
      widthInfo = [];
      this.leafColumnIndex = 0;
      this.columnWidthCache = {};
      if (nestedColumns == null) {
        return widthInfo;
      }
      for (j = 0, len = nestedColumns.length; j < len; j++) {
        node = nestedColumns[j];
        childWidths = this.getColumnWidthsByLevelRecursively(node.name, node.children, rows, node.leaf);
        for (level = l = 0, len1 = childWidths.length; l < len1; level = ++l) {
          widths = childWidths[level];
          if (widthInfo.length === level) {
            widthInfo.push([]);
          }
          widthInfo[level] = widthInfo[level].concat(widths.map(function(info) {
            return {
              name: info.name,
              width: info.width
            };
          }));
        }
      }
      return widthInfo;
    };

    RedesignTableChart.prototype.getColumnWidthsByLevelRecursively = function(colName, mapping, rows, leaf) {
      var calculatedWidth, childWidth, childWidthInfo, childWidths, delta, difference, info, j, l, len, len1, len2, length, level, m, maxWidth, name, node, showTotalColumn, widths;
      if (leaf) {
        showTotalColumn = this.pointCols().length === 0 && this.valueCols().length > 0;
        if ((colName == null) && (mapping == null) && !showTotalColumn) {
          return [];
        }
        calculatedWidth = this.calcColumnWidth(colName, rows, mapping);
        calculatedWidth += this.constructor.SORT_ICON_GUTTER;
        this.leafColumnIndex += 1;
        name = this.generateHeader(colName);
        if (colName == null) {
          name = '';
        }
        return [
          [
            {
              name: name,
              width: calculatedWidth
            }
          ]
        ];
      }
      if (!((mapping != null) && (mapping[0] != null))) {
        return [];
      }
      maxWidth = this.columnWidthFromName(colName) + this.constructor.PADDING_OFFSET;
      childWidthInfo = [];
      for (j = 0, len = mapping.length; j < len; j++) {
        node = mapping[j];
        childWidths = this.getColumnWidthsByLevelRecursively(node.name, node.children, rows, node.leaf);
        for (level = l = 0, len1 = childWidths.length; l < len1; level = ++l) {
          widths = childWidths[level];
          if (childWidthInfo.length === level) {
            childWidthInfo.push([]);
          }
          childWidthInfo[level] = childWidthInfo[level].concat(widths);
        }
      }
      if (childWidthInfo.length === 0) {
        return childWidthInfo;
      }
      childWidth = childWidthInfo[0].map(function(info) {
        return info.width;
      }).sum();
      if (maxWidth > childWidth) {
        difference = maxWidth - childWidth;
        for (level = m = 0, len2 = childWidthInfo.length; m < len2; level = ++m) {
          widths = childWidthInfo[level];
          length = widths.length;
          delta = difference / length;
          childWidthInfo[level] = (function() {
            var len3, n, results1;
            results1 = [];
            for (n = 0, len3 = widths.length; n < len3; n++) {
              info = widths[n];
              results1.push({
                name: info.name,
                width: info.width + delta
              });
            }
            return results1;
          })();
        }
      }
      if (childWidth > maxWidth) {
        maxWidth = childWidth;
      }
      childWidthInfo.unshift([
        {
          name: this.generateHeader(colName),
          width: maxWidth
        }
      ]);
      return childWidthInfo;
    };

    RedesignTableChart.prototype.setColumnWidths = function() {
      var columnWidths, headerIndex, i, info, j, l, leftOffset, len, len1, m, rowIndex, rows, startTime, width, widths;
      startTime = App.Utils.timeNowInSecs();
      rows = [];
      if (this.sortedRawRows != null) {
        for (i = j = 0; j <= 30; i = ++j) {
          if (i >= this.sortedRawRows.length) {
            break;
          }
          rows.push(this.processRow(i));
        }
      }
      columnWidths = this.getColumnWidthsByLevel(this.indexColWidth(), this.nestedColumns, rows);
      if (columnWidths.length > 0) {
        this.rawColumnWidths = columnWidths[columnWidths.length - 1].map(function(info) {
          return info.width;
        });
      } else {
        this.rawColumnWidths = [];
      }
      this.totalColumnWidth = this.rawColumnWidths.sum() + this.indexColWidth();
      this.leftOffsets = [];
      leftOffset = this.indexColWidth();
      if (this.fillAlign()) {
        leftOffset *= 100 / this.totalColumnWidth;
      }
      this.leftOffsets.push(this.addUnits(leftOffset));
      this.formattedColumnWidths = [];
      for (rowIndex = l = 0, len = columnWidths.length; l < len; rowIndex = ++l) {
        widths = columnWidths[rowIndex];
        if (App.Utils.timeNowInSecs() - this.constructor.SETDATA_TIMEOUT_SECS > startTime) {
          throw new Error(App.Chartographer.ERR_TIMEOUT);
        }
        this.formattedColumnWidths.push([]);
        leftOffset = this.indexColWidth();
        if (this.fillAlign()) {
          leftOffset *= 100 / this.totalColumnWidth;
        }
        for (headerIndex = m = 0, len1 = widths.length; m < len1; headerIndex = ++m) {
          info = widths[headerIndex];
          width = info.width;
          if (this.fillAlign()) {
            width *= 100 / this.totalColumnWidth;
          }
          leftOffset += width;
          if (this.fillAlign() && headerIndex === widths.length - 1) {
            width += 100 - leftOffset;
          }
          if (rowIndex === columnWidths.length - 1) {
            this.leftOffsets.push(this.addUnits(leftOffset));
          }
          this.formattedColumnWidths[rowIndex].push({
            name: info.name,
            width: this.addUnits(width)
          });
        }
      }
      if (this.formattedColumnWidths.length > 0) {
        return this.columnWidths = this.formattedColumnWidths[this.formattedColumnWidths.length - 1].map(function(info) {
          return info.width;
        });
      } else {
        return this.columnWidths = [];
      }
    };

    RedesignTableChart.prototype.columnWidthFromName = function(colName) {
      var header_text, header_width;
      header_text = this.generateHeader(colName).toUpperCase();
      if (this.columnWidthCache[header_text] == null) {
        header_width = App.Utils.canvasWidthForText(header_text);
        this.columnWidthCache[header_text] = header_width;
      }
      return this.columnWidthCache[header_text];
    };

    RedesignTableChart.prototype.calcColumnWidth = function(colName, rows, mapping) {
      var cell, i, j, level, maxLevel, maxWidth, row, str, userWidth, value, width;
      userWidth = this.getColumnTwiddle(colName, 'width') * 1;
      if (!(isNaN(userWidth) || userWidth <= 0)) {
        return userWidth;
      }
      maxWidth = this.columnWidthFromName(colName);
      maxLevel = this.pointCols().length - 1;
      for (i = j = 0; j <= 29; i = ++j) {
        if (i > rows.length - 1) {
          break;
        }
        row = rows[i];
        if ((row == null) || !(row[mapping] != null)) {
          continue;
        }
        cell = row[mapping] || row[mapping.toLowerCase()];
        value = cell["raw_value"];
        if ($.isNumeric(value)) {
          value = cell["value"];
        }
        if (cell["linkName"]) {
          value = cell["linkName"];
        }
        str = (value + "").substr(0, this.constructor.GRID_MAX_DISPLAY_CHARS);
        width = Math.ceil(App.Utils.canvasWidthForText(str)) + 1;
        if (colName === this.constructor.MULTICOHORT_XCOL_NAME) {
          level = row[this.constructor.LEVEL];
          width += level * this.constructor.LEVEL_INDENT_INCREMENT;
          if (maxLevel > 0 && level < maxLevel) {
            width += this.constructor.NEST_ARROW_WIDTH;
          }
        }
        if (width > maxWidth) {
          maxWidth = width;
        }
      }
      return maxWidth + this.constructor.PADDING_OFFSET;
    };

    RedesignTableChart.prototype.onWidgetSettingsUpdated = function(widget, twiddleName, value) {
      if (twiddleName === 'image_height') {
        return this.updateRowsHeight();
      }
    };

    RedesignTableChart.prototype.cellMouseEnter = function(e) {
      clearTimeout(this.hoverTimeout);
      return this.hoverTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.showHoverTooltip($(e.target));
        };
      })(this)), this.constructor.HOVER_TOOLTIP_TIMEOUT);
    };

    RedesignTableChart.prototype.cellMouseLeave = function() {
      var ref;
      clearTimeout(this.hoverTimeout);
      return (ref = this.hoverTooltip) != null ? ref.closeAndRelease() : void 0;
    };

    RedesignTableChart.prototype.showHoverTooltip = function(target) {
      var cellWidth, fullValueWidth, height, left, panelTop, pointerPosition, ref, ref1, targetOffset, targetWidth, tooltipValue, top, validParamSet, width;
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      targetOffset = target.offset();
      tooltipValue = this.tooltipValueForCell(target);
      if (!tooltipValue) {
        return;
      }
      fullValueWidth = App.Utils.canvasWidthForText(tooltipValue);
      targetWidth = target.width();
      if (target.hasClass('level1') || target.hasClass('level2')) {
        fullValueWidth += this.constructor.NEST_ARROW_WIDTH;
        targetWidth = target.outerWidth();
      }
      if (fullValueWidth <= targetWidth) {
        return;
      }
      cellWidth = target.outerWidth();
      pointerPosition = App.RedesignTooltipPanel.CENTER_POINTER;
      left = targetOffset.left + cellWidth / 2;
      top = targetOffset.top + 15;
      this.hoverTooltip = this.makeTooltip(target, App.RedesignTooltipPanel.BOTTOM, pointerPosition, left, top);
      height = this.hoverTooltip.panel.outerHeight();
      width = this.hoverTooltip.panel.outerWidth();
      panelTop = top - this.hoverTooltip.panel.outerHeight();
      if (App.IconTooltipHelper.validDashboardPosition(left - width * pointerPosition, panelTop, width, height)) {
        return;
      }
      validParamSet = App.IconTooltipHelper.findValidPosition(target, this.hoverTooltip.panel, App.IconTooltipHelper.POSITION_PARAMETERS_TABLE_CHART);
      if (validParamSet == null) {
        return;
      }
      if ((ref1 = this.hoverTooltip) != null) {
        ref1.closeAndRelease();
      }
      return this.hoverTooltip = this.makeTooltip(target, validParamSet.direction, validParamSet.scale, target.outerWidth() * validParamSet.leftScale + targetOffset.left, target.outerHeight() * validParamSet.topScale + targetOffset.top - 10);
    };

    RedesignTableChart.prototype.tooltipValueForCell = function(targetCell) {
      var columnId, rowId, val;
      if (!targetCell) {
        return "";
      }
      val = null;
      try {
        rowId = parseInt(targetCell.attr('row'));
        columnId = parseInt(targetCell.attr('column'));
        val = this.processedRows[rowId][this.columns[columnId]].value;
      } catch (error1) {
        val = null;
      }
      if (val == null) {
        val = targetCell.text().trim();
      }
      if (val.length > this.GRID_MAX_DISPLAY_CHARS_TOOLTIP) {
        val = val.substr(0, this.GRID_MAX_DISPLAY_CHARS_TOOLTIP) + '...';
      }
      return val;
    };

    RedesignTableChart.prototype.makeTooltip = function(target, tooltipDirection, pointerPosition, left, top) {
      return App.RedesignTooltipPanel.addPanel({
        side: tooltipDirection,
        width: (target.outerWidth() + 30) + "px",
        pointerOffsetPercent: pointerPosition,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        description: this.tooltipValueForCell(target),
        contentEl: null,
        useSmallPointer: true,
        extraClass: 'light-theme'
      }).pointAt(tooltipDirection, target, pointerPosition, left, top);
    };

    RedesignTableChart.prototype.nestedRowClicked = function(e) {
      var i, newCollapsedState, ninjaCell, rawRowIndex, ref, ref1, ref2, row, rowIndex, target, totalRowHeight;
      target = $(e.target);
      ninjaCell = target.closest('.ninja-cell');
      rowIndex = parseInt(ninjaCell.attr('row'));
      rawRowIndex = this.toRawRowIndex(rowIndex);
      if (rawRowIndex === -1) {
        return;
      }
      newCollapsedState = !this.sortedRawRows[rawRowIndex][this.constructor.COLLAPSED_STATE];
      target.find('.nest-arrow:first').toggleClass('collapsed', newCollapsedState);
      this.sortedRawRows[rawRowIndex][this.constructor.COLLAPSED_STATE] = newCollapsedState;
      if ((ref = this.processedRows) != null) {
        if ((ref1 = ref[rawRowIndex]) != null) {
          ref1[this.constructor.COLLAPSED_STATE] = newCollapsedState;
        }
      }
      ref2 = this.rowsOnPage;
      for (i in ref2) {
        row = ref2[i];
        if (parseInt(i) > rowIndex) {
          row.parentNode.removeChild(row);
          delete this.rowsOnPage[i];
          if (this.renderedEls[i]) {
            delete this.renderedEls[i];
          }
        }
      }
      this.handleViewportChange();
      totalRowHeight = this.rowHeight * Object.keys(this.rowsOnPage).length;
      this.rows.height(totalRowHeight);
      return this.tableBorder.height(totalRowHeight - 1);
    };

    RedesignTableChart.prototype.toRawRowIndex = function(rowIndex) {
      var pointer;
      pointer = 0;
      while (pointer < this.sortedRawRows.length) {
        if (rowIndex === 0) {
          return pointer;
        }
        if (this.sortedRawRows[pointer][this.constructor.COLLAPSED_STATE]) {
          pointer += this.sortedRawRows[pointer][this.constructor.CHILDREN_SIZE];
        }
        pointer += 1;
        rowIndex -= 1;
      }
      return -1;
    };

    RedesignTableChart.prototype.isPivotTable = function() {
      return this.twiddles.get('use_pivot_settings') && this.twiddles.get('chart_type') !== 'table';
    };

    RedesignTableChart.prototype.mouseEnterTable = function() {
      if (App.RedesignDashboardsController.timeSinceLastDashboardScroll() > App.RedesignChartContainerController.TIME_SINCE_LAST_DASHBOARD_SCROLL) {
        return this.ninjaGrid.removeClass('no-scrolling-initially');
      } else {
        return this.scrollCheckTimeout = setTimeout(this.mouseEnterTable, App.RedesignChartContainerController.SCROLL_CHECK_TIMEOUT);
      }
    };

    RedesignTableChart.prototype.mouseLeaveTable = function() {
      clearTimeout(this.scrollCheckTimeout);
      return this.ninjaGrid.addClass('no-scrolling-initially');
    };

    RedesignTableChart.prototype.getChartHandler = function(item, contentEl) {
      if (this.tableChartHandler == null) {
        this.tableChartHandler = new App.TableChartHandler({
          item: item,
          contentEl: contentEl,
          tableChart: this
        });
      }
      return this.tableChartHandler;
    };

    return RedesignTableChart;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignTooltipPanel = (function(superClass) {
    extend(RedesignTooltipPanel, superClass);

    function RedesignTooltipPanel() {
      this.release = bind(this.release, this);
      this.mouseLeft = bind(this.mouseLeft, this);
      this.mouseEntered = bind(this.mouseEntered, this);
      this.closeAndRelease = bind(this.closeAndRelease, this);
      this.fixPosition = bind(this.fixPosition, this);
      return RedesignTooltipPanel.__super__.constructor.apply(this, arguments);
    }

    RedesignTooltipPanel.prototype.className = 'tooltip-panel';

    RedesignTooltipPanel.prototype.elements = {
      '.panel': 'panel',
      '.panel .description': 'descriptionEl',
      '.panel .escapedDescription': 'escapedDescriptionEl',
      '.panel .panel-content': 'panelContent',
      '.panel .left.pointer': 'panelLeftPointer',
      '.panel .right.pointer': 'panelRightPointer',
      '.panel .top.pointer': 'panelTopPointer',
      '.panel .bottom.pointer': 'panelBottomPointer',
      '.panel .left.pointer-border': 'panelLeftPointerBorder',
      '.panel .right.pointer-border': 'panelRightPointerBorder',
      '.panel .top.pointer-border': 'panelTopPointerBorder',
      '.panel .bottom.pointer-border': 'panelBottomPointerBorder',
      '.panel .title': 'panelTitle'
    };

    RedesignTooltipPanel.prototype.events = {
      'mouseenter': 'mouseEntered',
      'mouseleave': 'mouseLeft'
    };

    RedesignTooltipPanel.LARGE_POINTER_SIZE = 20;

    RedesignTooltipPanel.SMALL_POINTER_SIZE = 4;

    RedesignTooltipPanel.POINTER_BORDER_SIZE = 1;

    RedesignTooltipPanel.PADDING_FOR_SHARED_DASHBOARD = 5;

    RedesignTooltipPanel.DEFAULT_POINTER_OFFSET = 0.17;

    RedesignTooltipPanel.DEFAULT_POINT_LEFT_SCALE = 0.33;

    RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE = 0.2;

    RedesignTooltipPanel.TIP_PADDING = 5;

    RedesignTooltipPanel.TOP = 'top';

    RedesignTooltipPanel.BOTTOM = 'bottom';

    RedesignTooltipPanel.LEFT = 'left';

    RedesignTooltipPanel.RIGHT = 'right';

    RedesignTooltipPanel.BLANK_TITLE = '';

    RedesignTooltipPanel.CENTER_POINTER = 0.5;

    RedesignTooltipPanel.addPanelForSchemaViewer = function(target, options) {
      var panel;
      panel = new App.RedesignTooltipPanel(_.merge(options, {
        escapedDescription: target.text(),
        extraClass: 'light-theme name',
        hideOnLeave: true,
        pointerOffsetPercent: 0.5,
        showOnce: false,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        useWidthAsMin: true
      }));
      $('.dashboards-container').append(panel.el);
      panel.addPanel();
      return panel;
    };

    RedesignTooltipPanel.addDialogPanel = function(options) {
      var panel;
      panel = this.newPanel(_.merge(options, {
        side: App.RedesignTooltipPanel.TOP,
        useSmallPointer: true
      }));
      if (AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON) {
        $('.editor-panel .bottom-box').append(panel.el);
      } else {
        $('.dashboards-container').append(panel.el);
      }
      panel.addDialogPanel();
      return panel;
    };

    RedesignTooltipPanel.addPanel = function(options) {
      var panel;
      panel = this.newPanel(options);
      if (panel.parentSelector != null) {
        $(panel.parentSelector).append(panel.el);
      } else if (AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON) {
        $('.editor-panel').append(panel.el);
      } else {
        $('.dashboards-container').append(panel.el);
      }
      panel.addPanel();
      return panel;
    };

    RedesignTooltipPanel.newPanel = function(options) {
      return new App.RedesignTooltipPanel(_.defaults(options, {
        hideOnLeave: true
      }));
    };

    RedesignTooltipPanel.prototype.fixPosition = function() {
      return this.panel.addClass('fixed');
    };

    RedesignTooltipPanel.prototype.closeAndRelease = function() {
      this.panel.removeClass('showing');
      return this.closeTimeout = setTimeout(this.release, App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RedesignTooltipPanel.prototype.mouseEntered = function(e) {
      if (this.showOnce) {
        return;
      }
      clearTimeout(this.mouseLeftTimeout);
      clearTimeout(this.closeTimeout);
      this.trigger('show');
      return this.panel.addClass('showing');
    };

    RedesignTooltipPanel.prototype.mouseLeft = function() {
      if (!this.hideOnLeave) {
        return;
      }
      this.mouseLeftTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.trigger('mouse-left');
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
      return this.closeAndRelease();
    };

    RedesignTooltipPanel.prototype.release = function() {
      this.trigger('hide');
      return RedesignTooltipPanel.__super__.release.apply(this, arguments);
    };

    RedesignTooltipPanel.prototype.addDialogPanel = function() {
      this.html(this.view('redesign/tooltip/dialog_panel')({
        title: this.title,
        description: this.description
      }));
      return this.renderPanel();
    };

    RedesignTooltipPanel.prototype.addPanel = function() {
      this.renderTooltipPanel();
      if (_.isEmpty(this.title)) {
        this.panelTitle.hide();
      }
      if (this.description == null) {
        this.descriptionEl.hide();
      }
      if (this.escapedDescription == null) {
        this.escapedDescriptionEl.hide();
      }
      return this.renderPanel();
    };

    RedesignTooltipPanel.prototype.renderTooltipPanel = function() {
      return this.html(this.view('redesign/tooltip/panel')({
        title: this.title,
        description: this.description,
        escapedDescription: this.escapedDescription
      }));
    };

    RedesignTooltipPanel.prototype.renderPanel = function() {
      var horizontalPointerBorderOffset, horizontalPointerOffset, positionHorizontalPointer, positionVerticalPointer, verticalPointerBorderOffset, verticalPointerOffset;
      if (this.extraClass != null) {
        this.el.addClass(this.extraClass);
      }
      this.panel.toggleClass('small-pointer', this.useSmallPointer);
      if (this.contentEl != null) {
        this.updateContent(this.contentEl);
      }
      if (this.useWidthAsMin) {
        this.panel.css('min-width', this.width);
      } else {
        this.panel.width(this.width);
      }
      horizontalPointerOffset = this.panel.outerWidth() * this.pointerOffsetPercent - this.pointerSize();
      horizontalPointerBorderOffset = horizontalPointerOffset - RedesignTooltipPanel.POINTER_BORDER_SIZE;
      verticalPointerOffset = this.panel.outerHeight() * this.pointerOffsetPercent - this.pointerSize();
      verticalPointerBorderOffset = verticalPointerOffset - RedesignTooltipPanel.POINTER_BORDER_SIZE;
      positionVerticalPointer = function(selector, borderSelector) {
        selector.css({
          top: verticalPointerOffset
        });
        borderSelector.css({
          top: verticalPointerBorderOffset
        });
        selector.show();
        return borderSelector.show();
      };
      positionHorizontalPointer = function(selector, borderSelector) {
        selector.css({
          left: horizontalPointerOffset
        });
        borderSelector.css({
          left: horizontalPointerBorderOffset
        });
        selector.show();
        return borderSelector.show();
      };
      if (this.side === RedesignTooltipPanel.LEFT) {
        return positionVerticalPointer(this.panelLeftPointer, this.panelLeftPointerBorder);
      } else if (this.side === RedesignTooltipPanel.RIGHT) {
        return positionVerticalPointer(this.panelRightPointer, this.panelRightPointerBorder);
      } else if (this.side === RedesignTooltipPanel.TOP) {
        return positionHorizontalPointer(this.panelTopPointer, this.panelTopPointerBorder);
      } else if (this.side === RedesignTooltipPanel.BOTTOM) {
        return positionHorizontalPointer(this.panelBottomPointer, this.panelBottomPointerBorder);
      }
    };

    RedesignTooltipPanel.prototype.updateContent = function(contentEl) {
      if (typeof contentEl === 'string') {
        contentEl = App.Utils.sanitizeHtml(contentEl);
      }
      this.panelContent.html('');
      return this.panelContent.append(contentEl);
    };

    RedesignTooltipPanel.prototype.updateDialogContent = function(contentEl, title, extraClass, subtractClass, hideOnLeave, showOnce) {
      if (hideOnLeave == null) {
        hideOnLeave = true;
      }
      if (showOnce == null) {
        showOnce = false;
      }
      this.updateContent(contentEl);
      this.panelTitle.text(title);
      this.el.addClass(extraClass);
      this.el.removeClass(subtractClass);
      this.hideOnLeave = hideOnLeave;
      return this.showOnce = showOnce;
    };

    RedesignTooltipPanel.prototype.pointAtEl = function(pointAtSide, targetEl, offsetPercent, targetWidthIdentPercent, targetHeightIndentPercent) {
      var left, offset, top;
      offset = targetEl.offset();
      left = offset.left + (targetEl.outerWidth() * targetWidthIdentPercent);
      top = offset.top + (targetEl.outerHeight() * targetHeightIndentPercent);
      return this.pointAt(pointAtSide, targetEl, offsetPercent, left, top);
    };

    RedesignTooltipPanel.prototype.fixPositionAt = function(targetLeft, targetTop) {
      var pointerOffsetPercent;
      pointerOffsetPercent = 0.5;
      this.panel.offset({
        left: targetLeft - this.panel.outerWidth() * pointerOffsetPercent,
        top: targetTop + this.pointerSize()
      });
      this.panel.addClass('showing');
      return this;
    };

    RedesignTooltipPanel.prototype.pointAt = function(pointAtSide, targetEl, pointAtPointerOffsetPercent, targetLeft, targetTop) {
      this.panel.addClass('showing');
      if (pointAtSide === RedesignTooltipPanel.LEFT) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() * pointAtPointerOffsetPercent + this.pointerSize() / 2,
          left: targetLeft + targetEl.outerWidth() + this.pointerSize() + RedesignTooltipPanel.TIP_PADDING
        });
      } else if (pointAtSide === RedesignTooltipPanel.RIGHT) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() * pointAtPointerOffsetPercent + this.pointerSize() / 2,
          left: targetLeft - this.panel.outerWidth() - this.pointerSize() - RedesignTooltipPanel.TIP_PADDING
        });
      } else if (pointAtSide === RedesignTooltipPanel.BOTTOM) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() - this.pointerSize() - RedesignTooltipPanel.TIP_PADDING,
          left: targetLeft - this.panel.outerWidth() * pointAtPointerOffsetPercent
        });
      } else if (pointAtSide === RedesignTooltipPanel.TOP) {
        this.panel.offset({
          top: targetTop + targetEl.outerHeight() + this.pointerSize() + RedesignTooltipPanel.TIP_PADDING,
          left: targetLeft - this.panel.outerWidth() * pointAtPointerOffsetPercent
        });
      }
      return this;
    };

    RedesignTooltipPanel.prototype.pointerSize = function() {
      if (this.useSmallPointer) {
        return RedesignTooltipPanel.SMALL_POINTER_SIZE;
      } else {
        return RedesignTooltipPanel.LARGE_POINTER_SIZE;
      }
    };

    return RedesignTooltipPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignWidgetUndoController = (function(superClass) {
    var WidgetState;

    extend(RedesignWidgetUndoController, superClass);

    RedesignWidgetUndoController.prototype.className = 'toast-container faded-out';

    RedesignWidgetUndoController.prototype.elements = {
      '.toast-yellow': 'toastEl'
    };

    RedesignWidgetUndoController.prototype.events = {
      'click .icon-close-toast': 'closeToast',
      'click .toast-undo-link': 'clickedUndo',
      'mouseenter .toast-yellow': 'clearTimeout',
      'mouseleave .toast-yellow': 'startTimeout'
    };

    function RedesignWidgetUndoController() {
      this.closeToast = bind(this.closeToast, this);
      this.startTimeout = bind(this.startTimeout, this);
      this.clearTimeout = bind(this.clearTimeout, this);
      RedesignWidgetUndoController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboard', 'action');
      this.widgetStates = [];
      if (App.RedesignDashboardSizer.inEditron(this.el) || !AppRedesign.isRedesignMode()) {
        return;
      }
      this.removeOldUndoMessages();
      this.html(this.view('dashboards/widget_undo')({
        action: this.action
      }));
      this.widgets = this.dashboard.widgets();
      this.widgetStates = _.map(this.widgets, function(widget) {
        return new WidgetState(widget);
      });
      App.Site.bind('close-toast', this.closeToast);
    }

    RedesignWidgetUndoController.prototype.maybeRender = function(widget) {
      if (this.widgetUnchanged(widget)) {
        return;
      }
      this.dashboardContainerEl().append(this.el);
      setTimeout(((function(_this) {
        return function() {
          return _this.el.removeClass('faded-out');
        };
      })(this)), 0);
      return this.startTimeout();
    };

    RedesignWidgetUndoController.prototype.widgetUnchanged = function(widget) {
      var matchedWidgetState;
      matchedWidgetState = _.find(this.widgetStates, function(widgetState) {
        return widgetState.widget.id === widget.id;
      });
      if (matchedWidgetState == null) {
        return false;
      }
      return matchedWidgetState.initialColumn === widget.getColumn() && matchedWidgetState.initialHeight === widget.getHeight() && matchedWidgetState.initialRow === widget.getRow() && matchedWidgetState.initialWidth === widget.getWidth();
    };

    RedesignWidgetUndoController.prototype.clearTimeout = function() {
      if (this.timerRunningCloseToast) {
        return clearTimeout(this.timerRunningCloseToast);
      }
    };

    RedesignWidgetUndoController.prototype.startTimeout = function() {
      if (this.timerRunningCloseToast) {
        clearTimeout(this.timerRunningCloseToast);
      }
      return this.timerRunningCloseToast = setTimeout(this.closeToast, AppRedesign.TOAST_NOTIFICATION_TIMEOUT);
    };

    RedesignWidgetUndoController.prototype.removeOldUndoMessages = function() {
      return this.dashboardContainerEl().find('.toast-container').remove();
    };

    RedesignWidgetUndoController.prototype.dashboardContainerEl = function() {
      return $('.dashboard-container');
    };

    RedesignWidgetUndoController.prototype.clickedUndo = function() {
      _.each(this.widgetStates, function(widgetState) {
        return widgetState.undo();
      });
      this.dashboard.saveWidgetStubs(App.Widget.stubsForWidgets(this.changedWidgets()));
      return this.release();
    };

    RedesignWidgetUndoController.prototype.changedWidgets = function() {
      return _.filter(this.widgets, 'positionOrSizeChanged');
    };

    RedesignWidgetUndoController.prototype.closeToast = function() {
      this.el.addClass('faded-out');
      return setTimeout(((function(_this) {
        return function() {
          return _this.el.remove();
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    RedesignWidgetUndoController.prototype.release = function() {
      RedesignWidgetUndoController.__super__.release.apply(this, arguments);
      return this.closeToast();
    };

    WidgetState = (function() {
      function WidgetState(widget1) {
        this.widget = widget1;
        this.initialColumn = this.widget.getColumn();
        this.initialHeight = this.widget.getHeight();
        this.initialRow = this.widget.getRow();
        this.initialWidth = this.widget.getWidth();
      }

      WidgetState.prototype.undo = function() {
        if (this.positionChanged()) {
          this.resetPosition();
        }
        if (this.sizeChanged()) {
          return this.resetSize();
        }
      };

      WidgetState.prototype.resetPosition = function() {
        return this.widget.moveTo(this.initialColumn, this.initialRow, false, false);
      };

      WidgetState.prototype.positionChanged = function() {
        return this.initialColumn !== this.widget.getColumn() || this.initialRow !== this.widget.getRow();
      };

      WidgetState.prototype.resetSize = function() {
        return this.widget.sizeTo(this.initialWidth, this.initialHeight, false, false);
      };

      WidgetState.prototype.sizeChanged = function() {
        return this.initialWidth !== this.widget.getWidth() || this.initialHeight !== this.widget.getHeight();
      };

      return WidgetState;

    })();

    return RedesignWidgetUndoController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignWidgetsController = (function(superClass) {
    extend(RedesignWidgetsController, superClass);

    RedesignWidgetsController.prototype.className = 'widget-container';

    RedesignWidgetsController.prototype.downloadImageButton = function() {
      return this.$('.widget-menu .menu-item .image.button');
    };

    RedesignWidgetsController.prototype.downloadImageText = function() {
      return this.$(".widget-menu .menu-item[name='image'] .text");
    };

    function RedesignWidgetsController() {
      this.constructImageData = bind(this.constructImageData, this);
      this.exportImageClick = bind(this.exportImageClick, this);
      this.refreshData = bind(this.refreshData, this);
      this.exportCSV = bind(this.exportCSV, this);
      this.showSlackModal = bind(this.showSlackModal, this);
      this.shareLink = bind(this.shareLink, this);
      this.createWidgetLink = bind(this.createWidgetLink, this);
      this.editWidgetAsCopy = bind(this.editWidgetAsCopy, this);
      this.editWidget = bind(this.editWidget, this);
      this.debugWidgetPrint = bind(this.debugWidgetPrint, this);
      this.addPivot = bind(this.addPivot, this);
      this.toggleSearch = bind(this.toggleSearch, this);
      this.exportImage = bind(this.exportImage, this);
      this.controlPressed = bind(this.controlPressed, this);
      this.changedUwv = bind(this.changedUwv, this);
      this.changedTwiddle = bind(this.changedTwiddle, this);
      this.update = bind(this.update, this);
      this.formulaSourceUpdated = bind(this.formulaSourceUpdated, this);
      this.annotationsChanged = bind(this.annotationsChanged, this);
      this.updateEditUIControls = bind(this.updateEditUIControls, this);
      this.render = bind(this.render, this);
      this.returnToUnrenderedState = bind(this.returnToUnrenderedState, this);
      this.onChartRendered = bind(this.onChartRendered, this);
      this.renderIfInViewport = bind(this.renderIfInViewport, this);
      this.postRefreshData = bind(this.postRefreshData, this);
      RedesignWidgetsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.el.addClass("widget-" + this.item.id);
      this.chartContainer = new App.RedesignChartContainerController({
        el: this.el,
        item: this.item,
        resizableFunc: this.resizableFunc,
        renderPriorityFunc: this.renderPriorityFunc
      });
      this.bubbles(this.chartContainer, 'size-updated title-needs-draggability');
      this.chartContainer.bind('edit-widget', this.editWidget);
      this.chartContainer.bind("control-pressed", this.controlPressed);
      this.chartContainer.bind("chart-rendered", this.onChartRendered);
      this.chartContainer.bind("export-image-click", this.exportImageClick);
      this.item.bind('widget-post-refresh-data', this.postRefreshData);
      this.bindEvents();
      this.renderedChart = false;
      if ((this.item.selectedFormulaSource() == null) || this.item.selectedFormulaSource().percent_complete !== 1) {
        this.item.fetchSource();
      }
      this.oldState = this.item.state();
    }

    RedesignWidgetsController.prototype.release = function() {
      var ref;
      if (this.released) {
        return;
      }
      this.item.unbind("update", this.update);
      this.item.unbind("destroy", this.release);
      this.item.unbind("changed-twiddle", this.changedTwiddle);
      this.item.unbind("changed-uwv", this.changedUwv);
      this.item.unbind('widget-post-refresh-data', this.postRefreshData);
      App.Site.unbind('annotation-change', this.annotationsChanged);
      App.Site.unbind('group-change', this.updateEditUIControls);
      App.SourceFetcher.unbind('source-updated', this.formulaSourceUpdated);
      if ((ref = this.chartContainer) != null) {
        ref.release();
      }
      this.released = true;
      return RedesignWidgetsController.__super__.release.apply(this, arguments);
    };

    RedesignWidgetsController.prototype.canBeRendered = function() {
      if (this.canBeRenderedFunc != null) {
        return this.canBeRenderedFunc();
      } else {
        return true;
      }
    };

    RedesignWidgetsController.prototype.postRefreshData = function(widget, refreshAll, udv) {
      if ((this.canBeRenderedFunc != null) && this.canBeRenderedFunc()) {
        return widget.postRefreshData(refreshAll, udv);
      } else {
        return Spine.Ajax.queue((function(_this) {
          return function() {
            return widget.postRefreshData(refreshAll, udv);
          };
        })(this));
      }
    };

    RedesignWidgetsController.prototype.bindEvents = function() {
      this.eventsBound = true;
      this.item.bind("update", this.update);
      this.item.bind("destroy", this.release);
      this.item.bind("changed-twiddle", this.changedTwiddle);
      this.item.bind("changed-uwv", this.changedUwv);
      App.SourceFetcher.bind('source-updated', this.formulaSourceUpdated);
      App.Site.bind('annotation-change', this.annotationsChanged);
      return App.Site.bind('group-change', this.updateEditUIControls);
    };

    RedesignWidgetsController.prototype.shouldResetRender = function() {
      return document.webkitHidden && AppRedesign.current().idleSeconds() > 60 && this.item.chart_type !== 'table';
    };

    RedesignWidgetsController.prototype.renderIfInViewport = function() {
      if (this.shouldResetRender()) {
        if (this.renderedChart) {
          this.returnToUnrenderedState();
        }
        return;
      }
      if (this.renderedChart) {
        return;
      }
      if (this.canBeRendered()) {
        return this.render();
      } else {
        return typeof app !== "undefined" && app !== null ? app.notRenderingWidget(this.item.id) : void 0;
      }
    };

    RedesignWidgetsController.prototype.onChartRendered = function() {
      if (!this.canBeRendered()) {
        return this.returnToUnrenderedState();
      }
    };

    RedesignWidgetsController.prototype.returnToUnrenderedState = function() {
      this.chartContainer.returnToUnrenderedState();
      this.renderedChart = false;
      return this.oldState = null;
    };

    RedesignWidgetsController.prototype.resizeCharts = function() {
      return this.chartContainer.resizeCharts();
    };

    RedesignWidgetsController.prototype.resetResizeable = function() {
      return this.chartContainer.notifyFrameReset();
    };

    RedesignWidgetsController.prototype.isEditable = function(asCopy) {
      this.item.reload();
      return this.isEditableToUser(asCopy) && !(typeof app !== "undefined" && app !== null ? app.tvmode : void 0);
    };

    RedesignWidgetsController.prototype.isEditableToUser = function(asCopy) {
      var ref;
      if (asCopy == null) {
        asCopy = false;
      }
      if (AppRedesign.restrictDatabasesEnabled() && !this.item.isDragDrop()) {
        return ((ref = App.User.currentUser()) != null ? ref.canQuery(this.item.database_id) : void 0) || (asCopy && AppRedesign.canOnlyEditChartAsCopy());
      }
      if (AppRedesign.current().state.RbacEnabled) {
        if (this.item.isDragDrop()) {
          return AppRedesign.createDiscoveryChartsEnabledOnDashboard();
        } else {
          return AppRedesign.createSqlChartsEnabledOnDashboard();
        }
      } else {
        if (asCopy) {
          return App.User.currentUser().canExplore();
        } else {
          return !this.item.isReadOnlyToCurrentUser();
        }
      }
    };

    RedesignWidgetsController.prototype.render = function(force) {
      var animate;
      if (force == null) {
        force = false;
      }
      if (!this.canBeRendered()) {
        return;
      }
      if (!this.renderedChart) {
        this.chartContainer.renderFrame();
        this.renderedChart = true;
      }
      animate = this.item.getTwiddle(App.TwiddleConfig.ANIMATE_ON_DASHBOARD);
      this.chartContainer.renderWidget(this.item, animate, force);
      return this.updateEditUIControls();
    };

    RedesignWidgetsController.prototype.updateEditUIControls = function() {
      if (!AppRedesign.restrictDatabasesEnabled()) {
        return;
      }
      return this.el.toggleClass('read-only', !this.isEditableToUser(AppRedesign.canOnlyEditChartAsCopy()));
    };

    RedesignWidgetsController.prototype.annotationsChanged = function(groups) {
      if (!((groups != null) && !groups.isEmpty())) {
        return;
      }
      if (!App.Utils.intersect(this.item.getArrayTwiddle('twiddle_annotation_groups'), groups).isEmpty()) {
        return this.render(true);
      }
    };

    RedesignWidgetsController.prototype.formulaSourceUpdated = function(formulaSource) {
      var hash_key, ref;
      this.item.reload();
      hash_key = this.item.hashKey();
      if (!((hash_key != null) && hash_key === formulaSource.hash_key)) {
        return;
      }
      if (formulaSource.percent_complete === 0 && !formulaSource.hasUpdatePending()) {
        return App.fetchSourceWithoutExplicitQuerySource(hash_key);
      }
      if (!(this.item.hasUpdatePending() || ((ref = this.item.selectedFormulaSource()) != null ? ref.waitingOnS3Links() : void 0))) {
        this.chartContainer.hideLoader();
      }
      return this.update();
    };

    RedesignWidgetsController.prototype.update = function() {
      var dataFetchedAt, fs;
      this.item.reload();
      this.item.fetchSource();
      this.chartContainer.updateTitleArea();
      fs = this.item.selectedFormulaSource();
      dataFetchedAt = fs != null ? fs.dataFetchedAt : void 0;
      if (fs != null) {
        fs.setDataFetchedAt(null);
      }
      if (!this.renderedChart) {
        return;
      }
      if (!this.canBeRendered()) {
        return this.returnToUnrenderedState();
      }
      if (!((fs != null) && (fs.isCompletelyLoaded() || fs.waiting()))) {
        return;
      }
      this.render();
      if (this.oldState === this.item.state()) {
        return;
      }
      if (dataFetchedAt) {
        AppRedesign.logToScalyr("widget-render-lag", {
          source: fs.id,
          widget_id: this.item.id,
          render_latency: (Date.now() - dataFetchedAt) / 1000
        });
      }
      this.oldState = this.item.state();
      if ([App.Widget.S_COMPLETE, App.Widget.S_CANCELED].includes(this.item.state())) {
        return this.chartContainer.hideLoader();
      } else {
        return this.chartContainer.fadeInLoader();
      }
    };

    RedesignWidgetsController.prototype.changedTwiddle = function() {
      return this.chartContainer.renderWidget(this.item, true);
    };

    RedesignWidgetsController.prototype.changedUwv = function(widget, uwv) {
      return this.chartContainer.renderWidget(this.item, true, false, uwv);
    };

    RedesignWidgetsController.prototype.changedSize = function() {
      this.resizeCharts();
      return this.resetResizeable();
    };

    RedesignWidgetsController.prototype.controlPressed = function(action) {
      switch (action) {
        case "refresh":
          return this.refreshData();
        case "csv":
          return this.exportCSV();
        case "link":
          return this.shareLink();
        case "slack":
          return this.showSlackModal();
        case "edit":
          return this.editWidget();
        case "w-id":
          return this.debugWidgetPrint();
        case "image":
          return this.exportImage();
        case "search":
          return this.toggleSearch();
        case "pivot":
          return this.addPivot();
        case "edit-copy":
          return this.editWidgetAsCopy();
      }
    };

    RedesignWidgetsController.prototype.exportImage = function() {
      return App.Utils.logFeature('download-widget-image', {
        widget_id: this.item.id
      });
    };

    RedesignWidgetsController.prototype.toggleSearch = function() {
      var ref;
      return (ref = this.chartContainer) != null ? ref.chartHandler('toggleSearch') : void 0;
    };

    RedesignWidgetsController.prototype.addPivot = function() {
      var ref;
      return (ref = this.chartContainer) != null ? ref.chartHandler('addPivot') : void 0;
    };

    RedesignWidgetsController.prototype.debugWidgetPrint = function() {
      if (this.item == null) {
        return;
      }
      window.debug_w = this.item;
      console.debug("(stored in var debug_w)");
      return console.debug(this.item);
    };

    RedesignWidgetsController.prototype.editWidget = function() {
      var ref, widget;
      if (!this.isEditable()) {
        return;
      }
      if ((ref = this.chartContainer) != null) {
        ref.chartHandler('close');
      }
      widget = App.Widget.find(this.item.id);
      widget.twiddles = _.cloneDeep(widget.twiddles);
      widget.mergeEditableProperties(this.item);
      return this.trigger('edit-widget', widget);
    };

    RedesignWidgetsController.prototype.editWidgetAsCopy = function() {
      var ref;
      if (!(this.isEditable(true) || (AppRedesign.current().state.RbacEnabled && AppRedesign.createSqlChartsEnabled() && AppRedesign.editChartAsCopyEnabledOnDashboard()))) {
        return;
      }
      if ((ref = this.chartContainer) != null) {
        ref.chartHandler('close');
      }
      return this.trigger('edit-widget', this.item.copy());
    };

    RedesignWidgetsController.prototype.createWidgetLink = function() {
      var params, ref;
      params = {
        widget: this.item.getLinkId(),
        udv: ((ref = App.UserDataView.current()) != null ? ref.id : void 0) || '0'
      };
      return ("?" + window.location.search + "&").replace(/\?(\?|&)/g, "?") + $.param(params) + window.location.hash;
    };

    RedesignWidgetsController.prototype.shareLink = function() {
      var ref;
      App.Utils.logFeature('linked-widget-create', {
        widget_id: (ref = this.item) != null ? ref.id : void 0,
        dashboard_id: App.Dashboard.currentDashboard().id
      });
      return window.open(this.createWidgetLink());
    };

    RedesignWidgetsController.prototype.showSlackModal = function() {
      var modalController, sendWidgetToSlackModal;
      modalController = new App.SendWidgetToSlackController({
        widget: this.item
      });
      sendWidgetToSlackModal = App.RedesignDialog.createDialog({
        title: 'Post to Slack',
        viewController: modalController,
        customDialogClass: 'send-widget-to-slack-modal'
      });
      return modalController.bind('close-dialog', sendWidgetToSlackModal.close);
    };

    RedesignWidgetsController.prototype.exportCSV = function() {
      return App.DownloadHelper.exportCSV(this.item);
    };

    RedesignWidgetsController.prototype.refreshData = function() {
      return this.item.refreshData();
    };

    RedesignWidgetsController.units = function() {
      return 32;
    };

    RedesignWidgetsController.prototype.exportImageClick = function() {
      var dataURL, downloadTitle;
      if (!this.chartContainer.supportsImageData()) {
        return;
      }
      downloadTitle = this.item.getTitleForDisplay().replace(/[^A-Za-z0-9]/g, '');
      if (downloadTitle.length === 0) {
        downloadTitle = 'chart';
      }
      dataURL = this.constructImageData();
      return dataURL.then((function(_this) {
        return function(result) {
          return _this.pushDownload(result, downloadTitle);
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          return AppRedesign.logError(new Error(error));
        };
      })(this));
    };

    RedesignWidgetsController.prototype.constructImageData = function() {
      var base;
      if (typeof (base = this.chartContainer.chart()).constructImageData === "function") {
        base.constructImageData();
      }
      return new Promise((function(_this) {
        return function(resolve, reject) {
          var completionHandler;
          completionHandler = function(retries) {
            var imageData;
            imageData = _this.chartContainer.getImageData();
            if (imageData != null) {
              return resolve(imageData);
            } else if (retries === 5) {
              return reject("Image Construction timed out for widget " + _this.chartContainer.item.id);
            } else {
              retries++;
              return setTimeout((function() {
                return completionHandler(retries);
              }), 200);
            }
          };
          return completionHandler(1);
        };
      })(this));
    };

    RedesignWidgetsController.prototype.pushDownload = function(imageData, downloadTitle) {
      var invisiblelink;
      invisiblelink = document.createElement("a");
      invisiblelink.download = downloadTitle + ".png";
      invisiblelink.target = "_blank";
      invisiblelink.href = imageData;
      invisiblelink.rel = "nofollow noopener noreferrer";
      invisiblelink.click();
      return invisiblelink.remove();
    };

    return RedesignWidgetsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RenderChartController = (function(superClass) {
    extend(RenderChartController, superClass);

    function RenderChartController() {
      this.updateTitle = bind(this.updateTitle, this);
      this.setAlertHeightForTableChart = bind(this.setAlertHeightForTableChart, this);
      this.mouseEnterGeomap = bind(this.mouseEnterGeomap, this);
      this.chartUnhover = bind(this.chartUnhover, this);
      this.chartHover = bind(this.chartHover, this);
      RenderChartController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item', 'dashboardSizer', 'showAlertFunc', 'uiQueueFunc');
      this.el.on('mouseenter', this.chartHover);
      this.el.on('mouseleave', this.chartUnhover);
    }

    RenderChartController.prototype.titleEl = function() {
      return this.$('.title');
    };

    RenderChartController.prototype.contentEl = function() {
      return this.$('.widget-content');
    };

    RenderChartController.prototype.contentContainerEl = function() {
      return this.$('.chart-container');
    };

    RenderChartController.prototype.alertBlockEl = function() {
      return this.$('.alert-flex-wrapper');
    };

    RenderChartController.prototype.renderWithChartographer = function(widget, source, animate, userWidgetView, renderGuid) {
      var chartData, chartHash, e, geomapError, ref, ref1, theme, twiddles;
      this.renderGuid = renderGuid;
      if (widget.blocked_by_database_mapping_feature) {
        return App.Widget.DB_MAPPING_ERROR_MESSAGE;
      }
      theme = widget.colorTheme();
      twiddles = this.createWidgetTwiddles(widget, source, userWidgetView);
      chartHash = this.chartographerHashKey(widget, twiddles);
      chartData = App.ChartographerCache.getFromCache(chartHash);
      if (chartData == null) {
        chartData = this.getChartData(widget, twiddles, chartHash, theme);
      }
      if (chartData.error != null) {
        this.trigger("chart-rendered", chartData);
        widget.trigger('new-chart-data', chartData);
        return chartData.error;
      }
      if ((ref = this.editHelper) != null ? (ref1 = ref.getInfoAndWarnings()) != null ? ref1.warnings.length : void 0 : void 0) {
        this.showAlertFunc('warning', 'Ambiguous Table Reference:', App.AlertHelpers.alertWarningMessage(this.editHelper.getInfoAndWarnings().warnings));
      }
      if ((chartData != null ? chartData.warning : void 0) && this.chartInEditron) {
        this.showAlertFunc('warning', '', chartData.warning);
      }
      if (widget.chart_type === 'scatter' && twiddles['twiddle_secondary_axis_enabled']) {
        this.item.setTwiddle('twiddle_multiple_y_axes', true);
        this.item.setTwiddle('twiddle_multiple_y_axes_columns', twiddles['twiddle_secondary_axis_series_names'].join(","));
      }
      this.el.toggleClass('sparkline', widget.chart_type === 'sparkline');
      switch (widget.chart_type) {
        case 'image':
          this.renderImageChart(chartData, widget);
          break;
        case 'codeimage':
          this.renderImageChart(chartData, widget);
          break;
        case 'geomap':
          geomapError = this.renderGeomap(chartData, widget);
          break;
        case 'codetext':
          this.renderTextChart(chartData, widget);
          break;
        case 'bignumber':
        case 'sparkline':
          this.renderOverlayChart(chartData, widget, animate);
          break;
        case 'cohort':
        case 'table':
          try {
            this.renderTableChart(chartData, widget);
          } catch (error1) {
            e = error1;
            widget.trigger('new-chart-data', chartData);
            AppRedesign.logError(e);
            return App.Chartographer.ERR_GENERIC;
          }
          break;
        default:
          this.renderCanvasChart(chartData, widget, animate);
      }
      this.drawOverlay(chartData, widget, animate);
      widget.trigger('new-chart-data', chartData);
      return geomapError;
    };

    RenderChartController.prototype.setTitleController = function(chartTitleController) {
      this.chartTitleController = chartTitleController;
    };

    RenderChartController.prototype.getAggregation = function(sql) {
      if (sql.indexOf(":aggregation]") !== -1) {
        return App.Dashboard.currentDashboard().aggregationSetting();
      }
      return null;
    };

    RenderChartController.prototype.getChartData = function(widget, twiddles, chartHash, theme) {
      var aggregation, dataType;
      aggregation = this.getAggregation(widget.sql);
      if (widget.hasCodeSource()) {
        dataType = App.ChartUtils.getCodeChartDataType(widget.getChartType());
        return new App.Chartographer.convertLinkData(widget.getRows(), widget.getColumns(), widget.linkData(dataType), widget.getCodeLanguage(), twiddles, chartHash, theme, aggregation);
      } else {
        return new App.Chartographer.convert(widget.getRows(), widget.getColumns(), twiddles, chartHash, theme, aggregation);
      }
    };

    RenderChartController.prototype.chartographerHashKey = function(widget, twiddles) {
      var fs;
      fs = widget.selectedFormulaSource();
      return [fs.hash_key, fs.last_update, JSON.stringify(twiddles), widget.colorTheme().colorList(), fs.waitingOnS3Links()].join(',');
    };

    RenderChartController.prototype.createWidgetTwiddles = function(widget, source, uwv) {
      var ref, twiddles;
      twiddles = $.extend(true, {}, App.DefaultTwiddleGenerator.call(widget.twiddles, widget.chart_type));
      twiddles['twiddle_chart_type'] = widget.chart_type;
      if (source.hasOrderBy()) {
        twiddles['twiddle_do_not_sort_series'] = true;
      }
      if (((ref = source.sql) != null ? ref.toLowerCase().indexOf('order by') : void 0) !== -1) {
        twiddles['twiddle_do_not_sort_series'] = true;
      }
      twiddles['twiddle_insertotron_segment_columns'] = widget.segmentColumnsFromInsertotron();
      if ((uwv == null) && (widget.uwv_twiddles != null)) {
        uwv = new App.UserWidgetView({
          twiddles: widget.uwv_twiddles
        });
      }
      if ((uwv != null) && widget.getTwiddle('twiddle_drag_drop_chart')) {
        if (this.chartInEditron || widget.chart_type !== 'table' || uwv.twiddles.twiddle_use_pivot_settings !== true) {
          uwv = null;
        }
      }
      if (uwv != null) {
        uwv.setWidgetTwiddles(twiddles);
      }
      return twiddles;
    };

    RenderChartController.prototype.renderImageChart = function(chartData, widget) {
      var ref, ref1;
      if ((ref = this.basicChart) != null) {
        ref.release();
      }
      if ((chartData != null ? (ref1 = chartData.linkData) != null ? ref1.data : void 0 : void 0) != null) {
        this.basicChart = new App.PlotlyCodeChart({
          chartData: chartData,
          widget: widget
        });
        this.bubbles(this.basicChart, 'overlay-error');
      } else {
        this.basicChart = new App.ImageChart({
          chartData: chartData,
          widget: widget
        });
      }
      this.basicChart.render();
      return this.contentContainerEl().append(this.basicChart.el);
    };

    RenderChartController.prototype.renderGeomap = function(chartData, widget) {
      var columns, dataMode, error, i, len, ref, ref1, ref2, series, weightColumns;
      if ((ref = this.geomapChart) != null) {
        ref.release();
      }
      dataMode = widget.getTwiddle(App.TwiddleConfig.GEOMAP_DATA_MODE);
      columns = widget.getColumns();
      if (dataMode === App.Geomap.DATA_MODE_GEOJSON) {
        columns = ["x", "y"];
      }
      weightColumns = (ref1 = chartData.twiddlesActual) != null ? ref1.get(App.TwiddleConfig.GEOMAP_WEIGHT_COLUMNS) : void 0;
      ref2 = chartData.dataSeries;
      for (i = 0, len = ref2.length; i < len; i++) {
        series = ref2[i];
        error = App.Geomap.checkDataForErrors(columns, series, dataMode, weightColumns);
        if (error != null) {
          return error;
        }
      }
      this.geomapChart = new App.Geomap({
        widget: widget,
        el: App.Utils.appendFrame(this.contentContainerEl(), 'geomap-container'),
        chartData: chartData,
        columns: ['x', 'y'],
        tooltipColumns: widget.availableDetailColumns(),
        plotMode: widget.getTwiddle(App.TwiddleConfig.GEOMAP_PLOT_MODE),
        dataMode: dataMode,
        satelliteTiles: widget.getTwiddle(App.TwiddleConfig.GEOMAP_SATELLITE_TILES),
        position: {
          zoom: widget.getTwiddle(App.TwiddleConfig.GEOMAP_ZOOM),
          lat: widget.getTwiddle(App.TwiddleConfig.GEOMAP_LATITUDE),
          lng: widget.getTwiddle(App.TwiddleConfig.GEOMAP_LONGITUDE)
        },
        columnWidthFunc: ((function(_this) {
          return function() {
            return _this.dashboardSizer.columnWidth(_this.chartInEditron);
          };
        })(this))
      });
      this.bubbles(this.geomapChart, 'save-map-position');
      this.geomapChart.render();
      return null;
    };

    RenderChartController.prototype.renderTextChart = function(chartData, widget) {
      var ref;
      if ((ref = this.basicChart) != null) {
        ref.release();
      }
      this.basicChart = new App.TextChart({
        chartData: chartData,
        widget: widget
      });
      this.basicChart.render();
      return this.contentContainerEl().append(this.basicChart.el);
    };

    RenderChartController.prototype.renderOverlayChart = function(chartData, widget, animate) {
      var ref, xColumnName;
      xColumnName = chartData.twiddlesActual.get(App.TwiddleConfig.POINT_COLS).first();
      if (widget.chart_type === 'bignumber' && chartData.dataSeries.first().dataPoints.length === 1 && xColumnName === App.ColumnProcessor.INDEX_COLUMN) {
        widget.triggerRendered();
        if ((ref = this.chartTitleController) != null) {
          ref.hideTitle();
        }
        return this.unrenderAllCharts();
      } else {
        return this.renderCanvasChart(chartData, widget, animate);
      }
    };

    RenderChartController.prototype.renderTableChart = function(chartData, widget) {
      var previousTableChart, ref;
      previousTableChart = this.tableChart;
      if ((ref = this.tableChart) != null) {
        ref.unrender();
      }
      if (this.tableChart == null) {
        this.tableChart = new App.RedesignTableChart({
          widget: widget,
          el: this.contentEl(),
          chartData: chartData
        });
      }
      this.setAlertHeightForTableChart();
      if (previousTableChart !== this.tableChart) {
        this.bubbles(this.tableChart, 'overlay-error');
      }
      this.tableChart.setDataFromChartData(chartData);
      this.tableChart.render();
      return widget.triggerRendered();
    };

    RenderChartController.prototype.renderCanvasChart = function(chartData, widget, animate) {
      var content, previousChart, width;
      if (animate == null) {
        animate = false;
      }
      content = this.contentEl();
      width = this.dashboardSizer.columnWidth(this.chartInEditron) - 1;
      previousChart = this.canvasChart;
      if (this.canvasChart == null) {
        this.canvasChart = new App.CanvasChart({
          widget: widget,
          el: content,
          renderGuid: this.renderGuid,
          chartData: chartData,
          width: width,
          height: width - 45,
          animateOnce: animate,
          columnWidthFunc: ((function(_this) {
            return function() {
              return _this.dashboardSizer.columnWidth(_this.chartInEditron);
            };
          })(this))
        });
      }
      if (previousChart !== this.canvasChart) {
        this.bubbles(this.canvasChart, 'add-annotation');
        this.bubbles(this.canvasChart, 'delete-annotations');
        this.bubbles(this.canvasChart, 'overlay-error');
      }
      this.canvasChart.render(chartData, content.width(), content.height(), animate);
      return widget.triggerRendered();
    };

    RenderChartController.prototype.chart = function() {
      var ref, ref1, ref2;
      return (ref = (ref1 = (ref2 = this.canvasChart) != null ? ref2 : this.basicChart) != null ? ref1 : this.geomapChart) != null ? ref : this.tableChart;
    };

    RenderChartController.prototype.drawOverlay = function(chartData, widget, animate) {
      var ref, ref1;
      if ((ref = widget.chart_type) === 'bignumber' || ref === 'sparkline') {
        if (this.overlay == null) {
          this.overlay = new App.ChartOverlay({
            el: App.Utils.appendFrame(this.el, 'bignumber-overlay')
          });
        }
        this.overlay.render(chartData, widget.getTitleForDisplay(), animate);
        return this.dashboardSizer.sizeBigNumberOverlays(this.el, widget);
      } else {
        if ((ref1 = this.overlay) != null) {
          ref1.release();
        }
        return delete this.overlay;
      }
    };

    RenderChartController.prototype.releaseChart = function() {
      var ref, ref1, ref2, ref3, ref4;
      if ((ref = this.overlay) != null) {
        ref.release();
      }
      this.overlay = null;
      this.el.removeClass('sparkline');
      if ((ref1 = this.canvasChart) != null) {
        ref1.release();
      }
      this.canvasChart = null;
      if ((ref2 = this.basicChart) != null) {
        ref2.release();
      }
      this.basicChart = null;
      if ((ref3 = this.geomapChart) != null) {
        ref3.release();
      }
      this.geomapChart = null;
      if ((ref4 = this.tableChart) != null) {
        ref4.release();
      }
      return this.tableChart = null;
    };

    RenderChartController.prototype.unrenderAllCharts = function() {
      var ref, ref1, ref2, ref3, ref4;
      if ((ref = this.tableChart) != null) {
        ref.unrender();
      }
      if ((ref1 = this.canvasChart) != null) {
        ref1.unrender();
      }
      if ((ref2 = this.basicChart) != null) {
        ref2.unrender();
      }
      if ((ref3 = this.geomapChart) != null) {
        ref3.release();
      }
      delete this.geomapChart;
      if ((ref4 = this.overlay) != null) {
        ref4.release();
      }
      return delete this.overlay;
    };

    RenderChartController.prototype.chartHover = function(e) {
      var ref;
      if (App.RedesignDashboardsController.isResizeDragInProgress()) {
        return;
      }
      if (this.geomapChart != null) {
        this.mouseEnterGeomap();
      }
      if (this.overlay == null) {
        return;
      }
      if ((ref = this.chartTitleController) != null) {
        ref.showTitle();
      }
      return this.overlay.chartHover(e);
    };

    RenderChartController.prototype.chartUnhover = function(e) {
      var ref, ref1;
      if (App.RedesignDashboardsController.isResizeDragInProgress()) {
        return;
      }
      if ((ref = this.chartTitleController) != null) {
        ref.hideMenu();
      }
      if (this.geomapChart != null) {
        this.mouseLeaveGeomap();
      }
      if (this.overlay == null) {
        return;
      }
      this.overlay.chartUnhover(e);
      if (this.shouldHideOverlayTitle()) {
        return (ref1 = this.chartTitleController) != null ? ref1.hideTitle() : void 0;
      }
    };

    RenderChartController.prototype.mouseEnterGeomap = function() {
      if (App.RedesignDashboardsController.timeSinceLastDashboardScroll() > this.constructor.TIME_SINCE_LAST_DASHBOARD_SCROLL) {
        return this.geomapChart.enableMouseZoom();
      } else {
        return this.scrollCheckTimeout = setTimeout(this.mouseEnterGeomap, this.constructor.SCROLL_CHECK_TIMEOUT);
      }
    };

    RenderChartController.prototype.mouseLeaveGeomap = function() {
      clearTimeout(this.scrollCheckTimeout);
      return this.geomapChart.disableMouseZoom();
    };

    RenderChartController.prototype.shouldHideOverlayTitle = function() {
      return (this.overlay != null) && !this.overlay.overlayCanFade() && this.item.chart_type === 'bignumber' && !this.el.hasClass('ui-draggable-dragging');
    };

    RenderChartController.prototype.chartHandler = function(msg) {
      var handler, ref, ref1;
      if (((ref = this.chart()) != null ? ref.getChartHandler : void 0) == null) {
        return;
      }
      handler = (ref1 = this.chart()) != null ? ref1.getChartHandler(this.item, this.contentEl()) : void 0;
      if (handler[msg] == null) {
        return;
      }
      return handler[msg]();
    };

    RenderChartController.prototype.resizeOnly = function() {
      var ref, ref1;
      this.dashboardSizer.sizeBigNumberOverlays(this.el, this.item);
      if ((ref = this.geomapChart) != null) {
        ref.resize();
      }
      if ((ref1 = this.tableChart) != null) {
        ref1.resize();
      }
      this.chartHandler('resize');
      if (this.chartInEditron) {
        this.chartTitleController.resizeTitle();
      }
      return this.alertBlockEl().css('max-height', this.el.height() - this.titleEl().outerHeight(true) - App.RedesignChartContainerController.ALERT_SPACE_FROM_BOTTOM);
    };

    RenderChartController.prototype.resizeCharts = function(errorMsg, sqlBlank) {
      var chartHidden, content, ref;
      content = this.contentEl();
      chartHidden = this.item.chart_type === 'bignumber' && ((ref = this.overlay) != null ? ref.useHeavyOverlay() : void 0) || sqlBlank;
      if (((this.canvasChart != null) || (this.geomapChart != null) || (this.basicChart != null)) && !errorMsg && !chartHidden) {
        this.uiQueueFunc(((function(_this) {
          return function() {
            var ref1, ref2, ref3;
            if ((ref1 = _this.canvasChart) != null) {
              ref1.render(null, content.width(), content.height(), false, _this.chartInEditron);
            }
            if ((ref2 = _this.geomapChart) != null) {
              ref2.render();
            }
            return (ref3 = _this.basicChart) != null ? ref3.render() : void 0;
          };
        })(this)), 'resizeCharts');
      }
      return this.resizeOnly();
    };

    RenderChartController.prototype.setAlertHeightForTableChart = function() {
      var adjustedHeight, ref;
      adjustedHeight = this.alertBlockEl().is(':visible') ? this.alertBlockEl().outerHeight(true) + App.RedesignChartContainerController.TABLE_CHART_ALERT_ADJUSTMENT : 0;
      return (ref = this.tableChart) != null ? ref.setAlertHeight(adjustedHeight) : void 0;
    };

    RenderChartController.prototype.updateTitle = function(title) {
      var ref;
      return (ref = this.overlay) != null ? ref.updateTitle(title) : void 0;
    };

    return RenderChartController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.RunResult = (function() {
    function RunResult(callback) {
      this.callback = callback;
      this.has_rows = false;
      this.running = true;
    }

    RunResult.prototype.setHashKey = function(hash_key1) {
      this.hash_key = hash_key1;
    };

    RunResult.prototype.setSqlHashKey = function(sql_hash_key) {
      this.sql_hash_key = sql_hash_key;
    };

    RunResult.prototype.setDbInfo = function(dbInfo1) {
      this.dbInfo = dbInfo1;
    };

    RunResult.prototype.completedWithFormulaSource = function(source) {
      var has_links;
      if (!this.running) {
        throw new Error("RunResult completed called more than once");
      }
      this.running = false;
      this.error_message = source.errorMessage();
      if (this.error_message) {
        this.error_message = App.SourceErrorMessageInterpreter.call(this.error_message);
        if (source.hasErrorPositions()) {
          this.error_message = App.ErrorMessageLineAnnotator.call(source.sql, source.htmlSql(), source.error_pos, this.error_message, this.dbInfo);
        }
      }
      this.has_rows = !source.emptyRows();
      has_links = source.links && source.links !== [];
      if (!this.error_message && !this.has_rows && !has_links) {
        this.message = App.Chartographer.ERR_NO_ROWS;
      }
      this.rows = source.rowsAsHashList();
      this.columns = source.columnsWithoutDupes();
      this.column_infos = source.column_infos;
      this.links = source.links;
      this.queryDuration = App.Utils.roundToSignificantDigits(source.query_duration, 3);
      this.ran_on_redshift = source.ran_on_redshift;
      if (source.source_type === 'preview_and_full_sql' && this.has_rows) {
        this.error_message = null;
      }
      if (this.callback != null) {
        return this.callback(this.getResult());
      }
    };

    RunResult.prototype.completedWithError = function(error) {
      if (!this.running) {
        throw new Error("RunResult completed called more than once");
      }
      this.running = false;
      this.error_message = error;
      if (this.callback != null) {
        return this.callback(this.getResult());
      }
    };

    RunResult.prototype.isWaitingFor = function(hash_key) {
      if (!this.running) {
        return false;
      }
      return hash_key === this.hash_key;
    };

    RunResult.prototype.isRunning = function() {
      return this.running;
    };

    RunResult.prototype.hasRows = function() {
      return this.has_rows;
    };

    RunResult.prototype.getRows = function() {
      return this.rows || [];
    };

    RunResult.prototype.getColumns = function() {
      return this.columns || [];
    };

    RunResult.prototype.getS3Links = function() {
      return this.links || [];
    };

    RunResult.prototype.getErrorMessage = function() {
      return this.error_message;
    };

    RunResult.prototype.getMessage = function() {
      return this.message;
    };

    RunResult.prototype.getHashKey = function() {
      return this.hash_key;
    };

    RunResult.prototype.getSqlHashKey = function() {
      return this.sql_hash_key;
    };

    RunResult.prototype.getQueryDuration = function() {
      return this.queryDuration;
    };

    RunResult.prototype.ranOnRedshift = function() {
      return this.ran_on_redshift;
    };

    RunResult.prototype.getSimpleColumnInfos = function() {
      var colInfo, i, len, ref, simple_column_infos;
      simple_column_infos = [];
      if (this.column_infos != null) {
        ref = this.column_infos;
        for (i = 0, len = ref.length; i < len; i++) {
          colInfo = ref[i];
          if (colInfo.column_type) {
            colInfo.column_type = App.Database.sqlTypeToSimpleType(colInfo.column_type.toLowerCase());
          }
          simple_column_infos.push(colInfo);
        }
      }
      return simple_column_infos;
    };

    RunResult.prototype.getResult = function() {
      return {
        column_infos: this.getSimpleColumnInfos(),
        columns: this.getColumns(),
        duration: this.getQueryDuration(),
        errors: this.getErrorMessage(),
        message: this.getMessage(),
        hashKey: this.getHashKey(),
        links: this.getS3Links(),
        ran_on_redshift: this.ranOnRedshift(),
        rows: this.getRows(),
        running: this.running
      };
    };

    RunResult.translateSourceToRunResultOutput = function(source, dbInfo) {
      var runResult;
      if (source == null) {
        return null;
      }
      runResult = new App.RunResult();
      runResult.setDbInfo(dbInfo);
      runResult.setHashKey(source.hash_key);
      runResult.completedWithFormulaSource(source);
      return runResult.getResult();
    };

    RunResult.translateItemToRunResultOutput = function(item) {
      var ref;
      return {
        rows: item.rowsAsHashList() ? item.rowsAsHashList() : [],
        columns: item.getColumns() ? item.getColumns() : [],
        errors: (ref = item.error_message) != null ? ref : null,
        running: false
      };
    };

    return RunResult;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SeriesColorPicker = (function(superClass) {
    extend(SeriesColorPicker, superClass);

    function SeriesColorPicker() {
      return SeriesColorPicker.__super__.constructor.apply(this, arguments);
    }

    SeriesColorPicker.prototype.className = 'gradient-color-picker';

    SeriesColorPicker.prototype.elements = {
      '.custom.color-content': 'colorPickerArea',
      '.recent.color-content': 'recentColorsArea',
      '.theme.color-content': 'themeColorsArea'
    };

    SeriesColorPicker.prototype.events = {
      'click .action.reset': 'resetColor',
      'click .action.delete': 'deleteColor',
      'click .action.save': 'updateAndRelease',
      'click .rotator-title': 'toggleRotator'
    };

    SeriesColorPicker.prototype.render = function() {
      this.html(this.view('redesign/settings/editor_color_picker')());
      this.renderThemeColors();
      return SeriesColorPicker.__super__.render.apply(this, arguments);
    };

    SeriesColorPicker.prototype.renderThemeColors = function() {
      this.themeColorsController = new App.ThemeColorsController({
        viewController: this,
        colorTheme: this.colorTheme
      });
      this.themeColorsController.bind('set-color', this.updateColor);
      return this.themeColorsArea.append(this.themeColorsController.$el);
    };

    SeriesColorPicker.prototype.setTargetColor = function() {
      if (this.colorToSet) {
        this.targetCircle.css({
          'background-color': this.colorToSet
        });
      }
      if (this.colorToSet) {
        return this.titleColor.css({
          'background-color': this.colorToSet
        });
      }
    };

    return SeriesColorPicker;

  })(App.SingleColorPickerController);

}).call(this);
(function() {
  App.HarvestState = (function() {
    function HarvestState(harvest) {
      this.harvest = harvest;
    }

    HarvestState.prototype.hasData = function() {
      if (this._salesforceHarvest()) {
        return this.harvest.last_successful_full_harvest_at != null;
      }
      return this.harvest.last_successful_harvest_at != null;
    };

    HarvestState.prototype.hasError = function() {
      return this.harvest.error_count > 0;
    };

    HarvestState.prototype.prettyHarvestState = function() {
      switch (this.harvest.status()) {
        case 'permission-denied':
          return 'Permission Denied';
        case 'waiting':
        case 'warning':
          return "Next " + (this._prettyNextYoinkType()) + " " + (this.harvest.nextUpdateText());
        case 'failed':
          return this._getFailedMessage();
        case 'queued':
          return (this._prettyNextYoinkType().titleize()) + " Queued";
        case 'running':
          return 'Caching';
        default:
          return this.harvest.status().titleize();
      }
    };

    HarvestState.prototype._getFailedMessage = function() {
      var ref;
      if (((ref = this.harvest) != null ? ref.pretty_error : void 0) != null) {
        return this.harvest.pretty_error;
      }
      return "Failed to cache table";
    };

    HarvestState.prototype._prettyNextYoinkType = function() {
      if (this._salesforceHarvest()) {
        return 'full update';
      }
      switch (this.harvest.next_yoink_type) {
        case 'inc':
          return 'incremental update';
        case 'full':
          return 'full update';
        default:
          return 'update';
      }
    };

    HarvestState.prototype._salesforceHarvest = function() {
      return this.harvest.constructor.className === 'SalesforceObjectHarvest';
    };

    return HarvestState;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCacheController = (function(superClass) {
    extend(RedesignCacheController, superClass);

    RedesignCacheController.APPLIES_TO_ALL_SPACES = false;

    RedesignCacheController.TITLE = 'Cache';

    function RedesignCacheController() {
      this.initialFetchSuccess = bind(this.initialFetchSuccess, this);
      RedesignCacheController.__super__.constructor.apply(this, arguments);
      if (!App.Database.any()) {
        return;
      }
      jQuery.ajax({
        url: "/sites/" + (App.Site.first().id) + "/configitron_state"
      }).done(this.initialFetchSuccess);
      if (App.Database.hasWarehouseWithNoConfigurableDatabases() || App.Database.cacheableDatabases().length === 0) {
        this.html(this.view('redesign/settings/no_db_message')({
          message: 'There are no cacheable databases connected'
        }));
        return;
      }
      this.gridController = new App.RedesignSettingsGridController({
        dropdownWidth: '220px',
        loadingMessage: 'Loading cache status...',
        mainControllerOptions: {
          prmCtrl: this,
          initValue: App.Database.cacheableDatabases().first().id
        },
        settingsGridCssClass: 'cache-layout',
        settingsController: this,
        hideCategoryDropdown: App.Database.cacheableDatabases().length <= 1
      });
      this.el = this.gridController.el;
      App.RedesignConfigitronController.setConfigitronOpen();
    }

    RedesignCacheController.prototype.initialFetchSuccess = function(response) {
      App.TableHarvest.applyUpdates(response.table_harvests);
      App.SalesforceObjectHarvest.applyUpdates(response.salesforce_object_harvests);
      App.Database.applyUpdates(response.database_dependents);
      if ((response.redshifts != null) && App.User.currentUserIsPeriscopeAdmin()) {
        return App.Redshift.applyUpdates(response.redshifts);
      }
    };

    RedesignCacheController.prototype.getCategories = function() {
      var d, i, len, ref;
      this.databases = [];
      ref = App.Database.cacheableDatabases();
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        this.databases.push({
          type: d.id,
          label: d.database_name,
          placeholder: "Search",
          mainController: App.RedesignCacheMainController,
          upperSectionController: App.RedesignCacheStrategyController,
          cid: d.cid
        });
      }
      return this.databases;
    };

    RedesignCacheController.prototype.firstCategory = function() {
      return this.databases[0];
    };

    RedesignCacheController.prototype.releaseMainControllerSpecificBinding = function(category) {};

    RedesignCacheController.prototype.setUpForMainController = function(category) {};

    RedesignCacheController.prototype.release = function() {
      var ref;
      if ((ref = this.gridController) != null) {
        ref.release();
      }
      App.RedesignConfigitronController.unsetConfigitronOpen();
      return RedesignCacheController.__super__.release.apply(this, arguments);
    };

    return RedesignCacheController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCacheControllerHelper = (function(superClass) {
    extend(RedesignCacheControllerHelper, superClass);

    function RedesignCacheControllerHelper() {
      return RedesignCacheControllerHelper.__super__.constructor.apply(this, arguments);
    }

    RedesignCacheControllerHelper.setTableHarvestFromItem = function(item) {
      var newItem;
      if (item instanceof App.TableHarvest || item instanceof App.SalesforceObjectHarvest) {
        newItem = item.clone();
        delete newItem['full_table_name'];
        return newItem;
      }
      return void 0;
    };

    RedesignCacheControllerHelper.tableHarvestRowCount = function(database, tableHarvest) {
      if (tableHarvest == null) {
        return '--';
      }
      return this.tableHarvestRowCount(database, tableHarvest.fullName());
    };

    RedesignCacheControllerHelper.tableNameRowCount = function(database, fullName) {
      var cleanName, count;
      if ((database != null) && (fullName != null)) {
        cleanName = fullName.replace(/^public\./, '');
        count = database.rowCountForTable(cleanName);
        if (count != null) {
          return "" + (count.commaDelimit());
        }
      }
      return '--';
    };

    RedesignCacheControllerHelper._validColumnsForDropdown = function(tableColumns, dropdownType) {
      var cols, i, len, ref, simpleType, tableCol, validTypes;
      cols = [];
      if (dropdownType === 'update') {
        validTypes = ['datetime', 'date'];
      } else if (dropdownType === 'diff-unique-id') {
        validTypes = ['integer', 'datetime', 'string', 'date', 'number', 'decimal', 'uuid'];
      } else if (dropdownType === 'diff-import-column') {
        validTypes = ['integer', 'datetime', 'date', 'number', 'decimal'];
      } else {
        validTypes = ['integer', 'datetime', 'string', 'date', 'number', 'decimal'];
      }
      if (App.Site.first().usingSupercache() && dropdownType !== 'diff-unique-id') {
        validTypes.push("datetime2");
      }
      for (i = 0, len = tableColumns.length; i < len; i++) {
        tableCol = tableColumns[i];
        simpleType = App.Database.sqlTypeToSimpleType((ref = tableCol.sql_type) != null ? ref.toLowerCase() : void 0);
        if (validTypes.includes(simpleType)) {
          cols.push(tableCol);
        }
      }
      return cols;
    };

    RedesignCacheControllerHelper.optionsForIngestKey = function(tableColumns, dropdownType) {
      var i, len, options, ref, tableCol;
      options = [];
      ref = this._validColumnsForDropdown(tableColumns, dropdownType);
      for (i = 0, len = ref.length; i < len; i++) {
        tableCol = ref[i];
        options.push({
          value: tableCol.name,
          name: tableCol.name
        });
      }
      return options;
    };

    RedesignCacheControllerHelper.optionsForStrategy = function(database) {
      if (database != null ? database.isSalesforceDatabase() : void 0) {
        return [
          {
            value: "",
            name: "None"
          }, {
            value: "full-only",
            name: "Full Only"
          }
        ];
      } else {
        return [
          {
            value: "",
            name: "None"
          }, {
            value: "incremental-only",
            name: "Incremental Only"
          }, {
            value: "full-and-incremental",
            name: "Full and Incremental"
          }, {
            value: "full-only",
            name: "Full Only"
          }, {
            value: "update",
            name: "Bounded Updates"
          }, {
            value: "diff",
            name: "Modified Only"
          }
        ];
      }
    };

    RedesignCacheControllerHelper.optionsForHarvestInterval = function(harvestIntervalSeconds) {
      var options;
      options = [];
      options = options.concat([
        {
          value: 5 * 60,
          name: "5 minutes"
        }, {
          value: 15 * 60,
          name: "15 minutes"
        }, {
          value: 30 * 60,
          name: "30 minutes"
        }, {
          value: 60 * 60,
          name: "1 hour"
        }, {
          value: 2 * 60 * 60,
          name: "2 hour"
        }, {
          value: 8 * 60 * 60,
          name: "8 hours"
        }, {
          value: 24 * 60 * 60,
          name: "24 hours"
        }, {
          value: 3 * 24 * 60 * 60,
          name: "3 days"
        }, {
          value: 5 * 24 * 60 * 60,
          name: "5 days"
        }
      ]);
      this.ensureTimeOptionExists(options, harvestIntervalSeconds);
      return options;
    };

    RedesignCacheControllerHelper.optionsForFullHarvestInterval = function(harvestIntervalSeconds, fullHarvestIntervalSeconds, rowCount, salesForce, isFullOnlyHarvest) {
      var options;
      options = [];
      if (salesForce) {
        options = options.concat([
          {
            value: 5 * 60,
            name: "5 minutes"
          }, {
            value: 15 * 60,
            name: "15 minutes"
          }, {
            value: 30 * 60,
            name: "30 minutes"
          }, {
            value: 60 * 60,
            name: "1 hour"
          }, {
            value: 2 * 60 * 60,
            name: "2 hour"
          }
        ]);
      } else if ((rowCount != null) && rowCount < this.FAST_FULL_REFRESH_ROW_COUNT_LIMIT) {
        options = options.concat([
          {
            value: 60 * 60,
            name: "1 hour"
          }, {
            value: 4 * 60 * 60,
            name: "4 hours"
          }
        ]);
      }
      options = options.concat([
        {
          value: 8 * 60 * 60,
          name: "8 hours"
        }, {
          value: 24 * 60 * 60,
          name: "24 hours"
        }, {
          value: 3 * 24 * 60 * 60,
          name: "3 days"
        }, {
          value: 5 * 24 * 60 * 60,
          name: "5 days"
        }, {
          value: 30 * 24 * 60 * 60,
          name: "30 days"
        }
      ]);
      if (parseInt(fullHarvestIntervalSeconds) > 0) {
        this.ensureTimeOptionExists(options, fullHarvestIntervalSeconds);
      }
      return options;
    };

    RedesignCacheControllerHelper.ensureTimeOptionExists = function(options, val) {
      var i, len, opt;
      if (val == null) {
        return;
      }
      val = parseInt(val);
      for (i = 0, len = options.length; i < len; i++) {
        opt = options[i];
        if (opt.value === val) {
          return;
        }
      }
      options.push({
        value: val,
        name: (Math.round(val / 60)) + " minutes"
      });
      return options.sort(function(a, b) {
        return a.value - b.value;
      });
    };

    RedesignCacheControllerHelper.lastUpdateText = function(dateString) {
      if (!((dateString != null) && dateString.length > 0)) {
        return '--';
      }
      return App.Utils.roundedAgoFromDateString(dateString, "ago");
    };

    RedesignCacheControllerHelper.lastRuntimeText = function(value) {
      if (!((value != null) && value >= 0)) {
        return '--';
      }
      return App.Utils.roundedAgo(value);
    };

    return RedesignCacheControllerHelper;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCacheMainController = (function(superClass) {
    extend(RedesignCacheMainController, superClass);

    RedesignCacheMainController.prototype.events = {
      'click .sg-reload': 'reloadTableHarvest'
    };

    RedesignCacheMainController.COLUMNS = [
      {
        label: "Schema",
        "class": "schema-name-column",
        sortOn: "schema_sort_name"
      }, {
        label: "Table",
        "class": "table-name-column",
        sortOn: "table_name"
      }, {
        label: "Rows",
        "class": "row-count-column sg-right",
        sortOn: "row_count"
      }, {
        label: "Status",
        "class": "status-column",
        sortOn: "status"
      }
    ];

    RedesignCacheMainController.SEARCH_ATTRIBUTES = ["table_name", "schema_name", "status"];

    RedesignCacheMainController.MENU_OPTIONS = [];

    RedesignCacheMainController.CACHE_FOR_BYOW = 'Caching is not currently supported for this site';

    RedesignCacheMainController.CACHE_UNSUPPORTED = 'This database type is not supported on the Sisense Cache.';

    RedesignCacheMainController.CACHE_NOT_ENABLED = 'This database has not been configured to use the Sisense Cache.';

    RedesignCacheMainController.CACHE_NO_TABLES = 'This database does not have any tables.';

    RedesignCacheMainController.DB_CONFIG_MESSAGE_CLASS = 'db-config grid-message';

    RedesignCacheMainController.NO_TABLES_MESSAGE_CLASS = 'no-tables grid-message';

    function RedesignCacheMainController() {
      this.updateHarvestStatuses = bind(this.updateHarvestStatuses, this);
      this.applyResponseHarvest = bind(this.applyResponseHarvest, this);
      this.reloadTableHarvest = bind(this.reloadTableHarvest, this);
      this.getHarvestFromEvent = bind(this.getHarvestFromEvent, this);
      this.renderTableHarvestRows = bind(this.renderTableHarvestRows, this);
      var messageClass, ref, rows;
      RedesignCacheMainController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "database_id");
      this.database = App.Database.find(this.database_id);
      rows = this.getRows();
      if (rows.length === 0) {
        this.emptyMessage = App.Site.first().byow_enabled ? App.RedesignCacheMainController.CACHE_FOR_BYOW : App.RedesignCacheMainController.CACHE_NO_TABLES;
        messageClass = App.RedesignCacheMainController.NO_TABLES_MESSAGE_CLASS;
      }
      if (!this.database.canCache()) {
        this.emptyMessage = this.database.cacheable() ? App.RedesignCacheMainController.CACHE_NOT_ENABLED : App.RedesignCacheMainController.CACHE_UNSUPPORTED;
        messageClass = App.RedesignCacheMainController.DB_CONFIG_MESSAGE_CLASS;
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "cache-grid",
        columns: App.RedesignCacheMainController.COLUMNS,
        rows: rows,
        rowTemplate: this.view("redesign/settings/cache_row"),
        searchAttributes: App.RedesignCacheMainController.SEARCH_ATTRIBUTES,
        menuOptions: App.RedesignCacheMainController.MENU_OPTIONS,
        gridType: 'cache',
        emptyMessage: this.emptyMessage,
        emptyMessageType: messageClass,
        unselectEnabled: false,
        idCallback: this.idFunc,
        rowsEqualCallback: this.rowsEqual
      });
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      if ((ref = this.database) != null ? ref.isSalesforceDatabase() : void 0) {
        this.harvestObject = App.SalesforceObjectHarvest;
      } else {
        this.harvestObject = App.TableHarvest;
      }
      this.harvestObject.bind('change', this.renderTableHarvestRows);
      this.statusUpdateInterval = setInterval(this.updateHarvestStatuses, 1 * 1000);
    }

    RedesignCacheMainController.prototype.idFunc = function(obj) {
      return obj.id || CSS.escape(obj[App.RedesignSimpleGridController.OBJECT_FIELD].full_table_name);
    };

    RedesignCacheMainController.prototype.rowsEqual = function(row1, row2) {
      return row1.row_count === row2.row_count && row1.status === row2.status && row1.status_class === row2.status_class;
    };

    RedesignCacheMainController.prototype.renderTableHarvestRows = function(harvest) {
      var ref, uiQueue;
      if (harvest.database_id !== this.database_id) {
        return;
      }
      uiQueue = AppRedesign.current().uiQueue;
      if (!uiQueue) {
        return;
      }
      if ((ref = AppRedesign.current()) != null ? ref.cacheUIPerfImprovementEnabled : void 0) {
        return uiQueue.addOrReplace((function(_this) {
          return function() {
            return _this.grid.updateChangedRows(_this.getRows());
          };
        })(this), 'renderTableHarvestRows');
      } else {
        return uiQueue.addOrReplace((function(_this) {
          return function() {
            return _this.grid.updateRowsAndScroll(_this.getRows());
          };
        })(this), 'renderTableHarvestRows');
      }
    };

    RedesignCacheMainController.prototype.getRows = function() {
      var existingHarvest, fullTableName, i, len, ref, ref1, ref2, rowCount, schemaName, status, tableHarvestArr, tableHarvestInfo, tableHarvestMap, tableName, tableNames;
      if (App.Site.first().byow_enabled || (!this.database.cache_enabled && !this.database.canCacheToSnowflake())) {
        if ((ref = this.grid) != null) {
          ref.setEmptyMessage(this.emptyMessage);
        }
        return [];
      }
      tableHarvestMap = this.database.tableHarvestsAsMapByName();
      tableNames = this.database.getTableNamesIncludingHarvestedTables();
      tableHarvestArr = [];
      for (i = 0, len = tableNames.length; i < len; i++) {
        fullTableName = tableNames[i];
        ref1 = fullTableName.split('.'), schemaName = ref1[0], tableName = ref1[1];
        existingHarvest = tableHarvestMap[fullTableName];
        rowCount = App.RedesignCacheControllerHelper.tableNameRowCount(this.database, fullTableName);
        if (existingHarvest != null) {
          existingHarvest.row_count = rowCount;
        }
        status = this.statusForHarvest(existingHarvest);
        tableHarvestInfo = {
          schema_name: (this.database.isSalesforceDatabase() ? '--' : schemaName),
          table_name: tableName,
          row_count: rowCount,
          status: status.text,
          status_class: status.state,
          schema_sort_name: (schemaName + "." + tableName).toLowerCase(),
          id: fullTableName
        };
        if (existingHarvest == null) {
          existingHarvest = {};
        }
        existingHarvest.full_table_name = fullTableName;
        tableHarvestInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = existingHarvest;
        tableHarvestArr.push(tableHarvestInfo);
      }
      if (tableHarvestArr.length === 0) {
        if ((ref2 = this.grid) != null) {
          ref2.setEmptyMessage(App.RedesignCacheMainController.CACHE_NO_TABLES);
        }
      }
      return tableHarvestArr;
    };

    RedesignCacheMainController.prototype.clearHighlightedRow = function() {};

    RedesignCacheMainController.prototype.search = function(searchTerm) {
      return this.panelCtrl.search(searchTerm);
    };

    RedesignCacheMainController.prototype.release = function() {
      var controller, name, ref;
      this.harvestObject.unbind('change', this.renderTableHarvestRows);
      clearInterval(this.statusUpdateInterval);
      ref = this.cacheSettingsHarvestControllers;
      for (name in ref) {
        controller = ref[name];
        controller.release();
      }
      delete this.cacheSettingsHarvestControllers;
      return RedesignCacheMainController.__super__.release.apply(this, arguments);
    };

    RedesignCacheMainController.prototype.getHarvestFromEvent = function(event) {
      var row, rowEl;
      rowEl = $(event.target).closest('.sg-row');
      row = rowEl != null ? rowEl.data('row') : void 0;
      return row != null ? row[App.RedesignSimpleGridController.OBJECT_FIELD] : void 0;
    };

    RedesignCacheMainController.prototype.reloadTableHarvest = function(event) {
      var action, harvest, method, object, objectId, ref;
      harvest = this.getHarvestFromEvent(event);
      objectId = harvest != null ? harvest.id : void 0;
      if (!objectId) {
        return;
      }
      if ((ref = this.database) != null ? ref.isSalesforceDatabase() : void 0) {
        action = 'full_refresh';
        method = 'put';
        object = 'salesforce_object_harvests';
      } else {
        action = 'full_refresh';
        method = 'post';
        object = 'table_harvests';
      }
      return jQuery.ajax({
        method: method,
        url: "/" + object + "/" + objectId + "/" + action
      }).done(this.applyResponseHarvest);
    };

    RedesignCacheMainController.prototype.applyResponseHarvest = function(response) {
      if ((response != null ? response.harvest : void 0) == null) {
        return;
      }
      return this.harvestObject.applyUpdates([response.harvest]);
    };

    RedesignCacheMainController.prototype.updateHarvestStatus = function(row, tableHarvest) {
      var cacheIcon, status;
      status = this.statusForHarvest(tableHarvest);
      row.find('.cache-status-text').text(status.text);
      cacheIcon = row.find('.cache-status-icon');
      cacheIcon.removeClass();
      return cacheIcon.addClass("cache-status-icon cache-status-" + status.state);
    };

    RedesignCacheMainController.prototype.updateHarvestStatuses = function() {
      var i, len, ref, results, row, rowEl, tableHarvest;
      ref = this.grid.el.find('.sg-body .sg-row');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        rowEl = ref[i];
        row = $(rowEl);
        tableHarvest = this.harvestObject.exists(row.attr('harvest_id'));
        if (!tableHarvest) {
          continue;
        }
        results.push(this.updateHarvestStatus(row, tableHarvest));
      }
      return results;
    };

    RedesignCacheMainController.prototype.statusForHarvest = function(th) {
      return this.newStatusForHarvest(th);
    };

    RedesignCacheMainController.prototype.newStatusForHarvest = function(th) {
      if (!((th != null) && th.exists())) {
        return {
          text: 'Uncached',
          state: 'uncached'
        };
      }
      return {
        text: new App.HarvestState(th).prettyHarvestState(),
        state: this.statusClassForHarvest(th)
      };
    };

    RedesignCacheMainController.prototype.statusClassForHarvest = function(th) {
      var harvestState;
      harvestState = new App.HarvestState(th);
      if (harvestState.hasData()) {
        if (harvestState.hasError()) {
          return 'has-data-has-error';
        } else {
          return 'has-data-no-error';
        }
      } else if (!harvestState.hasData()) {
        if (harvestState.hasError()) {
          return 'no-data-has-error';
        } else {
          return 'no-data-no-error';
        }
      }
    };

    RedesignCacheMainController.prototype.oldStatusForHarvest = function(th) {
      var displayStatus;
      if (!((th != null) && th.exists())) {
        return {
          text: 'Uncached',
          state: 'uncached'
        };
      }
      displayStatus = {
        text: new App.HarvestState(th).prettyHarvestState()
      };
      displayStatus.state = (function() {
        switch (th.status()) {
          case 'permission-denied':
            return 'failed';
          case 'waiting':
          case 'warning':
            return 'cached';
          case 'failed':
            return 'failed';
          case 'queued':
            return 'cached';
          case 'running':
            return 'caching';
          default:
            return th.status();
        }
      })();
      if (th.pretty_error != null) {
        displayStatus.state = 'warning';
      }
      return displayStatus;
    };

    return RedesignCacheMainController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignCacheStrategyController = (function(superClass) {
    extend(RedesignCacheStrategyController, superClass);

    RedesignCacheStrategyController.prototype.elements = {
      '.cache-strategy-body': 'cacheStrategyBody',
      '.cache-strategy': 'cacheStrategy',
      '.import-column': 'importColumn',
      '.import-column-for-bounded-update': 'importColumnForBoundedUpdate',
      '.import-column-for-full-only-and-redshift': 'importColumnForFullOnlyAndRedshift',
      '.update-interval': 'updateInterval',
      '.diff-interval': 'diffInterval',
      '.update-window': 'updateWindow',
      '.incremental-update-interval': 'incrementalUpdateInterval',
      '.cache-strategy-dropdown': 'cacheStrategyDropdown',
      '.import-column-dropdown': 'importColumnDropdown',
      '.import-column-for-bounded-update-dropdown': 'importColumnForBoundedUpdateDropdown',
      '.import-column-for-full-only-and-redshift-dropdown': 'importColumnForFullOnlyAndRedshiftDropdown',
      '.update-interval-dropdown': 'updateIntervalDropdown',
      '.diff-interval-dropdown': 'diffIntervalDropdown',
      '.update-window-dropdown': 'updateWindowDropdown',
      '.unique-id-column-dropdown': 'uniqueIdColumnDropdown',
      '.incremental-update-interval-dropdown': 'incrementalUpdateIntervalDropdown',
      '.cache-strategy-block.full-update': 'fullUpdate',
      '.cache-strategy-block.unique-id-column': 'uniqueIdColumn',
      '.full-update-interval': 'fullUpdateInterval',
      '.full-update-interval-dropdown': 'fullUpdateIntervalDropdown',
      '.full-update-schedule': 'fullUpdateSchedule',
      '.full-update-schedule-hour-dropdown': 'fullUpdateScheduleHourDropdown',
      '.full-update-schedule-min-dropdown': 'fullUpdateScheduleMinDropdown',
      '.full-update .interval.radio-button': 'fullUpdateIntervalRadioButton',
      '.full-update .schedule.radio-button': 'fullUpdateScheduleRadioButton',
      '.cache-strategy-block.toggler-container': 'cacheEnabledTogglerContainer',
      '.cache-strategy-block .toggler': 'cacheEnabledToggler',
      '.cache-strategy-block .ball': 'cacheEnabledTogglerBall',
      '.status-block': 'statusBlock',
      '.button-row.save': 'buttonRowSave',
      '.save .save.button': 'saveButton',
      '.save .cancel.button': 'cancelButton',
      '.button-row .inert.button': 'uncacheButton',
      '.button-row.confirm-uncache': 'buttonRowUncache',
      '.last-checked': 'lastChecked',
      '.last-incremental-update': 'lastIncrementalUpdate',
      '.last-incremental-runtime': 'lastIncrementalRuntime',
      '.last-full-update': 'lastFullUpdate',
      '.last-full-runtime': 'lastFullRuntime',
      '.last-update': 'lastUpdate',
      '.last-runtime': 'lastRuntime',
      '.last-incremental-row': 'lastIncrementalRow',
      '.last-full-row': 'lastFullRow',
      '.last-update-row': 'lastUpdateRow',
      '.modified-date': 'modifiedDate',
      '.modified-date-dropdown': 'modifiedDateDropdown',
      '.modified-null': 'modifiedNullContainer',
      '.created-date': 'createdDate',
      '.created-date-dropdown': 'createdDateDropdown'
    };

    RedesignCacheStrategyController.prototype.events = {
      'change .cache-strategy-dropdown': 'changeCacheStrategy',
      'click .full-update .interval.radio-button': 'clickFullUpdateInterval',
      'click .full-update .schedule.radio-button': 'clickFullUpdateSchedule',
      'click .cache-strategy-block .toggler.square': 'clickSuspendCaching',
      'click .chosen-container': 'clickCacheDropdown',
      'click .save .uncache-text.button': 'clickUncacheLink',
      'click .save .cancel.button': 'clickCancelButton',
      'click .save .save.button': 'clickSaveButton',
      'click .confirm-uncache .cancel.button': 'clickUncacheCancelButton',
      'click .confirm-uncache .confirm.button': 'clickUncacheConfirmButton',
      'change .import-column-dropdown': 'changeImportColumn',
      'change .import-column-for-full-only-and-redshift-dropdown': 'changeImportColumnForFullOnlyAndRedshift',
      'change .import-column-for-bounded-update-dropdown': 'changeImportColumnForBoundedUpdate',
      'change .unique-id-column-dropdown': 'changeUniqueIdColumn',
      'change .modified-date-dropdown': 'changeModifiedDate',
      'change .created-date-dropdown': 'changeCreatedDate',
      'change .full-update-interval-dropdown': 'changeFullUpdateIntervalDropdown',
      'change .full-update-schedule-hour-dropdown': 'changeFullUpdateScheduleHourDropdown',
      'change .full-update-schedule-min-dropdown': 'changeFullUpdateScheduleMinDropdown',
      'change .update-window-dropdown': 'changeUpdateWindowDropdown',
      'change .update-interval-dropdown': 'changeUpdateIntervalDropdown',
      'change .diff-interval-dropdown': 'changeDiffIntervalDropdown',
      'change .incremental-update-interval-dropdown': 'changeIncrementalUpdateIntervalDropdown'
    };

    RedesignCacheStrategyController.SAVE_BUTTON_DISABLE_CLASS = 'disabled allow-pointers';

    function RedesignCacheStrategyController() {
      this.clickSaveButton = bind(this.clickSaveButton, this);
      this.clickCancelButton = bind(this.clickCancelButton, this);
      this.enableButtons = bind(this.enableButtons, this);
      this.updateModifiedNullCheckboxStateAndEnableButton = bind(this.updateModifiedNullCheckboxStateAndEnableButton, this);
      this.updateModifiedNullCheckboxState = bind(this.updateModifiedNullCheckboxState, this);
      this.setFullUpdateInterval = bind(this.setFullUpdateInterval, this);
      this.destroyTableHarvest = bind(this.destroyTableHarvest, this);
      this.cancelTableHarvest = bind(this.cancelTableHarvest, this);
      this.saveTableHarvest = bind(this.saveTableHarvest, this);
      var ref, ref1;
      RedesignCacheStrategyController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'row');
      this.tableHarvest = App.RedesignCacheControllerHelper.setTableHarvestFromItem(this.item);
      this.html(this.view("redesign/settings/cache_strategy")({
        isDiffStrategy: (ref = this.tableHarvest) != null ? ref.uses_diff_strategy : void 0,
        suspendCaching: this.suspendCaching((ref1 = this.tableHarvest) != null ? ref1.disabled_at : void 0)
      }));
      this.database = App.Database.find(this.database_id);
      this.fullName = this.row.schema_name + "." + this.row.table_name;
      this.render();
    }

    RedesignCacheStrategyController.prototype.setHarvestAndRender = function() {
      this.tableHarvest = App.RedesignCacheControllerHelper.setTableHarvestFromItem(this.item);
      return this.render();
    };

    RedesignCacheStrategyController.prototype.render = function() {
      var ref, ref1, unsavedHarvest, yoinkStrategy;
      unsavedHarvest = this.tableHarvest == null;
      this.maybeHideStatus(unsavedHarvest);
      this.tableColumns = this.getTableColumns(this.fullName, this.database);
      if (this.tableHarvest == null) {
        this.tableHarvest = this.newTableHarvest(this.tableColumns);
      }
      yoinkStrategy = this.tableHarvest.getSavedStrategy();
      this.populateDropdowns(this.tableHarvest, this.tableColumns);
      this.createChosenDropdowns(this.tableHarvest);
      this.createCheckboxComponent(this.tableHarvest);
      this.setDropdownDefaults(this.tableHarvest);
      this.showDropdownsAndCheckboxes(yoinkStrategy, (ref = this.tableHarvest) != null ? ref.full_harvest_custom_schedule : void 0);
      this.setEnabledToggle(unsavedHarvest, (ref1 = this.tableHarvest) != null ? ref1.disabled_at : void 0);
      this.updateTimestamps(this.tableHarvest, yoinkStrategy);
      this.maybeDisableUncache();
      return this.showButtonTooltips();
    };

    RedesignCacheStrategyController.prototype.createCheckboxComponent = function(harvest) {
      if (this.modifiedNullCheckbox != null) {
        this.modifiedNullCheckbox.toggleSelected(!!harvest.updated_at_can_be_null);
      } else {
        this.modifiedNullCheckbox = new App.RedesignCheckbox({
          labelText: 'Modified Date is null on row insert',
          initialState: harvest.updated_at_can_be_null,
          callback: this.updateModifiedNullCheckboxStateAndEnableButton
        });
        this.modifiedNullContainer.prepend(this.modifiedNullCheckbox.el);
      }
      return this.updateModifiedNullCheckboxState(this.modifiedNullCheckbox.state());
    };

    RedesignCacheStrategyController.prototype.maybeDisableUncache = function() {
      var ref, status;
      status = (ref = this.tableHarvest) != null ? ref.status() : void 0;
      if ((status != null) && status === 'running') {
        return this.uncacheButton.addClass('disabled');
      } else {
        return this.uncacheButton.removeClass('disabled');
      }
    };

    RedesignCacheStrategyController.prototype.newTableHarvest = function(tableColumns) {
      var harvest;
      harvest = this.isSalesforceHarvest() ? new App.SalesforceObjectHarvest({
        salesforce_database_id: this.database.specific_database_id,
        harvest_interval_seconds: 0
      }) : new App.TableHarvest({
        schema_name: this.row.schema_name,
        harvest_interval_seconds: 15 * 60
      });
      harvest.database_id = this.database.id;
      harvest.table_name = this.row.table_name;
      harvest.full_harvest_interval_seconds = 8 * 60 * 60;
      return harvest;
    };

    RedesignCacheStrategyController.prototype.release = function() {
      return RedesignCacheStrategyController.__super__.release.apply(this, arguments);
    };

    RedesignCacheStrategyController.prototype.saveTableHarvest = function() {
      if (this.cacheStrategyDropdown.val() === '') {
        return this.destroyTableHarvest();
      }
      this.tableHarvest.save({
        ajax: true
      });
      return this.setEnabledToggle(false, this.tableHarvest.disabled_at);
    };

    RedesignCacheStrategyController.prototype.setIfDisplayed = function(parentElement, dropdown, defaultValue) {
      if (!parentElement.is(':visible')) {
        return defaultValue;
      }
      return parseInt(dropdown.val());
    };

    RedesignCacheStrategyController.prototype.cancelTableHarvest = function() {
      return this.setHarvestAndRender();
    };

    RedesignCacheStrategyController.prototype.destroyTableHarvest = function() {
      var ref;
      if (((ref = this.tableHarvest) != null ? ref.id : void 0) != null) {
        this.tableHarvest.destroy({
          ajax: true
        });
      }
      this.tableHarvest = void 0;
      return this.render();
    };

    RedesignCacheStrategyController.prototype.isSwitchingBetweenFullAndIncremental = function(nextStrategy) {
      return (this.tableHarvest.isFullOnly() || this.tableHarvest.isIncrementalOnly() || this.tableHarvest.isFullAndIncremental()) && (nextStrategy === App.TableHarvest.STRATEGIES.FULL_ONLY || nextStrategy === App.TableHarvest.STRATEGIES.INCREMENTAL_ONLY || nextStrategy === App.TableHarvest.STRATEGIES.FULL_AND_INCREMENTAL);
    };

    RedesignCacheStrategyController.prototype.isSwitchingBetweenBoundedAndModified = function(nextStrategy) {
      return (this.tableHarvest.isModifiedOnly() || this.tableHarvest.isBoundedUpdates()) && (nextStrategy === App.TableHarvest.STRATEGIES.MODIFIED_ONLY || nextStrategy === App.TableHarvest.STRATEGIES.BOUNDED_UPDATES);
    };

    RedesignCacheStrategyController.prototype.shouldReuseIngestKey = function(nextStrategy) {
      if (this.isSalesforceHarvest()) {
        return false;
      }
      return this.isSwitchingBetweenFullAndIncremental(nextStrategy) || this.isSwitchingBetweenBoundedAndModified(nextStrategy);
    };

    RedesignCacheStrategyController.prototype.changeCacheStrategy = function() {
      var interval, range, strategy;
      strategy = this.cacheStrategyDropdown.val();
      this.tableHarvest.set({
        'full_harvest_custom_schedule': null,
        'harvest_interval_seconds': null
      });
      this.showDropdownsAndCheckboxes(strategy, this.tableHarvest.full_harvest_custom_schedule);
      if (!this.shouldReuseIngestKey(strategy)) {
        this.tableHarvest.set({
          'ingest_key': null
        });
      }
      if (strategy === App.TableHarvest.STRATEGIES.MODIFIED_ONLY) {
        this.tableHarvest.set({
          'next_full_harvest_at': null,
          'update_harvest_interval_seconds': 0,
          'uses_diff_strategy': true,
          'clientSideStrategy': strategy
        });
      } else {
        this.tableHarvest.set({
          'unique_id_column': null,
          'update_harvest_interval_seconds': this.setIfDisplayed(this.updateInterval, this.updateIntervalDropdown, 0),
          'uses_diff_strategy': false,
          'clientSideStrategy': strategy
        });
      }
      if (this.tableHarvest.isFullOnly() || this.tableHarvest.isFullAndIncremental()) {
        this.setFullUpdateInterval();
      } else {
        this.tableHarvest.set({
          'full_harvest_interval_seconds': 0
        });
      }
      if (this.tableHarvest.isIncrementalOnly() || this.tableHarvest.isFullAndIncremental()) {
        interval = this.setIfDisplayed(this.incrementalUpdateInterval, this.incrementalUpdateIntervalDropdown, 0);
        this.tableHarvest.set({
          'harvest_interval_seconds': interval
        });
      }
      if (this.tableHarvest.isBoundedUpdates()) {
        range = this.setIfDisplayed(this.updateWindow, this.updateWindowDropdown, 0);
        this.tableHarvest.set({
          'update_date_range': range
        });
      }
      if (this.tableHarvest.isModifiedOnly()) {
        interval = parseInt(this.diffIntervalDropdown.val());
        this.tableHarvest.set({
          'harvest_interval_seconds': interval
        });
      }
      this.populateColumnDropdowns(this.tableHarvest, this.tableColumns);
      this.setDropdownDefaults();
      if (strategy === '') {
        return this.enableButtons();
      } else {
        return this.toggleButtons();
      }
    };

    RedesignCacheStrategyController.prototype.changeImportColumn = function() {
      this.tableHarvest.set({
        'ingest_key': this.importColumnDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeImportColumnForBoundedUpdate = function() {
      this.tableHarvest.set({
        'ingest_key': this.importColumnForBoundedUpdateDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeImportColumnForFullOnlyAndRedshift = function() {
      this.tableHarvest.set({
        'ingest_key': this.importColumnForFullOnlyAndRedshiftDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeUniqueIdColumn = function() {
      this.tableHarvest.set({
        'unique_id_column': this.uniqueIdColumnDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeModifiedDate = function() {
      this.tableHarvest.set({
        'ingest_key': this.modifiedDateDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeCreatedDate = function() {
      this.tableHarvest.set({
        'created_at_column': this.createdDateDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeFullUpdateIntervalDropdown = function() {
      this.setFullUpdateInterval();
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeFullUpdateScheduleHourDropdown = function() {
      this.setCustomSchedule();
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeFullUpdateScheduleMinDropdown = function() {
      this.setCustomSchedule();
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.setFullUpdateInterval = function() {
      var dropdownValue;
      dropdownValue = this.setIfDisplayed(this.fullUpdateInterval, this.fullUpdateIntervalDropdown, 0);
      this.tableHarvest.set({
        'full_harvest_interval_seconds': dropdownValue,
        'full_harvest_custom_schedule': null
      });
      if (this.tableHarvest.isFullOnly()) {
        return this.tableHarvest.set({
          'harvest_interval_seconds': dropdownValue
        });
      }
    };

    RedesignCacheStrategyController.prototype.setCustomSchedule = function() {
      var customSchedule, hour, min, oldHour, oldMin, oldSchedule;
      if (this.tableHarvest.full_harvest_custom_schedule != null) {
        oldSchedule = this.tableHarvest.full_harvest_custom_schedule.split(':');
      }
      oldHour = oldSchedule != null ? oldSchedule[0] : void 0;
      hour = this.setIfDisplayed(this.fullUpdateSchedule, this.fullUpdateScheduleHourDropdown, void 0);
      oldMin = oldSchedule != null ? oldSchedule[1] : void 0;
      min = this.setIfDisplayed(this.fullUpdateSchedule, this.fullUpdateScheduleMinDropdown, void 0);
      if (hour != null) {
        if (min != null) {
          customSchedule = hour + ":" + min;
        } else if (oldMin != null) {
          customSchedule = hour + ":" + oldMin;
        }
      } else if (oldHour != null) {
        if (min != null) {
          customSchedule = oldHour + ":" + min;
        } else if (oldMin != null) {
          customSchedule = oldHour + ":" + oldMin;
        }
      }
      this.tableHarvest.set({
        'full_harvest_custom_schedule': customSchedule
      });
      if (!this.tableHarvest.isFullAndIncremental()) {
        this.tableHarvest.set({
          'harvest_interval_seconds': null
        });
      }
      if (!this.isSalesforceHarvest()) {
        return this.tableHarvest.set({
          'full_harvest_interval_seconds': 0
        });
      }
    };

    RedesignCacheStrategyController.prototype.changeUpdateWindowDropdown = function() {
      var dropdownValue;
      dropdownValue = this.setIfDisplayed(this.updateWindow, this.updateWindowDropdown, 0);
      this.tableHarvest.set({
        'update_date_range': dropdownValue
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeUpdateIntervalDropdown = function() {
      this.tableHarvest.set({
        'update_harvest_interval_seconds': this.updateIntervalDropdown.val(),
        'harvest_interval_seconds': this.updateIntervalDropdown.val()
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeDiffIntervalDropdown = function() {
      this.tableHarvest.set({
        'harvest_interval_seconds': parseInt(this.diffIntervalDropdown.val())
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.changeIncrementalUpdateIntervalDropdown = function() {
      this.tableHarvest.set({
        'harvest_interval_seconds': parseInt(this.incrementalUpdateIntervalDropdown.val())
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.maybeUpdateRadioButton = function(clickedRadio, previousRadio, clickedDropdown, previousDropdown) {
      if (clickedRadio.hasClass('selected')) {
        return;
      }
      clickedRadio.addClass('selected');
      clickedDropdown.show();
      previousRadio.removeClass('selected');
      previousDropdown.hide();
      return this.tableHarvest.set({
        'full_update_changed': true
      });
    };

    RedesignCacheStrategyController.prototype.switchToScheduledUpdates = function() {
      this.maybeUpdateRadioButton(this.fullUpdateScheduleRadioButton, this.fullUpdateIntervalRadioButton, this.fullUpdateSchedule, this.fullUpdateInterval);
      return this.setCustomSchedule();
    };

    RedesignCacheStrategyController.prototype.switchToIntervalUpdates = function() {
      this.maybeUpdateRadioButton(this.fullUpdateIntervalRadioButton, this.fullUpdateScheduleRadioButton, this.fullUpdateInterval, this.fullUpdateSchedule);
      return this.setFullUpdateInterval();
    };

    RedesignCacheStrategyController.prototype.clickFullUpdateInterval = function() {
      this.switchToIntervalUpdates();
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.clickFullUpdateSchedule = function() {
      this.switchToScheduledUpdates();
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.clickSuspendCaching = function() {
      var disabledAtValue;
      if (this.cacheEnabledToggler.hasClass('disabled')) {
        return;
      }
      this.cacheEnabledTogglerBall.toggleClass('on');
      disabledAtValue = this.cacheEnabledTogglerBall.hasClass('on') ? true : void 0;
      this.tableHarvest.set({
        'disabled_at': disabledAtValue
      });
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.clickCacheDropdown = function() {
      return $(this.cacheStrategyBody)[0].scrollTop = $(this.cacheStrategyBody)[0].scrollHeight;
    };

    RedesignCacheStrategyController.prototype.setEnabledToggle = function(unsavedHarvest, disabled_at) {
      this.cacheEnabledTogglerBall.toggleClass('on', this.suspendCaching(disabled_at));
      this.cacheEnabledToggler.toggleClass('disabled', unsavedHarvest);
      return this.cacheEnabledTogglerContainer.toggleClass('disabled', unsavedHarvest);
    };

    RedesignCacheStrategyController.prototype.suspendCaching = function(disabled_at) {
      return (disabled_at != null) === true;
    };

    RedesignCacheStrategyController.prototype.showDropdownsAndCheckboxes = function(yoinkStrategy, full_harvest_custom_schedule) {
      var strategySet;
      this.importColumn.show();
      this.importColumnForBoundedUpdate.hide();
      this.importColumnForFullOnlyAndRedshift.hide();
      this.updateInterval.hide();
      this.diffInterval.hide();
      this.updateWindow.hide();
      this.fullUpdate.hide();
      this.incrementalUpdateInterval.hide();
      this.uniqueIdColumn.hide();
      strategySet = (yoinkStrategy != null ? yoinkStrategy.length : void 0) > 0;
      this.importColumn.toggle(strategySet);
      this.cacheEnabledTogglerContainer.toggle(strategySet);
      this.modifiedDate.hide();
      this.modifiedNullContainer.hide();
      switch (yoinkStrategy) {
        case 'incremental-only':
          this.incrementalUpdateInterval.show();
          break;
        case 'full-only':
          this.fullUpdate.show();
          if (this.database.isRedshift()) {
            this.importColumn.hide();
            this.importColumnForFullOnlyAndRedshift.show();
          }
          break;
        case 'full-and-incremental':
          this.incrementalUpdateInterval.show();
          this.fullUpdate.show();
          break;
        case 'update':
          this.importColumn.hide();
          this.importColumnForBoundedUpdate.show();
          this.updateInterval.show();
          this.updateWindow.show();
          break;
        case 'diff':
          this.importColumn.hide();
          this.uniqueIdColumn.show();
          this.modifiedDate.show();
          this.diffInterval.show();
          this.modifiedNullContainer.show();
      }
      if (yoinkStrategy === 'full-only' || yoinkStrategy === 'full-and-incremental') {
        if (full_harvest_custom_schedule != null) {
          this.switchToScheduledUpdates();
        } else {
          this.switchToIntervalUpdates();
        }
      }
      if (this.isSalesforceHarvest()) {
        return this.importColumn.hide();
      }
    };

    RedesignCacheStrategyController.prototype.updateModifiedNullCheckboxState = function(isChecked) {
      this.createdDate.toggle(isChecked);
      return this.tableHarvest.updated_at_can_be_null = isChecked;
    };

    RedesignCacheStrategyController.prototype.updateModifiedNullCheckboxStateAndEnableButton = function(isChecked) {
      this.updateModifiedNullCheckboxState(isChecked);
      return this.toggleButtons();
    };

    RedesignCacheStrategyController.prototype.getTableColumns = function(fullName, database) {
      var info;
      if (database == null) {
        return [];
      }
      info = database.getTableNamesWithColumnInfo(fullName.replace(/^public\./, "")).first();
      if (info == null) {
        return [];
      }
      return info.columns;
    };

    RedesignCacheStrategyController.prototype.rowCount = function() {
      return App.RedesignCacheControllerHelper.tableNameRowCount(this.database, this.fullName);
    };

    RedesignCacheStrategyController.prototype.optionsToHtml = function(dropdownEl, list, chosenVal) {
      return dropdownEl.html(App.Utils.optionsToHtml(list, chosenVal));
    };

    RedesignCacheStrategyController.prototype.optionsToHtmlWithNone = function(dropdownEl, list, chosenVal) {
      return dropdownEl.html(App.Utils.optionsToHtmlWithNone(list, chosenVal));
    };

    RedesignCacheStrategyController.prototype.optionsToHtmlWithPlaceholder = function(dropdownEl, list) {
      return dropdownEl.html(App.Utils.optionsToHtmlWithPlaceholder(list));
    };

    RedesignCacheStrategyController.prototype.optionsToHtmlWithNoneAndPlaceholder = function(dropdownEl, list) {
      return dropdownEl.html(App.Utils.optionsToHtmlWithNoneAndPlaceholder(list));
    };

    RedesignCacheStrategyController.prototype.populateDropdownWithOptionalPlaceholder = function(element, options, value) {
      if (value != null) {
        return this.optionsToHtml(element, options, value);
      } else {
        return this.optionsToHtmlWithPlaceholder(element, options);
      }
    };

    RedesignCacheStrategyController.prototype.populateDropdownWithNoneAndOptionalPlaceholder = function(element, options, value) {
      if (value != null) {
        return this.optionsToHtmlWithNone(element, options, value);
      } else {
        return this.optionsToHtmlWithNoneAndPlaceholder(element, options);
      }
    };

    RedesignCacheStrategyController.prototype.createChosenDropdowns = function() {
      var dropdownOptions;
      dropdownOptions = {
        width: '317px',
        disable_search: true
      };
      this.cacheStrategyDropdown.chosen(dropdownOptions);
      this.importColumnDropdown.chosen(dropdownOptions);
      this.importColumnForBoundedUpdateDropdown.chosen(dropdownOptions);
      this.importColumnForFullOnlyAndRedshiftDropdown.chosen(dropdownOptions);
      this.updateIntervalDropdown.chosen(dropdownOptions);
      this.diffIntervalDropdown.chosen(dropdownOptions);
      this.updateWindowDropdown.chosen(dropdownOptions);
      this.incrementalUpdateIntervalDropdown.chosen(dropdownOptions);
      this.uniqueIdColumnDropdown.chosen(dropdownOptions);
      this.modifiedDateDropdown.chosen(dropdownOptions);
      this.createdDateDropdown.chosen(dropdownOptions);
      this.fullUpdateIntervalDropdown.chosen({
        width: '150px',
        display: 'block',
        disable_search: true
      });
      this.fullUpdateScheduleHourDropdown.chosen({
        width: '70px',
        disable_search: true
      });
      return this.fullUpdateScheduleMinDropdown.chosen({
        width: '70px',
        disable_search: true
      });
    };

    RedesignCacheStrategyController.prototype.setDropdownDefaults = function(tableHarvest) {
      this.cacheStrategyDropdown.trigger('chosen:updated');
      this.incrementalUpdateIntervalDropdown.trigger('chosen:updated');
      this.fullUpdateIntervalDropdown.trigger('chosen:updated');
      this.fullUpdateScheduleHourDropdown.trigger('chosen:updated');
      this.fullUpdateScheduleMinDropdown.trigger('chosen:updated');
      this.importColumnDropdown.trigger('chosen:updated');
      this.importColumnForBoundedUpdateDropdown.trigger('chosen:updated');
      this.importColumnForFullOnlyAndRedshiftDropdown.trigger('chosen:updated');
      this.updateIntervalDropdown.trigger('chosen:updated');
      this.diffIntervalDropdown.trigger('chosen:updated');
      this.updateWindowDropdown.trigger('chosen:updated');
      this.uniqueIdColumnDropdown.trigger('chosen:updated');
      this.modifiedDateDropdown.trigger('chosen:updated');
      return this.createdDateDropdown.trigger('chosen:updated');
    };

    RedesignCacheStrategyController.prototype.populateDropdowns = function(tableHarvest, tableColumns) {
      var yoinkStrategy;
      yoinkStrategy = tableHarvest.getSavedStrategy();
      this.optionsToHtml(this.cacheStrategyDropdown, App.RedesignCacheControllerHelper.optionsForStrategy(this.database), yoinkStrategy);
      return this.populateColumnDropdowns(tableHarvest, tableColumns);
    };

    RedesignCacheStrategyController.prototype.populateColumnDropdowns = function(tableHarvest, tableColumns) {
      this.populateFull(tableHarvest, tableColumns);
      this.populateIncremental(tableHarvest, tableColumns);
      this.populateCustomSchedule(tableHarvest);
      this.populateBoundedUpdates(tableHarvest, tableColumns);
      return this.populateDiffUpdates(tableHarvest, tableColumns);
    };

    RedesignCacheStrategyController.prototype.populateDiffUpdates = function(tableHarvest, tableColumns) {
      var optionsForDiffIngestKey, optionsForDiffInterval, optionsForIdColumn;
      optionsForIdColumn = App.RedesignCacheControllerHelper.optionsForIngestKey(tableColumns, 'diff-unique-id');
      optionsForDiffIngestKey = App.RedesignCacheControllerHelper.optionsForIngestKey(tableColumns, 'diff-import-column');
      this.populateDropdownWithOptionalPlaceholder(this.uniqueIdColumnDropdown, optionsForIdColumn, tableHarvest.unique_id_column);
      this.populateDropdownWithOptionalPlaceholder(this.modifiedDateDropdown, optionsForDiffIngestKey, tableHarvest.ingest_key);
      this.populateDropdownWithOptionalPlaceholder(this.createdDateDropdown, optionsForDiffIngestKey, tableHarvest.created_at_column);
      optionsForDiffInterval = App.RedesignCacheControllerHelper.optionsForHarvestInterval(tableHarvest.harvest_interval_seconds);
      return this.optionsToHtml(this.diffIntervalDropdown, optionsForDiffInterval, tableHarvest.harvest_interval_seconds);
    };

    RedesignCacheStrategyController.prototype.populateFull = function(tableHarvest, tableColumns) {
      var optionsForFullUpdateInterval, optionsForImportColumn;
      optionsForImportColumn = App.RedesignCacheControllerHelper.optionsForIngestKey(tableColumns, 'default');
      this.populateDropdownWithNoneAndOptionalPlaceholder(this.importColumnForFullOnlyAndRedshiftDropdown, optionsForImportColumn, tableHarvest.ingest_key);
      this.populateDropdownWithOptionalPlaceholder(this.importColumnDropdown, optionsForImportColumn, tableHarvest.ingest_key);
      optionsForFullUpdateInterval = App.RedesignCacheControllerHelper.optionsForFullHarvestInterval(tableHarvest.harvest_interval_seconds, tableHarvest.full_harvest_interval_seconds, this.rowCount(), this.isSalesforceHarvest());
      return this.optionsToHtml(this.fullUpdateIntervalDropdown, optionsForFullUpdateInterval, tableHarvest.full_harvest_interval_seconds);
    };

    RedesignCacheStrategyController.prototype.populateIncremental = function(tableHarvest, tableColumns) {
      var optionsForImportColumn, optionsForIncrementalUpdateInterval;
      optionsForImportColumn = App.RedesignCacheControllerHelper.optionsForIngestKey(tableColumns, 'default');
      this.populateDropdownWithOptionalPlaceholder(this.importColumnDropdown, optionsForImportColumn, tableHarvest.ingest_key);
      optionsForIncrementalUpdateInterval = App.RedesignCacheControllerHelper.optionsForHarvestInterval(tableHarvest.harvest_interval_seconds);
      return this.optionsToHtml(this.incrementalUpdateIntervalDropdown, optionsForIncrementalUpdateInterval, tableHarvest.harvest_interval_seconds);
    };

    RedesignCacheStrategyController.prototype.populateCustomSchedule = function(tableHarvest) {
      var optionsForHour, optionsForMin, updateSchedule;
      updateSchedule = this.parseCustomSchedule(tableHarvest.full_harvest_custom_schedule);
      optionsForHour = App.Utils.generateOptionsForNumbers(0, 23);
      this.optionsToHtml(this.fullUpdateScheduleHourDropdown, optionsForHour, updateSchedule.hour);
      optionsForMin = App.Utils.generateOptionsForNumbers(0, 59);
      return this.optionsToHtml(this.fullUpdateScheduleMinDropdown, optionsForMin, updateSchedule.minute);
    };

    RedesignCacheStrategyController.prototype.populateBoundedUpdates = function(tableHarvest, tableColumns) {
      var i, optionsForIngestColumn, optionsForUpdateInterval, updateWindowOptions;
      optionsForIngestColumn = App.RedesignCacheControllerHelper.optionsForIngestKey(tableColumns, 'update');
      this.populateDropdownWithOptionalPlaceholder(this.importColumnForBoundedUpdateDropdown, optionsForIngestColumn, tableHarvest.ingest_key);
      optionsForUpdateInterval = App.RedesignCacheControllerHelper.optionsForFullHarvestInterval(0, tableHarvest.update_harvest_interval_seconds, 0, this.isSalesforceHarvest());
      this.optionsToHtml(this.updateIntervalDropdown, optionsForUpdateInterval, tableHarvest.update_harvest_interval_seconds);
      updateWindowOptions = [
        {
          value: 1,
          name: '1 Day'
        }
      ].concat((function() {
        var j, results;
        results = [];
        for (i = j = 2; j <= 14; i = ++j) {
          results.push({
            value: i,
            name: i + " Days"
          });
        }
        return results;
      })());
      return this.optionsToHtml(this.updateWindowDropdown, updateWindowOptions, tableHarvest.update_date_range);
    };

    RedesignCacheStrategyController.prototype.isSalesforceHarvest = function() {
      var ref;
      return (ref = this.database) != null ? ref.isSalesforceDatabase() : void 0;
    };

    RedesignCacheStrategyController.prototype.parseCustomSchedule = function(str) {
      var schedule;
      if (str == null) {
        return {
          hour: 0,
          minute: 0
        };
      }
      schedule = str.split(':');
      return {
        hour: parseInt(schedule[0]),
        minute: parseInt(schedule[1])
      };
    };

    RedesignCacheStrategyController.prototype.maybeHideStatus = function(unsavedHarvest) {
      if (unsavedHarvest) {
        this.uncacheButton.hide();
        return this.statusBlock.hide();
      }
    };

    RedesignCacheStrategyController.prototype.toggleButtons = function() {
      this.cancelButton.toggleClass('disabled', !this.tableHarvest.hasChanged());
      this.saveButton.toggleClass(this.constructor.SAVE_BUTTON_DISABLE_CLASS, !this.tableHarvest.isValid());
      return this.saveButton.toggleClass(this.saveButtonTooltip.exitClass, this.tableHarvest.isValid());
    };

    RedesignCacheStrategyController.prototype.enableButtons = function() {
      this.cancelButton.removeClass('disabled');
      this.saveButton.removeClass(this.constructor.SAVE_BUTTON_DISABLE_CLASS);
      return this.saveButton.addClass(this.saveButtonTooltip.exitClass);
    };

    RedesignCacheStrategyController.prototype.disableButtons = function() {
      this.saveButton.addClass(this.constructor.SAVE_BUTTON_DISABLE_CLASS);
      return this.cancelButton.addClass('disabled');
    };

    RedesignCacheStrategyController.prototype.showButtonTooltips = function() {
      return this.saveButtonTooltip = new App.IconTooltipHelper({
        direction: App.RedesignTooltipPanel.BOTTOM,
        icon: this.saveButton,
        infoCallback: function() {
          return "Complete to save";
        },
        leftOffset: 40,
        topOffset: -3,
        tooltipClass: 'rhe-tooltip'
      });
    };

    RedesignCacheStrategyController.prototype.updateTimestamps = function(tableHarvest, yoinkStrategy) {
      this.lastChecked.text(App.RedesignCacheControllerHelper.lastUpdateText(tableHarvest != null ? tableHarvest.last_successful_harvest_at : void 0));
      this.lastIncrementalUpdate.text(App.RedesignCacheControllerHelper.lastUpdateText(tableHarvest != null ? tableHarvest.last_successful_incremental_harvest_at : void 0));
      this.lastIncrementalRuntime.text(App.RedesignCacheControllerHelper.lastRuntimeText(tableHarvest != null ? tableHarvest.last_incremental_harvest_msec : void 0));
      this.lastFullUpdate.text(App.RedesignCacheControllerHelper.lastUpdateText(tableHarvest != null ? tableHarvest.last_successful_full_harvest_at : void 0));
      this.lastFullRuntime.text(App.RedesignCacheControllerHelper.lastRuntimeText(tableHarvest != null ? tableHarvest.last_full_harvest_msec : void 0));
      this.lastUpdate.text(App.RedesignCacheControllerHelper.lastUpdateText(tableHarvest != null ? tableHarvest.last_successful_harvest_at : void 0));
      this.lastRuntime.text(App.RedesignCacheControllerHelper.lastRuntimeText(tableHarvest != null ? tableHarvest.last_harvest_msec : void 0));
      if (yoinkStrategy === 'full-only') {
        this.lastIncrementalRow.hide();
      }
      if (yoinkStrategy === 'diff') {
        this.lastIncrementalRow.hide();
        return this.lastFullRow.hide();
      } else {
        return this.lastUpdateRow.hide();
      }
    };

    RedesignCacheStrategyController.prototype.clickUncacheLink = function() {
      this.buttonRowSave.hide();
      return this.buttonRowUncache.show();
    };

    RedesignCacheStrategyController.prototype.clickCancelButton = function() {
      if (this.cancelButton.hasClass('disabled')) {
        return;
      }
      this.cancelTableHarvest();
      return this.disableButtons();
    };

    RedesignCacheStrategyController.prototype.clickSaveButton = function() {
      if (this.saveButton.hasClass(this.constructor.SAVE_BUTTON_DISABLE_CLASS)) {
        return;
      }
      this.saveTableHarvest();
      this.disableButtons();
      return this.uncacheButton.show();
    };

    RedesignCacheStrategyController.prototype.clickUncacheCancelButton = function() {
      this.buttonRowUncache.hide();
      return this.buttonRowSave.show();
    };

    RedesignCacheStrategyController.prototype.clickUncacheConfirmButton = function() {
      this.buttonRowUncache.hide();
      this.buttonRowSave.show();
      this.uncacheButton.hide();
      this.destroyTableHarvest();
      return this.updateTimestamps(null);
    };

    return RedesignCacheStrategyController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClusterInfoSettingsController = (function(superClass) {
    extend(ClusterInfoSettingsController, superClass);

    ClusterInfoSettingsController.APPLIES_TO_ALL_SPACES = false;

    ClusterInfoSettingsController.TITLE = 'Cluster Info';

    ClusterInfoSettingsController.prototype.className = 'cluster-info two-column settings-area';

    ClusterInfoSettingsController.prototype.elements = {
      '.cluster-info': 'clusterInfoContainer'
    };

    function ClusterInfoSettingsController() {
      ClusterInfoSettingsController.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/settings/cluster_info')());
      this.showClusterInfo();
    }

    ClusterInfoSettingsController.prototype.showClusterInfo = function() {
      App.Utils.logFeature("cluster-info-tab-opened");
      return this.reactRoot = window.reactApp.clusterInfoRoot(this.clusterInfoContainer[0]);
    };

    ClusterInfoSettingsController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return ClusterInfoSettingsController.__super__.release.apply(this, arguments);
    };

    return ClusterInfoSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ConnectorIngestionController = (function(superClass) {
    extend(ConnectorIngestionController, superClass);

    ConnectorIngestionController.prototype.className = 'connector-ingestion-settings';

    ConnectorIngestionController.APPLIES_TO_ALL_SPACES = false;

    ConnectorIngestionController.TITLE = 'App Connections';

    function ConnectorIngestionController() {
      this.loadedSources = bind(this.loadedSources, this);
      this.loadedDependencies = bind(this.loadedDependencies, this);
      ConnectorIngestionController.__super__.constructor.apply(this, arguments);
      this.info_hash = {};
      this.loadDependencies();
      ConnectorIngestionController.setConnectorIngestionOpen();
    }

    ConnectorIngestionController.prototype.loadDependencies = function() {
      var loadSources;
      loadSources = jQuery.get("/saas_ingestion/sources", {
        client_site_id: App.Site.first().id
      });
      return jQuery.when(loadSources).done(this.loadedDependencies);
    };

    ConnectorIngestionController.prototype.loadedDependencies = function(response) {
      this.loadedSources(response);
      return this.reactRoot = window.reactApp.connectorIngestionRoot(this.el[0], this.info_hash);
    };

    ConnectorIngestionController.prototype.loadedSources = function(response) {
      this.info_hash['sources'] = response.ConnectorIngestionSource;
      return this.info_hash['initialAction'] = response.init;
    };

    ConnectorIngestionController.connectorIngestionIsOpen = function() {
      return $('body').data('in-connector-ingestion') === true;
    };

    ConnectorIngestionController.setConnectorIngestionOpen = function() {
      return $('body').data('in-connector-ingestion', true);
    };

    ConnectorIngestionController.unsetConnectorIngestionOpen = function() {
      return $('body').data('in-connector-ingestion', null);
    };

    ConnectorIngestionController.prototype.release = function() {
      this.reactRoot.close();
      ConnectorIngestionController.unsetConnectorIngestionOpen();
      return ConnectorIngestionController.__super__.release.apply(this, arguments);
    };

    return ConnectorIngestionController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DatabasePermissionsController = (function(superClass) {
    extend(DatabasePermissionsController, superClass);

    DatabasePermissionsController.prototype.events = {
      'click .restriction-toggle': 'permissionToggled',
      'click .edit-icon': 'toggleEditing'
    };

    function DatabasePermissionsController() {
      this.updateDisabledState = bind(this.updateDisabledState, this);
      DatabasePermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'currentDb');
      App.Database.bind('update create destroy', this.updateDisabledState);
      this.editing = false;
      this.render();
    }

    DatabasePermissionsController.prototype.render = function() {
      return this.html(this.view('redesign/settings/database_permissions_panel')({
        editGroups: this.groupPermissions(),
        editing: this.editing,
        selectedGroups: this.selectedGroups()
      }));
    };

    DatabasePermissionsController.prototype.dbSelected = function(currentDb) {
      this.currentDb = currentDb;
      return this.updateDisabledState();
    };

    DatabasePermissionsController.prototype.release = function() {
      App.Database.unbind('update create destroy', this.updateDisabledState);
      return DatabasePermissionsController.__super__.release.apply(this, arguments);
    };

    DatabasePermissionsController.prototype.updateDisabledState = function(db) {
      if (db == null) {
        db = null;
      }
      if ((db != null) && db.id !== this.currentDb.id) {

      }
    };

    DatabasePermissionsController.prototype.toggleEditing = function() {
      this.editing = !this.editing;
      return this.render();
    };

    DatabasePermissionsController.prototype.groupPermissions = function() {
      return App.DatabaseGroupPermission.editGroupsWithQueryPermissionStatus(this.currentDb.id);
    };

    DatabasePermissionsController.prototype.selectedGroups = function() {
      return _.filter(this.groupPermissions(), ['can_query', true]);
    };

    DatabasePermissionsController.prototype.permissionToggled = function(event) {
      var groupId, targetCheckbox;
      event.stopPropagation();
      targetCheckbox = $(event.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      groupId = targetCheckbox.data('group-id');
      if (targetCheckbox.hasClass('selected')) {
        return App.DatabaseGroupPermission.addQueryAccess(this.currentDb.id, groupId);
      } else {
        return App.DatabaseGroupPermission.revokeQueryAccess(this.currentDb.id, groupId);
      }
    };

    return DatabasePermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.AddModalHelper = (function() {
    function AddModalHelper() {}

    AddModalHelper.positionModal = function(el, offsetValue) {
      var addButton, offset;
      addButton = $('.grid-search .add-button');
      offset = addButton != null ? addButton.offset() : void 0;
      if (offset) {
        return el.css({
          'left': (offset.left - offsetValue) + "px"
        });
      }
    };

    return AddModalHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAddSiteFromDirectoryController = (function(superClass) {
    extend(RedesignAddSiteFromDirectoryController, superClass);

    RedesignAddSiteFromDirectoryController.prototype.className = 'directory-add-site';

    RedesignAddSiteFromDirectoryController.prototype.elements = {
      'input.site-name': 'siteName',
      '.error-row': 'errorRow',
      '.right-aligned-buttons': 'buttonRow'
    };

    RedesignAddSiteFromDirectoryController.prototype.events = {
      'keyup input': 'keyupInput'
    };

    function RedesignAddSiteFromDirectoryController() {
      this.successfullyCreated = bind(this.successfullyCreated, this);
      this.handleError = bind(this.handleError, this);
      this.doneAjax = bind(this.doneAjax, this);
      this.add = bind(this.add, this);
      this.closeDialog = bind(this.closeDialog, this);
      RedesignAddSiteFromDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el");
      this.html(this.view("redesign/directory/add_site_from_directory")());
      this.siteName.trigger('focus');
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.closeDialog,
        saveFunc: this.add,
        saveText: 'ADD'
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
      this.cancelSaveBlock.setSaveDisabled(true);
      this.addSpaceDialog = App.RedesignDialog.createDialog({
        title: 'Add Space',
        viewController: this
      });
    }

    RedesignAddSiteFromDirectoryController.prototype.closeDialog = function() {
      return this.trigger('close');
    };

    RedesignAddSiteFromDirectoryController.prototype.add = function() {
      var newSiteName;
      newSiteName = this.siteName.val().trim();
      if (!this.validateForm(newSiteName)) {
        return;
      }
      this.clearError();
      this.cancelSaveBlock.setSaveDisabled(true);
      return jQuery.post("/sites/" + (App.Site.first().id) + "/add_site_to_family", {
        new_site_name: newSiteName
      }).done(this.successfullyCreated).fail(this.handleError).always(this.doneAjax);
    };

    RedesignAddSiteFromDirectoryController.prototype.validateForm = function(newSiteName) {
      var error, isSuccessful, ref;
      ref = App.SiteNameValidator.validate(newSiteName), isSuccessful = ref[0], error = ref[1];
      if (isSuccessful) {
        return true;
      }
      this.showError("Space Name: " + error);
      return false;
    };

    RedesignAddSiteFromDirectoryController.prototype.doneAjax = function() {
      return this.cancelSaveBlock.setSaveDisabled(false);
    };

    RedesignAddSiteFromDirectoryController.prototype.handleError = function(response) {
      var attribute, errorList, errors, messages, ref;
      errors = (ref = response.responseJSON) != null ? ref.errors : void 0;
      if (errors == null) {
        errors = {};
      }
      errorList = [];
      for (attribute in errors) {
        messages = errors[attribute];
        errorList.push(attribute + ": " + (messages.join(', ')));
      }
      if (errorList.length === 0) {
        errorList.push("An unknown error has occurred.");
      }
      return this.showError(errorList.join("\n"));
    };

    RedesignAddSiteFromDirectoryController.prototype.successfullyCreated = function(response) {
      App.RedesignAddSiteController.commonSuccessfullyCreatedSite(response);
      return this.closeDialog();
    };

    RedesignAddSiteFromDirectoryController.prototype.showError = function(message) {
      this.hasError = true;
      return this.errorRow.text(message).slideDown();
    };

    RedesignAddSiteFromDirectoryController.prototype.clearError = function() {
      if (this.hasError) {
        this.errorRow.slideUp();
      }
      return this.hasError = false;
    };

    RedesignAddSiteFromDirectoryController.prototype.isSiteNameEmpty = function() {
      return _.isEmpty(this.siteName.val().trim());
    };

    RedesignAddSiteFromDirectoryController.prototype.keyupInput = function() {
      return this.cancelSaveBlock.setSaveDisabled(this.isSiteNameEmpty());
    };

    return RedesignAddSiteFromDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignRemoveSiteController = (function(superClass) {
    extend(RedesignRemoveSiteController, superClass);

    RedesignRemoveSiteController.prototype.className = 'delete-site modal';

    RedesignRemoveSiteController.prototype.elements = {
      'input': 'confirmationField',
      '.button.remove': 'removeButton'
    };

    RedesignRemoveSiteController.prototype.events = {
      'click .button.remove': 'clickedRemove',
      'click .button.cancel': 'release',
      'click .cancel-icon': 'release',
      'keyup input': 'keyUpped'
    };

    function RedesignRemoveSiteController() {
      this.confirmRemoval = bind(this.confirmRemoval, this);
      RedesignRemoveSiteController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'site_info', 'siteDirectoryController');
      jQuery.ajax({
        url: "/sites/" + this.site_info.id + "/pre_destroy_info"
      }).done((function(_this) {
        return function(data) {
          return _this.render(data);
        };
      })(this));
    }

    RedesignRemoveSiteController.prototype.render = function(data) {
      App.Site.trigger('enter-modal');
      this.html(this.view('redesign/directory/remove_space')({
        site_name: this.site_info.display_name,
        dashboard_text: data.dashboard_count + " " + (App.Utils.pluralizeIf('Dashboard', data.dashboard_count !== 1)),
        user_text: data.user_count + " " + (App.Utils.pluralizeIf('User', data.user_count !== 1))
      }));
      return $('#modal').empty().append(this.el);
    };

    RedesignRemoveSiteController.prototype.clickedRemove = function() {
      var curr_site_info, i, j, len, site, site_info_list;
      site = App.Site.first();
      site_info_list = site.site_info_list;
      for (i = j = 0, len = site_info_list.length; j < len; i = ++j) {
        curr_site_info = site_info_list[i];
        if (curr_site_info.id === this.site_info.id) {
          site_info_list.splice(i, 1);
          break;
        }
      }
      site.save({
        ajax: false
      });
      jQuery.ajax({
        method: 'delete',
        url: "/sites/" + this.site_info.id,
        data: {
          client_site_id: App.Site.first().id
        }
      }).done(this.confirmRemoval);
      return this.release();
    };

    RedesignRemoveSiteController.prototype.confirmRemoval = function() {
      return this.siteDirectoryController.siteDestroyed(this.site_info);
    };

    RedesignRemoveSiteController.prototype.keyUpped = function(e) {
      this.verified = this.confirmationField.val() === this.site_info.display_name;
      if (this.verified) {
        this.removeButton.removeClass('disabled');
        if (e.which === AppRedesign.KEYS.ENTER) {
          return this.clickedRemove();
        }
      } else {
        return this.removeButton.addClass('disabled');
      }
    };

    RedesignRemoveSiteController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignRemoveSiteController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    return RedesignRemoveSiteController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDirectoryController = (function(superClass) {
    extend(RedesignDirectoryController, superClass);

    RedesignDirectoryController.prototype.className = 'directory-controller';

    RedesignDirectoryController.prototype.elements = {
      '.spinner-container': 'spinnerContainer'
    };

    RedesignDirectoryController.PERMISSIONS_DATE_FORMAT = 'YYYY-MM-DD';

    RedesignDirectoryController.PERMISSIONS_TIME_FORMAT = 'H:mm:ss z';

    RedesignDirectoryController.BLANK_FIELD_FORMAT = '--';

    RedesignDirectoryController.APPLIES_TO_ALL_SPACES = true;

    RedesignDirectoryController.TITLE = 'Directory';

    function RedesignDirectoryController() {
      this.removeSpinnerAndRenderSettingsGrid = bind(this.removeSpinnerAndRenderSettingsGrid, this);
      RedesignDirectoryController.__super__.constructor.apply(this, arguments);
      this.directoryHelper = new App.RedesignDirectoryHelper();
      this.html(this.view('redesign/settings/spinner')());
      this.directoryHelper.bind('directory-loaded', this.removeSpinnerAndRenderSettingsGrid);
    }

    RedesignDirectoryController.prototype.removeSpinnerAndRenderSettingsGrid = function() {
      this.spinnerContainer.remove();
      $('body').data('in-directory-controller', true);
      this.gridController = new App.RedesignSettingsGridController({
        disableSearch: true,
        mainControllerOptions: {
          prmController: this,
          directoryHelper: this.directoryHelper
        },
        settingsController: this,
        settingsGridCssClass: 'directory-layout'
      });
      return this.el.append(this.gridController.el);
    };

    RedesignDirectoryController.prototype.getCategories = function() {
      var categories, ref, userCategory;
      categories = [
        {
          type: "spaces",
          label: "SPACES",
          placeholder: "Search for Spaces",
          addText: "ADD SPACE",
          mainController: App.RedesignSiteDirectoryController,
          addController: App.RedesignAddSiteFromDirectoryController,
          upperSectionController: App.RedesignGroupsForSitesDirectoryController,
          lowerSectionController: App.RedesignUsersForSitesDirectoryController
        }, {
          type: "users",
          label: "USERS",
          placeholder: "Search for Users",
          addText: "ADD USER",
          mainController: App.RedesignUserDirectoryController,
          addController: App.RedesignAddUserController,
          upperSectionController: App.RedesignGroupsForUsersDirectoryController,
          lowerSectionController: App.RedesignSitesForUsersDirectoryController
        }, {
          type: "groups",
          label: "GROUPS",
          placeholder: "Search for Groups",
          addText: "ADD GROUP",
          mainController: App.RedesignGroupDirectoryController,
          addController: App.RedesignAddGroupController,
          upperSectionController: App.RedesignUsersForGroupsDirectoryController,
          lowerSectionController: App.RedesignSitesForGroupsDirectoryController
        }
      ];
      if ((ref = App.Site.first()) != null ? ref.sso_enabled : void 0) {
        userCategory = categories[1];
        delete userCategory.addText;
      }
      return categories;
    };

    RedesignDirectoryController.prototype.releaseMainControllerSpecificBinding = function(category) {};

    RedesignDirectoryController.prototype.setUpForMainController = function(category) {
      return this.directoryHelper.bind('directory-loaded', (function(_this) {
        return function() {
          return _this.trigger('reload');
        };
      })(this));
    };

    RedesignDirectoryController.inDirectoryController = function() {
      return $('body').data('in-directory-controller') === true;
    };

    RedesignDirectoryController.prototype.release = function() {
      var ref;
      $('body').data('in-directory-controller', null);
      this.directoryHelper.unbind('directory-loaded', (function(_this) {
        return function() {
          return _this.trigger('reload');
        };
      })(this));
      this.directoryHelper.unbind('directory-loaded', this.removeSpinnerAndRenderSettingsGrid);
      this.directoryHelper.reset();
      if ((ref = this.gridController) != null) {
        ref.release();
      }
      delete this.directoryHelper;
      return RedesignDirectoryController.__super__.release.apply(this, arguments);
    };

    return RedesignDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupDirectoryController = (function(superClass) {
    extend(RedesignGroupDirectoryController, superClass);

    RedesignGroupDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortOrder"
      }, {
        label: "Created By",
        "class": "created-by-column",
        sortOn: "created_by"
      }, {
        label: "Created On",
        "class": "created-on-column",
        sortOn: "created_on"
      }, {
        label: "Users",
        "class": "users-column sg-center",
        sortOn: "users"
      }, {
        label: "Spaces",
        "class": "sites-column sg-center",
        sortOn: "sites"
      }
    ];

    RedesignGroupDirectoryController.SEARCH_ATTRIBUTES = ["name", "created_by"];

    RedesignGroupDirectoryController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    RedesignGroupDirectoryController.ALL_USERS_MENU_OPTIONS = [
      {
        label: 'Edit',
        type: 'edit'
      }
    ];

    function RedesignGroupDirectoryController() {
      this.changeGroupPermissions = bind(this.changeGroupPermissions, this);
      this.confirmGroupEdit = bind(this.confirmGroupEdit, this);
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.groupMembershipChanged = bind(this.groupMembershipChanged, this);
      this.groupRoleChanged = bind(this.groupRoleChanged, this);
      this.renderRows = bind(this.renderRows, this);
      this.groupUpdated = bind(this.groupUpdated, this);
      this.getRows = bind(this.getRows, this);
      RedesignGroupDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "directoryHelper");
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "groups-directory-grid",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/group_directory_row"),
        searchAttributes: this.constructor.SEARCH_ATTRIBUTES,
        menuOptions: this.constructor.MENU_OPTIONS,
        gridType: "groups",
        unselectEnabled: false
      });
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.Group.bind('update', this.groupUpdated);
      App.Group.bind('destroy', this.panelCtrl.itemDestroyed);
      App.GroupMembership.bind('change', this.groupMembershipChanged);
      App.GroupRole.bind('change', this.groupRoleChanged);
    }

    RedesignGroupDirectoryController.prototype.release = function() {
      App.Group.unbind('update', this.groupUpdated);
      App.Group.unbind('destroy', this.panelCtrl.itemDestroyed);
      App.GroupMembership.unbind('change', this.groupMembershipChanged);
      App.GroupRole.unbind('change', this.groupRoleChanged);
      this.panelCtrl.release();
      return RedesignGroupDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignGroupDirectoryController.prototype.getRows = function() {
      var group, groupRolesByGroup;
      groupRolesByGroup = this.groupRolesByGroup();
      return (function() {
        var i, len, ref, results;
        ref = App.Group.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          results.push(this.groupInfo(group, groupRolesByGroup[group.id]));
        }
        return results;
      }).call(this);
    };

    RedesignGroupDirectoryController.prototype.groupUpdated = function(group) {
      var info;
      info = this.groupInfo(group, this.groupRolesForGroup(group));
      if (info) {
        return this.grid.updateRow(info);
      }
    };

    RedesignGroupDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignGroupDirectoryController.prototype.groupInfo = function(group, groupRoles) {
      var groupInfo, ref, site, site_name, sortPostFix, sortPrefix;
      groupInfo = group.groupInfo({}, {});
      if (group.admin || (group.site_family_id != null)) {
        sortPrefix = '2-';
        if (group.admin) {
          sortPrefix = '1-';
        }
        groupInfo.sortOrder = sortPrefix + groupInfo.name;
        groupInfo.siteName = ' ';
      } else {
        site = this.directoryHelper.siteForId((ref = groupRoles[0]) != null ? ref.site_id : void 0);
        if (site != null) {
          sortPrefix = '3-';
          sortPostFix = '2-';
          if (group.all_users) {
            sortPostFix = '1-';
          }
          site_name = site.display_name;
          groupInfo.sortOrder = sortPrefix + (site_name != null ? site_name.toLowerCase() : void 0) + '-' + sortPostFix + groupInfo.name;
          groupInfo.siteName = site_name;
        }
      }
      groupInfo.is_site_family_group = group.site_family_id != null;
      groupInfo.sites = (groupRoles != null ? groupRoles.length : void 0) || 0;
      groupInfo.admin = group.admin;
      groupInfo.all_users = group.all_users;
      groupInfo.users = group.groupMemberships().length;
      groupInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = group;
      return groupInfo;
    };

    RedesignGroupDirectoryController.prototype.groupRolesByGroup = function() {
      return _.groupBy(App.GroupRole.all(), 'group_id');
    };

    RedesignGroupDirectoryController.prototype.groupRolesForGroup = function(group) {
      var groupRole, groupRoles, i, len, ref;
      groupRoles = [];
      ref = App.GroupRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (groupRole.group_id === group.id) {
          groupRoles.push(groupRole);
        }
      }
      return groupRoles;
    };

    RedesignGroupDirectoryController.prototype.groupRoleChanged = function(role) {
      var group;
      group = App.Group.exists(role.group_id);
      if (group) {
        return this.groupUpdated(group);
      }
    };

    RedesignGroupDirectoryController.prototype.groupMembershipChanged = function(membership) {
      var group;
      group = App.Group.exists(membership.group_id);
      if (group) {
        return this.groupUpdated(group);
      }
    };

    RedesignGroupDirectoryController.prototype.clickedGearOption = function(group, rowEl, option) {
      switch (option.type) {
        case "edit":
          return this.clickedEdit(group, rowEl);
        case "remove":
          return this.panelCtrl.askForConfirmation(group, rowEl, "remove-group", "REMOVE", this.panelCtrl.removeItem);
      }
    };

    RedesignGroupDirectoryController.prototype.clickedEdit = function(group, rowEl) {
      this.editingGroup = group;
      this.activeRowEl = rowEl;
      this.panelCtrl.closeEdit();
      if (group.all_users) {
        group.disabled = true;
      }
      this.editRow = $(this.view("redesign/directory/group_directory_row_edit")({
        group: group
      }));
      rowEl.before(this.editRow);
      this.editRow.find(".button.confirm").on("click", ((function(_this) {
        return function(e) {
          e.stopPropagation();
          return _this.confirmGroupEdit();
        };
      })(this)));
      this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
      return this.editRow.find(".checkbox").on("click", this.changeGroupPermissions);
    };

    RedesignGroupDirectoryController.prototype.confirmGroupEdit = function() {
      var group, newName;
      group = this.editingGroup;
      newName = this.editRow.find('.edit-group-name-column input').val();
      if ((newName != null ? newName.length : void 0) > 0) {
        group.name = newName;
      }
      group.save();
      return this.panelCtrl.closeEdit();
    };

    RedesignGroupDirectoryController.prototype.changeGroupPermissions = function(evt) {
      var can_edit_state, group, targetCheckbox;
      group = this.editingGroup;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      can_edit_state = targetCheckbox.hasClass('selected');
      return group.can_edit = can_edit_state;
    };

    RedesignGroupDirectoryController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    RedesignGroupDirectoryController.prototype.search = function(searchTerm) {
      return this.panelCtrl.search(searchTerm);
    };

    return RedesignGroupDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupsForSitesDirectoryController = (function(superClass) {
    extend(RedesignGroupsForSitesDirectoryController, superClass);

    RedesignGroupsForSitesDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignGroupsForSitesDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeGroupRole'
    };

    RedesignGroupsForSitesDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignGroupsForSitesDirectoryController() {
      this.changeGroupRole = bind(this.changeGroupRole, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      RedesignGroupsForSitesDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Groups"
      }));
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "groups-details-grid directory-subsection-grid with-globe fit-in-pane",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/groups_for_sites_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'groups',
        unselectEnabled: true,
        hideEditColumn: true
      });
      App.GroupRole.bind('create destroy', this.updateCallback);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignGroupsForSitesDirectoryController.prototype.release = function() {
      var ref;
      App.GroupRole.unbind('create', this.updateCallback);
      App.GroupRole.unbind('destroy', this.updateCallback);
      this.directoryHelper.unbind('directory-loaded', this.updateCallback);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignGroupsForSitesDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignGroupsForSitesDirectoryController.prototype.getRows = function() {
      return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.groupsInSite(this.item.id), false, (function(row) {
        return row.group.name;
      }), (function(row) {
        if (row.group.isLocalGroup() || row.group.admin) {
          return true;
        }
      }), (function(row) {
        return row.group.can_edit;
      }));
    };

    RedesignGroupsForSitesDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.customerGroupsNotInSite(this.item.id), true, function(row) {
        return row.group.name;
      }, null, (function(row) {
        return row.group.can_edit;
      }));
      return this.getRows().concat(unselectedRows);
    };

    RedesignGroupsForSitesDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing) {
        return this.renderRows();
      }
    };

    RedesignGroupsForSitesDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignGroupsForSitesDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignGroupsForSitesDirectoryController.prototype.changeGroupRole = function(evt) {
      var group, row, rowEl, targetCheckbox;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      group = row.group;
      if (targetCheckbox.hasClass('selected')) {
        return group.addRole(this.item.id);
      } else {
        return group.removeRole(this.item.id);
      }
    };

    return RedesignGroupsForSitesDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupsForUsersDirectoryController = (function(superClass) {
    extend(RedesignGroupsForUsersDirectoryController, superClass);

    RedesignGroupsForUsersDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignGroupsForUsersDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeGroupMembership'
    };

    RedesignGroupsForUsersDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignGroupsForUsersDirectoryController() {
      this.disallowCurrentUserFromDisablingAdministator = bind(this.disallowCurrentUserFromDisablingAdministator, this);
      this.changeGroupMembership = bind(this.changeGroupMembership, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      var ref;
      RedesignGroupsForUsersDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Groups"
      }));
      this.emptyMessage = "No groups since user does not have workbooks access";
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "groups-details-grid directory-subsection-grid with-globe fit-in-pane",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/groups_for_sites_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'groups',
        unselectEnabled: true,
        hideEditColumn: true
      });
      if (this.userLacksWorkbooksAccess()) {
        if ((ref = this.grid) != null) {
          ref.setEmptyMessage(this.emptyMessage);
        }
        this.editIcon.hide();
      }
      App.GroupMembership.bind('create destroy', this.updateCallback);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignGroupsForUsersDirectoryController.prototype.release = function() {
      var ref;
      App.GroupMembership.unbind('create', this.updateCallback);
      App.GroupMembership.unbind('destroy', this.updateCallback);
      this.directoryHelper.unbind('directory-loaded', this.updateCallback);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignGroupsForUsersDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignGroupsForUsersDirectoryController.prototype.userLacksWorkbooksAccess = function() {
      return AppRedesign.allowRevokingWorkbooksAccess() && !this.item.workbooks_access;
    };

    RedesignGroupsForUsersDirectoryController.prototype.getRows = function() {
      var isCurrentUser;
      isCurrentUser = this.item.id === App.User.currentUser().id;
      if (this.userLacksWorkbooksAccess()) {
        return [];
      }
      return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.groupsForUser(this.item.id), false, (function(row) {
        return row.group.name;
      }), ((function(_this) {
        return function(row) {
          return _this.disallowCurrentUserFromDisablingAdministator(isCurrentUser, row);
        };
      })(this)), (function(row) {
        return row.group.can_edit;
      }));
    };

    RedesignGroupsForUsersDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.groupsNotLinkedToUser(this.item.id), true, function(row) {
        return row.group.name;
      }, null, (function(row) {
        return row.group.can_edit;
      }));
      return this.getRows().concat(unselectedRows);
    };

    RedesignGroupsForUsersDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing) {
        return this.renderRows();
      }
    };

    RedesignGroupsForUsersDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignGroupsForUsersDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignGroupsForUsersDirectoryController.prototype.changeGroupMembership = function(evt) {
      var group, row, rowEl, targetCheckbox;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      group = row.group;
      if (targetCheckbox.hasClass('selected')) {
        return group.addUser(this.item, {
          success: this.triggerCheckForUpdates
        });
      } else {
        return group.removeUser(this.item, {
          success: this.triggerCheckForUpdates
        });
      }
    };

    RedesignGroupsForUsersDirectoryController.prototype.triggerCheckForUpdates = function() {
      return App.Site.trigger('request-several-updates');
    };

    RedesignGroupsForUsersDirectoryController.prototype.disallowCurrentUserFromDisablingAdministator = function(isCurrentUser, row) {
      return isCurrentUser && row.group.admin;
    };

    return RedesignGroupsForUsersDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSiteDirectoryController = (function(superClass) {
    extend(RedesignSiteDirectoryController, superClass);

    RedesignSiteDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortable_name"
      }, {
        label: "Created By",
        "class": "created-by-column",
        sortOn: 'created_by_user'
      }, {
        label: "Created On",
        "class": "created-on-column sg-center",
        sortOn: 'create_time'
      }, {
        label: "Groups",
        "class": "groups-column sg-center",
        sortOn: 'groups'
      }, {
        label: "Users",
        "class": "users-column sg-center",
        sortOn: 'users'
      }, {
        label: 'Databases',
        "class": 'databases-column sg-center',
        sortOn: 'databases'
      }, {
        label: 'Rows',
        "class": 'rows-column sg-center',
        sortOn: 'rows'
      }
    ];

    RedesignSiteDirectoryController.SEARCH_ATTRIBUTES = ['display_name'];

    RedesignSiteDirectoryController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    function RedesignSiteDirectoryController() {
      this.clickedDeleteSite = bind(this.clickedDeleteSite, this);
      this.doneRenaming = bind(this.doneRenaming, this);
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.siteInfo = bind(this.siteInfo, this);
      this.siteDestroyed = bind(this.siteDestroyed, this);
      this.siteUpdated = bind(this.siteUpdated, this);
      this.roleUpdated = bind(this.roleUpdated, this);
      this.updateAllSites = bind(this.updateAllSites, this);
      RedesignSiteDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'directoryHelper');
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "site-grid",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/site_row"),
        searchAttributes: this.constructor.SEARCH_ATTRIBUTES,
        menuOptions: this.constructor.MENU_OPTIONS,
        gridType: "spaces",
        unselectEnabled: false,
        idCallback: (function(_this) {
          return function(obj) {
            return obj[App.RedesignSimpleGridController.OBJECT_FIELD].id;
          };
        })(this)
      });
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.Site.bind('change', this.panelCtrl.rerenderRows);
      App.GroupRole.bind('create update destroy', this.roleUpdated);
      App.UserRole.bind('create update destroy', this.roleUpdated);
      this.directoryHelper.bind('directory-loaded', this.updateAllSites);
    }

    RedesignSiteDirectoryController.prototype.release = function() {
      App.Site.unbind('change', this.panelCtrl.rerenderRows);
      App.GroupRole.unbind('create', this.roleUpdated);
      App.GroupRole.unbind('update', this.roleUpdated);
      App.GroupRole.unbind('destroy', this.roleUpdated);
      App.UserRole.unbind('create', this.roleUpdated);
      App.UserRole.unbind('update', this.roleUpdated);
      App.UserRole.unbind('destroy', this.roleUpdated);
      this.directoryHelper.unbind('directory-loaded', this.updateAllSites);
      this.panelCtrl.release();
      return RedesignSiteDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignSiteDirectoryController.prototype.updateAllSites = function() {
      var i, len, ref, ref1, results, siteToGroupCount, siteToUserCount, site_info;
      ref = App.Site.first().site_info_list;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        site_info = ref[i];
        ref1 = this.getSiteCounts(), siteToGroupCount = ref1[0], siteToUserCount = ref1[1];
        results.push(this.siteUpdated(this.siteInfo(siteToGroupCount, siteToUserCount, site_info)));
      }
      return results;
    };

    RedesignSiteDirectoryController.prototype.roleUpdated = function(role) {
      var ref, siteToGroupCount, siteToUserCount, site_info, site_info_list;
      site_info_list = App.Site.first().site_info_list;
      site_info = _.find(site_info_list, function(site) {
        return site.id === role.site_id;
      });
      if (site_info == null) {
        return;
      }
      ref = this.getSiteCounts(), siteToGroupCount = ref[0], siteToUserCount = ref[1];
      return this.siteUpdated(this.siteInfo(siteToGroupCount, siteToUserCount, site_info));
    };

    RedesignSiteDirectoryController.prototype.siteUpdated = function(site_info) {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      return this.grid.updateRow(site_info, true);
    };

    RedesignSiteDirectoryController.prototype.siteDestroyed = function(site_info) {
      var base, name;
      site_info[name = App.RedesignSimpleGridController.OBJECT_FIELD] || (site_info[name] = {});
      (base = site_info[App.RedesignSimpleGridController.OBJECT_FIELD]).id || (base.id = site_info.id);
      return this.grid.deleteRow(site_info);
    };

    RedesignSiteDirectoryController.prototype.siteInfo = function(siteToGroupCount, siteToUserCount, site_info) {
      var createdByUser, ref;
      site_info = $.extend(true, {}, site_info);
      site_info.sortable_name = site_info.display_name.toLowerCase();
      site_info.rows = App.Utils.formatNumWithPrecision(site_info.rows);
      site_info.groups = siteToGroupCount[site_info.id] || 0;
      site_info.users = siteToUserCount[site_info.id] || 0;
      site_info[App.RedesignSimpleGridController.OBJECT_FIELD] = $.extend({}, site_info);
      createdByUser = App.User.exists(site_info.created_by_user_id);
      site_info.created_by_user = (ref = (createdByUser ? createdByUser.abbreviatedDisplayName() : void 0)) != null ? ref : '--';
      return site_info;
    };

    RedesignSiteDirectoryController.prototype.getSiteCounts = function() {
      var groupRole, i, j, len, len1, name, name1, ref, ref1, siteToGroupCount, siteToUserCount, userRole;
      siteToGroupCount = {};
      ref = App.GroupRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        groupRole = ref[i];
        if (siteToGroupCount[name = groupRole.site_id] == null) {
          siteToGroupCount[name] = 0;
        }
        siteToGroupCount[groupRole.site_id] += 1;
      }
      siteToUserCount = {};
      ref1 = App.UserRole.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        userRole = ref1[j];
        if (siteToUserCount[name1 = userRole.site_id] == null) {
          siteToUserCount[name1] = 0;
        }
        siteToUserCount[userRole.site_id] += 1;
      }
      return [siteToGroupCount, siteToUserCount];
    };

    RedesignSiteDirectoryController.prototype.getRows = function() {
      var ref, siteToGroupCount, siteToUserCount, site_info, site_info_list;
      site_info_list = App.Site.first().site_info_list;
      ref = this.getSiteCounts(), siteToGroupCount = ref[0], siteToUserCount = ref[1];
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = site_info_list.length; i < len; i++) {
          site_info = site_info_list[i];
          results.push(this.siteInfo(siteToGroupCount, siteToUserCount, site_info));
        }
        return results;
      }).call(this);
    };

    RedesignSiteDirectoryController.prototype.clickedGearOption = function(site, rowEl, option) {
      switch (option.type) {
        case 'edit':
          return this.clickedEdit(site, rowEl);
        case 'remove':
          return this.clickedDeleteSite(site, rowEl);
      }
    };

    RedesignSiteDirectoryController.prototype.clickedEdit = function(site, rowEl) {
      this.panelCtrl.closeEdit();
      this.editRow = $(this.view("redesign/directory/site_row_edit")({
        row: site
      }));
      rowEl.before(this.editRow);
      this.editRow.find('select.owner-select').chosen({
        disable_search: false,
        width: '193px'
      });
      this.editRow.find(".button.confirm").on("click", ((function(_this) {
        return function(e) {
          e.stopPropagation();
          return _this.saveSite(site);
        };
      })(this)));
      return this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
    };

    RedesignSiteDirectoryController.prototype.saveSite = function(site) {
      var ref, ref1;
      site.display_name = ((ref = this.editRow) != null ? ref.find('input.edit-name:first').val() : void 0) || '';
      if ((ref1 = this.editRow) != null) {
        ref1.remove();
      }
      jQuery.ajax({
        type: 'post',
        url: "/sites/" + site.id + "/rename_site",
        data: {
          client_site_id: App.Site.first().id,
          new_site_name: site.display_name
        }
      }).done(this.doneRenaming);
      site[App.RedesignSimpleGridController.OBJECT_FIELD] = {
        id: site.id
      };
      return this.siteUpdated(site);
    };

    RedesignSiteDirectoryController.prototype.doneRenaming = function(targetSite) {
      var currSite;
      currSite = App.Site.first();
      currSite.site_info_list = targetSite.site_info_list;
      return currSite.save({
        ajax: false
      });
    };

    RedesignSiteDirectoryController.prototype.clickedDeleteSite = function(site_info, rowEl) {
      if (site_info.id === App.Site.first().id) {
        this.panelCtrl.showMessage(rowEl, "Cannot delete current space.");
        return;
      }
      return new App.RedesignRemoveSiteController({
        site_info: site_info,
        siteDirectoryController: this
      });
    };

    RedesignSiteDirectoryController.prototype.search = function(searchTerm) {
      return this.panelCtrl.search(searchTerm);
    };

    RedesignSiteDirectoryController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    return RedesignSiteDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSitesForGroupsDirectoryController = (function(superClass) {
    extend(RedesignSitesForGroupsDirectoryController, superClass);

    RedesignSitesForGroupsDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignSitesForGroupsDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeSiteMembership'
    };

    RedesignSitesForGroupsDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignSitesForGroupsDirectoryController() {
      this.changeSiteMembership = bind(this.changeSiteMembership, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      RedesignSitesForGroupsDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Spaces"
      }));
      if (this.item.isLocalGroup() || this.item.admin) {
        this.editIcon.addClass("hidden disabled");
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "directory-subsection-grid fit-in-pane",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/single_column_check_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'spaces',
        unselectEnabled: true
      });
      App.GroupRole.bind('create destroy', this.updateCallback);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignSitesForGroupsDirectoryController.prototype.release = function() {
      var ref;
      App.GroupRole.unbind('create', this.updateCallback);
      App.GroupRole.unbind('destroy', this.updateCallback);
      this.directoryHelper.unbind('directory-loaded', this.updateCallback);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignSitesForGroupsDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignSitesForGroupsDirectoryController.prototype.getRows = function() {
      return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.sitesForGroup(this.item.id), false, function(row) {
        return row.site.display_name;
      });
    };

    RedesignSitesForGroupsDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.sitesNotLinkedToGroup(this.item.id), true, function(row) {
        return row.site.display_name;
      });
      return this.getRows().concat(unselectedRows);
    };

    RedesignSitesForGroupsDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing) {
        return this.renderRows();
      }
    };

    RedesignSitesForGroupsDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignSitesForGroupsDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignSitesForGroupsDirectoryController.prototype.changeSiteMembership = function(evt) {
      var group, row, rowEl, site, targetCheckbox;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      site = row.site;
      group = this.item;
      if (targetCheckbox.hasClass('selected')) {
        return group.addRole(site.id);
      } else {
        return group.removeRole(site.id);
      }
    };

    return RedesignSitesForGroupsDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSitesForUsersDirectoryController = (function(superClass) {
    extend(RedesignSitesForUsersDirectoryController, superClass);

    RedesignSitesForUsersDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignSitesForUsersDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeUserRole'
    };

    RedesignSitesForUsersDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignSitesForUsersDirectoryController() {
      this.handleSearch = bind(this.handleSearch, this);
      this.changeUserRole = bind(this.changeUserRole, this);
      this.editIconUpdate = bind(this.editIconUpdate, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      RedesignSitesForUsersDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Spaces"
      }));
      if (this.item.isAdmin()) {
        this.editIcon.addClass('hidden disabled');
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "directory-subsection-grid fit-in-pane",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/single_column_check_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'spaces',
        unselectEnabled: true
      });
      App.UserRole.bind('create destroy', this.updateCallback);
      App.GroupMembership.bind('create destroy', this.editIconUpdate);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignSitesForUsersDirectoryController.prototype.release = function() {
      var ref;
      App.UserRole.unbind('create', this.updateCallback);
      App.UserRole.unbind('destroy', this.updateCallback);
      App.GroupMembership.unbind('create', this.editIconUpdate);
      App.GroupMembership.unbind('destroy', this.editIconUpdate);
      this.directoryHelper.unbind('directory-loaded', this.updateCallback);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignSitesForUsersDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignSitesForUsersDirectoryController.prototype.getRows = function() {
      return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.sitesForUser(this.item.id), false, function(row) {
        return row.site.display_name;
      });
    };

    RedesignSitesForUsersDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.sitesNotLinkedToUser(this.item.id), true, function(row) {
        return row.site.display_name;
      });
      return this.getRows().concat(unselectedRows);
    };

    RedesignSitesForUsersDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing || this.item.isAdmin()) {
        return this.renderRows();
      }
    };

    RedesignSitesForUsersDirectoryController.prototype.renderRows = function() {
      var inGlobalAdmin;
      inGlobalAdmin = this.item.isAdmin();
      if (inGlobalAdmin) {
        this.editIcon.addClass('hidden disabled');
      } else {
        this.editIcon.removeClass('hidden disabled');
      }
      if (this.editing) {
        if (inGlobalAdmin) {
          this.clickedEdit();
          return this.grid.rerenderRows(this.getRows());
        } else {
          return this.grid.rerenderRows(this.getEditingRows());
        }
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignSitesForUsersDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignSitesForUsersDirectoryController.prototype.editIconUpdate = function(membership) {
      if (membership.user_id !== this.item.id) {
        return;
      }
      if (this.item.isAdmin()) {
        return this.editIcon.addClass('hidden disabled');
      } else {
        return this.editIcon.removeClass('hidden disabled');
      }
    };

    RedesignSitesForUsersDirectoryController.prototype.changeUserRole = function(evt) {
      var row, rowEl, siteId, targetCheckbox;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      siteId = row.site.id;
      if (targetCheckbox.hasClass('selected')) {
        return this.item.addUserRole(siteId, {
          success: this.triggerCheckForUpdates
        });
      } else {
        return this.item.removeUserRole(siteId, {
          success: this.triggerCheckForUpdates
        });
      }
    };

    RedesignSitesForUsersDirectoryController.prototype.triggerCheckForUpdates = function() {
      return App.Site.trigger('request-several-updates');
    };

    RedesignSitesForUsersDirectoryController.prototype.handleSearch = function() {
      return this.grid.search(this.searchInput.val());
    };

    return RedesignSitesForUsersDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUserDirectoryController = (function(superClass) {
    extend(RedesignUserDirectoryController, superClass);

    RedesignUserDirectoryController.COLUMNS = [
      {
        label: "Name & Email",
        "class": "name-column",
        sortOn: "display_name"
      }, {
        label: "Spaces",
        "class": "spaces-column sg-center",
        sortOn: "site_count"
      }, {
        label: "Last Login",
        "class": "login-column",
        sortOn: "last_site_login"
      }, {
        label: "Password Changed",
        "class": "password-column",
        sortOn: "password_changed_at"
      }, {
        label: "2FA",
        "class": "tfa-column sg-center",
        sortOn: "is_tfa_active"
      }
    ];

    RedesignUserDirectoryController.SEARCH_ATTRIBUTES = ["display_name", "email"];

    RedesignUserDirectoryController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Reset Password",
        type: "reset-password"
      }, {
        label: "Reset 2FA",
        type: "reset-2fa"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    function RedesignUserDirectoryController() {
      this.handleEditError = bind(this.handleEditError, this);
      this.removeItem = bind(this.removeItem, this);
      this.reset2fa = bind(this.reset2fa, this);
      this.resetPassword = bind(this.resetPassword, this);
      this.confirmUserEdit = bind(this.confirmUserEdit, this);
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.setRows = bind(this.setRows, this);
      this.setUsers = bind(this.setUsers, this);
      this.getRows = bind(this.getRows, this);
      this.userUpdated = bind(this.userUpdated, this);
      this.userRoleUpdated = bind(this.userRoleUpdated, this);
      var siteCountsByUser, user;
      RedesignUserDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "directoryHelper");
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        siteCountsByUser = this.siteCountsByUser();
        this.users = (function() {
          var i, len, ref, results;
          ref = App.User.all();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            user = ref[i];
            results.push(this.userInfo(user, siteCountsByUser[user.id]));
          }
          return results;
        }).call(this);
        App.User.search('', this.setUsers);
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "user-directory-grid",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/user_directory_row"),
        searchAttributes: this.constructor.SEARCH_ATTRIBUTES,
        menuOptions: this.constructor.MENU_OPTIONS,
        gridType: 'users',
        unselectEnabled: false
      });
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.User.bind('update', this.userUpdated);
      App.User.bind('destroy', this.panelCtrl.itemDestroyed);
      App.UserRole.bind('save destroy', this.userRoleUpdated);
    }

    RedesignUserDirectoryController.prototype.release = function() {
      App.User.unbind('update', this.userUpdated);
      App.User.unbind('destroy', this.panelCtrl.itemDestroyed);
      App.UserRole.unbind('save', this.userRoleUpdated);
      App.UserRole.unbind('destroy', this.userRoleUpdated);
      this.panelCtrl.release();
      return RedesignUserDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignUserDirectoryController.prototype.userRoleUpdated = function(userRole) {
      var user;
      user = App.User.exists(userRole.user_id);
      if (user) {
        return this.userUpdated(user);
      }
    };

    RedesignUserDirectoryController.prototype.userUpdated = function(user) {
      var info;
      info = this.userInfo(user, this.siteCountForUser(user));
      if (info) {
        return this.grid.updateRow(info);
      }
    };

    RedesignUserDirectoryController.prototype.getRows = function() {
      var siteCountsByUser, user;
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return this.users;
      } else {
        siteCountsByUser = this.siteCountsByUser();
        return (function() {
          var i, len, ref, results;
          ref = App.User.all();
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            user = ref[i];
            results.push(this.userInfo(user, siteCountsByUser[user.id]));
          }
          return results;
        }).call(this);
      }
    };

    RedesignUserDirectoryController.prototype.setUsers = function(raw_users) {
      var users;
      users = raw_users.map(function(u) {
        return new App.User(u);
      });
      return this.setRows(users);
    };

    RedesignUserDirectoryController.prototype.setRows = function(users) {
      var siteCountsByUser, user;
      siteCountsByUser = this.siteCountsByUser();
      this.users = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = users.length; i < len; i++) {
          user = users[i];
          results.push(this.userInfo(user, siteCountsByUser[user.id]));
        }
        return results;
      }).call(this);
      return this.grid.rerenderRows(this.users);
    };

    RedesignUserDirectoryController.prototype.userInfo = function(user, siteCount) {
      var info;
      info = {
        first_name: user.first_name,
        last_name: user.last_name,
        display_name: user.fullName(),
        email: user.email_address,
        site_count: siteCount,
        last_site_login: App.TimeMachine.parseDateTimeToTimestamp(user.last_login, App.TimeMachine.mapDisplayTimezone('UTC')),
        password_changed_at: App.TimeMachine.parseDateTimeToTimestamp(user.password_changed_at, App.TimeMachine.mapDisplayTimezone('UTC')),
        is_tfa_active: user.is_tfa_active
      };
      info[App.RedesignSimpleGridController.OBJECT_FIELD] = user;
      return info;
    };

    RedesignUserDirectoryController.prototype.siteCountsByUser = function() {
      var i, len, name, ref, siteCountsByUser, userRole;
      siteCountsByUser = {};
      ref = App.UserRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (siteCountsByUser[name = userRole.user_id] == null) {
          siteCountsByUser[name] = 0;
        }
        siteCountsByUser[userRole.user_id]++;
      }
      return siteCountsByUser;
    };

    RedesignUserDirectoryController.prototype.siteCountForUser = function(user) {
      var count, i, len, ref, userRole;
      count = 0;
      ref = App.UserRole.all();
      for (i = 0, len = ref.length; i < len; i++) {
        userRole = ref[i];
        if (userRole.user_id === user.id) {
          count++;
        }
      }
      return count;
    };

    RedesignUserDirectoryController.prototype.clickedGearOption = function(user, rowEl, option) {
      switch (option.type) {
        case "edit":
          return this.clickedEdit(user, rowEl);
        case "reset-password":
          return this.panelCtrl.askForConfirmation(user, rowEl, "reset-password", "RESET", this.resetPassword);
        case "reset-2fa":
          return this.panelCtrl.askForConfirmation(user, rowEl, "reset-2fa", "RESET", this.reset2fa);
        case "remove":
          return this.panelCtrl.askForConfirmation(user, rowEl, "remove-user", "REMOVE", this.removeItem);
      }
    };

    RedesignUserDirectoryController.prototype.clickedEdit = function(user, rowEl) {
      this.panelCtrl.closeEdit();
      this.editingUser = user;
      this.activeRowEl = rowEl;
      this.editRow = $(this.view("redesign/permissions/user_row_edit")({
        row: user
      }));
      rowEl.before(this.editRow);
      this.editRow.find(".button.confirm").on("click", ((function(_this) {
        return function(e) {
          e.stopPropagation();
          return _this.confirmUserEdit();
        };
      })(this)));
      return this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
    };

    RedesignUserDirectoryController.prototype.confirmUserEdit = function() {
      var ref, ref1, updateParams, user;
      user = this.editingUser;
      updateParams = {
        user_id: user.id,
        client_site_id: App.Site.first().id
      };
      if (((ref = this.editRow.find(".edit-first-name-column input").val()) != null ? ref.length : void 0) > 0) {
        updateParams['first_name'] = this.editRow.find(".edit-first-name-column input").val();
        user.first_name = updateParams['first_name'];
      }
      if (((ref1 = this.editRow.find(".edit-last-name-column input").val()) != null ? ref1.length : void 0) > 0) {
        updateParams['last_name'] = this.editRow.find(".edit-last-name-column input").val();
        user.last_name = updateParams['last_name'];
      }
      user.save({
        ajax: false
      });
      return $.post("/users/admin_update_profile", updateParams).fail(this.handleEditError).done(this.panelCtrl.closeEdit);
    };

    RedesignUserDirectoryController.prototype.resetPassword = function(user, rowEl) {
      user.sendForgotPasswordMail();
      return this.panelCtrl.showMessage(rowEl, "Password for " + (user.fullName()) + " has been reset.");
    };

    RedesignUserDirectoryController.prototype.reset2fa = function(user, rowEl) {
      return $.post("/users/reset_user_two_factor", {
        user_id: user.id,
        client_site_id: App.Site.first().id
      }).fail(((function(_this) {
        return function(r) {
          return _this.panelCtrl.showMessage(rowEl, r.responseJSON.error_message, true);
        };
      })(this))).done(((function(_this) {
        return function() {
          return _this.panelCtrl.showMessage(rowEl, "Two-Factor Authentication for " + (user.fullName()) + " has been reset.");
        };
      })(this)));
    };

    RedesignUserDirectoryController.prototype.removeItem = function(user, rowEl) {
      user.revokeAccessAllSites(this.directoryHelper);
      return this.trigger('deletedRow');
    };

    RedesignUserDirectoryController.prototype.handleEditError = function(r) {
      if (r.responseText.error != null) {
        return this.panelCtrl.showMessage(this.activeRowEl, r.responseText.error, true, function() {});
      } else {
        return this.panelCtrl.showMessage(this.activeRowEl, "User profile could not be updated", true, function() {});
      }
    };

    RedesignUserDirectoryController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    RedesignUserDirectoryController.prototype.search = function(searchTerm) {
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return App.User.search(searchTerm, this.setUsers);
      } else {
        return this.panelCtrl.search(searchTerm);
      }
    };

    return RedesignUserDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUsersForGroupsDirectoryController = (function(superClass) {
    extend(RedesignUsersForGroupsDirectoryController, superClass);

    RedesignUsersForGroupsDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignUsersForGroupsDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeGroupMembership'
    };

    RedesignUsersForGroupsDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "user-name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignUsersForGroupsDirectoryController() {
      this.changeGroupMembership = bind(this.changeGroupMembership, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      this.userLacksWorkbooksAccess = bind(this.userLacksWorkbooksAccess, this);
      this.search = bind(this.search, this);
      this.setUsers = bind(this.setUsers, this);
      RedesignUsersForGroupsDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Users"
      }));
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.rows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInSite(this.item.id), false, function(row) {
          return row.user.fullName();
        });
        this.search('');
      }
      if (this.item.all_users) {
        this.editIcon.addClass("hidden disabled");
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "directory-subsection-grid fit-in-pane users-for-groups",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/single_column_check_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'users',
        unselectEnabled: true
      });
      App.GroupMembership.bind('create destroy', this.updateCallback);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.grid.search = this.search;
      }
    }

    RedesignUsersForGroupsDirectoryController.prototype.release = function() {
      var ref;
      App.GroupMembership.unbind('create', this.updateCallback);
      App.GroupMembership.unbind('destroy', this.updateCallback);
      this.directoryHelper.unbind('directory-loaded', this.updateCallback);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignUsersForGroupsDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignUsersForGroupsDirectoryController.prototype.getRows = function() {
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return this.rows;
      } else {
        return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInGroup(this.item.id), false, (function(row) {
          return row.user.fullName();
        }), (function(row) {
          return row.user.id === App.User.currentUser().id;
        }));
      }
    };

    RedesignUsersForGroupsDirectoryController.prototype.setUsers = function(users) {
      this.rows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInGroupFromSearch(this.item.id, users.map(function(r) {
        return new App.User(r);
      })), false, (function(row) {
        return row.user.fullName();
      }), (function(row) {
        return row.user.id === App.User.currentUser().id;
      }));
      return this.grid.rerenderRows(this.rows);
    };

    RedesignUsersForGroupsDirectoryController.prototype.search = function(term) {
      var sitesGroups;
      sitesGroups = this.directoryHelper.sitesForGroup(this.item.id);
      return Promise.all(sitesGroups.map((function(_this) {
        return function(siteGroup) {
          return _this.searchSite(siteGroup.site.id, term);
        };
      })(this))).then(function(results) {
        return results.reduce((function(r1, r2) {
          return r1.concat(r2);
        }), []);
      }).then(this.setUsers);
    };

    RedesignUsersForGroupsDirectoryController.prototype.searchSite = function(siteId, searchTerm) {
      return fetch("/api/" + siteId + "/users/search?query=" + searchTerm).then(function(res) {
        return res.json();
      }).then(function(r) {
        return r['users'];
      });
    };

    RedesignUsersForGroupsDirectoryController.prototype.userLacksWorkbooksAccess = function(user) {
      return AppRedesign.allowRevokingWorkbooksAccess() && !user.workbooks_access;
    };

    RedesignUsersForGroupsDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersNotInGroup(this.item.id), true, function(row) {
        return row.user.fullName();
      }, (function(row) {
        if (AppRedesign.allowRevokingWorkbooksAccess() && !row.workbooks_access) {
          return true;
        }
      }));
      return this.getRows().concat(unselectedRows);
    };

    RedesignUsersForGroupsDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing) {
        return this.renderRows();
      }
    };

    RedesignUsersForGroupsDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignUsersForGroupsDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignUsersForGroupsDirectoryController.prototype.changeGroupMembership = function(evt) {
      var group, row, rowEl, targetCheckbox, user;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      user = row.user;
      group = this.item;
      if (targetCheckbox.hasClass('selected')) {
        return group.addUser(user, {
          success: this.triggerCheckForUpdates
        });
      } else {
        return group.removeUser(user, {
          success: this.triggerCheckForUpdates
        });
      }
    };

    RedesignUsersForGroupsDirectoryController.prototype.triggerCheckForUpdates = function() {
      return App.Site.trigger('request-several-updates');
    };

    return RedesignUsersForGroupsDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUsersForSitesDirectoryController = (function(superClass) {
    extend(RedesignUsersForSitesDirectoryController, superClass);

    RedesignUsersForSitesDirectoryController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignUsersForSitesDirectoryController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeUserRole'
    };

    RedesignUsersForSitesDirectoryController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "sortValue"
      }
    ];

    function RedesignUsersForSitesDirectoryController() {
      this.changeUserRole = bind(this.changeUserRole, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      this.renderRows = bind(this.renderRows, this);
      this.updateCallback = bind(this.updateCallback, this);
      this.search = bind(this.search, this);
      this.setUsers = bind(this.setUsers, this);
      RedesignUsersForSitesDirectoryController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "directoryHelper");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Users"
      }));
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.rows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInSite(this.item.id), false, function(row) {
          return row.user.fullName();
        });
        jQuery.get("/api/" + this.item.id + "/users/search", {
          'query': ''
        }).done(this.setUsers);
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "directory-subsection-grid fit-in-pane",
        columns: this.constructor.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/directory/single_column_check_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'users',
        unselectEnabled: true
      });
      App.UserRole.bind('create destroy', this.updateCallback);
      this.directoryHelper.bind('directory-loaded', this.updateCallback);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.grid.search = this.search;
      }
    }

    RedesignUsersForSitesDirectoryController.prototype.release = function() {
      var ref;
      App.UserRole.unbind('create', this.roleUpdated);
      App.UserRole.unbind('destroy', this.roleUpdated);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignUsersForSitesDirectoryController.__super__.release.apply(this, arguments);
    };

    RedesignUsersForSitesDirectoryController.prototype.getRows = function() {
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return this.rows;
      } else {
        return App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInSite(this.item.id), false, function(row) {
          return row.user.fullName();
        });
      }
    };

    RedesignUsersForSitesDirectoryController.prototype.setUsers = function(users) {
      this.rows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersInSiteFromSearch(this.item.id, users['users'].map(function(r) {
        return new App.User(r);
      })), false, function(row) {
        return row.user.fullName();
      });
      return this.grid.rerenderRows(this.rows);
    };

    RedesignUsersForSitesDirectoryController.prototype.search = function(searchTerm) {
      return jQuery.get("/api/" + this.item.id + "/users/search", {
        'query': searchTerm
      }).done(this.setUsers);
    };

    RedesignUsersForSitesDirectoryController.prototype.getEditingRows = function() {
      var unselectedRows;
      unselectedRows = App.ManipulateDirectoryForSimpleGrid.call(this.directoryHelper.usersNotInSite(this.item.id), true, function(row) {
        return row.user.fullName();
      });
      return this.getRows().concat(unselectedRows);
    };

    RedesignUsersForSitesDirectoryController.prototype.updateCallback = function() {
      if (!this.directoryHelper.hasLoaded()) {
        return;
      }
      if (!this.editing) {
        return this.renderRows();
      }
    };

    RedesignUsersForSitesDirectoryController.prototype.renderRows = function() {
      if (this.editing) {
        return this.grid.rerenderRows(this.getEditingRows());
      } else {
        return this.grid.rerenderRows(this.getRows());
      }
    };

    RedesignUsersForSitesDirectoryController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        this.editing = true;
      } else {
        this.sectionBody.removeClass("editing");
        this.editing = false;
      }
      return this.renderRows();
    };

    RedesignUsersForSitesDirectoryController.prototype.canBeUpdated = function() {
      return !this.editing;
    };

    RedesignUsersForSitesDirectoryController.prototype.changeUserRole = function(evt) {
      var row, rowEl, targetCheckbox, user;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      user = row.user;
      if (targetCheckbox.hasClass('selected')) {
        return user.addUserRole(this.item.id, {
          success: this.triggerCheckForUpdates
        });
      } else {
        return user.removeUserRole(this.item.id, {
          success: this.triggerCheckForUpdates
        });
      }
    };

    RedesignUsersForSitesDirectoryController.prototype.triggerCheckForUpdates = function() {
      return App.Site.trigger('request-several-updates');
    };

    return RedesignUsersForSitesDirectoryController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.InternalDatabaseConnectForm = (function(superClass) {
    extend(InternalDatabaseConnectForm, superClass);

    InternalDatabaseConnectForm.prototype.elements = {
      '.conn-errors': 'errorsPanel',
      '.db-loader': 'dbLoader',
      '.ssh-block.status': 'sshStatus',
      '.db-block.status': 'dbStatus',
      '[row="email_address"]': 'rowEmailAddress',
      '[row="display_name"]': 'rowDbDisplayName',
      '[row="database_name"]': 'rowDbName',
      '[row="host"]': 'rowDbHost',
      '[row="port"]': 'rowDbPort',
      '[row="username"]': 'rowDbUser',
      '[row="jdbc_command_type"]': 'rowJdbcCommandType',
      '[row="password"]': 'rowPassword',
      '[row="account_name"]': 'rowAccountName',
      '[row="warehouse_name"]': 'rowWarehouseName',
      '[row="httppath"]': 'rowHttppath',
      '[row="catalog"]': 'rowCatalog',
      '[row="snowflake_username"]': 'rowSnowflakeUsername',
      '[row="snowflake_password"]': 'rowSnowflakePassword',
      '[row="parent_database"]': 'parentDatabase',
      '[row="service_account"]': 'rowBigqueryServiceAccount',
      '[row="sql_dialect"]': 'rowBigquerySqlDialect',
      '[row="project_id"]': 'rowBigqueryProjectId',
      '[row="p12_key_file"]': 'rowBigqueryKeyFile',
      '[row="snowflake_pk8_key_file"]': 'rowSnowflakeKeyFile',
      '[row="command_type"]': 'rowCommandType',
      '[row="cloud_provider"]': 'rowCloudProvider',
      '[row="s3_staging_dir"]': 'rowS3StagingDir',
      '[row="cluster_name"]': 'rowClusterName',
      '.form [row="email_address"] input': 'fieldEmailAddress',
      '.form [row="display_name"] input': 'fieldDisplayName',
      '.form [row="database_name"] input': 'fieldDatabaseName',
      '.form [row="jdbc_command_type"] input': 'fieldOracleDatabaseName',
      '.form [row="host"] input': 'fieldHost',
      '.form [row="port"] input': 'fieldPort',
      '.form [row="username"] input': 'fieldUsername',
      '.form [row="password"] input': 'fieldPassword',
      '.form [row="account_name"] input': 'fieldAccountName',
      '.form [row="warehouse_name"] input': 'fieldWarehouseName',
      '.form [row="httppath"] input': 'fieldHttppath',
      '.form [row="catalog"] input': 'fieldCatalog',
      '.form [row="snowflake_username"] input': 'fieldSnowflakeUsername',
      '.form [row="snowflake_password"] input': 'fieldSnowflakePassword',
      '.form [row="parent_database"] select': 'parentDatabaseInput',
      '.form [row="service_account"] input': 'fieldServiceAccount',
      '.form [row="project_id"] input': 'fieldProjectId',
      '.form [row="p12_key_file"] input': 'fieldBigqueryKeyFile',
      '.form [row="snowflake_pk8_key_file"] input': 'fieldSnowflakePk8KeyFile',
      '.form [row="type"] select': 'databaseTypeInput',
      '.form [row="sql_dialect"] select': 'bigQuerySqlDialectInput',
      '.form [row="command_type"] select': 'commandTypeInput',
      '.form [row="cloud_provider"] select': 'cloudProviderInput',
      '.form [row="jdbc_command_type"] select': 'jdbcCommandTypeInput',
      '.form [row="cluster_name"] input': 'clusterNameInput',
      '.form [row="s3_staging_dir"] input': 's3StagingDirInput',
      '.key-file.p12 .file-name': 'divFileName',
      '.key-file.p12': 'divKeyFile',
      '.key-file.pk8 .file-name': 'divSnowflakePk8FileName',
      '.key-file.pk8': 'divSnowflakePk8KeyFile',
      '.form [row="ssh-host"] input': 'fieldSshHost',
      '.form [row="ssh-port"] input': 'fieldSshPort',
      '.form [row="ssh-username"] input': 'fieldSshUsername',
      '.errors': 'errorsBlock',
      '.errors .error.validation': 'errorValidation',
      '.errors .error': 'errorMessages',
      '#ssh-tunnel-error': 'sshTunnelError',
      '#connection-error': 'connectionStatus',
      '.connection-debug-info': 'connectionDebugInfo',
      '.connection-debug-info.ssl': 'connectionDebugInfoSsl',
      '.connection-debug-info.non-ssl': 'connectionDebugInfoNonSsl',
      '.errors .error .database_name': 'databaseNameInErrors',
      '.errors .error .username': 'usernameInErrors',
      '.errors .error .account_name': 'accountNameInErrors',
      '.errors .error.status-ok': 'successMessageEl',
      '.errors .error-unexpected .full-msg': 'unexpectedErrorFullMessageEl',
      '.errors .error-link': 'errorLinks',
      '.signup-form': 'signupForm',
      '.ssh-tunnel': 'sshTunnel',
      '.ssh-tunnel-form': 'sshTunnelForm',
      '.ssh-tunnel.help': 'sshTunnelHelp',
      '.private-network': 'privateNetwork',
      '.more-info': 'moreInfo',
      '.ssh-tunnel-doc': 'sshTunnelDoc',
      '.key-file.p12 .default-text': 'defaultBigqueryKeyFileText',
      '.key-file.pk8 .default-text': 'defaultSnowflakeKeyFileText',
      '.salesforce [row="client_id"] input': 'salesforceClientId',
      '.salesforce [row="client_secret"] input': 'salesforceClientSecret',
      '.salesforce [row="login_name"] input': 'salesforceLoginName',
      '.salesforce [row="login_password"] input': 'salesforceLoginPassword',
      '.salesforce [row="security_token"] input': 'salesforceSecurityToken',
      '#specific-database-fields': 'specificDatabaseFields',
      '.button-row': 'buttonRow'
    };

    InternalDatabaseConnectForm.prototype.events = {
      'click .button.submit': 'submit',
      'change [row="type"] select': 'databaseTypeChanged',
      'change .form [row="p12_key_file"] input': 'handleKeyFileSet',
      'change .form [row="snowflake_pk8_key_file"] input': 'handleSnowflakePk8KeyFileSet',
      'keyup .form input': 'formInputKeyup',
      'click .private-network': 'privateNetworkClicked'
    };

    InternalDatabaseConnectForm.STATUS_ERROR_UNEXPECTED = 'error-unexpected';

    InternalDatabaseConnectForm.STATUS_OK = 'status-ok';

    InternalDatabaseConnectForm.STATUS_PENDING = 'pending';

    InternalDatabaseConnectForm.STATUS_VALIDATION = 'validation';

    InternalDatabaseConnectForm.POLL_INTERVAL = 2000;

    InternalDatabaseConnectForm.FORM_FIELDS = ['email_address', 'database_name', 'host', 'port', 'username', 'password'];

    InternalDatabaseConnectForm.SYBASE = 'sybase';

    InternalDatabaseConnectForm.BIGQUERY = 'bigquery';

    InternalDatabaseConnectForm.BIGQUERY_STANDARD = 'bigquery_standard';

    InternalDatabaseConnectForm.SNOWFLAKE = 'snowflake';

    InternalDatabaseConnectForm.PRESTO = 'presto';

    InternalDatabaseConnectForm.QUBOLE = 'QuboleDatabase';

    InternalDatabaseConnectForm.ORACLE = 'oracle';

    InternalDatabaseConnectForm.ATHENA = 'AthenaDatabase';

    InternalDatabaseConnectForm.DATABRICKS = 'databricks';

    InternalDatabaseConnectForm.P12FILE_SIZE_LIMIT = 5000;

    InternalDatabaseConnectForm.NONE_PARENT_ID = "-1";

    function InternalDatabaseConnectForm() {
      this.setSnowflakePk8KeyFileHandle = bind(this.setSnowflakePk8KeyFileHandle, this);
      this.handleSnowflakePk8KeyFileSet = bind(this.handleSnowflakePk8KeyFileSet, this);
      this.uploadSnowflakePk8Start = bind(this.uploadSnowflakePk8Start, this);
      this.setKeyFileHandle = bind(this.setKeyFileHandle, this);
      this.handleKeyFileSet = bind(this.handleKeyFileSet, this);
      this.uploadComplete = bind(this.uploadComplete, this);
      this.uploadFailed = bind(this.uploadFailed, this);
      this.uploadStart = bind(this.uploadStart, this);
      this.showConnectionLoader = bind(this.showConnectionLoader, this);
      this.updateParentChildRelationship = bind(this.updateParentChildRelationship, this);
      this.showConnectionResults = bind(this.showConnectionResults, this);
      this.stopDoctorPolling = bind(this.stopDoctorPolling, this);
      this.startDoctorPolling = bind(this.startDoctorPolling, this);
      this.handleDbResponse = bind(this.handleDbResponse, this);
      this.doctorResponse = bind(this.doctorResponse, this);
      this.pollDoctor = bind(this.pollDoctor, this);
      this.validateForm = bind(this.validateForm, this);
      this.formInputKeyup = bind(this.formInputKeyup, this);
      this.handleSshTunnelResponse = bind(this.handleSshTunnelResponse, this);
      this.testDatabase = bind(this.testDatabase, this);
      this.testSshTunnel = bind(this.testSshTunnel, this);
      this.validateAndSubmit = bind(this.validateAndSubmit, this);
      this.submit = bind(this.submit, this);
      this.cancelFunc = bind(this.cancelFunc, this);
      var database_type;
      InternalDatabaseConnectForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'extraParams', 'sshTunnelRoute', 'submitRoute', 'newCustomer', 'successMessage');
      this.polling = false;
      this.html(this.view('redesign/internal/database_form')({
        newCustomer: this.newCustomer
      }));
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancelFunc,
        saveFunc: this.submit,
        saveText: 'Test!',
        hideCancel: true
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
      if (!this.addDb) {
        this.cancelSaveBlock.setSaveDisabled(true);
      }
      if (this.initialValues != null) {
        database_type = this.initialValues.database_type === this.constructor.BIGQUERY_STANDARD ? this.constructor.BIGQUERY : this.initialValues.database_type;
        this.databaseTypeInput.val(database_type);
        if (this.initialValues.database_type === 'SalesforceDatabase') {
          this.databaseTypeInput.prop('disabled', true);
        }
      } else {
        this.initialValues = {};
      }
      if (this.newCustomer) {
        this.moreInfo.hide();
      } else {
        this.sshTunnelDoc.hide();
      }
      this.databaseTypeInput.chosen({
        disable_search: true,
        width: '100%'
      });
      this.render();
    }

    InternalDatabaseConnectForm.prototype.cancelFunc = function() {
      return this.trigger('close-dialog');
    };

    InternalDatabaseConnectForm.prototype.render = function() {
      this.specificDatabaseFields.html(this.specificDatabase().renderSpecificDatabaseFields());
      this.fieldDisplayName.val(this.initialValues.display_name);
      if (this.infoGrid != null) {
        this.$('.form').addClass('info-grid');
      }
      this.refreshElements();
      return this.specificDatabase().render();
    };

    InternalDatabaseConnectForm.prototype.replicaDatabaseNames = function(values) {
      var d, databaseNames, databases, i, len;
      databaseNames = {};
      databases = App.Database.allSortedByName();
      for (i = 0, len = databases.length; i < len; i++) {
        d = databases[i];
        if (!(!d.warehouse)) {
          continue;
        }
        if ((values != null ? values.display_name : void 0) === d.database_name) {
          continue;
        }
        databaseNames[d.database_name] = d.id;
      }
      return databaseNames;
    };

    InternalDatabaseConnectForm.prototype.submit = function() {
      this.clearErrors();
      this.hideErrors();
      return this.validateAndSubmit();
    };

    InternalDatabaseConnectForm.prototype.clearErrors = function() {
      this.sshStatus.hide();
      this.dbStatus.hide();
      this.connectionStatus.removeClass('success').addClass('errors warning-icon').hide();
      this.connectionDebugInfo.hide();
      return this.sshTunnelError.hide();
    };

    InternalDatabaseConnectForm.prototype.validateAndSubmit = function() {
      if (!this.validateForm()) {
        return;
      }
      if (this.sshTunnelExists()) {
        return this.testSshTunnel();
      } else {
        return this.testDatabase();
      }
    };

    InternalDatabaseConnectForm.prototype.testSshTunnel = function() {
      this.sshStatus.show();
      return $.post(this.sshTunnelRoute, _.omit(this.formParams(), 'p12_key_file')).done(this.handleSshTunnelResponse);
    };

    InternalDatabaseConnectForm.prototype.testDatabase = function() {
      $.post(this.submitRoute, _.omit(this.formParams(), 'p12_key_file')).done(this.handleDbResponse);
      return this.dbStatus.show();
    };

    InternalDatabaseConnectForm.prototype.handleSshTunnelResponse = function(response) {
      var sshErrorText;
      sshErrorText = _.includes(response.ssh_tunnel_result, 'connection refused') ? 'Connection refused: Port may be behind a firewall.' : response.ssh_tunnel_result;
      if (response.ssh_tunnel_result === "OK") {
        this.sshTunnelError.text(this.successMessage);
        this.sshTunnelError.addClass('success').removeClass('errors warning-icon');
        this.testDatabase();
      } else {
        this.sshTunnelError.text(sshErrorText);
      }
      return this.sshTunnelError.show();
    };

    InternalDatabaseConnectForm.prototype.formParams = function() {
      var base, cloud_provider, command_type, databaseName, databaseType, host, k, params, password, ref, username, v;
      databaseType = this.databaseType();
      if (databaseType === this.constructor.SNOWFLAKE) {
        host = this.fieldAccountName.val();
        username = this.fieldSnowflakeUsername.val();
        password = this.fieldSnowflakePassword.val();
      } else {
        host = this.fieldHost.val();
        username = this.specificDatabase().username();
        password = this.specificDatabase().password();
      }
      command_type = databaseType === this.constructor.QUBOLE ? this.commandTypeInput.val() : databaseType === this.constructor.ORACLE ? this.jdbcCommandTypeInput.val() : '';
      cloud_provider = databaseType === this.constructor.QUBOLE ? this.cloudProviderInput.val() : '';
      databaseName = databaseType === this.constructor.ORACLE ? this.fieldOracleDatabaseName.val() : this.fieldDatabaseName.val();
      params = $.extend({
        database_type: databaseType,
        email_address: this.fieldEmailAddress.val(),
        database_name: databaseName,
        project_id: this.fieldProjectId.val(),
        display_name: this.fieldDisplayName.val(),
        host: host,
        port: this.fieldPort.val(),
        username: username,
        service_account: this.fieldServiceAccount.val(),
        password: password,
        ssh_host: this.fieldSshHost.val(),
        ssh_port: this.fieldSshPort.val(),
        ssh_username: this.fieldSshUsername.val(),
        p12_key_file: this.validKeyFile,
        sql_dialect: this.bigQuerySqlDialectInput.val(),
        parent_database_id: this.parentId(),
        specific_database_attributes: typeof (base = this.specificDatabase()).attributes === "function" ? base.attributes() : void 0,
        warehouse_name: this.fieldWarehouseName.val(),
        httppath: this.fieldHttppath.val(),
        catalog: this.fieldCatalog.val(),
        command_type: command_type,
        cloud_provider: cloud_provider,
        cluster_name: this.clusterNameInput.val(),
        s3_staging_dir: this.s3StagingDirInput.val()
      }, this.extraParams);
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        params = $.extend(params, {
          snowflake_pk8_key_file: this.validSnowflakePk8KeyFile,
          snowflake_pk8_pwd: this.fieldSnowflakePk8Pwd.val()
        });
      }
      for (k in params) {
        v = params[k];
        if (typeof v === 'string') {
          params[k] = v.trim();
        }
      }
      return params;
    };

    InternalDatabaseConnectForm.prototype.formInputKeyup = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        this.submit();
      }
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    InternalDatabaseConnectForm.prototype.unfinishedForm = function() {
      if (!this.isSshFormReadyForSubmission()) {
        return true;
      }
      return _.find(this.el.find('input'), this.isEmptyInput) != null;
    };

    InternalDatabaseConnectForm.prototype.sshTunnelExists = function() {
      return !_.isEmpty(this.fieldSshHost.val()) && !_.isEmpty(this.fieldSshPort.val()) && !_.isEmpty(this.fieldSshUsername.val());
    };

    InternalDatabaseConnectForm.prototype.isSshFormReadyForSubmission = function() {
      if (_.isEmpty(this.fieldSshHost.val())) {
        return true;
      } else {
        return !_.isEmpty(this.fieldSshPort.val()) && !_.isEmpty(this.fieldSshUsername.val());
      }
    };

    InternalDatabaseConnectForm.prototype.isEmptyInput = function(inputEl) {
      var input;
      input = $(inputEl);
      if (input.hasClass("optional")) {
        return false;
      }
      return input.closest('td').attr('row') !== 'display_name' && input.is(":visible") && input.val().length === 0;
    };

    InternalDatabaseConnectForm.prototype.databaseType = function() {
      return this.databaseTypeInput.val();
    };

    InternalDatabaseConnectForm.prototype.parentId = function() {
      return this.parentDatabaseInput.val() || App.InternalDatabaseConnectForm.NONE_PARENT_ID;
    };

    InternalDatabaseConnectForm.prototype.validateForm = function() {
      var errorFields, errorMessages, field, missingFields, msg, titleizedFields;
      missingFields = this.specificDatabase().missingFields();
      if (this.databaseType() === this.constructor.SNOWFLAKE) {
        if (missingFields.includes('username')) {
          missingFields.push('snowflake_username');
        }
        if (missingFields.includes('password')) {
          missingFields.push('snowflake_password');
        }
        if (missingFields.includes('host')) {
          missingFields.push('account_name');
        }
        missingFields = missingFields.withoutAny(['username', 'password', 'host']);
      }
      errorFields = [].concat(missingFields);
      errorMessages = [];
      this.markFieldsAsErrors(errorFields);
      if (errorFields.length > 0) {
        if (missingFields.length > 0) {
          titleizedFields = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = missingFields.length; i < len; i++) {
              field = missingFields[i];
              results.push(App.Utils.titleize(field));
            }
            return results;
          })();
          msg = "Missing required field";
          if (titleizedFields.length > 1) {
            msg = msg.pluralize();
          }
          errorMessages.push(msg + ": " + (titleizedFields.join(', ')));
        }
        this.errorValidation.text(errorMessages.join('\n'));
        this.showError(this.constructor.STATUS_VALIDATION);
        return false;
      } else {
        return true;
      }
    };

    InternalDatabaseConnectForm.prototype.removeAllErrors = function() {
      return this.$('.form input').removeClass('error');
    };

    InternalDatabaseConnectForm.prototype.markFieldsAsErrors = function(errorFields) {
      var field, i, len, ref;
      this.removeAllErrors();
      if (errorFields.isEmpty()) {
        return;
      }
      for (i = 0, len = errorFields.length; i < len; i++) {
        field = errorFields[i];
        this.$(".form [row=\"" + field + "\"] input").addClass('error');
        if (field === 'database_name') {
          this.fieldOracleDatabaseName.addClass('error');
        }
      }
      if (errorFields.includes('p12_key_file')) {
        this.divKeyFile.addClass('error');
      }
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        if (errorFields.includes('snowflake_pk8_key_file')) {
          return this.divSnowflakePk8KeyFile.addClass('error');
        }
      }
    };

    InternalDatabaseConnectForm.prototype.bigqueryRows = function() {
      return [this.rowBigqueryServiceAccount, this.rowBigquerySqlDialect, this.rowBigqueryProjectId, this.rowBigqueryKeyFile];
    };

    InternalDatabaseConnectForm.prototype.standardRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    InternalDatabaseConnectForm.prototype.oracleRows = function() {
      return [this.rowJdbcCommandType, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    InternalDatabaseConnectForm.prototype.quboleRows = function() {
      return [this.rowDbUser, this.rowPassword, this.rowCommandType, this.rowClusterName, this.rowCloudProvider];
    };

    InternalDatabaseConnectForm.prototype.athenaRows = function() {
      return [this.rowDbHost, this.rowDbPort, this.rowS3StagingDir, this.rowDbUser, this.rowPassword];
    };

    InternalDatabaseConnectForm.prototype.databricksRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowHttppath, this.rowCatalog, this.rowDbUser, this.rowPassword];
    };

    InternalDatabaseConnectForm.prototype.replicaRows = function() {
      return [this.parentDatabase];
    };

    InternalDatabaseConnectForm.prototype.snowflakeRows = function() {
      var ref, rows;
      rows = [this.rowDbName, this.rowAccountName, this.rowWarehouseName, this.rowSnowflakeUsername, this.rowSnowflakePassword];
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        rows = rows.concat([this.rowSnowflakeKeyFile, this.rowSnowflakePk8KeyFile]);
      }
      return rows;
    };

    InternalDatabaseConnectForm.prototype.specificDatabase = function() {
      var databaseClass, ref;
      databaseClass = (ref = App.InternalDatabaseConnectForm[(this.databaseType()) + "ConnectForm"]) != null ? ref : App.InternalDatabaseConnectForm.GenericDatabaseConnectForm;
      return this._specificDatabase = new databaseClass(this);
    };

    InternalDatabaseConnectForm.SalesforceDatabaseConnectForm = (function() {
      SalesforceDatabaseConnectForm.SALESFORCE_FIELDS = ['display_name', 'login_name', 'login_password', 'security_token', 'client_id', 'client_secret'];

      function SalesforceDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
      }

      SalesforceDatabaseConnectForm.prototype.render = function() {
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.toggleSshTunnel(false);
        return this.databaseConnectForm.togglePrivateNetwork(false);
      };

      SalesforceDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('redesign/settings/salesforce_form')({
          initialValues: this.databaseConnectForm.initialValues
        });
      };

      SalesforceDatabaseConnectForm.prototype.username = function() {
        return this.databaseConnectForm.salesforceLoginName.val();
      };

      SalesforceDatabaseConnectForm.prototype.password = function() {
        return this.databaseConnectForm.salesforceLoginPassword.val();
      };

      SalesforceDatabaseConnectForm.prototype.attributes = function() {
        var ref;
        return {
          id: (ref = this.databaseConnectForm.initialValues) != null ? ref.specific_database_id : void 0,
          client_id: this.databaseConnectForm.salesforceClientId.val(),
          client_secret: this.databaseConnectForm.salesforceClientSecret.val(),
          login_token: this.databaseConnectForm.salesforceSecurityToken.val()
        };
      };

      SalesforceDatabaseConnectForm.prototype.requiredFields = function() {
        return this.constructor.SALESFORCE_FIELDS;
      };

      SalesforceDatabaseConnectForm.prototype.missingFields = function() {
        var field, formParams, requiredFields, salesforceParams;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        formParams = this.databaseConnectForm.formParams();
        salesforceParams = {
          'client_id': formParams.specific_database_attributes['client_id'],
          'client_secret': formParams.specific_database_attributes['client_secret'],
          'security_token': formParams.specific_database_attributes['login_token'],
          'login_name': formParams['username'],
          'login_password': formParams['password'],
          'display_name': formParams['display_name']
        };
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (salesforceParams[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      return SalesforceDatabaseConnectForm;

    })();

    InternalDatabaseConnectForm.GenericDatabaseConnectForm = (function() {
      GenericDatabaseConnectForm.PLACEHOLDERS = {
        "default": ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        postgres: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        redshift: ["db1.abcdefg.us-east-1.redshift.amazonaws.com", "5439"],
        mysql: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "3306"],
        vertica: ["db1.company.com", "5433"],
        sql_server: ["db1.company.com", "1433"],
        oracle: ["db1.company.com", "1521"],
        memsql: ["ec2-154-43-211-119.compute-1.amazonaws.com", "3306"],
        sybase: ["db1.company.com", "5000"],
        bigquery: ["N/A", "N/A"],
        exasol: ["192.168.100.5", "8563"],
        presto: ["db1.company.com", "8080"],
        AthenaDatabase: ["athena.us-east-1.amazonaws.com", "443"]
      };

      function GenericDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
        this.handleSnowflakePk8Drop = bind(this.handleSnowflakePk8Drop, this);
        this.handleDrop = bind(this.handleDrop, this);
      }

      GenericDatabaseConnectForm.prototype.render = function() {
        var hasSsh, i, j, l, len, len1, len2, len3, len4, len5, len6, m, n, o, p, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, row, sshDisabled;
        if (this.databaseConnectForm.newCustomer || App.Database.countWithReplicas() <= 1) {
          this.databaseConnectForm.parentDatabase.hide();
        }
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.parentDatabaseInput.chosen({
          disable_search: true,
          width: '100%',
          placeholder_text_single: 'None'
        });
        if (this.databaseConnectForm.initialValues != null) {
          this.populateForm();
        } else {
          this.populateBlankForm();
        }
        ref = this.databaseConnectForm.standardRows();
        for (i = 0, len = ref.length; i < len; i++) {
          row = ref[i];
          row.hide();
        }
        ref1 = this.databaseConnectForm.bigqueryRows();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          row = ref1[j];
          row.hide();
        }
        ref2 = this.databaseConnectForm.snowflakeRows();
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          row = ref2[l];
          row.hide();
        }
        ref3 = this.databaseConnectForm.databricksRows();
        for (m = 0, len3 = ref3.length; m < len3; m++) {
          row = ref3[m];
          row.hide();
        }
        ref4 = this.databaseConnectForm.quboleRows();
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          row = ref4[n];
          row.hide();
        }
        ref5 = this.databaseConnectForm.athenaRows();
        for (o = 0, len5 = ref5.length; o < len5; o++) {
          row = ref5[o];
          row.hide();
        }
        ref6 = this.databaseConnectForm.oracleRows();
        for (p = 0, len6 = ref6.length; p < len6; p++) {
          row = ref6[p];
          row.hide();
        }
        this.databaseConnectForm.sshStatus.hide();
        this.databaseConnectForm.dbStatus.hide();
        hasSsh = (this.databaseConnectForm.initialValues.ssh_host != null) && this.databaseConnectForm.initialValues.ssh_host !== "";
        sshDisabled = [App.InternalDatabaseConnectForm.BIGQUERY, App.InternalDatabaseConnectForm.SNOWFLAKE].includes(this.databaseConnectForm.databaseType());
        this.databaseConnectForm.showSshForm(hasSsh && !sshDisabled);
        this.databaseConnectForm.togglePrivateNetwork(!(sshDisabled || hasSsh));
        this.showRows();
        if (this.databaseConnectForm.databaseType() === App.InternalDatabaseConnectForm.BIGQUERY) {
          this.databaseConnectForm.bigQuerySqlDialectInput.chosen({
            disable_search: true,
            width: '100%'
          });
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('drop', this.handleDrop, false);
        } else if (this.databaseConnectForm.fieldBigqueryKeyFile.length > 0) {
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('drop', this.handleDrop, false);
        }
        if ((ref7 = App.Site.first()) != null ? ref7.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.SNOWFLAKE) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('drop', this.handleSnowflakePk8Drop, false);
          } else if (this.databaseConnectForm.fieldSnowflakePk8KeyFile.length > 0) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('drop', this.handleSnowflakePk8Drop, false);
          }
        }
        if (this.databaseConnectForm.databaseType() === App.InternalDatabaseConnectForm.QUBOLE) {
          this.databaseConnectForm.commandTypeInput.chosen({
            disable_search: true,
            width: '100%'
          });
          this.databaseConnectForm.cloudProviderInput.chosen({
            disable_search: true,
            width: '100%'
          });
        } else if (this.databaseConnectForm.databaseType() === App.InternalDatabaseConnectForm.ORACLE) {
          this.databaseConnectForm.jdbcCommandTypeInput.chosen({
            disable_search: true,
            width: '119px'
          });
        }
        return this.setPlaceholderText();
      };

      GenericDatabaseConnectForm.prototype.populateForm = function() {
        this.databaseConnectForm.databaseTypeInput.trigger('chosen:updated');
        if (this.databaseConnectForm.initialValues.has_child) {
          this.databaseConnectForm.parentDatabaseInput.prop('disabled', true);
        }
        this.databaseConnectForm.parentDatabaseInput.val(this.databaseConnectForm.initialValues.parent_database_id || App.InternalDatabaseConnectForm.NONE_PARENT_ID);
        this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
        this.databaseConnectForm.fieldEmailAddress.val(this.databaseConnectForm.initialValues.email_address);
        this.databaseConnectForm.fieldDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
        this.databaseConnectForm.fieldHost.val(this.databaseConnectForm.initialValues.host);
        this.databaseConnectForm.fieldPort.val(this.databaseConnectForm.initialValues.port);
        this.databaseConnectForm.fieldUsername.val(this.databaseConnectForm.initialValues.username);
        if (this.databaseConnectForm.initialValues.ssh_host != null) {
          this.databaseConnectForm.fieldSshHost.val(this.databaseConnectForm.initialValues.ssh_host);
        }
        if (this.databaseConnectForm.initialValues.ssh_port != null) {
          this.databaseConnectForm.fieldSshPort.val(this.databaseConnectForm.initialValues.ssh_port);
        }
        if (this.databaseConnectForm.initialValues.ssh_username != null) {
          this.databaseConnectForm.fieldSshUsername.val(this.databaseConnectForm.initialValues.ssh_username);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.BIGQUERY) {
          this.databaseConnectForm.fieldServiceAccount.val(this.databaseConnectForm.initialValues.username);
          this.databaseConnectForm.fieldProjectId.val(this.databaseConnectForm.initialValues.database_name);
          this.databaseConnectForm.bigQuerySqlDialectInput.val(this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.BIGQUERY ? 'legacy' : 'standard');
        }
        if (this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.SNOWFLAKE) {
          this.databaseConnectForm.fieldWarehouseName.val(this.databaseConnectForm.initialValues.warehouse_name);
          this.databaseConnectForm.fieldAccountName.val(this.databaseConnectForm.initialValues.host);
          this.databaseConnectForm.fieldSnowflakeUsername.val(this.databaseConnectForm.initialValues.username);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.QUBOLE) {
          this.databaseConnectForm.clusterNameInput.val(this.databaseConnectForm.initialValues.cluster_name);
          this.databaseConnectForm.commandTypeInput.val(this.databaseConnectForm.initialValues.command_type);
          this.databaseConnectForm.commandTypeInput.val(this.databaseConnectForm.initialValues.cloud_provider);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.ATHENA) {
          this.databaseConnectForm.s3StagingDirInput.val(this.databaseConnectForm.initialValues.s3_staging_dir);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.ORACLE) {
          this.databaseConnectForm.fieldOracleDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
          return this.databaseConnectForm.jdbcCommandTypeInput.val(this.databaseConnectForm.initialValues.command_type === 'service_name' ? 'service_name' : 'sid');
        }
      };

      GenericDatabaseConnectForm.prototype.populateBlankForm = function() {
        this.databaseConnectForm.parentDatabaseInput.val(App.InternalDatabaseConnectForm.NONE_PARENT_ID);
        return this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
      };

      GenericDatabaseConnectForm.prototype.setPlaceholderText = function() {
        var placeholders;
        placeholders = this.constructor.PLACEHOLDERS[this.databaseConnectForm.databaseType()];
        if (placeholders != null) {
          return this.databaseConnectForm.setPlaceholders(placeholders[0], placeholders[1]);
        }
      };

      GenericDatabaseConnectForm.prototype.handleDragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleDrop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setKeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8DragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8Drop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setSnowflakePk8KeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.showRows = function() {
        var i, len, results, row, rows;
        rows = (function() {
          switch (this.databaseConnectForm.databaseType()) {
            case App.InternalDatabaseConnectForm.BIGQUERY:
              return this.databaseConnectForm.bigqueryRows();
            case App.InternalDatabaseConnectForm.SNOWFLAKE:
              return this.databaseConnectForm.snowflakeRows();
            case App.InternalDatabaseConnectForm.QUBOLE:
              return this.databaseConnectForm.quboleRows();
            case App.InternalDatabaseConnectForm.ATHENA:
              return this.databaseConnectForm.athenaRows();
            case App.InternalDatabaseConnectForm.ORACLE:
              return this.databaseConnectForm.oracleRows();
            case App.InternalDatabaseConnectForm.DATABRICKS:
              return this.databaseConnectForm.databricksRows();
            default:
              return this.databaseConnectForm.standardRows();
          }
        }).call(this);
        results = [];
        for (i = 0, len = rows.length; i < len; i++) {
          row = rows[i];
          results.push(row.show());
        }
        return results;
      };

      GenericDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('redesign/settings/non_polymorphic_form_fields')({
          moreHelp: this.databaseConnectForm.view('databases/more_help')(),
          databaseNames: this.databaseConnectForm.replicaDatabaseNames(this.databaseConnectForm.initialValues)
        });
      };

      GenericDatabaseConnectForm.prototype.username = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakeUsername.val();
        } else {
          return this.databaseConnectForm.fieldUsername.val();
        }
      };

      GenericDatabaseConnectForm.prototype.password = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakePassword.val();
        } else {
          return this.databaseConnectForm.fieldPassword.val();
        }
      };

      GenericDatabaseConnectForm.prototype.missingFields = function() {
        var field, params, requiredFields;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        params = this.databaseConnectForm.formParams();
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (params[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      GenericDatabaseConnectForm.prototype.requiredFields = function() {
        var constructor;
        constructor = this.databaseConnectForm.constructor;
        switch (this.databaseConnectForm.databaseType()) {
          case constructor.BIGQUERY:
            return ['service_account', 'project_id', 'email_address', 'p12_key_file'];
          case constructor.SNOWFLAKE:
            return ['email_address', 'database_name', 'warehouse_name', 'host', 'username'];
          case constructor.PRESTO:
            return ['email_address', 'host', 'port', 'username'];
          case constructor.QUBOLE:
            return ['display_name', 'username', 'password', 'cluster_name', 'command_type', 'cloud_provider'];
          case constructor.ATHENA:
            return ['display_name', 'host', 'port', 's3_staging_dir', 'username', 'password'];
          case constructor.DATABRICKS:
            return ['display_name', 'host', 'httppath', 'catalog', 'username', 'password', 'database_name'];
          default:
            return constructor.FORM_FIELDS;
        }
      };

      return GenericDatabaseConnectForm;

    })();

    InternalDatabaseConnectForm.prototype.databaseTypeChanged = function() {
      this.initialValues = this.formParams();
      this.hideErrors();
      this.render();
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    InternalDatabaseConnectForm.prototype.setPlaceholders = function(host, port) {
      this.fieldHost.attr('placeholder', host);
      return this.fieldPort.attr('placeholder', port);
    };

    InternalDatabaseConnectForm.prototype.showError = function(status) {
      var filter, foundError;
      filter = "." + status + "[databases~=\"" + (this.databaseType()) + "\"], ." + status + ":not([databases])";
      foundError = this.errorMessages.filter(filter);
      foundError.slideDown();
      this.errorMessages.not(foundError).slideUp();
      if (!(foundError.length > 0)) {
        this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      }
      return this.maybeShowErrorLink(foundError);
    };

    InternalDatabaseConnectForm.prototype.maybeShowErrorLink = function(foundError) {
      var databaseToDoc;
      this.errorsBlock.find('.error-link').remove();
      if (this.databaseType() !== 'sql_server') {
        return;
      }
      databaseToDoc = {
        'sql_server': 'connecting-sql-server'
      };
      if (foundError.find('.help-connecting').length === 0) {
        return foundError.append(this.view('databases/error_link')({
          link: databaseToDoc[this.databaseType()]
        }));
      }
    };

    InternalDatabaseConnectForm.prototype.substituteErrors = function() {
      this.databaseNameInErrors.text(this.formParams()['database_name']);
      this.usernameInErrors.text(this.formParams()['username']);
      return this.accountNameInErrors.text(this.formParams()['host']);
    };

    InternalDatabaseConnectForm.prototype.pollDoctor = function() {
      return $.post(this.pollRoute, this.extraParams).fail(this.handleAjaxError).done(this.doctorResponse);
    };

    InternalDatabaseConnectForm.prototype.doctorResponse = function(response) {
      if (response.status === this.constructor.STATUS_PENDING) {
        return;
      }
      this.stopDoctorPolling();
      this.updateStatus(response.status, response.error);
      this.showConnectionResults();
      this.updateParentChildRelationship();
      if (response.status === this.constructor.STATUS_OK) {
        App.Database.applyUpdates([response.db]);
        return this.trigger('database-connection-success', response.id);
      }
    };

    InternalDatabaseConnectForm.prototype.handleDbResponse = function(response) {
      var errorParts;
      if (response.connection_success) {
        this.connectionStatus.text(this.successMessage);
        this.connectionStatus.addClass('success').removeClass('errors warning-icon');
      } else {
        if (!_.isEmpty(response.connection_error)) {
          this.connectionStatus.text(response.connection_error);
        } else {
          this.connectionStatus.text("Connection failed");
        }
        if (!_.isEmpty(response.connection_debug_info)) {
          errorParts = _.split(_.split(response.connection_debug_info, 'sslError=')[1], '. | nonSslError=');
          this.connectionDebugInfoSsl.text(errorParts[0]);
          this.connectionDebugInfoNonSsl.text(errorParts[1]);
          this.connectionDebugInfo.show();
        }
      }
      return this.connectionStatus.show();
    };

    InternalDatabaseConnectForm.prototype.updateStatus = function(status, fullError) {
      if (fullError == null) {
        fullError = "";
      }
      this.unexpectedErrorFullMessageEl.text(fullError);
      this.substituteErrors();
      return this.showError(status);
    };

    InternalDatabaseConnectForm.prototype.startDoctorPolling = function() {
      this.stopDoctorPolling();
      this.polling = true;
      return this.doctorInterval = setInterval(this.pollDoctor, this.constructor.POLL_INTERVAL);
    };

    InternalDatabaseConnectForm.prototype.stopDoctorPolling = function() {
      this.polling = false;
      clearInterval(this.doctorInterval);
      return this.doctorInterval = null;
    };

    InternalDatabaseConnectForm.prototype.showConnectionResults = function() {
      return this.dbLoader.hide();
    };

    InternalDatabaseConnectForm.prototype.updateParentChildRelationship = function() {
      var parentDb, parentId, ref;
      parentId = this.parentId();
      App.Database.trigger('parent-database-added', parentId);
      if (!((parentId != null) && parentId !== App.InternalDatabaseConnectForm.NONE_PARENT_ID)) {
        return;
      }
      parentDb = App.Database.find(parentId);
      parentDb.has_child = true;
      parentDb.save({
        ajax: false
      });
      return (ref = App.User.currentUser()) != null ? ref.setLastUsedDatabase(parentId) : void 0;
    };

    InternalDatabaseConnectForm.prototype.showConnectionLoader = function() {
      this.dbLoader.fadeIn();
      this.dbLoader.css('display', 'block');
      return this.hideErrors();
    };

    InternalDatabaseConnectForm.prototype.hideErrors = function() {
      this.errorMessages.hide();
      return this.errorLinks.hide();
    };

    InternalDatabaseConnectForm.prototype.privateNetworkClicked = function() {
      this.toggleSshTunnel(true);
      return this.togglePrivateNetwork(false);
    };

    InternalDatabaseConnectForm.prototype.showSshForm = function(show) {
      this.sshTunnelHelp.toggle(show);
      return this.sshTunnelForm.toggle(show);
    };

    InternalDatabaseConnectForm.prototype.toggleSshTunnel = function(show) {
      this.sshTunnelHelp.toggle(show);
      if (show) {
        return this.sshTunnelForm.slideDown();
      } else {
        return this.sshTunnelForm.slideUp();
      }
    };

    InternalDatabaseConnectForm.prototype.togglePrivateNetwork = function(show) {
      return this.privateNetwork.toggle(show);
    };

    InternalDatabaseConnectForm.prototype.readFile = function() {
      var reader;
      reader = new FileReader();
      if (this.keyFile == null) {
        this.keyFile = this.fieldBigqueryKeyFile.val();
      }
      reader.file = this.keyFile;
      reader.onload = this.uploadStart;
      reader.readAsBinaryString(this.keyFile);
      return this.keyFileSize = this.keyFile.size;
    };

    InternalDatabaseConnectForm.prototype.uploadStart = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadKeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keyFileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    InternalDatabaseConnectForm.prototype.uploadFailed = function(xhr, msg, err) {
      this.errorValidation.text('Key file upload failed.');
      this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      return this.showConnectionResults();
    };

    InternalDatabaseConnectForm.prototype.uploadComplete = function() {
      return this.startDoctorPolling();
    };

    InternalDatabaseConnectForm.prototype.handleKeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      this.setKeyFileHandle(evt.target.files[0]);
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    InternalDatabaseConnectForm.prototype.setKeyFileHandle = function(file) {
      if (!file.type.match('application/x-pkcs12')) {
        return this.keyFileError('Key file should be of type .p12');
      } else if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keyFileError('Maximum key file size is 5KB');
      } else {
        this.defaultBigqueryKeyFileText.hide();
        this.errorValidation.text('');
        this.divKeyFile.removeClass('error');
        this.keyFile = file;
        this.divFileName.text(file.name);
        return this.validKeyFile = file.name;
      }
    };

    InternalDatabaseConnectForm.prototype.keyFileError = function(message) {
      this.divFileName.text('');
      this.divKeyFile.addClass('error');
      this.defaultBigqueryKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validKeyFile = '';
    };

    InternalDatabaseConnectForm.prototype.readSnowflakePk8File = function() {
      var reader;
      reader = new FileReader();
      if (this.keySnowflakePk8File == null) {
        this.keySnowflakePk8File = this.fieldSnowflakePk8KeyFile.val();
      }
      if (this.keySnowflakePk8File) {
        reader.file = this.keySnowflakePk8File;
        reader.onload = this.uploadSnowflakePk8Start;
        reader.readAsBinaryString(this.keySnowflakePk8File);
        return this.keySnowflakePk8FileSize = this.keySnowflakePk8File.size;
      } else {
        return this.startDoctorPolling();
      }
    };

    InternalDatabaseConnectForm.prototype.uploadSnowflakePk8Start = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadSnowflakePk8KeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keySnowflakePk8FileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    InternalDatabaseConnectForm.prototype.handleSnowflakePk8KeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      this.setSnowflakePk8KeyFileHandle(evt.target.files[0]);
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    InternalDatabaseConnectForm.prototype.setSnowflakePk8KeyFileHandle = function(file) {
      if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keySnowflakePk8FileError('Maximum key file size is 5KB');
      } else {
        this.defaultSnowflakeKeyFileText.hide();
        this.errorValidation.text('');
        this.divSnowflakePk8KeyFile.removeClass('error');
        this.keySnowflakePk8File = file;
        this.divSnowflakePk8FileName.text(file.name);
        return this.validSnowflakePk8KeyFile = file.name;
      }
    };

    InternalDatabaseConnectForm.prototype.keySnowflakePk8FileError = function(message) {
      this.divSnowflakePk8FileName.text('');
      this.divSnowflakePk8KeyFile.addClass('error');
      this.defaultSnowflakeKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validSnowflakePk8KeyFile = '';
    };

    return InternalDatabaseConnectForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardPermissionSettingsController = (function(superClass) {
    extend(RedesignDashboardPermissionSettingsController, superClass);

    RedesignDashboardPermissionSettingsController.SEVEN_DAY_USAGE_FULL_NAME = '7 Day Usage';

    RedesignDashboardPermissionSettingsController.SEVEN_DAY_USAGE_SHORT_NAME = 'Usage';

    RedesignDashboardPermissionSettingsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "name"
      }, {
        label: "Owner",
        "class": "owner-column",
        sortOn: 'owner'
      }, {
        label: "Groups",
        "class": "groups-column sg-center",
        sortOn: 'groups'
      }, {
        label: "Users",
        "class": "users-column sg-center",
        sortOn: 'users'
      }, {
        label: 'Shares',
        "class": 'shares-column sg-center',
        sortOn: 'shares'
      }, {
        label: 'Create Time',
        "class": 'create-time-column',
        sortOn: 'create_time'
      }, {
        label: "7 Day Usage",
        "class": 'seven-day-usage-column sg-center',
        sortOn: 'last_7_day_usage_hours'
      }
    ];

    RedesignDashboardPermissionSettingsController.SEARCH_ATTRIBUTES = ['name', 'owner'];

    RedesignDashboardPermissionSettingsController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    function RedesignDashboardPermissionSettingsController() {
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.groupPermissionUpdated = bind(this.groupPermissionUpdated, this);
      this.dashboardDestroyed = bind(this.dashboardDestroyed, this);
      this.dashboardUpdated = bind(this.dashboardUpdated, this);
      RedesignDashboardPermissionSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'prmCtrl');
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "dashboard-grid",
        columns: App.RedesignDashboardPermissionSettingsController.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/permissions/dashboard_row"),
        searchAttributes: App.RedesignDashboardPermissionSettingsController.SEARCH_ATTRIBUTES,
        menuOptions: App.RedesignDashboardPermissionSettingsController.MENU_OPTIONS,
        gridType: "dashboards",
        unselectEnabled: false
      });
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.Dashboard.bind('save refresh', this.dashboardUpdated);
      App.Dashboard.bind('destroy', this.dashboardDestroyed);
      this.prmCtrl.bind('group-permissions-map-updated', this.groupPermissionUpdated);
      this.prmCtrl.bind('remaining-state-updated group-membership-updated group-membership-deleted', this.panelCtrl.rerenderRows);
    }

    RedesignDashboardPermissionSettingsController.prototype.release = function() {
      App.Dashboard.unbind('save', this.dashboardUpdated);
      App.Dashboard.unbind('refresh', this.dashboardUpdated);
      App.Dashboard.unbind('destroy', this.dashboardDestroyed);
      this.prmCtrl.unbind('group-permissions-map-updated', this.groupPermissionUpdated);
      this.prmCtrl.unbind('group-membership-updated', this.panelCtrl.rerenderRows);
      this.prmCtrl.unbind('group-membership-deleted', this.panelCtrl.rerenderRows);
      this.prmCtrl.unbind('remaining-state-updated', this.panelCtrl.rerenderRows);
      this.panelCtrl.release();
      return RedesignDashboardPermissionSettingsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardPermissionSettingsController.prototype.dashboardUpdated = function(dashboard) {
      return this.grid.updateRow(this.getRow(dashboard));
    };

    RedesignDashboardPermissionSettingsController.prototype.dashboardDestroyed = function(dashboard) {
      return this.grid.deleteRow(this.getRow(dashboard));
    };

    RedesignDashboardPermissionSettingsController.prototype.groupPermissionUpdated = function(groupPermission) {
      var dashboard;
      try {
        dashboard = App.Dashboard.find(groupPermission.dashboard_id);
        return this.grid.updateRow(this.getRow(dashboard));
      } catch (error) {

      }
    };

    RedesignDashboardPermissionSettingsController.prototype.getRow = function(dashboard) {
      return dashboard.dashboardInfo(this.prmCtrl.dashboardToGroupsMap, this.prmCtrl.dashboardToUsersMap);
    };

    RedesignDashboardPermissionSettingsController.prototype.getRows = function() {
      return App.Dashboard.dashboardInfos(this.prmCtrl.dashboardToGroupsMap, this.prmCtrl.dashboardToUsersMap);
    };

    RedesignDashboardPermissionSettingsController.prototype.clickedGearOption = function(dashboard, rowEl, option) {
      this.panelCtrl.closeEdit();
      switch (option.type) {
        case 'edit':
          return this.clickedEdit(dashboard, rowEl);
        case 'remove':
          return this.panelCtrl.askForConfirmation(dashboard, rowEl, 'remove-dashboard', 'REMOVE', this.panelCtrl.removeItem);
      }
    };

    RedesignDashboardPermissionSettingsController.prototype.clickedEdit = function(dashboard, rowEl) {
      this.editRow = $(this.view("redesign/permissions/dashboard_row_edit")({
        row: dashboard
      }));
      rowEl.before(this.editRow);
      this.populateForm(dashboard);
      this.editRow.find('select.owner-select').chosen({
        disable_search: false,
        width: '193px'
      });
      this.editRow.find(".button.confirm").on("click", (function(_this) {
        return function() {
          return _this.saveDashboard(dashboard);
        };
      })(this));
      return this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
    };

    RedesignDashboardPermissionSettingsController.prototype.populateForm = function(dashboard) {
      return this.editRow.find('select.owner-select').first().html(App.Utils.optionsToHtml(dashboard.editableUserIdOptions(this.prmCtrl.groupToUsersMap, this.prmCtrl.dashboardToGroupsMap), dashboard.user_id));
    };

    RedesignDashboardPermissionSettingsController.prototype.saveDashboard = function(dashboard) {
      var ref, ref1, ref2, userId;
      dashboard.name = ((ref = this.editRow) != null ? ref.find('input.edit-name:first').val() : void 0) || '';
      try {
        userId = (ref1 = this.editRow) != null ? ref1.find('select.owner-select:first').val() : void 0;
        if (userId > 0) {
          dashboard.user_id = userId;
        }
      } catch (error) {

      }
      if ((ref2 = this.editRow) != null) {
        ref2.remove();
      }
      return dashboard.save();
    };

    RedesignDashboardPermissionSettingsController.prototype.search = function(searchTerm) {
      return this.panelCtrl.search(searchTerm);
    };

    RedesignDashboardPermissionSettingsController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    return RedesignDashboardPermissionSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupsForDashboardsPermissionsController = (function(superClass) {
    extend(RedesignGroupsForDashboardsPermissionsController, superClass);

    RedesignGroupsForDashboardsPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeDashboardPermission'
    };

    RedesignGroupsForDashboardsPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "name"
      }, {
        label: "Access",
        "class": "access-column",
        sortOn: "can_edit"
      }
    ];

    RedesignGroupsForDashboardsPermissionsController.SUBCOLUMNS = [
      {
        name: "View"
      }, {
        name: "Edit"
      }
    ];

    function RedesignGroupsForDashboardsPermissionsController() {
      this.clickedEdit = bind(this.clickedEdit, this);
      this.rerenderRows = bind(this.rerenderRows, this);
      this.groupPermissionUpdated = bind(this.groupPermissionUpdated, this);
      this.groupUpdated = bind(this.groupUpdated, this);
      var ref;
      RedesignGroupsForDashboardsPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item', 'prmCtrl');
      this.html(this.view('redesign/permissions/permissions_subsection')({
        headerName: 'Groups'
      }));
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.rerenderRows);
      }
      this.rows = this.getRows();
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "group-details-grid fit-in-pane",
        columns: App.RedesignGroupsForDashboardsPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view("redesign/permissions/groups_for_dashboards_row"),
        searchAttributes: ["name"],
        menuOptions: [],
        subcolumns: App.RedesignGroupsForDashboardsPermissionsController.SUBCOLUMNS,
        gridType: 'groups',
        unselectEnabled: true,
        activeDisabled: true
      });
      this.prmCtrl.bind('group-permissions-map-updated', this.groupPermissionUpdated);
      App.Group.bind('update', this.groupUpdated);
      this.editIcon.removeClass("hidden");
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignGroupsForDashboardsPermissionsController.prototype.release = function() {
      var ref;
      App.Group.unbind('update', this.groupUpdated);
      this.prmCtrl.unbind('remaining-state-updated', this.rerenderRows);
      this.prmCtrl.unbind('group-permissions-map-updated', this.groupPermissionUpdated);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignGroupsForDashboardsPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.getRows = function() {
      return this.item.groups(this.prmCtrl.dashboardToGroupsMap);
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.groupUpdated = function(group) {
      var groupInfo;
      this.rows = this.getRows();
      groupInfo = this.item.group(group.id, this.prmCtrl.dashboardToGroupsMap);
      if (!this.editing && groupInfo) {
        return this.grid.updateRow(groupInfo);
      }
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.groupPermissionUpdated = function(groupPermission) {
      if (groupPermission.dashboard_id === this.item.id) {
        return this.rerenderRows();
      }
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.rerenderRows = function() {
      var ref, ref1;
      this.rows = this.getRows();
      if (this.editing) {
        return (ref = this.grid) != null ? ref.setRows(this.getEditableRows(this.rows)) : void 0;
      } else {
        return (ref1 = this.grid) != null ? ref1.rerenderRows(this.rows) : void 0;
      }
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.editing = true;
        this.sectionBody.addClass("editing");
        App.Utils.logFeature("edit_groups_from_permissions_page");
        return this.renderRowsEditable();
      } else {
        this.editing = false;
        this.sectionBody.removeClass("editing");
        return this.renderRowsUneditable();
      }
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.renderRowsEditable = function() {
      var editGroupRows;
      editGroupRows = this.getEditableRows();
      return this.grid.rerenderRowsUnsorted(editGroupRows);
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.getEditableRows = function() {
      var editGroupRows, group, groupRow, i, len, ref, ref1;
      editGroupRows = this.rows.slice();
      ref = App.Group.all();
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (!((ref1 = this.prmCtrl.dashboardToGroupsMap[this.item.id]) != null ? ref1[group.id] : void 0)) {
          groupRow = {
            can_edit: false,
            can_view: false,
            name: group.name,
            disabled: false,
            can_edit_disabled: !group.can_edit,
            group_id: group.id,
            is_site_family_group: group.site_family_id != null
          };
          groupRow[App.RedesignSimpleGridController.OBJECT_FIELD] = group;
          editGroupRows.push(groupRow);
        }
      }
      return editGroupRows;
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.changeDashboardPermission = function(evt) {
      var edit, ref, row, rowEl, statusEl, targetCheckbox, view;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      if (row['disabled']) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      if (targetCheckbox.hasClass('edit') && targetCheckbox.hasClass('selected')) {
        rowEl.find(".view").addClass('selected');
      }
      if (targetCheckbox.hasClass('view') && !targetCheckbox.hasClass('selected')) {
        rowEl.find(".edit").removeClass('selected');
      }
      view = rowEl.find('.view').hasClass('selected');
      edit = rowEl.find(".edit").hasClass('selected');
      statusEl = rowEl.find(".edit-column");
      if (edit) {
        statusEl.text("Edit");
      } else if (view) {
        statusEl.text("View");
      } else {
        statusEl.text("--");
      }
      return this.savePermission((ref = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0, view, edit);
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.savePermission = function(groupId, view, edit) {
      var groupPermission;
      groupPermission = this.item.groupDashboardPermission(groupId);
      if (groupPermission) {
        if (view) {
          try {
            groupPermission.can_edit = edit;
            groupPermission.save({
              error: this.handleSaveError,
              success: this.clearError
            });
            return;
          } catch (error) {
            this.saveNewPermission(groupId, edit);
            return;
          }
        } else {
          groupPermission.destroy();
          return;
        }
      }
      return this.saveNewPermission(groupId, edit);
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.saveNewPermission = function(groupId, edit) {
      var permission;
      permission = new App.DashboardGroupPermission({
        dashboard_id: this.item.id,
        group_id: groupId,
        can_edit: edit
      });
      return permission.save();
    };

    RedesignGroupsForDashboardsPermissionsController.prototype.renderRowsUneditable = function() {
      return this.grid.rerenderRows(this.rows);
    };

    return RedesignGroupsForDashboardsPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUsersForDashboardsPermissionsController = (function(superClass) {
    extend(RedesignUsersForDashboardsPermissionsController, superClass);

    RedesignUsersForDashboardsPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignUsersForDashboardsPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "name"
      }, {
        label: "Access",
        "class": "access-column",
        sortOn: "access"
      }
    ];

    function RedesignUsersForDashboardsPermissionsController() {
      this.rerenderRows = bind(this.rerenderRows, this);
      this.userUpdated = bind(this.userUpdated, this);
      this.groupPermissionUpdated = bind(this.groupPermissionUpdated, this);
      this.deleteUserRow = bind(this.deleteUserRow, this);
      this.updateUserRow = bind(this.updateUserRow, this);
      this.onSearch = bind(this.onSearch, this);
      this.search = bind(this.search, this);
      this.getRow = bind(this.getRow, this);
      this.getRows = bind(this.getRows, this);
      var ref;
      RedesignUsersForDashboardsPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", 'item', 'prmCtrl');
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Users"
      }));
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.rerenderRows);
      }
      this.users = App.User.all();
      this.rows = this.getRows();
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: 'user-details-grid fit-in-pane',
        columns: App.RedesignUsersForDashboardsPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view('redesign/permissions/users_for_dashboards_row'),
        searchAttributes: ["name"],
        menuOptions: [],
        gridType: 'users',
        unselectEnabled: true
      });
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.search('');
        this.grid.search = this.search;
      }
      this.editIcon.addClass("hidden");
      this.grid.bind('selected-row-updated selected', this.openDropdown);
      this.grid.bind('unselected', this.closeDropdown);
      this.prmCtrl.bind('group-membership-updated', this.updateUserRow);
      this.prmCtrl.bind('group-membership-deleted', this.deleteUserRow);
      this.prmCtrl.bind('group-permissions-map-updated', this.groupPermissionUpdated);
      App.User.bind('refresh change', this.userUpdated);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignUsersForDashboardsPermissionsController.prototype.release = function() {
      var ref;
      this.grid.unbind("selected");
      this.grid.unbind("unselected");
      this.prmCtrl.unbind('remaining-state-updated', this.rerenderRows);
      this.prmCtrl.unbind('group-permissions-map-updated', this.groupPermissionUpdated);
      this.prmCtrl.unbind('group-membership-updated', this.updateUserRow);
      this.prmCtrl.unbind('group-membership-deleted', this.deleteUserRow);
      App.User.unbind('refresh', this.userUpdated);
      App.User.unbind('change', this.userUpdated);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignUsersForDashboardsPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignUsersForDashboardsPermissionsController.prototype.getRows = function() {
      this.rows = this.item.users(this.prmCtrl.dashboardToUsersMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.dashboardToGroupsMap, this.users);
      this.rowIds = _.map(this.rows, function(row) {
        return parseInt(row[App.RedesignSimpleGridController.OBJECT_FIELD].cid);
      });
      return this.rows;
    };

    RedesignUsersForDashboardsPermissionsController.prototype.getRow = function(userId) {
      return this.item.userInfo(userId, this.prmCtrl.userToGroupsMap, this.prmCtrl.dashboardToGroupsMap, this.prmCtrl.userToGroupsMap, this.users);
    };

    RedesignUsersForDashboardsPermissionsController.prototype.search = function(searchTerm) {
      return App.User.search(searchTerm, this.onSearch);
    };

    RedesignUsersForDashboardsPermissionsController.prototype.onSearch = function(rows) {
      this.users = rows.map(function(r) {
        return new App.User(r);
      });
      return this.rerenderRows();
    };

    RedesignUsersForDashboardsPermissionsController.prototype.updateUserRow = function(groupMembership) {
      var groupId, i, len, ref;
      ref = Object.keys(this.prmCtrl.dashboardToGroupsMap[this.item.id]);
      for (i = 0, len = ref.length; i < len; i++) {
        groupId = ref[i];
        if (parseInt(groupId) === groupMembership.group_id) {
          try {
            this.grid.updateRow(this.getRow(groupMembership.user_id));
          } catch (error) {

          }
          return;
        }
      }
    };

    RedesignUsersForDashboardsPermissionsController.prototype.deleteUserRow = function(groupMembership) {
      var groupId, i, len, ref, user, userInfo;
      ref = Object.keys(this.prmCtrl.dashboardToGroupsMap[this.item.id]);
      for (i = 0, len = ref.length; i < len; i++) {
        groupId = ref[i];
        if (parseInt(groupId) === groupMembership.group_id) {
          try {
            user = App.User.find(groupMembership.user_id);
            userInfo = {};
            userInfo[App.RedesignSimpleGridController.OBJECT_FIELD] = user;
            this.grid.deleteRow(userInfo);
          } catch (error) {

          }
          return;
        }
      }
    };

    RedesignUsersForDashboardsPermissionsController.prototype.groupPermissionUpdated = function(dashboardGroupPermission) {
      if (dashboardGroupPermission.dashboard_id !== this.item.id) {
        return;
      }
      return this.rerenderRows();
    };

    RedesignUsersForDashboardsPermissionsController.prototype.userUpdated = function(user) {
      if (_.indexOf(this.rowIds, user.id) >= 0) {
        try {
          return this.grid.updateRow(this.getRow(user.id));
        } catch (error) {

        }
      }
    };

    RedesignUsersForDashboardsPermissionsController.prototype.rerenderRows = function() {
      var ref;
      return (ref = this.grid) != null ? ref.rerenderRows(this.getRows()) : void 0;
    };

    RedesignUsersForDashboardsPermissionsController.prototype.closeDropdown = function(el) {
      el.find(".access-list").remove();
      return this.openEl = null;
    };

    RedesignUsersForDashboardsPermissionsController.prototype.openDropdown = function(user, el) {
      var subEl;
      if (this.openEl != null) {
        this.openEl.find(".access-list").remove();
      }
      subEl = $(this.view("redesign/permissions/users_access_via")({
        groupNames: user['group_names']
      }));
      el.append(subEl);
      return this.openEl = el;
    };

    return RedesignUsersForDashboardsPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardsForGroupsPermissionsController = (function(superClass) {
    extend(RedesignDashboardsForGroupsPermissionsController, superClass);

    RedesignDashboardsForGroupsPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeDashboardPermission'
    };

    RedesignDashboardsForGroupsPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "dashboard_name"
      }, {
        label: "Access",
        "class": "access-column",
        sortOn: "can_edit"
      }
    ];

    RedesignDashboardsForGroupsPermissionsController.SUBCOLUMNS = [
      {
        name: "View"
      }, {
        name: "Edit"
      }
    ];

    function RedesignDashboardsForGroupsPermissionsController() {
      this.clickedEdit = bind(this.clickedEdit, this);
      this.dashboardUpdated = bind(this.dashboardUpdated, this);
      this.dashboardPermissionChanged = bind(this.dashboardPermissionChanged, this);
      this.renderRows = bind(this.renderRows, this);
      var ref;
      RedesignDashboardsForGroupsPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "prmCtrl");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Dashboards"
      }));
      this.group = this.item;
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.renderRows);
      }
      this.rows = this.getRows();
      if (this.group.admin) {
        this.editIcon.addClass("hidden disabled");
        this.adminGroup = true;
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "dashboard-details-grid fit-in-pane",
        columns: App.RedesignDashboardsForGroupsPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view("redesign/permissions/dashboards_for_groups_row"),
        searchAttributes: ["dashboard_name"],
        menuOptions: [],
        subcolumns: App.RedesignDashboardsForGroupsPermissionsController.SUBCOLUMNS,
        gridType: 'dashboards',
        unselectEnabled: true,
        activeDisabled: true
      });
      this.prmCtrl.bind('dashboard-group-permissions-updated', this.dashboardPermissionChanged);
      this.prmCtrl.bind('dashboard-updated', this.dashboardUpdated);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignDashboardsForGroupsPermissionsController.prototype.release = function() {
      var ref;
      this.prmCtrl.unbind('remaining-state-updated', this.renderRows);
      this.prmCtrl.unbind('dashboard-group-permissions-updated', this.dashboardPermissionChanged);
      this.prmCtrl.unbind('dashboard-updated', this.dashboardUpdated);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignDashboardsForGroupsPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.getRows = function() {
      this.rows = this.group.getDashboardInfo(this.prmCtrl.groupToDashboardsMap);
      this.rowIds = _.map(this.rows, function(row) {
        return parseInt(row.id);
      });
      return this.rows;
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.renderRows = function() {
      var ref, ref1;
      this.rows = this.getRows();
      if (this.editing) {
        return (ref = this.grid) != null ? ref.setRows(this.getEditableRows()) : void 0;
      } else {
        return (ref1 = this.grid) != null ? ref1.rerenderRows(this.rows) : void 0;
      }
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.dashboardPermissionChanged = function(permission) {
      if (permission.group_id === this.group.id) {
        return this.renderRows();
      }
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.dashboardUpdated = function(dashboard) {
      if (_.indexOf(this.rowIds, dashboard.id) >= 0) {
        return this.renderRows();
      }
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.clickedEdit = function() {
      if (this.adminGroup) {
        return;
      }
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        return this.renderRowsEditable();
      } else {
        this.sectionBody.removeClass("editing");
        return this.renderRowsUneditable();
      }
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.renderRowsEditable = function() {
      this.editing = true;
      return this.grid.rerenderRowsUnsorted(this.getEditableRows());
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.getEditableRows = function() {
      var dashboardRows, db, dbMap, i, j, len, len1, r, rec, ref, ref1;
      dashboardRows = [];
      dbMap = {};
      if (this.rows != null) {
        ref = this.rows;
        for (i = 0, len = ref.length; i < len; i++) {
          rec = ref[i];
          r = $.extend({}, rec);
          r['can_view'] || (r['can_view'] = true);
          dashboardRows.push(r);
        }
      }
      dbMap = this.group.dashboardMap();
      ref1 = App.Dashboard.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        db = ref1[j];
        if (dbMap[db.id] == null) {
          dashboardRows.push({
            dashboard_name: db.getName(),
            id: db.id,
            can_edit: false,
            can_view: false
          });
        }
      }
      return dashboardRows;
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.renderRowsUneditable = function() {
      this.editing = false;
      return this.grid.rerenderRows(this.rows);
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.changeDashboardPermission = function(evt) {
      var row, rowEl, statusEl, targetCheckbox, transactionType;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      transactionType = targetCheckbox.hasClass("edit") ? 'edit' : 'view';
      if (targetCheckbox.hasClass('edit') && targetCheckbox.hasClass('selected')) {
        rowEl.find(".view").addClass('selected');
      }
      if (targetCheckbox.hasClass('view') && !targetCheckbox.hasClass('selected')) {
        rowEl.find(".edit").removeClass('selected');
      }
      statusEl = rowEl.find(".edit-column");
      if (rowEl.find(".edit").hasClass('selected')) {
        statusEl.text("Edit");
      } else if (rowEl.find(".view").hasClass('selected')) {
        statusEl.text("View");
      } else {
        statusEl.text("--");
      }
      if (targetCheckbox.hasClass('selected')) {
        this.addPermission(row.id, this.group.id, transactionType);
      } else {
        this.removePermission(row.id, this.group.id, transactionType);
      }
      return App.Utils.logFeature("update_dashboard_group_permission_from_permissions_page");
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.addPermission = function(dashboardId, groupId, type) {
      var edit, i, len, permission, ref;
      edit = type === 'edit';
      ref = this.group.currentGroupPermissionsForDashboard(dashboardId);
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        if (edit && !permission.can_edit) {
          permission.can_edit = true;
          permission.save({
            error: this.handleSaveError,
            success: this.clearError
          });
          return;
        }
      }
      permission = new App.DashboardGroupPermission({
        dashboard_id: dashboardId,
        group_id: groupId,
        can_edit: edit
      });
      return permission.save();
    };

    RedesignDashboardsForGroupsPermissionsController.prototype.removePermission = function(dashboardId, groupId, type) {
      var i, len, permission, ref, results;
      ref = this.group.currentGroupPermissionsForDashboard(dashboardId);
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        permission = ref[i];
        if (type === 'view') {
          results.push(permission.destroy());
        } else if (type === 'edit' && permission.can_edit) {
          permission.can_edit = false;
          results.push(permission.save());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return RedesignDashboardsForGroupsPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupPermissionsController = (function(superClass) {
    extend(RedesignGroupPermissionsController, superClass);

    RedesignGroupPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "name"
      }, {
        label: "Access",
        "class": "can-edit-column",
        sortOn: "can_edit"
      }, {
        label: "Created By",
        "class": "created-by-column",
        sortOn: "created_by"
      }, {
        label: "Created On",
        "class": "created-on-column",
        sortOn: "created_on"
      }, {
        label: "Users",
        "class": "users-column sg-center",
        sortOn: "users"
      }, {
        label: "Dashboards",
        "class": "dashboards-column sg-center",
        sortOn: "dashboards"
      }
    ];

    RedesignGroupPermissionsController.SEARCH_ATTRIBUTES = ["name", "created_by"];

    RedesignGroupPermissionsController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    RedesignGroupPermissionsController.ALL_USERS_MENU_OPTIONS = [
      {
        label: 'Edit',
        type: 'edit'
      }
    ];

    RedesignGroupPermissionsController.FAMILY_GROUP_MENU_OPTIONS = [
      {
        label: 'Edit',
        type: 'edit'
      }
    ];

    function RedesignGroupPermissionsController() {
      this.confirmGroupEdit = bind(this.confirmGroupEdit, this);
      this.accessLevels = bind(this.accessLevels, this);
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.dashboardPermissionChanged = bind(this.dashboardPermissionChanged, this);
      this.groupMembershipChanged = bind(this.groupMembershipChanged, this);
      this.groupUpdated = bind(this.groupUpdated, this);
      this.getRows = bind(this.getRows, this);
      RedesignGroupPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "prmCtrl");
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "groups-grid",
        columns: App.RedesignGroupPermissionsController.COLUMNS,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/permissions/group_permission_row"),
        searchAttributes: App.RedesignGroupPermissionsController.SEARCH_ATTRIBUTES,
        menuOptions: App.RedesignGroupPermissionsController.MENU_OPTIONS,
        gridType: "groups",
        unselectEnabled: false
      });
      this.addMenuOptionExceptions();
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.Group.bind('save', this.groupUpdated);
      App.Group.bind('destroy', this.panelCtrl.itemDestroyed);
      this.prmCtrl.bind('group-membership-updated', this.groupMembershipChanged);
      this.prmCtrl.bind('dashboard-group-permissions-updated', this.dashboardPermissionChanged);
      this.prmCtrl.bind('group-to-dashboards-updated remaining-state-updated', this.panelCtrl.rerenderRows);
    }

    RedesignGroupPermissionsController.prototype.release = function() {
      App.Group.unbind('save', this.groupUpdated);
      App.Group.unbind('destroy', this.panelCtrl.itemDestroyed);
      this.prmCtrl.unbind('group-membership-updated', this.groupMembershipChanged);
      this.prmCtrl.unbind('dashboard-group-permissions-updated', this.dashboardPermissionChanged);
      this.prmCtrl.unbind('group-to-dashboards-updated', this.panelCtrl.rerenderRows);
      this.prmCtrl.unbind('remaining-state-updated', this.panelCtrl.rerenderRows);
      this.panelCtrl.release();
      return RedesignGroupPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignGroupPermissionsController.prototype.getRows = function() {
      return App.Group.groupInfos(this.prmCtrl.groupToUsersMap, this.prmCtrl.groupToDashboardsMap);
    };

    RedesignGroupPermissionsController.prototype.addMenuOptionExceptions = function() {
      var group, i, id, len, map, ref, ref1;
      map = {};
      id = (ref = App.Group.allUsersGroup()) != null ? ref.id : void 0;
      if (id) {
        map[id] = this.constructor.ALL_USERS_MENU_OPTIONS;
      }
      ref1 = App.Group.all();
      for (i = 0, len = ref1.length; i < len; i++) {
        group = ref1[i];
        if ((group.site_family_id != null) && !group.admin) {
          map[group.id] = this.constructor.FAMILY_GROUP_MENU_OPTIONS;
        }
      }
      return this.grid.addMenuOptionExceptions(map);
    };

    RedesignGroupPermissionsController.prototype.groupUpdated = function(group) {
      var info;
      info = group.groupInfo(this.prmCtrl.groupToUsersMap, this.prmCtrl.groupToDashboardsMap);
      if (info) {
        return this.grid.updateRow(info);
      }
    };

    RedesignGroupPermissionsController.prototype.groupMembershipChanged = function(membership) {
      try {
        return this.grid.updateRow(App.Group.find(membership.group_id).groupInfo(this.prmCtrl.groupToUsersMap, this.prmCtrl.groupToDashboardsMap));
      } catch (error) {

      }
    };

    RedesignGroupPermissionsController.prototype.dashboardPermissionChanged = function(perm) {
      try {
        return this.grid.updateRow(App.Group.find(perm.group_id).groupInfo(this.prmCtrl.groupToUsersMap, this.prmCtrl.groupToDashboardsMap));
      } catch (error) {

      }
    };

    RedesignGroupPermissionsController.prototype.clickedGearOption = function(group, rowEl, option) {
      switch (option.type) {
        case "edit":
          return this.clickedEdit(group, rowEl);
        case "remove":
          return this.panelCtrl.askForConfirmation(group, rowEl, "remove-group", "REMOVE", this.panelCtrl.removeItem);
      }
    };

    RedesignGroupPermissionsController.prototype.clickedEdit = function(group, rowEl) {
      this.panelCtrl.closeEdit();
      this.editingGroup = group;
      if (group.all_users || group.isSiteFamilyGroup()) {
        group.disabled = true;
      }
      this.editRow = $(this.view("redesign/permissions/group_row_edit")({
        group: group
      }));
      rowEl.before(this.editRow);
      this.editRow.find(".button.confirm").on("click", this.confirmGroupEdit);
      this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
      this.accessLevelSelect = this.editRow.find('select.access-level');
      this.accessLevelSelect.html(this.accessLevels(group));
      return this.accessLevelSelect.chosen({
        disable_search: true,
        disable_search_threshold: 8,
        width: '95px'
      });
    };

    RedesignGroupPermissionsController.prototype.accessLevels = function(group) {
      return App.Utils.optionsToHtml(App.Site.first().accessLevels(), group.accessLevelValueCurrentSite());
    };

    RedesignGroupPermissionsController.prototype.confirmGroupEdit = function() {
      var group, newName, ref;
      group = this.editingGroup;
      newName = (ref = this.editRow.find('.edit-group-name-column input').val()) != null ? ref.trim() : void 0;
      group.setAccessLevelCurrentSite(this.accessLevelSelect.val());
      group.saveCurrentSiteGroupRole();
      if ((newName != null ? newName.length : void 0) > 0) {
        group.name = newName;
        group.save();
      }
      return this.panelCtrl.closeEdit();
    };

    RedesignGroupPermissionsController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    RedesignGroupPermissionsController.prototype.search = function(searchTerm) {
      return this.panelCtrl.search(searchTerm);
    };

    return RedesignGroupPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUsersForGroupsPermissionsController = (function(superClass) {
    extend(RedesignUsersForGroupsPermissionsController, superClass);

    RedesignUsersForGroupsPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignUsersForGroupsPermissionsController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeGroupMembership'
    };

    RedesignUsersForGroupsPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "user-name-column",
        sortOn: "user_name"
      }
    ];

    function RedesignUsersForGroupsPermissionsController() {
      this.changeGroupMembership = bind(this.changeGroupMembership, this);
      this.userLacksWorkbooksAccess = bind(this.userLacksWorkbooksAccess, this);
      this.onSearch = bind(this.onSearch, this);
      this.search = bind(this.search, this);
      this.getRows = bind(this.getRows, this);
      this.renderRows = bind(this.renderRows, this);
      this.userUpdated = bind(this.userUpdated, this);
      this.groupMembershipUpdated = bind(this.groupMembershipUpdated, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      var ref;
      RedesignUsersForGroupsPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "prmCtrl");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Users"
      }));
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.renderRows);
      }
      this.users = App.User.all();
      this.rows = this.getRows();
      this.editing = false;
      if (this.item.all_users) {
        this.editIcon.addClass("hidden disabled");
        this.allUsersGroup = true;
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "user-details-grid fit-in-pane users-for-groups",
        columns: App.RedesignUsersForGroupsPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view("redesign/permissions/users_for_groups_row"),
        searchAttributes: ["user_name"],
        menuOptions: [],
        gridType: 'users',
        unselectEnabled: true,
        activeDisabled: true
      });
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.search('');
        this.grid.search = this.search;
      }
      if (this.item.isSiteFamilyGroup()) {
        this.editIcon.addClass("hidden");
      }
      this.prmCtrl.bind('group-membership-updated', this.groupMembershipUpdated);
      App.User.bind('refresh change', this.userUpdated);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignUsersForGroupsPermissionsController.prototype.release = function() {
      var ref;
      this.prmCtrl.unbind('remaining-state-updated', this.renderRows);
      this.prmCtrl.unbind('group-membership-updated', this.renderRows);
      App.User.unbind('refresh', this.userUpdated);
      App.User.unbind('change', this.userUpdated);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignUsersForGroupsPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignUsersForGroupsPermissionsController.prototype.clickedEdit = function() {
      if (this.allUsersGroup) {
        return;
      }
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        return this.renderRowsEditable();
      } else {
        this.sectionBody.removeClass("editing");
        return this.renderRowsUneditable();
      }
    };

    RedesignUsersForGroupsPermissionsController.prototype.groupMembershipUpdated = function(groupMembership) {
      if (groupMembership.group_id === this.item.id) {
        return this.renderRows();
      }
    };

    RedesignUsersForGroupsPermissionsController.prototype.userUpdated = function(user) {
      if (_.indexOf(this.rowIds, user.id) >= 0) {
        return this.renderRows();
      }
    };

    RedesignUsersForGroupsPermissionsController.prototype.renderRows = function() {
      var ref, ref1;
      this.rows = this.getRows();
      if (this.editing) {
        return (ref = this.grid) != null ? ref.setRows(this.getEditableRows()) : void 0;
      } else {
        return (ref1 = this.grid) != null ? ref1.rerenderRows(this.rows) : void 0;
      }
    };

    RedesignUsersForGroupsPermissionsController.prototype.getRows = function() {
      this.rows = this.item.usersForGroup(this.prmCtrl.groupToUsersMap, this.users);
      this.rowIds = _.map(this.rows, function(row) {
        return parseInt(row.user_id);
      });
      return this.rows;
    };

    RedesignUsersForGroupsPermissionsController.prototype.search = function(searchTerm) {
      return App.User.search(searchTerm, this.onSearch);
    };

    RedesignUsersForGroupsPermissionsController.prototype.onSearch = function(rows) {
      this.users = rows.map(function(r) {
        return new App.User(r);
      });
      return this.renderRows();
    };

    RedesignUsersForGroupsPermissionsController.prototype.renderRowsEditable = function() {
      var editableRows;
      this.editing = true;
      editableRows = this.getEditableRows();
      return this.grid.rerenderRowsUnsorted(editableRows);
    };

    RedesignUsersForGroupsPermissionsController.prototype.getEditableRows = function() {
      var i, j, len, len1, r, rec, ref, ref1, ref2, user, userGroupRows;
      userGroupRows = [];
      ref = this.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        rec = ref[i];
        r = $.extend({}, rec);
        r['is_user_in_group'] || (r['is_user_in_group'] = true);
        userGroupRows.push(r);
      }
      ref1 = App.User.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        user = ref1[j];
        if (!((ref2 = this.prmCtrl.groupToUsersMap[this.item.id]) != null ? ref2[user.id] : void 0)) {
          if (!this.userLacksWorkbooksAccess(user)) {
            userGroupRows.push({
              user_name: user.fullName(),
              user_id: user.id,
              is_user_in_group: false
            });
          }
        }
      }
      return userGroupRows;
    };

    RedesignUsersForGroupsPermissionsController.prototype.userLacksWorkbooksAccess = function(user) {
      return AppRedesign.allowRevokingWorkbooksAccess() && !user.workbooks_access;
    };

    RedesignUsersForGroupsPermissionsController.prototype.renderRowsUneditable = function() {
      this.editing = false;
      return this.grid.rerenderRows(this.rows);
    };

    RedesignUsersForGroupsPermissionsController.prototype.changeGroupMembership = function(evt) {
      var rowEl, targetCheckbox, userRow;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      userRow = rowEl.data("row");
      if (targetCheckbox.hasClass('selected')) {
        return this.item.addUser(App.User.find(userRow.user_id));
      } else {
        return this.item.removeUser(App.User.find(userRow.user_id));
      }
    };

    return RedesignUsersForGroupsPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAddGroupController = (function(superClass) {
    extend(RedesignAddGroupController, superClass);

    RedesignAddGroupController.prototype.className = 'permissions-modal';

    RedesignAddGroupController.prototype.elements = {
      'input.group-name': 'groupName',
      '.can-edit': 'canEditArea',
      '.error-row': 'errorRow',
      '.button-row': 'buttonRow',
      'select.access-level': 'accessLevelSelect'
    };

    RedesignAddGroupController.prototype.events = {
      'keyup input': 'inputChanged'
    };

    function RedesignAddGroupController() {
      this.clickedAdd = bind(this.clickedAdd, this);
      this.isSelected = bind(this.isSelected, this);
      this.closeDialog = bind(this.closeDialog, this);
      RedesignAddGroupController.__super__.constructor.apply(this, arguments);
      this.html(this.view("redesign/permissions/group_add")({
        directoryHelperView: this.directoryHelper != null
      }));
      if (this.directoryHelper == null) {
        this.accessLevelSelect.html(this.accessLevels());
        this.accessLevelSelect.chosen({
          disable_search: true,
          disable_search_threshold: 8,
          width: '100%'
        });
      }
      this.groupName.trigger('focus');
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.closeDialog,
        saveFunc: this.clickedAdd,
        saveText: 'ADD'
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
      this.cancelSaveBlock.setSaveDisabled(true);
      App.RedesignDialog.createDialog({
        title: 'Add Group',
        viewController: this
      });
    }

    RedesignAddGroupController.prototype.accessLevels = function() {
      return App.Utils.optionsToHtml(App.Site.first().accessLevels(), 'SQL');
    };

    RedesignAddGroupController.prototype.closeDialog = function() {
      return this.trigger('close');
    };

    RedesignAddGroupController.prototype.isSelected = function(val) {
      return this.accessLevelSelect.val() === val;
    };

    RedesignAddGroupController.prototype.clickedAdd = function() {
      var group, groupRole;
      if (this.formValid()) {
        this.clearError();
        group = new App.Group({
          name: this.groupName.val().trim()
        });
        if (this.directoryHelper != null) {
          group.site_family_id = App.Site.first().site_family_id;
        }
        groupRole = App.GroupRole.create({
          can_edit: this.isSelected('can_edit'),
          group_id: group.cid,
          site_id: App.Site.first().site_id,
          can_drag_and_drop: this.isSelected('can_drag_and_drop')
        }, {
          ajax: false
        });
        group.save({
          ajax: false
        });
        $.post('/groups/create_with_role', _.merge(group.toJSON(), {
          can_edit: groupRole.can_edit,
          can_drag_and_drop: groupRole.can_drag_and_drop
        }), this.handleUpdates(group, groupRole));
        return this.closeDialog();
      } else {
        return this.showError('Group name required.');
      }
    };

    RedesignAddGroupController.prototype.handleUpdates = function(group, groupRole) {
      return function(data, status, xhr) {
        groupRole.ajax().recordResponse()(data.group_role, status, xhr);
        return group.ajax().recordResponse()(data.group, status, xhr);
      };
    };

    RedesignAddGroupController.prototype.formValid = function() {
      return !_.isEmpty(this.groupName.val().trim());
    };

    RedesignAddGroupController.prototype.inputChanged = function() {
      return this.cancelSaveBlock.setSaveDisabled(!this.formValid());
    };

    RedesignAddGroupController.prototype.showError = function(message) {
      return this.errorRow.html(message).slideDown();
    };

    RedesignAddGroupController.prototype.clearError = function() {
      return this.errorRow.slideUp();
    };

    return RedesignAddGroupController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignAddUserController = (function(superClass) {
    extend(RedesignAddUserController, superClass);

    RedesignAddUserController.prototype.className = 'permissions-modal';

    RedesignAddUserController.prototype.elements = {
      'input.first-name': 'firstName',
      'input.last-name': 'lastName',
      'input.email': 'email',
      '.self-service-checkbox': 'selfServiceAccess',
      '.workbooks-checkbox': 'workbooksAccess',
      '.button-row': 'buttonRow',
      '.error-row': 'errorRow',
      '.sites-dropdown.hidden-initially': 'sitesDropdown',
      'select.sites': 'sitesSelect'
    };

    RedesignAddUserController.prototype.events = {
      'keyup input': 'inputChanged',
      'change .sites': 'inputChanged',
      'click .self-service-checkbox': 'selfServiceCheckboxClick',
      'click .workbooks-checkbox': 'workbooksCheckboxClick'
    };

    function RedesignAddUserController() {
      this.handleServerResponse = bind(this.handleServerResponse, this);
      this.savedUser = bind(this.savedUser, this);
      this.clickedAdd = bind(this.clickedAdd, this);
      this.workbooksCheckboxClick = bind(this.workbooksCheckboxClick, this);
      this.selfServiceCheckboxClick = bind(this.selfServiceCheckboxClick, this);
      this.closeDialog = bind(this.closeDialog, this);
      var ref, sites;
      RedesignAddUserController.__super__.constructor.apply(this, arguments);
      sites = ((ref = App.Site.first()) != null ? ref.site_info_list : void 0) || [];
      this.showSites = this.directoryHelper != null;
      this.self_service_dashboard_access_enabled = AppRedesign.hasCustomerUnification();
      this.self_allow_revoking_workbooks_access = AppRedesign.allowRevokingWorkbooksAccess();
      this.html(this.view("redesign/permissions/user_add")({
        sites: sites,
        hasSisenseDeployment: this.self_service_dashboard_access_enabled,
        allowRevokingWorkbooksAccess: this.self_allow_revoking_workbooks_access,
        showSites: this.showSites
      }));
      this.firstName.trigger('focus');
      if (this.showSites) {
        this.sitesDropdown.removeClass('hidden-initially');
        this.sitesSelect.chosen({
          width: '100%',
          placeholder_text_multiple: 'Select Spaces',
          inherit_select_classes: true
        });
      }
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.closeDialog,
        saveFunc: this.clickedAdd,
        saveText: 'ADD'
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
      this.addText = this.cancelSaveBlock.saveButton.text();
      this.cancelSaveBlock.setSaveDisabled(true);
      this.addSpaceDialog = App.RedesignDialog.createDialog({
        title: 'Add User',
        viewController: this
      });
    }

    RedesignAddUserController.prototype.closeDialog = function() {
      return this.trigger('close');
    };

    RedesignAddUserController.prototype.inputChanged = function() {
      var disableSave;
      disableSave = this.isEmailEmpty() || (this.showSites && this.isSiteEmpty());
      return this.cancelSaveBlock.setSaveDisabled(disableSave);
    };

    RedesignAddUserController.prototype.selfServiceCheckboxClick = function(e) {
      return this.selfServiceAccess.toggleClass('selected');
    };

    RedesignAddUserController.prototype.workbooksCheckboxClick = function(e) {
      return this.workbooksAccess.toggleClass('selected');
    };

    RedesignAddUserController.prototype.clickedAdd = function() {
      var params, url;
      if (this.cancelSaveBlock.saveButton.hasClass('disabled')) {
        return;
      }
      if (this.validateInviteForm()) {
        this.clearError();
        params = {
          email_address: this.email.val().trim().toLowerCase(),
          first_name: this.firstName.val().trim(),
          last_name: this.lastName.val().trim(),
          client_site_id: App.Site.first().id
        };
        if (this.showSites) {
          params.site_ids = this.sitesSelect.val();
        }
        if (this.self_service_dashboard_access_enabled) {
          params.self_service_dashboards_access = this.selfServiceAccess.hasClass('selected');
        }
        params.workbooks_access = this.workbooksAccess.hasClass('selected');
        this.cancelSaveBlock.saveButton.addClass('disabled');
        this.cancelSaveBlock.saveButton.text('Loading');
        url = '/users/invite_new_user';
        if (this.showSites) {
          url = '/users/invite_new_user_to_multiple_sites';
        }
        jQuery.post(url, params, this.handleServerResponse).done(this.savedUser).fail(((function(_this) {
          return function() {
            _this.resetInvitebutton();
            return _this.showError('Error adding user, please try again later.');
          };
        })(this)));
        return App.Utils.logFeature("user-added");
      }
    };

    RedesignAddUserController.prototype.savedUser = function(result) {
      var user, user_roles;
      user = result.user;
      user_roles = result.user_roles;
      App.User.applyUpdates([user]);
      return App.UserRole.applyUpdates(user_roles);
    };

    RedesignAddUserController.prototype.isSiteEmpty = function() {
      return _.isEmpty(this.sitesSelect.val());
    };

    RedesignAddUserController.prototype.isEmailEmpty = function() {
      return _.isEmpty(this.email.val().trim());
    };

    RedesignAddUserController.prototype.validateInviteForm = function() {
      var success;
      success = true;
      this.email.val(this.email.val().trim().toLowerCase());
      if (this.isEmailEmpty()) {
        this.showError("Email address required.");
        success = false;
      } else if (!App.Utils.probablyAValidEmailAddress(this.email.val())) {
        this.showError("Email address invalid.");
        this.email.addClass('error');
        success = false;
      }
      if (this.showSites && this.isSiteEmpty()) {
        this.showError("At least one space must be selected.");
        success = false;
      }
      return success;
    };

    RedesignAddUserController.prototype.resetInvitebutton = function() {
      this.cancelSaveBlock.saveButton.removeClass('disabled');
      return this.cancelSaveBlock.saveButton.text(this.addText);
    };

    RedesignAddUserController.prototype.handleServerResponse = function(response) {
      var user;
      user = response.user;
      if (user != null) {
        this.closeDialog();
        App.User.applyUpdates([user]);
      } else {
        this.error('Error adding user, please try again later.');
      }
      return this.resetInvitebutton();
    };

    RedesignAddUserController.prototype.showError = function(message) {
      return this.errorRow.html(message).slideDown();
    };

    RedesignAddUserController.prototype.clearError = function() {
      return this.errorRow.slideUp();
    };

    return RedesignAddUserController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGridSearchController = (function(superClass) {
    extend(RedesignGridSearchController, superClass);

    RedesignGridSearchController.prototype.elements = {
      '.grid-search': 'gridSearch',
      '.handle-text': 'handleText',
      '.handle-area': 'handleArea',
      'select.category': 'categorySelect',
      'input': 'searchInput',
      '.add-button .label': 'addText',
      '.search-area': 'searchArea'
    };

    RedesignGridSearchController.prototype.events = {
      'click .add-button': 'clickedAdd',
      'change select.category': 'clickedOption'
    };

    RedesignGridSearchController.DISABLE_CATEGORY_SEARCH_THRESHOLD = 8;

    RedesignGridSearchController.GROUPS = "Groups";

    RedesignGridSearchController.DASHBOARDS = "Dashboards";

    function RedesignGridSearchController() {
      this.clickedOption = bind(this.clickedOption, this);
      this.logSearchInput = bind(this.logSearchInput, this);
      var category, i, len, options, ref, ref1, ref2, ref3;
      RedesignGridSearchController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "categories");
      this.html(this.view("redesign/permissions/grid_search")());
      this.currCategory = (ref = this.initValue) != null ? ref : this.categories[0];
      options = [];
      ref1 = this.categories;
      for (i = 0, len = ref1.length; i < len; i++) {
        category = ref1[i];
        options.push({
          name: category.label,
          value: category.type
        });
      }
      this.categorySelect.html(App.Utils.optionsToHtml(options, this.currCategory.type));
      this.categorySelect.chosen({
        disable_search: (ref2 = this.disableSearch) != null ? ref2 : true,
        disable_search_threshold: this.constructor.DISABLE_CATEGORY_SEARCH_THRESHOLD,
        width: (ref3 = this.dropdownWidth) != null ? ref3 : '142px'
      });
      this.updateHandle();
      this.debouncedLogSearchInput = _.debounce(this.logSearchInput, 1000);
      this.searchInput.on("keyup", (function(_this) {
        return function(evt) {
          _this.debouncedLogSearchInput();
          return _this.trigger("search", _this.searchInput.val().trim());
        };
      })(this));
      if (this.hideCategoryDropdown) {
        this.handleArea.hide();
      }
    }

    RedesignGridSearchController.prototype.logSearchInput = function() {
      if ([this.constructor.GROUPS, this.constructor.DASHBOARDS].includes(this.currCategory.label)) {
        return App.Utils.logFeature((this.currCategory.label.toLowerCase()) + "_search_from_permissions_page");
      }
    };

    RedesignGridSearchController.prototype.updateHandle = function() {
      this.searchInput.val("");
      this.currCategory = _.find(this.categories, (function(_this) {
        return function(category) {
          return ("" + category.type) === _this.categorySelect.val();
        };
      })(this));
      this.searchInput.attr("placeholder", this.currCategory.placeholder);
      this.addText.text(this.currCategory.addText || '');
      this.gridSearch.toggleClass("hide-add-area", this.currCategory.addText == null);
      if (this.hideSearchBar) {
        return this.searchArea.hide();
      }
    };

    RedesignGridSearchController.prototype.clickedOption = function(evt) {
      this.updateHandle();
      return this.trigger("category-change", this.currCategory);
    };

    RedesignGridSearchController.prototype.clickedAdd = function() {
      return this.trigger("clicked-add", this.currCategory);
    };

    RedesignGridSearchController.prototype.updateCategory = function(cid) {
      this.categorySelect.val(cid);
      return this.categorySelect.trigger('chosen:updated');
    };

    return RedesignGridSearchController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignPermissionsController = (function(superClass) {
    extend(RedesignPermissionsController, superClass);

    RedesignPermissionsController.APPLIES_TO_ALL_SPACES = false;

    RedesignPermissionsController.TITLE = 'Permissions';

    RedesignPermissionsController.PERMISSIONS_DATE_FORMAT = 'YYYY-MM-DD';

    RedesignPermissionsController.PERMISSIONS_TIME_FORMAT = 'H:mm:ss z';

    RedesignPermissionsController.BLANK_FIELD_FORMAT = '--';

    RedesignPermissionsController.OTHER_AREA_HEIGHT = 70 + 5 + 10 + 12;

    RedesignPermissionsController.PERMISSION_PANEL_LEFT_MARGIN = 19;

    RedesignPermissionsController.PERMISSION_PANEL_WIDTH = 1186;

    RedesignPermissionsController.PERMISSION_PANEL_MINIMUM_HEIGHT = 55 + 70.5;

    RedesignPermissionsController.prototype.className = 'directory-controller';

    RedesignPermissionsController.prototype.elements = {
      '.spinner-container': 'spinnerContainer'
    };

    function RedesignPermissionsController() {
      this.remainingStateLoadedForDashboards = bind(this.remainingStateLoadedForDashboards, this);
      this.remainingStateLoadedForGroups = bind(this.remainingStateLoadedForGroups, this);
      this.remainingStateLoadedForUsers = bind(this.remainingStateLoadedForUsers, this);
      this.setCachedMapsForGroups = bind(this.setCachedMapsForGroups, this);
      this.setCachedMapsForUsers = bind(this.setCachedMapsForUsers, this);
      this.setCachedMapsForDashboards = bind(this.setCachedMapsForDashboards, this);
      this.groupToDashboardUpdated = bind(this.groupToDashboardUpdated, this);
      this.dashboardChanged = bind(this.dashboardChanged, this);
      this.groupMembershipUpdatedForUsers = bind(this.groupMembershipUpdatedForUsers, this);
      this.groupMembershipDeletedForDashboards = bind(this.groupMembershipDeletedForDashboards, this);
      this.groupMembershipUpdatedForDashboards = bind(this.groupMembershipUpdatedForDashboards, this);
      this.groupMembershipDeleted = bind(this.groupMembershipDeleted, this);
      this.groupMembershipUpdated = bind(this.groupMembershipUpdated, this);
      this.groupPermissionUpdated = bind(this.groupPermissionUpdated, this);
      this.dashboardPermissionChanged = bind(this.dashboardPermissionChanged, this);
      this.bindToDashboardGroupPermissionForDashboards = bind(this.bindToDashboardGroupPermissionForDashboards, this);
      this.releaseGroupControllerBindings = bind(this.releaseGroupControllerBindings, this);
      this.bindToDashboardGroupPermissionForGroups = bind(this.bindToDashboardGroupPermissionForGroups, this);
      this.releaseUserControllerBindings = bind(this.releaseUserControllerBindings, this);
      this.bindToDashboardsAndDashboardGroupPermission = bind(this.bindToDashboardsAndDashboardGroupPermission, this);
      this.loadedDependencies = bind(this.loadedDependencies, this);
      RedesignPermissionsController.__super__.constructor.apply(this, arguments);
      this.loadDependencies();
      this.html(this.view('redesign/settings/spinner')());
    }

    RedesignPermissionsController.prototype.loadDependencies = function() {
      return jQuery.get('/group_memberships', {
        client_site_id: App.Site.first().id
      }).done(this.loadedDependencies);
    };

    RedesignPermissionsController.prototype.loadedDependencies = function(dependencies) {
      if (dependencies.GroupMembership != null) {
        App.GroupMembership.applyUpdates(dependencies.GroupMembership);
      }
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return this.initGrid();
      } else {
        return this.removeSpinnerAndRenderSettingsGrid();
      }
    };

    RedesignPermissionsController.prototype.removeSpinnerAndRenderSettingsGrid = function() {
      this.spinnerContainer.remove();
      return this.loadGrid();
    };

    RedesignPermissionsController.prototype.initGrid = function() {
      return this.gridController = new App.RedesignSettingsGridController({
        disableSearch: true,
        loadingMessage: 'Loading permissions information...',
        mainControllerOptions: {
          prmCtrl: this
        },
        settingsController: this,
        settingsGridCssClass: 'permissions-layout'
      });
    };

    RedesignPermissionsController.prototype.removeSpinnerAndRenderAsync = function() {
      this.spinnerContainer.remove();
      return this.el.append(this.gridController.el);
    };

    RedesignPermissionsController.prototype.loadGrid = function() {
      this.initGrid();
      return this.el.append(this.gridController.el);
    };

    RedesignPermissionsController.prototype.getCategories = function() {
      var categories, ref, userCategory;
      categories = [
        {
          type: "users",
          label: "Users",
          placeholder: "Search for Users",
          addText: "ADD USER",
          mainController: App.RedesignUserPermissionsController,
          addController: App.RedesignAddUserController,
          upperSectionController: App.RedesignGroupsForUsersPermissionsController,
          lowerSectionController: App.RedesignDashboardsForUsersPermissionsController
        }, {
          type: "groups",
          label: "Groups",
          placeholder: "Search for Groups",
          addText: "ADD GROUP",
          mainController: App.RedesignGroupPermissionsController,
          addController: App.RedesignAddGroupController,
          upperSectionController: App.RedesignUsersForGroupsPermissionsController,
          lowerSectionController: App.RedesignDashboardsForGroupsPermissionsController
        }, {
          type: "dashboards",
          label: "Dashboards",
          placeholder: "Search for Dashboards",
          mainController: App.RedesignDashboardPermissionSettingsController,
          upperSectionController: App.RedesignGroupsForDashboardsPermissionsController,
          lowerSectionController: App.RedesignUsersForDashboardsPermissionsController
        }
      ];
      if ((ref = App.Site.first()) != null ? ref.sso_enabled : void 0) {
        userCategory = categories[0];
        delete userCategory.addText;
      }
      return categories;
    };

    RedesignPermissionsController.prototype.release = function() {
      var ref;
      this.releaseDashboardControllerBindings();
      this.releaseUserControllerBindings();
      this.releaseGroupControllerBindings();
      if ((ref = this.gridController) != null) {
        ref.release();
      }
      return RedesignPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignPermissionsController.prototype.releaseMainControllerSpecificBinding = function(category) {
      if ((category != null ? category.type : void 0) != null) {
        switch (category.type) {
          case 'dashboards':
            return this.releaseDashboardControllerBindings();
          case 'users':
            return this.releaseUserControllerBindings();
          case 'groups':
            return this.releaseGroupControllerBindings();
        }
      }
    };

    RedesignPermissionsController.prototype.setUpForMainController = function(category) {
      if ((category != null ? category.type : void 0) != null) {
        switch (category.type) {
          case 'dashboards':
            return this.setUpForDashboardController();
          case 'users':
            return this.setUpForUsersController();
          case 'groups':
            return this.setUpForGroupsController();
        }
      }
    };

    RedesignPermissionsController.prototype.setUpForUsersController = function() {
      var ref;
      this.setCachedMapsForUsers();
      App.GroupMembership.bind('change', this.groupMembershipUpdatedForUsers);
      if ((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0) {
        return this.bindToDashboardsAndDashboardGroupPermission();
      } else {
        return App.Dashboard.bind('remaining-state-loaded', this.remainingStateLoadedForUsers);
      }
    };

    RedesignPermissionsController.prototype.bindToDashboardsAndDashboardGroupPermission = function() {
      App.DashboardGroupPermission.bind('refresh change', this.dashboardPermissionChanged);
      return App.Dashboard.bind('refresh change', this.dashboardChanged);
    };

    RedesignPermissionsController.prototype.releaseUserControllerBindings = function() {
      App.Dashboard.unbind('remaining-state-loaded', this.remainingStateLoadedForUsers);
      App.DashboardGroupPermission.unbind('refresh', this.dashboardPermissionChanged);
      App.DashboardGroupPermission.unbind('change', this.dashboardPermissionChanged);
      App.GroupMembership.unbind('change', this.groupMembershipUpdated);
      App.Dashboard.unbind('refresh', this.dashboardChanged);
      return App.Dashboard.unbind('change', this.dashboardChanged);
    };

    RedesignPermissionsController.prototype.setUpForGroupsController = function() {
      var ref;
      this.setCachedMapsForGroups();
      App.GroupMembership.bind('change', this.groupMembershipUpdated);
      if ((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0) {
        return this.bindToDashboardGroupPermissionForGroups();
      } else {
        return App.Dashboard.bind('remaining-state-loaded', this.remainingStateLoadedForGroups);
      }
    };

    RedesignPermissionsController.prototype.bindToDashboardGroupPermissionForGroups = function() {
      App.DashboardGroupPermission.bind('change', this.dashboardPermissionChanged);
      return App.Dashboard.bind('refresh change', this.dashboardChanged);
    };

    RedesignPermissionsController.prototype.releaseGroupControllerBindings = function() {
      App.Dashboard.unbind('remaining-state-loaded', this.remainingStateLoadedForGroups);
      App.GroupMembership.unbind('change', this.groupMembershipUpdated);
      App.DashboardGroupPermission.unbind('change', this.dashboardPermissionChanged);
      App.Dashboard.unbind('refresh', this.dashboardChanged);
      return App.Dashboard.unbind('change', this.dashboardChanged);
    };

    RedesignPermissionsController.prototype.setUpForDashboardController = function() {
      var ref;
      this.setCachedMapsForDashboards();
      App.GroupMembership.bind('save', this.groupMembershipUpdatedForDashboards);
      App.GroupMembership.bind('destroy', this.groupMembershipDeletedForDashboards);
      if ((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0) {
        return this.bindToDashboardGroupPermissionForDashboards();
      } else {
        return App.Dashboard.bind('remaining-state-loaded', this.remainingStateLoadedForDashboards);
      }
    };

    RedesignPermissionsController.prototype.bindToDashboardGroupPermissionForDashboards = function() {
      return App.DashboardGroupPermission.bind('change', this.groupPermissionUpdated);
    };

    RedesignPermissionsController.prototype.releaseDashboardControllerBindings = function() {
      App.Dashboard.unbind('remaining-state-loaded', this.remainingStateLoadedForDashboards);
      App.DashboardGroupPermission.unbind('change', this.groupPermissionUpdated);
      App.GroupMembership.unbind('save', this.groupMembershipUpdatedForDashboards);
      App.GroupMembership.unbind('destroy', this.groupMembershipDeletedForDashboards);
      return App.GroupMembership.unbind('change', this.groupMembershipUpdatedForUsers);
    };

    RedesignPermissionsController.prototype.dashboardPermissionChanged = function(groupPermission) {
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      return this.trigger('dashboard-group-permissions-updated', groupPermission);
    };

    RedesignPermissionsController.prototype.groupPermissionUpdated = function(groupPermission) {
      this.dashboardToGroupsMap = App.DashboardGroupPermission.dashboardToGroupsMap();
      App.DashboardGroupPermission.updateDashboardToUsersMap(this.dashboardToUsersMap, groupPermission.dashboard_id, this.dashboardToGroupsMap, this.groupToUsersMap);
      return this.trigger('group-permissions-map-updated', groupPermission);
    };

    RedesignPermissionsController.prototype.groupMembershipUpdated = function(groupMembership) {
      this.setGroupMembershipRelatedChanges();
      return this.trigger('group-membership-updated', groupMembership);
    };

    RedesignPermissionsController.prototype.groupMembershipDeleted = function(groupMembership) {
      this.setGroupMembershipRelatedChanges();
      return this.trigger('group-membership-deleted', groupMembership);
    };

    RedesignPermissionsController.prototype.groupMembershipUpdatedForDashboards = function(groupMembership) {
      this.setGroupMembershipRelatedChangesForDashboards();
      return this.trigger('group-membership-updated', groupMembership);
    };

    RedesignPermissionsController.prototype.groupMembershipDeletedForDashboards = function(groupMembership) {
      this.setGroupMembershipRelatedChangesForDashboards();
      return this.trigger('group-membership-deleted', groupMembership);
    };

    RedesignPermissionsController.prototype.groupMembershipUpdatedForUsers = function(groupMembership) {
      this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
      return this.trigger('group-membership-updated', groupMembership);
    };

    RedesignPermissionsController.prototype.dashboardChanged = function(dashboard) {
      this.ownerDashboardMap = App.User.ownerDashboardMap();
      return this.trigger('dashboard-updated', dashboard);
    };

    RedesignPermissionsController.prototype.groupToDashboardUpdated = function() {
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      return this.trigger('group-to-dashboards-updated');
    };

    RedesignPermissionsController.prototype.setGroupMembershipRelatedChanges = function() {
      this.groupToUsersMap = App.GroupMembership.membershipMap();
      return this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
    };

    RedesignPermissionsController.prototype.setGroupMembershipRelatedChangesForDashboards = function() {
      this.groupToUsersMap = App.GroupMembership.membershipMap();
      this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
      return this.dashboardToUsersMap = App.DashboardGroupPermission.dashboardToUsersMap(this.dashboardToGroupsMap, this.groupToUsersMap);
    };

    RedesignPermissionsController.prototype.setCachedMapsForDashboards = function() {
      this.dashboardToGroupsMap = App.DashboardGroupPermission.dashboardToGroupsMap();
      this.groupToUsersMap = App.GroupMembership.membershipMap();
      this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
      return this.dashboardToUsersMap = App.DashboardGroupPermission.dashboardToUsersMap(this.dashboardToGroupsMap, this.groupToUsersMap);
    };

    RedesignPermissionsController.prototype.setCachedMapsForUsers = function() {
      this.ownerDashboardMap = App.User.ownerDashboardMap();
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
      return this.groupToGroupRolesMap = App.Group.groupToGroupRolesMap();
    };

    RedesignPermissionsController.prototype.setCachedMapsForGroups = function() {
      this.groupToUsersMap = App.GroupMembership.membershipMap();
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      return this.userToGroupsMap = App.GroupMembership.userToGroupsMap();
    };

    RedesignPermissionsController.prototype.remainingStateLoadedForUsers = function() {
      this.bindToDashboardsAndDashboardGroupPermission();
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      this.ownerDashboardMap = App.User.ownerDashboardMap();
      return this.trigger('remaining-state-updated');
    };

    RedesignPermissionsController.prototype.remainingStateLoadedForGroups = function() {
      this.bindToDashboardGroupPermissionForGroups();
      this.groupToDashboardsMap = App.DashboardGroupPermission.groupToPermissionMap();
      return this.trigger('remaining-state-updated');
    };

    RedesignPermissionsController.prototype.remainingStateLoadedForDashboards = function() {
      this.bindToDashboardGroupPermissionForDashboards();
      this.dashboardToGroupsMap = App.DashboardGroupPermission.dashboardToGroupsMap();
      this.dashboardToUsersMap = App.DashboardGroupPermission.dashboardToUsersMap(this.dashboardToGroupsMap, this.groupToUsersMap);
      return this.trigger('remaining-state-updated');
    };

    return RedesignPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsGridPanelController = (function(superClass) {
    extend(RedesignSettingsGridPanelController, superClass);

    function RedesignSettingsGridPanelController() {
      this.rerenderRows = bind(this.rerenderRows, this);
      this.itemDestroyed = bind(this.itemDestroyed, this);
      this.askForConfirmation = bind(this.askForConfirmation, this);
      this.showMessage = bind(this.showMessage, this);
      this.removeItem = bind(this.removeItem, this);
      this.closeEdit = bind(this.closeEdit, this);
      RedesignSettingsGridPanelController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "grid", 'parentCtrl');
      this.bindToSimpleGrid();
    }

    RedesignSettingsGridPanelController.prototype.bindToSimpleGrid = function() {
      this.parentCtrl.bubbles(this.grid, 'selected selected-row-updated unselected');
      return this.grid.bind('clicked-menu-option', this.parentCtrl.clickedGearOption);
    };

    RedesignSettingsGridPanelController.prototype.release = function() {
      this.grid.unbind("clicked-menu-option");
      this.grid.unbind("selected");
      this.grid.unbind("unselected");
      this.grid.release();
      return RedesignSettingsGridPanelController.__super__.release.apply(this, arguments);
    };

    RedesignSettingsGridPanelController.prototype.closeEdit = function() {
      var ref;
      return (ref = this.parentCtrl.editRow) != null ? ref.remove() : void 0;
    };

    RedesignSettingsGridPanelController.prototype.search = function(searchTerm) {
      var ref;
      return (ref = this.grid) != null ? ref.search(searchTerm) : void 0;
    };

    RedesignSettingsGridPanelController.prototype.removeItem = function(item, rowEl) {
      item.destroy();
      return this.parentCtrl.trigger('deletedRow');
    };

    RedesignSettingsGridPanelController.prototype.showMessage = function(rowEl, message, error, followOnMethod, followOnParam) {
      var messageRow, prevRow;
      messageRow = $(this.view("redesign/permissions/message_row")({
        message: message,
        error: error
      }));
      prevRow = rowEl.prev();
      rowEl.before(messageRow);
      messageRow.find(".close-button").on("click", function() {
        messageRow.remove();
        return typeof followOnMethod === "function" ? followOnMethod(followOnParam) : void 0;
      });
      if (prevRow.hasClass('sg-overlay-row')) {
        return prevRow.remove();
      }
    };

    RedesignSettingsGridPanelController.prototype.askForConfirmation = function(item, rowEl, messageClass, buttonText, followOnMethod) {
      var confirmationRow;
      this.activeRowEl = rowEl;
      confirmationRow = $(this.view("redesign/permissions/confirm_row")({
        buttonText: buttonText
      }));
      confirmationRow.find(".message." + messageClass).addClass('visible');
      rowEl.before(confirmationRow);
      confirmationRow.find(".cancel").on("click", function() {
        return confirmationRow.remove();
      });
      return confirmationRow.find(".confirm").on("click", function() {
        confirmationRow.remove();
        return typeof followOnMethod === "function" ? followOnMethod(item, rowEl) : void 0;
      });
    };

    RedesignSettingsGridPanelController.prototype.itemDestroyed = function(item) {
      var ref, row;
      row = {};
      row[App.RedesignSimpleGridController.OBJECT_FIELD] = item;
      return (ref = this.grid) != null ? ref.deleteRow(row) : void 0;
    };

    RedesignSettingsGridPanelController.prototype.clearHighlightedRow = function() {
      return this.grid.clearHighlightedRow();
    };

    RedesignSettingsGridPanelController.prototype.rerenderRows = function() {
      return this.grid.updateRows(this.parentCtrl.getRows());
    };

    return RedesignSettingsGridPanelController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSimpleGridController = (function(superClass) {
    extend(RedesignSimpleGridController, superClass);

    RedesignSimpleGridController.prototype.elements = {
      '.simple-grid': 'simpleGrid',
      '.sg-empty-text .text': 'emptyGridText',
      '.sg-body': 'bodyEl',
      '.sg-menu': 'menuEl'
    };

    RedesignSimpleGridController.prototype.events = {
      'click .sg-header-column.sortable': 'clickedSort',
      'click .sg-body .sg-row': 'clickedRow',
      'click .sg-item': 'clickedItem',
      'click .sg-gear': 'toggleMenu',
      'mouseenter .sg-row': 'hideMenu',
      'mouseenter .sg-column.name-column, .sg-column > *': 'rowItemMouseEnter',
      'mouseleave .sg-column.name-column, .sg-column > *': 'rowItemMouseLeave'
    };

    RedesignSimpleGridController.OBJECT_FIELD = '___periscope_object';

    RedesignSimpleGridController.GROUP_NAME = "groups";

    RedesignSimpleGridController.DASHBOARD_NAME = "dashboards";

    function RedesignSimpleGridController() {
      this.rowItemMouseLeave = bind(this.rowItemMouseLeave, this);
      this.rowItemMouseEnter = bind(this.rowItemMouseEnter, this);
      this.formatString = bind(this.formatString, this);
      this.formatDate = bind(this.formatDate, this);
      this.clickedItem = bind(this.clickedItem, this);
      this.search = bind(this.search, this);
      this.rowCompareByColumn = bind(this.rowCompareByColumn, this);
      this.logNameSort = bind(this.logNameSort, this);
      this.clickedSort = bind(this.clickedSort, this);
      this.clearHighlightedRow = bind(this.clearHighlightedRow, this);
      this.clickedRow = bind(this.clickedRow, this);
      this.toggleMenu = bind(this.toggleMenu, this);
      this.hideMenu = bind(this.hideMenu, this);
      this.deleteRow = bind(this.deleteRow, this);
      this.updateRowObject = bind(this.updateRowObject, this);
      this.updateRow = bind(this.updateRow, this);
      this.renderRow = bind(this.renderRow, this);
      this.updateSearchTokens = bind(this.updateSearchTokens, this);
      this.getAddedRemovedChangedRows = bind(this.getAddedRemovedChangedRows, this);
      this.updateChangedRows = bind(this.updateChangedRows, this);
      this.updateRowsAndScroll = bind(this.updateRowsAndScroll, this);
      this.updateRows = bind(this.updateRows, this);
      this.renderSorted = bind(this.renderSorted, this);
      this.rerenderRowsUnsorted = bind(this.rerenderRowsUnsorted, this);
      this.rerenderRows = bind(this.rerenderRows, this);
      this.setRows = bind(this.setRows, this);
      this.addMenuOptionExceptions = bind(this.addMenuOptionExceptions, this);
      var ref, ref1;
      RedesignSimpleGridController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "gridClass", "columns", "rows", "rowTemplate", "searchAttributes", "menuOptions", "unselectEnabled");
      this.batchSize = 100;
      this.siteTimezone = (ref = App.Site) != null ? (ref1 = ref.first()) != null ? ref1.display_timezone : void 0 : void 0;
      this.html(this.view("redesign/permissions/simple_grid")({
        columns: this.columns,
        subcolumns: this.subcolumns,
        activeDisabled: this.activeDisabled,
        emptyMessageType: this.emptyMessageType
      }));
      this.menuEl = (new App.RedesignSimpleGridMenuController({
        menuOptions: this.menuOptions
      })).getMenuEl();
      this.simpleGrid.addClass(this.gridClass);
      this.currSortColumn = this.columns.first();
      this.sortOrder = 1;
      this.debouncedLogNameSort = _.debounce(this.logNameSort, 1000);
      this.sortRows(this.currSortColumn);
      this.renderAll();
    }

    RedesignSimpleGridController.prototype.clickRow = function(number) {
      var rows;
      rows = this.bodyEl.find('.sg-row');
      if (rows.length > number) {
        return rows[number].click();
      }
    };

    RedesignSimpleGridController.prototype.addMenuOptionExceptions = function(map) {
      var menuOptions, objectId, results;
      this.menuOptionExceptions = {};
      results = [];
      for (objectId in map) {
        menuOptions = map[objectId];
        results.push(this.menuOptionExceptions[objectId] = (new App.RedesignSimpleGridMenuController({
          menuOptions: menuOptions
        })).getMenuEl());
      }
      return results;
    };

    RedesignSimpleGridController.prototype.setRows = function(rows) {
      return this.rows = rows;
    };

    RedesignSimpleGridController.prototype.rerenderRows = function(rows) {
      this.setRows(rows);
      return this.renderSorted();
    };

    RedesignSimpleGridController.prototype.rerenderRowsUnsorted = function(rows) {
      this.setRows(rows);
      return this.renderAll();
    };

    RedesignSimpleGridController.prototype.renderSorted = function() {
      this.sortRows(this.currSortColumn);
      return this.renderAll();
    };

    RedesignSimpleGridController.prototype.updateRows = function(rows) {
      var i, len, ref, results, row;
      this.setRows(rows);
      if (this.isAnyRowActive()) {
        try {
          ref = this.rows;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            row = ref[i];
            results.push(this.updateRow(row));
          }
          return results;
        } catch (error) {
          return this.renderSorted();
        }
      } else {
        return this.renderSorted();
      }
    };

    RedesignSimpleGridController.prototype.updateRowsAndScroll = function(rows) {
      var scrollTop;
      scrollTop = this.bodyEl.scrollTop();
      this.updateRows(rows);
      this.bodyEl.scrollTop(scrollTop);
      if (!this.isAnyRowActive()) {
        return this.clickRow(0);
      }
    };

    RedesignSimpleGridController.prototype.updateChangedRows = function(rows) {
      var addedRows, changedRows, ref, removedRows;
      ref = this.getAddedRemovedChangedRows(rows, this.rows), addedRows = ref[0], removedRows = ref[1], changedRows = ref[2];
      if (this.DOMRows().length < this.rows.length) {
        this.rowsToUpdate = rows;
        this.replaceChangedRows(changedRows);
        return;
      }
      this.updateChangesInDom(addedRows, removedRows, changedRows);
      return this.rowsToUpdate = null;
    };

    RedesignSimpleGridController.prototype.updateChangesInDom = function(addedRows, removedRows, changedRows) {
      this.deleteRemovedRows(removedRows);
      this.insertAddedRows(addedRows);
      return this.replaceChangedRows(changedRows);
    };

    RedesignSimpleGridController.prototype.deleteRemovedRows = function(rows) {
      var i, len, results, row, rowEl, rowId, rowIndex;
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        rowId = this.getIdWithoutBackslash(row);
        rowIndex = this.getRowIdIndex(this.rows, rowId);
        rowEl = this.getRowDOMElement(rowId);
        this.rows.splice(rowIndex, 1);
        results.push($(rowEl).remove());
      }
      return results;
    };

    RedesignSimpleGridController.prototype.insertAddedRows = function(rows) {
      var i, index, len, newRowEl, results, row, rowLength;
      rowLength = this.DOMRows().length;
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        index = this.getRowInsertIndex(row);
        newRowEl = this.renderRow(row);
        if (index >= rowLength) {
          this.rows.push(row);
          this.bodyEl.append(newRowEl);
        } else {
          this.rows.splice(index, 0, row);
          this.DOMRows().eq(index).before(newRowEl);
        }
        results.push(rowLength++);
      }
      return results;
    };

    RedesignSimpleGridController.prototype.DOMRows = function() {
      return $('.sg-row');
    };

    RedesignSimpleGridController.prototype.replaceChangedRows = function(rows) {
      var activeRowId, i, len, newRowEl, results, row, rowDOMEl, rowId, rowIndex;
      activeRowId = this.isAnyRowActive() ? this.getActiveRowId() : null;
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        rowId = this.getIdWithoutBackslash(row);
        rowIndex = this.getRowIdIndex(this.rows, rowId);
        rowDOMEl = this.getRowDOMElement(rowId);
        if (rowDOMEl == null) {
          continue;
        }
        newRowEl = this.renderRow(row);
        this.rows[rowIndex] = row;
        if ((activeRowId != null) && activeRowId === rowId) {
          newRowEl.addClass("active");
          this.trigger('selected-row-updated', row, newRowEl);
          activeRowId = null;
        }
        $(rowDOMEl).find('.sg-menu').detach();
        results.push($(rowDOMEl).replaceWith(newRowEl));
      }
      return results;
    };

    RedesignSimpleGridController.prototype.getRowInsertIndex = function(row) {
      if (this.rows.length === 0) {
        return 0;
      }
      return this.findRowInsertIndex(0, this.rows.length - 1, row, this.rows);
    };

    RedesignSimpleGridController.prototype.findRowInsertIndex = function(startIndex, endIndex, row, rows) {
      var compareResult, midIndex;
      if (startIndex === endIndex) {
        if (this.rowCompare(row, rows[startIndex]) > 0) {
          return startIndex + 1;
        } else {
          return startIndex;
        }
      } else if (endIndex < startIndex) {
        return startIndex;
      }
      midIndex = Math.floor((startIndex + endIndex) / 2);
      compareResult = this.rowCompare(row, rows[midIndex]);
      if (compareResult === 0) {
        return midIndex;
      } else if (compareResult < 0) {
        return this.findRowInsertIndex(startIndex, midIndex - 1, row, rows);
      } else {
        return this.findRowInsertIndex(midIndex + 1, endIndex, row, rows);
      }
    };

    RedesignSimpleGridController.prototype.rowCompare = function(row1, row2) {
      var rowComparer;
      rowComparer = this.rowCompareByColumn(this.currSortColumn);
      return rowComparer(row1, row2);
    };

    RedesignSimpleGridController.prototype.getAddedRemovedChangedRows = function(newRows, oldRows) {
      var added, changed, i, id, len, newRow, newRowId, oldIdsToRows, oldRow, removed, row;
      added = [];
      removed = [];
      changed = [];
      oldIdsToRows = this.getIdsToRows(oldRows);
      for (i = 0, len = newRows.length; i < len; i++) {
        newRow = newRows[i];
        newRowId = this.getIdWithoutBackslash(newRow);
        oldRow = oldIdsToRows[newRowId];
        if (oldRow) {
          if (this.rowChanged(newRow, oldRow)) {
            changed.push(newRow);
          }
          delete oldIdsToRows[newRowId];
        } else {
          added.push(newRow);
        }
      }
      for (id in oldIdsToRows) {
        row = oldIdsToRows[id];
        removed.push(row);
      }
      return [added, removed, changed];
    };

    RedesignSimpleGridController.prototype.rowChanged = function(row1, row2) {
      if (this.rowsEqualCallback != null) {
        return !this.rowsEqualCallback(row1, row2);
      } else {
        return JSON.stringify(row1) !== JSON.stringify(row2);
      }
    };

    RedesignSimpleGridController.prototype.getIdWithoutBackslash = function(row) {
      return this.getId(row).replace('\\', '');
    };

    RedesignSimpleGridController.prototype.getIdsToRows = function(rows) {
      var i, idsToRows, len, row;
      idsToRows = {};
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        idsToRows[this.getIdWithoutBackslash(row)] = row;
      }
      return idsToRows;
    };

    RedesignSimpleGridController.prototype.getRowIdIndex = function(rows, rowId) {
      return rows.findIndex((function(_this) {
        return function(row) {
          return _this.getIdWithoutBackslash(row) === rowId;
        };
      })(this));
    };

    RedesignSimpleGridController.prototype.getRowDOMElement = function(rowId) {
      return document.getElementById(rowId);
    };

    RedesignSimpleGridController.prototype.getActiveRowId = function() {
      return this.bodyEl.find('.sg-row.active').attr('obj_id');
    };

    RedesignSimpleGridController.prototype.isAnyRowActive = function() {
      return this.bodyEl.find('.sg-row.active').length > 0;
    };

    RedesignSimpleGridController.prototype.updateSearchTokens = function(row) {
      var a, tokens;
      tokens = (function() {
        var i, len, ref, results;
        ref = this.searchAttributes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          a = ref[i];
          if (row[a]) {
            results.push(row[a]);
          }
        }
        return results;
      }).call(this);
      return row._searchTokens = tokens.tokenize();
    };

    RedesignSimpleGridController.prototype.setEmptyMessage = function(emptyMessage) {
      return this.emptyMessage = emptyMessage;
    };

    RedesignSimpleGridController.prototype.renderEmpty = function() {
      var emptyMessage;
      this.simpleGrid.addClass('empty');
      emptyMessage = this.emptyMessage;
      if (this.gridType != null) {
        if (emptyMessage == null) {
          emptyMessage = "No " + this.gridType;
        }
      }
      if (emptyMessage == null) {
        emptyMessage = 'Nothing to show.';
      }
      return this.emptyGridText.text(emptyMessage);
    };

    RedesignSimpleGridController.prototype.renderAll = function() {
      var ref;
      this.renderVersion = Math.random();
      this.menuEl.detach();
      this.menuEl = (new App.RedesignSimpleGridMenuController({
        menuOptions: this.menuOptions
      })).getMenuEl();
      this.bodyEl.empty();
      if (((ref = this.rows) != null ? ref.length : void 0) > 0) {
        this.simpleGrid.removeClass('empty');
        return this.render(this.renderVersion, 0);
      } else {
        return this.renderEmpty();
      }
    };

    RedesignSimpleGridController.prototype.render = function(renderVersion, startIndex) {
      var endIndex, i, index, newStartIndex, ref, ref1, row, rowEl;
      if (this.renderVersion !== renderVersion) {
        return;
      }
      endIndex = startIndex + this.batchSize;
      if (endIndex > this.rows.length) {
        endIndex = this.rows.length;
      }
      for (index = i = ref = startIndex, ref1 = endIndex; ref <= ref1 ? i < ref1 : i > ref1; index = ref <= ref1 ? ++i : --i) {
        row = this.rows[index];
        rowEl = this.renderRow(row);
        this.bodyEl.append(rowEl);
      }
      newStartIndex = startIndex + this.batchSize;
      if (newStartIndex >= this.rows.length) {
        if (this.rowsToUpdate != null) {
          this.updateChangedRows(this.rowsToUpdate);
        }
        return;
      }
      if (AppRedesign.current().uiQueue != null) {
        AppRedesign.current().uiQueue.add(((function(_this) {
          return function(renderVersion, newStartIndex) {
            return function() {
              return _this.render(renderVersion, newStartIndex);
            };
          };
        })(this))(this.renderVersion, newStartIndex), 'simple-grid');
        return AppRedesign.current().uiQueue.insertInterrupt();
      }
    };

    RedesignSimpleGridController.prototype.renderRow = function(row) {
      var rowEl;
      rowEl = $(this.rowTemplate({
        row: row,
        dateFormatter: this.formatDate,
        stringFormatter: this.formatString,
        hideEditColumn: this.hideEditColumn,
        customerUnificationEnabled: AppRedesign.hasCustomerUnification()
      }));
      rowEl.addClass("sg-row");
      rowEl.data("row", row);
      this.updateSearchTokens(row);
      if ((this.userSearchTokens != null) && !App.Utils.matchesQuery(this.userSearchTokens, row._searchTokens)) {
        rowEl.addClass("hidden");
      }
      return rowEl;
    };

    RedesignSimpleGridController.prototype.updateRow = function(newRowObj, no_reload) {
      var newRowEl, rowEl;
      if (no_reload == null) {
        no_reload = false;
      }
      if (!no_reload && newRowObj[this.constructor.OBJECT_FIELD] instanceof App.PeriscopeModel) {
        newRowObj[this.constructor.OBJECT_FIELD].reload();
      }
      newRowEl = this.renderRow(newRowObj);
      rowEl = this.bodyEl.find(".sg-row[obj_id=\"" + (this.getId(newRowObj)) + "\"]").first();
      if (rowEl[0] != null) {
        if (rowEl.hasClass("active")) {
          newRowEl.addClass("active");
          this.trigger('selected-row-updated', newRowObj, newRowEl);
        }
        $(rowEl).find('.sg-menu').detach();
        $(rowEl).replaceWith(newRowEl);
      } else {
        this.bodyEl.prepend(newRowEl);
      }
      return this.updateRowObject(newRowObj);
    };

    RedesignSimpleGridController.prototype.updateRowObject = function(row) {
      var found, i, idx, len, obj, ref;
      ref = this.rows;
      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
        obj = ref[idx];
        if (this.getId(obj) === this.getId(row)) {
          this.rows[idx] = row;
          found = true;
          break;
        }
      }
      if (found == null) {
        return this.rows[this.rows.length] = row;
      }
    };

    RedesignSimpleGridController.prototype.deleteRow = function(newRowObj) {
      var r, rowEl, rowId;
      rowId = this.getId(newRowObj);
      rowEl = this.bodyEl.find(".sg-row[obj_id=\"" + rowId + "\"]").first();
      if (rowEl[0] != null) {
        $(rowEl).remove();
      }
      return this.rows = (function() {
        var i, len, ref, results;
        ref = this.rows;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          r = ref[i];
          if (this.getId(r) !== rowId) {
            results.push(r);
          }
        }
        return results;
      }).call(this);
    };

    RedesignSimpleGridController.prototype.getId = function(obj) {
      if (this.idCallback != null) {
        return this.idCallback(obj);
      } else {
        return obj[App.RedesignSimpleGridController.OBJECT_FIELD].cid;
      }
    };

    RedesignSimpleGridController.prototype.hideMenu = function(evt) {
      return this.menuEl.detach();
    };

    RedesignSimpleGridController.prototype.toggleMenu = function(evt) {
      var gear, menuEl, objectId, ref, ref1, row, rowEl;
      evt.stopPropagation();
      gear = $(evt.target).closest(".sg-gear");
      rowEl = $(evt.target).closest('.sg-row');
      row = rowEl != null ? rowEl.data('row') : void 0;
      objectId = row != null ? (ref = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0 : void 0;
      if (objectId && ((ref1 = this.menuOptionExceptions) != null ? ref1[objectId] : void 0)) {
        menuEl = this.menuOptionExceptions[objectId];
        return this.toggleMenuElement(menuEl, gear);
      } else if (this.menuOptions.length > 0) {
        return this.toggleMenuElement(this.menuEl, gear);
      }
    };

    RedesignSimpleGridController.prototype.toggleMenuElement = function(menuEl, gear) {
      if (menuEl.parent()[0] === gear) {
        return menuEl.detach();
      } else {
        this.currentMenuEl = menuEl;
        return gear.append(menuEl);
      }
    };

    RedesignSimpleGridController.prototype.clickedRow = function(evt) {
      var row, rowEl;
      if (this.activeDisabled) {
        return;
      }
      rowEl = $(evt.currentTarget);
      if (rowEl[0] == null) {
        return;
      }
      if ($(rowEl[0]).parents('.sg-overlay-row').length > 0) {
        return;
      }
      if (rowEl.hasClass("active")) {
        if (this.unselectEnabled) {
          this.trigger("unselected", rowEl);
          return this.clearHighlightedRow();
        }
      } else {
        this.clearHighlightedRow();
        row = rowEl.data("row");
        rowEl.addClass("active");
        return this.trigger('selected', row, rowEl);
      }
    };

    RedesignSimpleGridController.prototype.clearHighlightedRow = function() {
      var ref;
      return (ref = this.bodyEl.find(".sg-row.active")) != null ? ref.removeClass("active") : void 0;
    };

    RedesignSimpleGridController.prototype.clickedSort = function(evt) {
      var column, header, sortOn;
      header = $(evt.target).closest('.sg-header-column');
      column = this.columns[header.index()];
      sortOn = column.sortOn;
      this.debouncedLogNameSort(sortOn);
      if (column === this.currSortColumn) {
        this.sortOrder *= -1;
      } else {
        this.sortOrder = 1;
      }
      this.sortRows(column);
      this.renderAll();
      return this.clickRow(0);
    };

    RedesignSimpleGridController.prototype.logNameSort = function(sortOn) {
      var columnName, columnNameSort, gridType;
      gridType = this.gridType;
      columnName = sortOn.split("_").last();
      if ([this.constructor.GROUP_NAME, this.constructor.DASHBOARD_NAME].includes(gridType) && columnName === "name") {
        columnNameSort = gridType + "_name";
        return App.Utils.logFeature(columnNameSort + "_sort_from_permissions_page");
      }
    };

    RedesignSimpleGridController.prototype.sortRows = function(column) {
      this.rows.sort(this.rowCompareByColumn(column));
      return this.currSortColumn = column;
    };

    RedesignSimpleGridController.prototype.rowCompareByColumn = function(column) {
      return (function(_this) {
        return function(row1, row2) {
          if ((row1[column.sortOn] == null) && (row2[column.sortOn] == null)) {
            return 0;
          }
          if (row1[column.sortOn] == null) {
            return _this.sortOrder * -1;
          }
          if (row2[column.sortOn] == null) {
            return _this.sortOrder * 1;
          }
          if (typeof row1[column.sortOn] === "boolean" && typeof row2[column.sortOn] === "boolean") {
            return _this.sortOrder * App.Utils.sortBooleanComparator(row1[column.sortOn], row2[column.sortOn]);
          }
          return _this.sortOrder * App.Utils.sortAlphanumericComparator(row1[column.sortOn], row2[column.sortOn]);
        };
      })(this);
    };

    RedesignSimpleGridController.prototype.search = function(searchTerm) {
      var i, len, matches, ref, results, rowEl, rowElements, rowTokens;
      if ((searchTerm != null ? searchTerm.length : void 0) > 0) {
        this.userSearchTokens = [searchTerm].tokenize();
      } else {
        this.userSearchTokens = null;
      }
      rowElements = this.bodyEl.children();
      if (this.userSearchTokens == null) {
        rowElements.removeClass("hidden");
        return;
      }
      results = [];
      for (i = 0, len = rowElements.length; i < len; i++) {
        rowEl = rowElements[i];
        rowEl = $(rowEl);
        rowTokens = (ref = rowEl.data("row")) != null ? ref._searchTokens : void 0;
        matches = (rowTokens != null) && App.Utils.matchesQuery(this.userSearchTokens, rowTokens);
        results.push(rowEl.toggleClass("hidden", !matches));
      }
      return results;
    };

    RedesignSimpleGridController.prototype.clickedItem = function(evt) {
      var itemEl, option, row, rowEl;
      evt.stopPropagation();
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      itemEl = $(evt.target).closest(".sg-item");
      option = itemEl.data("option");
      this.currentMenuEl.detach();
      return this.trigger("clicked-menu-option", row[App.RedesignSimpleGridController.OBJECT_FIELD], rowEl, option);
    };

    RedesignSimpleGridController.prototype.formatDate = function(timestamp) {
      var date, moment, ref, ref1, time;
      if (timestamp == null) {
        return null;
      }
      if (this.siteTimezone == null) {
        this.siteTimezone = (ref = App.Site) != null ? (ref1 = ref.first()) != null ? ref1.display_timezone : void 0 : void 0;
      }
      moment = App.TimeMachine.timestampToMoment(timestamp, App.TimeMachine.mapDisplayTimezone(this.siteTimezone));
      date = moment.format(App.RedesignPermissionsController.PERMISSIONS_DATE_FORMAT);
      time = moment.format(App.RedesignPermissionsController.PERMISSIONS_TIME_FORMAT);
      return [date, time];
    };

    RedesignSimpleGridController.prototype.formatString = function(str) {
      if (!!str) {
        return str;
      }
      return App.RedesignPermissionsController.BLANK_FIELD_FORMAT;
    };

    RedesignSimpleGridController.prototype.release = function() {
      this.renderVersion = Math.random();
      return RedesignSimpleGridController.__super__.release.apply(this, arguments);
    };

    RedesignSimpleGridController.prototype.rowItemMouseEnter = function(e) {
      var pointerOffset, ref, target, targetOffset, tooltipValue, tooltipWidth;
      target = $(e.target);
      if (!this.isOverflown(target[0])) {
        return;
      }
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      tooltipValue = target.text().trim();
      if (!tooltipValue) {
        return;
      }
      pointerOffset = App.RedesignTooltipPanel.DEFAULT_POINTER_OFFSET;
      targetOffset = target.offset();
      App.Utils.initCanvasWidthSizer(11);
      tooltipWidth = Math.min(250, App.Utils.canvasWidthForText(tooltipValue));
      return this.hoverTooltip = App.RedesignTooltipPanel.addPanel({
        side: App.RedesignTooltipPanel.BOTTOM,
        width: tooltipWidth + " px",
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        description: '',
        contentEl: $(this.view('tooltip_content')({
          tooltipValue: tooltipValue
        })),
        useSmallPointer: true,
        extraClass: 'light-theme'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, pointerOffset, targetOffset.left - (tooltipWidth - target.innerWidth()) * 0.45, targetOffset.top + (target.outerHeight() * App.RedesignTooltipPanel.DEFAULT_POINT_TOP_SCALE));
    };

    RedesignSimpleGridController.prototype.isOverflown = function(el) {
      if (!el) {
        return false;
      }
      return el.offsetWidth < el.scrollWidth;
    };

    RedesignSimpleGridController.prototype.rowItemMouseLeave = function() {
      var ref;
      if ((ref = this.hoverTooltip) != null) {
        ref.closeAndRelease();
      }
      return this.hoverTooltip = null;
    };

    return RedesignSimpleGridController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSimpleGridMenuController = (function(superClass) {
    extend(RedesignSimpleGridMenuController, superClass);

    RedesignSimpleGridMenuController.prototype.elements = {
      '.sg-menu': 'menuEl',
      '.sg-item-holder': 'itemHolderEl',
      '.sg-item': 'itemEl'
    };

    function RedesignSimpleGridMenuController() {
      var i, len, newItemEl, option, ref;
      RedesignSimpleGridMenuController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "menuOptions");
      this.html(this.view("redesign/permissions/simple_grid_gear_menu")());
      this.itemEl.detach();
      ref = this.menuOptions;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        newItemEl = this.itemEl.clone();
        newItemEl.text(option.label);
        newItemEl.data("option", option);
        if (option.type === 'remove') {
          newItemEl.removeClass('hover-eastern-blue');
          newItemEl.addClass('hover-red');
        }
        this.itemHolderEl.append(newItemEl);
      }
    }

    RedesignSimpleGridMenuController.prototype.getMenuEl = function() {
      return this.menuEl;
    };

    return RedesignSimpleGridMenuController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RoleBasedPermissionsController = (function(superClass) {
    extend(RoleBasedPermissionsController, superClass);

    RoleBasedPermissionsController.APPLIES_TO_ALL_SPACES = false;

    RoleBasedPermissionsController.TITLE = 'Roles and Policies';

    RoleBasedPermissionsController.EXTEND_HEADER = true;

    RoleBasedPermissionsController.prototype.className = 'directory-controller';

    RoleBasedPermissionsController.prototype.elements = {
      '.spinner-container': 'spinnerContainer'
    };

    function RoleBasedPermissionsController() {
      this.loadedDashboards = bind(this.loadedDashboards, this);
      this.loadedSpaces = bind(this.loadedSpaces, this);
      this.loadedRoles = bind(this.loadedRoles, this);
      this.loadedUsers = bind(this.loadedUsers, this);
      this.loadedDependencies = bind(this.loadedDependencies, this);
      RoleBasedPermissionsController.__super__.constructor.apply(this, arguments);
      this.info_hash = {};
      this.html(this.view('redesign/settings/permission_spinner')());
      this.loadDependencies();
    }

    RoleBasedPermissionsController.prototype.loadDependencies = function() {
      var loadDashboards, loadRoles, loadSpaces, loadUsers;
      loadUsers = jQuery.get("/api/" + (App.Site.first().id) + "/users/rbac_search", {
        client_site_id: App.Site.first().id,
        query: '',
        sort_by: 'first_name',
        sort_order: 'ASC',
        object_type: 'Dashboard',
        expand: 'roles',
        permissions: ''
      });
      loadRoles = jQuery.get('/roles', {
        client_site_id: App.Site.first().id
      });
      loadSpaces = jQuery.get("/sites/" + (App.Site.first().id) + "/space_info_for_site", {
        client_site_id: App.Site.first().id
      });
      loadDashboards = jQuery.get("/roles/dashboards_for_roles", {
        client_site_id: App.Site.first().id
      });
      return jQuery.when(loadUsers, loadRoles, loadSpaces, loadDashboards).done(this.loadedDependencies);
    };

    RoleBasedPermissionsController.prototype.loadedDependencies = function(response1, response2, response3, response4) {
      this.loadedUsers(response1.first());
      this.loadedRoles(response2.first());
      this.loadedSpaces(response3.first());
      this.loadedDashboards(response4.first());
      this.permissionsPage = new App.RoleBasedPermissionsPage(this.info_hash);
      this.append(this.permissionsPage.el);
      return this.removeSpinner();
    };

    RoleBasedPermissionsController.prototype.loadedUsers = function(response) {
      return this.info_hash['users'] = response.users;
    };

    RoleBasedPermissionsController.prototype.loadedRoles = function(response) {
      this.info_hash['roles'] = response.roles;
      return this.info_hash['defaultRolesCount'] = response.default_roles_count;
    };

    RoleBasedPermissionsController.prototype.loadedSpaces = function(response) {
      return this.info_hash['spaces'] = response.spaces;
    };

    RoleBasedPermissionsController.prototype.loadedDashboards = function(response) {
      this.info_hash['rolesToDashboards'] = response.roles;
      return this.info_hash['allDashboards'] = response.dashboards;
    };

    RoleBasedPermissionsController.prototype.removeSpinner = function() {
      return this.spinnerContainer.remove();
    };

    RoleBasedPermissionsController.prototype.release = function() {
      var ref;
      if ((ref = this.permissionsPage) != null) {
        ref.release();
      }
      return this.removeSpinner();
    };

    return RoleBasedPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardsForUsersPermissionsController = (function(superClass) {
    extend(RedesignDashboardsForUsersPermissionsController, superClass);

    RedesignDashboardsForUsersPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignDashboardsForUsersPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "dashboard_name"
      }, {
        label: "Access",
        "class": "access-column",
        sortOn: "can_edit"
      }
    ];

    function RedesignDashboardsForUsersPermissionsController() {
      this.rerenderGrid = bind(this.rerenderGrid, this);
      var ref;
      RedesignDashboardsForUsersPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "prmCtrl");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Dashboards"
      }));
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.rerenderGrid);
      }
      this.rows = this.getRows();
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "dashboard-details-grid fit-in-pane",
        columns: App.RedesignDashboardsForUsersPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view("redesign/permissions/dashboards_for_users_row"),
        searchAttributes: ["dashboard_name"],
        menuOptions: [],
        gridType: 'dashboards',
        unselectEnabled: true
      });
      this.editIcon.addClass("hidden");
      this.grid.bind("selected", this.openDropdown);
      this.grid.bind("unselected", this.closeDropdown);
      this.prmCtrl.bind('group-membership-updated dashboard-group-permissions-updated dashboard-updated', this.rerenderGrid);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignDashboardsForUsersPermissionsController.prototype.release = function() {
      var ref;
      this.grid.unbind("selected", this.openDropdown);
      this.grid.unbind("unselected", this.closeDropdown);
      this.prmCtrl.unbind('remaining-state-updated', this.rerenderGrid);
      this.prmCtrl.unbind('group-membership-updated', this.rerenderGrid);
      this.prmCtrl.unbind('dashboard-group-permissions-updated', this.rerenderGrid);
      this.prmCtrl.unbind('dashboard-updated', this.rerenderGrid);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignDashboardsForUsersPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardsForUsersPermissionsController.prototype.getRows = function() {
      return this.item.getDashboardInfo(this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap);
    };

    RedesignDashboardsForUsersPermissionsController.prototype.rerenderGrid = function() {
      var ref;
      this.rows = this.getRows();
      return (ref = this.grid) != null ? ref.rerenderRows(this.rows) : void 0;
    };

    RedesignDashboardsForUsersPermissionsController.prototype.closeDropdown = function(el) {
      el.find(".access-list").remove();
      return this.openEl = null;
    };

    RedesignDashboardsForUsersPermissionsController.prototype.openDropdown = function(dashboard, el) {
      var subEl;
      if (this.openEl != null) {
        this.openEl.find(".access-list").remove();
      }
      subEl = $(this.view("redesign/permissions/dashboards_accessible_by")({
        groupIds: dashboard.accessible_via,
        isOwnedByUser: dashboard.isOwnedByUser
      }));
      el.append(subEl);
      return this.openEl = el;
    };

    return RedesignDashboardsForUsersPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignGroupsForUsersPermissionsController = (function(superClass) {
    extend(RedesignGroupsForUsersPermissionsController, superClass);

    RedesignGroupsForUsersPermissionsController.prototype.elements = {
      '.section-body': 'sectionBody',
      '.edit-icon': 'editIcon'
    };

    RedesignGroupsForUsersPermissionsController.prototype.events = {
      'click .edit-icon': 'clickedEdit',
      'click .checkbox': 'changeGroupMembership'
    };

    RedesignGroupsForUsersPermissionsController.COLUMNS = [
      {
        label: "Name",
        "class": "name-column",
        sortOn: "group_name"
      }, {
        label: "Access",
        "class": "edit-column",
        sortOn: "can_edit"
      }
    ];

    function RedesignGroupsForUsersPermissionsController() {
      this.changeGroupMembership = bind(this.changeGroupMembership, this);
      this.renderRows = bind(this.renderRows, this);
      this.clickedEdit = bind(this.clickedEdit, this);
      var ref, ref1;
      RedesignGroupsForUsersPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "item", "prmCtrl");
      this.html(this.view("redesign/permissions/permissions_subsection")({
        headerName: "Groups"
      }));
      this.emptyMessage = "Grant access to Workbooks to configure user";
      this.user = this.item;
      if (!((ref = AppRedesign.current()) != null ? ref.remainingStateLoaded : void 0)) {
        this.prmCtrl.bind('remaining-state-updated', this.renderRows);
      }
      this.rows = this.getRows();
      this.grid = new App.RedesignSimpleGridController({
        el: this.sectionBody,
        gridClass: "group-details-grid fit-in-pane",
        columns: App.RedesignGroupsForUsersPermissionsController.COLUMNS,
        rows: this.rows,
        rowTemplate: this.view("redesign/permissions/groups_for_users_row"),
        searchAttributes: ["group_name"],
        menuOptions: [],
        gridType: 'groups',
        unselectEnabled: true,
        activeDisabled: true,
        emptyMessage: this.userLacksWorkbooksAccess() ? this.emptyMessage : null
      });
      if (this.userLacksWorkbooksAccess()) {
        if ((ref1 = this.grid) != null) {
          ref1.setEmptyMessage(this.emptyMessage);
        }
        this.editIcon.hide();
      }
      this.prmCtrl.bind('group-membership-updated', this.renderRows);
      App.Group.bind('refresh change', this.renderRows);
      new App.SearchFocusHelper({
        el: this.el,
        grid: this.grid
      });
    }

    RedesignGroupsForUsersPermissionsController.prototype.userLacksWorkbooksAccess = function() {
      return AppRedesign.allowRevokingWorkbooksAccess() && !this.user.workbooks_access;
    };

    RedesignGroupsForUsersPermissionsController.prototype.release = function() {
      var ref;
      this.prmCtrl.unbind('remaining-state-updated', this.renderRows);
      this.prmCtrl.unbind('group-membership-updated', this.renderRows);
      App.Group.unbind('refresh', this.renderRows);
      App.Group.unbind('change', this.renderRows);
      if ((ref = this.grid) != null) {
        ref.release();
      }
      return RedesignGroupsForUsersPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignGroupsForUsersPermissionsController.prototype.clickedEdit = function() {
      this.editIcon.toggleClass("active");
      if (this.editIcon.hasClass("active")) {
        this.sectionBody.addClass("editing");
        App.Utils.logFeature("edit_groups_from_permissions_page");
        return this.renderRowsEditable();
      } else {
        this.sectionBody.removeClass("editing");
        return this.renderRowsUneditable();
      }
    };

    RedesignGroupsForUsersPermissionsController.prototype.getRows = function() {
      if (this.userLacksWorkbooksAccess()) {
        return [];
      }
      return this.user.groupMembershipsByPermission(this.prmCtrl.userToGroupsMap);
    };

    RedesignGroupsForUsersPermissionsController.prototype.renderRows = function() {
      var ref, ref1;
      this.rows = this.getRows();
      if (this.editing) {
        return (ref = this.grid) != null ? ref.setRows(this.getEditableRows()) : void 0;
      } else {
        return (ref1 = this.grid) != null ? ref1.updateRows(this.getRows()) : void 0;
      }
    };

    RedesignGroupsForUsersPermissionsController.prototype.renderRowsEditable = function() {
      var editableRows;
      this.editing = true;
      editableRows = this.getEditableRows();
      return this.grid.rerenderRowsUnsorted(editableRows);
    };

    RedesignGroupsForUsersPermissionsController.prototype.getEditableRows = function() {
      var allUserGroupIds, allUsersGroupId, grp, hasSiteFamilyId, i, j, len, len1, r, rec, ref, ref1, userGroupRows;
      allUsersGroupId = App.Group.allUsersGroup().id;
      userGroupRows = [];
      ref = this.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        rec = ref[i];
        r = $.extend({}, rec);
        r['is_user_in_group'] || (r['is_user_in_group'] = true);
        if (r.id === allUsersGroupId || r.is_site_family_group) {
          r['disable'] || (r['disable'] = true);
        }
        userGroupRows.push(r);
      }
      allUserGroupIds = _.map(this.rows, 'id');
      ref1 = App.Group.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        grp = ref1[j];
        if (_.indexOf(allUserGroupIds, grp.id) < 0) {
          hasSiteFamilyId = (grp.site_family_id != null);
          userGroupRows.push({
            group_name: grp.name,
            id: grp.id,
            can_edit: grp.canEditCurrentSite(),
            is_user_in_group: false,
            disable: hasSiteFamilyId,
            is_site_family_group: hasSiteFamilyId
          });
        }
      }
      return userGroupRows;
    };

    RedesignGroupsForUsersPermissionsController.prototype.renderRowsUneditable = function() {
      this.editing = false;
      return this.grid.rerenderRows(this.rows);
    };

    RedesignGroupsForUsersPermissionsController.prototype.changeGroupMembership = function(evt) {
      var row, rowEl, targetCheckbox;
      evt.stopPropagation();
      targetCheckbox = $(evt.target).parent();
      if (targetCheckbox.hasClass('disabled')) {
        return;
      }
      targetCheckbox.toggleClass('selected');
      rowEl = $(evt.target).closest(".sg-row");
      row = rowEl.data("row");
      if (targetCheckbox.hasClass('selected')) {
        return App.Group.find(row.id).addUser(this.user);
      } else {
        return App.Group.find(row.id).removeUser(this.user);
      }
    };

    return RedesignGroupsForUsersPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignUserPermissionsController = (function(superClass) {
    extend(RedesignUserPermissionsController, superClass);

    RedesignUserPermissionsController.COLUMNS = [
      {
        label: "Name & Email",
        "class": "name-column",
        sortOn: "display_name"
      }, {
        label: "Groups",
        "class": "groups-column sg-center",
        sortOn: "group_count"
      }, {
        label: "Access",
        "class": "access-column",
        sortOn: "self_service_dashboards_access"
      }, {
        label: "Dashboards",
        "class": "dashboards-column sg-center",
        sortOn: "dashboard_count"
      }, {
        label: "Last Login",
        "class": "login-column",
        sortOn: "last_site_login"
      }, {
        label: "Password Changed",
        "class": "password-column",
        sortOn: "password_changed_at"
      }, {
        label: "2FA",
        "class": "tfa-column",
        sortOn: "is_tfa_active"
      }
    ];

    RedesignUserPermissionsController.SEARCH_ATTRIBUTES = ["display_name", "email"];

    RedesignUserPermissionsController.MENU_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Access Rights",
        type: "edit-access-rights"
      }, {
        label: "Reset Password",
        type: "reset-password"
      }, {
        label: "Reset 2FA",
        type: "reset-2fa"
      }, {
        label: "Remove",
        type: "remove"
      }
    ];

    RedesignUserPermissionsController.SITE_FAMILY_GROUP_USER_OPTIONS = [
      {
        label: "Edit",
        type: "edit"
      }, {
        label: "Access Rights",
        type: "edit-access-rights"
      }, {
        label: "Reset Password",
        type: "reset-password"
      }, {
        label: "Reset 2FA",
        type: "reset-2fa"
      }
    ];

    function RedesignUserPermissionsController() {
      this.setRows = bind(this.setRows, this);
      this.initRows = bind(this.initRows, this);
      this.handleEditError = bind(this.handleEditError, this);
      this.removeItem = bind(this.removeItem, this);
      this.reset2fa = bind(this.reset2fa, this);
      this.resetPassword = bind(this.resetPassword, this);
      this.confirmedUserAccessRights = bind(this.confirmedUserAccessRights, this);
      this.confirmUserAccessRights = bind(this.confirmUserAccessRights, this);
      this.changeWorkbooksRights = bind(this.changeWorkbooksRights, this);
      this.changeSelfServiceRights = bind(this.changeSelfServiceRights, this);
      this.confirmUserEdit = bind(this.confirmUserEdit, this);
      this.clickedGearOption = bind(this.clickedGearOption, this);
      this.membershipUpdated = bind(this.membershipUpdated, this);
      this.userUpdated = bind(this.userUpdated, this);
      var columns, menuOptions;
      RedesignUserPermissionsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "el", "prmCtrl");
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        this.currentRows = App.User.userInfos(this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap);
        App.User.searchUserInfos('', this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap, this.initRows);
      }
      columns = App.RedesignUserPermissionsController.COLUMNS.slice();
      menuOptions = App.RedesignUserPermissionsController.MENU_OPTIONS.slice();
      if (!AppRedesign.hasCustomerUnification()) {
        columns.splice(2, 1);
        menuOptions.splice(1, 1);
      }
      this.grid = new App.RedesignSimpleGridController({
        el: this.el,
        gridClass: "user-grid",
        columns: columns,
        rows: this.getRows(),
        rowTemplate: this.view("redesign/permissions/user_permission_row"),
        searchAttributes: App.RedesignUserPermissionsController.SEARCH_ATTRIBUTES,
        menuOptions: menuOptions,
        gridType: 'users',
        unselectEnabled: false
      });
      this.addMenuOptionExceptions();
      this.panelCtrl = new App.RedesignSettingsGridPanelController({
        el: this.el,
        grid: this.grid,
        parentCtrl: this
      });
      App.User.bind('save', this.userUpdated);
      App.User.bind('destroy', this.panelCtrl.itemDestroyed);
      this.prmCtrl.bind('group-membership-updated group-membership-deleted', this.membershipUpdated);
      this.prmCtrl.bind('dashboards-updated group-to-dashboards-updated', this.panelCtrl.rerenderRows);
      this.prmCtrl.bind('remaining-state-updated', this.panelCtrl.rerenderRows);
    }

    RedesignUserPermissionsController.prototype.release = function() {
      App.User.unbind('save', this.userUpdated);
      App.User.unbind('destroy', this.panelCtrl.itemDestroyed);
      this.prmCtrl.unbind('group-membership-updated', this.membershipUpdated);
      this.prmCtrl.unbind('group-membership-deleted', this.membershipUpdated);
      this.prmCtrl.unbind('dashboards-updated', this.panelCtrl.rerenderRows);
      this.prmCtrl.unbind('group-to-dashboards-updated', this.panelCtrl.rerenderRows);
      this.prmCtrl.unbind('remaining-state-updated', this.panelCtrl.rerenderRows);
      this.panelCtrl.release();
      return RedesignUserPermissionsController.__super__.release.apply(this, arguments);
    };

    RedesignUserPermissionsController.prototype.addMenuOptionExceptions = function() {
      var i, len, map, ref, siteFamilyGroupUserOptions, userId;
      if (!App.Site.isSpacesEnabled()) {
        return;
      }
      map = {};
      siteFamilyGroupUserOptions = this.constructor.SITE_FAMILY_GROUP_USER_OPTIONS.slice();
      if (!AppRedesign.hasCustomerUnification()) {
        siteFamilyGroupUserOptions.splice(1, 1);
      }
      ref = App.User.usersInSiteFamilyGroup();
      for (i = 0, len = ref.length; i < len; i++) {
        userId = ref[i];
        map[userId] = siteFamilyGroupUserOptions;
      }
      return this.grid.addMenuOptionExceptions(map);
    };

    RedesignUserPermissionsController.prototype.getUserInfo = function(user) {
      return user.userInfo(this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap);
    };

    RedesignUserPermissionsController.prototype.userUpdated = function(user) {
      var info;
      info = this.getUserInfo(user);
      if (info) {
        return this.grid.updateRow(info);
      }
    };

    RedesignUserPermissionsController.prototype.membershipUpdated = function(membership) {
      var user;
      try {
        user = App.User.find(membership.user_id);
        return this.grid.updateRow(this.getUserInfo(user));
      } catch (error) {

      }
    };

    RedesignUserPermissionsController.prototype.getRows = function() {
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return this.currentRows;
      } else {
        return App.User.userInfos(this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap);
      }
    };

    RedesignUserPermissionsController.prototype.clickedGearOption = function(user, rowEl, option) {
      this.panelCtrl.closeEdit();
      switch (option.type) {
        case "edit":
          return this.clickedEdit(user, rowEl);
        case "edit-access-rights":
          return this.clickedAccessRights(user, rowEl);
        case "reset-password":
          return this.panelCtrl.askForConfirmation(user, rowEl, "reset-password", "RESET", this.resetPassword);
        case "reset-2fa":
          return this.panelCtrl.askForConfirmation(user, rowEl, "reset-2fa", "RESET", this.reset2fa);
        case "remove":
          return this.panelCtrl.askForConfirmation(user, rowEl, "remove-user", "DELETE", this.removeItem);
      }
    };

    RedesignUserPermissionsController.prototype.clickedEdit = function(user, rowEl) {
      this.editingUser = user;
      this.editRow = $(this.view("redesign/permissions/user_row_edit")({
        row: user
      }));
      rowEl.before(this.editRow);
      this.editRow.find(".button.confirm").on("click", this.confirmUserEdit);
      return this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
    };

    RedesignUserPermissionsController.prototype.confirmUserEdit = function() {
      var ref, ref1, updateParams, user;
      user = this.editingUser;
      updateParams = {
        user_id: user.id,
        client_site_id: App.Site.first().id
      };
      if (((ref = this.editRow.find(".edit-first-name-column input").val()) != null ? ref.length : void 0) > 0) {
        updateParams['first_name'] = this.editRow.find(".edit-first-name-column input").val();
        user.first_name = updateParams['first_name'];
      }
      if (((ref1 = this.editRow.find(".edit-last-name-column input").val()) != null ? ref1.length : void 0) > 0) {
        updateParams['last_name'] = this.editRow.find(".edit-last-name-column input").val();
        user.last_name = updateParams['last_name'];
      }
      user.save({
        ajax: false
      });
      return $.post("/users/admin_update_profile", updateParams).fail(this.handleEditError).done(this.panelCtrl.closeEdit);
    };

    RedesignUserPermissionsController.prototype.clickedAccessRights = function(user, rowEl) {
      var selfServiceCheckbox, workbooksCheckbox;
      this.accessRightsUser = user;
      this.editRow = $(this.view("redesign/permissions/user_access_rights_row_edit")({
        row: user
      }));
      rowEl.before(this.editRow);
      selfServiceCheckbox = this.editRow.find(".self-service-checkbox");
      if (user.self_service_dashboards_access) {
        selfServiceCheckbox.addClass('selected');
      }
      selfServiceCheckbox.on("click", this.changeSelfServiceRights);
      workbooksCheckbox = this.editRow.find(".workbooks-checkbox");
      if (user.workbooks_access) {
        workbooksCheckbox.addClass('selected');
      }
      workbooksCheckbox.on("click", this.changeWorkbooksRights);
      this.editRow.find(".button.confirm").on("click", this.confirmUserAccessRights);
      return this.editRow.find(".button.cancel").on("click", this.panelCtrl.closeEdit);
    };

    RedesignUserPermissionsController.prototype.changeSelfServiceRights = function() {
      var selfServiceCheckbox;
      selfServiceCheckbox = this.editRow.find(".self-service-checkbox");
      if (selfServiceCheckbox.hasClass('selected')) {
        return selfServiceCheckbox.removeClass('selected');
      } else {
        return selfServiceCheckbox.addClass('selected');
      }
    };

    RedesignUserPermissionsController.prototype.changeWorkbooksRights = function() {
      var workbooksCheckbox;
      workbooksCheckbox = this.editRow.find(".workbooks-checkbox");
      if (workbooksCheckbox.hasClass('selected')) {
        return workbooksCheckbox.removeClass('selected');
      } else {
        return workbooksCheckbox.addClass('selected');
      }
    };

    RedesignUserPermissionsController.prototype.confirmUserAccessRights = function() {
      var self_service_checkbox, updateParams, workbooks_checkbox;
      self_service_checkbox = this.editRow.find(".self-service-checkbox").hasClass('selected');
      workbooks_checkbox = this.editRow.find(".workbooks-checkbox").hasClass('selected');
      if (!self_service_checkbox && !workbooks_checkbox) {
        this.editRow.find(".sg-overlay-row").prevObject[0].style.display = "none";
        return this.panelCtrl.askForConfirmation(this.accessRightsUser, this.editRow, "remove-user-no-access", "DELETE", this.removeItem);
      } else {
        if (!workbooks_checkbox) {
          return new App.RedesignAllSpacesWarningController({
            user: this.accessRightsUser,
            panel: this.panelCtrl
          });
        } else {
          updateParams = {
            user_id: this.accessRightsUser.id,
            client_site_id: App.Site.first().id
          };
          updateParams['self_service_dashboards_access'] = self_service_checkbox;
          this.accessRightsUser.self_service_dashboards_access = self_service_checkbox;
          updateParams['workbooks_access'] = workbooks_checkbox;
          this.accessRightsUser.workbooks_access = workbooks_checkbox;
          return $.post("/users/update_user_platform_access", updateParams).done(this.confirmedUserAccessRights);
        }
      }
    };

    RedesignUserPermissionsController.prototype.confirmedUserAccessRights = function() {
      this.panelCtrl.closeEdit();
      return this.accessRightsUser.save({
        ajax: false
      });
    };

    RedesignUserPermissionsController.prototype.resetPassword = function(user, rowEl) {
      user.sendForgotPasswordMail();
      return this.panelCtrl.showMessage(rowEl, "Password for " + (user.fullName()) + " has been reset.");
    };

    RedesignUserPermissionsController.prototype.reset2fa = function(user, rowEl) {
      $.post("/users/reset_user_two_factor", {
        user_id: user.id,
        client_site_id: App.Site.first().id
      }).fail(((function(_this) {
        return function(r) {
          return _this.panelCtrl.showMessage(rowEl, r.responseJSON.error_message, true, function() {});
        };
      })(this))).done(((function(_this) {
        return function() {
          return _this.panelCtrl.showMessage(rowEl, "Two-Factor Authentication for " + (user.fullName()) + " has been reset.");
        };
      })(this)));
      return this.panelCtrl.showMessage(rowEl, "Resetting Two-Factor Authentication for " + (user.fullName()) + "...");
    };

    RedesignUserPermissionsController.prototype.removeItem = function(user, rowEl) {
      user.revokeAccess();
      return this.trigger('deletedRow');
    };

    RedesignUserPermissionsController.prototype.handleEditError = function(r) {
      if (r.responseText.error != null) {
        return this.panelCtrl.showMessage(this.panelCtrl.activeRowEl, r.responseText.error, true, function() {});
      } else {
        return this.panelCtrl.showMessage(this.panelCtrl.activeRowEl, "User profile could not be updated", true, function() {});
      }
    };

    RedesignUserPermissionsController.prototype.initRows = function(rows) {
      this.setRows(rows);
      return this.prmCtrl.removeSpinnerAndRenderAsync();
    };

    RedesignUserPermissionsController.prototype.setRows = function(rows) {
      this.currentRows = rows;
      return this.grid.rerenderRows(rows);
    };

    RedesignUserPermissionsController.prototype.clearHighlightedRow = function() {
      return this.panelCtrl.clearHighlightedRow();
    };

    RedesignUserPermissionsController.prototype.search = function(searchTerm) {
      if (App.Site.first().isAccountFeatureSettingEnabled(App.User.USERS_SEARCH_API_ENABLED)) {
        return App.User.searchUserInfos(searchTerm, this.prmCtrl.groupToDashboardsMap, this.prmCtrl.userToGroupsMap, this.prmCtrl.ownerDashboardMap, this.setRows);
      } else {
        return this.panelCtrl.search(searchTerm);
      }
    };

    return RedesignUserPermissionsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SearchFocusHelper = (function(superClass) {
    extend(SearchFocusHelper, superClass);

    SearchFocusHelper.prototype.elements = {
      '.search-div': 'searchBox',
      'input.search': 'searchInput'
    };

    SearchFocusHelper.prototype.events = {
      'mouseover input.search': 'setFocused',
      'mouseout input.search': 'setBlurred',
      'keyup input.search': 'handleSearch'
    };

    function SearchFocusHelper() {
      SearchFocusHelper.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'grid');
    }

    SearchFocusHelper.prototype.setFocused = function() {
      return this.searchBox.addClass('focused');
    };

    SearchFocusHelper.prototype.setBlurred = function() {
      return this.searchBox.removeClass('focused');
    };

    SearchFocusHelper.prototype.handleSearch = function() {
      return this.grid.search(this.searchInput.val());
    };

    return SearchFocusHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignBillingSecurityController = (function(superClass) {
    extend(RedesignBillingSecurityController, superClass);

    RedesignBillingSecurityController.APPLIES_TO_ALL_SPACES = true;

    RedesignBillingSecurityController.TITLE = 'Billing & Authentication';

    RedesignBillingSecurityController.prototype.className = 'site-settings settings-area';

    RedesignBillingSecurityController.prototype.elements = {
      '.authentication-area .area-body': 'authenticationArea',
      '.billing-area .area-body': 'billingArea',
      '.upgrade-area .area-body': 'upgradeArea',
      '.panel.upgrade': 'upgradePanel',
      '.upgrade-confirmation': 'upgradeConfirmation'
    };

    function RedesignBillingSecurityController() {
      this.closeUpgradePanel = bind(this.closeUpgradePanel, this);
      RedesignBillingSecurityController.__super__.constructor.apply(this, arguments);
      this.render();
    }

    RedesignBillingSecurityController.prototype.billingEnabled = function() {
      return Features.enabled('billing');
    };

    RedesignBillingSecurityController.prototype.render = function() {
      this.html(this.view('redesign/settings/billing_security_panel')({
        billingEnabled: this.billingEnabled()
      }));
      this.authenticationController = new App.RedesignSettingsAuthentication({
        el: this.authenticationArea
      });
      if (this.billingEnabled()) {
        this.billingController = new App.ZuoraSettingsBillingFormController({
          el: this.billingArea
        });
      }
      if (AppRedesign.current().overageData != null) {
        this.upgradeController = new App.RowOverageUpgradeController({
          el: this.upgradeArea
        });
        return this.upgradeController.bind('close', this.closeUpgradePanel);
      }
    };

    RedesignBillingSecurityController.prototype.release = function() {
      var ref, ref1, ref2, ref3;
      if ((ref = this.authenticationController) != null) {
        ref.release();
      }
      if ((ref1 = this.billingController) != null) {
        ref1.release();
      }
      if ((ref2 = this.upgradeController) != null) {
        ref2.unbind('close', this.closeUpgradePanel);
      }
      if ((ref3 = this.upgradeController) != null) {
        ref3.release();
      }
      return RedesignBillingSecurityController.__super__.release.apply(this, arguments);
    };

    RedesignBillingSecurityController.prototype.closeUpgradePanel = function() {
      this.upgradeConfirmation.removeClass('hidden');
      return setTimeout(((function(_this) {
        return function() {
          return _this.upgradePanel.slideUp(1000);
        };
      })(this)), 1500);
    };

    return RedesignBillingSecurityController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignConfigitronController = (function(superClass) {
    extend(RedesignConfigitronController, superClass);

    RedesignConfigitronController.APPLIES_TO_ALL_SPACES = false;

    RedesignConfigitronController.TITLE = 'Database Connections';

    RedesignConfigitronController.URL_SLUG = 'database';

    RedesignConfigitronController.prototype.className = 'connection settings-area';

    RedesignConfigitronController.prototype.elements = {
      '.configitron-wrapper': 'configitronWapper',
      '.configitron': 'configitronBody',
      '.editor-header': 'headerEl',
      '.queries.settings-area': 'queriesSettingsArea',
      '.permissions .area-body': 'permissionsBody',
      '.status .area-body': 'statusBody',
      '.row-counts .area-body': 'rowCountsBody',
      '.disconnect .area-body': 'disconnectBody',
      '.credentials .area-body': 'credentialsBody',
      '.picker-panel': 'pickerPanel',
      '.info-icon': 'restrictionTooltipTrigger'
    };

    function RedesignConfigitronController() {
      this.databaseDestroyed = bind(this.databaseDestroyed, this);
      this.showDeleteDbForm = bind(this.showDeleteDbForm, this);
      this.dbAdded = bind(this.dbAdded, this);
      this.showAddDbForm = bind(this.showAddDbForm, this);
      this.initialFetchSuccess = bind(this.initialFetchSuccess, this);
      this.fetchFail = bind(this.fetchFail, this);
      this.reqFactory = bind(this.reqFactory, this);
      this.getConfigitronState = bind(this.getConfigitronState, this);
      this.shouldShowDBPermissionsPanel = bind(this.shouldShowDBPermissionsPanel, this);
      this.dbPicked = bind(this.dbPicked, this);
      this.escapePressed = bind(this.escapePressed, this);
      this.reallyRelease = bind(this.reallyRelease, this);
      RedesignConfigitronController.__super__.constructor.apply(this, arguments);
      if (App.Database.hasWarehouseWithNoConfigurableDatabases()) {
        this.html(this.view('redesign/settings/no_db_message')({
          message: 'Click Add Database to connect a new data source'
        }));
        return;
      }
      if (App.Site.first().dataEngineCloudAdminSite() === true) {
        return;
      }
      if (App.Database.configurableDatabases().length === 0) {
        this.showAddDbForm(true);
        return;
      }
      this.render();
      App.hotkeys.bind(App.HotkeyManager.ESC, this.escapePressed);
      App.Database.bind('destroy', this.databaseDestroyed);
      App.Database.bind('create', this.getConfigitronState);
      App.Utils.logFeature("configitron-opened");
    }

    RedesignConfigitronController.prototype.render = function() {
      this.html(this.view('redesign/settings/configitron')({
        display_db_permissions_panel: this.shouldShowDBPermissionsPanel(),
        row_count_disabled: this.currentlySelectedDb().row_count_disabled
      }));
      this.restrictionTooltipHelper = new App.IconTooltipHelper({
        icon: this.restrictionTooltipTrigger,
        infoCallback: this.restrictionTooltip,
        direction: App.RedesignTooltipPanel.BOTTOM,
        tooltipClass: 'help-tooltip'
      });
      this.createChildControllers();
      return this.getConfigitronState();
    };

    RedesignConfigitronController.prototype.restrictionTooltip = function() {
      return 'Restricted databases can only be queried by selected roles in charts. Charts running against a restricted database will not be able to use filters, views or snippets.';
    };

    RedesignConfigitronController.prototype.release = function() {
      var ref;
      if ((ref = this.restrictionTooltipHelper) != null) {
        ref.release();
      }
      App.Database.unbind('create', this.getConfigitronState);
      App.Database.unbind('destroy', this.databaseDestroyed);
      App.hotkeys.unbind(App.HotkeyManager.ESC, this.escapePressed);
      this.trigger('closing');
      return RedesignConfigitronController.__super__.release.apply(this, arguments);
    };

    RedesignConfigitronController.prototype.reallyRelease = function() {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6;
      RedesignConfigitronController.unsetConfigitronOpen();
      if ((ref = this.headerController) != null) {
        ref.release();
      }
      if ((ref1 = this.permissionsController) != null) {
        ref1.release();
      }
      if ((ref2 = this.statusController) != null) {
        ref2.release();
      }
      if ((ref3 = this.rowCountsController) != null) {
        ref3.release();
      }
      if ((ref4 = this.credentialsController) != null) {
        ref4.release();
      }
      if ((ref5 = this.addDbDialog) != null) {
        ref5.release();
      }
      if ((ref6 = this.deleteDbDialog) != null) {
        ref6.release();
      }
      return RedesignConfigitronController.__super__.reallyRelease.apply(this, arguments);
    };

    RedesignConfigitronController.prototype.editorBody = function() {
      return this.configitronBody;
    };

    RedesignConfigitronController.prototype.editorWrapper = function() {
      return this.configitronWapper;
    };

    RedesignConfigitronController.prototype.escapePressed = function() {
      if (this.addDbDialog != null) {
        this.addDbDialog.close();
        return delete this.addDbDialog;
      } else if (this.deleteDbDialog != null) {
        this.deleteDbDialog.close();
        return delete this.deleteDbDialog;
      }
    };

    RedesignConfigitronController.prototype.getCategories = function() {
      var d, i, len, ref;
      this.databases = [];
      ref = App.Database.configurableDatabases();
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        this.databases.push({
          type: d.cid,
          label: d.database_name,
          cid: d.cid
        });
      }
      return this.databases;
    };

    RedesignConfigitronController.prototype.dbPicked = function(db) {
      var ref, ref1, ref2, ref3, ref4;
      db = App.Database.exists(db.cid);
      if (db) {
        this.currentDb = db;
        if ((ref = this.permissionsController) != null) {
          ref.dbSelected(this.currentDb);
        }
        if ((ref1 = this.statusController) != null) {
          ref1.dbSelected(this.currentDb);
        }
        if ((ref2 = this.rowCountsController) != null) {
          ref2.dbSelected(this.currentDb);
        }
        if ((ref3 = this.disconnectController) != null) {
          ref3.dbSelected(this.currentDb);
        }
        if ((ref4 = this.credentialsController) != null) {
          ref4.dbSelected(this.currentDb);
        }
        return this.render();
      }
    };

    RedesignConfigitronController.prototype.currentlySelectedDb = function() {
      if (this.currentDb != null) {
        return this.currentDb;
      }
      return App.Database.configurableDatabases().first();
    };

    RedesignConfigitronController.prototype.recreateHeaderController = function() {
      var ref, ref1;
      if ((ref = this.headerController) != null) {
        ref.unbind('category-change');
      }
      if ((ref1 = this.headerController) != null) {
        ref1.release();
      }
      this.headerController = new App.RedesignGridSearchController({
        el: App.Utils.appendFrame(this.pickerPanel, ''),
        categories: this.getCategories(),
        disableSearch: false,
        hideSearchBar: true,
        initValue: {
          type: this.currentlySelectedDb().cid
        },
        dropdownWidth: '220px'
      });
      return this.headerController.bind('category-change', this.dbPicked);
    };

    RedesignConfigitronController.prototype.createChildControllers = function() {
      this.recreateHeaderController();
      this.currentDb = this.currentlySelectedDb();
      if (this.shouldShowDBPermissionsPanel()) {
        this.permissionsController = new App.DatabasePermissionsController({
          el: this.permissionsBody,
          currentDb: this.currentDb
        });
      }
      this.statusController = new App.DatabaseStatusController({
        el: this.statusBody,
        currentDb: this.currentDb
      });
      if (!this.currentlySelectedDb().row_count_disabled) {
        this.rowCountsController = new App.RedesignDatabaseRowCountsController({
          el: this.rowCountsBody,
          currentDb: this.currentDb
        });
      }
      this.disconnectController = new App.RedesignDatabaseDisconnectController({
        el: this.disconnectBody,
        currentDb: this.currentDb
      });
      this.disconnectController.bind('delete-database', this.showDeleteDbForm);
      return this.credentialsController = new App.RedesignDatabaseCredentialsController({
        el: this.credentialsBody,
        currentDb: this.currentDb
      });
    };

    RedesignConfigitronController.prototype.shouldShowDBPermissionsPanel = function() {
      var ref, ref1;
      return ((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0) && ((ref1 = App.User.currentUser()) != null ? ref1.isAdmin() : void 0) && this.currentlySelectedDb().is_restricted;
    };

    RedesignConfigitronController.prototype.getConfigitronState = function() {
      var smartFetcher;
      smartFetcher = new App.SmartFetcher(this.reqFactory, true);
      smartFetcher.startNow();
      return smartFetcher.shutdown();
    };

    RedesignConfigitronController.prototype.reqFactory = function() {
      return (function(_this) {
        return function() {
          return jQuery.ajax({
            url: "/sites/" + (App.Site.first().id) + "/configitron_state"
          }).done(_this.initialFetchSuccess).fail(_this.fetchFail);
        };
      })(this);
    };

    RedesignConfigitronController.prototype.fetchFail = function() {};

    RedesignConfigitronController.prototype.initialFetchSuccess = function(response) {
      var ref, ref1, ref2;
      App.TableHarvest.refresh(response.table_harvests);
      App.SalesforceObjectHarvest.refresh(response.salesforce_object_harvests);
      App.Database.applyUpdates(response.database_dependents);
      if ((response.redshifts != null) && App.User.currentUserIsPeriscopeAdmin()) {
        App.Redshift.applyUpdates(response.redshifts);
      }
      if ((ref = App.Site.first()) != null) {
        ref.applyAppConnectorsUsername(response.app_connectors_username);
      }
      if ((ref1 = this.disconnectController) != null) {
        ref1.recheckDeleteOk();
      }
      return (ref2 = this.rowCountsController) != null ? ref2.countsAreLoaded() : void 0;
    };

    RedesignConfigitronController.configitronIsOpen = function() {
      return $('#body').hasClass('configitron-open');
    };

    RedesignConfigitronController.setConfigitronOpen = function() {
      return $('#body').addClass('configitron-open');
    };

    RedesignConfigitronController.unsetConfigitronOpen = function() {
      return $('#body').removeClass('configitron-open');
    };

    RedesignConfigitronController.prototype.showAddDbForm = function(reloadOnSuccess) {
      var dbAddForm, ref;
      if (reloadOnSuccess == null) {
        reloadOnSuccess = false;
      }
      dbAddForm = new App.RedesignDatabaseConnectForm({
        el: $('<div class="creds-form"></div>'),
        submitRoute: "/databases/update_settings",
        pollRoute: "/databases/poll_doctor",
        uploadKeyRoute: "/databases/upload_bigquery_key",
        uploadSnowflakePk8KeyRoute: "/databases/upload_snowflake_key",
        uploadSnowflakeCacheablePk8KeyRoute: "/databases/upload_snowflake_cacheable_key",
        newCustomer: false,
        extraParams: {
          create_token: App.Utils.makeGuid(),
          client_site_id: App.Site.first().id
        },
        successMessage: "The database connection was successful!",
        infoGrid: true,
        addDb: true
      });
      this.addDbDialog = App.RedesignDialog.createDialog({
        title: 'Add Database',
        viewController: dbAddForm,
        customDialogClass: 'add-database'
      });
      if (reloadOnSuccess) {
        dbAddForm.bind('database-connection-success', ((function(_this) {
          return function() {
            return window.location.reload(true);
          };
        })(this)));
      }
      dbAddForm.bind('close-dialog', (ref = this.addDbDialog) != null ? ref.close : void 0);
      return dbAddForm.bind('database-connection-success', this.dbAdded);
    };

    RedesignConfigitronController.prototype.dbAdded = function(dbId) {
      var db, ref;
      db = App.Database.find(dbId);
      if ((ref = this.addDbDialog) != null) {
        ref.close;
      }
      return this.switchSelectedDb(db);
    };

    RedesignConfigitronController.prototype.showDeleteDbForm = function() {
      var dbDeleteForm;
      dbDeleteForm = new App.RedesignDatabaseDeleteForm({
        el: $('<div class="delete-form"></div>'),
        database: this.currentDb
      });
      this.addDbDialog = App.RedesignDialog.createDialog({
        title: 'Disconnect Database',
        viewController: dbDeleteForm
      });
      return dbDeleteForm.bind('close-dialog', this.addDbDialog.close);
    };

    RedesignConfigitronController.prototype.switchSelectedDb = function(database) {
      var ref;
      if ((ref = this.addDbDialog) != null) {
        ref.close();
      }
      delete this.addDbDialog;
      if (App.Database.hasWarehouseWithNoConfigurableDatabases()) {
        this.html(this.view('redesign/settings/no_db_message')({
          message: 'Click Add Database to connect a new data source'
        }));
        return;
      }
      this.dbPicked(database);
      return this.recreateHeaderController();
    };

    RedesignConfigitronController.prototype.databaseDestroyed = function() {
      return this.switchSelectedDb(App.Database.configurableDatabases().first());
    };

    return RedesignConfigitronController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDashboardRefreshController = (function(superClass) {
    extend(RedesignDashboardRefreshController, superClass);

    RedesignDashboardRefreshController.APPLIES_TO_ALL_SPACES = false;

    RedesignDashboardRefreshController.TITLE = 'Dashboard Refresh Management';

    RedesignDashboardRefreshController.EXTEND_HEADER = true;

    RedesignDashboardRefreshController.MIN_PANEL_HEIGHT = 400;

    RedesignDashboardRefreshController.VERT_PIXELS_USED_BY_OTHERS = 144;

    RedesignDashboardRefreshController.prototype.className = 'site-settings settings-area';

    RedesignDashboardRefreshController.prototype.elements = {
      '.dashboard-refresh': 'dashboardRefreshContainer'
    };

    function RedesignDashboardRefreshController() {
      this.setElHeight = bind(this.setElHeight, this);
      this.calculateMaximizedElHeight = bind(this.calculateMaximizedElHeight, this);
      this.maximizeElHeight = bind(this.maximizeElHeight, this);
      RedesignDashboardRefreshController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.initialize();
    }

    RedesignDashboardRefreshController.prototype.initialize = function() {
      this.html(this.view('redesign/settings/dashboard_refresh')());
      this.window().on('resize', this.maximizeElHeight);
      this.maximizeElHeight();
      return this.showDashboardRefresh();
    };

    RedesignDashboardRefreshController.prototype.showDashboardRefresh = function() {
      var site;
      App.Utils.logFeature("drm-open");
      site = App.Site.first();
      if (!window.reactApp) {
        return;
      }
      window.reactApp.updateAppState({
        dashboardRefreshV1Enabled: site.isDashboardRefreshV1Enabled(),
        dashboardRefreshV2Enabled: site.isDashboardRefreshV2Enabled(),
        skipForUnusedEnabled: site.isSkipForUnusedEnabled()
      });
      return this.reactRoot = window.reactApp.dashboardRefreshRoot(this.dashboardRefreshContainer[0]);
    };

    RedesignDashboardRefreshController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      this.window().off('resize', this.maximizeElHeight);
      return RedesignDashboardRefreshController.__super__.release.apply(this, arguments);
    };

    RedesignDashboardRefreshController.prototype.window = function() {
      return $(window);
    };

    RedesignDashboardRefreshController.prototype.bodyHeight = function() {
      return $('#body').height() || 0;
    };

    RedesignDashboardRefreshController.prototype.maximizeElHeight = function() {
      this.setElHeight(this.calculateMaximizedElHeight());
      return window.reactApp.updateAppState({
        settingsAreaHeight: this.settingsAreaHeight
      });
    };

    RedesignDashboardRefreshController.prototype.calculateMaximizedElHeight = function() {
      var calculatedHeight, height;
      calculatedHeight = this.bodyHeight() - this.constructor.VERT_PIXELS_USED_BY_OTHERS;
      height = Math.max(calculatedHeight, this.constructor.MIN_PANEL_HEIGHT);
      if (BrowserDetect.browser === "Firefox") {
        return height - 30;
      }
      return height;
    };

    RedesignDashboardRefreshController.prototype.setElHeight = function(height) {
      this.settingsAreaHeight = height;
      return this.el.css({
        height: height + "px"
      });
    };

    return RedesignDashboardRefreshController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDatabaseConnectForm = (function(superClass) {
    extend(RedesignDatabaseConnectForm, superClass);

    RedesignDatabaseConnectForm.prototype.elements = {
      '.db-loader': 'dbLoader',
      '[row="email_address"]': 'rowEmailAddress',
      '[row="display_name"]': 'rowDbDisplayName',
      '[row="database_name"]': 'rowDbName',
      '[row="host"]': 'rowDbHost',
      '[row="port"]': 'rowDbPort',
      '[row="username"]': 'rowDbUser',
      '[row="jdbc_command_type"]': 'rowJdbcCommandType',
      '[row="password"]': 'rowPassword',
      '[row="account_name"]': 'rowAccountName',
      '[row="warehouse_name"]': 'rowWarehouseName',
      '[row="httppath"]': 'rowHttppath',
      '[row="catalog"]': 'rowCatalog',
      '[row="snowflake_username"]': 'rowSnowflakeUsername',
      '[row="snowflake_password"]': 'rowSnowflakePassword',
      '[row="parent_database"]': 'parentDatabase',
      '[row="service_account"]': 'rowBigqueryServiceAccount',
      '[row="sql_dialect"]': 'rowBigquerySqlDialect',
      '[row="project_id"]': 'rowBigqueryProjectId',
      '[row="p12_key_file"]': 'rowBigqueryKeyFile',
      '[row="snowflake_pk8_key_file"]': 'rowSnowflakeKeyFile',
      '[row="snowflake_pk8_pwd"]': 'rowSnowflakePk8KeyFile',
      '[row="command_type"]': 'rowCommandType',
      '[row="cloud_provider"]': 'rowCloudProvider',
      '[row="s3_staging_dir"]': 'rowS3StagingDir',
      '[row="cluster_name"]': 'rowClusterName',
      '.form [row="email_address"] input': 'fieldEmailAddress',
      '.form [row="display_name"] input': 'fieldDisplayName',
      '.form [row="httppath"] input': 'fieldHttppath',
      '.form [row="catalog"] input': 'fieldCatalog',
      '.form [row="database_name"] input': 'fieldDatabaseName',
      '.form [row="jdbc_command_type"] input': 'fieldOracleDatabaseName',
      '.form [row="host"] input': 'fieldHost',
      '.form [row="port"] input': 'fieldPort',
      '.form [row="username"] input': 'fieldUsername',
      '.form [row="password"] input': 'fieldPassword',
      '.form [row="account_name"] input': 'fieldAccountName',
      '.form [row="warehouse_name"] input': 'fieldWarehouseName',
      '.form [row="snowflake_username"] input': 'fieldSnowflakeUsername',
      '.form [row="snowflake_password"] input': 'fieldSnowflakePassword',
      '.form [row="snowflake_pk8_key_file"] input': 'fieldSnowflakePk8KeyFile',
      '.form [row="snowflake_pk8_pwd"] input': 'fieldSnowflakePk8Pwd',
      '.form [row="cacheable-admin-pk8-file"] input': 'fieldSnowflakeCacheablePk8KeyFile',
      '.form [row="cacheable-admin-pk8-pwd"] input': 'fieldSnowflakeCacheablePk8Pwd',
      '.form [row="parent_database"] select': 'parentDatabaseInput',
      '.form [row="service_account"] input': 'fieldServiceAccount',
      '.form [row="project_id"] input': 'fieldProjectId',
      '.form [row="p12_key_file"] input': 'fieldBigqueryKeyFile',
      '.form [row="type"] select': 'databaseTypeInput',
      '.form [row="sql_dialect"] select': 'bigQuerySqlDialectInput',
      '.form [row="command_type"] select': 'commandTypeInput',
      '.form [row="cloud_provider"] select': 'cloudProviderInput',
      '.form [row="jdbc_command_type"] select': 'jdbcCommandTypeInput',
      '.form [row="roles"] select': 'rolesInput',
      '.form [row="cluster_name"] input': 'clusterNameInput',
      '.form [row="s3_staging_dir"] input': 's3StagingDirInput',
      '.key-file.p12 .file-name': 'divFileName',
      '.key-file.p12': 'divKeyFile',
      '.key-file.pk8 .file-name': 'divSnowflakePk8FileName',
      '.key-file.pk8': 'divSnowflakePk8KeyFile',
      '.key-file.cacheable-pk8 .file-name': 'divSnowflakeCacheablePk8FileName',
      '.key-file.cacheable-pk8': 'divSnowflakeCacheablePk8KeyFile',
      '.restriction-toggle': 'restrictionField',
      '.form [row="ssh-host"] input': 'fieldSshHost',
      '.form [row="ssh-port"] input': 'fieldSshPort',
      '.form [row="ssh-username"] input': 'fieldSshUsername',
      '.form [row="cacheable-admin-username"] input': 'fieldCacheableAdminUsername',
      '.form [row="cacheable-admin-password"] input': 'fieldCacheableAdminPassword',
      '.form [row="app-connectors-username"] input': 'fieldAppConnectorsUsername',
      '.form [row="app-connectors-password"] input': 'fieldAppConnectorsPassword',
      '.errors': 'errorsBlock',
      '.errors .error.validation': 'errorValidation',
      '.errors .error': 'errorMessages',
      '.errors .error .database_name': 'databaseNameInErrors',
      '.errors .error .username': 'usernameInErrors',
      '.errors .error .account_name': 'accountNameInErrors',
      '.errors .error.status-ok': 'successMessageEl',
      '.errors .error-unexpected .full-msg': 'unexpectedErrorFullMessageEl',
      '.errors .error-link': 'errorLinks',
      '.signup-form': 'signupForm',
      '.ssh-tunnel': 'sshTunnel',
      '.ssh-tunnel-form': 'sshTunnelForm',
      '.ssh-tunnel.help': 'sshTunnelHelp',
      '.teradata-private-network': 'teradataPrivateNetworkLink',
      '.private-network': 'privateNetwork',
      '.more-info': 'moreInfo',
      '.ssh-tunnel-doc': 'sshTunnelDoc',
      '.key-file.p12 .default-text': 'defaultBigqueryKeyFileText',
      '.key-file.pk8 .default-text': 'defaultSnowflakeKeyFileText',
      '.key-file.cacheable-pk8 .default-text': 'defaultSnowflakeCacheableKeyFileText',
      '.salesforce [row="client_id"] input': 'salesforceClientId',
      '.salesforce [row="client_secret"] input': 'salesforceClientSecret',
      '.salesforce [row="login_name"] input': 'salesforceLoginName',
      '.salesforce [row="login_password"] input': 'salesforceLoginPassword',
      '.salesforce [row="security_token"] input': 'salesforceSecurityToken',
      '#specific-database-fields': 'specificDatabaseFields',
      '.info-icon': 'restrictionTooltipTrigger',
      '.button-row': 'buttonRow'
    };

    RedesignDatabaseConnectForm.prototype.events = {
      'click .button.submit': 'submit',
      'change [row="type"] select': 'databaseTypeChanged',
      'change .form [row="p12_key_file"] input': 'handleKeyFileSet',
      'change .form [row="snowflake_pk8_key_file"] input': 'handleSnowflakePk8KeyFileSet',
      'change .form [row="cacheable-admin-pk8-file"] input': 'handleSnowflakeCacheablePk8KeyFileSet',
      'keyup .form input': 'formInputKeyup',
      'click .private-network': 'privateNetworkClicked',
      'click .info-icon': 'helpIconClicked',
      'click .restriction-toggle': 'toggleRestricted',
      'change .form [row="roles"] select': 'formInputKeyup'
    };

    RedesignDatabaseConnectForm.STATUS_ERROR_UNEXPECTED = 'error-unexpected';

    RedesignDatabaseConnectForm.STATUS_OK = 'status-ok';

    RedesignDatabaseConnectForm.STATUS_PENDING = 'pending';

    RedesignDatabaseConnectForm.STATUS_VALIDATION = 'validation';

    RedesignDatabaseConnectForm.POLL_INTERVAL = 2000;

    RedesignDatabaseConnectForm.FORM_FIELDS = ['email_address', 'database_name', 'host', 'port', 'username', 'password'];

    RedesignDatabaseConnectForm.SYBASE = 'sybase';

    RedesignDatabaseConnectForm.BIGQUERY = 'bigquery';

    RedesignDatabaseConnectForm.BIGQUERY_STANDARD = 'bigquery_standard';

    RedesignDatabaseConnectForm.SNOWFLAKE = 'snowflake';

    RedesignDatabaseConnectForm.PRESTO = 'presto';

    RedesignDatabaseConnectForm.QUBOLE = 'QuboleDatabase';

    RedesignDatabaseConnectForm.ORACLE = 'oracle';

    RedesignDatabaseConnectForm.ATHENA = 'AthenaDatabase';

    RedesignDatabaseConnectForm.TERADATA = 'teradata';

    RedesignDatabaseConnectForm.DATABRICKS = 'databricks';

    RedesignDatabaseConnectForm.P12FILE_SIZE_LIMIT = 5000;

    RedesignDatabaseConnectForm.NONE_PARENT_ID = "-1";

    function RedesignDatabaseConnectForm() {
      this.setSnowflakeCacheablePk8KeyFileHandle = bind(this.setSnowflakeCacheablePk8KeyFileHandle, this);
      this.handleSnowflakeCacheablePk8KeyFileSet = bind(this.handleSnowflakeCacheablePk8KeyFileSet, this);
      this.uploadSnowflakeCacheablePk8Start = bind(this.uploadSnowflakeCacheablePk8Start, this);
      this.setSnowflakePk8KeyFileHandle = bind(this.setSnowflakePk8KeyFileHandle, this);
      this.handleSnowflakePk8KeyFileSet = bind(this.handleSnowflakePk8KeyFileSet, this);
      this.uploadSnowflakePk8Start = bind(this.uploadSnowflakePk8Start, this);
      this.setKeyFileHandle = bind(this.setKeyFileHandle, this);
      this.handleKeyFileSet = bind(this.handleKeyFileSet, this);
      this.uploadComplete = bind(this.uploadComplete, this);
      this.uploadFailed = bind(this.uploadFailed, this);
      this.uploadStart = bind(this.uploadStart, this);
      this.showConnectionLoader = bind(this.showConnectionLoader, this);
      this.updateParentChildRelationship = bind(this.updateParentChildRelationship, this);
      this.showConnectionResults = bind(this.showConnectionResults, this);
      this.stopDoctorPolling = bind(this.stopDoctorPolling, this);
      this.startDoctorPolling = bind(this.startDoctorPolling, this);
      this.doctorResponse = bind(this.doctorResponse, this);
      this.pollDoctor = bind(this.pollDoctor, this);
      this.validateForm = bind(this.validateForm, this);
      this.isPresentInput = bind(this.isPresentInput, this);
      this.formInputKeyup = bind(this.formInputKeyup, this);
      this.handleAjaxResponse = bind(this.handleAjaxResponse, this);
      this.handleAjaxError = bind(this.handleAjaxError, this);
      this.validateAndSubmit = bind(this.validateAndSubmit, this);
      this.submit = bind(this.submit, this);
      this.cancelFunc = bind(this.cancelFunc, this);
      this.handleRolesResponse = bind(this.handleRolesResponse, this);
      var database_type, ref, ref1, ref2, ref3;
      RedesignDatabaseConnectForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'extraParams', 'uploadKeyRoute', 'uploadSnowflakePk8KeyRoute', 'uploadSnowflakeCacheablePk8KeyRoute', 'submitRoute', 'pollRoute', 'newCustomer', 'successMessage');
      this.polling = false;
      this.html(this.view('redesign/settings/database_form')({
        newCustomer: this.newCustomer,
        salesforceEnabled: (ref = App.Site.first()) != null ? ref.isSalesforceEnabled() : void 0,
        cacheEnabled: (ref1 = App.Site.first()) != null ? ref1.cache_enabled : void 0,
        showDbRestriction: this.showDbRestriction(),
        byowEnabled: (this.initialValues != null) && this.initialValues.byow_enabled_db,
        firstBYOW: !App.Site.first().hasCacheDatabase() || (((ref2 = this.initialValues) != null ? ref2.cacheable_admin_username : void 0) != null),
        teradataEnabled: AppRedesign.teradataEnabled(),
        databricksEnabled: AppRedesign.databricksEnabled(),
        connectorIngestionEnabled: AppRedesign.connectorIngestionEnabled(),
        connectorIngestionSpecificDbUserEnabled: AppRedesign.connectorIngestionSpecificDbUserEnabled()
      }));
      this.cancelSaveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancelFunc,
        saveFunc: this.submit,
        saveText: this.actionText(),
        hideCancel: this.addDb == null
      });
      this.buttonRow.append(this.cancelSaveBlock.el);
      if (!this.addDb) {
        this.cancelSaveBlock.setSaveDisabled(true);
      }
      if (this.initialValues != null) {
        database_type = this.initialValues.database_type === this.constructor.BIGQUERY_STANDARD ? this.constructor.BIGQUERY : this.initialValues.database_type;
        this.databaseTypeInput.val(database_type);
        if (this.initialValues.database_type === 'SalesforceDatabase') {
          this.databaseTypeInput.prop('disabled', true);
        }
      } else {
        this.initialValues = {};
      }
      if (this.newCustomer) {
        this.moreInfo.hide();
      } else {
        this.sshTunnelDoc.hide();
      }
      this.databaseTypeInput.chosen({
        disable_search: true,
        width: '100%'
      });
      this.roleNames = {};
      if ((ref3 = App.Site.first()) != null ? ref3.database_roles_mapping_enabled : void 0) {
        $.get('/roles', {
          client_site_id: App.Site.first().id
        }).fail(this.handleAjaxError).done(this.handleRolesResponse);
      }
      this.render();
    }

    RedesignDatabaseConnectForm.prototype.handleRolesResponse = function(response) {
      var i, len, ref, role;
      this.roleNames = {};
      ref = response.roles;
      for (i = 0, len = ref.length; i < len; i++) {
        role = ref[i];
        this.roleNames[role.id] = role.name;
      }
      return this.render();
    };

    RedesignDatabaseConnectForm.prototype.cancelFunc = function() {
      return this.trigger('close-dialog');
    };

    RedesignDatabaseConnectForm.prototype.actionText = function() {
      if (this.addDb != null) {
        return 'add';
      } else {
        return 'submit';
      }
    };

    RedesignDatabaseConnectForm.prototype.initialValuesSnowflake = function() {
      return (this.initialValues != null) && this.initialValues.database_type === this.constructor.SNOWFLAKE;
    };

    RedesignDatabaseConnectForm.prototype.render = function() {
      var ref;
      this.specificDatabaseFields.html(this.specificDatabase().renderSpecificDatabaseFields());
      this.fieldDisplayName.val(this.initialValues.display_name);
      this.fieldCacheableAdminUsername.val(this.initialValues.cacheable_admin_username);
      this.fieldAppConnectorsUsername.val((ref = App.Site.first()) != null ? ref.app_connectors_username : void 0);
      this.el.find('.for-snowflake-warehouse-only').toggle(this.initialValues.database_type === this.constructor.SNOWFLAKE);
      if (this.infoGrid != null) {
        this.$('.form').addClass('info-grid');
      }
      this.refreshElements();
      if (this.showDbRestriction()) {
        this.restrictionTooltip = new App.IconTooltipHelper({
          icon: this.restrictionTooltipTrigger,
          infoCallback: this.restrictionTooltipContent,
          direction: App.RedesignTooltipPanel.BOTTOM,
          tooltipClass: 'help-tooltip'
        });
      }
      return this.specificDatabase().render();
    };

    RedesignDatabaseConnectForm.prototype.replicaDatabaseNames = function(values) {
      var d, databaseNames, databases, i, len;
      databaseNames = {};
      databases = App.Database.allSortedByName();
      for (i = 0, len = databases.length; i < len; i++) {
        d = databases[i];
        if (!(!d.warehouse)) {
          continue;
        }
        if ((values != null ? values.display_name : void 0) === d.database_name) {
          continue;
        }
        databaseNames[d.database_name] = d.id;
      }
      return databaseNames;
    };

    RedesignDatabaseConnectForm.prototype.showDbRestriction = function() {
      var ref;
      return (this.addDb != null) && ((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0);
    };

    RedesignDatabaseConnectForm.prototype.restrictionTooltipContent = function() {
      return 'Restricted databases can only be queried by selected roles in charts. Charts running against a restricted database will not be able to use filters, views or snippets.';
    };

    RedesignDatabaseConnectForm.prototype.helpIconClicked = function() {
      return this.restrictionTooltip.iconMouseLeave();
    };

    RedesignDatabaseConnectForm.prototype.toggleRestricted = function() {
      this.restrictionField.toggleClass('selected');
      return this.restrictionField.data('is-restricted', !this.restrictionField.data('is-restricted'));
    };

    RedesignDatabaseConnectForm.prototype.submit = function() {
      var dbId, parentId, ref;
      parentId = this.parentId();
      dbId = (ref = this.initialValues) != null ? ref.database_id : void 0;
      if ((dbId != null) && (parentId != null) && parentId !== App.RedesignDatabaseConnectForm.NONE_PARENT_ID && App.Database.find(dbId).tableHarvests().length > 0) {
        return this.addDbDialog = App.RedesignDialog.createDialog({
          warning: true,
          title: 'WARNING',
          mainText: "Are you sure you want to set this database as a replica? This will remove all cache settings for this database.",
          okCallback: ((function(_this) {
            return function() {
              return _this.validateAndSubmit();
            };
          })(this))
        });
      } else {
        return this.validateAndSubmit();
      }
    };

    RedesignDatabaseConnectForm.prototype.validateAndSubmit = function() {
      if (this.polling) {
        return;
      }
      if (!this.validateForm()) {
        return;
      }
      $.post(this.submitRoute, _.omit(this.formParams(), 'p12_key_file')).fail(this.handleAjaxError).done(this.handleAjaxResponse);
      return this.showConnectionLoader();
    };

    RedesignDatabaseConnectForm.prototype.handleAjaxError = function(response) {
      var error;
      error = (response != null ? response.error_message : void 0) || this.constructor.STATUS_ERROR_UNEXPECTED;
      this.stopDoctorPolling();
      this.showConnectionResults();
      return this.updateStatus(error);
    };

    RedesignDatabaseConnectForm.prototype.handleAjaxResponse = function(response) {
      var ref;
      if (response.error) {
        return this.handleAjaxError(response);
      }
      if (this.databaseType() === RedesignDatabaseConnectForm.SYBASE) {
        this.showError(RedesignDatabaseConnectForm.STATUS_OK);
        return this.showConnectionResults();
      } else if (this.databaseType() === this.constructor.BIGQUERY) {
        return this.readFile();
      } else if (this.databaseType() === this.constructor.SNOWFLAKE && ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0)) {
        this.readSnowflakePk8File();
        return this.readSnowflakeCacheablePk8File();
      } else {
        return this.startDoctorPolling();
      }
    };

    RedesignDatabaseConnectForm.prototype.formParams = function() {
      var base, cloud_provider, command_type, databaseName, databaseType, host, k, params, password, ref, username, v;
      databaseType = this.databaseType();
      if (databaseType === this.constructor.SNOWFLAKE) {
        host = this.fieldAccountName.val();
        username = this.fieldSnowflakeUsername.val();
        password = this.fieldSnowflakePassword.val();
      } else {
        host = this.fieldHost.val();
        username = this.specificDatabase().username();
        password = this.specificDatabase().password();
      }
      command_type = databaseType === this.constructor.QUBOLE ? this.commandTypeInput.val() : databaseType === this.constructor.ORACLE ? this.jdbcCommandTypeInput.val() : '';
      cloud_provider = databaseType === this.constructor.QUBOLE ? this.cloudProviderInput.val() : '';
      databaseName = databaseType === this.constructor.ORACLE ? this.fieldOracleDatabaseName.val() : this.fieldDatabaseName.val();
      params = $.extend({
        database_type: databaseType,
        email_address: this.fieldEmailAddress.val(),
        database_name: databaseName,
        project_id: this.fieldProjectId.val(),
        display_name: this.fieldDisplayName.val(),
        httppath: this.fieldHttppath.val(),
        catalog: this.fieldCatalog.val(),
        host: host,
        port: this.fieldPort.val(),
        username: username,
        service_account: this.fieldServiceAccount.val(),
        password: password,
        ssh_host: this.fieldSshHost.val(),
        ssh_port: this.fieldSshPort.val(),
        ssh_username: this.fieldSshUsername.val(),
        p12_key_file: this.validKeyFile,
        sql_dialect: this.bigQuerySqlDialectInput.val(),
        parent_database_id: this.parentId(),
        specific_database_attributes: typeof (base = this.specificDatabase()).attributes === "function" ? base.attributes() : void 0,
        warehouse_name: this.fieldWarehouseName.val(),
        command_type: command_type,
        cloud_provider: cloud_provider,
        cluster_name: this.clusterNameInput.val(),
        s3_staging_dir: this.s3StagingDirInput.val(),
        is_restricted: this.restrictionField.data('is-restricted'),
        cacheable_attributes: this.cacheableAttributes(),
        app_connectors_username: this.fieldAppConnectorsUsername.val(),
        app_connectors_password: this.fieldAppConnectorsPassword.val(),
        database_roles_attributes: this.rolesInput.val()
      }, this.extraParams);
      if (this.initialValuesSnowflake()) {
        if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          params = $.extend(params, {
            snowflake_pk8_key_file: this.validSnowflakePk8KeyFile,
            snowflake_pk8_pwd: this.fieldSnowflakePk8Pwd.val()
          });
        }
      }
      for (k in params) {
        v = params[k];
        if (typeof v === 'string') {
          params[k] = v.trim();
        }
      }
      return params;
    };

    RedesignDatabaseConnectForm.prototype.formInputKeyup = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        this.submit();
      }
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    RedesignDatabaseConnectForm.prototype.unfinishedForm = function() {
      var allSnowflakeEitherFieldsAreEmpty, allSnowflakeWarehouseEitherFieldsAreEmpty, ref, requiredInputsAreEmpty, snowflakeEitherFields, snowflakeWarehouseEitherFields;
      if (!this.isSshFormReadyForSubmission()) {
        return true;
      }
      requiredInputsAreEmpty = _.find(this.el.find('input:not(.snowflake-either-present):not(.snowflake-warehouse-either-present)'), this.isEmptyInput) != null;
      if (!this.initialValuesSnowflake()) {
        return requiredInputsAreEmpty;
      }
      if (!((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0)) {
        return requiredInputsAreEmpty;
      }
      snowflakeEitherFields = this.el.find('input.snowflake-either-present:visible');
      snowflakeWarehouseEitherFields = this.el.find('input.snowflake-warehouse-either-present:visible');
      allSnowflakeEitherFieldsAreEmpty = snowflakeEitherFields.length > 0 && (_.find(snowflakeEitherFields, this.isPresentInput) == null);
      allSnowflakeWarehouseEitherFieldsAreEmpty = snowflakeWarehouseEitherFields.length > 0 && (_.find(snowflakeWarehouseEitherFields, this.isPresentInput) == null);
      return requiredInputsAreEmpty || allSnowflakeEitherFieldsAreEmpty || allSnowflakeWarehouseEitherFieldsAreEmpty;
    };

    RedesignDatabaseConnectForm.prototype.isSshFormReadyForSubmission = function() {
      if (_.isEmpty(this.fieldSshHost.val())) {
        return true;
      } else {
        return !_.isEmpty(this.fieldSshPort.val()) && !_.isEmpty(this.fieldSshUsername.val());
      }
    };

    RedesignDatabaseConnectForm.prototype.isPresentInput = function(inputEl) {
      return !this.isEmptyInput(inputEl);
    };

    RedesignDatabaseConnectForm.prototype.isEmptyInput = function(inputEl) {
      var input;
      input = $(inputEl);
      if (input.hasClass("optional")) {
        return false;
      }
      if (input.attr('value') === 'Select Roles') {
        return false;
      }
      return input.closest('td').attr('row') !== 'display_name' && input.is(":visible") && input.val().length === 0;
    };

    RedesignDatabaseConnectForm.prototype.databaseType = function() {
      return this.databaseTypeInput.val();
    };

    RedesignDatabaseConnectForm.prototype.parentId = function() {
      return this.parentDatabaseInput.val() || App.RedesignDatabaseConnectForm.NONE_PARENT_ID;
    };

    RedesignDatabaseConnectForm.prototype.validateForm = function() {
      var badEmail, email, errorFields, errorMessages, field, missingFields, msg, titleizedFields;
      missingFields = this.specificDatabase().missingFields();
      if (this.databaseType() === this.constructor.SNOWFLAKE) {
        if (missingFields.includes('username')) {
          missingFields.push('snowflake_username');
        }
        if (missingFields.includes('password')) {
          missingFields.push('snowflake_password');
        }
        if (missingFields.includes('host')) {
          missingFields.push('account_name');
        }
        missingFields = missingFields.withoutAny(['username', 'password', 'host']);
      }
      errorFields = [].concat(missingFields);
      errorMessages = [];
      if (this.newCustomer) {
        email = $.trim(this.fieldEmailAddress.val());
        if (email !== '' && !App.Utils.probablyAValidEmailAddress(email)) {
          errorFields = ['email_address'].concat(missingFields);
          errorMessages.push('Please enter a valid email address.');
          badEmail = true;
        }
      }
      if (this.fieldDisplayName.val().trim().includes(' ')) {
        errorFields.push('display_name');
        errorMessages.push('Display Name should not have spaces.');
      }
      if (_.eq(_.toLower(this.fieldDisplayName.val().trim()), "warehouse")) {
        errorFields.push('display_name');
        errorMessages.push('Warehouse is a reserved name.');
      }
      this.markFieldsAsErrors(errorFields);
      if (errorFields.length > 0) {
        if (missingFields.length > 0) {
          titleizedFields = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = missingFields.length; i < len; i++) {
              field = missingFields[i];
              results.push(App.Utils.titleize(field));
            }
            return results;
          })();
          msg = "Missing required field";
          if (titleizedFields.length > 1) {
            msg = msg.pluralize();
          }
          errorMessages.push(msg + ": " + (titleizedFields.join(', ')));
        }
        this.errorValidation.text(errorMessages.join('\n'));
        this.showError(this.constructor.STATUS_VALIDATION);
        return false;
      } else {
        return true;
      }
    };

    RedesignDatabaseConnectForm.prototype.removeAllErrors = function() {
      return this.$('.form input').removeClass('error');
    };

    RedesignDatabaseConnectForm.prototype.markFieldsAsErrors = function(errorFields) {
      var field, i, len, ref;
      this.removeAllErrors();
      if (errorFields.isEmpty()) {
        return;
      }
      for (i = 0, len = errorFields.length; i < len; i++) {
        field = errorFields[i];
        this.$(".form [row=\"" + field + "\"] input").addClass('error');
        if (field === 'database_name') {
          this.fieldOracleDatabaseName.addClass('error');
        }
      }
      if (errorFields.includes('p12_key_file')) {
        this.divKeyFile.addClass('error');
      }
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        if (errorFields.includes('snowflake_pk8_key_file')) {
          return this.divSnowflakePk8KeyFile.addClass('error');
        }
      }
    };

    RedesignDatabaseConnectForm.prototype.bigqueryRows = function() {
      return [this.rowBigqueryServiceAccount, this.rowBigquerySqlDialect, this.rowBigqueryProjectId, this.rowBigqueryKeyFile];
    };

    RedesignDatabaseConnectForm.prototype.standardRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    RedesignDatabaseConnectForm.prototype.oracleRows = function() {
      return [this.rowJdbcCommandType, this.rowDbHost, this.rowDbPort, this.rowDbUser, this.rowPassword];
    };

    RedesignDatabaseConnectForm.prototype.quboleRows = function() {
      return [this.rowDbUser, this.rowPassword, this.rowCommandType, this.rowClusterName, this.rowCloudProvider];
    };

    RedesignDatabaseConnectForm.prototype.athenaRows = function() {
      return [this.rowDbHost, this.rowDbPort, this.rowS3StagingDir, this.rowDbUser, this.rowPassword];
    };

    RedesignDatabaseConnectForm.prototype.replicaRows = function() {
      return [this.parentDatabase];
    };

    RedesignDatabaseConnectForm.prototype.snowflakeRows = function() {
      var ref, rows;
      rows = [this.rowDbName, this.rowAccountName, this.rowWarehouseName, this.rowSnowflakeUsername, this.rowSnowflakePassword];
      if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
        rows = rows.concat([this.rowSnowflakeKeyFile, this.rowSnowflakePk8KeyFile]);
      }
      return rows;
    };

    RedesignDatabaseConnectForm.prototype.databricksRows = function() {
      return [this.rowDbName, this.rowDbHost, this.rowHttppath, this.rowCatalog, this.rowDbUser, this.rowPassword];
    };

    RedesignDatabaseConnectForm.prototype.specificDatabase = function() {
      var databaseClass, ref;
      databaseClass = (ref = App.RedesignDatabaseConnectForm[(this.databaseType()) + "ConnectForm"]) != null ? ref : App.RedesignDatabaseConnectForm.GenericDatabaseConnectForm;
      return this._specificDatabase = new databaseClass(this);
    };

    RedesignDatabaseConnectForm.prototype.cacheableAttributes = function() {
      var ref, result;
      result = {
        admin_password: this.fieldCacheableAdminPassword.val(),
        admin_username: this.fieldCacheableAdminUsername.val()
      };
      if (this.initialValuesSnowflake()) {
        if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          result = $.extend(result, {
            admin_pk8_path: this.validSnowflakeCacheablePk8KeyFile,
            admin_pk8_pwd: this.fieldSnowflakeCacheablePk8Pwd.val()
          });
        }
      }
      return result;
    };

    RedesignDatabaseConnectForm.SalesforceDatabaseConnectForm = (function() {
      SalesforceDatabaseConnectForm.SALESFORCE_FIELDS = ['display_name', 'login_name', 'login_password', 'security_token', 'client_id', 'client_secret'];

      function SalesforceDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
      }

      SalesforceDatabaseConnectForm.prototype.render = function() {
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.toggleSshTunnel(false);
        this.databaseConnectForm.togglePrivateNetwork(false);
        return this.databaseConnectForm.toggleTeradataPrivateNetworkLink(false);
      };

      SalesforceDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('redesign/settings/salesforce_form')({
          initialValues: this.databaseConnectForm.initialValues
        });
      };

      SalesforceDatabaseConnectForm.prototype.username = function() {
        return this.databaseConnectForm.salesforceLoginName.val();
      };

      SalesforceDatabaseConnectForm.prototype.password = function() {
        return this.databaseConnectForm.salesforceLoginPassword.val();
      };

      SalesforceDatabaseConnectForm.prototype.attributes = function() {
        var ref;
        return {
          id: (ref = this.databaseConnectForm.initialValues) != null ? ref.specific_database_id : void 0,
          client_id: this.databaseConnectForm.salesforceClientId.val(),
          client_secret: this.databaseConnectForm.salesforceClientSecret.val(),
          login_token: this.databaseConnectForm.salesforceSecurityToken.val()
        };
      };

      SalesforceDatabaseConnectForm.prototype.requiredFields = function() {
        return this.constructor.SALESFORCE_FIELDS;
      };

      SalesforceDatabaseConnectForm.prototype.missingFields = function() {
        var field, formParams, ref, requiredFields, salesforceParams;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        if ((ref = App.Site.first()) != null ? ref.database_roles_mapping_enabled : void 0) {
          requiredFields = requiredFields.without('password');
        }
        formParams = this.databaseConnectForm.formParams();
        salesforceParams = {
          'client_id': formParams.specific_database_attributes['client_id'],
          'client_secret': formParams.specific_database_attributes['client_secret'],
          'security_token': formParams.specific_database_attributes['login_token'],
          'login_name': formParams['username'],
          'login_password': formParams['password'],
          'display_name': formParams['display_name']
        };
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (salesforceParams[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      return SalesforceDatabaseConnectForm;

    })();

    RedesignDatabaseConnectForm.GenericDatabaseConnectForm = (function() {
      GenericDatabaseConnectForm.PLACEHOLDERS = {
        "default": ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        postgres: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "5432"],
        redshift: ["db1.abcdefg.us-east-1.redshift.amazonaws.com", "5439"],
        mysql: ["db1.abcdefg.us-east-1.rds.amazonaws.com", "3306"],
        vertica: ["db1.company.com", "5433"],
        sql_server: ["db1.company.com", "1433"],
        oracle: ["db1.company.com", "1521"],
        memsql: ["ec2-154-43-211-119.compute-1.amazonaws.com", "3306"],
        sybase: ["db1.company.com", "5000"],
        bigquery: ["N/A", "N/A"],
        exasol: ["192.168.100.5", "8563"],
        presto: ["db1.company.com", "8080"],
        teradata: ["db1.abcdefg.us-east-1.teradata.amazonaws.com", "1025"],
        databricks: ["adb-322443444.0.azuredatabricks.net", "443"],
        AthenaDatabase: ["athena.us-east-1.amazonaws.com", "443"]
      };

      function GenericDatabaseConnectForm(databaseConnectForm) {
        this.databaseConnectForm = databaseConnectForm;
        this.handleSnowflakeCacheablePk8Drop = bind(this.handleSnowflakeCacheablePk8Drop, this);
        this.handleSnowflakePk8Drop = bind(this.handleSnowflakePk8Drop, this);
        this.handleDrop = bind(this.handleDrop, this);
      }

      GenericDatabaseConnectForm.prototype.render = function() {
        var hasSsh, i, j, l, len, len1, len2, len3, len4, len5, len6, m, n, o, p, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, row, sshDisabled;
        if (this.databaseConnectForm.newCustomer || App.Database.countWithReplicas() <= 1) {
          this.databaseConnectForm.parentDatabase.hide();
        }
        this.databaseConnectForm.successMessageEl.text(this.databaseConnectForm.successMessage);
        this.databaseConnectForm.parentDatabaseInput.chosen({
          disable_search: true,
          width: '100%',
          placeholder_text_single: 'None'
        });
        if (this.databaseConnectForm.initialValues != null) {
          this.populateForm();
        } else {
          this.populateBlankForm();
        }
        ref = this.databaseConnectForm.standardRows();
        for (i = 0, len = ref.length; i < len; i++) {
          row = ref[i];
          row.hide();
        }
        ref1 = this.databaseConnectForm.bigqueryRows();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          row = ref1[j];
          row.hide();
        }
        ref2 = this.databaseConnectForm.snowflakeRows();
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          row = ref2[l];
          row.hide();
        }
        ref3 = this.databaseConnectForm.quboleRows();
        for (m = 0, len3 = ref3.length; m < len3; m++) {
          row = ref3[m];
          row.hide();
        }
        ref4 = this.databaseConnectForm.athenaRows();
        for (n = 0, len4 = ref4.length; n < len4; n++) {
          row = ref4[n];
          row.hide();
        }
        ref5 = this.databaseConnectForm.oracleRows();
        for (o = 0, len5 = ref5.length; o < len5; o++) {
          row = ref5[o];
          row.hide();
        }
        ref6 = this.databaseConnectForm.databricksRows();
        for (p = 0, len6 = ref6.length; p < len6; p++) {
          row = ref6[p];
          row.hide();
        }
        hasSsh = (this.databaseConnectForm.initialValues.ssh_host != null) && this.databaseConnectForm.initialValues.ssh_host !== "";
        sshDisabled = [App.RedesignDatabaseConnectForm.BIGQUERY, App.RedesignDatabaseConnectForm.SNOWFLAKE, App.RedesignDatabaseConnectForm.TERADATA].includes(this.databaseConnectForm.databaseType());
        this.databaseConnectForm.showSshForm(hasSsh && !sshDisabled);
        this.databaseConnectForm.togglePrivateNetwork(!(sshDisabled || hasSsh));
        if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.TERADATA) {
          this.databaseConnectForm.toggleTeradataPrivateNetworkLink(true);
        } else {
          this.databaseConnectForm.toggleTeradataPrivateNetworkLink(false);
        }
        this.showRows();
        if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.BIGQUERY) {
          this.databaseConnectForm.bigQuerySqlDialectInput.chosen({
            disable_search: true,
            width: '100%'
          });
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].addEventListener('drop', this.handleDrop, false);
        } else if (this.databaseConnectForm.fieldBigqueryKeyFile.length > 0) {
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('dragover', this.handleDragOver, false);
          this.databaseConnectForm.fieldBigqueryKeyFile[0].removeEventListener('drop', this.handleDrop, false);
        }
        if ((ref7 = App.Site.first()) != null ? ref7.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.SNOWFLAKE) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].addEventListener('drop', this.handleSnowflakePk8Drop, false);
          } else if (this.databaseConnectForm.fieldSnowflakePk8KeyFile.length > 0) {
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('dragover', this.handleSnowflakePk8DragOver, false);
            this.databaseConnectForm.fieldSnowflakePk8KeyFile[0].removeEventListener('drop', this.handleSnowflakePk8Drop, false);
          }
          if (this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile && this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile[0]) {
            if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.SNOWFLAKE) {
              this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile[0].addEventListener('dragover', this.handleSnowflakeCacheablePk8DragOver, false);
              this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile[0].addEventListener('drop', this.handleSnowflakeCacheablePk8Drop, false);
            } else if (this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile.length > 0) {
              this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile[0].removeEventListener('dragover', this.handleSnowflakeCacheablePk8DragOver, false);
              this.databaseConnectForm.fieldSnowflakeCacheablePk8KeyFile[0].removeEventListener('drop', this.handleSnowflakeCacheablePk8Drop, false);
            }
          }
        }
        if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.QUBOLE) {
          this.databaseConnectForm.commandTypeInput.chosen({
            disable_search: true,
            width: '100%'
          });
          this.databaseConnectForm.cloudProviderInput.chosen({
            disable_search: true,
            width: '100%'
          });
        } else if (this.databaseConnectForm.databaseType() === App.RedesignDatabaseConnectForm.ORACLE) {
          this.databaseConnectForm.jdbcCommandTypeInput.chosen({
            disable_search: true,
            width: '119px'
          });
        }
        if ((ref8 = App.Site.first()) != null ? ref8.database_roles_mapping_enabled : void 0) {
          this.databaseConnectForm.rolesInput.chosen({
            disable_search: true,
            width: '100%',
            placeholder_text_multiple: 'Select Roles',
            inherit_select_classes: true
          });
        }
        return this.setPlaceholderText();
      };

      GenericDatabaseConnectForm.prototype.populateForm = function() {
        var ref;
        this.databaseConnectForm.databaseTypeInput.trigger('chosen:updated');
        if (this.databaseConnectForm.initialValues.has_child) {
          this.databaseConnectForm.parentDatabaseInput.prop('disabled', true);
        }
        this.databaseConnectForm.parentDatabaseInput.val(this.databaseConnectForm.initialValues.parent_database_id || App.RedesignDatabaseConnectForm.NONE_PARENT_ID);
        this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
        if ((ref = App.Site.first()) != null ? ref.database_roles_mapping_enabled : void 0) {
          this.databaseConnectForm.rolesInput.val(this.databaseConnectForm.initialValues.database_role_mapping_ids);
          this.databaseConnectForm.rolesInput.trigger('chosen:updated');
        }
        this.databaseConnectForm.fieldEmailAddress.val(this.databaseConnectForm.initialValues.email_address);
        this.databaseConnectForm.fieldDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
        this.databaseConnectForm.fieldHost.val(this.databaseConnectForm.initialValues.host);
        this.databaseConnectForm.fieldPort.val(this.databaseConnectForm.initialValues.port);
        this.databaseConnectForm.fieldUsername.val(this.databaseConnectForm.initialValues.username);
        if (this.databaseConnectForm.initialValues.ssh_host != null) {
          this.databaseConnectForm.fieldSshHost.val(this.databaseConnectForm.initialValues.ssh_host);
        }
        if (this.databaseConnectForm.initialValues.ssh_port != null) {
          this.databaseConnectForm.fieldSshPort.val(this.databaseConnectForm.initialValues.ssh_port);
        }
        if (this.databaseConnectForm.initialValues.ssh_username != null) {
          this.databaseConnectForm.fieldSshUsername.val(this.databaseConnectForm.initialValues.ssh_username);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.BIGQUERY) {
          this.databaseConnectForm.fieldServiceAccount.val(this.databaseConnectForm.initialValues.username);
          this.databaseConnectForm.fieldProjectId.val(this.databaseConnectForm.initialValues.database_name);
          this.databaseConnectForm.bigQuerySqlDialectInput.val(this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.BIGQUERY ? 'legacy' : 'standard');
        }
        if (this.databaseConnectForm.initialValues.database_type === this.databaseConnectForm.constructor.SNOWFLAKE) {
          this.databaseConnectForm.fieldWarehouseName.val(this.databaseConnectForm.initialValues.warehouse_name);
          this.databaseConnectForm.fieldAccountName.val(this.databaseConnectForm.initialValues.host);
          this.databaseConnectForm.fieldSnowflakeUsername.val(this.databaseConnectForm.initialValues.username);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.QUBOLE) {
          this.databaseConnectForm.clusterNameInput.val(this.databaseConnectForm.initialValues.cluster_name);
          this.databaseConnectForm.commandTypeInput.val(this.databaseConnectForm.initialValues.command_type);
          this.databaseConnectForm.cloudProviderInput.val(this.databaseConnectForm.initialValues.cloud_provider);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.ATHENA) {
          this.databaseConnectForm.s3StagingDirInput.val(this.databaseConnectForm.initialValues.s3_staging_dir);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.ORACLE) {
          this.databaseConnectForm.fieldOracleDatabaseName.val(this.databaseConnectForm.initialValues.database_name);
          this.databaseConnectForm.jdbcCommandTypeInput.val(this.databaseConnectForm.initialValues.command_type === 'service_name' ? 'service_name' : 'sid');
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.DATABRICKS && (this.databaseConnectForm.initialValues.warehouse_name != null)) {
          this.databaseConnectForm.fieldCatalog.val(this.databaseConnectForm.initialValues.warehouse_name);
        }
        if (this.databaseConnectForm.databaseType() === this.databaseConnectForm.constructor.DATABRICKS && (this.databaseConnectForm.initialValues.s3_staging_dir != null)) {
          return this.databaseConnectForm.fieldHttppath.val(this.databaseConnectForm.initialValues.s3_staging_dir);
        }
      };

      GenericDatabaseConnectForm.prototype.populateBlankForm = function() {
        this.databaseConnectForm.parentDatabaseInput.val(App.RedesignDatabaseConnectForm.NONE_PARENT_ID);
        return this.databaseConnectForm.parentDatabaseInput.trigger('chosen:updated');
      };

      GenericDatabaseConnectForm.prototype.setPlaceholderText = function() {
        var placeholders;
        placeholders = this.constructor.PLACEHOLDERS[this.databaseConnectForm.databaseType()];
        if (placeholders != null) {
          return this.databaseConnectForm.setPlaceholders(placeholders[0], placeholders[1]);
        }
      };

      GenericDatabaseConnectForm.prototype.handleDragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleDrop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setKeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8DragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakePk8Drop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setSnowflakePk8KeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakeCacheablePk8DragOver = function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        return evt.dataTransfer.dropEffect = 'copy';
      };

      GenericDatabaseConnectForm.prototype.handleSnowflakeCacheablePk8Drop = function(evt) {
        evt.stopPropagation();
        if (evt.dataTransfer.files.length < 1) {
          return;
        }
        return this.databaseConnectForm.setSnowflakeCacheablePk8KeyFileHandle(evt.dataTransfer.files[0]);
      };

      GenericDatabaseConnectForm.prototype.showRows = function() {
        var i, len, results, row, rows;
        rows = (function() {
          switch (this.databaseConnectForm.databaseType()) {
            case App.RedesignDatabaseConnectForm.BIGQUERY:
              return this.databaseConnectForm.bigqueryRows();
            case App.RedesignDatabaseConnectForm.SNOWFLAKE:
              return this.databaseConnectForm.snowflakeRows();
            case App.RedesignDatabaseConnectForm.QUBOLE:
              return this.databaseConnectForm.quboleRows();
            case App.RedesignDatabaseConnectForm.ATHENA:
              return this.databaseConnectForm.athenaRows();
            case App.RedesignDatabaseConnectForm.ORACLE:
              return this.databaseConnectForm.oracleRows();
            case App.RedesignDatabaseConnectForm.DATABRICKS:
              return this.databaseConnectForm.databricksRows();
            default:
              return this.databaseConnectForm.standardRows();
          }
        }).call(this);
        results = [];
        for (i = 0, len = rows.length; i < len; i++) {
          row = rows[i];
          results.push(row.show());
        }
        return results;
      };

      GenericDatabaseConnectForm.prototype.renderSpecificDatabaseFields = function() {
        return this.databaseConnectForm.view('redesign/settings/non_polymorphic_form_fields')({
          moreHelp: this.databaseConnectForm.view('databases/more_help')(),
          databaseNames: this.databaseConnectForm.replicaDatabaseNames(this.databaseConnectForm.initialValues),
          roleNames: this.databaseConnectForm.roleNames
        });
      };

      GenericDatabaseConnectForm.prototype.username = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakeUsername.val();
        } else {
          return this.databaseConnectForm.fieldUsername.val();
        }
      };

      GenericDatabaseConnectForm.prototype.password = function() {
        if (this.databaseConnectForm.databaseType === this.constructor.SNOWFLAKE) {
          return this.databaseConnectForm.fieldSnowflakePassword.val();
        } else {
          return this.databaseConnectForm.fieldPassword.val();
        }
      };

      GenericDatabaseConnectForm.prototype.missingFields = function() {
        var field, params, ref, requiredFields;
        requiredFields = this.requiredFields();
        if (!this.databaseConnectForm.newCustomer) {
          requiredFields = requiredFields.without('email_address');
        }
        if ((ref = App.Site.first()) != null ? ref.database_roles_mapping_enabled : void 0) {
          requiredFields = requiredFields.without('password');
        }
        params = this.databaseConnectForm.formParams();
        return (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = requiredFields.length; i < len; i++) {
            field = requiredFields[i];
            if (params[field] === '') {
              results.push(field);
            }
          }
          return results;
        })();
      };

      GenericDatabaseConnectForm.prototype.requiredFields = function() {
        var constructor;
        constructor = this.databaseConnectForm.constructor;
        switch (this.databaseConnectForm.databaseType()) {
          case constructor.BIGQUERY:
            return ['service_account', 'project_id', 'email_address', 'p12_key_file'];
          case constructor.SNOWFLAKE:
            return ['email_address', 'database_name', 'warehouse_name', 'host', 'username'];
          case constructor.PRESTO:
            return ['email_address', 'host', 'port', 'username'];
          case constructor.QUBOLE:
            return ['display_name', 'username', 'password', 'cluster_name', 'command_type', 'cloud_provider'];
          case constructor.ATHENA:
            return ['display_name', 'host', 'port', 's3_staging_dir', 'username', 'password'];
          case constructor.DATABRICKS:
            return ['display_name', 'host', 'httppath', 'catalog', 'username', 'password', 'database_name'];
          default:
            return constructor.FORM_FIELDS;
        }
      };

      return GenericDatabaseConnectForm;

    })();

    RedesignDatabaseConnectForm.prototype.databaseTypeChanged = function() {
      this.initialValues = this.formParams();
      this.hideErrors();
      this.render();
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    RedesignDatabaseConnectForm.prototype.setPlaceholders = function(host, port) {
      this.fieldHost.attr('placeholder', host);
      return this.fieldPort.attr('placeholder', port);
    };

    RedesignDatabaseConnectForm.prototype.showError = function(status) {
      var filter, foundError;
      filter = "." + status + "[databases~=\"" + (this.databaseType()) + "\"], ." + status + ":not([databases])";
      foundError = this.errorMessages.filter(filter);
      foundError.slideDown();
      this.errorMessages.not(foundError).slideUp();
      if (!(foundError.length > 0)) {
        this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      }
      return this.maybeShowErrorLink(foundError);
    };

    RedesignDatabaseConnectForm.prototype.maybeShowErrorLink = function(foundError) {
      var databaseToDoc;
      this.errorsBlock.find('.error-link').remove();
      if (this.databaseType() !== 'sql_server') {
        return;
      }
      databaseToDoc = {
        'sql_server': 'connecting-sql-server'
      };
      if (foundError.find('.help-connecting').length === 0) {
        return foundError.append(this.view('databases/error_link')({
          link: databaseToDoc[this.databaseType()]
        }));
      }
    };

    RedesignDatabaseConnectForm.prototype.substituteErrors = function() {
      this.databaseNameInErrors.text(this.formParams()['database_name']);
      this.usernameInErrors.text(this.formParams()['username']);
      return this.accountNameInErrors.text(this.formParams()['host']);
    };

    RedesignDatabaseConnectForm.prototype.pollDoctor = function() {
      return $.post(this.pollRoute, this.extraParams).fail(this.handleAjaxError).done(this.doctorResponse);
    };

    RedesignDatabaseConnectForm.prototype.doctorResponse = function(response) {
      if (response.status === this.constructor.STATUS_PENDING) {
        return;
      }
      this.stopDoctorPolling();
      this.updateStatus(response.status, response.error);
      this.showConnectionResults();
      this.updateParentChildRelationship();
      if (response.status === this.constructor.STATUS_OK) {
        App.Database.applyUpdates([response.db]);
        return this.trigger('database-connection-success', response.id);
      }
    };

    RedesignDatabaseConnectForm.prototype.updateStatus = function(status, fullError) {
      if (fullError == null) {
        fullError = "";
      }
      this.unexpectedErrorFullMessageEl.text(fullError);
      this.substituteErrors();
      return this.showError(status);
    };

    RedesignDatabaseConnectForm.prototype.startDoctorPolling = function() {
      this.stopDoctorPolling();
      this.polling = true;
      return this.doctorInterval = setInterval(this.pollDoctor, this.constructor.POLL_INTERVAL);
    };

    RedesignDatabaseConnectForm.prototype.stopDoctorPolling = function() {
      this.polling = false;
      clearInterval(this.doctorInterval);
      return this.doctorInterval = null;
    };

    RedesignDatabaseConnectForm.prototype.showConnectionResults = function() {
      return this.dbLoader.hide();
    };

    RedesignDatabaseConnectForm.prototype.updateParentChildRelationship = function() {
      var parentDb, parentId, ref;
      parentId = this.parentId();
      App.Database.trigger('parent-database-added', parentId);
      if (!((parentId != null) && parentId !== App.RedesignDatabaseConnectForm.NONE_PARENT_ID)) {
        return;
      }
      parentDb = App.Database.find(parentId);
      parentDb.has_child = true;
      parentDb.save({
        ajax: false
      });
      return (ref = App.User.currentUser()) != null ? ref.setLastUsedDatabase(parentId) : void 0;
    };

    RedesignDatabaseConnectForm.prototype.showConnectionLoader = function() {
      this.dbLoader.fadeIn();
      this.dbLoader.css('display', 'block');
      return this.hideErrors();
    };

    RedesignDatabaseConnectForm.prototype.hideErrors = function() {
      this.errorMessages.hide();
      return this.errorLinks.hide();
    };

    RedesignDatabaseConnectForm.prototype.privateNetworkClicked = function() {
      this.toggleSshTunnel(true);
      return this.togglePrivateNetwork(false);
    };

    RedesignDatabaseConnectForm.prototype.showSshForm = function(show) {
      this.sshTunnelHelp.toggle(show);
      return this.sshTunnelForm.toggle(show);
    };

    RedesignDatabaseConnectForm.prototype.toggleSshTunnel = function(show) {
      this.sshTunnelHelp.toggle(show);
      if (show) {
        return this.sshTunnelForm.slideDown();
      } else {
        return this.sshTunnelForm.slideUp();
      }
    };

    RedesignDatabaseConnectForm.prototype.togglePrivateNetwork = function(show) {
      return this.privateNetwork.toggle(show);
    };

    RedesignDatabaseConnectForm.prototype.toggleTeradataPrivateNetworkLink = function(show) {
      return this.teradataPrivateNetworkLink.toggle(show);
    };

    RedesignDatabaseConnectForm.prototype.readFile = function() {
      var reader;
      reader = new FileReader();
      if (this.keyFile == null) {
        this.keyFile = this.fieldBigqueryKeyFile.val();
      }
      reader.file = this.keyFile;
      reader.onload = this.uploadStart;
      reader.readAsBinaryString(this.keyFile);
      return this.keyFileSize = this.keyFile.size;
    };

    RedesignDatabaseConnectForm.prototype.uploadStart = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadKeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keyFileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    RedesignDatabaseConnectForm.prototype.uploadFailed = function(xhr, msg, err) {
      this.errorValidation.text('Key file upload failed.');
      this.showError(this.constructor.STATUS_ERROR_UNEXPECTED);
      return this.showConnectionResults();
    };

    RedesignDatabaseConnectForm.prototype.uploadComplete = function() {
      return this.startDoctorPolling();
    };

    RedesignDatabaseConnectForm.prototype.handleKeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      this.setKeyFileHandle(evt.target.files[0]);
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    RedesignDatabaseConnectForm.prototype.setKeyFileHandle = function(file) {
      if (!file.type.match('application/x-pkcs12')) {
        return this.keyFileError('Key file should be of type .p12');
      } else if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keyFileError('Maximum key file size is 5KB');
      } else {
        this.defaultBigqueryKeyFileText.hide();
        this.errorValidation.text('');
        this.divKeyFile.removeClass('error');
        this.keyFile = file;
        this.divFileName.text(file.name);
        return this.validKeyFile = file.name;
      }
    };

    RedesignDatabaseConnectForm.prototype.keyFileError = function(message) {
      this.divFileName.text('');
      this.divKeyFile.addClass('error');
      this.defaultBigqueryKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validKeyFile = '';
    };

    RedesignDatabaseConnectForm.prototype.readSnowflakePk8File = function() {
      var reader;
      reader = new FileReader();
      if (this.keySnowflakePk8File == null) {
        this.keySnowflakePk8File = this.fieldSnowflakePk8KeyFile.val();
      }
      if (this.keySnowflakePk8File) {
        reader.file = this.keySnowflakePk8File;
        reader.onload = this.uploadSnowflakePk8Start;
        reader.readAsBinaryString(this.keySnowflakePk8File);
        return this.keySnowflakePk8FileSize = this.keySnowflakePk8File.size;
      } else {
        return this.startDoctorPolling();
      }
    };

    RedesignDatabaseConnectForm.prototype.uploadSnowflakePk8Start = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadSnowflakePk8KeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keySnowflakePk8FileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    RedesignDatabaseConnectForm.prototype.handleSnowflakePk8KeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      this.setSnowflakePk8KeyFileHandle(evt.target.files[0]);
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    RedesignDatabaseConnectForm.prototype.setSnowflakePk8KeyFileHandle = function(file) {
      if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keySnowflakePk8FileError('Maximum key file size is 5KB');
      } else {
        this.defaultSnowflakeKeyFileText.hide();
        this.errorValidation.text('');
        this.divSnowflakePk8KeyFile.removeClass('error');
        this.keySnowflakePk8File = file;
        this.divSnowflakePk8FileName.text(file.name);
        return this.validSnowflakePk8KeyFile = file.name;
      }
    };

    RedesignDatabaseConnectForm.prototype.keySnowflakePk8FileError = function(message) {
      this.divSnowflakePk8FileName.text('');
      this.divSnowflakePk8KeyFile.addClass('error');
      this.defaultSnowflakeKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validSnowflakePk8KeyFile = '';
    };

    RedesignDatabaseConnectForm.prototype.readSnowflakeCacheablePk8File = function() {
      var reader;
      reader = new FileReader();
      if (this.keySnowflakeCacheablePk8File == null) {
        this.keySnowflakeCacheablePk8File = this.fieldSnowflakeCacheablePk8KeyFile.val();
      }
      if (this.keySnowflakeCacheablePk8File) {
        reader.file = this.keySnowflakeCacheablePk8File;
        reader.onload = this.uploadSnowflakeCacheablePk8Start;
        reader.readAsBinaryString(this.keySnowflakeCacheablePk8File);
        return this.keySnowflakeCacheablePk8FileSize = this.keySnowflakeCacheablePk8File.size;
      } else {
        return this.startDoctorPolling();
      }
    };

    RedesignDatabaseConnectForm.prototype.uploadSnowflakeCacheablePk8Start = function(evt) {
      this.file_data = evt.target.result;
      return jQuery.ajax({
        url: this.uploadSnowflakeCacheablePk8KeyRoute,
        type: "POST",
        data: {
          data: btoa(this.file_data),
          signup_token: this.extraParams['signup_token'],
          create_token: this.extraParams['create_token'],
          size: this.keySnowflakeCacheablePk8FileSize,
          id: this.extraParams['id']
        }
      }).done(this.uploadComplete).fail(this.uploadFailed);
    };

    RedesignDatabaseConnectForm.prototype.handleSnowflakeCacheablePk8KeyFileSet = function(evt) {
      if (evt.target.files.length < 1) {
        return;
      }
      this.setSnowflakeCacheablePk8KeyFileHandle(evt.target.files[0]);
      if (!this.addDb) {
        return this.cancelSaveBlock.setSaveDisabled(this.unfinishedForm());
      }
    };

    RedesignDatabaseConnectForm.prototype.setSnowflakeCacheablePk8KeyFileHandle = function(file) {
      if (file.size > this.constructor.P12FILE_SIZE_LIMIT) {
        return this.keySnowflakeCacheablePk8FileError('Maximum key file size is 5KB');
      } else {
        this.defaultSnowflakeCacheableKeyFileText.hide();
        this.errorValidation.text('');
        this.divSnowflakeCacheablePk8KeyFile.removeClass('error');
        this.keySnowflakeCacheablePk8File = file;
        this.divSnowflakeCacheablePk8FileName.text(file.name);
        return this.validSnowflakeCacheablePk8KeyFile = file.name;
      }
    };

    RedesignDatabaseConnectForm.prototype.keySnowflakeCacheablePk8FileError = function(message) {
      this.divSnowflakeCacheablePk8FileName.text('');
      this.divSnowflakeCacheablePk8KeyFile.addClass('error');
      this.defaultSnowflakeCacheableKeyFileText.show();
      this.errorValidation.text(message);
      this.showError(this.constructor.STATUS_VALIDATION);
      return this.validSnowflakeCacheablePk8KeyFile = '';
    };

    return RedesignDatabaseConnectForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDatabaseCredentialsController = (function(superClass) {
    extend(RedesignDatabaseCredentialsController, superClass);

    function RedesignDatabaseCredentialsController() {
      RedesignDatabaseCredentialsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'currentDb');
      this.makeDbConnectForm();
    }

    RedesignDatabaseCredentialsController.prototype.release = function() {
      var ref;
      if ((ref = this.dbConnectForm) != null) {
        ref.release();
      }
      return RedesignDatabaseCredentialsController.__super__.release.apply(this, arguments);
    };

    RedesignDatabaseCredentialsController.prototype.makeDbConnectForm = function() {
      var formEl, ref;
      if ((ref = this.dbConnectForm) != null) {
        ref.release();
      }
      formEl = $('<div class="creds-form"></div>');
      this.el.append(formEl);
      return this.dbConnectForm = new App.RedesignDatabaseConnectForm({
        el: formEl,
        submitRoute: "/databases/update_settings",
        pollRoute: "/databases/poll_doctor",
        uploadKeyRoute: "/databases/upload_bigquery_key",
        uploadSnowflakePk8KeyRoute: "/databases/upload_snowflake_key",
        uploadSnowflakeCacheablePk8KeyRoute: "/databases/upload_snowflake_cacheable_key",
        newCustomer: false,
        extraParams: {
          id: this.currentDb.id,
          client_site_id: App.Site.first().id
        },
        successMessage: "The database connection was successful!",
        infoGrid: true,
        initialValues: this.valuesFromDb()
      });
    };

    RedesignDatabaseCredentialsController.prototype.dbSelected = function(currentDb) {
      this.currentDb = currentDb;
      return this.makeDbConnectForm();
    };

    RedesignDatabaseCredentialsController.prototype.valuesFromDb = function() {
      var host, port, sshTunnel;
      if (this.currentDb.ssh_tunnel_id != null) {
        sshTunnel = App.SshTunnel.exists(this.currentDb.ssh_tunnel_id);
      }
      host = this.currentDb.database_host;
      port = this.currentDb.database_port;
      if (sshTunnel != null) {
        host = sshTunnel.database_host;
        port = sshTunnel.database_port;
      }
      return {
        database_type: this.currentDb.database_type,
        database_name: this.currentDb.real_database_name,
        display_name: this.currentDb.database_name,
        host: host,
        port: port,
        username: this.currentDb.database_user,
        ssh_host: sshTunnel != null ? sshTunnel.ssh_host : void 0,
        ssh_port: sshTunnel != null ? sshTunnel.ssh_port : void 0,
        ssh_username: sshTunnel != null ? sshTunnel.ssh_username : void 0,
        parent_database_id: this.currentDb.parent_database_id,
        has_child: this.currentDb.has_child,
        database_id: this.currentDb.id,
        warehouse_name: this.currentDb.warehouse_name,
        client_id: this.currentDb.client_id,
        specific_database_id: this.currentDb.specific_database_id,
        command_type: this.currentDb.command_type,
        cloud_provider: this.currentDb.cloud_provider,
        cluster_name: this.currentDb.cluster_name,
        s3_staging_dir: this.currentDb.s3_staging_dir,
        cacheable_admin_username: this.currentDb.cacheable_admin_username,
        byow_enabled_db: this.currentDb.isByowEligible(),
        database_role_mapping_ids: this.currentDb.database_role_mapping_ids
      };
    };

    return RedesignDatabaseCredentialsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDatabaseDeleteForm = (function(superClass) {
    extend(RedesignDatabaseDeleteForm, superClass);

    RedesignDatabaseDeleteForm.prototype.elements = {
      'select.replacement-db': 'replaceSelect',
      'input.delete-confirm': 'deleteConfirmInput',
      '.button.delete': 'deleteButtonEl'
    };

    RedesignDatabaseDeleteForm.prototype.events = {
      'click .delete.button': 'deleteClick',
      'keyup input.delete-confirm': 'deleteConfirmKeyup',
      'click .cancel.button': 'cancelClick'
    };

    function RedesignDatabaseDeleteForm() {
      this.deleteClick = bind(this.deleteClick, this);
      this.deleteConfirmKeyup = bind(this.deleteConfirmKeyup, this);
      RedesignDatabaseDeleteForm.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'database');
      this.html(this.view('redesign/settings/database_delete_form')({
        database_name: this.database.database_name,
        dependents_info: this.dependentsInfo()
      }));
      this.replaceSelect.html(App.Utils.optionsToHtml(this.replaceOptions()));
      this.replaceSelect.chosen({
        disable_search: true,
        width: '100%'
      });
    }

    RedesignDatabaseDeleteForm.prototype.dependentsInfo = function() {
      var parts, pif;
      parts = [];
      pif = App.Utils.pluralizeIf;
      if (this.database.num_widgets) {
        parts.push(this.database.num_widgets + " " + (pif("chart", this.database.num_widgets > 1)));
      }
      if (this.database.num_sql_views) {
        parts.push(this.database.num_sql_views + " " + (pif("view", this.database.num_sql_views > 1)));
      }
      if (parts.length === 0) {
        return null;
      }
      return parts.join(' and ');
    };

    RedesignDatabaseDeleteForm.prototype.replaceOptions = function() {
      var db, i, len, options, ref;
      options = [];
      ref = App.Database.allSortedByName();
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        if ((db.id !== this.database.id) && (!db.metadata_db)) {
          options.push({
            name: db.database_name,
            value: db.id
          });
        }
      }
      return options;
    };

    RedesignDatabaseDeleteForm.prototype.deleteIsConfirmed = function() {
      return this.deleteConfirmInput.val() === this.database.database_name;
    };

    RedesignDatabaseDeleteForm.prototype.deleteConfirmKeyup = function() {
      if (this.deleteIsConfirmed()) {
        return this.deleteButtonEl.removeClass("disabled");
      } else {
        return this.deleteButtonEl.addClass("disabled");
      }
    };

    RedesignDatabaseDeleteForm.prototype.deleteClick = function() {
      if (this.deleteIsConfirmed()) {
        jQuery.ajax({
          method: 'delete',
          url: "/databases/" + this.database.id,
          data: {
            client_site_id: App.Site.first().id,
            replace_with_id: this.replaceSelect.val() || this.replaceOptions().first().value
          }
        });
        return this.database.destroy({
          ajax: false
        });
      }
    };

    RedesignDatabaseDeleteForm.prototype.cancelClick = function() {
      return this.trigger('close-dialog');
    };

    return RedesignDatabaseDeleteForm;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDatabaseDisconnectController = (function(superClass) {
    extend(RedesignDatabaseDisconnectController, superClass);

    RedesignDatabaseDisconnectController.prototype.elements = {
      '.disable-row': 'disableRow',
      '.disable-queries .checkbox': 'disableCheckbox',
      '.delete-db .button': 'deleteButton'
    };

    RedesignDatabaseDisconnectController.prototype.events = {
      'click .disable-queries .checkbox': 'disableClick',
      'click .delete-db .button': 'deleteClick'
    };

    function RedesignDatabaseDisconnectController() {
      this.deleteClick = bind(this.deleteClick, this);
      this.recheckDeleteOk = bind(this.recheckDeleteOk, this);
      this.disableClick = bind(this.disableClick, this);
      this.updateDisabledState = bind(this.updateDisabledState, this);
      RedesignDatabaseDisconnectController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'currentDb');
      this.html(this.view('redesign/settings/database_disconnect_form')());
      this.recheckDeleteOk();
      this.updateDisabledState();
      this.disableRow.hide();
      App.Database.bind('update create destroy', this.updateDisabledState);
    }

    RedesignDatabaseDisconnectController.prototype.release = function() {
      App.Database.unbind('update create destroy', this.updateDisabledState);
      return RedesignDatabaseDisconnectController.__super__.release.apply(this, arguments);
    };

    RedesignDatabaseDisconnectController.prototype.dbSelected = function(currentDb) {
      this.currentDb = currentDb;
      return this.updateDisabledState();
    };

    RedesignDatabaseDisconnectController.prototype.updateDisabledState = function(db) {
      if (db == null) {
        db = null;
      }
      if ((db != null) && db.id !== this.currentDb.id) {
        return;
      }
      if (this.currentDb.disable_updates) {
        this.disableCheckbox.addClass('checked');
      } else {
        this.disableCheckbox.removeClass('checked');
      }
      return this.recheckDeleteOk();
    };

    RedesignDatabaseDisconnectController.prototype.disableClick = function() {
      this.currentDb.disable_updates = !this.currentDb.disable_updates;
      this.currentDb.save({
        ajax: false
      });
      return jQuery.ajax({
        method: 'post',
        url: "/databases/" + this.currentDb.id + "/toggle_disabled",
        data: {
          client_site_id: App.Site.first().id
        }
      });
    };

    RedesignDatabaseDisconnectController.prototype.hasMoreThanOneCustomerOwnedDatabase = function() {
      return App.Database.configurableDatabases().length > 1;
    };

    RedesignDatabaseDisconnectController.prototype.recheckDeleteOk = function() {
      if (this.hasMoreThanOneCustomerOwnedDatabase() && (this.currentDb.num_widgets != null)) {
        return this.deleteButton.removeClass('disabled');
      } else {
        return this.deleteButton.addClass('disabled');
      }
    };

    RedesignDatabaseDisconnectController.prototype.deleteClick = function() {
      if (!this.deleteButton.hasClass('disabled')) {
        return this.trigger('delete-database');
      }
    };

    return RedesignDatabaseDisconnectController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignDatabaseRowCountsController = (function(superClass) {
    extend(RedesignDatabaseRowCountsController, superClass);

    RedesignDatabaseRowCountsController.prototype.elements = {
      '.total-rows': 'totalRowsEl',
      '.num-tables': 'numTablesEl',
      '.row-count-updated': 'countUpdatedAgoEl',
      '.refresh-count-now.refresh-button': 'refreshRowCountsButton'
    };

    RedesignDatabaseRowCountsController.prototype.events = {
      'click .refresh-count-now.refresh-button': 'refreshRowCountsClick',
      'click .download-counts .clickable': 'downloadRowCountsClick'
    };

    function RedesignDatabaseRowCountsController() {
      this.downloadRowCountsClick = bind(this.downloadRowCountsClick, this);
      this.refreshCountFail = bind(this.refreshCountFail, this);
      this.refreshCountSuccess = bind(this.refreshCountSuccess, this);
      this.refreshRowCountsClick = bind(this.refreshRowCountsClick, this);
      this.updateForm = bind(this.updateForm, this);
      this.updateTimestamps = bind(this.updateTimestamps, this);
      RedesignDatabaseRowCountsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'currentDb');
      this.html(this.view('redesign/settings/database_row_counts_form')());
      App.Database.bind('update', this.updateForm);
      this.updateForm();
      this.statusUpdateInterval = setInterval(this.updateTimestamps, 1 * 1000);
    }

    RedesignDatabaseRowCountsController.prototype.release = function() {
      clearInterval(this.statusUpdateInterval);
      App.Database.unbind('update', this.updateForm);
      return RedesignDatabaseRowCountsController.__super__.release.apply(this, arguments);
    };

    RedesignDatabaseRowCountsController.prototype.dbSelected = function(currentDb) {
      this.currentDb = currentDb;
      return this.updateForm();
    };

    RedesignDatabaseRowCountsController.prototype.countsAreLoaded = function() {
      this.countsLoaded = true;
      return this.updateForm();
    };

    RedesignDatabaseRowCountsController.prototype.updateTimestamps = function() {
      return this.countUpdatedAgoEl.text(this.constructor.rowCountsUpdatedAgo(this.currentDb));
    };

    RedesignDatabaseRowCountsController.prototype.updateForm = function() {
      this.currentDb.reload();
      this.totalRowsEl.text(this.totalRowCount());
      this.numTablesEl.text(this.numTables());
      if (this.currentDb.row_counts_are_updating) {
        this.refreshRowCountsButton.hide();
      } else {
        this.refreshRowCountsButton.css('display', 'inline-block');
      }
      return this.updateTimestamps();
    };

    RedesignDatabaseRowCountsController.prototype.dataReady = function() {
      var ref;
      return this.countsLoaded && (((ref = this.currentDb) != null ? ref.schema : void 0) != null);
    };

    RedesignDatabaseRowCountsController.prototype.totalRowCount = function() {
      if (!this.dataReady()) {
        return 'Loading...';
      }
      return this.constructor.totalRowCount(this.currentDb);
    };

    RedesignDatabaseRowCountsController.totalRowCount = function(db) {
      var count, ct;
      count = db.totalRowCount();
      if (count != null) {
        ct = (count.commaDelimit()) + " row";
        if (count !== 1) {
          ct += "s";
        }
      } else {
        ct = 'Unknown';
      }
      return ct;
    };

    RedesignDatabaseRowCountsController.prototype.numTables = function() {
      if (!this.dataReady()) {
        return 'Loading...';
      }
      return this.constructor.numTables(this.currentDb);
    };

    RedesignDatabaseRowCountsController.numTables = function(db) {
      var numTables, numUncounted, str;
      numTables = db.numTables();
      numUncounted = db.numUncountedTables();
      if (numTables === 0) {
        return "None";
      }
      str = numTables + " table";
      if (numTables !== 1) {
        str = str.pluralize();
      }
      if ((numUncounted != null) && numUncounted > 0 && numUncounted !== numTables) {
        str = str + ", " + numUncounted + " uncounted";
      }
      return str;
    };

    RedesignDatabaseRowCountsController.rowCountsUpdatedAgo = function(db) {
      if (db.row_counts_are_updating) {
        return 'Counting...';
      }
      return db.rowCountsUpdatedAgo();
    };

    RedesignDatabaseRowCountsController.prototype.refreshRowCountsClick = function() {
      this.currentDb.row_counts_are_updating = true;
      this.currentDb.save({
        ajax: false
      });
      jQuery.ajax({
        method: 'post',
        url: "/databases/" + this.currentDb.id + "/update_row_count",
        data: {
          client_site_id: App.Site.first().id
        }
      }).done(this.refreshCountSuccess).fail(this.refreshCountFail);
      return App.Utils.logFeature("update-row-counts");
    };

    RedesignDatabaseRowCountsController.prototype.refreshCountSuccess = function(response) {
      return App.Database.applyUpdates(response);
    };

    RedesignDatabaseRowCountsController.prototype.refreshCountFail = function() {
      this.currentDb.row_counts_are_updating = false;
      return this.currentDb.save({
        ajax: false
      });
    };

    RedesignDatabaseRowCountsController.prototype.downloadRowCountsClick = function() {
      return window.location = "/databases/" + this.currentDb.id + "/row_count_csv";
    };

    return RedesignDatabaseRowCountsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignPivotSettings = (function(superClass) {
    extend(RedesignPivotSettings, superClass);

    RedesignPivotSettings.prototype.className = 'pivot-settings-frame';

    RedesignPivotSettings.prototype.elements = {
      '.title': 'pivotHeaderTitle',
      '.title h1': 'pivotHeaderTitleText',
      '#toggle-holder': 'toggleHolder',
      '.pivot-box#filters > ul, .pivot-box#columns > ul, .pivot-box#rows > ul, .pivot-box#values > ul': 'pivotBoxLists',
      '.pivot-box#filters, .pivot-box#columns, .pivot-box#rows, .pivot-box#values': 'pivotBoxes',
      '.pivot-box#fields > ul': 'fieldsList',
      '#pivot-default-message': 'pivotDefaultMessage'
    };

    RedesignPivotSettings.prototype.events = {
      'click .title #cancel-icon': 'cancel',
      'click .title #reset-link': 'resetDefaults',
      'click #values .field, #filters .field': 'fieldClicked',
      'click .func.dropdown, .type.dropdown': 'dropdownClicked',
      'keyup .filter-options .filter-value': 'setTwiddlesAndRender',
      'click .type-list .currency li': 'selectValueCurrency',
      'click .func-list .func-option': 'funcOptionClicked',
      'click .type-list .func-option': 'typeOptionClicked'
    };

    RedesignPivotSettings.TYPE_TO_FUNCS = {
      numeric: {
        aggregations: ['sum', 'count', 'average', 'min', 'max'],
        comparisons: ['>', '<', '==', '!=', '>=', '<=']
      },
      raw: {
        aggregations: ['count'],
        comparisons: ['equals', 'does not equal', 'contains', 'begins with', 'ends with']
      },
      datetime: {
        aggregations: ['count', 'min', 'max'],
        comparisons: ['365 Days', '180 Days', '90 Days', '60 Days', '30 Days', '14 Days', '7 Days', '3 Days', '1 Day']
      }
    };

    RedesignPivotSettings.PIVOT_SETTINGS_HEIGHT = 540;

    RedesignPivotSettings.PIVOT_SETTINGS_WIDTH = 400;

    RedesignPivotSettings.DEFAULT_SETTINGS_MESSAGE = "to <span id='keyword'>everyone</span>";

    RedesignPivotSettings.USER_SETTINGS_MESSAGE = "only to <span id='keyword'>you</span>";

    function RedesignPivotSettings() {
      this.pivotListScrolled = bind(this.pivotListScrolled, this);
      this.clearCurrency = bind(this.clearCurrency, this);
      this.selectValueCurrency = bind(this.selectValueCurrency, this);
      this.closeAllDropdowns = bind(this.closeAllDropdowns, this);
      this.typeOptionClicked = bind(this.typeOptionClicked, this);
      this.funcOptionClicked = bind(this.funcOptionClicked, this);
      this.maybeUpdateUwv = bind(this.maybeUpdateUwv, this);
      this.save = bind(this.save, this);
      this.cancel = bind(this.cancel, this);
      this.pivotSettingsClicked = bind(this.pivotSettingsClicked, this);
      this.updatePivotMessage = bind(this.updatePivotMessage, this);
      this.updateCurrentPivotSettings = bind(this.updateCurrentPivotSettings, this);
      this.getSettingsFromName = bind(this.getSettingsFromName, this);
      this.getFieldNamesFromPivotBox = bind(this.getFieldNamesFromPivotBox, this);
      this.setTwiddlesAndRender = bind(this.setTwiddlesAndRender, this);
      this.dropField = bind(this.dropField, this);
      this.pickupField = bind(this.pickupField, this);
      this.dropIntoFields = bind(this.dropIntoFields, this);
      this.handleToggle = bind(this.handleToggle, this);
      RedesignPivotSettings.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'columns', 'widget', 'widgetContainer', 'columnsToType');
      this.currentPivotSettings = {};
      this.uwv = App.UserWidgetView.findByWidget(this.widget);
      this.uwv.save_pivot_settings = false;
      App.UserWidgetView.bind('create', this.maybeUpdateUwv);
      this.saveUwv = false;
      this.render();
      $('body').on('click', this.cancel);
      this.el.on('click', this.pivotSettingsClicked);
      this.$('.pivot-list').on('scroll', this.pivotListScrolled);
      this.widgetContainer.on('click', this.pivotSettingsClicked);
      App.HotkeyManager.disable();
    }

    RedesignPivotSettings.prototype.release = function() {
      RedesignPivotSettings.__super__.release.apply(this, arguments);
      $('body').off('click', this.cancel);
      App.UserWidgetView.unbind('create', this.maybeUpdateUwv);
      this.el.off('click', this.pivotSettingsClicked);
      this.widgetContainer.off('click', this.pivotSettingsClicked);
      return App.HotkeyManager.enable();
    };

    RedesignPivotSettings.prototype.render = function() {
      var inEditron, settingsMessage;
      inEditron = AppRedesign.current().currentState === AppRedesign.IN_EDITRON;
      this.html(this.view("redesign/widgets/pivot_settings")({
        inEditron: inEditron,
        redesign: true
      }));
      this.refreshElements();
      this.showAllFields();
      this.setFieldsAndRender();
      this.updatePivotMessage();
      this.updateAllSelectedTexts();
      this.updateCheckMarks();
      if (inEditron) {
        this.defaultToggler = new App.Toggler({
          togglerClass: 'square',
          isToggleOn: this.uwv.save_pivot_settings
        }).bind('toggled', this.handleToggle);
        this.toggleHolder.append(this.defaultToggler.el);
        settingsMessage = this.uwv.save_pivot_settings ? this.constructor.DEFAULT_SETTINGS_MESSAGE : this.constructor.USER_SETTINGS_MESSAGE;
        return this.pivotDefaultMessage.html(settingsMessage);
      }
    };

    RedesignPivotSettings.prototype.handleToggle = function(state) {
      this.uwv.save_pivot_settings = state;
      if (this.defaultToggler.isToggleOn) {
        this.pivotDefaultMessage.html(this.constructor.DEFAULT_SETTINGS_MESSAGE);
        this.pivotHeaderTitleText.text('Default Pivot Settings');
      } else {
        this.pivotDefaultMessage.html(this.constructor.USER_SETTINGS_MESSAGE);
        this.pivotHeaderTitleText.text('My Pivot Settings');
      }
      this.pivotDefaultMessage.toggleClass('default', this.uwv.save_pivot_settings);
      return this.uwv.save({
        ajax: false
      });
    };

    RedesignPivotSettings.prototype.setTwiddlesFromUWV = function() {
      this.twiddles = App.TwiddleMap.readWrite(this.uwv.twiddles);
      return this.currentPivotSettings = this.getSettingsFromTwiddles(this.twiddles);
    };

    RedesignPivotSettings.prototype.setFieldsAndRender = function() {
      this.setTwiddlesFromUWV();
      this.renderAppliedPivots();
      return this.makeDraggable();
    };

    RedesignPivotSettings.prototype.showAllFields = function() {
      var column, i, len, ref, results;
      ref = this.columns;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        results.push(this.appendField($(this.fieldsList), column));
      }
      return results;
    };

    RedesignPivotSettings.prototype.updateCheckMarks = function() {
      var boxName, field, fieldName, fieldWrapperEl, fields, i, len, ref, ref1, results;
      ref = this.fieldsList.children();
      for (i = 0, len = ref.length; i < len; i++) {
        fieldWrapperEl = ref[i];
        this.hideCheckMark($(fieldWrapperEl));
      }
      ref1 = this.currentPivotSettings;
      results = [];
      for (boxName in ref1) {
        fields = ref1[boxName];
        results.push((function() {
          var j, len1, results1;
          results1 = [];
          for (j = 0, len1 = fields.length; j < len1; j++) {
            field = fields[j];
            fieldName = this.getFieldName(field);
            results1.push(this.showCheckMark(fieldName));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RedesignPivotSettings.prototype.showCheckMark = function(columnName) {
      var checkMark, columnFieldEl, columnNameSelector;
      columnNameSelector = '.field-wrapper[column="' + columnName + '"] .field';
      columnFieldEl = $(this.fieldsList).find(columnNameSelector);
      checkMark = columnFieldEl.find('#field-used-check');
      if (checkMark.length) {
        return checkMark.show();
      } else {
        return columnFieldEl.append("<div id='field-used-check'></div>");
      }
    };

    RedesignPivotSettings.prototype.hideCheckMark = function(fieldWrapperEl) {
      var checkEl;
      checkEl = fieldWrapperEl.find('#field-used-check');
      return checkEl.hide();
    };

    RedesignPivotSettings.prototype.makeDraggable = function() {
      this.el.draggable({
        handle: this.pivotHeaderTitle
      });
      this.pivotBoxLists.sortable({
        connectWith: '.pivot-box ul.pivot-list',
        start: this.pickupField,
        stop: this.dropField,
        cursorAt: {
          top: 8,
          left: 8
        },
        items: ".field-wrapper"
      }).droppable({
        greedy: true
      });
      this.fieldsList.children().draggable({
        helper: "clone",
        start: this.pickupField,
        connectToSortable: '.pivot-box ul.pivot-list',
        cursorAt: {
          top: 8,
          left: 8
        }
      });
      return this.fieldsList.droppable({
        drop: this.dropIntoFields
      });
    };

    RedesignPivotSettings.prototype.dropIntoFields = function(evt, ui) {
      if (this.dropTargetIs(ui, 'fields')) {
        return;
      }
      $(ui.draggable).remove();
      return this.updateCheckMarks();
    };

    RedesignPivotSettings.prototype.dropTargetIs = function(ui, pivotBox) {
      var fieldHandle;
      fieldHandle = pivotBox === 'fields' ? $(ui.draggable) : $(ui.item[0]);
      return fieldHandle.closest('.pivot-box').attr('id') === pivotBox;
    };

    RedesignPivotSettings.prototype.valueFormatTwiddleToFuncName = function(valueFormat) {
      switch (valueFormat) {
        case 'percent_of_column':
          return '% of column';
        case 'percent_of_row':
          return '% of row';
        case 'percent':
          return 'Percentage';
        default:
          return valueFormat.humanize();
      }
    };

    RedesignPivotSettings.prototype.getSettingsFromTwiddles = function(twiddles) {
      var filterColumn, filters, i, j, len, len1, ref, ref1, settings, valueColumn, values;
      settings = {};
      if (this.twiddles == null) {
        return settings;
      }
      filters = [];
      ref = twiddles.getArray('filter_columns');
      for (i = 0, len = ref.length; i < len; i++) {
        filterColumn = ref[i];
        filters.push({
          name: filterColumn.column_name,
          condition: filterColumn.column_filter_condition,
          value: filterColumn.column_filter_value
        });
      }
      settings['filters'] = filters;
      if (this.twiddles.get('use_pivot_settings') === false) {
        return settings;
      }
      settings['rows'] = twiddles.getArray('point_cols');
      settings['columns'] = twiddles.getArray('segment_column');
      values = [];
      ref1 = twiddles.getArray('value_columns');
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        valueColumn = ref1[j];
        values.push({
          name: valueColumn.column_name,
          format: valueColumn.column_value_format,
          aggregation: valueColumn.column_value_aggregation,
          currency: valueColumn.column_currency
        });
      }
      settings['values'] = values;
      return settings;
    };

    RedesignPivotSettings.prototype.renderAppliedPivots = function() {
      var field, i, len, pivotBox, ref, results, settings;
      settings = this.currentPivotSettings;
      if (Object.keys(settings).length === 0) {
        return;
      }
      ref = this.pivotBoxLists;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        pivotBox = ref[i];
        pivotBox = $(pivotBox);
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = settings[pivotBox.closest('.pivot-box').attr('id')] || [];
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            field = ref1[j];
            results1.push(this.appendField(pivotBox, field));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    RedesignPivotSettings.prototype.availableFuncsForColumn = function(columnName) {
      var columnType;
      columnType = this.columnsToType[columnName] || 'raw';
      return App.RedesignPivotSettings.TYPE_TO_FUNCS[columnType];
    };

    RedesignPivotSettings.prototype.hideInputBox = function(fieldWrapperEl) {
      var inputBoxEl;
      inputBoxEl = fieldWrapperEl.find('input.filter-value');
      return inputBoxEl.hide();
    };

    RedesignPivotSettings.prototype.getFieldName = function(field) {
      if (typeof field === 'object') {
        return field.name;
      } else {
        return field;
      }
    };

    RedesignPivotSettings.prototype.appendField = function(pivotBoxList, field) {
      var availableFuncs, currencyDropdown, fieldName, fieldWrapperEl, filterFuncDropdown, selectedFilterFunc, selectedValueFunc, valueFuncDropdown, valueTypeDropdown;
      fieldName = this.getFieldName(field);
      if (indexOf.call(this.columns, fieldName) < 0) {
        return;
      }
      availableFuncs = this.availableFuncsForColumn(fieldName);
      selectedFilterFunc = field.condition;
      selectedValueFunc = field.aggregation;
      if (selectedFilterFunc == null) {
        selectedFilterFunc = availableFuncs['comparisons'][0];
      }
      if (selectedValueFunc == null) {
        selectedValueFunc = availableFuncs.aggregations[0];
      }
      fieldWrapperEl = $(this.view("widgets/pivot_field")({
        column: fieldName,
        availableFuncs: availableFuncs,
        selectedFilter: field.value,
        selectedValue: this.valueFormatTwiddleToFuncName(field.format || "Number"),
        selectedFilterFunc: selectedFilterFunc,
        selectedValueFunc: selectedValueFunc.humanize()
      }));
      if (this.columnsToType[fieldName] === 'datetime') {
        this.hideInputBox(fieldWrapperEl);
      }
      filterFuncDropdown = fieldWrapperEl.find('.filter-options .func.dropdown');
      valueFuncDropdown = fieldWrapperEl.find('.value-options .func.dropdown');
      valueTypeDropdown = fieldWrapperEl.find('.value-options .type.dropdown');
      currencyDropdown = fieldWrapperEl.find('.currency-dropdown');
      filterFuncDropdown.data('selectedFunc', selectedFilterFunc);
      valueFuncDropdown.data('selectedFunc', selectedValueFunc);
      valueTypeDropdown.data('selectedFormat', field.format);
      currencyDropdown.data('selectedCurrency', field.currency);
      return pivotBoxList.append(fieldWrapperEl);
    };

    RedesignPivotSettings.prototype.pickupField = function(evt, ui) {
      var fieldWrapperEl;
      this.closeAllDropdowns();
      fieldWrapperEl = $(ui.item);
      if (fieldWrapperEl.hasClass('open')) {
        fieldWrapperEl.removeClass('open');
      }
      fieldWrapperEl.find('.open').removeClass('open');
      fieldWrapperEl.css({
        'width': 'inherit',
        'height': 'auto'
      });
      this.resetFieldName(fieldWrapperEl);
      return this.hideCheckMark(ui.helper);
    };

    RedesignPivotSettings.prototype.resetFieldName = function(fieldWrapperEl) {
      var columnName;
      columnName = fieldWrapperEl.attr('column');
      return fieldWrapperEl.find('.field > span').text(columnName);
    };

    RedesignPivotSettings.prototype.dropField = function(evt, ui) {
      var fieldWrapperEl;
      fieldWrapperEl = ui.item;
      if (this.dropTargetIs(ui, 'values')) {
        this.setSelectedAggregation(fieldWrapperEl);
      }
      fieldWrapperEl.css({
        'width': 'inherit',
        'height': 'auto'
      });
      this.setTwiddlesAndRender();
      return this.updateCheckMarks();
    };

    RedesignPivotSettings.prototype.setSelectedAggregation = function(fieldWrapperEl) {
      var assignedAggregation, availableAggregations, availableFuncs, columnName, dropdown, funcOption, selectedAggregations, sibling;
      columnName = fieldWrapperEl.attr('column');
      selectedAggregations = (function() {
        var i, len, ref, results;
        ref = fieldWrapperEl.siblings("[column=\"" + columnName + "\"]");
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          sibling = ref[i];
          results.push($(sibling).find('.value-options .func.dropdown').data('selectedFunc'));
        }
        return results;
      })();
      availableFuncs = this.availableFuncsForColumn(columnName);
      availableAggregations = availableFuncs.aggregations.withoutAny(selectedAggregations);
      if (availableAggregations.length > 0) {
        assignedAggregation = fieldWrapperEl.find('.value-options .func.dropdown').data('selectedFunc');
        if (assignedAggregation == null) {
          assignedAggregation = availableAggregations[0];
        }
        funcOption = fieldWrapperEl.find(".value-options .func-option[data-func-type=" + assignedAggregation + "]");
        dropdown = fieldWrapperEl.find('.value-options .func.dropdown');
        this.setDropdownSelection(dropdown, funcOption.text(), 'selectedFunc', funcOption.data('funcType'));
        this.updateSelectedText(fieldWrapperEl);
        return dropdown.data('selectedFunc', assignedAggregation);
      } else {
        return fieldWrapperEl.remove();
      }
    };

    RedesignPivotSettings.prototype.updateAllSelectedTexts = function() {
      var fieldWrapperEl, i, len, ref, results;
      ref = this.el.find('.field-wrapper');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        fieldWrapperEl = ref[i];
        results.push(this.updateSelectedText($(fieldWrapperEl)));
      }
      return results;
    };

    RedesignPivotSettings.prototype.updateSelectedText = function(fieldWrapperEl) {
      var pivotBoxName, selectedText;
      pivotBoxName = fieldWrapperEl.closest('.pivot-box').attr('id');
      if (pivotBoxName !== 'filters' && pivotBoxName !== 'values') {
        return;
      }
      selectedText = pivotBoxName === "values" ? this.getValueAggregationText(fieldWrapperEl) : this.getFilterConditionText(fieldWrapperEl);
      fieldWrapperEl.attr('selectedText', selectedText);
      return fieldWrapperEl.find('.field > span').text(selectedText);
    };

    RedesignPivotSettings.prototype.getFilterConditionText = function(fieldWrapperEl) {
      var columnName, comparisonValue, filterFunc;
      columnName = fieldWrapperEl.attr('column');
      filterFunc = fieldWrapperEl.find('.filter-options .func.dropdown #selected').text().trim().toLowerCase();
      comparisonValue = fieldWrapperEl.find('.filter-value').val().trim();
      if (!((comparisonValue != null ? comparisonValue.length : void 0) > 0)) {
        return columnName;
      }
      return columnName + " " + filterFunc + " " + comparisonValue;
    };

    RedesignPivotSettings.prototype.getValueAggregationText = function(fieldWrapperEl) {
      var aggregationFunc, columnName;
      columnName = fieldWrapperEl.attr('column');
      aggregationFunc = fieldWrapperEl.find('.value-options .func.dropdown #selected').text().trim().humanize();
      return aggregationFunc + " of " + columnName;
    };

    RedesignPivotSettings.prototype.isPivotedTable = function() {
      var i, len, pivotBox, pivotSettings;
      pivotSettings = ['rows', 'columns', 'values'];
      for (i = 0, len = pivotSettings.length; i < len; i++) {
        pivotBox = pivotSettings[i];
        if (!App.Utils.emptyArray(this.currentPivotSettings[pivotBox])) {
          return true;
        }
      }
      return false;
    };

    RedesignPivotSettings.prototype.setTwiddle = function(twiddle, value) {
      var prefixedTwiddle;
      prefixedTwiddle = 'twiddle_' + twiddle;
      return this.twiddles.setWithOverride(prefixedTwiddle, value);
    };

    RedesignPivotSettings.prototype.updateChartType = function() {
      var chartType, hideLineNumbers, isPivot, noCohortColor;
      isPivot = this.isPivotedTable();
      chartType = isPivot ? 'cohort' : 'table';
      this.setTwiddle('chart_type', chartType);
      this.setTwiddle('use_pivot_settings', isPivot);
      noCohortColor = isPivot || this.widget.getTwiddle('twiddle_no_cohort_color');
      this.setTwiddle('no_cohort_color', noCohortColor);
      hideLineNumbers = isPivot || this.widget.getTwiddle('twiddle_table_line_numbers');
      return this.setTwiddle('table_line_numbers', hideLineNumbers);
    };

    RedesignPivotSettings.prototype.setTwiddlesAndRender = function() {
      var filterColumns, filterProperties, filterProperty, i, j, len, len1, save_pivot_settings, valueColumns, valueProperties, valueProperty;
      this.saveUwv = true;
      this.updateCurrentPivotSettings();
      this.updateChartType();
      this.updatePivotMessage();
      this.setTwiddle('point_cols', this.getFieldNamesFromPivotBox('rows'));
      this.setTwiddle('segment_column', this.getFieldNamesFromPivotBox('columns'));
      valueProperties = this.currentPivotSettings.values;
      valueColumns = [];
      for (i = 0, len = valueProperties.length; i < len; i++) {
        valueProperty = valueProperties[i];
        valueColumns.push({
          column_name: valueProperty.name,
          column_value_format: valueProperty.format,
          column_value_aggregation: valueProperty.aggregation,
          column_currency: valueProperty.currency
        });
      }
      this.setTwiddle('value_columns', valueColumns);
      filterProperties = this.currentPivotSettings['filters'];
      filterColumns = [];
      for (j = 0, len1 = filterProperties.length; j < len1; j++) {
        filterProperty = filterProperties[j];
        filterColumns.push({
          column_name: filterProperty.name,
          column_filter_condition: filterProperty.condition,
          column_filter_value: filterProperty.value
        });
      }
      this.setTwiddle('filter_columns', filterColumns);
      save_pivot_settings = this.uwv.save_pivot_settings;
      if (this.hasClientWidget()) {
        this.uwv.reload();
        this.uwv.save_pivot_settings = save_pivot_settings;
      }
      this.uwv.twiddles = this.twiddles.twiddles;
      this.save();
      return this.widget.trigger('changed-uwv', this.uwv);
    };

    RedesignPivotSettings.prototype.getFieldNamesFromPivotBox = function(pivotBoxName) {
      return this.currentPivotSettings[pivotBoxName].map(function(field) {
        return field.name;
      });
    };

    RedesignPivotSettings.prototype.getSettingsFromName = function(properties, column) {
      return _(properties).find(function(property) {
        return property.name === column;
      });
    };

    RedesignPivotSettings.prototype.updateCurrentPivotSettings = function() {
      var field, fieldInfo, fields, i, j, len, len1, pivotBox, pivotBoxName, ref, ref1, settings;
      settings = {};
      ref = this.pivotBoxes;
      for (i = 0, len = ref.length; i < len; i++) {
        pivotBox = ref[i];
        pivotBoxName = $(pivotBox).attr('id');
        fields = [];
        ref1 = this.$(pivotBox).find('.pivot-list').find('.field-wrapper');
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          field = ref1[j];
          fieldInfo = (function() {
            switch (pivotBoxName) {
              case 'values':
                return this.valuesFieldInfo(field);
              case 'filters':
                return this.filtersFieldInfo(field);
              default:
                return {
                  name: $(field).attr('column')
                };
            }
          }).call(this);
          if (fieldInfo.name != null) {
            fields.push(fieldInfo);
          }
        }
        settings[pivotBoxName] = fields;
      }
      return this.currentPivotSettings = settings;
    };

    RedesignPivotSettings.prototype.updatePivotMessage = function() {
      var i, len, pivotBox, ref, results;
      ref = this.pivotBoxes;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        pivotBox = ref[i];
        if ($(pivotBox).find('.field-wrapper').length > 0) {
          results.push($(pivotBox).find('.pivot-box-message').hide());
        } else {
          results.push($(pivotBox).find('.pivot-box-message').show());
        }
      }
      return results;
    };

    RedesignPivotSettings.prototype.valuesFieldInfo = function(field) {
      var fieldWrapper;
      fieldWrapper = this.$(field);
      return {
        name: fieldWrapper.attr('column'),
        aggregation: fieldWrapper.find('.value-options .func.dropdown').data('selectedFunc'),
        format: fieldWrapper.find('.value-options .type.dropdown').data('selectedFormat'),
        currency: fieldWrapper.find('.currency-dropdown').data('selectedCurrency')
      };
    };

    RedesignPivotSettings.prototype.filtersFieldInfo = function(field) {
      return {
        name: this.$(field).attr('column'),
        condition: this.$(field).find('.filter-options .func.dropdown').data('selectedFunc'),
        value: this.$(field).find('.filter-value').val()
      };
    };

    RedesignPivotSettings.prototype.clearSettings = function() {
      var fields, i, len, pivotBox, ref, results;
      ref = this.pivotBoxLists;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        pivotBox = ref[i];
        fields = $(pivotBox).children('.field-wrapper');
        results.push(fields.remove());
      }
      return results;
    };

    RedesignPivotSettings.prototype.pivotSettingsClicked = function(evt) {
      if ($(evt.target).closest('.edit.button').length >= 1) {
        return;
      }
      evt.stopPropagation();
      return this.el.find('.dropdown.open').removeClass('open');
    };

    RedesignPivotSettings.prototype.cancel = function() {
      return this.trigger('close-pivot-settings');
    };

    RedesignPivotSettings.prototype.hasClientWidget = function() {
      return isNaN(parseFloat(this.uwv.widget_id));
    };

    RedesignPivotSettings.prototype.save = function(onExit) {
      if (onExit == null) {
        onExit = false;
      }
      if (!this.saveUwv) {
        return;
      }
      if ((onExit || !this.hasClientWidget()) && isNaN(this.uwv.id)) {
        delete Object.getPrototypeOf(this.uwv).id;
        delete this.uwv.id;
      }
      this.uwv.save({
        ajax: onExit
      });
      if (onExit) {
        return App.UserWidgetView.unbind('create', this.maybeUpdateUwv);
      }
    };

    RedesignPivotSettings.prototype.maybeUpdateUwv = function(uwv) {
      var save_pivot_settings, twiddles;
      if (!isNaN(this.uwv.id)) {
        return;
      }
      twiddles = jQuery.extend({}, this.uwv.twiddles);
      save_pivot_settings = this.uwv.save_pivot_settings;
      if (uwv.widget_id === this.widget.id && !(uwv.id === this.uwv.id)) {
        this.uwv.destroy();
        this.uwv = uwv;
        this.uwv.twiddles = twiddles;
        this.uwv.save_pivot_settings = save_pivot_settings;
        return App.UserWidgetView.unbind('create', this.maybeUpdateUwv);
      }
    };

    RedesignPivotSettings.prototype.fieldClicked = function(event) {
      var content, field, fieldWrapperEl, options, pivotBox, wrapper;
      content = $(event.currentTarget);
      field = content.closest('.field');
      pivotBox = field.closest('.pivot-box').attr('id');
      wrapper = field.closest('.field-wrapper');
      if (pivotBox === 'filters') {
        options = wrapper.children('.filter-options');
      }
      if (pivotBox === 'values') {
        options = wrapper.children('.value-options');
      }
      if (options) {
        options.toggleClass('open');
      }
      fieldWrapperEl = field.closest('.field-wrapper');
      fieldWrapperEl.toggleClass('open');
      if (fieldWrapperEl.hasClass('open')) {
        return field.children('span').text(fieldWrapperEl.attr('column'));
      } else {
        return this.updateSelectedText(fieldWrapperEl);
      }
    };

    RedesignPivotSettings.prototype.resetDefaults = function() {
      this.clearSettings();
      this.uwv.setDefaultsFromWidget(this.widget);
      this.setFieldsAndRender();
      this.updatePivotMessage();
      this.setTwiddlesAndRender();
      this.updateAllSelectedTexts();
      return this.updateCheckMarks();
    };

    RedesignPivotSettings.prototype.closeDropdown = function(dropEl) {
      dropEl.removeClass('open');
      return dropEl.closest('.details').removeClass('open');
    };

    RedesignPivotSettings.prototype.setDropdownSelection = function(dropEl, selectedText, dataType, selectedData) {
      dropEl.data(dataType, selectedData);
      return dropEl.find('#selected').text(selectedText);
    };

    RedesignPivotSettings.prototype.funcOptionClicked = function(event) {
      var dropdown, funcOption;
      event.stopPropagation();
      funcOption = $(event.currentTarget);
      dropdown = funcOption.closest('.func.dropdown');
      this.closeDropdown(dropdown);
      this.setDropdownSelection(dropdown, funcOption.text(), 'selectedFunc', funcOption.data('funcType'));
      return this.setTwiddlesAndRender();
    };

    RedesignPivotSettings.prototype.typeOptionClicked = function(event) {
      var dropdown, funcOption;
      event.stopPropagation();
      funcOption = $(event.currentTarget);
      dropdown = funcOption.closest('.type.dropdown');
      this.closeDropdown(dropdown);
      this.setDropdownSelection(dropdown, funcOption.data('funcName'), 'selectedFormat', funcOption.data('funcType'));
      return this.setTwiddlesAndRender();
    };

    RedesignPivotSettings.prototype.dropdownClicked = function(event) {
      var currentDetails, dropdown, fieldWrapper;
      event.stopPropagation();
      dropdown = $(event.currentTarget);
      dropdown.toggleClass('open');
      this.closeOtherDropdowns(dropdown);
      if (AppRedesign.current().getCurrentState() === AppRedesign.IN_EDITRON) {
        dropdown.addClass('dark-theme');
      }
      currentDetails = dropdown.find('.details');
      fieldWrapper = currentDetails.closest('.field-wrapper');
      return currentDetails.css({
        'width': fieldWrapper.outerWidth(),
        'top': fieldWrapper.position().top + fieldWrapper.height() - 5,
        'left': fieldWrapper.position().left + 7
      });
    };

    RedesignPivotSettings.prototype.closeOtherDropdowns = function(currentEl) {
      var fieldWrapper;
      currentEl.siblings('.open').removeClass('open');
      fieldWrapper = currentEl.closest('.field-wrapper');
      return fieldWrapper.siblings().find('.dropdown.open').removeClass('open');
    };

    RedesignPivotSettings.prototype.closeAllDropdowns = function() {
      return this.$('.dropdown').removeClass('open');
    };

    RedesignPivotSettings.prototype.selectValueCurrency = function(event) {
      var currencyDropdown, selectedCurrency;
      selectedCurrency = $(event.currentTarget);
      currencyDropdown = selectedCurrency.closest('.currency-dropdown');
      this.clearCurrency(currencyDropdown);
      selectedCurrency.addClass('selected-currency');
      return currencyDropdown.data('selectedCurrency', selectedCurrency.text());
    };

    RedesignPivotSettings.prototype.clearCurrency = function(currencyDropdown) {
      if ((currencyDropdown != null ? currencyDropdown.find : void 0) == null) {
        return;
      }
      return currencyDropdown.find('ul.currency li').removeClass('selected-currency');
    };

    RedesignPivotSettings.prototype.pivotListScrolled = function(event) {
      return $(event.currentTarget).find('.dropdown.open').removeClass('open');
    };

    return RedesignPivotSettings;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignQueryQueueController = (function(superClass) {
    extend(RedesignQueryQueueController, superClass);

    RedesignQueryQueueController.APPLIES_TO_ALL_SPACES = false;

    RedesignQueryQueueController.TITLE = 'Query Management';

    RedesignQueryQueueController.prototype.className = 'site-settings settings-area';

    RedesignQueryQueueController.prototype.elements = {
      '.query-queue': 'queryQueueContainer'
    };

    function RedesignQueryQueueController() {
      RedesignQueryQueueController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/settings/query_queue')());
      this.showQueryQueue();
    }

    RedesignQueryQueueController.prototype.showQueryQueue = function() {
      App.Utils.logFeature("query-management-tab-opened");
      return this.reactRoot = window.reactApp.queryQueueRoot(this.queryQueueContainer[0], this.cloneSpineDatabases());
    };

    RedesignQueryQueueController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return RedesignQueryQueueController.__super__.release.apply(this, arguments);
    };

    RedesignQueryQueueController.prototype.cloneSpineDatabases = function() {
      return App.Database.recordsValues().map(function(db) {
        return db.attributes();
      });
    };

    return RedesignQueryQueueController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsAccountController = (function(superClass) {
    extend(RedesignSettingsAccountController, superClass);

    RedesignSettingsAccountController.APPLIES_TO_ALL_SPACES = true;

    RedesignSettingsAccountController.TITLE = 'Profile';

    RedesignSettingsAccountController.prototype.className = 'my-account settings-area';

    RedesignSettingsAccountController.prototype.elements = {
      '.account-credentials .area-body': 'accountCredentialsBody',
      '.tfa .area-body': 'tfaBody',
      '.switch-site': 'switchSiteArea',
      '.switch-site .area-body': 'switchSiteAreaBody',
      '.logout .area-body': 'logoutArea'
    };

    function RedesignSettingsAccountController() {
      this.userUpdated = bind(this.userUpdated, this);
      this.isMultiSiteUser = bind(this.isMultiSiteUser, this);
      RedesignSettingsAccountController.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/settings/my_account_panel')());
      this.currentUser = App.User.currentUser();
      this.createChildControllers();
      if (!this.isMultiSiteUser()) {
        this.hideSwitchSiteArea();
      }
      this.currentUser.bind('update refresh', this.userUpdated);
    }

    RedesignSettingsAccountController.prototype.isMultiSiteUser = function() {
      var currSite, familySiteIds, sitesWithoutSpaces;
      currSite = App.Site.first();
      familySiteIds = currSite.site_info_list.map(function(site) {
        return site.id;
      });
      sitesWithoutSpaces = _.reject(App.User.currentUser().allSites(), function(site) {
        return site.id !== currSite.id && familySiteIds.includes(site.id);
      });
      return sitesWithoutSpaces.length > 1;
    };

    RedesignSettingsAccountController.prototype.createChildControllers = function() {
      this.twoFactorController = new App.RedesignSettingsMenuProfileTwoFactorController({
        el: this.tfaBody
      });
      this.profileController = new App.RedesignSettingsMenuProfileUpdateController({
        el: this.accountCredentialsBody
      });
      this.signoutController = new App.SettingsMenuProfileSignoutController({
        el: this.logoutArea
      });
      if (this.isMultiSiteUser()) {
        return this.switchSiteController = new App.SettingsMenuProfileSwitchSiteController({
          el: this.switchSiteAreaBody
        });
      }
    };

    RedesignSettingsAccountController.prototype.userUpdated = function() {
      return this.currentUser.reload();
    };

    RedesignSettingsAccountController.prototype.hideSwitchSiteArea = function() {
      var switchSitePanel;
      this.switchSiteArea.hide();
      switchSitePanel = this.switchSiteArea.parent();
      return switchSitePanel.css('display', 'none');
    };

    RedesignSettingsAccountController.prototype.release = function() {
      var ref, ref1, ref2, ref3;
      this.currentUser.unbind('update', this.userUpdated);
      this.currentUser.unbind('refresh', this.userUpdated);
      if ((ref = this.profileController) != null) {
        ref.release();
      }
      if ((ref1 = this.twoFactorController) != null) {
        ref1.release();
      }
      if ((ref2 = this.switchSiteController) != null) {
        ref2.release();
      }
      if ((ref3 = this.signoutController) != null) {
        ref3.release();
      }
      return RedesignSettingsAccountController.__super__.release.apply(this, arguments);
    };

    return RedesignSettingsAccountController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsApiKey = (function(superClass) {
    extend(RedesignSettingsApiKey, superClass);

    RedesignSettingsApiKey.prototype.elements = {
      '.site-specific .api-key-input': 'siteApiKeyInput',
      '.site-selector-row': 'siteSelectorRow',
      '.site-selector-for-api-key': 'siteSelectorForApiKey'
    };

    RedesignSettingsApiKey.prototype.events = {
      'click .about-api-link': 'aboutApiClick',
      'click .user-api-key-regenerate-button': 'regenerateUserApiKey',
      'change .site-selector-for-api-key': 'updatedSiteSelection'
    };

    function RedesignSettingsApiKey() {
      this.usakEnabled = bind(this.usakEnabled, this);
      this.siteSpecificApiKey = bind(this.siteSpecificApiKey, this);
      this.updatedSiteSelection = bind(this.updatedSiteSelection, this);
      this.siteOptions = bind(this.siteOptions, this);
      this.aboutApiClick = bind(this.aboutApiClick, this);
      this.showUserKeyPopup = bind(this.showUserKeyPopup, this);
      this.regenerateUserApiKey = bind(this.regenerateUserApiKey, this);
      RedesignSettingsApiKey.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.site = App.Site.first();
      this.render();
      if (this.siteSpecificApiKey()) {
        this.siteApiKeyInput.val(this.site.api_key);
        if (this.site.isSpacesEnabled()) {
          if (this.site.hasMultipleSitesInFamily()) {
            this.siteSelectorRow.show();
            this.siteSelectorForApiKey.html(App.Utils.optionsToHtml(this.siteOptions(), this.site.id));
            this.siteSelectorForApiKey.chosen({
              width: '100%',
              disable_search: true
            });
          }
        } else {
          this.siteSelectorRow.hide();
        }
      }
    }

    RedesignSettingsApiKey.prototype.render = function() {
      return this.html(this.view('redesign/settings/site_settings_api_key')({
        siteSpecificApiKey: this.siteSpecificApiKey(),
        userSpecificApiKey: this.usakEnabled()
      }));
    };

    RedesignSettingsApiKey.prototype.regenerateUserApiKey = function() {
      return new App.UserApiKeyConfirmationModalController({
        proceedCallback: this.showUserKeyPopup
      });
    };

    RedesignSettingsApiKey.prototype.showUserKeyPopup = function(loaderContext) {
      return jQuery.post("/user_api_keys/regenerate", {
        site_id: this.site.id
      }).done((function(_this) {
        return function(r) {
          return new App.UserApiKeyGeneratedModalController({
            apiKey: r.api_key
          });
        };
      })(this)).fail((function(_this) {
        return function(e) {
          return console.error('Failed to generate new User API Key', e);
        };
      })(this));
    };

    RedesignSettingsApiKey.prototype.aboutApiClick = function() {
      return window.open(AppRedesign.DOC_PATH + '/embed-api');
    };

    RedesignSettingsApiKey.prototype.siteOptions = function() {
      return this.site.site_info_list.map(function(site) {
        return {
          value: site.id,
          name: site.display_name
        };
      });
    };

    RedesignSettingsApiKey.prototype.updatedSiteSelection = function() {
      var i, len, ref, selectedSiteId, site_info;
      selectedSiteId = Number(this.siteSelectorForApiKey.val());
      ref = this.site.site_info_list;
      for (i = 0, len = ref.length; i < len; i++) {
        site_info = ref[i];
        if (site_info.id === selectedSiteId) {
          this.siteApiKeyInput.val(site_info.api_key);
          return;
        }
      }
    };

    RedesignSettingsApiKey.prototype.siteSpecificApiKey = function() {
      if (this.usakEnabled()) {
        return !this.site.only_user_specific_api_keys_enabled;
      } else {
        return true;
      }
    };

    RedesignSettingsApiKey.prototype.usakEnabled = function() {
      return this.site.user_specific_api_keys_feature_flag_enabled;
    };

    return RedesignSettingsApiKey;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsAuthentication = (function(superClass) {
    extend(RedesignSettingsAuthentication, superClass);

    RedesignSettingsAuthentication.prototype.elements = {
      '.api-key-form': 'apiKeyForm',
      '.sso-form': 'ssoForm',
      '.slack-form': 'slackForm',
      '.two-factor-form': 'twoFactorFormEl',
      '.update.button': 'updateButton',
      '.sso-label': 'ssoLabel'
    };

    RedesignSettingsAuthentication.prototype.events = {
      'click .about-tfa-link': 'aboutTfaClick',
      'click .about-slack-link': 'aboutSlackClick'
    };

    function RedesignSettingsAuthentication() {
      this.aboutSlackClick = bind(this.aboutSlackClick, this);
      this.aboutTfaClick = bind(this.aboutTfaClick, this);
      RedesignSettingsAuthentication.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('redesign/settings/site_settings_authentication')({
        slackEnabled: this.slackEnabled()
      }));
      this.apiKeyFormController = new App.RedesignSettingsApiKey({
        el: this.apiKeyForm
      });
      this.ssoFormController = new App.RedesignSettingsSsoConfigFormController({
        el: this.ssoForm
      });
      this.twoFactorForm = new App.RedesignSettingsSiteTwoFactor({
        el: this.twoFactorFormEl
      });
      if (this.slackEnabled()) {
        this.renderSlackSettings();
      }
    }

    RedesignSettingsAuthentication.prototype.slackEnabled = function() {
      return Features.enabled('slack');
    };

    RedesignSettingsAuthentication.prototype.release = function() {
      var ref;
      this.ssoFormController.release();
      this.twoFactorForm.release();
      if ((ref = this.slackSettings) != null) {
        ref.release();
      }
      return RedesignSettingsAuthentication.__super__.release.call(this);
    };

    RedesignSettingsAuthentication.prototype.aboutTfaClick = function() {
      return window.open(AppRedesign.DOC_PATH + '/two-factor');
    };

    RedesignSettingsAuthentication.prototype.aboutSlackClick = function() {
      return window.open(AppRedesign.DOC_PATH + '/slack-integration');
    };

    RedesignSettingsAuthentication.prototype.renderSlackSettings = function() {
      this.slackSettings || (this.slackSettings = new App.SlackSettingsController());
      return this.slackForm.append(this.slackSettings.el);
    };

    return RedesignSettingsAuthentication;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsColorThemesController = (function(superClass) {
    extend(RedesignSettingsColorThemesController, superClass);

    RedesignSettingsColorThemesController.prototype.className = 'color-settings';

    RedesignSettingsColorThemesController.prototype.elements = {
      '.panel-content.table': 'chartContainer',
      '.panel-content.bar-chart': 'barChartContainer',
      '#header-text-color': 'headerTextColor',
      '#odd-rows-text-color': 'oddRowsTextColor',
      '#even-rows-text-color': 'evenRowsTextColor',
      '#header-background-color': 'headerBackgroundColor',
      '#odd-rows-background-color': 'oddRowsBackgroundColor',
      '#even-rows-background-color': 'evenRowsBackgroundColor',
      '.button-row': 'buttonRow',
      'input.redesign-input': 'colorThemeName',
      '.errors.warning-icon': 'themeNameError',
      '.series-color': 'seriesColors',
      '.color-rotator': 'colorRotator',
      '.series.color-square': 'series'
    };

    RedesignSettingsColorThemesController.prototype.events = {
      'click .rotator-title': 'toggleTables',
      'change input.redesign-input': 'clearNameError',
      'click .add-series-icon': 'addSeriesPicker',
      'click .series.color-square': 'launchSeriesPicker',
      'click .table.color-square': 'launchTablePicker'
    };

    function RedesignSettingsColorThemesController() {
      this.clearNameError = bind(this.clearNameError, this);
      this.clickedClose = bind(this.clickedClose, this);
      this.saveTheme = bind(this.saveTheme, this);
      this.clickedSave = bind(this.clickedSave, this);
      this.handleThemeName = bind(this.handleThemeName, this);
      this.setTableColor = bind(this.setTableColor, this);
      this.refreshSeries = bind(this.refreshSeries, this);
      this.editColor = bind(this.editColor, this);
      this.deleteColor = bind(this.deleteColor, this);
      this.launchSeriesPicker = bind(this.launchSeriesPicker, this);
      this.addSeriesPicker = bind(this.addSeriesPicker, this);
      this.launchPicker = bind(this.launchPicker, this);
      this.launchTablePicker = bind(this.launchTablePicker, this);
      this.updateSeries = bind(this.updateSeries, this);
      this.render = bind(this.render, this);
      var ref;
      RedesignSettingsColorThemesController.__super__.constructor.apply(this, arguments);
      this.theme = (ref = this.colorTheme) != null ? ref : App.ColorTheme.newColorThemeWithPeriscopeDefaults();
      this.themeProxy = _.clone(this.theme);
      this.themeProxy.series = _.clone(this.theme.series);
      this.widget = new App.Widget({
        default_color_theme_id: this.themeProxy.id
      });
      this.render();
    }

    RedesignSettingsColorThemesController.prototype.render = function() {
      this.html(this.view('redesign/settings/color_themes_form')({
        theme: this.themeProxy
      }));
      this.dialog = App.RedesignDialog.createDialog({
        title: this.themeProxy.dialogTitle(),
        viewController: this,
        customDialogClass: 'color-theme',
        closeCallback: this.clickedClose
      });
      this.renderTableChart();
      this.renderSeriesColors();
      this.setUpColorDrag();
      this.renderBarGraph();
      return $('.table.color-square').each(function() {
        return App.ColorHelper.toggleBorderClassOnColorLightness($(this), $(this).data('color'), 'show-border', 200);
      });
    };

    RedesignSettingsColorThemesController.prototype.updateSeries = function(to, from) {
      this.themeProxy.series.splice(to, 0, this.themeProxy.series.splice(from, 1)[0]);
      return this.refreshSeries();
    };

    RedesignSettingsColorThemesController.prototype.renderTableChart = function() {
      var chartData, columns, rows, twiddles;
      twiddles = _.merge({
        twiddle_chart_type: 'table'
      }, this.themeProxy);
      columns = ['chart_type', 'month', 'count'];
      rows = [
        {
          chart_type: 'column',
          month: '2017-01-01',
          count: 16850
        }, {
          chart_type: 'sparkline',
          month: '2017-01-01',
          count: 1986
        }, {
          chart_type: 'scatter',
          month: '2017-01-01',
          count: 560
        }, {
          chart_type: 'aaaaaaaaaaaaaa',
          month: 'aaaaaaaaaaaaaaaa',
          count: 'aaaaaaaaaaa'
        }
      ];
      chartData = App.Chartographer.convert(rows, columns, twiddles);
      this.tableChart = new App.RedesignTableChart({
        widget: this.widget,
        el: this.chartContainer,
        chartData: chartData
      });
      this.tableChart.setDataFromChartData(chartData);
      this.tableChart.render();
      this.buttonBlock = new App.CancelSaveBlock({
        cancelFunc: this.clickedClose,
        saveFunc: this.clickedSave,
        saveText: 'save'
      });
      return this.buttonRow.append(this.buttonBlock.el);
    };

    RedesignSettingsColorThemesController.prototype.renderBarGraph = function() {
      var chartData, columns, rows;
      columns = ["dte", "Watermelon", "Oranges", "Limes", "Apples", "Lemons", "Bananas", "Kiwi", "Cherries", "Grapes", "", "  "];
      rows = [
        {
          dte: "2016-01-02 00:00:00",
          Watermelon: "8910",
          Oranges: "4843",
          Limes: "2781",
          Lemons: "9889",
          Kiwi: "200",
          Grapes: "8726",
          Cherries: "3189",
          Bananas: "7764",
          Apples: "6889"
        }, {
          dte: "2016-02-02 00:00:00",
          Watermelon: "8725",
          Oranges: "3101",
          Limes: "8339",
          Lemons: "9400",
          Kiwi: "899",
          Grapes: "6600",
          Cherries: "9496",
          Bananas: "9083",
          Apples: "5011"
        }, {
          dte: "2016-03-02 00:00:00",
          Watermelon: "8300",
          Oranges: "4300",
          Limes: "8000",
          Lemons: "11000",
          Kiwi: "1300",
          Grapes: "7600",
          Cherries: "13000",
          Bananas: "7083",
          Apples: "6000"
        }, {
          dte: "2016-04-02 00:00:00",
          Watermelon: "9923",
          Oranges: "5489",
          Limes: "8644",
          Lemons: "3897",
          Kiwi: "436",
          Grapes: "5821",
          Cherries: "7533",
          Bananas: "3010",
          Apples: "6361"
        }, {
          dte: "2016-05-02 00:00:00",
          Watermelon: "4232",
          Oranges: "5324",
          Limes: "7726",
          Lemons: "1425",
          Kiwi: "2092",
          Grapes: "5235",
          Cherries: "235",
          Bananas: "7365",
          Apples: "8614"
        }, {
          dte: "2016-06-02 00:00:00",
          Watermelon: "1800",
          Oranges: "2225",
          Limes: "6190",
          Lemons: "3980",
          Kiwi: "1600",
          Grapes: "6950",
          Cherries: "7500",
          Bananas: "2000",
          Apples: "7800"
        }, {
          dte: "2016-07-02 00:00:00",
          Watermelon: "2900",
          Oranges: "3225",
          Limes: "2190",
          Lemons: "4300",
          Kiwi: "2690",
          Grapes: "2950",
          Cherries: "1250",
          Bananas: "2100",
          Apples: "1700"
        }, {
          dte: "2016-08-02 00:00:00",
          Watermelon: "1100",
          Oranges: "8225",
          Limes: "1990",
          Lemons: "1560",
          Kiwi: "2600",
          Grapes: "1950",
          Cherries: "2750",
          Bananas: "4000",
          Apples: "8500"
        }
      ];
      chartData = new App.Chartographer.convert(rows, columns, {
        twiddle_chart_type: 'column',
        twiddle_point_cols: ['month'],
        twiddle_do_not_show_legend: true,
        continuous_x_axis: false,
        twiddle_x_axis_show_all_labels: true,
        twiddle_proportional: false,
        twiddle_drilldown_mapping: null,
        twiddle_segment_column: "fruit",
        twiddle_y_axis_enabled_columns: [],
        twiddle_use_pivot_settings: false
      }, 'string', this.themeProxy);
      this.seriesChart = new App.CanvasChart({
        el: this.barChartContainer,
        chartData: chartData,
        renderGuid: '100',
        width: 426,
        height: 209,
        widthInColumns: 50,
        columnWidthFunc: function() {
          return 5;
        },
        colorThemeChart: true
      });
      return this.seriesChart.render();
    };

    RedesignSettingsColorThemesController.prototype.renderSeriesColors = function() {
      var series;
      series = this.view('redesign/settings/series_colors')({
        theme: this.themeProxy
      });
      this.seriesColors.html(series);
      return $('.series.color-square').each(function() {
        return App.ColorHelper.toggleBorderClassOnColorLightness($(this), $(this).data('color'), 'show-border', 200);
      });
    };

    RedesignSettingsColorThemesController.prototype.setUpColorDrag = function() {
      this.colorDrag = new App.ColorBoxDragHelper({
        el: this.seriesColors
      });
      this.colorDrag.makeSortable();
      return this.colorDrag.bind('updateSeries', this.updateSeries);
    };

    RedesignSettingsColorThemesController.prototype.toggleTables = function(e) {
      var rotator;
      if ($(e.currentTarget).hasClass('edit-mode')) {
        return;
      }
      rotator = $(e.currentTarget).closest('.subheader-2.rotator');
      return $(rotator).toggleClass('closed');
    };

    RedesignSettingsColorThemesController.prototype.launchTablePicker = function(e) {
      var showDelete;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      showDelete = false;
      this.colorPicker = this.launchPicker($(e.currentTarget), showDelete);
      this.colorPicker.bind('update', this.setTableColor);
      return $(e.currentTarget).append(this.colorPicker.$el);
    };

    RedesignSettingsColorThemesController.prototype.launchPicker = function(currentColor, showDelete) {
      var backgroundColor, colorPicker, indexOrAttribute, ref;
      if ((ref = this.colorPicker) != null) {
        ref.release();
      }
      this.colorRotator.addClass('edit-mode');
      backgroundColor = currentColor.data('color');
      indexOrAttribute = currentColor.data('color-type');
      return colorPicker = new App.PreferencesColorPickerController({
        targetColor: currentColor,
        colorToSet: backgroundColor,
        indexOrAttribute: indexOrAttribute,
        showDelete: showDelete
      });
    };

    RedesignSettingsColorThemesController.prototype.addSeriesPicker = function(e) {
      var addNew;
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      this.themeProxy.series.push(App.ColorHelper.defaultNewChartColor());
      this.refreshSeries();
      addNew = true;
      return this.launchSeriesPicker(e, addNew);
    };

    RedesignSettingsColorThemesController.prototype.launchSeriesPicker = function(e, addNew) {
      var colorSquare, showDelete;
      if (addNew == null) {
        addNew = false;
      }
      if ($(e.target).parents('.gradient-color-picker').length) {
        return;
      }
      this.colorDrag.destroySortable();
      showDelete = true;
      colorSquare = addNew ? $('.series.color-square').last() : $(e.currentTarget);
      this.colorPicker = this.launchPicker(colorSquare, showDelete);
      this.colorPicker.bind('update', this.editColor);
      this.colorPicker.bind('delete', this.deleteColor);
      return colorSquare.append(this.colorPicker.$el);
    };

    RedesignSettingsColorThemesController.prototype.deleteColor = function(backgroundColor, currentColorIndex) {
      this.themeProxy.series.splice(currentColorIndex, 1);
      return this.refreshSeries();
    };

    RedesignSettingsColorThemesController.prototype.editColor = function(backgroundColor, currentColorIndex) {
      this.themeProxy.series[currentColorIndex] = backgroundColor;
      return this.refreshSeries();
    };

    RedesignSettingsColorThemesController.prototype.refreshSeries = function() {
      var ref;
      this.colorRotator.removeClass('edit-mode');
      if ((ref = this.colorDrag) != null) {
        ref.makeSortable();
      }
      this.renderSeriesColors();
      return this.renderBarGraph();
    };

    RedesignSettingsColorThemesController.prototype.setTableColor = function(themeValue, themeKey) {
      this.themeProxy[themeKey] = themeValue;
      this.colorRotator.removeClass('edit-mode');
      return this.renderTableChart();
    };

    RedesignSettingsColorThemesController.prototype.handleThemeName = function() {
      this.themeProxy.name = this.colorThemeName.val();
      if (this.themeProxy.name !== '') {
        return true;
      }
      this.themeNameError.show();
      this.colorThemeName.addClass('error');
      return false;
    };

    RedesignSettingsColorThemesController.prototype.clickedSave = function() {
      if (this.handleThemeName()) {
        return this.saveTheme();
      }
    };

    RedesignSettingsColorThemesController.prototype.saveTheme = function() {
      if (this.theme.isNew()) {
        App.Utils.logFeature('color-theme-create');
      }
      this.theme = this.themeProxy;
      this.theme.save();
      this.trigger('close');
      this.trigger('updated');
      return this.release();
    };

    RedesignSettingsColorThemesController.prototype.clickedClose = function() {
      delete this.themeProxy;
      this.trigger('close');
      return this.release();
    };

    RedesignSettingsColorThemesController.prototype.clearNameError = function() {
      this.colorThemeName.removeClass('error');
      if (this.colorThemeName.val() !== '') {
        return this.themeNameError.hide();
      }
    };

    RedesignSettingsColorThemesController.prototype.release = function() {
      var ref, ref1, ref2;
      if ((ref = this.colorPicker) != null) {
        ref.unbind('update', this.setTableColor);
      }
      if ((ref1 = this.colorPicker) != null) {
        ref1.unbind('update', this.editColor);
      }
      if ((ref2 = this.colorPicker) != null) {
        ref2.unbind('delete', this.deleteColor);
      }
      return RedesignSettingsColorThemesController.__super__.release.apply(this, arguments);
    };

    return RedesignSettingsColorThemesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsContainerController = (function(superClass) {
    extend(RedesignSettingsContainerController, superClass);

    RedesignSettingsContainerController.headerDescription = function(appliesToAllSpaces) {
      if (App.Site.isSpacesEnabled()) {
        if (appliesToAllSpaces) {
          return 'ACCOUNT SETTINGS';
        } else {
          return 'SETTINGS';
        }
      } else {
        return 'SETTINGS';
      }
    };

    RedesignSettingsContainerController.prototype.className = 'settings-wrapper';

    RedesignSettingsContainerController.prototype.elements = {
      '.button.add-database': 'addDatabaseButton',
      '.settings-main-content': 'settingsContentEl',
      '.settings-header': 'settingsHeaderEl'
    };

    RedesignSettingsContainerController.prototype.events = {
      'click .button.add-database': 'addDatabaseClicked'
    };

    function RedesignSettingsContainerController() {
      this.addDatabaseClicked = bind(this.addDatabaseClicked, this);
      RedesignSettingsContainerController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'settingsControllerClass');
      if (AppRedesign.hasCustomerUnification()) {
        this.el.addClass('customer-unification');
      }
      if (AppRedesign.hasNotificationBar()) {
        this.el.addClass('with-notification-bar');
      }
      this.html(this.view('redesign/settings/settings')({
        headerDescription: this.headerDescription(),
        spaceName: this.spaceName(),
        title: this.settingsControllerClass.TITLE
      }));
      if (this.settingsControllerClass === App.RedesignConfigitronController) {
        this.addDatabaseButton.css('display', 'block');
      }
      this.settingsController = new this.settingsControllerClass();
      this.settingsContentEl.append(this.settingsController.el);
      AppRedesign.current().startScreenTransitionAnimation();
      if (!this.settingsControllerClass.EXTEND_HEADER || !App.Site.first().isDashboardRefreshV1Enabled()) {
        this.settingsHeaderEl.addClass('with_border');
        this.settingsContentEl.addClass('with_border');
      }
    }

    RedesignSettingsContainerController.prototype.headerDescription = function() {
      return this.constructor.headerDescription(this.settingsControllerClass.APPLIES_TO_ALL_SPACES);
    };

    RedesignSettingsContainerController.prototype.spaceName = function() {
      if (App.Site.isSpacesEnabled() && this.settingsControllerClass.APPLIES_TO_ALL_SPACES) {
        return;
      }
      return App.Site.first().spaceName();
    };

    RedesignSettingsContainerController.prototype.addDatabaseClicked = function() {
      if (this.settingsControllerClass !== App.RedesignConfigitronController) {
        return;
      }
      return this.settingsController.showAddDbForm();
    };

    RedesignSettingsContainerController.prototype.release = function() {
      this.settingsController.release();
      this.trigger('close');
      AppRedesign.current().startScreenTransitionAnimation();
      return RedesignSettingsContainerController.__super__.release.apply(this, arguments);
    };

    return RedesignSettingsContainerController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsGridController = (function(superClass) {
    extend(RedesignSettingsGridController, superClass);

    RedesignSettingsGridController.prototype.className = 'settings-grid';

    RedesignSettingsGridController.prototype.elements = {
      '.search-panel': 'searchPanel',
      '.right-panel': 'rightPanel',
      '.grid-panel': 'gridPanel',
      '.upper-section': 'upperSection',
      '.lower-section': 'lowerSection'
    };

    function RedesignSettingsGridController() {
      this.resize = bind(this.resize, this);
      this.closeRightPanel = bind(this.closeRightPanel, this);
      this.unselectedRow = bind(this.unselectedRow, this);
      this.selectedRowUpdated = bind(this.selectedRowUpdated, this);
      this.selectedRow = bind(this.selectedRow, this);
      this.clickedAdd = bind(this.clickedAdd, this);
      this.updateCategory = bind(this.updateCategory, this);
      this.searchCallback = bind(this.searchCallback, this);
      var base, initValue;
      RedesignSettingsGridController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'settingsController', 'mainControllerOptions');
      this.el.addClass(this.settingsGridCssClass);
      this.html(this.view("redesign/settings/settings_grid")({
        loadingMessage: this.loadingMessage || 'Loading'
      }));
      if (AppRedesign.hasCustomerUnification()) {
        this.el.find('.left-panel').addClass('customer-unification');
        this.el.find('.right-panel').addClass('customer-unification');
      }
      if (AppRedesign.hasNotificationBar()) {
        this.el.find('.left-panel').addClass('with-notification-bar');
        this.el.find('.right-panel').addClass('with-notification-bar');
      }
      this.categories = this.settingsController.getCategories();
      initValue = _.find(this.categories, (function(_this) {
        return function(category) {
          return category.type === _this.mainControllerOptions.initValue;
        };
      })(this));
      this.search = new App.RedesignGridSearchController({
        el: this.searchPanel,
        categories: this.categories,
        disableSearch: this.disableSearch || false,
        initValue: initValue,
        dropdownWidth: this.dropdownWidth,
        hideCategoryDropdown: this.hideCategoryDropdown || false
      });
      this.search.bind("search", this.searchCallback);
      this.search.bind("category-change", this.updateCategory);
      this.search.bind("clicked-add", this.clickedAdd);
      this.updateCategory((typeof (base = this.settingsController).firstCategory === "function" ? base.firstCategory() : void 0) || this.categories[0]);
      this.window().on('resize', this.resize);
      this.resize();
      this.settingsController.bind('reload', this.rerenderRows);
    }

    RedesignSettingsGridController.prototype.window = function() {
      return $(window);
    };

    RedesignSettingsGridController.prototype.bodyHeight = function() {
      return $('#body').height();
    };

    RedesignSettingsGridController.prototype.bodyWidth = function() {
      return $('#body').width();
    };

    RedesignSettingsGridController.prototype.searchCallback = function(searchTerm) {
      return this.mainController.search(searchTerm);
    };

    RedesignSettingsGridController.prototype.updateCategory = function(category) {
      var mainControllerOptions, ref, ref1, ref2, ref3;
      if ((ref = this.settingsController) != null) {
        ref.releaseMainControllerSpecificBinding(this.currCategory);
      }
      this.releaseSubsectionControllers();
      this.currCategory = category;
      if ((ref1 = this.addController) != null) {
        ref1.release();
      }
      if ((ref2 = this.mainController) != null) {
        ref2.release();
      }
      if ((ref3 = this.settingsController) != null) {
        ref3.setUpForMainController(this.currCategory);
      }
      mainControllerOptions = $.extend(true, this.mainControllerOptions, {
        el: App.Utils.appendFrame(this.gridPanel, 'main-grid'),
        database_id: category.type
      });
      this.mainController = new category.mainController(mainControllerOptions);
      this.mainController.bind("selected", this.selectedRow);
      this.mainController.bind('selected-row-updated', this.selectedRowUpdated);
      this.mainController.bind("unselected", this.unselectedRow);
      this.mainController.bind("deletedRow", this.unselectedRow);
      this.closeRightPanel();
      return this.mainController.grid.clickRow(0);
    };

    RedesignSettingsGridController.prototype.clickedAdd = function(category) {
      var ref;
      if ((ref = this.addController) != null) {
        ref.release();
      }
      return this.addController = new category.addController({
        directoryHelper: this.mainControllerOptions.directoryHelper
      });
    };

    RedesignSettingsGridController.prototype.selectedRow = function(row) {
      var lowerSectionControllerOptions, ref, ref1, ref2, ref3, upperSectionControllerOptions;
      if ((ref = this.currUpperSectionController) != null) {
        ref.release();
      }
      this.openRightPanel();
      if (this.currCategory.upperSectionController != null) {
        upperSectionControllerOptions = $.extend(true, this.mainControllerOptions, {
          el: App.Utils.appendFrame(this.upperSection, 'section-frame'),
          item: (ref1 = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref1 : null,
          row: row
        });
        this.currUpperSectionController = new this.currCategory.upperSectionController(upperSectionControllerOptions);
      }
      if (this.currCategory.lowerSectionController == null) {
        return;
      }
      if ((ref2 = this.currLowerSectionController) != null) {
        ref2.release();
      }
      lowerSectionControllerOptions = $.extend(true, this.mainControllerOptions, {
        el: App.Utils.appendFrame(this.lowerSection, 'section-frame'),
        item: (ref3 = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref3 : null,
        row: row
      });
      return this.currLowerSectionController = new this.currCategory.lowerSectionController(lowerSectionControllerOptions);
    };

    RedesignSettingsGridController.prototype.selectedRowUpdated = function(row) {
      var base, base1, lowerSectionControllerOptions, ref, ref1, upperSectionControllerOptions;
      if ((this.currCategory.upperSectionController != null) && (typeof (base = this.currUpperSectionController).canBeUpdated === "function" ? base.canBeUpdated() : void 0)) {
        this.currUpperSectionController.release();
        upperSectionControllerOptions = $.extend(true, this.mainControllerOptions, {
          el: App.Utils.appendFrame(this.upperSection, 'section-frame'),
          item: (ref = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref : null,
          row: row
        });
        this.currUpperSectionController = new this.currCategory.upperSectionController(upperSectionControllerOptions);
      }
      if (!((this.currCategory.lowerSectionController != null) && (typeof (base1 = this.currLowerSectionController).canBeUpdated === "function" ? base1.canBeUpdated() : void 0))) {
        return;
      }
      this.currLowerSectionController.release();
      lowerSectionControllerOptions = $.extend(true, this.mainControllerOptions, {
        el: App.Utils.appendFrame(this.lowerSection, 'section-frame'),
        item: (ref1 = row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref1 : null,
        row: row
      });
      return this.currLowerSectionController = new this.currCategory.lowerSectionController(lowerSectionControllerOptions);
    };

    RedesignSettingsGridController.prototype.unselectedRow = function() {
      this.releaseSubsectionControllers();
      this.closeRightPanel();
      return this.mainController.grid.clickRow(0);
    };

    RedesignSettingsGridController.prototype.closeRightPanel = function() {
      this.trigger('right-panel-close');
      this.releaseSubsectionControllers();
      this.mainController.clearHighlightedRow();
      this.el.removeClass("right-panel-open");
      return this.rightPanel.hide();
    };

    RedesignSettingsGridController.prototype.openRightPanel = function() {
      this.trigger('right-panel-open');
      this.el.addClass("right-panel-open");
      return this.rightPanel.show();
    };

    RedesignSettingsGridController.prototype.releaseSubsectionControllers = function() {
      var ref, ref1;
      if ((ref = this.currUpperSectionController) != null) {
        ref.release();
      }
      return (ref1 = this.currLowerSectionController) != null ? ref1.release() : void 0;
    };

    RedesignSettingsGridController.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.mainController) != null) {
        ref.release();
      }
      if ((ref1 = this.addController) != null) {
        ref1.release();
      }
      this.releaseSubsectionControllers();
      this.search.release();
      return RedesignSettingsGridController.__super__.release.apply(this, arguments);
    };

    RedesignSettingsGridController.prototype.rerenderRows = function() {
      var ref, ref1, ref2;
      if ((ref = this.mainController) != null) {
        ref.grid.rerenderRows(this.mainController.getRows());
      }
      if ((ref1 = this.currUpperSectionController) != null) {
        ref1.grid.rerenderRows(this.currUpperSectionController.getRows());
      }
      return (ref2 = this.currLowerSectionController) != null ? ref2.grid.rerenderRows(this.currLowerSectionController.getRows()) : void 0;
    };

    RedesignSettingsGridController.prototype.resize = function() {
      var bodyHeight, bodyWidth, panelSize;
      bodyHeight = this.bodyHeight();
      bodyWidth = this.bodyWidth();
      if (this.cachedHeight === bodyHeight && this.cachedWidth === bodyWidth) {
        return;
      }
      this.cachedHeight = bodyHeight;
      this.cachedWidth = bodyWidth;
      panelSize = bodyHeight - App.RedesignPermissionsController.OTHER_AREA_HEIGHT;
      if (panelSize < App.RedesignPermissionsController.PERMISSION_PANEL_MINIMUM_HEIGHT) {
        panelSize = App.RedesignPermissionsController.PERMISSION_PANEL_MINIMUM_HEIGHT;
      }
      if (bodyWidth < (App.RedesignPermissionsController.PERMISSION_PANEL_WIDTH + App.RedesignPermissionsController.PERMISSION_PANEL_LEFT_MARGIN)) {
        return this.el.css({
          'margin-left': App.RedesignPermissionsController.PERMISSION_PANEL_LEFT_MARGIN + "px",
          'left': '0%',
          'height': panelSize + "px"
        });
      } else {
        return this.el.css({
          'height': panelSize + "px",
          'left': '50%',
          'margin-left': "-" + (App.RedesignPermissionsController.PERMISSION_PANEL_WIDTH / 2) + "px"
        });
      }
    };

    return RedesignSettingsGridController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsMenuProfileTwoFactorController = (function(superClass) {
    extend(RedesignSettingsMenuProfileTwoFactorController, superClass);

    RedesignSettingsMenuProfileTwoFactorController.prototype.elements = {
      '.enable-tfa-checkbox.permissions-checkbox': 'enableCheckboxArea',
      '.error-row': 'errorRow',
      '.required-sites': 'requiredSites',
      '.site-names': 'siteNames',
      '.tfa-picker': 'tfaPicker'
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.events = {
      'change .tfa-picker': 'changedTfa',
      'click': 'formClick'
    };

    function RedesignSettingsMenuProfileTwoFactorController() {
      this.userUpdated = bind(this.userUpdated, this);
      this.setTfaStatus = bind(this.setTfaStatus, this);
      this.handleServerResponse = bind(this.handleServerResponse, this);
      this.setPickerState = bind(this.setPickerState, this);
      this.changedTfa = bind(this.changedTfa, this);
      this.formClick = bind(this.formClick, this);
      this.escapePressed = bind(this.escapePressed, this);
      this.release = bind(this.release, this);
      this.getSitesRequiringTwoFactor = bind(this.getSitesRequiringTwoFactor, this);
      var siteNames;
      RedesignSettingsMenuProfileTwoFactorController.__super__.constructor.apply(this, arguments);
      this.html(this.view('redesign/settings/two_factor_form')());
      this.setPickerState();
      this.tfaPicker.chosen({
        disable_search: true,
        width: '100%'
      });
      siteNames = this.getSitesRequiringTwoFactor();
      if (siteNames.length > 0) {
        this.requiredSites.show();
        this.siteNames.html(siteNames.join(", "));
        this.tfaPicker.val('enabled');
        this.tfaPicker.prop('disabled', true).trigger('chosen:updated');
      } else {
        this.requiredSites.hide();
      }
      App.User.currentUser().bind('update refresh', this.userUpdated);
    }

    RedesignSettingsMenuProfileTwoFactorController.prototype.getSitesRequiringTwoFactor = function() {
      var currentSite, i, len, ref, siteName, siteNames;
      currentSite = App.Site.first();
      siteNames = [];
      if (currentSite.require_tfa) {
        siteNames.push(currentSite.display_name);
      }
      if (!App.User.currentUser().sites_requiring_tfa) {
        return siteNames;
      }
      ref = App.User.currentUser().sites_requiring_tfa;
      for (i = 0, len = ref.length; i < len; i++) {
        siteName = ref[i];
        if (siteName !== currentSite.display_name) {
          siteNames.push(siteName);
        }
      }
      return siteNames;
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.release = function() {
      App.User.currentUser().unbind('update', this.userUpdated);
      App.User.currentUser().unbind('refresh', this.userUpdated);
      return RedesignSettingsMenuProfileTwoFactorController.__super__.release.apply(this, arguments);
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.escapePressed = function() {
      return this.release();
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.formClick = function(evt) {
      return evt.stopPropagation();
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.changedTfa = function() {
      var tfaSetupForm;
      this.clearError();
      if (this.tfaPicker.val() === 'enabled') {
        tfaSetupForm = new App.RedesignAuthenticationSequenceController({
          el: $('<div class="tfa-wrapper"></div>'),
          selfEnabled: true,
          setupTfa: true,
          setPassword: false,
          forgotPassword: false
        });
        this.setupTfaDialog = App.RedesignDialog.createDialog({
          warning: false,
          noCancel: false,
          customDialogClass: 'redesign-auth-flow',
          viewController: tfaSetupForm,
          title: 'Two-Factor Authentication Setup'
        });
        return setTimeout(((function(_this) {
          return function() {
            return $('body').one('click', _this.setPickerState);
          };
        })(this)), 0);
      } else {
        return this.setTfaStatus(false);
      }
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.setPickerState = function() {
      var ref;
      if ((ref = App.User.currentUser()) != null ? ref.isTfaUser() : void 0) {
        this.tfaPicker.val('enabled');
      } else {
        this.tfaPicker.val('disabled');
      }
      return this.tfaPicker.trigger('chosen:updated');
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.handleServerResponse = function(response) {
      var user;
      user = response.user;
      if (user != null) {
        return App.User.applyUpdates([user]);
      } else {
        return this.showError('Error applying updates, please try again later.');
      }
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.setTfaStatus = function(status) {
      return jQuery.post("/users/update_profile", {
        is_tfa_active: status,
        client_site_id: App.Site.first().id
      }, this.handleServerResponse).fail(((function(_this) {
        return function() {
          return _this.showError('Error updating profile, please try again later.');
        };
      })(this)));
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.userUpdated = function() {
      App.User.currentUser().reload();
      return this.setPickerState();
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.showError = function(message) {
      return this.errorRow.html(message).slideDown();
    };

    RedesignSettingsMenuProfileTwoFactorController.prototype.clearError = function() {
      return this.errorRow.slideUp();
    };

    return RedesignSettingsMenuProfileTwoFactorController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsMenuProfileUpdateController = (function(superClass) {
    extend(RedesignSettingsMenuProfileUpdateController, superClass);

    RedesignSettingsMenuProfileUpdateController.prototype.elements = {
      '.first-name input': 'firstNameInput',
      '.last-name input': 'lastNameInput',
      '.password input': 'currentPasswordInput',
      '.password .label': 'currentPasswordLabel',
      '.new input': 'newPasswordInput',
      '.new-confirm input': 'newPasswordConfirmInput',
      '.new-passwords-area': 'newPasswordsArea',
      '.button-row': 'buttonRow',
      '.done.button': 'doneButton',
      '.errors': 'errorRow',
      'input': 'allInputs',
      '.cancel': 'cancelText'
    };

    RedesignSettingsMenuProfileUpdateController.prototype.events = {
      'click .done.button': 'doneClick',
      'click .cancel': 'cancelClick',
      'click .password': 'openPasswordForm',
      'click .first-name': 'showButtons',
      'click .last-name': 'showButtons',
      'click .btn-sign-out': 'deleteSessionClick',
      'keyup input': 'inputKeyup'
    };

    function RedesignSettingsMenuProfileUpdateController() {
      this._isValidLength = bind(this._isValidLength, this);
      this.handleServerResponse = bind(this.handleServerResponse, this);
      this.inputKeyup = bind(this.inputKeyup, this);
      this.cancelClick = bind(this.cancelClick, this);
      this.deleteSessionClick = bind(this.deleteSessionClick, this);
      this.doneClick = bind(this.doneClick, this);
      this.release = bind(this.release, this);
      this.showButtons = bind(this.showButtons, this);
      this.hideButtons = bind(this.hideButtons, this);
      this.closePasswordForm = bind(this.closePasswordForm, this);
      this.openPasswordForm = bind(this.openPasswordForm, this);
      RedesignSettingsMenuProfileUpdateController.__super__.constructor.apply(this, arguments);
      this.currentUser = App.User.currentUser();
      this.html(this.view('redesign/settings/profile_form')({
        user: this.currentUser
      }));
      this.resetDoneButton();
      this.closePasswordForm();
      this.hideButtons();
    }

    RedesignSettingsMenuProfileUpdateController.prototype.openPasswordForm = function() {
      this.currentPasswordLabel.text('Current Password');
      this.inputKeyup(null);
      this.newPasswordsArea.slideDown();
      return this.showButtons();
    };

    RedesignSettingsMenuProfileUpdateController.prototype.closePasswordForm = function() {
      this.clearError();
      this.currentPasswordLabel.text('Change Password');
      this.currentPasswordInput.val('');
      this.newPasswordsArea.slideUp();
      return this.hideButtons();
    };

    RedesignSettingsMenuProfileUpdateController.prototype.hideButtons = function() {
      this.buttonRow.addClass('hidden');
      return this.doneButton.addClass('disabled');
    };

    RedesignSettingsMenuProfileUpdateController.prototype.showButtons = function() {
      return this.buttonRow.removeClass('hidden');
    };

    RedesignSettingsMenuProfileUpdateController.prototype.release = function() {
      return RedesignSettingsMenuProfileUpdateController.__super__.release.apply(this, arguments);
    };

    RedesignSettingsMenuProfileUpdateController.prototype.doneClick = function() {
      if (this.el.hasClass('locked')) {
        return this.el.removeClass('locked');
      } else {
        return this.submit();
      }
    };

    RedesignSettingsMenuProfileUpdateController.prototype.deleteSessionClick = function(e) {
      var $this;
      $this = $(e.target);
      $this.parents('.js-session-row').remove();
      return jQuery.ajax({
        method: 'delete',
        url: "/sessions/" + ($this.data('id'))
      });
    };

    RedesignSettingsMenuProfileUpdateController.prototype.cancelClick = function() {
      this.closePasswordForm();
      this.firstNameInput.val(this.currentUser.first_name);
      return this.lastNameInput.val(this.currentUser.last_name);
    };

    RedesignSettingsMenuProfileUpdateController.prototype.applyErrorClass = function(field) {
      return this.allInputs.filter("." + field).addClass('error');
    };

    RedesignSettingsMenuProfileUpdateController.prototype.showError = function(message) {
      return this.errorRow.html(message).slideDown();
    };

    RedesignSettingsMenuProfileUpdateController.prototype.clearError = function() {
      this.errorRow.slideUp();
      return _.each(this.allInputs, (function(_this) {
        return function(input) {
          return $(input).removeClass('error');
        };
      })(this));
    };

    RedesignSettingsMenuProfileUpdateController.prototype.inputKeyup = function(event) {
      this.showButtons();
      if (this._firstNameChangeValid() || this._lastNameChangeValid() || this._passwordChangeValid()) {
        this.clearError();
        this.doneButton.removeClass('disabled');
      } else {
        this.doneButton.addClass('disabled');
      }
      if ((event != null ? event.keyCode : void 0) === AppRedesign.KEYS.ENTER) {
        return this.submit();
      }
    };

    RedesignSettingsMenuProfileUpdateController.prototype.resetDoneButton = function() {
      return this.doneButton.removeClass('disabled');
    };

    RedesignSettingsMenuProfileUpdateController.prototype.submit = function() {
      var currentPassword, errorMessage, firstNameInput, lastNameInput, newPassword, newPasswordConfirm, updateParams;
      this.clearError();
      if (!this.doneButton.hasClass('disabled')) {
        updateParams = {
          client_site_id: App.Site.first().id
        };
        firstNameInput = this.firstNameInput.val().trim();
        lastNameInput = this.lastNameInput.val().trim();
        if (firstNameInput !== App.User.currentUser().first_name) {
          updateParams['first_name'] = firstNameInput;
        }
        if (lastNameInput !== App.User.currentUser().last_name) {
          updateParams['last_name'] = lastNameInput;
        }
        currentPassword = this.currentPasswordInput.val();
        newPassword = this.newPasswordInput.val();
        newPasswordConfirm = this.newPasswordConfirmInput.val();
        if (newPassword || newPasswordConfirm || currentPassword) {
          if ((currentPassword != null ? currentPassword.length : void 0) > 0) {
            errorMessage = App.Utils.validatePassword(newPassword, newPasswordConfirm);
            if (errorMessage) {
              this.newPasswordInput.val('');
              this.newPasswordConfirmInput.val('');
              this.newPasswordInput.addClass('error');
              this.newPasswordConfirmInput.addClass('error');
              this.showError(errorMessage);
              return;
            }
            updateParams['raw_password'] = newPassword;
            updateParams['current_password'] = currentPassword;
          } else {
            this.currentPasswordInput.addClass('error');
            this.showError('Please enter current password.');
          }
        }
        if (Object.keys(updateParams).length > 1) {
          this.hideButtons();
          return jQuery.post("/users/update_profile", updateParams, this.handleServerResponse).then(((function(_this) {
            return function() {
              if (updateParams['first_name'] || updateParams['last_name']) {
                return App.User.trigger('wix-update');
              }
            };
          })(this))).fail(((function(_this) {
            return function() {
              _this.resetDoneButton();
              return _this.showError('Error updating profile, please try again later.');
            };
          })(this)));
        }
      }
    };

    RedesignSettingsMenuProfileUpdateController.prototype.handleServerResponse = function(response) {
      var error, errorField, location, sisense_logout_url, user;
      user = response.user;
      error = response.error;
      errorField = response.error_field;
      location = response.location;
      sisense_logout_url = response.sisense_logout_url;
      this.currentPasswordInput.val('');
      this.newPasswordInput.val('');
      this.newPasswordConfirmInput.val('');
      this.resetDoneButton();
      if (user != null) {
        App.User.applyUpdates([user]);
        this.closePasswordForm();
        return this.currentUser.reload();
      } else if (location != null) {
        if (sisense_logout_url != null) {
          return window.location = location + '?sisense_logout_url=' + sisense_logout_url;
        } else {
          return window.location = location;
        }
      } else if (error != null) {
        this.applyErrorClass(errorField);
        return this.showError(error);
      } else {
        return this.showError('Error updating profile, please try again later.');
      }
    };

    RedesignSettingsMenuProfileUpdateController.prototype._isValidLength = function(value) {
      return !_.isEmpty(value) && value.length <= 1000;
    };

    RedesignSettingsMenuProfileUpdateController.prototype._firstNameChangeValid = function() {
      var value;
      value = this.firstNameInput.val().trim();
      return this._isValidLength(value) && value !== this.currentUser.first_name;
    };

    RedesignSettingsMenuProfileUpdateController.prototype._lastNameChangeValid = function() {
      var value;
      value = this.lastNameInput.val().trim();
      return this._isValidLength(value) && value !== this.currentUser.last_name;
    };

    RedesignSettingsMenuProfileUpdateController.prototype._passwordChangeValid = function() {
      return !_.isEmpty(this.currentPasswordInput.val().trim()) && this._isValidLength(this.newPasswordInput.val().trim()) && this._isValidLength(this.newPasswordConfirmInput.val().trim());
    };

    return RedesignSettingsMenuProfileUpdateController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignPreferencesController = (function(superClass) {
    extend(RedesignPreferencesController, superClass);

    RedesignPreferencesController.APPLIES_TO_ALL_SPACES = false;

    RedesignPreferencesController.TITLE = 'Preferences';

    RedesignPreferencesController.prototype.className = 'settings-area settings-preferences';

    RedesignPreferencesController.prototype.elements = {
      '.color-theme.area': 'colorThemesArea',
      '.auto-archive-react-div': 'autoArchiveSettingsReactDiv',
      '.csv-settings-react-div': 'csvSettingsReactDiv',
      '.filter-settings-react-div': 'filterSettingsReactDiv',
      '.timezone-settings-react-div': 'timezoneSettingsReactDiv',
      '.dashboard-settings-react-div': 'dashboardSettingsReactDiv',
      '.landing-page-settings-react-div': 'landingPageSettingsReactDiv'
    };

    function RedesignPreferencesController() {
      RedesignPreferencesController.__super__.constructor.apply(this, arguments);
      this.render();
    }

    RedesignPreferencesController.prototype.render = function() {
      App.Utils.logFeature("preferences-open");
      this.html(this.view('redesign/settings/preferences_panel')({
        colorThemesEnabled: AppRedesign.current().colorThemesEnabled,
        csv_permissions_enabled: App.Site.first().isCsvDownloadPermissionsEnabled(),
        autoArchiveEnabled: AppRedesign.autoArchiveEnabled()
      }));
      if (AppRedesign.current().colorThemesEnabled) {
        this.renderColorThemes();
      }
      if (AppRedesign.autoArchiveEnabled()) {
        this.renderAutoArchiveSettings();
      }
      this.renderDashboardSettingsReact();
      this.renderCsvSettingsReact();
      this.renderFilterSettingsReact();
      this.renderTimezoneReact();
      return this.renderLandingPageSettingsReact();
    };

    RedesignPreferencesController.prototype.renderDashboardSettingsReact = function() {
      return this.dashboardReactRoot = window.reactApp.dashboardSettingsRoot(this.dashboardSettingsReactDiv[0], this.site().new_topics_not_public, this.site().new_dashboards_not_public, this.site().forbid_shared_dashboards, this.site().forbid_email_reports, this.site().forbid_slack_reports, this.site().pdf_download_enabled_for_admin, this.site().pdf_download_enabled, this.site().shared_dashboard_password_expiration_period);
    };

    RedesignPreferencesController.prototype.renderLandingPageSettingsReact = function() {
      return this.landingPageReactRoot = window.reactApp.landingPageSettingsRoot(this.landingPageSettingsReactDiv[0], this.dashboardList(), this.site().default_dashboard_id, this.site().default_topic_id, this.site().landing_page_type);
    };

    RedesignPreferencesController.prototype.renderTimezoneReact = function() {
      return this.timezoneReactRoot = window.reactApp.timezoneSettingsRoot(this.timezoneSettingsReactDiv[0], this.timeZoneList(), this.site().display_timezone, this.site().display_name);
    };

    RedesignPreferencesController.prototype.renderCsvSettingsReact = function() {
      return this.csvSettingsReactRoot = window.reactApp.csvSettingsRoot(this.csvSettingsReactDiv[0], this.site().isCsvDownloadPermissionsEnabled(), this.site().csv_api_access, this.site().csv_download_access, this.site().csv_download_disable_on_new_charts, this.site().csv_exports_disabled_for_shared_dashboards, this.site().csv_download_delimiter, AppRedesign.current().state.RbacEnabled);
    };

    RedesignPreferencesController.prototype.renderFilterSettingsReact = function() {
      return this.filterSettingsReactRoot = window.reactApp.filterSettingsRoot(this.filterSettingsReactDiv[0], this.site().new_filters_not_shared, this.site().filter_changes_run_unaffected_queries);
    };

    RedesignPreferencesController.prototype.renderAutoArchiveSettings = function() {
      return this.autoArchiveSettingsReactRoot = window.reactApp.autoArchiveSettingsRoot(this.autoArchiveSettingsReactDiv[0]);
    };

    RedesignPreferencesController.prototype.dashboardList = function() {
      var list;
      return list = _.map(App.Dashboard.allSortedByName(), function(dashboard) {
        return {
          name: dashboard.getName(),
          label: dashboard.getName(),
          value: dashboard.id
        };
      });
    };

    RedesignPreferencesController.prototype.timeZoneList = function() {
      return _(App.TimeMachine.TZ_MAP).map(function(tz_name, tz_abbreviation) {
        var offset, offset_minutes, str;
        offset = moment.tz(tz_name).utcOffset();
        offset_minutes = App.Utils.padZero(offset % 60, 2);
        str = "[UTC" + (Math.floor(offset / 60)) + ":" + offset_minutes + "] " + App.TimeMachine.TZ_NAMES[tz_abbreviation];
        return {
          label: str,
          value: tz_abbreviation,
          offset: offset
        };
      }).sortBy('offset').value();
    };

    RedesignPreferencesController.prototype.renderColorThemes = function() {
      return this.colorThemesController = new App.PreferencesColorThemesController({
        el: this.colorThemesArea,
        site: this.site()
      });
    };

    RedesignPreferencesController.prototype.site = function() {
      return App.Site.first();
    };

    RedesignPreferencesController.prototype.release = function() {
      var ref, ref1, ref2, ref3, ref4;
      if ((ref = this.dashboardReactRoot) != null) {
        ref.close();
      }
      if ((ref1 = this.timezoneReactRoot) != null) {
        ref1.close();
      }
      if ((ref2 = this.filterSettingsReactRoot) != null) {
        ref2.close();
      }
      if ((ref3 = this.csvSettingsReactRoot) != null) {
        ref3.close();
      }
      if ((ref4 = this.autoArchiveSettingsReactRoot) != null) {
        ref4.close();
      }
      return RedesignPreferencesController.__super__.release.apply(this, arguments);
    };

    return RedesignPreferencesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsSiteTwoFactor = (function(superClass) {
    extend(RedesignSettingsSiteTwoFactor, superClass);

    RedesignSettingsSiteTwoFactor.prototype.elements = {
      '.select-enable-tfa': 'selectEnableTfa',
      '.user-selector-slot': 'userSelectorSlot',
      '.user-selector-area': 'userSelectorArea',
      '.row.errors': 'errorRow'
    };

    RedesignSettingsSiteTwoFactor.prototype.events = {
      'change .select-enable-tfa': 'updatedEnableSelection'
    };

    function RedesignSettingsSiteTwoFactor() {
      this.showError = bind(this.showError, this);
      this.cancelCallback = bind(this.cancelCallback, this);
      this.updatedEnableSelection = bind(this.updatedEnableSelection, this);
      this.populateForm = bind(this.populateForm, this);
      RedesignSettingsSiteTwoFactor.__super__.constructor.apply(this, arguments);
      this.html(this.view('settings/site_two_factor_form')());
      this.populateForm();
    }

    RedesignSettingsSiteTwoFactor.prototype.populateForm = function() {
      this.selectEnableTfa.chosen({
        width: '100%',
        disable_search: true
      });
      if (App.Site.first().isTfaRequired()) {
        return this.selectEnableTfa.val("enabled").trigger("chosen:updated");
      }
    };

    RedesignSettingsSiteTwoFactor.prototype.updatedEnableSelection = function() {
      var site;
      if (this.selectEnableTfa.val() === "disabled") {
        site = App.Site.first();
        site.require_tfa = false;
        return site.save();
      } else if (this.selectEnableTfa.val() === "enabled") {
        return new App.RedesignTwoFactorUpdateController({
          cancelCallback: this.cancelCallback
        });
      }
    };

    RedesignSettingsSiteTwoFactor.prototype.cancelCallback = function() {
      return this.selectEnableTfa.val("disabled").trigger("chosen:updated");
    };

    RedesignSettingsSiteTwoFactor.prototype.showError = function(message) {
      return this.errorRow.html(message);
    };

    return RedesignSettingsSiteTwoFactor;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.RedesignSettingsSsoConfigFormController = (function(superClass) {
    extend(RedesignSettingsSsoConfigFormController, superClass);

    RedesignSettingsSsoConfigFormController.prototype.elements = {
      '.provider-type select': 'ssoProviderType',
      '.provider-sso-url input': 'ssoUrlInput',
      '.provider-slo-url input': 'sloUrlInput',
      '.provider-identifier input': 'identifierInput',
      '.provider-issuer input': 'providerIssuerInput',
      '.provider-cert textarea': 'certificateInput',
      '.provider-scim-enable-area': 'scimEnableArea',
      '.provider-scim-alerts': 'scimAlertsArea',
      '.default-site-field': 'defaultSiteField',
      '.default-site select': 'defaultSiteSelect',
      '.row .errors.validation': 'errorValidation',
      '.row.button-row': 'submitRow',
      '.button.submit': 'submitButton',
      '.regenerate-scim-key-section': 'scimKeyArea',
      '.scim-key-regenerate-button': 'scimKeyRegenerateButton'
    };

    RedesignSettingsSsoConfigFormController.prototype.events = {
      'change .provider-type select': 'enableSaveButton',
      'change .default-site select': 'enableSaveButton',
      'keyup .provider-sso-url input': 'enableSaveButton',
      'keyup .provider-slo-url input': 'enableSaveButton',
      'keyup .provider-identifier input': 'enableSaveButton',
      'keyup .provider-issuer input': 'enableSaveButton',
      'keyup .provider-cert textarea': 'enableSaveButton',
      'click .button.submit': 'submit',
      'click .help-icon': 'clickHelp',
      'click .scim-key-regenerate-button': 'regenerateScimApiKey'
    };

    RedesignSettingsSsoConfigFormController.SSO_DISABLED = 'disabled';

    RedesignSettingsSsoConfigFormController.SSO_CONFIG_TO_FIELD_NAME = {
      identity_provider_issuer: 'Issuer',
      identity_provider_sso_url: 'SSO URL',
      identity_provider_cert: 'Certificate',
      site_id: 'Default Space'
    };

    RedesignSettingsSsoConfigFormController.AZURE = 'azure';

    function RedesignSettingsSsoConfigFormController() {
      this.saveScimRecipients = bind(this.saveScimRecipients, this);
      this.scimAlertsInit = bind(this.scimAlertsInit, this);
      this.providerSelected = bind(this.providerSelected, this);
      this.validateForm = bind(this.validateForm, this);
      this.clickHelp = bind(this.clickHelp, this);
      this.submit = bind(this.submit, this);
      this.enableSaveButton = bind(this.enableSaveButton, this);
      this.showScimKeyPopup = bind(this.showScimKeyPopup, this);
      this.regenerateScimApiKey = bind(this.regenerateScimApiKey, this);
      this.applyScimChanges = bind(this.applyScimChanges, this);
      RedesignSettingsSsoConfigFormController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.item = App.SsoConfig.first() || new App.SsoConfig();
      if (this.item.site_id == null) {
        this.item.site_id = App.Site.first().id;
      }
      if (this.item.site_id === App.Site.first().id) {
        this.renderEmptyForm();
        this.submitButton.toggleClass('disabled', true);
        this.populateForm();
        this.el.attr('mode', this.ssoProviderType.val() || this.constructor.SSO_DISABLED);
        if (this.scimProvisioningEligible()) {
          this.scimAlertsInit();
          this.scimCheckbox.toggleSelected(this.item.idp_scim_enabled || false);
          this.toggleScimAlertsVisibility();
          this.toggleScimKeyVisibility();
        }
      }
    }

    RedesignSettingsSsoConfigFormController.prototype.scimProvisioningEligible = function() {
      var ref, ref1, state;
      state = AppRedesign.current().state;
      if (!(state.AllowedIdentityProviderTypesForScim && (ref = this.item.identity_provider_type, indexOf.call(state.AllowedIdentityProviderTypesForScim, ref) >= 0))) {
        return;
      }
      return ((ref1 = state.Site) != null ? ref1.scim_provisioning_feature_flag_enabled : void 0) && state.Site.sso_enabled && state.RbacEnabled;
    };

    RedesignSettingsSsoConfigFormController.prototype.renderEmptyForm = function() {
      this.html(this.view('redesign/settings/sso_config_form')({
        azure: this.item.identity_provider_type === this.constructor.AZURE
      }));
      if (!App.Site.isSpacesEnabled()) {
        this.defaultSiteField.hide();
      }
      if (this.scimProvisioningEligible()) {
        this.scimCheckbox = new App.RedesignCheckbox({
          labelText: 'Enable SCIM Provisioning',
          callback: (function(_this) {
            return function() {
              if (_this.scimCheckbox.state()) {
                return new App.RedesignScimUpdateModalController({
                  updatePurpose: 'enable',
                  cancelCallback: function() {
                    return _this.scimCheckbox.toggleSelected(false);
                  },
                  proceedCallback: _this.showScimKeyPopup
                });
              } else {
                return new App.RedesignScimUpdateModalController({
                  updatePurpose: 'disable',
                  cancelCallback: function() {
                    return _this.scimCheckbox.toggleSelected(true);
                  },
                  proceedCallback: _this.applyScimChanges
                });
              }
            };
          })(this)
        });
        return this.scimEnableArea.append(this.scimCheckbox.el);
      }
    };

    RedesignSettingsSsoConfigFormController.prototype.applyScimChanges = function() {
      this.toggleScimAlertsVisibility();
      this.toggleScimKeyVisibility();
      return this.item.dup(false).updateAttributes({
        idp_scim_enabled: this.scimCheckbox.state(),
        skip_logout: true
      });
    };

    RedesignSettingsSsoConfigFormController.prototype.regenerateScimApiKey = function() {
      return new App.RedesignSCIMGeneratedKeyConfirmationModalController({
        proceedCallback: this.showScimKeyPopup
      });
    };

    RedesignSettingsSsoConfigFormController.prototype.showScimKeyPopup = function(loaderContext) {
      return jQuery.post("/sso_configs/" + this.item.id + "/generate_scim_api_key", {
        site_id: this.item.site_id
      }).done((function(_this) {
        return function(response) {
          return new App.RedesignScimGeneratedKeyModalController({
            proceedCallback: _this.applyScimChanges,
            scimKey: (App.Site.first().host) + ":" + response.scim_api_key
          });
        };
      })(this)).fail((function(_this) {
        return function(error) {
          return console.error('Failed to generate new SCIM API Key');
        };
      })(this)).always((function(_this) {
        return function() {
          return loaderContext != null ? loaderContext.disableLoader() : void 0;
        };
      })(this));
    };

    RedesignSettingsSsoConfigFormController.prototype.populateForm = function() {
      var htmlOptions, providerTypeValue, ssoOptions;
      providerTypeValue = this.item.identity_provider_type || App.RedesignSettingsSsoConfigFormController.SSO_DISABLED;
      ssoOptions = App.SsoConfig.optionsForSamlProvider();
      this.ssoProviderType.html(App.Utils.optionsToHtml(ssoOptions, providerTypeValue));
      this.ssoProviderType.chosen({
        width: '100%',
        disable_search: true
      }).on('change', this.providerSelected);
      if (this.showDefaultSiteSelect()) {
        if (this.isCurrentSiteValid()) {
          htmlOptions = App.Utils.optionsToHtml(this.siteOptions(), this.item.site_id);
        } else {
          htmlOptions = App.Utils.optionsToHtmlWithNone(this.siteOptions(), this.item.site_id);
        }
        this.defaultSiteField.show();
        this.defaultSiteSelect.html(htmlOptions);
        this.defaultSiteSelect.chosen({
          width: '100%',
          disable_search: true
        });
      }
      this.ssoUrlInput.val(this.item.identity_provider_sso_url || '');
      if (this.item.identity_provider_type === this.constructor.AZURE) {
        this.sloUrlInput.val(this.item.identity_provider_slo_url || '');
      }
      if (this.item.identity_provider_type === this.constructor.AZURE) {
        this.identifierInput.val(this.item.identifier || '');
      }
      this.providerIssuerInput.val(this.item.identity_provider_issuer || '');
      this.certificateInput.val(this.item.identity_provider_cert || '');
      if (this.scimProvisioningEligible()) {
        this.scimCheckbox.unselect();
        this.toggleScimAlertsVisibility();
        return this.toggleScimKeyVisibility();
      }
    };

    RedesignSettingsSsoConfigFormController.prototype.isCurrentSiteValid = function() {
      var siteIds;
      siteIds = App.Site.first().site_info_list.map(function(site_info) {
        return site_info.id;
      });
      return siteIds.includes(this.item.site_id);
    };

    RedesignSettingsSsoConfigFormController.prototype.showDefaultSiteSelect = function() {
      var site;
      site = App.Site.first();
      return site.isSpacesEnabled() && site.hasMultipleSitesInFamily();
    };

    RedesignSettingsSsoConfigFormController.prototype.siteOptions = function() {
      return App.Site.first().site_info_list.map(function(site_info) {
        return {
          value: site_info.id,
          name: site_info.display_name
        };
      });
    };

    RedesignSettingsSsoConfigFormController.prototype.sanitizedField = function(field) {
      if (typeof field !== 'string') {
        return App.RedesignSettingsSsoConfigFormController.SSO_DISABLED;
      }
      if (field.trim().length === 0) {
        return App.RedesignSettingsSsoConfigFormController.SSO_DISABLED;
      }
      return field.toLowerCase();
    };

    RedesignSettingsSsoConfigFormController.prototype.enableSaveButton = function() {
      if (!this.submitButton.hasClass('disabled')) {
        return;
      }
      return this.submitButton.toggleClass('disabled', false);
    };

    RedesignSettingsSsoConfigFormController.prototype.submit = function() {
      if (this.isDisabled() && (this.item.id != null)) {
        this.openWarningDialog(true);
        return;
      }
      if (!this.validateForm()) {
        return;
      }
      this.item.identity_provider_type = this.ssoProviderType.val();
      this.item.identity_provider_issuer = this.providerIssuerInput.val();
      this.item.identity_provider_cert = this.certificateInput.val();
      this.item.identity_provider_sso_url = this.ssoUrlInput.val();
      if (this.item.identity_provider_type === this.constructor.AZURE) {
        this.item.identity_provider_slo_url = this.sloUrlInput.val();
      }
      if (this.item.identity_provider_type === this.constructor.AZURE) {
        this.item.identifier = this.identifierInput.val();
      }
      if (this.showDefaultSiteSelect()) {
        this.item.site_id = Number(this.defaultSiteSelect.val());
      }
      return this.openWarningDialog(false);
    };

    RedesignSettingsSsoConfigFormController.prototype.clickHelp = function(e) {
      var docUrl, providerType;
      if ($(e.currentTarget).hasClass('default-space')) {
        window.open(AppRedesign.DOC_PATH + '/spaces');
        return;
      }
      providerType = this.ssoProviderType.val();
      docUrl = AppRedesign.DOC_PATH + '/sso-overview';
      switch (providerType) {
        case 'okta':
          docUrl = AppRedesign.DOC_PATH + '/okta';
          break;
        case 'onelogin':
          docUrl = AppRedesign.DOC_PATH + '/onelogin';
          break;
        case 'google':
          docUrl = AppRedesign.DOC_PATH + '/google';
          break;
        case 'azure':
          docUrl = AppRedesign.DOC_PATH + '/azure-active-directory';
      }
      return window.open(docUrl);
    };

    RedesignSettingsSsoConfigFormController.prototype.validateForm = function() {
      var field, invalid, missingFields, msg, titlizedFields;
      this.removeAllErrors();
      missingFields = this.missingFields();
      invalid = false;
      if (missingFields.length > 0) {
        invalid = true;
        titlizedFields = (function() {
          var i, len, results;
          results = [];
          for (i = 0, len = missingFields.length; i < len; i++) {
            field = missingFields[i];
            results.push(this.constructor.SSO_CONFIG_TO_FIELD_NAME[field]);
          }
          return results;
        }).call(this);
        msg = 'Missing required field';
        if (missingFields.length > 1) {
          msg = msg.pluralize();
        }
        this.errorValidation.text(msg + ": " + (titlizedFields.join(', ')));
      }
      return !invalid;
    };

    RedesignSettingsSsoConfigFormController.prototype.removeAllErrors = function() {
      this.errorValidation.text('');
      if (this.scimProvisioningEligible()) {
        return this.scimEmailsList.clearError();
      }
    };

    RedesignSettingsSsoConfigFormController.prototype.missingFields = function() {
      var field, params, value;
      params = this.formParams();
      return (function() {
        var results;
        results = [];
        for (field in params) {
          value = params[field];
          if (value === '') {
            results.push(field);
          }
        }
        return results;
      })();
    };

    RedesignSettingsSsoConfigFormController.prototype.formParams = function() {
      var k, params, v;
      params = {
        identity_provider_type: this.ssoProviderType.val(),
        identity_provider_sso_url: this.ssoUrlInput.val(),
        identity_provider_issuer: this.providerIssuerInput.val(),
        identity_provider_cert: this.certificateInput.val()
      };
      for (k in params) {
        v = params[k];
        if (typeof v === 'string') {
          params[k] = v.trim();
        }
      }
      if (this.showDefaultSiteSelect()) {
        params.site_id = this.defaultSiteSelect.val();
      }
      return params;
    };

    RedesignSettingsSsoConfigFormController.prototype.providerSelected = function(event, param) {
      var ssoTypeValue;
      ssoTypeValue = param.selected;
      return this.maybeShowForms(ssoTypeValue);
    };

    RedesignSettingsSsoConfigFormController.prototype.isDisabled = function() {
      return this.ssoProviderType.val() === this.constructor.SSO_DISABLED;
    };

    RedesignSettingsSsoConfigFormController.prototype.maybeShowForms = function(ssoTypeValue) {
      this.el.attr("mode", ssoTypeValue);
      this.item.identity_provider_type = ssoTypeValue;
      this.renderEmptyForm();
      this.populateForm();
      if (this.scimProvisioningEligible()) {
        this.scimAlertsInit();
        this.scimCheckbox.toggleSelected(this.item.idp_scim_enabled || false);
        this.toggleScimAlertsVisibility();
        this.toggleScimKeyVisibility();
      }
      this.removeAllErrors();
      if (this.item.id != null) {
        return this.submitRow.show();
      }
    };

    RedesignSettingsSsoConfigFormController.prototype.openWarningDialog = function(isDisabled) {
      return new App.RedesignSsoUpdateController({
        item: this.item,
        isDisabled: isDisabled
      });
    };

    RedesignSettingsSsoConfigFormController.prototype.scimAlertsInit = function() {
      this.scimAlertsArea.show();
      this.scimEmailsList = new App.RedesignAddRemoveListController({
        el: this.scimAlertsArea,
        saveCallback: this.saveScimRecipients,
        itemClass: App.RedesignSettingsSsoConfigScimAlertRecipient
      });
      return this.scimEmailsList.addItems(this.parseScimEmails(this.item.idp_scim_alerts_emails).join(','));
    };

    RedesignSettingsSsoConfigFormController.prototype.parseScimEmails = function(values) {
      if (!values) {
        return [];
      }
      values = values.split(/[, ]+/).sort();
      return _.filter(values, function(email) {
        return email !== '';
      });
    };

    RedesignSettingsSsoConfigFormController.prototype.toggleScimAlertsVisibility = function() {
      return this.scimAlertsArea.toggle(this.scimCheckbox.state());
    };

    RedesignSettingsSsoConfigFormController.prototype.toggleScimKeyVisibility = function() {
      return this.scimKeyArea.toggle(this.scimCheckbox.state());
    };

    RedesignSettingsSsoConfigFormController.prototype.saveScimRecipients = function() {
      if (this.item.isNew()) {
        return;
      }
      return this.item.dup(false).updateAttributes({
        idp_scim_alerts_emails: this.scimEmailsList.joinValues(),
        skip_logout: true
      });
    };

    return RedesignSettingsSsoConfigFormController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSettingsSsoConfigScimAlertRecipient = (function(superClass) {
    extend(RedesignSettingsSsoConfigScimAlertRecipient, superClass);

    RedesignSettingsSsoConfigScimAlertRecipient.prototype.className = 'settings-sso-config-scim-alert-recipient';

    RedesignSettingsSsoConfigScimAlertRecipient.prototype.elements = {
      '.recipient-email': 'emailRow',
      '.remove-icon': 'removeButton'
    };

    RedesignSettingsSsoConfigScimAlertRecipient.prototype.events = {
      'click .remove-icon': 'clickedRemove'
    };

    function RedesignSettingsSsoConfigScimAlertRecipient() {
      this.clickedRemove = bind(this.clickedRemove, this);
      RedesignSettingsSsoConfigScimAlertRecipient.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'value', 'onRemove');
      this.html(this.view('redesign/settings/sso_config_scim_alert_recipient')());
      this.emailRow.text(this.value);
    }

    RedesignSettingsSsoConfigScimAlertRecipient.prototype.clickedRemove = function(e) {
      return this.onRemove(this.emailRow.text());
    };

    return RedesignSettingsSsoConfigScimAlertRecipient;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSsoUpdateController = (function(superClass) {
    extend(RedesignSsoUpdateController, superClass);

    RedesignSsoUpdateController.prototype.className = 'sso-update modal';

    RedesignSsoUpdateController.prototype.elements = {
      'input.update-confirm': 'updateConfirmInput',
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    RedesignSsoUpdateController.prototype.events = {
      'click .cancel-icon': 'cancel',
      'keyup input.update-confirm': 'updateConfirmKeyup'
    };

    function RedesignSsoUpdateController() {
      this.logout = bind(this.logout, this);
      this.remove = bind(this.remove, this);
      this.updateConfirmKeyup = bind(this.updateConfirmKeyup, this);
      this.cancel = bind(this.cancel, this);
      RedesignSsoUpdateController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'isDisabled');
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignSsoUpdateController.prototype.render = function() {
      this.html(this.view('redesign/settings/sso_update_form')());
      this.cancelRemoveBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.remove,
        saveText: 'CONFIRM',
        saveButtonClass: 'destructive'
      });
      this.cancelRemoveBlock.saveButton.toggleClass("disabled", true);
      this.rightAlignedButtons.append(this.cancelRemoveBlock.el);
      return $('#modal').html(this.el);
    };

    RedesignSsoUpdateController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignSsoUpdateController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignSsoUpdateController.prototype.cancel = function() {
      return this.release();
    };

    RedesignSsoUpdateController.prototype.updateIsConfirmed = function() {
      return this.updateConfirmInput.val().trim().toLowerCase() === 'logout';
    };

    RedesignSsoUpdateController.prototype.updateConfirmKeyup = function(e) {
      if (e.which === AppRedesign.KEYS.ENTER) {
        return this.cancelRemoveBlock.saveClicked();
      } else {
        return this.cancelRemoveBlock.saveButton.toggleClass("disabled", !this.updateIsConfirmed());
      }
    };

    RedesignSsoUpdateController.prototype.remove = function() {
      if (this.isDisabled) {
        return this.item.destroy({
          success: this.logout
        });
      } else {
        return this.item.save({
          success: this.logout
        });
      }
    };

    RedesignSsoUpdateController.prototype.logout = function() {
      App.Utils.logFeature('logout-from-periscope');
      AppRedesign.setDocumentTitle('Periscope');
      window.location = '/users/logout?ignore_just_logged_out=true&do_not_redirect=true';
      return this.release();
    };

    return RedesignSsoUpdateController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignTwoFactorUpdateController = (function(superClass) {
    extend(RedesignTwoFactorUpdateController, superClass);

    RedesignTwoFactorUpdateController.prototype.className = 'two-factor-update modal';

    RedesignTwoFactorUpdateController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    RedesignTwoFactorUpdateController.prototype.events = {
      'click .cancel-icon': 'cancel'
    };

    function RedesignTwoFactorUpdateController() {
      this.proceed = bind(this.proceed, this);
      this.cancel = bind(this.cancel, this);
      RedesignTwoFactorUpdateController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "cancelCallback");
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignTwoFactorUpdateController.prototype.render = function() {
      this.html(this.view('redesign/settings/two_factor_update_form')());
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.proceed,
        saveText: 'PROCEED'
      });
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      $('#modal').empty();
      return $('#modal').append(this.el);
    };

    RedesignTwoFactorUpdateController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignTwoFactorUpdateController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignTwoFactorUpdateController.prototype.cancel = function() {
      this.cancelCallback();
      return this.release();
    };

    RedesignTwoFactorUpdateController.prototype.proceed = function() {
      var site;
      site = App.Site.first();
      site.require_tfa = true;
      site.save();
      jQuery.get("/users/logout", {}).always((function() {
        AppRedesign.setDocumentTitle('Periscope');
        return window.location.reload();
      }));
      return this.release();
    };

    return RedesignTwoFactorUpdateController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignSCIMGeneratedKeyConfirmationModalController = (function(superClass) {
    extend(RedesignSCIMGeneratedKeyConfirmationModalController, superClass);

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.className = 'scim-key confirmation_modal modal';

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons',
      '.scim-key-tooltip': 'scimKeyTooltip',
      '.scim-key-input': 'scimKeyInput'
    };

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.events = {
      'click .cancel-icon': 'release'
    };

    function RedesignSCIMGeneratedKeyConfirmationModalController() {
      this.proceed = bind(this.proceed, this);
      RedesignSCIMGeneratedKeyConfirmationModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "proceedCallback");
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.render = function() {
      this.html(this.view('redesign/settings/scim/scim_generated_key_confirmation_form')());
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.release,
        saveFunc: this.proceed,
        saveText: "Generate Key"
      });
      this.cancelProceedBlock.saveButton.addClass('generate-scim-key-save-button');
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      $('#modal').empty();
      return $('#modal').append(this.el);
    };

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignSCIMGeneratedKeyConfirmationModalController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignSCIMGeneratedKeyConfirmationModalController.prototype.proceed = function() {
      this.proceedCallback();
      return this.release();
    };

    return RedesignSCIMGeneratedKeyConfirmationModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignScimGeneratedKeyModalController = (function(superClass) {
    extend(RedesignScimGeneratedKeyModalController, superClass);

    RedesignScimGeneratedKeyModalController.prototype.className = 'scim-key modal';

    RedesignScimGeneratedKeyModalController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons',
      '.scim-key-tooltip': 'scimKeyTooltip',
      '.scim-key-input': 'scimKeyInput'
    };

    RedesignScimGeneratedKeyModalController.prototype.events = {
      'click .cancel-icon': 'proceed',
      'click .scim-key-input': 'keyClick'
    };

    function RedesignScimGeneratedKeyModalController() {
      this.proceed = bind(this.proceed, this);
      this.keyClick = bind(this.keyClick, this);
      RedesignScimGeneratedKeyModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "proceedCallback");
      App.Utils.requires(this, "scimKey");
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignScimGeneratedKeyModalController.prototype.render = function() {
      this.html(this.view('redesign/settings/scim/scim_generated_key_form')({
        scimKey: this.scimKey
      }));
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.proceed,
        saveFunc: this.proceed,
        saveText: 'Close',
        hideCancel: true
      });
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      return $('#modal').html(this.el);
    };

    RedesignScimGeneratedKeyModalController.prototype.keyClick = function(e) {
      this.copyKeyToClipboard();
      return this.scimKeyTooltip.html('Copied to clipboard');
    };

    RedesignScimGeneratedKeyModalController.prototype.copyKeyToClipboard = function() {
      this.scimKeyInput.select();
      document.execCommand('copy');
      return window.getSelection().removeAllRanges();
    };

    RedesignScimGeneratedKeyModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignScimGeneratedKeyModalController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignScimGeneratedKeyModalController.prototype.proceed = function() {
      this.proceedCallback();
      return this.release();
    };

    return RedesignScimGeneratedKeyModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignScimUpdateModalController = (function(superClass) {
    extend(RedesignScimUpdateModalController, superClass);

    RedesignScimUpdateModalController.prototype.className = 'scim-enable modal';

    RedesignScimUpdateModalController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons',
      '.loader': 'scimLoader',
      '.body': 'modalBody',
      '.button-row': 'modalButtons',
      '.cancel-icon': 'cancelIcon'
    };

    RedesignScimUpdateModalController.prototype.events = {
      'click .cancel-icon': 'cancel'
    };

    function RedesignScimUpdateModalController() {
      this.proceed = bind(this.proceed, this);
      this.enableLoader = bind(this.enableLoader, this);
      this.disableLoader = bind(this.disableLoader, this);
      this.cancel = bind(this.cancel, this);
      RedesignScimUpdateModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, "cancelCallback");
      App.Utils.requires(this, "proceedCallback");
      App.Utils.requires(this, 'updatePurpose');
      App.Site.trigger('enter-modal');
      this.render();
    }

    RedesignScimUpdateModalController.prototype.render = function() {
      this.html(this.view("redesign/settings/scim/scim_provisioning_" + this.updatePurpose + "_form")());
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.cancel,
        saveFunc: this.proceed,
        saveText: this.updatePurpose,
        saveButtonClass: this.updatePurpose === 'enable' ? 'action' : 'destructive'
      });
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      return $('#modal').html(this.el);
    };

    RedesignScimUpdateModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return RedesignScimUpdateModalController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    RedesignScimUpdateModalController.prototype.cancel = function() {
      this.cancelCallback();
      return this.release();
    };

    RedesignScimUpdateModalController.prototype.disableLoader = function() {
      this.scimLoader.hide();
      this.modalBody.show();
      this.modalButtons.show();
      return this.cancelIcon.show();
    };

    RedesignScimUpdateModalController.prototype.enableLoader = function() {
      this.scimLoader.show();
      this.modalBody.hide();
      this.modalButtons.hide();
      return this.cancelIcon.hide();
    };

    RedesignScimUpdateModalController.prototype.proceed = function() {
      this.enableLoader();
      this.proceedCallback({
        disableLoader: this.disableLoader
      });
      if (this.updatePurpose === 'disable') {
        return this.release();
      }
    };

    return RedesignScimUpdateModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SlackSettingsController = (function(superClass) {
    extend(SlackSettingsController, superClass);

    SlackSettingsController.prototype.className = 'slack-settings site-list-panel';

    SlackSettingsController.prototype.elements = {
      '.site-list': 'siteList'
    };

    SlackSettingsController.prototype.events = {
      'click .install': 'installClicked',
      'click .save': 'saveClicked',
      'click .cancel': 'cancelClicked'
    };

    function SlackSettingsController() {
      this.render = bind(this.render, this);
      this.installClicked = bind(this.installClicked, this);
      this.saveClicked = bind(this.saveClicked, this);
      this.cancelClicked = bind(this.cancelClicked, this);
      this.checkboxChecked = bind(this.checkboxChecked, this);
      SlackSettingsController.__super__.constructor.apply(this, arguments);
      App.SlackTeam.bind('change delete', this.render);
      this.helper = new App.SlackSettingsHelper();
      this.helper.bind('data-loaded', this.render);
    }

    SlackSettingsController.prototype.release = function() {
      var ref;
      this.helper.release();
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      this.releaseCheckboxes();
      App.SlackTeam.unbind('change delete', this.render);
      return SlackSettingsController.__super__.release.apply(this, arguments);
    };

    SlackSettingsController.prototype.checkboxChecked = function() {
      return this.el.find('.disabled').removeClass('disabled');
    };

    SlackSettingsController.prototype.cancelClicked = function() {
      return this.render();
    };

    SlackSettingsController.prototype.saveClicked = function() {
      var cb;
      return this.helper.updateTeams((function() {
        var i, len, ref, results;
        ref = this.checkboxes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          cb = ref[i];
          results.push([cb.value, cb.state()]);
        }
        return results;
      }).call(this));
    };

    SlackSettingsController.prototype.installClicked = function() {
      return this.helper.install();
    };

    SlackSettingsController.prototype.render = function() {
      if (App.SlackTeam.count() > 0) {
        this.renderCheckboxList();
        return this.renderButtons();
      } else {
        return this.html(this.view('redesign/settings/slack/add_to_slack')());
      }
    };

    SlackSettingsController.prototype.renderCheckboxList = function() {
      var c, siteInfo;
      this.releaseCheckboxes();
      this.html(this.view('redesign/settings/slack/slack_settings')());
      this.checkboxes = (function() {
        var i, len, ref, results;
        ref = App.Site.allSites();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          siteInfo = ref[i];
          results.push(this.buildCheckbox(siteInfo));
        }
        return results;
      }).call(this);
      return this.siteList.append((function() {
        var i, len, ref, results;
        ref = this.checkboxes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          c = ref[i];
          results.push(c.el);
        }
        return results;
      }).call(this));
    };

    SlackSettingsController.prototype.renderButtons = function() {
      if (AppRedesign.isRedesignMode()) {
        return this.renderRedesignButtons();
      } else {
        return this.el.append(this.view('redesign/settings/slack/legacy_button_block')());
      }
    };

    SlackSettingsController.prototype.renderRedesignButtons = function() {
      var ref;
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      this.buttons = new App.ButtonBlock({
        deleteDisabled: true,
        action: 'save'
      });
      this.buttons.bind('cancel', this.cancelClicked);
      this.buttons.bind('save', this.saveClicked);
      this.el.append(this.buttons.el);
      this.buttons.render();
      return this.el.find('.button').addClass('disabled');
    };

    SlackSettingsController.prototype.buildCheckbox = function(siteInfo) {
      if (AppRedesign.isRedesignMode()) {
        return new App.RedesignCheckbox({
          labelText: siteInfo.display_name,
          value: siteInfo.id,
          initialState: App.SlackTeam.forSite(siteInfo.id),
          callback: this.checkboxChecked
        });
      } else {
        return new App.Checkbox({
          textLabel: siteInfo.display_name,
          value: siteInfo.id,
          initialState: App.SlackTeam.forSite(siteInfo.id),
          callback: this.checkboxChecked,
          el: $('<div class="checkbox"></div>')
        });
      }
    };

    SlackSettingsController.prototype.releaseCheckboxes = function() {
      var c, i, len, ref, results;
      if (this.checkboxes != null) {
        ref = this.checkboxes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          c = ref[i];
          results.push(c.release());
        }
        return results;
      }
    };

    return SlackSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SlackSettingsHelper = (function(superClass) {
    extend(SlackSettingsHelper, superClass);

    function SlackSettingsHelper() {
      this.loadSlackTeams = bind(this.loadSlackTeams, this);
      this.getSlackTeams = bind(this.getSlackTeams, this);
      this.smartFetcher = new App.SmartFetcher(((function(_this) {
        return function() {
          return _this.getSlackTeams;
        };
      })(this)), true);
      this.smartFetcher.startNow();
    }

    SlackSettingsHelper.prototype.release = function() {
      return this.smartFetcher.stop();
    };

    SlackSettingsHelper.prototype.install = function() {
      window.open("/slack/install?client_site_ids=" + (App.Site.first().id));
      return this.smartFetcher.startQuickly();
    };

    SlackSettingsHelper.prototype.updateTeams = function(siteSlackInfo) {
      var i, info, len, siteId, sitesToAdd, sitesToDelete, slackShouldExist, slackTeam;
      sitesToAdd = [];
      sitesToDelete = [];
      for (i = 0, len = siteSlackInfo.length; i < len; i++) {
        info = siteSlackInfo[i];
        siteId = info[0], slackShouldExist = info[1];
        slackTeam = App.SlackTeam.forSite(siteId);
        if (Boolean(slackShouldExist) === Boolean(slackTeam)) {
          continue;
        }
        if (slackShouldExist) {
          sitesToAdd.push(siteId);
        } else {
          sitesToDelete.push(siteId);
        }
      }
      return jQuery.post("/slack_teams/update", {
        add: sitesToAdd,
        remove: sitesToDelete,
        client_site_id: App.Site.first().id
      }).done(this.handleSlackTeamResponse);
    };

    SlackSettingsHelper.prototype.handleSlackTeamResponse = function(response) {
      var base, i, id, len, ref, results;
      if (response.added) {
        App.SlackTeam.applyUpdates(response.added);
      }
      if (response.removed) {
        ref = response.removed;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          id = ref[i];
          results.push(typeof (base = App.SlackTeam.forSite(id)).destroy === "function" ? base.destroy({
            ajax: false
          }) : void 0);
        }
        return results;
      }
    };

    SlackSettingsHelper.prototype.getSlackTeams = function() {
      return jQuery.get("/slack_teams", {
        client_site_id: App.Site.first().id
      }).done(this.loadSlackTeams);
    };

    SlackSettingsHelper.prototype.loadSlackTeams = function(response) {
      if (response.SlackTeam != null) {
        App.SlackTeam.applyUpdates(response.SlackTeam);
      }
      if (!this.firstResponseCompleted) {
        this.trigger('data-loaded');
      }
      return this.firstResponseCompleted = true;
    };

    return SlackSettingsHelper;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SupportAccessSettingsController = (function(superClass) {
    extend(SupportAccessSettingsController, superClass);

    SupportAccessSettingsController.prototype.className = 'support-access-settings';

    SupportAccessSettingsController.APPLIES_TO_ALL_SPACES = false;

    SupportAccessSettingsController.TITLE = 'Support Access';

    SupportAccessSettingsController.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    function SupportAccessSettingsController() {
      SupportAccessSettingsController.__super__.constructor.apply(this, arguments);
      this.render();
    }

    SupportAccessSettingsController.prototype.render = function() {
      return this.reactRoot = window.reactApp.supportAccessSettingsRoot(this.el[0]);
    };

    SupportAccessSettingsController.prototype.release = function() {
      this.reactRoot.close();
      return SupportAccessSettingsController.__super__.release.apply(this, arguments);
    };

    return SupportAccessSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UnarchiveButtonBlock = (function(superClass) {
    extend(UnarchiveButtonBlock, superClass);

    UnarchiveButtonBlock.prototype.className = 'button-block';

    UnarchiveButtonBlock.prototype.elements = {
      '.cancel.button': 'cancelButton'
    };

    UnarchiveButtonBlock.prototype.events = {
      'click .show-delete': 'showDeleteClicked',
      'click .cancel': 'cancelClicked',
      'click .delete': 'deleteClicked',
      'click .action': 'unarchiveClicked'
    };

    function UnarchiveButtonBlock() {
      this.cancelClicked = bind(this.cancelClicked, this);
      this.unarchiveClicked = bind(this.unarchiveClicked, this);
      this.deleteClicked = bind(this.deleteClicked, this);
      this.showDeleteClicked = bind(this.showDeleteClicked, this);
      UnarchiveButtonBlock.__super__.constructor.apply(this, arguments);
      this.render();
    }

    UnarchiveButtonBlock.prototype.render = function() {
      this.html(this.view('redesign/controls/unarchive_button_block')({
        itemName: this.itemName,
        delete_disabled: false
      }));
      return this.cancelButton.hide();
    };

    UnarchiveButtonBlock.prototype.showDeleteClicked = function() {
      this.el.addClass('show-delete-confirm');
      this.cancelButton.show();
      return this.trigger('size-changed');
    };

    UnarchiveButtonBlock.prototype.deleteClicked = function() {
      return this.trigger('perma-delete-archive');
    };

    UnarchiveButtonBlock.prototype.unarchiveClicked = function() {
      return this.trigger('unarchive');
    };

    UnarchiveButtonBlock.prototype.cancelClicked = function() {
      this.el.removeClass('show-delete-confirm');
      this.cancelButton.hide();
      return this.trigger('size-changed');
    };

    return UnarchiveButtonBlock;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UsageDataSettingsController = (function(superClass) {
    extend(UsageDataSettingsController, superClass);

    UsageDataSettingsController.APPLIES_TO_ALL_SPACES = true;

    UsageDataSettingsController.TITLE = 'Usage Data';

    UsageDataSettingsController.prototype.className = 'usage-data-settings settings-area';

    UsageDataSettingsController.prototype.elements = {
      '.area-body': 'areaBody',
      '.site-picker': 'sitePicker',
      '.button': 'buttonEl',
      '.button-row': 'buttonRow'
    };

    UsageDataSettingsController.prototype.events = {
      'change .site-picker': 'siteSelected'
    };

    UsageDataSettingsController.prototype.currentlySelectedSite = function() {
      return this.usageDataHelper().currentlySelectedSite();
    };

    function UsageDataSettingsController() {
      this.saveClicked = bind(this.saveClicked, this);
      this.cancelClicked = bind(this.cancelClicked, this);
      this.toggled = bind(this.toggled, this);
      this.siteSelected = bind(this.siteSelected, this);
      UsageDataSettingsController.__super__.constructor.apply(this, arguments);
      this.render();
    }

    UsageDataSettingsController.prototype.usageDataHelper = function() {
      return this._helper || (this._helper = new App.UsageDataHelper((function(_this) {
        return function() {
          return _this.render();
        };
      })(this)));
    };

    UsageDataSettingsController.prototype.render = function() {
      this.html(this.view('redesign/settings/usage_data_panel')({
        eligibleSites: this.usageDataHelper().eligibleSites(),
        siteFamilyEnabled: App.Site.isSpacesEnabled(),
        selectedSite: this.currentlySelectedSite()
      }));
      if (App.Site.isSpacesEnabled()) {
        return this.renderSitePicker();
      } else {
        return this.renderToggler();
      }
    };

    UsageDataSettingsController.prototype.renderSitePicker = function() {
      this.sitePicker.chosen({
        disable_search: true,
        width: '100%'
      });
      this.buttons = new App.ButtonBlock({
        deleteDisabled: true,
        action: 'update'
      });
      this.buttons.bind('cancel', this.cancelClicked);
      this.buttons.bind('update', this.saveClicked);
      this.buttonRow.append(this.buttons.el);
      this.buttons.render();
      this.refreshElements();
      return this.resetSiteSelector();
    };

    UsageDataSettingsController.prototype.currentSiteChosen = function() {
      return _.toString(this.sitePicker.val()) === _.toString(this.currentlySelectedSite());
    };

    UsageDataSettingsController.prototype.siteSelected = function() {
      return this.buttonEl.toggleClass('disabled', this.currentSiteChosen());
    };

    UsageDataSettingsController.prototype.renderToggler = function() {
      this.toggler = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: Boolean(this.currentlySelectedSite()),
        labelWhenToggleOn: 'Allow users to query usage data',
        labelWhenToggleOff: 'Allow users to query usage data'
      });
      this.toggler.bind('toggled', this.toggled);
      return this.areaBody.append(this.toggler.el);
    };

    UsageDataSettingsController.prototype.toggled = function(enabled) {
      if (enabled) {
        this.usageDataHelper().enableForSite(App.Site.first().id);
      } else {
        this.usageDataHelper().disable();
      }
      return enabled;
    };

    UsageDataSettingsController.prototype.resetSiteSelector = function() {
      this.sitePicker.val(this.currentlySelectedSite());
      this.sitePicker.chosen().trigger('chosen:updated');
      return this.siteSelected();
    };

    UsageDataSettingsController.prototype.cancelClicked = function() {
      return this.resetSiteSelector();
    };

    UsageDataSettingsController.prototype.saveClicked = function() {
      if (this.sitePicker.val()) {
        this.usageDataHelper().enableForSite(this.sitePicker.val());
      } else {
        this.usageDataHelper().disable();
      }
      return this.buttonEl.addClass('disabled');
    };

    UsageDataSettingsController.prototype.release = function() {
      var ref, ref1;
      if ((ref = this.buttons) != null) {
        ref.release();
      }
      if ((ref1 = this.toggler) != null) {
        ref1.release();
      }
      return UsageDataSettingsController.__super__.release.apply(this, arguments);
    };

    return UsageDataSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UserApiKeyConfirmationModalController = (function(superClass) {
    extend(UserApiKeyConfirmationModalController, superClass);

    UserApiKeyConfirmationModalController.prototype.className = 'user-api-key confirmation modal';

    UserApiKeyConfirmationModalController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons'
    };

    UserApiKeyConfirmationModalController.prototype.events = {
      'click .cancel-icon': 'release'
    };

    function UserApiKeyConfirmationModalController() {
      this.proceed = bind(this.proceed, this);
      UserApiKeyConfirmationModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'proceedCallback');
      App.Site.trigger('enter-modal');
      this.render();
    }

    UserApiKeyConfirmationModalController.prototype.render = function() {
      this.html(this.view('redesign/settings/site_settings_api_key_confirmation')());
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.release,
        saveFunc: this.proceed,
        saveText: 'Generate'
      });
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      return $('#modal').html(this.el);
    };

    UserApiKeyConfirmationModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return UserApiKeyConfirmationModalController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    UserApiKeyConfirmationModalController.prototype.proceed = function() {
      this.proceedCallback();
      return this.release();
    };

    return UserApiKeyConfirmationModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.UserApiKeyGeneratedModalController = (function(superClass) {
    extend(UserApiKeyGeneratedModalController, superClass);

    UserApiKeyGeneratedModalController.prototype.className = 'user-api-key generated modal';

    UserApiKeyGeneratedModalController.prototype.elements = {
      '.right-aligned-buttons': 'rightAlignedButtons',
      '.api-key-tooltip': 'apiKeyTooltip',
      '.api-key-input': 'apiKeyInput'
    };

    UserApiKeyGeneratedModalController.prototype.events = {
      'click .cancel-icon': 'proceed',
      'click .api-key-input': 'keyClick'
    };

    function UserApiKeyGeneratedModalController() {
      this.proceed = bind(this.proceed, this);
      this.keyClick = bind(this.keyClick, this);
      UserApiKeyGeneratedModalController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'apiKey');
      App.Site.trigger('enter-modal');
      this.render();
    }

    UserApiKeyGeneratedModalController.prototype.render = function() {
      this.html(this.view('redesign/settings/user_api_key_generated_form')({
        apiKey: this.apiKey
      }));
      this.cancelProceedBlock = new App.CancelSaveBlock({
        cancelFunc: this.proceed,
        saveFunc: this.proceed,
        saveText: 'Close',
        hideCancel: true
      });
      this.rightAlignedButtons.append(this.cancelProceedBlock.el);
      return $('#modal').html(this.el);
    };

    UserApiKeyGeneratedModalController.prototype.keyClick = function(e) {
      this.copyKeyToClipboard();
      return this.apiKeyTooltip.html('Copied to clipboard');
    };

    UserApiKeyGeneratedModalController.prototype.copyKeyToClipboard = function() {
      this.apiKeyInput.select();
      document.execCommand('copy');
      return window.getSelection().removeAllRanges();
    };

    UserApiKeyGeneratedModalController.prototype.release = function() {
      App.Site.trigger('exit-modal');
      return setTimeout(((function(_this) {
        return function() {
          return UserApiKeyGeneratedModalController.__super__.release.apply(_this, arguments);
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    UserApiKeyGeneratedModalController.prototype.proceed = function() {
      return this.release();
    };

    return UserApiKeyGeneratedModalController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.VersionControlSettingsPageController = (function(superClass) {
    extend(VersionControlSettingsPageController, superClass);

    VersionControlSettingsPageController.APPLIES_TO_ALL_SPACES = false;

    VersionControlSettingsPageController.TITLE = 'Version Control';

    VersionControlSettingsPageController.EXTEND_HEADER = false;

    VersionControlSettingsPageController.MIN_PANEL_HEIGHT = 400;

    VersionControlSettingsPageController.VERT_PIXELS_USED_BY_OTHERS = 144;

    VersionControlSettingsPageController.prototype.className = 'site-settings settings-area';

    VersionControlSettingsPageController.prototype.elements = {
      '.version-control-container': 'versionControlContainer'
    };

    function VersionControlSettingsPageController() {
      VersionControlSettingsPageController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.initialize();
    }

    VersionControlSettingsPageController.prototype.initialize = function() {
      this.html(this.view('redesign/settings/version_control')());
      return this.attachReactAndRender();
    };

    VersionControlSettingsPageController.prototype.attachReactAndRender = function() {
      App.Utils.logFeature("version-control-setting-page-open");
      if (!window.reactApp) {
        return;
      }
      return this.reactRoot = window.reactApp.versionControlRoot(this.versionControlContainer[0], this.badSnippetNames());
    };

    VersionControlSettingsPageController.prototype.badSnippetNames = function() {
      var badNames, id, ref, snippet;
      badNames = [];
      ref = App.SqlSnippet.records;
      for (id in ref) {
        snippet = ref[id];
        if (App.SqlSnippet.INVALID_FILENAME_REGEX.test(snippet.name)) {
          badNames.push(snippet.displayName());
        }
      }
      return badNames;
    };

    VersionControlSettingsPageController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return VersionControlSettingsPageController.__super__.release.apply(this, arguments);
    };

    return VersionControlSettingsPageController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SharedDashboardPasswordController = (function(superClass) {
    extend(SharedDashboardPasswordController, superClass);

    SharedDashboardPasswordController.prototype.elements = {
      '.shared-dashboard-password input': 'passwordInput',
      '.password-incorrect-message': 'passwordIncorrectMessage',
      '.button.action-medium': 'submitButton'
    };

    SharedDashboardPasswordController.prototype.events = {
      'click .button': 'submitClicked',
      'keyup .shared-dashboard-password input': 'passwordInputChanged'
    };

    SharedDashboardPasswordController.COOKIE_EXPIRATION = 30;

    function SharedDashboardPasswordController() {
      this.verifyUserEnteredPassword = bind(this.verifyUserEnteredPassword, this);
      this.userEnteredPasswordSuccessfullyChecked = bind(this.userEnteredPasswordSuccessfullyChecked, this);
      this.sessionPasswordSuccessfullyChecked = bind(this.sessionPasswordSuccessfullyChecked, this);
      SharedDashboardPasswordController.__super__.constructor.apply(this, arguments);
      this.throttledVerifyUserEnteredPassword = _.throttle(this.verifyUserEnteredPassword, 2000);
      jQuery.ajax({
        type: 'get',
        url: "/shared_dashboards/" + this.sharedDashboard.token + "/check_encrypted_session_password",
        success: this.sessionPasswordSuccessfullyChecked
      });
    }

    SharedDashboardPasswordController.prototype.sessionPasswordSuccessfullyChecked = function(response) {
      if (response.password_match) {
        return this.appRedesign.renderSharedModeFrame();
      } else {
        return this.render();
      }
    };

    SharedDashboardPasswordController.prototype.render = function() {
      return this.html(this.view('redesign/dashboards/shared_dashboard_password')());
    };

    SharedDashboardPasswordController.prototype.passwordInputChanged = function(keyPressed) {
      var inputEmpty;
      inputEmpty = _.isEmpty(this.passwordInput.val());
      this.submitButton.toggleClass('disabled', inputEmpty);
      if (!inputEmpty) {
        this.passwordIncorrectMessage.addClass('hidden');
        if (keyPressed.which === AppRedesign.KEYS.ENTER) {
          return this.submitClicked();
        }
      }
    };

    SharedDashboardPasswordController.prototype.submitClicked = function() {
      this.throttledVerifyUserEnteredPassword(this.passwordInput.val());
      this.passwordInput.val('');
      return this.submitButton.addClass('disabled');
    };

    SharedDashboardPasswordController.prototype.userEnteredPasswordSuccessfullyChecked = function(response) {
      if (response.password_match) {
        return this.appRedesign.renderSharedModeFrame();
      } else {
        return this.passwordIncorrectMessage.removeClass('hidden');
      }
    };

    SharedDashboardPasswordController.prototype.verifyUserEnteredPassword = function(password) {
      return jQuery.ajax({
        type: 'post',
        url: "/shared_dashboards/" + this.sharedDashboard.token + "/check_password",
        data: {
          password: password
        },
        success: this.userEnteredPasswordSuccessfullyChecked
      });
    };

    return SharedDashboardPasswordController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlSnippetViewSettingsController = (function(superClass) {
    extend(SqlSnippetViewSettingsController, superClass);

    SqlSnippetViewSettingsController.prototype.className = 'sql-snippet-settings';

    SqlSnippetViewSettingsController.prototype.elements = {
      '.default-settings-area': 'defaultSettingsArea',
      '.badge-toggle-area': 'badgeToggleArea'
    };

    function SqlSnippetViewSettingsController() {
      SqlSnippetViewSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    SqlSnippetViewSettingsController.prototype.release = function() {
      var ref;
      this.defaultSettingsController.release();
      if ((ref = this.badgeToggleSettingsController) != null) {
        ref.release();
      }
      return SqlSnippetViewSettingsController.__super__.release.apply(this, arguments);
    };

    SqlSnippetViewSettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/sql_snippet_settings')({
        badgeToggleEnabled: AppRedesign.dashboardOrganizationEnabled()
      }));
      this.renderDefaultSettingsArea();
      return this.renderBadgeToggleArea();
    };

    SqlSnippetViewSettingsController.prototype.renderDefaultSettingsArea = function() {
      this.defaultSettingsController = new App.DefaultEditorSettingsController({
        item: this.item,
        hideMainHeader: true
      });
      this.defaultSettingsController.one('right-panel-settings-changed', ((function(_this) {
        return function() {
          return _this.triggerOnce('right-panel-settings-changed');
        };
      })(this)));
      return this.defaultSettingsArea.append(this.defaultSettingsController.el);
    };

    SqlSnippetViewSettingsController.prototype.refresh = function() {
      return this.defaultSettingsController.refresh();
    };

    SqlSnippetViewSettingsController.prototype.renderBadgeToggleArea = function() {
      if (!(AppRedesign.dashboardOrganizationEnabled() && App.User.currentUser().isAdmin())) {
        return;
      }
      this.badgeToggleSettingsController = new App.BadgeToggleSettingsController({
        item: this.item,
        editHelper: this.editHelper,
        hasDetail: true
      });
      return this.badgeToggleArea.append(this.badgeToggleSettingsController.el);
    };

    return SqlSnippetViewSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableChartHandler = (function(superClass) {
    extend(TableChartHandler, superClass);

    function TableChartHandler() {
      TableChartHandler.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item', 'contentEl', 'tableChart');
    }

    TableChartHandler.prototype.addPivot = function() {
      var ref, ref1;
      if (this.pivotSettingsPosition != null) {
        this.closePivot();
        return;
      }
      if (((ref = this.tableChart) != null ? ref.twiddles : void 0) == null) {
        return;
      }
      return this.pivotSettingsPosition = new App.RedesignPivotSettingsPosition(this.contentEl, (ref1 = this.tableChart) != null ? ref1.twiddles : void 0, this.item, this.exitPivot);
    };

    TableChartHandler.prototype.exitPivot = function() {
      return this.pivotSettingsPosition = null;
    };

    TableChartHandler.prototype.toggleSearch = function() {
      return this.tableChart.toggleSearch();
    };

    TableChartHandler.prototype.close = function() {
      return this.closePivot();
    };

    TableChartHandler.prototype.closePivot = function() {
      var ref;
      if ((ref = this.pivotSettingsPosition) != null) {
        ref.exitPivotInDashboard();
      }
      return this.exitPivot();
    };

    TableChartHandler.prototype.resize = function() {
      var ref;
      return (ref = this.pivotSettingsPosition) != null ? ref.resize() : void 0;
    };

    return TableChartHandler;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TableColorPickerController = (function(superClass) {
    extend(TableColorPickerController, superClass);

    function TableColorPickerController() {
      this.render = bind(this.render, this);
      return TableColorPickerController.__super__.constructor.apply(this, arguments);
    }

    TableColorPickerController.prototype.className = 'gradient-color-picker';

    TableColorPickerController.prototype.elements = {
      '.custom.color-content': 'colorPickerArea',
      '.recent.color-content': 'recentColorsArea',
      '.theme.color-content': 'themeColorsArea'
    };

    TableColorPickerController.prototype.events = {
      'click .action.reset': 'resetColor',
      'click .action.save': 'updateAndRelease',
      'click .rotator-title': 'toggleRotator',
      'click .color-type': 'selectColor'
    };

    TableColorPickerController.prototype.render = function() {
      this.html(this.view('redesign/settings/table_color_picker')());
      return TableColorPickerController.__super__.render.apply(this, arguments);
    };

    return TableColorPickerController;

  })(App.DualColorPickerController);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TextBoxController = (function(superClass) {
    extend(TextBoxController, superClass);

    TextBoxController.prototype.className = 'text-box';

    TextBoxController.prototype.elements = {
      '.text-box-react-div': 'textBoxReactDiv'
    };

    function TextBoxController() {
      this.coverMouseDown = bind(this.coverMouseDown, this);
      this.repositionChart = bind(this.repositionChart, this);
      this.resizeCharts = bind(this.resizeCharts, this);
      this.flash = bind(this.flash, this);
      TextBoxController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.el.addClass("text-box-" + this.item.id);
      this.html(this.view('redesign/dashboards/text_box')());
      this.textBox = this.item.content();
      this.reactRoot = window.reactApp.textBoxRoot(this.textBoxReactDiv[0], this.textBox, this.item.id, this.editable());
      this.el.find('.cover').on('mousedown', this.coverMouseDown);
      this.dashboardSizer = new App.RedesignDashboardSizer(App.Dashboard.currentDashboard());
      this.el.append(this.view('resize_handle')());
      this.chartContainerResize = new App.ChartContainerResizer({
        el: this.el,
        dashboardSizer: this.dashboardSizer,
        item: this.item,
        isResizableFunc: function() {
          return true;
        },
        resizeChartsFunc: this.resizeCharts,
        repositionChartFunc: this.repositionChart,
        chartInEditron: false
      });
      this.bubbles(this.chartContainerResize, 'size-updated');
      this.item.trigger('frame-reset');
      this.textBox.bind('flash', this.flash);
    }

    TextBoxController.prototype.editable = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return AppRedesign.current().shared_mode !== true && ((ref = App.User.currentUser()) != null ? ref.canExplore() : void 0) && !App.Dashboard.currentDashboard().isReadOnlyToCurrentUser();
      }
    };

    TextBoxController.prototype.release = function() {
      var ref;
      this.textBox.unbind('flash', this.flash);
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      this.chartContainerResize.release();
      return TextBoxController.__super__.release.apply(this, arguments);
    };

    TextBoxController.prototype.flash = function() {
      return setTimeout(((function(_this) {
        return function() {
          return _this.item.trigger('flash');
        };
      })(this)), App.AppFrameRedesign.NORMAL_ANIMATION_TIME);
    };

    TextBoxController.prototype.resizeCharts = function() {};

    TextBoxController.prototype.repositionChart = function() {};

    TextBoxController.prototype.renderIfInViewport = function() {
      var ref;
      return (ref = AppRedesign.current()) != null ? ref.notRenderingWidget(this.item.id) : void 0;
    };

    TextBoxController.prototype.update = function() {
      return window.reactApp.updateNonActiveTextBox(this.item.content());
    };

    TextBoxController.prototype.changedSize = function() {
      return this.item.trigger('frame-reset');
    };

    TextBoxController.prototype.returnToUnrenderedState = function() {};

    TextBoxController.prototype.coverMouseDown = function(e) {
      return this.trigger('title-needs-draggability');
    };

    return TextBoxController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TextboxDrawingController = (function(superClass) {
    extend(TextboxDrawingController, superClass);

    function TextboxDrawingController() {
      this.release = bind(this.release, this);
      this.endTextBoxDrawingMode = bind(this.endTextBoxDrawingMode, this);
      this.onMouseUp = bind(this.onMouseUp, this);
      this.onMouseMove = bind(this.onMouseMove, this);
      this.updateTextBoxDimension = bind(this.updateTextBoxDimension, this);
      this.onMouseDown = bind(this.onMouseDown, this);
      TextboxDrawingController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'dashboardLayoutController', 'mainContent');
      this.mainContent.on('mousedown', this.onMouseDown);
      this.mainContent.on('mousemove', this.onMouseMove);
      this.mainContent.on('mouseup', this.onMouseUp);
      this.textBoxShadow = $(this.view('redesign/dashboards/textbox-shadow')());
      this.textBoxShadow.hide();
      this.dashboardLayoutController.el.append(this.textBoxShadow);
    }

    TextboxDrawingController.prototype.onMouseDown = function(e) {
      var left, top;
      if (!AppRedesign.current().newTextBoxDrawingMode) {
        return;
      }
      this.isMouseDown = true;
      this.columnWidth = this.dashboardLayoutController.dashboardSizer.columnWidth(false);
      this.gutterWidth = this.dashboardLayoutController.dashboardSizer.LEFT_GUTTER;
      this.startX = e.clientX - e.currentTarget.getClientRects()[0].left + e.currentTarget.scrollLeft;
      this.startY = e.clientY - e.currentTarget.getClientRects()[0].top + e.currentTarget.scrollTop;
      this.endX = this.startX;
      this.endY = this.startY;
      top = Math.round(this.startY / this.columnWidth) * this.columnWidth - 1;
      left = Math.round((this.startX - this.gutterWidth) / this.columnWidth) * this.columnWidth + this.gutterWidth - 1;
      this.textBoxShadow.css({
        top: top,
        left: left,
        width: this.columnWidth,
        height: this.columnWidth
      });
      this.textBoxShadow.show();
      this.rerenderInterval = setInterval(((function(_this) {
        return function() {
          if (!_this.isMouseDown) {
            return;
          }
          return _this.updateTextBoxDimension();
        };
      })(this)), 20);
      if (!this.insideChartsContainer(e)) {
        this.endTextBoxDrawingMode();
        return;
      }
      return this.dashboardLayoutController.showGrid();
    };

    TextboxDrawingController.prototype.updateTextBoxDimension = function() {
      var height, left, top, width;
      if (!AppRedesign.current().newTextBoxDrawingMode) {
        return;
      }
      if (!this.isMouseDown) {
        return;
      }
      if (!(this.startX && this.startY && this.endX && this.endY)) {
        return;
      }
      if (this.endX < this.startX || this.endY < this.startY) {
        return;
      }
      width = Math.abs(this.endX - this.startX) / this.columnWidth;
      height = Math.abs(this.endY - this.startY) / this.columnWidth;
      top = Math.round(this.startY / this.columnWidth) * this.columnWidth - 1;
      left = Math.round((this.startX - this.gutterWidth) / this.columnWidth) * this.columnWidth + this.gutterWidth - 1;
      return this.textBoxShadow.css({
        top: top,
        left: left,
        width: width * this.columnWidth,
        height: height * this.columnWidth
      });
    };

    TextboxDrawingController.prototype.onMouseMove = function(e) {
      if (!AppRedesign.current().newTextBoxDrawingMode) {
        return;
      }
      if (!this.isMouseDown) {
        return;
      }
      this.endX = e.clientX - e.currentTarget.getClientRects()[0].left + e.currentTarget.scrollLeft;
      this.endY = e.clientY - e.currentTarget.getClientRects()[0].top + e.currentTarget.scrollTop;
      if (!this.insideChartsContainer(e)) {

      }
    };

    TextboxDrawingController.prototype.onMouseUp = function(e) {
      var column, height, left, row, top, width;
      if (!AppRedesign.current().newTextBoxDrawingMode) {
        return;
      }
      if (!this.isMouseDown) {
        return;
      }
      this.isMouseDown = false;
      this.endX = e.clientX - e.currentTarget.getClientRects()[0].left + e.currentTarget.scrollLeft;
      this.endY = e.clientY - e.currentTarget.getClientRects()[0].top + e.currentTarget.scrollTop;
      if (this.startX === null || this.startY === null || this.endX === null || this.endY === null) {
        this.endTextBoxDrawingMode();
        return;
      }
      if (this.startX < 0 || this.startY < 0) {
        this.endTextBoxDrawingMode();
        return;
      }
      column = Math.max(0, Math.round((this.startX - this.gutterWidth) / this.columnWidth));
      row = Math.max(0, Math.round(this.startY / this.columnWidth));
      width = Math.max(7, Math.round(Math.abs(this.endX - this.startX) / this.columnWidth));
      height = Math.max(3, Math.round(Math.abs(this.endY - this.startY) / this.columnWidth));
      top = Math.round(this.startY / this.columnWidth) * this.columnWidth - 1;
      left = Math.round((this.startX - this.gutterWidth) / this.columnWidth) * this.columnWidth + this.gutterWidth - 1;
      this.textBoxShadow.css({
        top: top,
        left: left,
        width: width * this.columnWidth - 1,
        height: height * this.columnWidth - 1
      });
      this.trigger('create-new-text-box', column, row, width, height);
      return this.endTextBoxDrawingMode();
    };

    TextboxDrawingController.prototype.endTextBoxDrawingMode = function() {
      this.dashboardLayoutController.hideGrid();
      this.startX = null;
      this.startY = null;
      this.endX = null;
      this.endY = null;
      this.isMouseDown = false;
      setTimeout(((function(_this) {
        return function() {
          clearInterval(_this.rerenderInterval);
          return delete _this.rerenderInterval;
        };
      })(this)));
      setTimeout(((function(_this) {
        return function() {
          _this.textBoxShadow.fadeOut();
          return _this.textBoxShadow.remove();
        };
      })(this)));
      return AppRedesign.current().setTextBoxDrawingMode(false);
    };

    TextboxDrawingController.prototype.insideChartsContainer = function(e) {
      var targetClassName;
      targetClassName = e.target.className;
      return targetClassName.includes('grid-boundary') || targetClassName.includes('charts-container') || targetClassName.includes('empty-dash-message') || targetClassName.includes('main-content');
    };

    TextboxDrawingController.prototype.release = function() {
      this.mainContent.off('mousedown', this.onMouseDown);
      this.mainContent.off('mousemove', this.onMouseMove);
      this.mainContent.off('mouseup', this.onMouseUp);
      return TextboxDrawingController.__super__.release.apply(this, arguments);
    };

    return TextboxDrawingController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ThemeColorsController = (function(superClass) {
    extend(ThemeColorsController, superClass);

    ThemeColorsController.prototype.className = 'theme-colors';

    ThemeColorsController.prototype.events = {
      'click .recent-color': 'setFromTheme'
    };

    function ThemeColorsController() {
      ThemeColorsController.__super__.constructor.apply(this, arguments);
      this.themeColors = this.colorTheme.colorList();
      this.render();
    }

    ThemeColorsController.prototype.render = function() {
      return this.html(this.view('redesign/settings/recent_colors')({
        recent_colors: this.themeColors
      }));
    };

    ThemeColorsController.prototype.setFromTheme = function(e) {
      var color;
      color = $(e.currentTarget).data('color');
      return this.trigger('set-color', color);
    };

    return ThemeColorsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ViewDependenciesController = (function(superClass) {
    extend(ViewDependenciesController, superClass);

    ViewDependenciesController.prototype.className = 'views-container';

    function ViewDependenciesController() {
      ViewDependenciesController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.html(this.view('redesign/view_dependencies/container')());
      this.showViewDependencies();
    }

    ViewDependenciesController.prototype.showViewDependencies = function() {
      return this.reactRoot = window.reactApp.viewDependenciesRoot(this.el[0], this.item);
    };

    ViewDependenciesController.prototype.release = function() {
      this.reactRoot.close();
      return ViewDependenciesController.__super__.release.apply(this, arguments);
    };

    return ViewDependenciesController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ViewMaterializationSettingsController = (function(superClass) {
    extend(ViewMaterializationSettingsController, superClass);

    ViewMaterializationSettingsController.prototype.className = 'view-materialization-settings';

    ViewMaterializationSettingsController.prototype.elements = {
      '.form-container.toggles-area': 'cacheToggleArea'
    };

    function ViewMaterializationSettingsController() {
      this.disabledMaterializeMouseLeave = bind(this.disabledMaterializeMouseLeave, this);
      this.disabledMaterializeMouseEnter = bind(this.disabledMaterializeMouseEnter, this);
      this.cacheStateChanged = bind(this.cacheStateChanged, this);
      ViewMaterializationSettingsController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.render();
    }

    ViewMaterializationSettingsController.prototype.refresh = function() {
      return this.maybeDisableMaterialize();
    };

    ViewMaterializationSettingsController.prototype.render = function() {
      this.html(this.view('redesign/editors/view_materialization_settings')());
      this.appendCacheToggle();
      return this.maybeDisableMaterialize();
    };

    ViewMaterializationSettingsController.prototype.appendCacheToggle = function() {
      this.cacheToggle = new App.Toggler({
        togglerClass: 'square',
        isToggleOn: !this.item.no_cache_results,
        labelWhenToggleOn: 'Materialize View',
        labelWhenToggleOff: 'Materialize View'
      });
      this.cacheToggle.el.attr('id', 'cache-toggle');
      this.cacheToggleArea.append(this.cacheToggle.el);
      return this.cacheToggle.bind('toggled', this.cacheStateChanged);
    };

    ViewMaterializationSettingsController.prototype.cacheStateChanged = function(toggleState) {
      this.item.no_cache_results = !toggleState;
      App.Utils.logFeature('view-materialization-toggled', {
        detail: toggleState
      });
      return this.triggerOnce('right-panel-settings-changed');
    };

    ViewMaterializationSettingsController.prototype.maybeDisableMaterialize = function() {
      if (this.cacheToggle == null) {
        return false;
      }
      if (this.item.code && AppRedesign.current().deepAnalysisEnabled) {
        this.item.no_cache_results = false;
        return this.disableCacheToggleWithTooltip("This View includes " + this.item.code_language + " code and must be Materialized.");
      } else if (this.queryRunsOnSelectedDatabase() && !this.item.database().cache) {
        this.item.no_cache_results = true;
        return this.disableCacheToggleWithTooltip('This View is running on Source Database, and cannot be Materialized');
      } else {
        return this.enableCacheToggle();
      }
    };

    ViewMaterializationSettingsController.prototype.disableCacheToggleWithTooltip = function(description) {
      this.cacheToggle.setToggleState(!this.item.no_cache_results);
      this.cacheToggle.disable();
      this.disabledMaterializeTooltipDescription = description;
      this.cacheToggle.el.on('mouseenter', this.disabledMaterializeMouseEnter);
      return this.cacheToggle.el.on('mouseleave', this.disabledMaterializeMouseLeave);
    };

    ViewMaterializationSettingsController.prototype.enableCacheToggle = function() {
      this.cacheToggle.setToggleState(!this.item.no_cache_results);
      this.cacheToggle.enable();
      return this.turnOffDisabledMaterializeTooltip();
    };

    ViewMaterializationSettingsController.prototype.turnOffDisabledMaterializeTooltip = function() {
      this.disabledMaterializeTooltipDescription = null;
      this.cacheToggle.el.off('mouseenter', this.disabledMaterializeMouseEnter);
      return this.cacheToggle.el.off('mouseleave', this.disabledMaterializeMouseLeave);
    };

    ViewMaterializationSettingsController.prototype.queryRunsOnSelectedDatabase = function() {
      return App.Site.first().uses_explicit_cache;
    };

    ViewMaterializationSettingsController.prototype.disabledMaterializeMouseEnter = function(e) {
      var target;
      target = $(e.currentTarget);
      if (this.disabledMaterializeTooltipDescription == null) {
        this.disabledMaterializeTooltipDescription = 'This View is running on Source Database, and cannot be Materialized';
      }
      return this.disabledMaterializeTooltip = App.RedesignTooltipPanel.addPanel({
        contentEl: null,
        description: this.disabledMaterializeTooltipDescription,
        extraClass: 'light-theme name',
        pointerOffsetPercent: 0.5,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        width: '219px'
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, 0.2, target.offset().left, target.offset().top);
    };

    ViewMaterializationSettingsController.prototype.disabledMaterializeMouseLeave = function(e) {
      if (this.disabledMaterializeTooltip == null) {
        return;
      }
      this.disabledMaterializeTooltip.release();
      return this.disabledMaterializeTooltip = null;
    };

    return ViewMaterializationSettingsController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ViewScheduleController = (function(superClass) {
    extend(ViewScheduleController, superClass);

    ViewScheduleController.prototype.elements = {
      '.schedule-area': 'scheduleArea'
    };

    function ViewScheduleController() {
      this.getDefaultSchedule = bind(this.getDefaultSchedule, this);
      this.getDisabledScheduleOptions = bind(this.getDisabledScheduleOptions, this);
      this.cacheSchedules = bind(this.cacheSchedules, this);
      this.setCurrentScheduleState = bind(this.setCurrentScheduleState, this);
      this.render = bind(this.render, this);
      ViewScheduleController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.html(this.view('redesign/editors/view_schedule')());
      this.prepCacheScheduleIdsField();
      this.render();
    }

    ViewScheduleController.prototype.prepCacheScheduleIdsField = function() {
      return this.item.cache_schedule_ids = this.item.cacheSchedules().map((function(_this) {
        return function(cacheSchedule) {
          return cacheSchedule.id;
        };
      })(this));
    };

    ViewScheduleController.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return ViewScheduleController.__super__.release.apply(this, arguments);
    };

    ViewScheduleController.prototype.render = function() {
      this.scheduleArea.empty();
      this.scheduleArea.css({
        'font-size': 0
      });
      return this.reactRoot = window.reactApp.viewScheduleRoot(this.scheduleArea[0], this.item, this.cacheSchedules(), this.setCurrentScheduleState, this.getDisabledScheduleOptions(), this.getDefaultSchedule());
    };

    ViewScheduleController.prototype.setCurrentScheduleState = function(state, hasChanged) {
      if (hasChanged) {
        this.triggerOnce('right-panel-settings-changed');
      }
      if (state.scheduleType === 'never') {
        this.item.no_cache_results = true;
      } else {
        this.item.no_cache_results = false;
      }
      return this.item.schedulable = state;
    };

    ViewScheduleController.prototype.cacheSchedules = function() {
      if (this.item.cache_schedule_ids != null) {
        return this.item.cache_schedule_ids.map((function(_this) {
          return function(id) {
            return App.CacheSchedule.find(id);
          };
        })(this));
      } else {
        return [];
      }
    };

    ViewScheduleController.prototype.getDisabledScheduleOptions = function() {
      if (this.item.isCodeView()) {
        return [App.Schedule.TYPE_NEVER];
      } else if (this.item.database().isOrigin()) {
        return [App.Schedule.TYPE_NEVER, App.Schedule.TYPE_INTERVAL, App.Schedule.TYPE_CALENDAR];
      }
    };

    ViewScheduleController.prototype.getDefaultSchedule = function() {
      if (this.item.isCodeView()) {
        return {
          interval: App.Schedule.HOURLY,
          scheduleType: App.Schedule.TYPE_INTERVAL
        };
      } else if (this.item.database().isOrigin()) {
        return {
          scheduleType: App.Schedule.TYPE_NEVER
        };
      }
    };

    return ViewScheduleController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignChartTitleController = (function(superClass) {
    extend(RedesignChartTitleController, superClass);

    RedesignChartTitleController.prototype.elements = {
      '.widget-title': 'widgetTitle'
    };

    RedesignChartTitleController.prototype.events = {
      'focus .widget-title': 'titleFocused',
      'blur .widget-title': 'titleBlurred',
      'keyup .widget-title': 'titleKeypressed',
      'click .controls': 'controlsClicked',
      'mouseenter .preview-limit-icon': 'previewLimitMouseEntered',
      'mouseleave .preview-limit-icon': 'previewLimitMouseLeft'
    };

    RedesignChartTitleController.WIDGET_TITLE_FONT_SIZE = 15;

    function RedesignChartTitleController() {
      this.coverMouseDown = bind(this.coverMouseDown, this);
      this.previewLimitMouseLeft = bind(this.previewLimitMouseLeft, this);
      this.previewLimitMouseEntered = bind(this.previewLimitMouseEntered, this);
      this.toggleMenu = bind(this.toggleMenu, this);
      this.getMenuEl = bind(this.getMenuEl, this);
      this.setTitle = bind(this.setTitle, this);
      this.controlPressed = bind(this.controlPressed, this);
      this.chartDescription = bind(this.chartDescription, this);
      this.refreshChartDescriptionIcon = bind(this.refreshChartDescriptionIcon, this);
      this.sqlViewUpdated = bind(this.sqlViewUpdated, this);
      this.hideErrorMessage = bind(this.hideErrorMessage, this);
      this.release = bind(this.release, this);
      this.viewsLoaded = bind(this.viewsLoaded, this);
      this.hasItemsInWidgetMenu = bind(this.hasItemsInWidgetMenu, this);
      this.iconInfo = bind(this.iconInfo, this);
      this.render = bind(this.render, this);
      this.controlsClicked = bind(this.controlsClicked, this);
      RedesignChartTitleController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'item', 'supportsImageDataFunc', 'supportsCSVDataFunc', 'supportsSearchFunc', 'supportsPivotFunc', 'supportsCopyClipboard', 'chartHasError');
      this.menuShowing = false;
      App.SqlView.bind('update create', this.sqlViewUpdated);
      App.Dashboard.bind('remaining-state-loaded', this.viewsLoaded);
      this.widget().bind('title-changed', this.setTitle);
      this.editHelper = new App.EditHelper(this.item);
      this.previewLimitTooltip = new App.PreviewLimitTooltipController({
        editHelper: this.editHelper
      });
    }

    RedesignChartTitleController.prototype.controlsClicked = function() {
      if (!this.showDebugInfo()) {
        return;
      }
      return window.debug_w = this.widget();
    };

    RedesignChartTitleController.prototype.showDebugInfo = function() {
      return App.User.currentUserIsPeriscopeAdmin();
    };

    RedesignChartTitleController.prototype.widget = function() {
      return this.item;
    };

    RedesignChartTitleController.prototype.unformattedTitleFunc = function() {
      return this.widget().getName();
    };

    RedesignChartTitleController.prototype.formattedTitleFunc = function() {
      return this.widget().getTitleForDisplay();
    };

    RedesignChartTitleController.prototype.chartDescriptionFunc = function() {
      return App.Utils.sanitizeHtml(this.widget().getChartDescription());
    };

    RedesignChartTitleController.prototype.chartDescriptionIconEl = function() {
      return this.el.find('.description-icon');
    };

    RedesignChartTitleController.prototype.downloadImageButton = function() {
      return this.el.find(".widget-menu .menu-item[name='image']");
    };

    RedesignChartTitleController.prototype.failedViewWarningFunc = function() {
      var failedViews, ref, ref1, ref2;
      if ((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0) {
        return null;
      }
      if (!((ref1 = AppRedesign.current()) != null ? ref1.remainingStateLoaded : void 0)) {
        return null;
      }
      failedViews = (ref2 = this.widget().selectedFormulaSource()) != null ? ref2.getFailingViews() : void 0;
      if (failedViews && failedViews.length > 0) {
        return "This chart is based on SQL Views with errors: " + failedViews.map(function(fv) {
          return fv.name;
        }).join(", ");
      }
    };

    RedesignChartTitleController.prototype.canceledQueryWarningFunc = function() {
      var inEditron;
      if (this.widget().state() === App.Widget.S_CANCELED) {
        inEditron = AppRedesign.current().currentState === AppRedesign.IN_EDITRON;
        if (!inEditron) {
          return App.Widget.QUERY_CANCELED_MESSAGE;
        }
      }
    };

    RedesignChartTitleController.prototype.inputEl = function() {
      return this.widgetTitle;
    };

    RedesignChartTitleController.prototype.render = function() {
      var closeX, errorMessage, newTitle, ref;
      this.lastInfoMessage = null;
      newTitle = this.formattedTitleFunc();
      if (this.focused) {
        return;
      }
      this.focused = false;
      errorMessage = this.getErrorMessage();
      this.html(this.view('redesign/widgets/title')({
        title: newTitle,
        showError: errorMessage != null,
        errorMessage: errorMessage,
        editing: this.editing || this.widget().blocked_by_database_mapping_feature,
        canEdit: this.canEdit(),
        shouldShowPivotOutsideOfMenu: this.shouldShowPivotOutsideOfMenu(),
        showPreviewLimitIcon: this.shouldShowPreviewLimitIcon()
      }));
      if ((ref = this.iconTooltipHelper) != null) {
        ref.release();
      }
      this.iconTooltipHelper = new App.IconTooltipHelper({
        icon: this.el.find('.button'),
        infoCallback: this.iconInfo,
        direction: App.RedesignTooltipPanel.BOTTOM,
        keepWithinRightSide: true,
        tooltipClass: 'chart-controls-tooltip',
        leftOffset: 10,
        topOffset: 7,
        closeOnScroll: true,
        showOnce: true,
        alwaysKeepInDashboard: true
      });
      this.menuController = new App.WidgetMenuController({
        showImageIcon: this.supportsImageDataFunc(),
        showCsvIcon: this.csvButtonAllowed(),
        rowsText: this.csvRowsToDownload(),
        showSearchIcon: this.supportsSearchFunc(),
        showPivotIcon: this.supportsPivotFunc(),
        showEditCopyIcon: this.shouldShowCopyAs(),
        showLinkIcon: this.shouldShowLink(),
        showSlackIcon: this.showSlackIcon(),
        chartTitleController: this
      });
      if (this.menuShowing) {
        this.showMenu();
      }
      this.renderedTitle = newTitle;
      this.el.find('.cover').on('mousedown', this.coverMouseDown);
      this.refreshChartDescriptionIcon();
      if (this.editing) {
        this.resizeTitle();
      }
      this.el.off('click', this.controlPressed);
      this.el.on('click', this.controlPressed);
      $('body').off('click', this.hideErrorMessage);
      $('body').on('click', this.hideErrorMessage);
      if (errorMessage != null) {
        closeX = this.el.find('.close-x');
        closeX.off('click', this.hideErrorMessage);
        return closeX.on('click', this.hideErrorMessage);
      }
    };

    RedesignChartTitleController.prototype.iconInfo = function(evt) {
      return $(evt.currentTarget).data('tooltip');
    };

    RedesignChartTitleController.prototype.hasItemsInWidgetMenu = function() {
      return this.shouldShowSearch() || this.shouldShowCsvDownload() || this.shouldShowImageDownload() || this.shouldShowPivot() || this.shouldShowCopyAs() || this.shouldShowLink() || this.showSlackIcon();
    };

    RedesignChartTitleController.prototype.csvButtonAllowed = function() {
      var ref, ref1;
      return this.supportsCSVDataFunc() && (!this.widget().hasError() || (typeof this.sourceLimitError === "function" ? this.sourceLimitError() : void 0)) && !((ref = AppRedesign.current()) != null ? (ref1 = ref.state) != null ? ref1.csv_export_disabled : void 0 : void 0) && this.widget().csvDownloadEnabled();
    };

    RedesignChartTitleController.prototype.isRowsPrefixEmpty = function() {
      return this.widget().sourceRowsComplete() || (AppRedesign.current().shared_mode && !AppRedesign.current().allowLargeCsvDownloadForSharedDashboards());
    };

    RedesignChartTitleController.prototype.csvRowsToDownload = function() {
      var prefix, sourceRows;
      sourceRows = this.widget().getRows().length;
      if (sourceRows === 0) {
        return '';
      }
      prefix = this.isRowsPrefixEmpty() ? '' : 'Over ';
      return App.Utils.pluralizeIf(prefix + (sourceRows + " Row"), sourceRows !== 1);
    };

    RedesignChartTitleController.prototype.canEdit = function() {
      var ref, ref1;
      if (AppRedesign.restrictDatabasesEnabled() && !this.item.isDragDrop()) {
        return (ref = App.User.currentUser()) != null ? ref.canQuery(this.item.database_id) : void 0;
      }
      if (AppRedesign.current().state.RbacEnabled && this.item.isDragDrop()) {
        return AppRedesign.createDiscoveryChartsEnabledOnDashboard();
      } else if (AppRedesign.current().state.RbacEnabled && !this.item.isDragDrop()) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return !this.item.isReadOnlyToCurrentUser() && (this.item.isDragDrop() || ((ref1 = App.User.currentUser()) != null ? ref1.canEdit() : void 0));
      }
    };

    RedesignChartTitleController.prototype.canEditAsCopy = function() {
      var ref, ref1, ref2;
      if (AppRedesign.restrictDatabasesEnabled()) {
        return (ref = App.User.currentUser()) != null ? ref.canQuery(this.item.database_id) : void 0;
      }
      if (AppRedesign.current().state.RbacEnabled && this.item.isDragDrop()) {
        return AppRedesign.createDiscoveryChartsEnabledOnDashboard();
      } else if (AppRedesign.current().state.RbacEnabled && !this.item.isDragDrop()) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return ((ref1 = App.User.currentUser()) != null ? ref1.canEdit() : void 0) || (this.item.isDragDrop() && ((ref2 = App.User.currentUser()) != null ? ref2.canExplore() : void 0));
      }
    };

    RedesignChartTitleController.prototype.shouldShowPreviewLimitIcon = function() {
      var showError;
      showError = this.getErrorMessage() != null;
      return !showError && this.item.isTable() && AppRedesign.current().allowLargeCsvDownloadForSharedDashboards() && this.editHelper.hasRunResultReachedPreviewLimit();
    };

    RedesignChartTitleController.prototype.shouldShowCsvDownload = function() {
      return (!this.chartHasError() || (typeof this.sourceLimitError === "function" ? this.sourceLimitError() : void 0)) && this.csvButtonAllowed();
    };

    RedesignChartTitleController.prototype.shouldShowCopyAs = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return !AppRedesign.current().shared_mode && (this.canEditAsCopy() || (AppRedesign.createSqlChartsEnabled() && AppRedesign.editChartAsCopyEnabledOnDashboard()));
      } else {
        return !AppRedesign.current().shared_mode && this.canEditAsCopy();
      }
    };

    RedesignChartTitleController.prototype.shouldShowSearch = function() {
      return !this.chartHasError() && this.supportsSearchFunc();
    };

    RedesignChartTitleController.prototype.shouldShowImageDownload = function() {
      return !this.chartHasError() && this.supportsImageDataFunc();
    };

    RedesignChartTitleController.prototype.shouldShowPivot = function() {
      return !this.chartHasError() && this.supportsPivotFunc();
    };

    RedesignChartTitleController.prototype.shouldShowPivotOutsideOfMenu = function() {
      if (!this.editing) {
        return false;
      }
      return this.shouldShowPivot();
    };

    RedesignChartTitleController.prototype.shouldShowLink = function() {
      var ref;
      return !((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0) && !AppRedesign.isLinkedWidgetMode();
    };

    RedesignChartTitleController.prototype.showSlackIcon = function() {
      var ref;
      return !((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0) && AppRedesign.current().state.SlackEnabled;
    };

    RedesignChartTitleController.prototype.maybeHidePreviewTooltipIcon = function() {
      return this.el.find('.preview-limit-icon').addClass('hidden');
    };

    RedesignChartTitleController.prototype.maybeDisableExpand = function() {
      return this.el.find('.expand.button').toggleClass('disabled', !this.hasItemsInWidgetMenu());
    };

    RedesignChartTitleController.prototype.viewsLoaded = function() {
      AppRedesign.current().uiQueue.add(this.refreshChartDescriptionIcon, 'refresh-chart-description-icon', App.UiQueue.PRIORITY_REMAINING_STATE);
      return App.Dashboard.unbind('remaining-state-loaded', this.viewsLoaded);
    };

    RedesignChartTitleController.prototype.hideTitle = function() {
      return this.inputEl().hide();
    };

    RedesignChartTitleController.prototype.showTitle = function() {
      return this.inputEl().show();
    };

    RedesignChartTitleController.prototype.release = function() {
      var ref;
      if ((ref = this.descriptionTooltipHelper) != null) {
        ref.release();
      }
      $('#body').off('click', this.hideErrorMessage);
      this.widget().unbind('title-changed', this.setTitle);
      return RedesignChartTitleController.__super__.release.apply(this, arguments);
    };

    RedesignChartTitleController.prototype.setTitleErrorMessage = function(message) {
      if (message === this.errorMessage) {
        return;
      }
      this.errorMessage = message;
      return this.render();
    };

    RedesignChartTitleController.prototype.getErrorMessage = function() {
      return this.errorMessage;
    };

    RedesignChartTitleController.prototype.hideErrorMessage = function(event) {
      return this.setTitleErrorMessage(void 0);
    };

    RedesignChartTitleController.prototype.sqlViewUpdated = function() {
      clearTimeout(this.refreshChartDescriptionIconTimeout);
      return this.refreshChartDescriptionIconTimeout = setTimeout(this.refreshChartDescriptionIcon, 50);
    };

    RedesignChartTitleController.prototype.refreshChartDescriptionIcon = function() {
      var canceledQueryWarning, desc, failedViewWarning, hasWarning, newMessage, ref, ref1;
      failedViewWarning = this.failedViewWarningFunc() || '';
      canceledQueryWarning = this.canceledQueryWarningFunc() || '';
      desc = this.chartDescriptionFunc() || '';
      newMessage = failedViewWarning + canceledQueryWarning + desc;
      if (this.lastInfoMessage === newMessage) {
        return;
      }
      this.lastInfoMessage = newMessage;
      hasWarning = failedViewWarning !== '' || canceledQueryWarning !== '';
      this.el.toggleClass('with-view-warning', hasWarning);
      this.el.toggleClass('with-description', desc !== '');
      if (desc !== '' || hasWarning) {
        if ((ref = this.descriptionTooltipHelper) != null) {
          ref.release();
        }
        return this.descriptionTooltipHelper = new App.IconTooltipHelper({
          icon: this.chartDescriptionIconEl(),
          infoCallback: this.chartDescription,
          direction: App.RedesignTooltipPanel.BOTTOM,
          alwaysKeepInDashboard: true,
          useWidthAsMin: false,
          leftOffset: 5,
          minWidth: 60
        });
      } else {
        return (ref1 = this.descriptionTooltipHelper) != null ? ref1.release() : void 0;
      }
    };

    RedesignChartTitleController.prototype.chartDescription = function() {
      return this.failedViewWarningFunc() || this.canceledQueryWarningFunc() || this.chartDescriptionFunc();
    };

    RedesignChartTitleController.prototype.controlPressed = function(evt) {
      var target;
      this.iconTooltipHelper.iconMouseLeave();
      if ($(evt.target).attr('name') === 'expand') {
        evt.stopPropagation();
        if ($(evt.target).hasClass('disabled')) {
          return;
        }
        return this.toggleMenu(evt.target);
      } else if ($(evt.target)[0].hasAttribute('name')) {
        target = $(evt.target)[0];
        this.trigger('control-pressed', $(target).attr('name'));
        return this.menuController.hide();
      } else {
        target = $(evt.target).closest('.menu-item');
        this.trigger('control-pressed', target.attr('name'));
        return this.menuController.hide();
      }
    };

    RedesignChartTitleController.prototype.titleKeypressed = function(event) {
      if (event.which === AppRedesign.KEYS.ENTER) {
        this.widgetTitle.trigger('blur');
      } else {
        this.resizeTitle();
      }
      return this.widget().setName(this.getTitleVal());
    };

    RedesignChartTitleController.prototype.resizeTitle = function() {
      var descriptionIconOffset, pivotIconOffset, textToSize;
      App.Utils.initCanvasWidthSizer(App.RedesignChartTitleController.WIDGET_TITLE_FONT_SIZE, App.HeaderTitleController.INPUT_FONT);
      textToSize = this.widgetTitle.val();
      textToSize += 'W';
      descriptionIconOffset = this.chartDescriptionIconEl() != null ? 10 : 0;
      pivotIconOffset = this.shouldShowPivotOutsideOfMenu() ? 30 : 0;
      return this.widgetTitle.css('width', Math.max(175, Math.min(this.el.width() - descriptionIconOffset - pivotIconOffset, App.Utils.fastApproxWidthForText(textToSize) + 10)));
    };

    RedesignChartTitleController.prototype.titleFocused = function() {
      return this.renderRawTitle();
    };

    RedesignChartTitleController.prototype.renderRawTitle = function() {
      return this.widgetTitle.val(this.widget().getRawTitle());
    };

    RedesignChartTitleController.prototype.titleBlurred = function() {
      var newTitle, savedTitle;
      newTitle = this.getTitleVal();
      savedTitle = this.widget().getName();
      this.widget().setName(newTitle);
      return this.setTitle();
    };

    RedesignChartTitleController.prototype.setTitle = function() {
      if (this.inputEl().is(':focus')) {
        return;
      }
      this.inputEl().val(this.widget().getTitleForDisplay());
      return this.resizeTitle();
    };

    RedesignChartTitleController.prototype.getTitleVal = function() {
      return this.widgetTitle.val().trim();
    };

    RedesignChartTitleController.prototype.getMenuEl = function() {
      return this.menuController.getEl();
    };

    RedesignChartTitleController.prototype.toggleMenu = function(target) {
      if (this.getMenuEl().parent()[0] === target) {
        return this.hideMenu();
      } else {
        if (this.chartHasError()) {
          this.getMenuEl().addClass('errored');
        } else {
          this.getMenuEl().removeClass('errored');
        }
        return this.showMenu();
      }
    };

    RedesignChartTitleController.prototype.hideMenu = function() {
      var ref;
      if ((ref = this.getMenuEl()) != null) {
        ref.detach();
      }
      return this.menuShowing = false;
    };

    RedesignChartTitleController.prototype.showMenu = function() {
      this.menuController.render();
      this.el.find('.expand.button').append(this.getMenuEl());
      return this.menuShowing = true;
    };

    RedesignChartTitleController.prototype.previewLimitMouseEntered = function(e) {
      return this.previewLimitTooltip.show(e);
    };

    RedesignChartTitleController.prototype.previewLimitMouseLeft = function() {
      return this.previewLimitTooltip.hide();
    };

    RedesignChartTitleController.prototype.coverMouseDown = function(e) {
      return this.trigger('title-needs-draggability');
    };

    return RedesignChartTitleController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SettingsMenuProfileSignoutController = (function(superClass) {
    extend(SettingsMenuProfileSignoutController, superClass);

    SettingsMenuProfileSignoutController.prototype.events = {
      'click .button': 'logoutClicked'
    };

    function SettingsMenuProfileSignoutController() {
      this.logoutClicked = bind(this.logoutClicked, this);
      SettingsMenuProfileSignoutController.__super__.constructor.apply(this, arguments);
      this.html(this.view('settings/signout_form')());
    }

    SettingsMenuProfileSignoutController.prototype.logoutClicked = function() {
      App.Site.trigger('close-all-editors');
      App.Utils.logFeature('logout-from-periscope');
      AppRedesign.setDocumentTitle('Periscope');
      return window.location = '/users/logout';
    };

    return SettingsMenuProfileSignoutController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SettingsMenuProfileSwitchSiteController = (function(superClass) {
    extend(SettingsMenuProfileSwitchSiteController, superClass);

    SettingsMenuProfileSwitchSiteController.prototype.elements = {
      '.scroll-container': 'scrollContainer',
      '.items': 'itemsList'
    };

    SettingsMenuProfileSwitchSiteController.prototype.events = {
      'click .site.item .site-name': 'siteClick'
    };

    function SettingsMenuProfileSwitchSiteController() {
      this.siteClick = bind(this.siteClick, this);
      this.resetSitesList = bind(this.resetSitesList, this);
      SettingsMenuProfileSwitchSiteController.__super__.constructor.apply(this, arguments);
      this.html(this.view('settings/sites')());
      this.el.addClass('header-menu-settings-switch-site-frame');
      this.resetSitesList();
    }

    SettingsMenuProfileSwitchSiteController.prototype.resetSitesList = function() {
      var currSite, familySiteIds, i, len, ref, results, site;
      this.itemsList.find('.site.item').remove();
      currSite = App.Site.first();
      familySiteIds = currSite.site_info_list.map(function(site) {
        return site.id;
      });
      ref = App.User.currentUser().allSites();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        site = ref[i];
        if (site.id !== currSite.id && familySiteIds.includes(site.id)) {
          continue;
        }
        results.push(this.itemsList.append(this.view('settings/site_item')({
          host: site.host,
          name: site.name,
          current: site.current
        })));
      }
      return results;
    };

    SettingsMenuProfileSwitchSiteController.prototype.siteClick = function(event) {
      var host;
      host = jQuery(event.target).closest('.site.item').attr('host');
      window.open(AppRedesign.pathForSiteHost({
        siteHost: host
      }), "_blank");
      return this.trigger('close');
    };

    return SettingsMenuProfileSwitchSiteController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Shares = (function(superClass) {
    extend(Shares, superClass);

    Shares.prototype.elements = {
      '.shares-list-container': 'sharesListContainer',
      '.shares-edit-container': 'sharesEditContainer',
      '.button-area': 'buttonArea',
      '.dimensions-grid': 'dimensionsGrid',
      '.form-header .name': 'name',
      '.delete-confirm-area': 'deleteConfirmArea',
      '.revoke-button-area': 'revokeButtonArea',
      '.custom-date-range': 'customDateRangeRow',
      '.custom-date-range .range-start': 'dateRangeOptionRangeStart',
      '.custom-date-range .range-end': 'dateRangeOptionRangeEnd',
      'input.range-start': 'dateRangeInputStart',
      'input.range-end': 'dateRangeInputEnd',
      '.add-new.button': 'addNewButton',
      '.headers .changeable .info-icon': 'changeableInfoIcon'
    };

    Shares.prototype.events = {
      'click .revoke.link': 'revoke',
      'click .share.button': 'shareDashboard',
      'click .cancel-share.link': 'cancelShareClick',
      'click .add-new.button': 'showEditForm',
      'click .dimension-settings .checkbox': 'dimCheckChange',
      'click .shared-dashboard': 'clickSharedDashboard',
      'click .delete-confirm-area .delete': 'confirmDelete',
      'click .delete-confirm-area .cancel': 'cancelDelete',
      'click .custom-date-range .picker-button.start': 'clickDateRangeCustomRangeStartPick',
      'click .custom-date-range .picker-button.end': 'clickDateRangeCustomRangeEndPick',
      'wheel .dimensions-grid': 'maybePreventScroll',
      'mousewheel .dimensions-grid': 'maybePreventScroll',
      'scroll .dimensions-grid': 'maybePreventScroll',
      'mouseenter .headers .changeable .info-icon': 'showChangeableInfoIcon',
      'mouseleave .headers .changeable .info-icon': 'hideChangeableInfoIcon'
    };

    Shares.PLACEHOLDER_TEXT = 'None';

    function Shares() {
      this.hideChangeableInfoIcon = bind(this.hideChangeableInfoIcon, this);
      this.showChangeableInfoIcon = bind(this.showChangeableInfoIcon, this);
      this.reparentElement = bind(this.reparentElement, this);
      this.maybePreventScroll = bind(this.maybePreventScroll, this);
      this.hookUpDatePickers = bind(this.hookUpDatePickers, this);
      this.clickDateRangeCustomRangeEndPick = bind(this.clickDateRangeCustomRangeEndPick, this);
      this.clickDateRangeCustomRangeStartPick = bind(this.clickDateRangeCustomRangeStartPick, this);
      this.finalizeFromDateRangeCustomRangeBoxen = bind(this.finalizeFromDateRangeCustomRangeBoxen, this);
      this.showEditForm = bind(this.showEditForm, this);
      this.clickSharedDashboard = bind(this.clickSharedDashboard, this);
      this.dimCheckChange = bind(this.dimCheckChange, this);
      this.cancelDelete = bind(this.cancelDelete, this);
      this.confirmDelete = bind(this.confirmDelete, this);
      this.revoke = bind(this.revoke, this);
      this.cancelShareClick = bind(this.cancelShareClick, this);
      this.handleShareResponse = bind(this.handleShareResponse, this);
      this.shareDashboard = bind(this.shareDashboard, this);
      Shares.__super__.constructor.apply(this, arguments);
      this.chosens = [];
    }

    Shares.prototype.release = function() {
      this.safeReleasePickers();
      return Shares.__super__.release.apply(this, arguments);
    };

    Shares.prototype.safeReleasePickers = function() {
      try {
        this.dateRangeOptionRangeStart.datepicker('destroy');
        return this.dateRangeOptionRangeEnd.datepicker('destroy');
      } catch (error) {

      }
    };

    Shares.prototype.show = function() {
      this.dashboard = App.Dashboard.currentDashboard();
      if (!this.dashboard) {
        return;
      }
      this.render();
      return App.HotkeyManager.disable();
    };

    Shares.prototype.shareDashboard = function() {
      if (this.currentlySharing) {
        return;
      }
      this.currentlySharing = true;
      return jQuery.ajax({
        type: 'post',
        url: "/shared_dashboards",
        data: {
          dashboard_id: this.dashboard.id,
          client_site_id: App.Site.first().id,
          name: this.name.val(),
          unlocked_filters: this.unlockedFilters(),
          custom_dimensions_list: JSON.stringify(this.customDimensionsList()),
          aggregation: this.getAggregation(),
          date_range_dimension: this.getDateRangeDimension()
        },
        async: false,
        success: this.handleShareResponse
      }).always((function(_this) {
        return function() {
          return _this.currentlySharing = false;
        };
      })(this));
    };

    Shares.prototype.unlockedFilters = function() {
      var el, i, len, ref, unlockedFilters;
      unlockedFilters = [];
      ref = this.dimensionsGrid.find('.checkbox.checked');
      for (i = 0, len = ref.length; i < len; i++) {
        el = ref[i];
        unlockedFilters.push(App.CustomDimension.find($(el).attr("dim_cid")).id);
      }
      return JSON.stringify(unlockedFilters);
    };

    Shares.prototype.customDimensionsList = function() {
      var cid, customDimensionsList, dim_id, group, i, j, len, len1, name, option, ref, row, sel, value;
      customDimensionsList = [];
      ref = this.dimensionsGrid.find('.row.body');
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        cid = $(row).attr('dim_cid');
        if (!App.CustomDimension.isCustomDimensionId(cid)) {
          continue;
        }
        dim_id = App.CustomDimension.find(cid).id;
        sel = $(row).find('.selected-dimensions select option:selected');
        if (sel) {
          for (j = 0, len1 = sel.length; j < len1; j++) {
            option = sel[j];
            name = $(option).text();
            value = $(option).val();
            group = $(sel).attr('group');
            if ((group != null) && group !== "") {
              customDimensionsList.push([dim_id, value, name, group]);
            } else {
              customDimensionsList.push([dim_id, value, name]);
            }
          }
        }
      }
      return customDimensionsList;
    };

    Shares.prototype.getAggregation = function() {
      var aggregation, sel;
      aggregation = this.dimensionsGrid.find('div[dim_cid=aggregation]');
      if (aggregation == null) {
        return null;
      }
      sel = $(aggregation).find('.selected-dimensions select option:selected');
      if (sel) {
        return $(sel[0]).val();
      }
    };

    Shares.prototype.getDateRangeDimension = function() {
      var dateRange, json, sel, selectedValue;
      dateRange = this.dimensionsGrid.find('div[dim_cid=date_range]');
      if (dateRange == null) {
        return null;
      }
      sel = $(dateRange).find('.selected-dimensions select option:selected');
      if (sel) {
        selectedValue = $(sel[0]).val();
        if (selectedValue == null) {
          return null;
        }
        json = JSON.parse(selectedValue);
        if (json.type === App.RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE) {
          json['range_start'] = this.dateRangeInputStart.val();
          json['range_end'] = this.dateRangeInputEnd.val();
          return JSON.stringify(json);
        } else {
          return selectedValue;
        }
      }
    };

    Shares.prototype.handleShareResponse = function(response) {
      var sd;
      sd = new App.SharedDashboard(response).save({
        ajax: false
      });
      sd.openShareUrl();
      return this.render();
    };

    Shares.prototype.cancelShareClick = function() {
      return this.render();
    };

    Shares.prototype.revoke = function(event) {
      return this.buttonArea.addClass('open-confirm');
    };

    Shares.prototype.confirmDelete = function(event) {
      var sd;
      sd = App.SharedDashboard.exists(this.sharedId);
      if (sd) {
        sd.destroy();
      }
      return this.render();
    };

    Shares.prototype.cancelDelete = function(event) {
      return this.buttonArea.removeClass('open-confirm');
    };

    Shares.prototype.hide = function() {
      this.innerHTML = "";
      this.el.hide();
      return App.HotkeyManager.enable();
    };

    Shares.prototype.render = function() {
      this.el.show();
      this.addNewButton.show();
      return this.html(this.view('dashboards/shares')({
        title: this.title(),
        sharedDashboards: this.dashboard.sharedDashboards()
      }));
    };

    Shares.prototype.title = function() {
      return "Shares of " + this.dashboard.name;
    };

    Shares.prototype.dimCheckChange = function(evt) {
      if (!this.editMode) {
        return;
      }
      return $(evt.target).closest('.checkbox').toggleClass('checked');
    };

    Shares.prototype.clickSharedDashboard = function(evt) {
      var sd, target;
      this.addNewButton.show();
      this.editMode = false;
      this.sharesListContainer.find('.shared-dashboard.active').removeClass('active');
      target = $(evt.target).closest('.shared-dashboard');
      this.sharedId = target.attr('shared_dashboard_id');
      sd = App.SharedDashboard.find(this.sharedId);
      target.addClass('active');
      this.sharesEditContainer.html(this.view('dashboards/shares_form')({
        canEdit: this.editMode,
        title: sd.title(),
        dims: this.getAvailableDims(sd),
        shareUrl: sd.shareUrl(),
        viewCount: sd.access_count || 0
      }));
      return this.refreshElements();
    };

    Shares.prototype.getDateRangeAggregationFromSharedDashboard = function(sd) {
      var aggregationUnlocked, aggregationValue, dateRangeDimensionValue, dateRangeUnlocked, dims, ref, ref1, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      dims = [];
      aggregationValue = null;
      if (sd.aggregation != null) {
        aggregationValue = sd.aggregation.titleize();
      }
      aggregationUnlocked = (ref = sd.unlocked_filters) != null ? ref.includes('aggregation') : void 0;
      if (visible['aggregation']) {
        dims.push({
          cid: 'aggregation',
          name: 'Aggregation',
          values: [
            {
              value_name: aggregationValue
            }
          ],
          checked: aggregationUnlocked
        });
      }
      dateRangeDimensionValue = null;
      if (!isEmpty(sd.date_range_dimension)) {
        dateRangeDimensionValue = App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(sd.date_range_dimension);
      }
      dateRangeUnlocked = (ref1 = sd.unlocked_filters) != null ? ref1.includes('date_range') : void 0;
      if (visible['date_range']) {
        dims.push({
          cid: 'date_range',
          name: 'Date Range',
          values: [
            {
              value_name: dateRangeDimensionValue
            }
          ],
          checked: dateRangeUnlocked
        });
      }
      return dims;
    };

    Shares.prototype.getDateRangeAggregationFromCurrentUdv = function(sd) {
      var currentAggregationValue, currentDateRangeDimension, dims, label, values, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      dims = [];
      if ((visible['aggregation'] != null) && visible['aggregation']) {
        currentAggregationValue = this.dashboard.userDataView().aggregation;
        if (currentAggregationValue != null) {
          values = [
            {
              value: currentAggregationValue,
              value_name: currentAggregationValue.titleize()
            }
          ];
        } else {
          values = [];
        }
        dims.push({
          cid: 'aggregation',
          name: 'Aggregation',
          values: values,
          checked: false
        });
      }
      if ((visible['date_range'] != null) && visible['date_range']) {
        currentDateRangeDimension = this.dashboard.userDataView().date_range_dimension;
        if (!isEmpty(currentDateRangeDimension)) {
          label = App.RedesignDateRangeDimensionSetting.getOptionLabel(currentDateRangeDimension);
          values = [
            {
              value_name: label,
              value: JSON.stringify(currentDateRangeDimension)
            }
          ];
        } else {
          values = [];
        }
        dims.push({
          cid: 'date_range',
          name: 'Date Range',
          values: values,
          checked: false
        });
      }
      return dims;
    };

    Shares.prototype.getAvailableDims = function(sd) {
      var d, dims, i, len, ref, ref1, values, visible;
      if (sd == null) {
        sd = null;
      }
      visible = this.getDimensionAvailability(sd);
      dims = [];
      ref = App.CustomDimension.allSortedByName();
      for (i = 0, len = ref.length; i < len; i++) {
        d = ref[i];
        if (!visible[d.cid]) {
          continue;
        }
        if (sd != null) {
          values = this.getSelectedDimensionInfos(sd, d.id);
        } else {
          values = this.getSelectedDimensionInfos(this.dashboard.userDataView(), d.id);
        }
        dims.push({
          cid: d.cid,
          name: d.name,
          values: values,
          checked: sd != null ? (ref1 = sd.unlocked_filters) != null ? ref1.includes("" + d.id) : void 0 : void 0
        });
      }
      if (sd != null) {
        dims = dims.concat(this.getDateRangeAggregationFromSharedDashboard(sd));
      } else {
        dims = dims.concat(this.getDateRangeAggregationFromCurrentUdv(sd));
      }
      return dims;
    };

    Shares.prototype.getDimensionAvailability = function(sd) {
      var customDimension, dim, dimId, i, len, ref, visible;
      visible = App.DimensionAvailability.availableForDashboard(this.dashboard);
      if (sd == null) {
        return visible;
      }
      ref = sd.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        dim = ref[i];
        dimId = dim[0];
        customDimension = App.CustomDimension.exists(dimId);
        if (customDimension) {
          visible[customDimension.cid] = true;
        }
      }
      return visible;
    };

    Shares.prototype.getSelectedDimensionInfos = function(sd, dimension_id) {
      var cdl, i, len, matches, ref;
      if (sd == null) {
        return [];
      }
      matches = [];
      ref = sd.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        cdl = ref[i];
        if ((cdl.length > 2) && (cdl[0] === dimension_id)) {
          matches.push({
            value_name: cdl[2],
            value: cdl[1],
            group: cdl[3]
          });
        }
      }
      return matches;
    };

    Shares.prototype.showEditForm = function() {
      var sharesController;
      this.addNewButton.hide();
      this.sharesListContainer.find('.shared-dashboard.active').removeClass('active');
      this.editMode = true;
      this.sharesEditContainer.html(this.view('dashboards/shares_form')({
        canEdit: this.editMode,
        dims: this.getAvailableDims()
      }));
      this.refreshElements();
      this.name.trigger('focus');
      sharesController = this;
      return this.sharesEditContainer.find('.dimension-settings .body .selected-dimensions').each(function() {
        var cellEl, ch, dim_cid, selectEl;
        cellEl = $(this);
        selectEl = cellEl.find('select');
        dim_cid = selectEl.attr('dim_cid');
        ch = null;
        if (App.CustomDimension.isCustomDimensionId(dim_cid)) {
          ch = App.Shares.setUpCustomDimension(selectEl, sharesController);
        } else {
          switch (dim_cid) {
            case "aggregation":
              ch = App.Shares.setUpAggregationRow(selectEl);
              break;
            case "date_range":
              ch = App.Shares.setUpDateRangeRow(selectEl, sharesController, dim_cid);
          }
          if (ch != null) {
            App.Shares.setUpExclusiveChosen(ch, sharesController);
          }
        }
        if (ch != null) {
          return App.Shares.setUpChosenBinding(ch, sharesController);
        }
      });
    };

    Shares.prototype.cleanChildren = function(parent_dim_cid) {
      var cd, child_cids, cid, groupSelectors, groups, i, len, parent_dim, results, selectEl;
      parent_dim = App.CustomDimension.find(parent_dim_cid);
      child_cids = (function() {
        var i, len, ref, results;
        ref = App.CustomDimension.all();
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          cd = ref[i];
          if (cd.parent_id === parent_dim.id) {
            results.push(cd.cid);
          }
        }
        return results;
      })();
      if (!child_cids.length) {
        return;
      }
      groups = this.customDimensionsList().filter(function(d) {
        return d[0] === parent_dim.id;
      }).map(function(d) {
        return d[1];
      });
      groupSelectors = groups.map(function(g) {
        return "not([group=" + g + "])";
      }).join(':');
      if (groupSelectors.length) {
        groupSelectors = ":" + groupSelectors;
      }
      results = [];
      for (i = 0, len = child_cids.length; i < len; i++) {
        cid = child_cids[i];
        selectEl = this.el.find("select[dim_cid=" + cid + "]");
        if (!selectEl.length) {
          continue;
        }
        selectEl.find('option' + groupSelectors).remove();
        results.push(selectEl.trigger('chosen:updated'));
      }
      return results;
    };

    Shares.setUpCustomDimension = function(selectEl, sharesController) {
      var ch, dim;
      dim = App.CustomDimension.find(selectEl.attr('dim_cid'));
      ch = selectEl.asyncChosen({
        placeholder_text: this.PLACEHOLDER_TEXT,
        ignore_search_events: true,
        rewrote_search_input: false
      }, {
        keyupFocusCallback: (function(term, successCallback) {
          var groups, parentId;
          groups = null;
          if (dim.hasParent()) {
            parentId = dim.parent_id;
            groups = sharesController.customDimensionsList().filter(function(d) {
              return d[0] === parentId;
            }).map(function(d) {
              return d[1];
            });
            if (!groups.length) {
              return;
            }
          }
          return dim.getDimensionValuesAsArrays(term, groups, successCallback);
        })
      });
      ch.on('change', function(e) {
        var dim_cid;
        dim_cid = $(e.currentTarget).closest('select').attr('dim_cid');
        return sharesController.cleanChildren(dim_cid);
      });
      ch.on('change', function(e) {
        var closeButtons, i, idx, ref, results;
        if (!dim.exclusive) {
          return;
        }
        closeButtons = $(e.currentTarget).closest('.selected-dimensions').find('.search-choice-close');
        if (closeButtons.length > 1) {
          results = [];
          for (idx = i = 0, ref = closeButtons.length - 2; 0 <= ref ? i <= ref : i >= ref; idx = 0 <= ref ? ++i : --i) {
            results.push(closeButtons[idx].click());
          }
          return results;
        }
      });
      return ch;
    };

    Shares.setUpExclusiveChosen = function(ch, sharesController) {
      return ch.on('change', function(e) {
        var closeButtons, i, idx, ref, results;
        closeButtons = $(e.currentTarget).closest('.selected-dimensions').find('.search-choice-close');
        if (closeButtons.length > 1) {
          results = [];
          for (idx = i = 0, ref = closeButtons.length - 2; 0 <= ref ? i <= ref : i >= ref; idx = 0 <= ref ? ++i : --i) {
            results.push(closeButtons[idx].click());
          }
          return results;
        }
      });
    };

    Shares.setUpChosenBinding = function(ch, sharesController) {
      ch.on('chosen:hiding_dropdown', function(event, chosen) {
        return sharesController.reparentElement($(event.target).closest('.dimension-area'), false);
      });
      ch.on('chosen:showing_dropdown', function(event, chosen) {
        return sharesController.reparentElement($(event.target).closest('.dimension-area'), true);
      });
      return sharesController.chosens.push(ch);
    };

    Shares.setUpAggregationRow = function(selectEl) {
      return selectEl.asyncChosen({
        placeholder_text: this.PLACEHOLDER_TEXT,
        ignore_search_events: true
      }, {
        keyupFocusCallback: (function(term, successCallback) {
          return App.AggregationDimensionSetting.getAggregationValuesAsArrays(term, successCallback);
        })
      });
    };

    Shares.setUpDateRangeRow = function(selectEl, sharesController, dim_cid) {
      var ch;
      ch = selectEl.asyncChosen({
        placeholder_text: this.PLACEHOLDER_TEXT,
        ignore_search_events: true
      }, {
        keyupFocusCallback: (function(term, successCallback) {
          return App.RedesignDateRangeDimensionSetting.getDateRangeValuesAsArrays(term, successCallback);
        })
      });
      sharesController.hookUpDatePickers();
      ch.on('change', function(e) {
        var customRangeEl, grid, parsedValue, ref, selectedValue;
        selectedValue = (ref = selectEl.find('option:selected')) != null ? ref.val() : void 0;
        customRangeEl = $("[dim_cid=" + dim_cid + "] .custom-date-range");
        if (selectedValue != null) {
          parsedValue = JSON.parse(selectedValue);
          if (parsedValue.type === App.RedesignDateRangeDimensionSetting.DATE_RANGE_TYPE_RANGE) {
            customRangeEl.show();
            grid = selectEl.closest('.dimensions-grid');
            grid.scrollTop(grid.height());
            customRangeEl.find('.range-start').val(parsedValue.range_start);
            return customRangeEl.find('.range-end').val(parsedValue.range_end);
          } else {
            return customRangeEl.hide();
          }
        } else {
          return customRangeEl.hide();
        }
      });
      ch.trigger('change');
      return ch;
    };

    Shares.prototype.finalizeFromDateRangeCustomRangeBoxen = function() {
      App.RedesignDateRangeDimensionSetting.cleanUserDateInput(this.dateRangeOptionRangeStart);
      App.RedesignDateRangeDimensionSetting.cleanUserDateInput(this.dateRangeOptionRangeEnd);
      return App.RedesignDateRangeDimensionSetting.correctDateValuesIfReversed(this.dateRangeOptionRangeStart, this.dateRangeOptionRangeEnd, this.stashedDateRange);
    };

    Shares.prototype.clickDateRangeCustomRangeStartPick = function() {
      this.dateRangeOptionRangeStart.datepicker('show');
      return $('.ui-datepicker').addClass('dark-theme');
    };

    Shares.prototype.clickDateRangeCustomRangeEndPick = function() {
      this.dateRangeOptionRangeEnd.datepicker('show');
      return $('.ui-datepicker').addClass('dark-theme');
    };

    Shares.prototype.hookUpDatePickers = function() {
      var datePickerOpts;
      datePickerOpts = {
        showOn: "none",
        dateFormat: "yy-mm-dd",
        constrainInput: false,
        onClose: ((function(_this) {
          return function() {
            return setTimeout(_this.finalizeFromDateRangeCustomRangeBoxen, 0);
          };
        })(this))
      };
      this.dateRangeOptionRangeStart.datepicker(datePickerOpts);
      return this.dateRangeOptionRangeEnd.datepicker(datePickerOpts);
    };

    Shares.prototype.maybePreventScroll = function(evt) {
      if ($(document.activeElement).parent().attr('class') === 'search-field') {
        return evt.preventDefault();
      }
    };

    Shares.prototype.reparentElement = function(upEl, popOut) {
      var attrEl, dim_cid, downEl, originalHome, position;
      dim_cid = upEl.attr('dim_cid');
      downEl = upEl.closest(".dimension-area.reparented").removeClass("reparented").css({
        top: '',
        left: ''
      });
      if (dim_cid) {
        originalHome = this.el.find("[dim_cid=" + dim_cid + "] .selected-dimensions");
        originalHome.css({
          height: ""
        });
        downEl.find('.chosen-drop .chosen-results').html('');
        originalHome.append(downEl);
      }
      if (popOut) {
        position = upEl.position();
        attrEl = upEl.closest('tr');
        upEl.parent().css({
          height: upEl.parent().height()
        });
        upEl.addClass('reparented').css({
          top: position.top + "px",
          left: position.left + "px"
        }).attr('dim_cid', attrEl.attr('dim_cid'));
        return this.el.append(upEl);
      }
    };

    Shares.prototype.showChangeableInfoIcon = function() {
      var iconEl, iconElOffset, pointerOffset;
      pointerOffset = App.TooltipPanel.DEFAULT_POINTER_OFFSET;
      iconEl = this.changeableInfoIcon;
      iconElOffset = iconEl.offset();
      return this.changeableTooltip = App.TooltipPanel.addPanel(App.TooltipPanel.BOTTOM, '200px', pointerOffset, App.TooltipPanel.BLANK_TITLE, "Visible filters are available to users to change on the shared dashboard.").pointAt(App.TooltipPanel.BOTTOM, iconEl, pointerOffset, iconElOffset.left + (iconEl.outerWidth() * App.TooltipPanel.DEFAULT_POINT_LEFT_SCALE), iconElOffset.top + (iconEl.outerHeight() * App.TooltipPanel.DEFAULT_POINT_TOP_SCALE) - 3);
    };

    Shares.prototype.hideChangeableInfoIcon = function() {
      var ref;
      if ((ref = this.changeableTooltip) != null) {
        ref.closeAndRelease();
      }
      return this.changeableTooltip = null;
    };

    return Shares;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SiteController = (function(superClass) {
    extend(SiteController, superClass);

    function SiteController() {
      this.dbUpdated = bind(this.dbUpdated, this);
      this.versionChange = bind(this.versionChange, this);
      SiteController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'item');
      this.item.bind('site_version_change', this.versionChange);
    }

    SiteController.prototype.release = function() {
      App.Database.unbind('update', this.dbUpdated);
      return SiteController.__super__.release.apply(this, arguments);
    };

    SiteController.prototype.versionChange = function() {
      return this.trigger('site-version-changed');
    };

    SiteController.prototype.stashDatabaseStateOnce = function() {
      if (this.databaseStateStashed) {
        return;
      }
      this.databaseStateStashed = true;
      this.stashSchemaStatus();
      this.stashRowCountStatus();
      return App.Database.bind('update', this.dbUpdated);
    };

    SiteController.prototype.dbUpdated = function() {
      this.checkSchemaStatus();
      return this.checkRowCountsStatus();
    };

    SiteController.prototype.stashSchemaStatus = function() {
      var db, i, len, ref, results;
      this.schemasUpdatedAt = {};
      ref = App.Database.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        results.push(this.schemasUpdatedAt[db.id] = db.schema_updated_at);
      }
      return results;
    };

    SiteController.prototype.checkSchemaStatus = function() {
      var db, i, len, ref, results, updated_at;
      if (this.schemasUpdatedAt == null) {
        return;
      }
      ref = App.Database.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        updated_at = db.schema_updated_at;
        if (this.schemasUpdatedAt[db.id] !== updated_at) {
          this.schemasUpdatedAt[db.id] = updated_at;
          if (db.isSchemaUpdateRequested()) {
            results.push(db.getNewSchema());
          } else {
            db.schema_is_stale = true;
            results.push(db.save({
              ajax: false
            }));
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    SiteController.prototype.stashRowCountStatus = function() {
      var db, i, len, ref, results;
      this.rowCountsLastUpdatedAt = {};
      ref = App.Database.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        results.push(this.rowCountsLastUpdatedAt[db.id] = db.row_counts_updated_at);
      }
      return results;
    };

    SiteController.prototype.checkRowCountsStatus = function() {
      var db, i, len, ref, results, updated_at;
      if (this.rowCountsLastUpdatedAt == null) {
        return;
      }
      ref = App.Database.all();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        db = ref[i];
        updated_at = db.row_counts_updated_at;
        if (this.rowCountsLastUpdatedAt[db.id] !== updated_at) {
          this.rowCountsLastUpdatedAt[db.id] = updated_at;
          results.push(db.getNewRowCounts());
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return SiteController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.SiteNameValidator = (function() {
    function SiteNameValidator() {}

    SiteNameValidator.validate = function(siteName) {
      if (siteName.trim() === '') {
        return [false, "Cannot be blank"];
      }
      return [true];
    };

    return SiteNameValidator;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SiteVersionController = (function(superClass) {
    extend(SiteVersionController, superClass);

    SiteVersionController.prototype.className = 'reload-modal';

    SiteVersionController.prototype.elements = {
      '.button': 'reloadButton'
    };

    SiteVersionController.prototype.events = {
      'click .button': 'clickedReload'
    };

    SiteVersionController.SLEEP_THRESHOLD_MIN_SECONDS = 10;

    SiteVersionController.SLEEP_THRESHOLD_MAX_SECONDS = 60;

    function SiteVersionController() {
      this.clickedReload = bind(this.clickedReload, this);
      var sleepMs;
      SiteVersionController.__super__.constructor.apply(this, arguments);
      if (AppRedesign.current().immediateReload) {
        this.reloadNow();
        return;
      }
      this.render();
      sleepMs = App.Utils.randomInt(this.constructor.SLEEP_THRESHOLD_MIN_SECONDS, this.constructor.SLEEP_THRESHOLD_MAX_SECONDS) * 1000;
      this.reloadTimeout = setTimeout(this.reloadNow, sleepMs);
    }

    SiteVersionController.prototype.render = function() {
      if (AppRedesign.current().isRedesignMode) {
        this.html(this.view('redesign/reload/reload_modal'));
        return this.dialog = App.RedesignDialog.createDialog({
          noCancel: true,
          title: 'Reload Required',
          viewController: this
        });
      } else {
        this.html(this.view('reload/reload_modal'));
        return this.dialog = App.Dialog.createDialog({
          noCancel: true,
          title: 'Reload Required',
          viewController: this
        });
      }
    };

    SiteVersionController.prototype.clickedReload = function() {
      if (this.reloadButton.hasClass('disabled')) {
        return;
      }
      this.reloadButton.text('loading');
      this.reloadButton.addClass('disabled');
      clearTimeout(this.reloadTimeout);
      return this.reloadNow();
    };

    SiteVersionController.prototype.reloadNow = function() {
      return AppRedesign.current().resetIfReady();
    };

    return SiteVersionController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.StatusBarController = (function(superClass) {
    extend(StatusBarController, superClass);

    StatusBarController.prototype.events = {
      'click .status-bar-exit': 'clicked'
    };

    function StatusBarController() {
      this.clicked = bind(this.clicked, this);
      StatusBarController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.message = AppRedesign.current().maintenanceMessage;
      AppRedesign.recoverator().set('status-bar', this.message);
      this.render();
    }

    StatusBarController.prototype.render = function() {
      return this.html(this.view('app_frame/status_bar')({
        message: this.message
      }));
    };

    StatusBarController.prototype.clicked = function() {
      AppRedesign.recoverator().set('status-bar-clicked', true);
      return this.trigger('close');
    };

    StatusBarController.shouldShow = function() {
      var ref;
      if (this.statusAlreadyDismissed()) {
        return false;
      }
      return ((ref = AppRedesign.current().maintenanceMessage) != null ? ref.length : void 0) > 0;
    };

    StatusBarController.statusAlreadyDismissed = function() {
      return AppRedesign.current().maintenanceMessage === AppRedesign.recoverator().get('status-bar') && (AppRedesign.recoverator().get('status-bar-clicked') != null);
    };

    return StatusBarController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Textarea = (function(superClass) {
    extend(Textarea, superClass);

    function Textarea() {
      this.delayedResizeElementToContent = bind(this.delayedResizeElementToContent, this);
      this.resizeElementToContent = bind(this.resizeElementToContent, this);
      return Textarea.__super__.constructor.apply(this, arguments);
    }

    Textarea.prototype.events = {
      'change': 'resizeElementToContent',
      'cut': 'delayedResizeElementToContent',
      'keydown': 'delayedResizeElementToContent',
      'paste': 'delayedResizeElementToContent'
    };

    Textarea.prototype.resizeElementToContent = function(e) {
      if (this.resizeEnabled() == null) {
        return;
      }
      this.el.height(0);
      return this.el.height(_.min([this.elementContentHeight(), this.elementMaxHeight()]));
    };

    Textarea.prototype.delayedResizeElementToContent = function(e) {
      return setTimeout(this.resizeElementToContent);
    };

    Textarea.prototype.resizeEnabled = function() {
      return this.el.data('textarea-resize');
    };

    Textarea.prototype.elementMaxHeight = function() {
      return this.el.data('textarea-resize-max-height') || (function() {
        throw new Error('requires data-textarea-resize-max-height attribute');
      })();
    };

    Textarea.prototype.elementVerticalPadding = function() {
      return this.el.innerHeight() - this.el.height();
    };

    Textarea.prototype.elementContentHeight = function() {
      return this.el[0].scrollHeight - this.elementVerticalPadding();
    };

    return Textarea;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.Toggler = (function(superClass) {
    extend(Toggler, superClass);

    Toggler.prototype.elements = {
      '.toggler': 'toggler',
      '.ball': 'ball',
      '.toggler-label.left': 'leftLabelEl',
      '.toggler-label.right': 'rightLabelEl'
    };

    Toggler.prototype.events = {
      'click .toggler': 'toggle'
    };

    Toggler.prototype.className = 'toggler-container';

    function Toggler() {
      this.handleMoveDragEnd = bind(this.handleMoveDragEnd, this);
      this.handleMoveDragStart = bind(this.handleMoveDragStart, this);
      var ballState, displayClass, leftLabelText, rightLabelText;
      Toggler.__super__.constructor.apply(this, arguments);
      if (this.isToggleOn == null) {
        this.isToggleOn = false;
      }
      if (this.isToggleOn) {
        ballState = 'on';
      }
      displayClass = (this.togglerClass != null ? this.togglerClass : 'circle');
      this.hasLeftAndRightLabels = (this.staticLeftLabel && this.staticRightLabel) || false;
      this.hasRightLabelOnly = !this.hasLeftAndRightLabels;
      if (this.hasLeftAndRightLabels) {
        leftLabelText = this.leftLabelText();
      }
      rightLabelText = this.rightLabelText();
      this.html(this.view('toggler/toggler')({
        displayClass: displayClass,
        ballState: ballState,
        leftLabelText: leftLabelText,
        rightLabelText: rightLabelText
      }));
      this.ball.draggable({
        axis: "x",
        containment: "parent",
        start: this.handleMoveDragStart,
        stop: this.handleMoveDragEnd
      });
    }

    Toggler.prototype.leftLabelText = function() {
      if (this.hasLeftAndRightLabels && (this.staticLeftLabel != null)) {
        return this.staticLeftLabel;
      }
    };

    Toggler.prototype.rightLabelText = function() {
      switch (false) {
        case !(this.hasRightLabelOnly && (this.labelWhenToggleOn != null) && (this.labelWhenToggleOff != null)):
          if (this.isToggleOn) {
            return this.labelWhenToggleOn;
          } else {
            return this.labelWhenToggleOff;
          }
        case !(this.hasLeftAndRightLabels && (this.staticRightLabel != null)):
          return this.staticRightLabel;
      }
    };

    Toggler.prototype.release = function() {
      if (this.ball.data('ui-draggable')) {
        this.ball.draggable("destroy");
      }
      return Toggler.__super__.release.apply(this, arguments);
    };

    Toggler.prototype.setToggleState = function(newToggleState) {
      this.isToggleOn = newToggleState;
      this.ball.toggleClass('on', this.isToggleOn);
      if (this.hasRightLabelOnly) {
        this.rightLabelEl.text(this.rightLabelText());
        return;
      }
      if (this.hasLeftAndRightLabels) {
        this.leftLabelEl.text(this.leftLabelText());
        this.rightLabelEl.text(this.rightLabelText());
      }
    };

    Toggler.prototype.getToggleState = function() {
      return this.isToggleOn;
    };

    Toggler.prototype.isEnabled = function() {
      return !this.toggler.hasClass('disabled');
    };

    Toggler.prototype.toggle = function() {
      if (!this.isEnabled()) {
        return false;
      }
      this.setToggleState(!this.isToggleOn);
      return this.trigger('toggled', this.isToggleOn);
    };

    Toggler.prototype.disable = function() {
      this.toggler.addClass('disabled');
      return this.el.addClass('disabled');
    };

    Toggler.prototype.enable = function() {
      this.toggler.removeClass('disabled');
      return this.el.removeClass('disabled');
    };

    Toggler.prototype.handleMoveDragStart = function() {
      this.maxDragDelta = 0;
      this.ball.addClass('dragging');
      return this.ballDragStartX = this.ball.position().left;
    };

    Toggler.prototype.handleMoveDragEnd = function() {
      this.ball.removeClass('dragging');
      if (this.dragDistance() > this.dragThreshold()) {
        this.toggle();
      }
      return this.ball.css('left', '');
    };

    Toggler.prototype.dragDistance = function() {
      return Math.abs(this.ballDragStartX - this.ball.position().left);
    };

    Toggler.prototype.dragThreshold = function() {
      return (this.toggler.width() - this.ball.width()) / 2;
    };

    return Toggler;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TooltipPanel = (function(superClass) {
    extend(TooltipPanel, superClass);

    TooltipPanel.prototype.elements = {
      '.panel': 'panel',
      '.panel .description': 'descriptionEl',
      '.panel .panel-content': 'panelContent',
      '.panel .left.pointer': 'panelLeftPointer',
      '.panel .right.pointer': 'panelRightPointer',
      '.panel .top.pointer': 'panelTopPointer',
      '.panel .bottom.pointer': 'panelBottomPointer',
      '.panel .left.pointer-border': 'panelLeftPointerBorder',
      '.panel .right.pointer-border': 'panelRightPointerBorder',
      '.panel .top.pointer-border': 'panelTopPointerBorder',
      '.panel .bottom.pointer-border': 'panelBottomPointerBorder',
      '.panel .title': 'panelTitle'
    };

    TooltipPanel.prototype.events = {
      'mouseenter': 'mouseEntered',
      'mouseleave': 'mouseLeft'
    };

    TooltipPanel.LARGE_POINTER_SIZE = 20;

    TooltipPanel.SMALL_POINTER_SIZE = 10;

    TooltipPanel.POINTER_BORDER_SIZE = 1;

    TooltipPanel.DEFAULT_POINTER_OFFSET = 0.17;

    TooltipPanel.DEFAULT_POINT_LEFT_SCALE = 0.33;

    TooltipPanel.DEFAULT_POINT_TOP_SCALE = 0.2;

    TooltipPanel.TOP = 'top';

    TooltipPanel.BOTTOM = 'bottom';

    TooltipPanel.LEFT = 'left';

    TooltipPanel.RIGHT = 'right';

    TooltipPanel.BLANK_TITLE = '';

    TooltipPanel.CENTER_POINTER = 0.5;

    TooltipPanel.addPanel = function(side, width, pointerOffsetPercent, title, description, contentEl, useSmallPointer, extraClass, forceParentInBody, useWidthAsMin) {
      var panel, panelDiv;
      if (useSmallPointer == null) {
        useSmallPointer = false;
      }
      if (extraClass == null) {
        extraClass = null;
      }
      if (forceParentInBody == null) {
        forceParentInBody = false;
      }
      if (useWidthAsMin == null) {
        useWidthAsMin = false;
      }
      panelDiv = $('<div class="tooltip-panel"></div>');
      if (App.EditronController.editronIsOpen() && !forceParentInBody) {
        $('body').find('.editron-mk3').append(panelDiv);
      } else {
        $('body').find('.content-offset-wrapper > .content').append(panelDiv);
      }
      panel = new App.TooltipPanel({
        el: panelDiv,
        useSmallPointer: useSmallPointer
      });
      panel.addPanel(side, width, pointerOffsetPercent, title, description, contentEl, extraClass, useWidthAsMin);
      return panel;
    };

    function TooltipPanel() {
      this.mouseLeft = bind(this.mouseLeft, this);
      this.mouseEntered = bind(this.mouseEntered, this);
      this.closeAndRelease = bind(this.closeAndRelease, this);
      this.fixPosition = bind(this.fixPosition, this);
      TooltipPanel.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      if (this.useSmallPointer) {
        this.pointerSize = TooltipPanel.SMALL_POINTER_SIZE;
      } else {
        this.pointerSize = TooltipPanel.LARGE_POINTER_SIZE;
      }
    }

    TooltipPanel.prototype.fixPosition = function() {
      return this.panel.addClass('fixed');
    };

    TooltipPanel.prototype.closeAndRelease = function() {
      this.panel.removeClass('showing');
      return this.closeTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.release();
        };
      })(this)), App.AppFrameRedesign.FAST_ANIMATION_TIME);
    };

    TooltipPanel.prototype.mouseEntered = function(e) {
      clearTimeout(this.closeTimeout);
      return this.panel.addClass('showing');
    };

    TooltipPanel.prototype.mouseLeft = function() {
      return this.closeAndRelease();
    };

    TooltipPanel.prototype.addPanel = function(side, width, pointerOffsetPercent, title, description, contentEl, extraClass, useWidthAsMin) {
      var horizontalPointerBorderOffset, horizontalPointerOffset, positionHorizontalPointer, positionVerticalPointer, verticalPointerBorderOffset, verticalPointerOffset;
      this.html(this.view('tooltip/panel')({
        title: title,
        description: description
      }));
      if (extraClass != null) {
        this.el.addClass(extraClass);
      }
      this.panel.toggleClass('small-pointer', this.useSmallPointer);
      if (title == null) {
        this.panelTitle.hide();
      }
      if (description == null) {
        this.descriptionEl.hide();
      }
      if (contentEl != null) {
        this.panelContent.append(contentEl);
      }
      if (title === TooltipPanel.BLANK_TITLE) {
        this.panelTitle.hide();
      }
      if (useWidthAsMin) {
        this.panel.css('min-width', width);
      } else {
        this.panel.width(width);
      }
      horizontalPointerOffset = this.panel.outerWidth() * pointerOffsetPercent - this.pointerSize;
      horizontalPointerBorderOffset = horizontalPointerOffset - TooltipPanel.POINTER_BORDER_SIZE;
      verticalPointerOffset = this.panel.outerHeight() * pointerOffsetPercent - this.pointerSize;
      verticalPointerBorderOffset = verticalPointerOffset - TooltipPanel.POINTER_BORDER_SIZE;
      positionVerticalPointer = function(selector, borderSelector) {
        selector.css({
          top: verticalPointerOffset
        });
        borderSelector.css({
          top: verticalPointerBorderOffset
        });
        selector.show();
        return borderSelector.show();
      };
      positionHorizontalPointer = function(selector, borderSelector) {
        selector.css({
          left: horizontalPointerOffset
        });
        borderSelector.css({
          left: horizontalPointerBorderOffset
        });
        selector.show();
        return borderSelector.show();
      };
      if (side === TooltipPanel.LEFT) {
        return positionVerticalPointer(this.panelLeftPointer, this.panelLeftPointerBorder);
      } else if (side === TooltipPanel.RIGHT) {
        return positionVerticalPointer(this.panelRightPointer, this.panelRightPointerBorder);
      } else if (side === TooltipPanel.TOP) {
        return positionHorizontalPointer(this.panelTopPointer, this.panelTopPointerBorder);
      } else if (side === TooltipPanel.BOTTOM) {
        return positionHorizontalPointer(this.panelBottomPointer, this.panelBottomPointerBorder);
      }
    };

    TooltipPanel.prototype.updateContent = function(contentEl) {
      this.panelContent.html('');
      return this.panelContent.append(contentEl);
    };

    TooltipPanel.prototype.pointAtEl = function(side, targetEl, offsetPercent, targetWidthIdentPercent, targetHeightIndentPercent) {
      var left, offset, top;
      offset = targetEl.offset();
      left = offset.left + (targetEl.outerWidth() * targetWidthIdentPercent);
      top = offset.top + (targetEl.outerHeight() * targetHeightIndentPercent);
      return this.pointAt(side, targetEl, offsetPercent, left, top);
    };

    TooltipPanel.prototype.fixPositionAt = function(targetLeft, targetTop) {
      var pointerOffsetPercent;
      pointerOffsetPercent = 0.5;
      this.panel.offset({
        left: targetLeft - this.panel.outerWidth() * pointerOffsetPercent,
        top: targetTop + this.pointerSize
      });
      this.panel.addClass('showing');
      return this;
    };

    TooltipPanel.prototype.pointAt = function(side, targetEl, pointerOffsetPercent, targetLeft, targetTop) {
      var tipPadding;
      tipPadding = 5;
      if (side === TooltipPanel.LEFT) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() * pointerOffsetPercent + this.pointerSize / 2,
          left: targetLeft + targetEl.outerWidth() + this.pointerSize + tipPadding
        });
      } else if (side === TooltipPanel.RIGHT) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() * pointerOffsetPercent + this.pointerSize / 2,
          left: targetLeft - this.panel.outerWidth() - this.pointerSize - tipPadding
        });
      } else if (side === TooltipPanel.BOTTOM) {
        this.panel.offset({
          top: targetTop - this.panel.outerHeight() - this.pointerSize - tipPadding,
          left: targetLeft - this.panel.outerWidth() * pointerOffsetPercent
        });
      } else if (side === TooltipPanel.TOP) {
        this.panel.offset({
          top: targetTop + targetEl.outerHeight() + this.pointerSize + tipPadding,
          left: targetLeft - this.panel.outerWidth() * pointerOffsetPercent
        });
      }
      this.panel.addClass('showing');
      return this;
    };

    return TooltipPanel;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WidgetFetcher = (function(superClass) {
    extend(WidgetFetcher, superClass);

    WidgetFetcher.extend(Spine.Events);

    WidgetFetcher.EVENT_WIDGETS_ALL_FETCHED = 'widgets-all-fetched';

    function WidgetFetcher(siteId, dashboardId, widgetLoadHandler, handleFailedRemainingStateCallback, onWidgetsLoaded) {
      var coordinates;
      this.siteId = siteId;
      this.dashboardId = dashboardId;
      this.widgetLoadHandler = widgetLoadHandler;
      this.handleFailedRemainingStateCallback = handleFailedRemainingStateCallback;
      this.onWidgetsLoaded = onWidgetsLoaded;
      this.updateCurrentDashboardPermissions = bind(this.updateCurrentDashboardPermissions, this);
      this.handleRemainingStateWidgets = bind(this.handleRemainingStateWidgets, this);
      this.fetchWidgetsBatchedRequest = bind(this.fetchWidgetsBatchedRequest, this);
      coordinates = this.lastWidgetCoordinatesLoaded();
      this.firstBatch = true;
      this.fetchWidgetsBatchedRequest(coordinates.fluid_row, coordinates.fluid_column);
      this.lastInBatchWidgetIds = [];
    }

    WidgetFetcher.prototype.fetchWidgetsBatchedRequest = function(minimum_dashboard_fluid_row, fluid_column_for_last_widget_in_row) {
      return jQuery.ajax({
        url: '/welcome/remaining_widgets',
        type: 'GET',
        data: {
          client_site_id: this.siteId,
          current_dashboard: this.dashboardId,
          minimum_dashboard_fluid_row: minimum_dashboard_fluid_row,
          fluid_column_for_last_widget_in_row: fluid_column_for_last_widget_in_row
        },
        dataType: 'json'
      }).done(this.handleRemainingStateWidgets).fail(this.handleFailedRemainingStateCallback);
    };

    WidgetFetcher.prototype.handleRemainingStateWidgets = function(response) {
      var lastWidget, ref;
      this.updateCurrentDashboardPermissions(response);
      this.widgetLoadHandler(response);
      if (this.firstBatch) {
        AppRedesign.current().spinalCord.firstBatchOfWidgetsLoaded();
      }
      this.firstBatch = false;
      if (((ref = response.Widget) != null ? ref.length : void 0) > 0) {
        lastWidget = response.Widget.last();
        this.fetchWidgetsBatchedRequest(lastWidget.fluid_row, lastWidget.fluid_column + 1);
        return this.lastInBatchWidgetIds.push(lastWidget.id);
      } else {
        AppRedesign.current().spinalCord.setWidgetsLoadedForDashboard(this.dashboardId);
        App.Dashboard.trigger('update-empty-message');
        App.WidgetFetcher.trigger(this.constructor.EVENT_WIDGETS_ALL_FETCHED);
        if (typeof this.onWidgetsLoaded === "function") {
          this.onWidgetsLoaded();
        }
        return this.logIfMissingWidgets();
      }
    };

    WidgetFetcher.prototype.lastWidgetCoordinatesLoaded = function() {
      var coordinates, maxCoordinates, maxRow, widgetsOnDashboard;
      widgetsOnDashboard = _.filter(App.Widget.all(), (function(_this) {
        return function(widget) {
          return widget.dashboard_id === _this.dashboardId;
        };
      })(this));
      if (_.isEmpty(widgetsOnDashboard)) {
        return {
          fluid_row: 0,
          fluid_column: 0
        };
      }
      coordinates = _.map(widgetsOnDashboard, function(widget) {
        return {
          fluid_row: widget.fluid_row,
          fluid_column: widget.fluid_column
        };
      });
      maxRow = _(coordinates).map('fluid_row').max();
      maxCoordinates = _(coordinates).filter({
        fluid_row: maxRow
      }).maxBy('fluid_column');
      return maxCoordinates;
    };

    WidgetFetcher.prototype.logIfMissingWidgets = function() {
      var missingWidgetIds, widgetIdsInSpineDatabase;
      widgetIdsInSpineDatabase = _.filter(this.lastInBatchWidgetIds, function(widgetId) {
        return App.Widget.exists(widgetId);
      });
      missingWidgetIds = _.difference(this.lastInBatchWidgetIds, widgetIdsInSpineDatabase);
      if (!_.isEmpty(missingWidgetIds)) {
        AppRedesign.logToScalyr('batch_error_debug dashboard missing widgets', {
          last_in_batch_widget_ids: this.lastInBatchWidgetIds,
          widgetIdsInSpineDatabase: widgetIdsInSpineDatabase
        });
      }
      return null;
    };

    WidgetFetcher.prototype.updateCurrentDashboardPermissions = function(response) {
      var ref;
      if (!AppRedesign.current().state.RbacEnabled) {
        return;
      }
      if (response['CurrentDashboardPermissions']) {
        return (ref = App.Dashboard.currentDashboard()) != null ? ref.applyPermissions(response['CurrentDashboardPermissions']) : void 0;
      }
    };

    return WidgetFetcher;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WidgetMenuController = (function(superClass) {
    extend(WidgetMenuController, superClass);

    WidgetMenuController.prototype.elements = {
      '.widget-menu': 'widgetMenu'
    };

    function WidgetMenuController() {
      this.exportImageClick = bind(this.exportImageClick, this);
      this.hide = bind(this.hide, this);
      WidgetMenuController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'chartTitleController', 'rowsText', 'showCsvIcon', 'showImageIcon', 'showLinkIcon', 'showPivotIcon', 'showSearchIcon');
      this.render();
    }

    WidgetMenuController.prototype.render = function() {
      this.html(this.view('widgets/widget_menu')({
        rowsText: this.rowsText,
        showCsvIcon: this.showCsvIcon,
        showEditCopyIcon: this.showEditCopyIcon,
        showImageIcon: this.showImageIcon,
        showLinkIcon: this.showLinkIcon,
        showPivotIcon: this.showPivotIcon,
        showSearchIcon: this.showSearchIcon,
        showSlackIcon: this.showSlackIcon
      }));
      if (this.showImageIcon) {
        return this.widgetMenu.find(".menu-item[name='image']").on('click', this.exportImageClick);
      }
    };

    WidgetMenuController.prototype.getEl = function() {
      return this.widgetMenu;
    };

    WidgetMenuController.prototype.hide = function(evt) {
      return this.widgetMenu.detach();
    };

    WidgetMenuController.prototype.exportImageClick = function() {
      return this.chartTitleController.trigger('export-image-click');
    };

    return WidgetMenuController;

  })(Spine.Controller);

}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/app_frame/app_frame_redesign"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="left-navigation"></div>\n<div class="notification-bar"></div>\n<div class="dashboards-container">\n    <div class="no-database-message">\n        <div class="no-database-icon"></div>\n        There are no databases visible to you. <br/> Please contact one of your administrators for access.\n    </div>\n    <div class="no-privileges-message">\n        <div class="no-privileges-icon"></div>\n        There are no privileges available to you. <br/> Please contact one of your administrators for access.\n    </div>    \n    <div class="no-content-message">\n        <div class="no-content-icon"></div>\n        You do not have access to any content in this space. <br/> Please contact one of your administrators for access.\n    </div>\n</div>\n<div id="main-viewport-react"></div>\n<div class="page-overlay"></div>\n<div id="dialogs"></div>\n<div id="modals-react"></div>\n<iframe id="tv_mode_frame"></iframe>\n<canvas id="canvas-text-sizer"></canvas>\n<div id="modal"></div>\n<div class="sticky-footer-panels"></div>\n<div class="screen-loader-line"></div>\n<div id=\'react-simple-tooltip\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/app_frame/app_frame_redesign_unification"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="notification-bar" ></div>\n<div class="switcher tooltip-cover-heading">\n    <div class="sisense-logo-section">\n        <div class="sisense-logo"></div>\n    </div>\n    <div class="switcher-dropdown">\n        ');
      
        if (this.selfServiceAccessEnabled) {
          __out.push('\n            <div class="switcher-dropdown-contents">\n                Workbooks\n                <div class="switcher-dropdown-icon"></div>\n            </div>\n            <div class="switcher-dropdown-options" style=\'display: none\'>\n                <div class="switcher-dropdown-switch-to">\n                    Switch To:\n                </div>\n                <div class="switcher-dropdown-sisense">\n                    Dashboards\n                </div>\n            </div>\n        ');
        } else {
          __out.push('\n            <div class="switcher-dropdown-contents no-self-service-access">\n                Workbooks\n            </div>\n        ');
        }
      
        __out.push('\n    </div>\n</div>\n<div class="left-navigation customer-unification"></div>\n<div class="dashboards-container customer-unification">\n    <div class="no-workbooks-message">\n        <div class="no-workbooks-icon"></div>\n        Your Workbooks access has been restricted.<br />\n        Please contact one of your administrators for access.<br />\n        To access your user settings, please navigate to<br />\n        <a href="javascript:void(0)" role="button" id="no-workbooks-profile-link">Profiles</a>\n    </div>\n    <div class="no-database-message">\n        <div class="no-database-icon"></div>\n        There are no databases visible to you. <br/> Please contact one of your administrators for access.\n    </div>\n    <div class="no-privileges-message">\n        <div class="no-privileges-icon"></div>\n        There are no privileges available to you. <br/> Please contact one of your administrators for access.\n    </div>\n    <div class="no-content-message">\n        <div class="no-content-icon"></div>\n        You do not have access to any content in this space. <br/> Please contact one of your administrators for access.\n    </div>\n</div>\n<div id="main-viewport-react" class="customer-unification"></div>\n<div class="page-overlay"></div>\n<div id="dialogs"></div>\n<div id="modals-react"></div>\n<iframe id="tv_mode_frame"></iframe>\n<canvas id="canvas-text-sizer"></canvas>\n<div id="modal"></div>\n<div class="sticky-footer-panels"></div>\n<div class="screen-loader-line"></div>\n<div id=\'react-simple-tooltip\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/app_frame/non_payment_bar"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="non-payment-bar-text">\n  Your account\'s billing status is past due.\n\n  ');
      
        if (this.daysLeft > 1) {
          __out.push('\n    Your access will be turned off in ');
          __out.push(__sanitize(this.daysLeft));
          __out.push(' days.\n  ');
        } else {
          __out.push('\n    Your access will be turned off tomorrow.\n  ');
        }
      
        __out.push('\n\n  ');
      
        if (this.userIsAdmin) {
          __out.push('\n    Contact Sisense\'s Finance team at <a href="mailto:ar_datateams@sisense.com">ar_datateams@sisense.com</a> to submit payment.\n  ');
        } else {
          __out.push('\n    Contact your Sisense Administrator for more details.\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/app_frame/overage_notification"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var boldSpan, cachedRowsPhrase, cachedStoragePhrase, creatorPhrase, embedPhrase, explorerPhrase, rowPhrase, spacePhrase, userPhrase;
      
        __out.push('<div class="butter-bar-message">\n  ');
      
        if (this.overageDataPresenter.severalLimits()) {
          __out.push('\n    Your account has exceeded several plan capacity limits.\n  ');
        } else {
          __out.push('\n    ');
          boldSpan = "<span class='heavy-13-mirage-font'>";
          __out.push('\n    ');
          rowPhrase = "" + boldSpan + (this.overageDataPresenter.formattedMaxRows()) + " rows</span>";
          __out.push('\n    ');
          userPhrase = "" + boldSpan + (this.overageDataPresenter.pluralizedPlanMaxUsers()) + "</span>";
          __out.push('\n    ');
          creatorPhrase = "" + boldSpan + (this.overageDataPresenter.pluralizedPlanMaxCreators()) + "</span>";
          __out.push('\n    ');
          explorerPhrase = "" + boldSpan + (this.overageDataPresenter.pluralizedPlanMaxExplorers()) + "</span>";
          __out.push('\n    ');
          spacePhrase = "" + boldSpan + (this.overageDataPresenter.pluralizedPlanMaxSpaces()) + "</span>";
          __out.push('\n    ');
          embedPhrase = "" + boldSpan + (this.overageDataPresenter.formattedMaxEmbedApiHits()) + " calls</span>";
          __out.push('\n    ');
          cachedRowsPhrase = "" + boldSpan + (this.overageDataPresenter.formattedCachedRows()) + " rows</span>";
          __out.push('\n    ');
          cachedStoragePhrase = "" + boldSpan + (this.overageDataPresenter.formattedCachedStorage()) + " GBs</span>";
          __out.push('\n\n    Your account has exceeded its\n    ');
          if (this.overageDataPresenter.firstKeyIs('rows')) {
            __out.push('\n      row limit of ');
            __out.push(rowPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('spaces')) {
            __out.push('\n      space limit of ');
            __out.push(spacePhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('users')) {
            __out.push('\n      user limit of ');
            __out.push(userPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('creators')) {
            __out.push('\n      creator limit of ');
            __out.push(creatorPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('explorers')) {
            __out.push('\n      explorer limit of ');
            __out.push(explorerPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('embed_api_hits')) {
            __out.push('\n      embedded API calls quota of ');
            __out.push(embedPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('cached_rows')) {
            __out.push('\n      cached rows limit of ');
            __out.push(cachedRowsPhrase);
            __out.push('\n    ');
          } else if (this.overageDataPresenter.firstKeyIs('cached_storage')) {
            __out.push('\n      cached storage limit of ');
            __out.push(cachedStoragePhrase);
            __out.push('\n    ');
          }
          __out.push('\n\n    ');
          if (this.overageDataPresenter.twoLimits()) {
            __out.push('\n      and\n      ');
            if (this.overageDataPresenter.secondKeyIs('spaces')) {
              __out.push('\n        is using more than ');
              __out.push(spacePhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('users')) {
              __out.push('\n        user limit of ');
              __out.push(userPhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('creators')) {
              __out.push('\n        creator limit of ');
              __out.push(creatorPhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('explorers')) {
              __out.push('\n        explorer limit of ');
              __out.push(explorerPhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('embed_api_hits')) {
              __out.push('\n        embedded API calls quota of ');
              __out.push(embedPhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('cached_rows')) {
              __out.push('\n        cached rows limit of ');
              __out.push(cachedRowsPhrase);
              __out.push('.\n      ');
            } else if (this.overageDataPresenter.secondKeyIs('cached_storage')) {
              __out.push('\n        cached storage limit of ');
              __out.push(cachedStoragePhrase);
              __out.push('.\n      ');
            }
            __out.push('\n    ');
          } else {
            __out.push('\n      by\n      ');
            if (this.overageDataPresenter.firstKeyIs('rows')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push(__sanitize(this.overageDataPresenter.formattedExcessRows()));
              __out.push(' rows</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('spaces')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push('\n        ');
              __out.push(__sanitize(this.overageDataPresenter.pluralizedExcessSpaces()));
              __out.push('</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('users')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push('\n        ');
              __out.push(__sanitize(this.overageDataPresenter.pluralizedExcessUsers()));
              __out.push('</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('creators')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push('\n        ');
              __out.push(__sanitize(this.overageDataPresenter.pluralizedExcessCreators()));
              __out.push('</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('explorers')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push('\n        ');
              __out.push(__sanitize(this.overageDataPresenter.pluralizedExcessExplorers()));
              __out.push('</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('embed_api_hits')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push(__sanitize(this.overageDataPresenter.formattedExcessEmbedApiHits()));
              __out.push(' calls</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('cached_rows')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push(__sanitize(this.overageDataPresenter.formattedExcessCachedRows()));
              __out.push(' rows</span>.\n      ');
            } else if (this.overageDataPresenter.firstKeyIs('cached_storage')) {
              __out.push('\n        ');
              __out.push(boldSpan);
              __out.push(__sanitize(this.overageDataPresenter.formattedExcessCachedStorage()));
              __out.push(' GBs</span>.\n      ');
            }
            __out.push('\n    ');
          }
          __out.push('\n  ');
        }
      
        __out.push('\n  <span class=\'plan-upgrade-link\' style=\'text-decoration:underline;cursor:pointer;\'>\n    Upgrade your plan</span>\n  or contact your Customer Success Manager to upgrade.\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/app_frame/status_bar"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="status-bar-text">\n  <span>');
      
        __out.push(this.message);
      
        __out.push('</span>\n  <a target="_blank" href="https://status.periscopedata.com/" rel="nofollow noopener noreferrer">Learn More</a>\n</div>\n<div class="status-bar-exit"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/checkbox"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="icon"></div>\n<div class="label">');
      
        __out.push(__sanitize(this.label));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/controls/checkbox_list"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var checkbox, i, index, len, ref;
      
        ref = this.config;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          checkbox = ref[index];
          __out.push('\n  <div class="checkbox ');
          if (checkbox.checked) {
            __out.push(__sanitize('checked'));
          }
          __out.push('" checkbox_index="');
          __out.push(__sanitize(index));
          __out.push('">\n    <div class="icon"></div>\n    <div class="label">');
          __out.push(__sanitize(checkbox.label));
          __out.push('</div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboard_permission/content"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="permission-labels">\n  <div class="group-label">Built-in Groups</div>\n  <div class="permission-label view">View</div>\n  <div class="permission-label edit">Edit</div>\n</div>\n<div class="permission-box"></div>\n<div class="error-message">An error has occurred</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboard_permission/dashboard_permission_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="permission-group">\n    <div class="group">');
      
        __out.push(__sanitize(this.group.name));
      
        __out.push('</div>\n    <div class="checkbox ');
      
        if (this.viewIsChecked) {
          __out.push('checked');
        }
      
        __out.push(' ');
      
        if (this.viewDisabled) {
          __out.push('disabled');
        }
      
        __out.push('" group_id="');
      
        __out.push(__sanitize(this.group.id));
      
        __out.push('" permission="view">\n      <div class="icon"></div>\n    </div>\n    <div class="checkbox ');
      
        if (this.editIsChecked) {
          __out.push('checked');
        }
      
        __out.push(' ');
      
        if (this.editDisabled) {
          __out.push('disabled');
        }
      
        __out.push(' ');
      
        if (this.editGreyed) {
          __out.push('greyed');
        }
      
        __out.push('" group_id="');
      
        __out.push(__sanitize(this.group.id));
      
        __out.push('" permission="edit">\n      <div class="icon"></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboard_tags/content"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, tag;
      
        __out.push('<div class="tags-container">\n  ');
      
        if (this.tags.length === 0) {
          __out.push('\n    <div class="no-tags">No tags available.</div>\n  ');
        } else {
          __out.push('\n    ');
          ref = this.tags;
          for (i = 0, len = ref.length; i < len; i++) {
            tag = ref[i];
            __out.push('\n      <div class="tag" tagid="');
            __out.push(__sanitize(tag.id));
            __out.push('">\n        <div class="label">');
            __out.push(__sanitize(tag.name));
            __out.push('</div>\n        <div class="checkbox\n                    ');
            if (tag.checked) {
              __out.push(__sanitize('checked'));
            }
            __out.push(' \n                    ');
            if (tag.disabled) {
              __out.push(__sanitize('disabled'));
            }
            __out.push(' ">\n          <div class="icon"></div>\n        </div>\n      </div>\n    ');
          }
          __out.push('\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/aggregation_dimension_setting"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="aggregation-dropdown">\n  <div class="generic-label">Aggregation</div>\n  <div class="options"> </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/custom_dimension_availability_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="checkbox ');
      
        __out.push(__sanitize(this.checked ? 'checked' : void 0));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.disabled ? 'disabled' : void 0));
      
        __out.push('" cd_cid="');
      
        __out.push(__sanitize(this.cid));
      
        __out.push('">\n  <div class="icon"></div>\n  <div class="label">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('\n    ');
      
        if (this.disabled) {
          __out.push('<div class="locked">Visible on Shared Dashboard</div>');
        }
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/custom_dimension_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var d, i, len, ref;
      
        __out.push('<div class="form-animate-body light-theme">\n  <div class="form-title"></div>\n  <div class="form-scroll-body">\n    <div class="refresh-button"></div>\n    <div class="close-x"></div>\n    <input class="dimension-name" placeholder="Name"></input>\n    <div class="condition-options">\n      <div class="names-from-db block">\n        <div class="values-area">\n          <div class="values-content">\n            <div class="sql-box"></div>\n            <select class="database-picker">\n              ');
      
        ref = App.Database.all();
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          __out.push('\n                <option value=');
          __out.push(__sanitize(d.id));
          __out.push('>');
          __out.push(__sanitize(d.database_name));
          __out.push('</option>\n              ');
        }
      
        __out.push('\n            </select>\n          </div>\n        </div>\n      </div>\n      <div class="names-from-form block">\n        <div class="values-area">\n          <div class="values-content"></div>\n        </div>\n      </div>\n    </div>\n    <div class="expression-from-sql">\n      <div class="values-area">\n        <div class="values-content">\n          <div class="sql-box"></div>\n        </div>\n        <div class="delete-area">\n          <div class="checkbox enable-deletion">\n            <div class="icon"></div>\n            <div class="label">Enable deletion</div>\n          </div>\n          <div class="delete button auto-width">Permanently Delete</div>\n          <div class="delete-confirm">\n            <div class="message">Are you sure?</div>\n            <div class="delete button destructive auto-width">Yes, Delete</div>\n            <div class="options link cancel-delete">Cancel</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="save-row">\n      <div class="error"></div>\n      <div class="save button">Save</div>\n      <div class="more options link">More Options</div>\n      <div class="less options link">Fewer Options</div>\n      <div class="options link hide">Hide</div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/dashboard"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var bgImage;
      
        __out.push('<div class="dashboard-header">\n  <div class="dashboard-labels">\n    <div class="dash-name-area">\n      <input type="text" class="dashboard-name"></input>\n    </div>\n  </div>\n  <div class="email-subheader">\n    ');
      
        __out.push(__sanitize(this.screenshotTimestampLabel));
      
        __out.push('\n  </div>\n  ');
      
        if (!this.dashboard.is_fluid || this.isScreenshotMode !== true) {
          __out.push('\n    <div class="logo-area">\n      ');
          bgImage = "none";
          __out.push('\n      <div class="customer-logo" style="background-image:');
          __out.push(__sanitize(bgImage));
          __out.push(';"></div>\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="dashboard-settings-wrapper"></div>\n  <div class="control-row">\n    <div class="left-controls">\n      <span class="ownership"></span>\n      <span class="full-screen button">Go Full Screen</span>\n      <div class="tags-container dashboard-menu"></div>\n      <div class="more dashboard-menu"></div>\n      <span class="star button"></span>\n      <span class="refresh-icon"></span>\n      <div class="dash-loader"><div class="icon">&nbsp;</div><span class="message">Loading...</span></div>\n    </div>\n    <span class="add-sql-chart light-theme">\n      <div class="button create main">\n        <span class="text">New SQL Chart</span>\n      </div>\n    </span>\n  </div>\n</div>\n<div class="grid-boundary chart-tooltip-boundary">\n  <div class="grid-left-border"></div>\n  <div class="grid-right-border"></div>\n  ');
      
        if (this.dashboard.is_fluid) {
          __out.push('\n    <div class="empty-dash-message"><div class ="top">Click New SQL Chart</div><div class="bottom">to begin your analysis!</div></div>\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/dashboard_settings_filter"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div dimensionId="');
      
        __out.push(__sanitize(this.dimensionId));
      
        __out.push('"\n     dimensionValueId="');
      
        __out.push(__sanitize(this.dimensionValueId));
      
        __out.push('"\n     class="filter ');
      
        __out.push(__sanitize(this.filterType));
      
        __out.push('">\n  <span class="label">');
      
        __out.push(__sanitize(this.label));
      
        __out.push('</span>\n  <div class="remove"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/grid_columns"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-column-dividers" position="0"></div>\n<div class="grid-column-dividers" position="1"></div>\n<div class="grid-column-dividers" position="2"></div>\n<div class="grid-column-dividers" position="3"></div>\n<div class="grid-column-dividers" position="4"></div>\n<div class="grid-column-dividers" position="5"></div>\n<div class="grid-column-dividers" position="6"></div>\n<div class="grid-column-dividers" position="7"></div>\n<div class="grid-column-dividers" position="8"></div>\n<div class="grid-column-dividers" position="9"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/grid_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-row row-');
      
        __out.push(__sanitize(this.row));
      
        __out.push('">\n  <div class="corner-cover-corral">\n    <div class="corner-cover" position="0"></div>\n    <div class="corner-cover" position="1"></div>\n    <div class="corner-cover" position="2"></div>\n    <div class="corner-cover" position="3"></div>\n    <div class="corner-cover" position="4"></div>\n    <div class="corner-cover" position="5"></div>\n    <div class="corner-cover" position="6"></div>\n    <div class="corner-cover" position="7"></div>\n    <div class="corner-cover" position="8"></div>\n    <div class="corner-cover" position="9"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/parent_dim_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var d, i, len, ref;
      
        __out.push('<div class="parent-dim-area">\n\t<div class="checkbox"></div>\n  <select class="parent-dim-picker">\n    ');
      
        ref = App.CustomDimension.allNonFreeInputSortedByName();
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          if (!(d.id !== this.currentId)) {
            continue;
          }
          __out.push('\n    <option ');
          if (d.id === this.selectedId) {
            __out.push(__sanitize(' selected '));
          }
          __out.push(' value=');
          __out.push(__sanitize(d.id));
          __out.push('>');
          __out.push(__sanitize(d.name));
          __out.push('</option>\n    ');
        }
      
        __out.push('\n  </select>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/setting_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div dimension="');
      
        __out.push(__sanitize(App.CustomDimension.elementIdForDimension(this.dimension)));
      
        __out.push('"\n     class="setting dimension-setting ');
      
        __out.push(__sanitize(this.collapsed ? 'collapsed' : ''));
      
        __out.push('"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/shares"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, sd;
      
        __out.push('<div class="title">\n  <div class="label">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n  <div class="add-new button">ADD NEW</div>\n</div>\n<span class="shares-list-scroll-wrapper">\n  <div class="shares-list-container">\n    <div class="shared-dashboards-list">\n      ');
      
        ref = this.sharedDashboards;
        for (i = 0, len = ref.length; i < len; i++) {
          sd = ref[i];
          if (!(!(sd.api_generated || sd.temporary))) {
            continue;
          }
          __out.push('\n      <div class="shared-dashboard" shared_dashboard_id="');
          __out.push(__sanitize(sd.cid));
          __out.push('">\n        <div class="name">');
          __out.push(__sanitize(sd.title()));
          __out.push('</div>\n      </div>\n      ');
        }
      
        __out.push('\n    </div>\n  </div>\n</span>\n<div class="shares-edit-container">\n  <div class="instructions">\n    <div class="heading">Shared dashboards are externally accessible.</div>\n    <div class="subheading">Share dashboards with specific filter values to easily send data to\n        external parties.\n        <br/>\n        <a class="link subtle" target=\'_blank\' href="https://doc.periscopedata.com/doc/share-dashboards" rel="nofollow noopener noreferrer">Learn More.</a>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/shares_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var cd, i, idx, info, j, len, len1, ref, ref1;
      
        __out.push('<div class="form-header">\n  ');
      
        if (this.canEdit) {
          __out.push('\n    <input class="name" placeholder="Shared Dashboard Name">\n  ');
        } else {
          __out.push('\n    <div class="name">\n      <a class="share-link label" target="_blank" href="');
          __out.push(__sanitize(this.shareUrl));
          __out.push('" rel="nofollow noopener noreferrer">');
          __out.push(__sanitize(this.title));
          __out.push('</a>\n      <span class=\'view-count\'>');
          __out.push(__sanitize(this.viewCount));
          __out.push(' Views</span>\n    </div>\n    <div class="share-url"><a class="share-link" target="_blank" href="');
          __out.push(__sanitize(this.shareUrl));
          __out.push('" rel="nofollow noopener noreferrer">');
          __out.push(__sanitize(this.shareUrl));
          __out.push('</a></div>\n  ');
        }
      
        __out.push('\n</div>\n\n');
      
        if (this.dims.length) {
          __out.push('\n<div class="dimension-settings ');
          if (this.canEdit) {
            __out.push(__sanitize('edit'));
          }
          __out.push('">\n  <div class="row headers">\n    <div class="cell name">Filter</div>\n    <div class="cell changeable"><span class="label">Visible</span><div class="info-icon"></div></div>\n    <div class="cell selected-dimensions">Values</div>\n  </div>\n  <div class="dimensions-grid">\n  ');
          ref = this.dims;
          for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
            cd = ref[idx];
            __out.push('\n    <div row_index=');
            __out.push(__sanitize(idx % 2));
            __out.push('  dim_cid="');
            __out.push(__sanitize(cd.cid));
            __out.push('" class="row body">\n      <div class="cell name">');
            __out.push(__sanitize(cd.name));
            __out.push('</div>\n      <div class="cell changeable">\n        <div dim_cid="');
            __out.push(__sanitize(cd.cid));
            __out.push('"\n          class="checkbox\n            ');
            if (cd.checked) {
              __out.push(' checked');
            }
            __out.push('\n            ');
            if (!this.canEdit) {
              __out.push(' disabled');
            }
            __out.push('\n          "><div class="icon"></div>\n        </div>\n      </div>\n      <div class="cell selected-dimensions">\n        <div class="dimension-area" row_index=');
            __out.push(__sanitize(idx % 2));
            __out.push(' dim_cid="');
            __out.push(__sanitize(cd.cid));
            __out.push('">\n          ');
            if (this.canEdit) {
              __out.push('\n            <select multiple=true dim_cid="');
              __out.push(__sanitize(cd.cid));
              __out.push('">\n              ');
              ref1 = cd.values;
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                info = ref1[j];
                __out.push('\n                <option selected value="');
                __out.push(__sanitize(info.value));
                __out.push('" group="');
                __out.push(__sanitize(info.group));
                __out.push('">');
                __out.push(__sanitize(info.value_name));
                __out.push('</option>\n              ');
              }
              __out.push('\n            </select>\n            ');
              if (cd.cid === 'date_range') {
                __out.push('\n            <div class="custom-date-range">\n                <div class="range-row">\n                    <div class="input-wrapper"><input class="range-start range-input" placeholder="Start Date"></input></div>\n                    <div class="picker-button start"></div>\n                </div>\n                <div class="range-row">\n                    <div class="input-wrapper"><input class="range-end range-input" placeholder="End Date"></input></div>\n                    <div class="picker-button end"></div>\n                </div>\n            </div>\n            ');
              }
              __out.push('\n          ');
            } else {
              __out.push('\n            <div class="view-dim-name">');
              __out.push(__sanitize(((function() {
                var k, len2, ref2, results;
                ref2 = cd.values;
                results = [];
                for (k = 0, len2 = ref2.length; k < len2; k++) {
                  info = ref2[k];
                  results.push(info.value_name);
                }
                return results;
              })()).join(", ")));
              __out.push('</div>\n          ');
            }
            __out.push('\n        </div>\n      </div>\n    </div>\n  ');
          }
          __out.push('\n  </div>\n</div>\n');
        }
      
        __out.push('\n\n<div class="button-area">\n');
      
        if (this.canEdit) {
          __out.push('\n  <div class="share button">Share</div>\n  <div class="link cancel-share">Cancel</div>\n');
        } else {
          __out.push('\n    <div class="delete-confirm-area">\n      Are you sure?\n      <div class="delete button destructive">Yes, Delete</div>\n      <div class="cancel link">Cancel</div>\n    </div>\n    <div class="revoke link">Delete</div>\n');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dashboards/widget_undo"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="toast-yellow">\n  <div class=\'undo-widget-change\'>\n      <div class="toast-text">\n        Charts ');
      
        __out.push(__sanitize(this.action));
      
        __out.push('\n        <div class="toast-undo-link">Undo</div>\n        <div class="icon-close-toast"></div>\n      </div>\n  </div>\n<div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/databases/error_link"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<a class="underlined-link help-connecting" href="/doc/@link" target="_blank" rel="nofollow noopener noreferrer">Help connecting.</a>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/databases/form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="database-connect">\n  <table class="form">\n    ');
      
        if (this.newCustomer) {
          __out.push('\n        <tr row="email_address">\n          <td>Email Address</td>\n          <td><input type="text" placeholder="your@email.com" spellcheck="false" tabindex="0"></input></td>\n        </tr>\n    ');
        } else {
          __out.push('\n      <tr row="display_name">\n          <td>Display Name</td>\n          <td><input type="text" placeholder="prod_analytics" spellcheck="false" tabindex="0"></input></td>\n      </tr>\n    ');
        }
      
        __out.push('\n    <tr row="type">\n      <td>Database Type</td>\n      <td>\n        <select tabindex="-1">\n          <option value="mysql">MySQL</option>\n          <option value="postgres">Postgres</option>\n          <option value="redshift">Redshift</option>\n          <option value="vertica">Vertica</option>\n          <option value="sql_server">SQL Server</option>\n          <option value="oracle">Oracle</option>\n          <option value="memsql">MemSQL</option>\n          <option value="sybase">Sybase</option>\n          <option value="exasol">Exasol</option>\n          <option value="bigquery">BigQuery</option>\n          <option value="snowflake">Snowflake</option>\n          ');
      
        if (this.salesforceEnabled && this.cacheEnabled) {
          __out.push('\n            <option value="SalesforceDatabase">Salesforce</option>\n          ');
        }
      
        __out.push('\n        </select>\n      </td>\n    </tr>\n  </table>\n\n  <div id="specific-database-fields"></div>\n\n  <div class="row submit-row">\n    <div class="button submit">Submit</div>\n    <div class="ssh-tunnel private-network clickable">Connect to a Private Network</div>\n    <div class="ssh-tunnel help">\n      <form class="public-key" method="get" action="/periscope_id_rsa.pub">\n        <button class="clickable">Download Public Key</button>\n      </form>\n      &middot;\n      <a class="ssh-tunnel-doc clickable" href="/doc/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">Do I need an SSH Tunnel?</a>\n      <a class="more-info clickable" href="/doc/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">More Info</a>\n    </div>\n    <span class="db-loader"><span class="text">Loading...</span><span class="spinner"></span></span>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/databases/more_help"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="more-help">\n  For help, see our\n  <a href="https://doc.periscopedata.com/doc/common-connection-errors"\n  target="_blank" rel="nofollow noopener noreferrer">connection troubleshooting guide</a>.\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/databases/non_polymorphic_form_fields"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var database_id, database_name, ref, ref1, ref2;
      
        __out.push('<table class="form">\n    <tr row="jdbc_command_type">\n        <td>Database Name</td>\n        <td>\n            <select>\n               <option value="service_name">Service Name</option>\n               <option value="sid">SID</option>\n            </select>\n            <input class="redesign-input" type="text" placeholder="db1" spellcheck="false"></input>\n        </td>\n    </tr>\n    <tr row="database_name">\n        <td>Database Name</td>\n        <td><input type="text" placeholder="db1" spellcheck="false"></input></td>\n    </tr>\n    <tr row="host">\n        <td>Database Host</td>\n        <td><input type="text" spellcheck="false"></input></td>\n    </tr>\n    <tr row="port">\n        <td>Database Port</td>\n        <td><input type="text" spellcheck="false"></input></td>\n    </tr>\n    <tr row="account_name">\n        <td>Account Name</td>\n        <td><input type="text" placeholder="account.snowflakecomputing.com" spellcheck="false"></input></td>\n    </tr>\n    <tr row="warehouse_name">\n        <td>Warehouse Name</td>\n        <td><input type="text" placeholder="warehouse_name" spellcheck="false"></input></td>\n    </tr>\n    <tr row="snowflake_username">\n        <td>Snowflake Username</td>\n        <td><input type="text" placeholder="snowflake_username" spellcheck="false"></input></td>\n    </tr>\n    <tr row="snowflake_password">\n        <td>\n          Snowflake Password\n          ');
      
        if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          __out.push('\n            <span class="text-danger">(deprecated)</span>\n          ');
        }
      
        __out.push('\n        </td>\n        <td><input class="snowflake-either-present" type="password" placeholder="snowflake_password" spellcheck="false"></input></td>\n    </tr>\n    <tr row="username">\n        <td>Database Username</td>\n        <td><input type="text" placeholder="database_user" spellcheck="false"></input></td>\n    </tr>\n    <tr row="password">\n        <td>Database Password</td>\n        <td><input type="password" placeholder="database_password" spellcheck="false"></input></td>\n    </tr>\n    <tr row="parent_database">\n        <td>Replica Of</td>\n        <td>\n            <select class="replica-dropdown">\n                <option value="-1">None</option>\n                ');
      
        ref1 = this.databaseNames;
        for (database_name in ref1) {
          database_id = ref1[database_name];
          __out.push('\n                <option value="');
          __out.push(__sanitize(database_id));
          __out.push('">');
          __out.push(__sanitize(database_name));
          __out.push('</option>\n                ');
        }
      
        __out.push('\n            </select>\n        </td>\n    </tr>\n    <tr row="service_account">\n        <td>Service Account</td>\n        <td><input type="text" placeholder="abc123@developer.gserviceaccount.com" spellcheck="false"></input></td>\n    </tr>\n    <tr row="project_id">\n        <td>Project Id</td>\n        <td><input type="text" placeholder="strong-planet-103422" spellcheck="false"></input></td>\n    </tr>\n    <tr row="p12_key_file">\n        <td>P12 KeyFile</td>\n        <td><div class="key-file p12"><span class="default-text">Click or drag to upload</span><span class="file-name"></span>\n            <input class="key-file-drop" type="file" placeholder="Drag to Upload" spellcheck="false"></input>\n        </div></td>\n    </tr>\n\n    ');
      
        if ((ref2 = App.Site.first()) != null ? ref2.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          __out.push('\n      <tr row="snowflake_pk8_key_file">\n          <td>P8 KeyFile</td>\n          <td><div class="key-file pk8"><span class="default-text">Click or drag to upload</span><span class="file-name"></span>\n              <input class="key-file-drop snowflake-either-present" type="file" placeholder="Drag to Upload" spellcheck="false"></input>\n          </div></td>\n      </tr>\n      <tr row="snowflake_pk8_pwd">\n          <td>P8 Passphrase (optional)</td>\n          <td><input type="password" class="optional" placeholder="snowflake_pk_pwd" spellcheck="false"></input></td>\n      </tr>\n    ');
        }
      
        __out.push('\n</table>\n\n<div class="ssh-tunnel-form">\n  <table class="form">\n    <tr row="ssh-host">\n      <td>SSH Host</td>\n      <td><input type="text" placeholder="ssh-bastion.my-domain.com" spellcheck="false"></input></td>\n    </tr>\n    <tr row="ssh-username">\n      <td>SSH Username</td>\n      <td><input type="text" placeholder="ssh_user" spellcheck="false"></input></td>\n    </tr>\n    <tr row="ssh-port">\n      <td>SSH Port</td>\n      <td><input type="text" value="22" spellcheck="false"></input></td>\n    </tr>\n  </table>\n</div>\n\n<div class="errors">\n    <div class="error validation"></div>\n\n    <div class="error status-ok"></div>\n\n    <div class="error error-unexpected">\n        An unexpected error occurred:\n        <div class="full-msg"></div>\n    </div>\n\n    <div class="error error-timeout">\n        The database connection is timing out.<br>\n        <span class="error-info">\n            Please whitelist\n            <span class="ip">107.23.195.228</span> and <span class="ip">54.236.224.46</span>.\n            ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n        </span>\n    </div>\n\n    <div class="error error-snowflake-timeout">\n        The account was not found. Is the account name\n        <span class="account_name"></span> correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error user-temporarily-locked">\n        Snowflake user temporarily locked. Please try again later or contact your Snowflake system administrator.\n    </div>\n\n    <div class="error error-user-access-denied">\n        Access for user <span class="username"></span> was denied.\n        Are the username and password correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-unknown-database">\n        The database was not found. Is the database name\n        <span class="database_name"></span> correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-user-cannot-access-db" databases="mysql">\n        Permission was denied to the database. Please run:\n        <div class="indented">\n      <pre>\nGRANT SELECT ON <span class="database_name"></span>.% TO \'<span class="username"></span>\'@\'107.23.195.228\';\nGRANT SELECT ON <span class="database_name"></span>.% TO \'<span class="username"></span>\'@\'54.236.224.46\';</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-user-cannot-access-db" databases="postgres redshift">\n        Permission was denied to the database. Please run:\n        <div class="indented">\n      <pre>\nGRANT USAGE ON SCHEMA public TO <span class="username"></span>;\nGRANT SELECT ON ALL TABLES IN SCHEMA public TO <span class="username"></span>;</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-hba-conf">\n        The user is not permitted in the pg_hba.conf file. Please add these lines to your pg_hba.conf file:\n        <div class="indented">\n      <pre>\nhost&#09;all&#09;<span class="username"></span>&#09;107.23.195.228/32&#09;password\nhost&#09;all&#09;<span class="username"></span>&#09;54.236.224.46/32&#09;password</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-connection-attempt-failed">\n        Sisense could not connect to the database server. Are the database host and port correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-check-host-and-port">\n        Sisense was unable connect to the database server. Are the database host and port correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-authenticate">\n        SSH access was denied. Have you authorized the public key?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-host">\n        Could not find SSH host. Please check ssh host name and whitelist <span class="ip">107.23.195.228</span> and <span class="ip">54.236.224.46</span> in your firewall.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-internal-error">\n        Sisense had an internal error. Please try again shortly.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-tunnel-database">\n        SSH access was successful, but database could not be found. Please check your database host and port.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-key-not-authorized" database="bigquery">\n        The key file provided could not authenticate to BigQuery.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-key-file-integrity" database="bigquery">\n        The key file provided is not in the right format.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/databases/salesforce_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="form salesforce">\n  <tr row="login_name">\n  <td>Login Name</td>\n    <td><input type="text" spellcheck="false" value="');
      
        __out.push(__sanitize(this.initialValues.username));
      
        __out.push('"></input></td>\n  </tr>\n  <tr row="login_password">\n    <td>Login Password</td>\n    <td><input type="password" spellcheck="false"></input></td>\n  </tr>\n  <tr row="security_token">\n    <td>Security Token</td>\n    <td><input type="password" spellcheck="false"></input></td>\n  </tr>\n  <tr row="client_id">\n    <td>Client Id</td>\n    <td><input type="text" spellcheck="false" value="');
      
        __out.push(__sanitize(this.initialValues.client_id));
      
        __out.push('"</input>></td>\n  </tr>\n  <tr row="client_secret">\n    <td>Client Secret</td>\n    <td><input type="password" spellcheck="false"></input></td>\n  </tr>\n</table>\n\n<div class="errors">\n  <div class="error validation"></div>\n  <div class="error status-ok"></div>\n  <div class="error client-identifier-invalid">\n    Client Id Invalid\n  </div>\n  <div class="error invalid-client-credentials">\n    Client Secret invalid\n  </div>\n  <div class="error authentication-failure">\n    One or more of Login Name, Login Password, or Security Token is invalid\n  </div>\n  <div class="error invalid_site_for_salesforce">\n    This site is not enabled for Salesforce. Please contact Sisense.\n  </div>\n  <div class="error cache_not_enabled_salesforce">\n    Cannot make Salesforce database since this site is not enabled for caching. Please contact Sisense.\n  </div>\n  <div class="error error-unexpected">\n      An unexpected error occurred:\n      <div class="full-msg"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dialog/dialog"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="main-text">');
      
        __out.push(__sanitize(this.mainText));
      
        __out.push('</div>\n<div class="ok button auto-width">');
      
        __out.push(__sanitize(this.okButtonText));
      
        __out.push('</div>\n<div class="cancel button inert auto-width">');
      
        __out.push(__sanitize(this.cancelButtonText));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dialog/frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="dialog">\n  <div class="cancel-icon"></div>\n  <div class="warning-icon"></div><div class="dialog-title">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n  <div class="dialog-content"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/dropdown"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, opt, ref;
      
        __out.push('<span>\n  <select class="dropdown">\n  ');
      
        ref = this.options;
        for (i = 0, len = ref.length; i < len; i++) {
          opt = ref[i];
          __out.push('\n    <option value=');
          __out.push(__sanitize(opt.value));
          __out.push('>');
          __out.push(__sanitize(opt.name));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n  </select>\n</span>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/archive_viewer/archive_viewer"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="archive-viewer-content">\n  <div class="archive-title">HISTORY</div>\n  <div class="results-area"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/archive_viewer/header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="archive-header">');
      
        __out.push(__sanitize(this.header));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/archive_viewer/item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="archive-item ');
      
        __out.push(__sanitize(this.cssClass));
      
        __out.push('" archived_id="');
      
        __out.push(__sanitize(this.archivedId));
      
        __out.push('">\n\t<span class="time">');
      
        __out.push(__sanitize(this.time));
      
        __out.push('</span>\n\t<span class="message">');
      
        __out.push(__sanitize(this.message));
      
        __out.push('</span>\n\t<span class="apply">Apply</span>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/database_status_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="info-grid">\n  <tr><td>Connection Healthy</td><td class="last-ping">');
      
        __out.push(__sanitize(this.lastPingAgo));
      
        __out.push('</td></tr>\n  <tr><td>Schemas Updated</td><td>\n    <span class="schema-refresh">');
      
        __out.push(__sanitize(this.lastSchemaRefresh));
      
        __out.push('</span>\n    <span class="refresh-button refresh-schema-now"></span>\n  </td></tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/salesforce_object_harvest_config"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="form-area">\n    <table class="harvest-settings info-grid">\n        <tr>\n            <td>\n                Caching Strategy<a href="/doc/caching-strategies#caching-strategies" target="_blank" rel="nofollow noopener noreferrer"><div class="status-icon"></div></a>\n            </td>\n            <td>\n                <select class="strategy-select">\n                    <option value=\'none\'>None</option>\n                    <option value=\'full\'>Full</option>\n                </select>\n            </td>\n        <tr>\n        <tr class=\'full-row\'><td>Full Update</td><td class=\'full-update-cell\'>\n            <div class="radio-button interval"><div class="icon"></div> Interval</div>\n            <div class=\'select-cell full-harvest refresh-interval\'>\n                <select class="full-harvest-interval-select">\n                    <option value=\'300\'>5 minutes</option>\n                    <option value=\'900\'>15 minutes</option>\n                    <option value=\'1800\'>30 minutes</option>\n                    <option value=\'3600\'>1 hour</option>\n                    <option value=\'7200\'>2 hours</option>\n                    <option value=\'28800\' selected>8 hours</option>\n                    <option value=\'86400\'>24 hours</option>\n                </select>\n            </div>\n            <div class="radio-button schedule"><div class="icon"></div> Schedule</div>\n            <div class=\'select-cell refresh-schedule\'>\n                <select class="full-harvest-hour-select">\n                    <option value=\'0\'>00</option>\n                    <option value=\'1\'>01</option>\n                    <option value=\'2\'>02</option>\n                    <option value=\'3\'>03</option>\n                    <option value=\'4\'>04</option>\n                    <option value=\'5\'>05</option>\n                    <option value=\'6\'>06</option>\n                    <option value=\'7\'>07</option>\n                    <option value=\'8\'>08</option>\n                    <option value=\'9\'>09</option>\n                    <option value=\'10\'>10</option>\n                    <option value=\'11\'>11</option>\n                    <option value=\'12\'>12</option>\n                    <option value=\'13\'>13</option>\n                    <option value=\'14\'>14</option>\n                    <option value=\'15\'>15</option>\n                    <option value=\'16\'>16</option>\n                    <option value=\'17\'>17</option>\n                    <option value=\'18\'>18</option>\n                    <option value=\'19\'>19</option>\n                    <option value=\'20\'>20</option>\n                    <option value=\'21\'>21</option>\n                    <option value=\'22\'>22</option>\n                    <option value=\'23\'>23</option>\n                </select>\n                :\n                <select class="full-harvest-min-select">\n                    <option value=\'0\'>00</option>\n                    <option value=\'15\'>15</option>\n                    <option value=\'30\'>30</option>\n                    <option value=\'45\'>45</option>\n                </select>\n                <span class=\'utc-info\'>UTC</span>\n            </div>\n        </tr>\n    </table>\n    <div class="error-row"></div>\n    <div class="button-row">\n        <div class="link cancel">Cancel</div>\n        <div class="button action save">Save</div>\n    </div>\n</div>\n<div class=\'extras-area\'>\n  <table class="info-grid wider-first-child">\n    <tr><td>Table Size</td><td class="table-row-count">');
      
        __out.push(__sanitize(this.rowCount));
      
        __out.push('</td></tr>\n    <tr><td>Last Full Update</td><td class="last-full-update-time"></td></tr>\n    <tr><td>Last Full Update Runtime</td><td class="last-full-runtime"></td></tr>\n    <tr><td>Disabled</td><td class="disable-harvest">\n    <div class="checkbox"><div class="icon"></div></div>\n    </td></tr>\n    <tr><td>Reload Cache</td><td class="full-refresh-now"><div class="button subtle">Reload</div></td></tr>\n    <tr><td>Delete Cache</td><td class="delete-harvest"><div class="button subtle">Delete</div></td></tr>\n  </table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/salesforce_object_harvest_headers"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="row-headers">\n    <div class="row-header salesforce-table-name">Table</div>\n    <div class="row-header salesforce-cache-enabled">Cached</div>\n    <div class="row-header status">Status</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/salesforce_object_harvest_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="table-harvest-row" data-salesforce-table-name="');
      
        __out.push(__sanitize(this.tableName));
      
        __out.push('">\n    <div class="harvest-cell expansion"></div>\n    <div class="harvest-cell salesforce-table-name">');
      
        __out.push(__sanitize(this.tableName));
      
        __out.push('</div>\n    <div class="harvest-cell salesforce-cache-enabled">');
      
        __out.push(__sanitize(this.cacheEnabled));
      
        __out.push('</div>\n    <div class="harvest-cell status" state="');
      
        __out.push(__sanitize(this.statusState));
      
        __out.push('">');
      
        __out.push(__sanitize(this.statusText));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/table_harvest_cache_area"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="yoink-list"><div class="message">Loading cache status...</div></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/table_harvest_config"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="form-area">\n  <table class="harvest-settings info-grid">\n    <tr><td>Caching Strategy<a href="/doc/caching-strategies#caching-strategies" target="_blank" rel="nofollow noopener noreferrer"><div class="status-icon"></div></a></td><td><select class="strategy-select"></select></td><tr>\n    <tr class=\'ingest-key-row\'><td>Import Column<a href="/doc/caching-strategies#import-columns" target="_blank" rel="nofollow noopener noreferrer"><div class="status-icon"></div></a></td><td><select class="ingest-key-select"></select></td></tr>\n    <tr class=\'incremental-row\'><td>Incremental Update Interval</td><td><select class="harvest-interval-select"></select></td></tr>\n    <tr class=\'full-row\'><td>Full Update</td><td class=\'full-update-cell\'>\n      <div class="radio-button interval"><div class="icon"></div> Interval</div>\n      <div class=\'select-cell full-harvest refresh-interval\'><select class="full-harvest-interval-select"></select></div>\n      <div class="radio-button schedule"><div class="icon"></div> Schedule</div>\n      <div class=\'select-cell refresh-schedule\'><select class="full-harvest-hour-select"></select> : <select class="full-harvest-min-select"></select> <span class=\'utc-info\'>UTC</span></div>\n    </tr>\n    <tr class=\'update-row\'><td>Update Interval</td><td><select class="update-harvest-interval-select"></select></td></tr>\n    <tr class=\'update-row\'><td>Update Window</td><td><select class="update-harvest-daterange"></select></td></tr>\n  </table>\n  <div class="error-row"></div>\n  <div class="button-row">\n    <div class="link cancel">Cancel</div>\n    <div class="button action save">Save</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/table_harvest_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('\n<div class=\'extras-area\'>\n  <table class="info-grid wider-first-child">\n    <tr><td>Table Size</td><td class="table-row-count">');
      
        __out.push(__sanitize(this.rowCount));
      
        __out.push('</td></tr>\n    <tr><td>Last Checked</td><td class="last-update-time"></td></tr>\n    <tr><td>Last Incremental Update</td><td class="last-incremental-update-time"></td></tr>\n    <tr><td>Last Incremental Runtime</td><td class="last-incremental-runtime"></td></tr>\n    <tr><td>Last Full Update</td><td class="last-full-update-time"></td></tr>\n    <tr><td>Last Full Update Runtime</td><td class="last-full-runtime"></td></tr>\n    <tr><td>Disabled</td><td class="disable-harvest">\n    <div class="checkbox"><div class="icon"></div></div>\n    </td></tr>\n    <tr><td>Reload Cache</td><td class="full-refresh-now"><div class="button subtle">Reload</div></td></tr>\n    <tr><td>Delete Cache</td><td class="delete-harvest"><div class="button subtle">Delete</div></td></tr>\n  </table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/table_harvest_headers"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="row-headers">\n  <div class="row-header schema-name">Schema</div>\n  <div class="row-header table-name">Table</div>\n  <div class="row-header status">Status</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/configitron/table_harvest_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="table-harvest-row" full_name="');
      
        __out.push(__sanitize(this.schemaName));
      
        __out.push('.');
      
        __out.push(__sanitize(this.tableName));
      
        __out.push('">\n  <div class="harvest-cell expansion"></div>\n  <div class="harvest-cell schema-name">');
      
        __out.push(__sanitize(this.schemaName));
      
        __out.push('</div>\n  <div class="harvest-cell table-name">');
      
        __out.push(__sanitize(this.tableName));
      
        __out.push('</div>\n  <div class="harvest-cell status" state="');
      
        __out.push(__sanitize(this.statusState));
      
        __out.push('">');
      
        __out.push(__sanitize(this.statusText));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/data_bar_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="data-bar-row" rule_id="');
      
        __out.push(__sanitize(this.rule.id));
      
        __out.push('">\n  <div class="reorder-controls">\n    <div class="delete"></div>\n    <div class="description"></div>\n  </div>\n  <div class="conditional-dropdown"></div>\n  <div class="color-picker-area negative">\n    <div class="theme-color-picker-box none-selected large">\n      <div class="text-color" style="border-top-color: ');
      
        __out.push(__sanitize(this.rule.neg_text_color));
      
        __out.push('"></div>\n      <div class="background-color" style="border-bottom-color: ');
      
        __out.push(__sanitize(this.rule.neg_bar_color));
      
        __out.push('"></div>\n    </div>\n  </div>\n  <div class="color-picker-area positive">\n    <div class="theme-color-picker-box none-selected large">\n      <div class="text-color" style="border-top-color: ');
      
        __out.push(__sanitize(this.rule.pos_text_color));
      
        __out.push('"></div>\n      <div class="background-color" style="border-bottom-color: ');
      
        __out.push(__sanitize(this.rule.pos_bar_color));
      
        __out.push('"></div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/description_hint"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="de-hint body">\n  <div class="de-hint name">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</div>\n  <div class="de-hint desc">');
      
        __out.push(__sanitize(this.description));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/drilldown_mapping"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="drilldown-mapping">\n  <div class="reorder-controls">\n    <div class="delete"></div>\n    <div class="description"></div>\n  </div>\n  <div class="pair-item column-name"></div>\n  <div class="pair-item filter-id"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/drilldowns_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="drilldown-dashboard"></div>\n<div class="drilldown-mapping-list"></div>\n<div class="button subtle add-drilldown-mapping">Add Mapping</div>\n<div class="link delete-rules">Delete Mapping</div>\n<div class="link back-to-rules">Back</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/function_hint"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var wrapWithSpacer;
      
        wrapWithSpacer = this.details.doc || this.details.example;
      
        __out.push('\n');
      
        if (wrapWithSpacer) {
          __out.push('\n  <div class="fn-hint body">\n');
        }
      
        __out.push('\n<div class="fn-hint name">');
      
        __out.push(__sanitize(this.functionName));
      
        __out.push('(<span class="fn-arguments">');
      
        __out.push(__sanitize(this.details.args));
      
        __out.push('</span>)</div>\n');
      
        if (this.details.doc) {
          __out.push('\n  <div class="fn-hint doc">');
          __out.push(__sanitize(this.details.doc));
          __out.push('</div>\n');
        }
      
        __out.push('\n');
      
        if (this.details.example) {
          __out.push('\n  <div class="fn-hint example"><span class="label">Example: </span>');
          __out.push(__sanitize(this.details.example));
          __out.push('</div>\n');
        }
      
        __out.push('\n');
      
        if (wrapWithSpacer) {
          __out.push('\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/item_list"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="search-area"><input type="text"></div>\n<div class="scroll-container"><div class="items"></div></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/item_list_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="item" item_id="');
      
        __out.push(__sanitize(this.id));
      
        __out.push('">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/schema_viewer/redesign_schema_viewer_result_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, result;
      
        if (this.firstViewBlock) {
          __out.push('\n  <div class ="result-block views ');
          if (this.isViewBlockOpen) {
            __out.push('open');
          }
          __out.push('" attr_id=');
          __out.push(__sanitize(this.type));
          __out.push('>\n    <div class=\'result-header views ');
          __out.push(__sanitize(this.type));
          __out.push(' ');
          if (this.numViewResults === 0) {
            __out.push(' empty ');
          }
          __out.push('\'> \n    ');
          __out.push(__sanitize(this.viewHeader));
          __out.push(' <span class="count">(');
          __out.push(__sanitize(this.numViewResults));
          __out.push(')</span></div>\n    <div class=\'result-body\'>\n');
        }
      
        __out.push('\n\n<div class="result-block ');
      
        __out.push(__sanitize(this.type));
      
        __out.push('  ');
      
        if (this.isOpen) {
          __out.push(' open ');
        }
      
        __out.push(' " attr_id="');
      
        __out.push(__sanitize(this.header));
      
        __out.push('">\n\n\n  ');
      
        if (this.results.isEmpty()) {
          __out.push('\n    <div class=\'result-header empty ');
          __out.push(__sanitize(this.type));
          __out.push(' \'>');
          __out.push(__sanitize(this.header));
          __out.push(' <span class="count">(0)</span></div>\n  ');
        } else {
          __out.push('\n    <div class=\'result-header ');
          __out.push(__sanitize(this.type));
          __out.push(' \'>');
          __out.push(__sanitize(this.header));
          __out.push('  <span class="count">(');
          __out.push(__sanitize(this.numResults));
          __out.push(')</span></div>\n  ');
        }
      
        __out.push('\n\n  <div class=\'result-body\'>\n    ');
      
        ref = this.results;
        for (i = 0, len = ref.length; i < len; i++) {
          result = ref[i];
          __out.push('\n      ');
          __out.push(result);
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n\n');
      
        if (this.lastViewBlock) {
          __out.push('\n    </div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/schema_viewer/schema_browser_columns"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var column, columnIndex, i, len, ref;
      
        ref = this.columns;
        for (columnIndex = i = 0, len = ref.length; i < len; columnIndex = ++i) {
          column = ref[columnIndex];
          __out.push('\n  <div class="cell');
          if (this.columnIndexesMatchingQuery.indexOf(columnIndex) > -1) {
            __out.push(' bold');
          }
          __out.push('">\n    <span class="sql-type" \n      data-sql-type="');
          __out.push(__sanitize(App.Database.sqlTypeToSimpleType(column.sql_type)));
          __out.push('">\n    </span>\n    <span ');
          if (this.clickableColumn) {
            __out.push(' class="cell-name ');
            __out.push(__sanitize(App.Database.sqlTypeToSimpleType(column.sql_type)));
            __out.push('" ');
          }
          __out.push(' >\n      ');
          __out.push(__sanitize(column.name));
          __out.push('\n    </span>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/schema_viewer/schema_browser_data_result_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, result;
      
        __out.push('<div class=\'result-block ');
      
        __out.push(__sanitize(this.className));
      
        if (this.isOpen) {
          __out.push(' open ');
        }
      
        __out.push('\'>\n');
      
        if (this.results.isEmpty()) {
          __out.push('\n  <div class=\'result-header empty ');
          __out.push(__sanitize(this.className));
          __out.push(' \'>');
          __out.push(__sanitize(this.headerName));
          __out.push(' <span class="count">(0)</span></div>\n');
        } else {
          __out.push('\n  <div class=\'result-header ');
          __out.push(__sanitize(this.className));
          __out.push('\'>');
          __out.push(__sanitize(this.headerName));
          __out.push('\n    ');
          if (this.className !== 'database') {
            __out.push('\n      <span class="count">(');
            __out.push(__sanitize(this.numResults));
            __out.push(')</span>\n    ');
          }
          __out.push('\n  </div>\n');
        }
      
        __out.push('\n  <div class=\'result-body ');
      
        __out.push(__sanitize(this.className));
      
        __out.push('\'>\n    ');
      
        ref = this.results;
        for (i = 0, len = ref.length; i < len; i++) {
          result = ref[i];
          __out.push('\n      ');
          __out.push(result);
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/schema_viewer/schema_viewer_sql_snippet"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="result snippet" snippet_id="');
      
        __out.push(__sanitize(this.id));
      
        __out.push('">\n  <div class="name');
      
        if (this.shouldBoldName) {
          __out.push(' bold');
        }
      
        __out.push('">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</div>\n  <div class="description"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/sql_viewer"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="error">\n  <div class="icon"></div><span class="label">Error</span>\n  <div class="message"></div>\n</div>\n\n<div class="sql"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/tab_drawer/tab"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="tab rotated ');
      
        __out.push(__sanitize(this.cssClass));
      
        __out.push('" tab-index="');
      
        __out.push(__sanitize(this.tabIndex));
      
        __out.push('"><div class="tab-label"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/editors/tab_drawer/tab_content"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'tab-content\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/free_input_setting"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, value;
      
        __out.push('<div class="free-input-values">\n  ');
      
        if (!_.isEmpty(this.dimensionValues)) {
          __out.push('\n    ');
          ref = this.dimensionValues;
          for (i = 0, len = ref.length; i < len; i++) {
            value = ref[i];
            __out.push('\n      <div class=\'free-input-value\' data-value="');
            __out.push(__sanitize(value));
            __out.push('">\n        ');
            __out.push(__sanitize(value));
            __out.push('\n        <span class="remove-icon"></span>\n      </div>\n    ');
          }
          __out.push('\n  ');
        } else {
          __out.push('\n    <div class="placeholder-text">Filter values will appear here</div>\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/free_input_setting_autocomplete"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="search-box">\n    <input class="search-input" type="text" name="dimension_value" placeholder="Enter filter value(s)"></input>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/geomap/geomap_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="legend"></div>\n<div class="geomap-tooltip"></div>\n<div class="map" id="');
      
        __out.push(__sanitize(this.elId));
      
        __out.push('"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/header_menu_sites/frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="header-menu header-menu-sites-frame">\n  <div class="bar-and-triangle">\n    <div class="bar"></div>\n    <div class="right-triangle"></div>\n  </div>\n  <div class="label current-site-name">');
      
        __out.push(__sanitize(this.currentSiteDisplayName));
      
        __out.push('</div>\n  <div class="menu">\n    <div class="container-for-height"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/header_menu_sites/site_selector_dropdown"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, site;
      
        __out.push('<div class="sites">\n  ');
      
        if (this.isSpacesEnabled) {
          __out.push('\n    ');
          ref = this.sites;
          for (i = 0, len = ref.length; i < len; i++) {
            site = ref[i];
            __out.push('\n      <a href="');
            __out.push(__sanitize(site.url));
            __out.push('" class="menu-item site ');
            if (site.is_current_site) {
              __out.push(__sanitize('current'));
            }
            __out.push('" data-host=\'');
            __out.push(__sanitize(site.host));
            __out.push('\'>');
            __out.push(__sanitize(site.display_name));
            __out.push('</a>\n    ');
          }
          __out.push('\n  ');
        }
      
        __out.push('\n</div>\n');
      
        if (this.isSpacesEnabled) {
          __out.push('\n  <div class="navigation">\n    <div class="menu-item account-settings">Account Settings</div>\n    ');
          if (this.isAdmin) {
            __out.push('<div class="menu-item create-site">Create a Space</div>');
          }
          __out.push('\n  </div>\n');
        } else {
          __out.push('\n  ');
          if (this.isAdmin) {
            __out.push('<div class="menu-item enable-site-family">Enable Spaces</div>');
          }
          __out.push('\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/header_menu_sql_views/new_sql_view_tooltip_table"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="sql-view-tooltip">\n    ');
      
        if (this.lastMaterializedAt != null) {
          __out.push('<tr><td class=\'bold\'>Last materialized</td><td>');
          __out.push(__sanitize(this.lastMaterializedAt));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    <tr><td class=\'bold\'>Status</td><td>');
      
        __out.push(__sanitize(this.state));
      
        __out.push('</td></tr>\n    ');
      
        if (this.lastRunAt != null) {
          __out.push('<tr><td class=\'bold\'>Last run</td><td>');
          __out.push(__sanitize(this.lastRunAt));
          if (this.errorCount > 0) {
            __out.push('<span class=\'fail\'>');
            __out.push(__sanitize("  (Failed " + this.errorCount + " times)"));
            __out.push('</span>');
          }
          __out.push('</td></tr>');
        }
      
        __out.push('\n    ');
      
        if (this.sqlModifiedAt != null) {
          __out.push('<tr><td class=\'bold\'>Last modified</td><td>');
          __out.push(__sanitize(this.sqlModifiedAt));
          __out.push('</td></tr>');
        }
      
        __out.push('\n    ');
      
        if (this.counts != null) {
          __out.push('<tr><td class=\'bold\'>Used by</td><td>');
          __out.push(__sanitize(this.counts));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    ');
      
        if (this.lastModifiedBy != null) {
          __out.push('<tr><td class=\'bold\'>Last modified by</td><td>');
          __out.push(__sanitize(this.lastModifiedBy));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    ');
      
        if (this.lastUploadedBy != null) {
          __out.push('<tr><td class=\'bold\'>Uploaded by</td><td>');
          __out.push(__sanitize(this.lastUploadedBy));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    ');
      
        if (this.ownedBy != null) {
          __out.push('<tr><td class=\'bold\'>Owned by</td><td>');
          __out.push(__sanitize(this.ownedBy));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/header_menu_sql_views/sql_view_schedulable_tooltip_table"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="sql-view-tooltip">\n    ');
      
        if (this.lastMaterializedAt != null) {
          __out.push('<tr><td class=\'bold\'>Last materialized</td><td>');
          __out.push(__sanitize(this.lastMaterializedAt));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    <tr><td class=\'bold\'>Status</td><td>');
      
        __out.push(__sanitize(this.state));
      
        __out.push('</td></tr>\n    <tr><td class=\'bold\'>Schedule</td><td>');
      
        __out.push(__sanitize(this.schedule));
      
        __out.push('</td></tr>\n    <tr><td class=\'bold\'>Last duration</td><td>');
      
        __out.push(__sanitize(this.duration));
      
        __out.push('</td></tr>\n    ');
      
        if (this.lastRunAt != null) {
          __out.push('<tr><td class=\'bold\'>Last run</td><td>');
          __out.push(__sanitize(this.lastRunAt));
          if (this.errorCount > 0) {
            __out.push('<span class=\'fail\'>');
            __out.push(__sanitize("  (Failed " + this.errorCount + " times)"));
            __out.push('</span>');
          }
          __out.push('</td></tr>');
        }
      
        __out.push('\n    <tr><td class=\'bold\'>Next run</td><td>');
      
        __out.push(__sanitize(this.nextRunAt));
      
        __out.push('</td></tr>\n    ');
      
        if (this.sqlModifiedAt != null) {
          __out.push('<tr><td class=\'bold\'>Last modified</td><td>');
          __out.push(__sanitize(this.sqlModifiedAt));
          __out.push('</td></tr>');
        }
      
        __out.push('\n    ');
      
        if (this.counts != null) {
          __out.push('<tr><td class=\'bold\'>Used by</td><td>');
          __out.push(__sanitize(this.counts));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    ');
      
        if (this.lastModifiedBy != null) {
          __out.push('<tr><td class=\'bold\'>Last modified by</td><td>');
          __out.push(__sanitize(this.lastModifiedBy));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n    ');
      
        if (this.ownedBy != null) {
          __out.push('<tr><td class=\'bold\'>Owned by</td><td>');
          __out.push(__sanitize(this.ownedBy));
          __out.push('</td></tr> ');
        }
      
        __out.push('\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/image_chart/image_chart"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<img></img>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/ninja_chart/legend_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="item');
      
        if (this.isHidden) {
          __out.push(' not-visible');
        }
      
        __out.push('" series_id="');
      
        __out.push(__sanitize(this.seriesId));
      
        __out.push('">\n  <div class="label">\n    <div class="color" style="background-color:');
      
        __out.push(__sanitize(this.color));
      
        __out.push(';border-color:');
      
        __out.push(__sanitize(this.color));
      
        __out.push('"></div>\n    ');
      
        __out.push(__sanitize(this.label));
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/ninja_chart/ninja_chart"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="legend"></div>\n<div class="chart" id="');
      
        __out.push(__sanitize(this.chartId));
      
        __out.push('" style="height:');
      
        __out.push(__sanitize(this.height));
      
        __out.push('px;"></div>\n<div class="debug"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/onboarding/onboarding_wizard"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="onboarding-sidebar"></div>\n<div class="onboarding-main-column"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/radio_button"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="icon"></div>\n<div class="label ');
      
        __out.push(__sanitize(this.labelClass));
      
        __out.push('">');
      
        __out.push(__sanitize(this.label));
      
        __out.push(' <span class="default">(DEFAULT)</span></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/annotations/form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var group, i, len, ref;
      
        __out.push('<div class="annotations-tooltip">\n  <div class="label">Note for ');
      
        __out.push(__sanitize(this.x));
      
        __out.push('</div>\n  <input class="redesign-input note-description" placeholder="Chart Note"></input>\n  <div class="options open">\n  <div class="label">Add to Group</div>\n  <div class="select-wrapper">\n    <select class="add-group" data-placeholder="Select Group">\n        ');
      
        ref = this.options;
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          __out.push('\n            <option value="');
          __out.push(__sanitize(group.serverValue));
          __out.push('">');
          __out.push(__sanitize("" + group.name));
          __out.push('</option>\n        ');
        }
      
        __out.push('\n    </select>\n  </div>\n    <input class="redesign-input new-group" placeholder="Note Group Name"></input>\n  </div>\n</div>\n<div class="button-row"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/annotations/list"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var annotation, i, len, ref;
      
        __out.push('<div class="annotations-tooltip">\n  <div class="annotations">\n    ');
      
        ref = this.annotations;
        for (i = 0, len = ref.length; i < len; i++) {
          annotation = ref[i];
          __out.push('\n      <div class="annotation" annotation-id="');
          __out.push(__sanitize(annotation.id));
          __out.push('">\n      ');
          if (App.User.CurrentUserCanEdit()) {
            __out.push('\n        <div class="delete-x"></div>\n      ');
          }
          __out.push('\n        <span class="annotation-description">');
          __out.push(__sanitize(annotation.x_value));
          __out.push('</span>\n        -\n        <span class="annotation-description">');
          __out.push(__sanitize(annotation.description));
          __out.push('</span>\n        <span class="group">(');
          __out.push(__sanitize(annotation.group_name));
          __out.push(')</span>\n      </div>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/billing_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="onboarding-sidebar"></div>\n<div class="onboarding-main-column">\n  <div class="onboarding-pane billing">\n    <div class="onboarding-body">\n      <div class="onboarding-body-content no-overflow light-theme" style="padding-top:20px;padding-left:0px;padding-right:0px;">\n      </div>\n    </div> \n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/contact_us_modal"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'contact-us-modal modal\'>\n  <section class="modal-content">\n    <div class="body">\n      <div class="icon-lock"></div>\n      <div class="text-trial-expired">Thank you for trialing Sisense for Cloud Data Teams.</div>\n      <div class="text-salesperson-will-contact">\n        Please contact your sales rep or email <a href="mailto:sales-cdt@sisense.com">sales-cdt@sisense.com</a> to discuss a subscription agreement.\n      </div>\n    </div>\n  </section>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/overage_upgrade_modal"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'overage-upgrade-modal-content\'>\n  <span class="overage-upgrade-modal-bold">\n    ');
      
        __out.push(__sanitize(this.customerName));
      
        __out.push(' authorizes Sisense for Cloud Data Teams to invoice\n    ');
      
        __out.push(__sanitize(this.customerName));
      
        __out.push(' $');
      
        __out.push(__sanitize(this.newPlanPrice));
      
        __out.push(' per month, starting on\n    ');
      
        __out.push(__sanitize(this.currentDay));
      
        __out.push('. This invoice will be co-terminus and pro-rated to\n    ');
      
        __out.push(__sanitize(this.customerName));
      
        __out.push('\'s current fee schedule. Contact your Customer\n    Success Manager to upgrade for alternative agreements.\n  </span>\n  <div class="overage-upgrade-modal-text">\n    By clicking "I accept" below, ');
      
        __out.push(__sanitize(this.customerName));
      
        __out.push(' herby agrees to\n    Sisense for Cloud Data Teams\'\n      <a target="_blank" style="color: #363649;" href="https://s3.amazonaws.com/periscope-eula/periscope_terms_and_conditions.pdf" rel="nofollow noopener noreferrer">\n        Terms & Conditions\n      </a>\n    and shall supersede any other agreement in effect. Furthermore, you agree\n    that you represent and warrant that you are duly authorized to bind\n    ');
      
        __out.push(__sanitize(this.customerName));
      
        __out.push(' to fees set forth and the terms and conditions as noted\n    above.\n  </div>\n\n  <table class="eula-grid">\n    <tr>\n      <td>\n        <div class="eula checkbox">\n          <div class="icon"></div>\n        </div>\n      </td>\n      <td>\n        <div class="statement-text">\n          I accept the <a target="_blank" style="color: #363649;" href="https://s3.amazonaws.com/periscope-eula/periscope_terms_and_conditions.pdf" rel="nofollow noopener noreferrer">\n          Terms & Conditions.</a>\n        </div>\n      </td>\n    </tr>\n  </table>\n</div>\n\n<div class="actions">\n  <div class="button-row">\n    <div class="overage-upgrade-modal-buttons">\n      <div class="cancel-button button inert-medium">\n        <span>CANCEL</span>\n      </div>\n      <div class="submit-button button action-medium modal-upgrade-button">\n        <span>UPGRADE</span>\n      </div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/trial_extension"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="trial-extension-link normal-13-mirage-font">Need more time?</div>\n\n<div class="trial-extension-body">\n    <div class="normal-13-mirage-font">We will be happy to extend your trial by\n        ');
      
        __out.push(__sanitize(this.days));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.days > 1 ? 'days' : 'day'));
      
        __out.push(',\n        if you tell us what you still need to evaluate.</div>\n    <input class="reason-field redesign-input" type="text" placeholder="Reason">\n    <div class="undo-extension-link normal-13-mirage-font">Changed your mind?</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/upgrade_billing_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j, k, len, len1, overage, ref, ref1;
      
        __out.push('<div>\n  <span class=\'upgrade-message\'>\n    Upgrade your plan to get more capacity and continue using Sisense.\n  </span>\n  <table class=\'upgrade-table\'>\n    ');
      
        ref = this.overages;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          overage = ref[i];
          __out.push('\n    <tr class=\'current\'>\n      <td>');
          if (i === 0) {
            __out.push(__sanitize('Current Plan'));
          }
          __out.push('</td>\n      <td>\n        ');
          __out.push(__sanitize(overage.planMax()));
          __out.push(' ');
          __out.push(__sanitize(overage.noun()));
          __out.push('\n        <span class=\'errors warning-icon\'>\n                ');
          __out.push(__sanitize(overage.currentCount()));
          __out.push(' ');
          __out.push(__sanitize(overage.noun()));
          __out.push('\n            </span>\n      </td>\n      <td>');
          if (i === 0) {
            __out.push(__sanitize("$" + this.currentPlanPrice + "/mo"));
          }
          __out.push('</td>\n    </tr>\n    ');
        }
      
        __out.push('\n    ');
      
        ref1 = this.overages;
        for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
          overage = ref1[i];
          __out.push('\n    <tr class=\'additionals\'>\n      <td>Additional ');
          __out.push(__sanitize(overage.noun()));
          __out.push('</td>\n      <td>');
          __out.push(__sanitize(overage.additionalCount()));
          __out.push(' ');
          __out.push(__sanitize(overage.noun()));
          __out.push('</td>\n      <td>$');
          __out.push(__sanitize(overage.additionalCost()));
          __out.push('/mo</td>\n    </tr>\n    ');
        }
      
        __out.push('\n    <tr class=\'totals\'>\n      <td><span class=\'bold\'>New Monthly Plan</span></td>\n      <td>');
      
        __out.push(__sanitize(this.totals));
      
        __out.push('</td>\n      <td><span class=\'bold\'>$');
      
        __out.push(__sanitize(this.newPlanPrice));
      
        __out.push('/mo</span></td>\n    </tr>\n  </table>\n  <div class="button action-medium upgrade-button">\n    <div class="label">Upgrade</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/zuora_billing_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="onboarding-billing billing form no-label-fade">\n    <div class="billing-react-div"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/zuora_billing_not_enabled"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.salesOwnerEmail) {
          __out.push('\n    <p>Contact your sales rep, ');
          __out.push(__sanitize(this.salesOwnerName));
          __out.push(' (<a href="mailto:');
          __out.push(__sanitize(this.salesOwnerEmail));
          __out.push('">');
          __out.push(__sanitize(this.salesOwnerEmail));
          __out.push('</a>), to set up your account.</p>\n');
        } else {
          __out.push('\n    <p>For assistance with the configuration of these settings, please contact <a href="mailto:');
          __out.push(__sanitize(this.supportEmail));
          __out.push('">');
          __out.push(__sanitize(this.supportEmail));
          __out.push('</a></p>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/billing/zuora_plan_name"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="plan heavy-13-skyblue-font">Pricing Plan: <span class="base">$');
      
        __out.push(__sanitize(this.base));
      
        __out.push('</span><span class="discount"> $');
      
        if (this.discount != null) {
          __out.push(__sanitize(this.discount));
        }
      
        __out.push('</span>/mo</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/cancel_save"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (!this.hideCancel) {
          __out.push('\n  <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n');
        }
      
        __out.push('\n<div class="button ');
      
        __out.push(__sanitize(this.saveButtonClass));
      
        __out.push('-medium save"><div class="label">');
      
        __out.push(__sanitize(this.saveText));
      
        __out.push('</div></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/add_site"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="add-site-dialog">\n  <div class="content">\n    <div class="content-text">Spaces let you control access to your data. Databases and dashboards in a space are only\n    accessible to users who have been granted access.</div>\n\n    <form>\n      <label>Name the New Space</label>\n      <input class="redesign-input new-site-name" autofocus></input>\n    </form>\n    <div class="errors warning-icon"><div class="error"></div></div>\n  </div>\n\n  <div class="button-row">\n    <div class="right-aligned-buttons"></div>\n  </div>\n\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/all_spaces_warning"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n  <div class="cancel-icon"></div>\n  <span>Revoke Workbooks Access</span>\n</header>\n<section class="modal-content">\n  <div class="body">\n    <div class="message normal-13-storm-gray-font">\n      Workbooks access for this user will be revoked across\n      ALL spaces. Are you sure you want to do this?\n    </div>\n  </div>\n  <div class="button-row">\n    <div class="right-aligned-buttons buttons flex-fill-row">\n      <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n      <div class="button action-medium proceed"><div class="label">Proceed</div></div>\n    </div>\n  </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/button_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="delete-confirm-msg">Are you sure you want to <span>');
      
        __out.push(__sanitize(this.deleteLabel));
      
        __out.push('</span> this ');
      
        __out.push(__sanitize(this.itemName));
      
        __out.push('?</div>\n<div class="cancel-confirm-msg">Do you want to <span>discard</span> your changes?</div>\n');
      
        if (!this.delete_disabled) {
          __out.push(' <div class="show-delete button destructive-link ');
          __out.push(__sanitize(this.buttonSize));
          __out.push('">\n<div class="label">');
          __out.push(__sanitize(this.deleteLabel));
          __out.push('</div></div> ');
        }
      
        __out.push('\n<div class="cancel button inert-');
      
        __out.push(__sanitize(this.buttonSize));
      
        __out.push('"><div class="label">Cancel</div></div>\n<div class="delete button destructive-');
      
        __out.push(__sanitize(this.buttonSize));
      
        __out.push('">\n<div class="label">');
      
        __out.push(__sanitize(this.deleteLabel));
      
        __out.push('</div></div>\n');
      
        if (this.action != null) {
          __out.push('<div class="action button action-');
          __out.push(__sanitize(this.buttonSize));
          __out.push('"><div class="label">');
          __out.push(__sanitize(this.action));
          __out.push('</div></div>');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/checkbox_list"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var checkbox, i, index, len, ref;
      
        ref = this.config;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          checkbox = ref[index];
          __out.push('\n  <div class="checkbox ');
          __out.push(__sanitize(this.iconClass));
          __out.push(' ');
          if (checkbox.checked) {
            __out.push(__sanitize('selected'));
          }
          __out.push('" data-checkbox-index="');
          __out.push(__sanitize(index));
          __out.push('">\n    <div class="icon"></div>\n    <div class="label">');
          __out.push(__sanitize(checkbox.label));
          __out.push('</div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/copy_to_button_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<!--Initial state-->\n');
      
        if (this.item.exists()) {
          __out.push(' <div class="show-delete button destructive-link">Delete</div> ');
        }
      
        __out.push('\n<div class="cancel-edit button inert-large"><div class="label">Cancel</div></div>\n');
      
        if (this.canOnlyEditChartAsCopy) {
          __out.push('\n<div class="save-as-copy button action-large"><div class="label">Save as Copy</div></div>\n');
        } else {
          __out.push('\n<div class="expandable">\n    <div class="button action-large action fixed-width">\n        ');
          __out.push('\n        <div class="label">save</div><div class="expand"><div class="icon expando"></div></div>\n    </div>\n    <div class="options">\n        ');
          if (this.item.exists()) {
            __out.push('\n        <div class="option copy-to dinpro-medium-mirage hover-eastern-blue">\n            COPY TO...\n        </div>\n        ');
          }
          __out.push('\n        <div class="option move-to dinpro-medium-mirage hover-eastern-blue">\n            ');
          if (this.item.is_exploration) {
            __out.push('\n                SAVE TO...\n            ');
          } else {
            __out.push('\n                MOVE TO...\n            ');
          }
          __out.push('\n        </div>\n    </div>\n</div>\n');
        }
      
        __out.push('\n\n<!--Confirming cancel-->\n<div class="cancel-confirm-msg">Do you want to <span>discard</span> your changes?</div>\n<div class="cancel-discard-changes button inert-large"><div class="label">Cancel</div></div>\n<div class="discard-changes button destructive-large"><div class="label">Discard</div></div>\n\n<!--Confirming delete-->\n<div class="delete-confirm-msg">Are you sure you want to <span>delete</span> this ');
      
        __out.push(__sanitize(this.item.constructor.SIMPLE_CLASS_NAME));
      
        __out.push('?</div>\n<div class="cancel-delete button inert-large"><div class="label">Cancel</div></div>\n<div class="delete button destructive-large"><div class="label">Delete</div></div>\n\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/default_dialog"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="main-text">');
      
        __out.push(__sanitize(this.mainText));
      
        __out.push('</div>\n<div class="button-row">\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="flex-filler"></div>\n<div class="dialog modal">\n  <header>\n      <div class="cancel-icon"></div>\n      <span class="title bold">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</span>\n      ');
      
        if (this.helpIcon) {
          __out.push('\n        <div class="icon info-question-mark"></div>\n      ');
        }
      
        __out.push('\n  </header>\n  <div class="dialog-content"></div>\n</div>\n<div class="flex-filler long"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_menu_contents"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, item, len, ref;
      
        ref = this.items;
        for (i = 0, len = ref.length; i < len; i++) {
          item = ref[i];
          __out.push('\n  <li class="item status-');
          __out.push(__sanitize(item.status));
          __out.push('\n  ');
          if (item["class"] === 'Site' && item.cid === App.Site.first().host) {
            __out.push(__sanitize('bold current'));
          }
          __out.push('"\n  data-item-class="');
          __out.push(__sanitize(item["class"]));
          __out.push('"\n  data-item-cid="');
          __out.push(__sanitize(item.cid));
          __out.push('"\n  ');
          if (item.guid != null) {
            __out.push(' data-item-guid="');
            __out.push(__sanitize(item.guid));
            __out.push('" ');
          }
          __out.push('\n  ');
          if (item.widgetId != null) {
            __out.push(' data-item-widgetId="');
            __out.push(__sanitize(item.widgetId));
            __out.push('" ');
          }
          __out.push('>\n   \n    ');
          if (item.hasDataset) {
            __out.push('\n      <div class=\'itemName\'>');
            __out.push(__sanitize(item.name));
            __out.push('</div>\n      <div class=\'datasetLabel\'>Dataset</div>\n    ');
          } else {
            __out.push('\n      ');
            __out.push(__sanitize(item.name));
            __out.push('\n    ');
          }
          __out.push('\n\n  </li>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_menu_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="title">\n  <span class="din20">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</span>\n  ');
      
        if (this.showAddNewButton) {
          __out.push('\n    <div class="button add-new fixed-width"></div>\n  ');
        }
      
        __out.push('\n</div>\n<input class="search redesign-input dinpro13" placeholder="Search"></input>\n<div class="loading message">\n  <div class="spinner-and-text-holder">\n    <div class="spinner-gif"></div>\n    <div class="text-below-spinner">Loading</div>\n  </div>\n</div>\n');
      
        if (this.infoText != null) {
          __out.push('\n    <div class="info message">\n        <div class="info">');
          __out.push(__sanitize(this.infoText.text));
          __out.push('</div>\n        <div class="action">Click<div class="tiny-button action-small"></div>to ');
          __out.push(__sanitize(this.infoText.action));
          __out.push(' a ');
          __out.push(__sanitize(this.infoClass));
          __out.push('</div>\n    </div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.shouldAddDatasetToggler) {
          __out.push('\n  <div class="toggle-container">\n    <div class="toggle-title">Matching</div>\n    <div class="toggle-area"></div>\n  </div>\n');
        }
      
        __out.push('\n<div class="section-list"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_menu_results"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, index, isOpen, len, ref, section;
      
        ref = this.sections;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          section = ref[index];
          __out.push('\n  ');
          isOpen = index === 0 || this.isSearching || this.openSectionNames.includes(section.name);
          __out.push('\n<div class="menu-section ');
          if (isOpen) {
            __out.push(__sanitize('open'));
          }
          __out.push(' ');
          if (section.displayClass) {
            __out.push(__sanitize(section.displayClass));
          }
          __out.push('" name="');
          __out.push(__sanitize(section.name));
          __out.push('">\n  <div class="section-header">\n    <span class="section-name">');
          __out.push(__sanitize(section.name));
          __out.push('</span><span class="count bold">(');
          __out.push(__sanitize(section.items.length));
          __out.push(')</span>\n  </div>\n  <ol class="section-contents" data-section-id="');
          __out.push(__sanitize(index));
          __out.push('">\n  ');
          if (isOpen) {
            __out.push('\n    ');
            __out.push(this.contentsView({
              items: App.LeftMenuHelper.transformSectionRecordsToDisplayData(section).items
            }));
            __out.push('\n  ');
          }
          __out.push('\n  </ol>\n</div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_menu_settings_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var controller, controllerName, i, item, j, k, len, len1, len2, ref, ref1, ref2;
      
        __out.push('<div class="title">\n  <span class="din20">Settings</span>\n</div>\n\n<div class="section-list settings">\n  <div class="section-contents">\n    ');
      
        if (this.settings.spaces != null) {
          __out.push('\n        ');
          ref = this.settings.items;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            __out.push('\n        <section class="group">\n          <header class="heavy-14-eastern-blue-font">');
            __out.push(__sanitize(item.heading));
            __out.push('</header>\n          <section class="items">\n            ');
            ref1 = item.menu;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              controllerName = ref1[j];
              __out.push('\n              ');
              controller = App[controllerName];
              __out.push('\n              <div class="item settings-item normal-13-black-font ');
              __out.push(__sanitize(controllerName));
              __out.push('" data-item-class="');
              __out.push(__sanitize(controllerName));
              __out.push('">\n                <div class="settings-item-title ');
              __out.push(__sanitize(controllerName));
              __out.push('">');
              __out.push(__sanitize(controller.TITLE));
              __out.push('</div>\n                <div class="new-feature-icon ');
              __out.push(__sanitize(controllerName));
              __out.push(' spaces" ></div>\n                <div class="upgrade-icon ');
              __out.push(__sanitize(controllerName));
              __out.push('">UPGRADE</div>\n              </div>\n            ');
            }
            __out.push('\n          </section>\n        </section>\n        ');
          }
          __out.push('\n    ');
        } else {
          __out.push('\n        ');
          ref2 = this.settings;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            controllerName = ref2[k];
            __out.push('\n          ');
            controller = App[controllerName];
            __out.push('\n          <div class="item settings-item normal-13-black-font ');
            __out.push(__sanitize(controllerName));
            __out.push('" data-item-class="');
            __out.push(__sanitize(controllerName));
            __out.push('">\n            <div class="settings-item-title ');
            __out.push(__sanitize(controllerName));
            __out.push('">');
            __out.push(__sanitize(controller.TITLE));
            __out.push('</div>\n            <div class="new-feature-icon ');
            __out.push(__sanitize(controllerName));
            __out.push('" ></div>\n            <div class="upgrade-icon ');
            __out.push(__sanitize(controllerName));
            __out.push('">UPGRADE</div>\n          </div>\n        ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n  <div class="upsell-promo-react-container">\n  </div>\n  <div class="privacy-policy">\n    <a class="privacy-policy-link" href="https://www.sisense.com/legal/products-and-services/" target="_blank">\n      <span class="heavy-16-black-font privacy-policy-link-text">Privacy Policy</span>\n    </a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_menu_settings_frame_dec"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var controller, controllerName, i, len, ref;
      
        __out.push('<div class="title">\n  <span class="din20">Settings</span>\n</div>\n\n<div class="section-list settings">\n  <div class="section-contents">\n    ');
      
        ref = this.settings;
        for (i = 0, len = ref.length; i < len; i++) {
          controllerName = ref[i];
          __out.push('\n      ');
          controller = App[controllerName];
          __out.push('\n      ');
          if (controllerName.includes('Permissions') || controllerName.includes('SettingsAccount')) {
            __out.push('\n        <div class="item settings-item normal-13-black-font ');
            __out.push(__sanitize(controllerName));
            __out.push('" data-item-class="');
            __out.push(__sanitize(controllerName));
            __out.push('">\n          <div class="settings-item-title ');
            __out.push(__sanitize(controllerName));
            __out.push('">');
            __out.push(__sanitize(controller.TITLE));
            __out.push('</div>\n          <div class="new-feature-icon ');
            __out.push(__sanitize(controllerName));
            __out.push('" ></div>\n          <div class="upgrade-icon ');
            __out.push(__sanitize(controllerName));
            __out.push('">UPGRADE</div>\n        </div>\n      ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n  <div class="upsell-promo-react-container">\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_navigation"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.spaceEnabled) {
          __out.push('\n  ');
          if (this.customerUnificationEnabled) {
            __out.push('\n    <div class=\'space-area customer-unification\'>\n      <div class="bar-and-triangle">\n        <div class="bar"></div>\n        <div class="down-triangle"></div>\n      </div>\n      <div class="control space-icon customer-unification" data-menu=\'Site\' data-tooltip=\'Spaces\'\n      data-title=\'Spaces\'></div>\n    </div>\n  ');
          } else {
            __out.push('\n    <div class=\'space-area\'>\n      <div class="bar-and-triangle">\n        <div class="bar"></div>\n        <div class="down-triangle"></div>\n      </div>\n      <div class="periscope-logo"></div>\n      <div class="control space-icon" data-menu=\'Site\' data-tooltip=\'Spaces\'\n      data-title=\'Spaces\'></div>\n    </div>\n  ');
          }
          __out.push('\n');
        } else if (!this.customerUnificationEnabled) {
          __out.push('\n  <div class="periscope-logo"></div>\n');
        } else {
          __out.push('\n  <div class="left-nav-spacer"></div>\n');
        }
      
        __out.push('\n\n');
      
        if (!this.noDbMode) {
          __out.push('\n<div class="top-controls">\n  ');
          if (this.topicEnabled) {
            __out.push('\n    <div class="icon-container">\n      <div class="control search search-icon" data-menu=\'Search\' data-tooltip=\'Search\' ></div>\n    </div>\n    <div class="icon-container">\n      <div class="control topic topic-icon shorter" data-menu=\'Topic\' data-tooltip=\'Topics\' ></div>\n    </div>\n    <div class=\'separator\' ></div>\n    <div class="icon-container">\n      <div class="control dashboard dashboard-icon ');
            if (this.topicEnabled) {
              __out.push('shorter');
            }
            __out.push('" data-menu=\'Dashboard\' data-tooltip=\'Dashboards\' ></div>\n    </div>\n  ');
          } else if (this.displayDashboards) {
            __out.push('\n    <div class="control dashboard dashboard-icon" data-menu=\'Dashboard\' data-tooltip=\'Dashboards\' ></div>\n  ');
          }
          __out.push('\n  ');
          if (this.canCreateSql) {
            __out.push('\n    ');
            if (this.topicEnabled) {
              __out.push('\n      <div class="icon-container">\n        <div class="control sql-view sql-icon shorter" data-menu=\'View\' data-tooltip=\'Views\'>\n        </div>\n      </div>\n      <div class="icon-container">\n        <div class="control sql-snippet snippet-icon" data-menu=\'SqlSnippet\' data-tooltip=\'SQL Snippets\' >\n        </div>\n      </div>\n      <div class="icon-container">\n        <div class="control sql-alert sql-alert-icon" data-menu=\'SqlAlert\' data-tooltip=\'SQL Alerts\' ></div>\n      </div>\n    ');
            } else {
              __out.push('\n      <div class="control sql-view sql-icon" data-menu=\'SqlView\' data-tooltip=\'Views\'></div>\n      ');
              if (App.Site.first().cached_site) {
                __out.push('\n        <div class="control csv-view csv-icon" data-menu=\'CsvView\' data-tooltip=\'CSVs\'></div>\n      ');
              }
              __out.push('\n      <div class="control sql-snippet snippet-icon" data-menu=\'SqlSnippet\' data-tooltip=\'SQL Snippets\' ></div>\n      <div class="control sql-alert sql-alert-icon" data-menu=\'SqlAlert\' data-tooltip=\'SQL Alerts\' ></div>\n    ');
            }
            __out.push('\n  ');
          }
          __out.push('\n  ');
          if (this.canCreateSql || this.userCanExplore) {
            __out.push('\n    ');
            if (this.topicEnabled) {
              __out.push('\n      <div class=\'separator\' ></div>\n      <div class="icon-container">\n        <div class="control explore explore-icon" data-menu=\'Explore\' data-tooltip=\'New Exploration\' ></div>\n      </div>\n    ');
            } else {
              __out.push('\n      <div class="control explore explore-icon" data-menu=\'Explore\' data-tooltip=\'New Exploration\' ></div>\n    ');
            }
            __out.push('\n  ');
          }
          __out.push('\n</div>\n');
        }
      
        __out.push('\n<div class="bottom-controls');
      
        if (this.tutorialMolePresent) {
          __out.push(__sanitize(' tutorial-mole-present'));
        }
      
        __out.push('">\n  <div class="upsell-indicator" ></div>\n  <div class="control settings settings-wheel ');
      
        if (this.topicEnabled) {
          __out.push('shorter');
        }
      
        __out.push('" data-menu=\'Settings\' data-tooltip=\'Settings\'>\n    <div class="tooltip-panel upsell-tooltip">\n      <div class="panel showing">\n        <div class="panel-content">\n          <span class="close"></span>\n          <div class=\'text\'>');
      
        __out.push(this.upsellTooltipMessage);
      
        __out.push('<br/>');
      
        __out.push(this.upsellTooltipMessage2);
      
        __out.push('</div>\n        </div>\n        <div class="left pointer"></div>\n        <div class="right pointer"></div>\n        <div class="top pointer"></div>\n        <div class="bottom pointer"></div>\n        <div class="left pointer-border"></div>\n        <div class="right pointer-border"></div>\n        <div class="top pointer-border"></div>\n        <div class="bottom pointer-border"></div>\n      </div>\n    </div>\n  </div>\n  <div class="control help-icon" data-tooltip=\'Help\' ></div\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/left_navigation_dec"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="left-nav-spacer"></div>\n\n<div class="bottom-controls">\n  <div class="upsell-indicator" ></div>\n  <div class="control settings settings-wheel" data-menu=\'Settings\' data-tooltip=\'Settings\'>\n    <div class="tooltip-panel upsell-tooltip">\n      <div class="panel showing">\n        <div class="panel-content">\n          <span class="close"></span>\n          <div class=\'text\'></div>\n        </div>\n        <div class="left pointer"></div>\n        <div class="right pointer"></div>\n        <div class="top pointer"></div>\n        <div class="bottom pointer"></div>\n        <div class="left pointer-border"></div>\n        <div class="right pointer-border"></div>\n        <div class="top pointer-border"></div>\n        <div class="bottom pointer-border"></div>\n      </div>\n    </div>\n  </div>\n  <div class="control help-icon" data-tooltip=\'Help\' ></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/permission_denied"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n  <span>Permission Denied</span>\n</header>\n<section class="modal-content">\n  <div class="body">\n    <div class="message normal-13-storm-gray-font">\n      <p>\n        Sorry, your access to Cloud Data Teams has been interrupted. This could be due to a session timeout or a change in access control.\n      </p>\n\n      For updated access, please click Continue.\n    </div>\n  </div>\n  <div class="button-row">\n    <div class="right-aligned-buttons buttons flex-fill-row">\n      <div class="button inert-medium refresh"><div class="label">Continue</div></div>\n    </div>\n  </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/site_ready"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'site-ready\'>\n  <div class="ready-message">');
      
        __out.push(__sanitize(this.display_name));
      
        __out.push(' is ready!</div>\n  <div class="button action-medium go-to-new-site">GO</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/controls/unarchive_button_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="delete-confirm-msg">\n    Are you sure you want to <span>delete</span> this ');
      
        __out.push(__sanitize(this.itemName));
      
        __out.push('?\n</div>\n');
      
        if (!this.delete_disabled) {
          __out.push('\n    <div class="show-delete button destructive-link large">\n        <div class="label">delete</div>\n    </div>\n');
        }
      
        __out.push('\n<div class="cancel button inert-large">\n    <div class="label">Cancel</div>\n</div>\n<div class="delete button destructive-large">\n    <div class="label">delete</div>\n</div>\n<div class="action button action-large" style=\'width:99px;\'>\n    <div class="label">UNARCHIVE</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_email_reports/dashboard_email_recipient"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div>\n  <div class="recipient-email"></div>\n  <div class="remove-icon"></div>\n  <div class="send-test">Send Test</div>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_email_reports/dashboard_email_reports"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var d, h, i, j, len, len1, ref, ref1;
      
        if (this.showFilters) {
          __out.push('\n  <div class="default-filters-title">Default Filters</div>\n  <div class="default-filters"></div>\n');
        }
      
        __out.push('\n<div class="schedule">Schedule</div>\n<select class="day-schedule">\n');
      
        ref = this.days;
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          __out.push('\n  <option value=');
          __out.push(__sanitize(d.value));
          __out.push('>');
          __out.push(__sanitize(d.name));
          __out.push('</option>\n');
        }
      
        __out.push('\n</select>\n<select class="hour-schedule">\n');
      
        ref1 = this.hours;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          h = ref1[j];
          __out.push('\n  <option value=');
          __out.push(__sanitize(h.value));
          __out.push('>');
          __out.push(__sanitize(h.name));
          __out.push('</option>\n');
        }
      
        __out.push('\n</select>\n');
      
        if (this.showSlack) {
          __out.push('\n  <div class="recipients slack-header">Slack</div>\n  <div class="slack-container"></div>\n');
        }
      
        __out.push('\n');
      
        if (this.showEmail) {
          __out.push('\n  <div class="add-remove-list email-container">\n    <div class="recipients">Email</div>\n    <div class="input-container">\n      <input class="to new-item-input redesign-input" type="text" placeholder="Enter an email address" ></input>\n      <div class="icon add-icon"></div>\n    </div>\n    <div class="add-error"></div>\n    <div class="list daily-recipients"></div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_menu/dashboard_more_menu_rbac_disabled"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="light top pointer-border"></div>\n<div class="light top pointer"></div>\n<div class="modal-content normal-13-mirage-font">\n    ');
      
        if (this.user_can_edit && this.dashboard_editable) {
          __out.push('\n        <div class="top-section">\n          <div class="member preferences"><div class="menu-label">Dashboard Preferences...</div></div>\n        </div>\n    ');
        }
      
        __out.push('\n<div class="bottom-section">\n    ');
      
        if (this.user_can_edit) {
          __out.push('\n      <div class="member rearrange-charts"><div class="menu-label">Rearrange Charts...</div></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (!((ref = App.Site.first()) != null ? ref.sso_enabled : void 0)) {
          __out.push('\n        <div class="member enable-tv-mode"><div class="menu-label">Full Screen</div></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.user_can_edit) {
          __out.push('\n      ');
          if (this.dashboard_editable) {
            __out.push('\n        <div class="member disable-filters ');
            if (this.filters_enabled && this.shared_dashboards_exist) {
              __out.push(__sanitize('disabled'));
            }
            __out.push('">\n          <div class="menu-label">\n              ');
            if (this.filters_enabled) {
              __out.push('Disable');
            } else {
              __out.push('Enable');
            }
            __out.push(' Filters\n          </div>\n          <div class="confirm-dialog">\n              <div class="confirm-message">Filters will be removed and users will lose their filter settings.</div>\n              <div class="button cancel inert-small"><div class="label">Cancel</div></div>\n              <div class="button disable destructive-small"><div class="label">Disable</div>\n          </div></div>\n        </div>\n        <div class="member clone"><div class="menu-label">Clone Dashboard</div></div>\n      ');
          } else {
            __out.push('\n        <div class="member clone"><div class="menu-label">Clone Dashboard</div></div>\n      ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.pdf_download_enabled) {
          __out.push('\n      <div class="member download-pdf"><div class="menu-label">Download PDF</div></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.user_can_edit && this.dashboard_editable) {
          __out.push('\n      <div class="member delete ');
          if (!this.delete_enabled) {
            __out.push(__sanitize('disabled'));
          }
          __out.push('">\n        <div class="menu-label capitalize">');
          __out.push(__sanitize(this.deleteLabel));
          __out.push('</div>\n        <div class="confirm-message">Are you sure you want to ');
          __out.push(__sanitize(this.deleteLabel));
          __out.push(' this dashboard?</div>\n        <div class="button cancel inert-small"><div class="label">Cancel</div></div>\n        <div class="button delete destructive-small"><div class="label">');
          __out.push(__sanitize(this.deleteLabel));
          __out.push('</div></div>\n      </div>\n    ');
        }
      
        __out.push('\n\n</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_menu/dashboard_more_menu_rbac_enabled"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="light top pointer-border"></div>\n<div class="light top pointer"></div>\n<div class="modal-content normal-13-mirage-font">\n    ');
      
        if (this.showDashboardPreferencesButton) {
          __out.push('\n        <div class="top-section">\n            <div class="member preferences"><div class="menu-label">Dashboard Preferences...</div></div>\n        </div>\n    ');
        }
      
        __out.push('\n    <div class="bottom-section">\n        ');
      
        if (this.showRearrangeChartsButton) {
          __out.push('\n          <div class="member rearrange-charts"><div class="menu-label">Rearrange Charts...</div></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.showFullScreenButton) {
          __out.push('\n            <div class="member enable-tv-mode"><div class="menu-label">Full Screen</div></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.showFiltersButton) {
          __out.push('\n            <div class="member disable-filters ');
          if (this.grayOutFiltersButton) {
            __out.push(__sanitize('disabled'));
          }
          __out.push('">\n                <div class="menu-label">');
          __out.push(__sanitize(this.filtersButtonText));
          __out.push('</div>\n                <div class="confirm-dialog">\n                    <div class="confirm-message">Filters will be removed and users will lose their filter settings.</div>\n                    <div class="button cancel inert-small"><div class="label">Cancel</div></div>\n                    <div class="button disable destructive-small"><div class="label">Disable</div></div>\n                </div>\n            </div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.showCloneDashboardButton) {
          __out.push('\n            <div class="member clone"><div class="menu-label">Clone Dashboard</div></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.showDownloadPDFButton) {
          __out.push('\n          <div class="member download-pdf"><div class="menu-label">Download PDF</div></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.showArchiveButton) {
          __out.push('\n            <div class="member delete ');
          if (this.grayOutDeleteButton) {
            __out.push(__sanitize('disabled'));
          }
          __out.push('">\n                <div class="menu-label capitalize">');
          __out.push(__sanitize(this.deleteOrArchiveButtonText));
          __out.push('</div>\n                <div class="confirm-message">Are you sure you want to ');
          __out.push(__sanitize(this.deleteOrArchiveButtonText));
          __out.push(' this dashboard?</div>\n                <div class="button cancel inert-small"><div class="label">Cancel</div></div>\n                <div class="button delete destructive-small"><div class="label">');
          __out.push(__sanitize(this.deleteOrArchiveButtonText));
          __out.push('</div></div>\n            </div>\n        ');
        }
      
        __out.push('\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_color_themes"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        __out.push('<div class="top-label">\n  <div class="default-theme-container">\n    <div class="color-theme color-theme-row" obj-id="');
      
        __out.push(__sanitize(this.defaultTheme.cid));
      
        __out.push('">\n      <div class="dashboard-theme-name">\n        ');
      
        if (this.useParentTheme) {
          __out.push('\n          <span>');
          __out.push(__sanitize(this.defaultTheme.siteDefaultName()));
          __out.push('</span><span class="normal-12-mirage-font"> (');
          __out.push(__sanitize(this.defaultTheme.name));
          __out.push(')</span>\n        ');
        } else {
          __out.push('\n          ');
          __out.push(__sanitize(this.defaultTheme.name));
          __out.push('\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="color-row">\n        ');
      
        ref = this.defaultTheme.displayColors(20);
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n          <div class="color-square dashboard" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('"></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.defaultTheme.colorList().length > 20) {
          __out.push('\n          <span>...</span>\n        ');
        }
      
        __out.push('\n      </div>\n    </div>\n  </div>\n  <div class="icon expando"></div>\n</div>\n<div class="scroll-container">\n  <div class="body">\n    <div class="color-theme-box default"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_color_themes_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        __out.push('<div class="color-theme-row" data-set-to-site="');
      
        __out.push(__sanitize(this.useSpaceDefault));
      
        __out.push('">\n  <div class="dashboard-theme-name">\n    ');
      
        if (this.useParentTheme) {
          __out.push('\n      <span> ');
          __out.push(__sanitize(this.theme.siteDefaultName()));
          __out.push('</span><span class="normal-12-mirage-font"> (');
          __out.push(__sanitize(this.theme.name));
          __out.push(')</span>\n    ');
        } else {
          __out.push('\n      ');
          __out.push(__sanitize(this.theme.name));
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n  <div class="color-cell">\n    ');
      
        ref = this.theme.displayColors(20);
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n      <div class="color-square dashboard" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('"></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.theme.colorList().length > 20) {
          __out.push('\n      <span>...</span>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_permission_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="permission-group">\n    <div class="small-checkbox ');
      
        if (this.viewIsChecked) {
          __out.push('selected');
        }
      
        __out.push(' ');
      
        if (this.viewDisabled) {
          __out.push('disabled');
        }
      
        __out.push('" data-group-id="');
      
        __out.push(__sanitize(this.group.id));
      
        __out.push('" data-permission="view">\n        <div class="icon"></div>\n    </div>\n    <div class="small-checkbox ');
      
        if (this.editIsChecked) {
          __out.push('selected');
        }
      
        __out.push(' ');
      
        if (this.editDisabled) {
          __out.push('disabled');
        }
      
        __out.push(' ');
      
        if (this.editGreyed) {
          __out.push('greyed');
        }
      
        __out.push('" data-group-id="');
      
        __out.push(__sanitize(this.group.id));
      
        __out.push('" data-permission="edit">\n        <div class="icon"></div>\n    </div>\n    <div class="group">');
      
        __out.push(__sanitize(this.group.name));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_permissions"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="top-label');
      
        if (!this.can_edit) {
          __out.push(__sanitize(' disabled'));
        }
      
        __out.push('">\n    <span class="text name"></span>\n    <div class="icon expando"></div>\n</div>\n<div class="scroll-container">\n    <div class="body">\n        <div class="permission-labels default">\n            <div class="permission-label view">View</div>\n            <div class="permission-label edit">Edit</div>\n            <div class="group-label">Default Groups</div>\n        </div>\n        <div class="permission-box default"></div>\n        <div class="permission-labels custom-groups">\n            <div class="permission-label view"></div>\n            <div class="permission-label edit"></div>\n            <div class="group-label">Custom Groups</div>\n        </div>\n        <div class="permission-box custom-groups"></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_preferences"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="item-container">\n  <div class="item dashboard-settings ');
      
        if (!this.showSettingsTab) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n    Settings\n  </div>\n  <div class="item permissions ');
      
        if (!this.showPermissions) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n    Permissions\n  </div>\n  <div class="item shared-dashboards ');
      
        if (!this.showSharedDashboards) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n    Shared Dashboards\n    <div class="icon info-question-mark"></div>\n  </div>\n  <div class="item email ');
      
        if (!this.showReports) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n    ');
      
        if (this.slackEnabled) {
          __out.push('\n      Reports\n    ');
        } else {
          __out.push('\n      Email Reports\n    ');
        }
      
        __out.push('\n    <div class="icon info-question-mark"></div>\n  </div>\n  <div class="item quality-check ');
      
        if (!this.showQualityCheck) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n    Quality Check\n    <div class="icon info-question-mark"></div>\n  </div>\n</div>\n<div class="content-container scroll-container"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/dashboard_tags"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, tag;
      
        __out.push('<ul id="tags">\n    <li class="empty-message">Enter tags</li>\n    ');
      
        ref = this.tags;
        for (i = 0, len = ref.length; i < len; i++) {
          tag = ref[i];
          __out.push('\n    <li>');
          __out.push(__sanitize(tag));
          __out.push('</li>\n    ');
        }
      
        __out.push('\n</ul>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, u;
      
        __out.push('<div class="save-cancel-area">\n  <div class="button inert-small cancel-button">\n    <div class="label">Cancel</div>\n  </div>\n  <div class="button action-small save-button">\n      <div class="label">Save</div>\n  </div>\n</div>\n<div class="input-area">\n  <div class="tags-area">\n      <div class="title">Tags</div>\n  </div>\n  <div class="dashboard-description-area">\n      <div class="title">Description</div>\n      <div class="description">\n          <textarea class="redesign-input" placeholder="Enter Description" maxlength="');
      
        __out.push(__sanitize(App.PeriscopeModel.DESCRIPTION_MAX_LENGTH));
      
        __out.push('"></textarea>\n      </div>\n  </div>\n  ');
      
        if (!this.rbacEnabled) {
          __out.push('\n    <div class="owner">\n        <div class="title">Owner</div>\n        <select>\n          ');
          ref = this.allUsers;
          for (i = 0, len = ref.length; i < len; i++) {
            u = ref[i];
            __out.push('\n            <option value=');
            __out.push(__sanitize(u.id));
            __out.push('>');
            __out.push(__sanitize("" + (u.displayName())));
            __out.push('</option>\n          ');
          }
          __out.push('\n        </select>\n    </div>\n    <div class="permissions">\n        <div class="title">Permissions</div>\n        <div class="body"></div>\n    </div>\n  ');
        }
      
        __out.push('\n  ');
      
        if (this.colorThemesEnabled) {
          __out.push('\n    <div class="color-themes-area">\n      <div class="title">Dashboard Theme</div>\n      <div class="body"></div>\n    </div>\n  ');
        }
      
        __out.push('\n  ');
      
        if (this.autoArchiveEnabled) {
          __out.push('\n    <div class="title">Auto Archive</div>\n    <div class=\'archive-toggle-area\'></div>\n  ');
        }
      
        __out.push('\n  \n  ');
      
        if (this.badgeToggleEnabled) {
          __out.push('\n    <div class="title">Official Badge</div>\n    <div class=\'badge-toggle-area\'></div>\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/shared_dashboard_detail"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var cd, dimensionsToDisplay, i, info, j, len, len1, ref;
      
        __out.push('<div class="share-form-header">\n  <div class="top-box ');
      
        if (this.canEdit) {
          __out.push(__sanitize('edit'));
        }
      
        __out.push('">\n    ');
      
        if (this.canEdit) {
          __out.push('\n    <div class="title edit">\n      <input class="name shared-dash-name" placeholder="Shared Dashboard Name">\n    </div>\n    ');
        } else {
          __out.push('\n    <div class="title">\n      <div class="label">');
          __out.push(__sanitize(this.title));
          __out.push('</div>\n    </div>\n    ');
        }
      
        __out.push('\n    <div class="button-area"></div>\n  </div>\n  ');
      
        if (!this.canEdit) {
          __out.push('\n    <div class="share-url">\n    <a class="share-link" target="_blank" href="');
          __out.push(__sanitize(this.shareUrl));
          __out.push('" rel="nofollow noopener noreferrer">');
          __out.push(__sanitize(this.shareUrl));
          __out.push('</a>\n    <span class=\'view-count\'>');
          __out.push(__sanitize(this.viewCount));
          __out.push(' Views</span>\n  </div>\n  ');
        }
      
        __out.push('\n  ');
      
        if (this.passwordsEnabled) {
          __out.push('\n    <div class="password-area">\n      <div class="password-toggler"></div>\n      <div class="security-advisory">\n        <a href="https://doc.periscopedata.com/article/sharing-dashboards-with-external-users" target="_blank" rel="nofollow noopener noreferrer">\n          Security advisory\n        </a>\n      </div>\n      <div class="password-input-area">\n        <div class="view-hide-password"></div>\n        <div class="cross-out-line"></div>\n        <input placeholder="Set Password" type="password">\n        <div class="password-error-message hidden">Password cannot be blank.</div>\n      </div>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n\n');
      
        dimensionsToDisplay = _.filter(this.dims, ((function(_this) {
          return function(cd) {
            return _this.canEdit || cd.checked || cd.values.length > 0;
          };
        })(this)));
      
        __out.push('\n');
      
        if (dimensionsToDisplay.length) {
          __out.push('\n  <div class="filter-list-header">Applied Filters</div>\n  <div class="bottom-box ');
          if (this.canEdit) {
            __out.push(__sanitize('edit'));
          }
          __out.push(' scroll-container" >\n    <div class="row headers">\n      <div class="cell name"><span>Filter</span></div>\n      <div class="cell filter-is-visible">\n        <span class="label">Visible</span><div class="info-icon"></div>\n      </div>\n      <div class="cell selected-dimensions"><span>Values</span></div>\n    </div>\n    <div class="settings-body dimensions-grid">\n      ');
          for (i = 0, len = dimensionsToDisplay.length; i < len; i++) {
            cd = dimensionsToDisplay[i];
            __out.push('\n        <div dim_cid="');
            __out.push(__sanitize(cd.cid));
            __out.push('" class="row body">\n          <div class="cell name"><span>');
            __out.push(__sanitize(cd.name));
            __out.push('</span></div>\n          <div class="cell filter-is-visible">\n            ');
            if (this.canEdit) {
              __out.push('\n              <div dim_cid="');
              __out.push(__sanitize(cd.cid));
              __out.push('"\n                class="checkbox\n                ');
              if (cd.checked) {
                __out.push(' selected');
              }
              __out.push('\n                "><div class="icon"></div>\n              </div>\n            ');
            } else {
              __out.push('\n              <div class="text" dim_cid="');
              __out.push(__sanitize(cd.cid));
              __out.push('">\n                ');
              __out.push(__sanitize(cd.checked ? 'Yes' : 'No'));
              __out.push('\n              </div>\n            ');
            }
            __out.push('\n          </div>\n          <div class="cell selected-dimensions">\n            <div class="dimension-area" dim_cid="');
            __out.push(__sanitize(cd.cid));
            __out.push('">\n              ');
            if (this.canEdit) {
              __out.push('\n                <select multiple=true dim_cid="');
              __out.push(__sanitize(cd.cid));
              __out.push('">\n                  ');
              ref = cd.values;
              for (j = 0, len1 = ref.length; j < len1; j++) {
                info = ref[j];
                __out.push('\n                    <option selected value="');
                __out.push(__sanitize(info.value));
                __out.push('" group="');
                __out.push(__sanitize(info.group));
                __out.push('">');
                __out.push(__sanitize(info.value_name));
                __out.push('</option>\n                  ');
              }
              __out.push('\n                </select>\n                ');
              if (cd.cid === 'date_range' || cd.filterType === 'DateRange') {
                __out.push('\n                <div class="custom-date-range" dim_cid="');
                __out.push(__sanitize(cd.cid));
                __out.push('"=>\n                  <div class="range-row">\n                    <div class="input-wrapper">\n                      <input class="range-start range-input" placeholder="Start Date" ></input>\n                    </div>\n                    <div class="picker-button start"></div>\n                  </div>\n                  <div class="range-row">\n                    <div class="input-wrapper">\n                      <input class="range-end range-input" placeholder="End Date" ></input>\n                    </div>\n                    <div class="picker-button end"></div>\n                  </div>\n                </div>\n                ');
              }
              __out.push('\n              ');
            } else {
              __out.push('\n                <div class="view-dim-name">');
              __out.push(__sanitize(((function() {
                var k, len2, ref1, results;
                ref1 = cd.values;
                results = [];
                for (k = 0, len2 = ref1.length; k < len2; k++) {
                  info = ref1[k];
                  results.push(info.value_name);
                }
                return results;
              })()).join(", ")));
              __out.push('</div>\n              ');
            }
            __out.push('\n            </div>\n          </div>\n        </div>\n      ');
          }
          __out.push('\n    </div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/shared_dashboard_list"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, share;
      
        __out.push('<div class="share-list-header">\n  <div class="add-new button action-small"><span class="label">ADD NEW</span></div>\n</div>\n');
      
        if (this.sharedDashboards.length > 0) {
          __out.push('\n  <ol class="share-list">\n    ');
          ref = this.sharedDashboards;
          for (i = 0, len = ref.length; i < len; i++) {
            share = ref[i];
            __out.push('\n    <li class="share-list-item" shared_dashboard_id="');
            __out.push(__sanitize(share.cid));
            __out.push('">\n      <span class="share-title ');
            if (share.password_protected) {
              __out.push(__sanitize('password-lock'));
            }
            __out.push('">\n        ');
            __out.push(__sanitize(share.title()));
            __out.push('\n      </span>\n      <a class="link-icon" href="');
            __out.push(__sanitize(share.shareUrl()));
            __out.push('" target="_blank" rel="nofollow noopener noreferrer"></a>\n    </li>\n    ');
          }
          __out.push('\n  </ol>\n');
        } else {
          __out.push('\n  <div class="major-message">Shared Dashboards are externally accessible.</div>\n  <div class="minor-message">Share dashboards with specific filter values to easily send\n    to external parties.</div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_preferences/widget_color_themes_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        __out.push('<div class="color-theme-row">\n  <div class="dashboard-theme-name">\n    ');
      
        if (this.useParentTheme && !this.isCustomTheme) {
          __out.push('\n      <span> Dashboard Theme</span><span class="normal-12-mirage-font"> (');
          __out.push(__sanitize(this.theme.name));
          __out.push(')</span>\n    ');
        } else {
          __out.push('\n      ');
          __out.push(__sanitize(this.theme.name));
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n  <div class="widget-color-row">\n    ');
      
        ref = this.theme.displayColors(14);
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n      <div class="color-square dashboard" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('"></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.theme.colorList().length > 14) {
          __out.push('\n        <span>...</span>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_rearranger/dialog"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="dashboard-chart-rearranger-container">\n  <div class="buttons">\n     <div class="button-row flex-fill-row">\n        <div class="button disabled inert-small reset-rearrange">\n          <div class="label">Reset</div>\n        </div>\n        <div class="button disabled action-small apply-rearrange">\n          <div class="label">Apply</div>\n        </div>\n    </div>\n  </div>\n  <div class="grid-area">\n    <div class="grid-boundary rearranger fluid"></div>\n  </div>\n\n  <div class="message loading-message normal-14-scarpa-flow-font">Loading</div>\n  <div class="message no-charts-message normal-14-scarpa-flow-font">This dashboard has no charts to rearrange.</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboard_rearranger/rearranger_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="rearranger-block flex-fill-column"\n     data-widget-class-name="');
      
        __out.push(__sanitize(this.widget.constructor.className));
      
        __out.push('"\n     data-widget-cid="');
      
        __out.push(__sanitize(this.widget.cid));
      
        __out.push('"\n>\n    <div class="flex-filler"></div>\n    <div class="content">\n        <div class="icon"></div>\n        <div class="title"></div>\n    </div>\n    <div class="flex-filler"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/archived_dashboard_header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="text-icon-container">\n  <div class="text-icon-root" />\n</div>\n<div class="header-description ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n  ');
      
        if (this.spaceName != null) {
          __out.push('\n  <div class="space-name heavy-13-eastern-blue-font">');
          __out.push(__sanitize(this.spaceName));
          __out.push('</div> /\n  ');
        }
      
        __out.push('DASHBOARD</div>\n<div class="header-content">\n  <div class="left-controls ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n    <div class="title-wrapper">\n      <input type="text" class="header-title"/>\n    </div>\n    <div class=\'archived-icon\'>\n      Archived\n    </div>\n    <div class="dashboard-freshness-root ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('"></div>\n  </div>\n  <div class="right-controls ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n    ');
      
        if (this.textOnDashboardEnabled) {
          __out.push('\n      <div class="button action-large new-text-box-button ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('">\n        <div class="label">T</div>\n      </div>\n    ');
        }
      
        __out.push('\n    <div class="unarchive-button-area"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/charts-container"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-boundary chart-tooltip-boundary right-boundary">\n  <div class="grid-left-border"></div>\n  <div class="grid-right-border"></div>\n  <div class="grid-screen-marker p1024"></div>\n  <div class="grid-screen-marker p1920"></div>\n  <div class="grid-screen-marker p2560"></div>\n  <div class="grid-marker-label p1024">1024px</div>\n  <div class="grid-marker-label p1920">1920px</div>\n  <div class="grid-marker-label p2560">2560px</div>\n</div>\n<div id="tod-toolbar-wrapper" style="position:absolute;top:0;left:0"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/custom_dimension_availability_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="small-checkbox ');
      
        __out.push(__sanitize(this.selected ? 'selected' : void 0));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.disabled ? 'disabled' : void 0));
      
        __out.push('" cd_cid="');
      
        __out.push(__sanitize(this.cid));
      
        __out.push('">\n  <div class="icon"></div>\n  <div class="label">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('\n    ');
      
        if (this.disabled) {
          __out.push('<div class="locked">Visible on Shared Dashboard</div>');
        }
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/custom_dimension_input_value_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="input-row ');
      
        __out.push(__sanitize(this.mode));
      
        __out.push('">\n  <div class="input-row-content">\n    <div class="action"></div>\n    <input class="name redesign-input" placeholder="Name" value="');
      
        __out.push(__sanitize(this.name));
      
        __out.push('"></input>\n    <input class="value redesign-input" placeholder="Value" value="');
      
        __out.push(__sanitize(this.value));
      
        __out.push('" ></input>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/dashboard"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="app-header dashboard-header tooltip-cover-heading"></div>\n<div class="filters-wrapper tooltip-cover-heading"></div>\n<div class="main-content">\n    <div class="empty-dash-message" style="display:none">Click New Chart <br/> to begin your analysis</div>\n    <div class="dashboard-loader">\n      <div class="label-holder">\n        <div class="spinner"></div>\n        <div class="text-below-spinner">Loading</div>\n      </div>\n    </div>\n</div>\n<div class="app-footer dashboard-footer"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/dashboard_filters"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="dashboard-settings-frame">\n    <div class="dash-loading-cover">\n      <div class="new-spinner-with-label-white-bg">\n        <div class="new-spinner"></div>\n        <div class="new-text-below-spinner">Loading</div>\n      </div>\n    </div>\n    <div class="filters-bar invisible"></div>\n    <div class="settings">\n      <div class="no-dimensions-message"></div>\n    </div>\n    <div class="side-frame">\n        <div class="icon gear-icon"></div>\n        <div class="icon add-icon"></div>\n    </div>\n    <div class="bottom-menu-frame">\n        <div class="footer-text reset-filters">Reset Filters</div>\n        <div class="footer-text set-default-filters">Set As Default</div>\n        <div class="button inert-medium cancel-button"><div class="label">Cancel</div></div>\n        <div class="button action-medium apply-button"><div class="label">Apply</div></div>\n    </div>\n</div>\n<div class="add-dimension-form"></div>\n<div class="dimension-availability-form"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/dashboard_header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="text-icon-container">\n  <div class="text-icon-root" ></div>\n</div>\n<div class="header-description ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n  ');
      
        if (this.spaceName != null) {
          __out.push('\n  <div class="space-name heavy-13-eastern-blue-font">');
          __out.push(__sanitize(this.spaceName));
          __out.push('</div> /\n  ');
        }
      
        __out.push('DASHBOARD</div>\n<div class="header-content">\n  <div class="left-controls ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n    <div class="title-wrapper">\n      <input type="text" class="header-title"></input>\n    </div>\n    <div class="dashboard header-icons ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n      <div class="badge header-icon badge-hidden" ></div>\n      <div class="info dashboard header-icon"></div>\n      ');
      
        if (!this.dashboardOrganizationEnabled) {
          __out.push('\n      <div class="refresh dashboard header-icon" data-tooltip="Refresh"></div>\n      <div class="star dashboard header-icon" data-tooltip="Mark as Favorite"></div>\n      ');
        }
      
        __out.push('\n    </div>\n    <div class="dashboard-freshness-root ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('"></div>\n  </div>\n  <div class="right-controls ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n    <div class="dashboard header-icons ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n      ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('\n        <div class="refresh dashboard header-icon ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('" data-tooltip="Refresh"></div>\n        <div class="star dashboard header-icon ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('" data-tooltip="Mark as Favorite"></div>\n        <div class="add-to-topic dashboard header-icon ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('" data-tooltip="Add to Topics"></div>\n      ');
        }
      
        __out.push('\n      <div class="dashboard-menu dashboard header-icon ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('"></div>\n    </div>\n    ');
      
        if (this.textOnDashboardEnabled) {
          __out.push('\n      <div class="button action-large new-text-box-button ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('">\n        <div class="label">T</div>\n      </div>\n    ');
        }
      
        __out.push('\n    <div class="button action-large new-chart-button">\n      <div class="label">New Chart</div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/dashboard_settings_filter_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var dimension, i, len, ref;
      
        __out.push('<div class="filter-group">\n    <span class="dimension-name bold">');
      
        __out.push(__sanitize(this.dimensionArray[0].dimension));
      
        __out.push('</span><span class="colon-break">&nbsp:</span>\n    ');
      
        ref = this.dimensionArray;
        for (i = 0, len = ref.length; i < len; i++) {
          dimension = ref[i];
          __out.push('\n        <div dimensionId="');
          __out.push(__sanitize(this.dimensionId));
          __out.push('"\n             dimensionValueId="');
          __out.push(__sanitize(dimension.value));
          __out.push('"\n             class="filter">\n          <span class="label">');
          __out.push(__sanitize(dimension.name));
          __out.push('</span>\n          <div class="remove-icon-holder">\n            <div class="remove-icon"></div>\n          </div>\n        </div>\n    ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/date_range_dimension_setting"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="date-range-dropdown">\n  <div class="setting-header">\n    <div class="label">');
      
        __out.push(__sanitize(this.labelText));
      
        __out.push('</div>\n    <div class="filter-chevron"></div>\n  </div>\n  <div class="options">\n    <div class=\'custom-date-option\'></div>\n    <div class="custom-date-range">\n      <div class="range-row">\n        <input class="range-start redesign-input" placeholder="Start Date" ></input>\n        <div class="picker-button start"></div>\n      </div>\n      <div class="range-row">\n        <input class="range-end redesign-input" placeholder="End Date"></input>\n        <div class="picker-button end"></div>\n      </div>\n    </div>\n    <div class=\'other-options\'></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/drag_drop_editor_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'chart-builder-area\'></div>\n\n<div style=\'font-size:14px;padding-left:12px;padding-top:18px;padding-bottom:7px;\'>\n  <span class=\'chart-button\' style=\'padding-right:30px;cursor:pointer;\'>Chart</span>\n  <span class=\'sql-button\' style=\'cursor:pointer;\'>SQL</span>\n</div>\n\n<div class=\'source-viewer-area\'></div>\n<div class=\'read-only-sql-editor-area\' style=\'padding-left:12px;padding-right:12px;\'></div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/empty_box"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'react-div\' style=\'height:100%;\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/filter_bar"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="filters-bar-label bold">\nFilters\n<span id="filter-count">(');
      
        __out.push(__sanitize(this.filterCount));
      
        __out.push(')</span>\n<div class="icon arrow-drop-down"></div>\n</div>\n');
      
        if (!(this.filterCount > 0)) {
          __out.push('\n    <div class="no-filters">No filters selected</div>\n');
        }
      
        __out.push('\n<div class="filters"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/filter_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var d, i, len, ref;
      
        __out.push('<header>\n    <div class="refresh-icon"></div>\n    <div class="cancel-icon"></div>\n    <span class="title">Create Filter</span>\n</header>\n<section class="modal-content">\n    <input class="redesign-input dimension-name" placeholder="Name"></input>\n    <div class="errors warning-icon title-error"></div>\n    <div class="condition-options">\n        <div class="names-from-db block">\n            <div class="values-area">\n                <div class="values-content">\n                    <select class="database-picker">\n                        ');
      
        ref = App.Database.all();
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          __out.push('\n                        <option value=');
          __out.push(__sanitize(d.id));
          __out.push('>');
          __out.push(__sanitize(d.database_name));
          __out.push('</option>\n                        ');
        }
      
        __out.push('\n                    </select>\n                    <div class="sql-box"></div>\n                    <div class="errors warning-icon db-error"></div>\n                    <div class="alert-flex-wrapper filter">\n                        <div class="alert-sidebar"></div>\n                        <div class="alert-border">\n                            <div class="alert-icon"></div>\n                            <div class="alert-body">\n                                <div class="alert-reference"></div>\n                                <div class="alert-message"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="names-from-form block">\n            <div class="values-area">\n                <div class="values-content"></div>\n            </div>\n            <div class="errors warning-icon val-error"></div>\n        </div>\n        <div class="free-input block"></div>\n        <div class="daterange block"></div>\n    </div>\n    <div class="expression-from-sql">\n        <div class="values-area">\n            <div class="values-content">\n                <div class="sql-box"></div>\n            </div>\n            <div class="delete-area">\n                <div class="checkbox enable-deletion">\n                    <div class="icon"></div>\n                    <div class="label">Enable deletion</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="more options link">More Options</div>\n    <div class="less options link">Fewer Options</div>\n</section>\n<div class="save-row">\n    <div class="delete-confirm-msg">Are you sure you want to <span>delete</span> this Filter?</div>\n    <div class="options delete">Delete</div>\n    <div class="options hide">Hide</div>\n    <div class="cancel button inert-medium"><div class="label">Cancel</div></div>\n    <div class="save button action-medium"><div class="label">Save</div></div>\n    <div class="delete button destructive-medium"><div class="label">Delete</div></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/grid_columns"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j, ref;
      
        for (i = j = 0, ref = this.numDividers; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
          __out.push('\n    <div class="grid-column-dividers" position="');
          __out.push(__sanitize(i));
          __out.push('"></div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/info_view_tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        if (this.isFailingQualityCheck) {
          __out.push('\n  <div class="error-msg">This dashboard failed its data quality check. Contact the dashboard owner for more information</div>\n\n  <hr class="divider">\n');
        }
      
        __out.push('\n<table class="dashboard-info-tooltip">\n  ');
      
        if (this.ownedBy != null) {
          __out.push('\n    <tr>\n      <td class="label">Owner</td>\n      <td class="data">');
          __out.push(__sanitize(this.ownedBy));
          __out.push('</td>\n    </tr>\n  ');
        }
      
        __out.push('\n  ');
      
        if (this.lastRefreshed != null) {
          __out.push('\n    <tr>\n      <td class="label">Last Refreshed</td>\n      <td class="data">');
          __out.push(__sanitize(this.lastRefreshed));
          __out.push('</td>\n    </tr>\n  ');
        }
      
        __out.push('\n</table>\n');
      
        if (((ref = this.description) != null ? ref.length : void 0) > 0) {
          __out.push('\n  <hr class="divider">\n  <div>');
          __out.push(__sanitize(this.description));
          __out.push('</div>\n');
        }
      
        __out.push('\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/link_to_widget_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="chart-header">\n    <div class="header-description">');
      
        if (this.spaceName != null) {
          __out.push('\n        <div class="space-name heavy-13-eastern-blue-font">');
          __out.push(__sanitize(this.spaceName));
          __out.push('</div>\n        ');
        }
      
        __out.push('Chart</div>\n    <div class="chart-title-wrapper">\n          <span class="title"></span>\n    </div>\n    <div class="back-to-dash"><div class="back-icon"></div>Back to Dashboard</div>\n</div>\n<div class="bottom-box">\n  <div class="main-panel"></div>\n</div>\n<div class="app-footer dashboard-footer"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/link_to_widget_not_found"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="not-found-block">\n  <div class="error-icon"></div>\n  <div class="error-msg">This chart could not be found</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/manage_filters_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span class="title">Manage Filters</span>\n</header>\n<section class="modal-content">\n    <div class="form-animate-body light-theme">\n      <div class="dimension-settings-form">\n          <div class="left-column">\n            <div class="column-title light-theme">Visible</div>\n            <div class="visible-list"></div>\n          </div>\n          <div class="right-column">\n            <div class="column-title light-theme">Hidden</div>\n            <div class="hidden-list"></div>\n          </div>\n      </div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/pdf-guideline"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-screen-marker-horizontal guideline');
      
        __out.push(__sanitize(this.pageNum));
      
        __out.push('" style="top: ');
      
        __out.push(__sanitize(this.top));
      
        __out.push('px;"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/powered_by"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="embed-powered-by"><a href="https://www.periscopedata.com/product?utm_source=embed_footer" target="_blank" rel="nofollow noopener noreferrer">Powered by <span class="embed-pericope-data">Sisense for Cloud Data Teams</span></a></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/print-friendly-label"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-marker-label print-friendly">Print Friendly</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/setting"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="setting-header">\n    <div class="label">');
      
        __out.push(__sanitize(this.settingName));
      
        __out.push('</div>\n    ');
      
        if (this.canEdit) {
          __out.push('\n    <div class="edit-icon"></div>\n    ');
        }
      
        __out.push('\n    <div class="filter-chevron"></div>\n</div>\n\n<div class="values-selection" tabindex="1"></div>\n\n<div class="label-holder">\n   <div class="spinner"></div>\n   <div class="loading">Loading</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/setting_autocompleter"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="setting-header">\n  <div class="label">');
      
        __out.push(__sanitize(this.settingName));
      
        __out.push('</div>\n  ');
      
        if (!this.disableSearch) {
          __out.push('\n      <div class="edit-icon"></div>\n  ');
        }
      
        __out.push('\n  <div class="filter-chevron"></div>\n  ');
      
        if (!this.disableSearch) {
          __out.push('\n    <div class="search-box">\n      <div class="search-icon"></div>\n      <input class="search-input search-input-has-icon" autocomplete="off" placeholder="Search" spellcheck="false"></input>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n<div class="search-results"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/setting_autocompleter_standalone"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="search-box">\n    <div class="search-icon"></div>\n    <input class="search-input search-input-has-icon" autocomplete="off" placeholder="Search" spellcheck="false"></input>\n</div>\n\n');
      
        if (this.filterCheckAllEnabled) {
          __out.push('\n  <div class="checkbox small-checkbox check-all"\n       style=\'color:black;border-bottom:1px solid #d8d8d8;padding:6px 12px 4px 21px;margin-left:-9px;\'>\n    <div class="icon check-all"></div>\n    <div class="label check-all">Select Displayed</div>\n  </div>\n');
        }
      
        __out.push('\n\n<div class="search-results ');
      
        if (this.filterCheckAllEnabled) {
          __out.push('check-all');
        }
      
        __out.push('">\n</div>\n\n<div class="message"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/shared_dashboard_header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="shared-header-content">\n  <span class="shared header-title"></span>\n  ');
      
        if (this.showRefreshIcon) {
          __out.push('\n    <i class="refresh dashboard header-icon longer" data-tooltip="Refresh"></i>\n  ');
        }
      
        __out.push('\n  ');
      
        if (!this.hideLogo) {
          __out.push('\n    <div id=\'periscope-logo\' class="shared-mode-logo"></div>\n  ');
        }
      
        __out.push('\n  <div class="normal-14-scarpa-flow-font email-subheader">');
      
        __out.push(__sanitize(this.screenshotTimestampLabel));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/shared_dashboard_password"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="shared-dashboard-password">\n  <div class="password-container">\n    <div class="password-box">\n      <div class="password-section">\n        <div class="password-title">Password</div>\n        <div class="password-text">Enter the password for this dashboard</div>\n        <input placeholder="Enter password" type="password">\n        <div class="password-incorrect-message hidden">Password incorrect.</div>\n      </div>\n      <div class="button-section">\n        <div class="button action-medium disabled">VIEW DASHBOARD</div>\n      </div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/styleguide"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j;
      
        __out.push('<div class="styleguide">\n    <div class="title">\n        <h1>Styleguide</h1>\n        Welcome to the styleguide! Please keep some points in mind during the redesign:\n        <li> If rendering many radio buttons/checkboxes as part of a UI panel, avoid instantiating a controller for\n            each.\n            Instead, use a common controller to listen for click events on a certain DOM class and manually mutate state\n            of the element.\n        <li> Checkboxes/radio buttons that are children of disabled elements will be disabled by default. This, however,\n            does not apply to buttons.\n            You would need to add a \'disabled\' class explicitly to disable a button.\n        <li> We should display tooltips for overflown text only. This is being checked (in this controller) by comparing\n            the offsetWidth of the element to the scrollWidth.\n            There\'s probably a better way. This should be revisited before implementing tooltips.\n        <li> Use\n            <div class="bold">this font family</div>\n            where bold fonts are needed.\n    </div>\n    <div class="area radio-button-area">\n        <h1>Radio Buttons</h1>\n    </div>\n\n    <div class="area small-radio-button-area">\n        <h1>Small Radio Buttons</h1>\n    </div>\n\n    <div class="area checkbox-area">\n        <h1>Medium Checkbox</h1>\n    </div>\n\n    <div class="area small-checkbox-area">\n        <h1>Small Checkbox</h1>\n    </div>\n\n    <div class="area toggle-area">\n        <h1>Toggle</h1>\n    </div>\n\n    <div class="area tooltip-area">\n        <div class="content-offset-wrapper">\n            <div class="content">\n                <h1>Tooltip</h1>\n                <div class="tooltip-text">Text that is too long</div>\n            </div>\n        </div>\n    </div>\n\n    <div class="area icons-area">\n        <h1>Icons</h1>\n        <h2>Permissions</h2>\n        <div class="permissions-example">\n            <div class="icon edit-icon"></div>\n            <div class="unfold-area">\n                Sort\n                <div class="icon unfold"></div>\n            </div>\n            <div class="dropdown-area">\n                <div class="icon dropdown"></div> Item\n            </div>\n        </div>\n    </div>\n\n    <div class="area select-area">\n        <h1>Select</h1>\n        <select>\n            <option>Unu</option>\n            <option>Du</option>\n            <option>Tri</option>\n            <option>Kvar</option>\n            <option>...</option>\n        </select>\n    </div>\n\n    <div class="area buttons-area">\n        <h1>Buttons: Fixed-Width Family</h1>\n        <div class="button-column">\n            <h2>Active</h2>\n            <div class="button inert-large">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-large">\n                <div class="label">Delete</div>\n            </div>\n\n            <div class="button action-medium">\n                <div class="label">Apply</div>\n            </div>\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-small">\n                <div class="label">Delete</div>\n            </div>\n        </div>\n        <div class="button-column">\n            <h2>Disabled</h2>\n            <div class="button inert-large disabled">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-large disabled">\n                <div class="label">Delete</div>\n            </div>\n            <div class="button action-medium disabled">\n                <div class="label">Apply</div>\n            </div>\n            <div class="button inert-medium disabled">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-small disabled">\n                <div class="label">Delete</div>\n            </div>\n        </div>\n    </div>\n    <div class="area flex buttons-area">\n        <h1>Buttons: Fixed-Padding Family</h1>\n        <div class="button action-medium">\n            <div class="label">Run</div>\n        </div>\n        <div class="button action-medium">\n            <div class="label">Run Selected</div>\n        </div>\n        <div class="button action-medium">\n            <div class="label">Add New</div>\n        </div>\n\n        <h1>Button Pairs</h1>\n        <h2>Wider button has 14px padding, determines width</h2>\n        <div class="buttons flex-fill-row">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button action-medium">\n                <div class="label">Save</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button action-medium">\n                <div class="label">Create</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button action-medium">\n                <div class="label">Update</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-medium">\n                <div class="label">Delete</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-medium">\n                <div class="label">Remove</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row dc">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button destructive-medium">\n                <div class="label">Disconnect</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row proceed">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button action-medium">\n                <div class="label">Proceed</div>\n            </div>\n        </div>\n        <div class="buttons flex-fill-row confirm">\n            <div class="button inert-medium">\n                <div class="label">Cancel</div>\n            </div>\n            <div class="button action-medium">\n                <div class="label">Confirm</div>\n            </div>\n        </div>\n    </div>\n\n    <div class="area search-box-area">\n        <h1>Search Input</h1>\n        <div class="search-box">\n            <div class="search-icon"></div>\n            <input class="search-input" autocomplete="off" placeholder="Enabled Input"></input>\n        </div>\n        <div class="search-box disabled">\n            <input class="search-input" autocomplete="off" placeholder="Disabled Input" disabled></input>\n        </div>\n        <h1>Light Input Box</h1>\n        <input class="redesign-input" autocomplete="off" placeholder="Placeholder Text">\n        <h1>Light Input Box Error</h1>\n        <input class="redesign-input error" autocomplete="off" placeholder="Placeholder Text">\n    </div>\n\n    <div class="area modal-area">\n        <h1>Modal</h1>\n        <div class="modal">\n            <header>\n                <div class="cancel-icon"></div>\n                <span>A Modal</span>\n            </header>\n            <section class="modal-content">\n                Modal Content\n            </section>\n        </div>\n    </div>\n\n    <div class="area modal-area">\n        <h1>Modal with a dark header</h1>\n        <div class="modal">\n            <header class="modal-header-violet">\n                <div class="cancel-icon"></div>\n                <span>A Modal</span>\n            </header>\n            <section class="modal-content">\n                Modal Content\n            </section>\n        </div>\n    </div>\n\n    <div class="area dark-modal-area">\n        <h1>Two-Paneled Modal</h1>\n        <div class="modal dark">\n            <header>\n                <div class="cancel-icon"></div>\n                <span>A Modal</span>\n            </header>\n            <span class="item-scroll-wrapper">\n            <div class="item-container">\n                <div class="item active">\n                    Settings\n                </div>\n                <div class="item">\n                    Shared Dashboards\n                </div>\n            </div>\n            </span>\n            <span class="content-scroll-wrapper">\n            <div class="content-container"></div>\n                </span>\n        </div>\n    </div>\n\n  <div class="area rotator-area">\n    <h1>Rotator Text</h1>\n    <div class="subheader-1">subheader-1</div>\n    <div class="subheader-1 rotator closed">\n      <div class="rotator-title">subheader-1 with rotator. Click to expand.</div>\n      <div class="content-area indented">This is the content-area</div>\n    </div>\n    <div class="subheader-2">subheader-2</div>\n    <div class="subheader-2 rotator closed">\n      <div class="rotator-title">subheader-2 with rotator. Click to expand.</div>\n      <div class="content-area indented">This is the content-area</div>\n    </div>\n  </div>\n\n    <div class="area">\n        <h1>Errors</h1>\n        <div class="errors">This is a div with red text signifying an error.</div>\n        <span class="errors">Span is okay too.</span>\n        <div class="errors warning-icon">Error message with warning icon.</div>\n        <div class="errors warning-icon"></div> <!-- This is an empty error. Notice it does not appear. -->\n        <div class="errors warning-icon">Using div: Multi-line error message with a long message.</div>\n        <span class="errors warning-icon"></span> <!-- This is an empty error. Notice it does not appear. -->\n        <span class="errors warning-icon">You can also use span: Multi-line error message with a long message.</span>\n        <div class="error-block"> This is the default error block\n        for filter and chart errors </div>\n        <div class="filter-error"> This is a filter error </div>\n    </div>\n\n    <div class="headers">\n        <div class="sql-alert header"></div>\n        <div class="csv-view header"></div>\n        <div class="sql-view header"></div>\n        <div class="sql-snippet header"></div>\n        <div class="csv-view-with-error header"></div>\n    </div>\n\n    <div class="svg-icons">\n        <h2 style="font-size:16px"> SVG Icons </h2>\n        ');
      
        for (i = j = 1; j <= 131; i = ++j) {
          __out.push('\n            <div id="icon-');
          __out.push(__sanitize(i));
          __out.push('"></div>\n        ');
        }
      
        __out.push('\n    </div>\n\n    <div class="svg-logos">\n        <h2 style="font-size:16px"> SVG Logos </h2>\n        <div id="sisense-logo"></div><p>(This icon is white, there is no background color)</p>\n        <div id="sisense-logo-full-text"></div>\n    </div>\n\n    <div class="area text">\n        <h1>Text Styles</h1>\n        The following are the only text styles that we should need for the redesign.\n        &nbsp;\n        <h2 class=\'heavy-13-black-font\'> Font classes </h2>\n        <div class=\'normal-12-mirage-font\'>normal-12-mirage-font</div>\n        <div class=\'heavy-12-mirage-font\'>heavy-12-mirage-font</div>\n        <div class=\'normal-13-mirage-font\'>normal-13-mirage-font</div>\n        <div class=\'heavy-13-mirage-font\'>heavy-13-mirage-font</div>\n        <div class=\'normal-18-mirage-font\'>normal-18-mirage-font</div>\n        <div class=\'heavy-18-mirage-font\'>heavy-18-mirage-font</div>\n        <div class=\'normal-13-black-font\'>normal-13-black-font</div>\n        <div class=\'normal-14-black-font\'>normal-14-black-font</div>\n        <div class=\'normal-24-black-font\'>normal-24-black-font</div>\n        <div class=\'heavy-13-black-font\'>heavy-13-black-font</div>\n        <div class=\'normal-13-storm-gray-font\'>normal-13-storm-gray-font</div>\n        <div class=\'heavy-13-storm-gray-font\'>heavy-13-storm-gray-font</div>\n        <div class=\'normal-13-tuna-font\'>normal-13-tuna-font</div>\n        <div class=\'normal-14-tuna-font\'>normal-14-tuna-font</div>\n        <div class=\'heavy-13-tuna-font\'>heavy-13-tuna-font</div>\n        <div class=\'normal-14-scarpa-flow-font\'>normal-14-scarpa-flow-font</div>\n        <div class=\'normal-13-manatee-font\'>normal-13-manatee-font</div>\n        <div class=\'heavy-15-manatee-font\'>heavy-15-manatee-font</div>\n        <div class=\'heavy-13-eastern-blue-font\'>heavy-13-eastern-blue-font</div>\n        <div class=\'heavy-14-eastern-blue-font\'>heavy-14-eastern-blue-font</div>\n\n        &nbsp;\n        <h2 class=\'heavy-13-black-font\'> Legacy font styles that would ideally be eliminated </h2>\n        <div class="bold">In Zeplin, DINPro normal 500 weight corresponds to \'bold\' style (FF_DIN_MEDIUM). </div>\n        <div class="red-accent">red-accent</div>\n        <div class="dinpro13">dinpro13</div>\n        <div class="dinpro-medium-mirage">dinpro-medium-mirage</div>\n        <div class="dinpro-medium-mirage hover-eastern-blue">hover-eastern-blue</div>\n        <div class="underlined-link">underlined-link</div>\n        <div class="hover-red">hover-red</div>\n    </div>\n</div>\n\n\n\n<canvas id="canvas-text-sizer"></canvas>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/text_box"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'flash-box\'></div>\n<div class=\'text-box-react-div variable-left-margin-text-box\' style=\'height: 100%\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/dashboards/textbox-shadow"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'textbox-shadow\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/add_site_from_directory"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content">\n    <div class="title">Space Name</div>\n    <input class="site-name redesign-input" placeholder="Enter Space Name">\n    <div class="error-row red-accent dinpro13"></div>\n</div>\n<div class="button-row">\n    <div class="right-aligned-buttons"></div>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/group_directory_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column name-column">\n        <div class="sg-type-text group-name">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.name)));
      
        __out.push('</div>\n        <div class="globe ');
      
        if (this.row.is_site_family_group) {
          __out.push(__sanitize('show'));
        }
      
        __out.push('"></div>\n        <div class="sg-type-faded site-name">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.siteName)));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column created-by-column">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.created_by)));
      
        __out.push('</div>\n    <div class="sg-column created-on-column">\n        ');
      
        if (this.row.created_on) {
          __out.push('\n        ');
          formattedDate = this.dateFormatter(this.row.created_on);
          __out.push('\n                <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n                <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        --\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column sg-type-num users-column">');
      
        __out.push(__sanitize(this.row.users));
      
        __out.push('</div>\n    <div class="sg-column sg-type-num sites-column">');
      
        __out.push(__sanitize(this.row.sites));
      
        __out.push('</div>\n    <div class="sg-gear');
      
        if (this.row.admin || this.row.all_users) {
          __out.push(' hidden');
        }
      
        __out.push('"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/group_directory_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row">\n        <div class="sg-column edit-group-name-column">\n            <input ');
      
        if (this.group.disabled) {
          __out.push(__sanitize(disabled));
        }
      
        __out.push(' value="');
      
        __out.push(__sanitize(this.group.name));
      
        __out.push('" class="redesign-input"></input\n        </div>\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel">Cancel</div>\n            <div class="button action-medium confirm">Save</div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/groups_for_sites_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref, ref1;
      
        __out.push('<div class="sg-row ');
      
        if (this.row.disable) {
          __out.push(__sanitize('sg-type-faded'));
        }
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox ');
      
        if (this.row.inDirectory) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push(' ');
      
        if (((ref = this.row.group) != null ? ref.all_users : void 0) || this.row.disabled) {
          __out.push(__sanitize('disabled'));
        }
      
        __out.push('"><div class="icon"></div></div>\n        <div class="name-text-with-globe">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.name)));
      
        __out.push('</div>\n        <div class="globe');
      
        if ((ref1 = this.row.group) != null ? ref1.isSiteFamilyGroup() : void 0) {
          __out.push(__sanitize(' show'));
        }
      
        __out.push('"></div>\n    </div>\n    ');
      
        if (!this.hideEditColumn) {
          __out.push('\n      <div class="sg-column sg-type-text edit-column">\n          ');
          if (this.row.can_edit) {
            __out.push('Yes');
          } else {
            __out.push('No');
          }
          __out.push('\n      </div>\n    ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/remove_space"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Remove Space</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n    <div class="message normal-13-storm-gray-font">Removing <span class="red-accent">');
      
        __out.push(__sanitize(this.site_name));
      
        __out.push('</span> will delete\n        <span class="red-accent">');
      
        __out.push(__sanitize(this.dashboard_text));
      
        __out.push('</span> and\n        <span class="red-accent">');
      
        __out.push(__sanitize(this.user_text));
      
        __out.push('.</span>\n        To remove, type <span class="red-accent">');
      
        __out.push(__sanitize(this.site_name));
      
        __out.push('</span> in the form below. This action cannot be undone.\n    </div>\n    <input class="redesign-input error">\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons buttons flex-fill-row">\n            <div class="button inert-medium cancel"><div class="label">CANCEL</div></div>\n            <div class="button destructive-medium remove disabled"><div class="label">REMOVE</div></div>\n        </div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/single_column_check_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref, ref1;
      
        __out.push('<div class="sg-row ');
      
        if (this.row.disable) {
          __out.push(__sanitize('sg-type-faded'));
        }
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox ');
      
        if (this.row.inDirectory) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push(' ');
      
        if (((ref = this.row.group) != null ? ref.all_users : void 0) || this.row.disabled) {
          __out.push(__sanitize('disabled'));
        }
      
        __out.push('"><div class="icon"></div></div>\n        <div class="name-text-with-globe">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.name)));
      
        __out.push('</div>\n        <div class="globe ');
      
        if ((ref1 = this.row.group) != null ? ref1.isSiteFamilyGroup() : void 0) {
          __out.push(__sanitize('show'));
        }
      
        __out.push('"></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/site_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].id));
      
        __out.push('">\n  <div class="sg-column sg-type-text name-column">\n    <div class="name-text">');
      
        __out.push(__sanitize(this.row.display_name));
      
        __out.push('</div>\n  </div>\n  <div class="sg-column sg-type-text created-by-column">\n    ');
      
        __out.push(__sanitize(this.row.created_by_user));
      
        __out.push('\n  </div>\n  <div class="sg-column created-on-column">\n    ');
      
        formattedDate = this.dateFormatter(this.row.create_time * 1000);
      
        __out.push('\n    <div class="sg-type-text">');
      
        __out.push(__sanitize(formattedDate[0]));
      
        __out.push('</div>\n    <div class="sg-type-faded">');
      
        __out.push(__sanitize(formattedDate[1]));
      
        __out.push('</div>\n  </div>\n  <div class="sg-column sg-type-num groups-column">\n    ');
      
        __out.push(__sanitize(this.row.groups));
      
        __out.push('\n  </div>\n  <div class="sg-column sg-type-num users-column">\n    ');
      
        __out.push(__sanitize(this.row.users));
      
        __out.push('\n  </div>\n  <div class="sg-column sg-type-num databases-column">\n    ');
      
        __out.push(__sanitize(this.row.databases));
      
        __out.push('\n  </div>\n  <div class="sg-column sg-type-num rows-column">\n    ');
      
        __out.push(__sanitize(this.row.rows));
      
        __out.push('\n  </div>\n  <div class="sg-gear"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/site_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n  <div class="sg-row">\n    <div class="sg-column edit edit-name-column">\n      <input class="redesign-input edit-name" value="');
      
        __out.push(__sanitize(this.row.display_name));
      
        __out.push('"></input>\n    </div>\n    <div class="sg-column button-row">\n      <div class="button inert-medium cancel">Cancel</div>\n      <div class="button action-medium confirm">Save</div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/directory/user_directory_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column name-column">\n        <div class="sg-type-text user-name">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.display_name)));
      
        __out.push('</div>\n        <div class="sg-type-faded">');
      
        __out.push(__sanitize(this.row.email));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column sg-type-num spaces-column">');
      
        __out.push(__sanitize(this.row.site_count));
      
        __out.push('</div>\n    <div class="sg-column login-column">\n    ');
      
        formattedDate = this.dateFormatter(this.row.last_site_login);
      
        __out.push('\n        ');
      
        if (formattedDate != null) {
          __out.push('\n        <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n        <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        --\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column password-column">\n    ');
      
        formattedDate = this.dateFormatter(this.row.password_changed_at);
      
        __out.push('\n        ');
      
        if (formattedDate != null) {
          __out.push('\n        <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n        <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        --\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column tfa-column sg-type-bool" checked="');
      
        __out.push(__sanitize(this.row.is_tfa_active));
      
        __out.push('">\n        ');
      
        if (!this.row.is_tfa_active) {
          __out.push('--');
        }
      
        __out.push('\n    </div>\n    <div class="sg-gear"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/badge_toggle_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.hasDetail) {
          __out.push('\n  <div class="section-header">Official Badge</div>\n  <div class="section-subheader badges-header">Display a badge to indicate that this item is vetted</div>\n');
        }
      
        __out.push('\n<div class="section-toggle">\n  <div class="toggles-area badge-settings-text"></div>\n  <div class="badge-settings-icon"></div>\n</div>\n\n<div class="section-separator"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/center_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.restrictDatabasesEnabled) {
          __out.push('\n  <div class=\'restricted-banner\'>\n    This database connection is restricted. Views, snippets, filters, and SQL\n    formatters cannot be referenced in this query.\n  </div>\n');
        }
      
        __out.push('\n<div class=\'editor-title\'>SQL</div>\n<div class="sql-box inner-box">\n');
      
        if (this.showRun) {
          __out.push('\n  <div class=\'run-box flex-fill-row\'>\n    <div class=\'run-box-gutter\'>\n      <div class=\'preview-limit-icon hidden\'></div>\n    </div>\n    <div class=\'flex-filler\'></div>\n      <div class="expandable">\n          <div class=\'button action-medium action\'>\n                <div class="run-query">\n                  run<div class="selection-label">selected</div> SQL</div>\n                <div class="expand">\n                    <div class="icon expando"></div>\n                </div>\n            </div>\n          <div class="options">\n            <div class="option cancel-query dinpro-medium-mirage hover-eastern-blue">\n                cancel query...\n            </div>\n            <div class="option download dinpro-medium-mirage hover-eastern-blue">\n                download<div class="selection-label">selected</div>...\n            </div>\n            ');
          if (this.sagemakerEnabled) {
            __out.push('\n                <div class="option sagemaker-export dinpro-medium-mirage hover-eastern-blue">\n                   sagemaker<div class="selection-label">selected</div>...\n                </div>\n            ');
          }
          __out.push('\n       </div>\n      </div>\n  </div>\n  <div class="sql-result"></div>\n');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/conditional_formatting_rules_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="rules-area"></div>\n<div class="mini-link subtle add-rule">Add Rule</div>\n<div class="mini-link move-delete-rules red-accent">Reorder &amp; Delete</div>\n<div class="mini-link back-to-rules">Back</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/confirm"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span class="warning-icon">Warning</span>\n</header>\n<section class="modal-content">\n    <div class="body normal-13-tuna-font">\n        Do you want to save your changes to this ');
      
        __out.push(__sanitize(this.itemClass));
      
        __out.push('?\n    </div>\n    <div class="button-row">\n        <div class="left-aligned-buttons">\n            <div class="button inert-medium dont-save">\n                <div class="label">DON\'T SAVE</div>\n            </div>\n        </div>\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/copy_to"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content">\n  <div class="input-copy-to-name">\n    <div class="title">Copy Chart As</div>\n    <input class="widget-title redesign-input">\n  </div>\n  <div class="title">Destination Dashboard</div>\n  <select class="dashboard-list"></select>\n</div>\n<div class="button-row">\n  <div class="right-aligned-buttons"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/csv_center_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'editor-title\'>CSV</div>\n<div class=\'csv-box inner-box\'>\n');
      
        if (this.item.filename != null) {
          __out.push('\n  <div class="file-container">\n    <div class=\'file-info flex-fill-row\'>\n      <span class=\'icon\'></span>\n      <span class=\'filename bold\'>');
          __out.push(__sanitize(this.item.filename));
          __out.push('</span>\n      <span class=\'rows normal-14-tuna-font\'>Rows: ');
          __out.push(__sanitize(this.item.getRowCount()));
          __out.push('</span>\n      <span class=\'columns normal-14-tuna-font\'>Columns: ');
          __out.push(__sanitize(this.item.getColumnCount()));
          __out.push('</span>\n      <span class=\'replace underlined-link flex-filler\'>Replace</span>\n    </div>\n  </div>\n');
        } else {
          __out.push('\n  <div class="file-container file-container-centered">\n    <div class="file-upload">\n      <input type="file" name="file" ></input>\n      <div class="message">Drag and drop to upload CSV or <label for="file">Browse</label></div>\n    </div>\n  </div>\n');
        }
      
        __out.push('\n<div class="sql-result"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/csvview_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="header-label">SETTINGS</div>\n\n');
      
        if (this.dragDropEnabled) {
          __out.push('\n  <div class=\'data-discovery-area\'></div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.autoArchiveEnabled) {
          __out.push('\n  <div class=\'auto-archive-area\'>\n    <div class="section-header">Auto Archive</div>\n    <div class=\'auto-archive-toggle-area\'></div>\n    <div class="section-separator"></div>\n  </div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.badgeToggleEnabled) {
          __out.push('\n  <div class=\'badge-toggle-area\'></div>\n');
        }
      
        __out.push('\n\n<div class=\'default-settings-area\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/data_bars_rules_frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="rules-area"></div>\n<div class="mini-link subtle add-rule">Add Rule</div>\n<div class="mini-link move-delete-rules red-accent">Delete</div>\n<div class="mini-link back-to-rules">Back</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/data_discovery_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'section-header\'>Data Discovery</div>\n\n<div class=\'section-subheader\'>Enable discovery users to chart and explore datasets.</div>\n\n<div class="form-container toggles-area"></div>\n\n<div class=\'section-separator\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/database_caching_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="info-grid">\n  <tr class="pick-cluster-row">\n    <td class="content">\n      <div class="redshift-picker-dropdown"></div>\n    </td>\n  </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/default_editor_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j, len, len1, ref, ref1, tagName, u;
      
        if (!this.hideMainHeader) {
          __out.push('\n  <div class=\'header-label\'>SETTINGS</div>\n');
        }
      
        __out.push('\n\n<div class=\'section-header\'>Metadata</div>\n\n');
      
        if (this.isTaggable) {
          __out.push('\n<div class="form-container">\n  <div class="form-label">Tags</div>\n  <div class="tags-input">\n    <ul class="tags">\n      ');
          ref = this.tagNames;
          for (i = 0, len = ref.length; i < len; i++) {
            tagName = ref[i];
            __out.push('\n        <li>');
            __out.push(__sanitize(tagName));
            __out.push('</li>\n      ');
          }
          __out.push('\n    </ul>\n  </div>\n</div>\n');
        }
      
        __out.push('\n\n<div class="form-container">\n  <div class="form-label">Description</div>\n  <textarea placeholder="Enter ');
      
        __out.push(__sanitize(this.itemName));
      
        __out.push(' Description"\n  class="redesign-input desc wide" maxlength="');
      
        __out.push(__sanitize(App.PeriscopeModel.DESCRIPTION_MAX_LENGTH));
      
        __out.push('"></textarea>\n</div>\n\n<div class="form-container">\n  <div class="form-label">Owner</div>\n  <select class="owner">\n    ');
      
        ref1 = this.dashboardOwners;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          u = ref1[j];
          __out.push('\n      ');
          if (!AppRedesign.current().state.RbacEnabled) {
            __out.push('\n        <option value=');
            __out.push(__sanitize(u.id));
            __out.push('>');
            __out.push(__sanitize("" + (u.displayName())));
            __out.push('</option>\n      ');
          } else {
            __out.push('\n        <option value=');
            __out.push(__sanitize(u.user_id));
            __out.push('>');
            __out.push(__sanitize("" + u.display_name));
            __out.push('</option>\n      ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n  </select>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/editor"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="editor-body flex-filler flex-fill-row chart-tooltip-boundary"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/editor_chart_pane"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="grid-boundary">\n  <div class="widget-container"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/editor_error"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="alert-flex-wrapper chart margin-top">\n    <div class="alert-sidebar"></div>\n    <div class="alert-scroll">\n        <div class="alert-icon"></div>\n        <div class="alert-body">\n            <div class="alert-reference"></div>\n            <div class="alert-message"></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/history/header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="history-header bold">');
      
        __out.push(__sanitize(this.header));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/history/history"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="chart-format">\n    <div class="header-label">HISTORY</div>\n    <div class="history-content">\n\n        <div class="results-area"></div>\n    </div>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/history/item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="history-item ');
      
        __out.push(__sanitize(this.cssClass));
      
        __out.push('" archived_id="');
      
        __out.push(__sanitize(this.archivedId));
      
        __out.push('">\n\t<div class="time">');
      
        __out.push(__sanitize(this.time));
      
        __out.push('</div>\n\t<div class="message">');
      
        __out.push(__sanitize(this.message));
      
        __out.push('</div>\n\t');
      
        if (!this.applyDisabled) {
          __out.push('\n\t  <div class="apply">Apply</div>\n\t');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/history/no_results"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="history-no-results-message heavy-15-manatee-font right-panel-instructions show">');
      
        __out.push(__sanitize(this.errorText));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/left_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="editron-left-panel-toggle"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/loading_message"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="message loading">\n  <div class="label-holder">\n    <div class="spinner"></div>\n    <div class="loading">');
      
        __out.push(__sanitize(this.text));
      
        __out.push('</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/message"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'message\'>\n');
      
        if (this.cssClass === 'loading') {
          __out.push('<span class="spinner"></span>');
        }
      
        __out.push('\n<span class=\'');
      
        __out.push(__sanitize(this.cssClass));
      
        __out.push('\'>');
      
        __out.push(__sanitize(this.msg));
      
        __out.push('\n</span></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/move_to"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content">\n  <div class="title">Destination Dashboard</div>\n  <select class="dashboard-list"></select>\n</div>\n<div class="button-row">\n  <div class="right-aligned-buttons"></div>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/preview_limit_tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'preview-limit-icon\'></div>\n<div><span class="bold">Preview Limit:</span> Preview Limit of ');
      
        __out.push(__sanitize(this.rows));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.rowTerm));
      
        __out.push(' is impacting the results of this query</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/preview_limit_tooltip_large_file_download"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'preview-limit-icon\'></div>\n<div>Data limited to ');
      
        __out.push(__sanitize(this.rows));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.rowTerm));
      
        __out.push('. Please <span class="bold">Download Data</span> for full result set.</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/right_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, tab;
      
        __out.push('<div class="body"></div>\n<div class="icons right-panel-icons">\n  ');
      
        ref = this.tabs;
        for (i = 0, len = ref.length; i < len; i++) {
          tab = ref[i];
          __out.push('\n    <div class="icon ');
          __out.push(__sanitize(tab.iconClass));
          __out.push('"\n    data-iconclass="');
          __out.push(__sanitize(tab.iconClass));
          __out.push('"\n    data-tooltip="');
          __out.push(__sanitize(tab.tooltipText));
          __out.push('">\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/run-box"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'run-box\'><div class=\'flex-filler\'></div><div class=\'button action-medium\'>run</div></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/schema_viewer/schema_browser_table"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var column, i, len, ref;
      
        __out.push('<div class="result table" table_name="');
      
        __out.push(__sanitize(this.fullName));
      
        __out.push('"');
      
        if (this.matchingCols) {
          __out.push(' matching_cols=');
          __out.push(__sanitize(this.matchingCols));
        }
      
        __out.push('>\n  <div class="name');
      
        if (this.shouldBoldName) {
          __out.push(' bold');
        }
      
        __out.push('">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</div>\n  <div class="description');
      
        if (this.openMatchingCols) {
          __out.push(' open-matching-cols');
        }
      
        __out.push('">\n    ');
      
        if (this.openMatchingCols) {
          __out.push('\n      ');
          ref = this.columns;
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            __out.push('\n        <div class="cell ');
            if (column.matches_query) {
              __out.push(' matching-col bold');
            } else {
              __out.push(' non-matching-col');
            }
            __out.push('">\n          <span class="sql-type" data-sql-type="');
            __out.push(__sanitize(App.Database.sqlTypeToSimpleType(column.sql_type)));
            __out.push('"></span>\n          <span ');
            if (this.clickableColumn) {
              __out.push('class="cell-name"');
            }
            __out.push('>\n            ');
            __out.push(__sanitize(column.name));
            __out.push('\n          </span>\n        </div>\n      ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/schema_viewer/schema_viewer"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var d, i, len, ref;
      
        if (!this.hideDbDropdown) {
          __out.push('\n  <div class="database-selector">\n    <select class="database-picker">\n    ');
          ref = this.sortedDatabases;
          for (i = 0, len = ref.length; i < len; i++) {
            d = ref[i];
            __out.push('\n    <option\n      ');
            if (d.warehouseSchemaEnabled()) {
              __out.push('\n        ');
              if (d.isByowDatabase()) {
                __out.push('\n          class=\'byow warehouse\'\n        ');
              } else {
                __out.push('\n          class=\'warehouse\'\n        ');
              }
              __out.push('\n      ');
            }
            __out.push('\n      ');
            if (d.activeRestriction()) {
              __out.push('class=\'restricted\'');
            }
            __out.push('\n      value=');
            __out.push(__sanitize(d.id));
            __out.push('>\n      ');
            __out.push(__sanitize(d.database_name));
            __out.push('\n    </option>\n    ');
          }
          __out.push('\n    </select>\n  </div>\n');
        }
      
        __out.push('\n<div class="search-area"><input placeholder="Search" class="redesign-input"></input></div>\n<div class="toggle-area-container">\n  <div class="toggle-description">Matching</div>\n  <div class="toggle-area"></div>\n</div>\n<div class="sql-language-header">\n  <div class="sql-language-header-chevron"></div>\n  <div class="sql-language-header-text">SQL</div>\n</div>\n<div class="results-area"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/schema_viewer/schema_viewer_no_results"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="no-results">\n  <span class=\'message\'>No results found.</span>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/schema_viewer/schema_viewer_view"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var column, i, len, ref;
      
        __out.push('<div class="result view" view_id="');
      
        __out.push(__sanitize(this.id));
      
        __out.push('"');
      
        if (this.matchingCols) {
          __out.push(' matching_cols=');
          __out.push(__sanitize(this.matchingCols));
        }
      
        __out.push('>\n  <div class="name');
      
        if (this.shouldBoldName) {
          __out.push(' bold');
        }
      
        __out.push('">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</div>\n  <div class="description');
      
        if (this.openMatchingCols) {
          __out.push(' open-matching-cols');
        }
      
        __out.push('">\n    ');
      
        if (this.openMatchingCols) {
          __out.push('\n      ');
          ref = this.columns;
          for (i = 0, len = ref.length; i < len; i++) {
            column = ref[i];
            __out.push('\n        <div class="cell ');
            if (column.matches_query) {
              __out.push(' matching-col bold');
            } else {
              __out.push(' non-matching-col');
            }
            __out.push('">\n          <span ');
            if (this.clickableColumn) {
              __out.push(' class="cell-name"');
            }
            __out.push('>\n            ');
            __out.push(__sanitize(column.name));
            __out.push('\n          </span>\n          <span class="sql-type" data-sql-type="');
            __out.push(__sanitize(App.Database.sqlTypeToSimpleType(column.sql_type)));
            __out.push('">\n            ');
            __out.push(__sanitize(App.Database.sqlTypeToSimpleType(column.sql_type)));
            __out.push('\n          </span>\n        </div>\n      ');
          }
          __out.push('\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/send_widget_to_slack"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content">\n  <div class="send-widget-to-slack-modal">\n    <div class="title">Recipient</div>\n    <input class="channel-name redesign-input" placeholder="Enter Slack #channel"></input>\n    <div class="title">Message</div>\n    <textarea placeholder="Customize your message here. Be sure to /invite @sisense to ensure the message is delivered."\n  class="redesign-input slack-message wide" style="height:60px;" maxlength=256></textarea>\n  </div>\n</div>\n<div class="button-row">\n  <div class="right-aligned-buttons"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/source_view"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'tab-list\'>\n<span class=\'tab selected\' data-name=\'chart\'>chart</span>\n</div>\n<div class="bottom-box inner-box">\n  <div class="error-message normal-13-manatee-font">Query returned no matching rows.</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/spinner"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="spinner-container center-spinner">\n  <div class="new-spinner-with-label-gray-bg">\n    <div class="new-spinner"></div>\n      <div class="new-text-below-spinner">Loading</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sql_alert_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, op, ref;
      
        __out.push('<div class=\'header-label\'>ALERT SETTINGS</div>\n\n<div class="form-container">\n  <div class="alert-toggle"></div>\n</div>\n\n<hr class="section-separator" />\n\n<div class="form-container">\n  <div class="section-header">Condition</div>\n  <div class="trigger-label form-label">Criteria</div>\n  <select class="alert-trigger-operation">\n  ');
      
        ref = this.operators;
        for (i = 0, len = ref.length; i < len; i++) {
          op = ref[i];
          __out.push('\n    <option value=');
          __out.push(__sanitize(op.value));
          __out.push('>');
          __out.push(__sanitize(op.name));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n  </select>\n  <input class="redesign-input alert-trigger-value" type="text" value=');
      
        __out.push(__sanitize(this.default_comparator_value));
      
        __out.push('>\n</div>\n\n<div class="form-container query-errors">\n  <div class="form-label">Query Errors</div>\n  <div class="query-errors-checkbox-area"></div>\n  <div class="query-errors-container">\n    <span class="query-errors-max-errors-text">Max ignored errors</span>\n    <span class="query-errors-input-span">\n      <input class="redesign-input query-errors-input" type="text"></input>\n    </span>\n  </div>\n</div>\n\n<hr class="section-separator" />\n\n<div class="form-container">\n  <div class="section-header">Notification</div>\n  <div class="frequency-option"></div>\n  <div class="frequency-setting"></div>\n</div>\n\n\n<div class="form-container">\n  <div class="form-label">Email</div>\n  <input class="redesign-input email wide" type="text"></input>\n</div>\n\n<hr class="section-separator" />\n\n');
      
        if (this.badgeToggleEnabled) {
          __out.push('\n  <div class=\'badge-toggle-area\'></div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sql_alert_settings_interval"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, int, len, ref;
      
        __out.push('<span>\n  <select class="interval">\n  ');
      
        ref = this.intervals;
        for (i = 0, len = ref.length; i < len; i++) {
          int = ref[i];
          __out.push('\n    <option value=');
          __out.push(__sanitize(int.value));
          __out.push('>');
          __out.push(__sanitize(int.name));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n  </select>\n</span>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sql_alert_settings_schedule"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var h, i, j, len, len1, m, ref, ref1;
      
        __out.push('<div>\n  <select class="schedule-hour">\n  ');
      
        ref = this.hours;
        for (i = 0, len = ref.length; i < len; i++) {
          h = ref[i];
          __out.push('\n    <option value=');
          __out.push(__sanitize(h.value));
          __out.push('>');
          __out.push(__sanitize(h.name));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n  </select>\n  <select class="schedule-minute">\n  ');
      
        ref1 = this.minutes;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          m = ref1[j];
          __out.push('\n    <option value=');
          __out.push(__sanitize(m.value));
          __out.push('>');
          __out.push(__sanitize(m.name));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n  </select>\n  <div class="utc">UTC</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sql_limit_checkbox"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'checkbox-area\'></div><input class=\'redesign-input\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sql_snippet_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="header-label">SETTINGS</div>\n\n');
      
        if (this.badgeToggleEnabled) {
          __out.push('\n  <div class=\'badge-toggle-area\'></div>\n');
        }
      
        __out.push('\n\n<div class=\'default-settings-area\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/sqlview_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="header-label">SETTINGS</div>\n\n');
      
        if (this.viewMaterializationEnabled) {
          __out.push('\n  <div class=\'view-materialization-area\'></div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.viewScheduleEnabled) {
          __out.push('\n  <div class=\'view-schedule-area\'></div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.dragDropEnabled) {
          __out.push('\n  <div class=\'data-discovery-area\'></div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.autoArchiveEnabled) {
          __out.push('\n  <div class=\'auto-archive-area\'>\n    <div class="section-header">Auto Archive</div>\n    <div class="section-subheader">Automatically archive unused views.</div>\n    <div class=\'auto-archive-toggle-area\'></div>\n    <div class="section-separator"></div>\n  </div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.badgeToggleEnabled) {
          __out.push('\n  <div class=\'badge-toggle-area\'></div>\n');
        }
      
        __out.push('\n\n<div class=\'default-settings-area\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/starred_item_header_controller"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (!this.isWidget && this.dashboardOrganizationEnabled) {
          __out.push('\n  <div class="text-icon-container">\n    <div class="text-icon-root" ></div>\n  <div>\n');
        }
      
        __out.push('\n<div class="header-description ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push(' ');
      
        if (this.isWidget) {
          __out.push('is-widget');
        }
      
        __out.push('">\n    ');
      
        if (this.spaceName != null) {
          __out.push('\n        <div class="space-name heavy-13-eastern-blue-font">');
          __out.push(__sanitize(this.spaceName));
          __out.push('</div> /\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.isArchivedView) {
          __out.push('\n        archived\n    ');
        } else if (this.item.isNew()) {
          __out.push('\n        new\n    ');
        } else {
          __out.push('\n        edit\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.item.is_exploration) {
          __out.push('\n        Exploration\n    ');
        } else {
          __out.push('\n        ');
          __out.push(__sanitize(this.item.constructor.PRETTY_CLASS_NAME));
          __out.push('\n    ');
        }
      
        __out.push('\n</div>\n<div class="header-content">\n    <div class="left-controls ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push(' ');
      
        if (this.isWidget) {
          __out.push('is-widget');
        }
      
        __out.push('">\n        <div class="title-wrapper ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n            <input type="text" class="header-title" ');
      
        if (this.titleDisabled) {
          __out.push(' disabled=disabled ');
        }
      
        __out.push(' ');
      
        if (this.titlePlaceholder) {
          __out.push('placeholder="');
          __out.push(__sanitize(this.titlePlaceholder));
          __out.push('"');
        }
      
        __out.push(' >\n            <span class="errors warning-icon"></span>\n        </div>\n        <div class="header-icons ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n            <div class="badge header-icon ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push(' badge-hidden" ></div>\n            ');
      
        if (this.info) {
          __out.push('\n                <div class="info header-icon ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push(' ');
          if (this.item.status() != null) {
            __out.push('status-');
            __out.push(__sanitize(this.item.status()));
            __out.push(' ');
          }
          __out.push(' ');
          if (this.item.constructor === App.CsvView && this.item.isNew()) {
            __out.push('new-csv');
          }
          __out.push('"></div>\n            ');
        }
      
        __out.push('\n            ');
      
        if (!this.showAddToTopicIcon) {
          __out.push('\n                ');
          if (!(this.item instanceof App.Widget)) {
            __out.push('\n                  <div class="star ');
            if (this.dashboardOrganizationEnabled) {
              __out.push('longer');
            }
            __out.push(' header-icon"></div>\n                ');
          }
          __out.push('\n                ');
          if (this.showRefreshButton) {
            __out.push('\n                    <div class="refresh dashboard header-icon ');
            if (this.dashboardOrganizationEnabled) {
              __out.push('longer');
            }
            __out.push('"></div>\n                ');
          }
          __out.push('\n            ');
        }
      
        __out.push('\n            ');
      
        if (this.isArchivedView) {
          __out.push('\n                <div class=\'archived-icon ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('\'>\n                    Archived\n                </div>\n            ');
        }
      
        __out.push('\n        </div>\n    </div>\n    <div class="right-controls starred-item ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push('">\n        ');
      
        if (this.showAddToTopicIcon) {
          __out.push('\n            <div class="header-icons ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push('">\n                ');
          if (this.showRefreshButton) {
            __out.push('\n                    <div class="refresh manual dashboard header-icon ');
            if (this.dashboardOrganizationEnabled) {
              __out.push('longer');
            }
            __out.push('"></div>\n                ');
          }
          __out.push('\n                ');
          if (!(this.item instanceof App.Widget)) {
            __out.push('\n                  <div class="star ');
            if (this.dashboardOrganizationEnabled) {
              __out.push('longer');
            }
            __out.push(' header-icon"></div>\n                ');
          }
          __out.push('\n                <div class="add-to-topic ');
          if (this.dashboardOrganizationEnabled) {
            __out.push('longer');
          }
          __out.push(' header-icon" data-tooltip="Add to Topics"></div>\n            </div>\n        ');
        }
      
        __out.push('\n        <div class="button-area ');
      
        if (this.dashboardOrganizationEnabled) {
          __out.push('longer');
        }
      
        __out.push(' ');
      
        if (this.isWidget) {
          __out.push('is-widget');
        }
      
        __out.push('"></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/view_materialization_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="section-header">View Materialization</div>\n\n<div class="section-subheader">Enable faster queries by materializing this view as a table on the Sisense Cache.</div>\n\n<div class="form-container toggles-area"></div>\n\n<div class="section-separator"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/view_schedule"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'section-header\'>View Materialization</div>\n<div class=\'section-subheader\'>Enable faster queries by materializing this view as a table.</div>\n<div class=\'schedule-area\'></div>\n<div class=\'section-separator\'></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/advanced_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="advanced-settings subheader-1 rotator" data-subsection-name="');
      
        __out.push(__sanitize(this.subsectionName));
      
        __out.push('">\n  <div class="rotator-title bold">Advanced</div>\n  <div class="content-area indented">\n    <div class="subheader-2 csv-setting">\n      <div>CSV</div>\n      <div class="content-area">\n        <div class="csv-checkbox"></div>\n        <textarea readonly class="redesign-input full-width-input csv-textarea"></textarea>\n      </div>\n    </div>\n    <div class="subheader-2 chart-description">\n      <div>Chart Description</div>\n      <div class="content-area">\n        <textarea class="redesign-input full-width-input" placeholder="Enter chart description"></textarea>\n      </div>\n    </div>\n    <div class="subheader-2 annotation-groups">\n      <div>Annotation Groups</div>\n      <div class="content-area">\n        <select class="full-width-input annotation-group-dropdown" multiple="multiple"></select>\n      </div>\n    </div>\n    <div class="subheader-2 drilldowns">\n      <div>Drilldowns</div>\n      <div class="content-area">\n      </div>\n    </div>\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/axes_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="axes-settings subheader-1 rotator" data-subsection-name="');
      
        __out.push(__sanitize(this.subsectionName));
      
        __out.push('">\n  <div class="rotator-title bold">Axes</div>\n  <div class="content-area indented">\n    <div class="subheader-2 rotator">\n      <div class="rotator-title">Format</div>\n      <div class="content-area">\n        <div class="format-dropdown-area">\n          <select class="format-dropdown">\n            <option value="number">Number</option>\n            <option value="percent">Percent</option>\n            <option value="dollar">Currency</option>\n          </select>\n        </div>\n        <div class="currency-dropdown-area">\n          <select class="currency-dropdown">\n            <option value="dollar">$ Dollar</option>\n            <option value="euro">€ Euro</option>\n            <option value="pound">£ Pound</option>\n            <option value="won">₩ Won</option>\n            <option value="rupee">₹ Rupee</option>\n            <option value="SEK">kr Krona</option>\n            <option value="TRY">₺ Lira</option>\n          </select>\n        </div>\n      </div>\n    </div>\n\n    <div class="subheader-2 rotator">\n      <div class="rotator-title">X Axis</div>\n      <div class="content-area">\n        <input class="full-width-input redesign-input x-axis-title" placeholder="Axis Title"></input>\n        <div class="x-min-max-row">\n          <input class="redesign-input short-input last-input x-min" placeholder="Min" ></input>\n          <span class="dash">-</span>\n          <input class="redesign-input short-input x-max" placeholder="Max"></input>\n        </div>\n        <div class="checkboxes"></div>\n      </div>\n    </div>\n    <div class="subheader-2 rotator y-section closed">\n      <div class="rotator-title">Y Axis</div>\n      <div class="content-area">\n        <input class="full-width-input redesign-input y-axis-title" placeholder="Axis Title"></input>\n        <div class="y-min-max-interval-row last-input-row">\n          <input class="redesign-input short-input y-min" placeholder="Min" ></input>\n          <span class="dash">-</span>\n          <input class="redesign-input short-input y-max" placeholder="Max"></input>\n          <input class="redesign-input short-input right-input y-interval" placeholder="Interval"></input>\n        </div>\n      </div>\n    </div>\n    <div class="subheader-2 rotator y2-section closed">\n      <div class="rotator-title">Y2 Axis</div>\n      <div class="content-area">\n        <input class="full-width-input redesign-input y2-axis-title" placeholder="Axis Title"></input>\n        <input class="redesign-input short-input last-input y2-min" placeholder="Min" ></input>\n        <span class="dash">-</span>\n        <input class="redesign-input short-input y2-max" placeholder="Max"></input>\n        <input class="redesign-input short-input right-input y2-interval" placeholder="Interval"</input>\n      </div>\n    </div>\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/chart_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var chartType, i, len, ref;
      
        __out.push('<select class="chart-type-dropdown">\n  ');
      
        ref = this.chartTypes;
        for (i = 0, len = ref.length; i < len; i++) {
          chartType = ref[i];
          __out.push('\n  <option class=\'chart-type-');
          __out.push(__sanitize(chartType));
          __out.push('\' value="');
          __out.push(__sanitize(chartType));
          __out.push('" ');
          if (this.widget.chart_type === chartType) {
            __out.push('selected');
          }
          __out.push('>');
          __out.push(__sanitize(this.chartTypeDetails[chartType].display));
          __out.push('</option>\n  ');
        }
      
        __out.push('\n</select>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/chart_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="chart-format">\n  <div class="header-label">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n  <div class=\'settings-area\'>\n    <div class="chart-type-dropdown-area"></div>\n    <div class="main-content-area"></div>\n  </div>\n  <div class="heavy-15-manatee-font right-panel-instructions"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/cohort_series_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var field, i, len, ref;
      
        __out.push('<div class=\'field-settings cohort\'>\n  <div class=\'header-area\'>\n    <div class=\'fields bold\'>Fields</div>\n    <div class=\'cohort bold\'>Cohort</div>\n    <div class=\'pivot bold\'>Pivot</div>\n    <div class=\'data bold\'>Data</div>\n    <div class=\'detail bold\'>Detail</div>\n  </div>\n\n  ');
      
        ref = this.fields;
        for (i = 0, len = ref.length; i < len; i++) {
          field = ref[i];
          __out.push('\n    <div class=\'row\'>\n      <div class=\'field-name\'>');
          __out.push(__sanitize(field));
          __out.push('</div>\n      <div class="cohort" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n      <div class="pivot" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n      <div class="data" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n      <div class="detail" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n<div class="border-line"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/color_theme_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.color_themes_enabled) {
          __out.push('\n  <div class="subheader-1 rotator">\n    <div class="widget-color-container"></div>\n    <div class="rotator-title bold">');
          __out.push(__sanitize(this.title));
          __out.push('</div>\n    <div class="content-area indented content-container">\n      <div class="widget-color-themes-area">\n        <div class="body"></div>\n      </div>\n      ');
          if (this.userIsAdmin) {
            __out.push('\n        <span class="save-new-theme ');
            if (!this.isCustomTheme) {
              __out.push(__sanitize('disabled'));
            }
            __out.push('">Save...</span>\n      ');
          }
          __out.push('\n    </div>\n    <div class="border-line"></div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/conditional_formatting_rule"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="rule" rule_id="');
      
        __out.push(__sanitize(this.rule.id));
      
        __out.push('">\n  <div class="reorder-controls">\n    <div class="delete"></div>\n    <div class="description"></div>\n  </div>\n  <div class="conditional-dropdown"></div>\n  <input class="redesign-input" type="text"></input>\n  <div class="color-picker-area">\n      <div class="theme-color-picker-box none-selected large">\n        <div class="text-color" style="border-top-color: ');
      
        __out.push(__sanitize(this.rule.text_color));
      
        __out.push('"></div>\n        <div class="background-color" style="border-bottom-color: ');
      
        __out.push(__sanitize(this.rule.bg_color));
      
        __out.push('"></div>\n      </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/drilldown_option"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="mapping-row">\n  <div class="reorder-controls flex-fill-row">\n    <div class="description flex-filler">Here is the description</div>\n    <div class="delete"></div>\n  </div>\n  <select class="column-select">\n    <option>Select column</option>\n  </select>\n  <div class="flex-filler"></div>\n  <select class="filter-select">\n    <option>Select filter</option>\n  </select>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/drilldown_section"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<select class="full-width-input drilldown-dropdown"></select>\n<div class="mapping-section">\n  <div class="mapping-list"></div>\n  <div>\n    <span class="mini-link add-mapping-link">Add Mapping</span>\n    <span class="mini-link red-accent delete-link">Delete</span>\n    <span class="mini-link red-accent done-delete-link">Back</span>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/field_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var field, i, len, ref;
      
        __out.push('<div class="field-settings ');
      
        __out.push(__sanitize(this.chartType));
      
        __out.push(' ');
      
        if (this.geoJson) {
          __out.push('geojson');
        }
      
        __out.push(' ');
      
        if (this.latLong) {
          __out.push('weight');
        }
      
        __out.push('">\n  <div class=\'header-area\'>\n    <div class=\'fields bold\'>Fields</div>\n    <div class=\'x-axis bold\'>');
      
        if (this.latLong) {
          __out.push('Lat.');
        } else if (this.geoJson) {
          __out.push('GeoJSON');
        } else {
          __out.push('X Axis');
        }
      
        __out.push('</div>\n    ');
      
        if (!this.geoJson) {
          __out.push('<div class=\'y-axis bold\'>');
          if (this.latLong) {
            __out.push('Long.');
          } else {
            __out.push('Y Axis');
          }
          __out.push('</div>');
        }
      
        __out.push('\n    ');
      
        if (this.zAxisEnabled) {
          __out.push('<div class=\'z-axis bold\'>Z Axis</div>');
        }
      
        __out.push('\n    ');
      
        if (this.latLong) {
          __out.push('<div class=\'weight bold\'>Weight</div>');
        }
      
        __out.push('\n    <div class=\'series bold\'>Series</div>\n  </div>\n\n  ');
      
        ref = this.fields;
        for (i = 0, len = ref.length; i < len; i++) {
          field = ref[i];
          __out.push('\n    <div class=\'row\'>\n      <div class=\'field-name\'>');
          __out.push(__sanitize(field));
          __out.push('</div>\n      <div class="x-axis" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n      ');
          if (!this.geoJson) {
            __out.push('<div class="y-axis" data-field-name="');
            __out.push(__sanitize(field));
            __out.push('"></div>');
          }
          __out.push('\n      ');
          if (this.zAxisEnabled) {
            __out.push('<div class="z-axis" data-field-name="');
            __out.push(__sanitize(field));
            __out.push('"></div>');
          }
          __out.push('\n      ');
          if (this.latLong) {
            __out.push('<div class="weight" data-field-name="');
            __out.push(__sanitize(field));
            __out.push('"></div>');
          }
          __out.push('\n      <div class="series" data-field-name="');
          __out.push(__sanitize(field));
          __out.push('"></div>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n<div class="border-line"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/header_only_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="subheader-1 rotator">\n  <div class="rotator-title bold">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n  <div class="content-area indented"></div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/legend_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="legend-settings subheader-1 rotator" data-subsection-name="');
      
        __out.push(__sanitize(this.subsectionName));
      
        __out.push('">\n  <div class="rotator-title bold">Legend</div>\n  <div class="content-area indented">\n    <div class="legend-layout-settings">\n      <div class="subheader-2 legend-position position-option">\n        <div>Position</div>\n        <div class="content-area">\n          <div class="format-dropdown-area">\n            <select class="position-dropdown">\n              <option value="none">None</option>\n              <option value="right">Right</option>\n              <option value="bottom">Bottom</option>\n              <option value="top">Top</option>\n              <option value="left">Left</option>\n            </select>\n          </div>\n        </div>\n      </div>\n      <div class="subheader-2 legend-width width-option">\n        <div>Width</div>\n        <div class="content-area ">\n          <input class="redesign-input legend-width-input" placeholder="Auto"</input>\n        </div>\n      </div>\n    </div>\n    <div class="checkboxes"></div>\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/misc_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="misc-settings subheader-1 rotator">\n  <div class="rotator-title bold">Miscellaneous</div>\n  <div class="content-area indented">\n    <div class="checkboxes-area"></div>\n    <div class="max-series">\n      <span>Max Series</span>\n      <input class="redesign-input" type="text" value="');
      
        __out.push(__sanitize(this.default_max_series_value));
      
        __out.push('" </input>\n    </div>\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/no_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="heavy-15-manatee-font right-panel-instructions">');
      
        __out.push(__sanitize(this.errorText));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/number_overlay_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="number-overlay-settings subheader-1 rotator" data-subsection-name="');
      
        __out.push(__sanitize(this.subsectionName));
      
        __out.push('">\n  <div class="rotator-title bold">Number Overlay Settings</div>\n  <div class="content-area indented">\n    <div class="checkboxes"></div>\n    <div class="subheader-2 overlay-text-size text-size-option">\n      <div>Text Size</div>\n      <div class="content-area">\n        <div class="text-size-area">\n          <select class="text-size-dropdown">\n            <option value="autofit">Autofit</option>\n            <option value="xsmall">32</option>\n            <option value="small">48</option>\n            <option value="normal">72</option>\n            <option value="large">108</option>\n            <option value="xlarge">162</option>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/rolling_average"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="rolling-average">\n  <div class=\'trailing\'>\n    <span class="label">Trailing</span>\n    <input class="redesign-input" value="5">\n  </div>\n  <div class=\'leading\'>\n    <span class="label">Leading</span>\n    <input class="redesign-input" value="5">\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/series_header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="series-column-settings rotator subheader-1 ');
      
        if (this.closed) {
          __out.push('closed');
        }
      
        __out.push(' ');
      
        if (this.geomap) {
          __out.push('geomap');
        }
      
        __out.push('">\n  <div class="rotator-title bold">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n  <div class="content-area indented">\n    ');
      
        if (this.expandAll && !this.closed) {
          __out.push('\n      <div class=\'expand\'>\n        <span class="label-expand">Expand All</span>\n        <span class="label-collapse">Collapse All</span>\n      </div>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n<div class="border-line"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/specific_series"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="rotator-title bold">\n    <div class=\'title-color ');
      
        if (this.color == null) {
          __out.push('disabled %>');
        }
      
        __out.push('\'\n         style="background-color: ');
      
        __out.push(__sanitize((ref = this.color) != null ? ref : 'transparent'));
      
        __out.push('"></div>\n    <div class=\'column-name\'>');
      
        __out.push(__sanitize(this.columnName));
      
        __out.push('</div>\n</div>\n<div class="content-area indented"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/specific_series_content"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var chart_type, display_name, ref, ref1;
      
        __out.push('<div class="attributes" data-column="');
      
        __out.push(__sanitize(this.columnName));
      
        __out.push('">\n  <div class=\'series-color\'>\n    <div class="color-picker-area ');
      
        if (this.color == null) {
          __out.push('disabled %>');
        }
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize((ref = this.color) != null ? ref : 'transparent'));
      
        __out.push('"></div>\n    <div class=\'series-color-title\'>Series Color</div>\n  </div>\n\n  <div class=\'plot-y-axis\'>\n  </div>\n  ');
      
        if (!this.plotOnY2Disabled) {
          __out.push('\n    <div class=\'plot-y2-axis\'></div>\n  ');
        }
      
        __out.push('\n\n  ');
      
        if (!this.chartTypeHidden) {
          __out.push('\n  <div class=\'series-type\'>Series Type</div>\n    <div class="chart-type-dropdown-area">\n      <select class="chart-type-dropdown" ');
          if (this.chartTypeDisabled) {
            __out.push(__sanitize('disabled'));
          }
          __out.push('>\n        ');
          ref1 = this.chartTypes;
          for (chart_type in ref1) {
            display_name = ref1[chart_type];
            __out.push('\n        <option class="chart-type-');
            __out.push(__sanitize(chart_type));
            __out.push('" value=');
            __out.push(__sanitize(chart_type));
            __out.push('>');
            __out.push(__sanitize(display_name));
            __out.push('</option>\n        ');
          }
          __out.push('\n      </select>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/table_series_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var attrId, column, columnWidth, i, imageWidth, imgHeight, j, len, numDecimals, placeholderDecimals, ref, valueFormat;
      
        __out.push('<div class="table-series-settings subheader-1">\n  <div class="title bold">Series</div>\n  <div class=\'expand\'>\n    <span class="label-expand">Expand All</span>\n    <span class="label-collapse">Collapse All</span>\n  </div>\n  <div class="content-area">\n    ');
      
        ref = this.seriesNames();
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          column = ref[i];
          __out.push('\n    <div class="subheader-2 rotator ');
          if (!this.openRotators.includes(i)) {
            __out.push(__sanitize('closed'));
          }
          __out.push('">\n      <div class="rotator-title bold">');
          __out.push(__sanitize(column));
          __out.push('</div>\n      <div class="content-area indented">\n        <div class="attributes" data-column="');
          __out.push(__sanitize(column));
          __out.push('">\n          <span>Format</span>\n          <div class= \'format\'>\n            ');
          attrId = "value_format";
          __out.push('\n            <div class="input attribute value_format" attr_id="value_format" data_index="');
          __out.push(__sanitize(i));
          __out.push('" input_type="dropdown">\n              <select>\n                <option value="none">None</option>\n                <option value="number">Number</option>\n                <option value="percent">Percent</option>\n                ');
          if (this.chartTypeIsCohort && this.twiddlesActual.get('value_cols').includes(column)) {
            __out.push('\n                  <option value="cohort_percent_of_column">Percentage of Column</option>\n                  <option value="cohort_percent_of_row">Percentage of Row</option>\n                ');
          }
          __out.push('\n                <option value="currency">Currency</option>\n                <option value="image">Image</option>\n              </select>\n            </div>\n            ');
          attrId = "currency";
          __out.push('\n            <div class="input attribute currency" attr_id="currency" data_index="');
          __out.push(__sanitize(i));
          __out.push('" input_type="dropdown">\n              <select>\n                <option value="$">$ Dollar</option>\n                <option value="€">€ Euro</option>\n                <option value="£">£ Pound</option>\n                <option value="₩">₩ Won</option>\n                <option value="₹">₹ Rupee</option>\n                <option value="SEK">kr Krona</option>\n                <option value="₺">₺ Lira</option>\n              </select>\n            </div>\n          </div>\n          <div class=\'format-details\'>\n            ');
          attrId = "num_decimals";
          __out.push('\n              ');
          valueFormat = this.twiddlesActual.getForColumn(column, 'value_format');
          __out.push('\n              ');
          placeholderDecimals = App.ChartFormatters.DECIMAL_DEFAULTS[valueFormat] || 'Auto';
          __out.push('\n            ');
          if (!this.isFieldHidden(column, attrId)) {
            __out.push('\n              ');
            numDecimals = this.decimalsByIdx[i];
            __out.push('\n              <div class="input attribute num_decimals" attr_id="num_decimals" data_index="');
            __out.push(__sanitize(i));
            __out.push('" input_type="textbox">\n                <span>Decimals</span>\n                <input class=\'redesign-input\' type=\'text\'\n                      placeholder=\'');
            __out.push(__sanitize(placeholderDecimals));
            __out.push('\'\n                      value="');
            if (numDecimals != null) {
              __out.push(__sanitize(numDecimals));
            }
            __out.push('"\n                      ');
            if (this.isFieldDisabled(column, attrId)) {
              __out.push(__sanitize('disabled=true'));
            }
            __out.push('>\n              </div>\n            ');
          }
          __out.push('\n            ');
          attrId = "image_height";
          __out.push('\n            ');
          if (!this.isFieldHidden(column, attrId)) {
            __out.push('\n              ');
            imgHeight = this.imageHeightByIdx[i];
            __out.push('\n              <div class="input attribute image_height" attr_id="image_height" data_index="');
            __out.push(__sanitize(i));
            __out.push('" input_type="textbox">\n                <span>Height</span>\n                <input class=\'redesign-input textbox image_height\' type=\'text\'\n                      placeholder=\'Auto\'\n                      value="');
            if (imgHeight != null) {
              __out.push(__sanitize(imgHeight));
            }
            __out.push('">\n              </div>\n            ');
          }
          __out.push('\n            ');
          attrId = "column_width";
          __out.push('\n            ');
          if (!this.isFieldHidden(column, attrId)) {
            __out.push('\n              ');
            columnWidth = this.widthByIdx[i];
            __out.push('\n              <div class="input attribute column_width" attr_id="column_width" data_index="');
            __out.push(__sanitize(i));
            __out.push('" input_type="textbox">\n              <span>Width</span>\n                <input class="redesign-input textbox column_width" type=\'text\' placeholder=\'Auto\' value="');
            if (columnWidth != null) {
              __out.push(__sanitize(columnWidth));
            }
            __out.push('" >\n              </div>\n            ');
          }
          __out.push('\n\n            ');
          attrId = "image_width";
          __out.push('\n            ');
          if (!this.isFieldHidden(column, attrId)) {
            __out.push('\n              ');
            imageWidth = this.imageWidthByIdx[i];
            __out.push('\n              <div class="input attribute image_width" attr_id="image_width" data_index="');
            __out.push(__sanitize(i));
            __out.push('" input_type="textbox">\n              <span>Width</span>\n                <input class="redesign-input textbox image_width" type=\'text\' placeholder=\'Auto\' value="');
            if (imageWidth != null) {
              __out.push(__sanitize(imageWidth));
            }
            __out.push('" >\n              </div>\n            ');
          }
          __out.push('\n\n            ');
          attrId = "alignment";
          __out.push('\n            ');
          if (!this.isFieldHidden(column, attrId)) {
            __out.push('\n              ');
            if (!(this.chartTypeIsCohort && _.includes(this.singleCheckedPivotColumns, column))) {
              __out.push('\n              <div class="input attribute alignment" attr_id="alignment" data_index="');
              __out.push(__sanitize(i));
              __out.push('" input_type="dropdown">\n                <span>Alignment</span>\n                <select>\n                  <option value="left">Left</option>\n                  <option value="center">Center</option>\n                  <option value="right">Right</option>\n                </select>\n              </div>\n              ');
            }
            __out.push('\n            ');
          }
          __out.push('\n          </div>\n        </div>\n      </div>\n    </div>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/editors/widgets/tooltip_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="tooltip-settings subheader-1 rotator ');
      
        if (this.closed) {
          __out.push(' closed ');
        }
      
        __out.push('">\n  <div class="rotator-title bold">Tooltips</div>\n  <div class="content-area indented">\n    <div class="subheader-2 rotator">\n      <div class="rotator-title bold">Fields</div>\n      <div class="content-area fields indented"></div>\n    </div>\n    ');
      
        if (!this.noSegment) {
          __out.push('\n      <div class="subheader-2 rotator">\n        <div class="rotator-title bold">Series</div>\n        <div class="content-area series indented"></div>\n      </div>\n    ');
        }
      
        __out.push('\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/file_downloads/download_header"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="flex-filler"></div>\n<div class="header-container">\n  ');
      
        if (this.state.failed) {
          __out.push('\n    <div class="icon failed" ></div>\n  ');
        } else if (this.state.preparing) {
          __out.push('\n    <div class="icon" ></div>\n  ');
        } else if (this.state.ready) {
          __out.push('\n    <div class="icon ready" ></div>\n  ');
        }
      
        __out.push('\n  <div class="header-text">\n    <span class=\'normal-15-white-font\'>');
      
        __out.push(__sanitize(this.state.msg));
      
        __out.push('</span>\n  </div>\n</div>\n<div class="flex-filler"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/file_downloads/form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, item, len, ref;
      
        __out.push('<header class=\'modal-header-violet flex-fill-column\'></header>\n<table class=\'file-downloads-panel\'>\n');
      
        ref = this.items;
        for (i = 0, len = ref.length; i < len; i++) {
          item = ref[i];
          __out.push('\n\n  ');
          if (item.error) {
            __out.push('\n    <tr class="download-row error" id="');
            __out.push(__sanitize(item.cid));
            __out.push('" itemType="');
            __out.push(__sanitize(item.item_type));
            __out.push('"> \n  ');
          } else if (item.ready) {
            __out.push('\n    <tr class="download-row ready" id="');
            __out.push(__sanitize(item.cid));
            __out.push('" itemType="');
            __out.push(__sanitize(item.item_type));
            __out.push('"> \n  ');
          } else {
            __out.push('\n    <tr class="download-row loading" id="');
            __out.push(__sanitize(item.cid));
            __out.push('" itemType="');
            __out.push(__sanitize(item.item_type));
            __out.push('">\n  ');
          }
          __out.push('\n    <td class="status-icon" data-tooltip="');
          __out.push(__sanitize(item.error));
          __out.push('"></td>\n    <td class="item normal-13-mirage-font"><div class=\'name-label\'>');
          __out.push(__sanitize(item.file_name));
          __out.push('</div></td>\n\n    ');
          if (item.ready) {
            __out.push('\n      ');
            if (item.item_type === "SqlViewDataExport") {
              __out.push('\n        <td class="open-link normal-13-mirage-font"><a href="');
              __out.push(__sanitize(item.data_destination));
              __out.push('" target="_blank" rel="nofollow noopener noreferrer">Open in SageMaker</a></td>\n      ');
            } else {
              __out.push('\n        <td class="download-icon"><a download="');
              __out.push(__sanitize(item.display_name));
              __out.push('" href="');
              __out.push(__sanitize(item.data_destination));
              __out.push('"></a></td>\n      ');
            }
            __out.push('\n    ');
          } else {
            __out.push('\n        <td class="started-at normal-12-scarpa-flow-font">');
            if (item.error == null) {
              __out.push(__sanitize(item.time_elapsed));
            }
            __out.push('</td>\n    ');
          }
          __out.push('\n\n    <td class="cancel-icon"></td>\n</tr>\n');
        }
      
        __out.push('\n</table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/file_downloads/panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'sticky-footer-panel\'>\n    <div class=\'sticky-footer-panel-inner modal file-downloads invisible\'>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/gradient_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div id="gradient-color-picker">\n  <canvas id="color-block" height="132" width="162"></canvas>\n  <canvas id="color-strip" height="132" width="12"></canvas>\n</div>\n<input class="redesign-input" autocomplete="off" id="hexColor" value="');
      
        __out.push(__sanitize(this.hexColor));
      
        __out.push('"></input>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/internal/database_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="left-panel">\n<div class="database-connect">\n  <table class="form">\n    <tr>\n        <td row="display_name">\n          <div>Display Name</div>\n          <input class="redesign-input" type="text" placeholder="prod_analytics" spellcheck="false"></input>\n        </td>\n        <td row="type">\n          <div>Database Type</div>\n          <select>\n            <option value="mysql">MySQL</option>\n            <option value="postgres">Postgres</option>\n            <option value="redshift">Redshift</option>\n            <option value="vertica">Vertica</option>\n            <option value="sql_server">SQL Server</option>\n            <option value="oracle">Oracle</option>\n            <option value="memsql">MemSQL</option>\n            <option value="sybase">Sybase</option>\n            <option value="exasol">Exasol</option>\n            <option value="bigquery">BigQuery</option>\n            <option value="snowflake">Snowflake</option>\n            <option value="presto">Presto</option>\n            ');
      
        if (this.salesforceEnabled && this.cacheEnabled) {
          __out.push('\n              <option value="SalesforceDatabase">Salesforce</option>\n            ');
        }
      
        __out.push('\n            <option value="QuboleDatabase">Qubole</option>\n            <option value="AthenaDatabase">Athena</option>\n            <option value="databricks">Databricks</option>\n          </select>\n        </td>\n    </tr>\n  </table>\n\n  <div id="specific-database-fields"></div>\n\n  <div class="ssh-tunnel private-network clickable">Connect to a Private Network</div>\n  <div class="ssh-tunnel help">\n    <form class="public-key" method="get" action="/periscope_id_rsa.pub">\n      <button class="clickable">Download Public Key</button>\n    </form>\n    <a class="ssh-tunnel-doc clickable" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">Do I need an SSH Tunnel?</a>\n    <a class="more-info clickable" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">More Info</a>\n  </div>\n</div>\n<div class="button-row">\n  <div class="db-loader"><div class="spinner"></div></div>\n  <div class="errors warning-icon">\n    <div class="error validation"></div>\n    <div class="error status-ok"></div>\n  </div>\n</div>\n</div>\n<div class="right-panel">\nEnter credentials to test a connection!\n<table class="conn-errors">\n<tr class="ssh-block status">\n    <td> Testing SSH Tunnel...</td>\n</tr>\n<tr>\n    <td id="ssh-tunnel-error" class="errors warning-icon"></td>\n</tr>\n<tr class="db-block status">\n    <td> Connecting To Database...</td>\n</tr>\n<tr>\n<td id="connection-error" class="errors warning-icon"></td>\n</tr>\n<tr>\n<td class="connection-debug-info ssl error-block"></td>\n</tr>\n<tr>\n<td class="connection-debug-info non-ssl error-block"></td>\n<tr>\n</table>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/data_table_ninja_cell"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var paddingLeft;
      
        paddingLeft = "";
      
        __out.push('\n');
      
        if (this.paddingLeft != null) {
          paddingLeft += "padding-left:" + this.paddingLeft + "px;";
        }
      
        __out.push('\n<div class="ninja-cell ');
      
        __out.push(__sanitize(this.cssClassName));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.borderClass));
      
        __out.push('"\n    style="width:');
      
        __out.push(__sanitize(this.width));
      
        __out.push(';position: absolute; left:');
      
        __out.push(__sanitize(this.left));
      
        __out.push(';top:');
      
        __out.push(__sanitize(this.top));
      
        __out.push('px;');
      
        __out.push(__sanitize(paddingLeft));
      
        __out.push('" row="');
      
        __out.push(__sanitize(this.row));
      
        __out.push('" column="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n    ');
      
        if (this.isLink) {
          __out.push('\n\t  <a href="');
          __out.push(this.fullValue);
          __out.push('" target="_blank" rel="nofollow noopener noreferrer">\n\t');
        }
      
        __out.push('\n\t');
      
        __out.push(this.val);
      
        __out.push('\n\t');
      
        if ((this.val == null) || this.val === '') {
          __out.push('\n\t\t<span style="visibility:hidden">.</span>\n\t');
        }
      
        __out.push('\n\t');
      
        if (this.isLink) {
          __out.push(' </a> ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/data_table_ninja_grid"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var header, headers, i, j, k, len, len1, level, ref;
      
        __out.push('<div class="ninja-grid">\n<div class="alignment" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n  ');
      
        ref = this.totalHeaders;
        for (level = j = 0, len = ref.length; j < len; level = ++j) {
          headers = ref[level];
          __out.push('\n    <div class="header-row ');
          if (this.sortingDisabled) {
            __out.push(__sanitize("no-sorting "));
          }
          __out.push(' ');
          if (level === this.totalHeaders.length - 1) {
            __out.push(__sanitize("last "));
          }
          __out.push('" style="width: ');
          __out.push(__sanitize(this.totalWidth));
          __out.push(';">\n    ');
          if (this.renderIndex) {
            __out.push('\n        <div class="ninja-header index right-border top-border bottom-border level1"\n           style="width: ');
            __out.push(__sanitize(this.indexWidth));
            __out.push(';color:transparent;">.</div>\n    ');
          }
          __out.push('\n      ');
          for (i = k = 0, len1 = headers.length; k < len1; i = ++k) {
            header = headers[i];
            __out.push('\n        <div class="ninja-header top-border bottom-border ');
            if (i !== headers.length - 1) {
              __out.push(' right-border ');
            }
            __out.push(' level1"\n        headerIndex="');
            __out.push(__sanitize(i));
            __out.push('"\n             style="width:');
            __out.push(__sanitize(header.width));
            __out.push(';">\n          ');
            __out.push(__sanitize(header.name));
            __out.push('\n          <div class="table-chart-sort-icon"></div>\n        </div>\n      ');
          }
          __out.push('\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="rows-wrapper" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n    <div class="no-rows-message">No matching rows.</div>\n    <div class="rows" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push('"></div>\n  </div>\n</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/full_data_table_ninja_cell"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var paddingLeft;
      
        paddingLeft = "";
      
        __out.push('\n');
      
        if (this.paddingLeft != null) {
          paddingLeft += "padding-left:" + this.paddingLeft + "px;";
        }
      
        __out.push('\n<div class="ninja-cell ');
      
        __out.push(__sanitize(this.cssClassName));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.borderClass));
      
        __out.push('"\n    style="width:');
      
        __out.push(__sanitize(this.width));
      
        __out.push(';height:');
      
        __out.push(__sanitize(this.height));
      
        __out.push(';position: absolute; left:');
      
        __out.push(__sanitize(this.left));
      
        __out.push(';top:');
      
        __out.push(__sanitize(this.top));
      
        __out.push(';');
      
        __out.push(__sanitize(paddingLeft));
      
        __out.push('" row="');
      
        __out.push(__sanitize(this.row));
      
        __out.push('" column="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n    ');
      
        if (this.isLink) {
          __out.push('\n\t  <a href="');
          __out.push(this.fullValue);
          __out.push('" target="_blank" rel="nofollow noopener noreferrer">\n\t');
        }
      
        __out.push('\n\t');
      
        __out.push(this.val);
      
        __out.push('\n\t');
      
        if ((this.val == null) || this.val === '') {
          __out.push('\n\t\t<span style="visibility:hidden">.</span>\n\t');
        }
      
        __out.push('\n\t');
      
        if (this.isLink) {
          __out.push(' </a> ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/full_data_table_ninja_grid"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var header, headers, i, j, k, len, len1, level, ref;
      
        __out.push('<div class="ninja-grid full-ninja-grid">\n<div class="alignment" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n  ');
      
        ref = this.totalHeaders;
        for (level = j = 0, len = ref.length; j < len; level = ++j) {
          headers = ref[level];
          __out.push('\n    <div class="header-row ');
          if (this.sortingDisabled) {
            __out.push(__sanitize("no-sorting "));
          }
          __out.push(' ');
          if (level === this.totalHeaders.length - 1) {
            __out.push(__sanitize("last "));
          }
          __out.push('" style="width: ');
          __out.push(__sanitize(this.totalWidth));
          __out.push(';">\n    ');
          if (this.renderIndex) {
            __out.push('\n        <div class="ninja-header index right-border top-border bottom-border level1"\n           style="width: ');
            __out.push(__sanitize(this.indexWidth));
            __out.push(';color:transparent;">.</div>\n    ');
          }
          __out.push('\n      ');
          for (i = k = 0, len1 = headers.length; k < len1; i = ++k) {
            header = headers[i];
            __out.push('\n        <div class="ninja-header top-border bottom-border ');
            if (i !== headers.length - 1) {
              __out.push(' right-border ');
            }
            __out.push(' level1"\n        headerIndex="');
            __out.push(__sanitize(i));
            __out.push('"\n             style="width:');
            __out.push(__sanitize(header.width));
            __out.push(';">\n          ');
            __out.push(__sanitize(header.name));
            __out.push('\n          <div class="table-chart-sort-icon"></div>\n        </div>\n      ');
          }
          __out.push('\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="rows-wrapper" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n    <div class="no-rows-message">No matching rows.</div>\n    <div class="rows" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push('"></div>\n  </div>\n</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/ninja_cell_column"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="ninja-cell ');
      
        __out.push(__sanitize(this.cssClassName));
      
        __out.push(' ');
      
        __out.push(__sanitize(this.borderClass));
      
        __out.push('"\n    style="height:');
      
        __out.push(__sanitize(this.height));
      
        __out.push('px;width:');
      
        __out.push(__sanitize(this.width));
      
        __out.push(';position: absolute; left:');
      
        __out.push(__sanitize(this.left));
      
        __out.push(';top:');
      
        __out.push(__sanitize(this.top));
      
        __out.push('px;');
      
        if (this.multiCohortXCol) {
          __out.push(' ');
          __out.push(__sanitize(this.headerColors));
          __out.push(' ');
        } else {
          __out.push(' ');
          __out.push(__sanitize(this.colors));
          __out.push(' ');
        }
      
        __out.push('" row="');
      
        __out.push(__sanitize(this.row));
      
        __out.push('" column="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n\t');
      
        if (this.nested) {
          __out.push('<span class="nest-arrow ');
          __out.push(__sanitize(this.arrowCss));
          __out.push('"></span>');
        }
      
        __out.push('\n\t');
      
        if (this.isImage) {
          __out.push('\n\t\t<img src="');
          __out.push(this.fullValue);
          __out.push('" vertical-align="middle" width = "');
          __out.push(__sanitize(this.imgWidth));
          __out.push('" height = "');
          __out.push(__sanitize(this.imgHeight));
          __out.push('">\n\t');
        } else {
          __out.push('\n\t\t');
          if (this.isLink) {
            __out.push('\n\t\t\t<a href="');
            __out.push(this.fullValue);
            __out.push('" target="_blank" rel="nofollow noopener noreferrer">\n\t\t');
          }
          __out.push('\n\t\t');
          __out.push(this.val);
          __out.push('\n\t\t');
          if ((this.val == null) || this.val === '') {
            __out.push('\n\t\t\t<span style="visibility:hidden">.</span>\n\t\t');
          }
          __out.push('\n\t\t');
          if (this.isLink) {
            __out.push('\n\t\t\t</a>\n\t\t');
          }
          __out.push('\n\t');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/ninja_cell_index"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="ninja-cell index right-border"\n    style="height:');
      
        __out.push(__sanitize(this.height));
      
        __out.push('px;width:');
      
        __out.push(__sanitize(this.width));
      
        __out.push(';position: absolute; left:');
      
        __out.push(__sanitize(this.left));
      
        __out.push(';top:');
      
        __out.push(__sanitize(this.top));
      
        __out.push('px; ');
      
        __out.push(__sanitize(this.colors));
      
        __out.push('" >\n\n\t');
      
        __out.push(this.val);
      
        __out.push('\n\t');
      
        if ((this.val == null) || this.val === '') {
          __out.push('\n\t\t<span style="visibility:hidden">.</span>\n\t');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/ninja_grid/ninja_grid"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var borderColor, borderColors, colors, header, headers, i, indexColor, j, k, leftBorderColor, len, len1, level, ref, sideBorderColors;
      
        colors = "";
      
        __out.push('\n');
      
        if (this.textColor != null) {
          colors += "color:" + this.textColor + ";";
        }
      
        __out.push('\n');
      
        if (this.bgColor != null) {
          colors += "background:" + this.bgColor + ";";
        }
      
        __out.push('\n<div class="ninja-grid ');
      
        __out.push(__sanitize(this.gridCssClass));
      
        __out.push(' no-scrolling-initially">\n');
      
        if (this.bgColor != null) {
          borderColor = App.ColorHelper.lightenOrDarken(this.bgColor, -50);
        }
      
        __out.push('\n');
      
        if (borderColor) {
          borderColors = "border-color:" + borderColor + ";";
        }
      
        __out.push('\n');
      
        if (borderColor) {
          leftBorderColor = "border-left-color:" + borderColor + ";";
        }
      
        __out.push('\n');
      
        if (borderColor) {
          sideBorderColors = "border-right-color:" + borderColor + ";";
        }
      
        __out.push('\n');
      
        if ((leftBorderColor != null) && !this.inCohortMode) {
          sideBorderColors += leftBorderColor;
        }
      
        __out.push('\n<div class="ninja-grid ');
      
        __out.push(__sanitize(this.gridCssClass));
      
        __out.push('">\n<div class="table-border" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';');
      
        if (this.inCohortMode) {
          __out.push(leftBorderColor);
        }
      
        __out.push(' ');
      
        __out.push(__sanitize(this.horizontalPositioning));
      
        __out.push('; height: calc(100% - 1px)"></div>\n<div class="alignment" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push('; ');
      
        __out.push(__sanitize(this.horizontalPositioning));
      
        __out.push('">\n  ');
      
        ref = this.totalHeaders;
        for (level = j = 0, len = ref.length; j < len; level = ++j) {
          headers = ref[level];
          __out.push('\n    <div class="header-row ');
          if (this.sortingDisabled) {
            __out.push(__sanitize("no-sorting "));
          }
          __out.push(' ');
          if (level === this.totalHeaders.length - 1) {
            __out.push(__sanitize("last "));
          }
          __out.push('"\n    style="width: ');
          __out.push(__sanitize(this.totalWidth));
          __out.push('; ');
          __out.push(__sanitize(sideBorderColors));
          __out.push(' ">\n      ');
          if (this.renderIndex) {
            __out.push('\n        ');
            indexColor = "color:transparent;";
            __out.push('\n        ');
            if (this.bgColor != null) {
              indexColor += "background:" + this.bgColor + ";";
            }
            __out.push('\n        <div class="ninja-header index\n              ');
            __out.push(__sanitize(this.firstClass));
            __out.push('\n              ');
            if (level === 0) {
              __out.push(' top-border ');
            }
            __out.push('\n            "\n           style="width: ');
            __out.push(__sanitize(this.indexWidth));
            __out.push('; ');
            __out.push(__sanitize(indexColor));
            __out.push('; ');
            __out.push(__sanitize(borderColors));
            __out.push('">.</div>\n      ');
          }
          __out.push('\n      ');
          for (i = k = 0, len1 = headers.length; k < len1; i = ++k) {
            header = headers[i];
            __out.push('\n        <div class="ninja-header ');
            __out.push(__sanitize(this.cssClassName));
            __out.push('\n          ');
            if (level === 0 && this.singleValHeader && i === 1) {
              __out.push('single-val-header');
            }
            __out.push('\n          ');
            if (level < this.numBlankHeaders && i === 0) {
              __out.push('no-header-color');
            }
            __out.push('\n          ');
            if (level < this.numBlankHeaders - 1 && i === 0) {
              __out.push('no-bottom-border');
            }
            __out.push('\n          ');
            if (level === 0 && !(this.inCohortMode && i === 0)) {
              __out.push(' top-border ');
            }
            __out.push('\n          ');
            if (this.firstBorder && i === 0) {
              __out.push(' ');
              __out.push(__sanitize(this.firstClass));
              __out.push(' ');
            }
            __out.push('\n          ');
            if (i !== headers.length - 1) {
              __out.push(' right-border ');
            }
            __out.push('\n        " headerIndex="');
            __out.push(__sanitize(i));
            __out.push('"\n             style="width:');
            __out.push(__sanitize(header.width));
            __out.push('; ');
            if (!(this.inCohortMode && i === 0)) {
              __out.push(colors);
            }
            __out.push('; ');
            __out.push(__sanitize(borderColors));
            __out.push(';">\n          ');
            __out.push(__sanitize(header.name));
            __out.push('\n          <div class="table-chart-sort-icon"></div>\n        </div>\n      ');
          }
          __out.push('\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="table-search-box hidden" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n    <div class="search-table table-icon"></div>\n    <input type="text" placeholder="Search" value="');
      
        __out.push(__sanitize(this.query));
      
        __out.push('"></input>\n    <div class="close table-icon"></div>\n  </div>\n  <div class="rows-wrapper" style="width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(';">\n    <div class="no-rows-message">No matching rows.</div>\n    <div class="rows" style="height: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push(' !important; width: ');
      
        __out.push(__sanitize(this.totalWidth));
      
        __out.push('"></div>\n  </div>\n</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/nps_survey_response/form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, score;
      
        __out.push('<div class=\'sticky-footer-panel\'>\n  <div class=\'sticky-footer-panel-inner modal\'>\n\n    <header class=\'modal-header-violet\'>\n      <span class=\'normal-15-white-font\'>Help us with your feedback</span>\n      <div class=\'cancel-icon\'></div>\n    </header>\n\n    <div class=\'nps-survey-response-form-panel\'>\n      <form class=\'nps-survey-response-form\'>\n        <div class=\'nps-survey-response-form-body\'>\n          <p class=\'normal-13-tuna-font\'>How likely are you to recommend this product to a colleague?</p>\n\n          <div class=\'nps-survey-response-form-scores\'>\n            <div class=\'nps-survey-response-form-score-ranking-text nps-survey-response-form-score-ranking-text-not-likely normal-12-scarpa-flow-font\'>Not Likely</div>\n            ');
      
        for (score = i = 1; i <= 10; score = ++i) {
          __out.push('\n              <input\n                id=\'nps-survey-response-score-');
          __out.push(__sanitize(score));
          __out.push('\'\n                type=\'radio\'\n                name=\'score\'\n                class=\'nps-survey-response-score-radio hidden\'\n                value=\'');
          __out.push(__sanitize(score));
          __out.push('\'\n                ');
          if (this.npsSurveyResponse.score === score) {
            __out.push('\n                  checked=\'checked\'\n                ');
          }
          __out.push('\n              />\n              <label\n                id=\'nps-survey-response-score-');
          __out.push(__sanitize(score));
          __out.push('-label\'\n                for=\'nps-survey-response-score-');
          __out.push(__sanitize(score));
          __out.push('\'\n                class=\'nps-survey-response-score-label heavy-12-mirage-font\'\n              >\n                ');
          __out.push(__sanitize(score));
          __out.push('\n              </label>\n\n            ');
        }
      
        __out.push('\n            <div class=\'nps-survey-response-form-score-ranking-text nps-survey-response-form-score-ranking-text-very-likely normal-12-scarpa-flow-font\'>Very Likely</div>\n          </div>\n\n          <div class=\'nps-survey-response-explanation-and-submit ');
      
        if (!this.npsSurveyResponse.hasResponded()) {
          __out.push(__sanitize("hidden"));
        }
      
        __out.push('\'>\n            <textarea\n              name=\'explanation\'\n              class=\'nps-survey-response-explanation redesign-input\'\n              placeholder=\'Help us by explaining your score\'\n              data-textarea-resize=true\n              data-textarea-resize-max-height=145\n            >');
      
        __out.push(__sanitize(this.npsSurveyResponse.explanation));
      
        __out.push('</textarea>\n\n            <footer class=\'nps-survey-response-form-footer\'>\n              <button class=\'button action-medium nps-survey-response-submit-button\'>\n                <span class=\'label\'>Submit</span>\n              </button>\n            </footer>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <div class=\'nps-survey-response-thank-you-panel hidden\'>\n      <h1 class=\'bold normal-13-mirage-font\'>Thank you! We appreciate your feedback.</h1>\n      <p class=\'nps-survey-response-thank-you-message normal-13-mirage-font\'>\n        We will use your honest insight to make<br/>\n        Sisense better for you and your team.\n      </p>\n    </div>\n\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/get_started"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="overlay-screenshot"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/invite_users"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="bulk-invite-users">\n  <div class="form-label">Email</div>\n  <div class="field-column">\n    <textarea \n      class="form-textarea emails redesign-input"\n      placeholder="Invite colleagues by adding their email addresses separated by commas."></textarea>\n    <div class="error"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/onboarding_pane"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="onboarding-header">\n    <div class="label">\n        ');
      
        __out.push(__sanitize(this.title));
      
        __out.push('\n        ');
      
        if (this.showTitleHelpIcon) {
          __out.push('\n        <div class="help-icon"></div>\n        ');
        }
      
        __out.push('\n    </div>\n</div>\n\n<div class="onboarding-body">\n    <div class="onboarding-body-content light-theme"></div>\n    <div class="onboarding-button-row">\n        <div class="preload-white-on-blue-gif"></div>\n            ');
      
        if (this.showSkip) {
          __out.push('\n                <span class="action-link skip">\n                    ');
          if (this.skipMessage != null) {
            __out.push('\n                        ');
            __out.push(__sanitize(this.skipMessage));
            __out.push('\n                    ');
          } else {
            __out.push('\n                        Skip\n                    ');
          }
          __out.push('\n                <div class="tooltip-panel">\n                  <div class="panel small-pointer showing">\n                    <div class="text">\n                        If you’re not ready to connect now, you can add your database later.\n                    </div>\n                    <div class="bottom pointer"></div>\n                  </div>\n                </div>\n                </span>\n            ');
        }
      
        __out.push('\n        <div class="button inert-large back">Back</div>\n        <div class="button inert-large cancel">Cancel</div>\n        <div tabindex="0" class="button legacy-action-large submit">');
      
        __out.push(__sanitize(this.submitLabel));
      
        __out.push('</div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/onboarding_wizard"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="onboarding-sidebar"></div>\n<div class="onboarding-main-column"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/onboarding_wizard_progress"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var dotClass, i, len, ref;
      
        ref = this.dotClasses;
        for (i = 0, len = ref.length; i < len; i++) {
          dotClass = ref[i];
          __out.push('\n  <div class="dot ');
          __out.push(__sanitize(dotClass));
          __out.push('"></div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_billing"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon credit-card"></div>\n  <div class="sidebar-title">\n    Buy Now\n  </div>\n  <div class="sidebar-blurb">\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div><br>\n    ');
      
        if (this.salesOwnerEmail) {
          __out.push('\n      <p class="help-header">For more details contact</p>\n      ');
          if (this.salesOwnerName) {
            __out.push('\n        ');
            __out.push(__sanitize(this.salesOwnerName));
            __out.push(' <br>\n      ');
          }
          __out.push('\n      <a class=\'contact-ae\'\n        target="_blank"\n        href="mailto:');
          __out.push(__sanitize(this.salesOwnerEmail));
          __out.push('"\n        rel="nofollow noopener noreferrer">\n        ');
          __out.push(__sanitize(this.salesOwnerEmail));
          __out.push('\n      </a>\n    ');
        } else {
          __out.push('\n      <p class="help-header">For assistance with the configuration of these settings, please contact </p>\n      <a class=\'contact-ae\'\n        target="_blank"\n        href="mailto:');
          __out.push(__sanitize(this.supportEmail));
          __out.push('"\n        rel="nofollow noopener noreferrer">\n        ');
          __out.push(__sanitize(this.supportEmail));
          __out.push('\n      </a>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_connect_db"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon database"></div>\n  <div class="sidebar-title">\n    Connect Database\n  </div>\n  <div class="sidebar-blurb">\n    <p>Connect your SQL database to begin visualizing data.</p>\n    <p>If your database is behind a firewall, whitelist our IPs: <br>107.23.195.228 and 54.236.224.46</p>\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div>\n    <p class="help-header">Need Help?</p>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/connecting-to-periscope-menu" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_create_account"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon briefcase"></div>\n  <div class="sidebar-title">\n    Create Account\n  </div>\n  <div class="sidebar-blurb">\n    <p>Run, visualize, and share analyses from billions of rows in seconds.</p>\n    ');
      
        if (!this.amazon_flow && this.is_trial) {
          __out.push('\n      <p>Try Sisense free for 7 days.</p>\n    ');
        }
      
        __out.push('\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div>\n    <p class="help-header">Need Help?</p>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_forgot_password"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon briefcase"></div>\n  <div class="sidebar-title">\n    Reset Password\n  </div>\n  <div class="sidebar-blurb">\n    <p>Set a new password for your account.</p>\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div>\n    <p class="help-header">Need Help?</p>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_get_started"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon chart"></div>\n  <div class="sidebar-title">\n    Get Started\n  </div>\n  <div class="sidebar-blurb">\n    <p>You\'re ready to begin using <br>Sisense for Cloud Data Teams!</p>\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div>\n    <p class="help-header">Need Help?</p>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_invite_users"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon profile"></div>\n  <div class="sidebar-title">\n    Invite Colleagues\n  </div>\n  <div class="sidebar-blurb">\n    <p>Everyone at your company can have access to charts and dashboards created with Sisense for Cloud Data Teams.</p>\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    <div class="separator"></div>\n    <p class="help-header">Need Help?</p>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/onboarding/sidebar_tfa"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sidebar-top">\n  <div class="sidebar-progress"></div>\n  <div class="sidebar-icon tfa"></div>\n  <div class="sidebar-title">\n    Two-Factor Authentication\n  </div>\n  <div class="sidebar-blurb">\n    <p>Your Site Administrator has enabled Two-Factor Authentication for your\n     account. Follow the instructions to complete setup.</p>\n  </div>\n</div>\n<div class="sidebar-bottom">\n  <div class="sidebar-help">\n    Need Help?<br>\n    <a target="_blank" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/two-factor" rel="nofollow noopener noreferrer">Read the Docs</a> or\n    <a class="contact-support" href="mailto:supportdt@sisense.com">Contact Support</a>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/overloaded_site"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="overloaded-site">\n  <div class="content">\n    <div class="loading-bar">\n      <span class="new-spinner loading"></span>\n    </div>\n    <div class="content-text">\n      The system is experiencing heavy activity.\n      Charts may take longer than anticipated to load.\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/confirm_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row confirm-row">\n        <div class="sg-column message reset-password">Are you sure you want to <span class=\'highlight\'>reset</span> this user\'s password?</div>\n        <div class="sg-column message reset-2fa">Are you sure you want to <span class=\'highlight\'>reset</span> 2FA for this user?</div>\n        <div class="sg-column message remove-user">Are you sure you want to <span class=\'highlight\'>remove</span> this user?</div>\n        <div class="sg-column message remove-group">Are you sure you want to <span class=\'highlight\'>remove</span> this group?</div>\n        <div class="sg-column message remove-dashboard">Are you sure you want to <span class=\'highlight\'>remove</span> this dashboard?</div>\n        <div class="sg-column message remove-site">Are you sure you want to <span class=\'highlight\'>remove</span> this space?</div>\n        <div class="sg-column message remove-user-no-access">All access rights have been unselected. Are you sure you want to <span class=\'highlight\'>remove</span> this user?</div>\n\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n            <div class="button destructive-medium confirm"><div class="label">');
      
        __out.push(__sanitize(this.buttonText));
      
        __out.push('</div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/dashboard_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n      <div class="name-text">');
      
        __out.push(__sanitize(this.row.name));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column sg-type-text owner-column">\n        ');
      
        __out.push(__sanitize(this.row.owner));
      
        __out.push('\n    </div>\n    <div class="sg-column sg-type-num groups-column">\n        ');
      
        __out.push(__sanitize(this.row.groups));
      
        __out.push('\n    </div>\n    <div class="sg-column sg-type-num users-column">\n        ');
      
        __out.push(__sanitize(this.row.users));
      
        __out.push('\n    </div>\n    <div class="sg-column sg-type-num shares-column">\n        ');
      
        __out.push(__sanitize(this.row.shares));
      
        __out.push('\n    </div>\n    <div class="sg-column create-time-column">\n        ');
      
        formattedDate = this.dateFormatter(this.row.create_time * 1000);
      
        __out.push('\n        <div class="sg-type-text">');
      
        __out.push(__sanitize(formattedDate[0]));
      
        __out.push('</div>\n        <div class="sg-type-faded">');
      
        __out.push(__sanitize(formattedDate[1]));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column sg-type-text seven-day-usage-column">\n            ');
      
        if (this.row.last_7_day_usage_hours > 1) {
          __out.push('\n            ');
          __out.push(__sanitize(Math.round(this.row.last_7_day_usage_hours) + ' hrs'));
          __out.push('\n            ');
        } else {
          __out.push('\n            ');
          __out.push(__sanitize(Math.round(this.row.last_7_day_usage_hours * 60) + ' mins'));
          __out.push('\n            ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-gear"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/dashboard_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row">\n        <div class="sg-column edit edit-name-column">\n            <input class=\'edit-name redesign-input\' value="');
      
        __out.push(__sanitize(this.row.name));
      
        __out.push('"></input>\n        </div>\n        <div class="sg-column edit edit-owner-column">\n            <select class="owner-select"></select>\n        </div>\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n            <div class="button action-medium confirm"><div class="label">Save</div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/dashboards_accessible_by"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, id, len, ref;
      
        __out.push('<div class="access-list">\n    <div class="sg-subheader">Access Via</div>\n    <div class="sg-subbody">\n        ');
      
        if (this.isOwnedByUser) {
          __out.push('\n        <div class="sg-subrow sg-type-faded">Dashboard Owner</div>\n        ');
        }
      
        __out.push('\n        ');
      
        ref = this.groupIds;
        for (i = 0, len = ref.length; i < len; i++) {
          id = ref[i];
          __out.push('\n        <div class="sg-subrow sg-type-faded">\n            ');
          __out.push(__sanitize(App.Group.find(id).name));
          __out.push('\n        </div>\n        ');
        }
      
        __out.push('\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/dashboards_for_groups_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize((ref = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox view ');
      
        if (this.row.can_view) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push(' ');
      
        if (this.row.can_view == null) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n            <div class="icon"></div>\n        </div>\n        <div class="checkbox edit ');
      
        if (this.row.can_edit) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push(' ');
      
        if (this.row.can_view == null) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('">\n            <div class="icon"></div>\n        </div>\n        <div class="name-text">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.dashboard_name)));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column sg-type-text access-column">\n        ');
      
        if (this.row.can_edit) {
          __out.push(' Edit ');
        } else if (this.row.can_view === false) {
          __out.push(' -- ');
        } else {
          __out.push(' View ');
        }
      
        __out.push('\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/dashboards_for_users_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-row">\n    <div class="sg-column name-column"><div class="dropdown-label"></div>\n    <div class="name-text dropdown">');
      
        __out.push(__sanitize(this.row.dashboard_name));
      
        __out.push('</div></div>\n    <div class="sg-column sg-type-text access-column">\n    ');
      
        if (this.row.can_edit) {
          __out.push(' Edit ');
        } else {
          __out.push(' View ');
        }
      
        __out.push(' \n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/grid_search"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="grid-search hide-add-area">\n    <tr>\n        <td class="handle-area">\n            <select class="category"></select>\n        </td>\n        <td class="search-area">\n            <input class="redesign-input" placeholder="">\n        </td>\n        <td class="add-area">\n            <div class="add-button button action-large fixed-width">\n                <div class="label"></div>\n            </div>\n        </td>\n    </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/group_add"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content">\n    <div class="title">Group Name</div>\n    <input class="group-name redesign-input" placeholder="Enter Group Name">\n    ');
      
        if (!this.directoryHelperView) {
          __out.push('\n      <div class="access-level title">Access</div>\n      <select class="access-level"></select>\n      <div class="error-row red-accent dinpro13"></div>\n    ');
        }
      
        __out.push('\n</div>\n<div class="button-row"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/group_permission_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column name-column">\n        <div class="name-text-with-globe group-name">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.name)));
      
        __out.push('</div>\n        <div class="globe');
      
        if (this.row.is_site_family_group) {
          __out.push(__sanitize(' show'));
        }
      
        __out.push('"></div>\n    </div>\n    <div class="sg-column can-edit-column">\n        <div class="sg-type-text">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.access_level)));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column created-by-column">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.created_by)));
      
        __out.push('</div>\n    <div class="sg-column created-on-column">\n        ');
      
        formattedDate = this.dateFormatter(this.row.created_on);
      
        __out.push('\n        ');
      
        if (formattedDate != null) {
          __out.push('\n        <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n        <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        <div class="sg-type-text">--</div>\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column sg-type-num users-column">');
      
        __out.push(__sanitize(this.row.users));
      
        __out.push('</div>\n    <div class="sg-column sg-type-num dashboards-column">');
      
        __out.push(__sanitize(this.row.dashboards));
      
        __out.push('</div>\n    <div class="sg-gear');
      
        if (this.row.admin) {
          __out.push(' hidden');
        }
      
        __out.push('"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/group_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row">\n        <div class="sg-column edit-group-name-column">\n            <input class="redesign-input" value="');
      
        __out.push(__sanitize(this.group.name));
      
        __out.push('" ');
      
        if (this.group.disabled) {
          __out.push(__sanitize(' disabled'));
        }
      
        __out.push('>\n        </div>\n        <select class="access-level"></select>\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n            <div class="button action-medium confirm"><div class="label">Save</div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/groups_for_dashboards_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox view\n            ');
      
        if (this.row.disabled) {
          __out.push(__sanitize('disabled'));
        }
      
        __out.push('\n            ');
      
        if (this.row.can_view) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push('">\n            <div class="icon"></div>\n        </div>\n        <div class="checkbox edit\n            <!-- TODO: uncomment when prod UI changes for the correct behavior ');
      
        if (this.row.disabled || this.row.can_edit_disabled === true) {
          __out.push(__sanitize('disabled'));
        }
      
        __out.push('-->\n            ');
      
        if (this.row.disabled) {
          __out.push(__sanitize('disabled'));
        }
      
        __out.push('\n            ');
      
        if (this.row.can_edit) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push('">\n            <div class="icon"></div>\n        </div>\n        <div class="name-text-with-globe">');
      
        __out.push(__sanitize(this.row.name));
      
        __out.push('</div>\n        <div class="globe');
      
        if (this.row.is_site_family_group) {
          __out.push(__sanitize(' show'));
        }
      
        __out.push('"></div>\n    </div>\n    <div class="sg-column sg-type-text access-column">\n        ');
      
        if (this.row.can_edit) {
          __out.push(' Edit ');
        } else if (this.row.can_view === false) {
          __out.push(' -- ');
        } else {
          __out.push(' View ');
        }
      
        __out.push('\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/groups_for_users_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="sg-row ');
      
        if (this.row.disable) {
          __out.push(__sanitize('sg-type-faded'));
        }
      
        __out.push('" obj_id="');
      
        __out.push(__sanitize((ref = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox');
      
        if (this.row.disable) {
          __out.push(__sanitize(' disabled'));
        }
      
        if (this.row.is_user_in_group == null) {
          __out.push(__sanitize(' hidden'));
        }
      
        if (this.row.is_user_in_group) {
          __out.push(__sanitize(' selected'));
        }
      
        __out.push('"><div class="icon"></div></div>\n        <div class="name-text-with-globe">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.group_name)));
      
        __out.push('</div>\n        <div class="globe');
      
        if (this.row.is_site_family_group) {
          __out.push(__sanitize(' show'));
        }
      
        __out.push('"></div>\n    </div>\n    <div class="sg-column sg-type-text edit-column">\n    ');
      
        __out.push(__sanitize(this.row.access_level));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/message_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row message-row">\n        <div class="sg-column errors warning-icon ');
      
        if (!this.error) {
          __out.push(__sanitize('hidden'));
        }
      
        __out.push('"></div>\n        <div class="sg-column message">');
      
        __out.push(__sanitize(this.message));
      
        __out.push('</div>\n        <div class="close-button"><div class="icon close"></div></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/permissions_subsection"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="section-header-outer">\n    <div class="search-div">\n        <div class="icon search-icon"></div>\n        <input class="search heavy-12-mirage-font" placeholder="');
      
        __out.push(__sanitize(this.headerName));
      
        __out.push('">\n    </div>\n    <div class="edit-icon"></div>\n</div>\n<div class="header-line"></div>\n<div class="section-body"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/simple_grid"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var column, i, j, len, len1, ref, ref1, subcolumn;
      
        __out.push('<div class="simple-grid">\n    <div class="sg-empty-text flex-fill-column ');
      
        if (this.emptyMessageType != null) {
          __out.push(__sanitize(this.emptyMessageType));
        }
      
        __out.push('">\n        <div class="flex-filler"></div>\n        <div class="text"></div>\n        <div class="flex-filler"></div>\n    </div>\n    <div class="sg-header">\n        ');
      
        ref = this.columns;
        for (i = 0, len = ref.length; i < len; i++) {
          column = ref[i];
          __out.push('\n            <div class="sg-header-column ');
          __out.push(__sanitize(column["class"]));
          __out.push(' ');
          if (column.sortOn) {
            __out.push(__sanitize('sortable'));
          }
          __out.push('">\n            <div class="header-label">');
          __out.push(__sanitize(column.label));
          __out.push('</div></div>\n        ');
        }
      
        __out.push('\n    </div>\n    ');
      
        if (this.subcolumns != null) {
          __out.push('\n    <div class="mini-title">\n        ');
          ref1 = this.subcolumns;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            subcolumn = ref1[j];
            __out.push('\n            ');
            this.hasSubCols = true;
            __out.push('\n            <div class="label">');
            __out.push(__sanitize(subcolumn.name));
            __out.push('</div>\n         ');
          }
          __out.push('\n    </div>\n    ');
        }
      
        __out.push('\n    <div class="sg-body ');
      
        if (this.hasSubCols) {
          __out.push('with-mini-title');
        }
      
        if (this.activeDisabled) {
          __out.push(' active-disabled');
        }
      
        __out.push('">\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/simple_grid_gear_menu"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-menu">\n    <div class="sg-menu-triangle-border"></div>\n    <div class="sg-menu-triangle"></div>\n    <div class="sg-menu-handle"></div>\n    <div class="sg-item-holder">\n        <div class="sg-item hover-eastern-blue"></div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/user_access_rights_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row">\n        <div class="sg-column message visible">\n            Access Rights: \n        </div>\n        <div class="sg-column edit-access-rights-column">\n            <div class="small-checkbox no-margin self-service-checkbox">\n                <div class="icon"></div>\n            </div>\n        </div>\n        <div class="sg-column message visible">\n            Dashboards\n        </div>\n        <div class="sg-column edit-access-rights-column">\n            <div class="small-checkbox no-margin workbooks-checkbox">\n                <div class="icon"></div>\n            </div>\n        </div>\n        <div class="sg-column message visible">\n            Workbooks \n        </div>\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n            <div class="button action-medium confirm"><div class="label">Save</div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/user_add"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, site;
      
        __out.push('<div class="content">\n    <div class="form-area">\n        <div class="input-box">\n            <div class="title normal-14-black-font">First Name</div>\n            <input class="first-name redesign-input" placeholder="Enter First Name"></div>\n        <div class="input-box">\n            <div class="title normal-14-black-font">Last Name</div>\n            <input class="last-name redesign-input" placeholder="Enter Last Name"></div>\n        <div class="input-box">\n            <div class="title normal-14-black-font">Email</div>\n            <input class="email redesign-input" placeholder="Enter Email"></div>\n        <div class="input-box sites-dropdown hidden-initially">\n            <div class="title normal-14-black-font">Spaces</div>\n            <select class="sites normal-13-black-font" multiple>\n                ');
      
        ref = this.sites;
        for (i = 0, len = ref.length; i < len; i++) {
          site = ref[i];
          __out.push('\n                <option value="');
          __out.push(__sanitize(site.id));
          __out.push('">');
          __out.push(__sanitize(site.display_name));
          __out.push('</option>\n                ');
        }
      
        __out.push('\n            </select>\n        </div>\n        ');
      
        if (this.hasSisenseDeployment && !this.showSites) {
          __out.push('\n            <div class="input-box">\n                <div class="title normal-14-black-font">Access</div>\n                <div class="platformAccessCheckboxes">\n                    <div class="edit-access-rights-column">\n                        ');
          if (this.allowRevokingWorkbooksAccess) {
            __out.push('\n                            <div class="small-checkbox workbooks-checkbox">\n                        ');
          } else {
            __out.push('\n                            <div class="small-checkbox disabled selected workbooks-checkbox">\n                        ');
          }
          __out.push('\n                            <div class="icon"></div>\n                        </div>\n                        <div class="message visible">\n                            Workbooks \n                        </div>\n                    </div>\n                    <div class="edit-access-rights-column">\n                        ');
          if (this.allowRevokingWorkbooksAccess) {
            __out.push('\n                            <div class="small-checkbox selected self-service-checkbox">\n                        ');
          } else {
            __out.push('\n                            <div class="small-checkbox self-service-checkbox">\n                        ');
          }
          __out.push('\n                            <div class="icon"></div>\n                        </div>\n                         <div class="message visible">\n                            Dashboards \n                        </div>\n                    </div>\n                </div>\n            </div>\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="error-row red-accent dinpro13"></div>\n</div>\n<div class="button-row"></div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/user_permission_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var formattedDate;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize(this.row[App.RedesignSimpleGridController.OBJECT_FIELD].cid));
      
        __out.push('">\n    <div class="sg-column name-column">\n        <div class="sg-type-text user-name">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.display_name)));
      
        __out.push('</div>\n        <div class="sg-type-faded">');
      
        __out.push(__sanitize(this.row.email));
      
        __out.push('</div>\n    </div>\n    <div class="sg-column sg-type-num groups-column">');
      
        __out.push(__sanitize(this.row.group_count));
      
        __out.push('</div>\n    ');
      
        if (this.customerUnificationEnabled) {
          __out.push('\n        <div class="sg-column access-column">\n            <div>');
          if (this.row.self_service_dashboards_access) {
            __out.push(__sanitize("Dashboards"));
          }
          __out.push('</div>\n            <div>');
          if (this.row.workbooks_access) {
            __out.push(__sanitize("Workbooks"));
          }
          __out.push('</div>\n        </div>\n    ');
        }
      
        __out.push('\n    <div class="sg-column sg-type-num dashboards-column">');
      
        __out.push(__sanitize(this.row.dashboard_count));
      
        __out.push('</div>\n    <div class="sg-column login-column">\n        ');
      
        formattedDate = this.dateFormatter(this.row.last_site_login);
      
        __out.push('\n        ');
      
        if (formattedDate != null) {
          __out.push('\n        <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n        <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        <div class="sg-type-text">--</div>\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column password-column">\n        ');
      
        formattedDate = this.dateFormatter(this.row.password_changed_at);
      
        __out.push('\n        ');
      
        if (formattedDate != null) {
          __out.push('\n        <div class="sg-type-text">');
          __out.push(__sanitize(formattedDate[0]));
          __out.push('</div>\n        <div class="sg-type-faded">');
          __out.push(__sanitize(formattedDate[1]));
          __out.push('</div>\n        ');
        } else {
          __out.push('\n        <div class="sg-type-text">--</div>\n        ');
        }
      
        __out.push('\n    </div>\n    <div class="sg-column tfa-column sg-type-bool" checked="');
      
        __out.push(__sanitize(this.row.is_tfa_active));
      
        __out.push('">\n        ');
      
        if (!this.row.is_tfa_active) {
          __out.push('--');
        }
      
        __out.push('\n    </div>\n    <div class="sg-gear"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/user_row_edit"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-overlay-row">\n    <div class="sg-row">\n        <div class="sg-column edit-first-name-column">\n            <input class="redesign-input" value="');
      
        __out.push(__sanitize(this.row.first_name));
      
        __out.push('">\n        </div>\n        <div class="sg-column edit-last-name-column">\n            <input class="redesign-input" value="');
      
        __out.push(__sanitize(this.row.last_name));
      
        __out.push('">\n        </div>\n        <div class="sg-column button-row">\n            <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n            <div class="button action-medium confirm"><div class="label">Save</div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/users_access_via"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, name, ref;
      
        __out.push('<div class="access-list">\n    <div class="sg-subheader">Access Via</div>\n    <div class="sg-subbody">\n        ');
      
        ref = this.groupNames;
        for (i = 0, len = ref.length; i < len; i++) {
          name = ref[i];
          __out.push('\n        <div class="sg-subrow sg-type-faded">\n            ');
          __out.push(__sanitize(name));
          __out.push('\n        </div>\n        ');
        }
      
        __out.push('\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/users_for_dashboards_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="sg-row" obj_id="');
      
        __out.push(__sanitize((ref = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column"><div class="dropdown-label"></div><div class="name-text">');
      
        __out.push(__sanitize(this.row['name']));
      
        __out.push('</div></div>\n    <div class="sg-column sg-type-text access-column">');
      
        __out.push(__sanitize(this.row['access']));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/permissions/users_for_groups_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref;
      
        __out.push('<div class="sg-row ');
      
        if (this.row.disable) {
          __out.push(__sanitize('sg-type-faded'));
        }
      
        __out.push('" obj_id="');
      
        __out.push(__sanitize((ref = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.id : void 0));
      
        __out.push('">\n    <div class="sg-column sg-type-text name-column">\n        <div class="checkbox ');
      
        if (this.row.is_user_in_group == null) {
          __out.push(__sanitize('hidden'));
        }
      
        if (this.row.is_user_in_group) {
          __out.push(__sanitize('selected'));
        }
      
        __out.push('"><div class="icon"></div></div>\n        <div class="name-text">');
      
        __out.push(__sanitize(this.stringFormatter(this.row.user_name)));
      
        __out.push('</div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/quality_check/dashboard-quality-check"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, ref, sqlAlert;
      
        __out.push('<div class="save-cancel-area">\n  <div class="button inert-small cancel-button">\n    <div class="label">Cancel</div>\n  </div>\n  <div class="button action-small save-button">\n      <div class="label">Save</div>\n  </div>\n</div>\n\n<div class="quality-check-container">\n  <div class="title normal-15-black-font">Ensure Dashboard Quality with SQL Alerts</div>\n  <div class="description normal-13-gun-powder-font">\n    Use SQL Alerts to check the quality of data behind this dashboard, and inform users when charts may be inaccurate. Email reports will not be sent out if the SQL Alert triggers.\n  </div>\n\n  <div class="quality-check-form">\n    <div class="form-element">\n      <select class="search-select" data-placeholder="Select a SQL Alert">\n        <option></option>\n        ');
      
        ref = this.sqlAlerts;
        for (i = 0, len = ref.length; i < len; i++) {
          sqlAlert = ref[i];
          __out.push('\n          <option value=');
          __out.push(__sanitize(sqlAlert.id));
          __out.push('>');
          __out.push(__sanitize("" + sqlAlert.name));
          __out.push('</option>\n        ');
        }
      
        __out.push('\n      </select>\n    </div>\n\n    <div class="form-element">\n      <div class="failed-message-toggler normal-13-black-font"></div>\n    </div>\n\n    <div class="form-element">\n      <textarea class="redesign-input failed-message-area" placeholder="Type your message here"></textarea>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/reload/reload_modal"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="reload-site-dialog">\n  <div class="content">\n    <div class="content-text">Recent changes to Sisense require this tab to reload. Click Reload to continue.</div>\n  </div>\n\n  <div class="button-row">\n    <div class="right-aligned-buttons">\n    <div class="button action-medium">\n        <div class="label">Reload</div>\n    </div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/set_password/set_password_form_sidebar_flow"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var department, i, len, ref;
      
        __out.push('<div class="onboarding-pane-set-password ');
      
        if (!this.forgetPassword) {
          __out.push(__sanitize("set-password"));
        }
      
        __out.push('">\n  <table class="form info-grid">\n    <tr>\n      <td>Email</td>\n      <td>\n        <div class="email">');
      
        __out.push(__sanitize(this.email));
      
        __out.push('</div>\n      </td>\n    </tr>\n    ');
      
        if (!this.forgetPassword) {
          __out.push('\n      <tr>\n        <td>First Name<span class="optional-tag">Optional</span></td>\n        <td class="first-name">\n          <input class="first-name" value=\'');
          __out.push(__sanitize(this.first_name));
          __out.push('\' autofocus maxlength="1000"></input>\n        </td>\n      </tr>\n      <tr>\n        <td>Last Name<span class="optional-tag">Optional</span></td>\n        <td class="last-name">\n          <input class="last-name" value=\'');
          __out.push(__sanitize(this.last_name));
          __out.push('\' autofocus maxlength="1000"></input>\n        </td>\n      </tr>\n      ');
          if (this.showDepartment) {
            __out.push('\n        <tr>\n          <td>Department<span class="optional-tag">Optional</span></td>\n          <td class="department">\n            <select class="department-picker" name="department" data-placeholder="Select your department">\n              <option></option>\n              ');
            ref = this.departments;
            for (i = 0, len = ref.length; i < len; i++) {
              department = ref[i];
              __out.push('\n                <option value="');
              __out.push(__sanitize(department));
              __out.push('" ');
              if (this.department === department) {
                __out.push(__sanitize("selected"));
              }
              __out.push('>\n                  ');
              __out.push(__sanitize(department));
              __out.push('\n                </option>\n              ');
            }
            __out.push('\n            </select>\n          </td>\n        </tr>\n      ');
          }
          __out.push('\n      <tr>\n        <td>Job Role<span class="optional-tag">Optional</span></td>\n        <td class="role">\n          <select class="role-picker" name="role">\n            ');
          if (!this.showDepartment) {
            __out.push('\n              ');
            if (!this.job_title) {
              __out.push('\n                <option value="" disabled selected>Select your role</option>\n              ');
            }
            __out.push('\n              <option value="C-Level Executive" ');
            if (this.job_title === "C-Level Executive") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>C-Level Executive</option>\n              <option value="Consultant" ');
            if (this.job_title === "Consultant") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Consultant</option>\n              <option value="Data Engineer" ');
            if (this.job_title === "Data Engineer") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Data Engineer</option>\n              <option value="Data Professional" ');
            if (this.job_title === "Data Professional") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Data Professional</option>\n              <option value="Marketing" ');
            if (this.job_title === "Marketing") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Marketing</option>\n              <option value="Product" ');
            if (this.job_title === "Product") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Product</option>\n              <option value="Software Engineer" ');
            if (this.job_title === "Software Engineer") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Software Engineer</option>\n              <option value="Customer Success" ');
            if (this.job_title === "Customer Success") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Customer Success</option>\n              <option value="Sales" ');
            if (this.job_title === "Sales") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Sales</option>\n              <option value="Operations" ');
            if (this.job_title === "Operations") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Operations</option>\n              <option value="Other" ');
            if (this.job_title === "Other") {
              __out.push(__sanitize("selected"));
            }
            __out.push('>Other</option>\n            ');
          }
          __out.push('\n          </select>\n        </td>\n      </tr>\n      <tr>\n        <td>Primary Use Case<span class="optional-tag">Optional</span></td>\n        <td>\n          <div class="react-root-use-case">\n          </div>\n        </td>\n      </tr>\n    ');
        }
      
        __out.push('\n    <tr>\n      <td>Password</td>\n      <td class="password"><input class="password" type="password" autofocus maxlength="1000"></input></td>\n    </tr>\n    <tr>\n      <td>Confirm Password</td>\n      <td class="confirm-password"><input class="confirm-password" type="password" maxlength="1000"></input></td>\n    </tr>\n    ');
      
        if (!this.forgotPassword) {
          __out.push('\n      <tr>\n        <td></td>\n        <td class="eula-footer">\n          <span class="eula checkbox">\n            <span tabindex="0" class="icon"></span>\n          </span>\n          <span class="statement-text">\n            I accept the <a tabindex="-1" target="_blank" rel="nofollow noopener noreferrer"\n                            href="https://pages.sisense.com/rs/601-OXE-081/images/Master-Subscription-Agreement.pdf">terms\n            &\n            conditions</a> and <a tabindex="-1" target="_blank" rel="nofollow noopener noreferrer"\n                                  href="https://www.sisense.com/legal/products-and-services/">privacy\n            policy.</a>\n          </span>\n        </td>\n      </tr>\n    ');
        }
      
        __out.push('\n    <tr>\n      <td></td>\n      <td class="error-row">\n        <div class="errors"></div>\n      </td>\n    </tr>\n  </table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/billing_security_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (AppRedesign.current().overageData != null) {
          __out.push('\n  <div class="panel upgrade">\n    <div class=\'upgrade-confirmation hidden\'>\n      <div class=\'upgrade-confirmation-contents\'>\n        <div class=\'confirmation-icon\'></div>\n        Thank you for Upgrading!\n      </div>\n    </div>\n    <div class="upgrade-area area">\n      <div class="area-header">Upgrade</div>\n      <div class="area-body"></div>\n    </div>\n  </div>\n');
        }
      
        __out.push('\n');
      
        if (this.billingEnabled) {
          __out.push('\n<div class="panel">\n  <div class="billing-area area">\n    <div class="area-body"></div>\n  </div>\n</div>\n');
        }
      
        __out.push('\n<div class="panel">\n  <div class="authentication-area area">\n    <div class="area-header">Authentication</div>\n    <div class="area-body"></div>\n    <div class="form two-factor-form"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/cache_row"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref, ref1, ref2;
      
        __out.push('<div class="sg-row" id="');
      
        __out.push(__sanitize((ref = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref.full_table_name : void 0));
      
        __out.push('" obj_id="');
      
        __out.push(__sanitize((ref1 = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref1.full_table_name : void 0));
      
        __out.push('" harvest_id="');
      
        __out.push(__sanitize((ref2 = this.row[App.RedesignSimpleGridController.OBJECT_FIELD]) != null ? ref2.id : void 0));
      
        __out.push('">\n  <div class="sg-column sg-type-text schema-name-column">');
      
        __out.push(__sanitize(this.row.schema_name));
      
        __out.push('</div>\n  <div class="sg-column sg-type-text table-name-column">');
      
        __out.push(__sanitize(this.row.table_name));
      
        __out.push('</div>\n  <div class="sg-column sg-right row-count-column">');
      
        __out.push(__sanitize(this.row.row_count));
      
        __out.push('</div>\n  <div class="sg-column sg-type-text status-column">\n    <div class=\'cache-status-icon-area ');
      
        __out.push(__sanitize("cache-status-" + this.row.status_class));
      
        __out.push('\'></div>\n    <div class="cache-status-text">');
      
        __out.push(__sanitize(this.row.status));
      
        __out.push('</div>\n  </div>\n  <div class="sg-reload"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/cache_strategy"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="section-body">\n  <div class="cache-info">\n    <div class="cache-body cache-strategy-body">\n\n      <div class="cache-strategy-block cache-strategy">\n        <div class="block-header">Caching Strategy<a href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/caching-strategies#caching-strategies" target="_blank" rel="nofollow noopener noreferrer"><div class="help-icon"></div></a></div>\n        <select class="cache-dropdown cache-strategy-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block unique-id-column">\n        <div class="block-header">Unique Id</div>\n        <select data-placeholder="Select Column" class="cache-dropdown unique-id-column-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block import-column">\n        <div class="block-header ingest-key-row">\n          <span class=\'ingest-key-text\'>Import Column</span>\n          <a href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/caching-strategies#import-columns" target="_blank" rel="nofollow noopener noreferrer"><div class="help-icon"></div></a>\n        </div>\n        <select data-placeholder="Select Column" class="cache-dropdown import-column-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block import-column-for-full-only-and-redshift">\n        <div class="block-header ingest-key-row">\n          <span class=\'ingest-key-text\'>Import Column</span>\n          <a href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/caching-strategies#import-columns" target="_blank" rel="nofollow noopener noreferrer"><div class="help-icon"></div></a>\n        </div>\n        <select data-placeholder="Select Column" class="cache-dropdown import-column-for-full-only-and-redshift-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block import-column-for-bounded-update">\n        <div class="block-header ingest-key-row">\n          <span class=\'ingest-key-text\'>Import Column</span>\n          <a href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/caching-strategies#import-columns" target="_blank" rel="nofollow noopener noreferrer"><div class="help-icon"></div></a>\n        </div>\n        <select data-placeholder="Select Column" class="cache-dropdown import-column-for-bounded-update-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block modified-date">\n          <div class="block-header">\n              <span>Modified Date</span>\n              <a href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/caching-strategies#import-columns" target="_blank" rel="nofollow noopener noreferrer"><div class="help-icon"></div></a>\n          </div>\n          <select data-placeholder="Select Column" class="cache-dropdown modified-date-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block modified-null">\n        <div class="cache-strategy-block created-date">\n          <div class="block-header">Created Date</div>\n          <select data-placeholder="Select Column" class="cache-dropdown created-date-dropdown"></select>\n        </div>\n      </div>\n\n      <div class="cache-strategy-block update-interval">\n        <div class="block-header">Update Interval</div>\n        <select class="cache-dropdown update-interval-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block diff-interval">\n        <div class="block-header">Update Interval</div>\n        <select class="cache-dropdown diff-interval-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block update-window">\n        <div class="block-header">Update Window</div>\n        <select class="cache-dropdown update-window-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block incremental-update-interval">\n        <div class="block-header">Incremental Update Interval</div>\n        <select class="cache-dropdown incremental-update-interval-dropdown"></select>\n      </div>\n\n      <div class="cache-strategy-block full-update">\n        <div class="block-header">Full Update</div>\n        <div class="radio-button interval">\n          <div class="icon"></div>\n          <div class="label">Interval</div>\n        </div>\n        <div class="radio-button schedule">\n          <div class="icon"></div>\n          <div class="label">Schedule</div>\n        </div>\n        <div class="full-update-settings full-update-interval">\n          <select class="cache-dropdown full-update-settings full-update-interval-dropdown"></select>\n        </div>\n        <div class=\'full-update-settings full-update-schedule\'>\n          <select class="cache-dropdown full-update-schedule-hour-dropdown"></select> : <select class="cache-dropdown full-update-schedule-min-dropdown"></select>\n          <span class=\'utc-info\'>UTC</span>\n        </div>\n      </div>\n\n      <div class="cache-strategy-block toggler-container">\n        <div class="toggler square"><div class="ball ');
      
        if (this.suspendCaching) {
          __out.push('on');
        }
      
        __out.push('"></div></div>\n        <div class="toggler-label">Suspend Caching</div>\n      </div>\n    </div>\n\n    <div class="cache-body status-block">\n      <div class="label bold">Cache Information</div>\n      <table class="runtime-body">\n        <tr class="runtime-info">\n          <td class="label">Last Checked</td><td class="last-checked last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-incremental-row">\n          <td class="label">Last Incremental Update</td><td class="last-incremental-update last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-incremental-row">\n          <td class="label">Last Incremental Runtime</td><td class="last-incremental-runtime last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-full-row">\n          <td class="label">Last Full Update</td><td class="last-full-update last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-full-row">\n          <td class="label">Last Full Runtime</td><td class="last-full-runtime last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-update-row">\n          <td class="label">Last Update</td><td class="last-update last-checked"></td>\n        </tr>\n        <tr class="runtime-info last-update-row">\n          <td class="label">Last Runtime</td><td class="last-runtime last-checked"></td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class="cache-body button-block">\n    <div class="button-row save">\n      <div class="button inert uncache-text fixed-width">Uncache</div>\n      <div class="button inert-medium cancel disabled"><div class="label">Cancel</div></div>\n      <div class="button action-medium save disabled allow-pointers"><div class="label">Save</div></div>\n    </div>\n      <div class="button-row confirm-uncache">\n        <div class="confirm-message">Are you sure you want to <div class="inline uncache-text">uncache</div> this table?</div>\n        <div class="button inert-medium cancel"><div class="label">Cancel</div></div>\n        <div class="button destructive-medium confirm"><div class="label">Uncache</div></div>\n      </div>\n  </div>\n\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/cluster_info"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="cluster-info"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/color_theme_preference"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        __out.push('<div class="theme-name heavy-13-tuna-font">\n    ');
      
        __out.push(__sanitize(this.colorTheme.name));
      
        __out.push('\n    ');
      
        if (this.colorTheme.isSiteTheme()) {
          __out.push('\n    <span class="space-default normal-11-mirage-font">');
          __out.push(__sanitize(this.colorTheme.siteDefaultName()));
          __out.push('</span>\n    ');
        }
      
        __out.push('\n</div>\n');
      
        if (!this.hideGear) {
          __out.push('\n<div class="sg-gear-holder">\n    <div class="sg-gear"></div>\n</div>\n');
        }
      
        __out.push('\n<div class="color-cell">\n    ');
      
        ref = this.colorTheme.displayColors(20);
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n    <div class="color-square" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('"></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.colorTheme.colorList().length > 20) {
          __out.push('\n    <span>...</span>\n    ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/color_theme_preferences"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="area-header color-theme-area-header">Color Themes</div>\n<div class="icon add-icon"></div>\n<div class="color-theme-table simple-grid"></div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/color_themes_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="search-box-area theme-name">\n  <input class="redesign-input" autocomplete="off" placeholder="Default Theme" value="');
      
        __out.push(__sanitize(!this.theme.isNew() ? this.theme.name : void 0));
      
        __out.push('"></input>\n   <div class="errors warning-icon" style="display: none">Name cannot be blank.</div>\n</div>\n<div class="area-rotator-area">\n  <div class="bar-chart-settings subheader-2 rotator">\n    <div class="rotator-title heavy-12-mirage-font color-rotator">Charts</div>\n    <div class="content-area indented">\n      <div class="editor-color-picking-setting chart-tooltip-boundary">\n        <div class="series-settings color-themes">\n          <div class="series-color">\n          </div>\n          <div class="panel-content bar-chart">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="table-settings subheader-2 rotator">\n    <div class="rotator-title bold heavy-12-mirage-font color-rotator">Tables</div>\n    <div class="content-area indented">\n        <table class="table-chart-settings">\n          <tr>\n            <th class="color-label"></th>\n            <th>Header</th>\n            <th>Odd Rows</th>\n            <th>Even Rows</th>\n          </tr>\n          <tr class="text-color">\n            <td class="color-label">Text</td>\n            <td>\n              <div class="table color-square" data-color-type="table_color_header_text" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_header_text));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_header_text));
      
        __out.push('"></div>\n            </td>\n            <td>\n               <div class="table color-square" data-color-type="table_color_odd_rows_text" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_odd_rows_text));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_odd_rows_text));
      
        __out.push('"></div>\n            </td>\n            <td>\n               <div class="table color-square" data-color-type="table_color_even_rows_text" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_even_rows_text));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_even_rows_text));
      
        __out.push('"></div>\n            </td>\n          </tr>\n          <tr class="background-color">\n            <td class="color-label">Background Color</td>\n            <td>\n              <div class="table color-square" data-color-type="table_color_header_background" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_header_background));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_header_background));
      
        __out.push('"></div>\n            </td>\n            <td>\n               <div class="table color-square" data-color-type="table_color_odd_rows_background" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_odd_rows_background));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_odd_rows_background));
      
        __out.push('"></div>\n            </td>\n            <td>\n               <div class="table color-square" data-color-type="table_color_even_rows_background" data-color="');
      
        __out.push(__sanitize(this.theme.table_color_even_rows_background));
      
        __out.push('" style="background-color: ');
      
        __out.push(__sanitize(this.theme.table_color_even_rows_background));
      
        __out.push('"></div>\n            </td>\n          </tr>\n        </table>\n      <div class="color-themes">\n        <div class="panel-content table">\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="button-row"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/color_themes_menu"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sg-menu color-theme-menu">\n  <div class="sg-menu-triangle-border color"></div>\n  <div class="sg-menu-triangle color"></div>\n  <div class="sg-menu-handle color"></div>\n  <div class="sg-item-holder color">\n  ');
      
        if (!this.theme.isSiteTheme()) {
          __out.push('\n    <div class="sg-item default hover-eastern-blue">Set as Default</div>\n    <div class="set-default-block">\n      <div class="confirm-message normal-12-mirage-font">\n      ');
          __out.push(__sanitize(this.confirmMessage));
          __out.push('\n      </div>\n      <div class="button default cancel inert-small">\n        <div class="label">Cancel</div>\n      </div>\n      <div class="button default action-small">\n        <div class="label">Confirm</div>\n      </div>\n    </div>\n  ');
        }
      
        __out.push('\n  ');
      
        if (!this.theme.isPeriscopeDefault) {
          __out.push('\n    <div class="sg-item hover-eastern-blue edit">Edit...</div>\n    <div class="sg-item remove hover-red">Remove</div>\n    <div class="delete-block">\n      <div class="confirm-message normal-12-mirage-font">\n        Are you sure you want to remove this theme?\n      </div>\n      <div class="button delete cancel inert-small">\n        <div class="label">Cancel</div>\n      </div>\n      <div class="button delete destructive-small">\n        <div class="label">Remove</div>\n      </div>\n    </div>\n  ');
        }
      
        __out.push('\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/conditional_formatting_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="modal conditional-formatting editor-color-picker color-theme">\n  <div class="light top pointer-border"></div>\n  <div class="light top pointer"></div>\n  <div class="color-selection-section">\n    <div class="color-selection-type">\n      <div class="color-type color-type-text" data-color-type="text">Text</div>\n      <div class="color-type color-type-background selected" data-color-type="background">Background</div>\n    </div>\n  </div>\n  <div class="area-rotator-area recent-colors">\n    <div class="subheader-2 rotator recent-colors-rotator closed">\n      <div class="rotator-title">Recent Colors</div>\n      <div class="recent color-content"></div>\n    </div>\n    <div class="subheader-2 rotator theme-colors-rotator closed">\n      <div class="rotator-title">\n        ');
      
        if (AppRedesign.current().colorThemesEnabled) {
          __out.push('\n          Theme Colors\n        ');
        } else {
          __out.push('\n          Default Colors\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="theme color-content"></div>\n    </div>\n  </div>\n  <div class="area-rotator-area custom-color">\n    <div class="subheader-2 rotator gradient-rotator">\n      <div class="rotator-title">Custom Colors</div>\n        <div class="custom color-content">\n        </div>\n    </div>\n  </div>\n  <div class="reset-delete">\n    <div class="action reset">Reset</div>\n    <div class="action save">Set Color</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/configitron"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="outer-panel-wrapper">\n  <div class="picker-panel"></div>\n  <div class="panel-wrapper">\n    <div class="panel">\n      <div class="credentials area">\n        <div class="area-header">Credentials</div>\n        <div class="area-body"></div>\n      </div>\n    </div>\n    <div class="database-right-panel">\n      ');
      
        if (this.display_db_permissions_panel) {
          __out.push('\n        <div class="permissions area">\n          <div class="area-header">\n            Restricted Database\n            <div class="icon info-icon"></div>\n          </div>\n          <div class="area-body"></div>\n        </div>\n      ');
        }
      
        __out.push('\n      <div class="status area">\n        <div class="area-header">Status</div>\n        <div class="area-body"></div>\n      </div>\n      ');
      
        if (!this.row_count_disabled) {
          __out.push('\n        <div class="row-counts area">\n          <div class="area-header">Row Counts</div>\n          <div class="area-body"></div>\n        </div>\n      ');
        }
      
        __out.push('\n      <div class="disconnect area">\n        <div class="area-body"></div>\n      </div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/dashboard_refresh"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="dashboard-refresh"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/data_bars_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="modal js-toggle-positive-negative data-bars editor-color-picker color-theme ');
      
        if (this.positiveColorPicker) {
          __out.push(__sanitize('positive'));
        }
      
        if (this.negativeColorPicker) {
          __out.push(__sanitize('negative'));
        }
      
        __out.push('">\n  <div class="light top pointer-border"></div>\n  <div class="light top pointer"></div>\n  <div class="color-selection-section">\n    <div class="color-selection-type">\n      <div class="color-type color-type-text" data-color-type="text">Text</div>\n      <div class="color-type color-type-background selected" data-color-type="background">Bar</div>\n    </div>\n  </div>\n  <div class="area-rotator-area recent-colors">\n    <div class="subheader-2 rotator recent-colors-rotator closed">\n      <div class="rotator-title">Recent Colors</div>\n      <div class="recent color-content"></div>\n    </div>\n    <div class="subheader-2 rotator theme-colors-rotator closed">\n      <div class="rotator-title">\n        ');
      
        if (AppRedesign.current().colorThemesEnabled) {
          __out.push('\n          Theme Colors\n        ');
        } else {
          __out.push('\n          Default Colors\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="theme color-content"></div>\n    </div>\n  </div>\n  <div class="area-rotator-area custom-color">\n    <div class="subheader-2 rotator gradient-rotator">\n      <div class="rotator-title">Custom Colors</div>\n        <div class="custom color-content">\n        </div>\n    </div>\n  </div>\n  <div class="reset-delete">\n    <div class="action reset">Reset</div>\n    <div class="action save">Set Color</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/database_delete_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'dialog-content-wrapper\'>\n  ');
      
        if (this.dependents_info != null) {
          __out.push('\n    <div class="dependents">\n      Database <span class="db-name">');
          __out.push(__sanitize(this.database_name));
          __out.push('</span> is currently used\n      by ');
          __out.push(__sanitize(this.dependents_info));
          __out.push('. Which database should replace\n      <span class="db-name">');
          __out.push(__sanitize(this.database_name));
          __out.push('</span>?\n      <div class="replace-row">\n        <div class="label bold">Replace With</div>\n        <select class="replacement-db"></select>\n      </div>\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="delete-area">\n    To disconnect database <span class="db-name">');
      
        __out.push(__sanitize(this.database_name));
      
        __out.push('</span>,\n    type <span class="confirm-text">');
      
        __out.push(__sanitize(this.database_name));
      
        __out.push('</span> in the form below.\n    This action cannot be undone.\n  </div>\n  <input class="delete-confirm destructive redesign-input"></input>\n</div>\n\n<div class="button-row">\n  <div class="buttons flex-fill-row dc">\n      <div class="button inert-medium cancel">\n        <div class=\'label\'>Cancel</div>\n      </div>\n      <div class="button destructive-medium delete disabled">\n        <div class=\'label\'>Disconnect</div>\n      </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/database_disconnect_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="info-grid">\n  <tr class="disable-row"><td>Queries Disabled</td><td class="disable-queries">\n    <div class="checkbox"><div class="icon"></div></div>\n  </td></tr>\n  <tr class="delete-row">\n    <td class="delete-db">\n      <div class="button inert-medium">Disconnect Database</div>\n    </td>\n  </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/database_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var ref, ref1, ref2;
      
        __out.push('<div class="database-connect">\n  <table class="form">\n    <tr>\n        <td row="display_name">\n          <div>Display Name</div>\n          <input class="redesign-input" type="text" placeholder="prod_analytics" spellcheck="false"></input>\n        </td>\n        <td row="type">\n          <div>Database Type</div>\n          <select>\n            <option value="mysql">MySQL</option>\n            <option value="postgres">Postgres</option>\n            <option value="redshift">Redshift</option>\n            <option value="vertica">Vertica</option>\n            <option value="sql_server">SQL Server</option>\n            <option value="oracle">Oracle</option>\n            <option value="memsql">MemSQL</option>\n            <option value="sybase">Sybase</option>\n            <option value="exasol">Exasol</option>\n            <option value="bigquery">BigQuery</option>\n            <option value="snowflake">Snowflake</option>\n            <option value="presto">Presto</option>\n            ');
      
        if (this.salesforceEnabled && this.cacheEnabled) {
          __out.push('\n              <option value="SalesforceDatabase">Salesforce</option>\n            ');
        }
      
        __out.push('\n            <option value="QuboleDatabase">Qubole</option>\n            <option value="AthenaDatabase">Athena</option>\n            ');
      
        if (this.teradataEnabled) {
          __out.push('\n              <option value="teradata">Teradata</option>\n            ');
        }
      
        __out.push('\n            ');
      
        if (this.databricksEnabled) {
          __out.push('\n              <option value="databricks">Databricks</option>\n            ');
        }
      
        __out.push('\n          </select>\n        </td>\n    </tr>\n  </table>\n\n  <div id="specific-database-fields"></div>\n\n  ');
      
        if (this.byowEnabled && this.firstBYOW) {
          __out.push('\n    <div class="cacheable-database">\n      <div class="cacheable-header">\n        Warehouse Admin Credentials\n        <a class="cacheable-database-doc help-icon header-icon clickable" href="');
          __out.push(__sanitize(AppRedesign.DOC_PATH));
          __out.push('/bring-your-own-warehouse" target="_blank" rel="nofollow noopener noreferrer"></a>\n      </div>\n      <div class="cacheable-body">\n        <table class="form">\n          <tr>\n            <td row="cacheable-admin-username" style="display: table-cell;">\n              <div>Admin Username</div>\n              <input class="redesign-input" type="text" placeholder="sisense_admin" spellcheck="false" ></input>\n            </td>\n            <td row="cacheable-admin-password" style="display: table-cell;">\n              <div>\n                Admin Password\n                ');
          if ((ref = App.Site.first()) != null ? ref.snowflake_keypair_auth_feature_flag_enabled : void 0) {
            __out.push('\n                  <span class="text-danger for-snowflake-warehouse-only">(deprecated)</span>\n                ');
          }
          __out.push('\n              </div>\n              <input class="redesign-input ');
          if ((ref1 = App.Site.first()) != null ? ref1.snowflake_keypair_auth_feature_flag_enabled : void 0) {
            __out.push(__sanitize('snowflake-warehouse-either-present'));
          }
          __out.push('" type="password" spellcheck="false" ></input\n            </td>\n          </tr>\n\n          ');
          if ((ref2 = App.Site.first()) != null ? ref2.snowflake_keypair_auth_feature_flag_enabled : void 0) {
            __out.push('\n            <tr class="for-snowflake-warehouse-only">\n              <td row="cacheable-admin-pk8-file" style="display: table-cell;">\n                <div>\n                  Admin P8 KeyFile\n                </div>\n                <div class="key-file cacheable-pk8">\n                  <span class="default-text">\n                    Click or drag to upload\n                  </span>\n                  <span class="file-name"></span>\n                  <input class="redesign-input key-file-drop snowflake-warehouse-either-present" type="file" placeholder="Drag to Upload" spellcheck="false"></input>\n                </div>\n              </td>\n              <td row="cacheable-admin-pk8-pwd">\n                <div>\n                  Admin P8 Passphrase (optional)\n                </div>\n                <input type="password" class="optional redesign-input" placeholder="cacheable_admin_p8_pwd" spellcheck="false"></input>\n              </td>\n            </tr>\n          ');
          }
          __out.push('\n        </table>\n      </div>\n    </div>\n\n    ');
          if (this.connectorIngestionSpecificDbUserEnabled && this.connectorIngestionEnabled) {
            __out.push('\n      <div class="app-connectors-database">\n        <div class="app-connectors-header">\n          App Connectors Credentials\n        </div>\n        <div class="app-connectors-body">\n          <table class="form">\n            <tr>\n              <td row="app-connectors-username" style="display: table-cell;">\n                <div>App Connectors Username</div>\n                <input class="redesign-input" type="text" placeholder="sisense_connectors" spellcheck="false" ></input>\n              </td>\n              <td row="app-connectors-password" style="display: table-cell;">\n                <div>App Connectors Password</div>\n                <input class="redesign-input" type="password" spellcheck="false" ></input>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    ');
          }
          __out.push('\n  ');
        }
      
        __out.push('\n\n  <div class="ssh-tunnel private-network clickable">Connect to a Private Network</div>\n  <div class="ssh-tunnel help">\n    <form class="public-key" method="get" action="/periscope_id_rsa.pub">\n      <button class="clickable">Download Public Key</button>\n    </form>\n    <a class="ssh-tunnel-doc clickable" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">Do I need an SSH Tunnel?</a>\n    <a class="more-info clickable" href="');
      
        __out.push(__sanitize(AppRedesign.DOC_PATH));
      
        __out.push('/ssh-tunnel" target="_blank" rel="nofollow noopener noreferrer">More Info</a>\n  </div>\n  <a class="teradata-private-network clickable" href="https://doc.periscopedata.com/article/connecting-teradata" target="_blank" rel="nofollow noopener noreferrer">Using Teradata with Private Networks</a>\n  ');
      
        if (this.showDbRestriction) {
          __out.push('\n    <div class="restriction">\n      <div class="restriction-toggle checkbox">\n        <div class="icon"></div>\n      </div>\n      <span>Restrict Database</span>\n      <div class="icon info-icon"></div>\n    </div>\n  ');
        }
      
        __out.push('\n</div>\n<div class="button-row">\n  <div class="db-loader"><div class="spinner"></div></div>\n  <div class="errors warning-icon">\n    <div class="error validation"></div>\n    <div class="error status-ok"></div>\n    <div class="error error-timeout">\n        The database connection is timing out. Please whitelist\n        <span class="ip">107.23.195.228</span> and <span class="ip">54.236.224.46</span>.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-snowflake-timeout">\n        The account was not found. Is the account name\n        <span class="account_name"></span> correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error user-temporarily-locked">\n        Snowflake user temporarily locked. Please try again later or contact your Snowflake system administrator.\n    </div>\n\n    <div class="error error-user-access-denied">\n        Access for user <span class="username"></span> was denied.\n        Are the username and password correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-unknown-database">\n        The database was not found. Is the database name\n        <span class="database_name"></span> correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-user-cannot-access-db" databases="mysql">\n        Permission was denied to the database. Please run:\n        <div class="indented">\n      <pre>\nGRANT SELECT ON <span class="database_name"></span>.% TO \'<span class="username"></span>\'@\'107.23.195.228\';\nGRANT SELECT ON <span class="database_name"></span>.% TO \'<span class="username"></span>\'@\'54.236.224.46\';</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-user-cannot-access-db" databases="postgres redshift">\n        Permission was denied to the database. Please run:\n        <div class="indented">\n      <pre>\nGRANT USAGE ON SCHEMA public TO <span class="username"></span>;\nGRANT SELECT ON ALL TABLES IN SCHEMA public TO <span class="username"></span>;</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-hba-conf">\n        The user is not permitted in the pg_hba.conf file. Please add these lines to your pg_hba.conf file:\n        <div class="indented">\n      <pre>\nhost&#09;all&#09;<span class="username"></span>&#09;107.23.195.228/32&#09;password\nhost&#09;all&#09;<span class="username"></span>&#09;54.236.224.46/32&#09;password</pre>\n        </div>\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-connection-attempt-failed">\n        Sisense could not connect to the database server. Are the database host and port correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-check-host-and-port">\n        Sisense was unable connect to the database server. Are the database host and port correct?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-authenticate">\n        SSH access was denied. Have you authorized the public key?\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-host">\n        Could not find SSH host. Please check ssh host name and whitelist <span class="ip">107.23.195.228</span> and <span class="ip">54.236.224.46</span> in your firewall.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-internal-error">\n        Sisense had an internal error. Please try again shortly.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error ssh-tunnel-database">\n        SSH access was successful, but database could not be found. Please check your database host and port.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-key-not-authorized" database="bigquery">\n        The key file provided could not authenticate to BigQuery.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error error-key-file-integrity" database="bigquery">\n        The key file provided is not in the right format.\n        ');
      
        __out.push(this.moreHelp);
      
        __out.push('\n    </div>\n\n    <div class="error client-identifier-invalid">\n      Client Id Invalid\n    </div>\n    <div class="error invalid-client-credentials">\n      Client Secret invalid\n    </div>\n    <div class="error authentication-failure">\n      One or more of Login Name, Login Password, or Security Token is invalid\n    </div>\n    <div class="error invalid_site_for_salesforce">\n      This site is not enabled for salesforce. Please contact Sisense.\n    </div>\n    <div class="error cache_not_enabled_salesforce">\n      Cannot make salesforce database since this site is not enabled for caching. Please contact Sisense.\n    </div>\n    <div class="error error-unexpected">\n      An unexpected error occurred:\n      <div class="full-msg"></div>\n    </div>\n\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/database_permissions_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var group, i, j, len, len1, ref, ref1;
      
        __out.push('<table class="info-grid">\n  <tr>\n    <td>\n      <div class="subheading">\n        Query Access Groups\n      </div>\n      <div class="edit-icon ');
      
        if (this.editing) {
          __out.push(__sanitize('active'));
        }
      
        __out.push('"></div>\n    </td>\n  </tr>\n  <tr>\n    ');
      
        if (this.editing) {
          __out.push('\n      <td>\n        <div class=\'group-list\'>\n          ');
          ref = this.editGroups;
          for (i = 0, len = ref.length; i < len; i++) {
            group = ref[i];
            __out.push('\n            <div class="toggle-set">\n              <div class="restriction-toggle checkbox ');
            if (group.can_query) {
              __out.push(__sanitize('selected'));
            }
            __out.push(' ');
            if (group.is_admin) {
              __out.push(__sanitize('disabled'));
            }
            __out.push('"\n                data-group-id="');
            __out.push(__sanitize(group.group_id));
            __out.push('">\n                <div class="icon"></div>\n              </div>\n              <div class="name">');
            __out.push(__sanitize(group.display_name));
            __out.push('</div>\n            </div>\n          ');
          }
          __out.push('\n        </div>\n      </td>\n      ');
        } else {
          __out.push('\n        <td>\n          <div class=\'group-list\'>\n            ');
          ref1 = this.selectedGroups;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            group = ref1[j];
            __out.push('\n              <div class="name">');
            __out.push(__sanitize(group.display_name));
            __out.push('</div>\n            ');
          }
          __out.push('\n          </div>\n        </td>\n    ');
        }
      
        __out.push('\n  </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/database_row_counts_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="info-grid">\n  <tr><td>Total Rows</td><td class="total-rows"></td></tr>\n  <tr><td>Tables</td><td class="num-tables"></td></tr>\n  <tr><td>Last Updated</td><td>\n    <span class="row-count-updated"></span>\n    <span class="refresh-button refresh-count-now"></span>\n  </td></tr>\n  <tr>\n    <td>Export Counts</td>\n    <td class="download-counts">\n      <div class="subtle clickable">Download CSV</div>\n    </td>\n  </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/editor_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="modal editor-color-picker color-theme">\n  <div class="light top pointer-border"></div>\n  <div class="light top pointer"></div>\n  <div class="area-rotator-area recent-colors">\n    <div class="subheader-2 rotator recent-colors-rotator closed">\n      <div class="rotator-title">Recent Colors</div>\n      <div class="recent color-content"></div>\n    </div>\n    <div class="subheader-2 rotator theme-colors-rotator closed">\n      <div class="rotator-title">\n        ');
      
        if (AppRedesign.current().colorThemesEnabled) {
          __out.push('\n          Theme Colors\n        ');
        } else {
          __out.push('\n          Default Colors\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="theme color-content"></div>\n    </div>\n  </div>\n  <div class="area-rotator-area custom-color">\n    <div class="subheader-2 rotator gradient-rotator">\n      <div class="rotator-title">Custom Colors</div>\n        <div class="custom color-content">\n        </div>\n    </div>\n  </div>\n  <div class="reset-delete">\n    <div class="action reset">Reset</div>\n    <div class="action save">Set Color</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/my_account_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="panel">\n  <div class="account-credentials area">\n    <div class="area-header">Profile</div>\n    <div class="area-body"></div>\n  </div>\n</div>\n<div class="panel">\n  <div class="tfa area">\n    <div class="area-header">Two-Factor Authentication</div>\n    <div class="area-body"></div>\n  </div>\n</div>\n<div class="panel">\n  <div class="switch-site area">\n    <div class="area-header">Switch Site</div>\n    <div class="area-body"></div>\n  </div>\n</div>\n<div class="panel">\n  <div class="logout area">\n      <div class="area-body"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/no_db_message"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="settings-empty-text flex-fill-column panel-message db-config">\n    <div class="flex-filler"></div>\n    <div class="empty-text">');
      
        __out.push(this.message);
      
        __out.push('</div>\n    <div class="flex-filler"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/non_polymorphic_form_fields"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var database_id, database_name, ref, ref1, ref2, ref3, ref4, ref5, role_id, role_name;
      
        __out.push('<table class="form">\n  <tr>\n    <td colspan="2" row="host" class=\'full-span\'>\n      <div>Database Host</div>\n      <input class="redesign-input" type="text" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="port">\n      <div>Database Port</div>\n      <input class="redesign-input" type="text" spellcheck="false"></input>\n    </td>\n\n    <td row="warehouse_name">\n      <div>Warehouse Name</div>\n      <input class="redesign-input" type="text" placeholder="warehouse_name" spellcheck="false"></input>\n    </td>\n\n    <td row="httppath">\n      <div>HTTP Path</div>\n      <input class="redesign-input" type="text" placeholder="/sql/1.0/endpoints/958e128b9b285c6" spellcheck="false"></input>\n    </td>\n\n    <td row="jdbc_command_type">\n      <div>Database Name</div>\n      <select>\n         <option value="service_name">Service Name</option>\n         <option value="sid">SID</option>\n      </select>\n      <input class="redesign-input" type="text" placeholder="db1" spellcheck="false"></input>\n    </td>\n\n    <td row="database_name">\n      <div>Database Name</div>\n      <input class="redesign-input" type="text" placeholder="db1" spellcheck="false"></input>\n    </td>\n\n    <td row="s3_staging_dir">\n      <div>S3 Staging Directory</div>\n      <input class="redesign-input" type="text" placeholder="s3://bucket-dir/" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="catalog" class=\'full-span\' colspan="2">\n      <div>Catalog</div>\n      <input class="redesign-input" type="text" placeholder="default" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="username">\n      <div>Database Username</div>\n      <input class="redesign-input" type="text" placeholder="database_user" spellcheck="false"></input>\n    </td>\n    <td row="password">\n      <div>Database Password</div>\n      <input class="redesign-input ');
      
        if ((ref = App.Site.first()) != null ? ref.database_roles_mapping_enabled : void 0) {
          __out.push(__sanitize('optional'));
        }
      
        __out.push('" type="password" placeholder="database_password" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="account_name" class=\'full-span\' colspan="2">\n      <div>Account Name</div>\n      <input class="redesign-input" type="text" placeholder="account.snowflakecomputing.com" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="snowflake_username">\n      <div>Snowflake Username</div>\n      <input class="redesign-input" type="text" placeholder="snowflake_username" spellcheck="false"></input>\n    </td>\n    <td row="snowflake_password">\n      <div>\n        Snowflake Password\n        ');
      
        if ((ref1 = App.Site.first()) != null ? ref1.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          __out.push('\n          <span class="text-danger">(deprecated)</span>\n        ');
        }
      
        __out.push('\n      </div>\n      <input class="redesign-input ');
      
        if ((ref2 = App.Site.first()) != null ? ref2.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          __out.push(__sanitize('snowflake-either-present'));
        }
      
        __out.push('" type="password" placeholder="snowflake_password" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="service_account">\n      <div>Service Account</div>\n      <input class="redesign-input" type="text" placeholder="abc123@developer.gserviceaccount.com" spellcheck="false"></input>\n    </td>\n    <td row="sql_dialect">\n      <div>SQL Dialect</div>\n      <select>\n        <option value="legacy">Legacy</option>\n        <option value="standard">Standard</option>\n      </select>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="cluster_name">\n      <div>Cluster Name</div>\n      <input class="redesign-input" type="text" placeholder="default" spellcheck="false"></input>\n    </td>\n    <td row="command_type">\n      <div>Command Type</div>\n      <select>\n        <option value="hive">Hive</option>\n        <option value="presto">Presto</option>\n      </select>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="project_id">\n      <div>Project Id</div>\n      <input class="redesign-input" type="text" placeholder="strong-planet-103422" spellcheck="false"></input>\n    </td>\n    <td row="p12_key_file">\n      <div>P12 KeyFile</div>\n      <div class="key-file p12">\n        <span class="default-text">Click or drag to upload</span>\n        <span class="file-name"></span>\n        <input class="redesign-input key-file-drop" type="file" placeholder="Drag to Upload" spellcheck="false"></input>\n      </div>\n    </td>\n  </tr>\n\n  ');
      
        if ((ref3 = App.Site.first()) != null ? ref3.snowflake_keypair_auth_feature_flag_enabled : void 0) {
          __out.push('\n    <tr>\n      <td row="snowflake_pk8_key_file">\n        <div>P8 KeyFile</div>\n        <div class="key-file pk8">\n          <span class="default-text">Click or drag to upload</span>\n          <span class="file-name"></span>\n          <input class="redesign-input key-file-drop snowflake-either-present" type="file" placeholder="Drag to Upload" spellcheck="false"></input>\n        </div>\n      </td>\n      <td row="snowflake_pk8_pwd">\n        <div>P8 Passphrase (optional)</div>\n        <input class="redesign-input optional" type="password" placeholder="snowflake_p8_pwd" spellcheck="false"></input>\n      </td>\n    </tr>\n  ');
        }
      
        __out.push('\n\n  <tr>\n    <td row="parent_database">\n      <div>Replica Of</div>\n      <select class="replica-dropdown">\n          <option value="-1">None</option>\n          ');
      
        ref4 = this.databaseNames;
        for (database_name in ref4) {
          database_id = ref4[database_name];
          __out.push('\n          <option value="');
          __out.push(__sanitize(database_id));
          __out.push('">');
          __out.push(__sanitize(database_name));
          __out.push('</option>\n          ');
        }
      
        __out.push('\n      </select>\n    </td>\n    <td row="cloud_provider">\n      <div>Cloud Provider</div>\n      <select>\n        <option value="aws">AWS</option>\n        <option value="gcp">GCP</option>\n      </select>\n    </td>\n  </tr>\n\n  ');
      
        if (Object.keys(this.roleNames || {}).length) {
          __out.push('\n    <tr>\n      <td row="roles">\n        <div>Roles with access to db</div>\n        <select multiple="true">\n          <option></option>\n          ');
          ref5 = this.roleNames;
          for (role_id in ref5) {
            role_name = ref5[role_id];
            __out.push('\n            <option value="');
            __out.push(__sanitize(role_id));
            __out.push('">');
            __out.push(__sanitize(role_name));
            __out.push('</option>\n          ');
          }
          __out.push('\n        </select>\n      </td>\n    </tr>\n  ');
        }
      
        __out.push('\n</table>\n\n<div class="ssh-tunnel-form">\n  <table class="form">\n    <tr>\n      <td colspan="2" row="ssh-host" class=\'full-span\'>\n        <div>SSH Host</div>\n        <input class="redesign-input optional" type="text" placeholder="ssh-bastion.my-domain.com" spellcheck="false"></input>\n      </td>\n    </tr>\n    <tr>\n      <td row="ssh-username">\n        <div>SSH Username</div>\n        <input class="redesign-input optional" type="text" placeholder="ssh_user" spellcheck="false"></input>\n      </td>\n      <td row="ssh-port">\n        <div>SSH Port</div>\n        <input class="redesign-input optional" type="text" value="22" spellcheck="false"></input>\n      </td>\n    </tr>\n  </table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/permission_spinner"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="spinner-container">\n  <div class="new-spinner-with-label-white-bg">\n    <div class="new-spinner"></div>\n      <div class="new-permission-text-below-spinner">Loading permissions page...</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/preferences_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'panel\'>\n  <div class=\'timezone-settings-react-div\' ></div>\n</div>\n\n<div class=\'panel\'>\n  <div class=\'landing-page-settings-react-div\' ></div>\n</div>\n\n<div class=\'panel\'>\n  <div class=\'dashboard-settings-react-div\' ></div>\n</div>\n\n<div class=\'panel\'>\n  <div class=\'csv-settings-react-div\' ></div>\n</div>\n\n<div class="panel filters ');
      
        if (!this.autoArchiveEnabled) {
          __out.push('bottom-round-corner');
        }
      
        __out.push('">\n  <div class=\'filter-settings-react-div\' ></div>\n</div>\n\n');
      
        if (this.autoArchiveEnabled) {
          __out.push('\n  <div class=\'auto-archive-react-div\'></div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.colorThemesEnabled) {
          __out.push('\n  <div class="panel color-theme">\n    <div class="color-theme area">\n    </div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/profile_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, idx, len, ref, session;
      
        __out.push('<div class="label">Email</div>\n<div class="text">');
      
        __out.push(__sanitize(this.user.email_address));
      
        __out.push('</div>\n<div class="label">First Name</div>\n<div class="text-field first-name">\n  <input class="redesign-input first_name" type="text" placeholder="Enter First Name" value="');
      
        __out.push(__sanitize(this.user.first_name));
      
        __out.push('" maxlength="1000"></input>\n</div>\n<div class="label">Last Name</div>\n<div class="text-field last-name">\n  <input class="redesign-input last_name" type="text" placeholder="Enter Last Name" value="');
      
        __out.push(__sanitize(this.user.last_name));
      
        __out.push('" maxlength="1000"></input>\n</div>\n<div class="label">Change Password</div>\n<div class="text-field password medium-label">\n  <input class="redesign-input" type="password" placeholder="Current Password" name="current-password">\n</div>\n<div class="new-passwords-area">\n  <div class="text-field new">\n    <input class="redesign-input password" type="password" placeholder="New Password" name="new-password" maxlength="1000"></input>\n  </div>\n  <div class="text-field new-confirm medium-label">\n    <input class="redesign-input password" type="password" placeholder="Confirm Password" name="confirm-password" maxlength="1000"></input>\n  </div>\n</div>\n<div class="errors warning-icon"></div>\n<div class="button-row">\n  <div class="right-aligned-buttons">\n    <div class="cancel button inert-medium">Cancel</div>\n    <div class="done button action-medium">Save</div>\n  </div>\n</div>\n');
      
        if (this.user.sessions) {
          __out.push('\n  <div class="user-sessions">\n    <div class="label">Sessions</div>\n    <table class="">\n      <tr>\n        <th>IP</th>\n        <th>Device</th>\n        <th>Last Used</th>\n        <th></th>\n      </tr>\n      ');
          ref = this.user.sessions;
          for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
            session = ref[idx];
            __out.push('\n        <tr class="js-session-row">\n          <td>\n            ');
            __out.push(__sanitize(session.ip));
            __out.push('\n          </td>\n          <td>\n            <span title="');
            __out.push(__sanitize(session.user_agent));
            __out.push('">\n              ');
            __out.push(__sanitize(session.user_agent.substring(0, 25)));
            __out.push(' ...\n            </span>\n          <td>\n            <span title="');
            __out.push(__sanitize(App.Utils.formatDate(session.updated_at)));
            __out.push('">\n              ');
            __out.push(__sanitize(App.TimeMachine.timestampToMoment(session.updated_at).format(App.Utils.DATE_FORMAT)));
            __out.push(' ...\n            </span>\n          </td>\n          <td>\n            <div class="btn-sign-out" data-id="');
            __out.push(__sanitize(session.id));
            __out.push('">\n              Sign Out\n            </div>\n          </td>\n        </tr>\n      ');
          }
          __out.push('\n    </table>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/query_queue"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="query-queue"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/recent_colors"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        ref = this.recent_colors;
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n  <div class="color-square recent-color" data-color="');
          __out.push(__sanitize(color));
          __out.push('" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('">\n</div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/salesforce_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<table class="form salesforce">\n  <tr>\n    <td row="login_name">\n      <div>Login Name</div>\n      <input class="redesign-input" type="text" spellcheck="false" value="');
      
        __out.push(__sanitize(this.initialValues.username));
      
        __out.push('"></input>\n    </td>\n    <td row="login_password">\n      <div>Login Password</div>\n      <input class="redesign-input" type="password" spellcheck="false"></input>\n    </td>\n  </tr>\n\n  <tr>\n    <td row="security_token" class=\'full-span\' colspan="2">\n      <div>Security Token</div>\n      <input class="redesign-input" type="password" spellcheck="false"></input>\n    </td>\n  </tr>\n  <tr>\n    <td row="client_id">\n      <div>Client Id</div>\n      <input class="redesign-input" type="text" spellcheck="false" value="');
      
        __out.push(__sanitize(this.initialValues.client_id));
      
        __out.push('"></input>\n    </td>\n    <td row="client_secret">\n      <div>Client Secret</div>\n      <input class="redesign-input" type="password" spellcheck="false"></input>\n    </td>\n  </tr>\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/scim/scim_generated_key_confirmation_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Regenerate SCIM API Key</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      If you generate a new API key, your SCIM integration will stop working until you update your IdP configuration. Please copy the new key and paste it into the configuration in your IdP management console immediately to avoid interruption of role assignments. Are you sure you want to do this?\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/scim/scim_generated_key_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Copy API Key</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      <p>This is your SCIM API key. Please copy and paste it into the configuration in your IdP management console to complete the SCIM integration. If you lose this key, you can revisit this page to generate a new one.\n      </p>\n      <p>SCIM Integration API Key</p>\n      <div class="text-field">\n        <textarea class="scim-key-input redesign-input" readonly>');
      
        __out.push(__sanitize(this.scimKey));
      
        __out.push('</textarea>\n      </div>\n      <p class="scim-key-tooltip">Click to copy</p>\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/scim/scim_provisioning_disable_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Disable SCIM</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      Once this feature is disabled, your IdP will no longer manage your Sisense role assignments. If you wish to assign or change roles, this will need to be done from the Sisense platform. Are you sure you want to do this?\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/scim/scim_provisioning_enable_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Enable SCIM</span>\n</header>\n<section class="modal-content">\n    <div class="loader widget-loader">\n        <div class="loader-strip"></div>\n\n        <div class="label-holder">\n            <div class="label loading">\n            <div class="spinner"></div>\n            <div class=\'text-below-spinner\'>Making backup of data</div>\n            </div>\n        </div>\n    </div>\n\n    <div class="body">\n      By enabling this feature, you are allowing your IdP to manage Sisense role assignments.\n      <b>All current data will be saved, in case of disabling SCIM and restoring the previous state contact solutions engineer.</b>\n      You will no longer be able to assign or change roles from the Sisense platform. Are you sure you want to do this?\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/series_colors"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, index, len, ref;
      
        ref = this.theme.series;
        for (index = i = 0, len = ref.length; i < len; index = ++i) {
          color = ref[index];
          __out.push('\n<div class="draggable-color" data-color="');
          __out.push(__sanitize(color));
          __out.push('">\n  <div class="series color-square" data-color="');
          __out.push(__sanitize(color));
          __out.push('" data-color-type="');
          __out.push(__sanitize(index));
          __out.push('" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('">\n  </div>\n</div>\n');
        }
      
        __out.push('\n<div class="add-to-series-icon">\n  <div class="color-square add-series-icon"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="settings-header">\n    <div class=\'header-description\'>\n        ');
      
        if (this.spaceName != null) {
          __out.push('\n        <div class="space-name heavy-13-eastern-blue-font">');
          __out.push(__sanitize(this.spaceName));
          __out.push('</div> /\n        ');
        }
      
        __out.push(__sanitize(this.headerDescription));
      
        __out.push('\n    </div>\n    <div class=\'header-content\'>\n        <div class="title">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</div>\n        <div class="button action-large add-database">\n            <div class=\'label\'>Add Database</div>\n        </div>\n    </div>\n</div>\n<div class="settings-main-content"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/settings_grid"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="still-loading">');
      
        __out.push(__sanitize(this.loadingMessage));
      
        __out.push('</div>\n<div class="search-panel"></div>\n<div class="right-panel">\n    <div class="content">\n        <div class="section upper-section"></div>\n        <div class="section lower-section"></div>\n    </div>\n</div>\n<div class="left-panel">\n    <table class="left-panel-table">\n        <tr>\n            <td class="grid-td">\n                <div class="grid-panel"></div>\n            </td>\n        </tr>\n    </table>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/site_settings_api_key"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (this.siteSpecificApiKey) {
          __out.push('\n  <div class="label">Site API Key\n    <div class="link about-api-link help-icon"></div>\n  </div>\n  <div class="locked-for-input-only site-specific">\n    <div class="site-selector-row row provider-type dark-theme">\n      <select class="site-selector-for-api-key"></select>\n    </div>\n    <div class="text-field">\n      <input type="text" class="api-key-input redesign-input" disabled></input>\n    </div>\n  </div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.userSpecificApiKey) {
          __out.push('\n  <div class="label">User API Key\n    <div class="link about-api-link help-icon"></div>\n  </div>\n  <div class="locked-for-input-only user-specific">\n    <div class="text-field api-key-input-wrapper">\n      <input value="************" type="text" class="api-key-input redesign-input" disabled></input>\n    </div>\n    <div class="user-api-key-regenerate-button button action-medium">Regenerate</div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/site_settings_api_key_confirmation"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Regenerate User API Key</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      If you generate a new API key, your current API key will stop working. Are you sure you want to do this?\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/site_settings_authentication"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="form api-key-form"></div>\n\n<div class="form sso-form"></div>\n\n<div class="label label-without-button">\n  Site Two-Factor Authentication\n  <div class="link about-tfa-link help-icon"></div>\n</div>\n\n<div class="form two-factor-form"></div>\n\n');
      
        if (this.slackEnabled) {
          __out.push('\n  <div class="label label-without-button">\n    Slack\n    <div class="link about-slack-link help-icon"></div>\n  </div>\n  <div class="form slack-form"></div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/slack/add_to_slack"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<a class=\'install\'><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/slack/legacy_button_block"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="button-row dark-theme">\n  <div class="cancel link disabled">Cancel</div>\n  <div class="save create button disabled">Save</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/slack/slack_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        if (App.Site.isSpacesEnabled()) {
          __out.push('\n<div class="label spaces">Spaces</div>\n');
        }
      
        __out.push('\n<div class="site-list"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/spinner"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="spinner-container">\n  <div class="new-spinner-with-label-white-bg">\n    <div class="new-spinner"></div>\n      <div class="new-text-below-spinner">Loading directory information...</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/sso_config_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="label">Single Sign-On<div class="help-icon"></div></div>\n<div class="row provider-type dark-theme"><select class="sso-provider"></select></div>\n<div class="text-field provider-sso-url ">\n    <div class="label sso-url">SSO URL</div>\n    <input class="redesign-input"></input>\n</div>\n');
      
        if (this.azure) {
          __out.push('\n    <div class="text-field provider-slo-url">\n        <div class="label slo-url">SLO URL</div>\n        <input class="redesign-input"></input>\n    </div>\n    <div class="text-field provider-identifier">\n        <div class="label identifier">Identifier</div>\n        <input class="redesign-input"></input>\n    </div>\n');
        }
      
        __out.push('\n\n<div class="text-field provider-issuer">\n    <div class="label">Issuer</div>\n    <input class="redesign-input"></input>\n</div>\n<div class="text-field provider-cert">\n    <div class="label">Certificate</div>\n    <textarea class="redesign-input" rows="4" cols="25"></textarea>\n</div>\n<div class="default-site-section">\n    <div class="default-site-field" style="display:none">\n        <div class="label">Default Space<div class="default-space help-icon"></div></div>\n        <div class="row default-site dark-theme"><select></select></div>\n    </div>\n</div>\n<div class="row button-row">\n    <div class="button submit action-medium">Save</div>\n    <div class="errors validation warning-icon"></div>\n</div>\n\n<div class="provider-scim-enable-area"></div>\n<div class="regenerate-scim-key-section" style="display:none">\n    <div class="scim-key-label">\n        <div class="label">SCIM API Key</div>\n    </div>\n    <div class="scim-key-field">\n        <div class="text-field scim-key-input-wrapper">\n            <input type="text" class="redesign-input scim-key-input" value="************" disabled></input>\n        </div>\n        <div class="scim-key-regenerate-button button action-medium">Regenerate</div>\n    </div>\n</div>\n\n<div class="add-remove-list provider-scim-alerts" style="display:none">\n    <div class="label">SCIM Provisioning Alerts</div>\n    <div class="input-container">\n        <input class="new-item-input redesign-input" type="text" placeholder="Enter an email address" ></input>\n        <div class="icon add-icon"></div>\n    </div>\n    <div class="errors add-error"></div>\n    <div class="list recipients"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/sso_config_form_azure"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="label">Single Sign-On<div class="help-icon"></div></div>\n<div class="row provider-type dark-theme"><select class="sso-provider"></select></div>\n<div class="text-field provider-sso-url ">\n    <div class="label sso-url">SSO URL</div>\n    <input class="redesign-input"></input>\n</div>\n<div class="text-field provider-issuer">\n    <div class="label">Issuer</div>\n    <input class="redesign-input"></input>\n</div>\n<div class="text-field provider-cert">\n    <div class="label">Certificate</div>\n    <textarea class="redesign-input" rows="4" cols="25"></textarea>\n</div>\n<div class="default-site-section">\n    <div class="default-site-field">\n        <div class="label">Default Space<div class="default-space help-icon"></div></div>\n        <div class="row default-site dark-theme"><select></select></div>\n    </div>\n</div>\n<div class="row button-row">\n    <div class="button submit action-medium">Save</div>\n    <div class="errors validation warning-icon"></div>\n</div>\n<div class="provider-scim-enable-area"></div>\n<div class="add-remove-list provider-scim-alerts" style="display:none">\n    <div class="label">SCIM Provisioning Alerts</div>\n    <div class="input-container">\n        <input class="new-item-input redesign-input" type="text" placeholder="Enter an email address" ></input>\n        <div class="icon add-icon"></div>\n    </div>\n    <div class="errors add-error"></div>\n    <div class="list recipients"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/sso_config_scim_alert_recipient"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div>\n  <div class="recipient-email"></div>\n  <div class="remove-icon"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/sso_update_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Update SSO Configuration</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      <div class="update-area">\n        Updating your SSO configuration will <span class="scary-red">immediately</span> log all users out of Sisense.\n        Type <span class="scary-red">Logout</span> to update your SSO configuration.\n        <div class="form-row">\n          <input class="update-confirm redesign-input"></input>\n        </div>\n      </div>\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/table_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="modal table-picker editor-color-picker color-theme">\n  <div class="light top pointer-border"></div>\n  <div class="light top pointer"></div>\n  <div class="color-selection-section">\n    <div class="color-selection-type">\n      <div class="color-type color-type-text" data-color-type="text">Text</div>\n      <div class="color-type color-type-background selected" data-color-type="background">Background</div>\n    </div>\n  </div>\n  <div class="area-rotator-area recent-colors">\n    <div class="subheader-2 rotator recent-colors-rotator closed">\n      <div class="rotator-title">Recent Colors</div>\n      <div class="recent color-content"></div>\n    </div>\n    <div class="subheader-2 rotator theme-colors-rotator closed">\n      <div class="rotator-title">\n        ');
      
        if (AppRedesign.current().colorThemesEnabled) {
          __out.push('\n          Theme Colors\n        ');
        } else {
          __out.push('\n          Default Colors\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="theme color-content"></div>\n    </div>\n  </div>\n  <div class="area-rotator-area custom-color">\n    <div class="subheader-2 rotator gradient-rotator">\n      <div class="rotator-title">Custom Colors</div>\n        <div class="custom color-content">\n        </div>\n    </div>\n  </div>\n  <div class="reset-delete">\n    <div class="action reset">Reset</div>\n    <div class="action save">Set Color</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/theme_color_picker"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="theme-color-picker modal">\n  <div class="light top pointer-border"></div>\n  <div class="light top pointer"></div>\n  <div class="area-rotator-area recent-colors">\n    <div class="subheader-2 rotator recent-colors-rotator closed">\n      <div class="rotator-title normal-13-mirage-font">Recent Colors</div>\n        <div class="recent color-content">\n\n        </div>\n    </div>\n  </div>\n  <div class="area-rotator-area custom-color">\n    <div class="subheader-2 rotator gradient-rotator">\n      <div class="rotator-title normal-13-mirage-font">Custom Colors</div>\n        <div class="custom color-content">\n        </div>\n    </div>\n  </div>\n  <div class="reset-delete">\n    ');
      
        if (this.show_delete) {
          __out.push('\n      <div class="action delete">Delete</div>\n    ');
        }
      
        __out.push('\n    <div class="action reset">Reset</div>\n    <div class="action save">Set Color</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/theme_color_setting"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var key, ref, value;
      
        __out.push('<div class="subheader-1 rotator">\n  <div class="rotator-title bold">Color Settings</div>\n  <div class="content-area indented color-theme">\n  ');
      
        ref = this.colors;
        for (key in ref) {
          value = ref[key];
          __out.push('\n    <div class="theme-color-setting">\n      <div class="theme-color-picker-box" data-color-group="');
          __out.push(__sanitize(key));
          __out.push('">\n        <div class="text-color" style="border-top-color:');
          __out.push(__sanitize(value['text']));
          __out.push('"></div>\n        <div class="background-color" style="border-bottom-color:');
          __out.push(__sanitize(value['background']));
          __out.push('"></div>\n      </div>\n      <div class="theme-color-label">');
          __out.push(__sanitize(value['displayName']));
          __out.push('</div>\n    </div>\n  ');
        }
      
        __out.push('\n  </div>\n  <div class="border-line"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/two_factor_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="error-row"></div>\n<div class="required-sites note">(Required by <span class="site-names"></span>)</div>\n<select class="tfa-picker">\n  <option value=enabled>Enabled</option>\n  <option value=disabled>Disabled</option>\n</select>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/two_factor_update_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Enable Two Factor Authentication</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      Enabling Two-Factor Authentication will immediately log all users out of Sisense.\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/usage_data_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, id, len, name, ref, ref1;
      
        __out.push('<div class="panel">\n  <div class="usage-data-area area">\n    <div class="area-header">Usage Data\n        <a href="/docv2/usage-data" target="_blank" rel="nofollow noopener noreferrer"><div class="link about-usage-data-link help-icon"></div></a>\n    </div>\n    <div class="area-body">\n      ');
      
        if (this.siteFamilyEnabled) {
          __out.push('\n      <p class="message">\n        Sisense usage data allows you to analyze and audit your own usage of Sisense. Users with edit access in the selected space will be able to <em>query the usage data of all spaces.</em> Usage data is available to query via the editor.\n      </p>\n        <div class="label spaces">Select which spaces can query usage data:</div>\n      <select class="site-picker">\n        <option value="">None</option>\n        ');
          ref = this.eligibleSites;
          for (i = 0, len = ref.length; i < len; i++) {
            ref1 = ref[i], id = ref1[0], name = ref1[1];
            __out.push('\n          <option value="');
            __out.push(__sanitize(id));
            __out.push('">');
            __out.push(__sanitize(name));
            __out.push('</option>\n        ');
          }
          __out.push('\n      </select>\n      ');
        } else {
          __out.push('\n        <p class="message">\n          Sisense usage data allows you to analyze and audit your own usage of Sisense. Usage data is queryable by users with edit access and is available via the editor.\n        </p>\n      ');
        }
      
        __out.push('\n      <div class=\'button-row\'></div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/user_api_key_generated_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<header>\n    <div class="cancel-icon"></div>\n    <span>Copy API Key</span>\n</header>\n<section class="modal-content">\n    <div class="body">\n      <p>This is your User API key. If you lose this key, you can revisit this page to generate a new one.\n      </p>\n      <p>API Key</p>\n      <div class="text-field">\n        <textarea class="api-key-input redesign-input" readonly>');
      
        __out.push(__sanitize(this.apiKey));
      
        __out.push('</textarea>\n      </div>\n      <p class="api-key-tooltip">Click to copy</p>\n    </div>\n    <div class="button-row">\n        <div class="right-aligned-buttons"></div>\n    </div>\n</section>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/settings/version_control"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="version-control-container"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tfa/tfa_setup_form_sidebar_flow"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="tfa-area">\n    <div class="tfa-header">\n    <h2>Two-Factor Authentication</h2>\n        <div class="form-row comment">\n            <span class="enabler-id">\n            ');
      
        if (this.userEnabled) {
          __out.push('\n                You have\n            ');
        } else {
          __out.push('\n                Your Site Administrator has\n            ');
        }
      
        __out.push('</span>\n            enabled Two-Factor Authentication for your account. Follow the instructions to complete setup.\n        </div>\n    </div>\n        <div class="tfa-content">\n            <div class="qrcode-wrapper"> <div class="qrcode" id="qr"></div> </div>\n         </div>\n                     <div class="qr-steps">\n                <ol>\n                    <li>\n                        <div class="form-row step"><b>Download and Install</b>\n                            <a class="link simple-link" target="_blank" href="https://www.authy.com/" rel="nofollow noopener noreferrer">Authy</a>,\n                            <a class="link simple-link" target="_blank" href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer">Google Authenticator,</a> or\n                            <a class="link simple-link" target="_blank" href="https://www.microsoft.com/en-us/store/apps/authenticator/9wzdncrfj3rj" rel="nofollow noopener noreferrer">Windows Phone Authenticator</a>.\n                        </div>\n                    </li>\n                    <li> <div class="form-row step"><b>Scan this QR Code</b></div></li>\n                    <li>\n                    <div class="form-row step last"><b>Enter Verification Code</b>\n                    <input autocomplete="off" type="text" oninput="this.value=this.value.replace(/[^0-9]/g,\'\')" id="vcode" name="vcode" autofocus="true" class="vcode redesign-input" placeholder="Code" maxlength="6">\n                    <div class="errors warning-icon"></div></div>\n                    </li>\n                 </ol>\n             </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tfa/tfa_success_sidebar_flow"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j, ref;
      
        __out.push('<div class="tfa-area">\n    <div class="tfa-header">\n    <h2>Two-Factor Authentication Successful!</h2>\n        <div class="form-row comment">\n            <span class="enabler-id">\n            ');
      
        if (this.userEnabled) {
          __out.push('\n                You have enabled\n            ');
        } else {
          __out.push('\n                Your Site Administrator has required\n            ');
        }
      
        __out.push('</span>\n            two factor authentication for your account. Complete setup to continue Periscoping!\n        </div>\n    </div>\n    <div class="tfa-content backup">\n    <div class="form-row comment">\n        If you lose access to your authentication device, use one of these backup codes to login to your account. Each code may be used only once.\n        Make a copy of these codes and store it somewhere safe.\n        <div class="backup-codes">\n            <table>\n            ');
      
        for (i = j = 0, ref = (this.backupCodes.length - 1) / 2; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
          __out.push('\n                  <tr> <td> ');
          __out.push(__sanitize(this.backupCodes[2 * i]));
          __out.push(' </td> <td> ');
          __out.push(__sanitize(this.backupCodes[2 * i + 1]));
          __out.push(' </td> </tr>\n            ');
        }
      
        __out.push('\n            </table>\n        </div>\n        <div class="form-row">\n          <div class="button proceed">Proceed to Sisense</div>\n          <div class="error-wrapper"><div class="error vcode-message"></div></div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/alert_tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="up-arrow">\n    <div class="inner"></div>\n</div>\n<div class="alert-flex-wrapper tooltip ');
      
        __out.push(__sanitize(this.alertState.alertLevel));
      
        __out.push('">\n    <div class="alert-sidebar"></div>\n    <div class="alert-border">\n        <div class="alert-icon"></div>\n        <div class="alert-body">\n            <div class="alert-reference">');
      
        __out.push(__sanitize(this.alertState.alertReference));
      
        __out.push('</div>\n            <div class="alert-message">');
      
        __out.push(__sanitize(this.alertState.alertMessage));
      
        __out.push('</div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/chart_tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var entry, i, len, ref;
      
        __out.push('<div class="tooltip-container">\n  <div class="y-val bold" style="border-bottom-color: ');
      
        __out.push(__sanitize(this.seriesColor));
      
        __out.push('">');
      
        __out.push(__sanitize(this.yVal));
      
        __out.push('</div>\n  ');
      
        if (this.details) {
          __out.push('\n    <div class="tooltip-extra-data" style="border-bottom-color: ');
          __out.push(__sanitize(this.seriesColor));
          __out.push('">\n      <table cellspacing=0 class="extra-data-table">\n        ');
          ref = this.details;
          for (i = 0, len = ref.length; i < len; i++) {
            entry = ref[i];
            __out.push('\n          <tr>\n            <td class="label">');
            __out.push(__sanitize(entry[0]));
            __out.push('</td>\n            <td class="value">');
            __out.push(__sanitize(entry[1]));
            __out.push('</td>\n          </tr>\n        ');
          }
          __out.push('\n      </table>\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="x-val bold">');
      
        __out.push(__sanitize(this.xVal));
      
        __out.push('</div>\n  ');
      
        if (this.seriesLabel !== '') {
          __out.push('\n    <div class="series-val bold">');
          __out.push(__sanitize(this.seriesLabel));
          __out.push('\n  ');
        }
      
        __out.push('\n  <div class=\'arrow\'></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/dialog_panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="panel">\n    <div class="dialog modal">\n      <header>\n          <div class="cancel-icon"></div>\n          <span class="title bold">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</span>\n      </header>\n      <div class="dialog-content panel-content"></div>\n    </div>\n    <div class="left pointer"></div>\n    <div class="right pointer"></div>\n    <div class="top pointer"></div>\n    <div class="bottom pointer"></div>\n    <div class="left pointer-border"></div>\n    <div class="right pointer-border"></div>\n    <div class="top pointer-border"></div>\n    <div class="bottom pointer-border"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="panel">\n    <h3 class="title">');
      
        __out.push(__sanitize(this.title));
      
        __out.push('</h3>\n    <div class="description">');
      
        __out.push(this.description);
      
        __out.push('</div>\n    <div class="escapedDescription">');
      
        __out.push(__sanitize(this.escapedDescription));
      
        __out.push('</div>\n    <div class="panel-content"></div>\n    <div class="left pointer"></div>\n    <div class="right pointer"></div>\n    <div class="top pointer"></div>\n    <div class="bottom pointer"></div>\n    <div class="left pointer-border"></div>\n    <div class="right pointer-border"></div>\n    <div class="top pointer-border"></div>\n    <div class="bottom pointer-border"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/super_tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="left-arrow"><div class="inner"></div></div>\n<div class="tooltip-header">\n  <div class="name"></div>\n  <div class="description"></div>\n  <div class="tags"></div>\n</div>\n<div class="tooltip-options">\n  <div class="option sql">SQL</div>\n  <div class="option code">CODE</div>\n</div>\n<div class="tooltip-body">\n  <div class="view-preview"></div>\n  <div class="properties"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tooltip/super_tooltip_props"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, len, prop, ref;
      
        __out.push('<table>\n  ');
      
        ref = this.propList;
        for (i = 0, len = ref.length; i < len; i++) {
          prop = ref[i];
          __out.push('\n    <tr>\n      <td class="prop-name">');
          __out.push(__sanitize(prop.name));
          __out.push('</td>\n      <td class="prop-value ');
          if (prop.statusClass) {
            __out.push(__sanitize(prop.statusClass));
          }
          __out.push('">');
          __out.push(__sanitize(prop.value));
          __out.push('</td>\n    </tr>\n  ');
        }
      
        __out.push('\n</table>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/tutorial/mole"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="mole-day-count');
      
        if (this.countdownOnly) {
          __out.push(__sanitize(' no-hover'));
        }
      
        __out.push('"">\n    <div class="number heavy-24-white-font">');
      
        __out.push(__sanitize(this.daysLeft));
      
        __out.push('</div>\n    <div class="days normal-10-white-font">DAYS</div>\n</div>\n');
      
        if (!this.countdownOnly) {
          __out.push('\n  <div class="tutorial-mole-popup');
          if (!this.showPopup) {
            __out.push(__sanitize(' closed'));
          }
          __out.push('">\n      <div class="pointer"></div>\n      <div class="title flex-fill-row">\n          <div class="text flex-filler">');
          __out.push(__sanitize(this.daysLeft));
          __out.push(' Days Left</div>\n          <div class="close"></div>\n      </div>\n      <ul>\n          ');
          if (this.showConnect) {
            __out.push('\n              <li data-menu-item="connect">Connect Database</li>\n          ');
          }
          __out.push('\n          ');
          if (this.showInvite) {
            __out.push('\n              <li data-menu-item="invite">Invite Colleagues</li>\n          ');
          }
          __out.push('\n          ');
          if (this.showCreate) {
            __out.push('\n              <li data-menu-item="create">Create Charts</li>\n          ');
          }
          __out.push('\n      </ul>\n      <div class="purchase-step">\n          <div class="button" data-menu-item="buy">buy now</div>\n          <div class="button" data-menu-item="contact">contact sales</div>\n          <div class="msg">Your sales rep, ');
          __out.push(__sanitize(this.salesEmailAddress));
          __out.push(', will be in touch with you shortly!</div>\n      </div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/view_dependencies/container"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="view-dependencies">\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/widgets/archived_widget"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'');
      
        __out.push(__sanitize(this.chartType));
      
        __out.push(' background-icon\'></div>\n<div class=\'archived-widget-title\'>\n  ');
      
        __out.push(__sanitize(this.title));
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/widgets/pivot_settings"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'pivot-settings\'>\n  <header class="title">\n    <h1>My Pivot Settings</h1>\n    <p id="reset-link">Reset to default</p>\n    <div id="cancel-icon"></div>\n  </header>\n  <header class="message-bar">\n    ');
      
        if (this.inEditron) {
          __out.push('\n      <div id="toggle-holder"></div>\n    ');
        }
      
        __out.push('\n    <span class="message">Changes made are visible&nbsp;</span>\n      ');
      
        if (!this.inEditron) {
          __out.push('\n        <span id="pivot-default-message">only to <span id="keyword">you</span></span>\n      ');
        } else {
          __out.push('\n        <span id="pivot-default-message">to <span id="keyword">everyone</span></span>\n      ');
        }
      
        __out.push('\n\n  </header>\n  <div class="pivot-box" id="fields">\n    <h2>Fields</h2>\n    <ul></ul>\n  </div>\n  <div class="pivot-box" id="filters">\n    <h2>Filters</h2>\n    <ul class="pivot-list"><div class=\'pivot-box-message\'>Drag fields here</div></ul>\n  </div>\n  <div class="pivot-box" id="columns">\n    <h2>Columns</h2>\n    <ul class="pivot-list"><div class=\'pivot-box-message\'>Drag fields here</div></ul>\n  </div>\n  <div class="pivot-box" id="rows">\n    <h2>Rows</h2>\n    <ul class="pivot-list"><div class=\'pivot-box-message\'>Drag fields here</div></ul>\n  </div>\n  <div class="pivot-box" id="values">\n    <h2>Values</h2>\n    <ul class="pivot-list"><div class=\'pivot-box-message\'>Drag fields here</div></ul>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/widgets/title"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="description-icon"></div>\n<div class="cover"></div>\n');
      
        if (this.editing) {
          __out.push('\n  <input class="widget-title" placeholder="Enter chart title" type="text" ');
          if (typeof app !== "undefined" && app !== null ? app.shared_mode : void 0) {
            __out.push(__sanitize('disabled="disabled"'));
          }
          __out.push(' value="');
          __out.push(__sanitize(this.title));
          __out.push('"></input>\n');
        } else {
          __out.push('\n  <div class="widget-title">');
          __out.push(__sanitize(this.title));
          __out.push('</div>\n');
        }
      
        __out.push('\n');
      
        if (this.shouldShowPivotOutsideOfMenu) {
          __out.push('\n  <div name="pivot" class="pivot button" data-tooltip="Edit Pivot"></div>\n');
        }
      
        __out.push('\n\n');
      
        if (!this.editing) {
          __out.push('\n  ');
          if (this.showPreviewLimitIcon) {
            __out.push('\n    <div class="limit-icon-container">\n      <div class=\'preview-limit-icon\'></div>\n    </div>\n  ');
          }
          __out.push('\n\n  <div class="controls">\n    <div name="refresh" class="refresh button" data-tooltip="Refresh Chart"></div>\n    \n    ');
          if (this.canEdit) {
            __out.push('\n      <div name="edit" class="edit button" data-tooltip="Edit Chart"></div>\n    ');
          }
          __out.push('\n\n    <div name="expand" class="expand button" data-tooltip="More Options"></div>\n  </div>\n');
        }
      
        __out.push('\n\n');
      
        if (this.showError) {
          __out.push('\n  <div class="widget-error">\n    <div class="error-message">');
          __out.push(__sanitize(this.errorMessage));
          __out.push('</div>\n    <div class="close-x"></div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/widgets/widget"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="flash-box"></div>\n<div class="title variable-left-margin"></div>\n<div class="alert-flex-wrapper chart">\n    <div class="alert-sidebar"></div>\n    <div class="alert-scroll">\n        <div class="alert-icon"></div>\n        <div class="alert-body">\n            <div class="alert-reference"></div>\n            <div class="alert-message"></div>\n        </div>\n    </div>\n</div>\n<div class="widget-content variable-left-margin">\n  <div class="chart-container" id="');
      
        __out.push(__sanitize(this.renderGuid));
      
        __out.push('"></div>\n</div>\n<div class="resize-handle ui-resizable-handle ui-resizable-se"></div>\n<div class="border t"></div>\n<div class="border r"></div>\n<div class="border l"></div>\n<div class="border b"></div>\n<div class="error-message">Query returned no matching rows.</div>\n<div class="loader widget-loader">\n  <div class="loader-strip"></div>\n  <div class="label-holder">\n    <div class="label loading">\n      <div class="spinner"></div>\n      <div class=\'text-below-spinner\'>Loading</div>\n    </div>\n    <div class="label waiting">');
      
        __out.push(__sanitize(this.waitingText));
      
        __out.push('</div>\n  </div>\n</div>\n<div class="loader materializing">\n  <div class="spinner"></div>\n  <div class=\'text-below-spinner\'>Materializing CSV...</div>\n</div>\n<div class="resize-dimensions">\n  <span class="width"></span> x <span class="height"></span>\n</div>\n<div class="resize-warning">Resize may change the dashboard layout. <span class="bold link">Undo</span> </div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/redesign/widgets/widget_color_themes"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var color, i, len, ref;
      
        __out.push('<div class="top-label widget-theme-selection">\n  <div class="default-theme-container">\n    <div class="color-theme color-theme-row" obj-id="');
      
        __out.push(__sanitize(this.defaultTheme.cid));
      
        __out.push('">\n      <div class="dashboard-theme-name">\n        ');
      
        if (this.useParentTheme && !this.isCustomTheme) {
          __out.push('\n          <span>Dashboard Theme </span><span class="normal-12-mirage-font">(');
          __out.push(__sanitize(this.defaultTheme.name));
          __out.push(')</span>\n        ');
        } else {
          __out.push('\n          ');
          __out.push(__sanitize(this.defaultTheme.name));
          __out.push('\n        ');
        }
      
        __out.push('\n      </div>\n      <div class="widget-color-row">\n        ');
      
        ref = this.defaultTheme.displayColors(14);
        for (i = 0, len = ref.length; i < len; i++) {
          color = ref[i];
          __out.push('\n          <div class="color-square dashboard" style="background-color: ');
          __out.push(__sanitize(color));
          __out.push('"></div>\n        ');
        }
      
        __out.push('\n        ');
      
        if (this.defaultTheme.colorList().length > 14) {
          __out.push('\n          <span>...</span>\n        ');
        }
      
        __out.push('\n      </div>\n    </div>\n  </div>\n  <div class="icon expando"></div>\n</div>\n<div class="scroll-container">\n  <div class="widget-body">\n    <div class="color-theme-box default"></div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/reload/reload_modal"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="message">\n    Recent changes to Sisense require this tab to reload. Click Reload to continue.\n</div>\n<div class="button-row">\n    <div class="button"><div class="label">Reload</div></div>\n</div>\n\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/resize_handle"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="resize-handle ui-resizable-handle ui-resizable-se"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/salesforce_live_chat"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<script type=\'text/javascript\'>\n  var initESW = function(gslbBaseURL) {\n    embedded_svc.settings.displayHelpButton = true; //Or false\n    embedded_svc.settings.language = \'\'; //For example, enter \'en\' or \'en-US\'\n\n    //embedded_svc.settings.defaultMinimizedText = \'...\'; //(Defaults to Chat with an Expert)\n    //embedded_svc.settings.disabledMinimizedText = \'...\'; //(Defaults to Agent Offline)\n\n    //embedded_svc.settings.loadingText = \'\'; //(Defaults to Loading)\n    //embedded_svc.settings.storageDomain = \'yourdomain.com\'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)\n\n    //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {\n      // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.\n      // Returns a valid button ID.\n    //};\n    embedded_svc.settings.prepopulatedPrechatFields = {\n      FirstName: \'');
      
        __out.push(__sanitize(this.firstName));
      
        __out.push('\',\n      LastName: \'');
      
        __out.push(__sanitize(this.lastName));
      
        __out.push('\',\n      Email: \'');
      
        __out.push(__sanitize(this.email));
      
        __out.push('\',\n      Subject: \'take this field from either user select field or hidden\'\n    }; //Sets the auto-population of pre-chat form fields\n    //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId\n    //embedded_svc.settings.offlineSupportMinimizedText = \'...\'; //(Defaults to Contact Us)\n\n    embedded_svc.settings.enabledFeatures = [\'LiveAgent\'];\n    embedded_svc.settings.entryFeature = \'LiveAgent\';\n\n    embedded_svc.init(\n      \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcBaseUrl));
      
        __out.push('\',\n      \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcSurveyUrl));
      
        __out.push('\',\n      gslbBaseURL,\n      \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcCode));
      
        __out.push('\',\n      \'CDT_Chat\',\n      {\n        baseLiveAgentContentURL: \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcBaseLiveAgentContentUrl));
      
        __out.push('\',\n        deploymentId: \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcDeploymentId));
      
        __out.push('\',\n        buttonId: \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcButtonId));
      
        __out.push('\',\n        baseLiveAgentURL: \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcBaseLiveAgentUrl));
      
        __out.push('\',\n        eswLiveAgentDevName: \'CDT_Chat\',\n        isOfflineSupportEnabled: true\n      }\n    );\n  };\n\n  if (!window.embedded_svc) {\n    var s = document.createElement(\'script\');\n    s.setAttribute(\'src\', \'');
      
        __out.push(__sanitize(this.salesforceEmbeddedSvcSrcAttribute));
      
        __out.push('\');\n    s.onload = function() {\n      initESW(null);\n    };\n    document.body.appendChild(s);\n  } else {\n    initESW(\'https://service.force.com\');\n  }\n</script>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/settings/signout_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="button-row">\n    <div class="button inert">Sign Out</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/settings/site_item"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="item site ');
      
        __out.push(__sanitize(this.current ? 'current' : ''));
      
        __out.push('" host=');
      
        __out.push(__sanitize(this.host));
      
        __out.push('>\n  <div class="label ');
      
        if (!this.current) {
          __out.push(__sanitize('link'));
        }
      
        __out.push('"><span class="site-name">');
      
        __out.push(__sanitize(this.name));
      
        __out.push('</span></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/settings/site_two_factor_confirmation_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="site-two-factor-confirmation update-area">\n    <div class="warning-icon-cell"><div class="warning-icon"></div></div>\n    <span>Enabling Two-Factor Authentication will <span class="scary-red">immediately</span> log all users <span class="scary-red">out</span> of Sisense.\n    </span>\n    <br/>\n\n    <div class="row errors">\n        <div class="error"></div>\n    </div>\n\n    <div class="confirmation-row">\n        <div class="button destructive proceed">Proceed</div>\n        <div class="button cancel dark-theme inert">Cancel</div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/settings/site_two_factor_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="site-two-factor-form header-form">\n    <div class="row provider-type dark-theme">\n        <select class="select-enable-tfa">\n            <option value="disabled">Disabled</option>\n            <option value="enabled">Enabled</option>\n        </select>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/settings/sites"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="scroll-container">\n  <div class="items">\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/signup/frame"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="content signup light-theme">\n  <h1>Connect to Sisense</h1>\n  <div class="details">Enter your database information to get started with Sisense.</div>\n  <div class="signup-form light-theme"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/sso/sso_update_form"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="sso-update-form">\n  <div class="update-area">\n    Updating your SSO configuration will <span class="scary-red">immediately</span> log all users out of Sisense.\n    <br/>\n    Type <span class="scary-red">Logout</span> to update your SSO configuration.\n    <div class="form-row">\n      <input class="update-confirm"></input><div class="button destructive update disabled">Confirm</div>\n    </div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/toggler/toggler"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="toggler-container">\n');
      
        if (this.leftLabelText) {
          __out.push('\n  <div class="toggler-label left">');
          __out.push(__sanitize(this.leftLabelText));
          __out.push('</div>\n');
        }
      
        __out.push('\n<div class="toggler ');
      
        __out.push(__sanitize(this.displayClass));
      
        __out.push('"><div class="ball ');
      
        __out.push(__sanitize(this.ballState));
      
        __out.push('"></div></div>\n<div class="toggler-label right">');
      
        __out.push(__sanitize(this.rightLabelText));
      
        __out.push('</div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/tooltip"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var entry, i, len, ref;
      
        __out.push('<div class="tooltip-container">\n  <div class="y-val" style="border-bottom-color: ');
      
        __out.push(__sanitize(this.seriesColor));
      
        __out.push('">');
      
        __out.push(__sanitize(this.yVal));
      
        __out.push('</div>\n  ');
      
        if (this.details) {
          __out.push('\n    <div class="tooltip-extra-data" style="border-bottom-color: ');
          __out.push(__sanitize(this.seriesColor));
          __out.push('">\n      <table cellspacing=0 class="extra-data-table">\n        ');
          ref = this.details;
          for (i = 0, len = ref.length; i < len; i++) {
            entry = ref[i];
            __out.push('\n          <tr>\n            <td class="label">');
            __out.push(__sanitize(entry[0]));
            __out.push('</td>\n            <td class="value">');
            __out.push(__sanitize(entry[1]));
            __out.push('</td>\n          </tr>\n        ');
          }
          __out.push('\n      </table>\n    </div>\n  ');
        }
      
        __out.push('\n  <div class="x-val">');
      
        __out.push(__sanitize(this.xVal));
      
        __out.push('</div>\n  ');
      
        if (this.seriesLabel !== '') {
          __out.push('\n    <div class="series-val">');
          __out.push(__sanitize(this.seriesLabel));
          __out.push('\n  ');
        }
      
        __out.push('\n  <div class=\'arrow\'></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/tooltip/badge"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="bold">Marked Official</div>\n<div class="badge-tooltip-context">by ');
      
        __out.push(__sanitize(this.userString));
      
        __out.push(' on ');
      
        __out.push(__sanitize(this.dateString));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/tooltip/panel"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="panel">\n  <h3 class="title">');
      
        __out.push(this.title);
      
        __out.push('</h3>\n  <div class="description">');
      
        __out.push(this.description);
      
        __out.push('</div>\n  <div class="panel-content"></div>\n  <div class="left pointer"></div>\n  <div class="right pointer"></div>\n  <div class="top pointer"></div>\n  <div class="bottom pointer"></div>\n  <div class="left pointer-border"></div>\n  <div class="right pointer-border"></div>\n  <div class="top pointer-border"></div>\n  <div class="bottom pointer-border"></div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/tooltip/tutorial_link"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<span class="close"></span>\n<div class=\'text\'>');
      
        __out.push(this.titleText);
      
        __out.push('</div><a class=\'dinpro13\' target=\'_blank\' href=\'');
      
        __out.push(__sanitize(this.linkUrl));
      
        __out.push('\' rel=\'nofollow noopener noreferrer\'>Learn More</a>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/tooltip_content"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class=\'tooltip-content\'>');
      
        __out.push(__sanitize(this.tooltipValue));
      
        __out.push('</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/walkme"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<!-- Begin WalkMe code -->\n\n  <script type="text/javascript">\n    (function() {\n      var walkme = document.createElement(\'script\');\n      walkme.id = \'walkme-script\';\n      walkme.type = \'text/javascript\';\n      walkme.async = true;\n      walkme.src = \'https://cdn.walkme.com/users/7ece3de57f93477fb3080b6db24e1490/walkme_7ece3de57f93477fb3080b6db24e1490_https.js\';\n\n      var s = document.getElementsByTagName(\'script\')[0];\n      s.parentNode.insertBefore(walkme, s);\n      window._walkmeConfig = { smartLoad: true }\n    })();\n</script>\n\n<!-- End WalkMeCode -->\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/chart_overlay"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="bignumber-content">\n  <div class="latest-value"></div>\n  <div class="chart-title"></div>\n</div>\n<div class="original-value"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/pivot_field"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        var i, j, len, len1, name, ref, ref1;
      
        __out.push('<div class=\'field-wrapper\' column="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n    <li class=\'field\'>\n        <span>');
      
        __out.push(__sanitize(this.column));
      
        __out.push('</span>\n    </li>\n    <div class="filter-options func-and-type">\n        <div class="func dropdown">\n            <span id=\'selected\'> ');
      
        __out.push(__sanitize(this.selectedFilterFunc));
      
        __out.push('</span>\n            <div class="func-list details" fieldName="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n                ');
      
        ref = this.availableFuncs['comparisons'];
        for (i = 0, len = ref.length; i < len; i++) {
          name = ref[i];
          __out.push('\n                <div class =\'func-option\' data-func-type="');
          __out.push(__sanitize(name));
          __out.push('"> ');
          __out.push(__sanitize(name));
          __out.push('</div>\n                ');
        }
      
        __out.push('\n            </div>\n        </div>\n        <div id="filter-input"><input type="text" class="filter-value" value="');
      
        __out.push(__sanitize(this.selectedFilter));
      
        __out.push('" ></input></div>\n    </div>\n    <div class="value-options func-and-type">\n        <div class="func dropdown">\n            <span id=\'selected\'> ');
      
        __out.push(__sanitize(this.selectedValueFunc));
      
        __out.push('</span>\n            <div class="func-list details" fieldName="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n                ');
      
        ref1 = this.availableFuncs['aggregations'];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          name = ref1[j];
          __out.push('\n                <div class ="func-option" data-func-type="');
          __out.push(__sanitize(name));
          __out.push('">');
          __out.push(__sanitize(name));
          __out.push('</div>\n                ');
        }
      
        __out.push('\n            </div>\n        </div>\n        <div class="type dropdown">\n            <span id=\'selected\'> ');
      
        __out.push(__sanitize(this.selectedValue));
      
        __out.push(' </span>\n            <div class="type-list details" fieldName="');
      
        __out.push(__sanitize(this.column));
      
        __out.push('">\n                <div class="func-option" data-func-type="numeric" data-func-name="Number">Number</div>\n                <div class="func-option currency-dropdown" data-func-type="currency" data-func-name="Currency">\n                    <ul class="currency">\n                        <li>$</li>\n                        <li>€</li>\n                        <li>£</li>\n                        <li>₩</li>\n                        <li>₹</li>\n                        <li>Sek</li>\n                        <li>R</li>\n                        <li>₺</li>\n                    </ul>\n                </div>\n                <div class ="func-option" data-func-type="percent" data-func-name="Percentage">Percentage</div>\n                <div class ="func-option" data-func-type="percent_of_column" data-func-name="% of column">Percentage of column</div>\n                <div class ="func-option" data-func-type="percent_of_row" data-func-name="% of row">Percentage of row</div>\n            </div>\n        </div>\n    </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/text_chart"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="text-area"></div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/title"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="description-icon"></div>\n<div class="cover"></div>\n<input type="text" ');
      
        if (typeof app !== "undefined" && app !== null ? app.shared_mode : void 0) {
          __out.push(__sanitize('disabled="disabled"'));
        }
      
        __out.push(' value="');
      
        __out.push(__sanitize(this.title));
      
        __out.push('"></input>\n\n<div class="controls">\n\n  ');
      
        if (this.editing) {
          __out.push('\n    ');
          if (this.showPivotIcon) {
            __out.push('\n      <div name="pivot" class="pivot button" title="Pivot Table"></div>\n    ');
          }
          __out.push('\n    ');
          if (this.showCopyIcon) {
            __out.push('\n      <div name="copy" class="copy button" title="Copy to Clipboard"></div>\n    ');
          }
          __out.push('\n    <div class="status-icon ');
          __out.push(__sanitize(this.statusIconColor));
          __out.push('"></div>\n  ');
        } else {
          __out.push('\n    <div name="edit" class="edit button" title="Edit Chart"></div>\n    <div name="refresh" class="refresh button" title="Refresh Data"></div>\n    ');
          if (this.showExpand) {
            __out.push('\n      <div name="expand" class="expand button" title="More"></div>\n    ');
          }
          __out.push('\n  ');
        }
      
        __out.push('\n</div>\n\n');
      
        if (this.showDebug) {
          __out.push('\n<div class="debug-ids">\n  w: <div name="w-id" class="debug-widget-id">');
          __out.push(__sanitize(this.debugInfo['id']));
          __out.push('</div>\n  rs: <div class="debug-rs">');
          __out.push(__sanitize(this.debugInfo['rs']));
          __out.push('</div>\n  &#x29d7;:<div class="debug-time">');
          __out.push(__sanitize(this.debugInfo['time']));
          __out.push('</div>\n</div>\n');
        }
      
        __out.push('\n');
      
        if (this.showError) {
          __out.push('\n  <div class="widget-error">\n    <div class="error-message">');
          __out.push(__sanitize(this.errorMessage));
          __out.push('</div>\n    <div class="close-x"></div>\n  </div>\n');
        }
      
        __out.push('\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/widget"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="flash-box"></div>\n<div class="title"></div>\n<div class="widget-content">\n  <div class="chart-container" id="');
      
        __out.push(__sanitize(this.renderGuid));
      
        __out.push('"></div>\n</div>\n<div class="resize-handle ui-resizable-handle ui-resizable-se"></div>\n<div class="border t"></div>\n<div class="border r"></div>\n<div class="border l"></div>\n<div class="border b"></div>\n<div class="chart-message"></div>\n<div class="no-data-message">Query returned no results.</div>\n<div class="loader widget-loader">\n  <div class="label-holder">\n    <div class="label loading"><span class=\'msg\'>Loading...</span>\n        <span class="spinner"></span>\n    </div>\n    <div class="label waiting">');
      
        __out.push(__sanitize(this.waitingText));
      
        __out.push('</div>\n  </div>\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/widgets/widget_menu"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<div class="widget-menu">\n    ');
      
        if (this.showPivotIcon) {
          __out.push('\n        <div name="pivot" class="menu-item pivot">\n            <div class="pivot button"></div>\n            <div class="text">Edit Pivot</div>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showSearchIcon) {
          __out.push('\n        <div name="search" class="menu-item search">\n            <div class="search button"></div>\n            <div class="text">Search</div>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (!AppRedesign.current().shared_mode && (this.showPivotIcon || this.showSearchIcon) && (this.showImageIcon || this.showCsvIcon)) {
          __out.push('\n        <div class="border"></div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showImageIcon) {
          __out.push('\n        <div name="image" class="menu-item image">\n            <a class="image button"></a>\n            <a class="text">Download Image</a>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showCsvIcon) {
          __out.push('\n        <div name="csv" class="menu-item csv">\n            <div class="csv button"></div>\n            <div class="text">Download Data</div>\n            <div class="text detail">');
          __out.push(__sanitize(this.rowsText));
          __out.push('</div>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showLinkIcon) {
          __out.push('\n        <div name="link" class="menu-item link">\n            <div class="link button"></div>\n            <div class="text">Share Link</div>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showSlackIcon) {
          __out.push('\n        <div name="slack" class="menu-item slack">\n            <div class="slack button"></div>\n            <div class="text">Post to Slack</div>\n        </div>\n    ');
        }
      
        __out.push('\n    ');
      
        if (this.showEditCopyIcon) {
          __out.push('\n    <div name="edit-copy" class="menu-item edit-copy">\n        <div class="edit-copy button"></div>\n        <div class="text">Edit as Copy</div>\n    </div>\n    ');
        }
      
        __out.push('\n</div>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() { this.JST || (this.JST = {}); this.JST["app/views/wix_live_chat"] = function(__obj) {
    if (!__obj) __obj = {};
    var __out = [], __capture = function(callback) {
      var out = __out, result;
      __out = [];
      callback.call(this);
      result = __out.join('');
      __out = out;
      return __safe(result);
    }, __sanitize = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else if (typeof value !== 'undefined' && value != null) {
        return __escape(value);
      } else {
        return '';
      }
    }, __safe, __objSafe = __obj.safe, __escape = __obj.escape;
    __safe = __obj.safe = function(value) {
      if (value && value.ecoSafe) {
        return value;
      } else {
        if (!(typeof value !== 'undefined' && value != null)) value = '';
        var result = new String(value);
        result.ecoSafe = true;
        return result;
      }
    };
    if (!__escape) {
      __escape = __obj.escape = function(value) {
        return ('' + value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
    }
    (function() {
      (function() {
        __out.push('<script type="text/javascript">\n    !(function () {\n        function e() {\n            var e = document.createElement("script");\n            (e.type = "text/javascript"), (e.async = !0), (e.src = "');
      
        __out.push(__sanitize(this.embedJsUrl));
      
        __out.push('");\n            var t = document.getElementsByTagName("script")[0];\n            t.parentNode.insertBefore(e, t);\n        }\n        e() // We\'ll handle delaying the init\n\n        // Wix provides us script that adds Live Chat on \'load\' event on window.\n        // But we would like to add Live Chat to uiQueue pipeline and start when we want it.\n        // That\'s why comment-out part about \'load\' event, but keep commented code.\n        //\n        // window.addEventListener ? window.addEventListener("load", e) : window.attachEvent("onload", e),\n\n        window.AnswersWidget = {\n            onLoaded: function (e) {\n                window.AnswersWidget.queue.push(e);\n            },\n            queue: [],\n        };\n\n        window.AnswersWidget.onLoaded(() => {\n            window.AnswersWidget.setCustomFields({company: "');
      
        __out.push(__sanitize(this.company));
      
        __out.push('"});\n            window.AnswersWidget.addAuthenticationFn(');
      
        __out.push(this.addAuth);
      
        __out.push(');\n            window.AnswersWidget.onWidgetOpened(');
      
        __out.push(this.onWidgetOpened);
      
        __out.push(');\n            window.AnswersWidget.onChatStarted(');
      
        __out.push(this.onChatStarted);
      
        __out.push(');\n        });\n    })();\n</script>\n');
      
      }).call(this);
      
    }).call(__obj);
    __obj.safe = __objSafe, __obj.escape = __escape;
    return __out.join('');
  };
}).call(this);
(function() {
  var $, Path, Route, Spine, escapeRegExp, hashStrip, namedParam, splatParam,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  Spine = this.Spine || require('spine');

  $ = Spine.$;

  hashStrip = /^#*/;

  namedParam = /:([\w\d]+)/g;

  splatParam = /\*([\w\d]+)/g;

  escapeRegExp = /[-[\]{}()+?.,\\^$|#\s]/g;

  Path = (function(superClass) {
    extend(Path, superClass);

    function Path(path, callback) {
      var match;
      this.names = [];
      this.path = path;
      this.callback = callback;
      if (typeof path === 'string') {
        namedParam.lastIndex = 0;
        while ((match = namedParam.exec(path)) !== null) {
          this.names.push(match[1]);
        }
        splatParam.lastIndex = 0;
        while ((match = splatParam.exec(path)) !== null) {
          this.names.push(match[1]);
        }
        path = path.replace(escapeRegExp, '\\$&').replace(namedParam, '([^\/]*)').replace(splatParam, '(.*?)');
        this.route = new RegExp("^" + path + "$");
      } else {
        this.route = path;
      }
    }

    Path.prototype.match = function(path, options) {
      var i, j, len, match, param, params;
      if (options == null) {
        options = {};
      }
      if (!(match = this.route.exec(path))) {
        return false;
      }
      options.match = match;
      params = match.slice(1);
      if (this.names.length) {
        for (i = j = 0, len = params.length; j < len; i = ++j) {
          param = params[i];
          options[this.names[i]] = param;
        }
      }
      Route.trigger('before', this);
      return this.callback.call(null, options) !== false;
    };

    return Path;

  })(Spine.Module);

  Route = (function(superClass) {
    var ref;

    extend(Route, superClass);

    Route.extend(Spine.Events);

    Route.historySupport = ((ref = window.history) != null ? ref.pushState : void 0) != null;

    Route.options = {
      trigger: true,
      history: false,
      shim: false,
      replace: false,
      redirect: false
    };

    Route.routers = [];

    Route.setup = function(options) {
      if (options == null) {
        options = {};
      }
      this.options = $.extend({}, this.options, options);
      if (this.options.shim) {
        return;
      }
      if (this.options.history) {
        this.history = this.historySupport;
        $(window).on('popstate', this.change);
      } else {
        $(window).on('hashchange', this.change);
      }
      return this.change();
    };

    Route.unbind = function() {
      var unbindResult;
      if (this.options.shim) {
        return;
      }
      unbindResult = Spine.Events.unbind.apply(this, arguments);
      if (arguments.length > 0) {
        return unbindResult;
      }
      if (this.history) {
        return $(window).off('popstate', this.change);
      } else {
        return $(window).off('hashchange', this.change);
      }
    };

    Route.navigate = function() {
      var args, lastArg, options, path, routes;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      options = {};
      lastArg = args[args.length - 1];
      if (typeof lastArg === 'object') {
        options = args.pop();
      } else if (typeof lastArg === 'boolean') {
        options.trigger = args.pop();
      }
      options = $.extend({}, this.options, options);
      path = args.join('/');
      if (this.path === path) {
        return;
      }
      this.path = path;
      if (options.trigger) {
        this.trigger('navigate', this.path);
        routes = this.matchRoutes(this.path, options);
        if (!routes.length) {
          if (typeof options.redirect === 'function') {
            return options.redirect.apply(this, [this.path, options]);
          } else {
            if (options.redirect === true) {
              this.redirect(this.path);
            }
          }
        }
      }
      if (options.shim) {
        return true;
      } else if (this.history && options.replace) {
        return history.replaceState({}, document.title, this.path);
      } else if (this.history) {
        return history.pushState({}, document.title, this.path);
      } else {
        return window.location.hash = this.path;
      }
    };

    Route.create = function() {
      var router;
      router = new this;
      this.routers.push(router);
      return router;
    };

    Route.add = function(path, callback) {
      return this.router.add(path, callback);
    };

    Route.prototype.add = function(path, callback) {
      var key, results, value;
      if (typeof path === 'object' && !(path instanceof RegExp)) {
        results = [];
        for (key in path) {
          value = path[key];
          results.push(this.add(key, value));
        }
        return results;
      } else {
        return this.routes.push(new Path(path, callback));
      }
    };

    Route.prototype.destroy = function() {
      var r;
      this.routes.length = 0;
      return this.constructor.routers = (function() {
        var j, len, ref1, results;
        ref1 = this.constructor.routers;
        results = [];
        for (j = 0, len = ref1.length; j < len; j++) {
          r = ref1[j];
          if (r !== this) {
            results.push(r);
          }
        }
        return results;
      }).call(this);
    };

    Route.getPath = function() {
      var path;
      if (this.history) {
        path = window.location.pathname;
        if (path.substr(0, 1) !== '/') {
          path = '/' + path;
        }
      } else {
        path = window.location.hash;
        path = path.replace(hashStrip, '');
      }
      return path;
    };

    Route.getHost = function() {
      return window.location.protocol + "//" + window.location.host;
    };

    Route.change = function() {
      var path;
      path = Route.getPath();
      if (path === Route.path) {
        return;
      }
      Route.path = path;
      return Route.matchRoutes(Route.path);
    };

    Route.matchRoutes = function(path, options) {
      var j, len, match, matches, ref1, router;
      matches = [];
      ref1 = this.routers.concat([this.router]);
      for (j = 0, len = ref1.length; j < len; j++) {
        router = ref1[j];
        match = router.matchRoute(path, options);
        if (match) {
          matches.push(match);
        }
      }
      if (matches.length) {
        this.trigger('change', matches, path);
      }
      return matches;
    };

    Route.redirect = function(path) {
      return window.location = path;
    };

    function Route() {
      this.routes = [];
    }

    Route.prototype.matchRoute = function(path, options) {
      var j, len, ref1, route;
      ref1 = this.routes;
      for (j = 0, len = ref1.length; j < len; j++) {
        route = ref1[j];
        if (route.match(path, options)) {
          return route;
        }
      }
    };

    Route.prototype.trigger = function() {
      var args, ref1;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      args.splice(1, 0, this);
      return (ref1 = this.constructor).trigger.apply(ref1, args);
    };

    return Route;

  })(Spine.Module);

  Route.router = new Route;

  Spine.Controller.include({
    route: function(path, callback) {
      if (this.router instanceof Spine.Route) {
        return this.router.add(path, this.proxy(callback));
      } else {
        return Spine.Route.add(path, this.proxy(callback));
      }
    },
    routes: function(routes) {
      var key, results, value;
      results = [];
      for (key in routes) {
        value = routes[key];
        results.push(this.route(key, value));
      }
      return results;
    },
    navigate: function() {
      return Spine.Route.navigate.apply(Spine.Route, arguments);
    }
  });

  Route.Path = Path;

  Spine.Route = Route;

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Route;
  }

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    slice = [].slice;

  App.AddSqlHintToCodeMirror = (function() {
    AddSqlHintToCodeMirror.CRITICAL_PATH_WORDS = ['by', 'as', 'and', 'from', 'select', 'where', 'group', 'order'];

    AddSqlHintToCodeMirror.MAX_RESULTS = 100;

    AddSqlHintToCodeMirror.codeMirrorKeyPressHook = function(cm) {
      return setTimeout((function() {
        return AddSqlHintToCodeMirror.showHint(cm);
      }), 100);
    };

    AddSqlHintToCodeMirror.codeMirrorKeyUpHook = function(cm, event) {
      if (event.which !== AppRedesign.KEYS.BACKSPACE) {
        return;
      }
      return setTimeout(function() {
        return AddSqlHintToCodeMirror.showHint(cm);
      });
    };

    AddSqlHintToCodeMirror.showHint = function(cm) {
      return CodeMirror.showHint(cm, CodeMirror.hint.sql, {
        completeSingle: false,
        completeOnSingleClick: true
      });
    };

    AddSqlHintToCodeMirror.call = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return ((function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(this, args, function(){})).call();
    };

    function AddSqlHintToCodeMirror(codeMirror, databaseCallback) {
      this.codeMirror = codeMirror;
      this.databaseCallback = databaseCallback;
      this.get = bind(this.get, this);
    }

    AddSqlHintToCodeMirror.prototype.call = function() {
      CodeMirror.registerHelper('hint', 'sql', this.get);
      this.codeMirror.on('keypress', this.constructor.codeMirrorKeyPressHook);
      return this.codeMirror.on('keydown', this.constructor.codeMirrorKeyUpHook);
    };

    AddSqlHintToCodeMirror.prototype.get = function(editor) {
      var cursor, hasPeriod, prefix, prevToken, token;
      cursor = editor.getCursor(null);
      token = editor.getTokenAt(cursor);
      prevToken = this.getPrevToken(editor, cursor, token);
      if (prevToken.type === "number" && prevToken.end === token.start) {
        token = this.mergeTokens(prevToken, token);
        prevToken = this.getPrevToken(editor, cursor, prevToken);
      }
      hasPeriod = _.includes(token != null ? token.string : void 0, '.');
      prefix = this.getPrefixFromToken(token, prevToken);
      return {
        list: this.getHints(prefix, prevToken, hasPeriod),
        from: CodeMirror.Pos(cursor.line, token.end - prefix.length),
        to: CodeMirror.Pos(cursor.line, token.end)
      };
    };

    AddSqlHintToCodeMirror.prototype.mergeTokens = function(prevToken, token) {
      return {
        end: token.end,
        start: prevToken.start,
        state: token.state,
        string: prevToken.string + token.string,
        type: null
      };
    };

    AddSqlHintToCodeMirror.prototype.getAllStringsForDatabase = function(prevToken) {
      var database;
      database = App.Database.exists(this.databaseId());
      if (!database) {
        return [];
      }
      return database.getAutocompleteList(prevToken);
    };

    AddSqlHintToCodeMirror.prototype.getPrefixFromToken = function(token, prevToken) {
      var str;
      if ((token != null ? token.string : void 0) == null) {
        return "";
      }
      str = token.string.trim();
      return str.split('.').last().replace(/[^\w]+/, '');
    };

    AddSqlHintToCodeMirror.prototype.getPrevToken = function(editor, cursor, curToken) {
      var backPos;
      try {
        backPos = new CodeMirror.Pos(cursor.line, curToken.start);
        if (/\s+/.test(editor.getTokenAt(backPos).string)) {
          backPos = new CodeMirror.Pos(cursor.line, curToken.start - 1);
        }
        return editor.getTokenAt(backPos);
      } catch (error) {
        return null;
      }
    };

    AddSqlHintToCodeMirror.prototype.databaseId = function() {
      return this.databaseCallback().id;
    };

    AddSqlHintToCodeMirror.prototype.isRestrictedDataSource = function() {
      return this.databaseCallback().is_restricted;
    };

    AddSqlHintToCodeMirror.prototype.getCurrentQueryTokens = function(prefix) {
      return this.codeMirror.getValue().split(/\W+/).without(prefix);
    };

    AddSqlHintToCodeMirror.prototype.getStandardStrings = function(prevToken, prefix) {
      var allHints, ref;
      if (((ref = AppRedesign.current()) != null ? ref.restrictDatabasesEnabled : void 0) && this.isRestrictedDataSource()) {
        allHints = _.concat(this.getCurrentQueryTokens(prefix), this.constructor.CRITICAL_PATH_WORDS, this.getAllStringsForDatabase(prevToken), ['daterange', 'daterange_start', 'daterange_end']);
      } else {
        allHints = _.concat(this.getCurrentQueryTokens(prefix), this.constructor.CRITICAL_PATH_WORDS, this.getAllStringsForDatabase(prevToken), App.CustomDimension.wordsForSqlHints(), App.SqlSnippet.wordsForSqlHints(), App.SqlView.wordsForSqlHints(), App.CsvView.wordsForSqlHints());
      }
      return App.Utils.caseInsensitiveUniq(allHints);
    };

    AddSqlHintToCodeMirror.prototype.getAllColumnsMatchingTable = function(table) {
      var db, i, len, publicTables, ref, schema, schemaTables;
      db = App.Database.exists(this.databaseId());
      if (!db) {
        return [];
      }
      if (db.schemas().indexOf(table) > -1) {
        return this.getAllTablesMatchingSchema(db, table);
      }
      publicTables = db.getTableColumns(table);
      if (!publicTables.isEmpty()) {
        return publicTables;
      }
      schemaTables = [];
      ref = db.schemas();
      for (i = 0, len = ref.length; i < len; i++) {
        schema = ref[i];
        schemaTables = schemaTables.concat(db.getTableColumns(schema + "." + table));
      }
      return App.Utils.caseInsensitiveUniq(schemaTables);
    };

    AddSqlHintToCodeMirror.prototype.getAllTablesMatchingSchema = function(db, schema) {
      var i, len, ref, results, schemaDot, t;
      schemaDot = schema + ".";
      ref = db.getTableNames();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        t = ref[i];
        if (t.indexOf(schemaDot) === 0) {
          results.push(t.split('.').last());
        }
      }
      return results;
    };

    AddSqlHintToCodeMirror.prototype.getHintsMatchingPrefix = function(prefix, prevToken, isDottedString) {
      var allHints;
      allHints = isDottedString ? this.getAllColumnsMatchingTable(prevToken) : [];
      if (_.isEmpty(prefix)) {
        return allHints;
      }
      if (_.isEmpty(allHints)) {
        allHints = this.getStandardStrings(prevToken, prefix);
      }
      return _.filter(allHints, function(hint) {
        return _(hint.toLowerCase()).startsWith(prefix.toLowerCase());
      }).slice(0, this.constructor.MAX_RESULTS);
    };

    AddSqlHintToCodeMirror.functionHintRenderer = function(elt, data, cur) {
      return $(elt).html(JST["app/views/editors/function_hint"]({
        functionName: cur.functionName,
        details: cur.details
      }));
    };

    AddSqlHintToCodeMirror.prototype.annotateFunctionHints = function(hintStrings) {
      var db, details, detailsList, hintString, i, j, len, len1, newHints;
      db = App.Database.exists(this.databaseId());
      if (!db) {
        return hints;
      }
      newHints = [];
      for (i = 0, len = hintStrings.length; i < len; i++) {
        hintString = hintStrings[i];
        detailsList = App.DatabaseSqlFunctions.getDetails(db.database_type, hintString);
        if (detailsList) {
          for (j = 0, len1 = detailsList.length; j < len1; j++) {
            details = detailsList[j];
            newHints.push({
              render: App.AddSqlHintToCodeMirror.functionHintRenderer,
              text: hintString + ("(" + (details.args || '') + ")"),
              functionName: hintString,
              details: details
            });
          }
        } else {
          newHints.push(hintString);
        }
      }
      return newHints;
    };

    AddSqlHintToCodeMirror.descriptionHintRenderer = function(elt, data, cur) {
      var desc;
      desc = cur.description;
      if (desc.length > 180) {
        desc = desc.substr(0, 175) + '...';
      }
      return $(elt).html(JST["app/views/editors/description_hint"]({
        name: cur.name,
        description: desc
      }));
    };

    AddSqlHintToCodeMirror.prototype.annotateDescriptionHints = function(hints) {
      var descriptionMap, hint, i, j, len, len1, newHints, obj, objectsWithDescriptions, ref;
      objectsWithDescriptions = slice.call(App.SqlSnippet.all()).concat(slice.call(App.SqlView.all()), slice.call(App.CsvView.all()));
      descriptionMap = {};
      for (i = 0, len = objectsWithDescriptions.length; i < len; i++) {
        obj = objectsWithDescriptions[i];
        if (((ref = obj.description) != null ? ref.trim().length : void 0) > 0) {
          descriptionMap[obj.displayName()] = obj.description;
        }
      }
      newHints = [];
      for (j = 0, len1 = hints.length; j < len1; j++) {
        hint = hints[j];
        if (typeof hint === 'string' && descriptionMap[hint]) {
          newHints.push({
            render: App.AddSqlHintToCodeMirror.descriptionHintRenderer,
            text: hint,
            name: hint,
            description: descriptionMap[hint]
          });
        } else {
          newHints.push(hint);
        }
      }
      return newHints;
    };

    AddSqlHintToCodeMirror.getHighlightPositionForArg = function(line, chStart, text) {
      var argEnd, closeParenPos, commaPos, openParenPos;
      openParenPos = text.indexOf('(');
      if (openParenPos === -1) {
        return null;
      }
      commaPos = text.indexOf(',', openParenPos);
      closeParenPos = text.indexOf(')', openParenPos);
      if (commaPos === -1) {
        argEnd = closeParenPos;
      } else if (closeParenPos === -1) {
        argEnd = commaPos;
      } else {
        argEnd = Math.min(commaPos, closeParenPos);
      }
      if (closeParenPos === openParenPos + 1) {
        return null;
      }
      return {
        anchor: {
          line: line,
          ch: chStart + openParenPos + 1
        },
        head: {
          line: line,
          ch: chStart + argEnd
        }
      };
    };

    AddSqlHintToCodeMirror.prototype.getHints = function(prefix, prevToken, isDottedString) {
      var hints, prevString;
      if (!(/[a-zA-Z]/.test(prefix) || isDottedString)) {
        return [];
      }
      prevString = prevToken != null ? prevToken.string.replace(/^\./, '') : void 0;
      hints = this.getHintsMatchingPrefix(prefix, prevString, isDottedString);
      hints = this.annotateFunctionHints(hints);
      hints = this.annotateDescriptionHints(hints);
      if (hints.length === 1 && typeof hints[0] === 'string' && hints[0] === prefix) {
        return [];
      }
      return hints;
    };

    return AddSqlHintToCodeMirror;

  })();

}).call(this);
(function() {
  App.RedesignAlertToolTipHelper = (function() {
    function RedesignAlertToolTipHelper() {}

    RedesignAlertToolTipHelper.prototype.showAlert = function(evt, infoAndWarnings) {
      if (this.alertTooltip == null) {
        this.alertTooltip = new App.AlertTooltipController;
      }
      clearTimeout(this.hideTimeout);
      clearTimeout(this.showTimeout);
      return this.showTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.alertTooltip.showAlert($(evt.currentTarget), infoAndWarnings);
        };
      })(this)), App.AlertTooltipController.SHOW_DELAY_MS);
    };

    RedesignAlertToolTipHelper.prototype.hideAlert = function(fadeTime) {
      clearTimeout(this.hideTimeout);
      clearTimeout(this.showTimeout);
      if (this.alertTooltip) {
        return this.showTimeout = setTimeout(((function(_this) {
          return function() {
            return _this.alertTooltip.hide();
          };
        })(this)), fadeTime);
      }
    };

    RedesignAlertToolTipHelper.prototype.release = function() {
      if (this.alertTooltip) {
        return this.alertTooltip.release();
      }
    };

    return RedesignAlertToolTipHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  window.AppRedesign = (function(superClass) {
    extend(AppRedesign, superClass);

    AppRedesign.KEYS = {
      BACKSPACE: 8,
      ENTER: 13,
      SPACE: 32,
      LEFT_ARROW: 37,
      UP_ARROW: 38,
      RIGHT_ARROW: 39,
      DOWN_ARROW: 40,
      ESCAPE: 27,
      a: 97,
      z: 122,
      A: 65,
      Z: 90,
      ZERO: 48,
      NINE: 57
    };

    AppRedesign.VCODE_LENGTH = 6;

    AppRedesign.TV_MODE_REFRESH_SECONDS = 60 * 60 * 24;

    AppRedesign.DOUBLE_CLICK_TIMEFRAME = 400;

    AppRedesign.TYPE_TIMEOUT = 1000;

    AppRedesign.TOAST_NOTIFICATION_TIMEOUT = 5000;

    AppRedesign.SHARED_DASH_SOURCE_CHECK_SECONDS = 5 * 60;

    AppRedesign.IN_TOPIC = "topic";

    AppRedesign.IN_DASH = "dashboard";

    AppRedesign.IN_EDITRON = "editron";

    AppRedesign.IN_SINGLE_WIDGET = "singlewidget";

    AppRedesign.IN_DIALOG = "dialog";

    AppRedesign.DOC_PATH = '/docv2';

    AppRedesign.INTERACTIVE = "widget-rearrange";

    AppRedesign.SHARED_DASHBOARD_USER_ID = -1;

    AppRedesign.EMBED_DASHBOARD_USER_ID = -2;

    AppRedesign.current = function() {
      return window.app;
    };

    AppRedesign.setCurrentApp = function(app) {
      return window.app = app;
    };

    AppRedesign.documentReadyState = function() {
      return document.readyState;
    };

    AppRedesign.displayName = function(className) {
      var ref;
      return ((ref = App[className]) != null ? ref.PRETTY_CLASS_NAME : void 0) || className;
    };

    AppRedesign.windowLocation = function() {
      return _.toPlainObject(window.location);
    };

    AppRedesign.setDocumentTitle = function(documentTitle) {
      return document.title = documentTitle;
    };

    AppRedesign.readOnlyMaintenanceMode = function() {
      var ref;
      return (ref = AppRedesign.current().state) != null ? ref.ReadOnlyMaintenanceMode : void 0;
    };

    AppRedesign.hasPrivileges = function() {
      var allPrivileges, privilegeType, privileges, privilegesExist, privilegesValues;
      privilegesExist = false;
      allPrivileges = AppRedesign.current().state.RbacPermissionsHash;
      for (privilegeType in allPrivileges) {
        privileges = allPrivileges[privilegeType];
        privilegesValues = Object.values(privileges);
        if (privilegesValues.indexOf(true) !== -1) {
          privilegesExist = true;
          break;
        }
      }
      return privilegesExist;
    };

    AppRedesign.hasWorkbooksAccess = function() {
      return AppRedesign.current().state.CustomerUnificationFields.workbooks_access;
    };

    AppRedesign.recoverator = function() {
      var base;
      return (base = this.current()).recoverator != null ? base.recoverator : base.recoverator = new App.Recoverator();
    };

    AppRedesign.dragDropEnabled = function() {
      return this.current().dragDropEnabled();
    };

    AppRedesign.prototype.dragDropEnabled = function() {
      var ref;
      return (ref = this.state.Site) != null ? ref.drag_drop_enabled : void 0;
    };

    AppRedesign.cachedSite = function() {
      var ref;
      return Boolean((ref = this.current().state.Site) != null ? ref.cached_site : void 0);
    };

    AppRedesign.slackEnabled = function() {
      return this.current().state.SlackEnabled;
    };

    AppRedesign.teradataEnabled = function() {
      return this.current().state.TeradataEnabled;
    };

    AppRedesign.databricksEnabled = function() {
      return this.current().state.DatabricksEnabled;
    };

    AppRedesign.dragDropCalculatedFieldsEnabled = function() {
      var ref;
      return ((ref = this.current().state.Site) != null ? ref.drag_drop_calculated_fields_enabled : void 0) || false;
    };

    AppRedesign.codeInViewsEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.python_r_views_enabled : void 0;
    };

    AppRedesign.summaryStatsEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.summary_stats_enabled : void 0;
    };

    AppRedesign.magicLDemoModeEnabled = function() {
      return this.current().magicLDemoModeEnabled;
    };

    AppRedesign.deepAnalysisCodeLanguagesAndVersions = function() {
      return this.current().deepAnalysisCodeLanguagesAndVersions;
    };

    AppRedesign.sagemakerEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.sagemaker_enabled : void 0;
    };

    AppRedesign.prototype.welcomeFrameEl = function() {
      return this.el.find('.welcome-frame');
    };

    AppRedesign.prototype.getCurrentState = function() {
      return this.currentState;
    };

    AppRedesign.prototype.setCurrentState = function(state) {
      return this.currentState = state;
    };

    AppRedesign.prototype.userId = function() {
      var ref, ref1;
      return (ref = this.state.UserRole) != null ? (ref1 = ref.first()) != null ? ref1.user_id : void 0 : void 0;
    };

    AppRedesign.prototype.ensureFileDownloadsController = function() {
      return this.fileDownloadsController != null ? this.fileDownloadsController : this.fileDownloadsController = new App.FileDownloadsController();
    };

    AppRedesign.uiQueueAdd = function() {
      var args, ref;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (ref = AppRedesign.current().uiQueue).add.apply(ref, args);
    };

    AppRedesign.prototype.notifyRemainingStateLoaded = function() {
      return this.remainingStateLoaded = true;
    };

    function AppRedesign() {
      this.getCompleteDashboard = bind(this.getCompleteDashboard, this);
      this.ensureDbSchemaFetchedForWriteUser = bind(this.ensureDbSchemaFetchedForWriteUser, this);
      this.receiveAjaxError = bind(this.receiveAjaxError, this);
      this.firstChartRendered = bind(this.firstChartRendered, this);
      this.someChartRendered = bind(this.someChartRendered, this);
      this.notRenderingWidget = bind(this.notRenderingWidget, this);
      this.switchedToDashboard = bind(this.switchedToDashboard, this);
      this.openItemById = bind(this.openItemById, this);
      this.resetIfReady = bind(this.resetIfReady, this);
      this.renderPermissionDeniedNotice = bind(this.renderPermissionDeniedNotice, this);
      this.exitTVMode = bind(this.exitTVMode, this);
      this.prepareTVMode = bind(this.prepareTVMode, this);
      this.start = bind(this.start, this);
      this.checkTvModeReload = bind(this.checkTvModeReload, this);
      this.markLastInteractionTimetamp = bind(this.markLastInteractionTimetamp, this);
      this.onSqlViewRoute = bind(this.onSqlViewRoute, this);
      this.setupRouter = bind(this.setupRouter, this);
      this.featureLogContext = bind(this.featureLogContext, this);
      this.dragDropEnabled = bind(this.dragDropEnabled, this);
      var eventHomogenizer, ref, ref1, ref2, ref3, shared_mode;
      AppRedesign.setCurrentApp(this);
      $('#body').addClass('redesign');
      this.timing = new App.ClientTiming();
      this.timing.add('startTime', window.pageloadStartTime);
      this.timing.add('serverJsonDuration', window.pageloadServerJsonTime);
      this.timing.add('appStartTime');
      window.onerror = AppRedesign.logErrorObject;
      AppRedesign.__super__.constructor.apply(this, arguments);
      this.uuid = App.Utils.makeGuid();
      this.pageloadTimestamp = AppRedesign.timestamp();
      jQuery.ajaxSetup({
        cache: false,
        error: this.ajaxErrorHandler,
        timeout: 55 * 1000
      });
      this.uiQueue = new App.UiQueue();
      if (!AppRedesign.testMode()) {
        App.Lagotron.unleash();
      }
      App.Lagotron.addContext("app construction");
      App.TimeMachine.readCacheFromLocalStorage();
      App.Dashboard.bind('dashboard-made-current', this.switchedToDashboard);
      App.Dashboard.bind('load-dashboard', this.getCompleteDashboard);
      App.Dashboard.bind('prepare-tv-mode', this.prepareTVMode);
      App.Dashboard.bind('exit-tv-mode', this.exitTVMode);
      Spine.bind('permission_denied', this.renderPermissionDeniedNotice);
      eventHomogenizer = new App.EventHomogenizer();
      this.chartsRendered = 0;
      this.mapsRendered = 0;
      this.appFrameEl = this.el.find('.app-frame');
      this.bindFocusEvents();
      shared_mode = false;
      this.onMobileOs = ['Android', 'iPad', 'iPhone'].includes(BrowserDetect.OS);
      if (this.state) {
        shared_mode = this.state.shared_mode;
      }
      if (this.spinalCord == null) {
        this.spinalCord = new App.SpinalCord(shared_mode);
      }
      this.liveChat = new App.LiveChat();
      App.User.bind('wix-update', this.liveChat.wixUpdate);
      this.walkMe = new App.WalkMe();
      this.immediateReload = false;
      this.pdf_mode = this.state.pdf_mode;
      this.deepAnalysisEnabled = !!(((ref = this.state.Site) != null ? ref.deep_analysis_feature_flag_enabled : void 0) || ((ref1 = this.state) != null ? ref1.deep_analysis_feature_flag_enabled : void 0));
      this.codeSchemaViewerEnabled = this.deepAnalysisEnabled;
      this.batchedChartUpdateEnabled = !!((ref2 = this.state.Site) != null ? ref2.batched_chart_update_enabled : void 0) || !!((ref3 = this.state) != null ? ref3.batched_chart_update_enabled : void 0);
      this.showRbacPermissionsPage = _.includes(window.location.href, 'rbac=true');
      this._featureLogContext = new App.FeatureLogContext();
      AppRedesign.removeUtmParametersFromUrl();
      switch (false) {
        case !this.state.shared_mode:
          this.setupSharedMode();
          break;
        case !((this.state.Site != null) || (this.state.tv_mode_frame != null)):
          this.start(this.state);
      }
      if (this.pdf_mode) {
        $('#body .app-footer.dashboard-footer').css({
          display: 'none'
        });
      }
      App.Site.bind('request-several-updates', this.spinalCord.requestQuickUpdate);
      this.setupRouter();
    }

    AppRedesign.removeUtmParametersFromUrl = function() {
      var error, params;
      try {
        params = new URLSearchParams(AppRedesign.locationSearch());
        params["delete"]('utm_content');
        params["delete"]('utm_source');
        return AppRedesign.replaceState(params, AppRedesign.locationHash());
      } catch (error1) {
        error = error1;
        return null;
      }
    };

    AppRedesign.locationSearch = function() {
      return location.search;
    };

    AppRedesign.locationHash = function() {
      return location.hash;
    };

    AppRedesign.replaceState = function(params, locationHash) {
      return history.replaceState(null, '', '?' + params + locationHash);
    };

    AppRedesign.prototype.featureLogContext = function() {
      return this._featureLogContext;
    };

    AppRedesign.prototype.setupRouter = function() {
      Spine.Route.add(/sql-views#([0-9]+)/, this.onSqlViewRoute);
      return Spine.Route.setup();
    };

    AppRedesign.prototype.onSqlViewRoute = function(params) {
      return this.bind('loaded-sql-views', (function(_this) {
        return function(args) {
          var item;
          item = App.SqlView.exists(params.match[1]);
          if (item) {
            return App.RouteHelper.navigateTo('SqlView', item, {
              replace: true
            });
          }
        };
      })(this));
    };

    AppRedesign.prototype.setupSingleWidgetMode = function() {
      this.currentState = AppRedesign.IN_SINGLE_WIDGET;
      this.singleWidgetMode = true;
      this.setReleaseVersion(this.state);
      App.Site.refresh(this.state.Site);
      this.spinalCord.applyAllTheUpdates(this.state);
      this.appFrameEl.show();
      return this.appFrame = new App.AppFrameRedesign({
        el: this.appFrameEl,
        sharedMode: true
      });
    };

    AppRedesign.prototype.setupSharedMode = function() {
      var ref;
      this.currentState = AppRedesign.IN_DASH;
      this.timing.stop();
      this.shared_mode = true;
      if (this.shouldShowFilterBar()) {
        this.shared_filter_mode = true;
      }
      this.sourceMinUpdateTime = this.state.source_min_update_time;
      this.embed_mode = this.state.embed_mode;
      this.tvmode = this.state.tv_mode_frame != null;
      if (this.tvmode) {
        this.appFrameEl.addClass('tv-mode');
        App.Dashboard.trigger('enter-tv-mode');
      }
      if (this.shared_mode) {
        $('#body').addClass('shared-mode');
      }
      if (this.shared_filter_mode) {
        $('#body').addClass('with-filters');
      }
      if (this.embed_mode) {
        $('#body').addClass('embed-mode');
      }
      if (this.embed_mode === 'v2') {
        $('#body').addClass('embed-mode-v2');
      }
      if (this.state.Site.whitelabelled_embedded_dashboards_enabled) {
        $('#body').addClass('embed-white-labeled');
      }
      if (this.state.border === 'off' && !AppRedesign.isNewLook()) {
        $('#body').addClass('no-border');
      }
      this.shared_dashboard_token = this.state.shared_dashboard_token;
      if (this.embed_mode) {
        this.shared_dashboard_user_id = AppRedesign.EMBED_DASHBOARD_USER_ID;
      } else {
        this.shared_dashboard_user_id = AppRedesign.SHARED_DASHBOARD_USER_ID;
      }
      this.setReleaseVersion(this.state);
      this.spinalCord.handleInitialState(this.state);
      this.appFrameEl.show();
      if ((ref = this.state.shared_dashboard) != null ? ref.password_protected : void 0) {
        new App.SharedDashboardPasswordController({
          el: this.appFrameEl,
          appRedesign: this,
          sharedDashboard: this.state.shared_dashboard
        });
      } else {
        this.renderSharedModeFrame();
      }
      App.ReactBridge.initializeOnPageLoad();
      return window.addEventListener("message", App.SharedDashboard.messageFromPostMessageApi, false);
    };

    AppRedesign.prototype.renderSharedModeFrame = function() {
      this.appFrame = new App.AppFrameRedesign({
        el: this.appFrameEl,
        sharedMode: true,
        linked_widget_hash_key: this.state.linked_widget_formula_source_hash_key,
        code_linked_widget_hash_key: this.state.code_linked_widget_formula_source_hash_key
      });
      setTimeout(((function(_this) {
        return function() {
          _this.appFrame.addCurrentDashboard();
          return _this.ensureFileDownloadsController();
        };
      })(this)), 0);
      return setInterval(App.Widget.checkForNewData, AppRedesign.SHARED_DASH_SOURCE_CHECK_SECONDS * 1000);
    };

    AppRedesign.prototype.screenshotTimestampLabel = function() {
      return this.state.screenshotTimestampLabel;
    };

    AppRedesign.prototype.setupScreenshotMode = function() {
      return App.SetUpScreenshotMode.call(this, new App.RedesignDashboardSizer(App.Dashboard.first()));
    };

    AppRedesign.prototype.shouldShowFilterBar = function() {
      var dim, filter, i, j, len, len1, ref, ref1, ref2, ref3;
      if (this.state.filters_enabled && this.pdf_mode) {
        return true;
      }
      if (((ref = this.state.shared_dashboard) != null ? (ref1 = ref.unlocked_filters) != null ? ref1.length : void 0 : void 0) && this.state.shared_dashboard.token === this.state.shared_dashboard_token) {
        ref2 = this.state.shared_dashboard.unlocked_filters;
        for (i = 0, len = ref2.length; i < len; i++) {
          filter = ref2[i];
          if (filter === 'aggregation' || filter === 'date_range') {
            return true;
          }
          if (this.state.CustomDimension == null) {
            return false;
          }
          ref3 = this.state.CustomDimension;
          for (j = 0, len1 = ref3.length; j < len1; j++) {
            dim = ref3[j];
            if (dim['id'] === parseInt(filter)) {
              return true;
            }
          }
        }
      }
      return false;
    };

    AppRedesign.prototype.bindFocusEvents = function() {
      if (typeof document.webkitHidden !== "undefined") {
        this.focusedTab = !document.webkitHidden;
        this.currentTab = !document.webkitHidden;
        $(document).on('webkitvisibilitychange', ((function(_this) {
          return function() {
            var ref;
            _this.currentTab = !document.webkitHidden;
            App.Lagotron.addContext("webkitvisibilitychange: " + _this.currentTab);
            if (_this.currentTab) {
              return (ref = App.Dashboard.currentDashboard()) != null ? ref.trigger("dashboard-window-focus") : void 0;
            }
          };
        })(this)));
      } else if (typeof document.mozHidden !== "undefined") {
        this.focusedTab = !document.mozHidden;
        this.currentTab = !document.mozHidden;
        $(document).on('mozvisibilitychange', ((function(_this) {
          return function() {
            _this.currentTab = !document.mozHidden;
            return App.Lagotron.addContext("mozvisibilitychange: " + _this.currentTab);
          };
        })(this)));
      } else {
        this.focusedTab = true;
      }
      $(window).on('focus', ((function(_this) {
        return function() {
          _this.focusedTab = true;
          return App.Lagotron.addContext("gain focus");
        };
      })(this)));
      $(window).on('blur', ((function(_this) {
        return function() {
          _this.focusedTab = false;
          return App.Lagotron.addContext("lose focus");
        };
      })(this)));
      this.markLastInteractionTimetamp();
      return $(document).on('mousemove', this.markLastInteractionTimetamp);
    };

    AppRedesign.prototype.markLastInteractionTimetamp = function() {
      return this.lastInteractionTimestamp = AppRedesign.timestamp();
    };

    AppRedesign.prototype.idleSeconds = function() {
      return Math.round((AppRedesign.timestamp() - this.lastInteractionTimestamp) / 1000.0);
    };

    AppRedesign.prototype.secondsSincePageload = function() {
      return Math.round((AppRedesign.timestamp() - this.pageloadTimestamp) / 1000.0);
    };

    AppRedesign.prototype.checkTvModeReload = function() {
      if (!(this.tvmode && this.secondsSincePageload() > AppRedesign.TV_MODE_REFRESH_SECONDS)) {
        return;
      }
      return this.constructor.reloadPage();
    };

    AppRedesign.prototype.passwordResetRequired = function() {
      return Boolean(this.state.set_password);
    };

    AppRedesign.prototype.userForgotPassword = function() {
      return Boolean(this.state.forgot_password);
    };

    AppRedesign.prototype.tfaSetupRequired = function() {
      return Boolean(this.state.setup_tfa);
    };

    AppRedesign.prototype.start = function(state) {
      var dashId, fs, noPrivilgesExist, ref, ref1, ref2, ref3, setupFlow, site;
      setupFlow = new App.RedesignSetupFlow('auth-setup-required');
      setupFlow.delayedRun();
      this.timing.add('serverDuration', state.server_duration);
      if (AppRedesign.widgetIdInUrl()) {
        this.currentState = AppRedesign.IN_SINGLE_WIDGET;
      } else {
        this.currentState = AppRedesign.IN_DASH;
        this.timing.waitForWidgets(_.map(state.Widget, 'id'), false);
      }
      if (state.FormulaSource != null) {
        this.immediateRenderWidgetIds = (function() {
          var i, len, ref, results;
          ref = state.FormulaSource;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            fs = ref[i];
            results.push(fs.hash_key);
          }
          return results;
        })();
      }
      if (this.immediateRenderWidgetIds != null) {
        this.setupFirstChartRenderEvents(this.immediateRenderWidgetIds);
      }
      App.Lagotron.addContext('app.start');
      this.initialDashboardId = (ref = state.Dashboard) != null ? (ref1 = ref[0]) != null ? ref1.id : void 0 : void 0;
      if (state.RbacEnabled && this.initialDashboardId !== void 0) {
        if ((ref2 = state.Dashboard) != null) {
          if ((ref3 = ref2[0]) != null) {
            ref3.permissions = state.InitialDashboardPermissions;
          }
        }
      }
      this.setReleaseVersion(state);
      if (this.checkForUpdates == null) {
        this.checkForUpdates = new App.CheckForUpdates(state, this.spinalCord, this.initialDashboardId, this.timing);
      }
      noPrivilgesExist = AppRedesign.current().state.RbacEnabled && !AppRedesign.hasPrivileges();
      if (noPrivilgesExist) {
        this.checkForUpdates.disableFetcher();
      } else {
        this.checkForUpdates.configureFetcher();
        this.bubbles(this.checkForUpdates, 'loaded-sql-views loaded-dashboard-filters');
      }
      App.Site.refresh(state.Site);
      this.tvmodeParent = false;
      this.tvmode = state.tv_mode_frame != null;
      this.spinalCord.handleInitialState(state);
      setInterval(this.checkTvModeReload, 10000);
      this.colorThemesEnabled = state.ColorThemesEnabled;
      this.maintenanceMessage = state.MaintenanceMessage;
      this.overageData = state.OverageData;
      this.nonPaymentDeadline = state.NonPaymentDeadline;
      this.freeInputFiltersEnabled = state.FreeInputFiltersEnabled;
      this.customerExperiments = state.CustomerExperiments || [];
      this.magicLDemoModeEnabled = state.MagicLDemoModeEnabled;
      this.sharedDashboardPasswordEnabled = state.SharedDashboardPasswordEnabled;
      this.cacheUIPerfImprovementEnabled = state.CacheUIPerfImprovementEnabled;
      this.betaSignupFormType = state.BetaSignupFormType;
      this.restrictDatabasesEnabled = state.RestrictDatabasesEnabled;
      this.addDepartmentToSignup = state.AddDepartmentToSignup;
      this.deepAnalysisCodeLanguagesAndVersions = state.DeepAnalysisCodeLanguagesAndVersions;
      this.overloadedSite = state.overloaded_site;
      this.roleLevelAccessEnabled = state.roleLevelAccessEnabled;
      this.roleLevelAccessObject = state.roleLevelAccessObject;
      if ((state != null) && (state.Widget != null) && (state.Widget[0] != null)) {
        dashId = state.Widget[0].dashboard_id;
        this.spinalCord.setLastUpdateForDashboard(dashId, state.last_update);
      }
      this.appFrameEl.show();
      if (this.tvmode) {
        this.appFrameEl.addClass('tv-mode');
      }
      this.appFrame = new App.AppFrameRedesign({
        el: this.appFrameEl,
        linked_widget_hash_key: this.state.linked_widget_formula_source_hash_key,
        code_linked_widget_hash_key: this.state.code_linked_widget_formula_source_hash_key
      });
      this.bindAllTheErrors();
      site = App.Site.first();
      if (site != null) {
        this.siteController = new App.SiteController({
          item: site
        }).bind('site-version-changed', this.showStaleSiteModal);
      }
      App.ReactBridge.initializeOnPageLoad();
      return setTimeout((function(_this) {
        return function() {
          if (_this.tvmode) {
            App.Dashboard.trigger('enter-tv-mode');
          }
          if (_this.showPasswordForm) {
            _this.appFrameEl.addClass('blur');
          }
          if (_this.showingTwoFactorSetupForm) {
            _this.appFrameEl.addClass('blur');
          }
          _this.checkForUpdates.enableDashboardFetching();
          _this.timing.add('preDashboardTime');
          App.RouteHelper.initialRoute(state);
          _this.ensureFileDownloadsController();
          _this.timing.add('postDashboardTime');
          _this.timing.doneIfNoWidgets();
          _this.maybeShowModal();
          return _this.maybeShowNpsSurveyResponseModal(App.NpsSurveyResponse.incompleteResponse());
        };
      })(this));
    };

    AppRedesign.prototype.showStaleSiteModal = function() {
      return new App.SiteVersionController();
    };

    AppRedesign.prototype.maybeShowModal = function() {
      var site;
      site = App.Site.first();
      if (!site.anyBillingModalEnabled()) {
        return;
      }
      if (site.zuoraModalAllowed()) {
        return new App.ZuoraBillingModalController();
      } else if (site.shouldShowManualBillingModal() || site.shouldShowAutoExpBillingModal()) {
        return new App.ContactUsModalController();
      }
    };

    AppRedesign.prototype.maybeShowNpsSurveyResponseModal = function(npsSurveyResponse) {
      if (npsSurveyResponse == null) {
        return;
      }
      return new App.NpsSurveyResponseController({
        npsSurveyResponse: npsSurveyResponse
      });
    };

    AppRedesign.prototype.prepareTVMode = function() {
      this.tvmodeParent = true;
      return this.spinalCord.stopUpdates();
    };

    AppRedesign.prototype.exitTVMode = function() {
      this.tvmodeParent = false;
      return this.constructor.reloadPage();
    };

    AppRedesign.prototype.allowLargeCsvDownloadForSharedDashboards = function() {
      return AppRedesign.current().shared_mode && AppRedesign.current().state.large_csv_download_for_shared_dashboards_enabled;
    };

    AppRedesign.reactErrorHandler = function() {
      return Spine.trigger('permission_denied');
    };

    AppRedesign.prototype.ajaxErrorHandler = function(response) {
      if (response.status === 403) {
        return Spine.trigger('permission_denied');
      }
    };

    AppRedesign.prototype.renderPermissionDeniedNotice = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return App.AppFrameRedesign.renderPermissionDeniedNotice();
      }
    };

    AppRedesign.isNewLook = function() {
      var ref;
      return ((ref = AppRedesign.current()) != null ? ref.embed_mode : void 0) && AppRedesign.parseStringParam(AppRedesign.windowLocation().href, 'layout') === 'v2';
    };

    AppRedesign.reloadPage = function() {
      return window.location.reload(true);
    };

    AppRedesign.prototype.resetIfReady = function() {
      if (!this.tvmodeParent) {
        return this.constructor.reloadPage();
      }
    };

    AppRedesign.prototype.setReleaseVersion = function(state) {
      App.herokuReleaseVersion = this.herokuReleaseVersion = state.herokuReleaseVersion;
      if ((this.herokuReleaseVersion != null) && (typeof console !== "undefined" && console !== null)) {
        return console.log("Running Sisense for Cloud Data Teams " + this.herokuReleaseVersion);
      }
    };

    AppRedesign.widgetIdInUrl = function() {
      return this.parseNumericParam(window.location.href, 'widget');
    };

    AppRedesign.widgetEditMode = function() {
      return _.includes(AppRedesign.windowLocation().search, 'editMode=true') && AppRedesign.current().currentState === AppRedesign.IN_SINGLE_WIDGET;
    };

    AppRedesign.udvIdInUrl = function() {
      return this.parseNumericParam(window.location.href, 'udv');
    };

    AppRedesign.devDependencies = function() {
      return _.includes(AppRedesign.windowLocation().search, 'dev-dependencies=true');
    };

    AppRedesign.udvInUrl = function() {
      var udv;
      udv = App.UserDataView.exists(this.udvIdInUrl());
      if (udv) {
        return udv;
      }
      return null;
    };

    AppRedesign.loadOnlyFluidDashboards = function() {
      var ref;
      if ((ref = App.Site.first()) != null ? ref.redesign : void 0) {
        return false;
      }
      if ((window.app != null) && (window.app.shared_mode || window.app.embed_mode)) {
        return false;
      }
      return AppRedesign.redesignFlagSet();
    };

    AppRedesign.redesignFlagSet = function() {
      return this.redesignFlag != null ? this.redesignFlag : this.redesignFlag = _.includes(AppRedesign.windowLocation().href, 'redesign=1');
    };

    AppRedesign.screenshotModeInUrl = function() {
      return _.includes(window.location.href, 'screenshot=true');
    };

    AppRedesign.parseNumericParam = function(url, param) {
      var matches, regex;
      regex = new RegExp("[?&]" + param + "=(\\d+)");
      matches = url.match(regex);
      if ((matches != null) && matches.length === 2) {
        return parseInt(matches[1]);
      }
      return null;
    };

    AppRedesign.parseStringParam = function(url, param) {
      var matches, regex;
      regex = new RegExp("[?&]" + param + "=([\\w\\d]+)");
      matches = url.match(regex);
      if ((matches != null) && matches.length === 2) {
        return matches[1];
      }
      return null;
    };

    AppRedesign.isRedesignMode = function() {
      return AppRedesign.current().isRedesignMode;
    };

    AppRedesign.prototype.setImmediateReload = function() {
      return this.immediateReload = true;
    };

    AppRedesign.prototype.isRedesignMode = true;

    AppRedesign.prototype.syncParentIframeDashboardOnDrilldown = function(dashboard) {
      var error, parentDashboard;
      if (this.tvmode && App.Utils.isInsideIframe()) {
        try {
          parentDashboard = window.parent.App.Dashboard.find(dashboard.id);
          return App.RouteHelper.navigateTo('Dashboard', parentDashboard);
        } catch (error1) {
          error = error1;
          return AppRedesign.logError(error);
        }
      }
    };

    AppRedesign.prototype.fullUrlForCurrentSite = function() {
      return "" + window.location.origin + (AppRedesign.pathForSiteHost());
    };

    AppRedesign.prototype.fullUrlForDashboard = function(dashboardId) {
      return (this.fullUrlForCurrentSite()) + "/" + dashboardId;
    };

    AppRedesign.prototype.fullUrlForWidgetInSingleWidgetMode = function(dashboardId, widgetId) {
      return (this.fullUrlForCurrentSite()) + "/" + dashboardId + "?widget=" + widgetId + "&udv=0";
    };

    AppRedesign.testMode = function() {
      return window.location.pathname.match(/^\/jasmine/);
    };

    AppRedesign.sanitizeWordsForUrl = function(words) {
      if (words) {
        return words.replace(/[\s\\\/?#%]+/g, "-");
      }
    };

    AppRedesign.isLinkedWidgetMode = function() {
      return AppRedesign.current().getCurrentState() !== AppRedesign.IN_DASH && $(document.body).hasClass('linked-widget-mode');
    };

    AppRedesign.pathForSiteHost = function(params) {
      var dashboard, dashboardId, dashboardName, item, nameText, queryStr, siteHost;
      if (params == null) {
        params = {};
      }
      queryStr = params.queryStr, siteHost = params.siteHost, dashboardId = params.dashboardId, item = params.item;
      if (queryStr == null) {
        queryStr = '';
      }
      if (siteHost == null) {
        siteHost = App.Site.first().host;
      }
      if ((item != null ? item.constructor.className : void 0) === 'Dashboard') {
        dashboardId = item.id;
      }
      if ((dashboardId != null) && !App.Utils.isClientId(dashboardId)) {
        dashboard = App.Dashboard.exists(dashboardId);
        if (dashboard) {
          dashboardName = AppRedesign.sanitizeWordsForUrl(dashboard.name);
        }
        nameText = "";
        if (dashboardName) {
          nameText += "/" + dashboardName;
        }
        return "/app/" + siteHost + "/" + dashboardId + nameText + queryStr;
      } else {
        return "/app/" + siteHost + queryStr;
      }
    };

    AppRedesign.prototype.openItemById = function(type, id, options) {
      var item, ref;
      if (App[type] == null) {
        return;
      }
      if (id) {
        item = App[type].exists(id);
      } else {
        item = App.LeftMenuHelper.newItem(App[type]);
      }
      if (item) {
        return (ref = this.appFrame) != null ? ref.openItem(type, item, options) : void 0;
      }
    };

    AppRedesign.prototype.openDashboardInNewWindow = function(dashboardId) {
      var dashboard, dashboardUrl;
      if (dashboardId == null) {
        return;
      }
      dashboard = App.Dashboard.exists(dashboardId);
      if (!dashboard) {
        return;
      }
      dashboardUrl = this.fullUrlForDashboard(dashboardId);
      return window.open(dashboardUrl);
    };

    AppRedesign.prototype.openWidgetInSingleWidgetModeInNewWindow = function(dashboardId, widgetId) {
      var widgetUrl;
      if (dashboardId == null) {
        return;
      }
      if (widgetId == null) {
        return;
      }
      widgetUrl = this.fullUrlForWidgetInSingleWidgetMode(dashboardId, widgetId);
      return window.open(widgetUrl);
    };

    AppRedesign.prototype.roundedAgoFromDateString = function(updated_at) {
      return App.Utils.roundedAgoFromDateString(updated_at, "ago", "Never");
    };

    AppRedesign.prototype.switchedToDashboard = function(dashboard, onWidgetsLoaded) {
      return this.getCompleteDashboard(dashboard, onWidgetsLoaded);
    };

    AppRedesign.prototype.setupFirstChartRenderEvents = function(immediateRenderWidgets) {
      this.waitingOnFirstChartRender = true;
      if (immediateRenderWidgets.length === 0) {
        return setTimeout(this.someChartRendered, 0);
      } else {
        App.Widget.bind("chart-rendered", this.someChartRendered);
        return setTimeout(this.someChartRendered, 2000);
      }
    };

    AppRedesign.prototype.notRenderingWidget = function(widgetId) {
      return this.timing.doneWithWidget(widgetId, false);
    };

    AppRedesign.prototype.someChartRendered = function(widget) {
      if (widget != null) {
        this.timing.doneWithWidget(widget.id, true);
      }
      if (this.waitingOnFirstChartRender) {
        return this.firstChartRendered();
      }
    };

    AppRedesign.prototype.firstChartRendered = function() {
      this.waitingOnFirstChartRender = false;
      AppRedesign.current().uiQueue.add(((function(_this) {
        return function() {
          return App.Widget.trigger('after-first-chart-render');
        };
      })(this)), 'after-first-chart', App.UiQueue.PRIORITY_AFTER_FIRST_CHART);
      if (App.Site.first().tutorial_enabled) {
        if (!this.passwordResetRequired()) {
          this.walkMe.init();
        }
      }
      if (!this.shared_mode && !this.tvmode) {
        AppRedesign.current().uiQueue.add(((function(_this) {
          return function() {
            var ref;
            return (ref = _this.liveChat) != null ? ref.init() : void 0;
          };
        })(this)), 'reveal-chat', App.UiQueue.PRIORITY_LIVE_CHAT);
      }
      if ((typeof performance !== "undefined" && performance !== null) && typeof performance.mark === "function") {
        return performance.mark('first-chart-render');
      }
    };

    AppRedesign.prototype.reportAjaxFailure = function(response, msg) {
      msg = msg + " status=\"" + response.status + "\" error=\"" + response.statusText + "\" ";
      return AppRedesign.logError(new Error(msg));
    };

    AppRedesign.prototype.bindAllTheErrors = function() {
      var i, len, m, ref, results;
      ref = ['Widget', 'Dashboard', 'UserDataView'];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        m = ref[i];
        results.push(App[m].bind('ajaxError', this.receiveAjaxError));
      }
      return results;
    };

    AppRedesign.prototype.receiveAjaxError = function(model, error) {
      var e, errorText, modelString;
      if (error.statusText === 'OK') {
        return;
      }
      if (error.status === 403) {
        Spine.trigger('permission_denied');
      }
      try {
        modelString = JSON.stringify(model);
        errorText = "Ajax Error: " + modelString + ".";
      } catch (error1) {
        e = error1;
        errorText = "Ajax Error in " + model.constructor.className;
      }
      return AppRedesign.logError(new Error(errorText + " Error: " + error.statusText));
    };

    AppRedesign.logToScalyr = function(msg, values) {
      if (values == null) {
        values = {};
      }
      if (AppRedesign._batchingLogger == null) {
        AppRedesign._batchingLogger = new App.BatchingLogger();
      }
      return AppRedesign._batchingLogger.logToScalyr(msg, values);
    };

    AppRedesign.logErrorObject = function(message, file, line, column, errorObj) {
      return App.Logger.logErrorObject(message, file, line, column, errorObj);
    };

    AppRedesign.logError = function(error, extraDetails) {
      if (extraDetails == null) {
        extraDetails = null;
      }
      App.Logger.logError(error, extraDetails);
      return typeof Rollbar !== "undefined" && Rollbar !== null ? Rollbar.error(error, extraDetails) : void 0;
    };

    AppRedesign.logErrorAsWarning = function(error, extraDetails) {
      if (extraDetails == null) {
        extraDetails = null;
      }
      return typeof Rollbar !== "undefined" && Rollbar !== null ? Rollbar.warning(error, extraDetails) : void 0;
    };

    AppRedesign.timestamp = function() {
      return (new Date()).getTime();
    };

    AppRedesign.isInTvMode = function() {
      var ref;
      return (ref = AppRedesign.current()) != null ? ref.tvmode : void 0;
    };

    AppRedesign.isInEmbedMode = function() {
      var ref;
      return (ref = AppRedesign.current()) != null ? ref.embed_mode : void 0;
    };

    AppRedesign.prototype.userIsOrphan = function() {
      var ref;
      return (ref = this.appFrame) != null ? ref.orphaned : void 0;
    };

    AppRedesign.prototype.tutorial = function() {
      var countdownOnly, site;
      if (!this.isSSUTrialUser()) {
        return null;
      }
      site = App.Site.first();
      countdownOnly = site.tutorial_enabled != null;
      return this.tutorialFlow != null ? this.tutorialFlow : this.tutorialFlow = new App.RedesignTutorialFlow(this.appFrameEl, countdownOnly);
    };

    AppRedesign.prototype.isSSUTrialUser = function() {
      var site;
      site = App.Site.first();
      return site.self_signup && !site.has_ever_paid && site.customer_group !== 'paying';
    };

    AppRedesign.prototype.startScreenTransitionAnimation = function() {
      var ref;
      return (ref = this.appFrame) != null ? ref.startScreenTransitionAnimation() : void 0;
    };

    AppRedesign.prototype.bodyWidth = function() {
      return $('#body').width();
    };

    AppRedesign.pendingSiteModels = function() {
      return this.current().state.PendingSiteModels;
    };

    AppRedesign.autoArchiveEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.auto_archive_enabled : void 0;
    };

    AppRedesign.scimProvisioningEnabled = function() {
      var ref;
      return !!(this.current().state.RbacEnabled && ((ref = this.current().state.Site) != null ? ref.sso_config_idp_scim_enabled : void 0));
    };

    AppRedesign.dashboardOrganizationEnabled = function() {
      var ref, ref1;
      return ((ref = this.current().state.Site) != null ? ref.dashboard_organization_no_url_flag_enabled : void 0) || (((ref1 = this.current().state.Site) != null ? ref1.dashboard_organization_enabled : void 0) && _.includes(AppRedesign.windowLocation().href, 'organization=true'));
    };

    AppRedesign.connectorIngestionEnabled = function() {
      var ref, ref1;
      return ((ref = this.current().state.Site) != null ? ref.connector_ingestion_enabled : void 0) && this.connectorIngestionEnabledSourceTypes().length && ((ref1 = this.current().state.Site) != null ? ref1.connector_ingestion_has_stitch_connect_account_info : void 0);
    };

    AppRedesign.connectorIngestionEnabledSourceTypes = function() {
      var ref;
      return ((ref = this.current().state.Site) != null ? ref.connector_ingestion_enabled_source_types : void 0) || [];
    };

    AppRedesign.connectorIngestionSpecificDbUserEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.connector_ingestion_specific_db_user_enabled : void 0;
    };

    AppRedesign.filterCheckAllEnabled = function() {
      var ref;
      return (ref = this.current().state.Site) != null ? ref.filter_check_all_enabled : void 0;
    };

    AppRedesign.restrictDatabasesEnabled = function() {
      return this.current().state.RestrictDatabasesEnabled;
    };

    AppRedesign.allowQueryCancel = function(database) {
      if (_.includes(AppRedesign.windowLocation().href, 'query-cancel=true')) {
        return true;
      }
      if (!database) {
        return false;
      }
      return (this.current().state.AllowedDatabaseTypesForQueryCancel || []).includes(database.database_type);
    };

    AppRedesign.textOnDashboardEnabled = function() {
      var ref;
      return ((ref = this.current().state.Site) != null ? ref.text_on_dashboard_enabled : void 0) || this.current().state.text_on_dashboard_enabled;
    };

    AppRedesign.prototype.setTextBoxDrawingMode = function(newTextBoxDrawingMode) {
      this.newTextBoxDrawingMode = newTextBoxDrawingMode;
      return this.trigger('text-box-drawing-mode-changed');
    };

    AppRedesign.prototype.checkForUpdatesImmediately = function() {
      if (this.checkForUpdates == null) {
        return;
      }
      return this.checkForUpdates.checkForUpdatesImmediately();
    };

    AppRedesign.prototype.ensureDbSchemaFetchedForWriteUser = function(siteId, options) {
      if (this.checkForUpdates == null) {
        return;
      }
      return this.checkForUpdates.ensureDbSchemaFetchedForWriteUser(siteId, options);
    };

    AppRedesign.prototype.getCompleteDashboard = function(dashboard, onWidgetsLoaded) {
      if (this.checkForUpdates == null) {
        return;
      }
      return this.checkForUpdates.getCompleteDashboard(dashboard, onWidgetsLoaded);
    };

    AppRedesign.currentPermissionsExist = function() {
      if (App.Dashboard.currentDashboard() === null || App.Dashboard.currentDashboard().permissions === void 0) {
        return false;
      }
      return true;
    };

    AppRedesign.createDashboardsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.create_dashboards;
      } else {
        return true;
      }
    };

    AppRedesign.readDashboardsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.read_dashboards;
      } else {
        return true;
      }
    };

    AppRedesign.readDashboardsEnabledOnSpecificDashboard = function(dashboardId) {
      var ref, ref1;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!((ref = App.Dashboard.find(dashboardId)) != null ? ref.permissions : void 0)) {
          return false;
        }
        return AppRedesign.readDashboardsEnabled() && ((ref1 = App.Dashboard.find(dashboardId)) != null ? ref1.permissions['read_dashboards'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.createSqlChartsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.create_sql_charts;
      } else {
        return true;
      }
    };

    AppRedesign.createSqlChartsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.createSqlChartsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['create_sql_charts'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.editChartAsCopyEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.edit_chart_as_copy;
      } else {
        return true;
      }
    };

    AppRedesign.editChartAsCopyEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.editChartAsCopyEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['edit_chart_as_copy'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.canOnlyEditChartAsCopy = function() {
      return AppRedesign.editChartAsCopyEnabledOnDashboard() && !AppRedesign.createSqlChartsEnabledOnDashboard();
    };

    AppRedesign.createDiscoveryChartsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.create_discovery_charts;
      } else {
        return true;
      }
    };

    AppRedesign.createDiscoveryChartsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.createDiscoveryChartsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['create_discovery_charts'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.editDashboardSettingsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.edit_dashboard_settings;
      } else {
        return true;
      }
    };

    AppRedesign.editDashboardSettingsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.editDashboardSettingsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['edit_dashboard_settings'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.archiveDashboardsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.archive_dashboards;
      } else {
        return true;
      }
    };

    AppRedesign.archiveDashboardsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.archiveDashboardsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['archive_dashboards'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.cloneDashboardsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.clone_dashboards;
      } else {
        return true;
      }
    };

    AppRedesign.cloneDashboardsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.cloneDashboardsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['clone_dashboards'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.downloadPdfPermissionEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.download_pdf;
      } else {
        return true;
      }
    };

    AppRedesign.downloadPdfPermissionEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.downloadPdfPermissionEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['download_pdf'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.sharedDashboardsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.shared_dashboards;
      } else {
        return true;
      }
    };

    AppRedesign.sharedDashboardsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.sharedDashboardsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['shared_dashboards'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.editPermissionsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.edit_permissions;
      } else {
        return false;
      }
    };

    AppRedesign.editOfficeStatusEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.edit_dashboard_official_status;
      } else {
        return App.User.currentUser().isAdmin();
      }
    };

    AppRedesign.editOfficeStatusEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.editOfficeStatusEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['edit_dashboard_official_status'] : void 0);
      } else {
        return App.User.currentUser().isAdmin();
      }
    };

    AppRedesign.editPermissionsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.editPermissionsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['edit_permissions'] : void 0);
      } else {
        return false;
      }
    };

    AppRedesign.emailReportsEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.email_reports;
      } else {
        return true;
      }
    };

    AppRedesign.emailReportsEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.emailReportsEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['email_reports'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.qualityCheckEnabled = function() {
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.current().state.RbacPermissionsHash.dashboard_permissions.quality_check;
      } else {
        return true;
      }
    };

    AppRedesign.qualityCheckEnabledOnDashboard = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        if (!AppRedesign.currentPermissionsExist()) {
          return false;
        }
        return AppRedesign.qualityCheckEnabled() && ((ref = App.Dashboard.currentDashboard()) != null ? ref.permissions['quality_check'] : void 0);
      } else {
        return true;
      }
    };

    AppRedesign.slackGitIntegrationEnabled = function() {
      return _.includes(AppRedesign.windowLocation().href, 'slackGit=true');
    };

    AppRedesign.hasCustomerUnification = function() {
      var ref;
      return (ref = AppRedesign.current().state.CustomerUnificationFields) != null ? ref.customer_unification_enabled : void 0;
    };

    AppRedesign.allowRevokingWorkbooksAccess = function() {
      var ref;
      return (ref = AppRedesign.current().state.CustomerUnificationFields) != null ? ref.allow_revoking_workbooks_access : void 0;
    };

    AppRedesign.hasNotificationBar = function() {
      return $('.notification-bar').children().length > 0;
    };

    return AppRedesign;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.BatchingLogger = (function() {
    function BatchingLogger() {
      this.uploadLogs = bind(this.uploadLogs, this);
      this.events = [];
      this.interval = setInterval(this.uploadLogs, 60 * 1000);
    }

    BatchingLogger.prototype.logToScalyr = function(clientMessage, values) {
      var k, line, logChunks, v;
      if (values == null) {
        values = {};
      }
      logChunks = jQuery.extend(this.constructor.logData(clientMessage), values);
      line = ((function() {
        var results;
        results = [];
        for (k in logChunks) {
          v = logChunks[k];
          results.push(k + "=" + v);
        }
        return results;
      })()).join(" ");
      this.events.push(line);
      return line;
    };

    BatchingLogger.prototype.uploadLogs = function() {
      var ref, toUpload;
      if (this.events.isEmpty() || ((ref = AppRedesign.current()) != null ? ref.shared_mode : void 0)) {
        return;
      }
      toUpload = this.events;
      this.events = [];
      return jQuery.post("/sites/" + (App.Site.first().id) + "/log", {
        events: toUpload
      });
    };

    BatchingLogger.logData = function(clientMessage) {
      var details, e, ref, ref1, ref2, ref3, ref4;
      details = {};
      try {
        details = {
          client_message: clientMessage,
          browser: [BrowserDetect.OS, BrowserDetect.browser, BrowserDetect.version].join(','),
          uuid: (ref = AppRedesign.current()) != null ? ref.uuid : void 0,
          site: (ref1 = App.Site.first()) != null ? ref1.id : void 0,
          heroku: (ref2 = AppRedesign.current()) != null ? ref2.herokuReleaseVersion : void 0,
          user: App.User.safeCurrentUser().id,
          dashboard: (ref3 = App.Dashboard.currentDashboard()) != null ? ref3.id : void 0,
          udv: (ref4 = App.UserDataView.current()) != null ? ref4.id : void 0
        };
      } catch (error) {
        e = error;
        AppRedesign.logError(e);
      }
      return details;
    };

    return BatchingLogger;

  })();

}).call(this);
(function() {
  App.ChartFormatters = (function() {
    function ChartFormatters() {}

    ChartFormatters.CELL_FORMAT_PERCENT = 'percent';

    ChartFormatters.CELL_FORMAT_CURRENCY = 'currency';

    ChartFormatters.CELL_FORMAT_NUMBER = 'number';

    ChartFormatters.NUMERIC_CELL_FORMATS = [ChartFormatters.CELL_FORMAT_PERCENT, ChartFormatters.CELL_FORMAT_CURRENCY, ChartFormatters.CELL_FORMAT_NUMBER];

    ChartFormatters.DECIMAL_DEFAULTS = {};

    ChartFormatters.DECIMAL_DEFAULTS[ChartFormatters.CELL_FORMAT_PERCENT] = 2;

    ChartFormatters.DECIMAL_DEFAULTS[ChartFormatters.CELL_FORMAT_CURRENCY] = 2;

    ChartFormatters.DECIMAL_DEFAULTS[ChartFormatters.CELL_FORMAT_NUMBER] = null;

    ChartFormatters.defaultYAxisFormatter = function() {
      return App.Utils.scaleNumberForYAxis(this.value, this.axis.min, this.axis.max, this.axis.tickInterval);
    };

    ChartFormatters.yAxisPercentFormatter = function() {
      if (!((this.value != null) && !isNaN(parseFloat(this.value)))) {
        return "-";
      }
      return (App.Utils.roundToSignificantDigits(this.value * 100, 5)) + "%";
    };

    ChartFormatters.yAxisRevenueFormatter = function() {
      return App.Utils.formatDollarsAsString(this.value, {
        symbol: this.currency
      });
    };

    ChartFormatters.cohortGridCellFormatter = function(val, options) {
      var float_val, symbol;
      if (options == null) {
        options = {};
      }
      if (!App.ChartUtils.isNumberish(val)) {
        return val;
      }
      float_val = App.ChartUtils.numberFromNumberishString(val);
      if (options.tableValueFormat === App.Tooltip.PERCENT) {
        return App.Utils.formatAsPercent(float_val * 100, {
          num_decimals: 1
        });
      } else if (options.tableValueFormat === App.Tooltip.DOLLAR) {
        symbol = App.Tooltip.CURRENCY_SYMBOL[options.currency];
        return App.Utils.formatDollarsAsString(float_val, {
          do_not_round: Math.abs(float_val) < 1000,
          symbol: symbol
        });
      } else {
        return ChartFormatters.tableValueFormatter(val, options.columnValueFormat, options.numDecimals, options.currency);
      }
    };

    ChartFormatters.tableCellFormatter = function(val, options) {
      var format;
      format = options.columnValueFormat;
      return ChartFormatters.tableValueFormatter(val, format, options.numDecimals, options.currency);
    };

    ChartFormatters.tableValueFormatter = function(valStr, columnValueFormat, numDecimals, currency) {
      var number, prefix, roundedWithCommasStr, suffix;
      if (!App.ChartUtils.isNumberish(valStr)) {
        return valStr;
      }
      if (!ChartFormatters.NUMERIC_CELL_FORMATS.includes(columnValueFormat)) {
        return valStr;
      }
      number = App.ChartUtils.numberFromNumberishString(valStr);
      if (numDecimals == null) {
        numDecimals = ChartFormatters.DECIMAL_DEFAULTS[columnValueFormat];
      }
      prefix = '';
      suffix = '';
      if (columnValueFormat === ChartFormatters.CELL_FORMAT_PERCENT) {
        number *= 100;
        suffix = '%';
      } else if (columnValueFormat === ChartFormatters.CELL_FORMAT_CURRENCY) {
        if (currency == null) {
          currency = '$';
        }
        if (currency === 'none') {
          currency = '';
        }
        prefix = currency;
        if (prefix === 'SEK') {
          prefix = '';
          suffix = ' kr';
        }
      }
      if (numDecimals != null) {
        number = App.Utils.roundToDecimals(number, numDecimals);
      }
      roundedWithCommasStr = number.commaDelimit();
      if (numDecimals != null) {
        roundedWithCommasStr = App.Utils.rpadZeroes(roundedWithCommasStr, numDecimals);
      }
      if (number < 0 && columnValueFormat === ChartFormatters.CELL_FORMAT_CURRENCY && currency !== '') {
        return '-' + prefix + roundedWithCommasStr.substr(1) + suffix;
      }
      return prefix + roundedWithCommasStr + suffix;
    };

    ChartFormatters.defaultXAxisFormatter = function(val) {
      return val;
    };

    ChartFormatters.hourlyDatetimeXAxisFormatter = function(val) {
      var d;
      if (!/^\d{4}\-\d{2}\-\d{2} \d{2}:00:00$/.test(val)) {
        return val;
      }
      d = App.Utils.datetimeStringToJSDate(val);
      return (DateFormat.dateFormat('%e %b %H', d)) + ":00";
    };

    ChartFormatters.getYAxisFormatter = function(format) {
      if (format === App.Tooltip.DOLLAR) {
        return App.ChartFormatters.yAxisRevenueFormatter;
      }
      if (format === App.Tooltip.PERCENT) {
        return App.ChartFormatters.yAxisPercentFormatter;
      }
      return App.ChartFormatters.defaultYAxisFormatter;
    };

    return ChartFormatters;

  })();

}).call(this);
(function() {
  App.ChartUtils = (function() {
    function ChartUtils() {}

    ChartUtils.DATETIME_ON_THE_HOUR = /^\d{4}\-\d{2}\-\d{2} \d{2}:00:00([-+]00)?$/;

    ChartUtils.DATETIME_START_OF_DAY = /^\d{4}\-\d{2}\-\d{2} 00:00:00([-+]00)?$/;

    ChartUtils.LOOSE_DATE_REGEX = /\d{4}\-\d{2}\-\d{2}/;

    ChartUtils.CURRENCY_REGEX = /[$€£]/;

    ChartUtils.CHART_TYPES_ALLOW_CONT_X = ['line', 'column', 'area', 'scatter', 'bubble', 'sparkline', 'bignumber'];

    ChartUtils.CHART_TYPES_MULTI_VALUE = ['scatter', 'bubble', 'geomap'];

    ChartUtils.CHART_TYPES_NO_GROUPING = ['table'];

    ChartUtils.CHART_TYPES_X_Y_POINT = ['bubble', 'geomap'];

    ChartUtils.CHART_TYPES_ALLOW_STRING_VALUE_COLS = ['image', 'geomap', 'bignumber', 'table', 'cohort'];

    ChartUtils.CHART_TYPES_SORT_VALUE_COLS = ['cohort'];

    ChartUtils.CHART_TYPES_ALLOW_POINT_AND_VALUE = ['cohort', 'geomap'];

    ChartUtils.CHART_TYPES_ALLOW_BAD_DATES = ['cohort'];

    ChartUtils.CHART_TYPES_ONLY_EXPLICIT_COLUMNS_WHEN_SET = ['cohort'];

    ChartUtils.CHART_TYPES_DISALLOW_SEGMENTATION = ['codeimage', 'codetext', 'image', 'table'];

    ChartUtils.CHART_TYPES_DISABLE_CHART_SETTINGS = ['codeimage', 'codetext', 'image', 'geomap', 'pie', 'table', 'cohort'];

    ChartUtils.CHART_TYPES_DISABLE_TOOLTIP_TOTAL = ['codeimage', 'codetext', 'image', 'geomap', 'pie', 'table', 'cohort', 'bubble'];

    ChartUtils.CHART_TYPES_DISALLOW_AXIS_RANGE = ['table', 'codeimage', 'codetext', 'image', 'cohort', 'pie', 'geomap', 'sparkline'];

    ChartUtils.CHART_TYPES_TOTAL_ORDER = ['scatter', 'spline', 'line', 'bubble', 'stackedBar', 'stackedColumn', 'bar', 'column', 'stackedArea'];

    ChartUtils.CHART_TYPES_REVERSED_ORDER = ['stackedBar', 'stackedColumn', 'stackedArea'];

    ChartUtils.CHART_TYPES_DISCRETE_MARKER = ['scatter', 'column'];

    ChartUtils.CHART_TYPES_WITH_X_AXIS_LABELS = ['line', 'column', 'area', 'scatter', 'bubble'];

    ChartUtils.CHART_TYPES = {
      "column": {
        display: "Bar"
      },
      "line": {
        display: "Line"
      },
      "area": {
        display: "Area"
      },
      "pie": {
        display: "Pie"
      },
      "scatter": {
        display: "Scatter"
      },
      "bubble": {
        display: "Bubble"
      },
      "bignumber": {
        display: "Number Overlay"
      },
      "sparkline": {
        display: "Sparkline"
      },
      "table": {
        display: "Table"
      },
      "cohort": {
        display: "Cohort Grid"
      },
      "geomap": {
        display: "Map"
      },
      "image": {
        display: "Image"
      }
    };

    ChartUtils.CODE_CHART_DATA_TYPES = {
      "codeimage": {
        data_type: "imagelink"
      },
      "codetext": {
        data_type: "textlink"
      }
    };

    ChartUtils.R_CHART_TYPE_DETAILS = {
      "codeimage": {
        display: "R Chart",
        data_type: 'imagelink'
      },
      "codetext": {
        display: "R Text",
        data_type: 'textlink'
      }
    };

    ChartUtils.PYTHON_CHART_TYPE_DETAILS = {
      "codeimage": {
        display: "Python Chart",
        data_type: 'imagelink'
      },
      "codetext": {
        display: "Python Text",
        data_type: 'textlink'
      }
    };

    ChartUtils.DEFAULT_CHART_TYPE_BY_DATA_TYPE = {
      "imagelink": 'codeimage',
      "plotlylink": 'codeimage',
      "textlink": 'codetext'
    };

    ChartUtils.DATE_REGEX = /^\d{4}\-\d{2}\-\d{2}(\s00:00:00(\.0)?)?([\+\-]\d{2})?$/;

    ChartUtils.DATETIME_REGEX = /^\d{4}\-\d{2}\-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?(\+00)?$/;

    ChartUtils.getDefaultChartType = function(dataType) {
      var ref;
      return (ref = this.DEFAULT_CHART_TYPE_BY_DATA_TYPE[dataType]) != null ? ref : 'table';
    };

    ChartUtils.getCodeChartDataType = function(chartType) {
      var ref, ref1;
      return (ref = (ref1 = this.CODE_CHART_DATA_TYPES[chartType]) != null ? ref1.data_type : void 0) != null ? ref : 'table';
    };

    ChartUtils.isCodeChart = function(chartType) {
      return this.DEFAULT_CHART_TYPE_BY_DATA_TYPE[chartType] != null;
    };

    ChartUtils.displayNameForChartType = function(chartType) {
      var ref;
      return (ref = this.CHART_TYPES[chartType]) != null ? ref.display : void 0;
    };

    ChartUtils.disableChartSettings = function(twiddlesActual) {
      var base;
      return typeof (base = this.CHART_TYPES_DISABLE_CHART_SETTINGS).includes === "function" ? base.includes(twiddlesActual.twiddles['chart_type']) : void 0;
    };

    ChartUtils.chartHasXYPoints = function(twiddles) {
      var ct;
      ct = twiddles.twiddles[App.TwiddleConfig.CHART_TYPE];
      if (ct === 'bubble') {
        return true;
      }
      if (ct === 'geomap' && twiddles.twiddles[App.TwiddleConfig.GEOMAP_DATA_MODE] !== 'geojson') {
        return true;
      }
      return false;
    };

    ChartUtils.alwaysIndex = function(twiddles) {
      return this.noValueColumnNeeded(twiddles);
    };

    ChartUtils.noValueColumnNeeded = function(twiddles) {
      return twiddles.twiddles['twiddle_chart_type'] === 'geomap' && twiddles.twiddles[App.TwiddleConfig.GEOMAP_DATA_MODE] === App.Geomap.DATA_MODE_GEOJSON;
    };

    ChartUtils.columnIsNumeric = function(colName, rows, opts) {
      var allowBlanks, i, len, numRowsToTest, numericCount, ref, regStr, regex, row, val;
      if (opts == null) {
        opts = {};
      }
      allowBlanks = (opts.allowBlanks != null) && opts.allowBlanks;
      regStr = "-?\\d*(\\.\\d+)?([eE][-+]?\\d+)?";
      if (opts.allowPercent) {
        regStr += "%?";
      }
      regex = new RegExp("^" + regStr + "$");
      numericCount = 0;
      numRowsToTest = opts.numRowsToTest || 100;
      ref = rows.slice(0, numRowsToTest);
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        if (numericCount > 10 && !opts.checkAllRows) {
          break;
        }
        val = row[colName];
        if (allowBlanks && App.Utils.isBlank(val)) {
          continue;
        }
        val = (val + '').replace(/,/g, '');
        val = val.replace(ChartUtils.CURRENCY_REGEX, '').trim();
        if (!(val && regex.test(val))) {
          return false;
        }
        numericCount += 1;
      }
      return numericCount > 0 || allowBlanks;
    };

    ChartUtils.everyValueNumeric = function(row) {
      var key, value;
      for (key in row) {
        value = row[key];
        if (!$.isNumeric(value)) {
          return false;
        }
      }
      return true;
    };

    ChartUtils.stripStringToNumberishPart = function(str) {
      return str.replace(/[$\s]/g, '').match(/^(?:[#\$£₩₹₺€><=@]?|(?:SEK)?)\s*([0-9\.,\-]+([eE][-+]?\d+)?)/i);
    };

    ChartUtils.isNumberish = function(string) {
      if (typeof string === 'number') {
        return true;
      }
      if (typeof string !== 'string') {
        return false;
      }
      if (string.match(App.ChartUtils.LOOSE_DATE_REGEX)) {
        return false;
      }
      if (!this.stripStringToNumberishPart(string)) {
        return false;
      }
      return string.match(/\..*\./) == null;
    };

    ChartUtils.numberFromNumberishString = function(string) {
      var e, number, numberMatches, numberPart;
      number = string * 1;
      if (!isNaN(number)) {
        return number;
      }
      try {
        numberMatches = this.stripStringToNumberishPart(string);
        numberPart = numberMatches[1].replace(/[,]/g, '');
        number = parseFloat(numberPart);
        if (!(isNaN(number) || (number == null) || string.match(ChartUtils.DATE_REGEX) || string.match(ChartUtils.DATETIME_REGEX))) {
          return number;
        }
      } catch (error) {
        e = error;
      }
      return string;
    };

    ChartUtils.columnDateTimeType = function(colName, rows) {
      var dateTimeCount, dateTimeType, i, len, row, val;
      dateTimeCount = 0;
      dateTimeType = null;
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        val = row[colName];
        if (App.Utils.isBlank(val)) {
          continue;
        }
        dateTimeType = App.TimeMachine.dateTimeType(val);
        if (dateTimeType == null) {
          return null;
        }
        dateTimeCount += 1;
      }
      if (dateTimeCount > 0) {
        return dateTimeType;
      } else {
        return null;
      }
    };

    ChartUtils.columnIsHourlyDateTime = function(colName, rows) {
      var i, len, notStartOfDayCount, ref, row, val;
      notStartOfDayCount = 0;
      ref = rows.slice(0, 100);
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        if (notStartOfDayCount > 10) {
          break;
        }
        val = row[colName];
        if (App.Utils.isBlank(val)) {
          continue;
        }
        if (!this.DATETIME_ON_THE_HOUR.test(val)) {
          return false;
        }
        if (!this.DATETIME_START_OF_DAY.test(val)) {
          notStartOfDayCount += 1;
        }
      }
      return notStartOfDayCount > 0;
    };

    ChartUtils.callHighchartsFormatterForCanvasJs = function(formatter, value, axisMin, axisMax, tickInterval, formatterOptions) {
      if (formatterOptions == null) {
        formatterOptions = {};
      }
      return formatter.call({
        value: value,
        currency: App.Tooltip.CURRENCY_SYMBOL[formatterOptions.currency],
        axis: {
          min: axisMin,
          max: axisMax,
          tickInterval: tickInterval
        }
      });
    };

    return ChartUtils;

  })();

}).call(this);
(function() {
  App.ChartographerCache = (function() {
    ChartographerCache.RESULT_CACHE_SIZE = function() {
      return 25;
    };

    ChartographerCache.setIntoCache = function(chartHashKey, result) {
      var ref;
      (ref = this._chartographerCache()).setIntoCache.apply(ref, arguments);
      return result;
    };

    ChartographerCache.getFromCache = function() {
      var ref;
      return (ref = this._chartographerCache()).getFromCache.apply(ref, arguments);
    };

    ChartographerCache._chartographerCache = function() {
      var base;
      return (base = AppRedesign.current()).chartogropherCache != null ? base.chartogropherCache : base.chartogropherCache = new this();
    };

    function ChartographerCache() {
      this.resultsCache = new OrderedHash();
    }

    ChartographerCache.prototype.setIntoCache = function(chartHashKey, result) {
      if (!AppRedesign.isRedesignMode()) {
        return;
      }
      this.resultsCache.push(chartHashKey, result);
      if (this.resultsCache.length() > this.constructor.RESULT_CACHE_SIZE()) {
        return this.resultsCache.remove(this.resultsCache.firstKey());
      }
    };

    ChartographerCache.prototype.getFromCache = function(chartHashKey) {
      return this.resultsCache.val(chartHashKey);
    };

    return ChartographerCache;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CheckForUpdates = (function(superClass) {
    extend(CheckForUpdates, superClass);

    CheckForUpdates.include(Spine.Events);

    function CheckForUpdates(state1, spinalCord, initialDashboardId, timing) {
      this.state = state1;
      this.spinalCord = spinalCord;
      this.initialDashboardId = initialDashboardId;
      this.timing = timing;
      this.loadLibraries = bind(this.loadLibraries, this);
      this.handleFailedRemainingState = bind(this.handleFailedRemainingState, this);
      this.handleSuccessRemainingState = bind(this.handleSuccessRemainingState, this);
      this.completeRemainingStateUrl = bind(this.completeRemainingStateUrl, this);
      this.handleRemainingState = bind(this.handleRemainingState, this);
      this.getDashboardWidgets = bind(this.getDashboardWidgets, this);
      this.getDashboardState = bind(this.getDashboardState, this);
      this.loadedDashboardWidgets = bind(this.loadedDashboardWidgets, this);
      this.handleDbSchemaResponse = bind(this.handleDbSchemaResponse, this);
      this.fetchDbSchemas = bind(this.fetchDbSchemas, this);
      this.datasetsLoading = bind(this.datasetsLoading, this);
      this.getCompleteDashboard = bind(this.getCompleteDashboard, this);
      this.ensureDbSchemaFetchedForWriteUser = bind(this.ensureDbSchemaFetchedForWriteUser, this);
      this.canUserExplore = bind(this.canUserExplore, this);
      this.canUserEdit = bind(this.canUserEdit, this);
      this.canFetchDbSchema = bind(this.canFetchDbSchema, this);
      this.enableDashboardFetching = bind(this.enableDashboardFetching, this);
      this.remainingStateFailures = 0;
      this.fetcherDisabled = false;
    }

    CheckForUpdates.prototype.configureFetcher = function() {
      if (this.fetcherDisabled) {
        return;
      }
      this.allowDashboardFetching = false;
      this.configureSourceFetcher(this.state);
      this.fetchInitialWidgetHashKeys();
      if (this.state.Site != null) {
        return this.fetchRemainingState(this.state.Site.id, this.initialDashboardId);
      }
    };

    CheckForUpdates.prototype.disableFetcher = function() {
      return this.fetcherDisabled = true;
    };

    CheckForUpdates.prototype.enableDashboardFetching = function() {
      if (this.fetcherDisabled) {
        return;
      }
      return this.allowDashboardFetching = true;
    };

    CheckForUpdates.prototype.checkForUpdatesImmediately = function() {
      if (this.fetcherDisabled) {
        return;
      }
      return App.Site.trigger('request-several-updates');
    };

    CheckForUpdates.prototype.canFetchDbSchema = function() {
      if (this.fetcherDisabled) {
        return false;
      }
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        return App.User.CurrentUserCanEdit();
      }
    };

    CheckForUpdates.prototype.canUserEdit = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabled();
      } else {
        if (App.User.currentUser()) {
          return (ref = App.User.currentUser()) != null ? ref.canEdit() : void 0;
        } else {
          return true;
        }
      }
    };

    CheckForUpdates.prototype.canUserExplore = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createDiscoveryChartsEnabled();
      } else {
        if (App.User.currentUser()) {
          return (ref = App.User.currentUser()) != null ? ref.canExplore() : void 0;
        } else {
          return true;
        }
      }
    };

    CheckForUpdates.prototype.ensureDbSchemaFetchedForWriteUser = function(siteId, options) {
      var dbWithoutSchemaExists;
      if (this.fetcherDisabled) {
        return;
      }
      dbWithoutSchemaExists = options != null ? options.dbWithoutSchemaExists : void 0;
      if ((this.dbSchemaFetched || this.shared_mode) && !dbWithoutSchemaExists) {
        return;
      }
      if (siteId == null) {
        siteId = App.Site.first().id;
      }
      if (this.canFetchDbSchema()) {
        return this.fetchDbSchemas(siteId);
      }
    };

    CheckForUpdates.prototype.getCompleteDashboard = function(dashboard, onWidgetsLoaded) {
      if (this.fetcherDisabled) {
        return;
      }
      if (!this.allowDashboardFetching) {
        return;
      }
      if (dashboard.isArchived()) {
        return;
      }
      this.getDashboardState(dashboard);
      return this.getDashboardWidgets(App.Site.first().id, dashboard.id, onWidgetsLoaded);
    };

    CheckForUpdates.prototype.fetchRemainingState = function(siteId, dashboardId) {
      var i, len, remaining_state_calls, results, url;
      this.getDashboardWidgets(siteId, dashboardId);
      remaining_state_calls = ['/login_state/datasets', '/welcome/remaining_state/dashboard_group_permissions', '/login_state/dashboards', '/welcome/remaining_state/misc', '/sql_snippets/'];
      if (this.canUserExplore()) {
        remaining_state_calls.push('/login_state/sql_views');
        remaining_state_calls.push('/login_state/csv_views');
      }
      if (this.canUserEdit()) {
        remaining_state_calls.push('/login_state/sql_alerts');
      }
      if (AppRedesign.dashboardOrganizationEnabled()) {
        remaining_state_calls.push('/welcome/remaining_state/topics');
      }
      if (AppRedesign.autoArchiveEnabled() && !AppRedesign.dashboardOrganizationEnabled()) {
        remaining_state_calls.push('/login_state/searchable_archives');
      }
      if (AppRedesign.pendingSiteModels()) {
        remaining_state_calls.push('/welcome/remaining_state/site_models');
      }
      if (AppRedesign.restrictDatabasesEnabled()) {
        remaining_state_calls.push('/welcome/remaining_state/database_group_permissions');
      }
      this.pendingRemainingStateCalls = _.clone(remaining_state_calls);
      results = [];
      for (i = 0, len = remaining_state_calls.length; i < len; i++) {
        url = remaining_state_calls[i];
        results.push(this.getRemainingState(siteId, url));
      }
      return results;
    };

    CheckForUpdates.prototype.configureSourceFetcher = function(state) {
      var ref;
      return App.SourceFetcher.configure((ref = state.auth_tokens) != null ? ref.SourcererClient : void 0, state.sourcerer_fe_addr);
    };

    CheckForUpdates.prototype.fetchInitialWidgetHashKeys = function() {
      var hashKeys, w, widgets_json;
      widgets_json = this.state.Widget || [];
      hashKeys = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = widgets_json.length; i < len; i++) {
          w = widgets_json[i];
          if ((w.formula_source_hash_key != null) && !w.blocked_by_database_mapping_feature) {
            results.push(w.formula_source_hash_key);
          }
        }
        return results;
      })();
      return App.sourceFetcher().initialFetch(hashKeys);
    };

    CheckForUpdates.prototype.datasetsLoading = function(url) {
      var datasetsFullyLoaded;
      if (this.datasetPartsLoaded == null) {
        this.datasetPartsLoaded = [];
      }
      this.datasetPartsLoaded.push(_.replace(url, '/login_state/', ''));
      datasetsFullyLoaded = _.isEqual(this.datasetPartsLoaded.sort(), ['csv_views', 'datasets', 'sql_views']);
      if (datasetsFullyLoaded) {
        return window.reactApp.updateDatasets(App.DatasetViewer.datasets());
      }
    };

    CheckForUpdates.prototype.fetchDbSchemas = function(siteId) {
      return jQuery.get("/sites/" + siteId + "/get_db_schemas", {}, this.handleDbSchemaResponse);
    };

    CheckForUpdates.prototype.handleDbSchemaResponse = function(response) {
      var db, db_schema, i, len, ref;
      ref = response.results;
      for (i = 0, len = ref.length; i < len; i++) {
        db_schema = ref[i];
        db = App.Database.exists(db_schema.id);
        if (!db) {
          continue;
        }
        db.schema = db_schema.schema;
        db.row_counts = db_schema.row_counts;
        db.autocomplete_list = db_schema.autocomplete_list;
        db.save({
          ajax: false
        });
      }
      App.Database.clearTableCache();
      AppRedesign.current().siteController.stashDatabaseStateOnce();
      App.Dashboard.trigger('schemas-loaded');
      return this.dbSchemaFetched = true;
    };

    CheckForUpdates.prototype.loadedDashboardWidgets = function(response) {
      return this.spinalCord.applyAllTheUpdates(response);
    };

    CheckForUpdates.prototype.getDashboardState = function(dashboard, onSuccess) {
      if (onSuccess == null) {
        onSuccess = function() {};
      }
      if (!this.allowDashboardFetching) {
        return;
      }
      if (!dashboard.isCompletelyLoaded()) {
        return this.spinalCord.getStateForDashboardWithCallback(dashboard.id, onSuccess);
      } else {
        return this.spinalCord.requestQuickUpdate();
      }
    };

    CheckForUpdates.prototype.getDashboardWidgets = function(siteId, dashboardId, onWidgetsLoaded) {
      return new App.WidgetFetcher(siteId, dashboardId, this.loadedDashboardWidgets, this.handleFailedRemainingState, onWidgetsLoaded);
    };

    CheckForUpdates.prototype.getRemainingState = function(siteId, url) {
      return jQuery.ajax({
        url: url,
        type: 'GET',
        data: {
          client_site_id: siteId
        },
        dataType: 'json'
      }).done((function(_this) {
        return function(response) {
          return _this.handleRemainingState(response, url);
        };
      })(this)).fail((function(_this) {
        return function(response) {
          if (response.statusText === 'timeout') {
            App.Logger.logError('remaining_state timeout', {
              url: url
            });
          }
          return _this.handleFailedRemainingState();
        };
      })(this));
    };

    CheckForUpdates.prototype.handleRemainingState = function(response, url) {
      if (this.timing.waitingOnInitialCharts && AppRedesign.current().secondsSincePageload() < 8) {
        setTimeout(((function(_this) {
          return function() {
            return _this.handleRemainingState(response, url);
          };
        })(this)), 50);
        return;
      }
      this.spinalCord.applyAllTheUpdates(response, {
        remainingStateLoaded: true
      });
      this.completeRemainingStateUrl(response, url);
      if ((url != null) && url.includes('sql_views')) {
        this.trigger('loaded-sql-views');
      }
      if ((url != null) && AppRedesign.dragDropEnabled() && (url.includes('sql_views') || url.includes('csv_views') || url.includes('datasets'))) {
        return this.datasetsLoading(url);
      }
    };

    CheckForUpdates.prototype.completeRemainingStateUrl = function(response, url) {
      _.pull(this.pendingRemainingStateCalls, url);
      if (response.Dashboard) {
        App.Dashboard.trigger("remaining-state-loaded-dashboards");
      }
      if (_.isEmpty(this.pendingRemainingStateCalls)) {
        return this.handleSuccessRemainingState();
      }
    };

    CheckForUpdates.prototype.handleSuccessRemainingState = function() {
      var ref;
      AppRedesign.current().notifyRemainingStateLoaded();
      App.DimensionAvailability.consolidateEvents();
      this.loadLibraries(((ref = this.state) != null ? ref.DeferredLibraries : void 0) || []);
      return AppRedesign.current().uiQueue.add(((function(_this) {
        return function() {
          return App.Dashboard.trigger('remaining-state-loaded');
        };
      })(this)), 'remaining-data', App.UiQueue.PRIORITY_REMAINING_STATE);
    };

    CheckForUpdates.prototype.handleFailedRemainingState = function() {
      this.remainingStateFailures += 1;
      if (this.remainingStateFailures > 1) {

      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.fetchRemainingState(App.Site.first().id, _this.initialDashboardId);
          };
        })(this)), 1000);
      }
    };

    CheckForUpdates.prototype.loadLibraries = function(libraries) {
      var element, i, len, library, results;
      results = [];
      for (i = 0, len = libraries.length; i < len; i++) {
        library = libraries[i];
        element = document.createElement("script");
        element.src = library;
        results.push(document.body.appendChild(element));
      }
      return results;
    };

    return CheckForUpdates;

  })(Spine.Module);

}).call(this);
(function() {
  App.ColorHelper = (function() {
    function ColorHelper() {}

    ColorHelper.CHART_COLORS = {
      normal: ["#6fb8ff", "#ff7555", "#59cec5", "#8849a5", "#c1d30c", "#f215a4", "#9480c1", "#e493c7", "#b5ca92"]
    };

    ColorHelper.defaultNewChartColor = function() {
      return '#8849a5';
    };

    ColorHelper.rgbToHex = function(color) {
      var rgb;
      if (color == null) {
        return;
      }
      rgb = this.getColorTripletFromRGB(color);
      if (rgb) {
        return "#" + ("0" + parseInt(rgb[0], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) + ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2);
      } else {
        return color;
      }
    };

    ColorHelper.hexToRGB = function(hexcode) {
      var triplet;
      triplet = this.getColorTripletFromHex(hexcode);
      if (!triplet) {
        return;
      }
      return "rgb(" + triplet[0] + ", " + triplet[1] + ", " + triplet[2] + ")";
    };

    ColorHelper.hexToRGBA = function(hexcode, opacity) {
      var triplet;
      if (opacity == null) {
        opacity = 1;
      }
      triplet = this.getColorTripletFromHex(hexcode);
      if (!triplet) {
        return;
      }
      return "rgba(" + triplet[0] + ", " + triplet[1] + ", " + triplet[2] + ", " + opacity + ")";
    };

    ColorHelper.getColorTripletFromHex = function(hexcode) {
      var color, triplet;
      if (hexcode == null) {
        return;
      }
      if (hexcode[0] !== '#') {
        return hexcode;
      }
      color = hexcode.replace(/#/, '');
      triplet = color.length === 3 ? [parseInt(color.slice(0, 1) + color.slice(0, 1), 16), parseInt(color.slice(1, 2) + color.slice(1, 1), 16), parseInt(color.slice(2, 3) + color.slice(2, 1), 16)] : color.length === 6 ? [parseInt(color.slice(0, 2), 16), parseInt(color.slice(2, 4), 16), parseInt(color.slice(4, 6), 16)] : [0, 0, 0];
      return triplet;
    };

    ColorHelper.getColorTripletFromRGB = function(rgb) {
      var matchData;
      if (rgb == null) {
        return;
      }
      matchData = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
      if (matchData == null) {
        return;
      }
      return [matchData[1], matchData[2], matchData[3]];
    };

    ColorHelper.setAlpha = function(color, alpha) {
      var rgba;
      if (color == null) {
        return;
      }
      rgba = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d(\.\d+)?)/i);
      if (rgba && rgba.length >= 5) {
        return "rgba(" + rgba[1] + ", " + rgba[2] + ", " + rgba[3] + ", " + alpha + ")";
      } else {
        return color;
      }
    };

    ColorHelper.hexColorOrNull = function(str) {
      if (str == null) {
        return null;
      }
      str = str.replace("#", "");
      if (str.match(/^[a-f0-9]{6}$/i)) {
        return "#" + str;
      } else {
        return null;
      }
    };

    ColorHelper.lightenOrDarken = function(color, pct) {
      var b, g, hex, num, r, ref;
      hex = (ref = this.rgbToHex(color)) != null ? ref.slice(1) : void 0;
      if (!hex) {
        return;
      }
      num = parseInt(hex, 16);
      r = Math.max(0, Math.min(255, (num >> 16) + pct));
      g = Math.max(0, Math.min(255, ((num >> 8) & 0xff) + pct));
      b = Math.max(0, Math.min(255, (num & 0x0000ff) + pct));
      return "rgba(" + r + ", " + g + ", " + b + ", 1)";
    };

    ColorHelper.toggleBorderClassOnColorLightness = function(element, color, klass, hspBrightness) {
      return element.toggleClass(klass, this.isLighterThan(color, hspBrightness));
    };

    ColorHelper.isLighterThan = function(color, hspBrightness) {
      var b, g, perceivedBrightness, r, ref, ref1, str;
      if (color.match(/^rgb/)) {
        ref = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/), str = ref[0], r = ref[1], g = ref[2], b = ref[3];
      } else {
        ref1 = this.getColorTripletFromHex(color), r = ref1[0], g = ref1[1], b = ref1[2];
      }
      perceivedBrightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
      return perceivedBrightness >= hspBrightness;
    };

    ColorHelper.rgbToHsv = function(rgb) {
      var b, d, g, h, max, min, r, rgbArray, s;
      rgbArray = this.getColorTripletFromRGB(rgb);
      if (rgbArray == null) {
        return null;
      }
      r = rgbArray[0] / 255;
      g = rgbArray[1] / 255;
      b = rgbArray[2] / 255;
      max = _.max([r, g, b]);
      min = _.min([r, g, b]);
      d = max - min;
      s = max === 0 ? 0 : d / max;
      if (max === min) {
        h = 0;
      } else {
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
        }
        h /= 6;
      }
      return _.map([h, s, max], function(f) {
        return _.round(f, 3);
      });
    };

    ColorHelper.hsvToRgb = function(h, s, v) {
      var b, f, g, i, p, q, r, ref, t;
      if (!((h != null) && (s != null) && (v != null))) {
        return null;
      }
      i = _.floor(h * 6);
      f = h * 6 - i;
      p = v * (1 - s);
      q = v * (1 - f * s);
      t = v * (1 - (1 - f) * s);
      ref = (function() {
        switch (i % 6) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      })(), r = ref[0], g = ref[1], b = ref[2];
      return "rgb(" + (_.round(r * 255)) + ", " + (_.round(g * 255)) + ", " + (_.round(b * 255)) + ")";
    };

    return ColorHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.CsvUploader = (function() {
    CsvUploader.MAX_FILE_SIZE = 1024 * 1024 * 50;

    CsvUploader.PARSE_ROW_LIMIT = 0;

    CsvUploader.S_LOADING = 'loading';

    CsvUploader.S_COMPLETE = 'complete';

    function CsvUploader(item) {
      this.item = item;
      this.afterSave = bind(this.afterSave, this);
      this.uploadComplete = bind(this.uploadComplete, this);
      this.uploadFailed = bind(this.uploadFailed, this);
      this.error = bind(this.error, this);
      this.uploadAndSaveError = bind(this.uploadAndSaveError, this);
      this.readFileError = bind(this.readFileError, this);
      this.schemaDeduced = bind(this.schemaDeduced, this);
      this.csvCompleteHandler = bind(this.csvCompleteHandler, this);
      this.csvErrorHandler = bind(this.csvErrorHandler, this);
      this.testDelimiter = bind(this.testDelimiter, this);
      this.detectDelimiter = bind(this.detectDelimiter, this);
      this.parse = bind(this.parse, this);
      this.percent_complete = 0;
      this.promiseReadFileResolve = null;
      this.promiseReadFileReject = null;
      this.promiseReadFile = new Promise((function(_this) {
        return function(resolve, reject) {
          _this.promiseReadFileResolve = resolve;
          return _this.promiseReadFileReject = reject;
        };
      })(this));
      this.promiseUploadAndSaveResolve = null;
      this.promiseUploadAndSaveReject = null;
      this.promiseUploadAndSave = new Promise((function(_this) {
        return function(resolve, reject) {
          _this.promiseUploadAndSaveResolve = resolve;
          return _this.promiseUploadAndSaveReject = reject;
        };
      })(this));
    }

    CsvUploader.prototype.release = function() {
      this.file = null;
      return this.file_data = null;
    };

    CsvUploader.prototype.state = function() {
      switch (false) {
        case !(this.UPLOAD_STARTED && this.percent_complete < 1):
          return CsvUploader.S_LOADING;
        case !this.deducingSchema:
          return CsvUploader.S_LOADING;
        default:
          return CsvUploader.S_COMPLETE;
      }
    };

    CsvUploader.prototype.readFile = function(file) {
      var reader;
      if (file.size > CsvUploader.MAX_FILE_SIZE) {
        this.readFileError(App.CsvView.FILE_TOO_BIG);
        return false;
      }
      this.deducingSchema = true;
      this.item.trigger('loading');
      reader = new FileReader();
      reader.file = file;
      reader.onload = this.parse;
      reader.readAsBinaryString(file);
      return this.promiseReadFile;
    };

    CsvUploader.prototype.uploadAndSave = function(afterSaveCallback) {
      var errors, isSuccess;
      this.afterSaveCallback = afterSaveCallback;
      errors = this.item.validate();
      isSuccess = false;
      if (!_.isEmpty(errors)) {
        this.uploadAndSaveError(errors[0]);
      } else if (this.item.s3_key) {
        isSuccess = this.afterSave();
      } else {
        isSuccess = this.upload();
      }
      return {
        success: isSuccess,
        promise: this.promiseUploadAndSave
      };
    };

    CsvUploader.prototype.parse = function(evt) {
      var csvConfig, e, file, file_data;
      file_data = evt.target.result.trim();
      try {
        file_data = decode_utf8(file_data);
      } catch (error) {
        e = error;
      }
      file = evt.target.file;
      csvConfig = {
        delimiter: this.detectDelimiter(file_data),
        header: true,
        worker: false,
        preview: this.constructor.PARSE_ROW_LIMIT,
        complete: (function(_this) {
          return function(r) {
            return _this.csvCompleteHandler(r, file, file_data);
          };
        })(this),
        error: this._csvErrorHandler,
        skipEmptyLines: true
      };
      return Papa.parse(file_data, csvConfig);
    };

    CsvUploader.prototype.detectDelimiter = function(fileData) {
      var rows;
      rows = fileData.split(/\r\n|\r|\n/);
      switch (false) {
        case !this.testDelimiter(rows, ';'):
          return ';';
        case !this.testDelimiter(rows, '\t'):
          return '\t';
        case !this.testDelimiter(rows, '|'):
          return '|';
        default:
          return ',';
      }
    };

    CsvUploader.prototype.testDelimiter = function(rows, delimiter) {
      var columnCount, delimiterPerRow, row;
      delimiterPerRow = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = rows.length; j < len; j++) {
          row = rows[j];
          results1.push(row.split(delimiter).length);
        }
        return results1;
      })();
      columnCount = delimiterPerRow[0];
      return columnCount > 1 && delimiterPerRow.slice(1).every(function(r) {
        return r === columnCount;
      });
    };

    CsvUploader.prototype.csvErrorHandler = function(err, file) {
      AppRedesign.logError(new Error(err));
      return this.readFileError('error', [App.CsvView.BAD_FILE]);
    };

    CsvUploader.prototype.csvCompleteHandler = function(results, file, file_data) {
      var errors, linebreak;
      errors = this.checkResultErrors(results);
      if (errors.indexOf(App.CsvView.EMPTY_FIELD_NAMES) > -1) {
        this.readFileError(App.CsvView.EMPTY_FIELD_NAMES);
        return;
      } else if (errors.indexOf(App.CsvView.DUPE_FIELD_NAMES) > -1) {
        this.readFileError(App.CsvView.DUPE_FIELD_NAMES);
        return;
      } else if (errors.length) {
        this.readFileError(App.CsvView.BAD_FILE);
        return;
      }
      this.file = file;
      this.name = this.file.name;
      this.size = this.file.size;
      linebreak = results.meta.linebreak;
      this.file_data = file_data.replace(new RegExp(linebreak, 'g'), "\n");
      this.delimiter = results.meta.delimiter;
      if (!this.delimiter) {
        this.delimiter = ',';
      }
      this.rows = results.data;
      return CsvUploader.deduceSchemaAsync(results.meta.fields, this.rows, this.schemaDeduced, this.readFileError);
    };

    CsvUploader.prototype.schemaDeduced = function(user_columns) {
      var col;
      this.user_columns = user_columns;
      delete this.deducingSchema;
      this.columns = (function() {
        var j, len, ref, results1;
        ref = this.user_columns;
        results1 = [];
        for (j = 0, len = ref.length; j < len; j++) {
          col = ref[j];
          results1.push(col.name);
        }
        return results1;
      }).call(this);
      this.item.csvParsed(this);
      return this.promiseReadFileResolve();
    };

    CsvUploader.prototype.checkResultErrors = function(results) {
      var errors;
      errors = [];
      if (this.hasEmptyFieldNames(results)) {
        errors.push(App.CsvView.EMPTY_FIELD_NAMES);
      }
      if (this.hasDuplicateFieldNames(results)) {
        errors.push(App.CsvView.DUPE_FIELD_NAMES);
      }
      if (this.hasParseErrors(results)) {
        errors.push('errors during parse');
      }
      if (results.meta.fields.length === 0) {
        errors.push('no fields');
      }
      if (results.data.length === 0) {
        errors.push('no rows');
      }
      if (results.meta.newline === '') {
        errors.push('bad newline');
      }
      return errors;
    };

    CsvUploader.prototype.hasEmptyFieldNames = function(results) {
      var c, j, len, ref;
      ref = results.meta.fields;
      for (j = 0, len = ref.length; j < len; j++) {
        c = ref[j];
        if (c === "") {
          return true;
        }
      }
      return false;
    };

    CsvUploader.prototype.hasParseErrors = function(results) {
      var e, j, len, ref;
      ref = results.errors;
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        if (e.type !== 'Delimiter') {
          return true;
        }
      }
      return false;
    };

    CsvUploader.prototype.hasDuplicateFieldNames = function(results) {
      var ref;
      if (!(results != null ? (ref = results.meta) != null ? ref.fields : void 0 : void 0)) {
        return false;
      }
      return results.meta.fields.length !== results.meta.fields.unique().length;
    };

    CsvUploader.guessTypeForColumn = function(colName, rows, errorFunc) {
      switch (false) {
        case !this.columnIsDateSeries(colName, rows):
          return 'timestamp';
        case !this.columnIsStrictNumeric(colName, rows):
          if (this.hasRowWithOnlySpaceOrNewline && App.Site.first().has_snowflake_cache) {
            this.errorOccured = true;
            errorFunc("Numeric column '" + colName + "' cannot include space or newline characters");
            return;
          }
          if (this.numericColumnIsIntegers(colName, rows)) {
            return 'integer';
          }
          return 'float';
        default:
          if (this.stringColumnIsShort(colName, rows)) {
            return 'smalltext';
          }
          return 'text';
      }
    };

    CsvUploader.numericColumnIsIntegers = function(colName, rows) {
      var j, len, r;
      for (j = 0, len = rows.length; j < len; j++) {
        r = rows[j];
        if ((r[colName] != null) && r[colName] !== '' && r[colName].indexOf('.') !== -1) {
          return false;
        }
      }
      return true;
    };

    CsvUploader.stringColumnIsShort = function(colName, rows) {
      var j, len, r;
      for (j = 0, len = rows.length; j < len; j++) {
        r = rows[j];
        if (r[colName].length > 255) {
          return false;
        }
      }
      return true;
    };

    CsvUploader.sanitizeColumnName = function(col) {
      return App.Utils.sanitizeSqlIdentifier(col);
    };

    CsvUploader.dedupeColumnName = function(colName, seenColumns) {
      if (seenColumns[colName] != null) {
        return this.dedupeColumnName("" + colName + (++seenColumns[colName]), seenColumns);
      }
      seenColumns[colName] = 1;
      return colName;
    };

    CsvUploader.deduceSchemaAsync = function(columns, rows, completeFunc, errorFunc) {
      var colName, j, len, sanitizedName, seenColumns, userColumns;
      this.errorOccured = false;
      userColumns = [];
      seenColumns = {};
      for (j = 0, len = columns.length; j < len; j++) {
        colName = columns[j];
        sanitizedName = this.dedupeColumnName(this.sanitizeColumnName(colName), seenColumns);
        userColumns.push({
          name: sanitizedName,
          originalName: colName,
          type: null
        });
      }
      return this.deduceAllColumnTypes(userColumns, rows, completeFunc, errorFunc);
    };

    CsvUploader.deduceAllColumnTypes = function(userColumns, rows, completeFunc, errorFunc) {
      var colInfo, j, len;
      for (j = 0, len = userColumns.length; j < len; j++) {
        colInfo = userColumns[j];
        if (colInfo.type == null) {
          this.deduceColumnType(colInfo, rows, errorFunc);
          if (this.errorOccured) {
            return;
          }
          setTimeout(((function(_this) {
            return function() {
              return _this.deduceAllColumnTypes(userColumns, rows, completeFunc, errorFunc);
            };
          })(this)), 0);
          return;
        }
      }
      return completeFunc(userColumns);
    };

    CsvUploader.deduceColumnType = function(colInfo, rows, errorFunc) {
      var guessedType;
      guessedType = this.guessTypeForColumn(colInfo.originalName, rows, errorFunc);
      if (guessedType != null) {
        colInfo.type = guessedType;
        this.hasRowWithOnlySpaceOrNewline = false;
      } else {
        return;
      }
      if (colInfo.type == null) {
        throw new Error("Type cannot be null");
      }
      if (colInfo.name !== colInfo.originalName) {
        return this.replaceKeyInRows(rows, colInfo.originalName, colInfo.name);
      }
    };

    CsvUploader.replaceKeyInRows = function(rows, oldKey, newKey) {
      var i, j, ref, results1;
      if (oldKey === newKey) {
        return;
      }
      results1 = [];
      for (i = j = 0, ref = rows.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        rows[i][newKey] = rows[i][oldKey] || "";
        results1.push(delete rows[i][oldKey]);
      }
      return results1;
    };

    CsvUploader.DATE_TIME_REGEX = /^\d{4}[^\d]\d{2}[^\d]\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?(\+00)?$/;

    CsvUploader.DATE_REGEX = /^(\d|\d{2}|\d{4})[^\d:](\d|\d{2})[^\d:](\d{2}|\d{4})$/;

    CsvUploader.columnIsDateSeries = function(colName, rows) {
      var blank_count, j, len, row, val;
      blank_count = 0;
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        val = row[colName];
        if (App.Utils.isBlank(val)) {
          blank_count += 1;
          continue;
        }
        if (!(this.DATE_REGEX.test(val) || this.DATE_TIME_REGEX.test(val))) {
          return false;
        }
      }
      if (blank_count === rows.length) {
        return false;
      }
      return true;
    };

    CsvUploader.columnIsStrictNumeric = function(colName, rows) {
      var j, len, row, val;
      for (j = 0, len = rows.length; j < len; j++) {
        row = rows[j];
        val = row[colName];
        if (App.Utils.hasOnlySpaceOrNewline(val)) {
          this.hasRowWithOnlySpaceOrNewline = true;
        }
        if (App.Utils.isBlank(val)) {
          continue;
        }
        if (!$.isNumeric(val)) {
          return false;
        }
      }
      return true;
    };

    CsvUploader.prototype.upload = function() {
      if (!this.file_data) {
        this.uploadAndSaveError(App.CsvView.NO_DATA);
        return false;
      }
      if (this.UPLOAD_STARTED) {
        return;
      }
      this.UPLOAD_STARTED = true;
      this.percent_complete = 0;
      return this.getS3Url(((function(_this) {
        return function(resp) {
          return _this.reallyUpload(resp);
        };
      })(this)), this.uploadFailed);
    };

    CsvUploader.prototype.getS3Url = function(success, fail) {
      this.file_md5 = md5_base64(encode_utf8(this.file_data));
      return jQuery.ajax({
        url: "/csv_views/upload_url",
        type: "POST",
        data: {
          client_site_id: App.Site.first().id,
          name: this.name,
          size: this.size,
          md5: this.file_md5
        }
      }).done(success).fail(fail);
    };

    CsvUploader.prototype.reallyUpload = function(response) {
      var s3_key, s3_url;
      s3_url = response.url;
      s3_key = response.key;
      return jQuery.ajax({
        url: s3_url,
        type: "PUT",
        timeout: 120 * 1000,
        data: this.file_data,
        headers: {
          "content-md5": this.file_md5
        },
        contentType: "text/csv; charset=UTF-8"
      }).done(((function(_this) {
        return function() {
          return _this.uploadComplete(s3_key);
        };
      })(this))).fail(this.uploadFailed);
    };

    CsvUploader.prototype.readFileError = function(errs) {
      this.promiseReadFileReject(errs);
      return this.error(errs);
    };

    CsvUploader.prototype.uploadAndSaveError = function(errs) {
      this.promiseUploadAndSaveReject(errs);
      return this.error(errs);
    };

    CsvUploader.prototype.error = function(errs) {
      this.item.csvErring(errs);
      return this.item.trigger('error', [errs]);
    };

    CsvUploader.prototype.uploadFailed = function(xhr, msg, err) {
      delete this.UPLOAD_STARTED;
      AppRedesign.logError(new Error(msg + ":" + err));
      return this.uploadAndSaveError(App.CsvView.FAILED_UPLOAD);
    };

    CsvUploader.prototype.uploadComplete = function(s3_key) {
      this.percent_complete = 1;
      this.item.s3_key = s3_key;
      this.item.create({
        success: this.afterSave,
        error: ((function(_this) {
          return function(e) {
            return _this.uploadFailed(null, 'Failed to create', e);
          };
        })(this))
      });
      return this.promiseUploadAndSaveResolve();
    };

    CsvUploader.prototype.afterSave = function() {
      if (this.afterSaveCallback) {
        return this.afterSaveCallback();
      }
    };

    return CsvUploader;

  })();

}).call(this);
(function() {
  App.CsvViewState = (function() {
    function CsvViewState(csvView) {
      this.csvView = csvView;
    }

    CsvViewState.prototype.statusForIcon = function() {
      if ((this.csvView.error_message == null) && (this.csvView.last_refreshed_at != null)) {
        return 'cached';
      } else if (this.csvView.error_message != null) {
        return 'error-uncached';
      } else {
        return 'queued-uncached';
      }
    };

    return CsvViewState;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CustomDimensionHelper = (function(superClass) {
    extend(CustomDimensionHelper, superClass);

    function CustomDimensionHelper() {
      return CustomDimensionHelper.__super__.constructor.apply(this, arguments);
    }

    CustomDimensionHelper.include(Spine.Events);

    CustomDimensionHelper.DASHBOARD_STATE_URL = '/login_state/custom_dimensions';

    CustomDimensionHelper.hashKeyCache = {};

    CustomDimensionHelper.loadCustomDimensionsAndFetchDefaults = function(dashboardId) {
      return jQuery.ajax({
        url: this.DASHBOARD_STATE_URL,
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id,
          current_dashboard: dashboardId
        },
        dataType: 'json'
      }).done((function(_this) {
        return function(response) {
          var dimensionIdsToUpdate, filteredRecords;
          if (!response.CustomDimension) {
            return;
          }
          App.CustomDimension.applyUpdates(response.CustomDimension);
          dimensionIdsToUpdate = _.map(_.filter(response.CustomDimension, function(dim) {
            return App.CustomDimension.cacheGet(dim.id, '') === null;
          }), 'id');
          filteredRecords = {};
          _.map(dimensionIdsToUpdate, function(id) {
            return filteredRecords[id] = App.CustomDimension.find(id);
          });
          return App.CustomDimension.getDefaultDimensionValues(filteredRecords);
        };
      })(this));
    };

    CustomDimensionHelper.loadCustomDimensionsAndMakeCurrent = function(dashboard, id_values) {
      return jQuery.ajax({
        url: this.DASHBOARD_STATE_URL,
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id,
          current_dashboard: dashboard.id
        },
        dataType: 'json'
      }).done((function(_this) {
        return function(response) {
          if (response.CustomDimension) {
            App.CustomDimension.applyUpdates(response.CustomDimension);
          }
          return App.dimentorClient().remoteNameFromValues(id_values, dashboard.updateUserDataViewWithNamesAndMakeCurrent);
        };
      })(this));
    };

    CustomDimensionHelper.dimensionDataUpToDate = function(cd) {
      return (cd.hash_key != null) && (cd.last_data_loaded_at != null) && this.cachedHashKey(cd.id)[cd.hash_key] === cd.last_data_loaded_at;
    };

    CustomDimensionHelper.cachedHashKey = function(dimensionId) {
      var base;
      return (base = this.hashKeyCache)[dimensionId] != null ? base[dimensionId] : base[dimensionId] = {};
    };

    return CustomDimensionHelper;

  })(Spine.Module);

}).call(this);
(function() {
  App.DashboardSizer = (function() {
    function DashboardSizer(dash) {
      this.dash = dash;
      this.SCROLLBAR_WIDTH = 15;
      this.setupConstants();
    }

    DashboardSizer.prototype.setupConstants = function() {
      var ref, unit;
      this.PAGE_HEADER_HEIGHT = 48;
      this.DASHBOARD_HEADER_EMAIL_HEIGHT = 139;
      this.EMAIL_PAGE_PADDING = 15;
      this.SITE_MENU_WIDTH = 180;
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        this.isFluid = true;
        unit = 32;
        this.MIN_COLUMN_WIDTH = unit / 2;
        this.MAX_COLUMN_WIDTH = unit;
        this.MAX_ROW_HEIGHT = unit;
        this.MIN_NUM_COLS = 960 / unit;
        this.MAX_NUM_COLS = 2880 / unit;
        this.TV_MODE_COLS = (960 / unit) * 2;
        this.SCREENSHOT_COLUMN_WIDTH = unit;
        this.SCREENSHOT_MARGIN = 15;
        this.SCREENSHOT_MIN_COLS = 8;
        this.DEFAULT_SCREEN_MARGIN = 25;
        this.MAX_ROWS = 1280 / unit;
        this.EDITOR_MAX_COLUMNS = 960 / unit;
        this.EDITOR_MAX_ROWS = 2 * Math.round(320 / unit);
        this.EDITOR_INITIAL_HEIGHT = Math.round(320 / unit);
        this.SHARED_DASHBOARD_HEADER_LOGO_PADDING = 7;
        this.BIGNUM_FONT_SIZE = 77;
        this.BIGNUM_VALUE_MARGIN = 20;
        this.LINKED_MODE_NUM_COLS = 960 / unit;
        this.LINKED_MODE_NUM_ROWS = 2 * Math.round(320 / unit);
        this.LIMIT_TO_BE_CONSIDERED_WIDE = 15;
        this.MIN_WIDGET_WIDTH = Math.round(160 / unit);
        this.MIN_WIDGET_HEIGHT = Math.round(160 / unit);
        this.DEFAULT_ROW_BUFFER = Math.round(320 / unit);
        this.DEFAULT_ROWS = 5 * Math.round(320 / unit);
        this.BUFFER_WIDTH = 8;
        return this.OVERLAY_TOP_RATIO = 0.24;
      } else {
        this.isFluid = false;
        this.MIN_COLUMN_WIDTH = 150;
        this.MAX_COLUMN_WIDTH = 320;
        this.MAX_ROW_HEIGHT = 320;
        this.MIN_NUM_COLS = 3;
        this.MAX_NUM_COLS = 9;
        this.TV_MODE_COLS = 6;
        this.SCREENSHOT_COLUMN_WIDTH = 320;
        this.SCREENSHOT_MARGIN = 15;
        this.SCREENSHOT_MIN_COLS = 3;
        this.DEFAULT_SCREEN_MARGIN = 50;
        this.MAX_ROWS = 4;
        this.EDITOR_MAX_COLUMNS = 3;
        this.EDITOR_MAX_ROWS = 2;
        this.EDITOR_INITIAL_HEIGHT = 1;
        this.SHARED_DASHBOARD_HEADER_LOGO_PADDING = 7;
        this.BIGNUM_FONT_SIZE = 77;
        this.BIGNUM_VALUE_MARGIN = 20;
        this.LINKED_MODE_NUM_COLS = 3;
        this.LINKED_MODE_NUM_ROWS = 2;
        this.LIMIT_TO_BE_CONSIDERED_WIDE = 1;
        this.MIN_WIDGET_WIDTH = 1;
        this.MIN_WIDGET_HEIGHT = 1;
        this.DEFAULT_ROW_BUFFER = 1;
        return this.DEFAULT_ROWS = 5;
      }
    };

    DashboardSizer.prototype.minDashboardWidth = function() {
      return this.getRightmostWidgetGridColumn() * this.MIN_COLUMN_WIDTH;
    };

    DashboardSizer.prototype.maxDashboardWidth = function() {
      return this.numCols() * this.MAX_COLUMN_WIDTH;
    };

    DashboardSizer.prototype.numCols = function(inEditron, screenshotMode) {
      var ref;
      if (inEditron == null) {
        inEditron = false;
      }
      if (screenshotMode == null) {
        screenshotMode = false;
      }
      if (inEditron) {
        return this.MIN_NUM_COLS;
      }
      if ((this.dash != null) && this.dash.is_fluid) {
        if (screenshotMode || App.SetUpScreenshotMode.inScreenshotMode()) {
          return this.getRightmostWidgetGridColumn(this.SCREENSHOT_MIN_COLS);
        }
        return this.TV_MODE_COLS;
      }
      if (((ref = this.dash) != null ? ref.num_columns : void 0) != null) {
        return this.dash.num_columns;
      } else {
        return this.MIN_NUM_COLS;
      }
    };

    DashboardSizer.prototype.minCols = function() {
      return this.MIN_NUM_COLS;
    };

    DashboardSizer.prototype.maxCols = function() {
      return this.MAX_NUM_COLS;
    };

    DashboardSizer.prototype.numColsForTVMode = function() {
      return this.TV_MODE_COLS;
    };

    DashboardSizer.prototype.maxRows = function() {
      return this.MAX_ROWS;
    };

    DashboardSizer.prototype.maxColumnWidth = function() {
      return this.MAX_COLUMN_WIDTH;
    };

    DashboardSizer.prototype.getRightmostWidgetGridColumn = function(minimumWidth) {
      var j, len, max, ref, widget;
      if (minimumWidth == null) {
        minimumWidth = this.MIN_NUM_COLS;
      }
      max = minimumWidth;
      ref = this.dash.widgets();
      for (j = 0, len = ref.length; j < len; j++) {
        widget = ref[j];
        if (max < widget.getColumn() + widget.getWidth()) {
          max = widget.getColumn() + widget.getWidth();
        }
      }
      return max;
    };

    DashboardSizer.prototype.columnWidth = function(inEditron) {
      var colWidth, ref;
      if (inEditron == null) {
        inEditron = false;
      }
      if (inEditron) {
        return this.MAX_COLUMN_WIDTH;
      }
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.SCREENSHOT_COLUMN_WIDTH;
      }
      if (this.dash == null) {
        return this.MAX_COLUMN_WIDTH;
      }
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        colWidth = Math.floor(Math.max(this.maxWidthForScreen(), this.minDashboardWidth()) / this.getRightmostWidgetGridColumn());
      } else {
        colWidth = Math.floor(this.maxWidthForScreen() / this.numCols());
      }
      if (colWidth > this.MAX_COLUMN_WIDTH) {
        return this.MAX_COLUMN_WIDTH;
      } else if (colWidth < this.MIN_COLUMN_WIDTH) {
        return this.MIN_COLUMN_WIDTH;
      } else {
        return colWidth;
      }
    };

    DashboardSizer.prototype.rowHeight = function(inEditron) {
      return this.columnWidth(inEditron);
    };

    DashboardSizer.prototype.widthForScreen = function() {
      var dashboardContainerWidth, ref, snappedDashboardContainerWidth;
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        dashboardContainerWidth = App.DashboardSizer.screenSize() - this.screenMargin() * 2 - this.SCROLLBAR_WIDTH;
        if (App.SetUpScreenshotMode.inScreenshotMode()) {
          return this.columnWidth() * this.numCols();
        }
        if (this.columnWidth() < this.MAX_COLUMN_WIDTH) {
          return Math.max(this.columnWidth() * this.getRightmostWidgetGridColumn(), this.minDashboardWidth());
        } else if (dashboardContainerWidth < this.maxDashboardWidth()) {
          snappedDashboardContainerWidth = dashboardContainerWidth - (dashboardContainerWidth % this.MAX_COLUMN_WIDTH);
          return Math.max(snappedDashboardContainerWidth, this.minDashboardWidth());
        }
      }
      return this.columnWidth() * this.numCols();
    };

    DashboardSizer.prototype.marginForScreen = function() {
      var ref;
      if (App.SetUpScreenshotMode.inScreenshotMode()) {
        return this.SCREENSHOT_MARGIN;
      }
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        return Math.max((App.DashboardSizer.screenSize() - this.SCROLLBAR_WIDTH - this.widthForScreen()) / 2, 0);
      }
      return Math.max((App.DashboardSizer.screenSize() - this.widthForScreen()) / 2, 0);
    };

    DashboardSizer.prototype.maxWidthForScreen = function() {
      var ref;
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        return App.DashboardSizer.screenSize() - this.screenMargin() * 2 - this.SCROLLBAR_WIDTH;
      } else {
        return App.DashboardSizer.screenSize() - this.screenMargin() * 2;
      }
    };

    DashboardSizer.maybeBindResize = function() {
      if (DashboardSizer._boundResize == null) {
        return $(window).on('resize', this.clearCachedSizes).DashboardSizer_boundResize = true;
      }
    };

    DashboardSizer.clearCachedSizes = function() {
      return delete DashboardSizer._width;
    };

    DashboardSizer.screenSize = function() {
      if (DashboardSizer._width == null) {
        this.maybeBindResize();
        DashboardSizer._width = $("body").width();
      }
      return DashboardSizer._width;
    };

    DashboardSizer.prototype.screenMargin = function() {
      var ref;
      if (((ref = AppRedesign.current()) != null ? ref.embed_mode : void 0) === 'v2') {
        return 0;
      } else {
        return this.DEFAULT_SCREEN_MARGIN;
      }
    };

    DashboardSizer.prototype.sharedDashboardHeaderWidth = function() {
      return this.widthForScreen() + this.SHARED_DASHBOARD_HEADER_LOGO_PADDING;
    };

    DashboardSizer.prototype.centerElementForDashboard = function(el) {
      return el.css({
        width: (this.widthForScreen()) + "px",
        marginLeft: (this.marginForScreen()) + "px"
      });
    };

    DashboardSizer.prototype.centerHeaderForDashboard = function(el) {
      var ref;
      if (((ref = this.dash) != null ? ref.is_fluid : void 0) || this.numCols() === this.numColsForTVMode()) {
        return this.centerElementForDashboard(el);
      } else {
        return el.css({
          width: (this.widthForScreen() + SITE_MENU_WIDTH) + "px",
          marginLeft: (Math.max(0, this.marginForScreen() - SITE_MENU_WIDTH)) + "px"
        });
      }
    };

    DashboardSizer.prototype.view = function(name) {
      return JST["app/views/" + name];
    };

    DashboardSizer.prototype.buildEditorGrid = function(gridBoundaryEl) {
      var i, j;
      gridBoundaryEl.append(this.view('dashboards/grid_columns')());
      for (i = j = 0; j < 3; i = ++j) {
        gridBoundaryEl.append(this.view('dashboards/grid_row')({
          row: i
        }));
      }
      gridBoundaryEl.find(".grid-row").last().addClass("last");
      return this.layoutGrid(gridBoundaryEl);
    };

    DashboardSizer.prototype.resizeGrid = function(gridBoundaryEl) {
      gridBoundaryEl.css("background-size", (this.columnWidth() * 10) + "px " + (this.columnWidth() * 10) + "px");
      return gridBoundaryEl.css("background-position", (this.columnWidth() * 4.5) + "px " + (this.columnWidth() * 4.5) + "px");
    };

    DashboardSizer.prototype.layoutGrid = function(gridBoundaryEl) {
      var columnWidth, cornersList, el, inEditron, j, k, len, numColumns, numRows, pos, ref, ref1, ref2, ref3, rowHeight;
      this.resizeGrid(gridBoundaryEl);
      inEditron = App.DashboardSizer.inEditron(gridBoundaryEl);
      rowHeight = this.rowHeight(inEditron);
      if ((ref = this.dash) != null ? ref.is_fluid : void 0) {
        if ((ref1 = AppRedesign.current()) != null ? ref1.embed_mode : void 0) {
          numRows = (ref2 = this.dash) != null ? ref2.nextFreeRow() : void 0;
        } else if (inEditron) {
          numRows = this.EDITOR_MAX_ROWS;
        } else {
          numRows = Math.max(((ref3 = this.dash) != null ? ref3.nextFreeRow() : void 0) + this.DEFAULT_ROW_BUFFER, this.DEFAULT_ROWS);
        }
        return gridBoundaryEl.height(numRows * rowHeight);
      } else {
        columnWidth = this.columnWidth(inEditron);
        cornersList = [];
        numColumns = this.numCols(inEditron);
        for (pos = j = 0; j <= 9; pos = ++j) {
          cornersList.push(gridBoundaryEl.find(".corner-cover[position=" + pos + "], .grid-column-dividers[position=" + pos + "]"));
        }
        for (pos = k = 0, len = cornersList.length; k < len; pos = ++k) {
          el = cornersList[pos];
          if (pos > numColumns) {
            el.hide();
          } else {
            el.css({
              left: columnWidth * pos
            });
          }
        }
        return gridBoundaryEl.find('.grid-row:not(.last)').height(rowHeight - 1);
      }
    };

    DashboardSizer.prototype.getWidgetPositionOnDashboard = function(widget) {
      var newGridHeight, newGridWidth, newHeight, newLeft, newTop, newWidth;
      newGridWidth = newGridHeight = this.columnWidth();
      newWidth = newGridWidth * widget.getWidth() - 1;
      newHeight = newGridHeight * widget.getHeight() - 1;
      newTop = newGridHeight * widget.getRow();
      newLeft = newGridWidth * widget.getColumn();
      return [newWidth, newHeight, newTop, newLeft];
    };

    DashboardSizer.prototype.setWidgetDashboardPosition = function(widgetEl, widget, assumeInDashboard) {
      var newHeight, newLeft, newTop, newWidth, ref;
      if (assumeInDashboard == null) {
        assumeInDashboard = false;
      }
      if (!widget) {
        return;
      }
      ref = App.DashboardSizer.inLinkedWidgetArea(widgetEl) && !App.SetUpScreenshotMode.inScreenshotMode() ? this.widgetPositionLinkedMode(widgetEl, widget) : this.widgetPositionNormalMode(widgetEl, widget, assumeInDashboard), newWidth = ref[0], newHeight = ref[1], newTop = ref[2], newLeft = ref[3];
      widgetEl.css({
        width: newWidth,
        height: newHeight,
        top: newTop,
        left: newLeft
      });
      return [newWidth, newHeight];
    };

    DashboardSizer.prototype.sizeBigNumberOverlays = function(bigNumParent, widget) {
      var _, height, ref, ref1, ref2, width;
      if (widget == null) {
        widget = null;
      }
      bigNumParent.find('.bignumber-overlay').css({
        fontSize: (this.bigNumberFontSize()) + "px"
      });
      bigNumParent.find('.latest-value').css({
        marginBottom: (this.bigNumMarginBottom()) + "px"
      });
      if ((widget != null) && ((ref = this.dash) != null ? ref.is_fluid : void 0) && this.BUFFER_WIDTH && this.OVERLAY_TOP_RATIO) {
        if (AppRedesign.isLinkedWidgetMode()) {
          ref1 = this.widgetPositionLinkedMode(), width = ref1[0], height = ref1[1], _ = ref1[2], _ = ref1[3];
        } else {
          ref2 = this.widgetPositionNormalMode(bigNumParent, widget), width = ref2[0], height = ref2[1], _ = ref2[2], _ = ref2[3];
        }
        bigNumParent.find('.bignumber-content').width(width - this.BUFFER_WIDTH * 2);
        return bigNumParent.find('.bignumber-content').height(height * (1 - this.OVERLAY_TOP_RATIO) - this.BUFFER_WIDTH);
      }
    };

    DashboardSizer.prototype.bigNumberFontSize = function() {
      return this.BIGNUM_FONT_SIZE * (this.columnWidth() / this.MAX_COLUMN_WIDTH);
    };

    DashboardSizer.prototype.bigNumMarginBottom = function() {
      return this.BIGNUM_VALUE_MARGIN * (this.columnWidth() / this.MAX_COLUMN_WIDTH);
    };

    DashboardSizer.prototype.widgetPositionNormalMode = function(widgetEl, widget, assumeInDashboard) {
      var newGridHeight, newGridLeft, newGridTop, newGridWidth, newHeight, newLeft, newTop, newWidth, ref;
      if (assumeInDashboard == null) {
        assumeInDashboard = false;
      }
      ref = assumeInDashboard || App.DashboardSizer.inDashboard(widgetEl) ? this.widgetGridPositionDashboard(widgetEl, widget) : App.DashboardSizer.inEditron(widgetEl) ? this.widgetGridPositionEditron(widgetEl, widget) : this.widgetGridPositionDashboard(widgetEl, widget), newGridWidth = ref[0], newGridHeight = ref[1], newGridTop = ref[2], newGridLeft = ref[3];
      newWidth = newGridWidth * widget.getWidth() - 1;
      newHeight = newGridHeight * widget.getHeight() - 1;
      newTop = newGridTop * widget.getRow();
      newLeft = newGridLeft * widget.getColumn();
      return [newWidth, newHeight, newTop, newLeft];
    };

    DashboardSizer.prototype.widgetGridPositionDashboard = function(widgetEl, widget) {
      var colW, rowH;
      colW = this.columnWidth();
      rowH = this.rowHeight();
      return [colW, rowH, colW, rowH];
    };

    DashboardSizer.prototype.widgetGridPositionEditron = function(widgetEl, widget) {
      return [this.MAX_COLUMN_WIDTH, this.MAX_ROW_HEIGHT, 0, 0];
    };

    DashboardSizer.prototype.widgetPositionLinkedMode = function(widgetEl, widget) {
      var newHeight, newLeft, newTop, newWidth;
      newWidth = this.MAX_COLUMN_WIDTH * this.LINKED_MODE_NUM_COLS;
      newHeight = this.MAX_ROW_HEIGHT * this.LINKED_MODE_NUM_ROWS;
      newTop = 100;
      newLeft = 0;
      return [newWidth, newHeight, newTop, newLeft];
    };

    DashboardSizer.inDashboard = function(el) {
      return AppRedesign.current().getCurrentState() === AppRedesign.IN_DASH || this.inEl(el, ".dashboard-container");
    };

    DashboardSizer.inEditron = function(el) {
      var ref;
      return ((ref = AppRedesign.current()) != null ? ref.getCurrentState() : void 0) === AppRedesign.IN_EDITRON && this.inEl(el, ".editron, .editron-mk3");
    };

    DashboardSizer.inLinkedWidgetArea = function(el) {
      return this.inEl(el, '.linked-widget');
    };

    DashboardSizer.inDataTab = function(el) {
      return this.inEl(el, '.in-data-tab');
    };

    DashboardSizer.inEl = function(el, search) {
      return el.closest(search).length !== 0;
    };

    DashboardSizer.useDarkTheme = function(el) {
      return this.inEditron(el) || $('.app-frame').hasClass('tvmode') || App.RedesignDashboardSizer.isTvMode();
    };

    DashboardSizer.prototype.dashboardSizeForWidget = function(widget) {
      return [this.columnWidth() * widget.getWidth() - 1, this.rowHeight() * widget.getHeight() - 1];
    };

    DashboardSizer.prototype.editorSizeforWidget = function(widget) {
      return [this.MAX_COLUMN_WIDTH * Math.min(widget.getWidth(), this.EDITOR_MAX_COLUMNS) - 1, this.MAX_ROW_HEIGHT * Math.min(widget.getHeight(), this.EDITOR_MAX_ROWS) - 1];
    };

    DashboardSizer.prototype.gridSizeForWidget = function(widgetEl, widget) {
      if (App.DashboardSizer.inDashboard(widgetEl)) {
        return [this.columnWidth(), this.rowHeight()];
      } else {
        return [this.MAX_COLUMN_WIDTH, this.MAX_ROW_HEIGHT];
      }
    };

    DashboardSizer.prototype.isWide = function(width) {
      var widthInCols;
      widthInCols = Math.round(width / this.columnWidth());
      return widthInCols > this.LIMIT_TO_BE_CONSIDERED_WIDE;
    };

    DashboardSizer.prototype.getScreenshotPadding = function() {
      return this.DASHBOARD_HEADER_EMAIL_HEIGHT + this.PAGE_HEADER_HEIGHT + this.EMAIL_PAGE_PADDING;
    };

    DashboardSizer.prototype.getDashboardEmailMargin = function() {
      return 2 * this.SCREENSHOT_MARGIN;
    };

    return DashboardSizer;

  })();

}).call(this);
(function() {
  App.DatabaseSqlFunctions = (function() {
    function DatabaseSqlFunctions() {}

    DatabaseSqlFunctions.FUNCTIONS = {
      bigquery: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the non-null rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        date: [
          {
            args: "timestamp",
            doc: "Truncates a timestamp column to a date.",
            example: "date(purchase_date)"
          }
        ],
        date_add: [
          {
            args: "timestamp, interval, interval_units",
            doc: "Increments a timestamp value by a specified interval.",
            example: "date_add(created_at, 5, \"DAY\") "
          }
        ],
        datediff: [
          {
            args: "timestamp1, timestamp2",
            doc: "Returns the number of days between two timestamp data types",
            example: "datediff(created_at, close_date) "
          }
        ],
        exact_count_distinct: [
          {
            args: "expression",
            doc: "Returns the exact number of non-null, distinct values for the specified field.",
            example: "exact_count_distinct(user_id)"
          }
        ],
        "if": [
          {
            args: "condition, true_expression, false_expression",
            doc: "Returns one value if a condition is true, or another value if a condition is false.",
            example: "if(1<2, 'yes', 'no')"
          }
        ],
        integer: [
          {
            args: "expression",
            doc: "Casts the expression to a 64-bit integer.",
            example: "integer(phone_number)"
          }
        ],
        lower: [
          {
            args: "string",
            doc: "Returns the original string with all characters in lower case.",
            example: "lower(name)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the highest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the lowest numeric value in a set of rows.",
            example: "min(price)"
          }, {
            args: "string",
            doc: "Returns the first string of an alphanumericaly ordered rows.",
            example: "min(first_name)"
          }, {
            args: "date",
            doc: "Returns the first date in a set of rows.",
            example: "min(login_date)"
          }
        ],
        round: [
          {
            args: "numeric, decimal_places",
            doc: "Rounds numbers to the nearest integer or decimal.",
            example: "round(price, 2)"
          }
        ],
        string: [
          {
            args: "numeric",
            doc: "Returns numeric expression as a string.",
            example: "string(zip_code)"
          }
        ],
        substr: [
          {
            args: "string, start_position, num_characters",
            doc: "Returns the characters extracted from from the state position for a specified number of characters.",
            example: "substr(web_url, 5, 15)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression's values.",
            example: "sum(price)"
          }
        ],
        timestamp: [
          {
            args: "date",
            doc: "Converts a date string to a timestamp data type.",
            example: "timestamp(created_date)"
          }
        ]
      },
      bigquery_standard: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        coalesce: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        concat: [
          {
            args: "string1, string2",
            doc: "Concatenates two character strings and returns the resulting string.",
            example: "concat('hello', 'world')"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        date: [
          {
            args: "timestamp",
            doc: "Truncates a timestamp column to a date.",
            example: "date(purchase_date)"
          }
        ],
        date_add: [
          {
            args: "timestamp, interval, interval_units",
            doc: "Increments a timestamp value by a specified interval.",
            example: "date_add(created_at, 5, \"day\") "
          }
        ],
        datediff: [
          {
            args: "timestamp1, timestamp2",
            doc: "Returns the number of days between two timestamp data types.",
            example: "datediff(created_at, close_date) "
          }
        ],
        extract: [
          {
            args: "datepart from timestamp",
            doc: "Returns a date part (day, month, year, etc.) from a timestamp or date.",
            example: "extract(year from purchase_date)"
          }
        ],
        lower: [
          {
            args: "string",
            doc: "Returns the original string with all characters in lower case.",
            example: "lower(name)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the highest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        round: [
          {
            args: "numeric, decimal_places",
            doc: "Rounds numbers to the nearest integer or decimal.",
            example: "round(price, 2)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression values.",
            example: "sum(price)"
          }
        ],
        timestamp_milli: [
          {
            args: "int64_expression",
            doc: "Interprets int64_expression as the number of milliseconds since 1970-01-01 00:00:00 UTC.",
            example: "timestamp_millis(created_at)"
          }
        ],
        to_timestamp: [
          {
            args: "timestamp, format",
            doc: "Converts a timestamp string to timestampz.",
            example: "to_timestamp('1991-09-01 17:25', 'YYYY-MM-DD HH24:MI')"
          }
        ]
      },
      mysql: {
        coalesce: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        concat: [
          {
            args: "string1, string2",
            doc: "Concatenates two strings and returns the resulting string.",
            example: "concat('hello', 'world')"
          }
        ],
        convert_tz: [
          {
            args: "source, target, timestamp",
            doc: "Converts a timestamp from one time zone to another.",
            example: "convert_tz(created_at, 'US/Eastern', 'US/Central')"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        curdate: [
          {
            args: null,
            doc: "Returns the current date.",
            example: null
          }
        ],
        date: [
          {
            args: "timestamp",
            doc: "Truncates a timestamp column to a date.",
            example: "date(purchase_date)"
          }
        ],
        date_add: [
          {
            args: "timestamp, interval",
            doc: "Increments a timestamp value by a specified interval.",
            example: "date_add(start_time, interval 60 day)"
          }
        ],
        date_sub: [
          {
            args: "date, interval",
            doc: "Subtracts a time value (or an interval) from a date or datetime value.",
            example: "date_sub(start_date, interval 1 day)"
          }
        ],
        format: [
          {
            args: "number, decimal_places",
            doc: "Formats the number as a format of \"#,###.##\", rounded to the specificied decimal places.",
            example: "format(250500.5634, 2)"
          }
        ],
        from_unixtime: [
          {
            args: "unix_timestamp",
            doc: "Returns a representation of the unix_timestamp argument as a value in date format.",
            example: "from_unixtime(unix_timestamp)"
          }
        ],
        hour: [
          {
            args: "timestamp",
            doc: "Returns the hour value of a timestamp.",
            example: "hour(start_time)"
          }
        ],
        "if": [
          {
            args: "condition, value_if_true, value_if_false",
            doc: "Returns one value if the condition is true, or another value if the condition is false.",
            example: "if(1<2, 'yes', 'no')"
          }
        ],
        ifnull: [
          {
            args: "expression, alt_value",
            doc: "Returns an alternative value if an expression is null. ",
            example: "ifnull(null, 0)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the greatest numeric value in a set of rows.",
            example: "max(price)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the least numeric value in a set of rows.",
            example: "min(price)"
          }
        ],
        now: [
          {
            args: null,
            doc: "Returns the current date and time in the current session's time zone.",
            example: null
          }
        ],
        round: [
          {
            args: "numeric, decimal places",
            doc: "Rounds numbers to the nearest integer or decimal.",
            example: "round(price, 2)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression values.",
            example: "sum(price)"
          }
        ],
        time: [
          {
            args: "datetime",
            doc: "Extracts the time value from a time expression.",
            example: "time(created_at)"
          }
        ],
        timestampdiff: [
          {
            args: "datepart, datetime1, datetime2",
            doc: "Subtracts an interval from a datetime expression.",
            example: "timestampdiff(day, created_at, close_date)"
          }
        ],
        year: [
          {
            args: "datetime",
            doc: "Extracts the year from a date expression. ",
            example: "year(created_at)"
          }
        ]
      },
      postgres: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        coalesce: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        concat: [
          {
            args: "string1, string2",
            doc: "Concatenates two strings and returns the resulting string.",
            example: "concat('hello', 'world')"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the non-null rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        date: [
          {
            args: "timestamp",
            doc: "Truncates a timestamp column to a date.",
            example: "date(purchase_date)"
          }
        ],
        date_part: [
          {
            args: "datepart, timestamp",
            doc: "Extracts datepart values from an expression.",
            example: "date_part('hour', timestamp '2015-12-14 9:02:45')"
          }
        ],
        date_trunc: [
          {
            args: "datepart, timestamp",
            doc: "Truncates a timestamp expression based on the date part that you specify.",
            example: "date_trunc('month', sale_date)"
          }
        ],
        extract: [
          {
            args: "datepart from timestamp",
            doc: "Returns a date part (day, month, year, etc.) from a timestamp or date.",
            example: "extract(year from purchase_date)"
          }
        ],
        greatest: [
          {
            args: "numeric1, numeric2",
            doc: "Returns the largest from a list of numeric expressions.",
            example: "greatest(unit_price, discounted_price)"
          }, {
            args: "timestamp1, timestamp2",
            doc: "Returns the largest from a list of date or timestamp expressions.",
            example: "greatest(created_at, updated_at)"
          }
        ],
        least: [
          {
            args: "numeric1, numeric2",
            doc: "Returns the smallest from a list of numeric expressions.",
            example: "least(unit_price, discounted_price)"
          }, {
            args: "timestamp1, timestamp2",
            doc: "Returns the smallest from a list of date or timestamp expressions.",
            example: "least(created_at, updated_at)"
          }
        ],
        left: [
          {
            args: "string, integer ",
            doc: "Return the specified number of leftmost characters of a string.",
            example: "left(phone_number, 3)"
          }
        ],
        length: [
          {
            args: "string",
            doc: "Return the number of characters in string.",
            example: "length(first_name)"
          }
        ],
        lower: [
          {
            args: "string",
            doc: "Converts a string to lowercase.",
            example: "lower(first_name)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the highest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the least numeric value in a set of rows.",
            example: "min(price)"
          }, {
            args: "string",
            doc: "Returns the first string of an alphanumericaly ordered rows.",
            example: "min(first_name)"
          }, {
            args: "date",
            doc: "Returns the earliest date in a set of rows.",
            example: "min(login_date)"
          }
        ],
        now: [
          {
            args: null,
            doc: "Returns the current date and time in the current session's time zone.",
            example: null
          }
        ],
        nullif: [
          {
            args: "expression1, expression2 ",
            doc: "Returns null if the arguments are equal.",
            example: "nullif(total_revenue,0)"
          }
        ],
        replace: [
          {
            args: "string, old_chars, new_chars",
            doc: "Replaces all occurrences of a set of characters within a string with other characters.",
            example: "replace(file_path, '-', '_')"
          }
        ],
        right: [
          {
            args: "string, integer ",
            doc: "Return the specified number of rightmost characters of a string.",
            example: "right(ticket_number, 4)"
          }
        ],
        round: [
          {
            args: "integer, decimal_places",
            doc: "Rounds numbers to the nearest decimal.",
            example: "round(price, 2)"
          }
        ],
        split_part: [
          {
            args: "string, delimiter, part",
            doc: "Splits a string on the specified delimiter and returns the part at the specified position.",
            example: "split_part(purchase_date, '-', 1)"
          }
        ],
        substring: [
          {
            args: "string, start_position, num_characters",
            doc: "Returns the characters extracted from from the state position for a specified number of characters.",
            example: "substring(web_url, 5, 15)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression's values.",
            example: "sum(price)"
          }
        ],
        to_timestamp: [
          {
            args: "timestamp, format",
            doc: "Converts a timestamp string to timestamptz.",
            example: "to_timestamp('2015-12-14 9:02', 'YYYY-MM-DD HH24:MI')"
          }
        ],
        trim: [
          {
            args: "string",
            doc: "Trims a string by removing leading and trailing blanks.",
            example: "trim(description)"
          }, {
            args: "characters from string",
            doc: "Trims a string by removing characters that match a specified string.",
            example: "trim('-' from description)"
          }
        ],
        upper: [
          {
            args: "string",
            doc: "Converts a string to uppercase.",
            example: "upper(state)"
          }
        ]
      },
      redshift: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression's values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        coalesce: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        concat: [
          {
            args: "string1, string2",
            doc: "Concatenates two character strings and returns the resulting string.",
            example: "concat('hello', 'world')"
          }
        ],
        convert_timezone: [
          {
            args: "source, target, timestamp",
            doc: "Converts a time stamp from one time zone to another.",
            example: "convert_timezone('America/Los_Angeles', 'America/New_York', '2013-04-05 14:00:00')"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts rows where the expression is non-null.",
            example: "count(customer_id)"
          }
        ],
        date: [
          {
            args: "timestamp",
            doc: "Truncates a timestamp value to a date.",
            example: "date(purchase_date)"
          }
        ],
        date_part: [
          {
            args: "datepart, timestamp",
            doc: "Extracts datepart values from an expression.",
            example: "date_part('dow', starttime)"
          }
        ],
        date_trunc: [
          {
            args: "datepart, timestamp",
            doc: "Truncates a time stamp expression based on the date part that you specify.",
            example: "date_trunc('month', sale_date)"
          }
        ],
        dateadd: [
          {
            args: "datepart, interval, timestamp",
            doc: "Increments a timestamp value by a specified interval.",
            example: "dateadd('seconds', 60, start_time)"
          }, {
            args: "datepart, interval, date",
            doc: "Increments a date value by a specified interval.",
            example: "dateadd('days', 7, purchase_date)"
          }
        ],
        datediff: [
          {
            args: "datepart, timestamp, timestamp",
            doc: "Returns the difference between the date parts of two date or time values.",
            example: "datediff('hours', start_time, end_time)"
          }
        ],
        extract: [
          {
            args: "datepart from timestamp",
            doc: "Returns a date part (day, month, year, etc.) from a timestamp or date.",
            example: "extract(year from purchase_date)"
          }
        ],
        getdate: [
          {
            args: null,
            doc: "Returns the current date and time in the current session's time zone.",
            example: null
          }
        ],
        greatest: [
          {
            args: "numeric1, numeric2",
            doc: "Returns the largest from a list of numeric expressions.",
            example: "greatest(unit_price, discounted_price)"
          }, {
            args: "timestamp1, timestamp2",
            doc: "Returns the largest from a list of date or timestamp expressions.",
            example: "greatest(created_at, updated_at)"
          }
        ],
        least: [
          {
            args: "numeric1, numeric2",
            doc: "Returns the smallest from a list of numeric expressions.",
            example: "least(unit_price, discounted_price)"
          }, {
            args: "timestamp1, timestamp2",
            doc: "Returns the smallest from a list of date or timestamp expressions.",
            example: "least(created_at, updated_at)"
          }
        ],
        left: [
          {
            args: "string, integer ",
            doc: "Return the specified number of leftmost characters of a string.",
            example: "left(phone_number, 3)"
          }
        ],
        len: [
          {
            args: "string",
            doc: "Return the number of characters in string.",
            example: "len(first_name)"
          }
        ],
        lower: [
          {
            args: "string",
            doc: "Converts a string to lowercase.",
            example: "lower(first_name)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the greatest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the least numeric value in a set of rows.",
            example: "min(price)"
          }, {
            args: "string",
            doc: "Returns the first string of an alphanumericaly ordered rows.",
            example: "min(first_name)"
          }, {
            args: "date",
            doc: "Returns the earliest date in a set of rows.",
            example: "min(login_date)"
          }
        ],
        nullif: [
          {
            args: "expression1, expression2 ",
            doc: "Returns null if the arguments are equal.",
            example: "nullif(total_revenue,0)"
          }
        ],
        nvl: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "nvl(end_date, start_date)"
          }
        ],
        replace: [
          {
            args: "string, old_chars, new_chars",
            doc: "Replaces all occurrences of a set of characters within a string with other characters.",
            example: "replace(file_path, '-', '_')"
          }
        ],
        right: [
          {
            args: "string, integer ",
            doc: "Return the specified number of rightmost characters of a string.",
            example: "right(ticket_number, 4)"
          }
        ],
        round: [
          {
            args: "numeric",
            doc: "Rounds numbers to the nearest integer.",
            example: "round(price)"
          }, {
            args: "numeric, decimal_places",
            doc: "Rounds numbers to the decimal.",
            example: "round(price, 2)"
          }, {
            args: "numeric",
            doc: "Rounds numbers to the nearest integer.",
            example: "round(price)"
          }
        ],
        split_part: [
          {
            args: "string, delimiter, part",
            doc: "Splits a string on the specified delimiter and returns the part at the specified position.",
            example: "split_part(purchase_date, '-', 1)"
          }
        ],
        substring: [
          {
            args: "string, start_position, number_of_characters",
            doc: "Returns the characters extracted from from the state position for a specified number of characters.",
            example: "substring(web_url, 5, 15)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression.",
            example: "sum(price)"
          }
        ],
        to_timestamp: [
          {
            args: "timestamp, format",
            doc: "Converts a timestamp string to TIMESTAMPTZ.",
            example: "to_timestamp('2015-12-14 9:02', 'YYYY-MM-DD HH24:MI')"
          }
        ],
        trim: [
          {
            args: "string",
            doc: "Trims a string by removing leading and trailing blanks.",
            example: "trim(description)"
          }, {
            args: "characters from string",
            doc: "Trims a string by removing characters that match a specified string.",
            example: "trim('-' from description)"
          }
        ],
        trunc: [
          {
            args: "numeric, decimal_places",
            doc: "Truncates a number and right-fills it with zeros from the position specified.",
            example: "trunc(commission, 2)"
          }
        ],
        upper: [
          {
            args: "string",
            doc: "Converts a string to uppercase.",
            example: "upper(state)"
          }
        ]
      },
      snowflake: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        coalesce: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        convert_timezone: [
          {
            args: "source, target, timestamp",
            doc: "Converts a time stamp from one time zone to another.",
            example: "convert_timezone('America/Los_Angeles', 'America/New_York', '2013-04-05 14:00:00')"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the non-null rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        date_part: [
          {
            args: "datepart, timestamp",
            doc: "Extracts datepart values from an expression.",
            example: "date_part('dow', starttime)"
          }
        ],
        date_trunc: [
          {
            args: "datepart, timestamp",
            doc: "Truncates a time stamp expression based on the date part that you specify.",
            example: "date_trunc('month', sale_date)"
          }
        ],
        dateadd: [
          {
            args: "datepart, interval, timestamp",
            doc: "Increments a timestamp value by a specified interval.",
            example: "dateadd('seconds', 60, start_time)"
          }, {
            args: "datepart, interval, date",
            doc: "Increments a date value by a specified interval.",
            example: "dateadd('days', 7, purchase_date)"
          }
        ],
        datediff: [
          {
            args: "datepart, timestamp, timestamp",
            doc: "Returns the difference between the date parts of two date or time values.",
            example: "datediff('hours', start_time, end_time)"
          }
        ],
        dayofweek: [
          {
            args: "timestamp",
            doc: "Returns the day (number) of the week.",
            example: "dayofweek(created_at)"
          }
        ],
        dayofyear: [
          {
            args: "timestamp",
            doc: "Returns the day (number) of the year.",
            example: "dayofyear(created_at)"
          }
        ],
        extract: [
          {
            args: "datepart from timestamp",
            doc: "Returns a date part (day, month, year, etc.) from a timestamp or date.",
            example: "extract(year from purchase_date)"
          }
        ],
        ifnull: [
          {
            args: "expression, alt_value",
            doc: "Returns an alternative value if an expression is null.",
            example: "ifnull(NULL,0)"
          }
        ],
        listagg: [
          {
            args: "expression, delimiter",
            doc: "Returns the concatenated input values, separated by the delimiter string",
            example: "listagg(user_name, ', ')"
          }
        ],
        lower: [
          {
            args: "string",
            doc: "Converts a string to lowercase.",
            example: "lower(first_name)"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the highest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        median: [
          {
            args: "numeric",
            doc: "Returns the median of a set of values.",
            example: "median(price)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the lowest numeric value in a set of rows.",
            example: "min(price)"
          }, {
            args: "string",
            doc: "Returns the first string of an alphanumericaly ordered rows.",
            example: "min(first_name)"
          }, {
            args: "date",
            doc: "Returns the first date in a set of rows.",
            example: "min(login_date)"
          }
        ],
        month: [
          {
            args: "timestamp",
            doc: "Returns the month (number) of the year.",
            example: "month(created_at)"
          }
        ],
        nullif: [
          {
            args: "expression1, expression2 ",
            doc: "Returns null if the arguments are equal.",
            example: "nullif(total_revenue, 0)"
          }
        ],
        nvl: [
          {
            args: "expression, expression",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "nvl(end_date, start_date)"
          }
        ],
        quarter: [
          {
            args: "timestamp",
            doc: "Returns the quarter (number) of the year.",
            example: "quarter(created_at)"
          }
        ],
        round: [
          {
            args: "numeric, decimal places",
            doc: "Rounds numbers to the nearest integer or decimal.",
            example: "round(price, 2)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression values.",
            example: "sum(price)"
          }
        ],
        timeadd: [
          {
            args: "datepart, timestamp",
            doc: "Adds the specified date or time part to a date, time, or timestamp.",
            example: "timeadd('seconds', login_time)"
          }
        ],
        to_date: [
          {
            args: "date",
            doc: "Converts a string value to a date.",
            example: "to_date('2015.12.14')"
          }, {
            args: "date, date format",
            doc: "Converts a string value with a defined date format into a date.",
            example: "to_date('2015.12.14', 'YYYY.MM.DD')"
          }
        ],
        week: [
          {
            args: "timestamp",
            doc: "Returns the week (number) of the year.",
            example: "week(created_at)"
          }
        ],
        weekofyear: [
          {
            args: "timestamp",
            doc: "Returns the week (number) of the year.",
            example: "weekofyear(created_at)"
          }
        ],
        yearofweek: [
          {
            args: "timestamp",
            doc: "Returns the year that the extracted week belongs to.",
            example: "yearofweek(created_at)"
          }
        ]
      },
      sql_server: {
        avg: [
          {
            args: "numeric",
            doc: "Returns the average of the input expression values.",
            example: "avg(price)"
          }
        ],
        cast: [
          {
            args: "expression as datatype",
            doc: "Returns the data type specified by the type argument.",
            example: "cast(cost as numeric)"
          }
        ],
        coalesce: [
          {
            args: "expression, expression, ...",
            doc: "Returns the value of the first expression in the list that is not null.",
            example: "coalesce(end_date, start_date)"
          }
        ],
        count: [
          {
            args: "expression",
            doc: "Counts the rows defined by the expression.",
            example: "count(customer_id)"
          }
        ],
        dateadd: [
          {
            args: "interval, number, date",
            doc: "Returns a date after a certain time/date interval has been added.",
            example: "dateadd(year, 1, created_at)"
          }
        ],
        datediff: [
          {
            args: "datepart, timestamp, timestamp",
            doc: "Returns the difference between the date parts of two date or time values.",
            example: "datediff('hours', start_time, end_time)"
          }
        ],
        datepart: [
          {
            args: "interval, date",
            doc: "Returns a specified part of a given date, as an integer value.",
            example: "datepart(year, created_at)"
          }
        ],
        getdate: [
          {
            args: null,
            doc: "Returns a date after a certain time/date interval has been added.",
            example: null
          }
        ],
        "if": [
          {
            args: "condition, value_if_true, value_if_false",
            doc: "Returns one value if a condition is true, or another value if a condition is false.",
            example: "if(1<2, 'yes', 'no')"
          }
        ],
        isnull: [
          {
            args: "expression, alt_value",
            doc: "Return an alternative value when an expression is null.",
            example: "isnull(close_date, 'active')"
          }
        ],
        max: [
          {
            args: "numeric",
            doc: "Returns the highest numeric value in a set of rows.",
            example: "max(price)"
          }, {
            args: "string",
            doc: "Returns the last string of an alphanumerically ordered rows.",
            example: "max(first_name)"
          }, {
            args: "date",
            doc: "Returns the latest date in a set of rows.",
            example: "max(login_date)"
          }
        ],
        min: [
          {
            args: "numeric",
            doc: "Returns the lowest numeric value in a set of rows.",
            example: "min(price)"
          }, {
            args: "string",
            doc: "Returns the first string of an alphanumericaly ordered rows.",
            example: "min(first_name)"
          }, {
            args: "date",
            doc: "Returns the first date in a set of rows.",
            example: "min(login_date)"
          }
        ],
        month: [
          {
            args: "datetime",
            doc: "Returns the month (from 1 to 12) for a given date. ",
            example: "month(created_at)"
          }
        ],
        nullif: [
          {
            args: "expression1, expression2 ",
            doc: "Returns null if the arguments are equal.",
            example: "nullif(total_revenue, 0)"
          }
        ],
        round: [
          {
            args: "numeric, decimal places",
            doc: "Rounds numbers to the nearest integer or decimal.",
            example: "round(price, 2)"
          }
        ],
        sum: [
          {
            args: "numeric",
            doc: "Returns the sum of the input column or expression values.",
            example: "sum(price)"
          }
        ],
        year: [
          {
            args: "datetime",
            doc: "Extracts the year from a date expression. ",
            example: "year(created_at)"
          }
        ]
      }
    };

    DatabaseSqlFunctions.getNames = function(databaseType) {
      return Object.keys(this.FUNCTIONS[databaseType] || {});
    };

    DatabaseSqlFunctions.getDetails = function(databaseType, functionName) {
      var ref;
      return (ref = this.FUNCTIONS[databaseType]) != null ? ref[functionName] : void 0;
    };

    return DatabaseSqlFunctions;

  })();

}).call(this);
(function() {
  App.DefaultTwiddleGenerator = (function() {
    function DefaultTwiddleGenerator() {}

    DefaultTwiddleGenerator.call = function(actual_twiddles, chart_type) {
      if (!actual_twiddles) {
        return {};
      } else if (_.isEmpty(actual_twiddles)) {
        return this.forChartType(chart_type);
      } else {
        return actual_twiddles;
      }
    };

    DefaultTwiddleGenerator.forChartType = function(chart_type) {
      var default_twiddles;
      default_twiddles = {
        continuous_x_axis: true,
        dragDrop: {},
        series: {},
        twiddle_legend_position: 'right',
        twiddle_use_pivot_settings: false,
        use_default_chart_type: false
      };
      if (chart_type === 'table') {
        delete default_twiddles['twiddle_use_pivot_settings'];
        default_twiddles['use_default_chart_type'] = true;
      } else if (chart_type === 'geomap' || chart_type === 'bubble') {
        default_twiddles['twiddle_point_cols'] = [];
      }
      return default_twiddles;
    };

    return DefaultTwiddleGenerator;

  })();

}).call(this);
(function() {
  App.DimensionAvailability = (function() {
    function DimensionAvailability() {}

    DimensionAvailability.AVAILABILITY_CHANGED = 'dimension-availability-changed';

    DimensionAvailability.consolidateEvents = function() {
      App.Dashboard.bind('update', this.triggerUpdate);
      App.CustomDimension.bind('create update destroy', this.triggerUpdate);
      return App.Site.bind('all-updates', this.handleAllUpdatesEvent);
    };

    DimensionAvailability.handleAllUpdatesEvent = function(updatesByDash) {
      var _, updatedDashboards, updates;
      updatedDashboards = false;
      for (_ in updatesByDash) {
        updates = updatesByDash[_];
        if (updates.dashboard != null) {
          updatedDashboards = true;
          break;
        }
      }
      if (updatedDashboards) {
        return DimensionAvailability.triggerUpdate();
      }
    };

    DimensionAvailability.stopConsolidatingEvents = function() {
      App.Dashboard.unbind('update', this.triggerUpdate);
      App.CustomDimension.unbind('create update destroy', this.triggerUpdate);
      return App.Site.unbind('all-updates', this.triggerUpdate);
    };

    DimensionAvailability.triggerUpdate = function() {
      return App.Dashboard.trigger(DimensionAvailability.AVAILABILITY_CHANGED);
    };

    DimensionAvailability.availableForSharedDashboard = function(sharedDashboard) {
      var available, cd, existingDim, i, len, ref;
      available = {};
      ref = sharedDashboard.unlocked_filters || [];
      for (i = 0, len = ref.length; i < len; i++) {
        cd = ref[i];
        existingDim = this.dimensionExists(cd);
        if (existingDim) {
          available[existingDim.cid] = true;
        }
      }
      return available;
    };

    DimensionAvailability.availableForDashboard = function(dashboard) {
      var available, cd, dimension, existingDim, i, j, k, len, len1, len2, ref, ref1, ref2;
      available = {};
      ref = App.CustomDimension.BUILTIN_DIMENSIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        dimension = ref[i];
        available[dimension] = true;
      }
      ref1 = App.CustomDimension.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        cd = ref1[j];
        available[cd.cid] = cd.available_by_default;
      }
      ref2 = dashboard.dimension_availability || [];
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        cd = ref2[k];
        existingDim = this.dimensionExists(cd.custom_dimension_id);
        if (existingDim) {
          available[existingDim.cid] = cd.available;
        }
      }
      return available;
    };

    DimensionAvailability.availableForDashboardById = function(dashboard) {
      var available, cd, dimension, exists, i, id, j, k, len, len1, len2, ref, ref1, ref2;
      available = {};
      ref = App.CustomDimension.BUILTIN_DIMENSIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        dimension = ref[i];
        available[dimension] = true;
      }
      ref1 = App.CustomDimension.all();
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        cd = ref1[j];
        available[cd.id] = cd.available_by_default;
      }
      ref2 = dashboard.dimension_availability || [];
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        cd = ref2[k];
        available[cd.custom_dimension_id] = cd.available;
      }
      return (function() {
        var results;
        results = [];
        for (id in available) {
          exists = available[id];
          if (exists) {
            results.push(id);
          }
        }
        return results;
      })();
    };

    DimensionAvailability.setForDashboard = function(dashboard, custom_dimension_id, available, tryCount) {
      var availability, cd, cd_id, i, len, ref;
      if (tryCount == null) {
        tryCount = 0;
      }
      if (App.Utils.isClientId(custom_dimension_id)) {
        cd = App.CustomDimension.exists(custom_dimension_id);
        if (!(cd && tryCount < 10)) {
          return;
        }
        cd_id = cd.id;
        setTimeout(((function(_this) {
          return function() {
            return _this.setForDashboard(dashboard, cd_id, available, tryCount + 1);
          };
        })(this)), 500);
        return;
      }
      availability = [];
      ref = dashboard.dimension_availability || [];
      for (i = 0, len = ref.length; i < len; i++) {
        cd = ref[i];
        if (cd.custom_dimension_id !== custom_dimension_id && this.dimensionExists(cd.custom_dimension_id)) {
          availability.push(cd);
        }
      }
      availability.push({
        custom_dimension_id: custom_dimension_id,
        available: available
      });
      dashboard.dimension_availability = availability;
      dashboard.save();
      cd = App.CustomDimension.exists(custom_dimension_id);
      if (available && cd) {
        return cd.fetchHashKey();
      }
    };

    DimensionAvailability.setDimensionOrderForDashboard = function(dashboard) {
      var availableDims, cd, cid, dimensionOrder, i, isVisible, len, ref;
      availableDims = App.DimensionAvailability.availableForDashboard(dashboard);
      dimensionOrder = [];
      ref = dashboard.allDimensionCidsInOrder();
      for (i = 0, len = ref.length; i < len; i++) {
        cid = ref[i];
        cd = App.DimensionAvailability.dimensionExists(cid);
        if (!cd) {
          continue;
        }
        isVisible = availableDims[cd.cid];
        if (isVisible) {
          dimensionOrder.push(cd.id);
        }
      }
      dashboard.dimension_order = dimensionOrder;
      return dashboard.save({
        ajax: false
      });
    };

    DimensionAvailability.dimensionExists = function(cd_id) {
      if (App.CustomDimension.BUILTIN_DIMENSIONS.indexOf(cd_id) !== -1) {
        if (cd_id === 'aggregation') {
          return {
            name: 'Aggregation',
            cid: App.CustomDimension.AGGREGATION,
            id: cd_id
          };
        }
        if (cd_id === 'date_range') {
          return {
            name: 'Date Range',
            cid: App.CustomDimension.DATE_RANGE,
            id: cd_id
          };
        }
      }
      return App.CustomDimension.exists(cd_id);
    };

    return DimensionAvailability;

  })();

}).call(this);
(function() {
  App.DimensionConfig = (function() {
    DimensionConfig.DIMENSION_ID_INDEX = 0;

    DimensionConfig.DIMENSION_VALUE_ID_INDEX = 1;

    DimensionConfig.GROUP_INDEX = 3;

    DimensionConfig.SIGNATURE_INDEX = 4;

    function DimensionConfig() {
      this.clear();
    }

    DimensionConfig.prototype.initializeFrom = function(dashboard) {
      var ref, udv;
      udv = dashboard.userDataView();
      this.custom_dimensions_list = jQuery.extend(true, [], udv.custom_dimensions_list) || [];
      this.default_dimensions_list = (dashboard != null ? (ref = dashboard.filters()) != null ? ref.custom_dimensions_list : void 0 : void 0) || [];
      this.dashboard = dashboard;
      return this.sync_version = udv.sync_version;
    };

    DimensionConfig.prototype.setFromDashDefaults = function(dashboard) {
      var ref, ref1, sd;
      sd = App.SharedDashboard.currentSharedDashboard();
      this.dashboard = dashboard;
      this.sync_version = (ref = dashboard.getExistingUserDataView()) != null ? ref.sync_version : void 0;
      if (sd != null) {
        return this.custom_dimensions_list = jQuery.extend(true, [], sd.custom_dimensions_list) || [];
      } else {
        this.custom_dimensions_list = jQuery.extend(true, [], dashboard.filters().custom_dimensions_list) || [];
        return this.default_dimensions_list = (dashboard != null ? (ref1 = dashboard.filters()) != null ? ref1.custom_dimensions_list : void 0 : void 0) || [];
      }
    };

    DimensionConfig.prototype.clear = function() {
      this.custom_dimensions_list = [];
      return this.cleanupAndSave();
    };

    DimensionConfig.prototype.isEmpty = function() {
      return (this.dashboard != null) && this.canonicalizedDimensions().length === 0;
    };

    DimensionConfig.prototype.addDimensionInfo = function(dimensionId, dimensionValueId, label, group, signature) {
      if (this.has(dimensionId, dimensionValueId)) {
        return false;
      }
      if (group == null) {
        group = null;
      }
      this.custom_dimensions_list || (this.custom_dimensions_list = []);
      this.custom_dimensions_list.push([dimensionId, dimensionValueId, label, group, signature]);
      this.cleanupAndSave();
      return true;
    };

    DimensionConfig.prototype.removeDimensionInfo = function(dimensionId, dimensionValueId) {
      if (!this.has(dimensionId, dimensionValueId)) {
        return false;
      }
      this.custom_dimensions_list = this.filterDimensionValueFromCustomDimensionList(dimensionId, dimensionValueId);
      this.cleanupAndSave();
      return true;
    };

    DimensionConfig.prototype.filterDimensionInfoByGroup = function(dimensionId, validGroups) {
      var info;
      if (!(validGroups != null)) {
        return false;
      }
      this.custom_dimensions_list = (function() {
        var i, len, ref, results1;
        ref = this.custom_dimensions_list;
        results1 = [];
        for (i = 0, len = ref.length; i < len; i++) {
          info = ref[i];
          if ((info[0] !== dimensionId) || validGroups.indexOf(info[3]) >= 0) {
            results1.push(info);
          }
        }
        return results1;
      }).call(this);
      this.cleanupAndSave();
      return true;
    };

    DimensionConfig.prototype.setSingleInfoForDimension = function(dimensionId, dimensionValueId, label, group, signature) {
      if (this.hasOnly(dimensionId, dimensionValueId)) {
        return false;
      }
      if (group == null) {
        group = null;
      }
      this.custom_dimensions_list || (this.custom_dimensions_list = []);
      this.custom_dimensions_list = this.filterDimensionIdFromCustomDimensionList(dimensionId);
      this.custom_dimensions_list.push([dimensionId, dimensionValueId, label, group, signature]);
      this.cleanupAndSave();
      return true;
    };

    DimensionConfig.enforceExclusiveConstraints = function(config) {
      var custom_dimension, dimension, exclusive_ids, i, len, new_cdl, ref;
      if (!((config != null) && (config.custom_dimensions_list != null))) {
        return null;
      }
      exclusive_ids = [];
      new_cdl = [];
      ref = config.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        custom_dimension = ref[i];
        if (custom_dimension.length < 3 || exclusive_ids.includes(custom_dimension[0])) {
          continue;
        }
        dimension = App.CustomDimension.exists(custom_dimension[0]);
        new_cdl.push(custom_dimension);
        if (dimension !== false && dimension.exclusive === true) {
          exclusive_ids.push(custom_dimension[0]);
        }
      }
      config.custom_dimensions_list = new_cdl;
      return config;
    };

    DimensionConfig.prototype.canonicalizedDimensions = function(useDefaults) {
      var agg, dateRange, dim, dimName, dimensionId, i, info, infos, j, len, len1, name, ref, ref1, ref2, results, sd, selectedDimIds;
      if (useDefaults == null) {
        useDefaults = false;
      }
      results = [];
      selectedDimIds = this.dimensionIds(useDefaults);
      if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode) {
        sd = App.SharedDashboard.currentSharedDashboard();
        if (sd != null) {
          selectedDimIds = App.Utils.intersect(selectedDimIds, sd.unlocked_filters || []);
        } else {
          selectedDimIds = [];
        }
      }
      ref = App.DimensionConfig.dimensionsSortedByName(selectedDimIds);
      for (i = 0, len = ref.length; i < len; i++) {
        dimensionId = ref[i];
        infos = [].concat(this.configuredDimensionInfos(dimensionId));
        infos.sort(function(a, b) {
          return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
        });
        for (j = 0, len1 = infos.length; j < len1; j++) {
          info = infos[j];
          dim = App.CustomDimension.exists(dimensionId);
          dimName = (dim != null ? dim.name : void 0) || '';
          name = this.dimensionDisplayName(info, dimName);
          results.push({
            dimension: dimName,
            name: name,
            id: dimensionId,
            value: info.id
          });
        }
      }
      if (useDefaults) {
        agg = this.dashboard.defaultAggregationSetting();
        dateRange = this.dashboard.defaultDateRangeSetting();
      } else {
        agg = this.dashboard.aggregationSetting();
        dateRange = this.dashboard.dateRangeSetting();
      }
      if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode && (sd != null)) {
        if (!((ref1 = sd.unlocked_filters) != null ? ref1.includes(App.CustomDimension.AGGREGATION) : void 0)) {
          agg = null;
        }
        if (!((ref2 = sd.unlocked_filters) != null ? ref2.includes(App.CustomDimension.DATE_RANGE) : void 0)) {
          dateRange = null;
        }
      }
      if (agg != null) {
        results.push({
          dimension: 'Aggregation',
          name: App.RedesignDashboardSettingsController.labelForOptionValue(agg, App.AggregationDimensionSetting.AGGREGATION_OPTIONS),
          id: App.CustomDimension.AGGREGATION,
          value: null
        });
      }
      if ((dateRange != null) && dateRange !== App.RedesignDateRangeDimensionSetting.DEFAULT_DATE_RANGE_VALUE && Object.keys(dateRange).length > 0) {
        results.push({
          dimension: 'DateRange',
          name: App.RedesignDateRangeDimensionSetting.labelForDateRangeFilters(dateRange),
          id: App.CustomDimension.DATE_RANGE,
          value: null
        });
      }
      return results;
    };

    DimensionConfig.prototype.canonicalizedDimensionMap = function(useDefaults) {
      var agg, dateRange, dim, dimName, dimensionId, i, info, infos, j, len, len1, name, ref, ref1, results, sd, selectedDimIds;
      if (useDefaults == null) {
        useDefaults = false;
      }
      results = {};
      selectedDimIds = this.dimensionIds(useDefaults);
      if (AppRedesign.current().pdf_mode) {
        selectedDimIds = this.dimensionIds(useDefaults);
      } else if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode) {
        sd = App.SharedDashboard.currentSharedDashboard();
        if (sd != null) {
          selectedDimIds = App.Utils.intersect(selectedDimIds, sd.unlocked_filters || []);
        } else {
          selectedDimIds = [];
        }
      }
      for (i = 0, len = selectedDimIds.length; i < len; i++) {
        dimensionId = selectedDimIds[i];
        results[dimensionId] || (results[dimensionId] = []);
        infos = useDefaults ? _.clone(this.configuredDefaultDimensionInfos(dimensionId)) : _.clone(this.configuredDimensionInfos(dimensionId));
        infos.sort(function(a, b) {
          return (a.name || '').localeCompare(b.name || '', {}, {
            sensitivity: 'accent'
          });
        });
        dim = App.CustomDimension.exists(dimensionId);
        dimName = (dim != null ? dim.name : void 0) || '';
        for (j = 0, len1 = infos.length; j < len1; j++) {
          info = infos[j];
          name = this.dimensionDisplayName(info, dimName);
          results[dimensionId].push({
            dimension: dimName,
            name: name,
            value: info.id
          });
        }
      }
      agg = this.dashboard.aggregationSetting();
      dateRange = this.dashboard.dateRangeSetting();
      if (useDefaults) {
        agg = this.dashboard.defaultAggregationSetting();
        dateRange = this.dashboard.defaultDateRangeSetting();
      } else if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode && (sd != null)) {
        if (!((ref = sd.unlocked_filters) != null ? ref.includes(App.CustomDimension.AGGREGATION) : void 0)) {
          agg = null;
        }
        if (!((ref1 = sd.unlocked_filters) != null ? ref1.includes(App.CustomDimension.DATE_RANGE) : void 0)) {
          dateRange = null;
        }
      }
      if (agg != null) {
        results[App.CustomDimension.AGGREGATION] = [
          {
            dimension: 'Aggregation',
            name: App.RedesignDashboardSettingsController.labelForOptionValue(agg, App.AggregationDimensionSetting.AGGREGATION_OPTIONS),
            value: null
          }
        ];
      }
      if ((dateRange != null) && dateRange !== App.RedesignDateRangeDimensionSetting.DEFAULT_DATE_RANGE_VALUE && Object.keys(dateRange).length > 0) {
        results[App.CustomDimension.DATE_RANGE] = [
          {
            dimension: 'DateRange',
            name: App.RedesignDateRangeDimensionSetting.labelForDateRangeFilters(dateRange),
            value: null
          }
        ];
      }
      return results;
    };

    DimensionConfig.prototype.dimensionDisplayName = function(info, dimName) {
      if (!info.name) {
        return dimName + " (blank)";
      } else if (typeof info.name === 'object') {
        return App.RedesignDateRangeDimensionSetting.labelForDateRangeFilters(info.name);
      } else {
        return info.name;
      }
    };

    DimensionConfig.dimensionsSortedByName = function(dimensions) {
      var dimension, dimensionId, i, len, nameMap;
      nameMap = {};
      for (i = 0, len = dimensions.length; i < len; i++) {
        dimensionId = dimensions[i];
        dimension = App.CustomDimension.exists(dimensionId);
        if (dimension) {
          nameMap[dimensionId] = dimension.name.toLowerCase();
        } else {
          nameMap[dimensionId] = '';
        }
      }
      dimensions.sort(function(a, b) {
        return nameMap[a].localeCompare(nameMap[b]);
      });
      return dimensions;
    };

    DimensionConfig.prototype.cleanupAndSave = function() {
      var ref;
      this.filterOrphans();
      if ((ref = this.dashboard) != null) {
        ref.save({
          ajax: false
        });
      }
      return this.triggerChanged();
    };

    DimensionConfig.prototype.customDimensionsClone = function() {
      if (this.custom_dimensions_list == null) {
        return null;
      }
      return this.custom_dimensions_list.slice(0);
    };

    DimensionConfig.prototype.dimensionIds = function(useDefaults) {
      var dimension_list;
      if (useDefaults == null) {
        useDefaults = false;
      }
      dimension_list = useDefaults ? this.default_dimensions_list || [] : this.custom_dimensions_list;
      return dimension_list.map(function(cd) {
        return "" + cd[0];
      }).unique();
    };

    DimensionConfig.prototype.dimensionValues = function(dimensionId) {
      return this.custom_dimensions_list.filter(function(cd) {
        return cd[0] === dimensionId;
      }).map(function(cd) {
        return cd[1];
      });
    };

    DimensionConfig.prototype.triggerChanged = function() {
      var ref;
      return (ref = this.dashboard) != null ? ref.trigger(App.Dashboard.EVENT_CONFIG_CHANGED) : void 0;
    };

    DimensionConfig.prototype.filterDimensionIdFromCustomDimensionList = function(dimensionId) {
      var i, info, len, ref, results1;
      ref = this.custom_dimensions_list;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        info = ref[i];
        if (parseInt(info[0]) !== parseInt(dimensionId)) {
          results1.push(info);
        }
      }
      return results1;
    };

    DimensionConfig.prototype.filterDimensionValueFromCustomDimensionList = function(dimensionId, dimensionValue) {
      var i, info, len, ref, results1;
      ref = this.custom_dimensions_list;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        info = ref[i];
        if (!(parseInt(info[0]) === parseInt(dimensionId) && "" + info[1] === "" + dimensionValue)) {
          results1.push(info);
        }
      }
      return results1;
    };

    DimensionConfig.prototype.filterOrphans = function() {
      var dimGroup, dimModel, dimension, dimension_has_no_group, dimension_has_no_parent, i, j, len, len1, name1, new_dimensions, old_dimension_list_size, parentValues, parent_value_present, ref, ref1;
      parentValues = {};
      ref = this.custom_dimensions_list;
      for (i = 0, len = ref.length; i < len; i++) {
        dimension = ref[i];
        parentValues[name1 = dimension[0]] || (parentValues[name1] = []);
        parentValues[dimension[0]].push(dimension[1]);
      }
      new_dimensions = [];
      ref1 = this.custom_dimensions_list;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        dimension = ref1[j];
        dimModel = App.CustomDimension.exists(dimension[0]);
        dimGroup = dimension[this.constructor.GROUP_INDEX];
        if (!dimModel && (dimGroup != null)) {
          continue;
        }
        dimension_has_no_group = dimGroup == null;
        dimension_has_no_parent = dimModel.parent_id == null;
        parent_value_present = (parentValues[dimModel.parent_id] || []).indexOf(dimGroup) !== -1;
        if (dimension_has_no_group || dimension_has_no_parent || parent_value_present) {
          new_dimensions.push(dimension);
        }
      }
      old_dimension_list_size = this.custom_dimensions_list.length;
      this.custom_dimensions_list = new_dimensions;
      if (new_dimensions.length > 0 && new_dimensions.length !== old_dimension_list_size) {
        return this.filterOrphans();
      }
    };

    DimensionConfig.prototype.hasOnly = function(dimensionId, dimensionValueId) {
      return this.has(dimensionId, dimensionValueId) && this.dimensionValues(dimensionId).length === 1;
    };

    DimensionConfig.prototype.has = function(dimensionId, dimensionValueId) {
      return _.some(this.configuredDimensionInfos(dimensionId), function(info) {
        return _.toString(info.id) === _.toString(dimensionValueId);
      });
    };

    DimensionConfig.prototype.configuredDefaultDimensionInfos = function(dimensionId) {
      var info;
      if ((this.default_dimensions_list != null) && !this.default_dimensions_list.isEmpty()) {
        return (function() {
          var i, len, ref, results1;
          ref = this.default_dimensions_list;
          results1 = [];
          for (i = 0, len = ref.length; i < len; i++) {
            info = ref[i];
            if (parseInt(info[0]) === parseInt(dimensionId)) {
              results1.push({
                dimension: info[0],
                id: info[1],
                name: info[2]
              });
            }
          }
          return results1;
        }).call(this);
      }
      return [];
    };

    DimensionConfig.prototype.configuredDimensionInfos = function(dimensionId) {
      if (!((this.custom_dimensions_list != null) && !this.custom_dimensions_list.isEmpty())) {
        return [];
      }
      return _(this.custom_dimensions_list).filter(function(info) {
        return parseInt(info[0]) === parseInt(dimensionId);
      }).map(function(info) {
        return {
          dimension: info[0],
          id: info[1],
          name: info[2]
        };
      }).value();
    };

    DimensionConfig.prototype.configuredDimensionValues = function(dimensionId) {
      var info;
      if ((this.custom_dimensions_list != null) && !this.custom_dimensions_list.isEmpty()) {
        return (function() {
          var i, len, ref, results1;
          ref = this.custom_dimensions_list;
          results1 = [];
          for (i = 0, len = ref.length; i < len; i++) {
            info = ref[i];
            if (parseInt(info[0]) === parseInt(dimensionId)) {
              results1.push(info[1]);
            }
          }
          return results1;
        }).call(this);
      }
      return [];
    };

    DimensionConfig.prototype.customDimensionsFormattedForEmbedApi = function() {
      return _.map(this.custom_dimensions_list, (function(customDimension) {
        var filter_name, ref;
        filter_name = ((ref = App.CustomDimension.exists(customDimension[0])) != null ? ref.name : void 0) || '';
        if (customDimension.length < 3 || customDimension[3] === '') {
          return {
            name: filter_name,
            value: customDimension[1]
          };
        }
        return {
          name: filter_name,
          value: customDimension[1],
          group: customDimension[3]
        };
      }));
    };

    return DimensionConfig;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.DimensionValueFetcher = (function() {
    function DimensionValueFetcher(dimension) {
      this.dimension = dimension;
      this.completedFetch = bind(this.completedFetch, this);
    }

    DimensionValueFetcher.prototype.fetch = function(prefix, group, fetchCompleteCallback) {
      var cachedValue;
      group || (group = []);
      if (this.dimension.hasParent() && group.length === 0) {
        fetchCompleteCallback(prefix, []);
        return;
      }
      cachedValue = this.cacheGet(prefix, group);
      if (cachedValue) {
        fetchCompleteCallback(prefix, cachedValue);
        return;
      }
      return this.queryServer(prefix, group, fetchCompleteCallback);
    };

    DimensionValueFetcher.prototype.queryServer = function(prefix, group, fetchCompleteCallback) {
      if (App.CustomDimension.isCustomDimension(this.dimension)) {
        return this.dimension.getDimensionValues(prefix, group, (function(_this) {
          return function(response) {
            return _this.completedFetch(response, prefix, group, fetchCompleteCallback);
          };
        })(this));
      }
    };

    DimensionValueFetcher.prototype.completedFetch = function(response, prefix, group, fetchCompleteCallback) {
      var dimensionValues;
      dimensionValues = response;
      this.cacheResponse(prefix, dimensionValues, group);
      return fetchCompleteCallback(prefix, dimensionValues);
    };

    DimensionValueFetcher.prototype.cacheResponse = function(prefix, dimensionValues, group) {
      if (!((dimensionValues != null) && !dimensionValues.isEmpty())) {
        return;
      }
      return this.cacheSet(prefix, dimensionValues, group);
    };

    DimensionValueFetcher.prototype.cacheGet = function(prefix, groupNames) {
      return App.CustomDimension.cacheGet(this.dimension.id, prefix, groupNames);
    };

    DimensionValueFetcher.prototype.cacheSet = function(prefix, options, groupNames) {
      return App.CustomDimension.cacheSet(this.dimension, prefix, options, groupNames);
    };

    return DimensionValueFetcher;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.DimentorXClient = (function(superClass) {
    extend(DimentorXClient, superClass);

    DimentorXClient.include(Spine.Events);

    DimentorXClient.HOST = "dimentor-x.periscopedata.com";

    DimentorXClient.DEFAULT_SEARCH_LIMIT = 100;

    DimentorXClient.TOTAL_CHILD_LOAD_LIMIT = 1000;

    DimentorXClient.DEFAULT_CHUNK_SIZE = 25;

    DimentorXClient.prototype.release = function() {
      return this.unbind();
    };

    function DimentorXClient() {
      this.getSingleValueCallback = bind(this.getSingleValueCallback, this);
      this.valuesCallback = bind(this.valuesCallback, this);
      this.defaultValuesCallback = bind(this.defaultValuesCallback, this);
      this.dimentorFeSocketCall = bind(this.dimentorFeSocketCall, this);
      this.webSocketError = bind(this.webSocketError, this);
      this.webSocketDataMessage = bind(this.webSocketDataMessage, this);
      this.remoteNameFromValues = bind(this.remoteNameFromValues, this);
      this.remoteValues = bind(this.remoteValues, this);
      this.remoteDefaultValues = bind(this.remoteDefaultValues, this);
      this.initWebSocket();
    }

    DimentorXClient.prototype.initWebSocket = function() {
      var host, ref, ref1;
      host = DimentorXClient.HOST;
      return this.dimentorSocket = new $.JsonRpcClient({
        socketUrl: "wss://" + host + "/conn?uuid=" + ((ref = AppRedesign.current()) != null ? ref.uuid : void 0),
        onmessage: this.webSocketDataMessage,
        ajaxUrl: "https://" + host + "/http?uuid=" + ((ref1 = AppRedesign.current()) != null ? ref1.uuid : void 0),
        onerror: this.webSocketError,
        getSocket: (function() {
          return null;
        })
      });
    };

    DimentorXClient.prototype.remoteDefaultValues = function(customDimensionRecords, callback) {
      var customDimension, id, requests;
      requests = [];
      for (id in customDimensionRecords) {
        customDimension = customDimensionRecords[id];
        if (customDimension.hasDefault() && (customDimension.hash_key != null)) {
          requests.push({
            DimensionId: parseInt(id),
            HashKey: customDimension.hash_key,
            Prefix: "",
            Limit: parseInt(this.constructor.DEFAULT_SEARCH_LIMIT),
            GroupName: []
          });
        }
      }
      return this.chunkedRemoteDefaultValues(callback, requests);
    };

    DimentorXClient.prototype.remoteValues = function(customDimension, prefix, group, callback) {
      var limit, requests;
      if (group == null) {
        group = [];
      }
      if (!customDimension.hash_key) {
        AppRedesign.logToScalyr('IgnoredDimentorCallWithoutHashKey', {
          dimension_id: customDimension.id,
          call: 'remoteValues'
        });
        return;
      }
      requests = [];
      limit = this.constructor.DEFAULT_SEARCH_LIMIT;
      if ((customDimension.parent_id != null) && group.length === 0) {
        if (!((prefix != null) && prefix.length > 0)) {
          limit = this.constructor.TOTAL_CHILD_LOAD_LIMIT;
          prefix = "";
        }
      }
      requests.push({
        DimensionId: parseInt(customDimension.id),
        HashKey: customDimension.hash_key,
        Prefix: prefix,
        Limit: parseInt(limit),
        GroupName: group
      });
      return this.dimentorFeSocketCall('DimentorClientFe.ListAllValues', requests, ((function(_this) {
        return function(response) {
          return _this.valuesCallback(response, callback);
        };
      })(this)));
    };

    DimentorXClient.prototype.remoteNameFromValues = function(idValues, callback) {
      var customDimensionList, dim, dimensionId, hashKey, i, idValue, j, ref, request, results, valueId;
      if (!((idValues != null) && idValues.length)) {
        return callback({
          results: []
        });
      }
      customDimensionList = [];
      results = [];
      for (i = j = 0, ref = idValues.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        idValue = idValues[i];
        dimensionId = idValue['id'];
        valueId = idValue['value_id'];
        if (isNaN(parseInt(dimensionId))) {
          customDimensionList.push([dimensionId, valueId, valueId]);
          if (customDimensionList.length === idValues.length) {
            results.push(callback({
              results: customDimensionList
            }));
          } else {
            results.push(void 0);
          }
        } else {
          dim = App.CustomDimension.exists(dimensionId);
          hashKey = dim ? dim.hash_key : null;
          if (!dim.isFreeInput() && (hashKey == null)) {
            AppRedesign.logToScalyr('IgnoredDimentorCallWithoutHashKey', {
              dimension_id: dim.id,
              call: 'remoteNameFromValues'
            });
          }
          request = {
            DimensionId: dimensionId,
            HashKey: hashKey,
            ValueId: valueId
          };
          results.push(this.callScopedGetSingleValue(request, dimensionId, valueId, customDimensionList, idValues.length, callback));
        }
      }
      return results;
    };

    DimentorXClient.prototype.requestSignedDimension = function(dimensionId, valueId, udv, options) {
      var hashKey, ref, request;
      hashKey = (ref = App.CustomDimension.exists(dimensionId)) != null ? ref.hash_key : void 0;
      if (hashKey == null) {
        return App.UdvHelper.removeDeletedDimension(udv, dimensionId, valueId, options, App.UdvHelper.INVALID_UDV_DETAILS.HASH_KEY_MISSING);
      }
      request = {
        DimensionId: String(dimensionId),
        HashKey: hashKey,
        ValueId: String(valueId)
      };
      return this.dimentorFeSocketCall('DimentorClientFe.GetSingleValue', request, ((function(_this) {
        return function(response) {
          if (response == null) {
            return;
          }
          if (_.isEmpty(response.ID)) {
            return App.UdvHelper.removeDeletedDimension(udv, dimensionId, valueId, options);
          } else {
            return App.UdvHelper.signDimensionFromResponse(udv, dimensionId, response.ID, response.GroupName, response.Signature, options);
          }
        };
      })(this)));
    };

    DimentorXClient.prototype.chunkedRemoteDefaultValues = function(callback, requests) {
      var currentRequests, nextRequests, requestStartTimestamp;
      requestStartTimestamp = AppRedesign.timestamp();
      currentRequests = requests.slice(0, DimentorXClient.DEFAULT_CHUNK_SIZE);
      nextRequests = requests.slice(DimentorXClient.DEFAULT_CHUNK_SIZE);
      return this.dimentorFeSocketCall('DimentorClientFe.ListAllValues', currentRequests, ((function(_this) {
        return function(response) {
          _this.defaultValuesCallback(response, callback, requestStartTimestamp);
          if (nextRequests.length > 0) {
            return _this.chunkedRemoteDefaultValues(callback, nextRequests);
          }
        };
      })(this)));
    };

    DimentorXClient.prototype.callScopedGetSingleValue = function(request, dimensionId, valueId, customDimensionList, length, callback) {
      if (_.isEmpty(request.HashKey)) {
        return this.getSingleValueCallback(null, dimensionId, valueId, customDimensionList, length, callback);
      }
      return this.dimentorFeSocketCall('DimentorClientFe.GetSingleValue', request, ((function(_this) {
        return function(response) {
          return _this.getSingleValueCallback(response, dimensionId, valueId, customDimensionList, length, callback);
        };
      })(this)));
    };

    DimentorXClient.prototype.formatResponse = function(response) {
      var dimension, j, k, len, len1, ref, ref1, value, values;
      values = [];
      if ((response != null ? response.DimentorDimensions : void 0) == null) {
        return values;
      }
      ref = response.DimentorDimensions;
      for (j = 0, len = ref.length; j < len; j++) {
        dimension = ref[j];
        ref1 = dimension.Values;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          value = ref1[k];
          values.push({
            dimension_id: dimension.id,
            id: value['ID'],
            name: value['Name'],
            group: value['GroupName'],
            signature: value['Signature']
          });
        }
      }
      return values;
    };

    DimentorXClient.prototype.webSocketDataMessage = function(m) {
      var retObj;
      if (!m.data) {
        return;
      }
      retObj = JSON.parse(m.data);
      if (retObj.error) {
        return this.webSocketError(retObj.error);
      }
    };

    DimentorXClient.prototype.webSocketError = function(r) {
      var ref;
      try {
        if (r) {
          AppRedesign.logToScalyr("WebsocketFail", {
            ev: JSON.stringify(r),
            target: JSON.stringify(r.target),
            socketExists: this.dimentorSocket != null
          });
        }
        if ((ref = this.dimentorSocket) != null) {
          ref._wsSocket.close();
        }
      } catch (error) {
        false;
      }
      return delete this.dimentorSocket;
    };

    DimentorXClient.prototype.dimentorFeSocketCall = function(f, request, successCallback) {
      var requestId;
      if (DimentorXClient.authToken == null) {
        return;
      }
      if (!this.dimentorSocket) {
        this.initWebSocket();
      }
      requestId = App.Utils.S4() + App.Utils.S4();
      return this.dimentorSocket.call(f, [
        {
          Request: request,
          AuthToken: DimentorXClient.authToken,
          RequestId: requestId
        }
      ], successCallback, ((function(_this) {
        return function(r) {
          _this.webSocketError();
          return successCallback(null);
        };
      })(this)));
    };

    DimentorXClient.prototype.defaultValuesCallback = function(response, callback, requestStartTimestamp) {
      var elapsedTime, ref, values;
      elapsedTime = AppRedesign.timestamp() - requestStartTimestamp;
      AppRedesign.logToScalyr('DimentorDefaultValuesLoad', {
        elapsed: elapsedTime,
        request_id: response != null ? response.RequestId : void 0,
        start: new Date(requestStartTimestamp).toISOString(),
        null_response: response == null,
        dimensions_len: response != null ? (ref = response.DimentorDimensions) != null ? ref.length : void 0 : void 0
      });
      values = this.formatResponse(response);
      return callback(values);
    };

    DimentorXClient.prototype.valuesCallback = function(response, callback) {
      var values;
      values = this.formatResponse(response);
      return callback(values);
    };

    DimentorXClient.prototype.getSingleValueCallback = function(response, id, value_id, list, listLength, callback) {
      var filterName;
      if (response == null) {
        list.push([id, value_id, value_id]);
      } else {
        filterName = _.isEmpty(response.Name) ? value_id : response.Name;
        list.push([id, value_id, filterName, response.GroupName, response.Signature]);
      }
      if (list.length === listLength) {
        return callback({
          results: list
        });
      }
    };

    return DimentorXClient;

  })(Spine.Module);

  App.dimentorClient = function() {
    App.dimentorFeClient || (App.dimentorFeClient = new App.DimentorXClient());
    return App.dimentorFeClient;
  };

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  $.fn.extend({
    dropdownMenu: function(options) {
      if (options == null) {
        options = null;
      }
      return this.each(function(index, element) {
        var DropdownMenu, dMenu;
        DropdownMenu = (function() {
          DropdownMenu.S4 = function() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          };

          DropdownMenu.makeGuid = function() {
            return this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
          };

          DropdownMenu.MAX_HEIGHT = 400;

          DropdownMenu.DEFAULT_BUFFER = 60;

          function DropdownMenu(options1, element1) {
            var activeElement, i, item, itemEle, len, maxHeight, ref, ref1, ref2, screenMaxHeight, top;
            this.options = options1;
            this.element = element1;
            this.hoverSubItem = bind(this.hoverSubItem, this);
            this.hover = bind(this.hover, this);
            this.click = bind(this.click, this);
            if (this.options.items == null) {
              throw new Error("items must be defined");
            }
            if (this.options.callbackFunct == null) {
              throw new Error("callbackFunct must be defined");
            }
            this.errorText = this.options.errorText || "No options available.";
            this.dropdownClassId = DropdownMenu.makeGuid();
            this.dropdownElement = $("<div class='dropdownMenu " + this.dropdownClassId + "'></div>");
            this.dropdownSubMenuElement = $("<div class='dropdownMenu subMenu " + this.dropdownClassId + "'></div>").hide();
            this.dropdownSubSubMenuElement = $("<div class='dropdownMenu subSubMenu " + this.dropdownClassId + "'></div>").hide();
            if (this.options.width != null) {
              this.dropdownElement.width(this.options.width);
              this.dropdownSubMenuElement.width(this.options.width);
              this.dropdownSubSubMenuElement.width(this.options.width);
            }
            if (this.options.menuSortFunc != null) {
              this.options.items.sort(this.options.menuSortFunc);
            }
            if (this.options.items.length > 0) {
              ref = this.options.items;
              for (i = 0, len = ref.length; i < len; i++) {
                item = ref[i];
                itemEle = this.makeOptionElement(item);
                this.dropdownElement.append(itemEle);
                itemEle.on("mouseover", this.hover);
              }
            } else {
              this.dropdownElement.append(this.makeErrorElement());
            }
            this.dropdownElement.css({
              top: this.element.outerHeight(),
              left: 0
            });
            setTimeout(((function(_this) {
              return function() {
                return $("body").on("click", _this.click);
              };
            })(this)), 100);
            this.element.append(this.dropdownElement).append(this.dropdownSubMenuElement);
            this.element.append(this.dropdownElement).append(this.dropdownSubSubMenuElement);
            if (!this.options.noMaxHeight) {
              screenMaxHeight = window.innerHeight - this.element.position().top;
              maxHeight = _.min([screenMaxHeight, DropdownMenu.MAX_HEIGHT]);
              this.setMaxHeight(this.dropdownElement, maxHeight);
            }
            activeElement = this.dropdownElement.find(".item.checked");
            if ((activeElement != null) && (((ref1 = this.options) != null ? (ref2 = ref1.items) != null ? ref2.indexOf : void 0 : void 0) != null)) {
              this.activeIndex = this.options.items.indexOf(activeElement.data("dropdownValue"));
            }
            this.scrollToIndex(this.activeIndex, activeElement.height());
            top = activeElement.height() || 0;
            if (!AppRedesign.isRedesignMode()) {
              top -= 4;
            }
            this.dropdownElement.css({
              top: top
            });
          }

          DropdownMenu.prototype.destroy = function() {
            this.element.removeData("DropdownMenu");
            this.dropdownElement.remove();
            this.dropdownSubMenuElement.remove();
            this.dropdownSubSubMenuElement.remove();
            $("body").off("click", this.click);
            if (this.options.destroyCallbackFunct != null) {
              this.options.destroyCallbackFunct();
            }
            return null;
          };

          DropdownMenu.prototype.pickActiveOption = function(e) {
            e.stopPropagation();
            this.options.callbackFunct(this.element, this.options.items[this.activeIndex]);
            this.destroy();
            return null;
          };

          DropdownMenu.prototype.click = function(e) {
            var clickedOption, dropdownValue;
            clickedOption = $(e.target).closest(".item").data("dropdownValue");
            if ($(e.target).closest("." + this.dropdownClassId).length === 0) {
              this.destroy();
              return e.stopPropagation();
            } else {
              clickedOption = $(e.target).closest(".item");
              dropdownValue = clickedOption.data("dropdownValue");
              if (!(clickedOption.length === 0 || (dropdownValue != null) && ((dropdownValue.subItems != null) || dropdownValue.header))) {
                this.options.callbackFunct(this.element, clickedOption.data("dropdownValue"));
                this.destroy();
                return e.stopPropagation();
              }
            }
          };

          DropdownMenu.prototype.moveActiveIndexDown = function(e) {
            e.stopPropagation();
            this.activeIndex = (this.activeIndex + 1) % this.options.items.length;
            return this.highlightActiveItem();
          };

          DropdownMenu.prototype.moveActiveIndexUp = function(e) {
            e.stopPropagation();
            if (this.activeIndex !== -1) {
              this.activeIndex--;
            }
            if (this.activeIndex < 0) {
              this.activeIndex += this.options.items.length;
            }
            return this.highlightActiveItem();
          };

          DropdownMenu.prototype.scrollToIndex = function(index, height) {
            var scrollTo;
            if (index > 6) {
              scrollTo = (index - 6) * (height + 1);
            } else {
              scrollTo = 0;
            }
            this.dropdownElement.scrollTop(scrollTo);
            return scrollTo;
          };

          DropdownMenu.prototype.highlightActiveItem = function() {
            var activeEl, optionEls;
            optionEls = this.dropdownElement.find(".item");
            optionEls.removeClass("active");
            activeEl = $(optionEls[this.activeIndex]);
            activeEl.addClass("active");
            return this.scrollToIndex(this.activeIndex, activeEl.height());
          };

          DropdownMenu.prototype.hover = function(e, scroll) {
            var dValue, hoveredOption, oldActiveIndex;
            if ((this.noHover != null) && !scroll) {
              return;
            }
            hoveredOption = $(e.target).closest(".item");
            if (!hoveredOption.hasClass('active')) {
              this.dropdownElement.find(".active").removeClass("active");
              this.dropdownSubMenuElement.hide();
              this.dropdownSubSubMenuElement.hide();
              dValue = hoveredOption.data("dropdownValue");
              oldActiveIndex = this.activeIndex;
              this.activeIndex = this.options.items.indexOf(dValue);
              if (scroll) {
                if (this.activeIndex !== oldActiveIndex) {
                  this.highlightActiveItem();
                }
                this.noHover = true;
                if (this.reenableHover) {
                  clearTimeout(this.reenableHover);
                }
                this.reenableHover = setTimeout(((function(_this) {
                  return function() {
                    return _this.noHover = null;
                  };
                })(this)), AppRedesign.TYPE_TIMEOUT);
              } else {
                hoveredOption.addClass("active");
              }
              if ((dValue.subItems != null) && !hoveredOption.hasClass('disabled')) {
                return this.showSubMenu(hoveredOption, dValue.subItems);
              }
            }
          };

          DropdownMenu.prototype.hoverSubItem = function(e) {
            var dValue, hoveredOption;
            this.dropdownSubMenuElement.find(".active").removeClass("active");
            this.dropdownSubSubMenuElement.hide();
            hoveredOption = $(e.target).closest(".item");
            hoveredOption.addClass("active");
            dValue = hoveredOption.data("dropdownValue");
            if (dValue.subItems != null) {
              return this.showSubSubMenu(hoveredOption, dValue.subItems);
            }
          };

          DropdownMenu.prototype.showSubSubMenu = function(optionElement, items) {
            var i, item, itemEle, len;
            this.dropdownSubSubMenuElement.html('');
            for (i = 0, len = items.length; i < len; i++) {
              item = items[i];
              itemEle = this.makeOptionElement(item, false);
              this.dropdownSubSubMenuElement.append(itemEle);
            }
            this.positionSubMenuRelativeToParent(this.dropdownSubSubMenuElement, this.dropdownSubMenuElement, optionElement);
            this.dropdownSubSubMenuElement.show();
            this.scrollSubMenuToViewActiveItem(this.dropdownSubSubMenuElement);
            return this.setMaxHeight(this.dropdownSubSubMenuElement);
          };

          DropdownMenu.prototype.showSubMenu = function(optionElement, items) {
            var i, item, itemEle, len;
            this.dropdownSubMenuElement.html('');
            if (this.options.subMenuSortFunc != null) {
              items.sort(this.options.subMenuSortFunc);
            }
            for (i = 0, len = items.length; i < len; i++) {
              item = items[i];
              itemEle = this.makeOptionElement(item, false);
              itemEle.on("mouseover", this.hoverSubItem);
              this.dropdownSubMenuElement.append(itemEle);
            }
            this.positionSubMenuRelativeToParent(this.dropdownSubMenuElement, this.dropdownElement, optionElement);
            this.dropdownSubMenuElement.show();
            this.scrollSubMenuToViewActiveItem(this.dropdownSubSubMenuElement);
            return this.setMaxHeight(this.dropdownSubMenuElement);
          };

          DropdownMenu.prototype.scrollSubMenuToViewActiveItem = function(menuEl) {
            var activePosition, activeTop;
            activePosition = menuEl.find(".item.checked").position();
            activeTop = activePosition != null ? activePosition.top : 0;
            return menuEl.css("top", menuEl.position().top - activeTop);
          };

          DropdownMenu.prototype.positionSubMenuRelativeToParent = function(subMenu, parentMenu, optionElement) {
            var borderCollapingOffset, left, maxTop, normalTop, roomRight, subMenuWidth;
            subMenuWidth = subMenu.outerWidth();
            roomRight = $(window).width() - (parentMenu.offset().left + parentMenu.width() + subMenuWidth + DropdownMenu.DEFAULT_BUFFER);
            parentMenu.toggleClass('submenu-on-left', roomRight < 0);
            borderCollapingOffset = 1;
            if (roomRight < 0) {
              left = parentMenu.position().left - subMenuWidth + borderCollapingOffset;
            } else {
              left = parentMenu.position().left + parentMenu.outerWidth() - borderCollapingOffset;
            }
            normalTop = parentMenu.position().top + optionElement.position().top;
            maxTop = window.innerHeight - this.element.position().top - subMenu.height();
            return subMenu.css({
              top: _.min([normalTop, maxTop]),
              left: left
            });
          };

          DropdownMenu.prototype.setMaxHeight = function(menuElement, maxHeight) {
            menuElement.css("maxHeight", maxHeight || DropdownMenu.MAX_HEIGHT);
            return null;
          };

          DropdownMenu.prototype.makeOptionElement = function(item, showSubname) {
            var checkedPart, cssClassPart, expandoPart, headerPart, itemEle, spanEle;
            if (showSubname == null) {
              showSubname = true;
            }
            expandoPart = item.subItems != null ? "expando-arrow" : '';
            checkedPart = item.checked ? "checked" : "";
            headerPart = item.header ? 'item-header' : '';
            cssClassPart = item.cssClass != null ? item.cssClass : "";
            itemEle = $("<div class=\"item " + checkedPart + " " + expandoPart + " " + cssClassPart + " " + headerPart + "\">\n<div class=\"dlabel\"></div></div>");
            itemEle.find('.dlabel').text(item.name);
            if (showSubname) {
              spanEle = $('<div class="sub-name"></div>');
              spanEle.text(item.subName);
              itemEle.find('.dlabel').append(spanEle);
            }
            itemEle.data("dropdownValue", item);
            return itemEle;
          };

          DropdownMenu.prototype.makeErrorElement = function() {
            return $("<div class='error-item'>" + this.errorText + "</div>");
          };

          DropdownMenu.prototype.resetPosition = function() {
            this.dropdownElement.css({
              top: this.element.height()
            });
            return this.dropdownSubMenuElement.hide();
          };

          return DropdownMenu;

        })();
        element = $(element);
        if (options != null) {
          if (element.data("DropdownMenu") == null) {
            element.data("DropdownMenu", new DropdownMenu(options, element));
          }
          dMenu = element.data("DropdownMenu");
          if (typeof options === "string" && (dMenu != null)) {
            switch (options) {
              case "destroy":
                return dMenu.destroy();
              case "resetPosition":
                return dMenu.resetPosition();
            }
          }
        }
      });
    }
  });

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.ErrorMessageLineAnnotator = (function(superClass) {
    extend(ErrorMessageLineAnnotator, superClass);

    ErrorMessageLineAnnotator.call = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(this, args, function(){}).call();
    };

    function ErrorMessageLineAnnotator(originalSql, expandedSql, errorPositions, errorMessage, dbInfo) {
      this.originalSql = originalSql;
      this.expandedSql = expandedSql;
      this.errorPositions = errorPositions;
      this.errorMessage = errorMessage;
      this.dbInfo = dbInfo;
    }

    ErrorMessageLineAnnotator.prototype.call = function() {
      if (!this.errorIsPositional()) {
        return this.errorMessage;
      }
      if (this.errorPositionDifferentInOriginalVsExpandedSql()) {
        return this.newMessage().replace(/Expanded\:\s(\d+)/, "Expanded Line: " + (this.getExpandedLineNumber()) + " Position: " + (this.expandedLinePosition()));
      } else {
        return this.newMessage();
      }
    };

    ErrorMessageLineAnnotator.prototype.errorPositionDifferentInOriginalVsExpandedSql = function() {
      return this.errorMessage.match(/Expanded\:\s(\d+)/);
    };

    ErrorMessageLineAnnotator.prototype.newMessage = function() {
      if (this.dbInfo) {
        this.errorMessage = "Database: " + this.dbInfo.name + " (" + this.dbInfo.type + ") \n " + this.errorMessage;
      }
      if (this.errorMessage.match(/SQL compilation error:\nsyntax error line \d+ at position \d+/)) {
        return this.errorMessage.replace(/SQL compilation error:\nsyntax error line (\d+) at position (\d+)/, "syntax error at\nLine: " + (this.getOriginalLineNumber()) + " Position: " + (this.originalLinePosition()));
      } else {
        return this.errorMessage.replace(/Position\:\s(\d+)/, "Line: " + (this.getOriginalLineNumber()) + " Position: " + (this.originalLinePosition()));
      }
    };

    ErrorMessageLineAnnotator.prototype.errorIsPositional = function() {
      return this.errorPositions != null;
    };

    ErrorMessageLineAnnotator.prototype.originalPosition = function() {
      return this.errorPositions.first();
    };

    ErrorMessageLineAnnotator.prototype.expandedPosition = function() {
      return this.errorPositions.last();
    };

    ErrorMessageLineAnnotator.prototype.getOriginalLineNumber = function() {
      return this.originalLineNumber != null ? this.originalLineNumber : this.originalLineNumber = this.computeLineNumber(this.originalSql, this.originalPosition());
    };

    ErrorMessageLineAnnotator.prototype.getExpandedLineNumber = function() {
      return this.expandedLineNumber != null ? this.expandedLineNumber : this.expandedLineNumber = this.computeLineNumber(this.expandedSql, this.expandedPosition());
    };

    ErrorMessageLineAnnotator.prototype.originalLinePosition = function() {
      return this.computeLinePosition(this.originalSql, this.getOriginalLineNumber(), this.originalPosition());
    };

    ErrorMessageLineAnnotator.prototype.expandedLinePosition = function() {
      return this.computeLinePosition(this.expandedSql, this.getExpandedLineNumber(), this.expandedPosition());
    };

    ErrorMessageLineAnnotator.prototype.computeLineNumber = function(sql, position) {
      return (sql.substring(0, position).match(/\n/g) || []).length + 1;
    };

    ErrorMessageLineAnnotator.prototype.computeLinePosition = function(sql, lineNumber, fullSqlPosition) {
      var lengthOfLinesBeforeError;
      lengthOfLinesBeforeError = sql.split('\n', lineNumber - 1).join('\n').length;
      return fullSqlPosition - lengthOfLinesBeforeError;
    };

    return ErrorMessageLineAnnotator;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.EventHomogenizer = (function() {
    function EventHomogenizer() {
      this.flushEvents = bind(this.flushEvents, this);
      this.triggerAnnotationUpdate = bind(this.triggerAnnotationUpdate, this);
      this.triggerGroupChange = bind(this.triggerGroupChange, this);
      this.handleAllUpdates = bind(this.handleAllUpdates, this);
      this.pendingEvents = {};
      this.pendingEventArgs = {};
      this.homogenizeEverything();
      this.scheduledFlush = false;
    }

    EventHomogenizer.prototype.homogenizeEverything = function() {
      this.homogenizeGroupChange();
      return this.homogenizeAnnotationChange();
    };

    EventHomogenizer.prototype.homogenizeGroupChange = function() {
      var eventType, i, j, klass, len, len1, ref, ref1;
      ref = ['create', 'refresh', 'update', 'destroy'];
      for (i = 0, len = ref.length; i < len; i++) {
        eventType = ref[i];
        ref1 = ['Site', 'Dashboard', 'Group', 'GroupRole', 'GroupMembership', 'DashboardGroupPermission', 'DatabaseGroupPermission'];
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          klass = ref1[j];
          App[klass].bind(eventType, this.triggerGroupChange);
        }
      }
      return App.Site.bind('all-updates', this.handleAllUpdates);
    };

    EventHomogenizer.prototype.handleAllUpdates = function(updatesByDash) {
      var _, updates;
      for (_ in updatesByDash) {
        updates = updatesByDash[_];
        if (updates.dashboard != null) {
          this.aggregateTrigger('group-change');
          return;
        }
      }
    };

    EventHomogenizer.prototype.triggerGroupChange = function(evt) {
      return this.aggregateTrigger('group-change');
    };

    EventHomogenizer.prototype.homogenizeAnnotationChange = function() {
      var eventType, i, klass, len, ref, results;
      ref = ['create', 'refresh', 'update', 'destroy'];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        eventType = ref[i];
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = ['Annotation'];
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            klass = ref1[j];
            results1.push(App[klass].bind(eventType, this.triggerAnnotationUpdate));
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    EventHomogenizer.prototype.triggerAnnotationUpdate = function(anno) {
      return this.aggregateTrigger('annotation-change', anno.group_name);
    };

    EventHomogenizer.prototype.aggregateTrigger = function(eventType, args) {
      var base;
      if (args == null) {
        args = void 0;
      }
      this.pendingEvents[eventType] = true;
      if (args != null) {
        (base = this.pendingEventArgs)[eventType] || (base[eventType] = []);
        this.pendingEventArgs[eventType].push(args);
      }
      return this.scheduleEventFlush();
    };

    EventHomogenizer.prototype.scheduleEventFlush = function() {
      if (!this.scheduledFlush) {
        (typeof window.requestAnimationFrame === "function" ? window.requestAnimationFrame(this.flushEvents) : void 0) || setTimeout(this.flushEvents, 0);
        return this.scheduledFlush = true;
      }
    };

    EventHomogenizer.prototype.flushEvents = function() {
      var _, args, eventType, ref, ref1;
      ref = this.pendingEvents;
      for (eventType in ref) {
        _ = ref[eventType];
        args = (ref1 = this.pendingEventArgs[eventType]) != null ? ref1.unique() : void 0;
        App.Site.trigger(eventType, args);
        delete this.pendingEventArgs[eventType];
      }
      return this.scheduledFlush = false;
    };

    return EventHomogenizer;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.FeatureLogContext = (function() {
    FeatureLogContext.BLANK_VALUE = null;

    function FeatureLogContext() {
      this.setSessionIfBlank = bind(this.setSessionIfBlank, this);
      this.setSession = bind(this.setSession, this);
      this.clear = bind(this.clear, this);
      this.set = bind(this.set, this);
      this._context = App.FeatureLogContext.BLANK_VALUE;
    }

    FeatureLogContext.prototype.set = function(context) {
      return this._context = context;
    };

    FeatureLogContext.prototype.value = function() {
      return this._context;
    };

    FeatureLogContext.prototype.clear = function(context) {
      return this.set(App.FeatureLogContext.BLANK_VALUE);
    };

    FeatureLogContext.prototype.isBlank = function() {
      return this._context === App.FeatureLogContext.BLANK_VALUE;
    };

    FeatureLogContext.prototype.setSession = function(context) {
      return this.set(context + ':' + App.Utils.makeGuid());
    };

    FeatureLogContext.prototype.setSessionIfBlank = function(context) {
      if (this.isBlank()) {
        return this.setSession(context);
      }
    };

    return FeatureLogContext;

  })();

}).call(this);
(function() {
  var Features;

  Features = (function() {
    function Features() {}

    Features.enabled = function(feature) {
      var ref, ref1, ref2;
      return Boolean((ref = AppRedesign.current()) != null ? (ref1 = ref.state) != null ? (ref2 = ref1.features) != null ? ref2[feature] : void 0 : void 0 : void 0);
    };

    return Features;

  })();

  window.Features = Features;

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.FontLoadedChecker = (function() {
    FontLoadedChecker.SAMPLE_TEXT = 'abcdef %%%%';

    FontLoadedChecker.checkIfFirstTime = function() {
      if (this.hasStartedOnce != null) {
        return;
      }
      new App.FontLoadedChecker();
      return this.hasStartedOnce = true;
    };

    function FontLoadedChecker() {
      this.checkFontLoaded = bind(this.checkFontLoaded, this);
      this.counter = 50;
      this.checkFontLoaded();
      this.interval = setInterval(this.checkFontLoaded, 100);
    }

    FontLoadedChecker.prototype.checkFontLoaded = function() {
      var dashboard, width;
      if (AppRedesign.isRedesignMode()) {
        App.Utils.initRedesignCanvasWidthSizer(24);
        width = App.Utils.canvasWidthForText(this.constructor.SAMPLE_TEXT);
      } else {
        App.Utils.initCanvasWidthSizer(24);
        width = App.Utils.canvasWidthForText(this.constructor.SAMPLE_TEXT);
      }
      if (this.previousWidth == null) {
        this.previousWidth = width;
      }
      if (this.previousWidth !== width) {
        App.Utils.fastApproxWidthForTextCache = {};
        dashboard = App.Dashboard.currentDashboard();
        App.RouteHelper.navigateTo('Dashboard', dashboard, {
          force: true,
          replace: true
        });
      }
      this.previousWidth = width;
      if (--this.counter <= 0) {
        return clearInterval(this.interval);
      }
    };

    return FontLoadedChecker;

  })();

}).call(this);
(function() {
  App.Historian = (function() {
    var obj, obj1;

    Historian.HISTORIAN_MAP = (
      obj = {},
      obj["" + App.SqlAlert.className] = function() {
        return App.SqlAlertHistorian;
      },
      obj["" + App.SqlSnippet.className] = function() {
        return App.SqlSnippetHistorian;
      },
      obj["" + App.SqlView.className] = function() {
        return App.SqlViewHistorian;
      },
      obj["" + App.Widget.className] = function() {
        return App.WidgetHistorian;
      },
      obj
    );

    Historian.ARCHIVE_MAP = (
      obj1 = {},
      obj1["" + App.SqlAlert.className] = function() {
        return App.ArchivedSqlAlert;
      },
      obj1["" + App.SqlSnippet.className] = function() {
        return App.ArchivedSqlSnippet;
      },
      obj1["" + App.SqlView.className] = function() {
        return App.ArchivedSqlView;
      },
      obj1["" + App.Widget.className] = function() {
        return App.ArchivedWidget;
      },
      obj1
    );

    function Historian(item) {
      this.item = item;
    }

    Historian.prototype.applyHistory = function(archivedItemId) {
      var archivedItem, properties;
      archivedItem = this.archiveClass().exists(archivedItemId);
      if (!archivedItem) {
        return;
      }
      properties = _.cloneDeep(archivedItem[(this.modelName()) + "_properties"]);
      if (!properties) {
        return;
      }
      this.item.load(_.pick(properties, this.attrsToApply()));
      return null;
    };

    Historian.prototype.modelName = function() {
      return this.historianClass().modelName();
    };

    Historian.prototype.attrsToApply = function() {
      return _.map(this.historianClass().fields_to_check(), 'attr');
    };

    Historian.prototype.historianClass = function() {
      return this.constructor.HISTORIAN_MAP[this.item.constructor.className]();
    };

    Historian.prototype.archiveClass = function() {
      return this.constructor.ARCHIVE_MAP[this.item.constructor.className]();
    };

    return Historian;

  })();

}).call(this);
(function() {
  App.HistorianHelper = (function() {
    function HistorianHelper() {}

    HistorianHelper.fieldIsDifferent = function(cAttr, bAttr, field) {
      if ([cAttr, bAttr].every(function(attr) {
        return _.isNull(attr) || _.isUndefined(attr);
      })) {
        return false;
      }
      if ((cAttr != null) !== (bAttr != null)) {
        return true;
      }
      switch (field.dataType) {
        case 'json':
          return JSON.stringify(cAttr) !== JSON.stringify(bAttr);
        case 'array':
          return JSON.stringify(cAttr) !== JSON.stringify(bAttr);
        default:
          return cAttr !== bAttr;
      }
    };

    HistorianHelper.makeCreatedMessage = function(userName) {
      if (!userName) {
        return "Created";
      }
      return "Created by " + userName;
    };

    HistorianHelper.makeUpdatedMessage = function(userName, changes) {
      var changesStr;
      changesStr = changes.join(', ');
      if (!userName) {
        return this.capitalizeFirstChar(changesStr);
      }
      return userName + " " + changesStr;
    };

    HistorianHelper.capitalizeFirstChar = function(str) {
      return "" + (str.charAt(0).toUpperCase() + str.substr(1));
    };

    return HistorianHelper;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.HotkeyManager = (function(superClass) {
    extend(HotkeyManager, superClass);

    function HotkeyManager() {
      return HotkeyManager.__super__.constructor.apply(this, arguments);
    }

    HotkeyManager.KONAMI = "konami";

    HotkeyManager.SEARCH = "search";

    HotkeyManager.SEARCH_CHARTS = "search-charts";

    HotkeyManager.ESC = "esc-pressed";

    HotkeyManager.SAVE = "save-pressed";

    HotkeyManager.SAVE_AND_CLOSE = "save-and-close-pressed";

    HotkeyManager.NEW = "new-widget-pressed";

    HotkeyManager.NEW_VIEW = "new-view-pressed";

    HotkeyManager.TEMP_EDIT_VIEW = "edit-view-pressed";

    HotkeyManager.FORMAT = "format-pressed";

    HotkeyManager.GLOBAL_SEARCH = "global-search";

    HotkeyManager.unstoppableCombos = {};

    HotkeyManager.NO_HOTKEY_TAGS = ['SELECT', 'INPUT', 'TEXTAREA'];

    HotkeyManager.disable = false;

    HotkeyManager.prototype.registerKeyEvent = function(key, event, allowInTextboxen) {
      if ((allowInTextboxen != null) && allowInTextboxen) {
        this.addToUnstoppableList(key);
      }
      return Mousetrap.bind(key, ((function(_this) {
        return function(e) {
          return _this.trigger(event, e);
        };
      })(this)));
    };

    HotkeyManager.prototype.addToUnstoppableList = function(key) {
      if (key.forEach != null) {
        return key.forEach(this.addToUnstoppableList);
      }
      return App.HotkeyManager.unstoppableCombos[key] = true;
    };

    HotkeyManager.prototype.removeFromUnstoppableList = function(key) {
      if (key.forEach != null) {
        return key.forEach(this.removeFromUnstoppableList);
      }
      return delete App.HotkeyManager.unstoppableCombos[key];
    };

    HotkeyManager.prototype.clear = function(key) {
      this.removeFromUnstoppableList(key);
      return Mousetrap.unbind(key);
    };

    HotkeyManager.elementAllowsHotkeys = function(element) {
      if (App.HotkeyManager.disabled) {
        return false;
      }
      if ($(element).hasClass('mousetrap')) {
        return true;
      }
      if ((App.HotkeyManager.NO_HOTKEY_TAGS.indexOf(element.tagName) > -1) || (element.contentEditable && element.contentEditable === 'true')) {
        return false;
      }
      return true;
    };

    HotkeyManager.disable = function() {
      return App.HotkeyManager.disabled = true;
    };

    HotkeyManager.enable = function() {
      return App.HotkeyManager.disabled = false;
    };

    return HotkeyManager;

  })(Spine.Controller);

  Mousetrap.stopCallback = function(e, element, combo) {
    if ((typeof window === "undefined" || window === null) || window.test_mode) {
      return;
    }
    if (App.HotkeyManager.elementAllowsHotkeys(element) || (App.HotkeyManager.unstoppableCombos[combo] != null)) {
      App.Utils.logFeature("hotkey-used-" + combo);
      return false;
    }
    return true;
  };

  App.hotkeys = new App.HotkeyManager();

  App.hotkeys.registerKeyEvent("up up down down left right left right b a", App.HotkeyManager.KONAMI);

  App.hotkeys.registerKeyEvent('esc', App.HotkeyManager.ESC, true);

  App.hotkeys.registerKeyEvent(["command+s", "ctrl+s"], App.HotkeyManager.SAVE, true);

  App.hotkeys.registerKeyEvent(["command+shift+s", "ctrl+shift+s"], App.HotkeyManager.SAVE_AND_CLOSE, true);

  App.hotkeys.registerKeyEvent(["c", "n"], App.HotkeyManager.NEW);

  App.hotkeys.registerKeyEvent(["v"], App.HotkeyManager.NEW_VIEW);

  App.hotkeys.registerKeyEvent(["e v"], App.HotkeyManager.TEMP_EDIT_VIEW);

  App.hotkeys.registerKeyEvent("/", App.HotkeyManager.SEARCH);

  App.hotkeys.registerKeyEvent(["ctrl+shift+l", "command+shift+l"], App.HotkeyManager.FORMAT);

  App.hotkeys.registerKeyEvent(["f"], App.HotkeyManager.SEARCH_CHARTS);

  App.hotkeys.registerKeyEvent(["command+k", "ctrl+k"], App.HotkeyManager.GLOBAL_SEARCH);

}).call(this);
(function() {
  App.KMedoids = (function() {
    function KMedoids() {}

    KMedoids.DEFAULT_NUM_CLUSTERS = 50;

    KMedoids.MAX_CLUSTER_ITERATIONS = 100;

    KMedoids.MAX_MEDOID_DISTANCE = 5;

    KMedoids.MIN_MEDOID_DISTANCE = 1;

    KMedoids.cluster = function(points, numClusters) {
      var i, len, p, results;
      if (numClusters == null) {
        numClusters = this.DEFAULT_NUM_CLUSTERS;
      }
      points = this.cleanPoints(points);
      points = this.collapseDuplicates(points);
      if (points.length <= numClusters) {
        results = [];
        for (i = 0, len = points.length; i < len; i++) {
          p = points[i];
          results.push({
            medoid: p,
            weight: p.weight,
            points: [p]
          });
        }
        return results;
      } else {
        return this.makeClusters(points, numClusters);
      }
    };

    KMedoids.cleanPoints = function(points) {
      var i, len, p;
      for (i = 0, len = points.length; i < len; i++) {
        p = points[i];
        p.weight = App.Utils.parseFloatOr(p.weight, 1);
        p.x = App.Utils.parseFloatOr(p.x, 0);
        p.y = App.Utils.parseFloatOr(p.y, 0);
      }
      return points;
    };

    KMedoids.collapseDuplicates = function(points) {
      var dimStr, i, k, len, newPoints, p, results, v;
      newPoints = {};
      for (i = 0, len = points.length; i < len; i++) {
        p = points[i];
        dimStr = p.x + "," + p.y;
        if (newPoints[dimStr] != null) {
          newPoints[dimStr].weight += p.weight;
          newPoints[dimStr].duplicates += 1;
        } else {
          p.duplicates = 0;
          newPoints[dimStr] = p;
        }
      }
      results = [];
      for (k in newPoints) {
        v = newPoints[k];
        results.push(v);
      }
      return results;
    };

    KMedoids.makeClusters = function(points, numClusters) {
      var c, clusterChanged, clusters, i, iteration, len, medoids;
      medoids = this.getRandomPoints(points, numClusters);
      clusters = [];
      iteration = 0;
      clusterChanged = true;
      while (iteration++ < this.MAX_CLUSTER_ITERATIONS && clusterChanged) {
        clusters = this.associateMedoids(medoids, points);
        clusterChanged = false;
        for (i = 0, len = clusters.length; i < len; i++) {
          c = clusters[i];
          if (this.rebalanceCluster(c)) {
            clusterChanged = true;
          }
        }
        medoids = (function() {
          var j, len1, results;
          results = [];
          for (j = 0, len1 = clusters.length; j < len1; j++) {
            c = clusters[j];
            results.push(c.medoid);
          }
          return results;
        })();
      }
      return clusters;
    };

    KMedoids.associateMedoids = function(medoids, points) {
      var bestCluster, bestDistance, c, clusters, curDistance, i, j, len, len1, m, p;
      clusters = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = medoids.length; i < len; i++) {
          m = medoids[i];
          results.push({
            medoid: m,
            points: [],
            weight: 0,
            duplicates: 0
          });
        }
        return results;
      })();
      for (i = 0, len = points.length; i < len; i++) {
        p = points[i];
        bestCluster = clusters[0];
        bestDistance = this.calcDistance(bestCluster.medoid, p);
        for (j = 0, len1 = clusters.length; j < len1; j++) {
          c = clusters[j];
          curDistance = this.calcDistance(c.medoid, p);
          if (curDistance < bestDistance) {
            bestCluster = c;
            bestDistance = curDistance;
          }
        }
        if (this.pointTooFarFromMedoid(bestCluster.medoid, p)) {
          clusters.push({
            medoid: p,
            points: [p],
            weight: p.weight,
            duplicates: p.duplicates
          });
        } else {
          bestCluster.points.push(p);
          bestCluster.weight += p.weight;
          bestCluster.duplicates += p.duplicates;
        }
      }
      return clusters;
    };

    KMedoids.costCluster = function(c) {
      var cost, i, len, p, ref;
      cost = 0;
      ref = c.points;
      for (i = 0, len = ref.length; i < len; i++) {
        p = ref[i];
        cost += this.calcDistance(c.medoid, p);
      }
      return cost;
    };

    KMedoids.costConfig = function(clusters) {
      var c, cost, i, len;
      cost = 0;
      for (i = 0, len = clusters.length; i < len; i++) {
        c = clusters[i];
        cost += this.costCluster(c);
      }
      return cost;
    };

    KMedoids.pointTooFarFromMedoid = function(medoid, b) {
      return Math.pow(medoid.x - b.x, 2) + Math.pow(medoid.y - b.y, 2) > this.MAX_MEDOID_DISTANCE;
    };

    KMedoids.pointTooCloseForNewCluster = function(medoids, b) {
      var i, len, m;
      for (i = 0, len = medoids.length; i < len; i++) {
        m = medoids[i];
        if (Math.pow(m.x - b.x, 2) + Math.pow(m.y - b.y, 2) < this.MIN_MEDOID_DISTANCE) {
          return true;
        }
      }
      return false;
    };

    KMedoids.rebalanceCluster = function(cluster) {
      var bestCost, bestMedoid, changed, curCost, i, len, p, ref;
      changed = false;
      bestMedoid = cluster.medoid;
      bestCost = this.costCluster(cluster);
      ref = cluster.points;
      for (i = 0, len = ref.length; i < len; i++) {
        p = ref[i];
        cluster.medoid = p;
        curCost = this.costCluster(cluster);
        if (curCost < bestCost) {
          changed = true;
          bestMedoid = p;
          bestCost = curCost;
        } else {
          cluster.medoid = bestMedoid;
        }
      }
      return changed;
    };

    KMedoids.getRandomPoints = function(points, numRand) {
      var index, itrCount, randomPoints, usedPoints;
      if (points.length <= numRand) {
        return points;
      }
      usedPoints = {};
      randomPoints = [];
      while (randomPoints.length < numRand) {
        index = randomPoints.length * Math.floor(points.length / numRand);
        itrCount = 0;
        while (usedPoints[index] || (this.pointTooCloseForNewCluster(randomPoints, points[index]) && itrCount++ < points.length)) {
          index = (index + 1) % points.length;
        }
        usedPoints[index] = true;
        randomPoints.push(points[index]);
      }
      return randomPoints;
    };

    KMedoids.calcDistance = function(a, b) {
      return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
    };

    return KMedoids;

  })();

}).call(this);
(function() {
  var Lagotron,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Lagotron = (function() {
    Lagotron.unleash = function() {
      Lagotron.instance = new Lagotron();
      return Lagotron.instance.startPinging();
    };

    Lagotron.addContext = function(msg, details) {
      if (details == null) {
        details = {};
      }
      if (Lagotron.instance == null) {
        return;
      }
      return Lagotron.instance.addContext(msg, details);
    };

    Lagotron.MIN_LAG_MS = 500;

    Lagotron.MAX_LAG_MS = 60 * 1000;

    Lagotron.LAG_PING_INTERVAL = 100;

    Lagotron.INITIAL_CONTEXT = 'Lagotron initialized';

    Lagotron.NO_CONTEXT = 'No recent context';

    Lagotron.CONTEXT_LENGTH = 20;

    Lagotron.MAX_REPORTS_PER_HOUR = 100;

    function Lagotron() {
      this.ping = bind(this.ping, this);
      this.context = [];
      this.addContext(App.Lagotron.INITIAL_CONTEXT);
      this.updateLastPing(this.timestamp());
      this.lastHour = this.getHour();
      this.reportsThisHour = 0;
    }

    Lagotron.prototype.startPinging = function() {
      return setInterval(this.ping, Lagotron.LAG_PING_INTERVAL);
    };

    Lagotron.prototype.updateLastPing = function(timestamp) {
      this.lastPingTimestamp = timestamp;
      return this.lastPingCurrentTab = this.isCurrentTab();
    };

    Lagotron.prototype.ping = function() {
      var appropriateLag, currentHour, elapsed, now, validBrowser, validTab;
      currentHour = this.getHour();
      if (this.lastHour !== this.getHour()) {
        this.lastHour = currentHour;
        this.reportsThisHour = 0;
      }
      now = this.timestamp();
      elapsed = now - this.lastPingTimestamp;
      validTab = this.isCurrentTab() && this.lastPingCurrentTab;
      validBrowser = this.browser() !== 'Explorer';
      appropriateLag = (elapsed >= Lagotron.MIN_LAG_MS) && (elapsed < Lagotron.MAX_LAG_MS);
      if (appropriateLag && validTab && validBrowser && this.reportsThisHour < App.Lagotron.MAX_REPORTS_PER_HOUR) {
        this.report(now, elapsed);
        this.reportsThisHour += 1;
      }
      return this.updateLastPing(now);
    };

    Lagotron.prototype.report = function(now, elapsed) {
      var commonParams, context, dash, params, previousContext, ref, ref1, ref2, ref3, ref4, user, widget_label;
      context = this.longestContextInWindow(now, this.lastPingTimestamp);
      previousContext = this.previousContext(now, this.lastPingTimestamp);
      commonParams = {
        lag_duration: elapsed,
        context: context.name,
        context_duration: context.duration,
        previous_context: (ref = previousContext.context) != null ? ref.name : void 0,
        time_since_previous_context: previousContext.timeSince,
        browser: this.browser(),
        browser_version: BrowserDetect.version,
        os: BrowserDetect.OS,
        seconds_since_pageload: AppRedesign.current().secondsSincePageload(),
        idle_seconds: AppRedesign.current().idleSeconds(),
        tv_mode: !!((ref1 = AppRedesign.current()) != null ? ref1.tvmode : void 0),
        tv_mode_parent: !!((ref2 = AppRedesign.current()) != null ? ref2.tvmodeParent : void 0),
        focused_tab: this.isFocusedTab()
      };
      params = jQuery.extend(true, {}, commonParams, context.details);
      user = App.User.currentUser();
      if (user != null) {
        params.user_id = user.id;
      }
      dash = App.Dashboard.currentDashboard();
      if (dash != null) {
        params.dashboard_id = dash.id;
      }
      if ((ref3 = App.User.currentUser()) != null ? ref3.periscope_admin : void 0) {
        widget_label = context.details.widget_id != null ? " widget_id: " + context.details.widget_id : "";
        console.warn("Lag " + elapsed + "ms (" + context.duration + "ms) " + context.name + widget_label);
      }
      if (App.Site.count() > 0 && !((ref4 = AppRedesign.current()) != null ? ref4.shared_mode : void 0)) {
        return jQuery.post("/logging/log_lag", params);
      }
    };

    Lagotron.prototype.previousContext = function(now, lastPingTimestamp) {
      var context, currentTime, firstContextInWindow, j, len, previousContext, previousTime, ref;
      previousContext = null;
      firstContextInWindow = null;
      ref = this.context;
      for (j = 0, len = ref.length; j < len; j++) {
        context = ref[j];
        if (context.timestamp < lastPingTimestamp) {
          previousContext = context;
        } else {
          firstContextInWindow = context;
        }
      }
      if (previousContext) {
        previousTime = previousContext.timestamp;
        currentTime = (firstContextInWindow != null ? firstContextInWindow.timestamp : void 0) || lastPingTimestamp;
        return {
          context: previousContext,
          timeSince: currentTime - previousTime
        };
      }
      return {
        context: null,
        timeSince: null
      };
    };

    Lagotron.prototype.longestContextInWindow = function(now, lastPingTimestamp) {
      var context, contextDuration, i, j, len, longestContext, longestContextTime, nextContextTimestamp, ref;
      longestContext = {
        name: Lagotron.NO_CONTEXT,
        timestamp: this.timestamp(),
        details: {}
      };
      longestContextTime = 0;
      ref = this.context;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        context = ref[i];
        if (context.timestamp < lastPingTimestamp) {
          continue;
        }
        if (i < this.context.length - 1) {
          nextContextTimestamp = this.context[i + 1].timestamp;
        } else {
          nextContextTimestamp = now;
        }
        contextDuration = nextContextTimestamp - context.timestamp;
        if (contextDuration > longestContextTime) {
          longestContext = context;
          longestContextTime = contextDuration;
        }
      }
      return jQuery.extend(true, {
        duration: longestContextTime
      }, longestContext);
    };

    Lagotron.prototype.addContext = function(msg, details) {
      var newContext;
      if (details == null) {
        details = {};
      }
      newContext = {
        name: msg,
        timestamp: this.timestamp(),
        details: details
      };
      if (this.context.length > Lagotron.CONTEXT_LENGTH) {
        this.context.shift();
      }
      return this.context.push(newContext);
    };

    Lagotron.prototype.isFocusedTab = function() {
      if (AppRedesign.current() != null) {
        return AppRedesign.current().focusedTab;
      }
      return false;
    };

    Lagotron.prototype.isCurrentTab = function() {
      if (AppRedesign.current() != null) {
        return AppRedesign.current().currentTab;
      }
      return false;
    };

    Lagotron.prototype.browser = function() {
      return BrowserDetect.browser;
    };

    Lagotron.prototype.timestamp = function() {
      return (new Date()).getTime();
    };

    Lagotron.prototype.getHour = function() {
      return (new Date()).getHours();
    };

    return Lagotron;

  })();

  App.Lagotron = Lagotron;

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.Listotron = (function() {
    Listotron.BLOCK_CLASS = 'listotron-block';

    Listotron.BLOCK_SELECTOR = "." + Listotron.BLOCK_CLASS;

    Listotron.DRAGGING_CLASS = 'listotron-draggertime';

    Listotron.DRAGGING_SELECTOR = "." + Listotron.DRAGGING_CLASS;

    Listotron.SPACER_CLASS = 'listotron-spacer';

    Listotron.SPACER_SELECTOR = "." + Listotron.SPACER_CLASS;

    Listotron.FINAL_CLASS = 'listotron-block-final';

    Listotron.MIN_DRAG_DISTANCE = 10;

    Listotron.ANIMATION_TIME = App.AppFrameRedesign.FAST_ANIMATION_TIME;


    /*
      Welcome, citizen!
      Parameters
        required
          container: jQuery selector, parent element for all the list items
          handles: String, css selector for which element within objects added is the handle
        optional
          onChange: function, called when the order of elements changes, passed argument is array of elements
          onComplete: function, called when the user finishes dragging, passed argument is array of elements
    
      Basics
        Add draggable elements with listotron.add(). Spacer elements are added between each draggable
        element as needed. The heights of the spacer elements are CSS animated - this makes the draggable
        elements look animated. The element that is getting dragged is a clone of the original (which gets
        hidden). We clone the original so that we can destroy the dragged element - putting an absolutely
        positioned element back inline causes flicker.
     */

    function Listotron(options) {
      var k, v;
      if (options == null) {
        options = {};
      }
      this.mouseMove = bind(this.mouseMove, this);
      this.mouseUp = bind(this.mouseUp, this);
      this.mouseDownOnHandle = bind(this.mouseDownOnHandle, this);
      for (k in options) {
        v = options[k];
        this[k] = v;
      }
      if (!this.container) {
        throw new Error('container required');
      }
      if (!this.handles) {
        throw new Error('handles required');
      }
      this.dragging = false;
      this.mouseDown = false;
      this.dragstartY = null;
      this.container.css({
        position: 'relative'
      });
      $(document).on('mouseup', this.mouseUp).on("mousemove", this.mouseMove);
      this.originalElement = null;
      this.draggerElement = null;
    }

    Listotron.prototype.destroy = function() {
      $(document).off('mouseup', this.mouseUp).off("mousemove", this.mouseMove);
      this.container.css({
        position: ''
      });
      this.container.find(Listotron.SPACER_SELECTOR).remove();
      this.container.find(this.handles).off('mousedown', this.mouseDownOnHandle);
      return this.container.find(Listotron.BLOCK_SELECTOR).removeClass(Listotron.BLOCK_CLASS);
    };

    Listotron.prototype.add = function(element) {
      return element.addClass(Listotron.BLOCK_CLASS).find(this.handles).on('mousedown', this.mouseDownOnHandle);
    };

    Listotron.prototype.mouseDownOnHandle = function(event) {
      this.mouseDown = true;
      this.originalElement = $(event.target).closest(Listotron.BLOCK_SELECTOR);
      this.draggerHeight = this.originalElement.outerHeight(true);
      this.dragstartElementY = this.originalElement.position().top;
      this.dragstartMouseY = event.clientY;
      return this.dragstartY = event.clientY;
    };

    Listotron.prototype.mouseUp = function() {
      if (this.dragging) {
        this.finishDragging();
      }
      return this.mouseDown = false;
    };

    Listotron.prototype.mouseMove = function(event) {
      if (this.dragging) {
        return this.moveDragger(this.dragstartElementY + (event.clientY - this.dragstartMouseY));
      } else if (this.mouseDown) {
        if (Math.abs(event.clientY - this.dragstartMouseY) > Listotron.MIN_DRAG_DISTANCE) {
          return this.unleashTheDragger();
        }
      }
    };

    Listotron.prototype.unleashTheDragger = function() {
      this.dragging = true;
      this.container.css('height', (this.container.height() + 13) + "px");
      this.setAllDragging();
      return this.elevateDragger();
    };

    Listotron.prototype.setAllDragging = function() {
      return this.container.find(Listotron.BLOCK_SELECTOR).addClass(Listotron.DRAGGING_CLASS);
    };

    Listotron.prototype.unsetAllDragging = function() {
      this.container.find(Listotron.DRAGGING_SELECTOR).removeClass(Listotron.DRAGGING_CLASS);
      return this.container.find('input').attr('disabled', null);
    };

    Listotron.prototype.elevateDragger = function() {
      this.draggerElement = this.originalElement.clone();
      this.originalElement.after(this.draggerElement).removeClass(Listotron.BLOCK_CLASS).hide();
      this.draggerElement.after(this.newSpacer(this.draggerHeight)).css({
        position: 'absolute',
        zIndex: 1,
        top: this.dragstartElementY,
        left: this.draggerElement.position().left,
        width: this.draggerElement.width(),
        height: this.draggerElement.height()
      });
      return this.container.find('input').attr('disabled', 'disabled');
    };

    Listotron.prototype.finishDragging = function() {
      this.unsetAllDragging();
      this.dragging = false;
      this.draggerElement.addClass(Listotron.FINAL_CLASS);
      setTimeout(((function(_this) {
        return function() {
          return _this.draggerElement.css('top', (_this.finalPosition()) + "px");
        };
      })(this)));
      setTimeout(((function(_this) {
        return function() {
          _this.collapseSpacer(_this.container.find(Listotron.SPACER_SELECTOR), 0);
          _this.draggerElement.after(_this.originalElement).remove();
          return _this.originalElement.show().addClass(Listotron.BLOCK_CLASS);
        };
      })(this)), Listotron.ANIMATION_TIME);
      this.container.css('height', '');
      if (this.onComplete != null) {
        return this.onComplete(this.toArray());
      }
    };

    Listotron.prototype.finalPosition = function() {
      var prev;
      prev = this.draggerElement.prevAll(Listotron.BLOCK_SELECTOR).first();
      if (prev.length > 0) {
        return prev.position().top + prev.outerHeight(true);
      }
      return 0;
    };

    Listotron.prototype.moveDragger = function(newPosition) {
      var addSpace, currentPosition, nbr, newSpacer;
      if (newPosition < 0) {
        return;
      }
      currentPosition = this.draggerElement.position().top;
      this.draggerElement.css('top', newPosition + "px");
      addSpace = false;
      if (currentPosition < newPosition) {
        nbr = this.draggerElement.nextAll(Listotron.BLOCK_SELECTOR).first();
        if (nbr.length > 0 && (newPosition + this.draggerHeight) > (nbr.position().top + nbr.outerHeight(true) / 2)) {
          nbr.after(this.draggerElement);
          addSpace = true;
        }
      } else if (currentPosition > newPosition) {
        nbr = this.draggerElement.prevAll(Listotron.BLOCK_SELECTOR).first();
        if (nbr.length > 0 && newPosition < (nbr.position().top + nbr.outerHeight(true) / 2)) {
          nbr.before(this.draggerElement);
          addSpace = true;
        }
      }
      if (addSpace) {
        this.collapseSpacer(this.container.find(Listotron.SPACER_SELECTOR));
        newSpacer = this.newSpacer();
        this.draggerElement.after(newSpacer);
        this.expandSpacer(newSpacer);
        if (this.onChange != null) {
          return this.onChange(this.toArray());
        }
      }
    };

    Listotron.prototype.toArray = function() {
      var e, i, len, ref, results;
      ref = this.container.find(Listotron.BLOCK_SELECTOR);
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        e = ref[i];
        results.push(e);
      }
      return results;
    };

    Listotron.prototype.newSpacer = function(size) {
      if (size == null) {
        size = 0;
      }
      return $('<div/>', {
        style: "height:" + size + "px",
        "class": Listotron.SPACER_CLASS
      });
    };

    Listotron.prototype.expandSpacer = function(spacer) {
      return setTimeout(((function(_this) {
        return function() {
          return spacer.css('height', _this.draggerHeight + "px");
        };
      })(this)));
    };

    Listotron.prototype.collapseSpacer = function(spacer, time) {
      if (time == null) {
        time = Listotron.ANIMATION_TIME;
      }
      if (time === 0) {
        return spacer.remove();
      } else {
        setTimeout(((function(_this) {
          return function() {
            return spacer.css('height', 0);
          };
        })(this)));
        return setTimeout(((function(_this) {
          return function() {
            return spacer.remove();
          };
        })(this)), time);
      }
    };

    return Listotron;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.LiveChat = (function() {
    function LiveChat() {
      this.wixUpdate = bind(this.wixUpdate, this);
      var ref, ref1;
      this.initialized = false;
      this.wixEnabled = Features.enabled('wix_live_chat') || ((ref = App.Site.first()) != null ? ref.wix_feature_flag_enabled : void 0);
      this.salesforceEnabled = Features.enabled('salesforce_live_chat') || ((ref1 = App.Site.first()) != null ? ref1.salesforce_chat_feature_flag_enabled : void 0);
      if (this.salesforceEnabled) {
        this.salesforce = new App.SalesforceLiveChat();
      } else if (this.wixEnabled) {
        this.wix = new App.WixLiveChat();
      }
      true;
    }

    LiveChat.prototype.init = function() {
      var ref, ref1;
      if (this.initialized) {
        return false;
      }
      this.initialized = true;
      if ((ref = this.wix) != null) {
        ref.init();
      }
      return (ref1 = this.salesforce) != null ? ref1.init() : void 0;
    };

    LiveChat.prototype.wixUpdate = function() {
      var ref;
      return (ref = this.wix) != null ? ref.update() : void 0;
    };

    return LiveChat;

  })();

}).call(this);
(function() {
  App.LocalStorage = (function() {
    function LocalStorage() {}

    LocalStorage.isEnabled = function() {
      if (window.test_mode && !window.use_local_storage_in_test) {
        return false;
      }
      if (!this.isSupportedByBrowser()) {
        return false;
      }
      return true;
    };

    LocalStorage.isSupportedByBrowser = function() {
      var error;
      try {
        localStorage.setItem('a', 'test');
        localStorage.removeItem('a');
        return true;
      } catch (error1) {
        error = error1;
        return false;
      }
    };

    LocalStorage.setItem = function(keyName, keyValue) {
      var error;
      if (!this.isEnabled()) {
        return;
      }
      try {
        return localStorage.setItem(keyName, keyValue);
      } catch (error1) {
        error = error1;
        AppRedesign.logErrorAsWarning(error);
        return this.clear();
      }
    };

    LocalStorage.getItem = function(keyName) {
      if (!this.isEnabled()) {
        return;
      }
      return localStorage.getItem(keyName);
    };

    LocalStorage.removeItem = function(keyName) {
      if (!this.isEnabled()) {
        return;
      }
      return localStorage.removeItem(keyName);
    };

    LocalStorage.clear = function() {
      if (!this.isEnabled()) {
        return;
      }
      return localStorage.clear();
    };

    LocalStorage.hasValueForKey = function(keyName) {
      if (!this.isEnabled()) {
        return false;
      }
      return !(localStorage.getItem(keyName) === null);
    };

    LocalStorage.fetchItem = function(keyName, defaultValue) {
      if (!this.isEnabled()) {
        return defaultValue;
      }
      if (this.hasValueForKey(keyName)) {
        return this.getItem(keyName);
      } else {
        return defaultValue;
      }
    };

    LocalStorage.setJSONItem = function(keyName, keyValue) {
      if (!this.isEnabled()) {
        return;
      }
      return this.setItem(keyName, JSON.stringify(keyValue));
    };

    LocalStorage.getJSONItem = function(keyName) {
      if (!this.isEnabled()) {
        return;
      }
      return JSON.parse(this.getItem(keyName));
    };

    LocalStorage.fetchJSONItem = function(keyName, defaultValue) {
      if (!this.isEnabled()) {
        return defaultValue;
      }
      if (this.hasValueForKey(keyName)) {
        return JSON.parse(this.getItem(keyName));
      } else {
        return defaultValue;
      }
    };

    return LocalStorage;

  })();

}).call(this);
(function() {
  App.Logger = (function() {
    function Logger() {}

    Logger.LAST_ERROR_TIME = {};

    Logger.LOGGING_COOLDOWN = 1000 * 60 * 5;

    Logger.logErrorObject = function(message, file, line, column, errorObj) {
      if ((errorObj != null) && errorObj.stack) {
        return Logger.logError(errorObj);
      } else if (message != null) {
        return Logger.logError({
          message: message
        });
      } else {
        return Logger.logError({
          message: "Unknown error :("
        });
      }
    };

    Logger.logError = function(error, extraDetails) {
      var params, siteId;
      params = this.params(error, extraDetails);
      siteId = 0;
      if (App.Site.first() != null) {
        siteId = App.Site.first().id;
      }
      this.postError(siteId, params);
      if ((typeof console !== "undefined" && console !== null) && (console.warn != null) && !(typeof window !== "undefined" && window !== null ? window.test_mode : void 0)) {
        if (error.stack != null) {
          console.warn("Message for error in logError: ", error.message);
          return console.warn("Stack for error in logError:\n", error.stack);
        } else {
          return console.warn("No stack for error in logError:\n", error);
        }
      }
    };

    Logger.params = function(error, extraDetails) {
      var browserInfo, e, params, ref, ref1, userId;
      if (error == null) {
        error = {
          message: "Null error in logError"
        };
      }
      try {
        browserInfo = [BrowserDetect.OS, BrowserDetect.browser, BrowserDetect.version].join(', ');
        if (error.message != null) {
          params = {
            message: error.message,
            stack: error.stack,
            browser: browserInfo,
            details: error.details
          };
        } else {
          params = {
            message: error,
            stack: error != null ? error.stack : void 0,
            browser: browserInfo
          };
        }
        if (params.details == null) {
          params.details = {};
        }
        params.details.siteId = App.Site.first().id;
        params.details.uuid = (ref = AppRedesign.current()) != null ? ref.uuid : void 0;
        params.details.herokuReleaseVersion = typeof window !== "undefined" && window !== null ? (ref1 = window.AppRedesign.current()) != null ? ref1.herokuReleaseVersion : void 0 : void 0;
        userId = App.User.currentUser();
        if (userId) {
          userId = userId.id;
        }
        params.details.userId = userId;
        if (App.Dashboard.currentDashboard()) {
          params.details.currentDashboard = App.Dashboard.currentDashboard().id;
        }
        if (App.UserDataView.current() != null) {
          params.details.currentUdv = App.UserDataView.current().id;
        }
        if (extraDetails != null) {
          params.details.extraDetails = encodeURIComponent(JSON.stringify(extraDetails));
        }
      } catch (error1) {
        e = error1;
      }
      return params;
    };

    Logger.postError = function(siteId, params) {
      var lastErrorTime;
      if (typeof window !== "undefined" && window !== null ? window.test_mode : void 0) {
        return;
      }
      lastErrorTime = this.LAST_ERROR_TIME[params.message];
      if ((lastErrorTime != null) && (AppRedesign.timestamp() - lastErrorTime) < this.LOGGING_COOLDOWN) {
        return;
      }
      this.LAST_ERROR_TIME[params.message] = AppRedesign.timestamp();
      return jQuery.post("/sites/" + siteId + "/log_error", params);
    };

    return Logger;

  })();

}).call(this);
(function() {
  var slice = [].slice;

  App.Memoizer = (function() {
    Memoizer.memory = {};

    Memoizer.mem = function() {
      var k, keys;
      keys = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      k = this.joinKeys(keys);
      if (this.memory[k] == null) {
        this.memory[k] = new Memoizer(k);
      }
      return this.memory[k];
    };

    Memoizer.prototype.isSet = function() {
      return this.dataSet;
    };

    Memoizer.prototype.store = function(data) {
      this.data = data;
      return this.dataSet = true;
    };

    Memoizer.prototype.get = function() {
      return this.data;
    };

    function Memoizer() {
      this.dataSet = false;
    }

    Memoizer.joinKeys = function() {
      var k, keys;
      keys = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return ((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = keys.length; i < len; i++) {
          k = keys[i];
          results.push(JSON.stringify(k));
        }
        return results;
      })()).join(',');
    };

    return Memoizer;

  })();

}).call(this);
(function() {
  App.OverageDataPresenter = (function() {
    OverageDataPresenter.ORDERED_KEYS = ['rows', 'embed_api_hits', 'users', 'creators', 'explorers', 'spaces', 'cached_rows'];

    function OverageDataPresenter(overageData) {
      _.merge(this, overageData);
    }

    OverageDataPresenter.prototype.firstKeyIs = function(key) {
      return key === this.orderedKeysPresent()[0];
    };

    OverageDataPresenter.prototype.secondKeyIs = function(key) {
      return key === this.orderedKeysPresent()[1];
    };

    OverageDataPresenter.prototype.severalLimits = function() {
      return this.length() > 2;
    };

    OverageDataPresenter.prototype.twoLimits = function() {
      return this.length() === 2;
    };

    OverageDataPresenter.prototype.length = function() {
      return this.orderedKeysPresent().length;
    };

    OverageDataPresenter.prototype.orderedKeysPresent = function() {
      return this._orderedKeysPresent != null ? this._orderedKeysPresent : this._orderedKeysPresent = _.intersection(this.constructor.ORDERED_KEYS, this.keysPresent());
    };

    OverageDataPresenter.prototype.keysPresent = function() {
      return _(this).pick(this.constructor.ORDERED_KEYS).omitBy(_.isNull).keys().value();
    };

    OverageDataPresenter.prototype.formattedMaxRows = function() {
      if (this.rows == null) {
        return;
      }
      return this.format(this.rows.max_rows);
    };

    OverageDataPresenter.prototype.pluralizedExcessSpaces = function() {
      var noun;
      noun = App.Utils.pluralize('space', this.excessSpaces());
      return (this.excessSpaces()) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedExcessUsers = function() {
      var noun;
      noun = App.Utils.pluralize('user', this.excessUsers());
      return (this.excessUsers()) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedExcessCreators = function() {
      var noun;
      noun = App.Utils.pluralize('creator', this.excessCreators());
      return (this.excessCreators()) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedExcessExplorers = function() {
      var noun;
      noun = App.Utils.pluralize('explorer', this.excessExplorers());
      return (this.excessExplorers()) + " " + noun;
    };

    OverageDataPresenter.prototype.excessUsers = function() {
      return this.users.current_users - this.users.plan_max_users;
    };

    OverageDataPresenter.prototype.excessCreators = function() {
      return this.creators.current_creators - this.creators.plan_max_creators;
    };

    OverageDataPresenter.prototype.excessExplorers = function() {
      return this.explorers.current_explorers - this.explorers.plan_max_explorers;
    };

    OverageDataPresenter.prototype.excessSpaces = function() {
      return this.spaces.current_spaces - this.spaces.plan_max_spaces;
    };

    OverageDataPresenter.prototype.formattedMaxEmbedApiHits = function() {
      if (this.embed_api_hits == null) {
        return;
      }
      return this.format(this.embed_api_hits.plan_max_embed_api_hits);
    };

    OverageDataPresenter.prototype.formattedExcessEmbedApiHits = function() {
      if (this.embed_api_hits == null) {
        return;
      }
      return this.format(this.embed_api_hits.current_monthly_hits - this.embed_api_hits.plan_max_embed_api_hits);
    };

    OverageDataPresenter.prototype.formattedExcessRows = function() {
      if (this.rows == null) {
        return;
      }
      return this.format(this.rows.current_rows - this.rows.max_rows);
    };

    OverageDataPresenter.prototype.pluralizedPlanMaxUsers = function() {
      var noun, ref, ref1;
      noun = App.Utils.pluralize('user', (ref = this.users) != null ? ref.plan_max_users : void 0);
      return ((ref1 = this.users) != null ? ref1.plan_max_users : void 0) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedPlanMaxCreators = function() {
      var noun, ref, ref1;
      noun = App.Utils.pluralize('creator', (ref = this.creators) != null ? ref.plan_max_creators : void 0);
      return ((ref1 = this.creators) != null ? ref1.plan_max_creators : void 0) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedPlanMaxExplorers = function() {
      var noun, ref, ref1;
      noun = App.Utils.pluralize('explorer', (ref = this.explorers) != null ? ref.plan_max_explorers : void 0);
      return ((ref1 = this.explorers) != null ? ref1.plan_max_explorers : void 0) + " " + noun;
    };

    OverageDataPresenter.prototype.pluralizedPlanMaxSpaces = function() {
      var noun, ref, ref1;
      noun = App.Utils.pluralize('space', (ref = this.spaces) != null ? ref.plan_max_spaces : void 0);
      return ((ref1 = this.spaces) != null ? ref1.plan_max_spaces : void 0) + " " + noun;
    };

    OverageDataPresenter.prototype.formattedCachedRows = function() {
      if (this.cached_rows == null) {
        return;
      }
      return this.format(this.cached_rows.plan_max_cached_rows);
    };

    OverageDataPresenter.prototype.formattedExcessCachedRows = function() {
      var overage;
      if (this.cached_rows == null) {
        return;
      }
      overage = this.cached_rows.current_cached_rows - this.cached_rows.plan_max_cached_rows;
      return this.format(overage);
    };

    OverageDataPresenter.prototype.formattedCachedStorage = function() {
      if (this.cached_storage == null) {
        return;
      }
      return this.format(this.cached_storage.plan_max_cached_storage);
    };

    OverageDataPresenter.prototype.formattedExcessCachedStorage = function() {
      var overage;
      if (this.cached_storage == null) {
        return;
      }
      overage = this.cached_storage.current_cached_storage - this.cached_storage.plan_max_cached_storage;
      return this.format(overage);
    };

    OverageDataPresenter.prototype.format = function(number) {
      if (number == null) {
        return;
      }
      return App.Utils.scaleDisplayNumber(number, 3, true);
    };

    return OverageDataPresenter;

  })();

}).call(this);
(function() {
  App.PivotTableHelper = (function() {
    function PivotTableHelper() {}

    PivotTableHelper.createLeaf = function(column, leaf) {
      return {
        name: column,
        children: leaf,
        data: leaf,
        leaf: true
      };
    };

    PivotTableHelper.createNode = function(column) {
      return {
        name: column,
        children: [],
        data: {}
      };
    };

    PivotTableHelper.findNode = function(column, list) {
      var c, i, index, len;
      for (index = i = 0, len = list.length; i < len; index = ++i) {
        c = list[index];
        if (c.name === column) {
          return index;
        }
      }
      return -1;
    };

    PivotTableHelper.buildPath = function(list, tree, leaf) {
      var i, index, len, level, maxDepth, name, node, results;
      maxDepth = list.length - 1;
      node = tree;
      results = [];
      for (level = i = 0, len = list.length; i < len; level = ++i) {
        name = list[level];
        if (level === 0 && maxDepth > 1) {
          index = this.findNode(name, tree);
          if (index === -1) {
            index = tree.length;
            tree.push(this.createNode(name));
          }
          results.push(node = tree[index].children);
        } else if (level === maxDepth) {
          results.push(node.push(this.createLeaf(name, leaf)));
        } else {
          index = this.findNode(name, node);
          if (index === -1) {
            index = node.length;
            node.push(this.createNode(name));
          }
          results.push(node = node[index].children);
        }
      }
      return results;
    };

    PivotTableHelper.getNestedColumns = function(xCol, detailColumns, dataSeries) {
      var column, i, index, j, k, len, len1, maxDepth, nestedColumns, node, ref, ref1, ref2, ref3, series;
      nestedColumns = [];
      for (i = 0, len = dataSeries.length; i < len; i++) {
        series = dataSeries[i];
        if (series.name == null) {
          continue;
        }
        if (series.namelist == null) {
          nestedColumns.push(this.createLeaf(series.name, series.name));
        } else {
          this.buildPath(series.namelist, nestedColumns, series.name);
        }
      }
      maxDepth = dataSeries != null ? (ref = dataSeries[0]) != null ? (ref1 = ref.namelist) != null ? ref1.length : void 0 : void 0 : void 0;
      if (maxDepth == null) {
        maxDepth = 1;
      }
      ref2 = detailColumns.slice().reverse().concat([xCol]);
      for (j = 0, len1 = ref2.length; j < len1; j++) {
        column = ref2[j];
        node = nestedColumns;
        for (index = k = 0, ref3 = maxDepth; 0 <= ref3 ? k < ref3 : k > ref3; index = 0 <= ref3 ? ++k : --k) {
          if (index === maxDepth - 1) {
            node.unshift(this.createLeaf(column, column));
          } else {
            node.unshift(this.createNode(''));
            node = node[0].children;
          }
        }
      }
      return nestedColumns;
    };

    PivotTableHelper.traverseNestedColumns = function(nestedColumns) {
      var i, len, nestedColumn, order;
      if (!((nestedColumns != null ? nestedColumns.length : void 0) > 0)) {
        return [];
      }
      order = [];
      for (i = 0, len = nestedColumns.length; i < len; i++) {
        nestedColumn = nestedColumns[i];
        order = order.concat(this.traverseNestedColumn(nestedColumn));
      }
      return order;
    };

    PivotTableHelper.traverseNestedColumn = function(node) {
      var child, i, len, order, ref, ref1;
      if (node.leaf) {
        return [node.data];
      }
      if (!(((ref = node.children) != null ? ref.length : void 0) > 0)) {
        return [];
      }
      order = [];
      ref1 = node.children;
      for (i = 0, len = ref1.length; i < len; i++) {
        child = ref1[i];
        order = order.concat(this.traverseNestedColumn(child));
      }
      return order;
    };

    PivotTableHelper.getNestedRows = function(rows, seriesNames, twiddles, seriesToAggregationMap, summaryMap) {
      var i, len, nestedRows, row, xCol;
      xCol = App.RedesignTableChart.MULTICOHORT_XCOL_NAME;
      nestedRows = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        this.buildPath(row[xCol], nestedRows, row);
      }
      if (summaryMap != null) {
        this.populateSummaryValues(nestedRows, seriesNames, twiddles, summaryMap);
        return nestedRows;
      }
      this.calculateAggregation(nestedRows, seriesNames, twiddles);
      this.calculatePercentOfRow(nestedRows, twiddles, seriesToAggregationMap);
      return nestedRows;
    };

    PivotTableHelper.calculatePercentOfRow = function(nestedRows, twiddles, seriesToAggregationMap) {
      var i, len, ref, results, row, rowTotal, rowTotalKey, rowTotals, seriesName, val;
      results = [];
      for (i = 0, len = nestedRows.length; i < len; i++) {
        row = nestedRows[i];
        rowTotals = {};
        ref = row.data;
        for (seriesName in ref) {
          val = ref[seriesName];
          rowTotalKey = this.rowTotalKey(twiddles, seriesName, row.name, seriesToAggregationMap);
          if (!rowTotalKey) {
            continue;
          }
          if (rowTotals[rowTotalKey] == null) {
            rowTotals[rowTotalKey] = 0;
          }
          rowTotals[rowTotalKey] += (val != null ? val.originalVal : void 0) != null ? val.originalVal : val;
        }
        results.push((function() {
          var ref1, results1;
          ref1 = row.data;
          results1 = [];
          for (seriesName in ref1) {
            val = ref1[seriesName];
            rowTotalKey = this.rowTotalKey(twiddles, seriesName, row.name, seriesToAggregationMap);
            if (!rowTotalKey) {
              continue;
            }
            rowTotal = rowTotals[rowTotalKey];
            if (rowTotal === 0) {
              rowTotal = 1;
            }
            val = (val != null ? val.originalVal : void 0) != null ? val.originalVal : val;
            results1.push(row.data[seriesName] = val / rowTotal);
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    PivotTableHelper.rowTotalKey = function(twiddles, seriesName, rowName, seriesToAggregationMap) {
      if (this.hasValueFormat('cohort_percent_of_row', twiddles, seriesName)) {
        return rowName;
      } else if (this.hasValueFormat('percent_of_row', twiddles, seriesName)) {
        return seriesToAggregationMap[seriesName];
      }
    };

    PivotTableHelper.hasValueFormat = function(format, twiddles, seriesName) {
      return twiddles.getForSeries(seriesName, 'value_format') === format;
    };

    PivotTableHelper.populateSummaryValues = function(node, cols, twiddles, summaryMap, inputRowNameKeys) {
      var child, col, i, j, len, len1, ref, results, row, rowNameKeys;
      if (inputRowNameKeys == null) {
        inputRowNameKeys = [];
      }
      if (node == null) {
        return;
      }
      results = [];
      for (i = 0, len = node.length; i < len; i++) {
        row = node[i];
        if (row.leaf) {
          continue;
        }
        rowNameKeys = [].concat(inputRowNameKeys);
        rowNameKeys.push(row.name);
        this.populateSummaryValues(row.children, cols, twiddles, summaryMap, rowNameKeys);
        row.total_children = row.children.length;
        ref = row.children;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          child = ref[j];
          row.total_children += child.total_children || 0;
        }
        if (twiddles.get('cohort_no_row_totals')) {
          continue;
        }
        results.push((function() {
          var k, len2, results1;
          results1 = [];
          for (k = 0, len2 = cols.length; k < len2; k++) {
            col = cols[k];
            if (summaryMap[col]) {
              results1.push(row.data[col] = summaryMap[col][rowNameKeys.toString()] || null);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        })());
      }
      return results;
    };

    PivotTableHelper.calculateAggregation = function(node, cols, twiddles, seriesToAggregationMap) {
      var aggregation, child, childCount, col, columnIsDatetime, forEachGoodData, i, j, len, len1, max, min, ref, result, results, row, sum;
      if (node == null) {
        return;
      }
      results = [];
      for (i = 0, len = node.length; i < len; i++) {
        row = node[i];
        if (row.leaf) {
          continue;
        }
        this.calculateAggregation(row.children, cols, twiddles);
        row.total_children = row.children.length;
        ref = row.children;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          child = ref[j];
          row.total_children += child.total_children || 0;
        }
        if (twiddles.get('cohort_no_row_totals')) {
          continue;
        }
        results.push((function() {
          var k, len2, results1;
          results1 = [];
          for (k = 0, len2 = cols.length; k < len2; k++) {
            col = cols[k];
            if (['percent_of_column'].includes(twiddles.getForSeries(col, 'value_format'))) {
              aggregation = 'sum';
            } else {
              aggregation = App.RedesignTableChart.getColumnTwiddleFromTwiddles(twiddles, col, 'value_aggregation');
            }
            columnIsDatetime = App.RedesignTableChart.getColumnTwiddleFromTwiddles(twiddles, col, 'type') === App.Chartographer.DATETIME_COLUMN_TYPE;
            forEachGoodData = columnIsDatetime ? this.makeForEachGoodDataDatetime(col, row.children) : this.makeForEachGoodData(col, row.children);
            result = (function() {
              switch (aggregation) {
                case 'min':
                  min = null;
                  if (columnIsDatetime) {
                    forEachGoodData(function(data) {
                      if (min == null) {
                        min = data;
                      }
                      return min = moment.min(min, data);
                    });
                    if (min != null) {
                      return min._i;
                    }
                  } else {
                    forEachGoodData(function(data) {
                      if (data.originalVal != null) {
                        data = data.originalVal;
                      }
                      if (min == null) {
                        min = data;
                      }
                      return min = Math.min(min, data);
                    });
                    return min;
                  }
                  break;
                case 'max':
                  max = null;
                  if (columnIsDatetime) {
                    forEachGoodData(function(data) {
                      if (max == null) {
                        max = data;
                      }
                      return max = moment.max(max, data);
                    });
                    if (max != null) {
                      return max._i;
                    }
                  } else {
                    forEachGoodData(function(data) {
                      if (data.originalVal != null) {
                        data = data.originalVal;
                      }
                      if (max == null) {
                        max = data;
                      }
                      return max = Math.max(max, data);
                    });
                    return max;
                  }
                  break;
                case 'average':
                  sum = 0;
                  childCount = 0;
                  forEachGoodData((function(_this) {
                    return function(data) {
                      sum += _this.convertToSumValue(data.sum);
                      return childCount += data.count;
                    };
                  })(this));
                  if (childCount === 0) {
                    return null;
                  } else {
                    return sum / childCount;
                  }
                  break;
                default:
                  sum = null;
                  forEachGoodData((function(_this) {
                    return function(data) {
                      if (sum == null) {
                        sum = 0;
                      }
                      return sum += _this.convertToSumValue(data);
                    };
                  })(this));
                  return sum;
              }
            }).call(this);
            if (result != null) {
              results1.push(row.data[col] = result);
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    PivotTableHelper.makeForEachGoodData = function(col, children) {
      return function(callback) {
        var child, data, i, len, results;
        results = [];
        for (i = 0, len = children.length; i < len; i++) {
          child = children[i];
          data = child.data[col];
          if (data) {
            results.push(callback(data));
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
    };

    PivotTableHelper.makeForEachGoodDataDatetime = function(col, children) {
      return function(callback) {
        var child, data, i, len, results;
        results = [];
        for (i = 0, len = children.length; i < len; i++) {
          child = children[i];
          data = child.data[col];
          if (data) {
            results.push(callback(moment(data)));
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
    };

    PivotTableHelper.convertToSumValue = function(val) {
      if (typeof val === "string") {
        return 1;
      }
      if ((val != null ? val.originalVal : void 0) != null) {
        return val.originalVal;
      }
      if ((val != null ? val.val : void 0) != null) {
        return val.val;
      }
      return val;
    };

    PivotTableHelper.traverseNestedRows = function(node, stack, parentId, orderedRows) {
      var child, i, len, newRow, newStack, ref, results;
      newRow = this.initializeRow(node, stack, parentId);
      orderedRows.push(newRow);
      if (node.leaf) {
        return;
      }
      parentId = orderedRows.length - 1;
      ref = node.children;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        newStack = stack.concat(child.name);
        results.push(this.traverseNestedRows(child, newStack, parentId, orderedRows));
      }
      return results;
    };

    PivotTableHelper.initializeRow = function(node, stack, parentId) {
      var level, newRow;
      newRow = $.extend(node.data, {});
      level = stack.length;
      newRow[App.RedesignTableChart.MULTICOHORT_XCOL_NAME] = node.name;
      newRow[App.RedesignTableChart.LEVEL] = level;
      newRow[App.RedesignTableChart.COLLAPSED_STATE] = false;
      newRow[App.RedesignTableChart.PARENT_ID] = parentId;
      newRow[App.RedesignTableChart.CHILDREN_SIZE] = node.total_children || 0;
      return newRow;
    };

    PivotTableHelper.sortNestedRowsByName = function(rows, desc) {
      var direction, i, len, results, row;
      direction = desc ? -1 : 1;
      rows.sort(function(a, b) {
        var cmpA, cmpB, ref, ref1;
        if ((((ref = a.name) != null ? ref.localeCompare : void 0) == null) && (((ref1 = b.name) != null ? ref1.localeCompare : void 0) == null)) {
          return (a.name - b.name) * direction;
        } else {
          cmpA = a.name + "";
          cmpB = b.name + "";
          return cmpA.localeCompare(cmpB) * direction;
        }
      });
      if (((rows != null ? rows[0] : void 0) == null) || rows[0].leaf) {
        return;
      }
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        results.push(this.sortNestedRowsByName(row.children, desc));
      }
      return results;
    };

    PivotTableHelper.sortRows = function(isDataNumeric, sortDirection, sortedByColumn) {
      return function(a, b) {
        var cmpA, cmpB, sortColumnCompare;
        if (isDataNumeric) {
          cmpA = a.periscopeSortProperty;
          cmpB = b.periscopeSortProperty;
          if (isNaN(cmpA) || (cmpA == null)) {
            sortColumnCompare = -1;
          }
          if (isNaN(cmpB) || (cmpB == null)) {
            sortColumnCompare = 1;
          }
          if (sortColumnCompare == null) {
            sortColumnCompare = cmpA - cmpB;
          }
        } else {
          if (a.data != null) {
            cmpA = a.data[sortedByColumn] || "";
            cmpB = b.data[sortedByColumn] || "";
          } else {
            cmpA = a[sortedByColumn] || "";
            cmpB = b[sortedByColumn] || "";
          }
          sortColumnCompare = cmpA.localeCompare(cmpB);
        }
        if (sortColumnCompare === 0) {
          return a.periscopeLastIndex - b.periscopeLastIndex;
        } else {
          return sortDirection * sortColumnCompare;
        }
      };
    };

    PivotTableHelper.isDataNumeric = function(nestedRows, sortedByColumn) {
      var i, isDataNumeric, len, row, val;
      isDataNumeric = true;
      for (i = 0, len = nestedRows.length; i < len; i++) {
        row = nestedRows[i];
        val = row.data[sortedByColumn];
        isDataNumeric && (isDataNumeric = App.PivotTableHelper.setPeriscopeSortProperty(row, val));
        if (!isDataNumeric) {
          break;
        }
      }
      return isDataNumeric;
    };

    PivotTableHelper.sortNestedRows = function(rows, sortDirection, sortedByColumn) {
      var i, len, numericData, results, row;
      if ((rows != null ? rows[0] : void 0) == null) {
        return;
      }
      numericData = PivotTableHelper.isDataNumeric(rows, sortedByColumn) || (!rows[0].leaf && sortedByColumn !== App.RedesignTableChart.MULTICOHORT_XCOL_NAME);
      rows.sort(PivotTableHelper.sortRows(numericData, sortDirection, sortedByColumn));
      if (rows[0].leaf) {
        return;
      }
      results = [];
      for (i = 0, len = rows.length; i < len; i++) {
        row = rows[i];
        results.push(PivotTableHelper.sortNestedRows(row.children, sortDirection, sortedByColumn));
      }
      return results;
    };

    PivotTableHelper.setNestedPeriscopeSortProperty = function(node, sortedByColumn) {
      var child, i, isDataNumeric, len, ref, val;
      val = node.data[sortedByColumn];
      isDataNumeric = this.setPeriscopeSortProperty(node, val);
      if (!isDataNumeric) {
        return false;
      }
      ref = node.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        isDataNumeric && (isDataNumeric = this.setNestedPeriscopeSortProperty(child, sortedByColumn));
        if (!isDataNumeric) {
          break;
        }
      }
      return true;
    };

    PivotTableHelper.setPeriscopeSortProperty = function(row, val) {
      if ((val != null ? val.val : void 0) != null) {
        val = val.val;
      }
      if (typeof val === 'number') {
        row.periscopeSortProperty = val;
        return true;
      }
      if ((val != null ? val.replace : void 0) != null) {
        val = val.replace(/[$£€%,]/g, '');
      }
      if (!$.isNumeric(val) && (val != null) && val !== '') {
        return false;
      } else {
        row.periscopeSortProperty = parseFloat(val);
      }
      return true;
    };

    PivotTableHelper.getCohortLevelProperties = function(str, level, maxLevel) {
      var properties;
      properties = {
        'level': 1,
        'padding-left': null,
        'text': str,
        'nested': maxLevel > 1
      };
      if (level !== 0) {
        properties['padding-left'] = level * App.RedesignTableChart.LEVEL_INDENT_INCREMENT;
        if (level === maxLevel - 1) {
          properties['level'] = 3;
          properties['nested'] = false;
        } else {
          properties['level'] = 2;
        }
      }
      return properties;
    };

    PivotTableHelper.setNestedRowProperties = function(rawRow, newRow, maxLevel) {
      var cohortProperties, cssClass, level, paddingLeft;
      level = rawRow[App.RedesignTableChart.LEVEL] || 0;
      cohortProperties = this.getCohortLevelProperties(rawRow[App.RedesignTableChart.MULTICOHORT_XCOL_NAME], level, maxLevel);
      cssClass = "nested-row-header";
      if (cohortProperties['nested']) {
        cssClass += " nested";
      }
      paddingLeft = cohortProperties['padding-left'];
      $.extend(newRow[App.RedesignTableChart.MULTICOHORT_XCOL_NAME], {
        value: cohortProperties.test,
        cssClass: cssClass,
        paddingLeft: paddingLeft,
        paddingLeft: paddingLeft,
        nested: cohortProperties.nested,
        level: cohortProperties.level
      });
      newRow[App.RedesignTableChart.COLLAPSED_STATE] = rawRow[App.RedesignTableChart.COLLAPSED_STATE];
      return newRow[App.RedesignTableChart.LEVEL] = rawRow[App.RedesignTableChart.LEVEL];
    };

    PivotTableHelper.extractValueCol = function(column, twiddles) {
      var i, index, len, valueCol, valueCols, vc;
      valueCols = twiddles.getArray('value_cols');
      if (!(valueCols.length > 0)) {
        return column;
      }
      if (column == null) {
        return valueCols[0];
      }
      valueCol = column.split('-').last();
      for (index = i = 0, len = valueCols.length; i < len; index = ++i) {
        vc = valueCols[index];
        if (vc === valueCol) {
          return valueCols[index];
        }
      }
      return valueCols[0];
    };

    return PivotTableHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PreviewLimitTooltipController = (function(superClass) {
    extend(PreviewLimitTooltipController, superClass);

    function PreviewLimitTooltipController() {
      this.hide = bind(this.hide, this);
      this.show = bind(this.show, this);
      PreviewLimitTooltipController.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'editHelper');
    }

    PreviewLimitTooltipController.prototype.release = function() {
      var ref;
      return (ref = this.tooltip) != null ? ref.release() : void 0;
    };

    PreviewLimitTooltipController.prototype.show = function(e) {
      var offsetLeft, ref, rows, target, targetOffset, view_path;
      if (!this.editHelper.hasRunResultReachedPreviewLimit()) {
        return;
      }
      rows = this.editHelper.getSqlRows().length;
      target = $(e.target);
      if ((ref = this.tooltip) != null) {
        ref.closeAndRelease();
      }
      targetOffset = target.offset();
      view_path = AppRedesign.current().allowLargeCsvDownloadForSharedDashboards() ? 'redesign/editors/preview_limit_tooltip_large_file_download' : 'redesign/editors/preview_limit_tooltip';
      offsetLeft = AppRedesign.current().allowLargeCsvDownloadForSharedDashboards() ? targetOffset.left + target.outerWidth() / 2 - App.RedesignTooltipPanel.PADDING_FOR_SHARED_DASHBOARD : targetOffset.left + target.outerWidth() / 2;
      return this.tooltip = App.RedesignTooltipPanel.addPanel({
        description: this.view(view_path)({
          rows: rows,
          rowTerm: this.rowTerm(rows)
        }),
        extraClass: 'preview-limit',
        pointerOffsetPercent: App.RedesignTooltipPanel.CENTER_POINTER,
        side: App.RedesignTooltipPanel.BOTTOM,
        title: App.RedesignTooltipPanel.BLANK_TITLE,
        useSmallPointer: true,
        width: "425px"
      }).pointAt(App.RedesignTooltipPanel.BOTTOM, target, App.RedesignTooltipPanel.CENTER_POINTER, offsetLeft, targetOffset.top);
    };

    PreviewLimitTooltipController.prototype.hide = function() {
      var ref;
      if ((ref = this.tooltip) != null) {
        ref.closeAndRelease();
      }
      return this.tooltip = null;
    };

    PreviewLimitTooltipController.prototype.rowTerm = function(rowLength) {
      if (rowLength !== 1) {
        return 'rows';
      }
      return 'row';
    };

    return PreviewLimitTooltipController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PusherClient = (function(superClass) {
    extend(PusherClient, superClass);

    PusherClient.include(Spine.Events);

    PusherClient.HOST = "pusher.periscopedata.com";

    PusherClient.prototype.release = function() {
      return this.unbind();
    };

    function PusherClient(fetcher) {
      this.fetcher = fetcher;
      this.webSocketDataMessage = bind(this.webSocketDataMessage, this);
      this.webSocketError = bind(this.webSocketError, this);
      this.usePusher = true;
      this.initWebSocket();
    }

    PusherClient.prototype.remoteAddHash = function(hashKey) {
      return this.pusherSocketCall('Pusher.AddHash', hashKey);
    };

    PusherClient.prototype.remoteRemoveHash = function(hashKey) {
      return this.pusherSocketCall('Pusher.RemoveHash', hashKey);
    };

    PusherClient.prototype.initWebSocket = function() {
      var email, hash, i, len, ref, ref1, ref2, results;
      if (!this.usePusher) {
        return;
      }
      email = (ref = App.User.currentUser()) != null ? ref.email_address : void 0;
      this.pusherSocket = new $.JsonRpcClient({
        socketUrl: "wss://" + PusherClient.HOST + "/conn?email=" + email + "&uuid=" + ((ref1 = AppRedesign.current()) != null ? ref1.uuid : void 0),
        onmessage: this.webSocketDataMessage
      });
      ref2 = this.fetcher.pendingHashes.keys();
      results = [];
      for (i = 0, len = ref2.length; i < len; i++) {
        hash = ref2[i];
        results.push(this.remoteAddHash(hash));
      }
      return results;
    };

    PusherClient.prototype.webSocketError = function(r) {
      var ref;
      try {
        if ((ref = this.pusherSocket) != null) {
          ref._wsSocket.close();
        }
      } catch (error) {
        false;
      }
      return this.pusherSocket = null;
    };

    PusherClient.prototype.webSocketSuccess = function(r) {};

    PusherClient.prototype.webSocketDataMessage = function(m) {
      var retObj;
      if (!m.data) {
        return;
      }
      retObj = JSON.parse(m.data);
      if (retObj.error) {
        this.webSocketError(retObj.error);
      }
      if (retObj.hash_key) {
        return this.trigger('source-pushed', retObj.hash_key);
      }
    };

    PusherClient.prototype.pusherSocketCall = function(f, hashKey) {
      var ref;
      if (!this.usePusher) {
        return;
      }
      if (PusherClient.authToken == null) {
        return;
      }
      if (!this.pusherSocket) {
        this.initWebSocket();
      }
      return this.pusherSocket.call(f, [
        {
          Uuid: (ref = AppRedesign.current()) != null ? ref.uuid : void 0,
          HashKey: hashKey,
          AuthToken: PusherClient.authToken
        }
      ], this.webSocketSuccess, this.webSocketError);
    };

    return PusherClient;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.QueryRunner = (function(superClass) {
    extend(QueryRunner, superClass);

    QueryRunner.include(Spine.Events);

    QueryRunner.DEFAULT_SQL_LIMIT = '5000';

    function QueryRunner(helper) {
      this.helper = helper;
      this.waitForData = bind(this.waitForData, this);
      this.cancelLastQueryResponse = bind(this.cancelLastQueryResponse, this);
      this.onFail = bind(this.onFail, this);
      this.onSuccess = bind(this.onSuccess, this);
      QueryRunner.__super__.constructor.apply(this, arguments);
    }

    QueryRunner.prototype.runQuery = function(sql, limit, item, runPreviewAndFullSql) {
      var queryData;
      queryData = {
        query: sql,
        sql_limit: limit,
        database_id: this.helper.database().id,
        client_site_id: App.Site.first().id
      };
      if (item instanceof App.Widget) {
        _.assign(queryData, {
          dashboard_id: App.Dashboard.currentDashboard().id,
          udv_id: App.UserDataView.currentId()
        });
      } else {
        _.assign(queryData, {
          no_filters: true
        });
      }
      if (!item.isNew()) {
        queryData.item_id = item.id;
      }
      queryData.item_type = item.constructor.className;
      if (item instanceof App.Widget && (item.drag_drop_config != null)) {
        queryData.drag_drop_config = JSON.stringify(item.drag_drop_config);
      }
      if (runPreviewAndFullSql) {
        queryData.query_type = 'preview_and_full_sql';
      }
      if (this.duplicateRequest(queryData)) {
        return;
      }
      return jQuery.ajax({
        url: "/query_result",
        type: 'POST',
        data: queryData,
        dataType: 'json'
      }).done((function(_this) {
        return function(r) {
          return _this.onSuccess(r);
        };
      })(this)).fail((function(_this) {
        return function(r) {
          return _this.onFail(r);
        };
      })(this));
    };

    QueryRunner.prototype.onSuccess = function(response) {
      if (response.hash_key != null) {
        delete this.prevQueryData;
        this.lastRequestId = response.request_id;
        this.lastHashKey = response.hash_key;
        return this.waitForData(response);
      } else {
        return this.trigger('error', 'Error running query, please try again.');
      }
    };

    QueryRunner.prototype.onFail = function(response) {
      if (response.status === 400 && response.responseJSON.errorCode === 'requires_cache_enabled') {
        delete this.prevQueryData;
        return this.trigger('error', '--no_cache has been disabled for your account. Remove --no_cache and re-run your query.');
      } else {
        return this.trigger('error', 'Error running query, please try again.');
      }
    };

    QueryRunner.prototype.cancelLastQuery = function(cancelRequestId, cancelHashKey) {
      var data;
      if (cancelRequestId == null) {
        return;
      }
      data = {
        request_id: cancelRequestId,
        hash_key: cancelHashKey,
        client_site_id: App.Site.first().id
      };
      return jQuery.ajax({
        url: "/source_update_requests/cancel_one",
        type: 'PUT',
        data: data,
        dataType: 'json'
      }).always(((function(_this) {
        return function(r) {
          return _this.cancelLastQueryResponse(r);
        };
      })(this)));
    };

    QueryRunner.prototype.cancelLastQueryResponse = function(response) {
      if (!response.success) {
        return AppRedesign.logError(new Error("Error canceling query, site_id:" + App.Site.first().id + ", source_update_requests id:" + this.lastRequestId));
      }
    };

    QueryRunner.prototype.waitForData = function(response) {
      this.info_and_warnings = response.info_and_warnings;
      this.hash_key = response.hash_key;
      this.trigger('update', this.hash_key);
      return App.fetchSourceHighPriority(this.hash_key, App.SourceFetcher.QUERY_INTERACTIVE);
    };

    QueryRunner.prototype.duplicateRequest = function(queryData) {
      var dupe;
      dupe = this.prevQueryData === this.serializeQueryData(queryData);
      this.prevQueryData = this.serializeQueryData(queryData);
      return dupe;
    };

    QueryRunner.prototype.serializeQueryData = function(data) {
      return data.query + ":" + data.database_id + ":" + data.udv_id;
    };

    return QueryRunner;

  })(Spine.Module);

}).call(this);
(function() {
  App.ReactBridge = (function() {
    function ReactBridge() {}

    ReactBridge.initializeOnPageLoad = function() {
      var initialReduxStoreState, ref, ref1, ref2, ref3;
      if (!window.reactApp) {
        return;
      }
      initialReduxStoreState = {
        app: this.appState(),
        topics: {
          listViewTopicIds: ((ref = App.User.currentUser()) != null ? (ref1 = ref.preferences) != null ? ref1.list_view_topic_ids : void 0 : void 0) || []
        },
        navigation: {
          leftMenuSortBy: (ref2 = App.User.currentUser()) != null ? (ref3 = ref2.preferences) != null ? ref3.left_menu_sort_by : void 0 : void 0
        }
      };
      return window.reactApp.initializeOnPageLoad(initialReduxStoreState, this.reactModalEl(), this.reactMainViewportEl());
    };

    ReactBridge.appState = function() {
      var ref, ref1, ref10, ref11, ref12, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, site;
      site = App.Site.first();
      return {
        autoArchiveEnabled: site.auto_archive_enabled,
        cacheEnabled: site.cache_enabled || site.cached_site,
        cachedSite: site.cached_site,
        clientSiteId: site.id,
        colorThemesEnabled: (ref = AppRedesign.current()) != null ? ref.colorThemesEnabled : void 0,
        currentUserId: App.User.currentUserId(),
        currentUserIsAdmin: (ref1 = App.User.currentUser()) != null ? ref1.isAdmin() : void 0,
        currentUserIsSiteAdmin: (ref2 = App.User.currentUser()) != null ? ref2.isSiteAdmin() : void 0,
        currentUserCanEdit: (ref3 = App.User.currentUser()) != null ? ref3.canEdit() : void 0,
        currentUserCanExplore: (ref4 = App.User.currentUser()) != null ? ref4.canExplore() : void 0,
        currentUserHasMultipleSites: App.User.currentUserHasMultipleSites(),
        customerExperiments: (ref5 = AppRedesign.current()) != null ? ref5.customerExperiments : void 0,
        customerUnification: AppRedesign.hasCustomerUnification(),
        dashboardOrganizationEnabled: AppRedesign.dashboardOrganizationEnabled(),
        roleLevelAccessEnabled: site.role_level_access_enabled,
        dashboardRefreshV1Enabled: site.isDashboardRefreshV1Enabled(),
        dashboardRefreshV2Enabled: site.isDashboardRefreshV2Enabled(),
        displayTimezone: site.display_timezone,
        dragDropCalculatedFieldsEnabled: AppRedesign.dragDropCalculatedFieldsEnabled(),
        herokuReleaseVersion: (ref6 = AppRedesign.current()) != null ? ref6.herokuReleaseVersion : void 0,
        initialItem: this.initialItem(),
        magicLDemoModeEnabled: (ref7 = AppRedesign.current()) != null ? ref7.magicLDemoModeEnabled : void 0,
        deepAnalysisCodeLanguagesAndVersions: (ref8 = AppRedesign.current()) != null ? ref8.deepAnalysisCodeLanguagesAndVersions : void 0,
        rbacDisallowCopyAllPrivileges: site.isAccountFeatureSettingEnabled('rbac-disallow-copy-all-privileges'),
        rbacEnabled: (ref9 = AppRedesign.current()) != null ? ref9.state.RbacEnabled : void 0,
        siteHost: site.host,
        siteName: site.display_name,
        skipForUnusedEnabled: site.isSkipForUnusedEnabled(),
        summaryStatsEnabled: site.summary_stats_enabled,
        tvMode: (ref10 = AppRedesign.current()) != null ? ref10.tvmode : void 0,
        usesExplicitCache: site.uses_explicit_cache,
        uuid: (ref11 = AppRedesign.current()) != null ? ref11.uuid : void 0,
        warehouseEnabled: site.warehouse_enabled,
        versionControlEnabled: site.version_control_enabled,
        slackEnabled: (ref12 = AppRedesign.current()) != null ? ref12.state.SlackEnabled : void 0,
        allowRevokingWorkbooksAccess: AppRedesign.allowRevokingWorkbooksAccess()
      };
    };

    ReactBridge.initialItem = function() {
      var ref;
      if ((typeof app !== "undefined" && app !== null ? (ref = app.state) != null ? ref.initial_item_type : void 0 : void 0) === 'Topic') {
        return {
          item_type: app.state.initial_item_type,
          item_id: app.state.initial_item_id
        };
      }
    };

    ReactBridge.reactModalEl = function() {
      return document.querySelector('#modals-react');
    };

    ReactBridge.reactMainViewportEl = function() {
      return document.querySelector('#main-viewport-react');
    };

    return ReactBridge;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  App.ReactRoot = (function(superClass) {
    extend(ReactRoot, superClass);

    function ReactRoot() {
      var ref, ref1;
      ReactRoot.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'name', 'params');
      this.html("<div class=\"react-root\"></div>");
      if ((ref = window.reactApp) != null ? ref[this.name] : void 0) {
        this.reactRoot = (ref1 = window.reactApp)[this.name].apply(ref1, [this.el[0]].concat(slice.call(this.params)));
      } else {
        throw "Missing react root: " + this.name;
      }
    }

    ReactRoot.prototype.release = function() {
      var ref;
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return ReactRoot.__super__.release.apply(this, arguments);
    };

    ReactRoot.create = function(args) {
      return new App.ReactRoot(args);
    };

    return ReactRoot;

  })(Spine.Controller);

}).call(this);
(function() {
  App.Recoverator = (function() {
    function Recoverator() {}

    Recoverator.prototype.get = function(key) {
      if (!this.supportsStorage()) {
        return;
      }
      this.loadState();
      return this.getState()[key];
    };

    Recoverator.prototype.set = function(key, value) {
      if (!this.supportsStorage()) {
        return;
      }
      this.loadState();
      this.getState()[key] = value;
      this.saveState();
      return null;
    };

    Recoverator.prototype.appendToList = function(key, value) {
      var list;
      if (!this.supportsStorage()) {
        return;
      }
      list = this.get(key) || [];
      list.push(value);
      return this.set(key, list);
    };

    Recoverator.prototype.addToSet = function(key, value) {
      var list;
      if (!this.supportsStorage()) {
        return;
      }
      list = this.get(key) || [];
      if (_.includes(list, value)) {
        return;
      }
      list.push(value);
      return this.set(key, list);
    };

    Recoverator.prototype.clear = function(key) {
      if (!this.supportsStorage()) {
        return;
      }
      this.loadState();
      delete this.getState()[key];
      this.saveState();
      return null;
    };

    Recoverator.prototype.getState = function() {
      return this.state[this.currentUserId()][this.currentSiteId()];
    };

    Recoverator.prototype.loadState = function() {
      var base, base1, name, name1, periscopeState;
      periscopeState = App.LocalStorage.getItem('periscopeState');
      if (periscopeState) {
        this.state = (function() {
          try {
            return JSON.parse(periscopeState);
          } catch (error) {
            return null;
          }
        })();
      }
      this.state || (this.state = {});
      (base = this.state)[name = this.currentUserId()] || (base[name] = {});
      (base1 = this.state[this.currentUserId()])[name1 = this.currentSiteId()] || (base1[name1] = {});
      return this;
    };

    Recoverator.prototype.saveState = function() {
      return App.LocalStorage.setItem('periscopeState', JSON.stringify(this.state));
    };

    Recoverator.prototype.supportsStorage = function() {
      return typeof Storage !== "undefined";
    };

    Recoverator.prototype.currentSiteId = function() {
      var ref;
      return ((ref = App.Site.first()) != null ? ref.id : void 0) || 0;
    };

    Recoverator.prototype.currentUserId = function() {
      return App.User.safeCurrentUser().id || 0;
    };

    return Recoverator;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignChartTooltip = (function() {
    function RedesignChartTooltip(twiddles1, allSeriesDataByName) {
      this.twiddles = twiddles1;
      this.allSeriesDataByName = allSeriesDataByName != null ? allSeriesDataByName : {};
      this.makeTooltipHtml = bind(this.makeTooltipHtml, this);
      this.detailColumns = this.twiddles.get('detail_columns') || [];
      this.detailSeries = this.twiddles.get('detail_series') || [];
    }

    RedesignChartTooltip.prototype.makeTooltipHtml = function(entries) {
      var o;
      o = this.makeTooltipOptions(entries[0]);
      return RedesignChartTooltip.makeTooltipHtml(o.xLabel, o.formattedVal, o.seriesName, o.showSeriesName, o.seriesColor, o.details);
    };

    RedesignChartTooltip.prototype.makeTooltipOptions = function(entry) {
      var dataPointIdx, details, formatOverride, formattedTotal, formattedVal, isBubble, options, p, s, seriesName, total_name, unformattedX, xLabel, yLabel;
      p = entry.dataPoint;
      s = entry.dataSeries;
      unformattedX = p.label || p.otherLabel || p.x;
      xLabel = RedesignChartTooltip.formatX(unformattedX, this.twiddles);
      yLabel = p.percentage || p.y;
      formattedVal = p.z != null ? p.z : yLabel;
      if (s.type === 'pie') {
        seriesName = p.seriesName;
        dataPointIdx = 0;
      } else {
        seriesName = s.name;
        dataPointIdx = entry.index;
      }
      formatOverride = this.twiddles.get('values_format_original');
      details = this.buildDetails(seriesName, p.originalRowList, dataPointIdx, s._options._formatter, formatOverride);
      if (p.total != null) {
        total_name = 'total';
        if (this.twiddles.get('column_names').includesIgnoreCase('total')) {
          total_name = 'periscope_total';
        }
        if (this.twiddles.get('titleize_all_labels')) {
          total_name = total_name.titleize();
        }
        formattedTotal = s._options._formatter.formatValue(p.total, formatOverride);
        details.push([total_name, formattedTotal]);
      }
      isBubble = s.type === 'bubble';
      if ((p.z != null) || isBubble) {
        formattedVal = "" + formattedVal;
      } else if (s.type === 'pie') {
        formattedVal = s._options._formatter.formatValueForPieChart(formattedVal);
      } else {
        formattedVal = s._options._formatter.formatValue(formattedVal, null);
      }
      options = {
        xLabel: (p.z != null) || isBubble ? xLabel + ", " + (s._options._formatter.formatValue(yLabel)) : xLabel,
        formattedVal: formattedVal,
        seriesName: this.twiddles.getForSeries(s.name, 'display_name') || s.name,
        seriesColor: this.colorForEntry(entry),
        showSeriesName: this.twiddles.getForSeries(s.name, 'name_visible'),
        details: details
      };
      return options;
    };

    RedesignChartTooltip.prototype.buildDetails = function(seriesName, row, dataPointIdx, formatter, formatOverride) {
      var col, details, i, j, k, l, len, len1, len2, len3, len4, m, originRow, originRowList, originYVal, ref, ref1, ref2, ref3, ref4, seriesDisplayName, siblingPoint, value, valueCols;
      details = [];
      valueCols = [];
      if (this.twiddles.get('value_cols')) {
        ref = this.twiddles.get('value_cols');
        for (i = 0, len = ref.length; i < len; i++) {
          col = ref[i];
          if (this.twiddles.getForSeries(col, 'show_on_primary_axis')) {
            valueCols.push(col);
          }
        }
      }
      originRowList = row[seriesName] || {};
      ref1 = this.detailColumns;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        col = ref1[j];
        for (k = 0, len2 = originRowList.length; k < len2; k++) {
          originRow = originRowList[k];
          if (originRow[col] != null) {
            value = originRow[col];
            if (valueCols.includes(col)) {
              value = formatter.formatValue(value, formatOverride);
            }
            details.push([col, value]);
          }
        }
      }
      ref2 = this.detailSeries;
      for (l = 0, len3 = ref2.length; l < len3; l++) {
        seriesName = ref2[l];
        siblingPoint = (ref3 = this.allSeriesDataByName[seriesName]) != null ? ref3[dataPointIdx] : void 0;
        if (!siblingPoint) {
          continue;
        }
        seriesDisplayName = this.twiddles.getForSeries(seriesName, 'display_name') || seriesName;
        if ((siblingPoint.originalPoints != null) && siblingPoint.originalPoints[seriesName]) {
          ref4 = siblingPoint.originalPoints[seriesName];
          for (m = 0, len4 = ref4.length; m < len4; m++) {
            originYVal = ref4[m];
            value = formatter.formatValue(originYVal, formatOverride);
            details.push([seriesDisplayName, value]);
          }
        } else {
          value = formatter.formatValue(siblingPoint.y, formatOverride);
          details.push([seriesDisplayName, value]);
        }
      }
      return details;
    };

    RedesignChartTooltip.prototype.colorForEntry = function(entry) {
      if (entry.dataSeries.type === 'pie') {
        return entry.dataPoint.color;
      } else {
        return entry.dataSeries.color;
      }
    };

    RedesignChartTooltip.formatX = function(x, twiddles) {
      var moment;
      if (twiddles.get('x_axis_type') === App.Chartographer.TIMESERIES_AXIS_TYPE) {
        moment = App.TimeMachine.timestampToMoment(x, twiddles.get('timezone'));
        return App.TimeMachine.formatMomentAsAggregation(moment, twiddles.get('aggregation'));
      }
      return x;
    };

    RedesignChartTooltip.makeTooltipHtml = function(x, y, seriesName, showSeriesName, seriesColor, details) {
      var formattedDetails;
      formattedDetails = details;
      return JST['app/views/redesign/tooltip/chart_tooltip']({
        yVal: y,
        xVal: x,
        seriesColor: seriesColor,
        seriesLabel: showSeriesName ? seriesName : '',
        details: formattedDetails.isEmpty() ? null : formattedDetails
      });
    };

    return RedesignChartTooltip;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.RedesignRearrangerSizer = (function(superClass) {
    extend(RedesignRearrangerSizer, superClass);

    function RedesignRearrangerSizer(dash, viewController) {
      RedesignRearrangerSizer.__super__.constructor.call(this, dash);
      this.viewController = viewController;
      this.REARRANGER_ROW_HEIGHT = 8;
      this.REARRANGER_COLUMN_WIDTH = 8;
      this.REARRANGER_BUFFER_ROWS = 30;
      this.HEIGHT_OFFSET = 112;
    }

    RedesignRearrangerSizer.prototype.columnWidth = function() {
      return this.REARRANGER_COLUMN_WIDTH;
    };

    RedesignRearrangerSizer.prototype.bufferRowsAvailable = function(currentRows) {
      var height, spaceAvailable;
      height = $('.dialog.modal').height() - this.HEIGHT_OFFSET;
      spaceAvailable = height - (currentRows * this.rowHeight());
      return Math.floor(spaceAvailable / this.rowHeight());
    };

    RedesignRearrangerSizer.prototype.rowHeight = function() {
      return this.REARRANGER_ROW_HEIGHT;
    };

    RedesignRearrangerSizer.prototype.maxWidthForScreen = function() {
      return App.RedesignRearrangerSizer.screenSize() - App.RedesignDashboardRearranger.EDGE_PADDING * 2;
    };

    RedesignRearrangerSizer.screenSize = function() {
      if (RedesignRearrangerSizer._width == null) {
        RedesignRearrangerSizer.maybeBindResize();
        RedesignRearrangerSizer._width = $('.dashboard-rearranger .grid-area').width();
      }
      return RedesignRearrangerSizer._width;
    };

    RedesignRearrangerSizer.prototype.screenMargin = function() {
      return 0;
    };

    return RedesignRearrangerSizer;

  })(App.RedesignDashboardSizer);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.RedesignSqlTooltipHelper = (function() {
    function RedesignSqlTooltipHelper() {
      this.hideTooltip = bind(this.hideTooltip, this);
    }

    RedesignSqlTooltipHelper.prototype.release = function() {
      var ref;
      return (ref = this.tooltip) != null ? ref.release() : void 0;
    };

    RedesignSqlTooltipHelper.prototype.mouseEnterKw = function(evt) {
      var obj, objId;
      obj = this.tooltipTargetFromCodemirrorSpan(evt.currentTarget);
      if (!obj) {
        return;
      }
      objId = obj.constructor.className + ":" + obj.id;
      if (objId === this.lastObjId) {
        return;
      }
      this.lastObjId = objId;
      clearTimeout(this.hideTimeout);
      clearTimeout(this.showTimeout);
      if (this.tooltip == null) {
        this.tooltip = new App.SuperTooltipController({
          offsetLeft: 10
        });
      }
      return this.showTimeout = setTimeout(((function(_this) {
        return function() {
          return _this.tooltip.show(obj, $(evt.currentTarget));
        };
      })(this)), App.SuperTooltipController.SHOW_DELAY_MS);
    };

    RedesignSqlTooltipHelper.prototype.tooltipTargetFromCodemirrorSpan = function(el) {
      var objClass, snipName, targetText;
      el = $(el);
      targetText = el.text().replace('[', '').replace(']', '');
      snipName = "[" + (App.SqlSnippet.extractNameFromCall(targetText)) + "]";
      objClass = (function() {
        switch (false) {
          case !el.hasClass('cm-sql-view'):
            return App.SqlView;
          case !el.hasClass('cm-csv-view'):
            return App.CsvView;
          case !el.hasClass('cm-snippet'):
            return App.SqlSnippet;
        }
      })();
      return objClass.matches(snipName);
    };

    RedesignSqlTooltipHelper.prototype.hideTooltip = function(fadeTime) {
      return this.hideTimeout = setTimeout(((function(_this) {
        return function() {
          var ref;
          if ((ref = _this.tooltip) != null) {
            ref.hide();
          }
          _this.lastObjId = null;
          clearTimeout(_this.hideTimeout);
          return clearTimeout(_this.showTimeout);
        };
      })(this)), App.SuperTooltipController.HIDE_DELAY_MS);
    };

    return RedesignSqlTooltipHelper;

  })();

}).call(this);
(function() {
  App.RouteHelper = (function() {
    function RouteHelper() {}

    RouteHelper.ROUTED_CLASSES = ['Archive', 'Dashboard', 'SqlView', 'CsvView', 'SqlSnippet', 'SqlAlert', 'Settings', 'Site', 'Explore'];

    RouteHelper.initialRoute = function(state) {
      var dashboard, initialSettings, options, route, widget;
      options = {
        replace: true
      };
      dashboard = App.Dashboard.currentDashboard();
      if (dashboard) {
        Object.assign(options, {
          init: {
            id: "" + dashboard.id,
            name: dashboard.name,
            guid: dashboard.guid
          }
        });
      }
      if (state.initial_route) {
        route = state.initial_route;
        options = Object.assign(route.options, options);
        window.reactApp.navigate(route.routeId, route.params, options);
        return;
      }
      if (state.initial_linked_widget_id) {
        widget = App.Widget.exists(state.initial_linked_widget_id);
        if (widget) {
          App.RouteHelper.navigateTo('Widget', widget, options);
          return;
        }
      }
      if (state.initial_settings) {
        route = App.LeftMenuSettings.allowedRoutes()[state.initial_settings];
        initialSettings = route && route.controller && App[route.controller];
        if (initialSettings === App.RedesignSettingsAccountController) {
          App.RouteHelper.navigateTo('Settings', initialSettings, {
            init: true
          });
          return;
        } else if (initialSettings) {
          App.Dashboard.bind('schemas-loaded', function() {
            return App.RouteHelper.navigateTo('Settings', initialSettings, options);
          });
          return;
        }
      }
      return App.RouteHelper.navigateTo('Dashboard', App.Dashboard.currentDashboard(), options);
    };

    RouteHelper.navigateTo = function(itemClass, item, options) {
      var dashboard, params, routeId;
      if (item == null) {
        item = {};
      }
      if (options == null) {
        options = {};
      }
      if ((typeof window !== "undefined" && window !== null ? window.test_mode : void 0) || AppRedesign.current().shared_mode) {
        return;
      }
      if (!(this.ROUTED_CLASSES.includes(itemClass) || options.init)) {
        return;
      }
      if (item != null ? typeof item.isArchived === "function" ? item.isArchived() : void 0 : void 0) {
        return;
      }
      routeId = itemClass;
      params = {};
      if (item.id) {
        Object.assign(params, {
          id: "" + item.id
        });
      }
      if (item.guid) {
        Object.assign(params, {
          guid: item.guid
        });
      }
      if (item.name) {
        Object.assign(params, {
          name: item.name
        });
      }
      if (routeId === 'Widget') {
        dashboard = item.dashboard();
        Object.assign(params, {
          name: item.getName(),
          dashboardId: dashboard.id,
          dashboardName: dashboard.name
        });
      }
      if (routeId === 'Archive') {
        Object.assign(params, {
          className: item.class_name || item.className
        });
      }
      if (routeId === 'Settings') {
        Object.assign(params, {
          name: item.TITLE,
          id: App.LeftMenuSettings.controllerToRouteName(item)
        });
      }
      if (routeId === 'Site') {
        if (typeof item === 'string') {
          Object.assign(params, {
            siteHost: item
          });
        }
      }
      window.reactApp.navigate(routeId, params, options);
      return true;
    };

    RouteHelper.navigateToPrev = function(options) {
      return window.reactApp.navigateToPrev(options || {});
    };

    return RouteHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.SalesforceLiveChat = (function() {
    function SalesforceLiveChat() {
      this.update = bind(this.update, this);
      this.init = bind(this.init, this);
      this.initialized = false;
    }

    SalesforceLiveChat.prototype.init = function() {
      var ref;
      if (!this.featureEnabled()) {
        return false;
      }
      if (this.initialized) {
        return false;
      }
      this.initialized = true;
      this.site = App.Site.first();
      this.user = App.User.currentUser();
      if (!((ref = this.user) != null ? ref.id : void 0)) {
        return false;
      }
      this.appendToPage();
      return true;
    };

    SalesforceLiveChat.prototype.featureEnabled = function() {
      return Features.enabled('salesforce_live_chat');
    };

    SalesforceLiveChat.prototype.appendToPage = function() {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      return jQuery(document.body).append(JST['app/views/salesforce_live_chat']({
        firstName: this.user.first_name,
        lastName: this.user.last_name,
        email: this.user.email_address,
        salesforceEmbeddedSvcBaseUrl: (ref = AppRedesign.current()) != null ? ref.state.SalesforceEmbeddedSvcBaseUrl : void 0,
        salesforceEmbeddedSvcSurveyUrl: (ref1 = AppRedesign.current()) != null ? ref1.state.SalesforceEmbeddedSvcSurveyUrl : void 0,
        salesforceEmbeddedSvcCode: (ref2 = AppRedesign.current()) != null ? ref2.state.SalesforceEmbeddedSvcCode : void 0,
        salesforceEmbeddedSvcBaseLiveAgentContentUrl: (ref3 = AppRedesign.current()) != null ? ref3.state.SalesforceEmbeddedSvcBaseLiveAgentContentUrl : void 0,
        salesforceEmbeddedSvcDeploymentId: (ref4 = AppRedesign.current()) != null ? ref4.state.SalesforceEmbeddedSvcDeploymentId : void 0,
        salesforceEmbeddedSvcButtonId: (ref5 = AppRedesign.current()) != null ? ref5.state.SalesforceEmbeddedSvcButtonId : void 0,
        salesforceEmbeddedSvcBaseLiveAgentUrl: (ref6 = AppRedesign.current()) != null ? ref6.state.SalesforceEmbeddedSvcBaseLiveAgentUrl : void 0,
        salesforceEmbeddedSvcSrcAttribute: (ref7 = AppRedesign.current()) != null ? ref7.state.SalesforceEmbeddedSvcSrcAttribute : void 0
      }));
    };

    SalesforceLiveChat.prototype.update = function() {};

    SalesforceLiveChat.prototype.relogin = function() {};

    return SalesforceLiveChat;

  })();

}).call(this);
(function() {
  App.Searchotron = (function() {
    Searchotron.TOKENIZE_REGEX = /[- ,\/.]+/g;

    function Searchotron(columns, rows) {
      this.columns = columns;
      this.rows = rows;
      this.index = {};
      this.indexTokens = [];
      this.allTokens = null;
    }

    Searchotron.prototype.initializeIndexOnce = function() {
      if (this.allTokens == null) {
        return this.createIndex();
      }
    };

    Searchotron.prototype.createIndex = function() {
      var column, i, j, l, len, len1, len2, ref, ref1, row, rowIndex, token, tokens, val;
      this.allTokens = [];
      ref = this.rows;
      for (rowIndex = i = 0, len = ref.length; i < len; rowIndex = ++i) {
        row = ref[rowIndex];
        ref1 = this.columns;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          column = ref1[j];
          val = row[column];
          if ((val != null ? val.val : void 0) != null) {
            val = val.val;
          }
          val = '' + (val || '');
          tokens = Searchotron.tokenize(val);
          for (l = 0, len2 = tokens.length; l < len2; l++) {
            token = tokens[l];
            if (token === '') {
              continue;
            }
            if (!this.index.hasOwnProperty(token)) {
              this.index[token] = [];
            }
            this.index[token].push(rowIndex);
            this.allTokens.push(token);
          }
        }
      }
      return this.indexTokens = App.Utils.fastUnique(this.allTokens);
    };

    Searchotron.prototype.search = function(query) {
      var _, completelyMatchingRows, i, j, k, l, len, len1, len2, matchCountByRow, matchingRows, queryToken, queryTokens, ref, ref1, row, rowToken, t1, v;
      this.initializeIndexOnce();
      t1 = AppRedesign.timestamp();
      matchCountByRow = {};
      queryTokens = Searchotron.tokenize(query);
      queryTokens = App.Utils.fastUnique(queryTokens.filter(function(t) {
        return t !== '';
      }));
      for (i = 0, len = queryTokens.length; i < len; i++) {
        queryToken = queryTokens[i];
        matchingRows = {};
        ref = this.indexTokens;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          rowToken = ref[j];
          if (rowToken.substring(0, queryToken.length) !== queryToken) {
            continue;
          }
          ref1 = this.index[rowToken];
          for (l = 0, len2 = ref1.length; l < len2; l++) {
            row = ref1[l];
            matchingRows[row] = true;
          }
        }
        for (k in matchingRows) {
          _ = matchingRows[k];
          matchCountByRow[k] || (matchCountByRow[k] = 0);
          matchCountByRow[k] += 1;
        }
      }
      completelyMatchingRows = {};
      for (k in matchCountByRow) {
        v = matchCountByRow[k];
        if (v === queryTokens.length) {
          completelyMatchingRows[k] = true;
        }
      }
      return completelyMatchingRows;
    };

    Searchotron.tokenize = function(string) {
      var i, len, realTokens, token, tokens;
      tokens = string.toLowerCase().replace(Searchotron.TOKENIZE_REGEX, ' ').split(' ');
      realTokens = [];
      for (i = 0, len = tokens.length; i < len; i++) {
        token = tokens[i];
        if (token !== '') {
          realTokens.push(token);
        }
      }
      return realTokens;
    };

    return Searchotron;

  })();

}).call(this);
(function() {
  App.SeriesFormatter = (function() {
    SeriesFormatter.PERCENT = 'percent';

    SeriesFormatter.DOLLAR = 'dollar';

    SeriesFormatter.NUMBER = 'number';

    SeriesFormatter.CURRENCY = 'currency';

    SeriesFormatter.DEFAULT_VALUE_FORMAT = SeriesFormatter.NUMBER;

    SeriesFormatter.EURO = 'euro';

    SeriesFormatter.POUND = 'pound';

    SeriesFormatter.KRW = 'won';

    SeriesFormatter.INR = 'rupee';

    SeriesFormatter.SEK = 'SEK';

    SeriesFormatter.TRY = 'TRY';

    SeriesFormatter.CURRENCY_SYMBOL = {};

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.EURO] = '€';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.DOLLAR] = '$';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.POUND] = '£';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.KRW] = '₩';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.INR] = '₹';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.SEK] = 'kr';

    SeriesFormatter.CURRENCY_SYMBOL[SeriesFormatter.TRY] = '₺';

    function SeriesFormatter(series, twiddles) {
      this.valueFormat = this.constructor.valueFormatForAxis(series, twiddles);
      this.currencyType = twiddles.get('currency') || App.Tooltip.DOLLAR;
      this.chartType = series.chartType;
      this.timezone = twiddles.get('timezone');
    }

    SeriesFormatter.prototype.formatValue = function(y, formatOverride) {
      var format, sigFigs, symbol;
      if (formatOverride == null) {
        formatOverride = null;
      }
      if (!$.isNumeric(y)) {
        return y;
      }
      format = formatOverride || this.valueFormat;
      switch (format) {
        case 'string':
          return y;
        case App.Tooltip.DOLLAR:
          symbol = App.Tooltip.CURRENCY_SYMBOL[this.currencyType];
          return App.Utils.formatDollarsAsString(y, {
            symbol: symbol
          });
        case App.Tooltip.PERCENT:
          if (y > 1) {
            sigFigs = 2 + Math.floor(y).toString().length;
          } else {
            sigFigs = 2;
          }
          return App.Utils.roundToSignificantDigits(y * 100.0, sigFigs).commaDelimit() + "%";
      }
      if (Math.abs(y) < 1 || Math.abs(y) >= 10000) {
        return App.Utils.formatNumWithPrecision(y, 3);
      }
      return App.Utils.formatNumWithPrecision(y, 5);
    };

    SeriesFormatter.prototype.formatValueForPieChart = function(y) {
      var sigFigs;
      if (!$.isNumeric(y)) {
        return y;
      }
      if (this.valueFormat !== App.Tooltip.PERCENT) {
        return this.formatValue(y);
      }
      if (y > 1) {
        sigFigs = 2 + Math.floor(y).toString().length;
        return App.Utils.roundToSignificantDigits(y * 100.0, sigFigs).commaDelimit() + "%";
      } else {
        return App.Utils.displayRoundedPercentage(y, 3).commaDelimit() + "%";
      }
    };

    SeriesFormatter.prototype.formatValueNoRounding = function(y) {
      var symbol;
      switch (this.valueFormat) {
        case 'string':
          return y;
        case App.Tooltip.DOLLAR:
          symbol = App.Tooltip.CURRENCY_SYMBOL[this.currencyType];
          return App.Utils.formatDollarsAsString(y, {
            symbol: symbol,
            do_not_round: true
          });
        case App.Tooltip.PERCENT:
          return App.Utils.roundToSignificantDigits(y * 100.0, 12).commaDelimit() + "%";
        default:
          return y.commaDelimit();
      }
    };

    SeriesFormatter.valueFormatForAxis = function(series, twiddles) {
      var format, i, len, ref;
      switch (twiddles.get('value_column_type')) {
        case 'string':
        case 'datetime':
          return 'string';
        default:
          ref = [App.Tooltip.PERCENT, App.Tooltip.DOLLAR, App.Tooltip.NUMBER];
          for (i = 0, len = ref.length; i < len; i++) {
            format = ref[i];
            if (twiddles.getForSeries(series.name, 'values_format') === format) {
              return format;
            }
          }
          return App.Tooltip.DEFAULT_VALUE_FORMAT;
      }
    };

    return SeriesFormatter;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    slice = [].slice;

  App.SetUpScreenshotMode = (function() {
    SetUpScreenshotMode.TIMEOUT_MS = 45 * 1000;

    SetUpScreenshotMode.PAUSE_PERIOD_MS = 1000;

    SetUpScreenshotMode.CHART_REDRAW_DELAY_MS = 100;

    SetUpScreenshotMode.window = function() {
      return window;
    };

    SetUpScreenshotMode.inScreenshotMode = function() {
      return this.screenshotModeInUrl() && this.isPhantomJS();
    };

    SetUpScreenshotMode.inUrl = function(str) {
      return _.includes(AppRedesign.windowLocation().search, str);
    };

    SetUpScreenshotMode.screenshotModeInUrl = function() {
      return this.inUrl('screenshot=true');
    };

    SetUpScreenshotMode.directPdfModeInUrl = function() {
      return this.inUrl('directPdfMode=true');
    };

    SetUpScreenshotMode.slackModeInUrl = function() {
      return this.inUrl('slack=true');
    };

    SetUpScreenshotMode.widgetInUrl = function() {
      return this.inUrl('widget=');
    };

    SetUpScreenshotMode.isFakePhantomJs = function() {
      return this.inUrl('fakephantomjs=true');
    };

    SetUpScreenshotMode.isPhantomJS = function() {
      return typeof (this.window().callPhantom) === 'function' || this.isFakePhantomJs();
    };

    SetUpScreenshotMode.fontsReady = function(callback) {
      return $(this.window()).on('load', callback);
    };

    SetUpScreenshotMode.call = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(this, args, function(){}).call();
    };

    function SetUpScreenshotMode(app, dashboardSizer) {
      this.app = app;
      this.dashboardSizer = dashboardSizer;
      this.takeScreenshot = bind(this.takeScreenshot, this);
      this.takeScreenshotWithArbitraryDelayToEnsureOverlayTextRenders = bind(this.takeScreenshotWithArbitraryDelayToEnsureOverlayTextRenders, this);
      this.maybeTakeScreenshot = bind(this.maybeTakeScreenshot, this);
      this.onTimeout = bind(this.onTimeout, this);
      this.onMapRendered = bind(this.onMapRendered, this);
      this.onChartRendered = bind(this.onChartRendered, this);
      if (this.constructor.isFakePhantomJs() && (this.constructor.window().callPhantom == null)) {
        this.constructor.window().callPhantom = function() {
          return console.log.apply(console, arguments);
        };
      }
    }

    SetUpScreenshotMode.prototype.call = function() {
      if (!this.constructor.inScreenshotMode()) {
        return;
      }
      this.slackMode = this.constructor.slackModeInUrl();
      this.widgetMode = this.constructor.widgetInUrl();
      this.chartsRendered = 0;
      this.mapsRendered = 0;
      this.chartsIdsRendered = {};
      App.Widget.bind('chart-rendered', this.onChartRendered);
      App.Widget.bind('map-rendered', this.onMapRendered);
      this.app.spinalCord.sever();
      this.timeoutId = setTimeout(this.onTimeout, this.timeoutTime());
      $('#body').addClass('screenshot-mode');
      if (this.constructor.directPdfModeInUrl()) {
        $('#body').addClass('direct-pdf-mode');
      }
      if (this.slackMode) {
        $('#body').addClass('slack-mode');
      }
      this.screenshotSizer = this.dashboardSizer.screenshotDashboadSizer(this.slackMode, this.widgetMode);
      this.resizeBody();
      this.resizeHeaderIfSlackDashboard();
      return this.processStaticCharts();
    };

    SetUpScreenshotMode.prototype.resizeBody = function() {
      App.Utils.cssSet('#body', 'height', this.screenshotSizer.bodyHeight);
      App.Utils.cssSet('#body', 'width', this.screenshotSizer.bodyWidth);
      App.Utils.cssSet('.content-offset-wrapper > .content', 'width', this.screenshotSizer.bodyWidth);
      return this.constructor.fontsReady((function(_this) {
        return function() {
          return _this.wrapElapsed("maybeTakeScreenshot", _this.maybeTakeScreenshot);
        };
      })(this));
    };

    SetUpScreenshotMode.prototype.timeoutTime = function() {
      return Math.max(this.constructor.TIMEOUT_MS - this.elapsedMs(), 0);
    };

    SetUpScreenshotMode.prototype.processStaticCharts = function() {
      var i, len, ref, results, widget;
      ref = App.Widget.all().filter((function(_this) {
        return function(widget) {
          return widget.contentRequiresQuery() === false;
        };
      })(this));
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        widget = ref[i];
        results.push(this.onChartRendered(widget));
      }
      return results;
    };

    SetUpScreenshotMode.prototype.onChartRendered = function(widget) {
      if (this.chartsIdsRendered.hasOwnProperty(widget.id)) {
        return AppRedesign.logToScalyr("ChartRenderedTwiceForScreenshot", {
          widget_id: widget.id,
          dashboard_id: widget.dashboard_id,
          shared_dashboard_id: widget.shared_dashboard_id
        });
      } else {
        if (widget.state() !== App.Widget.S_COMPLETE) {
          AppRedesign.logToScalyr("IncompleteChartRenderForScreenshot", {
            widget_id: widget.id,
            dashboard_id: widget.dashboard_id,
            shared_dashboard_id: widget.shared_dashboard_id
          });
        }
        this.chartsRendered += 1;
        this.chartsIdsRendered[widget.id] = true;
        return this.wrapElapsed("maybeTakeScreenshot", this.maybeTakeScreenshot);
      }
    };

    SetUpScreenshotMode.prototype.onMapRendered = function() {
      this.mapsRendered += 1;
      return this.wrapElapsed("maybeTakeScreenshot", this.maybeTakeScreenshot);
    };

    SetUpScreenshotMode.prototype.onTimeout = function() {
      var dashboardId, ref;
      this.reportStatus();
      dashboardId = ((ref = App.Dashboard.currentDashboard()) != null ? ref.id : void 0) || 'no_current_dashboard';
      AppRedesign.logError(new Error("Screenshot dashboard " + dashboardId + " timed out waiting for widgets to load"));
      return this.wrapElapsed("takeScreenshot on timeout", this.takeScreenshot);
    };

    SetUpScreenshotMode.prototype.everythingRendered = function() {
      return this.wrapElapsed("fontsRendered", this.fontsRendered) && this.chartsRendered >= App.Widget.count() && this.mapsRendered >= this.wrapElapsed("mapWidgetCount", this.mapWidgetCount);
    };

    SetUpScreenshotMode.prototype.fontsRendered = function() {
      return AppRedesign.documentReadyState() === 'complete';
    };

    SetUpScreenshotMode.prototype.mapWidgetCount = function() {
      return _.filter(App.Widget.all(), _.method('isGeomap')).length;
    };

    SetUpScreenshotMode.prototype.maybeTakeScreenshot = function() {
      this.reportStatus();
      if (!this.everythingRendered()) {
        return;
      }
      return this.wrapElapsed("takeScreenshotWithArbitraryDelayToEnsureOverlayTextRenders", this.takeScreenshotWithArbitraryDelayToEnsureOverlayTextRenders);
    };

    SetUpScreenshotMode.prototype.resizeHeaderIfSlackDashboard = function() {
      if (this.slackMode && !this.widgetMode) {
        return this.screenshotSizer.resizeHeaderForSlack();
      }
    };

    SetUpScreenshotMode.prototype.takeScreenshotWithArbitraryDelayToEnsureOverlayTextRenders = function() {
      return setTimeout((function(_this) {
        return function() {
          return _this.wrapElapsed("takeScreenshot timeout after delay", _this.takeScreenshot);
        };
      })(this), this.constructor.PAUSE_PERIOD_MS);
    };

    SetUpScreenshotMode.prototype.reportStatus = function() {
      return this.constructor.window().callPhantom({
        elapsedMs: this.elapsedMs(),
        renderedWidgets: this.chartsRendered,
        renderedMaps: this.mapsRendered,
        totalMaps: this.mapWidgetCount(),
        totalWidgets: App.Widget.count()
      });
    };

    SetUpScreenshotMode.prototype.wrapElapsed = function(name, fn) {
      var res, startTime;
      startTime = AppRedesign.timestamp();
      res = fn();
      this.constructor.window().callPhantom({
        name: name,
        elapsedMs: AppRedesign.timestamp() - startTime
      });
      return res;
    };

    SetUpScreenshotMode.prototype.elapsedMs = function() {
      return AppRedesign.timestamp() - this.app.pageloadTimestamp;
    };

    SetUpScreenshotMode.prototype.takeScreenshot = function() {
      var ref;
      if ((ref = App.Dashboard.currentDashboard()) != null) {
        ref.trigger('resize-to-exact-height-for-screenshot');
      }
      clearInterval(this.timeoutId);
      return setTimeout(((function(_this) {
        return function() {
          return _this.constructor.window().callPhantom({
            renderNow: true
          });
        };
      })(this)), this.CHART_REDRAW_DELAY_MS);
    };

    return SetUpScreenshotMode;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.SmartFetcher = (function() {
    SmartFetcher.IDLE_FETCH_THRESHOLD_SEC = 60 * 10;

    SmartFetcher.IDLE_FETCH_INTERVAL_MS = 60 * 1000;

    function SmartFetcher(requestFactory, useSpine) {
      this.requestFactory = requestFactory;
      this.useSpine = useSpine;
      this.requestComplete = bind(this.requestComplete, this);
      this.requestFailed = bind(this.requestFailed, this);
      this.timerHandler = bind(this.timerHandler, this);
      this.intervalMs = 10000;
      this.requestIntensity = 0;
      this.consecutiveFailureCount = 0;
    }

    SmartFetcher.prototype.start = function() {
      return this.scheduleTimer();
    };

    SmartFetcher.prototype.startQuickly = function() {
      var intensity;
      intensity = 5;
      if (intensity > this.requestIntensity && this.pendingTimeout && !this.pendingRequest) {
        this.stop();
      }
      this.requestIntensity = intensity;
      return this.scheduleTimer();
    };

    SmartFetcher.prototype.startNow = function() {
      if (this.pendingRequest) {
        return;
      }
      this.stop();
      return this.scheduleTimer(0);
    };

    SmartFetcher.prototype.startWithoutTimeout = function() {
      return this.timerHandler();
    };

    SmartFetcher.prototype.resetIntensity = function() {
      return this.requestIntensity = 0;
    };

    SmartFetcher.prototype.scheduleTimer = function(interval) {
      if (interval == null) {
        interval = null;
      }
      if (this.pendingRequest || this.pendingTimeout || this.shutdownNow) {
        return;
      }
      if (interval == null) {
        interval = this.getNextInterval();
      }
      return this.pendingTimeout = setTimeout(this.timerHandler, interval);
    };

    SmartFetcher.prototype.getNextInterval = function() {
      var ref;
      if (((ref = AppRedesign.current()) != null ? ref.idleSeconds() : void 0) > App.SmartFetcher.IDLE_FETCH_THRESHOLD_SEC) {
        return App.SmartFetcher.IDLE_FETCH_INTERVAL_MS;
      }
      this.requestIntensity = Math.max(0, Math.min(this.requestIntensity, 5));
      switch (this.requestIntensity) {
        case 5:
          return 100;
        case 4:
          return 500;
        case 3:
          return 500;
        case 2:
          return 1000;
        case 1:
          return 3000;
      }
      return this.intervalMs;
    };

    SmartFetcher.prototype.timerHandler = function() {
      this.stop();
      return this.makeRequest();
    };

    SmartFetcher.prototype.stop = function() {
      clearTimeout(this.pendingTimeout);
      return this.pendingTimeout = null;
    };

    SmartFetcher.prototype.shutdown = function() {
      return this.shutdownRequested = true;
    };

    SmartFetcher.prototype.makeRequest = function() {
      var req;
      if (this.pendingRequest) {
        return;
      }
      this.pendingRequest = Date.now();
      req = ((function(_this) {
        return function() {
          var factoryRequest, r;
          factoryRequest = _this.requestFactory();
          if (factoryRequest != null) {
            r = factoryRequest();
          }
          if (r != null) {
            return r.fail(_this.requestFailed).done(_this.requestComplete);
          } else {
            _this.requestComplete();
            return jQuery.Deferred().resolve();
          }
        };
      })(this));
      if (this.useSpine) {
        return Spine.Ajax.queue(req);
      } else {
        return req();
      }
    };

    SmartFetcher.prototype.requestFailed = function() {
      this.stop();
      this.pendingRequest = null;
      this.requestIntensity--;
      return this.scheduleTimer(1000 * Math.min(++this.consecutiveFailureCount, 30));
    };

    SmartFetcher.prototype.requestComplete = function() {
      if (this.shutdownRequested) {
        this.shutdownNow = true;
      }
      this.consecutiveFailureCount = 0;
      this.stop();
      this.pendingRequest = null;
      this.requestIntensity--;
      return this.scheduleTimer();
    };

    return SmartFetcher;

  })();

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SourceErrorMessageInterpreter = (function(superClass) {
    extend(SourceErrorMessageInterpreter, superClass);

    function SourceErrorMessageInterpreter() {
      return SourceErrorMessageInterpreter.__super__.constructor.apply(this, arguments);
    }

    SourceErrorMessageInterpreter.call = function(errorMessage) {
      if (errorMessage.match(/CdtQueryTooLongError/)) {
        return "Error: The text of your expanded SQL query is larger than 5MB. Please reduce the length of your SQL query to proceed.";
      }
      return errorMessage;
    };

    return SourceErrorMessageInterpreter;

  })(Spine.Module);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SourceFetcher = (function(superClass) {
    extend(SourceFetcher, superClass);

    SourceFetcher.extend(Spine.Events);

    SourceFetcher.include(Spine.Events);

    SourceFetcher.waiting_hashes = {};

    SourceFetcher.QUERY_INTERACTIVE = 'client_interactive';

    SourceFetcher.QUERY_REFRESH = 'client_refresh';

    SourceFetcher.QUERY_CHECK_FOR_UPDATES = 'client_check_for_updates';

    SourceFetcher.QUERY_WIDGET = 'client_widget';

    SourceFetcher.FETCH_SIZE = 6;

    SourceFetcher.HOST = "sourceress.periscopedata.com";

    SourceFetcher.authToken = "";

    SourceFetcher.EVENT_SOURCES_FETCHED = 'sources-fetched';

    SourceFetcher.reset = function() {
      App.sourceFetcher().reset();
      return this.waiting_hashes = {};
    };

    SourceFetcher.sourcesPending = function() {
      return App.sourceFetcher().sourcesPending();
    };

    SourceFetcher.sourcePending = function(h) {
      return App.sourceFetcher().sourcePending(h);
    };

    function SourceFetcher() {
      this.handleFetch = bind(this.handleFetch, this);
      this.fetchSingleSource = bind(this.fetchSingleSource, this);
      this.fetchStatuses = bind(this.fetchStatuses, this);
      this.buildRequest = bind(this.buildRequest, this);
      this.maybeFetch = bind(this.maybeFetch, this);
      this.addSourceToReactToFetchS3Links = bind(this.addSourceToReactToFetchS3Links, this);
      this.formulaUpdated = bind(this.formulaUpdated, this);
      this.fetcher = new App.SmartFetcher(this.buildRequest, false);
      this.reset();
      this.doBind();
      this._idx = 0;
    }

    SourceFetcher.prototype.sourcesPending = function() {
      return this.numPending > 0;
    };

    SourceFetcher.prototype.sourcePending = function(h) {
      return this.pendingHashes.val(h) != null;
    };

    SourceFetcher.prototype.addHash = function(h, isHighPriority, querySource) {
      var ref;
      if (h == null) {
        throw new Error("Can't fetch a null hash key");
      }
      if (this.pendingHashes.val(h) != null) {
        return;
      }
      this.numPending++;
      this.pendingHashes.push(h, {
        fetched: false,
        added: Date.now(),
        fetched_at: 0,
        fetch_attempt: 0,
        fetch_idx: this._idx++,
        source: querySource,
        isHighPriority: isHighPriority
      });
      if ((ref = this.pusherClient) != null) {
        ref.remoteAddHash(h);
      }
      return this.maybeFetch();
    };

    SourceFetcher.prototype.delHash = function(h) {
      var ref;
      delete App.SourceFetcher.waiting_hashes[h];
      if (!this.pendingHashes.remove(h)) {
        return;
      }
      if ((ref = this.pusherClient) != null) {
        ref.remoteRemoveHash(h);
      }
      return this.numPending--;
    };

    SourceFetcher.prototype.doBind = function() {
      return App.FormulaSource.bind('change', this.formulaUpdated);
    };

    SourceFetcher.prototype.formulaUpdated = function(fs) {
      var push_requested, q_source, request_duration, totalFetchLatency, wastedTime;
      if (this.pendingHashes.val(fs.hash_key) == null) {
        return;
      }
      this.pendingHashes.val(fs.hash_key)['fetched'] = true;
      if (fs.percent_complete === 1 && !fs.tooOld()) {
        if (!fs.dataFetchedAt) {
          fs.setDataFetchedAt(Date.now());
        }
        totalFetchLatency = Date.now() - this.pendingHashes.val(fs.hash_key)['added'];
        q_source = this.pendingHashes.val(fs.hash_key)['source'];
        request_duration = Date.now() - this.pendingHashes.val(fs.hash_key)['fetched_at'];
        push_requested = this.pendingHashes.val(fs.hash_key)['push_fetched'] != null;
        wastedTime = totalFetchLatency / 1000 - fs.query_duration;
        AppRedesign.logToScalyr("SourceFetch", {
          source: fs.id,
          wasted_time: wastedTime,
          request_duration: request_duration / 1000,
          fetch_latency: totalFetchLatency / 1000,
          query_duration: fs.query_duration,
          push_requested: push_requested,
          query_source: q_source
        });
        this.delHash(fs.hash_key);
      }
      this.addSourceToReactToFetchS3Links(fs);
      return App.SourceFetcher.trigger('source-updated', fs);
    };

    SourceFetcher.prototype.addSourceToReactToFetchS3Links = function(fs) {
      if (!fs.links) {
        return;
      }
      return window.reactApp.addSource(fs.attributes());
    };

    SourceFetcher.prototype.resetPusherClient = function() {
      var ref;
      if ((ref = this.pusherClient) != null) {
        ref.release();
      }
      this.pusherClient = new App.PusherClient(this);
      return this.pusherClient.bind('source-pushed', this.fetchSingleSource);
    };

    SourceFetcher.prototype.reset = function() {
      this.pendingHashes = new OrderedHash();
      this.numPending = 0;
      this.fetcher.stop();
      return this.resetPusherClient();
    };

    SourceFetcher.prototype.maybeFetch = function() {
      if (this.numPending === 0) {
        return this.fetcher.stop();
      } else {
        this.pendingHashes.sort(App.SourceFetcher.hashComparator);
        if (this.pendingHashes.first().fetch_attempt > 0) {
          return this.fetcher.start();
        } else if (this.numPending > App.SourceFetcher.FETCH_SIZE) {
          return this.fetcher.startNow();
        } else {
          return this.fetcher.startQuickly();
        }
      }
    };

    SourceFetcher.prototype.urlFromRoute = function(route) {
      var routePrefix;
      routePrefix = (App.herokuReleaseVersion === 'Development' ? "http" : "https") + "://";
      routePrefix += App.SourceFetcher.HOST;
      return routePrefix + route;
    };

    SourceFetcher.prototype.urlForFetchSources = function() {
      return this.urlFromRoute("/fetch_sources");
    };

    SourceFetcher.prototype.urlForFetchStatuses = function() {
      return "/source_update_requests/fetch_statuses";
    };

    SourceFetcher.prototype.buildRequest = function() {
      var i, key, keys, len, userId;
      this.pendingHashes.sort(App.SourceFetcher.hashComparator);
      keys = this.pendingHashes.keys().slice(0, +App.SourceFetcher.FETCH_SIZE + 1 || 9e9);
      if (keys.length === 0) {
        return (function() {
          return null;
        });
      }
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        this.pendingHashes.val(key)['fetched_at'] = Date.now();
        this.pendingHashes.val(key)['fetch_attempt']++;
      }
      if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode) {
        userId = AppRedesign.current().shared_dashboard_user_id;
      } else {
        userId = AppRedesign.current().userId();
      }
      return (function(_this) {
        return function() {
          return jQuery.ajax({
            url: _this.urlForFetchSources(),
            data: {
              hashes: keys,
              auth_token: App.SourceFetcher.authToken,
              user_id: userId
            }
          }).done(_this.handleFetch);
        };
      })(this);
    };

    SourceFetcher.prototype.fetchStatuses = function(keys) {
      var userId;
      if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode) {
        userId = AppRedesign.current().shared_dashboard_user_id;
      } else {
        userId = AppRedesign.current().userId();
      }
      return jQuery.ajax({
        url: this.urlForFetchStatuses(),
        data: {
          client_site_id: App.Site.first().id,
          hash_keys: keys
        }
      });
    };

    SourceFetcher.prototype.fetchSingleSource = function(hashKey) {
      if (this.pendingHashes.val(hashKey) != null) {
        this.pendingHashes.val(hashKey)['fetched_at'] = Date.now();
        this.pendingHashes.val(hashKey)['fetch_attempt']++;
        this.pendingHashes.val(hashKey)['push_fetched'] = true;
      }
      return jQuery.ajax({
        url: this.urlForFetchSources(),
        data: {
          pusher_requested: true,
          hashes: [hashKey],
          auth_token: App.SourceFetcher.authToken,
          user_id: AppRedesign.current().userId()
        }
      }).done(this.handleFetch);
    };

    SourceFetcher.prototype.handleFetch = function(response) {
      App.FormulaSource.applyUpdates(response.formula_sources);
      App.SourceFetcher.trigger(this.constructor.EVENT_SOURCES_FETCHED);
      return setTimeout(this.maybeFetch, 0);
    };

    SourceFetcher.prototype.initialFetch = function(hashKeys) {
      var hashKey, i, len;
      for (i = 0, len = hashKeys.length; i < len; i++) {
        hashKey = hashKeys[i];
        this.addWaitingHash(hashKey);
        this.addHash(hashKey, true, App.SourceFetcher.QUERY_WIDGET);
      }
      return this.fetcher.startWithoutTimeout();
    };

    SourceFetcher.prototype.addWaitingHash = function(hashKey) {
      return App.SourceFetcher.waiting_hashes[hashKey] = 1;
    };

    SourceFetcher.hashComparator = function(a, b) {
      if (a.isHighPriority && !b.isHighPriority) {
        return -1;
      }
      if (b.isHighPriority && !a.isHighPriority) {
        return 1;
      }
      if ((a.fetch_attempt > 0) === (b.fetch_attempt > 0)) {
        if (a.fetched_at === b.fetched_at) {
          return a.fetch_idx - b.fetch_idx;
        }
        return a.fetched_at - b.fetched_at;
      }
      return a.fetch_attempt - b.fetch_attempt;
    };

    SourceFetcher.waitingFor = function(hash_key) {
      return App.SourceFetcher.waiting_hashes[hash_key] === 1;
    };

    SourceFetcher.configure = function(authToken, host) {
      if (authToken != null) {
        this.authToken = authToken;
      }
      if (host != null) {
        return this.HOST = host;
      }
    };

    return SourceFetcher;

  })(Spine.Module);

  App.sourceFetcher = function() {
    var base;
    return (base = AppRedesign.current()).sourceFetcherFactory != null ? base.sourceFetcherFactory : base.sourceFetcherFactory = new App.SourceFetcher();
  };

  App.fetchSourceWithoutExplicitQuerySource = function(hashKey) {
    return this.fetchSource(hashKey, '');
  };

  App.fetchSourceHighPriority = function(hashKey, querySource) {
    App.SourceFetcher.waiting_hashes[hashKey] = 1;
    return App.sourceFetcher().addHash(hashKey, true, querySource);
  };

  App.fetchSource = function(hashKey, querySource) {
    return App.sourceFetcher().addHash(hashKey, false, querySource);
  };

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.SpinalCord = (function() {
    var CHECK_FOR_UPDATES_INTERVAL_MS, CHECK_FOR_UPDATES_WATCHDOG_INTERVAL, SPINE_TO_REDUX_MODELS;

    CHECK_FOR_UPDATES_WATCHDOG_INTERVAL = 20 * 1000;

    CHECK_FOR_UPDATES_INTERVAL_MS = 10 * 1000;

    SpinalCord.MAX_FAILED_CHECK_FOR_UPDATES = 60;

    function SpinalCord(shared_mode) {
      this.shared_mode = shared_mode;
      this.createUpdateRequest = bind(this.createUpdateRequest, this);
      this.createUpdateRequestRoute = bind(this.createUpdateRequestRoute, this);
      this.periodicUpdateCleanup = bind(this.periodicUpdateCleanup, this);
      this.failedPeriodicUpdate = bind(this.failedPeriodicUpdate, this);
      this.handleRemainingUpdatedWidgetResponse = bind(this.handleRemainingUpdatedWidgetResponse, this);
      this.handlePeriodicUpdate = bind(this.handlePeriodicUpdate, this);
      this.requestInstantUpdate = bind(this.requestInstantUpdate, this);
      this.requestQuickUpdate = bind(this.requestQuickUpdate, this);
      this.checkForUpdatesWatchdogCb = bind(this.checkForUpdatesWatchdogCb, this);
      this.checkForUpdatesWatchdog = new App.Watchdog(CHECK_FOR_UPDATES_WATCHDOG_INTERVAL, "check_for_updates", this.checkForUpdatesWatchdogCb);
      this.smartFetcher = new App.SmartFetcher(this.createUpdateRequest, true);
      this.last_updates = {};
      this.checkForUpdatesFailCount = 0;
      this.checkForUpdatesSuccessCount = 0;
    }

    SpinalCord.prototype.checkForUpdatesWatchdogCb = function() {
      return 1;
    };

    SpinalCord.prototype.getStateForDashboard = function(dashId) {
      return this.getStateForDashboardWithCallback(dashId, function() {});
    };

    SpinalCord.prototype.getStateForDashboardWithCallback = function(dashId, callback) {
      App.Lagotron.addContext("get widgets for dashboard fetch");
      if (App.Utils.isClientId(dashId)) {
        this.setLastUpdateForDashboard(dashId, true);
        App.Dashboard.trigger("update-empty-message");
        return;
      }
      return jQuery.get("/sites/" + (App.Site.first().id) + "/get_dashboard_state", {
        dashboard_id: dashId
      }, (function(_this) {
        return function(r) {
          _this.handleGetStateForDashboard(dashId, r);
          return callback();
        };
      })(this));
    };

    SpinalCord.prototype.handleGetStateForDashboard = function(dashId, response) {
      App.Lagotron.addContext("get state for dashboard response");
      this.applyAllTheUpdates(response);
      return this.setLastUpdateForDashboard(dashId, response.last_update);
    };

    SpinalCord.allWidgetsHaveData = function() {
      var dashboard, i, j, len, len1, ref, ref1, widget;
      ref = App.Dashboard.all();
      for (i = 0, len = ref.length; i < len; i++) {
        dashboard = ref[i];
        ref1 = dashboard.widgets();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          widget = ref1[j];
          if (widget.hasUpdatePending(false)) {
            return false;
          }
        }
      }
      return true;
    };

    SpinalCord.allCustomDimensionsHaveData = function() {
      var cd, i, len, ref;
      ref = App.CustomDimension.all();
      for (i = 0, len = ref.length; i < len; i++) {
        cd = ref[i];
        if (cd.isLoading()) {
          return false;
        }
      }
      return true;
    };

    SpinalCord.modelsHaveData = function() {
      return SpinalCord.allCustomDimensionsHaveData() && SpinalCord.allWidgetsHaveData();
    };

    SpinalCord.prototype.requestQuickUpdate = function() {
      if (this.severed || (typeof window === "undefined" || window === null) || (AppRedesign.current() == null) || window.test_mode) {
        return false;
      }
      return this.smartFetcher.startQuickly();
    };

    SpinalCord.prototype.requestInstantUpdate = function() {
      if (this.severed || (typeof window === "undefined" || window === null) || (AppRedesign.current() == null)) {
        return false;
      }
      return this.smartFetcher.startNow();
    };

    SpinalCord.prototype.handleHashKeys = function(hash_keys, lastUpdate) {
      var fs, hash_key, i, len, results;
      results = [];
      for (i = 0, len = hash_keys.length; i < len; i++) {
        hash_key = hash_keys[i];
        fs = App.FormulaSource.findByHash(hash_key);
        if ((fs != null) && lastUpdate > 0 && fs.last_update >= lastUpdate) {
          continue;
        }
        results.push(App.fetchSource(hash_key, App.SourceFetcher.QUERY_CHECK_FOR_UPDATES));
      }
      return results;
    };

    SpinalCord.prototype.handleInitialState = function(state) {
      this.handlePeriodicUpdate(state);
      this.firstBatchOfWidgetsLoaded();
      if (this.severed) {
        return;
      }
      return this.smartFetcher.start();
    };

    SpinalCord.prototype.handlePeriodicUpdate = function(response, textStatus, jqXHR) {
      var changedDimensions, codeHashInResponse, currentDashboard, error, hashInResponse, previousUpdateTime, ref, ref1, ref2, ref3, widgetUpdateTime;
      try {
        App.Lagotron.addContext('handlePeriodicUpdate');
        this.checkForUpdatesSuccessCount++;
        previousUpdateTime = this.getLastUpdateForApp();
        if (response.refresh != null) {
          AppRedesign.current().resetIfReady();
        }
        if (response.reset != null) {
          return;
        }
        if (response.Site != null) {
          if (this.shared_mode) {
            this.initializeForSharedDashboard(response);
          } else {
            this.initializeForDashboard(response);
          }
        }
        hashInResponse = response.linked_widget_formula_source_hash_key;
        if ((hashInResponse != null) && AppRedesign.widgetIdInUrl()) {
          App.linkedWidgetFormulaSourceHashKey = hashInResponse;
        }
        codeHashInResponse = response.code_linked_widget_formula_source_hash_key;
        if ((codeHashInResponse != null) && AppRedesign.widgetIdInUrl()) {
          App.codeLinkedWidgetFormulaSourceHashKey = codeHashInResponse;
        }
        if (((ref = response.auth_tokens) != null ? ref.PusherClient : void 0) != null) {
          App.PusherClient.authToken = response.auth_tokens.PusherClient;
        }
        if (((ref1 = response.auth_tokens) != null ? ref1.DimentorClient : void 0) != null) {
          App.DimentorXClient.authToken = response.auth_tokens.DimentorClient;
        }
        if (response.dimentor_fe_addr != null) {
          App.DimentorXClient.HOST = response.dimentor_fe_addr;
          App.dimentorClient().initWebSocket();
        }
        if (response.pusher_addr != null) {
          App.PusherClient.HOST = response.pusher_addr;
        }
        if (response.sourcerer_fe_addr != null) {
          App.SourceFetcher.HOST = response.sourcerer_fe_addr;
        }
        if (((ref2 = response.auth_tokens) != null ? ref2.SourcererClient : void 0) != null) {
          App.SourceFetcher.authToken = response.auth_tokens.SourcererClient;
        }
        if ((response.updates != null) && (response.updates.Site != null) && App.Site.first()) {
          if (response.updates.Site.site_version !== App.Site.first().site_version) {
            App.Site.first().trigger('site_version_change', response.updates.Site.site_version);
          }
        }
        if (response.deletes != null) {
          this.applyAllTheDeletions(response.deletes);
        }
        if (response.updates != null) {
          this.applyAllTheUpdates(response.updates);
        }
        if (response.last_update != null) {
          this.setLastUpdateForApp(response.last_update);
        }
        currentDashboard = App.Dashboard.currentDashboard();
        if (currentDashboard != null) {
          widgetUpdateTime = this.getLastUpdateForDashboard(currentDashboard.id);
          this.setLastUpdateForDashboard(currentDashboard.id, response.last_update);
        }
        if (response.hash_keys != null) {
          this.handleHashKeys(response.hash_keys, previousUpdateTime);
        }
        if ((ref3 = AppRedesign.current()) != null) {
          ref3.loadUntilNextCheckForUpdates = false;
        }
        this.triggerAllUpdates(response.updates);
        this.handleRemainingUpdatedWidgets(response.remaining_widget_ids, widgetUpdateTime);
        if (AppRedesign.current().roleLevelAccessEnabled) {
          if (!App.User.safeCurrentUser().isAdmin() && (currentDashboard != null) && response.role_level_access_object) {
            changedDimensions = this.findChangedKeys(AppRedesign.current().roleLevelAccessObject, response.role_level_access_object);
            AppRedesign.current().roleLevelAccessObject = response.role_level_access_object;
            App.CustomDimension.all().forEach(function(dimension) {
              if (changedDimensions.includes(dimension.name)) {
                return dimension.resetCache();
              }
            });
          }
        }
      } catch (error1) {
        error = error1;
        if (window.test_mode) {
          throw error;
        }
        AppRedesign.logError(error);
      }
      this.lastHandlePeriodicUpdate = AppRedesign.timestamp();
      this.lastHandlePeriodicUpdateFailed = false;
      return this.periodicUpdateCleanup();
    };

    SpinalCord.prototype.findChangedKeys = function(oldObj, newObj) {
      var bothKeys;
      bothKeys = Object.keys(oldObj || {}).concat(Object.keys(newObj || {}));
      return _.uniq(bothKeys).filter(function(key) {
        var newVal, oldVal;
        oldVal = oldObj[key] || [];
        newVal = newObj[key] || [];
        return JSON.stringify(oldVal) !== JSON.stringify(newVal);
      });
    };

    SpinalCord.prototype.handleRemainingUpdatedWidgets = function(widgetIds, widgetUpdateTime) {
      var currentDashboard, options, route;
      if (_.isEmpty(widgetIds)) {
        return;
      }
      this.pendingWidgetsCount = widgetIds.length;
      currentDashboard = App.Dashboard.currentDashboard();
      if (currentDashboard == null) {
        return;
      }
      route = this.handleRemainingWidgetsRoute();
      options = {
        dashboard_id: currentDashboard.id,
        dashboard_last_widgets_sync: widgetUpdateTime,
        widget_ids: widgetIds
      };
      return jQuery.get(route, options, this.handleRemainingUpdatedWidgetResponse);
    };

    SpinalCord.prototype.handleRemainingWidgetsRoute = function() {
      return "/sites/" + (App.Site.first().id) + "/fetch_remaining_widgets";
    };

    SpinalCord.prototype.handleRemainingUpdatedWidgetResponse = function(response, textStatus, jqXHR) {
      var widgetsInResponse;
      if (response.updates != null) {
        this.applyAllTheUpdates(response.updates);
      }
      if (response.hash_keys != null) {
        this.handleHashKeys(response.hash_keys, response.last_update);
      }
      this.triggerAllUpdates(response.updates);
      widgetsInResponse = response.remaining_widget_ids;
      if (_.isEmpty(widgetsInResponse) || widgetsInResponse.length >= this.pendingWidgetsCount) {
        return;
      }
      return this.handleRemainingUpdatedWidgets(widgetsInResponse, response.widget_sync_time);
    };

    SpinalCord.prototype.firstBatchOfWidgetsNotLoaded = function() {
      return this.firstBatchLoaded = false;
    };

    SpinalCord.prototype.firstBatchOfWidgetsLoaded = function() {
      return this.firstBatchLoaded = true;
    };

    SpinalCord.prototype.initializeForSharedDashboard = function(state) {
      this.applyAllTheUpdates(state);
      if (App.Dashboard.count() > 0) {
        return this.setInitialDashboard(App.Dashboard.first().id);
      }
    };

    SpinalCord.prototype.initializeForDashboard = function(state) {
      App.User.refresh(state.user_profiles);
      this.applyAllTheUpdates(state);
      if (state.initial_dashboard_id) {
        return this.setInitialDashboard(state.initial_dashboard_id);
      }
    };

    SpinalCord.prototype.failedPeriodicUpdate = function(jqXHR, textStatus, errorThrown) {
      App.Lagotron.addContext('failedPeriodicUpdate');
      this.checkForUpdatesFailCount++;
      return this.periodicUpdateCleanup();
    };

    SpinalCord.prototype.periodicUpdateCleanup = function() {
      if (App.SpinalCord.modelsHaveData()) {
        return this.smartFetcher.resetIntensity();
      }
    };

    SpinalCord.prototype.triggerAllUpdates = function(updates) {
      var d, i, j, l, len, len1, len2, ref, ref1, ref2, u, updatesByDash, w;
      if (updates == null) {
        return;
      }
      updatesByDash = {};
      if (updates.Dashboard != null) {
        ref = updates.Dashboard;
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          updatesByDash[d.id] = {
            dashboard: d.id,
            widgets: []
          };
        }
      }
      if (updates.UserDataView != null) {
        if (updates.Widget == null) {
          updates.Widget = [];
        }
        ref1 = updates.UserDataView;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          u = ref1[j];
          updatesByDash[u.dashboard_id] = {
            dashboard: u.dashboard_id,
            widgets: []
          };
          updates.Widget = updates.Widget.concat(App.UserDataView.find(u.id).widgets());
        }
      }
      if (updates.Widget != null) {
        ref2 = updates.Widget;
        for (l = 0, len2 = ref2.length; l < len2; l++) {
          w = ref2[l];
          if (updatesByDash[w.dashboard_id] == null) {
            updatesByDash[w.dashboard_id] = {
              widgets: []
            };
          }
          updatesByDash[w.dashboard_id].widgets.push(w.id);
        }
      }
      if (updates.ColorTheme != null) {
        App.Site.trigger('update-color-themes');
      }
      return App.Site.trigger('all-updates', updatesByDash);
    };

    SpinalCord.prototype.serverModelToSpineModel = function(str) {
      var model;
      model = App[str];
      if (!((model != null) && (model.applyUpdates != null) && (model.applyDeletions != null))) {
        return null;
      }
      return model;
    };

    SPINE_TO_REDUX_MODELS = ['Dashboard', 'SqlView', 'CsvView', 'DashboardStar', 'StarredItem', 'RecentItem', 'Badge', 'SqlSnippet', 'SqlAlert'];

    SpinalCord.prototype.applyAllTheDeletions = function(theDeletes) {
      var k, permanentlyDeletedArchives, ref, v;
      for (k in theDeletes) {
        v = theDeletes[k];
        if (!(v != null)) {
          continue;
        }
        if ((ref = this.serverModelToSpineModel(k)) != null) {
          ref.applyDeletions(v);
        }
        if (AppRedesign.autoArchiveEnabled() && v.length > 0 && (k === 'Dashboard' || k === 'SqlView' || k === 'CsvView')) {
          permanentlyDeletedArchives = v.reduce(function(list, archivable) {
            if (!archivable.archived_at) {
              list.push({
                id: archivable.id,
                class_name: k
              });
            }
            return list;
          }, []);
          App.SearchableArchive.applyDeletions(permanentlyDeletedArchives);
        }
      }
      if (theDeletes['StitchConnectSource'] != null) {
        window.reactApp.removeConnectorIngestionSources(theDeletes['StitchConnectSource']);
      }
      if (AppRedesign.dashboardOrganizationEnabled()) {
        if (theDeletes['Topic'] != null) {
          window.reactApp.removeTopics(theDeletes['Topic']);
        }
        if (theDeletes['PinnedItem'] != null) {
          window.reactApp.removePinnedItems(theDeletes['PinnedItem']);
        }
        return SPINE_TO_REDUX_MODELS.forEach(function(type) {
          if (theDeletes[type] != null) {
            return window.reactApp.unpopulatePeriscopeModels(type, theDeletes[type]);
          }
        });
      }
    };

    SpinalCord.prototype.applyAllTheUpdates = function(theUpdates, options) {
      var excludedModels, i, k, len, orderedModels, reactOnlyModels, ref, v;
      orderedModels = ['FormulaSource', 'UserDataView', 'Database', 'GroupMembership', 'GroupRole', 'Site', 'TextBox'];
      for (i = 0, len = orderedModels.length; i < len; i++) {
        k = orderedModels[i];
        v = theUpdates[k];
        this.modelApplyUpdates(k, v);
      }
      this.maybeFetchDbSchemas(theUpdates);
      reactOnlyModels = ['Topic', 'PinnedItem', 'TopicPermissions', 'StitchConnectSource'];
      excludedModels = orderedModels.concat(reactOnlyModels);
      for (k in theUpdates) {
        v = theUpdates[k];
        if (!((v != null) && indexOf.call(excludedModels, k) < 0)) {
          continue;
        }
        this.modelApplyUpdates(k, v);
        if (AppRedesign.autoArchiveEnabled() && (v != null) && v.length > 0 && (k === 'Dashboard' || k === 'SqlView' || k === 'CsvView')) {
          App.SearchableArchive.applyDeletions(v.map(function(archivable) {
            return {
              id: archivable.id,
              class_name: k
            };
          }));
        }
      }
      if (theUpdates['StitchConnectSource'] != null) {
        window.reactApp.updateConnectorIngestionSources(theUpdates['StitchConnectSource'], options);
      }
      if (AppRedesign.dashboardOrganizationEnabled()) {
        if (theUpdates['Topic'] != null) {
          window.reactApp.updateTopics(theUpdates['Topic'], theUpdates['TopicPermissions'], options);
        }
        if (theUpdates['PinnedItem'] != null) {
          window.reactApp.updatePinnedItems(theUpdates['PinnedItem'], options);
        }
        SPINE_TO_REDUX_MODELS.forEach(function(type) {
          if (theUpdates[type] != null) {
            return window.reactApp.populatePeriscopeModels(type, theUpdates[type], options);
          }
        });
        if ((theUpdates.user_profiles != null) && !AppRedesign.current().state.RbacEnabled) {
          window.reactApp.populatePeriscopeModels('User', theUpdates.user_profiles);
        }
      }
      if (theUpdates['CurrentDashboardPermissions']) {
        return (ref = App.Dashboard.currentDashboard()) != null ? ref.applyPermissions(theUpdates['CurrentDashboardPermissions']) : void 0;
      }
    };

    SpinalCord.prototype.modelApplyUpdates = function(k, v) {
      var klass;
      if (v == null) {
        return;
      }
      klass = this.serverModelToSpineModel(k);
      if (klass == null) {
        return;
      }
      if (!isArray(v)) {
        v = [v];
      }
      return klass.applyUpdates(v, klass.DONT_TRIGGER_ON_CHECK_FOR_UPDATE);
    };

    SpinalCord.prototype.maybeFetchDbSchemas = function(theUpdates) {
      var anyUpdatedDatabaseHasNoSchema, attributesAreForDatabaseWithNoSchema;
      if (AppRedesign.restrictDatabasesEnabled()) {
        attributesAreForDatabaseWithNoSchema = function(dbAttributes) {
          var db;
          db = App.Database.exists(dbAttributes.id);
          if (db) {
            return !db.schema;
          } else {
            return false;
          }
        };
        anyUpdatedDatabaseHasNoSchema = function() {
          var ref;
          return (ref = theUpdates.Database) != null ? ref.some(attributesAreForDatabaseWithNoSchema) : void 0;
        };
        if (anyUpdatedDatabaseHasNoSchema()) {
          return AppRedesign.current().ensureDbSchemaFetchedForWriteUser(null, {
            dbWithoutSchemaExists: true
          });
        }
      } else {
        if ((theUpdates.GroupMembership != null) || (theUpdates.GroupRole != null)) {
          return AppRedesign.current().ensureDbSchemaFetchedForWriteUser();
        }
      }
    };

    SpinalCord.prototype.applyAllUnarchivedUpdates = function(unarchivedUpdates) {
      var itemIds, items, klass, klass_name;
      for (klass_name in unarchivedUpdates) {
        items = unarchivedUpdates[klass_name];
        klass = this.serverModelToSpineModel(klass_name);
        if (klass == null) {
          continue;
        }
        if (!isArray(items)) {
          items = [items];
        }
        itemIds = items.map(function(item) {
          return item.id;
        });
        klass.destroyedIds = _.difference(klass.destroyedIds, itemIds);
      }
      return this.applyAllTheUpdates(unarchivedUpdates);
    };

    SpinalCord.prototype.setInitialDashboard = function(initial_dashboard_id) {
      var dashboard;
      dashboard = App.Dashboard.exists(initial_dashboard_id) || App.Dashboard.first();
      if (dashboard) {
        return dashboard.makeCurrent();
      }
    };

    SpinalCord.prototype.stopUpdates = function() {
      return this.smartFetcher.stop();
    };

    SpinalCord.prototype.sever = function() {
      this.severed = true;
      return this.smartFetcher.stop();
    };

    SpinalCord.prototype.createUpdateRequestRoute = function() {
      if (this.shared_mode) {
        return "/shared_dashboards/" + (AppRedesign.current().shared_dashboard_token) + "/check_for_updates";
      } else {
        return "/sites/" + (App.Site.first().id) + "/fetch_updates";
      }
    };

    SpinalCord.prototype.createUpdateRequest = function() {
      var currentDash, error, get_options, post_options, ref, route;
      route = this.createUpdateRequestRoute();
      try {
        this.checkForUpdatesWatchdog.heartbeat();
        App.Lagotron.addContext('requestPeriodicUpdate');
        currentDash = App.Dashboard.currentDashboard();
        if (currentDash == null) {
          App.Dashboard.trigger('dashboard-orphaned');
          return null;
        }
        get_options = {
          last_update: this.getLastUpdateForApp(),
          dashboard_id: currentDash.id,
          release: AppRedesign.current().herokuReleaseVersion || 'Development',
          seconds_since_pageload: AppRedesign.current().secondsSincePageload(),
          dashboard_last_widgets_sync: this.getLastUpdateForDashboard(currentDash.id)
        };
        post_options = {
          uuid: (ref = AppRedesign.current()) != null ? ref.uuid : void 0,
          tvmode: AppRedesign.current().tvmode,
          tvmodeParent: AppRedesign.current().tvmodeParent,
          focused_tab: AppRedesign.current().focusedTab,
          widget_ids: currentDash.widgetIds(),
          widget_hash_keys: currentDash.widgetHashKeys(),
          linked_widget_id: AppRedesign.widgetIdInUrl(),
          linked_udv_id: AppRedesign.udvIdInUrl(),
          browser: BrowserDetect.browser,
          browser_version: BrowserDetect.version,
          os: BrowserDetect.OS,
          idle_seconds: AppRedesign.current().idleSeconds(),
          user_data_view_id: App.UserDataView.currentId()
        };
        if (AppRedesign.current().shared_mode && AppRedesign.current().shared_filter_mode && (App.UserDataView.current() != null)) {
          jQuery.extend(post_options, {
            shared_dashboard_filters: App.UserDataView.current().filtersAsJson()
          });
        }
        if (AppRedesign.current().currentTab != null) {
          jQuery.extend(post_options, {
            current_tab: AppRedesign.current().currentTab
          });
        }
        if (App.RedesignConfigitronController.configitronIsOpen()) {
          jQuery.extend(post_options, {
            configitron_open: true
          });
        }
        if (App.RedesignDirectoryController.inDirectoryController()) {
          jQuery.extend(post_options, {
            directory_open: true
          });
        }
        if (App.ConnectorIngestionController.connectorIngestionIsOpen()) {
          jQuery.extend(post_options, {
            saas_ingestion_open: true
          });
        }
      } catch (error1) {
        error = error1;
        if (window.test_mode) {
          throw error;
        }
        AppRedesign.logError(error);
      }
      return (function(_this) {
        return function() {
          App.Lagotron.addContext('makePeriodicUpdateRequest');
          return jQuery.post(route + "?" + $.param(get_options), post_options).fail(_this.failedPeriodicUpdate).done(_this.handlePeriodicUpdate);
        };
      })(this);
    };

    SpinalCord.prototype.getLastUpdateForApp = function() {
      return this.last_updates.app;
    };

    SpinalCord.prototype.setLastUpdateForApp = function(val) {
      return this.last_updates.app = val;
    };

    SpinalCord.prototype.getLastUpdateForDashboard = function(dashId) {
      return this.last_updates["dashboard-" + dashId];
    };

    SpinalCord.prototype.setLastUpdateForDashboard = function(dashId, val) {
      return this.last_updates["dashboard-" + dashId] = val;
    };

    SpinalCord.prototype.setWidgetsLoadedForDashboard = function(dashId) {
      return this.last_updates["dashboard-widgets-" + dashId] = true;
    };

    SpinalCord.prototype.getWidgetsLoadedForDashboard = function(dashId) {
      return this.last_updates["dashboard-widgets-" + dashId];
    };

    return SpinalCord;

  })();

}).call(this);
(function() {
  App.SqlAlertHistorian = (function() {
    function SqlAlertHistorian() {}

    SqlAlertHistorian.FIELDS_TO_CHECK = [
      {
        attr: 'name',
        name: 'Title'
      }, {
        attr: 'sql',
        name: 'SQL'
      }, {
        attr: 'sql_limit',
        name: 'Query Limit'
      }, {
        attr: 'custom_schedule',
        name: 'Settings'
      }, {
        attr: 'database_id',
        name: 'Settings'
      }, {
        attr: 'description',
        name: 'Settings'
      }, {
        attr: 'disabled',
        name: 'Settings'
      }, {
        attr: 'error_count',
        name: 'Settings'
      }, {
        attr: 'error_message',
        name: 'Settings'
      }, {
        attr: 'last_check_failed',
        name: 'Settings'
      }, {
        attr: 'last_refreshed_at',
        name: 'Settings'
      }, {
        attr: 'last_value',
        name: 'Settings'
      }, {
        attr: 'max_ignored_errors',
        name: 'Settings'
      }, {
        attr: 'refresh_interval_seconds',
        name: 'Settings'
      }, {
        attr: 'report_emails',
        name: 'Settings'
      }, {
        attr: 'site_id',
        name: 'Settings'
      }, {
        attr: 'sync_version',
        name: 'Settings'
      }, {
        attr: 'triggers',
        name: 'Settings'
      }, {
        attr: 'user_id',
        name: 'Settings'
      }
    ];

    SqlAlertHistorian.NO_RESULTS = "Save alerts to create version history.";

    SqlAlertHistorian.getHistory = function(sqlAlertId) {
      return this.makeHistory(this.getArchivedSqlAlerts(sqlAlertId));
    };

    SqlAlertHistorian.get = function(sqlAlertId) {
      var sqlAlert;
      sqlAlert = App.SqlAlert.exists(sqlAlertId);
      if (sqlAlert) {
        return sqlAlert;
      }
      return null;
    };

    SqlAlertHistorian.modelName = function() {
      return "sql_alert";
    };

    SqlAlertHistorian.fields_to_check = function() {
      return this.FIELDS_TO_CHECK;
    };

    SqlAlertHistorian.getArchivedSqlAlerts = function(sqlAlertId) {
      var asvs, sortedAsvs;
      asvs = App.ArchivedSqlAlert.allForSqlAlertId(sqlAlertId);
      if (!(asvs && asvs.length > 0)) {
        return [];
      }
      sortedAsvs = asvs.sort(function(a, b) {
        return a.created_at.localeCompare(b.created_at);
      });
      return sortedAsvs;
    };

    SqlAlertHistorian.makeHistory = function(sortedArchivedSqlAlerts) {
      var asv, diffItem, i, items, j, len;
      items = [];
      for (i = j = 0, len = sortedArchivedSqlAlerts.length; j < len; i = ++j) {
        asv = sortedArchivedSqlAlerts[i];
        if (i === 0) {
          items.push(this.makeHistoryItem(asv, App.HistorianHelper.makeCreatedMessage(asv.user_name)));
        } else {
          diffItem = this.makeDiffItem(asv, sortedArchivedSqlAlerts[i - 1]);
          if (diffItem != null) {
            items.push(diffItem);
          }
        }
      }
      return items.reverse();
    };

    SqlAlertHistorian.makeHistoryItem = function(asvItem, message) {
      return {
        archivedId: asvItem.id,
        message: message,
        date: asvItem.created_at
      };
    };

    SqlAlertHistorian.makeDiffItem = function(asvChange, asvBase) {
      var changes, field, j, len, ref;
      changes = [];
      ref = this.fields_to_check();
      for (j = 0, len = ref.length; j < len; j++) {
        field = ref[j];
        if (this.fieldIsDifferent(asvBase, asvChange, field)) {
          changes.push(field.name);
        }
      }
      if (changes.length > 0) {
        changes = _.uniq(changes);
        changes[0] = 'updated ' + changes[0];
        return this.makeHistoryItem(asvChange, App.HistorianHelper.makeUpdatedMessage(asvChange.user_name, changes));
      }
      return null;
    };

    SqlAlertHistorian.fieldIsDifferent = function(asvChange, asvBase, field) {
      var bAttr, cAttr, ref, ref1;
      cAttr = (ref = asvChange.sql_alert_properties) != null ? ref[field.attr] : void 0;
      bAttr = (ref1 = asvBase.sql_alert_properties) != null ? ref1[field.attr] : void 0;
      return App.HistorianHelper.fieldIsDifferent(cAttr, bAttr, field);
    };

    return SqlAlertHistorian;

  })();

}).call(this);
(function() {
  App.SqlSnippetHistorian = (function() {
    function SqlSnippetHistorian() {}

    SqlSnippetHistorian.FIELDS_TO_CHECK = [
      {
        attr: 'name',
        name: 'Title'
      }, {
        attr: 'sql',
        name: 'SQL'
      }, {
        attr: 'user_id',
        name: 'Settings'
      }, {
        attr: 'description',
        name: 'Settings'
      }
    ];

    SqlSnippetHistorian.NO_RESULTS = "Save snippets to create version history.";

    SqlSnippetHistorian.getHistory = function(sqlSnippetId) {
      return this.makeHistory(this.getArchivedSqlSnippets(sqlSnippetId));
    };

    SqlSnippetHistorian.get = function(sqlSnippetId) {
      var sqlSnippet;
      sqlSnippet = App.SqlSnippet.exists(sqlSnippetId);
      if (sqlSnippet) {
        return sqlSnippet;
      }
      return null;
    };

    SqlSnippetHistorian.fields_to_check = function() {
      return this.FIELDS_TO_CHECK;
    };

    SqlSnippetHistorian.modelName = function() {
      return "sql_snippet";
    };

    SqlSnippetHistorian.getArchivedSqlSnippets = function(sqlSnippetId) {
      var asvs, sortedAsvs;
      asvs = App.ArchivedSqlSnippet.allForSqlSnippetId(sqlSnippetId);
      if (!(asvs && asvs.length > 0)) {
        return [];
      }
      sortedAsvs = asvs.sort(function(a, b) {
        return a.created_at.localeCompare(b.created_at);
      });
      return sortedAsvs;
    };

    SqlSnippetHistorian.makeHistory = function(sortedArchivedSqlSnippets) {
      var asv, diffItem, i, items, j, len;
      items = [];
      for (i = j = 0, len = sortedArchivedSqlSnippets.length; j < len; i = ++j) {
        asv = sortedArchivedSqlSnippets[i];
        if (i === 0) {
          items.push(this.makeHistoryItem(asv, App.HistorianHelper.makeCreatedMessage(asv.user_name)));
        } else {
          diffItem = this.makeDiffItem(asv, sortedArchivedSqlSnippets[i - 1]);
          if (diffItem != null) {
            items.push(diffItem);
          }
        }
      }
      return items.reverse();
    };

    SqlSnippetHistorian.makeHistoryItem = function(asvItem, message) {
      return {
        archivedId: asvItem.id,
        message: message,
        date: asvItem.created_at
      };
    };

    SqlSnippetHistorian.makeDiffItem = function(asvChange, asvBase) {
      var changes, field, j, len, ref;
      changes = [];
      ref = this.fields_to_check();
      for (j = 0, len = ref.length; j < len; j++) {
        field = ref[j];
        if (this.fieldIsDifferent(asvBase, asvChange, field)) {
          changes.push(field.name);
        }
      }
      if (_.isEmpty(changes)) {
        return;
      }
      changes = _.uniq(changes);
      changes[0] = 'updated ' + changes[0];
      return this.makeHistoryItem(asvChange, App.HistorianHelper.makeUpdatedMessage(asvChange.user_name, changes));
    };

    SqlSnippetHistorian.fieldIsDifferent = function(asvChange, asvBase, field) {
      var bAttr, cAttr, ref, ref1;
      cAttr = (ref = asvChange.sql_snippet_properties) != null ? ref[field.attr] : void 0;
      bAttr = (ref1 = asvBase.sql_snippet_properties) != null ? ref1[field.attr] : void 0;
      return App.HistorianHelper.fieldIsDifferent(cAttr, bAttr, field);
    };

    return SqlSnippetHistorian;

  })();

}).call(this);
(function() {
  App.SqlViewHistorian = (function() {
    function SqlViewHistorian() {}

    SqlViewHistorian.FIELDS_TO_CHECK = [
      {
        attr: 'name',
        name: 'Name'
      }, {
        attr: 'published_at',
        name: 'Published flag'
      }, {
        attr: 'sql',
        name: 'SQL'
      }, {
        attr: 'sql_limit',
        name: 'Query Limit'
      }, {
        attr: 'database_id',
        name: 'Database'
      }, {
        attr: 'description',
        name: 'Description'
      }, {
        attr: 'owner_user_id',
        name: 'Owner'
      }, {
        attr: 'no_cache_results',
        name: 'Cache Status'
      }, {
        attr: 'cache_schedule_ids',
        name: 'Cache Schedule',
        dataType: 'array'
      }, {
        attr: 'excluded_from_auto_archive',
        name: 'excluded this view from Auto Archive'
      }, {
        attr: 'archived_at',
        name: 'archived this view'
      }
    ];

    SqlViewHistorian.NO_RESULTS = "Save views to create version history.";

    SqlViewHistorian.getHistory = function(sqlViewId) {
      return this.makeHistory(this.getArchivedSqlViews(sqlViewId));
    };

    SqlViewHistorian.get = function(sqlViewId) {
      var sqlView;
      sqlView = App.SqlView.exists(sqlViewId);
      if (sqlView) {
        return sqlView;
      }
      return null;
    };

    SqlViewHistorian.fields_to_check_for_code = function(fields) {
      return fields.concat([
        {
          attr: 'code',
          name: 'Code'
        }, {
          attr: 'code_language',
          name: 'Code Language'
        }, {
          attr: 'code_version',
          name: 'Code Version'
        }
      ]);
    };

    SqlViewHistorian.fields_to_check = function() {
      var fields;
      fields = this.FIELDS_TO_CHECK;
      if (AppRedesign.current().deepAnalysisEnabled) {
        fields = this.fields_to_check_for_code(fields);
      }
      return fields;
    };

    SqlViewHistorian.modelName = function() {
      return "sql_view";
    };

    SqlViewHistorian.getArchivedSqlViews = function(sqlViewId) {
      var asvs, sortedAsvs;
      asvs = App.ArchivedSqlView.allForSqlViewId(sqlViewId);
      if (!(asvs && asvs.length > 0)) {
        return [];
      }
      sortedAsvs = asvs.sort(function(a, b) {
        return a.created_at.localeCompare(b.created_at);
      });
      return sortedAsvs;
    };

    SqlViewHistorian.makeHistory = function(sortedArchivedSqlViews) {
      var asv, diffItem, i, items, j, len;
      items = [];
      for (i = j = 0, len = sortedArchivedSqlViews.length; j < len; i = ++j) {
        asv = sortedArchivedSqlViews[i];
        if (i === 0) {
          items.push(this.makeHistoryItem(asv, App.HistorianHelper.makeCreatedMessage(asv.user_name)));
        } else {
          diffItem = this.makeDiffItem(asv, sortedArchivedSqlViews[i - 1]);
          if (diffItem != null) {
            items.push(diffItem);
          }
        }
      }
      return items.reverse();
    };

    SqlViewHistorian.makeHistoryItem = function(asvItem, message, applyDisabled) {
      if (applyDisabled == null) {
        applyDisabled = false;
      }
      return {
        archivedId: asvItem.id,
        message: message,
        date: asvItem.created_at,
        applyDisabled: applyDisabled
      };
    };

    SqlViewHistorian.makeDiffItem = function(asvChange, asvBase) {
      var applyDisabled, changes, field, j, len, msg, ref, useUpdatedInMessage;
      changes = [];
      useUpdatedInMessage = false;
      applyDisabled = false;
      ref = this.fields_to_check();
      for (j = 0, len = ref.length; j < len; j++) {
        field = ref[j];
        if (!(this.fieldIsDifferent(asvBase, asvChange, field))) {
          continue;
        }
        msg = this.getDiffMessage(asvChange, field);
        if (!useUpdatedInMessage && field.attr !== 'archived_at' && field.attr !== 'excluded_from_auto_archive') {
          msg = 'updated ' + msg;
          useUpdatedInMessage = true;
        }
        changes.push(msg);
        if (field.attr === 'archived_at') {
          applyDisabled = true;
        }
      }
      if (changes.length > 0) {
        return this.makeHistoryItem(asvChange, App.HistorianHelper.makeUpdatedMessage(asvChange.user_name, changes), applyDisabled);
      }
      return null;
    };

    SqlViewHistorian.getDiffMessage = function(asvChange, field) {
      var ref, ref1;
      if (field.attr === 'archived_at') {
        if (!!((ref = asvChange.sql_view_properties) != null ? ref[field.attr] : void 0)) {
          return 'archived this view';
        } else {
          return 'unarchived this view';
        }
      } else if (field.attr === 'excluded_from_auto_archive') {
        if (((ref1 = asvChange.sql_view_properties) != null ? ref1[field.attr] : void 0) === true) {
          return 'excluded this view from Auto Archive';
        } else {
          return 'included this view in Auto Archive';
        }
      } else {
        return field.name;
      }
    };

    SqlViewHistorian.fieldIsDifferent = function(asvChange, asvBase, field) {
      var bAttr, cAttr, ref, ref1;
      cAttr = (ref = asvChange.sql_view_properties) != null ? ref[field.attr] : void 0;
      bAttr = (ref1 = asvBase.sql_view_properties) != null ? ref1[field.attr] : void 0;
      return App.HistorianHelper.fieldIsDifferent(cAttr, bAttr, field);
    };

    return SqlViewHistorian;

  })();

}).call(this);
(function() {
  App.SqlViewState = (function() {
    function SqlViewState(sqlView) {
      this.sqlView = sqlView;
    }

    SqlViewState.prototype.prettyStatus = function() {
      if (this.isMaterializing()) {
        return 'Materializing';
      }
      if (this._isSuspended()) {
        return 'Suspended';
      }
      if (this._hasFailed()) {
        return 'Failed';
      }
      if (this._isQueued()) {
        return 'Queued';
      }
      if (this._hasMaterialized()) {
        return 'Materialized';
      }
      if (this._isScheduled()) {
        return 'Scheduled';
      }
      return 'Not Scheduled';
    };

    SqlViewState.prototype.statusForIcon = function() {
      var dataText;
      dataText = this._hasMaterialized() ? 'cached' : 'uncached';
      if (this._isScheduleEnabled() && this.isMaterializing()) {
        return "dirty-" + dataText;
      }
      if (this._hasErrors()) {
        return "error-" + dataText;
      }
      if (this._hasChangedSinceLastMaterialization()) {
        return "dirty-" + dataText;
      }
      if (this._isCached()) {
        return 'cached';
      }
      return (_.replace(this.prettyStatus().toLowerCase(), ' ', '-')) + "-" + dataText;
    };

    SqlViewState.prototype.nextRunAt = function() {
      var date;
      if (this._nextMaterializeAt() == null) {
        return '--';
      }
      date = App.Utils.formatDateGivenDatetime(this._nextMaterializeAt());
      return date[0] + "  " + date[1];
    };

    SqlViewState.prototype.duration = function() {
      var lastDuration;
      lastDuration = this.sqlView.last_successful_materialize_time_ms;
      if (!((lastDuration != null) && lastDuration > 0)) {
        return '--';
      }
      return App.Utils.roundedAgo(lastDuration);
    };

    SqlViewState.prototype.schedule = function() {
      var schedule, time_interval;
      if (!this._isScheduleEnabled()) {
        return;
      }
      schedule = this.sqlView.cacheSchedules().first();
      if (schedule == null) {
        return "--";
      }
      if (schedule.custom != null) {
        return "Daily: " + (this._prettyTime(schedule.custom));
      } else if (schedule.interval != null) {
        time_interval = App.Utils.roundedAgo(schedule.interval * 1000, false, true);
        return time_interval + " interval";
      }
      return "--";
    };

    SqlViewState.prototype._getNextMaterialization = function() {
      var nextMaterializeAtMoment;
      nextMaterializeAtMoment = moment(this._nextMaterializeAt());
      if ((this._nextMaterializeAt() == null) || this._isSuspended()) {
        return "-";
      }
      if (nextMaterializeAtMoment < moment()) {
        return 'Queued';
      }
      return nextMaterializeAtMoment.calendar();
    };

    SqlViewState.prototype._prettyTime = function(schedule) {
      var hour, hourStr, minute, minuteStr, momentInTimezone, splitSchedule, targetTimezone, timezoneStr, utcMoment;
      splitSchedule = schedule.split(':');
      hour = splitSchedule[0];
      minute = splitSchedule[1];
      utcMoment = moment.utc();
      utcMoment.hours(hour);
      utcMoment.minutes(minute);
      targetTimezone = App.TimeMachine.mapDisplayTimezone(App.Site.first().display_timezone);
      momentInTimezone = App.TimeMachine.timestampToMoment(utcMoment.valueOf(), targetTimezone);
      hourStr = "" + (momentInTimezone.hour());
      minuteStr = ("" + (momentInTimezone.minute())).padStart(2, '0');
      timezoneStr = momentInTimezone.format('z');
      return hourStr + ":" + minuteStr + " " + timezoneStr;
    };

    SqlViewState.prototype._hasChangedSinceLastMaterialization = function() {
      if (this._isScheduleEnabled()) {
        return false;
      }
      return this.sqlView.last_successful_materialize_at < this.sqlView.last_updated_by_user_at;
    };

    SqlViewState.prototype._hasErrors = function() {
      return this.sqlView.error_count > 0;
    };

    SqlViewState.prototype._nextMaterializeAt = function() {
      if (this._isScheduleEnabled()) {
        return this._nextScheduleAt();
      } else {
        return this.sqlView.next_materialize_at;
      }
    };

    SqlViewState.prototype._nextScheduleAt = function() {
      if (this.sqlView.nextScheduleAt != null) {
        return this.sqlView.nextScheduleAt();
      } else {
        return App.SqlView.find(this.sqlView.id).nextScheduleAt();
      }
    };

    SqlViewState.prototype._isScheduleEnabled = function() {
      return App.Site.first().schedulable_views_enabled;
    };

    SqlViewState.prototype._hasFailed = function() {
      return this._isScheduleEnabled() && this._hasErrors() && !this._isSuspended();
    };

    SqlViewState.prototype._isCached = function() {
      return !this._isSuspended() && this._hasMaterialized();
    };

    SqlViewState.prototype._isScheduled = function() {
      return this._isScheduleEnabled() && (this._nextScheduleAt() != null);
    };

    SqlViewState.prototype._isSuspended = function() {
      return this.sqlView.error_count > 9;
    };

    SqlViewState.prototype.isMaterializing = function() {
      return this.sqlView.started_materialization_at != null;
    };

    SqlViewState.prototype._isQueued = function() {
      if (this._getNextMaterialization() === 'Queued') {
        return true;
      }
      return this._hasChangedSinceLastMaterialization();
    };

    SqlViewState.prototype._hasMaterialized = function() {
      return this.sqlView.last_successful_materialize_at != null;
    };

    return SqlViewState;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.TextboxAutosizer = (function() {
    TextboxAutosizer.CSS_COPY_ATTRIBUTES = ['font-size', 'font-family', 'font-weight', 'min-width', 'text-transform', 'text-indent', 'box-sizing', 'border', 'max-width', 'overflow'];

    TextboxAutosizer.MIN_WIDTH = 60;

    TextboxAutosizer.SIZER_CSS_PROPS = {
      display: 'inline-block',
      position: 'absolute',
      left: '-500px',
      top: '-500px',
      opacity: 0
    };

    function TextboxAutosizer(options) {
      var attr, i, len, ref, ref1, val;
      if (options == null) {
        options = {};
      }
      this.resize = bind(this.resize, this);
      this.el = options.textbox;
      this.sizer = jQuery('<div class="textbox-sizer"></div>');
      ref = TextboxAutosizer.SIZER_CSS_PROPS;
      for (attr in ref) {
        val = ref[attr];
        this.sizer.css(attr, val);
      }
      ref1 = TextboxAutosizer.CSS_COPY_ATTRIBUTES;
      for (i = 0, len = ref1.length; i < len; i++) {
        attr = ref1[i];
        this.sizer.css(attr, this.el.css(attr));
      }
      this.el.on('keypress keyup update', this.resize);
      jQuery('body').append(this.sizer);
      this.resize(null);
    }

    TextboxAutosizer.prototype.release = function() {
      this.el.off('keypress keyup update', this.resize);
      this.el.css('width', null);
      return this.sizer.remove();
    };

    TextboxAutosizer.prototype.resize = function(event) {
      var boxWidth, measureText, selectStart, textValue, textWidth;
      textValue = this.el.val();
      selectStart = null;
      if ((event != null) && event.type === 'keypress') {
        event.preventDefault();
        selectStart = this.el[0].selectionStart + 1;
        textValue = textValue.slice(0, this.el[0].selectionStart) + String.fromCharCode(event.charCode) + textValue.slice(this.el[0].selectionEnd, this.el.val().length);
      }
      measureText = textValue;
      if (measureText.trim() === '') {
        measureText = this.el.attr('placeholder');
      }
      textWidth = this.sizer.html(measureText).width();
      boxWidth = [textWidth, TextboxAutosizer.MIN_WIDTH].max();
      this.el.width(boxWidth);
      if (this.el.val() !== textValue) {
        this.el.val(textValue);
        if (selectStart != null) {
          return this.el[0].setSelectionRange(selectStart, selectStart);
        }
      }
    };

    return TextboxAutosizer;

  })();

}).call(this);
(function() {
  App.TimeMachine = (function() {
    var packedZones;

    function TimeMachine() {}

    TimeMachine.LOCAL_STOARGE_CACHE_VERSION = 'v1.1';

    TimeMachine.TIMESTAMP_CACHE = {};

    TimeMachine.SECONDS = 'seconds';

    TimeMachine.MINUTES = 'minutes';

    TimeMachine.HOURLY = 'hourly';

    TimeMachine.DAILY = 'daily';

    TimeMachine.WEEKLY = 'weekly';

    TimeMachine.MONTHLY = 'monthly';

    TimeMachine.QUARTERLY = 'quarterly';

    TimeMachine.YEARLY = 'yearly';

    TimeMachine.DATETIME_REGEX = /^\d{4}\-\d{2}(\-\d{2}([ T]\d{2}:\d{2}:\d{2}(\.\d+)?([-+][0-2]\d(:\d{2})?)?)?)?$/;

    TimeMachine.YEAR_MONTH_REGEX = /^\d{4}\-\d{2}$/;

    TimeMachine.YEAR_WEEK_REGEX = /^(19|20)\d\d[0-5]\d$/;

    TimeMachine.SHORT_TIMEZONE_REGEX = /:.*[-+][0-2]\d$/;

    TimeMachine.TZ_MOMENTS = {};

    TimeMachine.DATE_TYPE_DATE_TIME = 'datetime';

    TimeMachine.DATE_TYPE_YEAR_WEEK = 'yearweek';

    TimeMachine.TZ_MAP = {
      COT: 'America/Bogota',
      PST: 'America/Los_Angeles',
      MST: 'America/Denver',
      CST: 'America/Chicago',
      EST: 'America/New_York',
      PET: 'America/Lima',
      BRT: 'America/Sao_Paulo',
      IST: 'Asia/Calcutta',
      UTC: 'Etc/UTC',
      WET: 'Europe/Belfast',
      CET: 'Europe/Paris',
      EET: 'Europe/Helsinki',
      EAT: 'Africa/Nairobi',
      AWST: 'Australia/Perth',
      ACST: 'Australia/Darwin',
      ACDT: 'Australia/Adelaide',
      AEST: 'Australia/Brisbane',
      AEDT: 'Australia/ACT',
      ISRAEL: 'Asia/Jerusalem',
      WIB: 'Asia/Bangkok',
      MTD: 'Asia/Kuala_Lumpur',
      JST: 'Asia/Tokyo',
      KST: 'Asia/Seoul',
      SGT: 'Asia/Singapore'
    };

    TimeMachine.TZ_NAMES = {
      COT: 'Bogota',
      PST: 'Pacific Time (US & Canada)',
      MST: 'Mountain Time (US & Canada)',
      CST: 'Central Time (US & Canada)',
      EST: 'Eastern Time (US & Canada)',
      PET: 'Lima',
      BRT: 'Brasilia',
      IST: 'India',
      UTC: 'UTC',
      WET: 'Western European Time',
      CET: 'Paris',
      EET: 'Helsinki',
      EAT: 'Nairobi',
      AWST: 'Perth',
      ACST: 'Darwin',
      ACDT: 'Adelaide',
      AEST: 'Brisbane',
      AEDT: 'Australian Eastern Daylight Time',
      ISRAEL: 'Israel',
      WIB: 'Bangkok',
      MTD: 'Kuala Lampur',
      JST: 'Tokyo',
      KST: 'Seoul',
      SGT: 'Singapore'
    };

    packedZones = ["America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0", "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp0 1Vb0 3dB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0", "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0", "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0", "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0", "America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0", "America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0", "Europe/Belfast|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00", "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00", "Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00", "Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ", "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0", "Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0", "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0", "Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0", "Australia/ACT|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0", "Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0", "Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0", "Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4", "Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0", "Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u", "Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0", "Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0", "Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0", "Etc/UTC|UTC|0|0|"];

    moment.tz.add(packedZones);

    TimeMachine.mapDisplayTimezone = function(displayTimezone) {
      var tz;
      if ((displayTimezone == null) || displayTimezone === '') {
        return this.TZ_MAP.UTC;
      }
      tz = this.TZ_MAP[displayTimezone.toUpperCase()];
      if (tz != null) {
        return tz;
      } else {
        AppRedesign.logError(new Error("Unknown displayTimezone: " + displayTimezone + ", defaulting to UTC."));
        return this.TZ_MAP.UTC;
      }
    };

    TimeMachine.dateTimeType = function(input) {
      if (this.DATETIME_REGEX.test(input)) {
        return App.TimeMachine.DATE_TYPE_DATE_TIME;
      }
      if (this.YEAR_WEEK_REGEX.test(input)) {
        return App.TimeMachine.DATE_TYPE_YEAR_WEEK;
      }
      return null;
    };

    TimeMachine.parseDateTimeToTimestamp = function(input, targetTimezone, startOfWeek, allowBadDates) {
      return this.parseDateTimeToTimestamp(input, targetTimezone, startOfWeek, false);
    };

    TimeMachine.parseDateTimeToTimestamp = function(input, targetTimezone, startOfWeek, allowBadDates) {
      var cached, m, ts;
      targetTimezone || (targetTimezone = 'America/Los_Angeles');
      cached = this.cached(input, targetTimezone, startOfWeek);
      if (cached !== void 0) {
        return cached;
      }
      m = this.uncachedParseDateTimeToMoment(input, targetTimezone, startOfWeek);
      if (m != null) {
        ts = m.valueOf();
      } else {
        ts = null;
        if (allowBadDates) {
          ts = input;
        }
      }
      this.cache(input, targetTimezone, startOfWeek, ts);
      return ts;
    };

    TimeMachine.timestampToMoment = function(timestamp, targetTimezone) {
      return moment.tz(timestamp, targetTimezone);
    };

    TimeMachine.stripTimezone = function(input) {
      var pos;
      pos = Math.max(input.lastIndexOf('+'), input.lastIndexOf('-'));
      if (!(pos > 10)) {
        return input;
      }
      return input.substr(0, pos);
    };

    TimeMachine.uncachedParseDateTimeToMoment = function(input, targetTimezone, startOfWeek) {
      var modifiedInput;
      if (input == null) {
        return input;
      }
      if (input.length > 10) {
        modifiedInput = this.stripTimezone(input);
        return moment.tz(modifiedInput, targetTimezone);
      } else if (input.length === 10) {
        return this.parseYearMonthDay(input, targetTimezone);
      } else if (input.length === 6) {
        return this.parseYearWeek(input, targetTimezone, startOfWeek);
      } else if (input.length === 7) {
        return moment.tz(input + '-01', targetTimezone);
      }
    };

    TimeMachine.parseYearWeek = function(input, targetTimezone, startOfWeek) {
      var offset, week, year;
      year = parseFloat(input.slice(0, 4));
      week = parseFloat(input.slice(4, 6));
      offset = (startOfWeek >= 0 ? 1 : 0);
      return moment('2015-06-01').tz(targetTimezone).year(year).isoWeekday(startOfWeek).startOf('day').week(week + offset);
    };

    TimeMachine.timezoneDateMoment = function(targetTimezone) {
      var existing, m;
      existing = this.TZ_MOMENTS[targetTimezone];
      if (existing != null) {
        return existing;
      }
      m = moment().tz(targetTimezone).startOf('day');
      this.TZ_MOMENTS[targetTimezone] = m;
      return m;
    };

    TimeMachine.parseYearMonthDay = function(input, targetTimezone) {
      var date, dateStr, m, month, monthStr, parts, year;
      m = this.timezoneDateMoment(targetTimezone);
      parts = input.split('-');
      if (parts.length !== 3) {
        return null;
      }
      year = parseInt(parts[0]);
      monthStr = parts[1];
      dateStr = parts[2];
      if (monthStr[0] === '0') {
        monthStr = monthStr[1];
      }
      if (dateStr[0] === '0') {
        dateStr = dateStr[1];
      }
      month = parseInt(monthStr);
      date = parseInt(dateStr);
      this.adjustForDST(m, input, year, month, date);
      return m;
    };

    TimeMachine.adjustForDST = function(m, input, year, month, date) {
      var testInput;
      testInput = m.year(year).month(month - 1).date(date).hour(0).format('YYYY-MM-DD');
      while (testInput !== input) {
        testInput = m.add(1, 'hour').format('YYYY-MM-DD');
      }
      return testInput;
    };

    TimeMachine.formatTimestamp = function(epoch, format) {
      if (format == null) {
        format = 'YYYY-MM-DD';
      }
      return this.timestampToMoment(epoch).format(format);
    };

    TimeMachine.formatMomentAsAggregation = function(moment, aggregation) {
      if (aggregation === this.DAILY) {
        return moment.format('ddd, MMM D, YYYY');
      } else if (aggregation === this.WEEKLY) {
        return 'Week of ' + moment.format('MMM D, YYYY');
      } else if (aggregation === this.MONTHLY) {
        return moment.format('MMMM YYYY');
      } else if (aggregation === this.QUARTERLY) {
        return 'Q' + moment.format('Q YYYY');
      } else if (aggregation === this.HOURLY) {
        return moment.format('MMM D, YYYY H:mm');
      } else if (aggregation === this.MINUTES) {
        return moment.format('MMM D, YYYY H:mm');
      } else if (aggregation === this.SECONDS) {
        return moment.format('MMM D, YYYY H:mm:ss');
      } else if (aggregation === this.YEARLY) {
        return moment.format('YYYY');
      } else {
        return moment.format('MMM D, YYYY H:mm:ss.SSS A');
      }
    };

    TimeMachine.maybeWriteCache = function() {
      if (TimeMachine._writeSoon) {
        return;
      }
      return TimeMachine._writeSoon = setTimeout((function() {
        TimeMachine.saveCacheToLocalStorage();
        return delete TimeMachine._writeSoon;
      }), 1000);
    };

    TimeMachine.clearCache = function() {
      return this.TIMESTAMP_CACHE = {};
    };

    TimeMachine.cache = function(input, targetTimezone, startOfWeek, timestamp, fromTs) {
      var base, base1, base2;
      if (fromTs == null) {
        fromTs = false;
      }
      (base = this.TIMESTAMP_CACHE)[startOfWeek] || (base[startOfWeek] = {});
      (base1 = this.TIMESTAMP_CACHE[startOfWeek])[targetTimezone] || (base1[targetTimezone] = {});
      (base2 = this.TIMESTAMP_CACHE[startOfWeek][targetTimezone])[input] || (base2[input] = {});
      this.TIMESTAMP_CACHE[startOfWeek][targetTimezone][input] = timestamp;
      return TimeMachine.maybeWriteCache();
    };

    TimeMachine.cached = function(input, targetTimezone, startOfWeek) {
      var ref, ref1, ts;
      return ts = (ref = this.TIMESTAMP_CACHE[startOfWeek]) != null ? (ref1 = ref[targetTimezone]) != null ? ref1[input] : void 0 : void 0;
    };

    TimeMachine.saveCacheToLocalStorage = function() {
      if (!App.LocalStorage.isEnabled()) {
        return;
      }
      this.TIMESTAMP_CACHE['version'] = TimeMachine.LOCAL_STOARGE_CACHE_VERSION;
      return App.LocalStorage.setItem('ts.timestamp_cache', JSON.stringify(this.TIMESTAMP_CACHE));
    };

    TimeMachine.readCacheFromLocalStorage = function() {
      var data, dataObj;
      if (!App.LocalStorage.isEnabled()) {
        return;
      }
      data = App.LocalStorage.getItem('ts.timestamp_cache');
      if (data == null) {
        return null;
      }
      dataObj = JSON.parse(data);
      if (dataObj['version'] === TimeMachine.LOCAL_STOARGE_CACHE_VERSION) {
        return this.TIMESTAMP_CACHE = dataObj;
      } else {
        return App.LocalStorage.removeItem('ts.timestamp_cache');
      }
    };

    return TimeMachine;

  })();

  moment().constructor.prototype.getTime = moment().constructor.prototype.valueOf;

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.TitleFormatter = (function() {
    TitleFormatter.INSERTION_REGEX = new RegExp(/\[(.+?)(\|.+?)?\]/g);

    function TitleFormatter(widget) {
      this.widget = widget;
      this.doReplacement = bind(this.doReplacement, this);
      1;
    }

    TitleFormatter.prototype.formatChartTitle = function(str) {
      return str.replace(TitleFormatter.INSERTION_REGEX, this.doReplacement);
    };

    TitleFormatter.prototype.doReplacement = function(str, matchStr, defaultStr) {
      var lowerCaseMatchStr, r;
      if (defaultStr != null) {
        defaultStr = defaultStr.replace('|', '');
      }
      lowerCaseMatchStr = matchStr.toLowerCase();
      if (lowerCaseMatchStr === 'aggregation') {
        r = this.replaceAggregation();
      } else if (lowerCaseMatchStr === 'daterange') {
        r = this.replaceDateRange();
      } else {
        r = this.replaceDimension(lowerCaseMatchStr, defaultStr);
      }
      if (r != null) {
        if (matchStr[0] === matchStr[0].toUpperCase()) {
          r = r.titleize();
        }
        return r;
      }
      return str;
    };

    TitleFormatter.prototype.replaceAggregation = function() {
      return this.widget.filters().aggregation || 'daily';
    };

    TitleFormatter.prototype.replaceDateRange = function(dashboard) {
      var dr;
      dr = this.widget.filters().date_range_dimension;
      return App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(dr).toLowerCase();
    };

    TitleFormatter.prototype.replaceDimension = function(lowerCaseMatchStr, defaultStr) {
      var cd, cd_udv_values, udv_match, values;
      cd = App.CustomDimension.findByName(lowerCaseMatchStr);
      if (cd != null) {
        if (cd.isDateRange()) {
          cd_udv_values = this.widget.valuesForCustomDimension(cd.id);
          if ((cd_udv_values != null) && !cd_udv_values.isEmpty()) {
            udv_match = cd_udv_values[0];
          }
          if ((udv_match != null) && !udv_match.isEmpty()) {
            return App.RedesignDateRangeDimensionSetting.labelForDateRangeTitles(udv_match[1]).toLowerCase();
          }
        } else {
          values = this.widget.getActiveDimensionValueNames(cd.id);
          if (values.isEmpty()) {
            return defaultStr || 'all';
          } else {
            return values.join(', ').trim();
          }
        }
      }
    };

    return TitleFormatter;

  })();

}).call(this);
(function() {
  App.Tooltip = (function() {
    function Tooltip() {}

    Tooltip.PERCENT = 'percent';

    Tooltip.DOLLAR = 'dollar';

    Tooltip.NUMBER = 'number';

    Tooltip.CURRENCY = 'currency';

    Tooltip.DEFAULT_VALUE_FORMAT = Tooltip.NUMBER;

    Tooltip.EURO = 'euro';

    Tooltip.POUND = 'pound';

    Tooltip.KRW = 'won';

    Tooltip.INR = 'rupee';

    Tooltip.SEK = 'SEK';

    Tooltip.TRY = 'TRY';

    Tooltip.SUFFIX_CURRENCY = {
      'SEK': true,
      'kr': true
    };

    Tooltip.CURRENCY_SYMBOL = {};

    Tooltip.CURRENCY_SYMBOL[Tooltip.EURO] = '€';

    Tooltip.CURRENCY_SYMBOL[Tooltip.DOLLAR] = '$';

    Tooltip.CURRENCY_SYMBOL[Tooltip.POUND] = '£';

    Tooltip.CURRENCY_SYMBOL[Tooltip.KRW] = '₩';

    Tooltip.CURRENCY_SYMBOL[Tooltip.INR] = '₹';

    Tooltip.CURRENCY_SYMBOL[Tooltip.SEK] = 'kr';

    Tooltip.CURRENCY_SYMBOL[Tooltip.TRY] = '₺';

    Tooltip.CURRENCY_SYMBOLS = ['$', '€', '£', '₩', '₹', 'kr', '₺'];

    return Tooltip;

  })();

}).call(this);
(function() {
  App.TwiddleConfig = (function() {
    function TwiddleConfig() {}

    TwiddleConfig.SEGMENT_COLUMN = "twiddle_segment_column";

    TwiddleConfig.PROPORTIONAL = "twiddle_proportional";

    TwiddleConfig.KEEP_TABLE_COLUMN_UNDERSCORES = "twiddle_keep_table_column_underscores";

    TwiddleConfig.TABLE_LINE_NUMBERS = "twiddle_table_line_numbers";

    TwiddleConfig.TABLE_ALIGNMENT_CHECKED = "twiddle_table_alignment_checked";

    TwiddleConfig.TABLE_ALIGNMENT = "twiddle_table_alignment";

    TwiddleConfig.CUMULATIVE = "twiddle_cumulative";

    TwiddleConfig.OVERLAY_CUMULATIVE = "twiddle_overlay_cumulative";

    TwiddleConfig.OVERLAY_TEXT_SIZE = "twiddle_overlay_text_size";

    TwiddleConfig.OVERLAY_VALUE_ON_HOVER = "twiddle_overlay_value_on_hover";

    TwiddleConfig.OVERLAY_HAS_ONE_DATA_POINT = "overlay_has_one_data_point";

    TwiddleConfig.TOOLTIP_TOTAL = "twiddle_tooltip_total";

    TwiddleConfig.GROUPED_BARS = "twiddle_grouped_bars";

    TwiddleConfig.DETAIL_COLUMNS = "twiddle_detail_columns";

    TwiddleConfig.DETAIL_SERIES = "detail_series";

    TwiddleConfig.VALUES_FORMAT = "twiddle_values_format";

    TwiddleConfig.VALUES_FORMAT_ORIGINAL = "values_format_original";

    TwiddleConfig.MIN_X_AXIS = "twiddle_min_x_axis";

    TwiddleConfig.MAX_X_AXIS = "twiddle_max_x_axis";

    TwiddleConfig.X_AXIS_SHOW_ALL_LABELS = "twiddle_x_axis_show_all_labels";

    TwiddleConfig.MIN_Y_AXIS = "twiddle_min_y_axis";

    TwiddleConfig.MAX_Y_AXIS = "twiddle_max_y_axis";

    TwiddleConfig.Y_AXIS_INTERVAL = "twiddle_y_axis_interval";

    TwiddleConfig.Y_AXIS_FIT = "twiddle_y_axis_fit";

    TwiddleConfig.X_AXIS_INTERVAL = "twiddle_x_axis_interval";

    TwiddleConfig.Y2_AXIS_INTERVAL = "twiddle_y2_axis_interval";

    TwiddleConfig.Y2_AXIS_FIT = "twiddle_y2_axis_fit";

    TwiddleConfig.Y_AXIS_FORMAT = "twiddle_y_axis_format";

    TwiddleConfig.Y2_AXIS_FORMAT = "twiddle_y2_axis_format";

    TwiddleConfig.MIN_Y2_AXIS = "twiddle_min_y2_axis";

    TwiddleConfig.MAX_Y2_AXIS = "twiddle_max_y2_axis";

    TwiddleConfig.PIVOT_COLUMN = "twiddle_pivot_column";

    TwiddleConfig.UNPIVOTED_COLUMN = "twiddle_unpivoted_column";

    TwiddleConfig.COHORT_DETAIL_COLUMNS = "twiddle_cohort_detail_columns";

    TwiddleConfig.NO_COHORT_COLOR = "twiddle_no_cohort_color";

    TwiddleConfig.COHORT_SORT_ORDER = "twiddle_cohort_sort_order";

    TwiddleConfig.COHORT_NO_ROW_TOTALS = "twiddle_cohort_no_row_totals";

    TwiddleConfig.CURRENCY = "twiddle_currency";

    TwiddleConfig.DATA_LABELS = "twiddle_data_labels";

    TwiddleConfig.SERIES_NO_OTHER = "twiddle_series_no_other";

    TwiddleConfig.MAX_SERIES_BEFORE_OTHER = "twiddle_max_series_before_other";

    TwiddleConfig.DO_NOT_SORT_SERIES = "twiddle_do_not_sort_series";

    TwiddleConfig.DO_NOT_RESORT_FOR_LEGEND = "twiddle_do_not_resort_for_legend";

    TwiddleConfig.DO_NOT_SHOW_LEGEND = "twiddle_do_not_show_legend";

    TwiddleConfig.SHOW_VALUES_IN_LEGEND = "twiddle_show_values_in_legend";

    TwiddleConfig.TRANSPOSE_TABLE = "twiddle_transpose_table";

    TwiddleConfig.GEOMAP_PLOT_MODE = "twiddle_geomap_plot_mode";

    TwiddleConfig.GEOMAP_DATA_MODE = "twiddle_geomap_data_mode";

    TwiddleConfig.GEOMAP_WEIGHT_COLUMNS = "twiddle_geomap_weight_columns";

    TwiddleConfig.GEOMAP_SATELLITE_TILES = "twiddle_geomap_satellite_tiles";

    TwiddleConfig.GEOMAP_LATITUDE = "geomap_latitude";

    TwiddleConfig.GEOMAP_LONGITUDE = "geomap_longitude";

    TwiddleConfig.GEOMAP_ZOOM = "geomap_zoom";

    TwiddleConfig.CONDITIONAL_FORMATTING = 'conditional_formatting';

    TwiddleConfig.FILL_NULL_VALUES = "twiddle_fill_null_values";

    TwiddleConfig.FILL_NULL_VALUES_STRATEGY = "twiddle_fill_null_values_strategy";

    TwiddleConfig.DO_NOT_ROUND_BIG_NUMBER = "do_not_round_big_number";

    TwiddleConfig.TITLE_CASE_SERIES_NAMES = "twiddle_title_case_series_names";

    TwiddleConfig.X_AXIS_TITLE = "twiddle_x_axis_title";

    TwiddleConfig.Y_AXIS_TITLE = "twiddle_y_axis_title";

    TwiddleConfig.Y2_AXIS_TITLE = "twiddle_y2_axis_title";

    TwiddleConfig.AVERAGE_LINES_ENABLED = "twiddle_average_lines_enabled";

    TwiddleConfig.AVERAGE_LINES_NUM_LEADING = "twiddle_average_lines_num_leading";

    TwiddleConfig.AVERAGE_LINES_NUM_TRAILING = "twiddle_average_lines_num_trailing";

    TwiddleConfig.TRENDLINE_ENABLED = "twiddle_trendline_enabled";

    TwiddleConfig.HORIZONTAL_BARS = "twiddle_horizontal_bars";

    TwiddleConfig.MULTIPLE_Y_AXES = "twiddle_multiple_y_axes";

    TwiddleConfig.SECOND_AXIS_CHART_TYPE = "second_axis_chart_type";

    TwiddleConfig.MULTIPLE_Y_AXES_COLUMNS = "twiddle_multiple_y_axes_columns";

    TwiddleConfig.SECOND_AXIS_PERCENT = "twiddle_second_axis_percent";

    TwiddleConfig.TOOLTIP_SERIES_NAME_VISIBLE = 'twiddle_series_name_visible';

    TwiddleConfig.HORIZONTAL = 'horizontal';

    TwiddleConfig.TIMEZONE = 'timezone';

    TwiddleConfig.START_OF_WEEK = 'start_of_week';

    TwiddleConfig.X_AXIS_TYPE = 'x_axis_type';

    TwiddleConfig.POINT_COLS = 'point_cols';

    TwiddleConfig.VALUE_COLS = 'value_cols';

    TwiddleConfig.Y_AXIS_ENABLED_COLUMNS = 'twiddle_y_axis_enabled_columns';

    TwiddleConfig.TITLEIZE_ALL_LABELS = 'titleize_all_labels';

    TwiddleConfig.COLUMNAR_SERIES = 'columnar_series';

    TwiddleConfig.AGGREGATION = 'aggregation';

    TwiddleConfig.HOURLY_TIMESERIES = 'hourly_timeseries';

    TwiddleConfig.TABLE_TOTAL_COLUMN = 'table_total_column';

    TwiddleConfig.TABLE_RIGHT_ALIGN_NUMBERS = 'table_right_align_numbers';

    TwiddleConfig.CONTINUOUS_X_AXIS = 'continuous_x_axis';

    TwiddleConfig.ROTATE_X_AXIS_LABELS = 'rotate_x_axis_labels';

    TwiddleConfig.INSERTOTRON_SEGMENT_COLUMNS = 'twiddle_insertotron_segment_columns';

    TwiddleConfig.AUTO_Y2 = 'twiddle_auto_y2';

    TwiddleConfig.NEW_LOGIC = 'new_logic';

    TwiddleConfig.HIDE_TABLE_GRID_LINES = 'hide_table_grid_lines';

    TwiddleConfig.HIDE_LEGEND_STRATEGY = 'twiddle_hide_legend_strategy';

    TwiddleConfig.HIDE_LEGEND_FOR_SINGLE_SERIES = 'twiddle_hide_legend_for_single_series';

    TwiddleConfig.LEGEND_POSITION = 'twiddle_legend_position';

    TwiddleConfig.LEGEND_WIDTH = 'twiddle_legend_width';

    TwiddleConfig.ANNOTATION_GROUPS = 'twiddle_annotation_groups';

    TwiddleConfig.WIDGET_ANNOTATION_GROUP = 'twiddle_widget_annotation_group';

    TwiddleConfig.DRILLDOWN_DASHBOARD = 'twiddle_drilldown_dashboard';

    TwiddleConfig.DRILLDOWN_MAPPING = 'twiddle_drilldown_mapping';

    TwiddleConfig.USE_PIVOT_SETTINGS = 'twiddle_use_pivot_settings';

    TwiddleConfig.OVERLAY_ZOOM = 'overlay_zoom';

    TwiddleConfig.DATA_BARS = 'data_bars';

    TwiddleConfig.ANIMATE_ON_DASHBOARD = 'twiddle_animate_on_dashboard';

    TwiddleConfig.X_AXIS_SORT_BY = 'twiddle_x_axis_sort_by';

    TwiddleConfig.X_AXIS_SORT_DIR = 'twiddle_x_axis_sort_dir';

    TwiddleConfig.SERIES_SORT_BY = 'twiddle_series_sort_by';

    TwiddleConfig.SERIES_SORT_DIR = 'twiddle_series_sort_dir';

    TwiddleConfig.LIMIT_FIRST_BY = 'twiddle_limit_first_by';

    TwiddleConfig.TABLE_COLOR_HEADER_TEXT = 'twiddle_table_color_header_text';

    TwiddleConfig.TABLE_COLOR_HEADER_BACKGROUND = 'twiddle_table_color_header_background';

    TwiddleConfig.TABLE_COLOR_ODD_ROWS_TEXT = 'twiddle_table_color_odd_rows_text';

    TwiddleConfig.TABLE_COLOR_ODD_ROWS_BACKGROUND = 'twiddle_table_color_odd_rows_background';

    TwiddleConfig.TABLE_COLOR_EVEN_ROWS_TEXT = 'twiddle_table_color_even_rows_text';

    TwiddleConfig.TABLE_COLOR_EVEN_ROWS_BACKGROUND = 'twiddle_table_color_even_rows_background';

    TwiddleConfig.SECONDARY_AXIS_ENABLED = 'twiddle_secondary_axis_enabled';

    TwiddleConfig.SECONDARY_AXIS_SERIES_NAMES = 'twiddle_secondary_axis_series_names';

    TwiddleConfig.VALUE_COLUMN_TYPE = 'twiddle_value_column_type';

    TwiddleConfig.CHART_TYPE = 'twiddle_chart_type';

    TwiddleConfig.USE_DEFAULT_CHART_TYPE = 'twiddle_use_default_chart_type';

    TwiddleConfig.USE_EXPLICIT_POINT_COLS = 'twiddle_use_explicit_point_cols';

    TwiddleConfig.USE_EXPLICIT_SEGMENT_COLUMN = 'twiddle_use_explicit_segment_column';

    TwiddleConfig.USE_EXPLICIT_VALUE_COLS = 'twiddle_use_explicit_value_cols';

    TwiddleConfig.DRAG_DROP_CHART = 'twiddle_drag_drop_chart';

    TwiddleConfig.SERIES_NAMES = 'twiddle_series_names';

    TwiddleConfig.COLUMN_NAMES = 'twiddle_column_names';

    TwiddleConfig.SERIES = 'series';

    TwiddleConfig.SERIES_COLOR = 'series_color';

    TwiddleConfig.SERIES_LEGEND_COLOR = 'series_legend_color';

    TwiddleConfig.SERIES_NAME_VISIBLE = 'series_name_visible';

    TwiddleConfig.SERIES_SHOW_ON_SECONDARY_AXIS = 'series_show_on_secondary_axis';

    TwiddleConfig.SERIES_SHOW_ON_PRIMARY_AXIS = 'series_show_on_primary_axis';

    TwiddleConfig.SERIES_CHART_TYPE = 'series_chart_type';

    TwiddleConfig.SERIES_PROPORTIONAL = 'series_proportional';

    TwiddleConfig.SERIES_VALUES_FORMAT = 'series_values_format';

    TwiddleConfig.SERIES_AVERAGE_LINES_ENABLED = 'series_average_lines_enabled';

    TwiddleConfig.SERIES_AVERAGE_LINES_NUM_LEADING = 'average_lines_num_leading';

    TwiddleConfig.SERIES_AVERAGE_LINES_NUM_TRAILING = 'average_lines_num_trailing';

    TwiddleConfig.SERIES_TRENDLINE_ENABLED = 'series_trendline_enabled';

    TwiddleConfig.SERIES_CUMULATIVE = 'series_cumulative';

    TwiddleConfig.SERIES_DATA_LABELS = 'series_data_labels';

    TwiddleConfig.SERIES_HORIZONTAL_BARS = 'series_horizontal_bars';

    TwiddleConfig.SERIES_GROUPED_BARS = 'series_grouped_bars';

    TwiddleConfig.SERIES_SECOND_AXIS_PERCENT = 'series_second_axis_percent';

    TwiddleConfig.SERIES_DISPLAY_NAME = 'series_display_name';

    TwiddleConfig.SERIES_SYNTHETIC_SERIES_TYPE = 'serires_synthetic_series_type';

    TwiddleConfig.SERIES_GEOMAP_PLOT_MODE = 'series_geomap_plot_mode';

    TwiddleConfig.SERIES_TYPE = 'series_type';

    TwiddleConfig.SERIES_WIDTH = 'series_width';

    TwiddleConfig.SERIES_ALIGNMENT = 'series_alignment';

    TwiddleConfig.SERIES_VALUE_FORMAT = 'series_value_format';

    TwiddleConfig.SERIES_VALUE_AGGREGATION = 'series_value_aggregation';

    TwiddleConfig.SERIES_NUM_DECIMALS = 'series_num_decimals';

    TwiddleConfig.SERIES_CURRENCY = 'series_currency';

    TwiddleConfig.SERIES_TABLE_TOTAL_COLUMN = 'series_table_total_column';

    TwiddleConfig.COLUMN_TYPE = 'column_type';

    TwiddleConfig.COLUMN_USE_AS_VALUE = 'use_as_value';

    TwiddleConfig.COLUMN_WIDTH = 'column_width';

    TwiddleConfig.COLUMN_ALIGNMENT = 'column_alignment';

    TwiddleConfig.COLUMN_VALUE_FORMAT = 'column_value_format';

    TwiddleConfig.COLUMN_VALUE_AGGREGATION = 'column_value_aggregation';

    TwiddleConfig.COLUMN_NUM_DECIMALS = 'column_num_decimals';

    TwiddleConfig.COLUMN_CURRENCY = 'column_currency';

    TwiddleConfig.COLUMN_TABLE_TOTAL_COLUMN = 'column_table_total_column';

    TwiddleConfig.COLUMN_IMAGE_HEIGHT = 'column_image_height';

    TwiddleConfig.COLUMN_IMAGE_WIDTH = 'column_image_width';

    TwiddleConfig.COLUMN_FILTER_CONDITION = 'column_filter_condition';

    TwiddleConfig.COLUMN_FILTER_VALUE = 'column_filter_value';

    TwiddleConfig.FILTER_COLUMNS = 'filter_columns';

    TwiddleConfig.VALUE_COLUMNS = 'value_columns';

    TwiddleConfig.DRAGDROP = 'dragDrop';

    TwiddleConfig.isTwiddle = function(k) {
      return App.TwiddleConfig.hasOwnProperty(k.toUpperCase().replace("TWIDDLE_", ""));
    };

    TwiddleConfig.hasTwiddle = function(twiddles, k) {
      if (!App.TwiddleConfig.isTwiddle(k)) {
        throw new Error("No twiddle named " + k);
      }
      return twiddles[k] != null;
    };

    TwiddleConfig.getTwiddle = function(twiddles, k) {
      if (!App.TwiddleConfig.isTwiddle(k)) {
        throw new Error("No twiddle named " + k);
      }
      return twiddles[k];
    };

    TwiddleConfig.setTwiddle = function(twiddles, k, v) {
      if (!App.TwiddleConfig.isTwiddle(k)) {
        throw new Error("No twiddle named " + k);
      }
      if (App.TwiddleConfig.getTwiddle(twiddles, k) === v) {
        return false;
      }
      if (v != null) {
        twiddles[k] = v;
      } else {
        delete twiddles[k];
      }
      return true;
    };

    return TwiddleConfig;

  })();

}).call(this);
(function() {
  App.TwiddleMap = (function() {
    TwiddleMap.TWIDDLE_PREFIX = 'twiddle_';

    TwiddleMap.SERIES_PREFIX = 'series_';

    TwiddleMap.COLUMN_PREFIX = 'column_';

    function TwiddleMap(twiddles, readOnly) {
      this.twiddles = jQuery.extend(true, {}, twiddles);
      this.readOnly = readOnly;
    }

    TwiddleMap.prototype.get = function(twiddle) {
      this.requireRealTwiddle(twiddle);
      return this.getValue(twiddle);
    };

    TwiddleMap.prototype.getForSeries = function(seriesName, twiddle) {
      this.requireRealSeriesTwiddle(twiddle);
      return this.getSeriesValue(seriesName, twiddle);
    };

    TwiddleMap.prototype.getArray = function(twiddle) {
      this.requireRealTwiddle(twiddle);
      return this.getValue(twiddle) || [];
    };

    TwiddleMap.prototype.checkAndSetTwiddle = function(twiddle, value, override) {
      if (this.readOnly) {
        throw new Error("Can't set twiddles if readonly");
      }
      this.requireRealTwiddle(twiddle);
      if (!override && (this.getValue(twiddle) != null)) {
        throw new Error("Already set twiddle " + twiddle + ".");
      }
      return this.twiddles[twiddle] = value;
    };

    TwiddleMap.prototype.set = function(twiddle, value) {
      return this.checkAndSetTwiddle(twiddle, value, false);
    };

    TwiddleMap.prototype.setWithOverride = function(twiddle, value) {
      return this.checkAndSetTwiddle(twiddle, value, true);
    };

    TwiddleMap.prototype.checkAndSetSeriesTwiddle = function(seriesName, twiddle, value, override) {
      var base, base1;
      if (this.readOnly) {
        throw new Error("Can't set series twiddles if readonly");
      }
      this.requireRealSeriesTwiddle(twiddle);
      if (!override && (this.getSeriesValue(seriesName, twiddle) != null)) {
        throw new Error("Already set series twiddle " + twiddle + ".");
      }
      (base = this.twiddles).series || (base.series = {});
      (base1 = this.twiddles.series)[seriesName] || (base1[seriesName] = {});
      return this.twiddles.series[seriesName][TwiddleMap.SERIES_PREFIX + twiddle] = value;
    };

    TwiddleMap.prototype.anySeriesDifferent = function(twiddle, value) {
      var ref, series, seriesTwiddles, seriesValue;
      ref = this.twiddles.series || {};
      for (series in ref) {
        seriesTwiddles = ref[series];
        seriesValue = seriesTwiddles[twiddle];
        if ((seriesValue != null) && seriesValue !== value) {
          return true;
        }
      }
      return false;
    };

    TwiddleMap.prototype.setForSeries = function(seriesName, twiddle, value) {
      return this.checkAndSetSeriesTwiddle(seriesName, twiddle, value, false);
    };

    TwiddleMap.prototype.setForSeriesWithOverride = function(seriesName, twiddle, value) {
      return this.checkAndSetSeriesTwiddle(seriesName, twiddle, value, true);
    };

    TwiddleMap.prototype.getForColumn = function(columnName, twiddle) {
      this.requireRealColumnTwiddle(twiddle);
      return this.getColumnValue(columnName, twiddle);
    };

    TwiddleMap.prototype.setForColumn = function(columnName, twiddle, value) {
      var base, base1;
      if (this.readOnly) {
        throw "Can't set column twiddles if readonly";
      }
      this.requireRealColumnTwiddle(twiddle);
      if (this.getColumnValue(columnName, twiddle) != null) {
        throw new Error("Already set column twiddle " + twiddle + ".");
      }
      (base = this.twiddles).columns || (base.columns = {});
      (base1 = this.twiddles.columns)[columnName] || (base1[columnName] = {});
      if (value != null) {
        return this.twiddles.columns[columnName][TwiddleMap.COLUMN_PREFIX + twiddle] = value;
      }
    };

    TwiddleMap.prototype.setForColumnWithOverride = function(columnName, twiddle, value) {
      var base, base1;
      if (this.readOnly) {
        throw "Can't set column twiddles if readonly";
      }
      this.requireRealColumnTwiddle(twiddle);
      (base = this.twiddles).columns || (base.columns = {});
      (base1 = this.twiddles.columns)[columnName] || (base1[columnName] = {});
      if (value != null) {
        return this.twiddles.columns[columnName][TwiddleMap.COLUMN_PREFIX + twiddle] = value;
      }
    };

    TwiddleMap.prototype.deleteForColumn = function(columnName, twiddle) {
      this.requireRealColumnTwiddle(twiddle);
      return this.deleteColumnValue(columnName, twiddle);
    };

    TwiddleMap.prototype.colummnsWithValue = function(twiddle, value) {
      var columnNames;
      this.requireRealColumnTwiddle(twiddle);
      columnNames = _.keys(this.twiddles.columns);
      return columnNames.filter((function(_this) {
        return function(columnName) {
          return _this.getForColumn(columnName, twiddle) === value;
        };
      })(this));
    };

    TwiddleMap.prototype.cloneSeries = function(cloneFromSeriesName, cloneToSeriesName, overrides) {
      var clonedProperties, results, twiddle, value;
      clonedProperties = $.extend(true, {}, this.twiddles.series[cloneFromSeriesName]);
      this.twiddles.series[cloneToSeriesName] = clonedProperties;
      results = [];
      for (twiddle in overrides) {
        value = overrides[twiddle];
        results.push(this.twiddles.series[cloneToSeriesName][TwiddleMap.SERIES_PREFIX + twiddle] = value);
      }
      return results;
    };

    TwiddleMap.readOnly = function(twiddles) {
      return new App.TwiddleMap(twiddles, true);
    };

    TwiddleMap.readWrite = function(twiddles) {
      return new App.TwiddleMap(twiddles, false);
    };

    TwiddleMap.prototype.getValue = function(twiddle) {
      if (this.twiddles[twiddle] != null) {
        return this.twiddles[twiddle];
      }
      return this.twiddles[TwiddleMap.TWIDDLE_PREFIX + twiddle];
    };

    TwiddleMap.prototype.getSeriesValue = function(seriesName, twiddle) {
      var ref, seriesTwiddles;
      seriesTwiddles = (ref = this.twiddles.series) != null ? ref[seriesName] : void 0;
      if (seriesTwiddles == null) {
        return void 0;
      }
      return seriesTwiddles[TwiddleMap.SERIES_PREFIX + twiddle];
    };

    TwiddleMap.prototype.requireRealSeriesTwiddle = function(twiddle) {
      if (!App.TwiddleConfig.isTwiddle(TwiddleMap.SERIES_PREFIX + twiddle)) {
        throw new Error("No series twiddle named " + twiddle);
      }
    };

    TwiddleMap.prototype.getColumnValue = function(columnName, twiddle) {
      var columnTwiddles, ref;
      columnTwiddles = (ref = this.twiddles.columns) != null ? ref[columnName] : void 0;
      if (columnTwiddles == null) {
        return void 0;
      }
      return columnTwiddles[TwiddleMap.COLUMN_PREFIX + twiddle];
    };

    TwiddleMap.prototype.deleteColumnValue = function(columnName, twiddle) {
      var columnTwiddles, ref;
      columnTwiddles = (ref = this.twiddles.columns) != null ? ref[columnName] : void 0;
      if (columnTwiddles == null) {
        return;
      }
      return delete columnTwiddles[TwiddleMap.COLUMN_PREFIX + twiddle];
    };

    TwiddleMap.prototype.requireRealColumnTwiddle = function(twiddle) {
      if (!App.TwiddleConfig.isTwiddle(TwiddleMap.COLUMN_PREFIX + twiddle)) {
        throw new Error("No column twiddle named " + twiddle);
      }
    };

    TwiddleMap.prototype.requireRealTwiddle = function(twiddle) {
      if (!App.TwiddleConfig.isTwiddle(twiddle)) {
        throw new Error("No twiddle named " + twiddle);
      }
    };

    TwiddleMap.prototype.columnHasNumericFormatting = function(columnName) {
      var valueFormat;
      valueFormat = this.getForColumn(columnName, 'value_format');
      return App.ChartFormatters.NUMERIC_CELL_FORMATS.includes(valueFormat);
    };

    TwiddleMap.prototype.columnIsNumeric = function(columnName) {
      return this.getForColumn(columnName, 'type') === 'numeric';
    };

    TwiddleMap.prototype.columnTableTotalEnabled = function(columnName) {
      return this.columnIsNumeric(columnName);
    };

    TwiddleMap.prototype.columnTableTotalChecked = function(columnName) {
      var checked;
      if (!this.columnTableTotalEnabled(columnName)) {
        return false;
      }
      checked = this.getForColumn(columnName, 'table_total_column');
      if (checked == null) {
        checked = this.get('table_total_column');
      }
      return checked;
    };

    TwiddleMap.prototype.redesignGetArray = function(twiddle) {
      this.requireRealTwiddle(twiddle);
      return this.redesignGetValue(twiddle) || [];
    };

    TwiddleMap.prototype.redesignGetValue = function(twiddle) {
      if (this.twiddles[twiddle] != null) {
        return this.twiddles[twiddle];
      }
      if (this.twiddles[TwiddleMap.TWIDDLE_PREFIX + twiddle] != null) {
        return this.twiddles[TwiddleMap.TWIDDLE_PREFIX + twiddle];
      }
      return this.twiddles[twiddle.replace("twiddle_", "")];
    };

    return TwiddleMap;

  })();

}).call(this);
(function() {
  App.UdvHelper = (function() {
    function UdvHelper() {}

    UdvHelper.INVALID_UDV_DETAILS = {
      DIMENSION_DELETED: 0,
      VALUE_DELETED: 1,
      GROUP_CHANGE: 2,
      HASH_KEY_MISSING: 3
    };

    UdvHelper.dimensionMatches = function(d, dimensionId, dimensionValueId) {
      return d[App.DimensionConfig.DIMENSION_ID_INDEX] === dimensionId && d[App.DimensionConfig.DIMENSION_VALUE_ID_INDEX] === dimensionValueId;
    };

    UdvHelper.removeDimension = function(udv, dimensionId, dimensionValueId) {
      return _.remove(udv.custom_dimensions_list, (function(_this) {
        return function(d) {
          return _this.dimensionMatches(d, dimensionId, dimensionValueId);
        };
      })(this))[0];
    };

    UdvHelper.getSignedDimension = function(udv, dimensionId, dimensionValueId) {
      return _.find(udv.signed_custom_dimensions_list, (function(_this) {
        return function(d) {
          return _this.dimensionMatches(d, dimensionId, dimensionValueId);
        };
      })(this));
    };

    UdvHelper.getDimensionSignature = function(udv, dimensionId, dimensionValueId) {
      var ref;
      return (ref = this.getSignedDimension(udv, dimensionId, dimensionValueId)) != null ? ref[App.DimensionConfig.SIGNATURE_INDEX] : void 0;
    };

    UdvHelper.addToSignedDimensions = function(udv, result) {
      var dim;
      dim = [result.dimension_id, result.id, result.name, result.group, result.signature];
      _.remove(udv.signed_custom_dimensions_list, (function(_this) {
        return function(d) {
          return _this.dimensionMatches(d, result.dimension_id, result.id);
        };
      })(this));
      return udv.signed_custom_dimensions_list.push(dim);
    };

    UdvHelper.updateSignaturesFromResults = function(udv, dimensionId, results) {
      var dim, dimId, dimValueId, i, len, result, results1, signedDimensionsList;
      signedDimensionsList = _.filter(udv.signed_custom_dimensions_list, (function(_this) {
        return function(dim) {
          return dim[App.DimensionConfig.DIMENSION_ID_INDEX] === dimensionId;
        };
      })(this));
      if (udv.isNew() || _.isEmpty(signedDimensionsList)) {
        return;
      }
      results1 = [];
      for (i = 0, len = signedDimensionsList.length; i < len; i++) {
        dim = signedDimensionsList[i];
        dimId = dim[App.DimensionConfig.DIMENSION_ID_INDEX];
        dimValueId = dim[App.DimensionConfig.DIMENSION_VALUE_ID_INDEX];
        result = _.find(results, {
          'dimension_id': dimId,
          'id': dimValueId
        });
        if ((result != null) && result.signature !== this.getDimensionSignature(udv, dimensionId, dimValueId)) {
          results1.push(this.addToSignedDimensions(udv, result));
        } else {
          results1.push(void 0);
        }
      }
      return results1;
    };

    UdvHelper.valuesNeedingSignature = function(custom_dimensions_list) {
      var validIds;
      validIds = App.CustomDimension.signableIdsFromList(custom_dimensions_list);
      return _.filter(custom_dimensions_list, function(entry) {
        return _.includes(validIds, entry[App.DimensionConfig.DIMENSION_ID_INDEX]);
      });
    };

    UdvHelper.valuesFromDeletedDimensions = function(custom_dimensions_list) {
      var deletedIds;
      deletedIds = App.CustomDimension.deletedCustomDimensionIdsFromList(custom_dimensions_list);
      return _.filter(custom_dimensions_list, function(entry) {
        return _.includes(deletedIds, entry[App.DimensionConfig.DIMENSION_ID_INDEX]);
      });
    };

    UdvHelper.deletedValueTuples = function(custom_dimensions_list) {
      return _.map(this.valuesFromDeletedDimensions(custom_dimensions_list), (function(_this) {
        return function(dimensionEntry) {
          return [dimensionEntry[App.DimensionConfig.DIMENSION_ID_INDEX], dimensionEntry[App.DimensionConfig.DIMENSION_VALUE_ID_INDEX], _this.INVALID_UDV_DETAILS.DIMENSION_DELETED];
        };
      })(this));
    };

    UdvHelper.signAndCleanCustomDimensions = function(udv, options) {
      var ref;
      if (options == null) {
        options = {};
      }
      if (((ref = udv.dimensions_pending_signatures) != null ? ref.length : void 0) > 0) {
        return;
      }
      if (!udv.isNew()) {
        udv.save({
          ajax: false
        });
      }
      udv.dimensions_pending_signatures = [];
      udv.addAllToDeletedDimensions(this.deletedValueTuples(udv.custom_dimensions_list));
      _.forEach(this.valuesNeedingSignature(udv.custom_dimensions_list), (function(_this) {
        return function(dim) {
          var cachedSignedDimension, dimId, dimValueId, groupId;
          dimId = dim[App.DimensionConfig.DIMENSION_ID_INDEX];
          dimValueId = dim[App.DimensionConfig.DIMENSION_VALUE_ID_INDEX];
          groupId = dim[App.DimensionConfig.GROUP_INDEX];
          cachedSignedDimension = _this.getSignedDimension(udv, dimId, dimValueId);
          if (cachedSignedDimension != null) {
            return udv.signDimension(dimId, dimValueId, groupId, cachedSignedDimension[App.DimensionConfig.SIGNATURE_INDEX]);
          } else if (_.isEmpty(dim[App.DimensionConfig.SIGNATURE_INDEX])) {
            return udv.dimensions_pending_signatures.push([dimId, dimValueId]);
          }
        };
      })(this));
      if (_.isEmpty(udv.dimensions_pending_signatures)) {
        return udv.signAndSave(options);
      } else {
        return _.forEach(_.clone(udv.dimensions_pending_signatures), (function(_this) {
          return function(dimensionToBeSigned) {
            var dimId, dimValueId;
            dimId = dimensionToBeSigned[App.DimensionConfig.DIMENSION_ID_INDEX];
            dimValueId = dimensionToBeSigned[App.DimensionConfig.DIMENSION_VALUE_ID_INDEX];
            return App.dimentorClient().requestSignedDimension(dimId, dimValueId, udv, options);
          };
        })(this));
      }
    };

    UdvHelper.signDimensionFromResponse = function(udv, dimensionId, dimensionValueId, groupId, signature, options) {
      udv.signDimension(dimensionId, dimensionValueId, groupId, signature);
      return this.updateAndSaveIfComplete(udv, dimensionId, dimensionValueId, options);
    };

    UdvHelper.removeDeletedDimension = function(udv, dimensionId, dimensionValueId, options, reason) {
      udv.addToDeletedDimensions([dimensionId, dimensionValueId, reason || this.INVALID_UDV_DETAILS.VALUE_DELETED]);
      return this.updateAndSaveIfComplete(udv, dimensionId, dimensionValueId, options);
    };

    UdvHelper.updateAndSaveIfComplete = function(udv, dimensionId, dimensionValueId, options) {
      _.remove(udv.dimensions_pending_signatures, (function(_this) {
        return function(d) {
          return _this.dimensionMatches(d, dimensionId, dimensionValueId);
        };
      })(this));
      if (_.isEmpty(udv.dimensions_pending_signatures)) {
        return udv.signAndSave(options);
      }
    };

    UdvHelper.logInvalidDimensions = function(invalidDimensions) {
      return AppRedesign.logToScalyr('InvalidUDVDimensionsDeleted', {
        invalid_dimensions: invalidDimensions
      });
    };

    return UdvHelper;

  })();

}).call(this);
(function() {
  var UiQueue,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  UiQueue = (function() {
    UiQueue.PRIORITY_DASHBOARD_SETTINGS = 0.5;

    UiQueue.PRIORITY_REMAINING_STATE = 1.0;

    UiQueue.PRIORITY_AFTER_FIRST_CHART = 1.1;

    UiQueue.PRIORITY_LIVE_CHAT = 2.0;

    UiQueue.PRIORITY_WALKME = 3.0;

    UiQueue.PRIORITY_DEFAULT = 10;

    UiQueue.MULTI_TASK_MAX_DURATION = 200;

    function UiQueue() {
      this.resetQueue = bind(this.resetQueue, this);
      this.doNext = bind(this.doNext, this);
      this.schedule = bind(this.schedule, this);
      this.queue = [];
      this.interrupt = false;
    }

    UiQueue.prototype.addOrReplace = function(closure, label, priority, widget_id) {
      var i;
      if (priority == null) {
        priority = this.constructor.PRIORITY_DEFAULT;
      }
      if (widget_id == null) {
        widget_id = null;
      }
      i = _.find(this.queue, {
        label: label,
        widget_id: widget_id
      });
      if (i != null) {
        i.closure = closure;
        return i.priority = priority;
      } else {
        return this.add(closure, label, priority, widget_id);
      }
    };

    UiQueue.prototype.addWithFlush = function(closure, label, priority, widget_id) {
      if (priority == null) {
        priority = 10;
      }
      if (widget_id == null) {
        widget_id = null;
      }
      this.queue.push({
        priority: priority,
        closure: closure,
        label: label,
        widget_id: widget_id,
        flush: true
      });
      return this.schedule();
    };

    UiQueue.prototype.add = function(closure, label, priority, widget_id) {
      if (priority == null) {
        priority = this.constructor.PRIORITY_DEFAULT;
      }
      if (widget_id == null) {
        widget_id = null;
      }
      this.queue.push({
        priority: priority,
        closure: closure,
        label: label,
        widget_id: widget_id
      });
      return this.schedule();
    };

    UiQueue.prototype.schedule = function() {
      if (this.scheduleTimeout != null) {
        return;
      }
      return this.scheduleTimeout = (typeof window.requestAnimationFrame === "function" ? window.requestAnimationFrame(this.doNext) : void 0) || setTimeout(this.doNext, 0);
    };

    UiQueue.prototype.doNext = function() {
      this.scheduleTimeout = null;
      this.executeTasks();
      return this.schedule();
    };

    UiQueue.prototype.executeTasks = function() {
      var completedTasks, elapsedTime, error, startTime;
      try {
        elapsedTime = 0;
        startTime = AppRedesign.timestamp();
        completedTasks = 0;
        while (!this.empty() && this.canRunMore(startTime, completedTasks)) {
          this.executeTask();
          completedTasks += 1;
        }
        return this.interrupt = false;
      } catch (error1) {
        error = error1;
        return AppRedesign.logError(error);
      }
    };

    UiQueue.prototype.executeTask = function() {
      var nextItem;
      this.prioritizeQueue();
      nextItem = this.queue.shift();
      App.Lagotron.addContext("uiQueue: " + nextItem.label, {
        widget_id: nextItem.widget_id
      });
      return nextItem.closure();
    };

    UiQueue.prototype.insertInterrupt = function() {
      if (!this.empty()) {
        return this.interrupt = true;
      }
    };

    UiQueue.prototype.canRunMore = function(startTime, completedTasks) {
      if (this.interrupt) {
        return false;
      }
      if (completedTasks > 0 && this.nextTaskIsFlush()) {
        return false;
      }
      return (AppRedesign.timestamp() - startTime) < UiQueue.MULTI_TASK_MAX_DURATION;
    };

    UiQueue.prototype.nextTaskIsFlush = function() {
      return this.queue.length > 0 && this.queue[0].flush;
    };

    UiQueue.prototype.prioritizeQueue = function() {
      return this.queue.sort(function(a, b) {
        return a.priority - b.priority;
      });
    };

    UiQueue.prototype.empty = function() {
      return this.queue.length === 0;
    };

    UiQueue.prototype.resetQueue = function() {
      if (this.scheduleTimeout != null) {
        (typeof cancelAnimationFrame === "function" ? cancelAnimationFrame(this.scheduleTimeout) : void 0) || clearTimeout(this.scheduleTimeout);
      }
      this.scheduleTimeout = null;
      return this.queue = [];
    };

    UiQueue.prototype.testExecuteAll = function() {
      var nextItem, results;
      results = [];
      while (this.queue.length > 0) {
        nextItem = this.queue.shift();
        results.push(nextItem.closure());
      }
      return results;
    };

    return UiQueue;

  })();

  App.UiQueue = UiQueue;

}).call(this);
(function() {
  App.UsageDataHelper = (function() {
    UsageDataHelper.prototype.currentlySelectedSite = function() {
      return this.currentlySelectedSiteId;
    };

    function UsageDataHelper(updateCb) {
      this.updateCb = updateCb;
      App.Utils.logFeature("usage-data-open");
      this.getCurrent();
    }

    UsageDataHelper.prototype.eligibleSites = function() {
      var eligibleSiteList, i, len, results, siteInfo;
      eligibleSiteList = App.Site.allAdminSites();
      if (App.Site.first().cache_enabled) {
        eligibleSiteList = _.filter(eligibleSiteList, {
          cache_enabled: true
        });
      }
      results = [];
      for (i = 0, len = eligibleSiteList.length; i < len; i++) {
        siteInfo = eligibleSiteList[i];
        results.push([siteInfo.id, siteInfo.display_name]);
      }
      return results;
    };

    UsageDataHelper.prototype.getCurrent = function() {
      return jQuery.ajax({
        url: "/metadata_harvest",
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id
        },
        dataType: 'json'
      }).always(((function(_this) {
        return function(r) {
          return _this.dataRecv(r);
        };
      })(this)));
    };

    UsageDataHelper.prototype.enableForSite = function(site_id) {
      return jQuery.ajax({
        url: "/metadata_harvest",
        type: 'POST',
        data: {
          client_site_id: App.Site.first().id,
          site_id: site_id
        },
        dataType: 'json'
      }).always(((function(_this) {
        return function(r) {
          return _this.dataRecv(r);
        };
      })(this)));
    };

    UsageDataHelper.prototype.disable = function() {
      return jQuery.ajax({
        url: "/metadata_harvest",
        type: 'DELETE',
        data: {
          client_site_id: App.Site.first().id
        },
        dataType: 'json'
      }).always(((function(_this) {
        return function(r) {
          return _this.dataRecv(r);
        };
      })(this)));
    };

    UsageDataHelper.prototype.dataRecv = function(r) {
      this.currentlySelectedSiteId = (r != null ? r.site_id : void 0) || '';
      return this.updateCb();
    };

    return UsageDataHelper;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AggregationDimensionSetting = (function(superClass) {
    extend(AggregationDimensionSetting, superClass);

    AggregationDimensionSetting.prototype.elements = {
      '.aggregation-dropdown': 'aggregationDropdown',
      '.aggregation-dropdown .options': 'aggregationOptions'
    };

    AggregationDimensionSetting.DEFAULT_AGGREGATION_LABEL = "Aggregation";

    AggregationDimensionSetting.AGGREGATION_OPTIONS = [
      {
        value: 'hourly',
        label: "Hourly"
      }, {
        value: 'daily',
        label: "Daily"
      }, {
        value: 'weekly',
        label: "Weekly"
      }, {
        value: 'monthly',
        label: "Monthly"
      }, {
        value: 'quarterly',
        label: "Quarterly"
      }, {
        value: 'yearly',
        label: "Yearly"
      }
    ];

    function AggregationDimensionSetting() {
      this.clickedAggregationRadioButton = bind(this.clickedAggregationRadioButton, this);
      AggregationDimensionSetting.__super__.constructor.apply(this, arguments);
      this.render();
    }

    AggregationDimensionSetting.prototype.render = function() {
      this.html(this.view('dashboards/aggregation_dimension_setting')());
      this.refreshElements();
      return this.aggregationRadioButtonGroup = new App.RadioButtonGroup({
        radioOptions: this.constructor.AGGREGATION_OPTIONS,
        initialValue: this.dashboard.aggregationSetting(),
        defaultValue: -1,
        el: App.RadioButtonGroup.appendFrame(this.aggregationOptions),
        disableDeselection: true,
        callback: this.clickedAggregationRadioButton
      });
    };

    AggregationDimensionSetting.prototype.clickedAggregationRadioButton = function(value, clickOptions) {
      if (clickOptions.doubleClick) {
        return this.trigger('apply-pending-config');
      } else {
        return this.dashboard.setPendingAggregation(value);
      }
    };

    AggregationDimensionSetting.prototype.updateLabel = function() {
      var i, item, len, ref, selectedAggregation;
      ref = this.constructor.AGGREGATION_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        if (this.dashboard.aggregationSetting() === item.value) {
          selectedAggregation = item;
          break;
        }
      }
      if (selectedAggregation) {
        return this.aggregationRadioButtonGroup.setState(item.value);
      } else {
        return this.aggregationRadioButtonGroup.setState('daily');
      }
    };

    AggregationDimensionSetting.getAggregationValuesAsArrays = function(term, callback) {
      var translateCallback;
      translateCallback = function(results) {
        var r, values;
        values = (function() {
          var i, len, results1;
          results1 = [];
          for (i = 0, len = results.length; i < len; i++) {
            r = results[i];
            results1.push([r.value, r.label]);
          }
          return results1;
        })();
        return callback(values);
      };
      return this.getAggregationValues(term, translateCallback);
    };

    AggregationDimensionSetting.getAggregationValues = function(term, translateCallback) {
      var i, len, option, ref, results;
      term = term.trim().toLowerCase();
      results = [];
      ref = App.AggregationDimensionSetting.AGGREGATION_OPTIONS;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        if (option.value.toLowerCase().indexOf(term) !== -1) {
          results.push(option);
        }
      }
      return translateCallback(results);
    };

    return AggregationDimensionSetting;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.AlertTooltipController = (function(superClass) {
    extend(AlertTooltipController, superClass);

    AlertTooltipController.prototype.className = 'alert-tooltip';

    AlertTooltipController.prototype.elements = {
      '.left-arrow': 'leftArrowEl',
      '.alert-header': 'tooltipHeaderEl',
      '.alert-body': 'tooltipBodyEl',
      '.alert-icon': 'tooltipIconEl',
      '.alert-sidebar': 'tooltipSidebarEl',
      '.alert-reference': 'alertReferenceEl',
      '.alert-message': 'alertMessageEl'
    };

    AlertTooltipController.prototype.events = {
      'click': 'click',
      'mousedown': 'mousedown'
    };

    AlertTooltipController.SHOW_DELAY_MS = 500;

    AlertTooltipController.PANEL_OFFSET_TOP = 11;

    AlertTooltipController.PANEL_OFFSET_LEFT = -78;

    AlertTooltipController.UNDERLINE_ERROR_EL = "cm-underline-error";

    AlertTooltipController.UNDERLINE_INFO_EL = "cm-underline-info";

    AlertTooltipController.UNDERLINE_WARNING_EL = "cm-underline-warning";

    function AlertTooltipController() {
      AlertTooltipController.__super__.constructor.apply(this, arguments);
      this.el.hide();
      $('#body .app-frame').append(this.el);
    }

    AlertTooltipController.prototype.render = function() {
      return this.html(this.view('redesign/tooltip/alert_tooltip')({
        alertState: this.alertState()
      }));
    };

    AlertTooltipController.prototype.alertDataTag = function() {
      return this.infoAlertTags[this.target.attr('class').split(' ').last()];
    };

    AlertTooltipController.prototype.errorAlertState = function() {
      return {
        alertLevel: 'error',
        alertReference: 'Syntax Error:',
        alertMessage: 'Invalid syntax.'
      };
    };

    AlertTooltipController.prototype.infoAlertState = function() {
      return {
        alertLevel: 'info',
        alertReference: 'Unqualified table reference:',
        alertMessage: "Did you mean \n“" + (this.alertDataTag()) + "”?"
      };
    };

    AlertTooltipController.prototype.warningAlertState = function() {
      return {
        alertLevel: 'warning',
        alertReference: 'Ambiguous table reference:',
        alertMessage: "“" + (this.alertDataTag().table_name) + "” may refer to more than one table in the Sisense Cache. Did you mean " + (this.suggestions()) + "?"
      };
    };

    AlertTooltipController.prototype.suggestions = function() {
      var suggestions;
      suggestions = this.alertDataTag().hint;
      if (suggestions.length === 2) {
        return suggestions[0] + " or " + suggestions[1];
      } else if (suggestions.length === 1) {
        return "" + suggestions[0];
      }
    };

    AlertTooltipController.prototype.alertState = function() {
      switch (false) {
        case !this.target.hasClass(App.AlertTooltipController.UNDERLINE_ERROR_EL):
          return this.errorAlertState();
        case !this.target.hasClass(App.AlertTooltipController.UNDERLINE_INFO_EL):
          return this.infoAlertState();
        case !this.target.hasClass(App.AlertTooltipController.UNDERLINE_WARNING_EL):
          return this.warningAlertState();
      }
    };

    AlertTooltipController.prototype.showAlert = function(target, infoAlertTags) {
      this.target = target;
      this.infoAlertTags = infoAlertTags;
      this.reposition();
      this.render();
      return this.displayAlert();
    };

    AlertTooltipController.prototype.reposition = function() {
      var desiredTop, targetOffset;
      targetOffset = this.target.offset();
      if (this.elementHiddenOrDetached()) {
        return false;
      }
      desiredTop = targetOffset.top + this.target.height();
      return this.el.css({
        top: desiredTop + this.constructor.PANEL_OFFSET_TOP,
        left: targetOffset.left + this.constructor.PANEL_OFFSET_LEFT + this.target.width() / 2
      });
    };

    AlertTooltipController.prototype.elementHiddenOrDetached = function() {
      return this.target.offset().top === 0 && this.target.offset().left === 0;
    };

    AlertTooltipController.prototype.displayAlert = function() {
      return this.el.css('display', 'inline-block');
    };

    AlertTooltipController.prototype.hide = function() {
      return this.el.css('display', 'none');
    };

    AlertTooltipController.prototype.click = function(evt) {
      return evt.stopPropagation();
    };

    AlertTooltipController.prototype.mousedown = function(evt) {
      return evt.stopPropagation();
    };

    return AlertTooltipController;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CanvasChart = (function(superClass) {
    extend(CanvasChart, superClass);

    CanvasChart.REDESIGN_FONTS = 'FF_DIN_Regular, "Helvetica Neue", HelveticaNeue, "Helvetica-Neue", Helvetica, "BBAlpha Sans", sans-serif';

    CanvasChart.CLASSIC_FONTS = 'DINWeb, "Helvetica Neue", HelveticaNeue, "Helvetica-Neue", Helvetica, "BBAlpha Sans", sans-serif';

    CanvasChart.AGGREGATION_SIZE = {};

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.SECONDS] = 1 / (24.0 * 60 * 60);

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.MINUTES] = 1 / (24.0 * 60);

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.HOURLY] = 1 / 24.0;

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.DAILY] = 1;

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.WEEKLY] = 7;

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.MONTHLY] = 30;

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.QUARTERLY] = 91;

    CanvasChart.AGGREGATION_SIZE[App.TimeMachine.YEARLY] = 365;

    CanvasChart.AGG_TO_CANVAS_AGG = {
      seconds: 'second',
      minutes: 'minute',
      hourly: 'hour',
      daily: 'day',
      weekly: 'week',
      monthly: 'month',
      quarterly: 'quarter',
      yearly: 'year'
    };

    CanvasChart.DAY_MS = 1000 * 60 * 60 * 24;

    CanvasChart.MILLESECONDS_BY_INTERVAL_TYPE = {
      second: 1000,
      minute: 60000,
      hour: 3600000,
      day: 86400000,
      week: 604800000,
      month: 2592000000,
      quarter: 7776000000,
      year: 31536000000
    };

    CanvasChart.prototype.legendEl = function() {
      return this.el.find('.legend');
    };

    function CanvasChart() {
      this.selectSeriesInLegend = bind(this.selectSeriesInLegend, this);
      this.toggleSeriesInLegend = bind(this.toggleSeriesInLegend, this);
      this.getImageData = bind(this.getImageData, this);
      CanvasChart.__super__.constructor.apply(this, arguments);
      if (this.bareDOMElement != null) {
        this.el = $(this.bareDOMElement);
      }
      App.Utils.requires(this, 'el', 'chartData', 'renderGuid', 'width', 'height', 'columnWidthFunc');
      this.twiddles = this.chartData.twiddlesActual;
      this.hiddenSeries = {};
      this.checkSeriesInLegend();
      this.rendered = false;
      this.domId = "canvasjs-" + this.renderGuid;
      if (this.canvasChartCanvasJs == null) {
        this.canvasChartCanvasJs = new App.CanvasChartCanvasJs({
          el: this.el,
          chartData: this.chartData,
          twiddles: this.twiddles,
          width: this.width,
          height: this.height,
          renderGuid: this.renderGuid,
          selectedFontFamily: this.fontFamily(),
          tooltipReorientDisabled: this.tooltipReorientDisabled,
          annotationController: this.createAnnotationController(),
          noAnnotations: this.noAnnotations
        });
      }
      this.bubbles(this.canvasChartCanvasJs, 'overlay-error');
      if (!this.noRender) {
        this.renderFrame();
      }
    }

    CanvasChart.prototype.clear = function() {
      return this.renderFrame();
    };

    CanvasChart.prototype.createAnnotationController = function() {
      this.annotationController = new App.RedesignAnnotationController({
        el: this.el,
        defaultGroupFunc: ((function(_this) {
          return function() {
            return _this.twiddles.getArray('annotation_groups').last();
          };
        })(this))
      });
      this.bubbles(this.annotationController, 'add-annotation');
      this.bubbles(this.annotationController, 'delete-annotations');
      return this.annotationController;
    };

    CanvasChart.prototype.getImageData = function() {
      var canvasChartDownload;
      canvasChartDownload = new App.CanvasChartDownload({
        chart: this.chart.chart,
        legendPosition: this.twiddles.get('legend_position')
      });
      return canvasChartDownload.getImageDataURL();
    };

    CanvasChart.prototype.fontFamily = function() {
      return this.selectedFontFamily || (this.selectedFontFamily = AppRedesign.isRedesignMode() ? App.CanvasChart.REDESIGN_FONTS : App.CanvasChart.CLASSIC_FONTS);
    };

    CanvasChart.prototype.clearState = function() {
      this.labelToIndex = null;
      return this.labelIndex = null;
    };

    CanvasChart.prototype.release = function() {
      var ref, ref1, ref2;
      CanvasChart.__super__.release.apply(this, arguments);
      if ((ref = this.canvasChartCanvasJs) != null) {
        ref.release();
      }
      if ((ref1 = this.annotationController) != null) {
        ref1.release();
      }
      if ((ref2 = this.legend) != null) {
        ref2.release();
      }
      this.chartEl = null;
      return delete this.lastRenderOptions;
    };

    CanvasChart.prototype.twiddle = function(name) {
      return this.twiddles.get(name);
    };

    CanvasChart.prototype.seriesTwiddle = function(series, name) {
      return this.twiddles.getForSeries(series.name, name);
    };

    CanvasChart.prototype.render = function(chartData, width, height, animateOnce, rerender) {
      var ref, ref1;
      this.animateOnce = animateOnce != null ? animateOnce : false;
      if (rerender == null) {
        rerender = false;
      }
      if (chartData === null && this.width === width && this.height === height) {
        return;
      }
      this.clearState();
      if (this.el.width() === 0 || this.el.height() === 0) {
        if (this.chartEl != null) {
          this.unrender();
        }
        return;
      }
      if (chartData != null) {
        this.chartData = chartData;
        this.hiddenSeries = {};
      }
      if ((ref = this.annotationController) != null) {
        ref.hideAnnotation();
      }
      if (!(this.rendered && !rerender)) {
        this.renderFrame();
      }
      if ((height != null) && height > 0) {
        if ((ref1 = this.chartEl) != null) {
          ref1.height(height);
        }
      }
      if ((width != null) && width > 0) {
        this.width = width;
      }
      if ((height != null) && height > 0) {
        this.height = height;
      }
      this.twiddles = this.chartData.twiddlesActual;
      this.renderLegend(this.legendEnabled());
      this.checkSeriesInLegend();
      return this.chart = this.canvasChartCanvasJs.render(this.chartData, this.width, this.height, this.hiddenSeries, this.animateOnce);
    };

    CanvasChart.prototype.checkSeriesInLegend = function() {
      var base, i, j, len, ref, results, series;
      ref = this.chartData.dataSeries;
      results = [];
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        series = ref[i];
        results.push((base = this.hiddenSeries)[i] != null ? base[i] : base[i] = false);
      }
      return results;
    };

    CanvasChart.prototype.renderFrame = function() {
      var ref;
      if ((ref = this.legend) != null) {
        ref.release();
      }
      this.legend = null;
      this.el.html(this.view('ninja_chart/ninja_chart')({
        height: this.height,
        chartId: this.domId
      }));
      this.chartEl = $("#" + this.domId);
      return this.rendered = true;
    };

    CanvasChart.prototype.unrender = function() {
      this.rendered = false;
      delete this.lastRenderOptions;
      this.html('');
      return this.chartEl = null;
    };

    CanvasChart.prototype.isWide = function() {
      return new App.DashboardSizer(App.Dashboard.currentDashboard()).isWide(this.el.width());
    };

    CanvasChart.prototype.legendEnabled = function() {
      return !this.twiddle('do_not_show_legend');
    };

    CanvasChart.prototype.canvasChartLegendSizer = function() {
      return new App.CanvasChartLegendSizer({
        chartEl: this.chartEl,
        legendEl: this.legendEl(),
        twiddles: this.twiddles,
        isWide: this.isWide(),
        width: this.width,
        height: this.height,
        leftOffset: 12,
        rightOffset: -9
      });
    };

    CanvasChart.prototype.renderLegend = function(legendEnabled, initialize) {
      var ref;
      if (initialize == null) {
        initialize = true;
      }
      this.el.toggleClass('with-legend', legendEnabled).toggleClass('wide', this.isWide());
      if (legendEnabled) {
        if (this.legend == null) {
          this.legend = new App.CanvasLegend({
            el: this.legendEl()
          });
          this.legend.bind('legend-click', this.toggleSeriesInLegend);
          this.legend.bind('legend-dblclick', this.selectSeriesInLegend);
        }
        this.legend.render(this.chartData, this.hiddenSeries);
        if (initialize) {
          this.canvasChartLegendSizer().layoutChartAndLegend();
        }
        return this.legend.show();
      } else {
        if ((ref = this.legend) != null) {
          ref.hide();
        }
        return this.canvasChartLegendSizer().setChartToFullWidth();
      }
    };

    CanvasChart.prototype.allButOneHidden = function() {
      var k, numHidden;
      numHidden = ((function() {
        var j, len, ref, results;
        ref = Object.keys(this.hiddenSeries);
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          k = ref[j];
          if (this.hiddenSeries[k]) {
            results.push(1);
          }
        }
        return results;
      }).call(this)).length;
      return Object.keys(this.chartData.dataSeries).length <= (numHidden + 1);
    };

    CanvasChart.prototype.toggleSeriesInLegend = function(seriesId) {
      var allButOneHidden, j, key, len, ref;
      if (isNaN(seriesId)) {
        return;
      }
      allButOneHidden = this.allButOneHidden();
      if (this.hiddenSeries[seriesId] || !allButOneHidden) {
        this.hiddenSeries[seriesId] = !this.hiddenSeries[seriesId];
      } else if (allButOneHidden && !this.hiddenSeries[seriesId]) {
        ref = Object.keys(this.hiddenSeries);
        for (j = 0, len = ref.length; j < len; j++) {
          key = ref[j];
          this.hiddenSeries[key] = false;
        }
      }
      return this.rerenderWithVisibility();
    };

    CanvasChart.prototype.selectSeriesInLegend = function(seriesId) {
      var j, key, len, ref;
      if (isNaN(seriesId)) {
        return;
      }
      ref = Object.keys(this.hiddenSeries);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        this.hiddenSeries[key] = true;
      }
      this.hiddenSeries[seriesId] = false;
      return this.rerenderWithVisibility();
    };

    CanvasChart.prototype.rerenderWithVisibility = function() {
      this.renderLegend(this.legendEnabled(), false);
      if (this.twiddle('chart_type') === 'pie') {
        return this.chart = this.canvasChartCanvasJs.render(this.chartData, this.width, this.height, this.hiddenSeries, this.animateOnce);
      } else {
        return this.chart = this.canvasChartCanvasJs.rerender(this.hiddenSeries);
      }
    };

    return CanvasChart;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.CanvasChartCanvasJs = (function(superClass) {
    extend(CanvasChartCanvasJs, superClass);

    CanvasChartCanvasJs.EDITRON_TEXT_COLOR = '#fcfcf2';

    CanvasChartCanvasJs.DASH_TEXT_COLOR = '#363649';

    CanvasChartCanvasJs.ANNOTATION_LINE_COLOR = '#ced1d7';

    CanvasChartCanvasJs.ANNOTATION_LINE_COLOR_DARKMODE = '#b7b7b7';

    CanvasChartCanvasJs.BOTTOM_AXIS_MARGIN = -4;

    CanvasChartCanvasJs.LABEL_MARGIN = 10;

    CanvasChartCanvasJs.SIDE_AXIS_MARGIN = 10;

    CanvasChartCanvasJs.FONT_SIZE = 11;

    CanvasChartCanvasJs.PIXELS_PER_LABEL = 107;

    CanvasChartCanvasJs.MAX_LABEL_LETTERS = 20;

    CanvasChartCanvasJs.DEFAULT_LABEL_MAX_WIDTH = 80;

    CanvasChartCanvasJs.STACKED_TRANSLATED_CHART_TYPES = ['stackedColumn', 'stackedArea', 'stackedBar'];

    function CanvasChartCanvasJs() {
      this.dataPointDblclick = bind(this.dataPointDblclick, this);
      this.stripLineMouseout = bind(this.stripLineMouseout, this);
      this.stripLineMousemove = bind(this.stripLineMousemove, this);
      this.dataPointClick = bind(this.dataPointClick, this);
      CanvasChartCanvasJs.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'chartData', 'twiddles', 'width', 'height', 'renderGuid', 'selectedFontFamily', 'annotationController');
      this.domId = "canvasjs-" + this.renderGuid;
      this.hiddenSeries = {};
    }

    CanvasChartCanvasJs.prototype.twiddle = function(name) {
      return this.twiddles.get(name);
    };

    CanvasChartCanvasJs.prototype.seriesTwiddle = function(series, name) {
      return this.twiddles.getForSeries(series.name, name);
    };

    CanvasChartCanvasJs.prototype.render = function(chartData1, width1, height1, hiddenSeries, animateOnce) {
      var options;
      this.chartData = chartData1;
      this.width = width1;
      this.height = height1;
      this.hiddenSeries = hiddenSeries;
      this.animateOnce = animateOnce != null ? animateOnce : false;
      options = this.makeCanvasJsOptions(this.chartData);
      return this.renderCanvasJS(options);
    };

    CanvasChartCanvasJs.prototype.rerender = function(hiddenSeries) {
      var j, len, ref, series;
      this.hiddenSeries = hiddenSeries;
      ref = this.chart.options.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        series.visible = !this.hiddenSeries[series.seriesId];
      }
      this.chart.render();
      return this.chart;
    };

    CanvasChartCanvasJs.prototype.renderCanvasJS = function(options) {
      this.lastRenderOptions = options;
      this.chart = new CanvasJS.Chart(this.domId, options);
      this.chart.render();
      return this.chart;
    };

    CanvasChartCanvasJs.prototype.defaultChartOptions = function() {
      var ref, ref1, ref2, ref3;
      return this.defaultChartOptionsValue || (this.defaultChartOptionsValue = {
        zoomEnabled: true,
        animationEnabled: false,
        animationDuration: App.AppFrameRedesign.NORMAL_ANIMATION_TIME,
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        axisX: {
          labelFontFamily: this.selectedFontFamily,
          tickThickness: 1,
          lineThickness: 1,
          margin: App.CanvasChartCanvasJs.BOTTOM_AXIS_MARGIN,
          labelMaxWidth: App.CanvasChartCanvasJs.DEFAULT_LABEL_MAX_WIDTH,
          titleFontFamily: this.selectedFontFamily,
          titleFontSize: 14,
          labelFontSize: App.CanvasChartCanvasJs.FONT_SIZE,
          labelFontColor: App.CanvasChartCanvasJs.DASH_TEXT_COLOR,
          boldRotatedXAxisLabelsEnabled: (ref = AppRedesign.current()) != null ? (ref1 = ref.state) != null ? ref1.boldRotatedXAxisLabelsEnabled : void 0 : void 0,
          bolderRotatedXAxisLabelsEnabled: (ref2 = AppRedesign.current()) != null ? (ref3 = ref2.state) != null ? ref3.bolderRotatedXAxisLabelsEnabled : void 0 : void 0
        },
        axisY: {
          labelFontFamily: this.selectedFontFamily,
          gridThickness: 1,
          lineThickness: 0,
          tickThickness: 0,
          margin: App.CanvasChartCanvasJs.SIDE_AXIS_MARGIN,
          titleFontFamily: this.selectedFontFamily,
          titleFontSize: 14,
          labelFontSize: App.CanvasChartCanvasJs.FONT_SIZE,
          labelFontColor: App.CanvasChartCanvasJs.DASH_TEXT_COLOR
        },
        axisY2: {
          labelFontFamily: this.selectedFontFamily,
          gridThickness: 0,
          lineThickness: 0,
          tickThickness: 0,
          margin: App.CanvasChartCanvasJs.SIDE_AXIS_MARGIN,
          titleFontFamily: this.selectedFontFamily,
          titleFontSize: 14,
          labelFontSize: App.CanvasChartCanvasJs.FONT_SIZE,
          labelFontColor: App.CanvasChartCanvasJs.DASH_TEXT_COLOR
        }
      });
    };

    CanvasChartCanvasJs.prototype.makeCanvasJsOptions = function(chartData) {
      var options;
      this.chartData = chartData;
      this.twiddles = chartData.twiddlesActual;
      options = jQuery.extend(true, {}, this.defaultChartOptions());
      options.timezone = this.twiddles.get('timezone');
      options.startOfWeek = this.twiddles.get('start_of_week');
      options.data = this.makeCanvasJsSeriesList(chartData);
      if (this.animateOnce && !App.SetUpScreenshotMode.screenshotModeInUrl()) {
        options.animationEnabled = true;
        options.animationDuration = this.getAnimationDuration();
        this.animateOnce = false;
      }
      this.setTooltipOptions(chartData.dataSeries, options);
      this.setAxisOptions(options);
      this.addThreshold(chartData.threshold, options);
      this.correctAxisValuesIfOnlyOneDataPoint(options);
      return options;
    };

    CanvasChartCanvasJs.prototype.getAnimationDuration = function() {
      var ref;
      if (((ref = AppRedesign.current()) != null ? ref.getCurrentState() : void 0) === AppRedesign.IN_DASH) {
        return 2500;
      } else {
        return App.AppFrameRedesign.NORMAL_ANIMATION_TIME;
      }
    };

    CanvasChartCanvasJs.prototype.makePieSeriesList = function(chartData) {
      var index, j, k, len, len1, newSeries, percentageList, point, remainingDataSeries, roundedPercentageList, series, totalActivePercentage;
      newSeries = {
        name: 'pie',
        seriesId: 1,
        type: 'pie',
        dataPoints: [],
        _formatter: new App.SeriesFormatter(chartData.dataSeries.first(), this.twiddles),
        indexLabelFontFamily: this.selectedFontFamily,
        indexLabelFontSize: 11,
        startAngle: -90
      };
      newSeries = this.maybeAddDrilldown(newSeries);
      remainingDataSeries = (function() {
        var j, len, ref, results;
        ref = chartData.dataSeries;
        results = [];
        for (index = j = 0, len = ref.length; j < len; index = ++j) {
          series = ref[index];
          if (!(this.hiddenSeries[index] || this.twiddles.getForSeries(series.name, 'show_on_primary_axis') === false)) {
            results.push(series);
          }
        }
        return results;
      }).call(this);
      totalActivePercentage = 0;
      percentageList = [];
      for (index = j = 0, len = remainingDataSeries.length; j < len; index = ++j) {
        series = remainingDataSeries[index];
        point = series.dataPoints.first();
        totalActivePercentage += point.percentage;
        percentageList.push(point.percentage);
      }
      roundedPercentageList = App.Utils.displayRoundedPercentageList(percentageList);
      for (index = k = 0, len1 = remainingDataSeries.length; k < len1; index = ++k) {
        series = remainingDataSeries[index];
        newSeries.dataPoints.push(this.pointForPie(series, newSeries._formatter, totalActivePercentage, roundedPercentageList[index]));
      }
      this.applyChartSpecificSeriesOptions(newSeries);
      return [newSeries];
    };

    CanvasChartCanvasJs.prototype.pointForPie = function(series, formatter, totalActivePercentage, displayPercentage) {
      var indexLabel, point;
      point = series.dataPoints.first();
      indexLabel = this.seriesTwiddle(series, 'display_name');
      if (this.twiddles.get('show_values_in_legend')) {
        if (formatter.valueFormat === App.Tooltip.PERCENT) {
          indexLabel = displayPercentage + "%: " + indexLabel;
        } else {
          displayPercentage = point.percentage / totalActivePercentage;
          indexLabel = (formatter.formatValueForPieChart(displayPercentage)) + ": " + indexLabel;
        }
      }
      return {
        y: point.y,
        percentage: displayPercentage / 100,
        color: this.seriesTwiddle(series, 'color'),
        indexLabel: indexLabel,
        label: this.seriesTwiddle(series, 'display_name'),
        seriesName: series.name,
        originalRowList: point.row,
        originalPoints: point.originalPoints
      };
    };

    CanvasChartCanvasJs.prototype.makeCanvasJsSeriesList = function(chartData) {
      var canvasJsData, canvasSeries, i, j, k, len, len1, ref, ref1, series;
      this.labelToIndex = {};
      this.labelIndex = 0;
      if (this.twiddle('chart_type') === 'pie') {
        return this.makePieSeriesList(chartData);
      }
      canvasJsData = [];
      ref = chartData.dataSeries;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        series = ref[i];
        if (!(this.seriesTwiddle(series, 'show_on_secondary_axis'))) {
          continue;
        }
        canvasSeries = this.makeCanvasJsSeries(series, i);
        canvasSeries.axisYType = 'secondary';
        canvasJsData.push(canvasSeries);
      }
      ref1 = chartData.dataSeries;
      for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
        series = ref1[i];
        if (!(this.seriesTwiddle(series, 'show_on_primary_axis'))) {
          continue;
        }
        canvasSeries = this.makeCanvasJsSeries(series, i);
        canvasJsData.push(canvasSeries);
      }
      canvasJsData = this.sortSeriesByType(canvasJsData);
      return canvasJsData;
    };

    CanvasChartCanvasJs.prototype.makeCanvasJsSeries = function(chartDataSeries, nthSeries) {
      var ref, ref1, ref2, ref3, series;
      series = {
        dataPoints: this.translateSeriesData(chartDataSeries),
        markerType: 'none',
        seriesId: nthSeries,
        color: this.seriesTwiddle(chartDataSeries, 'color'),
        type: App.CanvasChartCanvasJs.translateChartType(chartDataSeries.name, this.twiddles, ((ref = this.chartData) != null ? (ref1 = ref.dataSeries) != null ? (ref2 = ref1.data) != null ? ref2.length : void 0 : void 0 : void 0) > 1),
        name: chartDataSeries.name,
        visible: !this.hiddenSeries[nthSeries],
        click: this.dataPointClick
      };
      series = this.maybeAddDrilldown(series);
      this.applyChartSpecificSeriesOptions(series, chartDataSeries.dataPoints);
      series._formatter = new App.SeriesFormatter(series, this.twiddles);
      if (this.seriesTwiddle(series, 'data_labels')) {
        this.applyDataLabels(series);
      }
      if (this.isDateSeries()) {
        series.xValueType = 'dateTime';
      }
      if (((ref3 = series.type) != null ? ref3.indexOf('Area') : void 0) > -1) {
        series.lineThickness = 0;
      }
      return series;
    };

    CanvasChartCanvasJs.prototype.applyChartSpecificSeriesOptions = function(series, dataPoints) {
      this.maybeSetMarkerTypeIfScatterOrBubble(series);
      this.maybeSetMarkerBorderThicknessIfBubble(series);
      return this.maybeSetMarkerTypeIfOneDataPoint(series, dataPoints);
    };

    CanvasChartCanvasJs.prototype.maybeSetMarkerTypeIfOneDataPoint = function(series, dataPoints) {
      var count;
      if (series.type !== 'line') {
        return;
      }
      count = dataPoints.filter(function(x) {
        return x.y !== null;
      }).length;
      if (count > 1) {
        return;
      }
      return series.markerType = "circle";
    };

    CanvasChartCanvasJs.prototype.maybeSetMarkerTypeIfScatterOrBubble = function(series) {
      if (App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(series.type)) {
        return series.markerType = "circle";
      }
    };

    CanvasChartCanvasJs.prototype.maybeSetMarkerBorderThicknessIfBubble = function(series) {
      if (App.ChartUtils.CHART_TYPES_X_Y_POINT.includes(series.type)) {
        return series.markerBorderThickness = 1;
      }
    };

    CanvasChartCanvasJs.prototype.correctAxisValuesIfOnlyOneDataPoint = function(options) {
      if (options.data.length === 1 && options.data[0].xValueType === 'dateTime') {
        options.axisX.maximum += 1;
        return options.axisX.minimum -= 1;
      }
    };

    CanvasChartCanvasJs.prototype.seriesRowSorter = function(a, b) {
      if (a.y > b.y) {
        return 1;
      } else if (a.y < b.y) {
        return -1;
      } else {
        return 0;
      }
    };

    CanvasChartCanvasJs.prototype.prepSeriesXYRowLookup = function(chartType, point, seriesName) {
      var colType, j, k, len, len1, rowList, rowVal, seriesRows, seriesXYRow, valueCol, valueCols, y;
      if (!App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(chartType)) {
        return {};
      }
      if (!(point.row && point.row[seriesName])) {
        return {};
      }
      seriesRows = point.row[seriesName];
      seriesXYRow = {};
      colType = (chartType === 'bubble' ? 'point_cols' : 'value_cols');
      valueCols = this.twiddles.get(colType);
      for (j = 0, len = valueCols.length; j < len; j++) {
        valueCol = valueCols[j];
        if (seriesXYRow[valueCol] == null) {
          seriesXYRow[valueCol] = {};
        }
        rowList = [];
        for (k = 0, len1 = seriesRows.length; k < len1; k++) {
          rowVal = seriesRows[k];
          y = parseFloat(rowVal[valueCol]);
          rowList.push({
            y: y,
            row: rowVal
          });
        }
        if ((rowList != null ? rowList.length : void 0) > 0) {
          seriesXYRow[valueCol].rowList = rowList.sort(this.seriesRowSorter);
        }
      }
      return seriesXYRow;
    };

    CanvasChartCanvasJs.prototype.collectSeriesYRows = function(y, rowList, midIndex) {
      var index, newRowList;
      index = midIndex;
      newRowList = [];
      while (index > 0 && (Math.abs(rowList[index].y - y) < 0.00000001)) {
        index--;
      }
      if (!(Math.abs(rowList[index].y - y) < 0.00000001)) {
        index++;
      }
      while (index < rowList.length && (Math.abs(rowList[index].y - y) < 0.00000001)) {
        newRowList.push(rowList[index].row);
        index++;
      }
      return newRowList;
    };

    CanvasChartCanvasJs.prototype.findSeriesYRows = function(y, rowList) {
      var attempts, maxIndex, midIndex, minIndex, value;
      if (!((rowList != null ? rowList.length : void 0) > 0)) {
        return null;
      }
      attempts = 0;
      minIndex = 0;
      maxIndex = rowList.length;
      while (attempts < 16) {
        attempts++;
        midIndex = Math.floor((maxIndex - minIndex) / 2) + minIndex;
        value = rowList[midIndex].y;
        if (Math.abs(value - y) < 0.00000001) {
          return this.collectSeriesYRows(y, rowList, midIndex);
        } else if (value < y) {
          minIndex = midIndex;
        } else {
          maxIndex = midIndex;
        }
      }
      while (minIndex < maxIndex) {
        midIndex = minIndex;
        value = rowList[midIndex].y;
        if (Math.abs(value - y) < 0.00000001) {
          return this.collectSeriesYRows(y, rowList, midIndex);
        }
        minIndex++;
      }
      return null;
    };

    CanvasChartCanvasJs.prototype.toolTipRow = function(chartType, point, seriesName, yRowHash) {
      var colType, j, len, newRowList, ref, ref1, ret, rowList, valueCol, valueCols, y;
      if (!App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(chartType)) {
        return point.row;
      }
      y = point.y;
      ret = {};
      ret[seriesName] = [];
      if (!((y != null) && (yRowHash != null))) {
        return ret;
      }
      newRowList = [];
      colType = (chartType === 'bubble' ? 'point_cols' : 'value_cols');
      valueCols = this.twiddles.get(colType);
      if (valueCols == null) {
        return;
      }
      for (j = 0, len = valueCols.length; j < len; j++) {
        valueCol = valueCols[j];
        if (((ref = yRowHash[valueCol]) != null ? (ref1 = ref.rowList) != null ? ref1.length : void 0 : void 0) > 0) {
          rowList = this.findSeriesYRows(y, yRowHash[valueCol].rowList);
          if ((rowList != null ? rowList.length : void 0) > 0) {
            newRowList.push.apply(newRowList, rowList);
          }
        }
      }
      ret[seriesName] = newRowList;
      return ret;
    };

    CanvasChartCanvasJs.prototype.translateSeriesData = function(series) {
      var chartType, i, isMultiValueChart, isProportional, j, len, point, points, prevPoint, ref, seriesYRow, titleize, xName, xVal;
      points = [];
      prevPoint = {
        label: null
      };
      xName = this.isContinuousXAxis() ? 'x' : 'label';
      titleize = this.twiddle('titleize_all_labels');
      chartType = this.twiddles.getForSeries(series.name, 'chart_type');
      isMultiValueChart = App.ChartUtils.CHART_TYPES_MULTI_VALUE.includes(chartType);
      isProportional = this.twiddles.getForSeries(series.name, 'proportional');
      seriesYRow = {};
      ref = series.dataPoints;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        point = ref[i];
        if (isProportional) {
          point.y = point.percentage;
        }
        xVal = point.x;
        if (titleize && (xVal.titleize != null)) {
          xVal = xVal.titleize();
        }
        if (point.x === '') {
          xVal = ' ';
        }
        if (xName === 'label') {
          xVal = "" + xVal;
        }
        if (xName !== 'x' && isMultiValueChart) {
          if (this.labelToIndex[xVal] == null) {
            this.labelToIndex[xVal] = this.labelIndex;
            this.labelIndex += 1;
          }
        }
        if (prevPoint[xName] === xVal && (!isMultiValueChart)) {
          prevPoint.y += point.y;
        } else {
          if (seriesYRow[xVal] == null) {
            seriesYRow[xVal] = this.prepSeriesXYRowLookup(chartType, point, series.name);
          }
          prevPoint = {
            y: point.y,
            z: point.z,
            total: point.total,
            originalRowList: this.toolTipRow(chartType, point, series.name, seriesYRow[xVal]),
            yValueExists: point.yValueExists,
            originalPoints: point.originalPoints
          };
          if (xName !== 'x' && isMultiValueChart) {
            prevPoint.x = this.labelToIndex[xVal];
          }
          prevPoint[xName] = xVal;
          points.push(prevPoint);
        }
      }
      return points;
    };

    CanvasChartCanvasJs.prototype.applyDataLabels = function(series) {
      var j, len, point, ref, results;
      series.indexLabelFontSize = 13;
      series.indexLabelPlacement = 'auto';
      series.indexLabelFontFamily = this.selectedFontFamily;
      ref = series.dataPoints;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        point = ref[j];
        if ((point.z != null) || series.type === 'bubble') {
          results.push(point['indexLabel'] = series._formatter.formatValue(point.z, App.SeriesFormatter.NUMBER));
        } else {
          results.push(point['indexLabel'] = series._formatter.formatValue(point.y));
        }
      }
      return results;
    };

    CanvasChartCanvasJs.prototype.isDateSeries = function() {
      return this.twiddle('x_axis_type') === App.Chartographer.TIMESERIES_AXIS_TYPE;
    };

    CanvasChartCanvasJs.prototype.isNumericXAxis = function() {
      return this.twiddle('x_axis_type') === App.Chartographer.NUMERIC_AXIS_TYPE;
    };

    CanvasChartCanvasJs.prototype.isContinuousXAxis = function() {
      var ref;
      return ref = this.twiddle('x_axis_type'), indexOf.call(App.Chartographer.CONTINUOUS_AXIS_TYPES, ref) >= 0;
    };

    CanvasChartCanvasJs.prototype.hasDiscreteMarkerSeries = function() {
      var j, len, ref, series;
      ref = this.chartData.dataSeries;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        if (App.ChartUtils.CHART_TYPES_DISCRETE_MARKER.includes(this.seriesTwiddle(series, 'chart_type'))) {
          return true;
        }
      }
      return false;
    };

    CanvasChartCanvasJs.prototype.hasChartWithXAxisLabels = function() {
      var j, len, ref, series;
      ref = this.chartData.dataSeries;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        if (App.ChartUtils.CHART_TYPES_WITH_X_AXIS_LABELS.includes(this.seriesTwiddle(series, 'chart_type'))) {
          return true;
        }
      }
      return false;
    };

    CanvasChartCanvasJs.prototype.hasBubbleSeries = function() {
      var j, len, ref, series;
      ref = this.chartData.dataSeries;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        if (this.seriesTwiddle(series, 'chart_type') === 'bubble') {
          return true;
        }
      }
      return false;
    };

    CanvasChartCanvasJs.prototype.sortSeriesByType = function(seriesList) {
      var j, k, l, len, len1, len2, len3, len4, listOrder, m, n, s, series, totalOrder, type;
      totalOrder = App.ChartUtils.CHART_TYPES_TOTAL_ORDER.slice(0);
      totalOrder.reverse();
      series = [];
      for (j = 0, len = totalOrder.length; j < len; j++) {
        type = totalOrder[j];
        listOrder = seriesList.slice(0);
        if (App.ChartUtils.CHART_TYPES_REVERSED_ORDER.includes(type)) {
          listOrder.reverse();
        }
        for (k = 0, len1 = listOrder.length; k < len1; k++) {
          s = listOrder[k];
          if (s.type === type && this.seriesTwiddle(s, 'show_on_primary_axis') && !this.appendLast(s)) {
            series.push(s);
          }
        }
        for (l = 0, len2 = listOrder.length; l < len2; l++) {
          s = listOrder[l];
          if (s.type === type && this.seriesTwiddle(s, 'show_on_secondary_axis') && !this.appendLast(s)) {
            series.push(s);
          }
        }
      }
      for (m = 0, len3 = seriesList.length; m < len3; m++) {
        s = seriesList[m];
        if (!totalOrder.includes(s.type)) {
          series.push(s);
        }
      }
      listOrder = seriesList.slice(0);
      for (n = 0, len4 = listOrder.length; n < len4; n++) {
        s = listOrder[n];
        if (this.appendLast(s)) {
          series.push(s);
        }
      }
      return series;
    };

    CanvasChartCanvasJs.prototype.appendLast = function(s) {
      return this.seriesTwiddle(s, 'synthetic_series_type') === 'trendline';
    };

    CanvasChartCanvasJs.translateChartType = function(seriesName, twiddles, multipleDataPoints) {
      var chartType, isAverageSeries, isGrouped, isHorizontalBars, isProportional;
      chartType = twiddles.getForSeries(seriesName, 'chart_type');
      if (chartType === "area") {
        return "stackedArea";
      }
      if (['sparkline', ''].includes(chartType)) {
        return 'line';
      }
      if (chartType === "pie") {
        return "pie";
      }
      isAverageSeries = twiddles.getForSeries(seriesName, 'synthetic_series_type') === 'average';
      isGrouped = twiddles.getForSeries(seriesName, 'grouped_bars');
      isProportional = twiddles.getForSeries(seriesName, 'proportional');
      isHorizontalBars = twiddles.getForSeries(seriesName, 'horizontal_bars');
      if (isProportional && !isGrouped) {
        if (isHorizontalBars) {
          return "stackedBar";
        } else {
          return "stackedColumn";
        }
      }
      if (isHorizontalBars) {
        if (isGrouped) {
          return "bar";
        } else {
          return "stackedBar";
        }
      }
      if (chartType === "column") {
        if (isGrouped) {
          return "column";
        } else {
          return "stackedColumn";
        }
      }
      if (isAverageSeries && chartType === 'line') {
        return 'spline';
      }
      if (chartType === "bignumber") {
        return 'line';
      }
      return chartType;
    };

    CanvasChartCanvasJs.prototype.setTooltipOptions = function(dataSeries, options) {
      var j, k, len, len1, point, ref, series, seriesDataByName;
      seriesDataByName = {};
      for (j = 0, len = dataSeries.length; j < len; j++) {
        series = dataSeries[j];
        if (series.type === 'pie') {
          ref = series.dataPoints;
          for (k = 0, len1 = ref.length; k < len1; k++) {
            point = ref[k];
            seriesDataByName[point.seriesName] = [point];
          }
        } else {
          seriesDataByName[series.name] = series.dataPoints;
        }
      }
      return options.toolTip = {
        getHtmlCallback: new App.RedesignChartTooltip(this.twiddles, seriesDataByName).makeTooltipHtml,
        tooltipReorientDisabled: this.tooltipReorientDisabled
      };
    };

    CanvasChartCanvasJs.prototype.dataPointClick = function(e) {
      var anno, annotations, groups, x, xAxisVal;
      if (!this.canClickOnDataPoint()) {
        return;
      }
      if (AppRedesign.current().onMobileOs) {
        return;
      }
      if (this.colorThemeChart) {
        return;
      }
      if (this.noAnnotations) {
        return;
      }
      xAxisVal = App.CanvasChartCanvasJs.originalXValueForDataPoint(e.dataPoint, this.twiddles);
      groups = this.twiddles.getArray('annotation_groups');
      annotations = (function() {
        var j, len, ref, results;
        ref = this.restrictAnnotationsByXValueAndGroup(this.lastRenderOptions);
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          anno = ref[j];
          if ("" + anno.x_value === "" + xAxisVal) {
            results.push(App.Annotation.find(anno.id));
          }
        }
        return results;
      }).call(this);
      x = this.annotationHorizontalAlignment(e);
      return this.annotationController.showAnnotations(annotations, x, null, xAxisVal, true, e.bottomAxisOffset);
    };

    CanvasChartCanvasJs.prototype.annotationHorizontalAlignment = function(e) {
      if (this.twiddles.get('horizontal')) {
        return this.width / 2;
      } else {
        return e.x;
      }
    };

    CanvasChartCanvasJs.originalXValueForDataPoint = function(dataPoint, twiddles) {
      var firstPoint, points, rows, series, xAxisCol, xAxisVal;
      xAxisCol = twiddles.get('point_cols')[0];
      rows = dataPoint.originalRowList;
      for (series in rows) {
        points = rows[series];
        if (points.length === 0) {
          continue;
        }
        firstPoint = points[0];
        xAxisVal = firstPoint[xAxisCol];
        if (xAxisVal != null) {
          return xAxisVal;
        }
      }
      return null;
    };

    CanvasChartCanvasJs.prototype.stripLineMousemove = function(ev) {
      var x;
      x = this.annotationHorizontalAlignment(ev);
      return this.annotationController.maybeShowAnnotation(ev.stripLine.annotation_ids, x, ev.ev.clientX, ev.bottomAxisOffset);
    };

    CanvasChartCanvasJs.prototype.stripLineMouseout = function(ev) {
      return this.annotationController.maybeHideAnnotation();
    };

    CanvasChartCanvasJs.prototype.addAnnotations = function(canvasJsOptions) {
      var aggregation, anno, axisX, j, len, ref, results, startOfWeek, stripLine, striplinesByXValue, tz, x_value;
      axisX = canvasJsOptions.axisX;
      axisX.stripLines = [];
      striplinesByXValue = {};
      tz = this.twiddle('timezone');
      startOfWeek = this.twiddle('start_of_week');
      aggregation = App.CanvasChart.AGG_TO_CANVAS_AGG[this.twiddle('aggregation')];
      ref = this.restrictAnnotationsByXValueAndGroup(canvasJsOptions);
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        anno = ref[j];
        x_value = anno.x_value;
        if (aggregation) {
          if (aggregation === 'week' && startOfWeek === 1) {
            aggregation = 'isoWeek';
          }
          x_value = App.TimeMachine.timestampToMoment(anno.x_value, tz, startOfWeek).startOf(aggregation).valueOf();
        }
        if (striplinesByXValue[x_value] != null) {
          results.push(striplinesByXValue[x_value].annotation_ids.push(anno.id));
        } else {
          stripLine = {
            annotation_ids: [anno.id],
            value: x_value,
            color: this.stripLineColor(),
            mousemove: this.stripLineMousemove
          };
          striplinesByXValue[x_value] = stripLine;
          results.push(axisX.stripLines.push(stripLine));
        }
      }
      return results;
    };

    CanvasChartCanvasJs.prototype.stripLineColor = function() {
      if (App.DashboardSizer.useDarkTheme(this.el)) {
        return App.CanvasChartCanvasJs.ANNOTATION_LINE_COLOR_DARKMODE;
      }
      return App.CanvasChartCanvasJs.ANNOTATION_LINE_COLOR;
    };

    CanvasChartCanvasJs.prototype.axisMin = function(canvasJsOptions) {
      var min, ref, ref1, ref2, ref3;
      min = canvasJsOptions.axisX.minimum;
      if ((min == null) && (((ref = canvasJsOptions.data) != null ? (ref1 = ref[0]) != null ? (ref2 = ref1.dataPoints) != null ? (ref3 = ref2[0]) != null ? ref3.x : void 0 : void 0 : void 0 : void 0) != null)) {
        min = canvasJsOptions.data[0].dataPoints[0].x;
      }
      return min;
    };

    CanvasChartCanvasJs.prototype.axisMax = function(canvasJsOptions) {
      var max, ref, ref1, ref2, ref3;
      max = canvasJsOptions.axisX.maximum;
      if ((max == null) && (((ref = canvasJsOptions.data) != null ? (ref1 = ref[0]) != null ? (ref2 = ref1.dataPoints) != null ? (ref3 = ref2.last()) != null ? ref3.x : void 0 : void 0 : void 0 : void 0) != null)) {
        max = canvasJsOptions.data[0].dataPoints.last().x;
      }
      return max;
    };

    CanvasChartCanvasJs.prototype.restrictAnnotationsByXValueAndGroup = function(canvasJsOptions) {
      var a, anno, annotation_groups, id, idx, j, k, len, len1, max, min, p, ref, ref1, ret, startOfWeek, tz, xValueOffsetMap, x_value;
      if (this.isContinuousXAxis()) {
        min = this.axisMin(canvasJsOptions);
        max = this.axisMax(canvasJsOptions);
        tz = this.twiddle('timezone');
        startOfWeek = this.twiddle('start_of_week');
      } else {
        xValueOffsetMap = {};
        if (!((canvasJsOptions.data != null) && (canvasJsOptions.data.first() != null))) {
          return [];
        }
        ref = canvasJsOptions.data.first().dataPoints;
        for (idx = j = 0, len = ref.length; j < len; idx = ++j) {
          p = ref[idx];
          xValueOffsetMap[p.label || p.x] = idx;
        }
      }
      a = this.twiddles.getArray('annotation_groups');
      annotation_groups = a.to_set();
      ret = [];
      ref1 = App.Annotation.all();
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        anno = ref1[k];
        id = anno.id;
        if (annotation_groups[anno.group_name] != null) {
          x_value = anno.x_value;
          if (this.isDateSeries()) {
            x_value = App.TimeMachine.parseDateTimeToTimestamp(x_value, tz, startOfWeek);
          }
          if ((min != null) && (max != null) && ((min <= x_value && x_value <= max))) {
            ret.push({
              id: id,
              x_value: x_value
            });
          } else if (xValueOffsetMap != null) {
            x_value = xValueOffsetMap[x_value];
            if (x_value != null) {
              ret.push({
                id: id,
                x_value: x_value
              });
            }
          }
        }
      }
      return ret;
    };

    CanvasChartCanvasJs.prototype.setAxisOptions = function(canvasJsOptions) {
      var axis, base, base1, canvasAxis, canvasSetting, chartographerTwiddle, f, fitOptions, interval, j, k, l, labelSlotsOnAxis, len, len1, len2, minMax, numCategories, numLabels, ref, twiddlePair, twiddlePairs, twiddleVal, xAxisRange, xMinMax;
      this.setAxisFontColor(canvasJsOptions);
      twiddlePairs = [['title', '?_axis_title'], ['minimum', 'min_?_axis'], ['maximum', 'max_?_axis'], ['interval', '?_axis_interval']];
      ref = ['x', 'y', 'y2'];
      for (j = 0, len = ref.length; j < len; j++) {
        axis = ref[j];
        canvasAxis = 'axis' + axis.toUpperCase();
        for (k = 0, len1 = twiddlePairs.length; k < len1; k++) {
          twiddlePair = twiddlePairs[k];
          canvasSetting = twiddlePair[0];
          chartographerTwiddle = twiddlePair[1].replace('?', axis);
          twiddleVal = this.twiddle(chartographerTwiddle);
          if ((twiddleVal != null) && twiddleVal !== '') {
            if (axis === 'x' && twiddleVal === parseInt(twiddleVal) && this.twiddle('x_axis_type') === 'numeric') {
              twiddleVal = parseFloat(twiddleVal);
            }
            canvasJsOptions[canvasAxis][canvasSetting] = twiddleVal;
          }
        }
      }
      fitOptions = [
        {
          axis: 'y',
          canvasAxis: 'axisY',
          twiddle: 'Y_AXIS_FIT'
        }, {
          axis: 'y2',
          canvasAxis: 'axisY2',
          twiddle: 'Y2_AXIS_FIT'
        }
      ];
      for (l = 0, len2 = fitOptions.length; l < len2; l++) {
        f = fitOptions[l];
        if (!(this.twiddle(App.TwiddleConfig[f.twiddle]))) {
          continue;
        }
        minMax = App.CanvasChartCanvasJs.roundDecimalMinMax(this.yMinMaxExpensive(f.axis));
        if ((base = canvasJsOptions[f.canvasAxis]).minimum == null) {
          base.minimum = minMax[0];
        }
        if ((base1 = canvasJsOptions[f.canvasAxis]).maximum == null) {
          base1.maximum = minMax[1];
        }
      }
      if (this.isContinuousXAxis()) {
        xMinMax = this.xAxisMinMax(canvasJsOptions);
        xAxisRange = {
          hasMinSpecified: canvasJsOptions.axisX.minimum != null,
          hasMaxSpecified: canvasJsOptions.axisX.maximum != null,
          dataMin: xMinMax.min,
          dataMax: xMinMax.max
        };
        if (this.hasDiscreteMarkerSeries()) {
          this.stretchAxisToNotClipDiscreteMarker(canvasJsOptions, xAxisRange);
        }
        if (this.hasBubbleSeries()) {
          this.stretchAxisToNotClipBubbles(canvasJsOptions, xAxisRange);
        }
      }
      if (this.twiddle('horizontal')) {
        canvasJsOptions.axisY.margin = App.CanvasChartCanvasJs.BOTTOM_AXIS_MARGIN;
        canvasJsOptions.axisY2.margin = App.CanvasChartCanvasJs.BOTTOM_AXIS_MARGIN;
        canvasJsOptions.axisX.margin = App.CanvasChartCanvasJs.SIDE_AXIS_MARGIN;
      }
      labelSlotsOnAxis = App.CanvasChartCanvasJs.labelSlotsOnAxis(this.width, this.height, this.twiddles);
      if (this.twiddle('rotate_x_axis_labels')) {
        canvasJsOptions.axisX.labelAngle = 25;
        canvasJsOptions.axisX.labelWrap = false;
      }
      if (!((canvasJsOptions.axisX['interval'] != null) || canvasJsOptions.data.length === 0)) {
        numCategories = canvasJsOptions.data[0].dataPoints.length;
        numLabels = Math.min(labelSlotsOnAxis, numCategories);
        interval = Math.ceil(numCategories / numLabels);
        if (!this.isNumericXAxis()) {
          canvasJsOptions.axisX['interval'] = interval;
        }
        this.setXAxisLabelOptions(canvasJsOptions.axisX, numLabels);
      }
      canvasJsOptions.axisY.labels = {
        formatter: App.ChartFormatters.getYAxisFormatter(this.twiddle('y_axis_format'))
      };
      canvasJsOptions.axisY2.labels = {
        formatter: App.ChartFormatters.getYAxisFormatter(this.twiddle('y2_axis_format'))
      };
      canvasJsOptions.axisY.formatter = App.ChartFormatters.getYAxisFormatter(this.twiddle('y_axis_format'));
      canvasJsOptions.axisY2.formatter = App.ChartFormatters.getYAxisFormatter(this.twiddle('y2_axis_format'));
      canvasJsOptions.axisY.formatterOptions = {
        currency: this.twiddle('currency')
      };
      if (this.isDateSeries()) {
        this.setDateTimeAxisProperties(canvasJsOptions.axisX, xAxisRange);
      }
      if (this.twiddle('chart_type') === 'sparkline') {
        this.configureSparklineAxisOptions(canvasJsOptions);
      }
      return this.addAnnotations(canvasJsOptions);
    };

    CanvasChartCanvasJs.prototype.addThreshold = function(threshold, options) {
      if (threshold == null) {
        return;
      }
      return options.axisY.stripLines = [threshold];
    };

    CanvasChartCanvasJs.prototype.configureSparklineAxisOptions = function(canvasJsOptions) {
      var minMax;
      canvasJsOptions.axisX = jQuery.extend(canvasJsOptions.axisX, {
        valueFormatString: " ",
        tickThickness: 0,
        lineThickness: 0,
        formatter: function() {
          return '';
        }
      });
      minMax = this.yMinMaxExpensive(null);
      canvasJsOptions.axisY = jQuery.extend(canvasJsOptions.axisY, {
        valueFormatString: " ",
        gridThickness: 0,
        minimum: minMax[0],
        maximum: minMax[1],
        formatter: null
      });
      return canvasJsOptions.axisY2 = jQuery.extend(canvasJsOptions.axisY2, {
        valueFormatString: " ",
        gridThickness: 0,
        formatter: null
      });
    };

    CanvasChartCanvasJs.prototype.yMinMaxExpensive = function(axisFilter) {
      var allSeriesChartTypesAreStackable, combinedYValues, combinedYValuesByXValues, j, k, len, len1, max, min, padding, point, range, ref, ref1, series, value, y;
      min = 1e15;
      max = -1e15;
      combinedYValuesByXValues = {};
      allSeriesChartTypesAreStackable = true;
      ref = this.chartData.dataSeries;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        if (!(this.seriesOnAxis(series, axisFilter))) {
          continue;
        }
        if (!this.seriesChartTypeIsStackable(series.name)) {
          allSeriesChartTypesAreStackable = false;
        }
        ref1 = series.dataPoints;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          point = ref1[k];
          if (!(point != null)) {
            continue;
          }
          value = point.y;
          if (value == null) {
            continue;
          }
          y = value[1] != null ? value[1] : value;
          if (allSeriesChartTypesAreStackable) {
            combinedYValuesByXValues[point.x] = combinedYValuesByXValues[point.x] != null ? combinedYValuesByXValues[point.x] + y : y;
          }
          if (y < min) {
            min = y;
          }
          if (y > max) {
            max = y;
          }
        }
      }
      if (allSeriesChartTypesAreStackable) {
        combinedYValues = _.values(combinedYValuesByXValues).sort(function(a, b) {
          return a - b;
        });
        min = combinedYValues.first();
        max = combinedYValues.last();
      }
      range = max - min;
      if (range === 0) {
        range = 1;
      }
      padding = range * 0.07;
      if (min >= 0 && (min - padding) < 0) {
        padding = min;
      }
      min -= padding;
      max += padding;
      if (range >= 7) {
        min = Math.floor(min);
        max = Math.ceil(max);
      }
      if (max >= 100000 || max <= -100000) {
        max = App.Utils.roundToSignificantDigits(max, 3);
      }
      if (min >= 100000 || min <= -100000) {
        min = App.Utils.roundToSignificantDigits(min, 3);
      }
      return [min, max];
    };

    CanvasChartCanvasJs.prototype.seriesChartTypeIsStackable = function(seriesName) {
      var ref, ref1, ref2, translatedChartType;
      translatedChartType = this.constructor.translateChartType(seriesName, this.twiddles, ((ref = this.chartData) != null ? (ref1 = ref.dataSeries) != null ? (ref2 = ref1.data) != null ? ref2.length : void 0 : void 0 : void 0) > 1);
      return indexOf.call(this.constructor.STACKED_TRANSLATED_CHART_TYPES, translatedChartType) >= 0;
    };

    CanvasChartCanvasJs.roundDecimalMinMax = function(minMax) {
      var decimalDigits, digStr, digitCount, j, len, rangeBuffer, valRange, valRangeStr;
      valRange = minMax[1] - minMax[0];
      valRangeStr = String(valRange);
      if (!_.includes(valRangeStr, '.')) {
        return minMax;
      }
      digitCount = 1;
      decimalDigits = valRangeStr.split('.')[1].split('');
      for (j = 0, len = decimalDigits.length; j < len; j++) {
        digStr = decimalDigits[j];
        if (digStr !== '0') {
          break;
        }
        digitCount++;
      }
      rangeBuffer = Math.pow(10, -1 * digitCount) / 2;
      return [App.Utils.roundToDecimals(minMax[0] - rangeBuffer, digitCount), App.Utils.roundToDecimals(minMax[1] + rangeBuffer, digitCount)];
    };

    CanvasChartCanvasJs.prototype.seriesOnAxis = function(series, axisFilter) {
      if (!axisFilter) {
        return true;
      }
      if (axisFilter === 'y') {
        return this.seriesTwiddle(series, 'show_on_primary_axis');
      }
      if (axisFilter === 'y2') {
        return this.seriesTwiddle(series, 'show_on_secondary_axis');
      }
      return false;
    };

    CanvasChartCanvasJs.prototype.setXAxisLabelOptions = function(axisX, numLabels) {
      var axisSize, calculatedMax, defaultMax, tz;
      axisSize = this.twiddle('horizontal') ? this.height : this.width;
      defaultMax = App.CanvasChartCanvasJs.DEFAULT_LABEL_MAX_WIDTH;
      calculatedMax = Math.ceil(axisSize / numLabels) - App.CanvasChartCanvasJs.LABEL_MARGIN;
      axisX.labelMaxWidth = Math.max(defaultMax, calculatedMax);
      tz = this.twiddles.get('timezone');
      return axisX.formatter = function() {
        var max_letters, val;
        val = this.value || "";
        max_letters = App.CanvasChartCanvasJs.MAX_LABEL_LETTERS;
        if (val.length > max_letters) {
          val = val.substr(0, max_letters - 3) + "...";
        }
        return val;
      };
    };

    CanvasChartCanvasJs.prototype.setAxisFontColor = function(canvasJsOptions) {
      var axis, fontColor, j, k, len, len1, ref, ref1, results, series;
      if (App.DashboardSizer.useDarkTheme(this.el)) {
        fontColor = App.CanvasChartCanvasJs.EDITRON_TEXT_COLOR;
      } else {
        fontColor = App.CanvasChartCanvasJs.DASH_TEXT_COLOR;
      }
      ref = canvasJsOptions.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        series.indexLabelFontColor = fontColor;
      }
      ref1 = ['axisX', 'axisY', 'axisY2'];
      results = [];
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        axis = ref1[k];
        canvasJsOptions[axis].labelFontColor = fontColor;
        results.push(canvasJsOptions[axis].titleFontColor = fontColor);
      }
      return results;
    };

    CanvasChartCanvasJs.labelSlotsOnAxis = function(width, height, twiddles) {
      var axisSize;
      axisSize = twiddles.get('horizontal') ? height : width;
      return Math.round(axisSize / App.CanvasChartCanvasJs.PIXELS_PER_LABEL);
    };

    CanvasChartCanvasJs.prototype.setAxisMinMax = function(axisX, xAxisRange, minX, maxX) {
      if (!xAxisRange.hasMinSpecified) {
        if (axisX.minimum != null) {
          axisX.minimum = Math.min(axisX.minimum, minX);
        } else {
          axisX.minimum = minX;
        }
      }
      if (!xAxisRange.hasMaxSpecified) {
        if (axisX.maximum != null) {
          return axisX.maximum = Math.max(axisX.maximum, maxX);
        } else {
          return axisX.maximum = maxX;
        }
      }
    };

    CanvasChartCanvasJs.prototype.setDateTimeAxisProperties = function(axisX, xAxisRange) {
      var aggregation, axisDateAggregation, chartRangeInMs, max, min, slots;
      min = xAxisRange.hasMinSpecified ? axisX.minimum : xAxisRange.dataMin;
      max = xAxisRange.hasMaxSpecified ? axisX.maximum : xAxisRange.dataMax;
      chartRangeInMs = max - min;
      aggregation = this.twiddle('aggregation');
      slots = App.CanvasChartCanvasJs.labelSlotsOnAxis(this.width, this.height, this.twiddles);
      if ((aggregation == null) && chartRangeInMs > 500) {
        aggregation = App.TimeMachine.SECONDS;
      }
      if (aggregation != null) {
        axisDateAggregation = App.CanvasChartCanvasJs.axisDateAggregation(chartRangeInMs, aggregation);
        axisX.valueFormatString = this.axisValueFormat(axisX, axisDateAggregation);
        axisX.intervalType = App.CanvasChart.AGG_TO_CANVAS_AGG[axisDateAggregation];
        axisX.interval = App.CanvasChartCanvasJs.intervalSkipRate(axisDateAggregation, chartRangeInMs, slots, this.twiddles);
      } else {
        axisX.interval = App.CanvasChartCanvasJs.intervalSkipRateFromDuration(1, chartRangeInMs, slots, this.twiddles);
        axisX.valueFormatString = 'H:mm:ss.SSS A';
        axisX.intervalType = 'millisecond';
      }
      if (xAxisRange.hasMinSpecified && xAxisRange.hasMaxSpecified) {
        return;
      }
      return this.setAxisMinMax(axisX, xAxisRange, xAxisRange.dataMin, xAxisRange.dataMax);
    };

    CanvasChartCanvasJs.prototype.stretchAxisToNotClipDiscreteMarker = function(canvasJsOptions, xAxisRange) {
      var axisRange, axisX, endPointPaddingRatio, max, min, spacePerPoint;
      if (!(canvasJsOptions.data.length > 0)) {
        return;
      }
      axisX = canvasJsOptions.axisX;
      min = xAxisRange.hasMinSpecified ? axisX.minimum : xAxisRange.dataMin;
      max = xAxisRange.hasMaxSpecified ? axisX.maximum : xAxisRange.dataMax;
      axisRange = max - min;
      if (axisRange === 0) {
        axisRange = 1;
      }
      spacePerPoint = this.estimatedRenderedBarWidth(canvasJsOptions, axisRange);
      endPointPaddingRatio = 0.75;
      axisX.minimum = min - spacePerPoint * endPointPaddingRatio;
      return axisX.maximum = max + spacePerPoint * endPointPaddingRatio;
    };

    CanvasChartCanvasJs.prototype.stretchAxisToNotClipBubbles = function(canvasJsOptions, xAxisRange) {
      var aspectRatio, bubbleX, h, j, k, len, len1, maxPointX, maxX, maxZ, minPointX, minX, minZ, point, rangeX, rangeZ, ref, ref1, series, w, zMinMax;
      if (!(canvasJsOptions.data.length > 0)) {
        return;
      }
      if (xAxisRange.hasMinSpecified && xAxisRange.hasMaxSpecified) {
        return;
      }
      minX = xAxisRange.dataMin;
      maxX = xAxisRange.dataMax;
      zMinMax = this.zAxisMinMax(canvasJsOptions);
      minZ = zMinMax.min;
      maxZ = zMinMax.max;
      rangeX = maxX - minX;
      rangeZ = maxZ - minZ;
      if (rangeZ === 0) {
        return;
      }
      w = this.width;
      h = this.height;
      if (h < w) {
        aspectRatio = h / w;
      } else {
        aspectRatio = 1.0;
      }
      minPointX = 2e308;
      maxPointX = -2e308;
      ref = canvasJsOptions.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        ref1 = series.dataPoints;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          point = ref1[k];
          if (point.z != null) {
            bubbleX = aspectRatio * (point.z - minZ) * 1.33 * 0.125 * rangeX / rangeZ;
            bubbleX = Math.max(bubbleX, rangeX / 20.0);
            minPointX = Math.min(minPointX, point.x - bubbleX);
            maxPointX = Math.max(maxPointX, point.x + bubbleX);
          }
        }
      }
      return this.setAxisMinMax(canvasJsOptions.axisX, xAxisRange, minPointX, maxPointX);
    };

    CanvasChartCanvasJs.prototype.xAxisMinMax = function(canvasJsOptions) {
      var j, k, len, len1, max, min, point, ref, ref1, series;
      min = 2e308;
      max = -2e308;
      ref = canvasJsOptions.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        ref1 = series.dataPoints;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          point = ref1[k];
          min = Math.min(min, point.x);
          max = Math.max(max, point.x);
        }
      }
      return {
        min: min,
        max: max
      };
    };

    CanvasChartCanvasJs.prototype.zAxisMinMax = function(canvasJsOptions) {
      var j, k, len, len1, max, min, point, ref, ref1, series;
      min = 2e308;
      max = -2e308;
      ref = canvasJsOptions.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        ref1 = series.dataPoints;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          point = ref1[k];
          if (!(point.z != null)) {
            continue;
          }
          min = Math.min(min, point.z);
          max = Math.max(max, point.z);
        }
      }
      return {
        min: min,
        max: max
      };
    };

    CanvasChartCanvasJs.prototype.estimatedRenderedBarWidth = function(canvasJsOptions, axisRange) {
      var index, j, len, maxSpacePerPoint, minDiff, nextPoint, point, ref, series, spacePerPoint;
      series = canvasJsOptions.data[0];
      minDiff = 2e308;
      ref = series.dataPoints;
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        point = ref[index];
        nextPoint = series.dataPoints[index + 1];
        if (nextPoint == null) {
          continue;
        }
        minDiff = Math.min(nextPoint.x - point.x, minDiff);
      }
      if (minDiff === 2e308) {
        spacePerPoint = 1;
      } else {
        spacePerPoint = minDiff * 0.6;
      }
      maxSpacePerPoint = axisRange * 0.15;
      return spacePerPoint = Math.min(spacePerPoint, maxSpacePerPoint * this.pointWidth(canvasJsOptions));
    };

    CanvasChartCanvasJs.prototype.pointWidth = function(canvasJsOptions) {
      var hasSecondary, j, len, numColumns, ref, series;
      numColumns = 1;
      hasSecondary = false;
      ref = canvasJsOptions.data;
      for (j = 0, len = ref.length; j < len; j++) {
        series = ref[j];
        if (series.type === 'column') {
          numColumns++;
        }
        if (series.axisYType === 'secondary' && series.type === 'stackedColumn') {
          hasSecondary = true;
        }
      }
      if (hasSecondary) {
        numColumns++;
      }
      if (numColumns === 2) {
        numColumns++;
      }
      return numColumns;
    };

    CanvasChartCanvasJs.prototype.axisValueFormat = function(axisX, axisDateAggregation) {
      switch (axisDateAggregation) {
        case App.TimeMachine.SECONDS:
          return "MMM D H:mm:ss";
        case App.TimeMachine.MINUTES:
          return "MMM D H:mm";
        case App.TimeMachine.MONTHLY:
          return "MMM 'YY";
        case App.TimeMachine.HOURLY:
          return "MMM D H:mm";
        case App.TimeMachine.YEARLY:
          return "YYYY";
        case App.TimeMachine.QUARTERLY:
          return "Q YYYY";
        default:
          return "D. MMM";
      }
    };

    CanvasChartCanvasJs.intervalSkipRate = function(axisDateAggregation, chartRangeInMs, labelSlotsOnAxis, twiddles) {
      var aggregationDuration;
      if (twiddles.get('x_axis_interval') != null) {
        return twiddles.get('x_axis_interval');
      }
      aggregationDuration = App.CanvasChart.AGGREGATION_SIZE[axisDateAggregation] * App.CanvasChart.DAY_MS;
      return this.intervalSkipRateFromDuration(aggregationDuration, chartRangeInMs, labelSlotsOnAxis);
    };

    CanvasChartCanvasJs.intervalSkipRateFromDuration = function(aggregationDuration, chartRangeInMs, labelSlotsOnAxis, twiddles) {
      var interval, numAggregations;
      numAggregations = chartRangeInMs / aggregationDuration;
      interval = Math.round(numAggregations / labelSlotsOnAxis);
      if ((interval == null) || interval < 1 || isNaN(interval)) {
        interval = 1;
      }
      return interval;
    };

    CanvasChartCanvasJs.axisDateAggregation = function(chartRangeInMs, aggregation) {
      var aggSize, detectedAxisAggregation;
      if (chartRangeInMs < (1 / 120.0) * App.CanvasChart.DAY_MS) {
        detectedAxisAggregation = App.TimeMachine.SECONDS;
      } else if (chartRangeInMs < (1 / 12.0) * App.CanvasChart.DAY_MS) {
        detectedAxisAggregation = App.TimeMachine.MINUTES;
      } else if (chartRangeInMs < 3 * App.CanvasChart.DAY_MS) {
        detectedAxisAggregation = App.TimeMachine.HOURLY;
      } else if (chartRangeInMs < 60 * App.CanvasChart.DAY_MS) {
        detectedAxisAggregation = App.TimeMachine.DAILY;
      } else if (chartRangeInMs < 120 * App.CanvasChart.DAY_MS) {
        detectedAxisAggregation = App.TimeMachine.WEEKLY;
      } else {
        detectedAxisAggregation = App.TimeMachine.MONTHLY;
      }
      aggSize = App.CanvasChart.AGGREGATION_SIZE;
      if (aggSize[aggregation] > aggSize[detectedAxisAggregation]) {
        return aggregation;
      } else {
        return detectedAxisAggregation;
      }
    };

    CanvasChartCanvasJs.prototype.dataPointDblclick = function(event) {
      var dashboard_id, mappings, point;
      if (App.DashboardSizer.inEditron(this.el)) {
        return;
      }
      if (this.annotationController != null) {
        this.annotationController.hideAnnotation();
      }
      dashboard_id = this.twiddles.get('drilldown_dashboard');
      if (dashboard_id == null) {
        return false;
      }
      point = event.exactOriginalDataPoint;
      mappings = this.twiddles.get('drilldown_mapping');
      return App.DrilldownsController.applyDrilldownRequest(this, dashboard_id, mappings, point, this.twiddles);
    };

    CanvasChartCanvasJs.prototype.maybeAddDrilldown = function(series) {
      if (App.DrilldownsController.shouldAddDrilldown(this.el, this.twiddles)) {
        series["dblclick"] = this.dataPointDblclick;
        series["cursor"] = "pointer";
      }
      return series;
    };

    CanvasChartCanvasJs.prototype.canClickOnDataPoint = function() {
      var ref;
      if (AppRedesign.current().state.RbacEnabled) {
        return AppRedesign.createSqlChartsEnabledOnDashboard();
      } else {
        return (ref = App.User.currentUser()) != null ? ref.canEdit() : void 0;
      }
    };

    return CanvasChartCanvasJs;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CanvasChartDownload = (function(superClass) {
    extend(CanvasChartDownload, superClass);

    CanvasChartDownload.VECTOR_TO_RASTR_RATIO = 2;

    CanvasChartDownload.STYLE_PROPERTY_NAMES = ['background-color', 'border-bottom-left-radius', 'border-left-color', 'color', 'font-family', 'font-size', 'line-height', 'margin-right', 'padding-bottom', 'padding-left', 'padding-top'];

    function CanvasChartDownload() {
      CanvasChartDownload.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'chart', 'legendPosition');
    }

    CanvasChartDownload.prototype.getStyle = function(computedStyle) {
      var i, len, propertyName, ref, style;
      style = {};
      ref = App.CanvasChartDownload.STYLE_PROPERTY_NAMES;
      for (i = 0, len = ref.length; i < len; i++) {
        propertyName = ref[i];
        style[propertyName] = computedStyle.getPropertyValue(propertyName);
      }
      return style;
    };

    CanvasChartDownload.prototype.getAncestor = function(childElement, ancestorName) {
      var className, parentElement;
      parentElement = childElement.parentElement;
      if (parentElement == null) {
        return null;
      }
      className = parentElement.getAttribute('class');
      if (className != null) {
        className = className.split(' ').first();
        if (className === ancestorName) {
          return parentElement;
        }
      }
      return this.getAncestor(parentElement, ancestorName);
    };

    CanvasChartDownload.prototype.getModelInfoFromDOM = function(parentDOM, classToProcess, classWithText, level, parentModel) {
      var child, childModel, children, className, fullClassName, i, innerText, len, rect;
      if (level == null) {
        level = 0;
      }
      if (parentModel == null) {
        parentModel = {
          className: 'root',
          children: [],
          child: {}
        };
      }
      children = parentDOM.children;
      if (children == null) {
        return;
      }
      for (i = 0, len = children.length; i < len; i++) {
        child = children[i];
        className = child.getAttribute('class');
        fullClassName = className;
        if (className != null) {
          className = className.split(' ').first();
        }
        if (classToProcess != null ? classToProcess[className] : void 0) {
          if (classWithText[className]) {
            innerText = child.innerText;
          } else {
            innerText = '';
          }
          rect = {
            x: child.offsetLeft,
            y: child.offsetTop,
            width: child.offsetWidth,
            height: child.offsetHeight
          };
          childModel = {
            className: className,
            fullClassName: fullClassName,
            rect: rect,
            text: innerText,
            style: this.getStyle(window.getComputedStyle(child, '')),
            children: [],
            child: {}
          };
          parentModel.children.push(childModel);
          parentModel.child[className] = childModel;
          this.getModelInfoFromDOM(child, classToProcess, classWithText, level + 1, childModel);
        } else {
          if (!(level > 0)) {
            this.getModelInfoFromDOM(child, classToProcess, classWithText, 0, parentModel);
          }
        }
      }
      return parentModel;
    };

    CanvasChartDownload.prototype.getTitleModel = function(chartContainer) {
      var domModel, fontColor, fontFamily, fontSize, headerRect, marginRight, text, textRect, title, titleClass, titleClassWithText, widgetTitle;
      titleClass = {
        'title': true,
        'widget-title': true
      };
      titleClassWithText = {
        'widget-title': true
      };
      domModel = this.getModelInfoFromDOM(chartContainer, titleClass, titleClassWithText);
      title = domModel.child['title'];
      widgetTitle = title.child['widget-title'];
      marginRight = parseInt(widgetTitle.style['margin-right']);
      headerRect = title.rect;
      textRect = widgetTitle.rect;
      textRect.x = headerRect.x;
      textRect.y = headerRect.y;
      textRect.width = headerRect.width - marginRight;
      text = widgetTitle.text;
      fontColor = widgetTitle.style['color'];
      fontSize = widgetTitle.style['font-size'];
      fontFamily = widgetTitle.style['font-family'];
      return {
        textRect: textRect,
        text: text,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontColor: fontColor
      };
    };

    CanvasChartDownload.prototype.addLegendItemModel = function(topX, topY, item, legendModel) {
      var color, colorRadius, colorRect, fontColor, fontFamily, fontSize, itemColor, label, lineHeight, maxLines, textLeftPadding, textRect;
      label = item.child.label;
      color = label.child.color;
      colorRadius = parseInt(color.style['border-bottom-left-radius']);
      lineHeight = parseInt(label.style['line-height']);
      colorRect = {
        x: topX,
        y: topY + label.rect.y - 1,
        width: color.rect.width,
        height: color.rect.height
      };
      textLeftPadding = parseInt(label.style['padding-left']);
      maxLines = Math.round(label.rect.height / lineHeight);
      textRect = {
        x: topX + textLeftPadding,
        y: topY + label.rect.y,
        width: label.rect.width - textLeftPadding + 1,
        height: lineHeight
      };
      fontFamily = label.style['font-family'];
      fontSize = label.style['font-size'];
      fontColor = label.style['color'];
      itemColor = color.style['background-color'];
      return legendModel.items.push({
        itemRect: item.rect,
        colorRect: colorRect,
        colorRadius: colorRadius,
        color: itemColor,
        textRect: textRect,
        text: label.text,
        maxLines: maxLines,
        fontColor: fontColor,
        fontSize: fontSize,
        fontFamily: fontFamily
      });
    };

    CanvasChartDownload.prototype.addLegendItemsHorizontally = function(topX, topY, legendModel, items) {
      var expectedItemX, expectedItemY, i, item, len, newRow, nextExpectedY, text, xUnselectedItemsOffset, yUnselectedItemsOffset;
      yUnselectedItemsOffset = 0;
      nextExpectedY = legendModel.topPadding;
      expectedItemY = legendModel.topPadding;
      xUnselectedItemsOffset = 0;
      expectedItemX = 0;
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        newRow = item.rect.x === items[0].rect.x;
        if (newRow) {
          xUnselectedItemsOffset = 0;
          expectedItemX = item.rect.x;
          expectedItemY = nextExpectedY;
        }
        if (!(item.fullClassName === "item not-visible")) {
          text = item.child.label.text.trim();
          if (text.length > 0) {
            if (expectedItemY < item.rect.y) {
              yUnselectedItemsOffset += expectedItemY - item.rect.y;
              expectedItemY = item.rect.y;
            }
            nextExpectedY = item.rect.y + item.rect.height;
            xUnselectedItemsOffset += expectedItemX - item.rect.x;
            expectedItemX = item.rect.x + item.rect.width;
            this.addLegendItemModel(topX + item.rect.x + xUnselectedItemsOffset, topY + yUnselectedItemsOffset, item, legendModel);
          }
        }
      }
      return nextExpectedY + yUnselectedItemsOffset + 2 * legendModel.bottomPadding;
    };

    CanvasChartDownload.prototype.addLegendItemsVertically = function(topX, topY, legendModel, items) {
      var expectedItemY, i, item, len, text, yUnselectedItemsOffset;
      yUnselectedItemsOffset = 0;
      expectedItemY = legendModel.topPadding;
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        if (!(item.fullClassName === "item not-visible")) {
          text = item.child.label.text.trim();
          if (text.length > 0) {
            yUnselectedItemsOffset += expectedItemY - item.rect.y;
            expectedItemY = item.rect.y + item.rect.height;
            this.addLegendItemModel(topX + item.rect.x, topY + yUnselectedItemsOffset, item, legendModel);
          }
        }
      }
      return expectedItemY + yUnselectedItemsOffset + legendModel.bottomPadding;
    };

    CanvasChartDownload.prototype.getLegendModel = function(chartContainer) {
      var borderColor, bottomPadding, canvasChartRect, changeInHeight, domModel, legend, legendClassToProcess, legendClassWithText, legendModel, legendRadius, newHeight, rect, topPadding, topX, topY, widgetContent;
      legendClassToProcess = {
        chart: true,
        'canvasjs-chart-container': true,
        'widget-content': true,
        label: true,
        item: true,
        legend: true,
        color: true
      };
      legendClassWithText = {
        label: true
      };
      domModel = this.getModelInfoFromDOM(chartContainer, legendClassToProcess, legendClassWithText);
      widgetContent = domModel.child['widget-content'];
      if (widgetContent == null) {
        return null;
      }
      canvasChartRect = widgetContent.child['chart'].child['canvasjs-chart-container'].rect;
      canvasChartRect.x += widgetContent.rect.x;
      canvasChartRect.y += widgetContent.rect.y;
      canvasChartRect.width = widgetContent.child['chart'].rect.width;
      canvasChartRect.height = widgetContent.child['chart'].rect.height;
      legend = widgetContent.child['legend'];
      if (legend == null) {
        return {
          canvasChartContainer: canvasChartRect
        };
      }
      topX = widgetContent.rect.x + legend.rect.x;
      topY = widgetContent.rect.y + legend.rect.y;
      rect = legend.rect;
      legendRadius = parseInt(legend.style['border-bottom-left-radius']);
      borderColor = legend.style['border-left-color'];
      topPadding = parseInt(legend.style['padding-top']);
      bottomPadding = parseInt(legend.style['padding-bottom']);
      legendModel = {
        canvasChartContainer: canvasChartRect,
        legendRect: {
          x: topX,
          y: topY,
          width: legend.rect.width,
          height: legend.rect.height
        },
        legendRadius: legendRadius,
        topPadding: topPadding,
        bottomPadding: bottomPadding,
        borderColor: borderColor,
        items: [],
        legendHeightShrink: 0
      };
      if (['top', 'bottom'].includes(this.legendPosition)) {
        newHeight = this.addLegendItemsHorizontally(topX, topY + 2, legendModel, legend.children);
      } else {
        newHeight = this.addLegendItemsVertically(topX, topY + 1, legendModel, legend.children);
      }
      if (legendModel.legendRect.height > newHeight) {
        changeInHeight = legendModel.legendRect.height - newHeight;
        legendModel.legendRect.height -= changeInHeight;
        if (this.legendPosition === 'top') {
          legendModel.canvasChartContainer.y -= changeInHeight;
        }
        if (['top', 'bottom'].includes(this.legendPosition)) {
          legendModel.legendHeightShrink = changeInHeight;
        }
      }
      return legendModel;
    };

    CanvasChartDownload.prototype.drawTitle = function(ctx, titleModel) {
      if (titleModel == null) {
        return;
      }
      ctx.save();
      App.CanvasGraphics.setFont(ctx, titleModel.fontColor, titleModel.fontSize, titleModel.fontFamily);
      App.CanvasGraphics.fillWrapText(ctx, titleModel.text, titleModel.textRect.x, titleModel.textRect.y, titleModel.textRect.width, titleModel.textRect.height);
      return ctx.restore();
    };

    CanvasChartDownload.prototype.drawLegendItem = function(ctx, legendItem) {
      ctx.fillStyle = legendItem.color;
      ctx.strokeStyle = legendItem.color;
      App.CanvasGraphics.fillRoundedRect(ctx, legendItem.colorRect.x, legendItem.colorRect.y, legendItem.colorRect.width, legendItem.colorRect.height, legendItem.colorRadius);
      App.CanvasGraphics.setFont(ctx, legendItem.fontColor, legendItem.fontSize, legendItem.fontFamily);
      return App.CanvasGraphics.fillWrapText(ctx, legendItem.text, legendItem.textRect.x, legendItem.textRect.y, legendItem.textRect.width, legendItem.textRect.height, legendItem.maxLines);
    };

    CanvasChartDownload.prototype.drawLegend = function(ctx, legendModel) {
      var i, item, len, ref;
      if (legendModel == null) {
        return;
      }
      ctx.save();
      App.CanvasGraphics.clipRect(ctx, legendModel.legendRect);
      ref = legendModel.items;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        this.drawLegendItem(ctx, item);
      }
      ctx.restore();
      ctx.strokeStyle = legendModel.borderColor;
      return App.CanvasGraphics.drawRoundedRect(ctx, legendModel.legendRect.x, legendModel.legendRect.y, legendModel.legendRect.width, legendModel.legendRect.height, legendModel.legendRadius);
    };

    CanvasChartDownload.prototype.getImageDataURL = function() {
      var canvas, chartContainer, ctx, legendModel, titleModel, xScale, yScale;
      chartContainer = this.getAncestor(this.chart.canvas, 'widget-container');
      titleModel = this.getTitleModel(chartContainer);
      legendModel = this.getLegendModel(chartContainer);
      canvas = document.createElement('canvas');
      xScale = this.chart.canvas.width / legendModel.canvasChartContainer.width * this.vectorToRastrRatio();
      yScale = this.chart.canvas.height / legendModel.canvasChartContainer.height * this.vectorToRastrRatio();
      canvas.width = xScale * parseInt(chartContainer.style.width);
      canvas.height = yScale * parseInt(chartContainer.style.height) - legendModel.legendHeightShrink;
      ctx = canvas.getContext('2d');
      ctx.scale(xScale, yScale);
      ctx.drawImage(this.chart.canvas, legendModel.canvasChartContainer.x, legendModel.canvasChartContainer.y + 0.5, legendModel.canvasChartContainer.width, legendModel.canvasChartContainer.height);
      this.drawTitle(ctx, titleModel);
      this.drawLegend(ctx, legendModel);
      return canvas.toDataURL('image/png');
    };

    CanvasChartDownload.prototype.vectorToRastrRatio = function() {
      return App.CanvasChartDownload.VECTOR_TO_RASTR_RATIO / window.devicePixelRatio;
    };

    return CanvasChartDownload;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CanvasChartLegendSizer = (function(superClass) {
    extend(CanvasChartLegendSizer, superClass);

    CanvasChartLegendSizer.MAX_LEGEND_WIDTH_PERCENT = 0.90;

    CanvasChartLegendSizer.MAX_LEGEND_WIDE_WIDTH_PERCENT = 0.50;

    function CanvasChartLegendSizer() {
      CanvasChartLegendSizer.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'chartEl', 'legendEl', 'twiddles', 'isWide', 'width', 'height', 'leftOffset', 'rightOffset');
    }

    CanvasChartLegendSizer.prototype.hasCustomLegendWidth = function() {
      if (this.isLegendTopOrBottom()) {
        return false;
      }
      return this.twiddles.get('legend_width') != null;
    };

    CanvasChartLegendSizer.prototype.legendCustomWidth = function() {
      return this.twiddles.get('legend_width');
    };

    CanvasChartLegendSizer.prototype.legendPosition = function() {
      return this.twiddles.get('legend_position');
    };

    CanvasChartLegendSizer.prototype.setLegendLocation = function() {
      var i, len, location, locations, results;
      locations = ['left', 'right', 'top', 'bottom'];
      results = [];
      for (i = 0, len = locations.length; i < len; i++) {
        location = locations[i];
        results.push(this.legendEl.toggleClass(location, this.legendPosition() === location));
      }
      return results;
    };

    CanvasChartLegendSizer.prototype.setInitialLegendWidth = function() {
      var legendWidth, maxLegendWidth;
      if (this.hasCustomLegendWidth()) {
        maxLegendWidth = this.constructor.MAX_LEGEND_WIDTH_PERCENT * this.width;
        if (this.legendCustomWidth() > maxLegendWidth) {
          legendWidth = maxLegendWidth + 'px';
        } else {
          legendWidth = this.legendCustomWidth() + 'px';
        }
      } else {
        legendWidth = '';
      }
      return this.legendEl.css('width', legendWidth);
    };

    CanvasChartLegendSizer.prototype.getLegendHeight = function() {
      return parseInt(this.legendEl.css('height'));
    };

    CanvasChartLegendSizer.prototype.isLegendTopOrBottom = function() {
      return ['top', 'bottom'].includes(this.legendPosition());
    };

    CanvasChartLegendSizer.prototype.getLegendWidthAdjustedForHorizontalPosition = function() {
      var i, item, legendWidth, len, maxItemWidth, maxLegendWidth, ref;
      if (this.isLegendTopOrBottom()) {
        maxItemWidth = this.width - parseInt(this.legendEl.css('padding-left')) - parseInt(this.legendEl.css('padding-right'));
        ref = this.legendEl.children();
        for (i = 0, len = ref.length; i < len; i++) {
          item = ref[i];
          $(item).css('max-width', maxItemWidth + 'px');
        }
        return this.width;
      }
      legendWidth = parseInt(this.legendEl.css('width'));
      if (!this.hasCustomLegendWidth()) {
        if (this.isWide) {
          maxLegendWidth = this.constructor.MAX_LEGEND_WIDE_WIDTH_PERCENT * this.width;
        } else {
          maxLegendWidth = this.constructor.MAX_LEGEND_WIDTH_PERCENT * this.width;
        }
        if (legendWidth > maxLegendWidth) {
          legendWidth = maxLegendWidth;
          this.legendEl.css('width', legendWidth + 'px');
        }
      }
      return legendWidth;
    };

    CanvasChartLegendSizer.prototype.setChartHorizontalPositionAndWidth = function(legendWidth) {
      var chartLegendPadding, chartMarginLeft, chartMarginRight;
      switch (this.legendPosition()) {
        case 'left':
          chartLegendPadding = this.leftOffset;
          chartMarginLeft = (legendWidth + chartLegendPadding) + 'px';
          chartMarginRight = '';
          break;
        case 'right':
          chartLegendPadding = this.rightOffset;
          chartMarginRight = (legendWidth + chartLegendPadding) + 'px';
          chartMarginLeft = '';
          break;
        default:
          this.setChartToFullWidth();
          return;
      }
      this.chartEl.css('margin-left', chartMarginLeft);
      this.chartEl.css('margin-right', chartMarginRight);
      return this.chartEl.css('margin-top', '');
    };

    CanvasChartLegendSizer.prototype.setChartVerticalPosition = function(legendHeight) {
      if (this.legendPosition() === 'top') {
        this.chartEl.css('margin-top', legendHeight);
      } else {
        this.chartEl.css('margin-bottom', legendHeight);
      }
      return this.chartEl.css('height', this.height - legendHeight);
    };

    CanvasChartLegendSizer.prototype.setChartToFullWidth = function() {
      var base, base1, base2, base3;
      if (typeof (base = this.chartEl).css === "function") {
        base.css('margin-right', '');
      }
      if (typeof (base1 = this.chartEl).css === "function") {
        base1.css('margin-left', '');
      }
      if (typeof (base2 = this.chartEl).css === "function") {
        base2.css('margin-top', '');
      }
      return typeof (base3 = this.chartEl).css === "function" ? base3.css('height', this.height) : void 0;
    };

    CanvasChartLegendSizer.prototype.layoutChartAndLegend = function() {
      var adjustedLegendWidth;
      this.setLegendLocation();
      this.setInitialLegendWidth();
      adjustedLegendWidth = this.getLegendWidthAdjustedForHorizontalPosition();
      if (this.isWide) {
        this.setChartHorizontalPositionAndWidth(adjustedLegendWidth);
      } else {
        this.setChartToFullWidth();
      }
      if (this.isLegendTopOrBottom()) {
        return this.setChartVerticalPosition(this.getLegendHeight());
      }
    };

    return CanvasChartLegendSizer;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CanvasGraphics = (function(superClass) {
    extend(CanvasGraphics, superClass);

    function CanvasGraphics() {
      return CanvasGraphics.__super__.constructor.apply(this, arguments);
    }

    CanvasGraphics.roomForDotDotDot = 5;

    CanvasGraphics.outlineRoundRectPath = function(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      return ctx.quadraticCurveTo(x, y, x + radius, y);
    };

    CanvasGraphics.fillRoundedRect = function(ctx, x, y, width, height, radius, border) {
      if (border == null) {
        border = true;
      }
      ctx.translate(0.5, 0.5);
      App.CanvasGraphics.outlineRoundRectPath(ctx, x, y, width, height, radius);
      ctx.fill();
      if (border) {
        ctx.stroke();
      }
      return ctx.translate(-0.5, -0.5);
    };

    CanvasGraphics.drawRoundedRect = function(ctx, x, y, width, height, radius, lineWidth) {
      if (lineWidth == null) {
        lineWidth = 0.5;
      }
      ctx.translate(0.5, 0.5);
      ctx.lineWidth = lineWidth;
      App.CanvasGraphics.outlineRoundRectPath(ctx, x, y, width, height, radius);
      ctx.stroke();
      return ctx.translate(-0.5, -0.5);
    };

    CanvasGraphics.getContinuedLine = function(ctx, line, word, maxWidth) {
      var availableSpace, ch, charWidth, continueLine, i, len;
      availableSpace = maxWidth - ctx.measureText(line + '...').width - 1;
      continueLine = line;
      for (i = 0, len = word.length; i < len; i++) {
        ch = word[i];
        charWidth = ctx.measureText(ch).width;
        if (charWidth >= availableSpace) {
          return continueLine + '...';
        }
        availableSpace -= charWidth;
        continueLine += ch;
      }
      return continueLine;
    };

    CanvasGraphics.wrapLargeWord = function(ctx, word, x, y, lineCnt, maxWidth, lineHeight, maxLines, processedLines) {
      var extraChars, forsureLine, largeWord, line, testLength, testLine, testWidth;
      testWidth = ctx.measureText(word).width;
      if (testWidth > maxWidth) {
        largeWord = true;
        testLength = word.length;
        while (largeWord) {
          testLength--;
          testLine = word.substring(0, testLength);
          testWidth = ctx.measureText(testLine).width;
          if (testWidth <= maxWidth) {
            if (lineCnt < maxLines) {
              ctx.fillText(testLine, x, y);
              processedLines.push(this.createText(testLine, x, y));
            } else {
              forsureLine = testLine.substring(0, testLine.length - this.roomForDotDotDot);
              extraChars = testLine.substring(testLine.length - this.roomForDotDotDot);
              line = this.getContinuedLine(ctx, forsureLine, extraChars, maxWidth);
              ctx.fillText(line, x, y);
              processedLines.push(this.createText(line, x, y));
              return null;
            }
            lineCnt++;
            y += lineHeight;
            word = word.substring(testLength);
            testLength = word.length;
            testWidth = ctx.measureText(word).width;
          }
          if (testWidth <= maxWidth) {
            largeWord = false;
          }
        }
      }
      return {
        y: y,
        word: word,
        lineCnt: lineCnt
      };
    };

    CanvasGraphics.createText = function(text, x, y) {
      return {
        text: text,
        x: x,
        y: y
      };
    };

    CanvasGraphics.fillWrapText = function(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
      var extraChars, forsureLine, i, len, line, lineCnt, nextWord, processedLines, testLine, testWidth, word, words;
      if (maxLines == null) {
        maxLines = 1;
      }
      processedLines = [];
      words = text.split(' ');
      line = null;
      ctx.textBaseline = 'top';
      lineCnt = 1;
      for (i = 0, len = words.length; i < len; i++) {
        word = words[i];
        if (line === null) {
          nextWord = App.CanvasGraphics.wrapLargeWord(ctx, word, x, y, lineCnt, maxWidth, lineHeight, maxLines, processedLines);
          if (nextWord == null) {
            return processedLines;
          }
          line = nextWord.word;
          y = nextWord.y;
        } else {
          testLine = line + ' ' + word;
          testWidth = ctx.measureText(testLine).width;
          if (testWidth > maxWidth) {
            if (lineCnt < maxLines) {
              ctx.fillText(line, x, y);
              processedLines.push(this.createText(line, x, y));
            } else {
              forsureLine = testLine.substring(0, line.length - this.roomForDotDotDot);
              extraChars = testLine.substring(line.length - this.roomForDotDotDot) + word;
              ctx.fillText(this.getContinuedLine(ctx, forsureLine, extraChars, maxWidth), x, y);
              processedLines.push(this.createText(line, x, y));
              return processedLines;
            }
            y += lineHeight;
            lineCnt++;
            nextWord = App.CanvasGraphics.wrapLargeWord(ctx, word, x, y, lineCnt, maxWidth, lineHeight, maxLines, processedLines);
            if (nextWord == null) {
              return processedLines;
            }
            line = nextWord.word;
            y = nextWord.y;
            lineCnt = nextWord.lineCnt;
          } else {
            line = testLine;
          }
        }
      }
      ctx.fillText(line, x, y);
      processedLines.push(this.createText(line, x, y));
      return processedLines;
    };

    CanvasGraphics.drawRect = function(ctx, lineWidth, style, rect) {
      ctx.translate(0.5, 0.5);
      ctx.beginPath();
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = style;
      ctx.rect(rect.x, rect.y, rect.width, rect.height);
      ctx.stroke();
      return ctx.translate(-0.5, -0.5);
    };

    CanvasGraphics.clipRect = function(ctx, rect) {
      ctx.rect(rect.x, rect.y, rect.width, rect.height);
      return ctx.clip();
    };

    CanvasGraphics.setFont = function(ctx, fontColor, fontSize, fontFamily) {
      ctx.fillStyle = fontColor;
      return ctx.font = fontSize + ' ' + fontFamily;
    };

    return CanvasGraphics;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CanvasLegend = (function(superClass) {
    extend(CanvasLegend, superClass);

    CanvasLegend.prototype.events = {
      'mouseenter': 'mouseEnterLegend',
      'mouseleave': 'mouseLeaveLegend'
    };

    function CanvasLegend() {
      this.mouseLeaveLegend = bind(this.mouseLeaveLegend, this);
      this.mouseEnterLegend = bind(this.mouseEnterLegend, this);
      this.scrollLegendWithoutLeaking = bind(this.scrollLegendWithoutLeaking, this);
      this.clickTimeout = bind(this.clickTimeout, this);
      CanvasLegend.__super__.constructor.apply(this, arguments);
      this.resetClickInfo();
      App.Utils.requires(this, 'el');
    }

    CanvasLegend.prototype.render = function(chartData, hiddenSeries) {
      var displayPercentage, i, index, j, len, len1, percentageList, point, ref, ref1, results, roundedPercentageList, series, series_id, totalActivePercentage;
      this.el.html('');
      if (!this.bound) {
        this.el.on('click', this.clickTimeout);
        this.el.on('wheel mousewheel', this.scrollLegendWithoutLeaking);
        this.bound = true;
      }
      totalActivePercentage = 0;
      percentageList = [];
      ref = chartData.dataSeries;
      for (series_id = i = 0, len = ref.length; i < len; series_id = ++i) {
        series = ref[series_id];
        point = series.dataPoints.first();
        if ((point != null) && !hiddenSeries[series_id] && !isNaN(point.percentage)) {
          totalActivePercentage += point.percentage;
          percentageList.push(point.percentage);
        }
      }
      roundedPercentageList = App.Utils.displayRoundedPercentageList(percentageList);
      index = 0;
      ref1 = chartData.dataSeries;
      results = [];
      for (series_id = j = 0, len1 = ref1.length; j < len1; series_id = ++j) {
        series = ref1[series_id];
        displayPercentage = roundedPercentageList[index];
        if (chartData.twiddlesActual.getForSeries(series.name, 'show_on_secondary_axis') || chartData.twiddlesActual.getForSeries(series.name, 'show_on_primary_axis')) {
          if (!!hiddenSeries[series_id]) {
            displayPercentage = 0;
          } else {
            displayPercentage = roundedPercentageList[index];
            index++;
          }
          results.push(this.appendSeries(series, chartData.twiddlesActual, series_id, !!hiddenSeries[series_id], totalActivePercentage, displayPercentage));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    CanvasLegend.prototype.hide = function() {
      return this.el.hide();
    };

    CanvasLegend.prototype.show = function() {
      return this.el.show();
    };

    CanvasLegend.prototype.resetClickInfo = function() {
      this.clickCount = 0;
      return this.lastClicked = -1;
    };

    CanvasLegend.prototype.clickTimeout = function(event) {
      var legendElement, seriesId;
      legendElement = $(event.target).closest('.item');
      seriesId = parseInt(legendElement.attr('series_id'));
      this.clickCount += 1;
      if (this.clickCount === 1 || seriesId !== this.lastClicked) {
        this.lastClicked = seriesId;
        this.trigger('legend-click', seriesId);
        if (this.singleClickTimer) {
          clearTimeout(this.singleClickTimer);
        }
        return this.singleClickTimer = setTimeout(((function(_this) {
          return function() {
            return _this.resetClickInfo();
          };
        })(this)), AppRedesign.DOUBLE_CLICK_TIMEFRAME);
      } else if (this.clickCount === 2 && seriesId === this.lastClicked) {
        if (this.singleClickTimer) {
          clearTimeout(this.singleClickTimer);
        }
        this.resetClickInfo();
        return this.trigger('legend-dblclick', seriesId);
      }
    };

    CanvasLegend.prototype.scrollLegendWithoutLeaking = function(event) {
      if (!this.noLeaking) {
        return;
      }
      return App.Utils.scrollWithoutLeaking(event, this.el);
    };

    CanvasLegend.prototype.appendSeries = function(series, twiddles, seriesId, isHidden, totalActivePercentage, displayPercentage) {
      var seriesElement;
      seriesElement = $(this.view('ninja_chart/legend_item')({
        color: twiddles.getForSeries(series.name, 'legend_color'),
        label: this.nameForSeries(series, twiddles, isHidden, totalActivePercentage, displayPercentage),
        seriesId: seriesId,
        isHidden: isHidden
      }));
      return this.el.append(seriesElement);
    };

    CanvasLegend.prototype.nameForSeries = function(series, twiddles, isHidden, totalActivePercentage, displayPercentage) {
      var name, point;
      name = twiddles.getForSeries(series.name, 'display_name') || series.name;
      if (twiddles.get('show_values_in_legend') && twiddles.get('chart_type') === 'pie' && totalActivePercentage > 0) {
        point = series.dataPoints.first();
        if (isHidden) {
          displayPercentage = 0;
        }
        name = displayPercentage + "%: " + name;
      }
      return name;
    };

    CanvasLegend.prototype.childrenHeight = function() {
      var c, height, i, len, ref;
      height = 0;
      ref = this.el.children();
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        height += $(c).outerHeight(true);
      }
      return height;
    };

    CanvasLegend.prototype.needsScroll = function() {
      return this.el.height() < this.childrenHeight();
    };

    CanvasLegend.prototype.mouseEnterLegend = function() {
      if (App.RedesignDashboardsController.timeSinceLastDashboardScroll() > 350 && this.needsScroll()) {
        this.el.addClass('scroll-ok');
        return this.noLeaking = true;
      } else {
        return this.scrollTimeout = setTimeout(this.mouseEnterLegend, 50);
      }
    };

    CanvasLegend.prototype.mouseLeaveLegend = function() {
      clearTimeout(this.scrollTimeout);
      delete this.noLeaking;
      return this.el.removeClass('scroll-ok');
    };

    return CanvasLegend;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ChartOverlay = (function(superClass) {
    extend(ChartOverlay, superClass);

    ChartOverlay.prototype.elements = {
      '.chart-title': 'chartTitleEl',
      '.latest-value': 'latestValueEl',
      '.original-value': 'originalValueEl'
    };

    ChartOverlay.BIGNUM_AUTOFIT = 'autofit';

    ChartOverlay.BIGNUM_DEFAULT_FONT_SIZE = 77;

    ChartOverlay.BIGNUM_DEFAULT_TEXT_SIZE = 'normal';

    ChartOverlay.BIGNUM_DEFAULT_MARGIN_BOTTOM = 20;

    ChartOverlay.ORIGINAL_VALUE_BUFFER = 5;

    ChartOverlay.ORIGINAL_VALUE_FONT_SIZE = ChartOverlay.BIGNUM_DEFAULT_FONT_SIZE * .19;

    ChartOverlay.FONT_SIZE_MAPPINGS = {
      'xsmall': 34.2,
      'small': 51.3,
      'normal': 77.0,
      'large': 115.5,
      'xlarge': 173.2
    };

    ChartOverlay.OVERLAY_TOP_RATIO = 0.24;

    ChartOverlay.BUFFER_WIDTH = 12;

    function ChartOverlay() {
      this.hideOverlay = bind(this.hideOverlay, this);
      this.renderOverlay = bind(this.renderOverlay, this);
      this.chartUnhover = bind(this.chartUnhover, this);
      this.chartHover = bind(this.chartHover, this);
      this.release = bind(this.release, this);
      ChartOverlay.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el');
      this.html(this.view('widgets/chart_overlay')());
    }

    ChartOverlay.prototype.release = function() {
      return ChartOverlay.__super__.release.apply(this, arguments);
    };

    ChartOverlay.prototype.overlayShouldShow = function() {
      var ref;
      return (ref = this.twiddles.get('chart_type')) === 'bignumber' || ref === 'sparkline';
    };

    ChartOverlay.prototype.overlayCanFade = function() {
      return this.twiddles.get('chart_type') === 'bignumber' && !this.useHeavyOverlay();
    };

    ChartOverlay.prototype.render = function(chartData, title, animate) {
      this.chartData = chartData;
      if (animate == null) {
        animate = false;
      }
      this.twiddles = this.chartData.twiddlesActual;
      if (this.overlayShouldShow()) {
        return this.renderOverlay(title, animate);
      } else {
        return this.hideOverlay();
      }
    };

    ChartOverlay.prototype.updateTitle = function(title) {
      return this.chartTitleEl.text(title);
    };

    ChartOverlay.prototype.updateLatestValue = function(displayValue) {
      this.latestValueEl.text(this.formattedOverlayValue(displayValue));
      return this.latestValueEl.html(this.latestValueEl.html().trim().replace(/\n/g, "<br>"));
    };

    ChartOverlay.prototype.showOverlayValue = function(animate) {
      var value;
      clearTimeout(this.animationTimeout);
      value = this.overlayValue();
      if (animate && $.isNumeric(value) && !App.SetUpScreenshotMode.screenshotModeInUrl()) {
        return this.animateLatestValue(value, AppRedesign.timestamp());
      } else {
        return this.updateLatestValue(value);
      }
    };

    ChartOverlay.prototype.showOriginalValueOnHover = function() {
      return this.twiddles.get(App.TwiddleConfig.OVERLAY_VALUE_ON_HOVER) && this.twiddles.get(App.TwiddleConfig.OVERLAY_HAS_ONE_DATA_POINT);
    };

    ChartOverlay.prototype.animateLatestValue = function(value, startTime) {
      var animationPercent;
      animationPercent = (AppRedesign.timestamp() - startTime) / this.getAnimationDuration();
      this.updateLatestValue(value);
      if (animationPercent < 1) {
        return this.animationTimeout = setTimeout(((function(_this) {
          return function() {
            return _this.animateLatestValue(value, startTime);
          };
        })(this)), 33);
      }
    };

    ChartOverlay.prototype.getAnimationDuration = function() {
      var ref;
      if (((ref = AppRedesign.current()) != null ? ref.getCurrentState() : void 0) === AppRedesign.IN_DASH) {
        return 5000;
      } else {
        return 1;
      }
    };

    ChartOverlay.prototype.chartHover = function(event) {
      if (!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement)) {
        if (this.overlayCanFade()) {
          if (this.el.data('animateTimeout') != null) {
            clearTimeout(this.el.data('animateTimeout'));
          }
          this.el.removeClass('shown');
          this.el.data('animateTimeout', setTimeout(((function(_this) {
            return function() {
              return _this.el.css("visibility", "hidden");
            };
          })(this)), 50));
        }
        if (this.showOriginalValueOnHover()) {
          return this.originalValueEl.css('opacity', '1');
        }
      }
    };

    ChartOverlay.prototype.chartUnhover = function(event) {
      if (this.showOriginalValueOnHover()) {
        this.originalValueEl.css('opacity', '0');
      }
      if (this.overlayShouldShow() && this.overlayCanFade()) {
        this.el.css("visibility", "initial");
        return App.Utils.animateHack(true, 'shown', this.el);
      }
    };

    ChartOverlay.prototype.useHeavyOverlay = function() {
      return this.twiddles.get(App.TwiddleConfig.OVERLAY_HAS_ONE_DATA_POINT);
    };

    ChartOverlay.prototype.findLastNotNullValue = function(dataPoints) {
      var j, p;
      for (j = dataPoints.length - 1; j >= 0; j += -1) {
        p = dataPoints[j];
        if (p.y != null) {
          return p;
        }
      }
    };

    ChartOverlay.prototype.findLastNotNullPoint = function() {
      return this.findLastNotNullValue(this.chartData.dataSeries.first().dataPoints);
    };

    ChartOverlay.prototype.overlayValue = function() {
      var j, lastPoint, lastSum, len, p, ref, ref1, ref2, valueColName;
      lastPoint = this.findLastNotNullPoint();
      if (lastPoint == null) {
        return null;
      }
      if (this.twiddles.get('value_column_type') === 'datetime') {
        valueColName = this.twiddles.get('value_cols').first();
        return (ref = lastPoint.row[valueColName]) != null ? (ref1 = ref[0]) != null ? ref1[valueColName] : void 0 : void 0;
      } else {
        if (this.twiddles.get('overlay_cumulative')) {
          lastSum = 0;
          ref2 = this.chartData.dataSeries.first().dataPoints;
          for (j = 0, len = ref2.length; j < len; j++) {
            p = ref2[j];
            if (p.y == null) {
              p.y = 0;
            }
            lastSum += p.y;
          }
          return lastSum;
        } else {
          return lastPoint.y;
        }
      }
    };

    ChartOverlay.prototype.originalValue = function() {
      var lastPoint, ref, valueColName;
      lastPoint = this.findLastNotNullPoint();
      if (lastPoint == null) {
        return null;
      }
      valueColName = (ref = this.twiddles.get('value_cols')) != null ? ref.first() : void 0;
      if (valueColName && lastPoint.row[valueColName]) {
        return lastPoint.row[valueColName][0][valueColName];
      }
      if (lastPoint.y != null) {
        return lastPoint.y;
      }
      return null;
    };

    ChartOverlay.prototype.roundOverlayValue = function() {
      return !this.twiddles.get('do_not_round_big_number');
    };

    ChartOverlay.prototype.renderOverlay = function(title, animate) {
      App.Utils.animateHack(true, 'shown', this.el);
      if (this.twiddles.get('overlay_zoom') != null) {
        this.chartTitleEl.css({
          "zoom": this.twiddles.get('overlay_zoom')
        });
        this.latestValueEl.css({
          "zoom": this.twiddles.get('overlay_zoom')
        });
        this.originalValueEl.css({
          "zoom": this.twiddles.get('overlay_zoom')
        });
      }
      this.setConditionalFormatting();
      this.el.toggleClass('heavy', this.useHeavyOverlay());
      this.el.toggleClass('nofade', !this.overlayCanFade());
      this.updateTitle(title);
      this.showOverlayValue(animate);
      return this.originalValueEl.text("Original Value: " + (this.originalValue()));
    };

    ChartOverlay.prototype.setConditionalFormatting = function() {
      var allCfRules, bgColor, rawValueStr, rule, sourceColumn, textColor, titleEl, titleZ, valueIsNumeric;
      allCfRules = (this.twiddles.get('conditional_formatting') || []).slice(0);
      sourceColumn = (this.twiddles.get('value_cols') || []).first();
      if (!sourceColumn) {
        return;
      }
      rawValueStr = String(this.overlayValue());
      valueIsNumeric = this.twiddles.get('value_column_type') === 'numeric';
      rule = App.RedesignConditionalFormattingRuleController.matchFirstRule(allCfRules, sourceColumn, rawValueStr, valueIsNumeric);
      textColor = (rule != null ? rule.text_color : void 0) || '';
      this.latestValueEl.css('color', textColor);
      this.chartTitleEl.css('color', textColor);
      this.originalValueEl.css('color', textColor);
      bgColor = rule != null ? rule.bg_color : void 0;
      if (bgColor && this.overlayCanFade()) {
        bgColor = App.ColorHelper.hexToRGBA(bgColor, 0.7);
      }
      this.el.css('backgroundColor', bgColor || '');
      this.originalValueEl.css('backgroundColor', bgColor || '');
      titleEl = this.el.closest('.widget-container').find('.title');
      titleZ = (!bgColor || this.overlayCanFade() ? '' : 9);
      return titleEl.css('zIndex', titleZ);
    };

    ChartOverlay.prototype.hideOverlay = function() {
      return App.Utils.animateHack(false, 'shown heavy', this.el);
    };

    ChartOverlay.prototype.formattedOverlayValue = function(value) {
      var formatter;
      if (!$.isNumeric(value)) {
        return value;
      }
      formatter = new App.SeriesFormatter(this.chartData.dataSeries.first(), this.twiddles);
      if (this.roundOverlayValue()) {
        return formatter.formatValue(value);
      } else {
        return formatter.formatValueNoRounding(value);
      }
    };

    ChartOverlay.autoFitFontSize = function(bigNumParent, contentScale) {
      var MAX_ATTEMPTS, i, j, maxSize, minSize, ref, trySize;
      minSize = this.FONT_SIZE_MAPPINGS['xsmall'] * contentScale;
      maxSize = this.FONT_SIZE_MAPPINGS['xlarge'] * contentScale;
      MAX_ATTEMPTS = 10;
      for (i = j = 0, ref = MAX_ATTEMPTS; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        trySize = (minSize + maxSize) / 2;
        this.setOverlayFontSize(bigNumParent, trySize);
        if (this.hasOverflownWidth(bigNumParent) || this.hasOverflownHeight(bigNumParent)) {
          maxSize = trySize;
        } else if (this.textWidth(bigNumParent) === this.parentWidth(bigNumParent) && this.textHeight(bigNumParent) === this.parentHeight(bigNumParent)) {
          return trySize;
        } else {
          minSize = trySize;
        }
      }
      return minSize;
    };

    ChartOverlay.parentWidth = function(bigNumParent) {
      return bigNumParent.find('.bignumber-content').width();
    };

    ChartOverlay.parentHeight = function(bigNumParent) {
      return bigNumParent.find('.bignumber-content').height();
    };

    ChartOverlay.originalValueDistanceFromBottom = function(bigNumParent) {
      return bigNumParent.find('.bignumber-overlay').height() - bigNumParent.find('.original-value')[0].offsetTop + this.ORIGINAL_VALUE_BUFFER;
    };

    ChartOverlay.textHeight = function(bigNumParent) {
      var chartTitle, latestValue;
      latestValue = bigNumParent.find('.latest-value')[0].scrollHeight;
      chartTitle = bigNumParent.find('.chart-title')[0].scrollHeight;
      return latestValue + chartTitle + this.originalValueDistanceFromBottom(bigNumParent);
    };

    ChartOverlay.hasOverflownHeight = function(bigNumParent) {
      return this.textHeight(bigNumParent) > this.parentHeight(bigNumParent);
    };

    ChartOverlay.textWidth = function(bigNumParent) {
      var chartTitle, latestValue;
      latestValue = bigNumParent.find('.latest-value')[0].scrollWidth;
      chartTitle = bigNumParent.find('.chart-title')[0].scrollWidth;
      return Math.max(latestValue, chartTitle);
    };

    ChartOverlay.hasOverflownWidth = function(bigNumParent) {
      return this.textWidth(bigNumParent) > this.parentWidth(bigNumParent);
    };

    ChartOverlay.setOverlayFontSize = function(bigNumParent, fontSize) {
      return bigNumParent.find('.bignumber-overlay').css({
        fontSize: fontSize + "px"
      });
    };

    ChartOverlay.alertInChart = function(bigNumParent) {
      if (bigNumParent.find('.alert-flex-wrapper').css('display') !== 'none') {
        return bigNumParent.find('.alert-flex-wrapper');
      }
    };

    ChartOverlay.sizeBigNumberOverlay = function(widget, bigNumParent, contentScale, parentWidth, parentHeight) {
      var alertEl, fontSize, textSize;
      alertEl = this.alertInChart(bigNumParent);
      if (alertEl != null) {
        bigNumParent.find('.bignumber-content').css('padding-top', alertEl.outerHeight(true) + "px");
      } else {
        bigNumParent.find('.bignumber-content').css('padding-top', 0);
      }
      bigNumParent.find('.latest-value').css({
        marginBottom: this.BIGNUM_DEFAULT_MARGIN_BOTTOM * contentScale + "px"
      });
      bigNumParent.find('.original-value').css({
        fontSize: this.ORIGINAL_VALUE_FONT_SIZE * contentScale + "px"
      });
      bigNumParent.find('.bignumber-content').height(parentHeight * (1 - this.OVERLAY_TOP_RATIO) - this.BUFFER_WIDTH);
      bigNumParent.find('.bignumber-content').width(parentWidth - this.BUFFER_WIDTH * 2);
      textSize = widget.getTwiddle(App.TwiddleConfig.OVERLAY_TEXT_SIZE);
      if (textSize == null) {
        textSize = this.BIGNUM_DEFAULT_TEXT_SIZE;
      }
      if (textSize === this.BIGNUM_AUTOFIT) {
        fontSize = this.autoFitFontSize(bigNumParent, contentScale);
      } else {
        fontSize = this.FONT_SIZE_MAPPINGS[textSize] * contentScale;
      }
      return this.setOverlayFontSize(bigNumParent, fontSize);
    };

    return ChartOverlay;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ImageChart = (function(superClass) {
    extend(ImageChart, superClass);

    ImageChart.prototype.className = 'image-frame';

    function ImageChart() {
      this.imageLoaded = bind(this.imageLoaded, this);
      ImageChart.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget', 'chartData');
    }

    ImageChart.prototype.render = function() {
      this.html(this.view('image_chart/image_chart')());
      this.$('img').on('load', this.imageLoaded);
      return this.$('img').attr('src', this.imageSrc());
    };

    ImageChart.prototype.imageSrc = function() {
      var url;
      url = this.chartData.chartType === 'codeimage' ? this.chartData.linkData : this.chartData.dataSeries[0].dataPoints[0].y;
      return App.extraEmebbedUrlSanitization(url);
    };

    ImageChart.prototype.unrender = function() {
      return this.html('');
    };

    ImageChart.prototype.clear = function() {
      return this.unrender();
    };

    ImageChart.prototype.getImageData = function() {
      return window.reactApp.retrieveDataURLForS3Link(this.imageSrc());
    };

    ImageChart.prototype.imageLoaded = function() {
      return this.widget.triggerRendered();
    };

    return ImageChart;

  })(Spine.Controller);

  App.extraEmebbedUrlSanitization = function(url) {
    return url.replace(/[<>'"!{}\(\)`#, ]/g, '').replace('javascript:', '');
  };

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PlotlyCodeChart = (function(superClass) {
    extend(PlotlyCodeChart, superClass);

    PlotlyCodeChart.prototype.className = 'plotly-code-chart';

    PlotlyCodeChart.prototype.elements = {
      '.react-root': 'reactRootEl'
    };

    PlotlyCodeChart.prototype.events = {
      "click": "interceptClickEvent"
    };

    function PlotlyCodeChart() {
      this.applyDrilldownRequest = bind(this.applyDrilldownRequest, this);
      this.constructImageData = bind(this.constructImageData, this);
      this.getImageData = bind(this.getImageData, this);
      PlotlyCodeChart.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'chartData', 'widget');
      this.widget.bind('plotly-drilldown', this.applyDrilldownRequest);
      this.html("<div class=\"react-root plotly-root\"></div>");
      this.resize();
    }

    PlotlyCodeChart.prototype.render = function() {
      var debouncedRender;
      debouncedRender = _.debounce(((function(_this) {
        return function() {
          return _this.resize();
        };
      })(this)), 500, true);
      return debouncedRender();
    };

    PlotlyCodeChart.prototype.resize = function() {
      this.plotlyData = $.extend({}, this.chartData.linkData);
      this.plotlyData.height = this.$el.height();
      this.plotlyData.width = this.$el.width();
      this.plotlyData.widgetId = this.widget.id;
      this.reactRoot = window.reactApp.plotlyCodeChartRoot(this.reactRootEl[0], this.plotlyData);
      return this.widget.triggerRendered();
    };

    PlotlyCodeChart.prototype.interceptClickEvent = function(e) {
      return e.stopImmediatePropagation();
    };

    PlotlyCodeChart.prototype.getImageData = function() {
      return this.imageData;
    };

    PlotlyCodeChart.prototype.constructImageData = function() {
      if (typeof Plotly !== "undefined" && Plotly !== null) {
        return Plotly.toImage(this.plotlyData, {
          height: this.widget.fluid_height * App.RedesignWidgetsController.units(),
          width: this.widget.fluid_width * App.RedesignWidgetsController.units()
        }).then((function(_this) {
          return function(data) {
            return _this.imageData = data;
          };
        })(this));
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.constructImageData();
          };
        })(this)), 50);
      }
    };

    PlotlyCodeChart.prototype.release = function() {
      var ref;
      this.widget.unbind('plotly-drilldown', this.applyDrilldownRequest);
      if ((ref = this.reactRoot) != null) {
        ref.close();
      }
      return PlotlyCodeChart.__super__.release.apply(this, arguments);
    };

    PlotlyCodeChart.prototype.unrender = function() {
      return this.html('');
    };

    PlotlyCodeChart.prototype.applyDrilldownRequest = function(widget, traceName, value) {
      var dashboard_id, i, len, mapping, mappings, point, twiddleMap;
      twiddleMap = new App.TwiddleMap(widget.twiddles, true);
      dashboard_id = twiddleMap.get('drilldown_dashboard');
      if (dashboard_id == null) {
        return;
      }
      mappings = twiddleMap.get('drilldown_mapping');
      if (mappings == null) {
        return;
      }
      for (i = 0, len = mappings.length; i < len; i++) {
        mapping = mappings[i];
        if (mapping.column === traceName) {
          point = {};
          point[traceName] = value.toString();
          return App.DrilldownsController.applyDrilldownRequest(this, dashboard_id, mappings, point, twiddleMap);
        }
      }
      return false;
    };

    PlotlyCodeChart.receiveDrilldownRequest = function(traceName, value, widgetId) {
      var widget;
      if (App.RedesignDashboardSizer.inEditron(this.el)) {
        return false;
      }
      widget = App.Widget.exists(widgetId);
      if (widget == null) {
        return;
      }
      return widget.trigger('plotly-drilldown', traceName, value);
    };

    return PlotlyCodeChart;

  })(Spine.Controller);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.TextChart = (function(superClass) {
    extend(TextChart, superClass);

    TextChart.prototype.className = 'text-frame';

    TextChart.prototype.elements = {
      '.text-area': 'testArea'
    };

    function TextChart() {
      TextChart.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'widget', 'chartData');
      this.html(this.view('widgets/text_chart')());
    }

    TextChart.prototype.render = function() {
      return this.testArea.text(this.text());
    };

    TextChart.prototype.text = function() {
      return App.textSanitization(this.chartData.linkData);
    };

    TextChart.prototype.unrender = function() {
      return this.html('');
    };

    TextChart.prototype.clear = function() {
      return this.unrender();
    };

    return TextChart;

  })(Spine.Controller);

  App.textSanitization = function(text) {
    return text;
  };

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SqlBox = (function(superClass) {
    extend(SqlBox, superClass);

    SqlBox.MAX_HEIGHT_FOR_TOOLTIP_ABOVE_SNIPPET_PX = 110;

    SqlBox.cachedPeriscopeSyntaxClass = {};

    SqlBox.prototype.elements = {
      '.CodeMirror': 'codeMirrorEl'
    };

    SqlBox.prototype.events = {
      'mouseenter .CodeMirror .cm-snippet': 'mouseEnterKw',
      'mousemove .CodeMirror  .cm-snippet': 'mouseEnterKw',
      'blur   .CodeMirror': 'codeMirrorBlurred',
      'submitted .CodeMirror': 'codeMirrorSubmit',
      'keydown .CodeMirror': 'codeMirrorKeydown',
      'mousedown   .CodeMirror': 'selectCodeMirror',
      'mouseleave  .cm-snippet': 'hideTooltip',
      'mouseenter  .cm-sql-view': 'mouseEnterKw',
      'mousemove   .cm-sql-view': 'mouseEnterKw',
      'mouseleave  .cm-sql-view': 'hideTooltip',
      'mouseenter  .cm-csv-view': 'mouseEnterKw',
      'mousemove   .cm-csv-view': 'mouseEnterKw',
      'mouseleave  .cm-csv-view': 'hideTooltip'
    };

    function SqlBox() {
      this.finishFormatResponse = bind(this.finishFormatResponse, this);
      this.handleFormatResponse = bind(this.handleFormatResponse, this);
      this.reformatSql = bind(this.reformatSql, this);
      this.maybeFade = bind(this.maybeFade, this);
      this.hideTooltip = bind(this.hideTooltip, this);
      this.mouseEnterKw = bind(this.mouseEnterKw, this);
      this.codeMirrorSubmit = bind(this.codeMirrorSubmit, this);
      this.triggerSubmittedIfMetaEnter = bind(this.triggerSubmittedIfMetaEnter, this);
      this.codeMirrorKeydown = bind(this.codeMirrorKeydown, this);
      this.codeMirrorBlurred = bind(this.codeMirrorBlurred, this);
      this.selectCodeMirror = bind(this.selectCodeMirror, this);
      this.cursorActivity = bind(this.cursorActivity, this);
      this.checkModified = bind(this.checkModified, this);
      this.insertAtCursor = bind(this.insertAtCursor, this);
      this.setSql = bind(this.setSql, this);
      this.getSql = bind(this.getSql, this);
      this.timeoutLoopCodeMirror = bind(this.timeoutLoopCodeMirror, this);
      this.deferredInitCodeMirror = bind(this.deferredInitCodeMirror, this);
      this.initCodeMirror = bind(this.initCodeMirror, this);
      this.show = bind(this.show, this);
      this.hide = bind(this.hide, this);
      SqlBox.__super__.constructor.apply(this, arguments);
      App.Utils.requires(this, 'el', 'dbFunc');
      App.SqlBox.cachedPeriscopeSyntaxClass = {};
      if (!this.darkMode) {
        this.darkMode = false;
      }
      this.hasSelection = false;
      this.el.addClass("codemirror-wrapper");
      this.deferredInitCodeMirror();
    }

    SqlBox.prototype.hide = function() {
      return this.el.hide();
    };

    SqlBox.prototype.show = function() {
      this.el.show();
      return setTimeout(((function(_this) {
        return function() {
          return _this.setSql(_this.getSql());
        };
      })(this)), 0);
    };

    SqlBox.prototype.release = function() {
      var ref, ref1, ref2, ref3;
      SqlBox.__super__.release.apply(this, arguments);
      if ((ref = this.codeMirror) != null) {
        if ((ref1 = ref.state) != null) {
          if ((ref2 = ref1.completionActive) != null) {
            ref2.close();
          }
        }
      }
      if ((ref3 = this.tooltip) != null) {
        ref3.release();
      }
      return this.codeMirror = null;
    };

    SqlBox.prototype.initCodeMirror = function(value, placeholder, enabled) {
      var _enabled, callback, i, len, name, pendingCallback, ref;
      this.codeMirror = CodeMirror(this.el[0], {
        mode: this.dbHighlightMode(),
        lineWrapping: true,
        autofocus: false,
        value: value || "",
        placeholder: _.trim(placeholder),
        theme: (this.darkMode ? 'dark-theme' : ''),
        tabSize: 2,
        indentWithTabs: false,
        matchBrackets: true,
        extraKeys: {
          Esc: this.cmEsc,
          Tab: this.cmIndent,
          "Shift-Ctrl-L": this.reformatSql,
          "Shift-Cmd-L": this.reformatSql,
          "Shift-Tab": this.cmBackdent,
          "Cmd-/": this.cmToggleComment,
          "Ctrl-/": this.cmToggleComment
        }
      });
      App.AddSqlHintToCodeMirror.call(this.codeMirror, this.dbFunc);
      this.refreshElements();
      this.codeMirror.on('cursorActivity', this.cursorActivity);
      this.codeMirrorEl.on('keydown', this.checkModified);
      this.renderErrors();
      setTimeout(((function(_this) {
        return function() {
          return _this.setSql(_this.getSql());
        };
      })(this)), 0);
      _enabled = this.pendingEnabled || enabled;
      if (_enabled) {
        this.setEnabled(_enabled);
      }
      if (this.pendingSql != null) {
        this.setSql(this.pendingSql);
      }
      if (this.pendingCallbacks != null) {
        ref = this.pendingCallbacks;
        for (i = 0, len = ref.length; i < len; i++) {
          pendingCallback = ref[i];
          name = pendingCallback[0];
          callback = pendingCallback[1];
          this.codeMirror.on(name, callback);
        }
      }
      delete this.pendingSql;
      delete this.pendingEnabled;
      delete this.pendingCallbacks;
      requestAnimationFrame((function(_this) {
        return function() {
          var ref1;
          return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.sqlboxLoaded(_this.setSql) : void 0;
        };
      })(this));
      return this.codeMirrorEl.on('click', (function(_this) {
        return function() {
          var ref1;
          return (ref1 = AppRedesign.current().tutorial()) != null ? ref1.codeMirrorClicked() : void 0;
        };
      })(this));
    };

    SqlBox.prototype.deferredInitCodeMirror = function() {
      if (typeof CodeMirror !== "undefined" && CodeMirror !== null) {
        return this.initCodeMirror(this.initialValue, this.placeHolder, this.enabled);
      } else {
        return this.timeoutLoopCodeMirror();
      }
    };

    SqlBox.prototype.timeoutLoopCodeMirror = function() {
      if (typeof CodeMirror !== "undefined" && CodeMirror !== null) {
        if (!this.codeMirror) {
          return this.initCodeMirror(this.initialValue, this.placeHolder, this.enabled);
        }
      } else {
        return setTimeout(((function(_this) {
          return function() {
            return _this.timeoutLoopCodeMirror();
          };
        })(this)), 10);
      }
    };

    SqlBox.prototype.cmEsc = function(cm) {
      return App.hotkeys.trigger(App.HotkeyManager.ESC, null);
    };

    SqlBox.prototype.cmIndent = function(cm) {
      if (cm.somethingSelected()) {
        return cm.indentSelection("add");
      } else {
        return cm.execCommand('insertSoftTab');
      }
    };

    SqlBox.prototype.cmBackdent = function(cm) {
      return cm.indentSelection("subtract");
    };

    SqlBox.prototype.cmToggleComment = function(cm) {
      return cm.execCommand('toggleComment');
    };

    SqlBox.prototype.getSql = function(preferSelected, clean) {
      var allSql, selectedSql;
      if (preferSelected == null) {
        preferSelected = false;
      }
      if (clean == null) {
        clean = true;
      }
      if ((this.pendingSql != null) && (this.codeMirror == null)) {
        return this.pendingSql;
      }
      if (this.codeMirror == null) {
        return '';
      }
      if (preferSelected) {
        selectedSql = this.codeMirror.getSelection();
        if (clean) {
          selectedSql = SqlBox.cleanSQL(selectedSql);
        }
        if (selectedSql && selectedSql.length > 0) {
          return selectedSql;
        }
      }
      allSql = this.codeMirror.getValue();
      if (clean) {
        allSql = SqlBox.cleanSQL(allSql);
      }
      return allSql;
    };

    SqlBox.prototype.setSql = function(sql, preferSelected) {
      var selectedSql, trimmedSql;
      if (preferSelected == null) {
        preferSelected = false;
      }
      if (this.codeMirror == null) {
        this.pendingSql = sql;
        return;
      }
      trimmedSql = sql.trim();
      selectedSql = this.codeMirror.getSelection();
      if (preferSelected && selectedSql && selectedSql.length > 0) {
        this.codeMirror.replaceSelection(trimmedSql);
      } else {
        this.codeMirror.setValue(trimmedSql);
      }
      return this.renderErrors();
    };

    SqlBox.prototype.insertAtCursor = function(text) {
      var cursorPosition;
      if (!((this.codeMirror != null) && (text != null ? text.length : void 0) > 0)) {
        return;
      }
      cursorPosition = this.codeMirror.getDoc().getCursor('head');
      this.codeMirror.getDoc().replaceRange(text, cursorPosition);
      if (!this.codeMirror.hasFocus()) {
        return this.codeMirror.focus();
      }
    };

    SqlBox.cleanSQL = function(sql) {
      var s;
      if (!((sql != null) && (sql.trim != null) && sql.length > 0)) {
        return sql;
      }
      s = sql.trim();
      while (s[s.length - 1] === ';') {
        s = s.slice(0, s.length - 1).trim();
      }
      return s;
    };

    SqlBox.prototype.checkModified = function() {
      if (this.getSql() !== (this.initialValue || "")) {
        this.trigger('first-sql-change');
        return this.codeMirrorEl.off('keydown', this.checkModified);
      }
    };

    SqlBox.prototype.setPlaceholder = function(placeholder) {
      var ref;
      return (ref = this.codeMirror) != null ? ref.setOption('placeholder', placeholder) : void 0;
    };

    SqlBox.prototype.setEnabled = function(enabled1) {
      this.enabled = enabled1;
      if (this.codeMirror == null) {
        this.pendingEnabled = this.enabled;
        return;
      }
      if (this.enabled) {
        this.codeMirror.setOption('readOnly', false);
        return this.codeMirrorEl.removeClass('disabled');
      } else {
        this.codeMirror.setOption('readOnly', "nocursor");
        return this.codeMirrorEl.addClass('disabled');
      }
    };

    SqlBox.prototype.cursorActivity = function() {
      var hasSelection;
      if (this.codeMirror == null) {
        return;
      }
      hasSelection = !!this.codeMirror.getSelection();
      if (this.hasSelection !== hasSelection) {
        this.trigger('selection-changed', hasSelection);
        return this.hasSelection = hasSelection;
      }
    };

    SqlBox.prototype.updateErrors = function(generatedSql, msg, pos, ranOnRefshift) {
      if (ranOnRefshift == null) {
        ranOnRefshift = false;
      }
      if (msg != null) {
        this.errorInfo = {
          sql: generatedSql,
          msg: msg,
          pos: pos,
          ranOnRefshift: ranOnRefshift
        };
      } else {
        this.errorInfo = null;
      }
      return this.renderErrors();
    };

    SqlBox.prototype.renderErrors = function() {
      var endIndex, endPos, i, len, msg, pos, posList, ranOnRefshift, results, selectionOffset, spacePos, sql, startIndex, startPos, stateObj, userSql;
      if (this.codeMirror == null) {
        return;
      }
      this.clearErrors();
      if (this.errorInfo == null) {
        return;
      }
      msg = this.errorInfo['msg'];
      pos = this.errorInfo['pos'];
      sql = this.errorInfo['sql'];
      ranOnRefshift = this.errorInfo['ranOnRefshift'];
      userSql = this.getSql();
      selectionOffset = 0;
      if (this.hasSelection) {
        selectionOffset = userSql.indexOf(this.codeMirror.getSelection());
      }
      if (pos == null) {
        return;
      }
      results = [];
      for (i = 0, len = pos.length; i < len; i++) {
        posList = pos[i];
        startIndex = posList[0] + selectionOffset;
        endIndex = posList[1] + selectionOffset;
        spacePos = /[\s'"`]/.exec(userSql.slice(endIndex));
        if (spacePos) {
          endIndex = endIndex + spacePos.index;
        }
        startPos = this.codeMirror.posFromIndex(startIndex);
        endPos = this.codeMirror.posFromIndex(endIndex);
        stateObj = {
          className: 'cm-error',
          startStyle: 'cm-error-icon',
          clearOnEnter: true,
          title: "Error"
        };
        results.push(this.codeMirror.markText(startPos, endPos, stateObj));
      }
      return results;
    };

    SqlBox.prototype.userSqlMatchesGeneratedSql = function(userSql, generatedSql, startPos, endPos) {
      if (!((userSql != null) && (generatedSql != null) && (startPos != null) && (endPos != null))) {
        return false;
      }
      return userSql.substring(startPos, endPos) === generatedSql.substring(startPos, endPos);
    };

    SqlBox.prototype.clearErrors = function() {
      var i, len, mark, ref, results;
      if (this.codeMirror == null) {
        return;
      }
      ref = this.codeMirror.getAllMarks();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        mark = ref[i];
        results.push(mark.clear());
      }
      return results;
    };

    SqlBox.prototype.selectCodeMirror = function(evt) {
      if (this.codeMirror == null) {
        return;
      }
      if (evt != null) {
        evt.preventDefault();
      }
      if (this.codeMirror.hasFocus()) {
        return;
      }
      this.codeMirror.focus();
      return this.codeMirror.getInputField().focus();
    };

    SqlBox.prototype.codeMirrorBlurred = function() {
      var ref, ref1;
      if (((ref = this.codeMirror) != null ? (ref1 = ref.state) != null ? ref1.completionActive : void 0 : void 0) != null) {

      }
    };

    SqlBox.prototype.codeMirrorKeydown = function(evt) {
      if (evt.which === AppRedesign.KEYS.ESCAPE) {
        evt.stopPropagation();
      }
      if (this.errorInfo) {
        this.clearErrors();
      }
      this.triggerSubmittedIfMetaEnter(evt);
      this.trigger('sql-keydown');
      return this.hideTooltip(evt, 250);
    };

    SqlBox.prototype.triggerSubmittedIfMetaEnter = function(event) {
      if (event.which === AppRedesign.KEYS.ENTER && (event.ctrlKey || event.metaKey)) {
        jQuery(event.target).trigger('submitted');
        return event.preventDefault();
      }
    };

    SqlBox.prototype.codeMirrorSubmit = function() {
      return this.trigger('sql-updated');
    };

    SqlBox.prototype.setCodeMirrorEvent = function(name, callback) {
      if (this.codeMirror != null) {
        return this.codeMirror.on(name, callback);
      } else {
        if (this.pendingCallbacks == null) {
          this.pendingCallbacks = [];
        }
        return this.pendingCallbacks.push([name, callback]);
      }
    };

    SqlBox.prototype.mouseEnterKw = function(evt) {
      var jqTarget, name, obj, objClass, panelClass, side, snipName, targetText, text;
      targetText = $(evt.target).text().replace('[', '').replace(']', '');
      snipName = "[" + (App.SqlSnippet.extractNameFromCall(targetText)) + "]";
      if (this.tooltip != null) {
        if (snipName = this.tooltipTokenName) {
          this.hiding = false;
          return;
        }
      }
      jqTarget = $(evt.target);
      if (jqTarget.hasClass('cm-sql-view')) {
        panelClass = 'sql-view';
        objClass = App.SqlView;
      } else if (jqTarget.hasClass('cm-csv-view')) {
        panelClass = 'csv-view';
        objClass = App.CsvView;
      } else if (jqTarget.hasClass('cm-snippet')) {
        panelClass = 'snippets';
        objClass = App.SqlSnippet;
      }
      obj = objClass.matches(snipName);
      if (!obj) {
        return;
      }
      if (objClass === App.SqlSnippet) {
        name = App.Utils.sanitizeHtml(obj.displayName());
      } else {
        name = App.Utils.sanitizeHtml(obj.name);
      }
      if (obj.sql != null) {
        text = App.Utils.sanitizeHtml(obj.sql);
      }
      if (obj.filename != null) {
        text = App.Utils.sanitizeHtml('Uploaded CSV: ' + obj.filename);
      }
      this.tooltip = new App.TooltipPanel({
        target: evt.target,
        el: this.el.closest('.editron-mk3').append("<div class=tooltip-panel></div>").find(".tooltip-panel")
      });
      this.tooltipTokenName = snipName;
      App.Utils.logFeature(panelClass + "-tooltip-shown");
      side = this.showTooltip(App.TooltipPanel.BOTTOM, name, text, panelClass);
      if (this.tooltip.panel.height() > App.SqlBox.MAX_HEIGHT_FOR_TOOLTIP_ABOVE_SNIPPET_PX) {
        side = this.showTooltip(App.TooltipPanel.TOP, name, text, panelClass);
      }
      return this.tooltip.pointAtEl(side, $(evt.target), .17, .33, .20);
    };

    SqlBox.prototype.showTooltip = function(side, name, text, panelClass) {
      var width;
      width = App.SqlBox.getTooltipHeightFromSnippet(text != null ? text.length : 0);
      this.tooltip.addPanel(side, width, .17, name, text);
      this.tooltip.el.find('.panel').addClass(panelClass).addClass('codetip');
      return side;
    };

    SqlBox.prototype.hideTooltip = function(evt, fadeTime) {
      if (fadeTime == null) {
        fadeTime = 50;
      }
      this.hiding = true;
      return setTimeout(this.maybeFade, fadeTime);
    };

    SqlBox.prototype.maybeFade = function() {
      if (!(this.hiding && (this.tooltip != null))) {
        return;
      }
      this.tooltip.closeAndRelease();
      this.tooltip = null;
      return this.tooltipTokenName = "";
    };

    SqlBox.getTooltipHeightFromSnippet = function(snipLen) {
      switch (false) {
        case !(snipLen > 150):
          return '600px';
        case !(snipLen > 100):
          return '500px';
        case !(snipLen > 50):
          return '400px';
        default:
          return '200px';
      }
    };

    SqlBox.prototype.dbHighlightMode = function() {
      var database_type, mode;
      database_type = 'postgres';
      if ((this.dbFunc != null) && (this.dbFunc() != null)) {
        database_type = this.dbFunc().database_type;
      }
      mode = 'text/x-mysql';
      if (database_type === 'redshift' || database_type === 'postgres' || database_type === 'vertica' || database_type === 'oracle' || database_type === 'snowflake') {
        mode = 'text/x-plsql';
      }
      return mode;
    };

    SqlBox.prototype.toggleGrey = function(useGray) {
      return this.codeMirrorEl.toggleClass("greyscale", useGray);
    };

    SqlBox.prototype.reformatSql = function() {
      var sql;
      if (this.formatRequestPending) {
        return;
      }
      this.formatRequestPending = true;
      sql = this.getSql(true);
      this.toggleGrey(true);
      jQuery.ajax({
        method: 'POST',
        url: '/sql_formatting/format',
        data: {
          sql: sql,
          client_site_id: App.Site.first().id
        }
      }).done(this.handleFormatResponse).always(this.finishFormatResponse);
      App.Utils.logFeature("format-sql");
      return this.codeMirror.focus();
    };

    SqlBox.prototype.handleFormatResponse = function(data) {
      this.setSql(data.formatted_sql, true);
      return this.checkModified();
    };

    SqlBox.prototype.finishFormatResponse = function() {
      this.formatRequestPending = false;
      return this.toggleGrey(false);
    };

    SqlBox.getPeriscopeSyntaxClass = function(matchStr, hookConfig) {
      var base;
      return (base = this.cachedPeriscopeSyntaxClass)[matchStr] || (base[matchStr] = this._getPeriscopeSyntaxClass(matchStr, hookConfig));
    };

    SqlBox._getPeriscopeSyntaxClass = function(matchStr, hookConfig) {
      var ref;
      matchStr = "[" + matchStr + "]";
      switch (false) {
        case !((hookConfig != null ? (ref = hookConfig.extraDimensions) != null ? ref.indexOf(matchStr.toLowerCase()) : void 0 : void 0) > -1):
          return 'dimension';
        case !App.CustomDimension.matches(matchStr):
          return 'dimension';
        case !App.CustomDimension.matchesColumnInsertion(matchStr):
          return 'dimension';
        case !App.CustomDimension.matchesLiteralInsertion(matchStr):
          return 'dimension';
        case !App.CustomDimension.matchesCustomDaterange(matchStr):
          return 'dimension';
        case !App.SqlSnippet.matches(matchStr):
          return 'snippet';
        case !App.SqlView.matches(matchStr):
          return 'sql-view';
        case !App.CsvView.matches(matchStr):
          return 'csv-view';
        case !App.Utils.matchesFormatter(matchStr):
          return 'formatter';
        case !App.Database.matchesMagicJoin(matchStr):
          return 'magic-join';
        case matchStr !== '[aggregation]':
          return 'aggregation';
        case !App.Utils.matchesDaterange(matchStr):
          return 'daterange';
        case !App.Database.matchesSampleFactor(matchStr):
          return 'sampler';
        case !App.SqlSnippet.matchesCurrentParameters(matchStr):
          return 'param';
        default:
          return null;
      }
    };

    return SqlBox;

  })(Spine.Controller);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.SuperTooltipController = (function(superClass) {
    extend(SuperTooltipController, superClass);

    SuperTooltipController.prototype.className = 'super-tooltip';

    SuperTooltipController.prototype.elements = {
      '.name': 'nameEl',
      '.description': 'descriptionEl',
      '.tags': 'tagsEl',
      '.tooltip-body': 'bodyEl',
      '.tooltip-options': 'optionsEl',
      '.left-arrow': 'leftArrowEl',
      '.view-preview': 'viewEl',
      '.properties': 'propertiesEl'
    };

    SuperTooltipController.prototype.events = {
      'mouseenter': 'mouseEnterMe',
      'mouseleave': 'mouseLeaveMe',
      'click': 'clickMe',
      'click .option': 'clickTooltipOption',
      'mousedown': 'mousedownMe'
    };

    SuperTooltipController.SHOW_DELAY_MS = 500;

    SuperTooltipController.HIDE_DELAY_MS = 250;

    SuperTooltipController.PANEL_OFFSET_TOP = -22;

    SuperTooltipController.PANEL_OFFSET_LEFT = -8;

    function SuperTooltipController() {
      this.renderSqlAlert = bind(this.renderSqlAlert, this);
      this.renderSqlSnippet = bind(this.renderSqlSnippet, this);
      this.renderCsvView = bind(this.renderCsvView, this);
      this.renderView = bind(this.renderView, this);
      this.renderDashboard = bind(this.renderDashboard, this);
      this.bodyClick = bind(this.bodyClick, this);
      this.mousedownBody = bind(this.mousedownBody, this);
      this.mousedownMe = bind(this.mousedownMe, this);
      this.clickTooltipOption = bind(this.clickTooltipOption, this);
      SuperTooltipController.__super__.constructor.apply(this, arguments);
      this.isVisible = false;
      if (this.offsetLeft == null) {
        this.offsetLeft = this.constructor.PANEL_OFFSET_LEFT;
      }
      if (this.offsetTop == null) {
        this.offsetTop = this.constructor.PANEL_OFFSET_TOP;
      }
      this.el.hide();
      $('#body .app-frame').append(this.el);
      $('#body').on('click', this.bodyClick);
      $('#body').on('mousedown', this.mousedownBody);
      this.html(this.view('redesign/tooltip/super_tooltip')());
    }

    SuperTooltipController.prototype.release = function() {
      $('#body').off('click', this.bodyClick);
      $('#body').off('mousedown', this.mousedownBody);
      this.maybeUnbindLastUpdateRenderValuesCallback();
      return SuperTooltipController.__super__.release.apply(this, arguments);
    };

    SuperTooltipController.prototype.visible = function() {
      return Boolean(this.isVisible);
    };

    SuperTooltipController.prototype.show = function(item, target) {
      var renderMethod;
      this.maybeUnbindLastUpdateRenderValuesCallback();
      this.isVisible = true;
      renderMethod = {
        CsvView: this.renderCsvView,
        Dashboard: this.renderDashboard,
        SqlView: this.renderView,
        SqlSnippet: this.renderSqlSnippet,
        SqlAlert: this.renderSqlAlert
      }[item.constructor.className];
      if (renderMethod) {
        this.lastItem = item;
        this.renderValues = this.getRenderValues(renderMethod);
        this.renderValues();
        this.ensureTooltipRerendersOnItemUpdate();
        if (!this.reposition(target)) {
          return;
        }
        setTimeout(((function(_this) {
          return function() {
            return _this.reposition(target);
          };
        })(this)), 1);
        this.el.show();
      } else {
        this.el.hide();
      }
      return this.hidePending = false;
    };

    SuperTooltipController.prototype.maybeUnbindLastUpdateRenderValuesCallback = function() {
      var ref;
      if ((ref = this.lastItem) != null) {
        ref.unbind('update', this.renderValues);
      }
      delete this.lastItem;
      return delete this.renderValues;
    };

    SuperTooltipController.prototype.getRenderValues = function(renderMethod) {
      return (function(_this) {
        return function() {
          _this.nameEl.text(_this.lastItem.getName());
          _this.setDescription(_this.lastItem.description);
          return renderMethod(_this.lastItem);
        };
      })(this);
    };

    SuperTooltipController.prototype.ensureTooltipRerendersOnItemUpdate = function() {
      return this.lastItem.bind('update', this.renderValues);
    };

    SuperTooltipController.prototype.hide = function() {
      if (this.mouseInMe) {
        this.hidePending = true;
        return;
      }
      this.isVisible = false;
      this.el.hide();
      return this.hidePending = false;
    };

    SuperTooltipController.prototype.mouseEnterMe = function() {
      return this.mouseInMe = true;
    };

    SuperTooltipController.prototype.mouseLeaveMe = function() {
      var ref;
      if ((ref = this.codeMirror) != null ? ref.somethingSelected() : void 0) {
        return;
      }
      this.mouseInMe = false;
      if (this.hidePending) {
        this.hide();
      }
      return true;
    };

    SuperTooltipController.prototype.clickMe = function(evt) {
      return evt.stopPropagation();
    };

    SuperTooltipController.prototype.clickTooltipOption = function(evt) {
      evt.stopPropagation();
      if (evt.target.className.includes("code")) {
        return this.renderCode(this.lastItem.code, this.lastItem.code_language);
      } else {
        return this.renderSql(this.lastItem.sql);
      }
    };

    SuperTooltipController.prototype.mousedownMe = function(evt) {
      this.mousedownStartInternal = true;
      return evt.stopPropagation();
    };

    SuperTooltipController.prototype.mousedownBody = function() {
      this.mousedownStartInternal = false;
      return true;
    };

    SuperTooltipController.prototype.bodyClick = function(evt) {
      if (!(this.isVisible && !this.mousedownStartInternal)) {
        return;
      }
      this.mouseInMe = false;
      this.hide();
      return true;
    };

    SuperTooltipController.prototype.reposition = function(target) {
      var arrowBottomBuffer, arrowTop, desiredTop, panelHeight, screenBottomBuffer, screenOverflow, targetOffset, topPullBack;
      targetOffset = target.offset();
      if (targetOffset.top === 0 && targetOffset.left === 0) {
        return false;
      }
      panelHeight = this.el.outerHeight();
      topPullBack = 0;
      desiredTop = targetOffset.top + this.offsetTop + target.height() / 2;
      screenOverflow = $(window).height() - desiredTop - panelHeight;
      screenBottomBuffer = 10;
      arrowBottomBuffer = 30;
      if (screenOverflow < 0) {
        topPullBack = screenOverflow - screenBottomBuffer;
        arrowTop = Math.min(-topPullBack + screenBottomBuffer, panelHeight - arrowBottomBuffer);
        this.leftArrowEl.css({
          top: arrowTop
        });
      } else {
        this.leftArrowEl.css({
          top: ''
        });
      }
      return this.el.css({
        top: desiredTop + topPullBack,
        left: targetOffset.left + target.outerWidth() + this.offsetLeft
      });
    };

    SuperTooltipController.prototype.renderDashboard = function(item) {
      this.renderTags(item.tags());
      this.bodyEl.show();
      this.viewEl.hide();
      this.optionsEl.hide();
      return this.renderProperties([
        {
          name: 'Owner',
          value: this.getUserName(item.user_id) || 'Unknown'
        }, {
          name: 'Email Reports',
          value: item.numEmailReports()
        }, {
          name: 'Shared Dashboards',
          value: item.num_shared_dashboards || 0
        }
      ]);
    };

    SuperTooltipController.prototype.renderView = function(item) {
      var code;
      this.bodyEl.show();
      this.propertiesEl.hide();
      this.renderTags(item.tag_names);
      code = AppRedesign.codeInViewsEnabled() && (item.code != null) ? item.code : void 0;
      this.el.find('.code').toggleClass('hidden-option', code == null);
      if (code != null) {
        this.el.find('.code').text(item.code_language.toUpperCase());
      }
      this.optionsEl.toggle(code != null);
      return this.initCodeMirror(item.sql, code);
    };

    SuperTooltipController.prototype.renderCsvView = function(item) {
      this.tagsEl.hide();
      this.viewEl.hide();
      this.optionsEl.hide();
      this.bodyEl.show();
      return this.renderProperties([
        {
          name: 'Owner',
          value: this.getUserName(item.user_id) || 'Unknown'
        }, {
          name: 'Filename',
          value: item.filename
        }, {
          name: 'Rows',
          value: item.getRowCount()
        }, {
          name: 'Columns',
          value: item.getColumnCount()
        }
      ]);
    };

    SuperTooltipController.prototype.renderSqlSnippet = function(item) {
      var code;
      this.bodyEl.show();
      this.propertiesEl.hide();
      this.renderTags(item.tag_names);
      code = AppRedesign.codeInViewsEnabled() && (item.code != null) ? item.code : void 0;
      this.el.find('.code').toggleClass('hidden-option', code == null);
      if (code != null) {
        this.el.find('.code').text(item.code_language.toUpperCase());
      }
      this.optionsEl.toggle(code != null);
      return this.initCodeMirror(item.sql, code);
    };

    SuperTooltipController.prototype.renderSqlAlert = function(item) {
      var val;
      this.tagsEl.hide();
      this.viewEl.hide();
      this.optionsEl.hide();
      this.bodyEl.show();
      val = item.error_message ? 'Error' : item.last_value;
      return this.renderProperties([
        {
          name: 'Owner',
          value: this.getUserName(item.user_id) || 'Unknown'
        }, {
          name: 'Last Value',
          value: val,
          statusClass: item.status()
        }, {
          name: 'Condition',
          value: item.conditionAsString()
        }
      ]);
    };

    SuperTooltipController.prototype.getUserName = function(user_id) {
      var u;
      u = App.User.exists(user_id);
      if (u) {
        return u.displayName();
      }
      return null;
    };

    SuperTooltipController.prototype.setDescription = function(text) {
      if ((text != null ? text.trim().length : void 0) > 0) {
        return this.descriptionEl.show().text(text);
      } else {
        return this.descriptionEl.hide();
      }
    };

    SuperTooltipController.prototype.renderTags = function(tagNameList) {
      var i, len, t, tag;
      if (tagNameList.length === 0) {
        this.tagsEl.hide();
        return;
      }
      this.tagsEl.html('');
      for (i = 0, len = tagNameList.length; i < len; i++) {
        t = tagNameList[i];
        tag = $('<div class="tag"></div>');
        tag.text("#" + t);
        this.tagsEl.append(tag);
      }
      return this.tagsEl.show();
    };

    SuperTooltipController.prototype.initCodeMirror = function(sql, code) {
      if (typeof CodeMirror === "undefined" || CodeMirror === null) {
        return;
      }
      if (this.codeMirror == null) {
        this.codeMirror = CodeMirror(this.viewEl[0], {
          autofocus: false,
          indentWithTabs: false,
          lineWrapping: true,
          mode: 'text/x-plsql',
          readOnly: true,
          tabSize: 2,
          theme: 'redesign-sql-box',
          value: ""
        });
      }
      return setTimeout(((function(_this) {
        return function() {
          var height, ref;
          _this.codeMirror.setSize(null, '0px');
          _this.codeMirror.setValue(code != null ? code : "");
          height = (ref = _this.codeMirror.getScrollInfo().height) != null ? ref : 0;
          _this.codeMirror.setValue(sql);
          height = _this.calcViewHeight(_this.codeMirror.getScrollInfo().height, height);
          _this.codeMirror.setSize(null, height + 'px');
          _this.codeMirror.setOption("mode", 'text/x-plsql');
          _this.codeMirror.refresh();
          return _this.renderSql(sql);
        };
      })(this)), 0);
    };

    SuperTooltipController.prototype.calcViewHeight = function(heightOne, heightTwo) {
      return Math.max(heightOne, heightTwo);
    };

    SuperTooltipController.prototype.renderSql = function(sql) {
      this.viewEl.show();
      this.el.find('.sql').toggleClass('selected-option', true);
      this.el.find('.code').toggleClass('selected-option', false);
      if (sql !== this.codeMirror.getValue()) {
        this.codeMirror.setOption("mode", 'text/x-plsql');
        this.codeMirror.setValue(sql);
        return this.codeMirror.refresh();
      }
    };

    SuperTooltipController.prototype.renderCode = function(code, language) {
      var mode;
      this.viewEl.show();
      this.el.find('.sql').toggleClass('selected-option', false);
      this.el.find('.code').toggleClass('selected-option', true);
      mode = (function() {
        switch (false) {
          case language.toLowerCase() !== 'r':
            return 'text/x-rsrc';
          case language.toLowerCase() !== 'python':
            return 'text/x-python';
          default:
            return "text/plain";
        }
      })();
      if (code !== this.codeMirror.getValue()) {
        this.codeMirror.setOption("mode", mode);
        this.codeMirror.setValue(code);
        return this.codeMirror.refresh();
      }
    };

    SuperTooltipController.prototype.renderProperties = function(propList) {
      this.propertiesEl.show();
      return this.propertiesEl.html(this.view('redesign/tooltip/super_tooltip_props')({
        propList: propList
      }));
    };

    return SuperTooltipController;

  })(Spine.Controller);

}).call(this);
(function() {
  App.ViewUtils = (function() {
    function ViewUtils() {}

    ViewUtils.fetchWidgetViewCount = function(view) {
      var routeName;
      if (App.Utils.isClientId(view.id)) {
        return {};
      }
      if (view.widgetViewCount) {
        return view.widgetViewCount;
      }
      routeName = view.constructor.routeName;
      view.widgetViewCount = {};
      return jQuery.ajax({
        url: "/" + routeName + "/" + view.id + "/usage",
        type: 'GET',
        data: {
          client_site_id: App.Site.first().id
        }
      }).done((function(_this) {
        return function(res) {
          return view.widgetViewCount = res;
        };
      })(this));
    };

    ViewUtils.statusColorClass = function(view) {
      if (view.cacheDisabled()) {
        return "";
      } else if (view.isFailed()) {
        return "failed";
      } else if (view.isErring()) {
        return "erring";
      } else if (view.isSuccessful()) {
        return "successful";
      } else {
        return "pending";
      }
    };

    ViewUtils.metadataWithCounts = function(view) {
      var metadata;
      metadata = view.getMetadata();
      jQuery.extend(metadata, view.widgetViewCount);
      if (metadata.widgets_count == null) {
        metadata.widgets_count = 0;
      }
      if (metadata.sql_views_count == null) {
        metadata.sql_views_count = 0;
      }
      metadata.counts = (metadata.sql_views_count + " " + (App.Utils.pluralizeIf('view', metadata.sql_views_count !== 1)) + " and ") + (metadata.widgets_count + " " + (App.Utils.pluralizeIf('chart', metadata.widgets_count !== 1)));
      metadata.materializeState = this.statusColorClass(view);
      return metadata;
    };

    return ViewUtils;

  })();

}).call(this);
(function() {
  App.WalkMe = (function() {
    function WalkMe() {
      this.initialized = false;
    }

    WalkMe.prototype.init = function() {
      if (this.initialized) {
        return false;
      }
      this.setWindowPeriscopeUser();
      this.addToUiQueue();
      return this.initialized = true;
    };

    WalkMe.prototype.setWindowPeriscopeUser = function() {
      var ref, ref1;
      return window.periscopeuser = {
        isAdmin: (ref = App.User.currentUser()) != null ? ref.isAdmin() : void 0,
        tutorialSegment: App.Site.first().tutorial_segment_id,
        useCase: (ref1 = App.User.currentUser()) != null ? ref1.use_case : void 0
      };
    };

    WalkMe.prototype.addToUiQueue = function() {
      return AppRedesign.current().uiQueue.add(((function(_this) {
        return function() {
          return _this.appendWalkMeToPage();
        };
      })(this)), 'show-tutorial', App.UiQueue.PRIORITY_WALKME);
    };

    WalkMe.prototype.appendWalkMeToPage = function() {
      return $(document.body).append(JST["app/views/walkme"]());
    };

    WalkMe.prototype.shutdown = function() {
      if (!this.initialized) {
        return;
      }
      $('#walkme-script').remove();
      return this.initialized = false;
    };

    return WalkMe;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.Watchdog = (function() {
    function Watchdog(intervalMs, name, cb) {
      this.intervalMs = intervalMs;
      this.name = name;
      this.cb = cb;
      this.handleTimeout = bind(this.handleTimeout, this);
      this.constructorStack = printStackTrace();
    }

    Watchdog.prototype.heartbeat = function() {
      if (this.timeout != null) {
        clearTimeout(this.timeout);
      }
      this.lastOk = Date.now();
      return this.timeout = setTimeout(this.handleTimeout, this.intervalMs);
    };

    Watchdog.prototype.start = function() {
      this.heartbeat();
      return this;
    };

    Watchdog.prototype.stop = function() {
      clearTimeout(this.timeout);
      this.timeout = null;
      return this.lastOk = null;
    };

    Watchdog.prototype.release = function() {
      return this.stop();
    };

    Watchdog.prototype.stack = function() {
      return this.constructorStack;
    };

    Watchdog.prototype.handleTimeout = function() {
      if (this.herokuReleaseVersion === 'Development') {
        console.log("Heartbeat for " + this.name + " failed to arrive after " + (Date.now() - this.lastOk) + " seconds");
      }
      if (this.cb != null) {
        if (this.cb(this) !== false) {
          return this.start();
        }
      } else {
        return this.start();
      }
    };

    return Watchdog;

  })();

}).call(this);
(function() {
  App.WidgetHistorian = (function() {
    function WidgetHistorian() {}

    WidgetHistorian.FIELDS_TO_CHECK = [
      {
        attr: 'title',
        name: 'Title'
      }, {
        attr: 'chart_type',
        name: 'Chart Type'
      }, {
        attr: 'database_id',
        name: 'Database'
      }, {
        attr: 'sql',
        name: 'SQL'
      }, {
        attr: 'sql_limit',
        name: 'Query Limit'
      }, {
        attr: 'chart_description',
        name: 'Description'
      }, {
        attr: 'twiddles',
        name: 'Settings',
        dataType: 'json'
      }, {
        attr: 'default_color_theme_id',
        name: 'Settings'
      }, {
        attr: 'drag_drop_config',
        name: 'Settings',
        dataType: 'json'
      }, {
        attr: 'use_periscope_theme',
        name: 'Settings'
      }
    ];

    WidgetHistorian.NO_RESULTS = "Save charts to create version history.";

    WidgetHistorian.getHistory = function(widgetId) {
      return this.makeHistory(this.getArchivedWidgets(widgetId));
    };

    WidgetHistorian.get = function(widgetId) {
      var widget;
      widget = App.Widget.exists(widgetId);
      if (widget) {
        return widget;
      }
    };

    WidgetHistorian.modelName = function() {
      return "widget";
    };

    WidgetHistorian.fields_to_check_for_code = function(fields) {
      return fields.concat([
        {
          attr: 'code',
          name: 'Code'
        }, {
          attr: 'code_language',
          name: 'Code Language'
        }, {
          attr: 'code_version',
          name: 'Code Version'
        }
      ]);
    };

    WidgetHistorian.fields_to_check_for_dragdrop = function(fields) {
      var index;
      index = fields.map(function(item) {
        return item.attr;
      }).indexOf('sql');
      if (index >= 0) {
        fields[index] = {
          attr: 'sql',
          name: 'Chart Fields'
        };
      }
      return fields;
    };

    WidgetHistorian.fields_to_check = function() {
      var fields;
      fields = this.FIELDS_TO_CHECK;
      if (AppRedesign.current().deepAnalysisEnabled) {
        fields = this.fields_to_check_for_code(fields);
      }
      if (AppRedesign.dragDropEnabled()) {
        fields = this.fields_to_check_for_dragdrop(fields);
      }
      return fields;
    };

    WidgetHistorian.getArchivedWidgets = function(widgetId) {
      var aws, sortedAws;
      aws = App.ArchivedWidget.allForWidgetId(widgetId);
      if (!(aws && aws.length > 0)) {
        return [];
      }
      sortedAws = aws.sort(function(a, b) {
        return a.created_at.localeCompare(b.created_at);
      });
      return sortedAws;
    };

    WidgetHistorian.makeHistory = function(sortedArchivedWidgets) {
      var aw, diffItem, i, items, j, len;
      items = [];
      for (i = j = 0, len = sortedArchivedWidgets.length; j < len; i = ++j) {
        aw = sortedArchivedWidgets[i];
        if (i === 0) {
          items.push(this.makeHistoryItem(aw, App.HistorianHelper.makeCreatedMessage(aw.user_name)));
        } else {
          diffItem = this.makeDiffItem(aw, sortedArchivedWidgets[i - 1]);
          if (diffItem != null) {
            items.push(diffItem);
          }
        }
      }
      return items.reverse();
    };

    WidgetHistorian.makeHistoryItem = function(awItem, message) {
      return {
        archivedId: awItem.id,
        message: message,
        date: awItem.created_at
      };
    };

    WidgetHistorian.makeDiffItem = function(awChange, awBase) {
      var changes, field, j, len, ref;
      changes = [];
      ref = this.fields_to_check();
      for (j = 0, len = ref.length; j < len; j++) {
        field = ref[j];
        if (this.fieldIsDifferent(awBase, awChange, field)) {
          changes.push(field.name);
        }
      }
      if (changes.length > 0) {
        changes = _.uniq(changes);
        changes[0] = 'updated ' + changes[0];
        return this.makeHistoryItem(awChange, App.HistorianHelper.makeUpdatedMessage(awChange.user_name, changes));
      }
      return null;
    };

    WidgetHistorian.fieldIsDifferent = function(awChange, awBase, field) {
      var bAttr, cAttr, ref, ref1;
      cAttr = (ref = awChange.widget_properties) != null ? ref[field.attr] : void 0;
      bAttr = (ref1 = awBase.widget_properties) != null ? ref1[field.attr] : void 0;
      return App.HistorianHelper.fieldIsDifferent(cAttr, bAttr, field);
    };

    return WidgetHistorian;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.WixLiveChat = (function() {
    function WixLiveChat() {
      this.update = bind(this.update, this);
      this.init = bind(this.init, this);
      this.initialized = false;
    }

    WixLiveChat.prototype.init = function() {
      if (this.initialized) {
        return false;
      }
      if (!this.featureEnabled()) {
        return false;
      }
      this.initialized = true;
      this.site = App.Site.first();
      this.appendToPage();
      return true;
    };

    WixLiveChat.prototype.featureEnabled = function() {
      return !Features.enabled('salesforce_chat_feature_flag_enabled');
    };

    WixLiveChat.prototype.appendToPage = function() {
      return jQuery(document.body).append(JST['app/views/wix_live_chat']({
        addAuth: this.addAuth,
        company: this.site.host,
        onWidgetOpened: this.onWidgetOpened,
        onChatStarted: this.onChatStarted,
        embedJsUrl: AppRedesign.current().state.WixChatEmbedUrl
      }));
    };

    WixLiveChat.prototype.addAuth = function() {
      return jQuery.when(jQuery.get('/api/wix/request_token', {
        site_id: App.Site.first().id
      }));
    };

    WixLiveChat.prototype.onWidgetOpened = function() {
      return jQuery.ajax({
        url: "/wix/users/" + (App.User.currentUser().id),
        type: 'PUT',
        data: {
          client_site_id: App.Site.first().id,
          updates: {
            custom_field: true
          }
        },
        dataType: 'json'
      });
    };

    WixLiveChat.prototype.onChatStarted = function() {
      return jQuery.ajax({
        url: "/wix/users/" + (App.User.currentUser().id),
        type: 'PUT',
        data: {
          client_site_id: App.Site.first().id,
          updates: {
            ticket_fields: true
          }
        },
        dataType: 'json'
      });
    };

    WixLiveChat.prototype.update = function() {
      if (!this.initialized) {
        return;
      }
      if (!this.featureEnabled()) {
        return;
      }
      return jQuery.ajax({
        url: "/wix/users/" + (App.User.currentUser().id),
        type: 'PUT',
        data: {
          client_site_id: App.Site.first().id,
          updates: {
            name: true
          }
        },
        dataType: 'json'
      });
    };

    WixLiveChat.prototype.relogin = function() {
      return window.AnswersWidget.authenticator();
    };

    return WixLiveChat;

  })();

}).call(this);
// Extracted from Highcharts.js

window.MakeDateFormatter = function() {return new function() {

  /**
   * Set the time methods globally based on the useUTC option. Time method can be either
   * local time or UTC (default).
   */
  this.setTimeMethods = function(useUTC) {
    var GET = useUTC ? 'getUTC' : 'get',
        SET = useUTC ? 'setUTC' : 'set';

    makeTime = useUTC ? Date.UTC : function (year, month, date, hours, minutes, seconds) {
      return new Date(
        year,
        month,
        pick(date, 1),
        pick(hours, 0),
        pick(minutes, 0),
        pick(seconds, 0)
      ).getTime();
    };
    this.getMinutes =  GET + 'Minutes';
    this.getHours =    GET + 'Hours';
    this.getDay =      GET + 'Day';
    this.getDate =     GET + 'Date';
    this.getMonth =    GET + 'Month';
    this.getFullYear = GET + 'FullYear';
  }

  /**
   * Return the first value that is defined. Like MooTools' $.pick.
   */
  function pick() {
    var args = arguments,
      i,
      arg,
      length = args.length;
    for (i = 0; i < length; i++) {
      arg = args[i];
      if (typeof arg !== 'undefined' && arg !== null) {
        return arg;
      }
    }
  }

  /**
   * Pad a string to a given length by adding 0 to the beginning
   * @param {Number} number
   * @param {Number} length
   */
  function pad(number, length) {
    // Create an array of the remaining length +1 and join it with 0's
    return new Array((length || 2) + 1 - String(number).length).join(0) + number;
  }

  function defined(obj) {
    return (typeof obj != 'undefined' && obj != null);
  }

  /**
   * Based on http://www.php.net/manual/en/function.strftime.php
   * @param {String} format
   * @param {Number} timestamp
   * @param {Boolean} capitalize
   */
  this.dateFormat = function (format, timestamp, capitalize) {
    if (!defined(timestamp) || isNaN(timestamp)) {
      return 'Invalid date';
    }
    format = pick(format, '%Y-%m-%d %H:%M:%S');

    var date = new Date(timestamp),
      key, // used in for constuct below
      // get the basic time values
      hours = date[this.getHours](),
      day = date[this.getDay](),
      dayOfMonth = date[this.getDate](),
      month = date[this.getMonth](),
      fullYear = date[this.getFullYear](),
      lang = {
        loading: 'Loading...',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
            'August', 'September', 'October', 'November', 'December'],
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        decimalPoint: '.',
        numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
        resetZoom: 'Reset zoom',
        resetZoomTitle: 'Reset zoom level 1:1',
        thousandsSep: ','
      },	
      langWeekdays = lang.weekdays,
      /* // uncomment this and the 'W' format key below to enable week numbers
      weekNumber = function () {
        var clone = new Date(date.valueOf()),
          day = clone[getDay]() == 0 ? 7 : clone[getDay](),
          dayNumber;
        clone.setDate(clone[getDate]() + 4 - day);
        dayNumber = mathFloor((clone.getTime() - new Date(clone[getFullYear](), 0, 1, -6)) / 86400000);
        return 1 + mathFloor(dayNumber / 7);
      },
      */

      // list all format keys
      replacements = {

        // Day
        'a': langWeekdays[day].substr(0, 3), // Short weekday, like 'Mon'
        'A': langWeekdays[day], // Long weekday, like 'Monday'
        'd': pad(dayOfMonth), // Two digit day of the month, 01 to 31
        'e': dayOfMonth, // Day of the month, 1 through 31

        // Week (none implemented)
        //'W': weekNumber(),

        // Month
        'b': lang.shortMonths[month], // Short month, like 'Jan'
        'B': lang.months[month], // Long month, like 'January'
        'm': pad(month + 1), // Two digit month number, 01 through 12

        // Year
        'y': fullYear.toString().substr(2, 2), // Two digits year, like 09 for 2009
        'Y': fullYear, // Four digits year, like 2009

        // Time
        'H': pad(hours), // Two digits hours in 24h format, 00 through 23
        'I': pad((hours % 12) || 12), // Two digits hours in 12h format, 00 through 11
        'l': (hours % 12) || 12, // Hours in 12h format, 1 through 12
        'M': pad(date[this.getMinutes]()), // Two digits minutes, 00 through 59
        'p': hours < 12 ? 'AM' : 'PM', // Upper case AM or PM
        'P': hours < 12 ? 'am' : 'pm', // Lower case AM or PM
        'S': pad(date.getSeconds()), // Two digits seconds, 00 through  59
        'L': pad(Math.round(timestamp % 1000), 3) // Milliseconds (naming from Ruby)
      };


    // do the replaces
    for (key in replacements) {
      while (format.indexOf('%' + key) !== -1) { // regex would do it in one line, but this is faster
        format = format.replace('%' + key, replacements[key]);
      }
    }

    // Optionally capitalize the string and return
    return capitalize ? format.substr(0, 1).toUpperCase() + format.substr(1) : format;
  };

};
};

window.DateFormat = MakeDateFormatter()
window.DateFormat.setTimeMethods(true)

window.DateFormatLocalTime = MakeDateFormatter()
window.DateFormatLocalTime.setTimeMethods(false)
;
// From http://www.mredkj.com/javascript/nfbasic.html
Number.prototype.commaDelimit = function() {
  nStr = this + '';
  x = nStr.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

Array.prototype.to_set = function() {
  retHash = {}
  for(var i = 0; i < this.length; i++) {
    retHash[this[i]] = true
  }
  return retHash
}

Array.prototype.sum = function() {
  if (this.length == 0) {
    return 0;
  }
  return this.reduce(function(previousValue, currentValue, index, array) {
    return previousValue + currentValue;
  });
}

Array.prototype.isEmpty = function() { return this.length == 0; }
Array.prototype.first = function() { return this[0] }
Array.prototype.last = function() { return this[this.length-1] }
Array.prototype.max = function() {
    if (this.length == 0) return null;
    var maxVal = this[0];
    for(var i = 0; i < this.length; i++)
        if(this[i] > maxVal) maxVal = this[i];
    return maxVal;
};
Array.prototype.includes = function(val) {
  for(var i = 0; i < this.length; i++)
    if(this[i] === val) return true;
  return false;
}
Array.prototype.includesIgnoreCase = function(val) {
    downcase = val.toLowerCase()
    for(var i = 0; i < this.length; i++)
        if(this[i].toLowerCase() === downcase) return true;
    return false;
}
Array.prototype.min = function() {
    if (this.length == 0) return null;
    var minVal = this[0];
    for(var i = 0; i < this.length; i++)
        if(this[i] < minVal) minVal = this[i];
    return minVal;
};
Array.prototype.with = function(item) {
  var newArr = this.slice(0);
  newArr.push(item);
  return newArr;
}
Array.prototype.without = function(item) {
  var newArr = new Array();
  for(var i = 0; i < this.length; i++) {
    if(this[i] != item) newArr.push(this[i]);
  }
  return newArr;
}
Array.prototype.withoutAny = function(forbiddenList) {
  var forbiddenMap = {}
  for (var i = 0; i < forbiddenList.length; i++) {
    forbiddenMap[forbiddenList[i]] = true
  }
  var result = []
  for(var i = 0; i < this.length; i++) {
    if(!forbiddenMap[this[i]]) {
      result.push(this[i]);
    }
  }
  return result;
}
Array.prototype.equals = function(otherArray) {
  if(otherArray == null || typeof otherArray == 'undefined') {
    return false;
	}
  if(this.length != otherArray.length) {
    return false;
	}
  for(var i = 0; i < this.length; i++) {
		if (typeof this[i].equals === "function") {
			if(!this[i].equals(otherArray[i])) {
				return false
			}
		} else if(this[i] != otherArray[i]) {
			return false;
		}
	}
  return true;
}
Array.prototype.sortIgnoreCase = function () {
  var allStrings = true;
  for (var i = 0; i < this.length; i++) {
    if (typeof this[i] != "string") {
      allStrings = false;
    }
  }

  if (allStrings) {
    return this.sort(function (a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  } else {
    return this.sort();
  }
};

Array.prototype.unique = function() {
  var h = {};
  var u = [];
  for( var i = 0; i < this.length; i++)
    if(!h[this[i]]) {
      u.push(this[i]);
      h[this[i]] = true
    }
  return u;
}

Array.prototype.tokenize = function(disableUnderscores) {
  var regex = /[\s\.\-_]+/g;
  if (disableUnderscores) {
    regex = /[\s\.\-]+/g;
  }
  return this.join(' ').toLowerCase().replace(regex,' ').split(' ')
}
Array.prototype.average = function() {
  if(this.length == 0)
    return 0;
  var sum = 0
  for(var i = 0; i < this.length; i++) {
    if(typeof this[i] == "number")
      sum += this[i]
  }
  return sum / this.length;
}
Array.prototype.transpose = function() {
  // requires dense matrix, i.e. all the inner arrays are the same length as the first inner array.
  var newArr = new Array();
  for(var row = 0; row < this.length; row++) {
    for(var col = 0; col < this[0].length; col++) {
      if(row == 0) { newArr.push([]); }
      newArr[col].push(this[row][col]);
    }
  }
  return newArr;
}
String.prototype.trim = function() { return this.replace(/^\s+|\s+$/g, ""); };
// from https://github.com/janl/mustache.js/blob/master/mustache.js
String.prototype.escapeHtml = function() {
  var escapeEntityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };
  return this.replace(/[&<>"'\/]/g, function (s) {
    return escapeEntityMap[s];
  });
}
String.prototype.startsWith = function (str){ return this.slice(0, str.length) == str; };
String.prototype.includes = function (str){ return this.indexOf(str) != -1; };

Date.prototype.monthString = function() {
  var months = ["January", "February", "March", "April", "May", "June", "July", "August",
    "September", "October", "November", "December"];
  return months[this.getMonth()];
};

var hasOwnProperty = Object.prototype.hasOwnProperty;
function isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

window.isArray = function(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
};

window.periscopePing = function(event_type) {
  try {
    $.post('/ping', {
      event_type: event_type,
      referrer: document.referrer,
      browser_width: window.innerWidth,
      browser_height: window.innerHeight,
      mobile_ui: '' + (window.mobileUI || false)
    });
  } catch (err) {
    if (window.console && window.console.info) {
      console.info("Error in periscopePing:")
      console.info(err)
    }
  }
}

function encode_utf8(s) {
  return unescape(encodeURIComponent(s));
}

function decode_utf8(s) {
  return decodeURIComponent(escape(s));
}

//------------------------ Cookies ------------------------

function createForeverCookie(name, value) {
  createCookie(name, value, 365*20)
}

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else {
    var expires = "";
  }
  var domain = " Domain=.periscopedata.com;"
  if (window.location.hostname == 'localhost') {
    domain = ''
  }
  document.cookie = name+"="+value+expires+";" + domain + " path=/";
}

function readCookie(name) {
 var nameEQ = name + "=";
 var ca = document.cookie.split(';');
 for(var i=0;i < ca.length;i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1,c.length);
   if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
 }
 return null;
}

function lg(o) {
  console.log(JSON.stringify(o))
}
;
//------------------------ Status Codes ------------------------
var HttpCodes = {
	success: 200,
	created: 201,
	permissionDenied: 403,
	notFound: 404,
	internalServerError: 500,
};
// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or vendor/assets/javascripts of plugins, if any, can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// the compiled file.
//
// WARNING: THE FIRST BLANK LINE MARKS THE END OF WHAT'S TO BE PROCESSED, ANY BLANK LINE SHOULD
// GO AFTER THE REQUIRES BELOW.
//





;
(function() {
  $(function() {
    var authToken, state;
    authToken = $('#body').data('authToken');
    state = $('body').data('state');
    $('#body').removeAttr('data-state');
    if ($('#body').hasClass('app')) {
      return new window.AppRedesign({
        authToken: authToken,
        el: '#body',
        state: state
      });
    } else if ($('#body').hasClass('styleguide')) {

    } else if ($('#body').hasClass('connect')) {
      return new App.ConnectPage({
        el: '#connect-page',
        state: state
      });
    } else if ($('#body').hasClass('internal-connect')) {
      return new App.ConnectionTester({
        el: '#connection-tester',
        state: state
      });
    }
  });

}).call(this);
